function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire50af"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire50af"] = parcelRequire;
}
parcelRequire.register("1pQec", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1080a3a57e8ee845$export$ffb0004e005737fa; }, function (v) { return $1080a3a57e8ee845$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1080a3a57e8ee845$export$34b9dba7ce09269b; }, function (v) { return $1080a3a57e8ee845$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1080a3a57e8ee845$export$25062201e9e25d76; }, function (v) { return $1080a3a57e8ee845$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1080a3a57e8ee845$export$ffb0004e005737fa;
var $1080a3a57e8ee845$export$34b9dba7ce09269b;
var $1080a3a57e8ee845$export$25062201e9e25d76;
"use strict";

var $lDSNw = parcelRequire("lDSNw");
var $1080a3a57e8ee845$var$k = Symbol.for("react.element"), $1080a3a57e8ee845$var$l = Symbol.for("react.fragment"), $1080a3a57e8ee845$var$m = Object.prototype.hasOwnProperty, $1080a3a57e8ee845$var$n = $lDSNw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1080a3a57e8ee845$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1080a3a57e8ee845$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1080a3a57e8ee845$var$m.call(a, b) && !$1080a3a57e8ee845$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1080a3a57e8ee845$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1080a3a57e8ee845$var$n.current
    };
}
$1080a3a57e8ee845$export$ffb0004e005737fa = $1080a3a57e8ee845$var$l;
$1080a3a57e8ee845$export$34b9dba7ce09269b = $1080a3a57e8ee845$var$q;
$1080a3a57e8ee845$export$25062201e9e25d76 = $1080a3a57e8ee845$var$q;

});
parcelRequire.register("lDSNw", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jdk57"));

});
parcelRequire.register("jdk57", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $dfcecf0565ba04bf$export$dca3b0875bd9a954; }, function (v) { return $dfcecf0565ba04bf$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $dfcecf0565ba04bf$export$16fa2f45be04daa8; }, function (v) { return $dfcecf0565ba04bf$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $dfcecf0565ba04bf$export$ffb0004e005737fa; }, function (v) { return $dfcecf0565ba04bf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $dfcecf0565ba04bf$export$e2c29f18771995cb; }, function (v) { return $dfcecf0565ba04bf$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $dfcecf0565ba04bf$export$221d75b3f55bb0bd; }, function (v) { return $dfcecf0565ba04bf$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $dfcecf0565ba04bf$export$5f8d39834fd61797; }, function (v) { return $dfcecf0565ba04bf$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $dfcecf0565ba04bf$export$74bf444e3cd11ea5; }, function (v) { return $dfcecf0565ba04bf$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $dfcecf0565ba04bf$export$ae55be85d98224ed; }, function (v) { return $dfcecf0565ba04bf$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $dfcecf0565ba04bf$export$e530037191fcd5d7; }, function (v) { return $dfcecf0565ba04bf$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $dfcecf0565ba04bf$export$fd42f52fd3ae1109; }, function (v) { return $dfcecf0565ba04bf$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $dfcecf0565ba04bf$export$c8a8987d4410bf2d; }, function (v) { return $dfcecf0565ba04bf$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $dfcecf0565ba04bf$export$d38cd72104c1f0e9; }, function (v) { return $dfcecf0565ba04bf$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $dfcecf0565ba04bf$export$7d1e3a5e95ceca43; }, function (v) { return $dfcecf0565ba04bf$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $dfcecf0565ba04bf$export$257a8862b851cb5b; }, function (v) { return $dfcecf0565ba04bf$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $dfcecf0565ba04bf$export$a8257692ac88316c; }, function (v) { return $dfcecf0565ba04bf$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $dfcecf0565ba04bf$export$488013bae63b21da; }, function (v) { return $dfcecf0565ba04bf$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $dfcecf0565ba04bf$export$7c73462e0d25e514; }, function (v) { return $dfcecf0565ba04bf$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $dfcecf0565ba04bf$export$7568632d0d33d16d; }, function (v) { return $dfcecf0565ba04bf$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $dfcecf0565ba04bf$export$88948ce120ea2619; }, function (v) { return $dfcecf0565ba04bf$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $dfcecf0565ba04bf$export$35808ee640e87ca7; }, function (v) { return $dfcecf0565ba04bf$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $dfcecf0565ba04bf$export$fae74005e78b1a27; }, function (v) { return $dfcecf0565ba04bf$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $dfcecf0565ba04bf$export$dc8fbce3eb94dc1e; }, function (v) { return $dfcecf0565ba04bf$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $dfcecf0565ba04bf$export$6a7bc4e911dc01cf; }, function (v) { return $dfcecf0565ba04bf$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $dfcecf0565ba04bf$export$6d9c69b0de29b591; }, function (v) { return $dfcecf0565ba04bf$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $dfcecf0565ba04bf$export$f680877a34711e37; }, function (v) { return $dfcecf0565ba04bf$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $dfcecf0565ba04bf$export$d5a552a76deda3c2; }, function (v) { return $dfcecf0565ba04bf$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $dfcecf0565ba04bf$export$aaabe4eda9ed9969; }, function (v) { return $dfcecf0565ba04bf$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $dfcecf0565ba04bf$export$e5c5a5f917a5871c; }, function (v) { return $dfcecf0565ba04bf$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $dfcecf0565ba04bf$export$1538c33de8887b59; }, function (v) { return $dfcecf0565ba04bf$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $dfcecf0565ba04bf$export$13e3392192263954; }, function (v) { return $dfcecf0565ba04bf$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $dfcecf0565ba04bf$export$b8f5890fc79d6aca; }, function (v) { return $dfcecf0565ba04bf$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $dfcecf0565ba04bf$export$60241385465d0a34; }, function (v) { return $dfcecf0565ba04bf$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $dfcecf0565ba04bf$export$306c0aa65ff9ec16; }, function (v) { return $dfcecf0565ba04bf$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $dfcecf0565ba04bf$export$7b286972b8d8ccbf; }, function (v) { return $dfcecf0565ba04bf$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $dfcecf0565ba04bf$export$83d89fbfd8236492; }, function (v) { return $dfcecf0565ba04bf$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfcecf0565ba04bf$export$dca3b0875bd9a954;
var $dfcecf0565ba04bf$export$16fa2f45be04daa8;
var $dfcecf0565ba04bf$export$ffb0004e005737fa;
var $dfcecf0565ba04bf$export$e2c29f18771995cb;
var $dfcecf0565ba04bf$export$221d75b3f55bb0bd;
var $dfcecf0565ba04bf$export$5f8d39834fd61797;
var $dfcecf0565ba04bf$export$74bf444e3cd11ea5;
var $dfcecf0565ba04bf$export$ae55be85d98224ed;
var $dfcecf0565ba04bf$export$e530037191fcd5d7;
var $dfcecf0565ba04bf$export$fd42f52fd3ae1109;
var $dfcecf0565ba04bf$export$c8a8987d4410bf2d;
var $dfcecf0565ba04bf$export$d38cd72104c1f0e9;
var $dfcecf0565ba04bf$export$7d1e3a5e95ceca43;
var $dfcecf0565ba04bf$export$257a8862b851cb5b;
var $dfcecf0565ba04bf$export$a8257692ac88316c;
var $dfcecf0565ba04bf$export$488013bae63b21da;
var $dfcecf0565ba04bf$export$7c73462e0d25e514;
var $dfcecf0565ba04bf$export$7568632d0d33d16d;
var $dfcecf0565ba04bf$export$88948ce120ea2619;
var $dfcecf0565ba04bf$export$35808ee640e87ca7;
var $dfcecf0565ba04bf$export$fae74005e78b1a27;
var $dfcecf0565ba04bf$export$dc8fbce3eb94dc1e;
var $dfcecf0565ba04bf$export$6a7bc4e911dc01cf;
var $dfcecf0565ba04bf$export$6d9c69b0de29b591;
var $dfcecf0565ba04bf$export$f680877a34711e37;
var $dfcecf0565ba04bf$export$d5a552a76deda3c2;
var $dfcecf0565ba04bf$export$aaabe4eda9ed9969;
var $dfcecf0565ba04bf$export$e5c5a5f917a5871c;
var $dfcecf0565ba04bf$export$1538c33de8887b59;
var $dfcecf0565ba04bf$export$13e3392192263954;
var $dfcecf0565ba04bf$export$b8f5890fc79d6aca;
var $dfcecf0565ba04bf$export$60241385465d0a34;
var $dfcecf0565ba04bf$export$306c0aa65ff9ec16;
var $dfcecf0565ba04bf$export$7b286972b8d8ccbf;
var $dfcecf0565ba04bf$export$83d89fbfd8236492;
"use strict";
var $dfcecf0565ba04bf$var$l = Symbol.for("react.element"), $dfcecf0565ba04bf$var$n = Symbol.for("react.portal"), $dfcecf0565ba04bf$var$p = Symbol.for("react.fragment"), $dfcecf0565ba04bf$var$q = Symbol.for("react.strict_mode"), $dfcecf0565ba04bf$var$r = Symbol.for("react.profiler"), $dfcecf0565ba04bf$var$t = Symbol.for("react.provider"), $dfcecf0565ba04bf$var$u = Symbol.for("react.context"), $dfcecf0565ba04bf$var$v = Symbol.for("react.forward_ref"), $dfcecf0565ba04bf$var$w = Symbol.for("react.suspense"), $dfcecf0565ba04bf$var$x = Symbol.for("react.memo"), $dfcecf0565ba04bf$var$y = Symbol.for("react.lazy"), $dfcecf0565ba04bf$var$z = Symbol.iterator;
function $dfcecf0565ba04bf$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dfcecf0565ba04bf$var$z && a[$dfcecf0565ba04bf$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dfcecf0565ba04bf$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dfcecf0565ba04bf$var$C = Object.assign, $dfcecf0565ba04bf$var$D = {};
function $dfcecf0565ba04bf$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dfcecf0565ba04bf$var$D;
    this.updater = e || $dfcecf0565ba04bf$var$B;
}
$dfcecf0565ba04bf$var$E.prototype.isReactComponent = {};
$dfcecf0565ba04bf$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dfcecf0565ba04bf$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dfcecf0565ba04bf$var$F() {}
$dfcecf0565ba04bf$var$F.prototype = $dfcecf0565ba04bf$var$E.prototype;
function $dfcecf0565ba04bf$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dfcecf0565ba04bf$var$D;
    this.updater = e || $dfcecf0565ba04bf$var$B;
}
var $dfcecf0565ba04bf$var$H = $dfcecf0565ba04bf$var$G.prototype = new $dfcecf0565ba04bf$var$F;
$dfcecf0565ba04bf$var$H.constructor = $dfcecf0565ba04bf$var$G;
$dfcecf0565ba04bf$var$C($dfcecf0565ba04bf$var$H, $dfcecf0565ba04bf$var$E.prototype);
$dfcecf0565ba04bf$var$H.isPureReactComponent = !0;
var $dfcecf0565ba04bf$var$I = Array.isArray, $dfcecf0565ba04bf$var$J = Object.prototype.hasOwnProperty, $dfcecf0565ba04bf$var$K = {
    current: null
}, $dfcecf0565ba04bf$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dfcecf0565ba04bf$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dfcecf0565ba04bf$var$J.call(b, d) && !$dfcecf0565ba04bf$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dfcecf0565ba04bf$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dfcecf0565ba04bf$var$K.current
    };
}
function $dfcecf0565ba04bf$var$N(a, b) {
    return {
        $$typeof: $dfcecf0565ba04bf$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dfcecf0565ba04bf$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dfcecf0565ba04bf$var$l;
}
function $dfcecf0565ba04bf$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dfcecf0565ba04bf$var$P = /\/+/g;
function $dfcecf0565ba04bf$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dfcecf0565ba04bf$var$escape("" + a.key) : b.toString(36);
}
function $dfcecf0565ba04bf$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dfcecf0565ba04bf$var$l:
                case $dfcecf0565ba04bf$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dfcecf0565ba04bf$var$Q(h, 0) : d, $dfcecf0565ba04bf$var$I(c) ? (e = "", null != a && (e = a.replace($dfcecf0565ba04bf$var$P, "$&/") + "/"), $dfcecf0565ba04bf$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dfcecf0565ba04bf$var$O(c) && (c = $dfcecf0565ba04bf$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dfcecf0565ba04bf$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dfcecf0565ba04bf$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dfcecf0565ba04bf$var$Q(k, g);
        h += $dfcecf0565ba04bf$var$R(k, b, e, f, c);
    }
    else if (f = $dfcecf0565ba04bf$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dfcecf0565ba04bf$var$Q(k, g++), h += $dfcecf0565ba04bf$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dfcecf0565ba04bf$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dfcecf0565ba04bf$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dfcecf0565ba04bf$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dfcecf0565ba04bf$var$U = {
    current: null
}, $dfcecf0565ba04bf$var$V = {
    transition: null
}, $dfcecf0565ba04bf$var$W = {
    ReactCurrentDispatcher: $dfcecf0565ba04bf$var$U,
    ReactCurrentBatchConfig: $dfcecf0565ba04bf$var$V,
    ReactCurrentOwner: $dfcecf0565ba04bf$var$K
};
$dfcecf0565ba04bf$export$dca3b0875bd9a954 = {
    map: $dfcecf0565ba04bf$var$S,
    forEach: function(a, b, e) {
        $dfcecf0565ba04bf$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dfcecf0565ba04bf$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dfcecf0565ba04bf$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dfcecf0565ba04bf$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dfcecf0565ba04bf$export$16fa2f45be04daa8 = $dfcecf0565ba04bf$var$E;
$dfcecf0565ba04bf$export$ffb0004e005737fa = $dfcecf0565ba04bf$var$p;
$dfcecf0565ba04bf$export$e2c29f18771995cb = $dfcecf0565ba04bf$var$r;
$dfcecf0565ba04bf$export$221d75b3f55bb0bd = $dfcecf0565ba04bf$var$G;
$dfcecf0565ba04bf$export$5f8d39834fd61797 = $dfcecf0565ba04bf$var$q;
$dfcecf0565ba04bf$export$74bf444e3cd11ea5 = $dfcecf0565ba04bf$var$w;
$dfcecf0565ba04bf$export$ae55be85d98224ed = $dfcecf0565ba04bf$var$W;
$dfcecf0565ba04bf$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dfcecf0565ba04bf$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dfcecf0565ba04bf$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dfcecf0565ba04bf$var$J.call(b, f) && !$dfcecf0565ba04bf$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dfcecf0565ba04bf$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dfcecf0565ba04bf$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dfcecf0565ba04bf$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dfcecf0565ba04bf$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dfcecf0565ba04bf$export$c8a8987d4410bf2d = $dfcecf0565ba04bf$var$M;
$dfcecf0565ba04bf$export$d38cd72104c1f0e9 = function(a) {
    var b = $dfcecf0565ba04bf$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dfcecf0565ba04bf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dfcecf0565ba04bf$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dfcecf0565ba04bf$var$v,
        render: a
    };
};
$dfcecf0565ba04bf$export$a8257692ac88316c = $dfcecf0565ba04bf$var$O;
$dfcecf0565ba04bf$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dfcecf0565ba04bf$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dfcecf0565ba04bf$var$T
    };
};
$dfcecf0565ba04bf$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dfcecf0565ba04bf$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dfcecf0565ba04bf$export$7568632d0d33d16d = function(a) {
    var b = $dfcecf0565ba04bf$var$V.transition;
    $dfcecf0565ba04bf$var$V.transition = {};
    try {
        a();
    } finally{
        $dfcecf0565ba04bf$var$V.transition = b;
    }
};
$dfcecf0565ba04bf$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$dfcecf0565ba04bf$export$35808ee640e87ca7 = function(a, b) {
    return $dfcecf0565ba04bf$var$U.current.useCallback(a, b);
};
$dfcecf0565ba04bf$export$fae74005e78b1a27 = function(a) {
    return $dfcecf0565ba04bf$var$U.current.useContext(a);
};
$dfcecf0565ba04bf$export$dc8fbce3eb94dc1e = function() {};
$dfcecf0565ba04bf$export$6a7bc4e911dc01cf = function(a) {
    return $dfcecf0565ba04bf$var$U.current.useDeferredValue(a);
};
$dfcecf0565ba04bf$export$6d9c69b0de29b591 = function(a, b) {
    return $dfcecf0565ba04bf$var$U.current.useEffect(a, b);
};
$dfcecf0565ba04bf$export$f680877a34711e37 = function() {
    return $dfcecf0565ba04bf$var$U.current.useId();
};
$dfcecf0565ba04bf$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dfcecf0565ba04bf$var$U.current.useImperativeHandle(a, b, e);
};
$dfcecf0565ba04bf$export$aaabe4eda9ed9969 = function(a, b) {
    return $dfcecf0565ba04bf$var$U.current.useInsertionEffect(a, b);
};
$dfcecf0565ba04bf$export$e5c5a5f917a5871c = function(a, b) {
    return $dfcecf0565ba04bf$var$U.current.useLayoutEffect(a, b);
};
$dfcecf0565ba04bf$export$1538c33de8887b59 = function(a, b) {
    return $dfcecf0565ba04bf$var$U.current.useMemo(a, b);
};
$dfcecf0565ba04bf$export$13e3392192263954 = function(a, b, e) {
    return $dfcecf0565ba04bf$var$U.current.useReducer(a, b, e);
};
$dfcecf0565ba04bf$export$b8f5890fc79d6aca = function(a) {
    return $dfcecf0565ba04bf$var$U.current.useRef(a);
};
$dfcecf0565ba04bf$export$60241385465d0a34 = function(a) {
    return $dfcecf0565ba04bf$var$U.current.useState(a);
};
$dfcecf0565ba04bf$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dfcecf0565ba04bf$var$U.current.useSyncExternalStore(a, b, e);
};
$dfcecf0565ba04bf$export$7b286972b8d8ccbf = function() {
    return $dfcecf0565ba04bf$var$U.current.useTransition();
};
$dfcecf0565ba04bf$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("ef4Zh", function(module, exports) {
"use strict";
function $a5e655cad3a329a3$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a5e655cad3a329a3$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a5e655cad3a329a3$var$checkDCE();

module.exports = (parcelRequire("kFbRV"));

});
parcelRequire.register("kFbRV", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f0b0d7da6e7d747b$export$ae55be85d98224ed; }, function (v) { return $f0b0d7da6e7d747b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $f0b0d7da6e7d747b$export$d39a5bbd09211389; }, function (v) { return $f0b0d7da6e7d747b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $f0b0d7da6e7d747b$export$882461b6382ed46c; }, function (v) { return $f0b0d7da6e7d747b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $f0b0d7da6e7d747b$export$466bfc07425424d5; }, function (v) { return $f0b0d7da6e7d747b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $f0b0d7da6e7d747b$export$cd75ccfd720a3cd4; }, function (v) { return $f0b0d7da6e7d747b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $f0b0d7da6e7d747b$export$fa8d919ba61d84db; }, function (v) { return $f0b0d7da6e7d747b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $f0b0d7da6e7d747b$export$757ceba2d55c277e; }, function (v) { return $f0b0d7da6e7d747b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $f0b0d7da6e7d747b$export$b3890eb0ae9dca99; }, function (v) { return $f0b0d7da6e7d747b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $f0b0d7da6e7d747b$export$502457920280e6be; }, function (v) { return $f0b0d7da6e7d747b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $f0b0d7da6e7d747b$export$c78a37762a8d58e1; }, function (v) { return $f0b0d7da6e7d747b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $f0b0d7da6e7d747b$export$dc54d992c10e8a18; }, function (v) { return $f0b0d7da6e7d747b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $f0b0d7da6e7d747b$export$83d89fbfd8236492; }, function (v) { return $f0b0d7da6e7d747b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f0b0d7da6e7d747b$export$ae55be85d98224ed;
var $f0b0d7da6e7d747b$export$d39a5bbd09211389;
var $f0b0d7da6e7d747b$export$882461b6382ed46c;
var $f0b0d7da6e7d747b$export$466bfc07425424d5;
var $f0b0d7da6e7d747b$export$cd75ccfd720a3cd4;
var $f0b0d7da6e7d747b$export$fa8d919ba61d84db;
var $f0b0d7da6e7d747b$export$757ceba2d55c277e;
var $f0b0d7da6e7d747b$export$b3890eb0ae9dca99;
var $f0b0d7da6e7d747b$export$502457920280e6be;
var $f0b0d7da6e7d747b$export$c78a37762a8d58e1;
var $f0b0d7da6e7d747b$export$dc54d992c10e8a18;
var $f0b0d7da6e7d747b$export$83d89fbfd8236492;
"use strict";

var $lDSNw = parcelRequire("lDSNw");

var $f1D4w = parcelRequire("f1D4w");
function $f0b0d7da6e7d747b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f0b0d7da6e7d747b$var$da = new Set, $f0b0d7da6e7d747b$var$ea = {};
function $f0b0d7da6e7d747b$var$fa(a, b) {
    $f0b0d7da6e7d747b$var$ha(a, b);
    $f0b0d7da6e7d747b$var$ha(a + "Capture", b);
}
function $f0b0d7da6e7d747b$var$ha(a, b) {
    $f0b0d7da6e7d747b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f0b0d7da6e7d747b$var$da.add(b[a]);
}
var $f0b0d7da6e7d747b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f0b0d7da6e7d747b$var$ja = Object.prototype.hasOwnProperty, $f0b0d7da6e7d747b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f0b0d7da6e7d747b$var$la = {}, $f0b0d7da6e7d747b$var$ma = {};
function $f0b0d7da6e7d747b$var$oa(a) {
    if ($f0b0d7da6e7d747b$var$ja.call($f0b0d7da6e7d747b$var$ma, a)) return !0;
    if ($f0b0d7da6e7d747b$var$ja.call($f0b0d7da6e7d747b$var$la, a)) return !1;
    if ($f0b0d7da6e7d747b$var$ka.test(a)) return $f0b0d7da6e7d747b$var$ma[a] = !0;
    $f0b0d7da6e7d747b$var$la[a] = !0;
    return !1;
}
function $f0b0d7da6e7d747b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f0b0d7da6e7d747b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f0b0d7da6e7d747b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f0b0d7da6e7d747b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f0b0d7da6e7d747b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f0b0d7da6e7d747b$var$z[b] = new $f0b0d7da6e7d747b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f0b0d7da6e7d747b$var$ra = /[\-:]([a-z])/g;
function $f0b0d7da6e7d747b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f0b0d7da6e7d747b$var$ra, $f0b0d7da6e7d747b$var$sa);
    $f0b0d7da6e7d747b$var$z[b] = new $f0b0d7da6e7d747b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f0b0d7da6e7d747b$var$ra, $f0b0d7da6e7d747b$var$sa);
    $f0b0d7da6e7d747b$var$z[b] = new $f0b0d7da6e7d747b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f0b0d7da6e7d747b$var$ra, $f0b0d7da6e7d747b$var$sa);
    $f0b0d7da6e7d747b$var$z[b] = new $f0b0d7da6e7d747b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f0b0d7da6e7d747b$var$z.xlinkHref = new $f0b0d7da6e7d747b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f0b0d7da6e7d747b$var$z[a] = new $f0b0d7da6e7d747b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f0b0d7da6e7d747b$var$ta(a, b, c, d) {
    var e = $f0b0d7da6e7d747b$var$z.hasOwnProperty(b) ? $f0b0d7da6e7d747b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f0b0d7da6e7d747b$var$qa(b, c, e, d) && (c = null), d || null === e ? $f0b0d7da6e7d747b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f0b0d7da6e7d747b$var$ua = $lDSNw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f0b0d7da6e7d747b$var$va = Symbol.for("react.element"), $f0b0d7da6e7d747b$var$wa = Symbol.for("react.portal"), $f0b0d7da6e7d747b$var$ya = Symbol.for("react.fragment"), $f0b0d7da6e7d747b$var$za = Symbol.for("react.strict_mode"), $f0b0d7da6e7d747b$var$Aa = Symbol.for("react.profiler"), $f0b0d7da6e7d747b$var$Ba = Symbol.for("react.provider"), $f0b0d7da6e7d747b$var$Ca = Symbol.for("react.context"), $f0b0d7da6e7d747b$var$Da = Symbol.for("react.forward_ref"), $f0b0d7da6e7d747b$var$Ea = Symbol.for("react.suspense"), $f0b0d7da6e7d747b$var$Fa = Symbol.for("react.suspense_list"), $f0b0d7da6e7d747b$var$Ga = Symbol.for("react.memo"), $f0b0d7da6e7d747b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f0b0d7da6e7d747b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f0b0d7da6e7d747b$var$Ja = Symbol.iterator;
function $f0b0d7da6e7d747b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f0b0d7da6e7d747b$var$Ja && a[$f0b0d7da6e7d747b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f0b0d7da6e7d747b$var$A = Object.assign, $f0b0d7da6e7d747b$var$La;
function $f0b0d7da6e7d747b$var$Ma(a) {
    if (void 0 === $f0b0d7da6e7d747b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f0b0d7da6e7d747b$var$La = b && b[1] || "";
    }
    return "\n" + $f0b0d7da6e7d747b$var$La + a;
}
var $f0b0d7da6e7d747b$var$Na = !1;
function $f0b0d7da6e7d747b$var$Oa(a, b) {
    if (!a || $f0b0d7da6e7d747b$var$Na) return "";
    $f0b0d7da6e7d747b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f0b0d7da6e7d747b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f0b0d7da6e7d747b$var$Ma(a) : "";
}
function $f0b0d7da6e7d747b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f0b0d7da6e7d747b$var$Ma(a.type);
        case 16:
            return $f0b0d7da6e7d747b$var$Ma("Lazy");
        case 13:
            return $f0b0d7da6e7d747b$var$Ma("Suspense");
        case 19:
            return $f0b0d7da6e7d747b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f0b0d7da6e7d747b$var$Oa(a.type, !1), a;
        case 11:
            return a = $f0b0d7da6e7d747b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f0b0d7da6e7d747b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f0b0d7da6e7d747b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f0b0d7da6e7d747b$var$ya:
            return "Fragment";
        case $f0b0d7da6e7d747b$var$wa:
            return "Portal";
        case $f0b0d7da6e7d747b$var$Aa:
            return "Profiler";
        case $f0b0d7da6e7d747b$var$za:
            return "StrictMode";
        case $f0b0d7da6e7d747b$var$Ea:
            return "Suspense";
        case $f0b0d7da6e7d747b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f0b0d7da6e7d747b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f0b0d7da6e7d747b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f0b0d7da6e7d747b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f0b0d7da6e7d747b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f0b0d7da6e7d747b$var$Qa(a.type) || "Memo";
        case $f0b0d7da6e7d747b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f0b0d7da6e7d747b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f0b0d7da6e7d747b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f0b0d7da6e7d747b$var$Qa(b);
        case 8:
            return b === $f0b0d7da6e7d747b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f0b0d7da6e7d747b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f0b0d7da6e7d747b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f0b0d7da6e7d747b$var$Ua(a) {
    var b = $f0b0d7da6e7d747b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f0b0d7da6e7d747b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f0b0d7da6e7d747b$var$Ua(a));
}
function $f0b0d7da6e7d747b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f0b0d7da6e7d747b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f0b0d7da6e7d747b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f0b0d7da6e7d747b$var$Ya(a, b) {
    var c = b.checked;
    return $f0b0d7da6e7d747b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f0b0d7da6e7d747b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f0b0d7da6e7d747b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f0b0d7da6e7d747b$var$ab(a, b) {
    b = b.checked;
    null != b && $f0b0d7da6e7d747b$var$ta(a, "checked", b, !1);
}
function $f0b0d7da6e7d747b$var$bb(a, b) {
    $f0b0d7da6e7d747b$var$ab(a, b);
    var c = $f0b0d7da6e7d747b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f0b0d7da6e7d747b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f0b0d7da6e7d747b$var$cb(a, b.type, $f0b0d7da6e7d747b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f0b0d7da6e7d747b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f0b0d7da6e7d747b$var$cb(a, b, c) {
    if ("number" !== b || $f0b0d7da6e7d747b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f0b0d7da6e7d747b$var$eb = Array.isArray;
function $f0b0d7da6e7d747b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f0b0d7da6e7d747b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f0b0d7da6e7d747b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f0b0d7da6e7d747b$var$p(91));
    return $f0b0d7da6e7d747b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f0b0d7da6e7d747b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f0b0d7da6e7d747b$var$p(92));
            if ($f0b0d7da6e7d747b$var$eb(c)) {
                if (1 < c.length) throw Error($f0b0d7da6e7d747b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f0b0d7da6e7d747b$var$Sa(c)
    };
}
function $f0b0d7da6e7d747b$var$ib(a, b) {
    var c = $f0b0d7da6e7d747b$var$Sa(b.value), d = $f0b0d7da6e7d747b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f0b0d7da6e7d747b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f0b0d7da6e7d747b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f0b0d7da6e7d747b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f0b0d7da6e7d747b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f0b0d7da6e7d747b$var$mb, $f0b0d7da6e7d747b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f0b0d7da6e7d747b$var$mb = $f0b0d7da6e7d747b$var$mb || document.createElement("div");
        $f0b0d7da6e7d747b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f0b0d7da6e7d747b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f0b0d7da6e7d747b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f0b0d7da6e7d747b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f0b0d7da6e7d747b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f0b0d7da6e7d747b$var$pb).forEach(function(a) {
    $f0b0d7da6e7d747b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f0b0d7da6e7d747b$var$pb[b] = $f0b0d7da6e7d747b$var$pb[a];
    });
});
function $f0b0d7da6e7d747b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f0b0d7da6e7d747b$var$pb.hasOwnProperty(a) && $f0b0d7da6e7d747b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f0b0d7da6e7d747b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f0b0d7da6e7d747b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f0b0d7da6e7d747b$var$tb = $f0b0d7da6e7d747b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f0b0d7da6e7d747b$var$ub(a, b) {
    if (b) {
        if ($f0b0d7da6e7d747b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f0b0d7da6e7d747b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f0b0d7da6e7d747b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f0b0d7da6e7d747b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f0b0d7da6e7d747b$var$p(62));
    }
}
function $f0b0d7da6e7d747b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f0b0d7da6e7d747b$var$wb = null;
function $f0b0d7da6e7d747b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f0b0d7da6e7d747b$var$yb = null, $f0b0d7da6e7d747b$var$zb = null, $f0b0d7da6e7d747b$var$Ab = null;
function $f0b0d7da6e7d747b$var$Bb(a) {
    if (a = $f0b0d7da6e7d747b$var$Cb(a)) {
        if ("function" !== typeof $f0b0d7da6e7d747b$var$yb) throw Error($f0b0d7da6e7d747b$var$p(280));
        var b = a.stateNode;
        b && (b = $f0b0d7da6e7d747b$var$Db(b), $f0b0d7da6e7d747b$var$yb(a.stateNode, a.type, b));
    }
}
function $f0b0d7da6e7d747b$var$Eb(a) {
    $f0b0d7da6e7d747b$var$zb ? $f0b0d7da6e7d747b$var$Ab ? $f0b0d7da6e7d747b$var$Ab.push(a) : $f0b0d7da6e7d747b$var$Ab = [
        a
    ] : $f0b0d7da6e7d747b$var$zb = a;
}
function $f0b0d7da6e7d747b$var$Fb() {
    if ($f0b0d7da6e7d747b$var$zb) {
        var a = $f0b0d7da6e7d747b$var$zb, b = $f0b0d7da6e7d747b$var$Ab;
        $f0b0d7da6e7d747b$var$Ab = $f0b0d7da6e7d747b$var$zb = null;
        $f0b0d7da6e7d747b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f0b0d7da6e7d747b$var$Bb(b[a]);
    }
}
function $f0b0d7da6e7d747b$var$Gb(a, b) {
    return a(b);
}
function $f0b0d7da6e7d747b$var$Hb() {}
var $f0b0d7da6e7d747b$var$Ib = !1;
function $f0b0d7da6e7d747b$var$Jb(a, b, c) {
    if ($f0b0d7da6e7d747b$var$Ib) return a(b, c);
    $f0b0d7da6e7d747b$var$Ib = !0;
    try {
        return $f0b0d7da6e7d747b$var$Gb(a, b, c);
    } finally{
        if ($f0b0d7da6e7d747b$var$Ib = !1, null !== $f0b0d7da6e7d747b$var$zb || null !== $f0b0d7da6e7d747b$var$Ab) $f0b0d7da6e7d747b$var$Hb(), $f0b0d7da6e7d747b$var$Fb();
    }
}
function $f0b0d7da6e7d747b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f0b0d7da6e7d747b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f0b0d7da6e7d747b$var$p(231, b, typeof c));
    return c;
}
var $f0b0d7da6e7d747b$var$Lb = !1;
if ($f0b0d7da6e7d747b$var$ia) try {
    var $f0b0d7da6e7d747b$var$Mb = {};
    Object.defineProperty($f0b0d7da6e7d747b$var$Mb, "passive", {
        get: function() {
            $f0b0d7da6e7d747b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f0b0d7da6e7d747b$var$Mb, $f0b0d7da6e7d747b$var$Mb);
    window.removeEventListener("test", $f0b0d7da6e7d747b$var$Mb, $f0b0d7da6e7d747b$var$Mb);
} catch (a) {
    $f0b0d7da6e7d747b$var$Lb = !1;
}
function $f0b0d7da6e7d747b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f0b0d7da6e7d747b$var$Ob = !1, $f0b0d7da6e7d747b$var$Pb = null, $f0b0d7da6e7d747b$var$Qb = !1, $f0b0d7da6e7d747b$var$Rb = null, $f0b0d7da6e7d747b$var$Sb = {
    onError: function(a) {
        $f0b0d7da6e7d747b$var$Ob = !0;
        $f0b0d7da6e7d747b$var$Pb = a;
    }
};
function $f0b0d7da6e7d747b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f0b0d7da6e7d747b$var$Ob = !1;
    $f0b0d7da6e7d747b$var$Pb = null;
    $f0b0d7da6e7d747b$var$Nb.apply($f0b0d7da6e7d747b$var$Sb, arguments);
}
function $f0b0d7da6e7d747b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f0b0d7da6e7d747b$var$Tb.apply(this, arguments);
    if ($f0b0d7da6e7d747b$var$Ob) {
        if ($f0b0d7da6e7d747b$var$Ob) {
            var l = $f0b0d7da6e7d747b$var$Pb;
            $f0b0d7da6e7d747b$var$Ob = !1;
            $f0b0d7da6e7d747b$var$Pb = null;
        } else throw Error($f0b0d7da6e7d747b$var$p(198));
        $f0b0d7da6e7d747b$var$Qb || ($f0b0d7da6e7d747b$var$Qb = !0, $f0b0d7da6e7d747b$var$Rb = l);
    }
}
function $f0b0d7da6e7d747b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f0b0d7da6e7d747b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f0b0d7da6e7d747b$var$Xb(a) {
    if ($f0b0d7da6e7d747b$var$Vb(a) !== a) throw Error($f0b0d7da6e7d747b$var$p(188));
}
function $f0b0d7da6e7d747b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f0b0d7da6e7d747b$var$Vb(a);
        if (null === b) throw Error($f0b0d7da6e7d747b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f0b0d7da6e7d747b$var$Xb(e), a;
                if (f === d) return $f0b0d7da6e7d747b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f0b0d7da6e7d747b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f0b0d7da6e7d747b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f0b0d7da6e7d747b$var$p(190));
    }
    if (3 !== c.tag) throw Error($f0b0d7da6e7d747b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f0b0d7da6e7d747b$var$Zb(a) {
    a = $f0b0d7da6e7d747b$var$Yb(a);
    return null !== a ? $f0b0d7da6e7d747b$var$$b(a) : null;
}
function $f0b0d7da6e7d747b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f0b0d7da6e7d747b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f0b0d7da6e7d747b$var$ac = $f1D4w.unstable_scheduleCallback, $f0b0d7da6e7d747b$var$bc = $f1D4w.unstable_cancelCallback, $f0b0d7da6e7d747b$var$cc = $f1D4w.unstable_shouldYield, $f0b0d7da6e7d747b$var$dc = $f1D4w.unstable_requestPaint, $f0b0d7da6e7d747b$var$B = $f1D4w.unstable_now, $f0b0d7da6e7d747b$var$ec = $f1D4w.unstable_getCurrentPriorityLevel, $f0b0d7da6e7d747b$var$fc = $f1D4w.unstable_ImmediatePriority, $f0b0d7da6e7d747b$var$gc = $f1D4w.unstable_UserBlockingPriority, $f0b0d7da6e7d747b$var$hc = $f1D4w.unstable_NormalPriority, $f0b0d7da6e7d747b$var$ic = $f1D4w.unstable_LowPriority, $f0b0d7da6e7d747b$var$jc = $f1D4w.unstable_IdlePriority, $f0b0d7da6e7d747b$var$kc = null, $f0b0d7da6e7d747b$var$lc = null;
function $f0b0d7da6e7d747b$var$mc(a) {
    if ($f0b0d7da6e7d747b$var$lc && "function" === typeof $f0b0d7da6e7d747b$var$lc.onCommitFiberRoot) try {
        $f0b0d7da6e7d747b$var$lc.onCommitFiberRoot($f0b0d7da6e7d747b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f0b0d7da6e7d747b$var$oc = Math.clz32 ? Math.clz32 : $f0b0d7da6e7d747b$var$nc, $f0b0d7da6e7d747b$var$pc = Math.log, $f0b0d7da6e7d747b$var$qc = Math.LN2;
function $f0b0d7da6e7d747b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f0b0d7da6e7d747b$var$pc(a) / $f0b0d7da6e7d747b$var$qc | 0) | 0;
}
var $f0b0d7da6e7d747b$var$rc = 64, $f0b0d7da6e7d747b$var$sc = 4194304;
function $f0b0d7da6e7d747b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f0b0d7da6e7d747b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f0b0d7da6e7d747b$var$tc(h) : (f &= g, 0 !== f && (d = $f0b0d7da6e7d747b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f0b0d7da6e7d747b$var$tc(g) : 0 !== f && (d = $f0b0d7da6e7d747b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f0b0d7da6e7d747b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f0b0d7da6e7d747b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f0b0d7da6e7d747b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f0b0d7da6e7d747b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f0b0d7da6e7d747b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f0b0d7da6e7d747b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f0b0d7da6e7d747b$var$yc() {
    var a = $f0b0d7da6e7d747b$var$rc;
    $f0b0d7da6e7d747b$var$rc <<= 1;
    0 === ($f0b0d7da6e7d747b$var$rc & 4194240) && ($f0b0d7da6e7d747b$var$rc = 64);
    return a;
}
function $f0b0d7da6e7d747b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f0b0d7da6e7d747b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f0b0d7da6e7d747b$var$oc(b);
    a[b] = c;
}
function $f0b0d7da6e7d747b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f0b0d7da6e7d747b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f0b0d7da6e7d747b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f0b0d7da6e7d747b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f0b0d7da6e7d747b$var$C = 0;
function $f0b0d7da6e7d747b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f0b0d7da6e7d747b$var$Ec, $f0b0d7da6e7d747b$var$Fc, $f0b0d7da6e7d747b$var$Gc, $f0b0d7da6e7d747b$var$Hc, $f0b0d7da6e7d747b$var$Ic, $f0b0d7da6e7d747b$var$Jc = !1, $f0b0d7da6e7d747b$var$Kc = [], $f0b0d7da6e7d747b$var$Lc = null, $f0b0d7da6e7d747b$var$Mc = null, $f0b0d7da6e7d747b$var$Nc = null, $f0b0d7da6e7d747b$var$Oc = new Map, $f0b0d7da6e7d747b$var$Pc = new Map, $f0b0d7da6e7d747b$var$Qc = [], $f0b0d7da6e7d747b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f0b0d7da6e7d747b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f0b0d7da6e7d747b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f0b0d7da6e7d747b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f0b0d7da6e7d747b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f0b0d7da6e7d747b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f0b0d7da6e7d747b$var$Pc.delete(b.pointerId);
    }
}
function $f0b0d7da6e7d747b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f0b0d7da6e7d747b$var$Cb(b), null !== b && $f0b0d7da6e7d747b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f0b0d7da6e7d747b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f0b0d7da6e7d747b$var$Lc = $f0b0d7da6e7d747b$var$Tc($f0b0d7da6e7d747b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f0b0d7da6e7d747b$var$Mc = $f0b0d7da6e7d747b$var$Tc($f0b0d7da6e7d747b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f0b0d7da6e7d747b$var$Nc = $f0b0d7da6e7d747b$var$Tc($f0b0d7da6e7d747b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f0b0d7da6e7d747b$var$Oc.set(f, $f0b0d7da6e7d747b$var$Tc($f0b0d7da6e7d747b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f0b0d7da6e7d747b$var$Pc.set(f, $f0b0d7da6e7d747b$var$Tc($f0b0d7da6e7d747b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f0b0d7da6e7d747b$var$Vc(a) {
    var b = $f0b0d7da6e7d747b$var$Wc(a.target);
    if (null !== b) {
        var c = $f0b0d7da6e7d747b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f0b0d7da6e7d747b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f0b0d7da6e7d747b$var$Ic(a.priority, function() {
                        $f0b0d7da6e7d747b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f0b0d7da6e7d747b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f0b0d7da6e7d747b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f0b0d7da6e7d747b$var$wb = d;
            c.target.dispatchEvent(d);
            $f0b0d7da6e7d747b$var$wb = null;
        } else return b = $f0b0d7da6e7d747b$var$Cb(c), null !== b && $f0b0d7da6e7d747b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f0b0d7da6e7d747b$var$Zc(a, b, c) {
    $f0b0d7da6e7d747b$var$Xc(a) && c.delete(b);
}
function $f0b0d7da6e7d747b$var$$c() {
    $f0b0d7da6e7d747b$var$Jc = !1;
    null !== $f0b0d7da6e7d747b$var$Lc && $f0b0d7da6e7d747b$var$Xc($f0b0d7da6e7d747b$var$Lc) && ($f0b0d7da6e7d747b$var$Lc = null);
    null !== $f0b0d7da6e7d747b$var$Mc && $f0b0d7da6e7d747b$var$Xc($f0b0d7da6e7d747b$var$Mc) && ($f0b0d7da6e7d747b$var$Mc = null);
    null !== $f0b0d7da6e7d747b$var$Nc && $f0b0d7da6e7d747b$var$Xc($f0b0d7da6e7d747b$var$Nc) && ($f0b0d7da6e7d747b$var$Nc = null);
    $f0b0d7da6e7d747b$var$Oc.forEach($f0b0d7da6e7d747b$var$Zc);
    $f0b0d7da6e7d747b$var$Pc.forEach($f0b0d7da6e7d747b$var$Zc);
}
function $f0b0d7da6e7d747b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f0b0d7da6e7d747b$var$Jc || ($f0b0d7da6e7d747b$var$Jc = !0, $f1D4w.unstable_scheduleCallback($f1D4w.unstable_NormalPriority, $f0b0d7da6e7d747b$var$$c)));
}
function $f0b0d7da6e7d747b$var$bd(a) {
    function b(b) {
        return $f0b0d7da6e7d747b$var$ad(b, a);
    }
    if (0 < $f0b0d7da6e7d747b$var$Kc.length) {
        $f0b0d7da6e7d747b$var$ad($f0b0d7da6e7d747b$var$Kc[0], a);
        for(var c = 1; c < $f0b0d7da6e7d747b$var$Kc.length; c++){
            var d = $f0b0d7da6e7d747b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f0b0d7da6e7d747b$var$Lc && $f0b0d7da6e7d747b$var$ad($f0b0d7da6e7d747b$var$Lc, a);
    null !== $f0b0d7da6e7d747b$var$Mc && $f0b0d7da6e7d747b$var$ad($f0b0d7da6e7d747b$var$Mc, a);
    null !== $f0b0d7da6e7d747b$var$Nc && $f0b0d7da6e7d747b$var$ad($f0b0d7da6e7d747b$var$Nc, a);
    $f0b0d7da6e7d747b$var$Oc.forEach(b);
    $f0b0d7da6e7d747b$var$Pc.forEach(b);
    for(c = 0; c < $f0b0d7da6e7d747b$var$Qc.length; c++)d = $f0b0d7da6e7d747b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f0b0d7da6e7d747b$var$Qc.length && (c = $f0b0d7da6e7d747b$var$Qc[0], null === c.blockedOn);)$f0b0d7da6e7d747b$var$Vc(c), null === c.blockedOn && $f0b0d7da6e7d747b$var$Qc.shift();
}
var $f0b0d7da6e7d747b$var$cd = $f0b0d7da6e7d747b$var$ua.ReactCurrentBatchConfig, $f0b0d7da6e7d747b$var$dd = !0;
function $f0b0d7da6e7d747b$var$ed(a, b, c, d) {
    var e = $f0b0d7da6e7d747b$var$C, f = $f0b0d7da6e7d747b$var$cd.transition;
    $f0b0d7da6e7d747b$var$cd.transition = null;
    try {
        $f0b0d7da6e7d747b$var$C = 1, $f0b0d7da6e7d747b$var$fd(a, b, c, d);
    } finally{
        $f0b0d7da6e7d747b$var$C = e, $f0b0d7da6e7d747b$var$cd.transition = f;
    }
}
function $f0b0d7da6e7d747b$var$gd(a, b, c, d) {
    var e = $f0b0d7da6e7d747b$var$C, f = $f0b0d7da6e7d747b$var$cd.transition;
    $f0b0d7da6e7d747b$var$cd.transition = null;
    try {
        $f0b0d7da6e7d747b$var$C = 4, $f0b0d7da6e7d747b$var$fd(a, b, c, d);
    } finally{
        $f0b0d7da6e7d747b$var$C = e, $f0b0d7da6e7d747b$var$cd.transition = f;
    }
}
function $f0b0d7da6e7d747b$var$fd(a, b, c, d) {
    if ($f0b0d7da6e7d747b$var$dd) {
        var e = $f0b0d7da6e7d747b$var$Yc(a, b, c, d);
        if (null === e) $f0b0d7da6e7d747b$var$hd(a, b, d, $f0b0d7da6e7d747b$var$id, c), $f0b0d7da6e7d747b$var$Sc(a, d);
        else if ($f0b0d7da6e7d747b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f0b0d7da6e7d747b$var$Sc(a, d), b & 4 && -1 < $f0b0d7da6e7d747b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f0b0d7da6e7d747b$var$Cb(e);
                null !== f && $f0b0d7da6e7d747b$var$Ec(f);
                f = $f0b0d7da6e7d747b$var$Yc(a, b, c, d);
                null === f && $f0b0d7da6e7d747b$var$hd(a, b, d, $f0b0d7da6e7d747b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f0b0d7da6e7d747b$var$hd(a, b, d, null, c);
    }
}
var $f0b0d7da6e7d747b$var$id = null;
function $f0b0d7da6e7d747b$var$Yc(a, b, c, d) {
    $f0b0d7da6e7d747b$var$id = null;
    a = $f0b0d7da6e7d747b$var$xb(d);
    a = $f0b0d7da6e7d747b$var$Wc(a);
    if (null !== a) {
        if (b = $f0b0d7da6e7d747b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f0b0d7da6e7d747b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f0b0d7da6e7d747b$var$id = a;
    return null;
}
function $f0b0d7da6e7d747b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f0b0d7da6e7d747b$var$ec()){
                case $f0b0d7da6e7d747b$var$fc:
                    return 1;
                case $f0b0d7da6e7d747b$var$gc:
                    return 4;
                case $f0b0d7da6e7d747b$var$hc:
                case $f0b0d7da6e7d747b$var$ic:
                    return 16;
                case $f0b0d7da6e7d747b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f0b0d7da6e7d747b$var$kd = null, $f0b0d7da6e7d747b$var$ld = null, $f0b0d7da6e7d747b$var$md = null;
function $f0b0d7da6e7d747b$var$nd() {
    if ($f0b0d7da6e7d747b$var$md) return $f0b0d7da6e7d747b$var$md;
    var a, b = $f0b0d7da6e7d747b$var$ld, c = b.length, d, e = "value" in $f0b0d7da6e7d747b$var$kd ? $f0b0d7da6e7d747b$var$kd.value : $f0b0d7da6e7d747b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f0b0d7da6e7d747b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f0b0d7da6e7d747b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f0b0d7da6e7d747b$var$pd() {
    return !0;
}
function $f0b0d7da6e7d747b$var$qd() {
    return !1;
}
function $f0b0d7da6e7d747b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f0b0d7da6e7d747b$var$pd : $f0b0d7da6e7d747b$var$qd;
        this.isPropagationStopped = $f0b0d7da6e7d747b$var$qd;
        return this;
    }
    $f0b0d7da6e7d747b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f0b0d7da6e7d747b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f0b0d7da6e7d747b$var$pd);
        },
        persist: function() {},
        isPersistent: $f0b0d7da6e7d747b$var$pd
    });
    return b;
}
var $f0b0d7da6e7d747b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f0b0d7da6e7d747b$var$td = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$sd), $f0b0d7da6e7d747b$var$ud = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$sd, {
    view: 0,
    detail: 0
}), $f0b0d7da6e7d747b$var$vd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$ud), $f0b0d7da6e7d747b$var$wd, $f0b0d7da6e7d747b$var$xd, $f0b0d7da6e7d747b$var$yd, $f0b0d7da6e7d747b$var$Ad = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f0b0d7da6e7d747b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f0b0d7da6e7d747b$var$yd && ($f0b0d7da6e7d747b$var$yd && "mousemove" === a.type ? ($f0b0d7da6e7d747b$var$wd = a.screenX - $f0b0d7da6e7d747b$var$yd.screenX, $f0b0d7da6e7d747b$var$xd = a.screenY - $f0b0d7da6e7d747b$var$yd.screenY) : $f0b0d7da6e7d747b$var$xd = $f0b0d7da6e7d747b$var$wd = 0, $f0b0d7da6e7d747b$var$yd = a);
        return $f0b0d7da6e7d747b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f0b0d7da6e7d747b$var$xd;
    }
}), $f0b0d7da6e7d747b$var$Bd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Ad), $f0b0d7da6e7d747b$var$Cd = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$Ad, {
    dataTransfer: 0
}), $f0b0d7da6e7d747b$var$Dd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Cd), $f0b0d7da6e7d747b$var$Ed = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$ud, {
    relatedTarget: 0
}), $f0b0d7da6e7d747b$var$Fd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Ed), $f0b0d7da6e7d747b$var$Gd = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f0b0d7da6e7d747b$var$Hd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Gd), $f0b0d7da6e7d747b$var$Id = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f0b0d7da6e7d747b$var$Jd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Id), $f0b0d7da6e7d747b$var$Kd = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$sd, {
    data: 0
}), $f0b0d7da6e7d747b$var$Ld = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Kd), $f0b0d7da6e7d747b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f0b0d7da6e7d747b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f0b0d7da6e7d747b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f0b0d7da6e7d747b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f0b0d7da6e7d747b$var$Od[a]) ? !!b[a] : !1;
}
function $f0b0d7da6e7d747b$var$zd() {
    return $f0b0d7da6e7d747b$var$Pd;
}
var $f0b0d7da6e7d747b$var$Qd = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f0b0d7da6e7d747b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f0b0d7da6e7d747b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f0b0d7da6e7d747b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f0b0d7da6e7d747b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f0b0d7da6e7d747b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f0b0d7da6e7d747b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f0b0d7da6e7d747b$var$Rd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Qd), $f0b0d7da6e7d747b$var$Sd = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f0b0d7da6e7d747b$var$Td = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Sd), $f0b0d7da6e7d747b$var$Ud = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f0b0d7da6e7d747b$var$zd
}), $f0b0d7da6e7d747b$var$Vd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Ud), $f0b0d7da6e7d747b$var$Wd = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f0b0d7da6e7d747b$var$Xd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Wd), $f0b0d7da6e7d747b$var$Yd = $f0b0d7da6e7d747b$var$A({}, $f0b0d7da6e7d747b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f0b0d7da6e7d747b$var$Zd = $f0b0d7da6e7d747b$var$rd($f0b0d7da6e7d747b$var$Yd), $f0b0d7da6e7d747b$var$$d = [
    9,
    13,
    27,
    32
], $f0b0d7da6e7d747b$var$ae = $f0b0d7da6e7d747b$var$ia && "CompositionEvent" in window, $f0b0d7da6e7d747b$var$be = null;
$f0b0d7da6e7d747b$var$ia && "documentMode" in document && ($f0b0d7da6e7d747b$var$be = document.documentMode);
var $f0b0d7da6e7d747b$var$ce = $f0b0d7da6e7d747b$var$ia && "TextEvent" in window && !$f0b0d7da6e7d747b$var$be, $f0b0d7da6e7d747b$var$de = $f0b0d7da6e7d747b$var$ia && (!$f0b0d7da6e7d747b$var$ae || $f0b0d7da6e7d747b$var$be && 8 < $f0b0d7da6e7d747b$var$be && 11 >= $f0b0d7da6e7d747b$var$be), $f0b0d7da6e7d747b$var$ee = String.fromCharCode(32), $f0b0d7da6e7d747b$var$fe = !1;
function $f0b0d7da6e7d747b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f0b0d7da6e7d747b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f0b0d7da6e7d747b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f0b0d7da6e7d747b$var$ie = !1;
function $f0b0d7da6e7d747b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f0b0d7da6e7d747b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f0b0d7da6e7d747b$var$fe = !0;
            return $f0b0d7da6e7d747b$var$ee;
        case "textInput":
            return a = b.data, a === $f0b0d7da6e7d747b$var$ee && $f0b0d7da6e7d747b$var$fe ? null : a;
        default:
            return null;
    }
}
function $f0b0d7da6e7d747b$var$ke(a, b) {
    if ($f0b0d7da6e7d747b$var$ie) return "compositionend" === a || !$f0b0d7da6e7d747b$var$ae && $f0b0d7da6e7d747b$var$ge(a, b) ? (a = $f0b0d7da6e7d747b$var$nd(), $f0b0d7da6e7d747b$var$md = $f0b0d7da6e7d747b$var$ld = $f0b0d7da6e7d747b$var$kd = null, $f0b0d7da6e7d747b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f0b0d7da6e7d747b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f0b0d7da6e7d747b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f0b0d7da6e7d747b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f0b0d7da6e7d747b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f0b0d7da6e7d747b$var$ne(a, b, c, d) {
    $f0b0d7da6e7d747b$var$Eb(d);
    b = $f0b0d7da6e7d747b$var$oe(b, "onChange");
    0 < b.length && (c = new $f0b0d7da6e7d747b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f0b0d7da6e7d747b$var$pe = null, $f0b0d7da6e7d747b$var$qe = null;
function $f0b0d7da6e7d747b$var$re(a) {
    $f0b0d7da6e7d747b$var$se(a, 0);
}
function $f0b0d7da6e7d747b$var$te(a) {
    var b = $f0b0d7da6e7d747b$var$ue(a);
    if ($f0b0d7da6e7d747b$var$Wa(b)) return a;
}
function $f0b0d7da6e7d747b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f0b0d7da6e7d747b$var$we = !1;
if ($f0b0d7da6e7d747b$var$ia) {
    var $f0b0d7da6e7d747b$var$xe;
    if ($f0b0d7da6e7d747b$var$ia) {
        var $f0b0d7da6e7d747b$var$ye = "oninput" in document;
        if (!$f0b0d7da6e7d747b$var$ye) {
            var $f0b0d7da6e7d747b$var$ze = document.createElement("div");
            $f0b0d7da6e7d747b$var$ze.setAttribute("oninput", "return;");
            $f0b0d7da6e7d747b$var$ye = "function" === typeof $f0b0d7da6e7d747b$var$ze.oninput;
        }
        $f0b0d7da6e7d747b$var$xe = $f0b0d7da6e7d747b$var$ye;
    } else $f0b0d7da6e7d747b$var$xe = !1;
    $f0b0d7da6e7d747b$var$we = $f0b0d7da6e7d747b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f0b0d7da6e7d747b$var$Ae() {
    $f0b0d7da6e7d747b$var$pe && ($f0b0d7da6e7d747b$var$pe.detachEvent("onpropertychange", $f0b0d7da6e7d747b$var$Be), $f0b0d7da6e7d747b$var$qe = $f0b0d7da6e7d747b$var$pe = null);
}
function $f0b0d7da6e7d747b$var$Be(a) {
    if ("value" === a.propertyName && $f0b0d7da6e7d747b$var$te($f0b0d7da6e7d747b$var$qe)) {
        var b = [];
        $f0b0d7da6e7d747b$var$ne(b, $f0b0d7da6e7d747b$var$qe, a, $f0b0d7da6e7d747b$var$xb(a));
        $f0b0d7da6e7d747b$var$Jb($f0b0d7da6e7d747b$var$re, b);
    }
}
function $f0b0d7da6e7d747b$var$Ce(a, b, c) {
    "focusin" === a ? ($f0b0d7da6e7d747b$var$Ae(), $f0b0d7da6e7d747b$var$pe = b, $f0b0d7da6e7d747b$var$qe = c, $f0b0d7da6e7d747b$var$pe.attachEvent("onpropertychange", $f0b0d7da6e7d747b$var$Be)) : "focusout" === a && $f0b0d7da6e7d747b$var$Ae();
}
function $f0b0d7da6e7d747b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f0b0d7da6e7d747b$var$te($f0b0d7da6e7d747b$var$qe);
}
function $f0b0d7da6e7d747b$var$Ee(a, b) {
    if ("click" === a) return $f0b0d7da6e7d747b$var$te(b);
}
function $f0b0d7da6e7d747b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f0b0d7da6e7d747b$var$te(b);
}
function $f0b0d7da6e7d747b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f0b0d7da6e7d747b$var$He = "function" === typeof Object.is ? Object.is : $f0b0d7da6e7d747b$var$Ge;
function $f0b0d7da6e7d747b$var$Ie(a, b) {
    if ($f0b0d7da6e7d747b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f0b0d7da6e7d747b$var$ja.call(b, e) || !$f0b0d7da6e7d747b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f0b0d7da6e7d747b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f0b0d7da6e7d747b$var$Ke(a, b) {
    var c = $f0b0d7da6e7d747b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f0b0d7da6e7d747b$var$Je(c);
    }
}
function $f0b0d7da6e7d747b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f0b0d7da6e7d747b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f0b0d7da6e7d747b$var$Me() {
    for(var a = window, b = $f0b0d7da6e7d747b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f0b0d7da6e7d747b$var$Xa(a.document);
    }
    return b;
}
function $f0b0d7da6e7d747b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f0b0d7da6e7d747b$var$Oe(a) {
    var b = $f0b0d7da6e7d747b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f0b0d7da6e7d747b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f0b0d7da6e7d747b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f0b0d7da6e7d747b$var$Ke(c, f);
                var g = $f0b0d7da6e7d747b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f0b0d7da6e7d747b$var$Pe = $f0b0d7da6e7d747b$var$ia && "documentMode" in document && 11 >= document.documentMode, $f0b0d7da6e7d747b$var$Qe = null, $f0b0d7da6e7d747b$var$Re = null, $f0b0d7da6e7d747b$var$Se = null, $f0b0d7da6e7d747b$var$Te = !1;
function $f0b0d7da6e7d747b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f0b0d7da6e7d747b$var$Te || null == $f0b0d7da6e7d747b$var$Qe || $f0b0d7da6e7d747b$var$Qe !== $f0b0d7da6e7d747b$var$Xa(d) || (d = $f0b0d7da6e7d747b$var$Qe, "selectionStart" in d && $f0b0d7da6e7d747b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f0b0d7da6e7d747b$var$Se && $f0b0d7da6e7d747b$var$Ie($f0b0d7da6e7d747b$var$Se, d) || ($f0b0d7da6e7d747b$var$Se = d, d = $f0b0d7da6e7d747b$var$oe($f0b0d7da6e7d747b$var$Re, "onSelect"), 0 < d.length && (b = new $f0b0d7da6e7d747b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f0b0d7da6e7d747b$var$Qe)));
}
function $f0b0d7da6e7d747b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f0b0d7da6e7d747b$var$We = {
    animationend: $f0b0d7da6e7d747b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f0b0d7da6e7d747b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f0b0d7da6e7d747b$var$Ve("Animation", "AnimationStart"),
    transitionend: $f0b0d7da6e7d747b$var$Ve("Transition", "TransitionEnd")
}, $f0b0d7da6e7d747b$var$Xe = {}, $f0b0d7da6e7d747b$var$Ye = {};
$f0b0d7da6e7d747b$var$ia && ($f0b0d7da6e7d747b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f0b0d7da6e7d747b$var$We.animationend.animation, delete $f0b0d7da6e7d747b$var$We.animationiteration.animation, delete $f0b0d7da6e7d747b$var$We.animationstart.animation), "TransitionEvent" in window || delete $f0b0d7da6e7d747b$var$We.transitionend.transition);
function $f0b0d7da6e7d747b$var$Ze(a) {
    if ($f0b0d7da6e7d747b$var$Xe[a]) return $f0b0d7da6e7d747b$var$Xe[a];
    if (!$f0b0d7da6e7d747b$var$We[a]) return a;
    var b = $f0b0d7da6e7d747b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f0b0d7da6e7d747b$var$Ye) return $f0b0d7da6e7d747b$var$Xe[a] = b[c];
    return a;
}
var $f0b0d7da6e7d747b$var$$e = $f0b0d7da6e7d747b$var$Ze("animationend"), $f0b0d7da6e7d747b$var$af = $f0b0d7da6e7d747b$var$Ze("animationiteration"), $f0b0d7da6e7d747b$var$bf = $f0b0d7da6e7d747b$var$Ze("animationstart"), $f0b0d7da6e7d747b$var$cf = $f0b0d7da6e7d747b$var$Ze("transitionend"), $f0b0d7da6e7d747b$var$df = new Map, $f0b0d7da6e7d747b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f0b0d7da6e7d747b$var$ff(a, b) {
    $f0b0d7da6e7d747b$var$df.set(a, b);
    $f0b0d7da6e7d747b$var$fa(b, [
        a
    ]);
}
for(var $f0b0d7da6e7d747b$var$gf = 0; $f0b0d7da6e7d747b$var$gf < $f0b0d7da6e7d747b$var$ef.length; $f0b0d7da6e7d747b$var$gf++){
    var $f0b0d7da6e7d747b$var$hf = $f0b0d7da6e7d747b$var$ef[$f0b0d7da6e7d747b$var$gf], $f0b0d7da6e7d747b$var$jf = $f0b0d7da6e7d747b$var$hf.toLowerCase(), $f0b0d7da6e7d747b$var$kf = $f0b0d7da6e7d747b$var$hf[0].toUpperCase() + $f0b0d7da6e7d747b$var$hf.slice(1);
    $f0b0d7da6e7d747b$var$ff($f0b0d7da6e7d747b$var$jf, "on" + $f0b0d7da6e7d747b$var$kf);
}
$f0b0d7da6e7d747b$var$ff($f0b0d7da6e7d747b$var$$e, "onAnimationEnd");
$f0b0d7da6e7d747b$var$ff($f0b0d7da6e7d747b$var$af, "onAnimationIteration");
$f0b0d7da6e7d747b$var$ff($f0b0d7da6e7d747b$var$bf, "onAnimationStart");
$f0b0d7da6e7d747b$var$ff("dblclick", "onDoubleClick");
$f0b0d7da6e7d747b$var$ff("focusin", "onFocus");
$f0b0d7da6e7d747b$var$ff("focusout", "onBlur");
$f0b0d7da6e7d747b$var$ff($f0b0d7da6e7d747b$var$cf, "onTransitionEnd");
$f0b0d7da6e7d747b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f0b0d7da6e7d747b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f0b0d7da6e7d747b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f0b0d7da6e7d747b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f0b0d7da6e7d747b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f0b0d7da6e7d747b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f0b0d7da6e7d747b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f0b0d7da6e7d747b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f0b0d7da6e7d747b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f0b0d7da6e7d747b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f0b0d7da6e7d747b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f0b0d7da6e7d747b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f0b0d7da6e7d747b$var$lf));
function $f0b0d7da6e7d747b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f0b0d7da6e7d747b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f0b0d7da6e7d747b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f0b0d7da6e7d747b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f0b0d7da6e7d747b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f0b0d7da6e7d747b$var$Qb) throw a = $f0b0d7da6e7d747b$var$Rb, $f0b0d7da6e7d747b$var$Qb = !1, $f0b0d7da6e7d747b$var$Rb = null, a;
}
function $f0b0d7da6e7d747b$var$D(a, b) {
    var c = b[$f0b0d7da6e7d747b$var$of];
    void 0 === c && (c = b[$f0b0d7da6e7d747b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f0b0d7da6e7d747b$var$pf(b, a, 2, !1), c.add(d));
}
function $f0b0d7da6e7d747b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f0b0d7da6e7d747b$var$pf(c, a, d, b);
}
var $f0b0d7da6e7d747b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f0b0d7da6e7d747b$var$sf(a) {
    if (!a[$f0b0d7da6e7d747b$var$rf]) {
        a[$f0b0d7da6e7d747b$var$rf] = !0;
        $f0b0d7da6e7d747b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f0b0d7da6e7d747b$var$mf.has(b) || $f0b0d7da6e7d747b$var$qf(b, !1, a), $f0b0d7da6e7d747b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f0b0d7da6e7d747b$var$rf] || (b[$f0b0d7da6e7d747b$var$rf] = !0, $f0b0d7da6e7d747b$var$qf("selectionchange", !1, b));
    }
}
function $f0b0d7da6e7d747b$var$pf(a, b, c, d) {
    switch($f0b0d7da6e7d747b$var$jd(b)){
        case 1:
            var e = $f0b0d7da6e7d747b$var$ed;
            break;
        case 4:
            e = $f0b0d7da6e7d747b$var$gd;
            break;
        default:
            e = $f0b0d7da6e7d747b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f0b0d7da6e7d747b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f0b0d7da6e7d747b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f0b0d7da6e7d747b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f0b0d7da6e7d747b$var$Jb(function() {
        var d = f, e = $f0b0d7da6e7d747b$var$xb(c), g = [];
        a: {
            var h = $f0b0d7da6e7d747b$var$df.get(a);
            if (void 0 !== h) {
                var k = $f0b0d7da6e7d747b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f0b0d7da6e7d747b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f0b0d7da6e7d747b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f0b0d7da6e7d747b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f0b0d7da6e7d747b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f0b0d7da6e7d747b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f0b0d7da6e7d747b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f0b0d7da6e7d747b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f0b0d7da6e7d747b$var$Vd;
                        break;
                    case $f0b0d7da6e7d747b$var$$e:
                    case $f0b0d7da6e7d747b$var$af:
                    case $f0b0d7da6e7d747b$var$bf:
                        k = $f0b0d7da6e7d747b$var$Hd;
                        break;
                    case $f0b0d7da6e7d747b$var$cf:
                        k = $f0b0d7da6e7d747b$var$Xd;
                        break;
                    case "scroll":
                        k = $f0b0d7da6e7d747b$var$vd;
                        break;
                    case "wheel":
                        k = $f0b0d7da6e7d747b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f0b0d7da6e7d747b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f0b0d7da6e7d747b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f0b0d7da6e7d747b$var$Kb(w, x), null != F && t.push($f0b0d7da6e7d747b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f0b0d7da6e7d747b$var$wb && (n = c.relatedTarget || c.fromElement) && ($f0b0d7da6e7d747b$var$Wc(n) || n[$f0b0d7da6e7d747b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f0b0d7da6e7d747b$var$Wc(n) : null, null !== n && (J = $f0b0d7da6e7d747b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f0b0d7da6e7d747b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f0b0d7da6e7d747b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f0b0d7da6e7d747b$var$ue(k);
                        u = null == n ? h : $f0b0d7da6e7d747b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f0b0d7da6e7d747b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f0b0d7da6e7d747b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f0b0d7da6e7d747b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f0b0d7da6e7d747b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f0b0d7da6e7d747b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f0b0d7da6e7d747b$var$vf(t);
                                x = $f0b0d7da6e7d747b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f0b0d7da6e7d747b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f0b0d7da6e7d747b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f0b0d7da6e7d747b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f0b0d7da6e7d747b$var$ve;
                else if ($f0b0d7da6e7d747b$var$me(h)) {
                    if ($f0b0d7da6e7d747b$var$we) na = $f0b0d7da6e7d747b$var$Fe;
                    else {
                        na = $f0b0d7da6e7d747b$var$De;
                        var xa = $f0b0d7da6e7d747b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f0b0d7da6e7d747b$var$Ee);
                if (na && (na = na(a, d))) {
                    $f0b0d7da6e7d747b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f0b0d7da6e7d747b$var$cb(h, "number", h.value);
            }
            xa = d ? $f0b0d7da6e7d747b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f0b0d7da6e7d747b$var$me(xa) || "true" === xa.contentEditable) $f0b0d7da6e7d747b$var$Qe = xa, $f0b0d7da6e7d747b$var$Re = d, $f0b0d7da6e7d747b$var$Se = null;
                    break;
                case "focusout":
                    $f0b0d7da6e7d747b$var$Se = $f0b0d7da6e7d747b$var$Re = $f0b0d7da6e7d747b$var$Qe = null;
                    break;
                case "mousedown":
                    $f0b0d7da6e7d747b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f0b0d7da6e7d747b$var$Te = !1;
                    $f0b0d7da6e7d747b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f0b0d7da6e7d747b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f0b0d7da6e7d747b$var$Ue(g, c, e);
            }
            var $a;
            if ($f0b0d7da6e7d747b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f0b0d7da6e7d747b$var$ie ? $f0b0d7da6e7d747b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f0b0d7da6e7d747b$var$de && "ko" !== c.locale && ($f0b0d7da6e7d747b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f0b0d7da6e7d747b$var$ie && ($a = $f0b0d7da6e7d747b$var$nd()) : ($f0b0d7da6e7d747b$var$kd = e, $f0b0d7da6e7d747b$var$ld = "value" in $f0b0d7da6e7d747b$var$kd ? $f0b0d7da6e7d747b$var$kd.value : $f0b0d7da6e7d747b$var$kd.textContent, $f0b0d7da6e7d747b$var$ie = !0)), xa = $f0b0d7da6e7d747b$var$oe(d, ba), 0 < xa.length && (ba = new $f0b0d7da6e7d747b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f0b0d7da6e7d747b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f0b0d7da6e7d747b$var$ce ? $f0b0d7da6e7d747b$var$je(a, c) : $f0b0d7da6e7d747b$var$ke(a, c)) d = $f0b0d7da6e7d747b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f0b0d7da6e7d747b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f0b0d7da6e7d747b$var$se(g, b);
    });
}
function $f0b0d7da6e7d747b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f0b0d7da6e7d747b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f0b0d7da6e7d747b$var$Kb(a, c), null != f && d.unshift($f0b0d7da6e7d747b$var$tf(a, f, e)), f = $f0b0d7da6e7d747b$var$Kb(a, b), null != f && d.push($f0b0d7da6e7d747b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f0b0d7da6e7d747b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f0b0d7da6e7d747b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f0b0d7da6e7d747b$var$Kb(c, f), null != k && g.unshift($f0b0d7da6e7d747b$var$tf(c, k, h))) : e || (k = $f0b0d7da6e7d747b$var$Kb(c, f), null != k && g.push($f0b0d7da6e7d747b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f0b0d7da6e7d747b$var$xf = /\r\n?/g, $f0b0d7da6e7d747b$var$yf = /\u0000|\uFFFD/g;
function $f0b0d7da6e7d747b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f0b0d7da6e7d747b$var$xf, "\n").replace($f0b0d7da6e7d747b$var$yf, "");
}
function $f0b0d7da6e7d747b$var$Af(a, b, c) {
    b = $f0b0d7da6e7d747b$var$zf(b);
    if ($f0b0d7da6e7d747b$var$zf(a) !== b && c) throw Error($f0b0d7da6e7d747b$var$p(425));
}
function $f0b0d7da6e7d747b$var$Bf() {}
var $f0b0d7da6e7d747b$var$Cf = null, $f0b0d7da6e7d747b$var$Df = null;
function $f0b0d7da6e7d747b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f0b0d7da6e7d747b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f0b0d7da6e7d747b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f0b0d7da6e7d747b$var$Hf = "function" === typeof Promise ? Promise : void 0, $f0b0d7da6e7d747b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f0b0d7da6e7d747b$var$Hf ? function(a) {
    return $f0b0d7da6e7d747b$var$Hf.resolve(null).then(a).catch($f0b0d7da6e7d747b$var$If);
} : $f0b0d7da6e7d747b$var$Ff;
function $f0b0d7da6e7d747b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f0b0d7da6e7d747b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f0b0d7da6e7d747b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f0b0d7da6e7d747b$var$bd(b);
}
function $f0b0d7da6e7d747b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f0b0d7da6e7d747b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f0b0d7da6e7d747b$var$Nf = Math.random().toString(36).slice(2), $f0b0d7da6e7d747b$var$Of = "__reactFiber$" + $f0b0d7da6e7d747b$var$Nf, $f0b0d7da6e7d747b$var$Pf = "__reactProps$" + $f0b0d7da6e7d747b$var$Nf, $f0b0d7da6e7d747b$var$uf = "__reactContainer$" + $f0b0d7da6e7d747b$var$Nf, $f0b0d7da6e7d747b$var$of = "__reactEvents$" + $f0b0d7da6e7d747b$var$Nf, $f0b0d7da6e7d747b$var$Qf = "__reactListeners$" + $f0b0d7da6e7d747b$var$Nf, $f0b0d7da6e7d747b$var$Rf = "__reactHandles$" + $f0b0d7da6e7d747b$var$Nf;
function $f0b0d7da6e7d747b$var$Wc(a) {
    var b = a[$f0b0d7da6e7d747b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f0b0d7da6e7d747b$var$uf] || c[$f0b0d7da6e7d747b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f0b0d7da6e7d747b$var$Mf(a); null !== a;){
                if (c = a[$f0b0d7da6e7d747b$var$Of]) return c;
                a = $f0b0d7da6e7d747b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f0b0d7da6e7d747b$var$Cb(a) {
    a = a[$f0b0d7da6e7d747b$var$Of] || a[$f0b0d7da6e7d747b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f0b0d7da6e7d747b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f0b0d7da6e7d747b$var$p(33));
}
function $f0b0d7da6e7d747b$var$Db(a) {
    return a[$f0b0d7da6e7d747b$var$Pf] || null;
}
var $f0b0d7da6e7d747b$var$Sf = [], $f0b0d7da6e7d747b$var$Tf = -1;
function $f0b0d7da6e7d747b$var$Uf(a) {
    return {
        current: a
    };
}
function $f0b0d7da6e7d747b$var$E(a) {
    0 > $f0b0d7da6e7d747b$var$Tf || (a.current = $f0b0d7da6e7d747b$var$Sf[$f0b0d7da6e7d747b$var$Tf], $f0b0d7da6e7d747b$var$Sf[$f0b0d7da6e7d747b$var$Tf] = null, $f0b0d7da6e7d747b$var$Tf--);
}
function $f0b0d7da6e7d747b$var$G(a, b) {
    $f0b0d7da6e7d747b$var$Tf++;
    $f0b0d7da6e7d747b$var$Sf[$f0b0d7da6e7d747b$var$Tf] = a.current;
    a.current = b;
}
var $f0b0d7da6e7d747b$var$Vf = {}, $f0b0d7da6e7d747b$var$H = $f0b0d7da6e7d747b$var$Uf($f0b0d7da6e7d747b$var$Vf), $f0b0d7da6e7d747b$var$Wf = $f0b0d7da6e7d747b$var$Uf(!1), $f0b0d7da6e7d747b$var$Xf = $f0b0d7da6e7d747b$var$Vf;
function $f0b0d7da6e7d747b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f0b0d7da6e7d747b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f0b0d7da6e7d747b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f0b0d7da6e7d747b$var$$f() {
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Wf);
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$H);
}
function $f0b0d7da6e7d747b$var$ag(a, b, c) {
    if ($f0b0d7da6e7d747b$var$H.current !== $f0b0d7da6e7d747b$var$Vf) throw Error($f0b0d7da6e7d747b$var$p(168));
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$H, b);
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Wf, c);
}
function $f0b0d7da6e7d747b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f0b0d7da6e7d747b$var$p(108, $f0b0d7da6e7d747b$var$Ra(a) || "Unknown", e));
    return $f0b0d7da6e7d747b$var$A({}, c, d);
}
function $f0b0d7da6e7d747b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f0b0d7da6e7d747b$var$Vf;
    $f0b0d7da6e7d747b$var$Xf = $f0b0d7da6e7d747b$var$H.current;
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$H, a);
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Wf, $f0b0d7da6e7d747b$var$Wf.current);
    return !0;
}
function $f0b0d7da6e7d747b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f0b0d7da6e7d747b$var$p(169));
    c ? (a = $f0b0d7da6e7d747b$var$bg(a, b, $f0b0d7da6e7d747b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Wf), $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$H), $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$H, a)) : $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Wf);
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Wf, c);
}
var $f0b0d7da6e7d747b$var$eg = null, $f0b0d7da6e7d747b$var$fg = !1, $f0b0d7da6e7d747b$var$gg = !1;
function $f0b0d7da6e7d747b$var$hg(a) {
    null === $f0b0d7da6e7d747b$var$eg ? $f0b0d7da6e7d747b$var$eg = [
        a
    ] : $f0b0d7da6e7d747b$var$eg.push(a);
}
function $f0b0d7da6e7d747b$var$ig(a) {
    $f0b0d7da6e7d747b$var$fg = !0;
    $f0b0d7da6e7d747b$var$hg(a);
}
function $f0b0d7da6e7d747b$var$jg() {
    if (!$f0b0d7da6e7d747b$var$gg && null !== $f0b0d7da6e7d747b$var$eg) {
        $f0b0d7da6e7d747b$var$gg = !0;
        var a = 0, b = $f0b0d7da6e7d747b$var$C;
        try {
            var c = $f0b0d7da6e7d747b$var$eg;
            for($f0b0d7da6e7d747b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f0b0d7da6e7d747b$var$eg = null;
            $f0b0d7da6e7d747b$var$fg = !1;
        } catch (e) {
            throw null !== $f0b0d7da6e7d747b$var$eg && ($f0b0d7da6e7d747b$var$eg = $f0b0d7da6e7d747b$var$eg.slice(a + 1)), $f0b0d7da6e7d747b$var$ac($f0b0d7da6e7d747b$var$fc, $f0b0d7da6e7d747b$var$jg), e;
        } finally{
            $f0b0d7da6e7d747b$var$C = b, $f0b0d7da6e7d747b$var$gg = !1;
        }
    }
    return null;
}
var $f0b0d7da6e7d747b$var$kg = [], $f0b0d7da6e7d747b$var$lg = 0, $f0b0d7da6e7d747b$var$mg = null, $f0b0d7da6e7d747b$var$ng = 0, $f0b0d7da6e7d747b$var$og = [], $f0b0d7da6e7d747b$var$pg = 0, $f0b0d7da6e7d747b$var$qg = null, $f0b0d7da6e7d747b$var$rg = 1, $f0b0d7da6e7d747b$var$sg = "";
function $f0b0d7da6e7d747b$var$tg(a, b) {
    $f0b0d7da6e7d747b$var$kg[$f0b0d7da6e7d747b$var$lg++] = $f0b0d7da6e7d747b$var$ng;
    $f0b0d7da6e7d747b$var$kg[$f0b0d7da6e7d747b$var$lg++] = $f0b0d7da6e7d747b$var$mg;
    $f0b0d7da6e7d747b$var$mg = a;
    $f0b0d7da6e7d747b$var$ng = b;
}
function $f0b0d7da6e7d747b$var$ug(a, b, c) {
    $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg++] = $f0b0d7da6e7d747b$var$rg;
    $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg++] = $f0b0d7da6e7d747b$var$sg;
    $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg++] = $f0b0d7da6e7d747b$var$qg;
    $f0b0d7da6e7d747b$var$qg = a;
    var d = $f0b0d7da6e7d747b$var$rg;
    a = $f0b0d7da6e7d747b$var$sg;
    var e = 32 - $f0b0d7da6e7d747b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f0b0d7da6e7d747b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f0b0d7da6e7d747b$var$rg = 1 << 32 - $f0b0d7da6e7d747b$var$oc(b) + e | c << e | d;
        $f0b0d7da6e7d747b$var$sg = f + a;
    } else $f0b0d7da6e7d747b$var$rg = 1 << f | c << e | d, $f0b0d7da6e7d747b$var$sg = a;
}
function $f0b0d7da6e7d747b$var$vg(a) {
    null !== a.return && ($f0b0d7da6e7d747b$var$tg(a, 1), $f0b0d7da6e7d747b$var$ug(a, 1, 0));
}
function $f0b0d7da6e7d747b$var$wg(a) {
    for(; a === $f0b0d7da6e7d747b$var$mg;)$f0b0d7da6e7d747b$var$mg = $f0b0d7da6e7d747b$var$kg[--$f0b0d7da6e7d747b$var$lg], $f0b0d7da6e7d747b$var$kg[$f0b0d7da6e7d747b$var$lg] = null, $f0b0d7da6e7d747b$var$ng = $f0b0d7da6e7d747b$var$kg[--$f0b0d7da6e7d747b$var$lg], $f0b0d7da6e7d747b$var$kg[$f0b0d7da6e7d747b$var$lg] = null;
    for(; a === $f0b0d7da6e7d747b$var$qg;)$f0b0d7da6e7d747b$var$qg = $f0b0d7da6e7d747b$var$og[--$f0b0d7da6e7d747b$var$pg], $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg] = null, $f0b0d7da6e7d747b$var$sg = $f0b0d7da6e7d747b$var$og[--$f0b0d7da6e7d747b$var$pg], $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg] = null, $f0b0d7da6e7d747b$var$rg = $f0b0d7da6e7d747b$var$og[--$f0b0d7da6e7d747b$var$pg], $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg] = null;
}
var $f0b0d7da6e7d747b$var$xg = null, $f0b0d7da6e7d747b$var$yg = null, $f0b0d7da6e7d747b$var$I = !1, $f0b0d7da6e7d747b$var$zg = null;
function $f0b0d7da6e7d747b$var$Ag(a, b) {
    var c = $f0b0d7da6e7d747b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f0b0d7da6e7d747b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f0b0d7da6e7d747b$var$xg = a, $f0b0d7da6e7d747b$var$yg = $f0b0d7da6e7d747b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f0b0d7da6e7d747b$var$xg = a, $f0b0d7da6e7d747b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f0b0d7da6e7d747b$var$qg ? {
                id: $f0b0d7da6e7d747b$var$rg,
                overflow: $f0b0d7da6e7d747b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f0b0d7da6e7d747b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f0b0d7da6e7d747b$var$xg = a, $f0b0d7da6e7d747b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f0b0d7da6e7d747b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f0b0d7da6e7d747b$var$Eg(a) {
    if ($f0b0d7da6e7d747b$var$I) {
        var b = $f0b0d7da6e7d747b$var$yg;
        if (b) {
            var c = b;
            if (!$f0b0d7da6e7d747b$var$Cg(a, b)) {
                if ($f0b0d7da6e7d747b$var$Dg(a)) throw Error($f0b0d7da6e7d747b$var$p(418));
                b = $f0b0d7da6e7d747b$var$Lf(c.nextSibling);
                var d = $f0b0d7da6e7d747b$var$xg;
                b && $f0b0d7da6e7d747b$var$Cg(a, b) ? $f0b0d7da6e7d747b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f0b0d7da6e7d747b$var$I = !1, $f0b0d7da6e7d747b$var$xg = a);
            }
        } else {
            if ($f0b0d7da6e7d747b$var$Dg(a)) throw Error($f0b0d7da6e7d747b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f0b0d7da6e7d747b$var$I = !1;
            $f0b0d7da6e7d747b$var$xg = a;
        }
    }
}
function $f0b0d7da6e7d747b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f0b0d7da6e7d747b$var$xg = a;
}
function $f0b0d7da6e7d747b$var$Gg(a) {
    if (a !== $f0b0d7da6e7d747b$var$xg) return !1;
    if (!$f0b0d7da6e7d747b$var$I) return $f0b0d7da6e7d747b$var$Fg(a), $f0b0d7da6e7d747b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f0b0d7da6e7d747b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f0b0d7da6e7d747b$var$yg)) {
        if ($f0b0d7da6e7d747b$var$Dg(a)) throw $f0b0d7da6e7d747b$var$Hg(), Error($f0b0d7da6e7d747b$var$p(418));
        for(; b;)$f0b0d7da6e7d747b$var$Ag(a, b), b = $f0b0d7da6e7d747b$var$Lf(b.nextSibling);
    }
    $f0b0d7da6e7d747b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f0b0d7da6e7d747b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f0b0d7da6e7d747b$var$yg = $f0b0d7da6e7d747b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f0b0d7da6e7d747b$var$yg = null;
        }
    } else $f0b0d7da6e7d747b$var$yg = $f0b0d7da6e7d747b$var$xg ? $f0b0d7da6e7d747b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f0b0d7da6e7d747b$var$Hg() {
    for(var a = $f0b0d7da6e7d747b$var$yg; a;)a = $f0b0d7da6e7d747b$var$Lf(a.nextSibling);
}
function $f0b0d7da6e7d747b$var$Ig() {
    $f0b0d7da6e7d747b$var$yg = $f0b0d7da6e7d747b$var$xg = null;
    $f0b0d7da6e7d747b$var$I = !1;
}
function $f0b0d7da6e7d747b$var$Jg(a) {
    null === $f0b0d7da6e7d747b$var$zg ? $f0b0d7da6e7d747b$var$zg = [
        a
    ] : $f0b0d7da6e7d747b$var$zg.push(a);
}
var $f0b0d7da6e7d747b$var$Kg = $f0b0d7da6e7d747b$var$ua.ReactCurrentBatchConfig;
function $f0b0d7da6e7d747b$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $f0b0d7da6e7d747b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $f0b0d7da6e7d747b$var$Mg = $f0b0d7da6e7d747b$var$Uf(null), $f0b0d7da6e7d747b$var$Ng = null, $f0b0d7da6e7d747b$var$Og = null, $f0b0d7da6e7d747b$var$Pg = null;
function $f0b0d7da6e7d747b$var$Qg() {
    $f0b0d7da6e7d747b$var$Pg = $f0b0d7da6e7d747b$var$Og = $f0b0d7da6e7d747b$var$Ng = null;
}
function $f0b0d7da6e7d747b$var$Rg(a) {
    var b = $f0b0d7da6e7d747b$var$Mg.current;
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Mg);
    a._currentValue = b;
}
function $f0b0d7da6e7d747b$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f0b0d7da6e7d747b$var$Tg(a, b) {
    $f0b0d7da6e7d747b$var$Ng = a;
    $f0b0d7da6e7d747b$var$Pg = $f0b0d7da6e7d747b$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f0b0d7da6e7d747b$var$Ug = !0), a.firstContext = null);
}
function $f0b0d7da6e7d747b$var$Vg(a) {
    var b = a._currentValue;
    if ($f0b0d7da6e7d747b$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f0b0d7da6e7d747b$var$Og) {
            if (null === $f0b0d7da6e7d747b$var$Ng) throw Error($f0b0d7da6e7d747b$var$p(308));
            $f0b0d7da6e7d747b$var$Og = a;
            $f0b0d7da6e7d747b$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f0b0d7da6e7d747b$var$Og = $f0b0d7da6e7d747b$var$Og.next = a;
    }
    return b;
}
var $f0b0d7da6e7d747b$var$Wg = null;
function $f0b0d7da6e7d747b$var$Xg(a) {
    null === $f0b0d7da6e7d747b$var$Wg ? $f0b0d7da6e7d747b$var$Wg = [
        a
    ] : $f0b0d7da6e7d747b$var$Wg.push(a);
}
function $f0b0d7da6e7d747b$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f0b0d7da6e7d747b$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f0b0d7da6e7d747b$var$Zg(a, d);
}
function $f0b0d7da6e7d747b$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f0b0d7da6e7d747b$var$$g = !1;
function $f0b0d7da6e7d747b$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f0b0d7da6e7d747b$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f0b0d7da6e7d747b$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f0b0d7da6e7d747b$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f0b0d7da6e7d747b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f0b0d7da6e7d747b$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f0b0d7da6e7d747b$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f0b0d7da6e7d747b$var$Zg(a, c);
}
function $f0b0d7da6e7d747b$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f0b0d7da6e7d747b$var$Cc(a, c);
    }
}
function $f0b0d7da6e7d747b$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f0b0d7da6e7d747b$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $f0b0d7da6e7d747b$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f0b0d7da6e7d747b$var$A({}, q, r);
                            break a;
                        case 2:
                            $f0b0d7da6e7d747b$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f0b0d7da6e7d747b$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f0b0d7da6e7d747b$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f0b0d7da6e7d747b$var$p(191, e));
            e.call(d);
        }
    }
}
var $f0b0d7da6e7d747b$var$jh = (new $lDSNw.Component).refs;
function $f0b0d7da6e7d747b$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f0b0d7da6e7d747b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f0b0d7da6e7d747b$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f0b0d7da6e7d747b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f0b0d7da6e7d747b$var$L(), e = $f0b0d7da6e7d747b$var$lh(a), f = $f0b0d7da6e7d747b$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f0b0d7da6e7d747b$var$dh(a, f, e);
        null !== b && ($f0b0d7da6e7d747b$var$mh(b, a, e, d), $f0b0d7da6e7d747b$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f0b0d7da6e7d747b$var$L(), e = $f0b0d7da6e7d747b$var$lh(a), f = $f0b0d7da6e7d747b$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f0b0d7da6e7d747b$var$dh(a, f, e);
        null !== b && ($f0b0d7da6e7d747b$var$mh(b, a, e, d), $f0b0d7da6e7d747b$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f0b0d7da6e7d747b$var$L(), d = $f0b0d7da6e7d747b$var$lh(a), e = $f0b0d7da6e7d747b$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f0b0d7da6e7d747b$var$dh(a, e, d);
        null !== b && ($f0b0d7da6e7d747b$var$mh(b, a, d, c), $f0b0d7da6e7d747b$var$eh(b, a, d));
    }
};
function $f0b0d7da6e7d747b$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f0b0d7da6e7d747b$var$Ie(c, d) || !$f0b0d7da6e7d747b$var$Ie(e, f) : !0;
}
function $f0b0d7da6e7d747b$var$ph(a, b, c) {
    var d = !1, e = $f0b0d7da6e7d747b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f0b0d7da6e7d747b$var$Vg(f) : (e = $f0b0d7da6e7d747b$var$Zf(b) ? $f0b0d7da6e7d747b$var$Xf : $f0b0d7da6e7d747b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f0b0d7da6e7d747b$var$Yf(a, e) : $f0b0d7da6e7d747b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f0b0d7da6e7d747b$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f0b0d7da6e7d747b$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f0b0d7da6e7d747b$var$nh.enqueueReplaceState(b, b.state, null);
}
function $f0b0d7da6e7d747b$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $f0b0d7da6e7d747b$var$jh;
    $f0b0d7da6e7d747b$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f0b0d7da6e7d747b$var$Vg(f) : (f = $f0b0d7da6e7d747b$var$Zf(b) ? $f0b0d7da6e7d747b$var$Xf : $f0b0d7da6e7d747b$var$H.current, e.context = $f0b0d7da6e7d747b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f0b0d7da6e7d747b$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f0b0d7da6e7d747b$var$nh.enqueueReplaceState(e, e.state, null), $f0b0d7da6e7d747b$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f0b0d7da6e7d747b$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f0b0d7da6e7d747b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f0b0d7da6e7d747b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $f0b0d7da6e7d747b$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f0b0d7da6e7d747b$var$p(284));
        if (!c._owner) throw Error($f0b0d7da6e7d747b$var$p(290, a));
    }
    return a;
}
function $f0b0d7da6e7d747b$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f0b0d7da6e7d747b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f0b0d7da6e7d747b$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $f0b0d7da6e7d747b$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f0b0d7da6e7d747b$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f0b0d7da6e7d747b$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f0b0d7da6e7d747b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f0b0d7da6e7d747b$var$Ha && $f0b0d7da6e7d747b$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $f0b0d7da6e7d747b$var$sh(a, b, c), d.return = a, d;
        d = $f0b0d7da6e7d747b$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f0b0d7da6e7d747b$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f0b0d7da6e7d747b$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f0b0d7da6e7d747b$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f0b0d7da6e7d747b$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f0b0d7da6e7d747b$var$va:
                    return c = $f0b0d7da6e7d747b$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $f0b0d7da6e7d747b$var$sh(a, null, b), c.return = a, c;
                case $f0b0d7da6e7d747b$var$wa:
                    return b = $f0b0d7da6e7d747b$var$zh(b, a.mode, c), b.return = a, b;
                case $f0b0d7da6e7d747b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f0b0d7da6e7d747b$var$eb(b) || $f0b0d7da6e7d747b$var$Ka(b)) return b = $f0b0d7da6e7d747b$var$Ah(b, a.mode, c, null), b.return = a, b;
            $f0b0d7da6e7d747b$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f0b0d7da6e7d747b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f0b0d7da6e7d747b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f0b0d7da6e7d747b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f0b0d7da6e7d747b$var$eb(c) || $f0b0d7da6e7d747b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f0b0d7da6e7d747b$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f0b0d7da6e7d747b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f0b0d7da6e7d747b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f0b0d7da6e7d747b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f0b0d7da6e7d747b$var$eb(d) || $f0b0d7da6e7d747b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f0b0d7da6e7d747b$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f0b0d7da6e7d747b$var$I && $f0b0d7da6e7d747b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f0b0d7da6e7d747b$var$I && $f0b0d7da6e7d747b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f0b0d7da6e7d747b$var$I && $f0b0d7da6e7d747b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f0b0d7da6e7d747b$var$Ka(h);
        if ("function" !== typeof l) throw Error($f0b0d7da6e7d747b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f0b0d7da6e7d747b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f0b0d7da6e7d747b$var$I && $f0b0d7da6e7d747b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f0b0d7da6e7d747b$var$I && $f0b0d7da6e7d747b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f0b0d7da6e7d747b$var$I && $f0b0d7da6e7d747b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f0b0d7da6e7d747b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f0b0d7da6e7d747b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f0b0d7da6e7d747b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f0b0d7da6e7d747b$var$Ha && $f0b0d7da6e7d747b$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f0b0d7da6e7d747b$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f0b0d7da6e7d747b$var$ya ? (d = $f0b0d7da6e7d747b$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f0b0d7da6e7d747b$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $f0b0d7da6e7d747b$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f0b0d7da6e7d747b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f0b0d7da6e7d747b$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f0b0d7da6e7d747b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f0b0d7da6e7d747b$var$eb(f)) return n(a, d, f, h);
            if ($f0b0d7da6e7d747b$var$Ka(f)) return t(a, d, f, h);
            $f0b0d7da6e7d747b$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f0b0d7da6e7d747b$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f0b0d7da6e7d747b$var$Bh = $f0b0d7da6e7d747b$var$vh(!0), $f0b0d7da6e7d747b$var$Ch = $f0b0d7da6e7d747b$var$vh(!1), $f0b0d7da6e7d747b$var$Dh = {}, $f0b0d7da6e7d747b$var$Eh = $f0b0d7da6e7d747b$var$Uf($f0b0d7da6e7d747b$var$Dh), $f0b0d7da6e7d747b$var$Fh = $f0b0d7da6e7d747b$var$Uf($f0b0d7da6e7d747b$var$Dh), $f0b0d7da6e7d747b$var$Gh = $f0b0d7da6e7d747b$var$Uf($f0b0d7da6e7d747b$var$Dh);
function $f0b0d7da6e7d747b$var$Hh(a) {
    if (a === $f0b0d7da6e7d747b$var$Dh) throw Error($f0b0d7da6e7d747b$var$p(174));
    return a;
}
function $f0b0d7da6e7d747b$var$Ih(a, b) {
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Gh, b);
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Fh, a);
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Eh, $f0b0d7da6e7d747b$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f0b0d7da6e7d747b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f0b0d7da6e7d747b$var$lb(b, a);
    }
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Eh);
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Eh, b);
}
function $f0b0d7da6e7d747b$var$Jh() {
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Eh);
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Fh);
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Gh);
}
function $f0b0d7da6e7d747b$var$Kh(a) {
    $f0b0d7da6e7d747b$var$Hh($f0b0d7da6e7d747b$var$Gh.current);
    var b = $f0b0d7da6e7d747b$var$Hh($f0b0d7da6e7d747b$var$Eh.current);
    var c = $f0b0d7da6e7d747b$var$lb(b, a.type);
    b !== c && ($f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Fh, a), $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Eh, c));
}
function $f0b0d7da6e7d747b$var$Lh(a) {
    $f0b0d7da6e7d747b$var$Fh.current === a && ($f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Eh), $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Fh));
}
var $f0b0d7da6e7d747b$var$M = $f0b0d7da6e7d747b$var$Uf(0);
function $f0b0d7da6e7d747b$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f0b0d7da6e7d747b$var$Nh = [];
function $f0b0d7da6e7d747b$var$Oh() {
    for(var a = 0; a < $f0b0d7da6e7d747b$var$Nh.length; a++)$f0b0d7da6e7d747b$var$Nh[a]._workInProgressVersionPrimary = null;
    $f0b0d7da6e7d747b$var$Nh.length = 0;
}
var $f0b0d7da6e7d747b$var$Ph = $f0b0d7da6e7d747b$var$ua.ReactCurrentDispatcher, $f0b0d7da6e7d747b$var$Qh = $f0b0d7da6e7d747b$var$ua.ReactCurrentBatchConfig, $f0b0d7da6e7d747b$var$Rh = 0, $f0b0d7da6e7d747b$var$N = null, $f0b0d7da6e7d747b$var$O = null, $f0b0d7da6e7d747b$var$P = null, $f0b0d7da6e7d747b$var$Sh = !1, $f0b0d7da6e7d747b$var$Th = !1, $f0b0d7da6e7d747b$var$Uh = 0, $f0b0d7da6e7d747b$var$Vh = 0;
function $f0b0d7da6e7d747b$var$Q() {
    throw Error($f0b0d7da6e7d747b$var$p(321));
}
function $f0b0d7da6e7d747b$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f0b0d7da6e7d747b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f0b0d7da6e7d747b$var$Xh(a, b, c, d, e, f) {
    $f0b0d7da6e7d747b$var$Rh = f;
    $f0b0d7da6e7d747b$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f0b0d7da6e7d747b$var$Ph.current = null === a || null === a.memoizedState ? $f0b0d7da6e7d747b$var$Yh : $f0b0d7da6e7d747b$var$Zh;
    a = c(d, e);
    if ($f0b0d7da6e7d747b$var$Th) {
        f = 0;
        do {
            $f0b0d7da6e7d747b$var$Th = !1;
            $f0b0d7da6e7d747b$var$Uh = 0;
            if (25 <= f) throw Error($f0b0d7da6e7d747b$var$p(301));
            f += 1;
            $f0b0d7da6e7d747b$var$P = $f0b0d7da6e7d747b$var$O = null;
            b.updateQueue = null;
            $f0b0d7da6e7d747b$var$Ph.current = $f0b0d7da6e7d747b$var$$h;
            a = c(d, e);
        }while ($f0b0d7da6e7d747b$var$Th);
    }
    $f0b0d7da6e7d747b$var$Ph.current = $f0b0d7da6e7d747b$var$ai;
    b = null !== $f0b0d7da6e7d747b$var$O && null !== $f0b0d7da6e7d747b$var$O.next;
    $f0b0d7da6e7d747b$var$Rh = 0;
    $f0b0d7da6e7d747b$var$P = $f0b0d7da6e7d747b$var$O = $f0b0d7da6e7d747b$var$N = null;
    $f0b0d7da6e7d747b$var$Sh = !1;
    if (b) throw Error($f0b0d7da6e7d747b$var$p(300));
    return a;
}
function $f0b0d7da6e7d747b$var$bi() {
    var a = 0 !== $f0b0d7da6e7d747b$var$Uh;
    $f0b0d7da6e7d747b$var$Uh = 0;
    return a;
}
function $f0b0d7da6e7d747b$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f0b0d7da6e7d747b$var$P ? $f0b0d7da6e7d747b$var$N.memoizedState = $f0b0d7da6e7d747b$var$P = a : $f0b0d7da6e7d747b$var$P = $f0b0d7da6e7d747b$var$P.next = a;
    return $f0b0d7da6e7d747b$var$P;
}
function $f0b0d7da6e7d747b$var$di() {
    if (null === $f0b0d7da6e7d747b$var$O) {
        var a = $f0b0d7da6e7d747b$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f0b0d7da6e7d747b$var$O.next;
    var b = null === $f0b0d7da6e7d747b$var$P ? $f0b0d7da6e7d747b$var$N.memoizedState : $f0b0d7da6e7d747b$var$P.next;
    if (null !== b) $f0b0d7da6e7d747b$var$P = b, $f0b0d7da6e7d747b$var$O = a;
    else {
        if (null === a) throw Error($f0b0d7da6e7d747b$var$p(310));
        $f0b0d7da6e7d747b$var$O = a;
        a = {
            memoizedState: $f0b0d7da6e7d747b$var$O.memoizedState,
            baseState: $f0b0d7da6e7d747b$var$O.baseState,
            baseQueue: $f0b0d7da6e7d747b$var$O.baseQueue,
            queue: $f0b0d7da6e7d747b$var$O.queue,
            next: null
        };
        null === $f0b0d7da6e7d747b$var$P ? $f0b0d7da6e7d747b$var$N.memoizedState = $f0b0d7da6e7d747b$var$P = a : $f0b0d7da6e7d747b$var$P = $f0b0d7da6e7d747b$var$P.next = a;
    }
    return $f0b0d7da6e7d747b$var$P;
}
function $f0b0d7da6e7d747b$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f0b0d7da6e7d747b$var$fi(a) {
    var b = $f0b0d7da6e7d747b$var$di(), c = b.queue;
    if (null === c) throw Error($f0b0d7da6e7d747b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f0b0d7da6e7d747b$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f0b0d7da6e7d747b$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f0b0d7da6e7d747b$var$N.lanes |= m;
                $f0b0d7da6e7d747b$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f0b0d7da6e7d747b$var$He(d, b.memoizedState) || ($f0b0d7da6e7d747b$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f0b0d7da6e7d747b$var$N.lanes |= f, $f0b0d7da6e7d747b$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f0b0d7da6e7d747b$var$gi(a) {
    var b = $f0b0d7da6e7d747b$var$di(), c = b.queue;
    if (null === c) throw Error($f0b0d7da6e7d747b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f0b0d7da6e7d747b$var$He(f, b.memoizedState) || ($f0b0d7da6e7d747b$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f0b0d7da6e7d747b$var$hi() {}
function $f0b0d7da6e7d747b$var$ii(a, b) {
    var c = $f0b0d7da6e7d747b$var$N, d = $f0b0d7da6e7d747b$var$di(), e = b(), f = !$f0b0d7da6e7d747b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f0b0d7da6e7d747b$var$Ug = !0);
    d = d.queue;
    $f0b0d7da6e7d747b$var$ji($f0b0d7da6e7d747b$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f0b0d7da6e7d747b$var$P && $f0b0d7da6e7d747b$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f0b0d7da6e7d747b$var$li(9, $f0b0d7da6e7d747b$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $f0b0d7da6e7d747b$var$R) throw Error($f0b0d7da6e7d747b$var$p(349));
        0 !== ($f0b0d7da6e7d747b$var$Rh & 30) || $f0b0d7da6e7d747b$var$ni(c, b, e);
    }
    return e;
}
function $f0b0d7da6e7d747b$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f0b0d7da6e7d747b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f0b0d7da6e7d747b$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f0b0d7da6e7d747b$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f0b0d7da6e7d747b$var$oi(b) && $f0b0d7da6e7d747b$var$pi(a);
}
function $f0b0d7da6e7d747b$var$ki(a, b, c) {
    return c(function() {
        $f0b0d7da6e7d747b$var$oi(b) && $f0b0d7da6e7d747b$var$pi(a);
    });
}
function $f0b0d7da6e7d747b$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f0b0d7da6e7d747b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f0b0d7da6e7d747b$var$pi(a) {
    var b = $f0b0d7da6e7d747b$var$Zg(a, 1);
    null !== b && $f0b0d7da6e7d747b$var$mh(b, a, 1, -1);
}
function $f0b0d7da6e7d747b$var$qi(a) {
    var b = $f0b0d7da6e7d747b$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f0b0d7da6e7d747b$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f0b0d7da6e7d747b$var$ri.bind(null, $f0b0d7da6e7d747b$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f0b0d7da6e7d747b$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f0b0d7da6e7d747b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f0b0d7da6e7d747b$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f0b0d7da6e7d747b$var$si() {
    return $f0b0d7da6e7d747b$var$di().memoizedState;
}
function $f0b0d7da6e7d747b$var$ti(a, b, c, d) {
    var e = $f0b0d7da6e7d747b$var$ci();
    $f0b0d7da6e7d747b$var$N.flags |= a;
    e.memoizedState = $f0b0d7da6e7d747b$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f0b0d7da6e7d747b$var$ui(a, b, c, d) {
    var e = $f0b0d7da6e7d747b$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f0b0d7da6e7d747b$var$O) {
        var g = $f0b0d7da6e7d747b$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $f0b0d7da6e7d747b$var$Wh(d, g.deps)) {
            e.memoizedState = $f0b0d7da6e7d747b$var$li(b, c, f, d);
            return;
        }
    }
    $f0b0d7da6e7d747b$var$N.flags |= a;
    e.memoizedState = $f0b0d7da6e7d747b$var$li(1 | b, c, f, d);
}
function $f0b0d7da6e7d747b$var$vi(a, b) {
    return $f0b0d7da6e7d747b$var$ti(8390656, 8, a, b);
}
function $f0b0d7da6e7d747b$var$ji(a, b) {
    return $f0b0d7da6e7d747b$var$ui(2048, 8, a, b);
}
function $f0b0d7da6e7d747b$var$wi(a, b) {
    return $f0b0d7da6e7d747b$var$ui(4, 2, a, b);
}
function $f0b0d7da6e7d747b$var$xi(a, b) {
    return $f0b0d7da6e7d747b$var$ui(4, 4, a, b);
}
function $f0b0d7da6e7d747b$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f0b0d7da6e7d747b$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f0b0d7da6e7d747b$var$ui(4, 4, $f0b0d7da6e7d747b$var$yi.bind(null, b, a), c);
}
function $f0b0d7da6e7d747b$var$Ai() {}
function $f0b0d7da6e7d747b$var$Bi(a, b) {
    var c = $f0b0d7da6e7d747b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f0b0d7da6e7d747b$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f0b0d7da6e7d747b$var$Ci(a, b) {
    var c = $f0b0d7da6e7d747b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f0b0d7da6e7d747b$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f0b0d7da6e7d747b$var$Di(a, b, c) {
    if (0 === ($f0b0d7da6e7d747b$var$Rh & 21)) return a.baseState && (a.baseState = !1, $f0b0d7da6e7d747b$var$Ug = !0), a.memoizedState = c;
    $f0b0d7da6e7d747b$var$He(c, b) || (c = $f0b0d7da6e7d747b$var$yc(), $f0b0d7da6e7d747b$var$N.lanes |= c, $f0b0d7da6e7d747b$var$hh |= c, a.baseState = !0);
    return b;
}
function $f0b0d7da6e7d747b$var$Ei(a, b) {
    var c = $f0b0d7da6e7d747b$var$C;
    $f0b0d7da6e7d747b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f0b0d7da6e7d747b$var$Qh.transition;
    $f0b0d7da6e7d747b$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f0b0d7da6e7d747b$var$C = c, $f0b0d7da6e7d747b$var$Qh.transition = d;
    }
}
function $f0b0d7da6e7d747b$var$Fi() {
    return $f0b0d7da6e7d747b$var$di().memoizedState;
}
function $f0b0d7da6e7d747b$var$Gi(a, b, c) {
    var d = $f0b0d7da6e7d747b$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f0b0d7da6e7d747b$var$Hi(a)) $f0b0d7da6e7d747b$var$Ii(b, c);
    else if (c = $f0b0d7da6e7d747b$var$Yg(a, b, c, d), null !== c) {
        var e = $f0b0d7da6e7d747b$var$L();
        $f0b0d7da6e7d747b$var$mh(c, a, d, e);
        $f0b0d7da6e7d747b$var$Ji(c, b, d);
    }
}
function $f0b0d7da6e7d747b$var$ri(a, b, c) {
    var d = $f0b0d7da6e7d747b$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f0b0d7da6e7d747b$var$Hi(a)) $f0b0d7da6e7d747b$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f0b0d7da6e7d747b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f0b0d7da6e7d747b$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f0b0d7da6e7d747b$var$Yg(a, b, e, d);
        null !== c && (e = $f0b0d7da6e7d747b$var$L(), $f0b0d7da6e7d747b$var$mh(c, a, d, e), $f0b0d7da6e7d747b$var$Ji(c, b, d));
    }
}
function $f0b0d7da6e7d747b$var$Hi(a) {
    var b = a.alternate;
    return a === $f0b0d7da6e7d747b$var$N || null !== b && b === $f0b0d7da6e7d747b$var$N;
}
function $f0b0d7da6e7d747b$var$Ii(a, b) {
    $f0b0d7da6e7d747b$var$Th = $f0b0d7da6e7d747b$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f0b0d7da6e7d747b$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f0b0d7da6e7d747b$var$Cc(a, c);
    }
}
var $f0b0d7da6e7d747b$var$ai = {
    readContext: $f0b0d7da6e7d747b$var$Vg,
    useCallback: $f0b0d7da6e7d747b$var$Q,
    useContext: $f0b0d7da6e7d747b$var$Q,
    useEffect: $f0b0d7da6e7d747b$var$Q,
    useImperativeHandle: $f0b0d7da6e7d747b$var$Q,
    useInsertionEffect: $f0b0d7da6e7d747b$var$Q,
    useLayoutEffect: $f0b0d7da6e7d747b$var$Q,
    useMemo: $f0b0d7da6e7d747b$var$Q,
    useReducer: $f0b0d7da6e7d747b$var$Q,
    useRef: $f0b0d7da6e7d747b$var$Q,
    useState: $f0b0d7da6e7d747b$var$Q,
    useDebugValue: $f0b0d7da6e7d747b$var$Q,
    useDeferredValue: $f0b0d7da6e7d747b$var$Q,
    useTransition: $f0b0d7da6e7d747b$var$Q,
    useMutableSource: $f0b0d7da6e7d747b$var$Q,
    useSyncExternalStore: $f0b0d7da6e7d747b$var$Q,
    useId: $f0b0d7da6e7d747b$var$Q,
    unstable_isNewReconciler: !1
}, $f0b0d7da6e7d747b$var$Yh = {
    readContext: $f0b0d7da6e7d747b$var$Vg,
    useCallback: function(a, b) {
        $f0b0d7da6e7d747b$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f0b0d7da6e7d747b$var$Vg,
    useEffect: $f0b0d7da6e7d747b$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f0b0d7da6e7d747b$var$ti(4194308, 4, $f0b0d7da6e7d747b$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f0b0d7da6e7d747b$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f0b0d7da6e7d747b$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f0b0d7da6e7d747b$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f0b0d7da6e7d747b$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f0b0d7da6e7d747b$var$Gi.bind(null, $f0b0d7da6e7d747b$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f0b0d7da6e7d747b$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f0b0d7da6e7d747b$var$qi,
    useDebugValue: $f0b0d7da6e7d747b$var$Ai,
    useDeferredValue: function(a) {
        return $f0b0d7da6e7d747b$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $f0b0d7da6e7d747b$var$qi(!1), b = a[0];
        a = $f0b0d7da6e7d747b$var$Ei.bind(null, a[1]);
        $f0b0d7da6e7d747b$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f0b0d7da6e7d747b$var$N, e = $f0b0d7da6e7d747b$var$ci();
        if ($f0b0d7da6e7d747b$var$I) {
            if (void 0 === c) throw Error($f0b0d7da6e7d747b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f0b0d7da6e7d747b$var$R) throw Error($f0b0d7da6e7d747b$var$p(349));
            0 !== ($f0b0d7da6e7d747b$var$Rh & 30) || $f0b0d7da6e7d747b$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f0b0d7da6e7d747b$var$vi($f0b0d7da6e7d747b$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f0b0d7da6e7d747b$var$li(9, $f0b0d7da6e7d747b$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f0b0d7da6e7d747b$var$ci(), b = $f0b0d7da6e7d747b$var$R.identifierPrefix;
        if ($f0b0d7da6e7d747b$var$I) {
            var c = $f0b0d7da6e7d747b$var$sg;
            var d = $f0b0d7da6e7d747b$var$rg;
            c = (d & ~(1 << 32 - $f0b0d7da6e7d747b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f0b0d7da6e7d747b$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f0b0d7da6e7d747b$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f0b0d7da6e7d747b$var$Zh = {
    readContext: $f0b0d7da6e7d747b$var$Vg,
    useCallback: $f0b0d7da6e7d747b$var$Bi,
    useContext: $f0b0d7da6e7d747b$var$Vg,
    useEffect: $f0b0d7da6e7d747b$var$ji,
    useImperativeHandle: $f0b0d7da6e7d747b$var$zi,
    useInsertionEffect: $f0b0d7da6e7d747b$var$wi,
    useLayoutEffect: $f0b0d7da6e7d747b$var$xi,
    useMemo: $f0b0d7da6e7d747b$var$Ci,
    useReducer: $f0b0d7da6e7d747b$var$fi,
    useRef: $f0b0d7da6e7d747b$var$si,
    useState: function() {
        return $f0b0d7da6e7d747b$var$fi($f0b0d7da6e7d747b$var$ei);
    },
    useDebugValue: $f0b0d7da6e7d747b$var$Ai,
    useDeferredValue: function(a) {
        var b = $f0b0d7da6e7d747b$var$di();
        return $f0b0d7da6e7d747b$var$Di(b, $f0b0d7da6e7d747b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $f0b0d7da6e7d747b$var$fi($f0b0d7da6e7d747b$var$ei)[0], b = $f0b0d7da6e7d747b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f0b0d7da6e7d747b$var$hi,
    useSyncExternalStore: $f0b0d7da6e7d747b$var$ii,
    useId: $f0b0d7da6e7d747b$var$Fi,
    unstable_isNewReconciler: !1
}, $f0b0d7da6e7d747b$var$$h = {
    readContext: $f0b0d7da6e7d747b$var$Vg,
    useCallback: $f0b0d7da6e7d747b$var$Bi,
    useContext: $f0b0d7da6e7d747b$var$Vg,
    useEffect: $f0b0d7da6e7d747b$var$ji,
    useImperativeHandle: $f0b0d7da6e7d747b$var$zi,
    useInsertionEffect: $f0b0d7da6e7d747b$var$wi,
    useLayoutEffect: $f0b0d7da6e7d747b$var$xi,
    useMemo: $f0b0d7da6e7d747b$var$Ci,
    useReducer: $f0b0d7da6e7d747b$var$gi,
    useRef: $f0b0d7da6e7d747b$var$si,
    useState: function() {
        return $f0b0d7da6e7d747b$var$gi($f0b0d7da6e7d747b$var$ei);
    },
    useDebugValue: $f0b0d7da6e7d747b$var$Ai,
    useDeferredValue: function(a) {
        var b = $f0b0d7da6e7d747b$var$di();
        return null === $f0b0d7da6e7d747b$var$O ? b.memoizedState = a : $f0b0d7da6e7d747b$var$Di(b, $f0b0d7da6e7d747b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $f0b0d7da6e7d747b$var$gi($f0b0d7da6e7d747b$var$ei)[0], b = $f0b0d7da6e7d747b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f0b0d7da6e7d747b$var$hi,
    useSyncExternalStore: $f0b0d7da6e7d747b$var$ii,
    useId: $f0b0d7da6e7d747b$var$Fi,
    unstable_isNewReconciler: !1
};
function $f0b0d7da6e7d747b$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $f0b0d7da6e7d747b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f0b0d7da6e7d747b$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f0b0d7da6e7d747b$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f0b0d7da6e7d747b$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $f0b0d7da6e7d747b$var$Oi(a, b, c) {
    c = $f0b0d7da6e7d747b$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f0b0d7da6e7d747b$var$Pi || ($f0b0d7da6e7d747b$var$Pi = !0, $f0b0d7da6e7d747b$var$Qi = d);
        $f0b0d7da6e7d747b$var$Mi(a, b);
    };
    return c;
}
function $f0b0d7da6e7d747b$var$Ri(a, b, c) {
    c = $f0b0d7da6e7d747b$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f0b0d7da6e7d747b$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f0b0d7da6e7d747b$var$Mi(a, b);
        "function" !== typeof d && (null === $f0b0d7da6e7d747b$var$Si ? $f0b0d7da6e7d747b$var$Si = new Set([
            this
        ]) : $f0b0d7da6e7d747b$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f0b0d7da6e7d747b$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f0b0d7da6e7d747b$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f0b0d7da6e7d747b$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $f0b0d7da6e7d747b$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f0b0d7da6e7d747b$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f0b0d7da6e7d747b$var$ch(-1, 1), b.tag = 2, $f0b0d7da6e7d747b$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f0b0d7da6e7d747b$var$Xi = $f0b0d7da6e7d747b$var$ua.ReactCurrentOwner, $f0b0d7da6e7d747b$var$Ug = !1;
function $f0b0d7da6e7d747b$var$Yi(a, b, c, d) {
    b.child = null === a ? $f0b0d7da6e7d747b$var$Ch(b, null, c, d) : $f0b0d7da6e7d747b$var$Bh(b, a.child, c, d);
}
function $f0b0d7da6e7d747b$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f0b0d7da6e7d747b$var$Tg(b, e);
    d = $f0b0d7da6e7d747b$var$Xh(a, b, c, d, f, e);
    c = $f0b0d7da6e7d747b$var$bi();
    if (null !== a && !$f0b0d7da6e7d747b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f0b0d7da6e7d747b$var$$i(a, b, e);
    $f0b0d7da6e7d747b$var$I && c && $f0b0d7da6e7d747b$var$vg(b);
    b.flags |= 1;
    $f0b0d7da6e7d747b$var$Yi(a, b, d, e);
    return b.child;
}
function $f0b0d7da6e7d747b$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f0b0d7da6e7d747b$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f0b0d7da6e7d747b$var$cj(a, b, f, d, e);
        a = $f0b0d7da6e7d747b$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f0b0d7da6e7d747b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f0b0d7da6e7d747b$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $f0b0d7da6e7d747b$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f0b0d7da6e7d747b$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f0b0d7da6e7d747b$var$Ie(f, d) && a.ref === b.ref) {
            if ($f0b0d7da6e7d747b$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f0b0d7da6e7d747b$var$Ug = !0);
            else return b.lanes = a.lanes, $f0b0d7da6e7d747b$var$$i(a, b, e);
        }
    }
    return $f0b0d7da6e7d747b$var$dj(a, b, c, d, e);
}
function $f0b0d7da6e7d747b$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$fj, $f0b0d7da6e7d747b$var$gj), $f0b0d7da6e7d747b$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$fj, $f0b0d7da6e7d747b$var$gj), $f0b0d7da6e7d747b$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$fj, $f0b0d7da6e7d747b$var$gj);
            $f0b0d7da6e7d747b$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$fj, $f0b0d7da6e7d747b$var$gj), $f0b0d7da6e7d747b$var$gj |= d;
    $f0b0d7da6e7d747b$var$Yi(a, b, e, c);
    return b.child;
}
function $f0b0d7da6e7d747b$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f0b0d7da6e7d747b$var$dj(a, b, c, d, e) {
    var f = $f0b0d7da6e7d747b$var$Zf(c) ? $f0b0d7da6e7d747b$var$Xf : $f0b0d7da6e7d747b$var$H.current;
    f = $f0b0d7da6e7d747b$var$Yf(b, f);
    $f0b0d7da6e7d747b$var$Tg(b, e);
    c = $f0b0d7da6e7d747b$var$Xh(a, b, c, d, f, e);
    d = $f0b0d7da6e7d747b$var$bi();
    if (null !== a && !$f0b0d7da6e7d747b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f0b0d7da6e7d747b$var$$i(a, b, e);
    $f0b0d7da6e7d747b$var$I && d && $f0b0d7da6e7d747b$var$vg(b);
    b.flags |= 1;
    $f0b0d7da6e7d747b$var$Yi(a, b, c, e);
    return b.child;
}
function $f0b0d7da6e7d747b$var$ij(a, b, c, d, e) {
    if ($f0b0d7da6e7d747b$var$Zf(c)) {
        var f = !0;
        $f0b0d7da6e7d747b$var$cg(b);
    } else f = !1;
    $f0b0d7da6e7d747b$var$Tg(b, e);
    if (null === b.stateNode) $f0b0d7da6e7d747b$var$jj(a, b), $f0b0d7da6e7d747b$var$ph(b, c, d), $f0b0d7da6e7d747b$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f0b0d7da6e7d747b$var$Vg(l) : (l = $f0b0d7da6e7d747b$var$Zf(c) ? $f0b0d7da6e7d747b$var$Xf : $f0b0d7da6e7d747b$var$H.current, l = $f0b0d7da6e7d747b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f0b0d7da6e7d747b$var$qh(b, g, d, l);
        $f0b0d7da6e7d747b$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $f0b0d7da6e7d747b$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f0b0d7da6e7d747b$var$Wf.current || $f0b0d7da6e7d747b$var$$g ? ("function" === typeof m && ($f0b0d7da6e7d747b$var$kh(b, c, m, d), k = b.memoizedState), (h = $f0b0d7da6e7d747b$var$$g || $f0b0d7da6e7d747b$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f0b0d7da6e7d747b$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f0b0d7da6e7d747b$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f0b0d7da6e7d747b$var$Vg(k) : (k = $f0b0d7da6e7d747b$var$Zf(c) ? $f0b0d7da6e7d747b$var$Xf : $f0b0d7da6e7d747b$var$H.current, k = $f0b0d7da6e7d747b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f0b0d7da6e7d747b$var$qh(b, g, d, k);
        $f0b0d7da6e7d747b$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $f0b0d7da6e7d747b$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f0b0d7da6e7d747b$var$Wf.current || $f0b0d7da6e7d747b$var$$g ? ("function" === typeof y && ($f0b0d7da6e7d747b$var$kh(b, c, y, d), n = b.memoizedState), (l = $f0b0d7da6e7d747b$var$$g || $f0b0d7da6e7d747b$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f0b0d7da6e7d747b$var$kj(a, b, c, d, f, e);
}
function $f0b0d7da6e7d747b$var$kj(a, b, c, d, e, f) {
    $f0b0d7da6e7d747b$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f0b0d7da6e7d747b$var$dg(b, c, !1), $f0b0d7da6e7d747b$var$$i(a, b, f);
    d = b.stateNode;
    $f0b0d7da6e7d747b$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f0b0d7da6e7d747b$var$Bh(b, a.child, null, f), b.child = $f0b0d7da6e7d747b$var$Bh(b, null, h, f)) : $f0b0d7da6e7d747b$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f0b0d7da6e7d747b$var$dg(b, c, !0);
    return b.child;
}
function $f0b0d7da6e7d747b$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f0b0d7da6e7d747b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f0b0d7da6e7d747b$var$ag(a, b.context, !1);
    $f0b0d7da6e7d747b$var$Ih(a, b.containerInfo);
}
function $f0b0d7da6e7d747b$var$mj(a, b, c, d, e) {
    $f0b0d7da6e7d747b$var$Ig();
    $f0b0d7da6e7d747b$var$Jg(e);
    b.flags |= 256;
    $f0b0d7da6e7d747b$var$Yi(a, b, c, d);
    return b.child;
}
var $f0b0d7da6e7d747b$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f0b0d7da6e7d747b$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f0b0d7da6e7d747b$var$pj(a, b, c) {
    var d = b.pendingProps, e = $f0b0d7da6e7d747b$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, e & 1);
    if (null === a) {
        $f0b0d7da6e7d747b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f0b0d7da6e7d747b$var$qj(g, d, 0, null), a = $f0b0d7da6e7d747b$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f0b0d7da6e7d747b$var$oj(c), b.memoizedState = $f0b0d7da6e7d747b$var$nj, a) : $f0b0d7da6e7d747b$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f0b0d7da6e7d747b$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f0b0d7da6e7d747b$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f0b0d7da6e7d747b$var$wh(h, f) : (f = $f0b0d7da6e7d747b$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f0b0d7da6e7d747b$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f0b0d7da6e7d747b$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f0b0d7da6e7d747b$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f0b0d7da6e7d747b$var$rj(a, b) {
    b = $f0b0d7da6e7d747b$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f0b0d7da6e7d747b$var$tj(a, b, c, d) {
    null !== d && $f0b0d7da6e7d747b$var$Jg(d);
    $f0b0d7da6e7d747b$var$Bh(b, a.child, null, c);
    a = $f0b0d7da6e7d747b$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f0b0d7da6e7d747b$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f0b0d7da6e7d747b$var$Li(Error($f0b0d7da6e7d747b$var$p(422))), $f0b0d7da6e7d747b$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f0b0d7da6e7d747b$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f0b0d7da6e7d747b$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f0b0d7da6e7d747b$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $f0b0d7da6e7d747b$var$oj(g);
        b.memoizedState = $f0b0d7da6e7d747b$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f0b0d7da6e7d747b$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f0b0d7da6e7d747b$var$p(419));
        d = $f0b0d7da6e7d747b$var$Li(f, d, void 0);
        return $f0b0d7da6e7d747b$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f0b0d7da6e7d747b$var$Ug || h) {
        d = $f0b0d7da6e7d747b$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f0b0d7da6e7d747b$var$Zg(a, e), $f0b0d7da6e7d747b$var$mh(d, a, e, -1));
        }
        $f0b0d7da6e7d747b$var$uj();
        d = $f0b0d7da6e7d747b$var$Li(Error($f0b0d7da6e7d747b$var$p(421)));
        return $f0b0d7da6e7d747b$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f0b0d7da6e7d747b$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f0b0d7da6e7d747b$var$yg = $f0b0d7da6e7d747b$var$Lf(e.nextSibling);
    $f0b0d7da6e7d747b$var$xg = b;
    $f0b0d7da6e7d747b$var$I = !0;
    $f0b0d7da6e7d747b$var$zg = null;
    null !== a && ($f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg++] = $f0b0d7da6e7d747b$var$rg, $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg++] = $f0b0d7da6e7d747b$var$sg, $f0b0d7da6e7d747b$var$og[$f0b0d7da6e7d747b$var$pg++] = $f0b0d7da6e7d747b$var$qg, $f0b0d7da6e7d747b$var$rg = a.id, $f0b0d7da6e7d747b$var$sg = a.overflow, $f0b0d7da6e7d747b$var$qg = b);
    b = $f0b0d7da6e7d747b$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f0b0d7da6e7d747b$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f0b0d7da6e7d747b$var$Sg(a.return, b, c);
}
function $f0b0d7da6e7d747b$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f0b0d7da6e7d747b$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f0b0d7da6e7d747b$var$Yi(a, b, d.children, c);
    d = $f0b0d7da6e7d747b$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f0b0d7da6e7d747b$var$wj(a, c, b);
            else if (19 === a.tag) $f0b0d7da6e7d747b$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f0b0d7da6e7d747b$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f0b0d7da6e7d747b$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f0b0d7da6e7d747b$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f0b0d7da6e7d747b$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $f0b0d7da6e7d747b$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f0b0d7da6e7d747b$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f0b0d7da6e7d747b$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f0b0d7da6e7d747b$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f0b0d7da6e7d747b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f0b0d7da6e7d747b$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f0b0d7da6e7d747b$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f0b0d7da6e7d747b$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $f0b0d7da6e7d747b$var$lj(b);
            $f0b0d7da6e7d747b$var$Ig();
            break;
        case 5:
            $f0b0d7da6e7d747b$var$Kh(b);
            break;
        case 1:
            $f0b0d7da6e7d747b$var$Zf(b.type) && $f0b0d7da6e7d747b$var$cg(b);
            break;
        case 4:
            $f0b0d7da6e7d747b$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, $f0b0d7da6e7d747b$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f0b0d7da6e7d747b$var$pj(a, b, c);
                $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, $f0b0d7da6e7d747b$var$M.current & 1);
                a = $f0b0d7da6e7d747b$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, $f0b0d7da6e7d747b$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f0b0d7da6e7d747b$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, $f0b0d7da6e7d747b$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f0b0d7da6e7d747b$var$ej(a, b, c);
    }
    return $f0b0d7da6e7d747b$var$$i(a, b, c);
}
var $f0b0d7da6e7d747b$var$Aj, $f0b0d7da6e7d747b$var$Bj, $f0b0d7da6e7d747b$var$Cj, $f0b0d7da6e7d747b$var$Dj;
$f0b0d7da6e7d747b$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f0b0d7da6e7d747b$var$Bj = function() {};
$f0b0d7da6e7d747b$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f0b0d7da6e7d747b$var$Hh($f0b0d7da6e7d747b$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f0b0d7da6e7d747b$var$Ya(a, e);
                d = $f0b0d7da6e7d747b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f0b0d7da6e7d747b$var$A({}, e, {
                    value: void 0
                });
                d = $f0b0d7da6e7d747b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f0b0d7da6e7d747b$var$gb(a, e);
                d = $f0b0d7da6e7d747b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f0b0d7da6e7d747b$var$Bf);
        }
        $f0b0d7da6e7d747b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f0b0d7da6e7d747b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f0b0d7da6e7d747b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f0b0d7da6e7d747b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f0b0d7da6e7d747b$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f0b0d7da6e7d747b$var$Ej(a, b) {
    if (!$f0b0d7da6e7d747b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f0b0d7da6e7d747b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f0b0d7da6e7d747b$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $f0b0d7da6e7d747b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f0b0d7da6e7d747b$var$S(b), null;
        case 1:
            return $f0b0d7da6e7d747b$var$Zf(b.type) && $f0b0d7da6e7d747b$var$$f(), $f0b0d7da6e7d747b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f0b0d7da6e7d747b$var$Jh();
            $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Wf);
            $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$H);
            $f0b0d7da6e7d747b$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f0b0d7da6e7d747b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f0b0d7da6e7d747b$var$zg && ($f0b0d7da6e7d747b$var$Gj($f0b0d7da6e7d747b$var$zg), $f0b0d7da6e7d747b$var$zg = null));
            $f0b0d7da6e7d747b$var$Bj(a, b);
            $f0b0d7da6e7d747b$var$S(b);
            return null;
        case 5:
            $f0b0d7da6e7d747b$var$Lh(b);
            var e = $f0b0d7da6e7d747b$var$Hh($f0b0d7da6e7d747b$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f0b0d7da6e7d747b$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f0b0d7da6e7d747b$var$p(166));
                    $f0b0d7da6e7d747b$var$S(b);
                    return null;
                }
                a = $f0b0d7da6e7d747b$var$Hh($f0b0d7da6e7d747b$var$Eh.current);
                if ($f0b0d7da6e7d747b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f0b0d7da6e7d747b$var$Of] = b;
                    d[$f0b0d7da6e7d747b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f0b0d7da6e7d747b$var$D("cancel", d);
                            $f0b0d7da6e7d747b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f0b0d7da6e7d747b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f0b0d7da6e7d747b$var$lf.length; e++)$f0b0d7da6e7d747b$var$D($f0b0d7da6e7d747b$var$lf[e], d);
                            break;
                        case "source":
                            $f0b0d7da6e7d747b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f0b0d7da6e7d747b$var$D("error", d);
                            $f0b0d7da6e7d747b$var$D("load", d);
                            break;
                        case "details":
                            $f0b0d7da6e7d747b$var$D("toggle", d);
                            break;
                        case "input":
                            $f0b0d7da6e7d747b$var$Za(d, f);
                            $f0b0d7da6e7d747b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f0b0d7da6e7d747b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f0b0d7da6e7d747b$var$hb(d, f), $f0b0d7da6e7d747b$var$D("invalid", d);
                    }
                    $f0b0d7da6e7d747b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f0b0d7da6e7d747b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f0b0d7da6e7d747b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f0b0d7da6e7d747b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f0b0d7da6e7d747b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f0b0d7da6e7d747b$var$Va(d);
                            $f0b0d7da6e7d747b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f0b0d7da6e7d747b$var$Va(d);
                            $f0b0d7da6e7d747b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f0b0d7da6e7d747b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f0b0d7da6e7d747b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f0b0d7da6e7d747b$var$Of] = b;
                    a[$f0b0d7da6e7d747b$var$Pf] = d;
                    $f0b0d7da6e7d747b$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f0b0d7da6e7d747b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f0b0d7da6e7d747b$var$D("cancel", a);
                                $f0b0d7da6e7d747b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f0b0d7da6e7d747b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f0b0d7da6e7d747b$var$lf.length; e++)$f0b0d7da6e7d747b$var$D($f0b0d7da6e7d747b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f0b0d7da6e7d747b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f0b0d7da6e7d747b$var$D("error", a);
                                $f0b0d7da6e7d747b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f0b0d7da6e7d747b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f0b0d7da6e7d747b$var$Za(a, d);
                                e = $f0b0d7da6e7d747b$var$Ya(a, d);
                                $f0b0d7da6e7d747b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f0b0d7da6e7d747b$var$A({}, d, {
                                    value: void 0
                                });
                                $f0b0d7da6e7d747b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f0b0d7da6e7d747b$var$hb(a, d);
                                e = $f0b0d7da6e7d747b$var$gb(a, d);
                                $f0b0d7da6e7d747b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f0b0d7da6e7d747b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f0b0d7da6e7d747b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f0b0d7da6e7d747b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f0b0d7da6e7d747b$var$ob(a, k) : "number" === typeof k && $f0b0d7da6e7d747b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f0b0d7da6e7d747b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f0b0d7da6e7d747b$var$D("scroll", a) : null != k && $f0b0d7da6e7d747b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f0b0d7da6e7d747b$var$Va(a);
                                $f0b0d7da6e7d747b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f0b0d7da6e7d747b$var$Va(a);
                                $f0b0d7da6e7d747b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f0b0d7da6e7d747b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f0b0d7da6e7d747b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f0b0d7da6e7d747b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f0b0d7da6e7d747b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f0b0d7da6e7d747b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f0b0d7da6e7d747b$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f0b0d7da6e7d747b$var$p(166));
                c = $f0b0d7da6e7d747b$var$Hh($f0b0d7da6e7d747b$var$Gh.current);
                $f0b0d7da6e7d747b$var$Hh($f0b0d7da6e7d747b$var$Eh.current);
                if ($f0b0d7da6e7d747b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f0b0d7da6e7d747b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f0b0d7da6e7d747b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f0b0d7da6e7d747b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f0b0d7da6e7d747b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f0b0d7da6e7d747b$var$Of] = b, b.stateNode = d;
            }
            $f0b0d7da6e7d747b$var$S(b);
            return null;
        case 13:
            $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f0b0d7da6e7d747b$var$I && null !== $f0b0d7da6e7d747b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f0b0d7da6e7d747b$var$Hg(), $f0b0d7da6e7d747b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f0b0d7da6e7d747b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f0b0d7da6e7d747b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f0b0d7da6e7d747b$var$p(317));
                        f[$f0b0d7da6e7d747b$var$Of] = b;
                    } else $f0b0d7da6e7d747b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f0b0d7da6e7d747b$var$S(b);
                    f = !1;
                } else null !== $f0b0d7da6e7d747b$var$zg && ($f0b0d7da6e7d747b$var$Gj($f0b0d7da6e7d747b$var$zg), $f0b0d7da6e7d747b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f0b0d7da6e7d747b$var$M.current & 1) ? 0 === $f0b0d7da6e7d747b$var$T && ($f0b0d7da6e7d747b$var$T = 3) : $f0b0d7da6e7d747b$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f0b0d7da6e7d747b$var$S(b);
            return null;
        case 4:
            return $f0b0d7da6e7d747b$var$Jh(), $f0b0d7da6e7d747b$var$Bj(a, b), null === a && $f0b0d7da6e7d747b$var$sf(b.stateNode.containerInfo), $f0b0d7da6e7d747b$var$S(b), null;
        case 10:
            return $f0b0d7da6e7d747b$var$Rg(b.type._context), $f0b0d7da6e7d747b$var$S(b), null;
        case 17:
            return $f0b0d7da6e7d747b$var$Zf(b.type) && $f0b0d7da6e7d747b$var$$f(), $f0b0d7da6e7d747b$var$S(b), null;
        case 19:
            $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$M);
            f = b.memoizedState;
            if (null === f) return $f0b0d7da6e7d747b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f0b0d7da6e7d747b$var$Ej(f, !1);
                else {
                    if (0 !== $f0b0d7da6e7d747b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f0b0d7da6e7d747b$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f0b0d7da6e7d747b$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, $f0b0d7da6e7d747b$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f0b0d7da6e7d747b$var$B() > $f0b0d7da6e7d747b$var$Hj && (b.flags |= 128, d = !0, $f0b0d7da6e7d747b$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f0b0d7da6e7d747b$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f0b0d7da6e7d747b$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f0b0d7da6e7d747b$var$I) return $f0b0d7da6e7d747b$var$S(b), null;
                    } else 2 * $f0b0d7da6e7d747b$var$B() - f.renderingStartTime > $f0b0d7da6e7d747b$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $f0b0d7da6e7d747b$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f0b0d7da6e7d747b$var$B(), b.sibling = null, c = $f0b0d7da6e7d747b$var$M.current, $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$M, d ? c & 1 | 2 : c & 1), b;
            $f0b0d7da6e7d747b$var$S(b);
            return null;
        case 22:
        case 23:
            return $f0b0d7da6e7d747b$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f0b0d7da6e7d747b$var$gj & 1073741824) && ($f0b0d7da6e7d747b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f0b0d7da6e7d747b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f0b0d7da6e7d747b$var$p(156, b.tag));
}
function $f0b0d7da6e7d747b$var$Jj(a, b) {
    $f0b0d7da6e7d747b$var$wg(b);
    switch(b.tag){
        case 1:
            return $f0b0d7da6e7d747b$var$Zf(b.type) && $f0b0d7da6e7d747b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f0b0d7da6e7d747b$var$Jh(), $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Wf), $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$H), $f0b0d7da6e7d747b$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f0b0d7da6e7d747b$var$Lh(b), null;
        case 13:
            $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f0b0d7da6e7d747b$var$p(340));
                $f0b0d7da6e7d747b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$M), null;
        case 4:
            return $f0b0d7da6e7d747b$var$Jh(), null;
        case 10:
            return $f0b0d7da6e7d747b$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $f0b0d7da6e7d747b$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f0b0d7da6e7d747b$var$Kj = !1, $f0b0d7da6e7d747b$var$U = !1, $f0b0d7da6e7d747b$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $f0b0d7da6e7d747b$var$V = null;
function $f0b0d7da6e7d747b$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f0b0d7da6e7d747b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f0b0d7da6e7d747b$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f0b0d7da6e7d747b$var$W(a, b, d);
    }
}
var $f0b0d7da6e7d747b$var$Oj = !1;
function $f0b0d7da6e7d747b$var$Pj(a, b) {
    $f0b0d7da6e7d747b$var$Cf = $f0b0d7da6e7d747b$var$dd;
    a = $f0b0d7da6e7d747b$var$Me();
    if ($f0b0d7da6e7d747b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f0b0d7da6e7d747b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f0b0d7da6e7d747b$var$dd = !1;
    for($f0b0d7da6e7d747b$var$V = b; null !== $f0b0d7da6e7d747b$var$V;)if (b = $f0b0d7da6e7d747b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f0b0d7da6e7d747b$var$V = a;
    else for(; null !== $f0b0d7da6e7d747b$var$V;){
        b = $f0b0d7da6e7d747b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f0b0d7da6e7d747b$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f0b0d7da6e7d747b$var$p(163));
            }
        } catch (F) {
            $f0b0d7da6e7d747b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f0b0d7da6e7d747b$var$V = a;
            break;
        }
        $f0b0d7da6e7d747b$var$V = b.return;
    }
    n = $f0b0d7da6e7d747b$var$Oj;
    $f0b0d7da6e7d747b$var$Oj = !1;
    return n;
}
function $f0b0d7da6e7d747b$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f0b0d7da6e7d747b$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f0b0d7da6e7d747b$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f0b0d7da6e7d747b$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f0b0d7da6e7d747b$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f0b0d7da6e7d747b$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f0b0d7da6e7d747b$var$Of], delete b[$f0b0d7da6e7d747b$var$Pf], delete b[$f0b0d7da6e7d747b$var$of], delete b[$f0b0d7da6e7d747b$var$Qf], delete b[$f0b0d7da6e7d747b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f0b0d7da6e7d747b$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f0b0d7da6e7d747b$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f0b0d7da6e7d747b$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f0b0d7da6e7d747b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f0b0d7da6e7d747b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f0b0d7da6e7d747b$var$Wj(a, b, c), a = a.sibling; null !== a;)$f0b0d7da6e7d747b$var$Wj(a, b, c), a = a.sibling;
}
function $f0b0d7da6e7d747b$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f0b0d7da6e7d747b$var$Xj(a, b, c), a = a.sibling; null !== a;)$f0b0d7da6e7d747b$var$Xj(a, b, c), a = a.sibling;
}
var $f0b0d7da6e7d747b$var$X = null, $f0b0d7da6e7d747b$var$Yj = !1;
function $f0b0d7da6e7d747b$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$f0b0d7da6e7d747b$var$ak(a, b, c), c = c.sibling;
}
function $f0b0d7da6e7d747b$var$ak(a, b, c) {
    if ($f0b0d7da6e7d747b$var$lc && "function" === typeof $f0b0d7da6e7d747b$var$lc.onCommitFiberUnmount) try {
        $f0b0d7da6e7d747b$var$lc.onCommitFiberUnmount($f0b0d7da6e7d747b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f0b0d7da6e7d747b$var$U || $f0b0d7da6e7d747b$var$Mj(c, b);
        case 6:
            var d = $f0b0d7da6e7d747b$var$X, e = $f0b0d7da6e7d747b$var$Yj;
            $f0b0d7da6e7d747b$var$X = null;
            $f0b0d7da6e7d747b$var$Zj(a, b, c);
            $f0b0d7da6e7d747b$var$X = d;
            $f0b0d7da6e7d747b$var$Yj = e;
            null !== $f0b0d7da6e7d747b$var$X && ($f0b0d7da6e7d747b$var$Yj ? (a = $f0b0d7da6e7d747b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f0b0d7da6e7d747b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f0b0d7da6e7d747b$var$X && ($f0b0d7da6e7d747b$var$Yj ? (a = $f0b0d7da6e7d747b$var$X, c = c.stateNode, 8 === a.nodeType ? $f0b0d7da6e7d747b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f0b0d7da6e7d747b$var$Kf(a, c), $f0b0d7da6e7d747b$var$bd(a)) : $f0b0d7da6e7d747b$var$Kf($f0b0d7da6e7d747b$var$X, c.stateNode));
            break;
        case 4:
            d = $f0b0d7da6e7d747b$var$X;
            e = $f0b0d7da6e7d747b$var$Yj;
            $f0b0d7da6e7d747b$var$X = c.stateNode.containerInfo;
            $f0b0d7da6e7d747b$var$Yj = !0;
            $f0b0d7da6e7d747b$var$Zj(a, b, c);
            $f0b0d7da6e7d747b$var$X = d;
            $f0b0d7da6e7d747b$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f0b0d7da6e7d747b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f0b0d7da6e7d747b$var$Nj(c, b, g) : 0 !== (f & 4) && $f0b0d7da6e7d747b$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f0b0d7da6e7d747b$var$Zj(a, b, c);
            break;
        case 1:
            if (!$f0b0d7da6e7d747b$var$U && ($f0b0d7da6e7d747b$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f0b0d7da6e7d747b$var$W(c, b, h);
            }
            $f0b0d7da6e7d747b$var$Zj(a, b, c);
            break;
        case 21:
            $f0b0d7da6e7d747b$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f0b0d7da6e7d747b$var$U = (d = $f0b0d7da6e7d747b$var$U) || null !== c.memoizedState, $f0b0d7da6e7d747b$var$Zj(a, b, c), $f0b0d7da6e7d747b$var$U = d) : $f0b0d7da6e7d747b$var$Zj(a, b, c);
            break;
        default:
            $f0b0d7da6e7d747b$var$Zj(a, b, c);
    }
}
function $f0b0d7da6e7d747b$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f0b0d7da6e7d747b$var$Lj);
        b.forEach(function(b) {
            var d = $f0b0d7da6e7d747b$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f0b0d7da6e7d747b$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f0b0d7da6e7d747b$var$X = h.stateNode;
                        $f0b0d7da6e7d747b$var$Yj = !1;
                        break a;
                    case 3:
                        $f0b0d7da6e7d747b$var$X = h.stateNode.containerInfo;
                        $f0b0d7da6e7d747b$var$Yj = !0;
                        break a;
                    case 4:
                        $f0b0d7da6e7d747b$var$X = h.stateNode.containerInfo;
                        $f0b0d7da6e7d747b$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f0b0d7da6e7d747b$var$X) throw Error($f0b0d7da6e7d747b$var$p(160));
            $f0b0d7da6e7d747b$var$ak(f, g, e);
            $f0b0d7da6e7d747b$var$X = null;
            $f0b0d7da6e7d747b$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f0b0d7da6e7d747b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f0b0d7da6e7d747b$var$ek(b, a), b = b.sibling;
}
function $f0b0d7da6e7d747b$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            if (d & 4) {
                try {
                    $f0b0d7da6e7d747b$var$Qj(3, a, a.return), $f0b0d7da6e7d747b$var$Rj(3, a);
                } catch (t) {
                    $f0b0d7da6e7d747b$var$W(a, a.return, t);
                }
                try {
                    $f0b0d7da6e7d747b$var$Qj(5, a, a.return);
                } catch (t) {
                    $f0b0d7da6e7d747b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            d & 512 && null !== c && $f0b0d7da6e7d747b$var$Mj(c, c.return);
            break;
        case 5:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            d & 512 && null !== c && $f0b0d7da6e7d747b$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f0b0d7da6e7d747b$var$ob(e, "");
                } catch (t) {
                    $f0b0d7da6e7d747b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f0b0d7da6e7d747b$var$ab(e, f);
                    $f0b0d7da6e7d747b$var$vb(h, g);
                    var l = $f0b0d7da6e7d747b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f0b0d7da6e7d747b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f0b0d7da6e7d747b$var$nb(e, q) : "children" === m ? $f0b0d7da6e7d747b$var$ob(e, q) : $f0b0d7da6e7d747b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f0b0d7da6e7d747b$var$bb(e, f);
                            break;
                        case "textarea":
                            $f0b0d7da6e7d747b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f0b0d7da6e7d747b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f0b0d7da6e7d747b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f0b0d7da6e7d747b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f0b0d7da6e7d747b$var$Pf] = f;
                } catch (t) {
                    $f0b0d7da6e7d747b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f0b0d7da6e7d747b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f0b0d7da6e7d747b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f0b0d7da6e7d747b$var$bd(b.containerInfo);
            } catch (t) {
                $f0b0d7da6e7d747b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            break;
        case 13:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f0b0d7da6e7d747b$var$gk = $f0b0d7da6e7d747b$var$B()));
            d & 4 && $f0b0d7da6e7d747b$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f0b0d7da6e7d747b$var$U = (l = $f0b0d7da6e7d747b$var$U) || m, $f0b0d7da6e7d747b$var$dk(b, a), $f0b0d7da6e7d747b$var$U = l) : $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f0b0d7da6e7d747b$var$V = a, m = a.child; null !== m;){
                    for(q = $f0b0d7da6e7d747b$var$V = m; null !== $f0b0d7da6e7d747b$var$V;){
                        r = $f0b0d7da6e7d747b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f0b0d7da6e7d747b$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $f0b0d7da6e7d747b$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f0b0d7da6e7d747b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f0b0d7da6e7d747b$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f0b0d7da6e7d747b$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f0b0d7da6e7d747b$var$V = y) : $f0b0d7da6e7d747b$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f0b0d7da6e7d747b$var$rb("display", g));
                            } catch (t) {
                                $f0b0d7da6e7d747b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f0b0d7da6e7d747b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f0b0d7da6e7d747b$var$dk(b, a);
            $f0b0d7da6e7d747b$var$fk(a);
            d & 4 && $f0b0d7da6e7d747b$var$bk(a);
            break;
        case 21:
            break;
        default:
            $f0b0d7da6e7d747b$var$dk(b, a), $f0b0d7da6e7d747b$var$fk(a);
    }
}
function $f0b0d7da6e7d747b$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f0b0d7da6e7d747b$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f0b0d7da6e7d747b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f0b0d7da6e7d747b$var$ob(e, ""), d.flags &= -33);
                    var f = $f0b0d7da6e7d747b$var$Vj(a);
                    $f0b0d7da6e7d747b$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f0b0d7da6e7d747b$var$Vj(a);
                    $f0b0d7da6e7d747b$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($f0b0d7da6e7d747b$var$p(161));
            }
        } catch (k) {
            $f0b0d7da6e7d747b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f0b0d7da6e7d747b$var$ik(a, b, c) {
    $f0b0d7da6e7d747b$var$V = a;
    $f0b0d7da6e7d747b$var$jk(a, b, c);
}
function $f0b0d7da6e7d747b$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f0b0d7da6e7d747b$var$V;){
        var e = $f0b0d7da6e7d747b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f0b0d7da6e7d747b$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f0b0d7da6e7d747b$var$U;
                h = $f0b0d7da6e7d747b$var$Kj;
                var l = $f0b0d7da6e7d747b$var$U;
                $f0b0d7da6e7d747b$var$Kj = g;
                if (($f0b0d7da6e7d747b$var$U = k) && !l) for($f0b0d7da6e7d747b$var$V = e; null !== $f0b0d7da6e7d747b$var$V;)g = $f0b0d7da6e7d747b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f0b0d7da6e7d747b$var$kk(e) : null !== k ? (k.return = g, $f0b0d7da6e7d747b$var$V = k) : $f0b0d7da6e7d747b$var$kk(e);
                for(; null !== f;)$f0b0d7da6e7d747b$var$V = f, $f0b0d7da6e7d747b$var$jk(f, b, c), f = f.sibling;
                $f0b0d7da6e7d747b$var$V = e;
                $f0b0d7da6e7d747b$var$Kj = h;
                $f0b0d7da6e7d747b$var$U = l;
            }
            $f0b0d7da6e7d747b$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f0b0d7da6e7d747b$var$V = f) : $f0b0d7da6e7d747b$var$lk(a, b, c);
    }
}
function $f0b0d7da6e7d747b$var$lk(a) {
    for(; null !== $f0b0d7da6e7d747b$var$V;){
        var b = $f0b0d7da6e7d747b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f0b0d7da6e7d747b$var$U || $f0b0d7da6e7d747b$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f0b0d7da6e7d747b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f0b0d7da6e7d747b$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f0b0d7da6e7d747b$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f0b0d7da6e7d747b$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f0b0d7da6e7d747b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f0b0d7da6e7d747b$var$p(163));
                }
                $f0b0d7da6e7d747b$var$U || b.flags & 512 && $f0b0d7da6e7d747b$var$Sj(b);
            } catch (r) {
                $f0b0d7da6e7d747b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f0b0d7da6e7d747b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f0b0d7da6e7d747b$var$V = c;
            break;
        }
        $f0b0d7da6e7d747b$var$V = b.return;
    }
}
function $f0b0d7da6e7d747b$var$hk(a) {
    for(; null !== $f0b0d7da6e7d747b$var$V;){
        var b = $f0b0d7da6e7d747b$var$V;
        if (b === a) {
            $f0b0d7da6e7d747b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f0b0d7da6e7d747b$var$V = c;
            break;
        }
        $f0b0d7da6e7d747b$var$V = b.return;
    }
}
function $f0b0d7da6e7d747b$var$kk(a) {
    for(; null !== $f0b0d7da6e7d747b$var$V;){
        var b = $f0b0d7da6e7d747b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f0b0d7da6e7d747b$var$Rj(4, b);
                    } catch (k) {
                        $f0b0d7da6e7d747b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f0b0d7da6e7d747b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f0b0d7da6e7d747b$var$Sj(b);
                    } catch (k) {
                        $f0b0d7da6e7d747b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f0b0d7da6e7d747b$var$Sj(b);
                    } catch (k) {
                        $f0b0d7da6e7d747b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f0b0d7da6e7d747b$var$W(b, b.return, k);
        }
        if (b === a) {
            $f0b0d7da6e7d747b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f0b0d7da6e7d747b$var$V = h;
            break;
        }
        $f0b0d7da6e7d747b$var$V = b.return;
    }
}
var $f0b0d7da6e7d747b$var$mk = Math.ceil, $f0b0d7da6e7d747b$var$nk = $f0b0d7da6e7d747b$var$ua.ReactCurrentDispatcher, $f0b0d7da6e7d747b$var$ok = $f0b0d7da6e7d747b$var$ua.ReactCurrentOwner, $f0b0d7da6e7d747b$var$pk = $f0b0d7da6e7d747b$var$ua.ReactCurrentBatchConfig, $f0b0d7da6e7d747b$var$K = 0, $f0b0d7da6e7d747b$var$R = null, $f0b0d7da6e7d747b$var$Y = null, $f0b0d7da6e7d747b$var$Z = 0, $f0b0d7da6e7d747b$var$gj = 0, $f0b0d7da6e7d747b$var$fj = $f0b0d7da6e7d747b$var$Uf(0), $f0b0d7da6e7d747b$var$T = 0, $f0b0d7da6e7d747b$var$qk = null, $f0b0d7da6e7d747b$var$hh = 0, $f0b0d7da6e7d747b$var$rk = 0, $f0b0d7da6e7d747b$var$sk = 0, $f0b0d7da6e7d747b$var$tk = null, $f0b0d7da6e7d747b$var$uk = null, $f0b0d7da6e7d747b$var$gk = 0, $f0b0d7da6e7d747b$var$Hj = Infinity, $f0b0d7da6e7d747b$var$vk = null, $f0b0d7da6e7d747b$var$Pi = !1, $f0b0d7da6e7d747b$var$Qi = null, $f0b0d7da6e7d747b$var$Si = null, $f0b0d7da6e7d747b$var$wk = !1, $f0b0d7da6e7d747b$var$xk = null, $f0b0d7da6e7d747b$var$yk = 0, $f0b0d7da6e7d747b$var$zk = 0, $f0b0d7da6e7d747b$var$Ak = null, $f0b0d7da6e7d747b$var$Bk = -1, $f0b0d7da6e7d747b$var$Ck = 0;
function $f0b0d7da6e7d747b$var$L() {
    return 0 !== ($f0b0d7da6e7d747b$var$K & 6) ? $f0b0d7da6e7d747b$var$B() : -1 !== $f0b0d7da6e7d747b$var$Bk ? $f0b0d7da6e7d747b$var$Bk : $f0b0d7da6e7d747b$var$Bk = $f0b0d7da6e7d747b$var$B();
}
function $f0b0d7da6e7d747b$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f0b0d7da6e7d747b$var$K & 2) && 0 !== $f0b0d7da6e7d747b$var$Z) return $f0b0d7da6e7d747b$var$Z & -$f0b0d7da6e7d747b$var$Z;
    if (null !== $f0b0d7da6e7d747b$var$Kg.transition) return 0 === $f0b0d7da6e7d747b$var$Ck && ($f0b0d7da6e7d747b$var$Ck = $f0b0d7da6e7d747b$var$yc()), $f0b0d7da6e7d747b$var$Ck;
    a = $f0b0d7da6e7d747b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f0b0d7da6e7d747b$var$jd(a.type);
    return a;
}
function $f0b0d7da6e7d747b$var$mh(a, b, c, d) {
    if (50 < $f0b0d7da6e7d747b$var$zk) throw $f0b0d7da6e7d747b$var$zk = 0, $f0b0d7da6e7d747b$var$Ak = null, Error($f0b0d7da6e7d747b$var$p(185));
    $f0b0d7da6e7d747b$var$Ac(a, c, d);
    if (0 === ($f0b0d7da6e7d747b$var$K & 2) || a !== $f0b0d7da6e7d747b$var$R) a === $f0b0d7da6e7d747b$var$R && (0 === ($f0b0d7da6e7d747b$var$K & 2) && ($f0b0d7da6e7d747b$var$rk |= c), 4 === $f0b0d7da6e7d747b$var$T && $f0b0d7da6e7d747b$var$Dk(a, $f0b0d7da6e7d747b$var$Z)), $f0b0d7da6e7d747b$var$Ek(a, d), 1 === c && 0 === $f0b0d7da6e7d747b$var$K && 0 === (b.mode & 1) && ($f0b0d7da6e7d747b$var$Hj = $f0b0d7da6e7d747b$var$B() + 500, $f0b0d7da6e7d747b$var$fg && $f0b0d7da6e7d747b$var$jg());
}
function $f0b0d7da6e7d747b$var$Ek(a, b) {
    var c = a.callbackNode;
    $f0b0d7da6e7d747b$var$wc(a, b);
    var d = $f0b0d7da6e7d747b$var$uc(a, a === $f0b0d7da6e7d747b$var$R ? $f0b0d7da6e7d747b$var$Z : 0);
    if (0 === d) null !== c && $f0b0d7da6e7d747b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f0b0d7da6e7d747b$var$bc(c);
        if (1 === b) 0 === a.tag ? $f0b0d7da6e7d747b$var$ig($f0b0d7da6e7d747b$var$Fk.bind(null, a)) : $f0b0d7da6e7d747b$var$hg($f0b0d7da6e7d747b$var$Fk.bind(null, a)), $f0b0d7da6e7d747b$var$Jf(function() {
            0 === ($f0b0d7da6e7d747b$var$K & 6) && $f0b0d7da6e7d747b$var$jg();
        }), c = null;
        else {
            switch($f0b0d7da6e7d747b$var$Dc(d)){
                case 1:
                    c = $f0b0d7da6e7d747b$var$fc;
                    break;
                case 4:
                    c = $f0b0d7da6e7d747b$var$gc;
                    break;
                case 16:
                    c = $f0b0d7da6e7d747b$var$hc;
                    break;
                case 536870912:
                    c = $f0b0d7da6e7d747b$var$jc;
                    break;
                default:
                    c = $f0b0d7da6e7d747b$var$hc;
            }
            c = $f0b0d7da6e7d747b$var$Gk(c, $f0b0d7da6e7d747b$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f0b0d7da6e7d747b$var$Hk(a, b) {
    $f0b0d7da6e7d747b$var$Bk = -1;
    $f0b0d7da6e7d747b$var$Ck = 0;
    if (0 !== ($f0b0d7da6e7d747b$var$K & 6)) throw Error($f0b0d7da6e7d747b$var$p(327));
    var c = a.callbackNode;
    if ($f0b0d7da6e7d747b$var$Ik() && a.callbackNode !== c) return null;
    var d = $f0b0d7da6e7d747b$var$uc(a, a === $f0b0d7da6e7d747b$var$R ? $f0b0d7da6e7d747b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f0b0d7da6e7d747b$var$Jk(a, d);
    else {
        b = d;
        var e = $f0b0d7da6e7d747b$var$K;
        $f0b0d7da6e7d747b$var$K |= 2;
        var f = $f0b0d7da6e7d747b$var$Kk();
        if ($f0b0d7da6e7d747b$var$R !== a || $f0b0d7da6e7d747b$var$Z !== b) $f0b0d7da6e7d747b$var$vk = null, $f0b0d7da6e7d747b$var$Hj = $f0b0d7da6e7d747b$var$B() + 500, $f0b0d7da6e7d747b$var$Lk(a, b);
        for(;;)try {
            $f0b0d7da6e7d747b$var$Mk();
            break;
        } catch (h) {
            $f0b0d7da6e7d747b$var$Nk(a, h);
        }
        $f0b0d7da6e7d747b$var$Qg();
        $f0b0d7da6e7d747b$var$nk.current = f;
        $f0b0d7da6e7d747b$var$K = e;
        null !== $f0b0d7da6e7d747b$var$Y ? b = 0 : ($f0b0d7da6e7d747b$var$R = null, $f0b0d7da6e7d747b$var$Z = 0, b = $f0b0d7da6e7d747b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f0b0d7da6e7d747b$var$xc(a), 0 !== e && (d = e, b = $f0b0d7da6e7d747b$var$Ok(a, e)));
        if (1 === b) throw c = $f0b0d7da6e7d747b$var$qk, $f0b0d7da6e7d747b$var$Lk(a, 0), $f0b0d7da6e7d747b$var$Dk(a, d), $f0b0d7da6e7d747b$var$Ek(a, $f0b0d7da6e7d747b$var$B()), c;
        if (6 === b) $f0b0d7da6e7d747b$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f0b0d7da6e7d747b$var$Pk(e) && (b = $f0b0d7da6e7d747b$var$Jk(a, d), 2 === b && (f = $f0b0d7da6e7d747b$var$xc(a), 0 !== f && (d = f, b = $f0b0d7da6e7d747b$var$Ok(a, f))), 1 === b)) throw c = $f0b0d7da6e7d747b$var$qk, $f0b0d7da6e7d747b$var$Lk(a, 0), $f0b0d7da6e7d747b$var$Dk(a, d), $f0b0d7da6e7d747b$var$Ek(a, $f0b0d7da6e7d747b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f0b0d7da6e7d747b$var$p(345));
                case 2:
                    $f0b0d7da6e7d747b$var$Qk(a, $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$vk);
                    break;
                case 3:
                    $f0b0d7da6e7d747b$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $f0b0d7da6e7d747b$var$gk + 500 - $f0b0d7da6e7d747b$var$B(), 10 < b)) {
                        if (0 !== $f0b0d7da6e7d747b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f0b0d7da6e7d747b$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f0b0d7da6e7d747b$var$Ff($f0b0d7da6e7d747b$var$Qk.bind(null, a, $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$vk), b);
                        break;
                    }
                    $f0b0d7da6e7d747b$var$Qk(a, $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$vk);
                    break;
                case 4:
                    $f0b0d7da6e7d747b$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f0b0d7da6e7d747b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f0b0d7da6e7d747b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f0b0d7da6e7d747b$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f0b0d7da6e7d747b$var$Ff($f0b0d7da6e7d747b$var$Qk.bind(null, a, $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$vk), d);
                        break;
                    }
                    $f0b0d7da6e7d747b$var$Qk(a, $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$vk);
                    break;
                case 5:
                    $f0b0d7da6e7d747b$var$Qk(a, $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$vk);
                    break;
                default:
                    throw Error($f0b0d7da6e7d747b$var$p(329));
            }
        }
    }
    $f0b0d7da6e7d747b$var$Ek(a, $f0b0d7da6e7d747b$var$B());
    return a.callbackNode === c ? $f0b0d7da6e7d747b$var$Hk.bind(null, a) : null;
}
function $f0b0d7da6e7d747b$var$Ok(a, b) {
    var c = $f0b0d7da6e7d747b$var$tk;
    a.current.memoizedState.isDehydrated && ($f0b0d7da6e7d747b$var$Lk(a, b).flags |= 256);
    a = $f0b0d7da6e7d747b$var$Jk(a, b);
    2 !== a && (b = $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$uk = c, null !== b && $f0b0d7da6e7d747b$var$Gj(b));
    return a;
}
function $f0b0d7da6e7d747b$var$Gj(a) {
    null === $f0b0d7da6e7d747b$var$uk ? $f0b0d7da6e7d747b$var$uk = a : $f0b0d7da6e7d747b$var$uk.push.apply($f0b0d7da6e7d747b$var$uk, a);
}
function $f0b0d7da6e7d747b$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f0b0d7da6e7d747b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f0b0d7da6e7d747b$var$Dk(a, b) {
    b &= ~$f0b0d7da6e7d747b$var$sk;
    b &= ~$f0b0d7da6e7d747b$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f0b0d7da6e7d747b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f0b0d7da6e7d747b$var$Fk(a) {
    if (0 !== ($f0b0d7da6e7d747b$var$K & 6)) throw Error($f0b0d7da6e7d747b$var$p(327));
    $f0b0d7da6e7d747b$var$Ik();
    var b = $f0b0d7da6e7d747b$var$uc(a, 0);
    if (0 === (b & 1)) return $f0b0d7da6e7d747b$var$Ek(a, $f0b0d7da6e7d747b$var$B()), null;
    var c = $f0b0d7da6e7d747b$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f0b0d7da6e7d747b$var$xc(a);
        0 !== d && (b = d, c = $f0b0d7da6e7d747b$var$Ok(a, d));
    }
    if (1 === c) throw c = $f0b0d7da6e7d747b$var$qk, $f0b0d7da6e7d747b$var$Lk(a, 0), $f0b0d7da6e7d747b$var$Dk(a, b), $f0b0d7da6e7d747b$var$Ek(a, $f0b0d7da6e7d747b$var$B()), c;
    if (6 === c) throw Error($f0b0d7da6e7d747b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f0b0d7da6e7d747b$var$Qk(a, $f0b0d7da6e7d747b$var$uk, $f0b0d7da6e7d747b$var$vk);
    $f0b0d7da6e7d747b$var$Ek(a, $f0b0d7da6e7d747b$var$B());
    return null;
}
function $f0b0d7da6e7d747b$var$Rk(a, b) {
    var c = $f0b0d7da6e7d747b$var$K;
    $f0b0d7da6e7d747b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f0b0d7da6e7d747b$var$K = c, 0 === $f0b0d7da6e7d747b$var$K && ($f0b0d7da6e7d747b$var$Hj = $f0b0d7da6e7d747b$var$B() + 500, $f0b0d7da6e7d747b$var$fg && $f0b0d7da6e7d747b$var$jg());
    }
}
function $f0b0d7da6e7d747b$var$Sk(a) {
    null !== $f0b0d7da6e7d747b$var$xk && 0 === $f0b0d7da6e7d747b$var$xk.tag && 0 === ($f0b0d7da6e7d747b$var$K & 6) && $f0b0d7da6e7d747b$var$Ik();
    var b = $f0b0d7da6e7d747b$var$K;
    $f0b0d7da6e7d747b$var$K |= 1;
    var c = $f0b0d7da6e7d747b$var$pk.transition, d = $f0b0d7da6e7d747b$var$C;
    try {
        if ($f0b0d7da6e7d747b$var$pk.transition = null, $f0b0d7da6e7d747b$var$C = 1, a) return a();
    } finally{
        $f0b0d7da6e7d747b$var$C = d, $f0b0d7da6e7d747b$var$pk.transition = c, $f0b0d7da6e7d747b$var$K = b, 0 === ($f0b0d7da6e7d747b$var$K & 6) && $f0b0d7da6e7d747b$var$jg();
    }
}
function $f0b0d7da6e7d747b$var$Ij() {
    $f0b0d7da6e7d747b$var$gj = $f0b0d7da6e7d747b$var$fj.current;
    $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$fj);
}
function $f0b0d7da6e7d747b$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f0b0d7da6e7d747b$var$Gf(c));
    if (null !== $f0b0d7da6e7d747b$var$Y) for(c = $f0b0d7da6e7d747b$var$Y.return; null !== c;){
        var d = c;
        $f0b0d7da6e7d747b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f0b0d7da6e7d747b$var$$f();
                break;
            case 3:
                $f0b0d7da6e7d747b$var$Jh();
                $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$Wf);
                $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$H);
                $f0b0d7da6e7d747b$var$Oh();
                break;
            case 5:
                $f0b0d7da6e7d747b$var$Lh(d);
                break;
            case 4:
                $f0b0d7da6e7d747b$var$Jh();
                break;
            case 13:
                $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$M);
                break;
            case 19:
                $f0b0d7da6e7d747b$var$E($f0b0d7da6e7d747b$var$M);
                break;
            case 10:
                $f0b0d7da6e7d747b$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $f0b0d7da6e7d747b$var$Ij();
        }
        c = c.return;
    }
    $f0b0d7da6e7d747b$var$R = a;
    $f0b0d7da6e7d747b$var$Y = a = $f0b0d7da6e7d747b$var$wh(a.current, null);
    $f0b0d7da6e7d747b$var$Z = $f0b0d7da6e7d747b$var$gj = b;
    $f0b0d7da6e7d747b$var$T = 0;
    $f0b0d7da6e7d747b$var$qk = null;
    $f0b0d7da6e7d747b$var$sk = $f0b0d7da6e7d747b$var$rk = $f0b0d7da6e7d747b$var$hh = 0;
    $f0b0d7da6e7d747b$var$uk = $f0b0d7da6e7d747b$var$tk = null;
    if (null !== $f0b0d7da6e7d747b$var$Wg) {
        for(b = 0; b < $f0b0d7da6e7d747b$var$Wg.length; b++)if (c = $f0b0d7da6e7d747b$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f0b0d7da6e7d747b$var$Wg = null;
    }
    return a;
}
function $f0b0d7da6e7d747b$var$Nk(a, b) {
    do {
        var c = $f0b0d7da6e7d747b$var$Y;
        try {
            $f0b0d7da6e7d747b$var$Qg();
            $f0b0d7da6e7d747b$var$Ph.current = $f0b0d7da6e7d747b$var$ai;
            if ($f0b0d7da6e7d747b$var$Sh) {
                for(var d = $f0b0d7da6e7d747b$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f0b0d7da6e7d747b$var$Sh = !1;
            }
            $f0b0d7da6e7d747b$var$Rh = 0;
            $f0b0d7da6e7d747b$var$P = $f0b0d7da6e7d747b$var$O = $f0b0d7da6e7d747b$var$N = null;
            $f0b0d7da6e7d747b$var$Th = !1;
            $f0b0d7da6e7d747b$var$Uh = 0;
            $f0b0d7da6e7d747b$var$ok.current = null;
            if (null === c || null === c.return) {
                $f0b0d7da6e7d747b$var$T = 1;
                $f0b0d7da6e7d747b$var$qk = b;
                $f0b0d7da6e7d747b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f0b0d7da6e7d747b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f0b0d7da6e7d747b$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f0b0d7da6e7d747b$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $f0b0d7da6e7d747b$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f0b0d7da6e7d747b$var$Ti(f, l, b);
                            $f0b0d7da6e7d747b$var$uj();
                            break a;
                        }
                        k = Error($f0b0d7da6e7d747b$var$p(426));
                    }
                } else if ($f0b0d7da6e7d747b$var$I && h.mode & 1) {
                    var J = $f0b0d7da6e7d747b$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f0b0d7da6e7d747b$var$Wi(J, g, h, f, b);
                        $f0b0d7da6e7d747b$var$Jg($f0b0d7da6e7d747b$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $f0b0d7da6e7d747b$var$Ki(k, h);
                4 !== $f0b0d7da6e7d747b$var$T && ($f0b0d7da6e7d747b$var$T = 2);
                null === $f0b0d7da6e7d747b$var$tk ? $f0b0d7da6e7d747b$var$tk = [
                    f
                ] : $f0b0d7da6e7d747b$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f0b0d7da6e7d747b$var$Oi(f, k, b);
                            $f0b0d7da6e7d747b$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f0b0d7da6e7d747b$var$Si || !$f0b0d7da6e7d747b$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f0b0d7da6e7d747b$var$Ri(f, h, b);
                                $f0b0d7da6e7d747b$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f0b0d7da6e7d747b$var$Tk(c);
        } catch (na) {
            b = na;
            $f0b0d7da6e7d747b$var$Y === c && null !== c && ($f0b0d7da6e7d747b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f0b0d7da6e7d747b$var$Kk() {
    var a = $f0b0d7da6e7d747b$var$nk.current;
    $f0b0d7da6e7d747b$var$nk.current = $f0b0d7da6e7d747b$var$ai;
    return null === a ? $f0b0d7da6e7d747b$var$ai : a;
}
function $f0b0d7da6e7d747b$var$uj() {
    if (0 === $f0b0d7da6e7d747b$var$T || 3 === $f0b0d7da6e7d747b$var$T || 2 === $f0b0d7da6e7d747b$var$T) $f0b0d7da6e7d747b$var$T = 4;
    null === $f0b0d7da6e7d747b$var$R || 0 === ($f0b0d7da6e7d747b$var$hh & 268435455) && 0 === ($f0b0d7da6e7d747b$var$rk & 268435455) || $f0b0d7da6e7d747b$var$Dk($f0b0d7da6e7d747b$var$R, $f0b0d7da6e7d747b$var$Z);
}
function $f0b0d7da6e7d747b$var$Jk(a, b) {
    var c = $f0b0d7da6e7d747b$var$K;
    $f0b0d7da6e7d747b$var$K |= 2;
    var d = $f0b0d7da6e7d747b$var$Kk();
    if ($f0b0d7da6e7d747b$var$R !== a || $f0b0d7da6e7d747b$var$Z !== b) $f0b0d7da6e7d747b$var$vk = null, $f0b0d7da6e7d747b$var$Lk(a, b);
    for(;;)try {
        $f0b0d7da6e7d747b$var$Uk();
        break;
    } catch (e) {
        $f0b0d7da6e7d747b$var$Nk(a, e);
    }
    $f0b0d7da6e7d747b$var$Qg();
    $f0b0d7da6e7d747b$var$K = c;
    $f0b0d7da6e7d747b$var$nk.current = d;
    if (null !== $f0b0d7da6e7d747b$var$Y) throw Error($f0b0d7da6e7d747b$var$p(261));
    $f0b0d7da6e7d747b$var$R = null;
    $f0b0d7da6e7d747b$var$Z = 0;
    return $f0b0d7da6e7d747b$var$T;
}
function $f0b0d7da6e7d747b$var$Uk() {
    for(; null !== $f0b0d7da6e7d747b$var$Y;)$f0b0d7da6e7d747b$var$Vk($f0b0d7da6e7d747b$var$Y);
}
function $f0b0d7da6e7d747b$var$Mk() {
    for(; null !== $f0b0d7da6e7d747b$var$Y && !$f0b0d7da6e7d747b$var$cc();)$f0b0d7da6e7d747b$var$Vk($f0b0d7da6e7d747b$var$Y);
}
function $f0b0d7da6e7d747b$var$Vk(a) {
    var b = $f0b0d7da6e7d747b$var$Wk(a.alternate, a, $f0b0d7da6e7d747b$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f0b0d7da6e7d747b$var$Tk(a) : $f0b0d7da6e7d747b$var$Y = b;
    $f0b0d7da6e7d747b$var$ok.current = null;
}
function $f0b0d7da6e7d747b$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f0b0d7da6e7d747b$var$Fj(c, b, $f0b0d7da6e7d747b$var$gj), null !== c) {
                $f0b0d7da6e7d747b$var$Y = c;
                return;
            }
        } else {
            c = $f0b0d7da6e7d747b$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f0b0d7da6e7d747b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f0b0d7da6e7d747b$var$T = 6;
                $f0b0d7da6e7d747b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f0b0d7da6e7d747b$var$Y = b;
            return;
        }
        $f0b0d7da6e7d747b$var$Y = b = a;
    }while (null !== b);
    0 === $f0b0d7da6e7d747b$var$T && ($f0b0d7da6e7d747b$var$T = 5);
}
function $f0b0d7da6e7d747b$var$Qk(a, b, c) {
    var d = $f0b0d7da6e7d747b$var$C, e = $f0b0d7da6e7d747b$var$pk.transition;
    try {
        $f0b0d7da6e7d747b$var$pk.transition = null, $f0b0d7da6e7d747b$var$C = 1, $f0b0d7da6e7d747b$var$Xk(a, b, c, d);
    } finally{
        $f0b0d7da6e7d747b$var$pk.transition = e, $f0b0d7da6e7d747b$var$C = d;
    }
    return null;
}
function $f0b0d7da6e7d747b$var$Xk(a, b, c, d) {
    do $f0b0d7da6e7d747b$var$Ik();
    while (null !== $f0b0d7da6e7d747b$var$xk);
    if (0 !== ($f0b0d7da6e7d747b$var$K & 6)) throw Error($f0b0d7da6e7d747b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f0b0d7da6e7d747b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f0b0d7da6e7d747b$var$Bc(a, f);
    a === $f0b0d7da6e7d747b$var$R && ($f0b0d7da6e7d747b$var$Y = $f0b0d7da6e7d747b$var$R = null, $f0b0d7da6e7d747b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f0b0d7da6e7d747b$var$wk || ($f0b0d7da6e7d747b$var$wk = !0, $f0b0d7da6e7d747b$var$Gk($f0b0d7da6e7d747b$var$hc, function() {
        $f0b0d7da6e7d747b$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f0b0d7da6e7d747b$var$pk.transition;
        $f0b0d7da6e7d747b$var$pk.transition = null;
        var g = $f0b0d7da6e7d747b$var$C;
        $f0b0d7da6e7d747b$var$C = 1;
        var h = $f0b0d7da6e7d747b$var$K;
        $f0b0d7da6e7d747b$var$K |= 4;
        $f0b0d7da6e7d747b$var$ok.current = null;
        $f0b0d7da6e7d747b$var$Pj(a, c);
        $f0b0d7da6e7d747b$var$ek(c, a);
        $f0b0d7da6e7d747b$var$Oe($f0b0d7da6e7d747b$var$Df);
        $f0b0d7da6e7d747b$var$dd = !!$f0b0d7da6e7d747b$var$Cf;
        $f0b0d7da6e7d747b$var$Df = $f0b0d7da6e7d747b$var$Cf = null;
        a.current = c;
        $f0b0d7da6e7d747b$var$ik(c, a, e);
        $f0b0d7da6e7d747b$var$dc();
        $f0b0d7da6e7d747b$var$K = h;
        $f0b0d7da6e7d747b$var$C = g;
        $f0b0d7da6e7d747b$var$pk.transition = f;
    } else a.current = c;
    $f0b0d7da6e7d747b$var$wk && ($f0b0d7da6e7d747b$var$wk = !1, $f0b0d7da6e7d747b$var$xk = a, $f0b0d7da6e7d747b$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($f0b0d7da6e7d747b$var$Si = null);
    $f0b0d7da6e7d747b$var$mc(c.stateNode, d);
    $f0b0d7da6e7d747b$var$Ek(a, $f0b0d7da6e7d747b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f0b0d7da6e7d747b$var$Pi) throw $f0b0d7da6e7d747b$var$Pi = !1, a = $f0b0d7da6e7d747b$var$Qi, $f0b0d7da6e7d747b$var$Qi = null, a;
    0 !== ($f0b0d7da6e7d747b$var$yk & 1) && 0 !== a.tag && $f0b0d7da6e7d747b$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f0b0d7da6e7d747b$var$Ak ? $f0b0d7da6e7d747b$var$zk++ : ($f0b0d7da6e7d747b$var$zk = 0, $f0b0d7da6e7d747b$var$Ak = a) : $f0b0d7da6e7d747b$var$zk = 0;
    $f0b0d7da6e7d747b$var$jg();
    return null;
}
function $f0b0d7da6e7d747b$var$Ik() {
    if (null !== $f0b0d7da6e7d747b$var$xk) {
        var a = $f0b0d7da6e7d747b$var$Dc($f0b0d7da6e7d747b$var$yk), b = $f0b0d7da6e7d747b$var$pk.transition, c = $f0b0d7da6e7d747b$var$C;
        try {
            $f0b0d7da6e7d747b$var$pk.transition = null;
            $f0b0d7da6e7d747b$var$C = 16 > a ? 16 : a;
            if (null === $f0b0d7da6e7d747b$var$xk) var d = !1;
            else {
                a = $f0b0d7da6e7d747b$var$xk;
                $f0b0d7da6e7d747b$var$xk = null;
                $f0b0d7da6e7d747b$var$yk = 0;
                if (0 !== ($f0b0d7da6e7d747b$var$K & 6)) throw Error($f0b0d7da6e7d747b$var$p(331));
                var e = $f0b0d7da6e7d747b$var$K;
                $f0b0d7da6e7d747b$var$K |= 4;
                for($f0b0d7da6e7d747b$var$V = a.current; null !== $f0b0d7da6e7d747b$var$V;){
                    var f = $f0b0d7da6e7d747b$var$V, g = f.child;
                    if (0 !== ($f0b0d7da6e7d747b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f0b0d7da6e7d747b$var$V = l; null !== $f0b0d7da6e7d747b$var$V;){
                                    var m = $f0b0d7da6e7d747b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f0b0d7da6e7d747b$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f0b0d7da6e7d747b$var$V = q;
                                    else for(; null !== $f0b0d7da6e7d747b$var$V;){
                                        m = $f0b0d7da6e7d747b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f0b0d7da6e7d747b$var$Tj(m);
                                        if (m === l) {
                                            $f0b0d7da6e7d747b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f0b0d7da6e7d747b$var$V = r;
                                            break;
                                        }
                                        $f0b0d7da6e7d747b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f0b0d7da6e7d747b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f0b0d7da6e7d747b$var$V = g;
                    else b: for(; null !== $f0b0d7da6e7d747b$var$V;){
                        f = $f0b0d7da6e7d747b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f0b0d7da6e7d747b$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f0b0d7da6e7d747b$var$V = x;
                            break b;
                        }
                        $f0b0d7da6e7d747b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f0b0d7da6e7d747b$var$V = w; null !== $f0b0d7da6e7d747b$var$V;){
                    g = $f0b0d7da6e7d747b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f0b0d7da6e7d747b$var$V = u;
                    else b: for(g = w; null !== $f0b0d7da6e7d747b$var$V;){
                        h = $f0b0d7da6e7d747b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f0b0d7da6e7d747b$var$Rj(9, h);
                            }
                        } catch (na) {
                            $f0b0d7da6e7d747b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f0b0d7da6e7d747b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f0b0d7da6e7d747b$var$V = F;
                            break b;
                        }
                        $f0b0d7da6e7d747b$var$V = h.return;
                    }
                }
                $f0b0d7da6e7d747b$var$K = e;
                $f0b0d7da6e7d747b$var$jg();
                if ($f0b0d7da6e7d747b$var$lc && "function" === typeof $f0b0d7da6e7d747b$var$lc.onPostCommitFiberRoot) try {
                    $f0b0d7da6e7d747b$var$lc.onPostCommitFiberRoot($f0b0d7da6e7d747b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f0b0d7da6e7d747b$var$C = c, $f0b0d7da6e7d747b$var$pk.transition = b;
        }
    }
    return !1;
}
function $f0b0d7da6e7d747b$var$Yk(a, b, c) {
    b = $f0b0d7da6e7d747b$var$Ki(c, b);
    b = $f0b0d7da6e7d747b$var$Oi(a, b, 1);
    a = $f0b0d7da6e7d747b$var$dh(a, b, 1);
    b = $f0b0d7da6e7d747b$var$L();
    null !== a && ($f0b0d7da6e7d747b$var$Ac(a, 1, b), $f0b0d7da6e7d747b$var$Ek(a, b));
}
function $f0b0d7da6e7d747b$var$W(a, b, c) {
    if (3 === a.tag) $f0b0d7da6e7d747b$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f0b0d7da6e7d747b$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f0b0d7da6e7d747b$var$Si || !$f0b0d7da6e7d747b$var$Si.has(d))) {
                a = $f0b0d7da6e7d747b$var$Ki(c, a);
                a = $f0b0d7da6e7d747b$var$Ri(b, a, 1);
                b = $f0b0d7da6e7d747b$var$dh(b, a, 1);
                a = $f0b0d7da6e7d747b$var$L();
                null !== b && ($f0b0d7da6e7d747b$var$Ac(b, 1, a), $f0b0d7da6e7d747b$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f0b0d7da6e7d747b$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f0b0d7da6e7d747b$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $f0b0d7da6e7d747b$var$R === a && ($f0b0d7da6e7d747b$var$Z & c) === c && (4 === $f0b0d7da6e7d747b$var$T || 3 === $f0b0d7da6e7d747b$var$T && ($f0b0d7da6e7d747b$var$Z & 130023424) === $f0b0d7da6e7d747b$var$Z && 500 > $f0b0d7da6e7d747b$var$B() - $f0b0d7da6e7d747b$var$gk ? $f0b0d7da6e7d747b$var$Lk(a, 0) : $f0b0d7da6e7d747b$var$sk |= c);
    $f0b0d7da6e7d747b$var$Ek(a, b);
}
function $f0b0d7da6e7d747b$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f0b0d7da6e7d747b$var$sc, $f0b0d7da6e7d747b$var$sc <<= 1, 0 === ($f0b0d7da6e7d747b$var$sc & 130023424) && ($f0b0d7da6e7d747b$var$sc = 4194304)));
    var c = $f0b0d7da6e7d747b$var$L();
    a = $f0b0d7da6e7d747b$var$Zg(a, b);
    null !== a && ($f0b0d7da6e7d747b$var$Ac(a, b, c), $f0b0d7da6e7d747b$var$Ek(a, c));
}
function $f0b0d7da6e7d747b$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f0b0d7da6e7d747b$var$Zk(a, c);
}
function $f0b0d7da6e7d747b$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f0b0d7da6e7d747b$var$p(314));
    }
    null !== d && d.delete(b);
    $f0b0d7da6e7d747b$var$Zk(a, c);
}
var $f0b0d7da6e7d747b$var$Wk;
$f0b0d7da6e7d747b$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f0b0d7da6e7d747b$var$Wf.current) $f0b0d7da6e7d747b$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f0b0d7da6e7d747b$var$Ug = !1, $f0b0d7da6e7d747b$var$zj(a, b, c);
            $f0b0d7da6e7d747b$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f0b0d7da6e7d747b$var$Ug = !1, $f0b0d7da6e7d747b$var$I && 0 !== (b.flags & 1048576) && $f0b0d7da6e7d747b$var$ug(b, $f0b0d7da6e7d747b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f0b0d7da6e7d747b$var$jj(a, b);
            a = b.pendingProps;
            var e = $f0b0d7da6e7d747b$var$Yf(b, $f0b0d7da6e7d747b$var$H.current);
            $f0b0d7da6e7d747b$var$Tg(b, c);
            e = $f0b0d7da6e7d747b$var$Xh(null, b, d, a, e, c);
            var f = $f0b0d7da6e7d747b$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f0b0d7da6e7d747b$var$Zf(d) ? (f = !0, $f0b0d7da6e7d747b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f0b0d7da6e7d747b$var$ah(b), e.updater = $f0b0d7da6e7d747b$var$nh, b.stateNode = e, e._reactInternals = b, $f0b0d7da6e7d747b$var$rh(b, d, a, c), b = $f0b0d7da6e7d747b$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $f0b0d7da6e7d747b$var$I && f && $f0b0d7da6e7d747b$var$vg(b), $f0b0d7da6e7d747b$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f0b0d7da6e7d747b$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f0b0d7da6e7d747b$var$$k(d);
                a = $f0b0d7da6e7d747b$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $f0b0d7da6e7d747b$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f0b0d7da6e7d747b$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f0b0d7da6e7d747b$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f0b0d7da6e7d747b$var$aj(null, b, d, $f0b0d7da6e7d747b$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($f0b0d7da6e7d747b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f0b0d7da6e7d747b$var$Lg(d, e), $f0b0d7da6e7d747b$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f0b0d7da6e7d747b$var$Lg(d, e), $f0b0d7da6e7d747b$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $f0b0d7da6e7d747b$var$lj(b);
                if (null === a) throw Error($f0b0d7da6e7d747b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f0b0d7da6e7d747b$var$bh(a, b);
                $f0b0d7da6e7d747b$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f0b0d7da6e7d747b$var$Ki(Error($f0b0d7da6e7d747b$var$p(423)), b);
                        b = $f0b0d7da6e7d747b$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f0b0d7da6e7d747b$var$Ki(Error($f0b0d7da6e7d747b$var$p(424)), b);
                        b = $f0b0d7da6e7d747b$var$mj(a, b, d, c, e);
                        break a;
                    } else for($f0b0d7da6e7d747b$var$yg = $f0b0d7da6e7d747b$var$Lf(b.stateNode.containerInfo.firstChild), $f0b0d7da6e7d747b$var$xg = b, $f0b0d7da6e7d747b$var$I = !0, $f0b0d7da6e7d747b$var$zg = null, c = $f0b0d7da6e7d747b$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f0b0d7da6e7d747b$var$Ig();
                    if (d === e) {
                        b = $f0b0d7da6e7d747b$var$$i(a, b, c);
                        break a;
                    }
                    $f0b0d7da6e7d747b$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f0b0d7da6e7d747b$var$Kh(b), null === a && $f0b0d7da6e7d747b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f0b0d7da6e7d747b$var$Ef(d, e) ? g = null : null !== f && $f0b0d7da6e7d747b$var$Ef(d, f) && (b.flags |= 32), $f0b0d7da6e7d747b$var$hj(a, b), $f0b0d7da6e7d747b$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $f0b0d7da6e7d747b$var$Eg(b), null;
        case 13:
            return $f0b0d7da6e7d747b$var$pj(a, b, c);
        case 4:
            return $f0b0d7da6e7d747b$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f0b0d7da6e7d747b$var$Bh(b, null, d, c) : $f0b0d7da6e7d747b$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f0b0d7da6e7d747b$var$Lg(d, e), $f0b0d7da6e7d747b$var$Zi(a, b, d, e, c);
        case 7:
            return $f0b0d7da6e7d747b$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f0b0d7da6e7d747b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f0b0d7da6e7d747b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f0b0d7da6e7d747b$var$G($f0b0d7da6e7d747b$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f0b0d7da6e7d747b$var$He(f.value, g)) {
                        if (f.children === e.children && !$f0b0d7da6e7d747b$var$Wf.current) {
                            b = $f0b0d7da6e7d747b$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f0b0d7da6e7d747b$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f0b0d7da6e7d747b$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f0b0d7da6e7d747b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f0b0d7da6e7d747b$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f0b0d7da6e7d747b$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f0b0d7da6e7d747b$var$Tg(b, c), e = $f0b0d7da6e7d747b$var$Vg(e), d = d(e), b.flags |= 1, $f0b0d7da6e7d747b$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f0b0d7da6e7d747b$var$Lg(d, b.pendingProps), e = $f0b0d7da6e7d747b$var$Lg(d.type, e), $f0b0d7da6e7d747b$var$aj(a, b, d, e, c);
        case 15:
            return $f0b0d7da6e7d747b$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f0b0d7da6e7d747b$var$Lg(d, e), $f0b0d7da6e7d747b$var$jj(a, b), b.tag = 1, $f0b0d7da6e7d747b$var$Zf(d) ? (a = !0, $f0b0d7da6e7d747b$var$cg(b)) : a = !1, $f0b0d7da6e7d747b$var$Tg(b, c), $f0b0d7da6e7d747b$var$ph(b, d, e), $f0b0d7da6e7d747b$var$rh(b, d, e, c), $f0b0d7da6e7d747b$var$kj(null, b, d, !0, a, c);
        case 19:
            return $f0b0d7da6e7d747b$var$yj(a, b, c);
        case 22:
            return $f0b0d7da6e7d747b$var$ej(a, b, c);
    }
    throw Error($f0b0d7da6e7d747b$var$p(156, b.tag));
};
function $f0b0d7da6e7d747b$var$Gk(a, b) {
    return $f0b0d7da6e7d747b$var$ac(a, b);
}
function $f0b0d7da6e7d747b$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f0b0d7da6e7d747b$var$Bg(a, b, c, d) {
    return new $f0b0d7da6e7d747b$var$al(a, b, c, d);
}
function $f0b0d7da6e7d747b$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f0b0d7da6e7d747b$var$$k(a) {
    if ("function" === typeof a) return $f0b0d7da6e7d747b$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f0b0d7da6e7d747b$var$Da) return 11;
        if (a === $f0b0d7da6e7d747b$var$Ga) return 14;
    }
    return 2;
}
function $f0b0d7da6e7d747b$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $f0b0d7da6e7d747b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f0b0d7da6e7d747b$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f0b0d7da6e7d747b$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f0b0d7da6e7d747b$var$ya:
            return $f0b0d7da6e7d747b$var$Ah(c.children, e, f, b);
        case $f0b0d7da6e7d747b$var$za:
            g = 8;
            e |= 8;
            break;
        case $f0b0d7da6e7d747b$var$Aa:
            return a = $f0b0d7da6e7d747b$var$Bg(12, c, b, e | 2), a.elementType = $f0b0d7da6e7d747b$var$Aa, a.lanes = f, a;
        case $f0b0d7da6e7d747b$var$Ea:
            return a = $f0b0d7da6e7d747b$var$Bg(13, c, b, e), a.elementType = $f0b0d7da6e7d747b$var$Ea, a.lanes = f, a;
        case $f0b0d7da6e7d747b$var$Fa:
            return a = $f0b0d7da6e7d747b$var$Bg(19, c, b, e), a.elementType = $f0b0d7da6e7d747b$var$Fa, a.lanes = f, a;
        case $f0b0d7da6e7d747b$var$Ia:
            return $f0b0d7da6e7d747b$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f0b0d7da6e7d747b$var$Ba:
                    g = 10;
                    break a;
                case $f0b0d7da6e7d747b$var$Ca:
                    g = 9;
                    break a;
                case $f0b0d7da6e7d747b$var$Da:
                    g = 11;
                    break a;
                case $f0b0d7da6e7d747b$var$Ga:
                    g = 14;
                    break a;
                case $f0b0d7da6e7d747b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f0b0d7da6e7d747b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f0b0d7da6e7d747b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f0b0d7da6e7d747b$var$Ah(a, b, c, d) {
    a = $f0b0d7da6e7d747b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f0b0d7da6e7d747b$var$qj(a, b, c, d) {
    a = $f0b0d7da6e7d747b$var$Bg(22, a, d, b);
    a.elementType = $f0b0d7da6e7d747b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f0b0d7da6e7d747b$var$xh(a, b, c) {
    a = $f0b0d7da6e7d747b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f0b0d7da6e7d747b$var$zh(a, b, c) {
    b = $f0b0d7da6e7d747b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f0b0d7da6e7d747b$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f0b0d7da6e7d747b$var$zc(0);
    this.expirationTimes = $f0b0d7da6e7d747b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f0b0d7da6e7d747b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f0b0d7da6e7d747b$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $f0b0d7da6e7d747b$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f0b0d7da6e7d747b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f0b0d7da6e7d747b$var$ah(f);
    return a;
}
function $f0b0d7da6e7d747b$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f0b0d7da6e7d747b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f0b0d7da6e7d747b$var$el(a) {
    if (!a) return $f0b0d7da6e7d747b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f0b0d7da6e7d747b$var$Vb(a) !== a || 1 !== a.tag) throw Error($f0b0d7da6e7d747b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f0b0d7da6e7d747b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f0b0d7da6e7d747b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f0b0d7da6e7d747b$var$Zf(c)) return $f0b0d7da6e7d747b$var$bg(a, c, b);
    }
    return b;
}
function $f0b0d7da6e7d747b$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $f0b0d7da6e7d747b$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $f0b0d7da6e7d747b$var$el(null);
    c = a.current;
    d = $f0b0d7da6e7d747b$var$L();
    e = $f0b0d7da6e7d747b$var$lh(c);
    f = $f0b0d7da6e7d747b$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f0b0d7da6e7d747b$var$dh(c, f, e);
    a.current.lanes = e;
    $f0b0d7da6e7d747b$var$Ac(a, e, d);
    $f0b0d7da6e7d747b$var$Ek(a, d);
    return a;
}
function $f0b0d7da6e7d747b$var$gl(a, b, c, d) {
    var e = b.current, f = $f0b0d7da6e7d747b$var$L(), g = $f0b0d7da6e7d747b$var$lh(e);
    c = $f0b0d7da6e7d747b$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f0b0d7da6e7d747b$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f0b0d7da6e7d747b$var$dh(e, b, g);
    null !== a && ($f0b0d7da6e7d747b$var$mh(a, e, g, f), $f0b0d7da6e7d747b$var$eh(a, e, g));
    return g;
}
function $f0b0d7da6e7d747b$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f0b0d7da6e7d747b$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f0b0d7da6e7d747b$var$jl(a, b) {
    $f0b0d7da6e7d747b$var$il(a, b);
    (a = a.alternate) && $f0b0d7da6e7d747b$var$il(a, b);
}
function $f0b0d7da6e7d747b$var$kl() {
    return null;
}
var $f0b0d7da6e7d747b$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f0b0d7da6e7d747b$var$ml(a) {
    this._internalRoot = a;
}
$f0b0d7da6e7d747b$var$nl.prototype.render = $f0b0d7da6e7d747b$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f0b0d7da6e7d747b$var$p(409));
    $f0b0d7da6e7d747b$var$gl(a, b, null, null);
};
$f0b0d7da6e7d747b$var$nl.prototype.unmount = $f0b0d7da6e7d747b$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f0b0d7da6e7d747b$var$Sk(function() {
            $f0b0d7da6e7d747b$var$gl(null, a, null, null);
        });
        b[$f0b0d7da6e7d747b$var$uf] = null;
    }
};
function $f0b0d7da6e7d747b$var$nl(a) {
    this._internalRoot = a;
}
$f0b0d7da6e7d747b$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f0b0d7da6e7d747b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f0b0d7da6e7d747b$var$Qc.length && 0 !== b && b < $f0b0d7da6e7d747b$var$Qc[c].priority; c++);
        $f0b0d7da6e7d747b$var$Qc.splice(c, 0, a);
        0 === c && $f0b0d7da6e7d747b$var$Vc(a);
    }
};
function $f0b0d7da6e7d747b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f0b0d7da6e7d747b$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f0b0d7da6e7d747b$var$ql() {}
function $f0b0d7da6e7d747b$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f0b0d7da6e7d747b$var$hl(g);
                f.call(a);
            };
        }
        var g = $f0b0d7da6e7d747b$var$fl(b, d, a, 0, null, !1, !1, "", $f0b0d7da6e7d747b$var$ql);
        a._reactRootContainer = g;
        a[$f0b0d7da6e7d747b$var$uf] = g.current;
        $f0b0d7da6e7d747b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f0b0d7da6e7d747b$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f0b0d7da6e7d747b$var$hl(k);
            h.call(a);
        };
    }
    var k = $f0b0d7da6e7d747b$var$cl(a, 0, !1, null, null, !1, !1, "", $f0b0d7da6e7d747b$var$ql);
    a._reactRootContainer = k;
    a[$f0b0d7da6e7d747b$var$uf] = k.current;
    $f0b0d7da6e7d747b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f0b0d7da6e7d747b$var$Sk(function() {
        $f0b0d7da6e7d747b$var$gl(b, k, c, d);
    });
    return k;
}
function $f0b0d7da6e7d747b$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f0b0d7da6e7d747b$var$hl(g);
                h.call(a);
            };
        }
        $f0b0d7da6e7d747b$var$gl(b, g, a, e);
    } else g = $f0b0d7da6e7d747b$var$rl(c, b, a, e, d);
    return $f0b0d7da6e7d747b$var$hl(g);
}
$f0b0d7da6e7d747b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f0b0d7da6e7d747b$var$tc(b.pendingLanes);
                0 !== c && ($f0b0d7da6e7d747b$var$Cc(b, c | 1), $f0b0d7da6e7d747b$var$Ek(b, $f0b0d7da6e7d747b$var$B()), 0 === ($f0b0d7da6e7d747b$var$K & 6) && ($f0b0d7da6e7d747b$var$Hj = $f0b0d7da6e7d747b$var$B() + 500, $f0b0d7da6e7d747b$var$jg()));
            }
            break;
        case 13:
            $f0b0d7da6e7d747b$var$Sk(function() {
                var b = $f0b0d7da6e7d747b$var$Zg(a, 1);
                if (null !== b) {
                    var c = $f0b0d7da6e7d747b$var$L();
                    $f0b0d7da6e7d747b$var$mh(b, a, 1, c);
                }
            }), $f0b0d7da6e7d747b$var$jl(a, 1);
    }
};
$f0b0d7da6e7d747b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f0b0d7da6e7d747b$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $f0b0d7da6e7d747b$var$L();
            $f0b0d7da6e7d747b$var$mh(b, a, 134217728, c);
        }
        $f0b0d7da6e7d747b$var$jl(a, 134217728);
    }
};
$f0b0d7da6e7d747b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f0b0d7da6e7d747b$var$lh(a), c = $f0b0d7da6e7d747b$var$Zg(a, b);
        if (null !== c) {
            var d = $f0b0d7da6e7d747b$var$L();
            $f0b0d7da6e7d747b$var$mh(c, a, b, d);
        }
        $f0b0d7da6e7d747b$var$jl(a, b);
    }
};
$f0b0d7da6e7d747b$var$Hc = function() {
    return $f0b0d7da6e7d747b$var$C;
};
$f0b0d7da6e7d747b$var$Ic = function(a, b) {
    var c = $f0b0d7da6e7d747b$var$C;
    try {
        return $f0b0d7da6e7d747b$var$C = a, b();
    } finally{
        $f0b0d7da6e7d747b$var$C = c;
    }
};
$f0b0d7da6e7d747b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f0b0d7da6e7d747b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f0b0d7da6e7d747b$var$Db(d);
                        if (!e) throw Error($f0b0d7da6e7d747b$var$p(90));
                        $f0b0d7da6e7d747b$var$Wa(d);
                        $f0b0d7da6e7d747b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f0b0d7da6e7d747b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f0b0d7da6e7d747b$var$fb(a, !!c.multiple, b, !1);
    }
};
$f0b0d7da6e7d747b$var$Gb = $f0b0d7da6e7d747b$var$Rk;
$f0b0d7da6e7d747b$var$Hb = $f0b0d7da6e7d747b$var$Sk;
var $f0b0d7da6e7d747b$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $f0b0d7da6e7d747b$var$Cb,
        $f0b0d7da6e7d747b$var$ue,
        $f0b0d7da6e7d747b$var$Db,
        $f0b0d7da6e7d747b$var$Eb,
        $f0b0d7da6e7d747b$var$Fb,
        $f0b0d7da6e7d747b$var$Rk
    ]
}, $f0b0d7da6e7d747b$var$ul = {
    findFiberByHostInstance: $f0b0d7da6e7d747b$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $f0b0d7da6e7d747b$var$vl = {
    bundleType: $f0b0d7da6e7d747b$var$ul.bundleType,
    version: $f0b0d7da6e7d747b$var$ul.version,
    rendererPackageName: $f0b0d7da6e7d747b$var$ul.rendererPackageName,
    rendererConfig: $f0b0d7da6e7d747b$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f0b0d7da6e7d747b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f0b0d7da6e7d747b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f0b0d7da6e7d747b$var$ul.findFiberByHostInstance || $f0b0d7da6e7d747b$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f0b0d7da6e7d747b$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f0b0d7da6e7d747b$var$wl.isDisabled && $f0b0d7da6e7d747b$var$wl.supportsFiber) try {
        $f0b0d7da6e7d747b$var$kc = $f0b0d7da6e7d747b$var$wl.inject($f0b0d7da6e7d747b$var$vl), $f0b0d7da6e7d747b$var$lc = $f0b0d7da6e7d747b$var$wl;
    } catch (a) {}
}
$f0b0d7da6e7d747b$export$ae55be85d98224ed = $f0b0d7da6e7d747b$var$tl;
$f0b0d7da6e7d747b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f0b0d7da6e7d747b$var$ol(b)) throw Error($f0b0d7da6e7d747b$var$p(200));
    return $f0b0d7da6e7d747b$var$dl(a, b, null, c);
};
$f0b0d7da6e7d747b$export$882461b6382ed46c = function(a, b) {
    if (!$f0b0d7da6e7d747b$var$ol(a)) throw Error($f0b0d7da6e7d747b$var$p(299));
    var c = !1, d = "", e = $f0b0d7da6e7d747b$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f0b0d7da6e7d747b$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$f0b0d7da6e7d747b$var$uf] = b.current;
    $f0b0d7da6e7d747b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f0b0d7da6e7d747b$var$ml(b);
};
$f0b0d7da6e7d747b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f0b0d7da6e7d747b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f0b0d7da6e7d747b$var$p(268, a));
    }
    a = $f0b0d7da6e7d747b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f0b0d7da6e7d747b$export$cd75ccfd720a3cd4 = function(a) {
    return $f0b0d7da6e7d747b$var$Sk(a);
};
$f0b0d7da6e7d747b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f0b0d7da6e7d747b$var$pl(b)) throw Error($f0b0d7da6e7d747b$var$p(200));
    return $f0b0d7da6e7d747b$var$sl(null, a, b, !0, c);
};
$f0b0d7da6e7d747b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f0b0d7da6e7d747b$var$ol(a)) throw Error($f0b0d7da6e7d747b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f0b0d7da6e7d747b$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f0b0d7da6e7d747b$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f0b0d7da6e7d747b$var$uf] = b.current;
    $f0b0d7da6e7d747b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f0b0d7da6e7d747b$var$nl(b);
};
$f0b0d7da6e7d747b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f0b0d7da6e7d747b$var$pl(b)) throw Error($f0b0d7da6e7d747b$var$p(200));
    return $f0b0d7da6e7d747b$var$sl(null, a, b, !1, c);
};
$f0b0d7da6e7d747b$export$502457920280e6be = function(a) {
    if (!$f0b0d7da6e7d747b$var$pl(a)) throw Error($f0b0d7da6e7d747b$var$p(40));
    return a._reactRootContainer ? ($f0b0d7da6e7d747b$var$Sk(function() {
        $f0b0d7da6e7d747b$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f0b0d7da6e7d747b$var$uf] = null;
        });
    }), !0) : !1;
};
$f0b0d7da6e7d747b$export$c78a37762a8d58e1 = $f0b0d7da6e7d747b$var$Rk;
$f0b0d7da6e7d747b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f0b0d7da6e7d747b$var$pl(c)) throw Error($f0b0d7da6e7d747b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f0b0d7da6e7d747b$var$p(38));
    return $f0b0d7da6e7d747b$var$sl(a, b, c, !1, d);
};
$f0b0d7da6e7d747b$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("f1D4w", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9451y"));

});
parcelRequire.register("9451y", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $01b401968094f1fb$export$c4744153514ff05d; }, function (v) { return $01b401968094f1fb$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $01b401968094f1fb$export$3e506c1ccc9cc1a7; }, function (v) { return $01b401968094f1fb$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $01b401968094f1fb$export$e26fe2ed2fa76875; }, function (v) { return $01b401968094f1fb$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $01b401968094f1fb$export$502329bbf4b505b1; }, function (v) { return $01b401968094f1fb$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $01b401968094f1fb$export$6e3807111c4874c4; }, function (v) { return $01b401968094f1fb$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $01b401968094f1fb$export$c27134553091fb3a; }, function (v) { return $01b401968094f1fb$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $01b401968094f1fb$export$33ee1acdc04fd2a2; }, function (v) { return $01b401968094f1fb$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $01b401968094f1fb$export$b00a404bbd5edef2; }, function (v) { return $01b401968094f1fb$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $01b401968094f1fb$export$8352ce38b91d0c62; }, function (v) { return $01b401968094f1fb$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $01b401968094f1fb$export$d66a1c1c77bd778b; }, function (v) { return $01b401968094f1fb$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $01b401968094f1fb$export$d3dfb8e4810cb555; }, function (v) { return $01b401968094f1fb$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $01b401968094f1fb$export$839f9183b0465a69; }, function (v) { return $01b401968094f1fb$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $01b401968094f1fb$export$72fdf0e06517287b; }, function (v) { return $01b401968094f1fb$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $01b401968094f1fb$export$4b844e58a3e414b4; }, function (v) { return $01b401968094f1fb$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $01b401968094f1fb$export$816d2913ae6b83b1; }, function (v) { return $01b401968094f1fb$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $01b401968094f1fb$export$61bcfe829111a1d0; }, function (v) { return $01b401968094f1fb$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $01b401968094f1fb$export$7ee8c9beb337bc3f; }, function (v) { return $01b401968094f1fb$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $01b401968094f1fb$export$b5836b71941fa3ed; }, function (v) { return $01b401968094f1fb$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $01b401968094f1fb$export$cf845f2c119da08a; }, function (v) { return $01b401968094f1fb$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $01b401968094f1fb$export$c4744153514ff05d;
var $01b401968094f1fb$export$3e506c1ccc9cc1a7;
var $01b401968094f1fb$export$e26fe2ed2fa76875;
var $01b401968094f1fb$export$502329bbf4b505b1;
var $01b401968094f1fb$export$6e3807111c4874c4;
var $01b401968094f1fb$export$c27134553091fb3a;
var $01b401968094f1fb$export$33ee1acdc04fd2a2;
var $01b401968094f1fb$export$b00a404bbd5edef2;
var $01b401968094f1fb$export$8352ce38b91d0c62;
var $01b401968094f1fb$export$d66a1c1c77bd778b;
var $01b401968094f1fb$export$d3dfb8e4810cb555;
var $01b401968094f1fb$export$839f9183b0465a69;
var $01b401968094f1fb$export$72fdf0e06517287b;
var $01b401968094f1fb$export$4b844e58a3e414b4;
var $01b401968094f1fb$export$816d2913ae6b83b1;
var $01b401968094f1fb$export$61bcfe829111a1d0;
var $01b401968094f1fb$export$7ee8c9beb337bc3f;
var $01b401968094f1fb$export$b5836b71941fa3ed;
var $01b401968094f1fb$export$cf845f2c119da08a;
"use strict";
function $01b401968094f1fb$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $01b401968094f1fb$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $01b401968094f1fb$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $01b401968094f1fb$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $01b401968094f1fb$var$g(C, c)) n < e && 0 > $01b401968094f1fb$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $01b401968094f1fb$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $01b401968094f1fb$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $01b401968094f1fb$var$l = performance;
    $01b401968094f1fb$export$c4744153514ff05d = function() {
        return $01b401968094f1fb$var$l.now();
    };
} else {
    var $01b401968094f1fb$var$p = Date, $01b401968094f1fb$var$q = $01b401968094f1fb$var$p.now();
    $01b401968094f1fb$export$c4744153514ff05d = function() {
        return $01b401968094f1fb$var$p.now() - $01b401968094f1fb$var$q;
    };
}
var $01b401968094f1fb$var$r = [], $01b401968094f1fb$var$t = [], $01b401968094f1fb$var$u = 1, $01b401968094f1fb$var$v = null, $01b401968094f1fb$var$y = 3, $01b401968094f1fb$var$z = !1, $01b401968094f1fb$var$A = !1, $01b401968094f1fb$var$B = !1, $01b401968094f1fb$var$D = "function" === typeof setTimeout ? setTimeout : null, $01b401968094f1fb$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $01b401968094f1fb$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $01b401968094f1fb$var$G(a) {
    for(var b = $01b401968094f1fb$var$h($01b401968094f1fb$var$t); null !== b;){
        if (null === b.callback) $01b401968094f1fb$var$k($01b401968094f1fb$var$t);
        else if (b.startTime <= a) $01b401968094f1fb$var$k($01b401968094f1fb$var$t), b.sortIndex = b.expirationTime, $01b401968094f1fb$var$f($01b401968094f1fb$var$r, b);
        else break;
        b = $01b401968094f1fb$var$h($01b401968094f1fb$var$t);
    }
}
function $01b401968094f1fb$var$H(a) {
    $01b401968094f1fb$var$B = !1;
    $01b401968094f1fb$var$G(a);
    if (!$01b401968094f1fb$var$A) {
        if (null !== $01b401968094f1fb$var$h($01b401968094f1fb$var$r)) $01b401968094f1fb$var$A = !0, $01b401968094f1fb$var$I($01b401968094f1fb$var$J);
        else {
            var b = $01b401968094f1fb$var$h($01b401968094f1fb$var$t);
            null !== b && $01b401968094f1fb$var$K($01b401968094f1fb$var$H, b.startTime - a);
        }
    }
}
function $01b401968094f1fb$var$J(a, b) {
    $01b401968094f1fb$var$A = !1;
    $01b401968094f1fb$var$B && ($01b401968094f1fb$var$B = !1, $01b401968094f1fb$var$E($01b401968094f1fb$var$L), $01b401968094f1fb$var$L = -1);
    $01b401968094f1fb$var$z = !0;
    var c = $01b401968094f1fb$var$y;
    try {
        $01b401968094f1fb$var$G(b);
        for($01b401968094f1fb$var$v = $01b401968094f1fb$var$h($01b401968094f1fb$var$r); null !== $01b401968094f1fb$var$v && (!($01b401968094f1fb$var$v.expirationTime > b) || a && !$01b401968094f1fb$var$M());){
            var d = $01b401968094f1fb$var$v.callback;
            if ("function" === typeof d) {
                $01b401968094f1fb$var$v.callback = null;
                $01b401968094f1fb$var$y = $01b401968094f1fb$var$v.priorityLevel;
                var e = d($01b401968094f1fb$var$v.expirationTime <= b);
                b = $01b401968094f1fb$export$c4744153514ff05d();
                "function" === typeof e ? $01b401968094f1fb$var$v.callback = e : $01b401968094f1fb$var$v === $01b401968094f1fb$var$h($01b401968094f1fb$var$r) && $01b401968094f1fb$var$k($01b401968094f1fb$var$r);
                $01b401968094f1fb$var$G(b);
            } else $01b401968094f1fb$var$k($01b401968094f1fb$var$r);
            $01b401968094f1fb$var$v = $01b401968094f1fb$var$h($01b401968094f1fb$var$r);
        }
        if (null !== $01b401968094f1fb$var$v) var w = !0;
        else {
            var m = $01b401968094f1fb$var$h($01b401968094f1fb$var$t);
            null !== m && $01b401968094f1fb$var$K($01b401968094f1fb$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $01b401968094f1fb$var$v = null, $01b401968094f1fb$var$y = c, $01b401968094f1fb$var$z = !1;
    }
}
var $01b401968094f1fb$var$N = !1, $01b401968094f1fb$var$O = null, $01b401968094f1fb$var$L = -1, $01b401968094f1fb$var$P = 5, $01b401968094f1fb$var$Q = -1;
function $01b401968094f1fb$var$M() {
    return $01b401968094f1fb$export$c4744153514ff05d() - $01b401968094f1fb$var$Q < $01b401968094f1fb$var$P ? !1 : !0;
}
function $01b401968094f1fb$var$R() {
    if (null !== $01b401968094f1fb$var$O) {
        var a = $01b401968094f1fb$export$c4744153514ff05d();
        $01b401968094f1fb$var$Q = a;
        var b = !0;
        try {
            b = $01b401968094f1fb$var$O(!0, a);
        } finally{
            b ? $01b401968094f1fb$var$S() : ($01b401968094f1fb$var$N = !1, $01b401968094f1fb$var$O = null);
        }
    } else $01b401968094f1fb$var$N = !1;
}
var $01b401968094f1fb$var$S;
if ("function" === typeof $01b401968094f1fb$var$F) $01b401968094f1fb$var$S = function() {
    $01b401968094f1fb$var$F($01b401968094f1fb$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $01b401968094f1fb$var$T = new MessageChannel, $01b401968094f1fb$var$U = $01b401968094f1fb$var$T.port2;
    $01b401968094f1fb$var$T.port1.onmessage = $01b401968094f1fb$var$R;
    $01b401968094f1fb$var$S = function() {
        $01b401968094f1fb$var$U.postMessage(null);
    };
} else $01b401968094f1fb$var$S = function() {
    $01b401968094f1fb$var$D($01b401968094f1fb$var$R, 0);
};
function $01b401968094f1fb$var$I(a) {
    $01b401968094f1fb$var$O = a;
    $01b401968094f1fb$var$N || ($01b401968094f1fb$var$N = !0, $01b401968094f1fb$var$S());
}
function $01b401968094f1fb$var$K(a, b) {
    $01b401968094f1fb$var$L = $01b401968094f1fb$var$D(function() {
        a($01b401968094f1fb$export$c4744153514ff05d());
    }, b);
}
$01b401968094f1fb$export$3e506c1ccc9cc1a7 = 5;
$01b401968094f1fb$export$e26fe2ed2fa76875 = 1;
$01b401968094f1fb$export$502329bbf4b505b1 = 4;
$01b401968094f1fb$export$6e3807111c4874c4 = 3;
$01b401968094f1fb$export$c27134553091fb3a = null;
$01b401968094f1fb$export$33ee1acdc04fd2a2 = 2;
$01b401968094f1fb$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$01b401968094f1fb$export$8352ce38b91d0c62 = function() {
    $01b401968094f1fb$var$A || $01b401968094f1fb$var$z || ($01b401968094f1fb$var$A = !0, $01b401968094f1fb$var$I($01b401968094f1fb$var$J));
};
$01b401968094f1fb$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $01b401968094f1fb$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$01b401968094f1fb$export$d3dfb8e4810cb555 = function() {
    return $01b401968094f1fb$var$y;
};
$01b401968094f1fb$export$839f9183b0465a69 = function() {
    return $01b401968094f1fb$var$h($01b401968094f1fb$var$r);
};
$01b401968094f1fb$export$72fdf0e06517287b = function(a) {
    switch($01b401968094f1fb$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $01b401968094f1fb$var$y;
    }
    var c = $01b401968094f1fb$var$y;
    $01b401968094f1fb$var$y = b;
    try {
        return a();
    } finally{
        $01b401968094f1fb$var$y = c;
    }
};
$01b401968094f1fb$export$4b844e58a3e414b4 = function() {};
$01b401968094f1fb$export$816d2913ae6b83b1 = function() {};
$01b401968094f1fb$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $01b401968094f1fb$var$y;
    $01b401968094f1fb$var$y = a;
    try {
        return b();
    } finally{
        $01b401968094f1fb$var$y = c;
    }
};
$01b401968094f1fb$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $01b401968094f1fb$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $01b401968094f1fb$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $01b401968094f1fb$var$f($01b401968094f1fb$var$t, a), null === $01b401968094f1fb$var$h($01b401968094f1fb$var$r) && a === $01b401968094f1fb$var$h($01b401968094f1fb$var$t) && ($01b401968094f1fb$var$B ? ($01b401968094f1fb$var$E($01b401968094f1fb$var$L), $01b401968094f1fb$var$L = -1) : $01b401968094f1fb$var$B = !0, $01b401968094f1fb$var$K($01b401968094f1fb$var$H, c - d))) : (a.sortIndex = e, $01b401968094f1fb$var$f($01b401968094f1fb$var$r, a), $01b401968094f1fb$var$A || $01b401968094f1fb$var$z || ($01b401968094f1fb$var$A = !0, $01b401968094f1fb$var$I($01b401968094f1fb$var$J)));
    return a;
};
$01b401968094f1fb$export$b5836b71941fa3ed = $01b401968094f1fb$var$M;
$01b401968094f1fb$export$cf845f2c119da08a = function(a) {
    var b = $01b401968094f1fb$var$y;
    return function() {
        var c = $01b401968094f1fb$var$y;
        $01b401968094f1fb$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $01b401968094f1fb$var$y = c;
        }
    };
};

});




parcelRequire.register("c1WUa", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $8c2345510dca2d5a$export$2b8d127b894957b9; }, function (v) { return $8c2345510dca2d5a$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $8c2345510dca2d5a$export$cea3a54a6425200c; }, function (v) { return $8c2345510dca2d5a$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $8c2345510dca2d5a$export$a7c73072b1a182ae; }, function (v) { return $8c2345510dca2d5a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8c2345510dca2d5a$export$9f27bc3417b4524d; }, function (v) { return $8c2345510dca2d5a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8c2345510dca2d5a$export$db77ccec0bb4ccac; }, function (v) { return $8c2345510dca2d5a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8c2345510dca2d5a$export$8392c0c9d3dcbd35; }, function (v) { return $8c2345510dca2d5a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8c2345510dca2d5a$export$ffb0004e005737fa; }, function (v) { return $8c2345510dca2d5a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8c2345510dca2d5a$export$b624eff549462981; }, function (v) { return $8c2345510dca2d5a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8c2345510dca2d5a$export$7897aa7841a5380c; }, function (v) { return $8c2345510dca2d5a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8c2345510dca2d5a$export$602eac185826482c; }, function (v) { return $8c2345510dca2d5a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8c2345510dca2d5a$export$e2c29f18771995cb; }, function (v) { return $8c2345510dca2d5a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8c2345510dca2d5a$export$5f8d39834fd61797; }, function (v) { return $8c2345510dca2d5a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8c2345510dca2d5a$export$74bf444e3cd11ea5; }, function (v) { return $8c2345510dca2d5a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8c2345510dca2d5a$export$92387174baf9b227; }, function (v) { return $8c2345510dca2d5a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8c2345510dca2d5a$export$ec112efeb987d9c6; }, function (v) { return $8c2345510dca2d5a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8c2345510dca2d5a$export$b706b080d889d2c9; }, function (v) { return $8c2345510dca2d5a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8c2345510dca2d5a$export$5be5a87408f70ddc; }, function (v) { return $8c2345510dca2d5a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8c2345510dca2d5a$export$45a5e7f76e0caa8d; }, function (v) { return $8c2345510dca2d5a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8c2345510dca2d5a$export$455c2e768291efa6; }, function (v) { return $8c2345510dca2d5a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8c2345510dca2d5a$export$9522e17588c12572; }, function (v) { return $8c2345510dca2d5a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8c2345510dca2d5a$export$2110ac352bb060b9; }, function (v) { return $8c2345510dca2d5a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8c2345510dca2d5a$export$56885ab8b9c456ab; }, function (v) { return $8c2345510dca2d5a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8c2345510dca2d5a$export$d927fcb6adf8f9de; }, function (v) { return $8c2345510dca2d5a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8c2345510dca2d5a$export$b82d16f27459e05a; }, function (v) { return $8c2345510dca2d5a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8c2345510dca2d5a$export$522c17b4f5e123e8; }, function (v) { return $8c2345510dca2d5a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8c2345510dca2d5a$export$1aabd8a0274ecfd6; }, function (v) { return $8c2345510dca2d5a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8c2345510dca2d5a$export$9b621391a187a31a; }, function (v) { return $8c2345510dca2d5a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8c2345510dca2d5a$export$f5bbd400c2f4426f; }, function (v) { return $8c2345510dca2d5a$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8c2345510dca2d5a$export$2b8d127b894957b9;
var $8c2345510dca2d5a$export$cea3a54a6425200c;
var $8c2345510dca2d5a$export$a7c73072b1a182ae;
var $8c2345510dca2d5a$export$9f27bc3417b4524d;
var $8c2345510dca2d5a$export$db77ccec0bb4ccac;
var $8c2345510dca2d5a$export$8392c0c9d3dcbd35;
var $8c2345510dca2d5a$export$ffb0004e005737fa;
var $8c2345510dca2d5a$export$b624eff549462981;
var $8c2345510dca2d5a$export$7897aa7841a5380c;
var $8c2345510dca2d5a$export$602eac185826482c;
var $8c2345510dca2d5a$export$e2c29f18771995cb;
var $8c2345510dca2d5a$export$5f8d39834fd61797;
var $8c2345510dca2d5a$export$74bf444e3cd11ea5;
var $8c2345510dca2d5a$export$92387174baf9b227;
var $8c2345510dca2d5a$export$ec112efeb987d9c6;
var $8c2345510dca2d5a$export$b706b080d889d2c9;
var $8c2345510dca2d5a$export$5be5a87408f70ddc;
var $8c2345510dca2d5a$export$45a5e7f76e0caa8d;
var $8c2345510dca2d5a$export$455c2e768291efa6;
var $8c2345510dca2d5a$export$9522e17588c12572;
var $8c2345510dca2d5a$export$2110ac352bb060b9;
var $8c2345510dca2d5a$export$56885ab8b9c456ab;
var $8c2345510dca2d5a$export$d927fcb6adf8f9de;
var $8c2345510dca2d5a$export$b82d16f27459e05a;
var $8c2345510dca2d5a$export$522c17b4f5e123e8;
var $8c2345510dca2d5a$export$1aabd8a0274ecfd6;
var $8c2345510dca2d5a$export$9b621391a187a31a;
var $8c2345510dca2d5a$export$f5bbd400c2f4426f;
"use strict";
var $8c2345510dca2d5a$var$b = "function" === typeof Symbol && Symbol.for, $8c2345510dca2d5a$var$c = $8c2345510dca2d5a$var$b ? Symbol.for("react.element") : 60103, $8c2345510dca2d5a$var$d = $8c2345510dca2d5a$var$b ? Symbol.for("react.portal") : 60106, $8c2345510dca2d5a$var$e = $8c2345510dca2d5a$var$b ? Symbol.for("react.fragment") : 60107, $8c2345510dca2d5a$var$f = $8c2345510dca2d5a$var$b ? Symbol.for("react.strict_mode") : 60108, $8c2345510dca2d5a$var$g = $8c2345510dca2d5a$var$b ? Symbol.for("react.profiler") : 60114, $8c2345510dca2d5a$var$h = $8c2345510dca2d5a$var$b ? Symbol.for("react.provider") : 60109, $8c2345510dca2d5a$var$k = $8c2345510dca2d5a$var$b ? Symbol.for("react.context") : 60110, $8c2345510dca2d5a$var$l = $8c2345510dca2d5a$var$b ? Symbol.for("react.async_mode") : 60111, $8c2345510dca2d5a$var$m = $8c2345510dca2d5a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8c2345510dca2d5a$var$n = $8c2345510dca2d5a$var$b ? Symbol.for("react.forward_ref") : 60112, $8c2345510dca2d5a$var$p = $8c2345510dca2d5a$var$b ? Symbol.for("react.suspense") : 60113, $8c2345510dca2d5a$var$q = $8c2345510dca2d5a$var$b ? Symbol.for("react.suspense_list") : 60120, $8c2345510dca2d5a$var$r = $8c2345510dca2d5a$var$b ? Symbol.for("react.memo") : 60115, $8c2345510dca2d5a$var$t = $8c2345510dca2d5a$var$b ? Symbol.for("react.lazy") : 60116, $8c2345510dca2d5a$var$v = $8c2345510dca2d5a$var$b ? Symbol.for("react.block") : 60121, $8c2345510dca2d5a$var$w = $8c2345510dca2d5a$var$b ? Symbol.for("react.fundamental") : 60117, $8c2345510dca2d5a$var$x = $8c2345510dca2d5a$var$b ? Symbol.for("react.responder") : 60118, $8c2345510dca2d5a$var$y = $8c2345510dca2d5a$var$b ? Symbol.for("react.scope") : 60119;
function $8c2345510dca2d5a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8c2345510dca2d5a$var$c:
                switch(a = a.type, a){
                    case $8c2345510dca2d5a$var$l:
                    case $8c2345510dca2d5a$var$m:
                    case $8c2345510dca2d5a$var$e:
                    case $8c2345510dca2d5a$var$g:
                    case $8c2345510dca2d5a$var$f:
                    case $8c2345510dca2d5a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8c2345510dca2d5a$var$k:
                            case $8c2345510dca2d5a$var$n:
                            case $8c2345510dca2d5a$var$t:
                            case $8c2345510dca2d5a$var$r:
                            case $8c2345510dca2d5a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8c2345510dca2d5a$var$d:
                return u;
        }
    }
}
function $8c2345510dca2d5a$var$A(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$m;
}
$8c2345510dca2d5a$export$2b8d127b894957b9 = $8c2345510dca2d5a$var$l;
$8c2345510dca2d5a$export$cea3a54a6425200c = $8c2345510dca2d5a$var$m;
$8c2345510dca2d5a$export$a7c73072b1a182ae = $8c2345510dca2d5a$var$k;
$8c2345510dca2d5a$export$9f27bc3417b4524d = $8c2345510dca2d5a$var$h;
$8c2345510dca2d5a$export$db77ccec0bb4ccac = $8c2345510dca2d5a$var$c;
$8c2345510dca2d5a$export$8392c0c9d3dcbd35 = $8c2345510dca2d5a$var$n;
$8c2345510dca2d5a$export$ffb0004e005737fa = $8c2345510dca2d5a$var$e;
$8c2345510dca2d5a$export$b624eff549462981 = $8c2345510dca2d5a$var$t;
$8c2345510dca2d5a$export$7897aa7841a5380c = $8c2345510dca2d5a$var$r;
$8c2345510dca2d5a$export$602eac185826482c = $8c2345510dca2d5a$var$d;
$8c2345510dca2d5a$export$e2c29f18771995cb = $8c2345510dca2d5a$var$g;
$8c2345510dca2d5a$export$5f8d39834fd61797 = $8c2345510dca2d5a$var$f;
$8c2345510dca2d5a$export$74bf444e3cd11ea5 = $8c2345510dca2d5a$var$p;
$8c2345510dca2d5a$export$92387174baf9b227 = function(a) {
    return $8c2345510dca2d5a$var$A(a) || $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$l;
};
$8c2345510dca2d5a$export$ec112efeb987d9c6 = $8c2345510dca2d5a$var$A;
$8c2345510dca2d5a$export$b706b080d889d2c9 = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$k;
};
$8c2345510dca2d5a$export$5be5a87408f70ddc = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$h;
};
$8c2345510dca2d5a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8c2345510dca2d5a$var$c;
};
$8c2345510dca2d5a$export$455c2e768291efa6 = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$n;
};
$8c2345510dca2d5a$export$9522e17588c12572 = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$e;
};
$8c2345510dca2d5a$export$2110ac352bb060b9 = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$t;
};
$8c2345510dca2d5a$export$56885ab8b9c456ab = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$r;
};
$8c2345510dca2d5a$export$d927fcb6adf8f9de = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$d;
};
$8c2345510dca2d5a$export$b82d16f27459e05a = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$g;
};
$8c2345510dca2d5a$export$522c17b4f5e123e8 = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$f;
};
$8c2345510dca2d5a$export$1aabd8a0274ecfd6 = function(a) {
    return $8c2345510dca2d5a$var$z(a) === $8c2345510dca2d5a$var$p;
};
$8c2345510dca2d5a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8c2345510dca2d5a$var$e || a === $8c2345510dca2d5a$var$m || a === $8c2345510dca2d5a$var$g || a === $8c2345510dca2d5a$var$f || a === $8c2345510dca2d5a$var$p || a === $8c2345510dca2d5a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8c2345510dca2d5a$var$t || a.$$typeof === $8c2345510dca2d5a$var$r || a.$$typeof === $8c2345510dca2d5a$var$h || a.$$typeof === $8c2345510dca2d5a$var$k || a.$$typeof === $8c2345510dca2d5a$var$n || a.$$typeof === $8c2345510dca2d5a$var$w || a.$$typeof === $8c2345510dca2d5a$var$x || a.$$typeof === $8c2345510dca2d5a$var$y || a.$$typeof === $8c2345510dca2d5a$var$v);
};
$8c2345510dca2d5a$export$f5bbd400c2f4426f = $8c2345510dca2d5a$var$z;

});

parcelRequire.register("houiY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ca9c2f815de9b9eb$var$ReactIs, $ca9c2f815de9b9eb$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jAiiq"))();

});
parcelRequire.register("jAiiq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kXOqC = parcelRequire("kXOqC");
function $e41f92604a127bd3$var$emptyFunction() {}
function $e41f92604a127bd3$var$emptyFunctionWithReset() {}
$e41f92604a127bd3$var$emptyFunctionWithReset.resetWarningCache = $e41f92604a127bd3$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kXOqC) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e41f92604a127bd3$var$emptyFunctionWithReset,
        resetWarningCache: $e41f92604a127bd3$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("kXOqC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4306f556546cee4$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4306f556546cee4$var$ReactPropTypesSecret;

});



parcelRequire.register("60Olm", function(module, exports) {

var $50pTR = parcelRequire("50pTR");

var $ekgYL = parcelRequire("ekgYL");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $50pTR.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $ekgYL;
module.exports = isBuffer;

});
parcelRequire.register("50pTR", function(module, exports) {

var $1EQBB = parcelRequire("1EQBB");
/** Detect free variable `self`. */ var $3a510b02a870bde7$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3a510b02a870bde7$var$root = $1EQBB || $3a510b02a870bde7$var$freeSelf || Function("return this")();
module.exports = $3a510b02a870bde7$var$root;

});
parcelRequire.register("1EQBB", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $1352553970f3f1a5$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $1352553970f3f1a5$var$freeGlobal;

});


parcelRequire.register("ekgYL", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $a6e01a9da3d07ff1$var$stubFalse() {
    return false;
}
module.exports = $a6e01a9da3d07ff1$var$stubFalse;

});


parcelRequire.register("5ETmX", function(module, exports) {

var $1EQBB = parcelRequire("1EQBB");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $1EQBB.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("dSjZP", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("bP6ao"));

});
parcelRequire.register("bP6ao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $cSuv3.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $cSuv3.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $4EK34.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $4EK34.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $cxn9F.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $cxn9F.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $cxn9F.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $cxn9F.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $89b93dafdace3de6$var$_symbol.symbolsStroke;
    }
});

var $89b93dafdace3de6$var$_arc = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("9xoPZ")));

var $89b93dafdace3de6$var$_area = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("4DZbS")));

var $89b93dafdace3de6$var$_line = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("eYXZI")));

var $89b93dafdace3de6$var$_pie = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("4k4NZ")));

var $89b93dafdace3de6$var$_areaRadial = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("ljvbD")));

var $89b93dafdace3de6$var$_lineRadial = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("hx1Xa")));

var $89b93dafdace3de6$var$_pointRadial = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("4uLtL")));

var $cxn9F = parcelRequire("cxn9F");

var $89b93dafdace3de6$var$_symbol = $89b93dafdace3de6$var$_interopRequireWildcard((parcelRequire("1OQiZ")));

var $89b93dafdace3de6$var$_asterisk = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("2elpY")));

var $89b93dafdace3de6$var$_circle = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("xTwUK")));

var $89b93dafdace3de6$var$_cross = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("cnWLE")));

var $89b93dafdace3de6$var$_diamond = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("8zZjJ")));

var $89b93dafdace3de6$var$_diamond2 = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("7Vv6q")));

var $89b93dafdace3de6$var$_plus = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("41ZKX")));

var $89b93dafdace3de6$var$_square = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("3jSv1")));

var $89b93dafdace3de6$var$_square2 = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("bTfxV")));

var $89b93dafdace3de6$var$_star = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("c4zmK")));

var $89b93dafdace3de6$var$_triangle = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("fPQqf")));

var $89b93dafdace3de6$var$_triangle2 = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("8Vxb5")));

var $89b93dafdace3de6$var$_wye = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("51A2u")));

var $89b93dafdace3de6$var$_x = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("8wBWG")));

var $89b93dafdace3de6$var$_basisClosed = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("aZ5yj")));

var $89b93dafdace3de6$var$_basisOpen = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("790qp")));

var $89b93dafdace3de6$var$_basis = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("dOjLk")));

var $cSuv3 = parcelRequire("cSuv3");

var $89b93dafdace3de6$var$_bundle = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("5q3eE")));

var $89b93dafdace3de6$var$_cardinalClosed = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("jREwA")));

var $89b93dafdace3de6$var$_cardinalOpen = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("5uJfB")));

var $89b93dafdace3de6$var$_cardinal = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("dmJ8m")));

var $89b93dafdace3de6$var$_catmullRomClosed = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("avrFd")));

var $89b93dafdace3de6$var$_catmullRomOpen = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("2iPCl")));

var $89b93dafdace3de6$var$_catmullRom = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("iSDo4")));

var $89b93dafdace3de6$var$_linearClosed = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("hZnWA")));

var $89b93dafdace3de6$var$_linear = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("6D0nx")));

var $4EK34 = parcelRequire("4EK34");

var $89b93dafdace3de6$var$_natural = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("iVqmn")));

var $89b93dafdace3de6$var$_step = $89b93dafdace3de6$var$_interopRequireWildcard((parcelRequire("7KOnK")));

var $89b93dafdace3de6$var$_stack = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("2aviL")));

var $89b93dafdace3de6$var$_expand = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("gAXuO")));

var $89b93dafdace3de6$var$_diverging = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("am9Jl")));

var $89b93dafdace3de6$var$_none = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("jgzyF")));

var $89b93dafdace3de6$var$_silhouette = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("8RXiW")));

var $89b93dafdace3de6$var$_wiggle = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("hKtlx")));

var $89b93dafdace3de6$var$_appearance = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("bYQ6X")));

var $89b93dafdace3de6$var$_ascending = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("qSxmF")));

var $89b93dafdace3de6$var$_descending = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("2YNAK")));

var $89b93dafdace3de6$var$_insideOut = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("llAou")));

var $89b93dafdace3de6$var$_none2 = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("5btUU")));

var $89b93dafdace3de6$var$_reverse = $89b93dafdace3de6$var$_interopRequireDefault((parcelRequire("kuVkT")));
function $89b93dafdace3de6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($89b93dafdace3de6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $89b93dafdace3de6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $89b93dafdace3de6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $89b93dafdace3de6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("9xoPZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f1a765907c0af0f$var$_default;

var $9DWR8 = parcelRequire("9DWR8");

var $6f1a765907c0af0f$var$_constant = $6f1a765907c0af0f$var$_interopRequireDefault((parcelRequire("gjOZe")));

var $6NP0o = parcelRequire("6NP0o");
function $6f1a765907c0af0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f1a765907c0af0f$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $6f1a765907c0af0f$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $6f1a765907c0af0f$var$arcStartAngle(d) {
    return d.startAngle;
}
function $6f1a765907c0af0f$var$arcEndAngle(d) {
    return d.endAngle;
}
function $6f1a765907c0af0f$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $6f1a765907c0af0f$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $6NP0o.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $6f1a765907c0af0f$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $6NP0o.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $6NP0o.sqrt)((0, $6NP0o.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $6f1a765907c0af0f$var$_default() {
    var innerRadius = $6f1a765907c0af0f$var$arcInnerRadius, outerRadius = $6f1a765907c0af0f$var$arcOuterRadius, cornerRadius = (0, $6f1a765907c0af0f$var$_constant.default)(0), padRadius = null, startAngle = $6f1a765907c0af0f$var$arcStartAngle, endAngle = $6f1a765907c0af0f$var$arcEndAngle, padAngle = $6f1a765907c0af0f$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $6NP0o.halfPi, a1 = endAngle.apply(this, arguments) - $6NP0o.halfPi, da = (0, $6NP0o.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $9DWR8.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $6NP0o.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $6NP0o.tau - $6NP0o.epsilon) {
            context.moveTo(r1 * (0, $6NP0o.cos)(a0), r1 * (0, $6NP0o.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $6NP0o.epsilon) {
                context.moveTo(r0 * (0, $6NP0o.cos)(a1), r0 * (0, $6NP0o.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $6NP0o.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $6NP0o.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $6NP0o.min)((0, $6NP0o.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $6NP0o.epsilon) {
                var p0 = (0, $6NP0o.asin)(rp / r0 * (0, $6NP0o.sin)(ap)), p1 = (0, $6NP0o.asin)(rp / r1 * (0, $6NP0o.sin)(ap));
                if ((da0 -= p0 * 2) > $6NP0o.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $6NP0o.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $6NP0o.cos)(a01), y01 = r1 * (0, $6NP0o.sin)(a01), x10 = r0 * (0, $6NP0o.cos)(a10), y10 = r0 * (0, $6NP0o.sin)(a10); // Apply rounded corners?
            if (rc > $6NP0o.epsilon) {
                var x11 = r1 * (0, $6NP0o.cos)(a11), y11 = r1 * (0, $6NP0o.sin)(a11), x00 = r0 * (0, $6NP0o.cos)(a00), y00 = r0 * (0, $6NP0o.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $6NP0o.pi && (oc = $6f1a765907c0af0f$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $6NP0o.sin)((0, $6NP0o.acos)((ax * bx + ay * by) / ((0, $6NP0o.sqrt)(ax * ax + ay * ay) * (0, $6NP0o.sqrt)(bx * bx + by * by))) / 2), lc = (0, $6NP0o.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $6NP0o.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $6NP0o.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $6NP0o.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $6NP0o.epsilon) {
                t0 = $6f1a765907c0af0f$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $6f1a765907c0af0f$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $6NP0o.atan2)(t0.y01, t0.x01), (0, $6NP0o.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $6NP0o.atan2)(t0.y01, t0.x01), (0, $6NP0o.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $6NP0o.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $6NP0o.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $6NP0o.atan2)(t1.y11, t1.x11), (0, $6NP0o.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $6NP0o.epsilon) || !(da0 > $6NP0o.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $6NP0o.epsilon) {
                t0 = $6f1a765907c0af0f$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $6f1a765907c0af0f$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $6NP0o.atan2)(t0.y01, t0.x01), (0, $6NP0o.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $6NP0o.atan2)(t0.y01, t0.x01), (0, $6NP0o.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $6NP0o.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $6NP0o.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $6NP0o.atan2)(t1.y11, t1.x11), (0, $6NP0o.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $6NP0o.pi / 2;
        return [
            (0, $6NP0o.cos)(a) * r,
            (0, $6NP0o.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $6f1a765907c0af0f$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $6f1a765907c0af0f$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $6f1a765907c0af0f$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $6f1a765907c0af0f$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $6f1a765907c0af0f$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $6f1a765907c0af0f$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $6f1a765907c0af0f$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRequire.register("9DWR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $70556922ff2d2cf1$var$_path.default;
    }
});

var $70556922ff2d2cf1$var$_path = $70556922ff2d2cf1$var$_interopRequireDefault((parcelRequire("dj91a")));
function $70556922ff2d2cf1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("dj91a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9b040b7908a7d9f2$var$pi = Math.PI, $9b040b7908a7d9f2$var$tau = 2 * $9b040b7908a7d9f2$var$pi, $9b040b7908a7d9f2$var$epsilon = 1e-6, $9b040b7908a7d9f2$var$tauEpsilon = $9b040b7908a7d9f2$var$tau - $9b040b7908a7d9f2$var$epsilon;
function $9b040b7908a7d9f2$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $9b040b7908a7d9f2$var$path() {
    return new $9b040b7908a7d9f2$var$Path();
}
$9b040b7908a7d9f2$var$Path.prototype = $9b040b7908a7d9f2$var$path.prototype = {
    constructor: $9b040b7908a7d9f2$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $9b040b7908a7d9f2$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $9b040b7908a7d9f2$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($9b040b7908a7d9f2$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $9b040b7908a7d9f2$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $9b040b7908a7d9f2$var$epsilon || Math.abs(this._y1 - y0) > $9b040b7908a7d9f2$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $9b040b7908a7d9f2$var$tau + $9b040b7908a7d9f2$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $9b040b7908a7d9f2$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $9b040b7908a7d9f2$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $9b040b7908a7d9f2$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $9b040b7908a7d9f2$var$_default = $9b040b7908a7d9f2$var$path;
module.exports.default = $9b040b7908a7d9f2$var$_default;

});


parcelRequire.register("gjOZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be15f88cf076327b$var$_default;
function $be15f88cf076327b$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRequire.register("6NP0o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $4f3ee241b166566d$var$acos;
module.exports.asin = $4f3ee241b166566d$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $4f3ee241b166566d$var$abs = Math.abs;
module.exports.abs = $4f3ee241b166566d$var$abs;
const $4f3ee241b166566d$var$atan2 = Math.atan2;
module.exports.atan2 = $4f3ee241b166566d$var$atan2;
const $4f3ee241b166566d$var$cos = Math.cos;
module.exports.cos = $4f3ee241b166566d$var$cos;
const $4f3ee241b166566d$var$max = Math.max;
module.exports.max = $4f3ee241b166566d$var$max;
const $4f3ee241b166566d$var$min = Math.min;
module.exports.min = $4f3ee241b166566d$var$min;
const $4f3ee241b166566d$var$sin = Math.sin;
module.exports.sin = $4f3ee241b166566d$var$sin;
const $4f3ee241b166566d$var$sqrt = Math.sqrt;
module.exports.sqrt = $4f3ee241b166566d$var$sqrt;
const $4f3ee241b166566d$var$epsilon = 1e-12;
module.exports.epsilon = $4f3ee241b166566d$var$epsilon;
const $4f3ee241b166566d$var$pi = Math.PI;
module.exports.pi = $4f3ee241b166566d$var$pi;
const $4f3ee241b166566d$var$halfPi = $4f3ee241b166566d$var$pi / 2;
module.exports.halfPi = $4f3ee241b166566d$var$halfPi;
const $4f3ee241b166566d$var$tau = 2 * $4f3ee241b166566d$var$pi;
module.exports.tau = $4f3ee241b166566d$var$tau;
function $4f3ee241b166566d$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $4f3ee241b166566d$var$pi : Math.acos(x);
}
function $4f3ee241b166566d$var$asin(x) {
    return x >= 1 ? $4f3ee241b166566d$var$halfPi : x <= -1 ? -$4f3ee241b166566d$var$halfPi : Math.asin(x);
}

});


parcelRequire.register("4DZbS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $361a451a76825106$var$_default;

var $9DWR8 = parcelRequire("9DWR8");

var $361a451a76825106$var$_array = $361a451a76825106$var$_interopRequireDefault((parcelRequire("9YFrt")));

var $361a451a76825106$var$_constant = $361a451a76825106$var$_interopRequireDefault((parcelRequire("gjOZe")));

var $361a451a76825106$var$_linear = $361a451a76825106$var$_interopRequireDefault((parcelRequire("6D0nx")));

var $361a451a76825106$var$_line = $361a451a76825106$var$_interopRequireDefault((parcelRequire("eYXZI")));

var $5jbGm = parcelRequire("5jbGm");
function $361a451a76825106$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $361a451a76825106$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $361a451a76825106$var$_constant.default)(true), context = null, curve = $361a451a76825106$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $5jbGm.x : (0, $361a451a76825106$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $361a451a76825106$var$_constant.default)(0) : (0, $361a451a76825106$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $5jbGm.y : (0, $361a451a76825106$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $361a451a76825106$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $9DWR8.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $361a451a76825106$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $361a451a76825106$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $361a451a76825106$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $361a451a76825106$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $361a451a76825106$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $361a451a76825106$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $361a451a76825106$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $361a451a76825106$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRequire.register("9YFrt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7439dd32caefc4cd$var$_default;
module.exports.slice = void 0;
var $7439dd32caefc4cd$var$slice = Array.prototype.slice;
module.exports.slice = $7439dd32caefc4cd$var$slice;
function $7439dd32caefc4cd$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRequire.register("6D0nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d36adcfbb477198$var$_default;
function $4d36adcfbb477198$var$Linear(context) {
    this._context = context;
}
$4d36adcfbb477198$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $4d36adcfbb477198$var$_default(context) {
    return new $4d36adcfbb477198$var$Linear(context);
}

});

parcelRequire.register("eYXZI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae8534eac664a34b$var$_default;

var $9DWR8 = parcelRequire("9DWR8");

var $ae8534eac664a34b$var$_array = $ae8534eac664a34b$var$_interopRequireDefault((parcelRequire("9YFrt")));

var $ae8534eac664a34b$var$_constant = $ae8534eac664a34b$var$_interopRequireDefault((parcelRequire("gjOZe")));

var $ae8534eac664a34b$var$_linear = $ae8534eac664a34b$var$_interopRequireDefault((parcelRequire("6D0nx")));

var $5jbGm = parcelRequire("5jbGm");
function $ae8534eac664a34b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae8534eac664a34b$var$_default(x, y) {
    var defined = (0, $ae8534eac664a34b$var$_constant.default)(true), context = null, curve = $ae8534eac664a34b$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $5jbGm.x : (0, $ae8534eac664a34b$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $5jbGm.y : (0, $ae8534eac664a34b$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $ae8534eac664a34b$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $9DWR8.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $ae8534eac664a34b$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $ae8534eac664a34b$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $ae8534eac664a34b$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRequire.register("5jbGm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $3dd7c9ed3354737c$var$x;
module.exports.y = $3dd7c9ed3354737c$var$y;
function $3dd7c9ed3354737c$var$x(p) {
    return p[0];
}
function $3dd7c9ed3354737c$var$y(p) {
    return p[1];
}

});



parcelRequire.register("4k4NZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $325cc1ec04f464aa$var$_default;

var $325cc1ec04f464aa$var$_array = $325cc1ec04f464aa$var$_interopRequireDefault((parcelRequire("9YFrt")));

var $325cc1ec04f464aa$var$_constant = $325cc1ec04f464aa$var$_interopRequireDefault((parcelRequire("gjOZe")));

var $325cc1ec04f464aa$var$_descending = $325cc1ec04f464aa$var$_interopRequireDefault((parcelRequire("gaZGC")));

var $325cc1ec04f464aa$var$_identity = $325cc1ec04f464aa$var$_interopRequireDefault((parcelRequire("n50Wm")));

var $6NP0o = parcelRequire("6NP0o");
function $325cc1ec04f464aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $325cc1ec04f464aa$var$_default() {
    var value = $325cc1ec04f464aa$var$_identity.default, sortValues = $325cc1ec04f464aa$var$_descending.default, sort = null, startAngle = (0, $325cc1ec04f464aa$var$_constant.default)(0), endAngle = (0, $325cc1ec04f464aa$var$_constant.default)($6NP0o.tau), padAngle = (0, $325cc1ec04f464aa$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $325cc1ec04f464aa$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($6NP0o.tau, Math.max(-$6NP0o.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $325cc1ec04f464aa$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $325cc1ec04f464aa$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $325cc1ec04f464aa$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $325cc1ec04f464aa$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRequire.register("gaZGC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc6d6e2b80c93792$var$_default;
function $bc6d6e2b80c93792$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRequire.register("n50Wm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $045609ce6b7502be$var$_default;
function $045609ce6b7502be$var$_default(d) {
    return d;
}

});


parcelRequire.register("ljvbD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8439051df8c5059$var$_default;

var $f8439051df8c5059$var$_radial = $f8439051df8c5059$var$_interopRequireWildcard((parcelRequire("2w59I")));

var $f8439051df8c5059$var$_area = $f8439051df8c5059$var$_interopRequireDefault((parcelRequire("4DZbS")));

var $hx1Xa = parcelRequire("hx1Xa");
function $f8439051df8c5059$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8439051df8c5059$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f8439051df8c5059$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f8439051df8c5059$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f8439051df8c5059$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f8439051df8c5059$var$_default() {
    var a = (0, $f8439051df8c5059$var$_area.default)().curve($f8439051df8c5059$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $hx1Xa.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $hx1Xa.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $hx1Xa.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $hx1Xa.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $f8439051df8c5059$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRequire.register("2w59I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $1d5291be5c86416a$var$curveRadial;

var $1d5291be5c86416a$var$_linear = $1d5291be5c86416a$var$_interopRequireDefault((parcelRequire("6D0nx")));
function $1d5291be5c86416a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1d5291be5c86416a$var$curveRadialLinear = $1d5291be5c86416a$var$curveRadial($1d5291be5c86416a$var$_linear.default);
module.exports.curveRadialLinear = $1d5291be5c86416a$var$curveRadialLinear;
function $1d5291be5c86416a$var$Radial(curve) {
    this._curve = curve;
}
$1d5291be5c86416a$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $1d5291be5c86416a$var$curveRadial(curve) {
    function radial(context) {
        return new $1d5291be5c86416a$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRequire.register("hx1Xa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc37089e7c947058$var$_default;
module.exports.lineRadial = $cc37089e7c947058$var$lineRadial;

var $cc37089e7c947058$var$_radial = $cc37089e7c947058$var$_interopRequireWildcard((parcelRequire("2w59I")));

var $cc37089e7c947058$var$_line = $cc37089e7c947058$var$_interopRequireDefault((parcelRequire("eYXZI")));
function $cc37089e7c947058$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cc37089e7c947058$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cc37089e7c947058$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cc37089e7c947058$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cc37089e7c947058$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cc37089e7c947058$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $cc37089e7c947058$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $cc37089e7c947058$var$_default() {
    return $cc37089e7c947058$var$lineRadial((0, $cc37089e7c947058$var$_line.default)().curve($cc37089e7c947058$var$_radial.curveRadialLinear));
}

});


parcelRequire.register("4uLtL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $345ecb1c4d2abe5b$var$_default;
function $345ecb1c4d2abe5b$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRequire.register("cxn9F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $920a8731927b59bb$var$link;
module.exports.linkHorizontal = $920a8731927b59bb$var$linkHorizontal;
module.exports.linkRadial = $920a8731927b59bb$var$linkRadial;
module.exports.linkVertical = $920a8731927b59bb$var$linkVertical;

var $9DWR8 = parcelRequire("9DWR8");

var $9YFrt = parcelRequire("9YFrt");

var $920a8731927b59bb$var$_constant = $920a8731927b59bb$var$_interopRequireDefault((parcelRequire("gjOZe")));

var $cSuv3 = parcelRequire("cSuv3");

var $5jbGm = parcelRequire("5jbGm");
function $920a8731927b59bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $920a8731927b59bb$var$linkSource(d) {
    return d.source;
}
function $920a8731927b59bb$var$linkTarget(d) {
    return d.target;
}
function $920a8731927b59bb$var$link(curve) {
    let source = $920a8731927b59bb$var$linkSource;
    let target = $920a8731927b59bb$var$linkTarget;
    let x = $5jbGm.x;
    let y = $5jbGm.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $9YFrt.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $9DWR8.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $920a8731927b59bb$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $920a8731927b59bb$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $920a8731927b59bb$var$linkHorizontal() {
    return $920a8731927b59bb$var$link($cSuv3.bumpX);
}
function $920a8731927b59bb$var$linkVertical() {
    return $920a8731927b59bb$var$link($cSuv3.bumpY);
}
function $920a8731927b59bb$var$linkRadial() {
    const l = $920a8731927b59bb$var$link($cSuv3.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRequire.register("cSuv3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $96022fd20b8d8a9a$var$bumpRadial;
module.exports.bumpX = $96022fd20b8d8a9a$var$bumpX;
module.exports.bumpY = $96022fd20b8d8a9a$var$bumpY;

var $96022fd20b8d8a9a$var$_pointRadial = $96022fd20b8d8a9a$var$_interopRequireDefault((parcelRequire("4uLtL")));
function $96022fd20b8d8a9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $96022fd20b8d8a9a$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $96022fd20b8d8a9a$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $96022fd20b8d8a9a$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $96022fd20b8d8a9a$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $96022fd20b8d8a9a$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $96022fd20b8d8a9a$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $96022fd20b8d8a9a$var$bumpX(context) {
    return new $96022fd20b8d8a9a$var$Bump(context, true);
}
function $96022fd20b8d8a9a$var$bumpY(context) {
    return new $96022fd20b8d8a9a$var$Bump(context, false);
}
function $96022fd20b8d8a9a$var$bumpRadial(context) {
    return new $96022fd20b8d8a9a$var$BumpRadial(context);
}

});


parcelRequire.register("1OQiZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $153308b23c5e78d4$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $9DWR8 = parcelRequire("9DWR8");

var $153308b23c5e78d4$var$_constant = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("gjOZe")));

var $153308b23c5e78d4$var$_asterisk = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("2elpY")));

var $153308b23c5e78d4$var$_circle = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("xTwUK")));

var $153308b23c5e78d4$var$_cross = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("cnWLE")));

var $153308b23c5e78d4$var$_diamond = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("8zZjJ")));

var $153308b23c5e78d4$var$_diamond2 = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("7Vv6q")));

var $153308b23c5e78d4$var$_plus = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("41ZKX")));

var $153308b23c5e78d4$var$_square = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("3jSv1")));

var $153308b23c5e78d4$var$_square2 = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("bTfxV")));

var $153308b23c5e78d4$var$_star = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("c4zmK")));

var $153308b23c5e78d4$var$_triangle = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("fPQqf")));

var $153308b23c5e78d4$var$_triangle2 = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("8Vxb5")));

var $153308b23c5e78d4$var$_wye = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("51A2u")));

var $153308b23c5e78d4$var$_x = $153308b23c5e78d4$var$_interopRequireDefault((parcelRequire("8wBWG")));
function $153308b23c5e78d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $153308b23c5e78d4$var$symbolsFill = [
    $153308b23c5e78d4$var$_circle.default,
    $153308b23c5e78d4$var$_cross.default,
    $153308b23c5e78d4$var$_diamond.default,
    $153308b23c5e78d4$var$_square.default,
    $153308b23c5e78d4$var$_star.default,
    $153308b23c5e78d4$var$_triangle.default,
    $153308b23c5e78d4$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $153308b23c5e78d4$var$symbolsFill;
const $153308b23c5e78d4$var$symbolsStroke = [
    $153308b23c5e78d4$var$_circle.default,
    $153308b23c5e78d4$var$_plus.default,
    $153308b23c5e78d4$var$_x.default,
    $153308b23c5e78d4$var$_triangle2.default,
    $153308b23c5e78d4$var$_asterisk.default,
    $153308b23c5e78d4$var$_square2.default,
    $153308b23c5e78d4$var$_diamond2.default
];
module.exports.symbolsStroke = $153308b23c5e78d4$var$symbolsStroke;
function $153308b23c5e78d4$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $153308b23c5e78d4$var$_constant.default)(type || $153308b23c5e78d4$var$_circle.default);
    size = typeof size === "function" ? size : (0, $153308b23c5e78d4$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $9DWR8.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $153308b23c5e78d4$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $153308b23c5e78d4$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRequire.register("2elpY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
const $19fd80c00d89aed1$var$sqrt3 = (0, $6NP0o.sqrt)(3);
var $19fd80c00d89aed1$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size + (0, $6NP0o.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $19fd80c00d89aed1$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $19fd80c00d89aed1$var$_default;

});

parcelRequire.register("xTwUK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
var $065e28424700d689$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size / $6NP0o.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $6NP0o.tau);
    }
};
module.exports.default = $065e28424700d689$var$_default;

});

parcelRequire.register("cnWLE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
var $90453808b7758fad$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $90453808b7758fad$var$_default;

});

parcelRequire.register("8zZjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
const $63f127f1eed2a2c8$var$tan30 = (0, $6NP0o.sqrt)(1 / 3);
const $63f127f1eed2a2c8$var$tan30_2 = $63f127f1eed2a2c8$var$tan30 * 2;
var $63f127f1eed2a2c8$var$_default = {
    draw (context, size) {
        const y = (0, $6NP0o.sqrt)(size / $63f127f1eed2a2c8$var$tan30_2);
        const x = y * $63f127f1eed2a2c8$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $63f127f1eed2a2c8$var$_default;

});

parcelRequire.register("7Vv6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
var $5c55fb9d9aeec088$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $5c55fb9d9aeec088$var$_default;

});

parcelRequire.register("41ZKX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
var $2ef728f0c8e967ed$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size - (0, $6NP0o.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $2ef728f0c8e967ed$var$_default;

});

parcelRequire.register("3jSv1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
var $26ad6be452495e01$var$_default = {
    draw (context, size) {
        const w = (0, $6NP0o.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $26ad6be452495e01$var$_default;

});

parcelRequire.register("bTfxV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
var $8a80e3eb4aafc755$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $8a80e3eb4aafc755$var$_default;

});

parcelRequire.register("c4zmK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
const $8ca14ab4f4140875$var$ka = 0.89081309152928522810;
const $8ca14ab4f4140875$var$kr = (0, $6NP0o.sin)($6NP0o.pi / 10) / (0, $6NP0o.sin)(7 * $6NP0o.pi / 10);
const $8ca14ab4f4140875$var$kx = (0, $6NP0o.sin)($6NP0o.tau / 10) * $8ca14ab4f4140875$var$kr;
const $8ca14ab4f4140875$var$ky = -(0, $6NP0o.cos)($6NP0o.tau / 10) * $8ca14ab4f4140875$var$kr;
var $8ca14ab4f4140875$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size * $8ca14ab4f4140875$var$ka);
        const x = $8ca14ab4f4140875$var$kx * r;
        const y = $8ca14ab4f4140875$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $6NP0o.tau * i / 5;
            const c = (0, $6NP0o.cos)(a);
            const s = (0, $6NP0o.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $8ca14ab4f4140875$var$_default;

});

parcelRequire.register("fPQqf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
const $b8744866ad9d0f6c$var$sqrt3 = (0, $6NP0o.sqrt)(3);
var $b8744866ad9d0f6c$var$_default = {
    draw (context, size) {
        const y = -(0, $6NP0o.sqrt)(size / ($b8744866ad9d0f6c$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$b8744866ad9d0f6c$var$sqrt3 * y, -y);
        context.lineTo($b8744866ad9d0f6c$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $b8744866ad9d0f6c$var$_default;

});

parcelRequire.register("8Vxb5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
const $67fd620560a6b32c$var$sqrt3 = (0, $6NP0o.sqrt)(3);
var $67fd620560a6b32c$var$_default = {
    draw (context, size) {
        const s = (0, $6NP0o.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $67fd620560a6b32c$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $67fd620560a6b32c$var$_default;

});

parcelRequire.register("51A2u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
const $3a890060b4d97f12$var$c = -0.5;
const $3a890060b4d97f12$var$s = (0, $6NP0o.sqrt)(3) / 2;
const $3a890060b4d97f12$var$k = 1 / (0, $6NP0o.sqrt)(12);
const $3a890060b4d97f12$var$a = ($3a890060b4d97f12$var$k / 2 + 1) * 3;
var $3a890060b4d97f12$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size / $3a890060b4d97f12$var$a);
        const x0 = r / 2, y0 = r * $3a890060b4d97f12$var$k;
        const x1 = x0, y1 = r * $3a890060b4d97f12$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($3a890060b4d97f12$var$c * x0 - $3a890060b4d97f12$var$s * y0, $3a890060b4d97f12$var$s * x0 + $3a890060b4d97f12$var$c * y0);
        context.lineTo($3a890060b4d97f12$var$c * x1 - $3a890060b4d97f12$var$s * y1, $3a890060b4d97f12$var$s * x1 + $3a890060b4d97f12$var$c * y1);
        context.lineTo($3a890060b4d97f12$var$c * x2 - $3a890060b4d97f12$var$s * y2, $3a890060b4d97f12$var$s * x2 + $3a890060b4d97f12$var$c * y2);
        context.lineTo($3a890060b4d97f12$var$c * x0 + $3a890060b4d97f12$var$s * y0, $3a890060b4d97f12$var$c * y0 - $3a890060b4d97f12$var$s * x0);
        context.lineTo($3a890060b4d97f12$var$c * x1 + $3a890060b4d97f12$var$s * y1, $3a890060b4d97f12$var$c * y1 - $3a890060b4d97f12$var$s * x1);
        context.lineTo($3a890060b4d97f12$var$c * x2 + $3a890060b4d97f12$var$s * y2, $3a890060b4d97f12$var$c * y2 - $3a890060b4d97f12$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $3a890060b4d97f12$var$_default;

});

parcelRequire.register("8wBWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6NP0o = parcelRequire("6NP0o");
var $634ebf1245a1c644$var$_default = {
    draw (context, size) {
        const r = (0, $6NP0o.sqrt)(size - (0, $6NP0o.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $634ebf1245a1c644$var$_default;

});


parcelRequire.register("aZ5yj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ff3e879686208e0$var$_default;

var $7ff3e879686208e0$var$_noop = $7ff3e879686208e0$var$_interopRequireDefault((parcelRequire("7vent")));

var $dOjLk = parcelRequire("dOjLk");
function $7ff3e879686208e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7ff3e879686208e0$var$BasisClosed(context) {
    this._context = context;
}
$7ff3e879686208e0$var$BasisClosed.prototype = {
    areaStart: $7ff3e879686208e0$var$_noop.default,
    areaEnd: $7ff3e879686208e0$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $dOjLk.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7ff3e879686208e0$var$_default(context) {
    return new $7ff3e879686208e0$var$BasisClosed(context);
}

});
parcelRequire.register("7vent", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $576694bc6abfa5b8$var$_default;
function $576694bc6abfa5b8$var$_default() {}

});

parcelRequire.register("dOjLk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $a0df464a21d4c22d$var$Basis;
module.exports.default = $a0df464a21d4c22d$var$_default;
module.exports.point = $a0df464a21d4c22d$var$point;
function $a0df464a21d4c22d$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $a0df464a21d4c22d$var$Basis(context) {
    this._context = context;
}
$a0df464a21d4c22d$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $a0df464a21d4c22d$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $a0df464a21d4c22d$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a0df464a21d4c22d$var$_default(context) {
    return new $a0df464a21d4c22d$var$Basis(context);
}

});


parcelRequire.register("790qp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5339b40d3f03d766$var$_default;

var $dOjLk = parcelRequire("dOjLk");
function $5339b40d3f03d766$var$BasisOpen(context) {
    this._context = context;
}
$5339b40d3f03d766$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $dOjLk.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $5339b40d3f03d766$var$_default(context) {
    return new $5339b40d3f03d766$var$BasisOpen(context);
}

});

parcelRequire.register("5q3eE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dOjLk = parcelRequire("dOjLk");
function $3f21e3ef48653068$var$Bundle(context, beta) {
    this._basis = new $dOjLk.Basis(context);
    this._beta = beta;
}
$3f21e3ef48653068$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $3f21e3ef48653068$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $dOjLk.Basis(context) : new $3f21e3ef48653068$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $3f21e3ef48653068$var$_default;

});

parcelRequire.register("jREwA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $e76266dffb8d5522$var$CardinalClosed;
module.exports.default = void 0;

var $e76266dffb8d5522$var$_noop = $e76266dffb8d5522$var$_interopRequireDefault((parcelRequire("7vent")));

var $dmJ8m = parcelRequire("dmJ8m");
function $e76266dffb8d5522$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e76266dffb8d5522$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e76266dffb8d5522$var$CardinalClosed.prototype = {
    areaStart: $e76266dffb8d5522$var$_noop.default,
    areaEnd: $e76266dffb8d5522$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $dmJ8m.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e76266dffb8d5522$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e76266dffb8d5522$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e76266dffb8d5522$var$_default;

});
parcelRequire.register("dmJ8m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $9bb0571a9b8e14d7$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $9bb0571a9b8e14d7$var$point;
function $9bb0571a9b8e14d7$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $9bb0571a9b8e14d7$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$9bb0571a9b8e14d7$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $9bb0571a9b8e14d7$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $9bb0571a9b8e14d7$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $9bb0571a9b8e14d7$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $9bb0571a9b8e14d7$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $9bb0571a9b8e14d7$var$_default;

});


parcelRequire.register("5uJfB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $4002daef02ce664f$var$CardinalOpen;
module.exports.default = void 0;

var $dmJ8m = parcelRequire("dmJ8m");
function $4002daef02ce664f$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$4002daef02ce664f$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $dmJ8m.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4002daef02ce664f$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $4002daef02ce664f$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $4002daef02ce664f$var$_default;

});

parcelRequire.register("avrFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jREwA = parcelRequire("jREwA");

var $7a624211ff46ff0a$var$_noop = $7a624211ff46ff0a$var$_interopRequireDefault((parcelRequire("7vent")));

var $iSDo4 = parcelRequire("iSDo4");
function $7a624211ff46ff0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a624211ff46ff0a$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$7a624211ff46ff0a$var$CatmullRomClosed.prototype = {
    areaStart: $7a624211ff46ff0a$var$_noop.default,
    areaEnd: $7a624211ff46ff0a$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $iSDo4.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $7a624211ff46ff0a$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $7a624211ff46ff0a$var$CatmullRomClosed(context, alpha) : new $jREwA.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $7a624211ff46ff0a$var$_default;

});
parcelRequire.register("iSDo4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.point = $dbebd2a08141ceab$var$point;

var $6NP0o = parcelRequire("6NP0o");

var $dmJ8m = parcelRequire("dmJ8m");
function $dbebd2a08141ceab$var$point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $6NP0o.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $6NP0o.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function $dbebd2a08141ceab$var$CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$dbebd2a08141ceab$var$CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $dbebd2a08141ceab$var$point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $dbebd2a08141ceab$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $dbebd2a08141ceab$var$CatmullRom(context, alpha) : new $dmJ8m.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $dbebd2a08141ceab$var$_default;

});


parcelRequire.register("2iPCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5uJfB = parcelRequire("5uJfB");

var $iSDo4 = parcelRequire("iSDo4");
function $1ad54d60db6c5c10$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$1ad54d60db6c5c10$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $iSDo4.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $1ad54d60db6c5c10$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $1ad54d60db6c5c10$var$CatmullRomOpen(context, alpha) : new $5uJfB.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $1ad54d60db6c5c10$var$_default;

});

parcelRequire.register("hZnWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d18ab4f69e665f8c$var$_default;

var $d18ab4f69e665f8c$var$_noop = $d18ab4f69e665f8c$var$_interopRequireDefault((parcelRequire("7vent")));
function $d18ab4f69e665f8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d18ab4f69e665f8c$var$LinearClosed(context) {
    this._context = context;
}
$d18ab4f69e665f8c$var$LinearClosed.prototype = {
    areaStart: $d18ab4f69e665f8c$var$_noop.default,
    areaEnd: $d18ab4f69e665f8c$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $d18ab4f69e665f8c$var$_default(context) {
    return new $d18ab4f69e665f8c$var$LinearClosed(context);
}

});

parcelRequire.register("4EK34", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $363e9e22141d7a0d$var$monotoneX;
module.exports.monotoneY = $363e9e22141d7a0d$var$monotoneY;
function $363e9e22141d7a0d$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $363e9e22141d7a0d$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($363e9e22141d7a0d$var$sign(s0) + $363e9e22141d7a0d$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $363e9e22141d7a0d$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $363e9e22141d7a0d$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $363e9e22141d7a0d$var$MonotoneX(context) {
    this._context = context;
}
$363e9e22141d7a0d$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $363e9e22141d7a0d$var$point(this, this._t0, $363e9e22141d7a0d$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $363e9e22141d7a0d$var$point(this, $363e9e22141d7a0d$var$slope2(this, t1 = $363e9e22141d7a0d$var$slope3(this, x, y)), t1);
                break;
            default:
                $363e9e22141d7a0d$var$point(this, this._t0, t1 = $363e9e22141d7a0d$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $363e9e22141d7a0d$var$MonotoneY(context) {
    this._context = new $363e9e22141d7a0d$var$ReflectContext(context);
}
($363e9e22141d7a0d$var$MonotoneY.prototype = Object.create($363e9e22141d7a0d$var$MonotoneX.prototype)).point = function(x, y) {
    $363e9e22141d7a0d$var$MonotoneX.prototype.point.call(this, y, x);
};
function $363e9e22141d7a0d$var$ReflectContext(context) {
    this._context = context;
}
$363e9e22141d7a0d$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $363e9e22141d7a0d$var$monotoneX(context) {
    return new $363e9e22141d7a0d$var$MonotoneX(context);
}
function $363e9e22141d7a0d$var$monotoneY(context) {
    return new $363e9e22141d7a0d$var$MonotoneY(context);
}

});

parcelRequire.register("iVqmn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc71ff68afe8e174$var$_default;
function $dc71ff68afe8e174$var$Natural(context) {
    this._context = context;
}
$dc71ff68afe8e174$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $dc71ff68afe8e174$var$controlPoints(x), py = $dc71ff68afe8e174$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $dc71ff68afe8e174$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $dc71ff68afe8e174$var$_default(context) {
    return new $dc71ff68afe8e174$var$Natural(context);
}

});

parcelRequire.register("7KOnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a53e91592f90fb8$var$_default;
module.exports.stepAfter = $5a53e91592f90fb8$var$stepAfter;
module.exports.stepBefore = $5a53e91592f90fb8$var$stepBefore;
function $5a53e91592f90fb8$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$5a53e91592f90fb8$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $5a53e91592f90fb8$var$_default(context) {
    return new $5a53e91592f90fb8$var$Step(context, 0.5);
}
function $5a53e91592f90fb8$var$stepBefore(context) {
    return new $5a53e91592f90fb8$var$Step(context, 0);
}
function $5a53e91592f90fb8$var$stepAfter(context) {
    return new $5a53e91592f90fb8$var$Step(context, 1);
}

});

parcelRequire.register("2aviL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1944cbcdbf6f33b9$var$_default;

var $1944cbcdbf6f33b9$var$_array = $1944cbcdbf6f33b9$var$_interopRequireDefault((parcelRequire("9YFrt")));

var $1944cbcdbf6f33b9$var$_constant = $1944cbcdbf6f33b9$var$_interopRequireDefault((parcelRequire("gjOZe")));

var $1944cbcdbf6f33b9$var$_none = $1944cbcdbf6f33b9$var$_interopRequireDefault((parcelRequire("jgzyF")));

var $1944cbcdbf6f33b9$var$_none2 = $1944cbcdbf6f33b9$var$_interopRequireDefault((parcelRequire("5btUU")));
function $1944cbcdbf6f33b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1944cbcdbf6f33b9$var$stackValue(d, key) {
    return d[key];
}
function $1944cbcdbf6f33b9$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $1944cbcdbf6f33b9$var$_default() {
    var keys = (0, $1944cbcdbf6f33b9$var$_constant.default)([]), order = $1944cbcdbf6f33b9$var$_none2.default, offset = $1944cbcdbf6f33b9$var$_none.default, value = $1944cbcdbf6f33b9$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $1944cbcdbf6f33b9$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $1944cbcdbf6f33b9$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $1944cbcdbf6f33b9$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $1944cbcdbf6f33b9$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $1944cbcdbf6f33b9$var$_none2.default : typeof _ === "function" ? _ : (0, $1944cbcdbf6f33b9$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $1944cbcdbf6f33b9$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRequire.register("jgzyF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e06b180a62bc91db$var$_default;
function $e06b180a62bc91db$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRequire.register("5btUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c652fb765003acb$var$_default;
function $3c652fb765003acb$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRequire.register("gAXuO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c14e28c836c737d1$var$_default;

var $c14e28c836c737d1$var$_none = $c14e28c836c737d1$var$_interopRequireDefault((parcelRequire("jgzyF")));
function $c14e28c836c737d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c14e28c836c737d1$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $c14e28c836c737d1$var$_none.default)(series, order);
}

});

parcelRequire.register("am9Jl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78a381b30109d832$var$_default;
function $78a381b30109d832$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRequire.register("8RXiW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $675146a12b16d0db$var$_default;

var $675146a12b16d0db$var$_none = $675146a12b16d0db$var$_interopRequireDefault((parcelRequire("jgzyF")));
function $675146a12b16d0db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $675146a12b16d0db$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $675146a12b16d0db$var$_none.default)(series, order);
}

});

parcelRequire.register("hKtlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cebd7f1b141dd16b$var$_default;

var $cebd7f1b141dd16b$var$_none = $cebd7f1b141dd16b$var$_interopRequireDefault((parcelRequire("jgzyF")));
function $cebd7f1b141dd16b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cebd7f1b141dd16b$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $cebd7f1b141dd16b$var$_none.default)(series, order);
}

});

parcelRequire.register("bYQ6X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b8db87c56a36ddc$var$_default;

var $8b8db87c56a36ddc$var$_none = $8b8db87c56a36ddc$var$_interopRequireDefault((parcelRequire("5btUU")));
function $8b8db87c56a36ddc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8b8db87c56a36ddc$var$_default(series) {
    var peaks = series.map($8b8db87c56a36ddc$var$peak);
    return (0, $8b8db87c56a36ddc$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $8b8db87c56a36ddc$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRequire.register("qSxmF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $050cbbc33778d78e$var$_default;
module.exports.sum = $050cbbc33778d78e$var$sum;

var $050cbbc33778d78e$var$_none = $050cbbc33778d78e$var$_interopRequireDefault((parcelRequire("5btUU")));
function $050cbbc33778d78e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $050cbbc33778d78e$var$_default(series) {
    var sums = series.map($050cbbc33778d78e$var$sum);
    return (0, $050cbbc33778d78e$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $050cbbc33778d78e$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRequire.register("2YNAK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22b7a744004d9d77$var$_default;

var $22b7a744004d9d77$var$_ascending = $22b7a744004d9d77$var$_interopRequireDefault((parcelRequire("qSxmF")));
function $22b7a744004d9d77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22b7a744004d9d77$var$_default(series) {
    return (0, $22b7a744004d9d77$var$_ascending.default)(series).reverse();
}

});

parcelRequire.register("llAou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8a7ca400106e622$var$_default;

var $f8a7ca400106e622$var$_appearance = $f8a7ca400106e622$var$_interopRequireDefault((parcelRequire("bYQ6X")));

var $qSxmF = parcelRequire("qSxmF");
function $f8a7ca400106e622$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8a7ca400106e622$var$_default(series) {
    var n = series.length, i, j, sums = series.map($qSxmF.sum), order = (0, $f8a7ca400106e622$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRequire.register("kuVkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec315ba9ea6b26f$var$_default;

var $eec315ba9ea6b26f$var$_none = $eec315ba9ea6b26f$var$_interopRequireDefault((parcelRequire("5btUU")));
function $eec315ba9ea6b26f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $eec315ba9ea6b26f$var$_default(series) {
    return (0, $eec315ba9ea6b26f$var$_none.default)(series).reverse();
}

});



parcelRequire.register("67H4j", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $4754ce06f2514050$var$PropTypes = $4754ce06f2514050$var$_interopRequireWildcard((parcelRequire("houiY")));

var $4754ce06f2514050$var$_addClass = $4754ce06f2514050$var$_interopRequireDefault((parcelRequire("bHfiu")));

var $4754ce06f2514050$var$_removeClass = $4754ce06f2514050$var$_interopRequireDefault((parcelRequire("jfpep")));

var $4754ce06f2514050$var$_react = $4754ce06f2514050$var$_interopRequireDefault((parcelRequire("lDSNw")));

var $4754ce06f2514050$var$_Transition = $4754ce06f2514050$var$_interopRequireDefault((parcelRequire("eR79z")));

function $4754ce06f2514050$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4754ce06f2514050$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $4754ce06f2514050$var$_extends() {
    $4754ce06f2514050$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4754ce06f2514050$var$_extends.apply(this, arguments);
}
function $4754ce06f2514050$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4754ce06f2514050$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $4754ce06f2514050$var$_addClass.default)(node, c);
    });
};
var $4754ce06f2514050$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $4754ce06f2514050$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $4754ce06f2514050$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $4754ce06f2514050$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $4754ce06f2514050$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $4754ce06f2514050$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $4754ce06f2514050$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $4754ce06f2514050$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $4754ce06f2514050$var$removeClass(node, className);
        activeClassName && $4754ce06f2514050$var$removeClass(node, activeClassName);
        doneClassName && $4754ce06f2514050$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $4754ce06f2514050$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $4754ce06f2514050$var$_extends({}, this.props);
        delete props.classNames;
        return $4754ce06f2514050$var$_react.default.createElement($4754ce06f2514050$var$_Transition.default, $4754ce06f2514050$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($4754ce06f2514050$var$_react.default.Component);
$4754ce06f2514050$var$CSSTransition.defaultProps = {
    classNames: ""
};
$4754ce06f2514050$var$CSSTransition.propTypes = {};
var $4754ce06f2514050$var$_default = $4754ce06f2514050$var$CSSTransition;
module.exports.default = $4754ce06f2514050$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("bHfiu", function(module, exports) {
"use strict";

var $8QUGU = parcelRequire("8QUGU");
module.exports.__esModule = true;
module.exports.default = $883f939254212d23$var$addClass;

var $883f939254212d23$var$_hasClass = $8QUGU((parcelRequire("1Z62g")));
function $883f939254212d23$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $883f939254212d23$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRequire.register("8QUGU", function(module, exports) {
function $671f27beeb6a75c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $671f27beeb6a75c1$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("1Z62g", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $17202b7c3af300eb$var$hasClass;
function $17202b7c3af300eb$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRequire.register("jfpep", function(module, exports) {
"use strict";
function $e032fd7daf60bb35$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $e032fd7daf60bb35$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $e032fd7daf60bb35$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRequire.register("eR79z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $ad0b9068fa95fa41$export$1e511d4a378977f5; }, function (v) { return $ad0b9068fa95fa41$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $ad0b9068fa95fa41$export$2e2bcd8739ae039; }, function (v) { return $ad0b9068fa95fa41$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $ad0b9068fa95fa41$export$4aacc83d4d59139f; }, function (v) { return $ad0b9068fa95fa41$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $ad0b9068fa95fa41$export$78e9e6e3e014d60a; }, function (v) { return $ad0b9068fa95fa41$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $ad0b9068fa95fa41$export$df38205c966be359; }, function (v) { return $ad0b9068fa95fa41$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $ad0b9068fa95fa41$export$84cbff306f539230; }, function (v) { return $ad0b9068fa95fa41$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $ad0b9068fa95fa41$export$bb38bb9a1161268; }, function (v) { return $ad0b9068fa95fa41$export$bb38bb9a1161268 = v; });
var $ad0b9068fa95fa41$export$1e511d4a378977f5;
var $ad0b9068fa95fa41$export$2e2bcd8739ae039;
var $ad0b9068fa95fa41$export$4aacc83d4d59139f;
var $ad0b9068fa95fa41$export$78e9e6e3e014d60a;
var $ad0b9068fa95fa41$export$df38205c966be359;
var $ad0b9068fa95fa41$export$84cbff306f539230;
var $ad0b9068fa95fa41$export$bb38bb9a1161268;
"use strict";
$ad0b9068fa95fa41$export$1e511d4a378977f5 = true;
$ad0b9068fa95fa41$export$2e2bcd8739ae039 = $ad0b9068fa95fa41$export$4aacc83d4d59139f = $ad0b9068fa95fa41$export$78e9e6e3e014d60a = $ad0b9068fa95fa41$export$df38205c966be359 = $ad0b9068fa95fa41$export$84cbff306f539230 = $ad0b9068fa95fa41$export$bb38bb9a1161268 = void 0;

var $ad0b9068fa95fa41$var$PropTypes = $ad0b9068fa95fa41$var$_interopRequireWildcard((parcelRequire("houiY")));

var $ad0b9068fa95fa41$var$_react = $ad0b9068fa95fa41$var$_interopRequireDefault((parcelRequire("lDSNw")));

var $ad0b9068fa95fa41$var$_reactDom = $ad0b9068fa95fa41$var$_interopRequireDefault((parcelRequire("ef4Zh")));

var $cBLyO = parcelRequire("cBLyO");

function $ad0b9068fa95fa41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ad0b9068fa95fa41$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ad0b9068fa95fa41$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ad0b9068fa95fa41$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $ad0b9068fa95fa41$var$UNMOUNTED = "unmounted";
$ad0b9068fa95fa41$export$bb38bb9a1161268 = $ad0b9068fa95fa41$var$UNMOUNTED;
var $ad0b9068fa95fa41$var$EXITED = "exited";
$ad0b9068fa95fa41$export$84cbff306f539230 = $ad0b9068fa95fa41$var$EXITED;
var $ad0b9068fa95fa41$var$ENTERING = "entering";
$ad0b9068fa95fa41$export$df38205c966be359 = $ad0b9068fa95fa41$var$ENTERING;
var $ad0b9068fa95fa41$var$ENTERED = "entered";
$ad0b9068fa95fa41$export$78e9e6e3e014d60a = $ad0b9068fa95fa41$var$ENTERED;
var $ad0b9068fa95fa41$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $ad0b9068fa95fa41$export$4aacc83d4d59139f = $ad0b9068fa95fa41$var$EXITING;
var $ad0b9068fa95fa41$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $ad0b9068fa95fa41$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $ad0b9068fa95fa41$var$EXITED;
                _this.appearStatus = $ad0b9068fa95fa41$var$ENTERING;
            } else initialStatus = $ad0b9068fa95fa41$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $ad0b9068fa95fa41$var$UNMOUNTED;
        else initialStatus = $ad0b9068fa95fa41$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $ad0b9068fa95fa41$var$UNMOUNTED) return {
            status: $ad0b9068fa95fa41$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $ad0b9068fa95fa41$var$ENTERING && status !== $ad0b9068fa95fa41$var$ENTERED) nextStatus = $ad0b9068fa95fa41$var$ENTERING;
            } else if (status === $ad0b9068fa95fa41$var$ENTERING || status === $ad0b9068fa95fa41$var$ENTERED) nextStatus = $ad0b9068fa95fa41$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $ad0b9068fa95fa41$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $ad0b9068fa95fa41$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $ad0b9068fa95fa41$var$EXITED) this.setState({
            status: $ad0b9068fa95fa41$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $ad0b9068fa95fa41$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $ad0b9068fa95fa41$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $ad0b9068fa95fa41$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $ad0b9068fa95fa41$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $ad0b9068fa95fa41$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $ad0b9068fa95fa41$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $ad0b9068fa95fa41$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $ad0b9068fa95fa41$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $ad0b9068fa95fa41$var$_react.default.Children.only(children);
        return $ad0b9068fa95fa41$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($ad0b9068fa95fa41$var$_react.default.Component);
$ad0b9068fa95fa41$var$Transition.contextTypes = {
    transitionGroup: $ad0b9068fa95fa41$var$PropTypes.object
};
$ad0b9068fa95fa41$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$ad0b9068fa95fa41$var$Transition.propTypes = {};
function $ad0b9068fa95fa41$var$noop() {}
$ad0b9068fa95fa41$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $ad0b9068fa95fa41$var$noop,
    onEntering: $ad0b9068fa95fa41$var$noop,
    onEntered: $ad0b9068fa95fa41$var$noop,
    onExit: $ad0b9068fa95fa41$var$noop,
    onExiting: $ad0b9068fa95fa41$var$noop,
    onExited: $ad0b9068fa95fa41$var$noop
};
$ad0b9068fa95fa41$var$Transition.UNMOUNTED = 0;
$ad0b9068fa95fa41$var$Transition.EXITED = 1;
$ad0b9068fa95fa41$var$Transition.ENTERING = 2;
$ad0b9068fa95fa41$var$Transition.ENTERED = 3;
$ad0b9068fa95fa41$var$Transition.EXITING = 4;
var $ad0b9068fa95fa41$var$_default = (0, $cBLyO.polyfill)($ad0b9068fa95fa41$var$Transition);
$ad0b9068fa95fa41$export$2e2bcd8739ae039 = $ad0b9068fa95fa41$var$_default;

});
parcelRequire.register("cBLyO", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $92ddd548db6c18af$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $92ddd548db6c18af$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $92ddd548db6c18af$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $92ddd548db6c18af$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$92ddd548db6c18af$var$componentWillMount.__suppressDeprecationWarning = true;
$92ddd548db6c18af$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$92ddd548db6c18af$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $92ddd548db6c18af$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $92ddd548db6c18af$var$componentWillMount;
        prototype.componentWillReceiveProps = $92ddd548db6c18af$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $92ddd548db6c18af$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRequire.register("6qXQO", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $4af398ec8acee34a$var$_propTypes = $4af398ec8acee34a$var$_interopRequireDefault((parcelRequire("houiY")));

var $4af398ec8acee34a$var$_react = $4af398ec8acee34a$var$_interopRequireDefault((parcelRequire("lDSNw")));

var $ef4Zh = parcelRequire("ef4Zh");

var $4af398ec8acee34a$var$_TransitionGroup = $4af398ec8acee34a$var$_interopRequireDefault((parcelRequire("9e6Xd")));
function $4af398ec8acee34a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4af398ec8acee34a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4af398ec8acee34a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $4af398ec8acee34a$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $4af398ec8acee34a$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $4af398ec8acee34a$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $ef4Zh.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $4af398ec8acee34a$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $4af398ec8acee34a$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $4af398ec8acee34a$var$_react.default.createElement($4af398ec8acee34a$var$_TransitionGroup.default, props, inProp ? $4af398ec8acee34a$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $4af398ec8acee34a$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($4af398ec8acee34a$var$_react.default.Component);
$4af398ec8acee34a$var$ReplaceTransition.propTypes = {};
var $4af398ec8acee34a$var$_default = $4af398ec8acee34a$var$ReplaceTransition;
module.exports.default = $4af398ec8acee34a$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("9e6Xd", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $6b7ad0cc7b778747$var$_propTypes = $6b7ad0cc7b778747$var$_interopRequireDefault((parcelRequire("houiY")));

var $6b7ad0cc7b778747$var$_react = $6b7ad0cc7b778747$var$_interopRequireDefault((parcelRequire("lDSNw")));

var $cBLyO = parcelRequire("cBLyO");

var $ffafy = parcelRequire("ffafy");
function $6b7ad0cc7b778747$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b7ad0cc7b778747$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6b7ad0cc7b778747$var$_extends() {
    $6b7ad0cc7b778747$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6b7ad0cc7b778747$var$_extends.apply(this, arguments);
}
function $6b7ad0cc7b778747$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $6b7ad0cc7b778747$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $6b7ad0cc7b778747$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $6b7ad0cc7b778747$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $6b7ad0cc7b778747$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $6b7ad0cc7b778747$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($6b7ad0cc7b778747$var$_assertThisInitialized($6b7ad0cc7b778747$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $ffafy.getInitialChildMapping)(nextProps, handleExited) : (0, $ffafy.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $ffafy.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $6b7ad0cc7b778747$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $6b7ad0cc7b778747$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $6b7ad0cc7b778747$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $6b7ad0cc7b778747$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($6b7ad0cc7b778747$var$_react.default.Component);
$6b7ad0cc7b778747$var$TransitionGroup.childContextTypes = {
    transitionGroup: $6b7ad0cc7b778747$var$_propTypes.default.object.isRequired
};
$6b7ad0cc7b778747$var$TransitionGroup.propTypes = {};
$6b7ad0cc7b778747$var$TransitionGroup.defaultProps = $6b7ad0cc7b778747$var$defaultProps;
var $6b7ad0cc7b778747$var$_default = (0, $cBLyO.polyfill)($6b7ad0cc7b778747$var$TransitionGroup);
module.exports.default = $6b7ad0cc7b778747$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("ffafy", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $b19035279acacdaf$export$bbc8a025727ea824; }, function (v) { return $b19035279acacdaf$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $b19035279acacdaf$export$fa71e2345c31d7a2; }, function (v) { return $b19035279acacdaf$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $b19035279acacdaf$export$36fd1af28d383ec0; }, function (v) { return $b19035279acacdaf$export$36fd1af28d383ec0 = v; });
var $b19035279acacdaf$export$1e511d4a378977f5;
var $b19035279acacdaf$export$bbc8a025727ea824;
var $b19035279acacdaf$export$7a874f95ccf533dd;
var $b19035279acacdaf$export$fa71e2345c31d7a2;
var $b19035279acacdaf$export$36fd1af28d383ec0;
"use strict";
$b19035279acacdaf$export$1e511d4a378977f5 = true;
$b19035279acacdaf$export$bbc8a025727ea824 = $b19035279acacdaf$var$getChildMapping;
$b19035279acacdaf$export$7a874f95ccf533dd = $b19035279acacdaf$var$mergeChildMappings;
$b19035279acacdaf$export$fa71e2345c31d7a2 = $b19035279acacdaf$var$getInitialChildMapping;
$b19035279acacdaf$export$36fd1af28d383ec0 = $b19035279acacdaf$var$getNextChildMapping;

var $lDSNw = parcelRequire("lDSNw");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $b19035279acacdaf$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $lDSNw.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $lDSNw.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $b19035279acacdaf$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $b19035279acacdaf$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $b19035279acacdaf$var$getInitialChildMapping(props, onExited) {
    return $b19035279acacdaf$var$getChildMapping(props.children, function(child) {
        return (0, $lDSNw.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $b19035279acacdaf$var$getProp(child, "appear", props),
            enter: $b19035279acacdaf$var$getProp(child, "enter", props),
            exit: $b19035279acacdaf$var$getProp(child, "exit", props)
        });
    });
}
function $b19035279acacdaf$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $b19035279acacdaf$var$getChildMapping(nextProps.children);
    var children = $b19035279acacdaf$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $lDSNw.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $lDSNw.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $lDSNw.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $b19035279acacdaf$var$getProp(child, "exit", nextProps),
            enter: $b19035279acacdaf$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $lDSNw.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $lDSNw.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $lDSNw.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $b19035279acacdaf$var$getProp(child, "exit", nextProps),
            enter: $b19035279acacdaf$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



parcelRequire.register("8oVtG", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("9DO33"));

});
parcelRequire.register("9DO33", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $704e941de6ce6f00$var$_tickFormat.default;
    }
});

var $704e941de6ce6f00$var$_band = $704e941de6ce6f00$var$_interopRequireWildcard((parcelRequire("e7vem")));

var $704e941de6ce6f00$var$_identity = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("75Oac")));

var $704e941de6ce6f00$var$_linear = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("4bGV3")));

var $704e941de6ce6f00$var$_log = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("jldhc")));

var $704e941de6ce6f00$var$_symlog = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("dyYUY")));

var $704e941de6ce6f00$var$_ordinal = $704e941de6ce6f00$var$_interopRequireWildcard((parcelRequire("ajjHF")));

var $704e941de6ce6f00$var$_pow = $704e941de6ce6f00$var$_interopRequireWildcard((parcelRequire("eFo2P")));

var $704e941de6ce6f00$var$_radial = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("bahss")));

var $704e941de6ce6f00$var$_quantile = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("9YomO")));

var $704e941de6ce6f00$var$_quantize = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("iz2r4")));

var $704e941de6ce6f00$var$_threshold = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("h6HOb")));

var $704e941de6ce6f00$var$_time = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("a9YvZ")));

var $704e941de6ce6f00$var$_utcTime = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("caTDE")));

var $704e941de6ce6f00$var$_sequential = $704e941de6ce6f00$var$_interopRequireWildcard((parcelRequire("iFnQQ")));

var $704e941de6ce6f00$var$_sequentialQuantile = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("f0DQk")));

var $704e941de6ce6f00$var$_diverging = $704e941de6ce6f00$var$_interopRequireWildcard((parcelRequire("jzX1k")));

var $704e941de6ce6f00$var$_tickFormat = $704e941de6ce6f00$var$_interopRequireDefault((parcelRequire("5WBP3")));
function $704e941de6ce6f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $704e941de6ce6f00$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($704e941de6ce6f00$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $704e941de6ce6f00$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $704e941de6ce6f00$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("e7vem", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a479f1dd0df470da$var$band;
module.exports.point = $a479f1dd0df470da$var$point;

var $2ccY8 = parcelRequire("2ccY8");

var $3HcC4 = parcelRequire("3HcC4");

var $a479f1dd0df470da$var$_ordinal = $a479f1dd0df470da$var$_interopRequireDefault((parcelRequire("ajjHF")));
function $a479f1dd0df470da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a479f1dd0df470da$var$band() {
    var scale = (0, $a479f1dd0df470da$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $2ccY8.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $a479f1dd0df470da$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $3HcC4.initRange.apply(rescale(), arguments);
}
function $a479f1dd0df470da$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $a479f1dd0df470da$var$pointish(copy());
    };
    return scale;
}
function $a479f1dd0df470da$var$point() {
    return $a479f1dd0df470da$var$pointish($a479f1dd0df470da$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRequire.register("2ccY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $65rlT.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $ceLHr.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $ceLHr.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $65rlT.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $65rlT.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $1996c3221cded19f$var$_zip.default;
    }
});

var $1996c3221cded19f$var$_bisect = $1996c3221cded19f$var$_interopRequireWildcard((parcelRequire("7rWi4")));

var $1996c3221cded19f$var$_ascending = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $1996c3221cded19f$var$_bisector = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("4qIcW")));

var $1996c3221cded19f$var$_count = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("e5w7q")));

var $1996c3221cded19f$var$_cross = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("fGOhq")));

var $1996c3221cded19f$var$_cumsum = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("7Nkd8")));

var $1996c3221cded19f$var$_descending = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("cBVMH")));

var $1996c3221cded19f$var$_deviation = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("6lZuc")));

var $1996c3221cded19f$var$_extent = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("i5zMJ")));

var $65rlT = parcelRequire("65rlT");

var $1996c3221cded19f$var$_group = $1996c3221cded19f$var$_interopRequireWildcard((parcelRequire("fik3D")));

var $1996c3221cded19f$var$_groupSort = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("4BIlO")));

var $1996c3221cded19f$var$_bin = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("jhAGn")));

var $1996c3221cded19f$var$_freedmanDiaconis = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("viVD1")));

var $1996c3221cded19f$var$_scott = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("iQh5R")));

var $1996c3221cded19f$var$_sturges = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("4xtzd")));

var $1996c3221cded19f$var$_max = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("hcRAa")));

var $1996c3221cded19f$var$_maxIndex = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("llzPJ")));

var $1996c3221cded19f$var$_mean = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("dLW6k")));

var $1996c3221cded19f$var$_median = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("3Yun1")));

var $1996c3221cded19f$var$_merge = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("ibm3w")));

var $1996c3221cded19f$var$_min = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("5UAfV")));

var $1996c3221cded19f$var$_minIndex = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("53XOV")));

var $1996c3221cded19f$var$_mode = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("30bBb")));

var $1996c3221cded19f$var$_nice = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("frKhl")));

var $1996c3221cded19f$var$_pairs = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("gPT01")));

var $1996c3221cded19f$var$_permute = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("3y5Qm")));

var $1996c3221cded19f$var$_quantile = $1996c3221cded19f$var$_interopRequireWildcard((parcelRequire("6kpGw")));

var $1996c3221cded19f$var$_quickselect = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("eeT17")));

var $1996c3221cded19f$var$_range = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("dL0pY")));

var $1996c3221cded19f$var$_rank = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("d4CJK")));

var $1996c3221cded19f$var$_least = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("fwiEq")));

var $1996c3221cded19f$var$_leastIndex = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("5P50e")));

var $1996c3221cded19f$var$_greatest = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("11dNY")));

var $1996c3221cded19f$var$_greatestIndex = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("e2MPN")));

var $1996c3221cded19f$var$_scan = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("4pXLU")));

var $1996c3221cded19f$var$_shuffle = $1996c3221cded19f$var$_interopRequireWildcard((parcelRequire("imreS")));

var $1996c3221cded19f$var$_sum = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("6D9Vx")));

var $1996c3221cded19f$var$_ticks = $1996c3221cded19f$var$_interopRequireWildcard((parcelRequire("5SJDB")));

var $1996c3221cded19f$var$_transpose = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("i2CA8")));

var $1996c3221cded19f$var$_variance = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("izbS8")));

var $1996c3221cded19f$var$_zip = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("dKGUl")));

var $1996c3221cded19f$var$_every = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("fBt7V")));

var $1996c3221cded19f$var$_some = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("ls1nB")));

var $1996c3221cded19f$var$_filter = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("6XHxC")));

var $1996c3221cded19f$var$_map = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("c0P9x")));

var $1996c3221cded19f$var$_reduce = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("9aqzE")));

var $1996c3221cded19f$var$_reverse = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("6tJ5G")));

var $1996c3221cded19f$var$_sort = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("6ZoXk")));

var $1996c3221cded19f$var$_difference = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("9wEzV")));

var $1996c3221cded19f$var$_disjoint = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("hG7na")));

var $1996c3221cded19f$var$_intersection = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("c8vEu")));

var $1996c3221cded19f$var$_subset = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("3fGQm")));

var $1996c3221cded19f$var$_superset = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("4dlfq")));

var $1996c3221cded19f$var$_union = $1996c3221cded19f$var$_interopRequireDefault((parcelRequire("1kgOT")));

var $ceLHr = parcelRequire("ceLHr");
function $1996c3221cded19f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1996c3221cded19f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1996c3221cded19f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1996c3221cded19f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1996c3221cded19f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("7rWi4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $56c8454df9cb80aa$var$_ascending = $56c8454df9cb80aa$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $56c8454df9cb80aa$var$_bisector = $56c8454df9cb80aa$var$_interopRequireDefault((parcelRequire("4qIcW")));

var $56c8454df9cb80aa$var$_number = $56c8454df9cb80aa$var$_interopRequireDefault((parcelRequire("3hemE")));
function $56c8454df9cb80aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $56c8454df9cb80aa$var$ascendingBisect = (0, $56c8454df9cb80aa$var$_bisector.default)($56c8454df9cb80aa$var$_ascending.default);
const $56c8454df9cb80aa$var$bisectRight = $56c8454df9cb80aa$var$ascendingBisect.right;
module.exports.bisectRight = $56c8454df9cb80aa$var$bisectRight;
const $56c8454df9cb80aa$var$bisectLeft = $56c8454df9cb80aa$var$ascendingBisect.left;
module.exports.bisectLeft = $56c8454df9cb80aa$var$bisectLeft;
const $56c8454df9cb80aa$var$bisectCenter = (0, $56c8454df9cb80aa$var$_bisector.default)($56c8454df9cb80aa$var$_number.default).center;
module.exports.bisectCenter = $56c8454df9cb80aa$var$bisectCenter;
var $56c8454df9cb80aa$var$_default = $56c8454df9cb80aa$var$bisectRight;
module.exports.default = $56c8454df9cb80aa$var$_default;

});
parcelRequire.register("cNJLT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $951d90e9cb858170$var$ascending;
function $951d90e9cb858170$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRequire.register("4qIcW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $339be1e23bc3a826$var$bisector;

var $339be1e23bc3a826$var$_ascending = $339be1e23bc3a826$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $339be1e23bc3a826$var$_descending = $339be1e23bc3a826$var$_interopRequireDefault((parcelRequire("cBVMH")));
function $339be1e23bc3a826$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $339be1e23bc3a826$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $339be1e23bc3a826$var$_ascending.default;
        compare2 = (d, x)=>(0, $339be1e23bc3a826$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $339be1e23bc3a826$var$_ascending.default || f === $339be1e23bc3a826$var$_descending.default ? f : $339be1e23bc3a826$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $339be1e23bc3a826$var$zero() {
    return 0;
}

});
parcelRequire.register("cBVMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92e5c38e1aeb925b$var$descending;
function $92e5c38e1aeb925b$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRequire.register("3hemE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $262e1a19a2fbb467$var$number;
module.exports.numbers = $262e1a19a2fbb467$var$numbers;
function $262e1a19a2fbb467$var$number(x) {
    return x === null ? NaN : +x;
}
function* $262e1a19a2fbb467$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRequire.register("e5w7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a41a726e61c81d5c$var$count;
function $a41a726e61c81d5c$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRequire.register("fGOhq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6c1c7d789d1579b$var$cross;
function $b6c1c7d789d1579b$var$length(array) {
    return array.length | 0;
}
function $b6c1c7d789d1579b$var$empty(length) {
    return !(length > 0);
}
function $b6c1c7d789d1579b$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $b6c1c7d789d1579b$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $b6c1c7d789d1579b$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $b6c1c7d789d1579b$var$reducer(values.pop());
    values = values.map($b6c1c7d789d1579b$var$arrayify);
    const lengths = values.map($b6c1c7d789d1579b$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($b6c1c7d789d1579b$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRequire.register("7Nkd8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5accc97a27c53f27$var$cumsum;
function $5accc97a27c53f27$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRequire.register("6lZuc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a0466164c25b559$var$deviation;

var $4a0466164c25b559$var$_variance = $4a0466164c25b559$var$_interopRequireDefault((parcelRequire("izbS8")));
function $4a0466164c25b559$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4a0466164c25b559$var$deviation(values, valueof) {
    const v = (0, $4a0466164c25b559$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRequire.register("izbS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d844b474042f7eeb$var$variance;
function $d844b474042f7eeb$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRequire.register("i5zMJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2b473cb92f4d763$var$extent;
function $d2b473cb92f4d763$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRequire.register("65rlT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $46e86d46b1889424$var$fcumsum;
module.exports.fsum = $46e86d46b1889424$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $46e86d46b1889424$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $46e86d46b1889424$var$Adder;
function $46e86d46b1889424$var$fsum(values, valueof) {
    const adder = new $46e86d46b1889424$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $46e86d46b1889424$var$fcumsum(values, valueof) {
    const adder = new $46e86d46b1889424$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRequire.register("fik3D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2281880b189b3c1$var$group;
module.exports.flatGroup = $b2281880b189b3c1$var$flatGroup;
module.exports.flatRollup = $b2281880b189b3c1$var$flatRollup;
module.exports.groups = $b2281880b189b3c1$var$groups;
module.exports.index = $b2281880b189b3c1$var$index;
module.exports.indexes = $b2281880b189b3c1$var$indexes;
module.exports.rollup = $b2281880b189b3c1$var$rollup;
module.exports.rollups = $b2281880b189b3c1$var$rollups;

var $ceLHr = parcelRequire("ceLHr");

var $b2281880b189b3c1$var$_identity = $b2281880b189b3c1$var$_interopRequireDefault((parcelRequire("hHrVy")));
function $b2281880b189b3c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2281880b189b3c1$var$group(values, ...keys) {
    return $b2281880b189b3c1$var$nest(values, $b2281880b189b3c1$var$_identity.default, $b2281880b189b3c1$var$_identity.default, keys);
}
function $b2281880b189b3c1$var$groups(values, ...keys) {
    return $b2281880b189b3c1$var$nest(values, Array.from, $b2281880b189b3c1$var$_identity.default, keys);
}
function $b2281880b189b3c1$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $b2281880b189b3c1$var$flatGroup(values, ...keys) {
    return $b2281880b189b3c1$var$flatten($b2281880b189b3c1$var$groups(values, ...keys), keys);
}
function $b2281880b189b3c1$var$flatRollup(values, reduce, ...keys) {
    return $b2281880b189b3c1$var$flatten($b2281880b189b3c1$var$rollups(values, reduce, ...keys), keys);
}
function $b2281880b189b3c1$var$rollup(values, reduce, ...keys) {
    return $b2281880b189b3c1$var$nest(values, $b2281880b189b3c1$var$_identity.default, reduce, keys);
}
function $b2281880b189b3c1$var$rollups(values, reduce, ...keys) {
    return $b2281880b189b3c1$var$nest(values, Array.from, reduce, keys);
}
function $b2281880b189b3c1$var$index(values, ...keys) {
    return $b2281880b189b3c1$var$nest(values, $b2281880b189b3c1$var$_identity.default, $b2281880b189b3c1$var$unique, keys);
}
function $b2281880b189b3c1$var$indexes(values, ...keys) {
    return $b2281880b189b3c1$var$nest(values, Array.from, $b2281880b189b3c1$var$unique, keys);
}
function $b2281880b189b3c1$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $b2281880b189b3c1$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $ceLHr.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRequire.register("ceLHr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $8e8bcb036a0e8a05$var$InternMap extends Map {
    constructor(entries, key = $8e8bcb036a0e8a05$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($8e8bcb036a0e8a05$var$intern_get(this, key));
    }
    has(key) {
        return super.has($8e8bcb036a0e8a05$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($8e8bcb036a0e8a05$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($8e8bcb036a0e8a05$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $8e8bcb036a0e8a05$var$InternMap;
class $8e8bcb036a0e8a05$var$InternSet extends Set {
    constructor(values, key = $8e8bcb036a0e8a05$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($8e8bcb036a0e8a05$var$intern_get(this, value));
    }
    add(value) {
        return super.add($8e8bcb036a0e8a05$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($8e8bcb036a0e8a05$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $8e8bcb036a0e8a05$var$InternSet;
function $8e8bcb036a0e8a05$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $8e8bcb036a0e8a05$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $8e8bcb036a0e8a05$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $8e8bcb036a0e8a05$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRequire.register("hHrVy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce2c1d9e24dbc9c4$var$identity;
function $ce2c1d9e24dbc9c4$var$identity(x) {
    return x;
}

});


parcelRequire.register("4BIlO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35ad054088431236$var$groupSort;

var $35ad054088431236$var$_ascending = $35ad054088431236$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $35ad054088431236$var$_group = $35ad054088431236$var$_interopRequireWildcard((parcelRequire("fik3D")));

var $35ad054088431236$var$_sort = $35ad054088431236$var$_interopRequireDefault((parcelRequire("6ZoXk")));
function $35ad054088431236$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($35ad054088431236$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $35ad054088431236$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $35ad054088431236$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $35ad054088431236$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $35ad054088431236$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $35ad054088431236$var$_sort.default)((0, $35ad054088431236$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $35ad054088431236$var$_ascending.default)(av, bv) || (0, $35ad054088431236$var$_ascending.default)(ak, bk)) : (0, $35ad054088431236$var$_sort.default)((0, $35ad054088431236$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $35ad054088431236$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRequire.register("6ZoXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $516bcc49feceb659$var$ascendingDefined;
module.exports.compareDefined = $516bcc49feceb659$var$compareDefined;
module.exports.default = $516bcc49feceb659$var$sort;

var $516bcc49feceb659$var$_ascending = $516bcc49feceb659$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $516bcc49feceb659$var$_permute = $516bcc49feceb659$var$_interopRequireDefault((parcelRequire("3y5Qm")));
function $516bcc49feceb659$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $516bcc49feceb659$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $516bcc49feceb659$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$516bcc49feceb659$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $516bcc49feceb659$var$_permute.default)(values, index);
    }
    return values.sort($516bcc49feceb659$var$compareDefined(f));
}
function $516bcc49feceb659$var$compareDefined(compare = $516bcc49feceb659$var$_ascending.default) {
    if (compare === $516bcc49feceb659$var$_ascending.default) return $516bcc49feceb659$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $516bcc49feceb659$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRequire.register("3y5Qm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2959147b7838aa7f$var$permute;
function $2959147b7838aa7f$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRequire.register("jhAGn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e09c0f3fbb95a1d1$var$bin;

var $bU9uQ = parcelRequire("bU9uQ");

var $e09c0f3fbb95a1d1$var$_bisect = $e09c0f3fbb95a1d1$var$_interopRequireDefault((parcelRequire("7rWi4")));

var $e09c0f3fbb95a1d1$var$_constant = $e09c0f3fbb95a1d1$var$_interopRequireDefault((parcelRequire("dPDNb")));

var $e09c0f3fbb95a1d1$var$_extent = $e09c0f3fbb95a1d1$var$_interopRequireDefault((parcelRequire("i5zMJ")));

var $e09c0f3fbb95a1d1$var$_identity = $e09c0f3fbb95a1d1$var$_interopRequireDefault((parcelRequire("hHrVy")));

var $e09c0f3fbb95a1d1$var$_nice = $e09c0f3fbb95a1d1$var$_interopRequireDefault((parcelRequire("frKhl")));

var $e09c0f3fbb95a1d1$var$_ticks = $e09c0f3fbb95a1d1$var$_interopRequireWildcard((parcelRequire("5SJDB")));

var $e09c0f3fbb95a1d1$var$_sturges = $e09c0f3fbb95a1d1$var$_interopRequireDefault((parcelRequire("4xtzd")));
function $e09c0f3fbb95a1d1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e09c0f3fbb95a1d1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e09c0f3fbb95a1d1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e09c0f3fbb95a1d1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e09c0f3fbb95a1d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e09c0f3fbb95a1d1$var$bin() {
    var value = $e09c0f3fbb95a1d1$var$_identity.default, domain = $e09c0f3fbb95a1d1$var$_extent.default, threshold = $e09c0f3fbb95a1d1$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $e09c0f3fbb95a1d1$var$_extent.default) [x0, x1] = (0, $e09c0f3fbb95a1d1$var$_nice.default)(x0, x1, tn);
            tz = (0, $e09c0f3fbb95a1d1$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $e09c0f3fbb95a1d1$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $e09c0f3fbb95a1d1$var$_extent.default) {
                    const step = (0, $e09c0f3fbb95a1d1$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $e09c0f3fbb95a1d1$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $e09c0f3fbb95a1d1$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $e09c0f3fbb95a1d1$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $e09c0f3fbb95a1d1$var$_constant.default)($bU9uQ.slice.call(_)) : (0, $e09c0f3fbb95a1d1$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRequire.register("bU9uQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $8aac4a7ed34953b1$var$array = Array.prototype;
var $8aac4a7ed34953b1$var$slice = $8aac4a7ed34953b1$var$array.slice;
module.exports.slice = $8aac4a7ed34953b1$var$slice;
var $8aac4a7ed34953b1$var$map = $8aac4a7ed34953b1$var$array.map;
module.exports.map = $8aac4a7ed34953b1$var$map;

});

parcelRequire.register("dPDNb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a11ee7ad84933451$var$constant;
function $a11ee7ad84933451$var$constant(x) {
    return ()=>x;
}

});

parcelRequire.register("frKhl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3ed46a0a2dc8dca$var$nice;

var $5SJDB = parcelRequire("5SJDB");
function $b3ed46a0a2dc8dca$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $5SJDB.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRequire.register("5SJDB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4485659b95f182ed$var$ticks;
module.exports.tickIncrement = $4485659b95f182ed$var$tickIncrement;
module.exports.tickStep = $4485659b95f182ed$var$tickStep;
var $4485659b95f182ed$var$e10 = Math.sqrt(50), $4485659b95f182ed$var$e5 = Math.sqrt(10), $4485659b95f182ed$var$e2 = Math.sqrt(2);
function $4485659b95f182ed$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $4485659b95f182ed$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $4485659b95f182ed$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $4485659b95f182ed$var$e10 ? 10 : error >= $4485659b95f182ed$var$e5 ? 5 : error >= $4485659b95f182ed$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $4485659b95f182ed$var$e10 ? 10 : error >= $4485659b95f182ed$var$e5 ? 5 : error >= $4485659b95f182ed$var$e2 ? 2 : 1);
}
function $4485659b95f182ed$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $4485659b95f182ed$var$e10) step1 *= 10;
    else if (error >= $4485659b95f182ed$var$e5) step1 *= 5;
    else if (error >= $4485659b95f182ed$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRequire.register("4xtzd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34e12de05cbb6321$var$thresholdSturges;

var $34e12de05cbb6321$var$_count = $34e12de05cbb6321$var$_interopRequireDefault((parcelRequire("e5w7q")));
function $34e12de05cbb6321$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34e12de05cbb6321$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $34e12de05cbb6321$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRequire.register("viVD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $05e1942b3b71a9d0$var$thresholdFreedmanDiaconis;

var $05e1942b3b71a9d0$var$_count = $05e1942b3b71a9d0$var$_interopRequireDefault((parcelRequire("e5w7q")));

var $05e1942b3b71a9d0$var$_quantile = $05e1942b3b71a9d0$var$_interopRequireDefault((parcelRequire("6kpGw")));
function $05e1942b3b71a9d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $05e1942b3b71a9d0$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $05e1942b3b71a9d0$var$_quantile.default)(values, 0.75) - (0, $05e1942b3b71a9d0$var$_quantile.default)(values, 0.25)) * Math.pow((0, $05e1942b3b71a9d0$var$_count.default)(values), -1 / 3)));
}

});
parcelRequire.register("6kpGw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49b888cc7b9c705f$var$quantile;
module.exports.quantileSorted = $49b888cc7b9c705f$var$quantileSorted;

var $49b888cc7b9c705f$var$_max = $49b888cc7b9c705f$var$_interopRequireDefault((parcelRequire("hcRAa")));

var $49b888cc7b9c705f$var$_min = $49b888cc7b9c705f$var$_interopRequireDefault((parcelRequire("5UAfV")));

var $49b888cc7b9c705f$var$_quickselect = $49b888cc7b9c705f$var$_interopRequireDefault((parcelRequire("eeT17")));

var $49b888cc7b9c705f$var$_number = $49b888cc7b9c705f$var$_interopRequireWildcard((parcelRequire("3hemE")));
function $49b888cc7b9c705f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($49b888cc7b9c705f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $49b888cc7b9c705f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $49b888cc7b9c705f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $49b888cc7b9c705f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49b888cc7b9c705f$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $49b888cc7b9c705f$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $49b888cc7b9c705f$var$_min.default)(values);
    if (p >= 1) return (0, $49b888cc7b9c705f$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $49b888cc7b9c705f$var$_max.default)((0, $49b888cc7b9c705f$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $49b888cc7b9c705f$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $49b888cc7b9c705f$var$quantileSorted(values, p, valueof = $49b888cc7b9c705f$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRequire.register("hcRAa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c86d1f02be867e21$var$max;
function $c86d1f02be867e21$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRequire.register("5UAfV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44de4e5ac8684b00$var$min;
function $44de4e5ac8684b00$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRequire.register("eeT17", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a5dd0cb77818a3e3$var$quickselect;

var $6ZoXk = parcelRequire("6ZoXk");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $a5dd0cb77818a3e3$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $6ZoXk.ascendingDefined : (0, $6ZoXk.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $a5dd0cb77818a3e3$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $a5dd0cb77818a3e3$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $a5dd0cb77818a3e3$var$swap(array, left, right);
        while(i < j){
            $a5dd0cb77818a3e3$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $a5dd0cb77818a3e3$var$swap(array, left, j);
        else ++j, $a5dd0cb77818a3e3$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $a5dd0cb77818a3e3$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRequire.register("iQh5R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $db7a57bda458fa15$var$thresholdScott;

var $db7a57bda458fa15$var$_count = $db7a57bda458fa15$var$_interopRequireDefault((parcelRequire("e5w7q")));

var $db7a57bda458fa15$var$_deviation = $db7a57bda458fa15$var$_interopRequireDefault((parcelRequire("6lZuc")));
function $db7a57bda458fa15$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $db7a57bda458fa15$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $db7a57bda458fa15$var$_count.default)(values)) / (3.49 * (0, $db7a57bda458fa15$var$_deviation.default)(values)));
}

});

parcelRequire.register("llzPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8a75ae89f2d0c40$var$maxIndex;
function $f8a75ae89f2d0c40$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRequire.register("dLW6k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a06cbbcd7e7710dd$var$mean;
function $a06cbbcd7e7710dd$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRequire.register("3Yun1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e4e88976e1ebe36$var$median;

var $2e4e88976e1ebe36$var$_quantile = $2e4e88976e1ebe36$var$_interopRequireDefault((parcelRequire("6kpGw")));
function $2e4e88976e1ebe36$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2e4e88976e1ebe36$var$median(values, valueof) {
    return (0, $2e4e88976e1ebe36$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRequire.register("ibm3w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d3ca5ce8187aa63f$var$merge;
function* $d3ca5ce8187aa63f$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $d3ca5ce8187aa63f$var$merge(arrays) {
    return Array.from($d3ca5ce8187aa63f$var$flatten(arrays));
}

});

parcelRequire.register("53XOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3afba29f677bef13$var$minIndex;
function $3afba29f677bef13$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRequire.register("30bBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22fa5e78931a3c2e$var$mode;

var $ceLHr = parcelRequire("ceLHr");
function $22fa5e78931a3c2e$var$mode(values, valueof) {
    const counts = new $ceLHr.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRequire.register("gPT01", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c41c127d0375ae66$var$pairs;
module.exports.pair = $c41c127d0375ae66$var$pair;
function $c41c127d0375ae66$var$pairs(values, pairof = $c41c127d0375ae66$var$pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $c41c127d0375ae66$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRequire.register("dL0pY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a03ffd1f729a1f53$var$range;
function $a03ffd1f729a1f53$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRequire.register("d4CJK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9849b26d3f957cae$var$rank;

var $9849b26d3f957cae$var$_ascending = $9849b26d3f957cae$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $6ZoXk = parcelRequire("6ZoXk");
function $9849b26d3f957cae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9849b26d3f957cae$var$rank(values, valueof = $9849b26d3f957cae$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $9849b26d3f957cae$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $9849b26d3f957cae$var$_ascending.default ? (i, j)=>(0, $6ZoXk.ascendingDefined)(V[i], V[j]) : (0, $6ZoXk.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRequire.register("fwiEq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4c84fdcae4272bf$var$least;

var $b4c84fdcae4272bf$var$_ascending = $b4c84fdcae4272bf$var$_interopRequireDefault((parcelRequire("cNJLT")));
function $b4c84fdcae4272bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4c84fdcae4272bf$var$least(values, compare = $b4c84fdcae4272bf$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $b4c84fdcae4272bf$var$_ascending.default)(value, minValue) < 0 : (0, $b4c84fdcae4272bf$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRequire.register("5P50e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $43d598994b9701bd$var$leastIndex;

var $43d598994b9701bd$var$_ascending = $43d598994b9701bd$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $43d598994b9701bd$var$_minIndex = $43d598994b9701bd$var$_interopRequireDefault((parcelRequire("53XOV")));
function $43d598994b9701bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $43d598994b9701bd$var$leastIndex(values, compare = $43d598994b9701bd$var$_ascending.default) {
    if (compare.length === 1) return (0, $43d598994b9701bd$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRequire.register("11dNY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0be097d3c93bb12c$var$greatest;

var $0be097d3c93bb12c$var$_ascending = $0be097d3c93bb12c$var$_interopRequireDefault((parcelRequire("cNJLT")));
function $0be097d3c93bb12c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0be097d3c93bb12c$var$greatest(values, compare = $0be097d3c93bb12c$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $0be097d3c93bb12c$var$_ascending.default)(value, maxValue) > 0 : (0, $0be097d3c93bb12c$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRequire.register("e2MPN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3972211dc4a0801$var$greatestIndex;

var $a3972211dc4a0801$var$_ascending = $a3972211dc4a0801$var$_interopRequireDefault((parcelRequire("cNJLT")));

var $a3972211dc4a0801$var$_maxIndex = $a3972211dc4a0801$var$_interopRequireDefault((parcelRequire("llzPJ")));
function $a3972211dc4a0801$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a3972211dc4a0801$var$greatestIndex(values, compare = $a3972211dc4a0801$var$_ascending.default) {
    if (compare.length === 1) return (0, $a3972211dc4a0801$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRequire.register("4pXLU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3377dc9f18255d2e$var$scan;

var $3377dc9f18255d2e$var$_leastIndex = $3377dc9f18255d2e$var$_interopRequireDefault((parcelRequire("5P50e")));
function $3377dc9f18255d2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3377dc9f18255d2e$var$scan(values, compare) {
    const index = (0, $3377dc9f18255d2e$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRequire.register("imreS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $d5df6921a63e23b3$var$shuffler;
var $d5df6921a63e23b3$var$_default = $d5df6921a63e23b3$var$shuffler(Math.random);
module.exports.default = $d5df6921a63e23b3$var$_default;
function $d5df6921a63e23b3$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRequire.register("6D9Vx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d3e15e3ffc8cd75$var$sum;
function $4d3e15e3ffc8cd75$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRequire.register("i2CA8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d22657766be4e883$var$transpose;

var $d22657766be4e883$var$_min = $d22657766be4e883$var$_interopRequireDefault((parcelRequire("5UAfV")));
function $d22657766be4e883$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d22657766be4e883$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $d22657766be4e883$var$_min.default)(matrix, $d22657766be4e883$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $d22657766be4e883$var$length(d) {
    return d.length;
}

});

parcelRequire.register("dKGUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a030dace73c3bf41$var$zip;

var $a030dace73c3bf41$var$_transpose = $a030dace73c3bf41$var$_interopRequireDefault((parcelRequire("i2CA8")));
function $a030dace73c3bf41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a030dace73c3bf41$var$zip() {
    return (0, $a030dace73c3bf41$var$_transpose.default)(arguments);
}

});

parcelRequire.register("fBt7V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5c0e7b2e53cce2f$var$every;
function $b5c0e7b2e53cce2f$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRequire.register("ls1nB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9dd48743c9f0689$var$some;
function $f9dd48743c9f0689$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRequire.register("6XHxC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $511a07242aaa87ca$var$filter;
function $511a07242aaa87ca$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRequire.register("c0P9x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bed2a079213d09e$var$map;
function $8bed2a079213d09e$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRequire.register("9aqzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ac9a94ab28b961d$var$reduce;
function $6ac9a94ab28b961d$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRequire.register("6tJ5G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b786d94e66bad32$var$reverse;
function $4b786d94e66bad32$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRequire.register("9wEzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ef69444eb53ce14$var$difference;

var $ceLHr = parcelRequire("ceLHr");
function $6ef69444eb53ce14$var$difference(values, ...others) {
    values = new $ceLHr.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRequire.register("hG7na", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdec13f82472fb58$var$disjoint;

var $ceLHr = parcelRequire("ceLHr");
function $cdec13f82472fb58$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $ceLHr.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRequire.register("c8vEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d5ec8d1953d7e08$var$intersection;

var $ceLHr = parcelRequire("ceLHr");
function $8d5ec8d1953d7e08$var$intersection(values, ...others) {
    values = new $ceLHr.InternSet(values);
    others = others.map($8d5ec8d1953d7e08$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $8d5ec8d1953d7e08$var$set(values) {
    return values instanceof $ceLHr.InternSet ? values : new $ceLHr.InternSet(values);
}

});

parcelRequire.register("3fGQm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25e401a8a31e228b$var$subset;

var $25e401a8a31e228b$var$_superset = $25e401a8a31e228b$var$_interopRequireDefault((parcelRequire("4dlfq")));
function $25e401a8a31e228b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25e401a8a31e228b$var$subset(values, other) {
    return (0, $25e401a8a31e228b$var$_superset.default)(other, values);
}

});
parcelRequire.register("4dlfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3118dbac30ad6f0e$var$superset;
function $3118dbac30ad6f0e$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $3118dbac30ad6f0e$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $3118dbac30ad6f0e$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $3118dbac30ad6f0e$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRequire.register("1kgOT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0f74b4ccdbf98c36$var$union;

var $ceLHr = parcelRequire("ceLHr");
function $0f74b4ccdbf98c36$var$union(...others) {
    const set = new $ceLHr.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRequire.register("3HcC4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $2b0f2bf65dd7482a$var$initInterpolator;
module.exports.initRange = $2b0f2bf65dd7482a$var$initRange;
function $2b0f2bf65dd7482a$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $2b0f2bf65dd7482a$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRequire.register("ajjHF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $781af664e657c110$var$ordinal;
module.exports.implicit = void 0;

var $2ccY8 = parcelRequire("2ccY8");

var $3HcC4 = parcelRequire("3HcC4");
const $781af664e657c110$var$implicit = Symbol("implicit");
module.exports.implicit = $781af664e657c110$var$implicit;
function $781af664e657c110$var$ordinal() {
    var index = new $2ccY8.InternMap(), domain = [], range = [], unknown = $781af664e657c110$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $781af664e657c110$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $2ccY8.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $781af664e657c110$var$ordinal(domain, range).unknown(unknown);
    };
    $3HcC4.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRequire.register("75Oac", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $529fe97c122ea223$var$identity;

var $4bGV3 = parcelRequire("4bGV3");

var $529fe97c122ea223$var$_number = $529fe97c122ea223$var$_interopRequireDefault((parcelRequire("8IAF0")));
function $529fe97c122ea223$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $529fe97c122ea223$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $529fe97c122ea223$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $529fe97c122ea223$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $529fe97c122ea223$var$_number.default) : [
        0,
        1
    ];
    return (0, $4bGV3.linearish)(scale);
}

});
parcelRequire.register("4bGV3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30c97b581dcf4c83$var$linear;
module.exports.linearish = $30c97b581dcf4c83$var$linearish;

var $2ccY8 = parcelRequire("2ccY8");

var $30c97b581dcf4c83$var$_continuous = $30c97b581dcf4c83$var$_interopRequireWildcard((parcelRequire("4p545")));

var $3HcC4 = parcelRequire("3HcC4");

var $30c97b581dcf4c83$var$_tickFormat = $30c97b581dcf4c83$var$_interopRequireDefault((parcelRequire("5WBP3")));
function $30c97b581dcf4c83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $30c97b581dcf4c83$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($30c97b581dcf4c83$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $30c97b581dcf4c83$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $30c97b581dcf4c83$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $30c97b581dcf4c83$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $2ccY8.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $30c97b581dcf4c83$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $2ccY8.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $30c97b581dcf4c83$var$linear() {
    var scale = (0, $30c97b581dcf4c83$var$_continuous.default)();
    scale.copy = function() {
        return (0, $30c97b581dcf4c83$var$_continuous.copy)(scale, $30c97b581dcf4c83$var$linear());
    };
    $3HcC4.initRange.apply(scale, arguments);
    return $30c97b581dcf4c83$var$linearish(scale);
}

});
parcelRequire.register("4p545", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $334d6d08c3d65c0a$var$copy;
module.exports.default = $334d6d08c3d65c0a$var$continuous;
module.exports.identity = $334d6d08c3d65c0a$var$identity;
module.exports.transformer = $334d6d08c3d65c0a$var$transformer;

var $2ccY8 = parcelRequire("2ccY8");

var $kHNFO = parcelRequire("kHNFO");

var $334d6d08c3d65c0a$var$_constant = $334d6d08c3d65c0a$var$_interopRequireDefault((parcelRequire("9HFYh")));

var $334d6d08c3d65c0a$var$_number = $334d6d08c3d65c0a$var$_interopRequireDefault((parcelRequire("8IAF0")));
function $334d6d08c3d65c0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $334d6d08c3d65c0a$var$unit = [
    0,
    1
];
function $334d6d08c3d65c0a$var$identity(x) {
    return x;
}
function $334d6d08c3d65c0a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $334d6d08c3d65c0a$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $334d6d08c3d65c0a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $334d6d08c3d65c0a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $334d6d08c3d65c0a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $334d6d08c3d65c0a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $334d6d08c3d65c0a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $334d6d08c3d65c0a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $2ccY8.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $334d6d08c3d65c0a$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $334d6d08c3d65c0a$var$transformer() {
    var domain = $334d6d08c3d65c0a$var$unit, range = $334d6d08c3d65c0a$var$unit, interpolate = $kHNFO.interpolate, transform, untransform, unknown, clamp = $334d6d08c3d65c0a$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $334d6d08c3d65c0a$var$identity) clamp = $334d6d08c3d65c0a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $334d6d08c3d65c0a$var$polymap : $334d6d08c3d65c0a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $kHNFO.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $334d6d08c3d65c0a$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $kHNFO.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $334d6d08c3d65c0a$var$identity, rescale()) : clamp !== $334d6d08c3d65c0a$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $334d6d08c3d65c0a$var$continuous() {
    return $334d6d08c3d65c0a$var$transformer()($334d6d08c3d65c0a$var$identity, $334d6d08c3d65c0a$var$identity);
}

});
parcelRequire.register("kHNFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $jaR8w.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $jaR8w.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $f12e5ae8f5034bce$var$_quantize.default;
    }
});

var $f12e5ae8f5034bce$var$_value = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("1xvti")));

var $f12e5ae8f5034bce$var$_array = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("dFnAM")));

var $f12e5ae8f5034bce$var$_basis = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("eueo4")));

var $f12e5ae8f5034bce$var$_basisClosed = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("fGZLb")));

var $f12e5ae8f5034bce$var$_date = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("eYobz")));

var $f12e5ae8f5034bce$var$_discrete = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("dkmE5")));

var $f12e5ae8f5034bce$var$_hue = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("kYUih")));

var $f12e5ae8f5034bce$var$_number = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("knLJE")));

var $f12e5ae8f5034bce$var$_numberArray = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("8G1iw")));

var $f12e5ae8f5034bce$var$_object = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("99Eat")));

var $f12e5ae8f5034bce$var$_round = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("bpCqE")));

var $f12e5ae8f5034bce$var$_string = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("kVsyi")));

var $jaR8w = parcelRequire("jaR8w");

var $f12e5ae8f5034bce$var$_zoom = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("1MBi7")));

var $f12e5ae8f5034bce$var$_rgb = $f12e5ae8f5034bce$var$_interopRequireWildcard((parcelRequire("hxzkQ")));

var $f12e5ae8f5034bce$var$_hsl = $f12e5ae8f5034bce$var$_interopRequireWildcard((parcelRequire("jj4sq")));

var $f12e5ae8f5034bce$var$_lab = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("nNUku")));

var $f12e5ae8f5034bce$var$_hcl = $f12e5ae8f5034bce$var$_interopRequireWildcard((parcelRequire("kunpT")));

var $f12e5ae8f5034bce$var$_cubehelix = $f12e5ae8f5034bce$var$_interopRequireWildcard((parcelRequire("3HfZg")));

var $f12e5ae8f5034bce$var$_piecewise = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("bVjfd")));

var $f12e5ae8f5034bce$var$_quantize = $f12e5ae8f5034bce$var$_interopRequireDefault((parcelRequire("kovOP")));
function $f12e5ae8f5034bce$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f12e5ae8f5034bce$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f12e5ae8f5034bce$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f12e5ae8f5034bce$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f12e5ae8f5034bce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("1xvti", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11f1491e11389f6d$var$_default;

var $1GKl5 = parcelRequire("1GKl5");

var $11f1491e11389f6d$var$_rgb = $11f1491e11389f6d$var$_interopRequireDefault((parcelRequire("hxzkQ")));

var $dFnAM = parcelRequire("dFnAM");

var $11f1491e11389f6d$var$_date = $11f1491e11389f6d$var$_interopRequireDefault((parcelRequire("eYobz")));

var $11f1491e11389f6d$var$_number = $11f1491e11389f6d$var$_interopRequireDefault((parcelRequire("knLJE")));

var $11f1491e11389f6d$var$_object = $11f1491e11389f6d$var$_interopRequireDefault((parcelRequire("99Eat")));

var $11f1491e11389f6d$var$_string = $11f1491e11389f6d$var$_interopRequireDefault((parcelRequire("kVsyi")));

var $11f1491e11389f6d$var$_constant = $11f1491e11389f6d$var$_interopRequireDefault((parcelRequire("69R6B")));

var $11f1491e11389f6d$var$_numberArray = $11f1491e11389f6d$var$_interopRequireWildcard((parcelRequire("8G1iw")));
function $11f1491e11389f6d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($11f1491e11389f6d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $11f1491e11389f6d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $11f1491e11389f6d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $11f1491e11389f6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11f1491e11389f6d$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $11f1491e11389f6d$var$_constant.default)(b) : (t === "number" ? $11f1491e11389f6d$var$_number.default : t === "string" ? (c = (0, $1GKl5.color)(b)) ? (b = c, $11f1491e11389f6d$var$_rgb.default) : $11f1491e11389f6d$var$_string.default : b instanceof $1GKl5.color ? $11f1491e11389f6d$var$_rgb.default : b instanceof Date ? $11f1491e11389f6d$var$_date.default : (0, $11f1491e11389f6d$var$_numberArray.isNumberArray)(b) ? $11f1491e11389f6d$var$_numberArray.default : Array.isArray(b) ? $dFnAM.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $11f1491e11389f6d$var$_object.default : $11f1491e11389f6d$var$_number.default)(a, b);
}

});
parcelRequire.register("1GKl5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $13ada8afd7cd8bfe$var$_color.rgb;
    }
});

var $13ada8afd7cd8bfe$var$_color = $13ada8afd7cd8bfe$var$_interopRequireWildcard((parcelRequire("andni")));

var $13ada8afd7cd8bfe$var$_lab = $13ada8afd7cd8bfe$var$_interopRequireWildcard((parcelRequire("5YP1g")));

var $13ada8afd7cd8bfe$var$_cubehelix = $13ada8afd7cd8bfe$var$_interopRequireDefault((parcelRequire("3yUZE")));
function $13ada8afd7cd8bfe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $13ada8afd7cd8bfe$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($13ada8afd7cd8bfe$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $13ada8afd7cd8bfe$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $13ada8afd7cd8bfe$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("andni", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Color = $78d66d50bb147d0f$var$Color;
module.exports.Rgb = $78d66d50bb147d0f$var$Rgb;
module.exports.darker = module.exports.brighter = void 0;
module.exports.default = $78d66d50bb147d0f$var$color;
module.exports.hsl = $78d66d50bb147d0f$var$hsl;
module.exports.hslConvert = $78d66d50bb147d0f$var$hslConvert;
module.exports.rgb = $78d66d50bb147d0f$var$rgb;
module.exports.rgbConvert = $78d66d50bb147d0f$var$rgbConvert;

var $78d66d50bb147d0f$var$_define = $78d66d50bb147d0f$var$_interopRequireWildcard((parcelRequire("kCvXz")));
function $78d66d50bb147d0f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($78d66d50bb147d0f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $78d66d50bb147d0f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $78d66d50bb147d0f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $78d66d50bb147d0f$var$Color() {}
var $78d66d50bb147d0f$var$darker = 0.7;
module.exports.darker = $78d66d50bb147d0f$var$darker;
var $78d66d50bb147d0f$var$brighter = 1 / $78d66d50bb147d0f$var$darker;
module.exports.brighter = $78d66d50bb147d0f$var$brighter;
var $78d66d50bb147d0f$var$reI = "\\s*([+-]?\\d+)\\s*", $78d66d50bb147d0f$var$reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", $78d66d50bb147d0f$var$reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $78d66d50bb147d0f$var$reHex = /^#([0-9a-f]{3,8})$/, $78d66d50bb147d0f$var$reRgbInteger = new RegExp(`^rgb\\(${$78d66d50bb147d0f$var$reI},${$78d66d50bb147d0f$var$reI},${$78d66d50bb147d0f$var$reI}\\)$`), $78d66d50bb147d0f$var$reRgbPercent = new RegExp(`^rgb\\(${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reP}\\)$`), $78d66d50bb147d0f$var$reRgbaInteger = new RegExp(`^rgba\\(${$78d66d50bb147d0f$var$reI},${$78d66d50bb147d0f$var$reI},${$78d66d50bb147d0f$var$reI},${$78d66d50bb147d0f$var$reN}\\)$`), $78d66d50bb147d0f$var$reRgbaPercent = new RegExp(`^rgba\\(${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reN}\\)$`), $78d66d50bb147d0f$var$reHslPercent = new RegExp(`^hsl\\(${$78d66d50bb147d0f$var$reN},${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reP}\\)$`), $78d66d50bb147d0f$var$reHslaPercent = new RegExp(`^hsla\\(${$78d66d50bb147d0f$var$reN},${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reP},${$78d66d50bb147d0f$var$reN}\\)$`);
var $78d66d50bb147d0f$var$named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $78d66d50bb147d0f$var$_define.default)($78d66d50bb147d0f$var$Color, $78d66d50bb147d0f$var$color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: $78d66d50bb147d0f$var$color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $78d66d50bb147d0f$var$color_formatHex,
    formatHex8: $78d66d50bb147d0f$var$color_formatHex8,
    formatHsl: $78d66d50bb147d0f$var$color_formatHsl,
    formatRgb: $78d66d50bb147d0f$var$color_formatRgb,
    toString: $78d66d50bb147d0f$var$color_formatRgb
});
function $78d66d50bb147d0f$var$color_formatHex() {
    return this.rgb().formatHex();
}
function $78d66d50bb147d0f$var$color_formatHex8() {
    return this.rgb().formatHex8();
}
function $78d66d50bb147d0f$var$color_formatHsl() {
    return $78d66d50bb147d0f$var$hslConvert(this).formatHsl();
}
function $78d66d50bb147d0f$var$color_formatRgb() {
    return this.rgb().formatRgb();
}
function $78d66d50bb147d0f$var$color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = $78d66d50bb147d0f$var$reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? $78d66d50bb147d0f$var$rgbn(m) // #ff0000
     : l === 3 ? new $78d66d50bb147d0f$var$Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? $78d66d50bb147d0f$var$rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? $78d66d50bb147d0f$var$rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = $78d66d50bb147d0f$var$reRgbInteger.exec(format)) ? new $78d66d50bb147d0f$var$Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = $78d66d50bb147d0f$var$reRgbPercent.exec(format)) ? new $78d66d50bb147d0f$var$Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = $78d66d50bb147d0f$var$reRgbaInteger.exec(format)) ? $78d66d50bb147d0f$var$rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = $78d66d50bb147d0f$var$reRgbaPercent.exec(format)) ? $78d66d50bb147d0f$var$rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = $78d66d50bb147d0f$var$reHslPercent.exec(format)) ? $78d66d50bb147d0f$var$hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = $78d66d50bb147d0f$var$reHslaPercent.exec(format)) ? $78d66d50bb147d0f$var$hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : $78d66d50bb147d0f$var$named.hasOwnProperty(format) ? $78d66d50bb147d0f$var$rgbn($78d66d50bb147d0f$var$named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new $78d66d50bb147d0f$var$Rgb(NaN, NaN, NaN, 0) : null;
}
function $78d66d50bb147d0f$var$rgbn(n) {
    return new $78d66d50bb147d0f$var$Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function $78d66d50bb147d0f$var$rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new $78d66d50bb147d0f$var$Rgb(r, g, b, a);
}
function $78d66d50bb147d0f$var$rgbConvert(o) {
    if (!(o instanceof $78d66d50bb147d0f$var$Color)) o = $78d66d50bb147d0f$var$color(o);
    if (!o) return new $78d66d50bb147d0f$var$Rgb();
    o = o.rgb();
    return new $78d66d50bb147d0f$var$Rgb(o.r, o.g, o.b, o.opacity);
}
function $78d66d50bb147d0f$var$rgb(r, g, b, opacity) {
    return arguments.length === 1 ? $78d66d50bb147d0f$var$rgbConvert(r) : new $78d66d50bb147d0f$var$Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function $78d66d50bb147d0f$var$Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $78d66d50bb147d0f$var$_define.default)($78d66d50bb147d0f$var$Rgb, $78d66d50bb147d0f$var$rgb, (0, $78d66d50bb147d0f$var$_define.extend)($78d66d50bb147d0f$var$Color, {
    brighter (k) {
        k = k == null ? $78d66d50bb147d0f$var$brighter : Math.pow($78d66d50bb147d0f$var$brighter, k);
        return new $78d66d50bb147d0f$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $78d66d50bb147d0f$var$darker : Math.pow($78d66d50bb147d0f$var$darker, k);
        return new $78d66d50bb147d0f$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new $78d66d50bb147d0f$var$Rgb($78d66d50bb147d0f$var$clampi(this.r), $78d66d50bb147d0f$var$clampi(this.g), $78d66d50bb147d0f$var$clampi(this.b), $78d66d50bb147d0f$var$clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $78d66d50bb147d0f$var$rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $78d66d50bb147d0f$var$rgb_formatHex,
    formatHex8: $78d66d50bb147d0f$var$rgb_formatHex8,
    formatRgb: $78d66d50bb147d0f$var$rgb_formatRgb,
    toString: $78d66d50bb147d0f$var$rgb_formatRgb
}));
function $78d66d50bb147d0f$var$rgb_formatHex() {
    return `#${$78d66d50bb147d0f$var$hex(this.r)}${$78d66d50bb147d0f$var$hex(this.g)}${$78d66d50bb147d0f$var$hex(this.b)}`;
}
function $78d66d50bb147d0f$var$rgb_formatHex8() {
    return `#${$78d66d50bb147d0f$var$hex(this.r)}${$78d66d50bb147d0f$var$hex(this.g)}${$78d66d50bb147d0f$var$hex(this.b)}${$78d66d50bb147d0f$var$hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function $78d66d50bb147d0f$var$rgb_formatRgb() {
    const a = $78d66d50bb147d0f$var$clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${$78d66d50bb147d0f$var$clampi(this.r)}, ${$78d66d50bb147d0f$var$clampi(this.g)}, ${$78d66d50bb147d0f$var$clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function $78d66d50bb147d0f$var$clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function $78d66d50bb147d0f$var$clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function $78d66d50bb147d0f$var$hex(value) {
    value = $78d66d50bb147d0f$var$clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function $78d66d50bb147d0f$var$hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new $78d66d50bb147d0f$var$Hsl(h, s, l, a);
}
function $78d66d50bb147d0f$var$hslConvert(o) {
    if (o instanceof $78d66d50bb147d0f$var$Hsl) return new $78d66d50bb147d0f$var$Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $78d66d50bb147d0f$var$Color)) o = $78d66d50bb147d0f$var$color(o);
    if (!o) return new $78d66d50bb147d0f$var$Hsl();
    if (o instanceof $78d66d50bb147d0f$var$Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new $78d66d50bb147d0f$var$Hsl(h, s, l, o.opacity);
}
function $78d66d50bb147d0f$var$hsl(h, s, l, opacity) {
    return arguments.length === 1 ? $78d66d50bb147d0f$var$hslConvert(h) : new $78d66d50bb147d0f$var$Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function $78d66d50bb147d0f$var$Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $78d66d50bb147d0f$var$_define.default)($78d66d50bb147d0f$var$Hsl, $78d66d50bb147d0f$var$hsl, (0, $78d66d50bb147d0f$var$_define.extend)($78d66d50bb147d0f$var$Color, {
    brighter (k) {
        k = k == null ? $78d66d50bb147d0f$var$brighter : Math.pow($78d66d50bb147d0f$var$brighter, k);
        return new $78d66d50bb147d0f$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $78d66d50bb147d0f$var$darker : Math.pow($78d66d50bb147d0f$var$darker, k);
        return new $78d66d50bb147d0f$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new $78d66d50bb147d0f$var$Rgb($78d66d50bb147d0f$var$hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), $78d66d50bb147d0f$var$hsl2rgb(h, m1, m2), $78d66d50bb147d0f$var$hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new $78d66d50bb147d0f$var$Hsl($78d66d50bb147d0f$var$clamph(this.h), $78d66d50bb147d0f$var$clampt(this.s), $78d66d50bb147d0f$var$clampt(this.l), $78d66d50bb147d0f$var$clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = $78d66d50bb147d0f$var$clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${$78d66d50bb147d0f$var$clamph(this.h)}, ${$78d66d50bb147d0f$var$clampt(this.s) * 100}%, ${$78d66d50bb147d0f$var$clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function $78d66d50bb147d0f$var$clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function $78d66d50bb147d0f$var$clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function $78d66d50bb147d0f$var$hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRequire.register("kCvXz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f03025cb370f3167$var$_default;
module.exports.extend = $f03025cb370f3167$var$extend;
function $f03025cb370f3167$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $f03025cb370f3167$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRequire.register("5YP1g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $45aa21c2ade6bcb7$var$Hcl;
module.exports.Lab = $45aa21c2ade6bcb7$var$Lab;
module.exports.default = $45aa21c2ade6bcb7$var$lab;
module.exports.gray = $45aa21c2ade6bcb7$var$gray;
module.exports.hcl = $45aa21c2ade6bcb7$var$hcl;
module.exports.lch = $45aa21c2ade6bcb7$var$lch;

var $45aa21c2ade6bcb7$var$_define = $45aa21c2ade6bcb7$var$_interopRequireWildcard((parcelRequire("kCvXz")));

var $andni = parcelRequire("andni");

var $3yTsf = parcelRequire("3yTsf");
function $45aa21c2ade6bcb7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($45aa21c2ade6bcb7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $45aa21c2ade6bcb7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $45aa21c2ade6bcb7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $45aa21c2ade6bcb7$var$K = 18, $45aa21c2ade6bcb7$var$Xn = 0.96422, $45aa21c2ade6bcb7$var$Yn = 1, $45aa21c2ade6bcb7$var$Zn = 0.82521, $45aa21c2ade6bcb7$var$t0 = 4 / 29, $45aa21c2ade6bcb7$var$t1 = 6 / 29, $45aa21c2ade6bcb7$var$t2 = 3 * $45aa21c2ade6bcb7$var$t1 * $45aa21c2ade6bcb7$var$t1, $45aa21c2ade6bcb7$var$t3 = $45aa21c2ade6bcb7$var$t1 * $45aa21c2ade6bcb7$var$t1 * $45aa21c2ade6bcb7$var$t1;
function $45aa21c2ade6bcb7$var$labConvert(o) {
    if (o instanceof $45aa21c2ade6bcb7$var$Lab) return new $45aa21c2ade6bcb7$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $45aa21c2ade6bcb7$var$Hcl) return $45aa21c2ade6bcb7$var$hcl2lab(o);
    if (!(o instanceof $andni.Rgb)) o = (0, $andni.rgbConvert)(o);
    var r = $45aa21c2ade6bcb7$var$rgb2lrgb(o.r), g = $45aa21c2ade6bcb7$var$rgb2lrgb(o.g), b = $45aa21c2ade6bcb7$var$rgb2lrgb(o.b), y = $45aa21c2ade6bcb7$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $45aa21c2ade6bcb7$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $45aa21c2ade6bcb7$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $45aa21c2ade6bcb7$var$Xn);
        z = $45aa21c2ade6bcb7$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $45aa21c2ade6bcb7$var$Zn);
    }
    return new $45aa21c2ade6bcb7$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $45aa21c2ade6bcb7$var$gray(l, opacity) {
    return new $45aa21c2ade6bcb7$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $45aa21c2ade6bcb7$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $45aa21c2ade6bcb7$var$labConvert(l) : new $45aa21c2ade6bcb7$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $45aa21c2ade6bcb7$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $45aa21c2ade6bcb7$var$_define.default)($45aa21c2ade6bcb7$var$Lab, $45aa21c2ade6bcb7$var$lab, (0, $45aa21c2ade6bcb7$var$_define.extend)($andni.Color, {
    brighter (k) {
        return new $45aa21c2ade6bcb7$var$Lab(this.l + $45aa21c2ade6bcb7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $45aa21c2ade6bcb7$var$Lab(this.l - $45aa21c2ade6bcb7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $45aa21c2ade6bcb7$var$Xn * $45aa21c2ade6bcb7$var$lab2xyz(x);
        y = $45aa21c2ade6bcb7$var$Yn * $45aa21c2ade6bcb7$var$lab2xyz(y);
        z = $45aa21c2ade6bcb7$var$Zn * $45aa21c2ade6bcb7$var$lab2xyz(z);
        return new $andni.Rgb($45aa21c2ade6bcb7$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $45aa21c2ade6bcb7$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $45aa21c2ade6bcb7$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $45aa21c2ade6bcb7$var$xyz2lab(t) {
    return t > $45aa21c2ade6bcb7$var$t3 ? Math.pow(t, 1 / 3) : t / $45aa21c2ade6bcb7$var$t2 + $45aa21c2ade6bcb7$var$t0;
}
function $45aa21c2ade6bcb7$var$lab2xyz(t) {
    return t > $45aa21c2ade6bcb7$var$t1 ? t * t * t : $45aa21c2ade6bcb7$var$t2 * (t - $45aa21c2ade6bcb7$var$t0);
}
function $45aa21c2ade6bcb7$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $45aa21c2ade6bcb7$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $45aa21c2ade6bcb7$var$hclConvert(o) {
    if (o instanceof $45aa21c2ade6bcb7$var$Hcl) return new $45aa21c2ade6bcb7$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $45aa21c2ade6bcb7$var$Lab)) o = $45aa21c2ade6bcb7$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $45aa21c2ade6bcb7$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $3yTsf.degrees;
    return new $45aa21c2ade6bcb7$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $45aa21c2ade6bcb7$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $45aa21c2ade6bcb7$var$hclConvert(l) : new $45aa21c2ade6bcb7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $45aa21c2ade6bcb7$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $45aa21c2ade6bcb7$var$hclConvert(h) : new $45aa21c2ade6bcb7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $45aa21c2ade6bcb7$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $45aa21c2ade6bcb7$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $45aa21c2ade6bcb7$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $3yTsf.radians;
    return new $45aa21c2ade6bcb7$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $45aa21c2ade6bcb7$var$_define.default)($45aa21c2ade6bcb7$var$Hcl, $45aa21c2ade6bcb7$var$hcl, (0, $45aa21c2ade6bcb7$var$_define.extend)($andni.Color, {
    brighter (k) {
        return new $45aa21c2ade6bcb7$var$Hcl(this.h, this.c, this.l + $45aa21c2ade6bcb7$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $45aa21c2ade6bcb7$var$Hcl(this.h, this.c, this.l - $45aa21c2ade6bcb7$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $45aa21c2ade6bcb7$var$hcl2lab(this).rgb();
    }
}));

});
parcelRequire.register("3yTsf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $297f902e053ed394$var$radians = Math.PI / 180;
module.exports.radians = $297f902e053ed394$var$radians;
const $297f902e053ed394$var$degrees = 180 / Math.PI;
module.exports.degrees = $297f902e053ed394$var$degrees;

});


parcelRequire.register("3yUZE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $2980c1c7db109ae8$var$Cubehelix;
module.exports.default = $2980c1c7db109ae8$var$cubehelix;

var $2980c1c7db109ae8$var$_define = $2980c1c7db109ae8$var$_interopRequireWildcard((parcelRequire("kCvXz")));

var $andni = parcelRequire("andni");

var $3yTsf = parcelRequire("3yTsf");
function $2980c1c7db109ae8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2980c1c7db109ae8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2980c1c7db109ae8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2980c1c7db109ae8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $2980c1c7db109ae8$var$A = -0.14861, $2980c1c7db109ae8$var$B = 1.78277, $2980c1c7db109ae8$var$C = -0.29227, $2980c1c7db109ae8$var$D = -0.90649, $2980c1c7db109ae8$var$E = 1.97294, $2980c1c7db109ae8$var$ED = $2980c1c7db109ae8$var$E * $2980c1c7db109ae8$var$D, $2980c1c7db109ae8$var$EB = $2980c1c7db109ae8$var$E * $2980c1c7db109ae8$var$B, $2980c1c7db109ae8$var$BC_DA = $2980c1c7db109ae8$var$B * $2980c1c7db109ae8$var$C - $2980c1c7db109ae8$var$D * $2980c1c7db109ae8$var$A;
function $2980c1c7db109ae8$var$cubehelixConvert(o) {
    if (o instanceof $2980c1c7db109ae8$var$Cubehelix) return new $2980c1c7db109ae8$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $andni.Rgb)) o = (0, $andni.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($2980c1c7db109ae8$var$BC_DA * b + $2980c1c7db109ae8$var$ED * r - $2980c1c7db109ae8$var$EB * g) / ($2980c1c7db109ae8$var$BC_DA + $2980c1c7db109ae8$var$ED - $2980c1c7db109ae8$var$EB), bl = b - l, k = ($2980c1c7db109ae8$var$E * (g - l) - $2980c1c7db109ae8$var$C * bl) / $2980c1c7db109ae8$var$D, s = Math.sqrt(k * k + bl * bl) / ($2980c1c7db109ae8$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $3yTsf.degrees - 120 : NaN;
    return new $2980c1c7db109ae8$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $2980c1c7db109ae8$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $2980c1c7db109ae8$var$cubehelixConvert(h) : new $2980c1c7db109ae8$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $2980c1c7db109ae8$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $2980c1c7db109ae8$var$_define.default)($2980c1c7db109ae8$var$Cubehelix, $2980c1c7db109ae8$var$cubehelix, (0, $2980c1c7db109ae8$var$_define.extend)($andni.Color, {
    brighter (k) {
        k = k == null ? $andni.brighter : Math.pow($andni.brighter, k);
        return new $2980c1c7db109ae8$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $andni.darker : Math.pow($andni.darker, k);
        return new $2980c1c7db109ae8$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $3yTsf.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $andni.Rgb(255 * (l + a * ($2980c1c7db109ae8$var$A * cosh + $2980c1c7db109ae8$var$B * sinh)), 255 * (l + a * ($2980c1c7db109ae8$var$C * cosh + $2980c1c7db109ae8$var$D * sinh)), 255 * (l + a * ($2980c1c7db109ae8$var$E * cosh)), this.opacity);
    }
}));

});


parcelRequire.register("hxzkQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $1GKl5 = parcelRequire("1GKl5");

var $cc50ed935800f3cd$var$_basis = $cc50ed935800f3cd$var$_interopRequireDefault((parcelRequire("eueo4")));

var $cc50ed935800f3cd$var$_basisClosed = $cc50ed935800f3cd$var$_interopRequireDefault((parcelRequire("fGZLb")));

var $cc50ed935800f3cd$var$_color = $cc50ed935800f3cd$var$_interopRequireWildcard((parcelRequire("c1q0U")));
function $cc50ed935800f3cd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cc50ed935800f3cd$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cc50ed935800f3cd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cc50ed935800f3cd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cc50ed935800f3cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cc50ed935800f3cd$var$_default = function rgbGamma(y) {
    var color = (0, $cc50ed935800f3cd$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $1GKl5.rgb)(start)).r, (end = (0, $1GKl5.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $cc50ed935800f3cd$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $cc50ed935800f3cd$var$_default;
function $cc50ed935800f3cd$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $1GKl5.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $cc50ed935800f3cd$var$rgbBasis = $cc50ed935800f3cd$var$rgbSpline($cc50ed935800f3cd$var$_basis.default);
module.exports.rgbBasis = $cc50ed935800f3cd$var$rgbBasis;
var $cc50ed935800f3cd$var$rgbBasisClosed = $cc50ed935800f3cd$var$rgbSpline($cc50ed935800f3cd$var$_basisClosed.default);
module.exports.rgbBasisClosed = $cc50ed935800f3cd$var$rgbBasisClosed;

});
parcelRequire.register("eueo4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $a8bf070b521359fb$var$basis;
module.exports.default = $a8bf070b521359fb$var$_default;
function $a8bf070b521359fb$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $a8bf070b521359fb$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $a8bf070b521359fb$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("fGZLb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6caaf8572b744c5$var$_default;

var $eueo4 = parcelRequire("eueo4");
function $b6caaf8572b744c5$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $eueo4.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("c1q0U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c09c1cd710a8807$var$nogamma;
module.exports.gamma = $8c09c1cd710a8807$var$gamma;
module.exports.hue = $8c09c1cd710a8807$var$hue;

var $8c09c1cd710a8807$var$_constant = $8c09c1cd710a8807$var$_interopRequireDefault((parcelRequire("69R6B")));
function $8c09c1cd710a8807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c09c1cd710a8807$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $8c09c1cd710a8807$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $8c09c1cd710a8807$var$hue(a, b) {
    var d = b - a;
    return d ? $8c09c1cd710a8807$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $8c09c1cd710a8807$var$_constant.default)(isNaN(a) ? b : a);
}
function $8c09c1cd710a8807$var$gamma(y) {
    return (y = +y) === 1 ? $8c09c1cd710a8807$var$nogamma : function(a, b) {
        return b - a ? $8c09c1cd710a8807$var$exponential(a, b, y) : (0, $8c09c1cd710a8807$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $8c09c1cd710a8807$var$nogamma(a, b) {
    var d = b - a;
    return d ? $8c09c1cd710a8807$var$linear(a, d) : (0, $8c09c1cd710a8807$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRequire.register("69R6B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $47bcc6f85fb69fdd$var$_default = (x)=>()=>x;
module.exports.default = $47bcc6f85fb69fdd$var$_default;

});



parcelRequire.register("dFnAM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f31679f595624cb$var$_default;
module.exports.genericArray = $9f31679f595624cb$var$genericArray;

var $9f31679f595624cb$var$_value = $9f31679f595624cb$var$_interopRequireDefault((parcelRequire("1xvti")));

var $9f31679f595624cb$var$_numberArray = $9f31679f595624cb$var$_interopRequireWildcard((parcelRequire("8G1iw")));
function $9f31679f595624cb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9f31679f595624cb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9f31679f595624cb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9f31679f595624cb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9f31679f595624cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f31679f595624cb$var$_default(a, b) {
    return ((0, $9f31679f595624cb$var$_numberArray.isNumberArray)(b) ? $9f31679f595624cb$var$_numberArray.default : $9f31679f595624cb$var$genericArray)(a, b);
}
function $9f31679f595624cb$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $9f31679f595624cb$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRequire.register("8G1iw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $651340afed5e146e$var$_default;
module.exports.isNumberArray = $651340afed5e146e$var$isNumberArray;
function $651340afed5e146e$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $651340afed5e146e$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRequire.register("eYobz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae696e0f0c1175ed$var$_default;
function $ae696e0f0c1175ed$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRequire.register("knLJE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed6afbdbe9162a90$var$_default;
function $ed6afbdbe9162a90$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRequire.register("99Eat", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6aa41cd14516904f$var$_default;

var $6aa41cd14516904f$var$_value = $6aa41cd14516904f$var$_interopRequireDefault((parcelRequire("1xvti")));
function $6aa41cd14516904f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6aa41cd14516904f$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $6aa41cd14516904f$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRequire.register("kVsyi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3bf4767c61a5f74$var$_default;

var $f3bf4767c61a5f74$var$_number = $f3bf4767c61a5f74$var$_interopRequireDefault((parcelRequire("knLJE")));
function $f3bf4767c61a5f74$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f3bf4767c61a5f74$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $f3bf4767c61a5f74$var$reB = new RegExp($f3bf4767c61a5f74$var$reA.source, "g");
function $f3bf4767c61a5f74$var$zero(b) {
    return function() {
        return b;
    };
}
function $f3bf4767c61a5f74$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $f3bf4767c61a5f74$var$_default(a, b) {
    var bi = $f3bf4767c61a5f74$var$reA.lastIndex = $f3bf4767c61a5f74$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $f3bf4767c61a5f74$var$reA.exec(a)) && (bm = $f3bf4767c61a5f74$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $f3bf4767c61a5f74$var$_number.default)(am, bm)
            });
        }
        bi = $f3bf4767c61a5f74$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $f3bf4767c61a5f74$var$one(q[0].x) : $f3bf4767c61a5f74$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRequire.register("dkmE5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b3eb58c8ea1c3db$var$_default;
function $9b3eb58c8ea1c3db$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRequire.register("kYUih", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4651400b3623ea3$var$_default;

var $c1q0U = parcelRequire("c1q0U");
function $f4651400b3623ea3$var$_default(a, b) {
    var i = (0, $c1q0U.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRequire.register("bpCqE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84efd6b438031332$var$_default;
function $84efd6b438031332$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRequire.register("jaR8w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $df582b4c1d01f444$var$_number = $df582b4c1d01f444$var$_interopRequireDefault((parcelRequire("knLJE")));

var $2gywi = parcelRequire("2gywi");
function $df582b4c1d01f444$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $df582b4c1d01f444$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $df582b4c1d01f444$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $df582b4c1d01f444$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $df582b4c1d01f444$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $df582b4c1d01f444$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $df582b4c1d01f444$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $df582b4c1d01f444$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $df582b4c1d01f444$var$interpolateTransformCss = $df582b4c1d01f444$var$interpolateTransform($2gywi.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $df582b4c1d01f444$var$interpolateTransformCss;
var $df582b4c1d01f444$var$interpolateTransformSvg = $df582b4c1d01f444$var$interpolateTransform($2gywi.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $df582b4c1d01f444$var$interpolateTransformSvg;

});
parcelRequire.register("2gywi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $1a67da4f7f4fc002$var$parseCss;
module.exports.parseSvg = $1a67da4f7f4fc002$var$parseSvg;

var $1a67da4f7f4fc002$var$_decompose = $1a67da4f7f4fc002$var$_interopRequireWildcard((parcelRequire("iL3A3")));
function $1a67da4f7f4fc002$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1a67da4f7f4fc002$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1a67da4f7f4fc002$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1a67da4f7f4fc002$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $1a67da4f7f4fc002$var$svgNode;
/* eslint-disable no-undef */ function $1a67da4f7f4fc002$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $1a67da4f7f4fc002$var$_decompose.identity : (0, $1a67da4f7f4fc002$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $1a67da4f7f4fc002$var$parseSvg(value) {
    if (value == null) return $1a67da4f7f4fc002$var$_decompose.identity;
    if (!$1a67da4f7f4fc002$var$svgNode) $1a67da4f7f4fc002$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $1a67da4f7f4fc002$var$svgNode.setAttribute("transform", value);
    if (!(value = $1a67da4f7f4fc002$var$svgNode.transform.baseVal.consolidate())) return $1a67da4f7f4fc002$var$_decompose.identity;
    value = value.matrix;
    return (0, $1a67da4f7f4fc002$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRequire.register("iL3A3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da7f64d1c38f8b7c$var$_default;
module.exports.identity = void 0;
var $da7f64d1c38f8b7c$var$degrees = 180 / Math.PI;
var $da7f64d1c38f8b7c$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $da7f64d1c38f8b7c$var$identity;
function $da7f64d1c38f8b7c$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $da7f64d1c38f8b7c$var$degrees,
        skewX: Math.atan(skewX) * $da7f64d1c38f8b7c$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRequire.register("1MBi7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $14c73362a3dcbc65$var$epsilon2 = 1e-12;
function $14c73362a3dcbc65$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $14c73362a3dcbc65$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $14c73362a3dcbc65$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $14c73362a3dcbc65$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $14c73362a3dcbc65$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $14c73362a3dcbc65$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $14c73362a3dcbc65$var$tanh(rho * s + r0) - $14c73362a3dcbc65$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $14c73362a3dcbc65$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $14c73362a3dcbc65$var$_default;

});

parcelRequire.register("jj4sq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $1GKl5 = parcelRequire("1GKl5");

var $e0e33fd87d79290b$var$_color = $e0e33fd87d79290b$var$_interopRequireWildcard((parcelRequire("c1q0U")));
function $e0e33fd87d79290b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e0e33fd87d79290b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e0e33fd87d79290b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e0e33fd87d79290b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e0e33fd87d79290b$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $1GKl5.hsl)(start)).h, (end = (0, $1GKl5.hsl)(end)).h), s = (0, $e0e33fd87d79290b$var$_color.default)(start.s, end.s), l = (0, $e0e33fd87d79290b$var$_color.default)(start.l, end.l), opacity = (0, $e0e33fd87d79290b$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $e0e33fd87d79290b$var$_default = $e0e33fd87d79290b$var$hsl($e0e33fd87d79290b$var$_color.hue);
module.exports.default = $e0e33fd87d79290b$var$_default;
var $e0e33fd87d79290b$var$hslLong = $e0e33fd87d79290b$var$hsl($e0e33fd87d79290b$var$_color.default);
module.exports.hslLong = $e0e33fd87d79290b$var$hslLong;

});

parcelRequire.register("nNUku", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0478dcb1efc841b9$var$lab;

var $1GKl5 = parcelRequire("1GKl5");

var $0478dcb1efc841b9$var$_color = $0478dcb1efc841b9$var$_interopRequireDefault((parcelRequire("c1q0U")));
function $0478dcb1efc841b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0478dcb1efc841b9$var$lab(start, end) {
    var l = (0, $0478dcb1efc841b9$var$_color.default)((start = (0, $1GKl5.lab)(start)).l, (end = (0, $1GKl5.lab)(end)).l), a = (0, $0478dcb1efc841b9$var$_color.default)(start.a, end.a), b = (0, $0478dcb1efc841b9$var$_color.default)(start.b, end.b), opacity = (0, $0478dcb1efc841b9$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRequire.register("kunpT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $1GKl5 = parcelRequire("1GKl5");

var $eea8c60b4645d2fa$var$_color = $eea8c60b4645d2fa$var$_interopRequireWildcard((parcelRequire("c1q0U")));
function $eea8c60b4645d2fa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($eea8c60b4645d2fa$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $eea8c60b4645d2fa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $eea8c60b4645d2fa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $eea8c60b4645d2fa$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $1GKl5.hcl)(start)).h, (end = (0, $1GKl5.hcl)(end)).h), c = (0, $eea8c60b4645d2fa$var$_color.default)(start.c, end.c), l = (0, $eea8c60b4645d2fa$var$_color.default)(start.l, end.l), opacity = (0, $eea8c60b4645d2fa$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $eea8c60b4645d2fa$var$_default = $eea8c60b4645d2fa$var$hcl($eea8c60b4645d2fa$var$_color.hue);
module.exports.default = $eea8c60b4645d2fa$var$_default;
var $eea8c60b4645d2fa$var$hclLong = $eea8c60b4645d2fa$var$hcl($eea8c60b4645d2fa$var$_color.default);
module.exports.hclLong = $eea8c60b4645d2fa$var$hclLong;

});

parcelRequire.register("3HfZg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $1GKl5 = parcelRequire("1GKl5");

var $2b11c9f1d0e3b045$var$_color = $2b11c9f1d0e3b045$var$_interopRequireWildcard((parcelRequire("c1q0U")));
function $2b11c9f1d0e3b045$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2b11c9f1d0e3b045$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2b11c9f1d0e3b045$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2b11c9f1d0e3b045$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2b11c9f1d0e3b045$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $1GKl5.cubehelix)(start)).h, (end = (0, $1GKl5.cubehelix)(end)).h), s = (0, $2b11c9f1d0e3b045$var$_color.default)(start.s, end.s), l = (0, $2b11c9f1d0e3b045$var$_color.default)(start.l, end.l), opacity = (0, $2b11c9f1d0e3b045$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $2b11c9f1d0e3b045$var$_default = $2b11c9f1d0e3b045$var$cubehelix($2b11c9f1d0e3b045$var$_color.hue);
module.exports.default = $2b11c9f1d0e3b045$var$_default;
var $2b11c9f1d0e3b045$var$cubehelixLong = $2b11c9f1d0e3b045$var$cubehelix($2b11c9f1d0e3b045$var$_color.default);
module.exports.cubehelixLong = $2b11c9f1d0e3b045$var$cubehelixLong;

});

parcelRequire.register("bVjfd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ae3f21f98c88cf1$var$piecewise;

var $8ae3f21f98c88cf1$var$_value = $8ae3f21f98c88cf1$var$_interopRequireDefault((parcelRequire("1xvti")));
function $8ae3f21f98c88cf1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ae3f21f98c88cf1$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $8ae3f21f98c88cf1$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRequire.register("kovOP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed8ebb1416822328$var$_default;
function $ed8ebb1416822328$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRequire.register("9HFYh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7108afd68c215218$var$constants;
function $7108afd68c215218$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRequire.register("8IAF0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $658edec82984180c$var$number;
function $658edec82984180c$var$number(x) {
    return +x;
}

});


parcelRequire.register("5WBP3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $453fb54cf548d098$var$tickFormat;

var $2ccY8 = parcelRequire("2ccY8");

var $8uQ6R = parcelRequire("8uQ6R");
function $453fb54cf548d098$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $2ccY8.tickStep)(start, stop, count), precision;
    specifier = (0, $8uQ6R.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $8uQ6R.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $8uQ6R.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $8uQ6R.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $8uQ6R.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $8uQ6R.format)(specifier);
}

});
parcelRequire.register("8uQ6R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $62f98bf801385aaf$var$_precisionRound.default;
    }
});

var $62f98bf801385aaf$var$_defaultLocale = $62f98bf801385aaf$var$_interopRequireWildcard((parcelRequire("i70R5")));

var $62f98bf801385aaf$var$_locale = $62f98bf801385aaf$var$_interopRequireDefault((parcelRequire("hYrAP")));

var $62f98bf801385aaf$var$_formatSpecifier = $62f98bf801385aaf$var$_interopRequireWildcard((parcelRequire("8V3RQ")));

var $62f98bf801385aaf$var$_precisionFixed = $62f98bf801385aaf$var$_interopRequireDefault((parcelRequire("hTYyp")));

var $62f98bf801385aaf$var$_precisionPrefix = $62f98bf801385aaf$var$_interopRequireDefault((parcelRequire("kPFiP")));

var $62f98bf801385aaf$var$_precisionRound = $62f98bf801385aaf$var$_interopRequireDefault((parcelRequire("cMKiO")));
function $62f98bf801385aaf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $62f98bf801385aaf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($62f98bf801385aaf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $62f98bf801385aaf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $62f98bf801385aaf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("i70R5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2f98b43e6160182$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $d2f98b43e6160182$var$_locale = $d2f98b43e6160182$var$_interopRequireDefault((parcelRequire("hYrAP")));
function $d2f98b43e6160182$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d2f98b43e6160182$var$locale;
var $d2f98b43e6160182$var$format;
module.exports.format = $d2f98b43e6160182$var$format;
var $d2f98b43e6160182$var$formatPrefix;
module.exports.formatPrefix = $d2f98b43e6160182$var$formatPrefix;
$d2f98b43e6160182$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $d2f98b43e6160182$var$defaultLocale(definition) {
    $d2f98b43e6160182$var$locale = (0, $d2f98b43e6160182$var$_locale.default)(definition);
    module.exports.format = $d2f98b43e6160182$var$format = $d2f98b43e6160182$var$locale.format;
    module.exports.formatPrefix = $d2f98b43e6160182$var$formatPrefix = $d2f98b43e6160182$var$locale.formatPrefix;
    return $d2f98b43e6160182$var$locale;
}

});
parcelRequire.register("hYrAP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d15d71af5ba86d0c$var$_default;

var $d15d71af5ba86d0c$var$_exponent = $d15d71af5ba86d0c$var$_interopRequireDefault((parcelRequire("fLRRp")));

var $d15d71af5ba86d0c$var$_formatGroup = $d15d71af5ba86d0c$var$_interopRequireDefault((parcelRequire("iKdn3")));

var $d15d71af5ba86d0c$var$_formatNumerals = $d15d71af5ba86d0c$var$_interopRequireDefault((parcelRequire("36edL")));

var $d15d71af5ba86d0c$var$_formatSpecifier = $d15d71af5ba86d0c$var$_interopRequireDefault((parcelRequire("8V3RQ")));

var $d15d71af5ba86d0c$var$_formatTrim = $d15d71af5ba86d0c$var$_interopRequireDefault((parcelRequire("eLyme")));

var $d15d71af5ba86d0c$var$_formatTypes = $d15d71af5ba86d0c$var$_interopRequireDefault((parcelRequire("giGlp")));

var $3dZ3d = parcelRequire("3dZ3d");

var $d15d71af5ba86d0c$var$_identity = $d15d71af5ba86d0c$var$_interopRequireDefault((parcelRequire("dw1pI")));
function $d15d71af5ba86d0c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d15d71af5ba86d0c$var$map = Array.prototype.map, $d15d71af5ba86d0c$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $d15d71af5ba86d0c$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $d15d71af5ba86d0c$var$_identity.default : (0, $d15d71af5ba86d0c$var$_formatGroup.default)($d15d71af5ba86d0c$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $d15d71af5ba86d0c$var$_identity.default : (0, $d15d71af5ba86d0c$var$_formatNumerals.default)($d15d71af5ba86d0c$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "−" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d15d71af5ba86d0c$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$d15d71af5ba86d0c$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $d15d71af5ba86d0c$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $d15d71af5ba86d0c$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $d15d71af5ba86d0c$var$prefixes[8 + $3dZ3d.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d15d71af5ba86d0c$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $d15d71af5ba86d0c$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $d15d71af5ba86d0c$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRequire.register("fLRRp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7b5065dffb6c093$var$_default;

var $1cvlJ = parcelRequire("1cvlJ");
function $b7b5065dffb6c093$var$_default(x) {
    return x = (0, $1cvlJ.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRequire.register("1cvlJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0dff3acde9b1329c$var$_default;
module.exports.formatDecimalParts = $0dff3acde9b1329c$var$formatDecimalParts;
function $0dff3acde9b1329c$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $0dff3acde9b1329c$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRequire.register("iKdn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da56e506e1e3e2a6$var$_default;
function $da56e506e1e3e2a6$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRequire.register("36edL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $241cf6a5b4b3a220$var$_default;
function $241cf6a5b4b3a220$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRequire.register("8V3RQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $67e6a59e2c74e1ea$var$FormatSpecifier;
module.exports.default = $67e6a59e2c74e1ea$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $67e6a59e2c74e1ea$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $67e6a59e2c74e1ea$var$formatSpecifier(specifier) {
    if (!(match = $67e6a59e2c74e1ea$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $67e6a59e2c74e1ea$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$67e6a59e2c74e1ea$var$formatSpecifier.prototype = $67e6a59e2c74e1ea$var$FormatSpecifier.prototype; // instanceof
function $67e6a59e2c74e1ea$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$67e6a59e2c74e1ea$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRequire.register("eLyme", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac001b28d41bbee8$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $ac001b28d41bbee8$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRequire.register("giGlp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bddf2c75d17085e6$var$_formatDecimal = $bddf2c75d17085e6$var$_interopRequireDefault((parcelRequire("1cvlJ")));

var $bddf2c75d17085e6$var$_formatPrefixAuto = $bddf2c75d17085e6$var$_interopRequireDefault((parcelRequire("3dZ3d")));

var $bddf2c75d17085e6$var$_formatRounded = $bddf2c75d17085e6$var$_interopRequireDefault((parcelRequire("atGrc")));
function $bddf2c75d17085e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bddf2c75d17085e6$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $bddf2c75d17085e6$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $bddf2c75d17085e6$var$_formatRounded.default)(x * 100, p),
    "r": $bddf2c75d17085e6$var$_formatRounded.default,
    "s": $bddf2c75d17085e6$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $bddf2c75d17085e6$var$_default;

});
parcelRequire.register("3dZ3d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2591f16fcf6fbe29$var$_default;
module.exports.prefixExponent = void 0;

var $1cvlJ = parcelRequire("1cvlJ");
var $2591f16fcf6fbe29$var$prefixExponent;
module.exports.prefixExponent = $2591f16fcf6fbe29$var$prefixExponent;
function $2591f16fcf6fbe29$var$_default(x, p) {
    var d = (0, $1cvlJ.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $2591f16fcf6fbe29$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $1cvlJ.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRequire.register("atGrc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a0d880f1d7ab077$var$_default;

var $1cvlJ = parcelRequire("1cvlJ");
function $7a0d880f1d7ab077$var$_default(x, p) {
    var d = (0, $1cvlJ.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRequire.register("dw1pI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d6f5c4173ca725a$var$_default;
function $9d6f5c4173ca725a$var$_default(x) {
    return x;
}

});



parcelRequire.register("hTYyp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0868b801ba4b59f$var$_default;

var $d0868b801ba4b59f$var$_exponent = $d0868b801ba4b59f$var$_interopRequireDefault((parcelRequire("fLRRp")));
function $d0868b801ba4b59f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0868b801ba4b59f$var$_default(step) {
    return Math.max(0, -(0, $d0868b801ba4b59f$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("kPFiP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2a89bebe54455c8$var$_default;

var $f2a89bebe54455c8$var$_exponent = $f2a89bebe54455c8$var$_interopRequireDefault((parcelRequire("fLRRp")));
function $f2a89bebe54455c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2a89bebe54455c8$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $f2a89bebe54455c8$var$_exponent.default)(value) / 3))) * 3 - (0, $f2a89bebe54455c8$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("cMKiO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94ede26e4658b470$var$_default;

var $94ede26e4658b470$var$_exponent = $94ede26e4658b470$var$_interopRequireDefault((parcelRequire("fLRRp")));
function $94ede26e4658b470$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94ede26e4658b470$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $94ede26e4658b470$var$_exponent.default)(max) - (0, $94ede26e4658b470$var$_exponent.default)(step)) + 1;
}

});





parcelRequire.register("jldhc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e14a46e95761cdf1$var$log;
module.exports.loggish = $e14a46e95761cdf1$var$loggish;

var $2ccY8 = parcelRequire("2ccY8");

var $8uQ6R = parcelRequire("8uQ6R");

var $e14a46e95761cdf1$var$_nice = $e14a46e95761cdf1$var$_interopRequireDefault((parcelRequire("5cXUt")));

var $4p545 = parcelRequire("4p545");

var $3HcC4 = parcelRequire("3HcC4");
function $e14a46e95761cdf1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e14a46e95761cdf1$var$transformLog(x) {
    return Math.log(x);
}
function $e14a46e95761cdf1$var$transformExp(x) {
    return Math.exp(x);
}
function $e14a46e95761cdf1$var$transformLogn(x) {
    return -Math.log(-x);
}
function $e14a46e95761cdf1$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $e14a46e95761cdf1$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $e14a46e95761cdf1$var$powp(base) {
    return base === 10 ? $e14a46e95761cdf1$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $e14a46e95761cdf1$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $e14a46e95761cdf1$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $e14a46e95761cdf1$var$loggish(transform) {
    const scale = transform($e14a46e95761cdf1$var$transformLog, $e14a46e95761cdf1$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $e14a46e95761cdf1$var$logp(base), pows = $e14a46e95761cdf1$var$powp(base);
        if (domain()[0] < 0) {
            logs = $e14a46e95761cdf1$var$reflect(logs), pows = $e14a46e95761cdf1$var$reflect(pows);
            transform($e14a46e95761cdf1$var$transformLogn, $e14a46e95761cdf1$var$transformExpn);
        } else transform($e14a46e95761cdf1$var$transformLog, $e14a46e95761cdf1$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $2ccY8.ticks)(u, v, n);
        } else z = (0, $2ccY8.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $8uQ6R.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $8uQ6R.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $e14a46e95761cdf1$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $e14a46e95761cdf1$var$log() {
    const scale = $e14a46e95761cdf1$var$loggish((0, $4p545.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $4p545.copy)(scale, $e14a46e95761cdf1$var$log()).base(scale.base());
    $3HcC4.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRequire.register("5cXUt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3cac8b9d0de8715e$var$nice;
function $3cac8b9d0de8715e$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRequire.register("dyYUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9dfdb45855d293a9$var$symlog;
module.exports.symlogish = $9dfdb45855d293a9$var$symlogish;

var $4bGV3 = parcelRequire("4bGV3");

var $4p545 = parcelRequire("4p545");

var $3HcC4 = parcelRequire("3HcC4");
function $9dfdb45855d293a9$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $9dfdb45855d293a9$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $9dfdb45855d293a9$var$symlogish(transform) {
    var c = 1, scale = transform($9dfdb45855d293a9$var$transformSymlog(c), $9dfdb45855d293a9$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($9dfdb45855d293a9$var$transformSymlog(c = +_), $9dfdb45855d293a9$var$transformSymexp(c)) : c;
    };
    return (0, $4bGV3.linearish)(scale);
}
function $9dfdb45855d293a9$var$symlog() {
    var scale = $9dfdb45855d293a9$var$symlogish((0, $4p545.transformer)());
    scale.copy = function() {
        return (0, $4p545.copy)(scale, $9dfdb45855d293a9$var$symlog()).constant(scale.constant());
    };
    return $3HcC4.initRange.apply(scale, arguments);
}

});

parcelRequire.register("eFo2P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aad78bccad5bb7b1$var$pow;
module.exports.powish = $aad78bccad5bb7b1$var$powish;
module.exports.sqrt = $aad78bccad5bb7b1$var$sqrt;

var $4bGV3 = parcelRequire("4bGV3");

var $4p545 = parcelRequire("4p545");

var $3HcC4 = parcelRequire("3HcC4");
function $aad78bccad5bb7b1$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $aad78bccad5bb7b1$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $aad78bccad5bb7b1$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $aad78bccad5bb7b1$var$powish(transform) {
    var scale = transform($4p545.identity, $4p545.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($4p545.identity, $4p545.identity) : exponent === 0.5 ? transform($aad78bccad5bb7b1$var$transformSqrt, $aad78bccad5bb7b1$var$transformSquare) : transform($aad78bccad5bb7b1$var$transformPow(exponent), $aad78bccad5bb7b1$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $4bGV3.linearish)(scale);
}
function $aad78bccad5bb7b1$var$pow() {
    var scale = $aad78bccad5bb7b1$var$powish((0, $4p545.transformer)());
    scale.copy = function() {
        return (0, $4p545.copy)(scale, $aad78bccad5bb7b1$var$pow()).exponent(scale.exponent());
    };
    $3HcC4.initRange.apply(scale, arguments);
    return scale;
}
function $aad78bccad5bb7b1$var$sqrt() {
    return $aad78bccad5bb7b1$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("bahss", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $820e2bb2416c70b5$var$radial;

var $820e2bb2416c70b5$var$_continuous = $820e2bb2416c70b5$var$_interopRequireDefault((parcelRequire("4p545")));

var $3HcC4 = parcelRequire("3HcC4");

var $4bGV3 = parcelRequire("4bGV3");

var $820e2bb2416c70b5$var$_number = $820e2bb2416c70b5$var$_interopRequireDefault((parcelRequire("8IAF0")));
function $820e2bb2416c70b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $820e2bb2416c70b5$var$square(x) {
    return Math.sign(x) * x * x;
}
function $820e2bb2416c70b5$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $820e2bb2416c70b5$var$radial() {
    var squared = (0, $820e2bb2416c70b5$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $820e2bb2416c70b5$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($820e2bb2416c70b5$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $820e2bb2416c70b5$var$_number.default)).map($820e2bb2416c70b5$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $820e2bb2416c70b5$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $3HcC4.initRange.apply(scale, arguments);
    return (0, $4bGV3.linearish)(scale);
}

});

parcelRequire.register("9YomO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $742c9e6f15575a2b$var$quantile;

var $2ccY8 = parcelRequire("2ccY8");

var $3HcC4 = parcelRequire("3HcC4");
function $742c9e6f15575a2b$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $2ccY8.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $2ccY8.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($2ccY8.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $742c9e6f15575a2b$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $3HcC4.initRange.apply(scale, arguments);
}

});

parcelRequire.register("iz2r4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d83d6284aee6baa5$var$quantize;

var $2ccY8 = parcelRequire("2ccY8");

var $4bGV3 = parcelRequire("4bGV3");

var $3HcC4 = parcelRequire("3HcC4");
function $d83d6284aee6baa5$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $2ccY8.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $d83d6284aee6baa5$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $3HcC4.initRange.apply((0, $4bGV3.linearish)(scale), arguments);
}

});

parcelRequire.register("h6HOb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c744faa072e24094$var$threshold;

var $2ccY8 = parcelRequire("2ccY8");

var $3HcC4 = parcelRequire("3HcC4");
function $c744faa072e24094$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $2ccY8.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c744faa072e24094$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $3HcC4.initRange.apply(scale, arguments);
}

});

parcelRequire.register("a9YvZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $7659afaa9b9328dd$var$calendar;
module.exports.default = $7659afaa9b9328dd$var$time;

var $5Wexi = parcelRequire("5Wexi");

var $2XPv2 = parcelRequire("2XPv2");

var $7659afaa9b9328dd$var$_continuous = $7659afaa9b9328dd$var$_interopRequireWildcard((parcelRequire("4p545")));

var $3HcC4 = parcelRequire("3HcC4");

var $7659afaa9b9328dd$var$_nice = $7659afaa9b9328dd$var$_interopRequireDefault((parcelRequire("5cXUt")));
function $7659afaa9b9328dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7659afaa9b9328dd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7659afaa9b9328dd$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7659afaa9b9328dd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7659afaa9b9328dd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7659afaa9b9328dd$var$date(t) {
    return new Date(t);
}
function $7659afaa9b9328dd$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $7659afaa9b9328dd$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $7659afaa9b9328dd$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $7659afaa9b9328dd$var$number)) : domain().map($7659afaa9b9328dd$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $7659afaa9b9328dd$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $7659afaa9b9328dd$var$_continuous.copy)(scale, $7659afaa9b9328dd$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $7659afaa9b9328dd$var$time() {
    return $3HcC4.initRange.apply($7659afaa9b9328dd$var$calendar($5Wexi.timeTicks, $5Wexi.timeTickInterval, $5Wexi.timeYear, $5Wexi.timeMonth, $5Wexi.timeWeek, $5Wexi.timeDay, $5Wexi.timeHour, $5Wexi.timeMinute, $5Wexi.timeSecond, $2XPv2.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRequire.register("5Wexi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $gu4JZ.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $gu4JZ.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $gu4JZ.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $gu4JZ.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $gu4JZ.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $gu4JZ.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $gu4JZ.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $gu4JZ.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $gu4JZ.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $gu4JZ.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $eZmJV.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $eZmJV.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $gu4JZ.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $gu4JZ.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $gu4JZ.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $gu4JZ.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $gu4JZ.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $gu4JZ.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $eZmJV.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $eZmJV.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $kRJHK.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $452da51326dd74ff$var$_utcYear.utcYears;
    }
});

var $452da51326dd74ff$var$_interval = $452da51326dd74ff$var$_interopRequireDefault((parcelRequire("7ka96")));

var $452da51326dd74ff$var$_millisecond = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("cE2BH")));

var $452da51326dd74ff$var$_second = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("btCBc")));

var $452da51326dd74ff$var$_minute = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("aJgin")));

var $452da51326dd74ff$var$_hour = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("gaCEt")));

var $452da51326dd74ff$var$_day = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("iX55C")));

var $gu4JZ = parcelRequire("gu4JZ");

var $452da51326dd74ff$var$_month = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("gA6Zm")));

var $452da51326dd74ff$var$_year = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("7LfZC")));

var $452da51326dd74ff$var$_utcMinute = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("h2eOT")));

var $452da51326dd74ff$var$_utcHour = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("ftghh")));

var $452da51326dd74ff$var$_utcDay = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("eaiK8")));

var $kRJHK = parcelRequire("kRJHK");

var $452da51326dd74ff$var$_utcMonth = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("7qMUs")));

var $452da51326dd74ff$var$_utcYear = $452da51326dd74ff$var$_interopRequireWildcard((parcelRequire("XeSp7")));

var $eZmJV = parcelRequire("eZmJV");
function $452da51326dd74ff$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($452da51326dd74ff$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $452da51326dd74ff$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $452da51326dd74ff$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $452da51326dd74ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("7ka96", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $555245681199ba1e$var$newInterval;
var $555245681199ba1e$var$t0 = new Date(), $555245681199ba1e$var$t1 = new Date();
function $555245681199ba1e$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $555245681199ba1e$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $555245681199ba1e$var$t0.setTime(+start), $555245681199ba1e$var$t1.setTime(+end);
            floori($555245681199ba1e$var$t0), floori($555245681199ba1e$var$t1);
            return Math.floor(count($555245681199ba1e$var$t0, $555245681199ba1e$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRequire.register("cE2BH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $934b3e27cc050b6e$var$_interval = $934b3e27cc050b6e$var$_interopRequireDefault((parcelRequire("7ka96")));
function $934b3e27cc050b6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $934b3e27cc050b6e$var$millisecond = (0, $934b3e27cc050b6e$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$934b3e27cc050b6e$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $934b3e27cc050b6e$var$millisecond;
    return (0, $934b3e27cc050b6e$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $934b3e27cc050b6e$var$_default = $934b3e27cc050b6e$var$millisecond;
module.exports.default = $934b3e27cc050b6e$var$_default;
var $934b3e27cc050b6e$var$milliseconds = $934b3e27cc050b6e$var$millisecond.range;
module.exports.milliseconds = $934b3e27cc050b6e$var$milliseconds;

});

parcelRequire.register("btCBc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $85b05813d61d6577$var$_interval = $85b05813d61d6577$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $85b05813d61d6577$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $85b05813d61d6577$var$second = (0, $85b05813d61d6577$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $2Sn02.durationSecond);
}, function(start, end) {
    return (end - start) / $2Sn02.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $85b05813d61d6577$var$_default = $85b05813d61d6577$var$second;
module.exports.default = $85b05813d61d6577$var$_default;
var $85b05813d61d6577$var$seconds = $85b05813d61d6577$var$second.range;
module.exports.seconds = $85b05813d61d6577$var$seconds;

});
parcelRequire.register("2Sn02", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $21827726eb874847$var$durationSecond = 1000;
module.exports.durationSecond = $21827726eb874847$var$durationSecond;
const $21827726eb874847$var$durationMinute = $21827726eb874847$var$durationSecond * 60;
module.exports.durationMinute = $21827726eb874847$var$durationMinute;
const $21827726eb874847$var$durationHour = $21827726eb874847$var$durationMinute * 60;
module.exports.durationHour = $21827726eb874847$var$durationHour;
const $21827726eb874847$var$durationDay = $21827726eb874847$var$durationHour * 24;
module.exports.durationDay = $21827726eb874847$var$durationDay;
const $21827726eb874847$var$durationWeek = $21827726eb874847$var$durationDay * 7;
module.exports.durationWeek = $21827726eb874847$var$durationWeek;
const $21827726eb874847$var$durationMonth = $21827726eb874847$var$durationDay * 30;
module.exports.durationMonth = $21827726eb874847$var$durationMonth;
const $21827726eb874847$var$durationYear = $21827726eb874847$var$durationDay * 365;
module.exports.durationYear = $21827726eb874847$var$durationYear;

});


parcelRequire.register("aJgin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $7cfabf43e796741b$var$_interval = $7cfabf43e796741b$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $7cfabf43e796741b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7cfabf43e796741b$var$minute = (0, $7cfabf43e796741b$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $2Sn02.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $2Sn02.durationMinute);
}, function(start, end) {
    return (end - start) / $2Sn02.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $7cfabf43e796741b$var$_default = $7cfabf43e796741b$var$minute;
module.exports.default = $7cfabf43e796741b$var$_default;
var $7cfabf43e796741b$var$minutes = $7cfabf43e796741b$var$minute.range;
module.exports.minutes = $7cfabf43e796741b$var$minutes;

});

parcelRequire.register("gaCEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $bc5b8ffac87fc174$var$_interval = $bc5b8ffac87fc174$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $bc5b8ffac87fc174$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bc5b8ffac87fc174$var$hour = (0, $bc5b8ffac87fc174$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $2Sn02.durationSecond - date.getMinutes() * $2Sn02.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $2Sn02.durationHour);
}, function(start, end) {
    return (end - start) / $2Sn02.durationHour;
}, function(date) {
    return date.getHours();
});
var $bc5b8ffac87fc174$var$_default = $bc5b8ffac87fc174$var$hour;
module.exports.default = $bc5b8ffac87fc174$var$_default;
var $bc5b8ffac87fc174$var$hours = $bc5b8ffac87fc174$var$hour.range;
module.exports.hours = $bc5b8ffac87fc174$var$hours;

});

parcelRequire.register("iX55C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $dcc1af60338db1cc$var$_interval = $dcc1af60338db1cc$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $dcc1af60338db1cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dcc1af60338db1cc$var$day = (0, $dcc1af60338db1cc$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $2Sn02.durationMinute) / $2Sn02.durationDay, (date)=>date.getDate() - 1);
var $dcc1af60338db1cc$var$_default = $dcc1af60338db1cc$var$day;
module.exports.default = $dcc1af60338db1cc$var$_default;
var $dcc1af60338db1cc$var$days = $dcc1af60338db1cc$var$day.range;
module.exports.days = $dcc1af60338db1cc$var$days;

});

parcelRequire.register("gu4JZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $c0032019698982bb$var$_interval = $c0032019698982bb$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $c0032019698982bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c0032019698982bb$var$weekday(i) {
    return (0, $c0032019698982bb$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $2Sn02.durationMinute) / $2Sn02.durationWeek;
    });
}
var $c0032019698982bb$var$sunday = $c0032019698982bb$var$weekday(0);
module.exports.sunday = $c0032019698982bb$var$sunday;
var $c0032019698982bb$var$monday = $c0032019698982bb$var$weekday(1);
module.exports.monday = $c0032019698982bb$var$monday;
var $c0032019698982bb$var$tuesday = $c0032019698982bb$var$weekday(2);
module.exports.tuesday = $c0032019698982bb$var$tuesday;
var $c0032019698982bb$var$wednesday = $c0032019698982bb$var$weekday(3);
module.exports.wednesday = $c0032019698982bb$var$wednesday;
var $c0032019698982bb$var$thursday = $c0032019698982bb$var$weekday(4);
module.exports.thursday = $c0032019698982bb$var$thursday;
var $c0032019698982bb$var$friday = $c0032019698982bb$var$weekday(5);
module.exports.friday = $c0032019698982bb$var$friday;
var $c0032019698982bb$var$saturday = $c0032019698982bb$var$weekday(6);
module.exports.saturday = $c0032019698982bb$var$saturday;
var $c0032019698982bb$var$sundays = $c0032019698982bb$var$sunday.range;
module.exports.sundays = $c0032019698982bb$var$sundays;
var $c0032019698982bb$var$mondays = $c0032019698982bb$var$monday.range;
module.exports.mondays = $c0032019698982bb$var$mondays;
var $c0032019698982bb$var$tuesdays = $c0032019698982bb$var$tuesday.range;
module.exports.tuesdays = $c0032019698982bb$var$tuesdays;
var $c0032019698982bb$var$wednesdays = $c0032019698982bb$var$wednesday.range;
module.exports.wednesdays = $c0032019698982bb$var$wednesdays;
var $c0032019698982bb$var$thursdays = $c0032019698982bb$var$thursday.range;
module.exports.thursdays = $c0032019698982bb$var$thursdays;
var $c0032019698982bb$var$fridays = $c0032019698982bb$var$friday.range;
module.exports.fridays = $c0032019698982bb$var$fridays;
var $c0032019698982bb$var$saturdays = $c0032019698982bb$var$saturday.range;
module.exports.saturdays = $c0032019698982bb$var$saturdays;

});

parcelRequire.register("gA6Zm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $c1256df441678cdf$var$_interval = $c1256df441678cdf$var$_interopRequireDefault((parcelRequire("7ka96")));
function $c1256df441678cdf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c1256df441678cdf$var$month = (0, $c1256df441678cdf$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $c1256df441678cdf$var$_default = $c1256df441678cdf$var$month;
module.exports.default = $c1256df441678cdf$var$_default;
var $c1256df441678cdf$var$months = $c1256df441678cdf$var$month.range;
module.exports.months = $c1256df441678cdf$var$months;

});

parcelRequire.register("7LfZC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $5a69540bad789a52$var$_interval = $5a69540bad789a52$var$_interopRequireDefault((parcelRequire("7ka96")));
function $5a69540bad789a52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5a69540bad789a52$var$year = (0, $5a69540bad789a52$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$5a69540bad789a52$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $5a69540bad789a52$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $5a69540bad789a52$var$_default = $5a69540bad789a52$var$year;
module.exports.default = $5a69540bad789a52$var$_default;
var $5a69540bad789a52$var$years = $5a69540bad789a52$var$year.range;
module.exports.years = $5a69540bad789a52$var$years;

});

parcelRequire.register("h2eOT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $c66e1e7eb88f269c$var$_interval = $c66e1e7eb88f269c$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $c66e1e7eb88f269c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c66e1e7eb88f269c$var$utcMinute = (0, $c66e1e7eb88f269c$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $2Sn02.durationMinute);
}, function(start, end) {
    return (end - start) / $2Sn02.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $c66e1e7eb88f269c$var$_default = $c66e1e7eb88f269c$var$utcMinute;
module.exports.default = $c66e1e7eb88f269c$var$_default;
var $c66e1e7eb88f269c$var$utcMinutes = $c66e1e7eb88f269c$var$utcMinute.range;
module.exports.utcMinutes = $c66e1e7eb88f269c$var$utcMinutes;

});

parcelRequire.register("ftghh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $b43630dba9a16c5e$var$_interval = $b43630dba9a16c5e$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $b43630dba9a16c5e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b43630dba9a16c5e$var$utcHour = (0, $b43630dba9a16c5e$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $2Sn02.durationHour);
}, function(start, end) {
    return (end - start) / $2Sn02.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $b43630dba9a16c5e$var$_default = $b43630dba9a16c5e$var$utcHour;
module.exports.default = $b43630dba9a16c5e$var$_default;
var $b43630dba9a16c5e$var$utcHours = $b43630dba9a16c5e$var$utcHour.range;
module.exports.utcHours = $b43630dba9a16c5e$var$utcHours;

});

parcelRequire.register("eaiK8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $a50089dab3ce1d0c$var$_interval = $a50089dab3ce1d0c$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $a50089dab3ce1d0c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a50089dab3ce1d0c$var$utcDay = (0, $a50089dab3ce1d0c$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $2Sn02.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $a50089dab3ce1d0c$var$_default = $a50089dab3ce1d0c$var$utcDay;
module.exports.default = $a50089dab3ce1d0c$var$_default;
var $a50089dab3ce1d0c$var$utcDays = $a50089dab3ce1d0c$var$utcDay.range;
module.exports.utcDays = $a50089dab3ce1d0c$var$utcDays;

});

parcelRequire.register("kRJHK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $f30c35dc02c5e281$var$_interval = $f30c35dc02c5e281$var$_interopRequireDefault((parcelRequire("7ka96")));

var $2Sn02 = parcelRequire("2Sn02");
function $f30c35dc02c5e281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f30c35dc02c5e281$var$utcWeekday(i) {
    return (0, $f30c35dc02c5e281$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $2Sn02.durationWeek;
    });
}
var $f30c35dc02c5e281$var$utcSunday = $f30c35dc02c5e281$var$utcWeekday(0);
module.exports.utcSunday = $f30c35dc02c5e281$var$utcSunday;
var $f30c35dc02c5e281$var$utcMonday = $f30c35dc02c5e281$var$utcWeekday(1);
module.exports.utcMonday = $f30c35dc02c5e281$var$utcMonday;
var $f30c35dc02c5e281$var$utcTuesday = $f30c35dc02c5e281$var$utcWeekday(2);
module.exports.utcTuesday = $f30c35dc02c5e281$var$utcTuesday;
var $f30c35dc02c5e281$var$utcWednesday = $f30c35dc02c5e281$var$utcWeekday(3);
module.exports.utcWednesday = $f30c35dc02c5e281$var$utcWednesday;
var $f30c35dc02c5e281$var$utcThursday = $f30c35dc02c5e281$var$utcWeekday(4);
module.exports.utcThursday = $f30c35dc02c5e281$var$utcThursday;
var $f30c35dc02c5e281$var$utcFriday = $f30c35dc02c5e281$var$utcWeekday(5);
module.exports.utcFriday = $f30c35dc02c5e281$var$utcFriday;
var $f30c35dc02c5e281$var$utcSaturday = $f30c35dc02c5e281$var$utcWeekday(6);
module.exports.utcSaturday = $f30c35dc02c5e281$var$utcSaturday;
var $f30c35dc02c5e281$var$utcSundays = $f30c35dc02c5e281$var$utcSunday.range;
module.exports.utcSundays = $f30c35dc02c5e281$var$utcSundays;
var $f30c35dc02c5e281$var$utcMondays = $f30c35dc02c5e281$var$utcMonday.range;
module.exports.utcMondays = $f30c35dc02c5e281$var$utcMondays;
var $f30c35dc02c5e281$var$utcTuesdays = $f30c35dc02c5e281$var$utcTuesday.range;
module.exports.utcTuesdays = $f30c35dc02c5e281$var$utcTuesdays;
var $f30c35dc02c5e281$var$utcWednesdays = $f30c35dc02c5e281$var$utcWednesday.range;
module.exports.utcWednesdays = $f30c35dc02c5e281$var$utcWednesdays;
var $f30c35dc02c5e281$var$utcThursdays = $f30c35dc02c5e281$var$utcThursday.range;
module.exports.utcThursdays = $f30c35dc02c5e281$var$utcThursdays;
var $f30c35dc02c5e281$var$utcFridays = $f30c35dc02c5e281$var$utcFriday.range;
module.exports.utcFridays = $f30c35dc02c5e281$var$utcFridays;
var $f30c35dc02c5e281$var$utcSaturdays = $f30c35dc02c5e281$var$utcSaturday.range;
module.exports.utcSaturdays = $f30c35dc02c5e281$var$utcSaturdays;

});

parcelRequire.register("7qMUs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $5690e686b4d89eee$var$_interval = $5690e686b4d89eee$var$_interopRequireDefault((parcelRequire("7ka96")));
function $5690e686b4d89eee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5690e686b4d89eee$var$utcMonth = (0, $5690e686b4d89eee$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $5690e686b4d89eee$var$_default = $5690e686b4d89eee$var$utcMonth;
module.exports.default = $5690e686b4d89eee$var$_default;
var $5690e686b4d89eee$var$utcMonths = $5690e686b4d89eee$var$utcMonth.range;
module.exports.utcMonths = $5690e686b4d89eee$var$utcMonths;

});

parcelRequire.register("XeSp7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $0b210cf68eccfa53$var$_interval = $0b210cf68eccfa53$var$_interopRequireDefault((parcelRequire("7ka96")));
function $0b210cf68eccfa53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0b210cf68eccfa53$var$utcYear = (0, $0b210cf68eccfa53$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$0b210cf68eccfa53$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $0b210cf68eccfa53$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $0b210cf68eccfa53$var$_default = $0b210cf68eccfa53$var$utcYear;
module.exports.default = $0b210cf68eccfa53$var$_default;
var $0b210cf68eccfa53$var$utcYears = $0b210cf68eccfa53$var$utcYear.range;
module.exports.utcYears = $0b210cf68eccfa53$var$utcYears;

});

parcelRequire.register("eZmJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $2ccY8 = parcelRequire("2ccY8");

var $2Sn02 = parcelRequire("2Sn02");

var $ae9866d109caf056$var$_millisecond = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("cE2BH")));

var $ae9866d109caf056$var$_second = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("btCBc")));

var $ae9866d109caf056$var$_minute = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("aJgin")));

var $ae9866d109caf056$var$_hour = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("gaCEt")));

var $ae9866d109caf056$var$_day = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("iX55C")));

var $gu4JZ = parcelRequire("gu4JZ");

var $ae9866d109caf056$var$_month = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("gA6Zm")));

var $ae9866d109caf056$var$_year = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("7LfZC")));

var $ae9866d109caf056$var$_utcMinute = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("h2eOT")));

var $ae9866d109caf056$var$_utcHour = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("ftghh")));

var $ae9866d109caf056$var$_utcDay = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("eaiK8")));

var $kRJHK = parcelRequire("kRJHK");

var $ae9866d109caf056$var$_utcMonth = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("7qMUs")));

var $ae9866d109caf056$var$_utcYear = $ae9866d109caf056$var$_interopRequireDefault((parcelRequire("XeSp7")));
function $ae9866d109caf056$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae9866d109caf056$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $ae9866d109caf056$var$_second.default,
            1,
            $2Sn02.durationSecond
        ],
        [
            $ae9866d109caf056$var$_second.default,
            5,
            5 * $2Sn02.durationSecond
        ],
        [
            $ae9866d109caf056$var$_second.default,
            15,
            15 * $2Sn02.durationSecond
        ],
        [
            $ae9866d109caf056$var$_second.default,
            30,
            30 * $2Sn02.durationSecond
        ],
        [
            minute,
            1,
            $2Sn02.durationMinute
        ],
        [
            minute,
            5,
            5 * $2Sn02.durationMinute
        ],
        [
            minute,
            15,
            15 * $2Sn02.durationMinute
        ],
        [
            minute,
            30,
            30 * $2Sn02.durationMinute
        ],
        [
            hour,
            1,
            $2Sn02.durationHour
        ],
        [
            hour,
            3,
            3 * $2Sn02.durationHour
        ],
        [
            hour,
            6,
            6 * $2Sn02.durationHour
        ],
        [
            hour,
            12,
            12 * $2Sn02.durationHour
        ],
        [
            day,
            1,
            $2Sn02.durationDay
        ],
        [
            day,
            2,
            2 * $2Sn02.durationDay
        ],
        [
            week,
            1,
            $2Sn02.durationWeek
        ],
        [
            month,
            1,
            $2Sn02.durationMonth
        ],
        [
            month,
            3,
            3 * $2Sn02.durationMonth
        ],
        [
            year,
            1,
            $2Sn02.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $2ccY8.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $2ccY8.tickStep)(start / $2Sn02.durationYear, stop / $2Sn02.durationYear, count));
        if (i === 0) return $ae9866d109caf056$var$_millisecond.default.every(Math.max((0, $2ccY8.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$ae9866d109caf056$var$utcTicks, $ae9866d109caf056$var$utcTickInterval] = $ae9866d109caf056$var$ticker($ae9866d109caf056$var$_utcYear.default, $ae9866d109caf056$var$_utcMonth.default, $kRJHK.utcSunday, $ae9866d109caf056$var$_utcDay.default, $ae9866d109caf056$var$_utcHour.default, $ae9866d109caf056$var$_utcMinute.default);
module.exports.utcTickInterval = $ae9866d109caf056$var$utcTickInterval;
module.exports.utcTicks = $ae9866d109caf056$var$utcTicks;
const [$ae9866d109caf056$var$timeTicks, $ae9866d109caf056$var$timeTickInterval] = $ae9866d109caf056$var$ticker($ae9866d109caf056$var$_year.default, $ae9866d109caf056$var$_month.default, $gu4JZ.sunday, $ae9866d109caf056$var$_day.default, $ae9866d109caf056$var$_hour.default, $ae9866d109caf056$var$_minute.default);
module.exports.timeTickInterval = $ae9866d109caf056$var$timeTickInterval;
module.exports.timeTicks = $ae9866d109caf056$var$timeTicks;

});


parcelRequire.register("2XPv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $22890a3231a2e92d$var$_defaultLocale.utcParse;
    }
});

var $22890a3231a2e92d$var$_defaultLocale = $22890a3231a2e92d$var$_interopRequireWildcard((parcelRequire("3ODsc")));

var $22890a3231a2e92d$var$_locale = $22890a3231a2e92d$var$_interopRequireDefault((parcelRequire("1Rs6b")));

var $22890a3231a2e92d$var$_isoFormat = $22890a3231a2e92d$var$_interopRequireDefault((parcelRequire("ivS2A")));

var $22890a3231a2e92d$var$_isoParse = $22890a3231a2e92d$var$_interopRequireDefault((parcelRequire("2XYtb")));
function $22890a3231a2e92d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22890a3231a2e92d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($22890a3231a2e92d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $22890a3231a2e92d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $22890a3231a2e92d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("3ODsc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c74a555cf8280a4$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $2c74a555cf8280a4$var$_locale = $2c74a555cf8280a4$var$_interopRequireDefault((parcelRequire("1Rs6b")));
function $2c74a555cf8280a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2c74a555cf8280a4$var$locale;
var $2c74a555cf8280a4$var$timeFormat;
module.exports.timeFormat = $2c74a555cf8280a4$var$timeFormat;
var $2c74a555cf8280a4$var$timeParse;
module.exports.timeParse = $2c74a555cf8280a4$var$timeParse;
var $2c74a555cf8280a4$var$utcFormat;
module.exports.utcFormat = $2c74a555cf8280a4$var$utcFormat;
var $2c74a555cf8280a4$var$utcParse;
module.exports.utcParse = $2c74a555cf8280a4$var$utcParse;
$2c74a555cf8280a4$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $2c74a555cf8280a4$var$defaultLocale(definition) {
    $2c74a555cf8280a4$var$locale = (0, $2c74a555cf8280a4$var$_locale.default)(definition);
    module.exports.timeFormat = $2c74a555cf8280a4$var$timeFormat = $2c74a555cf8280a4$var$locale.format;
    module.exports.timeParse = $2c74a555cf8280a4$var$timeParse = $2c74a555cf8280a4$var$locale.parse;
    module.exports.utcFormat = $2c74a555cf8280a4$var$utcFormat = $2c74a555cf8280a4$var$locale.utcFormat;
    module.exports.utcParse = $2c74a555cf8280a4$var$utcParse = $2c74a555cf8280a4$var$locale.utcParse;
    return $2c74a555cf8280a4$var$locale;
}

});
parcelRequire.register("1Rs6b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15b08980342d698e$var$formatLocale;

var $5Wexi = parcelRequire("5Wexi");
function $15b08980342d698e$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $15b08980342d698e$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $15b08980342d698e$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $15b08980342d698e$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $15b08980342d698e$var$formatRe(locale_periods), periodLookup = $15b08980342d698e$var$formatLookup(locale_periods), weekdayRe = $15b08980342d698e$var$formatRe(locale_weekdays), weekdayLookup = $15b08980342d698e$var$formatLookup(locale_weekdays), shortWeekdayRe = $15b08980342d698e$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $15b08980342d698e$var$formatLookup(locale_shortWeekdays), monthRe = $15b08980342d698e$var$formatRe(locale_months), monthLookup = $15b08980342d698e$var$formatLookup(locale_months), shortMonthRe = $15b08980342d698e$var$formatRe(locale_shortMonths), shortMonthLookup = $15b08980342d698e$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $15b08980342d698e$var$formatDayOfMonth,
        "e": $15b08980342d698e$var$formatDayOfMonth,
        "f": $15b08980342d698e$var$formatMicroseconds,
        "g": $15b08980342d698e$var$formatYearISO,
        "G": $15b08980342d698e$var$formatFullYearISO,
        "H": $15b08980342d698e$var$formatHour24,
        "I": $15b08980342d698e$var$formatHour12,
        "j": $15b08980342d698e$var$formatDayOfYear,
        "L": $15b08980342d698e$var$formatMilliseconds,
        "m": $15b08980342d698e$var$formatMonthNumber,
        "M": $15b08980342d698e$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $15b08980342d698e$var$formatUnixTimestamp,
        "s": $15b08980342d698e$var$formatUnixTimestampSeconds,
        "S": $15b08980342d698e$var$formatSeconds,
        "u": $15b08980342d698e$var$formatWeekdayNumberMonday,
        "U": $15b08980342d698e$var$formatWeekNumberSunday,
        "V": $15b08980342d698e$var$formatWeekNumberISO,
        "w": $15b08980342d698e$var$formatWeekdayNumberSunday,
        "W": $15b08980342d698e$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $15b08980342d698e$var$formatYear,
        "Y": $15b08980342d698e$var$formatFullYear,
        "Z": $15b08980342d698e$var$formatZone,
        "%": $15b08980342d698e$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $15b08980342d698e$var$formatUTCDayOfMonth,
        "e": $15b08980342d698e$var$formatUTCDayOfMonth,
        "f": $15b08980342d698e$var$formatUTCMicroseconds,
        "g": $15b08980342d698e$var$formatUTCYearISO,
        "G": $15b08980342d698e$var$formatUTCFullYearISO,
        "H": $15b08980342d698e$var$formatUTCHour24,
        "I": $15b08980342d698e$var$formatUTCHour12,
        "j": $15b08980342d698e$var$formatUTCDayOfYear,
        "L": $15b08980342d698e$var$formatUTCMilliseconds,
        "m": $15b08980342d698e$var$formatUTCMonthNumber,
        "M": $15b08980342d698e$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $15b08980342d698e$var$formatUnixTimestamp,
        "s": $15b08980342d698e$var$formatUnixTimestampSeconds,
        "S": $15b08980342d698e$var$formatUTCSeconds,
        "u": $15b08980342d698e$var$formatUTCWeekdayNumberMonday,
        "U": $15b08980342d698e$var$formatUTCWeekNumberSunday,
        "V": $15b08980342d698e$var$formatUTCWeekNumberISO,
        "w": $15b08980342d698e$var$formatUTCWeekdayNumberSunday,
        "W": $15b08980342d698e$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $15b08980342d698e$var$formatUTCYear,
        "Y": $15b08980342d698e$var$formatUTCFullYear,
        "Z": $15b08980342d698e$var$formatUTCZone,
        "%": $15b08980342d698e$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $15b08980342d698e$var$parseDayOfMonth,
        "e": $15b08980342d698e$var$parseDayOfMonth,
        "f": $15b08980342d698e$var$parseMicroseconds,
        "g": $15b08980342d698e$var$parseYear,
        "G": $15b08980342d698e$var$parseFullYear,
        "H": $15b08980342d698e$var$parseHour24,
        "I": $15b08980342d698e$var$parseHour24,
        "j": $15b08980342d698e$var$parseDayOfYear,
        "L": $15b08980342d698e$var$parseMilliseconds,
        "m": $15b08980342d698e$var$parseMonthNumber,
        "M": $15b08980342d698e$var$parseMinutes,
        "p": parsePeriod,
        "q": $15b08980342d698e$var$parseQuarter,
        "Q": $15b08980342d698e$var$parseUnixTimestamp,
        "s": $15b08980342d698e$var$parseUnixTimestampSeconds,
        "S": $15b08980342d698e$var$parseSeconds,
        "u": $15b08980342d698e$var$parseWeekdayNumberMonday,
        "U": $15b08980342d698e$var$parseWeekNumberSunday,
        "V": $15b08980342d698e$var$parseWeekNumberISO,
        "w": $15b08980342d698e$var$parseWeekdayNumberSunday,
        "W": $15b08980342d698e$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $15b08980342d698e$var$parseYear,
        "Y": $15b08980342d698e$var$parseFullYear,
        "Z": $15b08980342d698e$var$parseZone,
        "%": $15b08980342d698e$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $15b08980342d698e$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $15b08980342d698e$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $15b08980342d698e$var$utcDate($15b08980342d698e$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $5Wexi.utcMonday.ceil(week) : (0, $5Wexi.utcMonday)(week);
                    week = $5Wexi.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $15b08980342d698e$var$localDate($15b08980342d698e$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $5Wexi.timeMonday.ceil(week) : (0, $5Wexi.timeMonday)(week);
                    week = $5Wexi.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $15b08980342d698e$var$utcDate($15b08980342d698e$var$newDate(d.y, 0, 1)).getUTCDay() : $15b08980342d698e$var$localDate($15b08980342d698e$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $15b08980342d698e$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $15b08980342d698e$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $15b08980342d698e$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $15b08980342d698e$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $15b08980342d698e$var$numberRe = /^\s*\d+/, // note: ignores next directive
$15b08980342d698e$var$percentRe = /^%/, $15b08980342d698e$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $15b08980342d698e$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $15b08980342d698e$var$requote(s) {
    return s.replace($15b08980342d698e$var$requoteRe, "\\$&");
}
function $15b08980342d698e$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($15b08980342d698e$var$requote).join("|") + ")", "i");
}
function $15b08980342d698e$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $15b08980342d698e$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseWeekNumberSunday(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseWeekNumberISO(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseWeekNumberMonday(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseFullYear(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseYear(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseQuarter(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseMonthNumber(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseDayOfMonth(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseDayOfYear(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseHour24(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseMinutes(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseSeconds(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseMilliseconds(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseMicroseconds(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseLiteralPercent(d, string, i) {
    var n = $15b08980342d698e$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $15b08980342d698e$var$parseUnixTimestamp(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $15b08980342d698e$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $15b08980342d698e$var$formatDayOfMonth(d, p) {
    return $15b08980342d698e$var$pad(d.getDate(), p, 2);
}
function $15b08980342d698e$var$formatHour24(d, p) {
    return $15b08980342d698e$var$pad(d.getHours(), p, 2);
}
function $15b08980342d698e$var$formatHour12(d, p) {
    return $15b08980342d698e$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $15b08980342d698e$var$formatDayOfYear(d, p) {
    return $15b08980342d698e$var$pad(1 + $5Wexi.timeDay.count((0, $5Wexi.timeYear)(d), d), p, 3);
}
function $15b08980342d698e$var$formatMilliseconds(d, p) {
    return $15b08980342d698e$var$pad(d.getMilliseconds(), p, 3);
}
function $15b08980342d698e$var$formatMicroseconds(d, p) {
    return $15b08980342d698e$var$formatMilliseconds(d, p) + "000";
}
function $15b08980342d698e$var$formatMonthNumber(d, p) {
    return $15b08980342d698e$var$pad(d.getMonth() + 1, p, 2);
}
function $15b08980342d698e$var$formatMinutes(d, p) {
    return $15b08980342d698e$var$pad(d.getMinutes(), p, 2);
}
function $15b08980342d698e$var$formatSeconds(d, p) {
    return $15b08980342d698e$var$pad(d.getSeconds(), p, 2);
}
function $15b08980342d698e$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $15b08980342d698e$var$formatWeekNumberSunday(d, p) {
    return $15b08980342d698e$var$pad($5Wexi.timeSunday.count((0, $5Wexi.timeYear)(d) - 1, d), p, 2);
}
function $15b08980342d698e$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $5Wexi.timeThursday)(d) : $5Wexi.timeThursday.ceil(d);
}
function $15b08980342d698e$var$formatWeekNumberISO(d, p) {
    d = $15b08980342d698e$var$dISO(d);
    return $15b08980342d698e$var$pad($5Wexi.timeThursday.count((0, $5Wexi.timeYear)(d), d) + ((0, $5Wexi.timeYear)(d).getDay() === 4), p, 2);
}
function $15b08980342d698e$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $15b08980342d698e$var$formatWeekNumberMonday(d, p) {
    return $15b08980342d698e$var$pad($5Wexi.timeMonday.count((0, $5Wexi.timeYear)(d) - 1, d), p, 2);
}
function $15b08980342d698e$var$formatYear(d, p) {
    return $15b08980342d698e$var$pad(d.getFullYear() % 100, p, 2);
}
function $15b08980342d698e$var$formatYearISO(d, p) {
    d = $15b08980342d698e$var$dISO(d);
    return $15b08980342d698e$var$pad(d.getFullYear() % 100, p, 2);
}
function $15b08980342d698e$var$formatFullYear(d, p) {
    return $15b08980342d698e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $15b08980342d698e$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $5Wexi.timeThursday)(d) : $5Wexi.timeThursday.ceil(d);
    return $15b08980342d698e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $15b08980342d698e$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $15b08980342d698e$var$pad(z / 60 | 0, "0", 2) + $15b08980342d698e$var$pad(z % 60, "0", 2);
}
function $15b08980342d698e$var$formatUTCDayOfMonth(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCDate(), p, 2);
}
function $15b08980342d698e$var$formatUTCHour24(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCHours(), p, 2);
}
function $15b08980342d698e$var$formatUTCHour12(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $15b08980342d698e$var$formatUTCDayOfYear(d, p) {
    return $15b08980342d698e$var$pad(1 + $5Wexi.utcDay.count((0, $5Wexi.utcYear)(d), d), p, 3);
}
function $15b08980342d698e$var$formatUTCMilliseconds(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $15b08980342d698e$var$formatUTCMicroseconds(d, p) {
    return $15b08980342d698e$var$formatUTCMilliseconds(d, p) + "000";
}
function $15b08980342d698e$var$formatUTCMonthNumber(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $15b08980342d698e$var$formatUTCMinutes(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCMinutes(), p, 2);
}
function $15b08980342d698e$var$formatUTCSeconds(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCSeconds(), p, 2);
}
function $15b08980342d698e$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $15b08980342d698e$var$formatUTCWeekNumberSunday(d, p) {
    return $15b08980342d698e$var$pad($5Wexi.utcSunday.count((0, $5Wexi.utcYear)(d) - 1, d), p, 2);
}
function $15b08980342d698e$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $5Wexi.utcThursday)(d) : $5Wexi.utcThursday.ceil(d);
}
function $15b08980342d698e$var$formatUTCWeekNumberISO(d, p) {
    d = $15b08980342d698e$var$UTCdISO(d);
    return $15b08980342d698e$var$pad($5Wexi.utcThursday.count((0, $5Wexi.utcYear)(d), d) + ((0, $5Wexi.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $15b08980342d698e$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $15b08980342d698e$var$formatUTCWeekNumberMonday(d, p) {
    return $15b08980342d698e$var$pad($5Wexi.utcMonday.count((0, $5Wexi.utcYear)(d) - 1, d), p, 2);
}
function $15b08980342d698e$var$formatUTCYear(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $15b08980342d698e$var$formatUTCYearISO(d, p) {
    d = $15b08980342d698e$var$UTCdISO(d);
    return $15b08980342d698e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $15b08980342d698e$var$formatUTCFullYear(d, p) {
    return $15b08980342d698e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $15b08980342d698e$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $5Wexi.utcThursday)(d) : $5Wexi.utcThursday.ceil(d);
    return $15b08980342d698e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $15b08980342d698e$var$formatUTCZone() {
    return "+0000";
}
function $15b08980342d698e$var$formatLiteralPercent() {
    return "%";
}
function $15b08980342d698e$var$formatUnixTimestamp(d) {
    return +d;
}
function $15b08980342d698e$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRequire.register("ivS2A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $3ODsc = parcelRequire("3ODsc");
var $d7a50aa13fbca824$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $d7a50aa13fbca824$var$isoSpecifier;
function $d7a50aa13fbca824$var$formatIsoNative(date) {
    return date.toISOString();
}
var $d7a50aa13fbca824$var$formatIso = Date.prototype.toISOString ? $d7a50aa13fbca824$var$formatIsoNative : (0, $3ODsc.utcFormat)($d7a50aa13fbca824$var$isoSpecifier);
var $d7a50aa13fbca824$var$_default = $d7a50aa13fbca824$var$formatIso;
module.exports.default = $d7a50aa13fbca824$var$_default;

});

parcelRequire.register("2XYtb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ivS2A = parcelRequire("ivS2A");

var $3ODsc = parcelRequire("3ODsc");
function $228fff759a777911$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $228fff759a777911$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $228fff759a777911$var$parseIsoNative : (0, $3ODsc.utcParse)($ivS2A.isoSpecifier);
var $228fff759a777911$var$_default = $228fff759a777911$var$parseIso;
module.exports.default = $228fff759a777911$var$_default;

});



parcelRequire.register("caTDE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8dd193e291cd332f$var$utcTime;

var $5Wexi = parcelRequire("5Wexi");

var $2XPv2 = parcelRequire("2XPv2");

var $a9YvZ = parcelRequire("a9YvZ");

var $3HcC4 = parcelRequire("3HcC4");
function $8dd193e291cd332f$var$utcTime() {
    return $3HcC4.initRange.apply((0, $a9YvZ.calendar)($5Wexi.utcTicks, $5Wexi.utcTickInterval, $5Wexi.utcYear, $5Wexi.utcMonth, $5Wexi.utcWeek, $5Wexi.utcDay, $5Wexi.utcHour, $5Wexi.utcMinute, $5Wexi.utcSecond, $2XPv2.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRequire.register("iFnQQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $d96e8eba0625eccd$var$copy;
module.exports.default = $d96e8eba0625eccd$var$sequential;
module.exports.sequentialLog = $d96e8eba0625eccd$var$sequentialLog;
module.exports.sequentialPow = $d96e8eba0625eccd$var$sequentialPow;
module.exports.sequentialSqrt = $d96e8eba0625eccd$var$sequentialSqrt;
module.exports.sequentialSymlog = $d96e8eba0625eccd$var$sequentialSymlog;

var $kHNFO = parcelRequire("kHNFO");

var $4p545 = parcelRequire("4p545");

var $3HcC4 = parcelRequire("3HcC4");

var $4bGV3 = parcelRequire("4bGV3");

var $jldhc = parcelRequire("jldhc");

var $dyYUY = parcelRequire("dyYUY");

var $eFo2P = parcelRequire("eFo2P");
function $d96e8eba0625eccd$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $4p545.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($kHNFO.interpolate);
    scale.rangeRound = range($kHNFO.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $d96e8eba0625eccd$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $d96e8eba0625eccd$var$sequential() {
    var scale = (0, $4bGV3.linearish)($d96e8eba0625eccd$var$transformer()($4p545.identity));
    scale.copy = function() {
        return $d96e8eba0625eccd$var$copy(scale, $d96e8eba0625eccd$var$sequential());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $d96e8eba0625eccd$var$sequentialLog() {
    var scale = (0, $jldhc.loggish)($d96e8eba0625eccd$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $d96e8eba0625eccd$var$copy(scale, $d96e8eba0625eccd$var$sequentialLog()).base(scale.base());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $d96e8eba0625eccd$var$sequentialSymlog() {
    var scale = (0, $dyYUY.symlogish)($d96e8eba0625eccd$var$transformer());
    scale.copy = function() {
        return $d96e8eba0625eccd$var$copy(scale, $d96e8eba0625eccd$var$sequentialSymlog()).constant(scale.constant());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $d96e8eba0625eccd$var$sequentialPow() {
    var scale = (0, $eFo2P.powish)($d96e8eba0625eccd$var$transformer());
    scale.copy = function() {
        return $d96e8eba0625eccd$var$copy(scale, $d96e8eba0625eccd$var$sequentialPow()).exponent(scale.exponent());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $d96e8eba0625eccd$var$sequentialSqrt() {
    return $d96e8eba0625eccd$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("f0DQk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aed5c31dd3cdbab5$var$sequentialQuantile;

var $2ccY8 = parcelRequire("2ccY8");

var $4p545 = parcelRequire("4p545");

var $3HcC4 = parcelRequire("3HcC4");
function $aed5c31dd3cdbab5$var$sequentialQuantile() {
    var domain = [], interpolator = $4p545.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $2ccY8.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($2ccY8.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $2ccY8.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $aed5c31dd3cdbab5$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}

});

parcelRequire.register("jzX1k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e40f117275b6c3e4$var$diverging;
module.exports.divergingLog = $e40f117275b6c3e4$var$divergingLog;
module.exports.divergingPow = $e40f117275b6c3e4$var$divergingPow;
module.exports.divergingSqrt = $e40f117275b6c3e4$var$divergingSqrt;
module.exports.divergingSymlog = $e40f117275b6c3e4$var$divergingSymlog;

var $kHNFO = parcelRequire("kHNFO");

var $4p545 = parcelRequire("4p545");

var $3HcC4 = parcelRequire("3HcC4");

var $4bGV3 = parcelRequire("4bGV3");

var $jldhc = parcelRequire("jldhc");

var $iFnQQ = parcelRequire("iFnQQ");

var $dyYUY = parcelRequire("dyYUY");

var $eFo2P = parcelRequire("eFo2P");
function $e40f117275b6c3e4$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $4p545.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $kHNFO.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($kHNFO.interpolate);
    scale.rangeRound = range($kHNFO.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $e40f117275b6c3e4$var$diverging() {
    var scale = (0, $4bGV3.linearish)($e40f117275b6c3e4$var$transformer()($4p545.identity));
    scale.copy = function() {
        return (0, $iFnQQ.copy)(scale, $e40f117275b6c3e4$var$diverging());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $e40f117275b6c3e4$var$divergingLog() {
    var scale = (0, $jldhc.loggish)($e40f117275b6c3e4$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $iFnQQ.copy)(scale, $e40f117275b6c3e4$var$divergingLog()).base(scale.base());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $e40f117275b6c3e4$var$divergingSymlog() {
    var scale = (0, $dyYUY.symlogish)($e40f117275b6c3e4$var$transformer());
    scale.copy = function() {
        return (0, $iFnQQ.copy)(scale, $e40f117275b6c3e4$var$divergingSymlog()).constant(scale.constant());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $e40f117275b6c3e4$var$divergingPow() {
    var scale = (0, $eFo2P.powish)($e40f117275b6c3e4$var$transformer());
    scale.copy = function() {
        return (0, $iFnQQ.copy)(scale, $e40f117275b6c3e4$var$divergingPow()).exponent(scale.exponent());
    };
    return $3HcC4.initInterpolator.apply(scale, arguments);
}
function $e40f117275b6c3e4$var$divergingSqrt() {
    return $e40f117275b6c3e4$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRequire.register("kgaqp", function(module, exports) {
var $03ce68d48696dd93$var$minus = "-".charCodeAt(0);
var $03ce68d48696dd93$var$plus = "+".charCodeAt(0);
var $03ce68d48696dd93$var$dot = ".".charCodeAt(0);
var $03ce68d48696dd93$var$exp = "e".charCodeAt(0);
var $03ce68d48696dd93$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $03ce68d48696dd93$var$exp || code === $03ce68d48696dd93$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $03ce68d48696dd93$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $03ce68d48696dd93$var$plus || code === $03ce68d48696dd93$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});

parcelRequire.register("39sek", function(module, exports) {

module.exports = new URL((parcelRequire("5V6iE")).resolve("fUgK4"), import.meta.url).toString();

});

parcelRequire.register("6ARCB", function(module, exports) {

module.exports = new URL((parcelRequire("5V6iE")).resolve("1FV8G"), import.meta.url).toString();

});

parcelRequire.register("5EMV6", function(module, exports) {

module.exports = new URL((parcelRequire("5V6iE")).resolve("e8MzY"), import.meta.url).toString();

});

parcelRequire.register("fvQWf", function(module, exports) {

module.exports = new URL((parcelRequire("5V6iE")).resolve("4cbHo"), import.meta.url).toString();

});

parcelRequire.register("6NXnm", function(module, exports) {

module.exports = new URL((parcelRequire("5V6iE")).resolve("7lCuy"), import.meta.url).toString();

});

parcelRequire.register("4l43E", function(module, exports) {

module.exports = new URL((parcelRequire("5V6iE")).resolve("kmPz4"), import.meta.url).toString();

});

parcelRequire.register("54LfL", function(module, exports) {

module.exports = new URL((parcelRequire("5V6iE")).resolve("h5LP5"), import.meta.url).toString();

});

parcelRequire.register("axiof", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.33
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment.
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "0.7.33", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2000: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /yabrowser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                // Oculus/Samsung/Sailfish/Huawei Browser
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                // Ordered by popularity
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /((ipod|iphone)\d+,\d+)/i // iPod/iPhone model
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ipad\d+,\d+)/i // iPad model
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    "Mac OS"
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    "Chromium OS"
                ],
                VERSION
            ],
            [
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _ua = ua || (typeof window1 !== UNDEF_TYPE && window1.navigator && window1.navigator.userAgent ? window1.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if ("object" !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRequire.register("eZ0I6", function(module, exports) {

var $hvPjh = parcelRequire("hvPjh");
exports = module.exports = SemVer;
var debug;
/* istanbul ignore next */ typeof $hvPjh === "object" && $hvPjh.env && undefined;
debug = function() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = "2.0.0";
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
// The actual regexps go on exports.re
var re = exports.re = [];
var safeRe = exports.safeRe = [];
var src = exports.src = [];
var R = 0;
var LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
var safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
function makeSafeRe(value) {
    for(var i = 0; i < safeRegexReplacements.length; i++){
        var token = safeRegexReplacements[i][0];
        var max = safeRegexReplacements[i][1];
        value = value.split(token + "*").join(token + "{0," + max + "}").split(token + "+").join(token + "{1," + max + "}");
    }
    return value;
}
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = "0|[1-9]\\d*";
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = "\\d+";
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-]" + LETTERDASHNUMBER + "*";
// ## Main Version
// Three dot-separated numeric identifiers.
var MAINVERSION = R++;
src[MAINVERSION] = "(" + src[NUMERICIDENTIFIER] + ")\\." + "(" + src[NUMERICIDENTIFIER] + ")\\." + "(" + src[NUMERICIDENTIFIER] + ")";
var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = "(" + src[NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[NUMERICIDENTIFIERLOOSE] + ")";
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = "(?:" + src[NUMERICIDENTIFIER] + "|" + src[NONNUMERICIDENTIFIER] + ")";
var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = "(?:" + src[NUMERICIDENTIFIERLOOSE] + "|" + src[NONNUMERICIDENTIFIER] + ")";
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
var PRERELEASE = R++;
src[PRERELEASE] = "(?:-(" + src[PRERELEASEIDENTIFIER] + "(?:\\." + src[PRERELEASEIDENTIFIER] + ")*))";
var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = "(?:-?(" + src[PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + src[PRERELEASEIDENTIFIERLOOSE] + ")*))";
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = LETTERDASHNUMBER + "+";
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
var BUILD = R++;
src[BUILD] = "(?:\\+(" + src[BUILDIDENTIFIER] + "(?:\\." + src[BUILDIDENTIFIER] + ")*))";
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
var FULL = R++;
var FULLPLAIN = "v?" + src[MAINVERSION] + src[PRERELEASE] + "?" + src[BUILD] + "?";
src[FULL] = "^" + FULLPLAIN + "$";
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = "[v=\\s]*" + src[MAINVERSIONLOOSE] + src[PRERELEASELOOSE] + "?" + src[BUILD] + "?";
var LOOSE = R++;
src[LOOSE] = "^" + LOOSEPLAIN + "$";
var GTLT = R++;
src[GTLT] = "((?:<|>)?=?)";
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + "|x|X|\\*";
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + "|x|X|\\*";
var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = "[v=\\s]*(" + src[XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIER] + ")" + "(?:" + src[PRERELEASE] + ")?" + src[BUILD] + "?" + ")?)?";
var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = "[v=\\s]*(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:" + src[PRERELEASELOOSE] + ")?" + src[BUILD] + "?" + ")?)?";
var XRANGE = R++;
src[XRANGE] = "^" + src[GTLT] + "\\s*" + src[XRANGEPLAIN] + "$";
var XRANGELOOSE = R++;
src[XRANGELOOSE] = "^" + src[GTLT] + "\\s*" + src[XRANGEPLAINLOOSE] + "$";
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = "(?:^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "})" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:$|[^\\d])";
// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = "(?:~>?)";
var TILDETRIM = R++;
src[TILDETRIM] = "(\\s*)" + src[LONETILDE] + "\\s+";
re[TILDETRIM] = new RegExp(src[TILDETRIM], "g");
safeRe[TILDETRIM] = new RegExp(makeSafeRe(src[TILDETRIM]), "g");
var tildeTrimReplace = "$1~";
var TILDE = R++;
src[TILDE] = "^" + src[LONETILDE] + src[XRANGEPLAIN] + "$";
var TILDELOOSE = R++;
src[TILDELOOSE] = "^" + src[LONETILDE] + src[XRANGEPLAINLOOSE] + "$";
// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = "(?:\\^)";
var CARETTRIM = R++;
src[CARETTRIM] = "(\\s*)" + src[LONECARET] + "\\s+";
re[CARETTRIM] = new RegExp(src[CARETTRIM], "g");
safeRe[CARETTRIM] = new RegExp(makeSafeRe(src[CARETTRIM]), "g");
var caretTrimReplace = "$1^";
var CARET = R++;
src[CARET] = "^" + src[LONECARET] + src[XRANGEPLAIN] + "$";
var CARETLOOSE = R++;
src[CARETLOOSE] = "^" + src[LONECARET] + src[XRANGEPLAINLOOSE] + "$";
// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = "^" + src[GTLT] + "\\s*(" + LOOSEPLAIN + ")$|^$";
var COMPARATOR = R++;
src[COMPARATOR] = "^" + src[GTLT] + "\\s*(" + FULLPLAIN + ")$|^$";
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = "(\\s*)" + src[GTLT] + "\\s*(" + LOOSEPLAIN + "|" + src[XRANGEPLAIN] + ")";
// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], "g");
safeRe[COMPARATORTRIM] = new RegExp(makeSafeRe(src[COMPARATORTRIM]), "g");
var comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = "^\\s*(" + src[XRANGEPLAIN] + ")" + "\\s+-\\s+" + "(" + src[XRANGEPLAIN] + ")" + "\\s*$";
var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = "^\\s*(" + src[XRANGEPLAINLOOSE] + ")" + "\\s+-\\s+" + "(" + src[XRANGEPLAINLOOSE] + ")" + "\\s*$";
// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = "(<|>)?=?\\s*\\*";
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) {
        re[i] = new RegExp(src[i]);
        // Replace all greedy whitespace to prevent regex dos issues. These regex are
        // used internally via the safeRe object since all inputs in this library get
        // normalized first to trim and collapse all extra whitespace. The original
        // regexes are exported for userland consumption and lower level usage. A
        // future breaking change could export the safer regex only with a note that
        // all input should have extra whitespace removed.
        safeRe[i] = new RegExp(makeSafeRe(src[i]));
    }
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? safeRe[LOOSE] : safeRe[FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== "string") throw new TypeError("Invalid Version: " + version);
    if (version.length > MAX_LENGTH) throw new TypeError("version is longer than " + MAX_LENGTH + " characters");
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug("SemVer", version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? safeRe[LOOSE] : safeRe[FULL]);
    if (!m) throw new TypeError("Invalid Version: " + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split(".").map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split(".") : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + "." + this.minor + "." + this.patch;
    if (this.prerelease.length) this.version += "-" + this.prerelease.join(".");
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug("SemVer.compare", this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug("prerelease compare", i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case "premajor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc("pre", identifier);
            break;
        case "preminor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc("pre", identifier);
            break;
        case "prepatch":
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
            if (this.prerelease.length === 0) this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        case "major":
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "minor":
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "patch":
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case "pre":
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error("invalid increment argument: " + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === "string") {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = "";
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = "pre";
            var defaultResult = "prerelease";
        }
        for(var key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compare(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.rcompare(a, b, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return eq(a, b, loose);
        case "!=":
            return neq(a, b, loose);
        case ">":
            return gt(a, b, loose);
        case ">=":
            return gte(a, b, loose);
        case "<":
            return lt(a, b, loose);
        case "<=":
            return lte(a, b, loose);
        default:
            throw new TypeError("Invalid operator: " + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    comp = comp.trim().split(/\s+/).join(" ");
    debug("comparator", comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = "";
    else this.value = this.operator + this.semver.version;
    debug("comp", this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError("Invalid comparator: " + comp);
    this.operator = m[1];
    if (this.operator === "=") this.operator = "";
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug("Comparator.test", version, this.options.loose);
    if (this.semver === ANY) return true;
    if (typeof version === "string") version = new SemVer(version, this.options);
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === "") {
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === "") {
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
    var sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
    var oppositeDirectionsLessThan = cmp(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
    var oppositeDirectionsGreaterThan = cmp(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First reduce all whitespace as much as possible so we do not have to rely
    // on potentially slow regexes like \s*. This is then stored and used for
    // future error messages as well.
    this.raw = range.trim().split(/\s+/).join(" ");
    // First, split based on boolean or ||
    this.set = this.raw.split("||").map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError("Invalid SemVer Range: " + this.raw);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(" ").trim();
    }).join("||").trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? safeRe[HYPHENRANGELOOSE] : safeRe[HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug("hyphen replace", range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(safeRe[COMPARATORTRIM], comparatorTrimReplace);
    debug("comparator trim", range, safeRe[COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(safeRe[TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(safeRe[CARETTRIM], caretTrimReplace);
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var set = range.split(" ").map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(" ").split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError("a Range is required");
    return this.set.some(function(thisComparators) {
        return thisComparators.every(function(thisComparator) {
            return range.set.some(function(rangeComparators) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug("comp", comp, options);
    comp = replaceCarets(comp, options);
    debug("caret", comp);
    comp = replaceTildes(comp, options);
    debug("tildes", comp);
    comp = replaceXRanges(comp, options);
    debug("xrange", comp);
    comp = replaceStars(comp, options);
    debug("stars", comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(" ");
}
function replaceTilde(comp, options) {
    var r = options.loose ? safeRe[TILDELOOSE] : safeRe[TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("tilde", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        else if (pr) {
            debug("replaceTilde pr", pr);
            ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
        debug("tilde return", ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(" ");
}
function replaceCaret(comp, options) {
    debug("caret", comp, options);
    var r = options.loose ? safeRe[CARETLOOSE] : safeRe[CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("caret", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) {
            if (M === "0") ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
            else ret = ">=" + M + "." + m + ".0 <" + (+M + 1) + ".0.0";
        } else if (pr) {
            debug("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + (+M + 1) + ".0.0";
        } else {
            debug("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + " <" + (+M + 1) + ".0.0";
        }
        debug("caret return", ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(" ");
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? safeRe[XRANGELOOSE] : safeRe[XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + "." + m + "." + p;
        } else if (xm) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (xp) ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        debug("xRange return", ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(safeRe[STAR], "");
}
// This function is passed to string.replace(safeRe[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = "";
    else if (isX(fm)) from = ">=" + fM + ".0.0";
    else if (isX(fp)) from = ">=" + fM + "." + fm + ".0";
    else from = ">=" + from;
    if (isX(tM)) to = "";
    else if (isX(tm)) to = "<" + (+tM + 1) + ".0.0";
    else if (isX(tp)) to = "<" + tM + "." + (+tm + 1) + ".0";
    else if (tpr) to = "<=" + tM + "." + tm + "." + tp + "-" + tpr;
    else to = "<=" + to;
    return (from + " " + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === "string") version = new SemVer(version, this.options);
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer("0.0.0");
    if (range.test(minver)) return minver;
    minver = new SemVer("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: " + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || "*";
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, "<", options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, ">", options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version) {
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    var match = version.match(safeRe[COERCE]);
    if (match == null) return null;
    return parse(match[1] + "." + (match[2] || "0") + "." + (match[3] || "0"));
}

});
parcelRequire.register("hvPjh", function(module, exports) {
// shim for using process in browser
var $cbfd2205ff53e00f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cbfd2205ff53e00f$var$cachedSetTimeout;
var $cbfd2205ff53e00f$var$cachedClearTimeout;
function $cbfd2205ff53e00f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cbfd2205ff53e00f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cbfd2205ff53e00f$var$cachedSetTimeout = setTimeout;
        else $cbfd2205ff53e00f$var$cachedSetTimeout = $cbfd2205ff53e00f$var$defaultSetTimout;
    } catch (e) {
        $cbfd2205ff53e00f$var$cachedSetTimeout = $cbfd2205ff53e00f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cbfd2205ff53e00f$var$cachedClearTimeout = clearTimeout;
        else $cbfd2205ff53e00f$var$cachedClearTimeout = $cbfd2205ff53e00f$var$defaultClearTimeout;
    } catch (e) {
        $cbfd2205ff53e00f$var$cachedClearTimeout = $cbfd2205ff53e00f$var$defaultClearTimeout;
    }
})();
function $cbfd2205ff53e00f$var$runTimeout(fun) {
    if ($cbfd2205ff53e00f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cbfd2205ff53e00f$var$cachedSetTimeout === $cbfd2205ff53e00f$var$defaultSetTimout || !$cbfd2205ff53e00f$var$cachedSetTimeout) && setTimeout) {
        $cbfd2205ff53e00f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cbfd2205ff53e00f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cbfd2205ff53e00f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cbfd2205ff53e00f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cbfd2205ff53e00f$var$runClearTimeout(marker) {
    if ($cbfd2205ff53e00f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cbfd2205ff53e00f$var$cachedClearTimeout === $cbfd2205ff53e00f$var$defaultClearTimeout || !$cbfd2205ff53e00f$var$cachedClearTimeout) && clearTimeout) {
        $cbfd2205ff53e00f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cbfd2205ff53e00f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cbfd2205ff53e00f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cbfd2205ff53e00f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cbfd2205ff53e00f$var$queue = [];
var $cbfd2205ff53e00f$var$draining = false;
var $cbfd2205ff53e00f$var$currentQueue;
var $cbfd2205ff53e00f$var$queueIndex = -1;
function $cbfd2205ff53e00f$var$cleanUpNextTick() {
    if (!$cbfd2205ff53e00f$var$draining || !$cbfd2205ff53e00f$var$currentQueue) return;
    $cbfd2205ff53e00f$var$draining = false;
    if ($cbfd2205ff53e00f$var$currentQueue.length) $cbfd2205ff53e00f$var$queue = $cbfd2205ff53e00f$var$currentQueue.concat($cbfd2205ff53e00f$var$queue);
    else $cbfd2205ff53e00f$var$queueIndex = -1;
    if ($cbfd2205ff53e00f$var$queue.length) $cbfd2205ff53e00f$var$drainQueue();
}
function $cbfd2205ff53e00f$var$drainQueue() {
    if ($cbfd2205ff53e00f$var$draining) return;
    var timeout = $cbfd2205ff53e00f$var$runTimeout($cbfd2205ff53e00f$var$cleanUpNextTick);
    $cbfd2205ff53e00f$var$draining = true;
    var len = $cbfd2205ff53e00f$var$queue.length;
    while(len){
        $cbfd2205ff53e00f$var$currentQueue = $cbfd2205ff53e00f$var$queue;
        $cbfd2205ff53e00f$var$queue = [];
        while(++$cbfd2205ff53e00f$var$queueIndex < len)if ($cbfd2205ff53e00f$var$currentQueue) $cbfd2205ff53e00f$var$currentQueue[$cbfd2205ff53e00f$var$queueIndex].run();
        $cbfd2205ff53e00f$var$queueIndex = -1;
        len = $cbfd2205ff53e00f$var$queue.length;
    }
    $cbfd2205ff53e00f$var$currentQueue = null;
    $cbfd2205ff53e00f$var$draining = false;
    $cbfd2205ff53e00f$var$runClearTimeout(timeout);
}
$cbfd2205ff53e00f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cbfd2205ff53e00f$var$queue.push(new $cbfd2205ff53e00f$var$Item(fun, args));
    if ($cbfd2205ff53e00f$var$queue.length === 1 && !$cbfd2205ff53e00f$var$draining) $cbfd2205ff53e00f$var$runTimeout($cbfd2205ff53e00f$var$drainQueue);
};
// v8 likes predictible objects
function $cbfd2205ff53e00f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cbfd2205ff53e00f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cbfd2205ff53e00f$var$process.title = "browser";
$cbfd2205ff53e00f$var$process.browser = true;
$cbfd2205ff53e00f$var$process.env = {};
$cbfd2205ff53e00f$var$process.argv = [];
$cbfd2205ff53e00f$var$process.version = ""; // empty string to avoid regexp issues
$cbfd2205ff53e00f$var$process.versions = {};
function $cbfd2205ff53e00f$var$noop() {}
$cbfd2205ff53e00f$var$process.on = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.addListener = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.once = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.off = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.removeListener = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.removeAllListeners = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.emit = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.prependListener = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.prependOnceListener = $cbfd2205ff53e00f$var$noop;
$cbfd2205ff53e00f$var$process.listeners = function(name) {
    return [];
};
$cbfd2205ff53e00f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cbfd2205ff53e00f$var$process.cwd = function() {
    return "/";
};
$cbfd2205ff53e00f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cbfd2205ff53e00f$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("kZrZm", function(module, exports) {

$parcel$export(module.exports, "auth", function () { return $f47f371a591be597$export$73693bad9f5880b0; });
parcelRequire("dZzSU");
var $8eXKx = parcelRequire("8eXKx");
parcelRequire("iG8u9");

var $b094N = parcelRequire("b094N");
parcelRequire("5cupn");
parcelRequire("krkuu");
parcelRequire("2B0cO");
parcelRequire("3lq7C");
parcelRequire("3NLoR");
(function() {
    (function() {
        var l, aa = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ba;
        if ("function" == typeof Object.setPrototypeOf) ba = Object.setPrototypeOf;
        else {
            var ca;
            a: {
                var da = {
                    xb: !0
                }, ea = {};
                try {
                    ea.__proto__ = da;
                    ca = ea.xb;
                    break a;
                } catch (a) {}
                ca = !1;
            }
            ba = ca ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var fa = ba;
        function m(a, b) {
            a.prototype = aa(b.prototype);
            a.prototype.constructor = a;
            if (fa) fa(a, b);
            else for(var c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.K = b.prototype;
        }
        var ha = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            a != Array.prototype && a != Object.prototype && (a[b] = c.value);
        }, ia = "undefined" != typeof window && window === this ? this : "undefined" != typeof $parcel$global && null != $parcel$global ? $parcel$global : this;
        function ja(a, b) {
            if (b) {
                var c = ia;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    e in c || (c[e] = {});
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && ha(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        ja("Object.is", function(a) {
            return a ? a : function(b, c) {
                return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
            };
        });
        ja("Array.prototype.includes", function(a) {
            return a ? a : function(b, c) {
                var d = this;
                d instanceof String && (d = String(d));
                var e = d.length;
                c = c || 0;
                for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                    var f = d[c];
                    if (f === b || Object.is(f, b)) return !0;
                }
                return !1;
            };
        });
        var n = this;
        function ka(a) {
            return void 0 !== a;
        }
        function q(a) {
            return "string" == typeof a;
        }
        var la = /^[\w+/_-]+[=]{0,2}$/, ma = null;
        function na() {}
        function oa(a) {
            a.W = void 0;
            a.Xa = function() {
                return a.W ? a.W : a.W = new a;
            };
        }
        function pa(a) {
            var b = typeof a;
            if ("object" == b) {
                if (a) {
                    if (a instanceof Array) return "array";
                    if (a instanceof Object) return b;
                    var c = Object.prototype.toString.call(a);
                    if ("[object Window]" == c) return "object";
                    if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
                    if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
                } else return "null";
            } else if ("function" == b && "undefined" == typeof a.call) return "object";
            return b;
        }
        function qa(a) {
            return "array" == pa(a);
        }
        function ra(a) {
            var b = pa(a);
            return "array" == b || "object" == b && "number" == typeof a.length;
        }
        function sa(a) {
            return "function" == pa(a);
        }
        function ta(a) {
            var b = typeof a;
            return "object" == b && null != a || "function" == b;
        }
        var ua = "closure_uid_" + (1E9 * Math.random() >>> 0), va = 0;
        function wa(a, b, c) {
            return a.call.apply(a.bind, arguments);
        }
        function xa(a, b, c) {
            if (!a) throw Error();
            if (2 < arguments.length) {
                var d = Array.prototype.slice.call(arguments, 2);
                return function() {
                    var e = Array.prototype.slice.call(arguments);
                    Array.prototype.unshift.apply(e, d);
                    return a.apply(b, e);
                };
            }
            return function() {
                return a.apply(b, arguments);
            };
        }
        function r(a, b, c) {
            Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? r = wa : r = xa;
            return r.apply(null, arguments);
        }
        function za(a, b) {
            var c = Array.prototype.slice.call(arguments, 1);
            return function() {
                var d = c.slice();
                d.push.apply(d, arguments);
                return a.apply(this, d);
            };
        }
        function u(a, b) {
            for(var c in b)a[c] = b[c];
        }
        var Aa = Date.now || function() {
            return +new Date;
        };
        function v(a, b) {
            a = a.split(".");
            var c = n;
            a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
            for(var d; a.length && (d = a.shift());)!a.length && ka(b) ? c[d] = b : c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {};
        }
        function w(a, b) {
            function c() {}
            c.prototype = b.prototype;
            a.K = b.prototype;
            a.prototype = new c;
            a.prototype.constructor = a;
            a.wc = function(d, e, f) {
                for(var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++)g[h - 2] = arguments[h];
                return b.prototype[e].apply(d, g);
            };
        }
        function Ba(a) {
            if (Error.captureStackTrace) Error.captureStackTrace(this, Ba);
            else {
                var b = Error().stack;
                b && (this.stack = b);
            }
            a && (this.message = String(a));
        }
        w(Ba, Error);
        Ba.prototype.name = "CustomError";
        var Da;
        function Ea(a, b) {
            a = a.split("%s");
            for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
            Ba.call(this, c + a[d]);
        }
        w(Ea, Ba);
        Ea.prototype.name = "AssertionError";
        function Fa(a, b) {
            throw new Ea("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
        }
        var Ga = Array.prototype.indexOf ? function(a, b) {
            return Array.prototype.indexOf.call(a, b, void 0);
        } : function(a, b) {
            if (q(a)) return q(b) && 1 == b.length ? a.indexOf(b, 0) : -1;
            for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
            return -1;
        }, Ha = Array.prototype.forEach ? function(a, b, c) {
            Array.prototype.forEach.call(a, b, c);
        } : function(a, b, c) {
            for(var d = a.length, e = q(a) ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
        };
        function Ia(a, b) {
            for(var c = q(a) ? a.split("") : a, d = a.length - 1; 0 <= d; --d)d in c && b.call(void 0, c[d], d, a);
        }
        var Ja = Array.prototype.filter ? function(a, b) {
            return Array.prototype.filter.call(a, b, void 0);
        } : function(a, b) {
            for(var c = a.length, d = [], e = 0, f = q(a) ? a.split("") : a, g = 0; g < c; g++)if (g in f) {
                var h = f[g];
                b.call(void 0, h, g, a) && (d[e++] = h);
            }
            return d;
        }, Ka = Array.prototype.map ? function(a, b) {
            return Array.prototype.map.call(a, b, void 0);
        } : function(a, b) {
            for(var c = a.length, d = Array(c), e = q(a) ? a.split("") : a, f = 0; f < c; f++)f in e && (d[f] = b.call(void 0, e[f], f, a));
            return d;
        }, La = Array.prototype.some ? function(a, b) {
            return Array.prototype.some.call(a, b, void 0);
        } : function(a, b) {
            for(var c = a.length, d = q(a) ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) return !0;
            return !1;
        };
        function Ma(a, b) {
            return 0 <= Ga(a, b);
        }
        function Na(a, b) {
            b = Ga(a, b);
            var c;
            (c = 0 <= b) && Oa(a, b);
            return c;
        }
        function Oa(a, b) {
            return 1 == Array.prototype.splice.call(a, b, 1).length;
        }
        function Pa(a, b) {
            a: {
                for(var c = a.length, d = q(a) ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
                    b = e;
                    break a;
                }
                b = -1;
            }
            0 <= b && Oa(a, b);
        }
        function Qa(a, b) {
            var c = 0;
            Ia(a, function(d, e) {
                b.call(void 0, d, e, a) && Oa(a, e) && c++;
            });
        }
        function Ra(a) {
            return Array.prototype.concat.apply([], arguments);
        }
        function Sa(a) {
            var b = a.length;
            if (0 < b) {
                for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
                return c;
            }
            return [];
        }
        function Ta(a, b, c) {
            return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
        }
        var Ua = String.prototype.trim ? function(a) {
            return a.trim();
        } : function(a) {
            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
        }, Va = /&/g, Wa = /</g, Xa = />/g, Ya = /"/g, Za = /'/g, $a = /\x00/g, ab = /[\x00&<>"']/;
        function bb(a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        }
        function cb(a) {
            ab.test(a) && (-1 != a.indexOf("&") && (a = a.replace(Va, "&amp;")), -1 != a.indexOf("<") && (a = a.replace(Wa, "&lt;")), -1 != a.indexOf(">") && (a = a.replace(Xa, "&gt;")), -1 != a.indexOf('"') && (a = a.replace(Ya, "&quot;")), -1 != a.indexOf("'") && (a = a.replace(Za, "&#39;")), -1 != a.indexOf("\x00") && (a = a.replace($a, "&#0;")));
            return a;
        }
        function db(a, b, c) {
            for(var d in a)b.call(c, a[d], d, a);
        }
        function eb(a) {
            var b = {}, c;
            for(c in a)b[c] = a[c];
            return b;
        }
        var fb = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
        function gb(a, b) {
            for(var c, d, e = 1; e < arguments.length; e++){
                d = arguments[e];
                for(c in d)a[c] = d[c];
                for(var f = 0; f < fb.length; f++)c = fb[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
            }
        }
        var hb = "StopIteration" in n ? n.StopIteration : {
            message: "StopIteration",
            stack: ""
        };
        function ib() {}
        ib.prototype.next = function() {
            throw hb;
        };
        ib.prototype.ha = function() {
            return this;
        };
        function jb(a) {
            if (a instanceof ib) return a;
            if ("function" == typeof a.ha) return a.ha(!1);
            if (ra(a)) {
                var b = 0, c = new ib;
                c.next = function() {
                    for(;;){
                        if (b >= a.length) throw hb;
                        if (b in a) return a[b++];
                        b++;
                    }
                };
                return c;
            }
            throw Error("Not implemented");
        }
        function kb(a, b) {
            if (ra(a)) try {
                Ha(a, b, void 0);
            } catch (c) {
                if (c !== hb) throw c;
            }
            else {
                a = jb(a);
                try {
                    for(;;)b.call(void 0, a.next(), void 0, a);
                } catch (c$0) {
                    if (c$0 !== hb) throw c$0;
                }
            }
        }
        function lb(a) {
            if (ra(a)) return Sa(a);
            a = jb(a);
            var b = [];
            kb(a, function(c) {
                b.push(c);
            });
            return b;
        }
        function mb(a, b) {
            this.g = {};
            this.a = [];
            this.j = this.h = 0;
            var c = arguments.length;
            if (1 < c) {
                if (c % 2) throw Error("Uneven number of arguments");
                for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
            } else if (a) {
                if (a instanceof mb) for(c = a.ja(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
                else for(d in a)this.set(d, a[d]);
            }
        }
        l = mb.prototype;
        l.la = function() {
            nb(this);
            for(var a = [], b = 0; b < this.a.length; b++)a.push(this.g[this.a[b]]);
            return a;
        };
        l.ja = function() {
            nb(this);
            return this.a.concat();
        };
        l.clear = function() {
            this.g = {};
            this.j = this.h = this.a.length = 0;
        };
        function nb(a) {
            if (a.h != a.a.length) {
                for(var b = 0, c = 0; b < a.a.length;){
                    var d = a.a[b];
                    ob(a.g, d) && (a.a[c++] = d);
                    b++;
                }
                a.a.length = c;
            }
            if (a.h != a.a.length) {
                var e = {};
                for(c = b = 0; b < a.a.length;)d = a.a[b], ob(e, d) || (a.a[c++] = d, e[d] = 1), b++;
                a.a.length = c;
            }
        }
        l.get = function(a, b) {
            return ob(this.g, a) ? this.g[a] : b;
        };
        l.set = function(a, b) {
            ob(this.g, a) || (this.h++, this.a.push(a), this.j++);
            this.g[a] = b;
        };
        l.forEach = function(a, b) {
            for(var c = this.ja(), d = 0; d < c.length; d++){
                var e = c[d], f = this.get(e);
                a.call(b, f, e, this);
            }
        };
        l.ha = function(a) {
            nb(this);
            var b = 0, c = this.j, d = this, e = new ib;
            e.next = function() {
                if (c != d.j) throw Error("The map has changed since the iterator was created");
                if (b >= d.a.length) throw hb;
                var f = d.a[b++];
                return a ? f : d.g[f];
            };
            return e;
        };
        function ob(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }
        var pb = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
        function qb(a, b) {
            if (a) {
                a = a.split("&");
                for(var c = 0; c < a.length; c++){
                    var d = a[c].indexOf("="), e = null;
                    if (0 <= d) {
                        var f = a[c].substring(0, d);
                        e = a[c].substring(d + 1);
                    } else f = a[c];
                    b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
                }
            }
        }
        function rb(a, b, c, d) {
            for(var e = c.length; 0 <= (b = a.indexOf(c, b)) && b < d;){
                var f = a.charCodeAt(b - 1);
                if (38 == f || 63 == f) {
                    if (f = a.charCodeAt(b + e), !f || 61 == f || 38 == f || 35 == f) return b;
                }
                b += e + 1;
            }
            return -1;
        }
        var sb = /#|$/;
        function tb(a, b) {
            var c = a.search(sb), d = rb(a, 0, b, c);
            if (0 > d) return null;
            var e = a.indexOf("&", d);
            if (0 > e || e > c) e = c;
            d += b.length + 1;
            return decodeURIComponent(a.substr(d, e - d).replace(/\+/g, " "));
        }
        var ub = /[?&]($|#)/;
        function vb(a, b) {
            this.h = this.A = this.j = "";
            this.C = null;
            this.s = this.g = "";
            this.i = !1;
            var c;
            a instanceof vb ? (this.i = ka(b) ? b : a.i, wb(this, a.j), this.A = a.A, this.h = a.h, xb(this, a.C), this.g = a.g, yb(this, zb(a.a)), this.s = a.s) : a && (c = String(a).match(pb)) ? (this.i = !!b, wb(this, c[1] || "", !0), this.A = Ab(c[2] || ""), this.h = Ab(c[3] || "", !0), xb(this, c[4]), this.g = Ab(c[5] || "", !0), yb(this, c[6] || "", !0), this.s = Ab(c[7] || "")) : (this.i = !!b, this.a = new Bb(null, this.i));
        }
        vb.prototype.toString = function() {
            var a = [], b = this.j;
            b && a.push(Cb(b, Db, !0), ":");
            var c = this.h;
            if (c || "file" == b) a.push("//"), (b = this.A) && a.push(Cb(b, Db, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.C, null != c && a.push(":", String(c));
            if (c = this.g) this.h && "/" != c.charAt(0) && a.push("/"), a.push(Cb(c, "/" == c.charAt(0) ? Eb : Fb, !0));
            (c = this.a.toString()) && a.push("?", c);
            (c = this.s) && a.push("#", Cb(c, Gb));
            return a.join("");
        };
        function wb(a, b, c) {
            a.j = c ? Ab(b, !0) : b;
            a.j && (a.j = a.j.replace(/:$/, ""));
        }
        function xb(a, b) {
            if (b) {
                b = Number(b);
                if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
                a.C = b;
            } else a.C = null;
        }
        function yb(a, b, c) {
            b instanceof Bb ? (a.a = b, Hb(a.a, a.i)) : (c || (b = Cb(b, Ib)), a.a = new Bb(b, a.i));
        }
        function Jb(a) {
            return a instanceof vb ? new vb(a) : new vb(a, void 0);
        }
        function Ab(a, b) {
            return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
        }
        function Cb(a, b, c) {
            return q(a) ? (a = encodeURI(a).replace(b, Kb), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
        }
        function Kb(a) {
            a = a.charCodeAt(0);
            return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
        }
        var Db = /[#\/\?@]/g, Fb = /[#\?:]/g, Eb = /[#\?]/g, Ib = /[#\?@]/g, Gb = /#/g;
        function Bb(a, b) {
            this.g = this.a = null;
            this.h = a || null;
            this.j = !!b;
        }
        function Lb(a) {
            a.a || (a.a = new mb, a.g = 0, a.h && qb(a.h, function(b, c) {
                a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
            }));
        }
        l = Bb.prototype;
        l.add = function(a, b) {
            Lb(this);
            this.h = null;
            a = Mb(this, a);
            var c = this.a.get(a);
            c || this.a.set(a, c = []);
            c.push(b);
            this.g += 1;
            return this;
        };
        function Nb(a, b) {
            Lb(a);
            b = Mb(a, b);
            ob(a.a.g, b) && (a.h = null, a.g -= a.a.get(b).length, a = a.a, ob(a.g, b) && (delete a.g[b], a.h--, a.j++, a.a.length > 2 * a.h && nb(a)));
        }
        l.clear = function() {
            this.a = this.h = null;
            this.g = 0;
        };
        function Ob(a, b) {
            Lb(a);
            b = Mb(a, b);
            return ob(a.a.g, b);
        }
        l.forEach = function(a, b) {
            Lb(this);
            this.a.forEach(function(c, d) {
                Ha(c, function(e) {
                    a.call(b, e, d, this);
                }, this);
            }, this);
        };
        l.ja = function() {
            Lb(this);
            for(var a = this.a.la(), b = this.a.ja(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
            return c;
        };
        l.la = function(a) {
            Lb(this);
            var b = [];
            if (q(a)) Ob(this, a) && (b = Ra(b, this.a.get(Mb(this, a))));
            else {
                a = this.a.la();
                for(var c = 0; c < a.length; c++)b = Ra(b, a[c]);
            }
            return b;
        };
        l.set = function(a, b) {
            Lb(this);
            this.h = null;
            a = Mb(this, a);
            Ob(this, a) && (this.g -= this.a.get(a).length);
            this.a.set(a, [
                b
            ]);
            this.g += 1;
            return this;
        };
        l.get = function(a, b) {
            if (!a) return b;
            a = this.la(a);
            return 0 < a.length ? String(a[0]) : b;
        };
        l.toString = function() {
            if (this.h) return this.h;
            if (!this.a) return "";
            for(var a = [], b = this.a.ja(), c = 0; c < b.length; c++){
                var d = b[c], e = encodeURIComponent(String(d));
                d = this.la(d);
                for(var f = 0; f < d.length; f++){
                    var g = e;
                    "" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));
                    a.push(g);
                }
            }
            return this.h = a.join("&");
        };
        function zb(a) {
            var b = new Bb;
            b.h = a.h;
            a.a && (b.a = new mb(a.a), b.g = a.g);
            return b;
        }
        function Mb(a, b) {
            b = String(b);
            a.j && (b = b.toLowerCase());
            return b;
        }
        function Hb(a, b) {
            b && !a.j && (Lb(a), a.h = null, a.a.forEach(function(c, d) {
                var e = d.toLowerCase();
                d != e && (Nb(this, d), Nb(this, e), 0 < c.length && (this.h = null, this.a.set(Mb(this, e), Sa(c)), this.g += c.length));
            }, a));
            a.j = b;
        }
        function Pb(a) {
            this.a = Jb(a);
        }
        function Qb(a, b) {
            b ? a.a.a.set(x.Sa, b) : Nb(a.a.a, x.Sa);
        }
        function Rb(a, b) {
            null !== b ? a.a.a.set(x.Qa, b ? "1" : "0") : Nb(a.a.a, x.Qa);
        }
        function Sb(a) {
            return a.a.a.get(x.Pa) || null;
        }
        function Tb(a, b) {
            b ? a.a.a.set(x.PROVIDER_ID, b) : Nb(a.a.a, x.PROVIDER_ID);
        }
        Pb.prototype.toString = function() {
            return this.a.toString();
        };
        var x = {
            Pa: "ui_auid",
            mc: "apiKey",
            Qa: "ui_sd",
            ub: "mode",
            $a: "oobCode",
            PROVIDER_ID: "ui_pid",
            Sa: "ui_sid",
            vb: "tenantId"
        };
        var Ub;
        a: {
            var Vb = n.navigator;
            if (Vb) {
                var Wb = Vb.userAgent;
                if (Wb) {
                    Ub = Wb;
                    break a;
                }
            }
            Ub = "";
        }
        function y(a) {
            return -1 != Ub.indexOf(a);
        }
        function Xb() {
            return (y("Chrome") || y("CriOS")) && !y("Edge");
        }
        function Yb(a) {
            Yb[" "](a);
            return a;
        }
        Yb[" "] = na;
        function Zb(a, b) {
            var c = $b;
            return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
        }
        var ac = y("Opera"), z = y("Trident") || y("MSIE"), bc = y("Edge"), cc = bc || z, dc = y("Gecko") && !(-1 != Ub.toLowerCase().indexOf("webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"), ec = -1 != Ub.toLowerCase().indexOf("webkit") && !y("Edge"), fc = ec && y("Mobile"), gc = y("Macintosh");
        function hc() {
            var a = n.document;
            return a ? a.documentMode : void 0;
        }
        var ic;
        a: {
            var jc = "", kc = function() {
                var a = Ub;
                if (dc) return /rv:([^\);]+)(\)|;)/.exec(a);
                if (bc) return /Edge\/([\d\.]+)/.exec(a);
                if (z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
                if (ec) return /WebKit\/(\S+)/.exec(a);
                if (ac) return /(?:Version)[ \/]?(\S+)/.exec(a);
            }();
            kc && (jc = kc ? kc[1] : "");
            if (z) {
                var lc = hc();
                if (null != lc && lc > parseFloat(jc)) {
                    ic = String(lc);
                    break a;
                }
            }
            ic = jc;
        }
        var $b = {};
        function mc(a) {
            return Zb(a, function() {
                for(var b = 0, c = Ua(String(ic)).split("."), d = Ua(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++){
                    var g = c[f] || "", h = d[f] || "";
                    do {
                        g = /(\d*)(\D*)(.*)/.exec(g) || [
                            "",
                            "",
                            "",
                            ""
                        ];
                        h = /(\d*)(\D*)(.*)/.exec(h) || [
                            "",
                            "",
                            "",
                            ""
                        ];
                        if (0 == g[0].length && 0 == h[0].length) break;
                        b = bb(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || bb(0 == g[2].length, 0 == h[2].length) || bb(g[2], h[2]);
                        g = g[3];
                        h = h[3];
                    }while (0 == b);
                }
                return 0 <= b;
            });
        }
        var nc;
        var oc = n.document;
        nc = oc && z ? hc() || ("CSS1Compat" == oc.compatMode ? parseInt(ic, 10) : 5) : void 0;
        function pc(a, b) {
            this.a = a === qc && b || "";
            this.g = rc;
        }
        pc.prototype.ma = !0;
        pc.prototype.ka = function() {
            return this.a;
        };
        pc.prototype.toString = function() {
            return "Const{" + this.a + "}";
        };
        var rc = {}, qc = {};
        function sc() {
            this.a = "";
            this.h = tc;
        }
        sc.prototype.ma = !0;
        sc.prototype.ka = function() {
            return this.a.toString();
        };
        sc.prototype.g = function() {
            return 1;
        };
        sc.prototype.toString = function() {
            return "TrustedResourceUrl{" + this.a + "}";
        };
        function uc(a) {
            if (a instanceof sc && a.constructor === sc && a.h === tc) return a.a;
            Fa("expected object of type TrustedResourceUrl, got '" + a + "' of type " + pa(a));
            return "type_error:TrustedResourceUrl";
        }
        function vc() {
            var a = wc;
            a instanceof pc && a.constructor === pc && a.g === rc ? a = a.a : (Fa("expected object of type Const, got '" + a + "'"), a = "type_error:Const");
            var b = new sc;
            b.a = a;
            return b;
        }
        var tc = {};
        function xc() {
            this.a = "";
            this.h = yc;
        }
        xc.prototype.ma = !0;
        xc.prototype.ka = function() {
            return this.a.toString();
        };
        xc.prototype.g = function() {
            return 1;
        };
        xc.prototype.toString = function() {
            return "SafeUrl{" + this.a + "}";
        };
        function zc(a) {
            if (a instanceof xc && a.constructor === xc && a.h === yc) return a.a;
            Fa("expected object of type SafeUrl, got '" + a + "' of type " + pa(a));
            return "type_error:SafeUrl";
        }
        var Ac = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
        function Bc(a) {
            if (a instanceof xc) return a;
            a = "object" == typeof a && a.ma ? a.ka() : String(a);
            Ac.test(a) || (a = "about:invalid#zClosurez");
            return Cc(a);
        }
        function Dc(a) {
            if (a instanceof xc) return a;
            a = "object" == typeof a && a.ma ? a.ka() : String(a);
            Ac.test(a) || (a = "about:invalid#zClosurez");
            return Cc(a);
        }
        var yc = {};
        function Cc(a) {
            var b = new xc;
            b.a = a;
            return b;
        }
        Cc("about:blank");
        function Ec() {
            this.a = "";
            this.g = Fc;
        }
        Ec.prototype.ma = !0;
        var Fc = {};
        Ec.prototype.ka = function() {
            return this.a;
        };
        Ec.prototype.toString = function() {
            return "SafeStyle{" + this.a + "}";
        };
        function Gc() {
            this.a = "";
            this.j = Hc;
            this.h = null;
        }
        Gc.prototype.g = function() {
            return this.h;
        };
        Gc.prototype.ma = !0;
        Gc.prototype.ka = function() {
            return this.a.toString();
        };
        Gc.prototype.toString = function() {
            return "SafeHtml{" + this.a + "}";
        };
        function Ic(a) {
            if (a instanceof Gc && a.constructor === Gc && a.j === Hc) return a.a;
            Fa("expected object of type SafeHtml, got '" + a + "' of type " + pa(a));
            return "type_error:SafeHtml";
        }
        var Hc = {};
        function Jc(a, b) {
            var c = new Gc;
            c.a = a;
            c.h = b;
            return c;
        }
        Jc("<!DOCTYPE html>", 0);
        var Kc = Jc("", 0);
        Jc("<br>", 0);
        var Lc = function(a) {
            var b = !1, c;
            return function() {
                b || (c = a(), b = !0);
                return c;
            };
        }(function() {
            if ("undefined" === typeof document) return !1;
            var a = document.createElement("div"), b = document.createElement("div");
            b.appendChild(document.createElement("div"));
            a.appendChild(b);
            if (!a.firstChild) return !1;
            b = a.firstChild.firstChild;
            a.innerHTML = Ic(Kc);
            return !b.parentElement;
        });
        function Mc(a, b) {
            a.src = uc(b);
            if (null === ma) b: {
                b = n.document;
                if ((b = b.querySelector && b.querySelector("script[nonce]")) && (b = b.nonce || b.getAttribute("nonce")) && la.test(b)) {
                    ma = b;
                    break b;
                }
                ma = "";
            }
            b = ma;
            b && a.setAttribute("nonce", b);
        }
        function Nc(a, b) {
            b = b instanceof xc ? b : Dc(b);
            a.assign(zc(b));
        }
        function Oc(a, b) {
            this.a = ka(a) ? a : 0;
            this.g = ka(b) ? b : 0;
        }
        Oc.prototype.toString = function() {
            return "(" + this.a + ", " + this.g + ")";
        };
        Oc.prototype.ceil = function() {
            this.a = Math.ceil(this.a);
            this.g = Math.ceil(this.g);
            return this;
        };
        Oc.prototype.floor = function() {
            this.a = Math.floor(this.a);
            this.g = Math.floor(this.g);
            return this;
        };
        Oc.prototype.round = function() {
            this.a = Math.round(this.a);
            this.g = Math.round(this.g);
            return this;
        };
        function Pc(a, b) {
            this.width = a;
            this.height = b;
        }
        l = Pc.prototype;
        l.toString = function() {
            return "(" + this.width + " x " + this.height + ")";
        };
        l.aspectRatio = function() {
            return this.width / this.height;
        };
        l.ceil = function() {
            this.width = Math.ceil(this.width);
            this.height = Math.ceil(this.height);
            return this;
        };
        l.floor = function() {
            this.width = Math.floor(this.width);
            this.height = Math.floor(this.height);
            return this;
        };
        l.round = function() {
            this.width = Math.round(this.width);
            this.height = Math.round(this.height);
            return this;
        };
        function Qc(a) {
            return a ? new Rc(Sc(a)) : Da || (Da = new Rc);
        }
        function Tc(a, b) {
            var c = b || document;
            return c.querySelectorAll && c.querySelector ? c.querySelectorAll("." + a) : Uc(document, a, b);
        }
        function Vc(a, b) {
            var c = b || document;
            if (c.getElementsByClassName) a = c.getElementsByClassName(a)[0];
            else {
                c = document;
                var d = b || c;
                a = d.querySelectorAll && d.querySelector && a ? d.querySelector(a ? "." + a : "") : Uc(c, a, b)[0] || null;
            }
            return a || null;
        }
        function Uc(a, b, c) {
            var d;
            a = c || a;
            if (a.querySelectorAll && a.querySelector && b) return a.querySelectorAll(b ? "." + b : "");
            if (b && a.getElementsByClassName) {
                var e = a.getElementsByClassName(b);
                return e;
            }
            e = a.getElementsByTagName("*");
            if (b) {
                var f = {};
                for(c = d = 0; a = e[c]; c++){
                    var g = a.className;
                    "function" == typeof g.split && Ma(g.split(/\s+/), b) && (f[d++] = a);
                }
                f.length = d;
                return f;
            }
            return e;
        }
        function Wc(a, b) {
            db(b, function(c, d) {
                c && "object" == typeof c && c.ma && (c = c.ka());
                "style" == d ? a.style.cssText = c : "class" == d ? a.className = c : "for" == d ? a.htmlFor = c : Xc.hasOwnProperty(d) ? a.setAttribute(Xc[d], c) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, c) : a[d] = c;
            });
        }
        var Xc = {
            cellpadding: "cellPadding",
            cellspacing: "cellSpacing",
            colspan: "colSpan",
            frameborder: "frameBorder",
            height: "height",
            maxlength: "maxLength",
            nonce: "nonce",
            role: "role",
            rowspan: "rowSpan",
            type: "type",
            usemap: "useMap",
            valign: "vAlign",
            width: "width"
        };
        function Yc(a) {
            return a.scrollingElement ? a.scrollingElement : ec || "CSS1Compat" != a.compatMode ? a.body || a.documentElement : a.documentElement;
        }
        function Zc(a) {
            a && a.parentNode && a.parentNode.removeChild(a);
        }
        function Sc(a) {
            return 9 == a.nodeType ? a : a.ownerDocument || a.document;
        }
        function $c(a, b) {
            if ("textContent" in a) a.textContent = b;
            else if (3 == a.nodeType) a.data = String(b);
            else if (a.firstChild && 3 == a.firstChild.nodeType) {
                for(; a.lastChild != a.firstChild;)a.removeChild(a.lastChild);
                a.firstChild.data = String(b);
            } else {
                for(var c; c = a.firstChild;)a.removeChild(c);
                a.appendChild(Sc(a).createTextNode(String(b)));
            }
        }
        function ad(a, b) {
            return b ? bd(a, function(c) {
                return !b || q(c.className) && Ma(c.className.split(/\s+/), b);
            }) : null;
        }
        function bd(a, b) {
            for(var c = 0; a;){
                if (b(a)) return a;
                a = a.parentNode;
                c++;
            }
            return null;
        }
        function Rc(a) {
            this.a = a || n.document || document;
        }
        Rc.prototype.N = function() {
            return q(void 0) ? this.a.getElementById(void 0) : void 0;
        };
        var cd = {
            Gc: !0
        }, dd = {
            Ic: !0
        }, ed = {
            Fc: !0
        }, fd = {
            Hc: !0
        };
        function gd() {
            throw Error("Do not instantiate directly");
        }
        gd.prototype.va = null;
        gd.prototype.toString = function() {
            return this.content;
        };
        function hd(a, b, c, d) {
            a = a(b || id, void 0, c);
            d = (d || Qc()).a.createElement("DIV");
            a = jd(a);
            a.match(kd);
            a = Jc(a, null);
            if (Lc()) for(; d.lastChild;)d.removeChild(d.lastChild);
            d.innerHTML = Ic(a);
            1 == d.childNodes.length && (a = d.firstChild, 1 == a.nodeType && (d = a));
            return d;
        }
        function jd(a) {
            if (!ta(a)) return cb(String(a));
            if (a instanceof gd) {
                if (a.fa === cd) return a.content;
                if (a.fa === fd) return cb(a.content);
            }
            Fa("Soy template output is unsafe for use as HTML: " + a);
            return "zSoyz";
        }
        var kd = /^<(body|caption|col|colgroup|head|html|tr|td|th|tbody|thead|tfoot)>/i, id = {};
        function ld(a) {
            if (null != a) switch(a.va){
                case 1:
                    return 1;
                case -1:
                    return -1;
                case 0:
                    return 0;
            }
            return null;
        }
        function od() {
            gd.call(this);
        }
        w(od, gd);
        od.prototype.fa = cd;
        function A(a) {
            return null != a && a.fa === cd ? a : a instanceof Gc ? B(Ic(a).toString(), a.g()) : B(cb(String(String(a))), ld(a));
        }
        function pd() {
            gd.call(this);
        }
        w(pd, gd);
        pd.prototype.fa = dd;
        pd.prototype.va = 1;
        function qd(a, b) {
            this.content = String(a);
            this.va = null != b ? b : null;
        }
        w(qd, gd);
        qd.prototype.fa = fd;
        function C(a) {
            return new qd(a, void 0);
        }
        var B = function(a) {
            function b(c) {
                this.content = c;
            }
            b.prototype = a.prototype;
            return function(c, d) {
                c = new b(String(c));
                void 0 !== d && (c.va = d);
                return c;
            };
        }(od), rd = function(a) {
            function b(c) {
                this.content = c;
            }
            b.prototype = a.prototype;
            return function(c) {
                return new b(String(c));
            };
        }(pd);
        function sd(a) {
            function b() {}
            var c = {
                label: D("New password")
            };
            b.prototype = a;
            a = new b;
            for(var d in c)a[d] = c[d];
            return a;
        }
        function D(a) {
            return (a = String(a)) ? new qd(a, void 0) : "";
        }
        var td = function(a) {
            function b(c) {
                this.content = c;
            }
            b.prototype = a.prototype;
            return function(c, d) {
                c = String(c);
                if (!c) return "";
                c = new b(c);
                void 0 !== d && (c.va = d);
                return c;
            };
        }(od);
        function ud(a) {
            return null != a && a.fa === cd ? String(String(a.content).replace(vd, "").replace(wd, "&lt;")).replace(xd, yd) : cb(String(a));
        }
        function zd(a) {
            null != a && a.fa === dd ? a = String(a).replace(Ad, Bd) : a instanceof xc ? a = String(zc(a).toString()).replace(Ad, Bd) : (a = String(a), Cd.test(a) ? a = a.replace(Ad, Bd) : (Fa("Bad value `%s` for |filterNormalizeUri", [
                a
            ]), a = "#zSoyz"));
            return a;
        }
        function Dd(a) {
            null != a && a.fa === ed ? a = a.content : null == a ? a = "" : a instanceof Ec ? a instanceof Ec && a.constructor === Ec && a.g === Fc ? a = a.a : (Fa("expected object of type SafeStyle, got '" + a + "' of type " + pa(a)), a = "type_error:SafeStyle") : (a = String(a), Ed.test(a) || (Fa("Bad value `%s` for |filterCssValue", [
                a
            ]), a = "zSoyz"));
            return a;
        }
        var Fd = {
            "\x00": "&#0;",
            "	": "&#9;",
            "\n": "&#10;",
            "\v": "&#11;",
            "\f": "&#12;",
            "\r": "&#13;",
            " ": "&#32;",
            '"': "&quot;",
            "&": "&amp;",
            "'": "&#39;",
            "-": "&#45;",
            "/": "&#47;",
            "<": "&lt;",
            "=": "&#61;",
            ">": "&gt;",
            "`": "&#96;",
            "\x85": "&#133;",
            "\xa0": "&#160;",
            "\u2028": "&#8232;",
            "\u2029": "&#8233;"
        };
        function yd(a) {
            return Fd[a];
        }
        var Gd = {
            "\x00": "%00",
            "\x01": "%01",
            "\x02": "%02",
            "\x03": "%03",
            "\x04": "%04",
            "\x05": "%05",
            "\x06": "%06",
            "\x07": "%07",
            "\b": "%08",
            "	": "%09",
            "\n": "%0A",
            "\v": "%0B",
            "\f": "%0C",
            "\r": "%0D",
            "\x0e": "%0E",
            "\x0f": "%0F",
            "\x10": "%10",
            "\x11": "%11",
            "\x12": "%12",
            "\x13": "%13",
            "\x14": "%14",
            "\x15": "%15",
            "\x16": "%16",
            "\x17": "%17",
            "\x18": "%18",
            "\x19": "%19",
            "\x1a": "%1A",
            "\x1b": "%1B",
            "\x1c": "%1C",
            "\x1d": "%1D",
            "\x1e": "%1E",
            "\x1f": "%1F",
            " ": "%20",
            '"': "%22",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "<": "%3C",
            ">": "%3E",
            "\\": "%5C",
            "{": "%7B",
            "}": "%7D",
            "\x7f": "%7F",
            "\x85": "%C2%85",
            "\xa0": "%C2%A0",
            "\u2028": "%E2%80%A8",
            "\u2029": "%E2%80%A9",
            "！": "%EF%BC%81",
            "＃": "%EF%BC%83",
            "＄": "%EF%BC%84",
            "＆": "%EF%BC%86",
            "＇": "%EF%BC%87",
            "（": "%EF%BC%88",
            "）": "%EF%BC%89",
            "＊": "%EF%BC%8A",
            "＋": "%EF%BC%8B",
            "，": "%EF%BC%8C",
            "／": "%EF%BC%8F",
            "：": "%EF%BC%9A",
            "；": "%EF%BC%9B",
            "＝": "%EF%BC%9D",
            "？": "%EF%BC%9F",
            "＠": "%EF%BC%A0",
            "［": "%EF%BC%BB",
            "］": "%EF%BC%BD"
        };
        function Bd(a) {
            return Gd[a];
        }
        var xd = /[\x00\x22\x27\x3c\x3e]/g, Ad = /[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g, Ed = /^(?!-*(?:expression|(?:moz-)?binding))(?:[.#]?-?(?:[_a-z0-9-]+)(?:-[_a-z0-9-]+)*-?|-?(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)(?:[a-z]{1,2}|%)?|!important|)$/i, Cd = /^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i, vd = /<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g, wd = /</g;
        function Hd() {
            return C("Enter a valid phone number");
        }
        function Id() {
            return C("Unable to send password reset code to specified email");
        }
        function Jd() {
            return C("Something went wrong. Please try again.");
        }
        function Kd() {
            return C("This email already exists without any means of sign-in. Please reset the password to recover.");
        }
        function Ld(a) {
            a = a || {};
            var b = "";
            switch(a.code){
                case "invalid-argument":
                    b += "Client specified an invalid argument.";
                    break;
                case "invalid-configuration":
                    b += "Client specified an invalid project configuration.";
                    break;
                case "failed-precondition":
                    b += "Request can not be executed in the current system state.";
                    break;
                case "out-of-range":
                    b += "Client specified an invalid range.";
                    break;
                case "unauthenticated":
                    b += "Request not authenticated due to missing, invalid, or expired OAuth token.";
                    break;
                case "permission-denied":
                    b += "Client does not have sufficient permission.";
                    break;
                case "not-found":
                    b += "Specified resource is not found.";
                    break;
                case "aborted":
                    b += "Concurrency conflict, such as read-modify-write conflict.";
                    break;
                case "already-exists":
                    b += "The resource that a client tried to create already exists.";
                    break;
                case "resource-exhausted":
                    b += "Either out of resource quota or reaching rate limiting.";
                    break;
                case "cancelled":
                    b += "Request cancelled by the client.";
                    break;
                case "data-loss":
                    b += "Unrecoverable data loss or data corruption.";
                    break;
                case "unknown":
                    b += "Unknown server error.";
                    break;
                case "internal":
                    b += "Internal server error.";
                    break;
                case "not-implemented":
                    b += "API method not implemented by the server.";
                    break;
                case "unavailable":
                    b += "Service unavailable.";
                    break;
                case "deadline-exceeded":
                    b += "Request deadline exceeded.";
                    break;
                case "auth/user-disabled":
                    b += "The user account has been disabled by an administrator.";
                    break;
                case "auth/timeout":
                    b += "The operation has timed out.";
                    break;
                case "auth/too-many-requests":
                    b += "We have blocked all requests from this device due to unusual activity. Try again later.";
                    break;
                case "auth/quota-exceeded":
                    b += "The quota for this operation has been exceeded. Try again later.";
                    break;
                case "auth/network-request-failed":
                    b += "A network error has occurred. Try again later.";
                    break;
                case "restart-process":
                    b += "An issue was encountered when authenticating your request. Please visit the URL that redirected you to this page again to restart the authentication process.";
                    break;
                case "no-matching-tenant-for-email":
                    b += "No sign-in provider is available for the given email, please try with a different email.";
            }
            return C(b);
        }
        function Md() {
            return C("Please login again to perform this operation");
        }
        function Nd(a, b, c) {
            var d = Error.call(this);
            this.message = d.message;
            "stack" in d && (this.stack = d.stack);
            this.code = Od + a;
            if (!(a = b)) {
                a = "";
                switch(this.code){
                    case "firebaseui/merge-conflict":
                        a += "The current anonymous user failed to upgrade. The non-anonymous credential is already associated with a different user account.";
                        break;
                    default:
                        a += Jd();
                }
                a = C(a).toString();
            }
            this.message = a || "";
            this.credential = c || null;
        }
        m(Nd, Error);
        Nd.prototype.toJSON = function() {
            return {
                code: this.code,
                message: this.message
            };
        };
        var Od = "firebaseui/";
        function Pd() {
            0 != Qd && (Rd[this[ua] || (this[ua] = ++va)] = this);
            this.T = this.T;
            this.C = this.C;
        }
        var Qd = 0, Rd = {};
        Pd.prototype.T = !1;
        Pd.prototype.m = function() {
            if (!this.T && (this.T = !0, this.o(), 0 != Qd)) {
                var a = this[ua] || (this[ua] = ++va);
                if (0 != Qd && this.C && 0 < this.C.length) throw Error(this + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
                delete Rd[a];
            }
        };
        function Sd(a, b) {
            a.T ? ka(void 0) ? b.call(void 0) : b() : (a.C || (a.C = []), a.C.push(ka(void 0) ? r(b, void 0) : b));
        }
        Pd.prototype.o = function() {
            if (this.C) for(; this.C.length;)this.C.shift()();
        };
        function Td(a) {
            a && "function" == typeof a.m && a.m();
        }
        var Ud = Object.freeze || function(a) {
            return a;
        };
        var Vd = !z || 9 <= Number(nc), Wd = z && !mc("9"), Xd = function() {
            if (!n.addEventListener || !Object.defineProperty) return !1;
            var a = !1, b = Object.defineProperty({}, "passive", {
                get: function() {
                    a = !0;
                }
            });
            try {
                n.addEventListener("test", na, b), n.removeEventListener("test", na, b);
            } catch (c) {}
            return a;
        }();
        function Yd(a, b) {
            this.type = a;
            this.g = this.target = b;
            this.h = !1;
            this.qb = !0;
        }
        Yd.prototype.stopPropagation = function() {
            this.h = !0;
        };
        Yd.prototype.preventDefault = function() {
            this.qb = !1;
        };
        function Zd(a, b) {
            Yd.call(this, a ? a.type : "");
            this.relatedTarget = this.g = this.target = null;
            this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
            this.key = "";
            this.j = this.keyCode = 0;
            this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
            this.pointerId = 0;
            this.pointerType = "";
            this.a = null;
            if (a) {
                var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
                this.target = a.target || a.srcElement;
                this.g = b;
                if (b = a.relatedTarget) {
                    if (dc) {
                        a: {
                            try {
                                Yb(b.nodeName);
                                var e = !0;
                                break a;
                            } catch (f) {}
                            e = !1;
                        }
                        e || (b = null);
                    }
                } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
                this.relatedTarget = b;
                d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
                this.button = a.button;
                this.keyCode = a.keyCode || 0;
                this.key = a.key || "";
                this.j = a.charCode || ("keypress" == c ? a.keyCode : 0);
                this.ctrlKey = a.ctrlKey;
                this.altKey = a.altKey;
                this.shiftKey = a.shiftKey;
                this.metaKey = a.metaKey;
                this.pointerId = a.pointerId || 0;
                this.pointerType = q(a.pointerType) ? a.pointerType : $d[a.pointerType] || "";
                this.a = a;
                a.defaultPrevented && this.preventDefault();
            }
        }
        w(Zd, Yd);
        var $d = Ud({
            2: "touch",
            3: "pen",
            4: "mouse"
        });
        Zd.prototype.stopPropagation = function() {
            Zd.K.stopPropagation.call(this);
            this.a.stopPropagation ? this.a.stopPropagation() : this.a.cancelBubble = !0;
        };
        Zd.prototype.preventDefault = function() {
            Zd.K.preventDefault.call(this);
            var a = this.a;
            if (a.preventDefault) a.preventDefault();
            else if (a.returnValue = !1, Wd) try {
                if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
            } catch (b) {}
        };
        var ae = "closure_listenable_" + (1E6 * Math.random() | 0), be = 0;
        function ce(a, b, c, d, e) {
            this.listener = a;
            this.proxy = null;
            this.src = b;
            this.type = c;
            this.capture = !!d;
            this.La = e;
            this.key = ++be;
            this.sa = this.Ia = !1;
        }
        function de(a) {
            a.sa = !0;
            a.listener = null;
            a.proxy = null;
            a.src = null;
            a.La = null;
        }
        function ee(a) {
            this.src = a;
            this.a = {};
            this.g = 0;
        }
        ee.prototype.add = function(a, b, c, d, e) {
            var f = a.toString();
            a = this.a[f];
            a || (a = this.a[f] = [], this.g++);
            var g = fe(a, b, d, e);
            -1 < g ? (b = a[g], c || (b.Ia = !1)) : (b = new ce(b, this.src, f, !!d, e), b.Ia = c, a.push(b));
            return b;
        };
        function ge(a, b) {
            var c = b.type;
            c in a.a && Na(a.a[c], b) && (de(b), 0 == a.a[c].length && (delete a.a[c], a.g--));
        }
        function fe(a, b, c, d) {
            for(var e = 0; e < a.length; ++e){
                var f = a[e];
                if (!f.sa && f.listener == b && f.capture == !!c && f.La == d) return e;
            }
            return -1;
        }
        var he = "closure_lm_" + (1E6 * Math.random() | 0), ie = {}, je = 0;
        function ke(a, b, c, d, e) {
            if (d && d.once) return le(a, b, c, d, e);
            if (qa(b)) {
                for(var f = 0; f < b.length; f++)ke(a, b[f], c, d, e);
                return null;
            }
            c = me(c);
            return a && a[ae] ? a.J.add(String(b), c, !1, ta(d) ? !!d.capture : !!d, e) : ne(a, b, c, !1, d, e);
        }
        function ne(a, b, c, d, e, f) {
            if (!b) throw Error("Invalid event type");
            var g = ta(e) ? !!e.capture : !!e, h = oe(a);
            h || (a[he] = h = new ee(a));
            c = h.add(b, c, d, g, f);
            if (c.proxy) return c;
            d = pe();
            c.proxy = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener) Xd || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
            else if (a.attachEvent) a.attachEvent(qe(b.toString()), d);
            else if (a.addListener && a.removeListener) a.addListener(d);
            else throw Error("addEventListener and attachEvent are unavailable.");
            je++;
            return c;
        }
        function pe() {
            var a = re, b = Vd ? function(c) {
                return a.call(b.src, b.listener, c);
            } : function(c) {
                c = a.call(b.src, b.listener, c);
                if (!c) return c;
            };
            return b;
        }
        function le(a, b, c, d, e) {
            if (qa(b)) {
                for(var f = 0; f < b.length; f++)le(a, b[f], c, d, e);
                return null;
            }
            c = me(c);
            return a && a[ae] ? a.J.add(String(b), c, !0, ta(d) ? !!d.capture : !!d, e) : ne(a, b, c, !0, d, e);
        }
        function se(a, b, c, d, e) {
            if (qa(b)) for(var f = 0; f < b.length; f++)se(a, b[f], c, d, e);
            else (d = ta(d) ? !!d.capture : !!d, c = me(c), a && a[ae]) ? (a = a.J, b = String(b).toString(), b in a.a && (f = a.a[b], c = fe(f, c, d, e), -1 < c && (de(f[c]), Oa(f, c), 0 == f.length && (delete a.a[b], a.g--)))) : a && (a = oe(a)) && (b = a.a[b.toString()], a = -1, b && (a = fe(b, c, d, e)), (c = -1 < a ? b[a] : null) && te(c));
        }
        function te(a) {
            if ("number" != typeof a && a && !a.sa) {
                var b = a.src;
                if (b && b[ae]) ge(b.J, a);
                else {
                    var c = a.type, d = a.proxy;
                    b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(qe(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                    je--;
                    (c = oe(b)) ? (ge(c, a), 0 == c.g && (c.src = null, b[he] = null)) : de(a);
                }
            }
        }
        function qe(a) {
            return a in ie ? ie[a] : ie[a] = "on" + a;
        }
        function ue(a, b, c, d) {
            var e = !0;
            if (a = oe(a)) {
                if (b = a.a[b.toString()]) for(b = b.concat(), a = 0; a < b.length; a++){
                    var f = b[a];
                    f && f.capture == c && !f.sa && (f = ve(f, d), e = e && !1 !== f);
                }
            }
            return e;
        }
        function ve(a, b) {
            var c = a.listener, d = a.La || a.src;
            a.Ia && te(a);
            return c.call(d, b);
        }
        function re(a, b) {
            if (a.sa) return !0;
            if (!Vd) {
                if (!b) a: {
                    b = [
                        "window",
                        "event"
                    ];
                    for(var c = n, d = 0; d < b.length; d++)if (c = c[b[d]], null == c) {
                        b = null;
                        break a;
                    }
                    b = c;
                }
                d = b;
                b = new Zd(d, this);
                c = !0;
                if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                    a: {
                        var e = !1;
                        if (0 == d.keyCode) try {
                            d.keyCode = -1;
                            break a;
                        } catch (g) {
                            e = !0;
                        }
                        if (e || void 0 == d.returnValue) d.returnValue = !0;
                    }
                    d = [];
                    for(e = b.g; e; e = e.parentNode)d.push(e);
                    a = a.type;
                    for(e = d.length - 1; !b.h && 0 <= e; e--){
                        b.g = d[e];
                        var f = ue(d[e], a, !0, b);
                        c = c && f;
                    }
                    for(e = 0; !b.h && e < d.length; e++)b.g = d[e], f = ue(d[e], a, !1, b), c = c && f;
                }
                return c;
            }
            return ve(a, new Zd(b, this));
        }
        function oe(a) {
            a = a[he];
            return a instanceof ee ? a : null;
        }
        var we = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
        function me(a) {
            if (sa(a)) return a;
            a[we] || (a[we] = function(b) {
                return a.handleEvent(b);
            });
            return a[we];
        }
        function E() {
            Pd.call(this);
            this.J = new ee(this);
            this.wb = this;
            this.Ha = null;
        }
        w(E, Pd);
        E.prototype[ae] = !0;
        E.prototype.Za = function(a) {
            this.Ha = a;
        };
        E.prototype.removeEventListener = function(a, b, c, d) {
            se(this, a, b, c, d);
        };
        function xe(a, b) {
            var c, d = a.Ha;
            if (d) for(c = []; d; d = d.Ha)c.push(d);
            a = a.wb;
            d = b.type || b;
            if (q(b)) b = new Yd(b, a);
            else if (b instanceof Yd) b.target = b.target || a;
            else {
                var e = b;
                b = new Yd(d, a);
                gb(b, e);
            }
            e = !0;
            if (c) for(var f = c.length - 1; !b.h && 0 <= f; f--){
                var g = b.g = c[f];
                e = ye(g, d, !0, b) && e;
            }
            b.h || (g = b.g = a, e = ye(g, d, !0, b) && e, b.h || (e = ye(g, d, !1, b) && e));
            if (c) for(f = 0; !b.h && f < c.length; f++)g = b.g = c[f], e = ye(g, d, !1, b) && e;
            return e;
        }
        E.prototype.o = function() {
            E.K.o.call(this);
            if (this.J) {
                var a = this.J, b = 0, c;
                for(c in a.a){
                    for(var d = a.a[c], e = 0; e < d.length; e++)++b, de(d[e]);
                    delete a.a[c];
                    a.g--;
                }
            }
            this.Ha = null;
        };
        function ye(a, b, c, d) {
            b = a.J.a[String(b)];
            if (!b) return !0;
            b = b.concat();
            for(var e = !0, f = 0; f < b.length; ++f){
                var g = b[f];
                if (g && !g.sa && g.capture == c) {
                    var h = g.listener, k = g.La || g.src;
                    g.Ia && ge(a.J, g);
                    e = !1 !== h.call(k, d) && e;
                }
            }
            return e && 0 != d.qb;
        }
        var ze = {}, Ae = 0;
        function Be(a, b) {
            if (!a) throw Error("Event target element must be provided!");
            a = Ce(a);
            if (ze[a] && ze[a].length) for(var c = 0; c < ze[a].length; c++)xe(ze[a][c], b);
        }
        function De(a) {
            var b = Ce(a.N());
            ze[b] && ze[b].length && (Pa(ze[b], function(c) {
                return c == a;
            }), ze[b].length || delete ze[b]);
        }
        function Ce(a) {
            "undefined" === typeof a.a && (a.a = Ae, Ae++);
            return a.a;
        }
        function Ee(a) {
            if (!a) throw Error("Event target element must be provided!");
            E.call(this);
            this.a = a;
        }
        m(Ee, E);
        Ee.prototype.N = function() {
            return this.a;
        };
        Ee.prototype.register = function() {
            var a = Ce(this.N());
            ze[a] ? Ma(ze[a], this) || ze[a].push(this) : ze[a] = [
                this
            ];
        };
        function Fe(a) {
            if (!a) return !1;
            try {
                return !!a.$goog_Thenable;
            } catch (b) {
                return !1;
            }
        }
        function Ge(a, b) {
            this.h = a;
            this.j = b;
            this.g = 0;
            this.a = null;
        }
        Ge.prototype.get = function() {
            if (0 < this.g) {
                this.g--;
                var a = this.a;
                this.a = a.next;
                a.next = null;
            } else a = this.h();
            return a;
        };
        function He(a, b) {
            a.j(b);
            100 > a.g && (a.g++, b.next = a.a, a.a = b);
        }
        function Ie() {
            this.g = this.a = null;
        }
        var Ke = new Ge(function() {
            return new Je;
        }, function(a) {
            a.reset();
        });
        Ie.prototype.add = function(a, b) {
            var c = Ke.get();
            c.set(a, b);
            this.g ? this.g.next = c : this.a = c;
            this.g = c;
        };
        function Le() {
            var a = Me, b = null;
            a.a && (b = a.a, a.a = a.a.next, a.a || (a.g = null), b.next = null);
            return b;
        }
        function Je() {
            this.next = this.g = this.a = null;
        }
        Je.prototype.set = function(a, b) {
            this.a = a;
            this.g = b;
            this.next = null;
        };
        Je.prototype.reset = function() {
            this.next = this.g = this.a = null;
        };
        function Ne(a) {
            n.setTimeout(function() {
                throw a;
            }, 0);
        }
        var Oe;
        function Pe() {
            var a = n.MessageChannel;
            "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function() {
                var e = document.createElement("IFRAME");
                e.style.display = "none";
                e.src = "";
                document.documentElement.appendChild(e);
                var f = e.contentWindow;
                e = f.document;
                e.open();
                e.write("");
                e.close();
                var g = "callImmediate" + Math.random(), h = "file:" == f.location.protocol ? "*" : f.location.protocol + "//" + f.location.host;
                e = r(function(k) {
                    if (("*" == h || k.origin == h) && k.data == g) this.port1.onmessage();
                }, this);
                f.addEventListener("message", e, !1);
                this.port1 = {};
                this.port2 = {
                    postMessage: function() {
                        f.postMessage(g, h);
                    }
                };
            });
            if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
                var b = new a, c = {}, d = c;
                b.port1.onmessage = function() {
                    if (ka(c.next)) {
                        c = c.next;
                        var e = c.gb;
                        c.gb = null;
                        e();
                    }
                };
                return function(e) {
                    d.next = {
                        gb: e
                    };
                    d = d.next;
                    b.port2.postMessage(0);
                };
            }
            return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function(e) {
                var f = document.createElement("SCRIPT");
                f.onreadystatechange = function() {
                    f.onreadystatechange = null;
                    f.parentNode.removeChild(f);
                    f = null;
                    e();
                    e = null;
                };
                document.documentElement.appendChild(f);
            } : function(e) {
                n.setTimeout(e, 0);
            };
        }
        function Qe(a, b) {
            Re || Se();
            Te || (Re(), Te = !0);
            Me.add(a, b);
        }
        var Re;
        function Se() {
            if (n.Promise && n.Promise.resolve) {
                var a = n.Promise.resolve(void 0);
                Re = function() {
                    a.then(Ue);
                };
            } else Re = function() {
                var b = Ue;
                !sa(n.setImmediate) || n.Window && n.Window.prototype && !y("Edge") && n.Window.prototype.setImmediate == n.setImmediate ? (Oe || (Oe = Pe()), Oe(b)) : n.setImmediate(b);
            };
        }
        var Te = !1, Me = new Ie;
        function Ue() {
            for(var a; a = Le();){
                try {
                    a.a.call(a.g);
                } catch (b) {
                    Ne(b);
                }
                He(Ke, a);
            }
            Te = !1;
        }
        function Ve(a) {
            this.a = We;
            this.A = void 0;
            this.j = this.g = this.h = null;
            this.s = this.i = !1;
            if (a != na) try {
                var b = this;
                a.call(void 0, function(c) {
                    Xe(b, Ye, c);
                }, function(c) {
                    if (!(c instanceof Ze)) try {
                        if (c instanceof Error) throw c;
                        throw Error("Promise rejected.");
                    } catch (d) {}
                    Xe(b, $e, c);
                });
            } catch (c) {
                Xe(this, $e, c);
            }
        }
        var We = 0, Ye = 2, $e = 3;
        function af() {
            this.next = this.j = this.g = this.s = this.a = null;
            this.h = !1;
        }
        af.prototype.reset = function() {
            this.j = this.g = this.s = this.a = null;
            this.h = !1;
        };
        var bf = new Ge(function() {
            return new af;
        }, function(a) {
            a.reset();
        });
        function cf(a, b, c) {
            var d = bf.get();
            d.s = a;
            d.g = b;
            d.j = c;
            return d;
        }
        function F(a) {
            if (a instanceof Ve) return a;
            var b = new Ve(na);
            Xe(b, Ye, a);
            return b;
        }
        function df(a) {
            return new Ve(function(b, c) {
                c(a);
            });
        }
        Ve.prototype.then = function(a, b, c) {
            return ef(this, sa(a) ? a : null, sa(b) ? b : null, c);
        };
        Ve.prototype.$goog_Thenable = !0;
        l = Ve.prototype;
        l.fc = function(a, b) {
            a = cf(a, a, b);
            a.h = !0;
            ff(this, a);
            return this;
        };
        l.Ca = function(a, b) {
            return ef(this, null, a, b);
        };
        l.cancel = function(a) {
            this.a == We && Qe(function() {
                var b = new Ze(a);
                gf(this, b);
            }, this);
        };
        function gf(a, b) {
            if (a.a == We) {
                if (a.h) {
                    var c = a.h;
                    if (c.g) {
                        for(var d = 0, e = null, f = null, g = c.g; g && (g.h || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next)e || (f = g);
                        e && (c.a == We && 1 == d ? gf(c, b) : (f ? (d = f, d.next == c.j && (c.j = d), d.next = d.next.next) : hf(c), jf(c, e, $e, b)));
                    }
                    a.h = null;
                } else Xe(a, $e, b);
            }
        }
        function ff(a, b) {
            a.g || a.a != Ye && a.a != $e || kf(a);
            a.j ? a.j.next = b : a.g = b;
            a.j = b;
        }
        function ef(a, b, c, d) {
            var e = cf(null, null, null);
            e.a = new Ve(function(f, g) {
                e.s = b ? function(h) {
                    try {
                        var k = b.call(d, h);
                        f(k);
                    } catch (p) {
                        g(p);
                    }
                } : f;
                e.g = c ? function(h) {
                    try {
                        var k = c.call(d, h);
                        !ka(k) && h instanceof Ze ? g(h) : f(k);
                    } catch (p) {
                        g(p);
                    }
                } : g;
            });
            e.a.h = a;
            ff(a, e);
            return e.a;
        }
        l.hc = function(a) {
            this.a = We;
            Xe(this, Ye, a);
        };
        l.ic = function(a) {
            this.a = We;
            Xe(this, $e, a);
        };
        function Xe(a, b, c) {
            if (a.a == We) {
                a === c && (b = $e, c = new TypeError("Promise cannot resolve to itself"));
                a.a = 1;
                a: {
                    var d = c, e = a.hc, f = a.ic;
                    if (d instanceof Ve) {
                        ff(d, cf(e || na, f || null, a));
                        var g = !0;
                    } else if (Fe(d)) d.then(e, f, a), g = !0;
                    else {
                        if (ta(d)) try {
                            var h = d.then;
                            if (sa(h)) {
                                lf(d, h, e, f, a);
                                g = !0;
                                break a;
                            }
                        } catch (k) {
                            f.call(a, k);
                            g = !0;
                            break a;
                        }
                        g = !1;
                    }
                }
                g || (a.A = c, a.a = b, a.h = null, kf(a), b != $e || c instanceof Ze || mf(a, c));
            }
        }
        function lf(a, b, c, d, e) {
            function f(k) {
                h || (h = !0, d.call(e, k));
            }
            function g(k) {
                h || (h = !0, c.call(e, k));
            }
            var h = !1;
            try {
                b.call(a, g, f);
            } catch (k) {
                f(k);
            }
        }
        function kf(a) {
            a.i || (a.i = !0, Qe(a.Hb, a));
        }
        function hf(a) {
            var b = null;
            a.g && (b = a.g, a.g = b.next, b.next = null);
            a.g || (a.j = null);
            return b;
        }
        l.Hb = function() {
            for(var a; a = hf(this);)jf(this, a, this.a, this.A);
            this.i = !1;
        };
        function jf(a, b, c, d) {
            if (c == $e && b.g && !b.h) for(; a && a.s; a = a.h)a.s = !1;
            if (b.a) b.a.h = null, nf(b, c, d);
            else try {
                b.h ? b.s.call(b.j) : nf(b, c, d);
            } catch (e) {
                of.call(null, e);
            }
            He(bf, b);
        }
        function nf(a, b, c) {
            b == Ye ? a.s.call(a.j, c) : a.g && a.g.call(a.j, c);
        }
        function mf(a, b) {
            a.s = !0;
            Qe(function() {
                a.s && of.call(null, b);
            });
        }
        var of = Ne;
        function Ze(a) {
            Ba.call(this, a);
        }
        w(Ze, Ba);
        Ze.prototype.name = "cancel";
        function pf(a, b, c) {
            b || (b = {});
            c = c || window;
            var d = a instanceof xc ? a : Bc("undefined" != typeof a.href ? a.href : String(a));
            a = b.target || a.target;
            var e = [];
            for(f in b)switch(f){
                case "width":
                case "height":
                case "top":
                case "left":
                    e.push(f + "=" + b[f]);
                    break;
                case "target":
                case "noopener":
                case "noreferrer":
                    break;
                default:
                    e.push(f + "=" + (b[f] ? 1 : 0));
            }
            var f = e.join(",");
            (y("iPhone") && !y("iPod") && !y("iPad") || y("iPad") || y("iPod")) && c.navigator && c.navigator.standalone && a && "_self" != a ? (f = c.document.createElement("A"), d = d instanceof xc ? d : Dc(d), f.href = zc(d), f.setAttribute("target", a), b.noreferrer && f.setAttribute("rel", "noreferrer"), b = document.createEvent("MouseEvent"), b.initMouseEvent("click", !0, !0, c, 1), f.dispatchEvent(b), c = {}) : b.noreferrer ? (c = c.open("", a, f), b = zc(d).toString(), c && (cc && -1 != b.indexOf(";") && (b = "'" + b.replace(/'/g, "%27") + "'"), c.opener = null, b = Jc('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + cb(b) + '">', null), c.document.write(Ic(b)), c.document.close())) : (c = c.open(zc(d).toString(), a, f)) && b.noopener && (c.opener = null);
            return c;
        }
        function qf() {
            try {
                return !(!window.opener || !window.opener.location || window.opener.location.hostname !== window.location.hostname || window.opener.location.protocol !== window.location.protocol);
            } catch (a$1) {}
            return !1;
        }
        function rf(a) {
            pf(a, {
                target: window.cordova && window.cordova.InAppBrowser ? "_system" : "_blank"
            }, void 0);
        }
        function sf(a, b) {
            a = ta(a) && 1 == a.nodeType ? a : document.querySelector(String(a));
            if (null == a) throw Error(b || "Cannot find element.");
            return a;
        }
        function tf() {
            return window.location.href;
        }
        function uf() {
            var a = null;
            return new Ve(function(b) {
                "complete" == n.document.readyState ? b() : (a = function() {
                    b();
                }, le(window, "load", a));
            }).Ca(function(b) {
                se(window, "load", a);
                throw b;
            });
        }
        function vf() {
            for(var a = 32, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
            return b.join("");
        }
        function wf(a, b, c) {
            c = void 0 === c ? {} : c;
            return Object.keys(a).filter(function(d) {
                return b.includes(d);
            }).reduce(function(d, e) {
                d[e] = a[e];
                return d;
            }, c);
        }
        function xf(a) {
            var b = yf;
            this.s = [];
            this.T = b;
            this.O = a || null;
            this.j = this.a = !1;
            this.h = void 0;
            this.J = this.l = this.A = !1;
            this.i = 0;
            this.g = null;
            this.C = 0;
        }
        xf.prototype.cancel = function(a) {
            if (this.a) this.h instanceof xf && this.h.cancel();
            else {
                if (this.g) {
                    var b = this.g;
                    delete this.g;
                    a ? b.cancel(a) : (b.C--, 0 >= b.C && b.cancel());
                }
                this.T ? this.T.call(this.O, this) : this.J = !0;
                this.a || (a = new zf(this), Af(this), Bf(this, !1, a));
            }
        };
        xf.prototype.L = function(a, b) {
            this.A = !1;
            Bf(this, a, b);
        };
        function Bf(a, b, c) {
            a.a = !0;
            a.h = c;
            a.j = !b;
            Cf(a);
        }
        function Af(a) {
            if (a.a) {
                if (!a.J) throw new Df(a);
                a.J = !1;
            }
        }
        xf.prototype.callback = function(a) {
            Af(this);
            Bf(this, !0, a);
        };
        function Ef(a, b, c) {
            a.s.push([
                b,
                c,
                void 0
            ]);
            a.a && Cf(a);
        }
        xf.prototype.then = function(a, b, c) {
            var d, e, f = new Ve(function(g, h) {
                d = g;
                e = h;
            });
            Ef(this, d, function(g) {
                g instanceof zf ? f.cancel() : e(g);
            });
            return f.then(a, b, c);
        };
        xf.prototype.$goog_Thenable = !0;
        function Ff(a) {
            return La(a.s, function(b) {
                return sa(b[1]);
            });
        }
        function Cf(a) {
            if (a.i && a.a && Ff(a)) {
                var b = a.i, c = Gf[b];
                c && (n.clearTimeout(c.a), delete Gf[b]);
                a.i = 0;
            }
            a.g && (a.g.C--, delete a.g);
            b = a.h;
            for(var d = c = !1; a.s.length && !a.A;){
                var e = a.s.shift(), f = e[0], g = e[1];
                e = e[2];
                if (f = a.j ? g : f) try {
                    var h = f.call(e || a.O, b);
                    ka(h) && (a.j = a.j && (h == b || h instanceof Error), a.h = b = h);
                    if (Fe(b) || "function" === typeof n.Promise && b instanceof n.Promise) d = !0, a.A = !0;
                } catch (k) {
                    b = k, a.j = !0, Ff(a) || (c = !0);
                }
            }
            a.h = b;
            d && (h = r(a.L, a, !0), d = r(a.L, a, !1), b instanceof xf ? (Ef(b, h, d), b.l = !0) : b.then(h, d));
            c && (b = new Hf(b), Gf[b.a] = b, a.i = b.a);
        }
        function Df() {
            Ba.call(this);
        }
        w(Df, Ba);
        Df.prototype.message = "Deferred has already fired";
        Df.prototype.name = "AlreadyCalledError";
        function zf() {
            Ba.call(this);
        }
        w(zf, Ba);
        zf.prototype.message = "Deferred was canceled";
        zf.prototype.name = "CanceledError";
        function Hf(a) {
            this.a = n.setTimeout(r(this.h, this), 0);
            this.g = a;
        }
        Hf.prototype.h = function() {
            delete Gf[this.a];
            throw this.g;
        };
        var Gf = {};
        function If(a) {
            var b = {}, c = b.document || document, d = uc(a).toString(), e = document.createElement("SCRIPT"), f = {
                rb: e,
                sb: void 0
            }, g = new xf(f), h = null, k = null != b.timeout ? b.timeout : 5E3;
            0 < k && (h = window.setTimeout(function() {
                Jf(e, !0);
                var p = new Kf(Lf, "Timeout reached for loading script " + d);
                Af(g);
                Bf(g, !1, p);
            }, k), f.sb = h);
            e.onload = e.onreadystatechange = function() {
                e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (Jf(e, b.yc || !1, h), g.callback(null));
            };
            e.onerror = function() {
                Jf(e, !0, h);
                var p = new Kf(Mf, "Error while loading script " + d);
                Af(g);
                Bf(g, !1, p);
            };
            f = b.attributes || {};
            gb(f, {
                type: "text/javascript",
                charset: "UTF-8"
            });
            Wc(e, f);
            Mc(e, a);
            Nf(c).appendChild(e);
            return g;
        }
        function Nf(a) {
            var b = (a || document).getElementsByTagName("HEAD");
            return b && 0 != b.length ? b[0] : a.documentElement;
        }
        function yf() {
            if (this && this.rb) {
                var a = this.rb;
                a && "SCRIPT" == a.tagName && Jf(a, !0, this.sb);
            }
        }
        function Jf(a, b, c) {
            null != c && n.clearTimeout(c);
            a.onload = na;
            a.onerror = na;
            a.onreadystatechange = na;
            b && window.setTimeout(function() {
                Zc(a);
            }, 0);
        }
        var Mf = 0, Lf = 1;
        function Kf(a, b) {
            var c = "Jsloader error (code #" + a + ")";
            b && (c += ": " + b);
            Ba.call(this, c);
            this.code = a;
        }
        w(Kf, Ba);
        function Of() {
            return n.google && n.google.accounts && n.google.accounts.id || null;
        }
        function Pf(a) {
            this.a = a || Of();
            this.h = !1;
            this.g = null;
        }
        Pf.prototype.cancel = function() {
            this.a && this.h && (this.g && this.g(null), this.a.cancel());
        };
        function Qf(a, b, c) {
            if (a.a && b) return function() {
                a.h = !0;
                return new Ve(function(e) {
                    a.g = e;
                    a.a.initialize({
                        client_id: b,
                        callback: e,
                        auto_select: !c
                    });
                    a.a.prompt();
                });
            }();
            if (b) {
                var d = Rf.Xa().load().then(function() {
                    a.a = Of();
                    return Qf(a, b, c);
                }).Ca(function() {
                    return null;
                });
                return F(d);
            }
            return F(null);
        }
        oa(Pf);
        var wc = new pc(qc, "https://accounts.google.com/gsi/client");
        function Rf() {
            this.a = null;
        }
        Rf.prototype.load = function() {
            var a = this;
            if (this.a) return this.a;
            var b = vc();
            return Of() ? F() : this.a = uf().then(function() {
                if (!Of()) return new Ve(function(c, d) {
                    var e = setTimeout(function() {
                        a.a = null;
                        d(Error("Network error!"));
                    }, 1E4);
                    n.onGoogleLibraryLoad = function() {
                        clearTimeout(e);
                        c();
                    };
                    F(If(b)).then(function() {
                        Of() && c();
                    }).Ca(function(f) {
                        clearTimeout(e);
                        a.a = null;
                        d(f);
                    });
                });
            });
        };
        oa(Rf);
        function Sf(a, b) {
            this.a = a;
            this.g = b || function(c) {
                throw c;
            };
        }
        Sf.prototype.confirm = function(a) {
            return F(this.a.confirm(a)).Ca(this.g);
        };
        function Tf(a, b, c) {
            this.reset(a, b, c, void 0, void 0);
        }
        Tf.prototype.a = null;
        var Uf = 0;
        Tf.prototype.reset = function(a, b, c, d, e) {
            "number" == typeof e || Uf++;
            this.h = d || Aa();
            this.j = a;
            this.s = b;
            this.g = c;
            delete this.a;
        };
        function Vf(a) {
            this.s = a;
            this.a = this.h = this.j = this.g = null;
        }
        function Wf(a, b) {
            this.name = a;
            this.value = b;
        }
        Wf.prototype.toString = function() {
            return this.name;
        };
        var Xf = new Wf("SEVERE", 1E3), Yf = new Wf("WARNING", 900), Zf = new Wf("CONFIG", 700);
        function $f(a) {
            if (a.j) return a.j;
            if (a.g) return $f(a.g);
            Fa("Root logger has no level set.");
            return null;
        }
        Vf.prototype.log = function(a, b, c) {
            if (a.value >= $f(this).value) for(sa(b) && (b = b()), a = new Tf(a, String(b), this.s), c && (a.a = c), c = this; c;){
                var d = c, e = a;
                if (d.a) for(var f = 0; b = d.a[f]; f++)b(e);
                c = c.g;
            }
        };
        var ag = {}, bg = null;
        function cg() {
            bg || (bg = new Vf(""), ag[""] = bg, bg.j = Zf);
        }
        function dg(a) {
            cg();
            var b;
            if (!(b = ag[a])) {
                b = new Vf(a);
                var c = a.lastIndexOf("."), d = a.substr(c + 1);
                c = dg(a.substr(0, c));
                c.h || (c.h = {});
                c.h[d] = b;
                b.g = c;
                ag[a] = b;
            }
            return b;
        }
        function eg() {
            this.a = Aa();
        }
        var fg = null;
        eg.prototype.set = function(a) {
            this.a = a;
        };
        eg.prototype.reset = function() {
            this.set(Aa());
        };
        eg.prototype.get = function() {
            return this.a;
        };
        function gg(a) {
            this.j = a || "";
            fg || (fg = new eg);
            this.s = fg;
        }
        gg.prototype.a = !0;
        gg.prototype.g = !0;
        gg.prototype.h = !1;
        function hg(a) {
            return 10 > a ? "0" + a : String(a);
        }
        function ig(a, b) {
            a = (a.h - b) / 1E3;
            b = a.toFixed(3);
            var c = 0;
            if (1 > a) c = 2;
            else for(; 100 > a;)c++, a *= 10;
            for(; 0 < c--;)b = " " + b;
            return b;
        }
        function jg(a) {
            gg.call(this, a);
        }
        w(jg, gg);
        function kg(a, b) {
            var c = [];
            c.push(a.j, " ");
            if (a.g) {
                var d = new Date(b.h);
                c.push("[", hg(d.getFullYear() - 2E3) + hg(d.getMonth() + 1) + hg(d.getDate()) + " " + hg(d.getHours()) + ":" + hg(d.getMinutes()) + ":" + hg(d.getSeconds()) + "." + hg(Math.floor(d.getMilliseconds() / 10)), "] ");
            }
            c.push("[", ig(b, a.s.get()), "s] ");
            c.push("[", b.g, "] ");
            c.push(b.s);
            a.h && (b = b.a) && c.push("\n", b instanceof Error ? b.message : b.toString());
            a.a && c.push("\n");
            return c.join("");
        }
        function lg() {
            this.s = r(this.h, this);
            this.a = new jg;
            this.a.g = !1;
            this.a.h = !1;
            this.g = this.a.a = !1;
            this.j = {};
        }
        lg.prototype.h = function(a) {
            function b(f) {
                if (f) {
                    if (f.value >= Xf.value) return "error";
                    if (f.value >= Yf.value) return "warn";
                    if (f.value >= Zf.value) return "log";
                }
                return "debug";
            }
            if (!this.j[a.g]) {
                var c = kg(this.a, a), d = mg;
                if (d) {
                    var e = b(a.j);
                    ng(d, e, c, a.a);
                }
            }
        };
        var mg = n.console;
        function ng(a, b, c, d) {
            if (a[b]) a[b](c, d || "");
            else a.log(c, d || "");
        }
        function og(a, b) {
            var c = pg;
            c && c.log(Xf, a, b);
        }
        var pg;
        pg = dg("firebaseui");
        var qg = new lg;
        if (1 != qg.g) {
            var rg;
            cg();
            rg = bg;
            var sg = qg.s;
            rg.a || (rg.a = []);
            rg.a.push(sg);
            qg.g = !0;
        }
        function tg(a) {
            var b = pg;
            b && b.log(Yf, a, void 0);
        }
        function ug() {
            this.a = ("undefined" == typeof document ? null : document) || {
                cookie: ""
            };
        }
        l = ug.prototype;
        l.set = function(a, b, c, d, e, f) {
            if (/[;=\s]/.test(a)) throw Error('Invalid cookie name "' + a + '"');
            if (/[;\r\n]/.test(b)) throw Error('Invalid cookie value "' + b + '"');
            ka(c) || (c = -1);
            e = e ? ";domain=" + e : "";
            d = d ? ";path=" + d : "";
            f = f ? ";secure" : "";
            c = 0 > c ? "" : 0 == c ? ";expires=" + new Date(1970, 1, 1).toUTCString() : ";expires=" + new Date(Aa() + 1E3 * c).toUTCString();
            this.a.cookie = a + "=" + b + e + d + c + f;
        };
        l.get = function(a, b) {
            for(var c = a + "=", d = (this.a.cookie || "").split(";"), e = 0, f; e < d.length; e++){
                f = Ua(d[e]);
                if (0 == f.lastIndexOf(c, 0)) return f.substr(c.length);
                if (f == a) return "";
            }
            return b;
        };
        l.ja = function() {
            return vg(this).keys;
        };
        l.la = function() {
            return vg(this).values;
        };
        l.clear = function() {
            for(var a = vg(this).keys, b = a.length - 1; 0 <= b; b--){
                var c = a[b];
                this.get(c);
                this.set(c, "", 0, void 0, void 0);
            }
        };
        function vg(a) {
            a = (a.a.cookie || "").split(";");
            for(var b = [], c = [], d, e, f = 0; f < a.length; f++)e = Ua(a[f]), d = e.indexOf("="), -1 == d ? (b.push(""), c.push(e)) : (b.push(e.substring(0, d)), c.push(e.substring(d + 1)));
            return {
                keys: b,
                values: c
            };
        }
        var wg = new ug;
        function yg() {}
        function zg(a, b, c, d) {
            this.h = "undefined" !== typeof a && null !== a ? a : -1;
            this.g = b || null;
            this.a = c || null;
            this.j = !!d;
        }
        m(zg, yg);
        zg.prototype.set = function(a, b) {
            wg.set(a, b, this.h, this.g, this.a, this.j);
        };
        zg.prototype.get = function(a) {
            return wg.get(a) || null;
        };
        zg.prototype.ra = function(a) {
            var b = this.g, c = this.a;
            wg.get(a);
            wg.set(a, "", 0, b, c);
        };
        function Ag(a, b) {
            this.g = a;
            this.a = b || null;
        }
        function Bg(a) {
            return {
                email: a.g,
                credential: a.a && a.a.toJSON()
            };
        }
        function Cg(a) {
            if (a && a.email) {
                var b = a.credential && (0, $8eXKx.default).auth.AuthCredential.fromJSON(a.credential);
                return new Ag(a.email, b);
            }
            return null;
        }
        function Dg(a) {
            this.a = a || null;
        }
        function Eg(a) {
            for(var b = [], c = 0, d = 0; d < a.length; d++){
                var e = a.charCodeAt(d);
                255 < e && (b[c++] = e & 255, e >>= 8);
                b[c++] = e;
            }
            return b;
        }
        function Fg(a) {
            return Ka(a, function(b) {
                b = b.toString(16);
                return 1 < b.length ? b : "0" + b;
            }).join("");
        }
        function Gg(a) {
            this.i = a;
            this.g = this.i.length / 4;
            this.j = this.g + 6;
            this.h = [
                [],
                [],
                [],
                []
            ];
            this.s = [
                [],
                [],
                [],
                []
            ];
            this.a = Array(Hg * (this.j + 1));
            for(a = 0; a < this.g; a++)this.a[a] = [
                this.i[4 * a],
                this.i[4 * a + 1],
                this.i[4 * a + 2],
                this.i[4 * a + 3]
            ];
            var b = Array(4);
            for(a = this.g; a < Hg * (this.j + 1); a++){
                b[0] = this.a[a - 1][0];
                b[1] = this.a[a - 1][1];
                b[2] = this.a[a - 1][2];
                b[3] = this.a[a - 1][3];
                if (0 == a % this.g) {
                    var c = b, d = c[0];
                    c[0] = c[1];
                    c[1] = c[2];
                    c[2] = c[3];
                    c[3] = d;
                    Ig(b);
                    b[0] ^= Jg[a / this.g][0];
                    b[1] ^= Jg[a / this.g][1];
                    b[2] ^= Jg[a / this.g][2];
                    b[3] ^= Jg[a / this.g][3];
                } else 6 < this.g && 4 == a % this.g && Ig(b);
                this.a[a] = Array(4);
                this.a[a][0] = this.a[a - this.g][0] ^ b[0];
                this.a[a][1] = this.a[a - this.g][1] ^ b[1];
                this.a[a][2] = this.a[a - this.g][2] ^ b[2];
                this.a[a][3] = this.a[a - this.g][3] ^ b[3];
            }
        }
        Gg.prototype.A = 16;
        var Hg = Gg.prototype.A / 4;
        function Kg(a, b) {
            for(var c, d = 0; d < Hg; d++)for(var e = 0; 4 > e; e++)c = 4 * e + d, c = b[c], a.h[d][e] = c;
        }
        function Lg(a) {
            for(var b = [], c = 0; c < Hg; c++)for(var d = 0; 4 > d; d++)b[4 * d + c] = a.h[c][d];
            return b;
        }
        function Mg(a, b) {
            for(var c = 0; 4 > c; c++)for(var d = 0; 4 > d; d++)a.h[c][d] ^= a.a[4 * b + d][c];
        }
        function Ng(a, b) {
            for(var c = 0; 4 > c; c++)for(var d = 0; 4 > d; d++)a.h[c][d] = b[a.h[c][d]];
        }
        function Og(a) {
            for(var b = 1; 4 > b; b++)for(var c = 0; 4 > c; c++)a.s[b][c] = a.h[b][c];
            for(b = 1; 4 > b; b++)for(c = 0; 4 > c; c++)a.h[b][c] = a.s[b][(c + b) % Hg];
        }
        function Pg(a) {
            for(var b = 1; 4 > b; b++)for(var c = 0; 4 > c; c++)a.s[b][(c + b) % Hg] = a.h[b][c];
            for(b = 1; 4 > b; b++)for(c = 0; 4 > c; c++)a.h[b][c] = a.s[b][c];
        }
        function Ig(a) {
            a[0] = Qg[a[0]];
            a[1] = Qg[a[1]];
            a[2] = Qg[a[2]];
            a[3] = Qg[a[3]];
        }
        var Qg = [
            99,
            124,
            119,
            123,
            242,
            107,
            111,
            197,
            48,
            1,
            103,
            43,
            254,
            215,
            171,
            118,
            202,
            130,
            201,
            125,
            250,
            89,
            71,
            240,
            173,
            212,
            162,
            175,
            156,
            164,
            114,
            192,
            183,
            253,
            147,
            38,
            54,
            63,
            247,
            204,
            52,
            165,
            229,
            241,
            113,
            216,
            49,
            21,
            4,
            199,
            35,
            195,
            24,
            150,
            5,
            154,
            7,
            18,
            128,
            226,
            235,
            39,
            178,
            117,
            9,
            131,
            44,
            26,
            27,
            110,
            90,
            160,
            82,
            59,
            214,
            179,
            41,
            227,
            47,
            132,
            83,
            209,
            0,
            237,
            32,
            252,
            177,
            91,
            106,
            203,
            190,
            57,
            74,
            76,
            88,
            207,
            208,
            239,
            170,
            251,
            67,
            77,
            51,
            133,
            69,
            249,
            2,
            127,
            80,
            60,
            159,
            168,
            81,
            163,
            64,
            143,
            146,
            157,
            56,
            245,
            188,
            182,
            218,
            33,
            16,
            255,
            243,
            210,
            205,
            12,
            19,
            236,
            95,
            151,
            68,
            23,
            196,
            167,
            126,
            61,
            100,
            93,
            25,
            115,
            96,
            129,
            79,
            220,
            34,
            42,
            144,
            136,
            70,
            238,
            184,
            20,
            222,
            94,
            11,
            219,
            224,
            50,
            58,
            10,
            73,
            6,
            36,
            92,
            194,
            211,
            172,
            98,
            145,
            149,
            228,
            121,
            231,
            200,
            55,
            109,
            141,
            213,
            78,
            169,
            108,
            86,
            244,
            234,
            101,
            122,
            174,
            8,
            186,
            120,
            37,
            46,
            28,
            166,
            180,
            198,
            232,
            221,
            116,
            31,
            75,
            189,
            139,
            138,
            112,
            62,
            181,
            102,
            72,
            3,
            246,
            14,
            97,
            53,
            87,
            185,
            134,
            193,
            29,
            158,
            225,
            248,
            152,
            17,
            105,
            217,
            142,
            148,
            155,
            30,
            135,
            233,
            206,
            85,
            40,
            223,
            140,
            161,
            137,
            13,
            191,
            230,
            66,
            104,
            65,
            153,
            45,
            15,
            176,
            84,
            187,
            22
        ], Rg = [
            82,
            9,
            106,
            213,
            48,
            54,
            165,
            56,
            191,
            64,
            163,
            158,
            129,
            243,
            215,
            251,
            124,
            227,
            57,
            130,
            155,
            47,
            255,
            135,
            52,
            142,
            67,
            68,
            196,
            222,
            233,
            203,
            84,
            123,
            148,
            50,
            166,
            194,
            35,
            61,
            238,
            76,
            149,
            11,
            66,
            250,
            195,
            78,
            8,
            46,
            161,
            102,
            40,
            217,
            36,
            178,
            118,
            91,
            162,
            73,
            109,
            139,
            209,
            37,
            114,
            248,
            246,
            100,
            134,
            104,
            152,
            22,
            212,
            164,
            92,
            204,
            93,
            101,
            182,
            146,
            108,
            112,
            72,
            80,
            253,
            237,
            185,
            218,
            94,
            21,
            70,
            87,
            167,
            141,
            157,
            132,
            144,
            216,
            171,
            0,
            140,
            188,
            211,
            10,
            247,
            228,
            88,
            5,
            184,
            179,
            69,
            6,
            208,
            44,
            30,
            143,
            202,
            63,
            15,
            2,
            193,
            175,
            189,
            3,
            1,
            19,
            138,
            107,
            58,
            145,
            17,
            65,
            79,
            103,
            220,
            234,
            151,
            242,
            207,
            206,
            240,
            180,
            230,
            115,
            150,
            172,
            116,
            34,
            231,
            173,
            53,
            133,
            226,
            249,
            55,
            232,
            28,
            117,
            223,
            110,
            71,
            241,
            26,
            113,
            29,
            41,
            197,
            137,
            111,
            183,
            98,
            14,
            170,
            24,
            190,
            27,
            252,
            86,
            62,
            75,
            198,
            210,
            121,
            32,
            154,
            219,
            192,
            254,
            120,
            205,
            90,
            244,
            31,
            221,
            168,
            51,
            136,
            7,
            199,
            49,
            177,
            18,
            16,
            89,
            39,
            128,
            236,
            95,
            96,
            81,
            127,
            169,
            25,
            181,
            74,
            13,
            45,
            229,
            122,
            159,
            147,
            201,
            156,
            239,
            160,
            224,
            59,
            77,
            174,
            42,
            245,
            176,
            200,
            235,
            187,
            60,
            131,
            83,
            153,
            97,
            23,
            43,
            4,
            126,
            186,
            119,
            214,
            38,
            225,
            105,
            20,
            99,
            85,
            33,
            12,
            125
        ], Jg = [
            [
                0,
                0,
                0,
                0
            ],
            [
                1,
                0,
                0,
                0
            ],
            [
                2,
                0,
                0,
                0
            ],
            [
                4,
                0,
                0,
                0
            ],
            [
                8,
                0,
                0,
                0
            ],
            [
                16,
                0,
                0,
                0
            ],
            [
                32,
                0,
                0,
                0
            ],
            [
                64,
                0,
                0,
                0
            ],
            [
                128,
                0,
                0,
                0
            ],
            [
                27,
                0,
                0,
                0
            ],
            [
                54,
                0,
                0,
                0
            ]
        ], Sg = [
            0,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            16,
            18,
            20,
            22,
            24,
            26,
            28,
            30,
            32,
            34,
            36,
            38,
            40,
            42,
            44,
            46,
            48,
            50,
            52,
            54,
            56,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            120,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            142,
            144,
            146,
            148,
            150,
            152,
            154,
            156,
            158,
            160,
            162,
            164,
            166,
            168,
            170,
            172,
            174,
            176,
            178,
            180,
            182,
            184,
            186,
            188,
            190,
            192,
            194,
            196,
            198,
            200,
            202,
            204,
            206,
            208,
            210,
            212,
            214,
            216,
            218,
            220,
            222,
            224,
            226,
            228,
            230,
            232,
            234,
            236,
            238,
            240,
            242,
            244,
            246,
            248,
            250,
            252,
            254,
            27,
            25,
            31,
            29,
            19,
            17,
            23,
            21,
            11,
            9,
            15,
            13,
            3,
            1,
            7,
            5,
            59,
            57,
            63,
            61,
            51,
            49,
            55,
            53,
            43,
            41,
            47,
            45,
            35,
            33,
            39,
            37,
            91,
            89,
            95,
            93,
            83,
            81,
            87,
            85,
            75,
            73,
            79,
            77,
            67,
            65,
            71,
            69,
            123,
            121,
            127,
            125,
            115,
            113,
            119,
            117,
            107,
            105,
            111,
            109,
            99,
            97,
            103,
            101,
            155,
            153,
            159,
            157,
            147,
            145,
            151,
            149,
            139,
            137,
            143,
            141,
            131,
            129,
            135,
            133,
            187,
            185,
            191,
            189,
            179,
            177,
            183,
            181,
            171,
            169,
            175,
            173,
            163,
            161,
            167,
            165,
            219,
            217,
            223,
            221,
            211,
            209,
            215,
            213,
            203,
            201,
            207,
            205,
            195,
            193,
            199,
            197,
            251,
            249,
            255,
            253,
            243,
            241,
            247,
            245,
            235,
            233,
            239,
            237,
            227,
            225,
            231,
            229
        ], Tg = [
            0,
            3,
            6,
            5,
            12,
            15,
            10,
            9,
            24,
            27,
            30,
            29,
            20,
            23,
            18,
            17,
            48,
            51,
            54,
            53,
            60,
            63,
            58,
            57,
            40,
            43,
            46,
            45,
            36,
            39,
            34,
            33,
            96,
            99,
            102,
            101,
            108,
            111,
            106,
            105,
            120,
            123,
            126,
            125,
            116,
            119,
            114,
            113,
            80,
            83,
            86,
            85,
            92,
            95,
            90,
            89,
            72,
            75,
            78,
            77,
            68,
            71,
            66,
            65,
            192,
            195,
            198,
            197,
            204,
            207,
            202,
            201,
            216,
            219,
            222,
            221,
            212,
            215,
            210,
            209,
            240,
            243,
            246,
            245,
            252,
            255,
            250,
            249,
            232,
            235,
            238,
            237,
            228,
            231,
            226,
            225,
            160,
            163,
            166,
            165,
            172,
            175,
            170,
            169,
            184,
            187,
            190,
            189,
            180,
            183,
            178,
            177,
            144,
            147,
            150,
            149,
            156,
            159,
            154,
            153,
            136,
            139,
            142,
            141,
            132,
            135,
            130,
            129,
            155,
            152,
            157,
            158,
            151,
            148,
            145,
            146,
            131,
            128,
            133,
            134,
            143,
            140,
            137,
            138,
            171,
            168,
            173,
            174,
            167,
            164,
            161,
            162,
            179,
            176,
            181,
            182,
            191,
            188,
            185,
            186,
            251,
            248,
            253,
            254,
            247,
            244,
            241,
            242,
            227,
            224,
            229,
            230,
            239,
            236,
            233,
            234,
            203,
            200,
            205,
            206,
            199,
            196,
            193,
            194,
            211,
            208,
            213,
            214,
            223,
            220,
            217,
            218,
            91,
            88,
            93,
            94,
            87,
            84,
            81,
            82,
            67,
            64,
            69,
            70,
            79,
            76,
            73,
            74,
            107,
            104,
            109,
            110,
            103,
            100,
            97,
            98,
            115,
            112,
            117,
            118,
            127,
            124,
            121,
            122,
            59,
            56,
            61,
            62,
            55,
            52,
            49,
            50,
            35,
            32,
            37,
            38,
            47,
            44,
            41,
            42,
            11,
            8,
            13,
            14,
            7,
            4,
            1,
            2,
            19,
            16,
            21,
            22,
            31,
            28,
            25,
            26
        ], Ug = [
            0,
            9,
            18,
            27,
            36,
            45,
            54,
            63,
            72,
            65,
            90,
            83,
            108,
            101,
            126,
            119,
            144,
            153,
            130,
            139,
            180,
            189,
            166,
            175,
            216,
            209,
            202,
            195,
            252,
            245,
            238,
            231,
            59,
            50,
            41,
            32,
            31,
            22,
            13,
            4,
            115,
            122,
            97,
            104,
            87,
            94,
            69,
            76,
            171,
            162,
            185,
            176,
            143,
            134,
            157,
            148,
            227,
            234,
            241,
            248,
            199,
            206,
            213,
            220,
            118,
            127,
            100,
            109,
            82,
            91,
            64,
            73,
            62,
            55,
            44,
            37,
            26,
            19,
            8,
            1,
            230,
            239,
            244,
            253,
            194,
            203,
            208,
            217,
            174,
            167,
            188,
            181,
            138,
            131,
            152,
            145,
            77,
            68,
            95,
            86,
            105,
            96,
            123,
            114,
            5,
            12,
            23,
            30,
            33,
            40,
            51,
            58,
            221,
            212,
            207,
            198,
            249,
            240,
            235,
            226,
            149,
            156,
            135,
            142,
            177,
            184,
            163,
            170,
            236,
            229,
            254,
            247,
            200,
            193,
            218,
            211,
            164,
            173,
            182,
            191,
            128,
            137,
            146,
            155,
            124,
            117,
            110,
            103,
            88,
            81,
            74,
            67,
            52,
            61,
            38,
            47,
            16,
            25,
            2,
            11,
            215,
            222,
            197,
            204,
            243,
            250,
            225,
            232,
            159,
            150,
            141,
            132,
            187,
            178,
            169,
            160,
            71,
            78,
            85,
            92,
            99,
            106,
            113,
            120,
            15,
            6,
            29,
            20,
            43,
            34,
            57,
            48,
            154,
            147,
            136,
            129,
            190,
            183,
            172,
            165,
            210,
            219,
            192,
            201,
            246,
            255,
            228,
            237,
            10,
            3,
            24,
            17,
            46,
            39,
            60,
            53,
            66,
            75,
            80,
            89,
            102,
            111,
            116,
            125,
            161,
            168,
            179,
            186,
            133,
            140,
            151,
            158,
            233,
            224,
            251,
            242,
            205,
            196,
            223,
            214,
            49,
            56,
            35,
            42,
            21,
            28,
            7,
            14,
            121,
            112,
            107,
            98,
            93,
            84,
            79,
            70
        ], Vg = [
            0,
            11,
            22,
            29,
            44,
            39,
            58,
            49,
            88,
            83,
            78,
            69,
            116,
            127,
            98,
            105,
            176,
            187,
            166,
            173,
            156,
            151,
            138,
            129,
            232,
            227,
            254,
            245,
            196,
            207,
            210,
            217,
            123,
            112,
            109,
            102,
            87,
            92,
            65,
            74,
            35,
            40,
            53,
            62,
            15,
            4,
            25,
            18,
            203,
            192,
            221,
            214,
            231,
            236,
            241,
            250,
            147,
            152,
            133,
            142,
            191,
            180,
            169,
            162,
            246,
            253,
            224,
            235,
            218,
            209,
            204,
            199,
            174,
            165,
            184,
            179,
            130,
            137,
            148,
            159,
            70,
            77,
            80,
            91,
            106,
            97,
            124,
            119,
            30,
            21,
            8,
            3,
            50,
            57,
            36,
            47,
            141,
            134,
            155,
            144,
            161,
            170,
            183,
            188,
            213,
            222,
            195,
            200,
            249,
            242,
            239,
            228,
            61,
            54,
            43,
            32,
            17,
            26,
            7,
            12,
            101,
            110,
            115,
            120,
            73,
            66,
            95,
            84,
            247,
            252,
            225,
            234,
            219,
            208,
            205,
            198,
            175,
            164,
            185,
            178,
            131,
            136,
            149,
            158,
            71,
            76,
            81,
            90,
            107,
            96,
            125,
            118,
            31,
            20,
            9,
            2,
            51,
            56,
            37,
            46,
            140,
            135,
            154,
            145,
            160,
            171,
            182,
            189,
            212,
            223,
            194,
            201,
            248,
            243,
            238,
            229,
            60,
            55,
            42,
            33,
            16,
            27,
            6,
            13,
            100,
            111,
            114,
            121,
            72,
            67,
            94,
            85,
            1,
            10,
            23,
            28,
            45,
            38,
            59,
            48,
            89,
            82,
            79,
            68,
            117,
            126,
            99,
            104,
            177,
            186,
            167,
            172,
            157,
            150,
            139,
            128,
            233,
            226,
            255,
            244,
            197,
            206,
            211,
            216,
            122,
            113,
            108,
            103,
            86,
            93,
            64,
            75,
            34,
            41,
            52,
            63,
            14,
            5,
            24,
            19,
            202,
            193,
            220,
            215,
            230,
            237,
            240,
            251,
            146,
            153,
            132,
            143,
            190,
            181,
            168,
            163
        ], Wg = [
            0,
            13,
            26,
            23,
            52,
            57,
            46,
            35,
            104,
            101,
            114,
            127,
            92,
            81,
            70,
            75,
            208,
            221,
            202,
            199,
            228,
            233,
            254,
            243,
            184,
            181,
            162,
            175,
            140,
            129,
            150,
            155,
            187,
            182,
            161,
            172,
            143,
            130,
            149,
            152,
            211,
            222,
            201,
            196,
            231,
            234,
            253,
            240,
            107,
            102,
            113,
            124,
            95,
            82,
            69,
            72,
            3,
            14,
            25,
            20,
            55,
            58,
            45,
            32,
            109,
            96,
            119,
            122,
            89,
            84,
            67,
            78,
            5,
            8,
            31,
            18,
            49,
            60,
            43,
            38,
            189,
            176,
            167,
            170,
            137,
            132,
            147,
            158,
            213,
            216,
            207,
            194,
            225,
            236,
            251,
            246,
            214,
            219,
            204,
            193,
            226,
            239,
            248,
            245,
            190,
            179,
            164,
            169,
            138,
            135,
            144,
            157,
            6,
            11,
            28,
            17,
            50,
            63,
            40,
            37,
            110,
            99,
            116,
            121,
            90,
            87,
            64,
            77,
            218,
            215,
            192,
            205,
            238,
            227,
            244,
            249,
            178,
            191,
            168,
            165,
            134,
            139,
            156,
            145,
            10,
            7,
            16,
            29,
            62,
            51,
            36,
            41,
            98,
            111,
            120,
            117,
            86,
            91,
            76,
            65,
            97,
            108,
            123,
            118,
            85,
            88,
            79,
            66,
            9,
            4,
            19,
            30,
            61,
            48,
            39,
            42,
            177,
            188,
            171,
            166,
            133,
            136,
            159,
            146,
            217,
            212,
            195,
            206,
            237,
            224,
            247,
            250,
            183,
            186,
            173,
            160,
            131,
            142,
            153,
            148,
            223,
            210,
            197,
            200,
            235,
            230,
            241,
            252,
            103,
            106,
            125,
            112,
            83,
            94,
            73,
            68,
            15,
            2,
            21,
            24,
            59,
            54,
            33,
            44,
            12,
            1,
            22,
            27,
            56,
            53,
            34,
            47,
            100,
            105,
            126,
            115,
            80,
            93,
            74,
            71,
            220,
            209,
            198,
            203,
            232,
            229,
            242,
            255,
            180,
            185,
            174,
            163,
            128,
            141,
            154,
            151
        ], Xg = [
            0,
            14,
            28,
            18,
            56,
            54,
            36,
            42,
            112,
            126,
            108,
            98,
            72,
            70,
            84,
            90,
            224,
            238,
            252,
            242,
            216,
            214,
            196,
            202,
            144,
            158,
            140,
            130,
            168,
            166,
            180,
            186,
            219,
            213,
            199,
            201,
            227,
            237,
            255,
            241,
            171,
            165,
            183,
            185,
            147,
            157,
            143,
            129,
            59,
            53,
            39,
            41,
            3,
            13,
            31,
            17,
            75,
            69,
            87,
            89,
            115,
            125,
            111,
            97,
            173,
            163,
            177,
            191,
            149,
            155,
            137,
            135,
            221,
            211,
            193,
            207,
            229,
            235,
            249,
            247,
            77,
            67,
            81,
            95,
            117,
            123,
            105,
            103,
            61,
            51,
            33,
            47,
            5,
            11,
            25,
            23,
            118,
            120,
            106,
            100,
            78,
            64,
            82,
            92,
            6,
            8,
            26,
            20,
            62,
            48,
            34,
            44,
            150,
            152,
            138,
            132,
            174,
            160,
            178,
            188,
            230,
            232,
            250,
            244,
            222,
            208,
            194,
            204,
            65,
            79,
            93,
            83,
            121,
            119,
            101,
            107,
            49,
            63,
            45,
            35,
            9,
            7,
            21,
            27,
            161,
            175,
            189,
            179,
            153,
            151,
            133,
            139,
            209,
            223,
            205,
            195,
            233,
            231,
            245,
            251,
            154,
            148,
            134,
            136,
            162,
            172,
            190,
            176,
            234,
            228,
            246,
            248,
            210,
            220,
            206,
            192,
            122,
            116,
            102,
            104,
            66,
            76,
            94,
            80,
            10,
            4,
            22,
            24,
            50,
            60,
            46,
            32,
            236,
            226,
            240,
            254,
            212,
            218,
            200,
            198,
            156,
            146,
            128,
            142,
            164,
            170,
            184,
            182,
            12,
            2,
            16,
            30,
            52,
            58,
            40,
            38,
            124,
            114,
            96,
            110,
            68,
            74,
            88,
            86,
            55,
            57,
            43,
            37,
            15,
            1,
            19,
            29,
            71,
            73,
            91,
            85,
            127,
            113,
            99,
            109,
            215,
            217,
            203,
            197,
            239,
            225,
            243,
            253,
            167,
            169,
            187,
            181,
            159,
            145,
            131,
            141
        ];
        function Yg(a, b) {
            a = new Gg(Zg(a));
            b = Eg(b);
            for(var c = b.splice(0, 16), d = "", e; c.length;){
                e = 16 - c.length;
                for(var f = 0; f < e; f++)c.push(0);
                e = a;
                Kg(e, c);
                Mg(e, 0);
                for(c = 1; c < e.j; ++c){
                    Ng(e, Qg);
                    Og(e);
                    f = e.h;
                    for(var g = e.s[0], h = 0; 4 > h; h++)g[0] = f[0][h], g[1] = f[1][h], g[2] = f[2][h], g[3] = f[3][h], f[0][h] = Sg[g[0]] ^ Tg[g[1]] ^ g[2] ^ g[3], f[1][h] = g[0] ^ Sg[g[1]] ^ Tg[g[2]] ^ g[3], f[2][h] = g[0] ^ g[1] ^ Sg[g[2]] ^ Tg[g[3]], f[3][h] = Tg[g[0]] ^ g[1] ^ g[2] ^ Sg[g[3]];
                    Mg(e, c);
                }
                Ng(e, Qg);
                Og(e);
                Mg(e, e.j);
                d += Fg(Lg(e));
                c = b.splice(0, 16);
            }
            return d;
        }
        function $g(a, b) {
            a = new Gg(Zg(a));
            for(var c = [], d = 0; d < b.length; d += 2)c.push(parseInt(b.substring(d, d + 2), 16));
            var e = c.splice(0, 16);
            for(b = ""; e.length;){
                d = a;
                Kg(d, e);
                Mg(d, d.j);
                for(e = 1; e < d.j; ++e){
                    Pg(d);
                    Ng(d, Rg);
                    Mg(d, d.j - e);
                    for(var f = d.h, g = d.s[0], h = 0; 4 > h; h++)g[0] = f[0][h], g[1] = f[1][h], g[2] = f[2][h], g[3] = f[3][h], f[0][h] = Xg[g[0]] ^ Vg[g[1]] ^ Wg[g[2]] ^ Ug[g[3]], f[1][h] = Ug[g[0]] ^ Xg[g[1]] ^ Vg[g[2]] ^ Wg[g[3]], f[2][h] = Wg[g[0]] ^ Ug[g[1]] ^ Xg[g[2]] ^ Vg[g[3]], f[3][h] = Vg[g[0]] ^ Wg[g[1]] ^ Ug[g[2]] ^ Xg[g[3]];
                }
                Pg(d);
                Ng(d, Rg);
                Mg(d, 0);
                d = Lg(d);
                if (8192 >= d.length) d = String.fromCharCode.apply(null, d);
                else {
                    e = "";
                    for(f = 0; f < d.length; f += 8192)e += String.fromCharCode.apply(null, Ta(d, f, f + 8192));
                    d = e;
                }
                b += d;
                e = c.splice(0, 16);
            }
            return b.replace(/(\x00)+$/, "");
        }
        function Zg(a) {
            a = Eg(a.substring(0, 32));
            for(var b = 32 - a.length, c = 0; c < b; c++)a.push(0);
            return a;
        }
        function ah(a) {
            var b = [];
            bh(new ch, a, b);
            return b.join("");
        }
        function ch() {}
        function bh(a, b, c) {
            if (null == b) c.push("null");
            else {
                if ("object" == typeof b) {
                    if (qa(b)) {
                        var d = b;
                        b = d.length;
                        c.push("[");
                        for(var e = "", f = 0; f < b; f++)c.push(e), bh(a, d[f], c), e = ",";
                        c.push("]");
                        return;
                    }
                    if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                    else {
                        c.push("{");
                        e = "";
                        for(d in b)Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), dh(d, c), c.push(":"), bh(a, f, c), e = ","));
                        c.push("}");
                        return;
                    }
                }
                switch(typeof b){
                    case "string":
                        dh(b, c);
                        break;
                    case "number":
                        c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
                        break;
                    case "boolean":
                        c.push(String(b));
                        break;
                    case "function":
                        c.push("null");
                        break;
                    default:
                        throw Error("Unknown type: " + typeof b);
                }
            }
        }
        var eh = {
            '"': '\\"',
            "\\": "\\\\",
            "/": "\\/",
            "\b": "\\b",
            "\f": "\\f",
            "\n": "\\n",
            "\r": "\\r",
            "	": "\\t",
            "\v": "\\u000b"
        }, fh = /\uffff/.test("￿") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
        function dh(a, b) {
            b.push('"', a.replace(fh, function(c) {
                var d = eh[c];
                d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).substr(1), eh[c] = d);
                return d;
            }), '"');
        }
        function gh(a) {
            this.a = a;
        }
        gh.prototype.set = function(a, b) {
            ka(b) ? this.a.set(a, ah(b)) : this.a.ra(a);
        };
        gh.prototype.get = function(a) {
            try {
                var b = this.a.get(a);
            } catch (c) {
                return;
            }
            if (null !== b) try {
                return JSON.parse(b);
            } catch (c$2) {
                throw "Storage: Invalid value was encountered";
            }
        };
        function hh() {}
        w(hh, yg);
        hh.prototype.clear = function() {
            var a = lb(this.ha(!0)), b = this;
            Ha(a, function(c) {
                b.ra(c);
            });
        };
        function ih(a) {
            this.a = a;
        }
        w(ih, hh);
        function jh(a) {
            if (!a.a) return !1;
            try {
                return a.a.setItem("__sak", "1"), a.a.removeItem("__sak"), !0;
            } catch (b) {
                return !1;
            }
        }
        l = ih.prototype;
        l.set = function(a, b) {
            try {
                this.a.setItem(a, b);
            } catch (c) {
                if (0 == this.a.length) throw "Storage mechanism: Storage disabled";
                throw "Storage mechanism: Quota exceeded";
            }
        };
        l.get = function(a) {
            a = this.a.getItem(a);
            if (!q(a) && null !== a) throw "Storage mechanism: Invalid value was encountered";
            return a;
        };
        l.ra = function(a) {
            this.a.removeItem(a);
        };
        l.ha = function(a) {
            var b = 0, c = this.a, d = new ib;
            d.next = function() {
                if (b >= c.length) throw hb;
                var e = c.key(b++);
                if (a) return e;
                e = c.getItem(e);
                if (!q(e)) throw "Storage mechanism: Invalid value was encountered";
                return e;
            };
            return d;
        };
        l.clear = function() {
            this.a.clear();
        };
        l.key = function(a) {
            return this.a.key(a);
        };
        function kh() {
            var a = null;
            try {
                a = window.localStorage || null;
            } catch (b) {}
            this.a = a;
        }
        w(kh, ih);
        function lh() {
            var a = null;
            try {
                a = window.sessionStorage || null;
            } catch (b) {}
            this.a = a;
        }
        w(lh, ih);
        function mh(a, b) {
            this.g = a;
            this.a = b + "::";
        }
        w(mh, hh);
        mh.prototype.set = function(a, b) {
            this.g.set(this.a + a, b);
        };
        mh.prototype.get = function(a) {
            return this.g.get(this.a + a);
        };
        mh.prototype.ra = function(a) {
            this.g.ra(this.a + a);
        };
        mh.prototype.ha = function(a) {
            var b = this.g.ha(!0), c = this, d = new ib;
            d.next = function() {
                for(var e = b.next(); e.substr(0, c.a.length) != c.a;)e = b.next();
                return a ? e.substr(c.a.length) : c.g.get(e);
            };
            return d;
        };
        jh(new kh);
        var nh, oh = new lh;
        nh = jh(oh) ? new mh(oh, "firebaseui") : null;
        var ph = new gh(nh), qh = {
            name: "pendingEmailCredential",
            storage: ph
        }, rh = {
            name: "redirectStatus",
            storage: ph
        }, sh = {
            name: "redirectUrl",
            storage: ph
        }, th = {
            name: "emailForSignIn",
            storage: new gh(new zg(3600, "/"))
        }, uh = {
            name: "pendingEncryptedCredential",
            storage: new gh(new zg(3600, "/"))
        };
        function vh(a, b) {
            return a.storage.get(b ? a.name + ":" + b : a.name);
        }
        function wh(a, b) {
            a.storage.a.ra(b ? a.name + ":" + b : a.name);
        }
        function xh(a, b, c) {
            a.storage.set(c ? a.name + ":" + c : a.name, b);
        }
        function yh(a) {
            return vh(sh, a) || null;
        }
        function zh(a) {
            a = vh(qh, a) || null;
            return Cg(a);
        }
        function Ah(a) {
            wh(qh, a);
        }
        function Bh(a, b) {
            xh(qh, Bg(a), b);
        }
        function Ch(a) {
            return (a = vh(rh, a) || null) && "undefined" !== typeof a.tenantId ? new Dg(a.tenantId) : null;
        }
        function Dh(a, b) {
            xh(rh, {
                tenantId: a.a
            }, b);
        }
        function Eh(a, b) {
            b = vh(th, b);
            var c = null;
            if (b) try {
                var d = $g(a, b), e = JSON.parse(d);
                c = e && e.email || null;
            } catch (f) {}
            return c;
        }
        function Fh(a, b) {
            b = vh(uh, b);
            var c = null;
            if (b) try {
                var d = $g(a, b);
                c = JSON.parse(d);
            } catch (e) {}
            return Cg(c || null);
        }
        function Gh(a, b, c) {
            xh(uh, Yg(a, JSON.stringify(Bg(b))), c);
        }
        function Hh() {
            this.W = {};
        }
        function G(a, b, c) {
            if (b.toLowerCase() in a.W) throw Error("Configuration " + b + " has already been defined.");
            a.W[b.toLowerCase()] = c;
        }
        function Ih(a, b, c) {
            if (!(b.toLowerCase() in a.W)) throw Error("Configuration " + b + " is not defined.");
            a.W[b.toLowerCase()] = c;
        }
        Hh.prototype.get = function(a) {
            if (!(a.toLowerCase() in this.W)) throw Error("Configuration " + a + " is not defined.");
            return this.W[a.toLowerCase()];
        };
        function Jh(a, b) {
            a = a.get(b);
            if (!a) throw Error("Configuration " + b + " is required.");
            return a;
        }
        function Kh() {
            this.g = void 0;
            this.a = {};
        }
        l = Kh.prototype;
        l.set = function(a, b) {
            Lh(this, a, b, !1);
        };
        l.add = function(a, b) {
            Lh(this, a, b, !0);
        };
        function Lh(a, b, c, d) {
            for(var e = 0; e < b.length; e++){
                var f = b.charAt(e);
                a.a[f] || (a.a[f] = new Kh);
                a = a.a[f];
            }
            if (d && void 0 !== a.g) throw Error('The collection already contains the key "' + b + '"');
            a.g = c;
        }
        l.get = function(a) {
            a: {
                for(var b = this, c = 0; c < a.length; c++)if (b = b.a[a.charAt(c)], !b) {
                    a = void 0;
                    break a;
                }
                a = b;
            }
            return a ? a.g : void 0;
        };
        l.la = function() {
            var a = [];
            Mh(this, a);
            return a;
        };
        function Mh(a, b) {
            void 0 !== a.g && b.push(a.g);
            for(var c in a.a)Mh(a.a[c], b);
        }
        l.ja = function() {
            var a = [];
            Nh(this, "", a);
            return a;
        };
        function Nh(a, b, c) {
            void 0 !== a.g && c.push(b);
            for(var d in a.a)Nh(a.a[d], b + d, c);
        }
        l.clear = function() {
            this.a = {};
            this.g = void 0;
        };
        function Oh(a) {
            this.a = a;
            this.g = new Kh;
            for(a = 0; a < this.a.length; a++){
                var b = this.g.get("+" + this.a[a].b);
                b ? b.push(this.a[a]) : this.g.add("+" + this.a[a].b, [
                    this.a[a]
                ]);
            }
        }
        function Ph(a, b) {
            a = a.g;
            var c = {}, d = 0;
            void 0 !== a.g && (c[d] = a.g);
            for(; d < b.length; d++){
                var e = b.charAt(d);
                if (!(e in a.a)) break;
                a = a.a[e];
                void 0 !== a.g && (c[d] = a.g);
            }
            for(var f in c)if (c.hasOwnProperty(f)) return c[f];
            return [];
        }
        function Qh(a) {
            for(var b = 0; b < Rh.length; b++)if (Rh[b].c === a) return Rh[b];
            return null;
        }
        function Sh(a) {
            a = a.toUpperCase();
            for(var b = [], c = 0; c < Rh.length; c++)Rh[c].f === a && b.push(Rh[c]);
            return b;
        }
        function Th(a) {
            if (0 < a.length && "+" == a.charAt(0)) {
                a = a.substring(1);
                for(var b = [], c = 0; c < Rh.length; c++)Rh[c].b == a && b.push(Rh[c]);
                a = b;
            } else a = Sh(a);
            return a;
        }
        function Uh(a) {
            a.sort(function(b, c) {
                return b.name.localeCompare(c.name, "en");
            });
        }
        var Rh = [
            {
                name: "Afghanistan",
                c: "93-AF-0",
                b: "93",
                f: "AF"
            },
            {
                name: "\xc5land Islands",
                c: "358-AX-0",
                b: "358",
                f: "AX"
            },
            {
                name: "Albania",
                c: "355-AL-0",
                b: "355",
                f: "AL"
            },
            {
                name: "Algeria",
                c: "213-DZ-0",
                b: "213",
                f: "DZ"
            },
            {
                name: "American Samoa",
                c: "1-AS-0",
                b: "1",
                f: "AS"
            },
            {
                name: "Andorra",
                c: "376-AD-0",
                b: "376",
                f: "AD"
            },
            {
                name: "Angola",
                c: "244-AO-0",
                b: "244",
                f: "AO"
            },
            {
                name: "Anguilla",
                c: "1-AI-0",
                b: "1",
                f: "AI"
            },
            {
                name: "Antigua and Barbuda",
                c: "1-AG-0",
                b: "1",
                f: "AG"
            },
            {
                name: "Argentina",
                c: "54-AR-0",
                b: "54",
                f: "AR"
            },
            {
                name: "Armenia",
                c: "374-AM-0",
                b: "374",
                f: "AM"
            },
            {
                name: "Aruba",
                c: "297-AW-0",
                b: "297",
                f: "AW"
            },
            {
                name: "Ascension Island",
                c: "247-AC-0",
                b: "247",
                f: "AC"
            },
            {
                name: "Australia",
                c: "61-AU-0",
                b: "61",
                f: "AU"
            },
            {
                name: "Austria",
                c: "43-AT-0",
                b: "43",
                f: "AT"
            },
            {
                name: "Azerbaijan",
                c: "994-AZ-0",
                b: "994",
                f: "AZ"
            },
            {
                name: "Bahamas",
                c: "1-BS-0",
                b: "1",
                f: "BS"
            },
            {
                name: "Bahrain",
                c: "973-BH-0",
                b: "973",
                f: "BH"
            },
            {
                name: "Bangladesh",
                c: "880-BD-0",
                b: "880",
                f: "BD"
            },
            {
                name: "Barbados",
                c: "1-BB-0",
                b: "1",
                f: "BB"
            },
            {
                name: "Belarus",
                c: "375-BY-0",
                b: "375",
                f: "BY"
            },
            {
                name: "Belgium",
                c: "32-BE-0",
                b: "32",
                f: "BE"
            },
            {
                name: "Belize",
                c: "501-BZ-0",
                b: "501",
                f: "BZ"
            },
            {
                name: "Benin",
                c: "229-BJ-0",
                b: "229",
                f: "BJ"
            },
            {
                name: "Bermuda",
                c: "1-BM-0",
                b: "1",
                f: "BM"
            },
            {
                name: "Bhutan",
                c: "975-BT-0",
                b: "975",
                f: "BT"
            },
            {
                name: "Bolivia",
                c: "591-BO-0",
                b: "591",
                f: "BO"
            },
            {
                name: "Bosnia and Herzegovina",
                c: "387-BA-0",
                b: "387",
                f: "BA"
            },
            {
                name: "Botswana",
                c: "267-BW-0",
                b: "267",
                f: "BW"
            },
            {
                name: "Brazil",
                c: "55-BR-0",
                b: "55",
                f: "BR"
            },
            {
                name: "British Indian Ocean Territory",
                c: "246-IO-0",
                b: "246",
                f: "IO"
            },
            {
                name: "British Virgin Islands",
                c: "1-VG-0",
                b: "1",
                f: "VG"
            },
            {
                name: "Brunei",
                c: "673-BN-0",
                b: "673",
                f: "BN"
            },
            {
                name: "Bulgaria",
                c: "359-BG-0",
                b: "359",
                f: "BG"
            },
            {
                name: "Burkina Faso",
                c: "226-BF-0",
                b: "226",
                f: "BF"
            },
            {
                name: "Burundi",
                c: "257-BI-0",
                b: "257",
                f: "BI"
            },
            {
                name: "Cambodia",
                c: "855-KH-0",
                b: "855",
                f: "KH"
            },
            {
                name: "Cameroon",
                c: "237-CM-0",
                b: "237",
                f: "CM"
            },
            {
                name: "Canada",
                c: "1-CA-0",
                b: "1",
                f: "CA"
            },
            {
                name: "Cape Verde",
                c: "238-CV-0",
                b: "238",
                f: "CV"
            },
            {
                name: "Caribbean Netherlands",
                c: "599-BQ-0",
                b: "599",
                f: "BQ"
            },
            {
                name: "Cayman Islands",
                c: "1-KY-0",
                b: "1",
                f: "KY"
            },
            {
                name: "Central African Republic",
                c: "236-CF-0",
                b: "236",
                f: "CF"
            },
            {
                name: "Chad",
                c: "235-TD-0",
                b: "235",
                f: "TD"
            },
            {
                name: "Chile",
                c: "56-CL-0",
                b: "56",
                f: "CL"
            },
            {
                name: "China",
                c: "86-CN-0",
                b: "86",
                f: "CN"
            },
            {
                name: "Christmas Island",
                c: "61-CX-0",
                b: "61",
                f: "CX"
            },
            {
                name: "Cocos [Keeling] Islands",
                c: "61-CC-0",
                b: "61",
                f: "CC"
            },
            {
                name: "Colombia",
                c: "57-CO-0",
                b: "57",
                f: "CO"
            },
            {
                name: "Comoros",
                c: "269-KM-0",
                b: "269",
                f: "KM"
            },
            {
                name: "Democratic Republic Congo",
                c: "243-CD-0",
                b: "243",
                f: "CD"
            },
            {
                name: "Republic of Congo",
                c: "242-CG-0",
                b: "242",
                f: "CG"
            },
            {
                name: "Cook Islands",
                c: "682-CK-0",
                b: "682",
                f: "CK"
            },
            {
                name: "Costa Rica",
                c: "506-CR-0",
                b: "506",
                f: "CR"
            },
            {
                name: "C\xf4te d'Ivoire",
                c: "225-CI-0",
                b: "225",
                f: "CI"
            },
            {
                name: "Croatia",
                c: "385-HR-0",
                b: "385",
                f: "HR"
            },
            {
                name: "Cuba",
                c: "53-CU-0",
                b: "53",
                f: "CU"
            },
            {
                name: "Cura\xe7ao",
                c: "599-CW-0",
                b: "599",
                f: "CW"
            },
            {
                name: "Cyprus",
                c: "357-CY-0",
                b: "357",
                f: "CY"
            },
            {
                name: "Czech Republic",
                c: "420-CZ-0",
                b: "420",
                f: "CZ"
            },
            {
                name: "Denmark",
                c: "45-DK-0",
                b: "45",
                f: "DK"
            },
            {
                name: "Djibouti",
                c: "253-DJ-0",
                b: "253",
                f: "DJ"
            },
            {
                name: "Dominica",
                c: "1-DM-0",
                b: "1",
                f: "DM"
            },
            {
                name: "Dominican Republic",
                c: "1-DO-0",
                b: "1",
                f: "DO"
            },
            {
                name: "East Timor",
                c: "670-TL-0",
                b: "670",
                f: "TL"
            },
            {
                name: "Ecuador",
                c: "593-EC-0",
                b: "593",
                f: "EC"
            },
            {
                name: "Egypt",
                c: "20-EG-0",
                b: "20",
                f: "EG"
            },
            {
                name: "El Salvador",
                c: "503-SV-0",
                b: "503",
                f: "SV"
            },
            {
                name: "Equatorial Guinea",
                c: "240-GQ-0",
                b: "240",
                f: "GQ"
            },
            {
                name: "Eritrea",
                c: "291-ER-0",
                b: "291",
                f: "ER"
            },
            {
                name: "Estonia",
                c: "372-EE-0",
                b: "372",
                f: "EE"
            },
            {
                name: "Ethiopia",
                c: "251-ET-0",
                b: "251",
                f: "ET"
            },
            {
                name: "Falkland Islands [Islas Malvinas]",
                c: "500-FK-0",
                b: "500",
                f: "FK"
            },
            {
                name: "Faroe Islands",
                c: "298-FO-0",
                b: "298",
                f: "FO"
            },
            {
                name: "Fiji",
                c: "679-FJ-0",
                b: "679",
                f: "FJ"
            },
            {
                name: "Finland",
                c: "358-FI-0",
                b: "358",
                f: "FI"
            },
            {
                name: "France",
                c: "33-FR-0",
                b: "33",
                f: "FR"
            },
            {
                name: "French Guiana",
                c: "594-GF-0",
                b: "594",
                f: "GF"
            },
            {
                name: "French Polynesia",
                c: "689-PF-0",
                b: "689",
                f: "PF"
            },
            {
                name: "Gabon",
                c: "241-GA-0",
                b: "241",
                f: "GA"
            },
            {
                name: "Gambia",
                c: "220-GM-0",
                b: "220",
                f: "GM"
            },
            {
                name: "Georgia",
                c: "995-GE-0",
                b: "995",
                f: "GE"
            },
            {
                name: "Germany",
                c: "49-DE-0",
                b: "49",
                f: "DE"
            },
            {
                name: "Ghana",
                c: "233-GH-0",
                b: "233",
                f: "GH"
            },
            {
                name: "Gibraltar",
                c: "350-GI-0",
                b: "350",
                f: "GI"
            },
            {
                name: "Greece",
                c: "30-GR-0",
                b: "30",
                f: "GR"
            },
            {
                name: "Greenland",
                c: "299-GL-0",
                b: "299",
                f: "GL"
            },
            {
                name: "Grenada",
                c: "1-GD-0",
                b: "1",
                f: "GD"
            },
            {
                name: "Guadeloupe",
                c: "590-GP-0",
                b: "590",
                f: "GP"
            },
            {
                name: "Guam",
                c: "1-GU-0",
                b: "1",
                f: "GU"
            },
            {
                name: "Guatemala",
                c: "502-GT-0",
                b: "502",
                f: "GT"
            },
            {
                name: "Guernsey",
                c: "44-GG-0",
                b: "44",
                f: "GG"
            },
            {
                name: "Guinea Conakry",
                c: "224-GN-0",
                b: "224",
                f: "GN"
            },
            {
                name: "Guinea-Bissau",
                c: "245-GW-0",
                b: "245",
                f: "GW"
            },
            {
                name: "Guyana",
                c: "592-GY-0",
                b: "592",
                f: "GY"
            },
            {
                name: "Haiti",
                c: "509-HT-0",
                b: "509",
                f: "HT"
            },
            {
                name: "Heard Island and McDonald Islands",
                c: "672-HM-0",
                b: "672",
                f: "HM"
            },
            {
                name: "Honduras",
                c: "504-HN-0",
                b: "504",
                f: "HN"
            },
            {
                name: "Hong Kong",
                c: "852-HK-0",
                b: "852",
                f: "HK"
            },
            {
                name: "Hungary",
                c: "36-HU-0",
                b: "36",
                f: "HU"
            },
            {
                name: "Iceland",
                c: "354-IS-0",
                b: "354",
                f: "IS"
            },
            {
                name: "India",
                c: "91-IN-0",
                b: "91",
                f: "IN"
            },
            {
                name: "Indonesia",
                c: "62-ID-0",
                b: "62",
                f: "ID"
            },
            {
                name: "Iran",
                c: "98-IR-0",
                b: "98",
                f: "IR"
            },
            {
                name: "Iraq",
                c: "964-IQ-0",
                b: "964",
                f: "IQ"
            },
            {
                name: "Ireland",
                c: "353-IE-0",
                b: "353",
                f: "IE"
            },
            {
                name: "Isle of Man",
                c: "44-IM-0",
                b: "44",
                f: "IM"
            },
            {
                name: "Israel",
                c: "972-IL-0",
                b: "972",
                f: "IL"
            },
            {
                name: "Italy",
                c: "39-IT-0",
                b: "39",
                f: "IT"
            },
            {
                name: "Jamaica",
                c: "1-JM-0",
                b: "1",
                f: "JM"
            },
            {
                name: "Japan",
                c: "81-JP-0",
                b: "81",
                f: "JP"
            },
            {
                name: "Jersey",
                c: "44-JE-0",
                b: "44",
                f: "JE"
            },
            {
                name: "Jordan",
                c: "962-JO-0",
                b: "962",
                f: "JO"
            },
            {
                name: "Kazakhstan",
                c: "7-KZ-0",
                b: "7",
                f: "KZ"
            },
            {
                name: "Kenya",
                c: "254-KE-0",
                b: "254",
                f: "KE"
            },
            {
                name: "Kiribati",
                c: "686-KI-0",
                b: "686",
                f: "KI"
            },
            {
                name: "Kosovo",
                c: "377-XK-0",
                b: "377",
                f: "XK"
            },
            {
                name: "Kosovo",
                c: "381-XK-0",
                b: "381",
                f: "XK"
            },
            {
                name: "Kosovo",
                c: "386-XK-0",
                b: "386",
                f: "XK"
            },
            {
                name: "Kuwait",
                c: "965-KW-0",
                b: "965",
                f: "KW"
            },
            {
                name: "Kyrgyzstan",
                c: "996-KG-0",
                b: "996",
                f: "KG"
            },
            {
                name: "Laos",
                c: "856-LA-0",
                b: "856",
                f: "LA"
            },
            {
                name: "Latvia",
                c: "371-LV-0",
                b: "371",
                f: "LV"
            },
            {
                name: "Lebanon",
                c: "961-LB-0",
                b: "961",
                f: "LB"
            },
            {
                name: "Lesotho",
                c: "266-LS-0",
                b: "266",
                f: "LS"
            },
            {
                name: "Liberia",
                c: "231-LR-0",
                b: "231",
                f: "LR"
            },
            {
                name: "Libya",
                c: "218-LY-0",
                b: "218",
                f: "LY"
            },
            {
                name: "Liechtenstein",
                c: "423-LI-0",
                b: "423",
                f: "LI"
            },
            {
                name: "Lithuania",
                c: "370-LT-0",
                b: "370",
                f: "LT"
            },
            {
                name: "Luxembourg",
                c: "352-LU-0",
                b: "352",
                f: "LU"
            },
            {
                name: "Macau",
                c: "853-MO-0",
                b: "853",
                f: "MO"
            },
            {
                name: "Macedonia",
                c: "389-MK-0",
                b: "389",
                f: "MK"
            },
            {
                name: "Madagascar",
                c: "261-MG-0",
                b: "261",
                f: "MG"
            },
            {
                name: "Malawi",
                c: "265-MW-0",
                b: "265",
                f: "MW"
            },
            {
                name: "Malaysia",
                c: "60-MY-0",
                b: "60",
                f: "MY"
            },
            {
                name: "Maldives",
                c: "960-MV-0",
                b: "960",
                f: "MV"
            },
            {
                name: "Mali",
                c: "223-ML-0",
                b: "223",
                f: "ML"
            },
            {
                name: "Malta",
                c: "356-MT-0",
                b: "356",
                f: "MT"
            },
            {
                name: "Marshall Islands",
                c: "692-MH-0",
                b: "692",
                f: "MH"
            },
            {
                name: "Martinique",
                c: "596-MQ-0",
                b: "596",
                f: "MQ"
            },
            {
                name: "Mauritania",
                c: "222-MR-0",
                b: "222",
                f: "MR"
            },
            {
                name: "Mauritius",
                c: "230-MU-0",
                b: "230",
                f: "MU"
            },
            {
                name: "Mayotte",
                c: "262-YT-0",
                b: "262",
                f: "YT"
            },
            {
                name: "Mexico",
                c: "52-MX-0",
                b: "52",
                f: "MX"
            },
            {
                name: "Micronesia",
                c: "691-FM-0",
                b: "691",
                f: "FM"
            },
            {
                name: "Moldova",
                c: "373-MD-0",
                b: "373",
                f: "MD"
            },
            {
                name: "Monaco",
                c: "377-MC-0",
                b: "377",
                f: "MC"
            },
            {
                name: "Mongolia",
                c: "976-MN-0",
                b: "976",
                f: "MN"
            },
            {
                name: "Montenegro",
                c: "382-ME-0",
                b: "382",
                f: "ME"
            },
            {
                name: "Montserrat",
                c: "1-MS-0",
                b: "1",
                f: "MS"
            },
            {
                name: "Morocco",
                c: "212-MA-0",
                b: "212",
                f: "MA"
            },
            {
                name: "Mozambique",
                c: "258-MZ-0",
                b: "258",
                f: "MZ"
            },
            {
                name: "Myanmar [Burma]",
                c: "95-MM-0",
                b: "95",
                f: "MM"
            },
            {
                name: "Namibia",
                c: "264-NA-0",
                b: "264",
                f: "NA"
            },
            {
                name: "Nauru",
                c: "674-NR-0",
                b: "674",
                f: "NR"
            },
            {
                name: "Nepal",
                c: "977-NP-0",
                b: "977",
                f: "NP"
            },
            {
                name: "Netherlands",
                c: "31-NL-0",
                b: "31",
                f: "NL"
            },
            {
                name: "New Caledonia",
                c: "687-NC-0",
                b: "687",
                f: "NC"
            },
            {
                name: "New Zealand",
                c: "64-NZ-0",
                b: "64",
                f: "NZ"
            },
            {
                name: "Nicaragua",
                c: "505-NI-0",
                b: "505",
                f: "NI"
            },
            {
                name: "Niger",
                c: "227-NE-0",
                b: "227",
                f: "NE"
            },
            {
                name: "Nigeria",
                c: "234-NG-0",
                b: "234",
                f: "NG"
            },
            {
                name: "Niue",
                c: "683-NU-0",
                b: "683",
                f: "NU"
            },
            {
                name: "Norfolk Island",
                c: "672-NF-0",
                b: "672",
                f: "NF"
            },
            {
                name: "North Korea",
                c: "850-KP-0",
                b: "850",
                f: "KP"
            },
            {
                name: "Northern Mariana Islands",
                c: "1-MP-0",
                b: "1",
                f: "MP"
            },
            {
                name: "Norway",
                c: "47-NO-0",
                b: "47",
                f: "NO"
            },
            {
                name: "Oman",
                c: "968-OM-0",
                b: "968",
                f: "OM"
            },
            {
                name: "Pakistan",
                c: "92-PK-0",
                b: "92",
                f: "PK"
            },
            {
                name: "Palau",
                c: "680-PW-0",
                b: "680",
                f: "PW"
            },
            {
                name: "Palestinian Territories",
                c: "970-PS-0",
                b: "970",
                f: "PS"
            },
            {
                name: "Panama",
                c: "507-PA-0",
                b: "507",
                f: "PA"
            },
            {
                name: "Papua New Guinea",
                c: "675-PG-0",
                b: "675",
                f: "PG"
            },
            {
                name: "Paraguay",
                c: "595-PY-0",
                b: "595",
                f: "PY"
            },
            {
                name: "Peru",
                c: "51-PE-0",
                b: "51",
                f: "PE"
            },
            {
                name: "Philippines",
                c: "63-PH-0",
                b: "63",
                f: "PH"
            },
            {
                name: "Poland",
                c: "48-PL-0",
                b: "48",
                f: "PL"
            },
            {
                name: "Portugal",
                c: "351-PT-0",
                b: "351",
                f: "PT"
            },
            {
                name: "Puerto Rico",
                c: "1-PR-0",
                b: "1",
                f: "PR"
            },
            {
                name: "Qatar",
                c: "974-QA-0",
                b: "974",
                f: "QA"
            },
            {
                name: "R\xe9union",
                c: "262-RE-0",
                b: "262",
                f: "RE"
            },
            {
                name: "Romania",
                c: "40-RO-0",
                b: "40",
                f: "RO"
            },
            {
                name: "Russia",
                c: "7-RU-0",
                b: "7",
                f: "RU"
            },
            {
                name: "Rwanda",
                c: "250-RW-0",
                b: "250",
                f: "RW"
            },
            {
                name: "Saint Barth\xe9lemy",
                c: "590-BL-0",
                b: "590",
                f: "BL"
            },
            {
                name: "Saint Helena",
                c: "290-SH-0",
                b: "290",
                f: "SH"
            },
            {
                name: "St. Kitts",
                c: "1-KN-0",
                b: "1",
                f: "KN"
            },
            {
                name: "St. Lucia",
                c: "1-LC-0",
                b: "1",
                f: "LC"
            },
            {
                name: "Saint Martin",
                c: "590-MF-0",
                b: "590",
                f: "MF"
            },
            {
                name: "Saint Pierre and Miquelon",
                c: "508-PM-0",
                b: "508",
                f: "PM"
            },
            {
                name: "St. Vincent",
                c: "1-VC-0",
                b: "1",
                f: "VC"
            },
            {
                name: "Samoa",
                c: "685-WS-0",
                b: "685",
                f: "WS"
            },
            {
                name: "San Marino",
                c: "378-SM-0",
                b: "378",
                f: "SM"
            },
            {
                name: "S\xe3o Tom\xe9 and Pr\xedncipe",
                c: "239-ST-0",
                b: "239",
                f: "ST"
            },
            {
                name: "Saudi Arabia",
                c: "966-SA-0",
                b: "966",
                f: "SA"
            },
            {
                name: "Senegal",
                c: "221-SN-0",
                b: "221",
                f: "SN"
            },
            {
                name: "Serbia",
                c: "381-RS-0",
                b: "381",
                f: "RS"
            },
            {
                name: "Seychelles",
                c: "248-SC-0",
                b: "248",
                f: "SC"
            },
            {
                name: "Sierra Leone",
                c: "232-SL-0",
                b: "232",
                f: "SL"
            },
            {
                name: "Singapore",
                c: "65-SG-0",
                b: "65",
                f: "SG"
            },
            {
                name: "Sint Maarten",
                c: "1-SX-0",
                b: "1",
                f: "SX"
            },
            {
                name: "Slovakia",
                c: "421-SK-0",
                b: "421",
                f: "SK"
            },
            {
                name: "Slovenia",
                c: "386-SI-0",
                b: "386",
                f: "SI"
            },
            {
                name: "Solomon Islands",
                c: "677-SB-0",
                b: "677",
                f: "SB"
            },
            {
                name: "Somalia",
                c: "252-SO-0",
                b: "252",
                f: "SO"
            },
            {
                name: "South Africa",
                c: "27-ZA-0",
                b: "27",
                f: "ZA"
            },
            {
                name: "South Georgia and the South Sandwich Islands",
                c: "500-GS-0",
                b: "500",
                f: "GS"
            },
            {
                name: "South Korea",
                c: "82-KR-0",
                b: "82",
                f: "KR"
            },
            {
                name: "South Sudan",
                c: "211-SS-0",
                b: "211",
                f: "SS"
            },
            {
                name: "Spain",
                c: "34-ES-0",
                b: "34",
                f: "ES"
            },
            {
                name: "Sri Lanka",
                c: "94-LK-0",
                b: "94",
                f: "LK"
            },
            {
                name: "Sudan",
                c: "249-SD-0",
                b: "249",
                f: "SD"
            },
            {
                name: "Suriname",
                c: "597-SR-0",
                b: "597",
                f: "SR"
            },
            {
                name: "Svalbard and Jan Mayen",
                c: "47-SJ-0",
                b: "47",
                f: "SJ"
            },
            {
                name: "Swaziland",
                c: "268-SZ-0",
                b: "268",
                f: "SZ"
            },
            {
                name: "Sweden",
                c: "46-SE-0",
                b: "46",
                f: "SE"
            },
            {
                name: "Switzerland",
                c: "41-CH-0",
                b: "41",
                f: "CH"
            },
            {
                name: "Syria",
                c: "963-SY-0",
                b: "963",
                f: "SY"
            },
            {
                name: "Taiwan",
                c: "886-TW-0",
                b: "886",
                f: "TW"
            },
            {
                name: "Tajikistan",
                c: "992-TJ-0",
                b: "992",
                f: "TJ"
            },
            {
                name: "Tanzania",
                c: "255-TZ-0",
                b: "255",
                f: "TZ"
            },
            {
                name: "Thailand",
                c: "66-TH-0",
                b: "66",
                f: "TH"
            },
            {
                name: "Togo",
                c: "228-TG-0",
                b: "228",
                f: "TG"
            },
            {
                name: "Tokelau",
                c: "690-TK-0",
                b: "690",
                f: "TK"
            },
            {
                name: "Tonga",
                c: "676-TO-0",
                b: "676",
                f: "TO"
            },
            {
                name: "Trinidad/Tobago",
                c: "1-TT-0",
                b: "1",
                f: "TT"
            },
            {
                name: "Tunisia",
                c: "216-TN-0",
                b: "216",
                f: "TN"
            },
            {
                name: "Turkey",
                c: "90-TR-0",
                b: "90",
                f: "TR"
            },
            {
                name: "Turkmenistan",
                c: "993-TM-0",
                b: "993",
                f: "TM"
            },
            {
                name: "Turks and Caicos Islands",
                c: "1-TC-0",
                b: "1",
                f: "TC"
            },
            {
                name: "Tuvalu",
                c: "688-TV-0",
                b: "688",
                f: "TV"
            },
            {
                name: "U.S. Virgin Islands",
                c: "1-VI-0",
                b: "1",
                f: "VI"
            },
            {
                name: "Uganda",
                c: "256-UG-0",
                b: "256",
                f: "UG"
            },
            {
                name: "Ukraine",
                c: "380-UA-0",
                b: "380",
                f: "UA"
            },
            {
                name: "United Arab Emirates",
                c: "971-AE-0",
                b: "971",
                f: "AE"
            },
            {
                name: "United Kingdom",
                c: "44-GB-0",
                b: "44",
                f: "GB"
            },
            {
                name: "United States",
                c: "1-US-0",
                b: "1",
                f: "US"
            },
            {
                name: "Uruguay",
                c: "598-UY-0",
                b: "598",
                f: "UY"
            },
            {
                name: "Uzbekistan",
                c: "998-UZ-0",
                b: "998",
                f: "UZ"
            },
            {
                name: "Vanuatu",
                c: "678-VU-0",
                b: "678",
                f: "VU"
            },
            {
                name: "Vatican City",
                c: "379-VA-0",
                b: "379",
                f: "VA"
            },
            {
                name: "Venezuela",
                c: "58-VE-0",
                b: "58",
                f: "VE"
            },
            {
                name: "Vietnam",
                c: "84-VN-0",
                b: "84",
                f: "VN"
            },
            {
                name: "Wallis and Futuna",
                c: "681-WF-0",
                b: "681",
                f: "WF"
            },
            {
                name: "Western Sahara",
                c: "212-EH-0",
                b: "212",
                f: "EH"
            },
            {
                name: "Yemen",
                c: "967-YE-0",
                b: "967",
                f: "YE"
            },
            {
                name: "Zambia",
                c: "260-ZM-0",
                b: "260",
                f: "ZM"
            },
            {
                name: "Zimbabwe",
                c: "263-ZW-0",
                b: "263",
                f: "ZW"
            }
        ];
        Uh(Rh);
        var Vh = new Oh(Rh);
        function Wh(a, b) {
            this.a = a;
            this.Aa = b;
        }
        function Xh(a) {
            a = Ua(a);
            var b = Ph(Vh, a);
            return 0 < b.length ? new Wh("1" == b[0].b ? "1-US-0" : b[0].c, Ua(a.substr(b[0].b.length + 1))) : null;
        }
        function Yh(a) {
            var b = Qh(a.a);
            if (!b) throw Error("Country ID " + a.a + " not found.");
            return "+" + b.b + a.Aa;
        }
        function Zh(a, b) {
            for(var c = 0; c < a.length; c++)if (!Ma($h, a[c]) && (null !== ai && a[c] in ai || Ma(b, a[c]))) return a[c];
            return null;
        }
        var $h = [
            "emailLink",
            "password",
            "phone"
        ], ai = {
            "facebook.com": "FacebookAuthProvider",
            "github.com": "GithubAuthProvider",
            "google.com": "GoogleAuthProvider",
            password: "EmailAuthProvider",
            "twitter.com": "TwitterAuthProvider",
            phone: "PhoneAuthProvider"
        };
        function bi() {
            this.a = new Hh;
            G(this.a, "acUiConfig");
            G(this.a, "autoUpgradeAnonymousUsers");
            G(this.a, "callbacks");
            G(this.a, "credentialHelper", ci);
            G(this.a, "immediateFederatedRedirect", !1);
            G(this.a, "popupMode", !1);
            G(this.a, "privacyPolicyUrl");
            G(this.a, "queryParameterForSignInSuccessUrl", "signInSuccessUrl");
            G(this.a, "queryParameterForWidgetMode", "mode");
            G(this.a, "signInFlow");
            G(this.a, "signInOptions");
            G(this.a, "signInSuccessUrl");
            G(this.a, "siteName");
            G(this.a, "tosUrl");
            G(this.a, "widgetUrl");
            G(this.a, "adminRestrictedOperation");
        }
        function di(a) {
            var b = !!a.a.get("autoUpgradeAnonymousUsers");
            b && !ei(a) && og('Missing "signInFailure" callback: "signInFailure" callback needs to be provided when "autoUpgradeAnonymousUsers" is set to true.', void 0);
            return b;
        }
        function fi(a) {
            a = a.a.get("signInOptions") || [];
            for(var b = [], c = 0; c < a.length; c++){
                var d = a[c];
                d = ta(d) ? d : {
                    provider: d
                };
                d.provider && b.push(d);
            }
            return b;
        }
        function gi(a, b) {
            a = fi(a);
            for(var c = 0; c < a.length; c++)if (a[c].provider === b) return a[c];
            return null;
        }
        function hi(a) {
            return fi(a).map(function(b) {
                return b.provider;
            });
        }
        function ii(a, b) {
            a = ji(a);
            for(var c = 0; c < a.length; c++)if (a[c].providerId === b) return a[c];
            return null;
        }
        function ji(a) {
            return fi(a).map(function(b) {
                if (ai[b.provider] || Ma(ki, b.provider)) {
                    b = {
                        providerId: b.provider,
                        S: b.providerName || null,
                        V: b.fullLabel || null,
                        ta: b.buttonColor || null,
                        za: b.iconUrl ? zc(Bc(b.iconUrl)).toString() : null
                    };
                    for(var c in b)null === b[c] && delete b[c];
                    return b;
                }
                return {
                    providerId: b.provider,
                    S: b.providerName || null,
                    V: b.fullLabel || null,
                    ta: b.buttonColor || null,
                    za: b.iconUrl ? zc(Bc(b.iconUrl)).toString() : null,
                    Ob: b.loginHintKey || null
                };
            });
        }
        function li(a) {
            var b = gi(a, (0, $8eXKx.default).auth.GoogleAuthProvider.PROVIDER_ID);
            return b && b.clientId && mi(a) === ni ? b.clientId || null : null;
        }
        function oi(a) {
            a = gi(a, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID);
            return !!(a && a.disableSignUp && a.disableSignUp.status);
        }
        function pi(a) {
            a = a.a.get("adminRestrictedOperation") || null;
            return !(!a || !a.status);
        }
        function qi(a) {
            var b = null;
            fi(a).forEach(function(d) {
                d.provider == (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID && ta(d.recaptchaParameters) && !Array.isArray(d.recaptchaParameters) && (b = eb(d.recaptchaParameters));
            });
            if (b) {
                var c = [];
                ri.forEach(function(d) {
                    "undefined" !== typeof b[d] && (c.push(d), delete b[d]);
                });
                c.length && tg('The following provided "recaptchaParameters" keys are not allowed: ' + c.join(", "));
            }
            return b;
        }
        function si(a) {
            return (a = a.a.get("adminRestrictedOperation")) && a.adminEmail ? a.adminEmail : null;
        }
        function ti(a) {
            if (a = a.a.get("adminRestrictedOperation") || null) {
                var b = a.helpLink || null;
                if (b && "string" === typeof b) return function() {
                    rf(b);
                };
            }
            return null;
        }
        function ui(a) {
            return (a = gi(a, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID)) && a.disableSignUp && a.disableSignUp.adminEmail || null;
        }
        function vi(a) {
            if ((a = gi(a, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID)) && a.disableSignUp) {
                var b = a.disableSignUp.helpLink || null;
                if (b && "string" === typeof b) return function() {
                    rf(b);
                };
            }
            return null;
        }
        function wi(a, b) {
            a = (a = gi(a, b)) && a.scopes;
            return Array.isArray(a) ? a : [];
        }
        function xi(a, b) {
            a = (a = gi(a, b)) && a.customParameters;
            return ta(a) ? (a = eb(a), b === (0, $8eXKx.default).auth.GoogleAuthProvider.PROVIDER_ID && delete a.login_hint, b === (0, $8eXKx.default).auth.GithubAuthProvider.PROVIDER_ID && delete a.login, a) : null;
        }
        function yi(a) {
            a = gi(a, (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID);
            var b = null;
            a && "string" === typeof a.loginHint && (b = Xh(a.loginHint));
            return a && a.defaultNationalNumber || b && b.Aa || null;
        }
        function zi(a) {
            var b = (a = gi(a, (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID)) && a.defaultCountry || null;
            b = b && Sh(b);
            var c = null;
            a && "string" === typeof a.loginHint && (c = Xh(a.loginHint));
            return b && b[0] || c && Qh(c.a) || null;
        }
        function Ai(a) {
            a = gi(a, (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID);
            if (!a) return null;
            var b = a.whitelistedCountries, c = a.blacklistedCountries;
            if ("undefined" !== typeof b && (!Array.isArray(b) || 0 == b.length)) throw Error("WhitelistedCountries must be a non-empty array.");
            if ("undefined" !== typeof c && !Array.isArray(c)) throw Error("BlacklistedCountries must be an array.");
            if (b && c) throw Error("Both whitelistedCountries and blacklistedCountries are provided.");
            if (!b && !c) return Rh;
            a = [];
            if (b) {
                c = {};
                for(var d = 0; d < b.length; d++){
                    var e = Th(b[d]);
                    for(var f = 0; f < e.length; f++)c[e[f].c] = e[f];
                }
                for(var g in c)c.hasOwnProperty(g) && a.push(c[g]);
            } else {
                g = {};
                for(b = 0; b < c.length; b++)for(e = Th(c[b]), d = 0; d < e.length; d++)g[e[d].c] = e[d];
                for(e = 0; e < Rh.length; e++)null !== g && Rh[e].c in g || a.push(Rh[e]);
            }
            return a;
        }
        function Bi(a) {
            return Jh(a.a, "queryParameterForWidgetMode");
        }
        function H(a) {
            var b = a.a.get("tosUrl") || null;
            a = a.a.get("privacyPolicyUrl") || null;
            b && !a && tg("Privacy Policy URL is missing, the link will not be displayed.");
            if (b && a) {
                if ("function" === typeof b) return b;
                if ("string" === typeof b) return function() {
                    rf(b);
                };
            }
            return null;
        }
        function J(a) {
            var b = a.a.get("tosUrl") || null, c = a.a.get("privacyPolicyUrl") || null;
            c && !b && tg("Term of Service URL is missing, the link will not be displayed.");
            if (b && c) {
                if ("function" === typeof c) return c;
                if ("string" === typeof c) return function() {
                    rf(c);
                };
            }
            return null;
        }
        function Ci(a) {
            return (a = gi(a, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID)) && "undefined" !== typeof a.requireDisplayName ? !!a.requireDisplayName : !0;
        }
        function Di(a) {
            a = gi(a, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID);
            return !(!a || a.signInMethod !== (0, $8eXKx.default).auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD);
        }
        function Ei(a) {
            a = gi(a, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID);
            return !(!a || !a.forceSameDevice);
        }
        function Fi(a) {
            if (Di(a)) {
                var b = {
                    url: tf(),
                    handleCodeInApp: !0
                };
                (a = gi(a, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID)) && "function" === typeof a.emailLinkSignIn && gb(b, a.emailLinkSignIn());
                a = b.url;
                var c = tf();
                c instanceof vb || (c = Jb(c));
                a instanceof vb || (a = Jb(a));
                var d = c;
                c = new vb(d);
                var e = !!a.j;
                e ? wb(c, a.j) : e = !!a.A;
                e ? c.A = a.A : e = !!a.h;
                e ? c.h = a.h : e = null != a.C;
                var f = a.g;
                if (e) xb(c, a.C);
                else if (e = !!a.g) {
                    if ("/" != f.charAt(0) && (d.h && !d.g ? f = "/" + f : (d = c.g.lastIndexOf("/"), -1 != d && (f = c.g.substr(0, d + 1) + f))), ".." == f || "." == f) f = "";
                    else if (-1 != f.indexOf("./") || -1 != f.indexOf("/.")) {
                        d = 0 == f.lastIndexOf("/", 0);
                        f = f.split("/");
                        for(var g = [], h = 0; h < f.length;){
                            var k = f[h++];
                            "." == k ? d && h == f.length && g.push("") : ".." == k ? ((1 < g.length || 1 == g.length && "" != g[0]) && g.pop(), d && h == f.length && g.push("")) : (g.push(k), d = !0);
                        }
                        f = g.join("/");
                    }
                }
                e ? c.g = f : e = "" !== a.a.toString();
                e ? yb(c, zb(a.a)) : e = !!a.s;
                e && (c.s = a.s);
                b.url = c.toString();
                return b;
            }
            return null;
        }
        function Gi(a) {
            var b = !!a.a.get("immediateFederatedRedirect"), c = hi(a);
            a = Hi(a);
            return b && 1 == c.length && !Ma($h, c[0]) && a == Ii;
        }
        function Hi(a) {
            a = a.a.get("signInFlow");
            for(var b in Ji)if (Ji[b] == a) return Ji[b];
            return Ii;
        }
        function Ki(a) {
            return Li(a).signInSuccess || null;
        }
        function Mi(a) {
            return Li(a).signInSuccessWithAuthResult || null;
        }
        function ei(a) {
            return Li(a).signInFailure || null;
        }
        function Li(a) {
            return a.a.get("callbacks") || {};
        }
        function mi(a) {
            if ("http:" !== (window.location && window.location.protocol) && "https:" !== (window.location && window.location.protocol)) return ci;
            a = a.a.get("credentialHelper");
            if (a === Ni) return ci;
            for(var b in Oi)if (Oi[b] === a) return Oi[b];
            return ci;
        }
        var Ni = "accountchooser.com", ni = "googleyolo", ci = "none", Oi = {
            lc: Ni,
            oc: ni,
            NONE: ci
        }, Ii = "redirect", Ji = {
            rc: "popup",
            sc: Ii
        }, Pi = {
            nc: "callback",
            RECOVER_EMAIL: "recoverEmail",
            tc: "resetPassword",
            REVERT_SECOND_FACTOR_ADDITION: "revertSecondFactorAddition",
            uc: "select",
            vc: "signIn",
            VERIFY_AND_CHANGE_EMAIL: "verifyAndChangeEmail",
            VERIFY_EMAIL: "verifyEmail"
        }, ki = [
            "anonymous"
        ], ri = [
            "sitekey",
            "tabindex",
            "callback",
            "expired-callback"
        ];
        var Qi, Ri, Si, Ti, K = {};
        function L(a, b, c, d) {
            K[a].apply(null, Array.prototype.slice.call(arguments, 1));
        }
        function Ui(a) {
            if (a.classList) return a.classList;
            a = a.className;
            return q(a) && a.match(/\S+/g) || [];
        }
        function Vi(a, b) {
            return a.classList ? a.classList.contains(b) : Ma(Ui(a), b);
        }
        function Wi(a, b) {
            a.classList ? a.classList.add(b) : Vi(a, b) || (a.className += 0 < a.className.length ? " " + b : b);
        }
        function Xi(a, b) {
            a.classList ? a.classList.remove(b) : Vi(a, b) && (a.className = Ja(Ui(a), function(c) {
                return c != b;
            }).join(" "));
        }
        function Yi(a) {
            var b = a.type;
            switch(q(b) && b.toLowerCase()){
                case "checkbox":
                case "radio":
                    return a.checked ? a.value : null;
                case "select-one":
                    return b = a.selectedIndex, 0 <= b ? a.options[b].value : null;
                case "select-multiple":
                    b = [];
                    for(var c, d = 0; c = a.options[d]; d++)c.selected && b.push(c.value);
                    return b.length ? b : null;
                default:
                    return null != a.value ? a.value : null;
            }
        }
        function Zi(a, b) {
            var c = a.type;
            switch(q(c) && c.toLowerCase()){
                case "checkbox":
                case "radio":
                    a.checked = b;
                    break;
                case "select-one":
                    a.selectedIndex = -1;
                    if (q(b)) {
                        for(var d = 0; c = a.options[d]; d++)if (c.value == b) {
                            c.selected = !0;
                            break;
                        }
                    }
                    break;
                case "select-multiple":
                    q(b) && (b = [
                        b
                    ]);
                    for(d = 0; c = a.options[d]; d++)if (c.selected = !1, b) for(var e, f = 0; e = b[f]; f++)c.value == e && (c.selected = !0);
                    break;
                default:
                    a.value = null != b ? b : "";
            }
        }
        function $i(a) {
            if (a.altKey && !a.ctrlKey || a.metaKey || 112 <= a.keyCode && 123 >= a.keyCode) return !1;
            if (aj(a.keyCode)) return !0;
            switch(a.keyCode){
                case 18:
                case 20:
                case 93:
                case 17:
                case 40:
                case 35:
                case 27:
                case 36:
                case 45:
                case 37:
                case 224:
                case 91:
                case 144:
                case 12:
                case 34:
                case 33:
                case 19:
                case 255:
                case 44:
                case 39:
                case 145:
                case 16:
                case 38:
                case 252:
                case 224:
                case 92:
                    return !1;
                case 0:
                    return !dc;
                default:
                    return 166 > a.keyCode || 183 < a.keyCode;
            }
        }
        function bj(a, b, c, d, e, f) {
            if (ec && !mc("525")) return !0;
            if (gc && e) return aj(a);
            if (e && !d) return !1;
            if (!dc) {
                "number" == typeof b && (b = cj(b));
                var g = 17 == b || 18 == b || gc && 91 == b;
                if ((!c || gc) && g || gc && 16 == b && (d || f)) return !1;
            }
            if ((ec || bc) && d && c) switch(a){
                case 220:
                case 219:
                case 221:
                case 192:
                case 186:
                case 189:
                case 187:
                case 188:
                case 190:
                case 191:
                case 192:
                case 222:
                    return !1;
            }
            if (z && d && b == a) return !1;
            switch(a){
                case 13:
                    return dc ? f || e ? !1 : !(c && d) : !0;
                case 27:
                    return !(ec || bc || dc);
            }
            return dc && (d || e || f) ? !1 : aj(a);
        }
        function aj(a) {
            if (48 <= a && 57 >= a || 96 <= a && 106 >= a || 65 <= a && 90 >= a || (ec || bc) && 0 == a) return !0;
            switch(a){
                case 32:
                case 43:
                case 63:
                case 64:
                case 107:
                case 109:
                case 110:
                case 111:
                case 186:
                case 59:
                case 189:
                case 187:
                case 61:
                case 188:
                case 190:
                case 191:
                case 192:
                case 222:
                case 219:
                case 220:
                case 221:
                case 163:
                    return !0;
                case 173:
                    return dc;
                default:
                    return !1;
            }
        }
        function cj(a) {
            if (dc) a = dj(a);
            else if (gc && ec) switch(a){
                case 93:
                    a = 91;
            }
            return a;
        }
        function dj(a) {
            switch(a){
                case 61:
                    return 187;
                case 59:
                    return 186;
                case 173:
                    return 189;
                case 224:
                    return 91;
                case 0:
                    return 224;
                default:
                    return a;
            }
        }
        function ej(a) {
            E.call(this);
            this.a = a;
            ke(a, "keydown", this.g, !1, this);
            ke(a, "click", this.h, !1, this);
        }
        w(ej, E);
        ej.prototype.g = function(a) {
            (13 == a.keyCode || ec && 3 == a.keyCode) && fj(this, a);
        };
        ej.prototype.h = function(a) {
            fj(this, a);
        };
        function fj(a, b) {
            var c = new gj(b);
            if (xe(a, c)) {
                c = new hj(b);
                try {
                    xe(a, c);
                } finally{
                    b.stopPropagation();
                }
            }
        }
        ej.prototype.o = function() {
            ej.K.o.call(this);
            se(this.a, "keydown", this.g, !1, this);
            se(this.a, "click", this.h, !1, this);
            delete this.a;
        };
        function hj(a) {
            Zd.call(this, a.a);
            this.type = "action";
        }
        w(hj, Zd);
        function gj(a) {
            Zd.call(this, a.a);
            this.type = "beforeaction";
        }
        w(gj, Zd);
        function ij(a) {
            E.call(this);
            this.a = a;
            a = z ? "focusout" : "blur";
            this.g = ke(this.a, z ? "focusin" : "focus", this, !z);
            this.h = ke(this.a, a, this, !z);
        }
        w(ij, E);
        ij.prototype.handleEvent = function(a) {
            var b = new Zd(a.a);
            b.type = "focusin" == a.type || "focus" == a.type ? "focusin" : "focusout";
            xe(this, b);
        };
        ij.prototype.o = function() {
            ij.K.o.call(this);
            te(this.g);
            te(this.h);
            delete this.a;
        };
        function jj(a, b) {
            E.call(this);
            this.g = a || 1;
            this.a = b || n;
            this.h = r(this.gc, this);
            this.j = Aa();
        }
        w(jj, E);
        l = jj.prototype;
        l.Ka = !1;
        l.aa = null;
        l.gc = function() {
            if (this.Ka) {
                var a = Aa() - this.j;
                0 < a && a < .8 * this.g ? this.aa = this.a.setTimeout(this.h, this.g - a) : (this.aa && (this.a.clearTimeout(this.aa), this.aa = null), xe(this, "tick"), this.Ka && (kj(this), this.start()));
            }
        };
        l.start = function() {
            this.Ka = !0;
            this.aa || (this.aa = this.a.setTimeout(this.h, this.g), this.j = Aa());
        };
        function kj(a) {
            a.Ka = !1;
            a.aa && (a.a.clearTimeout(a.aa), a.aa = null);
        }
        l.o = function() {
            jj.K.o.call(this);
            kj(this);
            delete this.a;
        };
        function lj(a, b) {
            if (sa(a)) b && (a = r(a, b));
            else if (a && "function" == typeof a.handleEvent) a = r(a.handleEvent, a);
            else throw Error("Invalid listener argument");
            return 2147483647 < Number(0) ? -1 : n.setTimeout(a, 0);
        }
        function mj(a) {
            Pd.call(this);
            this.g = a;
            this.a = {};
        }
        w(mj, Pd);
        var nj = [];
        function oj(a, b, c, d) {
            qa(c) || (c && (nj[0] = c.toString()), c = nj);
            for(var e = 0; e < c.length; e++){
                var f = ke(b, c[e], d || a.handleEvent, !1, a.g || a);
                if (!f) break;
                a.a[f.key] = f;
            }
        }
        function pj(a) {
            db(a.a, function(b, c) {
                this.a.hasOwnProperty(c) && te(b);
            }, a);
            a.a = {};
        }
        mj.prototype.o = function() {
            mj.K.o.call(this);
            pj(this);
        };
        mj.prototype.handleEvent = function() {
            throw Error("EventHandler.handleEvent not implemented");
        };
        function qj(a) {
            E.call(this);
            this.a = null;
            this.g = a;
            a = z || bc || ec && !mc("531") && "TEXTAREA" == a.tagName;
            this.h = new mj(this);
            oj(this.h, this.g, a ? [
                "keydown",
                "paste",
                "cut",
                "drop",
                "input"
            ] : "input", this);
        }
        w(qj, E);
        qj.prototype.handleEvent = function(a) {
            if ("input" == a.type) z && mc(10) && 0 == a.keyCode && 0 == a.j || (rj(this), xe(this, sj(a)));
            else if ("keydown" != a.type || $i(a)) {
                var b = "keydown" == a.type ? this.g.value : null;
                z && 229 == a.keyCode && (b = null);
                var c = sj(a);
                rj(this);
                this.a = lj(function() {
                    this.a = null;
                    this.g.value != b && xe(this, c);
                }, this);
            }
        };
        function rj(a) {
            null != a.a && (n.clearTimeout(a.a), a.a = null);
        }
        function sj(a) {
            a = new Zd(a.a);
            a.type = "input";
            return a;
        }
        qj.prototype.o = function() {
            qj.K.o.call(this);
            this.h.m();
            rj(this);
            delete this.g;
        };
        function tj(a, b) {
            E.call(this);
            a && (this.Oa && uj(this), this.qa = a, this.Na = ke(this.qa, "keypress", this, b), this.Ya = ke(this.qa, "keydown", this.Jb, b, this), this.Oa = ke(this.qa, "keyup", this.Kb, b, this));
        }
        w(tj, E);
        l = tj.prototype;
        l.qa = null;
        l.Na = null;
        l.Ya = null;
        l.Oa = null;
        l.R = -1;
        l.X = -1;
        l.Ua = !1;
        var vj = {
            3: 13,
            12: 144,
            63232: 38,
            63233: 40,
            63234: 37,
            63235: 39,
            63236: 112,
            63237: 113,
            63238: 114,
            63239: 115,
            63240: 116,
            63241: 117,
            63242: 118,
            63243: 119,
            63244: 120,
            63245: 121,
            63246: 122,
            63247: 123,
            63248: 44,
            63272: 46,
            63273: 36,
            63275: 35,
            63276: 33,
            63277: 34,
            63289: 144,
            63302: 45
        }, wj = {
            Up: 38,
            Down: 40,
            Left: 37,
            Right: 39,
            Enter: 13,
            F1: 112,
            F2: 113,
            F3: 114,
            F4: 115,
            F5: 116,
            F6: 117,
            F7: 118,
            F8: 119,
            F9: 120,
            F10: 121,
            F11: 122,
            F12: 123,
            "U+007F": 46,
            Home: 36,
            End: 35,
            PageUp: 33,
            PageDown: 34,
            Insert: 45
        }, xj = !ec || mc("525"), yj = gc && dc;
        l = tj.prototype;
        l.Jb = function(a) {
            if (ec || bc) {
                if (17 == this.R && !a.ctrlKey || 18 == this.R && !a.altKey || gc && 91 == this.R && !a.metaKey) this.X = this.R = -1;
            }
            -1 == this.R && (a.ctrlKey && 17 != a.keyCode ? this.R = 17 : a.altKey && 18 != a.keyCode ? this.R = 18 : a.metaKey && 91 != a.keyCode && (this.R = 91));
            xj && !bj(a.keyCode, this.R, a.shiftKey, a.ctrlKey, a.altKey, a.metaKey) ? this.handleEvent(a) : (this.X = cj(a.keyCode), yj && (this.Ua = a.altKey));
        };
        l.Kb = function(a) {
            this.X = this.R = -1;
            this.Ua = a.altKey;
        };
        l.handleEvent = function(a) {
            var b = a.a, c = b.altKey;
            if (z && "keypress" == a.type) {
                var d = this.X;
                var e = 13 != d && 27 != d ? b.keyCode : 0;
            } else (ec || bc) && "keypress" == a.type ? (d = this.X, e = 0 <= b.charCode && 63232 > b.charCode && aj(d) ? b.charCode : 0) : ac && !ec ? (d = this.X, e = aj(d) ? b.keyCode : 0) : ("keypress" == a.type ? (yj && (c = this.Ua), b.keyCode == b.charCode ? 32 > b.keyCode ? (d = b.keyCode, e = 0) : (d = this.X, e = b.charCode) : (d = b.keyCode || this.X, e = b.charCode || 0)) : (d = b.keyCode || this.X, e = b.charCode || 0), gc && 63 == e && 224 == d && (d = 191));
            var f = d = cj(d);
            d ? 63232 <= d && d in vj ? f = vj[d] : 25 == d && a.shiftKey && (f = 9) : b.keyIdentifier && b.keyIdentifier in wj && (f = wj[b.keyIdentifier]);
            dc && xj && "keypress" == a.type && !bj(f, this.R, a.shiftKey, a.ctrlKey, c, a.metaKey) || (a = f == this.R, this.R = f, b = new zj(f, e, a, b), b.altKey = c, xe(this, b));
        };
        l.N = function() {
            return this.qa;
        };
        function uj(a) {
            a.Na && (te(a.Na), te(a.Ya), te(a.Oa), a.Na = null, a.Ya = null, a.Oa = null);
            a.qa = null;
            a.R = -1;
            a.X = -1;
        }
        l.o = function() {
            tj.K.o.call(this);
            uj(this);
        };
        function zj(a, b, c, d) {
            Zd.call(this, d);
            this.type = "key";
            this.keyCode = a;
            this.j = b;
            this.repeat = c;
        }
        w(zj, Zd);
        function Aj(a, b, c, d) {
            this.top = a;
            this.right = b;
            this.bottom = c;
            this.left = d;
        }
        Aj.prototype.toString = function() {
            return "(" + this.top + "t, " + this.right + "r, " + this.bottom + "b, " + this.left + "l)";
        };
        Aj.prototype.ceil = function() {
            this.top = Math.ceil(this.top);
            this.right = Math.ceil(this.right);
            this.bottom = Math.ceil(this.bottom);
            this.left = Math.ceil(this.left);
            return this;
        };
        Aj.prototype.floor = function() {
            this.top = Math.floor(this.top);
            this.right = Math.floor(this.right);
            this.bottom = Math.floor(this.bottom);
            this.left = Math.floor(this.left);
            return this;
        };
        Aj.prototype.round = function() {
            this.top = Math.round(this.top);
            this.right = Math.round(this.right);
            this.bottom = Math.round(this.bottom);
            this.left = Math.round(this.left);
            return this;
        };
        function Bj(a, b) {
            var c = Sc(a);
            return c.defaultView && c.defaultView.getComputedStyle && (a = c.defaultView.getComputedStyle(a, null)) ? a[b] || a.getPropertyValue(b) || "" : "";
        }
        function Cj(a) {
            try {
                var b = a.getBoundingClientRect();
            } catch (c) {
                return {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                };
            }
            z && a.ownerDocument.body && (a = a.ownerDocument, b.left -= a.documentElement.clientLeft + a.body.clientLeft, b.top -= a.documentElement.clientTop + a.body.clientTop);
            return b;
        }
        function Dj(a, b) {
            b = b || Yc(document);
            var c = b || Yc(document);
            var d = Ej(a), e = Ej(c);
            if (!z || 9 <= Number(nc)) {
                g = Bj(c, "borderLeftWidth");
                var f = Bj(c, "borderRightWidth");
                h = Bj(c, "borderTopWidth");
                k = Bj(c, "borderBottomWidth");
                f = new Aj(parseFloat(h), parseFloat(f), parseFloat(k), parseFloat(g));
            } else {
                var g = Fj(c, "borderLeft");
                f = Fj(c, "borderRight");
                var h = Fj(c, "borderTop"), k = Fj(c, "borderBottom");
                f = new Aj(h, f, k, g);
            }
            c == Yc(document) ? (g = d.a - c.scrollLeft, d = d.g - c.scrollTop, !z || 10 <= Number(nc) || (g += f.left, d += f.top)) : (g = d.a - e.a - f.left, d = d.g - e.g - f.top);
            e = a.offsetWidth;
            f = a.offsetHeight;
            h = ec && !e && !f;
            ka(e) && !h || !a.getBoundingClientRect ? a = new Pc(e, f) : (a = Cj(a), a = new Pc(a.right - a.left, a.bottom - a.top));
            e = c.clientHeight - a.height;
            f = c.scrollLeft;
            h = c.scrollTop;
            f += Math.min(g, Math.max(g - (c.clientWidth - a.width), 0));
            h += Math.min(d, Math.max(d - e, 0));
            c = new Oc(f, h);
            b.scrollLeft = c.a;
            b.scrollTop = c.g;
        }
        function Ej(a) {
            var b = Sc(a), c = new Oc(0, 0);
            var d = b ? Sc(b) : document;
            d = !z || 9 <= Number(nc) || "CSS1Compat" == Qc(d).a.compatMode ? d.documentElement : d.body;
            if (a == d) return c;
            a = Cj(a);
            d = Qc(b).a;
            b = Yc(d);
            d = d.parentWindow || d.defaultView;
            b = z && mc("10") && d.pageYOffset != b.scrollTop ? new Oc(b.scrollLeft, b.scrollTop) : new Oc(d.pageXOffset || b.scrollLeft, d.pageYOffset || b.scrollTop);
            c.a = a.left + b.a;
            c.g = a.top + b.g;
            return c;
        }
        var Gj = {
            thin: 2,
            medium: 4,
            thick: 6
        };
        function Fj(a, b) {
            if ("none" == (a.currentStyle ? a.currentStyle[b + "Style"] : null)) return 0;
            var c = a.currentStyle ? a.currentStyle[b + "Width"] : null;
            if (c in Gj) a = Gj[c];
            else if (/^\d+px?$/.test(c)) a = parseInt(c, 10);
            else {
                b = a.style.left;
                var d = a.runtimeStyle.left;
                a.runtimeStyle.left = a.currentStyle.left;
                a.style.left = c;
                c = a.style.pixelLeft;
                a.style.left = b;
                a.runtimeStyle.left = d;
                a = +c;
            }
            return a;
        }
        function Hj() {}
        oa(Hj);
        Hj.prototype.a = 0;
        function Ij(a) {
            E.call(this);
            this.s = a || Qc();
            this.cb = null;
            this.na = !1;
            this.g = null;
            this.L = void 0;
            this.oa = this.Ea = this.Y = null;
        }
        w(Ij, E);
        l = Ij.prototype;
        l.Lb = Hj.Xa();
        l.N = function() {
            return this.g;
        };
        function M(a, b) {
            return a.g ? Vc(b, a.g || a.s.a) : null;
        }
        function Jj(a) {
            a.L || (a.L = new mj(a));
            return a.L;
        }
        l.Za = function(a) {
            if (this.Y && this.Y != a) throw Error("Method not supported");
            Ij.K.Za.call(this, a);
        };
        l.kb = function() {
            this.g = this.s.a.createElement("DIV");
        };
        l.render = function(a) {
            if (this.na) throw Error("Component already rendered");
            this.g || this.kb();
            a ? a.insertBefore(this.g, null) : this.s.a.body.appendChild(this.g);
            this.Y && !this.Y.na || this.v();
        };
        l.v = function() {
            this.na = !0;
            Kj(this, function(a) {
                !a.na && a.N() && a.v();
            });
        };
        l.ya = function() {
            Kj(this, function(a) {
                a.na && a.ya();
            });
            this.L && pj(this.L);
            this.na = !1;
        };
        l.o = function() {
            this.na && this.ya();
            this.L && (this.L.m(), delete this.L);
            Kj(this, function(a) {
                a.m();
            });
            this.g && Zc(this.g);
            this.Y = this.g = this.oa = this.Ea = null;
            Ij.K.o.call(this);
        };
        function Kj(a, b) {
            a.Ea && Ha(a.Ea, b, void 0);
        }
        l.removeChild = function(a, b) {
            if (a) {
                var c = q(a) ? a : a.cb || (a.cb = ":" + (a.Lb.a++).toString(36));
                this.oa && c ? (a = this.oa, a = (null !== a && c in a ? a[c] : void 0) || null) : a = null;
                if (c && a) {
                    var d = this.oa;
                    c in d && delete d[c];
                    Na(this.Ea, a);
                    b && (a.ya(), a.g && Zc(a.g));
                    b = a;
                    if (null == b) throw Error("Unable to set parent component");
                    b.Y = null;
                    Ij.K.Za.call(b, null);
                }
            }
            if (!a) throw Error("Child is not in parent component");
            return a;
        };
        function N(a, b) {
            var c = ad(a, "firebaseui-textfield");
            b ? (Xi(a, "firebaseui-input-invalid"), Wi(a, "firebaseui-input"), c && Xi(c, "firebaseui-textfield-invalid")) : (Xi(a, "firebaseui-input"), Wi(a, "firebaseui-input-invalid"), c && Wi(c, "firebaseui-textfield-invalid"));
        }
        function Lj(a, b, c) {
            b = new qj(b);
            Sd(a, za(Td, b));
            oj(Jj(a), b, "input", c);
        }
        function Mj(a, b, c) {
            b = new tj(b);
            Sd(a, za(Td, b));
            oj(Jj(a), b, "key", function(d) {
                13 == d.keyCode && (d.stopPropagation(), d.preventDefault(), c(d));
            });
        }
        function Nj(a, b, c) {
            b = new ij(b);
            Sd(a, za(Td, b));
            oj(Jj(a), b, "focusin", c);
        }
        function Oj(a, b, c) {
            b = new ij(b);
            Sd(a, za(Td, b));
            oj(Jj(a), b, "focusout", c);
        }
        function O(a, b, c) {
            b = new ej(b);
            Sd(a, za(Td, b));
            oj(Jj(a), b, "action", function(d) {
                d.stopPropagation();
                d.preventDefault();
                c(d);
            });
        }
        function Pj(a) {
            Wi(a, "firebaseui-hidden");
        }
        function Qj(a, b) {
            b && $c(a, b);
            Xi(a, "firebaseui-hidden");
        }
        function Rj(a) {
            return !Vi(a, "firebaseui-hidden") && "none" != a.style.display;
        }
        function Sj(a) {
            a = a || {};
            var b = a.email, c = a.disabled, d = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-email-input">';
            d = a.xc ? d + "Enter new email address" : d + "Email";
            d += '</label><input type="email" name="email" id="ui-sign-in-email-input" autocomplete="username" class="mdl-textfield__input firebaseui-input firebaseui-id-email" value="' + ud(null != b ? b : "") + '"' + (c ? "disabled" : "") + '></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-email-error"></p></div>';
            return B(d);
        }
        function Tj(a) {
            a = a || {};
            a = a.label;
            var b = '<button type="submit" class="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">';
            b = a ? b + A(a) : b + "Next";
            return B(b + "</button>");
        }
        function Uj() {
            var a = "" + Tj({
                label: D("Sign In")
            });
            return B(a);
        }
        function Vj() {
            var a = "" + Tj({
                label: D("Save")
            });
            return B(a);
        }
        function Wj() {
            var a = "" + Tj({
                label: D("Continue")
            });
            return B(a);
        }
        function Xj(a) {
            a = a || {};
            a = a.label;
            var b = '<div class="firebaseui-new-password-component"><div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-new-password-input">';
            b = a ? b + A(a) : b + "Choose password";
            return B(b + '</label><input type="password" name="newPassword" id="ui-sign-in-new-password-input" autocomplete="new-password" class="mdl-textfield__input firebaseui-input firebaseui-id-new-password"></div><a href="javascript:void(0)" class="firebaseui-input-floating-button firebaseui-id-password-toggle firebaseui-input-toggle-on firebaseui-input-toggle-blur"></a><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-new-password-error"></p></div></div>');
        }
        function Yj() {
            var a = {};
            var b = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-password-input">';
            b = a.current ? b + "Current password" : b + "Password";
            return B(b + '</label><input type="password" name="password" id="ui-sign-in-password-input" autocomplete="current-password" class="mdl-textfield__input firebaseui-input firebaseui-id-password"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-password-error"></p></div>');
        }
        function Zj() {
            return B('<a class="firebaseui-link firebaseui-id-secondary-link" href="javascript:void(0)">Trouble signing in?</a>');
        }
        function ak(a) {
            a = a || {};
            a = a.label;
            var b = '<button class="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--primary">';
            b = a ? b + A(a) : b + "Cancel";
            return B(b + "</button>");
        }
        function bk(a) {
            var b = "";
            a.F && a.D && (b += '<ul class="firebaseui-tos-list firebaseui-tos"><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a></li><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a></li></ul>');
            return B(b);
        }
        function ck(a) {
            var b = "";
            a.F && a.D && (b += '<p class="firebaseui-tos firebaseui-tospp-full-message">By continuing, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>.</p>');
            return B(b);
        }
        function dk(a) {
            a = '<div class="firebaseui-info-bar firebaseui-id-info-bar"><p class="firebaseui-info-bar-message">' + A(a.message) + '&nbsp;&nbsp;<a href="javascript:void(0)" class="firebaseui-link firebaseui-id-dismiss-info-bar">Dismiss</a></p></div>';
            return B(a);
        }
        dk.a = "firebaseui.auth.soy2.element.infoBar";
        function ek(a) {
            var b = a.content;
            a = a.Ab;
            return B('<dialog class="mdl-dialog firebaseui-dialog firebaseui-id-dialog' + (a ? " " + ud(a) : "") + '">' + A(b) + "</dialog>");
        }
        function fk(a) {
            var b = a.message;
            return B(ek({
                content: td('<div class="firebaseui-dialog-icon-wrapper"><div class="' + ud(a.Ma) + ' firebaseui-dialog-icon"></div></div><div class="firebaseui-progress-dialog-message">' + A(b) + "</div>")
            }));
        }
        fk.a = "firebaseui.auth.soy2.element.progressDialog";
        function gk(a) {
            var b = '<div class="firebaseui-list-box-actions">';
            a = a.items;
            for(var c = a.length, d = 0; d < c; d++){
                var e = a[d];
                b += '<button type="button" data-listboxid="' + ud(e.id) + '" class="mdl-button firebaseui-id-list-box-dialog-button firebaseui-list-box-dialog-button">' + (e.Ma ? '<div class="firebaseui-list-box-icon-wrapper"><div class="firebaseui-list-box-icon ' + ud(e.Ma) + '"></div></div>' : "") + '<div class="firebaseui-list-box-label-wrapper">' + A(e.label) + "</div></button>";
            }
            b = "" + ek({
                Ab: D("firebaseui-list-box-dialog"),
                content: td(b + "</div>")
            });
            return B(b);
        }
        gk.a = "firebaseui.auth.soy2.element.listBoxDialog";
        function hk(a) {
            a = a || {};
            return B(a.tb ? '<div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>' : '<div class="mdl-progress mdl-js-progress mdl-progress__indeterminate firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>');
        }
        hk.a = "firebaseui.auth.soy2.element.busyIndicator";
        function ik(a, b) {
            a = a || {};
            a = a.ga;
            return C(a.S ? a.S : b.hb[a.providerId] ? "" + b.hb[a.providerId] : a.providerId && 0 == a.providerId.indexOf("saml.") ? a.providerId.substring(5) : a.providerId && 0 == a.providerId.indexOf("oidc.") ? a.providerId.substring(5) : "" + a.providerId);
        }
        function jk(a) {
            kk(a, "upgradeElement");
        }
        function lk(a) {
            kk(a, "downgradeElements");
        }
        var mk = [
            "mdl-js-textfield",
            "mdl-js-progress",
            "mdl-js-spinner",
            "mdl-js-button"
        ];
        function kk(a, b) {
            a && window.componentHandler && window.componentHandler[b] && mk.forEach(function(c) {
                if (Vi(a, c)) window.componentHandler[b](a);
                Ha(Tc(c, a), function(d) {
                    window.componentHandler[b](d);
                });
            });
        }
        function nk(a, b, c) {
            ok.call(this);
            document.body.appendChild(a);
            a.showModal || window.dialogPolyfill.registerDialog(a);
            a.showModal();
            jk(a);
            b && O(this, a, function(f) {
                var g = a.getBoundingClientRect();
                (f.clientX < g.left || g.left + g.width < f.clientX || f.clientY < g.top || g.top + g.height < f.clientY) && ok.call(this);
            });
            if (!c) {
                var d = this.N().parentElement || this.N().parentNode;
                if (d) {
                    var e = this;
                    this.da = function() {
                        if (a.open) {
                            var f = a.getBoundingClientRect().height, g = d.getBoundingClientRect().height, h = d.getBoundingClientRect().top - document.body.getBoundingClientRect().top, k = d.getBoundingClientRect().left - document.body.getBoundingClientRect().left, p = a.getBoundingClientRect().width, t = d.getBoundingClientRect().width;
                            a.style.top = (h + (g - f) / 2).toString() + "px";
                            f = k + (t - p) / 2;
                            a.style.left = f.toString() + "px";
                            a.style.right = (document.body.getBoundingClientRect().width - f - p).toString() + "px";
                        } else window.removeEventListener("resize", e.da);
                    };
                    this.da();
                    window.addEventListener("resize", this.da, !1);
                }
            }
        }
        function ok() {
            var a = pk.call(this);
            a && (lk(a), a.open && a.close(), Zc(a), this.da && window.removeEventListener("resize", this.da));
        }
        function pk() {
            return Vc("firebaseui-id-dialog");
        }
        function qk() {
            Zc(rk.call(this));
        }
        function rk() {
            return M(this, "firebaseui-id-info-bar");
        }
        function sk() {
            return M(this, "firebaseui-id-dismiss-info-bar");
        }
        var tk = {
            xa: {
                "google.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
                "github.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/github.svg",
                "facebook.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg",
                "twitter.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/twitter.svg",
                password: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg",
                phone: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/phone.svg",
                anonymous: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/anonymous.png",
                "microsoft.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/microsoft.svg",
                "yahoo.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/yahoo.svg",
                "apple.com": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/apple.png",
                saml: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/saml.svg",
                oidc: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/oidc.svg"
            },
            wa: {
                "google.com": "#ffffff",
                "github.com": "#333333",
                "facebook.com": "#3b5998",
                "twitter.com": "#55acee",
                password: "#db4437",
                phone: "#02bd7e",
                anonymous: "#f4b400",
                "microsoft.com": "#2F2F2F",
                "yahoo.com": "#720E9E",
                "apple.com": "#000000",
                saml: "#007bff",
                oidc: "#007bff"
            },
            hb: {
                "google.com": "Google",
                "github.com": "GitHub",
                "facebook.com": "Facebook",
                "twitter.com": "Twitter",
                password: "Password",
                phone: "Phone",
                anonymous: "Guest",
                "microsoft.com": "Microsoft",
                "yahoo.com": "Yahoo",
                "apple.com": "Apple"
            }
        };
        function uk(a, b, c) {
            Yd.call(this, a, b);
            for(var d in c)this[d] = c[d];
        }
        w(uk, Yd);
        function P(a, b, c, d, e) {
            Ij.call(this, c);
            this.fb = a;
            this.eb = b;
            this.Fa = !1;
            this.Ga = d || null;
            this.A = this.ca = null;
            this.Z = eb(tk);
            gb(this.Z, e || {});
        }
        w(P, Ij);
        l = P.prototype;
        l.kb = function() {
            var a = hd(this.fb, this.eb, this.Z, this.s);
            jk(a);
            this.g = a;
        };
        l.v = function() {
            P.K.v.call(this);
            Be(Q(this), new uk("pageEnter", Q(this), {
                pageId: this.Ga
            }));
            if (this.bb() && this.Z.F) {
                var a = this.Z.F;
                O(this, this.bb(), function() {
                    a();
                });
            }
            if (this.ab() && this.Z.D) {
                var b = this.Z.D;
                O(this, this.ab(), function() {
                    b();
                });
            }
        };
        l.ya = function() {
            Be(Q(this), new uk("pageExit", Q(this), {
                pageId: this.Ga
            }));
            P.K.ya.call(this);
        };
        l.o = function() {
            window.clearTimeout(this.ca);
            this.eb = this.fb = this.ca = null;
            this.Fa = !1;
            this.A = null;
            lk(this.N());
            P.K.o.call(this);
        };
        function vk(a) {
            a.Fa = !0;
            var b = Vi(a.N(), "firebaseui-use-spinner");
            a.ca = window.setTimeout(function() {
                a.N() && null === a.A && (a.A = hd(hk, {
                    tb: b
                }, null, a.s), a.N().appendChild(a.A), jk(a.A));
            }, 500);
        }
        l.I = function(a, b, c, d) {
            function e() {
                if (f.T) return null;
                f.Fa = !1;
                window.clearTimeout(f.ca);
                f.ca = null;
                f.A && (lk(f.A), Zc(f.A), f.A = null);
            }
            var f = this;
            if (f.Fa) return null;
            vk(f);
            return a.apply(null, b).then(c, d).then(e, e);
        };
        function Q(a) {
            return a.N().parentElement || a.N().parentNode;
        }
        function wk(a, b, c) {
            Mj(a, b, function() {
                c.focus();
            });
        }
        function xk(a, b, c) {
            Mj(a, b, function() {
                c();
            });
        }
        u(P.prototype, {
            a: function(a) {
                qk.call(this);
                var b = hd(dk, {
                    message: a
                }, null, this.s);
                this.N().appendChild(b);
                O(this, sk.call(this), function() {
                    Zc(b);
                });
            },
            zc: qk,
            Bc: rk,
            Ac: sk,
            $: function(a, b) {
                a = hd(fk, {
                    Ma: a,
                    message: b
                }, null, this.s);
                nk.call(this, a);
            },
            h: ok,
            Cb: pk,
            Dc: function() {
                return M(this, "firebaseui-tos");
            },
            bb: function() {
                return M(this, "firebaseui-tos-link");
            },
            ab: function() {
                return M(this, "firebaseui-pp-link");
            },
            Ec: function() {
                return M(this, "firebaseui-tos-list");
            }
        });
        function yk(a, b, c) {
            a = a || {};
            b = a.Va;
            var d = a.ia;
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in with email</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + Sj(a) + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? ak(null) : "") + Tj(null) + '</div></div><div class="firebaseui-card-footer">' + (d ? ck(c) : bk(c)) + "</div></form></div>";
            return B(a);
        }
        yk.a = "firebaseui.auth.soy2.page.signIn";
        function zk(a, b, c) {
            a = a || {};
            b = a.ia;
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content">' + Sj(a) + Yj() + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + Zj() + '</div><div class="firebaseui-form-actions">' + Uj() + '</div></div><div class="firebaseui-card-footer">' + (b ? ck(c) : bk(c)) + "</div></form></div>";
            return B(a);
        }
        zk.a = "firebaseui.auth.soy2.page.passwordSignIn";
        function Ak(a, b, c) {
            a = a || {};
            var d = a.Tb;
            b = a.Ta;
            var e = a.ia, f = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-up"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Create account</h1></div><div class="firebaseui-card-content">' + Sj(a);
            d ? (a = a || {}, a = a.name, a = '<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-name-input">First &amp; last name</label><input type="text" name="name" id="ui-sign-in-name-input" autocomplete="name" class="mdl-textfield__input firebaseui-input firebaseui-id-name" value="' + ud(null != a ? a : "") + '"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-name-error"></p></div>', a = B(a)) : a = "";
            c = f + a + Xj(null) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? ak(null) : "") + Vj() + '</div></div><div class="firebaseui-card-footer">' + (e ? ck(c) : bk(c)) + "</div></form></div>";
            return B(c);
        }
        Ak.a = "firebaseui.auth.soy2.page.passwordSignUp";
        function Bk(a, b, c) {
            a = a || {};
            b = a.Ta;
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Recover password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Get instructions sent to this email that explain how to reset your password</p>' + Sj(a) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (b ? ak(null) : "") + Tj({
                label: D("Send")
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(a);
        }
        Bk.a = "firebaseui.auth.soy2.page.passwordRecovery";
        function Ck(a, b, c) {
            b = a.G;
            var d = "";
            a = "Follow the instructions sent to <strong>" + (A(a.email) + "</strong> to recover your password");
            d += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery-email-sent"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Check your email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions">';
            b && (d += '<div class="firebaseui-form-actions">' + Tj({
                label: D("Done")
            }) + "</div>");
            d += '</div><div class="firebaseui-card-footer">' + bk(c) + "</div></div>";
            return B(d);
        }
        Ck.a = "firebaseui.auth.soy2.page.passwordRecoveryEmailSent";
        function Dk(a, b, c) {
            return B('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-callback"><div class="firebaseui-callback-indicator-container">' + hk(null, null, c) + "</div></div>");
        }
        Dk.a = "firebaseui.auth.soy2.page.callback";
        function Ek(a, b, c) {
            return B('<div class="firebaseui-container firebaseui-id-page-spinner">' + hk({
                tb: !0
            }, null, c) + "</div>");
        }
        Ek.a = "firebaseui.auth.soy2.page.spinner";
        function Fk() {
            return B('<div class="firebaseui-container firebaseui-id-page-blank firebaseui-use-spinner"></div>');
        }
        Fk.a = "firebaseui.auth.soy2.page.blank";
        function Gk(a, b, c) {
            b = "";
            a = "A sign-in email with additional instructions was sent to <strong>" + (A(a.email) + "</strong>. Check your email to complete sign-in.");
            var d = B('<a class="firebaseui-link firebaseui-id-trouble-getting-email-link" href="javascript:void(0)">Trouble getting email?</a>');
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-sent"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign-in email sent</h1></div><div class="firebaseui-card-content"><div class="firebaseui-email-sent"></div><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + d + '</div><div class="firebaseui-form-actions">' + ak({
                label: D("Back")
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(b);
        }
        Gk.a = "firebaseui.auth.soy2.page.emailLinkSignInSent";
        function Hk(a, b, c) {
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-not-received"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Trouble getting email?</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try these common fixes:<ul><li>Check if the email was marked as spam or filtered.</li><li>Check your internet connection.</li><li>Check that you did not misspell your email.</li><li>Check that your inbox space is not running out or other inbox settings related issues.</li></ul></p><p class="firebaseui-text">If the steps above didn\'t work, you can resend the email. Note that this will deactivate the link in the older email.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + B('<a class="firebaseui-link firebaseui-id-resend-email-link" href="javascript:void(0)">Resend</a>') + '</div><div class="firebaseui-form-actions">' + ak({
                label: D("Back")
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(a);
        }
        Hk.a = "firebaseui.auth.soy2.page.emailNotReceived";
        function Ik(a, b, c) {
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-confirmation"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Confirm email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Confirm your email to complete sign in</p><div class="firebaseui-relative-wrapper">' + Sj(a) + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ak(null) + Tj(null) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(a);
        }
        Ik.a = "firebaseui.auth.soy2.page.emailLinkSignInConfirmation";
        function Jk() {
            var a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-different-device-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">New device or browser detected</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try opening the link using the same device or browser where you started the sign-in process.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ak({
                label: D("Dismiss")
            }) + "</div></div></div>";
            return B(a);
        }
        Jk.a = "firebaseui.auth.soy2.page.differentDeviceError";
        function Kk() {
            var a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-anonymous-user-mismatch"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Session ended</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">The session associated with this sign-in request has either expired or was cleared.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ak({
                label: D("Dismiss")
            }) + "</div></div></div>";
            return B(a);
        }
        Kk.a = "firebaseui.auth.soy2.page.anonymousUserMismatch";
        function Lk(a, b, c) {
            b = "";
            a = "You’ve already used <strong>" + (A(a.email) + "</strong> to sign in. Enter your password for that account.");
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">' + a + "</p>" + Yj() + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">' + Zj() + '</div><div class="firebaseui-form-actions">' + Uj() + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(b);
        }
        Lk.a = "firebaseui.auth.soy2.page.passwordLinking";
        function Mk(a, b, c) {
            var d = a.email;
            b = "";
            a = "" + ik(a, c);
            a = D(a);
            d = "You’ve already used <strong>" + (A(d) + ("</strong>. You can connect your <strong>" + (A(a) + ("</strong> account with <strong>" + (A(d) + "</strong> by signing in with email link below.")))));
            a = "For this flow to successfully connect your " + (A(a) + " account with this email, you have to open the link on the same device or browser.");
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text firebaseui-text-justify">' + d + '<p class="firebaseui-text firebaseui-text-justify">' + a + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Uj() + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(b);
        }
        Mk.a = "firebaseui.auth.soy2.page.emailLinkSignInLinking";
        function Nk(a, b, c) {
            b = "";
            var d = "" + ik(a, c);
            d = D(d);
            a = "You originally intended to connect <strong>" + (A(d) + "</strong> to your email account but have opened the link on a different device where you are not signed in.");
            d = "If you still want to connect your <strong>" + (A(d) + "</strong> account, open the link on the same device where you started sign-in. Otherwise, tap Continue to sign-in on this device.");
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking-different-device"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text firebaseui-text-justify">' + a + '</p><p class="firebaseui-text firebaseui-text-justify">' + d + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Wj() + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(b);
        }
        Nk.a = "firebaseui.auth.soy2.page.emailLinkSignInLinkingDifferentDevice";
        function Ok(a, b, c) {
            var d = a.email;
            b = "";
            a = "" + ik(a, c);
            a = D(a);
            d = "You’ve already used <strong>" + (A(d) + ("</strong>. Sign in with " + (A(a) + " to continue.")));
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-federated-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">' + d + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Tj({
                label: D("Sign in with " + a)
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(b);
        }
        Ok.a = "firebaseui.auth.soy2.page.federatedLinking";
        function Pk(a, b, c) {
            a = a || {};
            var d = a.kc;
            b = a.yb;
            a = a.Eb;
            var e = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unauthorized-user"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Not Authorized</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">';
            d ? (d = "<strong>" + (A(d) + "</strong> is not authorized to view the requested page."), e += d) : e += "User is not authorized to view the requested page.";
            e += "</p>";
            b && (b = "Please contact <strong>" + (A(b) + "</strong> for authorization."), e += '<p class="firebaseui-text firebaseui-id-unauthorized-user-admin-email">' + b + "</p>");
            e += '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">';
            a && (e += '<a class="firebaseui-link firebaseui-id-unauthorized-user-help-link" href="javascript:void(0)" target="_blank">Learn More</a>');
            e += '</div><div class="firebaseui-form-actions">' + ak({
                label: D("Back")
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(e);
        }
        Pk.a = "firebaseui.auth.soy2.page.unauthorizedUser";
        function Qk(a, b, c) {
            b = "";
            a = "To continue sign in with <strong>" + (A(a.email) + "</strong> on this device, you have to recover the password.");
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unsupported-provider"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ak(null) + Tj({
                label: D("Recover password")
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(b);
        }
        Qk.a = "firebaseui.auth.soy2.page.unsupportedProvider";
        function Rk(a) {
            var b = "", c = '<p class="firebaseui-text">for <strong>' + (A(a.email) + "</strong></p>");
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Reset your password</h1></div><div class="firebaseui-card-content">' + c + Xj(sd(a)) + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Vj() + "</div></div></form></div>";
            return B(b);
        }
        Rk.a = "firebaseui.auth.soy2.page.passwordReset";
        function Sk(a) {
            a = a || {};
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Password changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new password</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(a);
        }
        Sk.a = "firebaseui.auth.soy2.page.passwordResetSuccess";
        function Tk(a) {
            a = a || {};
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try resetting your password again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to reset your password has expired or the link has already been used</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(a);
        }
        Tk.a = "firebaseui.auth.soy2.page.passwordResetFailure";
        function Uk(a) {
            var b = a.G, c = "";
            a = "Your sign-in email address has been changed back to <strong>" + (A(a.email) + "</strong>.");
            c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Updated email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p><p class="firebaseui-text">If you didn’t ask to change your sign-in email, it’s possible someone is trying to access your account and you should <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">change your password right away</a>.</p></div><div class="firebaseui-card-actions">' + (b ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></form></div>";
            return B(c);
        }
        Uk.a = "firebaseui.auth.soy2.page.emailChangeRevokeSuccess";
        function Vk(a) {
            a = a || {};
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Unable to update your email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">There was a problem changing your sign-in email back.</p><p class="firebaseui-text">If you try again and still can’t reset your email, try asking your administrator for help.</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(a);
        }
        Vk.a = "firebaseui.auth.soy2.page.emailChangeRevokeFailure";
        function Wk(a) {
            a = a || {};
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new account</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(a);
        }
        Wk.a = "firebaseui.auth.soy2.page.emailVerificationSuccess";
        function Yk(a) {
            a = a || {};
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try verifying your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify your email has expired or the link has already been used</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(a);
        }
        Yk.a = "firebaseui.auth.soy2.page.emailVerificationFailure";
        function Zk(a) {
            var b = a.G, c = "";
            a = "You can now sign in with your new email <strong>" + (A(a.email) + "</strong>.");
            c += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-verify-and-change-email-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified and changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + '</p></div><div class="firebaseui-card-actions">' + (b ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(c);
        }
        Zk.a = "firebaseui.auth.soy2.page.verifyAndChangeEmailSuccess";
        function $k(a) {
            a = a || {};
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-verify-and-change-email-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try updating your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify and update your email has expired or the link has already been used.</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(a);
        }
        $k.a = "firebaseui.auth.soy2.page.verifyAndChangeEmailFailure";
        function al(a) {
            var b = a.factorId, c = a.phoneNumber;
            a = a.G;
            var d = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-revert-second-factor-addition-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Removed second factor</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">';
            switch(b){
                case "phone":
                    b = "The <strong>" + (A(b) + (" " + (A(c) + "</strong> was removed as a second authentication step.")));
                    d += b;
                    break;
                default:
                    d += "The device or app was removed as a second authentication step.";
            }
            d += '</p><p class="firebaseui-text">If you don\'t recognize this device, someone might be trying to access your account. Consider <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">changing your password right away</a>.</p></div><div class="firebaseui-card-actions">' + (a ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></form></div>";
            return B(d);
        }
        al.a = "firebaseui.auth.soy2.page.revertSecondFactorAdditionSuccess";
        function bl(a) {
            a = a || {};
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-revert-second-factor-addition-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Couldn\'t remove your second factor</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Something went wrong removing your second factor.</p><p class="firebaseui-text">Try removing it again. If that doesn\'t work, contact support for assistance.</p></div><div class="firebaseui-card-actions">' + (a.G ? '<div class="firebaseui-form-actions">' + Wj() + "</div>" : "") + "</div></div>";
            return B(a);
        }
        bl.a = "firebaseui.auth.soy2.page.revertSecondFactorAdditionFailure";
        function cl(a) {
            var b = a.zb;
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-recoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + A(a.errorMessage) + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">';
            b && (a += Tj({
                label: D("Retry")
            }));
            return B(a + "</div></div></div>");
        }
        cl.a = "firebaseui.auth.soy2.page.recoverableError";
        function dl(a) {
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unrecoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + A(a.errorMessage) + "</p></div></div>";
            return B(a);
        }
        dl.a = "firebaseui.auth.soy2.page.unrecoverableError";
        function el(a, b, c) {
            var d = a.Qb;
            b = "";
            a = "Continue with " + (A(a.jc) + "?");
            d = "You originally wanted to sign in with " + A(d);
            b += '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-mismatch"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">' + a + '</h2><p class="firebaseui-text">' + d + '</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ak(null) + Tj({
                label: D("Continue")
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form></div>";
            return B(b);
        }
        el.a = "firebaseui.auth.soy2.page.emailMismatch";
        function fl(a, b, c) {
            var d = '<div class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-idp-list">';
            a = a.Sb;
            b = a.length;
            for(var e = 0; e < b; e++){
                var f = {
                    ga: a[e]
                }, g = c;
                f = f || {};
                var h = f.ga;
                var k = f;
                k = k || {};
                var p = "";
                switch(k.ga.providerId){
                    case "google.com":
                        p += "firebaseui-idp-google";
                        break;
                    case "github.com":
                        p += "firebaseui-idp-github";
                        break;
                    case "facebook.com":
                        p += "firebaseui-idp-facebook";
                        break;
                    case "twitter.com":
                        p += "firebaseui-idp-twitter";
                        break;
                    case "phone":
                        p += "firebaseui-idp-phone";
                        break;
                    case "anonymous":
                        p += "firebaseui-idp-anonymous";
                        break;
                    case "password":
                        p += "firebaseui-idp-password";
                        break;
                    default:
                        p += "firebaseui-idp-generic";
                }
                k = '<button class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised ' + ud(C(p)) + ' firebaseui-id-idp-button" data-provider-id="' + ud(h.providerId) + '" style="background-color:';
                p = (p = f) || {};
                p = p.ga;
                k = k + ud(Dd(C(p.ta ? p.ta : g.wa[p.providerId] ? "" + g.wa[p.providerId] : 0 == p.providerId.indexOf("saml.") ? "" + g.wa.saml : 0 == p.providerId.indexOf("oidc.") ? "" + g.wa.oidc : "" + g.wa.password))) + '"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="';
                var t = f;
                p = g;
                t = t || {};
                t = t.ga;
                p = rd(t.za ? zd(t.za) : p.xa[t.providerId] ? zd(p.xa[t.providerId]) : 0 == t.providerId.indexOf("saml.") ? zd(p.xa.saml) : 0 == t.providerId.indexOf("oidc.") ? zd(p.xa.oidc) : zd(p.xa.password));
                k = k + ud(zd(p)) + '"></span>';
                "password" == h.providerId ? (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : h.S ? (f = "Sign in with " + A(ik(f, g)), k += f) : k += "Sign in with email", k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">', k = h.S ? k + A(h.S) : k + "Email", k += "</span>") : "phone" == h.providerId ? (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : h.S ? (f = "Sign in with " + A(ik(f, g)), k += f) : k += "Sign in with phone", k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">', k = h.S ? k + A(h.S) : k + "Phone", k += "</span>") : "anonymous" == h.providerId ? (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : h.S ? (f = "Sign in with " + A(ik(f, g)), k += f) : k += "Continue as guest", k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">', k = h.S ? k + A(h.S) : k + "Guest", k += "</span>") : (k += '<span class="firebaseui-idp-text firebaseui-idp-text-long">', h.V ? k += A(h.V) : (p = "Sign in with " + A(ik(f, g)), k += p), k += '</span><span class="firebaseui-idp-text firebaseui-idp-text-short">' + (h.S ? A(h.S) : A(ik(f, g))) + "</span>");
                h = B(k + "</button>");
                d += '<li class="firebaseui-list-item">' + h + "</li>";
            }
            d += '</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">' + ck(c) + "</div></div>";
            return B(d);
        }
        fl.a = "firebaseui.auth.soy2.page.providerSignIn";
        function gl(a, b, c) {
            a = a || {};
            var d = a.Gb, e = a.Va;
            b = a.ia;
            a = a || {};
            a = a.Aa;
            a = '<div class="firebaseui-phone-number"><button class="firebaseui-id-country-selector firebaseui-country-selector mdl-button mdl-js-button"><span class="firebaseui-flag firebaseui-country-selector-flag firebaseui-id-country-selector-flag"></span><span class="firebaseui-id-country-selector-code"></span></button><div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label firebaseui-textfield firebaseui-phone-input-wrapper"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-number-input">Phone number</label><input type="tel" name="phoneNumber" id="ui-sign-in-phone-number-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-number" value="' + ud(null != a ? a : "") + '"></div></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-phone-number-error firebaseui-id-phone-number-error"></p></div>';
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-start"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Enter your phone number</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + B(a);
            var f;
            d ? f = B('<div class="firebaseui-recaptcha-wrapper"><div class="firebaseui-recaptcha-container"></div><div class="firebaseui-error-wrapper firebaseui-recaptcha-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-recaptcha-error"></p></div></div>') : f = "";
            f = a + f + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + (e ? ak(null) : "") + Tj({
                label: D("Verify")
            }) + '</div></div><div class="firebaseui-card-footer">';
            b ? (b = '<p class="firebaseui-tos firebaseui-phone-tos">', b = c.F && c.D ? b + 'By tapping Verify, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>. An SMS may be sent. Message &amp; data rates may apply.' : b + "By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.", c = B(b + "</p>")) : c = B('<p class="firebaseui-tos firebaseui-phone-sms-notice">By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.</p>') + bk(c);
            return B(f + c + "</div></form></div>");
        }
        gl.a = "firebaseui.auth.soy2.page.phoneSignInStart";
        function hl(a, b, c) {
            a = a || {};
            b = a.phoneNumber;
            var d = "";
            a = 'Enter the 6-digit code we sent to <a class="firebaseui-link firebaseui-change-phone-number-link firebaseui-id-change-phone-number-link" href="javascript:void(0)">&lrm;' + (A(b) + "</a>");
            A(b);
            b = d;
            d = B('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-confirmation-code-input">6-digit code</label><input type="number" name="phoneConfirmationCode" id="ui-sign-in-phone-confirmation-code-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-confirmation-code"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-phone-confirmation-code-error"></p></div>');
            c = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-finish"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Verify your phone number</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">' + a + "</p>" + d + '</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + ak(null) + Tj({
                label: D("Continue")
            }) + '</div></div><div class="firebaseui-card-footer">' + bk(c) + "</div></form>";
            a = B('<div class="firebaseui-resend-container"><span class="firebaseui-id-resend-countdown"></span><a href="javascript:void(0)" class="firebaseui-id-resend-link firebaseui-hidden firebaseui-link">Resend</a></div>');
            return B(b + (c + a + "</div>"));
        }
        hl.a = "firebaseui.auth.soy2.page.phoneSignInFinish";
        function il() {
            return B('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-out"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign Out</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You are now successfully signed out.</p></div></div>');
        }
        il.a = "firebaseui.auth.soy2.page.signOut";
        function jl(a, b, c) {
            var d = '<div class="firebaseui-container firebaseui-page-select-tenant firebaseui-id-page-select-tenant"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-tenant-list">';
            a = a.ec;
            b = a.length;
            for(var e = 0; e < b; e++){
                var f = a[e];
                var g = "";
                var h = A(f.displayName), k = f.tenantId ? f.tenantId : "top-level-project";
                k = D(k);
                g += '<button class="firebaseui-tenant-button mdl-button mdl-js-button mdl-button--raised firebaseui-tenant-selection-' + ud(k) + ' firebaseui-id-tenant-selection-button"' + (f.tenantId ? 'data-tenant-id="' + ud(f.tenantId) + '"' : "") + 'style="background-color:' + ud(Dd(f.ta)) + '"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="' + ud(zd(f.za)) + '"></span><span class="firebaseui-idp-text firebaseui-idp-text-long">';
                f.V ? g += A(f.V) : (f = "Sign in to " + A(f.displayName), g += f);
                g = B(g + ('</span><span class="firebaseui-idp-text firebaseui-idp-text-short">' + h + "</span></button>"));
                d += '<li class="firebaseui-list-item">' + g + "</li>";
            }
            d += '</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">' + ck(c) + "</div></div>";
            return B(d);
        }
        jl.a = "firebaseui.auth.soy2.page.selectTenant";
        function kl(a, b, c) {
            a = '<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-provider-match-by-email"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">' + Sj(null) + '</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">' + Tj(null) + '</div></div><div class="firebaseui-card-footer">' + ck(c) + "</div></form></div>";
            return B(a);
        }
        kl.a = "firebaseui.auth.soy2.page.providerMatchByEmail";
        function ll() {
            return M(this, "firebaseui-id-submit");
        }
        function ml() {
            return M(this, "firebaseui-id-secondary-link");
        }
        function nl(a, b) {
            O(this, ll.call(this), function(d) {
                a(d);
            });
            var c = ml.call(this);
            c && b && O(this, c, function(d) {
                b(d);
            });
        }
        function ol() {
            return M(this, "firebaseui-id-password");
        }
        function pl() {
            return M(this, "firebaseui-id-password-error");
        }
        function ql() {
            var a = ol.call(this), b = pl.call(this);
            Lj(this, a, function() {
                Rj(b) && (N(a, !0), Pj(b));
            });
        }
        function rl() {
            var a = ol.call(this);
            var b = pl.call(this);
            Yi(a) ? (N(a, !0), Pj(b), b = !0) : (N(a, !1), Qj(b, C("Enter your password").toString()), b = !1);
            return b ? Yi(a) : null;
        }
        function sl(a, b, c, d, e, f) {
            P.call(this, Lk, {
                email: a
            }, f, "passwordLinking", {
                F: d,
                D: e
            });
            this.w = b;
            this.H = c;
        }
        m(sl, P);
        sl.prototype.v = function() {
            this.P();
            this.M(this.w, this.H);
            xk(this, this.i(), this.w);
            this.i().focus();
            P.prototype.v.call(this);
        };
        sl.prototype.o = function() {
            this.w = null;
            P.prototype.o.call(this);
        };
        sl.prototype.j = function() {
            return Yi(M(this, "firebaseui-id-email"));
        };
        u(sl.prototype, {
            i: ol,
            B: pl,
            P: ql,
            u: rl,
            ea: ll,
            ba: ml,
            M: nl
        });
        var tl = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;
        function ul() {
            return M(this, "firebaseui-id-email");
        }
        function vl() {
            return M(this, "firebaseui-id-email-error");
        }
        function wl(a) {
            var b = ul.call(this), c = vl.call(this);
            Lj(this, b, function() {
                Rj(c) && (N(b, !0), Pj(c));
            });
            a && Mj(this, b, function() {
                a();
            });
        }
        function xl() {
            return Ua(Yi(ul.call(this)) || "");
        }
        function yl() {
            var a = ul.call(this);
            var b = vl.call(this);
            var c = Yi(a) || "";
            c ? tl.test(c) ? (N(a, !0), Pj(b), b = !0) : (N(a, !1), Qj(b, C("That email address isn't correct").toString()), b = !1) : (N(a, !1), Qj(b, C("Enter your email address to continue").toString()), b = !1);
            return b ? Ua(Yi(a)) : null;
        }
        function zl(a, b, c, d, e, f, g) {
            P.call(this, zk, {
                email: c,
                ia: !!f
            }, g, "passwordSignIn", {
                F: d,
                D: e
            });
            this.w = a;
            this.H = b;
        }
        m(zl, P);
        zl.prototype.v = function() {
            this.P();
            this.ea();
            this.ba(this.w, this.H);
            wk(this, this.l(), this.i());
            xk(this, this.i(), this.w);
            Yi(this.l()) ? this.i().focus() : this.l().focus();
            P.prototype.v.call(this);
        };
        zl.prototype.o = function() {
            this.H = this.w = null;
            P.prototype.o.call(this);
        };
        u(zl.prototype, {
            l: ul,
            U: vl,
            P: wl,
            M: xl,
            j: yl,
            i: ol,
            B: pl,
            ea: ql,
            u: rl,
            ua: ll,
            pa: ml,
            ba: nl
        });
        function R(a, b, c, d, e, f) {
            P.call(this, a, b, d, e || "notice", f);
            this.i = c || null;
        }
        w(R, P);
        R.prototype.v = function() {
            this.i && (this.u(this.i), this.l().focus());
            R.K.v.call(this);
        };
        R.prototype.o = function() {
            this.i = null;
            R.K.o.call(this);
        };
        u(R.prototype, {
            l: ll,
            w: ml,
            u: nl
        });
        function Al(a, b, c, d, e) {
            R.call(this, Ck, {
                email: a,
                G: !!b
            }, b, e, "passwordRecoveryEmailSent", {
                F: c,
                D: d
            });
        }
        w(Al, R);
        function Bl(a, b) {
            R.call(this, Wk, {
                G: !!a
            }, a, b, "emailVerificationSuccess");
        }
        w(Bl, R);
        function Cl(a, b) {
            R.call(this, Yk, {
                G: !!a
            }, a, b, "emailVerificationFailure");
        }
        w(Cl, R);
        function Dl(a, b, c) {
            R.call(this, Zk, {
                email: a,
                G: !!b
            }, b, c, "verifyAndChangeEmailSuccess");
        }
        w(Dl, R);
        function El(a, b) {
            R.call(this, $k, {
                G: !!a
            }, a, b, "verifyAndChangeEmailFailure");
        }
        w(El, R);
        function Fl(a, b) {
            R.call(this, bl, {
                G: !!a
            }, a, b, "revertSecondFactorAdditionFailure");
        }
        w(Fl, R);
        function Gl(a) {
            R.call(this, il, void 0, void 0, a, "signOut");
        }
        w(Gl, R);
        function Hl(a, b) {
            R.call(this, Sk, {
                G: !!a
            }, a, b, "passwordResetSuccess");
        }
        w(Hl, R);
        function Il(a, b) {
            R.call(this, Tk, {
                G: !!a
            }, a, b, "passwordResetFailure");
        }
        w(Il, R);
        function Jl(a, b) {
            R.call(this, Vk, {
                G: !!a
            }, a, b, "emailChangeRevokeFailure");
        }
        w(Jl, R);
        function Kl(a, b, c) {
            R.call(this, cl, {
                errorMessage: a,
                zb: !!b
            }, b, c, "recoverableError");
        }
        w(Kl, R);
        function Ll(a, b) {
            R.call(this, dl, {
                errorMessage: a
            }, void 0, b, "unrecoverableError");
        }
        w(Ll, R);
        function Ml(a) {
            if ("auth/invalid-credential" === a.code && a.message && -1 !== a.message.indexOf("error=consent_required")) return {
                code: "auth/user-cancelled"
            };
            if (a.message && -1 !== a.message.indexOf("HTTP Cloud Function returned an error:")) {
                var b = JSON.parse(a.message.substring(a.message.indexOf("{"), a.message.lastIndexOf("}") + 1));
                return {
                    code: a.code,
                    message: b && b.error && b.error.message || a.message
                };
            }
            return a;
        }
        function Nl(a, b, c, d) {
            function e(g) {
                if (!g.name || "cancel" != g.name) {
                    a: {
                        var h = g.message;
                        try {
                            var k = ((JSON.parse(h).error || {}).message || "").toLowerCase().match(/invalid.+(access|id)_token/);
                            if (k && k.length) {
                                var p = !0;
                                break a;
                            }
                        } catch (t) {}
                        p = !1;
                    }
                    if (p) g = Q(b), b.m(), S(a, g, void 0, C("Your sign-in session has expired. Please try again.").toString());
                    else {
                        p = g && g.message || "";
                        if (g.code) {
                            if ("auth/email-already-in-use" == g.code || "auth/credential-already-in-use" == g.code) return;
                            p = T(g);
                        }
                        b.a(p);
                    }
                }
            }
            Ol(a);
            if (d) return Pl(a, c), F();
            if (!c.credential) throw Error("No credential found!");
            if (!U(a).currentUser && !c.user) throw Error("User not logged in.");
            try {
                var f = Ql(a, c);
            } catch (g) {
                return og(g.code || g.message, g), b.a(g.code || g.message), F();
            }
            c = f.then(function(g) {
                Pl(a, g);
            }, e).then(void 0, e);
            V(a, f);
            return F(c);
        }
        function Pl(a, b) {
            if (!b.user) throw Error("No user found");
            var c = Mi(W(a));
            Ki(W(a)) && c && tg("Both signInSuccess and signInSuccessWithAuthResult callbacks are provided. Only signInSuccessWithAuthResult callback will be invoked.");
            if (c) {
                c = Mi(W(a));
                var d = yh(X(a)) || void 0;
                wh(sh, X(a));
                var e = !1;
                if (qf()) {
                    if (!c || c(b, d)) e = !0, Nc(window.opener.location, Rl(a, d));
                    c || window.close();
                } else if (!c || c(b, d)) e = !0, Nc(window.location, Rl(a, d));
                e || a.reset();
            } else {
                c = b.user;
                b = b.credential;
                d = Ki(W(a));
                e = yh(X(a)) || void 0;
                wh(sh, X(a));
                var f = !1;
                if (qf()) {
                    if (!d || d(c, b, e)) f = !0, Nc(window.opener.location, Rl(a, e));
                    d || window.close();
                } else if (!d || d(c, b, e)) f = !0, Nc(window.location, Rl(a, e));
                f || a.reset();
            }
        }
        function Rl(a, b) {
            a = b || W(a).a.get("signInSuccessUrl");
            if (!a) throw Error("No redirect URL has been found. You must either specify a signInSuccessUrl in the configuration, pass in a redirect URL to the widget URL, or return false from the callback.");
            return a;
        }
        function T(a) {
            var b = {
                code: a.code
            };
            b = b || {};
            var c = "";
            switch(b.code){
                case "auth/email-already-in-use":
                    c += "The email address is already used by another account";
                    break;
                case "auth/requires-recent-login":
                    c += Md();
                    break;
                case "auth/too-many-requests":
                    c += "You have entered an incorrect password too many times. Please try again in a few minutes.";
                    break;
                case "auth/user-cancelled":
                    c += "Please authorize the required permissions to sign in to the application";
                    break;
                case "auth/user-not-found":
                    c += "That email address doesn't match an existing account";
                    break;
                case "auth/user-token-expired":
                    c += Md();
                    break;
                case "auth/weak-password":
                    c += "Strong passwords have at least 6 characters and a mix of letters and numbers";
                    break;
                case "auth/wrong-password":
                    c += "The email and password you entered don't match";
                    break;
                case "auth/network-request-failed":
                    c += "A network error has occurred";
                    break;
                case "auth/invalid-phone-number":
                    c += Hd();
                    break;
                case "auth/invalid-verification-code":
                    c += C("Wrong code. Try again.");
                    break;
                case "auth/code-expired":
                    c += "This code is no longer valid";
                    break;
                case "auth/expired-action-code":
                    c += "This code has expired.";
                    break;
                case "auth/invalid-action-code":
                    c += "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.";
            }
            if (b = C(c).toString()) return b;
            try {
                return JSON.parse(a.message), og("Internal error: " + a.message, void 0), Jd().toString();
            } catch (d) {
                return a.message;
            }
        }
        function Sl(a, b, c) {
            var d = ai[b] && (0, $8eXKx.default).auth[ai[b]] ? new (0, $8eXKx.default).auth[ai[b]] : 0 == b.indexOf("saml.") ? new (0, $8eXKx.default).auth.SAMLAuthProvider(b) : new (0, $8eXKx.default).auth.OAuthProvider(b);
            if (!d) throw Error("Invalid Firebase Auth provider!");
            var e = wi(W(a), b);
            if (d.addScope) for(var f = 0; f < e.length; f++)d.addScope(e[f]);
            e = xi(W(a), b) || {};
            c && (b == (0, $8eXKx.default).auth.GoogleAuthProvider.PROVIDER_ID ? a = "login_hint" : b == (0, $8eXKx.default).auth.GithubAuthProvider.PROVIDER_ID ? a = "login" : a = (a = ii(W(a), b)) && a.Ob, a && (e[a] = c));
            d.setCustomParameters && d.setCustomParameters(e);
            return d;
        }
        function Tl(a, b, c, d) {
            function e() {
                Dh(new Dg(a.h.tenantId || null), X(a));
                V(a, b.I(r(a.dc, a), [
                    k
                ], function() {
                    if ("file:" === (window.location && window.location.protocol)) return V(a, Ul(a).then(function(p) {
                        b.m();
                        wh(rh, X(a));
                        L("callback", a, h, F(p));
                    }, f));
                }, g));
            }
            function f(p) {
                wh(rh, X(a));
                if (!p.name || "cancel" != p.name) switch(p = Ml(p), p.code){
                    case "auth/popup-blocked":
                        e();
                        break;
                    case "auth/popup-closed-by-user":
                    case "auth/cancelled-popup-request":
                        break;
                    case "auth/credential-already-in-use":
                        break;
                    case "auth/network-request-failed":
                    case "auth/too-many-requests":
                    case "auth/user-cancelled":
                        b.a(T(p));
                        break;
                    case "auth/admin-restricted-operation":
                        b.m();
                        pi(W(a)) ? L("handleUnauthorizedUser", a, h, null, c) : L("callback", a, h, df(p));
                        break;
                    default:
                        b.m(), L("callback", a, h, df(p));
                }
            }
            function g(p) {
                wh(rh, X(a));
                p.name && "cancel" == p.name || (og("signInWithRedirect: " + p.code, void 0), p = T(p), "blank" == b.Ga && Gi(W(a)) ? (b.m(), L("providerSignIn", a, h, p)) : b.a(p));
            }
            var h = Q(b), k = Sl(a, c, d);
            Hi(W(a)) == Ii ? e() : V(a, Vl(a, k).then(function(p) {
                b.m();
                L("callback", a, h, F(p));
            }, f));
        }
        function Wl(a, b) {
            V(a, b.I(r(a.$b, a), [], function(c) {
                b.m();
                return Nl(a, b, c, !0);
            }, function(c) {
                c.name && "cancel" == c.name || (og("ContinueAsGuest: " + c.code, void 0), c = T(c), b.a(c));
            }));
        }
        function Xl(a, b, c) {
            function d(f) {
                var g = !1;
                f = b.I(r(a.ac, a), [
                    f
                ], function(h) {
                    var k = Q(b);
                    b.m();
                    L("callback", a, k, F(h));
                    g = !0;
                }, function(h) {
                    if (!h.name || "cancel" != h.name) {
                        if (!h || "auth/credential-already-in-use" != h.code) {
                            if (h && "auth/email-already-in-use" == h.code && h.email && h.credential) {
                                var k = Q(b);
                                b.m();
                                L("callback", a, k, df(h));
                            } else h && "auth/admin-restricted-operation" == h.code && pi(W(a)) ? (h = Q(b), b.m(), L("handleUnauthorizedUser", a, h, null, (0, $8eXKx.default).auth.GoogleAuthProvider.PROVIDER_ID)) : (h = T(h), b.a(h));
                        }
                    }
                });
                V(a, f);
                return f.then(function() {
                    return g;
                }, function() {
                    return !1;
                });
            }
            if (c && c.credential && c.clientId === li(W(a))) {
                if (wi(W(a), (0, $8eXKx.default).auth.GoogleAuthProvider.PROVIDER_ID).length) {
                    try {
                        var e = JSON.parse(atob(c.credential.split(".")[1])).email;
                    } catch (f) {}
                    Tl(a, b, (0, $8eXKx.default).auth.GoogleAuthProvider.PROVIDER_ID, e);
                    return F(!0);
                }
                return d((0, $8eXKx.default).auth.GoogleAuthProvider.credential(c.credential));
            }
            c && b.a(C("The selected credential for the authentication provider is not supported!").toString());
            return F(!1);
        }
        function Yl(a, b) {
            var c = b.j(), d = b.u();
            if (c) {
                if (d) {
                    var e = (0, $8eXKx.default).auth.EmailAuthProvider.credential(c, d);
                    V(a, b.I(r(a.bc, a), [
                        c,
                        d
                    ], function(f) {
                        return Nl(a, b, {
                            user: f.user,
                            credential: e,
                            operationType: f.operationType,
                            additionalUserInfo: f.additionalUserInfo
                        });
                    }, function(f) {
                        if (!f.name || "cancel" != f.name) switch(f.code){
                            case "auth/email-already-in-use":
                                break;
                            case "auth/email-exists":
                                N(b.l(), !1);
                                Qj(b.U(), T(f));
                                break;
                            case "auth/too-many-requests":
                            case "auth/wrong-password":
                                N(b.i(), !1);
                                Qj(b.B(), T(f));
                                break;
                            default:
                                og("verifyPassword: " + f.message, void 0), b.a(T(f));
                        }
                    }));
                } else b.i().focus();
            } else b.l().focus();
        }
        function Zl(a) {
            a = hi(W(a));
            return 1 == a.length && a[0] == (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID;
        }
        function $l(a) {
            a = hi(W(a));
            return 1 == a.length && a[0] == (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID;
        }
        function S(a, b, c, d) {
            Zl(a) ? d ? L("signIn", a, b, c, d) : am(a, b, c) : a && $l(a) && !d ? L("phoneSignInStart", a, b) : a && Gi(W(a)) && !d ? L("federatedRedirect", a, b, c) : L("providerSignIn", a, b, d, c);
        }
        function bm(a, b, c, d) {
            var e = Q(b);
            V(a, b.I(r(U(a).fetchSignInMethodsForEmail, U(a)), [
                c
            ], function(f) {
                b.m();
                cm(a, e, f, c, d);
            }, function(f) {
                f = T(f);
                b.a(f);
            }));
        }
        function cm(a, b, c, d, e, f) {
            c.length || Di(W(a)) && !Di(W(a)) ? Ma(c, (0, $8eXKx.default).auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) ? L("passwordSignIn", a, b, d, f) : 1 == c.length && c[0] === (0, $8eXKx.default).auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD ? Di(W(a)) ? L("sendEmailLinkForSignIn", a, b, d, function() {
                L("signIn", a, b);
            }) : L("unsupportedProvider", a, b, d) : (c = Zh(c, hi(W(a)))) ? (Bh(new Ag(d), X(a)), L("federatedSignIn", a, b, d, c, e)) : L("unsupportedProvider", a, b, d) : oi(W(a)) ? L("handleUnauthorizedUser", a, b, d, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID) : Di(W(a)) ? L("sendEmailLinkForSignIn", a, b, d, function() {
                L("signIn", a, b);
            }) : L("passwordSignUp", a, b, d, void 0, void 0, f);
        }
        function dm(a, b, c, d, e, f) {
            var g = Q(b);
            V(a, b.I(r(a.Ib, a), [
                c,
                f
            ], function() {
                b.m();
                L("emailLinkSignInSent", a, g, c, d, f);
            }, e));
        }
        function am(a, b, c) {
            c ? L("prefilledEmailSignIn", a, b, c) : L("signIn", a, b);
        }
        function em() {
            return tb(tf(), "oobCode");
        }
        function fm() {
            var a = tb(tf(), "continueUrl");
            return a ? function() {
                Nc(window.location, a);
            } : null;
        }
        function gm(a, b) {
            P.call(this, Kk, void 0, b, "anonymousUserMismatch");
            this.i = a;
        }
        m(gm, P);
        gm.prototype.v = function() {
            var a = this;
            O(this, this.l(), function() {
                a.i();
            });
            this.l().focus();
            P.prototype.v.call(this);
        };
        gm.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(gm.prototype, {
            l: ml
        });
        K.anonymousUserMismatch = function(a, b) {
            var c = new gm(function() {
                c.m();
                S(a, b);
            });
            c.render(b);
            Y(a, c);
        };
        function hm(a) {
            P.call(this, Dk, void 0, a, "callback");
        }
        m(hm, P);
        hm.prototype.I = function(a, b, c, d) {
            return a.apply(null, b).then(c, d);
        };
        function im(a, b, c) {
            if (c.user) {
                var d = {
                    user: c.user,
                    credential: c.credential,
                    operationType: c.operationType,
                    additionalUserInfo: c.additionalUserInfo
                }, e = zh(X(a)), f = e && e.g;
                if (f && !jm(c.user, f)) km(a, b, d);
                else {
                    var g = e && e.a;
                    g ? V(a, c.user.linkWithCredential(g).then(function(h) {
                        d = {
                            user: h.user,
                            credential: g,
                            operationType: h.operationType,
                            additionalUserInfo: h.additionalUserInfo
                        };
                        lm(a, b, d);
                    }, function(h) {
                        mm(a, b, h);
                    })) : lm(a, b, d);
                }
            } else c = Q(b), b.m(), Ah(X(a)), S(a, c);
        }
        function lm(a, b, c) {
            Ah(X(a));
            Nl(a, b, c);
        }
        function mm(a, b, c) {
            var d = Q(b);
            Ah(X(a));
            c = T(c);
            b.m();
            S(a, d, void 0, c);
        }
        function nm(a, b, c, d) {
            var e = Q(b);
            V(a, U(a).fetchSignInMethodsForEmail(c).then(function(f) {
                b.m();
                f.length ? Ma(f, (0, $8eXKx.default).auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) ? L("passwordLinking", a, e, c) : 1 == f.length && f[0] === (0, $8eXKx.default).auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD ? L("emailLinkSignInLinking", a, e, c) : (f = Zh(f, hi(W(a)))) ? L("federatedLinking", a, e, c, f, d) : (Ah(X(a)), L("unsupportedProvider", a, e, c)) : (Ah(X(a)), L("passwordRecovery", a, e, c, !1, Kd().toString()));
            }, function(f) {
                mm(a, b, f);
            }));
        }
        function km(a, b, c) {
            var d = Q(b);
            V(a, om(a).then(function() {
                b.m();
                L("emailMismatch", a, d, c);
            }, function(e) {
                e.name && "cancel" == e.name || (e = T(e.code), b.a(e));
            }));
        }
        function jm(a, b) {
            if (b == a.email) return !0;
            if (a.providerData) {
                for(var c = 0; c < a.providerData.length; c++)if (b == a.providerData[c].email) return !0;
            }
            return !1;
        }
        K.callback = function(a, b, c) {
            var d = new hm;
            d.render(b);
            Y(a, d);
            c = c || Ul(a);
            V(a, c.then(function(e) {
                im(a, d, e);
            }, function(e) {
                if ((e = Ml(e)) && ("auth/account-exists-with-different-credential" == e.code || "auth/email-already-in-use" == e.code) && e.email && e.credential) Bh(new Ag(e.email, e.credential), X(a)), nm(a, d, e.email);
                else if (e && "auth/user-cancelled" == e.code) {
                    var f = zh(X(a)), g = T(e);
                    f && f.a ? nm(a, d, f.g, g) : f ? bm(a, d, f.g, g) : mm(a, d, e);
                } else e && "auth/credential-already-in-use" == e.code || (e && "auth/operation-not-supported-in-this-environment" == e.code && Zl(a) ? im(a, d, {
                    user: null,
                    credential: null
                }) : e && "auth/admin-restricted-operation" == e.code && pi(W(a)) ? (d.m(), Ah(X(a)), L("handleUnauthorizedUser", a, b, null, null)) : mm(a, d, e));
            }));
        };
        function pm(a, b) {
            P.call(this, Jk, void 0, b, "differentDeviceError");
            this.i = a;
        }
        m(pm, P);
        pm.prototype.v = function() {
            var a = this;
            O(this, this.l(), function() {
                a.i();
            });
            this.l().focus();
            P.prototype.v.call(this);
        };
        pm.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(pm.prototype, {
            l: ml
        });
        K.differentDeviceError = function(a, b) {
            var c = new pm(function() {
                c.m();
                S(a, b);
            });
            c.render(b);
            Y(a, c);
        };
        function qm(a, b, c, d) {
            P.call(this, Uk, {
                email: a,
                G: !!c
            }, d, "emailChangeRevoke");
            this.l = b;
            this.i = c || null;
        }
        m(qm, P);
        qm.prototype.v = function() {
            var a = this;
            O(this, M(this, "firebaseui-id-reset-password-link"), function() {
                a.l();
            });
            this.i && (this.w(this.i), this.u().focus());
            P.prototype.v.call(this);
        };
        qm.prototype.o = function() {
            this.l = this.i = null;
            P.prototype.o.call(this);
        };
        u(qm.prototype, {
            u: ll,
            B: ml,
            w: nl
        });
        function rm() {
            return M(this, "firebaseui-id-new-password");
        }
        function sm() {
            return M(this, "firebaseui-id-password-toggle");
        }
        function tm() {
            this.Ra = !this.Ra;
            var a = sm.call(this), b = rm.call(this);
            this.Ra ? (b.type = "text", Wi(a, "firebaseui-input-toggle-off"), Xi(a, "firebaseui-input-toggle-on")) : (b.type = "password", Wi(a, "firebaseui-input-toggle-on"), Xi(a, "firebaseui-input-toggle-off"));
            b.focus();
        }
        function um() {
            return M(this, "firebaseui-id-new-password-error");
        }
        function vm() {
            this.Ra = !1;
            var a = rm.call(this);
            a.type = "password";
            var b = um.call(this);
            Lj(this, a, function() {
                Rj(b) && (N(a, !0), Pj(b));
            });
            var c = sm.call(this);
            Wi(c, "firebaseui-input-toggle-on");
            Xi(c, "firebaseui-input-toggle-off");
            Nj(this, a, function() {
                Wi(c, "firebaseui-input-toggle-focus");
                Xi(c, "firebaseui-input-toggle-blur");
            });
            Oj(this, a, function() {
                Wi(c, "firebaseui-input-toggle-blur");
                Xi(c, "firebaseui-input-toggle-focus");
            });
            O(this, c, r(tm, this));
        }
        function wm() {
            var a = rm.call(this);
            var b = um.call(this);
            Yi(a) ? (N(a, !0), Pj(b), b = !0) : (N(a, !1), Qj(b, C("Enter your password").toString()), b = !1);
            return b ? Yi(a) : null;
        }
        function xm(a, b, c) {
            P.call(this, Rk, {
                email: a
            }, c, "passwordReset");
            this.l = b;
        }
        m(xm, P);
        xm.prototype.v = function() {
            this.H();
            this.B(this.l);
            xk(this, this.i(), this.l);
            this.i().focus();
            P.prototype.v.call(this);
        };
        xm.prototype.o = function() {
            this.l = null;
            P.prototype.o.call(this);
        };
        u(xm.prototype, {
            i: rm,
            w: um,
            M: sm,
            H: vm,
            u: wm,
            U: ll,
            P: ml,
            B: nl
        });
        function ym(a, b, c, d, e) {
            P.call(this, al, {
                factorId: a,
                phoneNumber: c || null,
                G: !!d
            }, e, "revertSecondFactorAdditionSuccess");
            this.l = b;
            this.i = d || null;
        }
        m(ym, P);
        ym.prototype.v = function() {
            var a = this;
            O(this, M(this, "firebaseui-id-reset-password-link"), function() {
                a.l();
            });
            this.i && (this.w(this.i), this.u().focus());
            P.prototype.v.call(this);
        };
        ym.prototype.o = function() {
            this.l = this.i = null;
            P.prototype.o.call(this);
        };
        u(ym.prototype, {
            u: ll,
            B: ml,
            w: nl
        });
        function zm(a, b, c, d, e) {
            var f = c.u();
            f && V(a, c.I(r(U(a).confirmPasswordReset, U(a)), [
                d,
                f
            ], function() {
                c.m();
                var g = new Hl(e);
                g.render(b);
                Y(a, g);
            }, function(g) {
                Am(a, b, c, g);
            }));
        }
        function Am(a, b, c, d) {
            "auth/weak-password" == (d && d.code) ? (a = T(d), N(c.i(), !1), Qj(c.w(), a), c.i().focus()) : (c && c.m(), c = new Il, c.render(b), Y(a, c));
        }
        function Bm(a, b, c) {
            var d = new qm(c, function() {
                V(a, d.I(r(U(a).sendPasswordResetEmail, U(a)), [
                    c
                ], function() {
                    d.m();
                    d = new Al(c, void 0, H(W(a)), J(W(a)));
                    d.render(b);
                    Y(a, d);
                }, function() {
                    d.a(Id().toString());
                }));
            });
            d.render(b);
            Y(a, d);
        }
        function Cm(a, b, c, d) {
            var e = new ym(d.factorId, function() {
                e.I(r(U(a).sendPasswordResetEmail, U(a)), [
                    c
                ], function() {
                    e.m();
                    e = new Al(c, void 0, H(W(a)), J(W(a)));
                    e.render(b);
                    Y(a, e);
                }, function() {
                    e.a(Id().toString());
                });
            }, d.phoneNumber);
            e.render(b);
            Y(a, e);
        }
        K.passwordReset = function(a, b, c, d) {
            V(a, U(a).verifyPasswordResetCode(c).then(function(e) {
                var f = new xm(e, function() {
                    zm(a, b, f, c, d);
                });
                f.render(b);
                Y(a, f);
            }, function() {
                Am(a, b);
            }));
        };
        K.emailChangeRevocation = function(a, b, c) {
            var d = null;
            V(a, U(a).checkActionCode(c).then(function(e) {
                d = e.data.email;
                return U(a).applyActionCode(c);
            }).then(function() {
                Bm(a, b, d);
            }, function() {
                var e = new Jl;
                e.render(b);
                Y(a, e);
            }));
        };
        K.emailVerification = function(a, b, c, d) {
            V(a, U(a).applyActionCode(c).then(function() {
                var e = new Bl(d);
                e.render(b);
                Y(a, e);
            }, function() {
                var e = new Cl;
                e.render(b);
                Y(a, e);
            }));
        };
        K.revertSecondFactorAddition = function(a, b, c) {
            var d = null, e = null;
            V(a, U(a).checkActionCode(c).then(function(f) {
                d = f.data.email;
                e = f.data.multiFactorInfo;
                return U(a).applyActionCode(c);
            }).then(function() {
                Cm(a, b, d, e);
            }, function() {
                var f = new Fl;
                f.render(b);
                Y(a, f);
            }));
        };
        K.verifyAndChangeEmail = function(a, b, c, d) {
            var e = null;
            V(a, U(a).checkActionCode(c).then(function(f) {
                e = f.data.email;
                return U(a).applyActionCode(c);
            }).then(function() {
                var f = new Dl(e, d);
                f.render(b);
                Y(a, f);
            }, function() {
                var f = new El;
                f.render(b);
                Y(a, f);
            }));
        };
        function Dm(a, b) {
            try {
                var c = "number" == typeof a.selectionStart;
            } catch (d) {
                c = !1;
            }
            c ? (a.selectionStart = b, a.selectionEnd = b) : z && !mc("9") && ("textarea" == a.type && (b = a.value.substring(0, b).replace(/(\r\n|\r|\n)/g, "\n").length), a = a.createTextRange(), a.collapse(!0), a.move("character", b), a.select());
        }
        function Em(a, b, c, d, e, f) {
            P.call(this, Ik, {
                email: c
            }, f, "emailLinkSignInConfirmation", {
                F: d,
                D: e
            });
            this.l = a;
            this.u = b;
        }
        m(Em, P);
        Em.prototype.v = function() {
            this.w(this.l);
            this.B(this.l, this.u);
            this.i().focus();
            Dm(this.i(), (this.i().value || "").length);
            P.prototype.v.call(this);
        };
        Em.prototype.o = function() {
            this.u = this.l = null;
            P.prototype.o.call(this);
        };
        u(Em.prototype, {
            i: ul,
            M: vl,
            w: wl,
            H: xl,
            j: yl,
            U: ll,
            P: ml,
            B: nl
        });
        K.emailLinkConfirmation = function(a, b, c, d, e, f) {
            var g = new Em(function() {
                var h = g.j();
                h ? (g.m(), d(a, b, h, c)) : g.i().focus();
            }, function() {
                g.m();
                S(a, b, e || void 0);
            }, e || void 0, H(W(a)), J(W(a)));
            g.render(b);
            Y(a, g);
            f && g.a(f);
        };
        function Fm(a, b, c, d, e) {
            P.call(this, Nk, {
                ga: a
            }, e, "emailLinkSignInLinkingDifferentDevice", {
                F: c,
                D: d
            });
            this.i = b;
        }
        m(Fm, P);
        Fm.prototype.v = function() {
            this.u(this.i);
            this.l().focus();
            P.prototype.v.call(this);
        };
        Fm.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(Fm.prototype, {
            l: ll,
            u: nl
        });
        K.emailLinkNewDeviceLinking = function(a, b, c, d) {
            var e = new Pb(c);
            c = e.a.a.get(x.PROVIDER_ID) || null;
            Tb(e, null);
            if (c) {
                var f = new Fm(ii(W(a), c), function() {
                    f.m();
                    d(a, b, e.toString());
                }, H(W(a)), J(W(a)));
                f.render(b);
                Y(a, f);
            } else S(a, b);
        };
        function Gm(a) {
            P.call(this, Fk, void 0, a, "blank");
        }
        m(Gm, P);
        function Hm(a, b, c, d, e) {
            var f = new Gm, g = new Pb(c), h = g.a.a.get(x.$a) || "", k = g.a.a.get(x.Sa) || "", p = "1" === g.a.a.get(x.Qa), t = Sb(g), I = g.a.a.get(x.PROVIDER_ID) || null;
            g = g.a.a.get(x.vb) || null;
            Im(a, g);
            var Ca = !vh(th, X(a)), Xk = d || Eh(k, X(a)), md = (d = Fh(k, X(a))) && d.a;
            I && md && md.providerId !== I && (md = null);
            f.render(b);
            Y(a, f);
            V(a, f.I(function() {
                var ya = F(null);
                ya = t && Ca || Ca && p ? df(Error("anonymous-user-not-found")) : Jm(a, c).then(function(xg) {
                    if (I && !md) throw Error("pending-credential-not-found");
                    return xg;
                });
                var nd = null;
                return ya.then(function(xg) {
                    nd = xg;
                    return e ? null : U(a).checkActionCode(h);
                }).then(function() {
                    return nd;
                });
            }, [], function(ya) {
                Xk ? Km(a, f, Xk, c, md, ya) : p ? (f.m(), L("differentDeviceError", a, b)) : (f.m(), L("emailLinkConfirmation", a, b, c, Lm));
            }, function(ya) {
                var nd = void 0;
                if (!ya || !ya.name || "cancel" != ya.name) switch(f.m(), ya && ya.message){
                    case "anonymous-user-not-found":
                        L("differentDeviceError", a, b);
                        break;
                    case "anonymous-user-mismatch":
                        L("anonymousUserMismatch", a, b);
                        break;
                    case "pending-credential-not-found":
                        L("emailLinkNewDeviceLinking", a, b, c, Mm);
                        break;
                    default:
                        ya && (nd = T(ya)), S(a, b, void 0, nd);
                }
            }));
        }
        function Lm(a, b, c, d) {
            Hm(a, b, d, c, !0);
        }
        function Mm(a, b, c) {
            Hm(a, b, c);
        }
        function Km(a, b, c, d, e, f) {
            var g = Q(b);
            b.$("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", C("Signing in...").toString());
            var h = null;
            e = (f ? Nm(a, f, c, d, e) : Om(a, c, d, e)).then(function(k) {
                wh(uh, X(a));
                wh(th, X(a));
                b.h();
                b.$("firebaseui-icon-done", C("Signed in!").toString());
                h = setTimeout(function() {
                    b.h();
                    Nl(a, b, k, !0);
                }, 1E3);
                V(a, function() {
                    b && (b.h(), b.m());
                    clearTimeout(h);
                });
            }, function(k) {
                b.h();
                b.m();
                if (!k.name || "cancel" != k.name) {
                    k = Ml(k);
                    var p = T(k);
                    "auth/email-already-in-use" == k.code || "auth/credential-already-in-use" == k.code ? (wh(uh, X(a)), wh(th, X(a))) : "auth/invalid-email" == k.code ? (p = C("The email provided does not match the current sign-in session.").toString(), L("emailLinkConfirmation", a, g, d, Lm, null, p)) : S(a, g, c, p);
                }
            });
            V(a, e);
        }
        K.emailLinkSignInCallback = Hm;
        function Pm(a, b, c, d, e, f) {
            P.call(this, Mk, {
                email: a,
                ga: b
            }, f, "emailLinkSignInLinking", {
                F: d,
                D: e
            });
            this.i = c;
        }
        m(Pm, P);
        Pm.prototype.v = function() {
            this.u(this.i);
            this.l().focus();
            P.prototype.v.call(this);
        };
        Pm.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(Pm.prototype, {
            l: ll,
            u: nl
        });
        function Qm(a, b, c, d) {
            var e = Q(b);
            dm(a, b, c, function() {
                S(a, e, c);
            }, function(f) {
                if (!f.name || "cancel" != f.name) {
                    var g = T(f);
                    f && "auth/network-request-failed" == f.code ? b.a(g) : (b.m(), S(a, e, c, g));
                }
            }, d);
        }
        K.emailLinkSignInLinking = function(a, b, c) {
            var d = zh(X(a));
            Ah(X(a));
            if (d) {
                var e = d.a.providerId, f = new Pm(c, ii(W(a), e), function() {
                    Qm(a, f, c, d);
                }, H(W(a)), J(W(a)));
                f.render(b);
                Y(a, f);
            } else S(a, b);
        };
        function Rm(a, b, c, d, e, f) {
            P.call(this, Gk, {
                email: a
            }, f, "emailLinkSignInSent", {
                F: d,
                D: e
            });
            this.u = b;
            this.i = c;
        }
        m(Rm, P);
        Rm.prototype.v = function() {
            var a = this;
            O(this, this.l(), function() {
                a.i();
            });
            O(this, M(this, "firebaseui-id-trouble-getting-email-link"), function() {
                a.u();
            });
            this.l().focus();
            P.prototype.v.call(this);
        };
        Rm.prototype.o = function() {
            this.i = this.u = null;
            P.prototype.o.call(this);
        };
        u(Rm.prototype, {
            l: ml
        });
        K.emailLinkSignInSent = function(a, b, c, d, e) {
            var f = new Rm(c, function() {
                f.m();
                L("emailNotReceived", a, b, c, d, e);
            }, function() {
                f.m();
                d();
            }, H(W(a)), J(W(a)));
            f.render(b);
            Y(a, f);
        };
        function Sm(a, b, c, d, e, f, g) {
            P.call(this, el, {
                jc: a,
                Qb: b
            }, g, "emailMismatch", {
                F: e,
                D: f
            });
            this.l = c;
            this.i = d;
        }
        m(Sm, P);
        Sm.prototype.v = function() {
            this.w(this.l, this.i);
            this.u().focus();
            P.prototype.v.call(this);
        };
        Sm.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(Sm.prototype, {
            u: ll,
            B: ml,
            w: nl
        });
        K.emailMismatch = function(a, b, c) {
            var d = zh(X(a));
            if (d) {
                var e = new Sm(c.user.email, d.g, function() {
                    var f = e;
                    Ah(X(a));
                    Nl(a, f, c);
                }, function() {
                    var f = c.credential.providerId, g = Q(e);
                    e.m();
                    d.a ? L("federatedLinking", a, g, d.g, f) : L("federatedSignIn", a, g, d.g, f);
                }, H(W(a)), J(W(a)));
                e.render(b);
                Y(a, e);
            } else S(a, b);
        };
        function Tm(a, b, c, d, e) {
            P.call(this, Hk, void 0, e, "emailNotReceived", {
                F: c,
                D: d
            });
            this.l = a;
            this.i = b;
        }
        m(Tm, P);
        Tm.prototype.v = function() {
            var a = this;
            O(this, this.u(), function() {
                a.i();
            });
            O(this, this.Da(), function() {
                a.l();
            });
            this.u().focus();
            P.prototype.v.call(this);
        };
        Tm.prototype.Da = function() {
            return M(this, "firebaseui-id-resend-email-link");
        };
        Tm.prototype.o = function() {
            this.i = this.l = null;
            P.prototype.o.call(this);
        };
        u(Tm.prototype, {
            u: ml
        });
        K.emailNotReceived = function(a, b, c, d, e) {
            var f = new Tm(function() {
                dm(a, f, c, d, function(g) {
                    g = T(g);
                    f.a(g);
                }, e);
            }, function() {
                f.m();
                S(a, b, c);
            }, H(W(a)), J(W(a)));
            f.render(b);
            Y(a, f);
        };
        function Um(a, b, c, d, e, f) {
            P.call(this, Ok, {
                email: a,
                ga: b
            }, f, "federatedLinking", {
                F: d,
                D: e
            });
            this.i = c;
        }
        m(Um, P);
        Um.prototype.v = function() {
            this.u(this.i);
            this.l().focus();
            P.prototype.v.call(this);
        };
        Um.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(Um.prototype, {
            l: ll,
            u: nl
        });
        K.federatedLinking = function(a, b, c, d, e) {
            var f = zh(X(a));
            if (f && f.a) {
                var g = new Um(c, ii(W(a), d), function() {
                    Tl(a, g, d, c);
                }, H(W(a)), J(W(a)));
                g.render(b);
                Y(a, g);
                e && g.a(e);
            } else S(a, b);
        };
        K.federatedRedirect = function(a, b, c) {
            var d = new Gm;
            d.render(b);
            Y(a, d);
            b = hi(W(a))[0];
            Tl(a, d, b, c);
        };
        K.federatedSignIn = function(a, b, c, d, e) {
            var f = new Um(c, ii(W(a), d), function() {
                Tl(a, f, d, c);
            }, H(W(a)), J(W(a)));
            f.render(b);
            Y(a, f);
            e && f.a(e);
        };
        function Vm(a, b, c, d) {
            var e = b.u();
            e ? V(a, b.I(r(a.Xb, a), [
                c,
                e
            ], function(f) {
                f = f.user.linkWithCredential(d).then(function(g) {
                    return Nl(a, b, {
                        user: g.user,
                        credential: d,
                        operationType: g.operationType,
                        additionalUserInfo: g.additionalUserInfo
                    });
                });
                V(a, f);
                return f;
            }, function(f) {
                if (!f.name || "cancel" != f.name) switch(f.code){
                    case "auth/wrong-password":
                        N(b.i(), !1);
                        Qj(b.B(), T(f));
                        break;
                    case "auth/too-many-requests":
                        b.a(T(f));
                        break;
                    default:
                        og("signInWithEmailAndPassword: " + f.message, void 0), b.a(T(f));
                }
            })) : b.i().focus();
        }
        K.passwordLinking = function(a, b, c) {
            var d = zh(X(a));
            Ah(X(a));
            var e = d && d.a;
            if (e) {
                var f = new sl(c, function() {
                    Vm(a, f, c, e);
                }, function() {
                    f.m();
                    L("passwordRecovery", a, b, c);
                }, H(W(a)), J(W(a)));
                f.render(b);
                Y(a, f);
            } else S(a, b);
        };
        function Wm(a, b, c, d, e, f) {
            P.call(this, Bk, {
                email: c,
                Ta: !!b
            }, f, "passwordRecovery", {
                F: d,
                D: e
            });
            this.l = a;
            this.u = b;
        }
        m(Wm, P);
        Wm.prototype.v = function() {
            this.B();
            this.H(this.l, this.u);
            Yi(this.i()) || this.i().focus();
            xk(this, this.i(), this.l);
            P.prototype.v.call(this);
        };
        Wm.prototype.o = function() {
            this.u = this.l = null;
            P.prototype.o.call(this);
        };
        u(Wm.prototype, {
            i: ul,
            w: vl,
            B: wl,
            M: xl,
            j: yl,
            U: ll,
            P: ml,
            H: nl
        });
        function Xm(a, b) {
            var c = b.j();
            if (c) {
                var d = Q(b);
                V(a, b.I(r(U(a).sendPasswordResetEmail, U(a)), [
                    c
                ], function() {
                    b.m();
                    var e = new Al(c, function() {
                        e.m();
                        S(a, d);
                    }, H(W(a)), J(W(a)));
                    e.render(d);
                    Y(a, e);
                }, function(e) {
                    N(b.i(), !1);
                    Qj(b.w(), T(e));
                }));
            } else b.i().focus();
        }
        K.passwordRecovery = function(a, b, c, d, e) {
            var f = new Wm(function() {
                Xm(a, f);
            }, d ? void 0 : function() {
                f.m();
                S(a, b);
            }, c, H(W(a)), J(W(a)));
            f.render(b);
            Y(a, f);
            e && f.a(e);
        };
        K.passwordSignIn = function(a, b, c, d) {
            var e = new zl(function() {
                Yl(a, e);
            }, function() {
                var f = e.M();
                e.m();
                L("passwordRecovery", a, b, f);
            }, c, H(W(a)), J(W(a)), d);
            e.render(b);
            Y(a, e);
        };
        function Ym() {
            return M(this, "firebaseui-id-name");
        }
        function Zm() {
            return M(this, "firebaseui-id-name-error");
        }
        function $m(a, b, c, d, e, f, g, h, k) {
            P.call(this, Ak, {
                email: d,
                Tb: a,
                name: e,
                Ta: !!c,
                ia: !!h
            }, k, "passwordSignUp", {
                F: f,
                D: g
            });
            this.w = b;
            this.H = c;
            this.B = a;
        }
        m($m, P);
        $m.prototype.v = function() {
            this.ea();
            this.B && this.Ja();
            this.ua();
            this.pa(this.w, this.H);
            this.B ? (wk(this, this.i(), this.u()), wk(this, this.u(), this.l())) : wk(this, this.i(), this.l());
            this.w && xk(this, this.l(), this.w);
            Yi(this.i()) ? this.B && !Yi(this.u()) ? this.u().focus() : this.l().focus() : this.i().focus();
            P.prototype.v.call(this);
        };
        $m.prototype.o = function() {
            this.H = this.w = null;
            P.prototype.o.call(this);
        };
        u($m.prototype, {
            i: ul,
            U: vl,
            ea: wl,
            jb: xl,
            j: yl,
            u: Ym,
            Cc: Zm,
            Ja: function() {
                var a = Ym.call(this), b = Zm.call(this);
                Lj(this, a, function() {
                    Rj(b) && (N(a, !0), Pj(b));
                });
            },
            M: function() {
                var a = Ym.call(this);
                var b = Zm.call(this);
                var c = Yi(a);
                c = !/^[\s\xa0]*$/.test(null == c ? "" : String(c));
                N(a, c);
                c ? (Pj(b), b = !0) : (Qj(b, C("Enter your account name").toString()), b = !1);
                return b ? Ua(Yi(a)) : null;
            },
            l: rm,
            ba: um,
            lb: sm,
            ua: vm,
            P: wm,
            Nb: ll,
            Mb: ml,
            pa: nl
        });
        function an(a, b) {
            var c = Ci(W(a)), d = b.j(), e = null;
            c && (e = b.M());
            var f = b.P();
            if (d) {
                if (c) {
                    if (e) e = cb(e);
                    else {
                        b.u().focus();
                        return;
                    }
                }
                if (f) {
                    var g = (0, $8eXKx.default).auth.EmailAuthProvider.credential(d, f);
                    V(a, b.I(r(a.Yb, a), [
                        d,
                        f
                    ], function(h) {
                        var k = {
                            user: h.user,
                            credential: g,
                            operationType: h.operationType,
                            additionalUserInfo: h.additionalUserInfo
                        };
                        return c ? (h = h.user.updateProfile({
                            displayName: e
                        }).then(function() {
                            return Nl(a, b, k);
                        }), V(a, h), h) : Nl(a, b, k);
                    }, function(h) {
                        if (!h.name || "cancel" != h.name) {
                            var k = Ml(h);
                            h = T(k);
                            switch(k.code){
                                case "auth/email-already-in-use":
                                    return bn(a, b, d, k);
                                case "auth/too-many-requests":
                                    h = C("Too many account requests are coming from your IP address. Try again in a few minutes.").toString();
                                case "auth/operation-not-allowed":
                                case "auth/weak-password":
                                    N(b.l(), !1);
                                    Qj(b.ba(), h);
                                    break;
                                case "auth/admin-restricted-operation":
                                    pi(W(a)) ? (h = Q(b), b.m(), L("handleUnauthorizedUser", a, h, d, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID)) : b.a(h);
                                    break;
                                default:
                                    k = "setAccountInfo: " + ah(k), og(k, void 0), b.a(h);
                            }
                        }
                    }));
                } else b.l().focus();
            } else b.i().focus();
        }
        function bn(a, b, c, d) {
            function e() {
                var g = T(d);
                N(b.i(), !1);
                Qj(b.U(), g);
                b.i().focus();
            }
            var f = U(a).fetchSignInMethodsForEmail(c).then(function(g) {
                g.length ? e() : (g = Q(b), b.m(), L("passwordRecovery", a, g, c, !1, Kd().toString()));
            }, function() {
                e();
            });
            V(a, f);
            return f;
        }
        K.passwordSignUp = function(a, b, c, d, e, f) {
            function g() {
                h.m();
                S(a, b);
            }
            var h = new $m(Ci(W(a)), function() {
                an(a, h);
            }, e ? void 0 : g, c, d, H(W(a)), J(W(a)), f);
            h.render(b);
            Y(a, h);
        };
        function cn() {
            return M(this, "firebaseui-id-phone-confirmation-code");
        }
        function dn() {
            return M(this, "firebaseui-id-phone-confirmation-code-error");
        }
        function en() {
            return M(this, "firebaseui-id-resend-countdown");
        }
        function fn(a, b, c, d, e, f, g, h, k) {
            P.call(this, hl, {
                phoneNumber: e
            }, k, "phoneSignInFinish", {
                F: g,
                D: h
            });
            this.jb = f;
            this.i = new jj(1E3);
            this.B = f;
            this.P = a;
            this.l = b;
            this.H = c;
            this.M = d;
        }
        m(fn, P);
        fn.prototype.v = function() {
            var a = this;
            this.U(this.jb);
            ke(this.i, "tick", this.w, !1, this);
            this.i.start();
            O(this, M(this, "firebaseui-id-change-phone-number-link"), function() {
                a.P();
            });
            O(this, this.Da(), function() {
                a.M();
            });
            this.Ja(this.l);
            this.ea(this.l, this.H);
            this.u().focus();
            P.prototype.v.call(this);
        };
        fn.prototype.o = function() {
            this.M = this.H = this.l = this.P = null;
            kj(this.i);
            se(this.i, "tick", this.w);
            this.i = null;
            P.prototype.o.call(this);
        };
        fn.prototype.w = function() {
            --this.B;
            0 < this.B ? this.U(this.B) : (kj(this.i), se(this.i, "tick", this.w), this.ua(), this.lb());
        };
        u(fn.prototype, {
            u: cn,
            pa: dn,
            Ja: function(a) {
                var b = cn.call(this), c = dn.call(this);
                Lj(this, b, function() {
                    Rj(c) && (N(b, !0), Pj(c));
                });
                a && Mj(this, b, function() {
                    a();
                });
            },
            ba: function() {
                var a = Ua(Yi(cn.call(this)) || "");
                return /^\d{6}$/.test(a) ? a : null;
            },
            Fb: en,
            U: function(a) {
                $c(en.call(this), C("Resend code in " + ((9 < a ? "0:" : "0:0") + a)).toString());
            },
            ua: function() {
                Pj(this.Fb());
            },
            Da: function() {
                return M(this, "firebaseui-id-resend-link");
            },
            lb: function() {
                Qj(this.Da());
            },
            Nb: ll,
            Mb: ml,
            ea: nl
        });
        function gn(a, b, c, d) {
            function e(g) {
                b.u().focus();
                N(b.u(), !1);
                Qj(b.pa(), g);
            }
            var f = b.ba();
            f ? (b.$("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", C("Verifying...").toString()), V(a, b.I(r(d.confirm, d), [
                f
            ], function(g) {
                b.h();
                b.$("firebaseui-icon-done", C("Verified!").toString());
                var h = setTimeout(function() {
                    b.h();
                    b.m();
                    var k = {
                        user: hn(a).currentUser,
                        credential: null,
                        operationType: g.operationType,
                        additionalUserInfo: g.additionalUserInfo
                    };
                    Nl(a, b, k, !0);
                }, 1E3);
                V(a, function() {
                    b && b.h();
                    clearTimeout(h);
                });
            }, function(g) {
                if (g.name && "cancel" == g.name) b.h();
                else {
                    var h = Ml(g);
                    g = T(h);
                    switch(h.code){
                        case "auth/credential-already-in-use":
                            b.h();
                            break;
                        case "auth/code-expired":
                            h = Q(b);
                            b.h();
                            b.m();
                            L("phoneSignInStart", a, h, c, g);
                            break;
                        case "auth/missing-verification-code":
                        case "auth/invalid-verification-code":
                            b.h();
                            e(g);
                            break;
                        default:
                            b.h(), b.a(g);
                    }
                }
            }))) : e(C("Wrong code. Try again.").toString());
        }
        K.phoneSignInFinish = function(a, b, c, d, e, f) {
            var g = new fn(function() {
                g.m();
                L("phoneSignInStart", a, b, c);
            }, function() {
                gn(a, g, c, e);
            }, function() {
                g.m();
                S(a, b);
            }, function() {
                g.m();
                L("phoneSignInStart", a, b, c);
            }, Yh(c), d, H(W(a)), J(W(a)));
            g.render(b);
            Y(a, g);
            f && g.a(f);
        };
        var jn = !z && !(y("Safari") && !(Xb() || y("Coast") || y("Opera") || y("Edge") || y("Firefox") || y("FxiOS") || y("Silk") || y("Android")));
        function kn(a, b) {
            if (/-[a-z]/.test(b)) return null;
            if (jn && a.dataset) {
                if (!(!y("Android") || Xb() || y("Firefox") || y("FxiOS") || y("Opera") || y("Silk") || b in a.dataset)) return null;
                a = a.dataset[b];
                return void 0 === a ? null : a;
            }
            return a.getAttribute("data-" + String(b).replace(/([A-Z])/g, "-$1").toLowerCase());
        }
        function ln(a, b, c) {
            var d = this;
            a = hd(gk, {
                items: a
            }, null, this.s);
            nk.call(this, a, !0, !0);
            c && (c = mn(a, c)) && (c.focus(), Dj(c, a));
            O(this, a, function(e) {
                if (e = (e = ad(e.target, "firebaseui-id-list-box-dialog-button")) && kn(e, "listboxid")) ok.call(d), b(e);
            });
        }
        function mn(a, b) {
            a = (a || document).getElementsByTagName("BUTTON");
            for(var c = 0; c < a.length; c++)if (kn(a[c], "listboxid") === b) return a[c];
            return null;
        }
        function nn() {
            return M(this, "firebaseui-id-phone-number");
        }
        function on() {
            return M(this, "firebaseui-id-country-selector");
        }
        function pn() {
            return M(this, "firebaseui-id-phone-number-error");
        }
        function qn(a, b) {
            var c = a.a, d = rn("1-US-0", c), e = null;
            b && rn(b, c) ? e = b : d ? e = "1-US-0" : e = 0 < c.length ? c[0].c : null;
            if (!e) throw Error("No available default country");
            sn.call(this, e, a);
        }
        function rn(a, b) {
            a = Qh(a);
            return !(!a || !Ma(b, a));
        }
        function tn(a) {
            return a.map(function(b) {
                return {
                    id: b.c,
                    Ma: "firebaseui-flag " + un(b),
                    label: b.name + " " + ("‎+" + b.b)
                };
            });
        }
        function un(a) {
            return "firebaseui-flag-" + a.f;
        }
        function vn(a) {
            var b = this;
            ln.call(this, tn(a.a), function(c) {
                sn.call(b, c, a, !0);
                b.O().focus();
            }, this.Ba);
        }
        function sn(a, b, c) {
            var d = Qh(a);
            d && (c && (c = Ua(Yi(nn.call(this)) || ""), b = Ph(b, c), b.length && b[0].b != d.b && (c = "+" + d.b + c.substr(b[0].b.length + 1), Zi(nn.call(this), c))), b = Qh(this.Ba), this.Ba = a, a = M(this, "firebaseui-id-country-selector-flag"), b && Xi(a, un(b)), Wi(a, un(d)), $c(M(this, "firebaseui-id-country-selector-code"), "‎+" + d.b));
        }
        function wn(a, b, c, d, e, f, g, h, k, p) {
            P.call(this, gl, {
                Gb: b,
                Aa: k || null,
                Va: !!c,
                ia: !!f
            }, p, "phoneSignInStart", {
                F: d,
                D: e
            });
            this.H = h || null;
            this.M = b;
            this.l = a;
            this.w = c || null;
            this.pa = g || null;
        }
        m(wn, P);
        wn.prototype.v = function() {
            this.ea(this.pa, this.H);
            this.P(this.l, this.w || void 0);
            this.M || wk(this, this.O(), this.i());
            xk(this, this.i(), this.l);
            this.O().focus();
            Dm(this.O(), (this.O().value || "").length);
            P.prototype.v.call(this);
        };
        wn.prototype.o = function() {
            this.w = this.l = null;
            P.prototype.o.call(this);
        };
        u(wn.prototype, {
            Cb: pk,
            O: nn,
            B: pn,
            ea: function(a, b, c) {
                var d = this, e = nn.call(this), f = on.call(this), g = pn.call(this), h = a || Vh, k = h.a;
                if (0 == k.length) throw Error("No available countries provided.");
                qn.call(d, h, b);
                O(this, f, function() {
                    vn.call(d, h);
                });
                Lj(this, e, function() {
                    Rj(g) && (N(e, !0), Pj(g));
                    var p = Ua(Yi(e) || ""), t = Qh(this.Ba), I = Ph(h, p);
                    p = rn("1-US-0", k);
                    I.length && I[0].b != t.b && (t = I[0], sn.call(d, "1" == t.b && p ? "1-US-0" : t.c, h));
                });
                c && Mj(this, e, function() {
                    c();
                });
            },
            U: function(a) {
                var b = Ua(Yi(nn.call(this)) || "");
                a = a || Vh;
                var c = a.a, d = Ph(Vh, b);
                if (d.length && !Ma(c, d[0])) throw Zi(nn.call(this)), nn.call(this).focus(), Qj(pn.call(this), C("The country code provided is not supported.").toString()), Error("The country code provided is not supported.");
                c = Qh(this.Ba);
                d.length && d[0].b != c.b && sn.call(this, d[0].c, a);
                d.length && (b = b.substr(d[0].b.length + 1));
                return b ? new Wh(this.Ba, b) : null;
            },
            Ja: on,
            ba: function() {
                return M(this, "firebaseui-recaptcha-container");
            },
            u: function() {
                return M(this, "firebaseui-id-recaptcha-error");
            },
            i: ll,
            ua: ml,
            P: nl
        });
        function xn(a, b, c, d) {
            try {
                var e = b.U(Si);
            } catch (f) {
                return;
            }
            e ? Qi ? (b.$("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon", C("Verifying...").toString()), V(a, b.I(r(a.cc, a), [
                Yh(e),
                c
            ], function(f) {
                var g = Q(b);
                b.$("firebaseui-icon-done", C("Code sent!").toString());
                var h = setTimeout(function() {
                    b.h();
                    b.m();
                    L("phoneSignInFinish", a, g, e, 15, f);
                }, 1E3);
                V(a, function() {
                    b && b.h();
                    clearTimeout(h);
                });
            }, function(f) {
                b.h();
                if (!f.name || "cancel" != f.name) {
                    grecaptcha.reset(Ti);
                    Qi = null;
                    var g = f && f.message || "";
                    if (f.code) switch(f.code){
                        case "auth/too-many-requests":
                            g = C("This phone number has been used too many times").toString();
                            break;
                        case "auth/invalid-phone-number":
                        case "auth/missing-phone-number":
                            b.O().focus();
                            Qj(b.B(), Hd().toString());
                            return;
                        case "auth/admin-restricted-operation":
                            if (pi(W(a))) {
                                f = Q(b);
                                b.m();
                                L("handleUnauthorizedUser", a, f, Yh(e), (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID);
                                return;
                            }
                            g = T(f);
                            break;
                        default:
                            g = T(f);
                    }
                    b.a(g);
                }
            }))) : Ri ? Qj(b.u(), C("Solve the reCAPTCHA").toString()) : !Ri && d && b.i().click() : (b.O().focus(), Qj(b.B(), Hd().toString()));
        }
        K.phoneSignInStart = function(a, b, c, d) {
            var e = qi(W(a)) || {};
            Qi = null;
            Ri = !(e && "invisible" === e.size);
            var f = $l(a), g = zi(W(a)), h = f ? yi(W(a)) : null;
            g = c && c.a || g && g.c || null;
            c = c && c.Aa || h;
            (h = Ai(W(a))) && Uh(h);
            Si = h ? new Oh(Ai(W(a))) : Vh;
            var k = new wn(function(t) {
                xn(a, k, p, !(!t || !t.keyCode));
            }, Ri, f ? null : function() {
                p.clear();
                k.m();
                S(a, b);
            }, H(W(a)), J(W(a)), f, Si, g, c);
            k.render(b);
            Y(a, k);
            d && k.a(d);
            e.callback = function(t) {
                k.u() && Pj(k.u());
                Qi = t;
                Ri || xn(a, k, p);
            };
            e["expired-callback"] = function() {
                Qi = null;
            };
            var p = new (0, $8eXKx.default).auth.RecaptchaVerifier(Ri ? k.ba() : k.i(), e, hn(a).app);
            V(a, k.I(r(p.render, p), [], function(t) {
                Ti = t;
            }, function(t) {
                t.name && "cancel" == t.name || (t = T(t), k.m(), S(a, b, void 0, t));
            }));
        };
        K.prefilledEmailSignIn = function(a, b, c) {
            var d = new Gm;
            d.render(b);
            Y(a, d);
            V(a, d.I(r(U(a).fetchSignInMethodsForEmail, U(a)), [
                c
            ], function(e) {
                d.m();
                var f = !(!Zl(a) || !yn(a));
                cm(a, b, e, c, void 0, f);
            }, function(e) {
                e = T(e);
                d.m();
                L("signIn", a, b, c, e);
            }));
        };
        function zn(a, b, c, d, e) {
            P.call(this, fl, {
                Sb: b
            }, e, "providerSignIn", {
                F: c,
                D: d
            });
            this.i = a;
        }
        m(zn, P);
        zn.prototype.v = function() {
            this.l(this.i);
            P.prototype.v.call(this);
        };
        zn.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(zn.prototype, {
            l: function(a) {
                function b(g) {
                    a(g);
                }
                for(var c = this.g ? Tc("firebaseui-id-idp-button", this.g || this.s.a) : [], d = 0; d < c.length; d++){
                    var e = c[d], f = kn(e, "providerId");
                    O(this, e, za(b, f));
                }
            }
        });
        K.providerSignIn = function(a, b, c, d) {
            var e = new zn(function(f) {
                f == (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID ? (e.m(), am(a, b, d)) : f == (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID ? (e.m(), L("phoneSignInStart", a, b)) : "anonymous" == f ? Wl(a, e) : Tl(a, e, f, d);
                Z(a);
                a.l.cancel();
            }, ji(W(a)), H(W(a)), J(W(a)));
            e.render(b);
            Y(a, e);
            c && e.a(c);
            An(a);
        };
        K.sendEmailLinkForSignIn = function(a, b, c, d) {
            var e = new hm;
            e.render(b);
            Y(a, e);
            dm(a, e, c, d, function(f) {
                e.m();
                f && "auth/admin-restricted-operation" == f.code && pi(W(a)) ? L("handleUnauthorizedUser", a, b, c, (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID) : (f = T(f), L("signIn", a, b, c, f));
            });
        };
        function Bn(a, b, c, d, e, f, g) {
            P.call(this, yk, {
                email: c,
                Va: !!b,
                ia: !!f
            }, g, "signIn", {
                F: d,
                D: e
            });
            this.i = a;
            this.u = b;
        }
        m(Bn, P);
        Bn.prototype.v = function() {
            this.w(this.i);
            this.B(this.i, this.u || void 0);
            this.l().focus();
            Dm(this.l(), (this.l().value || "").length);
            P.prototype.v.call(this);
        };
        Bn.prototype.o = function() {
            this.u = this.i = null;
            P.prototype.o.call(this);
        };
        u(Bn.prototype, {
            l: ul,
            M: vl,
            w: wl,
            H: xl,
            j: yl,
            U: ll,
            P: ml,
            B: nl
        });
        K.signIn = function(a, b, c, d) {
            var e = Zl(a), f = new Bn(function() {
                var g = f, h = g.j() || "";
                h && bm(a, g, h);
            }, e ? null : function() {
                f.m();
                S(a, b, c);
            }, c, H(W(a)), J(W(a)), e);
            f.render(b);
            Y(a, f);
            d && f.a(d);
        };
        function Cn(a, b, c, d, e, f, g) {
            P.call(this, Pk, {
                kc: a,
                yb: c,
                Eb: !!d
            }, g, "unauthorizedUser", {
                F: e,
                D: f
            });
            this.l = b;
            this.i = d;
        }
        m(Cn, P);
        Cn.prototype.v = function() {
            var a = this, b = M(this, "firebaseui-id-unauthorized-user-help-link");
            this.i && b && O(this, b, function() {
                a.i();
            });
            O(this, this.u(), function() {
                a.l();
            });
            this.u().focus();
            P.prototype.v.call(this);
        };
        Cn.prototype.o = function() {
            this.i = this.l = null;
            P.prototype.o.call(this);
        };
        u(Cn.prototype, {
            u: ml
        });
        K.handleUnauthorizedUser = function(a, b, c, d) {
            function e() {
                S(a, b);
            }
            d === (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID ? e = function() {
                am(a, b);
            } : d === (0, $8eXKx.default).auth.PhoneAuthProvider.PROVIDER_ID && (e = function() {
                L("phoneSignInStart", a, b);
            });
            var f = null, g = null;
            d === (0, $8eXKx.default).auth.EmailAuthProvider.PROVIDER_ID && oi(W(a)) ? (f = ui(W(a)), g = vi(W(a))) : pi(W(a)) && (f = si(W(a)), g = ti(W(a)));
            var h = new Cn(c, function() {
                h.m();
                e();
            }, f, g, H(W(a)), J(W(a)));
            h.render(b);
            Y(a, h);
        };
        function Dn(a, b, c, d, e, f) {
            P.call(this, Qk, {
                email: a
            }, f, "unsupportedProvider", {
                F: d,
                D: e
            });
            this.l = b;
            this.i = c;
        }
        m(Dn, P);
        Dn.prototype.v = function() {
            this.w(this.l, this.i);
            this.u().focus();
            P.prototype.v.call(this);
        };
        Dn.prototype.o = function() {
            this.i = this.l = null;
            P.prototype.o.call(this);
        };
        u(Dn.prototype, {
            u: ll,
            B: ml,
            w: nl
        });
        K.unsupportedProvider = function(a, b, c) {
            var d = new Dn(c, function() {
                d.m();
                L("passwordRecovery", a, b, c);
            }, function() {
                d.m();
                S(a, b, c);
            }, H(W(a)), J(W(a)));
            d.render(b);
            Y(a, d);
        };
        function En(a, b) {
            this.$ = !1;
            var c = Fn(b);
            if (Gn[c]) throw Error('An AuthUI instance already exists for the key "' + c + '"');
            Gn[c] = this;
            this.a = a;
            this.u = null;
            this.Y = !1;
            Hn(this.a);
            this.h = (0, $8eXKx.default).initializeApp({
                apiKey: a.app.options.apiKey,
                authDomain: a.app.options.authDomain
            }, a.app.name + "-firebaseui-temp").auth();
            if (a = a.emulatorConfig) c = a.port, this.h.useEmulator(a.protocol + "://" + a.host + (null === c ? "" : ":" + c), a.options);
            Hn(this.h);
            this.h.setPersistence && this.h.setPersistence((0, $8eXKx.default).auth.Auth.Persistence.SESSION);
            this.oa = b;
            this.ca = new bi;
            this.g = this.T = this.i = this.J = this.O = null;
            this.s = [];
            this.Z = !1;
            this.l = Pf.Xa();
            this.j = this.C = null;
            this.da = this.A = !1;
        }
        function Hn(a) {
            a && a.INTERNAL && a.INTERNAL.logFramework && a.INTERNAL.logFramework("FirebaseUI-web");
        }
        var Gn = {};
        function Fn(a) {
            return a || "[DEFAULT]";
        }
        function Ul(a) {
            Z(a);
            a.i || (a.i = In(a, function(b) {
                return b && !zh(X(a)) ? F(hn(a).getRedirectResult().then(function(c) {
                    return c;
                }, function(c) {
                    if (c && "auth/email-already-in-use" == c.code && c.email && c.credential) throw c;
                    return Jn(a, c);
                })) : F(U(a).getRedirectResult().then(function(c) {
                    return di(W(a)) && !c.user && a.j && !a.j.isAnonymous ? hn(a).getRedirectResult() : c;
                }));
            }));
            return a.i;
        }
        function Y(a, b) {
            Z(a);
            a.g = b;
        }
        var Kn = null;
        function U(a) {
            Z(a);
            return a.h;
        }
        function hn(a) {
            Z(a);
            return a.a;
        }
        function X(a) {
            Z(a);
            return a.oa;
        }
        function yn(a) {
            Z(a);
            return a.O ? a.O.emailHint : void 0;
        }
        l = En.prototype;
        l.nb = function() {
            Z(this);
            return !!Ch(X(this)) || Ln(tf());
        };
        function Ln(a) {
            a = new Pb(a);
            return "signIn" === (a.a.a.get(x.ub) || null) && !!a.a.a.get(x.$a);
        }
        l.start = function(a, b) {
            Mn(this, a, b);
        };
        function Mn(a, b, c, d) {
            Z(a);
            "undefined" !== typeof a.a.languageCode && (a.u = a.a.languageCode);
            var e = "en".replace(/_/g, "-");
            a.a.languageCode = e;
            a.h.languageCode = e;
            a.Y = !0;
            "undefined" !== typeof a.a.tenantId && (a.h.tenantId = a.a.tenantId);
            a.ib(c);
            a.O = d || null;
            var f = n.document;
            a.C ? a.C.then(function() {
                "complete" == f.readyState ? Nn(a, b) : le(window, "load", function() {
                    Nn(a, b);
                });
            }) : "complete" == f.readyState ? Nn(a, b) : le(window, "load", function() {
                Nn(a, b);
            });
        }
        function Nn(a, b) {
            var c = sf(b, "Could not find the FirebaseUI widget element on the page.");
            c.setAttribute("lang", "en".replace(/_/g, "-"));
            if (Kn) {
                var d = Kn;
                Z(d);
                zh(X(d)) && tg("UI Widget is already rendered on the page and is pending some user interaction. Only one widget instance can be rendered per page. The previous instance has been automatically reset.");
                Kn.reset();
            }
            Kn = a;
            a.T = c;
            On(a, c);
            if (jh(new kh) && jh(new lh)) {
                b = sf(b, "Could not find the FirebaseUI widget element on the page.");
                c = tf();
                d = Jh(W(a).a, "queryParameterForSignInSuccessUrl");
                c = (c = tb(c, d)) ? zc(Bc(c)).toString() : null;
                a: {
                    d = tf();
                    var e = Bi(W(a));
                    d = tb(d, e) || "";
                    for(f in Pi)if (Pi[f].toLowerCase() == d.toLowerCase()) {
                        var f = Pi[f];
                        break a;
                    }
                    f = "callback";
                }
                switch(f){
                    case "callback":
                        c && (f = X(a), xh(sh, c, f));
                        a.nb() ? L("callback", a, b) : S(a, b, yn(a));
                        break;
                    case "resetPassword":
                        L("passwordReset", a, b, em(), fm());
                        break;
                    case "recoverEmail":
                        L("emailChangeRevocation", a, b, em());
                        break;
                    case "revertSecondFactorAddition":
                        L("revertSecondFactorAddition", a, b, em());
                        break;
                    case "verifyEmail":
                        L("emailVerification", a, b, em(), fm());
                        break;
                    case "verifyAndChangeEmail":
                        L("verifyAndChangeEmail", a, b, em(), fm());
                        break;
                    case "signIn":
                        L("emailLinkSignInCallback", a, b, tf());
                        Pn();
                        break;
                    case "select":
                        c && (f = X(a), xh(sh, c, f));
                        S(a, b);
                        break;
                    default:
                        throw Error("Unhandled widget operation.");
                }
                b = W(a);
                (b = Li(b).uiShown || null) && b();
            } else b = sf(b, "Could not find the FirebaseUI widget element on the page."), f = new Ll(C("The browser you are using does not support Web Storage. Please try again in a different browser.").toString()), f.render(b), Y(a, f);
            b = a.g && "blank" == a.g.Ga && Gi(W(a));
            Ch(X(a)) && !b && (b = Ch(X(a)), Im(a, b.a), wh(rh, X(a)));
        }
        function In(a, b) {
            if (a.A) return b(Qn(a));
            V(a, function() {
                a.A = !1;
            });
            if (di(W(a))) {
                var c = new Ve(function(d) {
                    V(a, a.a.onAuthStateChanged(function(e) {
                        a.j = e;
                        a.A || (a.A = !0, d(b(Qn(a))));
                    }));
                });
                V(a, c);
                return c;
            }
            a.A = !0;
            return b(null);
        }
        function Qn(a) {
            Z(a);
            return di(W(a)) && a.j && a.j.isAnonymous ? a.j : null;
        }
        function V(a, b) {
            Z(a);
            if (b) {
                a.s.push(b);
                var c = function() {
                    Qa(a.s, function(d) {
                        return d == b;
                    });
                };
                "function" != typeof b && b.then(c, c);
            }
        }
        l.Db = function() {
            Z(this);
            this.Z = !0;
        };
        function Rn(a) {
            Z(a);
            var b;
            (b = a.Z) || (a = W(a), a = xi(a, (0, $8eXKx.default).auth.GoogleAuthProvider.PROVIDER_ID), b = !(!a || "select_account" !== a.prompt));
            return b;
        }
        function Ol(a) {
            "undefined" !== typeof a.a.languageCode && a.Y && (a.Y = !1, a.a.languageCode = a.u);
        }
        function Im(a, b) {
            a.a.tenantId = b;
            a.h.tenantId = b;
        }
        l.reset = function() {
            Z(this);
            var a = this;
            this.T && this.T.removeAttribute("lang");
            this.J && De(this.J);
            Ol(this);
            this.O = null;
            Pn();
            wh(rh, X(this));
            Z(this);
            this.l.cancel();
            this.i = F({
                user: null,
                credential: null
            });
            Kn == this && (Kn = null);
            this.T = null;
            for(var b = 0; b < this.s.length; b++)if ("function" == typeof this.s[b]) this.s[b]();
            else this.s[b].cancel && this.s[b].cancel();
            this.s = [];
            Ah(X(this));
            this.g && (this.g.m(), this.g = null);
            this.L = null;
            this.h && (this.C = om(this).then(function() {
                a.C = null;
            }, function() {
                a.C = null;
            }));
        };
        function On(a, b) {
            a.L = null;
            a.J = new Ee(b);
            a.J.register();
            ke(a.J, "pageEnter", function(c) {
                c = c && c.pageId;
                if (a.L != c) {
                    var d = W(a);
                    (d = Li(d).uiChanged || null) && d(a.L, c);
                    a.L = c;
                }
            });
        }
        l.ib = function(a) {
            Z(this);
            var b = this.ca, c;
            for(c in a)try {
                Ih(b.a, c, a[c]);
            } catch (d) {
                og('Invalid config: "' + c + '"', void 0);
            }
            fc && Ih(b.a, "popupMode", !1);
            Ai(b);
            !this.da && Ki(W(this)) && (tg("signInSuccess callback is deprecated. Please use signInSuccessWithAuthResult callback instead."), this.da = !0);
        };
        function W(a) {
            Z(a);
            return a.ca;
        }
        l.Wb = function() {
            Z(this);
            var a = W(this), b = Jh(a.a, "widgetUrl");
            a = Bi(a);
            var c = b.search(sb);
            for(var d = 0, e, f = []; 0 <= (e = rb(b, d, a, c));)f.push(b.substring(d, e)), d = Math.min(b.indexOf("&", e) + 1 || c, c);
            f.push(b.substr(d));
            b = f.join("").replace(ub, "$1");
            c = "=" + encodeURIComponent("select");
            (a += c) ? (c = b.indexOf("#"), 0 > c && (c = b.length), d = b.indexOf("?"), 0 > d || d > c ? (d = c, e = "") : e = b.substring(d + 1, c), b = [
                b.substr(0, d),
                e,
                b.substr(c)
            ], c = b[1], b[1] = a ? c ? c + "&" + a : a : c, c = b[0] + (b[1] ? "?" + b[1] : "") + b[2]) : c = b;
            W(this).a.get("popupMode") ? (a = (window.screen.availHeight - 600) / 2, b = (window.screen.availWidth - 500) / 2, c = c || "about:blank", a = {
                width: 500,
                height: 600,
                top: 0 < a ? a : 0,
                left: 0 < b ? b : 0,
                location: !0,
                resizable: !0,
                statusbar: !0,
                toolbar: !1
            }, a.target = a.target || c.target || "google_popup", a.width = a.width || 690, a.height = a.height || 500, (a = pf(c, a)) && a.focus()) : Nc(window.location, c);
        };
        function Z(a) {
            if (a.$) throw Error("AuthUI instance is deleted!");
        }
        l.Wa = function() {
            var a = this;
            Z(this);
            return this.h.app.delete().then(function() {
                var b = Fn(X(a));
                delete Gn[b];
                a.reset();
                a.$ = !0;
            });
        };
        function An(a) {
            Z(a);
            try {
                Qf(a.l, li(W(a)), Rn(a)).then(function(b) {
                    return a.g ? Xl(a, a.g, b) : !1;
                });
            } catch (b) {}
        }
        l.Ib = function(a, b) {
            Z(this);
            var c = this, d = vf();
            if (!Di(W(this))) return df(Error("Email link sign-in should be enabled to trigger email sending."));
            var e = Fi(W(this)), f = new Pb(e.url);
            Qb(f, d);
            b && b.a && (Gh(d, b, X(this)), Tb(f, b.a.providerId));
            Rb(f, Ei(W(this)));
            return In(this, function(g) {
                g && ((g = g.uid) ? f.a.a.set(x.Pa, g) : Nb(f.a.a, x.Pa));
                e.url = f.toString();
                return U(c).sendSignInLinkToEmail(a, e);
            }).then(function() {
                var g = X(c), h = {};
                h.email = a;
                xh(th, Yg(d, JSON.stringify(h)), g);
            }, function(g) {
                wh(uh, X(c));
                wh(th, X(c));
                throw g;
            });
        };
        function Jm(a, b) {
            var c = Sb(new Pb(b));
            if (!c) return F(null);
            b = new Ve(function(d, e) {
                var f = hn(a).onAuthStateChanged(function(g) {
                    f();
                    g && g.isAnonymous && g.uid === c ? d(g) : g && g.isAnonymous && g.uid !== c ? e(Error("anonymous-user-mismatch")) : e(Error("anonymous-user-not-found"));
                });
                V(a, f);
            });
            V(a, b);
            return b;
        }
        function Nm(a, b, c, d, e) {
            Z(a);
            var f = e || null, g = (0, $8eXKx.default).auth.EmailAuthProvider.credentialWithLink(c, d);
            c = f ? U(a).signInWithEmailLink(c, d).then(function(h) {
                return h.user.linkWithCredential(f);
            }).then(function() {
                return om(a);
            }).then(function() {
                return Jn(a, {
                    code: "auth/email-already-in-use"
                }, f);
            }) : U(a).fetchSignInMethodsForEmail(c).then(function(h) {
                return h.length ? Jn(a, {
                    code: "auth/email-already-in-use"
                }, g) : b.linkWithCredential(g);
            });
            V(a, c);
            return c;
        }
        function Om(a, b, c, d) {
            Z(a);
            var e = d || null, f;
            b = U(a).signInWithEmailLink(b, c).then(function(g) {
                f = {
                    user: g.user,
                    credential: null,
                    operationType: g.operationType,
                    additionalUserInfo: g.additionalUserInfo
                };
                if (e) return g.user.linkWithCredential(e).then(function(h) {
                    f = {
                        user: h.user,
                        credential: e,
                        operationType: f.operationType,
                        additionalUserInfo: h.additionalUserInfo
                    };
                });
            }).then(function() {
                om(a);
            }).then(function() {
                return hn(a).updateCurrentUser(f.user);
            }).then(function() {
                f.user = hn(a).currentUser;
                return f;
            });
            V(a, b);
            return b;
        }
        function Pn() {
            var a = tf();
            if (Ln(a)) {
                a = new Pb(a);
                for(var b in x)x.hasOwnProperty(b) && Nb(a.a.a, x[b]);
                b = {
                    state: "signIn",
                    mode: "emailLink",
                    operation: "clear"
                };
                var c = n.document.title;
                n.history && n.history.replaceState && n.history.replaceState(b, c, a.toString());
            }
        }
        l.bc = function(a, b) {
            Z(this);
            var c = this;
            return U(this).signInWithEmailAndPassword(a, b).then(function(d) {
                return In(c, function(e) {
                    return e ? om(c).then(function() {
                        return Jn(c, {
                            code: "auth/email-already-in-use"
                        }, (0, $8eXKx.default).auth.EmailAuthProvider.credential(a, b));
                    }) : d;
                });
            });
        };
        l.Yb = function(a, b) {
            Z(this);
            var c = this;
            return In(this, function(d) {
                if (d) {
                    var e = (0, $8eXKx.default).auth.EmailAuthProvider.credential(a, b);
                    return d.linkWithCredential(e);
                }
                return U(c).createUserWithEmailAndPassword(a, b);
            });
        };
        l.ac = function(a) {
            Z(this);
            var b = this;
            return In(this, function(c) {
                return c ? c.linkWithCredential(a).then(function(d) {
                    return d;
                }, function(d) {
                    if (d && "auth/email-already-in-use" == d.code && d.email && d.credential) throw d;
                    return Jn(b, d, a);
                }) : U(b).signInWithCredential(a);
            });
        };
        function Vl(a, b) {
            Z(a);
            return In(a, function(c) {
                return c && !zh(X(a)) ? c.linkWithPopup(b).then(function(d) {
                    return d;
                }, function(d) {
                    if (d && "auth/email-already-in-use" == d.code && d.email && d.credential) throw d;
                    return Jn(a, d);
                }) : U(a).signInWithPopup(b);
            });
        }
        l.dc = function(a) {
            Z(this);
            var b = this, c = this.i;
            this.i = null;
            return In(this, function(d) {
                return d && !zh(X(b)) ? d.linkWithRedirect(a) : U(b).signInWithRedirect(a);
            }).then(function() {}, function(d) {
                b.i = c;
                throw d;
            });
        };
        l.cc = function(a, b) {
            Z(this);
            var c = this;
            return In(this, function(d) {
                return d ? d.linkWithPhoneNumber(a, b).then(function(e) {
                    return new Sf(e, function(f) {
                        if ("auth/credential-already-in-use" == f.code) return Jn(c, f);
                        throw f;
                    });
                }) : hn(c).signInWithPhoneNumber(a, b).then(function(e) {
                    return new Sf(e);
                });
            });
        };
        l.$b = function() {
            Z(this);
            return hn(this).signInAnonymously();
        };
        function Ql(a, b) {
            Z(a);
            return In(a, function(c) {
                if (a.j && !a.j.isAnonymous && di(W(a)) && !U(a).currentUser) return om(a).then(function() {
                    "password" == b.credential.providerId && (b.credential = null);
                    return b;
                });
                if (c) return om(a).then(function() {
                    return c.linkWithCredential(b.credential);
                }).then(function(d) {
                    b.user = d.user;
                    b.credential = d.credential;
                    b.operationType = d.operationType;
                    b.additionalUserInfo = d.additionalUserInfo;
                    return b;
                }, function(d) {
                    if (d && "auth/email-already-in-use" == d.code && d.email && d.credential) throw d;
                    return Jn(a, d, b.credential);
                });
                if (!b.user) throw Error('Internal error: An incompatible or outdated version of "firebase.js" may be used.');
                return om(a).then(function() {
                    return hn(a).updateCurrentUser(b.user);
                }).then(function() {
                    b.user = hn(a).currentUser;
                    b.operationType = "signIn";
                    b.credential && b.credential.providerId && "password" == b.credential.providerId && (b.credential = null);
                    return b;
                });
            });
        }
        l.Xb = function(a, b) {
            Z(this);
            return U(this).signInWithEmailAndPassword(a, b);
        };
        function om(a) {
            Z(a);
            return U(a).signOut();
        }
        function Jn(a, b, c) {
            Z(a);
            if (b && b.code && ("auth/email-already-in-use" == b.code || "auth/credential-already-in-use" == b.code)) {
                var d = ei(W(a));
                return F().then(function() {
                    return d(new Nd("anonymous-upgrade-merge-conflict", null, c || b.credential));
                }).then(function() {
                    a.g && (a.g.m(), a.g = null);
                    throw b;
                });
            }
            return df(b);
        }
        function Sn(a, b, c, d) {
            P.call(this, kl, void 0, d, "providerMatchByEmail", {
                F: b,
                D: c
            });
            this.i = a;
        }
        m(Sn, P);
        Sn.prototype.v = function() {
            this.u(this.i);
            this.w(this.i);
            this.l().focus();
            Dm(this.l(), (this.l().value || "").length);
            P.prototype.v.call(this);
        };
        Sn.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        u(Sn.prototype, {
            l: ul,
            H: vl,
            u: wl,
            B: xl,
            j: yl,
            M: ll,
            w: nl
        });
        function Tn(a, b, c, d, e) {
            P.call(this, jl, {
                ec: b
            }, e, "selectTenant", {
                F: c,
                D: d
            });
            this.i = a;
        }
        m(Tn, P);
        Tn.prototype.v = function() {
            Un(this, this.i);
            P.prototype.v.call(this);
        };
        Tn.prototype.o = function() {
            this.i = null;
            P.prototype.o.call(this);
        };
        function Un(a, b) {
            function c(h) {
                b(h);
            }
            for(var d = a.g ? Tc("firebaseui-id-tenant-selection-button", a.g || a.s.a) : [], e = 0; e < d.length; e++){
                var f = d[e], g = kn(f, "tenantId");
                O(a, f, za(c, g));
            }
        }
        function Vn(a) {
            P.call(this, Ek, void 0, a, "spinner");
        }
        m(Vn, P);
        function Wn(a) {
            this.a = new Hh;
            G(this.a, "authDomain");
            G(this.a, "displayMode", Xn);
            G(this.a, "tenants");
            G(this.a, "callbacks");
            G(this.a, "tosUrl");
            G(this.a, "privacyPolicyUrl");
            for(var b in a)if (a.hasOwnProperty(b)) try {
                Ih(this.a, b, a[b]);
            } catch (c) {
                og('Invalid config: "' + b + '"', void 0);
            }
        }
        function Yn(a) {
            a = a.a.get("displayMode");
            for(var b in Zn)if (Zn[b] === a) return Zn[b];
            return Xn;
        }
        function $n(a) {
            return a.a.get("callbacks") || {};
        }
        function ao(a) {
            var b = a.a.get("tosUrl") || null;
            a = a.a.get("privacyPolicyUrl") || null;
            b && !a && tg("Privacy Policy URL is missing, the link will not be displayed.");
            if (b && a) {
                if ("function" === typeof b) return b;
                if ("string" === typeof b) return function() {
                    rf(b);
                };
            }
            return null;
        }
        function bo(a) {
            var b = a.a.get("tosUrl") || null, c = a.a.get("privacyPolicyUrl") || null;
            c && !b && tg("Terms of Service URL is missing, the link will not be displayed.");
            if (b && c) {
                if ("function" === typeof c) return c;
                if ("string" === typeof c) return function() {
                    rf(c);
                };
            }
            return null;
        }
        function co(a, b) {
            a = a.a.get("tenants");
            if (!a || !a.hasOwnProperty(b) && !a.hasOwnProperty(eo)) throw Error("Invalid tenant configuration!");
        }
        function fo(a, b, c) {
            a = a.a.get("tenants");
            if (!a) throw Error("Invalid tenant configuration!");
            var d = [];
            a = a[b] || a[eo];
            if (!a) return og("Invalid tenant configuration: " + (b + " is not configured!"), void 0), d;
            b = a.signInOptions;
            if (!b) throw Error("Invalid tenant configuration: signInOptions are invalid!");
            b.forEach(function(e) {
                if ("string" === typeof e) d.push(e);
                else if ("string" === typeof e.provider) {
                    var f = e.hd;
                    f && c ? (f instanceof RegExp ? f : new RegExp("@" + f.replace(".", "\\.") + "$")).test(c) && d.push(e.provider) : d.push(e.provider);
                } else e = "Invalid tenant configuration: signInOption " + (JSON.stringify(e) + " is invalid!"), og(e, void 0);
            });
            return d;
        }
        function go(a, b, c) {
            a = ho(a, b);
            (b = a.signInOptions) && c && (b = b.filter(function(d) {
                return "string" === typeof d ? c.includes(d) : c.includes(d.provider);
            }), a.signInOptions = b);
            return a;
        }
        function ho(a, b) {
            var c = io;
            var d = void 0 === d ? {} : d;
            co(a, b);
            a = a.a.get("tenants");
            return wf(a[b] || a[eo], c, d);
        }
        var io = [
            "immediateFederatedRedirect",
            "privacyPolicyUrl",
            "signInFlow",
            "signInOptions",
            "tosUrl"
        ], Xn = "optionFirst", Zn = {
            qc: Xn,
            pc: "identifierFirst"
        }, eo = "*";
        function jo(a, b) {
            var c = this;
            this.s = sf(a);
            this.a = {};
            Object.keys(b).forEach(function(d) {
                c.a[d] = new Wn(b[d]);
            });
            this.ob = this.g = this.A = this.h = this.i = this.j = null;
            Object.defineProperty(this, "languageCode", {
                get: function() {
                    return this.ob;
                },
                set: function(d) {
                    this.ob = d || null;
                },
                enumerable: !1
            });
        }
        l = jo.prototype;
        l.Ub = function(a, b) {
            var c = this;
            ko(this);
            var d = a.apiKey;
            return new Ve(function(e, f) {
                if (c.a.hasOwnProperty(d)) {
                    var g = $n(c.a[d]).selectTenantUiHidden || null;
                    if (Yn(c.a[d]) === Xn) {
                        var h = [];
                        b.forEach(function(t) {
                            t = t || "_";
                            var I = c.a[d].a.get("tenants");
                            if (!I) throw Error("Invalid tenant configuration!");
                            (I = I[t] || I[eo]) ? t = {
                                tenantId: "_" !== t ? t : null,
                                V: I.fullLabel || null,
                                displayName: I.displayName,
                                za: I.iconUrl,
                                ta: I.buttonColor
                            } : (og("Invalid tenant configuration: " + (t + " is not configured!"), void 0), t = null);
                            t && h.push(t);
                        });
                        var k = function(t) {
                            t = {
                                tenantId: t,
                                providerIds: fo(c.a[d], t || "_")
                            };
                            e(t);
                        };
                        if (1 === h.length) {
                            k(h[0].tenantId);
                            return;
                        }
                        c.g = new Tn(function(t) {
                            ko(c);
                            g && g();
                            k(t);
                        }, h, ao(c.a[d]), bo(c.a[d]));
                    } else c.g = new Sn(function() {
                        var t = c.g.j();
                        if (t) {
                            for(var I = 0; I < b.length; I++){
                                var Ca = fo(c.a[d], b[I] || "_", t);
                                if (0 !== Ca.length) {
                                    t = {
                                        tenantId: b[I],
                                        providerIds: Ca,
                                        email: t
                                    };
                                    ko(c);
                                    g && g();
                                    e(t);
                                    return;
                                }
                            }
                            c.g.a(Ld({
                                code: "no-matching-tenant-for-email"
                            }).toString());
                        }
                    }, ao(c.a[d]), bo(c.a[d]));
                    c.g.render(c.s);
                    (f = $n(c.a[d]).selectTenantUiShown || null) && f();
                } else {
                    var p = Error("Invalid project configuration: API key is invalid!");
                    p.code = "invalid-configuration";
                    c.pb(p);
                    f(p);
                }
            });
        };
        l.Pb = function(a, b) {
            if (!this.a.hasOwnProperty(a)) throw Error("Invalid project configuration: API key is invalid!");
            var c = b || void 0;
            co(this.a[a], b || "_");
            try {
                this.i = (0, $8eXKx.default).app(c).auth();
            } catch (e) {
                var d = this.a[a].a.get("authDomain");
                if (!d) throw Error("Invalid project configuration: authDomain is required!");
                a = (0, $8eXKx.default).initializeApp({
                    apiKey: a,
                    authDomain: d
                }, c);
                a.auth().tenantId = b;
                this.i = a.auth();
            }
            return this.i;
        };
        l.Zb = function(a, b) {
            var c = this;
            return new Ve(function(d, e) {
                function f(I, Ca) {
                    c.j = new En(a);
                    Mn(c.j, c.s, I, Ca);
                }
                var g = a.app.options.apiKey;
                c.a.hasOwnProperty(g) || e(Error("Invalid project configuration: API key is invalid!"));
                var h = go(c.a[g], a.tenantId || "_", b && b.providerIds);
                ko(c);
                e = {
                    signInSuccessWithAuthResult: function(I) {
                        d(I);
                        return !1;
                    }
                };
                var k = $n(c.a[g]).signInUiShown || null, p = !1;
                e.uiChanged = function(I, Ca) {
                    null === I && "callback" === Ca ? ((I = Vc("firebaseui-id-page-callback", c.s)) && Pj(I), c.h = new Vn, c.h.render(c.s)) : p || null === I && "spinner" === Ca || "blank" === Ca || (c.h && (c.h.m(), c.h = null), p = !0, k && k(a.tenantId));
                };
                h.callbacks = e;
                h.credentialHelper = "none";
                var t;
                b && b.email && (t = {
                    emailHint: b.email
                });
                c.j ? c.j.Wa().then(function() {
                    f(h, t);
                }) : f(h, t);
            });
        };
        l.reset = function() {
            var a = this;
            return F().then(function() {
                a.j && a.j.Wa();
            }).then(function() {
                a.j = null;
                ko(a);
            });
        };
        l.Vb = function() {
            var a = this;
            this.h || this.A || (this.A = window.setTimeout(function() {
                ko(a);
                a.h = new Vn;
                a.g = a.h;
                a.h.render(a.s);
                a.A = null;
            }, 500));
        };
        l.mb = function() {
            window.clearTimeout(this.A);
            this.A = null;
            this.h && (this.h.m(), this.h = null);
        };
        l.Bb = function() {
            ko(this);
            this.g = new Gl;
            this.g.render(this.s);
            return F();
        };
        function ko(a) {
            a.j && a.j.reset();
            a.mb();
            a.g && a.g.m();
        }
        l.pb = function(a) {
            var b = this, c = Ld({
                code: a.code
            }).toString() || a.message;
            ko(this);
            var d;
            a.retry && "function" === typeof a.retry && (d = function() {
                b.reset();
                a.retry();
            });
            this.g = new Kl(c, d);
            this.g.render(this.s);
        };
        l.Rb = function(a) {
            var b = this;
            return F().then(function() {
                var c = b.i && b.i.app.options.apiKey;
                if (!b.a.hasOwnProperty(c)) throw Error("Invalid project configuration: API key is invalid!");
                co(b.a[c], a.tenantId || "_");
                if (!b.i.currentUser || b.i.currentUser.uid !== a.uid) throw Error("The user being processed does not match the signed in user!");
                return (c = $n(b.a[c]).beforeSignInSuccess || null) ? c(a) : a;
            }).then(function(c) {
                if (c.uid !== a.uid) throw Error("User with mismatching UID returned.");
                return c;
            });
        };
        v("firebaseui.auth.FirebaseUiHandler", jo);
        v("firebaseui.auth.FirebaseUiHandler.prototype.selectTenant", jo.prototype.Ub);
        v("firebaseui.auth.FirebaseUiHandler.prototype.getAuth", jo.prototype.Pb);
        v("firebaseui.auth.FirebaseUiHandler.prototype.startSignIn", jo.prototype.Zb);
        v("firebaseui.auth.FirebaseUiHandler.prototype.reset", jo.prototype.reset);
        v("firebaseui.auth.FirebaseUiHandler.prototype.showProgressBar", jo.prototype.Vb);
        v("firebaseui.auth.FirebaseUiHandler.prototype.hideProgressBar", jo.prototype.mb);
        v("firebaseui.auth.FirebaseUiHandler.prototype.completeSignOut", jo.prototype.Bb);
        v("firebaseui.auth.FirebaseUiHandler.prototype.handleError", jo.prototype.pb);
        v("firebaseui.auth.FirebaseUiHandler.prototype.processUser", jo.prototype.Rb);
        v("firebaseui.auth.AuthUI", En);
        v("firebaseui.auth.AuthUI.getInstance", function(a) {
            a = Fn(a);
            return Gn[a] ? Gn[a] : null;
        });
        v("firebaseui.auth.AuthUI.prototype.disableAutoSignIn", En.prototype.Db);
        v("firebaseui.auth.AuthUI.prototype.start", En.prototype.start);
        v("firebaseui.auth.AuthUI.prototype.setConfig", En.prototype.ib);
        v("firebaseui.auth.AuthUI.prototype.signIn", En.prototype.Wb);
        v("firebaseui.auth.AuthUI.prototype.reset", En.prototype.reset);
        v("firebaseui.auth.AuthUI.prototype.delete", En.prototype.Wa);
        v("firebaseui.auth.AuthUI.prototype.isPendingRedirect", En.prototype.nb);
        v("firebaseui.auth.AuthUIError", Nd);
        v("firebaseui.auth.AuthUIError.prototype.toJSON", Nd.prototype.toJSON);
        v("firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM", Ni);
        v("firebaseui.auth.CredentialHelper.GOOGLE_YOLO", ni);
        v("firebaseui.auth.CredentialHelper.NONE", ci);
        v("firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID", "anonymous");
        Ve.prototype["catch"] = Ve.prototype.Ca;
        Ve.prototype["finally"] = Ve.prototype.fc;
    }).apply(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : window);
}).apply(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : window);
if (typeof window !== "undefined") window.dialogPolyfill = (0, (/*@__PURE__*/$parcel$interopDefault($b094N)));
var $f47f371a591be597$export$73693bad9f5880b0 = firebaseui.auth;

});
parcelRequire.register("dZzSU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8eXKx")).default; });

var $8eXKx = parcelRequire("8eXKx");
var $a2fccecfe810de45$var$name = "firebase";
var $a2fccecfe810de45$var$version = "8.10.1";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $8eXKx.default).registerVersion($a2fccecfe810de45$var$name, $a2fccecfe810de45$var$version, "app");
(0, $8eXKx.default).SDK_VERSION = $a2fccecfe810de45$var$version;

});
parcelRequire.register("8eXKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ffdfa90a38b8096$export$2e2bcd8739ae039; });

var $2WUgS = parcelRequire("2WUgS");

var $eTAKc = parcelRequire("eTAKc");

var $4TGB3 = parcelRequire("4TGB3");

var $i4pDv = parcelRequire("i4pDv");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5ffdfa90a38b8096$var$_a$1;
var $5ffdfa90a38b8096$var$ERRORS = ($5ffdfa90a38b8096$var$_a$1 = {}, $5ffdfa90a38b8096$var$_a$1["no-app" /* NO_APP */ ] = "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()", $5ffdfa90a38b8096$var$_a$1["bad-app-name" /* BAD_APP_NAME */ ] = "Illegal App name: '{$appName}", $5ffdfa90a38b8096$var$_a$1["duplicate-app" /* DUPLICATE_APP */ ] = "Firebase App named '{$appName}' already exists", $5ffdfa90a38b8096$var$_a$1["app-deleted" /* APP_DELETED */ ] = "Firebase App named '{$appName}' already deleted", $5ffdfa90a38b8096$var$_a$1["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ] = "firebase.{$appName}() takes either no argument or a Firebase App instance.", $5ffdfa90a38b8096$var$_a$1["invalid-log-argument" /* INVALID_LOG_ARGUMENT */ ] = "First argument to `onLog` must be null or a function.", $5ffdfa90a38b8096$var$_a$1);
var $5ffdfa90a38b8096$var$ERROR_FACTORY = new (0, $eTAKc.ErrorFactory)("app", "Firebase", $5ffdfa90a38b8096$var$ERRORS);
var $5ffdfa90a38b8096$var$name$c = "@firebase/app";
var $5ffdfa90a38b8096$var$version$1 = "0.6.30";
var $5ffdfa90a38b8096$var$name$b = "@firebase/analytics";
var $5ffdfa90a38b8096$var$name$a = "@firebase/app-check";
var $5ffdfa90a38b8096$var$name$9 = "@firebase/auth";
var $5ffdfa90a38b8096$var$name$8 = "@firebase/database";
var $5ffdfa90a38b8096$var$name$7 = "@firebase/functions";
var $5ffdfa90a38b8096$var$name$6 = "@firebase/installations";
var $5ffdfa90a38b8096$var$name$5 = "@firebase/messaging";
var $5ffdfa90a38b8096$var$name$4 = "@firebase/performance";
var $5ffdfa90a38b8096$var$name$3 = "@firebase/remote-config";
var $5ffdfa90a38b8096$var$name$2 = "@firebase/storage";
var $5ffdfa90a38b8096$var$name$1 = "@firebase/firestore";
var $5ffdfa90a38b8096$var$name = "firebase-wrapper";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5ffdfa90a38b8096$var$_a;
var $5ffdfa90a38b8096$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
var $5ffdfa90a38b8096$var$PLATFORM_LOG_STRING = ($5ffdfa90a38b8096$var$_a = {}, $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$c] = "fire-core", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$b] = "fire-analytics", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$a] = "fire-app-check", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$9] = "fire-auth", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$8] = "fire-rtdb", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$7] = "fire-fn", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$6] = "fire-iid", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$5] = "fire-fcm", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$4] = "fire-perf", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$3] = "fire-rc", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$2] = "fire-gcs", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name$1] = "fire-fst", $5ffdfa90a38b8096$var$_a["fire-js"] = "fire-js", $5ffdfa90a38b8096$var$_a[$5ffdfa90a38b8096$var$name] = "fire-js-all", $5ffdfa90a38b8096$var$_a);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5ffdfa90a38b8096$var$logger = new (0, $i4pDv.Logger)("@firebase/app");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Global context object for a collection of services using
 * a shared authentication state.
 */ var $5ffdfa90a38b8096$var$FirebaseAppImpl = /** @class */ function() {
    function FirebaseAppImpl(options, config, firebase_) {
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ = config.automaticDataCollectionEnabled || false;
        this.options_ = (0, $eTAKc.deepCopy)(options);
        this.container = new (0, $4TGB3.ComponentContainer)(config.name);
        // add itself to container
        this._addComponent(new (0, $4TGB3.Component)("app", function() {
            return _this;
        }, "PUBLIC" /* PUBLIC */ ));
        // populate ComponentContainer with existing components
        this.firebase_.INTERNAL.components.forEach(function(component) {
            return _this._addComponent(component);
        });
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function() {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function(val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function() {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function() {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function() {
        var _this = this;
        return new Promise(function(resolve) {
            _this.checkDestroyed_();
            resolve();
        }).then(function() {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function(provider) {
                return provider.delete();
            }));
        }).then(function() {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */ FirebaseAppImpl.prototype._getService = function(name, instanceIdentifier) {
        var _a;
        if (instanceIdentifier === void 0) instanceIdentifier = $5ffdfa90a38b8096$var$DEFAULT_ENTRY_NAME;
        this.checkDestroyed_();
        // Initialize instance if InstatiationMode is `EXPLICIT`.
        var provider = this.container.getProvider(name);
        if (!provider.isInitialized() && ((_a = provider.getComponent()) === null || _a === void 0 ? void 0 : _a.instantiationMode) === "EXPLICIT" /* EXPLICIT */ ) provider.initialize();
        // getImmediate will always succeed because _getService is only called for registered components.
        return provider.getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */ FirebaseAppImpl.prototype._removeServiceInstance = function(name, instanceIdentifier) {
        if (instanceIdentifier === void 0) instanceIdentifier = $5ffdfa90a38b8096$var$DEFAULT_ENTRY_NAME;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */ FirebaseAppImpl.prototype._addComponent = function(component) {
        try {
            this.container.addComponent(component);
        } catch (e) {
            $5ffdfa90a38b8096$var$logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function(component) {
        this.container.addOrOverwriteComponent(component);
    };
    FirebaseAppImpl.prototype.toJSON = function() {
        return {
            name: this.name,
            automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
            options: this.options
        };
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ FirebaseAppImpl.prototype.checkDestroyed_ = function() {
        if (this.isDeleted_) throw $5ffdfa90a38b8096$var$ERROR_FACTORY.create("app-deleted" /* APP_DELETED */ , {
            appName: this.name_
        });
    };
    return FirebaseAppImpl;
}();
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
$5ffdfa90a38b8096$var$FirebaseAppImpl.prototype.name && $5ffdfa90a38b8096$var$FirebaseAppImpl.prototype.options || $5ffdfa90a38b8096$var$FirebaseAppImpl.prototype.delete || console.log("dc");
var $5ffdfa90a38b8096$var$version = "8.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */ function $5ffdfa90a38b8096$var$createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: (0, $i4pDv.setLogLevel),
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: $5ffdfa90a38b8096$var$version,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace["default"] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, "apps", {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */ function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */ function app(name) {
        name = name || $5ffdfa90a38b8096$var$DEFAULT_ENTRY_NAME;
        if (!(0, $eTAKc.contains)(apps, name)) throw $5ffdfa90a38b8096$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
            appName: name
        });
        return apps[name];
    }
    // @ts-ignore
    app["App"] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) rawConfig = {};
        if (typeof rawConfig !== "object" || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = {
                name: name_1
            };
        }
        var config = rawConfig;
        if (config.name === undefined) config.name = $5ffdfa90a38b8096$var$DEFAULT_ENTRY_NAME;
        var name = config.name;
        if (typeof name !== "string" || !name) throw $5ffdfa90a38b8096$var$ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */ , {
            appName: String(name)
        });
        if ((0, $eTAKc.contains)(apps, name)) throw $5ffdfa90a38b8096$var$ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */ , {
            appName: name
        });
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */ function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function(name) {
            return apps[name];
        });
    }
    function registerComponent(component) {
        var componentName = component.name;
        if (components.has(componentName)) {
            $5ffdfa90a38b8096$var$logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */ ) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function(appArg) {
                if (appArg === void 0) appArg = app();
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== "function") // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw $5ffdfa90a38b8096$var$ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */ , {
                    appName: componentName
                });
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) (0, $eTAKc.deepExtend)(serviceNamespace, component.serviceProps);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] = // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var serviceFxn = this._getService.bind(this, componentName);
                return serviceFxn.apply(this, component.multipleInstances ? args : []);
            };
        }
        // add the component to existing app instances
        for(var _i = 0, _a = Object.keys(apps); _i < _a.length; _i++){
            var appName = _a[_i];
            apps[appName]._addComponent(component);
        }
        return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = $5ffdfa90a38b8096$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) library += "-" + variant;
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                'Unable to register library "' + library + '" with version "' + version + '":'
            ];
            if (libraryMismatch) warning.push('library name "' + library + '" contains illegal characters (whitespace or "/")');
            if (libraryMismatch && versionMismatch) warning.push("and");
            if (versionMismatch) warning.push('version name "' + version + '" contains illegal characters (whitespace or "/")');
            $5ffdfa90a38b8096$var$logger.warn(warning.join(" "));
            return;
        }
        registerComponent(new (0, $4TGB3.Component)(library + "-version", function() {
            return {
                library: library,
                version: version
            };
        }, "VERSION" /* VERSION */ ));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== "function") throw $5ffdfa90a38b8096$var$ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */ );
        (0, $i4pDv.setUserLogHandler)(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === "serverAuth") return null;
        var useService = name;
        return useService;
    }
    return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */ function $5ffdfa90a38b8096$var$createFirebaseNamespace() {
    var namespace = $5ffdfa90a38b8096$var$createFirebaseNamespaceCore($5ffdfa90a38b8096$var$FirebaseAppImpl);
    namespace.INTERNAL = (0, $2WUgS.__assign)((0, $2WUgS.__assign)({}, namespace.INTERNAL), {
        createFirebaseNamespace: $5ffdfa90a38b8096$var$createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: (0, $eTAKc.createSubscribe),
        ErrorFactory: (0, $eTAKc.ErrorFactory),
        deepExtend: (0, $eTAKc.deepExtend)
    });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */ function extendNamespace(props) {
        (0, $eTAKc.deepExtend)(namespace, props);
    }
    return namespace;
}
var $5ffdfa90a38b8096$var$firebase$1 = $5ffdfa90a38b8096$var$createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5ffdfa90a38b8096$var$PlatformLoggerService = /** @class */ function() {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function() {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map(function(provider) {
            if ($5ffdfa90a38b8096$var$isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            } else return null;
        }).filter(function(logString) {
            return logString;
        }).join(" ");
    };
    return PlatformLoggerService;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $5ffdfa90a38b8096$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5ffdfa90a38b8096$var$registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new (0, $4TGB3.Component)("platform-logger", function(container) {
        return new $5ffdfa90a38b8096$var$PlatformLoggerService(container);
    }, "PRIVATE" /* PRIVATE */ ));
    // Register `app` package.
    firebase.registerVersion($5ffdfa90a38b8096$var$name$c, $5ffdfa90a38b8096$var$version$1, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion("fire-js", "");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((0, $eTAKc.isBrowser)() && self.firebase !== undefined) {
    $5ffdfa90a38b8096$var$logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var $5ffdfa90a38b8096$var$sdkVersion = self.firebase.SDK_VERSION;
    if ($5ffdfa90a38b8096$var$sdkVersion && $5ffdfa90a38b8096$var$sdkVersion.indexOf("LITE") >= 0) $5ffdfa90a38b8096$var$logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
}
var $5ffdfa90a38b8096$var$initializeApp = $5ffdfa90a38b8096$var$firebase$1.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$5ffdfa90a38b8096$var$firebase$1.initializeApp = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if ((0, $eTAKc.isNode)()) $5ffdfa90a38b8096$var$logger.warn('\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the "main" field in package.json.\n      \n      If you are using Webpack, you can specify "main" as the first item in\n      "resolve.mainFields":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the @rollup/plugin-node-resolve plugin and specify "main"\n      as the first item in "mainFields", e.g. [\'main\', \'module\'].\n      https://github.com/rollup/@rollup/plugin-node-resolve\n      ');
    return $5ffdfa90a38b8096$var$initializeApp.apply(undefined, args);
};
var $5ffdfa90a38b8096$export$d7fa33c07db7fa7b = $5ffdfa90a38b8096$var$firebase$1;
$5ffdfa90a38b8096$var$registerCoreComponents($5ffdfa90a38b8096$export$d7fa33c07db7fa7b);
var $5ffdfa90a38b8096$export$2e2bcd8739ae039 = $5ffdfa90a38b8096$export$d7fa33c07db7fa7b;

});
parcelRequire.register("2WUgS", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $225ca5dbb961a3d2$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $225ca5dbb961a3d2$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $225ca5dbb961a3d2$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $225ca5dbb961a3d2$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $225ca5dbb961a3d2$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $225ca5dbb961a3d2$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $225ca5dbb961a3d2$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $225ca5dbb961a3d2$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $225ca5dbb961a3d2$var$extendStatics = function(d, b) {
    $225ca5dbb961a3d2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $225ca5dbb961a3d2$var$extendStatics(d, b);
};
function $225ca5dbb961a3d2$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $225ca5dbb961a3d2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $225ca5dbb961a3d2$export$18ce0697a983be9b = function() {
    $225ca5dbb961a3d2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $225ca5dbb961a3d2$export$18ce0697a983be9b.apply(this, arguments);
};
function $225ca5dbb961a3d2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $225ca5dbb961a3d2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $225ca5dbb961a3d2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $225ca5dbb961a3d2$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $225ca5dbb961a3d2$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $225ca5dbb961a3d2$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $225ca5dbb961a3d2$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $225ca5dbb961a3d2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $225ca5dbb961a3d2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $225ca5dbb961a3d2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $225ca5dbb961a3d2$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $225ca5dbb961a3d2$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $225ca5dbb961a3d2$export$45d3717a4c69092e(o, m, p);
}
function $225ca5dbb961a3d2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $225ca5dbb961a3d2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $225ca5dbb961a3d2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($225ca5dbb961a3d2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $225ca5dbb961a3d2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $225ca5dbb961a3d2$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $225ca5dbb961a3d2$export$10c90e4f7922046c(v) {
    return this instanceof $225ca5dbb961a3d2$export$10c90e4f7922046c ? (this.v = v, this) : new $225ca5dbb961a3d2$export$10c90e4f7922046c(v);
}
function $225ca5dbb961a3d2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $225ca5dbb961a3d2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $225ca5dbb961a3d2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $225ca5dbb961a3d2$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $225ca5dbb961a3d2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $225ca5dbb961a3d2$export$19a8beecd37a4c45 === "function" ? $225ca5dbb961a3d2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $225ca5dbb961a3d2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $225ca5dbb961a3d2$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $225ca5dbb961a3d2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $225ca5dbb961a3d2$export$45d3717a4c69092e(result, mod, k);
    }
    $225ca5dbb961a3d2$var$__setModuleDefault(result, mod);
    return result;
}
function $225ca5dbb961a3d2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $225ca5dbb961a3d2$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $225ca5dbb961a3d2$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $225ca5dbb961a3d2$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $225ca5dbb961a3d2$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $225ca5dbb961a3d2$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $225ca5dbb961a3d2$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $225ca5dbb961a3d2$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $225ca5dbb961a3d2$export$2e2bcd8739ae039 = {
    __extends: $225ca5dbb961a3d2$export$a8ba968b8961cb8a,
    __assign: $225ca5dbb961a3d2$export$18ce0697a983be9b,
    __rest: $225ca5dbb961a3d2$export$3c9a16f847548506,
    __decorate: $225ca5dbb961a3d2$export$29e00dfd3077644b,
    __param: $225ca5dbb961a3d2$export$d5ad3fd78186038f,
    __metadata: $225ca5dbb961a3d2$export$f1db080c865becb9,
    __awaiter: $225ca5dbb961a3d2$export$1050f835b63b671e,
    __generator: $225ca5dbb961a3d2$export$67ebef60e6f28a6,
    __createBinding: $225ca5dbb961a3d2$export$45d3717a4c69092e,
    __exportStar: $225ca5dbb961a3d2$export$f33643c0debef087,
    __values: $225ca5dbb961a3d2$export$19a8beecd37a4c45,
    __read: $225ca5dbb961a3d2$export$8d051b38c9118094,
    __spread: $225ca5dbb961a3d2$export$afc72e2116322959,
    __spreadArrays: $225ca5dbb961a3d2$export$6388937ca91ccae8,
    __spreadArray: $225ca5dbb961a3d2$export$1216008129fb82ed,
    __await: $225ca5dbb961a3d2$export$10c90e4f7922046c,
    __asyncGenerator: $225ca5dbb961a3d2$export$e427f37a30a4de9b,
    __asyncDelegator: $225ca5dbb961a3d2$export$bbd80228419bb833,
    __asyncValues: $225ca5dbb961a3d2$export$e3b29a3d6162315f,
    __makeTemplateObject: $225ca5dbb961a3d2$export$4fb47efe1390b86f,
    __importStar: $225ca5dbb961a3d2$export$c21735bcef00d192,
    __importDefault: $225ca5dbb961a3d2$export$da59b14a69baef04,
    __classPrivateFieldGet: $225ca5dbb961a3d2$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $225ca5dbb961a3d2$export$d40a35129aaff81f,
    __classPrivateFieldIn: $225ca5dbb961a3d2$export$81fdc39f203e4e04,
    __addDisposableResource: $225ca5dbb961a3d2$export$88ac25d8e944e405,
    __disposeResources: $225ca5dbb961a3d2$export$8f076105dc360e92
};

});

parcelRequire.register("eTAKc", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $ad82b4614260f042$export$a7a9523472993e97; });
$parcel$export(module.exports, "assertionError", function () { return $ad82b4614260f042$export$a39cad550e7ab28a; });
$parcel$export(module.exports, "base64", function () { return $ad82b4614260f042$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64Encode", function () { return $ad82b4614260f042$export$e510a73ee562749; });
$parcel$export(module.exports, "deepCopy", function () { return $ad82b4614260f042$export$6c40052bed430212; });
$parcel$export(module.exports, "deepExtend", function () { return $ad82b4614260f042$export$54e9fb29908872fa; });
$parcel$export(module.exports, "Deferred", function () { return $ad82b4614260f042$export$85f6557964517f1a; });
$parcel$export(module.exports, "createMockUserToken", function () { return $ad82b4614260f042$export$367bf224123348f1; });
$parcel$export(module.exports, "getUA", function () { return $ad82b4614260f042$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $ad82b4614260f042$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isNode", function () { return $ad82b4614260f042$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isBrowser", function () { return $ad82b4614260f042$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $ad82b4614260f042$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $ad82b4614260f042$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isElectron", function () { return $ad82b4614260f042$export$f2f6a8999f8ebd30; });
$parcel$export(module.exports, "isIE", function () { return $ad82b4614260f042$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isUWP", function () { return $ad82b4614260f042$export$202944b2d2824246; });
$parcel$export(module.exports, "isNodeSdk", function () { return $ad82b4614260f042$export$5d1d834fbbf8bab7; });
$parcel$export(module.exports, "isSafari", function () { return $ad82b4614260f042$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $ad82b4614260f042$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $ad82b4614260f042$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "areCookiesEnabled", function () { return $ad82b4614260f042$export$f172b7eb6cf60599; });
$parcel$export(module.exports, "FirebaseError", function () { return $ad82b4614260f042$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $ad82b4614260f042$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "jsonEval", function () { return $ad82b4614260f042$export$c5a53ce6a17cf18d; });
$parcel$export(module.exports, "stringify", function () { return $ad82b4614260f042$export$fac44ee5b035f737; });
$parcel$export(module.exports, "isValidFormat", function () { return $ad82b4614260f042$export$9565ca3d387f8aa0; });
$parcel$export(module.exports, "isAdmin", function () { return $ad82b4614260f042$export$fc970ed23da99565; });
$parcel$export(module.exports, "contains", function () { return $ad82b4614260f042$export$2344b14b097df817; });
$parcel$export(module.exports, "safeGet", function () { return $ad82b4614260f042$export$e51ae4db7b428f67; });
$parcel$export(module.exports, "isEmpty", function () { return $ad82b4614260f042$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "map", function () { return $ad82b4614260f042$export$871de8747c9eaa88; });
$parcel$export(module.exports, "querystring", function () { return $ad82b4614260f042$export$ac4103b836844853; });
$parcel$export(module.exports, "Sha1", function () { return $ad82b4614260f042$export$c85d589bf4e25fef; });
$parcel$export(module.exports, "createSubscribe", function () { return $ad82b4614260f042$export$364097d812234b3f; });
$parcel$export(module.exports, "validateArgCount", function () { return $ad82b4614260f042$export$20164226a0ed35c3; });
$parcel$export(module.exports, "errorPrefix", function () { return $ad82b4614260f042$export$adea4917e02d93dc; });
$parcel$export(module.exports, "validateCallback", function () { return $ad82b4614260f042$export$5bcd2a2eb6640dfa; });
$parcel$export(module.exports, "validateContextObject", function () { return $ad82b4614260f042$export$df77539402cfb523; });
$parcel$export(module.exports, "stringToByteArray", function () { return $ad82b4614260f042$export$655666783217a925; });
$parcel$export(module.exports, "stringLength", function () { return $ad82b4614260f042$export$9536dc0a75b20bf9; });
$parcel$export(module.exports, "calculateBackoffMillis", function () { return $ad82b4614260f042$export$4d810c0ca64ed8e9; });
$parcel$export(module.exports, "getModularInstance", function () { return $ad82b4614260f042$export$4befe9b5fa509a1b; });

var $2WUgS = parcelRequire("2WUgS");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $ad82b4614260f042$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $ad82b4614260f042$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $ad82b4614260f042$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $ad82b4614260f042$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $ad82b4614260f042$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ad82b4614260f042$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $ad82b4614260f042$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $ad82b4614260f042$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($ad82b4614260f042$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $ad82b4614260f042$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ var $ad82b4614260f042$export$e510a73ee562749 = function(str) {
    var utf8Bytes = $ad82b4614260f042$var$stringToByteArray$1(str);
    return $ad82b4614260f042$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ var $ad82b4614260f042$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $ad82b4614260f042$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $ad82b4614260f042$export$c62426fdd000a97e = function(str) {
    try {
        return $ad82b4614260f042$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $ad82b4614260f042$export$6c40052bed430212(value) {
    return $ad82b4614260f042$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $ad82b4614260f042$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$ad82b4614260f042$var$isValidKey(prop)) continue;
        target[prop] = $ad82b4614260f042$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $ad82b4614260f042$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ad82b4614260f042$export$85f6557964517f1a = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ Deferred.prototype.wrapCallback = function(callback) {
        var _this = this;
        return function(error, value) {
            if (error) _this.reject(error);
            else _this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function() {});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    };
    return Deferred;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $ad82b4614260f042$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: "none",
        type: "JWT"
    };
    var project = projectId || "demo-project";
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    var payload = (0, $2WUgS.__assign)({
        // Set all required fields to decent defaults
        iss: "https://securetoken.google.com/" + project,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = "";
    return [
        $ad82b4614260f042$export$4b5284a3025a455(JSON.stringify(header)),
        $ad82b4614260f042$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $ad82b4614260f042$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $ad82b4614260f042$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($ad82b4614260f042$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $ad82b4614260f042$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $ad82b4614260f042$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $ad82b4614260f042$export$caa8774a9107a58e() {
    var runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $ad82b4614260f042$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $ad82b4614260f042$export$f2f6a8999f8ebd30() {
    return $ad82b4614260f042$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $ad82b4614260f042$export$7e7b1a9668aaed8() {
    var ua = $ad82b4614260f042$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $ad82b4614260f042$export$202944b2d2824246() {
    return $ad82b4614260f042$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $ad82b4614260f042$export$5d1d834fbbf8bab7() {
    return $ad82b4614260f042$export$588c7fdda06fbb0a.NODE_CLIENT === true || $ad82b4614260f042$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $ad82b4614260f042$export$95df08bae54cb4df() {
    return !$ad82b4614260f042$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $ad82b4614260f042$export$3865db50535c2055() {
    return "indexedDB" in self && indexedDB != null;
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $ad82b4614260f042$export$a8a3018f3d187a4d() {
    return new Promise(function(resolve, reject) {
        try {
            var preExist_1 = true;
            var DB_CHECK_NAME_1 = "validate-browser-context-for-indexeddb-analytics-module";
            var request_1 = self.indexedDB.open(DB_CHECK_NAME_1);
            request_1.onsuccess = function() {
                request_1.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist_1) self.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
                resolve(true);
            };
            request_1.onupgradeneeded = function() {
                preExist_1 = false;
            };
            request_1.onerror = function() {
                var _a;
                reject(((_a = request_1.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $ad82b4614260f042$export$f172b7eb6cf60599() {
    if (!navigator || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $ad82b4614260f042$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ad82b4614260f042$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $ad82b4614260f042$export$dd24e9cd51226c56 = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(FirebaseError, _super);
    function FirebaseError(code, message, customData) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.customData = customData;
        _this.name = $ad82b4614260f042$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(_this, $ad82b4614260f042$export$3fa6e1b18a3b2d40.prototype.create);
        return _this;
    }
    return FirebaseError;
}(Error);
var $ad82b4614260f042$export$3fa6e1b18a3b2d40 = /** @class */ function() {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function(code) {
        var data = [];
        for(var _i = 1; _i < arguments.length; _i++)data[_i - 1] = arguments[_i];
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? $ad82b4614260f042$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new $ad82b4614260f042$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    };
    return ErrorFactory;
}();
function $ad82b4614260f042$var$replaceTemplate(template, data) {
    return template.replace($ad82b4614260f042$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? String(value) : "<" + key + "?>";
    });
}
var $ad82b4614260f042$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $ad82b4614260f042$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $ad82b4614260f042$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $ad82b4614260f042$export$2f872c0f2117be69 = function(token) {
    var header = {}, claims = {}, data = {}, signature = "";
    try {
        var parts = token.split(".");
        header = $ad82b4614260f042$export$c5a53ce6a17cf18d($ad82b4614260f042$export$c62426fdd000a97e(parts[0]) || "");
        claims = $ad82b4614260f042$export$c5a53ce6a17cf18d($ad82b4614260f042$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $ad82b4614260f042$export$5f870fcca7ae6a88 = function(token) {
    var claims = $ad82b4614260f042$export$2f872c0f2117be69(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $ad82b4614260f042$export$701c661ec91095f2 = function(token) {
    var claims = $ad82b4614260f042$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $ad82b4614260f042$export$9565ca3d387f8aa0 = function(token) {
    var decoded = $ad82b4614260f042$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $ad82b4614260f042$export$fc970ed23da99565 = function(token) {
    var claims = $ad82b4614260f042$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $ad82b4614260f042$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $ad82b4614260f042$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $ad82b4614260f042$export$dd1bc94b04021eeb(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $ad82b4614260f042$export$871de8747c9eaa88(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $ad82b4614260f042$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    for(var _i = 0, aKeys_1 = aKeys; _i < aKeys_1.length; _i++){
        var k = aKeys_1[_i];
        if (!bKeys.includes(k)) return false;
        var aProp = a[k];
        var bProp = b[k];
        if ($ad82b4614260f042$var$isObject(aProp) && $ad82b4614260f042$var$isObject(bProp)) {
            if (!$ad82b4614260f042$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for(var _a = 0, bKeys_1 = bKeys; _a < bKeys_1.length; _a++){
        var k = bKeys_1[_a];
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $ad82b4614260f042$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $ad82b4614260f042$export$ac4103b836844853(querystringParams) {
    var params = [];
    var _loop_1 = function(key, value) {
        if (Array.isArray(value)) value.forEach(function(arrayVal) {
            params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
        });
        else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    };
    for(var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $ad82b4614260f042$export$c1271ca4c8a70741(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach(function(token) {
        if (token) {
            var _a = token.split("="), key = _a[0], value = _a[1];
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $ad82b4614260f042$export$1a8408415472d8ed(url) {
    var queryStart = url.indexOf("?");
    if (!queryStart) return "";
    var fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $ad82b4614260f042$export$c85d589bf4e25fef = /** @class */ function() {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    Sha1.prototype.reset = function() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ Sha1.prototype.compress_ = function(buf, offset) {
        if (!offset) offset = 0;
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(var i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(var i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(var i = 16; i < 80; i++){
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(var i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            var t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    };
    Sha1.prototype.update = function(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */ Sha1.prototype.digest = function() {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(var i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for(var i = 0; i < 5; i++)for(var j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    };
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $ad82b4614260f042$export$364097d812234b3f(executor, onNoObservers) {
    var proxy = new $ad82b4614260f042$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $ad82b4614260f042$var$ObserverProxy = /** @class */ function() {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function(value) {
        this.forEachObserver(function(observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function(error) {
        this.forEachObserver(function(observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function() {
        this.forEachObserver(function(observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ ObserverProxy.prototype.subscribe = function(nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($ad82b4614260f042$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $ad82b4614260f042$var$noop;
        if (observer.error === undefined) observer.error = $ad82b4614260f042$var$noop;
        if (observer.complete === undefined) observer.complete = $ad82b4614260f042$var$noop;
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            try {
                if (_this.finalError) observer.error(_this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    };
    ObserverProxy.prototype.forEachObserver = function(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function(i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                fn(_this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    };
    ObserverProxy.prototype.close = function(err) {
        var _this = this;
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $ad82b4614260f042$export$12af436354f1a4f7(fn, onError) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        Promise.resolve(true).then(function() {
            fn.apply(void 0, args);
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $ad82b4614260f042$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for(var _i = 0, methods_1 = methods; _i < methods_1.length; _i++){
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $ad82b4614260f042$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $ad82b4614260f042$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        var error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $ad82b4614260f042$export$adea4917e02d93dc(fnName, argName) {
    return fnName + " failed: " + argName + " argument ";
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $ad82b4614260f042$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($ad82b4614260f042$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $ad82b4614260f042$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($ad82b4614260f042$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $ad82b4614260f042$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($ad82b4614260f042$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $ad82b4614260f042$export$655666783217a925 = function(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $ad82b4614260f042$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $ad82b4614260f042$export$9536dc0a75b20bf9 = function(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ var $ad82b4614260f042$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ var $ad82b4614260f042$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ var $ad82b4614260f042$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ var $ad82b4614260f042$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $ad82b4614260f042$export$4d810c0ca64ed8e9(backoffCount, intervalMillis, backoffFactor) {
    if (intervalMillis === void 0) intervalMillis = $ad82b4614260f042$var$DEFAULT_INTERVAL_MILLIS;
    if (backoffFactor === void 0) backoffFactor = $ad82b4614260f042$var$DEFAULT_BACKOFF_FACTOR;
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $ad82b4614260f042$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($ad82b4614260f042$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $ad82b4614260f042$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return "" + i;
    return i + $ad82b4614260f042$var$indicator(i);
}
function $ad82b4614260f042$var$indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    var dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $ad82b4614260f042$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});

parcelRequire.register("4TGB3", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $390d574870a865ab$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "Provider", function () { return $390d574870a865ab$export$2881499e37b75b9a; });
$parcel$export(module.exports, "ComponentContainer", function () { return $390d574870a865ab$export$436a80eea5d5c0c5; });

var $2WUgS = parcelRequire("2WUgS");

var $eTAKc = parcelRequire("eTAKc");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $390d574870a865ab$export$16fa2f45be04daa8 = /** @class */ function() {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
    Component.prototype.setInstantiationMode = function(mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function(props) {
        this.serviceProps = props;
        return this;
    };
    Component.prototype.setInstanceCreatedCallback = function(callback) {
        this.onInstanceCreated = callback;
        return this;
    };
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $390d574870a865ab$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $390d574870a865ab$export$2881499e37b75b9a = /** @class */ function() {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ Provider.prototype.get = function(identifier) {
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new (0, $eTAKc.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                var instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error("Service " + this.name + " is not available");
        }
    };
    Provider.prototype.getComponent = function() {
        return this.component;
    };
    Provider.prototype.setComponent = function(component) {
        var e_1, _a;
        if (component.name !== this.name) throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        if (this.component) throw Error("Component for " + this.name + " has already been provided");
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($390d574870a865ab$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $390d574870a865ab$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for(var _b = (0, $2WUgS.__values)(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = (0, $2WUgS.__read)(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    instanceDeferred.resolve(instance);
                } catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Provider.prototype.clearInstance = function(identifier) {
        if (identifier === void 0) identifier = $390d574870a865ab$var$DEFAULT_ENTRY_NAME;
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var services;
            return (0, $2WUgS.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        services = Array.from(this.instances.values());
                        return [
                            4 /*yield*/ ,
                            Promise.all((0, $2WUgS.__spreadArray)((0, $2WUgS.__spreadArray)([], (0, $2WUgS.__read)(services.filter(function(service) {
                                return "INTERNAL" in service;
                            }) // legacy services
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            .map(function(service) {
                                return service.INTERNAL.delete();
                            }))), (0, $2WUgS.__read)(services.filter(function(service) {
                                return "_delete" in service;
                            }) // modularized services
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            .map(function(service) {
                                return service._delete();
                            }))))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function() {
        return this.component != null;
    };
    Provider.prototype.isInitialized = function(identifier) {
        if (identifier === void 0) identifier = $390d574870a865ab$var$DEFAULT_ENTRY_NAME;
        return this.instances.has(identifier);
    };
    Provider.prototype.getOptions = function(identifier) {
        if (identifier === void 0) identifier = $390d574870a865ab$var$DEFAULT_ENTRY_NAME;
        return this.instancesOptions.get(identifier) || {};
    };
    Provider.prototype.initialize = function(opts) {
        var e_2, _a;
        if (opts === void 0) opts = {};
        var _b = opts.options, options = _b === void 0 ? {} : _b;
        var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(this.name + "(" + normalizedIdentifier + ") has already been initialized");
        if (!this.isComponentSet()) throw Error("Component " + this.name + " has not been registered yet");
        var instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        try {
            // resolve any pending promise waiting for the service instance
            for(var _c = (0, $2WUgS.__values)(this.instancesDeferred.entries()), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = (0, $2WUgS.__read)(_d.value, 2), instanceIdentifier = _e[0], instanceDeferred = _e[1];
                var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return instance;
    };
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ Provider.prototype.onInit = function(callback, identifier) {
        var _a;
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        var existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return function() {
            existingCallbacks.delete(callback);
        };
    };
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ Provider.prototype.invokeOnInitCallbacks = function(instance, identifier) {
        var e_3, _a;
        var callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        try {
            for(var callbacks_1 = (0, $2WUgS.__values)(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()){
                var callback = callbacks_1_1.value;
                try {
                    callback(instance, identifier);
                } catch (_b) {
                // ignore errors in the onInit callback
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    Provider.prototype.getOrInitializeService = function(_a) {
        var instanceIdentifier = _a.instanceIdentifier, _b = _a.options, options = _b === void 0 ? {} : _b;
        var instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $390d574870a865ab$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_c) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function(identifier) {
        if (identifier === void 0) identifier = $390d574870a865ab$var$DEFAULT_ENTRY_NAME;
        if (this.component) return this.component.multipleInstances ? identifier : $390d574870a865ab$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    };
    Provider.prototype.shouldAutoInitialize = function() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    };
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $390d574870a865ab$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $390d574870a865ab$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $390d574870a865ab$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $390d574870a865ab$export$436a80eea5d5c0c5 = /** @class */ function() {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ ComponentContainer.prototype.addComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error("Component " + component.name + " has already been registered with " + this.name);
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ ComponentContainer.prototype.getProvider = function(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new $390d574870a865ab$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function() {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}();

});

parcelRequire.register("i4pDv", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $d27c7c86ece948b7$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $d27c7c86ece948b7$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $d27c7c86ece948b7$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $d27c7c86ece948b7$export$29577d29c84db5f6; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $d27c7c86ece948b7$var$__spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d27c7c86ece948b7$var$_a;
/**
 * A container for all of the Logger instances
 */ var $d27c7c86ece948b7$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $d27c7c86ece948b7$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($d27c7c86ece948b7$export$243e62d78d3b544d || ($d27c7c86ece948b7$export$243e62d78d3b544d = {}));
var $d27c7c86ece948b7$var$levelStringToEnum = {
    "debug": $d27c7c86ece948b7$export$243e62d78d3b544d.DEBUG,
    "verbose": $d27c7c86ece948b7$export$243e62d78d3b544d.VERBOSE,
    "info": $d27c7c86ece948b7$export$243e62d78d3b544d.INFO,
    "warn": $d27c7c86ece948b7$export$243e62d78d3b544d.WARN,
    "error": $d27c7c86ece948b7$export$243e62d78d3b544d.ERROR,
    "silent": $d27c7c86ece948b7$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $d27c7c86ece948b7$var$defaultLogLevel = $d27c7c86ece948b7$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $d27c7c86ece948b7$var$ConsoleMethod = ($d27c7c86ece948b7$var$_a = {}, $d27c7c86ece948b7$var$_a[$d27c7c86ece948b7$export$243e62d78d3b544d.DEBUG] = "log", $d27c7c86ece948b7$var$_a[$d27c7c86ece948b7$export$243e62d78d3b544d.VERBOSE] = "log", $d27c7c86ece948b7$var$_a[$d27c7c86ece948b7$export$243e62d78d3b544d.INFO] = "info", $d27c7c86ece948b7$var$_a[$d27c7c86ece948b7$export$243e62d78d3b544d.WARN] = "warn", $d27c7c86ece948b7$var$_a[$d27c7c86ece948b7$export$243e62d78d3b544d.ERROR] = "error", $d27c7c86ece948b7$var$_a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $d27c7c86ece948b7$var$defaultLogHandler = function(instance, logType) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $d27c7c86ece948b7$var$ConsoleMethod[logType];
    if (method) console[method].apply(console, $d27c7c86ece948b7$var$__spreadArrays([
        "[" + now + "]  " + instance.name + ":"
    ], args));
    else throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
};
var $d27c7c86ece948b7$export$efa9a398d6368992 = /** @class */ function() {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $d27c7c86ece948b7$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $d27c7c86ece948b7$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $d27c7c86ece948b7$var$instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function() {
            return this._logLevel;
        },
        set: function(val) {
            if (!(val in $d27c7c86ece948b7$export$243e62d78d3b544d)) throw new TypeError('Invalid value "' + val + '" assigned to `logLevel`');
            this._logLevel = val;
        },
        enumerable: false,
        configurable: true
    });
    // Workaround for setter/getter having to be the same type.
    Logger.prototype.setLogLevel = function(val) {
        this._logLevel = typeof val === "string" ? $d27c7c86ece948b7$var$levelStringToEnum[val] : val;
    };
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function() {
            return this._logHandler;
        },
        set: function(val) {
            if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
            this._logHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function() {
            return this._userLogHandler;
        },
        set: function(val) {
            this._userLogHandler = val;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */ Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.DEBUG
        ], args));
        this._logHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.DEBUG
        ], args));
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.VERBOSE
        ], args));
        this._logHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.VERBOSE
        ], args));
    };
    Logger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.INFO
        ], args));
        this._logHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.INFO
        ], args));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.WARN
        ], args));
        this._logHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.WARN
        ], args));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.ERROR
        ], args));
        this._logHandler.apply(this, $d27c7c86ece948b7$var$__spreadArrays([
            this,
            $d27c7c86ece948b7$export$243e62d78d3b544d.ERROR
        ], args));
    };
    return Logger;
}();
function $d27c7c86ece948b7$export$c622e99c0ce7b1c9(level) {
    $d27c7c86ece948b7$var$instances.forEach(function(inst) {
        inst.setLogLevel(level);
    });
}
function $d27c7c86ece948b7$export$29577d29c84db5f6(logCallback, options) {
    var _loop_1 = function(instance) {
        var customLogLevel = null;
        if (options && options.level) customLogLevel = $d27c7c86ece948b7$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = function(instance, level) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            var message = args.map(function(arg) {
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter(function(arg) {
                return arg;
            }).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $d27c7c86ece948b7$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    };
    for(var _i = 0, instances_1 = $d27c7c86ece948b7$var$instances; _i < instances_1.length; _i++){
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}

});



parcelRequire.register("iG8u9", function(module, exports) {
parcelRequire("ii5tz");

});
parcelRequire.register("ii5tz", function(module, exports) {

var $8eXKx = parcelRequire("8eXKx");
(function() {
    var k, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    };
    function ba(a) {
        a = [
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global,
            a
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        return globalThis;
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                e in c || (c[e] = {});
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    }
    function fa(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : {
            next: ea(a)
        };
    }
    da("Promise", function(a) {
        function b(g) {
            this.b = 0;
            this.c = void 0;
            this.a = [];
            var h = this.f();
            try {
                g(h.resolve, h.reject);
            } catch (m) {
                h.reject(m);
            }
        }
        function c() {
            this.a = null;
        }
        function d(g) {
            return g instanceof b ? g : new b(function(h) {
                h(g);
            });
        }
        if (a) return a;
        c.prototype.b = function(g) {
            if (null == this.a) {
                this.a = [];
                var h = this;
                this.c(function() {
                    h.g();
                });
            }
            this.a.push(g);
        };
        var e = ca.setTimeout;
        c.prototype.c = function(g) {
            e(g, 0);
        };
        c.prototype.g = function() {
            for(; this.a && this.a.length;){
                var g = this.a;
                this.a = [];
                for(var h = 0; h < g.length; ++h){
                    var m = g[h];
                    g[h] = null;
                    try {
                        m();
                    } catch (p) {
                        this.f(p);
                    }
                }
            }
            this.a = null;
        };
        c.prototype.f = function(g) {
            this.c(function() {
                throw g;
            });
        };
        b.prototype.f = function() {
            function g(p) {
                return function(v) {
                    m || (m = !0, p.call(h, v));
                };
            }
            var h = this, m = !1;
            return {
                resolve: g(this.m),
                reject: g(this.g)
            };
        };
        b.prototype.m = function(g) {
            if (g === this) this.g(new TypeError("A Promise cannot resolve to itself"));
            else if (g instanceof b) this.s(g);
            else {
                a: switch(typeof g){
                    case "object":
                        var h = null != g;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.v(g) : this.h(g);
            }
        };
        b.prototype.v = function(g) {
            var h = void 0;
            try {
                h = g.then;
            } catch (m) {
                this.g(m);
                return;
            }
            "function" == typeof h ? this.u(h, g) : this.h(g);
        };
        b.prototype.g = function(g) {
            this.i(2, g);
        };
        b.prototype.h = function(g) {
            this.i(1, g);
        };
        b.prototype.i = function(g, h) {
            if (0 != this.b) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.b);
            this.b = g;
            this.c = h;
            this.l();
        };
        b.prototype.l = function() {
            if (null != this.a) {
                for(var g = 0; g < this.a.length; ++g)f.b(this.a[g]);
                this.a = null;
            }
        };
        var f = new c;
        b.prototype.s = function(g) {
            var h = this.f();
            g.Ra(h.resolve, h.reject);
        };
        b.prototype.u = function(g, h) {
            var m = this.f();
            try {
                g.call(h, m.resolve, m.reject);
            } catch (p) {
                m.reject(p);
            }
        };
        b.prototype.then = function(g, h) {
            function m(A, Q) {
                return "function" == typeof A ? function(ya) {
                    try {
                        p(A(ya));
                    } catch (Ad) {
                        v(Ad);
                    }
                } : Q;
            }
            var p, v, B = new b(function(A, Q) {
                p = A;
                v = Q;
            });
            this.Ra(m(g, p), m(h, v));
            return B;
        };
        b.prototype.catch = function(g) {
            return this.then(void 0, g);
        };
        b.prototype.Ra = function(g, h) {
            function m() {
                switch(p.b){
                    case 1:
                        g(p.c);
                        break;
                    case 2:
                        h(p.c);
                        break;
                    default:
                        throw Error("Unexpected state: " + p.b);
                }
            }
            var p = this;
            null == this.a ? f.b(m) : this.a.push(m);
        };
        b.resolve = d;
        b.reject = function(g) {
            return new b(function(h, m) {
                m(g);
            });
        };
        b.race = function(g) {
            return new b(function(h, m) {
                for(var p = fa(g), v = p.next(); !v.done; v = p.next())d(v.value).Ra(h, m);
            });
        };
        b.all = function(g) {
            var h = fa(g), m = h.next();
            return m.done ? d([]) : new b(function(p, v) {
                function B(ya) {
                    return function(Ad) {
                        A[ya] = Ad;
                        Q--;
                        0 == Q && p(A);
                    };
                }
                var A = [], Q = 0;
                do A.push(void 0), Q++, d(m.value).Ra(B(A.length - 1), v), m = h.next();
                while (!m.done);
            });
        };
        return b;
    });
    var ha = ha || {}, l = this || self, ia = /^[\w+/_-]+[=]{0,2}$/, ja = null;
    function ka(a) {
        return (a = a.querySelector && a.querySelector("script[nonce]")) && (a = a.nonce || a.getAttribute("nonce")) && ia.test(a) ? a : "";
    }
    function la() {}
    function ma(a) {
        var b = typeof a;
        return "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    }
    function na(a) {
        var b = ma(a);
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function oa(a) {
        return "function" == ma(a);
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function pa(a) {
        return Object.prototype.hasOwnProperty.call(a, qa) && a[qa] || (a[qa] = ++ra);
    }
    var qa = "closure_uid_" + (1E9 * Math.random() >>> 0), ra = 0;
    function sa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ta(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function q(a, b, c) {
        Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? q = sa : q = ta;
        return q.apply(null, arguments);
    }
    function ua(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    var va = Date.now;
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.bb = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
    }
    function wa(a) {
        return a;
    }
    function t(a, b, c) {
        this.code = xa + a;
        this.message = b || za[a] || "";
        this.a = c || null;
    }
    r(t, Error);
    t.prototype.w = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.a && (a.serverResponse = this.a);
        return a;
    };
    t.prototype.toJSON = function() {
        return this.w();
    };
    function Aa(a) {
        var b = a && a.code;
        return b ? new t(b.substring(xa.length), a.message, a.serverResponse) : null;
    }
    var xa = "auth/", za = {
        "admin-restricted-operation": "This operation is restricted to administrators only.",
        "argument-error": "",
        "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        "code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
        "cordova-not-ready": "Cordova framework is not ready.",
        "cors-unsupported": "This browser is not supported.",
        "credential-already-in-use": "This credential is already associated with a different user account.",
        "custom-token-mismatch": "The custom token corresponds to a different audience.",
        "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        "email-change-needs-verification": "Multi-factor users must always have a verified email.",
        "email-already-in-use": "The email address is already in use by another account.",
        "expired-action-code": "The action code has expired. ",
        "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
        "internal-error": "An internal error has occurred.",
        "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        "invalid-app-id": "The mobile app identifier is not registed for the current project.",
        "invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        "invalid-auth-event": "An internal error has occurred.",
        "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        "invalid-continue-uri": "The continue URL provided in the request is invalid.",
        "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
        "invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
        "invalid-email": "The email address is badly formatted.",
        "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
        "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
        "invalid-credential": "The supplied auth credential is malformed or has expired.",
        "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
        "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
        "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        "wrong-password": "The password is invalid or the user does not have a password.",
        "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
        "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        "invalid-provider-id": "The specified provider ID is invalid.",
        "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
        "invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
        "multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
        "multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
        "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
        "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
        "missing-continue-uri": "A continue URL must be provided in the request.",
        "missing-iframe-start": "An internal error has occurred.",
        "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
        "missing-multi-factor-info": "No second factor identifier is provided.",
        "missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
        "missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        "missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
        "missing-verification-id": "The phone auth credential was created with an empty verification ID.",
        "app-deleted": "This instance of FirebaseApp has been deleted.",
        "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
        "no-auth-event": "An internal error has occurred.",
        "no-such-provider": "User was not linked to an account with the given provider.",
        "null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
        "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
        "provider-already-linked": "User can only be linked to one identity for the given provider.",
        "quota-exceeded": "The project's quota for this operation has been exceeded.",
        "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
        "redirect-operation-pending": "A redirect sign-in operation is already pending.",
        "rejected-credential": "The request contains malformed or mismatching credentials.",
        "second-factor-already-in-use": "The second factor is already enrolled on this account.",
        "maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
        "tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
        timeout: "The operation has timed out.",
        "user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
        "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
        "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        "unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        "unsupported-persistence-type": "The current environment does not support the specified persistence type.",
        "unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
        "unverified-email": "The operation requires a verified email.",
        "user-cancelled": "The user did not grant your application the permissions it requested.",
        "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
        "user-disabled": "The user account has been disabled by an administrator.",
        "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
        "user-signed-out": "",
        "weak-password": "The password must be 6 characters long or more.",
        "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
    };
    var Ba = {
        ld: {
            Ua: "https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            $a: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Xa: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "b"
        },
        sd: {
            Ua: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/",
            $a: "https://securetoken.googleapis.com/v1/token",
            Xa: "https://identitytoolkit.googleapis.com/v2/",
            id: "p"
        },
        ud: {
            Ua: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            $a: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Xa: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "s"
        },
        vd: {
            Ua: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",
            $a: "https://test-securetoken.sandbox.googleapis.com/v1/token",
            Xa: "https://test-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "t"
        }
    };
    function Ca(a) {
        for(var b in Ba)if (Ba[b].id === a) return a = Ba[b], {
            firebaseEndpoint: a.Ua,
            secureTokenEndpoint: a.$a,
            identityPlatformEndpoint: a.Xa
        };
        return null;
    }
    var Da;
    Da = Ca("__EID__") ? "__EID__" : void 0;
    function Ea(a) {
        if (!a) return !1;
        try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    }
    function u(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, u);
        else {
            var b = Error().stack;
            b && (this.stack = b);
        }
        a && (this.message = String(a));
    }
    r(u, Error);
    u.prototype.name = "CustomError";
    function Fa(a, b) {
        a = a.split("%s");
        for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
        u.call(this, c + a[d]);
    }
    r(Fa, u);
    Fa.prototype.name = "AssertionError";
    function Ga(a, b) {
        throw new Fa("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    }
    function Ha(a, b) {
        this.c = a;
        this.f = b;
        this.b = 0;
        this.a = null;
    }
    Ha.prototype.get = function() {
        if (0 < this.b) {
            this.b--;
            var a = this.a;
            this.a = a.next;
            a.next = null;
        } else a = this.c();
        return a;
    };
    function Ia(a, b) {
        a.f(b);
        100 > a.b && (a.b++, b.next = a.a, a.a = b);
    }
    function Ja() {
        this.b = this.a = null;
    }
    var La = new Ha(function() {
        return new Ka;
    }, function(a) {
        a.reset();
    });
    Ja.prototype.add = function(a, b) {
        var c = La.get();
        c.set(a, b);
        this.b ? this.b.next = c : this.a = c;
        this.b = c;
    };
    function Ma() {
        var a = Na, b = null;
        a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
        return b;
    }
    function Ka() {
        this.next = this.b = this.a = null;
    }
    Ka.prototype.set = function(a, b) {
        this.a = a;
        this.b = b;
        this.next = null;
    };
    Ka.prototype.reset = function() {
        this.next = this.b = this.a = null;
    };
    var Oa = Array.prototype.indexOf ? function(a, b) {
        return Array.prototype.indexOf.call(a, b, void 0);
    } : function(a, b) {
        if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
        for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
        return -1;
    }, w = Array.prototype.forEach ? function(a, b, c) {
        Array.prototype.forEach.call(a, b, c);
    } : function(a, b, c) {
        for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
    };
    function Pa(a, b) {
        for(var c = "string" === typeof a ? a.split("") : a, d = a.length - 1; 0 <= d; --d)d in c && b.call(void 0, c[d], d, a);
    }
    var Qa = Array.prototype.filter ? function(a, b) {
        return Array.prototype.filter.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = [], e = 0, f = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)if (g in f) {
            var h = f[g];
            b.call(void 0, h, g, a) && (d[e++] = h);
        }
        return d;
    }, Ra = Array.prototype.map ? function(a, b) {
        return Array.prototype.map.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = Array(c), e = "string" === typeof a ? a.split("") : a, f = 0; f < c; f++)f in e && (d[f] = b.call(void 0, e[f], f, a));
        return d;
    }, Sa = Array.prototype.some ? function(a, b) {
        return Array.prototype.some.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) return !0;
        return !1;
    };
    function Ta(a) {
        a: {
            var b = Ua;
            for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
                b = e;
                break a;
            }
            b = -1;
        }
        return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
    }
    function Va(a, b) {
        return 0 <= Oa(a, b);
    }
    function Wa(a, b) {
        b = Oa(a, b);
        var c;
        (c = 0 <= b) && Array.prototype.splice.call(a, b, 1);
        return c;
    }
    function Xa(a, b) {
        var c = 0;
        Pa(a, function(d, e) {
            b.call(void 0, d, e, a) && 1 == Array.prototype.splice.call(a, e, 1).length && c++;
        });
    }
    function Ya(a) {
        return Array.prototype.concat.apply([], arguments);
    }
    function Za(a) {
        var b = a.length;
        if (0 < b) {
            for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    var $a = String.prototype.trim ? function(a) {
        return a.trim();
    } : function(a) {
        return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
    }, ab = /&/g, bb = /</g, cb = />/g, db = /"/g, eb = /'/g, fb = /\x00/g, gb = /[\x00&<>"']/;
    function x(a, b) {
        return -1 != a.indexOf(b);
    }
    function hb(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    var ib;
    a: {
        var jb = l.navigator;
        if (jb) {
            var kb = jb.userAgent;
            if (kb) {
                ib = kb;
                break a;
            }
        }
        ib = "";
    }
    function y(a) {
        return x(ib, a);
    }
    function lb(a, b) {
        for(var c in a)b.call(void 0, a[c], c, a);
    }
    function mb(a) {
        for(var b in a)return !1;
        return !0;
    }
    function nb(a) {
        var b = {}, c;
        for(c in a)b[c] = a[c];
        return b;
    }
    var ob = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function z(a, b) {
        for(var c, d, e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(var f = 0; f < ob.length; f++)c = ob[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function pb(a, b) {
        a: {
            try {
                var c = a && a.ownerDocument, d = c && (c.defaultView || c.parentWindow);
                d = d || l;
                if (d.Element && d.Location) {
                    var e = d;
                    break a;
                }
            } catch (g) {}
            e = null;
        }
        if (e && "undefined" != typeof e[b] && (!a || !(a instanceof e[b]) && (a instanceof e.Location || a instanceof e.Element))) {
            if (n(a)) try {
                var f = a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
            } catch (g) {
                f = "<object could not be stringified>";
            }
            else f = void 0 === a ? "undefined" : null === a ? "null" : typeof a;
            Ga("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, f);
        }
    }
    function qb(a, b) {
        this.a = a === rb && b || "";
        this.b = sb;
    }
    qb.prototype.ta = !0;
    qb.prototype.sa = function() {
        return this.a;
    };
    qb.prototype.toString = function() {
        return "Const{" + this.a + "}";
    };
    function tb(a) {
        if (a instanceof qb && a.constructor === qb && a.b === sb) return a.a;
        Ga("expected object of type Const, got '" + a + "'");
        return "type_error:Const";
    }
    var sb = {}, rb = {};
    var ub;
    function vb() {
        if (void 0 === ub) {
            var a = null, b = l.trustedTypes;
            if (b && b.createPolicy) {
                try {
                    a = b.createPolicy("goog#html", {
                        createHTML: wa,
                        createScript: wa,
                        createScriptURL: wa
                    });
                } catch (c) {
                    l.console && l.console.error(c.message);
                }
                ub = a;
            } else ub = a;
        }
        return ub;
    }
    function wb(a, b) {
        this.a = b === xb ? a : "";
    }
    wb.prototype.ta = !0;
    wb.prototype.sa = function() {
        return this.a.toString();
    };
    wb.prototype.toString = function() {
        return "TrustedResourceUrl{" + this.a + "}";
    };
    function yb(a) {
        if (a instanceof wb && a.constructor === wb) return a.a;
        Ga("expected object of type TrustedResourceUrl, got '" + a + "' of type " + ma(a));
        return "type_error:TrustedResourceUrl";
    }
    function zb(a, b) {
        var c = tb(a);
        if (!Ab.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
        a = c.replace(Bb, function(d, e) {
            if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
            d = b[e];
            return d instanceof qb ? tb(d) : encodeURIComponent(String(d));
        });
        return Cb(a);
    }
    var Bb = /%{(\w+)}/g, Ab = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, xb = {};
    function Cb(a) {
        var b = vb();
        a = b ? b.createScriptURL(a) : a;
        return new wb(a, xb);
    }
    function C(a, b) {
        this.a = b === Db ? a : "";
    }
    C.prototype.ta = !0;
    C.prototype.sa = function() {
        return this.a.toString();
    };
    C.prototype.toString = function() {
        return "SafeUrl{" + this.a + "}";
    };
    function Eb(a) {
        if (a instanceof C && a.constructor === C) return a.a;
        Ga("expected object of type SafeUrl, got '" + a + "' of type " + ma(a));
        return "type_error:SafeUrl";
    }
    var Fb = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, Gb = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, Hb = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
    function Ib(a) {
        if (a instanceof C) return a;
        a = "object" == typeof a && a.ta ? a.sa() : String(a);
        if (Hb.test(a)) a = new C(a, Db);
        else {
            a = String(a);
            a = a.replace(/(%0A|%0D)/g, "");
            var b = a.match(Gb);
            a = b && Fb.test(b[1]) ? new C(a, Db) : null;
        }
        return a;
    }
    function Jb(a) {
        if (a instanceof C) return a;
        a = "object" == typeof a && a.ta ? a.sa() : String(a);
        Hb.test(a) || (a = "about:invalid#zClosurez");
        return new C(a, Db);
    }
    var Db = {}, Kb = new C("about:invalid#zClosurez", Db);
    function Lb(a, b, c) {
        this.a = c === Mb ? a : "";
    }
    Lb.prototype.ta = !0;
    Lb.prototype.sa = function() {
        return this.a.toString();
    };
    Lb.prototype.toString = function() {
        return "SafeHtml{" + this.a + "}";
    };
    function Nb(a) {
        if (a instanceof Lb && a.constructor === Lb) return a.a;
        Ga("expected object of type SafeHtml, got '" + a + "' of type " + ma(a));
        return "type_error:SafeHtml";
    }
    var Mb = {};
    function Ob(a, b) {
        pb(a, "HTMLScriptElement");
        a.src = yb(b);
        (b = a.ownerDocument && a.ownerDocument.defaultView) && b != l ? b = ka(b.document) : (null === ja && (ja = ka(l.document)), b = ja);
        b && a.setAttribute("nonce", b);
    }
    function Pb(a, b, c, d) {
        a = a instanceof C ? a : Jb(a);
        b = b || l;
        c = c instanceof qb ? tb(c) : c || "";
        return b.open(Eb(a), c, d, void 0);
    }
    function Qb(a, b) {
        for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
        return d + c.join("%s");
    }
    function Rb(a) {
        gb.test(a) && (-1 != a.indexOf("&") && (a = a.replace(ab, "&amp;")), -1 != a.indexOf("<") && (a = a.replace(bb, "&lt;")), -1 != a.indexOf(">") && (a = a.replace(cb, "&gt;")), -1 != a.indexOf('"') && (a = a.replace(db, "&quot;")), -1 != a.indexOf("'") && (a = a.replace(eb, "&#39;")), -1 != a.indexOf("\x00") && (a = a.replace(fb, "&#0;")));
        return a;
    }
    function Sb(a) {
        Sb[" "](a);
        return a;
    }
    Sb[" "] = la;
    function Tb(a, b) {
        var c = Ub;
        return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    }
    var Vb = y("Opera"), Wb = y("Trident") || y("MSIE"), Xb = y("Edge"), Yb = Xb || Wb, Zb = y("Gecko") && !(x(ib.toLowerCase(), "webkit") && !y("Edge")) && !(y("Trident") || y("MSIE")) && !y("Edge"), $b = x(ib.toLowerCase(), "webkit") && !y("Edge");
    function ac() {
        var a = l.document;
        return a ? a.documentMode : void 0;
    }
    var bc;
    a: {
        var cc = "", dc = function() {
            var a = ib;
            if (Zb) return /rv:([^\);]+)(\)|;)/.exec(a);
            if (Xb) return /Edge\/([\d\.]+)/.exec(a);
            if (Wb) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
            if ($b) return /WebKit\/(\S+)/.exec(a);
            if (Vb) return /(?:Version)[ \/]?(\S+)/.exec(a);
        }();
        dc && (cc = dc ? dc[1] : "");
        if (Wb) {
            var ec = ac();
            if (null != ec && ec > parseFloat(cc)) {
                bc = String(ec);
                break a;
            }
        }
        bc = cc;
    }
    var Ub = {};
    function fc(a) {
        return Tb(a, function() {
            for(var b = 0, c = $a(String(bc)).split("."), d = $a(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++){
                var g = c[f] || "", h = d[f] || "";
                do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    h = /(\d*)(\D*)(.*)/.exec(h) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    if (0 == g[0].length && 0 == h[0].length) break;
                    b = hb(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || hb(0 == g[2].length, 0 == h[2].length) || hb(g[2], h[2]);
                    g = g[3];
                    h = h[3];
                }while (0 == b);
            }
            return 0 <= b;
        });
    }
    var gc;
    if (l.document && Wb) {
        var hc = ac();
        gc = hc ? hc : parseInt(bc, 10) || void 0;
    } else gc = void 0;
    var ic = gc;
    try {
        new self.OffscreenCanvas(0, 0).getContext("2d");
    } catch (a) {}
    var jc = !Wb || 9 <= Number(ic);
    function kc(a) {
        var b = document;
        return "string" === typeof a ? b.getElementById(a) : a;
    }
    function lc(a, b) {
        lb(b, function(c, d) {
            c && "object" == typeof c && c.ta && (c = c.sa());
            "style" == d ? a.style.cssText = c : "class" == d ? a.className = c : "for" == d ? a.htmlFor = c : mc.hasOwnProperty(d) ? a.setAttribute(mc[d], c) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, c) : a[d] = c;
        });
    }
    var mc = {
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        colspan: "colSpan",
        frameborder: "frameBorder",
        height: "height",
        maxlength: "maxLength",
        nonce: "nonce",
        role: "role",
        rowspan: "rowSpan",
        type: "type",
        usemap: "useMap",
        valign: "vAlign",
        width: "width"
    };
    function nc(a, b, c) {
        var d = arguments, e = document, f = String(d[0]), g = d[1];
        if (!jc && g && (g.name || g.type)) {
            f = [
                "<",
                f
            ];
            g.name && f.push(' name="', Rb(g.name), '"');
            if (g.type) {
                f.push(' type="', Rb(g.type), '"');
                var h = {};
                z(h, g);
                delete h.type;
                g = h;
            }
            f.push(">");
            f = f.join("");
        }
        f = oc(e, f);
        g && ("string" === typeof g ? f.className = g : Array.isArray(g) ? f.className = g.join(" ") : lc(f, g));
        2 < d.length && pc(e, f, d);
        return f;
    }
    function pc(a, b, c) {
        function d(h) {
            h && b.appendChild("string" === typeof h ? a.createTextNode(h) : h);
        }
        for(var e = 2; e < c.length; e++){
            var f = c[e];
            if (!na(f) || n(f) && 0 < f.nodeType) d(f);
            else {
                a: {
                    if (f && "number" == typeof f.length) {
                        if (n(f)) {
                            var g = "function" == typeof f.item || "string" == typeof f.item;
                            break a;
                        }
                        if (oa(f)) {
                            g = "function" == typeof f.item;
                            break a;
                        }
                    }
                    g = !1;
                }
                w(g ? Za(f) : f, d);
            }
        }
    }
    function oc(a, b) {
        b = String(b);
        "application/xhtml+xml" === a.contentType && (b = b.toLowerCase());
        return a.createElement(b);
    }
    function qc(a) {
        l.setTimeout(function() {
            throw a;
        }, 0);
    }
    var rc;
    function sc() {
        var a = l.MessageChannel;
        "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !y("Presto") && (a = function() {
            var e = oc(document, "IFRAME");
            e.style.display = "none";
            document.documentElement.appendChild(e);
            var f = e.contentWindow;
            e = f.document;
            e.open();
            e.close();
            var g = "callImmediate" + Math.random(), h = "file:" == f.location.protocol ? "*" : f.location.protocol + "//" + f.location.host;
            e = q(function(m) {
                if (("*" == h || m.origin == h) && m.data == g) this.port1.onmessage();
            }, this);
            f.addEventListener("message", e, !1);
            this.port1 = {};
            this.port2 = {
                postMessage: function() {
                    f.postMessage(g, h);
                }
            };
        });
        if ("undefined" !== typeof a && !y("Trident") && !y("MSIE")) {
            var b = new a, c = {}, d = c;
            b.port1.onmessage = function() {
                if (void 0 !== c.next) {
                    c = c.next;
                    var e = c.Hb;
                    c.Hb = null;
                    e();
                }
            };
            return function(e) {
                d.next = {
                    Hb: e
                };
                d = d.next;
                b.port2.postMessage(0);
            };
        }
        return function(e) {
            l.setTimeout(e, 0);
        };
    }
    function tc(a, b) {
        uc || vc();
        wc || (uc(), wc = !0);
        Na.add(a, b);
    }
    var uc;
    function vc() {
        if (l.Promise && l.Promise.resolve) {
            var a = l.Promise.resolve(void 0);
            uc = function() {
                a.then(xc);
            };
        } else uc = function() {
            var b = xc;
            !oa(l.setImmediate) || l.Window && l.Window.prototype && !y("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? (rc || (rc = sc()), rc(b)) : l.setImmediate(b);
        };
    }
    var wc = !1, Na = new Ja;
    function xc() {
        for(var a; a = Ma();){
            try {
                a.a.call(a.b);
            } catch (b) {
                qc(b);
            }
            Ia(La, a);
        }
        wc = !1;
    }
    function D(a, b) {
        this.a = yc;
        this.i = void 0;
        this.f = this.b = this.c = null;
        this.g = this.h = !1;
        if (a != la) try {
            var c = this;
            a.call(b, function(d) {
                zc(c, Ac, d);
            }, function(d) {
                if (!(d instanceof Bc)) try {
                    if (d instanceof Error) throw d;
                    throw Error("Promise rejected.");
                } catch (e) {}
                zc(c, Cc, d);
            });
        } catch (d) {
            zc(this, Cc, d);
        }
    }
    var yc = 0, Ac = 2, Cc = 3;
    function Dc() {
        this.next = this.f = this.b = this.g = this.a = null;
        this.c = !1;
    }
    Dc.prototype.reset = function() {
        this.f = this.b = this.g = this.a = null;
        this.c = !1;
    };
    var Ec = new Ha(function() {
        return new Dc;
    }, function(a) {
        a.reset();
    });
    function Fc(a, b, c) {
        var d = Ec.get();
        d.g = a;
        d.b = b;
        d.f = c;
        return d;
    }
    function E(a) {
        if (a instanceof D) return a;
        var b = new D(la);
        zc(b, Ac, a);
        return b;
    }
    function F(a) {
        return new D(function(b, c) {
            c(a);
        });
    }
    function Gc(a, b, c) {
        Hc(a, b, c, null) || tc(ua(b, a));
    }
    function Ic(a) {
        return new D(function(b, c) {
            var d = a.length, e = [];
            if (d) for(var f = function(p, v) {
                d--;
                e[p] = v;
                0 == d && b(e);
            }, g = function(p) {
                c(p);
            }, h = 0, m; h < a.length; h++)m = a[h], Gc(m, ua(f, h), g);
            else b(e);
        });
    }
    function Jc(a) {
        return new D(function(b) {
            var c = a.length, d = [];
            if (c) for(var e = function(h, m, p) {
                c--;
                d[h] = m ? {
                    Qb: !0,
                    value: p
                } : {
                    Qb: !1,
                    reason: p
                };
                0 == c && b(d);
            }, f = 0, g; f < a.length; f++)g = a[f], Gc(g, ua(e, f, !0), ua(e, f, !1));
            else b(d);
        });
    }
    D.prototype.then = function(a, b, c) {
        return Kc(this, oa(a) ? a : null, oa(b) ? b : null, c);
    };
    D.prototype.$goog_Thenable = !0;
    k = D.prototype;
    k.oa = function(a, b) {
        a = Fc(a, a, b);
        a.c = !0;
        Lc(this, a);
        return this;
    };
    k.o = function(a, b) {
        return Kc(this, null, a, b);
    };
    k.cancel = function(a) {
        if (this.a == yc) {
            var b = new Bc(a);
            tc(function() {
                Mc(this, b);
            }, this);
        }
    };
    function Mc(a, b) {
        if (a.a == yc) {
            if (a.c) {
                var c = a.c;
                if (c.b) {
                    for(var d = 0, e = null, f = null, g = c.b; g && (g.c || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next)e || (f = g);
                    e && (c.a == yc && 1 == d ? Mc(c, b) : (f ? (d = f, d.next == c.f && (c.f = d), d.next = d.next.next) : Nc(c), Oc(c, e, Cc, b)));
                }
                a.c = null;
            } else zc(a, Cc, b);
        }
    }
    function Lc(a, b) {
        a.b || a.a != Ac && a.a != Cc || Pc(a);
        a.f ? a.f.next = b : a.b = b;
        a.f = b;
    }
    function Kc(a, b, c, d) {
        var e = Fc(null, null, null);
        e.a = new D(function(f, g) {
            e.g = b ? function(h) {
                try {
                    var m = b.call(d, h);
                    f(m);
                } catch (p) {
                    g(p);
                }
            } : f;
            e.b = c ? function(h) {
                try {
                    var m = c.call(d, h);
                    void 0 === m && h instanceof Bc ? g(h) : f(m);
                } catch (p) {
                    g(p);
                }
            } : g;
        });
        e.a.c = a;
        Lc(a, e);
        return e.a;
    }
    k.$c = function(a) {
        this.a = yc;
        zc(this, Ac, a);
    };
    k.ad = function(a) {
        this.a = yc;
        zc(this, Cc, a);
    };
    function zc(a, b, c) {
        a.a == yc && (a === c && (b = Cc, c = new TypeError("Promise cannot resolve to itself")), a.a = 1, Hc(c, a.$c, a.ad, a) || (a.i = c, a.a = b, a.c = null, Pc(a), b != Cc || c instanceof Bc || Qc(a, c)));
    }
    function Hc(a, b, c, d) {
        if (a instanceof D) return Lc(a, Fc(b || la, c || null, d)), !0;
        if (Ea(a)) return a.then(b, c, d), !0;
        if (n(a)) try {
            var e = a.then;
            if (oa(e)) return Rc(a, e, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }
        return !1;
    }
    function Rc(a, b, c, d, e) {
        function f(m) {
            h || (h = !0, d.call(e, m));
        }
        function g(m) {
            h || (h = !0, c.call(e, m));
        }
        var h = !1;
        try {
            b.call(a, g, f);
        } catch (m) {
            f(m);
        }
    }
    function Pc(a) {
        a.h || (a.h = !0, tc(a.gc, a));
    }
    function Nc(a) {
        var b = null;
        a.b && (b = a.b, a.b = b.next, b.next = null);
        a.b || (a.f = null);
        return b;
    }
    k.gc = function() {
        for(var a; a = Nc(this);)Oc(this, a, this.a, this.i);
        this.h = !1;
    };
    function Oc(a, b, c, d) {
        if (c == Cc && b.b && !b.c) for(; a && a.g; a = a.c)a.g = !1;
        if (b.a) b.a.c = null, Sc(b, c, d);
        else try {
            b.c ? b.g.call(b.f) : Sc(b, c, d);
        } catch (e) {
            Tc.call(null, e);
        }
        Ia(Ec, b);
    }
    function Sc(a, b, c) {
        b == Ac ? a.g.call(a.f, c) : a.b && a.b.call(a.f, c);
    }
    function Qc(a, b) {
        a.g = !0;
        tc(function() {
            a.g && Tc.call(null, b);
        });
    }
    var Tc = qc;
    function Bc(a) {
        u.call(this, a);
    }
    r(Bc, u);
    Bc.prototype.name = "cancel";
    function Uc() {
        0 != Vc && (Wc[pa(this)] = this);
        this.ya = this.ya;
        this.pa = this.pa;
    }
    var Vc = 0, Wc = {};
    Uc.prototype.ya = !1;
    function Xc(a) {
        if (!a.ya && (a.ya = !0, a.Da(), 0 != Vc)) {
            var b = pa(a);
            if (0 != Vc && a.pa && 0 < a.pa.length) throw Error(a + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
            delete Wc[b];
        }
    }
    Uc.prototype.Da = function() {
        if (this.pa) for(; this.pa.length;)this.pa.shift()();
    };
    var Yc = Object.freeze || function(a) {
        return a;
    };
    var Zc = !Wb || 9 <= Number(ic), $c = Wb && !fc("9"), ad = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            l.addEventListener("test", la, b), l.removeEventListener("test", la, b);
        } catch (c) {}
        return a;
    }();
    function G(a, b) {
        this.type = a;
        this.b = this.target = b;
        this.defaultPrevented = !1;
    }
    G.prototype.preventDefault = function() {
        this.defaultPrevented = !0;
    };
    function bd(a, b) {
        G.call(this, a ? a.type : "");
        this.relatedTarget = this.b = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.pointerId = 0;
        this.pointerType = "";
        this.a = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.b = b;
            if (b = a.relatedTarget) {
                if (Zb) {
                    a: {
                        try {
                            Sb(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : cd[a.pointerType] || "";
            this.a = a;
            a.defaultPrevented && this.preventDefault();
        }
    }
    r(bd, G);
    var cd = Yc({
        2: "touch",
        3: "pen",
        4: "mouse"
    });
    bd.prototype.preventDefault = function() {
        bd.bb.preventDefault.call(this);
        var a = this.a;
        if (a.preventDefault) a.preventDefault();
        else if (a.returnValue = !1, $c) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };
    bd.prototype.g = function() {
        return this.a;
    };
    var dd = "closure_listenable_" + (1E6 * Math.random() | 0), ed = 0;
    function fd(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.Wa = e;
        this.key = ++ed;
        this.wa = this.Qa = !1;
    }
    function gd(a) {
        a.wa = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.Wa = null;
    }
    function hd(a) {
        this.src = a;
        this.a = {};
        this.b = 0;
    }
    hd.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.a[f];
        a || (a = this.a[f] = [], this.b++);
        var g = id(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.Qa = !1)) : (b = new fd(b, this.src, f, !!d, e), b.Qa = c, a.push(b));
        return b;
    };
    function jd(a, b) {
        var c = b.type;
        c in a.a && Wa(a.a[c], b) && (gd(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
    function id(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.wa && f.listener == b && f.capture == !!c && f.Wa == d) return e;
        }
        return -1;
    }
    var kd = "closure_lm_" + (1E6 * Math.random() | 0), ld = {}, md = 0;
    function nd(a, b, c, d, e) {
        if (d && d.once) od(a, b, c, d, e);
        else if (Array.isArray(b)) for(var f = 0; f < b.length; f++)nd(a, b[f], c, d, e);
        else c = pd(c), a && a[dd] ? qd(a, b, c, n(d) ? !!d.capture : !!d, e) : rd(a, b, c, !1, d, e);
    }
    function rd(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, h = sd(a);
        h || (a[kd] = h = new hd(a));
        c = h.add(b, c, d, g, f);
        if (!c.proxy) {
            d = td();
            c.proxy = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener) ad || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
            else if (a.attachEvent) a.attachEvent(ud(b.toString()), d);
            else if (a.addListener && a.removeListener) a.addListener(d);
            else throw Error("addEventListener and attachEvent are unavailable.");
            md++;
        }
    }
    function td() {
        var a = vd, b = Zc ? function(c) {
            return a.call(b.src, b.listener, c);
        } : function(c) {
            c = a.call(b.src, b.listener, c);
            if (!c) return c;
        };
        return b;
    }
    function od(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)od(a, b[f], c, d, e);
        else c = pd(c), a && a[dd] ? wd(a, b, c, n(d) ? !!d.capture : !!d, e) : rd(a, b, c, !0, d, e);
    }
    function xd(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)xd(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = pd(c), a && a[dd]) ? (a = a.v, b = String(b).toString(), b in a.a && (f = a.a[b], c = id(f, c, d, e), -1 < c && (gd(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = sd(a)) && (b = a.a[b.toString()], a = -1, b && (a = id(b, c, d, e)), (c = -1 < a ? b[a] : null) && yd(c));
    }
    function yd(a) {
        if ("number" !== typeof a && a && !a.wa) {
            var b = a.src;
            if (b && b[dd]) jd(b.v, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(ud(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                md--;
                (c = sd(b)) ? (jd(c, a), 0 == c.b && (c.src = null, b[kd] = null)) : gd(a);
            }
        }
    }
    function ud(a) {
        return a in ld ? ld[a] : ld[a] = "on" + a;
    }
    function zd(a, b, c, d) {
        var e = !0;
        if (a = sd(a)) {
            if (b = a.a[b.toString()]) for(b = b.concat(), a = 0; a < b.length; a++){
                var f = b[a];
                f && f.capture == c && !f.wa && (f = Bd(f, d), e = e && !1 !== f);
            }
        }
        return e;
    }
    function Bd(a, b) {
        var c = a.listener, d = a.Wa || a.src;
        a.Qa && yd(a);
        return c.call(d, b);
    }
    function vd(a, b) {
        if (a.wa) return !0;
        if (!Zc) {
            if (!b) a: {
                b = [
                    "window",
                    "event"
                ];
                for(var c = l, d = 0; d < b.length; d++)if (c = c[b[d]], null == c) {
                    b = null;
                    break a;
                }
                b = c;
            }
            d = b;
            b = new bd(d, this);
            c = !0;
            if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;
                    if (0 == d.keyCode) try {
                        d.keyCode = -1;
                        break a;
                    } catch (g) {
                        e = !0;
                    }
                    if (e || void 0 == d.returnValue) d.returnValue = !0;
                }
                d = [];
                for(e = b.b; e; e = e.parentNode)d.push(e);
                a = a.type;
                for(e = d.length - 1; 0 <= e; e--){
                    b.b = d[e];
                    var f = zd(d[e], a, !0, b);
                    c = c && f;
                }
                for(e = 0; e < d.length; e++)b.b = d[e], f = zd(d[e], a, !1, b), c = c && f;
            }
            return c;
        }
        return Bd(a, new bd(b, this));
    }
    function sd(a) {
        a = a[kd];
        return a instanceof hd ? a : null;
    }
    var Cd = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function pd(a) {
        if (oa(a)) return a;
        a[Cd] || (a[Cd] = function(b) {
            return a.handleEvent(b);
        });
        return a[Cd];
    }
    function H() {
        Uc.call(this);
        this.v = new hd(this);
        this.bc = this;
        this.hb = null;
    }
    r(H, Uc);
    H.prototype[dd] = !0;
    H.prototype.addEventListener = function(a, b, c, d) {
        nd(this, a, b, c, d);
    };
    H.prototype.removeEventListener = function(a, b, c, d) {
        xd(this, a, b, c, d);
    };
    H.prototype.dispatchEvent = function(a) {
        var b, c = this.hb;
        if (c) for(b = []; c; c = c.hb)b.push(c);
        c = this.bc;
        var d = a.type || a;
        if ("string" === typeof a) a = new G(a, c);
        else if (a instanceof G) a.target = a.target || c;
        else {
            var e = a;
            a = new G(d, c);
            z(a, e);
        }
        e = !0;
        if (b) for(var f = b.length - 1; 0 <= f; f--){
            var g = a.b = b[f];
            e = Dd(g, d, !0, a) && e;
        }
        g = a.b = c;
        e = Dd(g, d, !0, a) && e;
        e = Dd(g, d, !1, a) && e;
        if (b) for(f = 0; f < b.length; f++)g = a.b = b[f], e = Dd(g, d, !1, a) && e;
        return e;
    };
    H.prototype.Da = function() {
        H.bb.Da.call(this);
        if (this.v) {
            var a = this.v, b = 0, c;
            for(c in a.a){
                for(var d = a.a[c], e = 0; e < d.length; e++)++b, gd(d[e]);
                delete a.a[c];
                a.b--;
            }
        }
        this.hb = null;
    };
    function qd(a, b, c, d, e) {
        a.v.add(String(b), c, !1, d, e);
    }
    function wd(a, b, c, d, e) {
        a.v.add(String(b), c, !0, d, e);
    }
    function Dd(a, b, c, d) {
        b = a.v.a[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.wa && g.capture == c) {
                var h = g.listener, m = g.Wa || g.src;
                g.Qa && jd(a.v, g);
                e = !1 !== h.call(m, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Ed(a, b, c) {
        if (oa(a)) c && (a = q(a, c));
        else if (a && "function" == typeof a.handleEvent) a = q(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : l.setTimeout(a, b || 0);
    }
    function Fd(a) {
        var b = null;
        return new D(function(c, d) {
            b = Ed(function() {
                c(void 0);
            }, a);
            -1 == b && d(Error("Failed to schedule timer."));
        }).o(function(c) {
            l.clearTimeout(b);
            throw c;
        });
    }
    function Gd(a) {
        if (a.X && "function" == typeof a.X) return a.X();
        if ("string" === typeof a) return a.split("");
        if (na(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function Hd(a) {
        if (a.Y && "function" == typeof a.Y) return a.Y();
        if (!a.X || "function" != typeof a.X) {
            if (na(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(var d in a)b[c++] = d;
            return b;
        }
    }
    function Id(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (na(a) || "string" === typeof a) w(a, b, void 0);
        else for(var c = Hd(a), d = Gd(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    function Jd(a, b) {
        this.b = {};
        this.a = [];
        this.c = 0;
        var c = arguments.length;
        if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");
            for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
        } else if (a) {
            if (a instanceof Jd) for(c = a.Y(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
            else for(d in a)this.set(d, a[d]);
        }
    }
    k = Jd.prototype;
    k.X = function() {
        Kd(this);
        for(var a = [], b = 0; b < this.a.length; b++)a.push(this.b[this.a[b]]);
        return a;
    };
    k.Y = function() {
        Kd(this);
        return this.a.concat();
    };
    k.clear = function() {
        this.b = {};
        this.c = this.a.length = 0;
    };
    function Kd(a) {
        if (a.c != a.a.length) {
            for(var b = 0, c = 0; b < a.a.length;){
                var d = a.a[b];
                Ld(a.b, d) && (a.a[c++] = d);
                b++;
            }
            a.a.length = c;
        }
        if (a.c != a.a.length) {
            var e = {};
            for(c = b = 0; b < a.a.length;)d = a.a[b], Ld(e, d) || (a.a[c++] = d, e[d] = 1), b++;
            a.a.length = c;
        }
    }
    k.get = function(a, b) {
        return Ld(this.b, a) ? this.b[a] : b;
    };
    k.set = function(a, b) {
        Ld(this.b, a) || (this.c++, this.a.push(a));
        this.b[a] = b;
    };
    k.forEach = function(a, b) {
        for(var c = this.Y(), d = 0; d < c.length; d++){
            var e = c[d], f = this.get(e);
            a.call(b, f, e, this);
        }
    };
    function Ld(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    var Md = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
    function Nd(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function Od(a, b) {
        this.a = this.l = this.c = "";
        this.g = null;
        this.h = this.f = "";
        this.i = !1;
        var c;
        a instanceof Od ? (this.i = void 0 !== b ? b : a.i, Pd(this, a.c), this.l = a.l, this.a = a.a, Qd(this, a.g), this.f = a.f, Rd(this, Sd(a.b)), this.h = a.h) : a && (c = String(a).match(Md)) ? (this.i = !!b, Pd(this, c[1] || "", !0), this.l = Td(c[2] || ""), this.a = Td(c[3] || "", !0), Qd(this, c[4]), this.f = Td(c[5] || "", !0), Rd(this, c[6] || "", !0), this.h = Td(c[7] || "")) : (this.i = !!b, this.b = new Ud(null, this.i));
    }
    Od.prototype.toString = function() {
        var a = [], b = this.c;
        b && a.push(Vd(b, Wd, !0), ":");
        var c = this.a;
        if (c || "file" == b) a.push("//"), (b = this.l) && a.push(Vd(b, Wd, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.g, null != c && a.push(":", String(c));
        if (c = this.f) this.a && "/" != c.charAt(0) && a.push("/"), a.push(Vd(c, "/" == c.charAt(0) ? Xd : Yd, !0));
        (c = this.b.toString()) && a.push("?", c);
        (c = this.h) && a.push("#", Vd(c, Zd));
        return a.join("");
    };
    Od.prototype.resolve = function(a) {
        var b = new Od(this), c = !!a.c;
        c ? Pd(b, a.c) : c = !!a.l;
        c ? b.l = a.l : c = !!a.a;
        c ? b.a = a.a : c = null != a.g;
        var d = a.f;
        if (c) Qd(b, a.g);
        else if (c = !!a.f) {
            if ("/" != d.charAt(0)) {
                if (this.a && !this.f) d = "/" + d;
                else {
                    var e = b.f.lastIndexOf("/");
                    -1 != e && (d = b.f.substr(0, e + 1) + d);
                }
            }
            e = d;
            if (".." == e || "." == e) d = "";
            else if (x(e, "./") || x(e, "/.")) {
                d = 0 == e.lastIndexOf("/", 0);
                e = e.split("/");
                for(var f = [], g = 0; g < e.length;){
                    var h = e[g++];
                    "." == h ? d && g == e.length && f.push("") : ".." == h ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(h), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.f = d : c = "" !== a.b.toString();
        c ? Rd(b, Sd(a.b)) : c = !!a.h;
        c && (b.h = a.h);
        return b;
    };
    function Pd(a, b, c) {
        a.c = c ? Td(b, !0) : b;
        a.c && (a.c = a.c.replace(/:$/, ""));
    }
    function Qd(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.g = b;
        } else a.g = null;
    }
    function Rd(a, b, c) {
        b instanceof Ud ? (a.b = b, $d(a.b, a.i)) : (c || (b = Vd(b, ae)), a.b = new Ud(b, a.i));
    }
    function I(a, b, c) {
        a.b.set(b, c);
    }
    function be(a, b) {
        return a.b.get(b);
    }
    function J(a) {
        return a instanceof Od ? new Od(a) : new Od(a, void 0);
    }
    function ce(a, b, c, d) {
        var e = new Od(null, void 0);
        a && Pd(e, a);
        b && (e.a = b);
        c && Qd(e, c);
        d && (e.f = d);
        return e;
    }
    function Td(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function Vd(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, de), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function de(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var Wd = /[#\/\?@]/g, Yd = /[#\?:]/g, Xd = /[#\?]/g, ae = /[#\?@]/g, Zd = /#/g;
    function Ud(a, b) {
        this.b = this.a = null;
        this.c = a || null;
        this.f = !!b;
    }
    function ee(a) {
        a.a || (a.a = new Jd, a.b = 0, a.c && Nd(a.c, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    function fe(a) {
        var b = Hd(a);
        if ("undefined" == typeof b) throw Error("Keys are undefined");
        var c = new Ud(null, void 0);
        a = Gd(a);
        for(var d = 0; d < b.length; d++){
            var e = b[d], f = a[d];
            Array.isArray(f) ? ge(c, e, f) : c.add(e, f);
        }
        return c;
    }
    k = Ud.prototype;
    k.add = function(a, b) {
        ee(this);
        this.c = null;
        a = he(this, a);
        var c = this.a.get(a);
        c || this.a.set(a, c = []);
        c.push(b);
        this.b += 1;
        return this;
    };
    function ie(a, b) {
        ee(a);
        b = he(a, b);
        Ld(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, Ld(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && Kd(a)));
    }
    k.clear = function() {
        this.a = this.c = null;
        this.b = 0;
    };
    function je(a, b) {
        ee(a);
        b = he(a, b);
        return Ld(a.a.b, b);
    }
    k.forEach = function(a, b) {
        ee(this);
        this.a.forEach(function(c, d) {
            w(c, function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    k.Y = function() {
        ee(this);
        for(var a = this.a.X(), b = this.a.Y(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
        return c;
    };
    k.X = function(a) {
        ee(this);
        var b = [];
        if ("string" === typeof a) je(this, a) && (b = Ya(b, this.a.get(he(this, a))));
        else {
            a = this.a.X();
            for(var c = 0; c < a.length; c++)b = Ya(b, a[c]);
        }
        return b;
    };
    k.set = function(a, b) {
        ee(this);
        this.c = null;
        a = he(this, a);
        je(this, a) && (this.b -= this.a.get(a).length);
        this.a.set(a, [
            b
        ]);
        this.b += 1;
        return this;
    };
    k.get = function(a, b) {
        if (!a) return b;
        a = this.X(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function ge(a, b, c) {
        ie(a, b);
        0 < c.length && (a.c = null, a.a.set(he(a, b), Za(c)), a.b += c.length);
    }
    k.toString = function() {
        if (this.c) return this.c;
        if (!this.a) return "";
        for(var a = [], b = this.a.Y(), c = 0; c < b.length; c++){
            var d = b[c], e = encodeURIComponent(String(d));
            d = this.X(d);
            for(var f = 0; f < d.length; f++){
                var g = e;
                "" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));
                a.push(g);
            }
        }
        return this.c = a.join("&");
    };
    function Sd(a) {
        var b = new Ud;
        b.c = a.c;
        a.a && (b.a = new Jd(a.a), b.b = a.b);
        return b;
    }
    function he(a, b) {
        b = String(b);
        a.f && (b = b.toLowerCase());
        return b;
    }
    function $d(a, b) {
        b && !a.f && (ee(a), a.c = null, a.a.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (ie(this, d), ge(this, e, c));
        }, a));
        a.f = b;
    }
    function ke(a) {
        var b = [];
        le(new me, a, b);
        return b.join("");
    }
    function me() {}
    function le(a, b, c) {
        if (null == b) c.push("null");
        else {
            if ("object" == typeof b) {
                if (Array.isArray(b)) {
                    var d = b;
                    b = d.length;
                    c.push("[");
                    for(var e = "", f = 0; f < b; f++)c.push(e), le(a, d[f], c), e = ",";
                    c.push("]");
                    return;
                }
                if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                else {
                    c.push("{");
                    e = "";
                    for(d in b)Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), ne(d, c), c.push(":"), le(a, f, c), e = ","));
                    c.push("}");
                    return;
                }
            }
            switch(typeof b){
                case "string":
                    ne(b, c);
                    break;
                case "number":
                    c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
                    break;
                case "boolean":
                    c.push(String(b));
                    break;
                case "function":
                    c.push("null");
                    break;
                default:
                    throw Error("Unknown type: " + typeof b);
            }
        }
    }
    var oe = {
        '"': '\\"',
        "\\": "\\\\",
        "/": "\\/",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "	": "\\t",
        "\v": "\\u000b"
    }, pe = /\uffff/.test("￿") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
    function ne(a, b) {
        b.push('"', a.replace(pe, function(c) {
            var d = oe[c];
            d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).substr(1), oe[c] = d);
            return d;
        }), '"');
    }
    function qe() {
        var a = K();
        return Wb && !!ic && 11 == ic || /Edge\/\d+/.test(a);
    }
    function re() {
        return l.window && l.window.location.href || self && self.location && self.location.href || "";
    }
    function se(a, b) {
        b = b || l.window;
        var c = "about:blank";
        a && (c = Eb(Ib(a) || Kb));
        b.location.href = c;
    }
    function te(a, b) {
        var c = [], d;
        for(d in a)d in b ? typeof a[d] != typeof b[d] ? c.push(d) : "object" == typeof a[d] && null != a[d] && null != b[d] ? 0 < te(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
        for(d in b)d in a || c.push(d);
        return c;
    }
    function ue() {
        var a = K();
        a = ve(a) != we ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;
        return a && 30 > a ? !1 : !Wb || !ic || 9 < ic;
    }
    function xe(a) {
        a = (a || K()).toLowerCase();
        return a.match(/android/) || a.match(/webos/) || a.match(/iphone|ipad|ipod/) || a.match(/blackberry/) || a.match(/windows phone/) || a.match(/iemobile/) ? !0 : !1;
    }
    function ye(a) {
        a = a || l.window;
        try {
            a.close();
        } catch (b) {}
    }
    function ze(a, b, c) {
        var d = Math.floor(1E9 * Math.random()).toString();
        b = b || 500;
        c = c || 600;
        var e = (window.screen.availHeight - c) / 2, f = (window.screen.availWidth - b) / 2;
        b = {
            width: b,
            height: c,
            top: 0 < e ? e : 0,
            left: 0 < f ? f : 0,
            location: !0,
            resizable: !0,
            statusbar: !0,
            toolbar: !1
        };
        c = K().toLowerCase();
        d && (b.target = d, x(c, "crios/") && (b.target = "_blank"));
        ve(K()) == Ae && (a = a || "http://localhost", b.scrollbars = !0);
        c = a || "";
        (a = b) || (a = {});
        d = window;
        b = c instanceof C ? c : Ib("undefined" != typeof c.href ? c.href : String(c)) || Kb;
        c = a.target || c.target;
        e = [];
        for(g in a)switch(g){
            case "width":
            case "height":
            case "top":
            case "left":
                e.push(g + "=" + a[g]);
                break;
            case "target":
            case "noopener":
            case "noreferrer":
                break;
            default:
                e.push(g + "=" + (a[g] ? 1 : 0));
        }
        var g = e.join(",");
        if ((y("iPhone") && !y("iPod") && !y("iPad") || y("iPad") || y("iPod")) && d.navigator && d.navigator.standalone && c && "_self" != c) g = oc(document, "A"), pb(g, "HTMLAnchorElement"), b = b instanceof C ? b : Jb(b), g.href = Eb(b), g.setAttribute("target", c), a.noreferrer && g.setAttribute("rel", "noreferrer"), a = document.createEvent("MouseEvent"), a.initMouseEvent("click", !0, !0, d, 1), g.dispatchEvent(a), g = {};
        else if (a.noreferrer) {
            if (g = Pb("", d, c, g), a = Eb(b), g && (Yb && x(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'"), g.opener = null, a = '<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + Rb(a) + '">', a = (d = vb()) ? d.createHTML(a) : a, a = new Lb(a, null, Mb), d = g.document)) d.write(Nb(a)), d.close();
        } else (g = Pb(b, d, c, g)) && a.noopener && (g.opener = null);
        if (g) try {
            g.focus();
        } catch (h) {}
        return g;
    }
    function Be(a) {
        return new D(function(b) {
            function c() {
                Fd(2E3).then(function() {
                    if (!a || a.closed) b();
                    else return c();
                });
            }
            return c();
        });
    }
    var Ce = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, De = /^[^@]+@[^@]+$/;
    function Ee() {
        var a = null;
        return new D(function(b) {
            "complete" == l.document.readyState ? b() : (a = function() {
                b();
            }, od(window, "load", a));
        }).o(function(b) {
            xd(window, "load", a);
            throw b;
        });
    }
    function Fe() {
        return Ge(void 0) ? Ee().then(function() {
            return new D(function(a, b) {
                var c = l.document, d = setTimeout(function() {
                    b(Error("Cordova framework is not ready."));
                }, 1E3);
                c.addEventListener("deviceready", function() {
                    clearTimeout(d);
                    a();
                }, !1);
            });
        }) : F(Error("Cordova must run in an Android or iOS file scheme."));
    }
    function Ge(a) {
        a = a || K();
        return !("file:" !== He() && "ionic:" !== He() || !a.toLowerCase().match(/iphone|ipad|ipod|android/));
    }
    function Ie() {
        var a = l.window;
        try {
            return !(!a || a == a.top);
        } catch (b) {
            return !1;
        }
    }
    function Je() {
        return "undefined" !== typeof l.WorkerGlobalScope && "function" === typeof l.importScripts;
    }
    function Ke() {
        return (0, $8eXKx.default).INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : (0, $8eXKx.default).INTERNAL.hasOwnProperty("node") ? "Node" : Je() ? "Worker" : "Browser";
    }
    function Le() {
        var a = Ke();
        return "ReactNative" === a || "Node" === a;
    }
    function Me() {
        for(var a = 50, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    var Ae = "Firefox", we = "Chrome";
    function ve(a) {
        var b = a.toLowerCase();
        if (x(b, "opera/") || x(b, "opr/") || x(b, "opios/")) return "Opera";
        if (x(b, "iemobile")) return "IEMobile";
        if (x(b, "msie") || x(b, "trident/")) return "IE";
        if (x(b, "edge/")) return "Edge";
        if (x(b, "firefox/")) return Ae;
        if (x(b, "silk/")) return "Silk";
        if (x(b, "blackberry")) return "Blackberry";
        if (x(b, "webos")) return "Webos";
        if (!x(b, "safari/") || x(b, "chrome/") || x(b, "crios/") || x(b, "android")) {
            if (!x(b, "chrome/") && !x(b, "crios/") || x(b, "edge/")) {
                if (x(b, "android")) return "Android";
                if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
            } else return we;
        } else return "Safari";
        return "Other";
    }
    var Ne = {
        md: "FirebaseCore-web",
        od: "FirebaseUI-web"
    };
    function Oe(a, b) {
        b = b || [];
        var c = [], d = {}, e;
        for(e in Ne)d[Ne[e]] = !0;
        for(e = 0; e < b.length; e++)"undefined" !== typeof d[b[e]] && (delete d[b[e]], c.push(b[e]));
        c.sort();
        b = c;
        b.length || (b = [
            "FirebaseCore-web"
        ]);
        c = Ke();
        "Browser" === c ? (d = K(), c = ve(d)) : "Worker" === c && (d = K(), c = ve(d) + "-" + c);
        return c + "/JsCore/" + a + "/" + b.join(",");
    }
    function K() {
        return l.navigator && l.navigator.userAgent || "";
    }
    function L(a, b) {
        a = a.split(".");
        b = b || l;
        for(var c = 0; c < a.length && "object" == typeof b && null != b; c++)b = b[a[c]];
        c != a.length && (b = void 0);
        return b;
    }
    function Pe() {
        try {
            var a = l.localStorage, b = Qe();
            if (a) return a.setItem(b, "1"), a.removeItem(b), qe() ? !!l.indexedDB : !0;
        } catch (c) {
            return Je() && !!l.indexedDB;
        }
        return !1;
    }
    function Re() {
        return (Se() || "chrome-extension:" === He() || Ge()) && !Le() && Pe() && !Je();
    }
    function Se() {
        return "http:" === He() || "https:" === He();
    }
    function He() {
        return l.location && l.location.protocol || null;
    }
    function Te(a) {
        a = a || K();
        return xe(a) || ve(a) == Ae ? !1 : !0;
    }
    function Ue(a) {
        return "undefined" === typeof a ? null : ke(a);
    }
    function Ve(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
        return b;
    }
    function We(a) {
        if (null !== a) return JSON.parse(a);
    }
    function Qe(a) {
        return a ? a : Math.floor(1E9 * Math.random()).toString();
    }
    function Xe(a) {
        a = a || K();
        return "Safari" == ve(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0;
    }
    function Ye() {
        var a = l.___jsl;
        if (a && a.H) {
            for(var b in a.H)if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for(var c = 0; c < a.CP.length; c++)a.CP[c] = null;
        }
    }
    function Ze(a, b) {
        if (a > b) throw Error("Short delay should be less than long delay!");
        this.a = a;
        this.c = b;
        a = K();
        b = Ke();
        this.b = xe(a) || "ReactNative" === b;
    }
    Ze.prototype.get = function() {
        var a = l.navigator;
        return (a && "boolean" === typeof a.onLine && (Se() || "chrome-extension:" === He() || "undefined" !== typeof a.connection) ? a.onLine : 1) ? this.b ? this.c : this.a : Math.min(5E3, this.a);
    };
    function $e() {
        var a = l.document;
        return a && "undefined" !== typeof a.visibilityState ? "visible" == a.visibilityState : !0;
    }
    function af() {
        var a = l.document, b = null;
        return $e() || !a ? E() : new D(function(c) {
            b = function() {
                $e() && (a.removeEventListener("visibilitychange", b, !1), c());
            };
            a.addEventListener("visibilitychange", b, !1);
        }).o(function(c) {
            a.removeEventListener("visibilitychange", b, !1);
            throw c;
        });
    }
    function bf(a) {
        try {
            var b = new Date(parseInt(a, 10));
            if (!isNaN(b.getTime()) && !/[^0-9]/.test(a)) return b.toUTCString();
        } catch (c) {}
        return null;
    }
    function cf() {
        return !(!L("fireauth.oauthhelper", l) && !L("fireauth.iframe", l));
    }
    function df() {
        var a = l.navigator;
        return a && a.serviceWorker && a.serviceWorker.controller || null;
    }
    function ef() {
        var a = l.navigator;
        return a && a.serviceWorker ? E().then(function() {
            return a.serviceWorker.ready;
        }).then(function(b) {
            return b.active || null;
        }).o(function() {
            return null;
        }) : E(null);
    }
    var ff = {};
    function gf(a) {
        ff[a] || (ff[a] = !0, "undefined" !== typeof console && "function" === typeof console.warn && console.warn(a));
    }
    var hf;
    try {
        var jf = {};
        Object.defineProperty(jf, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 1
        });
        Object.defineProperty(jf, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 2
        });
        hf = 2 == jf.abcd;
    } catch (a) {
        hf = !1;
    }
    function M(a, b, c) {
        hf ? Object.defineProperty(a, b, {
            configurable: !0,
            enumerable: !0,
            value: c
        }) : a[b] = c;
    }
    function N(a, b) {
        if (b) for(var c in b)b.hasOwnProperty(c) && M(a, c, b[c]);
    }
    function kf(a) {
        var b = {};
        N(b, a);
        return b;
    }
    function lf(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && (b[c] = a[c]);
        return b;
    }
    function mf(a, b) {
        if (!b || !b.length) return !0;
        if (!a) return !1;
        for(var c = 0; c < b.length; c++){
            var d = a[b[c]];
            if (void 0 === d || null === d || "" === d) return !1;
        }
        return !0;
    }
    function nf(a) {
        var b = a;
        if ("object" == typeof a && null != a) {
            b = "length" in a ? [] : {};
            for(var c in a)M(b, c, nf(a[c]));
        }
        return b;
    }
    function of(a) {
        var b = a && (a[pf] ? "phone" : null);
        if (b && a && a[qf]) {
            M(this, "uid", a[qf]);
            M(this, "displayName", a[rf] || null);
            var c = null;
            a[sf] && (c = new Date(a[sf]).toUTCString());
            M(this, "enrollmentTime", c);
            M(this, "factorId", b);
        } else throw new t("internal-error", "Internal assert: invalid MultiFactorInfo object");
    }
    of.prototype.w = function() {
        return {
            uid: this.uid,
            displayName: this.displayName,
            factorId: this.factorId,
            enrollmentTime: this.enrollmentTime
        };
    };
    function tf(a) {
        try {
            var b = new uf(a);
        } catch (c) {
            b = null;
        }
        return b;
    }
    var rf = "displayName", sf = "enrolledAt", qf = "mfaEnrollmentId", pf = "phoneInfo";
    function uf(a) {
        of.call(this, a);
        M(this, "phoneNumber", a[pf]);
    }
    r(uf, of);
    uf.prototype.w = function() {
        var a = uf.bb.w.call(this);
        a.phoneNumber = this.phoneNumber;
        return a;
    };
    function vf(a) {
        var b = {}, c = a[wf], d = a[xf], e = a[yf];
        a = tf(a[zf]);
        if (!e || e != Af && e != Bf && !c || e == Bf && !d || e == Cf && !a) throw Error("Invalid checkActionCode response!");
        e == Bf ? (b[Df] = c || null, b[Ef] = c || null, b[Ff] = d) : (b[Df] = d || null, b[Ef] = d || null, b[Ff] = c || null);
        b[Gf] = a || null;
        M(this, Hf, e);
        M(this, If, nf(b));
    }
    var Cf = "REVERT_SECOND_FACTOR_ADDITION", Af = "EMAIL_SIGNIN", Bf = "VERIFY_AND_CHANGE_EMAIL", wf = "email", zf = "mfaInfo", xf = "newEmail", yf = "requestType", Ff = "email", Df = "fromEmail", Gf = "multiFactorInfo", Ef = "previousEmail", If = "data", Hf = "operation";
    function Jf(a) {
        a = J(a);
        var b = be(a, Kf) || null, c = be(a, Lf) || null, d = be(a, Mf) || null;
        d = d ? Nf[d] || null : null;
        if (!b || !c || !d) throw new t("argument-error", Kf + ", " + Lf + "and " + Mf + " are required in a valid action code URL.");
        N(this, {
            apiKey: b,
            operation: d,
            code: c,
            continueUrl: be(a, Of) || null,
            languageCode: be(a, Pf) || null,
            tenantId: be(a, Qf) || null
        });
    }
    var Kf = "apiKey", Lf = "oobCode", Of = "continueUrl", Pf = "languageCode", Mf = "mode", Qf = "tenantId", Nf = {
        recoverEmail: "RECOVER_EMAIL",
        resetPassword: "PASSWORD_RESET",
        revertSecondFactorAddition: Cf,
        signIn: Af,
        verifyAndChangeEmail: Bf,
        verifyEmail: "VERIFY_EMAIL"
    };
    function Rf(a) {
        try {
            return new Jf(a);
        } catch (b) {
            return null;
        }
    }
    function Sf(a) {
        var b = a[Tf];
        if ("undefined" === typeof b) throw new t("missing-continue-uri");
        if ("string" !== typeof b || "string" === typeof b && !b.length) throw new t("invalid-continue-uri");
        this.h = b;
        this.b = this.a = null;
        this.g = !1;
        var c = a[Uf];
        if (c && "object" === typeof c) {
            b = c[Vf];
            var d = c[Wf];
            c = c[Xf];
            if ("string" === typeof b && b.length) {
                this.a = b;
                if ("undefined" !== typeof d && "boolean" !== typeof d) throw new t("argument-error", Wf + " property must be a boolean when specified.");
                this.g = !!d;
                if ("undefined" !== typeof c && ("string" !== typeof c || "string" === typeof c && !c.length)) throw new t("argument-error", Xf + " property must be a non empty string when specified.");
                this.b = c || null;
            } else {
                if ("undefined" !== typeof b) throw new t("argument-error", Vf + " property must be a non empty string when specified.");
                if ("undefined" !== typeof d || "undefined" !== typeof c) throw new t("missing-android-pkg-name");
            }
        } else if ("undefined" !== typeof c) throw new t("argument-error", Uf + " property must be a non null object when specified.");
        this.f = null;
        if ((b = a[Yf]) && "object" === typeof b) {
            if (b = b[Zf], "string" === typeof b && b.length) this.f = b;
            else {
                if ("undefined" !== typeof b) throw new t("argument-error", Zf + " property must be a non empty string when specified.");
            }
        } else if ("undefined" !== typeof b) throw new t("argument-error", Yf + " property must be a non null object when specified.");
        b = a[$f];
        if ("undefined" !== typeof b && "boolean" !== typeof b) throw new t("argument-error", $f + " property must be a boolean when specified.");
        this.c = !!b;
        a = a[ag];
        if ("undefined" !== typeof a && ("string" !== typeof a || "string" === typeof a && !a.length)) throw new t("argument-error", ag + " property must be a non empty string when specified.");
        this.i = a || null;
    }
    var Uf = "android", ag = "dynamicLinkDomain", $f = "handleCodeInApp", Yf = "iOS", Tf = "url", Wf = "installApp", Xf = "minimumVersion", Vf = "packageName", Zf = "bundleId";
    function bg(a) {
        var b = {};
        b.continueUrl = a.h;
        b.canHandleCodeInApp = a.c;
        if (b.androidPackageName = a.a) b.androidMinimumVersion = a.b, b.androidInstallApp = a.g;
        b.iOSBundleId = a.f;
        b.dynamicLinkDomain = a.i;
        for(var c in b)null === b[c] && delete b[c];
        return b;
    }
    function cg(a) {
        return Ra(a, function(b) {
            b = b.toString(16);
            return 1 < b.length ? b : "0" + b;
        }).join("");
    }
    var dg = null;
    function eg(a) {
        var b = [];
        fg(a, function(c) {
            b.push(c);
        });
        return b;
    }
    function fg(a, b) {
        function c(m) {
            for(; d < a.length;){
                var p = a.charAt(d++), v = dg[p];
                if (null != v) return v;
                if (!/^[\s\xa0]*$/.test(p)) throw Error("Unknown base64 encoding at char: " + p);
            }
            return m;
        }
        gg();
        for(var d = 0;;){
            var e = c(-1), f = c(0), g = c(64), h = c(64);
            if (64 === h && -1 === e) break;
            b(e << 2 | f >> 4);
            64 != g && (b(f << 4 & 240 | g >> 2), 64 != h && b(g << 6 & 192 | h));
        }
    }
    function gg() {
        if (!dg) {
            dg = {};
            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], c = 0; 5 > c; c++)for(var d = a.concat(b[c].split("")), e = 0; e < d.length; e++){
                var f = d[e];
                void 0 === dg[f] && (dg[f] = e);
            }
        }
    }
    function hg(a) {
        var b = ig(a);
        if (!(b && b.sub && b.iss && b.aud && b.exp)) throw Error("Invalid JWT");
        this.h = a;
        this.a = b.exp;
        this.i = b.sub;
        a = Date.now() / 1E3;
        this.g = b.iat || (a > this.a ? this.a : a);
        this.b = b.provider_id || b.firebase && b.firebase.sign_in_provider || null;
        this.f = b.firebase && b.firebase.tenant || null;
        this.c = !!b.is_anonymous || "anonymous" == this.b;
    }
    hg.prototype.T = function() {
        return this.f;
    };
    hg.prototype.l = function() {
        return this.c;
    };
    hg.prototype.toString = function() {
        return this.h;
    };
    function jg(a) {
        try {
            return new hg(a);
        } catch (b) {
            return null;
        }
    }
    function ig(a) {
        if (!a) return null;
        a = a.split(".");
        if (3 != a.length) return null;
        a = a[1];
        for(var b = (4 - a.length % 4) % 4, c = 0; c < b; c++)a += ".";
        try {
            var d = eg(a);
            a = [];
            for(c = b = 0; b < d.length;){
                var e = d[b++];
                if (128 > e) a[c++] = String.fromCharCode(e);
                else if (191 < e && 224 > e) {
                    var f = d[b++];
                    a[c++] = String.fromCharCode((e & 31) << 6 | f & 63);
                } else if (239 < e && 365 > e) {
                    f = d[b++];
                    var g = d[b++], h = d[b++], m = ((e & 7) << 18 | (f & 63) << 12 | (g & 63) << 6 | h & 63) - 65536;
                    a[c++] = String.fromCharCode(55296 + (m >> 10));
                    a[c++] = String.fromCharCode(56320 + (m & 1023));
                } else f = d[b++], g = d[b++], a[c++] = String.fromCharCode((e & 15) << 12 | (f & 63) << 6 | g & 63);
            }
            return JSON.parse(a.join(""));
        } catch (p) {}
        return null;
    }
    var kg = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "), lg = [
        "client_id",
        "response_type",
        "scope",
        "redirect_uri",
        "state"
    ], mg = {
        nd: {
            Ja: "locale",
            va: 700,
            ua: 600,
            fa: "facebook.com",
            Ya: lg
        },
        pd: {
            Ja: null,
            va: 500,
            ua: 750,
            fa: "github.com",
            Ya: lg
        },
        qd: {
            Ja: "hl",
            va: 515,
            ua: 680,
            fa: "google.com",
            Ya: lg
        },
        wd: {
            Ja: "lang",
            va: 485,
            ua: 705,
            fa: "twitter.com",
            Ya: kg
        },
        kd: {
            Ja: "locale",
            va: 640,
            ua: 600,
            fa: "apple.com",
            Ya: []
        }
    };
    function ng(a) {
        for(var b in mg)if (mg[b].fa == a) return mg[b];
        return null;
    }
    function og(a) {
        var b = {};
        b["facebook.com"] = pg;
        b["google.com"] = qg;
        b["github.com"] = rg;
        b["twitter.com"] = sg;
        var c = a && a[tg];
        try {
            if (c) return b[c] ? new b[c](a) : new ug(a);
            if ("undefined" !== typeof a[vg]) return new wg(a);
        } catch (d) {}
        return null;
    }
    var vg = "idToken", tg = "providerId";
    function wg(a) {
        var b = a[tg];
        if (!b && a[vg]) {
            var c = jg(a[vg]);
            c && c.b && (b = c.b);
        }
        if (!b) throw Error("Invalid additional user info!");
        if ("anonymous" == b || "custom" == b) b = null;
        c = !1;
        "undefined" !== typeof a.isNewUser ? c = !!a.isNewUser : "identitytoolkit#SignupNewUserResponse" === a.kind && (c = !0);
        M(this, "providerId", b);
        M(this, "isNewUser", c);
    }
    function ug(a) {
        wg.call(this, a);
        a = We(a.rawUserInfo || "{}");
        M(this, "profile", nf(a || {}));
    }
    r(ug, wg);
    function pg(a) {
        ug.call(this, a);
        if ("facebook.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    r(pg, ug);
    function rg(a) {
        ug.call(this, a);
        if ("github.com" != this.providerId) throw Error("Invalid provider ID!");
        M(this, "username", this.profile && this.profile.login || null);
    }
    r(rg, ug);
    function qg(a) {
        ug.call(this, a);
        if ("google.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    r(qg, ug);
    function sg(a) {
        ug.call(this, a);
        if ("twitter.com" != this.providerId) throw Error("Invalid provider ID!");
        M(this, "username", a.screenName || null);
    }
    r(sg, ug);
    function xg(a) {
        var b = J(a), c = be(b, "link"), d = be(J(c), "link");
        b = be(b, "deep_link_id");
        return be(J(b), "link") || b || d || c || a;
    }
    function yg(a, b) {
        if (!a && !b) throw new t("internal-error", "Internal assert: no raw session string available");
        if (a && b) throw new t("internal-error", "Internal assert: unable to determine the session type");
        this.a = a || null;
        this.b = b || null;
        this.type = this.a ? zg : Ag;
    }
    var zg = "enroll", Ag = "signin";
    yg.prototype.Ha = function() {
        return this.a ? E(this.a) : E(this.b);
    };
    yg.prototype.w = function() {
        return this.type == zg ? {
            multiFactorSession: {
                idToken: this.a
            }
        } : {
            multiFactorSession: {
                pendingCredential: this.b
            }
        };
    };
    function Bg() {}
    Bg.prototype.ka = function() {};
    Bg.prototype.b = function() {};
    Bg.prototype.c = function() {};
    Bg.prototype.w = function() {};
    function Cg(a, b) {
        return a.then(function(c) {
            if (c[Dg]) {
                var d = jg(c[Dg]);
                if (!d || b != d.i) throw new t("user-mismatch");
                return c;
            }
            throw new t("user-mismatch");
        }).o(function(c) {
            throw c && c.code && c.code == xa + "user-not-found" ? new t("user-mismatch") : c;
        });
    }
    function Eg(a, b) {
        if (b) this.a = b;
        else throw new t("internal-error", "failed to construct a credential");
        M(this, "providerId", a);
        M(this, "signInMethod", a);
    }
    Eg.prototype.ka = function(a) {
        return Fg(a, Gg(this));
    };
    Eg.prototype.b = function(a, b) {
        var c = Gg(this);
        c.idToken = b;
        return Hg(a, c);
    };
    Eg.prototype.c = function(a, b) {
        return Cg(Ig(a, Gg(this)), b);
    };
    function Gg(a) {
        return {
            pendingToken: a.a,
            requestUri: "http://localhost"
        };
    }
    Eg.prototype.w = function() {
        return {
            providerId: this.providerId,
            signInMethod: this.signInMethod,
            pendingToken: this.a
        };
    };
    function Jg(a) {
        if (a && a.providerId && a.signInMethod && 0 == a.providerId.indexOf("saml.") && a.pendingToken) try {
            return new Eg(a.providerId, a.pendingToken);
        } catch (b) {}
        return null;
    }
    function Kg(a, b, c) {
        this.a = null;
        if (b.idToken || b.accessToken) b.idToken && M(this, "idToken", b.idToken), b.accessToken && M(this, "accessToken", b.accessToken), b.nonce && !b.pendingToken && M(this, "nonce", b.nonce), b.pendingToken && (this.a = b.pendingToken);
        else if (b.oauthToken && b.oauthTokenSecret) M(this, "accessToken", b.oauthToken), M(this, "secret", b.oauthTokenSecret);
        else throw new t("internal-error", "failed to construct a credential");
        M(this, "providerId", a);
        M(this, "signInMethod", c);
    }
    Kg.prototype.ka = function(a) {
        return Fg(a, Lg(this));
    };
    Kg.prototype.b = function(a, b) {
        var c = Lg(this);
        c.idToken = b;
        return Hg(a, c);
    };
    Kg.prototype.c = function(a, b) {
        var c = Lg(this);
        return Cg(Ig(a, c), b);
    };
    function Lg(a) {
        var b = {};
        a.idToken && (b.id_token = a.idToken);
        a.accessToken && (b.access_token = a.accessToken);
        a.secret && (b.oauth_token_secret = a.secret);
        b.providerId = a.providerId;
        a.nonce && !a.a && (b.nonce = a.nonce);
        b = {
            postBody: fe(b).toString(),
            requestUri: "http://localhost"
        };
        a.a && (delete b.postBody, b.pendingToken = a.a);
        return b;
    }
    Kg.prototype.w = function() {
        var a = {
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
        this.idToken && (a.oauthIdToken = this.idToken);
        this.accessToken && (a.oauthAccessToken = this.accessToken);
        this.secret && (a.oauthTokenSecret = this.secret);
        this.nonce && (a.nonce = this.nonce);
        this.a && (a.pendingToken = this.a);
        return a;
    };
    function Mg(a) {
        if (a && a.providerId && a.signInMethod) {
            var b = {
                idToken: a.oauthIdToken,
                accessToken: a.oauthTokenSecret ? null : a.oauthAccessToken,
                oauthTokenSecret: a.oauthTokenSecret,
                oauthToken: a.oauthTokenSecret && a.oauthAccessToken,
                nonce: a.nonce,
                pendingToken: a.pendingToken
            };
            try {
                return new Kg(a.providerId, b, a.signInMethod);
            } catch (c) {}
        }
        return null;
    }
    function Ng(a, b) {
        this.Qc = b || [];
        N(this, {
            providerId: a,
            isOAuthProvider: !0
        });
        this.Jb = {};
        this.qb = (ng(a) || {}).Ja || null;
        this.pb = null;
    }
    Ng.prototype.Ka = function(a) {
        this.Jb = nb(a);
        return this;
    };
    function Og(a) {
        if ("string" !== typeof a || 0 != a.indexOf("saml.")) throw new t("argument-error", 'SAML provider IDs must be prefixed with "saml."');
        Ng.call(this, a, []);
    }
    r(Og, Ng);
    function Pg(a) {
        Ng.call(this, a, lg);
        this.a = [];
    }
    r(Pg, Ng);
    Pg.prototype.Ca = function(a) {
        Va(this.a, a) || this.a.push(a);
        return this;
    };
    Pg.prototype.Rb = function() {
        return Za(this.a);
    };
    Pg.prototype.credential = function(a, b) {
        var c;
        n(a) ? c = {
            idToken: a.idToken || null,
            accessToken: a.accessToken || null,
            nonce: a.rawNonce || null
        } : c = {
            idToken: a || null,
            accessToken: b || null
        };
        if (!c.idToken && !c.accessToken) throw new t("argument-error", "credential failed: must provide the ID token and/or the access token.");
        return new Kg(this.providerId, c, this.providerId);
    };
    function Qg() {
        Pg.call(this, "facebook.com");
    }
    r(Qg, Pg);
    M(Qg, "PROVIDER_ID", "facebook.com");
    M(Qg, "FACEBOOK_SIGN_IN_METHOD", "facebook.com");
    function Rg(a) {
        if (!a) throw new t("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        n(a) && (b = a.accessToken);
        return (new Qg).credential({
            accessToken: b
        });
    }
    function Sg() {
        Pg.call(this, "github.com");
    }
    r(Sg, Pg);
    M(Sg, "PROVIDER_ID", "github.com");
    M(Sg, "GITHUB_SIGN_IN_METHOD", "github.com");
    function Tg(a) {
        if (!a) throw new t("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        n(a) && (b = a.accessToken);
        return (new Sg).credential({
            accessToken: b
        });
    }
    function Ug() {
        Pg.call(this, "google.com");
        this.Ca("profile");
    }
    r(Ug, Pg);
    M(Ug, "PROVIDER_ID", "google.com");
    M(Ug, "GOOGLE_SIGN_IN_METHOD", "google.com");
    function Vg(a, b) {
        var c = a;
        n(a) && (c = a.idToken, b = a.accessToken);
        return (new Ug).credential({
            idToken: c,
            accessToken: b
        });
    }
    function Wg() {
        Ng.call(this, "twitter.com", kg);
    }
    r(Wg, Ng);
    M(Wg, "PROVIDER_ID", "twitter.com");
    M(Wg, "TWITTER_SIGN_IN_METHOD", "twitter.com");
    function Xg(a, b) {
        var c = a;
        n(c) || (c = {
            oauthToken: a,
            oauthTokenSecret: b
        });
        if (!c.oauthToken || !c.oauthTokenSecret) throw new t("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");
        return new Kg("twitter.com", c, "twitter.com");
    }
    function Yg(a, b, c) {
        this.a = a;
        this.f = b;
        M(this, "providerId", "password");
        M(this, "signInMethod", c === Zg.EMAIL_LINK_SIGN_IN_METHOD ? Zg.EMAIL_LINK_SIGN_IN_METHOD : Zg.EMAIL_PASSWORD_SIGN_IN_METHOD);
    }
    Yg.prototype.ka = function(a) {
        return this.signInMethod == Zg.EMAIL_LINK_SIGN_IN_METHOD ? O(a, $g, {
            email: this.a,
            oobCode: this.f
        }) : O(a, ah, {
            email: this.a,
            password: this.f
        });
    };
    Yg.prototype.b = function(a, b) {
        return this.signInMethod == Zg.EMAIL_LINK_SIGN_IN_METHOD ? O(a, bh, {
            idToken: b,
            email: this.a,
            oobCode: this.f
        }) : O(a, ch, {
            idToken: b,
            email: this.a,
            password: this.f
        });
    };
    Yg.prototype.c = function(a, b) {
        return Cg(this.ka(a), b);
    };
    Yg.prototype.w = function() {
        return {
            email: this.a,
            password: this.f,
            signInMethod: this.signInMethod
        };
    };
    function dh(a) {
        return a && a.email && a.password ? new Yg(a.email, a.password, a.signInMethod) : null;
    }
    function Zg() {
        N(this, {
            providerId: "password",
            isOAuthProvider: !1
        });
    }
    function eh(a, b) {
        b = fh(b);
        if (!b) throw new t("argument-error", "Invalid email link!");
        return new Yg(a, b.code, Zg.EMAIL_LINK_SIGN_IN_METHOD);
    }
    function fh(a) {
        a = xg(a);
        return (a = Rf(a)) && a.operation === Af ? a : null;
    }
    N(Zg, {
        PROVIDER_ID: "password"
    });
    N(Zg, {
        EMAIL_LINK_SIGN_IN_METHOD: "emailLink"
    });
    N(Zg, {
        EMAIL_PASSWORD_SIGN_IN_METHOD: "password"
    });
    function gh(a) {
        if (!(a.fb && a.eb || a.La && a.ea)) throw new t("internal-error");
        this.a = a;
        M(this, "providerId", "phone");
        this.fa = "phone";
        M(this, "signInMethod", "phone");
    }
    gh.prototype.ka = function(a) {
        return a.gb(hh(this));
    };
    gh.prototype.b = function(a, b) {
        var c = hh(this);
        c.idToken = b;
        return O(a, ih, c);
    };
    gh.prototype.c = function(a, b) {
        var c = hh(this);
        c.operation = "REAUTH";
        a = O(a, jh, c);
        return Cg(a, b);
    };
    gh.prototype.w = function() {
        var a = {
            providerId: "phone"
        };
        this.a.fb && (a.verificationId = this.a.fb);
        this.a.eb && (a.verificationCode = this.a.eb);
        this.a.La && (a.temporaryProof = this.a.La);
        this.a.ea && (a.phoneNumber = this.a.ea);
        return a;
    };
    function kh(a) {
        if (a && "phone" === a.providerId && (a.verificationId && a.verificationCode || a.temporaryProof && a.phoneNumber)) {
            var b = {};
            w([
                "verificationId",
                "verificationCode",
                "temporaryProof",
                "phoneNumber"
            ], function(c) {
                a[c] && (b[c] = a[c]);
            });
            return new gh(b);
        }
        return null;
    }
    function hh(a) {
        return a.a.La && a.a.ea ? {
            temporaryProof: a.a.La,
            phoneNumber: a.a.ea
        } : {
            sessionInfo: a.a.fb,
            code: a.a.eb
        };
    }
    function lh(a) {
        try {
            this.a = a || (0, $8eXKx.default).auth();
        } catch (b) {
            throw new t("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
        }
        N(this, {
            providerId: "phone",
            isOAuthProvider: !1
        });
    }
    lh.prototype.gb = function(a, b) {
        var c = this.a.a;
        return E(b.verify()).then(function(d) {
            if ("string" !== typeof d) throw new t("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");
            switch(b.type){
                case "recaptcha":
                    var e = n(a) ? a.session : null, f = n(a) ? a.phoneNumber : a, g;
                    e && e.type == zg ? g = e.Ha().then(function(h) {
                        return mh(c, {
                            idToken: h,
                            phoneEnrollmentInfo: {
                                phoneNumber: f,
                                recaptchaToken: d
                            }
                        });
                    }) : e && e.type == Ag ? g = e.Ha().then(function(h) {
                        return nh(c, {
                            mfaPendingCredential: h,
                            mfaEnrollmentId: a.multiFactorHint && a.multiFactorHint.uid || a.multiFactorUid,
                            phoneSignInInfo: {
                                recaptchaToken: d
                            }
                        });
                    }) : g = oh(c, {
                        phoneNumber: f,
                        recaptchaToken: d
                    });
                    return g.then(function(h) {
                        "function" === typeof b.reset && b.reset();
                        return h;
                    }, function(h) {
                        "function" === typeof b.reset && b.reset();
                        throw h;
                    });
                default:
                    throw new t("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');
            }
        });
    };
    function ph(a, b) {
        if (!a) throw new t("missing-verification-id");
        if (!b) throw new t("missing-verification-code");
        return new gh({
            fb: a,
            eb: b
        });
    }
    N(lh, {
        PROVIDER_ID: "phone"
    });
    N(lh, {
        PHONE_SIGN_IN_METHOD: "phone"
    });
    function qh(a) {
        if (a.temporaryProof && a.phoneNumber) return new gh({
            La: a.temporaryProof,
            ea: a.phoneNumber
        });
        var b = a && a.providerId;
        if (!b || "password" === b) return null;
        var c = a && a.oauthAccessToken, d = a && a.oauthTokenSecret, e = a && a.nonce, f = a && a.oauthIdToken, g = a && a.pendingToken;
        try {
            switch(b){
                case "google.com":
                    return Vg(f, c);
                case "facebook.com":
                    return Rg(c);
                case "github.com":
                    return Tg(c);
                case "twitter.com":
                    return Xg(c, d);
                default:
                    return c || d || f || g ? g ? 0 == b.indexOf("saml.") ? new Eg(b, g) : new Kg(b, {
                        pendingToken: g,
                        idToken: a.oauthIdToken,
                        accessToken: a.oauthAccessToken
                    }, b) : new Pg(b).credential({
                        idToken: f,
                        accessToken: c,
                        rawNonce: e
                    }) : null;
            }
        } catch (h) {
            return null;
        }
    }
    function rh(a) {
        if (!a.isOAuthProvider) throw new t("invalid-oauth-provider");
    }
    function sh(a, b, c, d, e, f, g) {
        this.c = a;
        this.b = b || null;
        this.g = c || null;
        this.f = d || null;
        this.i = f || null;
        this.h = g || null;
        this.a = e || null;
        if (this.g || this.a) {
            if (this.g && this.a) throw new t("invalid-auth-event");
            if (this.g && !this.f) throw new t("invalid-auth-event");
        } else throw new t("invalid-auth-event");
    }
    sh.prototype.getUid = function() {
        var a = [];
        a.push(this.c);
        this.b && a.push(this.b);
        this.f && a.push(this.f);
        this.h && a.push(this.h);
        return a.join("-");
    };
    sh.prototype.T = function() {
        return this.h;
    };
    sh.prototype.w = function() {
        return {
            type: this.c,
            eventId: this.b,
            urlResponse: this.g,
            sessionId: this.f,
            postBody: this.i,
            tenantId: this.h,
            error: this.a && this.a.w()
        };
    };
    function th(a) {
        a = a || {};
        return a.type ? new sh(a.type, a.eventId, a.urlResponse, a.sessionId, a.error && Aa(a.error), a.postBody, a.tenantId) : null;
    }
    function uh() {
        this.b = null;
        this.a = [];
    }
    var vh = null;
    function wh(a) {
        var b = vh;
        b.a.push(a);
        b.b || (b.b = function(c) {
            for(var d = 0; d < b.a.length; d++)b.a[d](c);
        }, a = L("universalLinks.subscribe", l), "function" === typeof a && a(null, b.b));
    }
    function xh(a) {
        var b = "unauthorized-domain", c = void 0, d = J(a);
        a = d.a;
        d = d.c;
        "chrome-extension" == d ? c = Qb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : "http" == d || "https" == d ? c = Qb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : b = "operation-not-supported-in-this-environment";
        t.call(this, b, c);
    }
    r(xh, t);
    function yh(a, b, c) {
        t.call(this, a, c);
        a = b || {};
        a.Kb && M(this, "email", a.Kb);
        a.ea && M(this, "phoneNumber", a.ea);
        a.credential && M(this, "credential", a.credential);
        a.$b && M(this, "tenantId", a.$b);
    }
    r(yh, t);
    yh.prototype.w = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.email && (a.email = this.email);
        this.phoneNumber && (a.phoneNumber = this.phoneNumber);
        this.tenantId && (a.tenantId = this.tenantId);
        var b = this.credential && this.credential.w();
        b && z(a, b);
        return a;
    };
    yh.prototype.toJSON = function() {
        return this.w();
    };
    function zh(a) {
        if (a.code) {
            var b = a.code || "";
            0 == b.indexOf(xa) && (b = b.substring(xa.length));
            var c = {
                credential: qh(a),
                $b: a.tenantId
            };
            if (a.email) c.Kb = a.email;
            else if (a.phoneNumber) c.ea = a.phoneNumber;
            else if (!c.credential) return new t(b, a.message || void 0);
            return new yh(b, c, a.message);
        }
        return null;
    }
    function Ah() {}
    Ah.prototype.c = null;
    function Bh(a) {
        return a.c || (a.c = a.b());
    }
    var Ch;
    function Dh() {}
    r(Dh, Ah);
    Dh.prototype.a = function() {
        var a = Eh(this);
        return a ? new ActiveXObject(a) : new XMLHttpRequest;
    };
    Dh.prototype.b = function() {
        var a = {};
        Eh(this) && (a[0] = !0, a[1] = !0);
        return a;
    };
    function Eh(a) {
        if (!a.f && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for(var b = [
                "MSXML2.XMLHTTP.6.0",
                "MSXML2.XMLHTTP.3.0",
                "MSXML2.XMLHTTP",
                "Microsoft.XMLHTTP"
            ], c = 0; c < b.length; c++){
                var d = b[c];
                try {
                    return new ActiveXObject(d), a.f = d;
                } catch (e) {}
            }
            throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }
        return a.f;
    }
    Ch = new Dh;
    function Fh() {}
    r(Fh, Ah);
    Fh.prototype.a = function() {
        var a = new XMLHttpRequest;
        if ("withCredentials" in a) return a;
        if ("undefined" != typeof XDomainRequest) return new Gh;
        throw Error("Unsupported browser");
    };
    Fh.prototype.b = function() {
        return {};
    };
    function Gh() {
        this.a = new XDomainRequest;
        this.readyState = 0;
        this.onreadystatechange = null;
        this.responseType = this.responseText = this.response = "";
        this.status = -1;
        this.statusText = "";
        this.a.onload = q(this.qc, this);
        this.a.onerror = q(this.Tb, this);
        this.a.onprogress = q(this.rc, this);
        this.a.ontimeout = q(this.vc, this);
    }
    k = Gh.prototype;
    k.open = function(a, b, c) {
        if (null != c && !c) throw Error("Only async requests are supported.");
        this.a.open(a, b);
    };
    k.send = function(a) {
        if (a) {
            if ("string" == typeof a) this.a.send(a);
            else throw Error("Only string data is supported");
        } else this.a.send();
    };
    k.abort = function() {
        this.a.abort();
    };
    k.setRequestHeader = function() {};
    k.getResponseHeader = function(a) {
        return "content-type" == a.toLowerCase() ? this.a.contentType : "";
    };
    k.qc = function() {
        this.status = 200;
        this.response = this.responseText = this.a.responseText;
        Hh(this, 4);
    };
    k.Tb = function() {
        this.status = 500;
        this.response = this.responseText = "";
        Hh(this, 4);
    };
    k.vc = function() {
        this.Tb();
    };
    k.rc = function() {
        this.status = 200;
        Hh(this, 1);
    };
    function Hh(a, b) {
        a.readyState = b;
        if (a.onreadystatechange) a.onreadystatechange();
    }
    k.getAllResponseHeaders = function() {
        return "content-type: " + this.a.contentType;
    };
    function Ih(a, b, c) {
        this.reset(a, b, c, void 0, void 0);
    }
    Ih.prototype.a = null;
    var Jh = 0;
    Ih.prototype.reset = function(a, b, c, d, e) {
        "number" == typeof e || Jh++;
        d || va();
        delete this.a;
    };
    function Kh(a) {
        this.f = a;
        this.b = this.c = this.a = null;
    }
    function Lh(a, b) {
        this.name = a;
        this.value = b;
    }
    Lh.prototype.toString = function() {
        return this.name;
    };
    var Mh = new Lh("SEVERE", 1E3), Nh = new Lh("WARNING", 900), Oh = new Lh("CONFIG", 700), Ph = new Lh("FINE", 500);
    function Qh(a) {
        if (a.c) return a.c;
        if (a.a) return Qh(a.a);
        Ga("Root logger has no level set.");
        return null;
    }
    Kh.prototype.log = function(a, b, c) {
        if (a.value >= Qh(this).value) for(oa(b) && (b = b()), a = new Ih(a, String(b), this.f), c && (a.a = c), c = this; c;)c = c.a;
    };
    var Rh = {}, Sh = null;
    function Th(a) {
        Sh || (Sh = new Kh(""), Rh[""] = Sh, Sh.c = Oh);
        var b;
        if (!(b = Rh[a])) {
            b = new Kh(a);
            var c = a.lastIndexOf("."), d = a.substr(c + 1);
            c = Th(a.substr(0, c));
            c.b || (c.b = {});
            c.b[d] = b;
            b.a = c;
            Rh[a] = b;
        }
        return b;
    }
    function Uh(a, b) {
        a && a.log(Ph, b, void 0);
    }
    function Vh(a) {
        this.f = a;
    }
    r(Vh, Ah);
    Vh.prototype.a = function() {
        return new Wh(this.f);
    };
    Vh.prototype.b = function(a) {
        return function() {
            return a;
        };
    }({});
    function Wh(a) {
        H.call(this);
        this.u = a;
        this.h = void 0;
        this.readyState = Xh;
        this.status = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.l = new Headers;
        this.b = null;
        this.s = "GET";
        this.f = "";
        this.a = !1;
        this.i = Th("goog.net.FetchXmlHttp");
        this.m = this.c = this.g = null;
    }
    r(Wh, H);
    var Xh = 0;
    k = Wh.prototype;
    k.open = function(a, b) {
        if (this.readyState != Xh) throw this.abort(), Error("Error reopening a connection");
        this.s = a;
        this.f = b;
        this.readyState = 1;
        Yh(this);
    };
    k.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.a = !0;
        var b = {
            headers: this.l,
            method: this.s,
            credentials: this.h,
            cache: void 0
        };
        a && (b.body = a);
        this.u.fetch(new Request(this.f, b)).then(this.uc.bind(this), this.Va.bind(this));
    };
    k.abort = function() {
        this.response = this.responseText = "";
        this.l = new Headers;
        this.status = 0;
        this.c && this.c.cancel("Request was aborted.");
        1 <= this.readyState && this.a && 4 != this.readyState && (this.a = !1, Zh(this));
        this.readyState = Xh;
    };
    k.uc = function(a) {
        this.a && (this.g = a, this.b || (this.status = this.g.status, this.statusText = this.g.statusText, this.b = a.headers, this.readyState = 2, Yh(this)), this.a && (this.readyState = 3, Yh(this), this.a && ("arraybuffer" === this.responseType ? a.arrayBuffer().then(this.sc.bind(this), this.Va.bind(this)) : "undefined" !== typeof l.ReadableStream && "body" in a ? (this.response = this.responseText = "", this.c = a.body.getReader(), this.m = new TextDecoder, $h(this)) : a.text().then(this.tc.bind(this), this.Va.bind(this)))));
    };
    function $h(a) {
        a.c.read().then(a.pc.bind(a)).catch(a.Va.bind(a));
    }
    k.pc = function(a) {
        if (this.a) {
            var b = this.m.decode(a.value ? a.value : new Uint8Array(0), {
                stream: !a.done
            });
            b && (this.response = this.responseText += b);
            a.done ? Zh(this) : Yh(this);
            3 == this.readyState && $h(this);
        }
    };
    k.tc = function(a) {
        this.a && (this.response = this.responseText = a, Zh(this));
    };
    k.sc = function(a) {
        this.a && (this.response = a, Zh(this));
    };
    k.Va = function(a) {
        var b = this.i;
        b && b.log(Nh, "Failed to fetch url " + this.f, a instanceof Error ? a : Error(a));
        this.a && Zh(this);
    };
    function Zh(a) {
        a.readyState = 4;
        a.g = null;
        a.c = null;
        a.m = null;
        Yh(a);
    }
    k.setRequestHeader = function(a, b) {
        this.l.append(a, b);
    };
    k.getResponseHeader = function(a) {
        return this.b ? this.b.get(a.toLowerCase()) || "" : ((a = this.i) && a.log(Nh, "Attempting to get response header but no headers have been received for url: " + this.f, void 0), "");
    };
    k.getAllResponseHeaders = function() {
        if (!this.b) {
            var a = this.i;
            a && a.log(Nh, "Attempting to get all response headers but no headers have been received for url: " + this.f, void 0);
            return "";
        }
        a = [];
        for(var b = this.b.entries(), c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Yh(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Wh.prototype, "withCredentials", {
        get: function() {
            return "include" === this.h;
        },
        set: function(a) {
            this.h = a ? "include" : "same-origin";
        }
    });
    function ai(a) {
        H.call(this);
        this.headers = new Jd;
        this.D = a || null;
        this.c = !1;
        this.C = this.a = null;
        this.h = this.P = this.l = "";
        this.f = this.N = this.i = this.J = !1;
        this.g = 0;
        this.s = null;
        this.m = bi;
        this.u = this.S = !1;
    }
    r(ai, H);
    var bi = "";
    ai.prototype.b = Th("goog.net.XhrIo");
    var ci = /^https?$/i, di = [
        "POST",
        "PUT"
    ];
    function ei(a, b, c, d, e) {
        if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.l + "; newUri=" + b);
        c = c ? c.toUpperCase() : "GET";
        a.l = b;
        a.h = "";
        a.P = c;
        a.J = !1;
        a.c = !0;
        a.a = a.D ? a.D.a() : Ch.a();
        a.C = a.D ? Bh(a.D) : Bh(Ch);
        a.a.onreadystatechange = q(a.Wb, a);
        try {
            Uh(a.b, fi(a, "Opening Xhr")), a.N = !0, a.a.open(c, String(b), !0), a.N = !1;
        } catch (g) {
            Uh(a.b, fi(a, "Error opening Xhr: " + g.message));
            gi(a, g);
            return;
        }
        b = d || "";
        var f = new Jd(a.headers);
        e && Id(e, function(g, h) {
            f.set(h, g);
        });
        e = Ta(f.Y());
        d = l.FormData && b instanceof l.FormData;
        !Va(di, c) || e || d || f.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        f.forEach(function(g, h) {
            this.a.setRequestHeader(h, g);
        }, a);
        a.m && (a.a.responseType = a.m);
        "withCredentials" in a.a && a.a.withCredentials !== a.S && (a.a.withCredentials = a.S);
        try {
            hi(a), 0 < a.g && (a.u = ii(a.a), Uh(a.b, fi(a, "Will abort after " + a.g + "ms if incomplete, xhr2 " + a.u)), a.u ? (a.a.timeout = a.g, a.a.ontimeout = q(a.Ma, a)) : a.s = Ed(a.Ma, a.g, a)), Uh(a.b, fi(a, "Sending request")), a.i = !0, a.a.send(b), a.i = !1;
        } catch (g) {
            Uh(a.b, fi(a, "Send error: " + g.message)), gi(a, g);
        }
    }
    function ii(a) {
        return Wb && fc(9) && "number" === typeof a.timeout && void 0 !== a.ontimeout;
    }
    function Ua(a) {
        return "content-type" == a.toLowerCase();
    }
    k = ai.prototype;
    k.Ma = function() {
        "undefined" != typeof ha && this.a && (this.h = "Timed out after " + this.g + "ms, aborting", Uh(this.b, fi(this, this.h)), this.dispatchEvent("timeout"), this.abort(8));
    };
    function gi(a, b) {
        a.c = !1;
        a.a && (a.f = !0, a.a.abort(), a.f = !1);
        a.h = b;
        ji(a);
        ki(a);
    }
    function ji(a) {
        a.J || (a.J = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
    }
    k.abort = function() {
        this.a && this.c && (Uh(this.b, fi(this, "Aborting")), this.c = !1, this.f = !0, this.a.abort(), this.f = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), ki(this));
    };
    k.Da = function() {
        this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), ki(this, !0));
        ai.bb.Da.call(this);
    };
    k.Wb = function() {
        this.ya || (this.N || this.i || this.f ? li(this) : this.Jc());
    };
    k.Jc = function() {
        li(this);
    };
    function li(a) {
        if (a.c && "undefined" != typeof ha) {
            if (a.C[1] && 4 == mi(a) && 2 == ni(a)) Uh(a.b, fi(a, "Local request error detected and ignored"));
            else if (a.i && 4 == mi(a)) Ed(a.Wb, 0, a);
            else if (a.dispatchEvent("readystatechange"), 4 == mi(a)) {
                Uh(a.b, fi(a, "Request complete"));
                a.c = !1;
                try {
                    var b = ni(a);
                    a: switch(b){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var c = !0;
                            break a;
                        default:
                            c = !1;
                    }
                    var d;
                    if (!(d = c)) {
                        var e;
                        if (e = 0 === b) {
                            var f = String(a.l).match(Md)[1] || null;
                            if (!f && l.self && l.self.location) {
                                var g = l.self.location.protocol;
                                f = g.substr(0, g.length - 1);
                            }
                            e = !ci.test(f ? f.toLowerCase() : "");
                        }
                        d = e;
                    }
                    if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");
                    else {
                        try {
                            var h = 2 < mi(a) ? a.a.statusText : "";
                        } catch (m) {
                            Uh(a.b, "Can not get status: " + m.message), h = "";
                        }
                        a.h = h + " [" + ni(a) + "]";
                        ji(a);
                    }
                } finally{
                    ki(a);
                }
            }
        }
    }
    function ki(a, b) {
        if (a.a) {
            hi(a);
            var c = a.a, d = a.C[0] ? la : null;
            a.a = null;
            a.C = null;
            b || a.dispatchEvent("ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.b) && a.log(Mh, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    }
    function hi(a) {
        a.a && a.u && (a.a.ontimeout = null);
        a.s && (l.clearTimeout(a.s), a.s = null);
    }
    function mi(a) {
        return a.a ? a.a.readyState : 0;
    }
    function ni(a) {
        try {
            return 2 < mi(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    }
    function oi(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return Uh(a.b, "Can not get responseText: " + b.message), "";
        }
    }
    k.getResponse = function() {
        try {
            if (!this.a) return null;
            if ("response" in this.a) return this.a.response;
            switch(this.m){
                case bi:
                case "text":
                    return this.a.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in this.a) return this.a.mozResponseArrayBuffer;
            }
            var a = this.b;
            a && a.log(Mh, "Response type " + this.m + " is not supported on this browser", void 0);
            return null;
        } catch (b) {
            return Uh(this.b, "Can not get response: " + b.message), null;
        }
    };
    function fi(a, b) {
        return b + " [" + a.P + " " + a.l + " " + ni(a) + "]";
    }
    function pi(a) {
        var b = qi;
        this.g = [];
        this.u = b;
        this.s = a || null;
        this.f = this.a = !1;
        this.c = void 0;
        this.v = this.C = this.i = !1;
        this.h = 0;
        this.b = null;
        this.l = 0;
    }
    pi.prototype.cancel = function(a) {
        if (this.a) this.c instanceof pi && this.c.cancel();
        else {
            if (this.b) {
                var b = this.b;
                delete this.b;
                a ? b.cancel(a) : (b.l--, 0 >= b.l && b.cancel());
            }
            this.u ? this.u.call(this.s, this) : this.v = !0;
            this.a || (a = new ri(this), si(this), ti(this, !1, a));
        }
    };
    pi.prototype.m = function(a, b) {
        this.i = !1;
        ti(this, a, b);
    };
    function ti(a, b, c) {
        a.a = !0;
        a.c = c;
        a.f = !b;
        ui(a);
    }
    function si(a) {
        if (a.a) {
            if (!a.v) throw new vi(a);
            a.v = !1;
        }
    }
    function wi(a, b) {
        xi(a, null, b, void 0);
    }
    function xi(a, b, c, d) {
        a.g.push([
            b,
            c,
            d
        ]);
        a.a && ui(a);
    }
    pi.prototype.then = function(a, b, c) {
        var d, e, f = new D(function(g, h) {
            d = g;
            e = h;
        });
        xi(this, d, function(g) {
            g instanceof ri ? f.cancel() : e(g);
        });
        return f.then(a, b, c);
    };
    pi.prototype.$goog_Thenable = !0;
    function yi(a) {
        return Sa(a.g, function(b) {
            return oa(b[1]);
        });
    }
    function ui(a) {
        if (a.h && a.a && yi(a)) {
            var b = a.h, c = zi[b];
            c && (l.clearTimeout(c.a), delete zi[b]);
            a.h = 0;
        }
        a.b && (a.b.l--, delete a.b);
        b = a.c;
        for(var d = c = !1; a.g.length && !a.i;){
            var e = a.g.shift(), f = e[0], g = e[1];
            e = e[2];
            if (f = a.f ? g : f) try {
                var h = f.call(e || a.s, b);
                void 0 !== h && (a.f = a.f && (h == b || h instanceof Error), a.c = b = h);
                if (Ea(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.i = !0;
            } catch (m) {
                b = m, a.f = !0, yi(a) || (c = !0);
            }
        }
        a.c = b;
        d && (h = q(a.m, a, !0), d = q(a.m, a, !1), b instanceof pi ? (xi(b, h, d), b.C = !0) : b.then(h, d));
        c && (b = new Ai(b), zi[b.a] = b, a.h = b.a);
    }
    function vi() {
        u.call(this);
    }
    r(vi, u);
    vi.prototype.message = "Deferred has already fired";
    vi.prototype.name = "AlreadyCalledError";
    function ri() {
        u.call(this);
    }
    r(ri, u);
    ri.prototype.message = "Deferred was canceled";
    ri.prototype.name = "CanceledError";
    function Ai(a) {
        this.a = l.setTimeout(q(this.c, this), 0);
        this.b = a;
    }
    Ai.prototype.c = function() {
        delete zi[this.a];
        throw this.b;
    };
    var zi = {};
    function Bi(a) {
        var b = {}, c = b.document || document, d = yb(a).toString(), e = oc(document, "SCRIPT"), f = {
            Xb: e,
            Ma: void 0
        }, g = new pi(f), h = null, m = null != b.timeout ? b.timeout : 5E3;
        0 < m && (h = window.setTimeout(function() {
            Ci(e, !0);
            var p = new Di(Ei, "Timeout reached for loading script " + d);
            si(g);
            ti(g, !1, p);
        }, m), f.Ma = h);
        e.onload = e.onreadystatechange = function() {
            e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (Ci(e, b.xd || !1, h), si(g), ti(g, !0, null));
        };
        e.onerror = function() {
            Ci(e, !0, h);
            var p = new Di(Fi, "Error while loading script " + d);
            si(g);
            ti(g, !1, p);
        };
        f = b.attributes || {};
        z(f, {
            type: "text/javascript",
            charset: "UTF-8"
        });
        lc(e, f);
        Ob(e, a);
        Gi(c).appendChild(e);
        return g;
    }
    function Gi(a) {
        var b;
        return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
    }
    function qi() {
        if (this && this.Xb) {
            var a = this.Xb;
            a && "SCRIPT" == a.tagName && Ci(a, !0, this.Ma);
        }
    }
    function Ci(a, b, c) {
        null != c && l.clearTimeout(c);
        a.onload = la;
        a.onerror = la;
        a.onreadystatechange = la;
        b && window.setTimeout(function() {
            a && a.parentNode && a.parentNode.removeChild(a);
        }, 0);
    }
    var Fi = 0, Ei = 1;
    function Di(a, b) {
        var c = "Jsloader error (code #" + a + ")";
        b && (c += ": " + b);
        u.call(this, c);
        this.code = a;
    }
    r(Di, u);
    function Hi(a) {
        this.f = a;
    }
    r(Hi, Ah);
    Hi.prototype.a = function() {
        return new this.f;
    };
    Hi.prototype.b = function() {
        return {};
    };
    function Ii(a, b, c) {
        this.c = a;
        a = b || {};
        this.l = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";
        this.m = a.secureTokenTimeout || Ji;
        this.g = nb(a.secureTokenHeaders || Ki);
        this.h = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";
        this.i = a.identityPlatformEndpoint || "https://identitytoolkit.googleapis.com/v2/";
        this.v = a.firebaseTimeout || Li;
        this.a = nb(a.firebaseHeaders || Mi);
        c && (this.a["X-Client-Version"] = c, this.g["X-Client-Version"] = c);
        c = "Node" == Ke();
        c = l.XMLHttpRequest || c && (0, $8eXKx.default).INTERNAL.node && (0, $8eXKx.default).INTERNAL.node.XMLHttpRequest;
        if (!c && !Je()) throw new t("internal-error", "The XMLHttpRequest compatibility library was not found.");
        this.f = void 0;
        Je() ? this.f = new Vh(self) : Le() ? this.f = new Hi(c) : this.f = new Fh;
        this.b = null;
    }
    var Ni, Dg = "idToken", Ji = new Ze(3E4, 6E4), Ki = {
        "Content-Type": "application/x-www-form-urlencoded"
    }, Li = new Ze(3E4, 6E4), Mi = {
        "Content-Type": "application/json"
    };
    function Oi(a, b) {
        b ? a.a["X-Firebase-Locale"] = b : delete a.a["X-Firebase-Locale"];
    }
    function Pi(a, b) {
        b && (a.l = Qi("https://securetoken.googleapis.com/v1/token", b), a.h = Qi("https://www.googleapis.com/identitytoolkit/v3/relyingparty/", b), a.i = Qi("https://identitytoolkit.googleapis.com/v2/", b));
    }
    function Qi(a, b) {
        a = J(a);
        b = J(b.url);
        a.f = a.a + a.f;
        Pd(a, b.c);
        a.a = b.a;
        Qd(a, b.g);
        return a.toString();
    }
    function Ri(a, b) {
        b ? (a.a["X-Client-Version"] = b, a.g["X-Client-Version"] = b) : (delete a.a["X-Client-Version"], delete a.g["X-Client-Version"]);
    }
    Ii.prototype.T = function() {
        return this.b;
    };
    function Si(a, b, c, d, e, f, g) {
        ue() || Je() ? a = q(a.u, a) : (Ni || (Ni = new D(function(h, m) {
            Ti(h, m);
        })), a = q(a.s, a));
        a(b, c, d, e, f, g);
    }
    Ii.prototype.u = function(a, b, c, d, e, f) {
        if (Je() && ("undefined" === typeof l.fetch || "undefined" === typeof l.Headers || "undefined" === typeof l.Request)) throw new t("operation-not-supported-in-this-environment", "fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");
        var g = new ai(this.f);
        if (f) {
            g.g = Math.max(0, f);
            var h = setTimeout(function() {
                g.dispatchEvent("timeout");
            }, f);
        }
        qd(g, "complete", function() {
            h && clearTimeout(h);
            var m = null;
            try {
                m = JSON.parse(oi(this)) || null;
            } catch (p) {
                m = null;
            }
            b && b(m);
        });
        wd(g, "ready", function() {
            h && clearTimeout(h);
            Xc(this);
        });
        wd(g, "timeout", function() {
            h && clearTimeout(h);
            Xc(this);
            b && b(null);
        });
        ei(g, a, c, d, e);
    };
    var Ui = new qb(rb, "https://apis.google.com/js/client.js?onload=%{onload}"), Vi = "__fcb" + Math.floor(1E6 * Math.random()).toString();
    function Ti(a, b) {
        if (((window.gapi || {}).client || {}).request) a();
        else {
            l[Vi] = function() {
                ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
            };
            var c = zb(Ui, {
                onload: Vi
            });
            wi(Bi(c), function() {
                b(Error("CORS_UNSUPPORTED"));
            });
        }
    }
    Ii.prototype.s = function(a, b, c, d, e) {
        var f = this;
        Ni.then(function() {
            window.gapi.client.setApiKey(f.c);
            var g = window.gapi.auth.getToken();
            window.gapi.auth.setToken(null);
            window.gapi.client.request({
                path: a,
                method: c,
                body: d,
                headers: e,
                authType: "none",
                callback: function(h) {
                    window.gapi.auth.setToken(g);
                    b && b(h);
                }
            });
        }).o(function(g) {
            b && b({
                error: {
                    message: g && g.message || "CORS_UNSUPPORTED"
                }
            });
        });
    };
    function Wi(a, b) {
        return new D(function(c, d) {
            "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? Si(a, a.l + "?key=" + encodeURIComponent(a.c), function(e) {
                e ? e.error ? d(Xi(e)) : e.access_token && e.refresh_token ? c(e) : d(new t("internal-error")) : d(new t("network-request-failed"));
            }, "POST", fe(b).toString(), a.g, a.m.get()) : d(new t("internal-error"));
        });
    }
    function Yi(a, b, c, d, e, f, g) {
        var h = J(b + c);
        I(h, "key", a.c);
        g && I(h, "cb", Date.now().toString());
        var m = "GET" == d;
        if (m) for(var p in e)e.hasOwnProperty(p) && I(h, p, e[p]);
        return new D(function(v, B) {
            Si(a, h.toString(), function(A) {
                A ? A.error ? B(Xi(A, f || {})) : v(A) : B(new t("network-request-failed"));
            }, d, m ? void 0 : ke(Ve(e)), a.a, a.v.get());
        });
    }
    function Zi(a) {
        a = a.email;
        if ("string" !== typeof a || !De.test(a)) throw new t("invalid-email");
    }
    function $i(a) {
        "email" in a && Zi(a);
    }
    function aj(a, b) {
        return O(a, bj, {
            identifier: b,
            continueUri: Se() ? re() : "http://localhost"
        }).then(function(c) {
            return c.signinMethods || [];
        });
    }
    function cj(a) {
        return O(a, dj, {}).then(function(b) {
            return b.authorizedDomains || [];
        });
    }
    function P(a) {
        if (!a[Dg]) {
            if (a.mfaPendingCredential) throw new t("multi-factor-auth-required", null, nb(a));
            throw new t("internal-error");
        }
    }
    function ej(a) {
        if (a.phoneNumber || a.temporaryProof) {
            if (!a.phoneNumber || !a.temporaryProof) throw new t("internal-error");
        } else {
            if (!a.sessionInfo) throw new t("missing-verification-id");
            if (!a.code) throw new t("missing-verification-code");
        }
    }
    Ii.prototype.Ab = function() {
        return O(this, fj, {});
    };
    Ii.prototype.Cb = function(a, b) {
        return O(this, gj, {
            idToken: a,
            email: b
        });
    };
    Ii.prototype.Db = function(a, b) {
        return O(this, ch, {
            idToken: a,
            password: b
        });
    };
    var hj = {
        displayName: "DISPLAY_NAME",
        photoUrl: "PHOTO_URL"
    };
    k = Ii.prototype;
    k.Eb = function(a, b) {
        var c = {
            idToken: a
        }, d = [];
        lb(hj, function(e, f) {
            var g = b[f];
            null === g ? d.push(e) : f in b && (c[f] = g);
        });
        d.length && (c.deleteAttribute = d);
        return O(this, gj, c);
    };
    k.wb = function(a, b) {
        a = {
            requestType: "PASSWORD_RESET",
            email: a
        };
        z(a, b);
        return O(this, ij, a);
    };
    k.xb = function(a, b) {
        a = {
            requestType: "EMAIL_SIGNIN",
            email: a
        };
        z(a, b);
        return O(this, jj, a);
    };
    k.vb = function(a, b) {
        a = {
            requestType: "VERIFY_EMAIL",
            idToken: a
        };
        z(a, b);
        return O(this, kj, a);
    };
    k.Fb = function(a, b, c) {
        a = {
            requestType: "VERIFY_AND_CHANGE_EMAIL",
            idToken: a,
            newEmail: b
        };
        z(a, c);
        return O(this, lj, a);
    };
    function oh(a, b) {
        return O(a, mj, b);
    }
    k.gb = function(a) {
        return O(this, nj, a);
    };
    function mh(a, b) {
        return O(a, oj, b).then(function(c) {
            return c.phoneSessionInfo.sessionInfo;
        });
    }
    function pj(a) {
        if (!a.phoneVerificationInfo) throw new t("internal-error");
        if (!a.phoneVerificationInfo.sessionInfo) throw new t("missing-verification-id");
        if (!a.phoneVerificationInfo.code) throw new t("missing-verification-code");
    }
    function nh(a, b) {
        return O(a, qj, b).then(function(c) {
            return c.phoneResponseInfo.sessionInfo;
        });
    }
    function rj(a, b, c) {
        return O(a, sj, {
            idToken: b,
            deleteProvider: c
        });
    }
    function tj(a) {
        if (!a.requestUri || !a.sessionId && !a.postBody && !a.pendingToken) throw new t("internal-error");
    }
    function uj(a, b) {
        b.oauthIdToken && b.providerId && 0 == b.providerId.indexOf("oidc.") && !b.pendingToken && (a.sessionId ? b.nonce = a.sessionId : a.postBody && (a = new Ud(a.postBody), je(a, "nonce") && (b.nonce = a.get("nonce"))));
        return b;
    }
    function vj(a) {
        var b = null;
        a.needConfirmation ? (a.code = "account-exists-with-different-credential", b = zh(a)) : "FEDERATED_USER_ID_ALREADY_LINKED" == a.errorMessage ? (a.code = "credential-already-in-use", b = zh(a)) : "EMAIL_EXISTS" == a.errorMessage ? (a.code = "email-already-in-use", b = zh(a)) : a.errorMessage && (b = wj(a.errorMessage));
        if (b) throw b;
        P(a);
    }
    function Fg(a, b) {
        b.returnIdpCredential = !0;
        return O(a, xj, b);
    }
    function Hg(a, b) {
        b.returnIdpCredential = !0;
        return O(a, yj, b);
    }
    function Ig(a, b) {
        b.returnIdpCredential = !0;
        b.autoCreate = !1;
        return O(a, zj, b);
    }
    function Aj(a) {
        if (!a.oobCode) throw new t("invalid-action-code");
    }
    k.ob = function(a, b) {
        return O(this, Bj, {
            oobCode: a,
            newPassword: b
        });
    };
    k.Sa = function(a) {
        return O(this, Cj, {
            oobCode: a
        });
    };
    k.kb = function(a) {
        return O(this, Dj, {
            oobCode: a
        });
    };
    var Dj = {
        endpoint: "setAccountInfo",
        A: Aj,
        Z: "email",
        B: !0
    }, Cj = {
        endpoint: "resetPassword",
        A: Aj,
        G: function(a) {
            var b = a.requestType;
            if (!b || !a.email && "EMAIL_SIGNIN" != b && "VERIFY_AND_CHANGE_EMAIL" != b) throw new t("internal-error");
        },
        B: !0
    }, Ej = {
        endpoint: "signupNewUser",
        A: function(a) {
            Zi(a);
            if (!a.password) throw new t("weak-password");
        },
        G: P,
        V: !0,
        B: !0
    }, bj = {
        endpoint: "createAuthUri",
        B: !0
    }, Fj = {
        endpoint: "deleteAccount",
        O: [
            "idToken"
        ]
    }, sj = {
        endpoint: "setAccountInfo",
        O: [
            "idToken",
            "deleteProvider"
        ],
        A: function(a) {
            if (!Array.isArray(a.deleteProvider)) throw new t("internal-error");
        }
    }, $g = {
        endpoint: "emailLinkSignin",
        O: [
            "email",
            "oobCode"
        ],
        A: Zi,
        G: P,
        V: !0,
        B: !0
    }, bh = {
        endpoint: "emailLinkSignin",
        O: [
            "idToken",
            "email",
            "oobCode"
        ],
        A: Zi,
        G: P,
        V: !0
    }, Gj = {
        endpoint: "accounts/mfaEnrollment:finalize",
        O: [
            "idToken",
            "phoneVerificationInfo"
        ],
        A: pj,
        G: P,
        B: !0,
        Na: !0
    }, Hj = {
        endpoint: "accounts/mfaSignIn:finalize",
        O: [
            "mfaPendingCredential",
            "phoneVerificationInfo"
        ],
        A: pj,
        G: P,
        B: !0,
        Na: !0
    }, Ij = {
        endpoint: "getAccountInfo"
    }, jj = {
        endpoint: "getOobConfirmationCode",
        O: [
            "requestType"
        ],
        A: function(a) {
            if ("EMAIL_SIGNIN" != a.requestType) throw new t("internal-error");
            Zi(a);
        },
        Z: "email",
        B: !0
    }, kj = {
        endpoint: "getOobConfirmationCode",
        O: [
            "idToken",
            "requestType"
        ],
        A: function(a) {
            if ("VERIFY_EMAIL" != a.requestType) throw new t("internal-error");
        },
        Z: "email",
        B: !0
    }, lj = {
        endpoint: "getOobConfirmationCode",
        O: [
            "idToken",
            "newEmail",
            "requestType"
        ],
        A: function(a) {
            if ("VERIFY_AND_CHANGE_EMAIL" != a.requestType) throw new t("internal-error");
        },
        Z: "email",
        B: !0
    }, ij = {
        endpoint: "getOobConfirmationCode",
        O: [
            "requestType"
        ],
        A: function(a) {
            if ("PASSWORD_RESET" != a.requestType) throw new t("internal-error");
            Zi(a);
        },
        Z: "email",
        B: !0
    }, dj = {
        mb: !0,
        endpoint: "getProjectConfig",
        Vb: "GET"
    }, Jj = {
        mb: !0,
        endpoint: "getRecaptchaParam",
        Vb: "GET",
        G: function(a) {
            if (!a.recaptchaSiteKey) throw new t("internal-error");
        }
    }, Bj = {
        endpoint: "resetPassword",
        A: Aj,
        Z: "email",
        B: !0
    }, mj = {
        endpoint: "sendVerificationCode",
        O: [
            "phoneNumber",
            "recaptchaToken"
        ],
        Z: "sessionInfo",
        B: !0
    }, gj = {
        endpoint: "setAccountInfo",
        O: [
            "idToken"
        ],
        A: $i,
        V: !0
    }, ch = {
        endpoint: "setAccountInfo",
        O: [
            "idToken"
        ],
        A: function(a) {
            $i(a);
            if (!a.password) throw new t("weak-password");
        },
        G: P,
        V: !0
    }, fj = {
        endpoint: "signupNewUser",
        G: P,
        V: !0,
        B: !0
    }, oj = {
        endpoint: "accounts/mfaEnrollment:start",
        O: [
            "idToken",
            "phoneEnrollmentInfo"
        ],
        A: function(a) {
            if (!a.phoneEnrollmentInfo) throw new t("internal-error");
            if (!a.phoneEnrollmentInfo.phoneNumber) throw new t("missing-phone-number");
            if (!a.phoneEnrollmentInfo.recaptchaToken) throw new t("missing-app-credential");
        },
        G: function(a) {
            if (!a.phoneSessionInfo || !a.phoneSessionInfo.sessionInfo) throw new t("internal-error");
        },
        B: !0,
        Na: !0
    }, qj = {
        endpoint: "accounts/mfaSignIn:start",
        O: [
            "mfaPendingCredential",
            "mfaEnrollmentId",
            "phoneSignInInfo"
        ],
        A: function(a) {
            if (!a.phoneSignInInfo || !a.phoneSignInInfo.recaptchaToken) throw new t("missing-app-credential");
        },
        G: function(a) {
            if (!a.phoneResponseInfo || !a.phoneResponseInfo.sessionInfo) throw new t("internal-error");
        },
        B: !0,
        Na: !0
    }, xj = {
        endpoint: "verifyAssertion",
        A: tj,
        Za: uj,
        G: vj,
        V: !0,
        B: !0
    }, zj = {
        endpoint: "verifyAssertion",
        A: tj,
        Za: uj,
        G: function(a) {
            if (a.errorMessage && "USER_NOT_FOUND" == a.errorMessage) throw new t("user-not-found");
            if (a.errorMessage) throw wj(a.errorMessage);
            P(a);
        },
        V: !0,
        B: !0
    }, yj = {
        endpoint: "verifyAssertion",
        A: function(a) {
            tj(a);
            if (!a.idToken) throw new t("internal-error");
        },
        Za: uj,
        G: vj,
        V: !0
    }, Kj = {
        endpoint: "verifyCustomToken",
        A: function(a) {
            if (!a.token) throw new t("invalid-custom-token");
        },
        G: P,
        V: !0,
        B: !0
    }, ah = {
        endpoint: "verifyPassword",
        A: function(a) {
            Zi(a);
            if (!a.password) throw new t("wrong-password");
        },
        G: P,
        V: !0,
        B: !0
    }, nj = {
        endpoint: "verifyPhoneNumber",
        A: ej,
        G: P,
        B: !0
    }, ih = {
        endpoint: "verifyPhoneNumber",
        A: function(a) {
            if (!a.idToken) throw new t("internal-error");
            ej(a);
        },
        G: function(a) {
            if (a.temporaryProof) throw a.code = "credential-already-in-use", zh(a);
            P(a);
        }
    }, jh = {
        Ib: {
            USER_NOT_FOUND: "user-not-found"
        },
        endpoint: "verifyPhoneNumber",
        A: ej,
        G: P,
        B: !0
    }, Lj = {
        endpoint: "accounts/mfaEnrollment:withdraw",
        O: [
            "idToken",
            "mfaEnrollmentId"
        ],
        G: function(a) {
            if (!!a[Dg] ^ !!a.refreshToken) throw new t("internal-error");
        },
        B: !0,
        Na: !0
    };
    function O(a, b, c) {
        if (!mf(c, b.O)) return F(new t("internal-error"));
        var d = !!b.Na, e = b.Vb || "POST", f;
        return E(c).then(b.A).then(function() {
            b.V && (c.returnSecureToken = !0);
            b.B && a.b && "undefined" === typeof c.tenantId && (c.tenantId = a.b);
            return d ? Yi(a, a.i, b.endpoint, e, c, b.Ib, b.mb || !1) : Yi(a, a.h, b.endpoint, e, c, b.Ib, b.mb || !1);
        }).then(function(g) {
            f = g;
            return b.Za ? b.Za(c, f) : f;
        }).then(b.G).then(function() {
            if (!b.Z) return f;
            if (!(b.Z in f)) throw new t("internal-error");
            return f[b.Z];
        });
    }
    function wj(a) {
        return Xi({
            error: {
                errors: [
                    {
                        message: a
                    }
                ],
                code: 400,
                message: a
            }
        });
    }
    function Xi(a, b) {
        var c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";
        var d = {
            keyInvalid: "invalid-api-key",
            ipRefererBlocked: "app-not-authorized"
        };
        if (c = d[c] ? new t(d[c]) : null) return c;
        c = a.error && a.error.message || "";
        d = {
            INVALID_CUSTOM_TOKEN: "invalid-custom-token",
            CREDENTIAL_MISMATCH: "custom-token-mismatch",
            MISSING_CUSTOM_TOKEN: "internal-error",
            INVALID_IDENTIFIER: "invalid-email",
            MISSING_CONTINUE_URI: "internal-error",
            INVALID_EMAIL: "invalid-email",
            INVALID_PASSWORD: "wrong-password",
            USER_DISABLED: "user-disabled",
            MISSING_PASSWORD: "internal-error",
            EMAIL_EXISTS: "email-already-in-use",
            PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
            INVALID_IDP_RESPONSE: "invalid-credential",
            INVALID_PENDING_TOKEN: "invalid-credential",
            FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
            MISSING_OR_INVALID_NONCE: "missing-or-invalid-nonce",
            INVALID_MESSAGE_PAYLOAD: "invalid-message-payload",
            INVALID_RECIPIENT_EMAIL: "invalid-recipient-email",
            INVALID_SENDER: "invalid-sender",
            EMAIL_NOT_FOUND: "user-not-found",
            RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
            EXPIRED_OOB_CODE: "expired-action-code",
            INVALID_OOB_CODE: "invalid-action-code",
            MISSING_OOB_CODE: "internal-error",
            INVALID_PROVIDER_ID: "invalid-provider-id",
            CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
            INVALID_ID_TOKEN: "invalid-user-token",
            TOKEN_EXPIRED: "user-token-expired",
            USER_NOT_FOUND: "user-token-expired",
            CORS_UNSUPPORTED: "cors-unsupported",
            DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated",
            INVALID_APP_ID: "invalid-app-id",
            TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
            WEAK_PASSWORD: "weak-password",
            OPERATION_NOT_ALLOWED: "operation-not-allowed",
            USER_CANCELLED: "user-cancelled",
            CAPTCHA_CHECK_FAILED: "captcha-check-failed",
            INVALID_APP_CREDENTIAL: "invalid-app-credential",
            INVALID_CODE: "invalid-verification-code",
            INVALID_PHONE_NUMBER: "invalid-phone-number",
            INVALID_SESSION_INFO: "invalid-verification-id",
            INVALID_TEMPORARY_PROOF: "invalid-credential",
            MISSING_APP_CREDENTIAL: "missing-app-credential",
            MISSING_CODE: "missing-verification-code",
            MISSING_PHONE_NUMBER: "missing-phone-number",
            MISSING_SESSION_INFO: "missing-verification-id",
            QUOTA_EXCEEDED: "quota-exceeded",
            SESSION_EXPIRED: "code-expired",
            REJECTED_CREDENTIAL: "rejected-credential",
            INVALID_CONTINUE_URI: "invalid-continue-uri",
            MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
            MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id",
            UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
            INVALID_DYNAMIC_LINK_DOMAIN: "invalid-dynamic-link-domain",
            INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
            INVALID_CERT_HASH: "invalid-cert-hash",
            UNSUPPORTED_TENANT_OPERATION: "unsupported-tenant-operation",
            INVALID_TENANT_ID: "invalid-tenant-id",
            TENANT_ID_MISMATCH: "tenant-id-mismatch",
            ADMIN_ONLY_OPERATION: "admin-restricted-operation",
            INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
            MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
            MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
            MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
            EMAIL_CHANGE_NEEDS_VERIFICATION: "email-change-needs-verification",
            SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
            SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
            UNSUPPORTED_FIRST_FACTOR: "unsupported-first-factor",
            UNVERIFIED_EMAIL: "unverified-email"
        };
        z(d, b || {});
        b = (b = c.match(/^[^\s]+\s*:\s*([\s\S]*)$/)) && 1 < b.length ? b[1] : void 0;
        for(var e in d)if (0 === c.indexOf(e)) return new t(d[e], b);
        !b && a && (b = Ue(a));
        return new t("internal-error", b);
    }
    function Mj(a) {
        this.b = a;
        this.a = null;
        this.sb = Nj(this);
    }
    function Nj(a) {
        return Oj().then(function() {
            return new D(function(b, c) {
                L("gapi.iframes.getContext")().open({
                    where: document.body,
                    url: a.b,
                    messageHandlersFilter: L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),
                    attributes: {
                        style: {
                            position: "absolute",
                            top: "-100px",
                            width: "1px",
                            height: "1px"
                        }
                    },
                    dontclear: !0
                }, function(d) {
                    function e() {
                        clearTimeout(f);
                        b();
                    }
                    a.a = d;
                    a.a.restyle({
                        setHideOnLeave: !1
                    });
                    var f = setTimeout(function() {
                        c(Error("Network Error"));
                    }, Pj.get());
                    d.ping(e).then(e, function() {
                        c(Error("Network Error"));
                    });
                });
            });
        });
    }
    function Qj(a, b) {
        return a.sb.then(function() {
            return new D(function(c) {
                a.a.send(b.type, b, c, L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
            });
        });
    }
    function Rj(a, b) {
        a.sb.then(function() {
            a.a.register("authEvent", b, L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
        });
    }
    var Sj = new qb(rb, "https://apis.google.com/js/api.js?onload=%{onload}"), Tj = new Ze(3E4, 6E4), Pj = new Ze(5E3, 15E3), Uj = null;
    function Oj() {
        return Uj ? Uj : Uj = new D(function(a, b) {
            function c() {
                Ye();
                L("gapi.load")("gapi.iframes", {
                    callback: a,
                    ontimeout: function() {
                        Ye();
                        b(Error("Network Error"));
                    },
                    timeout: Tj.get()
                });
            }
            if (L("gapi.iframes.Iframe")) a();
            else if (L("gapi.load")) c();
            else {
                var d = "__iframefcb" + Math.floor(1E6 * Math.random()).toString();
                l[d] = function() {
                    L("gapi.load") ? c() : b(Error("Network Error"));
                };
                d = zb(Sj, {
                    onload: d
                });
                E(Bi(d)).o(function() {
                    b(Error("Network Error"));
                });
            }
        }).o(function(a) {
            Uj = null;
            throw a;
        });
    }
    function Vj(a, b, c, d) {
        this.l = a;
        this.h = b;
        this.i = c;
        this.g = d;
        this.f = null;
        this.g ? (a = J(this.g.url), a = ce(a.c, a.a, a.g, "/emulator/auth/iframe")) : a = ce("https", this.l, null, "/__/auth/iframe");
        this.a = a;
        I(this.a, "apiKey", this.h);
        I(this.a, "appName", this.i);
        this.b = null;
        this.c = [];
    }
    Vj.prototype.toString = function() {
        this.f ? I(this.a, "v", this.f) : ie(this.a.b, "v");
        this.b ? I(this.a, "eid", this.b) : ie(this.a.b, "eid");
        this.c.length ? I(this.a, "fw", this.c.join(",")) : ie(this.a.b, "fw");
        return this.a.toString();
    };
    function Wj(a, b, c, d, e, f) {
        this.u = a;
        this.s = b;
        this.c = c;
        this.m = d;
        this.v = f;
        this.i = this.g = this.l = null;
        this.a = e;
        this.h = this.f = null;
    }
    Wj.prototype.zb = function(a) {
        this.h = a;
        return this;
    };
    Wj.prototype.toString = function() {
        if (this.v) {
            var a = J(this.v.url);
            a = ce(a.c, a.a, a.g, "/emulator/auth/handler");
        } else a = ce("https", this.u, null, "/__/auth/handler");
        I(a, "apiKey", this.s);
        I(a, "appName", this.c);
        I(a, "authType", this.m);
        if (this.a.isOAuthProvider) {
            var b = this.a;
            try {
                var c = (0, $8eXKx.default).app(this.c).auth().la();
            } catch (h) {
                c = null;
            }
            b.pb = c;
            I(a, "providerId", this.a.providerId);
            c = this.a;
            b = Ve(c.Jb);
            for(var d in b)b[d] = b[d].toString();
            d = c.Qc;
            b = nb(b);
            for(var e = 0; e < d.length; e++){
                var f = d[e];
                f in b && delete b[f];
            }
            c.qb && c.pb && !b[c.qb] && (b[c.qb] = c.pb);
            mb(b) || I(a, "customParameters", Ue(b));
        }
        "function" === typeof this.a.Rb && (c = this.a.Rb(), c.length && I(a, "scopes", c.join(",")));
        this.l ? I(a, "redirectUrl", this.l) : ie(a.b, "redirectUrl");
        this.g ? I(a, "eventId", this.g) : ie(a.b, "eventId");
        this.i ? I(a, "v", this.i) : ie(a.b, "v");
        if (this.b) for(var g in this.b)this.b.hasOwnProperty(g) && !be(a, g) && I(a, g, this.b[g]);
        this.h ? I(a, "tid", this.h) : ie(a.b, "tid");
        this.f ? I(a, "eid", this.f) : ie(a.b, "eid");
        g = Xj(this.c);
        g.length && I(a, "fw", g.join(","));
        return a.toString();
    };
    function Xj(a) {
        try {
            return (0, $8eXKx.default).app(a).auth().Ga();
        } catch (b) {
            return [];
        }
    }
    function Yj(a, b, c, d, e, f) {
        this.s = a;
        this.g = b;
        this.b = c;
        this.f = f;
        this.c = d || null;
        this.i = e || null;
        this.l = this.u = this.C = null;
        this.h = [];
        this.m = this.a = null;
    }
    function Zj(a) {
        var b = re();
        return cj(a).then(function(c) {
            a: {
                var d = J(b), e = d.c;
                d = d.a;
                for(var f = 0; f < c.length; f++){
                    var g = c[f];
                    var h = d;
                    var m = e;
                    0 == g.indexOf("chrome-extension://") ? h = J(g).a == h && "chrome-extension" == m : "http" != m && "https" != m ? h = !1 : Ce.test(g) ? h = h == g : (g = g.split(".").join("\\."), h = new RegExp("^(.+\\." + g + "|" + g + ")$", "i").test(h));
                    if (h) {
                        c = !0;
                        break a;
                    }
                }
                c = !1;
            }
            if (!c) throw new xh(re());
        });
    }
    function ak(a) {
        if (a.m) return a.m;
        a.m = Ee().then(function() {
            if (!a.u) {
                var b = a.c, c = a.i, d = Xj(a.b), e = new Vj(a.s, a.g, a.b, a.f);
                e.f = b;
                e.b = c;
                e.c = Za(d || []);
                a.u = e.toString();
            }
            a.v = new Mj(a.u);
            bk(a);
        });
        return a.m;
    }
    k = Yj.prototype;
    k.Pb = function(a, b, c) {
        var d = new t("popup-closed-by-user"), e = new t("web-storage-unsupported"), f = this, g = !1;
        return this.ma().then(function() {
            ck(f).then(function(h) {
                h || (a && ye(a), b(e), g = !0);
            });
        }).o(function() {}).then(function() {
            if (!g) return Be(a);
        }).then(function() {
            if (!g) return Fd(c).then(function() {
                b(d);
            });
        });
    };
    k.Yb = function() {
        var a = K();
        return !Te(a) && !Xe(a);
    };
    k.Ub = function() {
        return !1;
    };
    k.Nb = function(a, b, c, d, e, f, g, h) {
        if (!a) return F(new t("popup-blocked"));
        if (g && !Te()) return this.ma().o(function(p) {
            ye(a);
            e(p);
        }), d(), E();
        this.a || (this.a = Zj(dk(this)));
        var m = this;
        return this.a.then(function() {
            var p = m.ma().o(function(v) {
                ye(a);
                e(v);
                throw v;
            });
            d();
            return p;
        }).then(function() {
            rh(c);
            if (!g) {
                var p = ek(m.s, m.g, m.b, b, c, null, f, m.c, void 0, m.i, h, m.f);
                se(p, a);
            }
        }).o(function(p) {
            "auth/network-request-failed" == p.code && (m.a = null);
            throw p;
        });
    };
    function dk(a) {
        a.l || (a.C = a.c ? Oe(a.c, Xj(a.b)) : null, a.l = new Ii(a.g, Ca(a.i), a.C), a.f && Pi(a.l, a.f));
        return a.l;
    }
    k.Ob = function(a, b, c, d) {
        this.a || (this.a = Zj(dk(this)));
        var e = this;
        return this.a.then(function() {
            rh(b);
            var f = ek(e.s, e.g, e.b, a, b, re(), c, e.c, void 0, e.i, d, e.f);
            se(f);
        }).o(function(f) {
            "auth/network-request-failed" == f.code && (e.a = null);
            throw f;
        });
    };
    k.ma = function() {
        var a = this;
        return ak(this).then(function() {
            return a.v.sb;
        }).o(function() {
            a.a = null;
            throw new t("network-request-failed");
        });
    };
    k.ac = function() {
        return !0;
    };
    function ek(a, b, c, d, e, f, g, h, m, p, v, B) {
        a = new Wj(a, b, c, d, e, B);
        a.l = f;
        a.g = g;
        a.i = h;
        a.b = nb(m || null);
        a.f = p;
        return a.zb(v).toString();
    }
    function bk(a) {
        if (!a.v) throw Error("IfcHandler must be initialized!");
        Rj(a.v, function(b) {
            var c = {};
            if (b && b.authEvent) {
                var d = !1;
                b = th(b.authEvent);
                for(c = 0; c < a.h.length; c++)d = a.h[c](b) || d;
                c = {};
                c.status = d ? "ACK" : "ERROR";
                return E(c);
            }
            c.status = "ERROR";
            return E(c);
        });
    }
    function ck(a) {
        var b = {
            type: "webStorageSupport"
        };
        return ak(a).then(function() {
            return Qj(a.v, b);
        }).then(function(c) {
            if (c && c.length && "undefined" !== typeof c[0].webStorageSupport) return c[0].webStorageSupport;
            throw Error();
        });
    }
    k.Ea = function(a) {
        this.h.push(a);
    };
    k.Ta = function(a) {
        Xa(this.h, function(b) {
            return b == a;
        });
    };
    function fk(a) {
        this.a = a || (0, $8eXKx.default).INTERNAL.reactNative && (0, $8eXKx.default).INTERNAL.reactNative.AsyncStorage;
        if (!this.a) throw new t("internal-error", "The React Native compatibility library was not found.");
        this.type = "asyncStorage";
    }
    k = fk.prototype;
    k.get = function(a) {
        return E(this.a.getItem(a)).then(function(b) {
            return b && We(b);
        });
    };
    k.set = function(a, b) {
        return E(this.a.setItem(a, Ue(b)));
    };
    k.U = function(a) {
        return E(this.a.removeItem(a));
    };
    k.ca = function() {};
    k.ia = function() {};
    function gk(a) {
        this.b = a;
        this.a = {};
        this.f = q(this.c, this);
    }
    var hk = [];
    function ik() {
        var a = Je() ? self : null;
        w(hk, function(c) {
            c.b == a && (b = c);
        });
        if (!b) {
            var b = new gk(a);
            hk.push(b);
        }
        return b;
    }
    gk.prototype.c = function(a) {
        var b = a.data.eventType, c = a.data.eventId, d = this.a[b];
        if (d && 0 < d.length) {
            a.ports[0].postMessage({
                status: "ack",
                eventId: c,
                eventType: b,
                response: null
            });
            var e = [];
            w(d, function(f) {
                e.push(E().then(function() {
                    return f(a.origin, a.data.data);
                }));
            });
            Jc(e).then(function(f) {
                var g = [];
                w(f, function(h) {
                    g.push({
                        fulfilled: h.Qb,
                        value: h.value,
                        reason: h.reason ? h.reason.message : void 0
                    });
                });
                w(g, function(h) {
                    for(var m in h)"undefined" === typeof h[m] && delete h[m];
                });
                a.ports[0].postMessage({
                    status: "done",
                    eventId: c,
                    eventType: b,
                    response: g
                });
            });
        }
    };
    function jk(a, b, c) {
        mb(a.a) && a.b.addEventListener("message", a.f);
        "undefined" === typeof a.a[b] && (a.a[b] = []);
        a.a[b].push(c);
    }
    function kk(a) {
        this.a = a;
    }
    kk.prototype.postMessage = function(a, b) {
        this.a.postMessage(a, b);
    };
    function lk(a) {
        this.c = a;
        this.b = !1;
        this.a = [];
    }
    function mk(a, b, c, d) {
        var e, f = c || {}, g, h, m, p = null;
        if (a.b) return F(Error("connection_unavailable"));
        var v = d ? 800 : 50, B = "undefined" !== typeof MessageChannel ? new MessageChannel : null;
        return new D(function(A, Q) {
            B ? (e = Math.floor(Math.random() * Math.pow(10, 20)).toString(), B.port1.start(), h = setTimeout(function() {
                Q(Error("unsupported_event"));
            }, v), g = function(ya) {
                ya.data.eventId === e && ("ack" === ya.data.status ? (clearTimeout(h), m = setTimeout(function() {
                    Q(Error("timeout"));
                }, 3E3)) : "done" === ya.data.status ? (clearTimeout(m), "undefined" !== typeof ya.data.response ? A(ya.data.response) : Q(Error("unknown_error"))) : (clearTimeout(h), clearTimeout(m), Q(Error("invalid_response"))));
            }, p = {
                messageChannel: B,
                onMessage: g
            }, a.a.push(p), B.port1.addEventListener("message", g), a.c.postMessage({
                eventType: b,
                eventId: e,
                data: f
            }, [
                B.port2
            ])) : Q(Error("connection_unavailable"));
        }).then(function(A) {
            nk(a, p);
            return A;
        }).o(function(A) {
            nk(a, p);
            throw A;
        });
    }
    function nk(a, b) {
        if (b) {
            var c = b.messageChannel, d = b.onMessage;
            c && (c.port1.removeEventListener("message", d), c.port1.close());
            Xa(a.a, function(e) {
                return e == b;
            });
        }
    }
    lk.prototype.close = function() {
        for(; 0 < this.a.length;)nk(this, this.a[0]);
        this.b = !0;
    };
    function ok() {
        if (!pk()) throw new t("web-storage-unsupported");
        this.c = {};
        this.a = [];
        this.b = 0;
        this.m = l.indexedDB;
        this.type = "indexedDB";
        this.g = this.v = this.f = this.l = null;
        this.s = !1;
        this.h = null;
        var a = this;
        Je() && self ? (this.v = ik(), jk(this.v, "keyChanged", function(b, c) {
            return qk(a).then(function(d) {
                0 < d.length && w(a.a, function(e) {
                    e(d);
                });
                return {
                    keyProcessed: Va(d, c.key)
                };
            });
        }), jk(this.v, "ping", function() {
            return E([
                "keyChanged"
            ]);
        })) : ef().then(function(b) {
            if (a.h = b) a.g = new lk(new kk(b)), mk(a.g, "ping", null, !0).then(function(c) {
                c[0].fulfilled && Va(c[0].value, "keyChanged") && (a.s = !0);
            }).o(function() {});
        });
    }
    var rk;
    function sk(a) {
        return new D(function(b, c) {
            var d = a.m.deleteDatabase("firebaseLocalStorageDb");
            d.onsuccess = function() {
                b();
            };
            d.onerror = function(e) {
                c(Error(e.target.error));
            };
        });
    }
    function tk(a) {
        return new D(function(b, c) {
            var d = a.m.open("firebaseLocalStorageDb", 1);
            d.onerror = function(e) {
                try {
                    e.preventDefault();
                } catch (f) {}
                c(Error(e.target.error));
            };
            d.onupgradeneeded = function(e) {
                e = e.target.result;
                try {
                    e.createObjectStore("firebaseLocalStorage", {
                        keyPath: "fbase_key"
                    });
                } catch (f) {
                    c(f);
                }
            };
            d.onsuccess = function(e) {
                e = e.target.result;
                e.objectStoreNames.contains("firebaseLocalStorage") ? b(e) : sk(a).then(function() {
                    return tk(a);
                }).then(function(f) {
                    b(f);
                }).o(function(f) {
                    c(f);
                });
            };
        });
    }
    function uk(a) {
        a.i || (a.i = tk(a));
        return a.i;
    }
    function vk(a, b) {
        function c(e, f) {
            uk(a).then(b).then(e).o(function(g) {
                if (3 < ++d) f(g);
                else return uk(a).then(function(h) {
                    h.close();
                    a.i = void 0;
                    return c(e, f);
                }).o(function(h) {
                    f(h);
                });
            });
        }
        var d = 0;
        return new D(c);
    }
    function pk() {
        try {
            return !!l.indexedDB;
        } catch (a) {
            return !1;
        }
    }
    function wk(a) {
        return a.objectStore("firebaseLocalStorage");
    }
    function xk(a, b) {
        return a.transaction([
            "firebaseLocalStorage"
        ], b ? "readwrite" : "readonly");
    }
    function yk(a) {
        return new D(function(b, c) {
            a.onsuccess = function(d) {
                d && d.target ? b(d.target.result) : b();
            };
            a.onerror = function(d) {
                c(d.target.error);
            };
        });
    }
    k = ok.prototype;
    k.set = function(a, b) {
        var c = this, d = !1;
        return vk(this, function(e) {
            e = wk(xk(e, !0));
            return yk(e.get(a));
        }).then(function(e) {
            return vk(c, function(f) {
                f = wk(xk(f, !0));
                if (e) return e.value = b, yk(f.put(e));
                c.b++;
                d = !0;
                var g = {};
                g.fbase_key = a;
                g.value = b;
                return yk(f.add(g));
            });
        }).then(function() {
            c.c[a] = b;
            return zk(c, a);
        }).oa(function() {
            d && c.b--;
        });
    };
    function zk(a, b) {
        return a.g && a.h && df() === a.h ? mk(a.g, "keyChanged", {
            key: b
        }, a.s).then(function() {}).o(function() {}) : E();
    }
    k.get = function(a) {
        return vk(this, function(b) {
            return yk(wk(xk(b, !1)).get(a));
        }).then(function(b) {
            return b && b.value;
        });
    };
    k.U = function(a) {
        var b = this, c = !1;
        return vk(this, function(d) {
            c = !0;
            b.b++;
            return yk(wk(xk(d, !0))["delete"](a));
        }).then(function() {
            delete b.c[a];
            return zk(b, a);
        }).oa(function() {
            c && b.b--;
        });
    };
    function qk(a) {
        return uk(a).then(function(b) {
            var c = wk(xk(b, !1));
            return c.getAll ? yk(c.getAll()) : new D(function(d, e) {
                var f = [], g = c.openCursor();
                g.onsuccess = function(h) {
                    (h = h.target.result) ? (f.push(h.value), h["continue"]()) : d(f);
                };
                g.onerror = function(h) {
                    e(h.target.error);
                };
            });
        }).then(function(b) {
            var c = {}, d = [];
            if (0 == a.b) {
                for(d = 0; d < b.length; d++)c[b[d].fbase_key] = b[d].value;
                d = te(a.c, c);
                a.c = c;
            }
            return d;
        });
    }
    k.ca = function(a) {
        0 == this.a.length && Ak(this);
        this.a.push(a);
    };
    k.ia = function(a) {
        Xa(this.a, function(b) {
            return b == a;
        });
        0 == this.a.length && Bk(this);
    };
    function Ak(a) {
        function b() {
            a.f = setTimeout(function() {
                a.l = qk(a).then(function(c) {
                    0 < c.length && w(a.a, function(d) {
                        d(c);
                    });
                }).then(function() {
                    b();
                }).o(function(c) {
                    "STOP_EVENT" != c.message && b();
                });
            }, 800);
        }
        Bk(a);
        b();
    }
    function Bk(a) {
        a.l && a.l.cancel("STOP_EVENT");
        a.f && (clearTimeout(a.f), a.f = null);
    }
    function Ck(a) {
        var b = this, c = null;
        this.a = [];
        this.type = "indexedDB";
        this.c = a;
        this.b = E().then(function() {
            if (pk()) {
                var d = Qe(), e = "__sak" + d;
                rk || (rk = new ok);
                c = rk;
                return c.set(e, d).then(function() {
                    return c.get(e);
                }).then(function(f) {
                    if (f !== d) throw Error("indexedDB not supported!");
                    return c.U(e);
                }).then(function() {
                    return c;
                }).o(function() {
                    return b.c;
                });
            }
            return b.c;
        }).then(function(d) {
            b.type = d.type;
            d.ca(function(e) {
                w(b.a, function(f) {
                    f(e);
                });
            });
            return d;
        });
    }
    k = Ck.prototype;
    k.get = function(a) {
        return this.b.then(function(b) {
            return b.get(a);
        });
    };
    k.set = function(a, b) {
        return this.b.then(function(c) {
            return c.set(a, b);
        });
    };
    k.U = function(a) {
        return this.b.then(function(b) {
            return b.U(a);
        });
    };
    k.ca = function(a) {
        this.a.push(a);
    };
    k.ia = function(a) {
        Xa(this.a, function(b) {
            return b == a;
        });
    };
    function Dk() {
        this.a = {};
        this.type = "inMemory";
    }
    k = Dk.prototype;
    k.get = function(a) {
        return E(this.a[a]);
    };
    k.set = function(a, b) {
        this.a[a] = b;
        return E();
    };
    k.U = function(a) {
        delete this.a[a];
        return E();
    };
    k.ca = function() {};
    k.ia = function() {};
    function Ek() {
        if (!Fk()) {
            if ("Node" == Ke()) throw new t("internal-error", "The LocalStorage compatibility library was not found.");
            throw new t("web-storage-unsupported");
        }
        this.a = Gk() || (0, $8eXKx.default).INTERNAL.node.localStorage;
        this.type = "localStorage";
    }
    function Gk() {
        try {
            var a = l.localStorage, b = Qe();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function Fk() {
        var a = "Node" == Ke();
        a = Gk() || a && (0, $8eXKx.default).INTERNAL.node && (0, $8eXKx.default).INTERNAL.node.localStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = Ek.prototype;
    k.get = function(a) {
        var b = this;
        return E().then(function() {
            var c = b.a.getItem(a);
            return We(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return E().then(function() {
            var d = Ue(b);
            null === d ? c.U(a) : c.a.setItem(a, d);
        });
    };
    k.U = function(a) {
        var b = this;
        return E().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ca = function(a) {
        l.window && nd(l.window, "storage", a);
    };
    k.ia = function(a) {
        l.window && xd(l.window, "storage", a);
    };
    function Hk() {
        this.type = "nullStorage";
    }
    k = Hk.prototype;
    k.get = function() {
        return E(null);
    };
    k.set = function() {
        return E();
    };
    k.U = function() {
        return E();
    };
    k.ca = function() {};
    k.ia = function() {};
    function Ik() {
        if (!Jk()) {
            if ("Node" == Ke()) throw new t("internal-error", "The SessionStorage compatibility library was not found.");
            throw new t("web-storage-unsupported");
        }
        this.a = Kk() || (0, $8eXKx.default).INTERNAL.node.sessionStorage;
        this.type = "sessionStorage";
    }
    function Kk() {
        try {
            var a = l.sessionStorage, b = Qe();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function Jk() {
        var a = "Node" == Ke();
        a = Kk() || a && (0, $8eXKx.default).INTERNAL.node && (0, $8eXKx.default).INTERNAL.node.sessionStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = Ik.prototype;
    k.get = function(a) {
        var b = this;
        return E().then(function() {
            var c = b.a.getItem(a);
            return We(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return E().then(function() {
            var d = Ue(b);
            null === d ? c.U(a) : c.a.setItem(a, d);
        });
    };
    k.U = function(a) {
        var b = this;
        return E().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ca = function() {};
    k.ia = function() {};
    function Lk() {
        var a = {};
        a.Browser = Mk;
        a.Node = Nk;
        a.ReactNative = Ok;
        a.Worker = Pk;
        this.a = a[Ke()];
    }
    var Qk, Mk = {
        F: Ek,
        cb: Ik
    }, Nk = {
        F: Ek,
        cb: Ik
    }, Ok = {
        F: fk,
        cb: Hk
    }, Pk = {
        F: Ek,
        cb: Hk
    };
    var Rk = {
        rd: "local",
        NONE: "none",
        td: "session"
    };
    function Sk(a) {
        var b = new t("invalid-persistence-type"), c = new t("unsupported-persistence-type");
        a: {
            for(d in Rk)if (Rk[d] == a) {
                var d = !0;
                break a;
            }
            d = !1;
        }
        if (!d || "string" !== typeof a) throw b;
        switch(Ke()){
            case "ReactNative":
                if ("session" === a) throw c;
                break;
            case "Node":
                if ("none" !== a) throw c;
                break;
            case "Worker":
                if ("session" === a || !pk() && "none" !== a) throw c;
                break;
            default:
                if (!Pe() && "none" !== a) throw c;
        }
    }
    function Tk() {
        var a = !Xe(K()) && Ie() ? !0 : !1, b = Te(), c = Pe();
        this.m = a;
        this.h = b;
        this.l = c;
        this.a = {};
        Qk || (Qk = new Lk);
        a = Qk;
        try {
            this.g = !qe() && cf() || !l.indexedDB ? new a.a.F : new Ck(Je() ? new Dk : new a.a.F);
        } catch (d) {
            this.g = new Dk, this.h = !0;
        }
        try {
            this.i = new a.a.cb;
        } catch (d) {
            this.i = new Dk;
        }
        this.v = new Dk;
        this.f = q(this.Zb, this);
        this.b = {};
    }
    var Uk;
    function Vk() {
        Uk || (Uk = new Tk);
        return Uk;
    }
    function Wk(a, b) {
        switch(b){
            case "session":
                return a.i;
            case "none":
                return a.v;
            default:
                return a.g;
        }
    }
    function Xk(a, b) {
        return "firebase:" + a.name + (b ? ":" + b : "");
    }
    function Yk(a, b, c) {
        var d = Xk(b, c), e = Wk(a, b.F);
        return a.get(b, c).then(function(f) {
            var g = null;
            try {
                g = We(l.localStorage.getItem(d));
            } catch (h) {}
            if (g && !f) return l.localStorage.removeItem(d), a.set(b, g, c);
            g && f && "localStorage" != e.type && l.localStorage.removeItem(d);
        });
    }
    k = Tk.prototype;
    k.get = function(a, b) {
        return Wk(this, a.F).get(Xk(a, b));
    };
    function Zk(a, b, c) {
        c = Xk(b, c);
        "local" == b.F && (a.b[c] = null);
        return Wk(a, b.F).U(c);
    }
    k.set = function(a, b, c) {
        var d = Xk(a, c), e = this, f = Wk(this, a.F);
        return f.set(d, b).then(function() {
            return f.get(d);
        }).then(function(g) {
            "local" == a.F && (e.b[d] = g);
        });
    };
    k.addListener = function(a, b, c) {
        a = Xk(a, b);
        this.l && (this.b[a] = l.localStorage.getItem(a));
        mb(this.a) && (Wk(this, "local").ca(this.f), this.h || (qe() || !cf()) && l.indexedDB || !this.l || $k(this));
        this.a[a] || (this.a[a] = []);
        this.a[a].push(c);
    };
    k.removeListener = function(a, b, c) {
        a = Xk(a, b);
        this.a[a] && (Xa(this.a[a], function(d) {
            return d == c;
        }), 0 == this.a[a].length && delete this.a[a]);
        mb(this.a) && (Wk(this, "local").ia(this.f), al(this));
    };
    function $k(a) {
        al(a);
        a.c = setInterval(function() {
            for(var b in a.a){
                var c = l.localStorage.getItem(b), d = a.b[b];
                c != d && (a.b[b] = c, c = new bd({
                    type: "storage",
                    key: b,
                    target: window,
                    oldValue: d,
                    newValue: c,
                    a: !0
                }), a.Zb(c));
            }
        }, 1E3);
    }
    function al(a) {
        a.c && (clearInterval(a.c), a.c = null);
    }
    k.Zb = function(a) {
        if (a && a.g) {
            var b = a.a.key;
            if (null == b) for(var c in this.a){
                var d = this.b[c];
                "undefined" === typeof d && (d = null);
                var e = l.localStorage.getItem(c);
                e !== d && (this.b[c] = e, this.nb(c));
            }
            else if (0 == b.indexOf("firebase:") && this.a[b]) {
                "undefined" !== typeof a.a.a ? Wk(this, "local").ia(this.f) : al(this);
                if (this.m) {
                    if (c = l.localStorage.getItem(b), d = a.a.newValue, d !== c) null !== d ? l.localStorage.setItem(b, d) : l.localStorage.removeItem(b);
                    else if (this.b[b] === d && "undefined" === typeof a.a.a) return;
                }
                var f = this;
                c = function() {
                    if ("undefined" !== typeof a.a.a || f.b[b] !== l.localStorage.getItem(b)) f.b[b] = l.localStorage.getItem(b), f.nb(b);
                };
                Wb && ic && 10 == ic && l.localStorage.getItem(b) !== a.a.newValue && a.a.newValue !== a.a.oldValue ? setTimeout(c, 10) : c();
            }
        } else w(a, q(this.nb, this));
    };
    k.nb = function(a) {
        this.a[a] && w(this.a[a], function(b) {
            b();
        });
    };
    function bl(a) {
        this.a = a;
        this.b = Vk();
    }
    var cl = {
        name: "authEvent",
        F: "local"
    };
    function dl(a) {
        return a.b.get(cl, a.a).then(function(b) {
            return th(b);
        });
    }
    function el() {
        this.a = Vk();
    }
    function fl() {
        this.b = -1;
    }
    function gl(a, b) {
        this.b = hl;
        this.f = l.Uint8Array ? new Uint8Array(this.b) : Array(this.b);
        this.g = this.c = 0;
        this.a = [];
        this.i = a;
        this.h = b;
        this.l = l.Int32Array ? new Int32Array(64) : Array(64);
        void 0 === il && (l.Int32Array ? il = new Int32Array(jl) : il = jl);
        this.reset();
    }
    var il;
    r(gl, fl);
    for(var hl = 64, kl = hl - 1, ll = [], ml = 0; ml < kl; ml++)ll[ml] = 0;
    var nl = Ya(128, ll);
    gl.prototype.reset = function() {
        this.g = this.c = 0;
        this.a = l.Int32Array ? new Int32Array(this.h) : Za(this.h);
    };
    function ol(a) {
        for(var b = a.f, c = a.l, d = 0, e = 0; e < b.length;)c[d++] = b[e] << 24 | b[e + 1] << 16 | b[e + 2] << 8 | b[e + 3], e = 4 * d;
        for(b = 16; 64 > b; b++){
            e = c[b - 15] | 0;
            d = c[b - 2] | 0;
            var f = (c[b - 16] | 0) + ((e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3) | 0, g = (c[b - 7] | 0) + ((d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10) | 0;
            c[b] = f + g | 0;
        }
        d = a.a[0] | 0;
        e = a.a[1] | 0;
        var h = a.a[2] | 0, m = a.a[3] | 0, p = a.a[4] | 0, v = a.a[5] | 0, B = a.a[6] | 0;
        f = a.a[7] | 0;
        for(b = 0; 64 > b; b++){
            var A = ((d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10)) + (d & e ^ d & h ^ e & h) | 0;
            g = p & v ^ ~p & B;
            f = f + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) | 0;
            g = g + (il[b] | 0) | 0;
            g = f + (g + (c[b] | 0) | 0) | 0;
            f = B;
            B = v;
            v = p;
            p = m + g | 0;
            m = h;
            h = e;
            e = d;
            d = g + A | 0;
        }
        a.a[0] = a.a[0] + d | 0;
        a.a[1] = a.a[1] + e | 0;
        a.a[2] = a.a[2] + h | 0;
        a.a[3] = a.a[3] + m | 0;
        a.a[4] = a.a[4] + p | 0;
        a.a[5] = a.a[5] + v | 0;
        a.a[6] = a.a[6] + B | 0;
        a.a[7] = a.a[7] + f | 0;
    }
    function pl(a, b, c) {
        void 0 === c && (c = b.length);
        var d = 0, e = a.c;
        if ("string" === typeof b) for(; d < c;)a.f[e++] = b.charCodeAt(d++), e == a.b && (ol(a), e = 0);
        else if (na(b)) for(; d < c;){
            var f = b[d++];
            if (!("number" == typeof f && 0 <= f && 255 >= f && f == (f | 0))) throw Error("message must be a byte array");
            a.f[e++] = f;
            e == a.b && (ol(a), e = 0);
        }
        else throw Error("message must be string or array");
        a.c = e;
        a.g += c;
    }
    var jl = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
    ];
    function ql() {
        gl.call(this, 8, rl);
    }
    r(ql, gl);
    var rl = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ];
    function sl(a, b, c, d, e, f) {
        this.v = a;
        this.i = b;
        this.l = c;
        this.m = d || null;
        this.u = e || null;
        this.s = f;
        this.h = b + ":" + c;
        this.C = new el;
        this.g = new bl(this.h);
        this.f = null;
        this.b = [];
        this.a = this.c = null;
    }
    function tl(a) {
        return new t("invalid-cordova-configuration", a);
    }
    k = sl.prototype;
    k.ma = function() {
        return this.Ia ? this.Ia : this.Ia = Fe().then(function() {
            if ("function" !== typeof L("universalLinks.subscribe", l)) throw tl("cordova-universal-links-plugin-fix is not installed");
            if ("undefined" === typeof L("BuildInfo.packageName", l)) throw tl("cordova-plugin-buildinfo is not installed");
            if ("function" !== typeof L("cordova.plugins.browsertab.openUrl", l)) throw tl("cordova-plugin-browsertab is not installed");
            if ("function" !== typeof L("cordova.InAppBrowser.open", l)) throw tl("cordova-plugin-inappbrowser is not installed");
        }, function() {
            throw new t("cordova-not-ready");
        });
    };
    function ul() {
        for(var a = 20, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    function vl(a) {
        var b = new ql;
        pl(b, a);
        a = [];
        var c = 8 * b.g;
        56 > b.c ? pl(b, nl, 56 - b.c) : pl(b, nl, b.b - (b.c - 56));
        for(var d = 63; 56 <= d; d--)b.f[d] = c & 255, c /= 256;
        ol(b);
        for(d = c = 0; d < b.i; d++)for(var e = 24; 0 <= e; e -= 8)a[c++] = b.a[d] >> e & 255;
        return cg(a);
    }
    k.Pb = function(a, b) {
        b(new t("operation-not-supported-in-this-environment"));
        return E();
    };
    k.Nb = function() {
        return F(new t("operation-not-supported-in-this-environment"));
    };
    k.ac = function() {
        return !1;
    };
    k.Yb = function() {
        return !0;
    };
    k.Ub = function() {
        return !0;
    };
    k.Ob = function(a, b, c, d) {
        if (this.c) return F(new t("redirect-operation-pending"));
        var e = this, f = l.document, g = null, h = null, m = null, p = null;
        return this.c = E().then(function() {
            rh(b);
            return wl(e);
        }).then(function() {
            return xl(e, a, b, c, d);
        }).then(function() {
            return new D(function(v, B) {
                h = function() {
                    var A = L("cordova.plugins.browsertab.close", l);
                    v();
                    "function" === typeof A && A();
                    e.a && "function" === typeof e.a.close && (e.a.close(), e.a = null);
                    return !1;
                };
                e.Ea(h);
                m = function() {
                    g || (g = Fd(2E3).then(function() {
                        B(new t("redirect-cancelled-by-user"));
                    }));
                };
                p = function() {
                    $e() && m();
                };
                f.addEventListener("resume", m, !1);
                K().toLowerCase().match(/android/) || f.addEventListener("visibilitychange", p, !1);
            }).o(function(v) {
                return yl(e).then(function() {
                    throw v;
                });
            });
        }).oa(function() {
            m && f.removeEventListener("resume", m, !1);
            p && f.removeEventListener("visibilitychange", p, !1);
            g && g.cancel();
            h && e.Ta(h);
            e.c = null;
        });
    };
    function xl(a, b, c, d, e) {
        var f = ul(), g = new sh(b, d, null, f, new t("no-auth-event"), null, e), h = L("BuildInfo.packageName", l);
        if ("string" !== typeof h) throw new t("invalid-cordova-configuration");
        var m = L("BuildInfo.displayName", l), p = {};
        if (K().toLowerCase().match(/iphone|ipad|ipod/)) p.ibi = h;
        else if (K().toLowerCase().match(/android/)) p.apn = h;
        else return F(new t("operation-not-supported-in-this-environment"));
        m && (p.appDisplayName = m);
        f = vl(f);
        p.sessionId = f;
        var v = ek(a.v, a.i, a.l, b, c, null, d, a.m, p, a.u, e, a.s);
        return a.ma().then(function() {
            var B = a.h;
            return a.C.a.set(cl, g.w(), B);
        }).then(function() {
            var B = L("cordova.plugins.browsertab.isAvailable", l);
            if ("function" !== typeof B) throw new t("invalid-cordova-configuration");
            var A = null;
            B(function(Q) {
                if (Q) {
                    A = L("cordova.plugins.browsertab.openUrl", l);
                    if ("function" !== typeof A) throw new t("invalid-cordova-configuration");
                    A(v);
                } else {
                    A = L("cordova.InAppBrowser.open", l);
                    if ("function" !== typeof A) throw new t("invalid-cordova-configuration");
                    Q = K();
                    a.a = A(v, Q.match(/(iPad|iPhone|iPod).*OS 7_\d/i) || Q.match(/(iPad|iPhone|iPod).*OS 8_\d/i) ? "_blank" : "_system", "location=yes");
                }
            });
        });
    }
    function zl(a, b) {
        for(var c = 0; c < a.b.length; c++)try {
            a.b[c](b);
        } catch (d) {}
    }
    function wl(a) {
        a.f || (a.f = a.ma().then(function() {
            return new D(function(b) {
                function c(d) {
                    b(d);
                    a.Ta(c);
                    return !1;
                }
                a.Ea(c);
                Al(a);
            });
        }));
        return a.f;
    }
    function yl(a) {
        var b = null;
        return dl(a.g).then(function(c) {
            b = c;
            c = a.g;
            return Zk(c.b, cl, c.a);
        }).then(function() {
            return b;
        });
    }
    function Al(a) {
        function b(g) {
            d = !0;
            e && e.cancel();
            yl(a).then(function(h) {
                var m = c;
                if (h && g && g.url) {
                    var p = null;
                    m = xg(g.url);
                    -1 != m.indexOf("/__/auth/callback") && (p = J(m), p = We(be(p, "firebaseError") || null), p = (p = "object" === typeof p ? Aa(p) : null) ? new sh(h.c, h.b, null, null, p, null, h.T()) : new sh(h.c, h.b, m, h.f, null, null, h.T()));
                    m = p || c;
                }
                zl(a, m);
            });
        }
        var c = new sh("unknown", null, null, null, new t("no-auth-event")), d = !1, e = Fd(500).then(function() {
            return yl(a).then(function() {
                d || zl(a, c);
            });
        }), f = l.handleOpenURL;
        l.handleOpenURL = function(g) {
            0 == g.toLowerCase().indexOf(L("BuildInfo.packageName", l).toLowerCase() + "://") && b({
                url: g
            });
            if ("function" === typeof f) try {
                f(g);
            } catch (h) {
                console.error(h);
            }
        };
        vh || (vh = new uh);
        wh(b);
    }
    k.Ea = function(a) {
        this.b.push(a);
        wl(this).o(function(b) {
            "auth/invalid-cordova-configuration" === b.code && (b = new sh("unknown", null, null, null, new t("no-auth-event")), a(b));
        });
    };
    k.Ta = function(a) {
        Xa(this.b, function(b) {
            return b == a;
        });
    };
    function Bl(a) {
        this.a = a;
        this.b = Vk();
    }
    var Cl = {
        name: "pendingRedirect",
        F: "session"
    };
    function Dl(a) {
        return a.b.set(Cl, "pending", a.a);
    }
    function El(a) {
        return Zk(a.b, Cl, a.a);
    }
    function Fl(a) {
        return a.b.get(Cl, a.a).then(function(b) {
            return "pending" == b;
        });
    }
    function Gl(a, b, c, d) {
        this.i = {};
        this.u = 0;
        this.D = a;
        this.v = b;
        this.m = c;
        this.J = d;
        this.h = [];
        this.f = !1;
        this.l = q(this.s, this);
        this.b = new Hl;
        this.C = new Il;
        this.g = new Bl(Jl(this.v, this.m));
        this.c = {};
        this.c.unknown = this.b;
        this.c.signInViaRedirect = this.b;
        this.c.linkViaRedirect = this.b;
        this.c.reauthViaRedirect = this.b;
        this.c.signInViaPopup = this.C;
        this.c.linkViaPopup = this.C;
        this.c.reauthViaPopup = this.C;
        this.a = Kl(this.D, this.v, this.m, Da, this.J);
    }
    function Kl(a, b, c, d, e) {
        var f = (0, $8eXKx.default).SDK_VERSION || null;
        return Ge() ? new sl(a, b, c, f, d, e) : new Yj(a, b, c, f, d, e);
    }
    Gl.prototype.reset = function() {
        this.f = !1;
        this.a.Ta(this.l);
        this.a = Kl(this.D, this.v, this.m, null, this.J);
        this.i = {};
    };
    function Ll(a) {
        a.f || (a.f = !0, a.a.Ea(a.l));
        var b = a.a;
        return a.a.ma().o(function(c) {
            a.a == b && a.reset();
            throw c;
        });
    }
    function Ml(a) {
        a.a.Yb() && Ll(a).o(function(b) {
            var c = new sh("unknown", null, null, null, new t("operation-not-supported-in-this-environment"));
            Nl(b) && a.s(c);
        });
        a.a.Ub() || Ol(a.b);
    }
    function Pl(a, b) {
        Va(a.h, b) || a.h.push(b);
        a.f || Fl(a.g).then(function(c) {
            c ? El(a.g).then(function() {
                Ll(a).o(function(d) {
                    var e = new sh("unknown", null, null, null, new t("operation-not-supported-in-this-environment"));
                    Nl(d) && a.s(e);
                });
            }) : Ml(a);
        }).o(function() {
            Ml(a);
        });
    }
    function Ql(a, b) {
        Xa(a.h, function(c) {
            return c == b;
        });
    }
    Gl.prototype.s = function(a) {
        if (!a) throw new t("invalid-auth-event");
        6E5 <= Date.now() - this.u && (this.i = {}, this.u = 0);
        if (a && a.getUid() && this.i.hasOwnProperty(a.getUid())) return !1;
        for(var b = !1, c = 0; c < this.h.length; c++){
            var d = this.h[c];
            if (d.Gb(a.c, a.b)) {
                if (b = this.c[a.c]) b.h(a, d), a && (a.f || a.b) && (this.i[a.getUid()] = !0, this.u = Date.now());
                b = !0;
                break;
            }
        }
        Ol(this.b);
        return b;
    };
    var Rl = new Ze(2E3, 1E4), Sl = new Ze(3E4, 6E4);
    Gl.prototype.ra = function() {
        return this.b.ra();
    };
    function Tl(a, b, c, d, e, f, g) {
        return a.a.Nb(b, c, d, function() {
            a.f || (a.f = !0, a.a.Ea(a.l));
        }, function() {
            a.reset();
        }, e, f, g);
    }
    function Nl(a) {
        return a && "auth/cordova-not-ready" == a.code ? !0 : !1;
    }
    function Ul(a, b, c, d, e) {
        var f;
        return Dl(a.g).then(function() {
            return a.a.Ob(b, c, d, e).o(function(g) {
                if (Nl(g)) throw new t("operation-not-supported-in-this-environment");
                f = g;
                return El(a.g).then(function() {
                    throw f;
                });
            }).then(function() {
                return a.a.ac() ? new D(function() {}) : El(a.g).then(function() {
                    return a.ra();
                }).then(function() {}).o(function() {});
            });
        });
    }
    function Vl(a, b, c, d, e) {
        return a.a.Pb(d, function(f) {
            b.na(c, null, f, e);
        }, Rl.get());
    }
    var Wl = {};
    function Jl(a, b, c) {
        a = a + ":" + b;
        c && (a = a + ":" + c.url);
        return a;
    }
    function Xl(a, b, c, d) {
        var e = Jl(b, c, d);
        Wl[e] || (Wl[e] = new Gl(a, b, c, d));
        return Wl[e];
    }
    function Hl() {
        this.b = null;
        this.f = [];
        this.c = [];
        this.a = null;
        this.i = this.g = !1;
    }
    Hl.prototype.reset = function() {
        this.b = null;
        this.a && (this.a.cancel(), this.a = null);
    };
    Hl.prototype.h = function(a, b) {
        if (a) {
            this.reset();
            this.g = !0;
            var c = a.c, d = a.b, e = a.a && "auth/web-storage-unsupported" == a.a.code, f = a.a && "auth/operation-not-supported-in-this-environment" == a.a.code;
            this.i = !(!e && !f);
            "unknown" != c || e || f ? a.a ? (Yl(this, !0, null, a.a), E()) : b.Fa(c, d) ? Zl(this, a, b) : F(new t("invalid-auth-event")) : (Yl(this, !1, null, null), E());
        } else F(new t("invalid-auth-event"));
    };
    function Ol(a) {
        a.g || (a.g = !0, Yl(a, !1, null, null));
    }
    function $l(a) {
        a.g && !a.i && Yl(a, !1, null, null);
    }
    function Zl(a, b, c) {
        c = c.Fa(b.c, b.b);
        var d = b.g, e = b.f, f = b.i, g = b.T(), h = !!b.c.match(/Redirect$/);
        c(d, e, g, f).then(function(m) {
            Yl(a, h, m, null);
        }).o(function(m) {
            Yl(a, h, null, m);
        });
    }
    function am(a, b) {
        a.b = function() {
            return F(b);
        };
        if (a.c.length) for(var c = 0; c < a.c.length; c++)a.c[c](b);
    }
    function bm(a, b) {
        a.b = function() {
            return E(b);
        };
        if (a.f.length) for(var c = 0; c < a.f.length; c++)a.f[c](b);
    }
    function Yl(a, b, c, d) {
        b ? d ? am(a, d) : bm(a, c) : bm(a, {
            user: null
        });
        a.f = [];
        a.c = [];
    }
    Hl.prototype.ra = function() {
        var a = this;
        return new D(function(b, c) {
            a.b ? a.b().then(b, c) : (a.f.push(b), a.c.push(c), cm(a));
        });
    };
    function cm(a) {
        var b = new t("timeout");
        a.a && a.a.cancel();
        a.a = Fd(Sl.get()).then(function() {
            a.b || (a.g = !0, Yl(a, !0, null, b));
        });
    }
    function Il() {}
    Il.prototype.h = function(a, b) {
        if (a) {
            var c = a.c, d = a.b;
            a.a ? (b.na(a.c, null, a.a, a.b), E()) : b.Fa(c, d) ? dm(a, b) : F(new t("invalid-auth-event"));
        } else F(new t("invalid-auth-event"));
    };
    function dm(a, b) {
        var c = a.b, d = a.c;
        b.Fa(d, c)(a.g, a.f, a.T(), a.i).then(function(e) {
            b.na(d, e, null, c);
        }).o(function(e) {
            b.na(d, null, e, c);
        });
    }
    function em() {
        this.jb = !1;
        Object.defineProperty(this, "appVerificationDisabled", {
            get: function() {
                return this.jb;
            },
            set: function(a) {
                this.jb = a;
            },
            enumerable: !1
        });
    }
    function fm(a, b) {
        this.a = b;
        M(this, "verificationId", a);
    }
    fm.prototype.confirm = function(a) {
        a = ph(this.verificationId, a);
        return this.a(a);
    };
    function gm(a, b, c, d) {
        return new lh(a).gb(b, c).then(function(e) {
            return new fm(e, d);
        });
    }
    function hm(a) {
        var b = ig(a);
        if (!(b && b.exp && b.auth_time && b.iat)) throw new t("internal-error", "An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");
        N(this, {
            token: a,
            expirationTime: bf(1E3 * b.exp),
            authTime: bf(1E3 * b.auth_time),
            issuedAtTime: bf(1E3 * b.iat),
            signInProvider: b.firebase && b.firebase.sign_in_provider ? b.firebase.sign_in_provider : null,
            signInSecondFactor: b.firebase && b.firebase.sign_in_second_factor ? b.firebase.sign_in_second_factor : null,
            claims: b
        });
    }
    function im(a, b, c) {
        var d = b && b[jm];
        if (!d) throw new t("argument-error", "Internal assert: Invalid MultiFactorResolver");
        this.a = a;
        this.f = nb(b);
        this.g = c;
        this.c = new yg(null, d);
        this.b = [];
        var e = this;
        w(b[km] || [], function(f) {
            (f = tf(f)) && e.b.push(f);
        });
        M(this, "auth", this.a);
        M(this, "session", this.c);
        M(this, "hints", this.b);
    }
    var km = "mfaInfo", jm = "mfaPendingCredential";
    im.prototype.Rc = function(a) {
        var b = this;
        return a.tb(this.a.a, this.c).then(function(c) {
            var d = nb(b.f);
            delete d[km];
            delete d[jm];
            z(d, c);
            return b.g(d);
        });
    };
    function lm(a, b, c, d) {
        t.call(this, "multi-factor-auth-required", d, b);
        this.b = new im(a, b, c);
        M(this, "resolver", this.b);
    }
    r(lm, t);
    function mm(a, b, c) {
        if (a && n(a.serverResponse) && "auth/multi-factor-auth-required" === a.code) try {
            return new lm(b, a.serverResponse, c, a.message);
        } catch (d) {}
        return null;
    }
    function nm() {}
    nm.prototype.tb = function(a, b, c) {
        return b.type == zg ? om(this, a, b, c) : pm(this, a, b);
    };
    function om(a, b, c, d) {
        return c.Ha().then(function(e) {
            e = {
                idToken: e
            };
            "undefined" !== typeof d && (e.displayName = d);
            z(e, {
                phoneVerificationInfo: hh(a.a)
            });
            return O(b, Gj, e);
        });
    }
    function pm(a, b, c) {
        return c.Ha().then(function(d) {
            d = {
                mfaPendingCredential: d
            };
            z(d, {
                phoneVerificationInfo: hh(a.a)
            });
            return O(b, Hj, d);
        });
    }
    function qm(a) {
        M(this, "factorId", a.fa);
        this.a = a;
    }
    r(qm, nm);
    function rm(a) {
        qm.call(this, a);
        if (this.a.fa != lh.PROVIDER_ID) throw new t("argument-error", "firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");
    }
    r(rm, qm);
    function sm(a, b) {
        G.call(this, a);
        for(var c in b)this[c] = b[c];
    }
    r(sm, G);
    function tm(a, b) {
        this.a = a;
        this.b = [];
        this.c = q(this.yc, this);
        nd(this.a, "userReloaded", this.c);
        var c = [];
        b && b.multiFactor && b.multiFactor.enrolledFactors && w(b.multiFactor.enrolledFactors, function(d) {
            var e = null, f = {};
            if (d) {
                d.uid && (f[qf] = d.uid);
                d.displayName && (f[rf] = d.displayName);
                d.enrollmentTime && (f[sf] = new Date(d.enrollmentTime).toISOString());
                d.phoneNumber && (f[pf] = d.phoneNumber);
                try {
                    e = new uf(f);
                } catch (g) {}
                d = e;
            } else d = null;
            d && c.push(d);
        });
        um(this, c);
    }
    function vm(a) {
        var b = [];
        w(a.mfaInfo || [], function(c) {
            (c = tf(c)) && b.push(c);
        });
        return b;
    }
    k = tm.prototype;
    k.yc = function(a) {
        um(this, vm(a.hd));
    };
    function um(a, b) {
        a.b = b;
        M(a, "enrolledFactors", b);
    }
    k.Sb = function() {
        return this.a.I().then(function(a) {
            return new yg(a, null);
        });
    };
    k.fc = function(a, b) {
        var c = this, d = this.a.a;
        return this.Sb().then(function(e) {
            return a.tb(d, e, b);
        }).then(function(e) {
            wm(c.a, e);
            return c.a.reload();
        });
    };
    k.bd = function(a) {
        var b = this, c = "string" === typeof a ? a : a.uid, d = this.a.a;
        return this.a.I().then(function(e) {
            return O(d, Lj, {
                idToken: e,
                mfaEnrollmentId: c
            });
        }).then(function(e) {
            var f = Qa(b.b, function(g) {
                return g.uid != c;
            });
            um(b, f);
            wm(b.a, e);
            return b.a.reload().o(function(g) {
                if ("auth/user-token-expired" != g.code) throw g;
            });
        });
    };
    k.w = function() {
        return {
            multiFactor: {
                enrolledFactors: Ra(this.b, function(a) {
                    return a.w();
                })
            }
        };
    };
    function xm(a, b, c) {
        this.h = a;
        this.i = b;
        this.g = c;
        this.c = 3E4;
        this.f = 96E4;
        this.b = null;
        this.a = this.c;
        if (this.f < this.c) throw Error("Proactive refresh lower bound greater than upper bound!");
    }
    xm.prototype.start = function() {
        this.a = this.c;
        ym(this, !0);
    };
    function zm(a, b) {
        if (b) return a.a = a.c, a.g();
        b = a.a;
        a.a *= 2;
        a.a > a.f && (a.a = a.f);
        return b;
    }
    function ym(a, b) {
        a.stop();
        a.b = Fd(zm(a, b)).then(function() {
            return af();
        }).then(function() {
            return a.h();
        }).then(function() {
            ym(a, !0);
        }).o(function(c) {
            a.i(c) && ym(a, !1);
        });
    }
    xm.prototype.stop = function() {
        this.b && (this.b.cancel(), this.b = null);
    };
    function Am(a) {
        this.f = a;
        this.b = this.a = null;
        this.c = Date.now();
    }
    Am.prototype.w = function() {
        return {
            apiKey: this.f.c,
            refreshToken: this.a,
            accessToken: this.b && this.b.toString(),
            expirationTime: this.c
        };
    };
    function Bm(a, b) {
        "undefined" === typeof b && (a.b ? (b = a.b, b = b.a - b.g) : b = 0);
        a.c = Date.now() + 1E3 * b;
    }
    function Cm(a, b) {
        a.b = jg(b[Dg] || "");
        a.a = b.refreshToken;
        b = b.expiresIn;
        Bm(a, "undefined" !== typeof b ? Number(b) : void 0);
    }
    function Dm(a, b) {
        a.b = b.b;
        a.a = b.a;
        a.c = b.c;
    }
    function Em(a, b) {
        return Wi(a.f, b).then(function(c) {
            a.b = jg(c.access_token);
            a.a = c.refresh_token;
            Bm(a, c.expires_in);
            return {
                accessToken: a.b.toString(),
                refreshToken: a.a
            };
        }).o(function(c) {
            "auth/user-token-expired" == c.code && (a.a = null);
            throw c;
        });
    }
    Am.prototype.getToken = function(a) {
        a = !!a;
        return this.b && !this.a ? F(new t("user-token-expired")) : a || !this.b || Date.now() > this.c - 3E4 ? this.a ? Em(this, {
            grant_type: "refresh_token",
            refresh_token: this.a
        }) : E(null) : E({
            accessToken: this.b.toString(),
            refreshToken: this.a
        });
    };
    function Fm(a, b) {
        this.a = a || null;
        this.b = b || null;
        N(this, {
            lastSignInTime: bf(b || null),
            creationTime: bf(a || null)
        });
    }
    function Gm(a) {
        return new Fm(a.a, a.b);
    }
    Fm.prototype.w = function() {
        return {
            lastLoginAt: this.b,
            createdAt: this.a
        };
    };
    function Hm(a, b, c, d, e, f) {
        N(this, {
            uid: a,
            displayName: d || null,
            photoURL: e || null,
            email: c || null,
            phoneNumber: f || null,
            providerId: b
        });
    }
    function Im(a, b, c) {
        this.N = [];
        this.l = a.apiKey;
        this.m = a.appName;
        this.s = a.authDomain || null;
        var d = (0, $8eXKx.default).SDK_VERSION ? Oe((0, $8eXKx.default).SDK_VERSION) : null;
        this.a = new Ii(this.l, Ca(Da), d);
        (this.u = a.emulatorConfig || null) && Pi(this.a, this.u);
        this.h = new Am(this.a);
        Jm(this, b[Dg]);
        Cm(this.h, b);
        M(this, "refreshToken", this.h.a);
        Km(this, c || {});
        H.call(this);
        this.P = !1;
        this.s && Re() && (this.b = Xl(this.s, this.l, this.m, this.u));
        this.W = [];
        this.i = null;
        this.D = Lm(this);
        this.ba = q(this.ib, this);
        var e = this;
        this.za = null;
        this.Pa = function(f) {
            e.xa(f.h);
        };
        this.qa = null;
        this.Ba = function(f) {
            Mm(e, f.c);
        };
        this.$ = null;
        this.aa = [];
        this.Oa = function(f) {
            Nm(e, f.f);
        };
        this.ja = null;
        this.S = new tm(this, c);
        M(this, "multiFactor", this.S);
    }
    r(Im, H);
    Im.prototype.xa = function(a) {
        this.za = a;
        Oi(this.a, a);
    };
    function Mm(a, b) {
        a.u = b;
        Pi(a.a, b);
        a.b && (b = a.b, a.b = Xl(a.s, a.l, a.m, a.u), a.P && (Ql(b, a), Pl(a.b, a)));
    }
    Im.prototype.la = function() {
        return this.za;
    };
    function Om(a, b) {
        a.qa && xd(a.qa, "languageCodeChanged", a.Pa);
        (a.qa = b) && nd(b, "languageCodeChanged", a.Pa);
    }
    function Pm(a, b) {
        a.$ && xd(a.$, "emulatorConfigChanged", a.Ba);
        (a.$ = b) && nd(b, "emulatorConfigChanged", a.Ba);
    }
    function Nm(a, b) {
        a.aa = b;
        Ri(a.a, (0, $8eXKx.default).SDK_VERSION ? Oe((0, $8eXKx.default).SDK_VERSION, a.aa) : null);
    }
    Im.prototype.Ga = function() {
        return Za(this.aa);
    };
    function Qm(a, b) {
        a.ja && xd(a.ja, "frameworkChanged", a.Oa);
        (a.ja = b) && nd(b, "frameworkChanged", a.Oa);
    }
    Im.prototype.ib = function() {
        this.D.b && (this.D.stop(), this.D.start());
    };
    function Rm(a) {
        try {
            return (0, $8eXKx.default).app(a.m).auth();
        } catch (b) {
            throw new t("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + a.m + "'!");
        }
    }
    function Lm(a) {
        return new xm(function() {
            return a.I(!0);
        }, function(b) {
            return b && "auth/network-request-failed" == b.code ? !0 : !1;
        }, function() {
            var b = a.h.c - Date.now() - 3E5;
            return 0 < b ? b : 0;
        });
    }
    function Sm(a) {
        a.J || a.D.b || (a.D.start(), xd(a, "tokenChanged", a.ba), nd(a, "tokenChanged", a.ba));
    }
    function Tm(a) {
        xd(a, "tokenChanged", a.ba);
        a.D.stop();
    }
    function Jm(a, b) {
        a.Aa = b;
        M(a, "_lat", b);
    }
    function Um(a, b) {
        Xa(a.W, function(c) {
            return c == b;
        });
    }
    function Vm(a) {
        for(var b = [], c = 0; c < a.W.length; c++)b.push(a.W[c](a));
        return Jc(b).then(function() {
            return a;
        });
    }
    function Wm(a) {
        a.b && !a.P && (a.P = !0, Pl(a.b, a));
    }
    function Km(a, b) {
        N(a, {
            uid: b.uid,
            displayName: b.displayName || null,
            photoURL: b.photoURL || null,
            email: b.email || null,
            emailVerified: b.emailVerified || !1,
            phoneNumber: b.phoneNumber || null,
            isAnonymous: b.isAnonymous || !1,
            tenantId: b.tenantId || null,
            metadata: new Fm(b.createdAt, b.lastLoginAt),
            providerData: []
        });
        a.a.b = a.tenantId;
    }
    M(Im.prototype, "providerId", "firebase");
    function Xm() {}
    function Ym(a) {
        return E().then(function() {
            if (a.J) throw new t("app-deleted");
        });
    }
    function Zm(a) {
        return Ra(a.providerData, function(b) {
            return b.providerId;
        });
    }
    function $m(a, b) {
        b && (an(a, b.providerId), a.providerData.push(b));
    }
    function an(a, b) {
        Xa(a.providerData, function(c) {
            return c.providerId == b;
        });
    }
    function bn(a, b, c) {
        ("uid" != b || c) && a.hasOwnProperty(b) && M(a, b, c);
    }
    function cn(a, b) {
        a != b && (N(a, {
            uid: b.uid,
            displayName: b.displayName,
            photoURL: b.photoURL,
            email: b.email,
            emailVerified: b.emailVerified,
            phoneNumber: b.phoneNumber,
            isAnonymous: b.isAnonymous,
            tenantId: b.tenantId,
            providerData: []
        }), b.metadata ? M(a, "metadata", Gm(b.metadata)) : M(a, "metadata", new Fm), w(b.providerData, function(c) {
            $m(a, c);
        }), Dm(a.h, b.h), M(a, "refreshToken", a.h.a), um(a.S, b.S.b));
    }
    k = Im.prototype;
    k.reload = function() {
        var a = this;
        return R(this, Ym(this).then(function() {
            return dn(a).then(function() {
                return Vm(a);
            }).then(Xm);
        }));
    };
    function dn(a) {
        return a.I().then(function(b) {
            var c = a.isAnonymous;
            return en(a, b).then(function() {
                c || bn(a, "isAnonymous", !1);
                return b;
            });
        });
    }
    k.oc = function(a) {
        return this.I(a).then(function(b) {
            return new hm(b);
        });
    };
    k.I = function(a) {
        var b = this;
        return R(this, Ym(this).then(function() {
            return b.h.getToken(a);
        }).then(function(c) {
            if (!c) throw new t("internal-error");
            c.accessToken != b.Aa && (Jm(b, c.accessToken), b.dispatchEvent(new sm("tokenChanged")));
            bn(b, "refreshToken", c.refreshToken);
            return c.accessToken;
        }));
    };
    function wm(a, b) {
        b[Dg] && a.Aa != b[Dg] && (Cm(a.h, b), a.dispatchEvent(new sm("tokenChanged")), Jm(a, b[Dg]), bn(a, "refreshToken", a.h.a));
    }
    function en(a, b) {
        return O(a.a, Ij, {
            idToken: b
        }).then(q(a.Kc, a));
    }
    k.Kc = function(a) {
        a = a.users;
        if (!a || !a.length) throw new t("internal-error");
        a = a[0];
        Km(this, {
            uid: a.localId,
            displayName: a.displayName,
            photoURL: a.photoUrl,
            email: a.email,
            emailVerified: !!a.emailVerified,
            phoneNumber: a.phoneNumber,
            lastLoginAt: a.lastLoginAt,
            createdAt: a.createdAt,
            tenantId: a.tenantId
        });
        for(var b = fn(a), c = 0; c < b.length; c++)$m(this, b[c]);
        bn(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
        this.dispatchEvent(new sm("userReloaded", {
            hd: a
        }));
    };
    function fn(a) {
        return (a = a.providerUserInfo) && a.length ? Ra(a, function(b) {
            return new Hm(b.rawId, b.providerId, b.email, b.displayName, b.photoUrl, b.phoneNumber);
        }) : [];
    }
    k.Lc = function(a) {
        gf("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");
        return this.ub(a);
    };
    k.ub = function(a) {
        var b = this, c = null;
        return R(this, a.c(this.a, this.uid).then(function(d) {
            wm(b, d);
            c = gn(b, d, "reauthenticate");
            b.i = null;
            return b.reload();
        }).then(function() {
            return c;
        }), !0);
    };
    function hn(a, b) {
        return dn(a).then(function() {
            if (Va(Zm(a), b)) return Vm(a).then(function() {
                throw new t("provider-already-linked");
            });
        });
    }
    k.Cc = function(a) {
        gf("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");
        return this.rb(a);
    };
    k.rb = function(a) {
        var b = this, c = null;
        return R(this, hn(this, a.providerId).then(function() {
            return b.I();
        }).then(function(d) {
            return a.b(b.a, d);
        }).then(function(d) {
            c = gn(b, d, "link");
            return jn(b, d);
        }).then(function() {
            return c;
        }));
    };
    k.Dc = function(a, b) {
        var c = this;
        return R(this, hn(this, "phone").then(function() {
            return gm(Rm(c), a, b, q(c.rb, c));
        }));
    };
    k.Mc = function(a, b) {
        var c = this;
        return R(this, E().then(function() {
            return gm(Rm(c), a, b, q(c.ub, c));
        }), !0);
    };
    function gn(a, b, c) {
        var d = qh(b);
        b = og(b);
        return kf({
            user: a,
            credential: d,
            additionalUserInfo: b,
            operationType: c
        });
    }
    function jn(a, b) {
        wm(a, b);
        return a.reload().then(function() {
            return a;
        });
    }
    k.Cb = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.Cb(c, a);
        }).then(function(c) {
            wm(b, c);
            return b.reload();
        }));
    };
    k.ed = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return a.b(b.a, c);
        }).then(function(c) {
            wm(b, c);
            return b.reload();
        }));
    };
    k.Db = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.Db(c, a);
        }).then(function(c) {
            wm(b, c);
            return b.reload();
        }));
    };
    k.Eb = function(a) {
        if (void 0 === a.displayName && void 0 === a.photoURL) return Ym(this);
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.Eb(c, {
                displayName: a.displayName,
                photoUrl: a.photoURL
            });
        }).then(function(c) {
            wm(b, c);
            bn(b, "displayName", c.displayName || null);
            bn(b, "photoURL", c.photoUrl || null);
            w(b.providerData, function(d) {
                "password" === d.providerId && (M(d, "displayName", b.displayName), M(d, "photoURL", b.photoURL));
            });
            return Vm(b);
        }).then(Xm));
    };
    k.cd = function(a) {
        var b = this;
        return R(this, dn(this).then(function(c) {
            return Va(Zm(b), a) ? rj(b.a, c, [
                a
            ]).then(function(d) {
                var e = {};
                w(d.providerUserInfo || [], function(f) {
                    e[f.providerId] = !0;
                });
                w(Zm(b), function(f) {
                    e[f] || an(b, f);
                });
                e[lh.PROVIDER_ID] || M(b, "phoneNumber", null);
                return Vm(b);
            }) : Vm(b).then(function() {
                throw new t("no-such-provider");
            });
        }));
    };
    k.delete = function() {
        var a = this;
        return R(this, this.I().then(function(b) {
            return O(a.a, Fj, {
                idToken: b
            });
        }).then(function() {
            a.dispatchEvent(new sm("userDeleted"));
        })).then(function() {
            for(var b = 0; b < a.N.length; b++)a.N[b].cancel("app-deleted");
            Om(a, null);
            Pm(a, null);
            Qm(a, null);
            a.N = [];
            a.J = !0;
            Tm(a);
            M(a, "refreshToken", null);
            a.b && Ql(a.b, a);
        });
    };
    k.Gb = function(a, b) {
        return "linkViaPopup" == a && (this.g || null) == b && this.f || "reauthViaPopup" == a && (this.g || null) == b && this.f || "linkViaRedirect" == a && (this.ga || null) == b || "reauthViaRedirect" == a && (this.ga || null) == b ? !0 : !1;
    };
    k.na = function(a, b, c, d) {
        "linkViaPopup" != a && "reauthViaPopup" != a || d != (this.g || null) || (c && this.C ? this.C(c) : b && !c && this.f && this.f(b), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.C);
    };
    k.Fa = function(a, b) {
        return "linkViaPopup" == a && b == (this.g || null) ? q(this.Lb, this) : "reauthViaPopup" == a && b == (this.g || null) ? q(this.Mb, this) : "linkViaRedirect" == a && (this.ga || null) == b ? q(this.Lb, this) : "reauthViaRedirect" == a && (this.ga || null) == b ? q(this.Mb, this) : null;
    };
    k.Ec = function(a) {
        var b = this;
        return kn(this, "linkViaPopup", a, function() {
            return hn(b, a.providerId).then(function() {
                return Vm(b);
            });
        }, !1);
    };
    k.Nc = function(a) {
        return kn(this, "reauthViaPopup", a, function() {
            return E();
        }, !0);
    };
    function kn(a, b, c, d, e) {
        if (!Re()) return F(new t("operation-not-supported-in-this-environment"));
        if (a.i && !e) return F(a.i);
        var f = ng(c.providerId), g = Qe(a.uid + ":::"), h = null;
        (!Te() || Ie()) && a.s && c.isOAuthProvider && (h = ek(a.s, a.l, a.m, b, c, null, g, (0, $8eXKx.default).SDK_VERSION || null, null, null, a.tenantId, a.u));
        var m = ze(h, f && f.va, f && f.ua);
        d = d().then(function() {
            ln(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            return Tl(a.b, m, b, c, g, !!h, a.tenantId);
        }).then(function() {
            return new D(function(p, v) {
                a.na(b, null, new t("cancelled-popup-request"), a.g || null);
                a.f = p;
                a.C = v;
                a.g = g;
                a.c = Vl(a.b, a, b, m, g);
            });
        }).then(function(p) {
            m && ye(m);
            return p ? kf(p) : null;
        }).o(function(p) {
            m && ye(m);
            throw p;
        });
        return R(a, d, e);
    }
    k.Fc = function(a) {
        var b = this;
        return mn(this, "linkViaRedirect", a, function() {
            return hn(b, a.providerId);
        }, !1);
    };
    k.Oc = function(a) {
        return mn(this, "reauthViaRedirect", a, function() {
            return E();
        }, !0);
    };
    function mn(a, b, c, d, e) {
        if (!Re()) return F(new t("operation-not-supported-in-this-environment"));
        if (a.i && !e) return F(a.i);
        var f = null, g = Qe(a.uid + ":::");
        d = d().then(function() {
            ln(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            a.ga = g;
            return Vm(a);
        }).then(function(h) {
            a.ha && (h = a.ha, h = h.b.set(nn, a.w(), h.a));
            return h;
        }).then(function() {
            return Ul(a.b, b, c, g, a.tenantId);
        }).o(function(h) {
            f = h;
            if (a.ha) return on(a.ha);
            throw f;
        }).then(function() {
            if (f) throw f;
        });
        return R(a, d, e);
    }
    function ln(a) {
        if (!a.b || !a.P) {
            if (a.b && !a.P) throw new t("internal-error");
            throw new t("auth-domain-config-required");
        }
    }
    k.Lb = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null;
        c = this.I().then(function(g) {
            return Hg(e.a, {
                requestUri: a,
                postBody: d,
                sessionId: b,
                idToken: g
            });
        }).then(function(g) {
            f = gn(e, g, "link");
            return jn(e, g);
        }).then(function() {
            return f;
        });
        return R(this, c);
    };
    k.Mb = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null, g = E().then(function() {
            return Cg(Ig(e.a, {
                requestUri: a,
                sessionId: b,
                postBody: d,
                tenantId: c
            }), e.uid);
        }).then(function(h) {
            f = gn(e, h, "reauthenticate");
            wm(e, h);
            e.i = null;
            return e.reload();
        }).then(function() {
            return f;
        });
        return R(this, g, !0);
    };
    k.vb = function(a) {
        var b = this, c = null;
        return R(this, this.I().then(function(d) {
            c = d;
            return "undefined" === typeof a || mb(a) ? {} : bg(new Sf(a));
        }).then(function(d) {
            return b.a.vb(c, d);
        }).then(function(d) {
            if (b.email != d) return b.reload();
        }).then(function() {}));
    };
    k.Fb = function(a, b) {
        var c = this, d = null;
        return R(this, this.I().then(function(e) {
            d = e;
            return "undefined" === typeof b || mb(b) ? {} : bg(new Sf(b));
        }).then(function(e) {
            return c.a.Fb(d, a, e);
        }).then(function(e) {
            if (c.email != e) return c.reload();
        }).then(function() {}));
    };
    function R(a, b, c) {
        var d = pn(a, b, c);
        a.N.push(d);
        d.oa(function() {
            Wa(a.N, d);
        });
        return d.o(function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = mm(e.w(), Rm(a), q(a.jc, a)));
            throw f || e;
        });
    }
    k.jc = function(a) {
        var b = null, c = this;
        a = Cg(E(a), c.uid).then(function(d) {
            b = gn(c, d, "reauthenticate");
            wm(c, d);
            c.i = null;
            return c.reload();
        }).then(function() {
            return b;
        });
        return R(this, a, !0);
    };
    function pn(a, b, c) {
        return a.i && !c ? (b.cancel(), F(a.i)) : b.o(function(d) {
            !d || "auth/user-disabled" != d.code && "auth/user-token-expired" != d.code || (a.i || a.dispatchEvent(new sm("userInvalidated")), a.i = d);
            throw d;
        });
    }
    k.toJSON = function() {
        return this.w();
    };
    k.w = function() {
        var a = {
            uid: this.uid,
            displayName: this.displayName,
            photoURL: this.photoURL,
            email: this.email,
            emailVerified: this.emailVerified,
            phoneNumber: this.phoneNumber,
            isAnonymous: this.isAnonymous,
            tenantId: this.tenantId,
            providerData: [],
            apiKey: this.l,
            appName: this.m,
            authDomain: this.s,
            stsTokenManager: this.h.w(),
            redirectEventId: this.ga || null
        };
        this.metadata && z(a, this.metadata.w());
        w(this.providerData, function(b) {
            a.providerData.push(lf(b));
        });
        z(a, this.S.w());
        return a;
    };
    function qn(a) {
        if (!a.apiKey) return null;
        var b = {
            apiKey: a.apiKey,
            authDomain: a.authDomain,
            appName: a.appName,
            emulatorConfig: a.emulatorConfig
        }, c = {};
        if (a.stsTokenManager && a.stsTokenManager.accessToken) {
            c[Dg] = a.stsTokenManager.accessToken;
            c.refreshToken = a.stsTokenManager.refreshToken || null;
            var d = a.stsTokenManager.expirationTime;
            d && (c.expiresIn = (d - Date.now()) / 1E3);
        } else return null;
        var e = new Im(b, c, a);
        a.providerData && w(a.providerData, function(f) {
            f && $m(e, kf(f));
        });
        a.redirectEventId && (e.ga = a.redirectEventId);
        return e;
    }
    function rn(a, b, c, d) {
        var e = new Im(a, b);
        c && (e.ha = c);
        d && Nm(e, d);
        return e.reload().then(function() {
            return e;
        });
    }
    function sn(a, b, c, d) {
        var e = a.h, f = {};
        f[Dg] = e.b && e.b.toString();
        f.refreshToken = e.a;
        b = new Im(b || {
            apiKey: a.l,
            authDomain: a.s,
            appName: a.m
        }, f);
        c && (b.ha = c);
        d && Nm(b, d);
        cn(b, a);
        return b;
    }
    function tn(a) {
        this.a = a;
        this.b = Vk();
    }
    var nn = {
        name: "redirectUser",
        F: "session"
    };
    function on(a) {
        return Zk(a.b, nn, a.a);
    }
    function un(a, b) {
        return a.b.get(nn, a.a).then(function(c) {
            c && b && (c.authDomain = b);
            return qn(c || {});
        });
    }
    function vn(a) {
        this.a = a;
        this.b = Vk();
        this.c = null;
        this.f = wn(this);
        this.b.addListener(xn("local"), this.a, q(this.g, this));
    }
    vn.prototype.g = function() {
        var a = this, b = xn("local");
        yn(this, function() {
            return E().then(function() {
                return a.c && "local" != a.c.F ? a.b.get(b, a.a) : null;
            }).then(function(c) {
                if (c) return zn(a, "local").then(function() {
                    a.c = b;
                });
            });
        });
    };
    function zn(a, b) {
        var c = [], d;
        for(d in Rk)Rk[d] !== b && c.push(Zk(a.b, xn(Rk[d]), a.a));
        c.push(Zk(a.b, An, a.a));
        return Ic(c);
    }
    function wn(a) {
        var b = xn("local"), c = xn("session"), d = xn("none");
        return Yk(a.b, b, a.a).then(function() {
            return a.b.get(c, a.a);
        }).then(function(e) {
            return e ? c : a.b.get(d, a.a).then(function(f) {
                return f ? d : a.b.get(b, a.a).then(function(g) {
                    return g ? b : a.b.get(An, a.a).then(function(h) {
                        return h ? xn(h) : b;
                    });
                });
            });
        }).then(function(e) {
            a.c = e;
            return zn(a, e.F);
        }).o(function() {
            a.c || (a.c = b);
        });
    }
    var An = {
        name: "persistence",
        F: "session"
    };
    function xn(a) {
        return {
            name: "authUser",
            F: a
        };
    }
    vn.prototype.yb = function(a) {
        var b = null, c = this;
        Sk(a);
        return yn(this, function() {
            return a != c.c.F ? c.b.get(c.c, c.a).then(function(d) {
                b = d;
                return zn(c, a);
            }).then(function() {
                c.c = xn(a);
                if (b) return c.b.set(c.c, b, c.a);
            }) : E();
        });
    };
    function Bn(a) {
        return yn(a, function() {
            return a.b.set(An, a.c.F, a.a);
        });
    }
    function Cn(a, b) {
        return yn(a, function() {
            return a.b.set(a.c, b.w(), a.a);
        });
    }
    function Dn(a) {
        return yn(a, function() {
            return Zk(a.b, a.c, a.a);
        });
    }
    function En(a, b, c) {
        return yn(a, function() {
            return a.b.get(a.c, a.a).then(function(d) {
                d && b && (d.authDomain = b);
                d && c && (d.emulatorConfig = c);
                return qn(d || {});
            });
        });
    }
    function yn(a, b) {
        a.f = a.f.then(b, b);
        return a.f;
    }
    function Fn(a) {
        this.l = !1;
        M(this, "settings", new em);
        M(this, "app", a);
        if (S(this).options && S(this).options.apiKey) a = (0, $8eXKx.default).SDK_VERSION ? Oe((0, $8eXKx.default).SDK_VERSION) : null, this.a = new Ii(S(this).options && S(this).options.apiKey, Ca(Da), a);
        else throw new t("invalid-api-key");
        this.P = [];
        this.s = [];
        this.N = [];
        this.Pa = (0, $8eXKx.default).INTERNAL.createSubscribe(q(this.zc, this));
        this.W = void 0;
        this.ib = (0, $8eXKx.default).INTERNAL.createSubscribe(q(this.Ac, this));
        Gn(this, null);
        this.i = new vn(S(this).options.apiKey + ":" + S(this).name);
        this.D = new tn(S(this).options.apiKey + ":" + S(this).name);
        this.$ = T(this, Hn(this));
        this.h = T(this, In(this));
        this.ba = !1;
        this.ja = q(this.Zc, this);
        this.Ba = q(this.da, this);
        this.qa = q(this.mc, this);
        this.za = q(this.wc, this);
        this.Aa = q(this.xc, this);
        this.b = null;
        Jn(this);
        this.INTERNAL = {};
        this.INTERNAL["delete"] = q(this.delete, this);
        this.INTERNAL.logFramework = q(this.Gc, this);
        this.u = 0;
        H.call(this);
        Kn(this);
        this.J = [];
        this.R = null;
    }
    r(Fn, H);
    function Ln(a) {
        G.call(this, "languageCodeChanged");
        this.h = a;
    }
    r(Ln, G);
    function Mn(a) {
        G.call(this, "emulatorConfigChanged");
        this.c = a;
    }
    r(Mn, G);
    function Nn(a) {
        G.call(this, "frameworkChanged");
        this.f = a;
    }
    r(Nn, G);
    k = Fn.prototype;
    k.yb = function(a) {
        a = this.i.yb(a);
        return T(this, a);
    };
    k.xa = function(a) {
        this.aa === a || this.l || (this.aa = a, Oi(this.a, this.aa), this.dispatchEvent(new Ln(this.la())));
    };
    k.la = function() {
        return this.aa;
    };
    k.fd = function() {
        var a = l.navigator;
        this.xa(a ? a.languages && a.languages[0] || a.language || a.userLanguage || null : null);
    };
    k.gd = function(a, b) {
        if (!this.R) {
            if (!/^https?:\/\//.test(a)) throw new t("argument-error", "Emulator URL must start with a valid scheme (http:// or https://).");
            b = b ? !!b.disableWarnings : !1;
            On(b);
            this.R = {
                url: a,
                ec: b
            };
            this.settings.jb = !0;
            Pi(this.a, this.R);
            this.dispatchEvent(new Mn(this.R));
        }
    };
    function On(a) {
        "undefined" !== typeof console && "function" === typeof console.info && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
        l.document && !a && Ee().then(function() {
            var b = l.document.createElement("div");
            b.innerText = "Running in emulator mode. Do not use with production credentials.";
            b.style.position = "fixed";
            b.style.width = "100%";
            b.style.backgroundColor = "#ffffff";
            b.style.border = ".1em solid #000000";
            b.style.color = "#b50000";
            b.style.bottom = "0px";
            b.style.left = "0px";
            b.style.margin = "0px";
            b.style.zIndex = 1E4;
            b.style.textAlign = "center";
            b.classList.add("firebase-emulator-warning");
            l.document.body.appendChild(b);
        });
    }
    k.Gc = function(a) {
        this.J.push(a);
        Ri(this.a, (0, $8eXKx.default).SDK_VERSION ? Oe((0, $8eXKx.default).SDK_VERSION, this.J) : null);
        this.dispatchEvent(new Nn(this.J));
    };
    k.Ga = function() {
        return Za(this.J);
    };
    k.zb = function(a) {
        this.S === a || this.l || (this.S = a, this.a.b = this.S);
    };
    k.T = function() {
        return this.S;
    };
    function Kn(a) {
        Object.defineProperty(a, "lc", {
            get: function() {
                return this.la();
            },
            set: function(b) {
                this.xa(b);
            },
            enumerable: !1
        });
        a.aa = null;
        Object.defineProperty(a, "ti", {
            get: function() {
                return this.T();
            },
            set: function(b) {
                this.zb(b);
            },
            enumerable: !1
        });
        a.S = null;
        Object.defineProperty(a, "emulatorConfig", {
            get: function() {
                if (this.R) {
                    var b = J(this.R.url);
                    b = kf({
                        protocol: b.c,
                        host: b.a,
                        port: b.g,
                        options: kf({
                            disableWarnings: this.R.ec
                        })
                    });
                } else b = null;
                return b;
            },
            enumerable: !1
        });
    }
    k.toJSON = function() {
        return {
            apiKey: S(this).options.apiKey,
            authDomain: S(this).options.authDomain,
            appName: S(this).name,
            currentUser: U(this) && U(this).w()
        };
    };
    function Pn(a) {
        return a.Oa || F(new t("auth-domain-config-required"));
    }
    function Jn(a) {
        var b = S(a).options.authDomain, c = S(a).options.apiKey;
        b && Re() && (a.Oa = a.$.then(function() {
            if (!a.l) {
                a.b = Xl(b, c, S(a).name, a.R);
                Pl(a.b, a);
                U(a) && Wm(U(a));
                if (a.m) {
                    Wm(a.m);
                    var d = a.m;
                    d.xa(a.la());
                    Om(d, a);
                    d = a.m;
                    Nm(d, a.J);
                    Qm(d, a);
                    d = a.m;
                    Mm(d, a.R);
                    Pm(d, a);
                    a.m = null;
                }
                return a.b;
            }
        }));
    }
    k.Gb = function(a, b) {
        switch(a){
            case "unknown":
            case "signInViaRedirect":
                return !0;
            case "signInViaPopup":
                return this.g == b && !!this.f;
            default:
                return !1;
        }
    };
    k.na = function(a, b, c, d) {
        "signInViaPopup" == a && this.g == d && (c && this.C ? this.C(c) : b && !c && this.f && this.f(b), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.C);
    };
    k.Fa = function(a, b) {
        return "signInViaRedirect" == a || "signInViaPopup" == a && this.g == b && this.f ? q(this.ic, this) : null;
    };
    k.ic = function(a, b, c, d) {
        var e = this, f = {
            requestUri: a,
            postBody: d,
            sessionId: b,
            tenantId: c
        };
        this.c && (this.c.cancel(), this.c = null);
        return e.$.then(function() {
            return Qn(e, Fg(e.a, f));
        });
    };
    k.Xc = function(a) {
        if (!Re()) return F(new t("operation-not-supported-in-this-environment"));
        var b = this, c = ng(a.providerId), d = Qe(), e = null;
        (!Te() || Ie()) && S(this).options.authDomain && a.isOAuthProvider && (e = ek(S(this).options.authDomain, S(this).options.apiKey, S(this).name, "signInViaPopup", a, null, d, (0, $8eXKx.default).SDK_VERSION || null, null, null, this.T(), this.R));
        var f = ze(e, c && c.va, c && c.ua);
        c = Pn(this).then(function(g) {
            return Tl(g, f, "signInViaPopup", a, d, !!e, b.T());
        }).then(function() {
            return new D(function(g, h) {
                b.na("signInViaPopup", null, new t("cancelled-popup-request"), b.g);
                b.f = g;
                b.C = h;
                b.g = d;
                b.c = Vl(b.b, b, "signInViaPopup", f, d);
            });
        }).then(function(g) {
            f && ye(f);
            return g ? kf(g) : null;
        }).o(function(g) {
            f && ye(f);
            throw g;
        });
        return T(this, c);
    };
    k.Yc = function(a) {
        if (!Re()) return F(new t("operation-not-supported-in-this-environment"));
        var b = this, c = Pn(this).then(function() {
            return Bn(b.i);
        }).then(function() {
            return Ul(b.b, "signInViaRedirect", a, void 0, b.T());
        });
        return T(this, c);
    };
    function Rn(a) {
        if (!Re()) return F(new t("operation-not-supported-in-this-environment"));
        var b = Pn(a).then(function() {
            return a.b.ra();
        }).then(function(c) {
            return c ? kf(c) : null;
        });
        return T(a, b);
    }
    k.ra = function() {
        var a = this;
        return Rn(this).then(function(b) {
            a.b && $l(a.b.b);
            return b;
        }).o(function(b) {
            a.b && $l(a.b.b);
            throw b;
        });
    };
    k.dd = function(a) {
        if (!a) return F(new t("null-user"));
        if (this.S != a.tenantId) return F(new t("tenant-id-mismatch"));
        var b = this, c = {};
        c.apiKey = S(this).options.apiKey;
        c.authDomain = S(this).options.authDomain;
        c.appName = S(this).name;
        var d = sn(a, c, b.D, b.Ga());
        return T(this, this.h.then(function() {
            if (S(b).options.apiKey != a.l) return d.reload();
        }).then(function() {
            if (U(b) && a.uid == U(b).uid) return cn(U(b), a), b.da(a);
            Gn(b, d);
            Wm(d);
            return b.da(d);
        }).then(function() {
            Sn(b);
        }));
    };
    function Tn(a, b) {
        var c = {};
        c.apiKey = S(a).options.apiKey;
        c.authDomain = S(a).options.authDomain;
        c.appName = S(a).name;
        a.R && (c.emulatorConfig = a.R);
        return a.$.then(function() {
            return rn(c, b, a.D, a.Ga());
        }).then(function(d) {
            if (U(a) && d.uid == U(a).uid) return cn(U(a), d), a.da(d);
            Gn(a, d);
            Wm(d);
            return a.da(d);
        }).then(function() {
            Sn(a);
        });
    }
    function Gn(a, b) {
        U(a) && (Um(U(a), a.Ba), xd(U(a), "tokenChanged", a.qa), xd(U(a), "userDeleted", a.za), xd(U(a), "userInvalidated", a.Aa), Tm(U(a)));
        b && (b.W.push(a.Ba), nd(b, "tokenChanged", a.qa), nd(b, "userDeleted", a.za), nd(b, "userInvalidated", a.Aa), 0 < a.u && Sm(b));
        M(a, "currentUser", b);
        b && (b.xa(a.la()), Om(b, a), Nm(b, a.J), Qm(b, a), Mm(b, a.R), Pm(b, a));
    }
    k.Bb = function() {
        var a = this, b = this.h.then(function() {
            a.b && $l(a.b.b);
            if (!U(a)) return E();
            Gn(a, null);
            return Dn(a.i).then(function() {
                Sn(a);
            });
        });
        return T(this, b);
    };
    function Un(a) {
        var b = un(a.D, S(a).options.authDomain).then(function(c) {
            if (a.m = c) c.ha = a.D;
            return on(a.D);
        });
        return T(a, b);
    }
    function Hn(a) {
        var b = S(a).options.authDomain, c = Un(a).then(function() {
            return En(a.i, b, a.R);
        }).then(function(d) {
            return d ? (d.ha = a.D, a.m && (a.m.ga || null) == (d.ga || null) ? d : d.reload().then(function() {
                return Cn(a.i, d).then(function() {
                    return d;
                });
            }).o(function(e) {
                return "auth/network-request-failed" == e.code ? d : Dn(a.i);
            })) : null;
        }).then(function(d) {
            Gn(a, d || null);
        });
        return T(a, c);
    }
    function In(a) {
        return a.$.then(function() {
            return Rn(a);
        }).o(function() {}).then(function() {
            if (!a.l) return a.ja();
        }).o(function() {}).then(function() {
            if (!a.l) {
                a.ba = !0;
                var b = a.i;
                b.b.addListener(xn("local"), b.a, a.ja);
            }
        });
    }
    k.Zc = function() {
        var a = this;
        return En(this.i, S(this).options.authDomain).then(function(b) {
            if (!a.l) {
                var c;
                if (c = U(a) && b) {
                    c = U(a).uid;
                    var d = b.uid;
                    c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
                }
                if (c) return cn(U(a), b), U(a).I();
                if (U(a) || b) Gn(a, b), b && (Wm(b), b.ha = a.D), a.b && Pl(a.b, a), Sn(a);
            }
        });
    };
    k.da = function(a) {
        return Cn(this.i, a);
    };
    k.mc = function() {
        Sn(this);
        this.da(U(this));
    };
    k.wc = function() {
        this.Bb();
    };
    k.xc = function() {
        this.Bb();
    };
    function Qn(a, b) {
        var c = null, d = null;
        return T(a, b.then(function(e) {
            c = qh(e);
            d = og(e);
            return Tn(a, e);
        }, function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = mm(e.w(), a, q(a.kc, a)));
            throw f || e;
        }).then(function() {
            return kf({
                user: U(a),
                credential: c,
                additionalUserInfo: d,
                operationType: "signIn"
            });
        }));
    }
    k.kc = function(a) {
        var b = this;
        return this.h.then(function() {
            return Qn(b, E(a));
        });
    };
    k.zc = function(a) {
        var b = this;
        this.addAuthTokenListener(function() {
            a.next(U(b));
        });
    };
    k.Ac = function(a) {
        var b = this;
        Vn(this, function() {
            a.next(U(b));
        });
    };
    k.Ic = function(a, b, c) {
        var d = this;
        this.ba && Promise.resolve().then(function() {
            "function" === typeof a ? a(U(d)) : "function" === typeof a.next && a.next(U(d));
        });
        return this.Pa(a, b, c);
    };
    k.Hc = function(a, b, c) {
        var d = this;
        this.ba && Promise.resolve().then(function() {
            d.W = d.getUid();
            "function" === typeof a ? a(U(d)) : "function" === typeof a.next && a.next(U(d));
        });
        return this.ib(a, b, c);
    };
    k.nc = function(a) {
        var b = this, c = this.h.then(function() {
            return U(b) ? U(b).I(a).then(function(d) {
                return {
                    accessToken: d
                };
            }) : null;
        });
        return T(this, c);
    };
    k.Tc = function(a) {
        var b = this;
        return this.h.then(function() {
            return Qn(b, O(b.a, Kj, {
                token: a
            }));
        }).then(function(c) {
            var d = c.user;
            bn(d, "isAnonymous", !1);
            b.da(d);
            return c;
        });
    };
    k.Uc = function(a, b) {
        var c = this;
        return this.h.then(function() {
            return Qn(c, O(c.a, ah, {
                email: a,
                password: b
            }));
        });
    };
    k.dc = function(a, b) {
        var c = this;
        return this.h.then(function() {
            return Qn(c, O(c.a, Ej, {
                email: a,
                password: b
            }));
        });
    };
    k.ab = function(a) {
        var b = this;
        return this.h.then(function() {
            return Qn(b, a.ka(b.a));
        });
    };
    k.Sc = function(a) {
        gf("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");
        return this.ab(a);
    };
    k.Ab = function() {
        var a = this;
        return this.h.then(function() {
            var b = U(a);
            if (b && b.isAnonymous) {
                var c = kf({
                    providerId: null,
                    isNewUser: !1
                });
                return kf({
                    user: b,
                    credential: null,
                    additionalUserInfo: c,
                    operationType: "signIn"
                });
            }
            return Qn(a, a.a.Ab()).then(function(d) {
                var e = d.user;
                bn(e, "isAnonymous", !0);
                a.da(e);
                return d;
            });
        });
    };
    function S(a) {
        return a.app;
    }
    function U(a) {
        return a.currentUser;
    }
    k.getUid = function() {
        return U(this) && U(this).uid || null;
    };
    function Wn(a) {
        return U(a) && U(a)._lat || null;
    }
    function Sn(a) {
        if (a.ba) {
            for(var b = 0; b < a.s.length; b++)if (a.s[b]) a.s[b](Wn(a));
            if (a.W !== a.getUid() && a.N.length) {
                for(a.W = a.getUid(), b = 0; b < a.N.length; b++)if (a.N[b]) a.N[b](Wn(a));
            }
        }
    }
    k.cc = function(a) {
        this.addAuthTokenListener(a);
        this.u++;
        0 < this.u && U(this) && Sm(U(this));
    };
    k.Pc = function(a) {
        var b = this;
        w(this.s, function(c) {
            c == a && b.u--;
        });
        0 > this.u && (this.u = 0);
        0 == this.u && U(this) && Tm(U(this));
        this.removeAuthTokenListener(a);
    };
    k.addAuthTokenListener = function(a) {
        var b = this;
        this.s.push(a);
        T(this, this.h.then(function() {
            b.l || Va(b.s, a) && a(Wn(b));
        }));
    };
    k.removeAuthTokenListener = function(a) {
        Xa(this.s, function(b) {
            return b == a;
        });
    };
    function Vn(a, b) {
        a.N.push(b);
        T(a, a.h.then(function() {
            !a.l && Va(a.N, b) && a.W !== a.getUid() && (a.W = a.getUid(), b(Wn(a)));
        }));
    }
    k.delete = function() {
        this.l = !0;
        for(var a = 0; a < this.P.length; a++)this.P[a].cancel("app-deleted");
        this.P = [];
        this.i && (a = this.i, a.b.removeListener(xn("local"), a.a, this.ja));
        this.b && (Ql(this.b, this), $l(this.b.b));
        return Promise.resolve();
    };
    function T(a, b) {
        a.P.push(b);
        b.oa(function() {
            Wa(a.P, b);
        });
        return b;
    }
    k.hc = function(a) {
        return T(this, aj(this.a, a));
    };
    k.Bc = function(a) {
        return !!fh(a);
    };
    k.xb = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            var d = new Sf(b);
            if (!d.c) throw new t("argument-error", $f + " must be true when sending sign in link to email");
            return bg(d);
        }).then(function(d) {
            return c.a.xb(a, d);
        }).then(function() {}));
    };
    k.jd = function(a) {
        return this.Sa(a).then(function(b) {
            return b.data.email;
        });
    };
    k.ob = function(a, b) {
        return T(this, this.a.ob(a, b).then(function() {}));
    };
    k.Sa = function(a) {
        return T(this, this.a.Sa(a).then(function(b) {
            return new vf(b);
        }));
    };
    k.kb = function(a) {
        return T(this, this.a.kb(a).then(function() {}));
    };
    k.wb = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            return "undefined" === typeof b || mb(b) ? {} : bg(new Sf(b));
        }).then(function(d) {
            return c.a.wb(a, d);
        }).then(function() {}));
    };
    k.Wc = function(a, b) {
        return T(this, gm(this, a, b, q(this.ab, this)));
    };
    k.Vc = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            var d = b || re(), e = eh(a, d);
            d = fh(d);
            if (!d) throw new t("argument-error", "Invalid email link!");
            if (d.tenantId !== c.T()) throw new t("tenant-id-mismatch");
            return c.ab(e);
        }));
    };
    function Xn() {}
    Xn.prototype.render = function() {};
    Xn.prototype.reset = function() {};
    Xn.prototype.getResponse = function() {};
    Xn.prototype.execute = function() {};
    function Yn() {
        this.a = {};
        this.b = 1E12;
    }
    var Zn = null;
    Yn.prototype.render = function(a, b) {
        this.a[this.b.toString()] = new $n(a, b);
        return this.b++;
    };
    Yn.prototype.reset = function(a) {
        var b = ao(this, a);
        a = bo(a);
        b && a && (b.delete(), delete this.a[a]);
    };
    Yn.prototype.getResponse = function(a) {
        return (a = ao(this, a)) ? a.getResponse() : null;
    };
    Yn.prototype.execute = function(a) {
        (a = ao(this, a)) && a.execute();
    };
    function ao(a, b) {
        return (b = bo(b)) ? a.a[b] || null : null;
    }
    function bo(a) {
        return (a = "undefined" === typeof a ? 1E12 : a) ? a.toString() : null;
    }
    function $n(a, b) {
        this.g = !1;
        this.c = b;
        this.a = this.b = null;
        this.h = "invisible" !== this.c.size;
        this.f = kc(a);
        var c = this;
        this.i = function() {
            c.execute();
        };
        this.h ? this.execute() : nd(this.f, "click", this.i);
    }
    $n.prototype.getResponse = function() {
        co(this);
        return this.b;
    };
    $n.prototype.execute = function() {
        co(this);
        var a = this;
        this.a || (this.a = setTimeout(function() {
            a.b = Me();
            var b = a.c.callback, c = a.c["expired-callback"];
            if (b) try {
                b(a.b);
            } catch (d) {}
            a.a = setTimeout(function() {
                a.a = null;
                a.b = null;
                if (c) try {
                    c();
                } catch (d) {}
                a.h && a.execute();
            }, 6E4);
        }, 500));
    };
    $n.prototype.delete = function() {
        co(this);
        this.g = !0;
        clearTimeout(this.a);
        this.a = null;
        xd(this.f, "click", this.i);
    };
    function co(a) {
        if (a.g) throw Error("reCAPTCHA mock was already deleted!");
    }
    function eo() {}
    M(eo, "FACTOR_ID", "phone");
    function fo() {}
    fo.prototype.g = function() {
        Zn || (Zn = new Yn);
        return E(Zn);
    };
    fo.prototype.c = function() {};
    var go = null;
    function ho() {
        this.b = l.grecaptcha ? Infinity : 0;
        this.f = null;
        this.a = "__rcb" + Math.floor(1E6 * Math.random()).toString();
    }
    var io = new qb(rb, "https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"), jo = new Ze(3E4, 6E4);
    ho.prototype.g = function(a) {
        var b = this;
        return new D(function(c, d) {
            var e = setTimeout(function() {
                d(new t("network-request-failed"));
            }, jo.get());
            if (!l.grecaptcha || a !== b.f && !b.b) {
                l[b.a] = function() {
                    if (l.grecaptcha) {
                        b.f = a;
                        var g = l.grecaptcha.render;
                        l.grecaptcha.render = function(h, m) {
                            h = g(h, m);
                            b.b++;
                            return h;
                        };
                        clearTimeout(e);
                        c(l.grecaptcha);
                    } else clearTimeout(e), d(new t("internal-error"));
                    delete l[b.a];
                };
                var f = zb(io, {
                    onload: b.a,
                    hl: a || ""
                });
                E(Bi(f)).o(function() {
                    clearTimeout(e);
                    d(new t("internal-error", "Unable to load external reCAPTCHA dependencies!"));
                });
            } else clearTimeout(e), c(l.grecaptcha);
        });
    };
    ho.prototype.c = function() {
        this.b--;
    };
    var ko = null;
    function lo(a, b, c, d, e, f, g) {
        M(this, "type", "recaptcha");
        this.c = this.f = null;
        this.J = !1;
        this.v = b;
        this.g = null;
        g ? (go || (go = new fo), g = go) : (ko || (ko = new ho), g = ko);
        this.m = g;
        this.a = c || {
            theme: "light",
            type: "image"
        };
        this.h = [];
        if (this.a[mo]) throw new t("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");
        this.i = "invisible" === this.a[no];
        if (!l.document) throw new t("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
        if (!kc(b) || !this.i && kc(b).hasChildNodes()) throw new t("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");
        this.s = new Ii(a, f || null, e || null);
        this.u = d || function() {
            return null;
        };
        var h = this;
        this.l = [];
        var m = this.a[oo];
        this.a[oo] = function(v) {
            po(h, v);
            if ("function" === typeof m) m(v);
            else if ("string" === typeof m) {
                var B = L(m, l);
                "function" === typeof B && B(v);
            }
        };
        var p = this.a[qo];
        this.a[qo] = function() {
            po(h, null);
            if ("function" === typeof p) p();
            else if ("string" === typeof p) {
                var v = L(p, l);
                "function" === typeof v && v();
            }
        };
    }
    var oo = "callback", qo = "expired-callback", mo = "sitekey", no = "size";
    function po(a, b) {
        for(var c = 0; c < a.l.length; c++)try {
            a.l[c](b);
        } catch (d) {}
    }
    function ro(a, b) {
        Xa(a.l, function(c) {
            return c == b;
        });
    }
    function so(a, b) {
        a.h.push(b);
        b.oa(function() {
            Wa(a.h, b);
        });
        return b;
    }
    k = lo.prototype;
    k.Ia = function() {
        var a = this;
        return this.f ? this.f : this.f = so(this, E().then(function() {
            if (Se() && !Je()) return Ee();
            throw new t("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
        }).then(function() {
            return a.m.g(a.u());
        }).then(function(b) {
            a.g = b;
            return O(a.s, Jj, {});
        }).then(function(b) {
            a.a[mo] = b.recaptchaSiteKey;
        }).o(function(b) {
            a.f = null;
            throw b;
        }));
    };
    k.render = function() {
        to(this);
        var a = this;
        return so(this, this.Ia().then(function() {
            if (null === a.c) {
                var b = a.v;
                if (!a.i) {
                    var c = kc(b);
                    b = nc("DIV");
                    c.appendChild(b);
                }
                a.c = a.g.render(b, a.a);
            }
            return a.c;
        }));
    };
    k.verify = function() {
        to(this);
        var a = this;
        return so(this, this.render().then(function(b) {
            return new D(function(c) {
                var d = a.g.getResponse(b);
                if (d) c(d);
                else {
                    var e = function(f) {
                        f && (ro(a, e), c(f));
                    };
                    a.l.push(e);
                    a.i && a.g.execute(a.c);
                }
            });
        }));
    };
    k.reset = function() {
        to(this);
        null !== this.c && this.g.reset(this.c);
    };
    function to(a) {
        if (a.J) throw new t("internal-error", "RecaptchaVerifier instance has been destroyed.");
    }
    k.clear = function() {
        to(this);
        this.J = !0;
        this.m.c();
        for(var a = 0; a < this.h.length; a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");
        if (!this.i) {
            a = kc(this.v);
            for(var b; b = a.firstChild;)a.removeChild(b);
        }
    };
    function uo(a, b, c) {
        var d = !1;
        try {
            this.b = c || (0, $8eXKx.default).app();
        } catch (g) {
            throw new t("argument-error", "No firebase.app.App instance is currently initialized.");
        }
        if (this.b.options && this.b.options.apiKey) c = this.b.options.apiKey;
        else throw new t("invalid-api-key");
        var e = this, f = null;
        try {
            f = this.b.auth().Ga();
        } catch (g) {}
        try {
            d = this.b.auth().settings.appVerificationDisabledForTesting;
        } catch (g) {}
        f = (0, $8eXKx.default).SDK_VERSION ? Oe((0, $8eXKx.default).SDK_VERSION, f) : null;
        lo.call(this, c, a, b, function() {
            try {
                var g = e.b.auth().la();
            } catch (h) {
                g = null;
            }
            return g;
        }, f, Ca(Da), d);
    }
    r(uo, lo);
    function vo(a, b, c, d) {
        a: {
            c = Array.prototype.slice.call(c);
            var e = 0;
            for(var f = !1, g = 0; g < b.length; g++)if (b[g].optional) f = !0;
            else {
                if (f) throw new t("internal-error", "Argument validator encountered a required argument after an optional argument.");
                e++;
            }
            f = b.length;
            if (c.length < e || f < c.length) d = "Expected " + (e == f ? 1 == e ? "1 argument" : e + " arguments" : e + "-" + f + " arguments") + " but got " + c.length + ".";
            else {
                for(e = 0; e < c.length; e++)if (f = b[e].optional && void 0 === c[e], !b[e].M(c[e]) && !f) {
                    b = b[e];
                    if (0 > e || e >= wo.length) throw new t("internal-error", "Argument validator received an unsupported number of arguments.");
                    c = wo[e];
                    d = (d ? "" : c + " argument ") + (b.name ? '"' + b.name + '" ' : "") + "must be " + b.K + ".";
                    break a;
                }
                d = null;
            }
        }
        if (d) throw new t("argument-error", a + " failed: " + d);
    }
    var wo = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");
    function V(a, b) {
        return {
            name: a || "",
            K: "a valid string",
            optional: !!b,
            M: function(c) {
                return "string" === typeof c;
            }
        };
    }
    function xo(a, b) {
        return {
            name: a || "",
            K: "a boolean",
            optional: !!b,
            M: function(c) {
                return "boolean" === typeof c;
            }
        };
    }
    function W(a, b) {
        return {
            name: a || "",
            K: "a valid object",
            optional: !!b,
            M: n
        };
    }
    function yo(a, b) {
        return {
            name: a || "",
            K: "a function",
            optional: !!b,
            M: function(c) {
                return "function" === typeof c;
            }
        };
    }
    function zo(a, b) {
        return {
            name: a || "",
            K: "null",
            optional: !!b,
            M: function(c) {
                return null === c;
            }
        };
    }
    function Ao() {
        return {
            name: "",
            K: "an HTML element",
            optional: !1,
            M: function(a) {
                return !!(a && a instanceof Element);
            }
        };
    }
    function Bo() {
        return {
            name: "auth",
            K: "an instance of Firebase Auth",
            optional: !0,
            M: function(a) {
                return !!(a && a instanceof Fn);
            }
        };
    }
    function Co() {
        return {
            name: "app",
            K: "an instance of Firebase App",
            optional: !0,
            M: function(a) {
                return !!(a && a instanceof (0, $8eXKx.default).app.App);
            }
        };
    }
    function Do(a) {
        return {
            name: a ? a + "Credential" : "credential",
            K: a ? "a valid " + a + " credential" : "a valid credential",
            optional: !1,
            M: function(b) {
                if (!b) return !1;
                var c = !a || b.providerId === a;
                return !(!b.ka || !c);
            }
        };
    }
    function Eo() {
        return {
            name: "multiFactorAssertion",
            K: "a valid multiFactorAssertion",
            optional: !1,
            M: function(a) {
                return a ? !!a.tb : !1;
            }
        };
    }
    function Fo() {
        return {
            name: "authProvider",
            K: "a valid Auth provider",
            optional: !1,
            M: function(a) {
                return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
            }
        };
    }
    function Go(a, b) {
        return n(a) && "string" === typeof a.type && a.type === b && "function" === typeof a.Ha;
    }
    function Ho(a) {
        return n(a) && "string" === typeof a.uid;
    }
    function Io() {
        return {
            name: "applicationVerifier",
            K: "an implementation of firebase.auth.ApplicationVerifier",
            optional: !1,
            M: function(a) {
                return !(!a || "string" !== typeof a.type || "function" !== typeof a.verify);
            }
        };
    }
    function X(a, b, c, d) {
        return {
            name: c || "",
            K: a.K + " or " + b.K,
            optional: !!d,
            M: function(e) {
                return a.M(e) || b.M(e);
            }
        };
    }
    function Y(a, b) {
        for(var c in b){
            var d = b[c].name;
            a[d] = Jo(d, a[c], b[c].j);
        }
    }
    function Ko(a, b) {
        for(var c in b){
            var d = b[c].name;
            d !== c && Object.defineProperty(a, d, {
                get: ua(function(e) {
                    return this[e];
                }, c),
                set: ua(function(e, f, g, h) {
                    vo(e, [
                        g
                    ], [
                        h
                    ], !0);
                    this[f] = h;
                }, d, c, b[c].lb),
                enumerable: !0
            });
        }
    }
    function Z(a, b, c, d) {
        a[b] = Jo(b, c, d);
    }
    function Jo(a, b, c) {
        function d() {
            var g = Array.prototype.slice.call(arguments);
            vo(e, c, g);
            return b.apply(this, g);
        }
        if (!c) return b;
        var e = Lo(a), f;
        for(f in b)d[f] = b[f];
        for(f in b.prototype)d.prototype[f] = b.prototype[f];
        return d;
    }
    function Lo(a) {
        a = a.split(".");
        return a[a.length - 1];
    }
    Y(Fn.prototype, {
        kb: {
            name: "applyActionCode",
            j: [
                V("code")
            ]
        },
        Sa: {
            name: "checkActionCode",
            j: [
                V("code")
            ]
        },
        ob: {
            name: "confirmPasswordReset",
            j: [
                V("code"),
                V("newPassword")
            ]
        },
        dc: {
            name: "createUserWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        hc: {
            name: "fetchSignInMethodsForEmail",
            j: [
                V("email")
            ]
        },
        ra: {
            name: "getRedirectResult",
            j: []
        },
        Bc: {
            name: "isSignInWithEmailLink",
            j: [
                V("emailLink")
            ]
        },
        Hc: {
            name: "onAuthStateChanged",
            j: [
                X(W(), yo(), "nextOrObserver"),
                yo("opt_error", !0),
                yo("opt_completed", !0)
            ]
        },
        Ic: {
            name: "onIdTokenChanged",
            j: [
                X(W(), yo(), "nextOrObserver"),
                yo("opt_error", !0),
                yo("opt_completed", !0)
            ]
        },
        wb: {
            name: "sendPasswordResetEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), zo(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        xb: {
            name: "sendSignInLinkToEmail",
            j: [
                V("email"),
                W("actionCodeSettings")
            ]
        },
        yb: {
            name: "setPersistence",
            j: [
                V("persistence")
            ]
        },
        Sc: {
            name: "signInAndRetrieveDataWithCredential",
            j: [
                Do()
            ]
        },
        Ab: {
            name: "signInAnonymously",
            j: []
        },
        ab: {
            name: "signInWithCredential",
            j: [
                Do()
            ]
        },
        Tc: {
            name: "signInWithCustomToken",
            j: [
                V("token")
            ]
        },
        Uc: {
            name: "signInWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        Vc: {
            name: "signInWithEmailLink",
            j: [
                V("email"),
                V("emailLink", !0)
            ]
        },
        Wc: {
            name: "signInWithPhoneNumber",
            j: [
                V("phoneNumber"),
                Io()
            ]
        },
        Xc: {
            name: "signInWithPopup",
            j: [
                Fo()
            ]
        },
        Yc: {
            name: "signInWithRedirect",
            j: [
                Fo()
            ]
        },
        dd: {
            name: "updateCurrentUser",
            j: [
                X(function(a) {
                    return {
                        name: "user",
                        K: "an instance of Firebase User",
                        optional: !!a,
                        M: function(b) {
                            return !!(b && b instanceof Im);
                        }
                    };
                }(), zo(), "user")
            ]
        },
        Bb: {
            name: "signOut",
            j: []
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        fd: {
            name: "useDeviceLanguage",
            j: []
        },
        gd: {
            name: "useEmulator",
            j: [
                V("url"),
                W("options", !0)
            ]
        },
        jd: {
            name: "verifyPasswordResetCode",
            j: [
                V("code")
            ]
        }
    });
    Ko(Fn.prototype, {
        lc: {
            name: "languageCode",
            lb: X(V(), zo(), "languageCode")
        },
        ti: {
            name: "tenantId",
            lb: X(V(), zo(), "tenantId")
        }
    });
    Fn.Persistence = Rk;
    Fn.Persistence.LOCAL = "local";
    Fn.Persistence.SESSION = "session";
    Fn.Persistence.NONE = "none";
    Y(Im.prototype, {
        "delete": {
            name: "delete",
            j: []
        },
        oc: {
            name: "getIdTokenResult",
            j: [
                xo("opt_forceRefresh", !0)
            ]
        },
        I: {
            name: "getIdToken",
            j: [
                xo("opt_forceRefresh", !0)
            ]
        },
        Cc: {
            name: "linkAndRetrieveDataWithCredential",
            j: [
                Do()
            ]
        },
        rb: {
            name: "linkWithCredential",
            j: [
                Do()
            ]
        },
        Dc: {
            name: "linkWithPhoneNumber",
            j: [
                V("phoneNumber"),
                Io()
            ]
        },
        Ec: {
            name: "linkWithPopup",
            j: [
                Fo()
            ]
        },
        Fc: {
            name: "linkWithRedirect",
            j: [
                Fo()
            ]
        },
        Lc: {
            name: "reauthenticateAndRetrieveDataWithCredential",
            j: [
                Do()
            ]
        },
        ub: {
            name: "reauthenticateWithCredential",
            j: [
                Do()
            ]
        },
        Mc: {
            name: "reauthenticateWithPhoneNumber",
            j: [
                V("phoneNumber"),
                Io()
            ]
        },
        Nc: {
            name: "reauthenticateWithPopup",
            j: [
                Fo()
            ]
        },
        Oc: {
            name: "reauthenticateWithRedirect",
            j: [
                Fo()
            ]
        },
        reload: {
            name: "reload",
            j: []
        },
        vb: {
            name: "sendEmailVerification",
            j: [
                X(W("opt_actionCodeSettings", !0), zo(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        cd: {
            name: "unlink",
            j: [
                V("provider")
            ]
        },
        Cb: {
            name: "updateEmail",
            j: [
                V("email")
            ]
        },
        Db: {
            name: "updatePassword",
            j: [
                V("password")
            ]
        },
        ed: {
            name: "updatePhoneNumber",
            j: [
                Do("phone")
            ]
        },
        Eb: {
            name: "updateProfile",
            j: [
                W("profile")
            ]
        },
        Fb: {
            name: "verifyBeforeUpdateEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), zo(null, !0), "opt_actionCodeSettings", !0)
            ]
        }
    });
    Y(Yn.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(Xn.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(D.prototype, {
        oa: {
            name: "finally"
        },
        o: {
            name: "catch"
        },
        then: {
            name: "then"
        }
    });
    Ko(em.prototype, {
        appVerificationDisabled: {
            name: "appVerificationDisabledForTesting",
            lb: xo("appVerificationDisabledForTesting")
        }
    });
    Y(fm.prototype, {
        confirm: {
            name: "confirm",
            j: [
                V("verificationCode")
            ]
        }
    });
    Z(Bg, "fromJSON", function(a) {
        a = "string" === typeof a ? JSON.parse(a) : a;
        for(var b, c = [
            Mg,
            dh,
            kh,
            Jg
        ], d = 0; d < c.length; d++)if (b = c[d](a)) return b;
        return null;
    }, [
        X(V(), W(), "json")
    ]);
    Z(Zg, "credential", function(a, b) {
        return new Yg(a, b);
    }, [
        V("email"),
        V("password")
    ]);
    Y(Yg.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Qg.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Qg, "credential", Rg, [
        X(V(), W(), "token")
    ]);
    Z(Zg, "credentialWithLink", eh, [
        V("email"),
        V("emailLink")
    ]);
    Y(Sg.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Sg, "credential", Tg, [
        X(V(), W(), "token")
    ]);
    Y(Ug.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Ug, "credential", Vg, [
        X(V(), X(W(), zo()), "idToken"),
        X(V(), zo(), "accessToken", !0)
    ]);
    Y(Wg.prototype, {
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Wg, "credential", Xg, [
        X(V(), W(), "token"),
        V("secret", !0)
    ]);
    Y(Pg.prototype, {
        Ca: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        credential: {
            name: "credential",
            j: [
                X(V(), X(W(), zo()), "optionsOrIdToken"),
                X(V(), zo(), "accessToken", !0)
            ]
        },
        Ka: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Y(Kg.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Eg.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Z(lh, "credential", ph, [
        V("verificationId"),
        V("verificationCode")
    ]);
    Y(lh.prototype, {
        gb: {
            name: "verifyPhoneNumber",
            j: [
                X(V(), function(a, b) {
                    return {
                        name: a || "phoneInfoOptions",
                        K: "valid phone info options",
                        optional: !!b,
                        M: function(c) {
                            return c ? c.session && c.phoneNumber ? Go(c.session, zg) && "string" === typeof c.phoneNumber : c.session && c.multiFactorHint ? Go(c.session, Ag) && Ho(c.multiFactorHint) : c.session && c.multiFactorUid ? Go(c.session, Ag) && "string" === typeof c.multiFactorUid : c.phoneNumber ? "string" === typeof c.phoneNumber : !1 : !1;
                        }
                    };
                }(), "phoneInfoOptions"),
                Io()
            ]
        }
    });
    Y(gh.prototype, {
        w: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(t.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(yh.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(xh.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(lm.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(im.prototype, {
        Rc: {
            name: "resolveSignIn",
            j: [
                Eo()
            ]
        }
    });
    Y(tm.prototype, {
        Sb: {
            name: "getSession",
            j: []
        },
        fc: {
            name: "enroll",
            j: [
                Eo(),
                V("displayName", !0)
            ]
        },
        bd: {
            name: "unenroll",
            j: [
                X({
                    name: "multiFactorInfo",
                    K: "a valid multiFactorInfo",
                    optional: !1,
                    M: Ho
                }, V(), "multiFactorInfoIdentifier")
            ]
        }
    });
    Y(uo.prototype, {
        clear: {
            name: "clear",
            j: []
        },
        render: {
            name: "render",
            j: []
        },
        verify: {
            name: "verify",
            j: []
        }
    });
    Z(Jf, "parseLink", Rf, [
        V("link")
    ]);
    Z(eo, "assertion", function(a) {
        return new rm(a);
    }, [
        Do("phone")
    ]);
    (function() {
        if ("undefined" !== typeof (0, $8eXKx.default) && (0, $8eXKx.default).INTERNAL && (0, $8eXKx.default).INTERNAL.registerComponent) {
            var a = {
                ActionCodeInfo: {
                    Operation: {
                        EMAIL_SIGNIN: Af,
                        PASSWORD_RESET: "PASSWORD_RESET",
                        RECOVER_EMAIL: "RECOVER_EMAIL",
                        REVERT_SECOND_FACTOR_ADDITION: Cf,
                        VERIFY_AND_CHANGE_EMAIL: Bf,
                        VERIFY_EMAIL: "VERIFY_EMAIL"
                    }
                },
                Auth: Fn,
                AuthCredential: Bg,
                Error: t
            };
            Z(a, "EmailAuthProvider", Zg, []);
            Z(a, "FacebookAuthProvider", Qg, []);
            Z(a, "GithubAuthProvider", Sg, []);
            Z(a, "GoogleAuthProvider", Ug, []);
            Z(a, "TwitterAuthProvider", Wg, []);
            Z(a, "OAuthProvider", Pg, [
                V("providerId")
            ]);
            Z(a, "SAMLAuthProvider", Og, [
                V("providerId")
            ]);
            Z(a, "PhoneAuthProvider", lh, [
                Bo()
            ]);
            Z(a, "RecaptchaVerifier", uo, [
                X(V(), Ao(), "recaptchaContainer"),
                W("recaptchaParameters", !0),
                Co()
            ]);
            Z(a, "ActionCodeURL", Jf, []);
            Z(a, "PhoneMultiFactorGenerator", eo, []);
            (0, $8eXKx.default).INTERNAL.registerComponent({
                name: "auth",
                instanceFactory: function(b) {
                    b = b.getProvider("app").getImmediate();
                    return new Fn(b);
                },
                multipleInstances: !1,
                serviceProps: a,
                instantiationMode: "LAZY",
                type: "PUBLIC",
                onInstanceCreated: function(b) {
                    b.getProvider("auth-internal").initialize();
                }
            });
            (0, $8eXKx.default).INTERNAL.registerComponent({
                name: "auth-internal",
                instanceFactory: function(b) {
                    b = b.getProvider("auth").getImmediate();
                    return {
                        getUid: q(b.getUid, b),
                        getToken: q(b.nc, b),
                        addAuthTokenListener: q(b.cc, b),
                        removeAuthTokenListener: q(b.Pc, b)
                    };
                },
                multipleInstances: !1,
                instantiationMode: "LAZY",
                type: "PRIVATE"
            });
            (0, $8eXKx.default).registerVersion("@firebase/auth", "0.16.8");
            (0, $8eXKx.default).INTERNAL.extendNamespace({
                User: Im
            });
        } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
    })();
}).apply(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});

});


parcelRequire.register("b094N", function(module, exports) {
(function() {
    // nb. This is for IE10 and lower _only_.
    var supportCustomEvent = window.CustomEvent;
    if (!supportCustomEvent || typeof supportCustomEvent === "object") {
        supportCustomEvent = function CustomEvent(event, x) {
            x = x || {};
            var ev = document.createEvent("CustomEvent");
            ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
            return ev;
        };
        supportCustomEvent.prototype = window.Event.prototype;
    }
    /**
   * @param {Element} el to check for stacking context
   * @return {boolean} whether this el or its parents creates a stacking context
   */ function createsStackingContext(el) {
        while(el && el !== document.body){
            var s = window.getComputedStyle(el);
            var invalid = function(k, ok) {
                return !(s[k] === undefined || s[k] === ok);
            };
            if (s.opacity < 1 || invalid("zIndex", "auto") || invalid("transform", "none") || invalid("mixBlendMode", "normal") || invalid("filter", "none") || invalid("perspective", "none") || s["isolation"] === "isolate" || s.position === "fixed" || s.webkitOverflowScrolling === "touch") return true;
            el = el.parentElement;
        }
        return false;
    }
    /**
   * Finds the nearest <dialog> from the passed element.
   *
   * @param {Element} el to search from
   * @return {HTMLDialogElement} dialog found
   */ function findNearestDialog(el) {
        while(el){
            if (el.localName === "dialog") return /** @type {HTMLDialogElement} */ el;
            el = el.parentElement;
        }
        return null;
    }
    /**
   * Blur the specified element, as long as it's not the HTML body element.
   * This works around an IE9/10 bug - blurring the body causes Windows to
   * blur the whole application.
   *
   * @param {Element} el to blur
   */ function safeBlur(el) {
        if (el && el.blur && el !== document.body) el.blur();
    }
    /**
   * @param {!NodeList} nodeList to search
   * @param {Node} node to find
   * @return {boolean} whether node is inside nodeList
   */ function inNodeList(nodeList, node) {
        for(var i = 0; i < nodeList.length; ++i){
            if (nodeList[i] === node) return true;
        }
        return false;
    }
    /**
   * @param {HTMLFormElement} el to check
   * @return {boolean} whether this form has method="dialog"
   */ function isFormMethodDialog(el) {
        if (!el || !el.hasAttribute("method")) return false;
        return el.getAttribute("method").toLowerCase() === "dialog";
    }
    /**
   * @param {!HTMLDialogElement} dialog to upgrade
   * @constructor
   */ function dialogPolyfillInfo(dialog) {
        this.dialog_ = dialog;
        this.replacedStyleTop_ = false;
        this.openAsModal_ = false;
        // Set a11y role. Browsers that support dialog implicitly know this already.
        if (!dialog.hasAttribute("role")) dialog.setAttribute("role", "dialog");
        dialog.show = this.show.bind(this);
        dialog.showModal = this.showModal.bind(this);
        dialog.close = this.close.bind(this);
        if (!("returnValue" in dialog)) dialog.returnValue = "";
        if ("MutationObserver" in window) {
            var mo = new MutationObserver(this.maybeHideModal.bind(this));
            mo.observe(dialog, {
                attributes: true,
                attributeFilter: [
                    "open"
                ]
            });
        } else {
            // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
            // seem to fire even if the element was removed as part of a parent removal. Use the removed
            // events to force downgrade (useful if removed/immediately added).
            var removed = false;
            var cb = (function() {
                removed ? this.downgradeModal() : this.maybeHideModal();
                removed = false;
            }).bind(this);
            var timeout;
            var delayModel = function(ev) {
                if (ev.target !== dialog) return;
                 // not for a child element
                var cand = "DOMNodeRemoved";
                removed |= ev.type.substr(0, cand.length) === cand;
                window.clearTimeout(timeout);
                timeout = window.setTimeout(cb, 0);
            };
            [
                "DOMAttrModified",
                "DOMNodeRemoved",
                "DOMNodeRemovedFromDocument"
            ].forEach(function(name) {
                dialog.addEventListener(name, delayModel);
            });
        }
        // Note that the DOM is observed inside DialogManager while any dialog
        // is being displayed as a modal, to catch modal removal from the DOM.
        Object.defineProperty(dialog, "open", {
            set: this.setOpen.bind(this),
            get: dialog.hasAttribute.bind(dialog, "open")
        });
        this.backdrop_ = document.createElement("div");
        this.backdrop_.className = "backdrop";
        this.backdrop_.addEventListener("click", this.backdropClick_.bind(this));
    }
    dialogPolyfillInfo.prototype = {
        get dialog () {
            return this.dialog_;
        },
        /**
     * Maybe remove this dialog from the modal top layer. This is called when
     * a modal dialog may no longer be tenable, e.g., when the dialog is no
     * longer open or is no longer part of the DOM.
     */ maybeHideModal: function() {
            if (this.dialog_.hasAttribute("open") && document.body.contains(this.dialog_)) return;
            this.downgradeModal();
        },
        /**
     * Remove this dialog from the modal top layer, leaving it as a non-modal.
     */ downgradeModal: function() {
            if (!this.openAsModal_) return;
            this.openAsModal_ = false;
            this.dialog_.style.zIndex = "";
            // This won't match the native <dialog> exactly because if the user set top on a centered
            // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
            // possible to polyfill this perfectly.
            if (this.replacedStyleTop_) {
                this.dialog_.style.top = "";
                this.replacedStyleTop_ = false;
            }
            // Clear the backdrop and remove from the manager.
            this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
            dialogPolyfill.dm.removeDialog(this);
        },
        /**
     * @param {boolean} value whether to open or close this dialog
     */ setOpen: function(value) {
            if (value) this.dialog_.hasAttribute("open") || this.dialog_.setAttribute("open", "");
            else {
                this.dialog_.removeAttribute("open");
                this.maybeHideModal(); // nb. redundant with MutationObserver
            }
        },
        /**
     * Handles clicks on the fake .backdrop element, redirecting them as if
     * they were on the dialog itself.
     *
     * @param {!Event} e to redirect
     */ backdropClick_: function(e) {
            if (!this.dialog_.hasAttribute("tabindex")) {
                // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
                // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
                // would not be needed - clicks would move the implicit cursor there.
                var fake = document.createElement("div");
                this.dialog_.insertBefore(fake, this.dialog_.firstChild);
                fake.tabIndex = -1;
                fake.focus();
                this.dialog_.removeChild(fake);
            } else this.dialog_.focus();
            var redirectedEvent = document.createEvent("MouseEvents");
            redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
            this.dialog_.dispatchEvent(redirectedEvent);
            e.stopPropagation();
        },
        /**
     * Focuses on the first focusable element within the dialog. This will always blur the current
     * focus, even if nothing within the dialog is found.
     */ focus_: function() {
            // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
            var target = this.dialog_.querySelector("[autofocus]:not([disabled])");
            if (!target && this.dialog_.tabIndex >= 0) target = this.dialog_;
            if (!target) {
                // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
                // alternative involves stepping through and trying to focus everything.
                var opts = [
                    "button",
                    "input",
                    "keygen",
                    "select",
                    "textarea"
                ];
                var query = opts.map(function(el) {
                    return el + ":not([disabled])";
                });
                // TODO(samthor): tabindex values that are not numeric are not focusable.
                query.push('[tabindex]:not([disabled]):not([tabindex=""])'); // tabindex != "", not disabled
                target = this.dialog_.querySelector(query.join(", "));
            }
            safeBlur(document.activeElement);
            target && target.focus();
        },
        /**
     * Sets the zIndex for the backdrop and dialog.
     *
     * @param {number} dialogZ
     * @param {number} backdropZ
     */ updateZIndex: function(dialogZ, backdropZ) {
            if (dialogZ < backdropZ) throw new Error("dialogZ should never be < backdropZ");
            this.dialog_.style.zIndex = dialogZ;
            this.backdrop_.style.zIndex = backdropZ;
        },
        /**
     * Shows the dialog. If the dialog is already open, this does nothing.
     */ show: function() {
            if (!this.dialog_.open) {
                this.setOpen(true);
                this.focus_();
            }
        },
        /**
     * Show this dialog modally.
     */ showModal: function() {
            if (this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");
            if (!document.body.contains(this.dialog_)) throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
            if (!dialogPolyfill.dm.pushDialog(this)) throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");
            if (createsStackingContext(this.dialog_.parentElement)) console.warn("A dialog is being shown inside a stacking context. This may cause it to be unusable. For more information, see this link: https://github.com/GoogleChrome/dialog-polyfill/#stacking-context");
            this.setOpen(true);
            this.openAsModal_ = true;
            // Optionally center vertically, relative to the current viewport.
            if (dialogPolyfill.needsCentering(this.dialog_)) {
                dialogPolyfill.reposition(this.dialog_);
                this.replacedStyleTop_ = true;
            } else this.replacedStyleTop_ = false;
            // Insert backdrop.
            this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);
            // Focus on whatever inside the dialog.
            this.focus_();
        },
        /**
     * Closes this HTMLDialogElement. This is optional vs clearing the open
     * attribute, however this fires a 'close' event.
     *
     * @param {string=} opt_returnValue to use as the returnValue
     */ close: function(opt_returnValue) {
            if (!this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");
            this.setOpen(false);
            // Leave returnValue untouched in case it was set directly on the element
            if (opt_returnValue !== undefined) this.dialog_.returnValue = opt_returnValue;
            // Triggering "close" event for any attached listeners on the <dialog>.
            var closeEvent = new supportCustomEvent("close", {
                bubbles: false,
                cancelable: false
            });
            this.dialog_.dispatchEvent(closeEvent);
        }
    };
    var dialogPolyfill = {};
    dialogPolyfill.reposition = function(element) {
        var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
        element.style.top = Math.max(scrollTop, topValue) + "px";
    };
    dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
        for(var i = 0; i < document.styleSheets.length; ++i){
            var styleSheet = document.styleSheets[i];
            var cssRules = null;
            // Some browsers throw on cssRules.
            try {
                cssRules = styleSheet.cssRules;
            } catch (e) {}
            if (!cssRules) continue;
            for(var j = 0; j < cssRules.length; ++j){
                var rule = cssRules[j];
                var selectedNodes = null;
                // Ignore errors on invalid selector texts.
                try {
                    selectedNodes = document.querySelectorAll(rule.selectorText);
                } catch (e) {}
                if (!selectedNodes || !inNodeList(selectedNodes, element)) continue;
                var cssTop = rule.style.getPropertyValue("top");
                var cssBottom = rule.style.getPropertyValue("bottom");
                if (cssTop && cssTop !== "auto" || cssBottom && cssBottom !== "auto") return true;
            }
        }
        return false;
    };
    dialogPolyfill.needsCentering = function(dialog) {
        var computedStyle = window.getComputedStyle(dialog);
        if (computedStyle.position !== "absolute") return false;
        // We must determine whether the top/bottom specified value is non-auto.  In
        // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
        // Firefox returns the used value. So we do this crazy thing instead: check
        // the inline style and then go through CSS rules.
        if (dialog.style.top !== "auto" && dialog.style.top !== "" || dialog.style.bottom !== "auto" && dialog.style.bottom !== "") return false;
        return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
    };
    /**
   * @param {!Element} element to force upgrade
   */ dialogPolyfill.forceRegisterDialog = function(element) {
        if (window.HTMLDialogElement || element.showModal) console.warn("This browser already supports <dialog>, the polyfill may not work correctly", element);
        if (element.localName !== "dialog") throw new Error("Failed to register dialog: The element is not a dialog.");
        new dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ element);
    };
    /**
   * @param {!Element} element to upgrade, if necessary
   */ dialogPolyfill.registerDialog = function(element) {
        if (!element.showModal) dialogPolyfill.forceRegisterDialog(element);
    };
    /**
   * @constructor
   */ dialogPolyfill.DialogManager = function() {
        /** @type {!Array<!dialogPolyfillInfo>} */ this.pendingDialogStack = [];
        var checkDOM = this.checkDOM_.bind(this);
        // The overlay is used to simulate how a modal dialog blocks the document.
        // The blocking dialog is positioned on top of the overlay, and the rest of
        // the dialogs on the pending dialog stack are positioned below it. In the
        // actual implementation, the modal dialog stacking is controlled by the
        // top layer, where z-index has no effect.
        this.overlay = document.createElement("div");
        this.overlay.className = "_dialog_overlay";
        this.overlay.addEventListener("click", (function(e) {
            this.forwardTab_ = undefined;
            e.stopPropagation();
            checkDOM([]); // sanity-check DOM
        }).bind(this));
        this.handleKey_ = this.handleKey_.bind(this);
        this.handleFocus_ = this.handleFocus_.bind(this);
        this.zIndexLow_ = 100000;
        this.zIndexHigh_ = 100150;
        this.forwardTab_ = undefined;
        if ("MutationObserver" in window) this.mo_ = new MutationObserver(function(records) {
            var removed = [];
            records.forEach(function(rec) {
                for(var i = 0, c; c = rec.removedNodes[i]; ++i){
                    if (!(c instanceof Element)) continue;
                    else if (c.localName === "dialog") removed.push(c);
                    removed = removed.concat(c.querySelectorAll("dialog"));
                }
            });
            removed.length && checkDOM(removed);
        });
    };
    /**
   * Called on the first modal dialog being shown. Adds the overlay and related
   * handlers.
   */ dialogPolyfill.DialogManager.prototype.blockDocument = function() {
        document.documentElement.addEventListener("focus", this.handleFocus_, true);
        document.addEventListener("keydown", this.handleKey_);
        this.mo_ && this.mo_.observe(document, {
            childList: true,
            subtree: true
        });
    };
    /**
   * Called on the first modal dialog being removed, i.e., when no more modal
   * dialogs are visible.
   */ dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
        document.documentElement.removeEventListener("focus", this.handleFocus_, true);
        document.removeEventListener("keydown", this.handleKey_);
        this.mo_ && this.mo_.disconnect();
    };
    /**
   * Updates the stacking of all known dialogs.
   */ dialogPolyfill.DialogManager.prototype.updateStacking = function() {
        var zIndex = this.zIndexHigh_;
        for(var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i){
            dpi.updateZIndex(--zIndex, --zIndex);
            if (i === 0) this.overlay.style.zIndex = --zIndex;
        }
        // Make the overlay a sibling of the dialog itself.
        var last = this.pendingDialogStack[0];
        if (last) {
            var p = last.dialog.parentNode || document.body;
            p.appendChild(this.overlay);
        } else if (this.overlay.parentNode) this.overlay.parentNode.removeChild(this.overlay);
    };
    /**
   * @param {Element} candidate to check if contained or is the top-most modal dialog
   * @return {boolean} whether candidate is contained in top dialog
   */ dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
        while(candidate = findNearestDialog(candidate)){
            for(var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i){
                if (dpi.dialog === candidate) return i === 0; // only valid if top-most
            }
            candidate = candidate.parentElement;
        }
        return false;
    };
    dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
        if (this.containedByTopDialog_(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        safeBlur(/** @type {Element} */ event.target);
        if (this.forwardTab_ === undefined) return;
         // move focus only from a tab key
        var dpi = this.pendingDialogStack[0];
        var dialog = dpi.dialog;
        var position = dialog.compareDocumentPosition(event.target);
        if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            if (this.forwardTab_) dpi.focus_();
            else document.documentElement.focus();
        } else ;
        return false;
    };
    dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
        this.forwardTab_ = undefined;
        if (event.keyCode === 27) {
            event.preventDefault();
            event.stopPropagation();
            var cancelEvent = new supportCustomEvent("cancel", {
                bubbles: false,
                cancelable: true
            });
            var dpi = this.pendingDialogStack[0];
            if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) dpi.dialog.close();
        } else if (event.keyCode === 9) this.forwardTab_ = !event.shiftKey;
    };
    /**
   * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
   * removed and immediately readded don't stay modal, they become normal.
   *
   * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
   */ dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
        // This operates on a clone because it may cause it to change. Each change also calls
        // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
        // at a time?!
        var clone = this.pendingDialogStack.slice();
        clone.forEach(function(dpi) {
            if (removed.indexOf(dpi.dialog) !== -1) dpi.downgradeModal();
            else dpi.maybeHideModal();
        });
    };
    /**
   * @param {!dialogPolyfillInfo} dpi
   * @return {boolean} whether the dialog was allowed
   */ dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
        var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
        if (this.pendingDialogStack.length >= allowed) return false;
        if (this.pendingDialogStack.unshift(dpi) === 1) this.blockDocument();
        this.updateStacking();
        return true;
    };
    /**
   * @param {!dialogPolyfillInfo} dpi
   */ dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
        var index = this.pendingDialogStack.indexOf(dpi);
        if (index === -1) return;
        this.pendingDialogStack.splice(index, 1);
        if (this.pendingDialogStack.length === 0) this.unblockDocument();
        this.updateStacking();
    };
    dialogPolyfill.dm = new dialogPolyfill.DialogManager();
    dialogPolyfill.formSubmitter = null;
    dialogPolyfill.useValue = null;
    /**
   * Installs global handlers, such as click listers and native method overrides. These are needed
   * even if a no dialog is registered, as they deal with <form method="dialog">.
   */ if (window.HTMLDialogElement === undefined) {
        /**
     * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
     * one that returns the correct value.
     */ var testForm = document.createElement("form");
        testForm.setAttribute("method", "dialog");
        if (testForm.method !== "dialog") {
            var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "method");
            if (methodDescriptor) {
                // nb. Some older iOS and older PhantomJS fail to return the descriptor. Don't do anything
                // and don't bother to update the element.
                var realGet = methodDescriptor.get;
                methodDescriptor.get = function() {
                    if (isFormMethodDialog(this)) return "dialog";
                    return realGet.call(this);
                };
                var realSet = methodDescriptor.set;
                methodDescriptor.set = function(v) {
                    if (typeof v === "string" && v.toLowerCase() === "dialog") return this.setAttribute("method", v);
                    return realSet.call(this, v);
                };
                Object.defineProperty(HTMLFormElement.prototype, "method", methodDescriptor);
            }
        }
        /**
     * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
     * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
     * document.activeElement.
     */ document.addEventListener("click", function(ev) {
            dialogPolyfill.formSubmitter = null;
            dialogPolyfill.useValue = null;
            if (ev.defaultPrevented) return;
             // e.g. a submit which prevents default submission
            var target = /** @type {Element} */ ev.target;
            if (!target || !isFormMethodDialog(target.form)) return;
            var valid = target.type === "submit" && [
                "button",
                "input"
            ].indexOf(target.localName) > -1;
            if (!valid) {
                if (!(target.localName === "input" && target.type === "image")) return;
                // this is a <input type="image">, which can submit forms
                dialogPolyfill.useValue = ev.offsetX + "," + ev.offsetY;
            }
            var dialog = findNearestDialog(target);
            if (!dialog) return;
            dialogPolyfill.formSubmitter = target;
        }, false);
        /**
     * Replace the native HTMLFormElement.submit() method, as it won't fire the
     * submit event and give us a chance to respond.
     */ var nativeFormSubmit = HTMLFormElement.prototype.submit;
        var replacementFormSubmit = function() {
            if (!isFormMethodDialog(this)) return nativeFormSubmit.call(this);
            var dialog = findNearestDialog(this);
            dialog && dialog.close();
        };
        HTMLFormElement.prototype.submit = replacementFormSubmit;
        /**
     * Global form 'dialog' method handler. Closes a dialog correctly on submit
     * and possibly sets its return value.
     */ document.addEventListener("submit", function(ev) {
            var form = /** @type {HTMLFormElement} */ ev.target;
            if (!isFormMethodDialog(form)) return;
            ev.preventDefault();
            var dialog = findNearestDialog(form);
            if (!dialog) return;
            // Forms can only be submitted via .submit() or a click (?), but anyway: sanity-check that
            // the submitter is correct before using its value as .returnValue.
            var s = dialogPolyfill.formSubmitter;
            if (s && s.form === form) dialog.close(dialogPolyfill.useValue || s.value);
            else dialog.close();
            dialogPolyfill.formSubmitter = null;
        }, true);
    }
    dialogPolyfill["forceRegisterDialog"] = dialogPolyfill.forceRegisterDialog;
    dialogPolyfill["registerDialog"] = dialogPolyfill.registerDialog;
    if (typeof define === "function" && "amd" in define) // AMD support
    define(function() {
        return dialogPolyfill;
    });
    else if (typeof module.exports === "object") // CommonJS support
    module.exports = dialogPolyfill;
    else // all others
    window["dialogPolyfill"] = dialogPolyfill;
})();

});

parcelRequire.register("5cupn", function(module, exports) {
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A component handler interface using the revealing module design pattern.
 * More details on this design pattern here:
 * https://github.com/jasonmayes/mdl-component-design-pattern
 *
 * @author Jason Mayes.
 */ /* exported componentHandler */ // Pre-defining the componentHandler interface, for closure documentation and
// static verification.
var $3c95a930df53fbca$var$componentHandler = {
    /**
   * Searches existing DOM for elements of our component type and upgrades them
   * if they have not already been upgraded.
   *
   * @param {string=} optJsClass the programatic name of the element class we
   * need to create a new instance of.
   * @param {string=} optCssClass the name of the CSS class elements of this
   * type will have.
   */ upgradeDom: function(optJsClass, optCssClass) {},
    /**
   * Upgrades a specific element rather than all in the DOM.
   *
   * @param {!Element} element The element we wish to upgrade.
   * @param {string=} optJsClass Optional name of the class we want to upgrade
   * the element to.
   */ upgradeElement: function(element, optJsClass) {},
    /**
   * Upgrades a specific list of elements rather than all in the DOM.
   *
   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
   * The elements we wish to upgrade.
   */ upgradeElements: function(elements) {},
    /**
   * Upgrades all registered components found in the current DOM. This is
   * automatically called on window load.
   */ upgradeAllRegistered: function() {},
    /**
   * Allows user to be alerted to any upgrades that are performed for a given
   * component type
   *
   * @param {string} jsClass The class name of the MDL component we wish
   * to hook into for any upgrades performed.
   * @param {function(!HTMLElement)} callback The function to call upon an
   * upgrade. This function should expect 1 parameter - the HTMLElement which
   * got upgraded.
   */ registerUpgradedCallback: function(jsClass, callback) {},
    /**
   * Registers a class for future use and attempts to upgrade existing DOM.
   *
   * @param {componentHandler.ComponentConfigPublic} config the registration configuration
   */ register: function(config) {},
    /**
   * Downgrade either a given node, an array of nodes, or a NodeList.
   *
   * @param {!Node|!Array<!Node>|!NodeList} nodes
   */ downgradeElements: function(nodes) {}
};
$3c95a930df53fbca$var$componentHandler = function() {
    "use strict";
    /** @type {!Array<componentHandler.ComponentConfig>} */ var registeredComponents_ = [];
    /** @type {!Array<componentHandler.Component>} */ var createdComponents_ = [];
    var componentConfigProperty_ = "mdlComponentConfigInternal_";
    /**
   * Searches registered components for a class we are interested in using.
   * Optionally replaces a match with passed object if specified.
   *
   * @param {string} name The name of a class we want to use.
   * @param {componentHandler.ComponentConfig=} optReplace Optional object to replace match with.
   * @return {!Object|boolean}
   * @private
   */ function findRegisteredClass_(name, optReplace) {
        for(var i = 0; i < registeredComponents_.length; i++)if (registeredComponents_[i].className === name) {
            if (typeof optReplace !== "undefined") registeredComponents_[i] = optReplace;
            return registeredComponents_[i];
        }
        return false;
    }
    /**
   * Returns an array of the classNames of the upgraded classes on the element.
   *
   * @param {!Element} element The element to fetch data from.
   * @return {!Array<string>}
   * @private
   */ function getUpgradedListOfElement_(element) {
        var dataUpgraded = element.getAttribute("data-upgraded");
        // Use `['']` as default value to conform the `,name,name...` style.
        return dataUpgraded === null ? [
            ""
        ] : dataUpgraded.split(",");
    }
    /**
   * Returns true if the given element has already been upgraded for the given
   * class.
   *
   * @param {!Element} element The element we want to check.
   * @param {string} jsClass The class to check for.
   * @returns {boolean}
   * @private
   */ function isElementUpgraded_(element, jsClass) {
        var upgradedList = getUpgradedListOfElement_(element);
        return upgradedList.indexOf(jsClass) !== -1;
    }
    /**
   * Create an event object.
   *
   * @param {string} eventType The type name of the event.
   * @param {boolean} bubbles Whether the event should bubble up the DOM.
   * @param {boolean} cancelable Whether the event can be canceled.
   * @returns {!Event}
   */ function createEvent_(eventType, bubbles, cancelable) {
        if ("CustomEvent" in window && typeof window.CustomEvent === "function") return new CustomEvent(eventType, {
            bubbles: bubbles,
            cancelable: cancelable
        });
        else {
            var ev = document.createEvent("Events");
            ev.initEvent(eventType, bubbles, cancelable);
            return ev;
        }
    }
    /**
   * Searches existing DOM for elements of our component type and upgrades them
   * if they have not already been upgraded.
   *
   * @param {string=} optJsClass the programatic name of the element class we
   * need to create a new instance of.
   * @param {string=} optCssClass the name of the CSS class elements of this
   * type will have.
   */ function upgradeDomInternal(optJsClass, optCssClass) {
        if (typeof optJsClass === "undefined" && typeof optCssClass === "undefined") for(var i = 0; i < registeredComponents_.length; i++)upgradeDomInternal(registeredComponents_[i].className, registeredComponents_[i].cssClass);
        else {
            var jsClass = /** @type {string} */ optJsClass;
            if (typeof optCssClass === "undefined") {
                var registeredClass = findRegisteredClass_(jsClass);
                if (registeredClass) optCssClass = registeredClass.cssClass;
            }
            var elements = document.querySelectorAll("." + optCssClass);
            for(var n = 0; n < elements.length; n++)upgradeElementInternal(elements[n], jsClass);
        }
    }
    /**
   * Upgrades a specific element rather than all in the DOM.
   *
   * @param {!Element} element The element we wish to upgrade.
   * @param {string=} optJsClass Optional name of the class we want to upgrade
   * the element to.
   */ function upgradeElementInternal(element, optJsClass) {
        // Verify argument type.
        if (!(typeof element === "object" && element instanceof Element)) throw new Error("Invalid argument provided to upgrade MDL element.");
        // Allow upgrade to be canceled by canceling emitted event.
        var upgradingEv = createEvent_("mdl-componentupgrading", true, true);
        element.dispatchEvent(upgradingEv);
        if (upgradingEv.defaultPrevented) return;
        var upgradedList = getUpgradedListOfElement_(element);
        var classesToUpgrade = [];
        // If jsClass is not provided scan the registered components to find the
        // ones matching the element's CSS classList.
        if (!optJsClass) {
            var classList = element.classList;
            registeredComponents_.forEach(function(component) {
                // Match CSS & Not to be upgraded & Not upgraded.
                if (classList.contains(component.cssClass) && classesToUpgrade.indexOf(component) === -1 && !isElementUpgraded_(element, component.className)) classesToUpgrade.push(component);
            });
        } else if (!isElementUpgraded_(element, optJsClass)) classesToUpgrade.push(findRegisteredClass_(optJsClass));
        // Upgrade the element for each classes.
        for(var i = 0, n = classesToUpgrade.length, registeredClass; i < n; i++){
            registeredClass = classesToUpgrade[i];
            if (registeredClass) {
                // Mark element as upgraded.
                upgradedList.push(registeredClass.className);
                element.setAttribute("data-upgraded", upgradedList.join(","));
                var instance = new registeredClass.classConstructor(element);
                instance[componentConfigProperty_] = registeredClass;
                createdComponents_.push(instance);
                // Call any callbacks the user has registered with this component type.
                for(var j = 0, m = registeredClass.callbacks.length; j < m; j++)registeredClass.callbacks[j](element);
                if (registeredClass.widget) // Assign per element instance for control over API
                element[registeredClass.className] = instance;
            } else throw new Error("Unable to find a registered component for the given class.");
            var upgradedEv = createEvent_("mdl-componentupgraded", true, false);
            element.dispatchEvent(upgradedEv);
        }
    }
    /**
   * Upgrades a specific list of elements rather than all in the DOM.
   *
   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
   * The elements we wish to upgrade.
   */ function upgradeElementsInternal(elements) {
        if (!Array.isArray(elements)) {
            if (elements instanceof Element) elements = [
                elements
            ];
            else elements = Array.prototype.slice.call(elements);
        }
        for(var i = 0, n = elements.length, element; i < n; i++){
            element = elements[i];
            if (element instanceof HTMLElement) {
                upgradeElementInternal(element);
                if (element.children.length > 0) upgradeElementsInternal(element.children);
            }
        }
    }
    /**
   * Registers a class for future use and attempts to upgrade existing DOM.
   *
   * @param {componentHandler.ComponentConfigPublic} config
   */ function registerInternal(config) {
        // In order to support both Closure-compiled and uncompiled code accessing
        // this method, we need to allow for both the dot and array syntax for
        // property access. You'll therefore see the `foo.bar || foo['bar']`
        // pattern repeated across this method.
        var widgetMissing = typeof config.widget === "undefined" && typeof config["widget"] === "undefined";
        var widget = true;
        if (!widgetMissing) widget = config.widget || config["widget"];
        var newConfig = /** @type {componentHandler.ComponentConfig} */ {
            classConstructor: config.constructor || config["constructor"],
            className: config.classAsString || config["classAsString"],
            cssClass: config.cssClass || config["cssClass"],
            widget: widget,
            callbacks: []
        };
        registeredComponents_.forEach(function(item) {
            if (item.cssClass === newConfig.cssClass) throw new Error("The provided cssClass has already been registered: " + item.cssClass);
            if (item.className === newConfig.className) throw new Error("The provided className has already been registered");
        });
        if (config.constructor.prototype.hasOwnProperty(componentConfigProperty_)) throw new Error("MDL component classes must not have " + componentConfigProperty_ + " defined as a property.");
        var found = findRegisteredClass_(config.classAsString, newConfig);
        if (!found) registeredComponents_.push(newConfig);
    }
    /**
   * Allows user to be alerted to any upgrades that are performed for a given
   * component type
   *
   * @param {string} jsClass The class name of the MDL component we wish
   * to hook into for any upgrades performed.
   * @param {function(!HTMLElement)} callback The function to call upon an
   * upgrade. This function should expect 1 parameter - the HTMLElement which
   * got upgraded.
   */ function registerUpgradedCallbackInternal(jsClass, callback) {
        var regClass = findRegisteredClass_(jsClass);
        if (regClass) regClass.callbacks.push(callback);
    }
    /**
   * Upgrades all registered components found in the current DOM. This is
   * automatically called on window load.
   */ function upgradeAllRegisteredInternal() {
        for(var n = 0; n < registeredComponents_.length; n++)upgradeDomInternal(registeredComponents_[n].className);
    }
    /**
   * Check the component for the downgrade method.
   * Execute if found.
   * Remove component from createdComponents list.
   *
   * @param {?componentHandler.Component} component
   */ function deconstructComponentInternal(component) {
        if (component) {
            var componentIndex = createdComponents_.indexOf(component);
            createdComponents_.splice(componentIndex, 1);
            var upgrades = component.element_.getAttribute("data-upgraded").split(",");
            var componentPlace = upgrades.indexOf(component[componentConfigProperty_].classAsString);
            upgrades.splice(componentPlace, 1);
            component.element_.setAttribute("data-upgraded", upgrades.join(","));
            var ev = createEvent_("mdl-componentdowngraded", true, false);
            component.element_.dispatchEvent(ev);
        }
    }
    /**
   * Downgrade either a given node, an array of nodes, or a NodeList.
   *
   * @param {!Node|!Array<!Node>|!NodeList} nodes
   */ function downgradeNodesInternal(nodes) {
        /**
     * Auxiliary function to downgrade a single node.
     * @param  {!Node} node the node to be downgraded
     */ var downgradeNode = function(node) {
            createdComponents_.filter(function(item) {
                return item.element_ === node;
            }).forEach(deconstructComponentInternal);
        };
        if (nodes instanceof Array || nodes instanceof NodeList) for(var n = 0; n < nodes.length; n++)downgradeNode(nodes[n]);
        else if (nodes instanceof Node) downgradeNode(nodes);
        else throw new Error("Invalid argument provided to downgrade MDL nodes.");
    }
    // Now return the functions that should be made public with their publicly
    // facing names...
    return {
        upgradeDom: upgradeDomInternal,
        upgradeElement: upgradeElementInternal,
        upgradeElements: upgradeElementsInternal,
        upgradeAllRegistered: upgradeAllRegisteredInternal,
        registerUpgradedCallback: registerUpgradedCallbackInternal,
        register: registerInternal,
        downgradeElements: downgradeNodesInternal
    };
}();
/**
 * Describes the type of a registered component type managed by
 * componentHandler. Provided for benefit of the Closure compiler.
 *
 * @typedef {{
 *   constructor: Function,
 *   classAsString: string,
 *   cssClass: string,
 *   widget: (string|boolean|undefined)
 * }}
 */ $3c95a930df53fbca$var$componentHandler.ComponentConfigPublic; // jshint ignore:line
/**
 * Describes the type of a registered component type managed by
 * componentHandler. Provided for benefit of the Closure compiler.
 *
 * @typedef {{
 *   constructor: !Function,
 *   className: string,
 *   cssClass: string,
 *   widget: (string|boolean),
 *   callbacks: !Array<function(!HTMLElement)>
 * }}
 */ $3c95a930df53fbca$var$componentHandler.ComponentConfig; // jshint ignore:line
/**
 * Created component (i.e., upgraded element) type as managed by
 * componentHandler. Provided for benefit of the Closure compiler.
 *
 * @typedef {{
 *   element_: !HTMLElement,
 *   className: string,
 *   classAsString: string,
 *   cssClass: string,
 *   widget: string
 * }}
 */ $3c95a930df53fbca$var$componentHandler.Component; // jshint ignore:line
// Export all symbols, for the benefit of Closure compiler.
// No effect on uncompiled code.
$3c95a930df53fbca$var$componentHandler["upgradeDom"] = $3c95a930df53fbca$var$componentHandler.upgradeDom;
$3c95a930df53fbca$var$componentHandler["upgradeElement"] = $3c95a930df53fbca$var$componentHandler.upgradeElement;
$3c95a930df53fbca$var$componentHandler["upgradeElements"] = $3c95a930df53fbca$var$componentHandler.upgradeElements;
$3c95a930df53fbca$var$componentHandler["upgradeAllRegistered"] = $3c95a930df53fbca$var$componentHandler.upgradeAllRegistered;
$3c95a930df53fbca$var$componentHandler["registerUpgradedCallback"] = $3c95a930df53fbca$var$componentHandler.registerUpgradedCallback;
$3c95a930df53fbca$var$componentHandler["register"] = $3c95a930df53fbca$var$componentHandler.register;
$3c95a930df53fbca$var$componentHandler["downgradeElements"] = $3c95a930df53fbca$var$componentHandler.downgradeElements;
window.componentHandler = $3c95a930df53fbca$var$componentHandler;
window["componentHandler"] = $3c95a930df53fbca$var$componentHandler;
window.addEventListener("load", function() {
    "use strict";
    /**
   * Performs a "Cutting the mustard" test. If the browser supports the features
   * tested, adds a mdl-js class to the <html> element. It then upgrades all MDL
   * components requiring JavaScript.
   */ if ("classList" in document.createElement("div") && "querySelector" in document && "addEventListener" in window && Array.prototype.forEach) {
        document.documentElement.classList.add("mdl-js");
        $3c95a930df53fbca$var$componentHandler.upgradeAllRegistered();
    } else {
        /**
     * Dummy function to avoid JS errors.
     */ $3c95a930df53fbca$var$componentHandler.upgradeElement = function() {};
        /**
     * Dummy function to avoid JS errors.
     */ $3c95a930df53fbca$var$componentHandler.register = function() {};
    }
});

});

parcelRequire.register("krkuu", function(module, exports) {
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (function() {
    "use strict";
    /**
   * Class constructor for Button MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @param {HTMLElement} element The element that will be upgraded.
   */ var MaterialButton = function MaterialButton(element) {
        this.element_ = element;
        // Initialize instance.
        this.init();
    };
    window["MaterialButton"] = MaterialButton;
    /**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */ MaterialButton.prototype.Constant_ = {
    };
    /**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */ MaterialButton.prototype.CssClasses_ = {
        RIPPLE_EFFECT: "mdl-js-ripple-effect",
        RIPPLE_CONTAINER: "mdl-button__ripple-container",
        RIPPLE: "mdl-ripple"
    };
    /**
   * Handle blur of element.
   *
   * @param {Event} event The event that fired.
   * @private
   */ MaterialButton.prototype.blurHandler_ = function(event) {
        if (event) this.element_.blur();
    };
    // Public methods.
    /**
   * Disable button.
   *
   * @public
   */ MaterialButton.prototype.disable = function() {
        this.element_.disabled = true;
    };
    MaterialButton.prototype["disable"] = MaterialButton.prototype.disable;
    /**
   * Enable button.
   *
   * @public
   */ MaterialButton.prototype.enable = function() {
        this.element_.disabled = false;
    };
    MaterialButton.prototype["enable"] = MaterialButton.prototype.enable;
    /**
   * Initialize element.
   */ MaterialButton.prototype.init = function() {
        if (this.element_) {
            if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
                var rippleContainer = document.createElement("span");
                rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
                this.rippleElement_ = document.createElement("span");
                this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
                rippleContainer.appendChild(this.rippleElement_);
                this.boundRippleBlurHandler = this.blurHandler_.bind(this);
                this.rippleElement_.addEventListener("mouseup", this.boundRippleBlurHandler);
                this.element_.appendChild(rippleContainer);
            }
            this.boundButtonBlurHandler = this.blurHandler_.bind(this);
            this.element_.addEventListener("mouseup", this.boundButtonBlurHandler);
            this.element_.addEventListener("mouseleave", this.boundButtonBlurHandler);
        }
    };
    // The component registers itself. It can assume componentHandler is available
    // in the global scope.
    componentHandler.register({
        constructor: MaterialButton,
        classAsString: "MaterialButton",
        cssClass: "mdl-js-button",
        widget: true
    });
})();

});

parcelRequire.register("2B0cO", function(module, exports) {
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (function() {
    "use strict";
    /**
   * Class constructor for Progress MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */ var MaterialProgress = function MaterialProgress(element) {
        this.element_ = element;
        // Initialize instance.
        this.init();
    };
    window["MaterialProgress"] = MaterialProgress;
    /**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */ MaterialProgress.prototype.Constant_ = {};
    /**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */ MaterialProgress.prototype.CssClasses_ = {
        INDETERMINATE_CLASS: "mdl-progress__indeterminate"
    };
    /**
   * Set the current progress of the progressbar.
   *
   * @param {number} p Percentage of the progress (0-100)
   * @public
   */ MaterialProgress.prototype.setProgress = function(p) {
        if (this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS)) return;
        this.progressbar_.style.width = p + "%";
    };
    MaterialProgress.prototype["setProgress"] = MaterialProgress.prototype.setProgress;
    /**
   * Set the current progress of the buffer.
   *
   * @param {number} p Percentage of the buffer (0-100)
   * @public
   */ MaterialProgress.prototype.setBuffer = function(p) {
        this.bufferbar_.style.width = p + "%";
        this.auxbar_.style.width = 100 - p + "%";
    };
    MaterialProgress.prototype["setBuffer"] = MaterialProgress.prototype.setBuffer;
    /**
   * Initialize element.
   */ MaterialProgress.prototype.init = function() {
        if (this.element_) {
            var el = document.createElement("div");
            el.className = "progressbar bar bar1";
            this.element_.appendChild(el);
            this.progressbar_ = el;
            el = document.createElement("div");
            el.className = "bufferbar bar bar2";
            this.element_.appendChild(el);
            this.bufferbar_ = el;
            el = document.createElement("div");
            el.className = "auxbar bar bar3";
            this.element_.appendChild(el);
            this.auxbar_ = el;
            this.progressbar_.style.width = "0%";
            this.bufferbar_.style.width = "100%";
            this.auxbar_.style.width = "0%";
            this.element_.classList.add("is-upgraded");
        }
    };
    // The component registers itself. It can assume componentHandler is available
    // in the global scope.
    componentHandler.register({
        constructor: MaterialProgress,
        classAsString: "MaterialProgress",
        cssClass: "mdl-js-progress",
        widget: true
    });
})();

});

parcelRequire.register("3lq7C", function(module, exports) {
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (function() {
    "use strict";
    /**
   * Class constructor for Spinner MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @param {HTMLElement} element The element that will be upgraded.
   * @constructor
   */ var MaterialSpinner = function MaterialSpinner(element) {
        this.element_ = element;
        // Initialize instance.
        this.init();
    };
    window["MaterialSpinner"] = MaterialSpinner;
    /**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */ MaterialSpinner.prototype.Constant_ = {
        MDL_SPINNER_LAYER_COUNT: 4
    };
    /**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */ MaterialSpinner.prototype.CssClasses_ = {
        MDL_SPINNER_LAYER: "mdl-spinner__layer",
        MDL_SPINNER_CIRCLE_CLIPPER: "mdl-spinner__circle-clipper",
        MDL_SPINNER_CIRCLE: "mdl-spinner__circle",
        MDL_SPINNER_GAP_PATCH: "mdl-spinner__gap-patch",
        MDL_SPINNER_LEFT: "mdl-spinner__left",
        MDL_SPINNER_RIGHT: "mdl-spinner__right"
    };
    /**
   * Auxiliary method to create a spinner layer.
   *
   * @param {number} index Index of the layer to be created.
   * @public
   */ MaterialSpinner.prototype.createLayer = function(index) {
        var layer = document.createElement("div");
        layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);
        layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER + "-" + index);
        var leftClipper = document.createElement("div");
        leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
        leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);
        var gapPatch = document.createElement("div");
        gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);
        var rightClipper = document.createElement("div");
        rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
        rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);
        var circleOwners = [
            leftClipper,
            gapPatch,
            rightClipper
        ];
        for(var i = 0; i < circleOwners.length; i++){
            var circle = document.createElement("div");
            circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);
            circleOwners[i].appendChild(circle);
        }
        layer.appendChild(leftClipper);
        layer.appendChild(gapPatch);
        layer.appendChild(rightClipper);
        this.element_.appendChild(layer);
    };
    MaterialSpinner.prototype["createLayer"] = MaterialSpinner.prototype.createLayer;
    /**
   * Stops the spinner animation.
   * Public method for users who need to stop the spinner for any reason.
   *
   * @public
   */ MaterialSpinner.prototype.stop = function() {
        this.element_.classList.remove("is-active");
    };
    MaterialSpinner.prototype["stop"] = MaterialSpinner.prototype.stop;
    /**
   * Starts the spinner animation.
   * Public method for users who need to manually start the spinner for any reason
   * (instead of just adding the 'is-active' class to their markup).
   *
   * @public
   */ MaterialSpinner.prototype.start = function() {
        this.element_.classList.add("is-active");
    };
    MaterialSpinner.prototype["start"] = MaterialSpinner.prototype.start;
    /**
   * Initialize element.
   */ MaterialSpinner.prototype.init = function() {
        if (this.element_) {
            for(var i = 1; i <= this.Constant_.MDL_SPINNER_LAYER_COUNT; i++)this.createLayer(i);
            this.element_.classList.add("is-upgraded");
        }
    };
    // The component registers itself. It can assume componentHandler is available
    // in the global scope.
    componentHandler.register({
        constructor: MaterialSpinner,
        classAsString: "MaterialSpinner",
        cssClass: "mdl-js-spinner",
        widget: true
    });
})();

});

parcelRequire.register("3NLoR", function(module, exports) {
/**
 * @license
 * Copyright 2015 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (function() {
    "use strict";
    /**
   * Class constructor for Textfield MDL component.
   * Implements MDL component design pattern defined at:
   * https://github.com/jasonmayes/mdl-component-design-pattern
   *
   * @constructor
   * @param {HTMLElement} element The element that will be upgraded.
   */ var MaterialTextfield = function MaterialTextfield(element) {
        this.element_ = element;
        this.maxRows = this.Constant_.NO_MAX_ROWS;
        // Initialize instance.
        this.init();
    };
    window["MaterialTextfield"] = MaterialTextfield;
    /**
   * Store constants in one place so they can be updated easily.
   *
   * @enum {string | number}
   * @private
   */ MaterialTextfield.prototype.Constant_ = {
        NO_MAX_ROWS: -1,
        MAX_ROWS_ATTRIBUTE: "maxrows"
    };
    /**
   * Store strings for class names defined by this component that are used in
   * JavaScript. This allows us to simply change it in one place should we
   * decide to modify at a later date.
   *
   * @enum {string}
   * @private
   */ MaterialTextfield.prototype.CssClasses_ = {
        LABEL: "mdl-textfield__label",
        INPUT: "mdl-textfield__input",
        IS_DIRTY: "is-dirty",
        IS_FOCUSED: "is-focused",
        IS_DISABLED: "is-disabled",
        IS_INVALID: "is-invalid",
        IS_UPGRADED: "is-upgraded",
        HAS_PLACEHOLDER: "has-placeholder"
    };
    /**
   * Handle input being entered.
   *
   * @param {Event} event The event that fired.
   * @private
   */ MaterialTextfield.prototype.onKeyDown_ = function(event) {
        var currentRowCount = event.target.value.split("\n").length;
        if (event.keyCode === 13) {
            if (currentRowCount >= this.maxRows) event.preventDefault();
        }
    };
    /**
   * Handle focus.
   *
   * @param {Event} event The event that fired.
   * @private
   */ MaterialTextfield.prototype.onFocus_ = function(event) {
        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
    };
    /**
   * Handle lost focus.
   *
   * @param {Event} event The event that fired.
   * @private
   */ MaterialTextfield.prototype.onBlur_ = function(event) {
        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
    };
    /**
   * Handle reset event from out side.
   *
   * @param {Event} event The event that fired.
   * @private
   */ MaterialTextfield.prototype.onReset_ = function(event) {
        this.updateClasses_();
    };
    /**
   * Handle class updates.
   *
   * @private
   */ MaterialTextfield.prototype.updateClasses_ = function() {
        this.checkDisabled();
        this.checkValidity();
        this.checkDirty();
        this.checkFocus();
    };
    // Public methods.
    /**
   * Check the disabled state and update field accordingly.
   *
   * @public
   */ MaterialTextfield.prototype.checkDisabled = function() {
        if (this.input_.disabled) this.element_.classList.add(this.CssClasses_.IS_DISABLED);
        else this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
    };
    MaterialTextfield.prototype["checkDisabled"] = MaterialTextfield.prototype.checkDisabled;
    /**
  * Check the focus state and update field accordingly.
  *
  * @public
  */ MaterialTextfield.prototype.checkFocus = function() {
        if (Boolean(this.element_.querySelector(":focus"))) this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
        else this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
    };
    MaterialTextfield.prototype["checkFocus"] = MaterialTextfield.prototype.checkFocus;
    /**
   * Check the validity state and update field accordingly.
   *
   * @public
   */ MaterialTextfield.prototype.checkValidity = function() {
        if (this.input_.validity) {
            if (this.input_.validity.valid) this.element_.classList.remove(this.CssClasses_.IS_INVALID);
            else this.element_.classList.add(this.CssClasses_.IS_INVALID);
        }
    };
    MaterialTextfield.prototype["checkValidity"] = MaterialTextfield.prototype.checkValidity;
    /**
   * Check the dirty state and update field accordingly.
   *
   * @public
   */ MaterialTextfield.prototype.checkDirty = function() {
        if (this.input_.value && this.input_.value.length > 0) this.element_.classList.add(this.CssClasses_.IS_DIRTY);
        else this.element_.classList.remove(this.CssClasses_.IS_DIRTY);
    };
    MaterialTextfield.prototype["checkDirty"] = MaterialTextfield.prototype.checkDirty;
    /**
   * Disable text field.
   *
   * @public
   */ MaterialTextfield.prototype.disable = function() {
        this.input_.disabled = true;
        this.updateClasses_();
    };
    MaterialTextfield.prototype["disable"] = MaterialTextfield.prototype.disable;
    /**
   * Enable text field.
   *
   * @public
   */ MaterialTextfield.prototype.enable = function() {
        this.input_.disabled = false;
        this.updateClasses_();
    };
    MaterialTextfield.prototype["enable"] = MaterialTextfield.prototype.enable;
    /**
   * Update text field value.
   *
   * @param {string} value The value to which to set the control (optional).
   * @public
   */ MaterialTextfield.prototype.change = function(value) {
        this.input_.value = value || "";
        this.updateClasses_();
    };
    MaterialTextfield.prototype["change"] = MaterialTextfield.prototype.change;
    /**
   * Initialize element.
   */ MaterialTextfield.prototype.init = function() {
        if (this.element_) {
            this.label_ = this.element_.querySelector("." + this.CssClasses_.LABEL);
            this.input_ = this.element_.querySelector("." + this.CssClasses_.INPUT);
            if (this.input_) {
                if (this.input_.hasAttribute(/** @type {string} */ this.Constant_.MAX_ROWS_ATTRIBUTE)) {
                    this.maxRows = parseInt(this.input_.getAttribute(/** @type {string} */ this.Constant_.MAX_ROWS_ATTRIBUTE), 10);
                    if (isNaN(this.maxRows)) this.maxRows = this.Constant_.NO_MAX_ROWS;
                }
                if (this.input_.hasAttribute("placeholder")) this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);
                this.boundUpdateClassesHandler = this.updateClasses_.bind(this);
                this.boundFocusHandler = this.onFocus_.bind(this);
                this.boundBlurHandler = this.onBlur_.bind(this);
                this.boundResetHandler = this.onReset_.bind(this);
                this.input_.addEventListener("input", this.boundUpdateClassesHandler);
                this.input_.addEventListener("focus", this.boundFocusHandler);
                this.input_.addEventListener("blur", this.boundBlurHandler);
                this.input_.addEventListener("reset", this.boundResetHandler);
                if (this.maxRows !== this.Constant_.NO_MAX_ROWS) {
                    // TODO: This should handle pasting multi line text.
                    // Currently doesn't.
                    this.boundKeyDownHandler = this.onKeyDown_.bind(this);
                    this.input_.addEventListener("keydown", this.boundKeyDownHandler);
                }
                var invalid = this.element_.classList.contains(this.CssClasses_.IS_INVALID);
                this.updateClasses_();
                this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
                if (invalid) this.element_.classList.add(this.CssClasses_.IS_INVALID);
                if (this.input_.hasAttribute("autofocus")) {
                    this.element_.focus();
                    this.checkFocus();
                }
            }
        }
    };
    // The component registers itself. It can assume componentHandler is available
    // in the global scope.
    componentHandler.register({
        constructor: MaterialTextfield,
        classAsString: "MaterialTextfield",
        cssClass: "mdl-js-textfield",
        widget: true
    });
})();

});


parcelRequire.register("gHhSd", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRequire.register("jQ8wd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7197b49f2f87a8a$export$2e2bcd8739ae039; });

var $kLtil = parcelRequire("kLtil");
var $e7197b49f2f87a8a$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e7197b49f2f87a8a$var$index = (0, $kLtil.default)(function(prop) {
    return $e7197b49f2f87a8a$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $e7197b49f2f87a8a$export$2e2bcd8739ae039 = $e7197b49f2f87a8a$var$index;

});
parcelRequire.register("kLtil", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1deebcc51444909$export$2e2bcd8739ae039; });
function $f1deebcc51444909$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f1deebcc51444909$export$2e2bcd8739ae039 = $f1deebcc51444909$var$memoize;

});


var $e800b0e3b29b4f13$exports = {};
"use strict";

$e800b0e3b29b4f13$exports = (parcelRequire("1pQec"));


parcelRequire("lDSNw");
parcelRequire("ef4Zh");
var $a1f2ba2fe2d2776b$export$882461b6382ed46c;
var $a1f2ba2fe2d2776b$export$757ceba2d55c277e;
"use strict";

var $ef4Zh = parcelRequire("ef4Zh");
var $a1f2ba2fe2d2776b$var$i;
$a1f2ba2fe2d2776b$export$882461b6382ed46c = $ef4Zh.createRoot;
$a1f2ba2fe2d2776b$export$757ceba2d55c277e = $ef4Zh.hydrateRoot;



// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $888ce804d5b32d1c$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.0/8 are considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $888ce804d5b32d1c$export$6503ec6e8aabbaf(config) {
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener("load", ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($888ce804d5b32d1c$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $888ce804d5b32d1c$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $888ce804d5b32d1c$var$registerValidSW(swUrl, config);
        });
    }
}
function $888ce804d5b32d1c$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log("Content is cached for offline use.");
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error("Error during service worker registration:", error);
    });
}
function $888ce804d5b32d1c$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl, {
        headers: {
            "Service-Worker": "script"
        }
    }).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get("content-type");
        if (response.status === 404 || contentType != null && contentType.indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $888ce804d5b32d1c$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function $888ce804d5b32d1c$export$d07f55d4c15c0440() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    }).catch((error)=>{
        console.error(error.message);
    });
}





var $2WUgS = parcelRequire("2WUgS");

var $8eXKx = parcelRequire("8eXKx");

var $8eXKx = parcelRequire("8eXKx");

var $4TGB3 = parcelRequire("4TGB3");

var $2WUgS = parcelRequire("2WUgS");

var $eTAKc = parcelRequire("eTAKc");
var $56e57777636181f6$exports = {};
(function(global, factory) {
    factory($56e57777636181f6$exports);
})($56e57777636181f6$exports, function(exports1) {
    "use strict";
    function toArray(arr) {
        return Array.prototype.slice.call(arr);
    }
    function promisifyRequest(request) {
        return new Promise(function(resolve, reject) {
            request.onsuccess = function() {
                resolve(request.result);
            };
            request.onerror = function() {
                reject(request.error);
            };
        });
    }
    function promisifyRequestCall(obj, method, args) {
        var request;
        var p = new Promise(function(resolve, reject) {
            request = obj[method].apply(obj, args);
            promisifyRequest(request).then(resolve, reject);
        });
        p.request = request;
        return p;
    }
    function promisifyCursorRequestCall(obj, method, args) {
        var p = promisifyRequestCall(obj, method, args);
        return p.then(function(value) {
            if (!value) return;
            return new Cursor(value, p.request);
        });
    }
    function proxyProperties(ProxyClass, targetProp, properties) {
        properties.forEach(function(prop) {
            Object.defineProperty(ProxyClass.prototype, prop, {
                get: function() {
                    return this[targetProp][prop];
                },
                set: function(val) {
                    this[targetProp][prop] = val;
                }
            });
        });
    }
    function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return promisifyRequestCall(this[targetProp], prop, arguments);
            };
        });
    }
    function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return this[targetProp][prop].apply(this[targetProp], arguments);
            };
        });
    }
    function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
        properties.forEach(function(prop) {
            if (!(prop in Constructor.prototype)) return;
            ProxyClass.prototype[prop] = function() {
                return promisifyCursorRequestCall(this[targetProp], prop, arguments);
            };
        });
    }
    function Index(index) {
        this._index = index;
    }
    proxyProperties(Index, "_index", [
        "name",
        "keyPath",
        "multiEntry",
        "unique"
    ]);
    proxyRequestMethods(Index, "_index", IDBIndex, [
        "get",
        "getKey",
        "getAll",
        "getAllKeys",
        "count"
    ]);
    proxyCursorRequestMethods(Index, "_index", IDBIndex, [
        "openCursor",
        "openKeyCursor"
    ]);
    function Cursor(cursor, request) {
        this._cursor = cursor;
        this._request = request;
    }
    proxyProperties(Cursor, "_cursor", [
        "direction",
        "key",
        "primaryKey",
        "value"
    ]);
    proxyRequestMethods(Cursor, "_cursor", IDBCursor, [
        "update",
        "delete"
    ]);
    // proxy 'next' methods
    [
        "advance",
        "continue",
        "continuePrimaryKey"
    ].forEach(function(methodName) {
        if (!(methodName in IDBCursor.prototype)) return;
        Cursor.prototype[methodName] = function() {
            var cursor = this;
            var args = arguments;
            return Promise.resolve().then(function() {
                cursor._cursor[methodName].apply(cursor._cursor, args);
                return promisifyRequest(cursor._request).then(function(value) {
                    if (!value) return;
                    return new Cursor(value, cursor._request);
                });
            });
        };
    });
    function ObjectStore(store) {
        this._store = store;
    }
    ObjectStore.prototype.createIndex = function() {
        return new Index(this._store.createIndex.apply(this._store, arguments));
    };
    ObjectStore.prototype.index = function() {
        return new Index(this._store.index.apply(this._store, arguments));
    };
    proxyProperties(ObjectStore, "_store", [
        "name",
        "keyPath",
        "indexNames",
        "autoIncrement"
    ]);
    proxyRequestMethods(ObjectStore, "_store", IDBObjectStore, [
        "put",
        "add",
        "delete",
        "clear",
        "get",
        "getAll",
        "getKey",
        "getAllKeys",
        "count"
    ]);
    proxyCursorRequestMethods(ObjectStore, "_store", IDBObjectStore, [
        "openCursor",
        "openKeyCursor"
    ]);
    proxyMethods(ObjectStore, "_store", IDBObjectStore, [
        "deleteIndex"
    ]);
    function Transaction(idbTransaction) {
        this._tx = idbTransaction;
        this.complete = new Promise(function(resolve, reject) {
            idbTransaction.oncomplete = function() {
                resolve();
            };
            idbTransaction.onerror = function() {
                reject(idbTransaction.error);
            };
            idbTransaction.onabort = function() {
                reject(idbTransaction.error);
            };
        });
    }
    Transaction.prototype.objectStore = function() {
        return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
    };
    proxyProperties(Transaction, "_tx", [
        "objectStoreNames",
        "mode"
    ]);
    proxyMethods(Transaction, "_tx", IDBTransaction, [
        "abort"
    ]);
    function UpgradeDB(db, oldVersion, transaction) {
        this._db = db;
        this.oldVersion = oldVersion;
        this.transaction = new Transaction(transaction);
    }
    UpgradeDB.prototype.createObjectStore = function() {
        return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
    };
    proxyProperties(UpgradeDB, "_db", [
        "name",
        "version",
        "objectStoreNames"
    ]);
    proxyMethods(UpgradeDB, "_db", IDBDatabase, [
        "deleteObjectStore",
        "close"
    ]);
    function DB(db) {
        this._db = db;
    }
    DB.prototype.transaction = function() {
        return new Transaction(this._db.transaction.apply(this._db, arguments));
    };
    proxyProperties(DB, "_db", [
        "name",
        "version",
        "objectStoreNames"
    ]);
    proxyMethods(DB, "_db", IDBDatabase, [
        "close"
    ]);
    // Add cursor iterators
    // TODO: remove this once browsers do the right thing with promises
    [
        "openCursor",
        "openKeyCursor"
    ].forEach(function(funcName) {
        [
            ObjectStore,
            Index
        ].forEach(function(Constructor) {
            // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
            if (!(funcName in Constructor.prototype)) return;
            Constructor.prototype[funcName.replace("open", "iterate")] = function() {
                var args = toArray(arguments);
                var callback = args[args.length - 1];
                var nativeObject = this._store || this._index;
                var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
                request.onsuccess = function() {
                    callback(request.result);
                };
            };
        });
    });
    // polyfill getAll
    [
        Index,
        ObjectStore
    ].forEach(function(Constructor) {
        if (Constructor.prototype.getAll) return;
        Constructor.prototype.getAll = function(query, count) {
            var instance = this;
            var items = [];
            return new Promise(function(resolve) {
                instance.iterateCursor(query, function(cursor) {
                    if (!cursor) {
                        resolve(items);
                        return;
                    }
                    items.push(cursor.value);
                    if (count !== undefined && items.length == count) {
                        resolve(items);
                        return;
                    }
                    cursor.continue();
                });
            });
        };
    });
    function openDb(name, version, upgradeCallback) {
        var p = promisifyRequestCall(indexedDB, "open", [
            name,
            version
        ]);
        var request = p.request;
        if (request) request.onupgradeneeded = function(event) {
            if (upgradeCallback) upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        };
        return p.then(function(db) {
            return new DB(db);
        });
    }
    function deleteDb(name) {
        return promisifyRequestCall(indexedDB, "deleteDatabase", [
            name
        ]);
    }
    exports1.openDb = openDb;
    exports1.deleteDb = deleteDb;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $a7cea3632a150641$var$name = "@firebase/installations";
var $a7cea3632a150641$var$version = "0.4.32";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cea3632a150641$var$PENDING_TIMEOUT_MS = 10000;
var $a7cea3632a150641$var$PACKAGE_VERSION = "w:" + $a7cea3632a150641$var$version;
var $a7cea3632a150641$var$INTERNAL_AUTH_VERSION = "FIS_v2";
var $a7cea3632a150641$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
var $a7cea3632a150641$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
var $a7cea3632a150641$var$SERVICE = "installations";
var $a7cea3632a150641$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cea3632a150641$var$_a;
var $a7cea3632a150641$var$ERROR_DESCRIPTION_MAP = ($a7cea3632a150641$var$_a = {}, $a7cea3632a150641$var$_a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ ] = 'Missing App configuration value: "{$valueName}"', $a7cea3632a150641$var$_a["not-registered" /* NOT_REGISTERED */ ] = "Firebase Installation is not registered.", $a7cea3632a150641$var$_a["installation-not-found" /* INSTALLATION_NOT_FOUND */ ] = "Firebase Installation not found.", $a7cea3632a150641$var$_a["request-failed" /* REQUEST_FAILED */ ] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"', $a7cea3632a150641$var$_a["app-offline" /* APP_OFFLINE */ ] = "Could not process request. Application offline.", $a7cea3632a150641$var$_a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */ ] = "Can't delete installation while there is a pending registration request.", $a7cea3632a150641$var$_a);
var $a7cea3632a150641$var$ERROR_FACTORY = new (0, $eTAKc.ErrorFactory)($a7cea3632a150641$var$SERVICE, $a7cea3632a150641$var$SERVICE_NAME, $a7cea3632a150641$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $a7cea3632a150641$var$isServerError(error) {
    return error instanceof (0, $eTAKc.FirebaseError) && error.code.includes("request-failed" /* REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$getInstallationsEndpoint(_a) {
    var projectId = _a.projectId;
    return $a7cea3632a150641$var$INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
}
function $a7cea3632a150641$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */ ,
        expiresIn: $a7cea3632a150641$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function $a7cea3632a150641$var$getErrorFromResponse(requestName, response) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var responseJson, errorData;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 1:
                    responseJson = _a.sent();
                    errorData = responseJson.error;
                    return [
                        2 /*return*/ ,
                        $a7cea3632a150641$var$ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */ , {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })
                    ];
            }
        });
    });
}
function $a7cea3632a150641$var$getHeaders(_a) {
    var apiKey = _a.apiKey;
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $a7cea3632a150641$var$getHeadersWithAuth(appConfig, _a) {
    var refreshToken = _a.refreshToken;
    var headers = $a7cea3632a150641$var$getHeaders(appConfig);
    headers.append("Authorization", $a7cea3632a150641$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ function $a7cea3632a150641$var$retryIfServerError(fn) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var result;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        fn()
                    ];
                case 1:
                    result = _a.sent();
                    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
                    return [
                        2 /*return*/ ,
                        fn()
                    ];
                    return [
                        2 /*return*/ ,
                        result
                    ];
            }
        });
    });
}
function $a7cea3632a150641$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $a7cea3632a150641$var$getAuthorizationHeader(refreshToken) {
    return $a7cea3632a150641$var$INTERNAL_AUTH_VERSION + " " + refreshToken;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$createInstallationRequest(appConfig, _a) {
    var fid = _a.fid;
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    endpoint = $a7cea3632a150641$var$getInstallationsEndpoint(appConfig);
                    headers = $a7cea3632a150641$var$getHeaders(appConfig);
                    body = {
                        fid: fid,
                        authVersion: $a7cea3632a150641$var$INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: $a7cea3632a150641$var$PACKAGE_VERSION
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 2:
                    responseValue = _b.sent();
                    registeredInstallationEntry = {
                        fid: responseValue.fid || fid,
                        registrationStatus: 2 /* COMPLETED */ ,
                        refreshToken: responseValue.refreshToken,
                        authToken: $a7cea3632a150641$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [
                        2 /*return*/ ,
                        registeredInstallationEntry
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getErrorFromResponse("Create Installation", response)
                    ];
                case 4:
                    throw _b.sent();
            }
        });
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $a7cea3632a150641$var$sleep(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$bufferToBase64UrlSafe(array) {
    var b64 = btoa(String.fromCharCode.apply(String, (0, $2WUgS.__spreadArray)([], (0, $2WUgS.__read)(array))));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cea3632a150641$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var $a7cea3632a150641$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $a7cea3632a150641$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto_1 = self.crypto || self.msCrypto;
        crypto_1.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        var fid = $a7cea3632a150641$var$encode(fidByteArray);
        return $a7cea3632a150641$var$VALID_FID_PATTERN.test(fid) ? fid : $a7cea3632a150641$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $a7cea3632a150641$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $a7cea3632a150641$var$encode(fidByteArray) {
    var b64String = $a7cea3632a150641$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $a7cea3632a150641$var$getKey(appConfig) {
    return appConfig.appName + "!" + appConfig.appId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cea3632a150641$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $a7cea3632a150641$var$fidChanged(appConfig, fid) {
    var key = $a7cea3632a150641$var$getKey(appConfig);
    $a7cea3632a150641$var$callFidChangeCallbacks(key, fid);
    $a7cea3632a150641$var$broadcastFidChange(key, fid);
}
function $a7cea3632a150641$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $a7cea3632a150641$var$getBroadcastChannel();
    var key = $a7cea3632a150641$var$getKey(appConfig);
    var callbackSet = $a7cea3632a150641$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $a7cea3632a150641$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $a7cea3632a150641$var$removeCallback(appConfig, callback) {
    var key = $a7cea3632a150641$var$getKey(appConfig);
    var callbackSet = $a7cea3632a150641$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $a7cea3632a150641$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $a7cea3632a150641$var$closeBroadcastChannel();
}
function $a7cea3632a150641$var$callFidChangeCallbacks(key, fid) {
    var e_1, _a;
    var callbacks = $a7cea3632a150641$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    try {
        for(var callbacks_1 = (0, $2WUgS.__values)(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()){
            var callback = callbacks_1_1.value;
            callback(fid);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
function $a7cea3632a150641$var$broadcastFidChange(key, fid) {
    var channel = $a7cea3632a150641$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $a7cea3632a150641$var$closeBroadcastChannel();
}
var $a7cea3632a150641$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $a7cea3632a150641$var$getBroadcastChannel() {
    if (!$a7cea3632a150641$var$broadcastChannel && "BroadcastChannel" in self) {
        $a7cea3632a150641$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $a7cea3632a150641$var$broadcastChannel.onmessage = function(e) {
            $a7cea3632a150641$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $a7cea3632a150641$var$broadcastChannel;
}
function $a7cea3632a150641$var$closeBroadcastChannel() {
    if ($a7cea3632a150641$var$fidChangeCallbacks.size === 0 && $a7cea3632a150641$var$broadcastChannel) {
        $a7cea3632a150641$var$broadcastChannel.close();
        $a7cea3632a150641$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cea3632a150641$var$DATABASE_NAME = "firebase-installations-database";
var $a7cea3632a150641$var$DATABASE_VERSION = 1;
var $a7cea3632a150641$var$OBJECT_STORE_NAME = "firebase-installations-store";
var $a7cea3632a150641$var$dbPromise = null;
function $a7cea3632a150641$var$getDbPromise() {
    if (!$a7cea3632a150641$var$dbPromise) $a7cea3632a150641$var$dbPromise = (0, $56e57777636181f6$exports.openDb)($a7cea3632a150641$var$DATABASE_NAME, $a7cea3632a150641$var$DATABASE_VERSION, function(upgradeDB) {
        // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case
        switch(upgradeDB.oldVersion){
            case 0:
                upgradeDB.createObjectStore($a7cea3632a150641$var$OBJECT_STORE_NAME);
        }
    });
    return $a7cea3632a150641$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ function $a7cea3632a150641$var$set(appConfig, value) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var key, db, tx, objectStore, oldValue;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $a7cea3632a150641$var$getKey(appConfig);
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($a7cea3632a150641$var$OBJECT_STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($a7cea3632a150641$var$OBJECT_STORE_NAME);
                    return [
                        4 /*yield*/ ,
                        objectStore.get(key)
                    ];
                case 2:
                    oldValue = _a.sent();
                    return [
                        4 /*yield*/ ,
                        objectStore.put(value, key)
                    ];
                case 3:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 4:
                    _a.sent();
                    if (!oldValue || oldValue.fid !== value.fid) $a7cea3632a150641$var$fidChanged(appConfig, value.fid);
                    return [
                        2 /*return*/ ,
                        value
                    ];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */ function $a7cea3632a150641$var$remove(appConfig) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var key, db, tx;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $a7cea3632a150641$var$getKey(appConfig);
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($a7cea3632a150641$var$OBJECT_STORE_NAME, "readwrite");
                    return [
                        4 /*yield*/ ,
                        tx.objectStore($a7cea3632a150641$var$OBJECT_STORE_NAME).delete(key)
                    ];
                case 2:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ function $a7cea3632a150641$var$update(appConfig, updateFn) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var key, db, tx, store, oldValue, newValue;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = $a7cea3632a150641$var$getKey(appConfig);
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getDbPromise()
                    ];
                case 1:
                    db = _a.sent();
                    tx = db.transaction($a7cea3632a150641$var$OBJECT_STORE_NAME, "readwrite");
                    store = tx.objectStore($a7cea3632a150641$var$OBJECT_STORE_NAME);
                    return [
                        4 /*yield*/ ,
                        store.get(key)
                    ];
                case 2:
                    oldValue = _a.sent();
                    newValue = updateFn(oldValue);
                    if (!(newValue === undefined)) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        store.delete(key)
                    ];
                case 3:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        store.put(newValue, key)
                    ];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [
                        4 /*yield*/ ,
                        tx.complete
                    ];
                case 7:
                    _a.sent();
                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $a7cea3632a150641$var$fidChanged(appConfig, newValue.fid);
                    return [
                        2 /*return*/ ,
                        newValue
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ function $a7cea3632a150641$var$getInstallationEntry(appConfig) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var registrationPromise, installationEntry;
        var _a;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$update(appConfig, function(oldEntry) {
                            var installationEntry = $a7cea3632a150641$var$updateOrCreateInstallationEntry(oldEntry);
                            var entryWithPromise = $a7cea3632a150641$var$triggerRegistrationIfNecessary(appConfig, installationEntry);
                            registrationPromise = entryWithPromise.registrationPromise;
                            return entryWithPromise.installationEntry;
                        })
                    ];
                case 1:
                    installationEntry = _b.sent();
                    if (!(installationEntry.fid === $a7cea3632a150641$var$INVALID_FID)) return [
                        3 /*break*/ ,
                        3
                    ];
                    _a = {};
                    return [
                        4 /*yield*/ ,
                        registrationPromise
                    ];
                case 2:
                    // FID generation failed. Waiting for the FID from the server.
                    return [
                        2 /*return*/ ,
                        (_a.installationEntry = _b.sent(), _a)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        {
                            installationEntry: installationEntry,
                            registrationPromise: registrationPromise
                        }
                    ];
            }
        });
    });
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $a7cea3632a150641$var$updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: $a7cea3632a150641$var$generateFid(),
        registrationStatus: 0 /* NOT_STARTED */ 
    };
    return $a7cea3632a150641$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $a7cea3632a150641$var$triggerRegistrationIfNecessary(appConfig, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject($a7cea3632a150641$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        var registrationPromise = $a7cea3632a150641$var$registerInstallation(appConfig, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $a7cea3632a150641$var$waitUntilFidRegistration(appConfig)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ function $a7cea3632a150641$var$registerInstallation(appConfig, installationEntry) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var registeredInstallationEntry, e_1;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        7
                    ]);
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$createInstallationRequest(appConfig, installationEntry)
                    ];
                case 1:
                    registeredInstallationEntry = _a.sent();
                    return [
                        2 /*return*/ ,
                        $a7cea3632a150641$var$set(appConfig, registeredInstallationEntry)
                    ];
                case 2:
                    e_1 = _a.sent();
                    if (!($a7cea3632a150641$var$isServerError(e_1) && e_1.customData.serverCode === 409)) return [
                        3 /*break*/ ,
                        4
                    ];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$remove(appConfig)
                    ];
                case 3:
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    // Registration failed. Set FID as not registered.
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$set(appConfig, {
                            fid: installationEntry.fid,
                            registrationStatus: 0 /* NOT_STARTED */ 
                        })
                    ];
                case 5:
                    // Registration failed. Set FID as not registered.
                    _a.sent();
                    _a.label = 6;
                case 6:
                    throw e_1;
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/** Call if FID registration is pending in another request. */ function $a7cea3632a150641$var$waitUntilFidRegistration(appConfig) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var entry, _a, installationEntry, registrationPromise;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$updateInstallationRequest(appConfig)
                    ];
                case 1:
                    entry = _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */ )) return [
                        3 /*break*/ ,
                        5
                    ];
                    // createInstallation request still in progress.
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$sleep(100)
                    ];
                case 3:
                    // createInstallation request still in progress.
                    _b.sent();
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$updateInstallationRequest(appConfig)
                    ];
                case 4:
                    entry = _b.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */ )) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getInstallationEntry(appConfig)
                    ];
                case 6:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) return [
                        2 /*return*/ ,
                        registrationPromise
                    ];
                    else // if there is no registrationPromise, entry is registered.
                    return [
                        2 /*return*/ ,
                        installationEntry
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        entry
                    ];
            }
        });
    });
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $a7cea3632a150641$var$updateInstallationRequest(appConfig) {
    return $a7cea3632a150641$var$update(appConfig, function(oldEntry) {
        if (!oldEntry) throw $a7cea3632a150641$var$ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */ );
        return $a7cea3632a150641$var$clearTimedOutRequest(oldEntry);
    });
}
function $a7cea3632a150641$var$clearTimedOutRequest(entry) {
    if ($a7cea3632a150641$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* NOT_STARTED */ 
    };
    return entry;
}
function $a7cea3632a150641$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* IN_PROGRESS */  && installationEntry.registrationTime + $a7cea3632a150641$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$generateAuthTokenRequest(_a, installationEntry) {
    var appConfig = _a.appConfig, platformLoggerProvider = _a.platformLoggerProvider;
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    endpoint = $a7cea3632a150641$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = $a7cea3632a150641$var$getHeadersWithAuth(appConfig, installationEntry);
                    platformLogger = platformLoggerProvider.getImmediate({
                        optional: true
                    });
                    if (platformLogger) headers.append("x-firebase-client", platformLogger.getPlatformInfoString());
                    body = {
                        installation: {
                            sdkVersion: $a7cea3632a150641$var$PACKAGE_VERSION
                        }
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 2:
                    responseValue = _b.sent();
                    completedAuthToken = $a7cea3632a150641$var$extractAuthTokenInfoFromResponse(responseValue);
                    return [
                        2 /*return*/ ,
                        completedAuthToken
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getErrorFromResponse("Generate Auth Token", response)
                    ];
                case 4:
                    throw _b.sent();
            }
        });
    });
}
function $a7cea3632a150641$var$getGenerateAuthTokenEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return $a7cea3632a150641$var$getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ function $a7cea3632a150641$var$refreshAuthToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var tokenPromise, entry, authToken, _a;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$update(dependencies.appConfig, function(oldEntry) {
                            if (!$a7cea3632a150641$var$isEntryRegistered(oldEntry)) throw $a7cea3632a150641$var$ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */ );
                            var oldAuthToken = oldEntry.authToken;
                            if (!forceRefresh && $a7cea3632a150641$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
                            return oldEntry;
                            else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */ ) {
                                // There already is a token request in progress.
                                tokenPromise = $a7cea3632a150641$var$waitUntilAuthTokenRequest(dependencies, forceRefresh);
                                return oldEntry;
                            } else {
                                // No token or token expired.
                                if (!navigator.onLine) throw $a7cea3632a150641$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ );
                                var inProgressEntry = $a7cea3632a150641$var$makeAuthTokenRequestInProgressEntry(oldEntry);
                                tokenPromise = $a7cea3632a150641$var$fetchAuthTokenFromServer(dependencies, inProgressEntry);
                                return inProgressEntry;
                            }
                        })
                    ];
                case 1:
                    entry = _b.sent();
                    if (!tokenPromise) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        tokenPromise
                    ];
                case 2:
                    _a = _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    _a = entry.authToken;
                    _b.label = 4;
                case 4:
                    authToken = _a;
                    return [
                        2 /*return*/ ,
                        authToken
                    ];
            }
        });
    });
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ function $a7cea3632a150641$var$waitUntilAuthTokenRequest(dependencies, forceRefresh) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var entry, authToken;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$updateAuthTokenRequest(dependencies.appConfig)
                    ];
                case 1:
                    entry = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */ )) return [
                        3 /*break*/ ,
                        5
                    ];
                    // generateAuthToken still in progress.
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$sleep(100)
                    ];
                case 3:
                    // generateAuthToken still in progress.
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$updateAuthTokenRequest(dependencies.appConfig)
                    ];
                case 4:
                    entry = _a.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
                    return [
                        2 /*return*/ ,
                        $a7cea3632a150641$var$refreshAuthToken(dependencies, forceRefresh)
                    ];
                    else return [
                        2 /*return*/ ,
                        authToken
                    ];
            }
        });
    });
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $a7cea3632a150641$var$updateAuthTokenRequest(appConfig) {
    return $a7cea3632a150641$var$update(appConfig, function(oldEntry) {
        if (!$a7cea3632a150641$var$isEntryRegistered(oldEntry)) throw $a7cea3632a150641$var$ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */ );
        var oldAuthToken = oldEntry.authToken;
        if ($a7cea3632a150641$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return (0, $2WUgS.__assign)((0, $2WUgS.__assign)({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
function $a7cea3632a150641$var$fetchAuthTokenFromServer(dependencies, installationEntry) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$generateAuthTokenRequest(dependencies, installationEntry)
                    ];
                case 1:
                    authToken = _a.sent();
                    updatedInstallationEntry = (0, $2WUgS.__assign)((0, $2WUgS.__assign)({}, installationEntry), {
                        authToken: authToken
                    });
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$set(dependencies.appConfig, updatedInstallationEntry)
                    ];
                case 2:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        authToken
                    ];
                case 3:
                    e_1 = _a.sent();
                    if (!($a7cea3632a150641$var$isServerError(e_1) && (e_1.customData.serverCode === 401 || e_1.customData.serverCode === 404))) return [
                        3 /*break*/ ,
                        5
                    ];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$remove(dependencies.appConfig)
                    ];
                case 4:
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    updatedInstallationEntry = (0, $2WUgS.__assign)((0, $2WUgS.__assign)({}, installationEntry), {
                        authToken: {
                            requestStatus: 0 /* NOT_STARTED */ 
                        }
                    });
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$set(dependencies.appConfig, updatedInstallationEntry)
                    ];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    throw e_1;
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $a7cea3632a150641$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* COMPLETED */ ;
}
function $a7cea3632a150641$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* COMPLETED */  && !$a7cea3632a150641$var$isAuthTokenExpired(authToken);
}
function $a7cea3632a150641$var$isAuthTokenExpired(authToken) {
    var now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $a7cea3632a150641$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $a7cea3632a150641$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return (0, $2WUgS.__assign)((0, $2WUgS.__assign)({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $a7cea3632a150641$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* IN_PROGRESS */  && authToken.requestTime + $a7cea3632a150641$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$getId(dependencies) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var _a, installationEntry, registrationPromise;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getInstallationEntry(dependencies.appConfig)
                    ];
                case 1:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) registrationPromise.catch(console.error);
                    else // If the installation is already registered, update the authentication
                    // token if needed.
                    $a7cea3632a150641$var$refreshAuthToken(dependencies).catch(console.error);
                    return [
                        2 /*return*/ ,
                        installationEntry.fid
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$getToken(dependencies, forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var authToken;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$completeInstallationRegistration(dependencies.appConfig)
                    ];
                case 1:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$refreshAuthToken(dependencies, forceRefresh)
                    ];
                case 2:
                    authToken = _a.sent();
                    return [
                        2 /*return*/ ,
                        authToken.token
                    ];
            }
        });
    });
}
function $a7cea3632a150641$var$completeInstallationRegistration(appConfig) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var registrationPromise;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getInstallationEntry(appConfig)
                    ];
                case 1:
                    registrationPromise = _a.sent().registrationPromise;
                    if (!registrationPromise) return [
                        3 /*break*/ ,
                        3
                    ];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [
                        4 /*yield*/ ,
                        registrationPromise
                    ];
                case 2:
                    // A createInstallation request is in progress. Wait until it finishes.
                    _a.sent();
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$deleteInstallationRequest(appConfig, installationEntry) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var endpoint, headers, request, response;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    endpoint = $a7cea3632a150641$var$getDeleteEndpoint(appConfig, installationEntry);
                    headers = $a7cea3632a150641$var$getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: "DELETE",
                        headers: headers
                    };
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$getErrorFromResponse("Delete Installation", response)
                    ];
                case 2:
                    throw _a.sent();
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $a7cea3632a150641$var$getDeleteEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return $a7cea3632a150641$var$getInstallationsEndpoint(appConfig) + "/" + fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$deleteInstallation(dependencies) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var appConfig, entry;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    appConfig = dependencies.appConfig;
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$update(appConfig, function(oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
                            return undefined;
                            return oldEntry;
                        })
                    ];
                case 1:
                    entry = _a.sent();
                    if (!entry) return [
                        3 /*break*/ ,
                        6
                    ];
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */ )) return [
                        3 /*break*/ ,
                        2
                    ];
                    // Can't delete while trying to register.
                    throw $a7cea3632a150641$var$ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */ );
                case 2:
                    if (!(entry.registrationStatus === 2 /* COMPLETED */ )) return [
                        3 /*break*/ ,
                        6
                    ];
                    if (!!navigator.onLine) return [
                        3 /*break*/ ,
                        3
                    ];
                    throw $a7cea3632a150641$var$ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */ );
                case 3:
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$deleteInstallationRequest(appConfig, entry)
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $a7cea3632a150641$var$remove(appConfig)
                    ];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 */ function $a7cea3632a150641$var$onIdChange(_a, callback) {
    var appConfig = _a.appConfig;
    $a7cea3632a150641$var$addCallback(appConfig, callback);
    return function() {
        $a7cea3632a150641$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$var$extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) throw $a7cea3632a150641$var$getMissingValueError("App Configuration");
    if (!app.name) throw $a7cea3632a150641$var$getMissingValueError("App Name");
    // Required app config keys
    var configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    try {
        for(var configKeys_1 = (0, $2WUgS.__values)(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()){
            var keyName = configKeys_1_1.value;
            if (!app.options[keyName]) throw $a7cea3632a150641$var$getMissingValueError(keyName);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $a7cea3632a150641$var$getMissingValueError(valueName) {
    return $a7cea3632a150641$var$ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cea3632a150641$export$6e695021ec3e22d4(instance) {
    var installationsName = "installations";
    instance.INTERNAL.registerComponent(new (0, $4TGB3.Component)(installationsName, function(container) {
        var app = container.getProvider("app").getImmediate();
        // Throws if app isn't configured properly.
        var appConfig = $a7cea3632a150641$var$extractAppConfig(app);
        var platformLoggerProvider = container.getProvider("platform-logger");
        var dependencies = {
            appConfig: appConfig,
            platformLoggerProvider: platformLoggerProvider
        };
        var installations = {
            app: app,
            getId: function() {
                return $a7cea3632a150641$var$getId(dependencies);
            },
            getToken: function(forceRefresh) {
                return $a7cea3632a150641$var$getToken(dependencies, forceRefresh);
            },
            delete: function() {
                return $a7cea3632a150641$var$deleteInstallation(dependencies);
            },
            onIdChange: function(callback) {
                return $a7cea3632a150641$var$onIdChange(dependencies, callback);
            }
        };
        return installations;
    }, "PUBLIC" /* PUBLIC */ ));
    instance.registerVersion($a7cea3632a150641$var$name, $a7cea3632a150641$var$version);
}
$a7cea3632a150641$export$6e695021ec3e22d4((0, $8eXKx.default));



var $i4pDv = parcelRequire("i4pDv");

var $eTAKc = parcelRequire("eTAKc");

var $4TGB3 = parcelRequire("4TGB3");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Key to attach FID to in gtag params.
var $7f3aa14dd87850fe$var$GA_FID_KEY = "firebase_id";
var $7f3aa14dd87850fe$var$ORIGIN_KEY = "origin";
var $7f3aa14dd87850fe$var$FETCH_TIMEOUT_MILLIS = 60000;
var $7f3aa14dd87850fe$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
var $7f3aa14dd87850fe$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
var $7f3aa14dd87850fe$var$GtagCommand;
(function(GtagCommand) {
    GtagCommand["EVENT"] = "event";
    GtagCommand["SET"] = "set";
    GtagCommand["CONFIG"] = "config";
})($7f3aa14dd87850fe$var$GtagCommand || ($7f3aa14dd87850fe$var$GtagCommand = {}));
/**
 * Officially recommended event names for gtag.js
 * Any other string is also allowed.
 *
 * @public
 */ var $7f3aa14dd87850fe$var$EventName;
(function(EventName) {
    EventName["ADD_SHIPPING_INFO"] = "add_shipping_info";
    EventName["ADD_PAYMENT_INFO"] = "add_payment_info";
    EventName["ADD_TO_CART"] = "add_to_cart";
    EventName["ADD_TO_WISHLIST"] = "add_to_wishlist";
    EventName["BEGIN_CHECKOUT"] = "begin_checkout";
    /**
     * @deprecated
     * This event name is deprecated and is unsupported in updated
     * Enhanced Ecommerce reports.
     */ EventName["CHECKOUT_PROGRESS"] = "checkout_progress";
    EventName["EXCEPTION"] = "exception";
    EventName["GENERATE_LEAD"] = "generate_lead";
    EventName["LOGIN"] = "login";
    EventName["PAGE_VIEW"] = "page_view";
    EventName["PURCHASE"] = "purchase";
    EventName["REFUND"] = "refund";
    EventName["REMOVE_FROM_CART"] = "remove_from_cart";
    EventName["SCREEN_VIEW"] = "screen_view";
    EventName["SEARCH"] = "search";
    EventName["SELECT_CONTENT"] = "select_content";
    EventName["SELECT_ITEM"] = "select_item";
    EventName["SELECT_PROMOTION"] = "select_promotion";
    /** @deprecated */ EventName["SET_CHECKOUT_OPTION"] = "set_checkout_option";
    EventName["SHARE"] = "share";
    EventName["SIGN_UP"] = "sign_up";
    EventName["TIMING_COMPLETE"] = "timing_complete";
    EventName["VIEW_CART"] = "view_cart";
    EventName["VIEW_ITEM"] = "view_item";
    EventName["VIEW_ITEM_LIST"] = "view_item_list";
    EventName["VIEW_PROMOTION"] = "view_promotion";
    EventName["VIEW_SEARCH_RESULTS"] = "view_search_results";
})($7f3aa14dd87850fe$var$EventName || ($7f3aa14dd87850fe$var$EventName = {}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ function $7f3aa14dd87850fe$var$logEvent(gtagFunction, initializationPromise, eventName, eventParams, options) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var measurementId, params;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.EVENT, eventName, eventParams);
                    return [
                        2 /*return*/ 
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _a.sent();
                    params = (0, $2WUgS.__assign)((0, $2WUgS.__assign)({}, eventParams), {
                        "send_to": measurementId
                    });
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.EVENT, eventName, params);
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ function $7f3aa14dd87850fe$var$setCurrentScreen(gtagFunction, initializationPromise, screenName, options) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var measurementId;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.SET, {
                        "screen_name": screenName
                    });
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _a.sent();
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.CONFIG, measurementId, {
                        update: true,
                        "screen_name": screenName
                    });
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ function $7f3aa14dd87850fe$var$setUserId(gtagFunction, initializationPromise, id, options) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var measurementId;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.SET, {
                        "user_id": id
                    });
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _a.sent();
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.CONFIG, measurementId, {
                        update: true,
                        "user_id": id
                    });
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ function $7f3aa14dd87850fe$var$setUserProperties(gtagFunction, initializationPromise, properties, options) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var flatProperties, _i, _a, key, measurementId;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(options && options.global)) return [
                        3 /*break*/ ,
                        1
                    ];
                    flatProperties = {};
                    for(_i = 0, _a = Object.keys(properties); _i < _a.length; _i++){
                        key = _a[_i];
                        // use dot notation for merge behavior in gtag.js
                        flatProperties["user_properties." + key] = properties[key];
                    }
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.SET, flatProperties);
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _b.sent();
                    gtagFunction($7f3aa14dd87850fe$var$GtagCommand.CONFIG, measurementId, {
                        update: true,
                        "user_properties": properties
                    });
                    _b.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ function $7f3aa14dd87850fe$var$setAnalyticsCollectionEnabled(initializationPromise, enabled) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var measurementId;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        initializationPromise
                    ];
                case 1:
                    measurementId = _a.sent();
                    window["ga-disable-" + measurementId] = !enabled;
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7f3aa14dd87850fe$var$logger = new (0, $i4pDv.Logger)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $7f3aa14dd87850fe$var$insertScriptTag(dataLayerName, measurementId) {
    var script = document.createElement("script");
    script.src = $7f3aa14dd87850fe$var$GTAG_URL + "?l=" + dataLayerName + "&id=" + measurementId;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $7f3aa14dd87850fe$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    var dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ function $7f3aa14dd87850fe$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var correspondingAppId, dynamicConfigResults, foundConfig, e_1;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    correspondingAppId = measurementIdToAppId[measurementId];
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    if (!correspondingAppId) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        initializationPromisesMap[correspondingAppId]
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        Promise.all(dynamicConfigPromisesList)
                    ];
                case 4:
                    dynamicConfigResults = _a.sent();
                    foundConfig = dynamicConfigResults.find(function(config) {
                        return config.measurementId === measurementId;
                    });
                    if (!foundConfig) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        initializationPromisesMap[foundConfig.appId]
                    ];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    e_1 = _a.sent();
                    $7f3aa14dd87850fe$var$logger.error(e_1);
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    gtagCore($7f3aa14dd87850fe$var$GtagCommand.CONFIG, measurementId, gtagParams);
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ function $7f3aa14dd87850fe$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var initializationPromisesToWaitFor, gaSendToList, dynamicConfigResults, _loop_1, _i, gaSendToList_1, sendToId, state_1, e_2;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    initializationPromisesToWaitFor = [];
                    if (!(gtagParams && gtagParams["send_to"])) return [
                        3 /*break*/ ,
                        2
                    ];
                    gaSendToList = gtagParams["send_to"];
                    // Make it an array if is isn't, so it can be dealt with the same way.
                    if (!Array.isArray(gaSendToList)) gaSendToList = [
                        gaSendToList
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(dynamicConfigPromisesList)
                    ];
                case 1:
                    dynamicConfigResults = _a.sent();
                    _loop_1 = function(sendToId) {
                        // Any fetched dynamic measurement ID that matches this 'send_to' ID
                        var foundConfig = dynamicConfigResults.find(function(config) {
                            return config.measurementId === sendToId;
                        });
                        var initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                        if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                        else {
                            // Found an item in 'send_to' that is not associated
                            // directly with an FID, possibly a group.  Empty this array,
                            // exit the loop early, and let it get populated below.
                            initializationPromisesToWaitFor = [];
                            return "break";
                        }
                    };
                    for(_i = 0, gaSendToList_1 = gaSendToList; _i < gaSendToList_1.length; _i++){
                        sendToId = gaSendToList_1[_i];
                        state_1 = _loop_1(sendToId);
                        if (state_1 === "break") break;
                    }
                    _a.label = 2;
                case 2:
                    // This will be unpopulated if there was no 'send_to' field , or
                    // if not all entries in the 'send_to' field could be mapped to
                    // a FID. In these cases, wait on all pending initialization promises.
                    if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
                    // Run core gtag function with args after all relevant initialization
                    // promises have been resolved.
                    return [
                        4 /*yield*/ ,
                        Promise.all(initializationPromisesToWaitFor)
                    ];
                case 3:
                    // Run core gtag function with args after all relevant initialization
                    // promises have been resolved.
                    _a.sent();
                    // Workaround for http://b/141370449 - third argument cannot be undefined.
                    gtagCore($7f3aa14dd87850fe$var$GtagCommand.EVENT, measurementId, gtagParams || {});
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    e_2 = _a.sent();
                    $7f3aa14dd87850fe$var$logger.error(e_2);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $7f3aa14dd87850fe$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ function gtagWrapper(command, idOrNameOrParams, gtagParams) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var e_3;
            return (0, $2WUgS.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        if (!(command === $7f3aa14dd87850fe$var$GtagCommand.EVENT)) return [
                            3 /*break*/ ,
                            2
                        ];
                        // If EVENT, second arg must be measurementId.
                        return [
                            4 /*yield*/ ,
                            $7f3aa14dd87850fe$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, idOrNameOrParams, gtagParams)
                        ];
                    case 1:
                        // If EVENT, second arg must be measurementId.
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(command === $7f3aa14dd87850fe$var$GtagCommand.CONFIG)) return [
                            3 /*break*/ ,
                            4
                        ];
                        // If CONFIG, second arg must be measurementId.
                        return [
                            4 /*yield*/ ,
                            $7f3aa14dd87850fe$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, idOrNameOrParams, gtagParams)
                        ];
                    case 3:
                        // If CONFIG, second arg must be measurementId.
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        // If SET, second arg must be params.
                        gtagCore($7f3aa14dd87850fe$var$GtagCommand.SET, idOrNameOrParams);
                        _a.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_3 = _a.sent();
                        $7f3aa14dd87850fe$var$logger.error(e_3);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $7f3aa14dd87850fe$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    var gtagCore = function() {
        var _args = [];
        for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $7f3aa14dd87850fe$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns first script tag in DOM matching our gtag url pattern.
 */ function $7f3aa14dd87850fe$var$findGtagScriptOnPage() {
    var scriptTags = window.document.getElementsByTagName("script");
    for(var _i = 0, _a = Object.values(scriptTags); _i < _a.length; _i++){
        var tag = _a[_i];
        if (tag.src && tag.src.includes($7f3aa14dd87850fe$var$GTAG_URL)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7f3aa14dd87850fe$var$_a;
var $7f3aa14dd87850fe$var$ERRORS = ($7f3aa14dd87850fe$var$_a = {}, $7f3aa14dd87850fe$var$_a["already-exists" /* ALREADY_EXISTS */ ] = "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.", $7f3aa14dd87850fe$var$_a["already-initialized" /* ALREADY_INITIALIZED */ ] = "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.", $7f3aa14dd87850fe$var$_a["interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */ ] = "Firebase Analytics Interop Component failed to instantiate: {$reason}", $7f3aa14dd87850fe$var$_a["invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */ ] = "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}", $7f3aa14dd87850fe$var$_a["indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ ] = "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}", $7f3aa14dd87850fe$var$_a["fetch-throttle" /* FETCH_THROTTLE */ ] = "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.", $7f3aa14dd87850fe$var$_a["config-fetch-failed" /* CONFIG_FETCH_FAILED */ ] = "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}", $7f3aa14dd87850fe$var$_a["no-api-key" /* NO_API_KEY */ ] = 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.', $7f3aa14dd87850fe$var$_a["no-app-id" /* NO_APP_ID */ ] = 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.', $7f3aa14dd87850fe$var$_a);
var $7f3aa14dd87850fe$var$ERROR_FACTORY = new (0, $eTAKc.ErrorFactory)("analytics", "Analytics", $7f3aa14dd87850fe$var$ERRORS);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ var $7f3aa14dd87850fe$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ var $7f3aa14dd87850fe$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ var $7f3aa14dd87850fe$var$RetryData = /** @class */ function() {
    function RetryData(throttleMetadata, intervalMillis) {
        if (throttleMetadata === void 0) throttleMetadata = {};
        if (intervalMillis === void 0) intervalMillis = $7f3aa14dd87850fe$var$BASE_INTERVAL_MILLIS;
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    RetryData.prototype.getThrottleMetadata = function(appId) {
        return this.throttleMetadata[appId];
    };
    RetryData.prototype.setThrottleMetadata = function(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    };
    RetryData.prototype.deleteThrottleMetadata = function(appId) {
        delete this.throttleMetadata[appId];
    };
    return RetryData;
}();
var $7f3aa14dd87850fe$var$defaultRetryData = new $7f3aa14dd87850fe$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $7f3aa14dd87850fe$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ function $7f3aa14dd87850fe$var$fetchDynamicConfig(appFields) {
    var _a;
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var appId, apiKey, request, appUrl, response, errorMessage, jsonResponse;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    appId = appFields.appId, apiKey = appFields.apiKey;
                    request = {
                        method: "GET",
                        headers: $7f3aa14dd87850fe$var$getHeaders(apiKey)
                    };
                    appUrl = $7f3aa14dd87850fe$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
                    return [
                        4 /*yield*/ ,
                        fetch(appUrl, request)
                    ];
                case 1:
                    response = _b.sent();
                    if (!(response.status !== 200 && response.status !== 304)) return [
                        3 /*break*/ ,
                        6
                    ];
                    errorMessage = "";
                    _b.label = 2;
                case 2:
                    _b.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        response.json()
                    ];
                case 3:
                    jsonResponse = _b.sent();
                    if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("config-fetch-failed" /* CONFIG_FETCH_FAILED */ , {
                        httpStatus: response.status,
                        responseMessage: errorMessage
                    });
                case 6:
                    return [
                        2 /*return*/ ,
                        response.json()
                    ];
            }
        });
    });
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ function $7f3aa14dd87850fe$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData, timeoutMillis) {
    if (retryData === void 0) retryData = $7f3aa14dd87850fe$var$defaultRetryData;
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var _a, appId, apiKey, measurementId, throttleMetadata, signal;
        var _this = this;
        return (0, $2WUgS.__generator)(this, function(_b) {
            _a = app.options, appId = _a.appId, apiKey = _a.apiKey, measurementId = _a.measurementId;
            if (!appId) throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */ );
            if (!apiKey) {
                if (measurementId) return [
                    2 /*return*/ ,
                    {
                        measurementId: measurementId,
                        appId: appId
                    }
                ];
                throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */ );
            }
            throttleMetadata = retryData.getThrottleMetadata(appId) || {
                backoffCount: 0,
                throttleEndTimeMillis: Date.now()
            };
            signal = new $7f3aa14dd87850fe$var$AnalyticsAbortSignal();
            setTimeout(function() {
                return (0, $2WUgS.__awaiter)(_this, void 0, void 0, function() {
                    return (0, $2WUgS.__generator)(this, function(_a) {
                        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
                        signal.abort();
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            }, timeoutMillis !== undefined ? timeoutMillis : $7f3aa14dd87850fe$var$FETCH_TIMEOUT_MILLIS);
            return [
                2 /*return*/ ,
                $7f3aa14dd87850fe$var$attemptFetchDynamicConfigWithRetry({
                    appId: appId,
                    apiKey: apiKey,
                    measurementId: measurementId
                }, throttleMetadata, signal, retryData)
            ];
        });
    });
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ function $7f3aa14dd87850fe$var$attemptFetchDynamicConfigWithRetry(appFields, _a, signal, retryData // for testing
) {
    var throttleEndTimeMillis = _a.throttleEndTimeMillis, backoffCount = _a.backoffCount;
    if (retryData === void 0) retryData = $7f3aa14dd87850fe$var$defaultRetryData;
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var appId, measurementId, e_1, response, e_2, backoffMillis, throttleMetadata;
        return (0, $2WUgS.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    appId = appFields.appId, measurementId = appFields.measurementId;
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        $7f3aa14dd87850fe$var$setAbortableTimeout(signal, throttleEndTimeMillis)
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    if (measurementId) {
                        $7f3aa14dd87850fe$var$logger.warn("Timed out fetching this Firebase app's measurement ID from the server." + (" Falling back to the measurement ID " + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + e_1.message + "]"));
                        return [
                            2 /*return*/ ,
                            {
                                appId: appId,
                                measurementId: measurementId
                            }
                        ];
                    }
                    throw e_1;
                case 4:
                    _b.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4 /*yield*/ ,
                        $7f3aa14dd87850fe$var$fetchDynamicConfig(appFields)
                    ];
                case 5:
                    response = _b.sent();
                    // Note the SDK only clears throttle state if response is success or non-retriable.
                    retryData.deleteThrottleMetadata(appId);
                    return [
                        2 /*return*/ ,
                        response
                    ];
                case 6:
                    e_2 = _b.sent();
                    if (!$7f3aa14dd87850fe$var$isRetriableError(e_2)) {
                        retryData.deleteThrottleMetadata(appId);
                        if (measurementId) {
                            $7f3aa14dd87850fe$var$logger.warn("Failed to fetch this Firebase app's measurement ID from the server." + (" Falling back to the measurement ID " + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + e_2.message + "]"));
                            return [
                                2 /*return*/ ,
                                {
                                    appId: appId,
                                    measurementId: measurementId
                                }
                            ];
                        } else throw e_2;
                    }
                    backoffMillis = Number(e_2.customData.httpStatus) === 503 ? (0, $eTAKc.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $7f3aa14dd87850fe$var$LONG_RETRY_FACTOR) : (0, $eTAKc.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
                    throttleMetadata = {
                        throttleEndTimeMillis: Date.now() + backoffMillis,
                        backoffCount: backoffCount + 1
                    };
                    // Persists state.
                    retryData.setThrottleMetadata(appId, throttleMetadata);
                    $7f3aa14dd87850fe$var$logger.debug("Calling attemptFetch again in " + backoffMillis + " millis");
                    return [
                        2 /*return*/ ,
                        $7f3aa14dd87850fe$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData)
                    ];
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $7f3aa14dd87850fe$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise(function(resolve, reject) {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        var timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(function() {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($7f3aa14dd87850fe$var$ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $7f3aa14dd87850fe$var$isRetriableError(e) {
    if (!(e instanceof (0, $eTAKc.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    var httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ var $7f3aa14dd87850fe$var$AnalyticsAbortSignal = /** @class */ function() {
    function AnalyticsAbortSignal() {
        this.listeners = [];
    }
    AnalyticsAbortSignal.prototype.addEventListener = function(listener) {
        this.listeners.push(listener);
    };
    AnalyticsAbortSignal.prototype.abort = function() {
        this.listeners.forEach(function(listener) {
            return listener();
        });
    };
    return AnalyticsAbortSignal;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7f3aa14dd87850fe$var$validateIndexedDB() {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e_1;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!!(0, $eTAKc.isIndexedDBAvailable)()) return [
                        3 /*break*/ ,
                        1
                    ];
                    $7f3aa14dd87850fe$var$logger.warn($7f3aa14dd87850fe$var$ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: "IndexedDB is not available in this environment."
                    }).message);
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $eTAKc.validateIndexedDBOpenable)()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _a.sent();
                    $7f3aa14dd87850fe$var$logger.warn($7f3aa14dd87850fe$var$ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: e_1
                    }).message);
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        true
                    ];
            }
        });
    });
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations FirebaseInstallations instance.
 *
 * @returns Measurement ID.
 */ function $7f3aa14dd87850fe$var$initializeIds(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var dynamicConfigPromise, fidPromise, _a, dynamicConfig, fid, configProperties;
        var _b;
        return (0, $2WUgS.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    dynamicConfigPromise = $7f3aa14dd87850fe$var$fetchDynamicConfigWithRetry(app);
                    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
                    dynamicConfigPromise.then(function(config) {
                        measurementIdToAppId[config.measurementId] = config.appId;
                        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $7f3aa14dd87850fe$var$logger.warn("The measurement ID in the local Firebase config (" + app.options.measurementId + ")" + (" does not match the measurement ID fetched from the server (" + config.measurementId + ").") + " To ensure analytics events are always sent to the correct Analytics property," + " update the" + " measurement ID field in the local config or remove it from the local config.");
                    }).catch(function(e) {
                        return $7f3aa14dd87850fe$var$logger.error(e);
                    });
                    // Add to list to track state of all dynamic config promises.
                    dynamicConfigPromisesList.push(dynamicConfigPromise);
                    fidPromise = $7f3aa14dd87850fe$var$validateIndexedDB().then(function(envIsValid) {
                        if (envIsValid) return installations.getId();
                        else return undefined;
                    });
                    return [
                        4 /*yield*/ ,
                        Promise.all([
                            dynamicConfigPromise,
                            fidPromise
                        ])
                    ];
                case 1:
                    _a = _c.sent(), dynamicConfig = _a[0], fid = _a[1];
                    // Detect if user has already put the gtag <script> tag on this page.
                    if (!$7f3aa14dd87850fe$var$findGtagScriptOnPage()) $7f3aa14dd87850fe$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
                    // This command initializes gtag.js and only needs to be called once for the entire web app,
                    // but since it is idempotent, we can call it multiple times.
                    // We keep it together with other initialization logic for better code structure.
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    gtagCore("js", new Date());
                    configProperties = (_b = {}, // guard against developers accidentally setting properties with prefix `firebase_`
                    _b[$7f3aa14dd87850fe$var$ORIGIN_KEY] = "firebase", _b.update = true, _b);
                    if (fid != null) configProperties[$7f3aa14dd87850fe$var$GA_FID_KEY] = fid;
                    // It should be the first config command called on this GA-ID
                    // Initialize this GA-ID and set FID on it using the gtag config API.
                    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
                    // `configProperties`.
                    gtagCore($7f3aa14dd87850fe$var$GtagCommand.CONFIG, dynamicConfig.measurementId, configProperties);
                    return [
                        2 /*return*/ ,
                        dynamicConfig.measurementId
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ var $7f3aa14dd87850fe$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ var $7f3aa14dd87850fe$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ var $7f3aa14dd87850fe$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ var $7f3aa14dd87850fe$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ var $7f3aa14dd87850fe$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ var $7f3aa14dd87850fe$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ var $7f3aa14dd87850fe$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ var $7f3aa14dd87850fe$var$globalInitDone = false;
/**
 * For testing
 */ function $7f3aa14dd87850fe$export$779c8e482cefabc0(newGlobalInitDone, newInitializationPromisesMap, newDynamicPromises) {
    if (newGlobalInitDone === void 0) newGlobalInitDone = false;
    if (newInitializationPromisesMap === void 0) newInitializationPromisesMap = {};
    if (newDynamicPromises === void 0) newDynamicPromises = [];
    $7f3aa14dd87850fe$var$globalInitDone = newGlobalInitDone;
    $7f3aa14dd87850fe$var$initializationPromisesMap = newInitializationPromisesMap;
    $7f3aa14dd87850fe$var$dynamicConfigPromisesList = newDynamicPromises;
    $7f3aa14dd87850fe$var$dataLayerName = "dataLayer";
    $7f3aa14dd87850fe$var$gtagName = "gtag";
}
/**
 * For testing
 */ function $7f3aa14dd87850fe$export$8ff36dd5b0c87ca7() {
    return {
        initializationPromisesMap: $7f3aa14dd87850fe$var$initializationPromisesMap,
        dynamicConfigPromisesList: $7f3aa14dd87850fe$var$dynamicConfigPromisesList
    };
}
/**
 * This must be run before calling firebase.analytics() or it won't
 * have any effect.
 * @param options Custom gtag and dataLayer names.
 */ function $7f3aa14dd87850fe$export$a5a6e0b888b2c992(options) {
    if ($7f3aa14dd87850fe$var$globalInitDone) throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $7f3aa14dd87850fe$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $7f3aa14dd87850fe$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $7f3aa14dd87850fe$var$warnOnBrowserContextMismatch() {
    var mismatchedEnvMessages = [];
    if ((0, $eTAKc.isBrowserExtension)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $eTAKc.areCookiesEnabled)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        var details = mismatchedEnvMessages.map(function(message, index) {
            return "(" + (index + 1) + ") " + message;
        }).join(" ");
        var err = $7f3aa14dd87850fe$var$ERROR_FACTORY.create("invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $7f3aa14dd87850fe$var$logger.warn(err.message);
    }
}
function $7f3aa14dd87850fe$export$e9008f2713103c6c(app, installations) {
    $7f3aa14dd87850fe$var$warnOnBrowserContextMismatch();
    var appId = app.options.appId;
    if (!appId) throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $7f3aa14dd87850fe$var$logger.warn('The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest' + (" measurement ID for this Firebase app. Falling back to the measurement ID " + app.options.measurementId) + ' provided in the "measurementId" field in the local Firebase config.');
        else throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */ );
    }
    if ($7f3aa14dd87850fe$var$initializationPromisesMap[appId] != null) throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("already-exists" /* ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$7f3aa14dd87850fe$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $7f3aa14dd87850fe$var$getOrCreateDataLayer($7f3aa14dd87850fe$var$dataLayerName);
        var _a = $7f3aa14dd87850fe$var$wrapOrCreateGtag($7f3aa14dd87850fe$var$initializationPromisesMap, $7f3aa14dd87850fe$var$dynamicConfigPromisesList, $7f3aa14dd87850fe$var$measurementIdToAppId, $7f3aa14dd87850fe$var$dataLayerName, $7f3aa14dd87850fe$var$gtagName), wrappedGtag = _a.wrappedGtag, gtagCore = _a.gtagCore;
        $7f3aa14dd87850fe$var$wrappedGtagFunction = wrappedGtag;
        $7f3aa14dd87850fe$var$gtagCoreFunction = gtagCore;
        $7f3aa14dd87850fe$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $7f3aa14dd87850fe$var$initializationPromisesMap[appId] = $7f3aa14dd87850fe$var$initializeIds(app, $7f3aa14dd87850fe$var$dynamicConfigPromisesList, $7f3aa14dd87850fe$var$measurementIdToAppId, installations, $7f3aa14dd87850fe$var$gtagCoreFunction, $7f3aa14dd87850fe$var$dataLayerName);
    var analyticsInstance = {
        app: app,
        // Public methods return void for API simplicity and to better match gtag,
        // while internal implementations return promises.
        logEvent: function(eventName, eventParams, options) {
            $7f3aa14dd87850fe$var$logEvent($7f3aa14dd87850fe$var$wrappedGtagFunction, $7f3aa14dd87850fe$var$initializationPromisesMap[appId], eventName, eventParams, options).catch(function(e) {
                return $7f3aa14dd87850fe$var$logger.error(e);
            });
        },
        setCurrentScreen: function(screenName, options) {
            $7f3aa14dd87850fe$var$setCurrentScreen($7f3aa14dd87850fe$var$wrappedGtagFunction, $7f3aa14dd87850fe$var$initializationPromisesMap[appId], screenName, options).catch(function(e) {
                return $7f3aa14dd87850fe$var$logger.error(e);
            });
        },
        setUserId: function(id, options) {
            $7f3aa14dd87850fe$var$setUserId($7f3aa14dd87850fe$var$wrappedGtagFunction, $7f3aa14dd87850fe$var$initializationPromisesMap[appId], id, options).catch(function(e) {
                return $7f3aa14dd87850fe$var$logger.error(e);
            });
        },
        setUserProperties: function(properties, options) {
            $7f3aa14dd87850fe$var$setUserProperties($7f3aa14dd87850fe$var$wrappedGtagFunction, $7f3aa14dd87850fe$var$initializationPromisesMap[appId], properties, options).catch(function(e) {
                return $7f3aa14dd87850fe$var$logger.error(e);
            });
        },
        setAnalyticsCollectionEnabled: function(enabled) {
            $7f3aa14dd87850fe$var$setAnalyticsCollectionEnabled($7f3aa14dd87850fe$var$initializationPromisesMap[appId], enabled).catch(function(e) {
                return $7f3aa14dd87850fe$var$logger.error(e);
            });
        },
        INTERNAL: {
            delete: function() {
                delete $7f3aa14dd87850fe$var$initializationPromisesMap[appId];
                return Promise.resolve();
            }
        }
    };
    return analyticsInstance;
}
var $7f3aa14dd87850fe$var$name = "@firebase/analytics";
var $7f3aa14dd87850fe$var$version = "0.6.18";
/**
 * Type constant for Firebase Analytics.
 */ var $7f3aa14dd87850fe$var$ANALYTICS_TYPE = "analytics";
function $7f3aa14dd87850fe$export$7c804eebd0c1f2e0(instance) {
    instance.INTERNAL.registerComponent(new (0, $4TGB3.Component)($7f3aa14dd87850fe$var$ANALYTICS_TYPE, function(container) {
        // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        var installations = container.getProvider("installations").getImmediate();
        return $7f3aa14dd87850fe$export$e9008f2713103c6c(app, installations);
    }, "PUBLIC" /* PUBLIC */ ).setServiceProps({
        settings: $7f3aa14dd87850fe$export$a5a6e0b888b2c992,
        EventName: $7f3aa14dd87850fe$var$EventName,
        isSupported: $7f3aa14dd87850fe$var$isSupported
    }));
    instance.INTERNAL.registerComponent(new (0, $4TGB3.Component)("analytics-internal", internalFactory, "PRIVATE" /* PRIVATE */ ));
    instance.registerVersion($7f3aa14dd87850fe$var$name, $7f3aa14dd87850fe$var$version);
    function internalFactory(container) {
        try {
            var analytics = container.getProvider($7f3aa14dd87850fe$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: analytics.logEvent
            };
        } catch (e) {
            throw $7f3aa14dd87850fe$var$ERROR_FACTORY.create("interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$7f3aa14dd87850fe$export$7c804eebd0c1f2e0((0, $8eXKx.default));
/**
 * this is a public static method provided to users that wraps four different checks:
 *
 * 1. check if it's not a browser extension environment.
 * 1. check if cookie is enabled in current browser.
 * 3. check if IndexedDB is supported by the browser environment.
 * 4. check if the current browser context is valid for using IndexedDB.
 *
 */ function $7f3aa14dd87850fe$var$isSupported() {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var isDBOpenable;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if ((0, $eTAKc.isBrowserExtension)()) return [
                        2 /*return*/ ,
                        false
                    ];
                    if (!(0, $eTAKc.areCookiesEnabled)()) return [
                        2 /*return*/ ,
                        false
                    ];
                    if (!(0, $eTAKc.isIndexedDBAvailable)()) return [
                        2 /*return*/ ,
                        false
                    ];
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, $eTAKc.validateIndexedDBOpenable)()
                    ];
                case 2:
                    isDBOpenable = _a.sent();
                    return [
                        2 /*return*/ ,
                        isDBOpenable
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}




parcelRequire("dZzSU");
var $8eXKx = parcelRequire("8eXKx");
parcelRequire("iG8u9");
var $9d8fdf02b8ce4d4a$exports = {};

var $8eXKx = parcelRequire("8eXKx");

var $4TGB3 = parcelRequire("4TGB3");

var $eTAKc = parcelRequire("eTAKc");

var $2WUgS = parcelRequire("2WUgS");

var $i4pDv = parcelRequire("i4pDv");

var $hvPjh = parcelRequire("hvPjh");
var $9d8fdf02b8ce4d4a$var$name = "@firebase/database";
var $9d8fdf02b8ce4d4a$var$version = "0.11.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ var $9d8fdf02b8ce4d4a$var$SDK_VERSION = "";
// SDK_VERSION should be set before any database instance is created
function $9d8fdf02b8ce4d4a$var$setSDKVersion(version) {
    $9d8fdf02b8ce4d4a$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ var $9d8fdf02b8ce4d4a$var$DOMStorageWrapper = /** @class */ function() {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = "firebase:";
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ DOMStorageWrapper.prototype.set = function(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $eTAKc.stringify)(value));
    };
    /**
     * @returns The value that was stored under this key, or null
     */ DOMStorageWrapper.prototype.get = function(key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $eTAKc.jsonEval)(storedVal);
    };
    DOMStorageWrapper.prototype.remove = function(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    DOMStorageWrapper.prototype.prefixedName_ = function(name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function() {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ var $9d8fdf02b8ce4d4a$var$MemoryStorage = /** @class */ function() {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    };
    MemoryStorage.prototype.get = function(key) {
        if ((0, $eTAKc.contains)(this.cache_, key)) return this.cache_[key];
        return null;
    };
    MemoryStorage.prototype.remove = function(key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ var $9d8fdf02b8ce4d4a$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== "undefined" && typeof window[domStorageName] !== "undefined") {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem("firebase:sentinel", "cache");
            domStorage.removeItem("firebase:sentinel");
            return new $9d8fdf02b8ce4d4a$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $9d8fdf02b8ce4d4a$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ var $9d8fdf02b8ce4d4a$var$PersistentStorage = $9d8fdf02b8ce4d4a$var$createStoragefor("localStorage");
/** A storage object that only lasts one session */ var $9d8fdf02b8ce4d4a$var$SessionStorage = $9d8fdf02b8ce4d4a$var$createStoragefor("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$logClient = new (0, $i4pDv.Logger)("@firebase/database");
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ var $9d8fdf02b8ce4d4a$var$LUIDGenerator = function() {
    var id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ var $9d8fdf02b8ce4d4a$var$sha1 = function(str) {
    var utf8Bytes = (0, $eTAKc.stringToByteArray)(str);
    var sha1 = new (0, $eTAKc.Sha1)();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return (0, $eTAKc.base64).encodeByteArray(sha1Bytes);
};
var $9d8fdf02b8ce4d4a$var$buildLogMessage_ = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "";
    for(var i = 0; i < varArgs.length; i++){
        var arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === "number") message += $9d8fdf02b8ce4d4a$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === "object") message += (0, $eTAKc.stringify)(arg);
        else message += arg;
        message += " ";
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ var $9d8fdf02b8ce4d4a$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ var $9d8fdf02b8ce4d4a$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ var $9d8fdf02b8ce4d4a$export$4e1d237eb9e560af = function(logger_, persistent) {
    (0, $eTAKc.assert)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $9d8fdf02b8ce4d4a$var$logClient.logLevel = (0, $i4pDv.LogLevel).VERBOSE;
        $9d8fdf02b8ce4d4a$var$logger = $9d8fdf02b8ce4d4a$var$logClient.log.bind($9d8fdf02b8ce4d4a$var$logClient);
        if (persistent) $9d8fdf02b8ce4d4a$var$SessionStorage.set("logging_enabled", true);
    } else if (typeof logger_ === "function") $9d8fdf02b8ce4d4a$var$logger = logger_;
    else {
        $9d8fdf02b8ce4d4a$var$logger = null;
        $9d8fdf02b8ce4d4a$var$SessionStorage.remove("logging_enabled");
    }
};
var $9d8fdf02b8ce4d4a$var$log = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    if ($9d8fdf02b8ce4d4a$var$firstLog_ === true) {
        $9d8fdf02b8ce4d4a$var$firstLog_ = false;
        if ($9d8fdf02b8ce4d4a$var$logger === null && $9d8fdf02b8ce4d4a$var$SessionStorage.get("logging_enabled") === true) $9d8fdf02b8ce4d4a$export$4e1d237eb9e560af(true);
    }
    if ($9d8fdf02b8ce4d4a$var$logger) {
        var message = $9d8fdf02b8ce4d4a$var$buildLogMessage_.apply(null, varArgs);
        $9d8fdf02b8ce4d4a$var$logger(message);
    }
};
var $9d8fdf02b8ce4d4a$var$logWrapper = function(prefix) {
    return function() {
        var varArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
        $9d8fdf02b8ce4d4a$var$log.apply(void 0, (0, $2WUgS.__spreadArray)([
            prefix
        ], (0, $2WUgS.__read)(varArgs)));
    };
};
var $9d8fdf02b8ce4d4a$var$error = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "FIREBASE INTERNAL ERROR: " + $9d8fdf02b8ce4d4a$var$buildLogMessage_.apply(void 0, (0, $2WUgS.__spreadArray)([], (0, $2WUgS.__read)(varArgs)));
    $9d8fdf02b8ce4d4a$var$logClient.error(message);
};
var $9d8fdf02b8ce4d4a$var$fatal = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "FIREBASE FATAL ERROR: " + $9d8fdf02b8ce4d4a$var$buildLogMessage_.apply(void 0, (0, $2WUgS.__spreadArray)([], (0, $2WUgS.__read)(varArgs)));
    $9d8fdf02b8ce4d4a$var$logClient.error(message);
    throw new Error(message);
};
var $9d8fdf02b8ce4d4a$var$warn = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "FIREBASE WARNING: " + $9d8fdf02b8ce4d4a$var$buildLogMessage_.apply(void 0, (0, $2WUgS.__spreadArray)([], (0, $2WUgS.__read)(varArgs)));
    $9d8fdf02b8ce4d4a$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ var $9d8fdf02b8ce4d4a$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== "undefined" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1) $9d8fdf02b8ce4d4a$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ var $9d8fdf02b8ce4d4a$var$isInvalidJSONNumber = function(data) {
    return typeof data === "number" && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
var $9d8fdf02b8ce4d4a$var$executeWhenDOMReady = function(fn) {
    if ((0, $eTAKc.isNodeSdk)() || document.readyState === "complete") fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function() {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener("DOMContentLoaded", wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener("load", wrappedFn_1, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent("onreadystatechange", function() {
                if (document.readyState === "complete") wrappedFn_1();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent("onload", wrappedFn_1);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ var $9d8fdf02b8ce4d4a$var$MIN_NAME = "[MIN_NAME]";
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ var $9d8fdf02b8ce4d4a$var$MAX_NAME = "[MAX_NAME]";
/**
 * Compares valid Firebase key names, plus min and max name
 */ var $9d8fdf02b8ce4d4a$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $9d8fdf02b8ce4d4a$var$MIN_NAME || b === $9d8fdf02b8ce4d4a$var$MAX_NAME) return -1;
    else if (b === $9d8fdf02b8ce4d4a$var$MIN_NAME || a === $9d8fdf02b8ce4d4a$var$MAX_NAME) return 1;
    else {
        var aAsInt = $9d8fdf02b8ce4d4a$var$tryParseInt(a), bAsInt = $9d8fdf02b8ce4d4a$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ var $9d8fdf02b8ce4d4a$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
var $9d8fdf02b8ce4d4a$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error("Missing required key (" + key + ") in object: " + (0, $eTAKc.stringify)(obj));
};
var $9d8fdf02b8ce4d4a$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== "object" || obj === null) return (0, $eTAKc.stringify)(obj);
    var keys = [];
    // eslint-disable-next-line guard-for-in
    for(var k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = "{";
    for(var i = 0; i < keys.length; i++){
        if (i !== 0) key += ",";
        key += (0, $eTAKc.stringify)(keys[i]);
        key += ":";
        key += $9d8fdf02b8ce4d4a$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += "}";
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ var $9d8fdf02b8ce4d4a$var$splitStringBySize = function(str, segsize) {
    var len = str.length;
    if (len <= segsize) return [
        str
    ];
    var dataSegs = [];
    for(var c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $9d8fdf02b8ce4d4a$var$each(obj, fn) {
    for(var key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ var $9d8fdf02b8ce4d4a$var$doubleToIEEE754String = function(v) {
    (0, $eTAKc.assert)(!$9d8fdf02b8ce4d4a$var$isInvalidJSONNumber(v), "Invalid JSON number"); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << ebits - 1) - 1;
    var s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    var bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    var str = bits.join("");
    // Return the data as a hex string. --MJL
    var hexByteString = "";
    for(i = 0; i < 64; i += 8){
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = "0" + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ var $9d8fdf02b8ce4d4a$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === "object" && window["chrome"] && window["chrome"]["extension"] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ var $9d8fdf02b8ce4d4a$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === "object" && typeof Windows.UI === "object";
};
/**
 * Converts a server error code to a Javascript Error
 */ function $9d8fdf02b8ce4d4a$var$errorForServerCode(code, query) {
    var reason = "Unknown Error";
    if (code === "too_big") reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === "permission_denied") reason = "Client doesn't have permission to access the desired data.";
    else if (code === "unavailable") reason = "The service is unavailable";
    var error = new Error(code + " at " + query._path.toString() + ": " + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ var $9d8fdf02b8ce4d4a$var$INTEGER_REGEXP_ = new RegExp("^-?(0*)\\d{1,10}$");
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ var $9d8fdf02b8ce4d4a$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in kyes, the maximum possible 32-bit integer.
 */ var $9d8fdf02b8ce4d4a$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ var $9d8fdf02b8ce4d4a$var$tryParseInt = function(str) {
    if ($9d8fdf02b8ce4d4a$var$INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= $9d8fdf02b8ce4d4a$var$INTEGER_32_MIN && intVal <= $9d8fdf02b8ce4d4a$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ var $9d8fdf02b8ce4d4a$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function() {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || "";
            $9d8fdf02b8ce4d4a$var$warn("Exception was thrown by user callback.", stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ var $9d8fdf02b8ce4d4a$var$beingCrawled = function() {
    var userAgent = typeof window === "object" && window["navigator"] && window["navigator"]["userAgent"] || "";
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ var $9d8fdf02b8ce4d4a$var$setTimeoutNonBlocking = function(fn, time) {
    var timeout = setTimeout(fn, time);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof timeout === "object" && timeout["unref"]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout["unref"]();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ var $9d8fdf02b8ce4d4a$var$AppCheckTokenProvider = /** @class */ function() {
    function AppCheckTokenProvider(appName_, appCheckProvider) {
        var _this = this;
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then(function(appCheck) {
            return _this.appCheck = appCheck;
        });
    }
    AppCheckTokenProvider.prototype.getToken = function(forceRefresh) {
        var _this = this;
        if (!this.appCheck) return new Promise(function(resolve, reject) {
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(function() {
                if (_this.appCheck) _this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    };
    AppCheckTokenProvider.prototype.addTokenChangeListener = function(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then(function(appCheck) {
            return appCheck.addTokenListener(listener);
        });
    };
    AppCheckTokenProvider.prototype.notifyForInvalidToken = function() {
        $9d8fdf02b8ce4d4a$var$warn('Provided AppCheck credentials for the app named "' + this.appName_ + '" ' + "are invalid. This usually indicates your app was not initialized correctly.");
    };
    return AppCheckTokenProvider;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ var $9d8fdf02b8ce4d4a$var$FirebaseAuthTokenProvider = /** @class */ function() {
    function FirebaseAuthTokenProvider(appName_, firebaseOptions_, authProvider_) {
        var _this = this;
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit(function(auth) {
            return _this.auth_ = auth;
        });
    }
    FirebaseAuthTokenProvider.prototype.getToken = function(forceRefresh) {
        var _this = this;
        if (!this.auth_) return new Promise(function(resolve, reject) {
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(function() {
                if (_this.auth_) _this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch(function(error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === "auth/token-not-initialized") {
                $9d8fdf02b8ce4d4a$var$log("Got auth/token-not-initialized error.  Treating as null token.");
                return null;
            } else return Promise.reject(error);
        });
    };
    FirebaseAuthTokenProvider.prototype.addTokenChangeListener = function(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then(function(auth) {
            return auth.addAuthTokenListener(listener);
        });
    };
    FirebaseAuthTokenProvider.prototype.removeTokenChangeListener = function(listener) {
        this.authProvider_.get().then(function(auth) {
            return auth.removeAuthTokenListener(listener);
        });
    };
    FirebaseAuthTokenProvider.prototype.notifyForInvalidToken = function() {
        var errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + "initialized correctly. ";
        if ("credential" in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ("serviceAccount" in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $9d8fdf02b8ce4d4a$var$warn(errorMessage);
    };
    return FirebaseAuthTokenProvider;
}();
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ var $9d8fdf02b8ce4d4a$var$EmulatorTokenProvider = /** @class */ function() {
    function EmulatorTokenProvider(accessToken) {
        this.accessToken = accessToken;
    }
    EmulatorTokenProvider.prototype.getToken = function(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    };
    EmulatorTokenProvider.prototype.addTokenChangeListener = function(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    };
    EmulatorTokenProvider.prototype.removeTokenChangeListener = function(listener) {};
    EmulatorTokenProvider.prototype.notifyForInvalidToken = function() {};
    /** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ EmulatorTokenProvider.OWNER = "owner";
    return EmulatorTokenProvider;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$PROTOCOL_VERSION = "5";
var $9d8fdf02b8ce4d4a$var$VERSION_PARAM = "v";
var $9d8fdf02b8ce4d4a$var$TRANSPORT_SESSION_PARAM = "s";
var $9d8fdf02b8ce4d4a$var$REFERER_PARAM = "r";
var $9d8fdf02b8ce4d4a$var$FORGE_REF = "f";
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
var $9d8fdf02b8ce4d4a$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
var $9d8fdf02b8ce4d4a$var$LAST_SESSION_PARAM = "ls";
var $9d8fdf02b8ce4d4a$var$APPLICATION_ID_PARAM = "p";
var $9d8fdf02b8ce4d4a$var$APP_CHECK_TOKEN_PARAM = "ac";
var $9d8fdf02b8ce4d4a$var$WEBSOCKET = "websocket";
var $9d8fdf02b8ce4d4a$var$LONG_POLLING = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ var $9d8fdf02b8ce4d4a$var$RepoInfo = /** @class */ function() {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ function RepoInfo(host, secure, namespace, webSocketOnly, nodeAdmin, persistenceKey, includeNamespaceInQueryParams) {
        if (nodeAdmin === void 0) nodeAdmin = false;
        if (persistenceKey === void 0) persistenceKey = "";
        if (includeNamespaceInQueryParams === void 0) includeNamespaceInQueryParams = false;
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf(".") + 1);
        this.internalHost = $9d8fdf02b8ce4d4a$var$PersistentStorage.get("host:" + host) || this._host;
    }
    RepoInfo.prototype.isCacheableHost = function() {
        return this.internalHost.substr(0, 2) === "s-";
    };
    RepoInfo.prototype.isCustomHost = function() {
        return this._domain !== "firebaseio.com" && this._domain !== "firebaseio-demo.com";
    };
    Object.defineProperty(RepoInfo.prototype, "host", {
        get: function() {
            return this._host;
        },
        set: function(newHost) {
            if (newHost !== this.internalHost) {
                this.internalHost = newHost;
                if (this.isCacheableHost()) $9d8fdf02b8ce4d4a$var$PersistentStorage.set("host:" + this._host, this.internalHost);
            }
        },
        enumerable: false,
        configurable: true
    });
    RepoInfo.prototype.toString = function() {
        var str = this.toURLString();
        if (this.persistenceKey) str += "<" + this.persistenceKey + ">";
        return str;
    };
    RepoInfo.prototype.toURLString = function() {
        var protocol = this.secure ? "https://" : "http://";
        var query = this.includeNamespaceInQueryParams ? "?ns=" + this.namespace : "";
        return "" + protocol + this.host + "/" + query;
    };
    return RepoInfo;
}();
function $9d8fdf02b8ce4d4a$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $9d8fdf02b8ce4d4a$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $eTAKc.assert)(typeof type === "string", "typeof type must == string");
    (0, $eTAKc.assert)(typeof params === "object", "typeof params must == object");
    var connURL;
    if (type === $9d8fdf02b8ce4d4a$var$WEBSOCKET) connURL = (repoInfo.secure ? "wss://" : "ws://") + repoInfo.internalHost + "/.ws?";
    else if (type === $9d8fdf02b8ce4d4a$var$LONG_POLLING) connURL = (repoInfo.secure ? "https://" : "http://") + repoInfo.internalHost + "/.lp?";
    else throw new Error("Unknown connection type: " + type);
    if ($9d8fdf02b8ce4d4a$var$repoInfoNeedsQueryParam(repoInfo)) params["ns"] = repoInfo.namespace;
    var pairs = [];
    $9d8fdf02b8ce4d4a$var$each(params, function(key, value) {
        pairs.push(key + "=" + value);
    });
    return connURL + pairs.join("&");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ var $9d8fdf02b8ce4d4a$var$StatsCollection = /** @class */ function() {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function(name, amount) {
        if (amount === void 0) amount = 1;
        if (!(0, $eTAKc.contains)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function() {
        return (0, $eTAKc.deepCopy)(this.counters_);
    };
    return StatsCollection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$collections = {};
var $9d8fdf02b8ce4d4a$var$reporters = {};
function $9d8fdf02b8ce4d4a$var$statsManagerGetCollection(repoInfo) {
    var hashString = repoInfo.toString();
    if (!$9d8fdf02b8ce4d4a$var$collections[hashString]) $9d8fdf02b8ce4d4a$var$collections[hashString] = new $9d8fdf02b8ce4d4a$var$StatsCollection();
    return $9d8fdf02b8ce4d4a$var$collections[hashString];
}
function $9d8fdf02b8ce4d4a$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    var hashString = repoInfo.toString();
    if (!$9d8fdf02b8ce4d4a$var$reporters[hashString]) $9d8fdf02b8ce4d4a$var$reporters[hashString] = creatorFunction();
    return $9d8fdf02b8ce4d4a$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ var $9d8fdf02b8ce4d4a$var$PacketReceiver = /** @class */ function() {
    /**
     * @param onMessage_
     */ function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ PacketReceiver.prototype.handleResponse = function(requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function() {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function(i) {
                if (toProcess[i]) $9d8fdf02b8ce4d4a$var$exceptionGuard(function() {
                    _this.onMessage_(toProcess[i]);
                });
            };
            for(var i = 0; i < toProcess.length; ++i)_loop_2(i);
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while(this.pendingResponses[this.currentResponseNum]){
            var state_1 = _loop_1();
            if (state_1 === "break") break;
        }
    };
    return PacketReceiver;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_START_PARAM = "start";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = "close";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = "pLPCommand";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_DATA_CB_NAME = "pRTLPCB";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_ID_PARAM = "id";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_PW_PARAM = "pw";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_SERIAL_PARAM = "ser";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = "cb";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = "seg";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = "ts";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_DATA_PARAM = "d";
var $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = "dframe";
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var $9d8fdf02b8ce4d4a$var$MAX_URL_DATA_SIZE = 1870;
var $9d8fdf02b8ce4d4a$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var $9d8fdf02b8ce4d4a$var$MAX_PAYLOAD_SIZE = $9d8fdf02b8ce4d4a$var$MAX_URL_DATA_SIZE - $9d8fdf02b8ce4d4a$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ var $9d8fdf02b8ce4d4a$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ var $9d8fdf02b8ce4d4a$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ var $9d8fdf02b8ce4d4a$var$BrowserPollConnection = /** @class */ function() {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ function BrowserPollConnection(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId) {
        var _this = this;
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $9d8fdf02b8ce4d4a$var$logWrapper(connId);
        this.stats_ = $9d8fdf02b8ce4d4a$var$statsManagerGetCollection(repoInfo);
        this.urlFn = function(params) {
            // Always add the token if we have one.
            if (_this.appCheckToken) params[$9d8fdf02b8ce4d4a$var$APP_CHECK_TOKEN_PARAM] = _this.appCheckToken;
            return $9d8fdf02b8ce4d4a$var$repoInfoConnectionURL(repoInfo, $9d8fdf02b8ce4d4a$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ BrowserPollConnection.prototype.open = function(onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $9d8fdf02b8ce4d4a$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function() {
            _this.log_("Timed out trying to connect.");
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($9d8fdf02b8ce4d4a$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $9d8fdf02b8ce4d4a$var$executeWhenDOMReady(function() {
            if (_this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new $9d8fdf02b8ce4d4a$var$FirebaseIFrameScriptHolder(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a = (0, $2WUgS.__read)(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2];
                _a[3];
                _a[4];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder) return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command === $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                } else if (command === $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function() {
                            _this.onClosed_();
                        });
                    } else _this.onClosed_();
                } else throw new Error("Unrecognized command received: " + command);
            }, function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a = (0, $2WUgS.__read)(args, 2), pN = _a[0], data = _a[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function() {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_START_PARAM] = "t";
            urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$9d8fdf02b8ce4d4a$var$VERSION_PARAM] = $9d8fdf02b8ce4d4a$var$PROTOCOL_VERSION;
            if (_this.transportSessionId) urlParams[$9d8fdf02b8ce4d4a$var$TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            if (_this.lastSessionId) urlParams[$9d8fdf02b8ce4d4a$var$LAST_SESSION_PARAM] = _this.lastSessionId;
            if (_this.applicationId) urlParams[$9d8fdf02b8ce4d4a$var$APPLICATION_ID_PARAM] = _this.applicationId;
            if (_this.appCheckToken) urlParams[$9d8fdf02b8ce4d4a$var$APP_CHECK_TOKEN_PARAM] = _this.appCheckToken;
            if (typeof location !== "undefined" && location.hostname && $9d8fdf02b8ce4d4a$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$9d8fdf02b8ce4d4a$var$REFERER_PARAM] = $9d8fdf02b8ce4d4a$var$FORGE_REF;
            var connectURL = _this.urlFn(urlParams);
            _this.log_("Connecting via long-poll to " + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function() {
            /* do nothing */ });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ BrowserPollConnection.prototype.start = function() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */ BrowserPollConnection.forceAllow = function() {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */ BrowserPollConnection.forceDisallow = function() {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function() {
        if ((0, $eTAKc.isNodeSdk)()) return false;
        else if (BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !BrowserPollConnection.forceDisallow_ && typeof document !== "undefined" && document.createElement != null && !$9d8fdf02b8ce4d4a$var$isChromeExtensionContentScript() && !$9d8fdf02b8ce4d4a$var$isWindowsStoreApp();
    };
    /**
     * No-op for polling
     */ BrowserPollConnection.prototype.markConnectionHealthy = function() {};
    /**
     * Stops polling and cleans up the iframe
     */ BrowserPollConnection.prototype.shutdown_ = function() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     */ BrowserPollConnection.prototype.onClosed_ = function() {
        if (!this.isClosed_) {
            this.log_("Longpoll is closing itself");
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ BrowserPollConnection.prototype.close = function() {
        if (!this.isClosed_) {
            this.log_("Longpoll is being closed.");
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ BrowserPollConnection.prototype.send = function(data) {
        var dataStr = (0, $eTAKc.stringify)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = (0, $eTAKc.base64Encode)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = $9d8fdf02b8ce4d4a$var$splitStringBySize(base64data, $9d8fdf02b8ce4d4a$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(var i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ BrowserPollConnection.prototype.addDisconnectPingFrame = function(id, pw) {
        if ((0, $eTAKc.isNodeSdk)()) return;
        this.myDisconnFrame = document.createElement("iframe");
        var urlParams = {};
        urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = "t";
        urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = "none";
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     */ BrowserPollConnection.prototype.incrementIncomingBytes_ = function(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = (0, $eTAKc.stringify)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter("bytes_received", bytesReceived);
    };
    return BrowserPollConnection;
}();
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ var $9d8fdf02b8ce4d4a$var$FirebaseIFrameScriptHolder = /** @class */ function() {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $eTAKc.isNodeSdk)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $9d8fdf02b8ce4d4a$var$LUIDGenerator();
            window[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = "";
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === "javascript:") {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = "<html><body>" + script + "</body></html>";
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $9d8fdf02b8ce4d4a$var$log("frame writing exception");
                if (e.stack) $9d8fdf02b8ce4d4a$var$log(e.stack);
                $9d8fdf02b8ce4d4a$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ FirebaseIFrameScriptHolder.createIFrame_ = function() {
        var iframe = document.createElement("iframe");
        iframe.style.display = "none";
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $9d8fdf02b8ce4d4a$var$log("No IE domain setting required");
            } catch (e) {
                var domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */ FirebaseIFrameScriptHolder.prototype.close = function() {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = "";
            setTimeout(function() {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ FirebaseIFrameScriptHolder.prototype.startLongPoll = function(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ FirebaseIFrameScriptHolder.prototype.newRequest_ = function() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = "";
            var i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $9d8fdf02b8ce4d4a$var$SEG_HEADER_SIZE + curDataString.length <= $9d8fdf02b8ce4d4a$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + "&" + $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + "=" + theSeg.seg + "&" + $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + "=" + theSeg.ts + "&" + $9d8fdf02b8ce4d4a$var$FIREBASE_LONGPOLL_DATA_PARAM + i + "=" + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ FirebaseIFrameScriptHolder.prototype.enqueueSegment = function(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function(url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        var doNewRequest = function() {
            _this.outstandingRequests.delete(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor($9d8fdf02b8ce4d4a$var$KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function() {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ FirebaseIFrameScriptHolder.prototype.addTag = function(url, loadCB) {
        var _this = this;
        if ((0, $eTAKc.isNodeSdk)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(function() {
            try {
                // if we're already closed, don't add this poll
                if (!_this.sendNewPolls) return;
                var newScript_1 = _this.myIFrame.doc.createElement("script");
                newScript_1.type = "text/javascript";
                newScript_1.async = true;
                newScript_1.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript_1.onload = newScript_1.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var rstate = newScript_1.readyState;
                    if (!rstate || rstate === "loaded" || rstate === "complete") {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript_1.onload = newScript_1.onreadystatechange = null;
                        if (newScript_1.parentNode) newScript_1.parentNode.removeChild(newScript_1);
                        loadCB();
                    }
                };
                newScript_1.onerror = function() {
                    $9d8fdf02b8ce4d4a$var$log("Long-poll script failed to load: " + url);
                    _this.sendNewPolls = false;
                    _this.close();
                };
                _this.myIFrame.doc.body.appendChild(newScript_1);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    };
    return FirebaseIFrameScriptHolder;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
var $9d8fdf02b8ce4d4a$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var $9d8fdf02b8ce4d4a$var$WebSocketImpl = null;
if (typeof MozWebSocket !== "undefined") $9d8fdf02b8ce4d4a$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== "undefined") $9d8fdf02b8ce4d4a$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ var $9d8fdf02b8ce4d4a$var$WebSocketConnection = /** @class */ function() {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ function WebSocketConnection(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $9d8fdf02b8ce4d4a$var$logWrapper(this.connId);
        this.stats_ = $9d8fdf02b8ce4d4a$var$statsManagerGetCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ WebSocketConnection.connectionURL_ = function(repoInfo, transportSessionId, lastSessionId, appCheckToken) {
        var urlParams = {};
        urlParams[$9d8fdf02b8ce4d4a$var$VERSION_PARAM] = $9d8fdf02b8ce4d4a$var$PROTOCOL_VERSION;
        if (!(0, $eTAKc.isNodeSdk)() && typeof location !== "undefined" && location.hostname && $9d8fdf02b8ce4d4a$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$9d8fdf02b8ce4d4a$var$REFERER_PARAM] = $9d8fdf02b8ce4d4a$var$FORGE_REF;
        if (transportSessionId) urlParams[$9d8fdf02b8ce4d4a$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$9d8fdf02b8ce4d4a$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$9d8fdf02b8ce4d4a$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        return $9d8fdf02b8ce4d4a$var$repoInfoConnectionURL(repoInfo, $9d8fdf02b8ce4d4a$var$WEBSOCKET, urlParams);
    };
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ WebSocketConnection.prototype.open = function(onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_("Websocket connecting to " + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $9d8fdf02b8ce4d4a$var$PersistentStorage.set("previous_websocket_failure", true);
        try {
            if ((0, $eTAKc.isNodeSdk)()) {
                var device = this.nodeAdmin ? "AdminNode" : "Node";
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        "User-Agent": "Firebase/" + $9d8fdf02b8ce4d4a$var$PROTOCOL_VERSION + "/" + $9d8fdf02b8ce4d4a$var$SDK_VERSION + "/" + $hvPjh.platform + "/" + device,
                        "X-Firebase-GMPID": this.applicationId || ""
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers["Authorization"] = "Bearer " + this.authToken;
                if (this.appCheckToken) options.headers["X-Firebase-AppCheck"] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = {};
                var proxy = this.connURL.indexOf("wss://") === 0 ? env["HTTPS_PROXY"] || env["https_proxy"] : env["HTTP_PROXY"] || env["http_proxy"];
                if (proxy) options["proxy"] = {
                    origin: proxy
                };
                this.mySock = new $9d8fdf02b8ce4d4a$var$WebSocketImpl(this.connURL, [], options);
            } else {
                var options = {
                    headers: {
                        "X-Firebase-GMPID": this.applicationId || "",
                        "X-Firebase-AppCheck": this.appCheckToken || ""
                    }
                };
                this.mySock = new $9d8fdf02b8ce4d4a$var$WebSocketImpl(this.connURL, [], options);
            }
        } catch (e) {
            this.log_("Error instantiating WebSocket.");
            var error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function() {
            _this.log_("Websocket connected.");
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function() {
            _this.log_("Websocket connection was disconnected.");
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function(m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function(e) {
            _this.log_("WebSocket error.  Closing connection.");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var error = e.message || e.data;
            if (error) _this.log_(error);
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ WebSocketConnection.prototype.start = function() {};
    WebSocketConnection.forceDisallow = function() {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function() {
        var isOldAndroid = false;
        if (typeof navigator !== "undefined" && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $9d8fdf02b8ce4d4a$var$WebSocketImpl !== null && !WebSocketConnection.forceDisallow_;
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     */ WebSocketConnection.previouslyFailed = function() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $9d8fdf02b8ce4d4a$var$PersistentStorage.isInMemoryStorage || $9d8fdf02b8ce4d4a$var$PersistentStorage.get("previous_websocket_failure") === true;
    };
    WebSocketConnection.prototype.markConnectionHealthy = function() {
        $9d8fdf02b8ce4d4a$var$PersistentStorage.remove("previous_websocket_failure");
    };
    WebSocketConnection.prototype.appendFrame_ = function(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            var fullMess = this.frames.join("");
            this.frames = null;
            var jsonMess = (0, $eTAKc.jsonEval)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ WebSocketConnection.prototype.handleNewFrameCount_ = function(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ WebSocketConnection.prototype.extractFrameCount_ = function(data) {
        (0, $eTAKc.assert)(this.frames === null, "We already have a frame buffer");
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ WebSocketConnection.prototype.handleIncomingFrame = function(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess["data"];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter("bytes_received", data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    };
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ WebSocketConnection.prototype.send = function(data) {
        this.resetKeepAlive();
        var dataStr = (0, $eTAKc.stringify)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = $9d8fdf02b8ce4d4a$var$splitStringBySize(dataStr, $9d8fdf02b8ce4d4a$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(var i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    };
    WebSocketConnection.prototype.shutdown_ = function() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function() {
        if (!this.isClosed_) {
            this.log_("WebSocket is closing itself");
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ WebSocketConnection.prototype.close = function() {
        if (!this.isClosed_) {
            this.log_("WebSocket is being closed");
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ WebSocketConnection.prototype.resetKeepAlive = function() {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function() {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) _this.sendString_("0");
            _this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($9d8fdf02b8ce4d4a$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ WebSocketConnection.prototype.sendString_ = function(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_("Exception thrown from WebSocket.send():", e.message || e.data, "Closing connection.");
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     */ WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     */ WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ var $9d8fdf02b8ce4d4a$var$TransportManager = /** @class */ function() {
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        get: function() {
            return [
                $9d8fdf02b8ce4d4a$var$BrowserPollConnection,
                $9d8fdf02b8ce4d4a$var$WebSocketConnection
            ];
        },
        enumerable: false,
        configurable: true
    });
    TransportManager.prototype.initTransports_ = function(repoInfo) {
        var e_1, _a;
        var isWebSocketsAvailable = $9d8fdf02b8ce4d4a$var$WebSocketConnection && $9d8fdf02b8ce4d4a$var$WebSocketConnection["isAvailable"]();
        var isSkipPollConnection = isWebSocketsAvailable && !$9d8fdf02b8ce4d4a$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $9d8fdf02b8ce4d4a$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $9d8fdf02b8ce4d4a$var$WebSocketConnection
        ];
        else {
            var transports = this.transports_ = [];
            try {
                for(var _b = (0, $2WUgS.__values)(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()){
                    var transport = _c.value;
                    if (transport && transport["isAvailable"]()) transports.push(transport);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
    };
    /**
     * @returns The constructor for the initial transport to use
     */ TransportManager.prototype.initialTransport = function() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error("No transports available");
    };
    /**
     * @returns The constructor for the next transport, or null
     */ TransportManager.prototype.upgradeTransport = function() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    };
    return TransportManager;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
var $9d8fdf02b8ce4d4a$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var $9d8fdf02b8ce4d4a$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var $9d8fdf02b8ce4d4a$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
var $9d8fdf02b8ce4d4a$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
var $9d8fdf02b8ce4d4a$var$MESSAGE_TYPE = "t";
var $9d8fdf02b8ce4d4a$var$MESSAGE_DATA = "d";
var $9d8fdf02b8ce4d4a$var$CONTROL_SHUTDOWN = "s";
var $9d8fdf02b8ce4d4a$var$CONTROL_RESET = "r";
var $9d8fdf02b8ce4d4a$var$CONTROL_ERROR = "e";
var $9d8fdf02b8ce4d4a$var$CONTROL_PONG = "o";
var $9d8fdf02b8ce4d4a$var$SWITCH_ACK = "a";
var $9d8fdf02b8ce4d4a$var$END_TRANSMISSION = "n";
var $9d8fdf02b8ce4d4a$var$PING = "p";
var $9d8fdf02b8ce4d4a$var$SERVER_HELLO = "h";
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ var $9d8fdf02b8ce4d4a$var$Connection = /** @class */ function() {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ function Connection(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */ ;
        this.log_ = $9d8fdf02b8ce4d4a$var$logWrapper("c:" + this.id + ":");
        this.transportManager_ = new $9d8fdf02b8ce4d4a$var$TransportManager(repoInfo_);
        this.log_("Connection created");
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ Connection.prototype.start_ = function() {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(function() {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeoutMS = conn["healthyTimeout"] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $9d8fdf02b8ce4d4a$var$setTimeoutNonBlocking(function() {
            _this.healthyTimeout_ = null;
            if (!_this.isHealthy_) {
                if (_this.conn_ && _this.conn_.bytesReceived > $9d8fdf02b8ce4d4a$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    _this.log_("Connection exceeded healthy timeout but has received " + _this.conn_.bytesReceived + " bytes.  Marking connection healthy.");
                    _this.isHealthy_ = true;
                    _this.conn_.markConnectionHealthy();
                } else if (_this.conn_ && _this.conn_.bytesSent > $9d8fdf02b8ce4d4a$var$BYTES_SENT_HEALTHY_OVERRIDE) _this.log_("Connection exceeded healthy timeout but has sent " + _this.conn_.bytesSent + " bytes.  Leaving connection alive.");
                else {
                    _this.log_("Closing unhealthy connection after timeout.");
                    _this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    };
    Connection.prototype.nextTransportId_ = function() {
        return "c:" + this.id + ":" + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function(conn) {
        var _this = this;
        return function(everConnected) {
            if (conn === _this.conn_) _this.onConnectionLost_(everConnected);
            else if (conn === _this.secondaryConn_) {
                _this.log_("Secondary connection lost.");
                _this.onSecondaryConnectionLost_();
            } else _this.log_("closing an old connection");
        };
    };
    Connection.prototype.connReceiver_ = function(conn) {
        var _this = this;
        return function(message) {
            if (_this.state_ !== 2 /* DISCONNECTED */ ) {
                if (conn === _this.rx_) _this.onPrimaryMessageReceived_(message);
                else if (conn === _this.secondaryConn_) _this.onSecondaryMessageReceived_(message);
                else _this.log_("message on old connection");
            }
        };
    };
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ Connection.prototype.sendRequest = function(dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = {
            t: "d",
            d: dataMsg
        };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function(controlData) {
        if ($9d8fdf02b8ce4d4a$var$MESSAGE_TYPE in controlData) {
            var cmd = controlData[$9d8fdf02b8ce4d4a$var$MESSAGE_TYPE];
            if (cmd === $9d8fdf02b8ce4d4a$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $9d8fdf02b8ce4d4a$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_("Got a reset on secondary, closing it");
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $9d8fdf02b8ce4d4a$var$CONTROL_PONG) {
                this.log_("got pong on secondary.");
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function(parsedData) {
        var layer = $9d8fdf02b8ce4d4a$var$requireKey("t", parsedData);
        var data = $9d8fdf02b8ce4d4a$var$requireKey("d", parsedData);
        if (layer === "c") this.onSecondaryControl_(data);
        else if (layer === "d") // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error("Unknown protocol layer: " + layer);
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_("Secondary connection is healthy.");
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_("sending ping on secondary.");
            this.secondaryConn_.send({
                t: "c",
                d: {
                    t: $9d8fdf02b8ce4d4a$var$PING,
                    d: {}
                }
            });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_("sending client ack on secondary");
        this.secondaryConn_.send({
            t: "c",
            d: {
                t: $9d8fdf02b8ce4d4a$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_("Ending transmission on primary");
        this.conn_.send({
            t: "c",
            d: {
                t: $9d8fdf02b8ce4d4a$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = $9d8fdf02b8ce4d4a$var$requireKey("t", parsedData);
        var data = $9d8fdf02b8ce4d4a$var$requireKey("d", parsedData);
        if (layer === "c") this.onControl_(data);
        else if (layer === "d") this.onDataMessage_(data);
    };
    Connection.prototype.onDataMessage_ = function(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_("Primary connection is healthy.");
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function(controlData) {
        var cmd = $9d8fdf02b8ce4d4a$var$requireKey($9d8fdf02b8ce4d4a$var$MESSAGE_TYPE, controlData);
        if ($9d8fdf02b8ce4d4a$var$MESSAGE_DATA in controlData) {
            var payload = controlData[$9d8fdf02b8ce4d4a$var$MESSAGE_DATA];
            if (cmd === $9d8fdf02b8ce4d4a$var$SERVER_HELLO) this.onHandshake_(payload);
            else if (cmd === $9d8fdf02b8ce4d4a$var$END_TRANSMISSION) {
                this.log_("recvd end transmission on primary");
                this.rx_ = this.secondaryConn_;
                for(var i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $9d8fdf02b8ce4d4a$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $9d8fdf02b8ce4d4a$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $9d8fdf02b8ce4d4a$var$CONTROL_ERROR) $9d8fdf02b8ce4d4a$var$error("Server Error: " + payload);
            else if (cmd === $9d8fdf02b8ce4d4a$var$CONTROL_PONG) {
                this.log_("got pong on primary.");
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $9d8fdf02b8ce4d4a$var$error("Unknown control packet command: " + cmd);
        }
    };
    /**
     * @param handshake - The handshake data returned from the server
     */ Connection.prototype.onHandshake_ = function(handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($9d8fdf02b8ce4d4a$var$PROTOCOL_VERSION !== version) $9d8fdf02b8ce4d4a$var$warn("Protocol version mismatch detected");
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function() {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    };
    Connection.prototype.startUpgrade_ = function(conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $9d8fdf02b8ce4d4a$var$setTimeoutNonBlocking(function() {
            if (_this.secondaryConn_) {
                _this.log_("Timed out trying to upgrade.");
                _this.secondaryConn_.close();
            }
        }, Math.floor($9d8fdf02b8ce4d4a$var$UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function(host) {
        this.log_("Reset packet received.  New host: " + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function(conn, timestamp) {
        var _this = this;
        this.log_("Realtime connection established.");
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_("Primary connection is healthy.");
            this.isHealthy_ = true;
        } else $9d8fdf02b8ce4d4a$var$setTimeoutNonBlocking(function() {
            _this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($9d8fdf02b8ce4d4a$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */ ) {
            this.log_("sending ping on primary.");
            this.sendData_({
                t: "c",
                d: {
                    t: $9d8fdf02b8ce4d4a$var$PING,
                    d: {}
                }
            });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function() {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    };
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ Connection.prototype.onConnectionLost_ = function(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */ ) {
            this.log_("Realtime connection failed.");
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $9d8fdf02b8ce4d4a$var$PersistentStorage.remove("host:" + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* CONNECTED */ ) this.log_("Realtime connection lost.");
        this.close();
    };
    Connection.prototype.onConnectionShutdown_ = function(reason) {
        this.log_("Connection shutdown command received. Shutting down...");
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function(data) {
        if (this.state_ !== 1 /* CONNECTED */ ) throw "Connection is not connected";
        else this.tx_.send(data);
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ Connection.prototype.close = function() {
        if (this.state_ !== 2 /* DISCONNECTED */ ) {
            this.log_("Closing realtime connection.");
            this.state_ = 2 /* DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    Connection.prototype.closeConnections_ = function() {
        this.log_("Shutting down all connections");
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ var $9d8fdf02b8ce4d4a$var$ServerActions = /** @class */ function() {
    function ServerActions() {}
    ServerActions.prototype.put = function(pathString, data, onComplete, hash) {};
    ServerActions.prototype.merge = function(pathString, data, onComplete, hash) {};
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ ServerActions.prototype.refreshAuthToken = function(token) {};
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ ServerActions.prototype.refreshAppCheckToken = function(token) {};
    ServerActions.prototype.onDisconnectPut = function(pathString, data, onComplete) {};
    ServerActions.prototype.onDisconnectMerge = function(pathString, data, onComplete) {};
    ServerActions.prototype.onDisconnectCancel = function(pathString, onComplete) {};
    ServerActions.prototype.reportStats = function(stats) {};
    return ServerActions;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ var $9d8fdf02b8ce4d4a$var$EventEmitter = /** @class */ function() {
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $eTAKc.assert)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, "Requires a non-empty array");
    }
    /**
     * To be called by derived classes to trigger events.
     */ EventEmitter.prototype.trigger = function(eventType) {
        var varArgs = [];
        for(var _i = 1; _i < arguments.length; _i++)varArgs[_i - 1] = arguments[_i];
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = (0, $2WUgS.__spreadArray)([], (0, $2WUgS.__read)(this.listeners_[eventType]));
            for(var i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    };
    EventEmitter.prototype.on = function(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    };
    EventEmitter.prototype.off = function(eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for(var i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    };
    EventEmitter.prototype.validateEventType_ = function(eventType) {
        (0, $eTAKc.assert)(this.allowedEvents_.find(function(et) {
            return et === eventType;
        }), "Unknown event: " + eventType);
    };
    return EventEmitter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ var $9d8fdf02b8ce4d4a$var$OnlineMonitor = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, [
            "online"
        ]) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined" && !(0, $eTAKc.isMobileCordova)()) {
            window.addEventListener("online", function() {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger("online", true);
                }
            }, false);
            window.addEventListener("offline", function() {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger("online", false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function() {
        return new OnlineMonitor();
    };
    OnlineMonitor.prototype.getInitialEvent = function(eventType) {
        (0, $eTAKc.assert)(eventType === "online", "Unknown event type: " + eventType);
        return [
            this.online_
        ];
    };
    OnlineMonitor.prototype.currentlyOnline = function() {
        return this.online_;
    };
    return OnlineMonitor;
}($9d8fdf02b8ce4d4a$var$EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ var $9d8fdf02b8ce4d4a$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ var $9d8fdf02b8ce4d4a$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ var $9d8fdf02b8ce4d4a$var$Path = /** @class */ function() {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split("/");
            // Remove empty pieces.
            var copyTo = 0;
            for(var i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Path.prototype.toString = function() {
        var pathString = "";
        for(var i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== "") pathString += "/" + this.pieces_[i];
        return pathString || "/";
    };
    return Path;
}();
function $9d8fdf02b8ce4d4a$var$newEmptyPath() {
    return new $9d8fdf02b8ce4d4a$var$Path("");
}
function $9d8fdf02b8ce4d4a$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $9d8fdf02b8ce4d4a$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $9d8fdf02b8ce4d4a$var$pathPopFront(path) {
    var pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $9d8fdf02b8ce4d4a$var$Path(path.pieces_, pieceNum);
}
function $9d8fdf02b8ce4d4a$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $9d8fdf02b8ce4d4a$var$pathToUrlEncodedString(path) {
    var pathString = "";
    for(var i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== "") pathString += "/" + encodeURIComponent(String(path.pieces_[i]));
    return pathString || "/";
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $9d8fdf02b8ce4d4a$var$pathSlice(path, begin) {
    if (begin === void 0) begin = 0;
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $9d8fdf02b8ce4d4a$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    var pieces = [];
    for(var i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $9d8fdf02b8ce4d4a$var$Path(pieces, 0);
}
function $9d8fdf02b8ce4d4a$var$pathChild(path, childPathObj) {
    var pieces = [];
    for(var i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $9d8fdf02b8ce4d4a$var$Path) for(var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        var childPieces = childPathObj.split("/");
        for(var i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $9d8fdf02b8ce4d4a$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $9d8fdf02b8ce4d4a$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $9d8fdf02b8ce4d4a$var$newRelativePath(outerPath, innerPath) {
    var outer = $9d8fdf02b8ce4d4a$var$pathGetFront(outerPath), inner = $9d8fdf02b8ce4d4a$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $9d8fdf02b8ce4d4a$var$newRelativePath($9d8fdf02b8ce4d4a$var$pathPopFront(outerPath), $9d8fdf02b8ce4d4a$var$pathPopFront(innerPath));
    else throw new Error("INTERNAL ERROR: innerPath (" + innerPath + ") is not within " + "outerPath (" + outerPath + ")");
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $9d8fdf02b8ce4d4a$var$pathCompare(left, right) {
    var leftKeys = $9d8fdf02b8ce4d4a$var$pathSlice(left, 0);
    var rightKeys = $9d8fdf02b8ce4d4a$var$pathSlice(right, 0);
    for(var i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        var cmp = $9d8fdf02b8ce4d4a$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $9d8fdf02b8ce4d4a$var$pathEquals(path, other) {
    if ($9d8fdf02b8ce4d4a$var$pathGetLength(path) !== $9d8fdf02b8ce4d4a$var$pathGetLength(other)) return false;
    for(var i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent (or the same as) other
 */ function $9d8fdf02b8ce4d4a$var$pathContains(path, other) {
    var i = path.pieceNum_;
    var j = other.pieceNum_;
    if ($9d8fdf02b8ce4d4a$var$pathGetLength(path) > $9d8fdf02b8ce4d4a$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ var $9d8fdf02b8ce4d4a$var$ValidationPath = /** @class */ function() {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $9d8fdf02b8ce4d4a$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(var i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $eTAKc.stringLength)(this.parts_[i]);
        $9d8fdf02b8ce4d4a$var$validationPathCheckValid(this);
    }
    return ValidationPath;
}();
function $9d8fdf02b8ce4d4a$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $eTAKc.stringLength)(child);
    $9d8fdf02b8ce4d4a$var$validationPathCheckValid(validationPath);
}
function $9d8fdf02b8ce4d4a$var$validationPathPop(validationPath) {
    var last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $eTAKc.stringLength)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $9d8fdf02b8ce4d4a$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $9d8fdf02b8ce4d4a$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + "has a key path longer than " + $9d8fdf02b8ce4d4a$var$MAX_PATH_LENGTH_BYTES + " bytes (" + validationPath.byteLength_ + ").");
    if (validationPath.parts_.length > $9d8fdf02b8ce4d4a$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + $9d8fdf02b8ce4d4a$var$MAX_PATH_DEPTH + ") or object contains a cycle " + $9d8fdf02b8ce4d4a$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $9d8fdf02b8ce4d4a$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return "";
    return "in property '" + validationPath.parts_.join(".") + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$VisibilityMonitor = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, [
            "visible"
        ]) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== "undefined" && typeof document.addEventListener !== "undefined") {
            if (typeof document["hidden"] !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = "visibilitychange";
                hidden = "hidden";
            } else if (typeof document["mozHidden"] !== "undefined") {
                visibilityChange = "mozvisibilitychange";
                hidden = "mozHidden";
            } else if (typeof document["msHidden"] !== "undefined") {
                visibilityChange = "msvisibilitychange";
                hidden = "msHidden";
            } else if (typeof document["webkitHidden"] !== "undefined") {
                visibilityChange = "webkitvisibilitychange";
                hidden = "webkitHidden";
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, function() {
            var visible = !document[hidden];
            if (visible !== _this.visible_) {
                _this.visible_ = visible;
                _this.trigger("visible", visible);
            }
        }, false);
        return _this;
    }
    VisibilityMonitor.getInstance = function() {
        return new VisibilityMonitor();
    };
    VisibilityMonitor.prototype.getInitialEvent = function(eventType) {
        (0, $eTAKc.assert)(eventType === "visible", "Unknown event type: " + eventType);
        return [
            this.visible_
        ];
    };
    return VisibilityMonitor;
}($9d8fdf02b8ce4d4a$var$EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$RECONNECT_MIN_DELAY = 1000;
var $9d8fdf02b8ce4d4a$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
var $9d8fdf02b8ce4d4a$var$GET_CONNECT_TIMEOUT = 3000;
var $9d8fdf02b8ce4d4a$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
var $9d8fdf02b8ce4d4a$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
var $9d8fdf02b8ce4d4a$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var $9d8fdf02b8ce4d4a$var$SERVER_KILL_INTERRUPT_REASON = "server_kill";
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var $9d8fdf02b8ce4d4a$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ var $9d8fdf02b8ce4d4a$var$PersistentConnection = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(PersistentConnection, _super);
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ function PersistentConnection(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.applicationId_ = applicationId_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.appCheckTokenProvider_ = appCheckTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = $9d8fdf02b8ce4d4a$var$logWrapper("p:" + _this.id + ":");
        _this.interruptReasons_ = {};
        _this.listens = new Map();
        _this.outstandingPuts_ = [];
        _this.outstandingGets_ = [];
        _this.outstandingPutCount_ = 0;
        _this.outstandingGetCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        _this.establishConnectionTimer_ = null;
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        _this.realtime_ = null;
        _this.authToken_ = null;
        _this.appCheckToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.invalidAppCheckTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $eTAKc.isNodeSdk)()) throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
        $9d8fdf02b8ce4d4a$var$VisibilityMonitor.getInstance().on("visible", _this.onVisible_, _this);
        if (repoInfo_.host.indexOf("fblocal") === -1) $9d8fdf02b8ce4d4a$var$OnlineMonitor.getInstance().on("online", _this.onOnline_, _this);
        return _this;
    }
    PersistentConnection.prototype.sendRequest = function(action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $eTAKc.stringify)(msg));
        (0, $eTAKc.assert)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    };
    PersistentConnection.prototype.get = function(query) {
        var _this = this;
        this.initConnection_();
        var deferred = new (0, $eTAKc.Deferred)();
        var request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        var outstandingGet = {
            action: "g",
            request: request,
            onComplete: function(message) {
                var payload = message["d"];
                if (message["s"] === "ok") {
                    _this.onDataUpdate_(request["p"], payload, /*isMerge*/ false, /*tag*/ null);
                    deferred.resolve(payload);
                } else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        var index = this.outstandingGets_.length - 1;
        if (!this.connected_) setTimeout(function() {
            var get = _this.outstandingGets_[index];
            if (get === undefined || outstandingGet !== get) return;
            delete _this.outstandingGets_[index];
            _this.outstandingGetCount_--;
            if (_this.outstandingGetCount_ === 0) _this.outstandingGets_ = [];
            _this.log_("get " + index + " timed out on connection");
            deferred.reject(new Error("Client is offline."));
        }, $9d8fdf02b8ce4d4a$var$GET_CONNECT_TIMEOUT);
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    };
    PersistentConnection.prototype.listen = function(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        var queryId = query._queryIdentifier;
        var pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $eTAKc.assert)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "listen() called for non-default but complete query");
        (0, $eTAKc.assert)(!this.listens.get(pathString).has(queryId), "listen() called twice for same path/queryId.");
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    };
    PersistentConnection.prototype.sendGet_ = function(index) {
        var _this = this;
        var get = this.outstandingGets_[index];
        this.sendRequest("g", get.request, function(message) {
            delete _this.outstandingGets_[index];
            _this.outstandingGetCount_--;
            if (_this.outstandingGetCount_ === 0) _this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    };
    PersistentConnection.prototype.sendListen_ = function(listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query._path.toString();
        var queryId = query._queryIdentifier;
        this.log_("Listen on " + pathString + " for " + queryId);
        var req = {
            p: pathString
        };
        var action = "q";
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req["q"] = query._queryObject;
            req["t"] = listenSpec.tag;
        }
        req[/*hash*/ "h"] = listenSpec.hashFn();
        this.sendRequest(action, req, function(message) {
            var payload = message[/*data*/ "d"];
            var status = message[/*status*/ "s"];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens.get(pathString) && _this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_("listen response", message);
                if (status !== "ok") _this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    };
    PersistentConnection.warnOnListenWarnings_ = function(payload, query) {
        if (payload && typeof payload === "object" && (0, $eTAKc.contains)(payload, "w")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var warnings = (0, $eTAKc.safeGet)(payload, "w");
            if (Array.isArray(warnings) && ~warnings.indexOf("no_index")) {
                var indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                var indexPath = query._path.toString();
                $9d8fdf02b8ce4d4a$var$warn("Using an unspecified index. Your data will be downloaded and " + ("filtered on the client. Consider adding " + indexSpec + " at ") + (indexPath + " to your security rules for better performance."));
            }
        }
    };
    PersistentConnection.prototype.refreshAuthToken = function(token) {
        this.authToken_ = token;
        this.log_("Auth token refreshed");
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest("unauth", {}, function() {});
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $eTAKc.isAdmin)(credential)) {
            this.log_("Admin auth credential detected.  Reducing max reconnect time.");
            this.maxReconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    PersistentConnection.prototype.refreshAppCheckToken = function(token) {
        this.appCheckToken_ = token;
        this.log_("App check token refreshed");
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest("unappeck", {}, function() {});
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ PersistentConnection.prototype.tryAuth = function() {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = (0, $eTAKc.isValidFormat)(token_1) ? "auth" : "gauth";
            var requestData = {
                cred: token_1
            };
            if (this.authOverride_ === null) requestData["noauth"] = true;
            else if (typeof this.authOverride_ === "object") requestData["authvar"] = this.authOverride_;
            this.sendRequest(authMethod, requestData, function(res) {
                var status = res[/*status*/ "s"];
                var data = res[/*data*/ "d"] || "error";
                if (_this.authToken_ === token_1) {
                    if (status === "ok") _this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    _this.onAuthRevoked_(status, data);
                }
            });
        }
    };
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ PersistentConnection.prototype.tryAppCheck = function() {
        var _this = this;
        if (this.connected_ && this.appCheckToken_) this.sendRequest("appcheck", {
            "token": this.appCheckToken_
        }, function(res) {
            var status = res[/*status*/ "s"];
            var data = res[/*data*/ "d"] || "error";
            if (status === "ok") _this.invalidAppCheckTokenCount_ = 0;
            else _this.onAppCheckRevoked_(status, data);
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.unlisten = function(query, tag) {
        var pathString = query._path.toString();
        var queryId = query._queryIdentifier;
        this.log_("Unlisten called for " + pathString + " " + queryId);
        (0, $eTAKc.assert)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "unlisten() called for non-default but complete query");
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    };
    PersistentConnection.prototype.sendUnlisten_ = function(pathString, queryId, queryObj, tag) {
        this.log_("Unlisten on " + pathString + " for " + queryId);
        var req = {
            p: pathString
        };
        var action = "n";
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req["q"] = queryObj;
            req["t"] = tag;
        }
        this.sendRequest(action, req);
    };
    PersistentConnection.prototype.onDisconnectPut = function(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("o", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "o",
            data: data,
            onComplete: onComplete
        });
    };
    PersistentConnection.prototype.onDisconnectMerge = function(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("om", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "om",
            data: data,
            onComplete: onComplete
        });
    };
    PersistentConnection.prototype.onDisconnectCancel = function(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("oc", pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "oc",
            data: null,
            onComplete: onComplete
        });
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function(action, pathString, data, onComplete) {
        var request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_("onDisconnect " + action, request);
        this.sendRequest(action, request, function(response) {
            if (onComplete) setTimeout(function() {
                onComplete(response[/*status*/ "s"], response[/* data */ "d"]);
            }, Math.floor(0));
        });
    };
    PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        this.putInternal("p", pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.merge = function(pathString, data, onComplete, hash) {
        this.putInternal("m", pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ "h"] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_("Buffering put: " + pathString);
    };
    PersistentConnection.prototype.sendPut_ = function(index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function(message) {
            _this.log_(action + " response", message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) _this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ "s"], message[/* data */ "d"]);
        });
    };
    PersistentConnection.prototype.reportStats = function(stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = {
                c: stats
            };
            this.log_("reportStats", request);
            this.sendRequest(/*stats*/ "s", request, function(result) {
                var status = result[/*status*/ "s"];
                if (status !== "ok") {
                    var errorReason = result[/* data */ "d"];
                    _this.log_("reportStats", "Error sending stats: " + errorReason);
                }
            });
        }
    };
    PersistentConnection.prototype.onDataMessage_ = function(message) {
        if ("r" in message) {
            // this is a response
            this.log_("from server: " + (0, $eTAKc.stringify)(message));
            var reqNum = message["r"];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ "b"]);
            }
        } else if ("error" in message) throw "A server-side error has occurred: " + message["error"];
        else if ("a" in message) // a and b are action and body, respectively
        this.onDataPush_(message["a"], message["b"]);
    };
    PersistentConnection.prototype.onDataPush_ = function(action, body) {
        this.log_("handleServerMessage", action, body);
        if (action === "d") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge*/ false, body["t"]);
        else if (action === "m") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge=*/ true, body["t"]);
        else if (action === "c") this.onListenRevoked_(body[/*path*/ "p"], body[/*query*/ "q"]);
        else if (action === "ac") this.onAuthRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "apc") this.onAppCheckRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "sd") this.onSecurityDebugPacket_(body);
        else $9d8fdf02b8ce4d4a$var$error("Unrecognized action received from server: " + (0, $eTAKc.stringify)(action) + "\nAre you using the latest client?");
    };
    PersistentConnection.prototype.onReady_ = function(timestamp, sessionId) {
        this.log_("connection ready");
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function(timeout) {
        var _this = this;
        (0, $eTAKc.assert)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function() {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    };
    PersistentConnection.prototype.initConnection_ = function() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    };
    PersistentConnection.prototype.onVisible_ = function(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_("Window became visible.  Reducing delay.");
            this.reconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function(online) {
        if (online) {
            this.log_("Browser went online.");
            this.reconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_("Browser went offline.  Killing connection.");
            if (this.realtime_) this.realtime_.close();
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function() {
        this.log_("data client disconnected");
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $9d8fdf02b8ce4d4a$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_("Trying to reconnect in " + reconnectDelay + "ms");
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $9d8fdf02b8ce4d4a$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var onDataMessage, onReady, onDisconnect_1, connId, lastSessionId, canceled_1, connection_1, closeFn, sendRequestFn, forceRefresh, _a, authToken, appCheckToken, error_1;
            var _this = this;
            return (0, $2WUgS.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.shouldReconnect_()) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.log_("Making a connection attempt");
                        this.lastConnectionAttemptTime_ = new Date().getTime();
                        this.lastConnectionEstablishedTime_ = null;
                        onDataMessage = this.onDataMessage_.bind(this);
                        onReady = this.onReady_.bind(this);
                        onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
                        connId = this.id + ":" + PersistentConnection.nextConnectionId_++;
                        lastSessionId = this.lastSessionId;
                        canceled_1 = false;
                        connection_1 = null;
                        closeFn = function() {
                            if (connection_1) connection_1.close();
                            else {
                                canceled_1 = true;
                                onDisconnect_1();
                            }
                        };
                        sendRequestFn = function(msg) {
                            (0, $eTAKc.assert)(connection_1, "sendRequest call when we're not connected not allowed.");
                            connection_1.sendRequest(msg);
                        };
                        this.realtime_ = {
                            close: closeFn,
                            sendRequest: sendRequestFn
                        };
                        forceRefresh = this.forceTokenRefresh_;
                        this.forceTokenRefresh_ = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.authTokenProvider_.getToken(forceRefresh),
                                this.appCheckTokenProvider_.getToken(forceRefresh)
                            ])
                        ];
                    case 2:
                        _a = (0, $2WUgS.__read).apply(void 0, [
                            _b.sent(),
                            2
                        ]), authToken = _a[0], appCheckToken = _a[1];
                        if (!canceled_1) {
                            $9d8fdf02b8ce4d4a$var$log("getToken() completed. Creating connection.");
                            this.authToken_ = authToken && authToken.accessToken;
                            this.appCheckToken_ = appCheckToken && appCheckToken.token;
                            connection_1 = new $9d8fdf02b8ce4d4a$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect_1, /* onKill= */ function(reason) {
                                $9d8fdf02b8ce4d4a$var$warn(reason + " (" + _this.repoInfo_.toString() + ")");
                                _this.interrupt($9d8fdf02b8ce4d4a$var$SERVER_KILL_INTERRUPT_REASON);
                            }, lastSessionId);
                        } else $9d8fdf02b8ce4d4a$var$log("getToken() completed but was canceled");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _b.sent();
                        this.log_("Failed to get token: " + error_1);
                        if (!canceled_1) {
                            if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                            // But getToken() may also just have temporarily failed, so we still want to
                            // continue retrying.
                            $9d8fdf02b8ce4d4a$var$warn(error_1);
                            closeFn();
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PersistentConnection.prototype.interrupt = function(reason) {
        $9d8fdf02b8ce4d4a$var$log("Interrupting connection for reason: " + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    };
    PersistentConnection.prototype.resume = function(reason) {
        $9d8fdf02b8ce4d4a$var$log("Resuming connection for reason: " + reason);
        delete this.interruptReasons_[reason];
        if ((0, $eTAKc.isEmpty)(this.interruptReasons_)) {
            this.reconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function(timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function() {
        for(var i = 0; i < this.outstandingPuts_.length; i++){
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ "h" in put.request && put.queued) {
                if (put.onComplete) put.onComplete("disconnect");
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    };
    PersistentConnection.prototype.onListenRevoked_ = function(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) queryId = "default";
        else queryId = query.map(function(q) {
            return $9d8fdf02b8ce4d4a$var$ObjectToUniqueKey(q);
        }).join("$");
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete("permission_denied");
    };
    PersistentConnection.prototype.removeListen_ = function(pathString, queryId) {
        var normalizedPathString = new $9d8fdf02b8ce4d4a$var$Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens.has(normalizedPathString)) {
            var map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function(statusCode, explanation) {
        $9d8fdf02b8ce4d4a$var$log("Auth token revoked: " + statusCode + "/" + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $9d8fdf02b8ce4d4a$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $9d8fdf02b8ce4d4a$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onAppCheckRevoked_ = function(statusCode, explanation) {
        $9d8fdf02b8ce4d4a$var$log("App check token revoked: " + statusCode + "/" + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $9d8fdf02b8ce4d4a$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ("msg" in body) console.log("FIREBASE: " + body["msg"].replace("\n", "\nFIREBASE: "));
    };
    PersistentConnection.prototype.restoreState_ = function() {
        var e_1, _a, e_2, _b;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        try {
            // Puts depend on having received the corresponding data update from the server before they complete, so we must
            // make sure to send listens before puts.
            for(var _c = (0, $2WUgS.__values)(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()){
                var queries = _d.value;
                try {
                    for(var _e = (e_2 = void 0, (0, $2WUgS.__values)(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()){
                        var listenSpec = _f.value;
                        this.sendListen_(listenSpec);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        for(var i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(var i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    };
    /**
     * Sends client stats for first connection
     */ PersistentConnection.prototype.sendConnectStats_ = function() {
        var stats = {};
        var clientName = "js";
        if ((0, $eTAKc.isNodeSdk)()) {
            if (this.repoInfo_.nodeAdmin) clientName = "admin_node";
            else clientName = "node";
        }
        stats["sdk." + clientName + "." + $9d8fdf02b8ce4d4a$var$SDK_VERSION.replace(/\./g, "-")] = 1;
        if ((0, $eTAKc.isMobileCordova)()) stats["framework.cordova"] = 1;
        else if ((0, $eTAKc.isReactNative)()) stats["framework.reactnative"] = 1;
        this.reportStats(stats);
    };
    PersistentConnection.prototype.shouldReconnect_ = function() {
        var online = $9d8fdf02b8ce4d4a$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $eTAKc.isEmpty)(this.interruptReasons_) && online;
    };
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     */ PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}($9d8fdf02b8ce4d4a$var$ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$NamedNode = /** @class */ function() {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    NamedNode.Wrap = function(name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$Index = /** @class */ function() {
    function Index() {}
    /**
     * @returns A standalone comparison function for
     * this index
     */ Index.prototype.getCompare = function() {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ Index.prototype.indexedValueChanged = function(oldNode, newNode) {
        var oldWrapped = new $9d8fdf02b8ce4d4a$var$NamedNode($9d8fdf02b8ce4d4a$var$MIN_NAME, oldNode);
        var newWrapped = new $9d8fdf02b8ce4d4a$var$NamedNode($9d8fdf02b8ce4d4a$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ Index.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9d8fdf02b8ce4d4a$var$NamedNode.MIN;
    };
    return Index;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$__EMPTY_NODE;
var $9d8fdf02b8ce4d4a$var$KeyIndex = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function() {
            return $9d8fdf02b8ce4d4a$var$__EMPTY_NODE;
        },
        set: function(val) {
            $9d8fdf02b8ce4d4a$var$__EMPTY_NODE = val;
        },
        enumerable: false,
        configurable: true
    });
    KeyIndex.prototype.compare = function(a, b) {
        return $9d8fdf02b8ce4d4a$var$nameCompare(a.name, b.name);
    };
    KeyIndex.prototype.isDefinedOn = function(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $eTAKc.assertionError)("KeyIndex.isDefinedOn not expected to be called.");
    };
    KeyIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    KeyIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9d8fdf02b8ce4d4a$var$NamedNode.MIN;
    };
    KeyIndex.prototype.maxPost = function() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $9d8fdf02b8ce4d4a$var$NamedNode($9d8fdf02b8ce4d4a$var$MAX_NAME, $9d8fdf02b8ce4d4a$var$__EMPTY_NODE);
    };
    KeyIndex.prototype.makePost = function(indexValue, name) {
        (0, $eTAKc.assert)(typeof indexValue === "string", "KeyIndex indexValue must always be a string.");
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $9d8fdf02b8ce4d4a$var$NamedNode(indexValue, $9d8fdf02b8ce4d4a$var$__EMPTY_NODE);
    };
    /**
     * @returns String representation for inclusion in a query spec
     */ KeyIndex.prototype.toString = function() {
        return ".key";
    };
    return KeyIndex;
}($9d8fdf02b8ce4d4a$var$Index);
var $9d8fdf02b8ce4d4a$var$KEY_INDEX = new $9d8fdf02b8ce4d4a$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ var $9d8fdf02b8ce4d4a$var$SortedMapIterator = /** @class */ function() {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) resultGenerator_ = null;
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        var cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    SortedMapIterator.prototype.getNext = function() {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function() {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function() {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    };
    return SortedMapIterator;
}();
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ var $9d8fdf02b8ce4d4a$var$LLRBNode = /** @class */ function() {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : $9d8fdf02b8ce4d4a$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $9d8fdf02b8ce4d4a$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ LLRBNode.prototype.copy = function(key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @returns The total number of nodes in the tree.
     */ LLRBNode.prototype.count = function() {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @returns True if the tree is empty.
     */ LLRBNode.prototype.isEmpty = function() {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ LLRBNode.prototype.inorderTraversal = function(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ LLRBNode.prototype.reverseTraversal = function(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    };
    /**
     * @returns The minimum node in the tree.
     */ LLRBNode.prototype.min_ = function() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    };
    /**
     * @returns The maximum key in the tree.
     */ LLRBNode.prototype.minKey = function() {
        return this.min_().key;
    };
    /**
     * @returns The maximum key in the tree.
     */ LLRBNode.prototype.maxKey = function() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    };
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ LLRBNode.prototype.insert = function(key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    };
    /**
     * @returns New tree, with the minimum key removed.
     */ LLRBNode.prototype.removeMin_ = function() {
        if (this.left.isEmpty()) return $9d8fdf02b8ce4d4a$var$SortedMap.EMPTY_NODE;
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ LLRBNode.prototype.remove = function(key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $9d8fdf02b8ce4d4a$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @returns Whether this is a RED node.
     */ LLRBNode.prototype.isRed_ = function() {
        return this.color;
    };
    /**
     * @returns New tree after performing any needed rotations.
     */ LLRBNode.prototype.fixUp_ = function() {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    };
    /**
     * @returns New tree, after moveRedLeft.
     */ LLRBNode.prototype.moveRedLeft_ = function() {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @returns New tree, after moveRedRight.
     */ LLRBNode.prototype.moveRedRight_ = function() {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @returns New tree, after rotateLeft.
     */ LLRBNode.prototype.rotateLeft_ = function() {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @returns New tree, after rotateRight.
     */ LLRBNode.prototype.rotateRight_ = function() {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @returns Newt ree, after colorFlip.
     */ LLRBNode.prototype.colorFlip_ = function() {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ LLRBNode.prototype.checkMaxDepth_ = function() {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    LLRBNode.prototype.check_ = function() {
        if (this.isRed_() && this.left.isRed_()) throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
        if (this.right.isRed_()) throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
        var blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error("Black depths differ");
        else return blackDepth + (this.isRed_() ? 0 : 1);
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}();
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ var $9d8fdf02b8ce4d4a$var$LLRBEmptyNode = /** @class */ function() {
    function LLRBEmptyNode() {}
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ LLRBEmptyNode.prototype.copy = function(key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ LLRBEmptyNode.prototype.insert = function(key, value, comparator) {
        return new $9d8fdf02b8ce4d4a$var$LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ LLRBEmptyNode.prototype.remove = function(key, comparator) {
        return this;
    };
    /**
     * @returns The total number of nodes in the tree.
     */ LLRBEmptyNode.prototype.count = function() {
        return 0;
    };
    /**
     * @returns True if the tree is empty.
     */ LLRBEmptyNode.prototype.isEmpty = function() {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ LLRBEmptyNode.prototype.inorderTraversal = function(action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ LLRBEmptyNode.prototype.reverseTraversal = function(action) {
        return false;
    };
    LLRBEmptyNode.prototype.minKey = function() {
        return null;
    };
    LLRBEmptyNode.prototype.maxKey = function() {
        return null;
    };
    LLRBEmptyNode.prototype.check_ = function() {
        return 0;
    };
    /**
     * @returns Whether this node is red.
     */ LLRBEmptyNode.prototype.isRed_ = function() {
        return false;
    };
    return LLRBEmptyNode;
}();
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ var $9d8fdf02b8ce4d4a$var$SortedMap = /** @class */ function() {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ function SortedMap(comparator_, root_) {
        if (root_ === void 0) root_ = SortedMap.EMPTY_NODE;
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ SortedMap.prototype.insert = function(key, value) {
        return new SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $9d8fdf02b8ce4d4a$var$LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ SortedMap.prototype.remove = function(key) {
        return new SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $9d8fdf02b8ce4d4a$var$LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ SortedMap.prototype.get = function(key) {
        var cmp;
        var node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ SortedMap.prototype.getPredecessorKey = function(key) {
        var cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
    };
    /**
     * @returns True if the map is empty.
     */ SortedMap.prototype.isEmpty = function() {
        return this.root_.isEmpty();
    };
    /**
     * @returns The total number of nodes in the map.
     */ SortedMap.prototype.count = function() {
        return this.root_.count();
    };
    /**
     * @returns The minimum key in the map.
     */ SortedMap.prototype.minKey = function() {
        return this.root_.minKey();
    };
    /**
     * @returns The maximum key in the map.
     */ SortedMap.prototype.maxKey = function() {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ SortedMap.prototype.inorderTraversal = function(action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ SortedMap.prototype.reverseTraversal = function(action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ SortedMap.prototype.getIterator = function(resultGenerator) {
        return new $9d8fdf02b8ce4d4a$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function(key, resultGenerator) {
        return new $9d8fdf02b8ce4d4a$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function(key, resultGenerator) {
        return new $9d8fdf02b8ce4d4a$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function(resultGenerator) {
        return new $9d8fdf02b8ce4d4a$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     */ SortedMap.EMPTY_NODE = new $9d8fdf02b8ce4d4a$var$LLRBEmptyNode();
    return SortedMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9d8fdf02b8ce4d4a$var$NAME_ONLY_COMPARATOR(left, right) {
    return $9d8fdf02b8ce4d4a$var$nameCompare(left.name, right.name);
}
function $9d8fdf02b8ce4d4a$var$NAME_COMPARATOR(left, right) {
    return $9d8fdf02b8ce4d4a$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$MAX_NODE$2;
function $9d8fdf02b8ce4d4a$var$setMaxNode$1(val) {
    $9d8fdf02b8ce4d4a$var$MAX_NODE$2 = val;
}
var $9d8fdf02b8ce4d4a$var$priorityHashText = function(priority) {
    if (typeof priority === "number") return "number:" + $9d8fdf02b8ce4d4a$var$doubleToIEEE754String(priority);
    else return "string:" + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ var $9d8fdf02b8ce4d4a$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        (0, $eTAKc.assert)(typeof val === "string" || typeof val === "number" || typeof val === "object" && (0, $eTAKc.contains)(val, ".sv"), "Priority must be a string or number.");
    } else (0, $eTAKc.assert)(priorityNode === $9d8fdf02b8ce4d4a$var$MAX_NODE$2 || priorityNode.isEmpty(), "priority of unexpected type.");
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $eTAKc.assert)(priorityNode === $9d8fdf02b8ce4d4a$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ var $9d8fdf02b8ce4d4a$var$LeafNode = /** @class */ function() {
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $eTAKc.assert)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $9d8fdf02b8ce4d4a$var$validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function() {
            return $9d8fdf02b8ce4d4a$var$__childrenNodeConstructor;
        },
        set: function(val) {
            $9d8fdf02b8ce4d4a$var$__childrenNodeConstructor = val;
        },
        enumerable: false,
        configurable: true
    });
    /** @inheritDoc */ LeafNode.prototype.isLeafNode = function() {
        return true;
    };
    /** @inheritDoc */ LeafNode.prototype.getPriority = function() {
        return this.priorityNode_;
    };
    /** @inheritDoc */ LeafNode.prototype.updatePriority = function(newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */ LeafNode.prototype.getImmediateChild = function(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.priorityNode_;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    };
    /** @inheritDoc */ LeafNode.prototype.getChild = function(path) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) return this;
        else if ($9d8fdf02b8ce4d4a$var$pathGetFront(path) === ".priority") return this.priorityNode_;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    };
    LeafNode.prototype.hasChild = function() {
        return false;
    };
    /** @inheritDoc */ LeafNode.prototype.getPredecessorChildName = function(childName, childNode) {
        return null;
    };
    /** @inheritDoc */ LeafNode.prototype.updateImmediateChild = function(childName, newChildNode) {
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== ".priority") return this;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    };
    /** @inheritDoc */ LeafNode.prototype.updateChild = function(path, newChildNode) {
        var front = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== ".priority") return this;
        else {
            (0, $eTAKc.assert)(front !== ".priority" || $9d8fdf02b8ce4d4a$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($9d8fdf02b8ce4d4a$var$pathPopFront(path), newChildNode));
        }
    };
    /** @inheritDoc */ LeafNode.prototype.isEmpty = function() {
        return false;
    };
    /** @inheritDoc */ LeafNode.prototype.numChildren = function() {
        return 0;
    };
    /** @inheritDoc */ LeafNode.prototype.forEachChild = function(index, action) {
        return false;
    };
    LeafNode.prototype.val = function(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            ".value": this.getValue(),
            ".priority": this.getPriority().val()
        };
        else return this.getValue();
    };
    /** @inheritDoc */ LeafNode.prototype.hash = function() {
        if (this.lazyHash_ === null) {
            var toHash = "";
            if (!this.priorityNode_.isEmpty()) toHash += "priority:" + $9d8fdf02b8ce4d4a$var$priorityHashText(this.priorityNode_.val()) + ":";
            var type = typeof this.value_;
            toHash += type + ":";
            if (type === "number") toHash += $9d8fdf02b8ce4d4a$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $9d8fdf02b8ce4d4a$var$sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ LeafNode.prototype.getValue = function() {
        return this.value_;
    };
    LeafNode.prototype.compareTo = function(other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $eTAKc.assert)(other.isLeafNode(), "Unknown node type");
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     */ LeafNode.prototype.compareToLeafNode_ = function(otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $eTAKc.assert)(otherIndex >= 0, "Unknown leaf type: " + otherLeafType);
        (0, $eTAKc.assert)(thisIndex >= 0, "Unknown leaf type: " + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === "object") // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    };
    LeafNode.prototype.withIndex = function() {
        return this;
    };
    LeafNode.prototype.isIndexed = function() {
        return true;
    };
    LeafNode.prototype.equals = function(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     */ LeafNode.VALUE_TYPE_ORDER = [
        "object",
        "boolean",
        "number",
        "string"
    ];
    return LeafNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$nodeFromJSON$1;
var $9d8fdf02b8ce4d4a$var$MAX_NODE$1;
function $9d8fdf02b8ce4d4a$var$setNodeFromJSON(val) {
    $9d8fdf02b8ce4d4a$var$nodeFromJSON$1 = val;
}
function $9d8fdf02b8ce4d4a$var$setMaxNode(val) {
    $9d8fdf02b8ce4d4a$var$MAX_NODE$1 = val;
}
var $9d8fdf02b8ce4d4a$var$PriorityIndex = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriorityIndex.prototype.compare = function(a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $9d8fdf02b8ce4d4a$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    PriorityIndex.prototype.isDefinedOn = function(node) {
        return !node.getPriority().isEmpty();
    };
    PriorityIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    PriorityIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9d8fdf02b8ce4d4a$var$NamedNode.MIN;
    };
    PriorityIndex.prototype.maxPost = function() {
        return new $9d8fdf02b8ce4d4a$var$NamedNode($9d8fdf02b8ce4d4a$var$MAX_NAME, new $9d8fdf02b8ce4d4a$var$LeafNode("[PRIORITY-POST]", $9d8fdf02b8ce4d4a$var$MAX_NODE$1));
    };
    PriorityIndex.prototype.makePost = function(indexValue, name) {
        var priorityNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON$1(indexValue);
        return new $9d8fdf02b8ce4d4a$var$NamedNode(name, new $9d8fdf02b8ce4d4a$var$LeafNode("[PRIORITY-POST]", priorityNode));
    };
    /**
     * @returns String representation for inclusion in a query spec
     */ PriorityIndex.prototype.toString = function() {
        return ".priority";
    };
    return PriorityIndex;
}($9d8fdf02b8ce4d4a$var$Index);
var $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX = new $9d8fdf02b8ce4d4a$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$LOG_2 = Math.log(2);
var $9d8fdf02b8ce4d4a$var$Base12Num = /** @class */ function() {
    function Base12Num(length) {
        var logBase2 = function(num) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return parseInt(Math.log(num) / $9d8fdf02b8ce4d4a$var$LOG_2, 10);
        };
        var bitMask = function(bits) {
            return parseInt(Array(bits + 1).join("1"), 2);
        };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    Base12Num.prototype.nextBitIsOne = function() {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    };
    return Base12Num;
}();
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ var $9d8fdf02b8ce4d4a$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function(low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $9d8fdf02b8ce4d4a$var$LLRBNode(key, namedNode.node, $9d8fdf02b8ce4d4a$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var middle = parseInt(length / 2, 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $9d8fdf02b8ce4d4a$var$LLRBNode(key, namedNode.node, $9d8fdf02b8ce4d4a$var$LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function(base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function(chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $9d8fdf02b8ce4d4a$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(var i = 0; i < base12.count; ++i){
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $9d8fdf02b8ce4d4a$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $9d8fdf02b8ce4d4a$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $9d8fdf02b8ce4d4a$var$LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new $9d8fdf02b8ce4d4a$var$Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $9d8fdf02b8ce4d4a$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$_defaultIndexMap;
var $9d8fdf02b8ce4d4a$var$fallbackObject = {};
var $9d8fdf02b8ce4d4a$var$IndexMap = /** @class */ function() {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         */ get: function() {
            (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$fallbackObject && $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, "ChildrenNode.ts has not been loaded");
            $9d8fdf02b8ce4d4a$var$_defaultIndexMap = $9d8fdf02b8ce4d4a$var$_defaultIndexMap || new IndexMap({
                ".priority": $9d8fdf02b8ce4d4a$var$fallbackObject
            }, {
                ".priority": $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX
            });
            return $9d8fdf02b8ce4d4a$var$_defaultIndexMap;
        },
        enumerable: false,
        configurable: true
    });
    IndexMap.prototype.get = function(indexKey) {
        var sortedMap = (0, $eTAKc.safeGet)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error("No index defined for " + indexKey);
        if (sortedMap instanceof $9d8fdf02b8ce4d4a$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    };
    IndexMap.prototype.hasIndex = function(indexDefinition) {
        return (0, $eTAKc.contains)(this.indexSet_, indexDefinition.toString());
    };
    IndexMap.prototype.addIndex = function(indexDefinition, existingChildren) {
        (0, $eTAKc.assert)(indexDefinition !== $9d8fdf02b8ce4d4a$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator($9d8fdf02b8ce4d4a$var$NamedNode.Wrap);
        var next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) newIndex = $9d8fdf02b8ce4d4a$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $9d8fdf02b8ce4d4a$var$fallbackObject;
        var indexName = indexDefinition.toString();
        var newIndexSet = (0, $2WUgS.__assign)({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = (0, $2WUgS.__assign)({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ IndexMap.prototype.addToIndexes = function(namedNode, existingChildren) {
        var _this = this;
        var newIndexes = (0, $eTAKc.map)(this.indexes_, function(indexedChildren, indexName) {
            var index = (0, $eTAKc.safeGet)(_this.indexSet_, indexName);
            (0, $eTAKc.assert)(index, "Missing index implementation for " + indexName);
            if (indexedChildren === $9d8fdf02b8ce4d4a$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator($9d8fdf02b8ce4d4a$var$NamedNode.Wrap);
                    var next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $9d8fdf02b8ce4d4a$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $9d8fdf02b8ce4d4a$var$fallbackObject;
            } else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $9d8fdf02b8ce4d4a$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     */ IndexMap.prototype.removeFromIndexes = function(namedNode, existingChildren) {
        var newIndexes = (0, $eTAKc.map)(this.indexes_, function(indexedChildren) {
            if (indexedChildren === $9d8fdf02b8ce4d4a$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $9d8fdf02b8ce4d4a$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
var $9d8fdf02b8ce4d4a$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ var $9d8fdf02b8ce4d4a$var$ChildrenNode = /** @class */ function() {
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $9d8fdf02b8ce4d4a$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $eTAKc.assert)(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function() {
            return $9d8fdf02b8ce4d4a$var$EMPTY_NODE || ($9d8fdf02b8ce4d4a$var$EMPTY_NODE = new ChildrenNode(new $9d8fdf02b8ce4d4a$var$SortedMap($9d8fdf02b8ce4d4a$var$NAME_COMPARATOR), null, $9d8fdf02b8ce4d4a$var$IndexMap.Default));
        },
        enumerable: false,
        configurable: true
    });
    /** @inheritDoc */ ChildrenNode.prototype.isLeafNode = function() {
        return false;
    };
    /** @inheritDoc */ ChildrenNode.prototype.getPriority = function() {
        return this.priorityNode_ || $9d8fdf02b8ce4d4a$var$EMPTY_NODE;
    };
    /** @inheritDoc */ ChildrenNode.prototype.updatePriority = function(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    };
    /** @inheritDoc */ ChildrenNode.prototype.getImmediateChild = function(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.getPriority();
        else {
            var child = this.children_.get(childName);
            return child === null ? $9d8fdf02b8ce4d4a$var$EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.getChild = function(path) {
        var front = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($9d8fdf02b8ce4d4a$var$pathPopFront(path));
    };
    /** @inheritDoc */ ChildrenNode.prototype.hasChild = function(childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */ ChildrenNode.prototype.updateImmediateChild = function(childName, newChildNode) {
        (0, $eTAKc.assert)(newChildNode, "We should always be passing snapshot nodes");
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else {
            var namedNode = new $9d8fdf02b8ce4d4a$var$NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            var newPriority = newChildren.isEmpty() ? $9d8fdf02b8ce4d4a$var$EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.updateChild = function(path, newChildNode) {
        var front = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$pathGetFront(path) !== ".priority" || $9d8fdf02b8ce4d4a$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            var newImmediateChild = this.getImmediateChild(front).updateChild($9d8fdf02b8ce4d4a$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.isEmpty = function() {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */ ChildrenNode.prototype.numChildren = function() {
        return this.children_.count();
    };
    /** @inheritDoc */ ChildrenNode.prototype.val = function(exportFormat) {
        if (this.isEmpty()) return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            // eslint-disable-next-line guard-for-in
            for(var key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj[".priority"] = this.getPriority().val();
            return obj;
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.hash = function() {
        if (this.lazyHash_ === null) {
            var toHash_1 = "";
            if (!this.getPriority().isEmpty()) toHash_1 += "priority:" + $9d8fdf02b8ce4d4a$var$priorityHashText(this.getPriority().val()) + ":";
            this.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== "") toHash_1 += ":" + key + ":" + childHash;
            });
            this.lazyHash_ = toHash_1 === "" ? "" : $9d8fdf02b8ce4d4a$var$sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */ ChildrenNode.prototype.getPredecessorChildName = function(childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new $9d8fdf02b8ce4d4a$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    };
    ChildrenNode.prototype.getFirstChildName = function(indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    };
    ChildrenNode.prototype.getFirstChild = function(indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $9d8fdf02b8ce4d4a$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ ChildrenNode.prototype.getLastChildName = function(indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    };
    ChildrenNode.prototype.getLastChild = function(indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $9d8fdf02b8ce4d4a$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    };
    ChildrenNode.prototype.forEachChild = function(index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal(function(wrappedNode) {
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    };
    ChildrenNode.prototype.getIterator = function(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    ChildrenNode.prototype.getIteratorFrom = function(startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, function(key) {
            return key;
        });
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, $9d8fdf02b8ce4d4a$var$NamedNode.Wrap);
            var next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    ChildrenNode.prototype.getReverseIterator = function(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    ChildrenNode.prototype.getReverseIteratorFrom = function(endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, function(key) {
            return key;
        });
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, $9d8fdf02b8ce4d4a$var$NamedNode.Wrap);
            var next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    ChildrenNode.prototype.compareTo = function(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $9d8fdf02b8ce4d4a$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    };
    ChildrenNode.prototype.withIndex = function(indexDefinition) {
        if (indexDefinition === $9d8fdf02b8ce4d4a$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    ChildrenNode.prototype.isIndexed = function(index) {
        return index === $9d8fdf02b8ce4d4a$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    ChildrenNode.prototype.equals = function(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ ChildrenNode.prototype.resolveIndex_ = function(indexDefinition) {
        if (indexDefinition === $9d8fdf02b8ce4d4a$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    };
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}();
var $9d8fdf02b8ce4d4a$var$MaxNode = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new $9d8fdf02b8ce4d4a$var$SortedMap($9d8fdf02b8ce4d4a$var$NAME_COMPARATOR), $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE, $9d8fdf02b8ce4d4a$var$IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function(other) {
        if (other === this) return 0;
        else return 1;
    };
    MaxNode.prototype.equals = function(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function() {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function(childName) {
        return $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function() {
        return false;
    };
    return MaxNode;
}($9d8fdf02b8ce4d4a$var$ChildrenNode);
/**
 * Marker that will sort higher than any other snapshot.
 */ var $9d8fdf02b8ce4d4a$var$MAX_NODE = new $9d8fdf02b8ce4d4a$var$MaxNode();
Object.defineProperties($9d8fdf02b8ce4d4a$var$NamedNode, {
    MIN: {
        value: new $9d8fdf02b8ce4d4a$var$NamedNode($9d8fdf02b8ce4d4a$var$MIN_NAME, $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $9d8fdf02b8ce4d4a$var$NamedNode($9d8fdf02b8ce4d4a$var$MAX_NAME, $9d8fdf02b8ce4d4a$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $9d8fdf02b8ce4d4a$var$KeyIndex.__EMPTY_NODE = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
$9d8fdf02b8ce4d4a$var$LeafNode.__childrenNodeConstructor = $9d8fdf02b8ce4d4a$var$ChildrenNode;
$9d8fdf02b8ce4d4a$var$setMaxNode$1($9d8fdf02b8ce4d4a$var$MAX_NODE);
$9d8fdf02b8ce4d4a$var$setMaxNode($9d8fdf02b8ce4d4a$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $9d8fdf02b8ce4d4a$var$nodeFromJSON(json, priority) {
    if (priority === void 0) priority = null;
    if (json === null) return $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === "object" && ".priority" in json) priority = json[".priority"];
    (0, $eTAKc.assert)(priority === null || typeof priority === "string" || typeof priority === "number" || typeof priority === "object" && ".sv" in priority, "Invalid priority type found: " + typeof priority);
    if (typeof json === "object" && ".value" in json && json[".value"] !== null) json = json[".value"];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== "object" || ".sv" in json) {
        var jsonLeaf = json;
        return new $9d8fdf02b8ce4d4a$var$LeafNode(jsonLeaf, $9d8fdf02b8ce4d4a$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $9d8fdf02b8ce4d4a$var$USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj = json;
        $9d8fdf02b8ce4d4a$var$each(hinzeJsonObj, function(key, child) {
            if (key.substring(0, 1) !== ".") {
                // Ignore metadata nodes
                var childNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 = childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new $9d8fdf02b8ce4d4a$var$NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length === 0) return $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
        var childSet = $9d8fdf02b8ce4d4a$var$buildChildSet(children_1, $9d8fdf02b8ce4d4a$var$NAME_ONLY_COMPARATOR, function(namedNode) {
            return namedNode.name;
        }, $9d8fdf02b8ce4d4a$var$NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = $9d8fdf02b8ce4d4a$var$buildChildSet(children_1, $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX.getCompare());
            return new $9d8fdf02b8ce4d4a$var$ChildrenNode(childSet, $9d8fdf02b8ce4d4a$var$nodeFromJSON(priority), new $9d8fdf02b8ce4d4a$var$IndexMap({
                ".priority": sortedChildSet
            }, {
                ".priority": $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX
            }));
        } else return new $9d8fdf02b8ce4d4a$var$ChildrenNode(childSet, $9d8fdf02b8ce4d4a$var$nodeFromJSON(priority), $9d8fdf02b8ce4d4a$var$IndexMap.Default);
    } else {
        var node_1 = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
        $9d8fdf02b8ce4d4a$var$each(json, function(key, childData) {
            if ((0, $eTAKc.contains)(json, key)) {
                if (key.substring(0, 1) !== ".") {
                    // ignore metadata nodes.
                    var childNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority($9d8fdf02b8ce4d4a$var$nodeFromJSON(priority));
    }
}
$9d8fdf02b8ce4d4a$var$setNodeFromJSON($9d8fdf02b8ce4d4a$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$PathIndex = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        (0, $eTAKc.assert)(!$9d8fdf02b8ce4d4a$var$pathIsEmpty(indexPath_) && $9d8fdf02b8ce4d4a$var$pathGetFront(indexPath_) !== ".priority", "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    PathIndex.prototype.extractChild = function(snap) {
        return snap.getChild(this.indexPath_);
    };
    PathIndex.prototype.isDefinedOn = function(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    PathIndex.prototype.compare = function(a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $9d8fdf02b8ce4d4a$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    PathIndex.prototype.makePost = function(indexValue, name) {
        var valueNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(indexValue);
        var node = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $9d8fdf02b8ce4d4a$var$NamedNode(name, node);
    };
    PathIndex.prototype.maxPost = function() {
        var node = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $9d8fdf02b8ce4d4a$var$MAX_NODE);
        return new $9d8fdf02b8ce4d4a$var$NamedNode($9d8fdf02b8ce4d4a$var$MAX_NAME, node);
    };
    PathIndex.prototype.toString = function() {
        return $9d8fdf02b8ce4d4a$var$pathSlice(this.indexPath_, 0).join("/");
    };
    return PathIndex;
}($9d8fdf02b8ce4d4a$var$Index);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$ValueIndex = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueIndex.prototype.compare = function(a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $9d8fdf02b8ce4d4a$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    ValueIndex.prototype.isDefinedOn = function(node) {
        return true;
    };
    ValueIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    ValueIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9d8fdf02b8ce4d4a$var$NamedNode.MIN;
    };
    ValueIndex.prototype.maxPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $9d8fdf02b8ce4d4a$var$NamedNode.MAX;
    };
    ValueIndex.prototype.makePost = function(indexValue, name) {
        var valueNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(indexValue);
        return new $9d8fdf02b8ce4d4a$var$NamedNode(name, valueNode);
    };
    /**
     * @returns String representation for inclusion in a query spec
     */ ValueIndex.prototype.toString = function() {
        return ".value";
    };
    return ValueIndex;
}($9d8fdf02b8ce4d4a$var$Index);
var $9d8fdf02b8ce4d4a$var$VALUE_INDEX = new $9d8fdf02b8ce4d4a$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
var $9d8fdf02b8ce4d4a$var$PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
var $9d8fdf02b8ce4d4a$var$MIN_PUSH_CHAR = "-";
var $9d8fdf02b8ce4d4a$var$MAX_PUSH_CHAR = "z";
var $9d8fdf02b8ce4d4a$var$MAX_KEY_LEN = 786;
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ var $9d8fdf02b8ce4d4a$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function(now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $9d8fdf02b8ce4d4a$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $eTAKc.assert)(now === 0, "Cannot push at time == 0");
        var id = timeStampChars.join("");
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $9d8fdf02b8ce4d4a$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $eTAKc.assert)(id.length === 20, "nextPushId: Length should be 20.");
        return id;
    };
}();
var $9d8fdf02b8ce4d4a$var$successor = function(key) {
    if (key === "" + $9d8fdf02b8ce4d4a$var$INTEGER_32_MAX) // See https://firebase.google.com/docs/database/web/lists-of-data#data-order
    return $9d8fdf02b8ce4d4a$var$MIN_PUSH_CHAR;
    var keyAsInt = $9d8fdf02b8ce4d4a$var$tryParseInt(key);
    if (keyAsInt != null) return "" + (keyAsInt + 1);
    var next = new Array(key.length);
    for(var i_1 = 0; i_1 < next.length; i_1++)next[i_1] = key.charAt(i_1);
    if (next.length < $9d8fdf02b8ce4d4a$var$MAX_KEY_LEN) {
        next.push($9d8fdf02b8ce4d4a$var$MIN_PUSH_CHAR);
        return next.join("");
    }
    var i = next.length - 1;
    while(i >= 0 && next[i] === $9d8fdf02b8ce4d4a$var$MAX_PUSH_CHAR)i--;
    // `successor` was called on the largest possible key, so return the
    // MAX_NAME, which sorts larger than all keys.
    if (i === -1) return $9d8fdf02b8ce4d4a$var$MAX_NAME;
    var source = next[i];
    var sourcePlusOne = $9d8fdf02b8ce4d4a$var$PUSH_CHARS.charAt($9d8fdf02b8ce4d4a$var$PUSH_CHARS.indexOf(source) + 1);
    next[i] = sourcePlusOne;
    return next.slice(0, i + 1).join("");
};
// `key` is assumed to be non-empty.
var $9d8fdf02b8ce4d4a$var$predecessor = function(key) {
    if (key === "" + $9d8fdf02b8ce4d4a$var$INTEGER_32_MIN) return $9d8fdf02b8ce4d4a$var$MIN_NAME;
    var keyAsInt = $9d8fdf02b8ce4d4a$var$tryParseInt(key);
    if (keyAsInt != null) return "" + (keyAsInt - 1);
    var next = new Array(key.length);
    for(var i = 0; i < next.length; i++)next[i] = key.charAt(i);
    // If `key` ends in `MIN_PUSH_CHAR`, the largest key lexicographically
    // smaller than `key`, is `key[0:key.length - 1]`. The next key smaller
    // than that, `predecessor(predecessor(key))`, is
    //
    // `key[0:key.length - 2] + (key[key.length - 1] - 1) + \
    //   { MAX_PUSH_CHAR repeated MAX_KEY_LEN - (key.length - 1) times }
    //
    // analogous to increment/decrement for base-10 integers.
    //
    // This works because lexigographic comparison works character-by-character,
    // using length as a tie-breaker if one key is a prefix of the other.
    if (next[next.length - 1] === $9d8fdf02b8ce4d4a$var$MIN_PUSH_CHAR) {
        if (next.length === 1) // See https://firebase.google.com/docs/database/web/lists-of-data#orderbykey
        return "" + $9d8fdf02b8ce4d4a$var$INTEGER_32_MAX;
        delete next[next.length - 1];
        return next.join("");
    }
    // Replace the last character with it's immediate predecessor, and
    // fill the suffix of the key with MAX_PUSH_CHAR. This is the
    // lexicographically largest possible key smaller than `key`.
    next[next.length - 1] = $9d8fdf02b8ce4d4a$var$PUSH_CHARS.charAt($9d8fdf02b8ce4d4a$var$PUSH_CHARS.indexOf(next[next.length - 1]) - 1);
    return next.join("") + $9d8fdf02b8ce4d4a$var$MAX_PUSH_CHAR.repeat($9d8fdf02b8ce4d4a$var$MAX_KEY_LEN - next.length);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9d8fdf02b8ce4d4a$var$changeValue(snapshotNode) {
    return {
        type: "value" /* VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $9d8fdf02b8ce4d4a$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $9d8fdf02b8ce4d4a$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $9d8fdf02b8ce4d4a$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $9d8fdf02b8ce4d4a$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ var $9d8fdf02b8ce4d4a$var$IndexedFilter = /** @class */ function() {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $eTAKc.assert)(snap.isIndexed(this.index_), "A node must be indexed if only a child is updated");
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildRemoved(key, oldChild));
                else (0, $eTAKc.assert)(snap.isLeafNode(), "A child remove without an old child only makes sense on a leaf node");
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    };
    IndexedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(key, childNode) {
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(key, childNode) {
                if (oldSnap.hasChild(key)) {
                    var oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    };
    IndexedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    };
    IndexedFilter.prototype.filtersNodes = function() {
        return false;
    };
    IndexedFilter.prototype.getIndexedFilter = function() {
        return this;
    };
    IndexedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    return IndexedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ var $9d8fdf02b8ce4d4a$var$RangedFilter = /** @class */ function() {
    function RangedFilter(params) {
        this.indexedFilter_ = new $9d8fdf02b8ce4d4a$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    RangedFilter.prototype.getStartPost = function() {
        return this.startPost_;
    };
    RangedFilter.prototype.getEndPost = function() {
        return this.endPost_;
    };
    RangedFilter.prototype.matches = function(node) {
        return this.index_.compare(this.getStartPost(), node) <= 0 && this.index_.compare(node, this.getEndPost()) <= 0;
    };
    RangedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $9d8fdf02b8ce4d4a$var$NamedNode(key, newChild))) newChild = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    RangedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(key, childNode) {
            if (!self.matches(new $9d8fdf02b8ce4d4a$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    RangedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    RangedFilter.prototype.filtersNodes = function() {
        return true;
    };
    RangedFilter.prototype.getIndexedFilter = function() {
        return this.indexedFilter_;
    };
    RangedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    RangedFilter.getStartPost_ = function(params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    };
    RangedFilter.getEndPost_ = function(params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    };
    return RangedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ var $9d8fdf02b8ce4d4a$var$LimitedFilter = /** @class */ function() {
    function LimitedFilter(params) {
        this.rangedFilter_ = new $9d8fdf02b8ce4d4a$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    LimitedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $9d8fdf02b8ce4d4a$var$NamedNode(key, newChild))) newChild = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    };
    LimitedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            var iterator = void 0;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            var count = 0;
            while(iterator.hasNext() && count < this.limit_){
                var next = iterator.getNext();
                var inRange = void 0;
                if (this.reverse_) inRange = this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                else inRange = this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                if (inRange) {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                } else break;
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE);
            var startPost = void 0;
            var endPost = void 0;
            var cmp = void 0;
            var iterator = void 0;
            if (this.reverse_) {
                iterator = filtered.getReverseIterator(this.index_);
                startPost = this.rangedFilter_.getEndPost();
                endPost = this.rangedFilter_.getStartPost();
                var indexCompare_1 = this.index_.getCompare();
                cmp = function(a, b) {
                    return indexCompare_1(b, a);
                };
            } else {
                iterator = filtered.getIterator(this.index_);
                startPost = this.rangedFilter_.getStartPost();
                endPost = this.rangedFilter_.getEndPost();
                cmp = this.index_.getCompare();
            }
            var count = 0;
            var foundStartPost = false;
            while(iterator.hasNext()){
                var next = iterator.getNext();
                if (!foundStartPost && cmp(startPost, next) <= 0) // start adding
                foundStartPost = true;
                var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    LimitedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    LimitedFilter.prototype.filtersNodes = function() {
        return true;
    };
    LimitedFilter.prototype.getIndexedFilter = function() {
        return this.rangedFilter_.getIndexedFilter();
    };
    LimitedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    LimitedFilter.prototype.fullLimitUpdateChild_ = function(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function(a, b) {
                return indexCmp_1(b, a);
            };
        } else cmp = this.index_.getCompare();
        var oldEventCache = snap;
        (0, $eTAKc.assert)(oldEventCache.numChildren() === this.limit_, "");
        var newChildNamedNode = new $9d8fdf02b8ce4d4a$var$NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildRemoved(childKey, oldChildSnap));
                var newEventCache = oldEventCache.updateImmediateChild(childKey, $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($9d8fdf02b8ce4d4a$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    };
    return LimitedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 */ var $9d8fdf02b8ce4d4a$var$QueryParams = /** @class */ function() {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = "";
        this.indexStartValue_ = null;
        this.indexStartName_ = "";
        this.indexEndValue_ = null;
        this.indexEndName_ = "";
        this.index_ = $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX;
    }
    QueryParams.prototype.hasStart = function() {
        return this.startSet_;
    };
    QueryParams.prototype.hasStartAfter = function() {
        return this.startAfterSet_;
    };
    QueryParams.prototype.hasEndBefore = function() {
        return this.endBeforeSet_;
    };
    /**
     * @returns True if it would return from left.
     */ QueryParams.prototype.isViewFromLeft = function() {
        if (this.viewFrom_ === "") // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* VIEW_FROM_LEFT */ ;
    };
    /**
     * Only valid to call if hasStart() returns true
     */ QueryParams.prototype.getIndexStartValue = function() {
        (0, $eTAKc.assert)(this.startSet_, "Only valid if start has been set");
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ QueryParams.prototype.getIndexStartName = function() {
        (0, $eTAKc.assert)(this.startSet_, "Only valid if start has been set");
        if (this.startNameSet_) return this.indexStartName_;
        else return $9d8fdf02b8ce4d4a$var$MIN_NAME;
    };
    QueryParams.prototype.hasEnd = function() {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     */ QueryParams.prototype.getIndexEndValue = function() {
        (0, $eTAKc.assert)(this.endSet_, "Only valid if end has been set");
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ QueryParams.prototype.getIndexEndName = function() {
        (0, $eTAKc.assert)(this.endSet_, "Only valid if end has been set");
        if (this.endNameSet_) return this.indexEndName_;
        else return $9d8fdf02b8ce4d4a$var$MAX_NAME;
    };
    QueryParams.prototype.hasLimit = function() {
        return this.limitSet_;
    };
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ QueryParams.prototype.hasAnchoredLimit = function() {
        return this.limitSet_ && this.viewFrom_ !== "";
    };
    /**
     * Only valid to call if hasLimit() returns true
     */ QueryParams.prototype.getLimit = function() {
        (0, $eTAKc.assert)(this.limitSet_, "Only valid if limit has been set");
        return this.limit_;
    };
    QueryParams.prototype.getIndex = function() {
        return this.index_;
    };
    QueryParams.prototype.loadsAllData = function() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    QueryParams.prototype.isDefault = function() {
        return this.loadsAllData() && this.index_ === $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX;
    };
    QueryParams.prototype.copy = function() {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    return QueryParams;
}();
function $9d8fdf02b8ce4d4a$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $9d8fdf02b8ce4d4a$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $9d8fdf02b8ce4d4a$var$LimitedFilter(queryParams);
    else return new $9d8fdf02b8ce4d4a$var$RangedFilter(queryParams);
}
function $9d8fdf02b8ce4d4a$var$queryParamsLimitToFirst(queryParams, newLimit) {
    var newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* VIEW_FROM_LEFT */ ;
    return newParams;
}
function $9d8fdf02b8ce4d4a$var$queryParamsLimitToLast(queryParams, newLimit) {
    var newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $9d8fdf02b8ce4d4a$var$queryParamsStartAt(queryParams, indexValue, key) {
    var newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = "";
    }
    return newParams;
}
function $9d8fdf02b8ce4d4a$var$queryParamsStartAfter(queryParams, indexValue, key) {
    var params;
    if (queryParams.index_ === $9d8fdf02b8ce4d4a$var$KEY_INDEX) {
        if (typeof indexValue === "string") indexValue = $9d8fdf02b8ce4d4a$var$successor(indexValue);
        params = $9d8fdf02b8ce4d4a$var$queryParamsStartAt(queryParams, indexValue, key);
    } else {
        var childKey = void 0;
        if (key == null) childKey = $9d8fdf02b8ce4d4a$var$MAX_NAME;
        else childKey = $9d8fdf02b8ce4d4a$var$successor(key);
        params = $9d8fdf02b8ce4d4a$var$queryParamsStartAt(queryParams, indexValue, childKey);
    }
    params.startAfterSet_ = true;
    return params;
}
function $9d8fdf02b8ce4d4a$var$queryParamsEndAt(queryParams, indexValue, key) {
    var newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = "";
    }
    return newParams;
}
function $9d8fdf02b8ce4d4a$var$queryParamsEndBefore(queryParams, indexValue, key) {
    var childKey;
    var params;
    if (queryParams.index_ === $9d8fdf02b8ce4d4a$var$KEY_INDEX) {
        if (typeof indexValue === "string") indexValue = $9d8fdf02b8ce4d4a$var$predecessor(indexValue);
        params = $9d8fdf02b8ce4d4a$var$queryParamsEndAt(queryParams, indexValue, key);
    } else {
        if (key == null) childKey = $9d8fdf02b8ce4d4a$var$MIN_NAME;
        else childKey = $9d8fdf02b8ce4d4a$var$predecessor(key);
        params = $9d8fdf02b8ce4d4a$var$queryParamsEndAt(queryParams, indexValue, childKey);
    }
    params.endBeforeSet_ = true;
    return params;
}
function $9d8fdf02b8ce4d4a$var$queryParamsOrderBy(queryParams, index) {
    var newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $9d8fdf02b8ce4d4a$var$queryParamsToRestQueryStringParameters(queryParams) {
    var qs = {};
    if (queryParams.isDefault()) return qs;
    var orderBy;
    if (queryParams.index_ === $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX) orderBy = "$priority" /* PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $9d8fdf02b8ce4d4a$var$VALUE_INDEX) orderBy = "$value" /* VALUE_INDEX */ ;
    else if (queryParams.index_ === $9d8fdf02b8ce4d4a$var$KEY_INDEX) orderBy = "$key" /* KEY_INDEX */ ;
    else {
        (0, $eTAKc.assert)(queryParams.index_ instanceof $9d8fdf02b8ce4d4a$var$PathIndex, "Unrecognized index type!");
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* ORDER_BY */ ] = (0, $eTAKc.stringify)(orderBy);
    if (queryParams.startSet_) {
        qs["startAt" /* START_AT */ ] = (0, $eTAKc.stringify)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs["startAt" /* START_AT */ ] += "," + (0, $eTAKc.stringify)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        qs["endAt" /* END_AT */ ] = (0, $eTAKc.stringify)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs["endAt" /* END_AT */ ] += "," + (0, $eTAKc.stringify)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $9d8fdf02b8ce4d4a$var$queryParamsGetQueryObject(queryParams) {
    var obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* INDEX_START_NAME */ ] = queryParams.indexStartName_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* INDEX_END_NAME */ ] = queryParams.indexEndName_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* LIMIT */ ] = queryParams.limit_;
        var viewFrom = queryParams.viewFrom_;
        if (viewFrom === "") {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX) obj["i" /* INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ var $9d8fdf02b8ce4d4a$var$ReadonlyRestClient = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(ReadonlyRestClient, _super);
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ _this.log_ = $9d8fdf02b8ce4d4a$var$logWrapper("p:rest:");
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function(stats) {
        throw new Error("Method not implemented.");
    };
    ReadonlyRestClient.getListenId_ = function(query, tag) {
        if (tag !== undefined) return "tag$" + tag;
        else {
            (0, $eTAKc.assert)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.listen = function(query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = $9d8fdf02b8ce4d4a$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + ".json", queryStringParameters, function(error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $eTAKc.safeGet)(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) status_1 = "ok";
                else if (error === 401) status_1 = "permission_denied";
                else status_1 = "rest_error:" + error;
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.unlisten = function(query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    ReadonlyRestClient.prototype.get = function(query) {
        var _this = this;
        var queryStringParameters = $9d8fdf02b8ce4d4a$var$queryParamsToRestQueryStringParameters(query._queryParams);
        var pathString = query._path.toString();
        var deferred = new (0, $eTAKc.Deferred)();
        this.restRequest_(pathString + ".json", queryStringParameters, function(error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.refreshAuthToken = function(token) {
    // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ ReadonlyRestClient.prototype.restRequest_ = function(pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) queryStringParameters = {};
        queryStringParameters["format"] = "export";
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(function(_a) {
            var _b = (0, $2WUgS.__read)(_a, 2), authToken = _b[0], appCheckToken = _b[1];
            if (authToken && authToken.accessToken) queryStringParameters["auth"] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters["ac"] = appCheckToken.token;
            var url = (_this.repoInfo_.secure ? "https://" : "http://") + _this.repoInfo_.host + pathString + "?" + "ns=" + _this.repoInfo_.namespace + (0, $eTAKc.querystring)(queryStringParameters);
            _this.log_("Sending REST request for " + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (callback && xhr.readyState === 4) {
                    _this.log_("REST Response for " + url + " received. status:", xhr.status, "response:", xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $eTAKc.jsonEval)(xhr.responseText);
                        } catch (e) {
                            $9d8fdf02b8ce4d4a$var$warn("Failed to parse JSON response for " + url + ": " + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $9d8fdf02b8ce4d4a$var$warn("Got unsuccessful REST response for " + url + " Status: " + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open("GET", url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}($9d8fdf02b8ce4d4a$var$ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ var $9d8fdf02b8ce4d4a$var$SnapshotHolder = /** @class */ function() {
    function SnapshotHolder() {
        this.rootNode_ = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function(path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9d8fdf02b8ce4d4a$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        var childKey = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $9d8fdf02b8ce4d4a$var$newSparseSnapshotTree());
        var child = sparseSnapshotTree.children.get(childKey);
        path = $9d8fdf02b8ce4d4a$var$pathPopFront(path);
        $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                var value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(key, tree) {
                    $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $9d8fdf02b8ce4d4a$var$Path(key), tree);
                });
                return $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            var childKey = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
            path = $9d8fdf02b8ce4d4a$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                var safeToRemove = $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, function(key, tree) {
        var path = new $9d8fdf02b8ce4d4a$var$Path(prefixPath.toString() + "/" + key);
        $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach(function(tree, key) {
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ var $9d8fdf02b8ce4d4a$var$StatsListener = /** @class */ function() {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function() {
        var newStats = this.collection_.get();
        var delta = (0, $2WUgS.__assign)({}, newStats);
        if (this.last_) $9d8fdf02b8ce4d4a$var$each(this.last_, function(stat, value) {
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var $9d8fdf02b8ce4d4a$var$FIRST_STATS_MIN_TIME = 10000;
var $9d8fdf02b8ce4d4a$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
var $9d8fdf02b8ce4d4a$var$REPORT_STATS_INTERVAL = 300000;
var $9d8fdf02b8ce4d4a$var$StatsReporter = /** @class */ function() {
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $9d8fdf02b8ce4d4a$var$StatsListener(collection);
        var timeout = $9d8fdf02b8ce4d4a$var$FIRST_STATS_MIN_TIME + ($9d8fdf02b8ce4d4a$var$FIRST_STATS_MAX_TIME - $9d8fdf02b8ce4d4a$var$FIRST_STATS_MIN_TIME) * Math.random();
        $9d8fdf02b8ce4d4a$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.reportStats_ = function() {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        $9d8fdf02b8ce4d4a$var$each(stats, function(stat, value) {
            if (value > 0 && (0, $eTAKc.contains)(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $9d8fdf02b8ce4d4a$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $9d8fdf02b8ce4d4a$var$REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}();
function $9d8fdf02b8ce4d4a$var$statsReporterIncludeStat(reporter, stat) {
    reporter.statsToReport_[stat] = true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $9d8fdf02b8ce4d4a$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($9d8fdf02b8ce4d4a$var$OperationType || ($9d8fdf02b8ce4d4a$var$OperationType = {}));
function $9d8fdf02b8ce4d4a$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $9d8fdf02b8ce4d4a$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $9d8fdf02b8ce4d4a$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$AckUserWrite = /** @class */ function() {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ function AckUserWrite(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $9d8fdf02b8ce4d4a$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $9d8fdf02b8ce4d4a$var$newOperationSourceUser();
    }
    AckUserWrite.prototype.operationForChild = function(childName) {
        if (!$9d8fdf02b8ce4d4a$var$pathIsEmpty(this.path)) {
            (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$pathGetFront(this.path) === childName, "operationForChild called for unrelated child.");
            return new AckUserWrite($9d8fdf02b8ce4d4a$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $eTAKc.assert)(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths.");
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            var childTree = this.affectedTree.subtree(new $9d8fdf02b8ce4d4a$var$Path(childName));
            return new AckUserWrite($9d8fdf02b8ce4d4a$var$newEmptyPath(), childTree, this.revert);
        }
    };
    return AckUserWrite;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$ListenComplete = /** @class */ function() {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $9d8fdf02b8ce4d4a$var$OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function(childName) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(this.path)) return new ListenComplete(this.source, $9d8fdf02b8ce4d4a$var$newEmptyPath());
        else return new ListenComplete(this.source, $9d8fdf02b8ce4d4a$var$pathPopFront(this.path));
    };
    return ListenComplete;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$Overwrite = /** @class */ function() {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $9d8fdf02b8ce4d4a$var$OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function(childName) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(this.path)) return new Overwrite(this.source, $9d8fdf02b8ce4d4a$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new Overwrite(this.source, $9d8fdf02b8ce4d4a$var$pathPopFront(this.path), this.snap);
    };
    return Overwrite;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$Merge = /** @class */ function() {
    function Merge(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $9d8fdf02b8ce4d4a$var$OperationType.MERGE;
    }
    Merge.prototype.operationForChild = function(childName) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(this.path)) {
            var childTree = this.children.subtree(new $9d8fdf02b8ce4d4a$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $9d8fdf02b8ce4d4a$var$Overwrite(this.source, $9d8fdf02b8ce4d4a$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new Merge(this.source, $9d8fdf02b8ce4d4a$var$newEmptyPath(), childTree);
        } else {
            (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, $9d8fdf02b8ce4d4a$var$pathPopFront(this.path), this.children);
        }
    };
    Merge.prototype.toString = function() {
        return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
    };
    return Merge;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ var $9d8fdf02b8ce4d4a$var$CacheNode = /** @class */ function() {
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ CacheNode.prototype.isFullyInitialized = function() {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ CacheNode.prototype.isFiltered = function() {
        return this.filtered_;
    };
    CacheNode.prototype.isCompleteForPath = function(path) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        var childKey = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    };
    CacheNode.prototype.isCompleteForChild = function(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    };
    CacheNode.prototype.getNode = function() {
        return this.node_;
    };
    return CacheNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ var $9d8fdf02b8ce4d4a$var$EventGenerator = /** @class */ function() {
    function EventGenerator(query_) {
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
    return EventGenerator;
}();
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    var events = [];
    var moves = [];
    changes.forEach(function(change) {
        if (change.type === "child_changed" /* CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($9d8fdf02b8ce4d4a$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    var filteredChanges = changes.filter(function(change) {
        return change.type === eventType;
    });
    filteredChanges.sort(function(a, b) {
        return $9d8fdf02b8ce4d4a$var$eventGeneratorCompareChanges(eventGenerator, a, b);
    });
    filteredChanges.forEach(function(change) {
        var materializedChange = $9d8fdf02b8ce4d4a$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach(function(registration) {
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $9d8fdf02b8ce4d4a$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === "value" || change.type === "child_removed") return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $9d8fdf02b8ce4d4a$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $eTAKc.assertionError)("Should only compare child_ events.");
    var aWrapped = new $9d8fdf02b8ce4d4a$var$NamedNode(a.childName, a.snapshotNode);
    var bWrapped = new $9d8fdf02b8ce4d4a$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9d8fdf02b8ce4d4a$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $9d8fdf02b8ce4d4a$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $9d8fdf02b8ce4d4a$var$newViewCache(new $9d8fdf02b8ce4d4a$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $9d8fdf02b8ce4d4a$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $9d8fdf02b8ce4d4a$var$newViewCache(viewCache.eventCache, new $9d8fdf02b8ce4d4a$var$CacheNode(serverSnap, complete, filtered));
}
function $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ var $9d8fdf02b8ce4d4a$var$EmptyChildren = function() {
    if (!$9d8fdf02b8ce4d4a$var$emptyChildrenSingleton) $9d8fdf02b8ce4d4a$var$emptyChildrenSingleton = new $9d8fdf02b8ce4d4a$var$SortedMap($9d8fdf02b8ce4d4a$var$stringCompare);
    return $9d8fdf02b8ce4d4a$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ var $9d8fdf02b8ce4d4a$var$ImmutableTree = /** @class */ function() {
    function ImmutableTree(value, children) {
        if (children === void 0) children = $9d8fdf02b8ce4d4a$var$EmptyChildren();
        this.value = value;
        this.children = children;
    }
    ImmutableTree.fromObject = function(obj) {
        var tree = new ImmutableTree(null);
        $9d8fdf02b8ce4d4a$var$each(obj, function(childPath, childSnap) {
            tree = tree.set(new $9d8fdf02b8ce4d4a$var$Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     */ ImmutableTree.prototype.isEmpty = function() {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ ImmutableTree.prototype.findRootMostMatchingPathAndValue = function(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $9d8fdf02b8ce4d4a$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath)) return null;
            else {
                var front = $9d8fdf02b8ce4d4a$var$pathGetFront(relativePath);
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue($9d8fdf02b8ce4d4a$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = $9d8fdf02b8ce4d4a$var$pathChild(new $9d8fdf02b8ce4d4a$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ ImmutableTree.prototype.findRootMostValueAndPath = function(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function() {
            return true;
        });
    };
    /**
     * @returns The subtree at the given path
     */ ImmutableTree.prototype.subtree = function(relativePath) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath)) return this;
        else {
            var front = $9d8fdf02b8ce4d4a$var$pathGetFront(relativePath);
            var childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($9d8fdf02b8ce4d4a$var$pathPopFront(relativePath));
            else return new ImmutableTree(null);
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ ImmutableTree.prototype.set = function(relativePath, toSet) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath)) return new ImmutableTree(toSet, this.children);
        else {
            var front = $9d8fdf02b8ce4d4a$var$pathGetFront(relativePath);
            var child = this.children.get(front) || new ImmutableTree(null);
            var newChild = child.set($9d8fdf02b8ce4d4a$var$pathPopFront(relativePath), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ ImmutableTree.prototype.remove = function(relativePath) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new ImmutableTree(null);
            else return new ImmutableTree(null, this.children);
        } else {
            var front = $9d8fdf02b8ce4d4a$var$pathGetFront(relativePath);
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove($9d8fdf02b8ce4d4a$var$pathPopFront(relativePath));
                var newChildren = void 0;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new ImmutableTree(null);
                else return new ImmutableTree(this.value, newChildren);
            } else return this;
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ ImmutableTree.prototype.get = function(relativePath) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath)) return this.value;
        else {
            var front = $9d8fdf02b8ce4d4a$var$pathGetFront(relativePath);
            var child = this.children.get(front);
            if (child) return child.get($9d8fdf02b8ce4d4a$var$pathPopFront(relativePath));
            else return null;
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ ImmutableTree.prototype.setTree = function(relativePath, newTree) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath)) return newTree;
        else {
            var front = $9d8fdf02b8ce4d4a$var$pathGetFront(relativePath);
            var child = this.children.get(front) || new ImmutableTree(null);
            var newChild = child.setTree($9d8fdf02b8ce4d4a$var$pathPopFront(relativePath), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ ImmutableTree.prototype.fold = function(fn) {
        return this.fold_($9d8fdf02b8ce4d4a$var$newEmptyPath(), fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     */ ImmutableTree.prototype.fold_ = function(pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function(childKey, childTree) {
            accum[childKey] = childTree.fold_($9d8fdf02b8ce4d4a$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ ImmutableTree.prototype.findOnPath = function(path, f) {
        return this.findOnPath_(path, $9d8fdf02b8ce4d4a$var$newEmptyPath(), f);
    };
    ImmutableTree.prototype.findOnPath_ = function(pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(pathToFollow)) return null;
            else {
                var front = $9d8fdf02b8ce4d4a$var$pathGetFront(pathToFollow);
                var nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($9d8fdf02b8ce4d4a$var$pathPopFront(pathToFollow), $9d8fdf02b8ce4d4a$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    };
    ImmutableTree.prototype.foreachOnPath = function(path, f) {
        return this.foreachOnPath_(path, $9d8fdf02b8ce4d4a$var$newEmptyPath(), f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function(pathToFollow, currentRelativePath, f) {
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            var front = $9d8fdf02b8ce4d4a$var$pathGetFront(pathToFollow);
            var nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($9d8fdf02b8ce4d4a$var$pathPopFront(pathToFollow), $9d8fdf02b8ce4d4a$var$pathChild(currentRelativePath, front), f);
            else return new ImmutableTree(null);
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ ImmutableTree.prototype.foreach = function(f) {
        this.foreach_($9d8fdf02b8ce4d4a$var$newEmptyPath(), f);
    };
    ImmutableTree.prototype.foreach_ = function(currentRelativePath, f) {
        this.children.inorderTraversal(function(childName, childTree) {
            childTree.foreach_($9d8fdf02b8ce4d4a$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    };
    ImmutableTree.prototype.foreachChild = function(f) {
        this.children.inorderTraversal(function(childName, childTree) {
            if (childTree.value) f(childName, childTree.value);
        });
    };
    return ImmutableTree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ var $9d8fdf02b8ce4d4a$var$CompoundWrite = /** @class */ function() {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    CompoundWrite.empty = function() {
        return new CompoundWrite(new $9d8fdf02b8ce4d4a$var$ImmutableTree(null));
    };
    return CompoundWrite;
}();
function $9d8fdf02b8ce4d4a$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) return new $9d8fdf02b8ce4d4a$var$CompoundWrite(new $9d8fdf02b8ce4d4a$var$ImmutableTree(node));
    else {
        var rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            var rootMostPath = rootmost.path;
            var value = rootmost.value;
            var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $9d8fdf02b8ce4d4a$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            var subtree = new $9d8fdf02b8ce4d4a$var$ImmutableTree(node);
            var newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $9d8fdf02b8ce4d4a$var$CompoundWrite(newWriteTree);
        }
    }
}
function $9d8fdf02b8ce4d4a$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    var newWrite = compoundWrite;
    $9d8fdf02b8ce4d4a$var$each(updates, function(childKey, node) {
        newWrite = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrite(newWrite, $9d8fdf02b8ce4d4a$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $9d8fdf02b8ce4d4a$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) return $9d8fdf02b8ce4d4a$var$CompoundWrite.empty();
    else {
        var newWriteTree = compoundWrite.writeTree_.setTree(path, new $9d8fdf02b8ce4d4a$var$ImmutableTree(null));
        return new $9d8fdf02b8ce4d4a$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $9d8fdf02b8ce4d4a$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    var rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($9d8fdf02b8ce4d4a$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteChildren(compoundWrite) {
    var children = [];
    var node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(childName, childNode) {
            children.push(new $9d8fdf02b8ce4d4a$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal(function(childName, childTree) {
        if (childTree.value != null) children.push(new $9d8fdf02b8ce4d4a$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) return compoundWrite;
    else {
        var shadowingNode = $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $9d8fdf02b8ce4d4a$var$CompoundWrite(new $9d8fdf02b8ce4d4a$var$ImmutableTree(shadowingNode));
        else return new $9d8fdf02b8ce4d4a$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $9d8fdf02b8ce4d4a$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $9d8fdf02b8ce4d4a$var$compoundWriteApply(compoundWrite, node) {
    return $9d8fdf02b8ce4d4a$var$applySubtreeWrite($9d8fdf02b8ce4d4a$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $9d8fdf02b8ce4d4a$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        var priorityWrite_1 = null;
        writeTree.children.inorderTraversal(function(childKey, childTree) {
            if (childKey === ".priority") {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $eTAKc.assert)(childTree.value !== null, "Priority writes must always be leaf nodes");
                priorityWrite_1 = childTree.value;
            } else node = $9d8fdf02b8ce4d4a$var$applySubtreeWrite($9d8fdf02b8ce4d4a$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) node = node.updateChild($9d8fdf02b8ce4d4a$var$pathChild(relativePath, ".priority"), priorityWrite_1);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $9d8fdf02b8ce4d4a$var$writeTreeChildWrites(writeTree, path) {
    return $9d8fdf02b8ce4d4a$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $9d8fdf02b8ce4d4a$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $eTAKc.assert)(writeId > writeTree.lastWriteId, "Stacking an older write on top of newer ones");
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $eTAKc.assert)(writeId > writeTree.lastWriteId, "Stacking an older merge on top of newer ones");
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $9d8fdf02b8ce4d4a$var$writeTreeGetWrite(writeTree, writeId) {
    for(var i = 0; i < writeTree.allWrites.length; i++){
        var record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    var idx = writeTree.allWrites.findIndex(function(s) {
        return s.writeId === writeId;
    });
    (0, $eTAKc.assert)(idx >= 0, "removeWrite called with nonexistent writeId.");
    var writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    var removedWriteWasVisible = writeToRemove.visible;
    var removedWriteOverlapsWithOtherWrites = false;
    var i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        var currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $9d8fdf02b8ce4d4a$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($9d8fdf02b8ce4d4a$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $9d8fdf02b8ce4d4a$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $9d8fdf02b8ce4d4a$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            var children = writeToRemove.children;
            $9d8fdf02b8ce4d4a$var$each(children, function(childName) {
                writeTree.visibleWrites = $9d8fdf02b8ce4d4a$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $9d8fdf02b8ce4d4a$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $9d8fdf02b8ce4d4a$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $9d8fdf02b8ce4d4a$var$pathContains(writeRecord.path, path);
    else {
        for(var childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $9d8fdf02b8ce4d4a$var$pathContains($9d8fdf02b8ce4d4a$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $9d8fdf02b8ce4d4a$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $9d8fdf02b8ce4d4a$var$writeTreeLayerTree_(writeTree.allWrites, $9d8fdf02b8ce4d4a$var$writeTreeDefaultFilter_, $9d8fdf02b8ce4d4a$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    var compoundWrite = $9d8fdf02b8ce4d4a$var$CompoundWrite.empty();
    for(var i = 0; i < writes.length; ++i){
        var write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            var writePath = write.path;
            var relativePath = void 0;
            if (write.snap) {
                if ($9d8fdf02b8ce4d4a$var$pathContains(treeRoot, writePath)) {
                    relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($9d8fdf02b8ce4d4a$var$pathContains(writePath, treeRoot)) {
                    relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrite(compoundWrite, $9d8fdf02b8ce4d4a$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($9d8fdf02b8ce4d4a$var$pathContains(treeRoot, writePath)) {
                    relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($9d8fdf02b8ce4d4a$var$pathContains(writePath, treeRoot)) {
                    relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(writePath, treeRoot);
                    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath)) compoundWrite = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrites(compoundWrite, $9d8fdf02b8ce4d4a$var$newEmptyPath(), write.children);
                    else {
                        var child = (0, $eTAKc.safeGet)(write.children, $9d8fdf02b8ce4d4a$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            var deepNode = child.getChild($9d8fdf02b8ce4d4a$var$pathPopFront(relativePath));
                            compoundWrite = $9d8fdf02b8ce4d4a$var$compoundWriteAddWrite(compoundWrite, $9d8fdf02b8ce4d4a$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $eTAKc.assertionError)("WriteRecord should have .snap or .children");
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $9d8fdf02b8ce4d4a$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        var shadowingNode = $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            var subMerge = $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($9d8fdf02b8ce4d4a$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$9d8fdf02b8ce4d4a$var$compoundWriteHasCompleteWrite(subMerge, $9d8fdf02b8ce4d4a$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                var layeredCache = completeServerCache || $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
                return $9d8fdf02b8ce4d4a$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        var merge = $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $9d8fdf02b8ce4d4a$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$9d8fdf02b8ce4d4a$var$compoundWriteHasCompleteWrite(merge, $9d8fdf02b8ce4d4a$var$newEmptyPath())) return null;
            else {
                var filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($9d8fdf02b8ce4d4a$var$pathContains(write.path, treePath) || $9d8fdf02b8ce4d4a$var$pathContains(treePath, write.path));
                };
                var mergeAtPath = $9d8fdf02b8ce4d4a$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                var layeredCache = completeServerCache || $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
                return $9d8fdf02b8ce4d4a$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    var completeChildren = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
    var topLevelSet = $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(childName, childSnap) {
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        var merge_1 = $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(childName, childNode) {
            var node = $9d8fdf02b8ce4d4a$var$compoundWriteApply($9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(merge_1, new $9d8fdf02b8ce4d4a$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteChildren(merge_1).forEach(function(namedNode) {
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        var merge = $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteChildren(merge).forEach(function(namedNode) {
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $9d8fdf02b8ce4d4a$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $eTAKc.assert)(existingEventSnap || existingServerSnap, "Either existingEventSnap or existingServerSnap must exist");
    var path = $9d8fdf02b8ce4d4a$var$pathChild(treePath, childPath);
    if ($9d8fdf02b8ce4d4a$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        var childMerge = $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($9d8fdf02b8ce4d4a$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $9d8fdf02b8ce4d4a$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    var path = $9d8fdf02b8ce4d4a$var$pathChild(treePath, childKey);
    var shadowingNode = $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            var childMerge = $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $9d8fdf02b8ce4d4a$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeShadowingWrite(writeTree, path) {
    return $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    var toIterate;
    var merge = $9d8fdf02b8ce4d4a$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    var shadowingNode = $9d8fdf02b8ce4d4a$var$compoundWriteGetCompleteNode(merge, $9d8fdf02b8ce4d4a$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $9d8fdf02b8ce4d4a$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        var nodes = [];
        var cmp = index.getCompare();
        var iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        var next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $9d8fdf02b8ce4d4a$var$newWriteTree() {
    return {
        visibleWrites: $9d8fdf02b8ce4d4a$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $9d8fdf02b8ce4d4a$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $9d8fdf02b8ce4d4a$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $9d8fdf02b8ce4d4a$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $9d8fdf02b8ce4d4a$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $9d8fdf02b8ce4d4a$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $9d8fdf02b8ce4d4a$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $9d8fdf02b8ce4d4a$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $9d8fdf02b8ce4d4a$var$writeTreeRefChild(writeTreeRef, childName) {
    return $9d8fdf02b8ce4d4a$var$newWriteTreeRef($9d8fdf02b8ce4d4a$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $9d8fdf02b8ce4d4a$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$ChildChangeAccumulator = /** @class */ function() {
    function ChildChangeAccumulator() {
        this.changeMap = new Map();
    }
    ChildChangeAccumulator.prototype.trackChildChange = function(change) {
        var type = change.type;
        var childKey = change.childName;
        (0, $eTAKc.assert)(type === "child_added" /* CHILD_ADDED */  || type === "child_changed" /* CHILD_CHANGED */  || type === "child_removed" /* CHILD_REMOVED */ , "Only child changes supported for tracking");
        (0, $eTAKc.assert)(childKey !== ".priority", "Only non-priority child changes can be tracked.");
        var oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type === "child_added" /* CHILD_ADDED */  && oldType === "child_removed" /* CHILD_REMOVED */ ) this.changeMap.set(childKey, $9d8fdf02b8ce4d4a$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* CHILD_REMOVED */  && oldType === "child_added" /* CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* CHILD_REMOVED */  && oldType === "child_changed" /* CHILD_CHANGED */ ) this.changeMap.set(childKey, $9d8fdf02b8ce4d4a$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* CHILD_CHANGED */  && oldType === "child_added" /* CHILD_ADDED */ ) this.changeMap.set(childKey, $9d8fdf02b8ce4d4a$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* CHILD_CHANGED */  && oldType === "child_changed" /* CHILD_CHANGED */ ) this.changeMap.set(childKey, $9d8fdf02b8ce4d4a$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $eTAKc.assertionError)("Illegal combination of changes: " + change + " occurred after " + oldChange);
        } else this.changeMap.set(childKey, change);
    };
    ChildChangeAccumulator.prototype.getChanges = function() {
        return Array.from(this.changeMap.values());
    };
    return ChildChangeAccumulator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
var $9d8fdf02b8ce4d4a$var$NoCompleteChildSource_ = /** @class */ function() {
    function NoCompleteChildSource_() {}
    NoCompleteChildSource_.prototype.getCompleteChild = function(childKey) {
        return null;
    };
    NoCompleteChildSource_.prototype.getChildAfterChild = function(index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}();
/**
 * Singleton instance.
 */ var $9d8fdf02b8ce4d4a$var$NO_COMPLETE_CHILD_SOURCE = new $9d8fdf02b8ce4d4a$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ var $9d8fdf02b8ce4d4a$var$WriteTreeCompleteChildSource = /** @class */ function() {
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) optCompleteServerCache_ = null;
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function(childKey) {
        var node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            var serverNode = this.optCompleteServerCache_ != null ? new $9d8fdf02b8ce4d4a$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    };
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function(index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        var nodes = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    };
    return WriteTreeCompleteChildSource;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9d8fdf02b8ce4d4a$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $9d8fdf02b8ce4d4a$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $eTAKc.assert)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Event snap not indexed");
    (0, $eTAKc.assert)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Server snap not indexed");
}
function $9d8fdf02b8ce4d4a$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    var accumulator = new $9d8fdf02b8ce4d4a$var$ChildChangeAccumulator();
    var newViewCache, filterServerNode;
    if (operation.type === $9d8fdf02b8ce4d4a$var$OperationType.OVERWRITE) {
        var overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $eTAKc.assert)(overwrite.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$9d8fdf02b8ce4d4a$var$pathIsEmpty(overwrite.path);
            newViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $9d8fdf02b8ce4d4a$var$OperationType.MERGE) {
        var merge = operation;
        if (merge.source.fromUser) newViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $eTAKc.assert)(merge.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $9d8fdf02b8ce4d4a$var$OperationType.ACK_USER_WRITE) {
        var ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $9d8fdf02b8ce4d4a$var$OperationType.LISTEN_COMPLETE) newViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $eTAKc.assertionError)("Unknown operation type: " + operation.type);
    var changes = accumulator.getChanges();
    $9d8fdf02b8ce4d4a$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $9d8fdf02b8ce4d4a$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    var eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        var oldCompleteSnap = $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($9d8fdf02b8ce4d4a$var$changeValue($9d8fdf02b8ce4d4a$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $9d8fdf02b8ce4d4a$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    var oldEventSnap = viewCache.eventCache;
    if ($9d8fdf02b8ce4d4a$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        var newEventCache = void 0, serverNode = void 0;
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $eTAKc.assert)(viewCache.serverCache.isFullyInitialized(), "If change path is empty, we must have complete server data");
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                var serverCache = $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(viewCache);
                var completeChildren = serverCache instanceof $9d8fdf02b8ce4d4a$var$ChildrenNode ? serverCache : $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
                var completeEventChildren = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                var completeNode = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventCache(writesCache, $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            var childKey = $9d8fdf02b8ce4d4a$var$pathGetFront(changePath);
            if (childKey === ".priority") {
                (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                var oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                var updatedPriority = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                var childChangePath = $9d8fdf02b8ce4d4a$var$pathPopFront(changePath);
                // update child
                var newEventChild = void 0;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    var eventChildUpdate = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $9d8fdf02b8ce4d4a$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $9d8fdf02b8ce4d4a$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    var oldServerSnap = oldViewCache.serverCache;
    var newServerCache;
    var serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        var newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        var childKey = $9d8fdf02b8ce4d4a$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $9d8fdf02b8ce4d4a$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        var childChangePath = $9d8fdf02b8ce4d4a$var$pathPopFront(changePath);
        var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        var newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === ".priority") newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $9d8fdf02b8ce4d4a$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    var newViewCache = $9d8fdf02b8ce4d4a$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $9d8fdf02b8ce4d4a$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    var source = new $9d8fdf02b8ce4d4a$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $9d8fdf02b8ce4d4a$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $9d8fdf02b8ce4d4a$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    var oldEventSnap = oldViewCache.eventCache;
    var newViewCache, newEventCache;
    var source = new $9d8fdf02b8ce4d4a$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $9d8fdf02b8ce4d4a$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        var childKey = $9d8fdf02b8ce4d4a$var$pathGetFront(changePath);
        if (childKey === ".priority") {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $9d8fdf02b8ce4d4a$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            var childChangePath = $9d8fdf02b8ce4d4a$var$pathPopFront(changePath);
            var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            var newChild = void 0;
            if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                var childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($9d8fdf02b8ce4d4a$var$pathGetBack(childChangePath) === ".priority" && childNode.getChild($9d8fdf02b8ce4d4a$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                var newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $9d8fdf02b8ce4d4a$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $9d8fdf02b8ce4d4a$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $9d8fdf02b8ce4d4a$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    var curViewCache = viewCache;
    changedChildren.foreach(function(relativePath, childNode) {
        var writePath = $9d8fdf02b8ce4d4a$var$pathChild(path, relativePath);
        if ($9d8fdf02b8ce4d4a$var$viewProcessorCacheHasChild(viewCache, $9d8fdf02b8ce4d4a$var$pathGetFront(writePath))) curViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach(function(relativePath, childNode) {
        var writePath = $9d8fdf02b8ce4d4a$var$pathChild(path, relativePath);
        if (!$9d8fdf02b8ce4d4a$var$viewProcessorCacheHasChild(viewCache, $9d8fdf02b8ce4d4a$var$pathGetFront(writePath))) curViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $9d8fdf02b8ce4d4a$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach(function(relativePath, childNode) {
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    var curViewCache = viewCache;
    var viewMergeTree;
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $9d8fdf02b8ce4d4a$var$ImmutableTree(null).setTree(path, changedChildren);
    var serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal(function(childKey, childTree) {
        if (serverNode.hasChild(childKey)) {
            var serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            var newChild = $9d8fdf02b8ce4d4a$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $9d8fdf02b8ce4d4a$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal(function(childKey, childMergeTree) {
        var isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === undefined;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            var serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            var newChild = $9d8fdf02b8ce4d4a$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $9d8fdf02b8ce4d4a$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $9d8fdf02b8ce4d4a$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($9d8fdf02b8ce4d4a$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    var filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    var serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            var changedChildren_1 = new $9d8fdf02b8ce4d4a$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($9d8fdf02b8ce4d4a$var$KEY_INDEX, function(name, node) {
                changedChildren_1 = changedChildren_1.set(new $9d8fdf02b8ce4d4a$var$Path(name), node);
            });
            return $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        var changedChildren_2 = new $9d8fdf02b8ce4d4a$var$ImmutableTree(null);
        affectedTree.foreach(function(mergePath, value) {
            var serverCachePath = $9d8fdf02b8ce4d4a$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $9d8fdf02b8ce4d4a$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $9d8fdf02b8ce4d4a$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    var oldServerNode = viewCache.serverCache;
    var newViewCache = $9d8fdf02b8ce4d4a$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $9d8fdf02b8ce4d4a$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $9d8fdf02b8ce4d4a$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $9d8fdf02b8ce4d4a$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $9d8fdf02b8ce4d4a$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    var complete;
    if ($9d8fdf02b8ce4d4a$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        var source = new $9d8fdf02b8ce4d4a$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        var oldEventCache = viewCache.eventCache.getNode();
        var newEventCache = void 0;
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(path) || $9d8fdf02b8ce4d4a$var$pathGetFront(path) === ".priority") {
            var newNode = void 0;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventCache(writesCache, $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                var serverChildren = viewCache.serverCache.getNode();
                (0, $eTAKc.assert)(serverChildren instanceof $9d8fdf02b8ce4d4a$var$ChildrenNode, "serverChildren would be complete if leaf node");
                newNode = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            var childKey = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
            var newChild = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $9d8fdf02b8ce4d4a$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE, $9d8fdf02b8ce4d4a$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventCache(writesCache, $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $9d8fdf02b8ce4d4a$var$writeTreeRefShadowingWrite(writesCache, $9d8fdf02b8ce4d4a$var$newEmptyPath()) != null;
        return $9d8fdf02b8ce4d4a$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ var $9d8fdf02b8ce4d4a$var$View = /** @class */ function() {
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_._queryParams;
        var indexFilter = new $9d8fdf02b8ce4d4a$var$IndexedFilter(params.getIndex());
        var filter = $9d8fdf02b8ce4d4a$var$queryParamsGetNodeFilter(params);
        this.processor_ = $9d8fdf02b8ce4d4a$var$newViewProcessor(filter);
        var initialServerCache = initialViewCache.serverCache;
        var initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode($9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode($9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new $9d8fdf02b8ce4d4a$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new $9d8fdf02b8ce4d4a$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $9d8fdf02b8ce4d4a$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $9d8fdf02b8ce4d4a$var$EventGenerator(this.query_);
    }
    Object.defineProperty(View.prototype, "query", {
        get: function() {
            return this.query_;
        },
        enumerable: false,
        configurable: true
    });
    return View;
}();
function $9d8fdf02b8ce4d4a$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $9d8fdf02b8ce4d4a$var$viewGetCompleteNode(view) {
    return $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $9d8fdf02b8ce4d4a$var$viewGetCompleteServerCache(view, path) {
    var cache = $9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$9d8fdf02b8ce4d4a$var$pathIsEmpty(path) && !cache.getImmediateChild($9d8fdf02b8ce4d4a$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $9d8fdf02b8ce4d4a$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $9d8fdf02b8ce4d4a$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $9d8fdf02b8ce4d4a$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    var cancelEvents = [];
    if (cancelError) {
        (0, $eTAKc.assert)(eventRegistration == null, "A cancel should cancel all event registrations.");
        var path_1 = view.query._path;
        view.eventRegistrations_.forEach(function(registration) {
            var maybeEvent = registration.createCancelEvent(cancelError, path_1);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        var remaining = [];
        for(var i = 0; i < view.eventRegistrations_.length; ++i){
            var existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $9d8fdf02b8ce4d4a$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $9d8fdf02b8ce4d4a$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$viewCacheGetCompleteServerSnap(view.viewCache_), "We should always have a full cache before handling merges");
        (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$viewCacheGetCompleteEventSnap(view.viewCache_), "Missing event cache, even though we have a server cache");
    }
    var oldViewCache = view.viewCache_;
    var result = $9d8fdf02b8ce4d4a$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $9d8fdf02b8ce4d4a$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $eTAKc.assert)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), "Once a server snap is complete, it should never go back");
    view.viewCache_ = result.viewCache;
    return $9d8fdf02b8ce4d4a$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $9d8fdf02b8ce4d4a$var$viewGetInitialEvents(view, registration) {
    var eventSnap = view.viewCache_.eventCache;
    var initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        var eventNode = eventSnap.getNode();
        eventNode.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(key, childNode) {
            initialChanges.push($9d8fdf02b8ce4d4a$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($9d8fdf02b8ce4d4a$var$changeValue(eventSnap.getNode()));
    return $9d8fdf02b8ce4d4a$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $9d8fdf02b8ce4d4a$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    var registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $9d8fdf02b8ce4d4a$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ var $9d8fdf02b8ce4d4a$var$SyncPoint = /** @class */ function() {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
    return SyncPoint;
}();
function $9d8fdf02b8ce4d4a$var$syncPointSetReferenceConstructor(val) {
    (0, $eTAKc.assert)(!$9d8fdf02b8ce4d4a$var$referenceConstructor$1, "__referenceConstructor has already been defined");
    $9d8fdf02b8ce4d4a$var$referenceConstructor$1 = val;
}
function $9d8fdf02b8ce4d4a$var$syncPointGetReferenceConstructor() {
    (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$referenceConstructor$1, "Reference.ts has not been loaded");
    return $9d8fdf02b8ce4d4a$var$referenceConstructor$1;
}
function $9d8fdf02b8ce4d4a$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $9d8fdf02b8ce4d4a$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    var e_1, _a;
    var queryId = operation.source.queryId;
    if (queryId !== null) {
        var view = syncPoint.views.get(queryId);
        (0, $eTAKc.assert)(view != null, "SyncTree gave us an op for an invalid query.");
        return $9d8fdf02b8ce4d4a$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        var events = [];
        try {
            for(var _b = (0, $2WUgS.__values)(syncPoint.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var view = _c.value;
                events = events.concat($9d8fdf02b8ce4d4a$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    var queryId = query._queryIdentifier;
    var view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        var eventCache = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        var eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $9d8fdf02b8ce4d4a$var$ChildrenNode) {
            eventCache = $9d8fdf02b8ce4d4a$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        var viewCache = $9d8fdf02b8ce4d4a$var$newViewCache(new $9d8fdf02b8ce4d4a$var$CacheNode(eventCache, eventCacheComplete, false), new $9d8fdf02b8ce4d4a$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $9d8fdf02b8ce4d4a$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    var view = $9d8fdf02b8ce4d4a$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $9d8fdf02b8ce4d4a$var$viewAddEventRegistration(view, eventRegistration);
    return $9d8fdf02b8ce4d4a$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $9d8fdf02b8ce4d4a$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    var e_2, _a;
    var queryId = query._queryIdentifier;
    var removed = [];
    var cancelEvents = [];
    var hadCompleteView = $9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(syncPoint);
    if (queryId === "default") try {
        // When you do ref.off(...), we search all views for the registration to remove.
        for(var _b = (0, $2WUgS.__values)(syncPoint.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, $2WUgS.__read)(_c.value, 2), viewQueryId = _d[0], view = _d[1];
            cancelEvents = cancelEvents.concat($9d8fdf02b8ce4d4a$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($9d8fdf02b8ce4d4a$var$viewIsEmpty(view)) {
                syncPoint.views.delete(viewQueryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    else {
        // remove the callback from the specific view.
        var view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($9d8fdf02b8ce4d4a$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($9d8fdf02b8ce4d4a$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($9d8fdf02b8ce4d4a$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $9d8fdf02b8ce4d4a$var$syncPointGetQueryViews(syncPoint) {
    var e_3, _a;
    var result = [];
    try {
        for(var _b = (0, $2WUgS.__values)(syncPoint.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
            var view = _c.value;
            if (!view.query._queryParams.loadsAllData()) result.push(view);
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(syncPoint, path) {
    var e_4, _a;
    var serverCache = null;
    try {
        for(var _b = (0, $2WUgS.__values)(syncPoint.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
            var view = _c.value;
            serverCache = serverCache || $9d8fdf02b8ce4d4a$var$viewGetCompleteServerCache(view, path);
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return serverCache;
}
function $9d8fdf02b8ce4d4a$var$syncPointViewForQuery(syncPoint, query) {
    var params = query._queryParams;
    if (params.loadsAllData()) return $9d8fdf02b8ce4d4a$var$syncPointGetCompleteView(syncPoint);
    else {
        var queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $9d8fdf02b8ce4d4a$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $9d8fdf02b8ce4d4a$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(syncPoint) {
    return $9d8fdf02b8ce4d4a$var$syncPointGetCompleteView(syncPoint) != null;
}
function $9d8fdf02b8ce4d4a$var$syncPointGetCompleteView(syncPoint) {
    var e_5, _a;
    try {
        for(var _b = (0, $2WUgS.__values)(syncPoint.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
            var view = _c.value;
            if (view.query._queryParams.loadsAllData()) return view;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$referenceConstructor;
function $9d8fdf02b8ce4d4a$var$syncTreeSetReferenceConstructor(val) {
    (0, $eTAKc.assert)(!$9d8fdf02b8ce4d4a$var$referenceConstructor, "__referenceConstructor has already been defined");
    $9d8fdf02b8ce4d4a$var$referenceConstructor = val;
}
function $9d8fdf02b8ce4d4a$var$syncTreeGetReferenceConstructor() {
    (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$referenceConstructor, "Reference.ts has not been loaded");
    return $9d8fdf02b8ce4d4a$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ var $9d8fdf02b8ce4d4a$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ var $9d8fdf02b8ce4d4a$var$SyncTree = /** @class */ function() {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $9d8fdf02b8ce4d4a$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $9d8fdf02b8ce4d4a$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
    return SyncTree;
}();
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $9d8fdf02b8ce4d4a$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9d8fdf02b8ce4d4a$var$Overwrite($9d8fdf02b8ce4d4a$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $9d8fdf02b8ce4d4a$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    var changeTree = $9d8fdf02b8ce4d4a$var$ImmutableTree.fromObject(changedChildren);
    return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9d8fdf02b8ce4d4a$var$Merge($9d8fdf02b8ce4d4a$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(syncTree, writeId, revert) {
    if (revert === void 0) revert = false;
    var write = $9d8fdf02b8ce4d4a$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    var needToReevaluate = $9d8fdf02b8ce4d4a$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        var affectedTree_1 = new $9d8fdf02b8ce4d4a$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree_1 = affectedTree_1.set($9d8fdf02b8ce4d4a$var$newEmptyPath(), true);
        else $9d8fdf02b8ce4d4a$var$each(write.children, function(pathString) {
            affectedTree_1 = affectedTree_1.set(new $9d8fdf02b8ce4d4a$var$Path(pathString), true);
        });
        return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9d8fdf02b8ce4d4a$var$AckUserWrite(write.path, affectedTree_1, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9d8fdf02b8ce4d4a$var$Overwrite($9d8fdf02b8ce4d4a$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    var changeTree = $9d8fdf02b8ce4d4a$var$ImmutableTree.fromObject(changedChildren);
    return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9d8fdf02b8ce4d4a$var$Merge($9d8fdf02b8ce4d4a$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyListenComplete(syncTree, path) {
    return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $9d8fdf02b8ce4d4a$var$ListenComplete($9d8fdf02b8ce4d4a$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    var queryKey = $9d8fdf02b8ce4d4a$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        var r = $9d8fdf02b8ce4d4a$var$syncTreeParseQueryKey_(queryKey);
        var queryPath = r.path, queryId = r.queryId;
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(queryPath, path);
        var op = new $9d8fdf02b8ce4d4a$var$ListenComplete($9d8fdf02b8ce4d4a$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    var path = query._path;
    var maybeSyncPoint = syncTree.syncPointTree_.get(path);
    var cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === "default" || $9d8fdf02b8ce4d4a$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        var removedAndEvents = $9d8fdf02b8ce4d4a$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($9d8fdf02b8ce4d4a$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        var removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        // We may have just removed one of many listeners and can short-circuit this whole process
        // We may also not have removed a default listener, in which case all of the descendant listeners should already be
        // properly set up.
        //
        // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
        // queryId === 'default'
        var removingDefault = -1 !== removed.findIndex(function(query) {
            return query._queryParams.loadsAllData();
        });
        var covered = syncTree.syncPointTree_.findOnPath(path, function(relativePath, parentSyncPoint) {
            return $9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(parentSyncPoint);
        });
        if (removingDefault && !covered) {
            var subtree = syncTree.syncPointTree_.subtree(path);
            // There are potentially child listeners. Determine what if any listens we need to send before executing the
            // removal
            if (!subtree.isEmpty()) {
                // We need to fold over our subtree and collect the listeners to send
                var newViews = $9d8fdf02b8ce4d4a$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                // Ok, we've collected all the listens we need. Set them up.
                for(var i = 0; i < newViews.length; ++i){
                    var view = newViews[i], newQuery = view.query;
                    var listener = $9d8fdf02b8ce4d4a$var$syncTreeCreateListenerForView_(syncTree, view);
                    syncTree.listenProvider_.startListening($9d8fdf02b8ce4d4a$var$syncTreeQueryForListening_(newQuery), $9d8fdf02b8ce4d4a$var$syncTreeTagForQuery_(syncTree, newQuery), listener.hashFn, listener.onComplete);
                }
            }
        }
        // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
        // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
        // Also, note that if we have a cancelError, it's already been removed at the provider level.
        if (!covered && removed.length > 0 && !cancelError) {
            // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
            // default. Otherwise, we need to iterate through and cancel each individual query
            if (removingDefault) {
                // We don't tag default listeners
                var defaultTag = null;
                syncTree.listenProvider_.stopListening($9d8fdf02b8ce4d4a$var$syncTreeQueryForListening_(query), defaultTag);
            } else removed.forEach(function(queryToRemove) {
                var tagToRemove = syncTree.queryToTagMap.get($9d8fdf02b8ce4d4a$var$syncTreeMakeQueryKey_(queryToRemove));
                syncTree.listenProvider_.stopListening($9d8fdf02b8ce4d4a$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
            });
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $9d8fdf02b8ce4d4a$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    var queryKey = $9d8fdf02b8ce4d4a$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        var r = $9d8fdf02b8ce4d4a$var$syncTreeParseQueryKey_(queryKey);
        var queryPath = r.path, queryId = r.queryId;
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(queryPath, path);
        var op = new $9d8fdf02b8ce4d4a$var$Overwrite($9d8fdf02b8ce4d4a$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    var queryKey = $9d8fdf02b8ce4d4a$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        var r = $9d8fdf02b8ce4d4a$var$syncTreeParseQueryKey_(queryKey);
        var queryPath = r.path, queryId = r.queryId;
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(queryPath, path);
        var changeTree = $9d8fdf02b8ce4d4a$var$ImmutableTree.fromObject(changedChildren);
        var op = new $9d8fdf02b8ce4d4a$var$Merge($9d8fdf02b8ce4d4a$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration) {
    var path = query._path;
    var serverCache = null;
    var foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, function(pathToSyncPoint, sp) {
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(sp);
    });
    var syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $9d8fdf02b8ce4d4a$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(syncPoint, $9d8fdf02b8ce4d4a$var$newEmptyPath());
    }
    var serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
        var subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild(function(childName, childSyncPoint) {
            var completeCache = $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(childSyncPoint, $9d8fdf02b8ce4d4a$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    var viewAlreadyExists = $9d8fdf02b8ce4d4a$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        var queryKey = $9d8fdf02b8ce4d4a$var$syncTreeMakeQueryKey_(query);
        (0, $eTAKc.assert)(!syncTree.queryToTagMap.has(queryKey), "View does not exist, but we have a tag");
        var tag = $9d8fdf02b8ce4d4a$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    var writesCache = $9d8fdf02b8ce4d4a$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    var events = $9d8fdf02b8ce4d4a$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView) {
        var view = $9d8fdf02b8ce4d4a$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $9d8fdf02b8ce4d4a$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    var includeHiddenSets = true;
    var writeTree = syncTree.pendingWriteTree_;
    var serverCache = syncTree.syncPointTree_.findOnPath(path, function(pathSoFar, syncPoint) {
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(pathSoFar, path);
        var serverCache = $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $9d8fdf02b8ce4d4a$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $9d8fdf02b8ce4d4a$var$syncTreeGetServerValue(syncTree, query) {
    var path = query._path;
    var serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, function(pathToSyncPoint, sp) {
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    var syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $9d8fdf02b8ce4d4a$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(syncPoint, $9d8fdf02b8ce4d4a$var$newEmptyPath());
    var serverCacheComplete = serverCache != null;
    var serverCacheNode = serverCacheComplete ? new $9d8fdf02b8ce4d4a$var$CacheNode(serverCache, true, false) : null;
    var writesCache = $9d8fdf02b8ce4d4a$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    var view = $9d8fdf02b8ce4d4a$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $9d8fdf02b8ce4d4a$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $9d8fdf02b8ce4d4a$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $9d8fdf02b8ce4d4a$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(operation.path)) return $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        var syncPoint = syncPointTree.get($9d8fdf02b8ce4d4a$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(syncPoint, $9d8fdf02b8ce4d4a$var$newEmptyPath());
        var events = [];
        var childName = $9d8fdf02b8ce4d4a$var$pathGetFront(operation.path);
        var childOperation = operation.operationForChild(childName);
        var childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            var childWritesCache = $9d8fdf02b8ce4d4a$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($9d8fdf02b8ce4d4a$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    var syncPoint = syncPointTree.get($9d8fdf02b8ce4d4a$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $9d8fdf02b8ce4d4a$var$syncPointGetCompleteServerCache(syncPoint, $9d8fdf02b8ce4d4a$var$newEmptyPath());
    var events = [];
    syncPointTree.children.inorderTraversal(function(childName, childTree) {
        var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        var childWritesCache = $9d8fdf02b8ce4d4a$var$writeTreeRefChild(writesCache, childName);
        var childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($9d8fdf02b8ce4d4a$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $9d8fdf02b8ce4d4a$var$syncTreeCreateListenerForView_(syncTree, view) {
    var query = view.query;
    var tag = $9d8fdf02b8ce4d4a$var$syncTreeTagForQuery_(syncTree, query);
    return {
        hashFn: function() {
            var cache = $9d8fdf02b8ce4d4a$var$viewGetServerCache(view) || $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: function(status) {
            if (status === "ok") {
                if (tag) return $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $9d8fdf02b8ce4d4a$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                var error = $9d8fdf02b8ce4d4a$var$errorForServerCode(status, query);
                return $9d8fdf02b8ce4d4a$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeTagForQuery_(syncTree, query) {
    var queryKey = $9d8fdf02b8ce4d4a$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + "$" + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $9d8fdf02b8ce4d4a$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeParseQueryKey_(queryKey) {
    var splitIndex = queryKey.indexOf("$");
    (0, $eTAKc.assert)(splitIndex !== -1 && splitIndex < queryKey.length - 1, "Bad queryKey.");
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $9d8fdf02b8ce4d4a$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    var syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $eTAKc.assert)(syncPoint, "Missing sync point for query tag that we're tracking");
    var writesCache = $9d8fdf02b8ce4d4a$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $9d8fdf02b8ce4d4a$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
        if (maybeChildSyncPoint && $9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            var completeView = $9d8fdf02b8ce4d4a$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            var views_1 = [];
            if (maybeChildSyncPoint) views_1 = $9d8fdf02b8ce4d4a$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $9d8fdf02b8ce4d4a$var$each(childMap, function(_key, childViews) {
                views_1 = views_1.concat(childViews);
            });
            return views_1;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $9d8fdf02b8ce4d4a$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($9d8fdf02b8ce4d4a$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $9d8fdf02b8ce4d4a$var$syncTreeRemoveTags_(syncTree, queries) {
    for(var j = 0; j < queries.length; ++j){
        var removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            var removedQueryKey = $9d8fdf02b8ce4d4a$var$syncTreeMakeQueryKey_(removedQuery);
            var removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $9d8fdf02b8ce4d4a$var$syncTreeGetNextQueryTag_() {
    return $9d8fdf02b8ce4d4a$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $9d8fdf02b8ce4d4a$var$syncTreeSetupListener_(syncTree, query, view) {
    var path = query._path;
    var tag = $9d8fdf02b8ce4d4a$var$syncTreeTagForQuery_(syncTree, query);
    var listener = $9d8fdf02b8ce4d4a$var$syncTreeCreateListenerForView_(syncTree, view);
    var events = syncTree.listenProvider_.startListening($9d8fdf02b8ce4d4a$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    var subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $eTAKc.assert)(!$9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        var queriesToStop = subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
            if (!$9d8fdf02b8ce4d4a$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $9d8fdf02b8ce4d4a$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $9d8fdf02b8ce4d4a$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                var queries_1 = [];
                if (maybeChildSyncPoint) queries_1 = queries_1.concat($9d8fdf02b8ce4d4a$var$syncPointGetQueryViews(maybeChildSyncPoint).map(function(view) {
                    return view.query;
                }));
                $9d8fdf02b8ce4d4a$var$each(childMap, function(_key, childQueries) {
                    queries_1 = queries_1.concat(childQueries);
                });
                return queries_1;
            }
        });
        for(var i = 0; i < queriesToStop.length; ++i){
            var queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($9d8fdf02b8ce4d4a$var$syncTreeQueryForListening_(queryToStop), $9d8fdf02b8ce4d4a$var$syncTreeTagForQuery_(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$ExistingValueProvider = /** @class */ function() {
    function ExistingValueProvider(node_) {
        this.node_ = node_;
    }
    ExistingValueProvider.prototype.getImmediateChild = function(childName) {
        var child = this.node_.getImmediateChild(childName);
        return new ExistingValueProvider(child);
    };
    ExistingValueProvider.prototype.node = function() {
        return this.node_;
    };
    return ExistingValueProvider;
}();
var $9d8fdf02b8ce4d4a$var$DeferredValueProvider = /** @class */ function() {
    function DeferredValueProvider(syncTree, path) {
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    DeferredValueProvider.prototype.getImmediateChild = function(childName) {
        var childPath = $9d8fdf02b8ce4d4a$var$pathChild(this.path_, childName);
        return new DeferredValueProvider(this.syncTree_, childPath);
    };
    DeferredValueProvider.prototype.node = function() {
        return $9d8fdf02b8ce4d4a$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    };
    return DeferredValueProvider;
}();
/**
 * Generate placeholders for deferred values.
 */ var $9d8fdf02b8ce4d4a$var$generateWithValues = function(values) {
    values = values || {};
    values["timestamp"] = values["timestamp"] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ var $9d8fdf02b8ce4d4a$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== "object") return value;
    (0, $eTAKc.assert)(".sv" in value, "Unexpected leaf node or priority contents");
    if (typeof value[".sv"] === "string") return $9d8fdf02b8ce4d4a$var$resolveScalarDeferredValue(value[".sv"], existingVal, serverValues);
    else if (typeof value[".sv"] === "object") return $9d8fdf02b8ce4d4a$var$resolveComplexDeferredValue(value[".sv"], existingVal);
    else (0, $eTAKc.assert)(false, "Unexpected server value: " + JSON.stringify(value, null, 2));
};
var $9d8fdf02b8ce4d4a$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case "timestamp":
            return serverValues["timestamp"];
        default:
            (0, $eTAKc.assert)(false, "Unexpected server value: " + op);
    }
};
var $9d8fdf02b8ce4d4a$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty("increment")) (0, $eTAKc.assert)(false, "Unexpected server value: " + JSON.stringify(op, null, 2));
    var delta = op["increment"];
    if (typeof delta !== "number") (0, $eTAKc.assert)(false, "Unexpected increment value: " + delta);
    var existingNode = existing.node();
    (0, $eTAKc.assert)(existingNode !== null && typeof existingNode !== "undefined", "Expected ChildrenNode.EMPTY_NODE for nulls");
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    var leaf = existingNode;
    var existingVal = leaf.getValue();
    if (typeof existingVal !== "number") return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ var $9d8fdf02b8ce4d4a$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $9d8fdf02b8ce4d4a$var$resolveDeferredValue(node, new $9d8fdf02b8ce4d4a$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ var $9d8fdf02b8ce4d4a$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $9d8fdf02b8ce4d4a$var$resolveDeferredValue(node, new $9d8fdf02b8ce4d4a$var$ExistingValueProvider(existing), serverValues);
};
function $9d8fdf02b8ce4d4a$var$resolveDeferredValue(node, existingVal, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = $9d8fdf02b8ce4d4a$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild(".priority"), serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = $9d8fdf02b8ce4d4a$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $9d8fdf02b8ce4d4a$var$LeafNode(value, $9d8fdf02b8ce4d4a$var$nodeFromJSON(priority));
        else return node;
    } else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $9d8fdf02b8ce4d4a$var$LeafNode(priority));
        childrenNode.forEachChild($9d8fdf02b8ce4d4a$var$PRIORITY_INDEX, function(childName, childNode) {
            var newChildNode = $9d8fdf02b8ce4d4a$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ var $9d8fdf02b8ce4d4a$var$Tree = /** @class */ function() {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ function Tree(name, parent, node) {
        if (name === void 0) name = "";
        if (parent === void 0) parent = null;
        if (node === void 0) node = {
            children: {},
            childCount: 0
        };
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
    return Tree;
}();
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $9d8fdf02b8ce4d4a$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    var path = pathObj instanceof $9d8fdf02b8ce4d4a$var$Path ? pathObj : new $9d8fdf02b8ce4d4a$var$Path(pathObj);
    var child = tree, next = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
    while(next !== null){
        var childNode = (0, $eTAKc.safeGet)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $9d8fdf02b8ce4d4a$var$Tree(next, child, childNode);
        path = $9d8fdf02b8ce4d4a$var$pathPopFront(path);
        next = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $9d8fdf02b8ce4d4a$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $9d8fdf02b8ce4d4a$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $9d8fdf02b8ce4d4a$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $9d8fdf02b8ce4d4a$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whethe rthe tree is empty (no value or children).
 */ function $9d8fdf02b8ce4d4a$var$treeIsEmpty(tree) {
    return $9d8fdf02b8ce4d4a$var$treeGetValue(tree) === undefined && !$9d8fdf02b8ce4d4a$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $9d8fdf02b8ce4d4a$var$treeForEachChild(tree, action) {
    $9d8fdf02b8ce4d4a$var$each(tree.node.children, function(child, childTree) {
        action(new $9d8fdf02b8ce4d4a$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $9d8fdf02b8ce4d4a$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $9d8fdf02b8ce4d4a$var$treeForEachChild(tree, function(child) {
        $9d8fdf02b8ce4d4a$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $9d8fdf02b8ce4d4a$var$treeForEachAncestor(tree, action, includeSelf) {
    var node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $9d8fdf02b8ce4d4a$var$treeGetPath(tree) {
    return new $9d8fdf02b8ce4d4a$var$Path(tree.parent === null ? tree.name : $9d8fdf02b8ce4d4a$var$treeGetPath(tree.parent) + "/" + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $9d8fdf02b8ce4d4a$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $9d8fdf02b8ce4d4a$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $9d8fdf02b8ce4d4a$var$treeUpdateChild(tree, childName, child) {
    var childEmpty = $9d8fdf02b8ce4d4a$var$treeIsEmpty(child);
    var childExists = (0, $eTAKc.contains)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $9d8fdf02b8ce4d4a$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $9d8fdf02b8ce4d4a$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ var $9d8fdf02b8ce4d4a$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ var $9d8fdf02b8ce4d4a$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ var $9d8fdf02b8ce4d4a$var$MAX_LEAF_SIZE_ = 10485760;
var $9d8fdf02b8ce4d4a$var$isValidKey = function(key) {
    return typeof key === "string" && key.length !== 0 && !$9d8fdf02b8ce4d4a$var$INVALID_KEY_REGEX_.test(key);
};
var $9d8fdf02b8ce4d4a$var$isValidPathString = function(pathString) {
    return typeof pathString === "string" && pathString.length !== 0 && !$9d8fdf02b8ce4d4a$var$INVALID_PATH_REGEX_.test(pathString);
};
var $9d8fdf02b8ce4d4a$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    return $9d8fdf02b8ce4d4a$var$isValidPathString(pathString);
};
var $9d8fdf02b8ce4d4a$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === "string" || typeof priority === "number" && !$9d8fdf02b8ce4d4a$var$isInvalidJSONNumber(priority) || priority && typeof priority === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $eTAKc.contains)(priority, ".sv");
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ var $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $9d8fdf02b8ce4d4a$var$validateFirebaseData((0, $eTAKc.errorPrefix)(fnName, "value"), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ var $9d8fdf02b8ce4d4a$var$validateFirebaseData = function(errorPrefix, data, path_) {
    var path = path_ instanceof $9d8fdf02b8ce4d4a$var$Path ? new $9d8fdf02b8ce4d4a$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + "contains undefined " + $9d8fdf02b8ce4d4a$var$validationPathToErrorString(path));
    if (typeof data === "function") throw new Error(errorPrefix + "contains a function " + $9d8fdf02b8ce4d4a$var$validationPathToErrorString(path) + " with contents = " + data.toString());
    if ($9d8fdf02b8ce4d4a$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + "contains " + data.toString() + " " + $9d8fdf02b8ce4d4a$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === "string" && data.length > $9d8fdf02b8ce4d4a$var$MAX_LEAF_SIZE_ / 3 && (0, $eTAKc.stringLength)(data) > $9d8fdf02b8ce4d4a$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + "contains a string greater than " + $9d8fdf02b8ce4d4a$var$MAX_LEAF_SIZE_ + " utf8 bytes " + $9d8fdf02b8ce4d4a$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === "object") {
        var hasDotValue_1 = false;
        var hasActualChild_1 = false;
        $9d8fdf02b8ce4d4a$var$each(data, function(key, value) {
            if (key === ".value") hasDotValue_1 = true;
            else if (key !== ".priority" && key !== ".sv") {
                hasActualChild_1 = true;
                if (!$9d8fdf02b8ce4d4a$var$isValidKey(key)) throw new Error(errorPrefix + " contains an invalid key (" + key + ") " + $9d8fdf02b8ce4d4a$var$validationPathToErrorString(path) + ".  Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $9d8fdf02b8ce4d4a$var$validationPathPush(path, key);
            $9d8fdf02b8ce4d4a$var$validateFirebaseData(errorPrefix, value, path);
            $9d8fdf02b8ce4d4a$var$validationPathPop(path);
        });
        if (hasDotValue_1 && hasActualChild_1) throw new Error(errorPrefix + ' contains ".value" child ' + $9d8fdf02b8ce4d4a$var$validationPathToErrorString(path) + " in addition to actual children.");
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ var $9d8fdf02b8ce4d4a$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    var i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        var keys = $9d8fdf02b8ce4d4a$var$pathSlice(curPath);
        for(var j = 0; j < keys.length; j++){
            if (keys[j] === ".priority" && j === keys.length - 1) ;
            else if (!$9d8fdf02b8ce4d4a$var$isValidKey(keys[j])) throw new Error(errorPrefix + "contains an invalid key (" + keys[j] + ") in path " + curPath.toString() + ". Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($9d8fdf02b8ce4d4a$var$pathCompare);
    var prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $9d8fdf02b8ce4d4a$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + "contains a path " + prevPath.toString() + " that is ancestor of another path " + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ var $9d8fdf02b8ce4d4a$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    var errorPrefix$1 = (0, $eTAKc.errorPrefix)(fnName, "values");
    if (!(data && typeof data === "object") || Array.isArray(data)) throw new Error(errorPrefix$1 + " must be an object containing the children to replace.");
    var mergePaths = [];
    $9d8fdf02b8ce4d4a$var$each(data, function(key, value) {
        var curPath = new $9d8fdf02b8ce4d4a$var$Path(key);
        $9d8fdf02b8ce4d4a$var$validateFirebaseData(errorPrefix$1, value, $9d8fdf02b8ce4d4a$var$pathChild(path, curPath));
        if ($9d8fdf02b8ce4d4a$var$pathGetBack(curPath) === ".priority") {
            if (!$9d8fdf02b8ce4d4a$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + "Firebase priority (a string, finite number, server value, or null).");
        }
        mergePaths.push(curPath);
    });
    $9d8fdf02b8ce4d4a$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
var $9d8fdf02b8ce4d4a$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($9d8fdf02b8ce4d4a$var$isInvalidJSONNumber(priority)) throw new Error((0, $eTAKc.errorPrefix)(fnName, "priority") + "is " + priority.toString() + ", but must be a valid Firebase priority (a string, finite number, " + "server value, or null).");
    // Special case to allow importing data with a .sv.
    if (!$9d8fdf02b8ce4d4a$var$isValidPriority(priority)) throw new Error((0, $eTAKc.errorPrefix)(fnName, "priority") + "must be a valid Firebase priority " + "(a string, finite number, server value, or null).");
};
var $9d8fdf02b8ce4d4a$var$validateEventType = function(fnName, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch(eventType){
        case "value":
        case "child_added":
        case "child_removed":
        case "child_changed":
        case "child_moved":
            break;
        default:
            throw new Error((0, $eTAKc.errorPrefix)(fnName, "eventType") + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
var $9d8fdf02b8ce4d4a$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$9d8fdf02b8ce4d4a$var$isValidKey(key)) throw new Error((0, $eTAKc.errorPrefix)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var $9d8fdf02b8ce4d4a$var$validatePathString = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$9d8fdf02b8ce4d4a$var$isValidPathString(pathString)) throw new Error((0, $eTAKc.errorPrefix)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
var $9d8fdf02b8ce4d4a$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    $9d8fdf02b8ce4d4a$var$validatePathString(fnName, argumentName, pathString, optional);
};
var $9d8fdf02b8ce4d4a$var$validateWritablePath = function(fnName, path) {
    if ($9d8fdf02b8ce4d4a$var$pathGetFront(path) === ".info") throw new Error(fnName + " failed = Can't modify data under /.info/");
};
var $9d8fdf02b8ce4d4a$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === "string") || parsedUrl.repoInfo.host.length === 0 || !$9d8fdf02b8ce4d4a$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(":")[0] !== "localhost" || pathString.length !== 0 && !$9d8fdf02b8ce4d4a$var$isValidRootPathString(pathString)) throw new Error((0, $eTAKc.errorPrefix)(fnName, "url") + "must be a valid firebase URL and " + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
var $9d8fdf02b8ce4d4a$var$validateBoolean = function(fnName, argumentName, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== "boolean") throw new Error((0, $eTAKc.errorPrefix)(fnName, argumentName) + "must be a boolean.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ var $9d8fdf02b8ce4d4a$var$EventQueue = /** @class */ function() {
    function EventQueue() {
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
    return EventQueue;
}();
/**
 * @param eventDataList - The new events to queue.
 */ function $9d8fdf02b8ce4d4a$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    var currList = null;
    for(var i = 0; i < eventDataList.length; i++){
        var data = eventDataList[i];
        var path = data.getPath();
        if (currList !== null && !$9d8fdf02b8ce4d4a$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $9d8fdf02b8ce4d4a$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, function(eventPath) {
        return $9d8fdf02b8ce4d4a$var$pathEquals(eventPath, path);
    });
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $9d8fdf02b8ce4d4a$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, function(eventPath) {
        return $9d8fdf02b8ce4d4a$var$pathContains(eventPath, changedPath) || $9d8fdf02b8ce4d4a$var$pathContains(changedPath, eventPath);
    });
}
function $9d8fdf02b8ce4d4a$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    var sentAll = true;
    for(var i = 0; i < eventQueue.eventLists_.length; i++){
        var eventList = eventQueue.eventLists_[i];
        if (eventList) {
            var eventPath = eventList.path;
            if (predicate(eventPath)) {
                $9d8fdf02b8ce4d4a$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $9d8fdf02b8ce4d4a$var$eventListRaise(eventList) {
    for(var i = 0; i < eventList.events.length; i++){
        var eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            var eventFn = eventData.getEventRunner();
            if ($9d8fdf02b8ce4d4a$var$logger) $9d8fdf02b8ce4d4a$var$log("event: " + eventData.toString());
            $9d8fdf02b8ce4d4a$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$INTERRUPT_REASON = "repo_interrupt";
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ var $9d8fdf02b8ce4d4a$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ var $9d8fdf02b8ce4d4a$var$Repo = /** @class */ function() {
    function Repo(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_) {
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $9d8fdf02b8ce4d4a$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $9d8fdf02b8ce4d4a$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $9d8fdf02b8ce4d4a$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ Repo.prototype.toString = function() {
        return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
    };
    return Repo;
}();
function $9d8fdf02b8ce4d4a$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $9d8fdf02b8ce4d4a$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $9d8fdf02b8ce4d4a$var$beingCrawled()) {
        repo.server_ = new $9d8fdf02b8ce4d4a$var$ReadonlyRestClient(repo.repoInfo_, function(pathString, data, isMerge, tag) {
            $9d8fdf02b8ce4d4a$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(function() {
            return $9d8fdf02b8ce4d4a$var$repoOnConnectStatus(repo, /* connectStatus= */ true);
        }, 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== "undefined" && authOverride !== null) {
            if (typeof authOverride !== "object") throw new Error("Only objects are supported for option databaseAuthVariableOverride");
            try {
                (0, $eTAKc.stringify)(authOverride);
            } catch (e) {
                throw new Error("Invalid authOverride provided: " + e);
            }
        }
        repo.persistentConnection_ = new $9d8fdf02b8ce4d4a$var$PersistentConnection(repo.repoInfo_, appId, function(pathString, data, isMerge, tag) {
            $9d8fdf02b8ce4d4a$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, function(connectStatus) {
            $9d8fdf02b8ce4d4a$var$repoOnConnectStatus(repo, connectStatus);
        }, function(updates) {
            $9d8fdf02b8ce4d4a$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener(function(token) {
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener(function(result) {
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $9d8fdf02b8ce4d4a$var$statsManagerGetOrCreateReporter(repo.repoInfo_, function() {
        return new $9d8fdf02b8ce4d4a$var$StatsReporter(repo.stats_, repo.server_);
    });
    // Used for .info.
    repo.infoData_ = new $9d8fdf02b8ce4d4a$var$SnapshotHolder();
    repo.infoSyncTree_ = new $9d8fdf02b8ce4d4a$var$SyncTree({
        startListening: function(query, tag, currentHashFn, onComplete) {
            var infoEvents = [];
            var node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $9d8fdf02b8ce4d4a$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(function() {
                    onComplete("ok");
                }, 0);
            }
            return infoEvents;
        },
        stopListening: function() {}
    });
    $9d8fdf02b8ce4d4a$var$repoUpdateInfo(repo, "connected", false);
    repo.serverSyncTree_ = new $9d8fdf02b8ce4d4a$var$SyncTree({
        startListening: function(query, tag, currentHashFn, onComplete) {
            repo.server_.listen(query, currentHashFn, tag, function(status, data) {
                var events = onComplete(status, data);
                $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: function(query, tag) {
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $9d8fdf02b8ce4d4a$var$repoServerTime(repo) {
    var offsetNode = repo.infoData_.getNode(new $9d8fdf02b8ce4d4a$var$Path(".info/serverTimeOffset"));
    var offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $9d8fdf02b8ce4d4a$var$repoGenerateServerValues(repo) {
    return $9d8fdf02b8ce4d4a$var$generateWithValues({
        timestamp: $9d8fdf02b8ce4d4a$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $9d8fdf02b8ce4d4a$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    var path = new $9d8fdf02b8ce4d4a$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    var events = [];
    if (tag) {
        if (isMerge) {
            var taggedChildren = (0, $eTAKc.map)(data, function(raw) {
                return $9d8fdf02b8ce4d4a$var$nodeFromJSON(raw);
            });
            events = $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            var taggedSnap = $9d8fdf02b8ce4d4a$var$nodeFromJSON(data);
            events = $9d8fdf02b8ce4d4a$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        var changedChildren = (0, $eTAKc.map)(data, function(raw) {
            return $9d8fdf02b8ce4d4a$var$nodeFromJSON(raw);
        });
        events = $9d8fdf02b8ce4d4a$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        var snap = $9d8fdf02b8ce4d4a$var$nodeFromJSON(data);
        events = $9d8fdf02b8ce4d4a$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    var affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $9d8fdf02b8ce4d4a$var$repoRerunTransactions(repo, path);
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
// TODO: This should be @private but it's used by test_access.js and internal.js
function $9d8fdf02b8ce4d4a$var$repoInterceptServerData(repo, callback) {
    repo.interceptServerDataCallback_ = callback;
}
function $9d8fdf02b8ce4d4a$var$repoOnConnectStatus(repo, connectStatus) {
    $9d8fdf02b8ce4d4a$var$repoUpdateInfo(repo, "connected", connectStatus);
    if (connectStatus === false) $9d8fdf02b8ce4d4a$var$repoRunOnDisconnectEvents(repo);
}
function $9d8fdf02b8ce4d4a$var$repoOnServerInfoUpdate(repo, updates) {
    $9d8fdf02b8ce4d4a$var$each(updates, function(key, value) {
        $9d8fdf02b8ce4d4a$var$repoUpdateInfo(repo, key, value);
    });
}
function $9d8fdf02b8ce4d4a$var$repoUpdateInfo(repo, pathString, value) {
    var path = new $9d8fdf02b8ce4d4a$var$Path("/.info/" + pathString);
    var newNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    var events = $9d8fdf02b8ce4d4a$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $9d8fdf02b8ce4d4a$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will try to
 * establish a connection and request the value for `query`. If
 * the client is not able to retrieve the query result, it reports
 * an error.
 *
 * @param query - The query to surface a value for.
 */ function $9d8fdf02b8ce4d4a$var$repoGetValue(repo, query) {
    // Only active queries are cached. There is no persisted cache.
    var cached = $9d8fdf02b8ce4d4a$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then(function(payload) {
        var node = $9d8fdf02b8ce4d4a$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        var events = $9d8fdf02b8ce4d4a$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
        return Promise.resolve(node);
    }, function(err) {
        $9d8fdf02b8ce4d4a$var$repoLog(repo, "get for query " + (0, $eTAKc.stringify)(query) + " failed: " + err);
        return Promise.reject(new Error(err));
    });
}
function $9d8fdf02b8ce4d4a$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $9d8fdf02b8ce4d4a$var$repoLog(repo, "set", {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    var serverValues = $9d8fdf02b8ce4d4a$var$repoGenerateServerValues(repo);
    var newNodeUnresolved = $9d8fdf02b8ce4d4a$var$nodeFromJSON(newVal, newPriority);
    var existing = $9d8fdf02b8ce4d4a$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    var newNode = $9d8fdf02b8ce4d4a$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    var writeId = $9d8fdf02b8ce4d4a$var$repoGetNextWriteId(repo);
    var events = $9d8fdf02b8ce4d4a$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $9d8fdf02b8ce4d4a$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function(status, errorReason) {
        var success = status === "ok";
        if (!success) $9d8fdf02b8ce4d4a$var$warn("set at " + path + " failed: " + status);
        var clearEvents = $9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    var affectedPath = $9d8fdf02b8ce4d4a$var$repoAbortTransactions(repo, path);
    $9d8fdf02b8ce4d4a$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $9d8fdf02b8ce4d4a$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $9d8fdf02b8ce4d4a$var$repoLog(repo, "update", {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    var empty = true;
    var serverValues = $9d8fdf02b8ce4d4a$var$repoGenerateServerValues(repo);
    var changedChildren = {};
    $9d8fdf02b8ce4d4a$var$each(childrenToMerge, function(changedKey, changedValue) {
        empty = false;
        changedChildren[changedKey] = $9d8fdf02b8ce4d4a$var$resolveDeferredValueTree($9d8fdf02b8ce4d4a$var$pathChild(path, changedKey), $9d8fdf02b8ce4d4a$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        var writeId_1 = $9d8fdf02b8ce4d4a$var$repoGetNextWriteId(repo);
        var events = $9d8fdf02b8ce4d4a$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId_1);
        $9d8fdf02b8ce4d4a$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, function(status, errorReason) {
            var success = status === "ok";
            if (!success) $9d8fdf02b8ce4d4a$var$warn("update at " + path + " failed: " + status);
            var clearEvents = $9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId_1, !success);
            var affectedPath = clearEvents.length > 0 ? $9d8fdf02b8ce4d4a$var$repoRerunTransactions(repo, path) : path;
            $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $9d8fdf02b8ce4d4a$var$each(childrenToMerge, function(changedPath) {
            var affectedPath = $9d8fdf02b8ce4d4a$var$repoAbortTransactions(repo, $9d8fdf02b8ce4d4a$var$pathChild(path, changedPath));
            $9d8fdf02b8ce4d4a$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $9d8fdf02b8ce4d4a$var$log("update() called with empty data.  Don't do anything.");
        $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $9d8fdf02b8ce4d4a$var$repoRunOnDisconnectEvents(repo) {
    $9d8fdf02b8ce4d4a$var$repoLog(repo, "onDisconnectEvents");
    var serverValues = $9d8fdf02b8ce4d4a$var$repoGenerateServerValues(repo);
    var resolvedOnDisconnectTree = $9d8fdf02b8ce4d4a$var$newSparseSnapshotTree();
    $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $9d8fdf02b8ce4d4a$var$newEmptyPath(), function(path, node) {
        var resolved = $9d8fdf02b8ce4d4a$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    var events = [];
    $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $9d8fdf02b8ce4d4a$var$newEmptyPath(), function(path, snap) {
        events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        var affectedPath = $9d8fdf02b8ce4d4a$var$repoAbortTransactions(repo, path);
        $9d8fdf02b8ce4d4a$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $9d8fdf02b8ce4d4a$var$newSparseSnapshotTree();
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $9d8fdf02b8ce4d4a$var$newEmptyPath(), events);
}
function $9d8fdf02b8ce4d4a$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), function(status, errorReason) {
        if (status === "ok") $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9d8fdf02b8ce4d4a$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    var newNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function(status, errorReason) {
        if (status === "ok") $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9d8fdf02b8ce4d4a$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    var newNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function(status, errorReason) {
        if (status === "ok") $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9d8fdf02b8ce4d4a$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $eTAKc.isEmpty)(childrenToMerge)) {
        $9d8fdf02b8ce4d4a$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, function(status, errorReason) {
        if (status === "ok") $9d8fdf02b8ce4d4a$var$each(childrenToMerge, function(childName, childNode) {
            var newChildNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(childNode);
            $9d8fdf02b8ce4d4a$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $9d8fdf02b8ce4d4a$var$pathChild(path, childName), newChildNode);
        });
        $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $9d8fdf02b8ce4d4a$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    var events;
    if ($9d8fdf02b8ce4d4a$var$pathGetFront(query._path) === ".info") events = $9d8fdf02b8ce4d4a$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $9d8fdf02b8ce4d4a$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $9d8fdf02b8ce4d4a$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    var events;
    if ($9d8fdf02b8ce4d4a$var$pathGetFront(query._path) === ".info") events = $9d8fdf02b8ce4d4a$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $9d8fdf02b8ce4d4a$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $9d8fdf02b8ce4d4a$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($9d8fdf02b8ce4d4a$var$INTERRUPT_REASON);
}
function $9d8fdf02b8ce4d4a$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($9d8fdf02b8ce4d4a$var$INTERRUPT_REASON);
}
function $9d8fdf02b8ce4d4a$var$repoStats(repo, showDelta) {
    if (showDelta === void 0) showDelta = false;
    if (typeof console === "undefined") return;
    var stats;
    if (showDelta) {
        if (!repo.statsListener_) repo.statsListener_ = new $9d8fdf02b8ce4d4a$var$StatsListener(repo.stats_);
        stats = repo.statsListener_.get();
    } else stats = repo.stats_.get();
    var longestName = Object.keys(stats).reduce(function(previousValue, currentValue) {
        return Math.max(currentValue.length, previousValue);
    }, 0);
    $9d8fdf02b8ce4d4a$var$each(stats, function(stat, value) {
        var paddedStat = stat;
        // pad stat names to be the same length (plus 2 extra spaces).
        for(var i = stat.length; i < longestName + 2; i++)paddedStat += " ";
        console.log(paddedStat + value);
    });
}
function $9d8fdf02b8ce4d4a$var$repoStatsIncrementCounter(repo, metric) {
    repo.stats_.incrementCounter(metric);
    $9d8fdf02b8ce4d4a$var$statsReporterIncludeStat(repo.statsReporter_, metric);
}
function $9d8fdf02b8ce4d4a$var$repoLog(repo) {
    var varArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)varArgs[_i - 1] = arguments[_i];
    var prefix = "";
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ":";
    $9d8fdf02b8ce4d4a$var$log.apply(void 0, (0, $2WUgS.__spreadArray)([
        prefix
    ], (0, $2WUgS.__read)(varArgs)));
}
function $9d8fdf02b8ce4d4a$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $9d8fdf02b8ce4d4a$var$exceptionGuard(function() {
        if (status === "ok") callback(null);
        else {
            var code = (status || "error").toUpperCase();
            var message = code;
            if (errorReason) message += ": " + errorReason;
            var error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $9d8fdf02b8ce4d4a$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $9d8fdf02b8ce4d4a$var$repoLog(repo, "transaction on " + path);
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $9d8fdf02b8ce4d4a$var$LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = $9d8fdf02b8ce4d4a$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $9d8fdf02b8ce4d4a$var$validateFirebaseData("transaction failed: Data returned ", newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* RUN */ ;
        var queueNode = $9d8fdf02b8ce4d4a$var$treeSubTree(repo.transactionQueueTree_, path);
        var nodeQueue = $9d8fdf02b8ce4d4a$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $9d8fdf02b8ce4d4a$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === "object" && newVal !== null && (0, $eTAKc.contains)(newVal, ".priority")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $eTAKc.safeGet)(newVal, ".priority");
            (0, $eTAKc.assert)($9d8fdf02b8ce4d4a$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            var currentNode = $9d8fdf02b8ce4d4a$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        var serverValues = $9d8fdf02b8ce4d4a$var$repoGenerateServerValues(repo);
        var newNodeUnresolved = $9d8fdf02b8ce4d4a$var$nodeFromJSON(newVal, priorityForNode);
        var newNode = $9d8fdf02b8ce4d4a$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $9d8fdf02b8ce4d4a$var$repoGetNextWriteId(repo);
        var events = $9d8fdf02b8ce4d4a$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $9d8fdf02b8ce4d4a$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $9d8fdf02b8ce4d4a$var$repoGetLatestState(repo, path, excludeSets) {
    return $9d8fdf02b8ce4d4a$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $9d8fdf02b8ce4d4a$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $9d8fdf02b8ce4d4a$var$repoSendReadyTransactions(repo, node) {
    if (node === void 0) node = repo.transactionQueueTree_;
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $9d8fdf02b8ce4d4a$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($9d8fdf02b8ce4d4a$var$treeGetValue(node)) {
        var queue = $9d8fdf02b8ce4d4a$var$repoBuildTransactionQueue(repo, node);
        (0, $eTAKc.assert)(queue.length > 0, "Sending zero length transaction queue");
        var allRun = queue.every(function(transaction) {
            return transaction.status === 0 /* RUN */ ;
        });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $9d8fdf02b8ce4d4a$var$repoSendTransactionQueue(repo, $9d8fdf02b8ce4d4a$var$treeGetPath(node), queue);
    } else if ($9d8fdf02b8ce4d4a$var$treeHasChildren(node)) $9d8fdf02b8ce4d4a$var$treeForEachChild(node, function(childNode) {
        $9d8fdf02b8ce4d4a$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $9d8fdf02b8ce4d4a$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function(txn) {
        return txn.currentWriteId;
    });
    var latestState = $9d8fdf02b8ce4d4a$var$repoGetLatestState(repo, path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for(var i = 0; i < queue.length; i++){
        var txn = queue[i];
        (0, $eTAKc.assert)(txn.status === 0 /* RUN */ , "tryToSendTransactionQueue_: items in queue should all be run.");
        txn.status = 1 /* SENT */ ;
        txn.retryCount++;
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, function(status) {
        $9d8fdf02b8ce4d4a$var$repoLog(repo, "transaction put response", {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === "ok") {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            var callbacks = [];
            var _loop_1 = function(i) {
                queue[i].status = 2 /* COMPLETED */ ;
                events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(function() {
                    return queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved);
                });
                queue[i].unwatcher();
            };
            for(var i = 0; i < queue.length; i++)_loop_1(i);
            // Now remove the completed transactions.
            $9d8fdf02b8ce4d4a$var$repoPruneCompletedTransactionsBelowNode(repo, $9d8fdf02b8ce4d4a$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $9d8fdf02b8ce4d4a$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(var i = 0; i < callbacks.length; i++)$9d8fdf02b8ce4d4a$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === "datastale") {
                for(var i = 0; i < queue.length; i++)if (queue[i].status === 3 /* SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* NEEDS_ABORT */ ;
                else queue[i].status = 0 /* RUN */ ;
            } else {
                $9d8fdf02b8ce4d4a$var$warn("transaction at " + pathToSend.toString() + " failed: " + status);
                for(var i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $9d8fdf02b8ce4d4a$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $9d8fdf02b8ce4d4a$var$repoRerunTransactions(repo, changedPath) {
    var rootMostTransactionNode = $9d8fdf02b8ce4d4a$var$repoGetAncestorTransactionNode(repo, changedPath);
    var path = $9d8fdf02b8ce4d4a$var$treeGetPath(rootMostTransactionNode);
    var queue = $9d8fdf02b8ce4d4a$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $9d8fdf02b8ce4d4a$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $9d8fdf02b8ce4d4a$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function(q) {
        return q.status === 0 /* RUN */ ;
    });
    var setsToIgnore = txnsToRerun.map(function(q) {
        return q.currentWriteId;
    });
    var _loop_2 = function(i) {
        var transaction = queue[i];
        var relativePath = $9d8fdf02b8ce4d4a$var$newRelativePath(path, transaction.path);
        var abortTransaction = false, abortReason;
        (0, $eTAKc.assert)(relativePath !== null, "rerunTransactionsUnderNode_: relativePath should not be null.");
        if (transaction.status === 4 /* NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* RUN */ ) {
            if (transaction.retryCount >= $9d8fdf02b8ce4d4a$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = "maxretry";
                events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                var currentNode = $9d8fdf02b8ce4d4a$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $9d8fdf02b8ce4d4a$var$validateFirebaseData("transaction failed: Data returned ", newData, transaction.path);
                    var newDataNode = $9d8fdf02b8ce4d4a$var$nodeFromJSON(newData);
                    var hasExplicitPriority = typeof newData === "object" && newData != null && (0, $eTAKc.contains)(newData, ".priority");
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = $9d8fdf02b8ce4d4a$var$repoGenerateServerValues(repo);
                    var newNodeResolved = $9d8fdf02b8ce4d4a$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $9d8fdf02b8ce4d4a$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = "nodata";
                    events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === "nodata") callbacks.push(function() {
                    return queue[i].onComplete(null, false, queue[i].currentInputSnapshot);
                });
                else callbacks.push(function() {
                    return queue[i].onComplete(new Error(abortReason), false, null);
                });
            }
        }
    };
    for(var i = 0; i < queue.length; i++)_loop_2(i);
    // Clean up completed transactions.
    $9d8fdf02b8ce4d4a$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(var i = 0; i < callbacks.length; i++)$9d8fdf02b8ce4d4a$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $9d8fdf02b8ce4d4a$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $9d8fdf02b8ce4d4a$var$repoGetAncestorTransactionNode(repo, path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    var transactionNode = repo.transactionQueueTree_;
    front = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
    while(front !== null && $9d8fdf02b8ce4d4a$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $9d8fdf02b8ce4d4a$var$treeSubTree(transactionNode, front);
        path = $9d8fdf02b8ce4d4a$var$pathPopFront(path);
        front = $9d8fdf02b8ce4d4a$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $9d8fdf02b8ce4d4a$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    $9d8fdf02b8ce4d4a$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function(a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
}
function $9d8fdf02b8ce4d4a$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    var nodeQueue = $9d8fdf02b8ce4d4a$var$treeGetValue(node);
    if (nodeQueue) for(var i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $9d8fdf02b8ce4d4a$var$treeForEachChild(node, function(child) {
        $9d8fdf02b8ce4d4a$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $9d8fdf02b8ce4d4a$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    var queue = $9d8fdf02b8ce4d4a$var$treeGetValue(node);
    if (queue) {
        var to = 0;
        for(var from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $9d8fdf02b8ce4d4a$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $9d8fdf02b8ce4d4a$var$treeForEachChild(node, function(childNode) {
        $9d8fdf02b8ce4d4a$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $9d8fdf02b8ce4d4a$var$repoAbortTransactions(repo, path) {
    var affectedPath = $9d8fdf02b8ce4d4a$var$treeGetPath($9d8fdf02b8ce4d4a$var$repoGetAncestorTransactionNode(repo, path));
    var transactionNode = $9d8fdf02b8ce4d4a$var$treeSubTree(repo.transactionQueueTree_, path);
    $9d8fdf02b8ce4d4a$var$treeForEachAncestor(transactionNode, function(node) {
        $9d8fdf02b8ce4d4a$var$repoAbortTransactionsOnNode(repo, node);
    });
    $9d8fdf02b8ce4d4a$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $9d8fdf02b8ce4d4a$var$treeForEachDescendant(transactionNode, function(node) {
        $9d8fdf02b8ce4d4a$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $9d8fdf02b8ce4d4a$var$repoAbortTransactionsOnNode(repo, node) {
    var queue = $9d8fdf02b8ce4d4a$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for(var i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* SENT */ ) {
                (0, $eTAKc.assert)(lastSent === i - 1, "All SENT items should be at beginning of queue.");
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = "set";
            } else {
                (0, $eTAKc.assert)(queue[i].status === 0 /* RUN */ , "Unexpected transaction status in abort");
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($9d8fdf02b8ce4d4a$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error("set"), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $9d8fdf02b8ce4d4a$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $9d8fdf02b8ce4d4a$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $9d8fdf02b8ce4d4a$var$treeGetPath(node), events);
        for(var i = 0; i < callbacks.length; i++)$9d8fdf02b8ce4d4a$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9d8fdf02b8ce4d4a$var$decodePath(pathString) {
    var pathStringDecoded = "";
    var pieces = pathString.split("/");
    for(var i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        var piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, " "));
        } catch (e) {}
        pathStringDecoded += "/" + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $9d8fdf02b8ce4d4a$var$decodeQuery(queryString) {
    var e_1, _a;
    var results = {};
    if (queryString.charAt(0) === "?") queryString = queryString.substring(1);
    try {
        for(var _b = (0, $2WUgS.__values)(queryString.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var segment = _c.value;
            if (segment.length === 0) continue;
            var kv = segment.split("=");
            if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
            else $9d8fdf02b8ce4d4a$var$warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return results;
}
var $9d8fdf02b8ce4d4a$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    var parsedUrl = $9d8fdf02b8ce4d4a$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === "firebase.com") $9d8fdf02b8ce4d4a$var$fatal(parsedUrl.host + " is no longer supported. " + "Please use <YOUR FIREBASE>.firebaseio.com instead");
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === "undefined") && parsedUrl.domain !== "localhost") $9d8fdf02b8ce4d4a$var$fatal("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");
    if (!parsedUrl.secure) $9d8fdf02b8ce4d4a$var$warnIfPageIsSecure();
    var webSocketOnly = parsedUrl.scheme === "ws" || parsedUrl.scheme === "wss";
    return {
        repoInfo: new $9d8fdf02b8ce4d4a$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, nodeAdmin, webSocketOnly, /*persistenceKey=*/ "", /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $9d8fdf02b8ce4d4a$var$Path(parsedUrl.pathString)
    };
};
var $9d8fdf02b8ce4d4a$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = "", domain = "", subdomain = "", pathString = "", namespace = "";
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = "https", port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === "string") {
        // Parse scheme.
        var colonInd = dataURL.indexOf("//");
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf("/");
        if (slashInd === -1) slashInd = dataURL.length;
        var questionMarkInd = dataURL.indexOf("?");
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $9d8fdf02b8ce4d4a$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        var queryParams = $9d8fdf02b8ce4d4a$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(":");
        if (colonInd >= 0) {
            secure = scheme === "https" || scheme === "wss";
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        var hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === "localhost") domain = "localhost";
        else if (hostWithoutPort.split(".").length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            var dotInd = host.indexOf(".");
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ("ns" in queryParams) namespace = queryParams["ns"];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ var $9d8fdf02b8ce4d4a$var$DataEvent = /** @class */ function() {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    DataEvent.prototype.getPath = function() {
        var ref = this.snapshot.ref;
        if (this.eventType === "value") return ref._path;
        else return ref.parent._path;
    };
    DataEvent.prototype.getEventType = function() {
        return this.eventType;
    };
    DataEvent.prototype.getEventRunner = function() {
        return this.eventRegistration.getEventRunner(this);
    };
    DataEvent.prototype.toString = function() {
        return this.getPath().toString() + ":" + this.eventType + ":" + (0, $eTAKc.stringify)(this.snapshot.exportVal());
    };
    return DataEvent;
}();
var $9d8fdf02b8ce4d4a$var$CancelEvent = /** @class */ function() {
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    CancelEvent.prototype.getPath = function() {
        return this.path;
    };
    CancelEvent.prototype.getEventType = function() {
        return "cancel";
    };
    CancelEvent.prototype.getEventRunner = function() {
        return this.eventRegistration.getEventRunner(this);
    };
    CancelEvent.prototype.toString = function() {
        return this.path.toString() + ":cancel";
    };
    return CancelEvent;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ var $9d8fdf02b8ce4d4a$var$CallbackContext = /** @class */ function() {
    function CallbackContext(snapshotCallback, cancelCallback) {
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    CallbackContext.prototype.onValue = function(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    };
    CallbackContext.prototype.onCancel = function(error) {
        (0, $eTAKc.assert)(this.hasCancelCallback, "Raising a cancel event on a listener with no cancel callback");
        return this.cancelCallback.call(null, error);
    };
    Object.defineProperty(CallbackContext.prototype, "hasCancelCallback", {
        get: function() {
            return !!this.cancelCallback;
        },
        enumerable: false,
        configurable: true
    });
    CallbackContext.prototype.matches = function(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    };
    return CallbackContext;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ var $9d8fdf02b8ce4d4a$var$OnDisconnect$1 = /** @class */ function() {
    /** @hideconstructor */ function OnDisconnect(_repo, _path) {
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ OnDisconnect.prototype.cancel = function() {
        var deferred = new (0, $eTAKc.Deferred)();
        $9d8fdf02b8ce4d4a$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(function() {}));
        return deferred.promise;
    };
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ OnDisconnect.prototype.remove = function() {
        $9d8fdf02b8ce4d4a$var$validateWritablePath("OnDisconnect.remove", this._path);
        var deferred = new (0, $eTAKc.Deferred)();
        $9d8fdf02b8ce4d4a$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(function() {}));
        return deferred.promise;
    };
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ OnDisconnect.prototype.set = function(value) {
        $9d8fdf02b8ce4d4a$var$validateWritablePath("OnDisconnect.set", this._path);
        $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("OnDisconnect.set", value, this._path, false);
        var deferred = new (0, $eTAKc.Deferred)();
        $9d8fdf02b8ce4d4a$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(function() {}));
        return deferred.promise;
    };
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ OnDisconnect.prototype.setWithPriority = function(value, priority) {
        $9d8fdf02b8ce4d4a$var$validateWritablePath("OnDisconnect.setWithPriority", this._path);
        $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("OnDisconnect.setWithPriority", value, this._path, false);
        $9d8fdf02b8ce4d4a$var$validatePriority("OnDisconnect.setWithPriority", priority, false);
        var deferred = new (0, $eTAKc.Deferred)();
        $9d8fdf02b8ce4d4a$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(function() {}));
        return deferred.promise;
    };
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ OnDisconnect.prototype.update = function(values) {
        $9d8fdf02b8ce4d4a$var$validateWritablePath("OnDisconnect.update", this._path);
        $9d8fdf02b8ce4d4a$var$validateFirebaseMergeDataArg("OnDisconnect.update", values, this._path, false);
        var deferred = new (0, $eTAKc.Deferred)();
        $9d8fdf02b8ce4d4a$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(function() {}));
        return deferred.promise;
    };
    return OnDisconnect;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var $9d8fdf02b8ce4d4a$var$QueryImpl = /** @class */ function() {
    /**
     * @hideconstructor
     */ function QueryImpl(_repo, _path, _queryParams, _orderByCalled) {
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    Object.defineProperty(QueryImpl.prototype, "key", {
        get: function() {
            if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(this._path)) return null;
            else return $9d8fdf02b8ce4d4a$var$pathGetBack(this._path);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryImpl.prototype, "ref", {
        get: function() {
            return new $9d8fdf02b8ce4d4a$var$ReferenceImpl(this._repo, this._path);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryImpl.prototype, "_queryIdentifier", {
        get: function() {
            var obj = $9d8fdf02b8ce4d4a$var$queryParamsGetQueryObject(this._queryParams);
            var id = $9d8fdf02b8ce4d4a$var$ObjectToUniqueKey(obj);
            return id === "{}" ? "default" : id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryImpl.prototype, "_queryObject", {
        /**
         * An object representation of the query parameters used by this Query.
         */ get: function() {
            return $9d8fdf02b8ce4d4a$var$queryParamsGetQueryObject(this._queryParams);
        },
        enumerable: false,
        configurable: true
    });
    QueryImpl.prototype.isEqual = function(other) {
        other = (0, $eTAKc.getModularInstance)(other);
        if (!(other instanceof QueryImpl)) return false;
        var sameRepo = this._repo === other._repo;
        var samePath = $9d8fdf02b8ce4d4a$var$pathEquals(this._path, other._path);
        var sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    };
    QueryImpl.prototype.toJSON = function() {
        return this.toString();
    };
    QueryImpl.prototype.toString = function() {
        return this._repo.toString() + $9d8fdf02b8ce4d4a$var$pathToUrlEncodedString(this._path);
    };
    return QueryImpl;
}();
/**
 * Validates that no other order by call has been made
 */ function $9d8fdf02b8ce4d4a$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(params) {
    var startNode = null;
    var endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $9d8fdf02b8ce4d4a$var$KEY_INDEX) {
        var tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        var wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            if (startName !== $9d8fdf02b8ce4d4a$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== "string") throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            if (endName !== $9d8fdf02b8ce4d4a$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== "string") throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX) {
        if (startNode != null && !$9d8fdf02b8ce4d4a$var$isValidPriority(startNode) || endNode != null && !$9d8fdf02b8ce4d4a$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $eTAKc.assert)(params.getIndex() instanceof $9d8fdf02b8ce4d4a$var$PathIndex || params.getIndex() === $9d8fdf02b8ce4d4a$var$VALUE_INDEX, "unknown index type.");
        if (startNode != null && typeof startNode === "object" || endNode != null && typeof endNode === "object") throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $9d8fdf02b8ce4d4a$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ var $9d8fdf02b8ce4d4a$var$ReferenceImpl = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(ReferenceImpl, _super);
    /** @hideconstructor */ function ReferenceImpl(repo, path) {
        return _super.call(this, repo, path, new $9d8fdf02b8ce4d4a$var$QueryParams(), false) || this;
    }
    Object.defineProperty(ReferenceImpl.prototype, "parent", {
        get: function() {
            var parentPath = $9d8fdf02b8ce4d4a$var$pathParent(this._path);
            return parentPath === null ? null : new ReferenceImpl(this._repo, parentPath);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReferenceImpl.prototype, "root", {
        get: function() {
            var ref = this;
            while(ref.parent !== null)ref = ref.parent;
            return ref;
        },
        enumerable: false,
        configurable: true
    });
    return ReferenceImpl;
}($9d8fdf02b8ce4d4a$var$QueryImpl);
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ var $9d8fdf02b8ce4d4a$var$DataSnapshot$1 = /** @class */ function() {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ function DataSnapshot(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index) {
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    Object.defineProperty(DataSnapshot.prototype, "priority", {
        /**
         * Gets the priority value of the data in this `DataSnapshot`.
         *
         * Applications need not use priority but can order collections by
         * ordinary properties (see
         * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
         * ).
         */ get: function() {
            // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
            return this._node.getPriority().val();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataSnapshot.prototype, "key", {
        /**
         * The key (last part of the path) of the location of this `DataSnapshot`.
         *
         * The last token in a Database location is considered its key. For example,
         * "ada" is the key for the /users/ada/ node. Accessing the key on any
         * `DataSnapshot` will return the key for the location that generated it.
         * However, accessing the key on the root URL of a Database will return
         * `null`.
         */ get: function() {
            return this.ref.key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataSnapshot.prototype, "size", {
        /** Returns the number of child properties of this `DataSnapshot`. */ get: function() {
            return this._node.numChildren();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ DataSnapshot.prototype.child = function(path) {
        var childPath = new $9d8fdf02b8ce4d4a$var$Path(path);
        var childRef = $9d8fdf02b8ce4d4a$var$child(this.ref, path);
        return new DataSnapshot(this._node.getChild(childPath), childRef, $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX);
    };
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ DataSnapshot.prototype.exists = function() {
        return !this._node.isEmpty();
    };
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    DataSnapshot.prototype.exportVal = function() {
        return this._node.val(true);
    };
    /**
     * Enumerates the top-level children in the `DataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ DataSnapshot.prototype.forEach = function(action) {
        var _this = this;
        if (this._node.isLeafNode()) return false;
        var childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, function(key, node) {
            return action(new DataSnapshot(node, $9d8fdf02b8ce4d4a$var$child(_this.ref, key), $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX));
        });
    };
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ DataSnapshot.prototype.hasChild = function(path) {
        var childPath = new $9d8fdf02b8ce4d4a$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    };
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ DataSnapshot.prototype.hasChildren = function() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    };
    /**
     * Returns a JSON-serializable representation of this object.
     */ DataSnapshot.prototype.toJSON = function() {
        return this.exportVal();
    };
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    DataSnapshot.prototype.val = function() {
        return this._node.val();
    };
    return DataSnapshot;
}();
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $9d8fdf02b8ce4d4a$var$ref(db, path) {
    db = (0, $eTAKc.getModularInstance)(db);
    db._checkNotDeleted("ref");
    return path !== undefined ? $9d8fdf02b8ce4d4a$var$child(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $9d8fdf02b8ce4d4a$var$refFromURL(db, url) {
    db = (0, $eTAKc.getModularInstance)(db);
    db._checkNotDeleted("refFromURL");
    var parsedURL = $9d8fdf02b8ce4d4a$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $9d8fdf02b8ce4d4a$var$validateUrl("refFromURL", parsedURL);
    var repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $9d8fdf02b8ce4d4a$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + " but expected " + db._repo.repoInfo_.host + ")");
    return $9d8fdf02b8ce4d4a$var$ref(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $9d8fdf02b8ce4d4a$var$child(parent, path) {
    parent = (0, $eTAKc.getModularInstance)(parent);
    if ($9d8fdf02b8ce4d4a$var$pathGetFront(parent._path) === null) $9d8fdf02b8ce4d4a$var$validateRootPathString("child", "path", path, false);
    else $9d8fdf02b8ce4d4a$var$validatePathString("child", "path", path, false);
    return new $9d8fdf02b8ce4d4a$var$ReferenceImpl(parent._repo, $9d8fdf02b8ce4d4a$var$pathChild(parent._path, path));
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}
 * </br>See {@link ttps://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $9d8fdf02b8ce4d4a$var$push(parent, value) {
    parent = (0, $eTAKc.getModularInstance)(parent);
    $9d8fdf02b8ce4d4a$var$validateWritablePath("push", parent._path);
    $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("push", value, parent._path, true);
    var now = $9d8fdf02b8ce4d4a$var$repoServerTime(parent._repo);
    var name = $9d8fdf02b8ce4d4a$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    var thennablePushRef = $9d8fdf02b8ce4d4a$var$child(parent, name);
    var pushRef = $9d8fdf02b8ce4d4a$var$child(parent, name);
    var promise;
    if (value != null) promise = $9d8fdf02b8ce4d4a$var$set(pushRef, value).then(function() {
        return pushRef;
    });
    else promise = Promise.resolve(pushRef);
    thennablePushRef.then = promise.then.bind(promise);
    thennablePushRef.catch = promise.then.bind(promise, undefined);
    return thennablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $9d8fdf02b8ce4d4a$var$remove(ref) {
    $9d8fdf02b8ce4d4a$var$validateWritablePath("remove", ref._path);
    return $9d8fdf02b8ce4d4a$var$set(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $9d8fdf02b8ce4d4a$var$set(ref, value) {
    ref = (0, $eTAKc.getModularInstance)(ref);
    $9d8fdf02b8ce4d4a$var$validateWritablePath("set", ref._path);
    $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("set", value, ref._path, false);
    var deferred = new (0, $eTAKc.Deferred)();
    $9d8fdf02b8ce4d4a$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(function() {}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $9d8fdf02b8ce4d4a$var$setPriority(ref, priority) {
    ref = (0, $eTAKc.getModularInstance)(ref);
    $9d8fdf02b8ce4d4a$var$validateWritablePath("setPriority", ref._path);
    $9d8fdf02b8ce4d4a$var$validatePriority("setPriority", priority, false);
    var deferred = new (0, $eTAKc.Deferred)();
    $9d8fdf02b8ce4d4a$var$repoSetWithPriority(ref._repo, $9d8fdf02b8ce4d4a$var$pathChild(ref._path, ".priority"), priority, null, deferred.wrapCallback(function() {}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $9d8fdf02b8ce4d4a$var$setWithPriority(ref, value, priority) {
    $9d8fdf02b8ce4d4a$var$validateWritablePath("setWithPriority", ref._path);
    $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("setWithPriority", value, ref._path, false);
    $9d8fdf02b8ce4d4a$var$validatePriority("setWithPriority", priority, false);
    if (ref.key === ".length" || ref.key === ".keys") throw "setWithPriority failed: " + ref.key + " is a read-only object.";
    var deferred = new (0, $eTAKc.Deferred)();
    $9d8fdf02b8ce4d4a$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(function() {}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $9d8fdf02b8ce4d4a$var$update(ref, values) {
    $9d8fdf02b8ce4d4a$var$validateFirebaseMergeDataArg("update", values, ref._path, false);
    var deferred = new (0, $eTAKc.Deferred)();
    $9d8fdf02b8ce4d4a$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(function() {}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A promise which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $9d8fdf02b8ce4d4a$var$get(query) {
    query = (0, $eTAKc.getModularInstance)(query);
    return $9d8fdf02b8ce4d4a$var$repoGetValue(query._repo, query).then(function(node) {
        return new $9d8fdf02b8ce4d4a$var$DataSnapshot$1(node, new $9d8fdf02b8ce4d4a$var$ReferenceImpl(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ var $9d8fdf02b8ce4d4a$var$ValueEventRegistration = /** @class */ function() {
    function ValueEventRegistration(callbackContext) {
        this.callbackContext = callbackContext;
    }
    ValueEventRegistration.prototype.respondsTo = function(eventType) {
        return eventType === "value";
    };
    ValueEventRegistration.prototype.createEvent = function(change, query) {
        var index = query._queryParams.getIndex();
        return new $9d8fdf02b8ce4d4a$var$DataEvent("value", this, new $9d8fdf02b8ce4d4a$var$DataSnapshot$1(change.snapshotNode, new $9d8fdf02b8ce4d4a$var$ReferenceImpl(query._repo, query._path), index));
    };
    ValueEventRegistration.prototype.getEventRunner = function(eventData) {
        var _this = this;
        if (eventData.getEventType() === "cancel") return function() {
            return _this.callbackContext.onCancel(eventData.error);
        };
        else return function() {
            return _this.callbackContext.onValue(eventData.snapshot, null);
        };
    };
    ValueEventRegistration.prototype.createCancelEvent = function(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $9d8fdf02b8ce4d4a$var$CancelEvent(this, error, path);
        else return null;
    };
    ValueEventRegistration.prototype.matches = function(other) {
        if (!(other instanceof ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    };
    ValueEventRegistration.prototype.hasAnyCallback = function() {
        return this.callbackContext !== null;
    };
    return ValueEventRegistration;
}();
/**
 * Represents the registration of a child_x event.
 */ var $9d8fdf02b8ce4d4a$var$ChildEventRegistration = /** @class */ function() {
    function ChildEventRegistration(eventType, callbackContext) {
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    ChildEventRegistration.prototype.respondsTo = function(eventType) {
        var eventToCheck = eventType === "children_added" ? "child_added" : eventType;
        eventToCheck = eventToCheck === "children_removed" ? "child_removed" : eventToCheck;
        return this.eventType === eventToCheck;
    };
    ChildEventRegistration.prototype.createCancelEvent = function(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $9d8fdf02b8ce4d4a$var$CancelEvent(this, error, path);
        else return null;
    };
    ChildEventRegistration.prototype.createEvent = function(change, query) {
        (0, $eTAKc.assert)(change.childName != null, "Child events should have a childName.");
        var childRef = $9d8fdf02b8ce4d4a$var$child(new $9d8fdf02b8ce4d4a$var$ReferenceImpl(query._repo, query._path), change.childName);
        var index = query._queryParams.getIndex();
        return new $9d8fdf02b8ce4d4a$var$DataEvent(change.type, this, new $9d8fdf02b8ce4d4a$var$DataSnapshot$1(change.snapshotNode, childRef, index), change.prevName);
    };
    ChildEventRegistration.prototype.getEventRunner = function(eventData) {
        var _this = this;
        if (eventData.getEventType() === "cancel") return function() {
            return _this.callbackContext.onCancel(eventData.error);
        };
        else return function() {
            return _this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
        };
    };
    ChildEventRegistration.prototype.matches = function(other) {
        if (other instanceof ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    };
    ChildEventRegistration.prototype.hasAnyCallback = function() {
        return !!this.callbackContext;
    };
    return ChildEventRegistration;
}();
function $9d8fdf02b8ce4d4a$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    var cancelCallback;
    if (typeof cancelCallbackOrListenOptions === "object") {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === "function") cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        var userCallback_1 = callback;
        var onceCallback = function(dataSnapshot, previousChildName) {
            $9d8fdf02b8ce4d4a$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback_1(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    var callbackContext = new $9d8fdf02b8ce4d4a$var$CallbackContext(callback, cancelCallback || undefined);
    var container = eventType === "value" ? new $9d8fdf02b8ce4d4a$var$ValueEventRegistration(callbackContext) : new $9d8fdf02b8ce4d4a$var$ChildEventRegistration(eventType, callbackContext);
    $9d8fdf02b8ce4d4a$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return function() {
        return $9d8fdf02b8ce4d4a$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
    };
}
function $9d8fdf02b8ce4d4a$var$onValue(query, callback, cancelCallbackOrListenOptions, options) {
    return $9d8fdf02b8ce4d4a$var$addEventListener(query, "value", callback, cancelCallbackOrListenOptions, options);
}
function $9d8fdf02b8ce4d4a$var$onChildAdded(query, callback, cancelCallbackOrListenOptions, options) {
    return $9d8fdf02b8ce4d4a$var$addEventListener(query, "child_added", callback, cancelCallbackOrListenOptions, options);
}
function $9d8fdf02b8ce4d4a$var$onChildChanged(query, callback, cancelCallbackOrListenOptions, options) {
    return $9d8fdf02b8ce4d4a$var$addEventListener(query, "child_changed", callback, cancelCallbackOrListenOptions, options);
}
function $9d8fdf02b8ce4d4a$var$onChildMoved(query, callback, cancelCallbackOrListenOptions, options) {
    return $9d8fdf02b8ce4d4a$var$addEventListener(query, "child_moved", callback, cancelCallbackOrListenOptions, options);
}
function $9d8fdf02b8ce4d4a$var$onChildRemoved(query, callback, cancelCallbackOrListenOptions, options) {
    return $9d8fdf02b8ce4d4a$var$addEventListener(query, "child_removed", callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with `on()`.
 *
 * Detach a callback previously attached with `on()`. Note that if `on()` was
 * called multiple times with the same eventType and callback, the callback
 * will be called multiple times for each event, and `off()` must be called
 * multiple times to remove the callback. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $9d8fdf02b8ce4d4a$var$off(query, eventType, callback) {
    var container = null;
    var expCallback = callback ? new $9d8fdf02b8ce4d4a$var$CallbackContext(callback) : null;
    if (eventType === "value") container = new $9d8fdf02b8ce4d4a$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $9d8fdf02b8ce4d4a$var$ChildEventRegistration(eventType, expCallback);
    $9d8fdf02b8ce4d4a$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ var $9d8fdf02b8ce4d4a$var$QueryConstraint = /** @class */ function() {
    function QueryConstraint() {}
    return QueryConstraint;
}();
var $9d8fdf02b8ce4d4a$var$QueryEndAtConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryEndAtConstraint, _super);
    function QueryEndAtConstraint(_value, _key) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this._key = _key;
        return _this;
    }
    QueryEndAtConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("endAt", this._value, query._path, true);
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $9d8fdf02b8ce4d4a$var$validateLimit(newParams);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, query._orderByCalled);
    };
    return QueryEndAtConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $9d8fdf02b8ce4d4a$var$endAt(value, key) {
    $9d8fdf02b8ce4d4a$var$validateKey("endAt", "key", key, true);
    return new $9d8fdf02b8ce4d4a$var$QueryEndAtConstraint(value, key);
}
var $9d8fdf02b8ce4d4a$var$QueryEndBeforeConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryEndBeforeConstraint, _super);
    function QueryEndBeforeConstraint(_value, _key) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this._key = _key;
        return _this;
    }
    QueryEndBeforeConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("endBefore", this._value, query._path, false);
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $9d8fdf02b8ce4d4a$var$validateLimit(newParams);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, query._orderByCalled);
    };
    return QueryEndBeforeConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value lesss than or equal
 * to the specified value and a a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $9d8fdf02b8ce4d4a$var$endBefore(value, key) {
    $9d8fdf02b8ce4d4a$var$validateKey("endBefore", "key", key, true);
    return new $9d8fdf02b8ce4d4a$var$QueryEndBeforeConstraint(value, key);
}
var $9d8fdf02b8ce4d4a$var$QueryStartAtConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryStartAtConstraint, _super);
    function QueryStartAtConstraint(_value, _key) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this._key = _key;
        return _this;
    }
    QueryStartAtConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("startAt", this._value, query._path, true);
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $9d8fdf02b8ce4d4a$var$validateLimit(newParams);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, query._orderByCalled);
    };
    return QueryStartAtConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $9d8fdf02b8ce4d4a$var$startAt(value, key) {
    if (value === void 0) value = null;
    $9d8fdf02b8ce4d4a$var$validateKey("startAt", "key", key, true);
    return new $9d8fdf02b8ce4d4a$var$QueryStartAtConstraint(value, key);
}
var $9d8fdf02b8ce4d4a$var$QueryStartAfterConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryStartAfterConstraint, _super);
    function QueryStartAfterConstraint(_value, _key) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this._key = _key;
        return _this;
    }
    QueryStartAfterConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("startAfter", this._value, query._path, false);
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $9d8fdf02b8ce4d4a$var$validateLimit(newParams);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, query._orderByCalled);
    };
    return QueryStartAfterConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $9d8fdf02b8ce4d4a$var$startAfter(value, key) {
    $9d8fdf02b8ce4d4a$var$validateKey("startAfter", "key", key, true);
    return new $9d8fdf02b8ce4d4a$var$QueryStartAfterConstraint(value, key);
}
var $9d8fdf02b8ce4d4a$var$QueryLimitToFirstConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryLimitToFirstConstraint, _super);
    function QueryLimitToFirstConstraint(_limit) {
        var _this = _super.call(this) || this;
        _this._limit = _limit;
        return _this;
    }
    QueryLimitToFirstConstraint.prototype._apply = function(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, $9d8fdf02b8ce4d4a$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    };
    return QueryLimitToFirstConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $9d8fdf02b8ce4d4a$var$limitToFirst(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToFirst: First argument must be a positive integer.");
    return new $9d8fdf02b8ce4d4a$var$QueryLimitToFirstConstraint(limit);
}
var $9d8fdf02b8ce4d4a$var$QueryLimitToLastConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryLimitToLastConstraint, _super);
    function QueryLimitToLastConstraint(_limit) {
        var _this = _super.call(this) || this;
        _this._limit = _limit;
        return _this;
    }
    QueryLimitToLastConstraint.prototype._apply = function(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, $9d8fdf02b8ce4d4a$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    };
    return QueryLimitToLastConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $9d8fdf02b8ce4d4a$var$limitToLast(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToLast: First argument must be a positive integer.");
    return new $9d8fdf02b8ce4d4a$var$QueryLimitToLastConstraint(limit);
}
var $9d8fdf02b8ce4d4a$var$QueryOrderByChildConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryOrderByChildConstraint, _super);
    function QueryOrderByChildConstraint(_path) {
        var _this = _super.call(this) || this;
        _this._path = _path;
        return _this;
    }
    QueryOrderByChildConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateNoPreviousOrderByCall(query, "orderByChild");
        var parsedPath = new $9d8fdf02b8ce4d4a$var$Path(this._path);
        if ($9d8fdf02b8ce4d4a$var$pathIsEmpty(parsedPath)) throw new Error("orderByChild: cannot pass in empty path. Use orderByValue() instead.");
        var index = new $9d8fdf02b8ce4d4a$var$PathIndex(parsedPath);
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsOrderBy(query._queryParams, index);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    };
    return QueryOrderByChildConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $9d8fdf02b8ce4d4a$var$orderByChild(path) {
    if (path === "$key") throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === "$priority") throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === "$value") throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $9d8fdf02b8ce4d4a$var$validatePathString("orderByChild", "path", path, false);
    return new $9d8fdf02b8ce4d4a$var$QueryOrderByChildConstraint(path);
}
var $9d8fdf02b8ce4d4a$var$QueryOrderByKeyConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryOrderByKeyConstraint, _super);
    function QueryOrderByKeyConstraint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryOrderByKeyConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateNoPreviousOrderByCall(query, "orderByKey");
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsOrderBy(query._queryParams, $9d8fdf02b8ce4d4a$var$KEY_INDEX);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    };
    return QueryOrderByKeyConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $9d8fdf02b8ce4d4a$var$orderByKey() {
    return new $9d8fdf02b8ce4d4a$var$QueryOrderByKeyConstraint();
}
var $9d8fdf02b8ce4d4a$var$QueryOrderByPriorityConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryOrderByPriorityConstraint, _super);
    function QueryOrderByPriorityConstraint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryOrderByPriorityConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateNoPreviousOrderByCall(query, "orderByPriority");
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsOrderBy(query._queryParams, $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    };
    return QueryOrderByPriorityConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $9d8fdf02b8ce4d4a$var$orderByPriority() {
    return new $9d8fdf02b8ce4d4a$var$QueryOrderByPriorityConstraint();
}
var $9d8fdf02b8ce4d4a$var$QueryOrderByValueConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryOrderByValueConstraint, _super);
    function QueryOrderByValueConstraint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryOrderByValueConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateNoPreviousOrderByCall(query, "orderByValue");
        var newParams = $9d8fdf02b8ce4d4a$var$queryParamsOrderBy(query._queryParams, $9d8fdf02b8ce4d4a$var$VALUE_INDEX);
        $9d8fdf02b8ce4d4a$var$validateQueryEndpoints(newParams);
        return new $9d8fdf02b8ce4d4a$var$QueryImpl(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    };
    return QueryOrderByValueConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $9d8fdf02b8ce4d4a$var$orderByValue() {
    return new $9d8fdf02b8ce4d4a$var$QueryOrderByValueConstraint();
}
var $9d8fdf02b8ce4d4a$var$QueryEqualToValueConstraint = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(QueryEqualToValueConstraint, _super);
    function QueryEqualToValueConstraint(_value, _key) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        _this._key = _key;
        return _this;
    }
    QueryEqualToValueConstraint.prototype._apply = function(query) {
        $9d8fdf02b8ce4d4a$var$validateFirebaseDataArg("equalTo", this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $9d8fdf02b8ce4d4a$var$QueryEndAtConstraint(this._value, this._key)._apply(new $9d8fdf02b8ce4d4a$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    };
    return QueryEqualToValueConstraint;
}($9d8fdf02b8ce4d4a$var$QueryConstraint);
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $9d8fdf02b8ce4d4a$var$equalTo(value, key) {
    $9d8fdf02b8ce4d4a$var$validateKey("equalTo", "key", key, true);
    return new $9d8fdf02b8ce4d4a$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $9d8fdf02b8ce4d4a$var$query(query) {
    var e_1, _a;
    var queryConstraints = [];
    for(var _i = 1; _i < arguments.length; _i++)queryConstraints[_i - 1] = arguments[_i];
    var queryImpl = (0, $eTAKc.getModularInstance)(query);
    try {
        for(var queryConstraints_1 = (0, $2WUgS.__values)(queryConstraints), queryConstraints_1_1 = queryConstraints_1.next(); !queryConstraints_1_1.done; queryConstraints_1_1 = queryConstraints_1.next()){
            var constraint = queryConstraints_1_1.value;
            queryImpl = constraint._apply(queryImpl);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (queryConstraints_1_1 && !queryConstraints_1_1.done && (_a = queryConstraints_1.return)) _a.call(queryConstraints_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $9d8fdf02b8ce4d4a$var$syncPointSetReferenceConstructor($9d8fdf02b8ce4d4a$var$ReferenceImpl);
$9d8fdf02b8ce4d4a$var$syncTreeSetReferenceConstructor($9d8fdf02b8ce4d4a$var$ReferenceImpl);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase node.js admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ var $9d8fdf02b8ce4d4a$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = "FIREBASE_DATABASE_EMULATOR_HOST";
/**
 * Creates and caches Repo instances.
 */ var $9d8fdf02b8ce4d4a$var$repos = {};
/**
 * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
 */ var $9d8fdf02b8ce4d4a$var$useRestClient = false;
/**
 * Update an existing repo in place to point to a new host/port.
 */ function $9d8fdf02b8ce4d4a$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $9d8fdf02b8ce4d4a$var$RepoInfo(host + ":" + port, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $9d8fdf02b8ce4d4a$var$repoManagerDatabaseFromApp(app, authProvider, appCheckProvider, url, nodeAdmin) {
    var dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $9d8fdf02b8ce4d4a$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $9d8fdf02b8ce4d4a$var$log("Using default host for project ", app.options.projectId);
        dbUrl = app.options.projectId + "-default-rtdb.firebaseio.com";
    }
    var parsedUrl = $9d8fdf02b8ce4d4a$var$parseRepoInfo(dbUrl, nodeAdmin);
    var repoInfo = parsedUrl.repoInfo;
    var isEmulator;
    var dbEmulatorHost = undefined;
    if (typeof $hvPjh !== "undefined") dbEmulatorHost = $hvPjh.env[$9d8fdf02b8ce4d4a$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
        parsedUrl = $9d8fdf02b8ce4d4a$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    var authTokenProvider = nodeAdmin && isEmulator ? new $9d8fdf02b8ce4d4a$var$EmulatorTokenProvider($9d8fdf02b8ce4d4a$var$EmulatorTokenProvider.OWNER) : new $9d8fdf02b8ce4d4a$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $9d8fdf02b8ce4d4a$var$validateUrl("Invalid Firebase Database URL", parsedUrl);
    if (!$9d8fdf02b8ce4d4a$var$pathIsEmpty(parsedUrl.path)) $9d8fdf02b8ce4d4a$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    var repo = $9d8fdf02b8ce4d4a$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $9d8fdf02b8ce4d4a$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $9d8fdf02b8ce4d4a$var$Database$1(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $9d8fdf02b8ce4d4a$var$repoManagerDeleteRepo(repo, appName) {
    var appRepos = $9d8fdf02b8ce4d4a$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $9d8fdf02b8ce4d4a$var$fatal("Database " + appName + "(" + repo.repoInfo_ + ") has already been deleted.");
    $9d8fdf02b8ce4d4a$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $9d8fdf02b8ce4d4a$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    var appRepos = $9d8fdf02b8ce4d4a$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $9d8fdf02b8ce4d4a$var$repos[app.name] = appRepos;
    }
    var repo = appRepos[repoInfo.toURLString()];
    if (repo) $9d8fdf02b8ce4d4a$var$fatal("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.");
    repo = new $9d8fdf02b8ce4d4a$var$Repo(repoInfo, $9d8fdf02b8ce4d4a$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $9d8fdf02b8ce4d4a$var$repoManagerForceRestClient(forceRestClient) {
    $9d8fdf02b8ce4d4a$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ var $9d8fdf02b8ce4d4a$var$Database$1 = /** @class */ function() {
    /** @hideconstructor */ function Database(_repoInternal, /** The FirebaseApp associated with this Realtime Database instance. */ app) {
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a database instance. */ this["type"] = "database";
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    Object.defineProperty(Database.prototype, "_repo", {
        get: function() {
            if (!this._instanceStarted) {
                $9d8fdf02b8ce4d4a$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options["databaseAuthVariableOverride"]);
                this._instanceStarted = true;
            }
            return this._repoInternal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Database.prototype, "_root", {
        get: function() {
            if (!this._rootInternal) this._rootInternal = new $9d8fdf02b8ce4d4a$var$ReferenceImpl(this._repo, $9d8fdf02b8ce4d4a$var$newEmptyPath());
            return this._rootInternal;
        },
        enumerable: false,
        configurable: true
    });
    Database.prototype._delete = function() {
        if (this._rootInternal !== null) {
            $9d8fdf02b8ce4d4a$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    };
    Database.prototype._checkNotDeleted = function(apiName) {
        if (this._rootInternal === null) $9d8fdf02b8ce4d4a$var$fatal("Cannot call " + apiName + " on a deleted database.");
    };
    return Database;
}();
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $9d8fdf02b8ce4d4a$var$connectDatabaseEmulator(db, host, port, options) {
    if (options === void 0) options = {};
    db = (0, $eTAKc.getModularInstance)(db);
    db._checkNotDeleted("useEmulator");
    if (db._instanceStarted) $9d8fdf02b8ce4d4a$var$fatal("Cannot call useEmulator() after instance has already been initialized.");
    var repo = db._repoInternal;
    var tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $9d8fdf02b8ce4d4a$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $9d8fdf02b8ce4d4a$var$EmulatorTokenProvider($9d8fdf02b8ce4d4a$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        var token = typeof options.mockUserToken === "string" ? options.mockUserToken : (0, $eTAKc.createMockUserToken)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $9d8fdf02b8ce4d4a$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $9d8fdf02b8ce4d4a$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $9d8fdf02b8ce4d4a$var$goOffline(db) {
    db = (0, $eTAKc.getModularInstance)(db);
    db._checkNotDeleted("goOffline");
    $9d8fdf02b8ce4d4a$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $9d8fdf02b8ce4d4a$var$goOnline(db) {
    db = (0, $eTAKc.getModularInstance)(db);
    db._checkNotDeleted("goOnline");
    $9d8fdf02b8ce4d4a$var$repoResume(db._repo);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$SERVER_TIMESTAMP = {
    ".sv": "timestamp"
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $9d8fdf02b8ce4d4a$var$serverTimestamp() {
    return $9d8fdf02b8ce4d4a$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $9d8fdf02b8ce4d4a$var$increment(delta) {
    return {
        ".sv": {
            "increment": delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of Firebase.transaction.
 */ var $9d8fdf02b8ce4d4a$var$TransactionResult$1 = /** @class */ function() {
    /** @hideconstructor */ function TransactionResult(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ TransactionResult.prototype.toJSON = function() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    };
    return TransactionResult;
}();
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `transaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A Promise that can optionally be used instead of the onComplete
 * callback to handle success and failure.
 */ function $9d8fdf02b8ce4d4a$var$runTransaction(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $eTAKc.getModularInstance)(ref);
    $9d8fdf02b8ce4d4a$var$validateWritablePath("Reference.transaction", ref._path);
    if (ref.key === ".length" || ref.key === ".keys") throw "Reference.transaction failed: " + ref.key + " is a read-only object.";
    var applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    var deferred = new (0, $eTAKc.Deferred)();
    var promiseComplete = function(error, committed, node) {
        var dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $9d8fdf02b8ce4d4a$var$DataSnapshot$1(node, new $9d8fdf02b8ce4d4a$var$ReferenceImpl(ref._repo, ref._path), $9d8fdf02b8ce4d4a$var$PRIORITY_INDEX);
            deferred.resolve(new $9d8fdf02b8ce4d4a$var$TransactionResult$1(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    var unwatcher = $9d8fdf02b8ce4d4a$var$onValue(ref, function() {});
    $9d8fdf02b8ce4d4a$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$export$95b7818b4ee6c2af = /** @class */ function() {
    function OnDisconnect(_delegate) {
        this._delegate = _delegate;
    }
    OnDisconnect.prototype.cancel = function(onComplete) {
        (0, $eTAKc.validateArgCount)("OnDisconnect.cancel", 0, 1, arguments.length);
        (0, $eTAKc.validateCallback)("OnDisconnect.cancel", "onComplete", onComplete, true);
        var result = this._delegate.cancel();
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    OnDisconnect.prototype.remove = function(onComplete) {
        (0, $eTAKc.validateArgCount)("OnDisconnect.remove", 0, 1, arguments.length);
        (0, $eTAKc.validateCallback)("OnDisconnect.remove", "onComplete", onComplete, true);
        var result = this._delegate.remove();
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    OnDisconnect.prototype.set = function(value, onComplete) {
        (0, $eTAKc.validateArgCount)("OnDisconnect.set", 1, 2, arguments.length);
        (0, $eTAKc.validateCallback)("OnDisconnect.set", "onComplete", onComplete, true);
        var result = this._delegate.set(value);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    OnDisconnect.prototype.setWithPriority = function(value, priority, onComplete) {
        (0, $eTAKc.validateArgCount)("OnDisconnect.setWithPriority", 2, 3, arguments.length);
        (0, $eTAKc.validateCallback)("OnDisconnect.setWithPriority", "onComplete", onComplete, true);
        var result = this._delegate.setWithPriority(value, priority);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    OnDisconnect.prototype.update = function(objectToMerge, onComplete) {
        (0, $eTAKc.validateArgCount)("OnDisconnect.update", 1, 2, arguments.length);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for(var i = 0; i < objectToMerge.length; ++i)newObjectToMerge["" + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $9d8fdf02b8ce4d4a$var$warn("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $eTAKc.validateCallback)("OnDisconnect.update", "onComplete", onComplete, true);
        var result = this._delegate.update(objectToMerge);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    return OnDisconnect;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$TransactionResult = /** @class */ function() {
    /**
     * A type for the resolve value of Firebase.transaction.
     */ function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function() {
        (0, $eTAKc.validateArgCount)("TransactionResult.toJSON", 0, 1, arguments.length);
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    };
    return TransactionResult;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-enable @typescript-eslint/no-explicit-any */ /**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */ var $9d8fdf02b8ce4d4a$export$80b98bcbc246c942 = /** @class */ function() {
    function DataSnapshot(_database, _delegate) {
        this._database = _database;
        this._delegate = _delegate;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ DataSnapshot.prototype.val = function() {
        (0, $eTAKc.validateArgCount)("DataSnapshot.val", 0, 0, arguments.length);
        return this._delegate.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ DataSnapshot.prototype.exportVal = function() {
        (0, $eTAKc.validateArgCount)("DataSnapshot.exportVal", 0, 0, arguments.length);
        return this._delegate.exportVal();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function() {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        (0, $eTAKc.validateArgCount)("DataSnapshot.toJSON", 0, 1, arguments.length);
        return this._delegate.toJSON();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @returns Whether the snapshot contains a non-null value, or is empty.
     */ DataSnapshot.prototype.exists = function() {
        (0, $eTAKc.validateArgCount)("DataSnapshot.exists", 0, 0, arguments.length);
        return this._delegate.exists();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param path - Path to a child.
     * @returns DataSnapshot for child node.
     */ DataSnapshot.prototype.child = function(path) {
        (0, $eTAKc.validateArgCount)("DataSnapshot.child", 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        path = String(path);
        $9d8fdf02b8ce4d4a$var$validatePathString("DataSnapshot.child", "path", path, false);
        return new DataSnapshot(this._database, this._delegate.child(path));
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param path - Path to a child.
     * @returns Whether the child exists.
     */ DataSnapshot.prototype.hasChild = function(path) {
        (0, $eTAKc.validateArgCount)("DataSnapshot.hasChild", 1, 1, arguments.length);
        $9d8fdf02b8ce4d4a$var$validatePathString("DataSnapshot.hasChild", "path", path, false);
        return this._delegate.hasChild(path);
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @returns The priority.
     */ DataSnapshot.prototype.getPriority = function() {
        (0, $eTAKc.validateArgCount)("DataSnapshot.getPriority", 0, 0, arguments.length);
        return this._delegate.priority;
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param action - Callback function to be called
     * for each child.
     * @returns True if forEach was canceled by action returning true for
     * one of the child nodes.
     */ DataSnapshot.prototype.forEach = function(action) {
        var _this = this;
        (0, $eTAKc.validateArgCount)("DataSnapshot.forEach", 1, 1, arguments.length);
        (0, $eTAKc.validateCallback)("DataSnapshot.forEach", "action", action, false);
        return this._delegate.forEach(function(expDataSnapshot) {
            return action(new DataSnapshot(_this._database, expDataSnapshot));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @returns True if the DataSnapshot contains 1 or more child nodes.
     */ DataSnapshot.prototype.hasChildren = function() {
        (0, $eTAKc.validateArgCount)("DataSnapshot.hasChildren", 0, 0, arguments.length);
        return this._delegate.hasChildren();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function() {
            return this._delegate.key;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @returns The number of children that this DataSnapshot contains.
     */ DataSnapshot.prototype.numChildren = function() {
        (0, $eTAKc.validateArgCount)("DataSnapshot.numChildren", 0, 0, arguments.length);
        return this._delegate.size;
    };
    /**
     * @returns The Firebase reference for the location this snapshot's data came
     * from.
     */ DataSnapshot.prototype.getRef = function() {
        (0, $eTAKc.validateArgCount)("DataSnapshot.ref", 0, 0, arguments.length);
        return new $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7(this._database, this._delegate.ref);
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function() {
            return this.getRef();
        },
        enumerable: false,
        configurable: true
    });
    return DataSnapshot;
}();
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */ var $9d8fdf02b8ce4d4a$export$62297b13309008b2 = /** @class */ function() {
    function Query(database, _delegate) {
        this.database = database;
        this._delegate = _delegate;
    }
    Query.prototype.on = function(eventType, callback, cancelCallbackOrContext, context) {
        var _this = this;
        var _a;
        (0, $eTAKc.validateArgCount)("Query.on", 2, 4, arguments.length);
        (0, $eTAKc.validateCallback)("Query.on", "callback", callback, false);
        var ret = Query.getCancelAndContextArgs_("Query.on", cancelCallbackOrContext, context);
        var valueCallback = function(expSnapshot, previousChildName) {
            callback.call(ret.context, new $9d8fdf02b8ce4d4a$export$80b98bcbc246c942(_this.database, expSnapshot), previousChildName);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        var cancelCallback = (_a = ret.cancel) === null || _a === void 0 ? void 0 : _a.bind(ret.context);
        switch(eventType){
            case "value":
                $9d8fdf02b8ce4d4a$var$onValue(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_added":
                $9d8fdf02b8ce4d4a$var$onChildAdded(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_removed":
                $9d8fdf02b8ce4d4a$var$onChildRemoved(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_changed":
                $9d8fdf02b8ce4d4a$var$onChildChanged(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_moved":
                $9d8fdf02b8ce4d4a$var$onChildMoved(this._delegate, valueCallback, cancelCallback);
                return callback;
            default:
                throw new Error((0, $eTAKc.errorPrefix)("Query.on", "eventType") + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
    };
    Query.prototype.off = function(eventType, callback, context) {
        (0, $eTAKc.validateArgCount)("Query.off", 0, 3, arguments.length);
        $9d8fdf02b8ce4d4a$var$validateEventType("Query.off", eventType, true);
        (0, $eTAKc.validateCallback)("Query.off", "callback", callback, true);
        (0, $eTAKc.validateContextObject)("Query.off", "context", context, true);
        if (callback) {
            var valueCallback = function() {};
            valueCallback.userCallback = callback;
            valueCallback.context = context;
            $9d8fdf02b8ce4d4a$var$off(this._delegate, eventType, valueCallback);
        } else $9d8fdf02b8ce4d4a$var$off(this._delegate, eventType);
    };
    /**
     * Get the server-value for this query, or return a cached value if not connected.
     */ Query.prototype.get = function() {
        var _this = this;
        return $9d8fdf02b8ce4d4a$var$get(this._delegate).then(function(expSnapshot) {
            return new $9d8fdf02b8ce4d4a$export$80b98bcbc246c942(_this.database, expSnapshot);
        });
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     */ Query.prototype.once = function(eventType, callback, failureCallbackOrContext, context) {
        var _this = this;
        (0, $eTAKc.validateArgCount)("Query.once", 1, 4, arguments.length);
        (0, $eTAKc.validateCallback)("Query.once", "callback", callback, true);
        var ret = Query.getCancelAndContextArgs_("Query.once", failureCallbackOrContext, context);
        var deferred = new (0, $eTAKc.Deferred)();
        var valueCallback = function(expSnapshot, previousChildName) {
            var result = new $9d8fdf02b8ce4d4a$export$80b98bcbc246c942(_this.database, expSnapshot);
            if (callback) callback.call(ret.context, result, previousChildName);
            deferred.resolve(result);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        var cancelCallback = function(error) {
            if (ret.cancel) ret.cancel.call(ret.context, error);
            deferred.reject(error);
        };
        switch(eventType){
            case "value":
                $9d8fdf02b8ce4d4a$var$onValue(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_added":
                $9d8fdf02b8ce4d4a$var$onChildAdded(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_removed":
                $9d8fdf02b8ce4d4a$var$onChildRemoved(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_changed":
                $9d8fdf02b8ce4d4a$var$onChildChanged(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_moved":
                $9d8fdf02b8ce4d4a$var$onChildMoved(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            default:
                throw new Error((0, $eTAKc.errorPrefix)("Query.once", "eventType") + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     */ Query.prototype.limitToFirst = function(limit) {
        (0, $eTAKc.validateArgCount)("Query.limitToFirst", 1, 1, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$limitToFirst(limit)));
    };
    /**
     * Set a limit and anchor it to the end of the window.
     */ Query.prototype.limitToLast = function(limit) {
        (0, $eTAKc.validateArgCount)("Query.limitToLast", 1, 1, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$limitToLast(limit)));
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     */ Query.prototype.orderByChild = function(path) {
        (0, $eTAKc.validateArgCount)("Query.orderByChild", 1, 1, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$orderByChild(path)));
    };
    /**
     * Return a new query ordered by the KeyIndex
     */ Query.prototype.orderByKey = function() {
        (0, $eTAKc.validateArgCount)("Query.orderByKey", 0, 0, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$orderByKey()));
    };
    /**
     * Return a new query ordered by the PriorityIndex
     */ Query.prototype.orderByPriority = function() {
        (0, $eTAKc.validateArgCount)("Query.orderByPriority", 0, 0, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$orderByPriority()));
    };
    /**
     * Return a new query ordered by the ValueIndex
     */ Query.prototype.orderByValue = function() {
        (0, $eTAKc.validateArgCount)("Query.orderByValue", 0, 0, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$orderByValue()));
    };
    Query.prototype.startAt = function(value, name) {
        if (value === void 0) value = null;
        (0, $eTAKc.validateArgCount)("Query.startAt", 0, 2, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$startAt(value, name)));
    };
    Query.prototype.startAfter = function(value, name) {
        if (value === void 0) value = null;
        (0, $eTAKc.validateArgCount)("Query.startAfter", 0, 2, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$startAfter(value, name)));
    };
    Query.prototype.endAt = function(value, name) {
        if (value === void 0) value = null;
        (0, $eTAKc.validateArgCount)("Query.endAt", 0, 2, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$endAt(value, name)));
    };
    Query.prototype.endBefore = function(value, name) {
        if (value === void 0) value = null;
        (0, $eTAKc.validateArgCount)("Query.endBefore", 0, 2, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$endBefore(value, name)));
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     */ Query.prototype.equalTo = function(value, name) {
        (0, $eTAKc.validateArgCount)("Query.equalTo", 1, 2, arguments.length);
        return new Query(this.database, $9d8fdf02b8ce4d4a$var$query(this._delegate, $9d8fdf02b8ce4d4a$var$equalTo(value, name)));
    };
    /**
     * @returns URL for this location.
     */ Query.prototype.toString = function() {
        (0, $eTAKc.validateArgCount)("Query.toString", 0, 0, arguments.length);
        return this._delegate.toString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function() {
        // An optional spacer argument is unnecessary for a string.
        (0, $eTAKc.validateArgCount)("Query.toJSON", 0, 1, arguments.length);
        return this._delegate.toJSON();
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     */ Query.prototype.isEqual = function(other) {
        (0, $eTAKc.validateArgCount)("Query.isEqual", 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = "Query.isEqual failed: First argument must be an instance of firebase.database.Query.";
            throw new Error(error);
        }
        return this._delegate.isEqual(other._delegate);
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param fnName - The function name (on or once)
     *
     */ Query.getCancelAndContextArgs_ = function(fnName, cancelOrContext, context) {
        var ret = {
            cancel: undefined,
            context: undefined
        };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            (0, $eTAKc.validateCallback)(fnName, "cancel", ret.cancel, true);
            ret.context = context;
            (0, $eTAKc.validateContextObject)(fnName, "context", ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === "object" && cancelOrContext !== null) // it's a context!
            ret.context = cancelOrContext;
            else if (typeof cancelOrContext === "function") ret.cancel = cancelOrContext;
            else throw new Error((0, $eTAKc.errorPrefix)(fnName, "cancelOrContext") + " must either be a cancel callback or a context object.");
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function() {
            return new $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7(this.database, new $9d8fdf02b8ce4d4a$var$ReferenceImpl(this._delegate._repo, this._delegate._path));
        },
        enumerable: false,
        configurable: true
    });
    return Query;
}();
var $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7 = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     */ function Reference(database, _delegate) {
        var _this = _super.call(this, database, new $9d8fdf02b8ce4d4a$var$QueryImpl(_delegate._repo, _delegate._path, new $9d8fdf02b8ce4d4a$var$QueryParams(), false)) || this;
        _this.database = database;
        _this._delegate = _delegate;
        return _this;
    }
    /** @returns {?string} */ Reference.prototype.getKey = function() {
        (0, $eTAKc.validateArgCount)("Reference.key", 0, 0, arguments.length);
        return this._delegate.key;
    };
    Reference.prototype.child = function(pathString) {
        (0, $eTAKc.validateArgCount)("Reference.child", 1, 1, arguments.length);
        if (typeof pathString === "number") pathString = String(pathString);
        return new Reference(this.database, $9d8fdf02b8ce4d4a$var$child(this._delegate, pathString));
    };
    /** @returns {?Reference} */ Reference.prototype.getParent = function() {
        (0, $eTAKc.validateArgCount)("Reference.parent", 0, 0, arguments.length);
        var parent = this._delegate.parent;
        return parent ? new Reference(this.database, parent) : null;
    };
    /** @returns {!Reference} */ Reference.prototype.getRoot = function() {
        (0, $eTAKc.validateArgCount)("Reference.root", 0, 0, arguments.length);
        return new Reference(this.database, this._delegate.root);
    };
    Reference.prototype.set = function(newVal, onComplete) {
        (0, $eTAKc.validateArgCount)("Reference.set", 1, 2, arguments.length);
        (0, $eTAKc.validateCallback)("Reference.set", "onComplete", onComplete, true);
        var result = $9d8fdf02b8ce4d4a$var$set(this._delegate, newVal);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    Reference.prototype.update = function(values, onComplete) {
        (0, $eTAKc.validateArgCount)("Reference.update", 1, 2, arguments.length);
        if (Array.isArray(values)) {
            var newObjectToMerge = {};
            for(var i = 0; i < values.length; ++i)newObjectToMerge["" + i] = values[i];
            values = newObjectToMerge;
            $9d8fdf02b8ce4d4a$var$warn("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        $9d8fdf02b8ce4d4a$var$validateWritablePath("Reference.update", this._delegate._path);
        (0, $eTAKc.validateCallback)("Reference.update", "onComplete", onComplete, true);
        var result = $9d8fdf02b8ce4d4a$var$update(this._delegate, values);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    Reference.prototype.setWithPriority = function(newVal, newPriority, onComplete) {
        (0, $eTAKc.validateArgCount)("Reference.setWithPriority", 2, 3, arguments.length);
        (0, $eTAKc.validateCallback)("Reference.setWithPriority", "onComplete", onComplete, true);
        var result = $9d8fdf02b8ce4d4a$var$setWithPriority(this._delegate, newVal, newPriority);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    Reference.prototype.remove = function(onComplete) {
        (0, $eTAKc.validateArgCount)("Reference.remove", 0, 1, arguments.length);
        (0, $eTAKc.validateCallback)("Reference.remove", "onComplete", onComplete, true);
        var result = $9d8fdf02b8ce4d4a$var$remove(this._delegate);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    Reference.prototype.transaction = function(transactionUpdate, onComplete, applyLocally) {
        var _this = this;
        (0, $eTAKc.validateArgCount)("Reference.transaction", 1, 3, arguments.length);
        (0, $eTAKc.validateCallback)("Reference.transaction", "transactionUpdate", transactionUpdate, false);
        (0, $eTAKc.validateCallback)("Reference.transaction", "onComplete", onComplete, true);
        $9d8fdf02b8ce4d4a$var$validateBoolean("Reference.transaction", "applyLocally", applyLocally, true);
        var result = $9d8fdf02b8ce4d4a$var$runTransaction(this._delegate, transactionUpdate, {
            applyLocally: applyLocally
        }).then(function(transactionResult) {
            return new $9d8fdf02b8ce4d4a$var$TransactionResult(transactionResult.committed, new $9d8fdf02b8ce4d4a$export$80b98bcbc246c942(_this.database, transactionResult.snapshot));
        });
        if (onComplete) result.then(function(transactionResult) {
            return onComplete(null, transactionResult.committed, transactionResult.snapshot);
        }, function(error) {
            return onComplete(error, false, null);
        });
        return result;
    };
    Reference.prototype.setPriority = function(priority, onComplete) {
        (0, $eTAKc.validateArgCount)("Reference.setPriority", 1, 2, arguments.length);
        (0, $eTAKc.validateCallback)("Reference.setPriority", "onComplete", onComplete, true);
        var result = $9d8fdf02b8ce4d4a$var$setPriority(this._delegate, priority);
        if (onComplete) result.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        return result;
    };
    Reference.prototype.push = function(value, onComplete) {
        var _this = this;
        (0, $eTAKc.validateArgCount)("Reference.push", 0, 2, arguments.length);
        (0, $eTAKc.validateCallback)("Reference.push", "onComplete", onComplete, true);
        var expPromise = $9d8fdf02b8ce4d4a$var$push(this._delegate, value);
        var promise = expPromise.then(function(expRef) {
            return new Reference(_this.database, expRef);
        });
        if (onComplete) promise.then(function() {
            return onComplete(null);
        }, function(error) {
            return onComplete(error);
        });
        var result = new Reference(this.database, expPromise);
        result.then = promise.then.bind(promise);
        result.catch = promise.catch.bind(promise, undefined);
        return result;
    };
    Reference.prototype.onDisconnect = function() {
        $9d8fdf02b8ce4d4a$var$validateWritablePath("Reference.onDisconnect", this._delegate._path);
        return new $9d8fdf02b8ce4d4a$export$95b7818b4ee6c2af(new $9d8fdf02b8ce4d4a$var$OnDisconnect$1(this._delegate._repo, this._delegate._path));
    };
    Object.defineProperty(Reference.prototype, "key", {
        get: function() {
            return this.getKey();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function() {
            return this.getParent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function() {
            return this.getRoot();
        },
        enumerable: false,
        configurable: true
    });
    return Reference;
}($9d8fdf02b8ce4d4a$export$62297b13309008b2);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase database.
 */ var $9d8fdf02b8ce4d4a$export$6feb5ea51a7b0b47 = /** @class */ function() {
    /**
     * The constructor should not be called by users of our public API.
     */ function Database(_delegate, app) {
        var _this = this;
        this._delegate = _delegate;
        this.app = app;
        this.INTERNAL = {
            delete: function() {
                return _this._delegate._delete();
            }
        };
    }
    /**
     * Modify this instance to communicate with the Realtime Database emulator.
     *
     * <p>Note: This method must be called before performing any other operation.
     *
     * @param host - the emulator host (ex: localhost)
     * @param port - the emulator port (ex: 8080)
     * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
     */ Database.prototype.useEmulator = function(host, port, options) {
        if (options === void 0) options = {};
        $9d8fdf02b8ce4d4a$var$connectDatabaseEmulator(this._delegate, host, port, options);
    };
    Database.prototype.ref = function(path) {
        (0, $eTAKc.validateArgCount)("database.ref", 0, 1, arguments.length);
        if (path instanceof $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7) {
            var childRef = $9d8fdf02b8ce4d4a$var$refFromURL(this._delegate, path.toString());
            return new $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7(this, childRef);
        } else {
            var childRef = $9d8fdf02b8ce4d4a$var$ref(this._delegate, path);
            return new $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7(this, childRef);
        }
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @returns Firebase reference.
     */ Database.prototype.refFromURL = function(url) {
        var apiName = "database.refFromURL";
        (0, $eTAKc.validateArgCount)(apiName, 1, 1, arguments.length);
        var childRef = $9d8fdf02b8ce4d4a$var$refFromURL(this._delegate, url);
        return new $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7(this, childRef);
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function() {
        (0, $eTAKc.validateArgCount)("database.goOffline", 0, 0, arguments.length);
        return $9d8fdf02b8ce4d4a$var$goOffline(this._delegate);
    };
    Database.prototype.goOnline = function() {
        (0, $eTAKc.validateArgCount)("database.goOnline", 0, 0, arguments.length);
        return $9d8fdf02b8ce4d4a$var$goOnline(this._delegate);
    };
    Database.ServerValue = {
        TIMESTAMP: $9d8fdf02b8ce4d4a$var$serverTimestamp(),
        increment: function(delta) {
            return $9d8fdf02b8ce4d4a$var$increment(delta);
        }
    };
    return Database;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 */ var $9d8fdf02b8ce4d4a$var$forceLongPolling = function() {
    $9d8fdf02b8ce4d4a$var$WebSocketConnection.forceDisallow();
    $9d8fdf02b8ce4d4a$var$BrowserPollConnection.forceAllow();
};
var $9d8fdf02b8ce4d4a$var$forceWebSockets = function() {
    $9d8fdf02b8ce4d4a$var$BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */ var $9d8fdf02b8ce4d4a$var$isWebSocketsAvailable = function() {
    return $9d8fdf02b8ce4d4a$var$WebSocketConnection["isAvailable"]();
};
var $9d8fdf02b8ce4d4a$var$setSecurityDebugCallback = function(ref, callback) {
    var connection = ref._delegate._repo.persistentConnection_;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    connection.securityDebugCallback_ = callback;
};
var $9d8fdf02b8ce4d4a$var$stats = function(ref, showDelta) {
    $9d8fdf02b8ce4d4a$var$repoStats(ref._delegate._repo, showDelta);
};
var $9d8fdf02b8ce4d4a$var$statsIncrementCounter = function(ref, metric) {
    $9d8fdf02b8ce4d4a$var$repoStatsIncrementCounter(ref._delegate._repo, metric);
};
var $9d8fdf02b8ce4d4a$var$dataUpdateCount = function(ref) {
    return ref._delegate._repo.dataUpdateCount;
};
var $9d8fdf02b8ce4d4a$var$interceptServerData = function(ref, callback) {
    return $9d8fdf02b8ce4d4a$var$repoInterceptServerData(ref._delegate._repo, callback);
};
/**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 *
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAuthImpl - custom auth implementation
 */ function $9d8fdf02b8ce4d4a$var$initStandalone(_a) {
    var app = _a.app, url = _a.url, version = _a.version, customAuthImpl = _a.customAuthImpl, namespace = _a.namespace, _b = _a.nodeAdmin, nodeAdmin = _b === void 0 ? false : _b;
    $9d8fdf02b8ce4d4a$var$setSDKVersion(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ var authProvider = new (0, $4TGB3.Provider)("auth-internal", new (0, $4TGB3.ComponentContainer)("database-standalone"));
    authProvider.setComponent(new (0, $4TGB3.Component)("auth-internal", function() {
        return customAuthImpl;
    }, "PRIVATE" /* PRIVATE */ ));
    return {
        instance: new $9d8fdf02b8ce4d4a$export$6feb5ea51a7b0b47($9d8fdf02b8ce4d4a$var$repoManagerDatabaseFromApp(app, authProvider, /* appCheckProvider= */ undefined, url, nodeAdmin), app),
        namespace: namespace
    };
}
var $9d8fdf02b8ce4d4a$var$INTERNAL = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    forceLongPolling: $9d8fdf02b8ce4d4a$var$forceLongPolling,
    forceWebSockets: $9d8fdf02b8ce4d4a$var$forceWebSockets,
    isWebSocketsAvailable: $9d8fdf02b8ce4d4a$var$isWebSocketsAvailable,
    setSecurityDebugCallback: $9d8fdf02b8ce4d4a$var$setSecurityDebugCallback,
    stats: $9d8fdf02b8ce4d4a$var$stats,
    statsIncrementCounter: $9d8fdf02b8ce4d4a$var$statsIncrementCounter,
    dataUpdateCount: $9d8fdf02b8ce4d4a$var$dataUpdateCount,
    interceptServerData: $9d8fdf02b8ce4d4a$var$interceptServerData,
    initStandalone: $9d8fdf02b8ce4d4a$var$initStandalone
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$var$DataConnection = $9d8fdf02b8ce4d4a$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$9d8fdf02b8ce4d4a$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest("q", {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$9d8fdf02b8ce4d4a$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest("echo", {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var $9d8fdf02b8ce4d4a$var$RealTimeConnection = $9d8fdf02b8ce4d4a$var$Connection;
var $9d8fdf02b8ce4d4a$var$hijackHash = function(newHash) {
    var oldPut = $9d8fdf02b8ce4d4a$var$PersistentConnection.prototype.put;
    $9d8fdf02b8ce4d4a$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $9d8fdf02b8ce4d4a$var$PersistentConnection.prototype.put = oldPut;
    };
};
var $9d8fdf02b8ce4d4a$var$ConnectionTarget = $9d8fdf02b8ce4d4a$var$RepoInfo;
var $9d8fdf02b8ce4d4a$var$queryIdentifier = function(query) {
    return query._delegate._queryIdentifier;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 */ var $9d8fdf02b8ce4d4a$var$forceRestClient = function(forceRestClient) {
    $9d8fdf02b8ce4d4a$var$repoManagerForceRestClient(forceRestClient);
};
var $9d8fdf02b8ce4d4a$var$TEST_ACCESS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DataConnection: $9d8fdf02b8ce4d4a$var$DataConnection,
    RealTimeConnection: $9d8fdf02b8ce4d4a$var$RealTimeConnection,
    hijackHash: $9d8fdf02b8ce4d4a$var$hijackHash,
    ConnectionTarget: $9d8fdf02b8ce4d4a$var$ConnectionTarget,
    queryIdentifier: $9d8fdf02b8ce4d4a$var$queryIdentifier,
    forceRestClient: $9d8fdf02b8ce4d4a$var$forceRestClient
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9d8fdf02b8ce4d4a$export$941e980876ff789f = $9d8fdf02b8ce4d4a$export$6feb5ea51a7b0b47.ServerValue;
function $9d8fdf02b8ce4d4a$export$44894f2caba7dc4c(instance) {
    // set SDK_VERSION
    $9d8fdf02b8ce4d4a$var$setSDKVersion(instance.SDK_VERSION);
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerComponent(new (0, $4TGB3.Component)("database", function(container, _a) {
        var url = _a.instanceIdentifier;
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        var authProvider = container.getProvider("auth-internal");
        var appCheckProvider = container.getProvider("app-check-internal");
        return new $9d8fdf02b8ce4d4a$export$6feb5ea51a7b0b47($9d8fdf02b8ce4d4a$var$repoManagerDatabaseFromApp(app, authProvider, appCheckProvider, url), app);
    }, "PUBLIC" /* PUBLIC */ ).setServiceProps(// firebase.database namespace properties
    {
        Reference: $9d8fdf02b8ce4d4a$export$e0be378c32fb70a7,
        Query: $9d8fdf02b8ce4d4a$export$62297b13309008b2,
        Database: $9d8fdf02b8ce4d4a$export$6feb5ea51a7b0b47,
        DataSnapshot: $9d8fdf02b8ce4d4a$export$80b98bcbc246c942,
        enableLogging: $9d8fdf02b8ce4d4a$export$4e1d237eb9e560af,
        INTERNAL: $9d8fdf02b8ce4d4a$var$INTERNAL,
        ServerValue: $9d8fdf02b8ce4d4a$export$941e980876ff789f,
        TEST_ACCESS: $9d8fdf02b8ce4d4a$var$TEST_ACCESS
    }).setMultipleInstances(true));
    instance.registerVersion($9d8fdf02b8ce4d4a$var$name, $9d8fdf02b8ce4d4a$var$version);
    if ((0, $eTAKc.isNodeSdk)()) $9d8fdf02b8ce4d4a$exports = namespace;
}
$9d8fdf02b8ce4d4a$export$44894f2caba7dc4c((0, $8eXKx.default));





var $8eXKx = parcelRequire("8eXKx");

var $2WUgS = parcelRequire("2WUgS");

var $eTAKc = parcelRequire("eTAKc");

var $i4pDv = parcelRequire("i4pDv");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2e7dd9641ea1df79$var$extendStatics = function(d, b) {
    $2e7dd9641ea1df79$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2e7dd9641ea1df79$var$extendStatics(d, b);
};
function $2e7dd9641ea1df79$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2e7dd9641ea1df79$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $2e7dd9641ea1df79$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $2e7dd9641ea1df79$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $2e7dd9641ea1df79$var$k, $2e7dd9641ea1df79$var$goog = $2e7dd9641ea1df79$var$goog || {}, $2e7dd9641ea1df79$var$l = $2e7dd9641ea1df79$var$commonjsGlobal || self;
function $2e7dd9641ea1df79$var$aa() {}
function $2e7dd9641ea1df79$var$ba(a) {
    var b = typeof a;
    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $2e7dd9641ea1df79$var$p(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $2e7dd9641ea1df79$var$da(a) {
    return Object.prototype.hasOwnProperty.call(a, $2e7dd9641ea1df79$var$ea) && a[$2e7dd9641ea1df79$var$ea] || (a[$2e7dd9641ea1df79$var$ea] = ++$2e7dd9641ea1df79$var$fa);
}
var $2e7dd9641ea1df79$var$ea = "closure_uid_" + (1E9 * Math.random() >>> 0), $2e7dd9641ea1df79$var$fa = 0;
function $2e7dd9641ea1df79$var$ha(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $2e7dd9641ea1df79$var$ia(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $2e7dd9641ea1df79$var$q(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $2e7dd9641ea1df79$var$q = $2e7dd9641ea1df79$var$ha : $2e7dd9641ea1df79$var$q = $2e7dd9641ea1df79$var$ia;
    return $2e7dd9641ea1df79$var$q.apply(null, arguments);
}
function $2e7dd9641ea1df79$var$ja(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
function $2e7dd9641ea1df79$var$t(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.Z = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.Vb = function(d, e, f) {
        for(var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)h[n - 2] = arguments[n];
        return b.prototype[e].apply(d, h);
    };
}
function $2e7dd9641ea1df79$var$v() {
    this.s = this.s;
    this.o = this.o;
}
var $2e7dd9641ea1df79$var$ka = 0, $2e7dd9641ea1df79$var$la = {};
$2e7dd9641ea1df79$var$v.prototype.s = !1;
$2e7dd9641ea1df79$var$v.prototype.na = function() {
    if (!this.s && (this.s = !0, this.M(), 0 != $2e7dd9641ea1df79$var$ka)) {
        var a = $2e7dd9641ea1df79$var$da(this);
        delete $2e7dd9641ea1df79$var$la[a];
    }
};
$2e7dd9641ea1df79$var$v.prototype.M = function() {
    if (this.o) for(; this.o.length;)this.o.shift()();
};
var $2e7dd9641ea1df79$var$ma = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
}, $2e7dd9641ea1df79$var$na = Array.prototype.forEach ? function(a, b, c) {
    Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
    var d = a.length, e = "string" === typeof a ? a.split("") : a;
    for(var f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
};
function $2e7dd9641ea1df79$var$oa(a) {
    a: {
        var b = $2e7dd9641ea1df79$var$pa;
        var c = a.length, d = "string" === typeof a ? a.split("") : a;
        for(var e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
            b = e;
            break a;
        }
        b = -1;
    }
    return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
}
function $2e7dd9641ea1df79$var$qa(a) {
    return Array.prototype.concat.apply([], arguments);
}
function $2e7dd9641ea1df79$var$ra(a) {
    var b = a.length;
    if (0 < b) {
        var c = Array(b);
        for(var d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $2e7dd9641ea1df79$var$sa(a) {
    return /^[\s\xa0]*$/.test(a);
}
var $2e7dd9641ea1df79$var$ta = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function $2e7dd9641ea1df79$var$w(a, b) {
    return -1 != a.indexOf(b);
}
function $2e7dd9641ea1df79$var$ua(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var $2e7dd9641ea1df79$var$x;
a: {
    var $2e7dd9641ea1df79$var$va = $2e7dd9641ea1df79$var$l.navigator;
    if ($2e7dd9641ea1df79$var$va) {
        var $2e7dd9641ea1df79$var$wa = $2e7dd9641ea1df79$var$va.userAgent;
        if ($2e7dd9641ea1df79$var$wa) {
            $2e7dd9641ea1df79$var$x = $2e7dd9641ea1df79$var$wa;
            break a;
        }
    }
    $2e7dd9641ea1df79$var$x = "";
}
function $2e7dd9641ea1df79$var$xa(a, b, c) {
    for(var d in a)b.call(c, a[d], d, a);
}
function $2e7dd9641ea1df79$var$ya(a) {
    var b = {};
    for(var c in a)b[c] = a[c];
    return b;
}
var $2e7dd9641ea1df79$var$za = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $2e7dd9641ea1df79$var$Aa(a, b) {
    var c, d;
    for(var e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(var f = 0; f < $2e7dd9641ea1df79$var$za.length; f++)c = $2e7dd9641ea1df79$var$za[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $2e7dd9641ea1df79$var$Ca(a) {
    $2e7dd9641ea1df79$var$Ca[" "](a);
    return a;
}
$2e7dd9641ea1df79$var$Ca[" "] = $2e7dd9641ea1df79$var$aa;
function $2e7dd9641ea1df79$var$Fa(a) {
    var b = $2e7dd9641ea1df79$var$Ga;
    return Object.prototype.hasOwnProperty.call(b, 9) ? b[9] : b[9] = a(9);
}
var $2e7dd9641ea1df79$var$Ha = $2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Opera"), $2e7dd9641ea1df79$var$y = $2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Trident") || $2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "MSIE"), $2e7dd9641ea1df79$var$Ia = $2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Edge"), $2e7dd9641ea1df79$var$Ja = $2e7dd9641ea1df79$var$Ia || $2e7dd9641ea1df79$var$y, $2e7dd9641ea1df79$var$Ka = $2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Gecko") && !($2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x.toLowerCase(), "webkit") && !$2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Edge")) && !($2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Trident") || $2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "MSIE")) && !$2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Edge"), $2e7dd9641ea1df79$var$La = $2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x.toLowerCase(), "webkit") && !$2e7dd9641ea1df79$var$w($2e7dd9641ea1df79$var$x, "Edge");
function $2e7dd9641ea1df79$var$Ma() {
    var a = $2e7dd9641ea1df79$var$l.document;
    return a ? a.documentMode : void 0;
}
var $2e7dd9641ea1df79$var$Na;
a: {
    var $2e7dd9641ea1df79$var$Oa = "", $2e7dd9641ea1df79$var$Pa = function() {
        var a = $2e7dd9641ea1df79$var$x;
        if ($2e7dd9641ea1df79$var$Ka) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($2e7dd9641ea1df79$var$Ia) return /Edge\/([\d\.]+)/.exec(a);
        if ($2e7dd9641ea1df79$var$y) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($2e7dd9641ea1df79$var$La) return /WebKit\/(\S+)/.exec(a);
        if ($2e7dd9641ea1df79$var$Ha) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $2e7dd9641ea1df79$var$Pa && ($2e7dd9641ea1df79$var$Oa = $2e7dd9641ea1df79$var$Pa ? $2e7dd9641ea1df79$var$Pa[1] : "");
    if ($2e7dd9641ea1df79$var$y) {
        var $2e7dd9641ea1df79$var$Qa = $2e7dd9641ea1df79$var$Ma();
        if (null != $2e7dd9641ea1df79$var$Qa && $2e7dd9641ea1df79$var$Qa > parseFloat($2e7dd9641ea1df79$var$Oa)) {
            $2e7dd9641ea1df79$var$Na = String($2e7dd9641ea1df79$var$Qa);
            break a;
        }
    }
    $2e7dd9641ea1df79$var$Na = $2e7dd9641ea1df79$var$Oa;
}
var $2e7dd9641ea1df79$var$Ga = {};
function $2e7dd9641ea1df79$var$Ra() {
    return $2e7dd9641ea1df79$var$Fa(function() {
        var a = 0;
        var b = $2e7dd9641ea1df79$var$ta(String($2e7dd9641ea1df79$var$Na)).split("."), c = $2e7dd9641ea1df79$var$ta("9").split("."), d = Math.max(b.length, c.length);
        for(var h = 0; 0 == a && h < d; h++){
            var e = b[h] || "", f = c[h] || "";
            do {
                e = /(\d*)(\D*)(.*)/.exec(e) || [
                    "",
                    "",
                    "",
                    ""
                ];
                f = /(\d*)(\D*)(.*)/.exec(f) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == e[0].length && 0 == f[0].length) break;
                a = $2e7dd9641ea1df79$var$ua(0 == e[1].length ? 0 : parseInt(e[1], 10), 0 == f[1].length ? 0 : parseInt(f[1], 10)) || $2e7dd9641ea1df79$var$ua(0 == e[2].length, 0 == f[2].length) || $2e7dd9641ea1df79$var$ua(e[2], f[2]);
                e = e[3];
                f = f[3];
            }while (0 == a);
        }
        return 0 <= a;
    });
}
var $2e7dd9641ea1df79$var$Sa;
if ($2e7dd9641ea1df79$var$l.document && $2e7dd9641ea1df79$var$y) {
    var $2e7dd9641ea1df79$var$Ta = $2e7dd9641ea1df79$var$Ma();
    $2e7dd9641ea1df79$var$Sa = $2e7dd9641ea1df79$var$Ta ? $2e7dd9641ea1df79$var$Ta : parseInt($2e7dd9641ea1df79$var$Na, 10) || void 0;
} else $2e7dd9641ea1df79$var$Sa = void 0;
var $2e7dd9641ea1df79$var$Ua = $2e7dd9641ea1df79$var$Sa;
var $2e7dd9641ea1df79$var$Va = function() {
    if (!$2e7dd9641ea1df79$var$l.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $2e7dd9641ea1df79$var$l.addEventListener("test", $2e7dd9641ea1df79$var$aa, b), $2e7dd9641ea1df79$var$l.removeEventListener("test", $2e7dd9641ea1df79$var$aa, b);
    } catch (c) {}
    return a;
}();
function $2e7dd9641ea1df79$var$z(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
}
$2e7dd9641ea1df79$var$z.prototype.h = function() {
    this.defaultPrevented = !0;
};
function $2e7dd9641ea1df79$var$A(a, b) {
    $2e7dd9641ea1df79$var$z.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        if (b = a.relatedTarget) {
            if ($2e7dd9641ea1df79$var$Ka) {
                a: {
                    try {
                        $2e7dd9641ea1df79$var$Ca(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $2e7dd9641ea1df79$var$Wa[a.pointerType] || "";
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && $2e7dd9641ea1df79$var$A.Z.h.call(this);
    }
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$A, $2e7dd9641ea1df79$var$z);
var $2e7dd9641ea1df79$var$Wa = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$2e7dd9641ea1df79$var$A.prototype.h = function() {
    $2e7dd9641ea1df79$var$A.Z.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $2e7dd9641ea1df79$var$B = "closure_listenable_" + (1E6 * Math.random() | 0);
var $2e7dd9641ea1df79$var$Xa = 0;
function $2e7dd9641ea1df79$var$Ya(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.ia = e;
    this.key = ++$2e7dd9641ea1df79$var$Xa;
    this.ca = this.fa = !1;
}
function $2e7dd9641ea1df79$var$Za(a) {
    a.ca = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.ia = null;
}
function $2e7dd9641ea1df79$var$$a(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
}
$2e7dd9641ea1df79$var$$a.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var h = $2e7dd9641ea1df79$var$ab(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.fa = !1)) : (b = new $2e7dd9641ea1df79$var$Ya(b, this.src, f, !!d, e), b.fa = c, a.push(b));
    return b;
};
function $2e7dd9641ea1df79$var$bb(a, b) {
    var c = b.type;
    if (c in a.g) {
        var d = a.g[c], e = $2e7dd9641ea1df79$var$ma(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($2e7dd9641ea1df79$var$Za(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
}
function $2e7dd9641ea1df79$var$ab(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.ca && f.listener == b && f.capture == !!c && f.ia == d) return e;
    }
    return -1;
}
var $2e7dd9641ea1df79$var$cb = "closure_lm_" + (1E6 * Math.random() | 0), $2e7dd9641ea1df79$var$db = {};
function $2e7dd9641ea1df79$var$fb(a, b, c, d, e) {
    if (d && d.once) return $2e7dd9641ea1df79$var$gb(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$2e7dd9641ea1df79$var$fb(a, b[f], c, d, e);
        return null;
    }
    c = $2e7dd9641ea1df79$var$hb(c);
    return a && a[$2e7dd9641ea1df79$var$B] ? a.N(b, c, $2e7dd9641ea1df79$var$p(d) ? !!d.capture : !!d, e) : $2e7dd9641ea1df79$var$ib(a, b, c, !1, d, e);
}
function $2e7dd9641ea1df79$var$ib(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $2e7dd9641ea1df79$var$p(e) ? !!e.capture : !!e, n = $2e7dd9641ea1df79$var$jb(a);
    n || (a[$2e7dd9641ea1df79$var$cb] = n = new $2e7dd9641ea1df79$var$$a(a));
    c = n.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $2e7dd9641ea1df79$var$kb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $2e7dd9641ea1df79$var$Va || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($2e7dd9641ea1df79$var$lb(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $2e7dd9641ea1df79$var$kb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    var b = $2e7dd9641ea1df79$var$mb;
    return a;
}
function $2e7dd9641ea1df79$var$gb(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$2e7dd9641ea1df79$var$gb(a, b[f], c, d, e);
        return null;
    }
    c = $2e7dd9641ea1df79$var$hb(c);
    return a && a[$2e7dd9641ea1df79$var$B] ? a.O(b, c, $2e7dd9641ea1df79$var$p(d) ? !!d.capture : !!d, e) : $2e7dd9641ea1df79$var$ib(a, b, c, !0, d, e);
}
function $2e7dd9641ea1df79$var$nb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$2e7dd9641ea1df79$var$nb(a, b[f], c, d, e);
    else (d = $2e7dd9641ea1df79$var$p(d) ? !!d.capture : !!d, c = $2e7dd9641ea1df79$var$hb(c), a && a[$2e7dd9641ea1df79$var$B]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = $2e7dd9641ea1df79$var$ab(f, c, d, e), -1 < c && ($2e7dd9641ea1df79$var$Za(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = $2e7dd9641ea1df79$var$jb(a)) && (b = a.g[b.toString()], a = -1, b && (a = $2e7dd9641ea1df79$var$ab(b, c, d, e)), (c = -1 < a ? b[a] : null) && $2e7dd9641ea1df79$var$ob(c));
}
function $2e7dd9641ea1df79$var$ob(a) {
    if ("number" !== typeof a && a && !a.ca) {
        var b = a.src;
        if (b && b[$2e7dd9641ea1df79$var$B]) $2e7dd9641ea1df79$var$bb(b.i, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($2e7dd9641ea1df79$var$lb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $2e7dd9641ea1df79$var$jb(b)) ? ($2e7dd9641ea1df79$var$bb(c, a), 0 == c.h && (c.src = null, b[$2e7dd9641ea1df79$var$cb] = null)) : $2e7dd9641ea1df79$var$Za(a);
        }
    }
}
function $2e7dd9641ea1df79$var$lb(a) {
    return a in $2e7dd9641ea1df79$var$db ? $2e7dd9641ea1df79$var$db[a] : $2e7dd9641ea1df79$var$db[a] = "on" + a;
}
function $2e7dd9641ea1df79$var$mb(a, b) {
    if (a.ca) a = !0;
    else {
        b = new $2e7dd9641ea1df79$var$A(b, this);
        var c = a.listener, d = a.ia || a.src;
        a.fa && $2e7dd9641ea1df79$var$ob(a);
        a = c.call(d, b);
    }
    return a;
}
function $2e7dd9641ea1df79$var$jb(a) {
    a = a[$2e7dd9641ea1df79$var$cb];
    return a instanceof $2e7dd9641ea1df79$var$$a ? a : null;
}
var $2e7dd9641ea1df79$var$pb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $2e7dd9641ea1df79$var$hb(a) {
    if ("function" === typeof a) return a;
    a[$2e7dd9641ea1df79$var$pb] || (a[$2e7dd9641ea1df79$var$pb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$2e7dd9641ea1df79$var$pb];
}
function $2e7dd9641ea1df79$var$C() {
    $2e7dd9641ea1df79$var$v.call(this);
    this.i = new $2e7dd9641ea1df79$var$$a(this);
    this.P = this;
    this.I = null;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$C, $2e7dd9641ea1df79$var$v);
$2e7dd9641ea1df79$var$C.prototype[$2e7dd9641ea1df79$var$B] = !0;
$2e7dd9641ea1df79$var$C.prototype.removeEventListener = function(a, b, c, d) {
    $2e7dd9641ea1df79$var$nb(this, a, b, c, d);
};
function $2e7dd9641ea1df79$var$D(a, b) {
    var c, d = a.I;
    if (d) for(c = []; d; d = d.I)c.push(d);
    a = a.P;
    d = b.type || b;
    if ("string" === typeof b) b = new $2e7dd9641ea1df79$var$z(b, a);
    else if (b instanceof $2e7dd9641ea1df79$var$z) b.target = b.target || a;
    else {
        var e = b;
        b = new $2e7dd9641ea1df79$var$z(d, a);
        $2e7dd9641ea1df79$var$Aa(b, e);
    }
    e = !0;
    if (c) for(var f = c.length - 1; 0 <= f; f--){
        var h = b.g = c[f];
        e = $2e7dd9641ea1df79$var$qb(h, d, !0, b) && e;
    }
    h = b.g = a;
    e = $2e7dd9641ea1df79$var$qb(h, d, !0, b) && e;
    e = $2e7dd9641ea1df79$var$qb(h, d, !1, b) && e;
    if (c) for(f = 0; f < c.length; f++)h = b.g = c[f], e = $2e7dd9641ea1df79$var$qb(h, d, !1, b) && e;
}
$2e7dd9641ea1df79$var$C.prototype.M = function() {
    $2e7dd9641ea1df79$var$C.Z.M.call(this);
    if (this.i) {
        var a = this.i, c;
        for(c in a.g){
            for(var d = a.g[c], e = 0; e < d.length; e++)$2e7dd9641ea1df79$var$Za(d[e]);
            delete a.g[c];
            a.h--;
        }
    }
    this.I = null;
};
$2e7dd9641ea1df79$var$C.prototype.N = function(a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
};
$2e7dd9641ea1df79$var$C.prototype.O = function(a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
};
function $2e7dd9641ea1df79$var$qb(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.ca && h.capture == c) {
            var n = h.listener, u = h.ia || h.src;
            h.fa && $2e7dd9641ea1df79$var$bb(a.i, h);
            e = !1 !== n.call(u, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $2e7dd9641ea1df79$var$rb = $2e7dd9641ea1df79$var$l.JSON.stringify;
function $2e7dd9641ea1df79$var$sb() {
    var a = $2e7dd9641ea1df79$var$tb;
    var b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
}
var $2e7dd9641ea1df79$var$ub = /** @class */ function() {
    function ub() {
        this.h = this.g = null;
    }
    ub.prototype.add = function(a, b) {
        var c = $2e7dd9641ea1df79$var$vb.get();
        c.set(a, b);
        this.h ? this.h.next = c : this.g = c;
        this.h = c;
    };
    return ub;
}();
var $2e7dd9641ea1df79$var$vb = new /** @class */ (function() {
    function class_2(a, b) {
        this.i = a;
        this.j = b;
        this.h = 0;
        this.g = null;
    }
    class_2.prototype.get = function() {
        var a;
        0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
        return a;
    };
    return class_2;
}())(function() {
    return new $2e7dd9641ea1df79$var$wb;
}, function(a) {
    return a.reset();
});
var $2e7dd9641ea1df79$var$wb = /** @class */ function() {
    function wb() {
        this.next = this.g = this.h = null;
    }
    wb.prototype.set = function(a, b) {
        this.h = a;
        this.g = b;
        this.next = null;
    };
    wb.prototype.reset = function() {
        this.next = this.g = this.h = null;
    };
    return wb;
}();
function $2e7dd9641ea1df79$var$yb(a) {
    $2e7dd9641ea1df79$var$l.setTimeout(function() {
        throw a;
    }, 0);
}
function $2e7dd9641ea1df79$var$zb(a, b) {
    $2e7dd9641ea1df79$var$Ab || $2e7dd9641ea1df79$var$Bb();
    $2e7dd9641ea1df79$var$Cb || ($2e7dd9641ea1df79$var$Ab(), $2e7dd9641ea1df79$var$Cb = !0);
    $2e7dd9641ea1df79$var$tb.add(a, b);
}
var $2e7dd9641ea1df79$var$Ab;
function $2e7dd9641ea1df79$var$Bb() {
    var a = $2e7dd9641ea1df79$var$l.Promise.resolve(void 0);
    $2e7dd9641ea1df79$var$Ab = function() {
        a.then($2e7dd9641ea1df79$var$Db);
    };
}
var $2e7dd9641ea1df79$var$Cb = !1, $2e7dd9641ea1df79$var$tb = new $2e7dd9641ea1df79$var$ub;
function $2e7dd9641ea1df79$var$Db() {
    for(var a; a = $2e7dd9641ea1df79$var$sb();){
        try {
            a.h.call(a.g);
        } catch (c) {
            $2e7dd9641ea1df79$var$yb(c);
        }
        var b = $2e7dd9641ea1df79$var$vb;
        b.j(a);
        100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }
    $2e7dd9641ea1df79$var$Cb = !1;
}
function $2e7dd9641ea1df79$var$Eb(a, b) {
    $2e7dd9641ea1df79$var$C.call(this);
    this.h = a || 1;
    this.g = b || $2e7dd9641ea1df79$var$l;
    this.j = $2e7dd9641ea1df79$var$q(this.kb, this);
    this.l = Date.now();
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Eb, $2e7dd9641ea1df79$var$C);
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$Eb.prototype;
$2e7dd9641ea1df79$var$k.da = !1;
$2e7dd9641ea1df79$var$k.S = null;
$2e7dd9641ea1df79$var$k.kb = function() {
    if (this.da) {
        var a = Date.now() - this.l;
        0 < a && a < .8 * this.h ? this.S = this.g.setTimeout(this.j, this.h - a) : (this.S && (this.g.clearTimeout(this.S), this.S = null), $2e7dd9641ea1df79$var$D(this, "tick"), this.da && ($2e7dd9641ea1df79$var$Fb(this), this.start()));
    }
};
$2e7dd9641ea1df79$var$k.start = function() {
    this.da = !0;
    this.S || (this.S = this.g.setTimeout(this.j, this.h), this.l = Date.now());
};
function $2e7dd9641ea1df79$var$Fb(a) {
    a.da = !1;
    a.S && (a.g.clearTimeout(a.S), a.S = null);
}
$2e7dd9641ea1df79$var$k.M = function() {
    $2e7dd9641ea1df79$var$Eb.Z.M.call(this);
    $2e7dd9641ea1df79$var$Fb(this);
    delete this.g;
};
function $2e7dd9641ea1df79$var$Gb(a, b, c) {
    if ("function" === typeof a) c && (a = $2e7dd9641ea1df79$var$q(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $2e7dd9641ea1df79$var$q(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $2e7dd9641ea1df79$var$l.setTimeout(a, b || 0);
}
function $2e7dd9641ea1df79$var$Hb(a) {
    a.g = $2e7dd9641ea1df79$var$Gb(function() {
        a.g = null;
        a.i && (a.i = !1, $2e7dd9641ea1df79$var$Hb(a));
    }, a.j);
    var b = a.h;
    a.h = null;
    a.m.apply(null, b);
}
var $2e7dd9641ea1df79$var$Ib = /** @class */ function(_super) {
    $2e7dd9641ea1df79$var$__extends(Ib, _super);
    function Ib(a, b) {
        var _this = _super.call(this) || this;
        _this.m = a;
        _this.j = b;
        _this.h = null;
        _this.i = !1;
        _this.g = null;
        return _this;
    }
    Ib.prototype.l = function(a) {
        this.h = arguments;
        this.g ? this.i = !0 : $2e7dd9641ea1df79$var$Hb(this);
    };
    Ib.prototype.M = function() {
        _super.prototype.M.call(this);
        this.g && ($2e7dd9641ea1df79$var$l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    };
    return Ib;
}($2e7dd9641ea1df79$var$v);
function $2e7dd9641ea1df79$var$E(a) {
    $2e7dd9641ea1df79$var$v.call(this);
    this.h = a;
    this.g = {};
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$E, $2e7dd9641ea1df79$var$v);
var $2e7dd9641ea1df79$var$Jb = [];
function $2e7dd9641ea1df79$var$Kb(a, b, c, d) {
    Array.isArray(c) || (c && ($2e7dd9641ea1df79$var$Jb[0] = c.toString()), c = $2e7dd9641ea1df79$var$Jb);
    for(var e = 0; e < c.length; e++){
        var f = $2e7dd9641ea1df79$var$fb(b, c[e], d || a.handleEvent, !1, a.h || a);
        if (!f) break;
        a.g[f.key] = f;
    }
}
function $2e7dd9641ea1df79$var$Lb(a) {
    $2e7dd9641ea1df79$var$xa(a.g, function(b, c) {
        this.g.hasOwnProperty(c) && $2e7dd9641ea1df79$var$ob(b);
    }, a);
    a.g = {};
}
$2e7dd9641ea1df79$var$E.prototype.M = function() {
    $2e7dd9641ea1df79$var$E.Z.M.call(this);
    $2e7dd9641ea1df79$var$Lb(this);
};
$2e7dd9641ea1df79$var$E.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $2e7dd9641ea1df79$var$Mb() {
    this.g = !0;
}
$2e7dd9641ea1df79$var$Mb.prototype.Aa = function() {
    this.g = !1;
};
function $2e7dd9641ea1df79$var$Nb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.g) {
            if (f) {
                var h = "";
                for(var n = f.split("&"), u = 0; u < n.length; u++){
                    var m = n[u].split("=");
                    if (1 < m.length) {
                        var r = m[0];
                        m = m[1];
                        var G = r.split("_");
                        h = 2 <= G.length && "type" == G[1] ? h + (r + "=" + m + "&") : h + (r + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $2e7dd9641ea1df79$var$Ob(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $2e7dd9641ea1df79$var$F(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $2e7dd9641ea1df79$var$Pb(a, c) + (d ? " " + d : "");
    });
}
function $2e7dd9641ea1df79$var$Qb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$2e7dd9641ea1df79$var$Mb.prototype.info = function() {};
function $2e7dd9641ea1df79$var$Pb(a, b) {
    if (!a.g) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $2e7dd9641ea1df79$var$rb(c);
    } catch (n) {
        return b;
    }
}
var $2e7dd9641ea1df79$var$H = {}, $2e7dd9641ea1df79$var$Rb = null;
function $2e7dd9641ea1df79$var$Sb() {
    return $2e7dd9641ea1df79$var$Rb = $2e7dd9641ea1df79$var$Rb || new $2e7dd9641ea1df79$var$C;
}
$2e7dd9641ea1df79$var$H.Ma = "serverreachability";
function $2e7dd9641ea1df79$var$Tb(a) {
    $2e7dd9641ea1df79$var$z.call(this, $2e7dd9641ea1df79$var$H.Ma, a);
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Tb, $2e7dd9641ea1df79$var$z);
function $2e7dd9641ea1df79$var$I(a) {
    var b = $2e7dd9641ea1df79$var$Sb();
    $2e7dd9641ea1df79$var$D(b, new $2e7dd9641ea1df79$var$Tb(b, a));
}
$2e7dd9641ea1df79$var$H.STAT_EVENT = "statevent";
function $2e7dd9641ea1df79$var$Ub(a, b) {
    $2e7dd9641ea1df79$var$z.call(this, $2e7dd9641ea1df79$var$H.STAT_EVENT, a);
    this.stat = b;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Ub, $2e7dd9641ea1df79$var$z);
function $2e7dd9641ea1df79$var$J(a) {
    var b = $2e7dd9641ea1df79$var$Sb();
    $2e7dd9641ea1df79$var$D(b, new $2e7dd9641ea1df79$var$Ub(b, a));
}
$2e7dd9641ea1df79$var$H.Na = "timingevent";
function $2e7dd9641ea1df79$var$Vb(a, b) {
    $2e7dd9641ea1df79$var$z.call(this, $2e7dd9641ea1df79$var$H.Na, a);
    this.size = b;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Vb, $2e7dd9641ea1df79$var$z);
function $2e7dd9641ea1df79$var$K(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return $2e7dd9641ea1df79$var$l.setTimeout(function() {
        a();
    }, b);
}
var $2e7dd9641ea1df79$var$Wb = {
    NO_ERROR: 0,
    lb: 1,
    yb: 2,
    xb: 3,
    sb: 4,
    wb: 5,
    zb: 6,
    Ja: 7,
    TIMEOUT: 8,
    Cb: 9
};
var $2e7dd9641ea1df79$var$Xb = {
    qb: "complete",
    Mb: "success",
    Ka: "error",
    Ja: "abort",
    Eb: "ready",
    Fb: "readystatechange",
    TIMEOUT: "timeout",
    Ab: "incrementaldata",
    Db: "progress",
    tb: "downloadprogress",
    Ub: "uploadprogress"
};
function $2e7dd9641ea1df79$var$Yb() {}
$2e7dd9641ea1df79$var$Yb.prototype.h = null;
function $2e7dd9641ea1df79$var$Zb(a) {
    return a.h || (a.h = a.i());
}
function $2e7dd9641ea1df79$var$$b() {}
var $2e7dd9641ea1df79$var$L = {
    OPEN: "a",
    pb: "b",
    Ka: "c",
    Bb: "d"
};
function $2e7dd9641ea1df79$var$ac() {
    $2e7dd9641ea1df79$var$z.call(this, "d");
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$ac, $2e7dd9641ea1df79$var$z);
function $2e7dd9641ea1df79$var$bc() {
    $2e7dd9641ea1df79$var$z.call(this, "c");
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$bc, $2e7dd9641ea1df79$var$z);
var $2e7dd9641ea1df79$var$cc;
function $2e7dd9641ea1df79$var$dc() {}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$dc, $2e7dd9641ea1df79$var$Yb);
$2e7dd9641ea1df79$var$dc.prototype.g = function() {
    return new XMLHttpRequest;
};
$2e7dd9641ea1df79$var$dc.prototype.i = function() {
    return {};
};
$2e7dd9641ea1df79$var$cc = new $2e7dd9641ea1df79$var$dc;
function $2e7dd9641ea1df79$var$M(a, b, c, d) {
    this.l = a;
    this.j = b;
    this.m = c;
    this.X = d || 1;
    this.V = new $2e7dd9641ea1df79$var$E(this);
    this.P = $2e7dd9641ea1df79$var$ec;
    a = $2e7dd9641ea1df79$var$Ja ? 125 : void 0;
    this.W = new $2e7dd9641ea1df79$var$Eb(a);
    this.H = null;
    this.i = !1;
    this.s = this.A = this.v = this.K = this.F = this.Y = this.B = null;
    this.D = [];
    this.g = null;
    this.C = 0;
    this.o = this.u = null;
    this.N = -1;
    this.I = !1;
    this.O = 0;
    this.L = null;
    this.aa = this.J = this.$ = this.U = !1;
    this.h = new $2e7dd9641ea1df79$var$fc;
}
function $2e7dd9641ea1df79$var$fc() {
    this.i = null;
    this.g = "";
    this.h = !1;
}
var $2e7dd9641ea1df79$var$ec = 45E3, $2e7dd9641ea1df79$var$gc = {}, $2e7dd9641ea1df79$var$hc = {};
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$M.prototype;
$2e7dd9641ea1df79$var$k.setTimeout = function(a) {
    this.P = a;
};
function $2e7dd9641ea1df79$var$ic(a, b, c) {
    a.K = 1;
    a.v = $2e7dd9641ea1df79$var$jc($2e7dd9641ea1df79$var$N(b));
    a.s = c;
    a.U = !0;
    $2e7dd9641ea1df79$var$kc(a, null);
}
function $2e7dd9641ea1df79$var$kc(a, b) {
    a.F = Date.now();
    $2e7dd9641ea1df79$var$lc(a);
    a.A = $2e7dd9641ea1df79$var$N(a.v);
    var c = a.A, d = a.X;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $2e7dd9641ea1df79$var$mc(c.h, "t", d);
    a.C = 0;
    c = a.l.H;
    a.h = new $2e7dd9641ea1df79$var$fc;
    a.g = $2e7dd9641ea1df79$var$nc(a.l, c ? b : null, !a.s);
    0 < a.O && (a.L = new $2e7dd9641ea1df79$var$Ib($2e7dd9641ea1df79$var$q(a.Ia, a, a.g), a.O));
    $2e7dd9641ea1df79$var$Kb(a.V, a.g, "readystatechange", a.gb);
    b = a.H ? $2e7dd9641ea1df79$var$ya(a.H) : {};
    a.s ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.s, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
    $2e7dd9641ea1df79$var$I(1);
    $2e7dd9641ea1df79$var$Nb(a.j, a.u, a.A, a.m, a.X, a.s);
}
$2e7dd9641ea1df79$var$k.gb = function(a) {
    a = a.target;
    var b = this.L;
    b && 3 == $2e7dd9641ea1df79$var$O(a) ? b.l() : this.Ia(a);
};
$2e7dd9641ea1df79$var$k.Ia = function(a) {
    try {
        if (a == this.g) a: {
            var r = $2e7dd9641ea1df79$var$O(this.g);
            var b = this.g.Da();
            var G = this.g.ba();
            if (!(3 > r) && (3 != r || $2e7dd9641ea1df79$var$Ja || this.g && (this.h.h || this.g.ga() || $2e7dd9641ea1df79$var$oc(this.g)))) {
                this.I || 4 != r || 7 == b || (8 == b || 0 >= G ? $2e7dd9641ea1df79$var$I(3) : $2e7dd9641ea1df79$var$I(2));
                $2e7dd9641ea1df79$var$pc(this);
                var c = this.g.ba();
                this.N = c;
                b: if ($2e7dd9641ea1df79$var$qc(this)) {
                    var d = $2e7dd9641ea1df79$var$oc(this.g);
                    a = "";
                    var e = d.length, f = 4 == $2e7dd9641ea1df79$var$O(this.g);
                    if (!this.h.i) {
                        if ("undefined" === typeof TextDecoder) {
                            $2e7dd9641ea1df79$var$P(this);
                            $2e7dd9641ea1df79$var$rc(this);
                            var h = "";
                            break b;
                        }
                        this.h.i = new $2e7dd9641ea1df79$var$l.TextDecoder;
                    }
                    for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                        stream: f && b == e - 1
                    });
                    d.splice(0, e);
                    this.h.g += a;
                    this.C = 0;
                    h = this.h.g;
                } else h = this.g.ga();
                this.i = 200 == c;
                $2e7dd9641ea1df79$var$Ob(this.j, this.u, this.A, this.m, this.X, r, c);
                if (this.i) {
                    if (this.$ && !this.J) {
                        b: {
                            if (this.g) {
                                var n, u = this.g;
                                if ((n = u.g ? u.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !$2e7dd9641ea1df79$var$sa(n)) {
                                    var m = n;
                                    break b;
                                }
                            }
                            m = null;
                        }
                        if (c = m) $2e7dd9641ea1df79$var$F(this.j, this.m, c, "Initial handshake response via X-HTTP-Initial-Response"), this.J = !0, $2e7dd9641ea1df79$var$sc(this, c);
                        else {
                            this.i = !1;
                            this.o = 3;
                            $2e7dd9641ea1df79$var$J(12);
                            $2e7dd9641ea1df79$var$P(this);
                            $2e7dd9641ea1df79$var$rc(this);
                            break a;
                        }
                    }
                    this.U ? ($2e7dd9641ea1df79$var$tc(this, r, h), $2e7dd9641ea1df79$var$Ja && this.i && 3 == r && ($2e7dd9641ea1df79$var$Kb(this.V, this.W, "tick", this.fb), this.W.start())) : ($2e7dd9641ea1df79$var$F(this.j, this.m, h, null), $2e7dd9641ea1df79$var$sc(this, h));
                    4 == r && $2e7dd9641ea1df79$var$P(this);
                    this.i && !this.I && (4 == r ? $2e7dd9641ea1df79$var$uc(this.l, this) : (this.i = !1, $2e7dd9641ea1df79$var$lc(this)));
                } else 400 == c && 0 < h.indexOf("Unknown SID") ? (this.o = 3, $2e7dd9641ea1df79$var$J(12)) : (this.o = 0, $2e7dd9641ea1df79$var$J(13)), $2e7dd9641ea1df79$var$P(this), $2e7dd9641ea1df79$var$rc(this);
            }
        }
    } catch (r) {} finally{}
};
function $2e7dd9641ea1df79$var$qc(a) {
    return a.g ? "GET" == a.u && 2 != a.K && a.l.Ba : !1;
}
function $2e7dd9641ea1df79$var$tc(a, b, c) {
    var d = !0, e;
    for(; !a.I && a.C < c.length;)if (e = $2e7dd9641ea1df79$var$vc(a, c), e == $2e7dd9641ea1df79$var$hc) {
        4 == b && (a.o = 4, $2e7dd9641ea1df79$var$J(14), d = !1);
        $2e7dd9641ea1df79$var$F(a.j, a.m, null, "[Incomplete Response]");
        break;
    } else if (e == $2e7dd9641ea1df79$var$gc) {
        a.o = 4;
        $2e7dd9641ea1df79$var$J(15);
        $2e7dd9641ea1df79$var$F(a.j, a.m, c, "[Invalid Chunk]");
        d = !1;
        break;
    } else $2e7dd9641ea1df79$var$F(a.j, a.m, e, null), $2e7dd9641ea1df79$var$sc(a, e);
    $2e7dd9641ea1df79$var$qc(a) && e != $2e7dd9641ea1df79$var$hc && e != $2e7dd9641ea1df79$var$gc && (a.h.g = "", a.C = 0);
    4 != b || 0 != c.length || a.h.h || (a.o = 1, $2e7dd9641ea1df79$var$J(16), d = !1);
    a.i = a.i && d;
    d ? 0 < c.length && !a.aa && (a.aa = !0, b = a.l, b.g == a && b.$ && !b.L && (b.h.info("Great, no buffering proxy detected. Bytes received: " + c.length), $2e7dd9641ea1df79$var$wc(b), b.L = !0, $2e7dd9641ea1df79$var$J(11))) : ($2e7dd9641ea1df79$var$F(a.j, a.m, c, "[Invalid Chunked Response]"), $2e7dd9641ea1df79$var$P(a), $2e7dd9641ea1df79$var$rc(a));
}
$2e7dd9641ea1df79$var$k.fb = function() {
    if (this.g) {
        var a = $2e7dd9641ea1df79$var$O(this.g), b = this.g.ga();
        this.C < b.length && ($2e7dd9641ea1df79$var$pc(this), $2e7dd9641ea1df79$var$tc(this, a, b), this.i && 4 != a && $2e7dd9641ea1df79$var$lc(this));
    }
};
function $2e7dd9641ea1df79$var$vc(a, b) {
    var c = a.C, d = b.indexOf("\n", c);
    if (-1 == d) return $2e7dd9641ea1df79$var$hc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $2e7dd9641ea1df79$var$gc;
    d += 1;
    if (d + c > b.length) return $2e7dd9641ea1df79$var$hc;
    b = b.substr(d, c);
    a.C = d + c;
    return b;
}
$2e7dd9641ea1df79$var$k.cancel = function() {
    this.I = !0;
    $2e7dd9641ea1df79$var$P(this);
};
function $2e7dd9641ea1df79$var$lc(a) {
    a.Y = Date.now() + a.P;
    $2e7dd9641ea1df79$var$xc(a, a.P);
}
function $2e7dd9641ea1df79$var$xc(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = $2e7dd9641ea1df79$var$K($2e7dd9641ea1df79$var$q(a.eb, a), b);
}
function $2e7dd9641ea1df79$var$pc(a) {
    a.B && ($2e7dd9641ea1df79$var$l.clearTimeout(a.B), a.B = null);
}
$2e7dd9641ea1df79$var$k.eb = function() {
    this.B = null;
    var a = Date.now();
    0 <= a - this.Y ? ($2e7dd9641ea1df79$var$Qb(this.j, this.A), 2 != this.K && ($2e7dd9641ea1df79$var$I(3), $2e7dd9641ea1df79$var$J(17)), $2e7dd9641ea1df79$var$P(this), this.o = 2, $2e7dd9641ea1df79$var$rc(this)) : $2e7dd9641ea1df79$var$xc(this, this.Y - a);
};
function $2e7dd9641ea1df79$var$rc(a) {
    0 == a.l.G || a.I || $2e7dd9641ea1df79$var$uc(a.l, a);
}
function $2e7dd9641ea1df79$var$P(a) {
    $2e7dd9641ea1df79$var$pc(a);
    var b = a.L;
    b && "function" == typeof b.na && b.na();
    a.L = null;
    $2e7dd9641ea1df79$var$Fb(a.W);
    $2e7dd9641ea1df79$var$Lb(a.V);
    a.g && (b = a.g, a.g = null, b.abort(), b.na());
}
function $2e7dd9641ea1df79$var$sc(a, b) {
    try {
        var c = a.l;
        if (0 != c.G && (c.g == a || $2e7dd9641ea1df79$var$yc(c.i, a))) {
            if (c.I = a.N, !a.J && $2e7dd9641ea1df79$var$yc(c.i, a) && 3 == c.G) {
                try {
                    var d = c.Ca.g.parse(b);
                } catch (m) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.u) {
                            if (c.g) {
                                if (c.g.F + 3E3 < a.F) $2e7dd9641ea1df79$var$zc(c), $2e7dd9641ea1df79$var$Ac(c);
                                else break a;
                            }
                            $2e7dd9641ea1df79$var$Bc(c);
                            $2e7dd9641ea1df79$var$J(18);
                        }
                    } else c.ta = e[1], 0 < c.ta - c.U && 37500 > e[2] && c.N && 0 == c.A && !c.v && (c.v = $2e7dd9641ea1df79$var$K($2e7dd9641ea1df79$var$q(c.ab, c), 6E3));
                    if (1 >= $2e7dd9641ea1df79$var$Cc(c.i) && c.ka) {
                        try {
                            c.ka();
                        } catch (m) {}
                        c.ka = void 0;
                    }
                } else $2e7dd9641ea1df79$var$Q(c, 11);
            } else if ((a.J || c.g == a) && $2e7dd9641ea1df79$var$zc(c), !$2e7dd9641ea1df79$var$sa(b)) for(e = c.Ca.g.parse(b), b = 0; b < e.length; b++){
                var m = e[b];
                c.U = m[0];
                m = m[1];
                if (2 == c.G) {
                    if ("c" == m[0]) {
                        c.J = m[1];
                        c.la = m[2];
                        var r = m[3];
                        null != r && (c.ma = r, c.h.info("VER=" + c.ma));
                        var G = m[4];
                        null != G && (c.za = G, c.h.info("SVER=" + c.za));
                        var Da = m[5];
                        null != Da && "number" === typeof Da && 0 < Da && (d = 1.5 * Da, c.K = d, c.h.info("backChannelRequestTimeoutMs_=" + d));
                        d = c;
                        var ca = a.g;
                        if (ca) {
                            var Ea = ca.g ? ca.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                            if (Ea) {
                                var f = d.i;
                                !f.g && ($2e7dd9641ea1df79$var$w(Ea, "spdy") || $2e7dd9641ea1df79$var$w(Ea, "quic") || $2e7dd9641ea1df79$var$w(Ea, "h2")) && (f.j = f.l, f.g = new Set, f.h && ($2e7dd9641ea1df79$var$Dc(f, f.h), f.h = null));
                            }
                            if (d.D) {
                                var xb = ca.g ? ca.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                xb && (d.sa = xb, $2e7dd9641ea1df79$var$R(d.F, d.D, xb));
                            }
                        }
                        c.G = 3;
                        c.j && c.j.xa();
                        c.$ && (c.O = Date.now() - a.F, c.h.info("Handshake RTT: " + c.O + "ms"));
                        d = c;
                        var h = a;
                        d.oa = $2e7dd9641ea1df79$var$Ec(d, d.H ? d.la : null, d.W);
                        if (h.J) {
                            $2e7dd9641ea1df79$var$Fc(d.i, h);
                            var n = h, u = d.K;
                            u && n.setTimeout(u);
                            n.B && ($2e7dd9641ea1df79$var$pc(n), $2e7dd9641ea1df79$var$lc(n));
                            d.g = h;
                        } else $2e7dd9641ea1df79$var$Gc(d);
                        0 < c.l.length && $2e7dd9641ea1df79$var$Hc(c);
                    } else "stop" != m[0] && "close" != m[0] || $2e7dd9641ea1df79$var$Q(c, 7);
                } else 3 == c.G && ("stop" == m[0] || "close" == m[0] ? "stop" == m[0] ? $2e7dd9641ea1df79$var$Q(c, 7) : $2e7dd9641ea1df79$var$Ic(c) : "noop" != m[0] && c.j && c.j.wa(m), c.A = 0);
            }
        }
        $2e7dd9641ea1df79$var$I(4);
    } catch (m) {}
}
function $2e7dd9641ea1df79$var$Jc(a) {
    if (a.R && "function" == typeof a.R) return a.R();
    if ("string" === typeof a) return a.split("");
    if ($2e7dd9641ea1df79$var$ba(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return b;
}
function $2e7dd9641ea1df79$var$Kc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($2e7dd9641ea1df79$var$ba(a) || "string" === typeof a) $2e7dd9641ea1df79$var$na(a, b, void 0);
    else {
        if (a.T && "function" == typeof a.T) var c = a.T();
        else if (a.R && "function" == typeof a.R) c = void 0;
        else if ($2e7dd9641ea1df79$var$ba(a) || "string" === typeof a) {
            c = [];
            for(var d = a.length, e = 0; e < d; e++)c.push(e);
        } else for(e in c = [], d = 0, a)c[d++] = e;
        d = $2e7dd9641ea1df79$var$Jc(a);
        e = d.length;
        for(var f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
}
function $2e7dd9641ea1df79$var$S(a, b) {
    this.h = {};
    this.g = [];
    this.i = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else if (a) {
        if (a instanceof $2e7dd9641ea1df79$var$S) for(c = a.T(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
        else for(d in a)this.set(d, a[d]);
    }
}
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$S.prototype;
$2e7dd9641ea1df79$var$k.R = function() {
    $2e7dd9641ea1df79$var$Lc(this);
    for(var a = [], b = 0; b < this.g.length; b++)a.push(this.h[this.g[b]]);
    return a;
};
$2e7dd9641ea1df79$var$k.T = function() {
    $2e7dd9641ea1df79$var$Lc(this);
    return this.g.concat();
};
function $2e7dd9641ea1df79$var$Lc(a) {
    if (a.i != a.g.length) {
        for(var b = 0, c = 0; b < a.g.length;){
            var d = a.g[b];
            $2e7dd9641ea1df79$var$T(a.h, d) && (a.g[c++] = d);
            b++;
        }
        a.g.length = c;
    }
    if (a.i != a.g.length) {
        var e = {};
        for(c = b = 0; b < a.g.length;)d = a.g[b], $2e7dd9641ea1df79$var$T(e, d) || (a.g[c++] = d, e[d] = 1), b++;
        a.g.length = c;
    }
}
$2e7dd9641ea1df79$var$k.get = function(a, b) {
    return $2e7dd9641ea1df79$var$T(this.h, a) ? this.h[a] : b;
};
$2e7dd9641ea1df79$var$k.set = function(a, b) {
    $2e7dd9641ea1df79$var$T(this.h, a) || (this.i++, this.g.push(a));
    this.h[a] = b;
};
$2e7dd9641ea1df79$var$k.forEach = function(a, b) {
    for(var c = this.T(), d = 0; d < c.length; d++){
        var e = c[d], f = this.get(e);
        a.call(b, f, e, this);
    }
};
function $2e7dd9641ea1df79$var$T(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var $2e7dd9641ea1df79$var$Mc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function $2e7dd9641ea1df79$var$Nc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $2e7dd9641ea1df79$var$U(a, b) {
    this.i = this.s = this.j = "";
    this.m = null;
    this.o = this.l = "";
    this.g = !1;
    if (a instanceof $2e7dd9641ea1df79$var$U) {
        this.g = void 0 !== b ? b : a.g;
        $2e7dd9641ea1df79$var$Oc(this, a.j);
        this.s = a.s;
        $2e7dd9641ea1df79$var$Pc(this, a.i);
        $2e7dd9641ea1df79$var$Qc(this, a.m);
        this.l = a.l;
        b = a.h;
        var c = new $2e7dd9641ea1df79$var$Rc;
        c.i = b.i;
        b.g && (c.g = new $2e7dd9641ea1df79$var$S(b.g), c.h = b.h);
        $2e7dd9641ea1df79$var$Sc(this, c);
        this.o = a.o;
    } else a && (c = String(a).match($2e7dd9641ea1df79$var$Mc)) ? (this.g = !!b, $2e7dd9641ea1df79$var$Oc(this, c[1] || "", !0), this.s = $2e7dd9641ea1df79$var$Tc(c[2] || ""), $2e7dd9641ea1df79$var$Pc(this, c[3] || "", !0), $2e7dd9641ea1df79$var$Qc(this, c[4]), this.l = $2e7dd9641ea1df79$var$Tc(c[5] || "", !0), $2e7dd9641ea1df79$var$Sc(this, c[6] || "", !0), this.o = $2e7dd9641ea1df79$var$Tc(c[7] || "")) : (this.g = !!b, this.h = new $2e7dd9641ea1df79$var$Rc(null, this.g));
}
$2e7dd9641ea1df79$var$U.prototype.toString = function() {
    var a = [], b = this.j;
    b && a.push($2e7dd9641ea1df79$var$Uc(b, $2e7dd9641ea1df79$var$Vc, !0), ":");
    var c = this.i;
    if (c || "file" == b) a.push("//"), (b = this.s) && a.push($2e7dd9641ea1df79$var$Uc(b, $2e7dd9641ea1df79$var$Vc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));
    if (c = this.l) this.i && "/" != c.charAt(0) && a.push("/"), a.push($2e7dd9641ea1df79$var$Uc(c, "/" == c.charAt(0) ? $2e7dd9641ea1df79$var$Wc : $2e7dd9641ea1df79$var$Xc, !0));
    (c = this.h.toString()) && a.push("?", c);
    (c = this.o) && a.push("#", $2e7dd9641ea1df79$var$Uc(c, $2e7dd9641ea1df79$var$Yc));
    return a.join("");
};
function $2e7dd9641ea1df79$var$N(a) {
    return new $2e7dd9641ea1df79$var$U(a);
}
function $2e7dd9641ea1df79$var$Oc(a, b, c) {
    a.j = c ? $2e7dd9641ea1df79$var$Tc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
}
function $2e7dd9641ea1df79$var$Pc(a, b, c) {
    a.i = c ? $2e7dd9641ea1df79$var$Tc(b, !0) : b;
}
function $2e7dd9641ea1df79$var$Qc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.m = b;
    } else a.m = null;
}
function $2e7dd9641ea1df79$var$Sc(a, b, c) {
    b instanceof $2e7dd9641ea1df79$var$Rc ? (a.h = b, $2e7dd9641ea1df79$var$Zc(a.h, a.g)) : (c || (b = $2e7dd9641ea1df79$var$Uc(b, $2e7dd9641ea1df79$var$$c)), a.h = new $2e7dd9641ea1df79$var$Rc(b, a.g));
}
function $2e7dd9641ea1df79$var$R(a, b, c) {
    a.h.set(b, c);
}
function $2e7dd9641ea1df79$var$jc(a) {
    $2e7dd9641ea1df79$var$R(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
}
function $2e7dd9641ea1df79$var$ad(a) {
    return a instanceof $2e7dd9641ea1df79$var$U ? $2e7dd9641ea1df79$var$N(a) : new $2e7dd9641ea1df79$var$U(a, void 0);
}
function $2e7dd9641ea1df79$var$bd(a, b, c, d) {
    var e = new $2e7dd9641ea1df79$var$U(null, void 0);
    a && $2e7dd9641ea1df79$var$Oc(e, a);
    b && $2e7dd9641ea1df79$var$Pc(e, b);
    c && $2e7dd9641ea1df79$var$Qc(e, c);
    d && (e.l = d);
    return e;
}
function $2e7dd9641ea1df79$var$Tc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $2e7dd9641ea1df79$var$Uc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $2e7dd9641ea1df79$var$cd), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $2e7dd9641ea1df79$var$cd(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $2e7dd9641ea1df79$var$Vc = /[#\/\?@]/g, $2e7dd9641ea1df79$var$Xc = /[#\?:]/g, $2e7dd9641ea1df79$var$Wc = /[#\?]/g, $2e7dd9641ea1df79$var$$c = /[#\?@]/g, $2e7dd9641ea1df79$var$Yc = /#/g;
function $2e7dd9641ea1df79$var$Rc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
}
function $2e7dd9641ea1df79$var$V(a) {
    a.g || (a.g = new $2e7dd9641ea1df79$var$S, a.h = 0, a.i && $2e7dd9641ea1df79$var$Nc(a.i, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$Rc.prototype;
$2e7dd9641ea1df79$var$k.add = function(a, b) {
    $2e7dd9641ea1df79$var$V(this);
    this.i = null;
    a = $2e7dd9641ea1df79$var$W(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
};
function $2e7dd9641ea1df79$var$dd(a, b) {
    $2e7dd9641ea1df79$var$V(a);
    b = $2e7dd9641ea1df79$var$W(a, b);
    $2e7dd9641ea1df79$var$T(a.g.h, b) && (a.i = null, a.h -= a.g.get(b).length, a = a.g, $2e7dd9641ea1df79$var$T(a.h, b) && (delete a.h[b], a.i--, a.g.length > 2 * a.i && $2e7dd9641ea1df79$var$Lc(a)));
}
function $2e7dd9641ea1df79$var$ed(a, b) {
    $2e7dd9641ea1df79$var$V(a);
    b = $2e7dd9641ea1df79$var$W(a, b);
    return $2e7dd9641ea1df79$var$T(a.g.h, b);
}
$2e7dd9641ea1df79$var$k.forEach = function(a, b) {
    $2e7dd9641ea1df79$var$V(this);
    this.g.forEach(function(c, d) {
        $2e7dd9641ea1df79$var$na(c, function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$2e7dd9641ea1df79$var$k.T = function() {
    $2e7dd9641ea1df79$var$V(this);
    for(var a = this.g.R(), b = this.g.T(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
    return c;
};
$2e7dd9641ea1df79$var$k.R = function(a) {
    $2e7dd9641ea1df79$var$V(this);
    var b = [];
    if ("string" === typeof a) $2e7dd9641ea1df79$var$ed(this, a) && (b = $2e7dd9641ea1df79$var$qa(b, this.g.get($2e7dd9641ea1df79$var$W(this, a))));
    else {
        a = this.g.R();
        for(var c = 0; c < a.length; c++)b = $2e7dd9641ea1df79$var$qa(b, a[c]);
    }
    return b;
};
$2e7dd9641ea1df79$var$k.set = function(a, b) {
    $2e7dd9641ea1df79$var$V(this);
    this.i = null;
    a = $2e7dd9641ea1df79$var$W(this, a);
    $2e7dd9641ea1df79$var$ed(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [
        b
    ]);
    this.h += 1;
    return this;
};
$2e7dd9641ea1df79$var$k.get = function(a, b) {
    if (!a) return b;
    a = this.R(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $2e7dd9641ea1df79$var$mc(a, b, c) {
    $2e7dd9641ea1df79$var$dd(a, b);
    0 < c.length && (a.i = null, a.g.set($2e7dd9641ea1df79$var$W(a, b), $2e7dd9641ea1df79$var$ra(c)), a.h += c.length);
}
$2e7dd9641ea1df79$var$k.toString = function() {
    if (this.i) return this.i;
    if (!this.g) return "";
    for(var a = [], b = this.g.T(), c = 0; c < b.length; c++){
        var d = b[c], e = encodeURIComponent(String(d));
        d = this.R(d);
        for(var f = 0; f < d.length; f++){
            var h = e;
            "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
            a.push(h);
        }
    }
    return this.i = a.join("&");
};
function $2e7dd9641ea1df79$var$W(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
}
function $2e7dd9641ea1df79$var$Zc(a, b) {
    b && !a.j && ($2e7dd9641ea1df79$var$V(a), a.i = null, a.g.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($2e7dd9641ea1df79$var$dd(this, d), $2e7dd9641ea1df79$var$mc(this, e, c));
    }, a));
    a.j = b;
}
var $2e7dd9641ea1df79$var$fd = /** @class */ function() {
    function fd(a, b) {
        this.h = a;
        this.g = b;
    }
    return fd;
}();
function $2e7dd9641ea1df79$var$gd(a) {
    this.l = a || $2e7dd9641ea1df79$var$hd;
    $2e7dd9641ea1df79$var$l.PerformanceNavigationTiming ? (a = $2e7dd9641ea1df79$var$l.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($2e7dd9641ea1df79$var$l.g && $2e7dd9641ea1df79$var$l.g.Ea && $2e7dd9641ea1df79$var$l.g.Ea() && $2e7dd9641ea1df79$var$l.g.Ea().Zb);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set);
    this.h = null;
    this.i = [];
}
var $2e7dd9641ea1df79$var$hd = 10;
function $2e7dd9641ea1df79$var$id(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
}
function $2e7dd9641ea1df79$var$Cc(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
}
function $2e7dd9641ea1df79$var$yc(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
}
function $2e7dd9641ea1df79$var$Dc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
}
function $2e7dd9641ea1df79$var$Fc(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
}
$2e7dd9641ea1df79$var$gd.prototype.cancel = function() {
    var e_1, _a;
    this.i = $2e7dd9641ea1df79$var$jd(this);
    if (this.h) this.h.cancel(), this.h = null;
    else if (this.g && 0 !== this.g.size) {
        try {
            for(var _b = $2e7dd9641ea1df79$var$__values(this.g.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var a = _c.value;
                a.cancel();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.g.clear();
    }
};
function $2e7dd9641ea1df79$var$jd(a) {
    var e_2, _a;
    if (null != a.h) return a.i.concat(a.h.D);
    if (null != a.g && 0 !== a.g.size) {
        var b = a.i;
        try {
            for(var _b = $2e7dd9641ea1df79$var$__values(a.g.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var c = _c.value;
                b = b.concat(c.D);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return b;
    }
    return $2e7dd9641ea1df79$var$ra(a.i);
}
function $2e7dd9641ea1df79$var$kd() {}
$2e7dd9641ea1df79$var$kd.prototype.stringify = function(a) {
    return $2e7dd9641ea1df79$var$l.JSON.stringify(a, void 0);
};
$2e7dd9641ea1df79$var$kd.prototype.parse = function(a) {
    return $2e7dd9641ea1df79$var$l.JSON.parse(a, void 0);
};
function $2e7dd9641ea1df79$var$ld() {
    this.g = new $2e7dd9641ea1df79$var$kd;
}
function $2e7dd9641ea1df79$var$md(a, b, c) {
    var d = c || "";
    try {
        $2e7dd9641ea1df79$var$Kc(a, function(e, f) {
            var h = e;
            $2e7dd9641ea1df79$var$p(e) && (h = $2e7dd9641ea1df79$var$rb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $2e7dd9641ea1df79$var$nd(a, b) {
    var c = new $2e7dd9641ea1df79$var$Mb;
    if ($2e7dd9641ea1df79$var$l.Image) {
        var d_1 = new Image;
        d_1.onload = $2e7dd9641ea1df79$var$ja($2e7dd9641ea1df79$var$od, c, d_1, "TestLoadImage: loaded", !0, b);
        d_1.onerror = $2e7dd9641ea1df79$var$ja($2e7dd9641ea1df79$var$od, c, d_1, "TestLoadImage: error", !1, b);
        d_1.onabort = $2e7dd9641ea1df79$var$ja($2e7dd9641ea1df79$var$od, c, d_1, "TestLoadImage: abort", !1, b);
        d_1.ontimeout = $2e7dd9641ea1df79$var$ja($2e7dd9641ea1df79$var$od, c, d_1, "TestLoadImage: timeout", !1, b);
        $2e7dd9641ea1df79$var$l.setTimeout(function() {
            if (d_1.ontimeout) d_1.ontimeout();
        }, 1E4);
        d_1.src = a;
    } else b(!1);
}
function $2e7dd9641ea1df79$var$od(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
function $2e7dd9641ea1df79$var$pd(a) {
    this.l = a.$b || null;
    this.j = a.ib || !1;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$pd, $2e7dd9641ea1df79$var$Yb);
$2e7dd9641ea1df79$var$pd.prototype.g = function() {
    return new $2e7dd9641ea1df79$var$qd(this.l, this.j);
};
$2e7dd9641ea1df79$var$pd.prototype.i = function(a) {
    return function() {
        return a;
    };
}({});
function $2e7dd9641ea1df79$var$qd(a, b) {
    $2e7dd9641ea1df79$var$C.call(this);
    this.D = a;
    this.u = b;
    this.m = void 0;
    this.readyState = $2e7dd9641ea1df79$var$rd;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.v = new Headers;
    this.h = null;
    this.C = "GET";
    this.B = "";
    this.g = !1;
    this.A = this.j = this.l = null;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$qd, $2e7dd9641ea1df79$var$C);
var $2e7dd9641ea1df79$var$rd = 0;
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$qd.prototype;
$2e7dd9641ea1df79$var$k.open = function(a, b) {
    if (this.readyState != $2e7dd9641ea1df79$var$rd) throw this.abort(), Error("Error reopening a connection");
    this.C = a;
    this.B = b;
    this.readyState = 1;
    $2e7dd9641ea1df79$var$sd(this);
};
$2e7dd9641ea1df79$var$k.send = function(a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    var b = {
        headers: this.v,
        method: this.C,
        credentials: this.m,
        cache: void 0
    };
    a && (b.body = a);
    (this.D || $2e7dd9641ea1df79$var$l).fetch(new Request(this.B, b)).then(this.Va.bind(this), this.ha.bind(this));
};
$2e7dd9641ea1df79$var$k.abort = function() {
    this.response = this.responseText = "";
    this.v = new Headers;
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.");
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, $2e7dd9641ea1df79$var$td(this));
    this.readyState = $2e7dd9641ea1df79$var$rd;
};
$2e7dd9641ea1df79$var$k.Va = function(a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, $2e7dd9641ea1df79$var$sd(this)), this.g && (this.readyState = 3, $2e7dd9641ea1df79$var$sd(this), this.g))) {
        if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Ta.bind(this), this.ha.bind(this));
        else if ("undefined" !== typeof $2e7dd9641ea1df79$var$l.ReadableStream && "body" in a) {
            this.j = a.body.getReader();
            if (this.u) {
                if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                this.response = [];
            } else this.response = this.responseText = "", this.A = new TextDecoder;
            $2e7dd9641ea1df79$var$ud(this);
        } else a.text().then(this.Ua.bind(this), this.ha.bind(this));
    }
};
function $2e7dd9641ea1df79$var$ud(a) {
    a.j.read().then(a.Sa.bind(a)).catch(a.ha.bind(a));
}
$2e7dd9641ea1df79$var$k.Sa = function(a) {
    if (this.g) {
        if (this.u && a.value) this.response.push(a.value);
        else if (!this.u) {
            var b = a.value ? a.value : new Uint8Array(0);
            if (b = this.A.decode(b, {
                stream: !a.done
            })) this.response = this.responseText += b;
        }
        a.done ? $2e7dd9641ea1df79$var$td(this) : $2e7dd9641ea1df79$var$sd(this);
        3 == this.readyState && $2e7dd9641ea1df79$var$ud(this);
    }
};
$2e7dd9641ea1df79$var$k.Ua = function(a) {
    this.g && (this.response = this.responseText = a, $2e7dd9641ea1df79$var$td(this));
};
$2e7dd9641ea1df79$var$k.Ta = function(a) {
    this.g && (this.response = a, $2e7dd9641ea1df79$var$td(this));
};
$2e7dd9641ea1df79$var$k.ha = function() {
    this.g && $2e7dd9641ea1df79$var$td(this);
};
function $2e7dd9641ea1df79$var$td(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.A = null;
    $2e7dd9641ea1df79$var$sd(a);
}
$2e7dd9641ea1df79$var$k.setRequestHeader = function(a, b) {
    this.v.append(a, b);
};
$2e7dd9641ea1df79$var$k.getResponseHeader = function(a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
$2e7dd9641ea1df79$var$k.getAllResponseHeaders = function() {
    if (!this.h) return "";
    var a = [], b = this.h.entries();
    for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    return a.join("\r\n");
};
function $2e7dd9641ea1df79$var$sd(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty($2e7dd9641ea1df79$var$qd.prototype, "withCredentials", {
    get: function() {
        return "include" === this.m;
    },
    set: function(a) {
        this.m = a ? "include" : "same-origin";
    }
});
var $2e7dd9641ea1df79$var$vd = $2e7dd9641ea1df79$var$l.JSON.parse;
function $2e7dd9641ea1df79$var$X(a) {
    $2e7dd9641ea1df79$var$C.call(this);
    this.headers = new $2e7dd9641ea1df79$var$S;
    this.u = a || null;
    this.h = !1;
    this.C = this.g = null;
    this.H = "";
    this.m = 0;
    this.j = "";
    this.l = this.F = this.v = this.D = !1;
    this.B = 0;
    this.A = null;
    this.J = $2e7dd9641ea1df79$var$wd;
    this.K = this.L = !1;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$X, $2e7dd9641ea1df79$var$C);
var $2e7dd9641ea1df79$var$wd = "", $2e7dd9641ea1df79$var$xd = /^https?$/i, $2e7dd9641ea1df79$var$yd = [
    "POST",
    "PUT"
];
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$X.prototype;
$2e7dd9641ea1df79$var$k.ea = function(a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.H + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.H = a;
    this.j = "";
    this.m = 0;
    this.D = !1;
    this.h = !0;
    this.g = this.u ? this.u.g() : $2e7dd9641ea1df79$var$cc.g();
    this.C = this.u ? $2e7dd9641ea1df79$var$Zb(this.u) : $2e7dd9641ea1df79$var$Zb($2e7dd9641ea1df79$var$cc);
    this.g.onreadystatechange = $2e7dd9641ea1df79$var$q(this.Fa, this);
    try {
        this.F = !0, this.g.open(b, String(a), !0), this.F = !1;
    } catch (f) {
        $2e7dd9641ea1df79$var$zd(this, f);
        return;
    }
    a = c || "";
    var e = new $2e7dd9641ea1df79$var$S(this.headers);
    d && $2e7dd9641ea1df79$var$Kc(d, function(f, h) {
        e.set(h, f);
    });
    d = $2e7dd9641ea1df79$var$oa(e.T());
    c = $2e7dd9641ea1df79$var$l.FormData && a instanceof $2e7dd9641ea1df79$var$l.FormData;
    !(0 <= $2e7dd9641ea1df79$var$ma($2e7dd9641ea1df79$var$yd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    e.forEach(function(f, h) {
        this.g.setRequestHeader(h, f);
    }, this);
    this.J && (this.g.responseType = this.J);
    "withCredentials" in this.g && this.g.withCredentials !== this.L && (this.g.withCredentials = this.L);
    try {
        $2e7dd9641ea1df79$var$Ad(this), 0 < this.B && ((this.K = $2e7dd9641ea1df79$var$Bd(this.g)) ? (this.g.timeout = this.B, this.g.ontimeout = $2e7dd9641ea1df79$var$q(this.pa, this)) : this.A = $2e7dd9641ea1df79$var$Gb(this.pa, this.B, this)), this.v = !0, this.g.send(a), this.v = !1;
    } catch (f) {
        $2e7dd9641ea1df79$var$zd(this, f);
    }
};
function $2e7dd9641ea1df79$var$Bd(a) {
    return $2e7dd9641ea1df79$var$y && $2e7dd9641ea1df79$var$Ra() && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
function $2e7dd9641ea1df79$var$pa(a) {
    return "content-type" == a.toLowerCase();
}
$2e7dd9641ea1df79$var$k.pa = function() {
    "undefined" != typeof $2e7dd9641ea1df79$var$goog && this.g && (this.j = "Timed out after " + this.B + "ms, aborting", this.m = 8, $2e7dd9641ea1df79$var$D(this, "timeout"), this.abort(8));
};
function $2e7dd9641ea1df79$var$zd(a, b) {
    a.h = !1;
    a.g && (a.l = !0, a.g.abort(), a.l = !1);
    a.j = b;
    a.m = 5;
    $2e7dd9641ea1df79$var$Cd(a);
    $2e7dd9641ea1df79$var$Dd(a);
}
function $2e7dd9641ea1df79$var$Cd(a) {
    a.D || (a.D = !0, $2e7dd9641ea1df79$var$D(a, "complete"), $2e7dd9641ea1df79$var$D(a, "error"));
}
$2e7dd9641ea1df79$var$k.abort = function(a) {
    this.g && this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1, this.m = a || 7, $2e7dd9641ea1df79$var$D(this, "complete"), $2e7dd9641ea1df79$var$D(this, "abort"), $2e7dd9641ea1df79$var$Dd(this));
};
$2e7dd9641ea1df79$var$k.M = function() {
    this.g && (this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1), $2e7dd9641ea1df79$var$Dd(this, !0));
    $2e7dd9641ea1df79$var$X.Z.M.call(this);
};
$2e7dd9641ea1df79$var$k.Fa = function() {
    this.s || (this.F || this.v || this.l ? $2e7dd9641ea1df79$var$Ed(this) : this.cb());
};
$2e7dd9641ea1df79$var$k.cb = function() {
    $2e7dd9641ea1df79$var$Ed(this);
};
function $2e7dd9641ea1df79$var$Ed(a) {
    if (a.h && "undefined" != typeof $2e7dd9641ea1df79$var$goog && (!a.C[1] || 4 != $2e7dd9641ea1df79$var$O(a) || 2 != a.ba())) {
        if (a.v && 4 == $2e7dd9641ea1df79$var$O(a)) $2e7dd9641ea1df79$var$Gb(a.Fa, 0, a);
        else if ($2e7dd9641ea1df79$var$D(a, "readystatechange"), 4 == $2e7dd9641ea1df79$var$O(a)) {
            a.h = !1;
            try {
                var n = a.ba();
                a: switch(n){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var b = !0;
                        break a;
                    default:
                        b = !1;
                }
                var c;
                if (!(c = b)) {
                    var d;
                    if (d = 0 === n) {
                        var e = String(a.H).match($2e7dd9641ea1df79$var$Mc)[1] || null;
                        if (!e && $2e7dd9641ea1df79$var$l.self && $2e7dd9641ea1df79$var$l.self.location) {
                            var f = $2e7dd9641ea1df79$var$l.self.location.protocol;
                            e = f.substr(0, f.length - 1);
                        }
                        d = !$2e7dd9641ea1df79$var$xd.test(e ? e.toLowerCase() : "");
                    }
                    c = d;
                }
                if (c) $2e7dd9641ea1df79$var$D(a, "complete"), $2e7dd9641ea1df79$var$D(a, "success");
                else {
                    a.m = 6;
                    try {
                        var h = 2 < $2e7dd9641ea1df79$var$O(a) ? a.g.statusText : "";
                    } catch (u) {
                        h = "";
                    }
                    a.j = h + " [" + a.ba() + "]";
                    $2e7dd9641ea1df79$var$Cd(a);
                }
            } finally{
                $2e7dd9641ea1df79$var$Dd(a);
            }
        }
    }
}
function $2e7dd9641ea1df79$var$Dd(a, b) {
    if (a.g) {
        $2e7dd9641ea1df79$var$Ad(a);
        var c = a.g, d = a.C[0] ? $2e7dd9641ea1df79$var$aa : null;
        a.g = null;
        a.C = null;
        b || $2e7dd9641ea1df79$var$D(a, "ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $2e7dd9641ea1df79$var$Ad(a) {
    a.g && a.K && (a.g.ontimeout = null);
    a.A && ($2e7dd9641ea1df79$var$l.clearTimeout(a.A), a.A = null);
}
function $2e7dd9641ea1df79$var$O(a) {
    return a.g ? a.g.readyState : 0;
}
$2e7dd9641ea1df79$var$k.ba = function() {
    try {
        return 2 < $2e7dd9641ea1df79$var$O(this) ? this.g.status : -1;
    } catch (a) {
        return -1;
    }
};
$2e7dd9641ea1df79$var$k.ga = function() {
    try {
        return this.g ? this.g.responseText : "";
    } catch (a) {
        return "";
    }
};
$2e7dd9641ea1df79$var$k.Qa = function(a) {
    if (this.g) {
        var b = this.g.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $2e7dd9641ea1df79$var$vd(b);
    }
};
function $2e7dd9641ea1df79$var$oc(a) {
    try {
        if (!a.g) return null;
        if ("response" in a.g) return a.g.response;
        switch(a.J){
            case $2e7dd9641ea1df79$var$wd:
            case "text":
                return a.g.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
        }
        return null;
    } catch (b) {
        return null;
    }
}
$2e7dd9641ea1df79$var$k.Da = function() {
    return this.m;
};
$2e7dd9641ea1df79$var$k.La = function() {
    return "string" === typeof this.j ? this.j : String(this.j);
};
function $2e7dd9641ea1df79$var$Fd(a) {
    var b = "";
    $2e7dd9641ea1df79$var$xa(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $2e7dd9641ea1df79$var$Gd(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $2e7dd9641ea1df79$var$Fd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $2e7dd9641ea1df79$var$R(a, b, c));
}
function $2e7dd9641ea1df79$var$Hd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $2e7dd9641ea1df79$var$Id(a) {
    this.za = 0;
    this.l = [];
    this.h = new $2e7dd9641ea1df79$var$Mb;
    this.la = this.oa = this.F = this.W = this.g = this.sa = this.D = this.aa = this.o = this.P = this.s = null;
    this.Za = this.V = 0;
    this.Xa = $2e7dd9641ea1df79$var$Hd("failFast", !1, a);
    this.N = this.v = this.u = this.m = this.j = null;
    this.X = !0;
    this.I = this.ta = this.U = -1;
    this.Y = this.A = this.C = 0;
    this.Pa = $2e7dd9641ea1df79$var$Hd("baseRetryDelayMs", 5E3, a);
    this.$a = $2e7dd9641ea1df79$var$Hd("retryDelaySeedMs", 1E4, a);
    this.Ya = $2e7dd9641ea1df79$var$Hd("forwardChannelMaxRetries", 2, a);
    this.ra = $2e7dd9641ea1df79$var$Hd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.qa = a && a.xmlHttpFactory || void 0;
    this.Ba = a && a.Yb || !1;
    this.K = void 0;
    this.H = a && a.supportsCrossDomainXhr || !1;
    this.J = "";
    this.i = new $2e7dd9641ea1df79$var$gd(a && a.concurrentRequestLimit);
    this.Ca = new $2e7dd9641ea1df79$var$ld;
    this.ja = a && a.fastHandshake || !1;
    this.Ra = a && a.Wb || !1;
    a && a.Aa && this.h.Aa();
    a && a.forceLongPolling && (this.X = !1);
    this.$ = !this.ja && this.X && a && a.detectBufferingProxy || !1;
    this.ka = void 0;
    this.O = 0;
    this.L = !1;
    this.B = null;
    this.Wa = !a || !1 !== a.Xb;
}
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$Id.prototype;
$2e7dd9641ea1df79$var$k.ma = 8;
$2e7dd9641ea1df79$var$k.G = 1;
function $2e7dd9641ea1df79$var$Ic(a) {
    $2e7dd9641ea1df79$var$Jd(a);
    if (3 == a.G) {
        var b = a.V++, c = $2e7dd9641ea1df79$var$N(a.F);
        $2e7dd9641ea1df79$var$R(c, "SID", a.J);
        $2e7dd9641ea1df79$var$R(c, "RID", b);
        $2e7dd9641ea1df79$var$R(c, "TYPE", "terminate");
        $2e7dd9641ea1df79$var$Kd(a, c);
        b = new $2e7dd9641ea1df79$var$M(a, a.h, b, void 0);
        b.K = 2;
        b.v = $2e7dd9641ea1df79$var$jc($2e7dd9641ea1df79$var$N(c));
        c = !1;
        $2e7dd9641ea1df79$var$l.navigator && $2e7dd9641ea1df79$var$l.navigator.sendBeacon && (c = $2e7dd9641ea1df79$var$l.navigator.sendBeacon(b.v.toString(), ""));
        !c && $2e7dd9641ea1df79$var$l.Image && ((new Image).src = b.v, c = !0);
        c || (b.g = $2e7dd9641ea1df79$var$nc(b.l, null), b.g.ea(b.v));
        b.F = Date.now();
        $2e7dd9641ea1df79$var$lc(b);
    }
    $2e7dd9641ea1df79$var$Ld(a);
}
$2e7dd9641ea1df79$var$k.hb = function(a) {
    try {
        this.h.info("Origin Trials invoked: " + a);
    } catch (b) {}
};
function $2e7dd9641ea1df79$var$Ac(a) {
    a.g && ($2e7dd9641ea1df79$var$wc(a), a.g.cancel(), a.g = null);
}
function $2e7dd9641ea1df79$var$Jd(a) {
    $2e7dd9641ea1df79$var$Ac(a);
    a.u && ($2e7dd9641ea1df79$var$l.clearTimeout(a.u), a.u = null);
    $2e7dd9641ea1df79$var$zc(a);
    a.i.cancel();
    a.m && ("number" === typeof a.m && $2e7dd9641ea1df79$var$l.clearTimeout(a.m), a.m = null);
}
function $2e7dd9641ea1df79$var$Md(a, b) {
    a.l.push(new $2e7dd9641ea1df79$var$fd(a.Za++, b));
    3 == a.G && $2e7dd9641ea1df79$var$Hc(a);
}
function $2e7dd9641ea1df79$var$Hc(a) {
    $2e7dd9641ea1df79$var$id(a.i) || a.m || (a.m = !0, $2e7dd9641ea1df79$var$zb(a.Ha, a), a.C = 0);
}
function $2e7dd9641ea1df79$var$Nd(a, b) {
    if ($2e7dd9641ea1df79$var$Cc(a.i) >= a.i.j - (a.m ? 1 : 0)) return !1;
    if (a.m) return a.l = b.D.concat(a.l), !0;
    if (1 == a.G || 2 == a.G || a.C >= (a.Xa ? 0 : a.Ya)) return !1;
    a.m = $2e7dd9641ea1df79$var$K($2e7dd9641ea1df79$var$q(a.Ha, a, b), $2e7dd9641ea1df79$var$Od(a, a.C));
    a.C++;
    return !0;
}
$2e7dd9641ea1df79$var$k.Ha = function(a) {
    if (this.m) {
        if (this.m = null, 1 == this.G) {
            if (!a) {
                this.V = Math.floor(1E5 * Math.random());
                a = this.V++;
                var e = new $2e7dd9641ea1df79$var$M(this, this.h, a, void 0);
                var f = this.s;
                this.P && (f ? (f = $2e7dd9641ea1df79$var$ya(f), $2e7dd9641ea1df79$var$Aa(f, this.P)) : f = this.P);
                null === this.o && (e.H = f);
                if (this.ja) a: {
                    var b = 0;
                    for(var c = 0; c < this.l.length; c++){
                        b: {
                            var d = this.l[c];
                            if ("__data__" in d.g && (d = d.g.__data__, "string" === typeof d)) {
                                d = d.length;
                                break b;
                            }
                            d = void 0;
                        }
                        if (void 0 === d) break;
                        b += d;
                        if (4096 < b) {
                            b = c;
                            break a;
                        }
                        if (4096 === b || c === this.l.length - 1) {
                            b = c + 1;
                            break a;
                        }
                    }
                    b = 1E3;
                }
                else b = 1E3;
                b = $2e7dd9641ea1df79$var$Pd(this, e, b);
                c = $2e7dd9641ea1df79$var$N(this.F);
                $2e7dd9641ea1df79$var$R(c, "RID", a);
                $2e7dd9641ea1df79$var$R(c, "CVER", 22);
                this.D && $2e7dd9641ea1df79$var$R(c, "X-HTTP-Session-Id", this.D);
                $2e7dd9641ea1df79$var$Kd(this, c);
                this.o && f && $2e7dd9641ea1df79$var$Gd(c, this.o, f);
                $2e7dd9641ea1df79$var$Dc(this.i, e);
                this.Ra && $2e7dd9641ea1df79$var$R(c, "TYPE", "init");
                this.ja ? ($2e7dd9641ea1df79$var$R(c, "$req", b), $2e7dd9641ea1df79$var$R(c, "SID", "null"), e.$ = !0, $2e7dd9641ea1df79$var$ic(e, c, null)) : $2e7dd9641ea1df79$var$ic(e, c, b);
                this.G = 2;
            }
        } else 3 == this.G && (a ? $2e7dd9641ea1df79$var$Qd(this, a) : 0 == this.l.length || $2e7dd9641ea1df79$var$id(this.i) || $2e7dd9641ea1df79$var$Qd(this));
    }
};
function $2e7dd9641ea1df79$var$Qd(a, b) {
    var c;
    b ? c = b.m : c = a.V++;
    var d = $2e7dd9641ea1df79$var$N(a.F);
    $2e7dd9641ea1df79$var$R(d, "SID", a.J);
    $2e7dd9641ea1df79$var$R(d, "RID", c);
    $2e7dd9641ea1df79$var$R(d, "AID", a.U);
    $2e7dd9641ea1df79$var$Kd(a, d);
    a.o && a.s && $2e7dd9641ea1df79$var$Gd(d, a.o, a.s);
    c = new $2e7dd9641ea1df79$var$M(a, a.h, c, a.C + 1);
    null === a.o && (c.H = a.s);
    b && (a.l = b.D.concat(a.l));
    b = $2e7dd9641ea1df79$var$Pd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.ra) + Math.round(.5 * a.ra * Math.random()));
    $2e7dd9641ea1df79$var$Dc(a.i, c);
    $2e7dd9641ea1df79$var$ic(c, d, b);
}
function $2e7dd9641ea1df79$var$Kd(a, b) {
    a.j && $2e7dd9641ea1df79$var$Kc({}, function(c, d) {
        $2e7dd9641ea1df79$var$R(b, d, c);
    });
}
function $2e7dd9641ea1df79$var$Pd(a, b, c) {
    c = Math.min(a.l.length, c);
    var d = a.j ? $2e7dd9641ea1df79$var$q(a.j.Oa, a.j, a) : null;
    a: {
        var e = a.l;
        var f = -1;
        for(;;){
            var h = [
                "count=" + c
            ];
            -1 == f ? 0 < c ? (f = e[0].h, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
            var n = !0;
            for(var u = 0; u < c; u++){
                var m = e[u].h;
                var r = e[u].g;
                m -= f;
                if (0 > m) f = Math.max(0, e[u].h - 100), n = !1;
                else try {
                    $2e7dd9641ea1df79$var$md(r, h, "req" + m + "_");
                } catch (G) {
                    d && d(r);
                }
            }
            if (n) {
                d = h.join("&");
                break a;
            }
        }
    }
    a = a.l.splice(0, c);
    b.D = a;
    return d;
}
function $2e7dd9641ea1df79$var$Gc(a) {
    a.g || a.u || (a.Y = 1, $2e7dd9641ea1df79$var$zb(a.Ga, a), a.A = 0);
}
function $2e7dd9641ea1df79$var$Bc(a) {
    if (a.g || a.u || 3 <= a.A) return !1;
    a.Y++;
    a.u = $2e7dd9641ea1df79$var$K($2e7dd9641ea1df79$var$q(a.Ga, a), $2e7dd9641ea1df79$var$Od(a, a.A));
    a.A++;
    return !0;
}
$2e7dd9641ea1df79$var$k.Ga = function() {
    this.u = null;
    $2e7dd9641ea1df79$var$Rd(this);
    if (this.$ && !(this.L || null == this.g || 0 >= this.O)) {
        var a = 2 * this.O;
        this.h.info("BP detection timer enabled: " + a);
        this.B = $2e7dd9641ea1df79$var$K($2e7dd9641ea1df79$var$q(this.bb, this), a);
    }
};
$2e7dd9641ea1df79$var$k.bb = function() {
    this.B && (this.B = null, this.h.info("BP detection timeout reached."), this.h.info("Buffering proxy detected and switch to long-polling!"), this.N = !1, this.L = !0, $2e7dd9641ea1df79$var$J(10), $2e7dd9641ea1df79$var$Ac(this), $2e7dd9641ea1df79$var$Rd(this));
};
function $2e7dd9641ea1df79$var$wc(a) {
    null != a.B && ($2e7dd9641ea1df79$var$l.clearTimeout(a.B), a.B = null);
}
function $2e7dd9641ea1df79$var$Rd(a) {
    a.g = new $2e7dd9641ea1df79$var$M(a, a.h, "rpc", a.Y);
    null === a.o && (a.g.H = a.s);
    a.g.O = 0;
    var b = $2e7dd9641ea1df79$var$N(a.oa);
    $2e7dd9641ea1df79$var$R(b, "RID", "rpc");
    $2e7dd9641ea1df79$var$R(b, "SID", a.J);
    $2e7dd9641ea1df79$var$R(b, "CI", a.N ? "0" : "1");
    $2e7dd9641ea1df79$var$R(b, "AID", a.U);
    $2e7dd9641ea1df79$var$Kd(a, b);
    $2e7dd9641ea1df79$var$R(b, "TYPE", "xmlhttp");
    a.o && a.s && $2e7dd9641ea1df79$var$Gd(b, a.o, a.s);
    a.K && a.g.setTimeout(a.K);
    var c = a.g;
    a = a.la;
    c.K = 1;
    c.v = $2e7dd9641ea1df79$var$jc($2e7dd9641ea1df79$var$N(b));
    c.s = null;
    c.U = !0;
    $2e7dd9641ea1df79$var$kc(c, a);
}
$2e7dd9641ea1df79$var$k.ab = function() {
    null != this.v && (this.v = null, $2e7dd9641ea1df79$var$Ac(this), $2e7dd9641ea1df79$var$Bc(this), $2e7dd9641ea1df79$var$J(19));
};
function $2e7dd9641ea1df79$var$zc(a) {
    null != a.v && ($2e7dd9641ea1df79$var$l.clearTimeout(a.v), a.v = null);
}
function $2e7dd9641ea1df79$var$uc(a, b) {
    var c = null;
    if (a.g == b) {
        $2e7dd9641ea1df79$var$zc(a);
        $2e7dd9641ea1df79$var$wc(a);
        a.g = null;
        var d = 2;
    } else if ($2e7dd9641ea1df79$var$yc(a.i, b)) c = b.D, $2e7dd9641ea1df79$var$Fc(a.i, b), d = 1;
    else return;
    a.I = b.N;
    if (0 != a.G) {
        if (b.i) {
            if (1 == d) {
                c = b.s ? b.s.length : 0;
                b = Date.now() - b.F;
                var e = a.C;
                d = $2e7dd9641ea1df79$var$Sb();
                $2e7dd9641ea1df79$var$D(d, new $2e7dd9641ea1df79$var$Vb(d, c, b, e));
                $2e7dd9641ea1df79$var$Hc(a);
            } else $2e7dd9641ea1df79$var$Gc(a);
        } else if (e = b.o, 3 == e || 0 == e && 0 < a.I || !(1 == d && $2e7dd9641ea1df79$var$Nd(a, b) || 2 == d && $2e7dd9641ea1df79$var$Bc(a))) switch(c && 0 < c.length && (b = a.i, b.i = b.i.concat(c)), e){
            case 1:
                $2e7dd9641ea1df79$var$Q(a, 5);
                break;
            case 4:
                $2e7dd9641ea1df79$var$Q(a, 10);
                break;
            case 3:
                $2e7dd9641ea1df79$var$Q(a, 6);
                break;
            default:
                $2e7dd9641ea1df79$var$Q(a, 2);
        }
    }
}
function $2e7dd9641ea1df79$var$Od(a, b) {
    var c = a.Pa + Math.floor(Math.random() * a.$a);
    a.j || (c *= 2);
    return c * b;
}
function $2e7dd9641ea1df79$var$Q(a, b) {
    a.h.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.j && (c = null);
        var d = $2e7dd9641ea1df79$var$q(a.jb, a);
        c || (c = new $2e7dd9641ea1df79$var$U("//www.google.com/images/cleardot.gif"), $2e7dd9641ea1df79$var$l.location && "http" == $2e7dd9641ea1df79$var$l.location.protocol || $2e7dd9641ea1df79$var$Oc(c, "https"), $2e7dd9641ea1df79$var$jc(c));
        $2e7dd9641ea1df79$var$nd(c.toString(), d);
    } else $2e7dd9641ea1df79$var$J(2);
    a.G = 0;
    a.j && a.j.va(b);
    $2e7dd9641ea1df79$var$Ld(a);
    $2e7dd9641ea1df79$var$Jd(a);
}
$2e7dd9641ea1df79$var$k.jb = function(a) {
    a ? (this.h.info("Successfully pinged google.com"), $2e7dd9641ea1df79$var$J(2)) : (this.h.info("Failed to ping google.com"), $2e7dd9641ea1df79$var$J(1));
};
function $2e7dd9641ea1df79$var$Ld(a) {
    a.G = 0;
    a.I = -1;
    if (a.j) {
        if (0 != $2e7dd9641ea1df79$var$jd(a.i).length || 0 != a.l.length) a.i.i.length = 0, $2e7dd9641ea1df79$var$ra(a.l), a.l.length = 0;
        a.j.ua();
    }
}
function $2e7dd9641ea1df79$var$Ec(a, b, c) {
    var d = $2e7dd9641ea1df79$var$ad(c);
    if ("" != d.i) b && $2e7dd9641ea1df79$var$Pc(d, b + "." + d.i), $2e7dd9641ea1df79$var$Qc(d, d.m);
    else {
        var e = $2e7dd9641ea1df79$var$l.location;
        d = $2e7dd9641ea1df79$var$bd(e.protocol, b ? b + "." + e.hostname : e.hostname, +e.port, c);
    }
    a.aa && $2e7dd9641ea1df79$var$xa(a.aa, function(e, f) {
        $2e7dd9641ea1df79$var$R(d, f, e);
    });
    b = a.D;
    c = a.sa;
    b && c && $2e7dd9641ea1df79$var$R(d, b, c);
    $2e7dd9641ea1df79$var$R(d, "VER", a.ma);
    $2e7dd9641ea1df79$var$Kd(a, d);
    return d;
}
function $2e7dd9641ea1df79$var$nc(a, b, c) {
    if (b && !a.H) throw Error("Can't create secondary domain capable XhrIo object.");
    b = c && a.Ba && !a.qa ? new $2e7dd9641ea1df79$var$X(new $2e7dd9641ea1df79$var$pd({
        ib: !0
    })) : new $2e7dd9641ea1df79$var$X(a.qa);
    b.L = a.H;
    return b;
}
function $2e7dd9641ea1df79$var$Sd() {}
$2e7dd9641ea1df79$var$k = $2e7dd9641ea1df79$var$Sd.prototype;
$2e7dd9641ea1df79$var$k.xa = function() {};
$2e7dd9641ea1df79$var$k.wa = function() {};
$2e7dd9641ea1df79$var$k.va = function() {};
$2e7dd9641ea1df79$var$k.ua = function() {};
$2e7dd9641ea1df79$var$k.Oa = function() {};
function $2e7dd9641ea1df79$var$Td() {
    if ($2e7dd9641ea1df79$var$y && !(10 <= Number($2e7dd9641ea1df79$var$Ua))) throw Error("Environmental error: no available transport.");
}
$2e7dd9641ea1df79$var$Td.prototype.g = function(a, b) {
    return new $2e7dd9641ea1df79$var$Y(a, b);
};
function $2e7dd9641ea1df79$var$Y(a, b) {
    $2e7dd9641ea1df79$var$C.call(this);
    this.g = new $2e7dd9641ea1df79$var$Id(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.g.s = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.ya && (a ? a["X-WebChannel-Client-Profile"] = b.ya : a = {
        "X-WebChannel-Client-Profile": b.ya
    });
    this.g.P = a;
    (a = b && b.httpHeadersOverwriteParam) && !$2e7dd9641ea1df79$var$sa(a) && (this.g.o = a);
    this.A = b && b.supportsCrossDomainXhr || !1;
    this.v = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$2e7dd9641ea1df79$var$sa(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new $2e7dd9641ea1df79$var$Z(this);
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Y, $2e7dd9641ea1df79$var$C);
$2e7dd9641ea1df79$var$Y.prototype.m = function() {
    this.g.j = this.j;
    this.A && (this.g.H = !0);
    var a = this.g, b = this.l, c = this.h || void 0;
    a.Wa && (a.h.info("Origin Trials enabled."), $2e7dd9641ea1df79$var$zb($2e7dd9641ea1df79$var$q(a.hb, a, b)));
    $2e7dd9641ea1df79$var$J(0);
    a.W = b;
    a.aa = c || {};
    a.N = a.X;
    a.F = $2e7dd9641ea1df79$var$Ec(a, null, a.W);
    $2e7dd9641ea1df79$var$Hc(a);
};
$2e7dd9641ea1df79$var$Y.prototype.close = function() {
    $2e7dd9641ea1df79$var$Ic(this.g);
};
$2e7dd9641ea1df79$var$Y.prototype.u = function(a) {
    if ("string" === typeof a) {
        var b = {};
        b.__data__ = a;
        $2e7dd9641ea1df79$var$Md(this.g, b);
    } else this.v ? (b = {}, b.__data__ = $2e7dd9641ea1df79$var$rb(a), $2e7dd9641ea1df79$var$Md(this.g, b)) : $2e7dd9641ea1df79$var$Md(this.g, a);
};
$2e7dd9641ea1df79$var$Y.prototype.M = function() {
    this.g.j = null;
    delete this.j;
    $2e7dd9641ea1df79$var$Ic(this.g);
    delete this.g;
    $2e7dd9641ea1df79$var$Y.Z.M.call(this);
};
function $2e7dd9641ea1df79$var$Ud(a) {
    $2e7dd9641ea1df79$var$ac.call(this);
    var b = a.__sm__;
    if (b) {
        a: {
            for(var c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
        this.data = b;
    } else this.data = a;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Ud, $2e7dd9641ea1df79$var$ac);
function $2e7dd9641ea1df79$var$Vd() {
    $2e7dd9641ea1df79$var$bc.call(this);
    this.status = 1;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Vd, $2e7dd9641ea1df79$var$bc);
function $2e7dd9641ea1df79$var$Z(a) {
    this.g = a;
}
$2e7dd9641ea1df79$var$t($2e7dd9641ea1df79$var$Z, $2e7dd9641ea1df79$var$Sd);
$2e7dd9641ea1df79$var$Z.prototype.xa = function() {
    $2e7dd9641ea1df79$var$D(this.g, "a");
};
$2e7dd9641ea1df79$var$Z.prototype.wa = function(a) {
    $2e7dd9641ea1df79$var$D(this.g, new $2e7dd9641ea1df79$var$Ud(a));
};
$2e7dd9641ea1df79$var$Z.prototype.va = function(a) {
    $2e7dd9641ea1df79$var$D(this.g, new $2e7dd9641ea1df79$var$Vd(a));
};
$2e7dd9641ea1df79$var$Z.prototype.ua = function() {
    $2e7dd9641ea1df79$var$D(this.g, "b");
}; /*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
$2e7dd9641ea1df79$var$Td.prototype.createWebChannel = $2e7dd9641ea1df79$var$Td.prototype.g;
$2e7dd9641ea1df79$var$Y.prototype.send = $2e7dd9641ea1df79$var$Y.prototype.u;
$2e7dd9641ea1df79$var$Y.prototype.open = $2e7dd9641ea1df79$var$Y.prototype.m;
$2e7dd9641ea1df79$var$Y.prototype.close = $2e7dd9641ea1df79$var$Y.prototype.close;
$2e7dd9641ea1df79$var$Wb.NO_ERROR = 0;
$2e7dd9641ea1df79$var$Wb.TIMEOUT = 8;
$2e7dd9641ea1df79$var$Wb.HTTP_ERROR = 6;
$2e7dd9641ea1df79$var$Xb.COMPLETE = "complete";
$2e7dd9641ea1df79$var$$b.EventType = $2e7dd9641ea1df79$var$L;
$2e7dd9641ea1df79$var$L.OPEN = "a";
$2e7dd9641ea1df79$var$L.CLOSE = "b";
$2e7dd9641ea1df79$var$L.ERROR = "c";
$2e7dd9641ea1df79$var$L.MESSAGE = "d";
$2e7dd9641ea1df79$var$C.prototype.listen = $2e7dd9641ea1df79$var$C.prototype.N;
$2e7dd9641ea1df79$var$X.prototype.listenOnce = $2e7dd9641ea1df79$var$X.prototype.O;
$2e7dd9641ea1df79$var$X.prototype.getLastError = $2e7dd9641ea1df79$var$X.prototype.La;
$2e7dd9641ea1df79$var$X.prototype.getLastErrorCode = $2e7dd9641ea1df79$var$X.prototype.Da;
$2e7dd9641ea1df79$var$X.prototype.getStatus = $2e7dd9641ea1df79$var$X.prototype.ba;
$2e7dd9641ea1df79$var$X.prototype.getResponseJson = $2e7dd9641ea1df79$var$X.prototype.Qa;
$2e7dd9641ea1df79$var$X.prototype.getResponseText = $2e7dd9641ea1df79$var$X.prototype.ga;
$2e7dd9641ea1df79$var$X.prototype.send = $2e7dd9641ea1df79$var$X.prototype.ea;
var $2e7dd9641ea1df79$export$66869136fc133c3a = function() {
    return new $2e7dd9641ea1df79$var$Td;
};
var $2e7dd9641ea1df79$export$888d0d9ab79d08fc = function() {
    return $2e7dd9641ea1df79$var$Sb();
};
var $2e7dd9641ea1df79$export$d4e71bc0b80dc0fb = $2e7dd9641ea1df79$var$Wb;
var $2e7dd9641ea1df79$export$3d7865934588d77e = $2e7dd9641ea1df79$var$Xb;
var $2e7dd9641ea1df79$export$d61e24a684f9e51 = $2e7dd9641ea1df79$var$H;
var $2e7dd9641ea1df79$export$cbbc350c1dfc80cb = {
    rb: 0,
    ub: 1,
    vb: 2,
    Ob: 3,
    Tb: 4,
    Qb: 5,
    Rb: 6,
    Pb: 7,
    Nb: 8,
    Sb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Lb: 12,
    Hb: 13,
    Ib: 14,
    Gb: 15,
    Jb: 16,
    Kb: 17,
    nb: 18,
    mb: 19,
    ob: 20
};
var $2e7dd9641ea1df79$export$ddb1030448106742 = $2e7dd9641ea1df79$var$pd;
var $2e7dd9641ea1df79$export$aa726fb96ad3e039 = $2e7dd9641ea1df79$var$$b;
var $2e7dd9641ea1df79$export$26404658cda3ee02 = $2e7dd9641ea1df79$var$X;
var $2e7dd9641ea1df79$var$esm = {
    createWebChannelTransport: $2e7dd9641ea1df79$export$66869136fc133c3a,
    getStatEventTarget: $2e7dd9641ea1df79$export$888d0d9ab79d08fc,
    ErrorCode: $2e7dd9641ea1df79$export$d4e71bc0b80dc0fb,
    EventType: $2e7dd9641ea1df79$export$3d7865934588d77e,
    Event: $2e7dd9641ea1df79$export$d61e24a684f9e51,
    Stat: $2e7dd9641ea1df79$export$cbbc350c1dfc80cb,
    FetchXmlHttpFactory: $2e7dd9641ea1df79$export$ddb1030448106742,
    WebChannel: $2e7dd9641ea1df79$export$aa726fb96ad3e039,
    XhrIo: $2e7dd9641ea1df79$export$26404658cda3ee02
};
var $2e7dd9641ea1df79$export$2e2bcd8739ae039 = $2e7dd9641ea1df79$var$esm;



var $hvPjh = parcelRequire("hvPjh");
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ var $8cffe22d3a2884c1$var$S = /** @class */ function() {
    function t(t, e) {
        var n = this;
        this.previousValue = t, e && (e.sequenceNumberHandler = function(t) {
            return n.t(t);
        }, this.i = function(t) {
            return e.writeSequenceNumber(t);
        });
    }
    return t.prototype.t = function(t) {
        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }, t.prototype.next = function() {
        var t = ++this.previousValue;
        return this.i && this.i(t), t;
    }, t;
}();
$8cffe22d3a2884c1$var$S.o = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$N = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
}, $8cffe22d3a2884c1$var$D = /** @class */ function(e) {
    /** @hideconstructor */ function n(/**
     * The backend error code associated with this error.
     */ t, /**
     * A custom error description.
     */ n) {
        var r = this;
        return (r = e.call(this, n) || this).code = t, r.message = n, /** The custom name for all FirestoreErrors. */ r.name = "FirebaseError", // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        r.toString = function() {
            return r.name + ": [code=" + r.code + "]: " + r.message;
        }, r;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}(Error), $8cffe22d3a2884c1$var$A = new (0, $i4pDv.Logger)("@firebase/firestore");
/** An error returned by a Firestore operation. */ // Helper methods are needed because variables can't be exported as read/write
function $8cffe22d3a2884c1$var$k() {
    return $8cffe22d3a2884c1$var$A.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $8cffe22d3a2884c1$var$C(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    if ($8cffe22d3a2884c1$var$A.logLevel <= (0, $i4pDv.LogLevel).DEBUG) {
        var i = n.map($8cffe22d3a2884c1$var$L);
        $8cffe22d3a2884c1$var$A.debug.apply($8cffe22d3a2884c1$var$A, (0, $2WUgS.__spreadArray)([
            "Firestore (8.10.1): " + t
        ], i));
    }
}
function $8cffe22d3a2884c1$var$x(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    if ($8cffe22d3a2884c1$var$A.logLevel <= (0, $i4pDv.LogLevel).ERROR) {
        var i = n.map($8cffe22d3a2884c1$var$L);
        $8cffe22d3a2884c1$var$A.error.apply($8cffe22d3a2884c1$var$A, (0, $2WUgS.__spreadArray)([
            "Firestore (8.10.1): " + t
        ], i));
    }
}
function $8cffe22d3a2884c1$var$R(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    if ($8cffe22d3a2884c1$var$A.logLevel <= (0, $i4pDv.LogLevel).WARN) {
        var i = n.map($8cffe22d3a2884c1$var$L);
        $8cffe22d3a2884c1$var$A.warn.apply($8cffe22d3a2884c1$var$A, (0, $2WUgS.__spreadArray)([
            "Firestore (8.10.1): " + t
        ], i));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $8cffe22d3a2884c1$var$L(t) {
    if ("string" == typeof t) return t;
    try {
        return e = t, JSON.stringify(e);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
    var e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $8cffe22d3a2884c1$var$O(t) {
    void 0 === t && (t = "Unexpected state");
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var e = "FIRESTORE (8.10.1) INTERNAL ASSERTION FAILED: " + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $8cffe22d3a2884c1$var$x(e), new Error(e) /**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ ;
}
function $8cffe22d3a2884c1$var$P(t, e) {
    t || $8cffe22d3a2884c1$var$O();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $8cffe22d3a2884c1$var$F(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $8cffe22d3a2884c1$var$M(t) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    var e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
    if (e && "function" == typeof e.getRandomValues) e.getRandomValues(n);
    else // Falls back to Math.random
    for(var r = 0; r < t; r++)n[r] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$V = /** @class */ function() {
    function t() {}
    return t.u = function() {
        for(// Alphanumeric characters
        var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length, n = ""; n.length < 20;)for(var r = $8cffe22d3a2884c1$var$M(40), i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
        // be evenly mapped to indices of `chars` via a modulo operation.
        n.length < 20 && r[i] < e && (n += t.charAt(r[i] % t.length));
        return n;
    }, t;
}();
function $8cffe22d3a2884c1$var$q(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $8cffe22d3a2884c1$var$U(t, e, n) {
    return t.length === e.length && t.every(function(t, r) {
        return n(t, e[r]);
    });
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $8cffe22d3a2884c1$var$B(t) {
    // Return the input string, with an additional NUL byte appended.
    return t + "\x00";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ var $8cffe22d3a2884c1$export$3a1a48c8f6ef640e = /** @class */ function() {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ function t(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ t, /**
     * The fractions of a second at nanosecond resolution.*
     */ e) {
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ return t.now = function() {
        return t.fromMillis(Date.now());
    }, /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ t.fromDate = function(e) {
        return t.fromMillis(e.getTime());
    }, /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ t.fromMillis = function(e) {
        var n = Math.floor(e / 1e3);
        return new t(n, Math.floor(1e6 * (e - 1e3 * n)));
    }, /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ t.prototype.toDate = function() {
        return new Date(this.toMillis());
    }, /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ t.prototype.toMillis = function() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }, t.prototype._compareTo = function(t) {
        return this.seconds === t.seconds ? $8cffe22d3a2884c1$var$q(this.nanoseconds, t.nanoseconds) : $8cffe22d3a2884c1$var$q(this.seconds, t.seconds);
    }, /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ t.prototype.isEqual = function(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }, /** Returns a textual representation of this `Timestamp`. */ t.prototype.toString = function() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }, /** Returns a JSON-serializable representation of this `Timestamp`. */ t.prototype.toJSON = function() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }, /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ t.prototype.valueOf = function() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexiographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexiographical ordering.
        var t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }, t;
}(), $8cffe22d3a2884c1$var$K = /** @class */ function() {
    function t(t) {
        this.timestamp = t;
    }
    return t.fromTimestamp = function(e) {
        return new t(e);
    }, t.min = function() {
        return new t(new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(0, 0));
    }, t.prototype.compareTo = function(t) {
        return this.timestamp._compareTo(t.timestamp);
    }, t.prototype.isEqual = function(t) {
        return this.timestamp.isEqual(t.timestamp);
    }, /** Returns a number representation of the version for use in spec tests. */ t.prototype.toMicroseconds = function() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }, t.prototype.toString = function() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }, t.prototype.toTimestamp = function() {
        return this.timestamp;
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8cffe22d3a2884c1$var$G(t) {
    var e = 0;
    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e++;
    return e;
}
function $8cffe22d3a2884c1$var$Q(t, e) {
    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
}
function $8cffe22d3a2884c1$var$z(t) {
    for(var e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ var $8cffe22d3a2884c1$var$W = /** @class */ function() {
    function t(t, e, n) {
        void 0 === e ? e = 0 : e > t.length && $8cffe22d3a2884c1$var$O(), void 0 === n ? n = t.length - e : n > t.length - e && $8cffe22d3a2884c1$var$O(), this.segments = t, this.offset = e, this.len = n;
    }
    return Object.defineProperty(t.prototype, "length", {
        get: function() {
            return this.len;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        return 0 === t.comparator(this, e);
    }, t.prototype.child = function(e) {
        var n = this.segments.slice(this.offset, this.limit());
        return e instanceof t ? e.forEach(function(t) {
            n.push(t);
        }) : n.push(e), this.construct(n);
    }, /** The index of one past the last segment of the path. */ t.prototype.limit = function() {
        return this.offset + this.length;
    }, t.prototype.popFirst = function(t) {
        return t = void 0 === t ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
    }, t.prototype.popLast = function() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }, t.prototype.firstSegment = function() {
        return this.segments[this.offset];
    }, t.prototype.lastSegment = function() {
        return this.get(this.length - 1);
    }, t.prototype.get = function(t) {
        return this.segments[this.offset + t];
    }, t.prototype.isEmpty = function() {
        return 0 === this.length;
    }, t.prototype.isPrefixOf = function(t) {
        if (t.length < this.length) return !1;
        for(var e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }, t.prototype.isImmediateParentOf = function(t) {
        if (this.length + 1 !== t.length) return !1;
        for(var e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }, t.prototype.forEach = function(t) {
        for(var e = this.offset, n = this.limit(); e < n; e++)t(this.segments[e]);
    }, t.prototype.toArray = function() {
        return this.segments.slice(this.offset, this.limit());
    }, t.comparator = function(t, e) {
        for(var n = Math.min(t.length, e.length), r = 0; r < n; r++){
            var i = t.get(r), o = e.get(r);
            if (i < o) return -1;
            if (i > o) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }, t;
}(), $8cffe22d3a2884c1$var$H = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.construct = function(t, e, r) {
        return new n(t, e, r);
    }, n.prototype.canonicalString = function() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }, n.prototype.toString = function() {
        return this.canonicalString();
    }, /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ n.fromString = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        for(var r = [], i = 0, o = t; i < o.length; i++){
            var s = o[i];
            if (s.indexOf("//") >= 0) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid segment (" + s + "). Paths must not contain // in them.");
            // Strip leading and traling slashed.
            r.push.apply(r, s.split("/").filter(function(t) {
                return t.length > 0;
            }));
        }
        return new n(r);
    }, n.emptyPath = function() {
        return new n([]);
    }, n;
}($8cffe22d3a2884c1$var$W), $8cffe22d3a2884c1$var$Y = /^[_a-zA-Z][_a-zA-Z0-9]*$/, $8cffe22d3a2884c1$var$$ = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.construct = function(t, e, r) {
        return new n(t, e, r);
    }, /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ n.isValidIdentifier = function(t) {
        return $8cffe22d3a2884c1$var$Y.test(t);
    }, n.prototype.canonicalString = function() {
        return this.toArray().map(function(t) {
            return t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), n.isValidIdentifier(t) || (t = "`" + t + "`"), t;
        }).join(".");
    }, n.prototype.toString = function() {
        return this.canonicalString();
    }, /**
     * Returns true if this field references the key of a document.
     */ n.prototype.isKeyField = function() {
        return 1 === this.length && "__name__" === this.get(0);
    }, /**
     * The field designating the key of a document.
     */ n.keyField = function() {
        return new n([
            "__name__"
        ]);
    }, /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ n.fromServerFormat = function(t) {
        for(var e = [], r = "", i = 0, o = function() {
            if (0 === r.length) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
            e.push(r), r = "";
        }, s = !1; i < t.length;){
            var u = t[i];
            if ("\\" === u) {
                if (i + 1 === t.length) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                var a = t[i + 1];
                if ("\\" !== a && "." !== a && "`" !== a) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                r += a, i += 2;
            } else "`" === u ? (s = !s, i++) : "." !== u || s ? (r += u, i++) : (o(), i++);
        }
        if (o(), s) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
        return new n(e);
    }, n.emptyPath = function() {
        return new n([]);
    }, n;
}($8cffe22d3a2884c1$var$W), $8cffe22d3a2884c1$var$X = /** @class */ function() {
    function t(t) {
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($8cffe22d3a2884c1$var$$.comparator) /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ ;
    }
    return t.prototype.covers = function(t) {
        for(var e = 0, n = this.fields; e < n.length; e++){
            if (n[e].isPrefixOf(t)) return !0;
        }
        return !1;
    }, t.prototype.isEqual = function(t) {
        return $8cffe22d3a2884c1$var$U(this.fields, t.fields, function(t, e) {
            return t.isEqual(e);
        });
    }, t;
}(), $8cffe22d3a2884c1$var$J = /** @class */ function() {
    function t(t) {
        this.binaryString = t;
    }
    return t.fromBase64String = function(e) {
        return new t(atob(e));
    }, t.fromUint8Array = function(e) {
        return new t(/**
 * Helper function to convert an Uint8array to a binary string.
 */ function(t) {
            for(var e = "", n = 0; n < t.length; ++n)e += String.fromCharCode(t[n]);
            return e;
        }(e));
    }, t.prototype.toBase64 = function() {
        var t;
        return t = this.binaryString, btoa(t);
    /** True if and only if the Base64 conversion functions are available. */ }, t.prototype.toUint8Array = function() {
        return function(t) {
            for(var e = new Uint8Array(t.length), n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
            return e;
        }(this.binaryString);
    }, t.prototype.approximateByteSize = function() {
        return 2 * this.binaryString.length;
    }, t.prototype.compareTo = function(t) {
        return $8cffe22d3a2884c1$var$q(this.binaryString, t.binaryString);
    }, t.prototype.isEqual = function(t) {
        return this.binaryString === t.binaryString;
    }, t;
}();
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */ $8cffe22d3a2884c1$var$J.EMPTY_BYTE_STRING = new $8cffe22d3a2884c1$var$J("");
var $8cffe22d3a2884c1$var$Z = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $8cffe22d3a2884c1$var$tt(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($8cffe22d3a2884c1$var$P(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var e = 0, n = $8cffe22d3a2884c1$var$Z.exec(t);
        if ($8cffe22d3a2884c1$var$P(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var r = n[1];
            r = (r + "000000000").substr(0, 9), e = Number(r);
        }
        // Parse the date to get the seconds.
        var i = new Date(t);
        return {
            seconds: Math.floor(i.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $8cffe22d3a2884c1$var$et(t.seconds),
        nanos: $8cffe22d3a2884c1$var$et(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $8cffe22d3a2884c1$var$et(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $8cffe22d3a2884c1$var$nt(t) {
    return "string" == typeof t ? $8cffe22d3a2884c1$var$J.fromBase64String(t) : $8cffe22d3a2884c1$var$J.fromUint8Array(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $8cffe22d3a2884c1$var$rt(t) {
    var e, n;
    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $8cffe22d3a2884c1$var$it(t) {
    var e = t.mapValue.fields.__previous_value__;
    return $8cffe22d3a2884c1$var$rt(e) ? $8cffe22d3a2884c1$var$it(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $8cffe22d3a2884c1$var$ot(t) {
    var e = $8cffe22d3a2884c1$var$tt(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ /**
 * Returns whether a variable is either undefined or null.
 */ function $8cffe22d3a2884c1$var$st(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $8cffe22d3a2884c1$var$ut(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $8cffe22d3a2884c1$var$at(t) {
    return "number" == typeof t && Number.isInteger(t) && !$8cffe22d3a2884c1$var$ut(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$ct = /** @class */ function() {
    function t(t) {
        this.path = t;
    }
    return t.fromPath = function(e) {
        return new t($8cffe22d3a2884c1$var$H.fromString(e));
    }, t.fromName = function(e) {
        return new t($8cffe22d3a2884c1$var$H.fromString(e).popFirst(5));
    }, /** Returns true if the document is in the specified collectionId. */ t.prototype.hasCollectionId = function(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }, t.prototype.isEqual = function(t) {
        return null !== t && 0 === $8cffe22d3a2884c1$var$H.comparator(this.path, t.path);
    }, t.prototype.toString = function() {
        return this.path.toString();
    }, t.comparator = function(t, e) {
        return $8cffe22d3a2884c1$var$H.comparator(t.path, e.path);
    }, t.isDocumentKey = function(t) {
        return t.length % 2 == 0;
    }, /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ t.fromSegments = function(e) {
        return new t(new $8cffe22d3a2884c1$var$H(e.slice()));
    }, t;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Extracts the backend's type order for the provided value. */ function $8cffe22d3a2884c1$var$ht(t) {
    return "nullValue" in t ? 0 /* NullValue */  : "booleanValue" in t ? 1 /* BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* NumberValue */  : "timestampValue" in t ? 3 /* TimestampValue */  : "stringValue" in t ? 5 /* StringValue */  : "bytesValue" in t ? 6 /* BlobValue */  : "referenceValue" in t ? 7 /* RefValue */  : "geoPointValue" in t ? 8 /* GeoPointValue */  : "arrayValue" in t ? 9 /* ArrayValue */  : "mapValue" in t ? $8cffe22d3a2884c1$var$rt(t) ? 4 /* ServerTimestampValue */  : 10 /* ObjectValue */  : $8cffe22d3a2884c1$var$O();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $8cffe22d3a2884c1$var$ft(t, e) {
    var n = $8cffe22d3a2884c1$var$ht(t);
    if (n !== $8cffe22d3a2884c1$var$ht(e)) return !1;
    switch(n){
        case 0 /* NullValue */ :
            return !0;
        case 1 /* BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* ServerTimestampValue */ :
            return $8cffe22d3a2884c1$var$ot(t).isEqual($8cffe22d3a2884c1$var$ot(e));
        case 3 /* TimestampValue */ :
            return function(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                var n = $8cffe22d3a2884c1$var$tt(t.timestampValue), r = $8cffe22d3a2884c1$var$tt(e.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(t, e);
        case 5 /* StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* BlobValue */ :
            return function(t, e) {
                return $8cffe22d3a2884c1$var$nt(t.bytesValue).isEqual($8cffe22d3a2884c1$var$nt(e.bytesValue));
            }(t, e);
        case 7 /* RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                return $8cffe22d3a2884c1$var$et(t.geoPointValue.latitude) === $8cffe22d3a2884c1$var$et(e.geoPointValue.latitude) && $8cffe22d3a2884c1$var$et(t.geoPointValue.longitude) === $8cffe22d3a2884c1$var$et(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* NumberValue */ :
            return function(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $8cffe22d3a2884c1$var$et(t.integerValue) === $8cffe22d3a2884c1$var$et(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    var n = $8cffe22d3a2884c1$var$et(t.doubleValue), r = $8cffe22d3a2884c1$var$et(e.doubleValue);
                    return n === r ? $8cffe22d3a2884c1$var$ut(n) === $8cffe22d3a2884c1$var$ut(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(t, e);
        case 9 /* ArrayValue */ :
            return $8cffe22d3a2884c1$var$U(t.arrayValue.values || [], e.arrayValue.values || [], $8cffe22d3a2884c1$var$ft);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                var n = t.mapValue.fields || {}, r = e.mapValue.fields || {};
                if ($8cffe22d3a2884c1$var$G(n) !== $8cffe22d3a2884c1$var$G(r)) return !1;
                for(var i in n)if (n.hasOwnProperty(i) && (void 0 === r[i] || !$8cffe22d3a2884c1$var$ft(n[i], r[i]))) return !1;
                return !0;
            }(t, e);
        default:
            return $8cffe22d3a2884c1$var$O();
    }
}
function $8cffe22d3a2884c1$var$lt(t, e) {
    return void 0 !== (t.values || []).find(function(t) {
        return $8cffe22d3a2884c1$var$ft(t, e);
    });
}
function $8cffe22d3a2884c1$var$dt(t, e) {
    var n = $8cffe22d3a2884c1$var$ht(t), r = $8cffe22d3a2884c1$var$ht(e);
    if (n !== r) return $8cffe22d3a2884c1$var$q(n, r);
    switch(n){
        case 0 /* NullValue */ :
            return 0;
        case 1 /* BooleanValue */ :
            return $8cffe22d3a2884c1$var$q(t.booleanValue, e.booleanValue);
        case 2 /* NumberValue */ :
            return function(t, e) {
                var n = $8cffe22d3a2884c1$var$et(t.integerValue || t.doubleValue), r = $8cffe22d3a2884c1$var$et(e.integerValue || e.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TimestampValue */ :
            return $8cffe22d3a2884c1$var$pt(t.timestampValue, e.timestampValue);
        case 4 /* ServerTimestampValue */ :
            return $8cffe22d3a2884c1$var$pt($8cffe22d3a2884c1$var$ot(t), $8cffe22d3a2884c1$var$ot(e));
        case 5 /* StringValue */ :
            return $8cffe22d3a2884c1$var$q(t.stringValue, e.stringValue);
        case 6 /* BlobValue */ :
            return function(t, e) {
                var n = $8cffe22d3a2884c1$var$nt(t), r = $8cffe22d3a2884c1$var$nt(e);
                return n.compareTo(r);
            }(t.bytesValue, e.bytesValue);
        case 7 /* RefValue */ :
            return function(t, e) {
                for(var n = t.split("/"), r = e.split("/"), i = 0; i < n.length && i < r.length; i++){
                    var o = $8cffe22d3a2884c1$var$q(n[i], r[i]);
                    if (0 !== o) return o;
                }
                return $8cffe22d3a2884c1$var$q(n.length, r.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                var n = $8cffe22d3a2884c1$var$q($8cffe22d3a2884c1$var$et(t.latitude), $8cffe22d3a2884c1$var$et(e.latitude));
                return 0 !== n ? n : $8cffe22d3a2884c1$var$q($8cffe22d3a2884c1$var$et(t.longitude), $8cffe22d3a2884c1$var$et(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* ArrayValue */ :
            return function(t, e) {
                for(var n = t.values || [], r = e.values || [], i = 0; i < n.length && i < r.length; ++i){
                    var o = $8cffe22d3a2884c1$var$dt(n[i], r[i]);
                    if (o) return o;
                }
                return $8cffe22d3a2884c1$var$q(n.length, r.length);
            }(t.arrayValue, e.arrayValue);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                var n = t.fields || {}, r = Object.keys(n), i = e.fields || {}, o = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), o.sort();
                for(var s = 0; s < r.length && s < o.length; ++s){
                    var u = $8cffe22d3a2884c1$var$q(r[s], o[s]);
                    if (0 !== u) return u;
                    var a = $8cffe22d3a2884c1$var$dt(n[r[s]], i[o[s]]);
                    if (0 !== a) return a;
                }
                return $8cffe22d3a2884c1$var$q(r.length, o.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $8cffe22d3a2884c1$var$O();
    }
}
function $8cffe22d3a2884c1$var$pt(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $8cffe22d3a2884c1$var$q(t, e);
    var n = $8cffe22d3a2884c1$var$tt(t), r = $8cffe22d3a2884c1$var$tt(e), i = $8cffe22d3a2884c1$var$q(n.seconds, r.seconds);
    return 0 !== i ? i : $8cffe22d3a2884c1$var$q(n.nanos, r.nanos);
}
function $8cffe22d3a2884c1$var$yt(t) {
    return $8cffe22d3a2884c1$var$vt(t);
}
function $8cffe22d3a2884c1$var$vt(t) {
    var e, n;
    return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function(t) {
        var e = $8cffe22d3a2884c1$var$tt(t);
        return "time(" + e.seconds + "," + e.nanos + ")";
    }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? $8cffe22d3a2884c1$var$nt(t.bytesValue).toBase64() : "referenceValue" in t ? (n = t.referenceValue, $8cffe22d3a2884c1$var$ct.fromName(n).toString()) : "geoPointValue" in t ? "geo(" + (e = t.geoPointValue).latitude + "," + e.longitude + ")" : "arrayValue" in t ? function(t) {
        for(var e = "[", n = !0, r = 0, i = t.values || []; r < i.length; r++)n ? n = !1 : e += ",", e += $8cffe22d3a2884c1$var$vt(i[r]);
        return e + "]";
    }(t.arrayValue) : "mapValue" in t ? function(t) {
        for(// Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        var e = "{", n = !0, r = 0, i = Object.keys(t.fields || {}).sort(); r < i.length; r++){
            var o = i[r];
            n ? n = !1 : e += ",", e += o + ":" + $8cffe22d3a2884c1$var$vt(t.fields[o]);
        }
        return e + "}";
    }(t.mapValue) : $8cffe22d3a2884c1$var$O();
}
function $8cffe22d3a2884c1$var$mt(t, e) {
    return {
        referenceValue: "projects/" + t.projectId + "/databases/" + t.database + "/documents/" + e.path.canonicalString()
    };
}
/** Returns true if `value` is an IntegerValue . */ function $8cffe22d3a2884c1$var$gt(t) {
    return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $8cffe22d3a2884c1$var$wt(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $8cffe22d3a2884c1$var$bt(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $8cffe22d3a2884c1$var$It(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $8cffe22d3a2884c1$var$Tt(t) {
    return !!t && "mapValue" in t;
}
/** Creates a deep copy of `source`. */ function $8cffe22d3a2884c1$var$_t(t) {
    if (t.geoPointValue) return {
        geoPointValue: Object.assign({}, t.geoPointValue)
    };
    if (t.timestampValue && "object" == typeof t.timestampValue) return {
        timestampValue: Object.assign({}, t.timestampValue)
    };
    if (t.mapValue) {
        var e = {
            mapValue: {
                fields: {}
            }
        };
        return $8cffe22d3a2884c1$var$Q(t.mapValue.fields, function(t, n) {
            return e.mapValue.fields[t] = $8cffe22d3a2884c1$var$_t(n);
        }), e;
    }
    if (t.arrayValue) {
        for(var n = {
            arrayValue: {
                values: []
            }
        }, r = 0; r < (t.arrayValue.values || []).length; ++r)n.arrayValue.values[r] = $8cffe22d3a2884c1$var$_t(t.arrayValue.values[r]);
        return n;
    }
    return Object.assign({}, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ var $8cffe22d3a2884c1$var$Et = /** @class */ function() {
    function t(t) {
        this.value = t;
    }
    return t.empty = function() {
        return new t({
            mapValue: {}
        });
    }, /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ t.prototype.field = function(t) {
        if (t.isEmpty()) return this.value;
        for(var e = this.value, n = 0; n < t.length - 1; ++n)if (!$8cffe22d3a2884c1$var$Tt(e = (e.mapValue.fields || {})[t.get(n)])) return null;
        return (e = (e.mapValue.fields || {})[t.lastSegment()]) || null;
    }, /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ t.prototype.set = function(t, e) {
        this.getFieldsMap(t.popLast())[t.lastSegment()] = $8cffe22d3a2884c1$var$_t(e);
    }, /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ t.prototype.setAll = function(t) {
        var e = this, n = $8cffe22d3a2884c1$var$$.emptyPath(), r = {}, i = [];
        t.forEach(function(t, o) {
            if (!n.isImmediateParentOf(o)) {
                // Insert the accumulated changes at this parent location
                var s = e.getFieldsMap(n);
                e.applyChanges(s, r, i), r = {}, i = [], n = o.popLast();
            }
            t ? r[o.lastSegment()] = $8cffe22d3a2884c1$var$_t(t) : i.push(o.lastSegment());
        });
        var o = this.getFieldsMap(n);
        this.applyChanges(o, r, i);
    }, /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ t.prototype.delete = function(t) {
        var e = this.field(t.popLast());
        $8cffe22d3a2884c1$var$Tt(e) && e.mapValue.fields && delete e.mapValue.fields[t.lastSegment()];
    }, t.prototype.isEqual = function(t) {
        return $8cffe22d3a2884c1$var$ft(this.value, t.value);
    }, /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ t.prototype.getFieldsMap = function(t) {
        var e = this.value;
        e.mapValue.fields || (e.mapValue = {
            fields: {}
        });
        for(var n = 0; n < t.length; ++n){
            var r = e.mapValue.fields[t.get(n)];
            $8cffe22d3a2884c1$var$Tt(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, e.mapValue.fields[t.get(n)] = r), e = r;
        }
        return e.mapValue.fields;
    }, /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ t.prototype.applyChanges = function(t, e, n) {
        $8cffe22d3a2884c1$var$Q(e, function(e, n) {
            return t[e] = n;
        });
        for(var r = 0, i = n; r < i.length; r++){
            var o = i[r];
            delete t[o];
        }
    }, t.prototype.clone = function() {
        return new t($8cffe22d3a2884c1$var$_t(this.value));
    }, t;
}();
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $8cffe22d3a2884c1$var$St(t) {
    var e = [];
    return $8cffe22d3a2884c1$var$Q(t.fields, function(t, n) {
        var r = new $8cffe22d3a2884c1$var$$([
            t
        ]);
        if ($8cffe22d3a2884c1$var$Tt(n)) {
            var i = $8cffe22d3a2884c1$var$St(n.mapValue).fields;
            if (0 === i.length) // Preserve the empty map by adding it to the FieldMask.
            e.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for(var o = 0, s = i; o < s.length; o++){
                var u = s[o];
                e.push(r.child(u));
            }
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        e.push(r);
    }), new $8cffe22d3a2884c1$var$X(e) /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ ;
}
var $8cffe22d3a2884c1$var$Nt = /** @class */ function() {
    function t(t, e, n, r, i) {
        this.key = t, this.documentType = e, this.version = n, this.data = r, this.documentState = i /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ ;
    }
    return t.newInvalidDocument = function(e) {
        return new t(e, 0 /* INVALID */ , $8cffe22d3a2884c1$var$K.min(), $8cffe22d3a2884c1$var$Et.empty(), 0 /* SYNCED */ );
    }, /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ t.newFoundDocument = function(e, n, r) {
        return new t(e, 1 /* FOUND_DOCUMENT */ , n, r, 0 /* SYNCED */ );
    }, /** Creates a new document that is known to not exist at the given version. */ t.newNoDocument = function(e, n) {
        return new t(e, 2 /* NO_DOCUMENT */ , n, $8cffe22d3a2884c1$var$Et.empty(), 0 /* SYNCED */ );
    }, /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ t.newUnknownDocument = function(e, n) {
        return new t(e, 3 /* UNKNOWN_DOCUMENT */ , n, $8cffe22d3a2884c1$var$Et.empty(), 2 /* HAS_COMMITTED_MUTATIONS */ );
    }, /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ t.prototype.convertToFoundDocument = function(t, e) {
        return this.version = t, this.documentType = 1 /* FOUND_DOCUMENT */ , this.data = e, this.documentState = 0 /* SYNCED */ , this;
    }, /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ t.prototype.convertToNoDocument = function(t) {
        return this.version = t, this.documentType = 2 /* NO_DOCUMENT */ , this.data = $8cffe22d3a2884c1$var$Et.empty(), this.documentState = 0 /* SYNCED */ , this;
    }, /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ t.prototype.convertToUnknownDocument = function(t) {
        return this.version = t, this.documentType = 3 /* UNKNOWN_DOCUMENT */ , this.data = $8cffe22d3a2884c1$var$Et.empty(), this.documentState = 2 /* HAS_COMMITTED_MUTATIONS */ , this;
    }, t.prototype.setHasCommittedMutations = function() {
        return this.documentState = 2 /* HAS_COMMITTED_MUTATIONS */ , this;
    }, t.prototype.setHasLocalMutations = function() {
        return this.documentState = 1 /* HAS_LOCAL_MUTATIONS */ , this;
    }, Object.defineProperty(t.prototype, "hasLocalMutations", {
        get: function() {
            return 1 /* HAS_LOCAL_MUTATIONS */  === this.documentState;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hasCommittedMutations", {
        get: function() {
            return 2 /* HAS_COMMITTED_MUTATIONS */  === this.documentState;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hasPendingWrites", {
        get: function() {
            return this.hasLocalMutations || this.hasCommittedMutations;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isValidDocument = function() {
        return 0 /* INVALID */  !== this.documentType;
    }, t.prototype.isFoundDocument = function() {
        return 1 /* FOUND_DOCUMENT */  === this.documentType;
    }, t.prototype.isNoDocument = function() {
        return 2 /* NO_DOCUMENT */  === this.documentType;
    }, t.prototype.isUnknownDocument = function() {
        return 3 /* UNKNOWN_DOCUMENT */  === this.documentType;
    }, t.prototype.isEqual = function(e) {
        return e instanceof t && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }, t.prototype.clone = function() {
        return new t(this.key, this.documentType, this.version, this.data.clone(), this.documentState);
    }, t.prototype.toString = function() {
        return "Document(" + this.key + ", " + this.version + ", " + JSON.stringify(this.data.value) + ", {documentType: " + this.documentType + "}), {documentState: " + this.documentState + "})";
    }, t;
}(), $8cffe22d3a2884c1$var$Dt = function(t, e, n, r, i, o, s) {
    void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = null), void 0 === s && (s = null), this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = o, this.endAt = s, this.h = null;
};
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $8cffe22d3a2884c1$var$At(t, e, n, r, i, o, s) {
    return void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = null), void 0 === s && (s = null), new $8cffe22d3a2884c1$var$Dt(t, e, n, r, i, o, s);
}
function $8cffe22d3a2884c1$var$kt(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    if (null === e.h) {
        var n = e.path.canonicalString();
        null !== e.collectionGroup && (n += "|cg:" + e.collectionGroup), n += "|f:", n += e.filters.map(function(t) {
            return function(t) {
                // TODO(b/29183165): Technically, this won't be unique if two values have
                // the same description, such as the int 3 and the string "3". So we should
                // add the types in here somehow, too.
                return t.field.canonicalString() + t.op.toString() + $8cffe22d3a2884c1$var$yt(t.value);
            }(t);
        }).join(","), n += "|ob:", n += e.orderBy.map(function(t) {
            return function(t) {
                // TODO(b/29183165): Make this collision robust.
                return t.field.canonicalString() + t.dir;
            }(t);
        }).join(","), $8cffe22d3a2884c1$var$st(e.limit) || (n += "|l:", n += e.limit), e.startAt && (n += "|lb:", n += $8cffe22d3a2884c1$var$jt(e.startAt)), e.endAt && (n += "|ub:", n += $8cffe22d3a2884c1$var$jt(e.endAt)), e.h = n;
    }
    return e.h;
}
function $8cffe22d3a2884c1$var$Ct(t, e) {
    if (t.limit !== e.limit) return !1;
    if (t.orderBy.length !== e.orderBy.length) return !1;
    for(var n = 0; n < t.orderBy.length; n++)if (!$8cffe22d3a2884c1$var$Gt(t.orderBy[n], e.orderBy[n])) return !1;
    if (t.filters.length !== e.filters.length) return !1;
    for(var r = 0; r < t.filters.length; r++)if (i = t.filters[r], o = e.filters[r], i.op !== o.op || !i.field.isEqual(o.field) || !$8cffe22d3a2884c1$var$ft(i.value, o.value)) return !1;
    var i, o;
    return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!$8cffe22d3a2884c1$var$zt(t.startAt, e.startAt) && $8cffe22d3a2884c1$var$zt(t.endAt, e.endAt);
}
function $8cffe22d3a2884c1$var$xt(t) {
    return $8cffe22d3a2884c1$var$ct.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
}
var $8cffe22d3a2884c1$var$Rt = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).field = t, i.op = n, i.value = r, i;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ return (0, $2WUgS.__extends)(n, e), n.create = function(t, e, r) {
        return t.isKeyField() ? "in" /* IN */  === e || "not-in" /* NOT_IN */  === e ? this.l(t, e, r) : new $8cffe22d3a2884c1$var$Lt(t, e, r) : "array-contains" /* ARRAY_CONTAINS */  === e ? new $8cffe22d3a2884c1$var$Mt(t, r) : "in" /* IN */  === e ? new $8cffe22d3a2884c1$var$Vt(t, r) : "not-in" /* NOT_IN */  === e ? new $8cffe22d3a2884c1$var$qt(t, r) : "array-contains-any" /* ARRAY_CONTAINS_ANY */  === e ? new $8cffe22d3a2884c1$var$Ut(t, r) : new n(t, e, r);
    }, n.l = function(t, e, n) {
        return "in" /* IN */  === e ? new $8cffe22d3a2884c1$var$Ot(t, n) : new $8cffe22d3a2884c1$var$Pt(t, n);
    }, n.prototype.matches = function(t) {
        var e = t.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* NOT_EQUAL */  === this.op ? null !== e && this.m($8cffe22d3a2884c1$var$dt(e, this.value)) : null !== e && $8cffe22d3a2884c1$var$ht(this.value) === $8cffe22d3a2884c1$var$ht(e) && this.m($8cffe22d3a2884c1$var$dt(e, this.value));
    // Only compare types with matching backend order (such as double and int).
    }, n.prototype.m = function(t) {
        switch(this.op){
            case "<" /* LESS_THAN */ :
                return t < 0;
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* EQUAL */ :
                return 0 === t;
            case "!=" /* NOT_EQUAL */ :
                return 0 !== t;
            case ">" /* GREATER_THAN */ :
                return t > 0;
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $8cffe22d3a2884c1$var$O();
        }
    }, n.prototype.g = function() {
        return [
            "<" /* LESS_THAN */ ,
            "<=" /* LESS_THAN_OR_EQUAL */ ,
            ">" /* GREATER_THAN */ ,
            ">=" /* GREATER_THAN_OR_EQUAL */ ,
            "!=" /* NOT_EQUAL */ ,
            "not-in" /* NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }, n;
}(function() {});
var $8cffe22d3a2884c1$var$Lt = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this, t, n, r) || this).key = $8cffe22d3a2884c1$var$ct.fromName(r.referenceValue), i;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.matches = function(t) {
        var e = $8cffe22d3a2884c1$var$ct.comparator(t.key, this.key);
        return this.m(e);
    }, n;
}($8cffe22d3a2884c1$var$Rt), $8cffe22d3a2884c1$var$Ot = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t, "in" /* IN */ , n) || this).keys = $8cffe22d3a2884c1$var$Ft("in" /* IN */ , n), r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.matches = function(t) {
        return this.keys.some(function(e) {
            return e.isEqual(t.key);
        });
    }, n;
}($8cffe22d3a2884c1$var$Rt), $8cffe22d3a2884c1$var$Pt = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t, "not-in" /* NOT_IN */ , n) || this).keys = $8cffe22d3a2884c1$var$Ft("not-in" /* NOT_IN */ , n), r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.matches = function(t) {
        return !this.keys.some(function(e) {
            return e.isEqual(t.key);
        });
    }, n;
}($8cffe22d3a2884c1$var$Rt);
/** Filter that matches on key fields within an array. */ function $8cffe22d3a2884c1$var$Ft(t, e) {
    var n;
    return ((null === (n = e.arrayValue) || void 0 === n ? void 0 : n.values) || []).map(function(t) {
        return $8cffe22d3a2884c1$var$ct.fromName(t.referenceValue);
    });
}
/** A Filter that implements the array-contains operator. */ var $8cffe22d3a2884c1$var$Mt = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "array-contains" /* ARRAY_CONTAINS */ , n) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.matches = function(t) {
        var e = t.data.field(this.field);
        return $8cffe22d3a2884c1$var$wt(e) && $8cffe22d3a2884c1$var$lt(e.arrayValue, this.value);
    }, n;
}($8cffe22d3a2884c1$var$Rt), $8cffe22d3a2884c1$var$Vt = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "in" /* IN */ , n) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.matches = function(t) {
        var e = t.data.field(this.field);
        return null !== e && $8cffe22d3a2884c1$var$lt(this.value.arrayValue, e);
    }, n;
}($8cffe22d3a2884c1$var$Rt), $8cffe22d3a2884c1$var$qt = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "not-in" /* NOT_IN */ , n) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.matches = function(t) {
        if ($8cffe22d3a2884c1$var$lt(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        var e = t.data.field(this.field);
        return null !== e && !$8cffe22d3a2884c1$var$lt(this.value.arrayValue, e);
    }, n;
}($8cffe22d3a2884c1$var$Rt), $8cffe22d3a2884c1$var$Ut = /** @class */ function(e) {
    function n(t, n) {
        return e.call(this, t, "array-contains-any" /* ARRAY_CONTAINS_ANY */ , n) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.matches = function(t) {
        var e = this, n = t.data.field(this.field);
        return !(!$8cffe22d3a2884c1$var$wt(n) || !n.arrayValue.values) && n.arrayValue.values.some(function(t) {
            return $8cffe22d3a2884c1$var$lt(e.value.arrayValue, t);
        });
    }, n;
}($8cffe22d3a2884c1$var$Rt), $8cffe22d3a2884c1$var$Bt = function(t, e) {
    this.position = t, this.before = e;
};
/** A Filter that implements the IN operator. */ function $8cffe22d3a2884c1$var$jt(t) {
    // TODO(b/29183165): Make this collision robust.
    return (t.before ? "b" : "a") + ":" + t.position.map(function(t) {
        return $8cffe22d3a2884c1$var$yt(t);
    }).join(",");
}
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ var $8cffe22d3a2884c1$var$Kt = function(t, e /* ASCENDING */ ) {
    void 0 === e && (e = "asc"), this.field = t, this.dir = e;
};
function $8cffe22d3a2884c1$var$Gt(t, e) {
    return t.dir === e.dir && t.field.isEqual(e.field);
}
/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function $8cffe22d3a2884c1$var$Qt(t, e, n) {
    for(var r = 0, i = 0; i < t.position.length; i++){
        var o = e[i], s = t.position[i];
        if (r = o.field.isKeyField() ? $8cffe22d3a2884c1$var$ct.comparator($8cffe22d3a2884c1$var$ct.fromName(s.referenceValue), n.key) : $8cffe22d3a2884c1$var$dt(s, n.data.field(o.field)), "desc" /* DESCENDING */  === o.dir && (r *= -1), 0 !== r) break;
    }
    return t.before ? r <= 0 : r < 0;
}
function $8cffe22d3a2884c1$var$zt(t, e) {
    if (null === t) return null === e;
    if (null === e) return !1;
    if (t.before !== e.before || t.position.length !== e.position.length) return !1;
    for(var n = 0; n < t.position.length; n++)if (!$8cffe22d3a2884c1$var$ft(t.position[n], e.position[n])) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ var $8cffe22d3a2884c1$var$Wt = /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ function(t, e, n, r, i, o /* First */ , s, u) {
    void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = "F"), void 0 === s && (s = null), void 0 === u && (u = null), this.path = t, this.collectionGroup = e, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = o, this.startAt = s, this.endAt = u, this.p = null, // The corresponding `Target` of this `Query` instance.
    this.T = null, this.startAt, this.endAt;
};
/** Creates a new Query instance with the options provided. */ function $8cffe22d3a2884c1$var$Ht(t, e, n, r, i, o, s, u) {
    return new $8cffe22d3a2884c1$var$Wt(t, e, n, r, i, o, s, u);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $8cffe22d3a2884c1$var$Yt(t) {
    return new $8cffe22d3a2884c1$var$Wt(t);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ function $8cffe22d3a2884c1$var$$t(t) {
    return !$8cffe22d3a2884c1$var$st(t.limit) && "F" /* First */  === t.limitType;
}
function $8cffe22d3a2884c1$var$Xt(t) {
    return !$8cffe22d3a2884c1$var$st(t.limit) && "L" /* Last */  === t.limitType;
}
function $8cffe22d3a2884c1$var$Jt(t) {
    return t.explicitOrderBy.length > 0 ? t.explicitOrderBy[0].field : null;
}
function $8cffe22d3a2884c1$var$Zt(t) {
    for(var e = 0, n = t.filters; e < n.length; e++){
        var r = n[e];
        if (r.g()) return r.field;
    }
    return null;
}
/**
 * Checks if any of the provided Operators are included in the query and
 * returns the first one that is, or null if none are.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $8cffe22d3a2884c1$var$te(t) {
    return null !== t.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */ function $8cffe22d3a2884c1$var$ee(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    if (null === e.p) {
        e.p = [];
        var n = $8cffe22d3a2884c1$var$Zt(e), r = $8cffe22d3a2884c1$var$Jt(e);
        if (null !== n && null === r) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        n.isKeyField() || e.p.push(new $8cffe22d3a2884c1$var$Kt(n)), e.p.push(new $8cffe22d3a2884c1$var$Kt($8cffe22d3a2884c1$var$$.keyField(), "asc" /* ASCENDING */ ));
        else {
            for(var i = !1, o = 0, s = e.explicitOrderBy; o < s.length; o++){
                var u = s[o];
                e.p.push(u), u.field.isKeyField() && (i = !0);
            }
            if (!i) {
                // The order of the implicit key ordering always matches the last
                // explicit order by
                var a = e.explicitOrderBy.length > 0 ? e.explicitOrderBy[e.explicitOrderBy.length - 1].dir : "asc" /* ASCENDING */ ;
                e.p.push(new $8cffe22d3a2884c1$var$Kt($8cffe22d3a2884c1$var$$.keyField(), a));
            }
        }
    }
    return e.p;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */ function $8cffe22d3a2884c1$var$ne(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    if (!e.T) {
        if ("F" /* First */  === e.limitType) e.T = $8cffe22d3a2884c1$var$At(e.path, e.collectionGroup, $8cffe22d3a2884c1$var$ee(e), e.filters, e.limit, e.startAt, e.endAt);
        else {
            for(// Flip the orderBy directions since we want the last results
            var n = [], r = 0, i = $8cffe22d3a2884c1$var$ee(e); r < i.length; r++){
                var o = i[r], s = "desc" /* DESCENDING */  === o.dir ? "asc" /* ASCENDING */  : "desc" /* DESCENDING */ ;
                n.push(new $8cffe22d3a2884c1$var$Kt(o.field, s));
            }
            // We need to swap the cursors to match the now-flipped query ordering.
            var u = e.endAt ? new $8cffe22d3a2884c1$var$Bt(e.endAt.position, !e.endAt.before) : null, a = e.startAt ? new $8cffe22d3a2884c1$var$Bt(e.startAt.position, !e.startAt.before) : null;
            // Now return as a LimitType.First query.
            e.T = $8cffe22d3a2884c1$var$At(e.path, e.collectionGroup, n, e.filters, e.limit, u, a);
        }
    }
    return e.T;
}
function $8cffe22d3a2884c1$var$re(t, e, n) {
    return new $8cffe22d3a2884c1$var$Wt(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
}
function $8cffe22d3a2884c1$var$ie(t, e) {
    return $8cffe22d3a2884c1$var$Ct($8cffe22d3a2884c1$var$ne(t), $8cffe22d3a2884c1$var$ne(e)) && t.limitType === e.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $8cffe22d3a2884c1$var$oe(t) {
    return $8cffe22d3a2884c1$var$kt($8cffe22d3a2884c1$var$ne(t)) + "|lt:" + t.limitType;
}
function $8cffe22d3a2884c1$var$se(t) {
    return "Query(target=" + function(t) {
        var e = t.path.canonicalString();
        return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), t.filters.length > 0 && (e += ", filters: [" + t.filters.map(function(t) {
            var e;
            return (e = t).field.canonicalString() + " " + e.op + " " + $8cffe22d3a2884c1$var$yt(e.value);
        /** Filter that matches on key fields (i.e. '__name__'). */ }).join(", ") + "]"), $8cffe22d3a2884c1$var$st(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += ", orderBy: [" + t.orderBy.map(function(t) {
            return function(t) {
                return t.field.canonicalString() + " (" + t.dir + ")";
            }(t);
        }).join(", ") + "]"), t.startAt && (e += ", startAt: " + $8cffe22d3a2884c1$var$jt(t.startAt)), t.endAt && (e += ", endAt: " + $8cffe22d3a2884c1$var$jt(t.endAt)), "Target(" + e + ")";
    }($8cffe22d3a2884c1$var$ne(t)) + "; limitType=" + t.limitType + ")";
}
/** Returns whether `doc` matches the constraints of `query`. */ function $8cffe22d3a2884c1$var$ue(t, e) {
    return e.isFoundDocument() && function(t, e) {
        var n = e.key.path;
        return null !== t.collectionGroup ? e.key.hasCollectionId(t.collectionGroup) && t.path.isPrefixOf(n) : $8cffe22d3a2884c1$var$ct.isDocumentKey(t.path) ? t.path.isEqual(n) : t.path.isImmediateParentOf(n);
    }(t, e) && function(t, e) {
        for(var n = 0, r = t.explicitOrderBy; n < r.length; n++){
            var i = r[n];
            // order by key always matches
            if (!i.field.isKeyField() && null === e.data.field(i.field)) return !1;
        }
        return !0;
    }(t, e) && function(t, e) {
        for(var n = 0, r = t.filters; n < r.length; n++){
            if (!r[n].matches(e)) return !1;
        }
        return !0;
    }(t, e) && function(t, e) {
        return !(t.startAt && !$8cffe22d3a2884c1$var$Qt(t.startAt, $8cffe22d3a2884c1$var$ee(t), e)) && (!t.endAt || !$8cffe22d3a2884c1$var$Qt(t.endAt, $8cffe22d3a2884c1$var$ee(t), e));
    }(t, e);
}
function $8cffe22d3a2884c1$var$ae(t) {
    return function(e, n) {
        for(var r = !1, i = 0, o = $8cffe22d3a2884c1$var$ee(t); i < o.length; i++){
            var s = o[i], u = $8cffe22d3a2884c1$var$ce(s, e, n);
            if (0 !== u) return u;
            r = r || s.field.isKeyField();
        }
        return 0;
    };
}
function $8cffe22d3a2884c1$var$ce(t, e, n) {
    var r = t.field.isKeyField() ? $8cffe22d3a2884c1$var$ct.comparator(e.key, n.key) : function(t, e, n) {
        var r = e.data.field(t), i = n.data.field(t);
        return null !== r && null !== i ? $8cffe22d3a2884c1$var$dt(r, i) : $8cffe22d3a2884c1$var$O();
    }(t.field, e, n);
    switch(t.dir){
        case "asc" /* ASCENDING */ :
            return r;
        case "desc" /* DESCENDING */ :
            return -1 * r;
        default:
            return $8cffe22d3a2884c1$var$O();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $8cffe22d3a2884c1$var$he(t, e) {
    if (t.I) {
        if (isNaN(e)) return {
            doubleValue: "NaN"
        };
        if (e === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (e === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $8cffe22d3a2884c1$var$ut(e) ? "-0" : e
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $8cffe22d3a2884c1$var$fe(t) {
    return {
        integerValue: "" + t
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $8cffe22d3a2884c1$var$le(t, e) {
    return $8cffe22d3a2884c1$var$at(e) ? $8cffe22d3a2884c1$var$fe(e) : $8cffe22d3a2884c1$var$he(t, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ var $8cffe22d3a2884c1$var$de = function() {
    // Make sure that the structural type of `TransformOperation` is unique.
    // See https://github.com/microsoft/TypeScript/issues/5451
    this._ = void 0;
};
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $8cffe22d3a2884c1$var$pe(t, e, n) {
    return t instanceof $8cffe22d3a2884c1$var$me ? function(t, e) {
        var n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: t.seconds,
                        nanos: t.nanoseconds
                    }
                }
            }
        };
        return e && (n.fields.__previous_value__ = e), {
            mapValue: n
        };
    }(n, e) : t instanceof $8cffe22d3a2884c1$var$ge ? $8cffe22d3a2884c1$var$we(t, e) : t instanceof $8cffe22d3a2884c1$var$be ? $8cffe22d3a2884c1$var$Ie(t, e) : function(t, e) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        var n = $8cffe22d3a2884c1$var$ve(t, e), r = $8cffe22d3a2884c1$var$_e(n) + $8cffe22d3a2884c1$var$_e(t.A);
        return $8cffe22d3a2884c1$var$gt(n) && $8cffe22d3a2884c1$var$gt(t.A) ? $8cffe22d3a2884c1$var$fe(r) : $8cffe22d3a2884c1$var$he(t.R, r);
    }(t, e);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $8cffe22d3a2884c1$var$ye(t, e, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return t instanceof $8cffe22d3a2884c1$var$ge ? $8cffe22d3a2884c1$var$we(t, e) : t instanceof $8cffe22d3a2884c1$var$be ? $8cffe22d3a2884c1$var$Ie(t, e) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $8cffe22d3a2884c1$var$ve(t, e) {
    var n;
    return t instanceof $8cffe22d3a2884c1$var$Te ? $8cffe22d3a2884c1$var$gt(n = e) || function(t) {
        return !!t && "doubleValue" in t;
    }(n) ? e : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ var $8cffe22d3a2884c1$var$me = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$de), $8cffe22d3a2884c1$var$ge = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).elements = t, n;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$de);
/** Transforms an array value via a union operation. */ function $8cffe22d3a2884c1$var$we(t, e) {
    for(var n = $8cffe22d3a2884c1$var$Ee(e), r = function(t) {
        n.some(function(e) {
            return $8cffe22d3a2884c1$var$ft(e, t);
        }) || n.push(t);
    }, i = 0, o = t.elements; i < o.length; i++)r(o[i]);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ var $8cffe22d3a2884c1$var$be = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).elements = t, n;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$de);
function $8cffe22d3a2884c1$var$Ie(t, e) {
    for(var n = $8cffe22d3a2884c1$var$Ee(e), r = function(t) {
        n = n.filter(function(e) {
            return !$8cffe22d3a2884c1$var$ft(e, t);
        });
    }, i = 0, o = t.elements; i < o.length; i++)r(o[i]);
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ var $8cffe22d3a2884c1$var$Te = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).R = t, r.A = n, r;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$de);
function $8cffe22d3a2884c1$var$_e(t) {
    return $8cffe22d3a2884c1$var$et(t.integerValue || t.doubleValue);
}
function $8cffe22d3a2884c1$var$Ee(t) {
    return $8cffe22d3a2884c1$var$wt(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ var $8cffe22d3a2884c1$var$Se = function(t, e) {
    this.field = t, this.transform = e;
};
/** The result of successfully applying a mutation to the backend. */ var $8cffe22d3a2884c1$var$Ne = function(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ t, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ e) {
    this.version = t, this.transformResults = e;
}, $8cffe22d3a2884c1$var$De = /** @class */ function() {
    function t(t, e) {
        this.updateTime = t, this.exists = e /** Creates a new empty Precondition. */ ;
    }
    return t.none = function() {
        return new t;
    }, /** Creates a new Precondition with an exists flag. */ t.exists = function(e) {
        return new t(void 0, e);
    }, /** Creates a new Precondition based on a version a document exists at. */ t.updateTime = function(e) {
        return new t(e);
    }, Object.defineProperty(t.prototype, "isNone", {
        /** Returns whether this Precondition is empty. */ get: function() {
            return void 0 === this.updateTime && void 0 === this.exists;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }, t;
}();
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ /** Returns true if the preconditions is valid for the given document. */ function $8cffe22d3a2884c1$var$Ae(t, e) {
    return void 0 !== t.updateTime ? e.isFoundDocument() && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `applySetMutationToRemoteDocument()` for an
 * example).
 */ var $8cffe22d3a2884c1$var$ke = function() {};
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $8cffe22d3a2884c1$var$Ce(t, e, n) {
    t instanceof $8cffe22d3a2884c1$var$Pe ? function(t, e, n) {
        // Unlike applySetMutationToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        var r = t.value.clone(), i = $8cffe22d3a2884c1$var$Ve(t.fieldTransforms, e, n.transformResults);
        r.setAll(i), e.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(t, e, n) : t instanceof $8cffe22d3a2884c1$var$Fe ? function(t, e, n) {
        if ($8cffe22d3a2884c1$var$Ae(t.precondition, e)) {
            var r = $8cffe22d3a2884c1$var$Ve(t.fieldTransforms, e, n.transformResults), i = e.data;
            i.setAll($8cffe22d3a2884c1$var$Me(t)), i.setAll(r), e.convertToFoundDocument(n.version, i).setHasCommittedMutations();
        } else e.convertToUnknownDocument(n.version);
    }(t, e, n) : function(t, e, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        e.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, e, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 */ function $8cffe22d3a2884c1$var$xe(t, e, n) {
    t instanceof $8cffe22d3a2884c1$var$Pe ? function(t, e, n) {
        if ($8cffe22d3a2884c1$var$Ae(t.precondition, e)) {
            var r = t.value.clone(), i = $8cffe22d3a2884c1$var$qe(t.fieldTransforms, n, e);
            r.setAll(i), e.convertToFoundDocument($8cffe22d3a2884c1$var$Oe(e), r).setHasLocalMutations();
        }
    }(t, e, n) : t instanceof $8cffe22d3a2884c1$var$Fe ? function(t, e, n) {
        if ($8cffe22d3a2884c1$var$Ae(t.precondition, e)) {
            var r = $8cffe22d3a2884c1$var$qe(t.fieldTransforms, n, e), i = e.data;
            i.setAll($8cffe22d3a2884c1$var$Me(t)), i.setAll(r), e.convertToFoundDocument($8cffe22d3a2884c1$var$Oe(e), i).setHasLocalMutations();
        }
    }(t, e, n) : function(t, e) {
        $8cffe22d3a2884c1$var$Ae(t.precondition, e) && // We don't call `setHasLocalMutations()` since we want to be backwards
        // compatible with the existing SDK behavior.
        e.convertToNoDocument($8cffe22d3a2884c1$var$K.min());
    }(t, e);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $8cffe22d3a2884c1$var$Re(t, e) {
    for(var n = null, r = 0, i = t.fieldTransforms; r < i.length; r++){
        var o = i[r], s = e.data.field(o.field), u = $8cffe22d3a2884c1$var$ve(o.transform, s || null);
        null != u && (null == n && (n = $8cffe22d3a2884c1$var$Et.empty()), n.set(o.field, u));
    }
    return n || null;
}
function $8cffe22d3a2884c1$var$Le(t, e) {
    return t.type === e.type && !!t.key.isEqual(e.key) && !!t.precondition.isEqual(e.precondition) && !!function(t, e) {
        return void 0 === t && void 0 === e || !(!t || !e) && $8cffe22d3a2884c1$var$U(t, e, function(t, e) {
            return function(t, e) {
                return t.field.isEqual(e.field) && function(t, e) {
                    return t instanceof $8cffe22d3a2884c1$var$ge && e instanceof $8cffe22d3a2884c1$var$ge || t instanceof $8cffe22d3a2884c1$var$be && e instanceof $8cffe22d3a2884c1$var$be ? $8cffe22d3a2884c1$var$U(t.elements, e.elements, $8cffe22d3a2884c1$var$ft) : t instanceof $8cffe22d3a2884c1$var$Te && e instanceof $8cffe22d3a2884c1$var$Te ? $8cffe22d3a2884c1$var$ft(t.A, e.A) : t instanceof $8cffe22d3a2884c1$var$me && e instanceof $8cffe22d3a2884c1$var$me;
                }(t.transform, e.transform);
            }(t, e);
        });
    }(t.fieldTransforms, e.fieldTransforms) && (0 /* Set */  === t.type ? t.value.isEqual(e.value) : 1 /* Patch */  !== t.type || t.data.isEqual(e.data) && t.fieldMask.isEqual(e.fieldMask));
}
/**
 * Returns the version from the given document for use as the result of a
 * mutation. Mutations are defined to return the version of the base document
 * only if it is an existing document. Deleted and unknown documents have a
 * post-mutation version of SnapshotVersion.min().
 */ function $8cffe22d3a2884c1$var$Oe(t) {
    return t.isFoundDocument() ? t.version : $8cffe22d3a2884c1$var$K.min();
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ var $8cffe22d3a2884c1$var$Pe = /** @class */ function(e) {
    function n(t, n, r, i) {
        void 0 === i && (i = []);
        var o = this;
        return (o = e.call(this) || this).key = t, o.value = n, o.precondition = r, o.fieldTransforms = i, o.type = 0 /* Set */ , o;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$ke), $8cffe22d3a2884c1$var$Fe = /** @class */ function(e) {
    function n(t, n, r, i, o) {
        void 0 === o && (o = []);
        var s = this;
        return (s = e.call(this) || this).key = t, s.data = n, s.fieldMask = r, s.precondition = i, s.fieldTransforms = o, s.type = 1 /* Patch */ , s;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$ke);
function $8cffe22d3a2884c1$var$Me(t) {
    var e = new Map;
    return t.fieldMask.fields.forEach(function(n) {
        if (!n.isEmpty()) {
            var r = t.data.field(n);
            e.set(n, r);
        }
    }), e /**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ ;
}
function $8cffe22d3a2884c1$var$Ve(t, e, n) {
    var r = new Map;
    $8cffe22d3a2884c1$var$P(t.length === n.length);
    for(var i = 0; i < n.length; i++){
        var o = t[i], s = o.transform, u = e.data.field(o.field);
        r.set(o.field, $8cffe22d3a2884c1$var$ye(s, u, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The current state of the document after applying all
 *     previous mutations.
 * @returns The transform results list.
 */ function $8cffe22d3a2884c1$var$qe(t, e, n) {
    for(var r = new Map, i = 0, o = t; i < o.length; i++){
        var s = o[i], u = s.transform, a = n.data.field(s.field);
        r.set(s.field, $8cffe22d3a2884c1$var$pe(u, a, e));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ var $8cffe22d3a2884c1$var$Ue, $8cffe22d3a2884c1$var$Be, $8cffe22d3a2884c1$var$je = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.precondition = n, r.type = 2 /* Delete */ , r.fieldTransforms = [], r;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$ke), $8cffe22d3a2884c1$var$Ke = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.precondition = n, r.type = 3 /* Verify */ , r.fieldTransforms = [], r;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$ke), $8cffe22d3a2884c1$var$Ge = // TODO(b/33078163): just use simplest form of existence filter for now
function(t) {
    this.count = t;
};
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $8cffe22d3a2884c1$var$Qe(t) {
    switch(t){
        case $8cffe22d3a2884c1$var$N.OK:
            return $8cffe22d3a2884c1$var$O();
        case $8cffe22d3a2884c1$var$N.CANCELLED:
        case $8cffe22d3a2884c1$var$N.UNKNOWN:
        case $8cffe22d3a2884c1$var$N.DEADLINE_EXCEEDED:
        case $8cffe22d3a2884c1$var$N.RESOURCE_EXHAUSTED:
        case $8cffe22d3a2884c1$var$N.INTERNAL:
        case $8cffe22d3a2884c1$var$N.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $8cffe22d3a2884c1$var$N.UNAUTHENTICATED:
            return !1;
        case $8cffe22d3a2884c1$var$N.INVALID_ARGUMENT:
        case $8cffe22d3a2884c1$var$N.NOT_FOUND:
        case $8cffe22d3a2884c1$var$N.ALREADY_EXISTS:
        case $8cffe22d3a2884c1$var$N.PERMISSION_DENIED:
        case $8cffe22d3a2884c1$var$N.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $8cffe22d3a2884c1$var$N.ABORTED:
        case $8cffe22d3a2884c1$var$N.OUT_OF_RANGE:
        case $8cffe22d3a2884c1$var$N.UNIMPLEMENTED:
        case $8cffe22d3a2884c1$var$N.DATA_LOSS:
            return !0;
        default:
            return $8cffe22d3a2884c1$var$O();
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $8cffe22d3a2884c1$var$ze(t) {
    if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $8cffe22d3a2884c1$var$x("GRPC error has no .code"), $8cffe22d3a2884c1$var$N.UNKNOWN;
    switch(t){
        case $8cffe22d3a2884c1$var$Ue.OK:
            return $8cffe22d3a2884c1$var$N.OK;
        case $8cffe22d3a2884c1$var$Ue.CANCELLED:
            return $8cffe22d3a2884c1$var$N.CANCELLED;
        case $8cffe22d3a2884c1$var$Ue.UNKNOWN:
            return $8cffe22d3a2884c1$var$N.UNKNOWN;
        case $8cffe22d3a2884c1$var$Ue.DEADLINE_EXCEEDED:
            return $8cffe22d3a2884c1$var$N.DEADLINE_EXCEEDED;
        case $8cffe22d3a2884c1$var$Ue.RESOURCE_EXHAUSTED:
            return $8cffe22d3a2884c1$var$N.RESOURCE_EXHAUSTED;
        case $8cffe22d3a2884c1$var$Ue.INTERNAL:
            return $8cffe22d3a2884c1$var$N.INTERNAL;
        case $8cffe22d3a2884c1$var$Ue.UNAVAILABLE:
            return $8cffe22d3a2884c1$var$N.UNAVAILABLE;
        case $8cffe22d3a2884c1$var$Ue.UNAUTHENTICATED:
            return $8cffe22d3a2884c1$var$N.UNAUTHENTICATED;
        case $8cffe22d3a2884c1$var$Ue.INVALID_ARGUMENT:
            return $8cffe22d3a2884c1$var$N.INVALID_ARGUMENT;
        case $8cffe22d3a2884c1$var$Ue.NOT_FOUND:
            return $8cffe22d3a2884c1$var$N.NOT_FOUND;
        case $8cffe22d3a2884c1$var$Ue.ALREADY_EXISTS:
            return $8cffe22d3a2884c1$var$N.ALREADY_EXISTS;
        case $8cffe22d3a2884c1$var$Ue.PERMISSION_DENIED:
            return $8cffe22d3a2884c1$var$N.PERMISSION_DENIED;
        case $8cffe22d3a2884c1$var$Ue.FAILED_PRECONDITION:
            return $8cffe22d3a2884c1$var$N.FAILED_PRECONDITION;
        case $8cffe22d3a2884c1$var$Ue.ABORTED:
            return $8cffe22d3a2884c1$var$N.ABORTED;
        case $8cffe22d3a2884c1$var$Ue.OUT_OF_RANGE:
            return $8cffe22d3a2884c1$var$N.OUT_OF_RANGE;
        case $8cffe22d3a2884c1$var$Ue.UNIMPLEMENTED:
            return $8cffe22d3a2884c1$var$N.UNIMPLEMENTED;
        case $8cffe22d3a2884c1$var$Ue.DATA_LOSS:
            return $8cffe22d3a2884c1$var$N.DATA_LOSS;
        default:
            return $8cffe22d3a2884c1$var$O();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($8cffe22d3a2884c1$var$Be = $8cffe22d3a2884c1$var$Ue || ($8cffe22d3a2884c1$var$Ue = {}))[$8cffe22d3a2884c1$var$Be.OK = 0] = "OK", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.CANCELLED = 1] = "CANCELLED", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.UNKNOWN = 2] = "UNKNOWN", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.NOT_FOUND = 5] = "NOT_FOUND", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.ABORTED = 10] = "ABORTED", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.INTERNAL = 13] = "INTERNAL", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.UNAVAILABLE = 14] = "UNAVAILABLE", $8cffe22d3a2884c1$var$Be[$8cffe22d3a2884c1$var$Be.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var $8cffe22d3a2884c1$var$We = /** @class */ function() {
    function t(t, e) {
        this.comparator = t, this.root = e || $8cffe22d3a2884c1$var$Ye.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    return t.prototype.insert = function(e, n) {
        return new t(this.comparator, this.root.insert(e, n, this.comparator).copy(null, null, $8cffe22d3a2884c1$var$Ye.BLACK, null, null));
    }, // Returns a copy of the map, with the specified key removed.
    t.prototype.remove = function(e) {
        return new t(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $8cffe22d3a2884c1$var$Ye.BLACK, null, null));
    }, // Returns the value of the node with the given key, or null.
    t.prototype.get = function(t) {
        for(var e = this.root; !e.isEmpty();){
            var n = this.comparator(t, e.key);
            if (0 === n) return e.value;
            n < 0 ? e = e.left : n > 0 && (e = e.right);
        }
        return null;
    }, // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    t.prototype.indexOf = function(t) {
        for(// Number of nodes that were pruned when descending right
        var e = 0, n = this.root; !n.isEmpty();){
            var r = this.comparator(t, n.key);
            if (0 === r) return e + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (e += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }, t.prototype.isEmpty = function() {
        return this.root.isEmpty();
    }, Object.defineProperty(t.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function() {
            return this.root.size;
        },
        enumerable: !1,
        configurable: !0
    }), // Returns the minimum key in the map.
    t.prototype.minKey = function() {
        return this.root.minKey();
    }, // Returns the maximum key in the map.
    t.prototype.maxKey = function() {
        return this.root.maxKey();
    }, // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.inorderTraversal = function(t) {
        return this.root.inorderTraversal(t);
    }, t.prototype.forEach = function(t) {
        this.inorderTraversal(function(e, n) {
            return t(e, n), !1;
        });
    }, t.prototype.toString = function() {
        var t = [];
        return this.inorderTraversal(function(e, n) {
            return t.push(e + ":" + n), !1;
        }), "{" + t.join(", ") + "}";
    }, // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.reverseTraversal = function(t) {
        return this.root.reverseTraversal(t);
    }, // Returns an iterator over the SortedMap.
    t.prototype.getIterator = function() {
        return new $8cffe22d3a2884c1$var$He(this.root, null, this.comparator, !1);
    }, t.prototype.getIteratorFrom = function(t) {
        return new $8cffe22d3a2884c1$var$He(this.root, t, this.comparator, !1);
    }, t.prototype.getReverseIterator = function() {
        return new $8cffe22d3a2884c1$var$He(this.root, null, this.comparator, !0);
    }, t.prototype.getReverseIteratorFrom = function(t) {
        return new $8cffe22d3a2884c1$var$He(this.root, t, this.comparator, !0);
    }, t;
}(), $8cffe22d3a2884c1$var$He = /** @class */ function() {
    function t(t, e, n, r) {
        this.isReverse = r, this.nodeStack = [];
        for(var i = 1; !t.isEmpty();)if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
        r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.isReverse ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
        }
    }
    return t.prototype.getNext = function() {
        var t = this.nodeStack.pop(), e = {
            key: t.key,
            value: t.value
        };
        if (this.isReverse) for(t = t.left; !t.isEmpty();)this.nodeStack.push(t), t = t.right;
        else for(t = t.right; !t.isEmpty();)this.nodeStack.push(t), t = t.left;
        return e;
    }, t.prototype.hasNext = function() {
        return this.nodeStack.length > 0;
    }, t.prototype.peek = function() {
        if (0 === this.nodeStack.length) return null;
        var t = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }, t;
}(), $8cffe22d3a2884c1$var$Ye = /** @class */ function() {
    function t(e, n, r, i, o) {
        this.key = e, this.value = n, this.color = null != r ? r : t.RED, this.left = null != i ? i : t.EMPTY, this.right = null != o ? o : t.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    return t.prototype.copy = function(e, n, r, i, o) {
        return new t(null != e ? e : this.key, null != n ? n : this.value, null != r ? r : this.color, null != i ? i : this.left, null != o ? o : this.right);
    }, t.prototype.isEmpty = function() {
        return !1;
    }, // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.inorderTraversal = function(t) {
        return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
    }, // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.reverseTraversal = function(t) {
        return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
    }, // Returns the minimum node in the tree.
    t.prototype.min = function() {
        return this.left.isEmpty() ? this : this.left.min();
    }, // Returns the maximum key in the tree.
    t.prototype.minKey = function() {
        return this.min().key;
    }, // Returns the maximum key in the tree.
    t.prototype.maxKey = function() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }, // Returns new tree, with the key/value added.
    t.prototype.insert = function(t, e, n) {
        var r = this, i = n(t, r.key);
        return (r = i < 0 ? r.copy(null, null, null, r.left.insert(t, e, n), null) : 0 === i ? r.copy(null, e, null, null, null) : r.copy(null, null, null, null, r.right.insert(t, e, n))).fixUp();
    }, t.prototype.removeMin = function() {
        if (this.left.isEmpty()) return t.EMPTY;
        var e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), (e = e.copy(null, null, null, e.left.removeMin(), null)).fixUp();
    }, // Returns new tree, with the specified item removed.
    t.prototype.remove = function(e, n) {
        var r, i = this;
        if (n(e, i.key) < 0) i.left.isEmpty() || i.left.isRed() || i.left.left.isRed() || (i = i.moveRedLeft()), i = i.copy(null, null, null, i.left.remove(e, n), null);
        else {
            if (i.left.isRed() && (i = i.rotateRight()), i.right.isEmpty() || i.right.isRed() || i.right.left.isRed() || (i = i.moveRedRight()), 0 === n(e, i.key)) {
                if (i.right.isEmpty()) return t.EMPTY;
                r = i.right.min(), i = i.copy(r.key, r.value, null, null, i.right.removeMin());
            }
            i = i.copy(null, null, null, null, i.right.remove(e, n));
        }
        return i.fixUp();
    }, t.prototype.isRed = function() {
        return this.color;
    }, // Returns new tree after performing any needed rotations.
    t.prototype.fixUp = function() {
        var t = this;
        return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
    }, t.prototype.moveRedLeft = function() {
        var t = this.colorFlip();
        return t.right.left.isRed() && (t = (t = (t = t.copy(null, null, null, null, t.right.rotateRight())).rotateLeft()).colorFlip()), t;
    }, t.prototype.moveRedRight = function() {
        var t = this.colorFlip();
        return t.left.left.isRed() && (t = (t = t.rotateRight()).colorFlip()), t;
    }, t.prototype.rotateLeft = function() {
        var e = this.copy(null, null, t.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }, t.prototype.rotateRight = function() {
        var e = this.copy(null, null, t.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }, t.prototype.colorFlip = function() {
        var t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, t, e);
    }, // For testing.
    t.prototype.checkMaxDepth = function() {
        var t = this.check();
        return Math.pow(2, t) <= this.size + 1;
    }, // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    t.prototype.check = function() {
        if (this.isRed() && this.left.isRed()) throw $8cffe22d3a2884c1$var$O();
        if (this.right.isRed()) throw $8cffe22d3a2884c1$var$O();
        var t = this.left.check();
        if (t !== this.right.check()) throw $8cffe22d3a2884c1$var$O();
        return t + (this.isRed() ? 0 : 1);
    }, t;
}();
// end SortedMap
// An iterator over an LLRBNode.
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$8cffe22d3a2884c1$var$Ye.EMPTY = null, $8cffe22d3a2884c1$var$Ye.RED = !0, $8cffe22d3a2884c1$var$Ye.BLACK = !1, // end LLRBEmptyNode
$8cffe22d3a2884c1$var$Ye.EMPTY = new /** @class */ (function() {
    function t() {
        this.size = 0;
    }
    return Object.defineProperty(t.prototype, "key", {
        get: function() {
            throw $8cffe22d3a2884c1$var$O();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "value", {
        get: function() {
            throw $8cffe22d3a2884c1$var$O();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "color", {
        get: function() {
            throw $8cffe22d3a2884c1$var$O();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "left", {
        get: function() {
            throw $8cffe22d3a2884c1$var$O();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "right", {
        get: function() {
            throw $8cffe22d3a2884c1$var$O();
        },
        enumerable: !1,
        configurable: !0
    }), // Returns a copy of the current node.
    t.prototype.copy = function(t, e, n, r, i) {
        return this;
    }, // Returns a copy of the tree, with the specified key/value added.
    t.prototype.insert = function(t, e, n) {
        return new $8cffe22d3a2884c1$var$Ye(t, e);
    }, // Returns a copy of the tree, with the specified key removed.
    t.prototype.remove = function(t, e) {
        return this;
    }, t.prototype.isEmpty = function() {
        return !0;
    }, t.prototype.inorderTraversal = function(t) {
        return !1;
    }, t.prototype.reverseTraversal = function(t) {
        return !1;
    }, t.prototype.minKey = function() {
        return null;
    }, t.prototype.maxKey = function() {
        return null;
    }, t.prototype.isRed = function() {
        return !1;
    }, // For testing.
    t.prototype.checkMaxDepth = function() {
        return !0;
    }, t.prototype.check = function() {
        return 0;
    }, t;
}());
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ var $8cffe22d3a2884c1$var$$e = /** @class */ function() {
    function t(t) {
        this.comparator = t, this.data = new $8cffe22d3a2884c1$var$We(this.comparator);
    }
    return t.prototype.has = function(t) {
        return null !== this.data.get(t);
    }, t.prototype.first = function() {
        return this.data.minKey();
    }, t.prototype.last = function() {
        return this.data.maxKey();
    }, Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.data.size;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.indexOf = function(t) {
        return this.data.indexOf(t);
    }, /** Iterates elements in order defined by "comparator" */ t.prototype.forEach = function(t) {
        this.data.inorderTraversal(function(e, n) {
            return t(e), !1;
        });
    }, /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ t.prototype.forEachInRange = function(t, e) {
        for(var n = this.data.getIteratorFrom(t[0]); n.hasNext();){
            var r = n.getNext();
            if (this.comparator(r.key, t[1]) >= 0) return;
            e(r.key);
        }
    }, /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ t.prototype.forEachWhile = function(t, e) {
        var n;
        for(n = void 0 !== e ? this.data.getIteratorFrom(e) : this.data.getIterator(); n.hasNext();)if (!t(n.getNext().key)) return;
    }, /** Finds the least element greater than or equal to `elem`. */ t.prototype.firstAfterOrEqual = function(t) {
        var e = this.data.getIteratorFrom(t);
        return e.hasNext() ? e.getNext().key : null;
    }, t.prototype.getIterator = function() {
        return new $8cffe22d3a2884c1$var$Xe(this.data.getIterator());
    }, t.prototype.getIteratorFrom = function(t) {
        return new $8cffe22d3a2884c1$var$Xe(this.data.getIteratorFrom(t));
    }, /** Inserts or updates an element */ t.prototype.add = function(t) {
        return this.copy(this.data.remove(t).insert(t, !0));
    }, /** Deletes an element */ t.prototype.delete = function(t) {
        return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }, t.prototype.isEmpty = function() {
        return this.data.isEmpty();
    }, t.prototype.unionWith = function(t) {
        var e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach(function(t) {
            e = e.add(t);
        }), e;
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) return !1;
        if (this.size !== e.size) return !1;
        for(var n = this.data.getIterator(), r = e.data.getIterator(); n.hasNext();){
            var i = n.getNext().key, o = r.getNext().key;
            if (0 !== this.comparator(i, o)) return !1;
        }
        return !0;
    }, t.prototype.toArray = function() {
        var t = [];
        return this.forEach(function(e) {
            t.push(e);
        }), t;
    }, t.prototype.toString = function() {
        var t = [];
        return this.forEach(function(e) {
            return t.push(e);
        }), "SortedSet(" + t.toString() + ")";
    }, t.prototype.copy = function(e) {
        var n = new t(this.comparator);
        return n.data = e, n;
    }, t;
}(), $8cffe22d3a2884c1$var$Xe = /** @class */ function() {
    function t(t) {
        this.iter = t;
    }
    return t.prototype.getNext = function() {
        return this.iter.getNext().key;
    }, t.prototype.hasNext = function() {
        return this.iter.hasNext();
    }, t;
}(), $8cffe22d3a2884c1$var$Je = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
function $8cffe22d3a2884c1$var$Ze() {
    return $8cffe22d3a2884c1$var$Je;
}
var $8cffe22d3a2884c1$var$tn = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
function $8cffe22d3a2884c1$var$en() {
    return $8cffe22d3a2884c1$var$tn;
}
var $8cffe22d3a2884c1$var$nn = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
function $8cffe22d3a2884c1$var$rn() {
    return $8cffe22d3a2884c1$var$nn;
}
var $8cffe22d3a2884c1$var$on = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$ct.comparator);
function $8cffe22d3a2884c1$var$sn() {
    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
    for(var n = $8cffe22d3a2884c1$var$on, r = 0, i = t; r < i.length; r++){
        var o = i[r];
        n = n.add(o);
    }
    return n;
}
var $8cffe22d3a2884c1$var$un = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q);
function $8cffe22d3a2884c1$var$an() {
    return $8cffe22d3a2884c1$var$un;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ var $8cffe22d3a2884c1$var$cn = /** @class */ function() {
    function t(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ t, /**
     * A map from target to changes to the target. See TargetChange.
     */ e, /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i) {
        this.snapshotVersion = t, this.targetChanges = e, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    return t.createSynthesizedRemoteEventForCurrentChange = function(e, n) {
        var r = new Map;
        return r.set(e, $8cffe22d3a2884c1$var$hn.createSynthesizedTargetChangeForCurrentChange(e, n)), new t($8cffe22d3a2884c1$var$K.min(), r, $8cffe22d3a2884c1$var$an(), $8cffe22d3a2884c1$var$Ze(), $8cffe22d3a2884c1$var$sn());
    }, t;
}(), $8cffe22d3a2884c1$var$hn = /** @class */ function() {
    function t(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ t, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ e, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i) {
        this.resumeToken = t, this.current = e, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ ;
    }
    return t.createSynthesizedTargetChangeForCurrentChange = function(e, n) {
        return new t($8cffe22d3a2884c1$var$J.EMPTY_BYTE_STRING, n, $8cffe22d3a2884c1$var$sn(), $8cffe22d3a2884c1$var$sn(), $8cffe22d3a2884c1$var$sn());
    }, t;
}(), $8cffe22d3a2884c1$var$fn = function(/** The new document applies to all of these targets. */ t, /** The new document is removed from all of these targets. */ e, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r) {
    this.v = t, this.removedTargetIds = e, this.key = n, this.P = r;
}, $8cffe22d3a2884c1$var$ln = function(t, e) {
    this.targetId = t, this.V = e;
}, $8cffe22d3a2884c1$var$dn = function(/** What kind of change occurred to the watch target. */ t, /** The target IDs that were added/removed/set. */ e, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n, r) {
    void 0 === n && (n = $8cffe22d3a2884c1$var$J.EMPTY_BYTE_STRING), void 0 === r && (r = null), this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = r;
}, $8cffe22d3a2884c1$var$pn = /** @class */ function() {
    function t() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.S = 0, /**
             * Keeps track of the document changes since the last raised snapshot.
             *
             * These changes are continuously updated as we receive document updates and
             * always reflect the current set of changes against the last issued snapshot.
             */ this.D = $8cffe22d3a2884c1$var$mn(), /** See public getters for explanations of these fields. */ this.C = $8cffe22d3a2884c1$var$J.EMPTY_BYTE_STRING, this.N = !1, /**
             * Whether this target state should be included in the next snapshot. We
             * initialize to true so that newly-added targets are included in the next
             * RemoteEvent.
             */ this.k = !0;
    }
    return Object.defineProperty(t.prototype, "current", {
        /**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */ get: function() {
            return this.N;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resumeToken", {
        /** The last resume token sent to us for this target. */ get: function() {
            return this.C;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "F", {
        /** Whether this target has pending target adds or target removes. */ get: function() {
            return 0 !== this.S;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "$", {
        /** Whether we have modified any state that should trigger a snapshot. */ get: function() {
            return this.k;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ t.prototype.O = function(t) {
        t.approximateByteSize() > 0 && (this.k = !0, this.C = t);
    }, /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ t.prototype.M = function() {
        var t = $8cffe22d3a2884c1$var$sn(), e = $8cffe22d3a2884c1$var$sn(), n = $8cffe22d3a2884c1$var$sn();
        return this.D.forEach(function(r, i) {
            switch(i){
                case 0 /* Added */ :
                    t = t.add(r);
                    break;
                case 2 /* Modified */ :
                    e = e.add(r);
                    break;
                case 1 /* Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $8cffe22d3a2884c1$var$O();
            }
        }), new $8cffe22d3a2884c1$var$hn(this.C, this.N, t, e, n);
    }, /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ t.prototype.L = function() {
        this.k = !1, this.D = $8cffe22d3a2884c1$var$mn();
    }, t.prototype.B = function(t, e) {
        this.k = !0, this.D = this.D.insert(t, e);
    }, t.prototype.q = function(t) {
        this.k = !0, this.D = this.D.remove(t);
    }, t.prototype.U = function() {
        this.S += 1;
    }, t.prototype.K = function() {
        this.S -= 1;
    }, t.prototype.j = function() {
        this.k = !0, this.N = !0;
    }, t;
}(), $8cffe22d3a2884c1$var$yn = /** @class */ function() {
    function t(t) {
        this.W = t, /** The internal state of all tracked targets. */ this.G = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.H = $8cffe22d3a2884c1$var$Ze(), /** A mapping of document keys to their set of target IDs. */ this.J = $8cffe22d3a2884c1$var$vn(), /**
             * A list of targets with existence filter mismatches. These targets are
             * known to be inconsistent and their listens needs to be re-established by
             * RemoteStore.
             */ this.Y = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q) /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ ;
    }
    return t.prototype.X = function(t) {
        for(var e = 0, n = t.v; e < n.length; e++){
            var r = n[e];
            t.P && t.P.isFoundDocument() ? this.Z(r, t.P) : this.tt(r, t.key, t.P);
        }
        for(var i = 0, o = t.removedTargetIds; i < o.length; i++){
            r = o[i];
            this.tt(r, t.key, t.P);
        }
    }, /** Processes and adds the WatchTargetChange to the current set of changes. */ t.prototype.et = function(t) {
        var e = this;
        this.forEachTarget(t, function(n) {
            var r = e.nt(n);
            switch(t.state){
                case 0 /* NoChange */ :
                    e.st(n) && r.O(t.resumeToken);
                    break;
                case 1 /* Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    r.K(), r.F || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    r.L(), r.O(t.resumeToken);
                    break;
                case 2 /* Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    r.K(), r.F || e.removeTarget(n);
                    break;
                case 3 /* Current */ :
                    e.st(n) && (r.j(), r.O(t.resumeToken));
                    break;
                case 4 /* Reset */ :
                    e.st(n) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (e.it(n), r.O(t.resumeToken));
                    break;
                default:
                    $8cffe22d3a2884c1$var$O();
            }
        });
    }, /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ t.prototype.forEachTarget = function(t, e) {
        var n = this;
        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.G.forEach(function(t, r) {
            n.st(r) && e(r);
        });
    }, /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ t.prototype.rt = function(t) {
        var e = t.targetId, n = t.V.count, r = this.ot(e);
        if (r) {
            var i = r.target;
            if ($8cffe22d3a2884c1$var$xt(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    var o = new $8cffe22d3a2884c1$var$ct(i.path);
                    this.tt(e, o, $8cffe22d3a2884c1$var$Nt.newNoDocument(o, $8cffe22d3a2884c1$var$K.min()));
                } else $8cffe22d3a2884c1$var$P(1 === n);
            } else this.ct(e) !== n && // Existence filter mismatch: We reset the mapping and raise a new
            // snapshot with `isFromCache:true`.
            (this.it(e), this.Y = this.Y.add(e));
        }
    }, /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ t.prototype.ut = function(t) {
        var e = this, n = new Map;
        this.G.forEach(function(r, i) {
            var o = e.ot(i);
            if (o) {
                if (r.current && $8cffe22d3a2884c1$var$xt(o.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    var s = new $8cffe22d3a2884c1$var$ct(o.target.path);
                    null !== e.H.get(s) || e.at(i, s) || e.tt(i, s, $8cffe22d3a2884c1$var$Nt.newNoDocument(s, t));
                }
                r.$ && (n.set(i, r.M()), r.L());
            }
        });
        var r = $8cffe22d3a2884c1$var$sn();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.J.forEach(function(t, n) {
            var i = !0;
            n.forEachWhile(function(t) {
                var n = e.ot(t);
                return !n || 2 /* LimboResolution */  === n.purpose || (i = !1, !1);
            }), i && (r = r.add(t));
        });
        var i = new $8cffe22d3a2884c1$var$cn(t, n, this.Y, this.H, r);
        return this.H = $8cffe22d3a2884c1$var$Ze(), this.J = $8cffe22d3a2884c1$var$vn(), this.Y = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q), i;
    }, /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    t.prototype.Z = function(t, e) {
        if (this.st(t)) {
            var n = this.at(t, e.key) ? 2 /* Modified */  : 0 /* Added */ ;
            this.nt(t).B(e.key, n), this.H = this.H.insert(e.key, e), this.J = this.J.insert(e.key, this.ht(e.key).add(t));
        }
    }, /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    t.prototype.tt = function(t, e, n) {
        if (this.st(t)) {
            var r = this.nt(t);
            this.at(t, e) ? r.B(e, 1 /* Removed */ ) : // The document may have entered and left the target before we raised a
            // snapshot, so we can just ignore the change.
            r.q(e), this.J = this.J.insert(e, this.ht(e).delete(t)), n && (this.H = this.H.insert(e, n));
        }
    }, t.prototype.removeTarget = function(t) {
        this.G.delete(t);
    }, /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ t.prototype.ct = function(t) {
        var e = this.nt(t).M();
        return this.W.getRemoteKeysForTarget(t).size + e.addedDocuments.size - e.removedDocuments.size;
    }, /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ t.prototype.U = function(t) {
        this.nt(t).U();
    }, t.prototype.nt = function(t) {
        var e = this.G.get(t);
        return e || (e = new $8cffe22d3a2884c1$var$pn, this.G.set(t, e)), e;
    }, t.prototype.ht = function(t) {
        var e = this.J.get(t);
        return e || (e = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q), this.J = this.J.insert(t, e)), e;
    }, /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ t.prototype.st = function(t) {
        var e = null !== this.ot(t);
        return e || $8cffe22d3a2884c1$var$C("WatchChangeAggregator", "Detected inactive target", t), e;
    }, /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ t.prototype.ot = function(t) {
        var e = this.G.get(t);
        return e && e.F ? null : this.W.lt(t);
    }, /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ t.prototype.it = function(t) {
        var e = this;
        this.G.set(t, new $8cffe22d3a2884c1$var$pn), this.W.getRemoteKeysForTarget(t).forEach(function(n) {
            e.tt(t, n, /*updatedDocument=*/ null);
        });
    }, /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ t.prototype.at = function(t, e) {
        return this.W.getRemoteKeysForTarget(t).has(e);
    }, t;
}();
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ function $8cffe22d3a2884c1$var$vn() {
    return new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
}
function $8cffe22d3a2884c1$var$mn() {
    return new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$gn = {
    asc: "ASCENDING",
    desc: "DESCENDING"
}, $8cffe22d3a2884c1$var$wn = {
    "<": "LESS_THAN",
    "<=": "LESS_THAN_OR_EQUAL",
    ">": "GREATER_THAN",
    ">=": "GREATER_THAN_OR_EQUAL",
    "==": "EQUAL",
    "!=": "NOT_EQUAL",
    "array-contains": "ARRAY_CONTAINS",
    in: "IN",
    "not-in": "NOT_IN",
    "array-contains-any": "ARRAY_CONTAINS_ANY"
}, $8cffe22d3a2884c1$var$bn = function(t, e) {
    this.databaseId = t, this.I = e;
};
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $8cffe22d3a2884c1$var$In(t, e) {
    return t.I ? new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "") + "." + ("000000000" + e.nanoseconds).slice(-9) + "Z" : {
        seconds: "" + e.seconds,
        nanos: e.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $8cffe22d3a2884c1$var$Tn(t, e) {
    return t.I ? e.toBase64() : e.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $8cffe22d3a2884c1$var$_n(t, e) {
    return $8cffe22d3a2884c1$var$In(t, e.toTimestamp());
}
function $8cffe22d3a2884c1$var$En(t) {
    return $8cffe22d3a2884c1$var$P(!!t), $8cffe22d3a2884c1$var$K.fromTimestamp(function(t) {
        var e = $8cffe22d3a2884c1$var$tt(t);
        return new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(e.seconds, e.nanos);
    }(t));
}
function $8cffe22d3a2884c1$var$Sn(t, e) {
    return (function(t) {
        return new $8cffe22d3a2884c1$var$H([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    })(t).child("documents").child(e).canonicalString();
}
function $8cffe22d3a2884c1$var$Nn(t) {
    var e = $8cffe22d3a2884c1$var$H.fromString(t);
    return $8cffe22d3a2884c1$var$P($8cffe22d3a2884c1$var$$n(e)), e;
}
function $8cffe22d3a2884c1$var$Dn(t, e) {
    return $8cffe22d3a2884c1$var$Sn(t.databaseId, e.path);
}
function $8cffe22d3a2884c1$var$An(t, e) {
    var n = $8cffe22d3a2884c1$var$Nn(e);
    if (n.get(1) !== t.databaseId.projectId) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + t.databaseId.projectId);
    if (n.get(3) !== t.databaseId.database) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + t.databaseId.database);
    return new $8cffe22d3a2884c1$var$ct($8cffe22d3a2884c1$var$Rn(n));
}
function $8cffe22d3a2884c1$var$kn(t, e) {
    return $8cffe22d3a2884c1$var$Sn(t.databaseId, e);
}
function $8cffe22d3a2884c1$var$Cn(t) {
    var e = $8cffe22d3a2884c1$var$Nn(t);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === e.length ? $8cffe22d3a2884c1$var$H.emptyPath() : $8cffe22d3a2884c1$var$Rn(e);
}
function $8cffe22d3a2884c1$var$xn(t) {
    return new $8cffe22d3a2884c1$var$H([
        "projects",
        t.databaseId.projectId,
        "databases",
        t.databaseId.database
    ]).canonicalString();
}
function $8cffe22d3a2884c1$var$Rn(t) {
    return $8cffe22d3a2884c1$var$P(t.length > 4 && "documents" === t.get(4)), t.popFirst(5) /** Creates a Document proto from key and fields (but no create/update time) */ ;
}
function $8cffe22d3a2884c1$var$Ln(t, e, n) {
    return {
        name: $8cffe22d3a2884c1$var$Dn(t, e),
        fields: n.value.mapValue.fields
    };
}
function $8cffe22d3a2884c1$var$On(t, e, n) {
    var r = $8cffe22d3a2884c1$var$An(t, e.name), i = $8cffe22d3a2884c1$var$En(e.updateTime), o = new $8cffe22d3a2884c1$var$Et({
        mapValue: {
            fields: e.fields
        }
    }), s = $8cffe22d3a2884c1$var$Nt.newFoundDocument(r, i, o);
    return n && s.setHasCommittedMutations(), n ? s.setHasCommittedMutations() : s;
}
function $8cffe22d3a2884c1$var$Pn(t, e) {
    var n;
    if (e instanceof $8cffe22d3a2884c1$var$Pe) n = {
        update: $8cffe22d3a2884c1$var$Ln(t, e.key, e.value)
    };
    else if (e instanceof $8cffe22d3a2884c1$var$je) n = {
        delete: $8cffe22d3a2884c1$var$Dn(t, e.key)
    };
    else if (e instanceof $8cffe22d3a2884c1$var$Fe) n = {
        update: $8cffe22d3a2884c1$var$Ln(t, e.key, e.data),
        updateMask: $8cffe22d3a2884c1$var$Yn(e.fieldMask)
    };
    else {
        if (!(e instanceof $8cffe22d3a2884c1$var$Ke)) return $8cffe22d3a2884c1$var$O();
        n = {
            verify: $8cffe22d3a2884c1$var$Dn(t, e.key)
        };
    }
    return e.fieldTransforms.length > 0 && (n.updateTransforms = e.fieldTransforms.map(function(t) {
        return function(t, e) {
            var n = e.transform;
            if (n instanceof $8cffe22d3a2884c1$var$me) return {
                fieldPath: e.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $8cffe22d3a2884c1$var$ge) return {
                fieldPath: e.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $8cffe22d3a2884c1$var$be) return {
                fieldPath: e.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $8cffe22d3a2884c1$var$Te) return {
                fieldPath: e.field.canonicalString(),
                increment: n.A
            };
            throw $8cffe22d3a2884c1$var$O();
        }(0, t);
    })), e.precondition.isNone || (n.currentDocument = function(t, e) {
        return void 0 !== e.updateTime ? {
            updateTime: $8cffe22d3a2884c1$var$_n(t, e.updateTime)
        } : void 0 !== e.exists ? {
            exists: e.exists
        } : $8cffe22d3a2884c1$var$O();
    }(t, e.precondition)), n;
}
function $8cffe22d3a2884c1$var$Fn(t, e) {
    var n = e.currentDocument ? function(t) {
        return void 0 !== t.updateTime ? $8cffe22d3a2884c1$var$De.updateTime($8cffe22d3a2884c1$var$En(t.updateTime)) : void 0 !== t.exists ? $8cffe22d3a2884c1$var$De.exists(t.exists) : $8cffe22d3a2884c1$var$De.none();
    }(e.currentDocument) : $8cffe22d3a2884c1$var$De.none(), r = e.updateTransforms ? e.updateTransforms.map(function(e) {
        return function(t, e) {
            var n = null;
            if ("setToServerValue" in e) $8cffe22d3a2884c1$var$P("REQUEST_TIME" === e.setToServerValue), n = new $8cffe22d3a2884c1$var$me;
            else if ("appendMissingElements" in e) {
                var r = e.appendMissingElements.values || [];
                n = new $8cffe22d3a2884c1$var$ge(r);
            } else if ("removeAllFromArray" in e) {
                var i = e.removeAllFromArray.values || [];
                n = new $8cffe22d3a2884c1$var$be(i);
            } else "increment" in e ? n = new $8cffe22d3a2884c1$var$Te(t, e.increment) : $8cffe22d3a2884c1$var$O();
            var o = $8cffe22d3a2884c1$var$$.fromServerFormat(e.fieldPath);
            return new $8cffe22d3a2884c1$var$Se(o, n);
        }(t, e);
    }) : [];
    if (e.update) {
        e.update.name;
        var i = $8cffe22d3a2884c1$var$An(t, e.update.name), o = new $8cffe22d3a2884c1$var$Et({
            mapValue: {
                fields: e.update.fields
            }
        });
        if (e.updateMask) {
            var s = function(t) {
                var e = t.fieldPaths || [];
                return new $8cffe22d3a2884c1$var$X(e.map(function(t) {
                    return $8cffe22d3a2884c1$var$$.fromServerFormat(t);
                }));
            }(e.updateMask);
            return new $8cffe22d3a2884c1$var$Fe(i, o, s, n, r);
        }
        return new $8cffe22d3a2884c1$var$Pe(i, o, n, r);
    }
    if (e.delete) {
        var u = $8cffe22d3a2884c1$var$An(t, e.delete);
        return new $8cffe22d3a2884c1$var$je(u, n);
    }
    if (e.verify) {
        var a = $8cffe22d3a2884c1$var$An(t, e.verify);
        return new $8cffe22d3a2884c1$var$Ke(a, n);
    }
    return $8cffe22d3a2884c1$var$O();
}
function $8cffe22d3a2884c1$var$Mn(t, e) {
    return {
        documents: [
            $8cffe22d3a2884c1$var$kn(t, e.path)
        ]
    };
}
function $8cffe22d3a2884c1$var$Vn(t, e) {
    // Dissect the path into parent, collectionId, and optional key filter.
    var n = {
        structuredQuery: {}
    }, r = e.path;
    null !== e.collectionGroup ? (n.parent = $8cffe22d3a2884c1$var$kn(t, r), n.structuredQuery.from = [
        {
            collectionId: e.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $8cffe22d3a2884c1$var$kn(t, r.popLast()), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]);
    var i = function(t) {
        if (0 !== t.length) {
            var e = t.map(function(t) {
                // visible for testing
                return function(t) {
                    if ("==" /* EQUAL */  === t.op) {
                        if ($8cffe22d3a2884c1$var$It(t.value)) return {
                            unaryFilter: {
                                field: $8cffe22d3a2884c1$var$Qn(t.field),
                                op: "IS_NAN"
                            }
                        };
                        if ($8cffe22d3a2884c1$var$bt(t.value)) return {
                            unaryFilter: {
                                field: $8cffe22d3a2884c1$var$Qn(t.field),
                                op: "IS_NULL"
                            }
                        };
                    } else if ("!=" /* NOT_EQUAL */  === t.op) {
                        if ($8cffe22d3a2884c1$var$It(t.value)) return {
                            unaryFilter: {
                                field: $8cffe22d3a2884c1$var$Qn(t.field),
                                op: "IS_NOT_NAN"
                            }
                        };
                        if ($8cffe22d3a2884c1$var$bt(t.value)) return {
                            unaryFilter: {
                                field: $8cffe22d3a2884c1$var$Qn(t.field),
                                op: "IS_NOT_NULL"
                            }
                        };
                    }
                    return {
                        fieldFilter: {
                            field: $8cffe22d3a2884c1$var$Qn(t.field),
                            op: $8cffe22d3a2884c1$var$Gn(t.op),
                            value: t.value
                        }
                    };
                }(t);
            });
            return 1 === e.length ? e[0] : {
                compositeFilter: {
                    op: "AND",
                    filters: e
                }
            };
        }
    }(e.filters);
    i && (n.structuredQuery.where = i);
    var o = function(t) {
        if (0 !== t.length) return t.map(function(t) {
            // visible for testing
            return function(t) {
                return {
                    field: $8cffe22d3a2884c1$var$Qn(t.field),
                    direction: $8cffe22d3a2884c1$var$Kn(t.dir)
                };
            }(t);
        });
    }(e.orderBy);
    o && (n.structuredQuery.orderBy = o);
    var s = function(t, e) {
        return t.I || $8cffe22d3a2884c1$var$st(e) ? e : {
            value: e
        };
    }(t, e.limit);
    return null !== s && (n.structuredQuery.limit = s), e.startAt && (n.structuredQuery.startAt = $8cffe22d3a2884c1$var$Bn(e.startAt)), e.endAt && (n.structuredQuery.endAt = $8cffe22d3a2884c1$var$Bn(e.endAt)), n;
}
function $8cffe22d3a2884c1$var$qn(t) {
    var e = $8cffe22d3a2884c1$var$Cn(t.parent), n = t.structuredQuery, r = n.from ? n.from.length : 0, i = null;
    if (r > 0) {
        $8cffe22d3a2884c1$var$P(1 === r);
        var o = n.from[0];
        o.allDescendants ? i = o.collectionId : e = e.child(o.collectionId);
    }
    var s = [];
    n.where && (s = $8cffe22d3a2884c1$var$Un(n.where));
    var u = [];
    n.orderBy && (u = n.orderBy.map(function(t) {
        return function(t) {
            return new $8cffe22d3a2884c1$var$Kt($8cffe22d3a2884c1$var$zn(t.field), // visible for testing
            function(t) {
                switch(t){
                    case "ASCENDING":
                        return "asc" /* ASCENDING */ ;
                    case "DESCENDING":
                        return "desc" /* DESCENDING */ ;
                    default:
                        return;
                }
            }(t.direction));
        }(t);
    }));
    var a = null;
    n.limit && (a = function(t) {
        var e;
        return $8cffe22d3a2884c1$var$st(e = "object" == typeof t ? t.value : t) ? null : e;
    }(n.limit));
    var c = null;
    n.startAt && (c = $8cffe22d3a2884c1$var$jn(n.startAt));
    var h = null;
    return n.endAt && (h = $8cffe22d3a2884c1$var$jn(n.endAt)), $8cffe22d3a2884c1$var$Ht(e, i, u, s, a, "F" /* First */ , c, h);
}
function $8cffe22d3a2884c1$var$Un(t) {
    return t ? void 0 !== t.unaryFilter ? [
        $8cffe22d3a2884c1$var$Hn(t)
    ] : void 0 !== t.fieldFilter ? [
        $8cffe22d3a2884c1$var$Wn(t)
    ] : void 0 !== t.compositeFilter ? t.compositeFilter.filters.map(function(t) {
        return $8cffe22d3a2884c1$var$Un(t);
    }).reduce(function(t, e) {
        return t.concat(e);
    }) : $8cffe22d3a2884c1$var$O() : [];
}
function $8cffe22d3a2884c1$var$Bn(t) {
    return {
        before: t.before,
        values: t.position
    };
}
function $8cffe22d3a2884c1$var$jn(t) {
    var e = !!t.before, n = t.values || [];
    return new $8cffe22d3a2884c1$var$Bt(n, e);
}
// visible for testing
function $8cffe22d3a2884c1$var$Kn(t) {
    return $8cffe22d3a2884c1$var$gn[t];
}
function $8cffe22d3a2884c1$var$Gn(t) {
    return $8cffe22d3a2884c1$var$wn[t];
}
function $8cffe22d3a2884c1$var$Qn(t) {
    return {
        fieldPath: t.canonicalString()
    };
}
function $8cffe22d3a2884c1$var$zn(t) {
    return $8cffe22d3a2884c1$var$$.fromServerFormat(t.fieldPath);
}
function $8cffe22d3a2884c1$var$Wn(t) {
    return $8cffe22d3a2884c1$var$Rt.create($8cffe22d3a2884c1$var$zn(t.fieldFilter.field), function(t) {
        switch(t){
            case "EQUAL":
                return "==" /* EQUAL */ ;
            case "NOT_EQUAL":
                return "!=" /* NOT_EQUAL */ ;
            case "GREATER_THAN":
                return ">" /* GREATER_THAN */ ;
            case "GREATER_THAN_OR_EQUAL":
                return ">=" /* GREATER_THAN_OR_EQUAL */ ;
            case "LESS_THAN":
                return "<" /* LESS_THAN */ ;
            case "LESS_THAN_OR_EQUAL":
                return "<=" /* LESS_THAN_OR_EQUAL */ ;
            case "ARRAY_CONTAINS":
                return "array-contains" /* ARRAY_CONTAINS */ ;
            case "IN":
                return "in" /* IN */ ;
            case "NOT_IN":
                return "not-in" /* NOT_IN */ ;
            case "ARRAY_CONTAINS_ANY":
                return "array-contains-any" /* ARRAY_CONTAINS_ANY */ ;
            case "OPERATOR_UNSPECIFIED":
            default:
                return $8cffe22d3a2884c1$var$O();
        }
    }(t.fieldFilter.op), t.fieldFilter.value);
}
function $8cffe22d3a2884c1$var$Hn(t) {
    switch(t.unaryFilter.op){
        case "IS_NAN":
            var e = $8cffe22d3a2884c1$var$zn(t.unaryFilter.field);
            return $8cffe22d3a2884c1$var$Rt.create(e, "==" /* EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NULL":
            var n = $8cffe22d3a2884c1$var$zn(t.unaryFilter.field);
            return $8cffe22d3a2884c1$var$Rt.create(n, "==" /* EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        case "IS_NOT_NAN":
            var r = $8cffe22d3a2884c1$var$zn(t.unaryFilter.field);
            return $8cffe22d3a2884c1$var$Rt.create(r, "!=" /* NOT_EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NOT_NULL":
            var i = $8cffe22d3a2884c1$var$zn(t.unaryFilter.field);
            return $8cffe22d3a2884c1$var$Rt.create(i, "!=" /* NOT_EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        case "OPERATOR_UNSPECIFIED":
        default:
            return $8cffe22d3a2884c1$var$O();
    }
}
function $8cffe22d3a2884c1$var$Yn(t) {
    var e = [];
    return t.fields.forEach(function(t) {
        return e.push(t.canonicalString());
    }), {
        fieldPaths: e
    };
}
function $8cffe22d3a2884c1$var$$n(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $8cffe22d3a2884c1$var$Xn(t) {
    for(var e = "", n = 0; n < t.length; n++)e.length > 0 && (e = $8cffe22d3a2884c1$var$Zn(e)), e = $8cffe22d3a2884c1$var$Jn(t.get(n), e);
    return $8cffe22d3a2884c1$var$Zn(e);
}
/** Encodes a single segment of a resource path into the given result */ function $8cffe22d3a2884c1$var$Jn(t, e) {
    for(var n = e, r = t.length, i = 0; i < r; i++){
        var o = t.charAt(i);
        switch(o){
            case "\x00":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += o;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $8cffe22d3a2884c1$var$Zn(t) {
    return t + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $8cffe22d3a2884c1$var$tr(t) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var e = t.length;
    if ($8cffe22d3a2884c1$var$P(e >= 2), 2 === e) return $8cffe22d3a2884c1$var$P("\x01" === t.charAt(0) && "\x01" === t.charAt(1)), $8cffe22d3a2884c1$var$H.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    for(var n = e - 2, r = [], i = "", o = 0; o < e;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var s = t.indexOf("\x01", o);
        switch((s < 0 || s > n) && $8cffe22d3a2884c1$var$O(), t.charAt(s + 1)){
            case "\x01":
                var u = t.substring(o, s), a = void 0;
                0 === i.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                a = u : (a = i += u, i = ""), r.push(a);
                break;
            case "\x10":
                i += t.substring(o, s), i += "\x00";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                i += t.substring(o, s + 1);
                break;
            default:
                $8cffe22d3a2884c1$var$O();
        }
        o = s + 2;
    }
    return new $8cffe22d3a2884c1$var$H(r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 */ /**
 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
 */ var $8cffe22d3a2884c1$var$er = function(t, e) {
    this.seconds = t, this.nanoseconds = e;
}, $8cffe22d3a2884c1$var$nr = function(t, /** Whether to allow shared access from multiple tabs. */ e, n) {
    this.ownerId = t, this.allowTabSynchronization = e, this.leaseTimestampMs = n;
};
/**
 * A singleton object to be stored in the 'owner' store in IndexedDb.
 *
 * A given database can have a single primary tab assigned at a given time. That
 * tab must validate that it is still holding the primary lease before every
 * operation that requires locked access. The primary tab should regularly
 * write an updated timestamp to this lease to prevent other tabs from
 * "stealing" the primary lease
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ $8cffe22d3a2884c1$var$nr.store = "owner", /**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */ $8cffe22d3a2884c1$var$nr.key = "owner";
/**
 * An object to be stored in the 'mutationQueues' store in IndexedDb.
 *
 * Each user gets a single queue of MutationBatches to apply to the server.
 * DbMutationQueue tracks the metadata about the queue.
 */ var $8cffe22d3a2884c1$var$rr = function(/**
     * The normalized user ID to which this queue belongs.
     */ t, /**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */ e, /**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */ n) {
    this.userId = t, this.lastAcknowledgedBatchId = e, this.lastStreamToken = n;
};
/** Name of the IndexedDb object store.  */ $8cffe22d3a2884c1$var$rr.store = "mutationQueues", /** Keys are automatically assigned via the userId property. */ $8cffe22d3a2884c1$var$rr.keyPath = "userId";
/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */ var $8cffe22d3a2884c1$var$ir = function(/**
     * The normalized user ID to which this batch belongs.
     */ t, /**
     * An identifier for this batch, allocated using an auto-generated key.
     */ e, /**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */ n, /**
     * A list of "mutations" that represent a partial base state from when this
     * write batch was initially created. During local application of the write
     * batch, these baseMutations are applied prior to the real writes in order
     * to override certain document fields from the remote document cache. This
     * is necessary in the case of non-idempotent writes (e.g. `increment()`
     * transforms) to make sure that the local view of the modified documents
     * doesn't flicker if the remote document cache receives the result of the
     * non-idempotent write before the write is removed from the queue.
     *
     * These mutations are never sent to the backend.
     */ r, /**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via toMutation().
     */ i) {
    this.userId = t, this.batchId = e, this.localWriteTimeMs = n, this.baseMutations = r, this.mutations = i;
};
/** Name of the IndexedDb object store.  */ $8cffe22d3a2884c1$var$ir.store = "mutations", /** Keys are automatically assigned via the userId, batchId properties. */ $8cffe22d3a2884c1$var$ir.keyPath = "batchId", /** The index name for lookup of mutations by user. */ $8cffe22d3a2884c1$var$ir.userMutationsIndex = "userMutationsIndex", /** The user mutations index is keyed by [userId, batchId] pairs. */ $8cffe22d3a2884c1$var$ir.userMutationsKeyPath = [
    "userId",
    "batchId"
];
/**
 * An object to be stored in the 'documentMutations' store in IndexedDb.
 *
 * A manually maintained index of all the mutation batches that affect a given
 * document key. The rows in this table are references based on the contents of
 * DbMutationBatch.mutations.
 */ var $8cffe22d3a2884c1$var$or = /** @class */ function() {
    function t() {}
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */ return t.prefixForUser = function(t) {
        return [
            t
        ];
    }, /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */ t.prefixForPath = function(t, e) {
        return [
            t,
            $8cffe22d3a2884c1$var$Xn(e)
        ];
    }, /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */ t.key = function(t, e, n) {
        return [
            t,
            $8cffe22d3a2884c1$var$Xn(e),
            n
        ];
    }, t;
}();
$8cffe22d3a2884c1$var$or.store = "documentMutations", /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */ $8cffe22d3a2884c1$var$or.PLACEHOLDER = new $8cffe22d3a2884c1$var$or;
/**
 * Represents the known absence of a document at a particular version.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */ var $8cffe22d3a2884c1$var$sr = function(t, e) {
    this.path = t, this.readTime = e;
}, $8cffe22d3a2884c1$var$ur = function(t, e) {
    this.path = t, this.version = e;
}, $8cffe22d3a2884c1$var$ar = // TODO: We are currently storing full document keys almost three times
// (once as part of the primary key, once - partly - as `parentPath` and once
// inside the encoded documents). During our next migration, we should
// rewrite the primary key as parentPath + document ID which would allow us
// to drop one value.
function(/**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */ t, /**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */ e, /**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */ n, /**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */ r, /**
     * When the document was read from the backend. Undefined for data written
     * prior to schema version 9.
     */ i, /**
     * The path of the collection this document is part of. Undefined for data
     * written prior to schema version 9.
     */ o) {
    this.unknownDocument = t, this.noDocument = e, this.document = n, this.hasCommittedMutations = r, this.readTime = i, this.parentPath = o;
};
/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */ $8cffe22d3a2884c1$var$ar.store = "remoteDocuments", /**
     * An index that provides access to all entries sorted by read time (which
     * corresponds to the last modification time of each row).
     *
     * This index is used to provide a changelog for Multi-Tab.
     */ $8cffe22d3a2884c1$var$ar.readTimeIndex = "readTimeIndex", $8cffe22d3a2884c1$var$ar.readTimeIndexPath = "readTime", /**
     * An index that provides access to documents in a collection sorted by read
     * time.
     *
     * This index is used to allow the RemoteDocumentCache to fetch newly changed
     * documents in a collection.
     */ $8cffe22d3a2884c1$var$ar.collectionReadTimeIndex = "collectionReadTimeIndex", $8cffe22d3a2884c1$var$ar.collectionReadTimeIndexPath = [
    "parentPath",
    "readTime"
];
/**
 * Contains a single entry that has metadata about the remote document cache.
 */ var $8cffe22d3a2884c1$var$cr = /**
     * @param byteSize - Approximately the total size in bytes of all the
     * documents in the document cache.
     */ function(t) {
    this.byteSize = t;
};
$8cffe22d3a2884c1$var$cr.store = "remoteDocumentGlobal", $8cffe22d3a2884c1$var$cr.key = "remoteDocumentGlobalKey";
/**
 * An object to be stored in the 'targets' store in IndexedDb.
 *
 * This is based on and should be kept in sync with the proto used in the iOS
 * client.
 *
 * Each query the client listens to against the server is tracked on disk so
 * that the query can be efficiently resumed on restart.
 */ var $8cffe22d3a2884c1$var$hr = function(/**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */ t, /**
     * The canonical string representing this query. This is not unique.
     */ e, /**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */ n, /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */ r, /**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */ i, /**
     * Denotes the maximum snapshot version at which the associated query view
     * contained no limbo documents.  Undefined for data written prior to
     * schema version 9.
     */ o, /**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */ s) {
    this.targetId = t, this.canonicalId = e, this.readTime = n, this.resumeToken = r, this.lastListenSequenceNumber = i, this.lastLimboFreeSnapshotVersion = o, this.query = s;
};
$8cffe22d3a2884c1$var$hr.store = "targets", /** Keys are automatically assigned via the targetId property. */ $8cffe22d3a2884c1$var$hr.keyPath = "targetId", /** The name of the queryTargets index. */ $8cffe22d3a2884c1$var$hr.queryTargetsIndexName = "queryTargetsIndex", /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */ $8cffe22d3a2884c1$var$hr.queryTargetsKeyPath = [
    "canonicalId",
    "targetId"
];
/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */ var $8cffe22d3a2884c1$var$fr = function(/**
     * The targetId identifying a target or 0 for a sentinel row.
     */ t, /**
     * The path to the document, as encoded in the key.
     */ e, /**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */ n) {
    this.targetId = t, this.path = e, this.sequenceNumber = n;
};
/** Name of the IndexedDb object store.  */ $8cffe22d3a2884c1$var$fr.store = "targetDocuments", /** Keys are automatically assigned via the targetId, path properties. */ $8cffe22d3a2884c1$var$fr.keyPath = [
    "targetId",
    "path"
], /** The index name for the reverse index. */ $8cffe22d3a2884c1$var$fr.documentTargetsIndex = "documentTargetsIndex", /** We also need to create the reverse index for these properties. */ $8cffe22d3a2884c1$var$fr.documentTargetsKeyPath = [
    "path",
    "targetId"
];
/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */ var $8cffe22d3a2884c1$var$lr = function(/**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */ t, /**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */ e, /**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */ n, /**
     * The number of targets persisted.
     */ r) {
    this.highestTargetId = t, this.highestListenSequenceNumber = e, this.lastRemoteSnapshotVersion = n, this.targetCount = r;
};
/**
 * The key string used for the single object that exists in the
 * DbTargetGlobal store.
 */ $8cffe22d3a2884c1$var$lr.key = "targetGlobalKey", $8cffe22d3a2884c1$var$lr.store = "targetGlobal";
/**
 * An object representing an association between a Collection id (e.g. 'messages')
 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
 * This is used to efficiently find all collections to query when performing
 * a Collection Group query.
 */ var $8cffe22d3a2884c1$var$dr = function(/**
     * The collectionId (e.g. 'messages')
     */ t, /**
     * The path to the parent (either a document location or an empty path for
     * a root-level collection).
     */ e) {
    this.collectionId = t, this.parent = e;
};
/** Name of the IndexedDb object store. */ $8cffe22d3a2884c1$var$dr.store = "collectionParents", /** Keys are automatically assigned via the collectionId, parent properties. */ $8cffe22d3a2884c1$var$dr.keyPath = [
    "collectionId",
    "parent"
];
/**
 * A record of the metadata state of each client.
 *
 * PORTING NOTE: This is used to synchronize multi-tab state and does not need
 * to be ported to iOS or Android.
 */ var $8cffe22d3a2884c1$var$pr = function(// Note: Previous schema versions included a field
// "lastProcessedDocumentChangeId". Don't use anymore.
/** The auto-generated client id assigned at client startup. */ t, /** The last time this state was updated. */ e, /** Whether the client's network connection is enabled. */ n, /** Whether this client is running in a foreground tab. */ r) {
    this.clientId = t, this.updateTimeMs = e, this.networkEnabled = n, this.inForeground = r;
};
/** Name of the IndexedDb object store. */ $8cffe22d3a2884c1$var$pr.store = "clientMetadata", /** Keys are automatically assigned via the clientId properties. */ $8cffe22d3a2884c1$var$pr.keyPath = "clientId";
/**
 * A object representing a bundle loaded by the SDK.
 */ var $8cffe22d3a2884c1$var$yr = function(/** The ID of the loaded bundle. */ t, /** The create time of the loaded bundle. */ e, /** The schema version of the loaded bundle. */ n) {
    this.bundleId = t, this.createTime = e, this.version = n;
};
/** Name of the IndexedDb object store. */ $8cffe22d3a2884c1$var$yr.store = "bundles", $8cffe22d3a2884c1$var$yr.keyPath = "bundleId";
/**
 * A object representing a named query loaded by the SDK via a bundle.
 */ var $8cffe22d3a2884c1$var$vr = function(/** The name of the query. */ t, /** The read time of the results saved in the bundle from the named query. */ e, /** The query saved in the bundle. */ n) {
    this.name = t, this.readTime = e, this.bundledQuery = n;
};
/** Name of the IndexedDb object store. */ $8cffe22d3a2884c1$var$vr.store = "namedQueries", $8cffe22d3a2884c1$var$vr.keyPath = "name";
// Visible for testing
var $8cffe22d3a2884c1$var$mr = (0, $2WUgS.__spreadArray)((0, $2WUgS.__spreadArray)([], (0, $2WUgS.__spreadArray)((0, $2WUgS.__spreadArray)([], (0, $2WUgS.__spreadArray)((0, $2WUgS.__spreadArray)([], (0, $2WUgS.__spreadArray)((0, $2WUgS.__spreadArray)([], [
    $8cffe22d3a2884c1$var$rr.store,
    $8cffe22d3a2884c1$var$ir.store,
    $8cffe22d3a2884c1$var$or.store,
    $8cffe22d3a2884c1$var$ar.store,
    $8cffe22d3a2884c1$var$hr.store,
    $8cffe22d3a2884c1$var$nr.store,
    $8cffe22d3a2884c1$var$lr.store,
    $8cffe22d3a2884c1$var$fr.store
]), [
    $8cffe22d3a2884c1$var$pr.store
])), [
    $8cffe22d3a2884c1$var$cr.store
])), [
    $8cffe22d3a2884c1$var$dr.store
])), [
    $8cffe22d3a2884c1$var$yr.store,
    $8cffe22d3a2884c1$var$vr.store
]), $8cffe22d3a2884c1$var$gr = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", $8cffe22d3a2884c1$var$wr = /** @class */ function() {
    function t() {
        this.onCommittedListeners = [];
    }
    return t.prototype.addOnCommittedListener = function(t) {
        this.onCommittedListeners.push(t);
    }, t.prototype.raiseOnCommittedEvent = function() {
        this.onCommittedListeners.forEach(function(t) {
            return t();
        });
    }, t;
}(), $8cffe22d3a2884c1$var$br = function() {
    var t = this;
    this.promise = new Promise(function(e, n) {
        t.resolve = e, t.reject = n;
    });
}, $8cffe22d3a2884c1$var$Ir = /** @class */ function() {
    function t(t) {
        var e = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, t(function(t) {
            e.isDone = !0, e.result = t, e.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            e.nextCallback(t);
        }, function(t) {
            e.isDone = !0, e.error = t, e.catchCallback && e.catchCallback(t);
        });
    }
    return t.prototype.catch = function(t) {
        return this.next(void 0, t);
    }, t.prototype.next = function(e, n) {
        var r = this;
        return this.callbackAttached && $8cffe22d3a2884c1$var$O(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(n, this.error) : this.wrapSuccess(e, this.result) : new t(function(t, i) {
            r.nextCallback = function(n) {
                r.wrapSuccess(e, n).next(t, i);
            }, r.catchCallback = function(e) {
                r.wrapFailure(n, e).next(t, i);
            };
        });
    }, t.prototype.toPromise = function() {
        var t = this;
        return new Promise(function(e, n) {
            t.next(e, n);
        });
    }, t.prototype.wrapUserFunction = function(e) {
        try {
            var n = e();
            return n instanceof t ? n : t.resolve(n);
        } catch (e) {
            return t.reject(e);
        }
    }, t.prototype.wrapSuccess = function(e, n) {
        return e ? this.wrapUserFunction(function() {
            return e(n);
        }) : t.resolve(n);
    }, t.prototype.wrapFailure = function(e, n) {
        return e ? this.wrapUserFunction(function() {
            return e(n);
        }) : t.reject(n);
    }, t.resolve = function(e) {
        return new t(function(t, n) {
            t(e);
        });
    }, t.reject = function(e) {
        return new t(function(t, n) {
            n(e);
        });
    }, t.waitFor = function(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new t(function(t, n) {
            var r = 0, i = 0, o = !1;
            e.forEach(function(e) {
                ++r, e.next(function() {
                    ++i, o && i === r && t();
                }, function(t) {
                    return n(t);
                });
            }), o = !0, i === r && t();
        });
    }, /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ t.or = function(e) {
        for(var n = t.resolve(!1), r = function(e) {
            n = n.next(function(n) {
                return n ? t.resolve(n) : e();
            });
        }, i = 0, o = e; i < o.length; i++)r(o[i]);
        return n;
    }, t.forEach = function(t, e) {
        var n = this, r = [];
        return t.forEach(function(t, i) {
            r.push(e.call(n, t, i));
        }), this.waitFor(r);
    }, t;
}(), $8cffe22d3a2884c1$var$Tr = /** @class */ function() {
    function t(t, e) {
        var n = this;
        this.action = t, this.transaction = e, this.aborted = !1, /**
             * A `Promise` that resolves with the result of the IndexedDb transaction.
             */ this.ft = new $8cffe22d3a2884c1$var$br, this.transaction.oncomplete = function() {
            n.ft.resolve();
        }, this.transaction.onabort = function() {
            e.error ? n.ft.reject(new $8cffe22d3a2884c1$var$Sr(t, e.error)) : n.ft.resolve();
        }, this.transaction.onerror = function(e) {
            var r = $8cffe22d3a2884c1$var$Cr(e.target.error);
            n.ft.reject(new $8cffe22d3a2884c1$var$Sr(t, r));
        };
    }
    return t.open = function(e, n, r, i) {
        try {
            return new t(n, e.transaction(i, r));
        } catch (e) {
            throw new $8cffe22d3a2884c1$var$Sr(n, e);
        }
    }, Object.defineProperty(t.prototype, "dt", {
        get: function() {
            return this.ft.promise;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.abort = function(t) {
        t && this.ft.reject(t), this.aborted || ($8cffe22d3a2884c1$var$C("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }, /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ t.prototype.store = function(t) {
        var e = this.transaction.objectStore(t);
        return new $8cffe22d3a2884c1$var$Dr(e);
    }, t;
}(), $8cffe22d3a2884c1$var$_r = /** @class */ function() {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ function t(e, n, r) {
        this.name = e, this.version = n, this.wt = r, // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === t._t((0, $eTAKc.getUA)()) && $8cffe22d3a2884c1$var$x("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ return t.delete = function(t) {
        return $8cffe22d3a2884c1$var$C("SimpleDb", "Removing database:", t), $8cffe22d3a2884c1$var$Ar(window.indexedDB.deleteDatabase(t)).toPromise();
    }, /** Returns true if IndexedDB is available in the current environment. */ t.yt = function() {
        if ("undefined" == typeof indexedDB) return !1;
        if (t.gt()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        var e = (0, $eTAKc.getUA)(), n = t._t(e), r = 0 < n && n < 10, o = t.Et(e), s = 0 < o && o < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || r || s);
    }, /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ t.gt = function() {
        var t;
        return "undefined" != typeof $hvPjh && "YES" === ((t = {}, void 0 === t) ? void 0 : t.Tt);
    }, /** Helper to get a typed SimpleDbStore from a transaction. */ t.It = function(t, e) {
        return t.store(e);
    }, // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ t._t = function(t) {
        var e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }, // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ t.Et = function(t) {
        var e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }, /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ t.prototype.At = function(t) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var e, n = this;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return this.db ? [
                            3 /*break*/ ,
                            2
                        ] : ($8cffe22d3a2884c1$var$C("SimpleDb", "Opening database:", this.name), e = this, [
                            4 /*yield*/ ,
                            new Promise(function(e, r) {
                                // TODO(mikelehen): Investigate browser compatibility.
                                // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
                                // suggests IE9 and older WebKit browsers handle upgrade
                                // differently. They expect setVersion, as described here:
                                // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
                                var i = indexedDB.open(n.name, n.version);
                                i.onsuccess = function(t) {
                                    var n = t.target.result;
                                    e(n);
                                }, i.onblocked = function() {
                                    r(new $8cffe22d3a2884c1$var$Sr(t, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
                                }, i.onerror = function(e) {
                                    var n = e.target.error;
                                    "VersionError" === n.name ? r(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : r(new $8cffe22d3a2884c1$var$Sr(t, n));
                                }, i.onupgradeneeded = function(t) {
                                    $8cffe22d3a2884c1$var$C("SimpleDb", 'Database "' + n.name + '" requires upgrade from version:', t.oldVersion);
                                    var e = t.target.result;
                                    n.wt.Rt(e, i.transaction, t.oldVersion, n.version).next(function() {
                                        $8cffe22d3a2884c1$var$C("SimpleDb", "Database upgrade to version " + n.version + " complete");
                                    });
                                };
                            })
                        ]);
                    case 1:
                        e.db = r.sent(), r.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            (this.bt && (this.db.onversionchange = function(t) {
                                return n.bt(t);
                            }), this.db)
                        ];
                }
            });
        });
    }, t.prototype.vt = function(t) {
        this.bt = t, this.db && (this.db.onversionchange = function(e) {
            return t(e);
        });
    }, t.prototype.runTransaction = function(t, e, i, o) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var n, s, u, a, c;
            return (0, $2WUgS.__generator)(this, function(h) {
                switch(h.label){
                    case 0:
                        n = "readonly" === e, s = 0, u = function() {
                            var e, u, c, h, f;
                            return (0, $2WUgS.__generator)(this, function(r) {
                                switch(r.label){
                                    case 0:
                                        ++s, r.label = 1;
                                    case 1:
                                        return r.trys.push([
                                            1,
                                            4,
                                            ,
                                            5
                                        ]), [
                                            4 /*yield*/ ,
                                            a.At(t)
                                        ];
                                    case 2:
                                        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                        // fire), but still return the original transactionFnResult back to the
                                        // caller.
                                        return a.db = r.sent(), e = $8cffe22d3a2884c1$var$Tr.open(a.db, t, n ? "readonly" : "readwrite", i), u = o(e).catch(function(t) {
                                            // Abort the transaction if there was an error.
                                            return e.abort(t), $8cffe22d3a2884c1$var$Ir.reject(t);
                                        }).toPromise(), c = {}, u.catch(function() {}), [
                                            4 /*yield*/ ,
                                            e.dt
                                        ];
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            (c.value = // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                            // fire), but still return the original transactionFnResult back to the
                                            // caller.
                                            (r.sent(), u), c)
                                        ];
                                    case 4:
                                        return h = r.sent(), f = "FirebaseError" !== h.name && s < 3, $8cffe22d3a2884c1$var$C("SimpleDb", "Transaction failed with error:", h.message, "Retrying:", f), a.close(), f ? [
                                            3 /*break*/ ,
                                            5
                                        ] : [
                                            2 /*return*/ ,
                                            {
                                                value: Promise.reject(h)
                                            }
                                        ];
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        }, a = this, h.label = 1;
                    case 1:
                        return [
                            5 /*yield**/ ,
                            u()
                        ];
                    case 2:
                        if ("object" == typeof (c = h.sent())) return [
                            2 /*return*/ ,
                            c.value
                        ];
                        h.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.close = function() {
        this.db && this.db.close(), this.db = void 0;
    }, t;
}(), $8cffe22d3a2884c1$var$Er = /** @class */ function() {
    function t(t) {
        this.Pt = t, this.Vt = !1, this.St = null;
    }
    return Object.defineProperty(t.prototype, "isDone", {
        get: function() {
            return this.Vt;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "Dt", {
        get: function() {
            return this.St;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "cursor", {
        set: function(t) {
            this.Pt = t;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * This function can be called to stop iteration at any point.
     */ t.prototype.done = function() {
        this.Vt = !0;
    }, /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ t.prototype.Ct = function(t) {
        this.St = t;
    }, /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ t.prototype.delete = function() {
        return $8cffe22d3a2884c1$var$Ar(this.Pt.delete());
    }, t;
}(), $8cffe22d3a2884c1$var$Sr = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, $8cffe22d3a2884c1$var$N.UNAVAILABLE, "IndexedDB transaction '" + t + "' failed: " + n) || this).name = "IndexedDbTransactionError", r;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$D);
// V2 is no longer usable (see comment at top of file)
// Visible for testing
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ /** Verifies whether `e` is an IndexedDbTransactionError. */ function $8cffe22d3a2884c1$var$Nr(t) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === t.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ var $8cffe22d3a2884c1$var$Dr = /** @class */ function() {
    function t(t) {
        this.store = t;
    }
    return t.prototype.put = function(t, e) {
        var n;
        return void 0 !== e ? ($8cffe22d3a2884c1$var$C("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : ($8cffe22d3a2884c1$var$C("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), $8cffe22d3a2884c1$var$Ar(n);
    }, /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ t.prototype.add = function(t) {
        return $8cffe22d3a2884c1$var$C("SimpleDb", "ADD", this.store.name, t, t), $8cffe22d3a2884c1$var$Ar(this.store.add(t));
    }, /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ t.prototype.get = function(t) {
        var e = this;
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $8cffe22d3a2884c1$var$Ar(this.store.get(t)).next(function(n) {
            // Normalize nonexistence to null.
            return void 0 === n && (n = null), $8cffe22d3a2884c1$var$C("SimpleDb", "GET", e.store.name, t, n), n;
        });
    }, t.prototype.delete = function(t) {
        return $8cffe22d3a2884c1$var$C("SimpleDb", "DELETE", this.store.name, t), $8cffe22d3a2884c1$var$Ar(this.store.delete(t));
    }, /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ t.prototype.count = function() {
        return $8cffe22d3a2884c1$var$C("SimpleDb", "COUNT", this.store.name), $8cffe22d3a2884c1$var$Ar(this.store.count());
    }, t.prototype.Nt = function(t, e) {
        var n = this.cursor(this.options(t, e)), r = [];
        return this.xt(n, function(t, e) {
            r.push(e);
        }).next(function() {
            return r;
        });
    }, t.prototype.kt = function(t, e) {
        $8cffe22d3a2884c1$var$C("SimpleDb", "DELETE ALL", this.store.name);
        var n = this.options(t, e);
        n.Ft = !1;
        var r = this.cursor(n);
        return this.xt(r, function(t, e, n) {
            return n.delete();
        });
    }, t.prototype.$t = function(t, e) {
        var n;
        e ? n = t : (n = {}, e = t);
        var r = this.cursor(n);
        return this.xt(r, e);
    }, /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ t.prototype.Ot = function(t) {
        var e = this.cursor({});
        return new $8cffe22d3a2884c1$var$Ir(function(n, r) {
            e.onerror = function(t) {
                var e = $8cffe22d3a2884c1$var$Cr(t.target.error);
                r(e);
            }, e.onsuccess = function(e) {
                var r = e.target.result;
                r ? t(r.primaryKey, r.value).next(function(t) {
                    t ? r.continue() : n();
                }) : n();
            };
        });
    }, t.prototype.xt = function(t, e) {
        var n = [];
        return new $8cffe22d3a2884c1$var$Ir(function(r, i) {
            t.onerror = function(t) {
                i(t.target.error);
            }, t.onsuccess = function(t) {
                var i = t.target.result;
                if (i) {
                    var o = new $8cffe22d3a2884c1$var$Er(i), s = e(i.primaryKey, i.value, o);
                    if (s instanceof $8cffe22d3a2884c1$var$Ir) {
                        var u = s.catch(function(t) {
                            return o.done(), $8cffe22d3a2884c1$var$Ir.reject(t);
                        });
                        n.push(u);
                    }
                    o.isDone ? r() : null === o.Dt ? i.continue() : i.continue(o.Dt);
                } else r();
            };
        }).next(function() {
            return $8cffe22d3a2884c1$var$Ir.waitFor(n);
        });
    }, t.prototype.options = function(t, e) {
        var n;
        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
            index: n,
            range: e
        };
    }, t.prototype.cursor = function(t) {
        var e = "next";
        if (t.reverse && (e = "prev"), t.index) {
            var n = this.store.index(t.index);
            return t.Ft ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
        }
        return this.store.openCursor(t.range, e);
    }, t;
}();
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $8cffe22d3a2884c1$var$Ar(t) {
    return new $8cffe22d3a2884c1$var$Ir(function(e, n) {
        t.onsuccess = function(t) {
            var n = t.target.result;
            e(n);
        }, t.onerror = function(t) {
            var e = $8cffe22d3a2884c1$var$Cr(t.target.error);
            n(e);
        };
    });
}
// Guard so we only report the error once.
var $8cffe22d3a2884c1$var$kr = !1;
function $8cffe22d3a2884c1$var$Cr(t) {
    var e = $8cffe22d3a2884c1$var$_r._t((0, $eTAKc.getUA)());
    if (e >= 12.2 && e < 13) {
        var n = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(n) >= 0) {
            // Wrap error in a more descriptive one.
            var r = new $8cffe22d3a2884c1$var$D("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + n + "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
            return $8cffe22d3a2884c1$var$kr || ($8cffe22d3a2884c1$var$kr = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(function() {
                throw r;
            }, 0)), r;
        }
    }
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$xr = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).Mt = t, r.currentSequenceNumber = n, r;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$wr);
function $8cffe22d3a2884c1$var$Rr(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t);
    return $8cffe22d3a2884c1$var$_r.It(n.Mt, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ var $8cffe22d3a2884c1$var$Lr = /** @class */ function() {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ function t(t, e, n, r) {
        this.batchId = t, this.localWriteTime = e, this.baseMutations = n, this.mutations = r /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ ;
    }
    return t.prototype.applyToRemoteDocument = function(t, e) {
        for(var n = e.mutationResults, r = 0; r < this.mutations.length; r++){
            var i = this.mutations[r];
            i.key.isEqual(t.key) && $8cffe22d3a2884c1$var$Ce(i, t, n[r]);
        }
    }, /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     */ t.prototype.applyToLocalView = function(t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for(var e = 0, n = this.baseMutations; e < n.length; e++)(o = n[e]).key.isEqual(t.key) && $8cffe22d3a2884c1$var$xe(o, t, this.localWriteTime);
        // Second, apply all user-provided mutations.
        for(var r = 0, i = this.mutations; r < i.length; r++){
            var o;
            (o = i[r]).key.isEqual(t.key) && $8cffe22d3a2884c1$var$xe(o, t, this.localWriteTime);
        }
    }, /**
     * Computes the local view for all provided documents given the mutations in
     * this batch.
     */ t.prototype.applyToLocalDocumentSet = function(t) {
        var e = this;
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        this.mutations.forEach(function(n) {
            var r = t.get(n.key), i = r;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            e.applyToLocalView(i), r.isValidDocument() || i.convertToNoDocument($8cffe22d3a2884c1$var$K.min());
        });
    }, t.prototype.keys = function() {
        return this.mutations.reduce(function(t, e) {
            return t.add(e.key);
        }, $8cffe22d3a2884c1$var$sn());
    }, t.prototype.isEqual = function(t) {
        return this.batchId === t.batchId && $8cffe22d3a2884c1$var$U(this.mutations, t.mutations, function(t, e) {
            return $8cffe22d3a2884c1$var$Le(t, e);
        }) && $8cffe22d3a2884c1$var$U(this.baseMutations, t.baseMutations, function(t, e) {
            return $8cffe22d3a2884c1$var$Le(t, e);
        });
    }, t;
}(), $8cffe22d3a2884c1$var$Or = /** @class */ function() {
    function t(t, e, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r) {
        this.batch = t, this.commitVersion = e, this.mutationResults = n, this.docVersions = r /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ ;
    }
    return t.from = function(e, n, r) {
        $8cffe22d3a2884c1$var$P(e.mutations.length === r.length);
        for(var i = $8cffe22d3a2884c1$var$rn(), o = e.mutations, s = 0; s < o.length; s++)i = i.insert(o[s].key, r[s].version);
        return new t(e, n, r, i);
    }, t;
}(), $8cffe22d3a2884c1$var$Pr = /** @class */ function() {
    function t(/** The target being listened to. */ t, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ e, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i, o, s) {
        void 0 === i && (i = $8cffe22d3a2884c1$var$K.min()), void 0 === o && (o = $8cffe22d3a2884c1$var$K.min()), void 0 === s && (s = $8cffe22d3a2884c1$var$J.EMPTY_BYTE_STRING), this.target = t, this.targetId = e, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = o, this.resumeToken = s;
    }
    /** Creates a new target data instance with an updated sequence number. */ return t.prototype.withSequenceNumber = function(e) {
        return new t(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken);
    }, /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ t.prototype.withResumeToken = function(e, n) {
        return new t(this.target, this.targetId, this.purpose, this.sequenceNumber, n, this.lastLimboFreeSnapshotVersion, e);
    }, /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ t.prototype.withLastLimboFreeSnapshotVersion = function(e) {
        return new t(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken);
    }, t;
}(), $8cffe22d3a2884c1$var$Fr = function(t) {
    this.Lt = t;
};
/** The result of applying a mutation batch to the backend. */ /** Decodes a remote document from storage locally to a Document. */ function $8cffe22d3a2884c1$var$Mr(t, e) {
    if (e.document) return $8cffe22d3a2884c1$var$On(t.Lt, e.document, !!e.hasCommittedMutations);
    if (e.noDocument) {
        var n = $8cffe22d3a2884c1$var$ct.fromSegments(e.noDocument.path), r = $8cffe22d3a2884c1$var$jr(e.noDocument.readTime), i = $8cffe22d3a2884c1$var$Nt.newNoDocument(n, r);
        return e.hasCommittedMutations ? i.setHasCommittedMutations() : i;
    }
    if (e.unknownDocument) {
        var o = $8cffe22d3a2884c1$var$ct.fromSegments(e.unknownDocument.path);
        r = $8cffe22d3a2884c1$var$jr(e.unknownDocument.version);
        return $8cffe22d3a2884c1$var$Nt.newUnknownDocument(o, r);
    }
    return $8cffe22d3a2884c1$var$O();
}
/** Encodes a document for storage locally. */ function $8cffe22d3a2884c1$var$Vr(t, e, n) {
    var r = $8cffe22d3a2884c1$var$qr(n), i = e.key.path.popLast().toArray();
    if (e.isFoundDocument()) {
        var o = function(t, e) {
            return {
                name: $8cffe22d3a2884c1$var$Dn(t, e.key),
                fields: e.data.value.mapValue.fields,
                updateTime: $8cffe22d3a2884c1$var$In(t, e.version.toTimestamp())
            };
        }(t.Lt, e), s = e.hasCommittedMutations;
        return new $8cffe22d3a2884c1$var$ar(/* unknownDocument= */ null, /* noDocument= */ null, o, s, r, i);
    }
    if (e.isNoDocument()) {
        var u = e.key.path.toArray(), a = $8cffe22d3a2884c1$var$Br(e.version);
        s = e.hasCommittedMutations;
        return new $8cffe22d3a2884c1$var$ar(/* unknownDocument= */ null, new $8cffe22d3a2884c1$var$sr(u, a), /* document= */ null, s, r, i);
    }
    if (e.isUnknownDocument()) {
        var c = e.key.path.toArray(), h = $8cffe22d3a2884c1$var$Br(e.version);
        return new $8cffe22d3a2884c1$var$ar(new $8cffe22d3a2884c1$var$ur(c, h), /* noDocument= */ null, /* document= */ null, /* hasCommittedMutations= */ !0, r, i);
    }
    return $8cffe22d3a2884c1$var$O();
}
function $8cffe22d3a2884c1$var$qr(t) {
    var e = t.toTimestamp();
    return [
        e.seconds,
        e.nanoseconds
    ];
}
function $8cffe22d3a2884c1$var$Ur(t) {
    var e = new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(t[0], t[1]);
    return $8cffe22d3a2884c1$var$K.fromTimestamp(e);
}
function $8cffe22d3a2884c1$var$Br(t) {
    var e = t.toTimestamp();
    return new $8cffe22d3a2884c1$var$er(e.seconds, e.nanoseconds);
}
function $8cffe22d3a2884c1$var$jr(t) {
    var e = new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(t.seconds, t.nanoseconds);
    return $8cffe22d3a2884c1$var$K.fromTimestamp(e);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $8cffe22d3a2884c1$var$Kr(t, e) {
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(var n = (e.baseMutations || []).map(function(e) {
        return $8cffe22d3a2884c1$var$Fn(t.Lt, e);
    }), r = 0; r < e.mutations.length - 1; ++r){
        var i = e.mutations[r];
        if (r + 1 < e.mutations.length && void 0 !== e.mutations[r + 1].transform) {
            var o = e.mutations[r + 1];
            i.updateTransforms = o.transform.fieldTransforms, e.mutations.splice(r + 1, 1), ++r;
        }
    }
    var s = e.mutations.map(function(e) {
        return $8cffe22d3a2884c1$var$Fn(t.Lt, e);
    }), u = $8cffe22d3a2884c1$export$3a1a48c8f6ef640e.fromMillis(e.localWriteTimeMs);
    return new $8cffe22d3a2884c1$var$Lr(e.batchId, u, n, s);
}
/** Decodes a DbTarget into TargetData */ function $8cffe22d3a2884c1$var$Gr(t) {
    var e, n, r = $8cffe22d3a2884c1$var$jr(t.readTime), i = void 0 !== t.lastLimboFreeSnapshotVersion ? $8cffe22d3a2884c1$var$jr(t.lastLimboFreeSnapshotVersion) : $8cffe22d3a2884c1$var$K.min();
    return void 0 !== t.query.documents ? ($8cffe22d3a2884c1$var$P(1 === (n = t.query).documents.length), e = $8cffe22d3a2884c1$var$ne($8cffe22d3a2884c1$var$Yt($8cffe22d3a2884c1$var$Cn(n.documents[0])))) : e = function(t) {
        return $8cffe22d3a2884c1$var$ne($8cffe22d3a2884c1$var$qn(t));
    }(t.query), new $8cffe22d3a2884c1$var$Pr(e, t.targetId, 0 /* Listen */ , t.lastListenSequenceNumber, r, i, $8cffe22d3a2884c1$var$J.fromBase64String(t.resumeToken)) /** Encodes TargetData into a DbTarget for storage locally. */ ;
}
function $8cffe22d3a2884c1$var$Qr(t, e) {
    var n, r = $8cffe22d3a2884c1$var$Br(e.snapshotVersion), i = $8cffe22d3a2884c1$var$Br(e.lastLimboFreeSnapshotVersion);
    n = $8cffe22d3a2884c1$var$xt(e.target) ? $8cffe22d3a2884c1$var$Mn(t.Lt, e.target) : $8cffe22d3a2884c1$var$Vn(t.Lt, e.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    var o = e.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return new $8cffe22d3a2884c1$var$hr(e.targetId, $8cffe22d3a2884c1$var$kt(e.target), r, o, e.sequenceNumber, i, n);
}
/**
 * A helper function for figuring out what kind of query has been stored.
 */ /**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $8cffe22d3a2884c1$var$zr(t) {
    var e = $8cffe22d3a2884c1$var$qn({
        parent: t.parent,
        structuredQuery: t.structuredQuery
    });
    return "LAST" === t.limitType ? $8cffe22d3a2884c1$var$re(e, e.limit, "L" /* Last */ ) : e;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$Wr = /** @class */ function() {
    function t() {}
    return t.prototype.getBundleMetadata = function(t, e) {
        return $8cffe22d3a2884c1$var$Hr(t).get(e).next(function(t) {
            if (t) return {
                id: (e = t).bundleId,
                createTime: $8cffe22d3a2884c1$var$jr(e.createTime),
                version: e.version
            };
            /** Encodes a DbBundle to a BundleMetadata object. */ var e;
        /** Encodes a BundleMetadata to a DbBundle. */ });
    }, t.prototype.saveBundleMetadata = function(t, e) {
        var n;
        return $8cffe22d3a2884c1$var$Hr(t).put({
            bundleId: (n = e).id,
            createTime: $8cffe22d3a2884c1$var$Br($8cffe22d3a2884c1$var$En(n.createTime)),
            version: n.version
        });
    /** Encodes a DbNamedQuery to a NamedQuery. */ }, t.prototype.getNamedQuery = function(t, e) {
        return $8cffe22d3a2884c1$var$Yr(t).get(e).next(function(t) {
            if (t) return {
                name: (e = t).name,
                query: $8cffe22d3a2884c1$var$zr(e.bundledQuery),
                readTime: $8cffe22d3a2884c1$var$jr(e.readTime)
            };
            var e;
        /** Encodes a NamedQuery from a bundle proto to a DbNamedQuery. */ });
    }, t.prototype.saveNamedQuery = function(t, e) {
        return $8cffe22d3a2884c1$var$Yr(t).put(function(t) {
            return {
                name: t.name,
                readTime: $8cffe22d3a2884c1$var$Br($8cffe22d3a2884c1$var$En(t.readTime)),
                bundledQuery: t.bundledQuery
            };
        }(e));
    }, t;
}();
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $8cffe22d3a2884c1$var$Hr(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$yr.store);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $8cffe22d3a2884c1$var$Yr(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$vr.store);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ var $8cffe22d3a2884c1$var$$r = /** @class */ function() {
    function t() {
        this.Bt = new $8cffe22d3a2884c1$var$Xr;
    }
    return t.prototype.addToCollectionParentIndex = function(t, e) {
        return this.Bt.add(e), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.getCollectionParents = function(t, e) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.Bt.getEntries(e));
    }, t;
}(), $8cffe22d3a2884c1$var$Xr = /** @class */ function() {
    function t() {
        this.index = {};
    }
    // Returns false if the entry already existed.
    return t.prototype.add = function(t) {
        var e = t.lastSegment(), n = t.popLast(), r = this.index[e] || new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$H.comparator), i = !r.has(n);
        return this.index[e] = r.add(n), i;
    }, t.prototype.has = function(t) {
        var e = t.lastSegment(), n = t.popLast(), r = this.index[e];
        return r && r.has(n);
    }, t.prototype.getEntries = function(t) {
        return (this.index[t] || new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$H.comparator)).toArray();
    }, t;
}(), $8cffe22d3a2884c1$var$Jr = /** @class */ function() {
    function t() {
        /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be used to
         * satisfy reads.
         */ this.qt = new $8cffe22d3a2884c1$var$Xr;
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ return t.prototype.addToCollectionParentIndex = function(t, e) {
        var n = this;
        if (!this.qt.has(e)) {
            var r = e.lastSegment(), i = e.popLast();
            t.addOnCommittedListener(function() {
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                n.qt.add(e);
            });
            var o = {
                collectionId: r,
                parent: $8cffe22d3a2884c1$var$Xn(i)
            };
            return $8cffe22d3a2884c1$var$Zr(t).put(o);
        }
        return $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.getCollectionParents = function(t, e) {
        var n = [], r = IDBKeyRange.bound([
            e,
            ""
        ], [
            $8cffe22d3a2884c1$var$B(e),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $8cffe22d3a2884c1$var$Zr(t).Nt(r).next(function(t) {
            for(var r = 0, i = t; r < i.length; r++){
                var o = i[r];
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (o.collectionId !== e) break;
                n.push($8cffe22d3a2884c1$var$tr(o.parent));
            }
            return n;
        });
    }, t;
}();
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ /**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $8cffe22d3a2884c1$var$Zr(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$dr.store);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$ti = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $8cffe22d3a2884c1$var$ei = /** @class */ function() {
    function t(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    t, // The percentage of sequence numbers that we will attempt to collect
    e, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n) {
        this.cacheSizeCollectionThreshold = t, this.percentileToCollect = e, this.maximumSequenceNumbersToCollect = n;
    }
    return t.withCacheSize = function(e) {
        return new t(e, t.DEFAULT_COLLECTION_PERCENTILE, t.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }, t;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $8cffe22d3a2884c1$var$ni(t, e, n) {
    var r = t.store($8cffe22d3a2884c1$var$ir.store), i = t.store($8cffe22d3a2884c1$var$or.store), o = [], s = IDBKeyRange.only(n.batchId), u = 0, a = r.$t({
        range: s
    }, function(t, e, n) {
        return u++, n.delete();
    });
    o.push(a.next(function() {
        $8cffe22d3a2884c1$var$P(1 === u);
    }));
    for(var c = [], h = 0, f = n.mutations; h < f.length; h++){
        var l = f[h], d = $8cffe22d3a2884c1$var$or.key(e, l.key.path, n.batchId);
        o.push(i.delete(d)), c.push(l.key);
    }
    return $8cffe22d3a2884c1$var$Ir.waitFor(o).next(function() {
        return c;
    });
}
/**
 * Returns an approximate size for the given document.
 */ function $8cffe22d3a2884c1$var$ri(t) {
    if (!t) return 0;
    var e;
    if (t.document) e = t.document;
    else if (t.unknownDocument) e = t.unknownDocument;
    else {
        if (!t.noDocument) throw $8cffe22d3a2884c1$var$O();
        e = t.noDocument;
    }
    return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $8cffe22d3a2884c1$var$ei.DEFAULT_COLLECTION_PERCENTILE = 10, $8cffe22d3a2884c1$var$ei.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $8cffe22d3a2884c1$var$ei.DEFAULT = new $8cffe22d3a2884c1$var$ei(41943040, $8cffe22d3a2884c1$var$ei.DEFAULT_COLLECTION_PERCENTILE, $8cffe22d3a2884c1$var$ei.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $8cffe22d3a2884c1$var$ei.DISABLED = new $8cffe22d3a2884c1$var$ei(-1, 0, 0);
var $8cffe22d3a2884c1$var$ii = /** @class */ function() {
    function t(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ t, e, n, r) {
        this.userId = t, this.R = e, this.Ut = n, this.referenceDelegate = r, /**
             * Caches the document keys for pending mutation batches. If the mutation
             * has been removed from IndexedDb, the cached value may continue to
             * be used to retrieve the batch's document keys. To remove a cached value
             * locally, `removeCachedMutationKeys()` should be invoked either directly
             * or through `removeMutationBatches()`.
             *
             * With multi-tab, when the primary client acknowledges or rejects a mutation,
             * this cache is used by secondary clients to invalidate the local
             * view of the documents that were previously affected by the mutation.
             */ // PORTING NOTE: Multi-tab only.
        this.Kt = {} /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ ;
    }
    return t.Qt = function(e, n, r, i) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        return $8cffe22d3a2884c1$var$P("" !== e.uid), new t(e.isAuthenticated() ? e.uid : "", n, r, i);
    }, t.prototype.checkEmpty = function(t) {
        var e = !0, n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $8cffe22d3a2884c1$var$si(t).$t({
            index: $8cffe22d3a2884c1$var$ir.userMutationsIndex,
            range: n
        }, function(t, n, r) {
            e = !1, r.done();
        }).next(function() {
            return e;
        });
    }, t.prototype.addMutationBatch = function(t, e, n, r) {
        var i = this, o = $8cffe22d3a2884c1$var$ui(t), s = $8cffe22d3a2884c1$var$si(t);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next(function(u) {
            $8cffe22d3a2884c1$var$P("number" == typeof u);
            for(var a = new $8cffe22d3a2884c1$var$Lr(u, e, n, r), c = function(t, e, n) {
                var r = n.baseMutations.map(function(e) {
                    return $8cffe22d3a2884c1$var$Pn(t.Lt, e);
                }), i = n.mutations.map(function(e) {
                    return $8cffe22d3a2884c1$var$Pn(t.Lt, e);
                });
                return new $8cffe22d3a2884c1$var$ir(e, n.batchId, n.localWriteTime.toMillis(), r, i);
            }(i.R, i.userId, a), h = [], f = new $8cffe22d3a2884c1$var$$e(function(t, e) {
                return $8cffe22d3a2884c1$var$q(t.canonicalString(), e.canonicalString());
            }), l = 0, d = r; l < d.length; l++){
                var p = d[l], y = $8cffe22d3a2884c1$var$or.key(i.userId, p.key.path, u);
                f = f.add(p.key.path.popLast()), h.push(s.put(c)), h.push(o.put(y, $8cffe22d3a2884c1$var$or.PLACEHOLDER));
            }
            return f.forEach(function(e) {
                h.push(i.Ut.addToCollectionParentIndex(t, e));
            }), t.addOnCommittedListener(function() {
                i.Kt[u] = a.keys();
            }), $8cffe22d3a2884c1$var$Ir.waitFor(h).next(function() {
                return a;
            });
        });
    }, t.prototype.lookupMutationBatch = function(t, e) {
        var n = this;
        return $8cffe22d3a2884c1$var$si(t).get(e).next(function(t) {
            return t ? ($8cffe22d3a2884c1$var$P(t.userId === n.userId), $8cffe22d3a2884c1$var$Kr(n.R, t)) : null;
        });
    }, /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.jt = function(t, e) {
        var n = this;
        return this.Kt[e] ? $8cffe22d3a2884c1$var$Ir.resolve(this.Kt[e]) : this.lookupMutationBatch(t, e).next(function(t) {
            if (t) {
                var r = t.keys();
                return n.Kt[e] = r, r;
            }
            return null;
        });
    }, t.prototype.getNextMutationBatchAfterBatchId = function(t, e) {
        var n = this, r = e + 1, i = IDBKeyRange.lowerBound([
            this.userId,
            r
        ]), o = null;
        return $8cffe22d3a2884c1$var$si(t).$t({
            index: $8cffe22d3a2884c1$var$ir.userMutationsIndex,
            range: i
        }, function(t, e, i) {
            e.userId === n.userId && ($8cffe22d3a2884c1$var$P(e.batchId >= r), o = $8cffe22d3a2884c1$var$Kr(n.R, e)), i.done();
        }).next(function() {
            return o;
        });
    }, t.prototype.getHighestUnacknowledgedBatchId = function(t) {
        var e = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]), n = -1;
        return $8cffe22d3a2884c1$var$si(t).$t({
            index: $8cffe22d3a2884c1$var$ir.userMutationsIndex,
            range: e,
            reverse: !0
        }, function(t, e, r) {
            n = e.batchId, r.done();
        }).next(function() {
            return n;
        });
    }, t.prototype.getAllMutationBatches = function(t) {
        var e = this, n = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $8cffe22d3a2884c1$var$si(t).Nt($8cffe22d3a2884c1$var$ir.userMutationsIndex, n).next(function(t) {
            return t.map(function(t) {
                return $8cffe22d3a2884c1$var$Kr(e.R, t);
            });
        });
    }, t.prototype.getAllMutationBatchesAffectingDocumentKey = function(t, e) {
        var n = this, r = $8cffe22d3a2884c1$var$or.prefixForPath(this.userId, e.path), i = IDBKeyRange.lowerBound(r), o = [];
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        return $8cffe22d3a2884c1$var$ui(t).$t({
            range: i
        }, function(r, i, s) {
            var u = r[0], a = r[1], c = r[2], h = $8cffe22d3a2884c1$var$tr(a);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (u === n.userId && e.path.isEqual(h)) // Look up the mutation batch in the store.
            return $8cffe22d3a2884c1$var$si(t).get(c).next(function(t) {
                if (!t) throw $8cffe22d3a2884c1$var$O();
                $8cffe22d3a2884c1$var$P(t.userId === n.userId), o.push($8cffe22d3a2884c1$var$Kr(n.R, t));
            });
            s.done();
        }).next(function() {
            return o;
        });
    }, t.prototype.getAllMutationBatchesAffectingDocumentKeys = function(t, e) {
        var n = this, r = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q), i = [];
        return e.forEach(function(e) {
            var o = $8cffe22d3a2884c1$var$or.prefixForPath(n.userId, e.path), s = IDBKeyRange.lowerBound(o), u = $8cffe22d3a2884c1$var$ui(t).$t({
                range: s
            }, function(t, i, o) {
                var s = t[0], u = t[1], a = t[2], c = $8cffe22d3a2884c1$var$tr(u);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === n.userId && e.path.isEqual(c) ? r = r.add(a) : o.done();
            });
            i.push(u);
        }), $8cffe22d3a2884c1$var$Ir.waitFor(i).next(function() {
            return n.Wt(t, r);
        });
    }, t.prototype.getAllMutationBatchesAffectingQuery = function(t, e) {
        var n = this, r = e.path, i = r.length + 1, o = $8cffe22d3a2884c1$var$or.prefixForPath(this.userId, r), s = IDBKeyRange.lowerBound(o), u = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q);
        return $8cffe22d3a2884c1$var$ui(t).$t({
            range: s
        }, function(t, e, o) {
            var s = t[0], a = t[1], c = t[2], h = $8cffe22d3a2884c1$var$tr(a);
            s === n.userId && r.isPrefixOf(h) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            h.length === i && (u = u.add(c)) : o.done();
        }).next(function() {
            return n.Wt(t, u);
        });
    }, t.prototype.Wt = function(t, e) {
        var n = this, r = [], i = [];
        // TODO(rockwood): Implement this using iterate.
        return e.forEach(function(e) {
            i.push($8cffe22d3a2884c1$var$si(t).get(e).next(function(t) {
                if (null === t) throw $8cffe22d3a2884c1$var$O();
                $8cffe22d3a2884c1$var$P(t.userId === n.userId), r.push($8cffe22d3a2884c1$var$Kr(n.R, t));
            }));
        }), $8cffe22d3a2884c1$var$Ir.waitFor(i).next(function() {
            return r;
        });
    }, t.prototype.removeMutationBatch = function(t, e) {
        var n = this;
        return $8cffe22d3a2884c1$var$ni(t.Mt, this.userId, e).next(function(r) {
            return t.addOnCommittedListener(function() {
                n.Gt(e.batchId);
            }), $8cffe22d3a2884c1$var$Ir.forEach(r, function(e) {
                return n.referenceDelegate.markPotentiallyOrphaned(t, e);
            });
        });
    }, /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    t.prototype.Gt = function(t) {
        delete this.Kt[t];
    }, t.prototype.performConsistencyCheck = function(t) {
        var e = this;
        return this.checkEmpty(t).next(function(n) {
            if (!n) return $8cffe22d3a2884c1$var$Ir.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var r = IDBKeyRange.lowerBound($8cffe22d3a2884c1$var$or.prefixForUser(e.userId)), i = [];
            return $8cffe22d3a2884c1$var$ui(t).$t({
                range: r
            }, function(t, n, r) {
                if (t[0] === e.userId) {
                    var o = $8cffe22d3a2884c1$var$tr(t[1]);
                    i.push(o);
                } else r.done();
            }).next(function() {
                $8cffe22d3a2884c1$var$P(0 === i.length);
            });
        });
    }, t.prototype.containsKey = function(t, e) {
        return $8cffe22d3a2884c1$var$oi(t, this.userId, e);
    }, // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ t.prototype.zt = function(t) {
        var e = this;
        return $8cffe22d3a2884c1$var$ai(t).get(this.userId).next(function(t) {
            return t || new $8cffe22d3a2884c1$var$rr(e.userId, -1, /*lastStreamToken=*/ "");
        });
    }, t;
}();
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $8cffe22d3a2884c1$var$oi(t, e, n) {
    var r = $8cffe22d3a2884c1$var$or.prefixForPath(e, n.path), i = r[1], o = IDBKeyRange.lowerBound(r), s = !1;
    return $8cffe22d3a2884c1$var$ui(t).$t({
        range: o,
        Ft: !0
    }, function(t, n, r) {
        var o = t[0], u = t[1];
        /*batchID*/ t[2], o === e && u === i && (s = !0), r.done();
    }).next(function() {
        return s;
    });
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $8cffe22d3a2884c1$var$si(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$ir.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $8cffe22d3a2884c1$var$ui(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$or.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $8cffe22d3a2884c1$var$ai(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$rr.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ var $8cffe22d3a2884c1$var$ci = /** @class */ function() {
    function t(t) {
        this.Ht = t;
    }
    return t.prototype.next = function() {
        return this.Ht += 2, this.Ht;
    }, t.Jt = function() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new t(0);
    }, t.Yt = function() {
        // Sync engine assigns target IDs for limbo document detection.
        return new t(-1);
    }, t;
}(), $8cffe22d3a2884c1$var$hi = /** @class */ function() {
    function t(t, e) {
        this.referenceDelegate = t, this.R = e;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    return t.prototype.allocateTargetId = function(t) {
        var e = this;
        return this.Xt(t).next(function(n) {
            var r = new $8cffe22d3a2884c1$var$ci(n.highestTargetId);
            return n.highestTargetId = r.next(), e.Zt(t, n).next(function() {
                return n.highestTargetId;
            });
        });
    }, t.prototype.getLastRemoteSnapshotVersion = function(t) {
        return this.Xt(t).next(function(t) {
            return $8cffe22d3a2884c1$var$K.fromTimestamp(new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds));
        });
    }, t.prototype.getHighestSequenceNumber = function(t) {
        return this.Xt(t).next(function(t) {
            return t.highestListenSequenceNumber;
        });
    }, t.prototype.setTargetsMetadata = function(t, e, n) {
        var r = this;
        return this.Xt(t).next(function(i) {
            return i.highestListenSequenceNumber = e, n && (i.lastRemoteSnapshotVersion = n.toTimestamp()), e > i.highestListenSequenceNumber && (i.highestListenSequenceNumber = e), r.Zt(t, i);
        });
    }, t.prototype.addTargetData = function(t, e) {
        var n = this;
        return this.te(t, e).next(function() {
            return n.Xt(t).next(function(r) {
                return r.targetCount += 1, n.ee(e, r), n.Zt(t, r);
            });
        });
    }, t.prototype.updateTargetData = function(t, e) {
        return this.te(t, e);
    }, t.prototype.removeTargetData = function(t, e) {
        var n = this;
        return this.removeMatchingKeysForTargetId(t, e.targetId).next(function() {
            return $8cffe22d3a2884c1$var$fi(t).delete(e.targetId);
        }).next(function() {
            return n.Xt(t);
        }).next(function(e) {
            return $8cffe22d3a2884c1$var$P(e.targetCount > 0), e.targetCount -= 1, n.Zt(t, e);
        });
    }, /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ t.prototype.removeTargets = function(t, e, n) {
        var r = this, i = 0, o = [];
        return $8cffe22d3a2884c1$var$fi(t).$t(function(s, u) {
            var a = $8cffe22d3a2884c1$var$Gr(u);
            a.sequenceNumber <= e && null === n.get(a.targetId) && (i++, o.push(r.removeTargetData(t, a)));
        }).next(function() {
            return $8cffe22d3a2884c1$var$Ir.waitFor(o);
        }).next(function() {
            return i;
        });
    }, /**
     * Call provided function with each `TargetData` that we have cached.
     */ t.prototype.forEachTarget = function(t, e) {
        return $8cffe22d3a2884c1$var$fi(t).$t(function(t, n) {
            var r = $8cffe22d3a2884c1$var$Gr(n);
            e(r);
        });
    }, t.prototype.Xt = function(t) {
        return $8cffe22d3a2884c1$var$li(t).get($8cffe22d3a2884c1$var$lr.key).next(function(t) {
            return $8cffe22d3a2884c1$var$P(null !== t), t;
        });
    }, t.prototype.Zt = function(t, e) {
        return $8cffe22d3a2884c1$var$li(t).put($8cffe22d3a2884c1$var$lr.key, e);
    }, t.prototype.te = function(t, e) {
        return $8cffe22d3a2884c1$var$fi(t).put($8cffe22d3a2884c1$var$Qr(this.R, e));
    }, /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ t.prototype.ee = function(t, e) {
        var n = !1;
        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }, t.prototype.getTargetCount = function(t) {
        return this.Xt(t).next(function(t) {
            return t.targetCount;
        });
    }, t.prototype.getTargetData = function(t, e) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        var n = $8cffe22d3a2884c1$var$kt(e), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]), i = null;
        return $8cffe22d3a2884c1$var$fi(t).$t({
            range: r,
            index: $8cffe22d3a2884c1$var$hr.queryTargetsIndexName
        }, function(t, n, r) {
            var o = $8cffe22d3a2884c1$var$Gr(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $8cffe22d3a2884c1$var$Ct(e, o.target) && (i = o, r.done());
        }).next(function() {
            return i;
        });
    }, t.prototype.addMatchingKeys = function(t, e, n) {
        var r = this, i = [], o = $8cffe22d3a2884c1$var$di(t);
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        return e.forEach(function(e) {
            var s = $8cffe22d3a2884c1$var$Xn(e.path);
            i.push(o.put(new $8cffe22d3a2884c1$var$fr(n, s))), i.push(r.referenceDelegate.addReference(t, n, e));
        }), $8cffe22d3a2884c1$var$Ir.waitFor(i);
    }, t.prototype.removeMatchingKeys = function(t, e, n) {
        var r = this, i = $8cffe22d3a2884c1$var$di(t);
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        return $8cffe22d3a2884c1$var$Ir.forEach(e, function(e) {
            var o = $8cffe22d3a2884c1$var$Xn(e.path);
            return $8cffe22d3a2884c1$var$Ir.waitFor([
                i.delete([
                    n,
                    o
                ]),
                r.referenceDelegate.removeReference(t, n, e)
            ]);
        });
    }, t.prototype.removeMatchingKeysForTargetId = function(t, e) {
        var n = $8cffe22d3a2884c1$var$di(t), r = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }, t.prototype.getMatchingKeysForTargetId = function(t, e) {
        var n = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $8cffe22d3a2884c1$var$di(t), i = $8cffe22d3a2884c1$var$sn();
        return r.$t({
            range: n,
            Ft: !0
        }, function(t, e, n) {
            var r = $8cffe22d3a2884c1$var$tr(t[1]), o = new $8cffe22d3a2884c1$var$ct(r);
            i = i.add(o);
        }).next(function() {
            return i;
        });
    }, t.prototype.containsKey = function(t, e) {
        var n = $8cffe22d3a2884c1$var$Xn(e.path), r = IDBKeyRange.bound([
            n
        ], [
            $8cffe22d3a2884c1$var$B(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), i = 0;
        return $8cffe22d3a2884c1$var$di(t).$t({
            index: $8cffe22d3a2884c1$var$fr.documentTargetsIndex,
            Ft: !0,
            range: r
        }, function(t, e, n) {
            var r = t[0];
            t[1], // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== r && (i++, n.done());
        }).next(function() {
            return i > 0;
        });
    }, /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.lt = function(t, e) {
        return $8cffe22d3a2884c1$var$fi(t).get(e).next(function(t) {
            return t ? $8cffe22d3a2884c1$var$Gr(t) : null;
        });
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $8cffe22d3a2884c1$var$fi(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$hr.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $8cffe22d3a2884c1$var$li(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$lr.store);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $8cffe22d3a2884c1$var$di(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$fr.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ function $8cffe22d3a2884c1$var$pi(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(e) {
            if (t.code !== $8cffe22d3a2884c1$var$N.FAILED_PRECONDITION || t.message !== $8cffe22d3a2884c1$var$gr) throw t;
            return $8cffe22d3a2884c1$var$C("LocalStore", "Unexpectedly lost primary lease"), [
                2 /*return*/ 
            ];
        });
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8cffe22d3a2884c1$var$yi(t, e) {
    var n = t[0], r = t[1], i = e[0], o = e[1], s = $8cffe22d3a2884c1$var$q(n, i);
    return 0 === s ? $8cffe22d3a2884c1$var$q(r, o) : s;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ var $8cffe22d3a2884c1$var$vi = /** @class */ function() {
    function t(t) {
        this.ne = t, this.buffer = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$yi), this.se = 0;
    }
    return t.prototype.ie = function() {
        return ++this.se;
    }, t.prototype.re = function(t) {
        var e = [
            t,
            this.ie()
        ];
        if (this.buffer.size < this.ne) this.buffer = this.buffer.add(e);
        else {
            var n = this.buffer.last();
            $8cffe22d3a2884c1$var$yi(e, n) < 0 && (this.buffer = this.buffer.delete(n).add(e));
        }
    }, Object.defineProperty(t.prototype, "maxValue", {
        get: function() {
            // Guaranteed to be non-empty. If we decide we are not collecting any
            // sequence numbers, nthSequenceNumber below short-circuits. If we have
            // decided that we are collecting n sequence numbers, it's because n is some
            // percentage of the existing sequence numbers. That means we should never
            // be in a situation where we are collecting sequence numbers but don't
            // actually have any.
            return this.buffer.last()[0];
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $8cffe22d3a2884c1$var$mi = /** @class */ function() {
    function t(t, e) {
        this.garbageCollector = t, this.asyncQueue = e, this.oe = !1, this.ce = null;
    }
    return t.prototype.start = function(t) {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.ue(t);
    }, t.prototype.stop = function() {
        this.ce && (this.ce.cancel(), this.ce = null);
    }, Object.defineProperty(t.prototype, "started", {
        get: function() {
            return null !== this.ce;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.ue = function(t) {
        var e = this, i = this.oe ? 3e5 : 6e4;
        $8cffe22d3a2884c1$var$C("LruGarbageCollector", "Garbage collection scheduled in " + i + "ms"), this.ce = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* LruGarbageCollection */ , i, function() {
            return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                var e;
                return (0, $2WUgS.__generator)(this, function(n) {
                    switch(n.label){
                        case 0:
                            this.ce = null, this.oe = !0, n.label = 1;
                        case 1:
                            return n.trys.push([
                                1,
                                3,
                                ,
                                7
                            ]), [
                                4 /*yield*/ ,
                                t.collectGarbage(this.garbageCollector)
                            ];
                        case 2:
                            return n.sent(), [
                                3 /*break*/ ,
                                7
                            ];
                        case 3:
                            return $8cffe22d3a2884c1$var$Nr(e = n.sent()) ? ($8cffe22d3a2884c1$var$C("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e), [
                                3 /*break*/ ,
                                6
                            ]) : [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                $8cffe22d3a2884c1$var$pi(e)
                            ];
                        case 5:
                            n.sent(), n.label = 6;
                        case 6:
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                4 /*yield*/ ,
                                this.ue(t)
                            ];
                        case 8:
                            return n.sent(), [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, t;
}(), $8cffe22d3a2884c1$var$gi = /** @class */ function() {
    function t(t, e) {
        this.ae = t, this.params = e;
    }
    return t.prototype.calculateTargetCount = function(t, e) {
        return this.ae.he(t).next(function(t) {
            return Math.floor(e / 100 * t);
        });
    }, t.prototype.nthSequenceNumber = function(t, e) {
        var n = this;
        if (0 === e) return $8cffe22d3a2884c1$var$Ir.resolve($8cffe22d3a2884c1$var$S.o);
        var r = new $8cffe22d3a2884c1$var$vi(e);
        return this.ae.forEachTarget(t, function(t) {
            return r.re(t.sequenceNumber);
        }).next(function() {
            return n.ae.le(t, function(t) {
                return r.re(t);
            });
        }).next(function() {
            return r.maxValue;
        });
    }, t.prototype.removeTargets = function(t, e, n) {
        return this.ae.removeTargets(t, e, n);
    }, t.prototype.removeOrphanedDocuments = function(t, e) {
        return this.ae.removeOrphanedDocuments(t, e);
    }, t.prototype.collect = function(t, e) {
        var n = this;
        return -1 === this.params.cacheSizeCollectionThreshold ? ($8cffe22d3a2884c1$var$C("LruGarbageCollector", "Garbage collection skipped; disabled"), $8cffe22d3a2884c1$var$Ir.resolve($8cffe22d3a2884c1$var$ti)) : this.getCacheSize(t).next(function(r) {
            return r < n.params.cacheSizeCollectionThreshold ? ($8cffe22d3a2884c1$var$C("LruGarbageCollector", "Garbage collection skipped; Cache size " + r + " is lower than threshold " + n.params.cacheSizeCollectionThreshold), $8cffe22d3a2884c1$var$ti) : n.fe(t, e);
        });
    }, t.prototype.getCacheSize = function(t) {
        return this.ae.getCacheSize(t);
    }, t.prototype.fe = function(t, e) {
        var n, r, i, o, s, u, a, c = this, h = Date.now();
        return this.calculateTargetCount(t, this.params.percentileToCollect).next(function(e) {
            // Cap at the configured max
            return e > c.params.maximumSequenceNumbersToCollect ? ($8cffe22d3a2884c1$var$C("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of " + c.params.maximumSequenceNumbersToCollect + " from " + e), r = c.params.maximumSequenceNumbersToCollect) : r = e, o = Date.now(), c.nthSequenceNumber(t, r);
        }).next(function(r) {
            return n = r, s = Date.now(), c.removeTargets(t, n, e);
        }).next(function(e) {
            return i = e, u = Date.now(), c.removeOrphanedDocuments(t, n);
        }).next(function(t) {
            return a = Date.now(), $8cffe22d3a2884c1$var$k() <= (0, $i4pDv.LogLevel).DEBUG && $8cffe22d3a2884c1$var$C("LruGarbageCollector", "LRU Garbage Collection\n	Counted targets in " + (o - h) + "ms\n	Determined least recently used " + r + " in " + (s - o) + "ms\n	Removed " + i + " targets in " + (u - s) + "ms\n	Removed " + t + " documents in " + (a - u) + "ms\nTotal Duration: " + (a - h) + "ms"), $8cffe22d3a2884c1$var$Ir.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: t
            });
        });
    }, t;
}(), $8cffe22d3a2884c1$var$wi = /** @class */ function() {
    function t(t, e) {
        this.db = t, this.garbageCollector = function(t, e) {
            return new $8cffe22d3a2884c1$var$gi(t, e);
        }(this, e);
    }
    return t.prototype.he = function(t) {
        var e = this.de(t);
        return this.db.getTargetCache().getTargetCount(t).next(function(t) {
            return e.next(function(e) {
                return t + e;
            });
        });
    }, t.prototype.de = function(t) {
        var e = 0;
        return this.le(t, function(t) {
            e++;
        }).next(function() {
            return e;
        });
    }, t.prototype.forEachTarget = function(t, e) {
        return this.db.getTargetCache().forEachTarget(t, e);
    }, t.prototype.le = function(t, e) {
        return this.we(t, function(t, n) {
            return e(n);
        });
    }, t.prototype.addReference = function(t, e, n) {
        return $8cffe22d3a2884c1$var$bi(t, n);
    }, t.prototype.removeReference = function(t, e, n) {
        return $8cffe22d3a2884c1$var$bi(t, n);
    }, t.prototype.removeTargets = function(t, e, n) {
        return this.db.getTargetCache().removeTargets(t, e, n);
    }, t.prototype.markPotentiallyOrphaned = function(t, e) {
        return $8cffe22d3a2884c1$var$bi(t, e);
    }, /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ t.prototype._e = function(t, e) {
        return function(t, e) {
            var n = !1;
            return $8cffe22d3a2884c1$var$ai(t).Ot(function(r) {
                return $8cffe22d3a2884c1$var$oi(t, r, e).next(function(t) {
                    return t && (n = !0), $8cffe22d3a2884c1$var$Ir.resolve(!t);
                });
            }).next(function() {
                return n;
            });
        }(t, e);
    }, t.prototype.removeOrphanedDocuments = function(t, e) {
        var n = this, r = this.db.getRemoteDocumentCache().newChangeBuffer(), i = [], o = 0;
        return this.we(t, function(s, u) {
            if (u <= e) {
                var a = n._e(t, s).next(function(e) {
                    if (!e) // Our size accounting requires us to read all documents before
                    // removing them.
                    return o++, r.getEntry(t, s).next(function() {
                        return r.removeEntry(s), $8cffe22d3a2884c1$var$di(t).delete([
                            0,
                            $8cffe22d3a2884c1$var$Xn(s.path)
                        ]);
                    });
                });
                i.push(a);
            }
        }).next(function() {
            return $8cffe22d3a2884c1$var$Ir.waitFor(i);
        }).next(function() {
            return r.apply(t);
        }).next(function() {
            return o;
        });
    }, t.prototype.removeTarget = function(t, e) {
        var n = e.withSequenceNumber(t.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(t, n);
    }, t.prototype.updateLimboDocument = function(t, e) {
        return $8cffe22d3a2884c1$var$bi(t, e);
    }, /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ t.prototype.we = function(t, e) {
        var n, r = $8cffe22d3a2884c1$var$di(t), i = $8cffe22d3a2884c1$var$S.o;
        return r.$t({
            index: $8cffe22d3a2884c1$var$fr.documentTargetsIndex
        }, function(t, r) {
            var o = t[0];
            t[1];
            var s = r.path, u = r.sequenceNumber;
            0 === o ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $8cffe22d3a2884c1$var$S.o && e(new $8cffe22d3a2884c1$var$ct($8cffe22d3a2884c1$var$tr(n)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = u, n = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $8cffe22d3a2884c1$var$S.o;
        }).next(function() {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $8cffe22d3a2884c1$var$S.o && e(new $8cffe22d3a2884c1$var$ct($8cffe22d3a2884c1$var$tr(n)), i);
        });
    }, t.prototype.getCacheSize = function(t) {
        return this.db.getRemoteDocumentCache().getSize(t);
    }, t;
}();
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ function $8cffe22d3a2884c1$var$bi(t, e) {
    return $8cffe22d3a2884c1$var$di(t).put(/**
 * @returns A value suitable for writing a sentinel row in the target-document
 * store.
 */ function(t, e) {
        return new $8cffe22d3a2884c1$var$fr(0, $8cffe22d3a2884c1$var$Xn(t.path), e);
    }(e, t.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ var $8cffe22d3a2884c1$var$Ii = /** @class */ function() {
    function t(t, e) {
        this.mapKeyFn = t, this.equalsFn = e, /**
             * The inner map for a key/value pair. Due to the possibility of collisions we
             * keep a list of entries that we do a linear search through to find an actual
             * match. Note that collisions should be rare, so we still expect near
             * constant time lookups in practice.
             */ this.inner = {} /** Get a value for this key, or undefined if it does not exist. */ ;
    }
    return t.prototype.get = function(t) {
        var e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 !== n) for(var r = 0, i = n; r < i.length; r++){
            var o = i[r], s = o[0], u = o[1];
            if (this.equalsFn(s, t)) return u;
        }
    }, t.prototype.has = function(t) {
        return void 0 !== this.get(t);
    }, /** Put this key and value in the map. */ t.prototype.set = function(t, e) {
        var n = this.mapKeyFn(t), r = this.inner[n];
        if (void 0 !== r) {
            for(var i = 0; i < r.length; i++)if (this.equalsFn(r[i][0], t)) return void (r[i] = [
                t,
                e
            ]);
            r.push([
                t,
                e
            ]);
        } else this.inner[n] = [
            [
                t,
                e
            ]
        ];
    }, /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ t.prototype.delete = function(t) {
        var e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 === n) return !1;
        for(var r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], t)) return 1 === n.length ? delete this.inner[e] : n.splice(r, 1), !0;
        return !1;
    }, t.prototype.forEach = function(t) {
        $8cffe22d3a2884c1$var$Q(this.inner, function(e, n) {
            for(var r = 0, i = n; r < i.length; r++){
                var o = i[r], s = o[0], u = o[1];
                t(s, u);
            }
        });
    }, t.prototype.isEmpty = function() {
        return $8cffe22d3a2884c1$var$z(this.inner);
    }, t;
}(), $8cffe22d3a2884c1$var$Ti = /** @class */ function() {
    function t() {
        // A mapping of document key to the new cache entry that should be written (or null if any
        // existing cache entry should be removed).
        this.changes = new $8cffe22d3a2884c1$var$Ii(function(t) {
            return t.toString();
        }, function(t, e) {
            return t.isEqual(e);
        }), this.changesApplied = !1;
    }
    return t.prototype.getReadTime = function(t) {
        var e = this.changes.get(t);
        return e ? e.readTime : $8cffe22d3a2884c1$var$K.min();
    }, /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ t.prototype.addEntry = function(t, e) {
        this.assertNotApplied(), this.changes.set(t.key, {
            document: t,
            readTime: e
        });
    }, /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ t.prototype.removeEntry = function(t, e) {
        void 0 === e && (e = null), this.assertNotApplied(), this.changes.set(t, {
            document: $8cffe22d3a2884c1$var$Nt.newInvalidDocument(t),
            readTime: e
        });
    }, /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ t.prototype.getEntry = function(t, e) {
        this.assertNotApplied();
        var n = this.changes.get(e);
        return void 0 !== n ? $8cffe22d3a2884c1$var$Ir.resolve(n.document) : this.getFromCache(t, e);
    }, /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ t.prototype.getEntries = function(t, e) {
        return this.getAllFromCache(t, e);
    }, /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ t.prototype.apply = function(t) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
    }, /** Helper to assert this.changes is not null  */ t.prototype.assertNotApplied = function() {}, t;
}(), $8cffe22d3a2884c1$var$_i = /** @class */ function() {
    /**
     * @param serializer - The document serializer.
     * @param indexManager - The query indexes that need to be maintained.
     */ function t(t, e) {
        this.R = t, this.Ut = e /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ ;
    }
    return t.prototype.addEntry = function(t, e, n) {
        return $8cffe22d3a2884c1$var$Ni(t).put($8cffe22d3a2884c1$var$Di(e), n);
    }, /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ t.prototype.removeEntry = function(t, e) {
        var n = $8cffe22d3a2884c1$var$Ni(t), r = $8cffe22d3a2884c1$var$Di(e);
        return n.delete(r);
    }, /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ t.prototype.updateMetadata = function(t, e) {
        var n = this;
        return this.getMetadata(t).next(function(r) {
            return r.byteSize += e, n.me(t, r);
        });
    }, t.prototype.getEntry = function(t, e) {
        var n = this;
        return $8cffe22d3a2884c1$var$Ni(t).get($8cffe22d3a2884c1$var$Di(e)).next(function(t) {
            return n.ye(e, t);
        });
    }, /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ t.prototype.ge = function(t, e) {
        var n = this;
        return $8cffe22d3a2884c1$var$Ni(t).get($8cffe22d3a2884c1$var$Di(e)).next(function(t) {
            return {
                document: n.ye(e, t),
                size: $8cffe22d3a2884c1$var$ri(t)
            };
        });
    }, t.prototype.getEntries = function(t, e) {
        var n = this, r = $8cffe22d3a2884c1$var$Ze();
        return this.pe(t, e, function(t, e) {
            var i = n.ye(t, e);
            r = r.insert(t, i);
        }).next(function() {
            return r;
        });
    }, /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ t.prototype.Ee = function(t, e) {
        var n = this, r = $8cffe22d3a2884c1$var$Ze(), i = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
        return this.pe(t, e, function(t, e) {
            var o = n.ye(t, e);
            r = r.insert(t, o), i = i.insert(t, $8cffe22d3a2884c1$var$ri(e));
        }).next(function() {
            return {
                documents: r,
                Te: i
            };
        });
    }, t.prototype.pe = function(t, e, n) {
        if (e.isEmpty()) return $8cffe22d3a2884c1$var$Ir.resolve();
        var r = IDBKeyRange.bound(e.first().path.toArray(), e.last().path.toArray()), i = e.getIterator(), o = i.getNext();
        return $8cffe22d3a2884c1$var$Ni(t).$t({
            range: r
        }, function(t, e, r) {
            // Go through keys not found in cache.
            for(var s = $8cffe22d3a2884c1$var$ct.fromSegments(t); o && $8cffe22d3a2884c1$var$ct.comparator(o, s) < 0;)n(o, null), o = i.getNext();
            o && o.isEqual(s) && // Key found in cache.
            (n(o, e), o = i.hasNext() ? i.getNext() : null), // Skip to the next key (if there is one).
            o ? r.Ct(o.path.toArray()) : r.done();
        }).next(function() {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = i.hasNext() ? i.getNext() : null;
        });
    }, t.prototype.getDocumentsMatchingQuery = function(t, e, n) {
        var r = this, i = $8cffe22d3a2884c1$var$Ze(), o = e.path.length + 1, s = {};
        if (n.isEqual($8cffe22d3a2884c1$var$K.min())) {
            // Documents are ordered by key, so we can use a prefix scan to narrow
            // down the documents we need to match the query against.
            var u = e.path.toArray();
            s.range = IDBKeyRange.lowerBound(u);
        } else {
            // Execute an index-free query and filter by read time. This is safe
            // since all document changes to queries that have a
            // lastLimboFreeSnapshotVersion (`sinceReadTime`) have a read time set.
            var a = e.path.toArray(), c = $8cffe22d3a2884c1$var$qr(n);
            s.range = IDBKeyRange.lowerBound([
                a,
                c
            ], /* open= */ !0), s.index = $8cffe22d3a2884c1$var$ar.collectionReadTimeIndex;
        }
        return $8cffe22d3a2884c1$var$Ni(t).$t(s, function(t, n, s) {
            // The query is actually returning any path that starts with the query
            // path prefix which may include documents in subcollections. For
            // example, a query on 'rooms' will return rooms/abc/messages/xyx but we
            // shouldn't match it. Fix this by discarding rows with document keys
            // more than one segment longer than the query path.
            if (t.length === o) {
                var u = $8cffe22d3a2884c1$var$Mr(r.R, n);
                e.path.isPrefixOf(u.key.path) ? $8cffe22d3a2884c1$var$ue(e, u) && (i = i.insert(u.key, u)) : s.done();
            }
        }).next(function() {
            return i;
        });
    }, t.prototype.newChangeBuffer = function(t) {
        return new $8cffe22d3a2884c1$var$Ei(this, !!t && t.trackRemovals);
    }, t.prototype.getSize = function(t) {
        return this.getMetadata(t).next(function(t) {
            return t.byteSize;
        });
    }, t.prototype.getMetadata = function(t) {
        return $8cffe22d3a2884c1$var$Si(t).get($8cffe22d3a2884c1$var$cr.key).next(function(t) {
            return $8cffe22d3a2884c1$var$P(!!t), t;
        });
    }, t.prototype.me = function(t, e) {
        return $8cffe22d3a2884c1$var$Si(t).put($8cffe22d3a2884c1$var$cr.key, e);
    }, /**
     * Decodes `remoteDoc` and returns the document (or null, if the document
     * corresponds to the format used for sentinel deletes).
     */ t.prototype.ye = function(t, e) {
        if (e) {
            var n = $8cffe22d3a2884c1$var$Mr(this.R, e);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!n.isNoDocument() || !n.version.isEqual($8cffe22d3a2884c1$var$K.min())) return n;
        }
        return $8cffe22d3a2884c1$var$Nt.newInvalidDocument(t);
    }, t;
}(), $8cffe22d3a2884c1$var$Ei = /** @class */ function(e) {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).Ie = t, r.trackRemovals = n, // A map of document sizes prior to applying the changes in this buffer.
        r.Ae = new $8cffe22d3a2884c1$var$Ii(function(t) {
            return t.toString();
        }, function(t, e) {
            return t.isEqual(e);
        }), r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.applyChanges = function(t) {
        var e = this, n = [], r = 0, i = new $8cffe22d3a2884c1$var$$e(function(t, e) {
            return $8cffe22d3a2884c1$var$q(t.canonicalString(), e.canonicalString());
        });
        return this.changes.forEach(function(o, s) {
            var u = e.Ae.get(o);
            if (s.document.isValidDocument()) {
                var a = $8cffe22d3a2884c1$var$Vr(e.Ie.R, s.document, e.getReadTime(o));
                i = i.add(o.path.popLast());
                var c = $8cffe22d3a2884c1$var$ri(a);
                r += c - u, n.push(e.Ie.addEntry(t, o, a));
            } else if (r -= u, e.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                var h = $8cffe22d3a2884c1$var$Vr(e.Ie.R, $8cffe22d3a2884c1$var$Nt.newNoDocument(o, $8cffe22d3a2884c1$var$K.min()), e.getReadTime(o));
                n.push(e.Ie.addEntry(t, o, h));
            } else n.push(e.Ie.removeEntry(t, o));
        }), i.forEach(function(r) {
            n.push(e.Ie.Ut.addToCollectionParentIndex(t, r));
        }), n.push(this.Ie.updateMetadata(t, r)), $8cffe22d3a2884c1$var$Ir.waitFor(n);
    }, n.prototype.getFromCache = function(t, e) {
        var n = this;
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Ie.ge(t, e).next(function(t) {
            return n.Ae.set(e, t.size), t.document;
        });
    }, n.prototype.getAllFromCache = function(t, e) {
        var n = this;
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Ie.Ee(t, e).next(function(t) {
            var e = t.documents;
            // Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            return t.Te.forEach(function(t, e) {
                n.Ae.set(t, e);
            }), e;
        });
    }, n;
}($8cffe22d3a2884c1$var$Ti);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ function $8cffe22d3a2884c1$var$Si(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$cr.store);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $8cffe22d3a2884c1$var$Ni(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$ar.store);
}
function $8cffe22d3a2884c1$var$Di(t) {
    return t.path.toArray();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ var $8cffe22d3a2884c1$var$Ai = /** @class */ function() {
    function t(t) {
        this.R = t;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ return t.prototype.Rt = function(t, e, n, r) {
        var i = this;
        $8cffe22d3a2884c1$var$P(n < r && n >= 0 && r <= 11);
        var o = new $8cffe22d3a2884c1$var$Tr("createOrUpgrade", e);
        n < 1 && r >= 1 && (function(t) {
            t.createObjectStore($8cffe22d3a2884c1$var$nr.store);
        }(t), function(t) {
            t.createObjectStore($8cffe22d3a2884c1$var$rr.store, {
                keyPath: $8cffe22d3a2884c1$var$rr.keyPath
            }), t.createObjectStore($8cffe22d3a2884c1$var$ir.store, {
                keyPath: $8cffe22d3a2884c1$var$ir.keyPath,
                autoIncrement: !0
            }).createIndex($8cffe22d3a2884c1$var$ir.userMutationsIndex, $8cffe22d3a2884c1$var$ir.userMutationsKeyPath, {
                unique: !0
            }), t.createObjectStore($8cffe22d3a2884c1$var$or.store);
        }(t), $8cffe22d3a2884c1$var$ki(t), function(t) {
            t.createObjectStore($8cffe22d3a2884c1$var$ar.store);
        }(t));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        var s = $8cffe22d3a2884c1$var$Ir.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (function(t) {
            t.deleteObjectStore($8cffe22d3a2884c1$var$fr.store), t.deleteObjectStore($8cffe22d3a2884c1$var$hr.store), t.deleteObjectStore($8cffe22d3a2884c1$var$lr.store);
        }(t), $8cffe22d3a2884c1$var$ki(t)), s = s.next(function() {
            /**
     * Creates the target global singleton row.
     *
     * @param txn - The version upgrade transaction for indexeddb
     */ return function(t) {
                var e = t.store($8cffe22d3a2884c1$var$lr.store), n = new $8cffe22d3a2884c1$var$lr(/*highestTargetId=*/ 0, /*lastListenSequenceNumber=*/ 0, $8cffe22d3a2884c1$var$K.min().toTimestamp(), /*targetCount=*/ 0);
                return e.put($8cffe22d3a2884c1$var$lr.key, n);
            }(o);
        })), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(function() {
            return function(t, e) {
                return e.store($8cffe22d3a2884c1$var$ir.store).Nt().next(function(n) {
                    t.deleteObjectStore($8cffe22d3a2884c1$var$ir.store), t.createObjectStore($8cffe22d3a2884c1$var$ir.store, {
                        keyPath: $8cffe22d3a2884c1$var$ir.keyPath,
                        autoIncrement: !0
                    }).createIndex($8cffe22d3a2884c1$var$ir.userMutationsIndex, $8cffe22d3a2884c1$var$ir.userMutationsKeyPath, {
                        unique: !0
                    });
                    var r = e.store($8cffe22d3a2884c1$var$ir.store), i = n.map(function(t) {
                        return r.put(t);
                    });
                    return $8cffe22d3a2884c1$var$Ir.waitFor(i);
                });
            }(t, o);
        })), s = s.next(function() {
            !function(t) {
                t.createObjectStore($8cffe22d3a2884c1$var$pr.store, {
                    keyPath: $8cffe22d3a2884c1$var$pr.keyPath
                });
            }(t);
        })), n < 5 && r >= 5 && (s = s.next(function() {
            return i.Re(o);
        })), n < 6 && r >= 6 && (s = s.next(function() {
            return function(t) {
                t.createObjectStore($8cffe22d3a2884c1$var$cr.store);
            }(t), i.be(o);
        })), n < 7 && r >= 7 && (s = s.next(function() {
            return i.ve(o);
        })), n < 8 && r >= 8 && (s = s.next(function() {
            return i.Pe(t, o);
        })), n < 9 && r >= 9 && (s = s.next(function() {
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function(t) {
                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
            }(t), function(t) {
                var e = t.objectStore($8cffe22d3a2884c1$var$ar.store);
                e.createIndex($8cffe22d3a2884c1$var$ar.readTimeIndex, $8cffe22d3a2884c1$var$ar.readTimeIndexPath, {
                    unique: !1
                }), e.createIndex($8cffe22d3a2884c1$var$ar.collectionReadTimeIndex, $8cffe22d3a2884c1$var$ar.collectionReadTimeIndexPath, {
                    unique: !1
                });
            }(e);
        })), n < 10 && r >= 10 && (s = s.next(function() {
            return i.Ve(o);
        })), n < 11 && r >= 11 && (s = s.next(function() {
            !function(t) {
                t.createObjectStore($8cffe22d3a2884c1$var$yr.store, {
                    keyPath: $8cffe22d3a2884c1$var$yr.keyPath
                });
            }(t), function(t) {
                t.createObjectStore($8cffe22d3a2884c1$var$vr.store, {
                    keyPath: $8cffe22d3a2884c1$var$vr.keyPath
                });
            }(t);
        })), s;
    }, t.prototype.be = function(t) {
        var e = 0;
        return t.store($8cffe22d3a2884c1$var$ar.store).$t(function(t, n) {
            e += $8cffe22d3a2884c1$var$ri(n);
        }).next(function() {
            var n = new $8cffe22d3a2884c1$var$cr(e);
            return t.store($8cffe22d3a2884c1$var$cr.store).put($8cffe22d3a2884c1$var$cr.key, n);
        });
    }, t.prototype.Re = function(t) {
        var e = this, n = t.store($8cffe22d3a2884c1$var$rr.store), r = t.store($8cffe22d3a2884c1$var$ir.store);
        return n.Nt().next(function(n) {
            return $8cffe22d3a2884c1$var$Ir.forEach(n, function(n) {
                var i = IDBKeyRange.bound([
                    n.userId,
                    -1
                ], [
                    n.userId,
                    n.lastAcknowledgedBatchId
                ]);
                return r.Nt($8cffe22d3a2884c1$var$ir.userMutationsIndex, i).next(function(r) {
                    return $8cffe22d3a2884c1$var$Ir.forEach(r, function(r) {
                        $8cffe22d3a2884c1$var$P(r.userId === n.userId);
                        var i = $8cffe22d3a2884c1$var$Kr(e.R, r);
                        return $8cffe22d3a2884c1$var$ni(t, n.userId, i).next(function() {});
                    });
                });
            });
        });
    }, /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ t.prototype.ve = function(t) {
        var e = t.store($8cffe22d3a2884c1$var$fr.store), n = t.store($8cffe22d3a2884c1$var$ar.store);
        return t.store($8cffe22d3a2884c1$var$lr.store).get($8cffe22d3a2884c1$var$lr.key).next(function(t) {
            var r = [];
            return n.$t(function(n, i) {
                var o = new $8cffe22d3a2884c1$var$H(n), s = function(t) {
                    return [
                        0,
                        $8cffe22d3a2884c1$var$Xn(t)
                    ];
                }(o);
                r.push(e.get(s).next(function(n) {
                    return n ? $8cffe22d3a2884c1$var$Ir.resolve() : function(n) {
                        return e.put(new $8cffe22d3a2884c1$var$fr(0, $8cffe22d3a2884c1$var$Xn(n), t.highestListenSequenceNumber));
                    }(o);
                }));
            }).next(function() {
                return $8cffe22d3a2884c1$var$Ir.waitFor(r);
            });
        });
    }, t.prototype.Pe = function(t, e) {
        // Create the index.
        t.createObjectStore($8cffe22d3a2884c1$var$dr.store, {
            keyPath: $8cffe22d3a2884c1$var$dr.keyPath
        });
        var n = e.store($8cffe22d3a2884c1$var$dr.store), r = new $8cffe22d3a2884c1$var$Xr, i = function(t) {
            if (r.add(t)) {
                var e = t.lastSegment(), i = t.popLast();
                return n.put({
                    collectionId: e,
                    parent: $8cffe22d3a2884c1$var$Xn(i)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return e.store($8cffe22d3a2884c1$var$ar.store).$t({
            Ft: !0
        }, function(t, e) {
            var n = new $8cffe22d3a2884c1$var$H(t);
            return i(n.popLast());
        }).next(function() {
            return e.store($8cffe22d3a2884c1$var$or.store).$t({
                Ft: !0
            }, function(t, e) {
                t[0];
                var n = t[1];
                t[2];
                var r = $8cffe22d3a2884c1$var$tr(n);
                return i(r.popLast());
            });
        });
    }, t.prototype.Ve = function(t) {
        var e = this, n = t.store($8cffe22d3a2884c1$var$hr.store);
        return n.$t(function(t, r) {
            var i = $8cffe22d3a2884c1$var$Gr(r), o = $8cffe22d3a2884c1$var$Qr(e.R, i);
            return n.put(o);
        });
    }, t;
}();
function $8cffe22d3a2884c1$var$ki(t) {
    t.createObjectStore($8cffe22d3a2884c1$var$fr.store, {
        keyPath: $8cffe22d3a2884c1$var$fr.keyPath
    }).createIndex($8cffe22d3a2884c1$var$fr.documentTargetsIndex, $8cffe22d3a2884c1$var$fr.documentTargetsKeyPath, {
        unique: !0
    }), // NOTE: This is unique only because the TargetId is the suffix.
    t.createObjectStore($8cffe22d3a2884c1$var$hr.store, {
        keyPath: $8cffe22d3a2884c1$var$hr.keyPath
    }).createIndex($8cffe22d3a2884c1$var$hr.queryTargetsIndexName, $8cffe22d3a2884c1$var$hr.queryTargetsKeyPath, {
        unique: !0
    }), t.createObjectStore($8cffe22d3a2884c1$var$lr.store);
}
var $8cffe22d3a2884c1$var$Ci = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $8cffe22d3a2884c1$var$xi = /** @class */ function() {
    function t(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, n, r, i, o, s, u, a, c, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ h) {
        if (this.allowTabSynchronization = e, this.persistenceKey = n, this.clientId = r, this.Se = o, this.window = s, this.document = u, this.De = c, this.Ce = h, this.Ne = null, this.xe = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.ke = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Fe = null, /** The client metadata refresh task. */ this.$e = null, /** The last time we garbage collected the client metadata object store. */ this.Oe = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Me = function(t) {
            return Promise.resolve();
        }, !t.yt()) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $8cffe22d3a2884c1$var$wi(this, i), this.Le = n + "main", this.R = new $8cffe22d3a2884c1$var$Fr(a), this.Be = new $8cffe22d3a2884c1$var$_r(this.Le, 11, new $8cffe22d3a2884c1$var$Ai(this.R)), this.qe = new $8cffe22d3a2884c1$var$hi(this.referenceDelegate, this.R), this.Ut = new $8cffe22d3a2884c1$var$Jr, this.Ue = function(t, e) {
            return new $8cffe22d3a2884c1$var$_i(t, e);
        }(this.R, this.Ut), this.Ke = new $8cffe22d3a2884c1$var$Wr, this.window && this.window.localStorage ? this.Qe = this.window.localStorage : (this.Qe = null, !1 === h && $8cffe22d3a2884c1$var$x("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ return t.prototype.start = function() {
        var t = this;
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.je().then(function() {
            if (!t.isPrimary && !t.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, $8cffe22d3a2884c1$var$Ci);
            return t.We(), t.Ge(), t.ze(), t.runTransaction("getHighestListenSequenceNumber", "readonly", function(e) {
                return t.qe.getHighestSequenceNumber(e);
            });
        }).then(function(e) {
            t.Ne = new $8cffe22d3a2884c1$var$S(e, t.De);
        }).then(function() {
            t.xe = !0;
        }).catch(function(e) {
            return t.Be && t.Be.close(), Promise.reject(e);
        });
    }, /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.He = function(t) {
        var e = this;
        return this.Me = function(i) {
            return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(e) {
                    return this.started ? [
                        2 /*return*/ ,
                        t(i)
                    ] : [
                        2 /*return*/ 
                    ];
                });
            });
        }, t(this.isPrimary);
    }, /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.setDatabaseDeletedListener = function(t) {
        var e = this;
        this.Be.vt(function(i) {
            return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(e) {
                    switch(e.label){
                        case 0:
                            return null === i.newVersion ? [
                                4 /*yield*/ ,
                                t()
                            ] : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            e.sent(), e.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.setNetworkEnabled = function(t) {
        var e = this;
        this.networkEnabled !== t && (this.networkEnabled = t, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Se.enqueueAndForget(function() {
            return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(t) {
                    switch(t.label){
                        case 0:
                            return this.started ? [
                                4 /*yield*/ ,
                                this.je()
                            ] : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            t.sent(), t.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }));
    }, /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ t.prototype.je = function() {
        var t = this;
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function(e) {
            return $8cffe22d3a2884c1$var$Li(e).put(new $8cffe22d3a2884c1$var$pr(t.clientId, Date.now(), t.networkEnabled, t.inForeground)).next(function() {
                if (t.isPrimary) return t.Je(e).next(function(e) {
                    e || (t.isPrimary = !1, t.Se.enqueueRetryable(function() {
                        return t.Me(!1);
                    }));
                });
            }).next(function() {
                return t.Ye(e);
            }).next(function(n) {
                return t.isPrimary && !n ? t.Xe(e).next(function() {
                    return !1;
                }) : !!n && t.Ze(e).next(function() {
                    return !0;
                });
            });
        }).catch(function(e) {
            if ($8cffe22d3a2884c1$var$Nr(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $8cffe22d3a2884c1$var$C("IndexedDbPersistence", "Failed to extend owner lease: ", e), t.isPrimary;
            if (!t.allowTabSynchronization) throw e;
            return $8cffe22d3a2884c1$var$C("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then(function(e) {
            t.isPrimary !== e && t.Se.enqueueRetryable(function() {
                return t.Me(e);
            }), t.isPrimary = e;
        });
    }, t.prototype.Je = function(t) {
        var e = this;
        return $8cffe22d3a2884c1$var$Ri(t).get($8cffe22d3a2884c1$var$nr.key).next(function(t) {
            return $8cffe22d3a2884c1$var$Ir.resolve(e.tn(t));
        });
    }, t.prototype.en = function(t) {
        return $8cffe22d3a2884c1$var$Li(t).delete(this.clientId);
    }, /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ t.prototype.nn = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e, n, i, o = this;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return !this.isPrimary || this.sn(this.Oe, 18e5) ? [
                            3 /*break*/ ,
                            2
                        ] : (this.Oe = Date.now(), [
                            4 /*yield*/ ,
                            this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function(t) {
                                var e = $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$pr.store);
                                return e.Nt().next(function(t) {
                                    var n = o.rn(t, 18e5), r = t.filter(function(t) {
                                        return -1 === n.indexOf(t);
                                    });
                                    // Delete metadata for clients that are no longer considered active.
                                    return $8cffe22d3a2884c1$var$Ir.forEach(r, function(t) {
                                        return e.delete(t.clientId);
                                    }).next(function() {
                                        return r;
                                    });
                                });
                            }).catch(function() {
                                return [];
                            })
                        ]);
                    case 1:
                        // Delete potential leftover entries that may continue to mark the
                        // inactive clients as zombied in LocalStorage.
                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                        // the client atomically, but we can't. So we opt to delete the IndexedDb
                        // entries first to avoid potentially reviving a zombied client.
                        if (t = r.sent(), this.Qe) for(e = 0, n = t; e < n.length; e++)i = n[e], this.Qe.removeItem(this.on(i.clientId));
                        r.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ t.prototype.ze = function() {
        var t = this;
        this.$e = this.Se.enqueueAfterDelay("client_metadata_refresh" /* ClientMetadataRefresh */ , 4e3, function() {
            return t.je().then(function() {
                return t.nn();
            }).then(function() {
                return t.ze();
            });
        });
    }, /** Checks whether `client` is the local client. */ t.prototype.tn = function(t) {
        return !!t && t.ownerId === this.clientId;
    }, /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ t.prototype.Ye = function(t) {
        var e = this;
        return this.Ce ? $8cffe22d3a2884c1$var$Ir.resolve(!0) : $8cffe22d3a2884c1$var$Ri(t).get($8cffe22d3a2884c1$var$nr.key).next(function(n) {
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== n && e.sn(n.leaseTimestampMs, 5e3) && !e.cn(n.ownerId)) {
                if (e.tn(n) && e.networkEnabled) return !0;
                if (!e.tn(n)) {
                    if (!n.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, $8cffe22d3a2884c1$var$Ci);
                    return !1;
                }
            }
            return !(!e.networkEnabled || !e.inForeground) || $8cffe22d3a2884c1$var$Li(t).Nt().next(function(t) {
                return void 0 === e.rn(t, 5e3).find(function(t) {
                    if (e.clientId !== t.clientId) {
                        var n = !e.networkEnabled && t.networkEnabled, r = !e.inForeground && t.inForeground, i = e.networkEnabled === t.networkEnabled;
                        if (n || r && i) return !0;
                    }
                    return !1;
                });
            });
        }).next(function(t) {
            return e.isPrimary !== t && $8cffe22d3a2884c1$var$C("IndexedDbPersistence", "Client " + (t ? "is" : "is not") + " eligible for a primary lease."), t;
        });
    }, t.prototype.shutdown = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t = this;
            return (0, $2WUgS.__generator)(this, function(e) {
                switch(e.label){
                    case 0:
                        // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
                        // has obtained the primary lease.
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        return this.xe = !1, this.un(), this.$e && (this.$e.cancel(), this.$e = null), this.an(), this.hn(), [
                            4 /*yield*/ ,
                            this.Be.runTransaction("shutdown", "readwrite", [
                                $8cffe22d3a2884c1$var$nr.store,
                                $8cffe22d3a2884c1$var$pr.store
                            ], function(e) {
                                var n = new $8cffe22d3a2884c1$var$xr(e, $8cffe22d3a2884c1$var$S.o);
                                return t.Xe(n).next(function() {
                                    return t.en(n);
                                });
                            })
                        ];
                    case 1:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
                        // has obtained the primary lease.
                        return e.sent(), this.Be.close(), // Remove the entry marking the client as zombied from LocalStorage since
                        // we successfully deleted its metadata from IndexedDb.
                        this.ln(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ t.prototype.rn = function(t, e) {
        var n = this;
        return t.filter(function(t) {
            return n.sn(t.updateTimeMs, e) && !n.cn(t.clientId);
        });
    }, /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.fn = function() {
        var t = this;
        return this.runTransaction("getActiveClients", "readonly", function(e) {
            return $8cffe22d3a2884c1$var$Li(e).Nt().next(function(e) {
                return t.rn(e, 18e5).map(function(t) {
                    return t.clientId;
                });
            });
        });
    }, Object.defineProperty(t.prototype, "started", {
        get: function() {
            return this.xe;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.getMutationQueue = function(t) {
        return $8cffe22d3a2884c1$var$ii.Qt(t, this.R, this.Ut, this.referenceDelegate);
    }, t.prototype.getTargetCache = function() {
        return this.qe;
    }, t.prototype.getRemoteDocumentCache = function() {
        return this.Ue;
    }, t.prototype.getIndexManager = function() {
        return this.Ut;
    }, t.prototype.getBundleCache = function() {
        return this.Ke;
    }, t.prototype.runTransaction = function(t, e, n) {
        var r = this;
        $8cffe22d3a2884c1$var$C("IndexedDbPersistence", "Starting transaction:", t);
        var i, o = "readonly" === e ? "readonly" : "readwrite";
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.Be.runTransaction(t, o, $8cffe22d3a2884c1$var$mr, function(o) {
            return i = new $8cffe22d3a2884c1$var$xr(o, r.Ne ? r.Ne.next() : $8cffe22d3a2884c1$var$S.o), "readwrite-primary" === e ? r.Je(i).next(function(t) {
                return !!t || r.Ye(i);
            }).next(function(e) {
                if (!e) throw $8cffe22d3a2884c1$var$x("Failed to obtain primary lease for action '" + t + "'."), r.isPrimary = !1, r.Se.enqueueRetryable(function() {
                    return r.Me(!1);
                }), new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, $8cffe22d3a2884c1$var$gr);
                return n(i);
            }).next(function(t) {
                return r.Ze(i).next(function() {
                    return t;
                });
            }) : r.dn(i).next(function() {
                return n(i);
            });
        }).then(function(t) {
            return i.raiseOnCommittedEvent(), t;
        });
    }, /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    t.prototype.dn = function(t) {
        var e = this;
        return $8cffe22d3a2884c1$var$Ri(t).get($8cffe22d3a2884c1$var$nr.key).next(function(t) {
            if (null !== t && e.sn(t.leaseTimestampMs, 5e3) && !e.cn(t.ownerId) && !e.tn(t) && !(e.Ce || e.allowTabSynchronization && t.allowTabSynchronization)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, $8cffe22d3a2884c1$var$Ci);
        });
    }, /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ t.prototype.Ze = function(t) {
        var e = new $8cffe22d3a2884c1$var$nr(this.clientId, this.allowTabSynchronization, Date.now());
        return $8cffe22d3a2884c1$var$Ri(t).put($8cffe22d3a2884c1$var$nr.key, e);
    }, t.yt = function() {
        return $8cffe22d3a2884c1$var$_r.yt();
    }, /** Checks the primary lease and removes it if we are the current primary. */ t.prototype.Xe = function(t) {
        var e = this, n = $8cffe22d3a2884c1$var$Ri(t);
        return n.get($8cffe22d3a2884c1$var$nr.key).next(function(t) {
            return e.tn(t) ? ($8cffe22d3a2884c1$var$C("IndexedDbPersistence", "Releasing primary lease."), n.delete($8cffe22d3a2884c1$var$nr.key)) : $8cffe22d3a2884c1$var$Ir.resolve();
        });
    }, /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ t.prototype.sn = function(t, e) {
        var n = Date.now();
        return !(t < n - e || t > n && ($8cffe22d3a2884c1$var$x("Detected an update time that is in the future: " + t + " > " + n), 1));
    }, t.prototype.We = function() {
        var t = this;
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Fe = function() {
            t.Se.enqueueAndForget(function() {
                return t.inForeground = "visible" === t.document.visibilityState, t.je();
            });
        }, this.document.addEventListener("visibilitychange", this.Fe), this.inForeground = "visible" === this.document.visibilityState);
    }, t.prototype.an = function() {
        this.Fe && (this.document.removeEventListener("visibilitychange", this.Fe), this.Fe = null);
    }, /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ t.prototype.Ge = function() {
        var t, e = this;
        "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.ke = function() {
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            e.un(), (0, $eTAKc.isSafari)() && navigator.appVersion.match("Version/14") && // On Safari 14, we do not run any cleanup actions as it might trigger
            // a bug that prevents Safari from re-opening IndexedDB during the
            // next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            e.Se.enterRestrictedMode(/* purgeExistingTasks= */ !0), e.Se.enqueueAndForget(function() {
                return e.shutdown();
            });
        }, this.window.addEventListener("pagehide", this.ke));
    }, t.prototype.hn = function() {
        this.ke && (this.window.removeEventListener("pagehide", this.ke), this.ke = null);
    }, /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ t.prototype.cn = function(t) {
        var e;
        try {
            var n = null !== (null === (e = this.Qe) || void 0 === e ? void 0 : e.getItem(this.on(t)));
            return $8cffe22d3a2884c1$var$C("IndexedDbPersistence", "Client '" + t + "' " + (n ? "is" : "is not") + " zombied in LocalStorage"), n;
        } catch (t) {
            // Gracefully handle if LocalStorage isn't working.
            return $8cffe22d3a2884c1$var$x("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
        }
    }, /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ t.prototype.un = function() {
        if (this.Qe) try {
            this.Qe.setItem(this.on(this.clientId), String(Date.now()));
        } catch (t) {
            // Gracefully handle if LocalStorage isn't available / working.
            $8cffe22d3a2884c1$var$x("Failed to set zombie client id.", t);
        }
    }, /** Removes the zombied client entry if it exists. */ t.prototype.ln = function() {
        if (this.Qe) try {
            this.Qe.removeItem(this.on(this.clientId));
        } catch (t) {
        // Ignore
        }
    }, t.prototype.on = function(t) {
        return "firestore_zombie_" + this.persistenceKey + "_" + t;
    }, t;
}();
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ /**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $8cffe22d3a2884c1$var$Ri(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$nr.store);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $8cffe22d3a2884c1$var$Li(t) {
    return $8cffe22d3a2884c1$var$Rr(t, $8cffe22d3a2884c1$var$pr.store);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $8cffe22d3a2884c1$var$Oi(t, e) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    var n = t.projectId;
    return t.isDefaultDatabase || (n += "." + t.database), "firestore/" + e + "/" + n + "/" /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ ;
}
var $8cffe22d3a2884c1$var$Pi = function(t, e) {
    this.progress = t, this.wn = e;
}, $8cffe22d3a2884c1$var$Fi = /** @class */ function() {
    function t(t, e, n) {
        this.Ue = t, this._n = e, this.Ut = n /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ ;
    }
    return t.prototype.mn = function(t, e) {
        var n = this;
        return this._n.getAllMutationBatchesAffectingDocumentKey(t, e).next(function(r) {
            return n.yn(t, e, r);
        });
    }, /** Internal version of `getDocument` that allows reusing batches. */ t.prototype.yn = function(t, e, n) {
        return this.Ue.getEntry(t, e).next(function(t) {
            for(var e = 0, r = n; e < r.length; e++)r[e].applyToLocalView(t);
            return t;
        });
    }, // Returns the view of the given `docs` as they would appear after applying
    // all mutations in the given `batches`.
    t.prototype.gn = function(t, e) {
        t.forEach(function(t, n) {
            for(var r = 0, i = e; r < i.length; r++)i[r].applyToLocalView(n);
        });
    }, /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ t.prototype.pn = function(t, e) {
        var n = this;
        return this.Ue.getEntries(t, e).next(function(e) {
            return n.En(t, e).next(function() {
                return e;
            });
        });
    }, /**
     * Applies the local view the given `baseDocs` without retrieving documents
     * from the local store.
     */ t.prototype.En = function(t, e) {
        var n = this;
        return this._n.getAllMutationBatchesAffectingDocumentKeys(t, e).next(function(t) {
            return n.gn(e, t);
        });
    }, /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param sinceReadTime - If not set to SnapshotVersion.min(), return only
     *     documents that have been read since this snapshot version (exclusive).
     */ t.prototype.getDocumentsMatchingQuery = function(t, e, n) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function(t) {
            return $8cffe22d3a2884c1$var$ct.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
        }(e) ? this.Tn(t, e.path) : $8cffe22d3a2884c1$var$te(e) ? this.In(t, e, n) : this.An(t, e, n);
    }, t.prototype.Tn = function(t, e) {
        // Just do a simple document lookup.
        return this.mn(t, new $8cffe22d3a2884c1$var$ct(e)).next(function(t) {
            var e = $8cffe22d3a2884c1$var$en();
            return t.isFoundDocument() && (e = e.insert(t.key, t)), e;
        });
    }, t.prototype.In = function(t, e, n) {
        var r = this, i = e.collectionGroup, o = $8cffe22d3a2884c1$var$en();
        return this.Ut.getCollectionParents(t, i).next(function(s) {
            return $8cffe22d3a2884c1$var$Ir.forEach(s, function(s) {
                var u = function(t, e) {
                    return new $8cffe22d3a2884c1$var$Wt(e, /*collectionGroup=*/ null, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
                }(e, s.child(i));
                return r.An(t, u, n).next(function(t) {
                    t.forEach(function(t, e) {
                        o = o.insert(t, e);
                    });
                });
            }).next(function() {
                return o;
            });
        });
    }, t.prototype.An = function(t, e, n) {
        var r, i, o = this;
        // Query the remote documents and overlay mutations.
        return this.Ue.getDocumentsMatchingQuery(t, e, n).next(function(n) {
            return r = n, o._n.getAllMutationBatchesAffectingQuery(t, e);
        }).next(function(e) {
            return i = e, o.Rn(t, i, r).next(function(t) {
                r = t;
                for(var e = 0, n = i; e < n.length; e++)for(var o = n[e], s = 0, u = o.mutations; s < u.length; s++){
                    var a = u[s], c = a.key, h = r.get(c);
                    null == h && // Create invalid document to apply mutations on top of
                    (h = $8cffe22d3a2884c1$var$Nt.newInvalidDocument(c), r = r.insert(c, h)), $8cffe22d3a2884c1$var$xe(a, h, o.localWriteTime), h.isFoundDocument() || (r = r.remove(c));
                }
            });
        }).next(function() {
            // Finally, filter out any documents that don't actually match
            // the query.
            return r.forEach(function(t, n) {
                $8cffe22d3a2884c1$var$ue(e, n) || (r = r.remove(t));
            }), r;
        });
    }, t.prototype.Rn = function(t, e, n) {
        for(var r = $8cffe22d3a2884c1$var$sn(), i = 0, o = e; i < o.length; i++)for(var s = 0, u = o[i].mutations; s < u.length; s++){
            var a = u[s];
            a instanceof $8cffe22d3a2884c1$var$Fe && null === n.get(a.key) && (r = r.add(a.key));
        }
        var c = n;
        return this.Ue.getEntries(t, r).next(function(t) {
            return t.forEach(function(t, e) {
                e.isFoundDocument() && (c = c.insert(t, e));
            }), c;
        });
    }, t;
}(), $8cffe22d3a2884c1$var$Mi = /** @class */ function() {
    function t(t, e, n, r) {
        this.targetId = t, this.fromCache = e, this.bn = n, this.vn = r;
    }
    return t.Pn = function(e, n) {
        for(var r = $8cffe22d3a2884c1$var$sn(), i = $8cffe22d3a2884c1$var$sn(), o = 0, s = n.docChanges; o < s.length; o++){
            var u = s[o];
            switch(u.type){
                case 0 /* Added */ :
                    r = r.add(u.doc.key);
                    break;
                case 1 /* Removed */ :
                    i = i.add(u.doc.key);
            }
        }
        return new t(e, n.fromCache, r, i);
    }, t;
}(), $8cffe22d3a2884c1$var$Vi = /** @class */ function() {
    function t() {}
    /** Sets the document view to query against. */ return t.prototype.Vn = function(t) {
        this.Sn = t;
    }, /** Returns all local documents matching the specified query. */ t.prototype.getDocumentsMatchingQuery = function(t, e, n, r) {
        var i = this;
        // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return function(t) {
            return 0 === t.filters.length && null === t.limit && null == t.startAt && null == t.endAt && (0 === t.explicitOrderBy.length || 1 === t.explicitOrderBy.length && t.explicitOrderBy[0].field.isKeyField());
        }(e) || n.isEqual($8cffe22d3a2884c1$var$K.min()) ? this.Dn(t, e) : this.Sn.pn(t, r).next(function(o) {
            var s = i.Cn(e, o);
            return ($8cffe22d3a2884c1$var$$t(e) || $8cffe22d3a2884c1$var$Xt(e)) && i.Nn(e.limitType, s, r, n) ? i.Dn(t, e) : ($8cffe22d3a2884c1$var$k() <= (0, $i4pDv.LogLevel).DEBUG && $8cffe22d3a2884c1$var$C("QueryEngine", "Re-using previous result from %s to execute query: %s", n.toString(), $8cffe22d3a2884c1$var$se(e)), i.Sn.getDocumentsMatchingQuery(t, e, n).next(function(t) {
                // We merge `previousResults` into `updateResults`, since
                // `updateResults` is already a DocumentMap. If a document is
                // contained in both lists, then its contents are the same.
                return s.forEach(function(e) {
                    t = t.insert(e.key, e);
                }), t;
            }));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }, /** Applies the query filter and sorting to the provided documents.  */ t.prototype.Cn = function(t, e) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        var n = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$ae(t));
        return e.forEach(function(e, r) {
            $8cffe22d3a2884c1$var$ue(t, r) && (n = n.add(r));
        }), n;
    }, /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ t.prototype.Nn = function(t, e, n, r) {
        // The query needs to be refilled if a previously matching document no
        // longer matches.
        if (n.size !== e.size) return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        var i = "F" /* First */  === t ? e.last() : e.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }, t.prototype.Dn = function(t, e) {
        return $8cffe22d3a2884c1$var$k() <= (0, $i4pDv.LogLevel).DEBUG && $8cffe22d3a2884c1$var$C("QueryEngine", "Using full collection scan to execute query:", $8cffe22d3a2884c1$var$se(e)), this.Sn.getDocumentsMatchingQuery(t, e, $8cffe22d3a2884c1$var$K.min());
    }, t;
}(), $8cffe22d3a2884c1$var$qi = /** @class */ function() {
    function t(/** Manages our in-memory or durable persistence. */ t, e, n, r) {
        this.persistence = t, this.xn = e, this.R = r, /**
             * Maps a targetID to data about its target.
             *
             * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
             * of `applyRemoteEvent()` idempotent.
             */ this.kn = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$q), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Fn = new $8cffe22d3a2884c1$var$Ii(function(t) {
            return $8cffe22d3a2884c1$var$kt(t);
        }, $8cffe22d3a2884c1$var$Ct), /**
             * The read time of the last entry processed by `getNewDocumentChanges()`.
             *
             * PORTING NOTE: This is only used for multi-tab synchronization.
             */ this.$n = $8cffe22d3a2884c1$var$K.min(), this._n = t.getMutationQueue(n), this.On = t.getRemoteDocumentCache(), this.qe = t.getTargetCache(), this.Mn = new $8cffe22d3a2884c1$var$Fi(this.On, this._n, this.persistence.getIndexManager()), this.Ke = t.getBundleCache(), this.xn.Vn(this.Mn);
    }
    return t.prototype.collectGarbage = function(t) {
        var e = this;
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function(n) {
            return t.collect(n, e.kn);
        });
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ function $8cffe22d3a2884c1$var$Ui(/** Manages our in-memory or durable persistence. */ t, e, n, r) {
    return new $8cffe22d3a2884c1$var$qi(t, e, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
function $8cffe22d3a2884c1$var$Bi(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o, s;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return n = $8cffe22d3a2884c1$var$F(t), i = n._n, o = n.Mn, [
                        4 /*yield*/ ,
                        n.persistence.runTransaction("Handle user change", "readonly", function(t) {
                            // Swap out the mutation queue, grabbing the pending mutation batches
                            // before and after.
                            var r;
                            return n._n.getAllMutationBatches(t).next(function(s) {
                                return r = s, i = n.persistence.getMutationQueue(e), // Recreate our LocalDocumentsView using the new
                                // MutationQueue.
                                o = new $8cffe22d3a2884c1$var$Fi(n.On, i, n.persistence.getIndexManager()), i.getAllMutationBatches(t);
                            }).next(function(e) {
                                for(var n = [], i = [], s = $8cffe22d3a2884c1$var$sn(), u = 0, a = r; u < a.length; u++){
                                    var c = a[u];
                                    n.push(c.batchId);
                                    for(var h = 0, f = c.mutations; h < f.length; h++){
                                        var l = f[h];
                                        s = s.add(l.key);
                                    }
                                }
                                for(var d = 0, p = e; d < p.length; d++){
                                    var y = p[d];
                                    i.push(y.batchId);
                                    for(var v = 0, m = y.mutations; v < m.length; v++){
                                        var g = m[v];
                                        s = s.add(g.key);
                                    }
                                }
                                // Return the set of all (potentially) changed documents and the list
                                // of mutation batch IDs that were affected by change.
                                return o.pn(t, s).next(function(t) {
                                    return {
                                        Ln: t,
                                        removedBatchIds: n,
                                        addedBatchIds: i
                                    };
                                });
                            });
                        })
                    ];
                case 1:
                    return s = r.sent(), [
                        2 /*return*/ ,
                        (n._n = i, n.Mn = o, n.xn.Vn(n.Mn), s)
                    ];
            }
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $8cffe22d3a2884c1$var$ji(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function(t) {
        var r = e.batch.keys(), i = n.On.newChangeBuffer({
            trackRemovals: !0
        });
        return (function(t, e, n, r) {
            var i = n.batch, o = i.keys(), s = $8cffe22d3a2884c1$var$Ir.resolve();
            return o.forEach(function(t) {
                s = s.next(function() {
                    return r.getEntry(e, t);
                }).next(function(e) {
                    var o = n.docVersions.get(t);
                    $8cffe22d3a2884c1$var$P(null !== o), e.version.compareTo(o) < 0 && (i.applyToRemoteDocument(e, n), e.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    r.addEntry(e, n.commitVersion));
                });
            }), s.next(function() {
                return t._n.removeMutationBatch(e, i);
            });
        })(n, t, e, i).next(function() {
            return i.apply(t);
        }).next(function() {
            return n._n.performConsistencyCheck(t);
        }).next(function() {
            return n.Mn.pn(t, r);
        });
    });
}
/**
 * Removes mutations from the MutationQueue for the specified batch;
 * LocalDocuments will be recalculated.
 *
 * @returns The resulting modified documents.
 */ /**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $8cffe22d3a2884c1$var$Ki(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    return e.persistence.runTransaction("Get last remote snapshot version", "readonly", function(t) {
        return e.qe.getLastRemoteSnapshotVersion(t);
    });
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $8cffe22d3a2884c1$var$Gi(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t), r = e.snapshotVersion, i = n.kn;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", function(t) {
        var o = n.On.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.kn;
        var s = [];
        e.targetChanges.forEach(function(e, o) {
            var u = i.get(o);
            if (u) {
                // Only update the remote keys if the target is still active. This
                // ensures that we can persist the updated target data along with
                // the updated assignment.
                s.push(n.qe.removeMatchingKeys(t, e.removedDocuments, o).next(function() {
                    return n.qe.addMatchingKeys(t, e.addedDocuments, o);
                }));
                var a = e.resumeToken;
                // Update the resume token if the change includes one.
                if (a.approximateByteSize() > 0) {
                    var c = u.withResumeToken(a, r).withSequenceNumber(t.currentSequenceNumber);
                    i = i.insert(o, c), // Update the target data if there are target changes (or if
                    // sufficient time has passed since the last update).
                    /**
     * Returns true if the newTargetData should be persisted during an update of
     * an active target. TargetData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, TargetData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */ function(t, e, n) {
                        // Always persist target data if we don't already have a resume token.
                        return $8cffe22d3a2884c1$var$P(e.resumeToken.approximateByteSize() > 0), 0 === t.resumeToken.approximateByteSize() || // Don't allow resume token changes to be buffered indefinitely. This
                        // allows us to be reasonably up-to-date after a crash and avoids needing
                        // to loop over all active queries on shutdown. Especially in the browser
                        // we may not get time to do anything interesting while the current tab is
                        // closing.
                        e.snapshotVersion.toMicroseconds() - t.snapshotVersion.toMicroseconds() >= 3e8 || n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
                    }(u, c, e) && s.push(n.qe.updateTargetData(t, c));
                }
            }
        });
        var u = $8cffe22d3a2884c1$var$Ze();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (e.documentUpdates.forEach(function(r, i) {
            e.resolvedLimboDocuments.has(r) && s.push(n.persistence.referenceDelegate.updateLimboDocument(t, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
        // documents in advance in a single call.
        s.push($8cffe22d3a2884c1$var$Qi(t, o, e.documentUpdates, r, void 0).next(function(t) {
            u = t;
        })), !r.isEqual($8cffe22d3a2884c1$var$K.min())) {
            var a = n.qe.getLastRemoteSnapshotVersion(t).next(function(e) {
                return n.qe.setTargetsMetadata(t, t.currentSequenceNumber, r);
            });
            s.push(a);
        }
        return $8cffe22d3a2884c1$var$Ir.waitFor(s).next(function() {
            return o.apply(t);
        }).next(function() {
            return n.Mn.En(t, u);
        }).next(function() {
            return u;
        });
    }).then(function(t) {
        return n.kn = i, t;
    });
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 * @param globalVersion - A `SnapshotVersion` representing the read time if all
 *        documents have the same read time.
 * @param documentVersions - A DocumentKey-to-SnapshotVersion map if documents
 *        have their own read time.
 *
 * Note: this function will use `documentVersions` if it is defined;
 * when it is not defined, resorts to `globalVersion`.
 */ function $8cffe22d3a2884c1$var$Qi(t, e, n, r, // TODO(wuandy): We could add `readTime` to MaybeDocument instead to remove
// this parameter.
i) {
    var o = $8cffe22d3a2884c1$var$sn();
    return n.forEach(function(t) {
        return o = o.add(t);
    }), e.getEntries(t, o).next(function(t) {
        var o = $8cffe22d3a2884c1$var$Ze();
        return n.forEach(function(n, s) {
            var u = t.get(n), a = (null == i ? void 0 : i.get(n)) || r;
            // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($8cffe22d3a2884c1$var$K.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (e.removeEntry(n, a), o = o.insert(n, s)) : !u.isValidDocument() || s.version.compareTo(u.version) > 0 || 0 === s.version.compareTo(u.version) && u.hasPendingWrites ? (e.addEntry(s, a), o = o.insert(n, s)) : $8cffe22d3a2884c1$var$C("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", u.version, " Watch version:", s.version);
        }), o;
    }) /**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ ;
}
function $8cffe22d3a2884c1$var$zi(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", function(t) {
        return void 0 === e && (e = -1), n._n.getNextMutationBatchAfterBatchId(t, e);
    });
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $8cffe22d3a2884c1$var$Wi(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t);
    return n.persistence.runTransaction("Allocate target", "readwrite", function(t) {
        var r;
        return n.qe.getTargetData(t, e).next(function(i) {
            return i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $8cffe22d3a2884c1$var$Ir.resolve(r)) : n.qe.allocateTargetId(t).next(function(i) {
                return r = new $8cffe22d3a2884c1$var$Pr(e, i, 0 /* Listen */ , t.currentSequenceNumber), n.qe.addTargetData(t, r).next(function() {
                    return r;
                });
            });
        });
    }).then(function(t) {
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        var r = n.kn.get(t.targetId);
        return (null === r || t.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.kn = n.kn.insert(t.targetId, t), n.Fn.set(e, t.targetId)), t;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
function $8cffe22d3a2884c1$var$Hi(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, o, s, u;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    n = $8cffe22d3a2884c1$var$F(t), o = n.kn.get(e), s = i ? "readwrite" : "readwrite-primary", r.label = 1;
                case 1:
                    return r.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]), i ? [
                        3 /*break*/ ,
                        3
                    ] : [
                        4 /*yield*/ ,
                        n.persistence.runTransaction("Release target", s, function(t) {
                            return n.persistence.referenceDelegate.removeTarget(t, o);
                        })
                    ];
                case 2:
                    r.sent(), r.label = 3;
                case 3:
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    if (!$8cffe22d3a2884c1$var$Nr(u = r.sent())) throw u;
                    // All `releaseTarget` does is record the final metadata state for the
                    // target, but we've been recording this periodically during target
                    // activity. If we lose this write this could cause a very slight
                    // difference in the order of target deletion during GC, but we
                    // don't define exact LRU semantics so this is acceptable.
                    return $8cffe22d3a2884c1$var$C("LocalStore", "Failed to update sequence numbers for target " + e + ": " + u), [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    return n.kn = n.kn.remove(e), n.Fn.delete(o.target), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $8cffe22d3a2884c1$var$Yi(t, e, n) {
    var r = $8cffe22d3a2884c1$var$F(t), i = $8cffe22d3a2884c1$var$K.min(), o = $8cffe22d3a2884c1$var$sn();
    return r.persistence.runTransaction("Execute query", "readonly", function(t) {
        return (function(t, e, n) {
            var r = $8cffe22d3a2884c1$var$F(t), i = r.Fn.get(n);
            return void 0 !== i ? $8cffe22d3a2884c1$var$Ir.resolve(r.kn.get(i)) : r.qe.getTargetData(e, n);
        })(r, t, $8cffe22d3a2884c1$var$ne(e)).next(function(e) {
            if (e) return i = e.lastLimboFreeSnapshotVersion, r.qe.getMatchingKeysForTargetId(t, e.targetId).next(function(t) {
                o = t;
            });
        }).next(function() {
            return r.xn.getDocumentsMatchingQuery(t, e, n ? i : $8cffe22d3a2884c1$var$K.min(), n ? o : $8cffe22d3a2884c1$var$sn());
        }).next(function(t) {
            return {
                documents: t,
                Bn: o
            };
        });
    });
}
// PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$$i(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t), r = $8cffe22d3a2884c1$var$F(n.qe), i = n.kn.get(e);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", function(t) {
        return r.lt(t, e).next(function(t) {
            return t ? t.target : null;
        });
    });
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$Xi(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    return e.persistence.runTransaction("Get new document changes", "readonly", function(t) {
        return function(t, e, n) {
            var r = $8cffe22d3a2884c1$var$F(t), i = $8cffe22d3a2884c1$var$Ze(), o = $8cffe22d3a2884c1$var$qr(n), s = $8cffe22d3a2884c1$var$Ni(e), u = IDBKeyRange.lowerBound(o, !0);
            return s.$t({
                index: $8cffe22d3a2884c1$var$ar.readTimeIndex,
                range: u
            }, function(t, e) {
                // Unlike `getEntry()` and others, `getNewDocumentChanges()` parses
                // the documents directly since we want to keep sentinel deletes.
                var n = $8cffe22d3a2884c1$var$Mr(r.R, e);
                i = i.insert(n.key, n), o = e.readTime;
            }).next(function() {
                return {
                    wn: i,
                    readTime: $8cffe22d3a2884c1$var$Ur(o)
                };
            });
        }(e.On, t, e.$n);
    }).then(function(t) {
        var n = t.wn, r = t.readTime;
        return e.$n = r, n;
    });
}
/**
 * Reads the newest document change from persistence and moves the internal
 * synchronization marker forward so that calls to `getNewDocumentChanges()`
 * only return changes that happened after client initialization.
 */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$Ji(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e;
        return (0, $2WUgS.__generator)(this, function(n) {
            return [
                2 /*return*/ ,
                (e = $8cffe22d3a2884c1$var$F(t)).persistence.runTransaction("Synchronize last document change read time", "readonly", function(t) {
                    return function(t) {
                        var e = $8cffe22d3a2884c1$var$Ni(t), n = $8cffe22d3a2884c1$var$K.min();
                        // If there are no existing entries, we return SnapshotVersion.min().
                        return e.$t({
                            index: $8cffe22d3a2884c1$var$ar.readTimeIndex,
                            reverse: !0
                        }, function(t, e, r) {
                            e.readTime && (n = $8cffe22d3a2884c1$var$Ur(e.readTime)), r.done();
                        }).next(function() {
                            return n;
                        });
                    }(t);
                }).then(function(t) {
                    e.$n = t;
                })
            ];
        });
    });
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $8cffe22d3a2884c1$var$Zi(t, e, i, o) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, s, u, a, c, h, f, l, d, p;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    for(n = $8cffe22d3a2884c1$var$F(t), s = $8cffe22d3a2884c1$var$sn(), u = $8cffe22d3a2884c1$var$Ze(), a = $8cffe22d3a2884c1$var$rn(), c = 0, h = i; c < h.length; c++)f = h[c], l = e.qn(f.metadata.name), f.document && (s = s.add(l)), u = u.insert(l, e.Un(f)), a = a.insert(l, e.Kn(f.metadata.readTime));
                    return d = n.On.newChangeBuffer({
                        trackRemovals: !0
                    }), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Wi(n, function(t) {
                            // It is OK that the path used for the query is not valid, because this will
                            // not be read and queried.
                            return $8cffe22d3a2884c1$var$ne($8cffe22d3a2884c1$var$Yt($8cffe22d3a2884c1$var$H.fromString("__bundle__/docs/" + t)));
                        }(o))
                    ];
                case 1:
                    // Allocates a target to hold all document keys from the bundle, such that
                    // they will not get garbage collected right away.
                    return p = r.sent(), [
                        2 /*return*/ ,
                        n.persistence.runTransaction("Apply bundle documents", "readwrite", function(t) {
                            return $8cffe22d3a2884c1$var$Qi(t, d, u, $8cffe22d3a2884c1$var$K.min(), a).next(function(e) {
                                return d.apply(t), e;
                            }).next(function(e) {
                                return n.qe.removeMatchingKeysForTargetId(t, p.targetId).next(function() {
                                    return n.qe.addMatchingKeys(t, s, p.targetId);
                                }).next(function() {
                                    return n.Mn.En(t, e);
                                }).next(function() {
                                    return e;
                                });
                            });
                        })
                    ];
            }
        });
    });
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ function $8cffe22d3a2884c1$var$to(t, e, i) {
    return void 0 === i && (i = $8cffe22d3a2884c1$var$sn()), (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, o;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Wi(t, $8cffe22d3a2884c1$var$ne($8cffe22d3a2884c1$var$zr(e.bundledQuery)))
                    ];
                case 1:
                    return n = r.sent(), [
                        2 /*return*/ ,
                        (o = $8cffe22d3a2884c1$var$F(t)).persistence.runTransaction("Save named query", "readwrite", function(t) {
                            var r = $8cffe22d3a2884c1$var$En(e.readTime);
                            // Simply save the query itself if it is older than what the SDK already
                            // has.
                            if (n.snapshotVersion.compareTo(r) >= 0) return o.Ke.saveNamedQuery(t, e);
                            // Update existing target data because the query from the bundle is newer.
                            var s = n.withResumeToken($8cffe22d3a2884c1$var$J.EMPTY_BYTE_STRING, r);
                            return o.kn = o.kn.insert(s.targetId, s), o.qe.updateTargetData(t, s).next(function() {
                                return o.qe.removeMatchingKeysForTargetId(t, n.targetId);
                            }).next(function() {
                                return o.qe.addMatchingKeys(t, i, n.targetId);
                            }).next(function() {
                                return o.Ke.saveNamedQuery(t, e);
                            });
                        })
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$eo = /** @class */ function() {
    function t(t) {
        this.R = t, this.Qn = new Map, this.jn = new Map;
    }
    return t.prototype.getBundleMetadata = function(t, e) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.Qn.get(e));
    }, t.prototype.saveBundleMetadata = function(t, e) {
        /** Decodes a BundleMetadata proto into a BundleMetadata object. */ var n;
        return this.Qn.set(e.id, {
            id: (n = e).id,
            version: n.version,
            createTime: $8cffe22d3a2884c1$var$En(n.createTime)
        }), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.getNamedQuery = function(t, e) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.jn.get(e));
    }, t.prototype.saveNamedQuery = function(t, e) {
        return this.jn.set(e.name, function(t) {
            return {
                name: t.name,
                query: $8cffe22d3a2884c1$var$zr(t.bundledQuery),
                readTime: $8cffe22d3a2884c1$var$En(t.readTime)
            };
        }(e)), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t;
}(), $8cffe22d3a2884c1$var$no = /** @class */ function() {
    function t() {
        // A set of outstanding references to a document sorted by key.
        this.Wn = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$ro.Gn), // A set of outstanding references to a document sorted by target id.
        this.zn = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$ro.Hn) /** Returns true if the reference set contains no references. */ ;
    }
    return t.prototype.isEmpty = function() {
        return this.Wn.isEmpty();
    }, /** Adds a reference to the given document key for the given ID. */ t.prototype.addReference = function(t, e) {
        var n = new $8cffe22d3a2884c1$var$ro(t, e);
        this.Wn = this.Wn.add(n), this.zn = this.zn.add(n);
    }, /** Add references to the given document keys for the given ID. */ t.prototype.Jn = function(t, e) {
        var n = this;
        t.forEach(function(t) {
            return n.addReference(t, e);
        });
    }, /**
     * Removes a reference to the given document key for the given
     * ID.
     */ t.prototype.removeReference = function(t, e) {
        this.Yn(new $8cffe22d3a2884c1$var$ro(t, e));
    }, t.prototype.Xn = function(t, e) {
        var n = this;
        t.forEach(function(t) {
            return n.removeReference(t, e);
        });
    }, /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ t.prototype.Zn = function(t) {
        var e = this, n = new $8cffe22d3a2884c1$var$ct(new $8cffe22d3a2884c1$var$H([])), r = new $8cffe22d3a2884c1$var$ro(n, t), i = new $8cffe22d3a2884c1$var$ro(n, t + 1), o = [];
        return this.zn.forEachInRange([
            r,
            i
        ], function(t) {
            e.Yn(t), o.push(t.key);
        }), o;
    }, t.prototype.ts = function() {
        var t = this;
        this.Wn.forEach(function(e) {
            return t.Yn(e);
        });
    }, t.prototype.Yn = function(t) {
        this.Wn = this.Wn.delete(t), this.zn = this.zn.delete(t);
    }, t.prototype.es = function(t) {
        var e = new $8cffe22d3a2884c1$var$ct(new $8cffe22d3a2884c1$var$H([])), n = new $8cffe22d3a2884c1$var$ro(e, t), r = new $8cffe22d3a2884c1$var$ro(e, t + 1), i = $8cffe22d3a2884c1$var$sn();
        return this.zn.forEachInRange([
            n,
            r
        ], function(t) {
            i = i.add(t.key);
        }), i;
    }, t.prototype.containsKey = function(t) {
        var e = new $8cffe22d3a2884c1$var$ro(t, 0), n = this.Wn.firstAfterOrEqual(e);
        return null !== n && t.isEqual(n.key);
    }, t;
}(), $8cffe22d3a2884c1$var$ro = /** @class */ function() {
    function t(t, e) {
        this.key = t, this.ns = e /** Compare by key then by ID */ ;
    }
    return t.Gn = function(t, e) {
        return $8cffe22d3a2884c1$var$ct.comparator(t.key, e.key) || $8cffe22d3a2884c1$var$q(t.ns, e.ns);
    }, /** Compare by ID then by key */ t.Hn = function(t, e) {
        return $8cffe22d3a2884c1$var$q(t.ns, e.ns) || $8cffe22d3a2884c1$var$ct.comparator(t.key, e.key);
    }, t;
}(), $8cffe22d3a2884c1$var$io = /** @class */ function() {
    function t(t, e) {
        this.Ut = t, this.referenceDelegate = e, /**
             * The set of all mutations that have been sent but not yet been applied to
             * the backend.
             */ this._n = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.ss = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.rs = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$ro.Gn);
    }
    return t.prototype.checkEmpty = function(t) {
        return $8cffe22d3a2884c1$var$Ir.resolve(0 === this._n.length);
    }, t.prototype.addMutationBatch = function(t, e, n, r) {
        var i = this.ss;
        this.ss++, this._n.length > 0 && this._n[this._n.length - 1];
        var o = new $8cffe22d3a2884c1$var$Lr(i, e, n, r);
        this._n.push(o);
        // Track references by document key and index collection parents.
        for(var s = 0, u = r; s < u.length; s++){
            var a = u[s];
            this.rs = this.rs.add(new $8cffe22d3a2884c1$var$ro(a.key, i)), this.Ut.addToCollectionParentIndex(t, a.key.path.popLast());
        }
        return $8cffe22d3a2884c1$var$Ir.resolve(o);
    }, t.prototype.lookupMutationBatch = function(t, e) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.os(e));
    }, t.prototype.getNextMutationBatchAfterBatchId = function(t, e) {
        var n = e + 1, r = this.cs(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $8cffe22d3a2884c1$var$Ir.resolve(this._n.length > i ? this._n[i] : null);
    }, t.prototype.getHighestUnacknowledgedBatchId = function() {
        return $8cffe22d3a2884c1$var$Ir.resolve(0 === this._n.length ? -1 : this.ss - 1);
    }, t.prototype.getAllMutationBatches = function(t) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this._n.slice());
    }, t.prototype.getAllMutationBatchesAffectingDocumentKey = function(t, e) {
        var n = this, r = new $8cffe22d3a2884c1$var$ro(e, 0), i = new $8cffe22d3a2884c1$var$ro(e, Number.POSITIVE_INFINITY), o = [];
        return this.rs.forEachInRange([
            r,
            i
        ], function(t) {
            var e = n.os(t.ns);
            o.push(e);
        }), $8cffe22d3a2884c1$var$Ir.resolve(o);
    }, t.prototype.getAllMutationBatchesAffectingDocumentKeys = function(t, e) {
        var n = this, r = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q);
        return e.forEach(function(t) {
            var e = new $8cffe22d3a2884c1$var$ro(t, 0), i = new $8cffe22d3a2884c1$var$ro(t, Number.POSITIVE_INFINITY);
            n.rs.forEachInRange([
                e,
                i
            ], function(t) {
                r = r.add(t.ns);
            });
        }), $8cffe22d3a2884c1$var$Ir.resolve(this.us(r));
    }, t.prototype.getAllMutationBatchesAffectingQuery = function(t, e) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var n = e.path, r = n.length + 1, i = n;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        $8cffe22d3a2884c1$var$ct.isDocumentKey(i) || (i = i.child(""));
        var o = new $8cffe22d3a2884c1$var$ro(new $8cffe22d3a2884c1$var$ct(i), 0), s = new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        return this.rs.forEachWhile(function(t) {
            var e = t.key.path;
            return !!n.isPrefixOf(e) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (e.length === r && (s = s.add(t.ns)), !0);
        }, o), $8cffe22d3a2884c1$var$Ir.resolve(this.us(s));
    }, t.prototype.us = function(t) {
        var e = this, n = [];
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        return t.forEach(function(t) {
            var r = e.os(t);
            null !== r && n.push(r);
        }), n;
    }, t.prototype.removeMutationBatch = function(t, e) {
        var n = this;
        $8cffe22d3a2884c1$var$P(0 === this.hs(e.batchId, "removed")), this._n.shift();
        var r = this.rs;
        return $8cffe22d3a2884c1$var$Ir.forEach(e.mutations, function(i) {
            var o = new $8cffe22d3a2884c1$var$ro(i.key, e.batchId);
            return r = r.delete(o), n.referenceDelegate.markPotentiallyOrphaned(t, i.key);
        }).next(function() {
            n.rs = r;
        });
    }, t.prototype.Gt = function(t) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }, t.prototype.containsKey = function(t, e) {
        var n = new $8cffe22d3a2884c1$var$ro(e, 0), r = this.rs.firstAfterOrEqual(n);
        return $8cffe22d3a2884c1$var$Ir.resolve(e.isEqual(r && r.key));
    }, t.prototype.performConsistencyCheck = function(t) {
        return this._n.length, $8cffe22d3a2884c1$var$Ir.resolve();
    }, /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ t.prototype.hs = function(t, e) {
        return this.cs(t);
    }, /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ t.prototype.cs = function(t) {
        return 0 === this._n.length ? 0 : t - this._n[0].batchId;
    // Examine the front of the queue to figure out the difference between the
    // batchId and indexes in the array. Note that since the queue is ordered
    // by batchId, if the first batch has a larger batchId then the requested
    // batchId doesn't exist in the queue.
    }, /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ t.prototype.os = function(t) {
        var e = this.cs(t);
        return e < 0 || e >= this._n.length ? null : this._n[e];
    }, t;
}(), $8cffe22d3a2884c1$var$oo = /** @class */ function() {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ function t(t, e) {
        this.Ut = t, this.ls = e, /** Underlying cache of documents and their read times. */ this.docs = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator), /** Size of all cached documents. */ this.size = 0 /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ ;
    }
    return t.prototype.addEntry = function(t, e, n) {
        var r = e.key, i = this.docs.get(r), o = i ? i.size : 0, s = this.ls(e);
        return this.docs = this.docs.insert(r, {
            document: e.clone(),
            size: s,
            readTime: n
        }), this.size += s - o, this.Ut.addToCollectionParentIndex(t, r.path.popLast());
    }, /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ t.prototype.removeEntry = function(t) {
        var e = this.docs.get(t);
        e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }, t.prototype.getEntry = function(t, e) {
        var n = this.docs.get(e);
        return $8cffe22d3a2884c1$var$Ir.resolve(n ? n.document.clone() : $8cffe22d3a2884c1$var$Nt.newInvalidDocument(e));
    }, t.prototype.getEntries = function(t, e) {
        var n = this, r = $8cffe22d3a2884c1$var$Ze();
        return e.forEach(function(t) {
            var e = n.docs.get(t);
            r = r.insert(t, e ? e.document.clone() : $8cffe22d3a2884c1$var$Nt.newInvalidDocument(t));
        }), $8cffe22d3a2884c1$var$Ir.resolve(r);
    }, t.prototype.getDocumentsMatchingQuery = function(t, e, n) {
        for(var r = $8cffe22d3a2884c1$var$Ze(), i = new $8cffe22d3a2884c1$var$ct(e.path.child("")), o = this.docs.getIteratorFrom(i); o.hasNext();){
            var s = o.getNext(), u = s.key, a = s.value, c = a.document, h = a.readTime;
            if (!e.path.isPrefixOf(u.path)) break;
            h.compareTo(n) <= 0 || $8cffe22d3a2884c1$var$ue(e, c) && (r = r.insert(c.key, c.clone()));
        }
        return $8cffe22d3a2884c1$var$Ir.resolve(r);
    }, t.prototype.fs = function(t, e) {
        return $8cffe22d3a2884c1$var$Ir.forEach(this.docs, function(t) {
            return e(t);
        });
    }, t.prototype.newChangeBuffer = function(t) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $8cffe22d3a2884c1$var$so(this);
    }, t.prototype.getSize = function(t) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.size);
    }, t;
}(), $8cffe22d3a2884c1$var$so = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).Ie = t, n;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.applyChanges = function(t) {
        var e = this, n = [];
        return this.changes.forEach(function(r, i) {
            i.document.isValidDocument() ? n.push(e.Ie.addEntry(t, i.document, e.getReadTime(r))) : e.Ie.removeEntry(r);
        }), $8cffe22d3a2884c1$var$Ir.waitFor(n);
    }, n.prototype.getFromCache = function(t, e) {
        return this.Ie.getEntry(t, e);
    }, n.prototype.getAllFromCache = function(t, e) {
        return this.Ie.getEntries(t, e);
    }, n;
}($8cffe22d3a2884c1$var$Ti), $8cffe22d3a2884c1$var$uo = /** @class */ function() {
    function t(t) {
        this.persistence = t, /**
             * Maps a target to the data about that target
             */ this.ds = new $8cffe22d3a2884c1$var$Ii(function(t) {
            return $8cffe22d3a2884c1$var$kt(t);
        }, $8cffe22d3a2884c1$var$Ct), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $8cffe22d3a2884c1$var$K.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.ws = 0, /**
             * A ordered bidirectional mapping between documents and the remote target
             * IDs.
             */ this._s = new $8cffe22d3a2884c1$var$no, this.targetCount = 0, this.ys = $8cffe22d3a2884c1$var$ci.Jt();
    }
    return t.prototype.forEachTarget = function(t, e) {
        return this.ds.forEach(function(t, n) {
            return e(n);
        }), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.getLastRemoteSnapshotVersion = function(t) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.lastRemoteSnapshotVersion);
    }, t.prototype.getHighestSequenceNumber = function(t) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.ws);
    }, t.prototype.allocateTargetId = function(t) {
        return this.highestTargetId = this.ys.next(), $8cffe22d3a2884c1$var$Ir.resolve(this.highestTargetId);
    }, t.prototype.setTargetsMetadata = function(t, e, n) {
        return n && (this.lastRemoteSnapshotVersion = n), e > this.ws && (this.ws = e), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.te = function(t) {
        this.ds.set(t.target, t);
        var e = t.targetId;
        e > this.highestTargetId && (this.ys = new $8cffe22d3a2884c1$var$ci(e), this.highestTargetId = e), t.sequenceNumber > this.ws && (this.ws = t.sequenceNumber);
    }, t.prototype.addTargetData = function(t, e) {
        return this.te(e), this.targetCount += 1, $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.updateTargetData = function(t, e) {
        return this.te(e), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.removeTargetData = function(t, e) {
        return this.ds.delete(e.target), this._s.Zn(e.targetId), this.targetCount -= 1, $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.removeTargets = function(t, e, n) {
        var r = this, i = 0, o = [];
        return this.ds.forEach(function(s, u) {
            u.sequenceNumber <= e && null === n.get(u.targetId) && (r.ds.delete(s), o.push(r.removeMatchingKeysForTargetId(t, u.targetId)), i++);
        }), $8cffe22d3a2884c1$var$Ir.waitFor(o).next(function() {
            return i;
        });
    }, t.prototype.getTargetCount = function(t) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this.targetCount);
    }, t.prototype.getTargetData = function(t, e) {
        var n = this.ds.get(e) || null;
        return $8cffe22d3a2884c1$var$Ir.resolve(n);
    }, t.prototype.addMatchingKeys = function(t, e, n) {
        return this._s.Jn(e, n), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.removeMatchingKeys = function(t, e, n) {
        this._s.Xn(e, n);
        var r = this.persistence.referenceDelegate, i = [];
        return r && e.forEach(function(e) {
            i.push(r.markPotentiallyOrphaned(t, e));
        }), $8cffe22d3a2884c1$var$Ir.waitFor(i);
    }, t.prototype.removeMatchingKeysForTargetId = function(t, e) {
        return this._s.Zn(e), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.getMatchingKeysForTargetId = function(t, e) {
        var n = this._s.es(e);
        return $8cffe22d3a2884c1$var$Ir.resolve(n);
    }, t.prototype.containsKey = function(t, e) {
        return $8cffe22d3a2884c1$var$Ir.resolve(this._s.containsKey(e));
    }, t;
}(), $8cffe22d3a2884c1$var$ao = /** @class */ function() {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ function t(t, e) {
        var n = this;
        this.gs = {}, this.Ne = new $8cffe22d3a2884c1$var$S(0), this.xe = !1, this.xe = !0, this.referenceDelegate = t(this), this.qe = new $8cffe22d3a2884c1$var$uo(this), this.Ut = new $8cffe22d3a2884c1$var$$r, this.Ue = function(t, e) {
            return new $8cffe22d3a2884c1$var$oo(t, function(t) {
                return n.referenceDelegate.ps(t);
            });
        }(this.Ut), this.R = new $8cffe22d3a2884c1$var$Fr(e), this.Ke = new $8cffe22d3a2884c1$var$eo(this.R);
    }
    return t.prototype.start = function() {
        return Promise.resolve();
    }, t.prototype.shutdown = function() {
        // No durable state to ensure is closed on shutdown.
        return this.xe = !1, Promise.resolve();
    }, Object.defineProperty(t.prototype, "started", {
        get: function() {
            return this.xe;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.setDatabaseDeletedListener = function() {
    // No op.
    }, t.prototype.setNetworkEnabled = function() {
    // No op.
    }, t.prototype.getIndexManager = function() {
        return this.Ut;
    }, t.prototype.getMutationQueue = function(t) {
        var e = this.gs[t.toKey()];
        return e || (e = new $8cffe22d3a2884c1$var$io(this.Ut, this.referenceDelegate), this.gs[t.toKey()] = e), e;
    }, t.prototype.getTargetCache = function() {
        return this.qe;
    }, t.prototype.getRemoteDocumentCache = function() {
        return this.Ue;
    }, t.prototype.getBundleCache = function() {
        return this.Ke;
    }, t.prototype.runTransaction = function(t, e, n) {
        var r = this;
        $8cffe22d3a2884c1$var$C("MemoryPersistence", "Starting transaction:", t);
        var i = new $8cffe22d3a2884c1$var$co(this.Ne.next());
        return this.referenceDelegate.Es(), n(i).next(function(t) {
            return r.referenceDelegate.Ts(i).next(function() {
                return t;
            });
        }).toPromise().then(function(t) {
            return i.raiseOnCommittedEvent(), t;
        });
    }, t.prototype.Is = function(t, e) {
        return $8cffe22d3a2884c1$var$Ir.or(Object.values(this.gs).map(function(n) {
            return function() {
                return n.containsKey(t, e);
            };
        }));
    }, t;
}(), $8cffe22d3a2884c1$var$co = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).currentSequenceNumber = t, n;
    }
    return (0, $2WUgS.__extends)(n, e), n;
}($8cffe22d3a2884c1$var$wr), $8cffe22d3a2884c1$var$ho = /** @class */ function() {
    function t(t) {
        this.persistence = t, /** Tracks all documents that are active in Query views. */ this.As = new $8cffe22d3a2884c1$var$no, /** The list of documents that are potentially GCed after each transaction. */ this.Rs = null;
    }
    return t.bs = function(e) {
        return new t(e);
    }, Object.defineProperty(t.prototype, "vs", {
        get: function() {
            if (this.Rs) return this.Rs;
            throw $8cffe22d3a2884c1$var$O();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.addReference = function(t, e, n) {
        return this.As.addReference(n, e), this.vs.delete(n.toString()), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.removeReference = function(t, e, n) {
        return this.As.removeReference(n, e), this.vs.add(n.toString()), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.markPotentiallyOrphaned = function(t, e) {
        return this.vs.add(e.toString()), $8cffe22d3a2884c1$var$Ir.resolve();
    }, t.prototype.removeTarget = function(t, e) {
        var n = this;
        this.As.Zn(e.targetId).forEach(function(t) {
            return n.vs.add(t.toString());
        });
        var r = this.persistence.getTargetCache();
        return r.getMatchingKeysForTargetId(t, e.targetId).next(function(t) {
            t.forEach(function(t) {
                return n.vs.add(t.toString());
            });
        }).next(function() {
            return r.removeTargetData(t, e);
        });
    }, t.prototype.Es = function() {
        this.Rs = new Set;
    }, t.prototype.Ts = function(t) {
        var e = this, n = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        // Remove newly orphaned documents.
        return $8cffe22d3a2884c1$var$Ir.forEach(this.vs, function(r) {
            var i = $8cffe22d3a2884c1$var$ct.fromPath(r);
            return e.Ps(t, i).next(function(t) {
                t || n.removeEntry(i);
            });
        }).next(function() {
            return e.Rs = null, n.apply(t);
        });
    }, t.prototype.updateLimboDocument = function(t, e) {
        var n = this;
        return this.Ps(t, e).next(function(t) {
            t ? n.vs.delete(e.toString()) : n.vs.add(e.toString());
        });
    }, t.prototype.ps = function(t) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }, t.prototype.Ps = function(t, e) {
        var n = this;
        return $8cffe22d3a2884c1$var$Ir.or([
            function() {
                return $8cffe22d3a2884c1$var$Ir.resolve(n.As.containsKey(e));
            },
            function() {
                return n.persistence.getTargetCache().containsKey(t, e);
            },
            function() {
                return n.persistence.Is(t, e);
            }
        ]);
    }, t;
}(), $8cffe22d3a2884c1$var$fo = /** @class */ function() {
    function t(t) {
        this.uid = t;
    }
    return t.prototype.isAuthenticated = function() {
        return null != this.uid;
    }, /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ t.prototype.toKey = function() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }, t.prototype.isEqual = function(t) {
        return t.uid === this.uid;
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ /** Assembles the key for a client state in WebStorage */ function $8cffe22d3a2884c1$var$lo(t, e) {
    return "firestore_clients_" + t + "_" + e;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $8cffe22d3a2884c1$var$po(t, e, n) {
    var r = "firestore_mutations_" + t + "_" + n;
    return e.isAuthenticated() && (r += "_" + e.uid), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $8cffe22d3a2884c1$var$yo(t, e) {
    return "firestore_targets_" + t + "_" + e;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
/** A user with a null UID. */ $8cffe22d3a2884c1$var$fo.UNAUTHENTICATED = new $8cffe22d3a2884c1$var$fo(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$8cffe22d3a2884c1$var$fo.GOOGLE_CREDENTIALS = new $8cffe22d3a2884c1$var$fo("google-credentials-uid"), $8cffe22d3a2884c1$var$fo.FIRST_PARTY = new $8cffe22d3a2884c1$var$fo("first-party-uid"), $8cffe22d3a2884c1$var$fo.MOCK_USER = new $8cffe22d3a2884c1$var$fo("mock-user");
var $8cffe22d3a2884c1$var$vo = /** @class */ function() {
    function t(t, e, n, r) {
        this.user = t, this.batchId = e, this.state = n, this.error = r /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.Vs = function(e, n, r) {
        var i, o = JSON.parse(r), s = "object" == typeof o && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(o.state) && (void 0 === o.error || "object" == typeof o.error);
        return s && o.error && (s = "string" == typeof o.error.message && "string" == typeof o.error.code) && (i = new $8cffe22d3a2884c1$var$D(o.error.code, o.error.message)), s ? new t(e, n, o.state, i) : ($8cffe22d3a2884c1$var$x("SharedClientState", "Failed to parse mutation state for ID '" + n + "': " + r), null);
    }, t.prototype.Ss = function() {
        var t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }, t;
}(), $8cffe22d3a2884c1$var$mo = /** @class */ function() {
    function t(t, e, n) {
        this.targetId = t, this.state = e, this.error = n /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.Vs = function(e, n) {
        var r, i = JSON.parse(n), o = "object" == typeof i && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(i.state) && (void 0 === i.error || "object" == typeof i.error);
        return o && i.error && (o = "string" == typeof i.error.message && "string" == typeof i.error.code) && (r = new $8cffe22d3a2884c1$var$D(i.error.code, i.error.message)), o ? new t(e, i.state, r) : ($8cffe22d3a2884c1$var$x("SharedClientState", "Failed to parse target state for ID '" + e + "': " + n), null);
    }, t.prototype.Ss = function() {
        var t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }, t;
}(), $8cffe22d3a2884c1$var$go = /** @class */ function() {
    function t(t, e) {
        this.clientId = t, this.activeTargetIds = e /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.Vs = function(e, n) {
        for(var r = JSON.parse(n), i = "object" == typeof r && r.activeTargetIds instanceof Array, o = $8cffe22d3a2884c1$var$an(), s = 0; i && s < r.activeTargetIds.length; ++s)i = $8cffe22d3a2884c1$var$at(r.activeTargetIds[s]), o = o.add(r.activeTargetIds[s]);
        return i ? new t(e, o) : ($8cffe22d3a2884c1$var$x("SharedClientState", "Failed to parse client data for instance '" + e + "': " + n), null);
    }, t;
}(), $8cffe22d3a2884c1$var$wo = /** @class */ function() {
    function t(t, e) {
        this.clientId = t, this.onlineState = e /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ ;
    }
    return t.Vs = function(e) {
        var n = JSON.parse(e);
        return "object" == typeof n && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(n.onlineState) && "string" == typeof n.clientId ? new t(n.clientId, n.onlineState) : ($8cffe22d3a2884c1$var$x("SharedClientState", "Failed to parse online state: " + e), null);
    }, t;
}(), $8cffe22d3a2884c1$var$bo = /** @class */ function() {
    function t() {
        this.activeTargetIds = $8cffe22d3a2884c1$var$an();
    }
    return t.prototype.Ds = function(t) {
        this.activeTargetIds = this.activeTargetIds.add(t);
    }, t.prototype.Cs = function(t) {
        this.activeTargetIds = this.activeTargetIds.delete(t);
    }, /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ t.prototype.Ss = function() {
        var t = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(t);
    }, t;
}(), $8cffe22d3a2884c1$var$Io = /** @class */ function() {
    function t(t, e, n, r, i) {
        this.window = t, this.Se = e, this.persistenceKey = n, this.Ns = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.xs = this.ks.bind(this), this.Fs = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$q), this.started = !1, /**
             * Captures WebStorage events that occur before `start()` is called. These
             * events are replayed once `WebStorageSharedClientState` is started.
             */ this.$s = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var o = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Os = $8cffe22d3a2884c1$var$lo(this.persistenceKey, this.Ns), this.Ms = /** Assembles the key for the current sequence number. */ function(t) {
            return "firestore_sequence_number_" + t;
        }(this.persistenceKey), this.Fs = this.Fs.insert(this.Ns, new $8cffe22d3a2884c1$var$bo), this.Ls = new RegExp("^firestore_clients_" + o + "_([^_]*)$"), this.Bs = new RegExp("^firestore_mutations_" + o + "_(\\d+)(?:_(.*))?$"), this.qs = new RegExp("^firestore_targets_" + o + "_(\\d+)$"), this.Us = /** Assembles the key for the online state of the primary tab. */ function(t) {
            return "firestore_online_state_" + t;
        }(this.persistenceKey), this.Ks = function(t) {
            return "firestore_bundle_loaded_" + t;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.xs);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ return t.yt = function(t) {
        return !(!t || !t.localStorage);
    }, t.prototype.start = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e, n, i, o, s, u, a, c, h, f, l = this;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.syncEngine.fn()
                        ];
                    case 1:
                        for(t = r.sent(), e = 0, n = t; e < n.length; e++)(i = n[e]) !== this.Ns && (o = this.getItem($8cffe22d3a2884c1$var$lo(this.persistenceKey, i))) && (s = $8cffe22d3a2884c1$var$go.Vs(i, o)) && (this.Fs = this.Fs.insert(s.clientId, s));
                        for(this.Qs(), (u = this.storage.getItem(this.Us)) && (a = this.js(u)) && this.Ws(a), c = 0, h = this.$s; c < h.length; c++)f = h[c], this.ks(f);
                        return this.$s = [], // Register a window unload hook to remove the client metadata entry from
                        // WebStorage even if `shutdown()` was not called.
                        this.window.addEventListener("pagehide", function() {
                            return l.shutdown();
                        }), this.started = !0, [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.writeSequenceNumber = function(t) {
        this.setItem(this.Ms, JSON.stringify(t));
    }, t.prototype.getAllActiveQueryTargets = function() {
        return this.Gs(this.Fs);
    }, t.prototype.isActiveQueryTarget = function(t) {
        var e = !1;
        return this.Fs.forEach(function(n, r) {
            r.activeTargetIds.has(t) && (e = !0);
        }), e;
    }, t.prototype.addPendingMutation = function(t) {
        this.zs(t, "pending");
    }, t.prototype.updateMutationState = function(t, e, n) {
        this.zs(t, e, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Hs(t);
    }, t.prototype.addLocalQueryTarget = function(t) {
        var e = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(t)) {
            var n = this.storage.getItem($8cffe22d3a2884c1$var$yo(this.persistenceKey, t));
            if (n) {
                var r = $8cffe22d3a2884c1$var$mo.Vs(t, n);
                r && (e = r.state);
            }
        }
        return this.Js.Ds(t), this.Qs(), e;
    }, t.prototype.removeLocalQueryTarget = function(t) {
        this.Js.Cs(t), this.Qs();
    }, t.prototype.isLocalQueryTarget = function(t) {
        return this.Js.activeTargetIds.has(t);
    }, t.prototype.clearQueryState = function(t) {
        this.removeItem($8cffe22d3a2884c1$var$yo(this.persistenceKey, t));
    }, t.prototype.updateQueryState = function(t, e, n) {
        this.Ys(t, e, n);
    }, t.prototype.handleUserChange = function(t, e, n) {
        var r = this;
        e.forEach(function(t) {
            r.Hs(t);
        }), this.currentUser = t, n.forEach(function(t) {
            r.addPendingMutation(t);
        });
    }, t.prototype.setOnlineState = function(t) {
        this.Xs(t);
    }, t.prototype.notifyBundleLoaded = function() {
        this.Zs();
    }, t.prototype.shutdown = function() {
        this.started && (this.window.removeEventListener("storage", this.xs), this.removeItem(this.Os), this.started = !1);
    }, t.prototype.getItem = function(t) {
        var e = this.storage.getItem(t);
        return $8cffe22d3a2884c1$var$C("SharedClientState", "READ", t, e), e;
    }, t.prototype.setItem = function(t, e) {
        $8cffe22d3a2884c1$var$C("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }, t.prototype.removeItem = function(t) {
        $8cffe22d3a2884c1$var$C("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }, t.prototype.ks = function(t) {
        var e = this, i = t;
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        if (i.storageArea === this.storage) {
            if ($8cffe22d3a2884c1$var$C("SharedClientState", "EVENT", i.key, i.newValue), i.key === this.Os) return void $8cffe22d3a2884c1$var$x("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Se.enqueueRetryable(function() {
                return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                    var t, e, n, o, s, u;
                    return (0, $2WUgS.__generator)(this, function(r) {
                        if (this.started) {
                            if (null !== i.key) {
                                if (this.Ls.test(i.key)) {
                                    if (null == i.newValue) return t = this.ti(i.key), [
                                        2 /*return*/ ,
                                        this.ei(t, null)
                                    ];
                                    if (e = this.ni(i.key, i.newValue)) return [
                                        2 /*return*/ ,
                                        this.ei(e.clientId, e)
                                    ];
                                } else if (this.Bs.test(i.key)) {
                                    if (null !== i.newValue && (n = this.si(i.key, i.newValue))) return [
                                        2 /*return*/ ,
                                        this.ii(n)
                                    ];
                                } else if (this.qs.test(i.key)) {
                                    if (null !== i.newValue && (o = this.ri(i.key, i.newValue))) return [
                                        2 /*return*/ ,
                                        this.oi(o)
                                    ];
                                } else if (i.key === this.Us) {
                                    if (null !== i.newValue && (s = this.js(i.newValue))) return [
                                        2 /*return*/ ,
                                        this.Ws(s)
                                    ];
                                } else if (i.key === this.Ms) (u = function(t) {
                                    var e = $8cffe22d3a2884c1$var$S.o;
                                    if (null != t) try {
                                        var n = JSON.parse(t);
                                        $8cffe22d3a2884c1$var$P("number" == typeof n), e = n;
                                    } catch (t) {
                                        $8cffe22d3a2884c1$var$x("SharedClientState", "Failed to read sequence number from WebStorage", t);
                                    }
                                    return e;
                                }(i.newValue)) !== $8cffe22d3a2884c1$var$S.o && this.sequenceNumberHandler(u);
                                else if (i.key === this.Ks) return [
                                    2 /*return*/ ,
                                    this.syncEngine.ci()
                                ];
                            }
                        } else this.$s.push(i);
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        }
    }, Object.defineProperty(t.prototype, "Js", {
        get: function() {
            return this.Fs.get(this.Ns);
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.Qs = function() {
        this.setItem(this.Os, this.Js.Ss());
    }, t.prototype.zs = function(t, e, n) {
        var r = new $8cffe22d3a2884c1$var$vo(this.currentUser, t, e, n), i = $8cffe22d3a2884c1$var$po(this.persistenceKey, this.currentUser, t);
        this.setItem(i, r.Ss());
    }, t.prototype.Hs = function(t) {
        var e = $8cffe22d3a2884c1$var$po(this.persistenceKey, this.currentUser, t);
        this.removeItem(e);
    }, t.prototype.Xs = function(t) {
        var e = {
            clientId: this.Ns,
            onlineState: t
        };
        this.storage.setItem(this.Us, JSON.stringify(e));
    }, t.prototype.Ys = function(t, e, n) {
        var r = $8cffe22d3a2884c1$var$yo(this.persistenceKey, t), i = new $8cffe22d3a2884c1$var$mo(t, e, n);
        this.setItem(r, i.Ss());
    }, t.prototype.Zs = function() {
        this.setItem(this.Ks, "value-not-used");
    }, /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ t.prototype.ti = function(t) {
        var e = this.Ls.exec(t);
        return e ? e[1] : null;
    }, /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ t.prototype.ni = function(t, e) {
        var n = this.ti(t);
        return $8cffe22d3a2884c1$var$go.Vs(n, e);
    }, /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ t.prototype.si = function(t, e) {
        var n = this.Bs.exec(t), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $8cffe22d3a2884c1$var$vo.Vs(new $8cffe22d3a2884c1$var$fo(i), r, e);
    }, /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ t.prototype.ri = function(t, e) {
        var n = this.qs.exec(t), r = Number(n[1]);
        return $8cffe22d3a2884c1$var$mo.Vs(r, e);
    }, /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ t.prototype.js = function(t) {
        return $8cffe22d3a2884c1$var$wo.Vs(t);
    }, t.prototype.ii = function(t) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(e) {
                return t.user.uid === this.currentUser.uid ? [
                    2 /*return*/ ,
                    this.syncEngine.ui(t.batchId, t.state, t.error)
                ] : ($8cffe22d3a2884c1$var$C("SharedClientState", "Ignoring mutation for non-active user " + t.user.uid), [
                    2 /*return*/ 
                ]);
            });
        });
    }, t.prototype.oi = function(t) {
        return this.syncEngine.ai(t.targetId, t.state, t.error);
    }, t.prototype.ei = function(t, e) {
        var n = this, r = e ? this.Fs.insert(t, e) : this.Fs.remove(t), i = this.Gs(this.Fs), o = this.Gs(r), s = [], u = [];
        return o.forEach(function(t) {
            i.has(t) || s.push(t);
        }), i.forEach(function(t) {
            o.has(t) || u.push(t);
        }), this.syncEngine.hi(s, u).then(function() {
            n.Fs = r;
        });
    }, t.prototype.Ws = function(t) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Fs.get(t.clientId) && this.onlineStateHandler(t.onlineState);
    }, t.prototype.Gs = function(t) {
        var e = $8cffe22d3a2884c1$var$an();
        return t.forEach(function(t, n) {
            e = e.unionWith(n.activeTargetIds);
        }), e;
    }, t;
}(), $8cffe22d3a2884c1$var$To = /** @class */ function() {
    function t() {
        this.li = new $8cffe22d3a2884c1$var$bo, this.fi = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    return t.prototype.addPendingMutation = function(t) {
    // No op.
    }, t.prototype.updateMutationState = function(t, e, n) {
    // No op.
    }, t.prototype.addLocalQueryTarget = function(t) {
        return this.li.Ds(t), this.fi[t] || "not-current";
    }, t.prototype.updateQueryState = function(t, e, n) {
        this.fi[t] = e;
    }, t.prototype.removeLocalQueryTarget = function(t) {
        this.li.Cs(t);
    }, t.prototype.isLocalQueryTarget = function(t) {
        return this.li.activeTargetIds.has(t);
    }, t.prototype.clearQueryState = function(t) {
        delete this.fi[t];
    }, t.prototype.getAllActiveQueryTargets = function() {
        return this.li.activeTargetIds;
    }, t.prototype.isActiveQueryTarget = function(t) {
        return this.li.activeTargetIds.has(t);
    }, t.prototype.start = function() {
        return this.li = new $8cffe22d3a2884c1$var$bo, Promise.resolve();
    }, t.prototype.handleUserChange = function(t, e, n) {
    // No op.
    }, t.prototype.setOnlineState = function(t) {
    // No op.
    }, t.prototype.shutdown = function() {}, t.prototype.writeSequenceNumber = function(t) {}, t.prototype.notifyBundleLoaded = function() {
    // No op.
    }, t;
}(), $8cffe22d3a2884c1$var$_o = /** @class */ function() {
    function t() {}
    return t.prototype.di = function(t) {
    // No-op.
    }, t.prototype.shutdown = function() {
    // No-op.
    }, t;
}(), $8cffe22d3a2884c1$var$Eo = /** @class */ function() {
    function t() {
        var t = this;
        this.wi = function() {
            return t._i();
        }, this.mi = function() {
            return t.yi();
        }, this.gi = [], this.pi();
    }
    return t.prototype.di = function(t) {
        this.gi.push(t);
    }, t.prototype.shutdown = function() {
        window.removeEventListener("online", this.wi), window.removeEventListener("offline", this.mi);
    }, t.prototype.pi = function() {
        window.addEventListener("online", this.wi), window.addEventListener("offline", this.mi);
    }, t.prototype._i = function() {
        $8cffe22d3a2884c1$var$C("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for(var t = 0, e = this.gi; t < e.length; t++)(0, e[t])(0 /* AVAILABLE */ );
    }, t.prototype.yi = function() {
        $8cffe22d3a2884c1$var$C("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for(var t = 0, e = this.gi; t < e.length; t++)(0, e[t])(1 /* UNAVAILABLE */ );
    }, // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ t.yt = function() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }, t;
}(), $8cffe22d3a2884c1$var$So = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery"
}, $8cffe22d3a2884c1$var$No = /** @class */ function() {
    function t(t) {
        this.Ei = t.Ei, this.Ti = t.Ti;
    }
    return t.prototype.Ii = function(t) {
        this.Ai = t;
    }, t.prototype.Ri = function(t) {
        this.bi = t;
    }, t.prototype.onMessage = function(t) {
        this.vi = t;
    }, t.prototype.close = function() {
        this.Ti();
    }, t.prototype.send = function(t) {
        this.Ei(t);
    }, t.prototype.Pi = function() {
        this.Ai();
    }, t.prototype.Vi = function(t) {
        this.bi(t);
    }, t.prototype.Si = function(t) {
        this.vi(t);
    }, t;
}(), $8cffe22d3a2884c1$var$Do = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this, t) || this).forceLongPolling = t.forceLongPolling, n.autoDetectLongPolling = t.autoDetectLongPolling, n.useFetchStreams = t.useFetchStreams, n;
    }
    /**
     * Base class for all Rest-based connections to the backend (WebChannel and
     * HTTP).
     */ return (0, $2WUgS.__extends)(n, e), n.prototype.Fi = function(t, e, n, r) {
        return new Promise(function(i, o) {
            var s = new (0, $2e7dd9641ea1df79$export$26404658cda3ee02);
            s.listenOnce((0, $2e7dd9641ea1df79$export$3d7865934588d77e).COMPLETE, function() {
                try {
                    switch(s.getLastErrorCode()){
                        case (0, $2e7dd9641ea1df79$export$d4e71bc0b80dc0fb).NO_ERROR:
                            var e = s.getResponseJson();
                            $8cffe22d3a2884c1$var$C("Connection", "XHR received:", JSON.stringify(e)), i(e);
                            break;
                        case (0, $2e7dd9641ea1df79$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $8cffe22d3a2884c1$var$C("Connection", 'RPC "' + t + '" timed out'), o(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $2e7dd9641ea1df79$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            var n = s.getStatus();
                            if ($8cffe22d3a2884c1$var$C("Connection", 'RPC "' + t + '" failed with status:', n, "response text:", s.getResponseText()), n > 0) {
                                var r = s.getResponseJson().error;
                                if (r && r.status && r.message) {
                                    var u = function(t) {
                                        var e = t.toLowerCase().replace(/_/g, "-");
                                        return Object.values($8cffe22d3a2884c1$var$N).indexOf(e) >= 0 ? e : $8cffe22d3a2884c1$var$N.UNKNOWN;
                                    }(r.status);
                                    o(new $8cffe22d3a2884c1$var$D(u, r.message));
                                } else o(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNKNOWN, "Server responded with status " + s.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $8cffe22d3a2884c1$var$O();
                    }
                } finally{
                    $8cffe22d3a2884c1$var$C("Connection", 'RPC "' + t + '" completed.');
                }
            });
            var u = JSON.stringify(r);
            s.send(e, "POST", u, n, 15);
        });
    }, n.prototype.Oi = function(t, e) {
        var n = [
            this.Di,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            t,
            "/channel"
        ], r = (0, $2e7dd9641ea1df79$export$66869136fc133c3a)(), i = (0, $2e7dd9641ea1df79$export$888d0d9ab79d08fc)(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        };
        this.useFetchStreams && (o.xmlHttpFactory = new (0, $2e7dd9641ea1df79$export$ddb1030448106742)({})), this.ki(o.initMessageHeaders, e), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
        // doesn't have an Origin header. So we have to exclude a few browser environments that are
        // known to (sometimes) not include an Origin. See
        // https://github.com/firebase/firebase-js-sdk/issues/1491.
        (0, $eTAKc.isMobileCordova)() || (0, $eTAKc.isReactNative)() || (0, $eTAKc.isElectron)() || (0, $eTAKc.isIE)() || (0, $eTAKc.isUWP)() || (0, $eTAKc.isBrowserExtension)() || (o.httpHeadersOverwriteParam = "$httpHeaders");
        var l = n.join("");
        $8cffe22d3a2884c1$var$C("Connection", "Creating WebChannel: " + l, o);
        var d = r.createWebChannel(l, o), p = !1, y = !1, v = new $8cffe22d3a2884c1$var$No({
            Ei: function(t) {
                y ? $8cffe22d3a2884c1$var$C("Connection", "Not sending because WebChannel is closed:", t) : (p || ($8cffe22d3a2884c1$var$C("Connection", "Opening WebChannel transport."), d.open(), p = !0), $8cffe22d3a2884c1$var$C("Connection", "WebChannel sending:", t), d.send(t));
            },
            Ti: function() {
                return d.close();
            }
        }), m = function(t, e, n) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            t.listen(e, function(t) {
                try {
                    n(t);
                } catch (t) {
                    setTimeout(function() {
                        throw t;
                    }, 0);
                }
            });
        };
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return m(d, (0, $2e7dd9641ea1df79$export$aa726fb96ad3e039).EventType.OPEN, function() {
            y || $8cffe22d3a2884c1$var$C("Connection", "WebChannel transport opened.");
        }), m(d, (0, $2e7dd9641ea1df79$export$aa726fb96ad3e039).EventType.CLOSE, function() {
            y || (y = !0, $8cffe22d3a2884c1$var$C("Connection", "WebChannel transport closed"), v.Vi());
        }), m(d, (0, $2e7dd9641ea1df79$export$aa726fb96ad3e039).EventType.ERROR, function(t) {
            y || (y = !0, $8cffe22d3a2884c1$var$R("Connection", "WebChannel transport errored:", t), v.Vi(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNAVAILABLE, "The operation could not be completed")));
        }), m(d, (0, $2e7dd9641ea1df79$export$aa726fb96ad3e039).EventType.MESSAGE, function(t) {
            var e;
            if (!y) {
                var n = t.data[0];
                $8cffe22d3a2884c1$var$P(!!n);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                var r = n, i = r.error || (null === (e = r[0]) || void 0 === e ? void 0 : e.error);
                if (i) {
                    $8cffe22d3a2884c1$var$C("Connection", "WebChannel received error:", i);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var o = i.status, s = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function(t) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var e = $8cffe22d3a2884c1$var$Ue[t];
                        if (void 0 !== e) return $8cffe22d3a2884c1$var$ze(e);
                    }(o), u = i.message;
                    void 0 === s && (s = $8cffe22d3a2884c1$var$N.INTERNAL, u = "Unknown error status: " + o + " with message " + i.message), // Mark closed so no further events are propagated
                    y = !0, v.Vi(new $8cffe22d3a2884c1$var$D(s, u)), d.close();
                } else $8cffe22d3a2884c1$var$C("Connection", "WebChannel received:", n), v.Si(n);
            }
        }), m(i, (0, $2e7dd9641ea1df79$export$d61e24a684f9e51).STAT_EVENT, function(t) {
            t.stat === (0, $2e7dd9641ea1df79$export$cbbc350c1dfc80cb).PROXY ? $8cffe22d3a2884c1$var$C("Connection", "Detected buffering proxy") : t.stat === (0, $2e7dd9641ea1df79$export$cbbc350c1dfc80cb).NOPROXY && $8cffe22d3a2884c1$var$C("Connection", "Detected no buffering proxy");
        }), setTimeout(function() {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            v.Pi();
        }, 0), v;
    }, n;
}(/** @class */ function() {
    function t(t) {
        this.databaseInfo = t, this.databaseId = t.databaseId;
        var e = t.ssl ? "https" : "http";
        this.Di = e + "://" + t.host, this.Ci = "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database + "/documents";
    }
    return t.prototype.Ni = function(t, e, n, r) {
        var i = this.xi(t, e);
        $8cffe22d3a2884c1$var$C("RestConnection", "Sending: ", i, n);
        var o = {};
        return this.ki(o, r), this.Fi(t, i, o, n).then(function(t) {
            return $8cffe22d3a2884c1$var$C("RestConnection", "Received: ", t), t;
        }, function(e) {
            throw $8cffe22d3a2884c1$var$R("RestConnection", t + " failed with error: ", e, "url: ", i, "request:", n), e;
        });
    }, t.prototype.$i = function(t, e, n, r) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Ni(t, e, n, r);
    }, /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ t.prototype.ki = function(t, e) {
        if (t["X-Goog-Api-Client"] = "gl-js/ fire/8.10.1", // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), e) for(var n in e.authHeaders)e.authHeaders.hasOwnProperty(n) && (t[n] = e.authHeaders[n]);
    }, t.prototype.xi = function(t, e) {
        var n = $8cffe22d3a2884c1$var$So[t];
        return this.Di + "/v1/" + e + ":" + n;
    }, t;
}());
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $8cffe22d3a2884c1$var$Ao() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $8cffe22d3a2884c1$var$ko() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8cffe22d3a2884c1$var$Co(t) {
    return new $8cffe22d3a2884c1$var$bn(t, /* useProto3Json= */ !0);
}
/**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ var $8cffe22d3a2884c1$var$xo = /** @class */ function() {
    function t(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n, r, i) {
        void 0 === n && (n = 1e3), void 0 === r && (r = 1.5), void 0 === i && (i = 6e4), this.Se = t, this.timerId = e, this.Mi = n, this.Li = r, this.Bi = i, this.qi = 0, this.Ui = null, /** The last backoff attempt, as epoch milliseconds. */ this.Ki = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ return t.prototype.reset = function() {
        this.qi = 0;
    }, /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ t.prototype.Qi = function() {
        this.qi = this.Bi;
    }, /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ t.prototype.ji = function(t) {
        var e = this;
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var n = Math.floor(this.qi + this.Wi()), r = Math.max(0, Date.now() - this.Ki), i = Math.max(0, n - r);
        // Guard against lastAttemptTime being in the future due to a clock change.
        i > 0 && $8cffe22d3a2884c1$var$C("ExponentialBackoff", "Backing off for " + i + " ms (base delay: " + this.qi + " ms, delay with jitter: " + n + " ms, last attempt: " + r + " ms ago)"), this.Ui = this.Se.enqueueAfterDelay(this.timerId, i, function() {
            return e.Ki = Date.now(), t();
        }), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.qi *= this.Li, this.qi < this.Mi && (this.qi = this.Mi), this.qi > this.Bi && (this.qi = this.Bi);
    }, t.prototype.Gi = function() {
        null !== this.Ui && (this.Ui.skipDelay(), this.Ui = null);
    }, t.prototype.cancel = function() {
        null !== this.Ui && (this.Ui.cancel(), this.Ui = null);
    }, /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ t.prototype.Wi = function() {
        return (Math.random() - .5) * this.qi;
    }, t;
}(), $8cffe22d3a2884c1$var$Ro = /** @class */ function() {
    function t(t, e, n, r, i, o) {
        this.Se = t, this.zi = n, this.Hi = r, this.Ji = i, this.listener = o, this.state = 0 /* Initial */ , /**
             * A close count that's incremented every time the stream is closed; used by
             * getCloseGuardedDispatcher() to invalidate callbacks that happen after
             * close.
             */ this.Yi = 0, this.Xi = null, this.stream = null, this.Zi = new $8cffe22d3a2884c1$var$xo(t, e) /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ ;
    }
    return t.prototype.tr = function() {
        return 1 /* Starting */  === this.state || 2 /* Open */  === this.state || 4 /* Backoff */  === this.state;
    }, /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ t.prototype.er = function() {
        return 2 /* Open */  === this.state;
    }, /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ t.prototype.start = function() {
        3 /* Error */  !== this.state ? this.auth() : this.nr();
    }, /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ t.prototype.stop = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.tr() ? [
                            4 /*yield*/ ,
                            this.close(0 /* Initial */ )
                        ] : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ t.prototype.sr = function() {
        this.state = 0 /* Initial */ , this.Zi.reset();
    }, /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ t.prototype.ir = function() {
        var t = this;
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.er() && null === this.Xi && (this.Xi = this.Se.enqueueAfterDelay(this.zi, 6e4, function() {
            return t.rr();
        }));
    }, /** Sends a message to the underlying stream. */ t.prototype.cr = function(t) {
        this.ur(), this.stream.send(t);
    }, /** Called by the idle timer when the stream should close due to inactivity. */ t.prototype.rr = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(t) {
                return this.er() ? [
                    2 /*return*/ ,
                    this.close(0 /* Initial */ )
                ] : [
                    2 /*return*/ 
                ];
            });
        });
    }, /** Marks the stream as active again. */ t.prototype.ur = function() {
        this.Xi && (this.Xi.cancel(), this.Xi = null);
    }, /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ t.prototype.close = function(t, e) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(n) {
                switch(n.label){
                    case 0:
                        // Notify the listener that the stream closed.
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        return this.ur(), this.Zi.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
                        // underlying stream), guaranteeing they won't execute.
                        this.Yi++, 3 /* Error */  !== t ? // If this is an intentional close ensure we don't delay our next connection attempt.
                        this.Zi.reset() : e && e.code === $8cffe22d3a2884c1$var$N.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                        ($8cffe22d3a2884c1$var$x(e.toString()), $8cffe22d3a2884c1$var$x("Using maximum backoff delay to prevent overloading the backend."), this.Zi.Qi()) : e && e.code === $8cffe22d3a2884c1$var$N.UNAUTHENTICATED && // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
                        // just expired.
                        this.Ji.invalidateToken(), // Clean up the underlying stream because we are no longer interested in events.
                        null !== this.stream && (this.ar(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
                        // inhibit backoff or otherwise manipulate the state in its non-started state.
                        this.state = t, [
                            4 /*yield*/ ,
                            this.listener.Ri(e)
                        ];
                    case 1:
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        // Notify the listener that the stream closed.
                        return n.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ t.prototype.ar = function() {}, t.prototype.auth = function() {
        var t = this;
        this.state = 1 /* Starting */ ;
        var e = this.hr(this.Yi), n = this.Yi;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        this.Ji.getToken().then(function(e) {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            t.Yi === n && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            t.lr(e);
        }, function(n) {
            e(function() {
                var e = new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNKNOWN, "Fetching auth token failed: " + n.message);
                return t.dr(e);
            });
        });
    }, t.prototype.lr = function(t) {
        var e = this, n = this.hr(this.Yi);
        this.stream = this.wr(t), this.stream.Ii(function() {
            n(function() {
                return e.state = 2 /* Open */ , e.listener.Ii();
            });
        }), this.stream.Ri(function(t) {
            n(function() {
                return e.dr(t);
            });
        }), this.stream.onMessage(function(t) {
            n(function() {
                return e.onMessage(t);
            });
        });
    }, t.prototype.nr = function() {
        var t = this;
        this.state = 4 /* Backoff */ , this.Zi.ji(function() {
            return (0, $2WUgS.__awaiter)(t, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(t) {
                    return this.state = 0 /* Initial */ , this.start(), [
                        2 /*return*/ 
                    ];
                });
            });
        });
    }, // Visible for tests
    t.prototype.dr = function(t) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $8cffe22d3a2884c1$var$C("PersistentStream", "close with error: " + t), this.stream = null, this.close(3 /* Error */ , t);
    }, /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ t.prototype.hr = function(t) {
        var e = this;
        return function(n) {
            e.Se.enqueueAndForget(function() {
                return e.Yi === t ? n() : ($8cffe22d3a2884c1$var$C("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
            });
        };
    }, t;
}(), $8cffe22d3a2884c1$var$Lo = /** @class */ function(e) {
    function n(t, n, r, i, o) {
        var s = this;
        return (s = e.call(this, t, "listen_stream_connection_backoff" /* ListenStreamConnectionBackoff */ , "listen_stream_idle" /* ListenStreamIdle */ , n, r, o) || this).R = i, s;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.wr = function(t) {
        return this.Hi.Oi("Listen", t);
    }, n.prototype.onMessage = function(t) {
        // A successful response means the stream is healthy
        this.Zi.reset();
        var e = function(t, e) {
            var n;
            if ("targetChange" in e) {
                e.targetChange;
                // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
                // if unset
                var r = function(t) {
                    return "NO_CHANGE" === t ? 0 /* NoChange */  : "ADD" === t ? 1 /* Added */  : "REMOVE" === t ? 2 /* Removed */  : "CURRENT" === t ? 3 /* Current */  : "RESET" === t ? 4 /* Reset */  : $8cffe22d3a2884c1$var$O();
                }(e.targetChange.targetChangeType || "NO_CHANGE"), i = e.targetChange.targetIds || [], o = function(t, e) {
                    return t.I ? ($8cffe22d3a2884c1$var$P(void 0 === e || "string" == typeof e), $8cffe22d3a2884c1$var$J.fromBase64String(e || "")) : ($8cffe22d3a2884c1$var$P(void 0 === e || e instanceof Uint8Array), $8cffe22d3a2884c1$var$J.fromUint8Array(e || new Uint8Array));
                }(t, e.targetChange.resumeToken), s = (u = e.targetChange.cause) && function(t) {
                    var e = void 0 === t.code ? $8cffe22d3a2884c1$var$N.UNKNOWN : $8cffe22d3a2884c1$var$ze(t.code);
                    return new $8cffe22d3a2884c1$var$D(e, t.message || "");
                }(u);
                n = new $8cffe22d3a2884c1$var$dn(r, i, o, s || null);
            } else if ("documentChange" in e) {
                e.documentChange, (r = e.documentChange).document, r.document.name, r.document.updateTime, i = $8cffe22d3a2884c1$var$An(t, r.document.name), o = $8cffe22d3a2884c1$var$En(r.document.updateTime);
                var u = new $8cffe22d3a2884c1$var$Et({
                    mapValue: {
                        fields: r.document.fields
                    }
                }), a = (s = $8cffe22d3a2884c1$var$Nt.newFoundDocument(i, o, u), r.targetIds || []), c = r.removedTargetIds || [];
                n = new $8cffe22d3a2884c1$var$fn(a, c, s.key, s);
            } else if ("documentDelete" in e) e.documentDelete, (r = e.documentDelete).document, i = $8cffe22d3a2884c1$var$An(t, r.document), o = r.readTime ? $8cffe22d3a2884c1$var$En(r.readTime) : $8cffe22d3a2884c1$var$K.min(), u = $8cffe22d3a2884c1$var$Nt.newNoDocument(i, o), s = r.removedTargetIds || [], n = new $8cffe22d3a2884c1$var$fn([], s, u.key, u);
            else if ("documentRemove" in e) e.documentRemove, (r = e.documentRemove).document, i = $8cffe22d3a2884c1$var$An(t, r.document), o = r.removedTargetIds || [], n = new $8cffe22d3a2884c1$var$fn([], o, i, null);
            else {
                if (!("filter" in e)) return $8cffe22d3a2884c1$var$O();
                e.filter;
                var h = e.filter;
                h.targetId, r = h.count || 0, i = new $8cffe22d3a2884c1$var$Ge(r), o = h.targetId, n = new $8cffe22d3a2884c1$var$ln(o, i);
            }
            return n;
        }(this.R, t), n = function(t) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in t)) return $8cffe22d3a2884c1$var$K.min();
            var e = t.targetChange;
            return e.targetIds && e.targetIds.length ? $8cffe22d3a2884c1$var$K.min() : e.readTime ? $8cffe22d3a2884c1$var$En(e.readTime) : $8cffe22d3a2884c1$var$K.min();
        }(t);
        return this.listener._r(e, n);
    }, /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ n.prototype.mr = function(t) {
        var e = {};
        e.database = $8cffe22d3a2884c1$var$xn(this.R), e.addTarget = function(t, e) {
            var n, r = e.target;
            return (n = $8cffe22d3a2884c1$var$xt(r) ? {
                documents: $8cffe22d3a2884c1$var$Mn(t, r)
            } : {
                query: $8cffe22d3a2884c1$var$Vn(t, r)
            }).targetId = e.targetId, e.resumeToken.approximateByteSize() > 0 ? n.resumeToken = $8cffe22d3a2884c1$var$Tn(t, e.resumeToken) : e.snapshotVersion.compareTo($8cffe22d3a2884c1$var$K.min()) > 0 && // TODO(wuandy): Consider removing above check because it is most likely true.
            // Right now, many tests depend on this behaviour though (leaving min() out
            // of serialization).
            (n.readTime = $8cffe22d3a2884c1$var$In(t, e.snapshotVersion.toTimestamp())), n;
        }(this.R, t);
        var n = function(t, e) {
            var n = function(t, e) {
                switch(e){
                    case 0 /* Listen */ :
                        return null;
                    case 1 /* ExistenceFilterMismatch */ :
                        return "existence-filter-mismatch";
                    case 2 /* LimboResolution */ :
                        return "limbo-document";
                    default:
                        return $8cffe22d3a2884c1$var$O();
                }
            }(0, e.purpose);
            return null == n ? null : {
                "goog-listen-tags": n
            };
        }(this.R, t);
        n && (e.labels = n), this.cr(e);
    }, /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ n.prototype.yr = function(t) {
        var e = {};
        e.database = $8cffe22d3a2884c1$var$xn(this.R), e.removeTarget = t, this.cr(e);
    }, n;
}($8cffe22d3a2884c1$var$Ro), $8cffe22d3a2884c1$var$Oo = /** @class */ function(e) {
    function n(t, n, r, i, o) {
        var s = this;
        return (s = e.call(this, t, "write_stream_connection_backoff" /* WriteStreamConnectionBackoff */ , "write_stream_idle" /* WriteStreamIdle */ , n, r, o) || this).R = i, s.gr = !1, s;
    }
    return (0, $2WUgS.__extends)(n, e), Object.defineProperty(n.prototype, "pr", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */ get: function() {
            return this.gr;
        },
        enumerable: !1,
        configurable: !0
    }), // Override of PersistentStream.start
    n.prototype.start = function() {
        this.gr = !1, this.lastStreamToken = void 0, e.prototype.start.call(this);
    }, n.prototype.ar = function() {
        this.gr && this.Er([]);
    }, n.prototype.wr = function(t) {
        return this.Hi.Oi("Write", t);
    }, n.prototype.onMessage = function(t) {
        if (// Always capture the last stream token.
        $8cffe22d3a2884c1$var$P(!!t.streamToken), this.lastStreamToken = t.streamToken, this.gr) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.Zi.reset();
            var e = function(t, e) {
                return t && t.length > 0 ? ($8cffe22d3a2884c1$var$P(void 0 !== e), t.map(function(t) {
                    return function(t, e) {
                        // NOTE: Deletes don't have an updateTime.
                        var n = t.updateTime ? $8cffe22d3a2884c1$var$En(t.updateTime) : $8cffe22d3a2884c1$var$En(e);
                        return n.isEqual($8cffe22d3a2884c1$var$K.min()) && // The Firestore Emulator currently returns an update time of 0 for
                        // deletes of non-existing documents (rather than null). This breaks the
                        // test "get deleted doc while offline with source=cache" as NoDocuments
                        // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
                        // TODO(#2149): Remove this when Emulator is fixed
                        (n = $8cffe22d3a2884c1$var$En(e)), new $8cffe22d3a2884c1$var$Ne(n, t.transformResults || []);
                    }(t, e);
                })) : [];
            }(t.writeResults, t.commitTime), n = $8cffe22d3a2884c1$var$En(t.commitTime);
            return this.listener.Tr(n, e);
        }
        // The first response is always the handshake response
        return $8cffe22d3a2884c1$var$P(!t.writeResults || 0 === t.writeResults.length), this.gr = !0, this.listener.Ir();
    }, /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ n.prototype.Ar = function() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var t = {};
        t.database = $8cffe22d3a2884c1$var$xn(this.R), this.cr(t);
    }, /** Sends a group of mutations to the Firestore backend to apply. */ n.prototype.Er = function(t) {
        var e = this, n = {
            streamToken: this.lastStreamToken,
            writes: t.map(function(t) {
                return $8cffe22d3a2884c1$var$Pn(e.R, t);
            })
        };
        this.cr(n);
    }, n;
}($8cffe22d3a2884c1$var$Ro), $8cffe22d3a2884c1$var$Po = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).credentials = t, i.Hi = n, i.R = r, i.Rr = !1, i;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.br = function() {
        if (this.Rr) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    }, /** Gets an auth token and invokes the provided RPC. */ n.prototype.Ni = function(t, e, n) {
        var r = this;
        return this.br(), this.credentials.getToken().then(function(i) {
            return r.Hi.Ni(t, e, n, i);
        }).catch(function(t) {
            throw "FirebaseError" === t.name ? (t.code === $8cffe22d3a2884c1$var$N.UNAUTHENTICATED && r.credentials.invalidateToken(), t) : new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNKNOWN, t.toString());
        });
    }, /** Gets an auth token and invokes the provided RPC with streamed results. */ n.prototype.$i = function(t, e, n) {
        var r = this;
        return this.br(), this.credentials.getToken().then(function(i) {
            return r.Hi.$i(t, e, n, i);
        }).catch(function(t) {
            throw "FirebaseError" === t.name ? (t.code === $8cffe22d3a2884c1$var$N.UNAUTHENTICATED && r.credentials.invalidateToken(), t) : new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNKNOWN, t.toString());
        });
    }, n.prototype.terminate = function() {
        this.Rr = !0;
    }, n;
}(function() {}), $8cffe22d3a2884c1$var$Fo = /** @class */ function() {
    function t(t, e) {
        this.asyncQueue = t, this.onlineStateHandler = e, /** The current OnlineState. */ this.state = "Unknown" /* Unknown */ , /**
             * A count of consecutive failures to open the stream. If it reaches the
             * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
             * Offline.
             */ this.vr = 0, /**
             * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
             * transition from OnlineState.Unknown to OnlineState.Offline without waiting
             * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
             */ this.Pr = null, /**
             * Whether the client should log a warning message if it fails to connect to
             * the backend (initially true, cleared after a successful stream, or if we've
             * logged the message already).
             */ this.Vr = !0 /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ ;
    }
    return t.prototype.Sr = function() {
        var t = this;
        0 === this.vr && (this.Dr("Unknown" /* Unknown */ ), this.Pr = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* OnlineStateTimeout */ , 1e4, function() {
            return t.Pr = null, t.Cr("Backend didn't respond within 10 seconds."), t.Dr("Offline" /* Offline */ ), Promise.resolve();
        }));
    }, /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ t.prototype.Nr = function(t) {
        "Online" /* Online */  === this.state ? this.Dr("Unknown" /* Unknown */ ) : (this.vr++, this.vr >= 1 && (this.kr(), this.Cr("Connection failed 1 times. Most recent error: " + t.toString()), this.Dr("Offline" /* Offline */ )));
    }, /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ t.prototype.set = function(t) {
        this.kr(), this.vr = 0, "Online" /* Online */  === t && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.Vr = !1), this.Dr(t);
    }, t.prototype.Dr = function(t) {
        t !== this.state && (this.state = t, this.onlineStateHandler(t));
    }, t.prototype.Cr = function(t) {
        var e = "Could not reach Cloud Firestore backend. " + t + "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.";
        this.Vr ? ($8cffe22d3a2884c1$var$x(e), this.Vr = !1) : $8cffe22d3a2884c1$var$C("OnlineStateTracker", e);
    }, t.prototype.kr = function() {
        null !== this.Pr && (this.Pr.cancel(), this.Pr = null);
    }, t;
}(), $8cffe22d3a2884c1$var$Mo = function(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ t, /** The client-side proxy for interacting with the backend. */ e, i, o, s) {
    var u = this;
    this.localStore = t, this.datastore = e, this.asyncQueue = i, this.remoteSyncer = {}, /**
             * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
             * LocalStore via fillWritePipeline() and have or will send to the write
             * stream.
             *
             * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
             * restart the write stream. When the stream is established the writes in the
             * pipeline will be sent in order.
             *
             * Writes remain in writePipeline until they are acknowledged by the backend
             * and thus will automatically be re-sent if the stream is interrupted /
             * restarted before they're acknowledged.
             *
             * Write responses from the backend are linked to their originating request
             * purely based on order, and so we can just shift() writes from the front of
             * the writePipeline as we receive responses.
             */ this.Fr = [], /**
             * A mapping of watched targets that the client cares about tracking and the
             * user has explicitly called a 'listen' for this target.
             *
             * These targets may or may not have been sent to or acknowledged by the
             * server. On re-establishing the listen stream, these targets should be sent
             * to the server. The targets removed with unlistens are removed eagerly
             * without waiting for confirmation from the listen stream.
             */ this.$r = new Map, /**
             * A set of reasons for why the RemoteStore may be offline. If empty, the
             * RemoteStore may start its network connections.
             */ this.Or = new Set, /**
             * Event handlers that get called when the network is disabled or enabled.
             *
             * PORTING NOTE: These functions are used on the Web client to create the
             * underlying streams (to support tree-shakeable streams). On Android and iOS,
             * the streams are created during construction of RemoteStore.
             */ this.Mr = [], this.Lr = s, this.Lr.di(function(t) {
        i.enqueueAndForget(function() {
            return (0, $2WUgS.__awaiter)(u, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(t) {
                    switch(t.label){
                        case 0:
                            return $8cffe22d3a2884c1$var$zo(this) ? ($8cffe22d3a2884c1$var$C("RemoteStore", "Restarting streams for network reachability change."), [
                                4 /*yield*/ ,
                                function(t) {
                                    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                        var e;
                                        return (0, $2WUgS.__generator)(this, function(n) {
                                            switch(n.label){
                                                case 0:
                                                    return (e = $8cffe22d3a2884c1$var$F(t)).Or.add(4 /* ConnectivityChange */ ), [
                                                        4 /*yield*/ ,
                                                        $8cffe22d3a2884c1$var$qo(e)
                                                    ];
                                                case 1:
                                                    return n.sent(), e.Br.set("Unknown" /* Unknown */ ), e.Or.delete(4 /* ConnectivityChange */ ), [
                                                        4 /*yield*/ ,
                                                        $8cffe22d3a2884c1$var$Vo(e)
                                                    ];
                                                case 2:
                                                    return n.sent(), [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }(this)
                            ]) : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            t.sent(), t.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }), this.Br = new $8cffe22d3a2884c1$var$Fo(i, o);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ function $8cffe22d3a2884c1$var$Vo(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e, n;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    if (!$8cffe22d3a2884c1$var$zo(t)) return [
                        3 /*break*/ ,
                        4
                    ];
                    e = 0, n = t.Mr, r.label = 1;
                case 1:
                    return e < n.length ? [
                        4 /*yield*/ ,
                        (0, n[e])(/* enabled= */ !0)
                    ] : [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    r.sent(), r.label = 3;
                case 3:
                    return e++, [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ function $8cffe22d3a2884c1$var$qo(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e, n;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    e = 0, n = t.Mr, r.label = 1;
                case 1:
                    return e < n.length ? [
                        4 /*yield*/ ,
                        (0, n[e])(/* enabled= */ !1)
                    ] : [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    r.sent(), r.label = 3;
                case 3:
                    return e++, [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $8cffe22d3a2884c1$var$Uo(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t);
    n.$r.has(e.targetId) || // Mark this as something the client is currently listening for.
    (n.$r.set(e.targetId, e), $8cffe22d3a2884c1$var$Qo(n) ? // The listen will be sent in onWatchStreamOpen
    $8cffe22d3a2884c1$var$Go(n) : $8cffe22d3a2884c1$var$us(n).er() && $8cffe22d3a2884c1$var$jo(n, e));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $8cffe22d3a2884c1$var$Bo(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t), r = $8cffe22d3a2884c1$var$us(n);
    n.$r.delete(e), r.er() && $8cffe22d3a2884c1$var$Ko(n, e), 0 === n.$r.size && (r.er() ? r.ir() : $8cffe22d3a2884c1$var$zo(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.Br.set("Unknown" /* Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $8cffe22d3a2884c1$var$jo(t, e) {
    t.qr.U(e.targetId), $8cffe22d3a2884c1$var$us(t).mr(e) /**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ ;
}
function $8cffe22d3a2884c1$var$Ko(t, e) {
    t.qr.U(e), $8cffe22d3a2884c1$var$us(t).yr(e);
}
function $8cffe22d3a2884c1$var$Go(t) {
    t.qr = new $8cffe22d3a2884c1$var$yn({
        getRemoteKeysForTarget: function(e) {
            return t.remoteSyncer.getRemoteKeysForTarget(e);
        },
        lt: function(e) {
            return t.$r.get(e) || null;
        }
    }), $8cffe22d3a2884c1$var$us(t).start(), t.Br.Sr() /**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ ;
}
function $8cffe22d3a2884c1$var$Qo(t) {
    return $8cffe22d3a2884c1$var$zo(t) && !$8cffe22d3a2884c1$var$us(t).tr() && t.$r.size > 0;
}
function $8cffe22d3a2884c1$var$zo(t) {
    return 0 === $8cffe22d3a2884c1$var$F(t).Or.size;
}
function $8cffe22d3a2884c1$var$Wo(t) {
    t.qr = void 0;
}
function $8cffe22d3a2884c1$var$Ho(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(e) {
            return t.$r.forEach(function(e, n) {
                $8cffe22d3a2884c1$var$jo(t, e);
            }), [
                2 /*return*/ 
            ];
        });
    });
}
function $8cffe22d3a2884c1$var$Yo(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(n) {
            return $8cffe22d3a2884c1$var$Wo(t), // If we still need the watch stream, retry the connection.
            $8cffe22d3a2884c1$var$Qo(t) ? (t.Br.Nr(e), $8cffe22d3a2884c1$var$Go(t)) : // No need to restart watch stream because there are no active targets.
            // The online state is set to unknown because there is no active attempt
            // at establishing a connection
            t.Br.set("Unknown" /* Unknown */ ), [
                2 /*return*/ 
            ];
        });
    });
}
function $8cffe22d3a2884c1$var$$o(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var o, s, u;
        return (0, $2WUgS.__generator)(this, function(a) {
            switch(a.label){
                case 0:
                    if (t.Br.set("Online" /* Online */ ), !(e instanceof $8cffe22d3a2884c1$var$dn && 2 /* Removed */  === e.state && e.cause)) // Mark the client as online since we got a message from the server
                    return [
                        3 /*break*/ ,
                        6
                    ];
                    a.label = 1;
                case 1:
                    return a.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]), [
                        4 /*yield*/ ,
                        /** Handles an error on a target */ function(t, e) {
                            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                var n, i, o, s;
                                return (0, $2WUgS.__generator)(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            n = e.cause, i = 0, o = e.targetIds, r.label = 1;
                                        case 1:
                                            return i < o.length ? (s = o[i], t.$r.has(s) ? [
                                                4 /*yield*/ ,
                                                t.remoteSyncer.rejectListen(s, n)
                                            ] : [
                                                3 /*break*/ ,
                                                3
                                            ]) : [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 2:
                                            r.sent(), t.$r.delete(s), t.qr.removeTarget(s), r.label = 3;
                                        case 3:
                                            r.label = 4;
                                        case 4:
                                            return i++, [
                                                3 /*break*/ ,
                                                1
                                            ];
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }(t, e)
                    ];
                case 2:
                    return a.sent(), [
                        3 /*break*/ ,
                        5
                    ];
                case 3:
                    return o = a.sent(), $8cffe22d3a2884c1$var$C("RemoteStore", "Failed to remove targets %s: %s ", e.targetIds.join(","), o), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Xo(t, o)
                    ];
                case 4:
                    return a.sent(), [
                        3 /*break*/ ,
                        5
                    ];
                case 5:
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    if (e instanceof $8cffe22d3a2884c1$var$fn ? t.qr.X(e) : e instanceof $8cffe22d3a2884c1$var$ln ? t.qr.rt(e) : t.qr.et(e), i.isEqual($8cffe22d3a2884c1$var$K.min())) return [
                        3 /*break*/ ,
                        13
                    ];
                    a.label = 7;
                case 7:
                    return a.trys.push([
                        7,
                        11,
                        ,
                        13
                    ]), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ki(t.localStore)
                    ];
                case 8:
                    return s = a.sent(), i.compareTo(s) >= 0 ? [
                        4 /*yield*/ ,
                        /**
                 * Takes a batch of changes from the Datastore, repackages them as a
                 * RemoteEvent, and passes that on to the listener, which is typically the
                 * SyncEngine.
                 */ function(t, e) {
                            var n = t.qr.ut(e);
                            // Update in-memory resume tokens. LocalStore will update the
                            // persistent view of these when applying the completed RemoteEvent.
                            return n.targetChanges.forEach(function(n, r) {
                                if (n.resumeToken.approximateByteSize() > 0) {
                                    var i = t.$r.get(r);
                                    // A watched target might have been removed already.
                                    i && t.$r.set(r, i.withResumeToken(n.resumeToken, e));
                                }
                            }), // Re-establish listens for the targets that have been invalidated by
                            // existence filter mismatches.
                            n.targetMismatches.forEach(function(e) {
                                var n = t.$r.get(e);
                                if (n) {
                                    // Clear the resume token for the target, since we're in a known mismatch
                                    // state.
                                    t.$r.set(e, n.withResumeToken($8cffe22d3a2884c1$var$J.EMPTY_BYTE_STRING, n.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                                    // deliberately don't send a resume token so that we get a full update.
                                    $8cffe22d3a2884c1$var$Ko(t, e);
                                    // Mark the target we send as being on behalf of an existence filter
                                    // mismatch, but don't actually retain that in listenTargets. This ensures
                                    // that we flag the first re-listen this way without impacting future
                                    // listens of this target (that might happen e.g. on reconnect).
                                    var r = new $8cffe22d3a2884c1$var$Pr(n.target, e, 1 /* ExistenceFilterMismatch */ , n.sequenceNumber);
                                    $8cffe22d3a2884c1$var$jo(t, r);
                                }
                            }), t.remoteSyncer.applyRemoteEvent(n);
                        }(t, i)
                    ] : [
                        3 /*break*/ ,
                        10
                    ];
                // We have received a target change with a global snapshot if the snapshot
                // version is not equal to SnapshotVersion.min().
                case 9:
                    // We have received a target change with a global snapshot if the snapshot
                    // version is not equal to SnapshotVersion.min().
                    a.sent(), a.label = 10;
                case 10:
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 11:
                    return $8cffe22d3a2884c1$var$C("RemoteStore", "Failed to raise snapshot:", u = a.sent()), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Xo(t, u)
                    ];
                case 12:
                    return a.sent(), [
                        3 /*break*/ ,
                        13
                    ];
                case 13:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ function $8cffe22d3a2884c1$var$Xo(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var o = this;
        return (0, $2WUgS.__generator)(this, function(s) {
            switch(s.label){
                case 0:
                    if (!$8cffe22d3a2884c1$var$Nr(e)) throw e;
                    // Disable network and raise offline snapshots
                    return t.Or.add(1 /* IndexedDbFailed */ ), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$qo(t)
                    ];
                case 1:
                    // Disable network and raise offline snapshots
                    return s.sent(), t.Br.set("Offline" /* Offline */ ), i || // Use a simple read operation to determine if IndexedDB recovered.
                    // Ideally, we would expose a health check directly on SimpleDb, but
                    // RemoteStore only has access to persistence through LocalStore.
                    (i = function() {
                        return $8cffe22d3a2884c1$var$Ki(t.localStore);
                    }), // Probe IndexedDB periodically and re-enable network
                    t.asyncQueue.enqueueRetryable(function() {
                        return (0, $2WUgS.__awaiter)(o, void 0, void 0, function() {
                            return (0, $2WUgS.__generator)(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        return $8cffe22d3a2884c1$var$C("RemoteStore", "Retrying IndexedDB access"), [
                                            4 /*yield*/ ,
                                            i()
                                        ];
                                    case 1:
                                        return e.sent(), t.Or.delete(1 /* IndexedDbFailed */ ), [
                                            4 /*yield*/ ,
                                            $8cffe22d3a2884c1$var$Vo(t)
                                        ];
                                    case 2:
                                        return e.sent(), [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    }), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $8cffe22d3a2884c1$var$Jo(t, e) {
    return e().catch(function(n) {
        return $8cffe22d3a2884c1$var$Xo(t, n, e);
    });
}
function $8cffe22d3a2884c1$var$Zo(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e, n, i, o, s;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    e = $8cffe22d3a2884c1$var$F(t), n = $8cffe22d3a2884c1$var$as(e), i = e.Fr.length > 0 ? e.Fr[e.Fr.length - 1].batchId : -1, r.label = 1;
                case 1:
                    if (!/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function(t) {
                        return $8cffe22d3a2884c1$var$zo(t) && t.Fr.length < 10;
                    }(e)) return [
                        3 /*break*/ ,
                        7
                    ];
                    r.label = 2;
                case 2:
                    return r.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$zi(e.localStore, i)
                    ];
                case 3:
                    return null === (o = r.sent()) ? (0 === e.Fr.length && n.ir(), [
                        3 /*break*/ ,
                        7
                    ]) : (i = o.batchId, function(t, e) {
                        t.Fr.push(e);
                        var n = $8cffe22d3a2884c1$var$as(t);
                        n.er() && n.pr && n.Er(e.mutations);
                    }(e, o), [
                        3 /*break*/ ,
                        6
                    ]);
                case 4:
                    return s = r.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Xo(e, s)
                    ];
                case 5:
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 7:
                    return $8cffe22d3a2884c1$var$ts(e) && $8cffe22d3a2884c1$var$es(e), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$ts(t) {
    return $8cffe22d3a2884c1$var$zo(t) && !$8cffe22d3a2884c1$var$as(t).tr() && t.Fr.length > 0;
}
function $8cffe22d3a2884c1$var$es(t) {
    $8cffe22d3a2884c1$var$as(t).start();
}
function $8cffe22d3a2884c1$var$ns(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(e) {
            return $8cffe22d3a2884c1$var$as(t).Ar(), [
                2 /*return*/ 
            ];
        });
    });
}
function $8cffe22d3a2884c1$var$rs(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e, n, i, o;
        return (0, $2WUgS.__generator)(this, function(r) {
            // Send the write pipeline now that the stream is established.
            for(e = $8cffe22d3a2884c1$var$as(t), n = 0, i = t.Fr; n < i.length; n++)o = i[n], e.Er(o.mutations);
            return [
                2 /*return*/ 
            ];
        });
    });
}
function $8cffe22d3a2884c1$var$is(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, o;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return n = t.Fr.shift(), o = $8cffe22d3a2884c1$var$Or.from(n, e, i), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Jo(t, function() {
                            return t.remoteSyncer.applySuccessfulWrite(o);
                        })
                    ];
                case 1:
                    // It's possible that with the completion of this mutation another
                    // slot has freed up.
                    return r.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Zo(t)
                    ];
                case 2:
                    // It's possible that with the completion of this mutation another
                    // slot has freed up.
                    return r.sent(), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$os(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(i) {
            switch(i.label){
                case 0:
                    return e && $8cffe22d3a2884c1$var$as(t).pr ? [
                        4 /*yield*/ ,
                        function(t, e) {
                            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                var n, i;
                                return (0, $2WUgS.__generator)(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            return $8cffe22d3a2884c1$var$Qe(i = e.code) && i !== $8cffe22d3a2884c1$var$N.ABORTED ? (n = t.Fr.shift(), // In this case it's also unlikely that the server itself is melting
                                            // down -- this was just a bad request so inhibit backoff on the next
                                            // restart.
                                            $8cffe22d3a2884c1$var$as(t).sr(), [
                                                4 /*yield*/ ,
                                                $8cffe22d3a2884c1$var$Jo(t, function() {
                                                    return t.remoteSyncer.rejectFailedWrite(n.batchId, e);
                                                })
                                            ]) : [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 1:
                                            // It's possible that with the completion of this mutation
                                            // another slot has freed up.
                                            return r.sent(), [
                                                4 /*yield*/ ,
                                                $8cffe22d3a2884c1$var$Zo(t)
                                            ];
                                        case 2:
                                            // In this case it's also unlikely that the server itself is melting
                                            // down -- this was just a bad request so inhibit backoff on the next
                                            // restart.
                                            // It's possible that with the completion of this mutation
                                            // another slot has freed up.
                                            r.sent(), r.label = 3;
                                        case 3:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }(t, e)
                    ] : [
                        3 /*break*/ ,
                        2
                    ];
                // This error affects the actual write.
                case 1:
                    // This error affects the actual write.
                    i.sent(), i.label = 2;
                case 2:
                    // If the write stream closed after the write handshake completes, a write
                    // operation failed and we fail the pending operation.
                    // The write stream might have been started by refilling the write
                    // pipeline for failed writes
                    return $8cffe22d3a2884c1$var$ts(t) && $8cffe22d3a2884c1$var$es(t), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ function $8cffe22d3a2884c1$var$ss(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return n = $8cffe22d3a2884c1$var$F(t), e ? (n.Or.delete(2 /* IsSecondary */ ), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Vo(n)
                    ]) : [
                        3 /*break*/ ,
                        2
                    ];
                case 1:
                    return r.sent(), [
                        3 /*break*/ ,
                        5
                    ];
                case 2:
                    return e ? [
                        3 /*break*/ ,
                        4
                    ] : (n.Or.add(2 /* IsSecondary */ ), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$qo(n)
                    ]);
                case 3:
                    r.sent(), n.Br.set("Unknown" /* Unknown */ ), r.label = 4;
                case 4:
                    r.label = 5;
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $8cffe22d3a2884c1$var$us(t) {
    var e = this;
    return t.Ur || // Create stream (but note that it is not started yet).
    (t.Ur = function(t, e, n) {
        var r = $8cffe22d3a2884c1$var$F(t);
        return r.br(), new $8cffe22d3a2884c1$var$Lo(e, r.Hi, r.credentials, r.R, n);
    }(t.datastore, t.asyncQueue, {
        Ii: $8cffe22d3a2884c1$var$Ho.bind(null, t),
        Ri: $8cffe22d3a2884c1$var$Yo.bind(null, t),
        _r: $8cffe22d3a2884c1$var$$o.bind(null, t)
    }), t.Mr.push(function(i) {
        return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(e) {
                switch(e.label){
                    case 0:
                        return i ? (t.Ur.sr(), $8cffe22d3a2884c1$var$Qo(t) ? $8cffe22d3a2884c1$var$Go(t) : t.Br.set("Unknown" /* Unknown */ ), [
                            3 /*break*/ ,
                            3
                        ]) : [
                            3 /*break*/ ,
                            1
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            t.Ur.stop()
                        ];
                    case 2:
                        e.sent(), $8cffe22d3a2884c1$var$Wo(t), e.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    })), t.Ur /**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ ;
}
function $8cffe22d3a2884c1$var$as(t) {
    var e = this;
    return t.Kr || // Create stream (but note that it is not started yet).
    (t.Kr = function(t, e, n) {
        var r = $8cffe22d3a2884c1$var$F(t);
        return r.br(), new $8cffe22d3a2884c1$var$Oo(e, r.Hi, r.credentials, r.R, n);
    }(t.datastore, t.asyncQueue, {
        Ii: $8cffe22d3a2884c1$var$ns.bind(null, t),
        Ri: $8cffe22d3a2884c1$var$os.bind(null, t),
        Ir: $8cffe22d3a2884c1$var$rs.bind(null, t),
        Tr: $8cffe22d3a2884c1$var$is.bind(null, t)
    }), t.Mr.push(function(i) {
        return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(e) {
                switch(e.label){
                    case 0:
                        return i ? (t.Kr.sr(), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Zo(t)
                        ]) : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        // This will start the write stream if necessary.
                        return e.sent(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            t.Kr.stop()
                        ];
                    case 3:
                        e.sent(), t.Fr.length > 0 && ($8cffe22d3a2884c1$var$C("RemoteStore", "Stopping write stream with " + t.Fr.length + " pending writes"), t.Fr = []), e.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    })), t.Kr /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ ;
}
var $8cffe22d3a2884c1$var$cs = /** @class */ function() {
    function t(t, e, n, r, i) {
        this.asyncQueue = t, this.timerId = e, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $8cffe22d3a2884c1$var$br, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function(t) {}) /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ ;
    }
    return t.createAndSchedule = function(e, n, r, i, o) {
        var s = new t(e, n, Date.now() + r, i, o);
        return s.start(r), s;
    }, /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ t.prototype.start = function(t) {
        var e = this;
        this.timerHandle = setTimeout(function() {
            return e.handleDelayElapsed();
        }, t);
    }, /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ t.prototype.skipDelay = function() {
        return this.handleDelayElapsed();
    }, /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ t.prototype.cancel = function(t) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }, t.prototype.handleDelayElapsed = function() {
        var t = this;
        this.asyncQueue.enqueueAndForget(function() {
            return null !== t.timerHandle ? (t.clearTimeout(), t.op().then(function(e) {
                return t.deferred.resolve(e);
            })) : Promise.resolve();
        });
    }, t.prototype.clearTimeout = function() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }, t;
}();
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $8cffe22d3a2884c1$var$hs(t, e) {
    if ($8cffe22d3a2884c1$var$x("AsyncQueue", e + ": " + t), $8cffe22d3a2884c1$var$Nr(t)) return new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNAVAILABLE, e + ": " + t);
    throw t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ var $8cffe22d3a2884c1$var$fs = /** @class */ function() {
    /** The default ordering is by key if the comparator is omitted */ function t(t) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = t ? function(e, n) {
            return t(e, n) || $8cffe22d3a2884c1$var$ct.comparator(e.key, n.key);
        } : function(t, e) {
            return $8cffe22d3a2884c1$var$ct.comparator(t.key, e.key);
        }, this.keyedMap = $8cffe22d3a2884c1$var$en(), this.sortedSet = new $8cffe22d3a2884c1$var$We(this.comparator) /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ ;
    }
    return t.emptySet = function(e) {
        return new t(e.comparator);
    }, t.prototype.has = function(t) {
        return null != this.keyedMap.get(t);
    }, t.prototype.get = function(t) {
        return this.keyedMap.get(t);
    }, t.prototype.first = function() {
        return this.sortedSet.minKey();
    }, t.prototype.last = function() {
        return this.sortedSet.maxKey();
    }, t.prototype.isEmpty = function() {
        return this.sortedSet.isEmpty();
    }, /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ t.prototype.indexOf = function(t) {
        var e = this.keyedMap.get(t);
        return e ? this.sortedSet.indexOf(e) : -1;
    }, Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.sortedSet.size;
        },
        enumerable: !1,
        configurable: !0
    }), /** Iterates documents in order defined by "comparator" */ t.prototype.forEach = function(t) {
        this.sortedSet.inorderTraversal(function(e, n) {
            return t(e), !1;
        });
    }, /** Inserts or updates a document with the same key */ t.prototype.add = function(t) {
        // First remove the element if we have it.
        var e = this.delete(t.key);
        return e.copy(e.keyedMap.insert(t.key, t), e.sortedSet.insert(t, null));
    }, /** Deletes a document with a given key */ t.prototype.delete = function(t) {
        var e = this.get(t);
        return e ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(e)) : this;
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) return !1;
        if (this.size !== e.size) return !1;
        for(var n = this.sortedSet.getIterator(), r = e.sortedSet.getIterator(); n.hasNext();){
            var i = n.getNext().key, o = r.getNext().key;
            if (!i.isEqual(o)) return !1;
        }
        return !0;
    }, t.prototype.toString = function() {
        var t = [];
        return this.forEach(function(e) {
            t.push(e.toString());
        }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }, t.prototype.copy = function(e, n) {
        var r = new t;
        return r.comparator = this.comparator, r.keyedMap = e, r.sortedSet = n, r;
    }, t;
}(), $8cffe22d3a2884c1$var$ls = /** @class */ function() {
    function t() {
        this.Qr = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
    }
    return t.prototype.track = function(t) {
        var e = t.doc.key, n = this.Qr.get(e);
        n ? // Merge the new change with the existing change.
        0 /* Added */  !== t.type && 3 /* Metadata */  === n.type ? this.Qr = this.Qr.insert(e, t) : 3 /* Metadata */  === t.type && 1 /* Removed */  !== n.type ? this.Qr = this.Qr.insert(e, {
            type: n.type,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 2 /* Modified */  === n.type ? this.Qr = this.Qr.insert(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 0 /* Added */  === n.type ? this.Qr = this.Qr.insert(e, {
            type: 0 /* Added */ ,
            doc: t.doc
        }) : 1 /* Removed */  === t.type && 0 /* Added */  === n.type ? this.Qr = this.Qr.remove(e) : 1 /* Removed */  === t.type && 2 /* Modified */  === n.type ? this.Qr = this.Qr.insert(e, {
            type: 1 /* Removed */ ,
            doc: n.doc
        }) : 0 /* Added */  === t.type && 1 /* Removed */  === n.type ? this.Qr = this.Qr.insert(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $8cffe22d3a2884c1$var$O() : this.Qr = this.Qr.insert(e, t);
    }, t.prototype.jr = function() {
        var t = [];
        return this.Qr.inorderTraversal(function(e, n) {
            t.push(n);
        }), t;
    }, t;
}(), $8cffe22d3a2884c1$var$ds = /** @class */ function() {
    function t(t, e, n, r, i, o, s, u) {
        this.query = t, this.docs = e, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = o, this.syncStateChanged = s, this.excludesMetadataChanges = u /** Returns a view snapshot as if all documents in the snapshot were added. */ ;
    }
    return t.fromInitialDocuments = function(e, n, r, i) {
        var o = [];
        return n.forEach(function(t) {
            o.push({
                type: 0 /* Added */ ,
                doc: t
            });
        }), new t(e, n, $8cffe22d3a2884c1$var$fs.emptySet(n), o, r, i, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1);
    }, Object.defineProperty(t.prototype, "hasPendingWrites", {
        get: function() {
            return !this.mutatedKeys.isEmpty();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(t) {
        if (!(this.fromCache === t.fromCache && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && $8cffe22d3a2884c1$var$ie(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs))) return !1;
        var e = this.docChanges, n = t.docChanges;
        if (e.length !== n.length) return !1;
        for(var r = 0; r < e.length; r++)if (e[r].type !== n[r].type || !e[r].doc.isEqual(n[r].doc)) return !1;
        return !0;
    }, t;
}(), $8cffe22d3a2884c1$var$ps = function() {
    this.Wr = void 0, this.listeners = [];
}, $8cffe22d3a2884c1$var$ys = function() {
    this.queries = new $8cffe22d3a2884c1$var$Ii(function(t) {
        return $8cffe22d3a2884c1$var$oe(t);
    }, $8cffe22d3a2884c1$var$ie), this.onlineState = "Unknown" /* Unknown */ , this.Gr = new Set;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ function $8cffe22d3a2884c1$var$vs(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o, s, u, a, c;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    if (n = $8cffe22d3a2884c1$var$F(t), i = e.query, o = !1, (s = n.queries.get(i)) || (o = !0, s = new $8cffe22d3a2884c1$var$ps), !o) return [
                        3 /*break*/ ,
                        4
                    ];
                    r.label = 1;
                case 1:
                    return r.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), u = s, [
                        4 /*yield*/ ,
                        n.onListen(i)
                    ];
                case 2:
                    return u.Wr = r.sent(), [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    return a = r.sent(), c = $8cffe22d3a2884c1$var$hs(a, "Initialization of query '" + $8cffe22d3a2884c1$var$se(e.query) + "' failed"), [
                        2 /*return*/ ,
                        void e.onError(c)
                    ];
                case 4:
                    return n.queries.set(i, s), s.listeners.push(e), // Run global snapshot listeners if a consistent snapshot has been emitted.
                    e.zr(n.onlineState), s.Wr && e.Hr(s.Wr) && $8cffe22d3a2884c1$var$bs(n), [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$ms(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o, s, u;
        return (0, $2WUgS.__generator)(this, function(r) {
            return n = $8cffe22d3a2884c1$var$F(t), i = e.query, o = !1, (s = n.queries.get(i)) && (u = s.listeners.indexOf(e)) >= 0 && (s.listeners.splice(u, 1), o = 0 === s.listeners.length), o ? [
                2 /*return*/ ,
                (n.queries.delete(i), n.onUnlisten(i))
            ] : [
                2 /*return*/ 
            ];
        });
    });
}
function $8cffe22d3a2884c1$var$gs(t, e) {
    for(var n = $8cffe22d3a2884c1$var$F(t), r = !1, i = 0, o = e; i < o.length; i++){
        var s = o[i], u = s.query, a = n.queries.get(u);
        if (a) {
            for(var c = 0, h = a.listeners; c < h.length; c++)h[c].Hr(s) && (r = !0);
            a.Wr = s;
        }
    }
    r && $8cffe22d3a2884c1$var$bs(n);
}
function $8cffe22d3a2884c1$var$ws(t, e, n) {
    var r = $8cffe22d3a2884c1$var$F(t), i = r.queries.get(e);
    if (i) for(var o = 0, s = i.listeners; o < s.length; o++)s[o].onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(e);
}
// Call all global snapshot listeners that have been set.
function $8cffe22d3a2884c1$var$bs(t) {
    t.Gr.forEach(function(t) {
        t.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ var $8cffe22d3a2884c1$var$Is = /** @class */ function() {
    function t(t, e, n) {
        this.query = t, this.Jr = e, /**
             * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
             * observer. This flag is set to true once we've actually raised an event.
             */ this.Yr = !1, this.Xr = null, this.onlineState = "Unknown" /* Unknown */ , this.options = n || {} /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ ;
    }
    return t.prototype.Hr = function(t) {
        if (!this.options.includeMetadataChanges) {
            for(// Remove the metadata only changes.
            var e = [], n = 0, r = t.docChanges; n < r.length; n++){
                var i = r[n];
                3 /* Metadata */  !== i.type && e.push(i);
            }
            t = new $8cffe22d3a2884c1$var$ds(t.query, t.docs, t.oldDocs, e, t.mutatedKeys, t.fromCache, t.syncStateChanged, /* excludesMetadataChanges= */ !0);
        }
        var o = !1;
        return this.Yr ? this.Zr(t) && (this.Jr.next(t), o = !0) : this.eo(t, this.onlineState) && (this.no(t), o = !0), this.Xr = t, o;
    }, t.prototype.onError = function(t) {
        this.Jr.error(t);
    }, /** Returns whether a snapshot was raised. */ t.prototype.zr = function(t) {
        this.onlineState = t;
        var e = !1;
        return this.Xr && !this.Yr && this.eo(this.Xr, t) && (this.no(this.Xr), e = !0), e;
    }, t.prototype.eo = function(t, e) {
        // Always raise the first event when we're synced
        if (!t.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        var n = "Offline" /* Offline */  !== e;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return !(this.options.so && n || t.docs.isEmpty() && "Offline" /* Offline */  !== e);
    // Raise data from cache if we have any documents or we are offline
    }, t.prototype.Zr = function(t) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (t.docChanges.length > 0) return !0;
        var e = this.Xr && this.Xr.hasPendingWrites !== t.hasPendingWrites;
        return !(!t.syncStateChanged && !e) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }, t.prototype.no = function(t) {
        t = $8cffe22d3a2884c1$var$ds.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache), this.Yr = !0, this.Jr.next(t);
    }, t;
}(), $8cffe22d3a2884c1$var$Ts = /** @class */ function() {
    function t(t, // How many bytes this element takes to store in the bundle.
    e) {
        this.payload = t, this.byteLength = e;
    }
    return t.prototype.io = function() {
        return "metadata" in this.payload;
    }, t;
}(), $8cffe22d3a2884c1$var$_s = /** @class */ function() {
    function t(t) {
        this.R = t;
    }
    return t.prototype.qn = function(t) {
        return $8cffe22d3a2884c1$var$An(this.R, t);
    }, /**
     * Converts a BundleDocument to a MutableDocument.
     */ t.prototype.Un = function(t) {
        return t.metadata.exists ? $8cffe22d3a2884c1$var$On(this.R, t.document, !1) : $8cffe22d3a2884c1$var$Nt.newNoDocument(this.qn(t.metadata.name), this.Kn(t.metadata.readTime));
    }, t.prototype.Kn = function(t) {
        return $8cffe22d3a2884c1$var$En(t);
    }, t;
}(), $8cffe22d3a2884c1$var$Es = /** @class */ function() {
    function t(t, e, n) {
        this.ro = t, this.localStore = e, this.R = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], this.progress = $8cffe22d3a2884c1$var$Ss(t) /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ ;
    }
    return t.prototype.oo = function(t) {
        this.progress.bytesLoaded += t.byteLength;
        var e = this.progress.documentsLoaded;
        return t.payload.namedQuery ? this.queries.push(t.payload.namedQuery) : t.payload.documentMetadata ? (this.documents.push({
            metadata: t.payload.documentMetadata
        }), t.payload.documentMetadata.exists || ++e) : t.payload.document && (this.documents[this.documents.length - 1].document = t.payload.document, ++e), e !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = e, Object.assign({}, this.progress)) : null;
    }, t.prototype.co = function(t) {
        for(var e = new Map, n = new $8cffe22d3a2884c1$var$_s(this.R), r = 0, i = t; r < i.length; r++){
            var o = i[r];
            if (o.metadata.queries) for(var s = n.qn(o.metadata.name), u = 0, a = o.metadata.queries; u < a.length; u++){
                var c = a[u], h = (e.get(c) || $8cffe22d3a2884c1$var$sn()).add(s);
                e.set(c, h);
            }
        }
        return e;
    }, /**
     * Update the progress to 'Success' and return the updated progress.
     */ t.prototype.complete = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e, n, i, o;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Zi(this.localStore, new $8cffe22d3a2884c1$var$_s(this.R), this.documents, this.ro.id)
                        ];
                    case 1:
                        t = r.sent(), e = this.co(this.documents), n = 0, i = this.queries, r.label = 2;
                    case 2:
                        return n < i.length ? (o = i[n], [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$to(this.localStore, o, e.get(o.name))
                        ]) : [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        r.sent(), r.label = 4;
                    case 4:
                        return n++, [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            (this.progress.taskState = "Success", new $8cffe22d3a2884c1$var$Pi(Object.assign({}, this.progress), t))
                        ];
                }
            });
        });
    }, t;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ /**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $8cffe22d3a2884c1$var$Ss(t) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: t.totalDocuments,
        totalBytes: t.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8cffe22d3a2884c1$var$Ns = function(t) {
    this.key = t;
}, $8cffe22d3a2884c1$var$Ds = function(t) {
    this.key = t;
}, $8cffe22d3a2884c1$var$As = /** @class */ function() {
    function t(t, /** Documents included in the remote target */ e) {
        this.query = t, this.uo = e, this.ao = null, /**
             * A flag whether the view is current with the backend. A view is considered
             * current after it has seen the current flag from the backend and did not
             * lose consistency within the watch stream (e.g. because of an existence
             * filter mismatch).
             */ this.current = !1, /** Documents in the view but not in the remote target */ this.ho = $8cffe22d3a2884c1$var$sn(), /** Document Keys that have local changes */ this.mutatedKeys = $8cffe22d3a2884c1$var$sn(), this.lo = $8cffe22d3a2884c1$var$ae(t), this.fo = new $8cffe22d3a2884c1$var$fs(this.lo);
    }
    return Object.defineProperty(t.prototype, "wo", {
        /**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */ get: function() {
            return this.uo;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ t.prototype._o = function(t, e) {
        var n = this, r = e ? e.mo : new $8cffe22d3a2884c1$var$ls, i = e ? e.fo : this.fo, o = e ? e.mutatedKeys : this.mutatedKeys, s = i, u = !1, a = $8cffe22d3a2884c1$var$$t(this.query) && i.size === this.query.limit ? i.last() : null, c = $8cffe22d3a2884c1$var$Xt(this.query) && i.size === this.query.limit ? i.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (t.inorderTraversal(function(t, e) {
            var h = i.get(t), f = $8cffe22d3a2884c1$var$ue(n.query, e) ? e : null, l = !!h && n.mutatedKeys.has(h.key), d = !!f && (f.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            n.mutatedKeys.has(f.key) && f.hasCommittedMutations), p = !1;
            // Calculate change
            h && f ? h.data.isEqual(f.data) ? l !== d && (r.track({
                type: 3 /* Metadata */ ,
                doc: f
            }), p = !0) : n.yo(h, f) || (r.track({
                type: 2 /* Modified */ ,
                doc: f
            }), p = !0, (a && n.lo(f, a) > 0 || c && n.lo(f, c) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (u = !0)) : !h && f ? (r.track({
                type: 0 /* Added */ ,
                doc: f
            }), p = !0) : h && !f && (r.track({
                type: 1 /* Removed */ ,
                doc: h
            }), p = !0, (a || c) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (u = !0)), p && (f ? (s = s.add(f), o = d ? o.add(t) : o.delete(t)) : (s = s.delete(t), o = o.delete(t)));
        }), $8cffe22d3a2884c1$var$$t(this.query) || $8cffe22d3a2884c1$var$Xt(this.query)) for(; s.size > this.query.limit;){
            var h = $8cffe22d3a2884c1$var$$t(this.query) ? s.last() : s.first();
            s = s.delete(h.key), o = o.delete(h.key), r.track({
                type: 1 /* Removed */ ,
                doc: h
            });
        }
        return {
            fo: s,
            mo: r,
            Nn: u,
            mutatedKeys: o
        };
    }, t.prototype.yo = function(t, e) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return t.hasLocalMutations && e.hasCommittedMutations && !e.hasLocalMutations;
    }, /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    t.prototype.applyChanges = function(t, e, n) {
        var r = this, i = this.fo;
        this.fo = t.fo, this.mutatedKeys = t.mutatedKeys;
        // Sort changes based on type and query comparator
        var o = t.mo.jr();
        o.sort(function(t, e) {
            return function(t, e) {
                var n = function(t) {
                    switch(t){
                        case 0 /* Added */ :
                            return 1;
                        case 2 /* Modified */ :
                        case 3 /* Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* Removed */ :
                            return 0;
                        default:
                            return $8cffe22d3a2884c1$var$O();
                    }
                };
                return n(t) - n(e);
            }(t.type, e.type) || r.lo(t.doc, e.doc);
        }), this.po(n);
        var s = e ? this.Eo() : [], u = 0 === this.ho.size && this.current ? 1 /* Synced */  : 0 /* Local */ , a = u !== this.ao;
        return this.ao = u, 0 !== o.length || a ? {
            snapshot: new $8cffe22d3a2884c1$var$ds(this.query, t.fo, i, o, t.mutatedKeys, 0 /* Local */  === u, a, /* excludesMetadataChanges= */ !1),
            To: s
        } : {
            To: s
        };
    // no changes
    }, /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ t.prototype.zr = function(t) {
        return this.current && "Offline" /* Offline */  === t ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            fo: this.fo,
            mo: new $8cffe22d3a2884c1$var$ls,
            mutatedKeys: this.mutatedKeys,
            Nn: !1
        }, /* updateLimboDocuments= */ !1)) : {
            To: []
        };
    }, /**
     * Returns whether the doc for the given key should be in limbo.
     */ t.prototype.Io = function(t) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.uo.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.fo.has(t) && !this.fo.get(t).hasLocalMutations;
    }, /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ t.prototype.po = function(t) {
        var e = this;
        t && (t.addedDocuments.forEach(function(t) {
            return e.uo = e.uo.add(t);
        }), t.modifiedDocuments.forEach(function(t) {}), t.removedDocuments.forEach(function(t) {
            return e.uo = e.uo.delete(t);
        }), this.current = t.current);
    }, t.prototype.Eo = function() {
        var t = this;
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var e = this.ho;
        this.ho = $8cffe22d3a2884c1$var$sn(), this.fo.forEach(function(e) {
            t.Io(e.key) && (t.ho = t.ho.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        var n = [];
        return e.forEach(function(e) {
            t.ho.has(e) || n.push(new $8cffe22d3a2884c1$var$Ds(e));
        }), this.ho.forEach(function(t) {
            e.has(t) || n.push(new $8cffe22d3a2884c1$var$Ns(t));
        }), n;
    }, /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.Ao = function(t) {
        this.uo = t.Bn, this.ho = $8cffe22d3a2884c1$var$sn();
        var e = this._o(t.documents);
        return this.applyChanges(e, /*updateLimboDocuments=*/ !0);
    }, /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.Ro = function() {
        return $8cffe22d3a2884c1$var$ds.fromInitialDocuments(this.query, this.fo, this.mutatedKeys, 0 /* Local */  === this.ao);
    }, t;
}(), $8cffe22d3a2884c1$var$ks = function(/**
     * The query itself.
     */ t, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ e, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n) {
    this.query = t, this.targetId = e, this.view = n;
}, $8cffe22d3a2884c1$var$Cs = function(t) {
    this.key = t, /**
             * Set to true once we've received a document. This is used in
             * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
             * decide whether it needs to manufacture a delete event for the target once
             * the target is CURRENT.
             */ this.bo = !1;
}, $8cffe22d3a2884c1$var$xs = /** @class */ function() {
    function t(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, o) {
        this.localStore = t, this.remoteStore = e, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = o, this.vo = {}, this.Po = new $8cffe22d3a2884c1$var$Ii(function(t) {
            return $8cffe22d3a2884c1$var$oe(t);
        }, $8cffe22d3a2884c1$var$ie), this.Vo = new Map, /**
             * The keys of documents that are in limbo for which we haven't yet started a
             * limbo resolution query. The strings in this set are the result of calling
             * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
             *
             * The `Set` type was chosen because it provides efficient lookup and removal
             * of arbitrary elements and it also maintains insertion order, providing the
             * desired queue-like FIFO semantics.
             */ this.So = new Set, /**
             * Keeps track of the target ID for each document that is in limbo with an
             * active target.
             */ this.Do = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator), /**
             * Keeps track of the information about an active limbo resolution for each
             * active target ID that was started for the purpose of limbo resolution.
             */ this.Co = new Map, this.No = new $8cffe22d3a2884c1$var$no, /** Stores user completion handlers, indexed by User and BatchId. */ this.xo = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.ko = new Map, this.Fo = $8cffe22d3a2884c1$var$ci.Yt(), this.onlineState = "Unknown" /* Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.$o = void 0;
    }
    return Object.defineProperty(t.prototype, "isPrimaryClient", {
        get: function() {
            return !0 === this.$o;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}();
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ function $8cffe22d3a2884c1$var$Rs(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o, s, u, a;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return n = $8cffe22d3a2884c1$var$uu(t), (s = n.Po.get(e)) ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                    // already exists when EventManager calls us for the first time. This
                    // happens when the primary tab is already listening to this query on
                    // behalf of another tab and the user of the primary also starts listening
                    // to the query. EventManager will not have an assigned target ID in this
                    // case and calls `listen` to obtain this ID.
                    (i = s.targetId, n.sharedClientState.addLocalQueryTarget(i), o = s.view.Ro(), [
                        3 /*break*/ ,
                        4
                    ]) : [
                        3 /*break*/ ,
                        1
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Wi(n.localStore, $8cffe22d3a2884c1$var$ne(e))
                    ];
                case 2:
                    return u = r.sent(), a = n.sharedClientState.addLocalQueryTarget(u.targetId), i = u.targetId, [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ls(n, e, i, "current" === a)
                    ];
                case 3:
                    o = r.sent(), n.isPrimaryClient && $8cffe22d3a2884c1$var$Uo(n.remoteStore, u), r.label = 4;
                case 4:
                    return [
                        2 /*return*/ ,
                        o
                    ];
            }
        });
    });
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ function $8cffe22d3a2884c1$var$Ls(t, e, i, o) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var s, u, a, c, h, f;
        return (0, $2WUgS.__generator)(this, function(l) {
            switch(l.label){
                case 0:
                    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
                    // targets based on view changes. This allows us to only depend on Limbo
                    // changes when user code includes queries.
                    return t.Oo = function(e, i, o) {
                        return function(t, e, i, o) {
                            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                var n, s, u;
                                return (0, $2WUgS.__generator)(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            return n = e.view._o(i), n.Nn ? [
                                                4 /*yield*/ ,
                                                $8cffe22d3a2884c1$var$Yi(t.localStore, e.query, /* usePreviousResults= */ !1).then(function(t) {
                                                    var r = t.documents;
                                                    return e.view._o(r, n);
                                                })
                                            ] : [
                                                3 /*break*/ ,
                                                2
                                            ];
                                        case 1:
                                            // The query has a limit and some docs were removed, so we need
                                            // to re-run the query against the local store to make sure we
                                            // didn't lose any good docs that had been past the limit.
                                            n = r.sent(), r.label = 2;
                                        case 2:
                                            return s = o && o.targetChanges.get(e.targetId), u = e.view.applyChanges(n, /* updateLimboDocuments= */ t.isPrimaryClient, s), [
                                                2 /*return*/ ,
                                                ($8cffe22d3a2884c1$var$zs(t, e.targetId, u.To), u.snapshot)
                                            ];
                                    }
                                });
                            });
                        }(t, e, i, o);
                    }, [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Yi(t.localStore, e, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    return s = l.sent(), u = new $8cffe22d3a2884c1$var$As(e, s.Bn), a = u._o(s.documents), c = $8cffe22d3a2884c1$var$hn.createSynthesizedTargetChangeForCurrentChange(i, o && "Offline" /* Offline */  !== t.onlineState), h = u.applyChanges(a, /* updateLimboDocuments= */ t.isPrimaryClient, c), $8cffe22d3a2884c1$var$zs(t, i, h.To), f = new $8cffe22d3a2884c1$var$ks(e, i, u), [
                        2 /*return*/ ,
                        (t.Po.set(e, f), t.Vo.has(i) ? t.Vo.get(i).push(e) : t.Vo.set(i, [
                            e
                        ]), h.snapshot)
                    ];
            }
        });
    });
}
/** Stops listening to the query. */ function $8cffe22d3a2884c1$var$Os(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return n = $8cffe22d3a2884c1$var$F(t), i = n.Po.get(e), (o = n.Vo.get(i.targetId)).length > 1 ? [
                        2 /*return*/ ,
                        (n.Vo.set(i.targetId, o.filter(function(t) {
                            return !$8cffe22d3a2884c1$var$ie(t, e);
                        })), void n.Po.delete(e))
                    ] : n.isPrimaryClient ? // We need to remove the local query target first to allow us to verify
                    // whether any other client is still interested in this target.
                    (n.sharedClientState.removeLocalQueryTarget(i.targetId), n.sharedClientState.isActiveQueryTarget(i.targetId) ? [
                        3 /*break*/ ,
                        2
                    ] : [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Hi(n.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(function() {
                            n.sharedClientState.clearQueryState(i.targetId), $8cffe22d3a2884c1$var$Bo(n.remoteStore, i.targetId), $8cffe22d3a2884c1$var$Gs(n, i.targetId);
                        }).catch($8cffe22d3a2884c1$var$pi)
                    ]) : [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    r.sent(), r.label = 2;
                case 2:
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 3:
                    return $8cffe22d3a2884c1$var$Gs(n, i.targetId), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Hi(n.localStore, i.targetId, /*keepPersistedTargetData=*/ !0)
                    ];
                case 4:
                    r.sent(), r.label = 5;
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ function $8cffe22d3a2884c1$var$Ps(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, o, s, u;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    n = $8cffe22d3a2884c1$var$au(t), r.label = 1;
                case 1:
                    return r.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        function(t, e) {
                            var n, r = $8cffe22d3a2884c1$var$F(t), i = $8cffe22d3a2884c1$export$3a1a48c8f6ef640e.now(), o = e.reduce(function(t, e) {
                                return t.add(e.key);
                            }, $8cffe22d3a2884c1$var$sn());
                            return r.persistence.runTransaction("Locally write mutations", "readwrite", function(t) {
                                return r.Mn.pn(t, o).next(function(o) {
                                    n = o;
                                    for(// For non-idempotent mutations (such as `FieldValue.increment()`),
                                    // we record the base state in a separate patch mutation. This is
                                    // later used to guarantee consistent values and prevents flicker
                                    // even if the backend sends us an update that already includes our
                                    // transform.
                                    var s = [], u = 0, a = e; u < a.length; u++){
                                        var c = a[u], h = $8cffe22d3a2884c1$var$Re(c, n.get(c.key));
                                        null != h && // NOTE: The base state should only be applied if there's some
                                        // existing document to override, so use a Precondition of
                                        // exists=true
                                        s.push(new $8cffe22d3a2884c1$var$Fe(c.key, h, $8cffe22d3a2884c1$var$St(h.value.mapValue), $8cffe22d3a2884c1$var$De.exists(!0)));
                                    }
                                    return r._n.addMutationBatch(t, i, s, e);
                                });
                            }).then(function(t) {
                                return t.applyToLocalDocumentSet(n), {
                                    batchId: t.batchId,
                                    changes: n
                                };
                            });
                        }(n.localStore, e)
                    ];
                case 2:
                    return o = r.sent(), n.sharedClientState.addPendingMutation(o.batchId), function(t, e, n) {
                        var r = t.xo[t.currentUser.toKey()];
                        r || (r = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$q)), r = r.insert(e, n), t.xo[t.currentUser.toKey()] = r;
                    }(n, o.batchId, i), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ys(n, o.changes)
                    ];
                case 3:
                    return r.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Zo(n.remoteStore)
                    ];
                case 4:
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    return s = r.sent(), u = $8cffe22d3a2884c1$var$hs(s, "Failed to persist write"), i.reject(u), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ function $8cffe22d3a2884c1$var$Fs(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    n = $8cffe22d3a2884c1$var$F(t), r.label = 1;
                case 1:
                    return r.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Gi(n.localStore, e)
                    ];
                case 2:
                    return i = r.sent(), // Update `receivedDocument` as appropriate for any limbo targets.
                    e.targetChanges.forEach(function(t, e) {
                        var r = n.Co.get(e);
                        r && // Since this is a limbo resolution lookup, it's for a single document
                        // and it could be added, modified, or removed, but not a combination.
                        ($8cffe22d3a2884c1$var$P(t.addedDocuments.size + t.modifiedDocuments.size + t.removedDocuments.size <= 1), t.addedDocuments.size > 0 ? r.bo = !0 : t.modifiedDocuments.size > 0 ? $8cffe22d3a2884c1$var$P(r.bo) : t.removedDocuments.size > 0 && ($8cffe22d3a2884c1$var$P(r.bo), r.bo = !1));
                    }), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ys(n, i, e)
                    ];
                case 3:
                    // Update `receivedDocument` as appropriate for any limbo targets.
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$pi(r.sent())
                    ];
                case 5:
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $8cffe22d3a2884c1$var$Ms(t, e, n) {
    var r = $8cffe22d3a2884c1$var$F(t);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* RemoteStore */  === n || !r.isPrimaryClient && 1 /* SharedClientState */  === n) {
        var i = [];
        r.Po.forEach(function(t, n) {
            var r = n.view.zr(e);
            r.snapshot && i.push(r.snapshot);
        }), function(t, e) {
            var n = $8cffe22d3a2884c1$var$F(t);
            n.onlineState = e;
            var r = !1;
            n.queries.forEach(function(t, n) {
                for(var i = 0, o = n.listeners; i < o.length; i++)// Run global snapshot listeners if a consistent snapshot has been emitted.
                o[i].zr(e) && (r = !0);
            }), r && $8cffe22d3a2884c1$var$bs(n);
        }(r.eventManager, e), i.length && r.vo._r(i), r.onlineState = e, r.isPrimaryClient && r.sharedClientState.setOnlineState(e);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ function $8cffe22d3a2884c1$var$Vs(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, o, s, u, a, c;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    // PORTING NOTE: Multi-tab only.
                    return (n = $8cffe22d3a2884c1$var$F(t)).sharedClientState.updateQueryState(e, "rejected", i), o = n.Co.get(e), (s = o && o.key) ? (u = (u = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator)).insert(s, $8cffe22d3a2884c1$var$Nt.newNoDocument(s, $8cffe22d3a2884c1$var$K.min())), a = $8cffe22d3a2884c1$var$sn().add(s), c = new $8cffe22d3a2884c1$var$cn($8cffe22d3a2884c1$var$K.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $8cffe22d3a2884c1$var$$e($8cffe22d3a2884c1$var$q), u, a), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Fs(n, c)
                    ]) : [
                        3 /*break*/ ,
                        2
                    ];
                case 1:
                    return r.sent(), // Since this query failed, we won't want to manually unlisten to it.
                    // We only remove it from bookkeeping after we successfully applied the
                    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
                    // this query when the RemoteStore restarts the Watch stream, which should
                    // re-trigger the target failure.
                    n.Do = n.Do.remove(s), n.Co.delete(e), $8cffe22d3a2884c1$var$Hs(n), [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Hi(n.localStore, e, /* keepPersistedTargetData */ !1).then(function() {
                            return $8cffe22d3a2884c1$var$Gs(n, e, i);
                        }).catch($8cffe22d3a2884c1$var$pi)
                    ];
                case 3:
                    r.sent(), r.label = 4;
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$qs(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    n = $8cffe22d3a2884c1$var$F(t), i = e.batch.batchId, r.label = 1;
                case 1:
                    return r.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$ji(n.localStore, e)
                    ];
                case 2:
                    return o = r.sent(), // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught
                    // up), so we raise user callbacks first so that they consistently happen
                    // before listen events.
                    $8cffe22d3a2884c1$var$Ks(n, i, /*error=*/ null), $8cffe22d3a2884c1$var$js(n, i), n.sharedClientState.updateMutationState(i, "acknowledged"), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ys(n, o)
                    ];
                case 3:
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught
                    // up), so we raise user callbacks first so that they consistently happen
                    // before listen events.
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$pi(r.sent())
                    ];
                case 5:
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$Us(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, o;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    n = $8cffe22d3a2884c1$var$F(t), r.label = 1;
                case 1:
                    return r.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]), [
                        4 /*yield*/ ,
                        function(t, e) {
                            var n = $8cffe22d3a2884c1$var$F(t);
                            return n.persistence.runTransaction("Reject batch", "readwrite-primary", function(t) {
                                var r;
                                return n._n.lookupMutationBatch(t, e).next(function(e) {
                                    return $8cffe22d3a2884c1$var$P(null !== e), r = e.keys(), n._n.removeMutationBatch(t, e);
                                }).next(function() {
                                    return n._n.performConsistencyCheck(t);
                                }).next(function() {
                                    return n.Mn.pn(t, r);
                                });
                            });
                        }(n.localStore, e)
                    ];
                case 2:
                    return o = r.sent(), // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught up),
                    // so we raise user callbacks first so that they consistently happen before
                    // listen events.
                    $8cffe22d3a2884c1$var$Ks(n, e, i), $8cffe22d3a2884c1$var$js(n, e), n.sharedClientState.updateMutationState(e, "rejected", i), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ys(n, o)
                    ];
                case 3:
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught up),
                    // so we raise user callbacks first so that they consistently happen before
                    // listen events.
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$pi(r.sent())
                    ];
                case 5:
                    return r.sent(), [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ function $8cffe22d3a2884c1$var$Bs(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o, s, u;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    $8cffe22d3a2884c1$var$zo((n = $8cffe22d3a2884c1$var$F(t)).remoteStore) || $8cffe22d3a2884c1$var$C("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled."), r.label = 1;
                case 1:
                    return r.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), [
                        4 /*yield*/ ,
                        function(t) {
                            var e = $8cffe22d3a2884c1$var$F(t);
                            return e.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function(t) {
                                return e._n.getHighestUnacknowledgedBatchId(t);
                            });
                        }(n.localStore)
                    ];
                case 2:
                    return -1 === (i = r.sent()) ? [
                        2 /*return*/ ,
                        void e.resolve()
                    ] : ((o = n.ko.get(i) || []).push(e), n.ko.set(i, o), [
                        3 /*break*/ ,
                        4
                    ]);
                case 3:
                    return s = r.sent(), u = $8cffe22d3a2884c1$var$hs(s, "Initialization of waitForPendingWrites() operation failed"), e.reject(u), [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $8cffe22d3a2884c1$var$js(t, e) {
    (t.ko.get(e) || []).forEach(function(t) {
        t.resolve();
    }), t.ko.delete(e) /** Reject all outstanding callbacks waiting for pending writes to complete. */ ;
}
function $8cffe22d3a2884c1$var$Ks(t, e, n) {
    var r = $8cffe22d3a2884c1$var$F(t), i = r.xo[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        var o = i.get(e);
        o && (n ? o.reject(n) : o.resolve(), i = i.remove(e)), r.xo[r.currentUser.toKey()] = i;
    }
}
function $8cffe22d3a2884c1$var$Gs(t, e, n) {
    void 0 === n && (n = null), t.sharedClientState.removeLocalQueryTarget(e);
    for(var r = 0, i = t.Vo.get(e); r < i.length; r++){
        var o = i[r];
        t.Po.delete(o), n && t.vo.Mo(o, n);
    }
    t.Vo.delete(e), t.isPrimaryClient && t.No.Zn(e).forEach(function(e) {
        t.No.containsKey(e) || // We removed the last reference for this key
        $8cffe22d3a2884c1$var$Qs(t, e);
    });
}
function $8cffe22d3a2884c1$var$Qs(t, e) {
    t.So.delete(e.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    var n = t.Do.get(e);
    null !== n && ($8cffe22d3a2884c1$var$Bo(t.remoteStore, n), t.Do = t.Do.remove(e), t.Co.delete(n), $8cffe22d3a2884c1$var$Hs(t));
}
function $8cffe22d3a2884c1$var$zs(t, e, n) {
    for(var r = 0, i = n; r < i.length; r++){
        var o = i[r];
        o instanceof $8cffe22d3a2884c1$var$Ns ? (t.No.addReference(o.key, e), $8cffe22d3a2884c1$var$Ws(t, o)) : o instanceof $8cffe22d3a2884c1$var$Ds ? ($8cffe22d3a2884c1$var$C("SyncEngine", "Document no longer in limbo: " + o.key), t.No.removeReference(o.key, e), t.No.containsKey(o.key) || // We removed the last reference for this key
        $8cffe22d3a2884c1$var$Qs(t, o.key)) : $8cffe22d3a2884c1$var$O();
    }
}
function $8cffe22d3a2884c1$var$Ws(t, e) {
    var n = e.key, r = n.path.canonicalString();
    t.Do.get(n) || t.So.has(r) || ($8cffe22d3a2884c1$var$C("SyncEngine", "New document in limbo: " + n), t.So.add(r), $8cffe22d3a2884c1$var$Hs(t));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $8cffe22d3a2884c1$var$Hs(t) {
    for(; t.So.size > 0 && t.Do.size < t.maxConcurrentLimboResolutions;){
        var e = t.So.values().next().value;
        t.So.delete(e);
        var n = new $8cffe22d3a2884c1$var$ct($8cffe22d3a2884c1$var$H.fromString(e)), r = t.Fo.next();
        t.Co.set(r, new $8cffe22d3a2884c1$var$Cs(n)), t.Do = t.Do.insert(n, r), $8cffe22d3a2884c1$var$Uo(t.remoteStore, new $8cffe22d3a2884c1$var$Pr($8cffe22d3a2884c1$var$ne($8cffe22d3a2884c1$var$Yt(n.path)), r, 2 /* LimboResolution */ , $8cffe22d3a2884c1$var$S.o));
    }
}
function $8cffe22d3a2884c1$var$Ys(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var o, s, u, a;
        return (0, $2WUgS.__generator)(this, function(c) {
            switch(c.label){
                case 0:
                    return o = $8cffe22d3a2884c1$var$F(t), s = [], u = [], a = [], o.Po.isEmpty() ? [
                        3 /*break*/ ,
                        3
                    ] : (o.Po.forEach(function(t, n) {
                        a.push(o.Oo(n, e, i).then(function(t) {
                            if (t) {
                                o.isPrimaryClient && o.sharedClientState.updateQueryState(n.targetId, t.fromCache ? "not-current" : "current"), s.push(t);
                                var e = $8cffe22d3a2884c1$var$Mi.Pn(n.targetId, t);
                                u.push(e);
                            }
                        }));
                    }), [
                        4 /*yield*/ ,
                        Promise.all(a)
                    ]);
                case 1:
                    return c.sent(), o.vo._r(s), [
                        4 /*yield*/ ,
                        function(t, e) {
                            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                var n, i, o, s, u, a, c, h, f;
                                return (0, $2WUgS.__generator)(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            n = $8cffe22d3a2884c1$var$F(t), r.label = 1;
                                        case 1:
                                            return r.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]), [
                                                4 /*yield*/ ,
                                                n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function(t) {
                                                    return $8cffe22d3a2884c1$var$Ir.forEach(e, function(e) {
                                                        return $8cffe22d3a2884c1$var$Ir.forEach(e.bn, function(r) {
                                                            return n.persistence.referenceDelegate.addReference(t, e.targetId, r);
                                                        }).next(function() {
                                                            return $8cffe22d3a2884c1$var$Ir.forEach(e.vn, function(r) {
                                                                return n.persistence.referenceDelegate.removeReference(t, e.targetId, r);
                                                            });
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            return r.sent(), [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            if (!$8cffe22d3a2884c1$var$Nr(i = r.sent())) throw i;
                                            // If `notifyLocalViewChanges` fails, we did not advance the sequence
                                            // number for the documents that were included in this transaction.
                                            // This might trigger them to be deleted earlier than they otherwise
                                            // would have, but it should not invalidate the integrity of the data.
                                            return $8cffe22d3a2884c1$var$C("LocalStore", "Failed to update sequence numbers: " + i), [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            for(o = 0, s = e; o < s.length; o++)u = s[o], a = u.targetId, u.fromCache || (c = n.kn.get(a), h = c.snapshotVersion, f = c.withLastLimboFreeSnapshotVersion(h), // Advance the last limbo free snapshot version
                                            n.kn = n.kn.insert(a, f));
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }(o.localStore, u)
                    ];
                case 2:
                    c.sent(), c.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$$s(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return (n = $8cffe22d3a2884c1$var$F(t)).currentUser.isEqual(e) ? [
                        3 /*break*/ ,
                        3
                    ] : ($8cffe22d3a2884c1$var$C("SyncEngine", "User change. New user:", e.toKey()), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Bi(n.localStore, e)
                    ]);
                case 1:
                    return i = r.sent(), n.currentUser = e, // Fails tasks waiting for pending writes requested by previous user.
                    function(t, e) {
                        t.ko.forEach(function(t) {
                            t.forEach(function(t) {
                                t.reject(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.CANCELLED, "'waitForPendingWrites' promise is rejected due to a user change."));
                            });
                        }), t.ko.clear();
                    }(n), // TODO(b/114226417): Consider calling this only in the primary tab.
                    n.sharedClientState.handleUserChange(e, i.removedBatchIds, i.addedBatchIds), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ys(n, i.Ln)
                    ];
                case 2:
                    r.sent(), r.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$Xs(t, e) {
    var n = $8cffe22d3a2884c1$var$F(t), r = n.Co.get(e);
    if (r && r.bo) return $8cffe22d3a2884c1$var$sn().add(r.key);
    var i = $8cffe22d3a2884c1$var$sn(), o = n.Vo.get(e);
    if (!o) return i;
    for(var s = 0, u = o; s < u.length; s++){
        var a = u[s], c = n.Po.get(a);
        i = i.unionWith(c.view.wo);
    }
    return i;
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ function $8cffe22d3a2884c1$var$Js(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Yi((n = $8cffe22d3a2884c1$var$F(t)).localStore, e.query, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    return i = r.sent(), o = e.view.Ao(i), [
                        2 /*return*/ ,
                        (n.isPrimaryClient && $8cffe22d3a2884c1$var$zs(n, e.targetId, o.To), o)
                    ];
            }
        });
    });
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$Zs(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e;
        return (0, $2WUgS.__generator)(this, function(n) {
            return [
                2 /*return*/ ,
                $8cffe22d3a2884c1$var$Xi((e = $8cffe22d3a2884c1$var$F(t)).localStore).then(function(t) {
                    return $8cffe22d3a2884c1$var$Ys(e, t);
                })
            ];
        });
    });
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$tu(t, e, i, o) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, s;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        function(t, e) {
                            var n = $8cffe22d3a2884c1$var$F(t), r = $8cffe22d3a2884c1$var$F(n._n);
                            return n.persistence.runTransaction("Lookup mutation documents", "readonly", function(t) {
                                return r.jt(t, e).next(function(e) {
                                    return e ? n.Mn.pn(t, e) : $8cffe22d3a2884c1$var$Ir.resolve(null);
                                });
                            });
                        }((n = $8cffe22d3a2884c1$var$F(t)).localStore, e)
                    ];
                case 1:
                    return null === (s = r.sent()) ? [
                        3 /*break*/ ,
                        6
                    ] : "pending" !== i ? [
                        3 /*break*/ ,
                        3
                    ] : [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Zo(n.remoteStore)
                    ];
                case 2:
                    // If we are the primary client, we need to send this write to the
                    // backend. Secondary clients will ignore these writes since their remote
                    // connection is disabled.
                    return r.sent(), [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    "acknowledged" === i || "rejected" === i ? // NOTE: Both these methods are no-ops for batches that originated from
                    // other clients.
                    ($8cffe22d3a2884c1$var$Ks(n, e, o || null), $8cffe22d3a2884c1$var$js(n, e), function(t, e) {
                        $8cffe22d3a2884c1$var$F($8cffe22d3a2884c1$var$F(t)._n).Gt(e);
                    }(n.localStore, e)) : $8cffe22d3a2884c1$var$O(), r.label = 4;
                case 4:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ys(n, s)
                    ];
                case 5:
                    return r.sent(), [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    // A throttled tab may not have seen the mutation before it was completed
                    // and removed from the mutation queue, in which case we won't have cached
                    // the affected documents. In this case we can safely ignore the update
                    // since that means we didn't apply the mutation locally at all (if we
                    // had, we would have cached the affected documents), and so we will just
                    // see any resulting document changes via normal remote document updates
                    // as applicable.
                    $8cffe22d3a2884c1$var$C("SyncEngine", "Cannot apply mutation batch with id: " + e), r.label = 7;
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$eu(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o, s, u, a, c, h;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return $8cffe22d3a2884c1$var$uu(n = $8cffe22d3a2884c1$var$F(t)), $8cffe22d3a2884c1$var$au(n), !0 !== e || !0 === n.$o ? [
                        3 /*break*/ ,
                        3
                    ] : (i = n.sharedClientState.getAllActiveQueryTargets(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$nu(n, i.toArray())
                    ]);
                case 1:
                    return o = r.sent(), n.$o = !0, [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$ss(n.remoteStore, !0)
                    ];
                case 2:
                    for(r.sent(), s = 0, u = o; s < u.length; s++)a = u[s], $8cffe22d3a2884c1$var$Uo(n.remoteStore, a);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 3:
                    return !1 !== e || !1 === n.$o ? [
                        3 /*break*/ ,
                        7
                    ] : (c = [], h = Promise.resolve(), n.Vo.forEach(function(t, e) {
                        n.sharedClientState.isLocalQueryTarget(e) ? c.push(e) : h = h.then(function() {
                            return $8cffe22d3a2884c1$var$Gs(n, e), $8cffe22d3a2884c1$var$Hi(n.localStore, e, /*keepPersistedTargetData=*/ !0);
                        }), $8cffe22d3a2884c1$var$Bo(n.remoteStore, e);
                    }), [
                        4 /*yield*/ ,
                        h
                    ]);
                case 4:
                    return r.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$nu(n, c)
                    ];
                case 5:
                    return r.sent(), // PORTING NOTE: Multi-Tab only.
                    function(t) {
                        var e = $8cffe22d3a2884c1$var$F(t);
                        e.Co.forEach(function(t, n) {
                            $8cffe22d3a2884c1$var$Bo(e.remoteStore, n);
                        }), e.No.ts(), e.Co = new Map, e.Do = new $8cffe22d3a2884c1$var$We($8cffe22d3a2884c1$var$ct.comparator);
                    }(n), n.$o = !1, [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$ss(n.remoteStore, !1)
                    ];
                case 6:
                    r.sent(), r.label = 7;
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$nu(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, i, o, s, u, a, c, h, f, l, d, p, y, v;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    n = $8cffe22d3a2884c1$var$F(t), i = [], o = [], s = 0, u = e, r.label = 1;
                case 1:
                    return s < u.length ? (a = u[s], c = void 0, (h = n.Vo.get(a)) && 0 !== h.length ? [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Wi(n.localStore, $8cffe22d3a2884c1$var$ne(h[0]))
                    ] : [
                        3 /*break*/ ,
                        7
                    ]) : [
                        3 /*break*/ ,
                        13
                    ];
                case 2:
                    // For queries that have a local View, we fetch their current state
                    // from LocalStore (as the resume token and the snapshot version
                    // might have changed) and reconcile their views with the persisted
                    // state (the list of syncedDocuments may have gotten out of sync).
                    c = r.sent(), f = 0, l = h, r.label = 3;
                case 3:
                    return f < l.length ? (d = l[f], p = n.Po.get(d), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Js(n, p)
                    ]) : [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    (y = r.sent()).snapshot && o.push(y.snapshot), r.label = 5;
                case 5:
                    return f++, [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 7:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$$i(n.localStore, a)
                    ];
                case 8:
                    return v = r.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Wi(n.localStore, v)
                    ];
                case 9:
                    return c = r.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ls(n, $8cffe22d3a2884c1$var$ru(v), a, /*current=*/ !1)
                    ];
                case 10:
                    r.sent(), r.label = 11;
                case 11:
                    i.push(c), r.label = 12;
                case 12:
                    return s++, [
                        3 /*break*/ ,
                        1
                    ];
                case 13:
                    return [
                        2 /*return*/ ,
                        (n.vo._r(o), i)
                    ];
            }
        });
    });
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$ru(t) {
    return $8cffe22d3a2884c1$var$Ht(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* First */ , t.startAt, t.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$iu(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    return $8cffe22d3a2884c1$var$F($8cffe22d3a2884c1$var$F(e.localStore).persistence).fn();
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
function $8cffe22d3a2884c1$var$ou(t, e, i, o) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, s, u;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return (n = $8cffe22d3a2884c1$var$F(t)).$o ? // If we receive a target state notification via WebStorage, we are
                    // either already secondary or another tab has taken the primary lease.
                    ($8cffe22d3a2884c1$var$C("SyncEngine", "Ignoring unexpected query state notification."), [
                        3 /*break*/ ,
                        8
                    ]) : [
                        3 /*break*/ ,
                        1
                    ];
                case 1:
                    if (!n.Vo.has(e)) return [
                        3 /*break*/ ,
                        8
                    ];
                    switch(i){
                        case "current":
                        case "not-current":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "rejected":
                            return [
                                3 /*break*/ ,
                                5
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Xi(n.localStore)
                    ];
                case 3:
                    return s = r.sent(), u = $8cffe22d3a2884c1$var$cn.createSynthesizedRemoteEventForCurrentChange(e, "current" === i), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ys(n, s, u)
                    ];
                case 4:
                    return r.sent(), [
                        3 /*break*/ ,
                        8
                    ];
                case 5:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Hi(n.localStore, e, /* keepPersistedTargetData */ !0)
                    ];
                case 6:
                    return r.sent(), $8cffe22d3a2884c1$var$Gs(n, e, o), [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    $8cffe22d3a2884c1$var$O(), r.label = 8;
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/** Adds or removes Watch targets for queries from different tabs. */ function $8cffe22d3a2884c1$var$su(t, e, i) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var n, o, s, u, a, c, h, f, l, d;
        return (0, $2WUgS.__generator)(this, function(p) {
            switch(p.label){
                case 0:
                    if (!(n = $8cffe22d3a2884c1$var$uu(t)).$o) return [
                        3 /*break*/ ,
                        10
                    ];
                    o = 0, s = e, p.label = 1;
                case 1:
                    return o < s.length ? (u = s[o], n.Vo.has(u) ? // A target might have been added in a previous attempt
                    ($8cffe22d3a2884c1$var$C("SyncEngine", "Adding an already active target " + u), [
                        3 /*break*/ ,
                        5
                    ]) : [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$$i(n.localStore, u)
                    ]) : [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    return a = p.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Wi(n.localStore, a)
                    ];
                case 3:
                    return c = p.sent(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Ls(n, $8cffe22d3a2884c1$var$ru(a), c.targetId, /*current=*/ !1)
                    ];
                case 4:
                    p.sent(), $8cffe22d3a2884c1$var$Uo(n.remoteStore, c), p.label = 5;
                case 5:
                    return o++, [
                        3 /*break*/ ,
                        1
                    ];
                case 6:
                    h = function(t) {
                        return (0, $2WUgS.__generator)(this, function(e) {
                            switch(e.label){
                                case 0:
                                    return n.Vo.has(t) ? [
                                        4 /*yield*/ ,
                                        $8cffe22d3a2884c1$var$Hi(n.localStore, t, /* keepPersistedTargetData */ !1).then(function() {
                                            $8cffe22d3a2884c1$var$Bo(n.remoteStore, t), $8cffe22d3a2884c1$var$Gs(n, t);
                                        }).catch($8cffe22d3a2884c1$var$pi)
                                    ] : [
                                        3 /*break*/ ,
                                        2
                                    ];
                                // Release queries that are still active.
                                case 1:
                                    // Release queries that are still active.
                                    e.sent(), e.label = 2;
                                case 2:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    }, f = 0, l = i, p.label = 7;
                case 7:
                    return f < l.length ? (d = l[f], [
                        5 /*yield**/ ,
                        h(d)
                    ]) : [
                        3 /*break*/ ,
                        10
                    ];
                case 8:
                    p.sent(), p.label = 9;
                case 9:
                    return f++, [
                        3 /*break*/ ,
                        7
                    ];
                case 10:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$uu(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    return e.remoteStore.remoteSyncer.applyRemoteEvent = $8cffe22d3a2884c1$var$Fs.bind(null, e), e.remoteStore.remoteSyncer.getRemoteKeysForTarget = $8cffe22d3a2884c1$var$Xs.bind(null, e), e.remoteStore.remoteSyncer.rejectListen = $8cffe22d3a2884c1$var$Vs.bind(null, e), e.vo._r = $8cffe22d3a2884c1$var$gs.bind(null, e.eventManager), e.vo.Mo = $8cffe22d3a2884c1$var$ws.bind(null, e.eventManager), e;
}
function $8cffe22d3a2884c1$var$au(t) {
    var e = $8cffe22d3a2884c1$var$F(t);
    return e.remoteStore.remoteSyncer.applySuccessfulWrite = $8cffe22d3a2884c1$var$qs.bind(null, e), e.remoteStore.remoteSyncer.rejectFailedWrite = $8cffe22d3a2884c1$var$Us.bind(null, e), e /**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ ;
}
function $8cffe22d3a2884c1$var$cu(t, e, i) {
    var o = $8cffe22d3a2884c1$var$F(t);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (function(t, e, i) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var n, o, s, u, a, c;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return r.trys.push([
                            0,
                            14,
                            ,
                            15
                        ]), [
                            4 /*yield*/ ,
                            e.getMetadata()
                        ];
                    case 1:
                        return n = r.sent(), [
                            4 /*yield*/ ,
                            function(t, e) {
                                var n = $8cffe22d3a2884c1$var$F(t), r = $8cffe22d3a2884c1$var$En(e.createTime);
                                return n.persistence.runTransaction("hasNewerBundle", "readonly", function(t) {
                                    return n.Ke.getBundleMetadata(t, e.id);
                                }).then(function(t) {
                                    return !!t && t.createTime.compareTo(r) >= 0;
                                });
                            }(t.localStore, n)
                        ];
                    case 2:
                        return r.sent() ? [
                            4 /*yield*/ ,
                            e.close()
                        ] : [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (r.sent(), void i._completeWith(function(t) {
                                return {
                                    taskState: "Success",
                                    documentsLoaded: t.totalDocuments,
                                    bytesLoaded: t.totalBytes,
                                    totalDocuments: t.totalDocuments,
                                    totalBytes: t.totalBytes
                                };
                            }(n)))
                        ];
                    case 4:
                        return i._updateProgress($8cffe22d3a2884c1$var$Ss(n)), o = new $8cffe22d3a2884c1$var$Es(n, t.localStore, e.R), [
                            4 /*yield*/ ,
                            e.Lo()
                        ];
                    case 5:
                        s = r.sent(), r.label = 6;
                    case 6:
                        return s ? [
                            4 /*yield*/ ,
                            o.oo(s)
                        ] : [
                            3 /*break*/ ,
                            10
                        ];
                    case 7:
                        return (u = r.sent()) && i._updateProgress(u), [
                            4 /*yield*/ ,
                            e.Lo()
                        ];
                    case 8:
                        s = r.sent(), r.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            o.complete()
                        ];
                    case 11:
                        // TODO(b/160876443): This currently raises snapshots with
                        // `fromCache=false` if users already listen to some queries and bundles
                        // has newer version.
                        return a = r.sent(), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Ys(t, a.wn, /* remoteEvent */ void 0)
                        ];
                    case 12:
                        // Save metadata, so loading the same bundle will skip.
                        // TODO(b/160876443): This currently raises snapshots with
                        // `fromCache=false` if users already listen to some queries and bundles
                        // has newer version.
                        return r.sent(), [
                            4 /*yield*/ ,
                            function(t, e) {
                                var n = $8cffe22d3a2884c1$var$F(t);
                                return n.persistence.runTransaction("Save bundle", "readwrite", function(t) {
                                    return n.Ke.saveBundleMetadata(t, e);
                                });
                            }(t.localStore, n)
                        ];
                    case 13:
                        // TODO(b/160876443): This currently raises snapshots with
                        // `fromCache=false` if users already listen to some queries and bundles
                        // has newer version.
                        // Save metadata, so loading the same bundle will skip.
                        return r.sent(), i._completeWith(a.progress), [
                            3 /*break*/ ,
                            15
                        ];
                    case 14:
                        return $8cffe22d3a2884c1$var$R("SyncEngine", "Loading bundle failed with " + (c = r.sent())), i._failWith(c), [
                            3 /*break*/ ,
                            15
                        ];
                    case 15:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    })(o, e, i).then(function() {
        o.sharedClientState.notifyBundleLoaded();
    });
}
var $8cffe22d3a2884c1$var$hu = /** @class */ function() {
    function t() {
        this.synchronizeTabs = !1;
    }
    return t.prototype.initialize = function(t) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.R = $8cffe22d3a2884c1$var$Co(t.databaseInfo.databaseId), this.sharedClientState = this.Bo(t), this.persistence = this.qo(t), [
                            4 /*yield*/ ,
                            this.persistence.start()
                        ];
                    case 1:
                        return e.sent(), this.gcScheduler = this.Uo(t), this.localStore = this.Ko(t), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.Uo = function(t) {
        return null;
    }, t.prototype.Ko = function(t) {
        return $8cffe22d3a2884c1$var$Ui(this.persistence, new $8cffe22d3a2884c1$var$Vi, t.initialUser, this.R);
    }, t.prototype.qo = function(t) {
        return new $8cffe22d3a2884c1$var$ao($8cffe22d3a2884c1$var$ho.bs, this.R);
    }, t.prototype.Bo = function(t) {
        return new $8cffe22d3a2884c1$var$To;
    }, t.prototype.terminate = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.gcScheduler && this.gcScheduler.stop(), [
                            4 /*yield*/ ,
                            this.sharedClientState.shutdown()
                        ];
                    case 1:
                        return t.sent(), [
                            4 /*yield*/ ,
                            this.persistence.shutdown()
                        ];
                    case 2:
                        return t.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t;
}(), $8cffe22d3a2884c1$var$fu = /** @class */ function(e) {
    function i(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).Qo = t, i.cacheSizeBytes = n, i.forceOwnership = r, i.synchronizeTabs = !1, i;
    }
    return (0, $2WUgS.__extends)(i, e), i.prototype.initialize = function(t) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var n = this;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            e.prototype.initialize.call(this, t)
                        ];
                    case 1:
                        return r.sent(), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Ji(this.localStore)
                        ];
                    case 2:
                        return r.sent(), [
                            4 /*yield*/ ,
                            this.Qo.initialize(this, t)
                        ];
                    case 3:
                        // Enqueue writes from a previous session
                        return r.sent(), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$au(this.Qo.syncEngine)
                        ];
                    case 4:
                        // Enqueue writes from a previous session
                        return r.sent(), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Zo(this.Qo.remoteStore)
                        ];
                    case 5:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return r.sent(), [
                            4 /*yield*/ ,
                            this.persistence.He(function() {
                                return n.gcScheduler && !n.gcScheduler.started && n.gcScheduler.start(n.localStore), Promise.resolve();
                            })
                        ];
                    case 6:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return r.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, i.prototype.Ko = function(t) {
        return $8cffe22d3a2884c1$var$Ui(this.persistence, new $8cffe22d3a2884c1$var$Vi, t.initialUser, this.R);
    }, i.prototype.Uo = function(t) {
        var e = this.persistence.referenceDelegate.garbageCollector;
        return new $8cffe22d3a2884c1$var$mi(e, t.asyncQueue);
    }, i.prototype.qo = function(t) {
        var e = $8cffe22d3a2884c1$var$Oi(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $8cffe22d3a2884c1$var$ei.withCacheSize(this.cacheSizeBytes) : $8cffe22d3a2884c1$var$ei.DEFAULT;
        return new $8cffe22d3a2884c1$var$xi(this.synchronizeTabs, e, t.clientId, n, t.asyncQueue, $8cffe22d3a2884c1$var$Ao(), $8cffe22d3a2884c1$var$ko(), this.R, this.sharedClientState, !!this.forceOwnership);
    }, i.prototype.Bo = function(t) {
        return new $8cffe22d3a2884c1$var$To;
    }, i;
}($8cffe22d3a2884c1$var$hu), $8cffe22d3a2884c1$var$lu = /** @class */ function(e) {
    function i(t, n) {
        var r = this;
        return (r = e.call(this, t, n, /* forceOwnership= */ !1) || this).Qo = t, r.cacheSizeBytes = n, r.synchronizeTabs = !0, r;
    }
    return (0, $2WUgS.__extends)(i, e), i.prototype.initialize = function(t) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var i, o = this;
            return (0, $2WUgS.__generator)(this, function(s) {
                switch(s.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            e.prototype.initialize.call(this, t)
                        ];
                    case 1:
                        return s.sent(), i = this.Qo.syncEngine, this.sharedClientState instanceof $8cffe22d3a2884c1$var$Io ? (this.sharedClientState.syncEngine = {
                            ui: $8cffe22d3a2884c1$var$tu.bind(null, i),
                            ai: $8cffe22d3a2884c1$var$ou.bind(null, i),
                            hi: $8cffe22d3a2884c1$var$su.bind(null, i),
                            fn: $8cffe22d3a2884c1$var$iu.bind(null, i),
                            ci: $8cffe22d3a2884c1$var$Zs.bind(null, i)
                        }, [
                            4 /*yield*/ ,
                            this.sharedClientState.start()
                        ]) : [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        s.sent(), s.label = 3;
                    case 3:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return [
                            4 /*yield*/ ,
                            this.persistence.He(function(t) {
                                return (0, $2WUgS.__awaiter)(o, void 0, void 0, function() {
                                    return (0, $2WUgS.__generator)(this, function(e) {
                                        switch(e.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    $8cffe22d3a2884c1$var$eu(this.Qo.syncEngine, t)
                                                ];
                                            case 1:
                                                return e.sent(), this.gcScheduler && (t && !this.gcScheduler.started ? this.gcScheduler.start(this.localStore) : t || this.gcScheduler.stop()), [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 4:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return s.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, i.prototype.Bo = function(t) {
        var e = $8cffe22d3a2884c1$var$Ao();
        if (!$8cffe22d3a2884c1$var$Io.yt(e)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        var n = $8cffe22d3a2884c1$var$Oi(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey);
        return new $8cffe22d3a2884c1$var$Io(e, t.asyncQueue, n, t.clientId, t.initialUser);
    }, i;
}($8cffe22d3a2884c1$var$fu), $8cffe22d3a2884c1$var$du = /** @class */ function() {
    function t() {}
    return t.prototype.initialize = function(t, e) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var n = this;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return this.localStore ? [
                            3 /*break*/ ,
                            2
                        ] : (this.localStore = t.localStore, this.sharedClientState = t.sharedClientState, this.datastore = this.createDatastore(e), this.remoteStore = this.createRemoteStore(e), this.eventManager = this.createEventManager(e), this.syncEngine = this.createSyncEngine(e, /* startAsPrimary=*/ !t.synchronizeTabs), this.sharedClientState.onlineStateHandler = function(t) {
                            return $8cffe22d3a2884c1$var$Ms(n.syncEngine, t, 1 /* SharedClientState */ );
                        }, this.remoteStore.remoteSyncer.handleCredentialChange = $8cffe22d3a2884c1$var$$s.bind(null, this.syncEngine), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$ss(this.remoteStore, this.syncEngine.isPrimaryClient)
                        ]);
                    case 1:
                        r.sent(), r.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.createEventManager = function(t) {
        return new $8cffe22d3a2884c1$var$ys;
    }, t.prototype.createDatastore = function(t) {
        var e, n = $8cffe22d3a2884c1$var$Co(t.databaseInfo.databaseId), r = (e = t.databaseInfo, new $8cffe22d3a2884c1$var$Do(e));
        /** Return the Platform-specific connectivity monitor. */ return function(t, e, n) {
            return new $8cffe22d3a2884c1$var$Po(t, e, n);
        }(t.credentials, r, n);
    }, t.prototype.createRemoteStore = function(t) {
        var e, n, r, i, o, s = this;
        return e = this.localStore, n = this.datastore, r = t.asyncQueue, i = function(t) {
            return $8cffe22d3a2884c1$var$Ms(s.syncEngine, t, 0 /* RemoteStore */ );
        }, o = $8cffe22d3a2884c1$var$Eo.yt() ? new $8cffe22d3a2884c1$var$Eo : new $8cffe22d3a2884c1$var$_o, new $8cffe22d3a2884c1$var$Mo(e, n, r, i, o);
    }, t.prototype.createSyncEngine = function(t, e) {
        return function(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, o, s) {
            var u = new $8cffe22d3a2884c1$var$xs(t, e, n, r, i, o);
            return s && (u.$o = !0), u;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, e);
    }, t.prototype.terminate = function() {
        return function(t) {
            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                var e;
                return (0, $2WUgS.__generator)(this, function(n) {
                    switch(n.label){
                        case 0:
                            return e = $8cffe22d3a2884c1$var$F(t), $8cffe22d3a2884c1$var$C("RemoteStore", "RemoteStore shutting down."), e.Or.add(5 /* Shutdown */ ), [
                                4 /*yield*/ ,
                                $8cffe22d3a2884c1$var$qo(e)
                            ];
                        case 1:
                            return n.sent(), e.Lr.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                            // triggering spurious listener events with cached data, etc.
                            e.Br.set("Unknown" /* Unknown */ ), [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }(this.remoteStore);
    }, t;
}();
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $8cffe22d3a2884c1$var$pu(t, e) {
    void 0 === e && (e = 10240);
    var i = 0;
    return {
        read: function() {
            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                var n;
                return (0, $2WUgS.__generator)(this, function(r) {
                    return i < t.byteLength ? (n = {
                        value: t.slice(i, i + e),
                        done: !1
                    }, [
                        2 /*return*/ ,
                        (i += e, n)
                    ]) : [
                        2 /*return*/ ,
                        {
                            done: !0
                        }
                    ];
                });
            });
        },
        cancel: function() {
            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(t) {
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        },
        releaseLock: function() {},
        closed: Promise.reject("unimplemented")
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ var $8cffe22d3a2884c1$var$yu = /** @class */ function() {
    function t(t) {
        this.observer = t, /**
             * When set to true, will not raise future events. Necessary to deal with
             * async detachment of listener.
             */ this.muted = !1;
    }
    return t.prototype.next = function(t) {
        this.observer.next && this.jo(this.observer.next, t);
    }, t.prototype.error = function(t) {
        this.observer.error ? this.jo(this.observer.error, t) : console.error("Uncaught Error in snapshot listener:", t);
    }, t.prototype.Wo = function() {
        this.muted = !0;
    }, t.prototype.jo = function(t, e) {
        var n = this;
        this.muted || setTimeout(function() {
            n.muted || t(e);
        }, 0);
    }, t;
}(), $8cffe22d3a2884c1$var$vu = /** @class */ function() {
    function t(/** The reader to read from underlying binary bundle data source. */ t, e) {
        var n = this;
        this.Go = t, this.R = e, /** Cached bundle metadata. */ this.metadata = new $8cffe22d3a2884c1$var$br, /**
             * Internal buffer to hold bundle content, accumulating incomplete element
             * content.
             */ this.buffer = new Uint8Array, this.zo = new TextDecoder("utf-8"), // Read the metadata (which is the first element).
        this.Ho().then(function(t) {
            t && t.io() ? n.metadata.resolve(t.payload.metadata) : n.metadata.reject(new Error("The first element of the bundle is not a metadata, it is\n             " + JSON.stringify(null == t ? void 0 : t.payload)));
        }, function(t) {
            return n.metadata.reject(t);
        });
    }
    return t.prototype.close = function() {
        return this.Go.cancel();
    }, t.prototype.getMetadata = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(t) {
                return [
                    2 /*return*/ ,
                    this.metadata.promise
                ];
            });
        });
    }, t.prototype.Lo = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getMetadata()
                        ];
                    case 1:
                        // Makes sure metadata is read before proceeding.
                        return [
                            2 /*return*/ ,
                            (t.sent(), this.Ho())
                        ];
                }
            });
        });
    }, /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ t.prototype.Ho = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e, n, i;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.Jo()
                        ];
                    case 1:
                        return null === (t = r.sent()) ? [
                            2 /*return*/ ,
                            null
                        ] : (e = this.zo.decode(t), n = Number(e), isNaN(n) && this.Yo("length string (" + e + ") is not valid number"), [
                            4 /*yield*/ ,
                            this.Xo(n)
                        ]);
                    case 2:
                        return i = r.sent(), [
                            2 /*return*/ ,
                            new $8cffe22d3a2884c1$var$Ts(JSON.parse(i), t.length + n)
                        ];
                }
            });
        });
    }, /** First index of '{' from the underlying buffer. */ t.prototype.Zo = function() {
        return this.buffer.findIndex(function(t) {
            return t === "{".charCodeAt(0);
        });
    }, /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ t.prototype.Jo = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e;
            return (0, $2WUgS.__generator)(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.Zo() < 0 ? [
                            4 /*yield*/ ,
                            this.tc()
                        ] : [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        if (n.sent()) return [
                            3 /*break*/ ,
                            3
                        ];
                        n.label = 2;
                    case 2:
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 3:
                        // Broke out of the loop because underlying stream is closed, and there
                        // happens to be no more data to process.
                        return 0 === this.buffer.length ? [
                            2 /*return*/ ,
                            null
                        ] : (// Broke out of the loop because underlying stream is closed, but still
                        // cannot find an open bracket.
                        (t = this.Zo()) < 0 && this.Yo("Reached the end of bundle when a length string is expected."), e = this.buffer.slice(0, t), [
                            2 /*return*/ ,
                            (this.buffer = this.buffer.slice(t), e)
                        ]);
                }
            });
        });
    }, /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ t.prototype.Xo = function(t) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var e;
            return (0, $2WUgS.__generator)(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.buffer.length < t ? [
                            4 /*yield*/ ,
                            this.tc()
                        ] : [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        n.sent() && this.Yo("Reached the end of bundle when more is expected."), n.label = 2;
                    case 2:
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 3:
                        // Update the internal buffer to drop the read json string.
                        return e = this.zo.decode(this.buffer.slice(0, t)), [
                            2 /*return*/ ,
                            (this.buffer = this.buffer.slice(t), e)
                        ];
                }
            });
        });
    }, t.prototype.Yo = function(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Go.cancel(), new Error("Invalid bundle format: " + t);
    }, /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ t.prototype.tc = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e;
            return (0, $2WUgS.__generator)(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.Go.read()
                        ];
                    case 1:
                        return (t = n.sent()).done || ((e = new Uint8Array(this.buffer.length + t.value.length)).set(this.buffer), e.set(t.value, this.buffer.length), this.buffer = e), [
                            2 /*return*/ ,
                            t.done
                        ];
                }
            });
        });
    }, t;
}(), $8cffe22d3a2884c1$var$mu = /** @class */ function() {
    function t(t) {
        this.datastore = t, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
             * A deferred usage error that occurred previously in this transaction that
             * will cause the transaction to fail once it actually commits.
             */ this.lastWriteError = null, /**
             * Set of documents that have been written in the transaction.
             *
             * When there's more than one write to the same key in a transaction, any
             * writes after the first are handled differently.
             */ this.writtenDocs = new Set;
    }
    return t.prototype.lookup = function(t) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var e, i = this;
            return (0, $2WUgS.__generator)(this, function(o) {
                switch(o.label){
                    case 0:
                        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
                        return [
                            4 /*yield*/ ,
                            function(t, e) {
                                return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                    var n, i, o, s, u, a;
                                    return (0, $2WUgS.__generator)(this, function(r) {
                                        switch(r.label){
                                            case 0:
                                                return n = $8cffe22d3a2884c1$var$F(t), i = $8cffe22d3a2884c1$var$xn(n.R) + "/documents", o = {
                                                    documents: e.map(function(t) {
                                                        return $8cffe22d3a2884c1$var$Dn(n.R, t);
                                                    })
                                                }, [
                                                    4 /*yield*/ ,
                                                    n.$i("BatchGetDocuments", i, o)
                                                ];
                                            case 1:
                                                return s = r.sent(), u = new Map, s.forEach(function(t) {
                                                    var e = function(t, e) {
                                                        return "found" in e ? function(t, e) {
                                                            $8cffe22d3a2884c1$var$P(!!e.found), e.found.name, e.found.updateTime;
                                                            var n = $8cffe22d3a2884c1$var$An(t, e.found.name), r = $8cffe22d3a2884c1$var$En(e.found.updateTime), i = new $8cffe22d3a2884c1$var$Et({
                                                                mapValue: {
                                                                    fields: e.found.fields
                                                                }
                                                            });
                                                            return $8cffe22d3a2884c1$var$Nt.newFoundDocument(n, r, i);
                                                        }(t, e) : "missing" in e ? function(t, e) {
                                                            $8cffe22d3a2884c1$var$P(!!e.missing), $8cffe22d3a2884c1$var$P(!!e.readTime);
                                                            var n = $8cffe22d3a2884c1$var$An(t, e.missing), r = $8cffe22d3a2884c1$var$En(e.readTime);
                                                            return $8cffe22d3a2884c1$var$Nt.newNoDocument(n, r);
                                                        }(t, e) : $8cffe22d3a2884c1$var$O();
                                                    }(n.R, t);
                                                    u.set(e.key.toString(), e);
                                                }), a = [], [
                                                    2 /*return*/ ,
                                                    (e.forEach(function(t) {
                                                        var e = u.get(t.toString());
                                                        $8cffe22d3a2884c1$var$P(!!e), a.push(e);
                                                    }), a)
                                                ];
                                        }
                                    });
                                });
                            }(this.datastore, t)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            ((e = o.sent()).forEach(function(t) {
                                return i.recordVersion(t);
                            }), e)
                        ];
                }
            });
        });
    }, t.prototype.set = function(t, e) {
        this.write(e.toMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }, t.prototype.update = function(t, e) {
        try {
            this.write(e.toMutation(t, this.preconditionForUpdate(t)));
        } catch (t) {
            this.lastWriteError = t;
        }
        this.writtenDocs.add(t.toString());
    }, t.prototype.delete = function(t) {
        this.write(new $8cffe22d3a2884c1$var$je(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }, t.prototype.commit = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e = this;
            return (0, $2WUgS.__generator)(this, function(i) {
                switch(i.label){
                    case 0:
                        if (this.ensureCommitNotCalled(), this.lastWriteError) throw this.lastWriteError;
                        return t = this.readVersions, // For each mutation, note that the doc was written.
                        this.mutations.forEach(function(e) {
                            t.delete(e.key.toString());
                        }), // For each document that was read but not written to, we want to perform
                        // a `verify` operation.
                        t.forEach(function(t, n) {
                            var r = $8cffe22d3a2884c1$var$ct.fromPath(n);
                            e.mutations.push(new $8cffe22d3a2884c1$var$Ke(r, e.precondition(r)));
                        }), [
                            4 /*yield*/ ,
                            function(t, e) {
                                return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                    var n, i, o;
                                    return (0, $2WUgS.__generator)(this, function(r) {
                                        switch(r.label){
                                            case 0:
                                                return n = $8cffe22d3a2884c1$var$F(t), i = $8cffe22d3a2884c1$var$xn(n.R) + "/documents", o = {
                                                    writes: e.map(function(t) {
                                                        return $8cffe22d3a2884c1$var$Pn(n.R, t);
                                                    })
                                                }, [
                                                    4 /*yield*/ ,
                                                    n.Ni("Commit", i, o)
                                                ];
                                            case 1:
                                                return r.sent(), [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }(this.datastore, this.mutations)
                        ];
                    case 1:
                        // For each mutation, note that the doc was written.
                        return i.sent(), this.committed = !0, [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.recordVersion = function(t) {
        var e;
        if (t.isFoundDocument()) e = t.version;
        else {
            if (!t.isNoDocument()) throw $8cffe22d3a2884c1$var$O();
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            e = $8cffe22d3a2884c1$var$K.min();
        }
        var n = this.readVersions.get(t.key.toString());
        if (n) {
            if (!e.isEqual(n)) // This transaction will fail no matter what.
            throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(t.key.toString(), e);
    }, /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ t.prototype.precondition = function(t) {
        var e = this.readVersions.get(t.toString());
        return !this.writtenDocs.has(t.toString()) && e ? $8cffe22d3a2884c1$var$De.updateTime(e) : $8cffe22d3a2884c1$var$De.none();
    }, /**
     * Returns the precondition for a document if the operation is an update.
     */ t.prototype.preconditionForUpdate = function(t) {
        var e = this.readVersions.get(t.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(t.toString()) && e) {
            if (e.isEqual($8cffe22d3a2884c1$var$K.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $8cffe22d3a2884c1$var$De.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $8cffe22d3a2884c1$var$De.exists(!0);
    }, t.prototype.write = function(t) {
        this.ensureCommitNotCalled(), this.mutations.push(t);
    }, t.prototype.ensureCommitNotCalled = function() {}, t;
}(), $8cffe22d3a2884c1$var$gu = /** @class */ function() {
    function t(t, e, n, r) {
        this.asyncQueue = t, this.datastore = e, this.updateFunction = n, this.deferred = r, this.ec = 5, this.Zi = new $8cffe22d3a2884c1$var$xo(this.asyncQueue, "transaction_retry" /* TransactionRetry */ ) /** Runs the transaction and sets the result on deferred. */ ;
    }
    return t.prototype.run = function() {
        this.ec -= 1, this.nc();
    }, t.prototype.nc = function() {
        var t = this;
        this.Zi.ji(function() {
            return (0, $2WUgS.__awaiter)(t, void 0, void 0, function() {
                var t, e, n = this;
                return (0, $2WUgS.__generator)(this, function(r) {
                    return t = new $8cffe22d3a2884c1$var$mu(this.datastore), (e = this.sc(t)) && e.then(function(e) {
                        n.asyncQueue.enqueueAndForget(function() {
                            return t.commit().then(function() {
                                n.deferred.resolve(e);
                            }).catch(function(t) {
                                n.ic(t);
                            });
                        });
                    }).catch(function(t) {
                        n.ic(t);
                    }), [
                        2 /*return*/ 
                    ];
                });
            });
        });
    }, t.prototype.sc = function(t) {
        try {
            var e = this.updateFunction(t);
            return !$8cffe22d3a2884c1$var$st(e) && e.catch && e.then ? e : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(t), null;
        }
    }, t.prototype.ic = function(t) {
        var e = this;
        this.ec > 0 && this.rc(t) ? (this.ec -= 1, this.asyncQueue.enqueueAndForget(function() {
            return e.nc(), Promise.resolve();
        })) : this.deferred.reject(t);
    }, t.prototype.rc = function(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            var e = t.code;
            return "aborted" === e || "failed-precondition" === e || !$8cffe22d3a2884c1$var$Qe(e);
        }
        return !1;
    }, t;
}(), $8cffe22d3a2884c1$var$wu = /** @class */ function() {
    function t(t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ e, i) {
        var o = this;
        this.credentials = t, this.asyncQueue = e, this.databaseInfo = i, this.user = $8cffe22d3a2884c1$var$fo.UNAUTHENTICATED, this.clientId = $8cffe22d3a2884c1$var$V.u(), this.credentialListener = function() {
            return Promise.resolve();
        }, this.credentials.setChangeListener(e, function(t) {
            return (0, $2WUgS.__awaiter)(o, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(e) {
                    switch(e.label){
                        case 0:
                            return $8cffe22d3a2884c1$var$C("FirestoreClient", "Received user=", t.uid), [
                                4 /*yield*/ ,
                                this.credentialListener(t)
                            ];
                        case 1:
                            return e.sent(), this.user = t, [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }
    return t.prototype.getConfiguration = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(t) {
                return [
                    2 /*return*/ ,
                    {
                        asyncQueue: this.asyncQueue,
                        databaseInfo: this.databaseInfo,
                        clientId: this.clientId,
                        credentials: this.credentials,
                        initialUser: this.user,
                        maxConcurrentLimboResolutions: 100
                    }
                ];
            });
        });
    }, t.prototype.setCredentialChangeListener = function(t) {
        this.credentialListener = t;
    }, /**
     * Checks that the client has not been terminated. Ensures that other methods on
     * this class cannot be called after the client is terminated.
     */ t.prototype.verifyNotTerminated = function() {
        if (this.asyncQueue.isShuttingDown) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    }, t.prototype.terminate = function() {
        var t = this;
        this.asyncQueue.enterRestrictedMode();
        var e = new $8cffe22d3a2884c1$var$br;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(function() {
            return (0, $2WUgS.__awaiter)(t, void 0, void 0, function() {
                var t, n;
                return (0, $2WUgS.__generator)(this, function(r) {
                    switch(r.label){
                        case 0:
                            return r.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]), this.onlineComponents ? [
                                4 /*yield*/ ,
                                this.onlineComponents.terminate()
                            ] : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            r.sent(), r.label = 2;
                        case 2:
                            return this.offlineComponents ? [
                                4 /*yield*/ ,
                                this.offlineComponents.terminate()
                            ] : [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            r.sent(), r.label = 4;
                        case 4:
                            // `removeChangeListener` must be called after shutting down the
                            // RemoteStore as it will prevent the RemoteStore from retrieving
                            // auth tokens.
                            return this.credentials.removeChangeListener(), e.resolve(), [
                                3 /*break*/ ,
                                6
                            ];
                        case 5:
                            return t = r.sent(), n = $8cffe22d3a2884c1$var$hs(t, "Failed to shutdown persistence"), e.reject(n), [
                                3 /*break*/ ,
                                6
                            ];
                        case 6:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }), e.promise;
    }, t;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ function $8cffe22d3a2884c1$var$bu(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var i, o, s = this;
        return (0, $2WUgS.__generator)(this, function(u) {
            switch(u.label){
                case 0:
                    return t.asyncQueue.verifyOperationInProgress(), $8cffe22d3a2884c1$var$C("FirestoreClient", "Initializing OfflineComponentProvider"), [
                        4 /*yield*/ ,
                        t.getConfiguration()
                    ];
                case 1:
                    return i = u.sent(), [
                        4 /*yield*/ ,
                        e.initialize(i)
                    ];
                case 2:
                    return u.sent(), o = i.initialUser, t.setCredentialChangeListener(function(t) {
                        return (0, $2WUgS.__awaiter)(s, void 0, void 0, function() {
                            return (0, $2WUgS.__generator)(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return o.isEqual(t) ? [
                                            3 /*break*/ ,
                                            2
                                        ] : [
                                            4 /*yield*/ ,
                                            $8cffe22d3a2884c1$var$Bi(e.localStore, t)
                                        ];
                                    case 1:
                                        n.sent(), o = t, n.label = 2;
                                    case 2:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    }), // When a user calls clearPersistence() in one client, all other clients
                    // need to be terminated to allow the delete to succeed.
                    e.persistence.setDatabaseDeletedListener(function() {
                        return t.terminate();
                    }), t.offlineComponents = e, [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$Iu(t, e) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var i, o;
        return (0, $2WUgS.__generator)(this, function(s) {
            switch(s.label){
                case 0:
                    return t.asyncQueue.verifyOperationInProgress(), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Tu(t)
                    ];
                case 1:
                    return i = s.sent(), $8cffe22d3a2884c1$var$C("FirestoreClient", "Initializing OnlineComponentProvider"), [
                        4 /*yield*/ ,
                        t.getConfiguration()
                    ];
                case 2:
                    return o = s.sent(), [
                        4 /*yield*/ ,
                        e.initialize(i, o)
                    ];
                case 3:
                    return s.sent(), // The CredentialChangeListener of the online component provider takes
                    // precedence over the offline component provider.
                    t.setCredentialChangeListener(function(t) {
                        return function(t, e) {
                            return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                var n, i;
                                return (0, $2WUgS.__generator)(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            return (n = $8cffe22d3a2884c1$var$F(t)).asyncQueue.verifyOperationInProgress(), $8cffe22d3a2884c1$var$C("RemoteStore", "RemoteStore received new credentials"), i = $8cffe22d3a2884c1$var$zo(n), // Tear down and re-create our network streams. This will ensure we get a
                                            // fresh auth token for the new user and re-fill the write pipeline with
                                            // new mutations from the LocalStore (since mutations are per-user).
                                            n.Or.add(3 /* CredentialChange */ ), [
                                                4 /*yield*/ ,
                                                $8cffe22d3a2884c1$var$qo(n)
                                            ];
                                        case 1:
                                            return r.sent(), i && // Don't set the network status to Unknown if we are offline.
                                            n.Br.set("Unknown" /* Unknown */ ), [
                                                4 /*yield*/ ,
                                                n.remoteSyncer.handleCredentialChange(e)
                                            ];
                                        case 2:
                                            return r.sent(), n.Or.delete(3 /* CredentialChange */ ), [
                                                4 /*yield*/ ,
                                                $8cffe22d3a2884c1$var$Vo(n)
                                            ];
                                        case 3:
                                            // Tear down and re-create our network streams. This will ensure we get a
                                            // fresh auth token for the new user and re-fill the write pipeline with
                                            // new mutations from the LocalStore (since mutations are per-user).
                                            return r.sent(), [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }(e.remoteStore, t);
                    }), t.onlineComponents = e, [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$Tu(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(e) {
            switch(e.label){
                case 0:
                    return t.offlineComponents ? [
                        3 /*break*/ ,
                        2
                    ] : ($8cffe22d3a2884c1$var$C("FirestoreClient", "Using default OfflineComponentProvider"), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$bu(t, new $8cffe22d3a2884c1$var$hu)
                    ]);
                case 1:
                    e.sent(), e.label = 2;
                case 2:
                    return [
                        2 /*return*/ ,
                        t.offlineComponents
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$_u(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(e) {
            switch(e.label){
                case 0:
                    return t.onlineComponents ? [
                        3 /*break*/ ,
                        2
                    ] : ($8cffe22d3a2884c1$var$C("FirestoreClient", "Using default OnlineComponentProvider"), [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$Iu(t, new $8cffe22d3a2884c1$var$du)
                    ]);
                case 1:
                    e.sent(), e.label = 2;
                case 2:
                    return [
                        2 /*return*/ ,
                        t.onlineComponents
                    ];
            }
        });
    });
}
function $8cffe22d3a2884c1$var$Eu(t) {
    return $8cffe22d3a2884c1$var$Tu(t).then(function(t) {
        return t.persistence;
    });
}
function $8cffe22d3a2884c1$var$Su(t) {
    return $8cffe22d3a2884c1$var$Tu(t).then(function(t) {
        return t.localStore;
    });
}
function $8cffe22d3a2884c1$var$Nu(t) {
    return $8cffe22d3a2884c1$var$_u(t).then(function(t) {
        return t.remoteStore;
    });
}
function $8cffe22d3a2884c1$var$Du(t) {
    return $8cffe22d3a2884c1$var$_u(t).then(function(t) {
        return t.syncEngine;
    });
}
function $8cffe22d3a2884c1$var$Au(t) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var e, n;
        return (0, $2WUgS.__generator)(this, function(r) {
            switch(r.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $8cffe22d3a2884c1$var$_u(t)
                    ];
                case 1:
                    return e = r.sent(), [
                        2 /*return*/ ,
                        ((n = e.eventManager).onListen = $8cffe22d3a2884c1$var$Rs.bind(null, e.syncEngine), n.onUnlisten = $8cffe22d3a2884c1$var$Os.bind(null, e.syncEngine), n)
                    ];
            }
        });
    });
}
/** Enables the network connection and re-enqueues all pending operations. */ function $8cffe22d3a2884c1$var$ku(t, e, i) {
    var o = this;
    void 0 === i && (i = {});
    var s = new $8cffe22d3a2884c1$var$br;
    return t.asyncQueue.enqueueAndForget(function() {
        return (0, $2WUgS.__awaiter)(o, void 0, void 0, function() {
            var n;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return n = function(t, e, n, r, i) {
                            var o = new $8cffe22d3a2884c1$var$yu({
                                next: function(o) {
                                    // Remove query first before passing event to user to avoid
                                    // user actions affecting the now stale query.
                                    e.enqueueAndForget(function() {
                                        return $8cffe22d3a2884c1$var$ms(t, s);
                                    });
                                    var u = o.docs.has(n);
                                    !u && o.fromCache ? // TODO(dimond): If we're online and the document doesn't
                                    // exist then we resolve with a doc.exists set to false. If
                                    // we're offline however, we reject the Promise in this
                                    // case. Two options: 1) Cache the negative response from
                                    // the server so we can deliver that even when you're
                                    // offline 2) Actually reject the Promise in the online case
                                    // if the document doesn't exist.
                                    i.reject(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && o.fromCache && r && "server" === r.source ? i.reject(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(o);
                                },
                                error: function(t) {
                                    return i.reject(t);
                                }
                            }), s = new $8cffe22d3a2884c1$var$Is($8cffe22d3a2884c1$var$Yt(n.path), o, {
                                includeMetadataChanges: !0,
                                so: !0
                            });
                            return $8cffe22d3a2884c1$var$vs(t, s);
                        }, [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Au(t)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            n.apply(void 0, [
                                r.sent(),
                                t.asyncQueue,
                                e,
                                i,
                                s
                            ])
                        ];
                }
            });
        });
    }), s.promise;
}
function $8cffe22d3a2884c1$var$Cu(t, e, i) {
    var o = this;
    void 0 === i && (i = {});
    var s = new $8cffe22d3a2884c1$var$br;
    return t.asyncQueue.enqueueAndForget(function() {
        return (0, $2WUgS.__awaiter)(o, void 0, void 0, function() {
            var n;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return n = function(t, e, n, r, i) {
                            var o = new $8cffe22d3a2884c1$var$yu({
                                next: function(n) {
                                    // Remove query first before passing event to user to avoid
                                    // user actions affecting the now stale query.
                                    e.enqueueAndForget(function() {
                                        return $8cffe22d3a2884c1$var$ms(t, s);
                                    }), n.fromCache && "server" === r.source ? i.reject(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                                },
                                error: function(t) {
                                    return i.reject(t);
                                }
                            }), s = new $8cffe22d3a2884c1$var$Is(n, o, {
                                includeMetadataChanges: !0,
                                so: !0
                            });
                            return $8cffe22d3a2884c1$var$vs(t, s);
                        }, [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Au(t)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            n.apply(void 0, [
                                r.sent(),
                                t.asyncQueue,
                                e,
                                i,
                                s
                            ])
                        ];
                }
            });
        });
    }), s.promise;
}
var $8cffe22d3a2884c1$var$xu = /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ function(t, e, n, r, i, o, s, u) {
    this.databaseId = t, this.appId = e, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = o, this.autoDetectLongPolling = s, this.useFetchStreams = u;
}, $8cffe22d3a2884c1$var$Ru = /** @class */ function() {
    function t(t, e) {
        this.projectId = t, this.database = e || "(default)";
    }
    return Object.defineProperty(t.prototype, "isDefaultDatabase", {
        get: function() {
            return "(default)" === this.database;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        return e instanceof t && e.projectId === this.projectId && e.database === this.database;
    }, t;
}(), $8cffe22d3a2884c1$var$Lu = new Map, $8cffe22d3a2884c1$var$Ou = function(t, e) {
    this.user = e, this.type = "OAuth", this.authHeaders = {}, // Set the headers using Object Literal notation to avoid minification
    this.authHeaders.Authorization = "Bearer " + t;
}, $8cffe22d3a2884c1$var$Pu = /** @class */ function() {
    function t() {
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    return t.prototype.getToken = function() {
        return Promise.resolve(null);
    }, t.prototype.invalidateToken = function() {}, t.prototype.setChangeListener = function(t, e) {
        this.changeListener = e, // Fire with initial user.
        t.enqueueRetryable(function() {
            return e($8cffe22d3a2884c1$var$fo.UNAUTHENTICATED);
        });
    }, t.prototype.removeChangeListener = function() {
        this.changeListener = null;
    }, t;
}(), $8cffe22d3a2884c1$var$Fu = /** @class */ function() {
    function t(t) {
        this.token = t, /**
             * Stores the listener registered with setChangeListener()
             * This isn't actually necessary since the UID never changes, but we use this
             * to verify the listen contract is adhered to in tests.
             */ this.changeListener = null;
    }
    return t.prototype.getToken = function() {
        return Promise.resolve(this.token);
    }, t.prototype.invalidateToken = function() {}, t.prototype.setChangeListener = function(t, e) {
        var n = this;
        this.changeListener = e, // Fire with initial user.
        t.enqueueRetryable(function() {
            return e(n.token.user);
        });
    }, t.prototype.removeChangeListener = function() {
        this.changeListener = null;
    }, t;
}(), $8cffe22d3a2884c1$var$Mu = /** @class */ function() {
    function t(t) {
        var e = this;
        /** Tracks the current User. */ this.currentUser = $8cffe22d3a2884c1$var$fo.UNAUTHENTICATED, /** Promise that allows blocking on the initialization of Firebase Auth. */ this.oc = new $8cffe22d3a2884c1$var$br, /**
             * Counter used to detect if the token changed while a getToken request was
             * outstanding.
             */ this.cc = 0, this.forceRefresh = !1, this.auth = null, this.asyncQueue = null, this.uc = function() {
            e.cc++, e.currentUser = e.ac(), e.oc.resolve(), e.changeListener && e.asyncQueue.enqueueRetryable(function() {
                return e.changeListener(e.currentUser);
            });
        };
        var n = function(t) {
            $8cffe22d3a2884c1$var$C("FirebaseCredentialsProvider", "Auth detected"), e.auth = t, e.auth.addAuthTokenListener(e.uc);
        };
        t.onInit(function(t) {
            return n(t);
        }), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(function() {
            if (!e.auth) {
                var r = t.getImmediate({
                    optional: !0
                });
                r ? n(r) : // If auth is still not available, proceed with `null` user
                ($8cffe22d3a2884c1$var$C("FirebaseCredentialsProvider", "Auth not yet detected"), e.oc.resolve());
            }
        }, 0);
    }
    return t.prototype.getToken = function() {
        var t = this, e = this.cc, n = this.forceRefresh;
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(n).then(function(n) {
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            return t.cc !== e ? ($8cffe22d3a2884c1$var$C("FirebaseCredentialsProvider", "getToken aborted due to token change."), t.getToken()) : n ? ($8cffe22d3a2884c1$var$P("string" == typeof n.accessToken), new $8cffe22d3a2884c1$var$Ou(n.accessToken, t.currentUser)) : null;
        }) : Promise.resolve(null);
    }, t.prototype.invalidateToken = function() {
        this.forceRefresh = !0;
    }, t.prototype.setChangeListener = function(t, e) {
        var i = this;
        this.asyncQueue = t, // Blocks the AsyncQueue until the next user is available.
        this.asyncQueue.enqueueRetryable(function() {
            return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                return (0, $2WUgS.__generator)(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.oc.promise
                            ];
                        case 1:
                            return t.sent(), [
                                4 /*yield*/ ,
                                e(this.currentUser)
                            ];
                        case 2:
                            return t.sent(), this.changeListener = e, [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, t.prototype.removeChangeListener = function() {
        this.auth && this.auth.removeAuthTokenListener(this.uc), this.changeListener = function() {
            return Promise.resolve();
        };
    }, // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    t.prototype.ac = function() {
        var t = this.auth && this.auth.getUid();
        return $8cffe22d3a2884c1$var$P(null === t || "string" == typeof t), new $8cffe22d3a2884c1$var$fo(t);
    }, t;
}(), $8cffe22d3a2884c1$var$Vu = /** @class */ function() {
    function t(t, e, n) {
        this.hc = t, this.lc = e, this.fc = n, this.type = "FirstParty", this.user = $8cffe22d3a2884c1$var$fo.FIRST_PARTY;
    }
    return Object.defineProperty(t.prototype, "authHeaders", {
        get: function() {
            var t = {
                "X-Goog-AuthUser": this.lc
            }, e = this.hc.auth.getAuthHeaderValueForFirstParty([]);
            // Use array notation to prevent minification
            return e && (t.Authorization = e), this.fc && (t["X-Goog-Iam-Authorization-Token"] = this.fc), t;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $8cffe22d3a2884c1$var$qu = /** @class */ function() {
    function t(t, e, n) {
        this.hc = t, this.lc = e, this.fc = n;
    }
    return t.prototype.getToken = function() {
        return Promise.resolve(new $8cffe22d3a2884c1$var$Vu(this.hc, this.lc, this.fc));
    }, t.prototype.setChangeListener = function(t, e) {
        // Fire with initial uid.
        t.enqueueRetryable(function() {
            return e($8cffe22d3a2884c1$var$fo.FIRST_PARTY);
        });
    }, t.prototype.removeChangeListener = function() {}, t.prototype.invalidateToken = function() {}, t;
}();
/** The default database name for a project. */ /** Represents the database ID a Firestore client is associated with. */ /**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8cffe22d3a2884c1$var$Uu(t, e, n) {
    if (!n) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Function " + t + "() cannot be called with an empty " + e + ".");
}
function $8cffe22d3a2884c1$var$Bu(t, e) {
    if (void 0 === e) return {
        merge: !1
    };
    if (void 0 !== e.mergeFields && void 0 !== e.merge) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid options passed to function " + t + '(): You cannot specify both "merge" and "mergeFields".');
    return e;
}
/**
 * Validates that two boolean options are not set at the same time.
 */ function $8cffe22d3a2884c1$var$ju(t, e, n, r) {
    if (!0 === e && !0 === r) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, t + " and " + n + " cannot be used together.");
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $8cffe22d3a2884c1$var$Ku(t) {
    if (!$8cffe22d3a2884c1$var$ct.isDocumentKey(t)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + t + " has " + t.length + ".");
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $8cffe22d3a2884c1$var$Gu(t) {
    if ($8cffe22d3a2884c1$var$ct.isDocumentKey(t)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but " + t + " has " + t.length + ".");
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $8cffe22d3a2884c1$var$Qu(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = t.substring(0, 20) + "..."), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        var e = /** Hacky method to try to get the constructor name for an object. */ function(t) {
            if (t.constructor) {
                var e = /function\s+([^\s(]+)\s*\(/.exec(t.constructor.toString());
                if (e && e.length > 1) return e[1];
            }
            return null;
        }(t);
        return e ? "a custom " + e + " object" : "an object";
    }
    return "function" == typeof t ? "a function" : $8cffe22d3a2884c1$var$O();
}
function $8cffe22d3a2884c1$var$zu(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    if ("_delegate" in t && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t = t._delegate), !(t instanceof e)) {
        if (e.name === t.constructor.name) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        var n = $8cffe22d3a2884c1$var$Qu(t);
        throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Expected type '" + e.name + "', but it was: " + n);
    }
    return t;
}
function $8cffe22d3a2884c1$var$Wu(t, e) {
    if (e <= 0) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Function " + t + "() requires a positive number, but it was: " + e + ".");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ var $8cffe22d3a2884c1$var$Hu = /** @class */ function() {
    function t(t) {
        var e;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = !0;
        } else this.host = t.host, this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if (this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, void 0 === t.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.useFetchStreams = !!t.useFetchStreams, $8cffe22d3a2884c1$var$ju("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling);
    }
    return t.prototype.isEqual = function(t) {
        return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
    }, t;
}(), $8cffe22d3a2884c1$var$Yu = /** @class */ function() {
    /** @hideconstructor */ function t(t, e) {
        /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $8cffe22d3a2884c1$var$Hu({}), this._settingsFrozen = !1, t instanceof $8cffe22d3a2884c1$var$Ru ? (this._databaseId = t, this._credentials = new $8cffe22d3a2884c1$var$Pu) : (this._app = t, this._databaseId = function(t) {
            if (!Object.prototype.hasOwnProperty.apply(t.options, [
                "projectId"
            ])) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $8cffe22d3a2884c1$var$Ru(t.options.projectId);
        }(t), this._credentials = new $8cffe22d3a2884c1$var$Mu(e));
    }
    return Object.defineProperty(t.prototype, "app", {
        /**
         * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
         * instance.
         */ get: function() {
            if (!this._app) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
            return this._app;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "_initialized", {
        get: function() {
            return this._settingsFrozen;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "_terminated", {
        get: function() {
            return void 0 !== this._terminateTask;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype._setSettings = function(t) {
        if (this._settingsFrozen) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $8cffe22d3a2884c1$var$Hu(t), void 0 !== t.credentials && (this._credentials = function(t) {
            if (!t) return new $8cffe22d3a2884c1$var$Pu;
            switch(t.type){
                case "gapi":
                    var e = t.client;
                    // Make sure this really is a Gapi client.
                    return $8cffe22d3a2884c1$var$P(!("object" != typeof e || null === e || !e.auth || !e.auth.getAuthHeaderValueForFirstParty)), new $8cffe22d3a2884c1$var$qu(e, t.sessionIndex || "0", t.iamToken || null);
                case "provider":
                    return t.client;
                default:
                    throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "makeCredentialsProvider failed due to invalid credential type");
            }
        }(t.credentials));
    }, t.prototype._getSettings = function() {
        return this._settings;
    }, t.prototype._freezeSettings = function() {
        return this._settingsFrozen = !0, this._settings;
    }, t.prototype._delete = function() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }, /** Returns a JSON-serializable representation of this `Firestore` instance. */ t.prototype.toJSON = function() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }, /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ t.prototype._terminate = function() {
        var t, e;
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return t = this, (e = $8cffe22d3a2884c1$var$Lu.get(t)) && ($8cffe22d3a2884c1$var$C("ComponentProvider", "Removing Datastore"), $8cffe22d3a2884c1$var$Lu.delete(t), e.terminate()), Promise.resolve();
    }, t;
}(), $8cffe22d3a2884c1$var$$u = /** @class */ function() {
    /** @hideconstructor */ function t(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n) {
        this.converter = e, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = t;
    }
    return Object.defineProperty(t.prototype, "_path", {
        get: function() {
            return this._key.path;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "id", {
        /**
         * The document's identifier within its collection.
         */ get: function() {
            return this._key.path.lastSegment();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "path", {
        /**
         * A string representing the path of the referenced document (relative
         * to the root of the database).
         */ get: function() {
            return this._key.path.canonicalString();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "parent", {
        /**
         * The collection this `DocumentReference` belongs to.
         */ get: function() {
            return new $8cffe22d3a2884c1$var$Ju(this.firestore, this.converter, this._key.path.popLast());
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.withConverter = function(e) {
        return new t(this.firestore, e, this._key);
    }, t;
}(), $8cffe22d3a2884c1$var$Xu = /** @class */ function() {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ function t(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n) {
        this.converter = e, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = t;
    }
    return t.prototype.withConverter = function(e) {
        return new t(this.firestore, e, this._query);
    }, t;
}(), $8cffe22d3a2884c1$var$Ju = /** @class */ function(e) {
    /** @hideconstructor */ function n(t, n, r) {
        var i = this;
        return (i = e.call(this, t, n, $8cffe22d3a2884c1$var$Yt(r)) || this)._path = r, /** The type of this Firestore reference. */ i.type = "collection", i;
    }
    return (0, $2WUgS.__extends)(n, e), Object.defineProperty(n.prototype, "id", {
        /** The collection's identifier. */ get: function() {
            return this._query.path.lastSegment();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "path", {
        /**
         * A string representing the path of the referenced collection (relative
         * to the root of the database).
         */ get: function() {
            return this._query.path.canonicalString();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "parent", {
        /**
         * A reference to the containing `DocumentReference` if this is a
         * subcollection. If this isn't a subcollection, the reference is null.
         */ get: function() {
            var t = this._path.popLast();
            return t.isEmpty() ? null : new $8cffe22d3a2884c1$var$$u(this.firestore, /* converter= */ null, new $8cffe22d3a2884c1$var$ct(t));
        },
        enumerable: !1,
        configurable: !0
    }), n.prototype.withConverter = function(t) {
        return new n(this.firestore, t, this._path);
    }, n;
}($8cffe22d3a2884c1$var$Xu);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link getFirestore}.
 */ function $8cffe22d3a2884c1$var$Zu(t, n) {
    for(var r, i = [], o = 2; o < arguments.length; o++)i[o - 2] = arguments[o];
    if (t = (0, $eTAKc.getModularInstance)(t), $8cffe22d3a2884c1$var$Uu("collection", "path", n), t instanceof $8cffe22d3a2884c1$var$Yu) return $8cffe22d3a2884c1$var$Gu(r = $8cffe22d3a2884c1$var$H.fromString.apply($8cffe22d3a2884c1$var$H, (0, $2WUgS.__spreadArray)([
        n
    ], i))), new $8cffe22d3a2884c1$var$Ju(t, /* converter= */ null, r);
    if (!(t instanceof $8cffe22d3a2884c1$var$$u || t instanceof $8cffe22d3a2884c1$var$Ju)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
    return $8cffe22d3a2884c1$var$Gu(r = $8cffe22d3a2884c1$var$H.fromString.apply($8cffe22d3a2884c1$var$H, (0, $2WUgS.__spreadArray)([
        t.path
    ], i)).child($8cffe22d3a2884c1$var$H.fromString(n))), new $8cffe22d3a2884c1$var$Ju(t.firestore, /* converter= */ null, r);
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $8cffe22d3a2884c1$var$ta(t, n) {
    for(var r, i = [], o = 2; o < arguments.length; o++)i[o - 2] = arguments[o];
    if (t = (0, $eTAKc.getModularInstance)(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (n = $8cffe22d3a2884c1$var$V.u()), $8cffe22d3a2884c1$var$Uu("doc", "path", n), t instanceof $8cffe22d3a2884c1$var$Yu) return $8cffe22d3a2884c1$var$Ku(r = $8cffe22d3a2884c1$var$H.fromString.apply($8cffe22d3a2884c1$var$H, (0, $2WUgS.__spreadArray)([
        n
    ], i))), new $8cffe22d3a2884c1$var$$u(t, /* converter= */ null, new $8cffe22d3a2884c1$var$ct(r));
    if (!(t instanceof $8cffe22d3a2884c1$var$$u || t instanceof $8cffe22d3a2884c1$var$Ju)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
    return $8cffe22d3a2884c1$var$Ku(r = t._path.child($8cffe22d3a2884c1$var$H.fromString.apply($8cffe22d3a2884c1$var$H, (0, $2WUgS.__spreadArray)([
        n
    ], i)))), new $8cffe22d3a2884c1$var$$u(t.firestore, t instanceof $8cffe22d3a2884c1$var$Ju ? t.converter : null, new $8cffe22d3a2884c1$var$ct(r));
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $8cffe22d3a2884c1$var$ea(t, e) {
    return t = (0, $eTAKc.getModularInstance)(t), e = (0, $eTAKc.getModularInstance)(e), (t instanceof $8cffe22d3a2884c1$var$$u || t instanceof $8cffe22d3a2884c1$var$Ju) && (e instanceof $8cffe22d3a2884c1$var$$u || e instanceof $8cffe22d3a2884c1$var$Ju) && t.firestore === e.firestore && t.path === e.path && t.converter === e.converter /**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ ;
}
function $8cffe22d3a2884c1$var$na(t, e) {
    return t = (0, $eTAKc.getModularInstance)(t), e = (0, $eTAKc.getModularInstance)(e), t instanceof $8cffe22d3a2884c1$var$Xu && e instanceof $8cffe22d3a2884c1$var$Xu && t.firestore === e.firestore && $8cffe22d3a2884c1$var$ie(t._query, e._query) && t.converter === e.converter /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ ;
}
var $8cffe22d3a2884c1$var$ra = /** @class */ function() {
    function t() {
        var t = this;
        // The last promise in the queue.
        this.dc = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.wc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this._c = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.mc = [], // visible for testing
        this.yc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.gc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Ec = !1, // List of TimerIds to fast-forward delays for.
        this.Tc = [], // Backoff timer used to schedule retries for retryable operations
        this.Zi = new $8cffe22d3a2884c1$var$xo(this, "async_queue_retry" /* AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Ic = function() {
            var e = $8cffe22d3a2884c1$var$ko();
            e && $8cffe22d3a2884c1$var$C("AsyncQueue", "Visibility state changed to " + e.visibilityState), t.Zi.Gi();
        };
        var e = $8cffe22d3a2884c1$var$ko();
        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.Ic);
    }
    return Object.defineProperty(t.prototype, "isShuttingDown", {
        get: function() {
            return this._c;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ t.prototype.enqueueAndForget = function(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }, t.prototype.enqueueAndForgetEvenWhileRestricted = function(t) {
        this.Ac(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Rc(t);
    }, t.prototype.enterRestrictedMode = function(t) {
        if (!this._c) {
            this._c = !0, this.Ec = t || !1;
            var e = $8cffe22d3a2884c1$var$ko();
            e && "function" == typeof e.removeEventListener && e.removeEventListener("visibilitychange", this.Ic);
        }
    }, t.prototype.enqueue = function(t) {
        var e = this;
        if (this.Ac(), this._c) // Return a Promise which never resolves.
        return new Promise(function() {});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        var n = new $8cffe22d3a2884c1$var$br;
        return this.Rc(function() {
            return e._c && e.Ec ? Promise.resolve() : (t().then(n.resolve, n.reject), n.promise);
        }).then(function() {
            return n.promise;
        });
    }, t.prototype.enqueueRetryable = function(t) {
        var e = this;
        this.enqueueAndForget(function() {
            return e.wc.push(t), e.bc();
        });
    }, /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ t.prototype.bc = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t, e = this;
            return (0, $2WUgS.__generator)(this, function(n) {
                switch(n.label){
                    case 0:
                        if (0 === this.wc.length) return [
                            3 /*break*/ ,
                            5
                        ];
                        n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4 /*yield*/ ,
                            this.wc[0]()
                        ];
                    case 2:
                        return n.sent(), this.wc.shift(), this.Zi.reset(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        if (!$8cffe22d3a2884c1$var$Nr(t = n.sent())) throw t;
                        // Failure will be handled by AsyncQueue
                        return $8cffe22d3a2884c1$var$C("AsyncQueue", "Operation failed with retryable error: " + t), [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        this.wc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
                        // This is necessary to run retryable operations that failed during
                        // their initial attempt since we don't know whether they are already
                        // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
                        // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
                        // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
                        // call scheduled here.
                        // Since `backoffAndRun()` cancels an existing backoff and schedules a
                        // new backoff on every call, there is only ever a single additional
                        // operation in the queue.
                        this.Zi.ji(function() {
                            return e.bc();
                        }), n.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.Rc = function(t) {
        var e = this, n = this.dc.then(function() {
            return e.gc = !0, t().catch(function(t) {
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw e.yc = t, e.gc = !1, $8cffe22d3a2884c1$var$x("INTERNAL UNHANDLED ERROR: ", /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function(t) {
                    var e = t.message || "";
                    return t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack), e;
                }(t)), t;
            }).then(function(t) {
                return e.gc = !1, t;
            });
        });
        return this.dc = n, n;
    }, t.prototype.enqueueAfterDelay = function(t, e, n) {
        var r = this;
        this.Ac(), // Fast-forward delays for timerIds that have been overriden.
        this.Tc.indexOf(t) > -1 && (e = 0);
        var i = $8cffe22d3a2884c1$var$cs.createAndSchedule(this, t, e, n, function(t) {
            return r.vc(t);
        });
        return this.mc.push(i), i;
    }, t.prototype.Ac = function() {
        this.yc && $8cffe22d3a2884c1$var$O();
    }, t.prototype.verifyOperationInProgress = function() {}, /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ t.prototype.Pc = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var t;
            return (0, $2WUgS.__generator)(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            t = this.dc
                        ];
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        if (t !== this.dc) return [
                            3 /*break*/ ,
                            0
                        ];
                        e.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ t.prototype.Vc = function(t) {
        for(var e = 0, n = this.mc; e < n.length; e++){
            if (n[e].timerId === t) return !0;
        }
        return !1;
    }, /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ t.prototype.Sc = function(t) {
        var e = this;
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Pc().then(function() {
            // Run ops in the same order they'd run if they ran naturally.
            e.mc.sort(function(t, e) {
                return t.targetTimeMs - e.targetTimeMs;
            });
            for(var n = 0, r = e.mc; n < r.length; n++){
                var i = r[n];
                if (i.skipDelay(), "all" /* All */  !== t && i.timerId === t) break;
            }
            return e.Pc();
        });
    }, /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ t.prototype.Dc = function(t) {
        this.Tc.push(t);
    }, /** Called once a DelayedOperation is run or canceled. */ t.prototype.vc = function(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        var e = this.mc.indexOf(t);
        this.mc.splice(e, 1);
    }, t;
}();
function $8cffe22d3a2884c1$var$ia(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function(t, e) {
        if ("object" != typeof t || null === t) return !1;
        for(var n = t, r = 0, i = [
            "next",
            "error",
            "complete"
        ]; r < i.length; r++){
            var o = i[r];
            if (o in n && "function" == typeof n[o]) return !0;
        }
        return !1;
    }(t);
}
var $8cffe22d3a2884c1$var$oa = /** @class */ function() {
    function t() {
        this._progressObserver = {}, this._taskCompletionResolver = new $8cffe22d3a2884c1$var$br, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        } /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ ;
    }
    return t.prototype.onProgress = function(t, e, n) {
        this._progressObserver = {
            next: t,
            error: e,
            complete: n
        };
    }, /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ t.prototype.catch = function(t) {
        return this._taskCompletionResolver.promise.catch(t);
    }, /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ t.prototype.then = function(t, e) {
        return this._taskCompletionResolver.promise.then(t, e);
    }, /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ t.prototype._completeWith = function(t) {
        this._updateProgress(t), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(t);
    }, /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ t.prototype._failWith = function(t) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(t), this._taskCompletionResolver.reject(t);
    }, /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ t.prototype._updateProgress = function(t) {
        this._lastProgress = t, this._progressObserver.next && this._progressObserver.next(t);
    }, t;
}(), $8cffe22d3a2884c1$export$a9c23c6ac3fc3eca = -1, $8cffe22d3a2884c1$export$971d5caa766a69d7 = /** @class */ function(e) {
    /** @hideconstructor */ function n(t, n) {
        var r = this;
        /**
             * Whether it's a {@link Firestore} or Firestore Lite instance.
             */ return (r = e.call(this, t, n) || this).type = "firestore", r._queue = new $8cffe22d3a2884c1$var$ra, r._persistenceKey = "name" in t ? t.name : "[DEFAULT]", r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._terminate = function() {
        return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        $8cffe22d3a2884c1$var$ca(this), this._firestoreClient.terminate();
    }, n;
}($8cffe22d3a2884c1$var$Yu);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** DOMException error code constants. */ /**
 * @internal
 */ function $8cffe22d3a2884c1$var$aa(t) {
    return t._firestoreClient || $8cffe22d3a2884c1$var$ca(t), t._firestoreClient.verifyNotTerminated(), t._firestoreClient;
}
function $8cffe22d3a2884c1$var$ca(t) {
    var e, n = t._freezeSettings(), r = function(t, e, n, r) {
        return new $8cffe22d3a2884c1$var$xu(t, e, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, r.useFetchStreams);
    }(t._databaseId, (null === (e = t._app) || void 0 === e ? void 0 : e.options.appId) || "", t._persistenceKey, n);
    t._firestoreClient = new $8cffe22d3a2884c1$var$wu(t._credentials, t._queue, r);
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link getFirestore} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 */ /**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $8cffe22d3a2884c1$var$ha(t, e, i) {
    var o = this, s = new $8cffe22d3a2884c1$var$br;
    return t.asyncQueue.enqueue(function() {
        return (0, $2WUgS.__awaiter)(o, void 0, void 0, function() {
            var n;
            return (0, $2WUgS.__generator)(this, function(r) {
                switch(r.label){
                    case 0:
                        return r.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$bu(t, i)
                        ];
                    case 1:
                        return r.sent(), [
                            4 /*yield*/ ,
                            $8cffe22d3a2884c1$var$Iu(t, e)
                        ];
                    case 2:
                        return r.sent(), s.resolve(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        if (!/**
         * Decides whether the provided error allows us to gracefully disable
         * persistence (as opposed to crashing the client).
         */ function(t) {
                            return "FirebaseError" === t.name ? t.code === $8cffe22d3a2884c1$var$N.FAILED_PRECONDITION || t.code === $8cffe22d3a2884c1$var$N.UNIMPLEMENTED : !("undefined" != typeof DOMException && t instanceof DOMException) || 22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
                            // INVALID_STATE for any usage.
                            11 === t.code;
                        }(n = r.sent())) throw n;
                        return console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + n), s.reject(n), [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }).then(function() {
        return s.promise;
    });
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $8cffe22d3a2884c1$var$fa(t) {
    if (t._initialized || t._terminated) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ var $8cffe22d3a2884c1$var$la = /** @class */ function() {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ function t() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        for(var n = 0; n < t.length; ++n)if (0 === t[n].length) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $8cffe22d3a2884c1$var$$(t);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ return t.prototype.isEqual = function(t) {
        return this._internalPath.isEqual(t._internalPath);
    }, t;
}(), $8cffe22d3a2884c1$var$da = /** @class */ function() {
    /** @hideconstructor */ function t(t) {
        this._byteString = t;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ return t.fromBase64String = function(e) {
        try {
            return new t($8cffe22d3a2884c1$var$J.fromBase64String(e));
        } catch (e) {
            throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }, /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ t.fromUint8Array = function(e) {
        return new t($8cffe22d3a2884c1$var$J.fromUint8Array(e));
    }, /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ t.prototype.toBase64 = function() {
        return this._byteString.toBase64();
    }, /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ t.prototype.toUint8Array = function() {
        return this._byteString.toUint8Array();
    }, /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ t.prototype.toString = function() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }, /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ t.prototype.isEqual = function(t) {
        return this._byteString.isEqual(t._byteString);
    }, t;
}(), $8cffe22d3a2884c1$var$pa = /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ function(t) {
    this._methodName = t;
}, $8cffe22d3a2884c1$export$e7094788287c5e9b = /** @class */ function() {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ function t(t, e) {
        if (!isFinite(t) || t < -90 || t > 90) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
        this._lat = t, this._long = e;
    }
    return Object.defineProperty(t.prototype, "latitude", {
        /**
         * The latitude of this `GeoPoint` instance.
         */ get: function() {
            return this._lat;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "longitude", {
        /**
         * The longitude of this `GeoPoint` instance.
         */ get: function() {
            return this._long;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ t.prototype.isEqual = function(t) {
        return this._lat === t._lat && this._long === t._long;
    }, /** Returns a JSON-serializable representation of this GeoPoint. */ t.prototype.toJSON = function() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }, /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ t.prototype._compareTo = function(t) {
        return $8cffe22d3a2884c1$var$q(this._lat, t._lat) || $8cffe22d3a2884c1$var$q(this._long, t._long);
    }, t;
}(), $8cffe22d3a2884c1$var$va = /^__.*__$/, $8cffe22d3a2884c1$var$ma = /** @class */ function() {
    function t(t, e, n) {
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    return t.prototype.toMutation = function(t, e) {
        return null !== this.fieldMask ? new $8cffe22d3a2884c1$var$Fe(t, this.data, this.fieldMask, e, this.fieldTransforms) : new $8cffe22d3a2884c1$var$Pe(t, this.data, e, this.fieldTransforms);
    }, t;
}(), $8cffe22d3a2884c1$var$ga = /** @class */ function() {
    function t(t, // The fieldMask does not include document transforms.
    e, n) {
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    return t.prototype.toMutation = function(t, e) {
        return new $8cffe22d3a2884c1$var$Fe(t, this.data, this.fieldMask, e, this.fieldTransforms);
    }, t;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ function $8cffe22d3a2884c1$var$wa(t) {
    switch(t){
        case 0 /* Set */ :
        // fall through
        case 2 /* MergeSet */ :
        // fall through
        case 1 /* Update */ :
            return !0;
        case 3 /* Argument */ :
        case 4 /* ArrayArgument */ :
            return !1;
        default:
            throw $8cffe22d3a2884c1$var$O();
    }
}
/** A "context" object passed around while parsing user data. */ var $8cffe22d3a2884c1$var$ba = /** @class */ function() {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ function t(t, e, n, r, i, o) {
        this.settings = t, this.databaseId = e, this.R = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Cc(), this.fieldTransforms = i || [], this.fieldMask = o || [];
    }
    return Object.defineProperty(t.prototype, "path", {
        get: function() {
            return this.settings.path;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "Nc", {
        get: function() {
            return this.settings.Nc;
        },
        enumerable: !1,
        configurable: !0
    }), /** Returns a new context with the specified settings overwritten. */ t.prototype.xc = function(e) {
        return new t(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.R, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }, t.prototype.kc = function(t) {
        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.xc({
            path: n,
            Fc: !1
        });
        return r.$c(t), r;
    }, t.prototype.Oc = function(t) {
        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.xc({
            path: n,
            Fc: !1
        });
        return r.Cc(), r;
    }, t.prototype.Mc = function(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.xc({
            path: void 0,
            Fc: !0
        });
    }, t.prototype.Lc = function(t) {
        return $8cffe22d3a2884c1$var$Ua(t, this.settings.methodName, this.settings.Bc || !1, this.path, this.settings.qc);
    }, /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ t.prototype.contains = function(t) {
        return void 0 !== this.fieldMask.find(function(e) {
            return t.isPrefixOf(e);
        }) || void 0 !== this.fieldTransforms.find(function(e) {
            return t.isPrefixOf(e.field);
        });
    }, t.prototype.Cc = function() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(var t = 0; t < this.path.length; t++)this.$c(this.path.get(t));
    }, t.prototype.$c = function(t) {
        if (0 === t.length) throw this.Lc("Document fields must not be empty");
        if ($8cffe22d3a2884c1$var$wa(this.Nc) && $8cffe22d3a2884c1$var$va.test(t)) throw this.Lc('Document fields cannot begin and end with "__"');
    }, t;
}(), $8cffe22d3a2884c1$var$Ia = /** @class */ function() {
    function t(t, e, n) {
        this.databaseId = t, this.ignoreUndefinedProperties = e, this.R = n || $8cffe22d3a2884c1$var$Co(t) /** Creates a new top-level parse context. */ ;
    }
    return t.prototype.Uc = function(t, e, n, r) {
        return void 0 === r && (r = !1), new $8cffe22d3a2884c1$var$ba({
            Nc: t,
            methodName: e,
            qc: n,
            path: $8cffe22d3a2884c1$var$$.emptyPath(),
            Fc: !1,
            Bc: r
        }, this.databaseId, this.R, this.ignoreUndefinedProperties);
    }, t;
}();
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ function $8cffe22d3a2884c1$var$Ta(t) {
    var e = t._freezeSettings(), n = $8cffe22d3a2884c1$var$Co(t._databaseId);
    return new $8cffe22d3a2884c1$var$Ia(t._databaseId, !!e.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $8cffe22d3a2884c1$var$_a(t, e, n, r, i, o) {
    void 0 === o && (o = {});
    var s = t.Uc(o.merge || o.mergeFields ? 2 /* MergeSet */  : 0 /* Set */ , e, n, i);
    $8cffe22d3a2884c1$var$Fa("Data must be an object, but it was:", s, r);
    var u, a, c = $8cffe22d3a2884c1$var$Oa(r, s);
    if (o.merge) u = new $8cffe22d3a2884c1$var$X(s.fieldMask), a = s.fieldTransforms;
    else if (o.mergeFields) {
        for(var h = [], f = 0, l = o.mergeFields; f < l.length; f++){
            var d = $8cffe22d3a2884c1$var$Ma(e, l[f], n);
            if (!s.contains(d)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Field '" + d + "' is specified in your field mask but missing from your input data.");
            $8cffe22d3a2884c1$var$Ba(h, d) || h.push(d);
        }
        u = new $8cffe22d3a2884c1$var$X(h), a = s.fieldTransforms.filter(function(t) {
            return u.covers(t.field);
        });
    } else u = null, a = s.fieldTransforms;
    return new $8cffe22d3a2884c1$var$ma(new $8cffe22d3a2884c1$var$Et(c), u, a);
}
var $8cffe22d3a2884c1$var$Ea = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._toFieldTransform = function(t) {
        if (2 /* MergeSet */  !== t.Nc) throw 1 /* Update */  === t.Nc ? t.Lc(this._methodName + "() can only appear at the top level of your update data") : t.Lc(this._methodName + "() cannot be used with set() unless you pass {merge:true}");
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.fieldMask.push(t.path), null;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n;
    }, n;
}($8cffe22d3a2884c1$var$pa);
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $8cffe22d3a2884c1$var$Sa(t, e, n) {
    return new $8cffe22d3a2884c1$var$ba({
        Nc: 3 /* Argument */ ,
        qc: e.settings.qc,
        methodName: t._methodName,
        Fc: n
    }, e.databaseId, e.R, e.ignoreUndefinedProperties);
}
var $8cffe22d3a2884c1$var$Na = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._toFieldTransform = function(t) {
        return new $8cffe22d3a2884c1$var$Se(t.path, new $8cffe22d3a2884c1$var$me);
    }, n.prototype.isEqual = function(t) {
        return t instanceof n;
    }, n;
}($8cffe22d3a2884c1$var$pa), $8cffe22d3a2884c1$var$Da = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t) || this).Kc = n, r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._toFieldTransform = function(t) {
        var e = $8cffe22d3a2884c1$var$Sa(this, t, /*array=*/ !0), n = this.Kc.map(function(t) {
            return $8cffe22d3a2884c1$var$La(t, e);
        }), r = new $8cffe22d3a2884c1$var$ge(n);
        return new $8cffe22d3a2884c1$var$Se(t.path, r);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($8cffe22d3a2884c1$var$pa), $8cffe22d3a2884c1$var$Aa = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t) || this).Kc = n, r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._toFieldTransform = function(t) {
        var e = $8cffe22d3a2884c1$var$Sa(this, t, /*array=*/ !0), n = this.Kc.map(function(t) {
            return $8cffe22d3a2884c1$var$La(t, e);
        }), r = new $8cffe22d3a2884c1$var$be(n);
        return new $8cffe22d3a2884c1$var$Se(t.path, r);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($8cffe22d3a2884c1$var$pa), $8cffe22d3a2884c1$var$ka = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t) || this).Qc = n, r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._toFieldTransform = function(t) {
        var e = new $8cffe22d3a2884c1$var$Te(t.R, $8cffe22d3a2884c1$var$le(t.R, this.Qc));
        return new $8cffe22d3a2884c1$var$Se(t.path, e);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($8cffe22d3a2884c1$var$pa);
/** Parse update data from an update() call. */ function $8cffe22d3a2884c1$var$Ca(t, e, n, r) {
    var i = t.Uc(1 /* Update */ , e, n);
    $8cffe22d3a2884c1$var$Fa("Data must be an object, but it was:", i, r);
    var o = [], s = $8cffe22d3a2884c1$var$Et.empty();
    $8cffe22d3a2884c1$var$Q(r, function(t, r) {
        var u = $8cffe22d3a2884c1$var$qa(e, t, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $eTAKc.getModularInstance)(r);
        var a = i.Oc(u);
        if (r instanceof $8cffe22d3a2884c1$var$Ea) // Add it to the field mask, but don't add anything to updateData.
        o.push(u);
        else {
            var c = $8cffe22d3a2884c1$var$La(r, a);
            null != c && (o.push(u), s.set(u, c));
        }
    });
    var u = new $8cffe22d3a2884c1$var$X(o);
    return new $8cffe22d3a2884c1$var$ga(s, u, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $8cffe22d3a2884c1$var$xa(t, e, n, r, i, o) {
    var s = t.Uc(1 /* Update */ , e, n), u = [
        $8cffe22d3a2884c1$var$Ma(e, r, n)
    ], a = [
        i
    ];
    if (o.length % 2 != 0) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Function " + e + "() needs to be called with an even number of arguments that alternate between field names and values.");
    for(var c = 0; c < o.length; c += 2)u.push($8cffe22d3a2884c1$var$Ma(e, o[c])), a.push(o[c + 1]);
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(var h = [], f = $8cffe22d3a2884c1$var$Et.empty(), d = u.length - 1; d >= 0; --d)if (!$8cffe22d3a2884c1$var$Ba(h, u[d])) {
        var p = u[d], y = a[d];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        y = (0, $eTAKc.getModularInstance)(y);
        var v = s.Oc(p);
        if (y instanceof $8cffe22d3a2884c1$var$Ea) // Add it to the field mask, but don't add anything to updateData.
        h.push(p);
        else {
            var m = $8cffe22d3a2884c1$var$La(y, v);
            null != m && (h.push(p), f.set(p, m));
        }
    }
    var g = new $8cffe22d3a2884c1$var$X(h);
    return new $8cffe22d3a2884c1$var$ga(f, g, s.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $8cffe22d3a2884c1$var$Ra(t, e, n, r) {
    return void 0 === r && (r = !1), $8cffe22d3a2884c1$var$La(n, t.Uc(r ? 4 /* ArrayArgument */  : 3 /* Argument */ , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $8cffe22d3a2884c1$var$La(t, e) {
    if ($8cffe22d3a2884c1$var$Pa(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    t = (0, $eTAKc.getModularInstance)(t))) return $8cffe22d3a2884c1$var$Fa("Unsupported field value:", e, t), $8cffe22d3a2884c1$var$Oa(t, e);
    if (t instanceof $8cffe22d3a2884c1$var$pa) // FieldValues usually parse into transforms (except FieldValue.delete())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */ return function(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$8cffe22d3a2884c1$var$wa(e.Nc)) throw e.Lc(t._methodName + "() can only be used with update() and set()");
        if (!e.path) throw e.Lc(t._methodName + "() is not currently supported inside arrays");
        var n = t._toFieldTransform(e);
        n && e.fieldTransforms.push(n);
    }(t, e), null;
    if (void 0 === t && e.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.fieldMask.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.Fc && 4 /* ArrayArgument */  !== e.Nc) throw e.Lc("Nested arrays are not supported");
        return function(t, e) {
            for(var n = [], r = 0, i = 0, o = t; i < o.length; i++){
                var s = $8cffe22d3a2884c1$var$La(o[i], e.Mc(r));
                null == s && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (s = {
                    nullValue: "NULL_VALUE"
                }), n.push(s), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(t, e);
    }
    return function(t, e) {
        if (null === (t = (0, $eTAKc.getModularInstance)(t))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return $8cffe22d3a2884c1$var$le(e.R, t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            var n = $8cffe22d3a2884c1$export$3a1a48c8f6ef640e.fromDate(t);
            return {
                timestampValue: $8cffe22d3a2884c1$var$In(e.R, n)
            };
        }
        if (t instanceof $8cffe22d3a2884c1$export$3a1a48c8f6ef640e) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            n = new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: $8cffe22d3a2884c1$var$In(e.R, n)
            };
        }
        if (t instanceof $8cffe22d3a2884c1$export$e7094788287c5e9b) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $8cffe22d3a2884c1$var$da) return {
            bytesValue: $8cffe22d3a2884c1$var$Tn(e.R, t._byteString)
        };
        if (t instanceof $8cffe22d3a2884c1$var$$u) {
            n = e.databaseId;
            var r = t.firestore._databaseId;
            if (!r.isEqual(n)) throw e.Lc("Document reference is for database " + r.projectId + "/" + r.database + " but should be for database " + n.projectId + "/" + n.database);
            return {
                referenceValue: $8cffe22d3a2884c1$var$Sn(t.firestore._databaseId || e.databaseId, t._key.path)
            };
        }
        throw e.Lc("Unsupported field value: " + $8cffe22d3a2884c1$var$Qu(t));
    }(t, e);
}
function $8cffe22d3a2884c1$var$Oa(t, e) {
    var n = {};
    return $8cffe22d3a2884c1$var$z(t) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.fieldMask.push(e.path) : $8cffe22d3a2884c1$var$Q(t, function(t, r) {
        var i = $8cffe22d3a2884c1$var$La(r, e.kc(t));
        null != i && (n[t] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $8cffe22d3a2884c1$var$Pa(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $8cffe22d3a2884c1$export$3a1a48c8f6ef640e || t instanceof $8cffe22d3a2884c1$export$e7094788287c5e9b || t instanceof $8cffe22d3a2884c1$var$da || t instanceof $8cffe22d3a2884c1$var$$u || t instanceof $8cffe22d3a2884c1$var$pa);
}
function $8cffe22d3a2884c1$var$Fa(t, e, n) {
    if (!$8cffe22d3a2884c1$var$Pa(n) || !function(t) {
        return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
    }(n)) {
        var r = $8cffe22d3a2884c1$var$Qu(n);
        throw "an object" === r ? e.Lc(t + " a custom object") : e.Lc(t + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $8cffe22d3a2884c1$var$Ma(t, e, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (e = (0, $eTAKc.getModularInstance)(e)) instanceof $8cffe22d3a2884c1$var$la) return e._internalPath;
    if ("string" == typeof e) return $8cffe22d3a2884c1$var$qa(t, e);
    throw $8cffe22d3a2884c1$var$Ua("Field path arguments must be of type string or FieldPath.", t, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ var $8cffe22d3a2884c1$var$Va = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $8cffe22d3a2884c1$var$qa(t, n, r) {
    if (n.search($8cffe22d3a2884c1$var$Va) >= 0) throw $8cffe22d3a2884c1$var$Ua("Invalid field path (" + n + "). Paths must not contain '~', '*', '/', '[', or ']'", t, /* hasConverter= */ !1, /* path= */ void 0, r);
    try {
        return (new ($8cffe22d3a2884c1$var$la.bind.apply($8cffe22d3a2884c1$var$la, (0, $2WUgS.__spreadArray)([
            void 0
        ], n.split(".")))))._internalPath;
    } catch (e) {
        throw $8cffe22d3a2884c1$var$Ua("Invalid field path (" + n + "). Paths must not be empty, begin with '.', end with '.', or contain '..'", t, /* hasConverter= */ !1, /* path= */ void 0, r);
    }
}
function $8cffe22d3a2884c1$var$Ua(t, e, n, r, i) {
    var o = r && !r.isEmpty(), s = void 0 !== i, u = "Function " + e + "() called with invalid data";
    n && (u += " (via `toFirestore()`)");
    var a = "";
    return (o || s) && (a += " (found", o && (a += " in field " + r), s && (a += " in document " + i), a += ")"), new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, (u += ". ") + t + a) /** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ ;
}
function $8cffe22d3a2884c1$var$Ba(t, e) {
    return t.some(function(t) {
        return t.isEqual(e);
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ var $8cffe22d3a2884c1$var$ja = /** @class */ function() {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ function t(t, e, n, r, i) {
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = r, this._converter = i;
    }
    return Object.defineProperty(t.prototype, "id", {
        /** Property of the `DocumentSnapshot` that provides the document's ID. */ get: function() {
            return this._key.path.lastSegment();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ref", {
        /**
         * The `DocumentReference` for the document included in the `DocumentSnapshot`.
         */ get: function() {
            return new $8cffe22d3a2884c1$var$$u(this._firestore, this._converter, this._key);
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ t.prototype.exists = function() {
        return null !== this._document;
    }, /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ t.prototype.data = function() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                var t = new $8cffe22d3a2884c1$var$Ka(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }, /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t.prototype.get = function(t) {
        if (this._document) {
            var e = this._document.data.field($8cffe22d3a2884c1$var$Ga("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }, t;
}(), $8cffe22d3a2884c1$var$Ka = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ return (0, $2WUgS.__extends)(n, e), n.prototype.data = function() {
        return e.prototype.data.call(this);
    }, n;
}($8cffe22d3a2884c1$var$ja);
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ /**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $8cffe22d3a2884c1$var$Ga(t, e) {
    return "string" == typeof e ? $8cffe22d3a2884c1$var$qa(t, e) : e instanceof $8cffe22d3a2884c1$var$la ? e._internalPath : e._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ var $8cffe22d3a2884c1$var$Qa = /** @class */ function() {
    /** @hideconstructor */ function t(t, e) {
        this.hasPendingWrites = t, this.fromCache = e /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ ;
    }
    return t.prototype.isEqual = function(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }, t;
}(), $8cffe22d3a2884c1$var$za = /** @class */ function(e) {
    /** @hideconstructor protected */ function n(t, n, r, i, o, s) {
        var u = this;
        return (u = e.call(this, t, n, r, i, s) || this)._firestore = t, u._firestoreImpl = t, u.metadata = o, u;
    }
    /**
     * Property of the `DocumentSnapshot` that signals whether or not the data
     * exists. True if the document exists.
     */ return (0, $2WUgS.__extends)(n, e), n.prototype.exists = function() {
        return e.prototype.exists.call(this);
    }, /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `FieldValue.serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ n.prototype.data = function(t) {
        if (void 0 === t && (t = {}), this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                var e = new $8cffe22d3a2884c1$var$Wa(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }, /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `FieldValue.serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    n.prototype.get = function(t, e) {
        if (void 0 === e && (e = {}), this._document) {
            var n = this._document.data.field($8cffe22d3a2884c1$var$Ga("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }, n;
}($8cffe22d3a2884c1$var$ja), $8cffe22d3a2884c1$var$Wa = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `FieldValue.serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ return (0, $2WUgS.__extends)(n, e), n.prototype.data = function(t) {
        return void 0 === t && (t = {}), e.prototype.data.call(this, t);
    }, n;
}($8cffe22d3a2884c1$var$za), $8cffe22d3a2884c1$var$Ha = /** @class */ function() {
    /** @hideconstructor */ function t(t, e, n, r) {
        this._firestore = t, this._userDataWriter = e, this._snapshot = r, this.metadata = new $8cffe22d3a2884c1$var$Qa(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    return Object.defineProperty(t.prototype, "docs", {
        /** An array of all the documents in the `QuerySnapshot`. */ get: function() {
            var t = [];
            return this.forEach(function(e) {
                return t.push(e);
            }), t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
        /** The number of documents in the `QuerySnapshot`. */ get: function() {
            return this._snapshot.docs.size;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "empty", {
        /** True if there are no documents in the `QuerySnapshot`. */ get: function() {
            return 0 === this.size;
        },
        enumerable: !1,
        configurable: !0
    }), /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ t.prototype.forEach = function(t, e) {
        var n = this;
        this._snapshot.docs.forEach(function(r) {
            t.call(e, new $8cffe22d3a2884c1$var$Wa(n._firestore, n._userDataWriter, r.key, r, new $8cffe22d3a2884c1$var$Qa(n._snapshot.mutatedKeys.has(r.key), n._snapshot.fromCache), n.query.converter));
        });
    }, /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ t.prototype.docChanges = function(t) {
        void 0 === t && (t = {});
        var e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                var n = 0;
                return t._snapshot.docChanges.map(function(e) {
                    return {
                        type: "added",
                        doc: new $8cffe22d3a2884c1$var$Wa(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $8cffe22d3a2884c1$var$Qa(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter),
                        oldIndex: -1,
                        newIndex: n++
                    };
                });
            }
            // A `DocumentSet` that is updated incrementally as changes are applied to use
            // to lookup the index of a document.
            var r = t._snapshot.oldDocs;
            return t._snapshot.docChanges.filter(function(t) {
                return e || 3 /* Metadata */  !== t.type;
            }).map(function(e) {
                var n = new $8cffe22d3a2884c1$var$Wa(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $8cffe22d3a2884c1$var$Qa(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter), i = -1, o = -1;
                return 0 /* Added */  !== e.type && (i = r.indexOf(e.doc.key), r = r.delete(e.doc.key)), 1 /* Removed */  !== e.type && (o = (r = r.add(e.doc)).indexOf(e.doc.key)), {
                    type: $8cffe22d3a2884c1$var$Ya(e.type),
                    doc: n,
                    oldIndex: i,
                    newIndex: o
                };
            });
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }, t;
}();
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ function $8cffe22d3a2884c1$var$Ya(t) {
    switch(t){
        case 0 /* Added */ :
            return "added";
        case 2 /* Modified */ :
        case 3 /* Metadata */ :
            return "modified";
        case 1 /* Removed */ :
            return "removed";
        default:
            return $8cffe22d3a2884c1$var$O();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $8cffe22d3a2884c1$var$$a(t, e) {
    return t instanceof $8cffe22d3a2884c1$var$za && e instanceof $8cffe22d3a2884c1$var$za ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $8cffe22d3a2884c1$var$Ha && e instanceof $8cffe22d3a2884c1$var$Ha && t._firestore === e._firestore && $8cffe22d3a2884c1$var$na(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8cffe22d3a2884c1$var$Xa(t) {
    if ($8cffe22d3a2884c1$var$Xt(t) && 0 === t.explicitOrderBy.length) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * endBefore:1}, {@link (endAt:1)}, {@link limit} or {@link limitToLast} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ var $8cffe22d3a2884c1$var$Ja = function() {};
/**
 * Creates a new immutable instance of {@link Query} that is extended to also include
 * additional query constraints.
 *
 * @param query - The {@link Query} instance to use as a base for the new constraints.
 * @param queryConstraints - The list of {@link QueryConstraint}s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $8cffe22d3a2884c1$var$Za(t) {
    for(var e = [], n = 1; n < arguments.length; n++)e[n - 1] = arguments[n];
    for(var r = 0, i = e; r < i.length; r++){
        var o = i[r];
        t = o._apply(t);
    }
    return t;
}
var $8cffe22d3a2884c1$var$tc = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).jc = t, i.Wc = n, i.Gc = r, i.type = "where", i;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._apply = function(t) {
        var e = $8cffe22d3a2884c1$var$Ta(t.firestore), n = function(t, e, n, r, i, o, s) {
            var u;
            if (i.isKeyField()) {
                if ("array-contains" /* ARRAY_CONTAINS */  === o || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === o) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + o + "' queries on FieldPath.documentId().");
                if ("in" /* IN */  === o || "not-in" /* NOT_IN */  === o) {
                    $8cffe22d3a2884c1$var$uc(s, o);
                    for(var a = [], c = 0, h = s; c < h.length; c++){
                        var f = h[c];
                        a.push($8cffe22d3a2884c1$var$sc(r, t, f));
                    }
                    u = {
                        arrayValue: {
                            values: a
                        }
                    };
                } else u = $8cffe22d3a2884c1$var$sc(r, t, s);
            } else "in" /* IN */  !== o && "not-in" /* NOT_IN */  !== o && "array-contains-any" /* ARRAY_CONTAINS_ANY */  !== o || $8cffe22d3a2884c1$var$uc(s, o), u = $8cffe22d3a2884c1$var$Ra(n, "where", s, /* allowArrays= */ "in" /* IN */  === o || "not-in" /* NOT_IN */  === o);
            var l = $8cffe22d3a2884c1$var$Rt.create(i, o, u);
            return function(t, e) {
                if (e.g()) {
                    var n = $8cffe22d3a2884c1$var$Zt(t);
                    if (null !== n && !n.isEqual(e.field)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '" + n.toString() + "' and '" + e.field.toString() + "'");
                    var r = $8cffe22d3a2884c1$var$Jt(t);
                    null !== r && $8cffe22d3a2884c1$var$ac(t, e.field, r);
                }
                var i = function(t, e) {
                    for(var n = 0, r = t.filters; n < r.length; n++){
                        var i = r[n];
                        if (e.indexOf(i.op) >= 0) return i.op;
                    }
                    return null;
                }(t, /**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one array operator is allowed.
 * 2. Only one disjunctive operator is allowed.
 * 3. `NOT_EQUAL` cannot be used with another `NOT_EQUAL` operator.
 * 4. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 *
 * Array operators: `ARRAY_CONTAINS`, `ARRAY_CONTAINS_ANY`
 * Disjunctive operators: `IN`, `ARRAY_CONTAINS_ANY`, `NOT_IN`
 */ function(t) {
                    switch(t){
                        case "!=" /* NOT_EQUAL */ :
                            return [
                                "!=" /* NOT_EQUAL */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "array-contains" /* ARRAY_CONTAINS */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "in" /* IN */ :
                            return [
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "array-contains-any" /* ARRAY_CONTAINS_ANY */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "not-in" /* NOT_IN */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ ,
                                "!=" /* NOT_EQUAL */ 
                            ];
                        default:
                            return [];
                    }
                }(e.op));
                if (null !== i) // Special case when it's a duplicate op to give a slightly clearer error message.
                throw i === e.op ? new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '" + e.op.toString() + "' filter.") : new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. You cannot use '" + e.op.toString() + "' filters with '" + i.toString() + "' filters.");
            }(t, l), l;
        }(t._query, 0, e, t.firestore._databaseId, this.jc, this.Wc, this.Gc);
        return new $8cffe22d3a2884c1$var$Xu(t.firestore, t.converter, function(t, e) {
            var n = t.filters.concat([
                e
            ]);
            return new $8cffe22d3a2884c1$var$Wt(t.path, t.collectionGroup, t.explicitOrderBy.slice(), n, t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, n));
    }, n;
}($8cffe22d3a2884c1$var$Ja), $8cffe22d3a2884c1$var$ec = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this) || this).jc = t, r.zc = n, r.type = "orderBy", r;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._apply = function(t) {
        var e = function(t, e, n) {
            if (null !== t.startAt) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            var r = new $8cffe22d3a2884c1$var$Kt(e, n);
            return function(t, e) {
                if (null === $8cffe22d3a2884c1$var$Jt(t)) {
                    // This is the first order by. It must match any inequality.
                    var n = $8cffe22d3a2884c1$var$Zt(t);
                    null !== n && $8cffe22d3a2884c1$var$ac(t, n, e.field);
                }
            }(t, r), r;
        }(t._query, this.jc, this.zc);
        return new $8cffe22d3a2884c1$var$Xu(t.firestore, t.converter, function(t, e) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            var n = t.explicitOrderBy.concat([
                e
            ]);
            return new $8cffe22d3a2884c1$var$Wt(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, e));
    }, n;
}($8cffe22d3a2884c1$var$Ja), $8cffe22d3a2884c1$var$nc = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).type = t, i.Hc = n, i.Jc = r, i;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._apply = function(t) {
        return new $8cffe22d3a2884c1$var$Xu(t.firestore, t.converter, $8cffe22d3a2884c1$var$re(t._query, this.Hc, this.Jc));
    }, n;
}($8cffe22d3a2884c1$var$Ja), $8cffe22d3a2884c1$var$rc = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).type = t, i.Yc = n, i.Xc = r, i;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._apply = function(t) {
        var e = $8cffe22d3a2884c1$var$oc(t, this.type, this.Yc, this.Xc);
        return new $8cffe22d3a2884c1$var$Xu(t.firestore, t.converter, function(t, e) {
            return new $8cffe22d3a2884c1$var$Wt(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, e, t.endAt);
        }(t._query, e));
    }, n;
}($8cffe22d3a2884c1$var$Ja), $8cffe22d3a2884c1$var$ic = /** @class */ function(e) {
    function n(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).type = t, i.Yc = n, i.Xc = r, i;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype._apply = function(t) {
        var e = $8cffe22d3a2884c1$var$oc(t, this.type, this.Yc, this.Xc);
        return new $8cffe22d3a2884c1$var$Xu(t.firestore, t.converter, function(t, e) {
            return new $8cffe22d3a2884c1$var$Wt(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, e);
        }(t._query, e));
    }, n;
}($8cffe22d3a2884c1$var$Ja);
/**
 * Creates a {@link QueryConstraint} that enforces that documents must contain the
 * specified field and that the value should satisfy the relation constraint
 * provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link Query}.
 */ /** Helper function to create a bound from a document or fields */ function $8cffe22d3a2884c1$var$oc(t, e, n, r) {
    if (n[0] = (0, $eTAKc.getModularInstance)(n[0]), n[0] instanceof $8cffe22d3a2884c1$var$ja) return function(t, e, n, r, i) {
        if (!r) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " + n + "().");
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for(var o = [], s = 0, u = $8cffe22d3a2884c1$var$ee(t); s < u.length; s++){
            var a = u[s];
            if (a.field.isKeyField()) o.push($8cffe22d3a2884c1$var$mt(e, r.key));
            else {
                var c = r.data.field(a.field);
                if ($8cffe22d3a2884c1$var$rt(c)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + a.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
                if (null === c) {
                    var h = a.field.canonicalString();
                    throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '" + h + "' (used as the orderBy) does not exist.");
                }
                o.push(c);
            }
        }
        return new $8cffe22d3a2884c1$var$Bt(o, i);
    }(t._query, t.firestore._databaseId, e, n[0]._document, r);
    var i = $8cffe22d3a2884c1$var$Ta(t.firestore);
    return function(t, e, n, r, i, o) {
        // Use explicit order by's because it has to match the query the user made
        var s = t.explicitOrderBy;
        if (i.length > s.length) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Too many arguments provided to " + r + "(). The number of arguments must be less than or equal to the number of orderBy() clauses");
        for(var u = [], a = 0; a < i.length; a++){
            var c = i[a];
            if (s[a].field.isKeyField()) {
                if ("string" != typeof c) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " + r + "(), but got a " + typeof c);
                if (!$8cffe22d3a2884c1$var$te(t) && -1 !== c.indexOf("/")) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), the value passed to " + r + "() must be a plain document ID, but '" + c + "' contains a slash.");
                var h = t.path.child($8cffe22d3a2884c1$var$H.fromString(c));
                if (!$8cffe22d3a2884c1$var$ct.isDocumentKey(h)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by FieldPath.documentId(), the value passed to " + r + "() must result in a valid document path, but '" + h + "' is not because it contains an odd number of segments.");
                var f = new $8cffe22d3a2884c1$var$ct(h);
                u.push($8cffe22d3a2884c1$var$mt(e, f));
            } else {
                var l = $8cffe22d3a2884c1$var$Ra(n, r, c);
                u.push(l);
            }
        }
        return new $8cffe22d3a2884c1$var$Bt(u, o);
    }(t._query, t.firestore._databaseId, i, e, n, r);
}
function $8cffe22d3a2884c1$var$sc(t, e, n) {
    if ("string" == typeof (n = (0, $eTAKc.getModularInstance)(n))) {
        if ("" === n) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$8cffe22d3a2884c1$var$te(e) && -1 !== n.indexOf("/")) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. When querying a collection by FieldPath.documentId(), you must provide a plain document ID, but '" + n + "' contains a '/' character.");
        var r = e.path.child($8cffe22d3a2884c1$var$H.fromString(n));
        if (!$8cffe22d3a2884c1$var$ct.isDocumentKey(r)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. When querying a collection group by FieldPath.documentId(), the value provided must result in a valid document path, but '" + r + "' is not because it has an odd number of segments (" + r.length + ").");
        return $8cffe22d3a2884c1$var$mt(t, new $8cffe22d3a2884c1$var$ct(r));
    }
    if (n instanceof $8cffe22d3a2884c1$var$$u) return $8cffe22d3a2884c1$var$mt(t, n._key);
    throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid string or a DocumentReference, but it was: " + $8cffe22d3a2884c1$var$Qu(n) + ".");
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $8cffe22d3a2884c1$var$uc(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '" + e.toString() + "' filters.");
    if (t.length > 10) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters support a maximum of 10 elements in the value array.");
}
function $8cffe22d3a2884c1$var$ac(t, e, n) {
    if (!n.isEqual(e)) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '" + e.toString() + "' and so you must also use '" + e.toString() + "' as your first argument to orderBy(), but your first orderBy() is on field '" + n.toString() + "' instead.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ var $8cffe22d3a2884c1$var$cc = /** @class */ function() {
    function t() {}
    return t.prototype.convertValue = function(t, e) {
        switch(void 0 === e && (e = "none"), $8cffe22d3a2884c1$var$ht(t)){
            case 0 /* NullValue */ :
                return null;
            case 1 /* BooleanValue */ :
                return t.booleanValue;
            case 2 /* NumberValue */ :
                return $8cffe22d3a2884c1$var$et(t.integerValue || t.doubleValue);
            case 3 /* TimestampValue */ :
                return this.convertTimestamp(t.timestampValue);
            case 4 /* ServerTimestampValue */ :
                return this.convertServerTimestamp(t, e);
            case 5 /* StringValue */ :
                return t.stringValue;
            case 6 /* BlobValue */ :
                return this.convertBytes($8cffe22d3a2884c1$var$nt(t.bytesValue));
            case 7 /* RefValue */ :
                return this.convertReference(t.referenceValue);
            case 8 /* GeoPointValue */ :
                return this.convertGeoPoint(t.geoPointValue);
            case 9 /* ArrayValue */ :
                return this.convertArray(t.arrayValue, e);
            case 10 /* ObjectValue */ :
                return this.convertObject(t.mapValue, e);
            default:
                throw $8cffe22d3a2884c1$var$O();
        }
    }, t.prototype.convertObject = function(t, e) {
        var n = this, r = {};
        return $8cffe22d3a2884c1$var$Q(t.fields, function(t, i) {
            r[t] = n.convertValue(i, e);
        }), r;
    }, t.prototype.convertGeoPoint = function(t) {
        return new $8cffe22d3a2884c1$export$e7094788287c5e9b($8cffe22d3a2884c1$var$et(t.latitude), $8cffe22d3a2884c1$var$et(t.longitude));
    }, t.prototype.convertArray = function(t, e) {
        var n = this;
        return (t.values || []).map(function(t) {
            return n.convertValue(t, e);
        });
    }, t.prototype.convertServerTimestamp = function(t, e) {
        switch(e){
            case "previous":
                var n = $8cffe22d3a2884c1$var$it(t);
                return null == n ? null : this.convertValue(n, e);
            case "estimate":
                return this.convertTimestamp($8cffe22d3a2884c1$var$ot(t));
            default:
                return null;
        }
    }, t.prototype.convertTimestamp = function(t) {
        var e = $8cffe22d3a2884c1$var$tt(t);
        return new $8cffe22d3a2884c1$export$3a1a48c8f6ef640e(e.seconds, e.nanos);
    }, t.prototype.convertDocumentKey = function(t, e) {
        var n = $8cffe22d3a2884c1$var$H.fromString(t);
        $8cffe22d3a2884c1$var$P($8cffe22d3a2884c1$var$$n(n));
        var r = new $8cffe22d3a2884c1$var$Ru(n.get(1), n.get(3)), i = new $8cffe22d3a2884c1$var$ct(n.popFirst(5));
        return r.isEqual(e) || // TODO(b/64130202): Somehow support foreign references.
        $8cffe22d3a2884c1$var$x("Document " + i + " contains a document reference within a different database (" + r.projectId + "/" + r.database + ") which is not supported. It will be treated as a reference in the current database (" + e.projectId + "/" + e.database + ") instead."), i;
    }, t;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $8cffe22d3a2884c1$var$hc(t, e, n) {
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e;
}
var $8cffe22d3a2884c1$var$fc = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).firestore = t, n;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.convertBytes = function(t) {
        return new $8cffe22d3a2884c1$var$da(t);
    }, n.prototype.convertReference = function(t) {
        var e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $8cffe22d3a2884c1$var$$u(this.firestore, /* converter= */ null, e);
    }, n;
}($8cffe22d3a2884c1$var$cc), $8cffe22d3a2884c1$var$lc = /** @class */ function() {
    /** @hideconstructor */ function t(t, e) {
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = $8cffe22d3a2884c1$var$Ta(t);
    }
    return t.prototype.set = function(t, e, n) {
        this._verifyNotCommitted();
        var r = $8cffe22d3a2884c1$var$dc(t, this._firestore), i = $8cffe22d3a2884c1$var$hc(r.converter, e, n), o = $8cffe22d3a2884c1$var$_a(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(o.toMutation(r._key, $8cffe22d3a2884c1$var$De.none())), this;
    }, t.prototype.update = function(t, e, n) {
        for(var r = [], i = 3; i < arguments.length; i++)r[i - 3] = arguments[i];
        this._verifyNotCommitted();
        var o, s = $8cffe22d3a2884c1$var$dc(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        return o = "string" == typeof (e = (0, $eTAKc.getModularInstance)(e)) || e instanceof $8cffe22d3a2884c1$var$la ? $8cffe22d3a2884c1$var$xa(this._dataReader, "WriteBatch.update", s._key, e, n, r) : $8cffe22d3a2884c1$var$Ca(this._dataReader, "WriteBatch.update", s._key, e), this._mutations.push(o.toMutation(s._key, $8cffe22d3a2884c1$var$De.exists(!0))), this;
    }, /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ t.prototype.delete = function(t) {
        this._verifyNotCommitted();
        var e = $8cffe22d3a2884c1$var$dc(t, this._firestore);
        return this._mutations = this._mutations.concat(new $8cffe22d3a2884c1$var$je(e._key, $8cffe22d3a2884c1$var$De.none())), this;
    }, /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ t.prototype.commit = function() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }, t.prototype._verifyNotCommitted = function() {
        if (this._committed) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }, t;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ function $8cffe22d3a2884c1$var$dc(t, e) {
    if ((t = (0, $eTAKc.getModularInstance)(t)).firestore !== e) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ var $8cffe22d3a2884c1$var$pc = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).firestore = t, n;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.convertBytes = function(t) {
        return new $8cffe22d3a2884c1$var$da(t);
    }, n.prototype.convertReference = function(t) {
        var e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $8cffe22d3a2884c1$var$$u(this.firestore, /* converter= */ null, e);
    }, n;
}($8cffe22d3a2884c1$var$cc);
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $8cffe22d3a2884c1$var$yc(t, e, n) {
    t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$$u);
    var r = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), i = $8cffe22d3a2884c1$var$hc(t.converter, e, n);
    return $8cffe22d3a2884c1$var$gc(r, [
        $8cffe22d3a2884c1$var$_a($8cffe22d3a2884c1$var$Ta(r), "setDoc", t._key, i, null !== t.converter, n).toMutation(t._key, $8cffe22d3a2884c1$var$De.none())
    ]);
}
function $8cffe22d3a2884c1$var$vc(t, e, n) {
    for(var r = [], i = 3; i < arguments.length; i++)r[i - 3] = arguments[i];
    t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$$u);
    var o = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), s = $8cffe22d3a2884c1$var$Ta(o);
    return $8cffe22d3a2884c1$var$gc(o, [
        ("string" == typeof // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        (e = (0, $eTAKc.getModularInstance)(e)) || e instanceof $8cffe22d3a2884c1$var$la ? $8cffe22d3a2884c1$var$xa(s, "updateDoc", t._key, e, n, r) : $8cffe22d3a2884c1$var$Ca(s, "updateDoc", t._key, e)).toMutation(t._key, $8cffe22d3a2884c1$var$De.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $8cffe22d3a2884c1$var$mc(t) {
    for(var e, i, o, s = [], u = 1; u < arguments.length; u++)s[u - 1] = arguments[u];
    t = (0, $eTAKc.getModularInstance)(t);
    var a = {
        includeMetadataChanges: !1
    }, c = 0;
    "object" != typeof s[c] || $8cffe22d3a2884c1$var$ia(s[c]) || (a = s[c], c++);
    var h, f, d, p = {
        includeMetadataChanges: a.includeMetadataChanges
    };
    if ($8cffe22d3a2884c1$var$ia(s[c])) {
        var y = s[c];
        s[c] = null === (e = y.next) || void 0 === e ? void 0 : e.bind(y), s[c + 1] = null === (i = y.error) || void 0 === i ? void 0 : i.bind(y), s[c + 2] = null === (o = y.complete) || void 0 === o ? void 0 : o.bind(y);
    }
    if (t instanceof $8cffe22d3a2884c1$var$$u) f = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), d = $8cffe22d3a2884c1$var$Yt(t._key.path), h = {
        next: function(e) {
            s[c] && s[c]($8cffe22d3a2884c1$var$wc(f, t, e));
        },
        error: s[c + 1],
        complete: s[c + 2]
    };
    else {
        var v = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$Xu);
        f = $8cffe22d3a2884c1$var$zu(v.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), d = v._query;
        var m = new $8cffe22d3a2884c1$var$pc(f);
        h = {
            next: function(t) {
                s[c] && s[c](new $8cffe22d3a2884c1$var$Ha(f, m, v, t));
            },
            error: s[c + 1],
            complete: s[c + 2]
        }, $8cffe22d3a2884c1$var$Xa(t._query);
    }
    return function(t, e, i, o) {
        var s = this, u = new $8cffe22d3a2884c1$var$yu(o), a = new $8cffe22d3a2884c1$var$Is(e, u, i);
        return t.asyncQueue.enqueueAndForget(function() {
            return (0, $2WUgS.__awaiter)(s, void 0, void 0, function() {
                var e;
                return (0, $2WUgS.__generator)(this, function(n) {
                    switch(n.label){
                        case 0:
                            return e = $8cffe22d3a2884c1$var$vs, [
                                4 /*yield*/ ,
                                $8cffe22d3a2884c1$var$Au(t)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                e.apply(void 0, [
                                    n.sent(),
                                    a
                                ])
                            ];
                    }
                });
            });
        }), function() {
            u.Wo(), t.asyncQueue.enqueueAndForget(function() {
                return (0, $2WUgS.__awaiter)(s, void 0, void 0, function() {
                    var e;
                    return (0, $2WUgS.__generator)(this, function(n) {
                        switch(n.label){
                            case 0:
                                return e = $8cffe22d3a2884c1$var$ms, [
                                    4 /*yield*/ ,
                                    $8cffe22d3a2884c1$var$Au(t)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    e.apply(void 0, [
                                        n.sent(),
                                        a
                                    ])
                                ];
                        }
                    });
                });
            });
        };
    }($8cffe22d3a2884c1$var$aa(f), d, p, h);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $8cffe22d3a2884c1$var$gc(t, e) {
    return function(t, e) {
        var i = this, o = new $8cffe22d3a2884c1$var$br;
        return t.asyncQueue.enqueueAndForget(function() {
            return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                var n;
                return (0, $2WUgS.__generator)(this, function(r) {
                    switch(r.label){
                        case 0:
                            return n = $8cffe22d3a2884c1$var$Ps, [
                                4 /*yield*/ ,
                                $8cffe22d3a2884c1$var$Du(t)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                n.apply(void 0, [
                                    r.sent(),
                                    e,
                                    o
                                ])
                            ];
                    }
                });
            });
        }), o.promise;
    }($8cffe22d3a2884c1$var$aa(t), e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $8cffe22d3a2884c1$var$wc(t, e, n) {
    var r = n.docs.get(e._key), i = new $8cffe22d3a2884c1$var$pc(t);
    return new $8cffe22d3a2884c1$var$za(t, i, e._key, r, new $8cffe22d3a2884c1$var$Qa(n.hasPendingWrites, n.fromCache), e.converter);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ var $8cffe22d3a2884c1$var$bc = /** @class */ function(e) {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ function n(t, n) {
        var r = this;
        return (r = e.call(this, t, n) || this)._firestore = t, r;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ return (0, $2WUgS.__extends)(n, e), n.prototype.get = function(t) {
        var n = this, r = $8cffe22d3a2884c1$var$dc(t, this._firestore), i = new $8cffe22d3a2884c1$var$pc(this._firestore);
        return e.prototype.get.call(this, t).then(function(t) {
            return new $8cffe22d3a2884c1$var$za(n._firestore, i, r._key, t._document, new $8cffe22d3a2884c1$var$Qa(/* hasPendingWrites= */ !1, /* fromCache= */ !1), r.converter);
        });
    }, n;
}(/** @class */ function() {
    /** @hideconstructor */ function t(t, e) {
        this._firestore = t, this._transaction = e, this._dataReader = $8cffe22d3a2884c1$var$Ta(t) /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ ;
    }
    return t.prototype.get = function(t) {
        var e = this, n = $8cffe22d3a2884c1$var$dc(t, this._firestore), r = new $8cffe22d3a2884c1$var$fc(this._firestore);
        return this._transaction.lookup([
            n._key
        ]).then(function(t) {
            if (!t || 1 !== t.length) return $8cffe22d3a2884c1$var$O();
            var i = t[0];
            if (i.isFoundDocument()) return new $8cffe22d3a2884c1$var$ja(e._firestore, r, i.key, i, n.converter);
            if (i.isNoDocument()) return new $8cffe22d3a2884c1$var$ja(e._firestore, r, n._key, null, n.converter);
            throw $8cffe22d3a2884c1$var$O();
        });
    }, t.prototype.set = function(t, e, n) {
        var r = $8cffe22d3a2884c1$var$dc(t, this._firestore), i = $8cffe22d3a2884c1$var$hc(r.converter, e, n), o = $8cffe22d3a2884c1$var$_a(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, o), this;
    }, t.prototype.update = function(t, e, n) {
        for(var r = [], i = 3; i < arguments.length; i++)r[i - 3] = arguments[i];
        var o, s = $8cffe22d3a2884c1$var$dc(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        return o = "string" == typeof (e = (0, $eTAKc.getModularInstance)(e)) || e instanceof $8cffe22d3a2884c1$var$la ? $8cffe22d3a2884c1$var$xa(this._dataReader, "Transaction.update", s._key, e, n, r) : $8cffe22d3a2884c1$var$Ca(this._dataReader, "Transaction.update", s._key, e), this._transaction.update(s._key, o), this;
    }, /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ t.prototype.delete = function(t) {
        var e = $8cffe22d3a2884c1$var$dc(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }, t;
}());
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Helper function to assert Uint8Array is available at runtime. */ function $8cffe22d3a2884c1$var$Ic() {
    if ("undefined" == typeof Uint8Array) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNIMPLEMENTED, "Uint8Arrays are not available in this environment.");
}
/** Helper function to assert Base64 functions are available at runtime. */ function $8cffe22d3a2884c1$var$Tc() {
    if ("undefined" == typeof atob) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNIMPLEMENTED, "Blobs are unavailable in Firestore in this environment.");
}
/** Immutable class holding a blob (binary data) */ var $8cffe22d3a2884c1$export$61196ced6d74a310 = /** @class */ function() {
    function t(t) {
        this._delegate = t;
    }
    return t.fromBase64String = function(e) {
        return $8cffe22d3a2884c1$var$Tc(), new t($8cffe22d3a2884c1$var$da.fromBase64String(e));
    }, t.fromUint8Array = function(e) {
        return $8cffe22d3a2884c1$var$Ic(), new t($8cffe22d3a2884c1$var$da.fromUint8Array(e));
    }, t.prototype.toBase64 = function() {
        return $8cffe22d3a2884c1$var$Tc(), this._delegate.toBase64();
    }, t.prototype.toUint8Array = function() {
        return $8cffe22d3a2884c1$var$Ic(), this._delegate.toUint8Array();
    }, t.prototype.isEqual = function(t) {
        return this._delegate.isEqual(t._delegate);
    }, t.prototype.toString = function() {
        return "Blob(base64: " + this.toBase64() + ")";
    }, t;
}(), $8cffe22d3a2884c1$export$3a6d5c9ae78a2c08 = /** @class */ function() {
    function t() {}
    return t.prototype.enableIndexedDbPersistence = function(t, e) {
        return function(t, e) {
            $8cffe22d3a2884c1$var$fa(t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$export$971d5caa766a69d7));
            var n = $8cffe22d3a2884c1$var$aa(t), r = t._freezeSettings(), i = new $8cffe22d3a2884c1$var$du;
            return $8cffe22d3a2884c1$var$ha(n, i, new $8cffe22d3a2884c1$var$fu(i, r.cacheSizeBytes, null == e ? void 0 : e.forceOwnership));
        }(t._delegate, {
            forceOwnership: e
        });
    }, t.prototype.enableMultiTabIndexedDbPersistence = function(t) {
        return function(t) {
            $8cffe22d3a2884c1$var$fa(t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$export$971d5caa766a69d7));
            var e = $8cffe22d3a2884c1$var$aa(t), n = t._freezeSettings(), r = new $8cffe22d3a2884c1$var$du;
            return $8cffe22d3a2884c1$var$ha(e, r, new $8cffe22d3a2884c1$var$lu(r, n.cacheSizeBytes));
        }(t._delegate);
    }, t.prototype.clearIndexedDbPersistence = function(t) {
        return function(t) {
            var e = this;
            if (t._initialized && !t._terminated) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
            var i = new $8cffe22d3a2884c1$var$br;
            return t._queue.enqueueAndForgetEvenWhileRestricted(function() {
                return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                    var e;
                    return (0, $2WUgS.__generator)(this, function(o) {
                        switch(o.label){
                            case 0:
                                return o.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]), [
                                    4 /*yield*/ ,
                                    function(t) {
                                        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                            var e;
                                            return (0, $2WUgS.__generator)(this, function(n) {
                                                switch(n.label){
                                                    case 0:
                                                        return $8cffe22d3a2884c1$var$_r.yt() ? (e = t + "main", [
                                                            4 /*yield*/ ,
                                                            $8cffe22d3a2884c1$var$_r.delete(e)
                                                        ]) : [
                                                            2 /*return*/ ,
                                                            Promise.resolve()
                                                        ];
                                                    case 1:
                                                        return n.sent(), [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }($8cffe22d3a2884c1$var$Oi(t._databaseId, t._persistenceKey))
                                ];
                            case 1:
                                return o.sent(), i.resolve(), [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                return e = o.sent(), i.reject(e), [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }), i.promise /**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ ;
        }(t._delegate);
    }, t;
}(), $8cffe22d3a2884c1$export$3466f893ebf79586 = /** @class */ function() {
    function t(t, e, n) {
        var r = this;
        this._delegate = e, this.Zc = n, this.INTERNAL = {
            delete: function() {
                return r.terminate();
            }
        }, t instanceof $8cffe22d3a2884c1$var$Ru || (this.tu = t);
    }
    return Object.defineProperty(t.prototype, "_databaseId", {
        get: function() {
            return this._delegate._databaseId;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.settings = function(t) {
        var e = this._delegate._getSettings();
        t.merge || e.host === t.host || $8cffe22d3a2884c1$var$R("You are overriding the original host. If you did not intend to override your settings, use {merge: true}."), t.merge && // Remove the property from the settings once the merge is completed
        delete (t = Object.assign(Object.assign({}, e), t)).merge, this._delegate._setSettings(t);
    }, t.prototype.useEmulator = function(t, e, n) {
        void 0 === n && (n = {}), function(t, e, n, r) {
            var i;
            void 0 === r && (r = {});
            var o = (t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$Yu))._getSettings();
            if ("firestore.googleapis.com" !== o.host && o.host !== e && $8cffe22d3a2884c1$var$R("Host has been set in both settings() and useEmulator(), emulator host will be used"), t._setSettings(Object.assign(Object.assign({}, o), {
                host: e + ":" + n,
                ssl: !1
            })), r.mockUserToken) {
                var s, u;
                if ("string" == typeof r.mockUserToken) s = r.mockUserToken, u = $8cffe22d3a2884c1$var$fo.MOCK_USER;
                else {
                    // Let createMockUserToken validate first (catches common mistakes like
                    // invalid field "uid" and missing field "sub" / "user_id".)
                    s = (0, $eTAKc.createMockUserToken)(r.mockUserToken, null === (i = t._app) || void 0 === i ? void 0 : i.options.projectId);
                    var a = r.mockUserToken.sub || r.mockUserToken.user_id;
                    if (!a) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
                    u = new $8cffe22d3a2884c1$var$fo(a);
                }
                t._credentials = new $8cffe22d3a2884c1$var$Fu(new $8cffe22d3a2884c1$var$Ou(s, u));
            }
        }(this._delegate, t, e, n);
    }, t.prototype.enableNetwork = function() {
        return function(t) {
            var e = this;
            return t.asyncQueue.enqueue(function() {
                return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                    var e, n;
                    return (0, $2WUgS.__generator)(this, function(r) {
                        switch(r.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    $8cffe22d3a2884c1$var$Eu(t)
                                ];
                            case 1:
                                return e = r.sent(), [
                                    4 /*yield*/ ,
                                    $8cffe22d3a2884c1$var$Nu(t)
                                ];
                            case 2:
                                return n = r.sent(), [
                                    2 /*return*/ ,
                                    (e.setNetworkEnabled(!0), function(t) {
                                        var e = $8cffe22d3a2884c1$var$F(t);
                                        return e.Or.delete(0 /* UserDisabled */ ), $8cffe22d3a2884c1$var$Vo(e);
                                    }(n))
                                ];
                        }
                    });
                });
            });
        }($8cffe22d3a2884c1$var$aa($8cffe22d3a2884c1$var$zu(this._delegate, $8cffe22d3a2884c1$export$971d5caa766a69d7)));
    }, t.prototype.disableNetwork = function() {
        return function(t) {
            var e = this;
            return t.asyncQueue.enqueue(function() {
                return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                    var e, i;
                    return (0, $2WUgS.__generator)(this, function(o) {
                        switch(o.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    $8cffe22d3a2884c1$var$Eu(t)
                                ];
                            case 1:
                                return e = o.sent(), [
                                    4 /*yield*/ ,
                                    $8cffe22d3a2884c1$var$Nu(t)
                                ];
                            case 2:
                                return i = o.sent(), [
                                    2 /*return*/ ,
                                    (e.setNetworkEnabled(!1), function(t) {
                                        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                            var e;
                                            return (0, $2WUgS.__generator)(this, function(n) {
                                                switch(n.label){
                                                    case 0:
                                                        return (e = $8cffe22d3a2884c1$var$F(t)).Or.add(0 /* UserDisabled */ ), [
                                                            4 /*yield*/ ,
                                                            $8cffe22d3a2884c1$var$qo(e)
                                                        ];
                                                    case 1:
                                                        return n.sent(), // Set the OnlineState to Offline so get()s return from cache, etc.
                                                        e.Br.set("Offline" /* Offline */ ), [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }(i))
                                ];
                        }
                    });
                });
            });
        }($8cffe22d3a2884c1$var$aa($8cffe22d3a2884c1$var$zu(this._delegate, $8cffe22d3a2884c1$export$971d5caa766a69d7)));
    }, t.prototype.enablePersistence = function(t) {
        var e = !1, n = !1;
        return t && $8cffe22d3a2884c1$var$ju("synchronizeTabs", e = !!t.synchronizeTabs, "experimentalForceOwningTab", n = !!t.experimentalForceOwningTab), e ? this.Zc.enableMultiTabIndexedDbPersistence(this) : this.Zc.enableIndexedDbPersistence(this, n);
    }, t.prototype.clearPersistence = function() {
        return this.Zc.clearIndexedDbPersistence(this);
    }, t.prototype.terminate = function() {
        return this.tu && (this.tu._removeServiceInstance("firestore"), this.tu._removeServiceInstance("firestore-exp")), this._delegate._delete();
    }, t.prototype.waitForPendingWrites = function() {
        return function(t) {
            var e = this, i = new $8cffe22d3a2884c1$var$br;
            return t.asyncQueue.enqueueAndForget(function() {
                return (0, $2WUgS.__awaiter)(e, void 0, void 0, function() {
                    var e;
                    return (0, $2WUgS.__generator)(this, function(n) {
                        switch(n.label){
                            case 0:
                                return e = $8cffe22d3a2884c1$var$Bs, [
                                    4 /*yield*/ ,
                                    $8cffe22d3a2884c1$var$Du(t)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    e.apply(void 0, [
                                        n.sent(),
                                        i
                                    ])
                                ];
                        }
                    });
                });
            }), i.promise;
        }($8cffe22d3a2884c1$var$aa($8cffe22d3a2884c1$var$zu(this._delegate, $8cffe22d3a2884c1$export$971d5caa766a69d7)));
    }, t.prototype.onSnapshotsInSync = function(t) {
        return function(t, e) {
            return function(t, e) {
                var i = this, o = new $8cffe22d3a2884c1$var$yu(e);
                return t.asyncQueue.enqueueAndForget(function() {
                    return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                        var e;
                        return (0, $2WUgS.__generator)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    return e = function(t, e) {
                                        $8cffe22d3a2884c1$var$F(t).Gr.add(e), // Immediately fire an initial event, indicating all existing listeners
                                        // are in-sync.
                                        e.next();
                                    }, [
                                        4 /*yield*/ ,
                                        $8cffe22d3a2884c1$var$Au(t)
                                    ];
                                case 1:
                                    return [
                                        2 /*return*/ ,
                                        e.apply(void 0, [
                                            n.sent(),
                                            o
                                        ])
                                    ];
                            }
                        });
                    });
                }), function() {
                    o.Wo(), t.asyncQueue.enqueueAndForget(function() {
                        return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                            var e;
                            return (0, $2WUgS.__generator)(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return e = function(t, e) {
                                            $8cffe22d3a2884c1$var$F(t).Gr.delete(e);
                                        }, [
                                            4 /*yield*/ ,
                                            $8cffe22d3a2884c1$var$Au(t)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            e.apply(void 0, [
                                                n.sent(),
                                                o
                                            ])
                                        ];
                                }
                            });
                        });
                    });
                } /**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ ;
            }($8cffe22d3a2884c1$var$aa(t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$export$971d5caa766a69d7)), $8cffe22d3a2884c1$var$ia(e) ? e : {
                next: e
            });
        }(this._delegate, t);
    }, Object.defineProperty(t.prototype, "app", {
        get: function() {
            if (!this.tu) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
            return this.tu;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.collection = function(t) {
        try {
            return new $8cffe22d3a2884c1$export$23f2a1d2818174ef(this, $8cffe22d3a2884c1$var$Zu(this._delegate, t));
        } catch (t) {
            throw $8cffe22d3a2884c1$var$Rc(t, "collection()", "Firestore.collection()");
        }
    }, t.prototype.doc = function(t) {
        try {
            return new $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd(this, $8cffe22d3a2884c1$var$ta(this._delegate, t));
        } catch (t) {
            throw $8cffe22d3a2884c1$var$Rc(t, "doc()", "Firestore.doc()");
        }
    }, t.prototype.collectionGroup = function(t) {
        try {
            return new $8cffe22d3a2884c1$export$f1e1789686576879(this, function(t, e) {
                if (t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$Yu), $8cffe22d3a2884c1$var$Uu("collectionGroup", "collection id", e), e.indexOf("/") >= 0) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid collection ID '" + e + "' passed to function collectionGroup(). Collection IDs must not contain '/'.");
                return new $8cffe22d3a2884c1$var$Xu(t, /* converter= */ null, /**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ function(t) {
                    return new $8cffe22d3a2884c1$var$Wt($8cffe22d3a2884c1$var$H.emptyPath(), t);
                }(e));
            }(this._delegate, t));
        } catch (t) {
            throw $8cffe22d3a2884c1$var$Rc(t, "collectionGroup()", "Firestore.collectionGroup()");
        }
    }, t.prototype.runTransaction = function(t) {
        var e = this;
        return function(t, e) {
            return function(t, e) {
                var i = this, o = new $8cffe22d3a2884c1$var$br;
                return t.asyncQueue.enqueueAndForget(function() {
                    return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                        var n;
                        return (0, $2WUgS.__generator)(this, function(r) {
                            switch(r.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        function(t) {
                                            return $8cffe22d3a2884c1$var$_u(t).then(function(t) {
                                                return t.datastore;
                                            });
                                        }(t)
                                    ];
                                case 1:
                                    return n = r.sent(), new $8cffe22d3a2884c1$var$gu(t.asyncQueue, n, e, o).run(), [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }), o.promise;
            }($8cffe22d3a2884c1$var$aa(t), function(n) {
                return e(new $8cffe22d3a2884c1$var$bc(t, n));
            });
        }(this._delegate, function(n) {
            return t(new $8cffe22d3a2884c1$export$71cec2538cb2c617(e, n));
        });
    }, t.prototype.batch = function() {
        var t = this;
        return $8cffe22d3a2884c1$var$aa(this._delegate), new $8cffe22d3a2884c1$export$2329c99376c9d0a4(new $8cffe22d3a2884c1$var$lc(this._delegate, function(e) {
            return $8cffe22d3a2884c1$var$gc(t._delegate, e);
        }));
    }, t.prototype.loadBundle = function(t) {
        throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, '"loadBundle()" does not exist, have you imported "firebase/firestore/bundle"?');
    }, t.prototype.namedQuery = function(t) {
        throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.FAILED_PRECONDITION, '"namedQuery()" does not exist, have you imported "firebase/firestore/bundle"?');
    }, t;
}(), $8cffe22d3a2884c1$var$Nc = /** @class */ function(e) {
    function n(t) {
        var n = this;
        return (n = e.call(this) || this).firestore = t, n;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.convertBytes = function(t) {
        return new $8cffe22d3a2884c1$export$61196ced6d74a310(new $8cffe22d3a2884c1$var$da(t));
    }, n.prototype.convertReference = function(t) {
        var e = this.convertDocumentKey(t, this.firestore._databaseId);
        return $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd.eu(e, this.firestore, /* converter= */ null);
    }, n;
}($8cffe22d3a2884c1$var$cc);
/**
 * The persistence provider included with the full Firestore SDK.
 */ function $8cffe22d3a2884c1$export$35e795649ee09318(t) {
    var e;
    e = t, $8cffe22d3a2884c1$var$A.setLogLevel(e);
}
/**
 * A reference to a transaction.
 */ var $8cffe22d3a2884c1$export$71cec2538cb2c617 = /** @class */ function() {
    function t(t, e) {
        this._firestore = t, this._delegate = e, this._userDataWriter = new $8cffe22d3a2884c1$var$Nc(t);
    }
    return t.prototype.get = function(t) {
        var e = this, n = $8cffe22d3a2884c1$var$Bc(t);
        return this._delegate.get(n).then(function(t) {
            return new $8cffe22d3a2884c1$export$dc98b0b04f4c7758(e._firestore, new $8cffe22d3a2884c1$var$za(e._firestore._delegate, e._userDataWriter, t._key, t._document, t.metadata, n.converter));
        });
    }, t.prototype.set = function(t, e, n) {
        var r = $8cffe22d3a2884c1$var$Bc(t);
        return n ? ($8cffe22d3a2884c1$var$Bu("Transaction.set", n), this._delegate.set(r, e, n)) : this._delegate.set(r, e), this;
    }, t.prototype.update = function(t, n, r) {
        for(var i, o = [], s = 3; s < arguments.length; s++)o[s - 3] = arguments[s];
        var u = $8cffe22d3a2884c1$var$Bc(t);
        return 2 === arguments.length ? this._delegate.update(u, n) : (i = this._delegate).update.apply(i, (0, $2WUgS.__spreadArray)([
            u,
            n,
            r
        ], o)), this;
    }, t.prototype.delete = function(t) {
        var e = $8cffe22d3a2884c1$var$Bc(t);
        return this._delegate.delete(e), this;
    }, t;
}(), $8cffe22d3a2884c1$export$2329c99376c9d0a4 = /** @class */ function() {
    function t(t) {
        this._delegate = t;
    }
    return t.prototype.set = function(t, e, n) {
        var r = $8cffe22d3a2884c1$var$Bc(t);
        return n ? ($8cffe22d3a2884c1$var$Bu("WriteBatch.set", n), this._delegate.set(r, e, n)) : this._delegate.set(r, e), this;
    }, t.prototype.update = function(t, n, r) {
        for(var i, o = [], s = 3; s < arguments.length; s++)o[s - 3] = arguments[s];
        var u = $8cffe22d3a2884c1$var$Bc(t);
        return 2 === arguments.length ? this._delegate.update(u, n) : (i = this._delegate).update.apply(i, (0, $2WUgS.__spreadArray)([
            u,
            n,
            r
        ], o)), this;
    }, t.prototype.delete = function(t) {
        var e = $8cffe22d3a2884c1$var$Bc(t);
        return this._delegate.delete(e), this;
    }, t.prototype.commit = function() {
        return this._delegate.commit();
    }, t;
}(), $8cffe22d3a2884c1$var$Cc = /** @class */ function() {
    function t(t, e, n) {
        this._firestore = t, this._userDataWriter = e, this._delegate = n;
    }
    return t.prototype.fromFirestore = function(t, e) {
        var n = new $8cffe22d3a2884c1$var$Wa(this._firestore._delegate, this._userDataWriter, t._key, t._document, t.metadata, /* converter= */ null);
        return this._delegate.fromFirestore(new $8cffe22d3a2884c1$export$625550452a3fa3ec(this._firestore, n), null != e ? e : {});
    }, t.prototype.toFirestore = function(t, e) {
        return e ? this._delegate.toFirestore(t, e) : this._delegate.toFirestore(t);
    }, // Use the same instance of `FirestoreDataConverter` for the given instances
    // of `Firestore` and `PublicFirestoreDataConverter` so that isEqual() will
    // compare equal for two objects created with the same converter instance.
    t.nu = function(e, n) {
        var r = t.su, i = r.get(e);
        i || (i = new WeakMap, r.set(e, i));
        var o = i.get(n);
        return o || (o = new t(e, new $8cffe22d3a2884c1$var$Nc(e), n), i.set(n, o)), o;
    }, t;
}();
$8cffe22d3a2884c1$var$Cc.su = new WeakMap;
/**
 * A reference to a particular document in a collection in the database.
 */ var $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd = /** @class */ function() {
    function t(t, e) {
        this.firestore = t, this._delegate = e, this._userDataWriter = new $8cffe22d3a2884c1$var$Nc(t);
    }
    return t.iu = function(e, n, r) {
        if (e.length % 2 != 0) throw new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + e.canonicalString() + " has " + e.length);
        return new t(n, new $8cffe22d3a2884c1$var$$u(n._delegate, r, new $8cffe22d3a2884c1$var$ct(e)));
    }, t.eu = function(e, n, r) {
        return new t(n, new $8cffe22d3a2884c1$var$$u(n._delegate, r, e));
    }, Object.defineProperty(t.prototype, "id", {
        get: function() {
            return this._delegate.id;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "parent", {
        get: function() {
            return new $8cffe22d3a2884c1$export$23f2a1d2818174ef(this.firestore, this._delegate.parent);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "path", {
        get: function() {
            return this._delegate.path;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.collection = function(t) {
        try {
            return new $8cffe22d3a2884c1$export$23f2a1d2818174ef(this.firestore, $8cffe22d3a2884c1$var$Zu(this._delegate, t));
        } catch (t) {
            throw $8cffe22d3a2884c1$var$Rc(t, "collection()", "DocumentReference.collection()");
        }
    }, t.prototype.isEqual = function(t) {
        return (t = (0, $eTAKc.getModularInstance)(t)) instanceof $8cffe22d3a2884c1$var$$u && $8cffe22d3a2884c1$var$ea(this._delegate, t);
    }, t.prototype.set = function(t, e) {
        e = $8cffe22d3a2884c1$var$Bu("DocumentReference.set", e);
        try {
            return e ? $8cffe22d3a2884c1$var$yc(this._delegate, t, e) : $8cffe22d3a2884c1$var$yc(this._delegate, t);
        } catch (t) {
            throw $8cffe22d3a2884c1$var$Rc(t, "setDoc()", "DocumentReference.set()");
        }
    }, t.prototype.update = function(t, n) {
        for(var r = [], i = 2; i < arguments.length; i++)r[i - 2] = arguments[i];
        try {
            return 1 === arguments.length ? $8cffe22d3a2884c1$var$vc(this._delegate, t) : $8cffe22d3a2884c1$var$vc.apply(void 0, (0, $2WUgS.__spreadArray)([
                this._delegate,
                t,
                n
            ], r));
        } catch (t) {
            throw $8cffe22d3a2884c1$var$Rc(t, "updateDoc()", "DocumentReference.update()");
        }
    }, t.prototype.delete = function() {
        var t;
        return $8cffe22d3a2884c1$var$gc($8cffe22d3a2884c1$var$zu((t = this._delegate).firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), [
            new $8cffe22d3a2884c1$var$je(t._key, $8cffe22d3a2884c1$var$De.none())
        ]);
    /**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ }, t.prototype.onSnapshot = function() {
        for(var t = this, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        var r = $8cffe22d3a2884c1$var$Lc(e), i = $8cffe22d3a2884c1$var$Oc(e, function(e) {
            return new $8cffe22d3a2884c1$export$dc98b0b04f4c7758(t.firestore, new $8cffe22d3a2884c1$var$za(t.firestore._delegate, t._userDataWriter, e._key, e._document, e.metadata, t._delegate.converter));
        });
        return $8cffe22d3a2884c1$var$mc(this._delegate, r, i);
    }, t.prototype.get = function(t) {
        var e = this;
        return ("cache" === (null == t ? void 0 : t.source) ? function(t) {
            t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$$u);
            var e = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), i = $8cffe22d3a2884c1$var$aa(e), o = new $8cffe22d3a2884c1$var$pc(e);
            return (function(t, e) {
                var i = this, o = new $8cffe22d3a2884c1$var$br;
                return t.asyncQueue.enqueueAndForget(function() {
                    return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                        var i;
                        return (0, $2WUgS.__generator)(this, function(s) {
                            switch(s.label){
                                case 0:
                                    return i = function(t, e, i) {
                                        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                            var n, o;
                                            return (0, $2WUgS.__generator)(this, function(r) {
                                                switch(r.label){
                                                    case 0:
                                                        return r.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            3
                                                        ]), [
                                                            4 /*yield*/ ,
                                                            function(t, e) {
                                                                var n = $8cffe22d3a2884c1$var$F(t);
                                                                return n.persistence.runTransaction("read document", "readonly", function(t) {
                                                                    return n.Mn.mn(t, e);
                                                                });
                                                            }(t, e)
                                                        ];
                                                    case 1:
                                                        return (o = r.sent()).isFoundDocument() ? i.resolve(o) : o.isNoDocument() ? i.resolve(null) : i.reject(new $8cffe22d3a2884c1$var$D($8cffe22d3a2884c1$var$N.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)")), [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        return n = r.sent(), o = $8cffe22d3a2884c1$var$hs(n, "Failed to get document '" + e + " from cache"), i.reject(o), [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, [
                                        4 /*yield*/ ,
                                        $8cffe22d3a2884c1$var$Su(t)
                                    ];
                                case 1:
                                    return [
                                        2 /*return*/ ,
                                        i.apply(void 0, [
                                            s.sent(),
                                            e,
                                            o
                                        ])
                                    ];
                            }
                        });
                    });
                }), o.promise;
            })(i, t._key).then(function(n) {
                return new $8cffe22d3a2884c1$var$za(e, o, t._key, n, new $8cffe22d3a2884c1$var$Qa(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter);
            });
        }(this._delegate) : "server" === (null == t ? void 0 : t.source) ? function(t) {
            t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$$u);
            var e = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7);
            return $8cffe22d3a2884c1$var$ku($8cffe22d3a2884c1$var$aa(e), t._key, {
                source: "server"
            }).then(function(n) {
                return $8cffe22d3a2884c1$var$wc(e, t, n);
            });
        }(this._delegate) : function(t) {
            t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$$u);
            var e = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7);
            return $8cffe22d3a2884c1$var$ku($8cffe22d3a2884c1$var$aa(e), t._key).then(function(n) {
                return $8cffe22d3a2884c1$var$wc(e, t, n);
            });
        }(this._delegate)).then(function(t) {
            return new $8cffe22d3a2884c1$export$dc98b0b04f4c7758(e.firestore, new $8cffe22d3a2884c1$var$za(e.firestore._delegate, e._userDataWriter, t._key, t._document, t.metadata, e._delegate.converter));
        });
    }, t.prototype.withConverter = function(e) {
        return new t(this.firestore, e ? this._delegate.withConverter($8cffe22d3a2884c1$var$Cc.nu(this.firestore, e)) : this._delegate.withConverter(null));
    }, t;
}();
/**
 * Replaces the function name in an error thrown by the firestore-exp API
 * with the function names used in the classic API.
 */ function $8cffe22d3a2884c1$var$Rc(t, e, n) {
    return t.message = t.message.replace(e, n), t /**
 * Iterates the list of arguments from an `onSnapshot` call and returns the
 * first argument that may be an `SnapshotListenOptions` object. Returns an
 * empty object if none is found.
 */ ;
}
function $8cffe22d3a2884c1$var$Lc(t) {
    for(var e = 0, n = t; e < n.length; e++){
        var r = n[e];
        if ("object" == typeof r && !$8cffe22d3a2884c1$var$ia(r)) return r;
    }
    return {};
}
/**
 * Creates an observer that can be passed to the firestore-exp SDK. The
 * observer converts all observed values into the format expected by the classic
 * SDK.
 *
 * @param args - The list of arguments from an `onSnapshot` call.
 * @param wrapper - The function that converts the firestore-exp type into the
 * type used by this shim.
 */ function $8cffe22d3a2884c1$var$Oc(t, e) {
    var n, r, i;
    return {
        next: function(t) {
            i.next && i.next(e(t));
        },
        error: null === (n = (i = $8cffe22d3a2884c1$var$ia(t[0]) ? t[0] : $8cffe22d3a2884c1$var$ia(t[1]) ? t[1] : "function" == typeof t[0] ? {
            next: t[0],
            error: t[1],
            complete: t[2]
        } : {
            next: t[1],
            error: t[2],
            complete: t[3]
        }).error) || void 0 === n ? void 0 : n.bind(i),
        complete: null === (r = i.complete) || void 0 === r ? void 0 : r.bind(i)
    };
}
var $8cffe22d3a2884c1$export$dc98b0b04f4c7758 = /** @class */ function() {
    function t(t, e) {
        this._firestore = t, this._delegate = e;
    }
    return Object.defineProperty(t.prototype, "ref", {
        get: function() {
            return new $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd(this._firestore, this._delegate.ref);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "id", {
        get: function() {
            return this._delegate.id;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "metadata", {
        get: function() {
            return this._delegate.metadata;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "exists", {
        get: function() {
            return this._delegate.exists();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.data = function(t) {
        return this._delegate.data(t);
    }, t.prototype.get = function(t, e) {
        return this._delegate.get(t, e);
    }, t.prototype.isEqual = function(t) {
        return $8cffe22d3a2884c1$var$$a(this._delegate, t._delegate);
    }, t;
}(), $8cffe22d3a2884c1$export$625550452a3fa3ec = /** @class */ function(e) {
    function n() {
        return null !== e && e.apply(this, arguments) || this;
    }
    return (0, $2WUgS.__extends)(n, e), n.prototype.data = function(t) {
        return this._delegate.data(t);
    }, n;
}($8cffe22d3a2884c1$export$dc98b0b04f4c7758), $8cffe22d3a2884c1$export$f1e1789686576879 = /** @class */ function() {
    function t(t, e) {
        this.firestore = t, this._delegate = e, this._userDataWriter = new $8cffe22d3a2884c1$var$Nc(t);
    }
    return t.prototype.where = function(e, n, r) {
        try {
            // The "as string" cast is a little bit of a hack. `where` accepts the
            // FieldPath Compat type as input, but is not typed as such in order to
            // not expose this via our public typings file.
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, function(t, e, n) {
                var r = e, i = $8cffe22d3a2884c1$var$Ga("where", t);
                return new $8cffe22d3a2884c1$var$tc(i, r, n);
            }(e, n, r)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, /(orderBy|where)\(\)/, "Query.$1()");
        }
    }, t.prototype.orderBy = function(e, n) {
        try {
            // The "as string" cast is a little bit of a hack. `orderBy` accepts the
            // FieldPath Compat type as input, but is not typed as such in order to
            // not expose this via our public typings file.
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, function(t, e) {
                void 0 === e && (e = "asc");
                var n = e, r = $8cffe22d3a2884c1$var$Ga("orderBy", t);
                return new $8cffe22d3a2884c1$var$ec(r, n);
            }(e, n)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, /(orderBy|where)\(\)/, "Query.$1()");
        }
    }, t.prototype.limit = function(e) {
        try {
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, function(t) {
                return $8cffe22d3a2884c1$var$Wu("limit", t), new $8cffe22d3a2884c1$var$nc("limit", t, "F" /* First */ );
            }(e)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, "limit()", "Query.limit()");
        }
    }, t.prototype.limitToLast = function(e) {
        try {
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, function(t) {
                return $8cffe22d3a2884c1$var$Wu("limitToLast", t), new $8cffe22d3a2884c1$var$nc("limitToLast", t, "L" /* Last */ );
            }(e)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, "limitToLast()", "Query.limitToLast()");
        }
    }, t.prototype.startAt = function() {
        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        try {
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, (function() {
                for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                return new $8cffe22d3a2884c1$var$rc("startAt", t, /*before=*/ !0);
            }).apply(void 0, e)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, "startAt()", "Query.startAt()");
        }
    }, t.prototype.startAfter = function() {
        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        try {
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, (function() {
                for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                return new $8cffe22d3a2884c1$var$rc("startAfter", t, /*before=*/ !1);
            }).apply(void 0, e)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, "startAfter()", "Query.startAfter()");
        }
    }, t.prototype.endBefore = function() {
        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        try {
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, (function() {
                for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                return new $8cffe22d3a2884c1$var$ic("endBefore", t, /*before=*/ !0);
            }).apply(void 0, e)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, "endBefore()", "Query.endBefore()");
        }
    }, t.prototype.endAt = function() {
        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        try {
            return new t(this.firestore, $8cffe22d3a2884c1$var$Za(this._delegate, (function() {
                for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                return new $8cffe22d3a2884c1$var$ic("endAt", t, /*before=*/ !1);
            }).apply(void 0, e)));
        } catch (e) {
            throw $8cffe22d3a2884c1$var$Rc(e, "endAt()", "Query.endAt()");
        }
    }, t.prototype.isEqual = function(t) {
        return $8cffe22d3a2884c1$var$na(this._delegate, t._delegate);
    }, t.prototype.get = function(t) {
        var e = this;
        return ("cache" === (null == t ? void 0 : t.source) ? /**
     * Executes the query and returns the results as a `QuerySnapshot` from cache.
     * Returns an error if the document is not currently cached.
     *
     * @returns A `Promise` that will be resolved with the results of the query.
     */ function(t) {
            t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$Xu);
            var e = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), i = $8cffe22d3a2884c1$var$aa(e), o = new $8cffe22d3a2884c1$var$pc(e);
            return (function(t, e) {
                var i = this, o = new $8cffe22d3a2884c1$var$br;
                return t.asyncQueue.enqueueAndForget(function() {
                    return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                        var i;
                        return (0, $2WUgS.__generator)(this, function(s) {
                            switch(s.label){
                                case 0:
                                    return i = function(t, e, i) {
                                        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
                                            var n, o, s, u, a;
                                            return (0, $2WUgS.__generator)(this, function(r) {
                                                switch(r.label){
                                                    case 0:
                                                        return r.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            3
                                                        ]), [
                                                            4 /*yield*/ ,
                                                            $8cffe22d3a2884c1$var$Yi(t, e, /* usePreviousResults= */ !0)
                                                        ];
                                                    case 1:
                                                        return a = r.sent(), n = new $8cffe22d3a2884c1$var$As(e, a.Bn), o = n._o(a.documents), s = n.applyChanges(o, /* updateLimboDocuments= */ !1), i.resolve(s.snapshot), [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        return u = r.sent(), a = $8cffe22d3a2884c1$var$hs(u, "Failed to execute query '" + e + " against cache"), i.reject(a), [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, [
                                        4 /*yield*/ ,
                                        $8cffe22d3a2884c1$var$Su(t)
                                    ];
                                case 1:
                                    return [
                                        2 /*return*/ ,
                                        i.apply(void 0, [
                                            s.sent(),
                                            e,
                                            o
                                        ])
                                    ];
                            }
                        });
                    });
                }), o.promise;
            })(i, t._query).then(function(n) {
                return new $8cffe22d3a2884c1$var$Ha(e, o, t, n);
            });
        }(this._delegate) : "server" === (null == t ? void 0 : t.source) ? function(t) {
            t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$Xu);
            var e = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), n = $8cffe22d3a2884c1$var$aa(e), r = new $8cffe22d3a2884c1$var$pc(e);
            return $8cffe22d3a2884c1$var$Cu(n, t._query, {
                source: "server"
            }).then(function(n) {
                return new $8cffe22d3a2884c1$var$Ha(e, r, t, n);
            });
        }(this._delegate) : function(t) {
            t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$Xu);
            var e = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), n = $8cffe22d3a2884c1$var$aa(e), r = new $8cffe22d3a2884c1$var$pc(e);
            return $8cffe22d3a2884c1$var$Xa(t._query), $8cffe22d3a2884c1$var$Cu(n, t._query).then(function(n) {
                return new $8cffe22d3a2884c1$var$Ha(e, r, t, n);
            });
        }(this._delegate)).then(function(t) {
            return new $8cffe22d3a2884c1$export$2408f22a0fab9ae5(e.firestore, new $8cffe22d3a2884c1$var$Ha(e.firestore._delegate, e._userDataWriter, e._delegate, t._snapshot));
        });
    }, t.prototype.onSnapshot = function() {
        for(var t = this, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        var r = $8cffe22d3a2884c1$var$Lc(e), i = $8cffe22d3a2884c1$var$Oc(e, function(e) {
            return new $8cffe22d3a2884c1$export$2408f22a0fab9ae5(t.firestore, new $8cffe22d3a2884c1$var$Ha(t.firestore._delegate, t._userDataWriter, t._delegate, e._snapshot));
        });
        return $8cffe22d3a2884c1$var$mc(this._delegate, r, i);
    }, t.prototype.withConverter = function(e) {
        return new t(this.firestore, e ? this._delegate.withConverter($8cffe22d3a2884c1$var$Cc.nu(this.firestore, e)) : this._delegate.withConverter(null));
    }, t;
}(), $8cffe22d3a2884c1$var$Vc = /** @class */ function() {
    function t(t, e) {
        this._firestore = t, this._delegate = e;
    }
    return Object.defineProperty(t.prototype, "type", {
        get: function() {
            return this._delegate.type;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "doc", {
        get: function() {
            return new $8cffe22d3a2884c1$export$625550452a3fa3ec(this._firestore, this._delegate.doc);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "oldIndex", {
        get: function() {
            return this._delegate.oldIndex;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "newIndex", {
        get: function() {
            return this._delegate.newIndex;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $8cffe22d3a2884c1$export$2408f22a0fab9ae5 = /** @class */ function() {
    function t(t, e) {
        this._firestore = t, this._delegate = e;
    }
    return Object.defineProperty(t.prototype, "query", {
        get: function() {
            return new $8cffe22d3a2884c1$export$f1e1789686576879(this._firestore, this._delegate.query);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "metadata", {
        get: function() {
            return this._delegate.metadata;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this._delegate.size;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "empty", {
        get: function() {
            return this._delegate.empty;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "docs", {
        get: function() {
            var t = this;
            return this._delegate.docs.map(function(e) {
                return new $8cffe22d3a2884c1$export$625550452a3fa3ec(t._firestore, e);
            });
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.docChanges = function(t) {
        var e = this;
        return this._delegate.docChanges(t).map(function(t) {
            return new $8cffe22d3a2884c1$var$Vc(e._firestore, t);
        });
    }, t.prototype.forEach = function(t, e) {
        var n = this;
        this._delegate.forEach(function(r) {
            t.call(e, new $8cffe22d3a2884c1$export$625550452a3fa3ec(n._firestore, r));
        });
    }, t.prototype.isEqual = function(t) {
        return $8cffe22d3a2884c1$var$$a(this._delegate, t._delegate);
    }, t;
}(), $8cffe22d3a2884c1$export$23f2a1d2818174ef = /** @class */ function(e) {
    function n(t, n) {
        var r = this;
        return (r = e.call(this, t, n) || this).firestore = t, r._delegate = n, r;
    }
    return (0, $2WUgS.__extends)(n, e), Object.defineProperty(n.prototype, "id", {
        get: function() {
            return this._delegate.id;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "path", {
        get: function() {
            return this._delegate.path;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(n.prototype, "parent", {
        get: function() {
            var t = this._delegate.parent;
            return t ? new $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd(this.firestore, t) : null;
        },
        enumerable: !1,
        configurable: !0
    }), n.prototype.doc = function(t) {
        try {
            return new $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd(this.firestore, void 0 === t ? $8cffe22d3a2884c1$var$ta(this._delegate) : $8cffe22d3a2884c1$var$ta(this._delegate, t));
        } catch (t) {
            throw $8cffe22d3a2884c1$var$Rc(t, "doc()", "CollectionReference.doc()");
        }
    }, n.prototype.add = function(t) {
        var e = this;
        return (function(t, e) {
            var n = $8cffe22d3a2884c1$var$zu(t.firestore, $8cffe22d3a2884c1$export$971d5caa766a69d7), r = $8cffe22d3a2884c1$var$ta(t), i = $8cffe22d3a2884c1$var$hc(t.converter, e);
            return $8cffe22d3a2884c1$var$gc(n, [
                $8cffe22d3a2884c1$var$_a($8cffe22d3a2884c1$var$Ta(t.firestore), "addDoc", r._key, i, null !== t.converter, {}).toMutation(r._key, $8cffe22d3a2884c1$var$De.exists(!1))
            ]).then(function() {
                return r;
            });
        })(this._delegate, t).then(function(t) {
            return new $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd(e.firestore, t);
        });
    }, n.prototype.isEqual = function(t) {
        return $8cffe22d3a2884c1$var$ea(this._delegate, t._delegate);
    }, n.prototype.withConverter = function(t) {
        return new n(this.firestore, t ? this._delegate.withConverter($8cffe22d3a2884c1$var$Cc.nu(this.firestore, t)) : this._delegate.withConverter(null));
    }, n;
}($8cffe22d3a2884c1$export$f1e1789686576879);
function $8cffe22d3a2884c1$var$Bc(t) {
    return $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$var$$u);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
/**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a list
 * of field names (referring to a nested field in the document).
 */ var $8cffe22d3a2884c1$export$ae1af26003f05816 = /** @class */ function() {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ function t() {
        for(var t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
        this._delegate = new ($8cffe22d3a2884c1$var$la.bind.apply($8cffe22d3a2884c1$var$la, (0, $2WUgS.__spreadArray)([
            void 0
        ], t)));
    }
    return t.documentId = function() {
        /**
         * Internal Note: The backend doesn't technically support querying by
         * document ID. Instead it queries by the entire document name (full path
         * included), but in the cases we currently support documentId(), the net
         * effect is the same.
         */ return new t($8cffe22d3a2884c1$var$$.keyField().canonicalString());
    }, t.prototype.isEqual = function(t) {
        return (t = (0, $eTAKc.getModularInstance)(t)) instanceof $8cffe22d3a2884c1$var$la && this._delegate._internalPath.isEqual(t._internalPath);
    }, t;
}(), $8cffe22d3a2884c1$export$db3b6bfb95261072 = /** @class */ function() {
    function t(t) {
        this._delegate = t;
    }
    return t.serverTimestamp = function() {
        var e = new $8cffe22d3a2884c1$var$Na("serverTimestamp");
        return e._methodName = "FieldValue.serverTimestamp", new t(e);
    }, t.delete = function() {
        var e = new $8cffe22d3a2884c1$var$Ea("deleteField");
        return e._methodName = "FieldValue.delete", new t(e);
    }, t.arrayUnion = function() {
        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        var r = /**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ (function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            // NOTE: We don't actually parse the data until it's used in set() or
            // update() since we'd need the Firestore instance to do this.
            return new $8cffe22d3a2884c1$var$Da("arrayUnion", t);
        }).apply(void 0, e);
        return r._methodName = "FieldValue.arrayUnion", new t(r);
    }, t.arrayRemove = function() {
        for(var e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        var r = (function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            // NOTE: We don't actually parse the data until it's used in set() or
            // update() since we'd need the Firestore instance to do this.
            return new $8cffe22d3a2884c1$var$Aa("arrayRemove", t);
        }).apply(void 0, e);
        return r._methodName = "FieldValue.arrayRemove", new t(r);
    }, t.increment = function(e) {
        var n = function(t) {
            return new $8cffe22d3a2884c1$var$ka("increment", t);
        }(e);
        return n._methodName = "FieldValue.increment", new t(n);
    }, t.prototype.isEqual = function(t) {
        return this._delegate.isEqual(t._delegate);
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8cffe22d3a2884c1$export$3b14a55fb2447963(t) {
    /**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for for.
 * @param bundleData - An object representing the bundle to be loaded. Valid objects are
 *   `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns
 *   A `LoadBundleTask` object, which notifies callers with progress updates, and completion
 *   or error events. It can be used as a `Promise<LoadBundleTaskProgress>`.
 */ return function(t, e) {
        var i = $8cffe22d3a2884c1$var$aa(t = $8cffe22d3a2884c1$var$zu(t, $8cffe22d3a2884c1$export$971d5caa766a69d7)), o = new $8cffe22d3a2884c1$var$oa;
        return function(t, e, i, o) {
            var s = this, u = function(t, e) {
                return function(t, e) {
                    return new $8cffe22d3a2884c1$var$vu(t, e);
                }(function(t, e) {
                    if (t instanceof Uint8Array) return $8cffe22d3a2884c1$var$pu(t, e);
                    if (t instanceof ArrayBuffer) return $8cffe22d3a2884c1$var$pu(new Uint8Array(t), e);
                    if (t instanceof ReadableStream) return t.getReader();
                    throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
                }("string" == typeof t ? (new TextEncoder).encode(t) : t), e);
            }(i, $8cffe22d3a2884c1$var$Co(e));
            t.asyncQueue.enqueueAndForget(function() {
                return (0, $2WUgS.__awaiter)(s, void 0, void 0, function() {
                    var e;
                    return (0, $2WUgS.__generator)(this, function(n) {
                        switch(n.label){
                            case 0:
                                return e = $8cffe22d3a2884c1$var$cu, [
                                    4 /*yield*/ ,
                                    $8cffe22d3a2884c1$var$Du(t)
                                ];
                            case 1:
                                return e.apply(void 0, [
                                    n.sent(),
                                    u,
                                    o
                                ]), [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        }(i, t._databaseId, e, o), o;
    }(this._delegate, t);
}
function $8cffe22d3a2884c1$export$407448d2b89b1813(t) {
    var e, i, o = this;
    return (e = this._delegate, i = t, (function(t, e) {
        var i = this;
        return t.asyncQueue.enqueue(function() {
            return (0, $2WUgS.__awaiter)(i, void 0, void 0, function() {
                var n;
                return (0, $2WUgS.__generator)(this, function(r) {
                    switch(r.label){
                        case 0:
                            return n = function(t, e) {
                                var n = $8cffe22d3a2884c1$var$F(t);
                                return n.persistence.runTransaction("Get named query", "readonly", function(t) {
                                    return n.Ke.getNamedQuery(t, e);
                                });
                            }, [
                                4 /*yield*/ ,
                                $8cffe22d3a2884c1$var$Su(t)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                n.apply(void 0, [
                                    r.sent(),
                                    e
                                ])
                            ];
                    }
                });
            });
        });
    })($8cffe22d3a2884c1$var$aa(e = $8cffe22d3a2884c1$var$zu(e, $8cffe22d3a2884c1$export$971d5caa766a69d7)), i).then(function(t) {
        return t ? new $8cffe22d3a2884c1$var$Xu(e, null, t.query) : null;
    })).then(function(t) {
        return t ? new $8cffe22d3a2884c1$export$f1e1789686576879(o, t) : null;
    });
}



var $4TGB3 = parcelRequire("4TGB3");

parcelRequire("eTAKc");
parcelRequire("i4pDv");

var $73fd42e7eed4b526$var$C = {
    Firestore: (0, $8cffe22d3a2884c1$export$3466f893ebf79586),
    GeoPoint: (0, $8cffe22d3a2884c1$export$e7094788287c5e9b),
    Timestamp: (0, $8cffe22d3a2884c1$export$3a1a48c8f6ef640e),
    Blob: (0, $8cffe22d3a2884c1$export$61196ced6d74a310),
    Transaction: (0, $8cffe22d3a2884c1$export$71cec2538cb2c617),
    WriteBatch: (0, $8cffe22d3a2884c1$export$2329c99376c9d0a4),
    DocumentReference: (0, $8cffe22d3a2884c1$export$7f8ddf7c7c20b3cd),
    DocumentSnapshot: (0, $8cffe22d3a2884c1$export$dc98b0b04f4c7758),
    Query: (0, $8cffe22d3a2884c1$export$f1e1789686576879),
    QueryDocumentSnapshot: (0, $8cffe22d3a2884c1$export$625550452a3fa3ec),
    QuerySnapshot: (0, $8cffe22d3a2884c1$export$2408f22a0fab9ae5),
    CollectionReference: (0, $8cffe22d3a2884c1$export$23f2a1d2818174ef),
    FieldPath: (0, $8cffe22d3a2884c1$export$ae1af26003f05816),
    FieldValue: (0, $8cffe22d3a2884c1$export$db3b6bfb95261072),
    setLogLevel: (0, $8cffe22d3a2884c1$export$35e795649ee09318),
    CACHE_SIZE_UNLIMITED: (0, $8cffe22d3a2884c1$export$a9c23c6ac3fc3eca)
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Registers the main Firestore build with the components framework.
 * Persistence can be enabled via `firebase.firestore().enablePersistence()`.
 */ function $73fd42e7eed4b526$export$d9d7c974c56fbaf7(e) {
    !/**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 *
 * @param firebase - The FirebaseNamespace to register Firestore with
 * @param firestoreFactory - A factory function that returns a new Firestore
 *    instance.
 */ function(e, r) {
        e.INTERNAL.registerComponent(new (0, $4TGB3.Component)("firestore", function(e) {
            var t = e.getProvider("app").getImmediate();
            return r(t, e.getProvider("auth-internal"));
        }, "PUBLIC" /* PUBLIC */ ).setServiceProps(Object.assign({}, $73fd42e7eed4b526$var$C)));
    }(e, function(e, s) {
        return new (0, $8cffe22d3a2884c1$export$3466f893ebf79586)(e, new (0, $8cffe22d3a2884c1$export$971d5caa766a69d7)(e, s), new (0, $8cffe22d3a2884c1$export$3a6d5c9ae78a2c08));
    }), e.registerVersion("@firebase/firestore", "2.4.1");
}
$73fd42e7eed4b526$export$d9d7c974c56fbaf7((0, $8eXKx.default));





var $8eXKx = parcelRequire("8eXKx");

var $2WUgS = parcelRequire("2WUgS");

var $4TGB3 = parcelRequire("4TGB3");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ var $080b7578103ce3b8$var$errorCodeMap = {
    OK: "ok",
    CANCELLED: "cancelled",
    UNKNOWN: "unknown",
    INVALID_ARGUMENT: "invalid-argument",
    DEADLINE_EXCEEDED: "deadline-exceeded",
    NOT_FOUND: "not-found",
    ALREADY_EXISTS: "already-exists",
    PERMISSION_DENIED: "permission-denied",
    UNAUTHENTICATED: "unauthenticated",
    RESOURCE_EXHAUSTED: "resource-exhausted",
    FAILED_PRECONDITION: "failed-precondition",
    ABORTED: "aborted",
    OUT_OF_RANGE: "out-of-range",
    UNIMPLEMENTED: "unimplemented",
    INTERNAL: "internal",
    UNAVAILABLE: "unavailable",
    DATA_LOSS: "data-loss"
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */ var $080b7578103ce3b8$var$HttpsErrorImpl = /** @class */ function(_super) {
    (0, $2WUgS.__extends)(HttpsErrorImpl, _super);
    function HttpsErrorImpl(code, message, details) {
        var _this = _super.call(this, message) || this;
        // This is a workaround for a bug in TypeScript when extending Error:
        // tslint:disable-next-line
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
        _this.code = code;
        _this.details = details;
        return _this;
    }
    return HttpsErrorImpl;
}(Error);
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $080b7578103ce3b8$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return "ok";
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return "internal";
        case 400:
            return "invalid-argument";
        case 401:
            return "unauthenticated";
        case 403:
            return "permission-denied";
        case 404:
            return "not-found";
        case 409:
            return "aborted";
        case 429:
            return "resource-exhausted";
        case 499:
            return "cancelled";
        case 500:
            return "internal";
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline-exceeded";
    }
    return "unknown";
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $080b7578103ce3b8$var$_errorForResponse(status, bodyJSON, serializer) {
    var code = $080b7578103ce3b8$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    var description = code;
    var details = undefined;
    // Then look through the body for explicit details.
    try {
        var errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            var status_1 = errorJSON.status;
            if (typeof status_1 === "string") {
                if (!$080b7578103ce3b8$var$errorCodeMap[status_1]) // They must've included an unknown error code in the body.
                return new $080b7578103ce3b8$var$HttpsErrorImpl("internal", "internal");
                code = $080b7578103ce3b8$var$errorCodeMap[status_1];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status_1;
            }
            var message = errorJSON.message;
            if (typeof message === "string") description = message;
            details = errorJSON.details;
            if (details !== undefined) details = serializer.decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === "ok") // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $080b7578103ce3b8$var$HttpsErrorImpl(code, description, details);
}
/**
 * Helper class to get metadata that should be included with a function call.
 */ var $080b7578103ce3b8$var$ContextProvider = /** @class */ function() {
    function ContextProvider(authProvider, messagingProvider) {
        var _this = this;
        this.auth = null;
        this.messaging = null;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then(function(auth) {
            return _this.auth = auth;
        }, function() {
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then(function(messaging) {
            return _this.messaging = messaging;
        }, function() {
        /* get() never rejects */ });
    }
    ContextProvider.prototype.getAuthToken = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var token;
            return (0, $2WUgS.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.auth) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.auth.getToken()
                        ];
                    case 2:
                        token = _a.sent();
                        if (!token) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        return [
                            2 /*return*/ ,
                            token.accessToken
                        ];
                    case 3:
                        _a.sent();
                        // If there's any error when trying to get the auth token, leave it off.
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ContextProvider.prototype.getInstanceIdToken = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            return (0, $2WUgS.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.messaging || !("Notification" in self) || Notification.permission !== "granted") return [
                            2 /*return*/ ,
                            undefined
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.messaging.getToken()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        _a.sent();
                        // We don't warn on this, because it usually means messaging isn't set up.
                        // console.warn('Failed to retrieve instance id token.', e);
                        // If there's any error when trying to get the token, leave it off.
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ContextProvider.prototype.getContext = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var authToken, instanceIdToken;
            return (0, $2WUgS.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getAuthToken()
                        ];
                    case 1:
                        authToken = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.getInstanceIdToken()
                        ];
                    case 2:
                        instanceIdToken = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                authToken: authToken,
                                instanceIdToken: instanceIdToken
                            }
                        ];
                }
            });
        });
    };
    return ContextProvider;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $080b7578103ce3b8$var$LONG_TYPE = "type.googleapis.com/google.protobuf.Int64Value";
var $080b7578103ce3b8$var$UNSIGNED_LONG_TYPE = "type.googleapis.com/google.protobuf.UInt64Value";
function $080b7578103ce3b8$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    var result = {};
    for(var key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
var $080b7578103ce3b8$var$Serializer = /** @class */ function() {
    function Serializer() {}
    // Takes data and encodes it in a JSON-friendly way, such that types such as
    // Date are preserved.
    Serializer.prototype.encode = function(data) {
        var _this = this;
        if (data == null) return null;
        if (data instanceof Number) data = data.valueOf();
        if (typeof data === "number" && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
        // without any loss of precision.
        return data;
        if (data === true || data === false) return data;
        if (Object.prototype.toString.call(data) === "[object String]") return data;
        if (data instanceof Date) return data.toISOString();
        if (Array.isArray(data)) return data.map(function(x) {
            return _this.encode(x);
        });
        if (typeof data === "function" || typeof data === "object") return $080b7578103ce3b8$var$mapValues(data, function(x) {
            return _this.encode(x);
        });
        // If we got this far, the data is not encodable.
        throw new Error("Data cannot be encoded in JSON: " + data);
    };
    // Takes data that's been encoded in a JSON-friendly form and returns a form
    // with richer datatypes, such as Dates, etc.
    Serializer.prototype.decode = function(json) {
        var _this = this;
        if (json == null) return json;
        if (json["@type"]) switch(json["@type"]){
            case $080b7578103ce3b8$var$LONG_TYPE:
            // Fall through and handle this the same as unsigned.
            case $080b7578103ce3b8$var$UNSIGNED_LONG_TYPE:
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                var value = Number(json["value"]);
                if (isNaN(value)) throw new Error("Data cannot be decoded from JSON: " + json);
                return value;
            default:
                throw new Error("Data cannot be decoded from JSON: " + json);
        }
        if (Array.isArray(json)) return json.map(function(x) {
            return _this.decode(x);
        });
        if (typeof json === "function" || typeof json === "object") return $080b7578103ce3b8$var$mapValues(json, function(x) {
            return _this.decode(x);
        });
        // Anything else is safe to return.
        return json;
    };
    return Serializer;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type HttpsErrorImpl.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $080b7578103ce3b8$var$failAfter(millis) {
    var timer;
    var promise = new Promise(function(_, reject) {
        timer = setTimeout(function() {
            reject(new $080b7578103ce3b8$var$HttpsErrorImpl("deadline-exceeded", "deadline-exceeded"));
        }, millis);
    });
    return {
        timer: timer,
        promise: promise
    };
}
/**
 * The main class for the Firebase Functions SDK.
 */ var $080b7578103ce3b8$var$Service = /** @class */ function() {
    /**
     * Creates a new Functions service for the given app and (optional) region or custom domain.
     * @param app_ The FirebaseApp to use.
     * @param regionOrCustomDomain_ one of:
     *   a) A region to call functions from, such as us-central1
     *   b) A custom domain to use as a functions prefix, such as https://mydomain.com
     */ function Service(app_, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain_, fetchImpl) {
        var _this = this;
        if (regionOrCustomDomain_ === void 0) regionOrCustomDomain_ = "us-central1";
        this.app_ = app_;
        this.appCheckProvider = appCheckProvider;
        this.fetchImpl = fetchImpl;
        this.serializer = new $080b7578103ce3b8$var$Serializer();
        this.emulatorOrigin = null;
        this.INTERNAL = {
            delete: function() {
                return Promise.resolve(_this.deleteService());
            }
        };
        this.contextProvider = new $080b7578103ce3b8$var$ContextProvider(authProvider, messagingProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise(function(resolve) {
            _this.deleteService = function() {
                return resolve();
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            var url = new URL(regionOrCustomDomain_);
            this.customDomain = url.origin;
            this.region = "us-central1";
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain_;
        }
    }
    Object.defineProperty(Service.prototype, "app", {
        get: function() {
            return this.app_;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the URL for a callable with the given name.
     * @param name The name of the callable.
     */ Service.prototype._url = function(name) {
        var projectId = this.app_.options.projectId;
        if (this.emulatorOrigin !== null) {
            var origin_1 = this.emulatorOrigin;
            return origin_1 + "/" + projectId + "/" + this.region + "/" + name;
        }
        if (this.customDomain !== null) return this.customDomain + "/" + name;
        return "https://" + this.region + "-" + projectId + ".cloudfunctions.net/" + name;
    };
    /**
     * Modify this instance to communicate with the Cloud Functions emulator.
     *
     * Note: this must be called before this instance has been used to do any operations.
     *
     * @param host The emulator host (ex: localhost)
     * @param port The emulator port (ex: 5001)
     */ Service.prototype.useEmulator = function(host, port) {
        this.emulatorOrigin = "http://" + host + ":" + port;
    };
    /**
     * Changes this instance to point to a Cloud Functions emulator running
     * locally. See https://firebase.google.com/docs/functions/local-emulator
     *
     * @deprecated Prefer the useEmulator(host, port) method.
     * @param origin The origin of the local emulator, such as
     * "http://localhost:5005".
     */ Service.prototype.useFunctionsEmulator = function(origin) {
        this.emulatorOrigin = origin;
    };
    /**
     * Returns a reference to the callable https trigger with the given name.
     * @param name The name of the trigger.
     */ Service.prototype.httpsCallable = function(name, options) {
        var _this = this;
        return function(data) {
            return _this.call(name, data, options || {});
        };
    };
    /**
     * Does an HTTP POST and returns the completed response.
     * @param url The url to post to.
     * @param body The JSON body of the post.
     * @param headers The HTTP headers to include in the request.
     * @return A Promise that will succeed when the request finishes.
     */ Service.prototype.postJSON = function(url, body, headers) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var appCheckToken, response, json;
            return (0, $2WUgS.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        headers["Content-Type"] = "application/json";
                        return [
                            4 /*yield*/ ,
                            this.getAppCheckToken()
                        ];
                    case 1:
                        appCheckToken = _a.sent();
                        if (appCheckToken !== null) headers["X-Firebase-AppCheck"] = appCheckToken;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchImpl(url, {
                                method: "POST",
                                body: JSON.stringify(body),
                                headers: headers
                            })
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _a.sent();
                        // This could be an unhandled error on the backend, or it could be a
                        // network error. There's no way to know, since an unhandled error on the
                        // backend will fail to set the proper CORS header, and thus will be
                        // treated as a network error by fetch.
                        return [
                            2 /*return*/ ,
                            {
                                status: 0,
                                json: null
                            }
                        ];
                    case 5:
                        json = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 7:
                        json = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            {
                                status: response.status,
                                json: json
                            }
                        ];
                }
            });
        });
    };
    Service.prototype.getAppCheckToken = function() {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var appCheck, result;
            return (0, $2WUgS.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        appCheck = this.appCheckProvider.getImmediate({
                            optional: true
                        });
                        if (!appCheck) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            appCheck.getToken()
                        ];
                    case 1:
                        result = _a.sent();
                        // If getToken() fails, it will still return a dummy token that also has
                        // an error field containing the error message. We will send any token
                        // provided here and show an error if/when it is rejected by the functions
                        // endpoint.
                        return [
                            2 /*return*/ ,
                            result.token
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            null
                        ];
                }
            });
        });
    };
    /**
     * Calls a callable function asynchronously and returns the result.
     * @param name The name of the callable trigger.
     * @param data The data to pass as params to the function.s
     */ Service.prototype.call = function(name, data, options) {
        return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
            var url, body, headers, context, timeout, _a, timer, failAfterPromise, response, error, responseData, decodedData;
            return (0, $2WUgS.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        url = this._url(name);
                        // Encode any special types, such as dates, in the input data.
                        data = this.serializer.encode(data);
                        body = {
                            data: data
                        };
                        headers = {};
                        return [
                            4 /*yield*/ ,
                            this.contextProvider.getContext()
                        ];
                    case 1:
                        context = _b.sent();
                        if (context.authToken) headers["Authorization"] = "Bearer " + context.authToken;
                        if (context.instanceIdToken) headers["Firebase-Instance-ID-Token"] = context.instanceIdToken;
                        timeout = options.timeout || 70000;
                        _a = $080b7578103ce3b8$var$failAfter(timeout), timer = _a.timer, failAfterPromise = _a.promise;
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                $080b7578103ce3b8$var$clearTimeoutWrapper(timer, this.postJSON(url, body, headers)),
                                failAfterPromise,
                                $080b7578103ce3b8$var$clearTimeoutWrapper(timer, this.cancelAllRequests)
                            ])
                        ];
                    case 2:
                        response = _b.sent();
                        // If service was deleted, interrupted response throws an error.
                        if (!response) throw new $080b7578103ce3b8$var$HttpsErrorImpl("cancelled", "Firebase Functions instance was deleted.");
                        error = $080b7578103ce3b8$var$_errorForResponse(response.status, response.json, this.serializer);
                        if (error) throw error;
                        if (!response.json) throw new $080b7578103ce3b8$var$HttpsErrorImpl("internal", "Response is not valid JSON object.");
                        responseData = response.json.data;
                        // TODO(klimt): For right now, allow "result" instead of "data", for
                        // backwards compatibility.
                        if (typeof responseData === "undefined") responseData = response.json.result;
                        if (typeof responseData === "undefined") // Consider the response malformed.
                        throw new $080b7578103ce3b8$var$HttpsErrorImpl("internal", "Response is missing data field.");
                        decodedData = this.serializer.decode(responseData);
                        return [
                            2 /*return*/ ,
                            {
                                data: decodedData
                            }
                        ];
                }
            });
        });
    };
    return Service;
}();
function $080b7578103ce3b8$var$clearTimeoutWrapper(timer, promise) {
    return (0, $2WUgS.__awaiter)(this, void 0, void 0, function() {
        var result;
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        promise
                    ];
                case 1:
                    result = _a.sent();
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    clearTimeout(timer);
                    return [
                        2 /*return*/ ,
                        result
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ var $080b7578103ce3b8$var$FUNCTIONS_TYPE = "functions";
function $080b7578103ce3b8$var$registerFunctions(instance, fetchImpl) {
    var namespaceExports = {
        // no-inline
        Functions: $080b7578103ce3b8$var$Service
    };
    function factory(container, _a) {
        var regionOrCustomDomain = _a.instanceIdentifier;
        // Dependencies
        var app = container.getProvider("app").getImmediate();
        var authProvider = container.getProvider("auth-internal");
        var appCheckProvider = container.getProvider("app-check-internal");
        var messagingProvider = container.getProvider("messaging");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $080b7578103ce3b8$var$Service(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain, fetchImpl);
    }
    instance.INTERNAL.registerComponent(new (0, $4TGB3.Component)($080b7578103ce3b8$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* PUBLIC */ ).setServiceProps(namespaceExports).setMultipleInstances(true));
}
var $080b7578103ce3b8$var$name = "@firebase/functions";
var $080b7578103ce3b8$var$version = "0.6.16";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $080b7578103ce3b8$var$registerFunctions((0, $8eXKx.default), fetch.bind(self));
(0, $8eXKx.default).registerVersion($080b7578103ce3b8$var$name, $080b7578103ce3b8$var$version);





var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
var $d5c35a4573de93de$var$snapshotToData = function(snapshot, snapshotOptions, idField, refField, transform) {
    if (!snapshot.exists) return undefined;
    var data = snapshot.data(snapshotOptions);
    if (transform) data = transform(data);
    if (idField) data[idField] = snapshot.id;
    if (refField) data[refField] = snapshot.ref;
    return data;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $d5c35a4573de93de$var$__assign = function() {
    $d5c35a4573de93de$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d5c35a4573de93de$var$__assign.apply(this, arguments);
};
var $d5c35a4573de93de$var$defaultState = function(defaultValue) {
    return {
        loading: defaultValue === undefined || defaultValue === null,
        value: defaultValue
    };
};
var $d5c35a4573de93de$var$reducer = function() {
    return function(state, action) {
        switch(action.type){
            case "error":
                return $d5c35a4573de93de$var$__assign({}, state, {
                    error: action.error,
                    loading: false,
                    value: undefined
                });
            case "reset":
                return $d5c35a4573de93de$var$defaultState(action.defaultValue);
            case "value":
                return $d5c35a4573de93de$var$__assign({}, state, {
                    error: undefined,
                    loading: false,
                    value: action.value
                });
            default:
                return state;
        }
    };
};
var $d5c35a4573de93de$var$useLoadingValue = function(getDefaultValue) {
    var defaultValue = getDefaultValue ? getDefaultValue() : undefined;
    var _a = (0, $lDSNw.useReducer)($d5c35a4573de93de$var$reducer(), $d5c35a4573de93de$var$defaultState(defaultValue)), state = _a[0], dispatch = _a[1];
    var reset = function() {
        var defaultValue = getDefaultValue ? getDefaultValue() : undefined;
        dispatch({
            type: "reset",
            defaultValue: defaultValue
        });
    };
    var setError = function(error) {
        dispatch({
            type: "error",
            error: error
        });
    };
    var setValue = function(value) {
        dispatch({
            type: "value",
            value: value
        });
    };
    return (0, $lDSNw.useMemo)(function() {
        return {
            error: state.error,
            loading: state.loading,
            reset: reset,
            setError: setError,
            setValue: setValue,
            value: state.value
        };
    }, [
        state.error,
        state.loading,
        reset,
        setError,
        setValue,
        state.value
    ]);
};
var $d5c35a4573de93de$var$useComparatorRef = function(value, isEqual, onChange) {
    var ref = (0, $lDSNw.useRef)(value);
    (0, $lDSNw.useEffect)(function() {
        if (!isEqual(value, ref.current)) {
            ref.current = value;
            if (onChange) onChange();
        }
    });
    return ref;
};
var $d5c35a4573de93de$var$isEqual = function(v1, v2) {
    var bothNull = !v1 && !v2;
    var equal = !!v1 && !!v2 && v1.isEqual(v2);
    return bothNull || equal;
};
var $d5c35a4573de93de$var$useIsEqualRef = function(value, onChange) {
    return $d5c35a4573de93de$var$useComparatorRef(value, $d5c35a4573de93de$var$isEqual, onChange);
};
var $d5c35a4573de93de$export$6cd28814d92fa9c9 = function(query, options) {
    return $d5c35a4573de93de$var$useCollectionInternal(true, query, options);
};
var $d5c35a4573de93de$export$b806f8b31e648973 = function(query, options) {
    return $d5c35a4573de93de$var$useCollectionInternal(false, query, options);
};
var $d5c35a4573de93de$export$f976898995c345b4 = function(query, options) {
    return $d5c35a4573de93de$var$useCollectionDataInternal(true, query, options);
};
var $d5c35a4573de93de$export$97bdb71edd3a292f = function(query, options) {
    return $d5c35a4573de93de$var$useCollectionDataInternal(false, query, options);
};
var $d5c35a4573de93de$var$useCollectionInternal = function(listen, query, options) {
    var _a = $d5c35a4573de93de$var$useLoadingValue(), error = _a.error, loading = _a.loading, reset = _a.reset, setError = _a.setError, setValue = _a.setValue, value = _a.value;
    var ref = $d5c35a4573de93de$var$useIsEqualRef(query, reset);
    (0, $lDSNw.useEffect)(function() {
        if (!ref.current) {
            setValue(undefined);
            return;
        }
        if (listen) {
            var listener_1 = options && options.snapshotListenOptions ? ref.current.onSnapshot(options.snapshotListenOptions, setValue, setError) : ref.current.onSnapshot(setValue, setError);
            return function() {
                listener_1();
            };
        } else ref.current.get(options ? options.getOptions : undefined).then(setValue).catch(setError);
    }, [
        ref.current
    ]);
    var resArray = [
        value,
        loading,
        error
    ];
    return (0, $lDSNw.useMemo)(function() {
        return resArray;
    }, resArray);
};
var $d5c35a4573de93de$var$useCollectionDataInternal = function(listen, query, options) {
    var idField = options ? options.idField : undefined;
    var refField = options ? options.refField : undefined;
    var snapshotOptions = options ? options.snapshotOptions : undefined;
    var transform = options ? options.transform : undefined;
    var _a = $d5c35a4573de93de$var$useCollectionInternal(listen, query, options), snapshots = _a[0], loading = _a[1], error = _a[2];
    var values = (0, $lDSNw.useMemo)(function() {
        return snapshots ? snapshots.docs.map(function(doc) {
            return $d5c35a4573de93de$var$snapshotToData(doc, snapshotOptions, idField, refField, transform);
        }) : options && options.initialValue;
    }, [
        snapshots,
        snapshotOptions,
        idField,
        refField,
        transform
    ]);
    var resArray = [
        values,
        loading,
        error
    ];
    return (0, $lDSNw.useMemo)(function() {
        return resArray;
    }, resArray);
};
var $d5c35a4573de93de$export$e71e2fb5c5c476d5 = function(docRef, options) {
    return $d5c35a4573de93de$var$useDocumentInternal(true, docRef, options);
};
var $d5c35a4573de93de$export$7d9b51c0f5747a63 = function(docRef, options) {
    return $d5c35a4573de93de$var$useDocumentInternal(false, docRef, options);
};
var $d5c35a4573de93de$export$d8c0c0b7453663d0 = function(docRef, options) {
    return $d5c35a4573de93de$var$useDocumentDataInternal(true, docRef, options);
};
var $d5c35a4573de93de$export$3d94ca782eda2c23 = function(docRef, options) {
    return $d5c35a4573de93de$var$useDocumentDataInternal(false, docRef, options);
};
var $d5c35a4573de93de$var$useDocumentInternal = function(listen, docRef, options) {
    var _a = $d5c35a4573de93de$var$useLoadingValue(), error = _a.error, loading = _a.loading, reset = _a.reset, setError = _a.setError, setValue = _a.setValue, value = _a.value;
    var ref = $d5c35a4573de93de$var$useIsEqualRef(docRef, reset);
    (0, $lDSNw.useEffect)(function() {
        if (!ref.current) {
            setValue(undefined);
            return;
        }
        if (listen) {
            var listener_1 = options && options.snapshotListenOptions ? ref.current.onSnapshot(options.snapshotListenOptions, setValue, setError) : ref.current.onSnapshot(setValue, setError);
            return function() {
                listener_1();
            };
        } else ref.current.get(options ? options.getOptions : undefined).then(setValue).catch(setError);
    }, [
        ref.current
    ]);
    var resArray = [
        value,
        loading,
        error
    ];
    return (0, $lDSNw.useMemo)(function() {
        return resArray;
    }, resArray);
};
var $d5c35a4573de93de$var$useDocumentDataInternal = function(listen, docRef, options) {
    var idField = options ? options.idField : undefined;
    var refField = options ? options.refField : undefined;
    var snapshotOptions = options ? options.snapshotOptions : undefined;
    var transform = options ? options.transform : undefined;
    var _a = $d5c35a4573de93de$var$useDocumentInternal(listen, docRef, options), snapshot = _a[0], loading = _a[1], error = _a[2];
    var value = (0, $lDSNw.useMemo)(function() {
        return snapshot ? $d5c35a4573de93de$var$snapshotToData(snapshot, snapshotOptions, idField, refField, transform) : options && options.initialValue;
    }, [
        snapshot,
        snapshotOptions,
        idField,
        refField,
        transform
    ]);
    var resArray = [
        value,
        loading,
        error
    ];
    return (0, $lDSNw.useMemo)(function() {
        return resArray;
    }, resArray);
};


// the amount of progress above and below the ad to include in the recording
// eg: a buffer of 25 means it will start recording when the ad is 75% in view at the bottom
// and stop when it is again 75% in view at the top
const $11d563350f5dc624$var$PROGRESS_BUFFER = 0;
let $11d563350f5dc624$var$lastTime;
let $11d563350f5dc624$var$isFirstScrollEvent = true;
const $11d563350f5dc624$var$isInView = function(progress) {
    return progress >= 0 && progress <= 100;
};
const $11d563350f5dc624$export$55f50a00c84f0ed3 = function(prevScrollInfo, progress) {
    const date = new Date();
    const currentTime = date.getTime();
    const timeDelta = currentTime - $11d563350f5dc624$var$lastTime;
    // can't start recording info until at least the 2nd scroll event as we need the time delta
    if ($11d563350f5dc624$var$isFirstScrollEvent) {
        $11d563350f5dc624$var$lastTime = currentTime;
        $11d563350f5dc624$var$isFirstScrollEvent = false;
        return prevScrollInfo;
    }
    if (prevScrollInfo.length > 0) {
        const prevProgress = prevScrollInfo[prevScrollInfo.length - 1].progress;
        // don't update if progress has changed only a small amount
        if (Math.abs(progress - prevProgress) < 1) return prevScrollInfo;
        // don't update if prevProgress and current progress are both outside of the ad range
        if (!$11d563350f5dc624$var$isInView(prevProgress) && !$11d563350f5dc624$var$isInView(progress)) return prevScrollInfo;
    }
    const newScrollEntry = {
        progress: progress,
        timeDelta: timeDelta
    };
    $11d563350f5dc624$var$lastTime = currentTime;
    return [
        ...prevScrollInfo,
        newScrollEntry
    ];
};
const $11d563350f5dc624$export$e9498bc088292d89 = function(scrollInfo) {
    const data = [];
    for(let i = 1; i < scrollInfo.length; i++){
        // const prev = scrollInfo[i - 1];
        const curr = scrollInfo[i];
        const { timeDelta: timeDelta, progress: progress } = curr;
        if (timeDelta > 500) data.push({
            idleTime: timeDelta,
            progress: progress
        });
    }
    return data;
};
const $11d563350f5dc624$export$fcce7887255d1c69 = function(from, to) {
    if (from.progress === to.progress) return "idle";
    return to.progress > from.progress ? "down" : "up";
};
const $11d563350f5dc624$export$8efd0841b0865f2c = function(scrollInfo) {
    // create the initial single segment sequence
    const sequence = {
        startProgress: scrollInfo[0].progress,
        endProgress: scrollInfo[1].progress,
        direction: $11d563350f5dc624$export$fcce7887255d1c69(scrollInfo[0], scrollInfo[1]),
        duration: scrollInfo[1].timeDelta
    };
    // continue adding to the sequence from the 2nd segment on
    for(let to = 2; to < scrollInfo.length; to++){
        const prev = scrollInfo[to - 1];
        const curr = scrollInfo[to];
        const direction = $11d563350f5dc624$export$fcce7887255d1c69(prev, curr);
        // end the sequence if the direction changes
        if (direction !== sequence.direction) {
            // subtract 1 from the slice position because the end of this sequence will become the start of the next sequence
            const remainingScrollInfo = scrollInfo.slice(to - 1);
            return [
                sequence,
                remainingScrollInfo
            ];
        }
        // sequence gets a little longer
        sequence.endProgress = curr.progress;
        sequence.duration += curr.timeDelta;
    }
    // if we make it to the end of scrollInfo without a direction change
    // then return the final sequence
    return [
        sequence,
        []
    ];
};
const $11d563350f5dc624$export$c554f64eaaa85ca7 = function(scrollInfo) {
    let sequences = [];
    let remainingScrollInfo = [
        ...scrollInfo
    ];
    while(remainingScrollInfo.length > 1){
        const [sequence, newScrollInfo] = $11d563350f5dc624$export$8efd0841b0865f2c(remainingScrollInfo);
        sequences.push(sequence);
        remainingScrollInfo = newScrollInfo;
    }
    return sequences;
};
const $11d563350f5dc624$var$getOverlaps = function(sequences, mode, sessionSize) {
    let overlaps = new Array(101).fill(0);
    for (const sequence of sequences){
        const startTimeline = mode === "timeline" ? sequence.startTimeline : sequence.startProgress;
        const endTimeline = mode === "timeline" ? sequence.endTimeline : sequence.endProgress;
        const duration = sequence.duration;
        const start = Math.floor(Math.min(startTimeline, endTimeline));
        const end = Math.floor(Math.max(startTimeline, endTimeline));
        for(let i = start + $11d563350f5dc624$var$PROGRESS_BUFFER; i <= end + $11d563350f5dc624$var$PROGRESS_BUFFER; i += 1){
            if (duration / Math.abs((endTimeline - startTimeline).toFixed(2)) === Infinity) console.error("infinate", duration, Math.abs(Math.floor(endTimeline - startTimeline)));
            if (i >= 0 && i <= 100 && end - start !== 0) overlaps[i] += 1;
        }
    }
    return overlaps.map((overlap)=>+(overlap / sessionSize).toFixed(5));
};
const $11d563350f5dc624$export$6c9dbc2dfbd602db = function(sequences, mode, sessionSize) {
    const overlaps = $11d563350f5dc624$var$getOverlaps(sequences, mode, sessionSize);
    return overlaps.map((value, index)=>({
            timeline: index - $11d563350f5dc624$var$PROGRESS_BUFFER,
            playfulness: value
        }));
};
const $11d563350f5dc624$export$3a0f8eb7361883bd = (data, startProgress, endProgress, dataKey)=>{
    const dataClone = [
        ...data
    ].slice(startProgress, endProgress);
    const max = dataClone.reduce((prev, current)=>prev[dataKey] > current[dataKey] ? prev : current)[dataKey];
    const min = dataClone.reduce(function(prev, current) {
        return prev[dataKey] < current[dataKey] ? prev : current;
    })[dataKey];
    const gap = max - min;
    return data.map((value)=>{
        const newValue = {
            ...value
        };
        if (value[dataKey] >= min && value[dataKey] <= max) newValue[dataKey] = (value[dataKey] - min) * (100 / gap);
        else if (value[dataKey] > max) newValue[dataKey] = 100;
        else newValue[dataKey] = 0;
        return newValue;
    });
};



const $abbc57578fc5f1d4$var$firebaseConfig = {
    apiKey: "AIzaSyDpUhDd45mMt7ziJb1lH65qgEKKjVKW0Uw",
    authDomain: "creative-analytics-tool-2.firebaseapp.com",
    databaseURL: "https://creative-analytics-tool-2.firebaseio.com",
    projectId: "creative-analytics-tool-2",
    storageBucket: "creative-analytics-tool-2.appspot.com",
    messagingSenderId: "635812627036",
    appId: "1:635812627036:web:95a138785f35da32e7dc99",
    measurementId: "G-BH0QRR4MHX"
};
if ((0, $8eXKx.default).apps.length === 0) (0, $8eXKx.default).initializeApp($abbc57578fc5f1d4$var$firebaseConfig);
var $abbc57578fc5f1d4$export$2e2bcd8739ae039 = (0, $8eXKx.default);
const $abbc57578fc5f1d4$export$c554f64eaaa85ca7 = (...restArgs)=>(0, $8eXKx.default).functions().httpsCallable("getBuildSequences")(...restArgs);
const $abbc57578fc5f1d4$export$94bc68ccb51c8a90 = (0, $8eXKx.default).functions().httpsCallable("CATReportCreative");
const $abbc57578fc5f1d4$export$1ba065e814a7b0c = (0, $8eXKx.default).functions().httpsCallable("getRawSessionsData");
const $abbc57578fc5f1d4$export$1af1d9fcab526faa = (0, $8eXKx.default).functions().httpsCallable("getHomepageCache");
const $abbc57578fc5f1d4$export$768091fc174c24e0 = (0, $8eXKx.default).functions().httpsCallable("aggregateCatData");
const $abbc57578fc5f1d4$export$ab07af100e3ae3cc = async (buildId)=>{
    const docRef = (0, $8eXKx.default).firestore().collection("CAT3").doc(buildId);
    const snapshot = await docRef.get();
    if (snapshot.exists) {
        let data = snapshot.data();
        // if there's no aggregated data, we'll generate it and save it for next time
        if (!data.aggregatedSessionSize) {
            console.log("Need to aggregate data for buildId: ", buildId);
            const aggregatedData = await $abbc57578fc5f1d4$export$768091fc174c24e0({
                buildId: buildId
            });
            data = {
                ...data,
                ...aggregatedData.data
            };
        }
        const domainRef = (0, $8eXKx.default).firestore().collection("CAT3").doc(buildId).collection("domains");
        const domainSnapshot = await domainRef.get();
        data.domains = domainSnapshot.docs.map((doc)=>({
                domain: doc.id,
                ...doc.data()
            }));
        return data;
    } else throw "No data for that build id.";
};
const $abbc57578fc5f1d4$export$2369333ddd6d5edd = async (format = "hang-time")=>{
    const dataRef = (0, $8eXKx.default).firestore().collection("Vertical-Baselines").doc("baseline").collection(format).doc("current");
    const querySnapshot = await dataRef.get();
    if (querySnapshot.exists) return querySnapshot.data();
    else throw "No baseline data.";
};
const $abbc57578fc5f1d4$export$d77a2064e943270a = async (format = "hang-time")=>{
    const dataRef = (0, $8eXKx.default).firestore().collection("Video-Baselines").doc(format);
    const querySnapshot = await dataRef.get();
    if (querySnapshot.exists) {
        const data = querySnapshot.data();
        return data.byDurationVideoDropOffBaselines;
    } else throw "No baseline data.";
};
const $abbc57578fc5f1d4$export$4a03b8b56ddcdd7d = async (buildId)=>{
    const rootDataRef = (0, $8eXKx.default).firestore().collection("CAT3").doc(buildId);
    return await rootDataRef.get().then((querySnapshot)=>{
        const scriptVersion = querySnapshot.data().scriptVersion ? querySnapshot.data().scriptVersion : "unknown";
        const brandNames = querySnapshot.data().brandNames ? querySnapshot.data().brandNames : "";
        const campaignNames = querySnapshot.data().campaignNames ? querySnapshot.data().campaignNames : "";
        const creativeNames = querySnapshot.data().creativeNames ? querySnapshot.data().creativeNames.split("- Approved")[0] : "";
        const format = querySnapshot.data().format ? querySnapshot.data().format : "hang-time";
        return {
            scriptVersion: scriptVersion,
            brandNames: brandNames,
            campaignNames: campaignNames,
            creativeNames: creativeNames,
            format: format
        };
    });
};
const $abbc57578fc5f1d4$export$1ccd18b430f734f = async (buildId, minSequenceLength, triggerType)=>{
    const dataRef = (0, $8eXKx.default).firestore().collection("CAT3").doc(buildId).collection(buildId === "nayoyo" ? "sessions" : triggerType === "scrub" ? "scrubSessions" : "dwellTimeSessions");
    let querySnapshot;
    try {
        querySnapshot = await dataRef.get();
    } catch (error) {
        console.error("Error getting document");
        throw error;
    }
    if (querySnapshot.empty) throw "Creative hasn't registered any data in CAT yet. Please wait for the creative to go live.";
    const response = querySnapshot.docs.map((doc)=>doc.data()).reduce((acc, { sequences: sequences, dwellTime: dwellTime }, i, array)=>{
        if (sequences.length >= minSequenceLength) {
            acc.sequences = [
                ...acc.sequences,
                ...sequences
            ];
            acc.sessionSize++;
        }
        if (dwellTime.length) dwellTime.forEach((time, i)=>{
            acc.dwellTimes[i].dwellTime += time / array.length; //Purposely not rounding here as we'd lose accuracy
            acc.dwellTimes[i].counter = array.length; //TODO: check if that is used
        });
        return acc;
    }, {
        dwellTimes: Array.from({
            length: 101
        }, (_, timeline)=>({
                timeline: timeline,
                dwellTime: 0,
                counter: 0
            })),
        sessionSize: 0,
        sequences: []
    });
    const scrollMode = response.sequences[0]?.startProgress ? "progress" : "timeline";
    return {
        ...response,
        scrollMode: scrollMode
    };
};
const $abbc57578fc5f1d4$export$c980331f44211c8 = (0, $8eXKx.default).functions().httpsCallable("saveABPresentation");
const $abbc57578fc5f1d4$export$c8df2540c925bbd4 = (buildId)=>{
    const [data, isLoading, error] = (0, $d5c35a4573de93de$export$3d94ca782eda2c23)((0, $8eXKx.default).firestore().collection("CAT3").doc(buildId));
    const [devData = null, isLoadingDev = false, devError = null] = (0, $d5c35a4573de93de$export$3d94ca782eda2c23)((0, $8eXKx.default).firestore().collection("CAT-Test-Creative").doc(buildId));
    const [returnData, setReturnData] = (0, $lDSNw.useState)();
    (0, $lDSNw.useEffect)(()=>{
        devData && console.log(devData);
        setReturnData({
            ...data,
            ...devData
        });
    }, [
        data,
        devData
    ]);
    return [
        returnData,
        isLoading || isLoadingDev,
        error ? error : devError ? devError : null
    ];
};
const $abbc57578fc5f1d4$export$d6364df2fe2951ac = (buildId)=>{
    let [data, setData] = (0, $lDSNw.useState)([]);
    let [isLoaded, setIsLoaded] = (0, $lDSNw.useState)(true);
    let [error, setError] = (0, $lDSNw.useState)(null);
    (0, $lDSNw.useEffect)(()=>{
        (0, $8eXKx.default).firestore().collection(`CAT3/${buildId}/DCOARecommendations/current/domainRecommendations`).get().then((snap)=>{
            setIsLoaded(false);
            setData(snap.docs.map((doc)=>doc.data()));
        }).catch(setError);
    }, []);
    return [
        data,
        isLoaded,
        error
    ];
};
const $abbc57578fc5f1d4$export$899b73fa4a791c00 = async (buildId)=>{
    const dcoRef = (0, $8eXKx.default).firestore().collection("DCO").doc(buildId);
    const dcoHistoryRef = dcoRef.collection("history");
    const dcoSnapshot = await dcoRef.get();
    const dcoHistorySnapshot = await dcoHistoryRef.get();
    const dcoMetaData = dcoSnapshot.data();
    const dcoHistoryData = dcoHistorySnapshot.docs.map((doc)=>{
        const data = doc.data();
        data.variations.sort((a, b)=>b.weighting - a.weighting);
        return data;
    });
    dcoHistoryData.sort((a, b)=>a.created - b.created);
    // when we import the data here we'll assign a colour to each variation so it's consistent
    // across the report – these are a selection of the default colours from Chakra UI Theme
    // TODO - refactor this as the color and an Icon should come from Remix
    // when the DCO is created and be saved to the db (DCO variations collection)
    const colors = [
        "purple",
        "orange",
        "blue",
        "green",
        "teal",
        "cyan",
        "pink",
        "yellow"
    ];
    // the score will just be the total scrubs average (scrubsTotal / sessions)
    const overallScrubPerformance = dcoHistoryData.reduce((acc, curr)=>{
        const score = curr?.overall?.scrubs ? curr.overall.scrubs.reduce((a, c)=>{
            return a + c;
        }, 0) : 0;
        const controlScore = curr?.control?.scrubs ? curr.control.scrubs.reduce((a, c)=>{
            return a + c;
        }, 0) : 0;
        acc.overall.push(score);
        acc.control.push(controlScore);
        return acc;
    }, {
        overall: [],
        control: []
    });
    // group by variation
    const historyByVariation = dcoHistoryData[dcoHistoryData.length - 1].variations.map((item, i)=>{
        const color = i > colors.length - 1 ? "blue" : colors[i];
        const variationHistory = dcoHistoryData.map((h)=>{
            return h.variations.find((v)=>v.id === item.id);
        }).map((v, _)=>{
            return {
                color: color,
                name: item.name || "Variation " + (i + 1),
                data: v.variationSequences ? v.variationSequences.map((i)=>i / v.sessions) : new Array(101).fill(0.2),
                dwellTime: $abbc57578fc5f1d4$var$groupArray(v.variationDwellTimes ? v.variationDwellTimes.map((i)=>i / v.sessions) : new Array(101).fill(0.2)),
                weighting: v.weighting > 1 ? v.weighting / 100 : v.weighting
            };
        });
        return {
            id: item.id,
            history: variationHistory,
            color: color,
            name: item.name || "Variation " + (i + 1)
        };
    });
    return {
        dcoMetaData: dcoMetaData,
        dcoHistoryData: dcoHistoryData,
        historyByVariation: historyByVariation,
        overallScrubPerformance: overallScrubPerformance
    };
};
function $abbc57578fc5f1d4$var$groupArray(originalArray) {
    const newArray = originalArray.reduce((acc, curr, index)=>{
        const groupIndex = Math.floor(index / 10);
        if (!acc[groupIndex]) acc[groupIndex] = 0;
        acc[groupIndex] += curr;
        return acc;
    }, []);
    return newArray;
}


function $5d282778a8cc30d8$export$2e2bcd8739ae039() {
    $5d282778a8cc30d8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d282778a8cc30d8$export$2e2bcd8739ae039.apply(this, arguments);
}



var $lDSNw = parcelRequire("lDSNw");
function $077ceb3dd560409c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $f95b937350c59d71$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f95b937350c59d71$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $077ceb3dd560409c$export$2e2bcd8739ae039)(function(prop) {
    return $f95b937350c59d71$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $lDSNw = parcelRequire("lDSNw");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $a1766fe273c0baa8$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $a1766fe273c0baa8$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $a1766fe273c0baa8$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($a1766fe273c0baa8$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $a1766fe273c0baa8$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 = "-ms-";
var $6bb8ad4cb76568e5$export$2c0f367103c8d01c = "-moz-";
var $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 = "-webkit-";
var $6bb8ad4cb76568e5$export$a29989082612d0d9 = "comm";
var $6bb8ad4cb76568e5$export$aa3a2e812ca8570d = "rule";
var $6bb8ad4cb76568e5$export$527d108ccf083c2b = "decl";
var $6bb8ad4cb76568e5$export$d3d35020fa5b54f0 = "@page";
var $6bb8ad4cb76568e5$export$500415a86c544f73 = "@media";
var $6bb8ad4cb76568e5$export$a763edbf796b780a = "@import";
var $6bb8ad4cb76568e5$export$2790aeb8b4e5c826 = "@charset";
var $6bb8ad4cb76568e5$export$1cc683e23b84b133 = "@viewport";
var $6bb8ad4cb76568e5$export$9447a5efea57e862 = "@supports";
var $6bb8ad4cb76568e5$export$ef011b4e114b1fba = "@document";
var $6bb8ad4cb76568e5$export$6aad947bda0f3f46 = "@namespace";
var $6bb8ad4cb76568e5$export$b44a8529a35fcb60 = "@keyframes";
var $6bb8ad4cb76568e5$export$2c16de31893252e6 = "@font-face";
var $6bb8ad4cb76568e5$export$3d846dd52e150c6f = "@counter-style";
var $6bb8ad4cb76568e5$export$22314bfbb57653fe = "@font-feature-values";
var $6bb8ad4cb76568e5$export$d773506282b3cfe6 = "@layer";
var $6bb8ad4cb76568e5$export$2335f513bbd82c6d = Math.abs;
var $6bb8ad4cb76568e5$export$6788812c4e6611e6 = String.fromCharCode;
var $6bb8ad4cb76568e5$export$e6e34fd1f2686227 = Object.assign;
function $6bb8ad4cb76568e5$export$d6af199866bfb566(e, r) {
    return $6bb8ad4cb76568e5$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $6bb8ad4cb76568e5$export$a9db5e087081082d(e, 0)) << 2 ^ $6bb8ad4cb76568e5$export$a9db5e087081082d(e, 1)) << 2 ^ $6bb8ad4cb76568e5$export$a9db5e087081082d(e, 2)) << 2 ^ $6bb8ad4cb76568e5$export$a9db5e087081082d(e, 3) : 0;
}
function $6bb8ad4cb76568e5$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $6bb8ad4cb76568e5$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $6bb8ad4cb76568e5$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $6bb8ad4cb76568e5$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $6bb8ad4cb76568e5$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $6bb8ad4cb76568e5$export$36776f635604f274(e) {
    return e.length;
}
function $6bb8ad4cb76568e5$export$f9084667e487ed46(e) {
    return e.length;
}
function $6bb8ad4cb76568e5$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $6bb8ad4cb76568e5$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $6bb8ad4cb76568e5$export$53f1d5ea8de3d7c = 1;
var $6bb8ad4cb76568e5$export$4e0c71f277ca26b3 = 1;
var $6bb8ad4cb76568e5$export$f24224f1c91d8156 = 0;
var $6bb8ad4cb76568e5$export$5880b8b5730aff45 = 0;
var $6bb8ad4cb76568e5$export$c0306caf338ac095 = 0;
var $6bb8ad4cb76568e5$export$30a86d91af8ff6e6 = "";
function $6bb8ad4cb76568e5$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $6bb8ad4cb76568e5$export$53f1d5ea8de3d7c,
        column: $6bb8ad4cb76568e5$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $6bb8ad4cb76568e5$export$784d13d8ee351f07(e, r) {
    return $6bb8ad4cb76568e5$export$e6e34fd1f2686227($6bb8ad4cb76568e5$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $6bb8ad4cb76568e5$export$eba6f6f03b0a92e7() {
    return $6bb8ad4cb76568e5$export$c0306caf338ac095;
}
function $6bb8ad4cb76568e5$export$232faf9add678146() {
    $6bb8ad4cb76568e5$export$c0306caf338ac095 = $6bb8ad4cb76568e5$export$5880b8b5730aff45 > 0 ? $6bb8ad4cb76568e5$export$a9db5e087081082d($6bb8ad4cb76568e5$export$30a86d91af8ff6e6, --$6bb8ad4cb76568e5$export$5880b8b5730aff45) : 0;
    if ($6bb8ad4cb76568e5$export$4e0c71f277ca26b3--, $6bb8ad4cb76568e5$export$c0306caf338ac095 === 10) $6bb8ad4cb76568e5$export$4e0c71f277ca26b3 = 1, $6bb8ad4cb76568e5$export$53f1d5ea8de3d7c--;
    return $6bb8ad4cb76568e5$export$c0306caf338ac095;
}
function $6bb8ad4cb76568e5$export$48cfd1e771a65c4f() {
    $6bb8ad4cb76568e5$export$c0306caf338ac095 = $6bb8ad4cb76568e5$export$5880b8b5730aff45 < $6bb8ad4cb76568e5$export$f24224f1c91d8156 ? $6bb8ad4cb76568e5$export$a9db5e087081082d($6bb8ad4cb76568e5$export$30a86d91af8ff6e6, $6bb8ad4cb76568e5$export$5880b8b5730aff45++) : 0;
    if ($6bb8ad4cb76568e5$export$4e0c71f277ca26b3++, $6bb8ad4cb76568e5$export$c0306caf338ac095 === 10) $6bb8ad4cb76568e5$export$4e0c71f277ca26b3 = 1, $6bb8ad4cb76568e5$export$53f1d5ea8de3d7c++;
    return $6bb8ad4cb76568e5$export$c0306caf338ac095;
}
function $6bb8ad4cb76568e5$export$4d3fb11e950abb9e() {
    return $6bb8ad4cb76568e5$export$a9db5e087081082d($6bb8ad4cb76568e5$export$30a86d91af8ff6e6, $6bb8ad4cb76568e5$export$5880b8b5730aff45);
}
function $6bb8ad4cb76568e5$export$e88cb2efb12ae807() {
    return $6bb8ad4cb76568e5$export$5880b8b5730aff45;
}
function $6bb8ad4cb76568e5$export$58adb3bec8346d0f(e, r) {
    return $6bb8ad4cb76568e5$export$2f35ab04d2335697($6bb8ad4cb76568e5$export$30a86d91af8ff6e6, e, r);
}
function $6bb8ad4cb76568e5$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $6bb8ad4cb76568e5$export$2de70f21292aac9e(e) {
    return $6bb8ad4cb76568e5$export$53f1d5ea8de3d7c = $6bb8ad4cb76568e5$export$4e0c71f277ca26b3 = 1, $6bb8ad4cb76568e5$export$f24224f1c91d8156 = $6bb8ad4cb76568e5$export$36776f635604f274($6bb8ad4cb76568e5$export$30a86d91af8ff6e6 = e), $6bb8ad4cb76568e5$export$5880b8b5730aff45 = 0, [];
}
function $6bb8ad4cb76568e5$export$45918ac1574455b1(e) {
    return $6bb8ad4cb76568e5$export$30a86d91af8ff6e6 = "", e;
}
function $6bb8ad4cb76568e5$export$410ac95b9ec204b8(e) {
    return $6bb8ad4cb76568e5$export$87c2784dc9fc4ab($6bb8ad4cb76568e5$export$58adb3bec8346d0f($6bb8ad4cb76568e5$export$5880b8b5730aff45 - 1, $6bb8ad4cb76568e5$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $6bb8ad4cb76568e5$export$660b2ee2d4fb4eff(e) {
    return $6bb8ad4cb76568e5$export$45918ac1574455b1($6bb8ad4cb76568e5$export$5f8c09e3ae6f64e1($6bb8ad4cb76568e5$export$2de70f21292aac9e(e)));
}
function $6bb8ad4cb76568e5$export$7af1228ff777d175(e) {
    while($6bb8ad4cb76568e5$export$c0306caf338ac095 = $6bb8ad4cb76568e5$export$4d3fb11e950abb9e())if ($6bb8ad4cb76568e5$export$c0306caf338ac095 < 33) $6bb8ad4cb76568e5$export$48cfd1e771a65c4f();
    else break;
    return $6bb8ad4cb76568e5$export$9e1725a4cfeada27(e) > 2 || $6bb8ad4cb76568e5$export$9e1725a4cfeada27($6bb8ad4cb76568e5$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $6bb8ad4cb76568e5$export$5f8c09e3ae6f64e1(e) {
    while($6bb8ad4cb76568e5$export$48cfd1e771a65c4f())switch($6bb8ad4cb76568e5$export$9e1725a4cfeada27($6bb8ad4cb76568e5$export$c0306caf338ac095)){
        case 0:
            $6bb8ad4cb76568e5$export$10d8903dec122b9d($6bb8ad4cb76568e5$export$c2ab62c7bf24634($6bb8ad4cb76568e5$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $6bb8ad4cb76568e5$export$10d8903dec122b9d($6bb8ad4cb76568e5$export$410ac95b9ec204b8($6bb8ad4cb76568e5$export$c0306caf338ac095), e);
            break;
        default:
            $6bb8ad4cb76568e5$export$10d8903dec122b9d($6bb8ad4cb76568e5$export$6788812c4e6611e6($6bb8ad4cb76568e5$export$c0306caf338ac095), e);
    }
    return e;
}
function $6bb8ad4cb76568e5$export$955ba06d119e085e(e, r) {
    while(--r && $6bb8ad4cb76568e5$export$48cfd1e771a65c4f())if ($6bb8ad4cb76568e5$export$c0306caf338ac095 < 48 || $6bb8ad4cb76568e5$export$c0306caf338ac095 > 102 || $6bb8ad4cb76568e5$export$c0306caf338ac095 > 57 && $6bb8ad4cb76568e5$export$c0306caf338ac095 < 65 || $6bb8ad4cb76568e5$export$c0306caf338ac095 > 70 && $6bb8ad4cb76568e5$export$c0306caf338ac095 < 97) break;
    return $6bb8ad4cb76568e5$export$58adb3bec8346d0f(e, $6bb8ad4cb76568e5$export$e88cb2efb12ae807() + (r < 6 && $6bb8ad4cb76568e5$export$4d3fb11e950abb9e() == 32 && $6bb8ad4cb76568e5$export$48cfd1e771a65c4f() == 32));
}
function $6bb8ad4cb76568e5$export$c889f2fcc19dbf12(e) {
    while($6bb8ad4cb76568e5$export$48cfd1e771a65c4f())switch($6bb8ad4cb76568e5$export$c0306caf338ac095){
        case e:
            return $6bb8ad4cb76568e5$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $6bb8ad4cb76568e5$export$c889f2fcc19dbf12($6bb8ad4cb76568e5$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $6bb8ad4cb76568e5$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $6bb8ad4cb76568e5$export$48cfd1e771a65c4f();
            break;
    }
    return $6bb8ad4cb76568e5$export$5880b8b5730aff45;
}
function $6bb8ad4cb76568e5$export$4254d4e2b3745c4c(e, r) {
    while($6bb8ad4cb76568e5$export$48cfd1e771a65c4f())if (e + $6bb8ad4cb76568e5$export$c0306caf338ac095 === 57) break;
    else if (e + $6bb8ad4cb76568e5$export$c0306caf338ac095 === 84 && $6bb8ad4cb76568e5$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $6bb8ad4cb76568e5$export$58adb3bec8346d0f(r, $6bb8ad4cb76568e5$export$5880b8b5730aff45 - 1) + "*" + $6bb8ad4cb76568e5$export$6788812c4e6611e6(e === 47 ? e : $6bb8ad4cb76568e5$export$48cfd1e771a65c4f());
}
function $6bb8ad4cb76568e5$export$c2ab62c7bf24634(e) {
    while(!$6bb8ad4cb76568e5$export$9e1725a4cfeada27($6bb8ad4cb76568e5$export$4d3fb11e950abb9e()))$6bb8ad4cb76568e5$export$48cfd1e771a65c4f();
    return $6bb8ad4cb76568e5$export$58adb3bec8346d0f(e, $6bb8ad4cb76568e5$export$5880b8b5730aff45);
}
function $6bb8ad4cb76568e5$export$ef7acd7185315e22(e) {
    return $6bb8ad4cb76568e5$export$45918ac1574455b1($6bb8ad4cb76568e5$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $6bb8ad4cb76568e5$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $6bb8ad4cb76568e5$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $6bb8ad4cb76568e5$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $6bb8ad4cb76568e5$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($6bb8ad4cb76568e5$export$f8e21b1e77979a08(j += $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed($6bb8ad4cb76568e5$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $6bb8ad4cb76568e5$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $6bb8ad4cb76568e5$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $6bb8ad4cb76568e5$export$955ba06d119e085e($6bb8ad4cb76568e5$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($6bb8ad4cb76568e5$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $6bb8ad4cb76568e5$export$10d8903dec122b9d($6bb8ad4cb76568e5$export$4a34f930e789283c($6bb8ad4cb76568e5$export$4254d4e2b3745c4c($6bb8ad4cb76568e5$export$48cfd1e771a65c4f(), $6bb8ad4cb76568e5$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $6bb8ad4cb76568e5$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $6bb8ad4cb76568e5$export$36776f635604f274(j) - l) $6bb8ad4cb76568e5$export$10d8903dec122b9d(p > 32 ? $6bb8ad4cb76568e5$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $6bb8ad4cb76568e5$export$f8483753829ec8f3($6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $6bb8ad4cb76568e5$export$10d8903dec122b9d(y = $6bb8ad4cb76568e5$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $6bb8ad4cb76568e5$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $6bb8ad4cb76568e5$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $6bb8ad4cb76568e5$export$98e6a39c04603d36(e, y, y, n && $6bb8ad4cb76568e5$export$10d8903dec122b9d($6bb8ad4cb76568e5$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $6bb8ad4cb76568e5$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $6bb8ad4cb76568e5$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $6bb8ad4cb76568e5$export$232faf9add678146() == 125) continue;
            }
            switch(j += $6bb8ad4cb76568e5$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($6bb8ad4cb76568e5$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($6bb8ad4cb76568e5$export$4d3fb11e950abb9e() === 45) j += $6bb8ad4cb76568e5$export$410ac95b9ec204b8($6bb8ad4cb76568e5$export$48cfd1e771a65c4f());
                    v = $6bb8ad4cb76568e5$export$4d3fb11e950abb9e(), o = l = $6bb8ad4cb76568e5$export$36776f635604f274(g = j += $6bb8ad4cb76568e5$export$c2ab62c7bf24634($6bb8ad4cb76568e5$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $6bb8ad4cb76568e5$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $6bb8ad4cb76568e5$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $6bb8ad4cb76568e5$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $6bb8ad4cb76568e5$export$2f35ab04d2335697(e, v + 1, v = $6bb8ad4cb76568e5$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $6bb8ad4cb76568e5$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $6bb8ad4cb76568e5$export$35059013cd4a06db(e, r, a, s === 0 ? $6bb8ad4cb76568e5$export$aa3a2e812ca8570d : i, f, o, l);
}
function $6bb8ad4cb76568e5$export$4a34f930e789283c(e, r, a) {
    return $6bb8ad4cb76568e5$export$35059013cd4a06db(e, r, a, $6bb8ad4cb76568e5$export$a29989082612d0d9, $6bb8ad4cb76568e5$export$6788812c4e6611e6($6bb8ad4cb76568e5$export$eba6f6f03b0a92e7()), $6bb8ad4cb76568e5$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $6bb8ad4cb76568e5$export$f8483753829ec8f3(e, r, a, n) {
    return $6bb8ad4cb76568e5$export$35059013cd4a06db(e, r, a, $6bb8ad4cb76568e5$export$527d108ccf083c2b, $6bb8ad4cb76568e5$export$2f35ab04d2335697(e, 0, n), $6bb8ad4cb76568e5$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $6bb8ad4cb76568e5$export$82e9f45cca5ba907(n, c, s) {
    switch($6bb8ad4cb76568e5$export$d6af199866bfb566(n, c)){
        case 5103:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $6bb8ad4cb76568e5$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$2c0f367103c8d01c + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($6bb8ad4cb76568e5$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "box-$1$2" + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "flex-item-" + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$6bb8ad4cb76568e5$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "grid-row-" + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "flex-line-pack" + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "box-" + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "-grow", "") + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed($6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed($6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed($6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "box-pack:$3" + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$6bb8ad4cb76568e5$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "grid-column-align" + $6bb8ad4cb76568e5$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $6bb8ad4cb76568e5$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$6bb8ad4cb76568e5$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$6bb8ad4cb76568e5$export$f8e21b1e77979a08(s, "span") ? $6bb8ad4cb76568e5$export$4659b591c19bdf3d(s, /\d+/) : +$6bb8ad4cb76568e5$export$4659b591c19bdf3d(s, /\d+/) - +$6bb8ad4cb76568e5$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $6bb8ad4cb76568e5$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed($6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($6bb8ad4cb76568e5$export$36776f635604f274(n) - 1 - c > 6) switch($6bb8ad4cb76568e5$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($6bb8ad4cb76568e5$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $6bb8ad4cb76568e5$export$2c0f367103c8d01c + ($6bb8ad4cb76568e5$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$6bb8ad4cb76568e5$export$f8e21b1e77979a08(n, "stretch") ? $6bb8ad4cb76568e5$export$82e9f45cca5ba907($6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($6bb8ad4cb76568e5$export$a9db5e087081082d(n, c + 6) === 121) return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, ":", ":" + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($6bb8ad4cb76568e5$export$a9db5e087081082d(n, $6bb8ad4cb76568e5$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + ($6bb8ad4cb76568e5$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, ":", ":" + $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $6bb8ad4cb76568e5$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $6bb8ad4cb76568e5$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $6bb8ad4cb76568e5$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $6bb8ad4cb76568e5$export$a763edbf796b780a:
        case $6bb8ad4cb76568e5$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $6bb8ad4cb76568e5$export$a29989082612d0d9:
            return "";
        case $6bb8ad4cb76568e5$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $6bb8ad4cb76568e5$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $6bb8ad4cb76568e5$export$36776f635604f274(a = $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $6bb8ad4cb76568e5$export$5a7767152ae0305f(e) {
    var r = $6bb8ad4cb76568e5$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $6bb8ad4cb76568e5$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $6bb8ad4cb76568e5$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $6bb8ad4cb76568e5$export$527d108ccf083c2b:
                n.return = $6bb8ad4cb76568e5$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $6bb8ad4cb76568e5$export$b44a8529a35fcb60:
                return $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb([
                    $6bb8ad4cb76568e5$export$784d13d8ee351f07(n, {
                        value: $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $6bb8ad4cb76568e5$export$aa3a2e812ca8570d:
                if (n.length) return $6bb8ad4cb76568e5$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($6bb8ad4cb76568e5$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb([
                                $6bb8ad4cb76568e5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $6bb8ad4cb76568e5$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb([
                                $6bb8ad4cb76568e5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $6bb8ad4cb76568e5$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $6bb8ad4cb76568e5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $6bb8ad4cb76568e5$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $6bb8ad4cb76568e5$export$784d13d8ee351f07(n, {
                                    props: [
                                        $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $6bb8ad4cb76568e5$export$76a88f7de6507443(e) {
    switch(e.type){
        case $6bb8ad4cb76568e5$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $6bb8ad4cb76568e5$export$1be1fc439b849fdf($6bb8ad4cb76568e5$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($6bb8ad4cb76568e5$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $6bb8ad4cb76568e5$export$2f35ab04d2335697(r, 1, $6bb8ad4cb76568e5$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $6bb8ad4cb76568e5$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $6bb8ad4cb76568e5$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $6bb8ad4cb76568e5$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $a707cb94818dcb07$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};



var $6a2c18332cff1b13$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $6bb8ad4cb76568e5$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $6bb8ad4cb76568e5$export$9e1725a4cfeada27)(character)) break;
        (0, $6bb8ad4cb76568e5$export$48cfd1e771a65c4f)();
    }
    return (0, $6bb8ad4cb76568e5$export$58adb3bec8346d0f)(begin, (0, $6bb8ad4cb76568e5$export$5880b8b5730aff45));
};
var $6a2c18332cff1b13$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $6bb8ad4cb76568e5$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $6bb8ad4cb76568e5$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $6a2c18332cff1b13$var$identifierWithPointTracking((0, $6bb8ad4cb76568e5$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $6bb8ad4cb76568e5$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $6bb8ad4cb76568e5$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $6bb8ad4cb76568e5$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $6bb8ad4cb76568e5$export$48cfd1e771a65c4f)());
    return parsed;
};
var $6a2c18332cff1b13$var$getRules = function getRules(value, points) {
    return (0, $6bb8ad4cb76568e5$export$45918ac1574455b1)($6a2c18332cff1b13$var$toRules((0, $6bb8ad4cb76568e5$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $6a2c18332cff1b13$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $6a2c18332cff1b13$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$6a2c18332cff1b13$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $6a2c18332cff1b13$var$fixedElements.set(element, true);
    var points = [];
    var rules = $6a2c18332cff1b13$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $6a2c18332cff1b13$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $6a2c18332cff1b13$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $6a2c18332cff1b13$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($6a2c18332cff1b13$var$ignoreFlag) > -1;
};
var $6a2c18332cff1b13$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($6a2c18332cff1b13$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $6a2c18332cff1b13$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $6a2c18332cff1b13$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$6a2c18332cff1b13$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $6a2c18332cff1b13$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $6a2c18332cff1b13$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$6a2c18332cff1b13$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $6a2c18332cff1b13$var$nullifyElement(element);
    } else if ($6a2c18332cff1b13$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $6a2c18332cff1b13$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $6a2c18332cff1b13$var$prefix(value, length) {
    switch((0, $6bb8ad4cb76568e5$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$2c0f367103c8d01c) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + "flex-item-" + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "box-" + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)((0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)((0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)((0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $6bb8ad4cb76568e5$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $6bb8ad4cb76568e5$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $6bb8ad4cb76568e5$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $6bb8ad4cb76568e5$export$2c0f367103c8d01c) + ((0, $6bb8ad4cb76568e5$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $6bb8ad4cb76568e5$export$f8e21b1e77979a08)(value, "stretch") ? $6a2c18332cff1b13$var$prefix((0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $6bb8ad4cb76568e5$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $6bb8ad4cb76568e5$export$a9db5e087081082d)(value, (0, $6bb8ad4cb76568e5$export$36776f635604f274)(value) - 3 - (~(0, $6bb8ad4cb76568e5$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + ((0, $6bb8ad4cb76568e5$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $6bb8ad4cb76568e5$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + value + (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $6a2c18332cff1b13$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $6bb8ad4cb76568e5$export$527d108ccf083c2b:
                element["return"] = $6a2c18332cff1b13$var$prefix(element.value, element.length);
                break;
            case 0, $6bb8ad4cb76568e5$export$b44a8529a35fcb60:
                return (0, $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb)([
                    (0, $6bb8ad4cb76568e5$export$784d13d8ee351f07)(element, {
                        value: (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $6bb8ad4cb76568e5$export$aa3a2e812ca8570d:
                if (element.length) return (0, $6bb8ad4cb76568e5$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $6bb8ad4cb76568e5$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb)([
                                (0, $6bb8ad4cb76568e5$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $6bb8ad4cb76568e5$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb)([
                                (0, $6bb8ad4cb76568e5$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $6bb8ad4cb76568e5$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $6bb8ad4cb76568e5$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $6bb8ad4cb76568e5$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $6bb8ad4cb76568e5$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $6bb8ad4cb76568e5$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $6bb8ad4cb76568e5$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $6a2c18332cff1b13$var$defaultStylisPlugins = [
    $6a2c18332cff1b13$var$prefixer
];
var $6a2c18332cff1b13$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $6a2c18332cff1b13$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $6a2c18332cff1b13$var$compat,
        $6a2c18332cff1b13$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $6bb8ad4cb76568e5$export$fac44ee5b035f737),
        (0, $6bb8ad4cb76568e5$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $6bb8ad4cb76568e5$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $6bb8ad4cb76568e5$export$dfdc1655ccc5b9cb)((0, $6bb8ad4cb76568e5$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $a1766fe273c0baa8$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $6e0bdff1309e9d3f$exports = {};
"use strict";
var $23dc7c94650826f3$exports = {};
"use strict";

$23dc7c94650826f3$exports = (parcelRequire("c1WUa"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $6e0bdff1309e9d3f$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $6e0bdff1309e9d3f$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $6e0bdff1309e9d3f$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $6e0bdff1309e9d3f$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $6e0bdff1309e9d3f$var$TYPE_STATICS = {};
$6e0bdff1309e9d3f$var$TYPE_STATICS[$23dc7c94650826f3$exports.ForwardRef] = $6e0bdff1309e9d3f$var$FORWARD_REF_STATICS;
$6e0bdff1309e9d3f$var$TYPE_STATICS[$23dc7c94650826f3$exports.Memo] = $6e0bdff1309e9d3f$var$MEMO_STATICS;
function $6e0bdff1309e9d3f$var$getStatics(component) {
    // React v16.11 and below
    if ($23dc7c94650826f3$exports.isMemo(component)) return $6e0bdff1309e9d3f$var$MEMO_STATICS;
     // React v16.12 and above
    return $6e0bdff1309e9d3f$var$TYPE_STATICS[component["$$typeof"]] || $6e0bdff1309e9d3f$var$REACT_STATICS;
}
var $6e0bdff1309e9d3f$var$defineProperty = Object.defineProperty;
var $6e0bdff1309e9d3f$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $6e0bdff1309e9d3f$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6e0bdff1309e9d3f$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6e0bdff1309e9d3f$var$getPrototypeOf = Object.getPrototypeOf;
var $6e0bdff1309e9d3f$var$objectPrototype = Object.prototype;
function $6e0bdff1309e9d3f$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($6e0bdff1309e9d3f$var$objectPrototype) {
            var inheritedComponent = $6e0bdff1309e9d3f$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $6e0bdff1309e9d3f$var$objectPrototype) $6e0bdff1309e9d3f$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $6e0bdff1309e9d3f$var$getOwnPropertyNames(sourceComponent);
        if ($6e0bdff1309e9d3f$var$getOwnPropertySymbols) keys = keys.concat($6e0bdff1309e9d3f$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $6e0bdff1309e9d3f$var$getStatics(targetComponent);
        var sourceStatics = $6e0bdff1309e9d3f$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$6e0bdff1309e9d3f$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $6e0bdff1309e9d3f$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $6e0bdff1309e9d3f$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$6e0bdff1309e9d3f$exports = $6e0bdff1309e9d3f$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $a54c8cbc17908e3b$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6e0bdff1309e9d3f$exports)))(targetComponent, sourceComponent);
};


var $b2b8c910fcf836d8$var$isBrowser = true;
function $b2b8c910fcf836d8$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $b2b8c910fcf836d8$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $b2b8c910fcf836d8$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $b2b8c910fcf836d8$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $b2b8c910fcf836d8$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a8cd445224c2a33b$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $7a17f072e57a273d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $974bc3faefbcac40$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $974bc3faefbcac40$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $974bc3faefbcac40$var$hyphenateRegex = /[A-Z]|^ms/g;
var $974bc3faefbcac40$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $974bc3faefbcac40$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $974bc3faefbcac40$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $974bc3faefbcac40$var$processStyleName = /* #__PURE__ */ (0, $077ceb3dd560409c$export$2e2bcd8739ae039)(function(styleName) {
    return $974bc3faefbcac40$var$isCustomProperty(styleName) ? styleName : styleName.replace($974bc3faefbcac40$var$hyphenateRegex, "-$&").toLowerCase();
});
var $974bc3faefbcac40$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($974bc3faefbcac40$var$animationRegex, function(match, p1, p2) {
                $974bc3faefbcac40$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $974bc3faefbcac40$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7a17f072e57a273d$export$2e2bcd8739ae039)[key] !== 1 && !$974bc3faefbcac40$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $974bc3faefbcac40$var$contentValuePattern, $974bc3faefbcac40$var$contentValues, $974bc3faefbcac40$var$oldProcessStyleValue, $974bc3faefbcac40$var$msPattern, $974bc3faefbcac40$var$hyphenPattern, $974bc3faefbcac40$var$hyphenatedCache;
var $974bc3faefbcac40$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $974bc3faefbcac40$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $974bc3faefbcac40$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $974bc3faefbcac40$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $974bc3faefbcac40$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $974bc3faefbcac40$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $974bc3faefbcac40$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $974bc3faefbcac40$var$cursor;
                var result = interpolation(mergedProps);
                $974bc3faefbcac40$var$cursor = previousCursor;
                return $974bc3faefbcac40$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $974bc3faefbcac40$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $974bc3faefbcac40$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($974bc3faefbcac40$var$isProcessableValue(value)) string += $974bc3faefbcac40$var$processStyleName(_key) + ":" + $974bc3faefbcac40$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($974bc3faefbcac40$var$isProcessableValue(value[_i])) string += $974bc3faefbcac40$var$processStyleName(_key) + ":" + $974bc3faefbcac40$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $974bc3faefbcac40$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $974bc3faefbcac40$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $974bc3faefbcac40$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $974bc3faefbcac40$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $974bc3faefbcac40$var$cursor;
var $974bc3faefbcac40$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $974bc3faefbcac40$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $974bc3faefbcac40$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $974bc3faefbcac40$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $974bc3faefbcac40$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $974bc3faefbcac40$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $a8cd445224c2a33b$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $974bc3faefbcac40$var$cursor
    };
};



var $lDSNw = parcelRequire("lDSNw");
var $6221fb477a4c7703$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6221fb477a4c7703$var$useInsertionEffect = $lDSNw.useInsertionEffect ? $lDSNw.useInsertionEffect : false;
var $6221fb477a4c7703$export$db21c7ffa21794e7 = $6221fb477a4c7703$var$useInsertionEffect || $6221fb477a4c7703$var$syncFallback;
var $6221fb477a4c7703$export$811a713a7276cb9d = $6221fb477a4c7703$var$useInsertionEffect || $lDSNw.useLayoutEffect;


var $fee187d89b24554e$export$23f2a1d2818174ef = true;
var $fee187d89b24554e$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $fee187d89b24554e$var$EmotionCacheContext = /* #__PURE__ */ $lDSNw.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $6a2c18332cff1b13$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $fee187d89b24554e$export$e7094788287c5e9b = $fee187d89b24554e$var$EmotionCacheContext.Provider;
var $fee187d89b24554e$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $lDSNw.useContext)($fee187d89b24554e$var$EmotionCacheContext);
};
var $fee187d89b24554e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $lDSNw.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $lDSNw.useContext)($fee187d89b24554e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$fee187d89b24554e$export$23f2a1d2818174ef) $fee187d89b24554e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $lDSNw.useContext)($fee187d89b24554e$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6a2c18332cff1b13$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $lDSNw.createElement($fee187d89b24554e$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $fee187d89b24554e$export$971d5caa766a69d7 = /* #__PURE__ */ $lDSNw.createContext({});
var $fee187d89b24554e$export$3b14a55fb2447963 = function useTheme() {
    return $lDSNw.useContext($fee187d89b24554e$export$971d5caa766a69d7);
};
var $fee187d89b24554e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $fee187d89b24554e$var$createCacheWithTheme = /* #__PURE__ */ (0, $a707cb94818dcb07$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $a707cb94818dcb07$export$2e2bcd8739ae039)(function(theme) {
        return $fee187d89b24554e$var$getTheme(outerTheme, theme);
    });
});
var $fee187d89b24554e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $lDSNw.useContext($fee187d89b24554e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $fee187d89b24554e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $lDSNw.createElement($fee187d89b24554e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $fee187d89b24554e$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $lDSNw.useContext($fee187d89b24554e$export$971d5caa766a69d7);
        return /*#__PURE__*/ $lDSNw.createElement(Component, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $lDSNw.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $a54c8cbc17908e3b$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $fee187d89b24554e$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $fee187d89b24554e$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $fee187d89b24554e$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $fee187d89b24554e$var$getLastPart(match[1]);
    return undefined;
};
var $fee187d89b24554e$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $fee187d89b24554e$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $fee187d89b24554e$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $fee187d89b24554e$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($fee187d89b24554e$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $fee187d89b24554e$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $fee187d89b24554e$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $fee187d89b24554e$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $fee187d89b24554e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($fee187d89b24554e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$fee187d89b24554e$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $fee187d89b24554e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $b2b8c910fcf836d8$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $6221fb477a4c7703$export$db21c7ffa21794e7)(function() {
        return (0, $b2b8c910fcf836d8$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $fee187d89b24554e$var$Emotion = /* #__PURE__ */ $fee187d89b24554e$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$fee187d89b24554e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $b2b8c910fcf836d8$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $974bc3faefbcac40$export$6321afa313b251b5)(registeredStyles, undefined, $lDSNw.useContext($fee187d89b24554e$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($fee187d89b24554e$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $fee187d89b24554e$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $lDSNw.createElement($lDSNw.Fragment, null, /*#__PURE__*/ $lDSNw.createElement($fee187d89b24554e$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $lDSNw.createElement(WrappedComponent, newProps));
});
var $fee187d89b24554e$export$a9c23c6ac3fc3eca = $fee187d89b24554e$var$Emotion;



var $lDSNw = parcelRequire("lDSNw");




var $ced6a93d5751b1f0$exports = {};
function $ced6a93d5751b1f0$var$_extends() {
    $ced6a93d5751b1f0$exports = $ced6a93d5751b1f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $ced6a93d5751b1f0$exports.__esModule = true, $ced6a93d5751b1f0$exports["default"] = $ced6a93d5751b1f0$exports;
    return $ced6a93d5751b1f0$var$_extends.apply(this, arguments);
}
$ced6a93d5751b1f0$exports = $ced6a93d5751b1f0$var$_extends, $ced6a93d5751b1f0$exports.__esModule = true, $ced6a93d5751b1f0$exports["default"] = $ced6a93d5751b1f0$exports;





var $8c971e9544ccda33$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $8c971e9544ccda33$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $fee187d89b24554e$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $lDSNw.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $fee187d89b24554e$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $fee187d89b24554e$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $lDSNw.createElement.apply(null, createElementArgArray);
};
var $8c971e9544ccda33$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $8c971e9544ccda33$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $fee187d89b24554e$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $974bc3faefbcac40$export$6321afa313b251b5)([
        styles
    ], undefined, $lDSNw.useContext((0, $fee187d89b24554e$export$971d5caa766a69d7)));
    if (!(0, $fee187d89b24554e$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $lDSNw.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $lDSNw.useRef();
    (0, $6221fb477a4c7703$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $6221fb477a4c7703$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $b2b8c910fcf836d8$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $8c971e9544ccda33$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $974bc3faefbcac40$export$6321afa313b251b5)(args);
}
var $8c971e9544ccda33$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $8c971e9544ccda33$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $8c971e9544ccda33$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $8c971e9544ccda33$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $b2b8c910fcf836d8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $8c971e9544ccda33$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $6221fb477a4c7703$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $b2b8c910fcf836d8$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $8c971e9544ccda33$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $fee187d89b24554e$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $974bc3faefbcac40$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $b2b8c910fcf836d8$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $8c971e9544ccda33$var$merge(cache.registered, css, $8c971e9544ccda33$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $lDSNw.useContext((0, $fee187d89b24554e$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $lDSNw.createElement($lDSNw.Fragment, null, /*#__PURE__*/ $lDSNw.createElement($8c971e9544ccda33$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $8c971e9544ccda33$var$isBrowser, $8c971e9544ccda33$var$isTestEnv, $8c971e9544ccda33$var$globalContext, $8c971e9544ccda33$var$globalKey;





var $39930abee900df6c$var$testOmitPropsOnStringTag = (0, $f95b937350c59d71$export$2e2bcd8739ae039);
var $39930abee900df6c$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $39930abee900df6c$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $39930abee900df6c$var$testOmitPropsOnStringTag : $39930abee900df6c$var$testOmitPropsOnComponent;
};
var $39930abee900df6c$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $39930abee900df6c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $39930abee900df6c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $b2b8c910fcf836d8$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $6221fb477a4c7703$export$db21c7ffa21794e7)(function() {
        return (0, $b2b8c910fcf836d8$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $39930abee900df6c$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $39930abee900df6c$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $39930abee900df6c$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $fee187d89b24554e$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $lDSNw.useContext((0, $fee187d89b24554e$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $b2b8c910fcf836d8$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $974bc3faefbcac40$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $39930abee900df6c$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $lDSNw.createElement($lDSNw.Fragment, null, /*#__PURE__*/ $lDSNw.createElement($39930abee900df6c$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $lDSNw.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $39930abee900df6c$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("lDSNw");





var $2809f842de743c7e$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $2809f842de743c7e$export$2e2bcd8739ae039 = (0, $39930abee900df6c$export$2e2bcd8739ae039).bind();
$2809f842de743c7e$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $2809f842de743c7e$export$2e2bcd8739ae039[tagName] = $2809f842de743c7e$export$2e2bcd8739ae039(tagName);
});



var $lDSNw = parcelRequire("lDSNw");

var $ef4Zh = parcelRequire("ef4Zh");


var $lDSNw = parcelRequire("lDSNw");
const $4c28a9656c805907$var$FalafelRoot = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  --fill: var(--colors-primary);

  display: flex;
  justify-content: center;
  align-items: flex-start;
  > div {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    div {
      position: absolute;
      top: 33px;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background: var(--fill);
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
      &:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
      }
      &:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
      }
      &:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
      }
      &:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
      }
    }
  }

  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
`;
const $4c28a9656c805907$export$ba01ffa8d63a745d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($4c28a9656c805907$var$FalafelRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", null)));





var $lDSNw = parcelRequire("lDSNw");
const $f3ede31544397a74$export$3d6ac70d37c7788e = (start = "140%", end = "0%")=>`
    0% {
      opacity: 1;  
      transform: translateY(${start});
    }

    100% {
      opacity: 1;
      transform: translateY(${end});
    }
  `;
const $f3ede31544397a74$export$f90f2ca1f95197f2 = (start = "0%", end = "200%")=>`
    0% {
      opacity: 1;  
      transform: translateY(${start});
    }

    100% {
      opacity: 0;
      transform: translateY(${end});
    }
  `;




var $lDSNw = parcelRequire("lDSNw");
var $fa9a3398194cfbbd$exports = {};

$fa9a3398194cfbbd$exports = new URL((parcelRequire("5V6iE")).resolve("agHju"), import.meta.url).toString();


const $b8a1238394860ec0$var$IconButtonRoot = (0, $2809f842de743c7e$export$2e2bcd8739ae039).button`
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--space-1);
  &:hover {
    opacity: 0.5;
  }
`;
const $b8a1238394860ec0$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $lDSNw.forwardRef)(({ iconPath: iconPath, ...restProps }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($b8a1238394860ec0$var$IconButtonRoot, {
        ...restProps,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("img", {
        src: iconPath = (0, (/*@__PURE__*/$parcel$interopDefault($fa9a3398194cfbbd$exports)))
    }));
});




var $lDSNw = parcelRequire("lDSNw");
const $99ceae00e3750c32$var$StyledText = (0, $2809f842de743c7e$export$2e2bcd8739ae039).p`
  font-style: normal;
  font-size: var(--text-${({ kind: kind })=>kind}-fontSize);
  line-height: var(--text-${({ kind: kind })=>kind}-lineHeight);
  letter-spacing: var(--text-${({ kind: kind })=>kind}-letterSpacing);
  color: var(--colors-text);
`;
const $99ceae00e3750c32$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $lDSNw.forwardRef)(({ type: type, as: as = "p", children: children, ...restProps }, ref = null)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($99ceae00e3750c32$var$StyledText, {
        as: as,
        ref: ref,
        kind: type,
        ...restProps
    }, children);
});


const $86896944c76a0602$var$bounceUpFrames = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)`${(0, $f3ede31544397a74$export$3d6ac70d37c7788e)()}`;
const $86896944c76a0602$var$bounceDownFrames = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)`${(0, $f3ede31544397a74$export$f90f2ca1f95197f2)()}`;
const $86896944c76a0602$var$SnackBarRoot = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: fixed;
  bottom: var(--space-4);
  left: 50%;
  margin-left: max(-400px, -35vw);

  width: 70vw;
  max-width: 800px;
  padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
  gap: var(--space-3);
  z-index: 101;

  animation: ${$86896944c76a0602$var$bounceUpFrames} 0.8s cubic-bezier(0.68, -0.6, 0.32, 1.6) forwards;
  animation-delay: 0.7s;
  opacity: 0;
  transform: translateY(140%);

  background-color: ${({ backgroundColor: backgroundColor })=>backgroundColor || "var(--colors-trafficlight-2)"};
  font-family: Roboto;

  &.bye {
    animation: ${$86896944c76a0602$var$bounceDownFrames} 0.5s cubic-bezier(0.68, -0.6, 0.32, 1.6)
      forwards;
  }
`;
const $86896944c76a0602$var$SnackBarButton = (0, $2809f842de743c7e$export$2e2bcd8739ae039).button`
  background: none;
  border: none;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
`;
const $86896944c76a0602$export$b7063aba2b72bcec = ({ title: title, description: description, status: status, delayToClose: delayToClose })=>{
    const [show, setShow] = (0, $lDSNw.useState)(true);
    const [animateOut, setAnimateOut] = (0, $lDSNw.useState)(false);
    const backgroundColor = {
        success: "var(--snackBar-success)",
        error: "var(--snackBar-error)",
        info: "var(--snackBar--info)",
        warning: "var(--snackBar-warning)"
    }[status];
    const close = ()=>{
        setAnimateOut(true);
        setTimeout(()=>{
            setShow(false);
            setAnimateOut(false);
        }, 700);
    };
    if (delayToClose) setTimeout(()=>{
        close();
    }, delayToClose);
    return show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($86896944c76a0602$var$SnackBarRoot, {
        className: animateOut && "bye",
        backgroundColor: backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "body01",
        as: "span"
    }, title)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "body01"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $b8a1238394860ec0$export$c25acd513dcc8062), {
        onClick: close
    }));
};




var $lDSNw = parcelRequire("lDSNw");
const $6d34caa3f6c24444$var$scales = {
    s: 0.5,
    xs: 0.1,
    m: 1
};
const $6d34caa3f6c24444$var$LoadingCat = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: relative;
  width: 300px;
  height: 300px;
  margin: 48px auto;

  --outline: var(--spinnyCat-outline);
  --fill1: var(--spinnyCat-fills-0);
  --fill2: var(--spinnyCat-fills-1);

  transform: scale(${({ size: size })=>$6d34caa3f6c24444$var$scales[size] ?? 1});
  transform-origin: top left;

  & * {
    box-sizing: content-box; 
  }

  @keyframes mask-animation {
    0% {
      transform: rotate(45deg);
    }
    100% {
      transform: rotate(-675deg);
    }
  }

  @keyframes mask-animation-sub-left {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(90deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  @keyframes mask-animation-sub-right {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(-90deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  @keyframes head-animation {
    0% {
      transform: rotate(70deg);
    }
    100% {
      transform: rotate(-650deg);
    }
  }

  @keyframes foot-animation {
    0% {
      transform: rotate(25deg);
    }
    100% {
      transform: rotate(-695deg);
    }
  }

  @keyframes eye-light-animation {
    0% {
      opacity: 0;
      height: 6px;
    }
    50% {
      opacity: 0.75;
      height: 50px;
    }
    80% {
      opacity: 1;
      height: 6px;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes mouth-animation {
    0% {
      height: 0px;
    }
    50% {
      height: 10px;
    }
    100% {
      height: 0px;
    }
  }
`;
const $6d34caa3f6c24444$var$Body = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: absolute;
  width: 290px;
  height: 290px;
  background-color: var(--fill1);
  border-radius: 50%;
  border: 5px solid var(--outline);

  &:before {
    content: "";
    position: absolute;
    top: calc(50% - 188px / 2 - 5px);
    left: calc(50% - 188px / 2 - 5px);
    width: 188px;
    height: 188px;
    border-radius: 50%;
    border: 5px solid var(--outline);
    background-color: var(--fill2);
  }
  &:after {
    content: "";
    position: absolute;
    top: calc(50% - 222px / 2 - 22px);
    left: calc(50% - 222px / 2 - 22px);
    height: 222px;
    width: 222px;
    border: 22px solid var(--fill2);
    border-radius: 50%;
  }
`;
const $6d34caa3f6c24444$var$AnimationMask = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  transform: rotate(45deg);
  animation: mask-animation 2s 0s infinite;

  &:before {
    animation: mask-animation-sub-right 2s 0s infinite;
  }
  &:after {
    animation: mask-animation-sub-left 2s 0s infinite;
  }

  position: absolute;
  height: 50%;
  width: 50%;
  background-color: var(--fill2);
  transform-origin: right bottom;

  &:before {
    content: "";
    position: absolute;
    left: 100%;
    height: 100%;
    width: 100%;
    background-color: var(--fill2);
    transform-origin: left bottom;
  }
  &:after {
    content: "";
    position: absolute;
    top: 100%;
    height: 100%;
    width: 100%;
    background-color: var(--fill2);
    transform-origin: right top;
  }
`;
const $6d34caa3f6c24444$var$Head = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  transform: rotate(70deg);
  animation: head-animation 2s 0s infinite;
  animation-timing-function: cubic-bezier(0.2, 0, 0.09, 1);

  position: absolute;
  right: 0;
  top: 0;
  height: 50%;
  width: 50%;
  background-color: var(--fill2);
  transform-origin: left bottom;
`;
const $6d34caa3f6c24444$var$Face = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 0px;
  right: 0;
  width: 50px;
  height: 40px;
  background-color: var(--fill1);
  border: 5px solid var(--outline);
  border-bottom: 0;

  &:before {
    content: "";
    position: absolute;
    left: calc(50% - 10px);
    bottom: -15px;
    height: 22px;
    width: 22px;
    background-color: var(--fill2);
    border-radius: 50%;
  }
`;
const $6d34caa3f6c24444$var$Ear = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 39px;
  right: 0;
  width: 10px;
  height: 12px;
  background-color: var(--fill1);
  border: 5px solid var(--outline);
  border-bottom: 0;
  border-radius: 20px 0 0 0;

  &:before {
    content: "";
    position: absolute;
    top: -5px;
    left: -45px;
    width: 10px;
    height: 12px;
    background-color: var(--fill1);
    border: 5px solid var(--outline);
    border-bottom: 0;
    border-radius: 0 20px 0 0;
  }
`;
const $6d34caa3f6c24444$var$Hand = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: -32px;
  right: 0;
  width: 10px;
  height: 30px;
  background-color: var(--fill1);
  border: 5px solid var(--outline);
  border-top: 0;
  border-radius: 0 0 10px 10px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -45px;
    width: 10px;
    height: 30px;
    background-color: var(--fill1);
    border: 5px solid var(--outline);
    border-top: 0;
    border-radius: 0 0 10px 10px;
  }
`;
const $6d34caa3f6c24444$var$eyecss = `
  position: absolute;
  top: 116px;
  right: 12px;
  width: 6px;
  height: 6px;
  background-color: var(--outline);
  border-radius: 3px;

  &:before {
    content: "";
    position: absolute;
    top: 0px;
    right: 30px;
    width: 6px;
    height: 6px;
    background-color: var(--outline);
    border-radius: 3px;
  }
`;
const $6d34caa3f6c24444$var$Eye = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  ${$6d34caa3f6c24444$var$eyecss}
`;
const $6d34caa3f6c24444$var$EyeLight = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  ${$6d34caa3f6c24444$var$eyecss}
  background-color: white;
  box-shadow: 0 0 10px white;
  opacity: 0;
  animation: eye-light-animation 2s 0s infinite;

  &:before {
    background-color: white;
    box-shadow: 0 0 10px white;
    opacity: 0;
    animation: eye-light-animation 2s 0s infinite;
  }
`;
const $6d34caa3f6c24444$var$Mouth = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 16px;
  right: 27px;
  width: 2px;
  height: 0px;
  background-color: var(--fill1);
  border: 2px solid var(--outline);
  border-top: 0;
  border-radius: 0 0 10px 10px;
  animation: mouth-animation 2s 0s infinite;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: -4px;
    width: 2px;
    height: 2px;
    background-color: var(--fill1);
    border: 2px solid var(--outline);
    border-top: 0;
    border-radius: 0 0 10px 10px;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0px;
    width: 2px;
    height: 2px;
    background-color: var(--fill1);
    border: 2px solid var(--outline);
    border-top: 0;
    border-radius: 0 0 10px 10px;
  }
`;
const $6d34caa3f6c24444$var$bearcss = `
  position: absolute;
  bottom: 18px;
  right: -4px;
  width: 12px;
  height: 3px;
  background-color: var(--outline);

  &:before {
    content: "";
    position: absolute;
    top: -5px;
    right: 0;
    width: 12px;
    height: 3px;
    background-color: var(--outline);
    transform: rotate(-10deg);
  }
  &:after {
    content: "";
    position: absolute;
    top: 5px;
    right: 0;
    width: 12px;
    height: 3px;
    background-color: var(--outline);
    transform: rotate(10deg);
  }
`;
const $6d34caa3f6c24444$var$BeardLeft = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  ${$6d34caa3f6c24444$var$bearcss}
`;
const $6d34caa3f6c24444$var$BeardRight = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  ${$6d34caa3f6c24444$var$bearcss}
  right: 52px;

  &:before {
    transform: rotate(10deg);
  }
  &:after {
    transform: rotate(-10deg);
  }
`;
const $6d34caa3f6c24444$var$Foot = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  transform: rotate(25deg);
  animation: foot-animation 2s 0s infinite;
  animation-timing-function: cubic-bezier(0.2, 0, 0.45, 1);

  position: absolute;
  left: 0;
  bottom: 0;
  height: 50%;
  width: 50%;
  background-color: var(--fill2);
  transform-origin: right top;
`;
const $6d34caa3f6c24444$var$Belly = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 14px;
  height: 46px;
  background-color: var(--fill1);
  border: 5px solid var(--outline);
  border-left: 0;
  border-right: 0;
`;
const $6d34caa3f6c24444$var$Leg = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 0px;
  right: 14px;
  width: 30px;
  height: 10px;
  background-color: var(--fill1);
  border: 5px solid var(--outline);
  border-right: 0;
  border-radius: 10px 0 0 10px;

  &:before {
    content: "";
    position: absolute;
    top: -41px;
    right: 0;
    width: 30px;
    height: 10px;
    background-color: var(--fill1);
    border: 5px solid var(--outline);
    border-right: 0;
    border-radius: 10px 0 0 10px;
  }
`;
const $6d34caa3f6c24444$var$Tail = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
position: absolute;
      bottom: 16px;
      right: 14px;
      width: 50px;
      height: 14px;
      background-color: var(--$orange);
      border: 5px solid var(--outline);
      border-right: 0;
      border-radius: 14px 0 0 14px;

      &:after {
        content: "";
        position: absolute;
        right: -28px;
        bottom: -4px;
        height: 22px;
        width: 22px;
        background-color: var(--fill2);
        border-radius: 50%;
      }
      &:before {
        content: "";
        position: absolute;
        bottom: -7px;
        right: 0;
        width: 10px;
        height: 18px;
        background-color: var(--fill1);
        border: 5px solid var(--outline);
        border-right: 0;
        border-radius: 12px 0 0 12px;
      }
    }
`;
const $6d34caa3f6c24444$export$e854a2165401836f = ({ size: size = "m" })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$LoadingCat, {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Body, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$AnimationMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Head, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Face, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Ear, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Hand, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Eye, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$EyeLight, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Mouth, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$BeardLeft, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$BeardRight, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Foot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Belly, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Leg, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($6d34caa3f6c24444$var$Tail, null)));




var $lDSNw = parcelRequire("lDSNw");
const $7153b660cd53c35b$var$ButtonTemplate = `
  display: flex;
  align-items: center;
  gap: var(--space-2);
  white-space: nowrap;

  cursor: pointer;

  border-radius: var(--radii-0);
  line-height: var(--lineHeights-3);
  letter-spacing: var(--letterSpacings-0);
  transition: var(--transitions-0);
`;
const $7153b660cd53c35b$var$PrimaryButton = (0, $2809f842de743c7e$export$2e2bcd8739ae039).button`
  ${$7153b660cd53c35b$var$ButtonTemplate}
  color: var(--buttons-primary-text);
  font-size: ${({ fontSize: fontSize })=>fontSize};
  padding: ${({ padding: padding })=>padding};
  background: var(--buttons-primary-background);
  border: var(--borderWidths-0) var(--buttons-primary-border)
    var(--borderStyles-0);
  font-weight: var(--fontWeights-1);

  &:hover {
    background: var(--buttons-primary-hover-background);
    border-color: var(--buttons-primary-hover-border);
  }

  &:disabled {
    cursor: not-allowed;
    background: var(--buttons-primary-disabled-background);
    border-color: var(--buttons-primary-disabled-border);
  }
`;
const $7153b660cd53c35b$var$SecondaryButton = (0, $2809f842de743c7e$export$2e2bcd8739ae039).button`
  ${$7153b660cd53c35b$var$ButtonTemplate}
  color: var(--buttons-secondary-text);
  font-size: ${({ fontSize: fontSize })=>fontSize};
  padding: ${({ padding: padding })=>padding};
  background: var(--buttons-secondary-background);
  border: var(--borderWidths-0) var(--buttons-secondary-border)
    var(--borderStyles-0);
  font-weight: var(--fontWeights-1);

  &:hover {
    color: var(--buttons-secondary-hover-text);
    border-color: var(--buttons-secondary-hover-border);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--buttons-secondary-disabled-text);
    border-color: var(--buttons-secondary-disabled-border);
  }
`;
const $7153b660cd53c35b$var$TertiaryButton = (0, $2809f842de743c7e$export$2e2bcd8739ae039).button`
  ${$7153b660cd53c35b$var$ButtonTemplate}
  color: var(--buttons-tertiary-text);
  font-size: ${({ fontSize: fontSize })=>fontSize};
  padding: ${({ padding: padding })=>padding};
  background: var(--buttons-tertiary-background);
  border: var(--buttons-tertiary-border);
  font-weight: var(--fontWeights-2);

  &:hover {
    color: var(--buttons-tertiary-hover-text);
    border-color: var(--buttons-tertiary-hover-border);
    background-color: var(--buttons-tertiary-hover-background);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--buttons-tertiary-disabled-text);
    border-color: var(--buttons-tertiary-disabled-border);
  }
`;
const $7153b660cd53c35b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $lDSNw.forwardRef)(({ size: size = "sm", variant: variant = "primary", leftIcon: leftIcon, rightIcon: rightIcon, children: children, ...restProps }, ref)=>{
    const btnSize = {
        md: {
            font: "var(--fontSizes-2)",
            padding: "var(--space-2) var(--space-4) ;"
        },
        sm: {
            font: "var(--fontSizes-1)",
            padding: "var(--space-1) var(--space-3);"
        }
    }[size];
    const ButtonVariant = {
        primary: $7153b660cd53c35b$var$PrimaryButton,
        secondary: $7153b660cd53c35b$var$SecondaryButton,
        tertiary: $7153b660cd53c35b$var$TertiaryButton
    }[variant];
    const kind = {
        md: "baseline",
        sm: "body01"
    }[variant];
    const lineHeight = {
        md: "var(--lineHeights-2)",
        sm: "var(--lineHeights-2)"
    }[variant];
    const letterSpacings = {
        md: "var(--letterSpacings-2)",
        sm: "var(--letterSpacings-2)"
    }[variant];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(ButtonVariant, {
        ref: ref,
        kind: kind,
        fontSize: btnSize.font,
        padding: btnSize.padding,
        ...restProps
    }, leftIcon, " ", children, " ", rightIcon);
});



const $73d7766f123d34ce$export$69b1032f2ecdf404 = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  display: flex;
  gap: var(--space-3);
  align-items: baseline;
`;





var $lDSNw = parcelRequire("lDSNw");
var $b440e23ddb10485e$exports = {};

$b440e23ddb10485e$exports = new URL((parcelRequire("5V6iE")).resolve("7NB1g"), import.meta.url).toString();


var $7928b630e48fa845$exports = {};

$7928b630e48fa845$exports = new URL((parcelRequire("5V6iE")).resolve("9FFG3"), import.meta.url).toString();


var $db456491aa47a8c5$exports = {};

$db456491aa47a8c5$exports = new URL((parcelRequire("5V6iE")).resolve("iGa0R"), import.meta.url).toString();


var $a5381fa8adce63cb$exports = {};

$a5381fa8adce63cb$exports = new URL((parcelRequire("5V6iE")).resolve("ftsUn"), import.meta.url).toString();


var $c44d9c2a14a8b391$exports = {};
$c44d9c2a14a8b391$exports = $c44d9c2a14a8b391$var$flatten;
$c44d9c2a14a8b391$var$flatten.flatten = $c44d9c2a14a8b391$var$flatten;
$c44d9c2a14a8b391$var$flatten.unflatten = $c44d9c2a14a8b391$var$unflatten;
function $c44d9c2a14a8b391$var$isBuffer(obj) {
    return obj && obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function $c44d9c2a14a8b391$var$keyIdentity(key) {
    return key;
}
function $c44d9c2a14a8b391$var$flatten(target, opts) {
    opts = opts || {};
    const delimiter = opts.delimiter || ".";
    const maxDepth = opts.maxDepth;
    const transformKey = opts.transformKey || $c44d9c2a14a8b391$var$keyIdentity;
    const output = {};
    function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function(key) {
            const value = object[key];
            const isarray = opts.safe && Array.isArray(value);
            const type = Object.prototype.toString.call(value);
            const isbuffer = $c44d9c2a14a8b391$var$isBuffer(value);
            const isobject = type === "[object Object]" || type === "[object Array]";
            const newKey = prev ? prev + delimiter + transformKey(key) : transformKey(key);
            if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) return step(value, newKey, currentDepth + 1);
            output[newKey] = value;
        });
    }
    step(target);
    return output;
}
function $c44d9c2a14a8b391$var$unflatten(target, opts) {
    opts = opts || {};
    const delimiter = opts.delimiter || ".";
    const overwrite = opts.overwrite || false;
    const transformKey = opts.transformKey || $c44d9c2a14a8b391$var$keyIdentity;
    const result = {};
    const isbuffer = $c44d9c2a14a8b391$var$isBuffer(target);
    if (isbuffer || Object.prototype.toString.call(target) !== "[object Object]") return target;
    // safely ensure that the key is
    // an integer.
    function getkey(key) {
        const parsedKey = Number(key);
        return isNaN(parsedKey) || key.indexOf(".") !== -1 || opts.object ? key : parsedKey;
    }
    function addKeys(keyPrefix, recipient, target) {
        return Object.keys(target).reduce(function(result, key) {
            result[keyPrefix + delimiter + key] = target[key];
            return result;
        }, recipient);
    }
    function isEmpty(val) {
        const type = Object.prototype.toString.call(val);
        const isArray = type === "[object Array]";
        const isObject = type === "[object Object]";
        if (!val) return true;
        else if (isArray) return !val.length;
        else if (isObject) return !Object.keys(val).length;
    }
    target = Object.keys(target).reduce(function(result, key) {
        const type = Object.prototype.toString.call(target[key]);
        const isObject = type === "[object Object]" || type === "[object Array]";
        if (!isObject || isEmpty(target[key])) {
            result[key] = target[key];
            return result;
        } else return addKeys(key, result, $c44d9c2a14a8b391$var$flatten(target[key], opts));
    }, {});
    Object.keys(target).forEach(function(key) {
        const split = key.split(delimiter).map(transformKey);
        let key1 = getkey(split.shift());
        let key2 = getkey(split[0]);
        let recipient = result;
        while(key2 !== undefined){
            if (key1 === "__proto__") return;
            const type = Object.prototype.toString.call(recipient[key1]);
            const isobject = type === "[object Object]" || type === "[object Array]";
            // do not write over falsey, non-undefined values if overwrite is false
            if (!overwrite && !isobject && typeof recipient[key1] !== "undefined") return;
            if (overwrite && !isobject || !overwrite && recipient[key1] == null) recipient[key1] = typeof key2 === "number" && !opts.object ? [] : {};
            recipient = recipient[key1];
            if (split.length > 0) {
                key1 = getkey(split.shift());
                key2 = getkey(split[0]);
            }
        }
        // unflatten again for 'messy objects'
        recipient[key1] = $c44d9c2a14a8b391$var$unflatten(target[key], opts);
    });
    return result;
}


const $3b601628bb3b2ed7$export$99aaa11fb71d263 = {
    borderStyles: [
        "solid"
    ],
    borderWidths: [
        "2px"
    ],
    space: [
        "0",
        "4px",
        "8px",
        "16px",
        "32px",
        "64px"
    ],
    fonts: [
        "TTNorms,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'"
    ],
    radii: [
        "4px"
    ],
    fontSizes: [
        "12px",
        "13.5px",
        "16.5px",
        "32.5px",
        "38px"
    ],
    transitions: [
        "all 150ms ease-out"
    ],
    fontWeights: [
        400,
        500,
        600
    ],
    lineHeights: [
        1.05,
        1.23,
        1.45,
        1.78,
        2
    ],
    letterSpacings: [
        "-0.002em",
        "-0.004em",
        "-0.008em"
    ],
    shadows: {
        low: "0px 0px 4px #00000033",
        med: "0px 0px 8px #000000AA",
        high: "0px 0px 16px #000000AA",
        soft: `0 1px 1px rgb(0 0 0 / 5%), 0 2px 2px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 5%), 0 8px 8px rgb(0 0 0 / 5%), 0 16px 16px rgb(0 0 0 / 5%), 0 32px 32px rgb(0 0 0 / 5%)`
    },
    colors: {
        text: "#202020",
        primary: "#00CE7C",
        secondary: "#4AC1E0",
        muted: "#DBDBD9",
        brandGradient: "linear-gradient(5.09deg, #00CE7C -4.18%, #4AC1E0 32.84%, var(--colors-primary) 85.79%)",
        neutral: [
            "#202020",
            "#6A6868",
            "#A4A2A2",
            "#DBDBD9",
            "#F0F0EE",
            "#FFFFFF"
        ],
        chart: [
            "#00CE7C",
            "#4AC1E0",
            "#00CE7C",
            "#4AC1E0",
            "#00CE7C",
            "#4AC1E0"
        ],
        trafficlight: [
            "#F47777",
            "#88E196",
            "var(--colors-chart-0)"
        ],
        modes: {
            dark: {
                text: "#FFFFFF",
                neutral: [
                    "#3e474a",
                    "#252B2C"
                ]
            }
        }
    },
    text: {
        heading1: {
            fontWeight: "var(--fontWeights-2)",
            lineHeight: "var(--lineHeights-0)",
            letterSpacing: "var(--letterSpacings-2)",
            fontSize: "var(--fontSizes-4)"
        },
        heading2: {
            fontWeight: "var(--fontWeights-2)",
            lineHeight: "var(--lineHeights-1)",
            letterSpacing: "var(--letterSpacings-2)",
            fontSize: "var(--fontSizes-3)"
        },
        baseline: {
            fontWeight: "var(--fontWeights-0)",
            lineHeight: "var(--lineHeights-2)",
            letterSpacing: "var(--letterSpacings-1)",
            fontSize: "var(--fontSizes-2)"
        },
        body01: {
            fontWeight: "var(--fontWeights-0)",
            lineHeight: "var(--lineHeights-3)",
            letterSpacing: "var(--letterSpacings-0)",
            fontSize: "var(--fontSizes-1)"
        },
        body02: {
            fontWeight: "var(--fontWeights-0)",
            lineHeight: "var(--lineHeights-4)",
            letterSpacing: "var(--letterSpacings-0)",
            fontSize: "var(--fontSizes-0)"
        }
    },
    //We only define colours here for our components
    spinnyCat: {
        outline: "var(--colors-chart-2)",
        fills: [
            "var(--colors-chart-3)",
            "var(--colors-neutral-5)"
        ]
    },
    buttons: {
        primary: {
            background: "var(--colors-primary)",
            text: "var(--colors-neutral-5)",
            border: "var(--colors-primary)",
            hover: {
                background: "var(--colors-secondary)",
                border: "var(--colors-secondary)"
            },
            disabled: {
                background: "var(--colors-muted)",
                border: "var(--colors-muted)"
            }
        },
        secondary: {
            background: "transparent",
            text: "var(--colors-primary)",
            border: "var(--colors-primary)",
            hover: {
                text: "var(--colors-secondary)",
                border: "var(--colors-secondary)"
            },
            disabled: {
                text: "var(--colors-muted)",
                border: "var(--colors-muted)"
            }
        },
        tertiary: {
            background: "transparent",
            text: "var(--colors-neutral-0)",
            border: "var(--borderWidths-0) transparent var(--borderStyles-0)",
            hover: {
                text: "var(--colors-neutral-0)",
                border: "var(--colors-neutral-4)",
                background: "var(--colors-neutral-4)"
            },
            disabled: {
                text: "var(--colors-neutral-2)",
                border: "transparent"
            }
        }
    },
    snackBar: {
        success: "var(--colors-trafficlight-1)",
        error: "var(--colors-trafficlight-0)",
        info: "var(--colors-neutral-4)",
        warning: "var(--colors-trafficlight-2)"
    }
};
const $3b601628bb3b2ed7$var$theme = $3b601628bb3b2ed7$export$99aaa11fb71d263;
const $3b601628bb3b2ed7$export$fd62969fb0b7081c = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($c44d9c2a14a8b391$exports)))($3b601628bb3b2ed7$var$theme, {
    delimiter: "-"
})).reduce((acc, [key, value])=>{
    acc += `--${key}: ${value};
      `;
    return acc;
}, "");


const $461c96fff363e55b$export$cceeabf822b64fc0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8c971e9544ccda33$export$98f03c5d19621d70), {
        styles: (0, $8c971e9544ccda33$export$dbf350e5966cf602)`
        @font-face {
          font-family: "TTNorms";
          src: local("TTNorms"), url(${(0, (/*@__PURE__*/$parcel$interopDefault($a5381fa8adce63cb$exports)))}) format("opentype");
        }

        @font-face {
          font-family: "TTNorms";
          font-weight: 500;
          src: local("TTNorms"), url(${(0, (/*@__PURE__*/$parcel$interopDefault($db456491aa47a8c5$exports)))}) format("opentype");
        }

        @font-face {
          font-family: "TTNorms";
          font-weight: 600;
          src: local("TTNorms"), url(${(0, (/*@__PURE__*/$parcel$interopDefault($7928b630e48fa845$exports)))}) format("truetype");
        }

        @font-face {
          font-family: "TTNorms";
          font-weight: 700;
          src: local("TTNorms"), url(${(0, (/*@__PURE__*/$parcel$interopDefault($b440e23ddb10485e$exports)))}) format("opentype");
        }

        :root {
          ${(0, $3b601628bb3b2ed7$export$fd62969fb0b7081c)}
        }

        body {
          color: var(--colors-text);
          background: var(--colors-neutral-5);
          font-weight: var(--fontWeights-0);
        }

        b {
          font-weight: var(--fontWeights-1);
        }
      `
    });
};




var $lDSNw = parcelRequire("lDSNw");
const $38015ab38cd1ffdd$var$StyledText = (0, $2809f842de743c7e$export$2e2bcd8739ae039).h1`
  font-style: normal;
  font-size: var(--text-${({ kind: kind })=>kind}-fontSize);
  font-weight: var(--text-${({ kind: kind })=>kind}-fontWeight);
  line-height: var(--text-${({ kind: kind })=>kind}-lineHeight);
  letter-spacing: var(--text-${({ kind: kind })=>kind}-letterSpacing);
  color: var(--colors-text);

  // Link compoents inside a heading should have a thicker border
  & a span{
    border-width: 4px;
  }
`;
const $38015ab38cd1ffdd$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $lDSNw.forwardRef)(({ type: type = "heading2", children: children }, ref = null)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($38015ab38cd1ffdd$var$StyledText, {
        as: type === "heading1" ? "h1" : "h2",
        ref: ref,
        kind: type
    }, children);
});





var $lDSNw = parcelRequire("lDSNw");
const $21f7d76a059ae835$var$StyledLink = (0, $2809f842de743c7e$export$2e2bcd8739ae039).a`
  text-decoration: none;
  padding: 0;
  margin: 0;
  ${({ maxWidth: maxWidth })=>maxWidth && $21f7d76a059ae835$var$maxWidthOverrides(maxWidth)} 
  ${({ variant: variant })=>variant === "emphasis" && $21f7d76a059ae835$var$emphVarientOverrides}
`;
const $21f7d76a059ae835$var$Span = (0, $2809f842de743c7e$export$2e2bcd8739ae039).span`
  padding-bottom: 2px;
  border-bottom: 2px solid var(--colors-neutral-3);
  transition: color 0.3s ease-in-out, border-color 0.5s ease-in-out;

  &:hover {
    border-color: var(--colors-primary);
    cursor: pointer;
  }

  &:active {
    padding-bottom: 3px;
    color: var(--colors-neutral-1);
    cursor: pointer;
    transition: padding-bottom 0.4s;
  }
`;
// Variant overrides
const $21f7d76a059ae835$var$emphVarientOverrides = `
  & span {
    border-bottom: 2px solid var(--colors-primary);
    &:hover {
      color: var(--colors-primary);    
      border-color:#ff458b; //will fix
    }
  }
`;
const $21f7d76a059ae835$var$maxWidthOverrides = (maxWidth)=>`
  display: inline-flex;
  & span{
    max-width: ${maxWidth};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const $21f7d76a059ae835$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $lDSNw.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($21f7d76a059ae835$var$StyledLink, {
        as: "a",
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($21f7d76a059ae835$var$Span, null, children));
});




var $lDSNw = parcelRequire("lDSNw");
const $aa3c569a62b6b581$var$StyledHR = (0, $2809f842de743c7e$export$2e2bcd8739ae039).hr`
  width: 100%;
  border: none;
  border-top: 1px solid var(--colors-neutral-4);
  margin: var(--space-${({ margin: margin })=>margin}) 0;
`;
const $aa3c569a62b6b581$export$c65504044f62f430 = ({ margin: margin = "3" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($aa3c569a62b6b581$var$StyledHR, {
        margin: margin
    });
};











const $93a99fe5a3d73d0c$export$f5b8910cec6cf069 = (0, $2809f842de743c7e$export$2e2bcd8739ae039).input`
  color: var(--colors-neutral-2);
  border: solid 1px var(--colors-neutral-3);
  border-radius: var(--radii-0);
  font-family: monospace;
  padding: var(--space-2) var(--space-3);
`;










const $9b28324802ef1b89$var$LibraryContainer = (0, $2809f842de743c7e$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding: var(--space-4);
  gap: var(--space-3);
`;
const $9b28324802ef1b89$var$lorem = `TT Norms Pro is a geometric sans serif for a wide range of applications—a
trouble-free workhorse. The third version of the TT Norms Pro bestseller.
In it, we tried to bring the font to the new, unprecedented level of
functionality, visual quality and technical perfection. 1234567890`;
const $9b28324802ef1b89$export$3fcb9806c74df6 = ()=>{
    const [successSnackBar, setSuccessSnackBar] = (0, $lDSNw.useState)(false);
    const [errorSnackBar, setErrorSnackBar] = (0, $lDSNw.useState)(false);
    const [infoSnackBar, setInfoSnackBar] = (0, $lDSNw.useState)(false);
    const [warningSnackBar, setWarningSnackBar] = (0, $lDSNw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($9b28324802ef1b89$var$LibraryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $461c96fff363e55b$export$cceeabf822b64fc0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), {
        type: "heading1"
    }, "Component Lib"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa3c569a62b6b581$export$c65504044f62f430), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "Primary Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $73d7766f123d34ce$export$69b1032f2ecdf404), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        size: "sm"
    }, "My Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        size: "md"
    }, "My Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        size: "md",
        disabled: true
    }, "My Button")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "Secondary Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $73d7766f123d34ce$export$69b1032f2ecdf404), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        variant: "secondary",
        size: "sm"
    }, "My Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        variant: "secondary",
        size: "md"
    }, "My Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        variant: "secondary",
        size: "md",
        disabled: true
    }, "My Button")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "Tertiary Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $73d7766f123d34ce$export$69b1032f2ecdf404), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        variant: "tertiary",
        size: "sm"
    }, "My Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        variant: "tertiary",
        size: "md"
    }, "My Button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        variant: "tertiary",
        size: "md",
        disabled: true
    }, "My Button")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa3c569a62b6b581$export$c65504044f62f430), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "Links"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "This is a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $21f7d76a059ae835$export$a6c7ac8248d6e38a), null, " link component "), " inside of a heading. It should be used inside of a Text or a Heading component."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "body01",
        as: "p"
    }, "This is a ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $21f7d76a059ae835$export$a6c7ac8248d6e38a), null, " link component"), " inside of a text box."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa3c569a62b6b581$export$c65504044f62f430), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "Typography"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), {
        type: "heading1"
    }, "TT Norms Pro is a geometric sans serif for a wide range of applications."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "TT Norms Pro is a geometric sans serif for a wide range of applications."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa3c569a62b6b581$export$c65504044f62f430), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "baseline"
    }, $9b28324802ef1b89$var$lorem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "baseline",
        as: "b"
    }, $9b28324802ef1b89$var$lorem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "body01"
    }, $9b28324802ef1b89$var$lorem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "body01",
        as: "b"
    }, $9b28324802ef1b89$var$lorem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "body02"
    }, " ", $9b28324802ef1b89$var$lorem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
        type: "body02",
        as: "b"
    }, $9b28324802ef1b89$var$lorem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa3c569a62b6b581$export$c65504044f62f430), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "SnackBars \uD83C\uDF6B"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $73d7766f123d34ce$export$69b1032f2ecdf404), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        onClick: ()=>{
            setSuccessSnackBar(true);
        }
    }, "Open Success snackbar"), successSnackBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ef4Zh))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $86896944c76a0602$export$b7063aba2b72bcec), {
        title: "It worked, the thing happened, great job.",
        status: "success",
        delayToClose: 6000
    }), document.getElementById("alerts")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        onClick: ()=>{
            setErrorSnackBar(true);
        }
    }, "Open Error snackbar"), errorSnackBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ef4Zh))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $86896944c76a0602$export$b7063aba2b72bcec), {
        title: "Something went wrong, you should probably fix it.",
        status: "error"
    }), document.getElementById("alerts")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        onClick: ()=>{
            setInfoSnackBar(true);
        }
    }, "Open Info snackbar"), infoSnackBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ef4Zh))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $86896944c76a0602$export$b7063aba2b72bcec), {
        title: "This is some info, you should probably read it.",
        status: "info",
        delayToClose: 6000
    }), document.getElementById("alerts")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
        onClick: ()=>{
            setWarningSnackBar(true);
        }
    }, "Open Warning snackbar"), warningSnackBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ef4Zh))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $86896944c76a0602$export$b7063aba2b72bcec), {
        title: "This is a warning, you should probably read it.",
        status: "warning",
        delayToClose: 3000
    }), document.getElementById("alerts"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa3c569a62b6b581$export$c65504044f62f430), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "SpinnyCat"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $6d34caa3f6c24444$export$e854a2165401836f), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "SpinnyKitten - (SpinnyCat size s)"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $6d34caa3f6c24444$export$e854a2165401836f), {
        size: "s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $38015ab38cd1ffdd$export$a8a3e93435678ff9), null, "FalafelLoader"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $4c28a9656c805907$export$ba01ffa8d63a745d), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa3c569a62b6b581$export$c65504044f62f430), null));
};


parcelRequire("lDSNw");
function $aa0c8fc10b49674f$export$2e2bcd8739ae039(o, p) {
    $aa0c8fc10b49674f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aa0c8fc10b49674f$export$2e2bcd8739ae039(o, p);
}


function $8429ec9982803cf6$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $aa0c8fc10b49674f$export$2e2bcd8739ae039)(subClass, superClass);
}



var $lDSNw = parcelRequire("lDSNw");

var $houiY = parcelRequire("houiY");

function $269975269a046703$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $269975269a046703$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $269975269a046703$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $269975269a046703$var$isAbsolute(to);
    var isFromAbs = from && $269975269a046703$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $269975269a046703$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $269975269a046703$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $269975269a046703$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $269975269a046703$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$269975269a046703$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $269975269a046703$export$2e2bcd8739ae039 = $269975269a046703$var$resolvePathname;


function $88e38681f378321a$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $88e38681f378321a$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $88e38681f378321a$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $88e38681f378321a$var$valueOf(a);
        var bValue = $88e38681f378321a$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $88e38681f378321a$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $88e38681f378321a$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $88e38681f378321a$export$2e2bcd8739ae039 = $88e38681f378321a$var$valueEqual;



var $faa21f25e6a568af$var$isProduction = true;
var $faa21f25e6a568af$var$prefix = "Invariant failed";
function $faa21f25e6a568af$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($faa21f25e6a568af$var$isProduction) throw new Error($faa21f25e6a568af$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($faa21f25e6a568af$var$prefix, ": ").concat(provided) : $faa21f25e6a568af$var$prefix;
    throw new Error(value);
}


function $a59c7fc8689634e5$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $a59c7fc8689634e5$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $a59c7fc8689634e5$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $a59c7fc8689634e5$var$stripBasename(path, prefix) {
    return $a59c7fc8689634e5$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $a59c7fc8689634e5$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $a59c7fc8689634e5$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $a59c7fc8689634e5$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $a59c7fc8689634e5$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $a59c7fc8689634e5$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $269975269a046703$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $a59c7fc8689634e5$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $88e38681f378321a$export$2e2bcd8739ae039)(a.state, b.state);
}
function $a59c7fc8689634e5$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $a59c7fc8689634e5$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $a59c7fc8689634e5$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $a59c7fc8689634e5$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $a59c7fc8689634e5$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $a59c7fc8689634e5$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $a59c7fc8689634e5$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $a59c7fc8689634e5$var$PopStateEvent = "popstate";
var $a59c7fc8689634e5$var$HashChangeEvent = "hashchange";
function $a59c7fc8689634e5$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $a59c7fc8689634e5$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$a59c7fc8689634e5$var$canUseDOM && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $a59c7fc8689634e5$var$supportsHistory();
    var needsHashChangeListener = !$a59c7fc8689634e5$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $a59c7fc8689634e5$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $a59c7fc8689634e5$var$stripTrailingSlash($a59c7fc8689634e5$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $a59c7fc8689634e5$var$stripBasename(path, basename);
        return $a59c7fc8689634e5$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $a59c7fc8689634e5$var$createTransitionManager();
    function setState(nextState) {
        (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($a59c7fc8689634e5$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($a59c7fc8689634e5$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($a59c7fc8689634e5$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $a59c7fc8689634e5$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $a59c7fc8689634e5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $a59c7fc8689634e5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($a59c7fc8689634e5$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($a59c7fc8689634e5$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($a59c7fc8689634e5$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($a59c7fc8689634e5$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $a59c7fc8689634e5$var$HashChangeEvent$1 = "hashchange";
var $a59c7fc8689634e5$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $a59c7fc8689634e5$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $a59c7fc8689634e5$var$stripLeadingSlash,
        decodePath: $a59c7fc8689634e5$var$addLeadingSlash
    },
    slash: {
        encodePath: $a59c7fc8689634e5$var$addLeadingSlash,
        decodePath: $a59c7fc8689634e5$var$addLeadingSlash
    }
};
function $a59c7fc8689634e5$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $a59c7fc8689634e5$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $a59c7fc8689634e5$var$pushHashPath(path) {
    window.location.hash = path;
}
function $a59c7fc8689634e5$var$replaceHashPath(path) {
    window.location.replace($a59c7fc8689634e5$var$stripHash(window.location.href) + "#" + path);
}
function $a59c7fc8689634e5$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$a59c7fc8689634e5$var$canUseDOM && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $a59c7fc8689634e5$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $a59c7fc8689634e5$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $a59c7fc8689634e5$var$stripTrailingSlash($a59c7fc8689634e5$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $a59c7fc8689634e5$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($a59c7fc8689634e5$var$getHashPath());
        if (basename) path = $a59c7fc8689634e5$var$stripBasename(path, basename);
        return $a59c7fc8689634e5$export$90c043f1c57770b8(path);
    }
    var transitionManager = $a59c7fc8689634e5$var$createTransitionManager();
    function setState(nextState) {
        (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $a59c7fc8689634e5$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $a59c7fc8689634e5$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $a59c7fc8689634e5$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($a59c7fc8689634e5$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($a59c7fc8689634e5$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $a59c7fc8689634e5$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $a59c7fc8689634e5$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $a59c7fc8689634e5$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $a59c7fc8689634e5$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $a59c7fc8689634e5$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $a59c7fc8689634e5$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $a59c7fc8689634e5$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $a59c7fc8689634e5$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $a59c7fc8689634e5$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($a59c7fc8689634e5$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $a59c7fc8689634e5$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $a59c7fc8689634e5$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $a59c7fc8689634e5$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $a59c7fc8689634e5$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($a59c7fc8689634e5$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($a59c7fc8689634e5$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($a59c7fc8689634e5$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $a59c7fc8689634e5$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $a59c7fc8689634e5$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $a59c7fc8689634e5$var$createTransitionManager();
    function setState(nextState) {
        (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $a59c7fc8689634e5$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $a59c7fc8689634e5$export$90c043f1c57770b8(entry, undefined, createKey()) : $a59c7fc8689634e5$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $a59c7fc8689634e5$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $a59c7fc8689634e5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $a59c7fc8689634e5$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $a59c7fc8689634e5$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $323f0b8b420580a7$exports = {};
var $43056b47c58ad11d$exports = {};
$43056b47c58ad11d$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $323f0b8b420580a7$exports = $323f0b8b420580a7$var$pathToRegexp;
$323f0b8b420580a7$exports.parse = $323f0b8b420580a7$var$parse;
$323f0b8b420580a7$exports.compile = $323f0b8b420580a7$var$compile;
$323f0b8b420580a7$exports.tokensToFunction = $323f0b8b420580a7$var$tokensToFunction;
$323f0b8b420580a7$exports.tokensToRegExp = $323f0b8b420580a7$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $323f0b8b420580a7$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $323f0b8b420580a7$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $323f0b8b420580a7$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $323f0b8b420580a7$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $323f0b8b420580a7$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $323f0b8b420580a7$var$compile(str, options) {
    return $323f0b8b420580a7$var$tokensToFunction($323f0b8b420580a7$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $323f0b8b420580a7$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $323f0b8b420580a7$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $323f0b8b420580a7$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $323f0b8b420580a7$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $323f0b8b420580a7$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($43056b47c58ad11d$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $323f0b8b420580a7$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $323f0b8b420580a7$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $323f0b8b420580a7$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $323f0b8b420580a7$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $323f0b8b420580a7$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $323f0b8b420580a7$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $323f0b8b420580a7$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $323f0b8b420580a7$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($323f0b8b420580a7$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $323f0b8b420580a7$var$flags(options));
    return $323f0b8b420580a7$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $323f0b8b420580a7$var$stringToRegexp(path, keys, options) {
    return $323f0b8b420580a7$var$tokensToRegExp($323f0b8b420580a7$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $323f0b8b420580a7$var$tokensToRegExp(tokens, keys, options) {
    if (!$43056b47c58ad11d$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $323f0b8b420580a7$var$escapeString(token);
        else {
            var prefix = $323f0b8b420580a7$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $323f0b8b420580a7$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $323f0b8b420580a7$var$attachKeys(new RegExp("^" + route, $323f0b8b420580a7$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $323f0b8b420580a7$var$pathToRegexp(path, keys, options) {
    if (!$43056b47c58ad11d$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $323f0b8b420580a7$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($43056b47c58ad11d$exports(path)) return $323f0b8b420580a7$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $323f0b8b420580a7$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}



function $e357090fb59eb644$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $5058ffe240ffde31$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $5058ffe240ffde31$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $5058ffe240ffde31$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $5058ffe240ffde31$var$commonjsGlobal[key] = ($5058ffe240ffde31$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $5058ffe240ffde31$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $5058ffe240ffde31$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $5058ffe240ffde31$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $5058ffe240ffde31$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $5058ffe240ffde31$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $5058ffe240ffde31$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($5058ffe240ffde31$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $5058ffe240ffde31$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5058ffe240ffde31$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5058ffe240ffde31$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $5058ffe240ffde31$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $5058ffe240ffde31$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createContext || $5058ffe240ffde31$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $5058ffe240ffde31$var$createNamedContext = function createNamedContext(name) {
    var context = $5058ffe240ffde31$var$createContext();
    context.displayName = name;
    return context;
};
var $5058ffe240ffde31$export$c213558b66925821 = /*#__PURE__*/ $5058ffe240ffde31$var$createNamedContext("Router-History");
var $5058ffe240ffde31$export$63baa8ccbe60bb07 = /*#__PURE__*/ $5058ffe240ffde31$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $5058ffe240ffde31$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $5058ffe240ffde31$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $a59c7fc8689634e5$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
var $5058ffe240ffde31$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $5058ffe240ffde31$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $5058ffe240ffde31$var$messageType;
var $5058ffe240ffde31$var$cache = {};
var $5058ffe240ffde31$var$cacheLimit = 10000;
var $5058ffe240ffde31$var$cacheCount = 0;
function $5058ffe240ffde31$var$compilePath(path) {
    if ($5058ffe240ffde31$var$cache[path]) return $5058ffe240ffde31$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($323f0b8b420580a7$exports))).compile(path);
    if ($5058ffe240ffde31$var$cacheCount < $5058ffe240ffde31$var$cacheLimit) {
        $5058ffe240ffde31$var$cache[path] = generator;
        $5058ffe240ffde31$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $5058ffe240ffde31$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $5058ffe240ffde31$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $5058ffe240ffde31$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $a59c7fc8689634e5$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $5058ffe240ffde31$export$82476f982757e71e(to, computedMatch.params) : (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, to, {
            pathname: $5058ffe240ffde31$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $a59c7fc8689634e5$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $a59c7fc8689634e5$export$c3e8bb440bd55b18)(prevLocation, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $5058ffe240ffde31$var$cache$1 = {};
var $5058ffe240ffde31$var$cacheLimit$1 = 10000;
var $5058ffe240ffde31$var$cacheCount$1 = 0;
function $5058ffe240ffde31$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $5058ffe240ffde31$var$cache$1[cacheKey] || ($5058ffe240ffde31$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($323f0b8b420580a7$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($5058ffe240ffde31$var$cacheCount$1 < $5058ffe240ffde31$var$cacheLimit$1) {
        pathCache[path] = result;
        $5058ffe240ffde31$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $5058ffe240ffde31$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $5058ffe240ffde31$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $5058ffe240ffde31$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Children.count(children) === 0;
}
function $5058ffe240ffde31$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $5058ffe240ffde31$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $5058ffe240ffde31$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $5058ffe240ffde31$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
function $5058ffe240ffde31$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $5058ffe240ffde31$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, location, {
        pathname: $5058ffe240ffde31$var$addLeadingSlash(basename) + location.pathname
    });
}
function $5058ffe240ffde31$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $5058ffe240ffde31$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $5058ffe240ffde31$var$createURL(location) {
    return typeof location === "string" ? location : (0, $a59c7fc8689634e5$export$fe53371bee54353d)(location);
}
function $5058ffe240ffde31$var$staticHandler(methodName) {
    return function() {
        (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
    };
}
function $5058ffe240ffde31$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $5058ffe240ffde31$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $5058ffe240ffde31$var$noop;
        };
        _this.handleBlock = function() {
            return $5058ffe240ffde31$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $5058ffe240ffde31$var$addBasename(basename, (0, $a59c7fc8689634e5$export$90c043f1c57770b8)(location));
        context.url = $5058ffe240ffde31$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $e357090fb59eb644$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $5058ffe240ffde31$var$addLeadingSlash(basename + $5058ffe240ffde31$var$createURL(path));
            },
            action: "POP",
            location: $5058ffe240ffde31$var$stripBasename(basename, (0, $a59c7fc8689634e5$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $5058ffe240ffde31$var$staticHandler("go"),
            goBack: $5058ffe240ffde31$var$staticHandler("goBack"),
            goForward: $5058ffe240ffde31$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$55185c17a0fcbe46, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $5058ffe240ffde31$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $5058ffe240ffde31$export$81336c211d5ff295(location.pathname, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $5058ffe240ffde31$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $e357090fb59eb644$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($5058ffe240ffde31$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(Component, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6e0bdff1309e9d3f$exports)))(C, Component);
}
var $5058ffe240ffde31$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).useContext;
function $5058ffe240ffde31$export$3420e1dc2c4a518c() {
    return $5058ffe240ffde31$var$useContext($5058ffe240ffde31$export$c213558b66925821);
}
function $5058ffe240ffde31$export$45d76561a5302f2b() {
    return $5058ffe240ffde31$var$useContext($5058ffe240ffde31$export$63baa8ccbe60bb07).location;
}
function $5058ffe240ffde31$export$99eaa27ddbbb95ef() {
    var match = $5058ffe240ffde31$var$useContext($5058ffe240ffde31$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $5058ffe240ffde31$export$632be4bb944c1bc7(path) {
    var location = $5058ffe240ffde31$export$45d76561a5302f2b();
    var match = $5058ffe240ffde31$var$useContext($5058ffe240ffde31$export$63baa8ccbe60bb07).match;
    return path ? $5058ffe240ffde31$export$81336c211d5ff295(location.pathname, path) : match;
}
var $5058ffe240ffde31$var$global$1, $5058ffe240ffde31$var$key, $5058ffe240ffde31$var$buildNames, $5058ffe240ffde31$var$initialBuildName, $5058ffe240ffde31$var$secondaryBuildName;


var $e698b80e74857b87$exports = {};

$parcel$export($e698b80e74857b87$exports, "active", function () { return $e698b80e74857b87$export$89da14300d534261; }, function (v) { return $e698b80e74857b87$export$89da14300d534261 = v; });
$parcel$export($e698b80e74857b87$exports, "actual", function () { return $e698b80e74857b87$export$f2bb41c35c9c6b13; }, function (v) { return $e698b80e74857b87$export$f2bb41c35c9c6b13 = v; });
$parcel$export($e698b80e74857b87$exports, "baseline", function () { return $e698b80e74857b87$export$baf5c2f62dd5cf3e; }, function (v) { return $e698b80e74857b87$export$baf5c2f62dd5cf3e = v; });
$parcel$export($e698b80e74857b87$exports, "brand", function () { return $e698b80e74857b87$export$96ff94e0adb1d772; }, function (v) { return $e698b80e74857b87$export$96ff94e0adb1d772 = v; });
$parcel$export($e698b80e74857b87$exports, "campaign", function () { return $e698b80e74857b87$export$b98c010fcdebc6be; }, function (v) { return $e698b80e74857b87$export$b98c010fcdebc6be = v; });
$parcel$export($e698b80e74857b87$exports, "campaignTitle", function () { return $e698b80e74857b87$export$143582cd53d50983; }, function (v) { return $e698b80e74857b87$export$143582cd53d50983 = v; });
$parcel$export($e698b80e74857b87$exports, "cardsContainer", function () { return $e698b80e74857b87$export$583b62a65da9ae06; }, function (v) { return $e698b80e74857b87$export$583b62a65da9ae06 = v; });
$parcel$export($e698b80e74857b87$exports, "catComparison", function () { return $e698b80e74857b87$export$4a752138cb317f9e; }, function (v) { return $e698b80e74857b87$export$4a752138cb317f9e = v; });
$parcel$export($e698b80e74857b87$exports, "catComparisonContainer", function () { return $e698b80e74857b87$export$64b0404f98d8b928; }, function (v) { return $e698b80e74857b87$export$64b0404f98d8b928 = v; });
$parcel$export($e698b80e74857b87$exports, "catrouselViewer", function () { return $e698b80e74857b87$export$ad1f04563ea156d9; }, function (v) { return $e698b80e74857b87$export$ad1f04563ea156d9 = v; });
$parcel$export($e698b80e74857b87$exports, "dummy", function () { return $e698b80e74857b87$export$3e042c74ad7d42ae; }, function (v) { return $e698b80e74857b87$export$3e042c74ad7d42ae = v; });
$parcel$export($e698b80e74857b87$exports, "dwellTime", function () { return $e698b80e74857b87$export$d374588d52786018; }, function (v) { return $e698b80e74857b87$export$d374588d52786018 = v; });
$parcel$export($e698b80e74857b87$exports, "legends", function () { return $e698b80e74857b87$export$33854e570d464ff0; }, function (v) { return $e698b80e74857b87$export$33854e570d464ff0 = v; });
$parcel$export($e698b80e74857b87$exports, "noMore", function () { return $e698b80e74857b87$export$7124ee307633d35; }, function (v) { return $e698b80e74857b87$export$7124ee307633d35 = v; });
$parcel$export($e698b80e74857b87$exports, "scrub", function () { return $e698b80e74857b87$export$1b16ec8d157f41c5; }, function (v) { return $e698b80e74857b87$export$1b16ec8d157f41c5 = v; });
$parcel$export($e698b80e74857b87$exports, "sectionNavigation", function () { return $e698b80e74857b87$export$e8fb2107fdab453c; }, function (v) { return $e698b80e74857b87$export$e8fb2107fdab453c = v; });
$parcel$export($e698b80e74857b87$exports, "sectionNavigationItem", function () { return $e698b80e74857b87$export$aa948fdce21f3ecc; }, function (v) { return $e698b80e74857b87$export$aa948fdce21f3ecc = v; });
$parcel$export($e698b80e74857b87$exports, "sectionTitle", function () { return $e698b80e74857b87$export$1a952fe22cdce89e; }, function (v) { return $e698b80e74857b87$export$1a952fe22cdce89e = v; });
$parcel$export($e698b80e74857b87$exports, "sectionTitleWeight", function () { return $e698b80e74857b87$export$e0a49a75d3b6a247; }, function (v) { return $e698b80e74857b87$export$e0a49a75d3b6a247 = v; });
$parcel$export($e698b80e74857b87$exports, "showMore", function () { return $e698b80e74857b87$export$ae9a281c4379b144; }, function (v) { return $e698b80e74857b87$export$ae9a281c4379b144 = v; });
$parcel$export($e698b80e74857b87$exports, "tooltipText", function () { return $e698b80e74857b87$export$f6280bcb2c59d0ac; }, function (v) { return $e698b80e74857b87$export$f6280bcb2c59d0ac = v; });
var $e698b80e74857b87$export$89da14300d534261;
var $e698b80e74857b87$export$f2bb41c35c9c6b13;
var $e698b80e74857b87$export$baf5c2f62dd5cf3e;
var $e698b80e74857b87$export$96ff94e0adb1d772;
var $e698b80e74857b87$export$b98c010fcdebc6be;
var $e698b80e74857b87$export$143582cd53d50983;
var $e698b80e74857b87$export$583b62a65da9ae06;
var $e698b80e74857b87$export$4a752138cb317f9e;
var $e698b80e74857b87$export$64b0404f98d8b928;
var $e698b80e74857b87$export$ad1f04563ea156d9;
var $e698b80e74857b87$export$3e042c74ad7d42ae;
var $e698b80e74857b87$export$d374588d52786018;
var $e698b80e74857b87$export$33854e570d464ff0;
var $e698b80e74857b87$export$7124ee307633d35;
var $e698b80e74857b87$export$1b16ec8d157f41c5;
var $e698b80e74857b87$export$e8fb2107fdab453c;
var $e698b80e74857b87$export$aa948fdce21f3ecc;
var $e698b80e74857b87$export$1a952fe22cdce89e;
var $e698b80e74857b87$export$e0a49a75d3b6a247;
var $e698b80e74857b87$export$ae9a281c4379b144;
var $e698b80e74857b87$export$f6280bcb2c59d0ac;
$e698b80e74857b87$export$89da14300d534261 = `-0HrKa_active`;
$e698b80e74857b87$export$f2bb41c35c9c6b13 = `-0HrKa_actual`;
$e698b80e74857b87$export$baf5c2f62dd5cf3e = `-0HrKa_baseline`;
$e698b80e74857b87$export$96ff94e0adb1d772 = `-0HrKa_brand`;
$e698b80e74857b87$export$b98c010fcdebc6be = `-0HrKa_campaign`;
$e698b80e74857b87$export$143582cd53d50983 = `-0HrKa_campaignTitle`;
$e698b80e74857b87$export$583b62a65da9ae06 = `-0HrKa_cardsContainer`;
$e698b80e74857b87$export$4a752138cb317f9e = `-0HrKa_catComparison`;
$e698b80e74857b87$export$64b0404f98d8b928 = `-0HrKa_catComparisonContainer`;
$e698b80e74857b87$export$ad1f04563ea156d9 = `-0HrKa_catrouselViewer`;
$e698b80e74857b87$export$3e042c74ad7d42ae = `-0HrKa_dummy`;
$e698b80e74857b87$export$d374588d52786018 = `-0HrKa_dwellTime`;
$e698b80e74857b87$export$33854e570d464ff0 = `-0HrKa_legends`;
$e698b80e74857b87$export$7124ee307633d35 = `-0HrKa_noMore`;
$e698b80e74857b87$export$1b16ec8d157f41c5 = `-0HrKa_scrub`;
$e698b80e74857b87$export$e8fb2107fdab453c = `-0HrKa_sectionNavigation`;
$e698b80e74857b87$export$aa948fdce21f3ecc = `-0HrKa_sectionNavigationItem`;
$e698b80e74857b87$export$1a952fe22cdce89e = `-0HrKa_sectionTitle`;
$e698b80e74857b87$export$e0a49a75d3b6a247 = `-0HrKa_sectionTitleWeight`;
$e698b80e74857b87$export$ae9a281c4379b144 = `-0HrKa_showMore`;
$e698b80e74857b87$export$f6280bcb2c59d0ac = `-0HrKa_tooltipText`;



/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ var $36045e57d0ad82eb$export$82e9f45cca5ba907 = "fas";
var $36045e57d0ad82eb$export$7af266c3465b1ff2 = {
    prefix: "fas",
    iconName: "ad",
    icon: [
        512,
        512,
        [],
        "f641",
        "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
    ]
};
var $36045e57d0ad82eb$export$853fd1561789e3bb = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $36045e57d0ad82eb$export$6ea408c7266ed557 = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $36045e57d0ad82eb$export$cfa06e4b68edca2d = {
    prefix: "fas",
    iconName: "adjust",
    icon: [
        512,
        512,
        [],
        "f042",
        "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
    ]
};
var $36045e57d0ad82eb$export$a5e63e89b5ccee83 = {
    prefix: "fas",
    iconName: "air-freshener",
    icon: [
        512,
        512,
        [],
        "f5d0",
        "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
    ]
};
var $36045e57d0ad82eb$export$70e29dd05344623e = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
    ]
};
var $36045e57d0ad82eb$export$97c42b56d462df72 = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$e490f662af4d1c78 = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$7370f36a39a38737 = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
    ]
};
var $36045e57d0ad82eb$export$dcae2101babbffff = {
    prefix: "fas",
    iconName: "allergies",
    icon: [
        448,
        512,
        [],
        "f461",
        "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$f5c7042778b51765 = {
    prefix: "fas",
    iconName: "ambulance",
    icon: [
        640,
        512,
        [],
        "f0f9",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $36045e57d0ad82eb$export$23a7517099ab1b86 = {
    prefix: "fas",
    iconName: "american-sign-language-interpreting",
    icon: [
        640,
        512,
        [],
        "f2a3",
        "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
    ]
};
var $36045e57d0ad82eb$export$12a35719f889cd1 = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [],
        "f13d",
        "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
    ]
};
var $36045e57d0ad82eb$export$fd504117f273ca92 = {
    prefix: "fas",
    iconName: "angle-double-down",
    icon: [
        320,
        512,
        [],
        "f103",
        "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
    ]
};
var $36045e57d0ad82eb$export$21b0833b3cf929a7 = {
    prefix: "fas",
    iconName: "angle-double-left",
    icon: [
        448,
        512,
        [],
        "f100",
        "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
    ]
};
var $36045e57d0ad82eb$export$792931403404faf0 = {
    prefix: "fas",
    iconName: "angle-double-right",
    icon: [
        448,
        512,
        [],
        "f101",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
    ]
};
var $36045e57d0ad82eb$export$9bb51e1a2c07db7c = {
    prefix: "fas",
    iconName: "angle-double-up",
    icon: [
        320,
        512,
        [],
        "f102",
        "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
    ]
};
var $36045e57d0ad82eb$export$4b5be0142d10f342 = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        320,
        512,
        [],
        "f107",
        "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    ]
};
var $36045e57d0ad82eb$export$3cbcd1b7e35945d2 = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        256,
        512,
        [],
        "f104",
        "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
    ]
};
var $36045e57d0ad82eb$export$6bce1afb61f2eb66 = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        256,
        512,
        [],
        "f105",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
    ]
};
var $36045e57d0ad82eb$export$887340269e6d6cac = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        320,
        512,
        [],
        "f106",
        "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
    ]
};
var $36045e57d0ad82eb$export$3c96c08e234498c5 = {
    prefix: "fas",
    iconName: "angry",
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
    ]
};
var $36045e57d0ad82eb$export$8736909014b15ca9 = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [],
        "f644",
        "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
    ]
};
var $36045e57d0ad82eb$export$bcdd94f3977a0884 = {
    prefix: "fas",
    iconName: "apple-alt",
    icon: [
        448,
        512,
        [],
        "f5d1",
        "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
    ]
};
var $36045e57d0ad82eb$export$26b3e1c454273f34 = {
    prefix: "fas",
    iconName: "archive",
    icon: [
        512,
        512,
        [],
        "f187",
        "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$d56753dd2eb5c323 = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        576,
        512,
        [],
        "f557",
        "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$ff3afbc8c0bc5d59 = {
    prefix: "fas",
    iconName: "arrow-alt-circle-down",
    icon: [
        512,
        512,
        [],
        "f358",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
    ]
};
var $36045e57d0ad82eb$export$5460a5b11a24996f = {
    prefix: "fas",
    iconName: "arrow-alt-circle-left",
    icon: [
        512,
        512,
        [],
        "f359",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
    ]
};
var $36045e57d0ad82eb$export$88962ffdad8b856d = {
    prefix: "fas",
    iconName: "arrow-alt-circle-right",
    icon: [
        512,
        512,
        [],
        "f35a",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
    ]
};
var $36045e57d0ad82eb$export$3747a8ef0995eadf = {
    prefix: "fas",
    iconName: "arrow-alt-circle-up",
    icon: [
        512,
        512,
        [],
        "f35b",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
    ]
};
var $36045e57d0ad82eb$export$6cfa36bbb3a057 = {
    prefix: "fas",
    iconName: "arrow-circle-down",
    icon: [
        512,
        512,
        [],
        "f0ab",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
    ]
};
var $36045e57d0ad82eb$export$728262abb9f58d0a = {
    prefix: "fas",
    iconName: "arrow-circle-left",
    icon: [
        512,
        512,
        [],
        "f0a8",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
    ]
};
var $36045e57d0ad82eb$export$7d3d828103aa3be7 = {
    prefix: "fas",
    iconName: "arrow-circle-right",
    icon: [
        512,
        512,
        [],
        "f0a9",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
    ]
};
var $36045e57d0ad82eb$export$a2f6f3baa50af0b1 = {
    prefix: "fas",
    iconName: "arrow-circle-up",
    icon: [
        512,
        512,
        [],
        "f0aa",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
    ]
};
var $36045e57d0ad82eb$export$9686eff8d817f770 = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        448,
        512,
        [],
        "f063",
        "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
    ]
};
var $36045e57d0ad82eb$export$b7fac681e7d09400 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [],
        "f060",
        "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    ]
};
var $36045e57d0ad82eb$export$b4da69a0247f3620 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [],
        "f061",
        "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    ]
};
var $36045e57d0ad82eb$export$8e144ed4d52eef49 = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        448,
        512,
        [],
        "f062",
        "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
    ]
};
var $36045e57d0ad82eb$export$3cdabfff52cfc73a = {
    prefix: "fas",
    iconName: "arrows-alt",
    icon: [
        512,
        512,
        [],
        "f0b2",
        "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
    ]
};
var $36045e57d0ad82eb$export$7937ea574fb1389 = {
    prefix: "fas",
    iconName: "arrows-alt-h",
    icon: [
        512,
        512,
        [],
        "f337",
        "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
    ]
};
var $36045e57d0ad82eb$export$138cb56a3f8f7040 = {
    prefix: "fas",
    iconName: "arrows-alt-v",
    icon: [
        256,
        512,
        [],
        "f338",
        "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
    ]
};
var $36045e57d0ad82eb$export$8eeef3dc0035b165 = {
    prefix: "fas",
    iconName: "assistive-listening-systems",
    icon: [
        512,
        512,
        [],
        "f2a2",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
    ]
};
var $36045e57d0ad82eb$export$19eff32c0fd4f99f = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        512,
        512,
        [],
        "f069",
        "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
    ]
};
var $36045e57d0ad82eb$export$c115e8063ee02632 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [],
        "f1fa",
        "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
    ]
};
var $36045e57d0ad82eb$export$380a9050e42fe5d7 = {
    prefix: "fas",
    iconName: "atlas",
    icon: [
        448,
        512,
        [],
        "f558",
        "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
    ]
};
var $36045e57d0ad82eb$export$b5bb295e8ad4ab31 = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        448,
        512,
        [],
        "f5d2",
        "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
    ]
};
var $36045e57d0ad82eb$export$b6b464c98c009494 = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        512,
        512,
        [],
        "f29e",
        "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
    ]
};
var $36045e57d0ad82eb$export$f8db2747dadd48f7 = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
    ]
};
var $36045e57d0ad82eb$export$8afab767536f59ad = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        384,
        512,
        [],
        "f77c",
        "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
    ]
};
var $36045e57d0ad82eb$export$3b3ab4d86bad7d26 = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [],
        "f77d",
        "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
    ]
};
var $36045e57d0ad82eb$export$e43e3f67102fc526 = {
    prefix: "fas",
    iconName: "backspace",
    icon: [
        640,
        512,
        [],
        "f55a",
        "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
    ]
};
var $36045e57d0ad82eb$export$ae65f96ea7a4078d = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [],
        "f04a",
        "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
    ]
};
var $36045e57d0ad82eb$export$ab07061fe21a3a8e = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [],
        "f7e5",
        "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
    ]
};
var $36045e57d0ad82eb$export$7fc18cf2d526c341 = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
    ]
};
var $36045e57d0ad82eb$export$b0babe4230e35ebe = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        512,
        512,
        [],
        "e05a",
        "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
    ]
};
var $36045e57d0ad82eb$export$6d636565b3ec36b4 = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        512,
        512,
        [],
        "f666",
        "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
    ]
};
var $36045e57d0ad82eb$export$fec323dcfd81d750 = {
    prefix: "fas",
    iconName: "balance-scale",
    icon: [
        640,
        512,
        [],
        "f24e",
        "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$786cb0c775487f19 = {
    prefix: "fas",
    iconName: "balance-scale-left",
    icon: [
        640,
        512,
        [],
        "f515",
        "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
    ]
};
var $36045e57d0ad82eb$export$2238e05f8920005a = {
    prefix: "fas",
    iconName: "balance-scale-right",
    icon: [
        640,
        512,
        [],
        "f516",
        "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
    ]
};
var $36045e57d0ad82eb$export$76f704d256def3c7 = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [],
        "f05e",
        "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
    ]
};
var $36045e57d0ad82eb$export$b14a1014df2fdf46 = {
    prefix: "fas",
    iconName: "band-aid",
    icon: [
        640,
        512,
        [],
        "f462",
        "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
    ]
};
var $36045e57d0ad82eb$export$3825a842b5afc5aa = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
    ]
};
var $36045e57d0ad82eb$export$36e9cf7887265da2 = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [],
        "f0c9",
        "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    ]
};
var $36045e57d0ad82eb$export$63a3f8ceae07c7f3 = {
    prefix: "fas",
    iconName: "baseball-ball",
    icon: [
        496,
        512,
        [],
        "f433",
        "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
    ]
};
var $36045e57d0ad82eb$export$36550ab8ffcc5b28 = {
    prefix: "fas",
    iconName: "basketball-ball",
    icon: [
        496,
        512,
        [],
        "f434",
        "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
    ]
};
var $36045e57d0ad82eb$export$1ea66a88b8f620c9 = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [],
        "f2cd",
        "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
    ]
};
var $36045e57d0ad82eb$export$1344b64f6e922e12 = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        640,
        512,
        [],
        "f244",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$9338fc4614cfc0cf = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        640,
        512,
        [],
        "f240",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
    ]
};
var $36045e57d0ad82eb$export$e6dadc1155c4ee48 = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        640,
        512,
        [],
        "f242",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
    ]
};
var $36045e57d0ad82eb$export$acec92052ac2183 = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        640,
        512,
        [],
        "f243",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
    ]
};
var $36045e57d0ad82eb$export$cfb37069d38f379e = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        640,
        512,
        [],
        "f241",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
    ]
};
var $36045e57d0ad82eb$export$f24e0fce77994d4d = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [],
        "f236",
        "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
    ]
};
var $36045e57d0ad82eb$export$f74725691538983b = {
    prefix: "fas",
    iconName: "beer",
    icon: [
        448,
        512,
        [],
        "f0fc",
        "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$9b6162797ab1b255 = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    ]
};
var $36045e57d0ad82eb$export$6b31a1e5968b2378 = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var $36045e57d0ad82eb$export$a527a6267c55a54c = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$2eac809b0670d139 = {
    prefix: "fas",
    iconName: "bible",
    icon: [
        448,
        512,
        [],
        "f647",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $36045e57d0ad82eb$export$36cb1885ad7a570f = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [],
        "f206",
        "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
    ]
};
var $36045e57d0ad82eb$export$a5bcf835dbf9c0b = {
    prefix: "fas",
    iconName: "biking",
    icon: [
        640,
        512,
        [],
        "f84a",
        "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
    ]
};
var $36045e57d0ad82eb$export$8a910017964bb8c2 = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
    ]
};
var $36045e57d0ad82eb$export$ae3a453550dec95 = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [],
        "f780",
        "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$bdcf98f725a7241a = {
    prefix: "fas",
    iconName: "birthday-cake",
    icon: [
        448,
        512,
        [],
        "f1fd",
        "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
    ]
};
var $36045e57d0ad82eb$export$db34f7a6de38784f = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
    ]
};
var $36045e57d0ad82eb$export$f35a116a762ef8fc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$923de21def6ea9b6 = {
    prefix: "fas",
    iconName: "blind",
    icon: [
        384,
        512,
        [],
        "f29d",
        "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
    ]
};
var $36045e57d0ad82eb$export$890d5e011054935a = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
    ]
};
var $36045e57d0ad82eb$export$7e0c7fd2a2e88823 = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
    ]
};
var $36045e57d0ad82eb$export$6869964aa308dd31 = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        320,
        512,
        [],
        "f0e7",
        "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
    ]
};
var $36045e57d0ad82eb$export$d59078f6e80b4a67 = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [],
        "f1e2",
        "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $36045e57d0ad82eb$export$5902c007d5703f2d = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        640,
        512,
        [],
        "f5d7",
        "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
    ]
};
var $36045e57d0ad82eb$export$e74974fac77c468e = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
    ]
};
var $36045e57d0ad82eb$export$c9d7ef726d1a8742 = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [],
        "f02d",
        "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    ]
};
var $36045e57d0ad82eb$export$b98a3f8c3941a74a = {
    prefix: "fas",
    iconName: "book-dead",
    icon: [
        448,
        512,
        [],
        "f6b7",
        "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
    ]
};
var $36045e57d0ad82eb$export$6feb44fec53ba30d = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
    ]
};
var $36045e57d0ad82eb$export$8a3071811b2b7979 = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [],
        "f518",
        "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
    ]
};
var $36045e57d0ad82eb$export$cee14fe33262fa7d = {
    prefix: "fas",
    iconName: "book-reader",
    icon: [
        512,
        512,
        [],
        "f5da",
        "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
    ]
};
var $36045e57d0ad82eb$export$4ed9da5c3cca0ef1 = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [],
        "f02e",
        "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
    ]
};
var $36045e57d0ad82eb$export$93a5eb721c9c0d25 = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
    ]
};
var $36045e57d0ad82eb$export$2b488402ec335d97 = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$c2867ca78120d644 = {
    prefix: "fas",
    iconName: "border-style",
    icon: [
        448,
        512,
        [],
        "f853",
        "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$5ee2640fe105312d = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        496,
        512,
        [],
        "f436",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$6e7cf270cda52323 = {
    prefix: "fas",
    iconName: "box",
    icon: [
        512,
        512,
        [],
        "f466",
        "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
    ]
};
var $36045e57d0ad82eb$export$9010ed816a8b9c97 = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
    ]
};
var $36045e57d0ad82eb$export$f2adc06617bc0c7 = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
    ]
};
var $36045e57d0ad82eb$export$2007320dd6cde6db = {
    prefix: "fas",
    iconName: "boxes",
    icon: [
        576,
        512,
        [],
        "f468",
        "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$983e9c27cac7ed1c = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$97fa4f4c1006ab1 = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        576,
        512,
        [],
        "f5dc",
        "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
    ]
};
var $36045e57d0ad82eb$export$d78e8b0681279167 = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        576,
        512,
        [],
        "f7ec",
        "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
    ]
};
var $36045e57d0ad82eb$export$8da450d063b0eb37 = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [],
        "f0b1",
        "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    ]
};
var $36045e57d0ad82eb$export$5000f52ca9819bf5 = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
    ]
};
var $36045e57d0ad82eb$export$f68b38d51f5c0ed = {
    prefix: "fas",
    iconName: "broadcast-tower",
    icon: [
        640,
        512,
        [],
        "f519",
        "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
    ]
};
var $36045e57d0ad82eb$export$2a533051418ff4ca = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        640,
        512,
        [],
        "f51a",
        "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
    ]
};
var $36045e57d0ad82eb$export$5824ffe6f8983c83 = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
    ]
};
var $36045e57d0ad82eb$export$a18cfac400116d9f = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
    ]
};
var $36045e57d0ad82eb$export$f26673f8b10c3d46 = {
    prefix: "fas",
    iconName: "building",
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
    ]
};
var $36045e57d0ad82eb$export$dacae2b4ec565333 = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        576,
        512,
        [],
        "f0a1",
        "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
    ]
};
var $36045e57d0ad82eb$export$554720e3bf74fe90 = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        496,
        512,
        [],
        "f140",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
    ]
};
var $36045e57d0ad82eb$export$80ed4535efc60402 = {
    prefix: "fas",
    iconName: "burn",
    icon: [
        384,
        512,
        [],
        "f46a",
        "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
    ]
};
var $36045e57d0ad82eb$export$ce69441578ff2fdb = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        512,
        512,
        [],
        "f207",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$40616edfab6d332a = {
    prefix: "fas",
    iconName: "bus-alt",
    icon: [
        512,
        512,
        [],
        "f55e",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$694b7e88782dec12 = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [],
        "f64a",
        "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
    ]
};
var $36045e57d0ad82eb$export$693bd40950ed2c3a = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        448,
        512,
        [],
        "f1ec",
        "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
    ]
};
var $36045e57d0ad82eb$export$34f5c36a3e80efa2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [],
        "f133",
        "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
    ]
};
var $36045e57d0ad82eb$export$cbc139f33cff356 = {
    prefix: "fas",
    iconName: "calendar-alt",
    icon: [
        448,
        512,
        [],
        "f073",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$5655108e1162ba45 = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
    ]
};
var $36045e57d0ad82eb$export$80968bcfef6481ca = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$23e8b4955c2d951b = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
    ]
};
var $36045e57d0ad82eb$export$16768a660ae3ca9d = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
    ]
};
var $36045e57d0ad82eb$export$99b20d7352fbcf08 = {
    prefix: "fas",
    iconName: "calendar-times",
    icon: [
        448,
        512,
        [],
        "f273",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
    ]
};
var $36045e57d0ad82eb$export$39be5cb4aed5a521 = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$84ffbd7161ca2008 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [],
        "f030",
        "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
    ]
};
var $36045e57d0ad82eb$export$41dbdadc07a89b05 = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [],
        "f083",
        "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$295287303c0e9c7c = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        640,
        512,
        [],
        "f6bb",
        "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
    ]
};
var $36045e57d0ad82eb$export$14d66ba7571ae0b9 = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
    ]
};
var $36045e57d0ad82eb$export$8ec2f752344b69bd = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
    ]
};
var $36045e57d0ad82eb$export$ba6fd4a436804a48 = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
    ]
};
var $36045e57d0ad82eb$export$9eefe7fcdf123b76 = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [],
        "f1b9",
        "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $36045e57d0ad82eb$export$7937ed2462a665c0 = {
    prefix: "fas",
    iconName: "car-alt",
    icon: [
        480,
        512,
        [],
        "f5de",
        "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $36045e57d0ad82eb$export$a44d0c11093d9c1e = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [],
        "f5df",
        "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
    ]
};
var $36045e57d0ad82eb$export$8ff55566398404cd = {
    prefix: "fas",
    iconName: "car-crash",
    icon: [
        640,
        512,
        [],
        "f5e1",
        "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
    ]
};
var $36045e57d0ad82eb$export$6f7218565b1b8d0e = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [],
        "f5e4",
        "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$afb5d0eee7c1bdb = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
    ]
};
var $36045e57d0ad82eb$export$f9395ef707603e40 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    ]
};
var $36045e57d0ad82eb$export$85a918a11b7643c2 = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        192,
        512,
        [],
        "f0d9",
        "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
    ]
};
var $36045e57d0ad82eb$export$f1011352b01c1c0 = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        192,
        512,
        [],
        "f0da",
        "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    ]
};
var $36045e57d0ad82eb$export$61aea18df1c84401 = {
    prefix: "fas",
    iconName: "caret-square-down",
    icon: [
        448,
        512,
        [],
        "f150",
        "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
    ]
};
var $36045e57d0ad82eb$export$d0c8ba444f1f9581 = {
    prefix: "fas",
    iconName: "caret-square-left",
    icon: [
        448,
        512,
        [],
        "f191",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
    ]
};
var $36045e57d0ad82eb$export$ae86c9de7e0f62fa = {
    prefix: "fas",
    iconName: "caret-square-right",
    icon: [
        448,
        512,
        [],
        "f152",
        "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
    ]
};
var $36045e57d0ad82eb$export$307ae80b26533ce5 = {
    prefix: "fas",
    iconName: "caret-square-up",
    icon: [
        448,
        512,
        [],
        "f151",
        "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
    ]
};
var $36045e57d0ad82eb$export$7de776bdab4e536d = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
    ]
};
var $36045e57d0ad82eb$export$28e93ec9f5e2ddf3 = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [],
        "f787",
        "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
    ]
};
var $36045e57d0ad82eb$export$9206260ff0c0c616 = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
    ]
};
var $36045e57d0ad82eb$export$6675e2bf21fdb87e = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$6357093f67788b33 = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
    ]
};
var $36045e57d0ad82eb$export$ab927dada03be4b3 = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        512,
        512,
        [],
        "f6be",
        "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$a881f37164b11fbf = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
    ]
};
var $36045e57d0ad82eb$export$a339864ee3df7e9a = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [],
        "f6c0",
        "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
    ]
};
var $36045e57d0ad82eb$export$49a36efd66df775 = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        640,
        512,
        [],
        "f51b",
        "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$443fcf69b0155291 = {
    prefix: "fas",
    iconName: "chalkboard-teacher",
    icon: [
        640,
        512,
        [],
        "f51c",
        "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
    ]
};
var $36045e57d0ad82eb$export$bab2cd86f8c65657 = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
    ]
};
var $36045e57d0ad82eb$export$2acab8312b7a999b = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [],
        "f1fe",
        "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
    ]
};
var $36045e57d0ad82eb$export$b532f5d25de97633 = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [],
        "f080",
        "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$e022f62a119e1d93 = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [],
        "f201",
        "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
    ]
};
var $36045e57d0ad82eb$export$1de7b9cf7d1b153b = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        544,
        512,
        [],
        "f200",
        "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
    ]
};
var $36045e57d0ad82eb$export$62b2c752fccc6a9c = {
    prefix: "fas",
    iconName: "check",
    icon: [
        512,
        512,
        [],
        "f00c",
        "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    ]
};
var $36045e57d0ad82eb$export$be9e388158c74f29 = {
    prefix: "fas",
    iconName: "check-circle",
    icon: [
        512,
        512,
        [],
        "f058",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
    ]
};
var $36045e57d0ad82eb$export$f178c8c2ad3cc861 = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        512,
        512,
        [],
        "f560",
        "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
    ]
};
var $36045e57d0ad82eb$export$f0c8040f596df7fe = {
    prefix: "fas",
    iconName: "check-square",
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
    ]
};
var $36045e57d0ad82eb$export$549b99473b7201e6 = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
    ]
};
var $36045e57d0ad82eb$export$442fddbbd741c590 = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
    ]
};
var $36045e57d0ad82eb$export$a831eedd2f59c62f = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [],
        "f43a",
        "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$bd301515df6246af = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        512,
        512,
        [],
        "f43c",
        "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
    ]
};
var $36045e57d0ad82eb$export$d5713874f8fefe1b = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [],
        "f43f",
        "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
    ]
};
var $36045e57d0ad82eb$export$861b1f13085cf122 = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        384,
        512,
        [],
        "f441",
        "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$3db75d5ac9e98468 = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [],
        "f443",
        "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$7b8ce73615739d30 = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [],
        "f445",
        "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
    ]
};
var $36045e57d0ad82eb$export$5d65c40a109eb09c = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        384,
        512,
        [],
        "f447",
        "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$9926124d75b2ecab = {
    prefix: "fas",
    iconName: "chevron-circle-down",
    icon: [
        512,
        512,
        [],
        "f13a",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
    ]
};
var $36045e57d0ad82eb$export$4a42c8c2451a33fd = {
    prefix: "fas",
    iconName: "chevron-circle-left",
    icon: [
        512,
        512,
        [],
        "f137",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
    ]
};
var $36045e57d0ad82eb$export$2a5db4f6eba6f2b = {
    prefix: "fas",
    iconName: "chevron-circle-right",
    icon: [
        512,
        512,
        [],
        "f138",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
    ]
};
var $36045e57d0ad82eb$export$b786cf5db03f2c36 = {
    prefix: "fas",
    iconName: "chevron-circle-up",
    icon: [
        512,
        512,
        [],
        "f139",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
    ]
};
var $36045e57d0ad82eb$export$8db9bc521720fccd = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        448,
        512,
        [],
        "f078",
        "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    ]
};
var $36045e57d0ad82eb$export$75702e3e3dd44a44 = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [],
        "f053",
        "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
    ]
};
var $36045e57d0ad82eb$export$930de8c26eb20490 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [],
        "f054",
        "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
    ]
};
var $36045e57d0ad82eb$export$877e5ae47a854215 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        448,
        512,
        [],
        "f077",
        "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
    ]
};
var $36045e57d0ad82eb$export$60b41e3581d1739a = {
    prefix: "fas",
    iconName: "child",
    icon: [
        384,
        512,
        [],
        "f1ae",
        "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
    ]
};
var $36045e57d0ad82eb$export$16a3f12c6ae9650 = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [],
        "f51d",
        "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
    ]
};
var $36045e57d0ad82eb$export$4280b2387fbdad12 = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
    ]
};
var $36045e57d0ad82eb$export$9429fd8df55155d = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
    ]
};
var $36045e57d0ad82eb$export$a9947c2888b3c8fd = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [],
        "f64f",
        "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
    ]
};
var $36045e57d0ad82eb$export$20d8a680febc7434 = {
    prefix: "fas",
    iconName: "clinic-medical",
    icon: [
        576,
        512,
        [],
        "f7f2",
        "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
    ]
};
var $36045e57d0ad82eb$export$97d84347d71ba297 = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [],
        "f328",
        "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
    ]
};
var $36045e57d0ad82eb$export$7babcb2c90eb609a = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
    ]
};
var $36045e57d0ad82eb$export$2c5a9d8548d8810e = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $36045e57d0ad82eb$export$95b9968e7fceb821 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [],
        "f017",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
    ]
};
var $36045e57d0ad82eb$export$76c1aa4bf9a39458 = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    ]
};
var $36045e57d0ad82eb$export$8e047801a8603af7 = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
    ]
};
var $36045e57d0ad82eb$export$8bb3c4d5c2f50243 = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [],
        "f0c2",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
    ]
};
var $36045e57d0ad82eb$export$351357a14c41f824 = {
    prefix: "fas",
    iconName: "cloud-download-alt",
    icon: [
        640,
        512,
        [],
        "f381",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
    ]
};
var $36045e57d0ad82eb$export$5d120e8b87ad33f4 = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
    ]
};
var $36045e57d0ad82eb$export$482eb125aaf0fbc2 = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        576,
        512,
        [],
        "f6c3",
        "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
    ]
};
var $36045e57d0ad82eb$export$301c3fab0c4545bd = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $36045e57d0ad82eb$export$a6c308ee087b4ded = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [],
        "f73d",
        "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
    ]
};
var $36045e57d0ad82eb$export$af51c741ee9cc090 = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
    ]
};
var $36045e57d0ad82eb$export$dcaadfd9c98e42a1 = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [],
        "f6c4",
        "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
    ]
};
var $36045e57d0ad82eb$export$dd9dc9b4227dbe94 = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        576,
        512,
        [],
        "f743",
        "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $36045e57d0ad82eb$export$e73b3e819b9d14a5 = {
    prefix: "fas",
    iconName: "cloud-upload-alt",
    icon: [
        640,
        512,
        [],
        "f382",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
    ]
};
var $36045e57d0ad82eb$export$4be708f1e41d387b = {
    prefix: "fas",
    iconName: "cocktail",
    icon: [
        576,
        512,
        [],
        "f561",
        "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
    ]
};
var $36045e57d0ad82eb$export$eba095993e51cc97 = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
    ]
};
var $36045e57d0ad82eb$export$aa054a78ab078db3 = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        384,
        512,
        [],
        "f126",
        "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
    ]
};
var $36045e57d0ad82eb$export$1d24a9e457278011 = {
    prefix: "fas",
    iconName: "coffee",
    icon: [
        640,
        512,
        [],
        "f0f4",
        "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
    ]
};
var $36045e57d0ad82eb$export$d6298bbfd1912a78 = {
    prefix: "fas",
    iconName: "cog",
    icon: [
        512,
        512,
        [],
        "f013",
        "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $36045e57d0ad82eb$export$af1575770afc9559 = {
    prefix: "fas",
    iconName: "cogs",
    icon: [
        640,
        512,
        [],
        "f085",
        "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
    ]
};
var $36045e57d0ad82eb$export$bc5da164799a0e = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
    ]
};
var $36045e57d0ad82eb$export$bb861166644ac28a = {
    prefix: "fas",
    iconName: "columns",
    icon: [
        512,
        512,
        [],
        "f0db",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
    ]
};
var $36045e57d0ad82eb$export$805cd88398a70581 = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
    ]
};
var $36045e57d0ad82eb$export$6e96904d9af0ec4a = {
    prefix: "fas",
    iconName: "comment-alt",
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
    ]
};
var $36045e57d0ad82eb$export$7a088030853df12c = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
    ]
};
var $36045e57d0ad82eb$export$63ffcb3d4e94cb92 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$101422b773924276 = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
    ]
};
var $36045e57d0ad82eb$export$3786a0422a3f33ea = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $36045e57d0ad82eb$export$932912e74adb8939 = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        576,
        512,
        [],
        "f086",
        "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
    ]
};
var $36045e57d0ad82eb$export$d477129b070e5ac4 = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        576,
        512,
        [],
        "f653",
        "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
    ]
};
var $36045e57d0ad82eb$export$84021631df0f831b = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        496,
        512,
        [],
        "f51f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$b4d344633433e50e = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        496,
        512,
        [],
        "f14e",
        "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
    ]
};
var $36045e57d0ad82eb$export$83632d1150d3541f = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $36045e57d0ad82eb$export$a05650ebe54bede = {
    prefix: "fas",
    iconName: "compress-alt",
    icon: [
        448,
        512,
        [],
        "f422",
        "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
    ]
};
var $36045e57d0ad82eb$export$39205db0ea980efd = {
    prefix: "fas",
    iconName: "compress-arrows-alt",
    icon: [
        512,
        512,
        [],
        "f78c",
        "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
    ]
};
var $36045e57d0ad82eb$export$ad92ffbbfbc0fcf3 = {
    prefix: "fas",
    iconName: "concierge-bell",
    icon: [
        512,
        512,
        [],
        "f562",
        "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$b3e64f5f68c6623f = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [],
        "f563",
        "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$317dde8664f7de71 = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$e9bd786d30cb716c = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
    ]
};
var $36045e57d0ad82eb$export$da61665fff8aebfe = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
    ]
};
var $36045e57d0ad82eb$export$ce96e32767a7dd51 = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
    ]
};
var $36045e57d0ad82eb$export$3e7437bf6535bef0 = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [],
        "f09d",
        "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
    ]
};
var $36045e57d0ad82eb$export$afa58590dfb6fca2 = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$d932915fde4f1010 = {
    prefix: "fas",
    iconName: "crop-alt",
    icon: [
        512,
        512,
        [],
        "f565",
        "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
    ]
};
var $36045e57d0ad82eb$export$9d0a89fcd084abb = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [],
        "f654",
        "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$721c101130c40043 = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ]
};
var $36045e57d0ad82eb$export$bfa312207b788ed9 = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$dc1083dcd1d7b9d6 = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        640,
        512,
        [],
        "f521",
        "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$e94134641c0e2 = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
    ]
};
var $36045e57d0ad82eb$export$973ae4f1e4d2ce78 = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
    ]
};
var $36045e57d0ad82eb$export$30523a9441a31e97 = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        512,
        512,
        [],
        "f1b3",
        "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
    ]
};
var $36045e57d0ad82eb$export$66847f2a71b260e7 = {
    prefix: "fas",
    iconName: "cut",
    icon: [
        448,
        512,
        [],
        "f0c4",
        "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$24680dede86b1883 = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
    ]
};
var $36045e57d0ad82eb$export$4b666adf83f0de01 = {
    prefix: "fas",
    iconName: "deaf",
    icon: [
        512,
        512,
        [],
        "f2a4",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
    ]
};
var $36045e57d0ad82eb$export$a1672d808fbed0bd = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
    ]
};
var $36045e57d0ad82eb$export$6e6ddc253102e596 = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [],
        "f108",
        "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
    ]
};
var $36045e57d0ad82eb$export$45cbd92c28deb2c7 = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [],
        "f655",
        "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
    ]
};
var $36045e57d0ad82eb$export$68bad2b52a90d1fa = {
    prefix: "fas",
    iconName: "diagnoses",
    icon: [
        640,
        512,
        [],
        "f470",
        "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$4ed8206e6619cc8f = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [],
        "f522",
        "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$b06003a02c9055bd = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        480,
        512,
        [],
        "f6cf",
        "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
    ]
};
var $36045e57d0ad82eb$export$64bfd48ed353c031 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
    ]
};
var $36045e57d0ad82eb$export$d9769fb795c2db82 = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [],
        "f523",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$2df6451abf70a6ff = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [],
        "f524",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$d91800b7be5303b0 = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [],
        "f525",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$3397c7b4679acccc = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [],
        "f526",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$221059e0d5fd8958 = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [],
        "f527",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$4d85df590065572f = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [],
        "f528",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$b3bf1994f0fefe98 = {
    prefix: "fas",
    iconName: "digital-tachograph",
    icon: [
        640,
        512,
        [],
        "f566",
        "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
    ]
};
var $36045e57d0ad82eb$export$6a6973de44442fe5 = {
    prefix: "fas",
    iconName: "directions",
    icon: [
        512,
        512,
        [],
        "f5eb",
        "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
    ]
};
var $36045e57d0ad82eb$export$c7675a37487adc45 = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
    ]
};
var $36045e57d0ad82eb$export$89fa217ec5503ac9 = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [],
        "f529",
        "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$89a2b10dabc487e8 = {
    prefix: "fas",
    iconName: "dizzy",
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
    ]
};
var $36045e57d0ad82eb$export$c062100d54a2da00 = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [],
        "f471",
        "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
    ]
};
var $36045e57d0ad82eb$export$c6406747800cf702 = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [],
        "f6d3",
        "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
    ]
};
var $36045e57d0ad82eb$export$fb420d3e4d8c6a18 = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        288,
        512,
        [],
        "f155",
        "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
    ]
};
var $36045e57d0ad82eb$export$5879d0bca1aa497b = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [],
        "f472",
        "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$f7c6efb60c53b285 = {
    prefix: "fas",
    iconName: "dolly-flatbed",
    icon: [
        640,
        512,
        [],
        "f474",
        "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$40050ae52860cde7 = {
    prefix: "fas",
    iconName: "donate",
    icon: [
        512,
        512,
        [],
        "f4b9",
        "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$2c79e1a422528bba = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        640,
        512,
        [],
        "f52a",
        "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$41821b9a6fd703de = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        640,
        512,
        [],
        "f52b",
        "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
    ]
};
var $36045e57d0ad82eb$export$92bc269cb244d66a = {
    prefix: "fas",
    iconName: "dot-circle",
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
    ]
};
var $36045e57d0ad82eb$export$a1ab1e69a300089f = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [],
        "f4ba",
        "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$8f734e51d72ca13a = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $36045e57d0ad82eb$export$c8c2b127d13b9d79 = {
    prefix: "fas",
    iconName: "drafting-compass",
    icon: [
        512,
        512,
        [],
        "f568",
        "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
    ]
};
var $36045e57d0ad82eb$export$ae1875ba975aa0e9 = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [],
        "f6d5",
        "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
    ]
};
var $36045e57d0ad82eb$export$df9bd3777d1154d2 = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$5b9205e1042594b7 = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [],
        "f569",
        "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
    ]
};
var $36045e57d0ad82eb$export$48d1206500db2e9d = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
    ]
};
var $36045e57d0ad82eb$export$482976e9a4ab10f3 = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
    ]
};
var $36045e57d0ad82eb$export$56700074cf37be5c = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$3b934e22d1851a3b = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$25e9b29b3f2230b5 = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
    ]
};
var $36045e57d0ad82eb$export$1156dc6acb0058bd = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
    ]
};
var $36045e57d0ad82eb$export$7be713e57d023733 = {
    prefix: "fas",
    iconName: "edit",
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
    ]
};
var $36045e57d0ad82eb$export$1199a8ce85311ab5 = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [],
        "f7fb",
        "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
    ]
};
var $36045e57d0ad82eb$export$8484041d5b209494 = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [],
        "f052",
        "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
    ]
};
var $36045e57d0ad82eb$export$c9f2fedd4489a2ee = {
    prefix: "fas",
    iconName: "ellipsis-h",
    icon: [
        512,
        512,
        [],
        "f141",
        "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
    ]
};
var $36045e57d0ad82eb$export$e58494c7fcb5380 = {
    prefix: "fas",
    iconName: "ellipsis-v",
    icon: [
        192,
        512,
        [],
        "f142",
        "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
    ]
};
var $36045e57d0ad82eb$export$6f095630677adc = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    ]
};
var $36045e57d0ad82eb$export$c6c3bd5f7d9b8bf2 = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
    ]
};
var $36045e57d0ad82eb$export$f5c53ce8ec380d11 = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
    ]
};
var $36045e57d0ad82eb$export$354e159473e73552 = {
    prefix: "fas",
    iconName: "envelope-square",
    icon: [
        448,
        512,
        [],
        "f199",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
    ]
};
var $36045e57d0ad82eb$export$a7c5f5e4805fdab = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [],
        "f52c",
        "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$e7fc4fe34e767f28 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        512,
        512,
        [],
        "f12d",
        "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
    ]
};
var $36045e57d0ad82eb$export$6bad2c9f317b52e5 = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$902a3969bb113dff = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [],
        "f153",
        "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
    ]
};
var $36045e57d0ad82eb$export$f6c6fb20d374b128 = {
    prefix: "fas",
    iconName: "exchange-alt",
    icon: [
        512,
        512,
        [],
        "f362",
        "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$de6218b649cbb6a9 = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        192,
        512,
        [],
        "f12a",
        "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
    ]
};
var $36045e57d0ad82eb$export$220e07e14c5d7e5d = {
    prefix: "fas",
    iconName: "exclamation-circle",
    icon: [
        512,
        512,
        [],
        "f06a",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $36045e57d0ad82eb$export$3d249b63b52cce7c = {
    prefix: "fas",
    iconName: "exclamation-triangle",
    icon: [
        576,
        512,
        [],
        "f071",
        "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $36045e57d0ad82eb$export$1fe4a9976a241685 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
    ]
};
var $36045e57d0ad82eb$export$bcb8d86a3a1d6eb6 = {
    prefix: "fas",
    iconName: "expand-alt",
    icon: [
        448,
        512,
        [],
        "f424",
        "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
    ]
};
var $36045e57d0ad82eb$export$6219dcd88b5fa6c2 = {
    prefix: "fas",
    iconName: "expand-arrows-alt",
    icon: [
        448,
        512,
        [],
        "f31e",
        "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
    ]
};
var $36045e57d0ad82eb$export$d7f107e456ab0306 = {
    prefix: "fas",
    iconName: "external-link-alt",
    icon: [
        512,
        512,
        [],
        "f35d",
        "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    ]
};
var $36045e57d0ad82eb$export$e4cdf2977151ee26 = {
    prefix: "fas",
    iconName: "external-link-square-alt",
    icon: [
        448,
        512,
        [],
        "f360",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$b8c3e79e8c99c95b = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [],
        "f06e",
        "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    ]
};
var $36045e57d0ad82eb$export$1bc3e0ad56dc9eb0 = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [],
        "f1fb",
        "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
    ]
};
var $36045e57d0ad82eb$export$ed3f2918429d029a = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
    ]
};
var $36045e57d0ad82eb$export$55145a3dae4f984a = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $36045e57d0ad82eb$export$e6246a3279a379b8 = {
    prefix: "fas",
    iconName: "fast-backward",
    icon: [
        512,
        512,
        [],
        "f049",
        "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
    ]
};
var $36045e57d0ad82eb$export$61a8cdc53c2e078d = {
    prefix: "fas",
    iconName: "fast-forward",
    icon: [
        512,
        512,
        [],
        "f050",
        "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
    ]
};
var $36045e57d0ad82eb$export$a0856b225f3b0614 = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
    ]
};
var $36045e57d0ad82eb$export$b5698497901d7197 = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [],
        "f1ac",
        "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
    ]
};
var $36045e57d0ad82eb$export$5e19aea195b31816 = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [],
        "f52d",
        "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
    ]
};
var $36045e57d0ad82eb$export$68cf766c786bcd78 = {
    prefix: "fas",
    iconName: "feather-alt",
    icon: [
        512,
        512,
        [],
        "f56b",
        "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
    ]
};
var $36045e57d0ad82eb$export$70e8e75e61dd7169 = {
    prefix: "fas",
    iconName: "female",
    icon: [
        256,
        512,
        [],
        "f182",
        "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
    ]
};
var $36045e57d0ad82eb$export$102b809faf56e033 = {
    prefix: "fas",
    iconName: "fighter-jet",
    icon: [
        640,
        512,
        [],
        "f0fb",
        "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
    ]
};
var $36045e57d0ad82eb$export$cad54bead856a678 = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [],
        "f15b",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $36045e57d0ad82eb$export$243b47dca32bf0b8 = {
    prefix: "fas",
    iconName: "file-alt",
    icon: [
        384,
        512,
        [],
        "f15c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $36045e57d0ad82eb$export$bf2047a9946b5c3f = {
    prefix: "fas",
    iconName: "file-archive",
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
    ]
};
var $36045e57d0ad82eb$export$b8d24c57c9e64933 = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $36045e57d0ad82eb$export$143d0ca7d2200f20 = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
    ]
};
var $36045e57d0ad82eb$export$70fde3f3fdaa6a6a = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $36045e57d0ad82eb$export$82cea4f586f6ec9 = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $36045e57d0ad82eb$export$1013b9966d758343 = {
    prefix: "fas",
    iconName: "file-download",
    icon: [
        384,
        512,
        [],
        "f56d",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $36045e57d0ad82eb$export$77cb1a465c4fe84 = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $36045e57d0ad82eb$export$364f19abcfac1b0a = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [],
        "f56e",
        "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
    ]
};
var $36045e57d0ad82eb$export$6440b286d3cbac9b = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
    ]
};
var $36045e57d0ad82eb$export$d796c05153b1255c = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [],
        "f56f",
        "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
    ]
};
var $36045e57d0ad82eb$export$bef39294aed2281a = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
    ]
};
var $36045e57d0ad82eb$export$a3dced32d48cb1ea = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
    ]
};
var $36045e57d0ad82eb$export$56cbcd962389b090 = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
    ]
};
var $36045e57d0ad82eb$export$ef02a0f5b39aa61f = {
    prefix: "fas",
    iconName: "file-medical-alt",
    icon: [
        448,
        512,
        [],
        "f478",
        "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $36045e57d0ad82eb$export$38611f1c776aba73 = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
    ]
};
var $36045e57d0ad82eb$export$c341daeecdea449a = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
    ]
};
var $36045e57d0ad82eb$export$a20cb90865b6beb8 = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $36045e57d0ad82eb$export$d0de575ac166712b = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
    ]
};
var $36045e57d0ad82eb$export$dd55ded1264643d2 = {
    prefix: "fas",
    iconName: "file-upload",
    icon: [
        384,
        512,
        [],
        "f574",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $36045e57d0ad82eb$export$b44eb38345c6a964 = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
    ]
};
var $36045e57d0ad82eb$export$f0858dff6e769cf6 = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $36045e57d0ad82eb$export$d3c2bcfd3b861e4a = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
    ]
};
var $36045e57d0ad82eb$export$38320138fc0262d0 = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
    ]
};
var $36045e57d0ad82eb$export$c03de0cc616e77bb = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [],
        "f008",
        "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $36045e57d0ad82eb$export$f253a38d7142e29f = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    ]
};
var $36045e57d0ad82eb$export$614dc068d88655af = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
    ]
};
var $36045e57d0ad82eb$export$7b24b34ef6cc130c = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        384,
        512,
        [],
        "f06d",
        "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
    ]
};
var $36045e57d0ad82eb$export$70dc26b4926d0b1b = {
    prefix: "fas",
    iconName: "fire-alt",
    icon: [
        448,
        512,
        [],
        "f7e4",
        "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
    ]
};
var $36045e57d0ad82eb$export$d75fb6743634a0a = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        448,
        512,
        [],
        "f134",
        "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$5b01ccb2da4c4387 = {
    prefix: "fas",
    iconName: "first-aid",
    icon: [
        576,
        512,
        [],
        "f479",
        "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$24228a855c5f6812 = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [],
        "f578",
        "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$fa0323a4d7489a8d = {
    prefix: "fas",
    iconName: "fist-raised",
    icon: [
        384,
        512,
        [],
        "f6de",
        "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
    ]
};
var $36045e57d0ad82eb$export$6591b1ea509be9da = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        512,
        512,
        [],
        "f024",
        "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
    ]
};
var $36045e57d0ad82eb$export$92fad97e19a9fea = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        512,
        512,
        [],
        "f11e",
        "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
    ]
};
var $36045e57d0ad82eb$export$19357abad396e723 = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        512,
        512,
        [],
        "f74d",
        "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$f9b579ba06048af = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
    ]
};
var $36045e57d0ad82eb$export$dfd2bd012685aeac = {
    prefix: "fas",
    iconName: "flushed",
    icon: [
        496,
        512,
        [],
        "f579",
        "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
    ]
};
var $36045e57d0ad82eb$export$72b780186370e953 = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$758f1fb3784e4080 = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
    ]
};
var $36045e57d0ad82eb$export$ff7e93418af88b78 = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [],
        "f07c",
        "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
    ]
};
var $36045e57d0ad82eb$export$e18e05ffa2045d3b = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
    ]
};
var $36045e57d0ad82eb$export$a5dc297d3f60936 = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
    ]
};
var $36045e57d0ad82eb$export$6e20d421a2e0f320 = {
    prefix: "fas",
    iconName: "font-awesome-logo-full",
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var $36045e57d0ad82eb$export$e8fd664711e31704 = {
    prefix: "fas",
    iconName: "football-ball",
    icon: [
        496,
        512,
        [],
        "f44e",
        "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
    ]
};
var $36045e57d0ad82eb$export$a8710cdb23198d53 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [],
        "f04e",
        "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
    ]
};
var $36045e57d0ad82eb$export$fe2358263efac504 = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$43b7108508aecc5f = {
    prefix: "fas",
    iconName: "frown",
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
    ]
};
var $36045e57d0ad82eb$export$c4775e66bed5d96 = {
    prefix: "fas",
    iconName: "frown-open",
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$cebe38ad8f0a143d = {
    prefix: "fas",
    iconName: "funnel-dollar",
    icon: [
        640,
        512,
        [],
        "f662",
        "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
    ]
};
var $36045e57d0ad82eb$export$65a345b33858a655 = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [],
        "f1e3",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
    ]
};
var $36045e57d0ad82eb$export$6a66b1b639455bef = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
    ]
};
var $36045e57d0ad82eb$export$84666c793cb2a347 = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [],
        "f52f",
        "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
    ]
};
var $36045e57d0ad82eb$export$c36fb40057e2c3aa = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [],
        "f0e3",
        "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
    ]
};
var $36045e57d0ad82eb$export$31ee86ac717db552 = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
    ]
};
var $36045e57d0ad82eb$export$c093cc22e88981c2 = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        288,
        512,
        [],
        "f22d",
        "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
    ]
};
var $36045e57d0ad82eb$export$1a989eb1919c64c1 = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [],
        "f6e2",
        "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$b2727de8ccdbb5ec = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [],
        "f06b",
        "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $36045e57d0ad82eb$export$de9a67b55dbe819a = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
    ]
};
var $36045e57d0ad82eb$export$20007d7d74cb98fe = {
    prefix: "fas",
    iconName: "glass-cheers",
    icon: [
        640,
        512,
        [],
        "f79f",
        "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
    ]
};
var $36045e57d0ad82eb$export$e96f280e39af4a91 = {
    prefix: "fas",
    iconName: "glass-martini",
    icon: [
        512,
        512,
        [],
        "f000",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
    ]
};
var $36045e57d0ad82eb$export$2258439b8f4e7acb = {
    prefix: "fas",
    iconName: "glass-martini-alt",
    icon: [
        512,
        512,
        [],
        "f57b",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
    ]
};
var $36045e57d0ad82eb$export$fdec0f5f1a169419 = {
    prefix: "fas",
    iconName: "glass-whiskey",
    icon: [
        512,
        512,
        [],
        "f7a0",
        "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
    ]
};
var $36045e57d0ad82eb$export$58d7d709c0a8ca5f = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
    ]
};
var $36045e57d0ad82eb$export$b1b1cdce4a19c682 = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        496,
        512,
        [],
        "f0ac",
        "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
    ]
};
var $36045e57d0ad82eb$export$64af36f3b403a57c = {
    prefix: "fas",
    iconName: "globe-africa",
    icon: [
        496,
        512,
        [],
        "f57c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
    ]
};
var $36045e57d0ad82eb$export$e96bcc7bde9498db = {
    prefix: "fas",
    iconName: "globe-americas",
    icon: [
        496,
        512,
        [],
        "f57d",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
    ]
};
var $36045e57d0ad82eb$export$796fdfc909e603f4 = {
    prefix: "fas",
    iconName: "globe-asia",
    icon: [
        496,
        512,
        [],
        "f57e",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
    ]
};
var $36045e57d0ad82eb$export$5318b8ede86cc96b = {
    prefix: "fas",
    iconName: "globe-europe",
    icon: [
        496,
        512,
        [],
        "f7a2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
    ]
};
var $36045e57d0ad82eb$export$2251487a9a33c682 = {
    prefix: "fas",
    iconName: "golf-ball",
    icon: [
        416,
        512,
        [],
        "f450",
        "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
    ]
};
var $36045e57d0ad82eb$export$31f89d8ac1d14ed6 = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $36045e57d0ad82eb$export$874e305fd7920cce = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [],
        "f19d",
        "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
    ]
};
var $36045e57d0ad82eb$export$da07b6bc24a496ca = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [],
        "f531",
        "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
    ]
};
var $36045e57d0ad82eb$export$7bf8dfe2e6661a54 = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$3d08cd36ac1ef231 = {
    prefix: "fas",
    iconName: "grimace",
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
    ]
};
var $36045e57d0ad82eb$export$37e1f10b6de76621 = {
    prefix: "fas",
    iconName: "grin",
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $36045e57d0ad82eb$export$b4abebfe416d36ba = {
    prefix: "fas",
    iconName: "grin-alt",
    icon: [
        496,
        512,
        [],
        "f581",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $36045e57d0ad82eb$export$734da5249381ec7e = {
    prefix: "fas",
    iconName: "grin-beam",
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $36045e57d0ad82eb$export$14d0ccc54c5b6826 = {
    prefix: "fas",
    iconName: "grin-beam-sweat",
    icon: [
        504,
        512,
        [],
        "f583",
        "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $36045e57d0ad82eb$export$c56cf0e0c3bc5ed2 = {
    prefix: "fas",
    iconName: "grin-hearts",
    icon: [
        496,
        512,
        [],
        "f584",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
    ]
};
var $36045e57d0ad82eb$export$243ae757907b1580 = {
    prefix: "fas",
    iconName: "grin-squint",
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $36045e57d0ad82eb$export$542206d6a85f3b42 = {
    prefix: "fas",
    iconName: "grin-squint-tears",
    icon: [
        512,
        512,
        [],
        "f586",
        "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
    ]
};
var $36045e57d0ad82eb$export$64347a5c8c402ef4 = {
    prefix: "fas",
    iconName: "grin-stars",
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
    ]
};
var $36045e57d0ad82eb$export$b2f7512221512b5b = {
    prefix: "fas",
    iconName: "grin-tears",
    icon: [
        640,
        512,
        [],
        "f588",
        "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $36045e57d0ad82eb$export$ef222816a43a4b3a = {
    prefix: "fas",
    iconName: "grin-tongue",
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $36045e57d0ad82eb$export$4edf34c3def09a31 = {
    prefix: "fas",
    iconName: "grin-tongue-squint",
    icon: [
        496,
        512,
        [],
        "f58a",
        "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
    ]
};
var $36045e57d0ad82eb$export$58099903d50aefb3 = {
    prefix: "fas",
    iconName: "grin-tongue-wink",
    icon: [
        496,
        512,
        [],
        "f58b",
        "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $36045e57d0ad82eb$export$2397fcd34eb12177 = {
    prefix: "fas",
    iconName: "grin-wink",
    icon: [
        496,
        512,
        [],
        "f58c",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
    ]
};
var $36045e57d0ad82eb$export$4a45308d6c8decc1 = {
    prefix: "fas",
    iconName: "grip-horizontal",
    icon: [
        448,
        512,
        [],
        "f58d",
        "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$1412f35381064d7d = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        512,
        512,
        [],
        "f7a4",
        "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$523960de087f5198 = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        256,
        512,
        [],
        "f7a5",
        "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
    ]
};
var $36045e57d0ad82eb$export$cacbd95c283996ec = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$790dd5b32282b6fb = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
    ]
};
var $36045e57d0ad82eb$export$f08bbcf8f59eafc2 = {
    prefix: "fas",
    iconName: "h-square",
    icon: [
        448,
        512,
        [],
        "f0fd",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$bab3bb9f4f59363 = {
    prefix: "fas",
    iconName: "hamburger",
    icon: [
        512,
        512,
        [],
        "f805",
        "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
    ]
};
var $36045e57d0ad82eb$export$6310f315e1ebbca5 = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [],
        "f6e3",
        "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
    ]
};
var $36045e57d0ad82eb$export$38d20d399463edf9 = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$e6094d25274088ab = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $36045e57d0ad82eb$export$97e5ef3e80a0fbef = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $36045e57d0ad82eb$export$bb2a6b1b5e852300 = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
    ]
};
var $36045e57d0ad82eb$export$47d27bc305b59690 = {
    prefix: "fas",
    iconName: "hand-holding-usd",
    icon: [
        576,
        512,
        [],
        "f4c0",
        "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
    ]
};
var $36045e57d0ad82eb$export$4265371b99d38b95 = {
    prefix: "fas",
    iconName: "hand-holding-water",
    icon: [
        576,
        512,
        [],
        "f4c1",
        "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $36045e57d0ad82eb$export$54608d0a883fea4d = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        576,
        512,
        [],
        "f258",
        "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
    ]
};
var $36045e57d0ad82eb$export$bd40d3a3a16fb147 = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        512,
        512,
        [],
        "f806",
        "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
    ]
};
var $36045e57d0ad82eb$export$6e6216c8b50471bb = {
    prefix: "fas",
    iconName: "hand-paper",
    icon: [
        448,
        512,
        [],
        "f256",
        "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
    ]
};
var $36045e57d0ad82eb$export$e49e3cfceea441cc = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        448,
        512,
        [],
        "f25b",
        "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
    ]
};
var $36045e57d0ad82eb$export$f6dcbf0a940428f4 = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $36045e57d0ad82eb$export$b276ec3dc9760d39 = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
    ]
};
var $36045e57d0ad82eb$export$f7bc8714c970afa4 = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $36045e57d0ad82eb$export$cdc9f5e7e94e76da = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [],
        "f0a6",
        "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
    ]
};
var $36045e57d0ad82eb$export$d97ff927c450c87f = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
    ]
};
var $36045e57d0ad82eb$export$97a81eba394c8c44 = {
    prefix: "fas",
    iconName: "hand-rock",
    icon: [
        512,
        512,
        [],
        "f255",
        "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
    ]
};
var $36045e57d0ad82eb$export$c578e919f2c5c135 = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
    ]
};
var $36045e57d0ad82eb$export$72e2d874a963de0c = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
    ]
};
var $36045e57d0ad82eb$export$2262d6b626de1120 = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        512,
        512,
        [],
        "f259",
        "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
    ]
};
var $36045e57d0ad82eb$export$f9712d0cf5150f0c = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$287dbb1632da0d44 = {
    prefix: "fas",
    iconName: "hands-helping",
    icon: [
        640,
        512,
        [],
        "f4c4",
        "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
    ]
};
var $36045e57d0ad82eb$export$996b5dea53b124e3 = {
    prefix: "fas",
    iconName: "hands-wash",
    icon: [
        576,
        512,
        [],
        "e05e",
        "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
    ]
};
var $36045e57d0ad82eb$export$b4c63e9bfc7906f1 = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
    ]
};
var $36045e57d0ad82eb$export$ca302f956ae9f1bf = {
    prefix: "fas",
    iconName: "handshake-alt-slash",
    icon: [
        640,
        512,
        [],
        "e05f",
        "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
    ]
};
var $36045e57d0ad82eb$export$2cef3f81ad90fb76 = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
    ]
};
var $36045e57d0ad82eb$export$3dcd4ca3f7108a82 = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [],
        "f6e6",
        "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
    ]
};
var $36045e57d0ad82eb$export$7b72177558a98b6f = {
    prefix: "fas",
    iconName: "hard-hat",
    icon: [
        512,
        512,
        [],
        "f807",
        "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$c92c903bade56844 = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [],
        "f292",
        "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
    ]
};
var $36045e57d0ad82eb$export$37672611144b857b = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
    ]
};
var $36045e57d0ad82eb$export$ab6f71fd6878da90 = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
    ]
};
var $36045e57d0ad82eb$export$7daa48199dcb2ad1 = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
    ]
};
var $36045e57d0ad82eb$export$62551e9c5ba7093f = {
    prefix: "fas",
    iconName: "hdd",
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$3cd04b7c1624f598 = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
    ]
};
var $36045e57d0ad82eb$export$b293ee8fb8e6b0c4 = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
    ]
};
var $36045e57d0ad82eb$export$280300af4baa1a3e = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        512,
        512,
        [],
        "e063",
        "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
    ]
};
var $36045e57d0ad82eb$export$5b64b916710da7c7 = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
    ]
};
var $36045e57d0ad82eb$export$4805b8d175aeb9fb = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        512,
        512,
        [],
        "f1dc",
        "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
    ]
};
var $36045e57d0ad82eb$export$ad02dd8ca5816958 = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [],
        "f025",
        "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
    ]
};
var $36045e57d0ad82eb$export$6f0433fa527dd5be = {
    prefix: "fas",
    iconName: "headphones-alt",
    icon: [
        512,
        512,
        [],
        "f58f",
        "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
    ]
};
var $36045e57d0ad82eb$export$23b086400a31acfe = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
    ]
};
var $36045e57d0ad82eb$export$e4b51a47a2f8b9db = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [],
        "f004",
        "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
    ]
};
var $36045e57d0ad82eb$export$4a565395cb65b282 = {
    prefix: "fas",
    iconName: "heart-broken",
    icon: [
        512,
        512,
        [],
        "f7a9",
        "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $36045e57d0ad82eb$export$ca880e19206e80aa = {
    prefix: "fas",
    iconName: "heartbeat",
    icon: [
        512,
        512,
        [],
        "f21e",
        "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $36045e57d0ad82eb$export$612d3e1afaf45fa5 = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [],
        "f533",
        "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
    ]
};
var $36045e57d0ad82eb$export$73801ed54b42fabe = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        544,
        512,
        [],
        "f591",
        "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
    ]
};
var $36045e57d0ad82eb$export$b2ab0105a901499e = {
    prefix: "fas",
    iconName: "hiking",
    icon: [
        384,
        512,
        [],
        "f6ec",
        "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
    ]
};
var $36045e57d0ad82eb$export$d4c909619093de2d = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [],
        "f6ed",
        "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$76d1986559ca7b7a = {
    prefix: "fas",
    iconName: "history",
    icon: [
        512,
        512,
        [],
        "f1da",
        "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
    ]
};
var $36045e57d0ad82eb$export$a274b02dc75663dc = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
    ]
};
var $36045e57d0ad82eb$export$273296afacf93991 = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        448,
        512,
        [],
        "f7aa",
        "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
    ]
};
var $36045e57d0ad82eb$export$48f10d71ec526479 = {
    prefix: "fas",
    iconName: "home",
    icon: [
        576,
        512,
        [],
        "f015",
        "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    ]
};
var $36045e57d0ad82eb$export$5b05f097fa38352a = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [],
        "f6f0",
        "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$5bcca85203ebd1e8 = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$7a76c9d35b42d691 = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
    ]
};
var $36045e57d0ad82eb$export$cea7736417b94a3b = {
    prefix: "fas",
    iconName: "hospital-alt",
    icon: [
        576,
        512,
        [],
        "f47d",
        "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $36045e57d0ad82eb$export$c8a3c78d99c23fed = {
    prefix: "fas",
    iconName: "hospital-symbol",
    icon: [
        512,
        512,
        [],
        "f47e",
        "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
    ]
};
var $36045e57d0ad82eb$export$684703c93d630cc5 = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        640,
        512,
        [],
        "f80d",
        "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
    ]
};
var $36045e57d0ad82eb$export$4842af92b516c40b = {
    prefix: "fas",
    iconName: "hot-tub",
    icon: [
        512,
        512,
        [],
        "f593",
        "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
    ]
};
var $36045e57d0ad82eb$export$9fae219b4d3ce0be = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [],
        "f80f",
        "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
    ]
};
var $36045e57d0ad82eb$export$c402efcf01d5ca07 = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        576,
        512,
        [],
        "f594",
        "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $36045e57d0ad82eb$export$b9098a890f61e022 = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [],
        "f254",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
    ]
};
var $36045e57d0ad82eb$export$52757ecc5b1e25b9 = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [],
        "f253",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
    ]
};
var $36045e57d0ad82eb$export$703272eebf5e3eea = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [],
        "f252",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
    ]
};
var $36045e57d0ad82eb$export$f0c28584caa8f4b = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [],
        "f251",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
    ]
};
var $36045e57d0ad82eb$export$8d7e943005ce0b49 = {
    prefix: "fas",
    iconName: "house-damage",
    icon: [
        576,
        512,
        [],
        "f6f1",
        "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
    ]
};
var $36045e57d0ad82eb$export$9a513ee921e8e885 = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
    ]
};
var $36045e57d0ad82eb$export$33d5f94bd6f75f59 = {
    prefix: "fas",
    iconName: "hryvnia",
    icon: [
        384,
        512,
        [],
        "f6f2",
        "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
    ]
};
var $36045e57d0ad82eb$export$7fddf76ec23943d8 = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
    ]
};
var $36045e57d0ad82eb$export$dd52741c60cc638f = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [],
        "f810",
        "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
    ]
};
var $36045e57d0ad82eb$export$78792ed87d92a3ad = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
    ]
};
var $36045e57d0ad82eb$export$7fe2894454d8eb8a = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [],
        "f86d",
        "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
    ]
};
var $36045e57d0ad82eb$export$a75288855ea05282 = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $36045e57d0ad82eb$export$782ac893fc22249b = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
    ]
};
var $36045e57d0ad82eb$export$dc37ebbac31f6c6c = {
    prefix: "fas",
    iconName: "id-card-alt",
    icon: [
        576,
        512,
        [],
        "f47f",
        "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
    ]
};
var $36045e57d0ad82eb$export$4a284575edd6f1af = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
    ]
};
var $36045e57d0ad82eb$export$7e9f0928967e03b = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
    ]
};
var $36045e57d0ad82eb$export$74f06b41ed2ca28a = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
    ]
};
var $36045e57d0ad82eb$export$366b69cbdce46334 = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        576,
        512,
        [],
        "f01c",
        "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
    ]
};
var $36045e57d0ad82eb$export$318208bc30aeebcc = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$5548c3eb51060fa8 = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        512,
        512,
        [],
        "f275",
        "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
    ]
};
var $36045e57d0ad82eb$export$a590003279d671b8 = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [],
        "f534",
        "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
    ]
};
var $36045e57d0ad82eb$export$d469b770895f47ac = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
    ]
};
var $36045e57d0ad82eb$export$aa9288aeadf882fa = {
    prefix: "fas",
    iconName: "info-circle",
    icon: [
        512,
        512,
        [],
        "f05a",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    ]
};
var $36045e57d0ad82eb$export$16e344bae4d495ed = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        320,
        512,
        [],
        "f033",
        "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
    ]
};
var $36045e57d0ad82eb$export$859f204e59641ca4 = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
    ]
};
var $36045e57d0ad82eb$export$e5a289fb22ffb8cb = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$66a0d8d45aab6631 = {
    prefix: "fas",
    iconName: "journal-whills",
    icon: [
        448,
        512,
        [],
        "f66a",
        "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
    ]
};
var $36045e57d0ad82eb$export$ab1408bfbe914cc9 = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [],
        "f66b",
        "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
    ]
};
var $36045e57d0ad82eb$export$fa6ecc35e7315db = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [],
        "f084",
        "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
    ]
};
var $36045e57d0ad82eb$export$fb61df5d98785fa8 = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $36045e57d0ad82eb$export$8d41d1f1ba3f9217 = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [],
        "f66d",
        "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
    ]
};
var $36045e57d0ad82eb$export$c762a77aabf64fd0 = {
    prefix: "fas",
    iconName: "kiss",
    icon: [
        496,
        512,
        [],
        "f596",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$d6ff8a73c0812e63 = {
    prefix: "fas",
    iconName: "kiss-beam",
    icon: [
        496,
        512,
        [],
        "f597",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
    ]
};
var $36045e57d0ad82eb$export$ebba617701dfb917 = {
    prefix: "fas",
    iconName: "kiss-wink-heart",
    icon: [
        504,
        512,
        [],
        "f598",
        "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
    ]
};
var $36045e57d0ad82eb$export$d9933d91e1314d02 = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
    ]
};
var $36045e57d0ad82eb$export$2bebc54c51db6505 = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [],
        "f66f",
        "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$8a7bee49fdf8c954 = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
    ]
};
var $36045e57d0ad82eb$export$c2dee3bd177275a2 = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [],
        "f109",
        "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $36045e57d0ad82eb$export$94100f4c6ee29932 = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $36045e57d0ad82eb$export$efd983de5e4d6ad3 = {
    prefix: "fas",
    iconName: "laptop-house",
    icon: [
        640,
        512,
        [],
        "e066",
        "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
    ]
};
var $36045e57d0ad82eb$export$ba2fa38f7bcc6930 = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$6c74e314e801a4fe = {
    prefix: "fas",
    iconName: "laugh",
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
    ]
};
var $36045e57d0ad82eb$export$a88d1f4073ea9369 = {
    prefix: "fas",
    iconName: "laugh-beam",
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $36045e57d0ad82eb$export$b206e700cf7084e1 = {
    prefix: "fas",
    iconName: "laugh-squint",
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $36045e57d0ad82eb$export$77ac40095f39933e = {
    prefix: "fas",
    iconName: "laugh-wink",
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $36045e57d0ad82eb$export$a137712e11e257dd = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        512,
        512,
        [],
        "f5fd",
        "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
    ]
};
var $36045e57d0ad82eb$export$7c497bae2754a087 = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        576,
        512,
        [],
        "f06c",
        "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
    ]
};
var $36045e57d0ad82eb$export$4fbda8f64648f3b5 = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        512,
        512,
        [],
        "f094",
        "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
    ]
};
var $36045e57d0ad82eb$export$7f24f1bf98af5411 = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [],
        "f536",
        "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
    ]
};
var $36045e57d0ad82eb$export$b2c723344cff0d8 = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$c07eb6ff5a382cbd = {
    prefix: "fas",
    iconName: "level-down-alt",
    icon: [
        320,
        512,
        [],
        "f3be",
        "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
    ]
};
var $36045e57d0ad82eb$export$d6f21a309b179c3d = {
    prefix: "fas",
    iconName: "level-up-alt",
    icon: [
        320,
        512,
        [],
        "f3bf",
        "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
    ]
};
var $36045e57d0ad82eb$export$53dd2cacf674142a = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
    ]
};
var $36045e57d0ad82eb$export$1e80f89fe84a215b = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$88bc01ff8dbecc55 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        512,
        512,
        [],
        "f0c1",
        "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
    ]
};
var $36045e57d0ad82eb$export$f0f37dbc60110b10 = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        384,
        512,
        [],
        "f195",
        "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
    ]
};
var $36045e57d0ad82eb$export$6cfc59842fedbc16 = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [],
        "f03a",
        "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$c6327a203ffc65a3 = {
    prefix: "fas",
    iconName: "list-alt",
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
    ]
};
var $36045e57d0ad82eb$export$3db8f67cd0fc963b = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [],
        "f0cb",
        "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
    ]
};
var $36045e57d0ad82eb$export$f8a219cf4f516384 = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [],
        "f0ca",
        "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$4ac9c4c370f7b157 = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        512,
        512,
        [],
        "f124",
        "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
    ]
};
var $36045e57d0ad82eb$export$7aa08ad5d562578a = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [],
        "f023",
        "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
    ]
};
var $36045e57d0ad82eb$export$84b5acad4436d02a = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
    ]
};
var $36045e57d0ad82eb$export$8b92530ca6418c2f = {
    prefix: "fas",
    iconName: "long-arrow-alt-down",
    icon: [
        256,
        512,
        [],
        "f309",
        "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
    ]
};
var $36045e57d0ad82eb$export$a8b3226b2bf323d = {
    prefix: "fas",
    iconName: "long-arrow-alt-left",
    icon: [
        448,
        512,
        [],
        "f30a",
        "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
    ]
};
var $36045e57d0ad82eb$export$533e1f578f74c066 = {
    prefix: "fas",
    iconName: "long-arrow-alt-right",
    icon: [
        448,
        512,
        [],
        "f30b",
        "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
    ]
};
var $36045e57d0ad82eb$export$43c8f2a46326c55f = {
    prefix: "fas",
    iconName: "long-arrow-alt-up",
    icon: [
        256,
        512,
        [],
        "f30c",
        "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
    ]
};
var $36045e57d0ad82eb$export$7a65d2aa54cb4e93 = {
    prefix: "fas",
    iconName: "low-vision",
    icon: [
        576,
        512,
        [],
        "f2a8",
        "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
    ]
};
var $36045e57d0ad82eb$export$bd1e24dd3cde8514 = {
    prefix: "fas",
    iconName: "luggage-cart",
    icon: [
        640,
        512,
        [],
        "f59d",
        "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
    ]
};
var $36045e57d0ad82eb$export$ba9b387e84727819 = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [],
        "f604",
        "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
    ]
};
var $36045e57d0ad82eb$export$895159d10626af74 = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
    ]
};
var $36045e57d0ad82eb$export$e58f9b502d4dd52d = {
    prefix: "fas",
    iconName: "magic",
    icon: [
        512,
        512,
        [],
        "f0d0",
        "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
    ]
};
var $36045e57d0ad82eb$export$78932e9c9abea6b7 = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        512,
        512,
        [],
        "f076",
        "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
    ]
};
var $36045e57d0ad82eb$export$dd24f40c5337e2e1 = {
    prefix: "fas",
    iconName: "mail-bulk",
    icon: [
        576,
        512,
        [],
        "f674",
        "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
    ]
};
var $36045e57d0ad82eb$export$2e21f9dba1630651 = {
    prefix: "fas",
    iconName: "male",
    icon: [
        192,
        512,
        [],
        "f183",
        "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$fc82fb79180cd17c = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [],
        "f279",
        "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $36045e57d0ad82eb$export$df04458e7e32352c = {
    prefix: "fas",
    iconName: "map-marked",
    icon: [
        576,
        512,
        [],
        "f59f",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $36045e57d0ad82eb$export$a977d47c74d8e86c = {
    prefix: "fas",
    iconName: "map-marked-alt",
    icon: [
        576,
        512,
        [],
        "f5a0",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $36045e57d0ad82eb$export$10d360e4f1a554dd = {
    prefix: "fas",
    iconName: "map-marker",
    icon: [
        384,
        512,
        [],
        "f041",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
    ]
};
var $36045e57d0ad82eb$export$4be92fa780613f93 = {
    prefix: "fas",
    iconName: "map-marker-alt",
    icon: [
        384,
        512,
        [],
        "f3c5",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    ]
};
var $36045e57d0ad82eb$export$184725965b3402dc = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        288,
        512,
        [],
        "f276",
        "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
    ]
};
var $36045e57d0ad82eb$export$743f4b1071b3333a = {
    prefix: "fas",
    iconName: "map-signs",
    icon: [
        512,
        512,
        [],
        "f277",
        "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$e6789173649caa25 = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
    ]
};
var $36045e57d0ad82eb$export$a9f5c0b9c1e77a6f = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        384,
        512,
        [],
        "f222",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $36045e57d0ad82eb$export$2f8a28204bb4b86f = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        512,
        512,
        [],
        "f227",
        "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
    ]
};
var $36045e57d0ad82eb$export$aa05fce255a5d269 = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        384,
        512,
        [],
        "f229",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $36045e57d0ad82eb$export$5cb0daeafbcdabe3 = {
    prefix: "fas",
    iconName: "mars-stroke-h",
    icon: [
        480,
        512,
        [],
        "f22b",
        "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $36045e57d0ad82eb$export$ed7aa1c25104f333 = {
    prefix: "fas",
    iconName: "mars-stroke-v",
    icon: [
        288,
        512,
        [],
        "f22a",
        "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $36045e57d0ad82eb$export$7b028758c03b9655 = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        640,
        512,
        [],
        "f6fa",
        "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
    ]
};
var $36045e57d0ad82eb$export$b48a5be96314835a = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [],
        "f5a2",
        "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
    ]
};
var $36045e57d0ad82eb$export$e75f02bae5b7d34b = {
    prefix: "fas",
    iconName: "medkit",
    icon: [
        512,
        512,
        [],
        "f0fa",
        "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
    ]
};
var $36045e57d0ad82eb$export$6d2db489aaeeecd2 = {
    prefix: "fas",
    iconName: "meh",
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$e945435725f71e88 = {
    prefix: "fas",
    iconName: "meh-blank",
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$fdc62a1bea767cc2 = {
    prefix: "fas",
    iconName: "meh-rolling-eyes",
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
    ]
};
var $36045e57d0ad82eb$export$5f9bd9f6df021f93 = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        640,
        512,
        [],
        "f538",
        "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
    ]
};
var $36045e57d0ad82eb$export$232452c59d77c56e = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
    ]
};
var $36045e57d0ad82eb$export$e134ecd00b622a47 = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        288,
        512,
        [],
        "f223",
        "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $36045e57d0ad82eb$export$1439f0d6365138da = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [],
        "f753",
        "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
    ]
};
var $36045e57d0ad82eb$export$4a7bb4be15f35178 = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
    ]
};
var $36045e57d0ad82eb$export$eed3c491effe6d12 = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        352,
        512,
        [],
        "f130",
        "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$f08ef94fea14f5ac = {
    prefix: "fas",
    iconName: "microphone-alt",
    icon: [
        352,
        512,
        [],
        "f3c9",
        "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
    ]
};
var $36045e57d0ad82eb$export$d2a53a388f30780 = {
    prefix: "fas",
    iconName: "microphone-alt-slash",
    icon: [
        640,
        512,
        [],
        "f539",
        "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$843f63d64e6f7951 = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$6a99139787bf9967 = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [],
        "f610",
        "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
    ]
};
var $36045e57d0ad82eb$export$fee0376c250cdef = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [],
        "f068",
        "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$f3979b49bf57313c = {
    prefix: "fas",
    iconName: "minus-circle",
    icon: [
        512,
        512,
        [],
        "f056",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
    ]
};
var $36045e57d0ad82eb$export$ffe9387966b3e681 = {
    prefix: "fas",
    iconName: "minus-square",
    icon: [
        448,
        512,
        [],
        "f146",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
    ]
};
var $36045e57d0ad82eb$export$5030322c5fc886d7 = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
    ]
};
var $36045e57d0ad82eb$export$59edacfad04cd121 = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        320,
        512,
        [],
        "f10b",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$e9599bc6cd92234d = {
    prefix: "fas",
    iconName: "mobile-alt",
    icon: [
        320,
        512,
        [],
        "f3cd",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
    ]
};
var $36045e57d0ad82eb$export$608138a7337b5d1a = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        640,
        512,
        [],
        "f0d6",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $36045e57d0ad82eb$export$a35d573395884c3d = {
    prefix: "fas",
    iconName: "money-bill-alt",
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $36045e57d0ad82eb$export$53e23123cc9a6796 = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        640,
        512,
        [],
        "f53a",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
    ]
};
var $36045e57d0ad82eb$export$1613858e873cbb3e = {
    prefix: "fas",
    iconName: "money-bill-wave-alt",
    icon: [
        640,
        512,
        [],
        "f53b",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
    ]
};
var $36045e57d0ad82eb$export$be069f641c85d0b3 = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        640,
        512,
        [],
        "f53c",
        "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$8c6ccc9745897cb2 = {
    prefix: "fas",
    iconName: "money-check-alt",
    icon: [
        640,
        512,
        [],
        "f53d",
        "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
    ]
};
var $36045e57d0ad82eb$export$6f9b0bfc012deb25 = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $36045e57d0ad82eb$export$c4c2f69a53bab720 = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        512,
        512,
        [],
        "f186",
        "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
    ]
};
var $36045e57d0ad82eb$export$55ceb5d0c144580a = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$4999586d7e1087fb = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [],
        "f678",
        "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
    ]
};
var $36045e57d0ad82eb$export$f26017bdca99338d = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [],
        "f21c",
        "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
    ]
};
var $36045e57d0ad82eb$export$64f9eb99c9749cce = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        640,
        512,
        [],
        "f6fc",
        "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
    ]
};
var $36045e57d0ad82eb$export$198b96b894c66074 = {
    prefix: "fas",
    iconName: "mouse",
    icon: [
        384,
        512,
        [],
        "f8cc",
        "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
    ]
};
var $36045e57d0ad82eb$export$2e19a69cc26b147 = {
    prefix: "fas",
    iconName: "mouse-pointer",
    icon: [
        320,
        512,
        [],
        "f245",
        "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
    ]
};
var $36045e57d0ad82eb$export$47a822c30184e8af = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [],
        "f7b6",
        "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$fcb0647a5340b5b8 = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [],
        "f001",
        "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
    ]
};
var $36045e57d0ad82eb$export$882cabd11f4943b8 = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
    ]
};
var $36045e57d0ad82eb$export$771cf879fba0cf93 = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        288,
        512,
        [],
        "f22c",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $36045e57d0ad82eb$export$d91b374112d4f8c1 = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
    ]
};
var $36045e57d0ad82eb$export$6a15ccae09bbaf93 = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
    ]
};
var $36045e57d0ad82eb$export$b2d79133c81d6697 = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        384,
        512,
        [],
        "f481",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
    ]
};
var $36045e57d0ad82eb$export$40cdac24aa94a57a = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        512,
        512,
        [],
        "f247",
        "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
    ]
};
var $36045e57d0ad82eb$export$887f6345573abcac = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        576,
        512,
        [],
        "f248",
        "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
    ]
};
var $36045e57d0ad82eb$export$2599126c3a57f727 = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
    ]
};
var $36045e57d0ad82eb$export$8de8eb94230028a5 = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [],
        "f679",
        "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
    ]
};
var $36045e57d0ad82eb$export$743cce3ca4eb1d7d = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [],
        "f700",
        "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
    ]
};
var $36045e57d0ad82eb$export$e21cfc4f23776bff = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [],
        "f03b",
        "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$e1611f373a10a98c = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [],
        "f815",
        "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
    ]
};
var $36045e57d0ad82eb$export$594db3339e212bc9 = {
    prefix: "fas",
    iconName: "paint-brush",
    icon: [
        512,
        512,
        [],
        "f1fc",
        "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
    ]
};
var $36045e57d0ad82eb$export$d1de8d1b815d6a5 = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
    ]
};
var $36045e57d0ad82eb$export$5c390baea5db4f77 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [],
        "f53f",
        "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$d7ff2047dbc34562 = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
    ]
};
var $36045e57d0ad82eb$export$b5378818301da1be = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
    ]
};
var $36045e57d0ad82eb$export$4b24ca1552f410af = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [],
        "f0c6",
        "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    ]
};
var $36045e57d0ad82eb$export$ca9e3368f1d9500a = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
    ]
};
var $36045e57d0ad82eb$export$dec46f8df1860e0 = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [],
        "f1dd",
        "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
    ]
};
var $36045e57d0ad82eb$export$fda29c8f99573a4e = {
    prefix: "fas",
    iconName: "parking",
    icon: [
        448,
        512,
        [],
        "f540",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$2c31ca0d9bee400f = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
    ]
};
var $36045e57d0ad82eb$export$733efdaec97447be = {
    prefix: "fas",
    iconName: "pastafarianism",
    icon: [
        640,
        512,
        [],
        "f67b",
        "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
    ]
};
var $36045e57d0ad82eb$export$6f95f90dd1f6d86b = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        448,
        512,
        [],
        "f0ea",
        "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
    ]
};
var $36045e57d0ad82eb$export$da79f048408b1722 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        448,
        512,
        [],
        "f04c",
        "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
    ]
};
var $36045e57d0ad82eb$export$d8cf08a0362da8db = {
    prefix: "fas",
    iconName: "pause-circle",
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
    ]
};
var $36045e57d0ad82eb$export$7bc6e4d977673e69 = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
    ]
};
var $36045e57d0ad82eb$export$8614cb1326eacd7a = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        496,
        512,
        [],
        "f67c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
    ]
};
var $36045e57d0ad82eb$export$8f4567331fb0d3bc = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [],
        "f304",
        "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
    ]
};
var $36045e57d0ad82eb$export$a3d3e92e430d3beb = {
    prefix: "fas",
    iconName: "pen-alt",
    icon: [
        512,
        512,
        [],
        "f305",
        "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
    ]
};
var $36045e57d0ad82eb$export$8bdfe14ac72a8b17 = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [],
        "f5ac",
        "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
    ]
};
var $36045e57d0ad82eb$export$a82594dcc75a49f5 = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [],
        "f5ad",
        "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
    ]
};
var $36045e57d0ad82eb$export$fbb231ccb3d960bc = {
    prefix: "fas",
    iconName: "pen-square",
    icon: [
        448,
        512,
        [],
        "f14b",
        "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
    ]
};
var $36045e57d0ad82eb$export$8210adc172262df = {
    prefix: "fas",
    iconName: "pencil-alt",
    icon: [
        512,
        512,
        [],
        "f303",
        "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    ]
};
var $36045e57d0ad82eb$export$e3a7a1affea005f5 = {
    prefix: "fas",
    iconName: "pencil-ruler",
    icon: [
        512,
        512,
        [],
        "f5ae",
        "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
    ]
};
var $36045e57d0ad82eb$export$804bfc5c390e1a2a = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        576,
        512,
        [],
        "e068",
        "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
    ]
};
var $36045e57d0ad82eb$export$35fbd4ff1265acd5 = {
    prefix: "fas",
    iconName: "people-carry",
    icon: [
        640,
        512,
        [],
        "f4ce",
        "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
    ]
};
var $36045e57d0ad82eb$export$4894bf28f771e1f3 = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [],
        "f816",
        "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
    ]
};
var $36045e57d0ad82eb$export$89a1764fbb7ad2cb = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        448,
        512,
        [],
        "f295",
        "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
    ]
};
var $36045e57d0ad82eb$export$89333857fc063a2e = {
    prefix: "fas",
    iconName: "percentage",
    icon: [
        384,
        512,
        [],
        "f541",
        "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
    ]
};
var $36045e57d0ad82eb$export$2337c975289bdd84 = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$ddab067855cf34cb = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [],
        "f095",
        "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    ]
};
var $36045e57d0ad82eb$export$a07a9b305deebf32 = {
    prefix: "fas",
    iconName: "phone-alt",
    icon: [
        512,
        512,
        [],
        "f879",
        "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
    ]
};
var $36045e57d0ad82eb$export$4c60a3aade08b6c2 = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $36045e57d0ad82eb$export$8ba22605a641ebdf = {
    prefix: "fas",
    iconName: "phone-square",
    icon: [
        448,
        512,
        [],
        "f098",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
    ]
};
var $36045e57d0ad82eb$export$a41e77f0de98bba7 = {
    prefix: "fas",
    iconName: "phone-square-alt",
    icon: [
        448,
        512,
        [],
        "f87b",
        "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
    ]
};
var $36045e57d0ad82eb$export$c377f240bb8b5d74 = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        384,
        512,
        [],
        "f2a0",
        "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
    ]
};
var $36045e57d0ad82eb$export$739f6a6a12dfb6ed = {
    prefix: "fas",
    iconName: "photo-video",
    icon: [
        640,
        512,
        [],
        "f87c",
        "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
    ]
};
var $36045e57d0ad82eb$export$46d49a6734c4872a = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
    ]
};
var $36045e57d0ad82eb$export$6380e2ed6e69d350 = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
    ]
};
var $36045e57d0ad82eb$export$c9f93c4667edc585 = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $36045e57d0ad82eb$export$c5a9302c8c13c79a = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
    ]
};
var $36045e57d0ad82eb$export$f654c69e66b466c0 = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
    ]
};
var $36045e57d0ad82eb$export$9b2dbe133273f284 = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [],
        "f5af",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
    ]
};
var $36045e57d0ad82eb$export$6ccbeeccfea6dc8a = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [],
        "f5b0",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
    ]
};
var $36045e57d0ad82eb$export$cfee4df0d5df6d21 = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
    ]
};
var $36045e57d0ad82eb$export$436587205947bca5 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        448,
        512,
        [],
        "f04b",
        "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
    ]
};
var $36045e57d0ad82eb$export$cf04333781061c5e = {
    prefix: "fas",
    iconName: "play-circle",
    icon: [
        512,
        512,
        [],
        "f144",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
    ]
};
var $36045e57d0ad82eb$export$cae5752c3e3b6545 = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [],
        "f1e6",
        "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
    ]
};
var $36045e57d0ad82eb$export$a105e7b44ca0eb9e = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [],
        "f067",
        "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$d9cc3a81499af48c = {
    prefix: "fas",
    iconName: "plus-circle",
    icon: [
        512,
        512,
        [],
        "f055",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $36045e57d0ad82eb$export$b6359eebfe900c35 = {
    prefix: "fas",
    iconName: "plus-square",
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $36045e57d0ad82eb$export$5c0b4709125e92f8 = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
    ]
};
var $36045e57d0ad82eb$export$bc8ca14ab51f93db = {
    prefix: "fas",
    iconName: "poll",
    icon: [
        448,
        512,
        [],
        "f681",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
    ]
};
var $36045e57d0ad82eb$export$456a238f0144d430 = {
    prefix: "fas",
    iconName: "poll-h",
    icon: [
        448,
        512,
        [],
        "f682",
        "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
    ]
};
var $36045e57d0ad82eb$export$dd0ede1713d2d2f9 = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [],
        "f2fe",
        "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$48a38da471b097a2 = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [],
        "f75a",
        "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
    ]
};
var $36045e57d0ad82eb$export$bb45b6b87d1adf27 = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
    ]
};
var $36045e57d0ad82eb$export$e3d25f819c7ee7d7 = {
    prefix: "fas",
    iconName: "portrait",
    icon: [
        384,
        512,
        [],
        "f3e0",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $36045e57d0ad82eb$export$9ce041dfec8319b = {
    prefix: "fas",
    iconName: "pound-sign",
    icon: [
        320,
        512,
        [],
        "f154",
        "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
    ]
};
var $36045e57d0ad82eb$export$a1cca9928dcf9798 = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [],
        "f011",
        "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
    ]
};
var $36045e57d0ad82eb$export$3b32c982141cad51 = {
    prefix: "fas",
    iconName: "pray",
    icon: [
        384,
        512,
        [],
        "f683",
        "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
    ]
};
var $36045e57d0ad82eb$export$95e08e91b0929943 = {
    prefix: "fas",
    iconName: "praying-hands",
    icon: [
        640,
        512,
        [],
        "f684",
        "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
    ]
};
var $36045e57d0ad82eb$export$8767bafb19515ee4 = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        384,
        512,
        [],
        "f5b1",
        "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
    ]
};
var $36045e57d0ad82eb$export$214f9ce665590486 = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$65d1c884b8581d1a = {
    prefix: "fas",
    iconName: "prescription-bottle-alt",
    icon: [
        384,
        512,
        [],
        "f486",
        "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
    ]
};
var $36045e57d0ad82eb$export$ae64371e02ee8e56 = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [],
        "f02f",
        "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$5f9e1870e1866dde = {
    prefix: "fas",
    iconName: "procedures",
    icon: [
        640,
        512,
        [],
        "f487",
        "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var $36045e57d0ad82eb$export$30bf9f5b96509df1 = {
    prefix: "fas",
    iconName: "project-diagram",
    icon: [
        640,
        512,
        [],
        "f542",
        "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$f1b881c73328720c = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        384,
        512,
        [],
        "e06a",
        "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
    ]
};
var $36045e57d0ad82eb$export$821aeede187f23c9 = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        384,
        512,
        [],
        "e06b",
        "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
    ]
};
var $36045e57d0ad82eb$export$7ee0dbd1e92e2859 = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        576,
        512,
        [],
        "f12e",
        "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
    ]
};
var $36045e57d0ad82eb$export$fc19ca0fe15e73bc = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
    ]
};
var $36045e57d0ad82eb$export$d96973f90e8f6e47 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        384,
        512,
        [],
        "f128",
        "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
    ]
};
var $36045e57d0ad82eb$export$5ba67d7f2265c1a5 = {
    prefix: "fas",
    iconName: "question-circle",
    icon: [
        512,
        512,
        [],
        "f059",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
    ]
};
var $36045e57d0ad82eb$export$c00c446e6db1605f = {
    prefix: "fas",
    iconName: "quidditch",
    icon: [
        640,
        512,
        [],
        "f458",
        "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
    ]
};
var $36045e57d0ad82eb$export$932a67a1b1a7a724 = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        512,
        512,
        [],
        "f10d",
        "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$54e3a80c9875b74c = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        512,
        512,
        [],
        "f10e",
        "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$46f29ea84ed4c5f1 = {
    prefix: "fas",
    iconName: "quran",
    icon: [
        448,
        512,
        [],
        "f687",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $36045e57d0ad82eb$export$4c4e509518093d6d = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        496,
        512,
        [],
        "f7b9",
        "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
    ]
};
var $36045e57d0ad82eb$export$2f048fa82bbddf6f = {
    prefix: "fas",
    iconName: "radiation-alt",
    icon: [
        496,
        512,
        [],
        "f7ba",
        "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $36045e57d0ad82eb$export$92ab27739d3a91b2 = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        576,
        512,
        [],
        "f75b",
        "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
    ]
};
var $36045e57d0ad82eb$export$8357bf8cc666d5f0 = {
    prefix: "fas",
    iconName: "random",
    icon: [
        512,
        512,
        [],
        "f074",
        "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
    ]
};
var $36045e57d0ad82eb$export$32b0cd6133c2742 = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [],
        "f543",
        "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
    ]
};
var $36045e57d0ad82eb$export$fe2d5012d9982673 = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
    ]
};
var $36045e57d0ad82eb$export$a65c441f12cb6bd = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [],
        "f1b8",
        "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
    ]
};
var $36045e57d0ad82eb$export$3d9f98aa1c24c776 = {
    prefix: "fas",
    iconName: "redo",
    icon: [
        512,
        512,
        [],
        "f01e",
        "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
    ]
};
var $36045e57d0ad82eb$export$50c037520c6cfdc1 = {
    prefix: "fas",
    iconName: "redo-alt",
    icon: [
        512,
        512,
        [],
        "f2f9",
        "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
    ]
};
var $36045e57d0ad82eb$export$5f519e9ac15ab8c3 = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [],
        "f25d",
        "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
    ]
};
var $36045e57d0ad82eb$export$d91179f327329532 = {
    prefix: "fas",
    iconName: "remove-format",
    icon: [
        640,
        512,
        [],
        "f87d",
        "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
    ]
};
var $36045e57d0ad82eb$export$bb06d4a7bb6736fe = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [],
        "f3e5",
        "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
    ]
};
var $36045e57d0ad82eb$export$ca6fd367f31ecbc5 = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [],
        "f122",
        "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
    ]
};
var $36045e57d0ad82eb$export$929518bb4b66a588 = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$5fbcef35138741a5 = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
    ]
};
var $36045e57d0ad82eb$export$cebc76f79478e40e = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        640,
        512,
        [],
        "f079",
        "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
    ]
};
var $36045e57d0ad82eb$export$838459d11f3971df = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [],
        "f4d6",
        "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
    ]
};
var $36045e57d0ad82eb$export$a95486586631edc7 = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
    ]
};
var $36045e57d0ad82eb$export$f224567a4851a5e9 = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [],
        "f018",
        "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
    ]
};
var $36045e57d0ad82eb$export$30a5bb4ad3fa716c = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [],
        "f544",
        "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
    ]
};
var $36045e57d0ad82eb$export$b24d84ed5657d89a = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
    ]
};
var $36045e57d0ad82eb$export$806c0a45a7ecd6e8 = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$7329a1ca27b90c5b = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [],
        "f09e",
        "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
    ]
};
var $36045e57d0ad82eb$export$89c9b1cca2c11484 = {
    prefix: "fas",
    iconName: "rss-square",
    icon: [
        448,
        512,
        [],
        "f143",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
    ]
};
var $36045e57d0ad82eb$export$1ae0a94c8ba4131a = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [],
        "f158",
        "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
    ]
};
var $36045e57d0ad82eb$export$8e90575265a56cfc = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        640,
        512,
        [],
        "f545",
        "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
    ]
};
var $36045e57d0ad82eb$export$613f406c1b5802a8 = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$46c6347bff3e04a = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        576,
        512,
        [],
        "f547",
        "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$a6ad5df9d9f29553 = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
    ]
};
var $36045e57d0ad82eb$export$5dfd1cb43dc9eadb = {
    prefix: "fas",
    iconName: "running",
    icon: [
        416,
        512,
        [],
        "f70c",
        "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
    ]
};
var $36045e57d0ad82eb$export$8bf9e3f7f57d486a = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        320,
        512,
        [],
        "f156",
        "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
    ]
};
var $36045e57d0ad82eb$export$8e924e6bd422cef9 = {
    prefix: "fas",
    iconName: "sad-cry",
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
    ]
};
var $36045e57d0ad82eb$export$4b5241926f692f91 = {
    prefix: "fas",
    iconName: "sad-tear",
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
    ]
};
var $36045e57d0ad82eb$export$da3f1730d013e224 = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [],
        "f7bf",
        "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
    ]
};
var $36045e57d0ad82eb$export$219ccae0e4da3c92 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [],
        "f7c0",
        "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
    ]
};
var $36045e57d0ad82eb$export$1aaa83ff70706e1e = {
    prefix: "fas",
    iconName: "save",
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
    ]
};
var $36045e57d0ad82eb$export$51e9b8434982947d = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [],
        "f549",
        "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$7484ff654cd6474f = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [],
        "f54a",
        "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
    ]
};
var $36045e57d0ad82eb$export$7c265716d4399676 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        640,
        512,
        [],
        "f70e",
        "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
    ]
};
var $36045e57d0ad82eb$export$303efb6031da122 = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
    ]
};
var $36045e57d0ad82eb$export$871a78837687ffe8 = {
    prefix: "fas",
    iconName: "search",
    icon: [
        512,
        512,
        [],
        "f002",
        "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    ]
};
var $36045e57d0ad82eb$export$65b49a6767630708 = {
    prefix: "fas",
    iconName: "search-dollar",
    icon: [
        512,
        512,
        [],
        "f688",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
    ]
};
var $36045e57d0ad82eb$export$c33aba6c251a898a = {
    prefix: "fas",
    iconName: "search-location",
    icon: [
        512,
        512,
        [],
        "f689",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$efca97eef6a7a17d = {
    prefix: "fas",
    iconName: "search-minus",
    icon: [
        512,
        512,
        [],
        "f010",
        "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $36045e57d0ad82eb$export$378f00e6b1a8185 = {
    prefix: "fas",
    iconName: "search-plus",
    icon: [
        512,
        512,
        [],
        "f00e",
        "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $36045e57d0ad82eb$export$d7b60b8dbd03cfe4 = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [],
        "f4d8",
        "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
    ]
};
var $36045e57d0ad82eb$export$1bf820d499b6202e = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$b17d50542d1fc340 = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [],
        "f61f",
        "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
    ]
};
var $36045e57d0ad82eb$export$c08b4b0e2b0dc027 = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [],
        "f064",
        "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
    ]
};
var $36045e57d0ad82eb$export$f8e8bb0b3aa8c658 = {
    prefix: "fas",
    iconName: "share-alt",
    icon: [
        448,
        512,
        [],
        "f1e0",
        "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
    ]
};
var $36045e57d0ad82eb$export$3799c2d8fd7e493b = {
    prefix: "fas",
    iconName: "share-alt-square",
    icon: [
        448,
        512,
        [],
        "f1e1",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
    ]
};
var $36045e57d0ad82eb$export$ae9e1434571f373c = {
    prefix: "fas",
    iconName: "share-square",
    icon: [
        576,
        512,
        [],
        "f14d",
        "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
    ]
};
var $36045e57d0ad82eb$export$3570be7b68efb8db = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [],
        "f20b",
        "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$d6508d18a824f291 = {
    prefix: "fas",
    iconName: "shield-alt",
    icon: [
        512,
        512,
        [],
        "f3ed",
        "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
    ]
};
var $36045e57d0ad82eb$export$bea811bbf570f05a = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
    ]
};
var $36045e57d0ad82eb$export$6c645741140616af = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        640,
        512,
        [],
        "f21a",
        "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
    ]
};
var $36045e57d0ad82eb$export$5e419f47aaeb3c05 = {
    prefix: "fas",
    iconName: "shipping-fast",
    icon: [
        640,
        512,
        [],
        "f48b",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $36045e57d0ad82eb$export$cdbdd2118099ae07 = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
    ]
};
var $36045e57d0ad82eb$export$5745f8adbc11eb01 = {
    prefix: "fas",
    iconName: "shopping-bag",
    icon: [
        448,
        512,
        [],
        "f290",
        "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$ca6d443595a6578f = {
    prefix: "fas",
    iconName: "shopping-basket",
    icon: [
        576,
        512,
        [],
        "f291",
        "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
    ]
};
var $36045e57d0ad82eb$export$51da406e5aa1388c = {
    prefix: "fas",
    iconName: "shopping-cart",
    icon: [
        576,
        512,
        [],
        "f07a",
        "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
    ]
};
var $36045e57d0ad82eb$export$f7f7c15f18cc19a1 = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [],
        "f2cc",
        "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
    ]
};
var $36045e57d0ad82eb$export$9d63d851db698c09 = {
    prefix: "fas",
    iconName: "shuttle-van",
    icon: [
        640,
        512,
        [],
        "f5b6",
        "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
    ]
};
var $36045e57d0ad82eb$export$d21d0d6c8e9e8bf9 = {
    prefix: "fas",
    iconName: "sign",
    icon: [
        512,
        512,
        [],
        "f4d9",
        "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
    ]
};
var $36045e57d0ad82eb$export$e6709746115bd2ea = {
    prefix: "fas",
    iconName: "sign-in-alt",
    icon: [
        512,
        512,
        [],
        "f2f6",
        "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
    ]
};
var $36045e57d0ad82eb$export$20993813350f9671 = {
    prefix: "fas",
    iconName: "sign-language",
    icon: [
        448,
        512,
        [],
        "f2a7",
        "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
    ]
};
var $36045e57d0ad82eb$export$c844d6923b7096c2 = {
    prefix: "fas",
    iconName: "sign-out-alt",
    icon: [
        512,
        512,
        [],
        "f2f5",
        "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    ]
};
var $36045e57d0ad82eb$export$79046b073b6c584d = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [],
        "f012",
        "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$afa7b53ac8ebcb5d = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
    ]
};
var $36045e57d0ad82eb$export$3bee83bf278fddbe = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
    ]
};
var $36045e57d0ad82eb$export$2a9dda2096ce792e = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
    ]
};
var $36045e57d0ad82eb$export$b2ce5e79d0eccaf8 = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        640,
        512,
        [],
        "f0e8",
        "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$21bd1d54bd4f2c5a = {
    prefix: "fas",
    iconName: "skating",
    icon: [
        448,
        512,
        [],
        "f7c5",
        "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $36045e57d0ad82eb$export$eae1acab6fb96708 = {
    prefix: "fas",
    iconName: "skiing",
    icon: [
        512,
        512,
        [],
        "f7c9",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
    ]
};
var $36045e57d0ad82eb$export$6ea48260d7d09b1b = {
    prefix: "fas",
    iconName: "skiing-nordic",
    icon: [
        576,
        512,
        [],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
    ]
};
var $36045e57d0ad82eb$export$138b45e2afb1dfa4 = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [],
        "f54c",
        "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
    ]
};
var $36045e57d0ad82eb$export$8717352b90217272 = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [],
        "f714",
        "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
    ]
};
var $36045e57d0ad82eb$export$f54d004dd5f1cb5e = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
    ]
};
var $36045e57d0ad82eb$export$26a8fd1143d2d6c0 = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
    ]
};
var $36045e57d0ad82eb$export$94d4dcb523f95563 = {
    prefix: "fas",
    iconName: "sliders-h",
    icon: [
        512,
        512,
        [],
        "f1de",
        "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$c632b2334f0913bc = {
    prefix: "fas",
    iconName: "smile",
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
    ]
};
var $36045e57d0ad82eb$export$54ada6dc9690e0ca = {
    prefix: "fas",
    iconName: "smile-beam",
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
    ]
};
var $36045e57d0ad82eb$export$f5dbb37f6801ee3f = {
    prefix: "fas",
    iconName: "smile-wink",
    icon: [
        496,
        512,
        [],
        "f4da",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
    ]
};
var $36045e57d0ad82eb$export$aa11b8edb09fed14 = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
    ]
};
var $36045e57d0ad82eb$export$c4ab83701fc591a5 = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [],
        "f48d",
        "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
    ]
};
var $36045e57d0ad82eb$export$e50452a49dec29f = {
    prefix: "fas",
    iconName: "smoking-ban",
    icon: [
        512,
        512,
        [],
        "f54d",
        "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
    ]
};
var $36045e57d0ad82eb$export$9dbcc3443daa7323 = {
    prefix: "fas",
    iconName: "sms",
    icon: [
        512,
        512,
        [],
        "f7cd",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
    ]
};
var $36045e57d0ad82eb$export$72683772d587302a = {
    prefix: "fas",
    iconName: "snowboarding",
    icon: [
        512,
        512,
        [],
        "f7ce",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
    ]
};
var $36045e57d0ad82eb$export$bab8f3647c394f48 = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
    ]
};
var $36045e57d0ad82eb$export$b23df6bafb174693 = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [],
        "f7d0",
        "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$695fae58f55c3a87 = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$64f1c53b21f310ac = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [],
        "e06e",
        "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
    ]
};
var $36045e57d0ad82eb$export$8d36a54dbf1e6bce = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [],
        "f696",
        "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
    ]
};
var $36045e57d0ad82eb$export$b9c649c5e37017f3 = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
    ]
};
var $36045e57d0ad82eb$export$4941c5969d5399b = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [],
        "f0dc",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
    ]
};
var $36045e57d0ad82eb$export$7658045270aafde3 = {
    prefix: "fas",
    iconName: "sort-alpha-down",
    icon: [
        448,
        512,
        [],
        "f15d",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $36045e57d0ad82eb$export$e12d23d82d5c8a89 = {
    prefix: "fas",
    iconName: "sort-alpha-down-alt",
    icon: [
        448,
        512,
        [],
        "f881",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $36045e57d0ad82eb$export$3c4115b156be730d = {
    prefix: "fas",
    iconName: "sort-alpha-up",
    icon: [
        448,
        512,
        [],
        "f15e",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $36045e57d0ad82eb$export$95ef20828693fb0f = {
    prefix: "fas",
    iconName: "sort-alpha-up-alt",
    icon: [
        448,
        512,
        [],
        "f882",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $36045e57d0ad82eb$export$4b2a02d50e417b5f = {
    prefix: "fas",
    iconName: "sort-amount-down",
    icon: [
        512,
        512,
        [],
        "f160",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$e7d80d8c226cb77 = {
    prefix: "fas",
    iconName: "sort-amount-down-alt",
    icon: [
        512,
        512,
        [],
        "f884",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $36045e57d0ad82eb$export$28ef3e933e4b5364 = {
    prefix: "fas",
    iconName: "sort-amount-up",
    icon: [
        512,
        512,
        [],
        "f161",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$6e87844b0f151b6a = {
    prefix: "fas",
    iconName: "sort-amount-up-alt",
    icon: [
        512,
        512,
        [],
        "f885",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
    ]
};
var $36045e57d0ad82eb$export$58e2577a373e7d4 = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [],
        "f0dd",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    ]
};
var $36045e57d0ad82eb$export$835db7eb35b3c29b = {
    prefix: "fas",
    iconName: "sort-numeric-down",
    icon: [
        448,
        512,
        [],
        "f162",
        "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $36045e57d0ad82eb$export$857385fda7a5a98e = {
    prefix: "fas",
    iconName: "sort-numeric-down-alt",
    icon: [
        448,
        512,
        [],
        "f886",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $36045e57d0ad82eb$export$d213a3ba3cabed48 = {
    prefix: "fas",
    iconName: "sort-numeric-up",
    icon: [
        448,
        512,
        [],
        "f163",
        "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
    ]
};
var $36045e57d0ad82eb$export$d41859f1bbb9e086 = {
    prefix: "fas",
    iconName: "sort-numeric-up-alt",
    icon: [
        448,
        512,
        [],
        "f887",
        "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $36045e57d0ad82eb$export$f9dd5b1410e95035 = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [],
        "f0de",
        "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
    ]
};
var $36045e57d0ad82eb$export$f9a38ef7b046ab51 = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
    ]
};
var $36045e57d0ad82eb$export$4d1c12ba2b4ca565 = {
    prefix: "fas",
    iconName: "space-shuttle",
    icon: [
        640,
        512,
        [],
        "f197",
        "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
    ]
};
var $36045e57d0ad82eb$export$761e747b06ed2e1f = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
    ]
};
var $36045e57d0ad82eb$export$6daa96b1986e2ef0 = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        576,
        512,
        [],
        "f717",
        "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
    ]
};
var $36045e57d0ad82eb$export$1025ad641edb49c2 = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$d6f21e17ea797702 = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
    ]
};
var $36045e57d0ad82eb$export$4952c502f544cf85 = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$90b4406457aae8cc = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$7ec6541fee081990 = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [],
        "f45c",
        "M512 512H0V0h512v512z"
    ]
};
var $36045e57d0ad82eb$export$28e4b96627e00057 = {
    prefix: "fas",
    iconName: "square-root-alt",
    icon: [
        576,
        512,
        [],
        "f698",
        "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
    ]
};
var $36045e57d0ad82eb$export$722e92d2d93ffc68 = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
    ]
};
var $36045e57d0ad82eb$export$a3b0eb2cd7942125 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [],
        "f005",
        "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    ]
};
var $36045e57d0ad82eb$export$cafa834c96ebcb1a = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [],
        "f699",
        "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
    ]
};
var $36045e57d0ad82eb$export$228008b5e11032fa = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
    ]
};
var $36045e57d0ad82eb$export$c13575f42532efb3 = {
    prefix: "fas",
    iconName: "star-half-alt",
    icon: [
        536,
        512,
        [],
        "f5c0",
        "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
    ]
};
var $36045e57d0ad82eb$export$f823fee3712b2601 = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        464,
        512,
        [],
        "f69a",
        "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
    ]
};
var $36045e57d0ad82eb$export$aa3c4c1c5a47bf98 = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        480,
        512,
        [],
        "f621",
        "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
    ]
};
var $36045e57d0ad82eb$export$2884e379aed297d4 = {
    prefix: "fas",
    iconName: "step-backward",
    icon: [
        448,
        512,
        [],
        "f048",
        "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    ]
};
var $36045e57d0ad82eb$export$b303329afce5de18 = {
    prefix: "fas",
    iconName: "step-forward",
    icon: [
        448,
        512,
        [],
        "f051",
        "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    ]
};
var $36045e57d0ad82eb$export$acb2d72d28cd92d9 = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        512,
        512,
        [],
        "f0f1",
        "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$80889adc5d98bf4a = {
    prefix: "fas",
    iconName: "sticky-note",
    icon: [
        448,
        512,
        [],
        "f249",
        "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
    ]
};
var $36045e57d0ad82eb$export$51577929c676143b = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        448,
        512,
        [],
        "f04d",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$47af2aad60ab3e7c = {
    prefix: "fas",
    iconName: "stop-circle",
    icon: [
        512,
        512,
        [],
        "f28d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
    ]
};
var $36045e57d0ad82eb$export$b85a7300fc7960b6 = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [],
        "f2f2",
        "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $36045e57d0ad82eb$export$df6244b0501f2112 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
    ]
};
var $36045e57d0ad82eb$export$de59c2657a8ace67 = {
    prefix: "fas",
    iconName: "store",
    icon: [
        616,
        512,
        [],
        "f54e",
        "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
    ]
};
var $36045e57d0ad82eb$export$1f1871dab9cec9d8 = {
    prefix: "fas",
    iconName: "store-alt",
    icon: [
        640,
        512,
        [],
        "f54f",
        "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
    ]
};
var $36045e57d0ad82eb$export$b932a586f6ff48b4 = {
    prefix: "fas",
    iconName: "store-alt-slash",
    icon: [
        640,
        512,
        [],
        "e070",
        "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
    ]
};
var $36045e57d0ad82eb$export$4ab2f33219630bad = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
    ]
};
var $36045e57d0ad82eb$export$ed81ab40fc4e904 = {
    prefix: "fas",
    iconName: "stream",
    icon: [
        512,
        512,
        [],
        "f550",
        "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$6aab6c3359c2554c = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
    ]
};
var $36045e57d0ad82eb$export$eff51ea25b4de135 = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
    ]
};
var $36045e57d0ad82eb$export$195780ddabd8e0c6 = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
    ]
};
var $36045e57d0ad82eb$export$34c1e678c32ed646 = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$4cabc8a12d4e2f9 = {
    prefix: "fas",
    iconName: "subway",
    icon: [
        448,
        512,
        [],
        "f239",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$60710f3921019268 = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [],
        "f0f2",
        "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
    ]
};
var $36045e57d0ad82eb$export$957e62a9b80ff4e3 = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
    ]
};
var $36045e57d0ad82eb$export$2fa35dcbc038dbe9 = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [],
        "f185",
        "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
    ]
};
var $36045e57d0ad82eb$export$4fa56a54e822dd25 = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$46647c72213f53ba = {
    prefix: "fas",
    iconName: "surprise",
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$c74a20c81b957b6a = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
    ]
};
var $36045e57d0ad82eb$export$67daf2e2f88c1365 = {
    prefix: "fas",
    iconName: "swimmer",
    icon: [
        640,
        512,
        [],
        "f5c4",
        "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
    ]
};
var $36045e57d0ad82eb$export$4dee691631c67d5c = {
    prefix: "fas",
    iconName: "swimming-pool",
    icon: [
        640,
        512,
        [],
        "f5c5",
        "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
    ]
};
var $36045e57d0ad82eb$export$20d991385719b5b4 = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [],
        "f69b",
        "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
    ]
};
var $36045e57d0ad82eb$export$ff87319002e3dae9 = {
    prefix: "fas",
    iconName: "sync",
    icon: [
        512,
        512,
        [],
        "f021",
        "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
    ]
};
var $36045e57d0ad82eb$export$2ff2056be8c281e4 = {
    prefix: "fas",
    iconName: "sync-alt",
    icon: [
        512,
        512,
        [],
        "f2f1",
        "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
    ]
};
var $36045e57d0ad82eb$export$1aa9423ec6b1d609 = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [],
        "f48e",
        "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
    ]
};
var $36045e57d0ad82eb$export$36583f5d3d5a971f = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
    ]
};
var $36045e57d0ad82eb$export$f378fbb4e0ef7edf = {
    prefix: "fas",
    iconName: "table-tennis",
    icon: [
        512,
        512,
        [],
        "f45d",
        "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
    ]
};
var $36045e57d0ad82eb$export$1c92b67c45a4b4fc = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$db0cac088255eacc = {
    prefix: "fas",
    iconName: "tablet-alt",
    icon: [
        448,
        512,
        [],
        "f3fa",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
    ]
};
var $36045e57d0ad82eb$export$bed2b0ed4ae45e0d = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
    ]
};
var $36045e57d0ad82eb$export$38dd17b9f064c10f = {
    prefix: "fas",
    iconName: "tachometer-alt",
    icon: [
        576,
        512,
        [],
        "f3fd",
        "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$cb61f447f29887e = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        512,
        512,
        [],
        "f02b",
        "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$d55778e3ab6c933f = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        640,
        512,
        [],
        "f02c",
        "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
    ]
};
var $36045e57d0ad82eb$export$b88ed5e1e0eac4c6 = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        640,
        512,
        [],
        "f4db",
        "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ]
};
var $36045e57d0ad82eb$export$2f6d5b2fec286d63 = {
    prefix: "fas",
    iconName: "tasks",
    icon: [
        512,
        512,
        [],
        "f0ae",
        "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$9958afcdfece1b58 = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [],
        "f1ba",
        "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$b4619aeaf0b9d18e = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        640,
        512,
        [],
        "f62e",
        "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
    ]
};
var $36045e57d0ad82eb$export$c88ac21fe7c88ae6 = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        640,
        512,
        [],
        "f62f",
        "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
    ]
};
var $36045e57d0ad82eb$export$15d012277c3ecf9a = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $36045e57d0ad82eb$export$9e9af12b90a1abd2 = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $36045e57d0ad82eb$export$af6ebee83047b793 = {
    prefix: "fas",
    iconName: "tenge",
    icon: [
        384,
        512,
        [],
        "f7d7",
        "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
    ]
};
var $36045e57d0ad82eb$export$5e63e8b85b5f119c = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        640,
        512,
        [],
        "f120",
        "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
    ]
};
var $36045e57d0ad82eb$export$3313bce3924ea7da = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
    ]
};
var $36045e57d0ad82eb$export$d8724cf433389700 = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
    ]
};
var $36045e57d0ad82eb$export$4d383c83efc0c819 = {
    prefix: "fas",
    iconName: "th",
    icon: [
        512,
        512,
        [],
        "f00a",
        "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
    ]
};
var $36045e57d0ad82eb$export$69782f333e90cdc6 = {
    prefix: "fas",
    iconName: "th-large",
    icon: [
        512,
        512,
        [],
        "f009",
        "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
    ]
};
var $36045e57d0ad82eb$export$daf2614a457122c0 = {
    prefix: "fas",
    iconName: "th-list",
    icon: [
        512,
        512,
        [],
        "f00b",
        "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
    ]
};
var $36045e57d0ad82eb$export$3dbedc487b0159ac = {
    prefix: "fas",
    iconName: "theater-masks",
    icon: [
        640,
        512,
        [],
        "f630",
        "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
    ]
};
var $36045e57d0ad82eb$export$f576739e9b18ea4f = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
    ]
};
var $36045e57d0ad82eb$export$81a2f8298cf523f9 = {
    prefix: "fas",
    iconName: "thermometer-empty",
    icon: [
        256,
        512,
        [],
        "f2cb",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $36045e57d0ad82eb$export$74e07083cef79a6f = {
    prefix: "fas",
    iconName: "thermometer-full",
    icon: [
        256,
        512,
        [],
        "f2c7",
        "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
    ]
};
var $36045e57d0ad82eb$export$2090f040324b4449 = {
    prefix: "fas",
    iconName: "thermometer-half",
    icon: [
        256,
        512,
        [],
        "f2c9",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $36045e57d0ad82eb$export$ed05754fcbec6e46 = {
    prefix: "fas",
    iconName: "thermometer-quarter",
    icon: [
        256,
        512,
        [],
        "f2ca",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $36045e57d0ad82eb$export$6c632d1dc30d4a77 = {
    prefix: "fas",
    iconName: "thermometer-three-quarters",
    icon: [
        256,
        512,
        [],
        "f2c8",
        "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $36045e57d0ad82eb$export$aba24ca305bbe8c1 = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [],
        "f165",
        "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
    ]
};
var $36045e57d0ad82eb$export$47e4e0d519d33497 = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [],
        "f164",
        "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
    ]
};
var $36045e57d0ad82eb$export$b6314cdc01bb5c43 = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [],
        "f08d",
        "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
    ]
};
var $36045e57d0ad82eb$export$75e38ba471fd89c4 = {
    prefix: "fas",
    iconName: "ticket-alt",
    icon: [
        576,
        512,
        [],
        "f3ff",
        "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
    ]
};
var $36045e57d0ad82eb$export$174bd7f477b115b4 = {
    prefix: "fas",
    iconName: "times",
    icon: [
        352,
        512,
        [],
        "f00d",
        "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    ]
};
var $36045e57d0ad82eb$export$ab0ec50720a747eb = {
    prefix: "fas",
    iconName: "times-circle",
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
    ]
};
var $36045e57d0ad82eb$export$60dd975bd5938c15 = {
    prefix: "fas",
    iconName: "tint",
    icon: [
        352,
        512,
        [],
        "f043",
        "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $36045e57d0ad82eb$export$5d6f0943039b898f = {
    prefix: "fas",
    iconName: "tint-slash",
    icon: [
        640,
        512,
        [],
        "f5c7",
        "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
    ]
};
var $36045e57d0ad82eb$export$3d016d62cda18371 = {
    prefix: "fas",
    iconName: "tired",
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
    ]
};
var $36045e57d0ad82eb$export$d20aaceb882ca545 = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
    ]
};
var $36045e57d0ad82eb$export$5cffc34afa81e517 = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
    ]
};
var $36045e57d0ad82eb$export$505476859b9691c0 = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        384,
        512,
        [],
        "f7d8",
        "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
    ]
};
var $36045e57d0ad82eb$export$c8cc083ccc72b17 = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        576,
        512,
        [],
        "f71e",
        "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
    ]
};
var $36045e57d0ad82eb$export$7a494edbf9b65575 = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
    ]
};
var $36045e57d0ad82eb$export$b34d64c205c732a9 = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [],
        "f552",
        "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
    ]
};
var $36045e57d0ad82eb$export$646e4e7a8c6172aa = {
    prefix: "fas",
    iconName: "tools",
    icon: [
        512,
        512,
        [],
        "f7d9",
        "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$3a1fa2d16f90d635 = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [],
        "f5c9",
        "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
    ]
};
var $36045e57d0ad82eb$export$54d07baabd8c2acb = {
    prefix: "fas",
    iconName: "torah",
    icon: [
        640,
        512,
        [],
        "f6a0",
        "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
    ]
};
var $36045e57d0ad82eb$export$75825a4c2b3375e = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [],
        "f6a1",
        "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
    ]
};
var $36045e57d0ad82eb$export$e87e41787bbedc98 = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [],
        "f722",
        "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
    ]
};
var $36045e57d0ad82eb$export$9c9b2fbddd59047d = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [],
        "f25c",
        "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
    ]
};
var $36045e57d0ad82eb$export$bf0b19daceaec9c2 = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        384,
        512,
        [],
        "f637",
        "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$3a48b9820e92f5ab = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
    ]
};
var $36045e57d0ad82eb$export$17cde74bf6f1ee89 = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [],
        "f238",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
    ]
};
var $36045e57d0ad82eb$export$a7a36674c079f293 = {
    prefix: "fas",
    iconName: "tram",
    icon: [
        512,
        512,
        [],
        "f7da",
        "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $36045e57d0ad82eb$export$7e3f1701aa95ef01 = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        384,
        512,
        [],
        "f224",
        "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $36045e57d0ad82eb$export$9c36cf9334c052f = {
    prefix: "fas",
    iconName: "transgender-alt",
    icon: [
        480,
        512,
        [],
        "f225",
        "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $36045e57d0ad82eb$export$ed8c149a0ea54bb4 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
    ]
};
var $36045e57d0ad82eb$export$88df7ff7eb32f9dc = {
    prefix: "fas",
    iconName: "trash-alt",
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$d32f45a64ed40e8d = {
    prefix: "fas",
    iconName: "trash-restore",
    icon: [
        448,
        512,
        [],
        "f829",
        "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$d075b19b21cb9856 = {
    prefix: "fas",
    iconName: "trash-restore-alt",
    icon: [
        448,
        512,
        [],
        "f82a",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$1744430f718caf6b = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        384,
        512,
        [],
        "f1bb",
        "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
    ]
};
var $36045e57d0ad82eb$export$29c432d69ccf85a5 = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [],
        "f091",
        "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
    ]
};
var $36045e57d0ad82eb$export$d7895f386f8bd8b8 = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [],
        "f0d1",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $36045e57d0ad82eb$export$f00c152db7d44638 = {
    prefix: "fas",
    iconName: "truck-loading",
    icon: [
        640,
        512,
        [],
        "f4de",
        "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$24b8a0147653649a = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$a06617a1a4ccea67 = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$f846b848b3ba3064 = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [],
        "f63c",
        "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $36045e57d0ad82eb$export$36edce3ba87c2b17 = {
    prefix: "fas",
    iconName: "tshirt",
    icon: [
        640,
        512,
        [],
        "f553",
        "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
    ]
};
var $36045e57d0ad82eb$export$7c85aba0f9624b29 = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [],
        "f1e4",
        "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $36045e57d0ad82eb$export$e0cfed4ba2fe562c = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [],
        "f26c",
        "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
    ]
};
var $36045e57d0ad82eb$export$9ff64ffae70e08c0 = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
    ]
};
var $36045e57d0ad82eb$export$20932e4d438e4e4c = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        640,
        512,
        [],
        "f5ca",
        "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$22346afd6a3cddf8 = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $36045e57d0ad82eb$export$a5e5ba60b1dfe2b2 = {
    prefix: "fas",
    iconName: "undo",
    icon: [
        512,
        512,
        [],
        "f0e2",
        "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
    ]
};
var $36045e57d0ad82eb$export$c8197b992c46c4a6 = {
    prefix: "fas",
    iconName: "undo-alt",
    icon: [
        512,
        512,
        [],
        "f2ea",
        "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
    ]
};
var $36045e57d0ad82eb$export$e119aada7f690d05 = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
    ]
};
var $36045e57d0ad82eb$export$f2e1460ebe1a8cb0 = {
    prefix: "fas",
    iconName: "university",
    icon: [
        512,
        512,
        [],
        "f19c",
        "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
    ]
};
var $36045e57d0ad82eb$export$2f546f7d8ba01e18 = {
    prefix: "fas",
    iconName: "unlink",
    icon: [
        512,
        512,
        [],
        "f127",
        "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
    ]
};
var $36045e57d0ad82eb$export$db1382cd406cc506 = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [],
        "f09c",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$b19f508797f3d9c3 = {
    prefix: "fas",
    iconName: "unlock-alt",
    icon: [
        448,
        512,
        [],
        "f13e",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
    ]
};
var $36045e57d0ad82eb$export$a9578350255b2b79 = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $36045e57d0ad82eb$export$f5699fa0844e0188 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $36045e57d0ad82eb$export$ae9b19c2ac726cfc = {
    prefix: "fas",
    iconName: "user-alt",
    icon: [
        512,
        512,
        [],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
    ]
};
var $36045e57d0ad82eb$export$46185fab4772ada6 = {
    prefix: "fas",
    iconName: "user-alt-slash",
    icon: [
        640,
        512,
        [],
        "f4fa",
        "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
    ]
};
var $36045e57d0ad82eb$export$94363e983c225a04 = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
    ]
};
var $36045e57d0ad82eb$export$76de2a120043c9f8 = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
    ]
};
var $36045e57d0ad82eb$export$be7d974e9e0dba1a = {
    prefix: "fas",
    iconName: "user-circle",
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    ]
};
var $36045e57d0ad82eb$export$b00596a09aa07311 = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
    ]
};
var $36045e57d0ad82eb$export$474108c2b86e730e = {
    prefix: "fas",
    iconName: "user-cog",
    icon: [
        640,
        512,
        [],
        "f4fe",
        "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
    ]
};
var $36045e57d0ad82eb$export$a68a6960fc8eef82 = {
    prefix: "fas",
    iconName: "user-edit",
    icon: [
        640,
        512,
        [],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
    ]
};
var $36045e57d0ad82eb$export$46073bec205635d9 = {
    prefix: "fas",
    iconName: "user-friends",
    icon: [
        640,
        512,
        [],
        "f500",
        "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
    ]
};
var $36045e57d0ad82eb$export$10f5839059d22f7e = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
    ]
};
var $36045e57d0ad82eb$export$c950c1ba7f227d5b = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
    ]
};
var $36045e57d0ad82eb$export$d9b89b5872b67a4f = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
    ]
};
var $36045e57d0ad82eb$export$ab0d33a2c03f1794 = {
    prefix: "fas",
    iconName: "user-md",
    icon: [
        448,
        512,
        [],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
    ]
};
var $36045e57d0ad82eb$export$d6e17c0df8ed1bf7 = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $36045e57d0ad82eb$export$a9174995732e03c5 = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [],
        "f504",
        "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
    ]
};
var $36045e57d0ad82eb$export$ab9af5aa013d2162 = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
    ]
};
var $36045e57d0ad82eb$export$4c17261776a709f2 = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $36045e57d0ad82eb$export$597826232327559b = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [],
        "f21b",
        "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
    ]
};
var $36045e57d0ad82eb$export$d1886bc596424e6c = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
    ]
};
var $36045e57d0ad82eb$export$3924ab4d3ef9b5ef = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
    ]
};
var $36045e57d0ad82eb$export$9eec597148166b36 = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
    ]
};
var $36045e57d0ad82eb$export$48c51dda34e9f04c = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
    ]
};
var $36045e57d0ad82eb$export$45b996d071667753 = {
    prefix: "fas",
    iconName: "user-times",
    icon: [
        640,
        512,
        [],
        "f235",
        "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $36045e57d0ad82eb$export$e5a8f011aef571ac = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $36045e57d0ad82eb$export$5e0b06753fc69b81 = {
    prefix: "fas",
    iconName: "users-cog",
    icon: [
        640,
        512,
        [],
        "f509",
        "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $36045e57d0ad82eb$export$b71a093b86e3da1f = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
    ]
};
var $36045e57d0ad82eb$export$fb7af5d245fb9053 = {
    prefix: "fas",
    iconName: "utensil-spoon",
    icon: [
        512,
        512,
        [],
        "f2e5",
        "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
    ]
};
var $36045e57d0ad82eb$export$750d52edc1dafc7 = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        416,
        512,
        [],
        "f2e7",
        "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
    ]
};
var $36045e57d0ad82eb$export$567d5631a7b0599f = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        512,
        512,
        [],
        "f5cb",
        "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
    ]
};
var $36045e57d0ad82eb$export$f89d028573ffc0a6 = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        288,
        512,
        [],
        "f221",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $36045e57d0ad82eb$export$6a6f9cba7a1e5fe4 = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        512,
        512,
        [],
        "f226",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
    ]
};
var $36045e57d0ad82eb$export$63f2d9e5f4689aa8 = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        576,
        512,
        [],
        "f228",
        "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $36045e57d0ad82eb$export$c8370e53051a657 = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
    ]
};
var $36045e57d0ad82eb$export$750a64470c2e0f3f = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
    ]
};
var $36045e57d0ad82eb$export$aa014b06d2d70598 = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        480,
        512,
        [],
        "f492",
        "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
    ]
};
var $36045e57d0ad82eb$export$507e8edd7676b2e9 = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        640,
        512,
        [],
        "f493",
        "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
    ]
};
var $36045e57d0ad82eb$export$5c6bd8729527871b = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [],
        "f03d",
        "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
    ]
};
var $36045e57d0ad82eb$export$a714fc79f58cc9ef = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
    ]
};
var $36045e57d0ad82eb$export$ee4b92e89fe0dfaf = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
    ]
};
var $36045e57d0ad82eb$export$37c67e0b3dc6bd1b = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
    ]
};
var $36045e57d0ad82eb$export$c4ff5306c5470939 = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
    ]
};
var $36045e57d0ad82eb$export$ee194b18f5c6f6b6 = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
    ]
};
var $36045e57d0ad82eb$export$4f1ce88b2b4cd5cd = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
    ]
};
var $36045e57d0ad82eb$export$a15e6fc8e68a76b0 = {
    prefix: "fas",
    iconName: "volleyball-ball",
    icon: [
        512,
        512,
        [],
        "f45f",
        "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
    ]
};
var $36045e57d0ad82eb$export$69fdf57632b6cc29 = {
    prefix: "fas",
    iconName: "volume-down",
    icon: [
        384,
        512,
        [],
        "f027",
        "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
    ]
};
var $36045e57d0ad82eb$export$aa8decd057dfd29b = {
    prefix: "fas",
    iconName: "volume-mute",
    icon: [
        512,
        512,
        [],
        "f6a9",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
    ]
};
var $36045e57d0ad82eb$export$d94ba52e980ea0f1 = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        256,
        512,
        [],
        "f026",
        "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
    ]
};
var $36045e57d0ad82eb$export$5940d3e475d90cc4 = {
    prefix: "fas",
    iconName: "volume-up",
    icon: [
        576,
        512,
        [],
        "f028",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
    ]
};
var $36045e57d0ad82eb$export$e87bb3db1608b850 = {
    prefix: "fas",
    iconName: "vote-yea",
    icon: [
        640,
        512,
        [],
        "f772",
        "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
    ]
};
var $36045e57d0ad82eb$export$248171cb6dad4307 = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
    ]
};
var $36045e57d0ad82eb$export$4886811b7174ec35 = {
    prefix: "fas",
    iconName: "walking",
    icon: [
        320,
        512,
        [],
        "f554",
        "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
    ]
};
var $36045e57d0ad82eb$export$79204db8777905c8 = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$e3a174a50618c208 = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
    ]
};
var $36045e57d0ad82eb$export$efaeddad0a6e901b = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
    ]
};
var $36045e57d0ad82eb$export$c38cf504b3bc58a2 = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
    ]
};
var $36045e57d0ad82eb$export$cf3bafa68a60bae4 = {
    prefix: "fas",
    iconName: "weight",
    icon: [
        512,
        512,
        [],
        "f496",
        "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
    ]
};
var $36045e57d0ad82eb$export$43d1fa6671908715 = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $36045e57d0ad82eb$export$76a9413fbe130a53 = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
    ]
};
var $36045e57d0ad82eb$export$1642419fe3db2857 = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [],
        "f1eb",
        "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
    ]
};
var $36045e57d0ad82eb$export$cc58cb0f2257a6a9 = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
    ]
};
var $36045e57d0ad82eb$export$18b7775f78a3e16 = {
    prefix: "fas",
    iconName: "window-close",
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
    ]
};
var $36045e57d0ad82eb$export$703cd98be31ec905 = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
    ]
};
var $36045e57d0ad82eb$export$26a3f9d2784b90d8 = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
    ]
};
var $36045e57d0ad82eb$export$eccfff9bfd585652 = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
    ]
};
var $36045e57d0ad82eb$export$770be8b3d5776043 = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
    ]
};
var $36045e57d0ad82eb$export$e06d6607d3577d6e = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        288,
        512,
        [],
        "f4e3",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
    ]
};
var $36045e57d0ad82eb$export$b8ff3fe2b78aef2f = {
    prefix: "fas",
    iconName: "wine-glass-alt",
    icon: [
        288,
        512,
        [],
        "f5ce",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
    ]
};
var $36045e57d0ad82eb$export$51790ddd26e431bc = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        576,
        512,
        [],
        "f159",
        "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
    ]
};
var $36045e57d0ad82eb$export$3c6c0c8185296ac5 = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [],
        "f0ad",
        "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $36045e57d0ad82eb$export$8cf137aceaaf4de0 = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        640,
        512,
        [],
        "f497",
        "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
    ]
};
var $36045e57d0ad82eb$export$30f1437f5a4e991d = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        384,
        512,
        [],
        "f157",
        "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
    ]
};
var $36045e57d0ad82eb$export$6ec1acbf3f610b8f = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        496,
        512,
        [],
        "f6ad",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $36045e57d0ad82eb$export$da048c47c8dcd50a = {
    faAd: $36045e57d0ad82eb$export$7af266c3465b1ff2,
    faAddressBook: $36045e57d0ad82eb$export$853fd1561789e3bb,
    faAddressCard: $36045e57d0ad82eb$export$6ea408c7266ed557,
    faAdjust: $36045e57d0ad82eb$export$cfa06e4b68edca2d,
    faAirFreshener: $36045e57d0ad82eb$export$a5e63e89b5ccee83,
    faAlignCenter: $36045e57d0ad82eb$export$70e29dd05344623e,
    faAlignJustify: $36045e57d0ad82eb$export$97c42b56d462df72,
    faAlignLeft: $36045e57d0ad82eb$export$e490f662af4d1c78,
    faAlignRight: $36045e57d0ad82eb$export$7370f36a39a38737,
    faAllergies: $36045e57d0ad82eb$export$dcae2101babbffff,
    faAmbulance: $36045e57d0ad82eb$export$f5c7042778b51765,
    faAmericanSignLanguageInterpreting: $36045e57d0ad82eb$export$23a7517099ab1b86,
    faAnchor: $36045e57d0ad82eb$export$12a35719f889cd1,
    faAngleDoubleDown: $36045e57d0ad82eb$export$fd504117f273ca92,
    faAngleDoubleLeft: $36045e57d0ad82eb$export$21b0833b3cf929a7,
    faAngleDoubleRight: $36045e57d0ad82eb$export$792931403404faf0,
    faAngleDoubleUp: $36045e57d0ad82eb$export$9bb51e1a2c07db7c,
    faAngleDown: $36045e57d0ad82eb$export$4b5be0142d10f342,
    faAngleLeft: $36045e57d0ad82eb$export$3cbcd1b7e35945d2,
    faAngleRight: $36045e57d0ad82eb$export$6bce1afb61f2eb66,
    faAngleUp: $36045e57d0ad82eb$export$887340269e6d6cac,
    faAngry: $36045e57d0ad82eb$export$3c96c08e234498c5,
    faAnkh: $36045e57d0ad82eb$export$8736909014b15ca9,
    faAppleAlt: $36045e57d0ad82eb$export$bcdd94f3977a0884,
    faArchive: $36045e57d0ad82eb$export$26b3e1c454273f34,
    faArchway: $36045e57d0ad82eb$export$d56753dd2eb5c323,
    faArrowAltCircleDown: $36045e57d0ad82eb$export$ff3afbc8c0bc5d59,
    faArrowAltCircleLeft: $36045e57d0ad82eb$export$5460a5b11a24996f,
    faArrowAltCircleRight: $36045e57d0ad82eb$export$88962ffdad8b856d,
    faArrowAltCircleUp: $36045e57d0ad82eb$export$3747a8ef0995eadf,
    faArrowCircleDown: $36045e57d0ad82eb$export$6cfa36bbb3a057,
    faArrowCircleLeft: $36045e57d0ad82eb$export$728262abb9f58d0a,
    faArrowCircleRight: $36045e57d0ad82eb$export$7d3d828103aa3be7,
    faArrowCircleUp: $36045e57d0ad82eb$export$a2f6f3baa50af0b1,
    faArrowDown: $36045e57d0ad82eb$export$9686eff8d817f770,
    faArrowLeft: $36045e57d0ad82eb$export$b7fac681e7d09400,
    faArrowRight: $36045e57d0ad82eb$export$b4da69a0247f3620,
    faArrowUp: $36045e57d0ad82eb$export$8e144ed4d52eef49,
    faArrowsAlt: $36045e57d0ad82eb$export$3cdabfff52cfc73a,
    faArrowsAltH: $36045e57d0ad82eb$export$7937ea574fb1389,
    faArrowsAltV: $36045e57d0ad82eb$export$138cb56a3f8f7040,
    faAssistiveListeningSystems: $36045e57d0ad82eb$export$8eeef3dc0035b165,
    faAsterisk: $36045e57d0ad82eb$export$19eff32c0fd4f99f,
    faAt: $36045e57d0ad82eb$export$c115e8063ee02632,
    faAtlas: $36045e57d0ad82eb$export$380a9050e42fe5d7,
    faAtom: $36045e57d0ad82eb$export$b5bb295e8ad4ab31,
    faAudioDescription: $36045e57d0ad82eb$export$b6b464c98c009494,
    faAward: $36045e57d0ad82eb$export$f8db2747dadd48f7,
    faBaby: $36045e57d0ad82eb$export$8afab767536f59ad,
    faBabyCarriage: $36045e57d0ad82eb$export$3b3ab4d86bad7d26,
    faBackspace: $36045e57d0ad82eb$export$e43e3f67102fc526,
    faBackward: $36045e57d0ad82eb$export$ae65f96ea7a4078d,
    faBacon: $36045e57d0ad82eb$export$ab07061fe21a3a8e,
    faBacteria: $36045e57d0ad82eb$export$7fc18cf2d526c341,
    faBacterium: $36045e57d0ad82eb$export$b0babe4230e35ebe,
    faBahai: $36045e57d0ad82eb$export$6d636565b3ec36b4,
    faBalanceScale: $36045e57d0ad82eb$export$fec323dcfd81d750,
    faBalanceScaleLeft: $36045e57d0ad82eb$export$786cb0c775487f19,
    faBalanceScaleRight: $36045e57d0ad82eb$export$2238e05f8920005a,
    faBan: $36045e57d0ad82eb$export$76f704d256def3c7,
    faBandAid: $36045e57d0ad82eb$export$b14a1014df2fdf46,
    faBarcode: $36045e57d0ad82eb$export$3825a842b5afc5aa,
    faBars: $36045e57d0ad82eb$export$36e9cf7887265da2,
    faBaseballBall: $36045e57d0ad82eb$export$63a3f8ceae07c7f3,
    faBasketballBall: $36045e57d0ad82eb$export$36550ab8ffcc5b28,
    faBath: $36045e57d0ad82eb$export$1ea66a88b8f620c9,
    faBatteryEmpty: $36045e57d0ad82eb$export$1344b64f6e922e12,
    faBatteryFull: $36045e57d0ad82eb$export$9338fc4614cfc0cf,
    faBatteryHalf: $36045e57d0ad82eb$export$e6dadc1155c4ee48,
    faBatteryQuarter: $36045e57d0ad82eb$export$acec92052ac2183,
    faBatteryThreeQuarters: $36045e57d0ad82eb$export$cfb37069d38f379e,
    faBed: $36045e57d0ad82eb$export$f24e0fce77994d4d,
    faBeer: $36045e57d0ad82eb$export$f74725691538983b,
    faBell: $36045e57d0ad82eb$export$9b6162797ab1b255,
    faBellSlash: $36045e57d0ad82eb$export$6b31a1e5968b2378,
    faBezierCurve: $36045e57d0ad82eb$export$a527a6267c55a54c,
    faBible: $36045e57d0ad82eb$export$2eac809b0670d139,
    faBicycle: $36045e57d0ad82eb$export$36cb1885ad7a570f,
    faBiking: $36045e57d0ad82eb$export$a5bcf835dbf9c0b,
    faBinoculars: $36045e57d0ad82eb$export$8a910017964bb8c2,
    faBiohazard: $36045e57d0ad82eb$export$ae3a453550dec95,
    faBirthdayCake: $36045e57d0ad82eb$export$bdcf98f725a7241a,
    faBlender: $36045e57d0ad82eb$export$db34f7a6de38784f,
    faBlenderPhone: $36045e57d0ad82eb$export$f35a116a762ef8fc,
    faBlind: $36045e57d0ad82eb$export$923de21def6ea9b6,
    faBlog: $36045e57d0ad82eb$export$890d5e011054935a,
    faBold: $36045e57d0ad82eb$export$7e0c7fd2a2e88823,
    faBolt: $36045e57d0ad82eb$export$6869964aa308dd31,
    faBomb: $36045e57d0ad82eb$export$d59078f6e80b4a67,
    faBone: $36045e57d0ad82eb$export$5902c007d5703f2d,
    faBong: $36045e57d0ad82eb$export$e74974fac77c468e,
    faBook: $36045e57d0ad82eb$export$c9d7ef726d1a8742,
    faBookDead: $36045e57d0ad82eb$export$b98a3f8c3941a74a,
    faBookMedical: $36045e57d0ad82eb$export$6feb44fec53ba30d,
    faBookOpen: $36045e57d0ad82eb$export$8a3071811b2b7979,
    faBookReader: $36045e57d0ad82eb$export$cee14fe33262fa7d,
    faBookmark: $36045e57d0ad82eb$export$4ed9da5c3cca0ef1,
    faBorderAll: $36045e57d0ad82eb$export$93a5eb721c9c0d25,
    faBorderNone: $36045e57d0ad82eb$export$2b488402ec335d97,
    faBorderStyle: $36045e57d0ad82eb$export$c2867ca78120d644,
    faBowlingBall: $36045e57d0ad82eb$export$5ee2640fe105312d,
    faBox: $36045e57d0ad82eb$export$6e7cf270cda52323,
    faBoxOpen: $36045e57d0ad82eb$export$9010ed816a8b9c97,
    faBoxTissue: $36045e57d0ad82eb$export$f2adc06617bc0c7,
    faBoxes: $36045e57d0ad82eb$export$2007320dd6cde6db,
    faBraille: $36045e57d0ad82eb$export$983e9c27cac7ed1c,
    faBrain: $36045e57d0ad82eb$export$97fa4f4c1006ab1,
    faBreadSlice: $36045e57d0ad82eb$export$d78e8b0681279167,
    faBriefcase: $36045e57d0ad82eb$export$8da450d063b0eb37,
    faBriefcaseMedical: $36045e57d0ad82eb$export$5000f52ca9819bf5,
    faBroadcastTower: $36045e57d0ad82eb$export$f68b38d51f5c0ed,
    faBroom: $36045e57d0ad82eb$export$2a533051418ff4ca,
    faBrush: $36045e57d0ad82eb$export$5824ffe6f8983c83,
    faBug: $36045e57d0ad82eb$export$a18cfac400116d9f,
    faBuilding: $36045e57d0ad82eb$export$f26673f8b10c3d46,
    faBullhorn: $36045e57d0ad82eb$export$dacae2b4ec565333,
    faBullseye: $36045e57d0ad82eb$export$554720e3bf74fe90,
    faBurn: $36045e57d0ad82eb$export$80ed4535efc60402,
    faBus: $36045e57d0ad82eb$export$ce69441578ff2fdb,
    faBusAlt: $36045e57d0ad82eb$export$40616edfab6d332a,
    faBusinessTime: $36045e57d0ad82eb$export$694b7e88782dec12,
    faCalculator: $36045e57d0ad82eb$export$693bd40950ed2c3a,
    faCalendar: $36045e57d0ad82eb$export$34f5c36a3e80efa2,
    faCalendarAlt: $36045e57d0ad82eb$export$cbc139f33cff356,
    faCalendarCheck: $36045e57d0ad82eb$export$5655108e1162ba45,
    faCalendarDay: $36045e57d0ad82eb$export$80968bcfef6481ca,
    faCalendarMinus: $36045e57d0ad82eb$export$23e8b4955c2d951b,
    faCalendarPlus: $36045e57d0ad82eb$export$16768a660ae3ca9d,
    faCalendarTimes: $36045e57d0ad82eb$export$99b20d7352fbcf08,
    faCalendarWeek: $36045e57d0ad82eb$export$39be5cb4aed5a521,
    faCamera: $36045e57d0ad82eb$export$84ffbd7161ca2008,
    faCameraRetro: $36045e57d0ad82eb$export$41dbdadc07a89b05,
    faCampground: $36045e57d0ad82eb$export$295287303c0e9c7c,
    faCandyCane: $36045e57d0ad82eb$export$14d66ba7571ae0b9,
    faCannabis: $36045e57d0ad82eb$export$8ec2f752344b69bd,
    faCapsules: $36045e57d0ad82eb$export$ba6fd4a436804a48,
    faCar: $36045e57d0ad82eb$export$9eefe7fcdf123b76,
    faCarAlt: $36045e57d0ad82eb$export$7937ed2462a665c0,
    faCarBattery: $36045e57d0ad82eb$export$a44d0c11093d9c1e,
    faCarCrash: $36045e57d0ad82eb$export$8ff55566398404cd,
    faCarSide: $36045e57d0ad82eb$export$6f7218565b1b8d0e,
    faCaravan: $36045e57d0ad82eb$export$afb5d0eee7c1bdb,
    faCaretDown: $36045e57d0ad82eb$export$f9395ef707603e40,
    faCaretLeft: $36045e57d0ad82eb$export$85a918a11b7643c2,
    faCaretRight: $36045e57d0ad82eb$export$f1011352b01c1c0,
    faCaretSquareDown: $36045e57d0ad82eb$export$61aea18df1c84401,
    faCaretSquareLeft: $36045e57d0ad82eb$export$d0c8ba444f1f9581,
    faCaretSquareRight: $36045e57d0ad82eb$export$ae86c9de7e0f62fa,
    faCaretSquareUp: $36045e57d0ad82eb$export$307ae80b26533ce5,
    faCaretUp: $36045e57d0ad82eb$export$7de776bdab4e536d,
    faCarrot: $36045e57d0ad82eb$export$28e93ec9f5e2ddf3,
    faCartArrowDown: $36045e57d0ad82eb$export$9206260ff0c0c616,
    faCartPlus: $36045e57d0ad82eb$export$6675e2bf21fdb87e,
    faCashRegister: $36045e57d0ad82eb$export$6357093f67788b33,
    faCat: $36045e57d0ad82eb$export$ab927dada03be4b3,
    faCertificate: $36045e57d0ad82eb$export$a881f37164b11fbf,
    faChair: $36045e57d0ad82eb$export$a339864ee3df7e9a,
    faChalkboard: $36045e57d0ad82eb$export$49a36efd66df775,
    faChalkboardTeacher: $36045e57d0ad82eb$export$443fcf69b0155291,
    faChargingStation: $36045e57d0ad82eb$export$bab2cd86f8c65657,
    faChartArea: $36045e57d0ad82eb$export$2acab8312b7a999b,
    faChartBar: $36045e57d0ad82eb$export$b532f5d25de97633,
    faChartLine: $36045e57d0ad82eb$export$e022f62a119e1d93,
    faChartPie: $36045e57d0ad82eb$export$1de7b9cf7d1b153b,
    faCheck: $36045e57d0ad82eb$export$62b2c752fccc6a9c,
    faCheckCircle: $36045e57d0ad82eb$export$be9e388158c74f29,
    faCheckDouble: $36045e57d0ad82eb$export$f178c8c2ad3cc861,
    faCheckSquare: $36045e57d0ad82eb$export$f0c8040f596df7fe,
    faCheese: $36045e57d0ad82eb$export$549b99473b7201e6,
    faChess: $36045e57d0ad82eb$export$442fddbbd741c590,
    faChessBishop: $36045e57d0ad82eb$export$a831eedd2f59c62f,
    faChessBoard: $36045e57d0ad82eb$export$bd301515df6246af,
    faChessKing: $36045e57d0ad82eb$export$d5713874f8fefe1b,
    faChessKnight: $36045e57d0ad82eb$export$861b1f13085cf122,
    faChessPawn: $36045e57d0ad82eb$export$3db75d5ac9e98468,
    faChessQueen: $36045e57d0ad82eb$export$7b8ce73615739d30,
    faChessRook: $36045e57d0ad82eb$export$5d65c40a109eb09c,
    faChevronCircleDown: $36045e57d0ad82eb$export$9926124d75b2ecab,
    faChevronCircleLeft: $36045e57d0ad82eb$export$4a42c8c2451a33fd,
    faChevronCircleRight: $36045e57d0ad82eb$export$2a5db4f6eba6f2b,
    faChevronCircleUp: $36045e57d0ad82eb$export$b786cf5db03f2c36,
    faChevronDown: $36045e57d0ad82eb$export$8db9bc521720fccd,
    faChevronLeft: $36045e57d0ad82eb$export$75702e3e3dd44a44,
    faChevronRight: $36045e57d0ad82eb$export$930de8c26eb20490,
    faChevronUp: $36045e57d0ad82eb$export$877e5ae47a854215,
    faChild: $36045e57d0ad82eb$export$60b41e3581d1739a,
    faChurch: $36045e57d0ad82eb$export$16a3f12c6ae9650,
    faCircle: $36045e57d0ad82eb$export$4280b2387fbdad12,
    faCircleNotch: $36045e57d0ad82eb$export$9429fd8df55155d,
    faCity: $36045e57d0ad82eb$export$a9947c2888b3c8fd,
    faClinicMedical: $36045e57d0ad82eb$export$20d8a680febc7434,
    faClipboard: $36045e57d0ad82eb$export$97d84347d71ba297,
    faClipboardCheck: $36045e57d0ad82eb$export$7babcb2c90eb609a,
    faClipboardList: $36045e57d0ad82eb$export$2c5a9d8548d8810e,
    faClock: $36045e57d0ad82eb$export$95b9968e7fceb821,
    faClone: $36045e57d0ad82eb$export$76c1aa4bf9a39458,
    faClosedCaptioning: $36045e57d0ad82eb$export$8e047801a8603af7,
    faCloud: $36045e57d0ad82eb$export$8bb3c4d5c2f50243,
    faCloudDownloadAlt: $36045e57d0ad82eb$export$351357a14c41f824,
    faCloudMeatball: $36045e57d0ad82eb$export$5d120e8b87ad33f4,
    faCloudMoon: $36045e57d0ad82eb$export$482eb125aaf0fbc2,
    faCloudMoonRain: $36045e57d0ad82eb$export$301c3fab0c4545bd,
    faCloudRain: $36045e57d0ad82eb$export$a6c308ee087b4ded,
    faCloudShowersHeavy: $36045e57d0ad82eb$export$af51c741ee9cc090,
    faCloudSun: $36045e57d0ad82eb$export$dcaadfd9c98e42a1,
    faCloudSunRain: $36045e57d0ad82eb$export$dd9dc9b4227dbe94,
    faCloudUploadAlt: $36045e57d0ad82eb$export$e73b3e819b9d14a5,
    faCocktail: $36045e57d0ad82eb$export$4be708f1e41d387b,
    faCode: $36045e57d0ad82eb$export$eba095993e51cc97,
    faCodeBranch: $36045e57d0ad82eb$export$aa054a78ab078db3,
    faCoffee: $36045e57d0ad82eb$export$1d24a9e457278011,
    faCog: $36045e57d0ad82eb$export$d6298bbfd1912a78,
    faCogs: $36045e57d0ad82eb$export$af1575770afc9559,
    faCoins: $36045e57d0ad82eb$export$bc5da164799a0e,
    faColumns: $36045e57d0ad82eb$export$bb861166644ac28a,
    faComment: $36045e57d0ad82eb$export$805cd88398a70581,
    faCommentAlt: $36045e57d0ad82eb$export$6e96904d9af0ec4a,
    faCommentDollar: $36045e57d0ad82eb$export$7a088030853df12c,
    faCommentDots: $36045e57d0ad82eb$export$63ffcb3d4e94cb92,
    faCommentMedical: $36045e57d0ad82eb$export$101422b773924276,
    faCommentSlash: $36045e57d0ad82eb$export$3786a0422a3f33ea,
    faComments: $36045e57d0ad82eb$export$932912e74adb8939,
    faCommentsDollar: $36045e57d0ad82eb$export$d477129b070e5ac4,
    faCompactDisc: $36045e57d0ad82eb$export$84021631df0f831b,
    faCompass: $36045e57d0ad82eb$export$b4d344633433e50e,
    faCompress: $36045e57d0ad82eb$export$83632d1150d3541f,
    faCompressAlt: $36045e57d0ad82eb$export$a05650ebe54bede,
    faCompressArrowsAlt: $36045e57d0ad82eb$export$39205db0ea980efd,
    faConciergeBell: $36045e57d0ad82eb$export$ad92ffbbfbc0fcf3,
    faCookie: $36045e57d0ad82eb$export$b3e64f5f68c6623f,
    faCookieBite: $36045e57d0ad82eb$export$317dde8664f7de71,
    faCopy: $36045e57d0ad82eb$export$e9bd786d30cb716c,
    faCopyright: $36045e57d0ad82eb$export$da61665fff8aebfe,
    faCouch: $36045e57d0ad82eb$export$ce96e32767a7dd51,
    faCreditCard: $36045e57d0ad82eb$export$3e7437bf6535bef0,
    faCrop: $36045e57d0ad82eb$export$afa58590dfb6fca2,
    faCropAlt: $36045e57d0ad82eb$export$d932915fde4f1010,
    faCross: $36045e57d0ad82eb$export$9d0a89fcd084abb,
    faCrosshairs: $36045e57d0ad82eb$export$721c101130c40043,
    faCrow: $36045e57d0ad82eb$export$bfa312207b788ed9,
    faCrown: $36045e57d0ad82eb$export$dc1083dcd1d7b9d6,
    faCrutch: $36045e57d0ad82eb$export$e94134641c0e2,
    faCube: $36045e57d0ad82eb$export$973ae4f1e4d2ce78,
    faCubes: $36045e57d0ad82eb$export$30523a9441a31e97,
    faCut: $36045e57d0ad82eb$export$66847f2a71b260e7,
    faDatabase: $36045e57d0ad82eb$export$24680dede86b1883,
    faDeaf: $36045e57d0ad82eb$export$4b666adf83f0de01,
    faDemocrat: $36045e57d0ad82eb$export$a1672d808fbed0bd,
    faDesktop: $36045e57d0ad82eb$export$6e6ddc253102e596,
    faDharmachakra: $36045e57d0ad82eb$export$45cbd92c28deb2c7,
    faDiagnoses: $36045e57d0ad82eb$export$68bad2b52a90d1fa,
    faDice: $36045e57d0ad82eb$export$4ed8206e6619cc8f,
    faDiceD20: $36045e57d0ad82eb$export$b06003a02c9055bd,
    faDiceD6: $36045e57d0ad82eb$export$64bfd48ed353c031,
    faDiceFive: $36045e57d0ad82eb$export$d9769fb795c2db82,
    faDiceFour: $36045e57d0ad82eb$export$2df6451abf70a6ff,
    faDiceOne: $36045e57d0ad82eb$export$d91800b7be5303b0,
    faDiceSix: $36045e57d0ad82eb$export$3397c7b4679acccc,
    faDiceThree: $36045e57d0ad82eb$export$221059e0d5fd8958,
    faDiceTwo: $36045e57d0ad82eb$export$4d85df590065572f,
    faDigitalTachograph: $36045e57d0ad82eb$export$b3bf1994f0fefe98,
    faDirections: $36045e57d0ad82eb$export$6a6973de44442fe5,
    faDisease: $36045e57d0ad82eb$export$c7675a37487adc45,
    faDivide: $36045e57d0ad82eb$export$89fa217ec5503ac9,
    faDizzy: $36045e57d0ad82eb$export$89a2b10dabc487e8,
    faDna: $36045e57d0ad82eb$export$c062100d54a2da00,
    faDog: $36045e57d0ad82eb$export$c6406747800cf702,
    faDollarSign: $36045e57d0ad82eb$export$fb420d3e4d8c6a18,
    faDolly: $36045e57d0ad82eb$export$5879d0bca1aa497b,
    faDollyFlatbed: $36045e57d0ad82eb$export$f7c6efb60c53b285,
    faDonate: $36045e57d0ad82eb$export$40050ae52860cde7,
    faDoorClosed: $36045e57d0ad82eb$export$2c79e1a422528bba,
    faDoorOpen: $36045e57d0ad82eb$export$41821b9a6fd703de,
    faDotCircle: $36045e57d0ad82eb$export$92bc269cb244d66a,
    faDove: $36045e57d0ad82eb$export$a1ab1e69a300089f,
    faDownload: $36045e57d0ad82eb$export$8f734e51d72ca13a,
    faDraftingCompass: $36045e57d0ad82eb$export$c8c2b127d13b9d79,
    faDragon: $36045e57d0ad82eb$export$ae1875ba975aa0e9,
    faDrawPolygon: $36045e57d0ad82eb$export$df9bd3777d1154d2,
    faDrum: $36045e57d0ad82eb$export$5b9205e1042594b7,
    faDrumSteelpan: $36045e57d0ad82eb$export$48d1206500db2e9d,
    faDrumstickBite: $36045e57d0ad82eb$export$482976e9a4ab10f3,
    faDumbbell: $36045e57d0ad82eb$export$56700074cf37be5c,
    faDumpster: $36045e57d0ad82eb$export$3b934e22d1851a3b,
    faDumpsterFire: $36045e57d0ad82eb$export$25e9b29b3f2230b5,
    faDungeon: $36045e57d0ad82eb$export$1156dc6acb0058bd,
    faEdit: $36045e57d0ad82eb$export$7be713e57d023733,
    faEgg: $36045e57d0ad82eb$export$1199a8ce85311ab5,
    faEject: $36045e57d0ad82eb$export$8484041d5b209494,
    faEllipsisH: $36045e57d0ad82eb$export$c9f2fedd4489a2ee,
    faEllipsisV: $36045e57d0ad82eb$export$e58494c7fcb5380,
    faEnvelope: $36045e57d0ad82eb$export$6f095630677adc,
    faEnvelopeOpen: $36045e57d0ad82eb$export$c6c3bd5f7d9b8bf2,
    faEnvelopeOpenText: $36045e57d0ad82eb$export$f5c53ce8ec380d11,
    faEnvelopeSquare: $36045e57d0ad82eb$export$354e159473e73552,
    faEquals: $36045e57d0ad82eb$export$a7c5f5e4805fdab,
    faEraser: $36045e57d0ad82eb$export$e7fc4fe34e767f28,
    faEthernet: $36045e57d0ad82eb$export$6bad2c9f317b52e5,
    faEuroSign: $36045e57d0ad82eb$export$902a3969bb113dff,
    faExchangeAlt: $36045e57d0ad82eb$export$f6c6fb20d374b128,
    faExclamation: $36045e57d0ad82eb$export$de6218b649cbb6a9,
    faExclamationCircle: $36045e57d0ad82eb$export$220e07e14c5d7e5d,
    faExclamationTriangle: $36045e57d0ad82eb$export$3d249b63b52cce7c,
    faExpand: $36045e57d0ad82eb$export$1fe4a9976a241685,
    faExpandAlt: $36045e57d0ad82eb$export$bcb8d86a3a1d6eb6,
    faExpandArrowsAlt: $36045e57d0ad82eb$export$6219dcd88b5fa6c2,
    faExternalLinkAlt: $36045e57d0ad82eb$export$d7f107e456ab0306,
    faExternalLinkSquareAlt: $36045e57d0ad82eb$export$e4cdf2977151ee26,
    faEye: $36045e57d0ad82eb$export$b8c3e79e8c99c95b,
    faEyeDropper: $36045e57d0ad82eb$export$1bc3e0ad56dc9eb0,
    faEyeSlash: $36045e57d0ad82eb$export$ed3f2918429d029a,
    faFan: $36045e57d0ad82eb$export$55145a3dae4f984a,
    faFastBackward: $36045e57d0ad82eb$export$e6246a3279a379b8,
    faFastForward: $36045e57d0ad82eb$export$61a8cdc53c2e078d,
    faFaucet: $36045e57d0ad82eb$export$a0856b225f3b0614,
    faFax: $36045e57d0ad82eb$export$b5698497901d7197,
    faFeather: $36045e57d0ad82eb$export$5e19aea195b31816,
    faFeatherAlt: $36045e57d0ad82eb$export$68cf766c786bcd78,
    faFemale: $36045e57d0ad82eb$export$70e8e75e61dd7169,
    faFighterJet: $36045e57d0ad82eb$export$102b809faf56e033,
    faFile: $36045e57d0ad82eb$export$cad54bead856a678,
    faFileAlt: $36045e57d0ad82eb$export$243b47dca32bf0b8,
    faFileArchive: $36045e57d0ad82eb$export$bf2047a9946b5c3f,
    faFileAudio: $36045e57d0ad82eb$export$b8d24c57c9e64933,
    faFileCode: $36045e57d0ad82eb$export$143d0ca7d2200f20,
    faFileContract: $36045e57d0ad82eb$export$70fde3f3fdaa6a6a,
    faFileCsv: $36045e57d0ad82eb$export$82cea4f586f6ec9,
    faFileDownload: $36045e57d0ad82eb$export$1013b9966d758343,
    faFileExcel: $36045e57d0ad82eb$export$77cb1a465c4fe84,
    faFileExport: $36045e57d0ad82eb$export$364f19abcfac1b0a,
    faFileImage: $36045e57d0ad82eb$export$6440b286d3cbac9b,
    faFileImport: $36045e57d0ad82eb$export$d796c05153b1255c,
    faFileInvoice: $36045e57d0ad82eb$export$bef39294aed2281a,
    faFileInvoiceDollar: $36045e57d0ad82eb$export$a3dced32d48cb1ea,
    faFileMedical: $36045e57d0ad82eb$export$56cbcd962389b090,
    faFileMedicalAlt: $36045e57d0ad82eb$export$ef02a0f5b39aa61f,
    faFilePdf: $36045e57d0ad82eb$export$38611f1c776aba73,
    faFilePowerpoint: $36045e57d0ad82eb$export$c341daeecdea449a,
    faFilePrescription: $36045e57d0ad82eb$export$a20cb90865b6beb8,
    faFileSignature: $36045e57d0ad82eb$export$d0de575ac166712b,
    faFileUpload: $36045e57d0ad82eb$export$dd55ded1264643d2,
    faFileVideo: $36045e57d0ad82eb$export$b44eb38345c6a964,
    faFileWord: $36045e57d0ad82eb$export$f0858dff6e769cf6,
    faFill: $36045e57d0ad82eb$export$d3c2bcfd3b861e4a,
    faFillDrip: $36045e57d0ad82eb$export$38320138fc0262d0,
    faFilm: $36045e57d0ad82eb$export$c03de0cc616e77bb,
    faFilter: $36045e57d0ad82eb$export$f253a38d7142e29f,
    faFingerprint: $36045e57d0ad82eb$export$614dc068d88655af,
    faFire: $36045e57d0ad82eb$export$7b24b34ef6cc130c,
    faFireAlt: $36045e57d0ad82eb$export$70dc26b4926d0b1b,
    faFireExtinguisher: $36045e57d0ad82eb$export$d75fb6743634a0a,
    faFirstAid: $36045e57d0ad82eb$export$5b01ccb2da4c4387,
    faFish: $36045e57d0ad82eb$export$24228a855c5f6812,
    faFistRaised: $36045e57d0ad82eb$export$fa0323a4d7489a8d,
    faFlag: $36045e57d0ad82eb$export$6591b1ea509be9da,
    faFlagCheckered: $36045e57d0ad82eb$export$92fad97e19a9fea,
    faFlagUsa: $36045e57d0ad82eb$export$19357abad396e723,
    faFlask: $36045e57d0ad82eb$export$f9b579ba06048af,
    faFlushed: $36045e57d0ad82eb$export$dfd2bd012685aeac,
    faFolder: $36045e57d0ad82eb$export$72b780186370e953,
    faFolderMinus: $36045e57d0ad82eb$export$758f1fb3784e4080,
    faFolderOpen: $36045e57d0ad82eb$export$ff7e93418af88b78,
    faFolderPlus: $36045e57d0ad82eb$export$e18e05ffa2045d3b,
    faFont: $36045e57d0ad82eb$export$a5dc297d3f60936,
    faFontAwesomeLogoFull: $36045e57d0ad82eb$export$6e20d421a2e0f320,
    faFootballBall: $36045e57d0ad82eb$export$e8fd664711e31704,
    faForward: $36045e57d0ad82eb$export$a8710cdb23198d53,
    faFrog: $36045e57d0ad82eb$export$fe2358263efac504,
    faFrown: $36045e57d0ad82eb$export$43b7108508aecc5f,
    faFrownOpen: $36045e57d0ad82eb$export$c4775e66bed5d96,
    faFunnelDollar: $36045e57d0ad82eb$export$cebe38ad8f0a143d,
    faFutbol: $36045e57d0ad82eb$export$65a345b33858a655,
    faGamepad: $36045e57d0ad82eb$export$6a66b1b639455bef,
    faGasPump: $36045e57d0ad82eb$export$84666c793cb2a347,
    faGavel: $36045e57d0ad82eb$export$c36fb40057e2c3aa,
    faGem: $36045e57d0ad82eb$export$31ee86ac717db552,
    faGenderless: $36045e57d0ad82eb$export$c093cc22e88981c2,
    faGhost: $36045e57d0ad82eb$export$1a989eb1919c64c1,
    faGift: $36045e57d0ad82eb$export$b2727de8ccdbb5ec,
    faGifts: $36045e57d0ad82eb$export$de9a67b55dbe819a,
    faGlassCheers: $36045e57d0ad82eb$export$20007d7d74cb98fe,
    faGlassMartini: $36045e57d0ad82eb$export$e96f280e39af4a91,
    faGlassMartiniAlt: $36045e57d0ad82eb$export$2258439b8f4e7acb,
    faGlassWhiskey: $36045e57d0ad82eb$export$fdec0f5f1a169419,
    faGlasses: $36045e57d0ad82eb$export$58d7d709c0a8ca5f,
    faGlobe: $36045e57d0ad82eb$export$b1b1cdce4a19c682,
    faGlobeAfrica: $36045e57d0ad82eb$export$64af36f3b403a57c,
    faGlobeAmericas: $36045e57d0ad82eb$export$e96bcc7bde9498db,
    faGlobeAsia: $36045e57d0ad82eb$export$796fdfc909e603f4,
    faGlobeEurope: $36045e57d0ad82eb$export$5318b8ede86cc96b,
    faGolfBall: $36045e57d0ad82eb$export$2251487a9a33c682,
    faGopuram: $36045e57d0ad82eb$export$31f89d8ac1d14ed6,
    faGraduationCap: $36045e57d0ad82eb$export$874e305fd7920cce,
    faGreaterThan: $36045e57d0ad82eb$export$da07b6bc24a496ca,
    faGreaterThanEqual: $36045e57d0ad82eb$export$7bf8dfe2e6661a54,
    faGrimace: $36045e57d0ad82eb$export$3d08cd36ac1ef231,
    faGrin: $36045e57d0ad82eb$export$37e1f10b6de76621,
    faGrinAlt: $36045e57d0ad82eb$export$b4abebfe416d36ba,
    faGrinBeam: $36045e57d0ad82eb$export$734da5249381ec7e,
    faGrinBeamSweat: $36045e57d0ad82eb$export$14d0ccc54c5b6826,
    faGrinHearts: $36045e57d0ad82eb$export$c56cf0e0c3bc5ed2,
    faGrinSquint: $36045e57d0ad82eb$export$243ae757907b1580,
    faGrinSquintTears: $36045e57d0ad82eb$export$542206d6a85f3b42,
    faGrinStars: $36045e57d0ad82eb$export$64347a5c8c402ef4,
    faGrinTears: $36045e57d0ad82eb$export$b2f7512221512b5b,
    faGrinTongue: $36045e57d0ad82eb$export$ef222816a43a4b3a,
    faGrinTongueSquint: $36045e57d0ad82eb$export$4edf34c3def09a31,
    faGrinTongueWink: $36045e57d0ad82eb$export$58099903d50aefb3,
    faGrinWink: $36045e57d0ad82eb$export$2397fcd34eb12177,
    faGripHorizontal: $36045e57d0ad82eb$export$4a45308d6c8decc1,
    faGripLines: $36045e57d0ad82eb$export$1412f35381064d7d,
    faGripLinesVertical: $36045e57d0ad82eb$export$523960de087f5198,
    faGripVertical: $36045e57d0ad82eb$export$cacbd95c283996ec,
    faGuitar: $36045e57d0ad82eb$export$790dd5b32282b6fb,
    faHSquare: $36045e57d0ad82eb$export$f08bbcf8f59eafc2,
    faHamburger: $36045e57d0ad82eb$export$bab3bb9f4f59363,
    faHammer: $36045e57d0ad82eb$export$6310f315e1ebbca5,
    faHamsa: $36045e57d0ad82eb$export$38d20d399463edf9,
    faHandHolding: $36045e57d0ad82eb$export$e6094d25274088ab,
    faHandHoldingHeart: $36045e57d0ad82eb$export$97e5ef3e80a0fbef,
    faHandHoldingMedical: $36045e57d0ad82eb$export$bb2a6b1b5e852300,
    faHandHoldingUsd: $36045e57d0ad82eb$export$47d27bc305b59690,
    faHandHoldingWater: $36045e57d0ad82eb$export$4265371b99d38b95,
    faHandLizard: $36045e57d0ad82eb$export$54608d0a883fea4d,
    faHandMiddleFinger: $36045e57d0ad82eb$export$bd40d3a3a16fb147,
    faHandPaper: $36045e57d0ad82eb$export$6e6216c8b50471bb,
    faHandPeace: $36045e57d0ad82eb$export$e49e3cfceea441cc,
    faHandPointDown: $36045e57d0ad82eb$export$f6dcbf0a940428f4,
    faHandPointLeft: $36045e57d0ad82eb$export$b276ec3dc9760d39,
    faHandPointRight: $36045e57d0ad82eb$export$f7bc8714c970afa4,
    faHandPointUp: $36045e57d0ad82eb$export$cdc9f5e7e94e76da,
    faHandPointer: $36045e57d0ad82eb$export$d97ff927c450c87f,
    faHandRock: $36045e57d0ad82eb$export$97a81eba394c8c44,
    faHandScissors: $36045e57d0ad82eb$export$c578e919f2c5c135,
    faHandSparkles: $36045e57d0ad82eb$export$72e2d874a963de0c,
    faHandSpock: $36045e57d0ad82eb$export$2262d6b626de1120,
    faHands: $36045e57d0ad82eb$export$f9712d0cf5150f0c,
    faHandsHelping: $36045e57d0ad82eb$export$287dbb1632da0d44,
    faHandsWash: $36045e57d0ad82eb$export$996b5dea53b124e3,
    faHandshake: $36045e57d0ad82eb$export$b4c63e9bfc7906f1,
    faHandshakeAltSlash: $36045e57d0ad82eb$export$ca302f956ae9f1bf,
    faHandshakeSlash: $36045e57d0ad82eb$export$2cef3f81ad90fb76,
    faHanukiah: $36045e57d0ad82eb$export$3dcd4ca3f7108a82,
    faHardHat: $36045e57d0ad82eb$export$7b72177558a98b6f,
    faHashtag: $36045e57d0ad82eb$export$c92c903bade56844,
    faHatCowboy: $36045e57d0ad82eb$export$37672611144b857b,
    faHatCowboySide: $36045e57d0ad82eb$export$ab6f71fd6878da90,
    faHatWizard: $36045e57d0ad82eb$export$7daa48199dcb2ad1,
    faHdd: $36045e57d0ad82eb$export$62551e9c5ba7093f,
    faHeadSideCough: $36045e57d0ad82eb$export$3cd04b7c1624f598,
    faHeadSideCoughSlash: $36045e57d0ad82eb$export$b293ee8fb8e6b0c4,
    faHeadSideMask: $36045e57d0ad82eb$export$280300af4baa1a3e,
    faHeadSideVirus: $36045e57d0ad82eb$export$5b64b916710da7c7,
    faHeading: $36045e57d0ad82eb$export$4805b8d175aeb9fb,
    faHeadphones: $36045e57d0ad82eb$export$ad02dd8ca5816958,
    faHeadphonesAlt: $36045e57d0ad82eb$export$6f0433fa527dd5be,
    faHeadset: $36045e57d0ad82eb$export$23b086400a31acfe,
    faHeart: $36045e57d0ad82eb$export$e4b51a47a2f8b9db,
    faHeartBroken: $36045e57d0ad82eb$export$4a565395cb65b282,
    faHeartbeat: $36045e57d0ad82eb$export$ca880e19206e80aa,
    faHelicopter: $36045e57d0ad82eb$export$612d3e1afaf45fa5,
    faHighlighter: $36045e57d0ad82eb$export$73801ed54b42fabe,
    faHiking: $36045e57d0ad82eb$export$b2ab0105a901499e,
    faHippo: $36045e57d0ad82eb$export$d4c909619093de2d,
    faHistory: $36045e57d0ad82eb$export$76d1986559ca7b7a,
    faHockeyPuck: $36045e57d0ad82eb$export$a274b02dc75663dc,
    faHollyBerry: $36045e57d0ad82eb$export$273296afacf93991,
    faHome: $36045e57d0ad82eb$export$48f10d71ec526479,
    faHorse: $36045e57d0ad82eb$export$5b05f097fa38352a,
    faHorseHead: $36045e57d0ad82eb$export$5bcca85203ebd1e8,
    faHospital: $36045e57d0ad82eb$export$7a76c9d35b42d691,
    faHospitalAlt: $36045e57d0ad82eb$export$cea7736417b94a3b,
    faHospitalSymbol: $36045e57d0ad82eb$export$c8a3c78d99c23fed,
    faHospitalUser: $36045e57d0ad82eb$export$684703c93d630cc5,
    faHotTub: $36045e57d0ad82eb$export$4842af92b516c40b,
    faHotdog: $36045e57d0ad82eb$export$9fae219b4d3ce0be,
    faHotel: $36045e57d0ad82eb$export$c402efcf01d5ca07,
    faHourglass: $36045e57d0ad82eb$export$b9098a890f61e022,
    faHourglassEnd: $36045e57d0ad82eb$export$52757ecc5b1e25b9,
    faHourglassHalf: $36045e57d0ad82eb$export$703272eebf5e3eea,
    faHourglassStart: $36045e57d0ad82eb$export$f0c28584caa8f4b,
    faHouseDamage: $36045e57d0ad82eb$export$8d7e943005ce0b49,
    faHouseUser: $36045e57d0ad82eb$export$9a513ee921e8e885,
    faHryvnia: $36045e57d0ad82eb$export$33d5f94bd6f75f59,
    faICursor: $36045e57d0ad82eb$export$7fddf76ec23943d8,
    faIceCream: $36045e57d0ad82eb$export$dd52741c60cc638f,
    faIcicles: $36045e57d0ad82eb$export$78792ed87d92a3ad,
    faIcons: $36045e57d0ad82eb$export$7fe2894454d8eb8a,
    faIdBadge: $36045e57d0ad82eb$export$a75288855ea05282,
    faIdCard: $36045e57d0ad82eb$export$782ac893fc22249b,
    faIdCardAlt: $36045e57d0ad82eb$export$dc37ebbac31f6c6c,
    faIgloo: $36045e57d0ad82eb$export$4a284575edd6f1af,
    faImage: $36045e57d0ad82eb$export$7e9f0928967e03b,
    faImages: $36045e57d0ad82eb$export$74f06b41ed2ca28a,
    faInbox: $36045e57d0ad82eb$export$366b69cbdce46334,
    faIndent: $36045e57d0ad82eb$export$318208bc30aeebcc,
    faIndustry: $36045e57d0ad82eb$export$5548c3eb51060fa8,
    faInfinity: $36045e57d0ad82eb$export$a590003279d671b8,
    faInfo: $36045e57d0ad82eb$export$d469b770895f47ac,
    faInfoCircle: $36045e57d0ad82eb$export$aa9288aeadf882fa,
    faItalic: $36045e57d0ad82eb$export$16e344bae4d495ed,
    faJedi: $36045e57d0ad82eb$export$859f204e59641ca4,
    faJoint: $36045e57d0ad82eb$export$e5a289fb22ffb8cb,
    faJournalWhills: $36045e57d0ad82eb$export$66a0d8d45aab6631,
    faKaaba: $36045e57d0ad82eb$export$ab1408bfbe914cc9,
    faKey: $36045e57d0ad82eb$export$fa6ecc35e7315db,
    faKeyboard: $36045e57d0ad82eb$export$fb61df5d98785fa8,
    faKhanda: $36045e57d0ad82eb$export$8d41d1f1ba3f9217,
    faKiss: $36045e57d0ad82eb$export$c762a77aabf64fd0,
    faKissBeam: $36045e57d0ad82eb$export$d6ff8a73c0812e63,
    faKissWinkHeart: $36045e57d0ad82eb$export$ebba617701dfb917,
    faKiwiBird: $36045e57d0ad82eb$export$d9933d91e1314d02,
    faLandmark: $36045e57d0ad82eb$export$2bebc54c51db6505,
    faLanguage: $36045e57d0ad82eb$export$8a7bee49fdf8c954,
    faLaptop: $36045e57d0ad82eb$export$c2dee3bd177275a2,
    faLaptopCode: $36045e57d0ad82eb$export$94100f4c6ee29932,
    faLaptopHouse: $36045e57d0ad82eb$export$efd983de5e4d6ad3,
    faLaptopMedical: $36045e57d0ad82eb$export$ba2fa38f7bcc6930,
    faLaugh: $36045e57d0ad82eb$export$6c74e314e801a4fe,
    faLaughBeam: $36045e57d0ad82eb$export$a88d1f4073ea9369,
    faLaughSquint: $36045e57d0ad82eb$export$b206e700cf7084e1,
    faLaughWink: $36045e57d0ad82eb$export$77ac40095f39933e,
    faLayerGroup: $36045e57d0ad82eb$export$a137712e11e257dd,
    faLeaf: $36045e57d0ad82eb$export$7c497bae2754a087,
    faLemon: $36045e57d0ad82eb$export$4fbda8f64648f3b5,
    faLessThan: $36045e57d0ad82eb$export$7f24f1bf98af5411,
    faLessThanEqual: $36045e57d0ad82eb$export$b2c723344cff0d8,
    faLevelDownAlt: $36045e57d0ad82eb$export$c07eb6ff5a382cbd,
    faLevelUpAlt: $36045e57d0ad82eb$export$d6f21a309b179c3d,
    faLifeRing: $36045e57d0ad82eb$export$53dd2cacf674142a,
    faLightbulb: $36045e57d0ad82eb$export$1e80f89fe84a215b,
    faLink: $36045e57d0ad82eb$export$88bc01ff8dbecc55,
    faLiraSign: $36045e57d0ad82eb$export$f0f37dbc60110b10,
    faList: $36045e57d0ad82eb$export$6cfc59842fedbc16,
    faListAlt: $36045e57d0ad82eb$export$c6327a203ffc65a3,
    faListOl: $36045e57d0ad82eb$export$3db8f67cd0fc963b,
    faListUl: $36045e57d0ad82eb$export$f8a219cf4f516384,
    faLocationArrow: $36045e57d0ad82eb$export$4ac9c4c370f7b157,
    faLock: $36045e57d0ad82eb$export$7aa08ad5d562578a,
    faLockOpen: $36045e57d0ad82eb$export$84b5acad4436d02a,
    faLongArrowAltDown: $36045e57d0ad82eb$export$8b92530ca6418c2f,
    faLongArrowAltLeft: $36045e57d0ad82eb$export$a8b3226b2bf323d,
    faLongArrowAltRight: $36045e57d0ad82eb$export$533e1f578f74c066,
    faLongArrowAltUp: $36045e57d0ad82eb$export$43c8f2a46326c55f,
    faLowVision: $36045e57d0ad82eb$export$7a65d2aa54cb4e93,
    faLuggageCart: $36045e57d0ad82eb$export$bd1e24dd3cde8514,
    faLungs: $36045e57d0ad82eb$export$ba9b387e84727819,
    faLungsVirus: $36045e57d0ad82eb$export$895159d10626af74,
    faMagic: $36045e57d0ad82eb$export$e58f9b502d4dd52d,
    faMagnet: $36045e57d0ad82eb$export$78932e9c9abea6b7,
    faMailBulk: $36045e57d0ad82eb$export$dd24f40c5337e2e1,
    faMale: $36045e57d0ad82eb$export$2e21f9dba1630651,
    faMap: $36045e57d0ad82eb$export$fc82fb79180cd17c,
    faMapMarked: $36045e57d0ad82eb$export$df04458e7e32352c,
    faMapMarkedAlt: $36045e57d0ad82eb$export$a977d47c74d8e86c,
    faMapMarker: $36045e57d0ad82eb$export$10d360e4f1a554dd,
    faMapMarkerAlt: $36045e57d0ad82eb$export$4be92fa780613f93,
    faMapPin: $36045e57d0ad82eb$export$184725965b3402dc,
    faMapSigns: $36045e57d0ad82eb$export$743f4b1071b3333a,
    faMarker: $36045e57d0ad82eb$export$e6789173649caa25,
    faMars: $36045e57d0ad82eb$export$a9f5c0b9c1e77a6f,
    faMarsDouble: $36045e57d0ad82eb$export$2f8a28204bb4b86f,
    faMarsStroke: $36045e57d0ad82eb$export$aa05fce255a5d269,
    faMarsStrokeH: $36045e57d0ad82eb$export$5cb0daeafbcdabe3,
    faMarsStrokeV: $36045e57d0ad82eb$export$ed7aa1c25104f333,
    faMask: $36045e57d0ad82eb$export$7b028758c03b9655,
    faMedal: $36045e57d0ad82eb$export$b48a5be96314835a,
    faMedkit: $36045e57d0ad82eb$export$e75f02bae5b7d34b,
    faMeh: $36045e57d0ad82eb$export$6d2db489aaeeecd2,
    faMehBlank: $36045e57d0ad82eb$export$e945435725f71e88,
    faMehRollingEyes: $36045e57d0ad82eb$export$fdc62a1bea767cc2,
    faMemory: $36045e57d0ad82eb$export$5f9bd9f6df021f93,
    faMenorah: $36045e57d0ad82eb$export$232452c59d77c56e,
    faMercury: $36045e57d0ad82eb$export$e134ecd00b622a47,
    faMeteor: $36045e57d0ad82eb$export$1439f0d6365138da,
    faMicrochip: $36045e57d0ad82eb$export$4a7bb4be15f35178,
    faMicrophone: $36045e57d0ad82eb$export$eed3c491effe6d12,
    faMicrophoneAlt: $36045e57d0ad82eb$export$f08ef94fea14f5ac,
    faMicrophoneAltSlash: $36045e57d0ad82eb$export$d2a53a388f30780,
    faMicrophoneSlash: $36045e57d0ad82eb$export$843f63d64e6f7951,
    faMicroscope: $36045e57d0ad82eb$export$6a99139787bf9967,
    faMinus: $36045e57d0ad82eb$export$fee0376c250cdef,
    faMinusCircle: $36045e57d0ad82eb$export$f3979b49bf57313c,
    faMinusSquare: $36045e57d0ad82eb$export$ffe9387966b3e681,
    faMitten: $36045e57d0ad82eb$export$5030322c5fc886d7,
    faMobile: $36045e57d0ad82eb$export$59edacfad04cd121,
    faMobileAlt: $36045e57d0ad82eb$export$e9599bc6cd92234d,
    faMoneyBill: $36045e57d0ad82eb$export$608138a7337b5d1a,
    faMoneyBillAlt: $36045e57d0ad82eb$export$a35d573395884c3d,
    faMoneyBillWave: $36045e57d0ad82eb$export$53e23123cc9a6796,
    faMoneyBillWaveAlt: $36045e57d0ad82eb$export$1613858e873cbb3e,
    faMoneyCheck: $36045e57d0ad82eb$export$be069f641c85d0b3,
    faMoneyCheckAlt: $36045e57d0ad82eb$export$8c6ccc9745897cb2,
    faMonument: $36045e57d0ad82eb$export$6f9b0bfc012deb25,
    faMoon: $36045e57d0ad82eb$export$c4c2f69a53bab720,
    faMortarPestle: $36045e57d0ad82eb$export$55ceb5d0c144580a,
    faMosque: $36045e57d0ad82eb$export$4999586d7e1087fb,
    faMotorcycle: $36045e57d0ad82eb$export$f26017bdca99338d,
    faMountain: $36045e57d0ad82eb$export$64f9eb99c9749cce,
    faMouse: $36045e57d0ad82eb$export$198b96b894c66074,
    faMousePointer: $36045e57d0ad82eb$export$2e19a69cc26b147,
    faMugHot: $36045e57d0ad82eb$export$47a822c30184e8af,
    faMusic: $36045e57d0ad82eb$export$fcb0647a5340b5b8,
    faNetworkWired: $36045e57d0ad82eb$export$882cabd11f4943b8,
    faNeuter: $36045e57d0ad82eb$export$771cf879fba0cf93,
    faNewspaper: $36045e57d0ad82eb$export$d91b374112d4f8c1,
    faNotEqual: $36045e57d0ad82eb$export$6a15ccae09bbaf93,
    faNotesMedical: $36045e57d0ad82eb$export$b2d79133c81d6697,
    faObjectGroup: $36045e57d0ad82eb$export$40cdac24aa94a57a,
    faObjectUngroup: $36045e57d0ad82eb$export$887f6345573abcac,
    faOilCan: $36045e57d0ad82eb$export$2599126c3a57f727,
    faOm: $36045e57d0ad82eb$export$8de8eb94230028a5,
    faOtter: $36045e57d0ad82eb$export$743cce3ca4eb1d7d,
    faOutdent: $36045e57d0ad82eb$export$e21cfc4f23776bff,
    faPager: $36045e57d0ad82eb$export$e1611f373a10a98c,
    faPaintBrush: $36045e57d0ad82eb$export$594db3339e212bc9,
    faPaintRoller: $36045e57d0ad82eb$export$d1de8d1b815d6a5,
    faPalette: $36045e57d0ad82eb$export$5c390baea5db4f77,
    faPallet: $36045e57d0ad82eb$export$d7ff2047dbc34562,
    faPaperPlane: $36045e57d0ad82eb$export$b5378818301da1be,
    faPaperclip: $36045e57d0ad82eb$export$4b24ca1552f410af,
    faParachuteBox: $36045e57d0ad82eb$export$ca9e3368f1d9500a,
    faParagraph: $36045e57d0ad82eb$export$dec46f8df1860e0,
    faParking: $36045e57d0ad82eb$export$fda29c8f99573a4e,
    faPassport: $36045e57d0ad82eb$export$2c31ca0d9bee400f,
    faPastafarianism: $36045e57d0ad82eb$export$733efdaec97447be,
    faPaste: $36045e57d0ad82eb$export$6f95f90dd1f6d86b,
    faPause: $36045e57d0ad82eb$export$da79f048408b1722,
    faPauseCircle: $36045e57d0ad82eb$export$d8cf08a0362da8db,
    faPaw: $36045e57d0ad82eb$export$7bc6e4d977673e69,
    faPeace: $36045e57d0ad82eb$export$8614cb1326eacd7a,
    faPen: $36045e57d0ad82eb$export$8f4567331fb0d3bc,
    faPenAlt: $36045e57d0ad82eb$export$a3d3e92e430d3beb,
    faPenFancy: $36045e57d0ad82eb$export$8bdfe14ac72a8b17,
    faPenNib: $36045e57d0ad82eb$export$a82594dcc75a49f5,
    faPenSquare: $36045e57d0ad82eb$export$fbb231ccb3d960bc,
    faPencilAlt: $36045e57d0ad82eb$export$8210adc172262df,
    faPencilRuler: $36045e57d0ad82eb$export$e3a7a1affea005f5,
    faPeopleArrows: $36045e57d0ad82eb$export$804bfc5c390e1a2a,
    faPeopleCarry: $36045e57d0ad82eb$export$35fbd4ff1265acd5,
    faPepperHot: $36045e57d0ad82eb$export$4894bf28f771e1f3,
    faPercent: $36045e57d0ad82eb$export$89a1764fbb7ad2cb,
    faPercentage: $36045e57d0ad82eb$export$89333857fc063a2e,
    faPersonBooth: $36045e57d0ad82eb$export$2337c975289bdd84,
    faPhone: $36045e57d0ad82eb$export$ddab067855cf34cb,
    faPhoneAlt: $36045e57d0ad82eb$export$a07a9b305deebf32,
    faPhoneSlash: $36045e57d0ad82eb$export$4c60a3aade08b6c2,
    faPhoneSquare: $36045e57d0ad82eb$export$8ba22605a641ebdf,
    faPhoneSquareAlt: $36045e57d0ad82eb$export$a41e77f0de98bba7,
    faPhoneVolume: $36045e57d0ad82eb$export$c377f240bb8b5d74,
    faPhotoVideo: $36045e57d0ad82eb$export$739f6a6a12dfb6ed,
    faPiggyBank: $36045e57d0ad82eb$export$46d49a6734c4872a,
    faPills: $36045e57d0ad82eb$export$6380e2ed6e69d350,
    faPizzaSlice: $36045e57d0ad82eb$export$c9f93c4667edc585,
    faPlaceOfWorship: $36045e57d0ad82eb$export$c5a9302c8c13c79a,
    faPlane: $36045e57d0ad82eb$export$f654c69e66b466c0,
    faPlaneArrival: $36045e57d0ad82eb$export$9b2dbe133273f284,
    faPlaneDeparture: $36045e57d0ad82eb$export$6ccbeeccfea6dc8a,
    faPlaneSlash: $36045e57d0ad82eb$export$cfee4df0d5df6d21,
    faPlay: $36045e57d0ad82eb$export$436587205947bca5,
    faPlayCircle: $36045e57d0ad82eb$export$cf04333781061c5e,
    faPlug: $36045e57d0ad82eb$export$cae5752c3e3b6545,
    faPlus: $36045e57d0ad82eb$export$a105e7b44ca0eb9e,
    faPlusCircle: $36045e57d0ad82eb$export$d9cc3a81499af48c,
    faPlusSquare: $36045e57d0ad82eb$export$b6359eebfe900c35,
    faPodcast: $36045e57d0ad82eb$export$5c0b4709125e92f8,
    faPoll: $36045e57d0ad82eb$export$bc8ca14ab51f93db,
    faPollH: $36045e57d0ad82eb$export$456a238f0144d430,
    faPoo: $36045e57d0ad82eb$export$dd0ede1713d2d2f9,
    faPooStorm: $36045e57d0ad82eb$export$48a38da471b097a2,
    faPoop: $36045e57d0ad82eb$export$bb45b6b87d1adf27,
    faPortrait: $36045e57d0ad82eb$export$e3d25f819c7ee7d7,
    faPoundSign: $36045e57d0ad82eb$export$9ce041dfec8319b,
    faPowerOff: $36045e57d0ad82eb$export$a1cca9928dcf9798,
    faPray: $36045e57d0ad82eb$export$3b32c982141cad51,
    faPrayingHands: $36045e57d0ad82eb$export$95e08e91b0929943,
    faPrescription: $36045e57d0ad82eb$export$8767bafb19515ee4,
    faPrescriptionBottle: $36045e57d0ad82eb$export$214f9ce665590486,
    faPrescriptionBottleAlt: $36045e57d0ad82eb$export$65d1c884b8581d1a,
    faPrint: $36045e57d0ad82eb$export$ae64371e02ee8e56,
    faProcedures: $36045e57d0ad82eb$export$5f9e1870e1866dde,
    faProjectDiagram: $36045e57d0ad82eb$export$30bf9f5b96509df1,
    faPumpMedical: $36045e57d0ad82eb$export$f1b881c73328720c,
    faPumpSoap: $36045e57d0ad82eb$export$821aeede187f23c9,
    faPuzzlePiece: $36045e57d0ad82eb$export$7ee0dbd1e92e2859,
    faQrcode: $36045e57d0ad82eb$export$fc19ca0fe15e73bc,
    faQuestion: $36045e57d0ad82eb$export$d96973f90e8f6e47,
    faQuestionCircle: $36045e57d0ad82eb$export$5ba67d7f2265c1a5,
    faQuidditch: $36045e57d0ad82eb$export$c00c446e6db1605f,
    faQuoteLeft: $36045e57d0ad82eb$export$932a67a1b1a7a724,
    faQuoteRight: $36045e57d0ad82eb$export$54e3a80c9875b74c,
    faQuran: $36045e57d0ad82eb$export$46f29ea84ed4c5f1,
    faRadiation: $36045e57d0ad82eb$export$4c4e509518093d6d,
    faRadiationAlt: $36045e57d0ad82eb$export$2f048fa82bbddf6f,
    faRainbow: $36045e57d0ad82eb$export$92ab27739d3a91b2,
    faRandom: $36045e57d0ad82eb$export$8357bf8cc666d5f0,
    faReceipt: $36045e57d0ad82eb$export$32b0cd6133c2742,
    faRecordVinyl: $36045e57d0ad82eb$export$fe2d5012d9982673,
    faRecycle: $36045e57d0ad82eb$export$a65c441f12cb6bd,
    faRedo: $36045e57d0ad82eb$export$3d9f98aa1c24c776,
    faRedoAlt: $36045e57d0ad82eb$export$50c037520c6cfdc1,
    faRegistered: $36045e57d0ad82eb$export$5f519e9ac15ab8c3,
    faRemoveFormat: $36045e57d0ad82eb$export$d91179f327329532,
    faReply: $36045e57d0ad82eb$export$bb06d4a7bb6736fe,
    faReplyAll: $36045e57d0ad82eb$export$ca6fd367f31ecbc5,
    faRepublican: $36045e57d0ad82eb$export$929518bb4b66a588,
    faRestroom: $36045e57d0ad82eb$export$5fbcef35138741a5,
    faRetweet: $36045e57d0ad82eb$export$cebc76f79478e40e,
    faRibbon: $36045e57d0ad82eb$export$838459d11f3971df,
    faRing: $36045e57d0ad82eb$export$a95486586631edc7,
    faRoad: $36045e57d0ad82eb$export$f224567a4851a5e9,
    faRobot: $36045e57d0ad82eb$export$30a5bb4ad3fa716c,
    faRocket: $36045e57d0ad82eb$export$b24d84ed5657d89a,
    faRoute: $36045e57d0ad82eb$export$806c0a45a7ecd6e8,
    faRss: $36045e57d0ad82eb$export$7329a1ca27b90c5b,
    faRssSquare: $36045e57d0ad82eb$export$89c9b1cca2c11484,
    faRubleSign: $36045e57d0ad82eb$export$1ae0a94c8ba4131a,
    faRuler: $36045e57d0ad82eb$export$8e90575265a56cfc,
    faRulerCombined: $36045e57d0ad82eb$export$613f406c1b5802a8,
    faRulerHorizontal: $36045e57d0ad82eb$export$46c6347bff3e04a,
    faRulerVertical: $36045e57d0ad82eb$export$a6ad5df9d9f29553,
    faRunning: $36045e57d0ad82eb$export$5dfd1cb43dc9eadb,
    faRupeeSign: $36045e57d0ad82eb$export$8bf9e3f7f57d486a,
    faSadCry: $36045e57d0ad82eb$export$8e924e6bd422cef9,
    faSadTear: $36045e57d0ad82eb$export$4b5241926f692f91,
    faSatellite: $36045e57d0ad82eb$export$da3f1730d013e224,
    faSatelliteDish: $36045e57d0ad82eb$export$219ccae0e4da3c92,
    faSave: $36045e57d0ad82eb$export$1aaa83ff70706e1e,
    faSchool: $36045e57d0ad82eb$export$51e9b8434982947d,
    faScrewdriver: $36045e57d0ad82eb$export$7484ff654cd6474f,
    faScroll: $36045e57d0ad82eb$export$7c265716d4399676,
    faSdCard: $36045e57d0ad82eb$export$303efb6031da122,
    faSearch: $36045e57d0ad82eb$export$871a78837687ffe8,
    faSearchDollar: $36045e57d0ad82eb$export$65b49a6767630708,
    faSearchLocation: $36045e57d0ad82eb$export$c33aba6c251a898a,
    faSearchMinus: $36045e57d0ad82eb$export$efca97eef6a7a17d,
    faSearchPlus: $36045e57d0ad82eb$export$378f00e6b1a8185,
    faSeedling: $36045e57d0ad82eb$export$d7b60b8dbd03cfe4,
    faServer: $36045e57d0ad82eb$export$1bf820d499b6202e,
    faShapes: $36045e57d0ad82eb$export$b17d50542d1fc340,
    faShare: $36045e57d0ad82eb$export$c08b4b0e2b0dc027,
    faShareAlt: $36045e57d0ad82eb$export$f8e8bb0b3aa8c658,
    faShareAltSquare: $36045e57d0ad82eb$export$3799c2d8fd7e493b,
    faShareSquare: $36045e57d0ad82eb$export$ae9e1434571f373c,
    faShekelSign: $36045e57d0ad82eb$export$3570be7b68efb8db,
    faShieldAlt: $36045e57d0ad82eb$export$d6508d18a824f291,
    faShieldVirus: $36045e57d0ad82eb$export$bea811bbf570f05a,
    faShip: $36045e57d0ad82eb$export$6c645741140616af,
    faShippingFast: $36045e57d0ad82eb$export$5e419f47aaeb3c05,
    faShoePrints: $36045e57d0ad82eb$export$cdbdd2118099ae07,
    faShoppingBag: $36045e57d0ad82eb$export$5745f8adbc11eb01,
    faShoppingBasket: $36045e57d0ad82eb$export$ca6d443595a6578f,
    faShoppingCart: $36045e57d0ad82eb$export$51da406e5aa1388c,
    faShower: $36045e57d0ad82eb$export$f7f7c15f18cc19a1,
    faShuttleVan: $36045e57d0ad82eb$export$9d63d851db698c09,
    faSign: $36045e57d0ad82eb$export$d21d0d6c8e9e8bf9,
    faSignInAlt: $36045e57d0ad82eb$export$e6709746115bd2ea,
    faSignLanguage: $36045e57d0ad82eb$export$20993813350f9671,
    faSignOutAlt: $36045e57d0ad82eb$export$c844d6923b7096c2,
    faSignal: $36045e57d0ad82eb$export$79046b073b6c584d,
    faSignature: $36045e57d0ad82eb$export$afa7b53ac8ebcb5d,
    faSimCard: $36045e57d0ad82eb$export$3bee83bf278fddbe,
    faSink: $36045e57d0ad82eb$export$2a9dda2096ce792e,
    faSitemap: $36045e57d0ad82eb$export$b2ce5e79d0eccaf8,
    faSkating: $36045e57d0ad82eb$export$21bd1d54bd4f2c5a,
    faSkiing: $36045e57d0ad82eb$export$eae1acab6fb96708,
    faSkiingNordic: $36045e57d0ad82eb$export$6ea48260d7d09b1b,
    faSkull: $36045e57d0ad82eb$export$138b45e2afb1dfa4,
    faSkullCrossbones: $36045e57d0ad82eb$export$8717352b90217272,
    faSlash: $36045e57d0ad82eb$export$f54d004dd5f1cb5e,
    faSleigh: $36045e57d0ad82eb$export$26a8fd1143d2d6c0,
    faSlidersH: $36045e57d0ad82eb$export$94d4dcb523f95563,
    faSmile: $36045e57d0ad82eb$export$c632b2334f0913bc,
    faSmileBeam: $36045e57d0ad82eb$export$54ada6dc9690e0ca,
    faSmileWink: $36045e57d0ad82eb$export$f5dbb37f6801ee3f,
    faSmog: $36045e57d0ad82eb$export$aa11b8edb09fed14,
    faSmoking: $36045e57d0ad82eb$export$c4ab83701fc591a5,
    faSmokingBan: $36045e57d0ad82eb$export$e50452a49dec29f,
    faSms: $36045e57d0ad82eb$export$9dbcc3443daa7323,
    faSnowboarding: $36045e57d0ad82eb$export$72683772d587302a,
    faSnowflake: $36045e57d0ad82eb$export$bab8f3647c394f48,
    faSnowman: $36045e57d0ad82eb$export$b23df6bafb174693,
    faSnowplow: $36045e57d0ad82eb$export$695fae58f55c3a87,
    faSoap: $36045e57d0ad82eb$export$64f1c53b21f310ac,
    faSocks: $36045e57d0ad82eb$export$8d36a54dbf1e6bce,
    faSolarPanel: $36045e57d0ad82eb$export$b9c649c5e37017f3,
    faSort: $36045e57d0ad82eb$export$4941c5969d5399b,
    faSortAlphaDown: $36045e57d0ad82eb$export$7658045270aafde3,
    faSortAlphaDownAlt: $36045e57d0ad82eb$export$e12d23d82d5c8a89,
    faSortAlphaUp: $36045e57d0ad82eb$export$3c4115b156be730d,
    faSortAlphaUpAlt: $36045e57d0ad82eb$export$95ef20828693fb0f,
    faSortAmountDown: $36045e57d0ad82eb$export$4b2a02d50e417b5f,
    faSortAmountDownAlt: $36045e57d0ad82eb$export$e7d80d8c226cb77,
    faSortAmountUp: $36045e57d0ad82eb$export$28ef3e933e4b5364,
    faSortAmountUpAlt: $36045e57d0ad82eb$export$6e87844b0f151b6a,
    faSortDown: $36045e57d0ad82eb$export$58e2577a373e7d4,
    faSortNumericDown: $36045e57d0ad82eb$export$835db7eb35b3c29b,
    faSortNumericDownAlt: $36045e57d0ad82eb$export$857385fda7a5a98e,
    faSortNumericUp: $36045e57d0ad82eb$export$d213a3ba3cabed48,
    faSortNumericUpAlt: $36045e57d0ad82eb$export$d41859f1bbb9e086,
    faSortUp: $36045e57d0ad82eb$export$f9dd5b1410e95035,
    faSpa: $36045e57d0ad82eb$export$f9a38ef7b046ab51,
    faSpaceShuttle: $36045e57d0ad82eb$export$4d1c12ba2b4ca565,
    faSpellCheck: $36045e57d0ad82eb$export$761e747b06ed2e1f,
    faSpider: $36045e57d0ad82eb$export$6daa96b1986e2ef0,
    faSpinner: $36045e57d0ad82eb$export$1025ad641edb49c2,
    faSplotch: $36045e57d0ad82eb$export$d6f21e17ea797702,
    faSprayCan: $36045e57d0ad82eb$export$4952c502f544cf85,
    faSquare: $36045e57d0ad82eb$export$90b4406457aae8cc,
    faSquareFull: $36045e57d0ad82eb$export$7ec6541fee081990,
    faSquareRootAlt: $36045e57d0ad82eb$export$28e4b96627e00057,
    faStamp: $36045e57d0ad82eb$export$722e92d2d93ffc68,
    faStar: $36045e57d0ad82eb$export$a3b0eb2cd7942125,
    faStarAndCrescent: $36045e57d0ad82eb$export$cafa834c96ebcb1a,
    faStarHalf: $36045e57d0ad82eb$export$228008b5e11032fa,
    faStarHalfAlt: $36045e57d0ad82eb$export$c13575f42532efb3,
    faStarOfDavid: $36045e57d0ad82eb$export$f823fee3712b2601,
    faStarOfLife: $36045e57d0ad82eb$export$aa3c4c1c5a47bf98,
    faStepBackward: $36045e57d0ad82eb$export$2884e379aed297d4,
    faStepForward: $36045e57d0ad82eb$export$b303329afce5de18,
    faStethoscope: $36045e57d0ad82eb$export$acb2d72d28cd92d9,
    faStickyNote: $36045e57d0ad82eb$export$80889adc5d98bf4a,
    faStop: $36045e57d0ad82eb$export$51577929c676143b,
    faStopCircle: $36045e57d0ad82eb$export$47af2aad60ab3e7c,
    faStopwatch: $36045e57d0ad82eb$export$b85a7300fc7960b6,
    faStopwatch20: $36045e57d0ad82eb$export$df6244b0501f2112,
    faStore: $36045e57d0ad82eb$export$de59c2657a8ace67,
    faStoreAlt: $36045e57d0ad82eb$export$1f1871dab9cec9d8,
    faStoreAltSlash: $36045e57d0ad82eb$export$b932a586f6ff48b4,
    faStoreSlash: $36045e57d0ad82eb$export$4ab2f33219630bad,
    faStream: $36045e57d0ad82eb$export$ed81ab40fc4e904,
    faStreetView: $36045e57d0ad82eb$export$6aab6c3359c2554c,
    faStrikethrough: $36045e57d0ad82eb$export$eff51ea25b4de135,
    faStroopwafel: $36045e57d0ad82eb$export$195780ddabd8e0c6,
    faSubscript: $36045e57d0ad82eb$export$34c1e678c32ed646,
    faSubway: $36045e57d0ad82eb$export$4cabc8a12d4e2f9,
    faSuitcase: $36045e57d0ad82eb$export$60710f3921019268,
    faSuitcaseRolling: $36045e57d0ad82eb$export$957e62a9b80ff4e3,
    faSun: $36045e57d0ad82eb$export$2fa35dcbc038dbe9,
    faSuperscript: $36045e57d0ad82eb$export$4fa56a54e822dd25,
    faSurprise: $36045e57d0ad82eb$export$46647c72213f53ba,
    faSwatchbook: $36045e57d0ad82eb$export$c74a20c81b957b6a,
    faSwimmer: $36045e57d0ad82eb$export$67daf2e2f88c1365,
    faSwimmingPool: $36045e57d0ad82eb$export$4dee691631c67d5c,
    faSynagogue: $36045e57d0ad82eb$export$20d991385719b5b4,
    faSync: $36045e57d0ad82eb$export$ff87319002e3dae9,
    faSyncAlt: $36045e57d0ad82eb$export$2ff2056be8c281e4,
    faSyringe: $36045e57d0ad82eb$export$1aa9423ec6b1d609,
    faTable: $36045e57d0ad82eb$export$36583f5d3d5a971f,
    faTableTennis: $36045e57d0ad82eb$export$f378fbb4e0ef7edf,
    faTablet: $36045e57d0ad82eb$export$1c92b67c45a4b4fc,
    faTabletAlt: $36045e57d0ad82eb$export$db0cac088255eacc,
    faTablets: $36045e57d0ad82eb$export$bed2b0ed4ae45e0d,
    faTachometerAlt: $36045e57d0ad82eb$export$38dd17b9f064c10f,
    faTag: $36045e57d0ad82eb$export$cb61f447f29887e,
    faTags: $36045e57d0ad82eb$export$d55778e3ab6c933f,
    faTape: $36045e57d0ad82eb$export$b88ed5e1e0eac4c6,
    faTasks: $36045e57d0ad82eb$export$2f6d5b2fec286d63,
    faTaxi: $36045e57d0ad82eb$export$9958afcdfece1b58,
    faTeeth: $36045e57d0ad82eb$export$b4619aeaf0b9d18e,
    faTeethOpen: $36045e57d0ad82eb$export$c88ac21fe7c88ae6,
    faTemperatureHigh: $36045e57d0ad82eb$export$15d012277c3ecf9a,
    faTemperatureLow: $36045e57d0ad82eb$export$9e9af12b90a1abd2,
    faTenge: $36045e57d0ad82eb$export$af6ebee83047b793,
    faTerminal: $36045e57d0ad82eb$export$5e63e8b85b5f119c,
    faTextHeight: $36045e57d0ad82eb$export$3313bce3924ea7da,
    faTextWidth: $36045e57d0ad82eb$export$d8724cf433389700,
    faTh: $36045e57d0ad82eb$export$4d383c83efc0c819,
    faThLarge: $36045e57d0ad82eb$export$69782f333e90cdc6,
    faThList: $36045e57d0ad82eb$export$daf2614a457122c0,
    faTheaterMasks: $36045e57d0ad82eb$export$3dbedc487b0159ac,
    faThermometer: $36045e57d0ad82eb$export$f576739e9b18ea4f,
    faThermometerEmpty: $36045e57d0ad82eb$export$81a2f8298cf523f9,
    faThermometerFull: $36045e57d0ad82eb$export$74e07083cef79a6f,
    faThermometerHalf: $36045e57d0ad82eb$export$2090f040324b4449,
    faThermometerQuarter: $36045e57d0ad82eb$export$ed05754fcbec6e46,
    faThermometerThreeQuarters: $36045e57d0ad82eb$export$6c632d1dc30d4a77,
    faThumbsDown: $36045e57d0ad82eb$export$aba24ca305bbe8c1,
    faThumbsUp: $36045e57d0ad82eb$export$47e4e0d519d33497,
    faThumbtack: $36045e57d0ad82eb$export$b6314cdc01bb5c43,
    faTicketAlt: $36045e57d0ad82eb$export$75e38ba471fd89c4,
    faTimes: $36045e57d0ad82eb$export$174bd7f477b115b4,
    faTimesCircle: $36045e57d0ad82eb$export$ab0ec50720a747eb,
    faTint: $36045e57d0ad82eb$export$60dd975bd5938c15,
    faTintSlash: $36045e57d0ad82eb$export$5d6f0943039b898f,
    faTired: $36045e57d0ad82eb$export$3d016d62cda18371,
    faToggleOff: $36045e57d0ad82eb$export$d20aaceb882ca545,
    faToggleOn: $36045e57d0ad82eb$export$5cffc34afa81e517,
    faToilet: $36045e57d0ad82eb$export$505476859b9691c0,
    faToiletPaper: $36045e57d0ad82eb$export$c8cc083ccc72b17,
    faToiletPaperSlash: $36045e57d0ad82eb$export$7a494edbf9b65575,
    faToolbox: $36045e57d0ad82eb$export$b34d64c205c732a9,
    faTools: $36045e57d0ad82eb$export$646e4e7a8c6172aa,
    faTooth: $36045e57d0ad82eb$export$3a1fa2d16f90d635,
    faTorah: $36045e57d0ad82eb$export$54d07baabd8c2acb,
    faToriiGate: $36045e57d0ad82eb$export$75825a4c2b3375e,
    faTractor: $36045e57d0ad82eb$export$e87e41787bbedc98,
    faTrademark: $36045e57d0ad82eb$export$9c9b2fbddd59047d,
    faTrafficLight: $36045e57d0ad82eb$export$bf0b19daceaec9c2,
    faTrailer: $36045e57d0ad82eb$export$3a48b9820e92f5ab,
    faTrain: $36045e57d0ad82eb$export$17cde74bf6f1ee89,
    faTram: $36045e57d0ad82eb$export$a7a36674c079f293,
    faTransgender: $36045e57d0ad82eb$export$7e3f1701aa95ef01,
    faTransgenderAlt: $36045e57d0ad82eb$export$9c36cf9334c052f,
    faTrash: $36045e57d0ad82eb$export$ed8c149a0ea54bb4,
    faTrashAlt: $36045e57d0ad82eb$export$88df7ff7eb32f9dc,
    faTrashRestore: $36045e57d0ad82eb$export$d32f45a64ed40e8d,
    faTrashRestoreAlt: $36045e57d0ad82eb$export$d075b19b21cb9856,
    faTree: $36045e57d0ad82eb$export$1744430f718caf6b,
    faTrophy: $36045e57d0ad82eb$export$29c432d69ccf85a5,
    faTruck: $36045e57d0ad82eb$export$d7895f386f8bd8b8,
    faTruckLoading: $36045e57d0ad82eb$export$f00c152db7d44638,
    faTruckMonster: $36045e57d0ad82eb$export$24b8a0147653649a,
    faTruckMoving: $36045e57d0ad82eb$export$a06617a1a4ccea67,
    faTruckPickup: $36045e57d0ad82eb$export$f846b848b3ba3064,
    faTshirt: $36045e57d0ad82eb$export$36edce3ba87c2b17,
    faTty: $36045e57d0ad82eb$export$7c85aba0f9624b29,
    faTv: $36045e57d0ad82eb$export$e0cfed4ba2fe562c,
    faUmbrella: $36045e57d0ad82eb$export$9ff64ffae70e08c0,
    faUmbrellaBeach: $36045e57d0ad82eb$export$20932e4d438e4e4c,
    faUnderline: $36045e57d0ad82eb$export$22346afd6a3cddf8,
    faUndo: $36045e57d0ad82eb$export$a5e5ba60b1dfe2b2,
    faUndoAlt: $36045e57d0ad82eb$export$c8197b992c46c4a6,
    faUniversalAccess: $36045e57d0ad82eb$export$e119aada7f690d05,
    faUniversity: $36045e57d0ad82eb$export$f2e1460ebe1a8cb0,
    faUnlink: $36045e57d0ad82eb$export$2f546f7d8ba01e18,
    faUnlock: $36045e57d0ad82eb$export$db1382cd406cc506,
    faUnlockAlt: $36045e57d0ad82eb$export$b19f508797f3d9c3,
    faUpload: $36045e57d0ad82eb$export$a9578350255b2b79,
    faUser: $36045e57d0ad82eb$export$f5699fa0844e0188,
    faUserAlt: $36045e57d0ad82eb$export$ae9b19c2ac726cfc,
    faUserAltSlash: $36045e57d0ad82eb$export$46185fab4772ada6,
    faUserAstronaut: $36045e57d0ad82eb$export$94363e983c225a04,
    faUserCheck: $36045e57d0ad82eb$export$76de2a120043c9f8,
    faUserCircle: $36045e57d0ad82eb$export$be7d974e9e0dba1a,
    faUserClock: $36045e57d0ad82eb$export$b00596a09aa07311,
    faUserCog: $36045e57d0ad82eb$export$474108c2b86e730e,
    faUserEdit: $36045e57d0ad82eb$export$a68a6960fc8eef82,
    faUserFriends: $36045e57d0ad82eb$export$46073bec205635d9,
    faUserGraduate: $36045e57d0ad82eb$export$10f5839059d22f7e,
    faUserInjured: $36045e57d0ad82eb$export$c950c1ba7f227d5b,
    faUserLock: $36045e57d0ad82eb$export$d9b89b5872b67a4f,
    faUserMd: $36045e57d0ad82eb$export$ab0d33a2c03f1794,
    faUserMinus: $36045e57d0ad82eb$export$d6e17c0df8ed1bf7,
    faUserNinja: $36045e57d0ad82eb$export$a9174995732e03c5,
    faUserNurse: $36045e57d0ad82eb$export$ab9af5aa013d2162,
    faUserPlus: $36045e57d0ad82eb$export$4c17261776a709f2,
    faUserSecret: $36045e57d0ad82eb$export$597826232327559b,
    faUserShield: $36045e57d0ad82eb$export$d1886bc596424e6c,
    faUserSlash: $36045e57d0ad82eb$export$3924ab4d3ef9b5ef,
    faUserTag: $36045e57d0ad82eb$export$9eec597148166b36,
    faUserTie: $36045e57d0ad82eb$export$48c51dda34e9f04c,
    faUserTimes: $36045e57d0ad82eb$export$45b996d071667753,
    faUsers: $36045e57d0ad82eb$export$e5a8f011aef571ac,
    faUsersCog: $36045e57d0ad82eb$export$5e0b06753fc69b81,
    faUsersSlash: $36045e57d0ad82eb$export$b71a093b86e3da1f,
    faUtensilSpoon: $36045e57d0ad82eb$export$fb7af5d245fb9053,
    faUtensils: $36045e57d0ad82eb$export$750d52edc1dafc7,
    faVectorSquare: $36045e57d0ad82eb$export$567d5631a7b0599f,
    faVenus: $36045e57d0ad82eb$export$f89d028573ffc0a6,
    faVenusDouble: $36045e57d0ad82eb$export$6a6f9cba7a1e5fe4,
    faVenusMars: $36045e57d0ad82eb$export$63f2d9e5f4689aa8,
    faVest: $36045e57d0ad82eb$export$c8370e53051a657,
    faVestPatches: $36045e57d0ad82eb$export$750a64470c2e0f3f,
    faVial: $36045e57d0ad82eb$export$aa014b06d2d70598,
    faVials: $36045e57d0ad82eb$export$507e8edd7676b2e9,
    faVideo: $36045e57d0ad82eb$export$5c6bd8729527871b,
    faVideoSlash: $36045e57d0ad82eb$export$a714fc79f58cc9ef,
    faVihara: $36045e57d0ad82eb$export$ee4b92e89fe0dfaf,
    faVirus: $36045e57d0ad82eb$export$37c67e0b3dc6bd1b,
    faVirusSlash: $36045e57d0ad82eb$export$c4ff5306c5470939,
    faViruses: $36045e57d0ad82eb$export$ee194b18f5c6f6b6,
    faVoicemail: $36045e57d0ad82eb$export$4f1ce88b2b4cd5cd,
    faVolleyballBall: $36045e57d0ad82eb$export$a15e6fc8e68a76b0,
    faVolumeDown: $36045e57d0ad82eb$export$69fdf57632b6cc29,
    faVolumeMute: $36045e57d0ad82eb$export$aa8decd057dfd29b,
    faVolumeOff: $36045e57d0ad82eb$export$d94ba52e980ea0f1,
    faVolumeUp: $36045e57d0ad82eb$export$5940d3e475d90cc4,
    faVoteYea: $36045e57d0ad82eb$export$e87bb3db1608b850,
    faVrCardboard: $36045e57d0ad82eb$export$248171cb6dad4307,
    faWalking: $36045e57d0ad82eb$export$4886811b7174ec35,
    faWallet: $36045e57d0ad82eb$export$79204db8777905c8,
    faWarehouse: $36045e57d0ad82eb$export$e3a174a50618c208,
    faWater: $36045e57d0ad82eb$export$efaeddad0a6e901b,
    faWaveSquare: $36045e57d0ad82eb$export$c38cf504b3bc58a2,
    faWeight: $36045e57d0ad82eb$export$cf3bafa68a60bae4,
    faWeightHanging: $36045e57d0ad82eb$export$43d1fa6671908715,
    faWheelchair: $36045e57d0ad82eb$export$76a9413fbe130a53,
    faWifi: $36045e57d0ad82eb$export$1642419fe3db2857,
    faWind: $36045e57d0ad82eb$export$cc58cb0f2257a6a9,
    faWindowClose: $36045e57d0ad82eb$export$18b7775f78a3e16,
    faWindowMaximize: $36045e57d0ad82eb$export$703cd98be31ec905,
    faWindowMinimize: $36045e57d0ad82eb$export$26a3f9d2784b90d8,
    faWindowRestore: $36045e57d0ad82eb$export$eccfff9bfd585652,
    faWineBottle: $36045e57d0ad82eb$export$770be8b3d5776043,
    faWineGlass: $36045e57d0ad82eb$export$e06d6607d3577d6e,
    faWineGlassAlt: $36045e57d0ad82eb$export$b8ff3fe2b78aef2f,
    faWonSign: $36045e57d0ad82eb$export$51790ddd26e431bc,
    faWrench: $36045e57d0ad82eb$export$3c6c0c8185296ac5,
    faXRay: $36045e57d0ad82eb$export$8cf137aceaaf4de0,
    faYenSign: $36045e57d0ad82eb$export$30f1437f5a4e991d,
    faYinYang: $36045e57d0ad82eb$export$6ec1acbf3f610b8f
};


/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ function $d31a6ed399ae6f4f$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d31a6ed399ae6f4f$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $d31a6ed399ae6f4f$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d31a6ed399ae6f4f$var$_typeof(obj);
}
function $d31a6ed399ae6f4f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d31a6ed399ae6f4f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d31a6ed399ae6f4f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d31a6ed399ae6f4f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d31a6ed399ae6f4f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d31a6ed399ae6f4f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d31a6ed399ae6f4f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $d31a6ed399ae6f4f$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $d31a6ed399ae6f4f$var$_slicedToArray(arr, i) {
    return $d31a6ed399ae6f4f$var$_arrayWithHoles(arr) || $d31a6ed399ae6f4f$var$_iterableToArrayLimit(arr, i) || $d31a6ed399ae6f4f$var$_nonIterableRest();
}
function $d31a6ed399ae6f4f$var$_toConsumableArray(arr) {
    return $d31a6ed399ae6f4f$var$_arrayWithoutHoles(arr) || $d31a6ed399ae6f4f$var$_iterableToArray(arr) || $d31a6ed399ae6f4f$var$_nonIterableSpread();
}
function $d31a6ed399ae6f4f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $d31a6ed399ae6f4f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d31a6ed399ae6f4f$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $d31a6ed399ae6f4f$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d31a6ed399ae6f4f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $d31a6ed399ae6f4f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var $d31a6ed399ae6f4f$var$noop = function noop() {};
var $d31a6ed399ae6f4f$var$_WINDOW = {};
var $d31a6ed399ae6f4f$var$_DOCUMENT = {};
var $d31a6ed399ae6f4f$var$_MUTATION_OBSERVER = null;
var $d31a6ed399ae6f4f$var$_PERFORMANCE = {
    mark: $d31a6ed399ae6f4f$var$noop,
    measure: $d31a6ed399ae6f4f$var$noop
};
try {
    if (typeof window !== "undefined") $d31a6ed399ae6f4f$var$_WINDOW = window;
    if (typeof document !== "undefined") $d31a6ed399ae6f4f$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $d31a6ed399ae6f4f$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $d31a6ed399ae6f4f$var$_PERFORMANCE = performance;
} catch (e) {}
var $d31a6ed399ae6f4f$var$_ref = $d31a6ed399ae6f4f$var$_WINDOW.navigator || {}, $d31a6ed399ae6f4f$var$_ref$userAgent = $d31a6ed399ae6f4f$var$_ref.userAgent, $d31a6ed399ae6f4f$var$userAgent = $d31a6ed399ae6f4f$var$_ref$userAgent === void 0 ? "" : $d31a6ed399ae6f4f$var$_ref$userAgent;
var $d31a6ed399ae6f4f$var$WINDOW = $d31a6ed399ae6f4f$var$_WINDOW;
var $d31a6ed399ae6f4f$var$DOCUMENT = $d31a6ed399ae6f4f$var$_DOCUMENT;
var $d31a6ed399ae6f4f$var$MUTATION_OBSERVER = $d31a6ed399ae6f4f$var$_MUTATION_OBSERVER;
var $d31a6ed399ae6f4f$var$PERFORMANCE = $d31a6ed399ae6f4f$var$_PERFORMANCE;
var $d31a6ed399ae6f4f$var$IS_BROWSER = !!$d31a6ed399ae6f4f$var$WINDOW.document;
var $d31a6ed399ae6f4f$var$IS_DOM = !!$d31a6ed399ae6f4f$var$DOCUMENT.documentElement && !!$d31a6ed399ae6f4f$var$DOCUMENT.head && typeof $d31a6ed399ae6f4f$var$DOCUMENT.addEventListener === "function" && typeof $d31a6ed399ae6f4f$var$DOCUMENT.createElement === "function";
var $d31a6ed399ae6f4f$var$IS_IE = ~$d31a6ed399ae6f4f$var$userAgent.indexOf("MSIE") || ~$d31a6ed399ae6f4f$var$userAgent.indexOf("Trident/");
var $d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $d31a6ed399ae6f4f$var$UNITS_IN_GRID = 16;
var $d31a6ed399ae6f4f$var$DEFAULT_FAMILY_PREFIX = "fa";
var $d31a6ed399ae6f4f$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $d31a6ed399ae6f4f$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $d31a6ed399ae6f4f$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $d31a6ed399ae6f4f$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $d31a6ed399ae6f4f$var$DATA_PREFIX = "data-prefix";
var $d31a6ed399ae6f4f$var$DATA_ICON = "data-icon";
var $d31a6ed399ae6f4f$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $d31a6ed399ae6f4f$var$MUTATION_APPROACH_ASYNC = "async";
var $d31a6ed399ae6f4f$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $d31a6ed399ae6f4f$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $d31a6ed399ae6f4f$var$PREFIX_TO_STYLE = {
    "fas": "solid",
    "far": "regular",
    "fal": "light",
    "fad": "duotone",
    "fab": "brands",
    "fak": "kit",
    "fa": "solid"
};
var $d31a6ed399ae6f4f$var$STYLE_TO_PREFIX = {
    "solid": "fas",
    "regular": "far",
    "light": "fal",
    "duotone": "fad",
    "brands": "fab",
    "kit": "fak"
};
var $d31a6ed399ae6f4f$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $d31a6ed399ae6f4f$var$FONT_FAMILY_PATTERN = /Font Awesome ([5 ]*)(Solid|Regular|Light|Duotone|Brands|Free|Pro|Kit).*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var $d31a6ed399ae6f4f$var$FONT_WEIGHT_TO_PREFIX = {
    "900": "fas",
    "400": "far",
    "normal": "far",
    "300": "fal"
};
var $d31a6ed399ae6f4f$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $d31a6ed399ae6f4f$var$oneToTwenty = $d31a6ed399ae6f4f$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $d31a6ed399ae6f4f$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $d31a6ed399ae6f4f$var$DUOTONE_CLASSES = {
    GROUP: "group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $d31a6ed399ae6f4f$var$RESERVED_CLASSES = [
    "xs",
    "sm",
    "lg",
    "fw",
    "ul",
    "li",
    "border",
    "pull-left",
    "pull-right",
    "spin",
    "pulse",
    "rotate-90",
    "rotate-180",
    "rotate-270",
    "flip-horizontal",
    "flip-vertical",
    "flip-both",
    "stack",
    "stack-1x",
    "stack-2x",
    "inverse",
    "layers",
    "layers-text",
    "layers-counter",
    $d31a6ed399ae6f4f$var$DUOTONE_CLASSES.GROUP,
    $d31a6ed399ae6f4f$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $d31a6ed399ae6f4f$var$DUOTONE_CLASSES.PRIMARY,
    $d31a6ed399ae6f4f$var$DUOTONE_CLASSES.SECONDARY
].concat($d31a6ed399ae6f4f$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($d31a6ed399ae6f4f$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $d31a6ed399ae6f4f$var$initial = $d31a6ed399ae6f4f$var$WINDOW.FontAwesomeConfig || {};
function $d31a6ed399ae6f4f$var$getAttrConfig(attr) {
    var element = $d31a6ed399ae6f4f$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $d31a6ed399ae6f4f$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($d31a6ed399ae6f4f$var$DOCUMENT && typeof $d31a6ed399ae6f4f$var$DOCUMENT.querySelector === "function") {
    var $d31a6ed399ae6f4f$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $d31a6ed399ae6f4f$var$attrs.forEach(function(_ref) {
        var _ref2 = $d31a6ed399ae6f4f$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $d31a6ed399ae6f4f$var$coerce($d31a6ed399ae6f4f$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $d31a6ed399ae6f4f$var$initial[key] = val;
    });
}
var $d31a6ed399ae6f4f$var$_default = {
    familyPrefix: $d31a6ed399ae6f4f$var$DEFAULT_FAMILY_PREFIX,
    replacementClass: $d31a6ed399ae6f4f$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
var $d31a6ed399ae6f4f$var$_config = $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$_default, $d31a6ed399ae6f4f$var$initial);
if (!$d31a6ed399ae6f4f$var$_config.autoReplaceSvg) $d31a6ed399ae6f4f$var$_config.observeMutations = false;
var $d31a6ed399ae6f4f$export$e506a1d27d1eaa20 = $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$_config);
$d31a6ed399ae6f4f$var$WINDOW.FontAwesomeConfig = $d31a6ed399ae6f4f$export$e506a1d27d1eaa20;
var $d31a6ed399ae6f4f$var$w = $d31a6ed399ae6f4f$var$WINDOW || {};
if (!$d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER]) $d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER] = {};
if (!$d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER].styles) $d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER].hooks) $d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER].shims) $d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER].shims = [];
var $d31a6ed399ae6f4f$var$namespace = $d31a6ed399ae6f4f$var$w[$d31a6ed399ae6f4f$var$NAMESPACE_IDENTIFIER];
var $d31a6ed399ae6f4f$var$functions = [];
var $d31a6ed399ae6f4f$var$listener = function listener() {
    $d31a6ed399ae6f4f$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $d31a6ed399ae6f4f$var$loaded = 1;
    $d31a6ed399ae6f4f$var$functions.map(function(fn) {
        return fn();
    });
};
var $d31a6ed399ae6f4f$var$loaded = false;
if ($d31a6ed399ae6f4f$var$IS_DOM) {
    $d31a6ed399ae6f4f$var$loaded = ($d31a6ed399ae6f4f$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($d31a6ed399ae6f4f$var$DOCUMENT.readyState);
    if (!$d31a6ed399ae6f4f$var$loaded) $d31a6ed399ae6f4f$var$DOCUMENT.addEventListener("DOMContentLoaded", $d31a6ed399ae6f4f$var$listener);
}
function $d31a6ed399ae6f4f$var$domready(fn) {
    if (!$d31a6ed399ae6f4f$var$IS_DOM) return;
    $d31a6ed399ae6f4f$var$loaded ? setTimeout(fn, 0) : $d31a6ed399ae6f4f$var$functions.push(fn);
}
var $d31a6ed399ae6f4f$var$PENDING = "pending";
var $d31a6ed399ae6f4f$var$SETTLED = "settled";
var $d31a6ed399ae6f4f$var$FULFILLED = "fulfilled";
var $d31a6ed399ae6f4f$var$REJECTED = "rejected";
var $d31a6ed399ae6f4f$var$NOOP = function NOOP() {};
var $d31a6ed399ae6f4f$var$isNode = typeof $parcel$global !== "undefined" && typeof $parcel$global.process !== "undefined" && typeof $parcel$global.process.emit === "function";
var $d31a6ed399ae6f4f$var$asyncSetTimer = typeof setImmediate === "undefined" ? setTimeout : setImmediate;
var $d31a6ed399ae6f4f$var$asyncQueue = [];
var $d31a6ed399ae6f4f$var$asyncTimer;
function $d31a6ed399ae6f4f$var$asyncFlush() {
    // run promise callbacks
    for(var i = 0; i < $d31a6ed399ae6f4f$var$asyncQueue.length; i++)$d31a6ed399ae6f4f$var$asyncQueue[i][0]($d31a6ed399ae6f4f$var$asyncQueue[i][1]);
     // reset async asyncQueue
    $d31a6ed399ae6f4f$var$asyncQueue = [];
    $d31a6ed399ae6f4f$var$asyncTimer = false;
}
function $d31a6ed399ae6f4f$var$asyncCall(callback, arg) {
    $d31a6ed399ae6f4f$var$asyncQueue.push([
        callback,
        arg
    ]);
    if (!$d31a6ed399ae6f4f$var$asyncTimer) {
        $d31a6ed399ae6f4f$var$asyncTimer = true;
        $d31a6ed399ae6f4f$var$asyncSetTimer($d31a6ed399ae6f4f$var$asyncFlush, 0);
    }
}
function $d31a6ed399ae6f4f$var$invokeResolver(resolver, promise) {
    function resolvePromise(value) {
        $d31a6ed399ae6f4f$var$resolve(promise, value);
    }
    function rejectPromise(reason) {
        $d31a6ed399ae6f4f$var$reject(promise, reason);
    }
    try {
        resolver(resolvePromise, rejectPromise);
    } catch (e) {
        rejectPromise(e);
    }
}
function $d31a6ed399ae6f4f$var$invokeCallback(subscriber) {
    var owner = subscriber.owner;
    var settled = owner._state;
    var value = owner._data;
    var callback = subscriber[settled];
    var promise = subscriber.then;
    if (typeof callback === "function") {
        settled = $d31a6ed399ae6f4f$var$FULFILLED;
        try {
            value = callback(value);
        } catch (e) {
            $d31a6ed399ae6f4f$var$reject(promise, e);
        }
    }
    if (!$d31a6ed399ae6f4f$var$handleThenable(promise, value)) {
        if (settled === $d31a6ed399ae6f4f$var$FULFILLED) $d31a6ed399ae6f4f$var$resolve(promise, value);
        if (settled === $d31a6ed399ae6f4f$var$REJECTED) $d31a6ed399ae6f4f$var$reject(promise, value);
    }
}
function $d31a6ed399ae6f4f$var$handleThenable(promise, value) {
    var resolved;
    try {
        if (promise === value) throw new TypeError("A promises callback cannot return that same promise.");
        if (value && (typeof value === "function" || $d31a6ed399ae6f4f$var$_typeof(value) === "object")) {
            // then should be retrieved only once
            var then = value.then;
            if (typeof then === "function") {
                then.call(value, function(val) {
                    if (!resolved) {
                        resolved = true;
                        if (value === val) $d31a6ed399ae6f4f$var$fulfill(promise, val);
                        else $d31a6ed399ae6f4f$var$resolve(promise, val);
                    }
                }, function(reason) {
                    if (!resolved) {
                        resolved = true;
                        $d31a6ed399ae6f4f$var$reject(promise, reason);
                    }
                });
                return true;
            }
        }
    } catch (e) {
        if (!resolved) $d31a6ed399ae6f4f$var$reject(promise, e);
        return true;
    }
    return false;
}
function $d31a6ed399ae6f4f$var$resolve(promise, value) {
    if (promise === value || !$d31a6ed399ae6f4f$var$handleThenable(promise, value)) $d31a6ed399ae6f4f$var$fulfill(promise, value);
}
function $d31a6ed399ae6f4f$var$fulfill(promise, value) {
    if (promise._state === $d31a6ed399ae6f4f$var$PENDING) {
        promise._state = $d31a6ed399ae6f4f$var$SETTLED;
        promise._data = value;
        $d31a6ed399ae6f4f$var$asyncCall($d31a6ed399ae6f4f$var$publishFulfillment, promise);
    }
}
function $d31a6ed399ae6f4f$var$reject(promise, reason) {
    if (promise._state === $d31a6ed399ae6f4f$var$PENDING) {
        promise._state = $d31a6ed399ae6f4f$var$SETTLED;
        promise._data = reason;
        $d31a6ed399ae6f4f$var$asyncCall($d31a6ed399ae6f4f$var$publishRejection, promise);
    }
}
function $d31a6ed399ae6f4f$var$publish(promise) {
    promise._then = promise._then.forEach($d31a6ed399ae6f4f$var$invokeCallback);
}
function $d31a6ed399ae6f4f$var$publishFulfillment(promise) {
    promise._state = $d31a6ed399ae6f4f$var$FULFILLED;
    $d31a6ed399ae6f4f$var$publish(promise);
}
function $d31a6ed399ae6f4f$var$publishRejection(promise) {
    promise._state = $d31a6ed399ae6f4f$var$REJECTED;
    $d31a6ed399ae6f4f$var$publish(promise);
    if (!promise._handled && $d31a6ed399ae6f4f$var$isNode) $parcel$global.process.emit("unhandledRejection", promise._data, promise);
}
function $d31a6ed399ae6f4f$var$notifyRejectionHandled(promise) {
    $parcel$global.process.emit("rejectionHandled", promise);
}
/**
 * @class
 */ function $d31a6ed399ae6f4f$var$P(resolver) {
    if (typeof resolver !== "function") throw new TypeError("Promise resolver " + resolver + " is not a function");
    if (this instanceof $d31a6ed399ae6f4f$var$P === false) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    this._then = [];
    $d31a6ed399ae6f4f$var$invokeResolver(resolver, this);
}
$d31a6ed399ae6f4f$var$P.prototype = {
    constructor: $d31a6ed399ae6f4f$var$P,
    _state: $d31a6ed399ae6f4f$var$PENDING,
    _then: null,
    _data: undefined,
    _handled: false,
    then: function then(onFulfillment, onRejection) {
        var subscriber = {
            owner: this,
            then: new this.constructor($d31a6ed399ae6f4f$var$NOOP),
            fulfilled: onFulfillment,
            rejected: onRejection
        };
        if ((onRejection || onFulfillment) && !this._handled) {
            this._handled = true;
            if (this._state === $d31a6ed399ae6f4f$var$REJECTED && $d31a6ed399ae6f4f$var$isNode) $d31a6ed399ae6f4f$var$asyncCall($d31a6ed399ae6f4f$var$notifyRejectionHandled, this);
        }
        if (this._state === $d31a6ed399ae6f4f$var$FULFILLED || this._state === $d31a6ed399ae6f4f$var$REJECTED) // already resolved, call callback async
        $d31a6ed399ae6f4f$var$asyncCall($d31a6ed399ae6f4f$var$invokeCallback, subscriber);
        else // subscribe
        this._then.push(subscriber);
        return subscriber.then;
    },
    catch: function _catch(onRejection) {
        return this.then(null, onRejection);
    }
};
$d31a6ed399ae6f4f$var$P.all = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.all().");
    return new $d31a6ed399ae6f4f$var$P(function(resolve, reject) {
        var results = [];
        var remaining = 0;
        function resolver(index) {
            remaining++;
            return function(value) {
                results[index] = value;
                if (!--remaining) resolve(results);
            };
        }
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === "function") promise.then(resolver(i), reject);
            else results[i] = promise;
        }
        if (!remaining) resolve(results);
    });
};
$d31a6ed399ae6f4f$var$P.race = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.race().");
    return new $d31a6ed399ae6f4f$var$P(function(resolve, reject) {
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === "function") promise.then(resolve, reject);
            else resolve(promise);
        }
    });
};
$d31a6ed399ae6f4f$var$P.resolve = function(value) {
    if (value && $d31a6ed399ae6f4f$var$_typeof(value) === "object" && value.constructor === $d31a6ed399ae6f4f$var$P) return value;
    return new $d31a6ed399ae6f4f$var$P(function(resolve) {
        resolve(value);
    });
};
$d31a6ed399ae6f4f$var$P.reject = function(reason) {
    return new $d31a6ed399ae6f4f$var$P(function(resolve, reject) {
        reject(reason);
    });
};
var $d31a6ed399ae6f4f$var$picked = typeof Promise === "function" ? Promise : $d31a6ed399ae6f4f$var$P;
var $d31a6ed399ae6f4f$var$d = $d31a6ed399ae6f4f$var$UNITS_IN_GRID;
var $d31a6ed399ae6f4f$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $d31a6ed399ae6f4f$var$isReserved(name) {
    return ~$d31a6ed399ae6f4f$var$RESERVED_CLASSES.indexOf(name);
}
function $d31a6ed399ae6f4f$var$insertCss(css) {
    if (!css || !$d31a6ed399ae6f4f$var$IS_DOM) return;
    var style = $d31a6ed399ae6f4f$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $d31a6ed399ae6f4f$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $d31a6ed399ae6f4f$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $d31a6ed399ae6f4f$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $d31a6ed399ae6f4f$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $d31a6ed399ae6f4f$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $d31a6ed399ae6f4f$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $d31a6ed399ae6f4f$var$classArray(node) {
    if (node.classList) return $d31a6ed399ae6f4f$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $d31a6ed399ae6f4f$var$getIconName(familyPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === familyPrefix && iconName !== "" && !$d31a6ed399ae6f4f$var$isReserved(iconName)) return iconName;
    else return null;
}
function $d31a6ed399ae6f4f$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $d31a6ed399ae6f4f$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($d31a6ed399ae6f4f$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $d31a6ed399ae6f4f$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
    }, "");
}
function $d31a6ed399ae6f4f$var$transformIsMeaningful(transform) {
    return transform.size !== $d31a6ed399ae6f4f$var$meaninglessTransform.size || transform.x !== $d31a6ed399ae6f4f$var$meaninglessTransform.x || transform.y !== $d31a6ed399ae6f4f$var$meaninglessTransform.y || transform.rotate !== $d31a6ed399ae6f4f$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $d31a6ed399ae6f4f$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $d31a6ed399ae6f4f$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $d31a6ed399ae6f4f$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $d31a6ed399ae6f4f$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $d31a6ed399ae6f4f$var$IS_IE) val += "translate(".concat(transform.x / $d31a6ed399ae6f4f$var$d - width / 2, "em, ").concat(transform.y / $d31a6ed399ae6f4f$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $d31a6ed399ae6f4f$var$d, "em), calc(-50% + ").concat(transform.y / $d31a6ed399ae6f4f$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $d31a6ed399ae6f4f$var$d, "em, ").concat(transform.y / $d31a6ed399ae6f4f$var$d, "em) ");
    val += "scale(".concat(transform.size / $d31a6ed399ae6f4f$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $d31a6ed399ae6f4f$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $d31a6ed399ae6f4f$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $d31a6ed399ae6f4f$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = "black";
    return abstract;
}
function $d31a6ed399ae6f4f$var$deGroup(abstract) {
    if (abstract.tag === "g") return abstract.children;
    else return [
        abstract
    ];
}
function $d31a6ed399ae6f4f$var$makeIconMasking(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
    var mainWidth = main.width, mainPath = main.icon;
    var maskWidth = mask.width, maskPath = mask.icon;
    var trans = $d31a6ed399ae6f4f$var$transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
    });
    var maskRect = {
        tag: "rect",
        attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$ALL_SPACE, {
            fill: "white"
        })
    };
    var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map($d31a6ed399ae6f4f$var$fillBlack)
    } : {};
    var maskInnerGroup = {
        tag: "g",
        attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, trans.inner),
        children: [
            $d31a6ed399ae6f4f$var$fillBlack($d31a6ed399ae6f4f$var$_objectSpread({
                tag: mainPath.tag,
                attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, mainPath.attributes, trans.path)
            }, maskInnerGroupChildrenMixin))
        ]
    };
    var maskOuterGroup = {
        tag: "g",
        attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, trans.outer),
        children: [
            maskInnerGroup
        ]
    };
    var maskId = "mask-".concat(explicitMaskId || $d31a6ed399ae6f4f$var$nextUniqueId());
    var clipId = "clip-".concat(explicitMaskId || $d31a6ed399ae6f4f$var$nextUniqueId());
    var maskTag = {
        tag: "mask",
        attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$ALL_SPACE, {
            id: maskId,
            maskUnits: "userSpaceOnUse",
            maskContentUnits: "userSpaceOnUse"
        }),
        children: [
            maskRect,
            maskOuterGroup
        ]
    };
    var defs = {
        tag: "defs",
        children: [
            {
                tag: "clipPath",
                attributes: {
                    id: clipId
                },
                children: $d31a6ed399ae6f4f$var$deGroup(maskPath)
            },
            maskTag
        ]
    };
    children.push(defs, {
        tag: "rect",
        attributes: $d31a6ed399ae6f4f$var$_objectSpread({
            fill: "currentColor",
            "clip-path": "url(#".concat(clipId, ")"),
            mask: "url(#".concat(maskId, ")")
        }, $d31a6ed399ae6f4f$var$ALL_SPACE)
    });
    return {
        children: children,
        attributes: attributes
    };
}
function $d31a6ed399ae6f4f$var$makeIconStandard(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, transform = _ref.transform, styles = _ref.styles;
    var styleString = $d31a6ed399ae6f4f$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    if ($d31a6ed399ae6f4f$var$transformIsMeaningful(transform)) {
        var trans = $d31a6ed399ae6f4f$var$transformForSvg({
            transform: transform,
            containerWidth: main.width,
            iconWidth: main.width
        });
        children.push({
            tag: "g",
            attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, trans.outer),
            children: [
                {
                    tag: "g",
                    attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, trans.inner),
                    children: [
                        {
                            tag: main.icon.tag,
                            children: main.icon.children,
                            attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, main.icon.attributes, trans.path)
                        }
                    ]
                }
            ]
        });
    } else children.push(main.icon);
    return {
        children: children,
        attributes: attributes
    };
}
function $d31a6ed399ae6f4f$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($d31a6ed399ae6f4f$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $d31a6ed399ae6f4f$var$joinStyles($d31a6ed399ae6f4f$var$_objectSpread({}, styles, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $d31a6ed399ae6f4f$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, attributes, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $d31a6ed399ae6f4f$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var widthClass = isUploadedIcon ? "" : "fa-w-".concat(Math.ceil(width / height * 16));
    var attrClass = [
        $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.replacementClass,
        iconName ? "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : "",
        widthClass
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, extra.attributes, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$d31a6ed399ae6f4f$var$DATA_FA_I2SVG] = "";
    if (title) content.children.push({
        tag: "title",
        attributes: {
            id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $d31a6ed399ae6f4f$var$nextUniqueId())
        },
        children: [
            title
        ]
    });
    var args = $d31a6ed399ae6f4f$var$_objectSpread({}, content, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $d31a6ed399ae6f4f$var$_objectSpread({}, uploadedIconWidthStyle, extra.styles)
    });
    var _ref2 = mask.found && main.found ? $d31a6ed399ae6f4f$var$makeIconMasking(args) : $d31a6ed399ae6f4f$var$makeIconStandard(args), children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $d31a6ed399ae6f4f$var$asSymbol(args);
    else return $d31a6ed399ae6f4f$var$asIcon(args);
}
function $d31a6ed399ae6f4f$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $d31a6ed399ae6f4f$var$_objectSpread({}, extra.attributes, title ? {
        "title": title
    } : {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$d31a6ed399ae6f4f$var$DATA_FA_I2SVG] = "";
    var styles = $d31a6ed399ae6f4f$var$_objectSpread({}, extra.styles);
    if ($d31a6ed399ae6f4f$var$transformIsMeaningful(transform)) {
        styles["transform"] = $d31a6ed399ae6f4f$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $d31a6ed399ae6f4f$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $d31a6ed399ae6f4f$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $d31a6ed399ae6f4f$var$_objectSpread({}, extra.attributes, title ? {
        "title": title
    } : {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $d31a6ed399ae6f4f$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $d31a6ed399ae6f4f$var$noop$1 = function noop() {};
var $d31a6ed399ae6f4f$var$p = $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.measurePerformance && $d31a6ed399ae6f4f$var$PERFORMANCE && $d31a6ed399ae6f4f$var$PERFORMANCE.mark && $d31a6ed399ae6f4f$var$PERFORMANCE.measure ? $d31a6ed399ae6f4f$var$PERFORMANCE : {
    mark: $d31a6ed399ae6f4f$var$noop$1,
    measure: $d31a6ed399ae6f4f$var$noop$1
};
var $d31a6ed399ae6f4f$var$preamble = 'FA "5.15.4"';
var $d31a6ed399ae6f4f$var$begin = function begin(name) {
    $d31a6ed399ae6f4f$var$p.mark("".concat($d31a6ed399ae6f4f$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $d31a6ed399ae6f4f$var$end(name);
    };
};
var $d31a6ed399ae6f4f$var$end = function end(name) {
    $d31a6ed399ae6f4f$var$p.mark("".concat($d31a6ed399ae6f4f$var$preamble, " ").concat(name, " ends"));
    $d31a6ed399ae6f4f$var$p.measure("".concat($d31a6ed399ae6f4f$var$preamble, " ").concat(name), "".concat($d31a6ed399ae6f4f$var$preamble, " ").concat(name, " begins"), "".concat($d31a6ed399ae6f4f$var$preamble, " ").concat(name, " ends"));
};
var $d31a6ed399ae6f4f$var$perf = {
    begin: $d31a6ed399ae6f4f$var$begin,
    end: $d31a6ed399ae6f4f$var$end
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $d31a6ed399ae6f4f$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $d31a6ed399ae6f4f$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $d31a6ed399ae6f4f$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
function $d31a6ed399ae6f4f$var$toHex(unicode) {
    var result = "";
    for(var i = 0; i < unicode.length; i++){
        var hex = unicode.charCodeAt(i).toString(16);
        result += ("000" + hex).slice(-4);
    }
    return result;
}
function $d31a6ed399ae6f4f$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
    if (typeof $d31a6ed399ae6f4f$var$namespace.hooks.addPack === "function" && !skipHooks) $d31a6ed399ae6f4f$var$namespace.hooks.addPack(prefix, normalized);
    else $d31a6ed399ae6f4f$var$namespace.styles[prefix] = $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$namespace.styles[prefix] || {}, normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $d31a6ed399ae6f4f$var$defineIcons("fa", icons);
}
var $d31a6ed399ae6f4f$var$styles = $d31a6ed399ae6f4f$var$namespace.styles, $d31a6ed399ae6f4f$var$shims = $d31a6ed399ae6f4f$var$namespace.shims;
var $d31a6ed399ae6f4f$var$_byUnicode = {};
var $d31a6ed399ae6f4f$var$_byLigature = {};
var $d31a6ed399ae6f4f$var$_byOldName = {};
var $d31a6ed399ae6f4f$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $d31a6ed399ae6f4f$var$reduce($d31a6ed399ae6f4f$var$styles, function(o, style, prefix) {
            o[prefix] = $d31a6ed399ae6f4f$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $d31a6ed399ae6f4f$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        return acc;
    });
    $d31a6ed399ae6f4f$var$_byLigature = lookup(function(acc, icon, iconName) {
        var ligatures = icon[2];
        acc[iconName] = iconName;
        ligatures.forEach(function(ligature) {
            acc[ligature] = iconName;
        });
        return acc;
    });
    var hasRegular = "far" in $d31a6ed399ae6f4f$var$styles;
    $d31a6ed399ae6f4f$var$_byOldName = $d31a6ed399ae6f4f$var$reduce($d31a6ed399ae6f4f$var$shims, function(acc, shim) {
        var oldName = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        acc[oldName] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {});
};
$d31a6ed399ae6f4f$var$build();
function $d31a6ed399ae6f4f$var$byUnicode(prefix, unicode) {
    return ($d31a6ed399ae6f4f$var$_byUnicode[prefix] || {})[unicode];
}
function $d31a6ed399ae6f4f$var$byLigature(prefix, ligature) {
    return ($d31a6ed399ae6f4f$var$_byLigature[prefix] || {})[ligature];
}
function $d31a6ed399ae6f4f$var$byOldName(name) {
    return $d31a6ed399ae6f4f$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
var $d31a6ed399ae6f4f$var$styles$1 = $d31a6ed399ae6f4f$var$namespace.styles;
var $d31a6ed399ae6f4f$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $d31a6ed399ae6f4f$var$getCanonicalIcon(values) {
    return values.reduce(function(acc, cls) {
        var iconName = $d31a6ed399ae6f4f$var$getIconName($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, cls);
        if ($d31a6ed399ae6f4f$var$styles$1[cls]) acc.prefix = cls;
        else if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoFetchSvg && Object.keys($d31a6ed399ae6f4f$var$PREFIX_TO_STYLE).indexOf(cls) > -1) acc.prefix = cls;
        else if (iconName) {
            var shim = acc.prefix === "fa" ? $d31a6ed399ae6f4f$var$byOldName(iconName) : {};
            acc.iconName = shim.iconName || iconName;
            acc.prefix = shim.prefix || acc.prefix;
        } else if (cls !== $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.replacementClass && cls.indexOf("fa-w-") !== 0) acc.rest.push(cls);
        return acc;
    }, $d31a6ed399ae6f4f$var$emptyCanonicalIcon());
}
function $d31a6ed399ae6f4f$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
function $d31a6ed399ae6f4f$export$a10125c086a4df16(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $d31a6ed399ae6f4f$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($d31a6ed399ae6f4f$var$joinAttributes(attributes), ">").concat(children.map($d31a6ed399ae6f4f$export$a10125c086a4df16).join(""), "</").concat(tag, ">");
}
var $d31a6ed399ae6f4f$var$noop$2 = function noop() {};
function $d31a6ed399ae6f4f$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($d31a6ed399ae6f4f$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $d31a6ed399ae6f4f$var$getMutator() {
    if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoReplaceSvg === true) return $d31a6ed399ae6f4f$var$mutators.replace;
    var mutator = $d31a6ed399ae6f4f$var$mutators[$d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoReplaceSvg];
    return mutator || $d31a6ed399ae6f4f$var$mutators.replace;
}
var $d31a6ed399ae6f4f$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        var newOuterHTML = abstract.map(function(a) {
            return $d31a6ed399ae6f4f$export$a10125c086a4df16(a);
        }).join("\n");
        if (node.parentNode && node.outerHTML) node.outerHTML = newOuterHTML + ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.keepOriginalSource && node.tagName.toLowerCase() !== "svg" ? "<!-- ".concat(node.outerHTML, " Font Awesome fontawesome.com -->") : "");
        else if (node.parentNode) {
            var newNode = document.createElement("span");
            node.parentNode.replaceChild(newNode, node);
            newNode.outerHTML = newOuterHTML;
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$d31a6ed399ae6f4f$var$classArray(node).indexOf($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.replacementClass)) return $d31a6ed399ae6f4f$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-.*"));
        delete abstract[0].attributes.style;
        delete abstract[0].attributes.id;
        var splitClasses = abstract[0].attributes.class.split(" ").reduce(function(acc, cls) {
            if (cls === $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
            else acc.toNode.push(cls);
            return acc;
        }, {
            toNode: [],
            toSvg: []
        });
        abstract[0].attributes.class = splitClasses.toSvg.join(" ");
        var newInnerHTML = abstract.map(function(a) {
            return $d31a6ed399ae6f4f$export$a10125c086a4df16(a);
        }).join("\n");
        node.setAttribute("class", splitClasses.toNode.join(" "));
        node.setAttribute($d31a6ed399ae6f4f$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $d31a6ed399ae6f4f$var$performOperationSync(op) {
    op();
}
function $d31a6ed399ae6f4f$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $d31a6ed399ae6f4f$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $d31a6ed399ae6f4f$var$performOperationSync;
        if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.mutateApproach === $d31a6ed399ae6f4f$var$MUTATION_APPROACH_ASYNC) frame = $d31a6ed399ae6f4f$var$WINDOW.requestAnimationFrame || $d31a6ed399ae6f4f$var$performOperationSync;
        frame(function() {
            var mutator = $d31a6ed399ae6f4f$var$getMutator();
            var mark = $d31a6ed399ae6f4f$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $d31a6ed399ae6f4f$var$disabled = false;
function $d31a6ed399ae6f4f$var$disableObservation() {
    $d31a6ed399ae6f4f$var$disabled = true;
}
function $d31a6ed399ae6f4f$var$enableObservation() {
    $d31a6ed399ae6f4f$var$disabled = false;
}
var $d31a6ed399ae6f4f$var$mo = null;
function $d31a6ed399ae6f4f$var$observe(options) {
    if (!$d31a6ed399ae6f4f$var$MUTATION_OBSERVER) return;
    if (!$d31a6ed399ae6f4f$export$e506a1d27d1eaa20.observeMutations) return;
    var treeCallback = options.treeCallback, nodeCallback = options.nodeCallback, pseudoElementsCallback = options.pseudoElementsCallback, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $d31a6ed399ae6f4f$var$DOCUMENT : _options$observeMutat;
    $d31a6ed399ae6f4f$var$mo = new $d31a6ed399ae6f4f$var$MUTATION_OBSERVER(function(objects) {
        if ($d31a6ed399ae6f4f$var$disabled) return;
        $d31a6ed399ae6f4f$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$d31a6ed399ae6f4f$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $d31a6ed399ae6f4f$var$isWatched(mutationRecord.target) && ~$d31a6ed399ae6f4f$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class") {
                    var _getCanonicalIcon = $d31a6ed399ae6f4f$var$getCanonicalIcon($d31a6ed399ae6f4f$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    if (prefix) mutationRecord.target.setAttribute("data-prefix", prefix);
                    if (iconName) mutationRecord.target.setAttribute("data-icon", iconName);
                } else nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$d31a6ed399ae6f4f$var$IS_DOM) return;
    $d31a6ed399ae6f4f$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $d31a6ed399ae6f4f$var$disconnect() {
    if (!$d31a6ed399ae6f4f$var$mo) return;
    $d31a6ed399ae6f4f$var$mo.disconnect();
}
function $d31a6ed399ae6f4f$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $d31a6ed399ae6f4f$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $d31a6ed399ae6f4f$var$getCanonicalIcon($d31a6ed399ae6f4f$var$classArray(node));
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.prefix && innerText.length > 1) val.iconName = $d31a6ed399ae6f4f$var$byLigature(val.prefix, node.innerText);
    else if (val.prefix && innerText.length === 1) val.iconName = $d31a6ed399ae6f4f$var$byUnicode(val.prefix, $d31a6ed399ae6f4f$var$toHex(node.innerText));
    return val;
}
var $d31a6ed399ae6f4f$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    if (!transformString) return transform;
    else return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
function $d31a6ed399ae6f4f$var$transformParser(node) {
    return $d31a6ed399ae6f4f$var$parseTransformString(node.getAttribute("data-fa-transform"));
}
function $d31a6ed399ae6f4f$var$symbolParser(node) {
    var symbol = node.getAttribute("data-fa-symbol");
    return symbol === null ? false : symbol === "" ? true : symbol;
}
function $d31a6ed399ae6f4f$var$attributesParser(node) {
    var extraAttributes = $d31a6ed399ae6f4f$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $d31a6ed399ae6f4f$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $d31a6ed399ae6f4f$var$maskParser(node) {
    var mask = node.getAttribute("data-fa-mask");
    if (!mask) return $d31a6ed399ae6f4f$var$emptyCanonicalIcon();
    else return $d31a6ed399ae6f4f$var$getCanonicalIcon(mask.split(" ").map(function(i) {
        return i.trim();
    }));
}
function $d31a6ed399ae6f4f$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $d31a6ed399ae6f4f$var$meaninglessTransform,
        symbol: false,
        mask: null,
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $d31a6ed399ae6f4f$var$parseMeta(node) {
    var _classParser = $d31a6ed399ae6f4f$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraStyles = $d31a6ed399ae6f4f$var$styleParser(node);
    var transform = $d31a6ed399ae6f4f$var$transformParser(node);
    var symbol = $d31a6ed399ae6f4f$var$symbolParser(node);
    var extraAttributes = $d31a6ed399ae6f4f$var$attributesParser(node);
    var mask = $d31a6ed399ae6f4f$var$maskParser(node);
    return {
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: transform,
        symbol: symbol,
        mask: mask,
        maskId: node.getAttribute("data-fa-mask-id"),
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    };
}
function $d31a6ed399ae6f4f$var$MissingIcon(error) {
    this.name = "MissingIcon";
    this.message = error || "Icon unavailable";
    this.stack = new Error().stack;
}
$d31a6ed399ae6f4f$var$MissingIcon.prototype = Object.create(Error.prototype);
$d31a6ed399ae6f4f$var$MissingIcon.prototype.constructor = $d31a6ed399ae6f4f$var$MissingIcon;
var $d31a6ed399ae6f4f$var$FILL = {
    fill: "currentColor"
};
var $d31a6ed399ae6f4f$var$ANIMATION_BASE = {
    attributeType: "XML",
    repeatCount: "indefinite",
    dur: "2s"
};
var $d31a6ed399ae6f4f$var$RING = {
    tag: "path",
    attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$FILL, {
        d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
    })
};
var $d31a6ed399ae6f4f$var$OPACITY_ANIMATE = $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$ANIMATION_BASE, {
    attributeName: "opacity"
});
var $d31a6ed399ae6f4f$var$DOT = {
    tag: "circle",
    attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$FILL, {
        cx: "256",
        cy: "364",
        r: "28"
    }),
    children: [
        {
            tag: "animate",
            attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$ANIMATION_BASE, {
                attributeName: "r",
                values: "28;14;28;28;14;28;"
            })
        },
        {
            tag: "animate",
            attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$OPACITY_ANIMATE, {
                values: "1;0;1;1;0;1;"
            })
        }
    ]
};
var $d31a6ed399ae6f4f$var$QUESTION = {
    tag: "path",
    attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$FILL, {
        opacity: "1",
        d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
    }),
    children: [
        {
            tag: "animate",
            attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$OPACITY_ANIMATE, {
                values: "1;0;0;0;0;1;"
            })
        }
    ]
};
var $d31a6ed399ae6f4f$var$EXCLAMATION = {
    tag: "path",
    attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$FILL, {
        opacity: "0",
        d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
    }),
    children: [
        {
            tag: "animate",
            attributes: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$OPACITY_ANIMATE, {
                values: "0;0;1;1;0;0;"
            })
        }
    ]
};
var $d31a6ed399ae6f4f$var$missing = {
    tag: "g",
    children: [
        $d31a6ed399ae6f4f$var$RING,
        $d31a6ed399ae6f4f$var$DOT,
        $d31a6ed399ae6f4f$var$QUESTION,
        $d31a6ed399ae6f4f$var$EXCLAMATION
    ]
};
var $d31a6ed399ae6f4f$var$styles$2 = $d31a6ed399ae6f4f$var$namespace.styles;
function $d31a6ed399ae6f4f$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $d31a6ed399ae6f4f$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-").concat($d31a6ed399ae6f4f$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-").concat($d31a6ed399ae6f4f$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-").concat($d31a6ed399ae6f4f$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
function $d31a6ed399ae6f4f$var$findIcon(iconName, prefix) {
    return new $d31a6ed399ae6f4f$var$picked(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $d31a6ed399ae6f4f$var$missing
        };
        if (iconName && prefix && $d31a6ed399ae6f4f$var$styles$2[prefix] && $d31a6ed399ae6f4f$var$styles$2[prefix][iconName]) {
            var icon = $d31a6ed399ae6f4f$var$styles$2[prefix][iconName];
            return resolve($d31a6ed399ae6f4f$var$asFoundIcon(icon));
        }
        if (iconName && prefix && !$d31a6ed399ae6f4f$export$e506a1d27d1eaa20.showMissingIcons) reject(new $d31a6ed399ae6f4f$var$MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
        else resolve(val);
    });
}
var $d31a6ed399ae6f4f$var$styles$3 = $d31a6ed399ae6f4f$var$namespace.styles;
function $d31a6ed399ae6f4f$var$generateSvgReplacementMutation(node, nodeMeta) {
    var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
    return new $d31a6ed399ae6f4f$var$picked(function(resolve, reject) {
        $d31a6ed399ae6f4f$var$picked.all([
            $d31a6ed399ae6f4f$var$findIcon(iconName, prefix),
            $d31a6ed399ae6f4f$var$findIcon(mask.iconName, mask.prefix)
        ]).then(function(_ref) {
            var _ref2 = $d31a6ed399ae6f4f$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
            resolve([
                node,
                $d31a6ed399ae6f4f$var$makeInlineSvgAbstract({
                    icons: {
                        main: main,
                        mask: mask
                    },
                    prefix: prefix,
                    iconName: iconName,
                    transform: transform,
                    symbol: symbol,
                    mask: mask,
                    maskId: maskId,
                    title: title,
                    titleId: titleId,
                    extra: extra,
                    watchable: true
                })
            ]);
        });
    });
}
function $d31a6ed399ae6f4f$var$generateLayersText(node, nodeMeta) {
    var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
    var width = null;
    var height = null;
    if ($d31a6ed399ae6f4f$var$IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
    }
    if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
    return $d31a6ed399ae6f4f$var$picked.resolve([
        node,
        $d31a6ed399ae6f4f$var$makeLayersTextAbstract({
            content: node.innerHTML,
            width: width,
            height: height,
            transform: transform,
            title: title,
            extra: extra,
            watchable: true
        })
    ]);
}
function $d31a6ed399ae6f4f$var$generateMutation(node) {
    var nodeMeta = $d31a6ed399ae6f4f$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($d31a6ed399ae6f4f$var$LAYERS_TEXT_CLASSNAME)) return $d31a6ed399ae6f4f$var$generateLayersText(node, nodeMeta);
    else return $d31a6ed399ae6f4f$var$generateSvgReplacementMutation(node, nodeMeta);
}
function $d31a6ed399ae6f4f$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$d31a6ed399ae6f4f$var$IS_DOM) return;
    var htmlClassList = $d31a6ed399ae6f4f$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($d31a6ed399ae6f4f$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($d31a6ed399ae6f4f$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoFetchSvg ? Object.keys($d31a6ed399ae6f4f$var$PREFIX_TO_STYLE) : Object.keys($d31a6ed399ae6f4f$var$styles$3);
    var prefixesDomQuery = [
        ".".concat($d31a6ed399ae6f4f$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($d31a6ed399ae6f4f$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($d31a6ed399ae6f4f$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return;
    var candidates = [];
    try {
        candidates = $d31a6ed399ae6f4f$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return;
    var mark = $d31a6ed399ae6f4f$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $d31a6ed399ae6f4f$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$d31a6ed399ae6f4f$var$PRODUCTION) {
                if (e instanceof $d31a6ed399ae6f4f$var$MissingIcon) console.error(e);
            }
        }
        return acc;
    }, []);
    return new $d31a6ed399ae6f4f$var$picked(function(resolve, reject) {
        $d31a6ed399ae6f4f$var$picked.all(mutations).then(function(resolvedMutations) {
            $d31a6ed399ae6f4f$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function() {
            mark();
            reject();
        });
    });
}
function $d31a6ed399ae6f4f$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $d31a6ed399ae6f4f$var$generateMutation(node).then(function(mutation) {
        if (mutation) $d31a6ed399ae6f4f$var$perform([
            mutation
        ], callback);
    });
}
function $d31a6ed399ae6f4f$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($d31a6ed399ae6f4f$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new $d31a6ed399ae6f4f$var$picked(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $d31a6ed399ae6f4f$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($d31a6ed399ae6f4f$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $d31a6ed399ae6f4f$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($d31a6ed399ae6f4f$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $d31a6ed399ae6f4f$var$STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : $d31a6ed399ae6f4f$var$FONT_WEIGHT_TO_PREFIX[fontWeight];
            var hexValue = $d31a6ed399ae6f4f$var$toHex(_content.length === 3 ? _content.substr(1, 1) : _content);
            var iconName = $d31a6ed399ae6f4f$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName; // Only convert the pseudo element in this :before/:after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($d31a6ed399ae6f4f$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($d31a6ed399ae6f4f$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $d31a6ed399ae6f4f$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$d31a6ed399ae6f4f$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $d31a6ed399ae6f4f$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $d31a6ed399ae6f4f$var$makeInlineSvgAbstract($d31a6ed399ae6f4f$var$_objectSpread({}, meta, {
                        icons: {
                            main: main,
                            mask: $d31a6ed399ae6f4f$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $d31a6ed399ae6f4f$var$DOCUMENT.createElement("svg");
                    if (position === ":before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return $d31a6ed399ae6f4f$export$a10125c086a4df16(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $d31a6ed399ae6f4f$var$replace(node) {
    return $d31a6ed399ae6f4f$var$picked.all([
        $d31a6ed399ae6f4f$var$replaceForPosition(node, ":before"),
        $d31a6ed399ae6f4f$var$replaceForPosition(node, ":after")
    ]);
}
function $d31a6ed399ae6f4f$var$processable(node) {
    return node.parentNode !== document.head && !~$d31a6ed399ae6f4f$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($d31a6ed399ae6f4f$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $d31a6ed399ae6f4f$var$searchPseudoElements(root) {
    if (!$d31a6ed399ae6f4f$var$IS_DOM) return;
    return new $d31a6ed399ae6f4f$var$picked(function(resolve, reject) {
        var operations = $d31a6ed399ae6f4f$var$toArray(root.querySelectorAll("*")).filter($d31a6ed399ae6f4f$var$processable).map($d31a6ed399ae6f4f$var$replace);
        var end = $d31a6ed399ae6f4f$var$perf.begin("searchPseudoElements");
        $d31a6ed399ae6f4f$var$disableObservation();
        $d31a6ed399ae6f4f$var$picked.all(operations).then(function() {
            end();
            $d31a6ed399ae6f4f$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $d31a6ed399ae6f4f$var$enableObservation();
            reject();
        });
    });
}
var $d31a6ed399ae6f4f$var$baseStyles = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
function $d31a6ed399ae6f4f$var$css() {
    var dfp = $d31a6ed399ae6f4f$var$DEFAULT_FAMILY_PREFIX;
    var drc = $d31a6ed399ae6f4f$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix;
    var rc = $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.replacementClass;
    var s = $d31a6ed399ae6f4f$var$baseStyles;
    if (fp !== dfp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $d31a6ed399ae6f4f$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $d31a6ed399ae6f4f$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $d31a6ed399ae6f4f$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $d31a6ed399ae6f4f$var$_objectSpread({}, _this.definitions[key] || {}, additions[key]);
                    $d31a6ed399ae6f4f$var$defineIcons(key, additions[key]);
                    $d31a6ed399ae6f4f$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    if (!additions[prefix]) additions[prefix] = {};
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
function $d31a6ed399ae6f4f$var$ensureCss() {
    if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoAddCss && !$d31a6ed399ae6f4f$var$_cssInserted) {
        $d31a6ed399ae6f4f$var$insertCss($d31a6ed399ae6f4f$var$css());
        $d31a6ed399ae6f4f$var$_cssInserted = true;
    }
}
function $d31a6ed399ae6f4f$var$apiObject(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $d31a6ed399ae6f4f$export$a10125c086a4df16(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$d31a6ed399ae6f4f$var$IS_DOM) return;
            var container = $d31a6ed399ae6f4f$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $d31a6ed399ae6f4f$export$221fed4a47f597a5(iconLookup) {
    var _iconLookup$prefix = iconLookup.prefix, prefix = _iconLookup$prefix === void 0 ? "fa" : _iconLookup$prefix, iconName = iconLookup.iconName;
    if (!iconName) return;
    return $d31a6ed399ae6f4f$var$iconFromMapping($d31a6ed399ae6f4f$export$b839f963c7dc0e34.definitions, prefix, iconName) || $d31a6ed399ae6f4f$var$iconFromMapping($d31a6ed399ae6f4f$var$namespace.styles, prefix, iconName);
}
function $d31a6ed399ae6f4f$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $d31a6ed399ae6f4f$export$221fed4a47f597a5(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $d31a6ed399ae6f4f$export$221fed4a47f597a5(mask || {});
        return next(iconDefinition, $d31a6ed399ae6f4f$var$_objectSpread({}, params, {
            mask: mask
        }));
    };
}
var $d31a6ed399ae6f4f$export$b839f963c7dc0e34 = new $d31a6ed399ae6f4f$var$Library();
var $d31a6ed399ae6f4f$export$4f8e844b2782642c = function noAuto() {
    $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoReplaceSvg = false;
    $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.observeMutations = false;
    $d31a6ed399ae6f4f$var$disconnect();
};
var $d31a6ed399ae6f4f$var$_cssInserted = false;
var $d31a6ed399ae6f4f$export$df3a06d6289f983e = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($d31a6ed399ae6f4f$var$IS_DOM) {
            $d31a6ed399ae6f4f$var$ensureCss();
            var _params$node = params.node, node = _params$node === void 0 ? $d31a6ed399ae6f4f$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.searchPseudoElements) $d31a6ed399ae6f4f$var$searchPseudoElements(node);
            return $d31a6ed399ae6f4f$var$onTree(node, callback);
        } else return $d31a6ed399ae6f4f$var$picked.reject("Operation requires a DOM of some kind.");
    },
    css: $d31a6ed399ae6f4f$var$css,
    insertCss: function insertCss$$1() {
        if (!$d31a6ed399ae6f4f$var$_cssInserted) {
            $d31a6ed399ae6f4f$var$insertCss($d31a6ed399ae6f4f$var$css());
            $d31a6ed399ae6f4f$var$_cssInserted = true;
        }
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot, observeMutationsRoot = params.observeMutationsRoot;
        if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoReplaceSvg === false) $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoReplaceSvg = true;
        $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.observeMutations = true;
        $d31a6ed399ae6f4f$var$domready(function() {
            $d31a6ed399ae6f4f$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $d31a6ed399ae6f4f$var$observe({
                treeCallback: $d31a6ed399ae6f4f$var$onTree,
                nodeCallback: $d31a6ed399ae6f4f$var$onNode,
                pseudoElementsCallback: $d31a6ed399ae6f4f$var$searchPseudoElements,
                observeMutationsRoot: observeMutationsRoot
            });
        });
    }
};
var $d31a6ed399ae6f4f$export$98e6a39c04603d36 = {
    transform: function transform(transformString) {
        return $d31a6ed399ae6f4f$var$parseTransformString(transformString);
    }
};
var $d31a6ed399ae6f4f$export$1ca1ec8b29a4ce27 = $d31a6ed399ae6f4f$var$resolveIcons(function(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $d31a6ed399ae6f4f$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $d31a6ed399ae6f4f$var$apiObject($d31a6ed399ae6f4f$var$_objectSpread({
        type: "icon"
    }, iconDefinition), function() {
        $d31a6ed399ae6f4f$var$ensureCss();
        if ($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $d31a6ed399ae6f4f$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $d31a6ed399ae6f4f$var$makeInlineSvgAbstract({
            icons: {
                main: $d31a6ed399ae6f4f$var$asFoundIcon(icon),
                mask: mask ? $d31a6ed399ae6f4f$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$meaninglessTransform, transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
});
var $d31a6ed399ae6f4f$export$6f093cfa640b7166 = function text(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform2 = params.transform, transform = _params$transform2 === void 0 ? $d31a6ed399ae6f4f$var$meaninglessTransform : _params$transform2, _params$title2 = params.title, title = _params$title2 === void 0 ? null : _params$title2, _params$classes2 = params.classes, classes = _params$classes2 === void 0 ? [] : _params$classes2, _params$attributes2 = params.attributes, attributes = _params$attributes2 === void 0 ? {} : _params$attributes2, _params$styles2 = params.styles, styles = _params$styles2 === void 0 ? {} : _params$styles2;
    return $d31a6ed399ae6f4f$var$apiObject({
        type: "text",
        content: content
    }, function() {
        $d31a6ed399ae6f4f$var$ensureCss();
        return $d31a6ed399ae6f4f$var$makeLayersTextAbstract({
            content: content,
            transform: $d31a6ed399ae6f4f$var$_objectSpread({}, $d31a6ed399ae6f4f$var$meaninglessTransform, transform),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-layers-text")
                ].concat($d31a6ed399ae6f4f$var$_toConsumableArray(classes))
            }
        });
    });
};
var $d31a6ed399ae6f4f$export$e575061ef2a070eb = function counter(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$title3 = params.title, title = _params$title3 === void 0 ? null : _params$title3, _params$classes3 = params.classes, classes = _params$classes3 === void 0 ? [] : _params$classes3, _params$attributes3 = params.attributes, attributes = _params$attributes3 === void 0 ? {} : _params$attributes3, _params$styles3 = params.styles, styles = _params$styles3 === void 0 ? {} : _params$styles3;
    return $d31a6ed399ae6f4f$var$apiObject({
        type: "counter",
        content: content
    }, function() {
        $d31a6ed399ae6f4f$var$ensureCss();
        return $d31a6ed399ae6f4f$var$makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-layers-counter")
                ].concat($d31a6ed399ae6f4f$var$_toConsumableArray(classes))
            }
        });
    });
};
var $d31a6ed399ae6f4f$export$50a222d9023da98b = function layer(assembler) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$classes4 = params.classes, classes = _params$classes4 === void 0 ? [] : _params$classes4;
    return $d31a6ed399ae6f4f$var$apiObject({
        type: "layer"
    }, function() {
        $d31a6ed399ae6f4f$var$ensureCss();
        var children = [];
        assembler(function(args) {
            Array.isArray(args) ? args.map(function(a) {
                children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
        });
        return [
            {
                tag: "span",
                attributes: {
                    class: [
                        "".concat($d31a6ed399ae6f4f$export$e506a1d27d1eaa20.familyPrefix, "-layers")
                    ].concat($d31a6ed399ae6f4f$var$_toConsumableArray(classes)).join(" ")
                },
                children: children
            }
        ];
    });
};
var $d31a6ed399ae6f4f$var$api = {
    noAuto: $d31a6ed399ae6f4f$export$4f8e844b2782642c,
    config: $d31a6ed399ae6f4f$export$e506a1d27d1eaa20,
    dom: $d31a6ed399ae6f4f$export$df3a06d6289f983e,
    library: $d31a6ed399ae6f4f$export$b839f963c7dc0e34,
    parse: $d31a6ed399ae6f4f$export$98e6a39c04603d36,
    findIconDefinition: $d31a6ed399ae6f4f$export$221fed4a47f597a5,
    icon: $d31a6ed399ae6f4f$export$1ca1ec8b29a4ce27,
    text: $d31a6ed399ae6f4f$export$6f093cfa640b7166,
    counter: $d31a6ed399ae6f4f$export$e575061ef2a070eb,
    layer: $d31a6ed399ae6f4f$export$50a222d9023da98b,
    toHtml: $d31a6ed399ae6f4f$export$a10125c086a4df16
};
var $d31a6ed399ae6f4f$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $d31a6ed399ae6f4f$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($d31a6ed399ae6f4f$var$namespace.styles).length > 0 || $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoFetchSvg) && $d31a6ed399ae6f4f$var$IS_DOM && $d31a6ed399ae6f4f$export$e506a1d27d1eaa20.autoReplaceSvg) $d31a6ed399ae6f4f$var$api.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};



var $houiY = parcelRequire("houiY");

var $lDSNw = parcelRequire("lDSNw");
function $a59a3f093b9574b7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a59a3f093b9574b7$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a59a3f093b9574b7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a59a3f093b9574b7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a59a3f093b9574b7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a59a3f093b9574b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a59a3f093b9574b7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a59a3f093b9574b7$var$_typeof(obj);
}
function $a59a3f093b9574b7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a59a3f093b9574b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a59a3f093b9574b7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a59a3f093b9574b7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a59a3f093b9574b7$var$_toConsumableArray(arr) {
    return $a59a3f093b9574b7$var$_arrayWithoutHoles(arr) || $a59a3f093b9574b7$var$_iterableToArray(arr) || $a59a3f093b9574b7$var$_unsupportedIterableToArray(arr) || $a59a3f093b9574b7$var$_nonIterableSpread();
}
function $a59a3f093b9574b7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a59a3f093b9574b7$var$_arrayLikeToArray(arr);
}
function $a59a3f093b9574b7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a59a3f093b9574b7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a59a3f093b9574b7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a59a3f093b9574b7$var$_arrayLikeToArray(o, minLen);
}
function $a59a3f093b9574b7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a59a3f093b9574b7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $a59a3f093b9574b7$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $a59a3f093b9574b7$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $a59a3f093b9574b7$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $a59a3f093b9574b7$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $a59a3f093b9574b7$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $a59a3f093b9574b7$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $a59a3f093b9574b7$var$camelize(string) {
    if ($a59a3f093b9574b7$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $a59a3f093b9574b7$var$_excluded$1 = [
    "style"
];
function $a59a3f093b9574b7$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $a59a3f093b9574b7$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $a59a3f093b9574b7$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$a59a3f093b9574b7$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $a59a3f093b9574b7$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $a59a3f093b9574b7$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $a59a3f093b9574b7$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$a59a3f093b9574b7$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $a59a3f093b9574b7$var$_objectWithoutProperties(extraProps, $a59a3f093b9574b7$var$_excluded$1);
    mixins.attrs["style"] = $a59a3f093b9574b7$var$_objectSpread2($a59a3f093b9574b7$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $a59a3f093b9574b7$var$_objectSpread2($a59a3f093b9574b7$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($a59a3f093b9574b7$var$_toConsumableArray(children)));
}
var $a59a3f093b9574b7$var$PRODUCTION = false;
try {
    $a59a3f093b9574b7$var$PRODUCTION = true;
} catch (e) {}
function $a59a3f093b9574b7$var$log() {
    if (!$a59a3f093b9574b7$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $a59a3f093b9574b7$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $a59a3f093b9574b7$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $d31a6ed399ae6f4f$export$98e6a39c04603d36).icon) return (0, $d31a6ed399ae6f4f$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $a59a3f093b9574b7$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $a59a3f093b9574b7$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $a59a3f093b9574b7$var$_defineProperty({}, key, value) : {};
}
var $a59a3f093b9574b7$var$_excluded = [
    "forwardedRef"
];
function $a59a3f093b9574b7$export$2b9260d4a45c8710(_ref) {
    var forwardedRef = _ref.forwardedRef, props = $a59a3f093b9574b7$var$_objectWithoutProperties(_ref, $a59a3f093b9574b7$var$_excluded);
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $a59a3f093b9574b7$var$normalizeIconArgs(iconArgs);
    var classes = $a59a3f093b9574b7$var$objectWithKey("classes", [].concat($a59a3f093b9574b7$var$_toConsumableArray($a59a3f093b9574b7$var$classList(props)), $a59a3f093b9574b7$var$_toConsumableArray(className.split(" "))));
    var transform = $a59a3f093b9574b7$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $d31a6ed399ae6f4f$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $a59a3f093b9574b7$var$objectWithKey("mask", $a59a3f093b9574b7$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $d31a6ed399ae6f4f$export$1ca1ec8b29a4ce27)(iconLookup, $a59a3f093b9574b7$var$_objectSpread2($a59a3f093b9574b7$var$_objectSpread2($a59a3f093b9574b7$var$_objectSpread2($a59a3f093b9574b7$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $a59a3f093b9574b7$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: forwardedRef
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$a59a3f093b9574b7$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $a59a3f093b9574b7$var$convertCurry(abstract[0], extraProps);
}
$a59a3f093b9574b7$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$a59a3f093b9574b7$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool
};
$a59a3f093b9574b7$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $a59a3f093b9574b7$var$convertCurry = $a59a3f093b9574b7$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement);



var $lDSNw = parcelRequire("lDSNw");
const $1eefc8ec6b0aa42b$export$123b3f6a12b10eb2 = (data)=>data.reduce((acc, { performanceByAsset: performanceByAsset })=>{
        performanceByAsset.forEach((slot, i)=>{
            acc = [
                ...acc,
                slot
            ];
        });
        return acc;
    }, []).sort((a, b)=>{
        return b.score - a.score;
    });
const $1eefc8ec6b0aa42b$export$4a168f3c5dfef519 = (data)=>data.reduce((acc, { performanceByAsset: performanceByAsset })=>{
        performanceByAsset.forEach((slot, i)=>{
            const assets = Object.values(slot).filter((asset)=>asset.score !== 0);
            acc[i] = [
                ...acc[i] ?? [],
                ...assets
            ];
        });
        return acc;
    }, []).map((slot)=>{
        // Zheng's note: get the mean score for each slot
        const mean = slot.reduce((acc, { score: score }, _, { length: length })=>acc + score / length, 0);
        return slot.map((recommendation)=>({
                ...recommendation,
                distance: recommendation.score - mean,
                mean: // Zheng's note: calculate distances between each score and its relative slot's mean
                mean
            }));
    }).flat() // Zheng's note: flatten the array of recommendations per slot and sort them by distance to means
    .sort((a, b)=>{
        return b.distance - a.distance;
    }).reduce((acc, recommendation, _, array)=>{
        const { length: length } = acc.filter(({ id: id })=>recommendation.id === id);
        if (length) return acc;
        const dups = array.filter(({ id: id })=>recommendation.id === id);
        acc.push({
            ...recommendation,
            // Zheng's note: calculate average distance between each item
            distance: dups.reduce((acc, { distance: distance }, _, { length: length })=>{
                return acc + distance / length;
            }, 0),
            isDup: dups.length > 1
        });
        return acc;
    }, []).sort((a, b)=>{
        return b.distance - a.distance;
    });
const $1eefc8ec6b0aa42b$export$6eaed201bc0ad2f9 = (data)=>{
    return data.map(({ id: id, score: score }, i)=>({
            name: id,
            value: parseInt(score),
            fill: $1eefc8ec6b0aa42b$export$eb4a6c9777179c4c(i)
        }));
};
const $1eefc8ec6b0aa42b$export$747ddc15ee52f80 = (data)=>{
    return data.map(({ id: id, score: score }, i)=>({
            value: parseInt(score),
            name: id,
            fill: $1eefc8ec6b0aa42b$export$eb4a6c9777179c4c(i)
        }));
};
const $1eefc8ec6b0aa42b$export$eb4a6c9777179c4c = (index)=>{
    const colors = Array.from({
        length: 6
    }, (_, i)=>`var(--colors-chart-${i})`);
    return colors[index % 6];
};





parcelRequire("lDSNw");
/**
 * @fileOverview Cross
 */ var $1a0af961fe314d4f$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$1a0af961fe314d4f$export$f6f0c3fe4ec306ea.displayName = "Cell";

var $b12409ad867c77f5$exports = {};
var $381d490267e538c0$exports = {};
var $9d0c04c90015b763$exports = {};

var $50pTR = parcelRequire("50pTR");
/** Built-in value references. */ var $9d0c04c90015b763$var$Symbol = $50pTR.Symbol;
$9d0c04c90015b763$exports = $9d0c04c90015b763$var$Symbol;


var $dbb7d28d40840b68$exports = {};

/** Used for built-in method references. */ var $dbb7d28d40840b68$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dbb7d28d40840b68$var$hasOwnProperty = $dbb7d28d40840b68$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dbb7d28d40840b68$var$nativeObjectToString = $dbb7d28d40840b68$var$objectProto.toString;
/** Built-in value references. */ var $dbb7d28d40840b68$var$symToStringTag = $9d0c04c90015b763$exports ? $9d0c04c90015b763$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dbb7d28d40840b68$var$getRawTag(value) {
    var isOwn = $dbb7d28d40840b68$var$hasOwnProperty.call(value, $dbb7d28d40840b68$var$symToStringTag), tag = value[$dbb7d28d40840b68$var$symToStringTag];
    try {
        value[$dbb7d28d40840b68$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dbb7d28d40840b68$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dbb7d28d40840b68$var$symToStringTag] = tag;
        else delete value[$dbb7d28d40840b68$var$symToStringTag];
    }
    return result;
}
$dbb7d28d40840b68$exports = $dbb7d28d40840b68$var$getRawTag;


var $671cf76858368a56$exports = {};
/** Used for built-in method references. */ var $671cf76858368a56$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $671cf76858368a56$var$nativeObjectToString = $671cf76858368a56$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $671cf76858368a56$var$objectToString(value) {
    return $671cf76858368a56$var$nativeObjectToString.call(value);
}
$671cf76858368a56$exports = $671cf76858368a56$var$objectToString;


/** `Object#toString` result references. */ var $381d490267e538c0$var$nullTag = "[object Null]", $381d490267e538c0$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $381d490267e538c0$var$symToStringTag = $9d0c04c90015b763$exports ? $9d0c04c90015b763$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $381d490267e538c0$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $381d490267e538c0$var$undefinedTag : $381d490267e538c0$var$nullTag;
    return $381d490267e538c0$var$symToStringTag && $381d490267e538c0$var$symToStringTag in Object(value) ? $dbb7d28d40840b68$exports(value) : $671cf76858368a56$exports(value);
}
$381d490267e538c0$exports = $381d490267e538c0$var$baseGetTag;


var $1e60876e846aca7c$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1e60876e846aca7c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$1e60876e846aca7c$exports = $1e60876e846aca7c$var$isObject;


/** `Object#toString` result references. */ var $b12409ad867c77f5$var$asyncTag = "[object AsyncFunction]", $b12409ad867c77f5$var$funcTag = "[object Function]", $b12409ad867c77f5$var$genTag = "[object GeneratorFunction]", $b12409ad867c77f5$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b12409ad867c77f5$var$isFunction(value) {
    if (!$1e60876e846aca7c$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $381d490267e538c0$exports(value);
    return tag == $b12409ad867c77f5$var$funcTag || tag == $b12409ad867c77f5$var$genTag || tag == $b12409ad867c77f5$var$asyncTag || tag == $b12409ad867c77f5$var$proxyTag;
}
$b12409ad867c77f5$exports = $b12409ad867c77f5$var$isFunction;


var $78a3e0804befecf2$exports = {};
var $52c7c35fde7b0b7d$exports = {};
var $3efe34f6c7e23d8a$exports = {};
var $2040da940dbce26f$exports = {};
var $cfaad5b9e6cb1fdd$exports = {};
var $121b86e8cfaae9d1$exports = {};
var $e97942353349732e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e97942353349732e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$e97942353349732e$exports = $e97942353349732e$var$listCacheClear;


var $1d7cfd3c09c2242c$exports = {};
var $2b239fc09a5eff4b$exports = {};
var $61269e018e176ece$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $61269e018e176ece$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$61269e018e176ece$exports = $61269e018e176ece$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2b239fc09a5eff4b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($61269e018e176ece$exports(array[length][0], key)) return length;
    }
    return -1;
}
$2b239fc09a5eff4b$exports = $2b239fc09a5eff4b$var$assocIndexOf;


/** Used for built-in method references. */ var $1d7cfd3c09c2242c$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $1d7cfd3c09c2242c$var$splice = $1d7cfd3c09c2242c$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1d7cfd3c09c2242c$var$listCacheDelete(key) {
    var data = this.__data__, index = $2b239fc09a5eff4b$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $1d7cfd3c09c2242c$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$1d7cfd3c09c2242c$exports = $1d7cfd3c09c2242c$var$listCacheDelete;


var $9685c2fe48057ae8$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9685c2fe48057ae8$var$listCacheGet(key) {
    var data = this.__data__, index = $2b239fc09a5eff4b$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$9685c2fe48057ae8$exports = $9685c2fe48057ae8$var$listCacheGet;


var $33e62cb08ffdb39e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $33e62cb08ffdb39e$var$listCacheHas(key) {
    return $2b239fc09a5eff4b$exports(this.__data__, key) > -1;
}
$33e62cb08ffdb39e$exports = $33e62cb08ffdb39e$var$listCacheHas;


var $c0c4365614946f9b$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c0c4365614946f9b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $2b239fc09a5eff4b$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$c0c4365614946f9b$exports = $c0c4365614946f9b$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $121b86e8cfaae9d1$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$121b86e8cfaae9d1$var$ListCache.prototype.clear = $e97942353349732e$exports;
$121b86e8cfaae9d1$var$ListCache.prototype["delete"] = $1d7cfd3c09c2242c$exports;
$121b86e8cfaae9d1$var$ListCache.prototype.get = $9685c2fe48057ae8$exports;
$121b86e8cfaae9d1$var$ListCache.prototype.has = $33e62cb08ffdb39e$exports;
$121b86e8cfaae9d1$var$ListCache.prototype.set = $c0c4365614946f9b$exports;
$121b86e8cfaae9d1$exports = $121b86e8cfaae9d1$var$ListCache;


var $0994f9fea1f069b1$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0994f9fea1f069b1$var$stackClear() {
    this.__data__ = new $121b86e8cfaae9d1$exports;
    this.size = 0;
}
$0994f9fea1f069b1$exports = $0994f9fea1f069b1$var$stackClear;


var $008a9eef7d18a855$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $008a9eef7d18a855$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$008a9eef7d18a855$exports = $008a9eef7d18a855$var$stackDelete;


var $66e742e89d0793a8$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $66e742e89d0793a8$var$stackGet(key) {
    return this.__data__.get(key);
}
$66e742e89d0793a8$exports = $66e742e89d0793a8$var$stackGet;


var $36f79ce77cad4a9d$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $36f79ce77cad4a9d$var$stackHas(key) {
    return this.__data__.has(key);
}
$36f79ce77cad4a9d$exports = $36f79ce77cad4a9d$var$stackHas;


var $eeca7cd4e4c1054a$exports = {};

var $b40deed3a00fd518$exports = {};
var $160af1b543b551be$exports = {};
var $543903464d192c2d$exports = {};

var $6e920adbeabef36b$exports = {};
var $e938ecebef569e4a$exports = {};

var $50pTR = parcelRequire("50pTR");
/** Used to detect overreaching core-js shims. */ var $e938ecebef569e4a$var$coreJsData = $50pTR["__core-js_shared__"];
$e938ecebef569e4a$exports = $e938ecebef569e4a$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $6e920adbeabef36b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($e938ecebef569e4a$exports && $e938ecebef569e4a$exports.keys && $e938ecebef569e4a$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6e920adbeabef36b$var$isMasked(func) {
    return !!$6e920adbeabef36b$var$maskSrcKey && $6e920adbeabef36b$var$maskSrcKey in func;
}
$6e920adbeabef36b$exports = $6e920adbeabef36b$var$isMasked;



var $485043477d4e3478$exports = {};
/** Used for built-in method references. */ var $485043477d4e3478$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $485043477d4e3478$var$funcToString = $485043477d4e3478$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $485043477d4e3478$var$toSource(func) {
    if (func != null) {
        try {
            return $485043477d4e3478$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$485043477d4e3478$exports = $485043477d4e3478$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $543903464d192c2d$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $543903464d192c2d$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $543903464d192c2d$var$funcProto = Function.prototype, $543903464d192c2d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $543903464d192c2d$var$funcToString = $543903464d192c2d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $543903464d192c2d$var$hasOwnProperty = $543903464d192c2d$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $543903464d192c2d$var$reIsNative = RegExp("^" + $543903464d192c2d$var$funcToString.call($543903464d192c2d$var$hasOwnProperty).replace($543903464d192c2d$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $543903464d192c2d$var$baseIsNative(value) {
    if (!$1e60876e846aca7c$exports(value) || $6e920adbeabef36b$exports(value)) return false;
    var pattern = $b12409ad867c77f5$exports(value) ? $543903464d192c2d$var$reIsNative : $543903464d192c2d$var$reIsHostCtor;
    return pattern.test($485043477d4e3478$exports(value));
}
$543903464d192c2d$exports = $543903464d192c2d$var$baseIsNative;


var $3dad42428d7380af$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3dad42428d7380af$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$3dad42428d7380af$exports = $3dad42428d7380af$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $160af1b543b551be$var$getNative(object, key) {
    var value = $3dad42428d7380af$exports(object, key);
    return $543903464d192c2d$exports(value) ? value : undefined;
}
$160af1b543b551be$exports = $160af1b543b551be$var$getNative;



var $50pTR = parcelRequire("50pTR");
/* Built-in method references that are verified to be native. */ var $b40deed3a00fd518$var$Map = $160af1b543b551be$exports($50pTR, "Map");
$b40deed3a00fd518$exports = $b40deed3a00fd518$var$Map;


var $5c4332b2a41d3880$exports = {};
var $4ec9108143cdd7f1$exports = {};
var $db0ecb8eee9bbf67$exports = {};
var $ff97ac060ed43a8e$exports = {};
var $9b030cde0fbb8131$exports = {};

/* Built-in method references that are verified to be native. */ var $9b030cde0fbb8131$var$nativeCreate = $160af1b543b551be$exports(Object, "create");
$9b030cde0fbb8131$exports = $9b030cde0fbb8131$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $ff97ac060ed43a8e$var$hashClear() {
    this.__data__ = $9b030cde0fbb8131$exports ? $9b030cde0fbb8131$exports(null) : {};
    this.size = 0;
}
$ff97ac060ed43a8e$exports = $ff97ac060ed43a8e$var$hashClear;


var $c1a93b77fff4564d$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c1a93b77fff4564d$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$c1a93b77fff4564d$exports = $c1a93b77fff4564d$var$hashDelete;


var $d7592e65fdc0e264$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d7592e65fdc0e264$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $d7592e65fdc0e264$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d7592e65fdc0e264$var$hasOwnProperty = $d7592e65fdc0e264$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d7592e65fdc0e264$var$hashGet(key) {
    var data = this.__data__;
    if ($9b030cde0fbb8131$exports) {
        var result = data[key];
        return result === $d7592e65fdc0e264$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d7592e65fdc0e264$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$d7592e65fdc0e264$exports = $d7592e65fdc0e264$var$hashGet;


var $6819853cc778e1c0$exports = {};

/** Used for built-in method references. */ var $6819853cc778e1c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6819853cc778e1c0$var$hasOwnProperty = $6819853cc778e1c0$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6819853cc778e1c0$var$hashHas(key) {
    var data = this.__data__;
    return $9b030cde0fbb8131$exports ? data[key] !== undefined : $6819853cc778e1c0$var$hasOwnProperty.call(data, key);
}
$6819853cc778e1c0$exports = $6819853cc778e1c0$var$hashHas;


var $e5a45a1dcd4f9a9d$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $e5a45a1dcd4f9a9d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e5a45a1dcd4f9a9d$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $9b030cde0fbb8131$exports && value === undefined ? $e5a45a1dcd4f9a9d$var$HASH_UNDEFINED : value;
    return this;
}
$e5a45a1dcd4f9a9d$exports = $e5a45a1dcd4f9a9d$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $db0ecb8eee9bbf67$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$db0ecb8eee9bbf67$var$Hash.prototype.clear = $ff97ac060ed43a8e$exports;
$db0ecb8eee9bbf67$var$Hash.prototype["delete"] = $c1a93b77fff4564d$exports;
$db0ecb8eee9bbf67$var$Hash.prototype.get = $d7592e65fdc0e264$exports;
$db0ecb8eee9bbf67$var$Hash.prototype.has = $6819853cc778e1c0$exports;
$db0ecb8eee9bbf67$var$Hash.prototype.set = $e5a45a1dcd4f9a9d$exports;
$db0ecb8eee9bbf67$exports = $db0ecb8eee9bbf67$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $4ec9108143cdd7f1$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $db0ecb8eee9bbf67$exports,
        "map": new ($b40deed3a00fd518$exports || $121b86e8cfaae9d1$exports),
        "string": new $db0ecb8eee9bbf67$exports
    };
}
$4ec9108143cdd7f1$exports = $4ec9108143cdd7f1$var$mapCacheClear;


var $af2f71dcbe46e5ed$exports = {};
var $044ab731d6b57324$exports = {};
var $769e0304e351cd96$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $769e0304e351cd96$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$769e0304e351cd96$exports = $769e0304e351cd96$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $044ab731d6b57324$var$getMapData(map, key) {
    var data = map.__data__;
    return $769e0304e351cd96$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$044ab731d6b57324$exports = $044ab731d6b57324$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $af2f71dcbe46e5ed$var$mapCacheDelete(key) {
    var result = $044ab731d6b57324$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$af2f71dcbe46e5ed$exports = $af2f71dcbe46e5ed$var$mapCacheDelete;


var $8427d4ef68a02380$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8427d4ef68a02380$var$mapCacheGet(key) {
    return $044ab731d6b57324$exports(this, key).get(key);
}
$8427d4ef68a02380$exports = $8427d4ef68a02380$var$mapCacheGet;


var $f88783d8dbdb04cf$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f88783d8dbdb04cf$var$mapCacheHas(key) {
    return $044ab731d6b57324$exports(this, key).has(key);
}
$f88783d8dbdb04cf$exports = $f88783d8dbdb04cf$var$mapCacheHas;


var $d7c722b8232de3f2$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $d7c722b8232de3f2$var$mapCacheSet(key, value) {
    var data = $044ab731d6b57324$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$d7c722b8232de3f2$exports = $d7c722b8232de3f2$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5c4332b2a41d3880$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$5c4332b2a41d3880$var$MapCache.prototype.clear = $4ec9108143cdd7f1$exports;
$5c4332b2a41d3880$var$MapCache.prototype["delete"] = $af2f71dcbe46e5ed$exports;
$5c4332b2a41d3880$var$MapCache.prototype.get = $8427d4ef68a02380$exports;
$5c4332b2a41d3880$var$MapCache.prototype.has = $f88783d8dbdb04cf$exports;
$5c4332b2a41d3880$var$MapCache.prototype.set = $d7c722b8232de3f2$exports;
$5c4332b2a41d3880$exports = $5c4332b2a41d3880$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $eeca7cd4e4c1054a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $eeca7cd4e4c1054a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $121b86e8cfaae9d1$exports) {
        var pairs = data.__data__;
        if (!$b40deed3a00fd518$exports || pairs.length < $eeca7cd4e4c1054a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $5c4332b2a41d3880$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$eeca7cd4e4c1054a$exports = $eeca7cd4e4c1054a$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cfaad5b9e6cb1fdd$var$Stack(entries) {
    var data = this.__data__ = new $121b86e8cfaae9d1$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$cfaad5b9e6cb1fdd$var$Stack.prototype.clear = $0994f9fea1f069b1$exports;
$cfaad5b9e6cb1fdd$var$Stack.prototype["delete"] = $008a9eef7d18a855$exports;
$cfaad5b9e6cb1fdd$var$Stack.prototype.get = $66e742e89d0793a8$exports;
$cfaad5b9e6cb1fdd$var$Stack.prototype.has = $36f79ce77cad4a9d$exports;
$cfaad5b9e6cb1fdd$var$Stack.prototype.set = $eeca7cd4e4c1054a$exports;
$cfaad5b9e6cb1fdd$exports = $cfaad5b9e6cb1fdd$var$Stack;


var $e50842fe59193160$exports = {};
var $5d51063ee4436072$exports = {};

var $e25638b1a2449235$exports = {};
var $20c8e479cb651aa7$exports = {};

var $c1bfbc0f9f5a73da$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $c1bfbc0f9f5a73da$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $c1bfbc0f9f5a73da$var$setCacheAdd(value) {
    this.__data__.set(value, $c1bfbc0f9f5a73da$var$HASH_UNDEFINED);
    return this;
}
$c1bfbc0f9f5a73da$exports = $c1bfbc0f9f5a73da$var$setCacheAdd;


var $53f759f5f3a75ce5$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $53f759f5f3a75ce5$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$53f759f5f3a75ce5$exports = $53f759f5f3a75ce5$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $20c8e479cb651aa7$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $5c4332b2a41d3880$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$20c8e479cb651aa7$var$SetCache.prototype.add = $20c8e479cb651aa7$var$SetCache.prototype.push = $c1bfbc0f9f5a73da$exports;
$20c8e479cb651aa7$var$SetCache.prototype.has = $53f759f5f3a75ce5$exports;
$20c8e479cb651aa7$exports = $20c8e479cb651aa7$var$SetCache;


var $1b27f0f94dfa755c$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $1b27f0f94dfa755c$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$1b27f0f94dfa755c$exports = $1b27f0f94dfa755c$var$arraySome;


var $ef45acb6e03538bb$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ef45acb6e03538bb$var$cacheHas(cache, key) {
    return cache.has(key);
}
$ef45acb6e03538bb$exports = $ef45acb6e03538bb$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $e25638b1a2449235$var$COMPARE_PARTIAL_FLAG = 1, $e25638b1a2449235$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e25638b1a2449235$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e25638b1a2449235$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e25638b1a2449235$var$COMPARE_UNORDERED_FLAG ? new $20c8e479cb651aa7$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$1b27f0f94dfa755c$exports(other, function(othValue, othIndex) {
                if (!$ef45acb6e03538bb$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$e25638b1a2449235$exports = $e25638b1a2449235$var$equalArrays;


var $c97d69106c053ef1$exports = {};

var $ec42fa0f6330fd05$exports = {};

var $50pTR = parcelRequire("50pTR");
/** Built-in value references. */ var $ec42fa0f6330fd05$var$Uint8Array = $50pTR.Uint8Array;
$ec42fa0f6330fd05$exports = $ec42fa0f6330fd05$var$Uint8Array;




var $a775bf75cfb65dce$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $a775bf75cfb65dce$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$a775bf75cfb65dce$exports = $a775bf75cfb65dce$var$mapToArray;


var $b008243b8e4f334f$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b008243b8e4f334f$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$b008243b8e4f334f$exports = $b008243b8e4f334f$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $c97d69106c053ef1$var$COMPARE_PARTIAL_FLAG = 1, $c97d69106c053ef1$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $c97d69106c053ef1$var$boolTag = "[object Boolean]", $c97d69106c053ef1$var$dateTag = "[object Date]", $c97d69106c053ef1$var$errorTag = "[object Error]", $c97d69106c053ef1$var$mapTag = "[object Map]", $c97d69106c053ef1$var$numberTag = "[object Number]", $c97d69106c053ef1$var$regexpTag = "[object RegExp]", $c97d69106c053ef1$var$setTag = "[object Set]", $c97d69106c053ef1$var$stringTag = "[object String]", $c97d69106c053ef1$var$symbolTag = "[object Symbol]";
var $c97d69106c053ef1$var$arrayBufferTag = "[object ArrayBuffer]", $c97d69106c053ef1$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $c97d69106c053ef1$var$symbolProto = $9d0c04c90015b763$exports ? $9d0c04c90015b763$exports.prototype : undefined, $c97d69106c053ef1$var$symbolValueOf = $c97d69106c053ef1$var$symbolProto ? $c97d69106c053ef1$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c97d69106c053ef1$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $c97d69106c053ef1$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $c97d69106c053ef1$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $ec42fa0f6330fd05$exports(object), new $ec42fa0f6330fd05$exports(other))) return false;
            return true;
        case $c97d69106c053ef1$var$boolTag:
        case $c97d69106c053ef1$var$dateTag:
        case $c97d69106c053ef1$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $61269e018e176ece$exports(+object, +other);
        case $c97d69106c053ef1$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $c97d69106c053ef1$var$regexpTag:
        case $c97d69106c053ef1$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $c97d69106c053ef1$var$mapTag:
            var convert = $a775bf75cfb65dce$exports;
        case $c97d69106c053ef1$var$setTag:
            var isPartial = bitmask & $c97d69106c053ef1$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $b008243b8e4f334f$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $c97d69106c053ef1$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $e25638b1a2449235$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $c97d69106c053ef1$var$symbolTag:
            if ($c97d69106c053ef1$var$symbolValueOf) return $c97d69106c053ef1$var$symbolValueOf.call(object) == $c97d69106c053ef1$var$symbolValueOf.call(other);
    }
    return false;
}
$c97d69106c053ef1$exports = $c97d69106c053ef1$var$equalByTag;


var $83c0fc3742bcef01$exports = {};
var $0634b6925af17a7e$exports = {};
var $baa194745e64b3ec$exports = {};
var $00bd5c86843bc067$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $00bd5c86843bc067$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$00bd5c86843bc067$exports = $00bd5c86843bc067$var$arrayPush;


var $84ca1aa52314c546$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $84ca1aa52314c546$var$isArray = Array.isArray;
$84ca1aa52314c546$exports = $84ca1aa52314c546$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $baa194745e64b3ec$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $84ca1aa52314c546$exports(object) ? result : $00bd5c86843bc067$exports(result, symbolsFunc(object));
}
$baa194745e64b3ec$exports = $baa194745e64b3ec$var$baseGetAllKeys;


var $94d27305b351432d$exports = {};
var $e4aa8d6a236ef822$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e4aa8d6a236ef822$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$e4aa8d6a236ef822$exports = $e4aa8d6a236ef822$var$arrayFilter;


var $8f3eb5c777ee6395$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8f3eb5c777ee6395$var$stubArray() {
    return [];
}
$8f3eb5c777ee6395$exports = $8f3eb5c777ee6395$var$stubArray;


/** Used for built-in method references. */ var $94d27305b351432d$var$objectProto = Object.prototype;
/** Built-in value references. */ var $94d27305b351432d$var$propertyIsEnumerable = $94d27305b351432d$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $94d27305b351432d$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $94d27305b351432d$var$getSymbols = !$94d27305b351432d$var$nativeGetSymbols ? $8f3eb5c777ee6395$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $e4aa8d6a236ef822$exports($94d27305b351432d$var$nativeGetSymbols(object), function(symbol) {
        return $94d27305b351432d$var$propertyIsEnumerable.call(object, symbol);
    });
};
$94d27305b351432d$exports = $94d27305b351432d$var$getSymbols;


var $0ec295ae69d8df95$exports = {};
var $6f9c8e57dab70b0e$exports = {};
var $682f363e113c14c1$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $682f363e113c14c1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$682f363e113c14c1$exports = $682f363e113c14c1$var$baseTimes;


var $f343e8c27e3a88b9$exports = {};
var $63e3eabb6e5c144b$exports = {};

var $c7f0e95f7b8234dc$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c7f0e95f7b8234dc$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$c7f0e95f7b8234dc$exports = $c7f0e95f7b8234dc$var$isObjectLike;


/** `Object#toString` result references. */ var $63e3eabb6e5c144b$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $63e3eabb6e5c144b$var$baseIsArguments(value) {
    return $c7f0e95f7b8234dc$exports(value) && $381d490267e538c0$exports(value) == $63e3eabb6e5c144b$var$argsTag;
}
$63e3eabb6e5c144b$exports = $63e3eabb6e5c144b$var$baseIsArguments;



/** Used for built-in method references. */ var $f343e8c27e3a88b9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f343e8c27e3a88b9$var$hasOwnProperty = $f343e8c27e3a88b9$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $f343e8c27e3a88b9$var$propertyIsEnumerable = $f343e8c27e3a88b9$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $f343e8c27e3a88b9$var$isArguments = $63e3eabb6e5c144b$exports(function() {
    return arguments;
}()) ? $63e3eabb6e5c144b$exports : function(value) {
    return $c7f0e95f7b8234dc$exports(value) && $f343e8c27e3a88b9$var$hasOwnProperty.call(value, "callee") && !$f343e8c27e3a88b9$var$propertyIsEnumerable.call(value, "callee");
};
$f343e8c27e3a88b9$exports = $f343e8c27e3a88b9$var$isArguments;




var $60Olm = parcelRequire("60Olm");
var $6c1a7e10c83cdbae$exports = {};
/** Used as references for various `Number` constants. */ var $6c1a7e10c83cdbae$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $6c1a7e10c83cdbae$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $6c1a7e10c83cdbae$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $6c1a7e10c83cdbae$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $6c1a7e10c83cdbae$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$6c1a7e10c83cdbae$exports = $6c1a7e10c83cdbae$var$isIndex;


var $4ab3c58c2599966f$exports = {};
var $30618812f046199e$exports = {};

var $ea064dca462d501a$exports = {};
/** Used as references for various `Number` constants. */ var $ea064dca462d501a$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ea064dca462d501a$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $ea064dca462d501a$var$MAX_SAFE_INTEGER;
}
$ea064dca462d501a$exports = $ea064dca462d501a$var$isLength;



/** `Object#toString` result references. */ var $30618812f046199e$var$argsTag = "[object Arguments]", $30618812f046199e$var$arrayTag = "[object Array]", $30618812f046199e$var$boolTag = "[object Boolean]", $30618812f046199e$var$dateTag = "[object Date]", $30618812f046199e$var$errorTag = "[object Error]", $30618812f046199e$var$funcTag = "[object Function]", $30618812f046199e$var$mapTag = "[object Map]", $30618812f046199e$var$numberTag = "[object Number]", $30618812f046199e$var$objectTag = "[object Object]", $30618812f046199e$var$regexpTag = "[object RegExp]", $30618812f046199e$var$setTag = "[object Set]", $30618812f046199e$var$stringTag = "[object String]", $30618812f046199e$var$weakMapTag = "[object WeakMap]";
var $30618812f046199e$var$arrayBufferTag = "[object ArrayBuffer]", $30618812f046199e$var$dataViewTag = "[object DataView]", $30618812f046199e$var$float32Tag = "[object Float32Array]", $30618812f046199e$var$float64Tag = "[object Float64Array]", $30618812f046199e$var$int8Tag = "[object Int8Array]", $30618812f046199e$var$int16Tag = "[object Int16Array]", $30618812f046199e$var$int32Tag = "[object Int32Array]", $30618812f046199e$var$uint8Tag = "[object Uint8Array]", $30618812f046199e$var$uint8ClampedTag = "[object Uint8ClampedArray]", $30618812f046199e$var$uint16Tag = "[object Uint16Array]", $30618812f046199e$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $30618812f046199e$var$typedArrayTags = {};
$30618812f046199e$var$typedArrayTags[$30618812f046199e$var$float32Tag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$float64Tag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$int8Tag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$int16Tag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$int32Tag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$uint8Tag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$uint8ClampedTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$uint16Tag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$uint32Tag] = true;
$30618812f046199e$var$typedArrayTags[$30618812f046199e$var$argsTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$arrayTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$arrayBufferTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$boolTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$dataViewTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$dateTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$errorTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$funcTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$mapTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$numberTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$objectTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$regexpTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$setTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$stringTag] = $30618812f046199e$var$typedArrayTags[$30618812f046199e$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $30618812f046199e$var$baseIsTypedArray(value) {
    return $c7f0e95f7b8234dc$exports(value) && $ea064dca462d501a$exports(value.length) && !!$30618812f046199e$var$typedArrayTags[$381d490267e538c0$exports(value)];
}
$30618812f046199e$exports = $30618812f046199e$var$baseIsTypedArray;


var $a82eeedc6911bee7$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a82eeedc6911bee7$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$a82eeedc6911bee7$exports = $a82eeedc6911bee7$var$baseUnary;



var $5ETmX = parcelRequire("5ETmX");
/* Node.js helper references. */ var $4ab3c58c2599966f$var$nodeIsTypedArray = $5ETmX && $5ETmX.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $4ab3c58c2599966f$var$isTypedArray = $4ab3c58c2599966f$var$nodeIsTypedArray ? $a82eeedc6911bee7$exports($4ab3c58c2599966f$var$nodeIsTypedArray) : $30618812f046199e$exports;
$4ab3c58c2599966f$exports = $4ab3c58c2599966f$var$isTypedArray;


/** Used for built-in method references. */ var $6f9c8e57dab70b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6f9c8e57dab70b0e$var$hasOwnProperty = $6f9c8e57dab70b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $6f9c8e57dab70b0e$var$arrayLikeKeys(value, inherited) {
    var isArr = $84ca1aa52314c546$exports(value), isArg = !isArr && $f343e8c27e3a88b9$exports(value), isBuff = !isArr && !isArg && $60Olm(value), isType = !isArr && !isArg && !isBuff && $4ab3c58c2599966f$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $682f363e113c14c1$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $6f9c8e57dab70b0e$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $6c1a7e10c83cdbae$exports(key, length)))) result.push(key);
    return result;
}
$6f9c8e57dab70b0e$exports = $6f9c8e57dab70b0e$var$arrayLikeKeys;


var $51978c658e646c89$exports = {};
var $ee0dfa17f2108157$exports = {};
/** Used for built-in method references. */ var $ee0dfa17f2108157$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $ee0dfa17f2108157$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $ee0dfa17f2108157$var$objectProto;
    return value === proto;
}
$ee0dfa17f2108157$exports = $ee0dfa17f2108157$var$isPrototype;


var $4736bdebbca4029e$exports = {};
var $aa4fc3d1fdb35009$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $aa4fc3d1fdb35009$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$aa4fc3d1fdb35009$exports = $aa4fc3d1fdb35009$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $4736bdebbca4029e$var$nativeKeys = $aa4fc3d1fdb35009$exports(Object.keys, Object);
$4736bdebbca4029e$exports = $4736bdebbca4029e$var$nativeKeys;


/** Used for built-in method references. */ var $51978c658e646c89$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $51978c658e646c89$var$hasOwnProperty = $51978c658e646c89$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $51978c658e646c89$var$baseKeys(object) {
    if (!$ee0dfa17f2108157$exports(object)) return $4736bdebbca4029e$exports(object);
    var result = [];
    for(var key in Object(object))if ($51978c658e646c89$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$51978c658e646c89$exports = $51978c658e646c89$var$baseKeys;


var $842d4a0d91f878c6$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $842d4a0d91f878c6$var$isArrayLike(value) {
    return value != null && $ea064dca462d501a$exports(value.length) && !$b12409ad867c77f5$exports(value);
}
$842d4a0d91f878c6$exports = $842d4a0d91f878c6$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0ec295ae69d8df95$var$keys(object) {
    return $842d4a0d91f878c6$exports(object) ? $6f9c8e57dab70b0e$exports(object) : $51978c658e646c89$exports(object);
}
$0ec295ae69d8df95$exports = $0ec295ae69d8df95$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0634b6925af17a7e$var$getAllKeys(object) {
    return $baa194745e64b3ec$exports(object, $0ec295ae69d8df95$exports, $94d27305b351432d$exports);
}
$0634b6925af17a7e$exports = $0634b6925af17a7e$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $83c0fc3742bcef01$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $83c0fc3742bcef01$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $83c0fc3742bcef01$var$hasOwnProperty = $83c0fc3742bcef01$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $83c0fc3742bcef01$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $83c0fc3742bcef01$var$COMPARE_PARTIAL_FLAG, objProps = $0634b6925af17a7e$exports(object), objLength = objProps.length, othProps = $0634b6925af17a7e$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $83c0fc3742bcef01$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$83c0fc3742bcef01$exports = $83c0fc3742bcef01$var$equalObjects;


var $2319df611fcc133c$exports = {};
var $922c09a837ad4b66$exports = {};


var $50pTR = parcelRequire("50pTR");
/* Built-in method references that are verified to be native. */ var $922c09a837ad4b66$var$DataView = $160af1b543b551be$exports($50pTR, "DataView");
$922c09a837ad4b66$exports = $922c09a837ad4b66$var$DataView;



var $ada86ae87b59cee3$exports = {};


var $50pTR = parcelRequire("50pTR");
/* Built-in method references that are verified to be native. */ var $ada86ae87b59cee3$var$Promise = $160af1b543b551be$exports($50pTR, "Promise");
$ada86ae87b59cee3$exports = $ada86ae87b59cee3$var$Promise;


var $819715fdb7557b14$exports = {};


var $50pTR = parcelRequire("50pTR");
/* Built-in method references that are verified to be native. */ var $819715fdb7557b14$var$Set = $160af1b543b551be$exports($50pTR, "Set");
$819715fdb7557b14$exports = $819715fdb7557b14$var$Set;


var $131488eb34baecbf$exports = {};


var $50pTR = parcelRequire("50pTR");
/* Built-in method references that are verified to be native. */ var $131488eb34baecbf$var$WeakMap = $160af1b543b551be$exports($50pTR, "WeakMap");
$131488eb34baecbf$exports = $131488eb34baecbf$var$WeakMap;




/** `Object#toString` result references. */ var $2319df611fcc133c$var$mapTag = "[object Map]", $2319df611fcc133c$var$objectTag = "[object Object]", $2319df611fcc133c$var$promiseTag = "[object Promise]", $2319df611fcc133c$var$setTag = "[object Set]", $2319df611fcc133c$var$weakMapTag = "[object WeakMap]";
var $2319df611fcc133c$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $2319df611fcc133c$var$dataViewCtorString = $485043477d4e3478$exports($922c09a837ad4b66$exports), $2319df611fcc133c$var$mapCtorString = $485043477d4e3478$exports($b40deed3a00fd518$exports), $2319df611fcc133c$var$promiseCtorString = $485043477d4e3478$exports($ada86ae87b59cee3$exports), $2319df611fcc133c$var$setCtorString = $485043477d4e3478$exports($819715fdb7557b14$exports), $2319df611fcc133c$var$weakMapCtorString = $485043477d4e3478$exports($131488eb34baecbf$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $2319df611fcc133c$var$getTag = $381d490267e538c0$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($922c09a837ad4b66$exports && $2319df611fcc133c$var$getTag(new $922c09a837ad4b66$exports(new ArrayBuffer(1))) != $2319df611fcc133c$var$dataViewTag || $b40deed3a00fd518$exports && $2319df611fcc133c$var$getTag(new $b40deed3a00fd518$exports) != $2319df611fcc133c$var$mapTag || $ada86ae87b59cee3$exports && $2319df611fcc133c$var$getTag($ada86ae87b59cee3$exports.resolve()) != $2319df611fcc133c$var$promiseTag || $819715fdb7557b14$exports && $2319df611fcc133c$var$getTag(new $819715fdb7557b14$exports) != $2319df611fcc133c$var$setTag || $131488eb34baecbf$exports && $2319df611fcc133c$var$getTag(new $131488eb34baecbf$exports) != $2319df611fcc133c$var$weakMapTag) $2319df611fcc133c$var$getTag = function(value) {
    var result = $381d490267e538c0$exports(value), Ctor = result == $2319df611fcc133c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $485043477d4e3478$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $2319df611fcc133c$var$dataViewCtorString:
            return $2319df611fcc133c$var$dataViewTag;
        case $2319df611fcc133c$var$mapCtorString:
            return $2319df611fcc133c$var$mapTag;
        case $2319df611fcc133c$var$promiseCtorString:
            return $2319df611fcc133c$var$promiseTag;
        case $2319df611fcc133c$var$setCtorString:
            return $2319df611fcc133c$var$setTag;
        case $2319df611fcc133c$var$weakMapCtorString:
            return $2319df611fcc133c$var$weakMapTag;
    }
    return result;
};
$2319df611fcc133c$exports = $2319df611fcc133c$var$getTag;




var $60Olm = parcelRequire("60Olm");

/** Used to compose bitmasks for value comparisons. */ var $5d51063ee4436072$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $5d51063ee4436072$var$argsTag = "[object Arguments]", $5d51063ee4436072$var$arrayTag = "[object Array]", $5d51063ee4436072$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $5d51063ee4436072$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5d51063ee4436072$var$hasOwnProperty = $5d51063ee4436072$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5d51063ee4436072$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $84ca1aa52314c546$exports(object), othIsArr = $84ca1aa52314c546$exports(other), objTag = objIsArr ? $5d51063ee4436072$var$arrayTag : $2319df611fcc133c$exports(object), othTag = othIsArr ? $5d51063ee4436072$var$arrayTag : $2319df611fcc133c$exports(other);
    objTag = objTag == $5d51063ee4436072$var$argsTag ? $5d51063ee4436072$var$objectTag : objTag;
    othTag = othTag == $5d51063ee4436072$var$argsTag ? $5d51063ee4436072$var$objectTag : othTag;
    var objIsObj = objTag == $5d51063ee4436072$var$objectTag, othIsObj = othTag == $5d51063ee4436072$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $60Olm(object)) {
        if (!$60Olm(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $cfaad5b9e6cb1fdd$exports);
        return objIsArr || $4ab3c58c2599966f$exports(object) ? $e25638b1a2449235$exports(object, other, bitmask, customizer, equalFunc, stack) : $c97d69106c053ef1$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $5d51063ee4436072$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $5d51063ee4436072$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $5d51063ee4436072$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $cfaad5b9e6cb1fdd$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $cfaad5b9e6cb1fdd$exports);
    return $83c0fc3742bcef01$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$5d51063ee4436072$exports = $5d51063ee4436072$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $e50842fe59193160$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$c7f0e95f7b8234dc$exports(value) && !$c7f0e95f7b8234dc$exports(other)) return value !== value && other !== other;
    return $5d51063ee4436072$exports(value, other, bitmask, customizer, $e50842fe59193160$var$baseIsEqual, stack);
}
$e50842fe59193160$exports = $e50842fe59193160$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $2040da940dbce26f$var$COMPARE_PARTIAL_FLAG = 1, $2040da940dbce26f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $2040da940dbce26f$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $cfaad5b9e6cb1fdd$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $e50842fe59193160$exports(srcValue, objValue, $2040da940dbce26f$var$COMPARE_PARTIAL_FLAG | $2040da940dbce26f$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$2040da940dbce26f$exports = $2040da940dbce26f$var$baseIsMatch;


var $d405d7f50123ddf0$exports = {};
var $c72fca38267751b3$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $c72fca38267751b3$var$isStrictComparable(value) {
    return value === value && !$1e60876e846aca7c$exports(value);
}
$c72fca38267751b3$exports = $c72fca38267751b3$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $d405d7f50123ddf0$var$getMatchData(object) {
    var result = $0ec295ae69d8df95$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $c72fca38267751b3$exports(value)
        ];
    }
    return result;
}
$d405d7f50123ddf0$exports = $d405d7f50123ddf0$var$getMatchData;


var $68116c9b3910aada$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $68116c9b3910aada$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$68116c9b3910aada$exports = $68116c9b3910aada$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $3efe34f6c7e23d8a$var$baseMatches(source) {
    var matchData = $d405d7f50123ddf0$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $68116c9b3910aada$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2040da940dbce26f$exports(object, source, matchData);
    };
}
$3efe34f6c7e23d8a$exports = $3efe34f6c7e23d8a$var$baseMatches;


var $5b2d70d211127829$exports = {};

var $e98d756dd2f93ef0$exports = {};
var $b202afe34a2964fd$exports = {};
var $83ba8ab5916dd116$exports = {};

var $6c6f3da46c098d31$exports = {};

var $e7b08efe289d0f2f$exports = {};


/** `Object#toString` result references. */ var $e7b08efe289d0f2f$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e7b08efe289d0f2f$var$isSymbol(value) {
    return typeof value == "symbol" || $c7f0e95f7b8234dc$exports(value) && $381d490267e538c0$exports(value) == $e7b08efe289d0f2f$var$symbolTag;
}
$e7b08efe289d0f2f$exports = $e7b08efe289d0f2f$var$isSymbol;


/** Used to match property names within property paths. */ var $6c6f3da46c098d31$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6c6f3da46c098d31$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6c6f3da46c098d31$var$isKey(value, object) {
    if ($84ca1aa52314c546$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $e7b08efe289d0f2f$exports(value)) return true;
    return $6c6f3da46c098d31$var$reIsPlainProp.test(value) || !$6c6f3da46c098d31$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$6c6f3da46c098d31$exports = $6c6f3da46c098d31$var$isKey;


var $752a340fae0e67da$exports = {};
var $8f04057a7f548eaa$exports = {};
var $6a39f1b45a4a019f$exports = {};

/** Error message constants. */ var $6a39f1b45a4a019f$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $6a39f1b45a4a019f$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($6a39f1b45a4a019f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($6a39f1b45a4a019f$var$memoize.Cache || $5c4332b2a41d3880$exports);
    return memoized;
}
// Expose `MapCache`.
$6a39f1b45a4a019f$var$memoize.Cache = $5c4332b2a41d3880$exports;
$6a39f1b45a4a019f$exports = $6a39f1b45a4a019f$var$memoize;


/** Used as the maximum memoize cache size. */ var $8f04057a7f548eaa$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $8f04057a7f548eaa$var$memoizeCapped(func) {
    var result = $6a39f1b45a4a019f$exports(func, function(key) {
        if (cache.size === $8f04057a7f548eaa$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$8f04057a7f548eaa$exports = $8f04057a7f548eaa$var$memoizeCapped;


/** Used to match property names within property paths. */ var $752a340fae0e67da$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $752a340fae0e67da$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $752a340fae0e67da$var$stringToPath = $8f04057a7f548eaa$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($752a340fae0e67da$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($752a340fae0e67da$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$752a340fae0e67da$exports = $752a340fae0e67da$var$stringToPath;


var $8faa576c1e28d275$exports = {};
var $fe61ad35ed6d4671$exports = {};

var $0be0047497ddc620$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $0be0047497ddc620$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$0be0047497ddc620$exports = $0be0047497ddc620$var$arrayMap;




/** Used as references for various `Number` constants. */ var $fe61ad35ed6d4671$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $fe61ad35ed6d4671$var$symbolProto = $9d0c04c90015b763$exports ? $9d0c04c90015b763$exports.prototype : undefined, $fe61ad35ed6d4671$var$symbolToString = $fe61ad35ed6d4671$var$symbolProto ? $fe61ad35ed6d4671$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $fe61ad35ed6d4671$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($84ca1aa52314c546$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $0be0047497ddc620$exports(value, $fe61ad35ed6d4671$var$baseToString) + "";
    if ($e7b08efe289d0f2f$exports(value)) return $fe61ad35ed6d4671$var$symbolToString ? $fe61ad35ed6d4671$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$fe61ad35ed6d4671$var$INFINITY ? "-0" : result;
}
$fe61ad35ed6d4671$exports = $fe61ad35ed6d4671$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $8faa576c1e28d275$var$toString(value) {
    return value == null ? "" : $fe61ad35ed6d4671$exports(value);
}
$8faa576c1e28d275$exports = $8faa576c1e28d275$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $83ba8ab5916dd116$var$castPath(value, object) {
    if ($84ca1aa52314c546$exports(value)) return value;
    return $6c6f3da46c098d31$exports(value, object) ? [
        value
    ] : $752a340fae0e67da$exports($8faa576c1e28d275$exports(value));
}
$83ba8ab5916dd116$exports = $83ba8ab5916dd116$var$castPath;


var $d1d1cc3384710807$exports = {};

/** Used as references for various `Number` constants. */ var $d1d1cc3384710807$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $d1d1cc3384710807$var$toKey(value) {
    if (typeof value == "string" || $e7b08efe289d0f2f$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$d1d1cc3384710807$var$INFINITY ? "-0" : result;
}
$d1d1cc3384710807$exports = $d1d1cc3384710807$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $b202afe34a2964fd$var$baseGet(object, path) {
    path = $83ba8ab5916dd116$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$d1d1cc3384710807$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$b202afe34a2964fd$exports = $b202afe34a2964fd$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $e98d756dd2f93ef0$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $b202afe34a2964fd$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$e98d756dd2f93ef0$exports = $e98d756dd2f93ef0$var$get;


var $6f6a1b2790fc6592$exports = {};
var $61d8de809ba022d4$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $61d8de809ba022d4$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$61d8de809ba022d4$exports = $61d8de809ba022d4$var$baseHasIn;


var $33444c5fd7e1a093$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $33444c5fd7e1a093$var$hasPath(object, path, hasFunc) {
    path = $83ba8ab5916dd116$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $d1d1cc3384710807$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $ea064dca462d501a$exports(length) && $6c1a7e10c83cdbae$exports(key, length) && ($84ca1aa52314c546$exports(object) || $f343e8c27e3a88b9$exports(object));
}
$33444c5fd7e1a093$exports = $33444c5fd7e1a093$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $6f6a1b2790fc6592$var$hasIn(object, path) {
    return object != null && $33444c5fd7e1a093$exports(object, path, $61d8de809ba022d4$exports);
}
$6f6a1b2790fc6592$exports = $6f6a1b2790fc6592$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $5b2d70d211127829$var$COMPARE_PARTIAL_FLAG = 1, $5b2d70d211127829$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $5b2d70d211127829$var$baseMatchesProperty(path, srcValue) {
    if ($6c6f3da46c098d31$exports(path) && $c72fca38267751b3$exports(srcValue)) return $68116c9b3910aada$exports($d1d1cc3384710807$exports(path), srcValue);
    return function(object) {
        var objValue = $e98d756dd2f93ef0$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $6f6a1b2790fc6592$exports(object, path) : $e50842fe59193160$exports(srcValue, objValue, $5b2d70d211127829$var$COMPARE_PARTIAL_FLAG | $5b2d70d211127829$var$COMPARE_UNORDERED_FLAG);
    };
}
$5b2d70d211127829$exports = $5b2d70d211127829$var$baseMatchesProperty;


var $8b6dcd74cc369ffa$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $8b6dcd74cc369ffa$var$identity(value) {
    return value;
}
$8b6dcd74cc369ffa$exports = $8b6dcd74cc369ffa$var$identity;



var $2a2cb82e5650120d$exports = {};
var $1eb3d958d7ce3791$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $1eb3d958d7ce3791$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$1eb3d958d7ce3791$exports = $1eb3d958d7ce3791$var$baseProperty;


var $59a6a34d215c01f1$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $59a6a34d215c01f1$var$basePropertyDeep(path) {
    return function(object) {
        return $b202afe34a2964fd$exports(object, path);
    };
}
$59a6a34d215c01f1$exports = $59a6a34d215c01f1$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $2a2cb82e5650120d$var$property(path) {
    return $6c6f3da46c098d31$exports(path) ? $1eb3d958d7ce3791$exports($d1d1cc3384710807$exports(path)) : $59a6a34d215c01f1$exports(path);
}
$2a2cb82e5650120d$exports = $2a2cb82e5650120d$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $52c7c35fde7b0b7d$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $8b6dcd74cc369ffa$exports;
    if (typeof value == "object") return $84ca1aa52314c546$exports(value) ? $5b2d70d211127829$exports(value[0], value[1]) : $3efe34f6c7e23d8a$exports(value);
    return $2a2cb82e5650120d$exports(value);
}
$52c7c35fde7b0b7d$exports = $52c7c35fde7b0b7d$var$baseIteratee;


var $448c3a28585ff7e2$exports = {};

var $7b1a4e83a3a1dbde$exports = {};
var $1a0d9a80a9cddfc2$exports = {};
var $517bb4d11a6e6516$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $517bb4d11a6e6516$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$517bb4d11a6e6516$exports = $517bb4d11a6e6516$var$baseFindIndex;


var $3f8204c033bbb020$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3f8204c033bbb020$var$baseIsNaN(value) {
    return value !== value;
}
$3f8204c033bbb020$exports = $3f8204c033bbb020$var$baseIsNaN;


var $57e3c4cb7e168e40$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $57e3c4cb7e168e40$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$57e3c4cb7e168e40$exports = $57e3c4cb7e168e40$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $1a0d9a80a9cddfc2$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $57e3c4cb7e168e40$exports(array, value, fromIndex) : $517bb4d11a6e6516$exports(array, $3f8204c033bbb020$exports, fromIndex);
}
$1a0d9a80a9cddfc2$exports = $1a0d9a80a9cddfc2$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $7b1a4e83a3a1dbde$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $1a0d9a80a9cddfc2$exports(array, value, 0) > -1;
}
$7b1a4e83a3a1dbde$exports = $7b1a4e83a3a1dbde$var$arrayIncludes;


var $0d5d19d9ba4f18f2$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $0d5d19d9ba4f18f2$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$0d5d19d9ba4f18f2$exports = $0d5d19d9ba4f18f2$var$arrayIncludesWith;



var $768fdbb1f23bc52c$exports = {};

var $113f61c8c8daa21a$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $113f61c8c8daa21a$var$noop() {
// No operation performed.
}
$113f61c8c8daa21a$exports = $113f61c8c8daa21a$var$noop;



/** Used as references for various `Number` constants. */ var $768fdbb1f23bc52c$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $768fdbb1f23bc52c$var$createSet = !($819715fdb7557b14$exports && 1 / $b008243b8e4f334f$exports(new $819715fdb7557b14$exports([
    ,
    -0
]))[1] == $768fdbb1f23bc52c$var$INFINITY) ? $113f61c8c8daa21a$exports : function(values) {
    return new $819715fdb7557b14$exports(values);
};
$768fdbb1f23bc52c$exports = $768fdbb1f23bc52c$var$createSet;



/** Used as the size to enable large array optimizations. */ var $448c3a28585ff7e2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $448c3a28585ff7e2$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7b1a4e83a3a1dbde$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $0d5d19d9ba4f18f2$exports;
    } else if (length >= $448c3a28585ff7e2$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $768fdbb1f23bc52c$exports(array);
        if (set) return $b008243b8e4f334f$exports(set);
        isCommon = false;
        includes = $ef45acb6e03538bb$exports;
        seen = new $20c8e479cb651aa7$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$448c3a28585ff7e2$exports = $448c3a28585ff7e2$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $78a3e0804befecf2$var$uniqBy(array, iteratee) {
    return array && array.length ? $448c3a28585ff7e2$exports(array, $52c7c35fde7b0b7d$exports(iteratee, 2)) : [];
}
$78a3e0804befecf2$exports = $78a3e0804befecf2$var$uniqBy;



var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
var $f736a71bb7ffc367$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $f736a71bb7ffc367$exports) {
        classNames.default = classNames;
        $f736a71bb7ffc367$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $lDSNw = parcelRequire("lDSNw");



var $5616f51c0f760501$exports = {};



/** `Object#toString` result references. */ var $5616f51c0f760501$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $5616f51c0f760501$var$isString(value) {
    return typeof value == "string" || !$84ca1aa52314c546$exports(value) && $c7f0e95f7b8234dc$exports(value) && $381d490267e538c0$exports(value) == $5616f51c0f760501$var$stringTag;
}
$5616f51c0f760501$exports = $5616f51c0f760501$var$isString;



var $0a099db9feea9f1c$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $0a099db9feea9f1c$var$isNil(value) {
    return value == null;
}
$0a099db9feea9f1c$exports = $0a099db9feea9f1c$var$isNil;




var $lDSNw = parcelRequire("lDSNw");



var $ebdb18b484d894aa$exports = {};
var $a42ee6807e0c4cc2$exports = {};


/** `Object#toString` result references. */ var $a42ee6807e0c4cc2$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $a42ee6807e0c4cc2$var$isNumber(value) {
    return typeof value == "number" || $c7f0e95f7b8234dc$exports(value) && $381d490267e538c0$exports(value) == $a42ee6807e0c4cc2$var$numberTag;
}
$a42ee6807e0c4cc2$exports = $a42ee6807e0c4cc2$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $ebdb18b484d894aa$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $a42ee6807e0c4cc2$exports(value) && value != +value;
}
$ebdb18b484d894aa$exports = $ebdb18b484d894aa$var$isNaN;




var $aee02c7eefa94d8b$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $aee02c7eefa94d8b$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5616f51c0f760501$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $aee02c7eefa94d8b$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a42ee6807e0c4cc2$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($ebdb18b484d894aa$exports)))(value);
};
var $aee02c7eefa94d8b$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $aee02c7eefa94d8b$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($5616f51c0f760501$exports)))(value);
};
var $aee02c7eefa94d8b$var$idCounter = 0;
var $aee02c7eefa94d8b$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$aee02c7eefa94d8b$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $aee02c7eefa94d8b$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$aee02c7eefa94d8b$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($5616f51c0f760501$exports)))(percent)) return defaultValue;
    var value;
    if ($aee02c7eefa94d8b$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ebdb18b484d894aa$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $aee02c7eefa94d8b$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $aee02c7eefa94d8b$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $aee02c7eefa94d8b$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($aee02c7eefa94d8b$export$7e4aa119212bc614(numberA) && $aee02c7eefa94d8b$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $aee02c7eefa94d8b$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $aee02c7eefa94d8b$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $85fb59aede47d0be$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}




var $lDSNw = parcelRequire("lDSNw");
function $f50c94b715022fe9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f50c94b715022fe9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f50c94b715022fe9$var$_typeof(obj);
}
//
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $f50c94b715022fe9$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $f50c94b715022fe9$export$190f430946f96110 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $f50c94b715022fe9$var$PolyElementKeys = [
    "points",
    "pathLength"
];
var $f50c94b715022fe9$export$2b22758266a6fa48 = {
    svg: $f50c94b715022fe9$var$SVGContainerPropKeys,
    polygon: $f50c94b715022fe9$var$PolyElementKeys,
    polyline: $f50c94b715022fe9$var$PolyElementKeys
};
var $f50c94b715022fe9$export$f30789245f2c4d11 = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var $f50c94b715022fe9$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $lDSNw.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1e60876e846aca7c$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($f50c94b715022fe9$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $f50c94b715022fe9$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $f50c94b715022fe9$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1e60876e846aca7c$exports)))(props) || $f50c94b715022fe9$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($f50c94b715022fe9$export$f30789245f2c4d11.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $f50c94b715022fe9$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $65af1a52cac4dd09$var$_excluded = [
    "children"
], $65af1a52cac4dd09$var$_excluded2 = [
    "children"
];
function $65af1a52cac4dd09$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $65af1a52cac4dd09$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $65af1a52cac4dd09$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $65af1a52cac4dd09$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $65af1a52cac4dd09$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $65af1a52cac4dd09$var$_typeof(obj);
}
var $65af1a52cac4dd09$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var $65af1a52cac4dd09$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $65af1a52cac4dd09$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $65af1a52cac4dd09$export$59a4d7d024cf1025 = [
    "none"
];
var $65af1a52cac4dd09$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $65af1a52cac4dd09$var$lastChildren = null;
var $65af1a52cac4dd09$var$lastResult = null;
var $65af1a52cac4dd09$export$45b10814cc054894 = function toArray(children) {
    if (children === $65af1a52cac4dd09$var$lastChildren && (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))($65af1a52cac4dd09$var$lastResult)) return $65af1a52cac4dd09$var$lastResult;
    var result = [];
    (0, $lDSNw.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(child)) return;
        if ((0, $23dc7c94650826f3$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $65af1a52cac4dd09$var$lastResult = result;
    $65af1a52cac4dd09$var$lastChildren = children;
    return result;
};
function $65af1a52cac4dd09$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(type)) types = type.map(function(t) {
        return $65af1a52cac4dd09$export$be63e0664592e141(t);
    });
    else types = [
        $65af1a52cac4dd09$export$be63e0664592e141(type)
    ];
    $65af1a52cac4dd09$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $65af1a52cac4dd09$export$64c61536a2b72e0f(children, type) {
    var result = $65af1a52cac4dd09$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $65af1a52cac4dd09$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(type)) types = type.map(function(t) {
        return $65af1a52cac4dd09$export$be63e0664592e141(t);
    });
    else types = [
        $65af1a52cac4dd09$export$be63e0664592e141(type)
    ];
    $65af1a52cac4dd09$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $65af1a52cac4dd09$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $65af1a52cac4dd09$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $65af1a52cac4dd09$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($5616f51c0f760501$exports)))(child.type) && $65af1a52cac4dd09$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $65af1a52cac4dd09$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $65af1a52cac4dd09$var$_typeof(dot) === "object" && "cx" in dot && "cy" in dot && "r" in dot;
};
var $65af1a52cac4dd09$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $f50c94b715022fe9$export$2b22758266a6fa48) === null || (0, $f50c94b715022fe9$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $f50c94b715022fe9$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $f50c94b715022fe9$export$190f430946f96110).includes(key)) || includeEvents && (0, $f50c94b715022fe9$export$f30789245f2c4d11).includes(key);
};
var $65af1a52cac4dd09$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $65af1a52cac4dd09$export$45b10814cc054894(children).forEach(function(entry) {
        if ($65af1a52cac4dd09$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $65af1a52cac4dd09$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $lDSNw.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1e60876e846aca7c$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($65af1a52cac4dd09$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $65af1a52cac4dd09$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $lDSNw.Children).count(nextChildren);
    if (count !== (0, $lDSNw.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $65af1a52cac4dd09$export$96bceecf65400492((0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(nextChildren) ? nextChildren[0] : nextChildren, (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(nextChild) || (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$65af1a52cac4dd09$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $65af1a52cac4dd09$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $65af1a52cac4dd09$var$_objectWithoutProperties(_ref, $65af1a52cac4dd09$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $65af1a52cac4dd09$var$_objectWithoutProperties(_ref2, $65af1a52cac4dd09$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $85fb59aede47d0be$export$d36bdfa510afb180)(nextProps, prevProps) && $65af1a52cac4dd09$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $85fb59aede47d0be$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $65af1a52cac4dd09$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $65af1a52cac4dd09$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($65af1a52cac4dd09$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $65af1a52cac4dd09$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $65af1a52cac4dd09$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $65af1a52cac4dd09$var$REACT_BROWSER_EVENT_MAP[type]) return $65af1a52cac4dd09$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $65af1a52cac4dd09$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $65af1a52cac4dd09$export$45b10814cc054894(children).indexOf(child);
};


var $09ba7bcaf26150d4$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style"
];
function $09ba7bcaf26150d4$var$_extends() {
    $09ba7bcaf26150d4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09ba7bcaf26150d4$var$_extends.apply(this, arguments);
}
function $09ba7bcaf26150d4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $09ba7bcaf26150d4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $09ba7bcaf26150d4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $09ba7bcaf26150d4$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, others = $09ba7bcaf26150d4$var$_objectWithoutProperties(props, $09ba7bcaf26150d4$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("svg", $09ba7bcaf26150d4$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("desc", null, props.desc), children);
}


var $27db65edc002de9d$exports = {};
var $1a089ac127bff949$exports = {};
var $9e45a5e81042b665$exports = {};
var $3c9007490284b0d6$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $3c9007490284b0d6$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$3c9007490284b0d6$exports = $3c9007490284b0d6$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $9e45a5e81042b665$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $3c9007490284b0d6$exports(array, start, end);
}
$9e45a5e81042b665$exports = $9e45a5e81042b665$var$castSlice;


var $5aa72154f6878381$exports = {};
/** Used to compose unicode character classes. */ var $5aa72154f6878381$var$rsAstralRange = "\ud800-\udfff", $5aa72154f6878381$var$rsComboMarksRange = "\\u0300-\\u036f", $5aa72154f6878381$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $5aa72154f6878381$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $5aa72154f6878381$var$rsComboRange = $5aa72154f6878381$var$rsComboMarksRange + $5aa72154f6878381$var$reComboHalfMarksRange + $5aa72154f6878381$var$rsComboSymbolsRange, $5aa72154f6878381$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $5aa72154f6878381$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $5aa72154f6878381$var$reHasUnicode = RegExp("[" + $5aa72154f6878381$var$rsZWJ + $5aa72154f6878381$var$rsAstralRange + $5aa72154f6878381$var$rsComboRange + $5aa72154f6878381$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $5aa72154f6878381$var$hasUnicode(string) {
    return $5aa72154f6878381$var$reHasUnicode.test(string);
}
$5aa72154f6878381$exports = $5aa72154f6878381$var$hasUnicode;


var $2cfd80197417e9c4$exports = {};
var $57cfed2f923ffdcb$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $57cfed2f923ffdcb$var$asciiToArray(string) {
    return string.split("");
}
$57cfed2f923ffdcb$exports = $57cfed2f923ffdcb$var$asciiToArray;



var $72406f5964a7f1aa$exports = {};
/** Used to compose unicode character classes. */ var $72406f5964a7f1aa$var$rsAstralRange = "\ud800-\udfff", $72406f5964a7f1aa$var$rsComboMarksRange = "\\u0300-\\u036f", $72406f5964a7f1aa$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $72406f5964a7f1aa$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $72406f5964a7f1aa$var$rsComboRange = $72406f5964a7f1aa$var$rsComboMarksRange + $72406f5964a7f1aa$var$reComboHalfMarksRange + $72406f5964a7f1aa$var$rsComboSymbolsRange, $72406f5964a7f1aa$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $72406f5964a7f1aa$var$rsAstral = "[" + $72406f5964a7f1aa$var$rsAstralRange + "]", $72406f5964a7f1aa$var$rsCombo = "[" + $72406f5964a7f1aa$var$rsComboRange + "]", $72406f5964a7f1aa$var$rsFitz = "\ud83c[\udffb-\udfff]", $72406f5964a7f1aa$var$rsModifier = "(?:" + $72406f5964a7f1aa$var$rsCombo + "|" + $72406f5964a7f1aa$var$rsFitz + ")", $72406f5964a7f1aa$var$rsNonAstral = "[^" + $72406f5964a7f1aa$var$rsAstralRange + "]", $72406f5964a7f1aa$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $72406f5964a7f1aa$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $72406f5964a7f1aa$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $72406f5964a7f1aa$var$reOptMod = $72406f5964a7f1aa$var$rsModifier + "?", $72406f5964a7f1aa$var$rsOptVar = "[" + $72406f5964a7f1aa$var$rsVarRange + "]?", $72406f5964a7f1aa$var$rsOptJoin = "(?:" + $72406f5964a7f1aa$var$rsZWJ + "(?:" + [
    $72406f5964a7f1aa$var$rsNonAstral,
    $72406f5964a7f1aa$var$rsRegional,
    $72406f5964a7f1aa$var$rsSurrPair
].join("|") + ")" + $72406f5964a7f1aa$var$rsOptVar + $72406f5964a7f1aa$var$reOptMod + ")*", $72406f5964a7f1aa$var$rsSeq = $72406f5964a7f1aa$var$rsOptVar + $72406f5964a7f1aa$var$reOptMod + $72406f5964a7f1aa$var$rsOptJoin, $72406f5964a7f1aa$var$rsSymbol = "(?:" + [
    $72406f5964a7f1aa$var$rsNonAstral + $72406f5964a7f1aa$var$rsCombo + "?",
    $72406f5964a7f1aa$var$rsCombo,
    $72406f5964a7f1aa$var$rsRegional,
    $72406f5964a7f1aa$var$rsSurrPair,
    $72406f5964a7f1aa$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $72406f5964a7f1aa$var$reUnicode = RegExp($72406f5964a7f1aa$var$rsFitz + "(?=" + $72406f5964a7f1aa$var$rsFitz + ")|" + $72406f5964a7f1aa$var$rsSymbol + $72406f5964a7f1aa$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $72406f5964a7f1aa$var$unicodeToArray(string) {
    return string.match($72406f5964a7f1aa$var$reUnicode) || [];
}
$72406f5964a7f1aa$exports = $72406f5964a7f1aa$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2cfd80197417e9c4$var$stringToArray(string) {
    return $5aa72154f6878381$exports(string) ? $72406f5964a7f1aa$exports(string) : $57cfed2f923ffdcb$exports(string);
}
$2cfd80197417e9c4$exports = $2cfd80197417e9c4$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $1a089ac127bff949$var$createCaseFirst(methodName) {
    return function(string) {
        string = $8faa576c1e28d275$exports(string);
        var strSymbols = $5aa72154f6878381$exports(string) ? $2cfd80197417e9c4$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $9e45a5e81042b665$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$1a089ac127bff949$exports = $1a089ac127bff949$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $27db65edc002de9d$var$upperFirst = $1a089ac127bff949$exports("toUpperCase");
$27db65edc002de9d$exports = $27db65edc002de9d$var$upperFirst;



var $lDSNw = parcelRequire("lDSNw");
var $c0ba789d13717a18$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$c0ba789d13717a18$exports = (parcelRequire("dSjZP"));




function $dfbea7091b7a3eec$var$_extends() {
    $dfbea7091b7a3eec$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dfbea7091b7a3eec$var$_extends.apply(this, arguments);
}
var $dfbea7091b7a3eec$var$symbolFactories = {
    symbolCircle: (0, $c0ba789d13717a18$exports.symbolCircle),
    symbolCross: (0, $c0ba789d13717a18$exports.symbolCross),
    symbolDiamond: (0, $c0ba789d13717a18$exports.symbolDiamond),
    symbolSquare: (0, $c0ba789d13717a18$exports.symbolSquare),
    symbolStar: (0, $c0ba789d13717a18$exports.symbolStar),
    symbolTriangle: (0, $c0ba789d13717a18$exports.symbolTriangle),
    symbolWye: (0, $c0ba789d13717a18$exports.symbolWye)
};
var $dfbea7091b7a3eec$var$RADIAN = Math.PI / 180;
var $dfbea7091b7a3eec$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($27db65edc002de9d$exports)))(type));
    return $dfbea7091b7a3eec$var$symbolFactories[name] || (0, $c0ba789d13717a18$exports.symbolCircle);
};
var $dfbea7091b7a3eec$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $dfbea7091b7a3eec$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $dfbea7091b7a3eec$var$symbolsDefaultProps = {
    type: "circle",
    size: 64,
    sizeType: "area"
};
var $dfbea7091b7a3eec$var$registerSymbol = function registerSymbol(key, factory) {
    $dfbea7091b7a3eec$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($27db65edc002de9d$exports)))(key))] = factory;
};
var $dfbea7091b7a3eec$export$fa456266707bf4e4 = function Symbols(props) {
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var size = props.size, sizeType = props.sizeType, type = props.type;
        var symbolFactory = $dfbea7091b7a3eec$var$getSymbolFactory(type);
        var symbol = (0, $c0ba789d13717a18$exports.symbol)().type(symbolFactory).size($dfbea7091b7a3eec$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy, size = props.size;
    var filteredProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $dfbea7091b7a3eec$var$_extends({}, filteredProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$dfbea7091b7a3eec$export$fa456266707bf4e4.defaultProps = $dfbea7091b7a3eec$var$symbolsDefaultProps;
$dfbea7091b7a3eec$export$fa456266707bf4e4.registerSymbol = $dfbea7091b7a3eec$var$registerSymbol;



function $cd05ed8bb0f9655b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cd05ed8bb0f9655b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cd05ed8bb0f9655b$var$_typeof(obj);
}
function $cd05ed8bb0f9655b$var$_extends() {
    $cd05ed8bb0f9655b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd05ed8bb0f9655b$var$_extends.apply(this, arguments);
}
function $cd05ed8bb0f9655b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cd05ed8bb0f9655b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cd05ed8bb0f9655b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cd05ed8bb0f9655b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cd05ed8bb0f9655b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cd05ed8bb0f9655b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cd05ed8bb0f9655b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cd05ed8bb0f9655b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $cd05ed8bb0f9655b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cd05ed8bb0f9655b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cd05ed8bb0f9655b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $cd05ed8bb0f9655b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $cd05ed8bb0f9655b$var$_setPrototypeOf(subClass, superClass);
}
function $cd05ed8bb0f9655b$var$_setPrototypeOf(o, p) {
    $cd05ed8bb0f9655b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cd05ed8bb0f9655b$var$_setPrototypeOf(o, p);
}
function $cd05ed8bb0f9655b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cd05ed8bb0f9655b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cd05ed8bb0f9655b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cd05ed8bb0f9655b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cd05ed8bb0f9655b$var$_possibleConstructorReturn(this, result);
    };
}
function $cd05ed8bb0f9655b$var$_possibleConstructorReturn(self, call) {
    if (call && ($cd05ed8bb0f9655b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $cd05ed8bb0f9655b$var$_assertThisInitialized(self);
}
function $cd05ed8bb0f9655b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cd05ed8bb0f9655b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cd05ed8bb0f9655b$var$_getPrototypeOf(o) {
    $cd05ed8bb0f9655b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cd05ed8bb0f9655b$var$_getPrototypeOf(o);
}
function $cd05ed8bb0f9655b$var$_defineProperty(obj, key, value) {
    key = $cd05ed8bb0f9655b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd05ed8bb0f9655b$var$_toPropertyKey(arg) {
    var key = $cd05ed8bb0f9655b$var$_toPrimitive(arg, "string");
    return $cd05ed8bb0f9655b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cd05ed8bb0f9655b$var$_toPrimitive(input, hint) {
    if ($cd05ed8bb0f9655b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cd05ed8bb0f9655b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $cd05ed8bb0f9655b$var$SIZE = 32;
var $cd05ed8bb0f9655b$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $cd05ed8bb0f9655b$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $cd05ed8bb0f9655b$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $cd05ed8bb0f9655b$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $cd05ed8bb0f9655b$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $cd05ed8bb0f9655b$var$SIZE / 2;
                var sixthSize = $cd05ed8bb0f9655b$var$SIZE / 6;
                var thirdSize = $cd05ed8bb0f9655b$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $cd05ed8bb0f9655b$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($cd05ed8bb0f9655b$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($cd05ed8bb0f9655b$var$SIZE / 8, "h").concat($cd05ed8bb0f9655b$var$SIZE, "v").concat($cd05ed8bb0f9655b$var$SIZE * 3 / 4, "h").concat(-$cd05ed8bb0f9655b$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(data.legendIcon)) {
                    var iconProps = $cd05ed8bb0f9655b$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $dfbea7091b7a3eec$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $cd05ed8bb0f9655b$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $cd05ed8bb0f9655b$var$SIZE,
                    height: $cd05ed8bb0f9655b$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _classNames;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))((_classNames = {
                        "recharts-legend-item": true
                    }, $cd05ed8bb0f9655b$var$_defineProperty(_classNames, "legend-item-".concat(i), true), $cd05ed8bb0f9655b$var$_defineProperty(_classNames, "inactive", entry.inactive), _classNames));
                    if (entry.type === "none") return null;
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("li", $cd05ed8bb0f9655b$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $09ba7bcaf26150d4$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $lDSNw.PureComponent));
$cd05ed8bb0f9655b$var$_defineProperty($cd05ed8bb0f9655b$export$99f8d96ed0cededa, "displayName", "Legend");
$cd05ed8bb0f9655b$var$_defineProperty($cd05ed8bb0f9655b$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});



function $22f8c7fa15a15fc3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $22f8c7fa15a15fc3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $22f8c7fa15a15fc3$var$_typeof(obj);
}
var $22f8c7fa15a15fc3$var$_excluded = [
    "ref"
];
function $22f8c7fa15a15fc3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $22f8c7fa15a15fc3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $22f8c7fa15a15fc3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $22f8c7fa15a15fc3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $22f8c7fa15a15fc3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $22f8c7fa15a15fc3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $22f8c7fa15a15fc3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $22f8c7fa15a15fc3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $22f8c7fa15a15fc3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $22f8c7fa15a15fc3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $22f8c7fa15a15fc3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $22f8c7fa15a15fc3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $22f8c7fa15a15fc3$var$_setPrototypeOf(subClass, superClass);
}
function $22f8c7fa15a15fc3$var$_setPrototypeOf(o, p) {
    $22f8c7fa15a15fc3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $22f8c7fa15a15fc3$var$_setPrototypeOf(o, p);
}
function $22f8c7fa15a15fc3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $22f8c7fa15a15fc3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $22f8c7fa15a15fc3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $22f8c7fa15a15fc3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $22f8c7fa15a15fc3$var$_possibleConstructorReturn(this, result);
    };
}
function $22f8c7fa15a15fc3$var$_possibleConstructorReturn(self, call) {
    if (call && ($22f8c7fa15a15fc3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $22f8c7fa15a15fc3$var$_assertThisInitialized(self);
}
function $22f8c7fa15a15fc3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $22f8c7fa15a15fc3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $22f8c7fa15a15fc3$var$_getPrototypeOf(o) {
    $22f8c7fa15a15fc3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $22f8c7fa15a15fc3$var$_getPrototypeOf(o);
}
function $22f8c7fa15a15fc3$var$_defineProperty(obj, key, value) {
    key = $22f8c7fa15a15fc3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $22f8c7fa15a15fc3$var$_toPropertyKey(arg) {
    var key = $22f8c7fa15a15fc3$var$_toPrimitive(arg, "string");
    return $22f8c7fa15a15fc3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $22f8c7fa15a15fc3$var$_toPrimitive(input, hint) {
    if ($22f8c7fa15a15fc3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($22f8c7fa15a15fc3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $22f8c7fa15a15fc3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $22f8c7fa15a15fc3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $22f8c7fa15a15fc3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $22f8c7fa15a15fc3$var$defaultUniqBy(entry) {
    return entry.value;
}
function $22f8c7fa15a15fc3$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($78a3e0804befecf2$exports)))(payload, $22f8c7fa15a15fc3$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($78a3e0804befecf2$exports)))(payload, option);
    return payload;
}
function $22f8c7fa15a15fc3$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(content, props);
    var ref = props.ref, otherProps = $22f8c7fa15a15fc3$var$_objectWithoutProperties(props, $22f8c7fa15a15fc3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cd05ed8bb0f9655b$export$99f8d96ed0cededa), otherProps);
}
var $22f8c7fa15a15fc3$var$EPS = 1;
var $22f8c7fa15a15fc3$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $22f8c7fa15a15fc3$var$_inherits(Legend, _PureComponent);
    var _super = $22f8c7fa15a15fc3$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $22f8c7fa15a15fc3$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $22f8c7fa15a15fc3$var$_defineProperty($22f8c7fa15a15fc3$var$_assertThisInitialized(_this), "state", {
            boxWidth: -1,
            boxHeight: -1
        });
        return _this;
    }
    $22f8c7fa15a15fc3$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight;
                if (boxWidth >= 0 && boxHeight >= 0) return {
                    width: boxWidth,
                    height: boxHeight
                };
                return null;
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box = this.getBBoxSnapshot() || {
                            width: 0
                        };
                        hPos = {
                            left: ((chartWidth || 0) - _box.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box2 = this.getBBoxSnapshot() || {
                            height: 0
                        };
                        vPos = {
                            top: ((chartHeight || 0) - _box2.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $22f8c7fa15a15fc3$var$_objectSpread($22f8c7fa15a15fc3$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box3 = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box3.width - boxWidth) > $22f8c7fa15a15fc3$var$EPS || Math.abs(_box3.height - boxHeight) > $22f8c7fa15a15fc3$var$EPS) this.setState({
                        boxWidth: _box3.width,
                        boxHeight: _box3.height
                    }, function() {
                        if (onBBoxUpdate) onBBoxUpdate(_box3);
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                }, function() {
                    if (onBBoxUpdate) onBBoxUpdate(null);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $22f8c7fa15a15fc3$var$_objectSpread($22f8c7fa15a15fc3$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $22f8c7fa15a15fc3$var$renderContent(content, $22f8c7fa15a15fc3$var$_objectSpread($22f8c7fa15a15fc3$var$_objectSpread({}, this.props), {}, {
                    payload: $22f8c7fa15a15fc3$var$getUniqPayload(payloadUniqBy, payload)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $lDSNw.PureComponent));
$22f8c7fa15a15fc3$var$_defineProperty($22f8c7fa15a15fc3$export$ed247974535929c7, "displayName", "Legend");
$22f8c7fa15a15fc3$var$_defineProperty($22f8c7fa15a15fc3$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});

var $accecf4f4d483c19$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $accecf4f4d483c19$var$isEqual(value, other) {
    return $e50842fe59193160$exports(value, other);
}
$accecf4f4d483c19$exports = $accecf4f4d483c19$var$isEqual;



var $b9a99be29b3e5771$exports = {};

var $964176c2d19407e3$exports = {};

/** Built-in value references. */ var $964176c2d19407e3$var$getPrototype = $aa4fc3d1fdb35009$exports(Object.getPrototypeOf, Object);
$964176c2d19407e3$exports = $964176c2d19407e3$var$getPrototype;



/** `Object#toString` result references. */ var $b9a99be29b3e5771$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $b9a99be29b3e5771$var$funcProto = Function.prototype, $b9a99be29b3e5771$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b9a99be29b3e5771$var$funcToString = $b9a99be29b3e5771$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b9a99be29b3e5771$var$hasOwnProperty = $b9a99be29b3e5771$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $b9a99be29b3e5771$var$objectCtorString = $b9a99be29b3e5771$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $b9a99be29b3e5771$var$isPlainObject(value) {
    if (!$c7f0e95f7b8234dc$exports(value) || $381d490267e538c0$exports(value) != $b9a99be29b3e5771$var$objectTag) return false;
    var proto = $964176c2d19407e3$exports(value);
    if (proto === null) return true;
    var Ctor = $b9a99be29b3e5771$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $b9a99be29b3e5771$var$funcToString.call(Ctor) == $b9a99be29b3e5771$var$objectCtorString;
}
$b9a99be29b3e5771$exports = $b9a99be29b3e5771$var$isPlainObject;





var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");

var $houiY = parcelRequire("houiY");
var $3db4016a62b667a7$exports = {};
(function(global, factory) {
    factory($3db4016a62b667a7$exports);
})($3db4016a62b667a7$exports, function(exports1) {
    "use strict";
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = "_owner";
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var REG_EXP_TAG = "[object RegExp]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== "object" || typeof b !== "object") return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $b111e92796b45e15$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else requestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $24ed0a549e304a9b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $24ed0a549e304a9b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $24ed0a549e304a9b$var$_typeof(obj);
}
function $24ed0a549e304a9b$var$_toArray(arr) {
    return $24ed0a549e304a9b$var$_arrayWithHoles(arr) || $24ed0a549e304a9b$var$_iterableToArray(arr) || $24ed0a549e304a9b$var$_unsupportedIterableToArray(arr) || $24ed0a549e304a9b$var$_nonIterableRest();
}
function $24ed0a549e304a9b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $24ed0a549e304a9b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $24ed0a549e304a9b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $24ed0a549e304a9b$var$_arrayLikeToArray(o, minLen);
}
function $24ed0a549e304a9b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $24ed0a549e304a9b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $24ed0a549e304a9b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $24ed0a549e304a9b$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $24ed0a549e304a9b$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $b111e92796b45e15$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $b111e92796b45e15$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($24ed0a549e304a9b$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $7f91566aef852dee$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7f91566aef852dee$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7f91566aef852dee$var$_typeof(obj);
}
function $7f91566aef852dee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7f91566aef852dee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7f91566aef852dee$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7f91566aef852dee$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7f91566aef852dee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7f91566aef852dee$var$_defineProperty(obj, key, value) {
    key = $7f91566aef852dee$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f91566aef852dee$var$_toPropertyKey(arg) {
    var key = $7f91566aef852dee$var$_toPrimitive(arg, "string");
    return $7f91566aef852dee$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7f91566aef852dee$var$_toPrimitive(input, hint) {
    if ($7f91566aef852dee$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7f91566aef852dee$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $7f91566aef852dee$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $7f91566aef852dee$var$IN_LINE_PREFIX_LIST = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
var $7f91566aef852dee$var$IN_COMPATIBLE_PROPERTY = [
    "transform",
    "transformOrigin",
    "transition"
];
var $7f91566aef852dee$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $7f91566aef852dee$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $7f91566aef852dee$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $7f91566aef852dee$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($7f91566aef852dee$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $7f91566aef852dee$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === "transition";
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $7f91566aef852dee$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($7f91566aef852dee$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $7f91566aef852dee$var$_objectSpread($7f91566aef852dee$var$_objectSpread({}, result), {}, $7f91566aef852dee$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $7f91566aef852dee$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $7f91566aef852dee$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $7f91566aef852dee$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $7f91566aef852dee$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $7f91566aef852dee$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $7f91566aef852dee$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $7f91566aef852dee$var$_objectSpread($7f91566aef852dee$var$_objectSpread({}, res), {}, $7f91566aef852dee$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $7f91566aef852dee$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $7f91566aef852dee$var$_objectSpread($7f91566aef852dee$var$_objectSpread({}, res), $7f91566aef852dee$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $7f91566aef852dee$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $7f91566aef852dee$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $7f91566aef852dee$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($7f91566aef852dee$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $7f91566aef852dee$var$isDev = false;
var $7f91566aef852dee$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($7f91566aef852dee$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $4699523458b42c45$var$_slicedToArray(arr, i) {
    return $4699523458b42c45$var$_arrayWithHoles(arr) || $4699523458b42c45$var$_iterableToArrayLimit(arr, i) || $4699523458b42c45$var$_unsupportedIterableToArray(arr, i) || $4699523458b42c45$var$_nonIterableRest();
}
function $4699523458b42c45$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4699523458b42c45$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $4699523458b42c45$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4699523458b42c45$var$_toConsumableArray(arr) {
    return $4699523458b42c45$var$_arrayWithoutHoles(arr) || $4699523458b42c45$var$_iterableToArray(arr) || $4699523458b42c45$var$_unsupportedIterableToArray(arr) || $4699523458b42c45$var$_nonIterableSpread();
}
function $4699523458b42c45$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4699523458b42c45$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4699523458b42c45$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4699523458b42c45$var$_arrayLikeToArray(o, minLen);
}
function $4699523458b42c45$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4699523458b42c45$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4699523458b42c45$var$_arrayLikeToArray(arr);
}
function $4699523458b42c45$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4699523458b42c45$var$ACCURACY = 1e-4;
var $4699523458b42c45$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $4699523458b42c45$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $4699523458b42c45$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $4699523458b42c45$var$cubicBezierFactor(c1, c2);
        return $4699523458b42c45$var$multyTime(params, t);
    };
};
var $4699523458b42c45$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $4699523458b42c45$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($4699523458b42c45$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $4699523458b42c45$var$multyTime(newParams, t);
    };
};
var $4699523458b42c45$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $4699523458b42c45$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $7f91566aef852dee$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $7f91566aef852dee$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $4699523458b42c45$var$cubicBezier(x1, x2);
    var curveY = $4699523458b42c45$var$cubicBezier(y1, y2);
    var derCurveX = $4699523458b42c45$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $4699523458b42c45$var$ACCURACY || derVal < $4699523458b42c45$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $4699523458b42c45$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $4699523458b42c45$var$ACCURACY && Math.abs(newV) < $4699523458b42c45$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $4699523458b42c45$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $4699523458b42c45$export$56c51296f72f0592(easing);
        case "spring":
            return $4699523458b42c45$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $4699523458b42c45$export$56c51296f72f0592(easing);
            (0, $7f91566aef852dee$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $7f91566aef852dee$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $b5aa7b0f8a958367$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b5aa7b0f8a958367$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b5aa7b0f8a958367$var$_typeof(obj);
}
function $b5aa7b0f8a958367$var$_toConsumableArray(arr) {
    return $b5aa7b0f8a958367$var$_arrayWithoutHoles(arr) || $b5aa7b0f8a958367$var$_iterableToArray(arr) || $b5aa7b0f8a958367$var$_unsupportedIterableToArray(arr) || $b5aa7b0f8a958367$var$_nonIterableSpread();
}
function $b5aa7b0f8a958367$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b5aa7b0f8a958367$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b5aa7b0f8a958367$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b5aa7b0f8a958367$var$_arrayLikeToArray(arr);
}
function $b5aa7b0f8a958367$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b5aa7b0f8a958367$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b5aa7b0f8a958367$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b5aa7b0f8a958367$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b5aa7b0f8a958367$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b5aa7b0f8a958367$var$_defineProperty(obj, key, value) {
    key = $b5aa7b0f8a958367$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5aa7b0f8a958367$var$_toPropertyKey(arg) {
    var key = $b5aa7b0f8a958367$var$_toPrimitive(arg, "string");
    return $b5aa7b0f8a958367$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b5aa7b0f8a958367$var$_toPrimitive(input, hint) {
    if ($b5aa7b0f8a958367$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b5aa7b0f8a958367$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b5aa7b0f8a958367$var$_slicedToArray(arr, i) {
    return $b5aa7b0f8a958367$var$_arrayWithHoles(arr) || $b5aa7b0f8a958367$var$_iterableToArrayLimit(arr, i) || $b5aa7b0f8a958367$var$_unsupportedIterableToArray(arr, i) || $b5aa7b0f8a958367$var$_nonIterableRest();
}
function $b5aa7b0f8a958367$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b5aa7b0f8a958367$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b5aa7b0f8a958367$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b5aa7b0f8a958367$var$_arrayLikeToArray(o, minLen);
}
function $b5aa7b0f8a958367$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b5aa7b0f8a958367$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $b5aa7b0f8a958367$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b5aa7b0f8a958367$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $b5aa7b0f8a958367$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $b5aa7b0f8a958367$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $7f91566aef852dee$export$d6051a0f7a227332)(function(key, val) {
        if ($b5aa7b0f8a958367$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $b5aa7b0f8a958367$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $7f91566aef852dee$export$d6051a0f7a227332)(function(key, val) {
        if ($b5aa7b0f8a958367$var$needContinue(val)) return $b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread({}, val), {}, {
            velocity: $b5aa7b0f8a958367$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $b5aa7b0f8a958367$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$b5aa7b0f8a958367$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $7f91566aef852dee$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread({}, res), {}, $b5aa7b0f8a958367$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread({}, res), {}, $b5aa7b0f8a958367$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $7f91566aef852dee$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($b5aa7b0f8a958367$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $b5aa7b0f8a958367$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $7f91566aef852dee$export$d6051a0f7a227332)(function(key, val) {
            return $b5aa7b0f8a958367$var$alpha.apply(void 0, $b5aa7b0f8a958367$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $7f91566aef852dee$export$d6051a0f7a227332)(function(key, val) {
                return $b5aa7b0f8a958367$var$alpha.apply(void 0, $b5aa7b0f8a958367$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread($b5aa7b0f8a958367$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $b39d0c6d9f48ac2c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b39d0c6d9f48ac2c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b39d0c6d9f48ac2c$var$_typeof(obj);
}
var $b39d0c6d9f48ac2c$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $b39d0c6d9f48ac2c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b39d0c6d9f48ac2c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b39d0c6d9f48ac2c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b39d0c6d9f48ac2c$var$_toConsumableArray(arr) {
    return $b39d0c6d9f48ac2c$var$_arrayWithoutHoles(arr) || $b39d0c6d9f48ac2c$var$_iterableToArray(arr) || $b39d0c6d9f48ac2c$var$_unsupportedIterableToArray(arr) || $b39d0c6d9f48ac2c$var$_nonIterableSpread();
}
function $b39d0c6d9f48ac2c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b39d0c6d9f48ac2c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b39d0c6d9f48ac2c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b39d0c6d9f48ac2c$var$_arrayLikeToArray(o, minLen);
}
function $b39d0c6d9f48ac2c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b39d0c6d9f48ac2c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b39d0c6d9f48ac2c$var$_arrayLikeToArray(arr);
}
function $b39d0c6d9f48ac2c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b39d0c6d9f48ac2c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b39d0c6d9f48ac2c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b39d0c6d9f48ac2c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b39d0c6d9f48ac2c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b39d0c6d9f48ac2c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b39d0c6d9f48ac2c$var$_defineProperty(obj, key, value) {
    key = $b39d0c6d9f48ac2c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b39d0c6d9f48ac2c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b39d0c6d9f48ac2c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b39d0c6d9f48ac2c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b39d0c6d9f48ac2c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b39d0c6d9f48ac2c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b39d0c6d9f48ac2c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b39d0c6d9f48ac2c$var$_toPropertyKey(arg) {
    var key = $b39d0c6d9f48ac2c$var$_toPrimitive(arg, "string");
    return $b39d0c6d9f48ac2c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b39d0c6d9f48ac2c$var$_toPrimitive(input, hint) {
    if ($b39d0c6d9f48ac2c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b39d0c6d9f48ac2c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b39d0c6d9f48ac2c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b39d0c6d9f48ac2c$var$_setPrototypeOf(subClass, superClass);
}
function $b39d0c6d9f48ac2c$var$_setPrototypeOf(o, p) {
    $b39d0c6d9f48ac2c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b39d0c6d9f48ac2c$var$_setPrototypeOf(o, p);
}
function $b39d0c6d9f48ac2c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b39d0c6d9f48ac2c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b39d0c6d9f48ac2c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b39d0c6d9f48ac2c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b39d0c6d9f48ac2c$var$_possibleConstructorReturn(this, result);
    };
}
function $b39d0c6d9f48ac2c$var$_possibleConstructorReturn(self, call) {
    if (call && ($b39d0c6d9f48ac2c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b39d0c6d9f48ac2c$var$_assertThisInitialized(self);
}
function $b39d0c6d9f48ac2c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b39d0c6d9f48ac2c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b39d0c6d9f48ac2c$var$_getPrototypeOf(o) {
    $b39d0c6d9f48ac2c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b39d0c6d9f48ac2c$var$_getPrototypeOf(o);
}
var $b39d0c6d9f48ac2c$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $b39d0c6d9f48ac2c$var$_inherits(Animate, _PureComponent);
    var _super = $b39d0c6d9f48ac2c$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $b39d0c6d9f48ac2c$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($b39d0c6d9f48ac2c$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($b39d0c6d9f48ac2c$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $b39d0c6d9f48ac2c$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $b39d0c6d9f48ac2c$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $b39d0c6d9f48ac2c$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $b39d0c6d9f48ac2c$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $b39d0c6d9f48ac2c$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $3db4016a62b667a7$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $b39d0c6d9f48ac2c$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($b39d0c6d9f48ac2c$var$_objectSpread($b39d0c6d9f48ac2c$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $b5aa7b0f8a958367$export$2e2bcd8739ae039)(from, to, (0, $4699523458b42c45$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($b39d0c6d9f48ac2c$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $7f91566aef852dee$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $b39d0c6d9f48ac2c$var$_objectSpread($b39d0c6d9f48ac2c$var$_objectSpread($b39d0c6d9f48ac2c$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($b39d0c6d9f48ac2c$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $7f91566aef852dee$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($b39d0c6d9f48ac2c$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $24ed0a549e304a9b$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $b39d0c6d9f48ac2c$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $7f91566aef852dee$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $b39d0c6d9f48ac2c$var$_objectSpread($b39d0c6d9f48ac2c$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $b39d0c6d9f48ac2c$var$_objectWithoutProperties(_this$props4, $b39d0c6d9f48ac2c$var$_excluded);
                var count = (0, $lDSNw.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $7f91566aef852dee$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $lDSNw.cloneElement)(container, $b39d0c6d9f48ac2c$var$_objectSpread($b39d0c6d9f48ac2c$var$_objectSpread({}, others), {}, {
                        style: $b39d0c6d9f48ac2c$var$_objectSpread($b39d0c6d9f48ac2c$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $lDSNw.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", null, (0, $lDSNw.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $lDSNw.PureComponent));
$b39d0c6d9f48ac2c$var$Animate.displayName = "Animate";
$b39d0c6d9f48ac2c$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$b39d0c6d9f48ac2c$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($houiY))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func
};
var $b39d0c6d9f48ac2c$export$2e2bcd8739ae039 = $b39d0c6d9f48ac2c$var$Animate;





var $lDSNw = parcelRequire("lDSNw");
var $d94ab8e12642f1c4$exports = {};
"use strict";

var $d94ab8e12642f1c4$var$_CSSTransition = $d94ab8e12642f1c4$var$_interopRequireDefault((parcelRequire("67H4j")));

var $d94ab8e12642f1c4$var$_ReplaceTransition = $d94ab8e12642f1c4$var$_interopRequireDefault((parcelRequire("6qXQO")));

var $d94ab8e12642f1c4$var$_TransitionGroup = $d94ab8e12642f1c4$var$_interopRequireDefault((parcelRequire("9e6Xd")));

var $d94ab8e12642f1c4$var$_Transition = $d94ab8e12642f1c4$var$_interopRequireDefault((parcelRequire("eR79z")));
function $d94ab8e12642f1c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d94ab8e12642f1c4$exports = {
    Transition: $d94ab8e12642f1c4$var$_Transition.default,
    TransitionGroup: $d94ab8e12642f1c4$var$_TransitionGroup.default,
    ReplaceTransition: $d94ab8e12642f1c4$var$_ReplaceTransition.default,
    CSSTransition: $d94ab8e12642f1c4$var$_CSSTransition.default
};



var $houiY = parcelRequire("houiY");

var $lDSNw = parcelRequire("lDSNw");


var $houiY = parcelRequire("houiY");

var $09e058c2f1fd32dc$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $09e058c2f1fd32dc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $09e058c2f1fd32dc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $09e058c2f1fd32dc$var$_typeof(obj);
}
function $09e058c2f1fd32dc$var$_extends() {
    $09e058c2f1fd32dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09e058c2f1fd32dc$var$_extends.apply(this, arguments);
}
function $09e058c2f1fd32dc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $09e058c2f1fd32dc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $09e058c2f1fd32dc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $09e058c2f1fd32dc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $09e058c2f1fd32dc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $09e058c2f1fd32dc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $09e058c2f1fd32dc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $09e058c2f1fd32dc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $09e058c2f1fd32dc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $09e058c2f1fd32dc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $09e058c2f1fd32dc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $09e058c2f1fd32dc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $09e058c2f1fd32dc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $09e058c2f1fd32dc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $09e058c2f1fd32dc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $09e058c2f1fd32dc$var$_setPrototypeOf(subClass, superClass);
}
function $09e058c2f1fd32dc$var$_setPrototypeOf(o, p) {
    $09e058c2f1fd32dc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $09e058c2f1fd32dc$var$_setPrototypeOf(o, p);
}
function $09e058c2f1fd32dc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $09e058c2f1fd32dc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $09e058c2f1fd32dc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $09e058c2f1fd32dc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $09e058c2f1fd32dc$var$_possibleConstructorReturn(this, result);
    };
}
function $09e058c2f1fd32dc$var$_possibleConstructorReturn(self, call) {
    if (call && ($09e058c2f1fd32dc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $09e058c2f1fd32dc$var$_assertThisInitialized(self);
}
function $09e058c2f1fd32dc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $09e058c2f1fd32dc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $09e058c2f1fd32dc$var$_getPrototypeOf(o) {
    $09e058c2f1fd32dc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $09e058c2f1fd32dc$var$_getPrototypeOf(o);
}
function $09e058c2f1fd32dc$var$_defineProperty(obj, key, value) {
    key = $09e058c2f1fd32dc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $09e058c2f1fd32dc$var$_toPropertyKey(arg) {
    var key = $09e058c2f1fd32dc$var$_toPrimitive(arg, "string");
    return $09e058c2f1fd32dc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $09e058c2f1fd32dc$var$_toPrimitive(input, hint) {
    if ($09e058c2f1fd32dc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($09e058c2f1fd32dc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === "number" && isFinite(value);
};
var $09e058c2f1fd32dc$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $09e058c2f1fd32dc$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $09e058c2f1fd32dc$var$_inherits(AnimateGroupChild, _Component);
    var _super = $09e058c2f1fd32dc$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $09e058c2f1fd32dc$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $09e058c2f1fd32dc$var$_defineProperty($09e058c2f1fd32dc$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $09e058c2f1fd32dc$var$_defineProperty($09e058c2f1fd32dc$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $09e058c2f1fd32dc$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($09e058c2f1fd32dc$var$_objectSpread($09e058c2f1fd32dc$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $09e058c2f1fd32dc$var$parseDurationOfSingleTransition(appearOptions) + $09e058c2f1fd32dc$var$parseDurationOfSingleTransition(enterOptions) + $09e058c2f1fd32dc$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $09e058c2f1fd32dc$var$_objectWithoutProperties(_this$props3, $09e058c2f1fd32dc$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $d94ab8e12642f1c4$exports.Transition), $09e058c2f1fd32dc$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $b39d0c6d9f48ac2c$export$2e2bcd8739ae039), _this2.state, (0, $lDSNw.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $lDSNw.Component));
$09e058c2f1fd32dc$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).element
};
var $09e058c2f1fd32dc$export$2e2bcd8739ae039 = $09e058c2f1fd32dc$var$AnimateGroupChild;


function $81249be377f97c36$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $d94ab8e12642f1c4$exports.TransitionGroup), {
        component: component
    }, (0, $lDSNw.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $09e058c2f1fd32dc$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$81249be377f97c36$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).any
};
$81249be377f97c36$var$AnimateGroup.defaultProps = {
    component: "span"
};
var $81249be377f97c36$export$2e2bcd8739ae039 = $81249be377f97c36$var$AnimateGroup;


var $1f1c6c2214af1451$export$2e2bcd8739ae039 = (0, $b39d0c6d9f48ac2c$export$2e2bcd8739ae039);




var $lDSNw = parcelRequire("lDSNw");


var $cf8cc3c87e97bf14$var$_excluded = [
    "children",
    "className"
];
function $cf8cc3c87e97bf14$var$_extends() {
    $cf8cc3c87e97bf14$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf8cc3c87e97bf14$var$_extends.apply(this, arguments);
}
function $cf8cc3c87e97bf14$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf8cc3c87e97bf14$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf8cc3c87e97bf14$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cf8cc3c87e97bf14$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $cf8cc3c87e97bf14$var$_objectWithoutProperties(props, $cf8cc3c87e97bf14$var$_excluded);
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", $cf8cc3c87e97bf14$var$_extends({
        className: layerClass
    }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $lDSNw = parcelRequire("lDSNw");





var $768d47a24ee3d1c4$exports = {};
var $f2097ebe1ba862dc$exports = {};

var $bcca8861c34713ba$exports = {};



/** Built-in value references. */ var $bcca8861c34713ba$var$spreadableSymbol = $9d0c04c90015b763$exports ? $9d0c04c90015b763$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $bcca8861c34713ba$var$isFlattenable(value) {
    return $84ca1aa52314c546$exports(value) || $f343e8c27e3a88b9$exports(value) || !!($bcca8861c34713ba$var$spreadableSymbol && value && value[$bcca8861c34713ba$var$spreadableSymbol]);
}
$bcca8861c34713ba$exports = $bcca8861c34713ba$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f2097ebe1ba862dc$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $bcca8861c34713ba$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f2097ebe1ba862dc$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $00bd5c86843bc067$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$f2097ebe1ba862dc$exports = $f2097ebe1ba862dc$var$baseFlatten;


var $b9b47245cd40e743$exports = {};



var $cdbca11dc37339e7$exports = {};
var $c2b15ad98b6e43d3$exports = {};
var $a77c320a217cd25e$exports = {};
var $b517a8ae0048a7b3$exports = {};
var $96416271e1cf7904$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $96416271e1cf7904$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$96416271e1cf7904$exports = $96416271e1cf7904$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $b517a8ae0048a7b3$var$baseFor = $96416271e1cf7904$exports();
$b517a8ae0048a7b3$exports = $b517a8ae0048a7b3$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $a77c320a217cd25e$var$baseForOwn(object, iteratee) {
    return object && $b517a8ae0048a7b3$exports(object, iteratee, $0ec295ae69d8df95$exports);
}
$a77c320a217cd25e$exports = $a77c320a217cd25e$var$baseForOwn;


var $c8f1980c71a4a100$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $c8f1980c71a4a100$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$842d4a0d91f878c6$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$c8f1980c71a4a100$exports = $c8f1980c71a4a100$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $c2b15ad98b6e43d3$var$baseEach = $c8f1980c71a4a100$exports($a77c320a217cd25e$exports);
$c2b15ad98b6e43d3$exports = $c2b15ad98b6e43d3$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $cdbca11dc37339e7$var$baseMap(collection, iteratee) {
    var index = -1, result = $842d4a0d91f878c6$exports(collection) ? Array(collection.length) : [];
    $c2b15ad98b6e43d3$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$cdbca11dc37339e7$exports = $cdbca11dc37339e7$var$baseMap;


var $76bead7612e557c6$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $76bead7612e557c6$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$76bead7612e557c6$exports = $76bead7612e557c6$var$baseSortBy;



var $0b094b335bfb0d8d$exports = {};
var $1437d3e2ad393aad$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $1437d3e2ad393aad$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $e7b08efe289d0f2f$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $e7b08efe289d0f2f$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$1437d3e2ad393aad$exports = $1437d3e2ad393aad$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $0b094b335bfb0d8d$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $1437d3e2ad393aad$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$0b094b335bfb0d8d$exports = $0b094b335bfb0d8d$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $b9b47245cd40e743$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $0be0047497ddc620$exports(iteratees, function(iteratee) {
        if ($84ca1aa52314c546$exports(iteratee)) return function(value) {
            return $b202afe34a2964fd$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $8b6dcd74cc369ffa$exports
    ];
    var index = -1;
    iteratees = $0be0047497ddc620$exports(iteratees, $a82eeedc6911bee7$exports($52c7c35fde7b0b7d$exports));
    var result = $cdbca11dc37339e7$exports(collection, function(value, key, collection) {
        var criteria = $0be0047497ddc620$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $76bead7612e557c6$exports(result, function(object, other) {
        return $0b094b335bfb0d8d$exports(object, other, orders);
    });
}
$b9b47245cd40e743$exports = $b9b47245cd40e743$var$baseOrderBy;


var $db4d93343657f382$exports = {};

var $d9ab996e7f69b113$exports = {};
var $98f9e1abd5c249b4$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $98f9e1abd5c249b4$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$98f9e1abd5c249b4$exports = $98f9e1abd5c249b4$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9ab996e7f69b113$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $d9ab996e7f69b113$var$overRest(func, start, transform) {
    start = $d9ab996e7f69b113$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $d9ab996e7f69b113$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $98f9e1abd5c249b4$exports(func, this, otherArgs);
    };
}
$d9ab996e7f69b113$exports = $d9ab996e7f69b113$var$overRest;


var $1417ea418a203574$exports = {};
var $e3b2e8cd294c1939$exports = {};
var $a4bbb8623b601aa1$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $a4bbb8623b601aa1$var$constant(value) {
    return function() {
        return value;
    };
}
$a4bbb8623b601aa1$exports = $a4bbb8623b601aa1$var$constant;


var $eebc8199e29d4fa6$exports = {};

var $eebc8199e29d4fa6$var$defineProperty = function() {
    try {
        var func = $160af1b543b551be$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$eebc8199e29d4fa6$exports = $eebc8199e29d4fa6$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e3b2e8cd294c1939$var$baseSetToString = !$eebc8199e29d4fa6$exports ? $8b6dcd74cc369ffa$exports : function(func, string) {
    return $eebc8199e29d4fa6$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $a4bbb8623b601aa1$exports(string),
        "writable": true
    });
};
$e3b2e8cd294c1939$exports = $e3b2e8cd294c1939$var$baseSetToString;


var $c0273f63f75e1f33$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $c0273f63f75e1f33$var$HOT_COUNT = 800, $c0273f63f75e1f33$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c0273f63f75e1f33$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $c0273f63f75e1f33$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $c0273f63f75e1f33$var$nativeNow(), remaining = $c0273f63f75e1f33$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $c0273f63f75e1f33$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$c0273f63f75e1f33$exports = $c0273f63f75e1f33$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1417ea418a203574$var$setToString = $c0273f63f75e1f33$exports($e3b2e8cd294c1939$exports);
$1417ea418a203574$exports = $1417ea418a203574$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $db4d93343657f382$var$baseRest(func, start) {
    return $1417ea418a203574$exports($d9ab996e7f69b113$exports(func, start, $8b6dcd74cc369ffa$exports), func + "");
}
$db4d93343657f382$exports = $db4d93343657f382$var$baseRest;


var $3a756535bab803ed$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $3a756535bab803ed$var$isIterateeCall(value, index, object) {
    if (!$1e60876e846aca7c$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $842d4a0d91f878c6$exports(object) && $6c1a7e10c83cdbae$exports(index, object.length) : type == "string" && index in object) return $61269e018e176ece$exports(object[index], value);
    return false;
}
$3a756535bab803ed$exports = $3a756535bab803ed$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $768d47a24ee3d1c4$var$sortBy = $db4d93343657f382$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $3a756535bab803ed$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $3a756535bab803ed$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $b9b47245cd40e743$exports(collection, $f2097ebe1ba862dc$exports(iteratees, 1), []);
});
$768d47a24ee3d1c4$exports = $768d47a24ee3d1c4$var$sortBy;






var $7a8edb845f1490bc$exports = {};
var $60cc081a6c7671c3$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $60cc081a6c7671c3$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$e7b08efe289d0f2f$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$60cc081a6c7671c3$exports = $60cc081a6c7671c3$var$baseExtremum;


var $fb3f6c96a64a9c37$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $fb3f6c96a64a9c37$var$baseGt(value, other) {
    return value > other;
}
$fb3f6c96a64a9c37$exports = $fb3f6c96a64a9c37$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7a8edb845f1490bc$var$max(array) {
    return array && array.length ? $60cc081a6c7671c3$exports(array, $8b6dcd74cc369ffa$exports, $fb3f6c96a64a9c37$exports) : undefined;
}
$7a8edb845f1490bc$exports = $7a8edb845f1490bc$var$max;


var $b7ad2834a36a6519$exports = {};

var $57d8fea5e5433e11$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $57d8fea5e5433e11$var$baseLt(value, other) {
    return value < other;
}
$57d8fea5e5433e11$exports = $57d8fea5e5433e11$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $b7ad2834a36a6519$var$min(array) {
    return array && array.length ? $60cc081a6c7671c3$exports(array, $8b6dcd74cc369ffa$exports, $57d8fea5e5433e11$exports) : undefined;
}
$b7ad2834a36a6519$exports = $b7ad2834a36a6519$var$min;


var $3cec2c584f4e381e$exports = {};

var $a6c4cdb29318c3a5$exports = {};




/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a6c4cdb29318c3a5$var$map(collection, iteratee) {
    var func = $84ca1aa52314c546$exports(collection) ? $0be0047497ddc620$exports : $cdbca11dc37339e7$exports;
    return func(collection, $52c7c35fde7b0b7d$exports(iteratee, 3));
}
$a6c4cdb29318c3a5$exports = $a6c4cdb29318c3a5$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $3cec2c584f4e381e$var$flatMap(collection, iteratee) {
    return $f2097ebe1ba862dc$exports($a6c4cdb29318c3a5$exports(collection, iteratee), 1);
}
$3cec2c584f4e381e$exports = $3cec2c584f4e381e$var$flatMap;





var $30f8fd6045919cf1$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$30f8fd6045919cf1$exports = (parcelRequire("8oVtG"));



var $6bdf878532f94bf4$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $6bdf878532f94bf4$exports) $6bdf878532f94bf4$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($6bdf878532f94bf4$exports);


function $5f5c79f8f7c75ea3$var$_toConsumableArray(arr) {
    return $5f5c79f8f7c75ea3$var$_arrayWithoutHoles(arr) || $5f5c79f8f7c75ea3$var$_iterableToArray(arr) || $5f5c79f8f7c75ea3$var$_unsupportedIterableToArray(arr) || $5f5c79f8f7c75ea3$var$_nonIterableSpread();
}
function $5f5c79f8f7c75ea3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5f5c79f8f7c75ea3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5f5c79f8f7c75ea3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5f5c79f8f7c75ea3$var$_arrayLikeToArray(o, minLen);
}
function $5f5c79f8f7c75ea3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $5f5c79f8f7c75ea3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5f5c79f8f7c75ea3$var$_arrayLikeToArray(arr);
}
function $5f5c79f8f7c75ea3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5f5c79f8f7c75ea3$var$identity = function identity(i) {
    return i;
};
var $5f5c79f8f7c75ea3$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $5f5c79f8f7c75ea3$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $5f5c79f8f7c75ea3$export$ca73b6d700d0505;
};
var $5f5c79f8f7c75ea3$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $5f5c79f8f7c75ea3$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $5f5c79f8f7c75ea3$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $5f5c79f8f7c75ea3$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $5f5c79f8f7c75ea3$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $5f5c79f8f7c75ea3$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $5f5c79f8f7c75ea3$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $5f5c79f8f7c75ea3$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $5f5c79f8f7c75ea3$export$c3095a23b368d1f2 = function curry(fn) {
    return $5f5c79f8f7c75ea3$var$curryN(fn.length, fn);
};
var $5f5c79f8f7c75ea3$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $5f5c79f8f7c75ea3$export$871de8747c9eaa88 = $5f5c79f8f7c75ea3$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $5f5c79f8f7c75ea3$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $5f5c79f8f7c75ea3$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $5f5c79f8f7c75ea3$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $5f5c79f8f7c75ea3$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $33d03d7bee1718c5$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $33d03d7bee1718c5$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $33d03d7bee1718c5$var$interpolateNumber = (0, $5f5c79f8f7c75ea3$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $33d03d7bee1718c5$var$uninterpolateNumber = (0, $5f5c79f8f7c75ea3$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $33d03d7bee1718c5$var$uninterpolateTruncation = (0, $5f5c79f8f7c75ea3$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $33d03d7bee1718c5$export$2e2bcd8739ae039 = {
    rangeStep: $33d03d7bee1718c5$var$rangeStep,
    getDigitCount: $33d03d7bee1718c5$var$getDigitCount,
    interpolateNumber: $33d03d7bee1718c5$var$interpolateNumber,
    uninterpolateNumber: $33d03d7bee1718c5$var$uninterpolateNumber,
    uninterpolateTruncation: $33d03d7bee1718c5$var$uninterpolateTruncation
};


function $7e2ff32b48b653a5$var$_toConsumableArray(arr) {
    return $7e2ff32b48b653a5$var$_arrayWithoutHoles(arr) || $7e2ff32b48b653a5$var$_iterableToArray(arr) || $7e2ff32b48b653a5$var$_unsupportedIterableToArray(arr) || $7e2ff32b48b653a5$var$_nonIterableSpread();
}
function $7e2ff32b48b653a5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7e2ff32b48b653a5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $7e2ff32b48b653a5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7e2ff32b48b653a5$var$_arrayLikeToArray(arr);
}
function $7e2ff32b48b653a5$var$_slicedToArray(arr, i) {
    return $7e2ff32b48b653a5$var$_arrayWithHoles(arr) || $7e2ff32b48b653a5$var$_iterableToArrayLimit(arr, i) || $7e2ff32b48b653a5$var$_unsupportedIterableToArray(arr, i) || $7e2ff32b48b653a5$var$_nonIterableRest();
}
function $7e2ff32b48b653a5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7e2ff32b48b653a5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7e2ff32b48b653a5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7e2ff32b48b653a5$var$_arrayLikeToArray(o, minLen);
}
function $7e2ff32b48b653a5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7e2ff32b48b653a5$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7e2ff32b48b653a5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $7e2ff32b48b653a5$var$getValidInterval(_ref) {
    var _ref2 = $7e2ff32b48b653a5$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $7e2ff32b48b653a5$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(0);
    var digitCount = (0, $33d03d7bee1718c5$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $7e2ff32b48b653a5$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(10).pow((0, $33d03d7bee1718c5$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $5f5c79f8f7c75ea3$export$f672e0b6f7222cd7)((0, $5f5c79f8f7c75ea3$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $5f5c79f8f7c75ea3$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $7e2ff32b48b653a5$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $7e2ff32b48b653a5$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $7e2ff32b48b653a5$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $7e2ff32b48b653a5$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $7e2ff32b48b653a5$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $7e2ff32b48b653a5$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $7e2ff32b48b653a5$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($7e2ff32b48b653a5$var$_toConsumableArray((0, $5f5c79f8f7c75ea3$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($7e2ff32b48b653a5$var$_toConsumableArray((0, $5f5c79f8f7c75ea3$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $5f5c79f8f7c75ea3$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $7e2ff32b48b653a5$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $7e2ff32b48b653a5$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $33d03d7bee1718c5$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $5f5c79f8f7c75ea3$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $7e2ff32b48b653a5$var$getTickValuesFn(_ref5) {
    var _ref6 = $7e2ff32b48b653a5$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $7e2ff32b48b653a5$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $7e2ff32b48b653a5$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $7e2ff32b48b653a5$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $7e2ff32b48b653a5$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $5f5c79f8f7c75ea3$export$f672e0b6f7222cd7)((0, $5f5c79f8f7c75ea3$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(n).mul(step)).toNumber();
    }), (0, $5f5c79f8f7c75ea3$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $5f5c79f8f7c75ea3$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $7e2ff32b48b653a5$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $7e2ff32b48b653a5$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $7e2ff32b48b653a5$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $7e2ff32b48b653a5$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $7e2ff32b48b653a5$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($7e2ff32b48b653a5$var$_toConsumableArray((0, $33d03d7bee1718c5$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($6bdf878532f94bf4$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $5f5c79f8f7c75ea3$export$66c1ae025e96b4bc)(values) : values;
}
var $7e2ff32b48b653a5$export$b84e75ccbfe6a612 = (0, $5f5c79f8f7c75ea3$export$fc10aeed3a532e2a)($7e2ff32b48b653a5$var$getNiceTickValuesFn);
var $7e2ff32b48b653a5$export$4cc7a216492b1f53 = (0, $5f5c79f8f7c75ea3$export$fc10aeed3a532e2a)($7e2ff32b48b653a5$var$getTickValuesFn);
var $7e2ff32b48b653a5$export$e9d28da780436e98 = (0, $5f5c79f8f7c75ea3$export$fc10aeed3a532e2a)($7e2ff32b48b653a5$var$getTickValuesFixedDomainFn);





var $lDSNw = parcelRequire("lDSNw");


var $2f8a30b541520345$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $2f8a30b541520345$var$_extends() {
    $2f8a30b541520345$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2f8a30b541520345$var$_extends.apply(this, arguments);
}
function $2f8a30b541520345$var$_slicedToArray(arr, i) {
    return $2f8a30b541520345$var$_arrayWithHoles(arr) || $2f8a30b541520345$var$_iterableToArrayLimit(arr, i) || $2f8a30b541520345$var$_unsupportedIterableToArray(arr, i) || $2f8a30b541520345$var$_nonIterableRest();
}
function $2f8a30b541520345$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2f8a30b541520345$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2f8a30b541520345$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2f8a30b541520345$var$_arrayLikeToArray(o, minLen);
}
function $2f8a30b541520345$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2f8a30b541520345$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $2f8a30b541520345$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2f8a30b541520345$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2f8a30b541520345$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2f8a30b541520345$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2f8a30b541520345$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $2f8a30b541520345$var$_objectWithoutProperties(props, $2f8a30b541520345$var$_excluded);
    var svgProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others);
    var errorBars = data.map(function(entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $2f8a30b541520345$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === "vertical") {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === "horizontal") {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $2f8a30b541520345$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
        }, svgProps), lineCoordinates.map(function(coordinates, index) {
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", $2f8a30b541520345$var$_extends({}, coordinates, {
                key: "line-".concat(index)
            })));
        })));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$2f8a30b541520345$export$4f4d7676bdf949e5.defaultProps = {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
};
$2f8a30b541520345$export$4f4d7676bdf949e5.displayName = "ErrorBar";





function $ecbafd4b4677e0ac$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ecbafd4b4677e0ac$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ecbafd4b4677e0ac$var$_typeof(obj);
}
function $ecbafd4b4677e0ac$var$_toConsumableArray(arr) {
    return $ecbafd4b4677e0ac$var$_arrayWithoutHoles(arr) || $ecbafd4b4677e0ac$var$_iterableToArray(arr) || $ecbafd4b4677e0ac$var$_unsupportedIterableToArray(arr) || $ecbafd4b4677e0ac$var$_nonIterableSpread();
}
function $ecbafd4b4677e0ac$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ecbafd4b4677e0ac$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ecbafd4b4677e0ac$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ecbafd4b4677e0ac$var$_arrayLikeToArray(o, minLen);
}
function $ecbafd4b4677e0ac$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ecbafd4b4677e0ac$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ecbafd4b4677e0ac$var$_arrayLikeToArray(arr);
}
function $ecbafd4b4677e0ac$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ecbafd4b4677e0ac$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ecbafd4b4677e0ac$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ecbafd4b4677e0ac$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ecbafd4b4677e0ac$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ecbafd4b4677e0ac$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ecbafd4b4677e0ac$var$_defineProperty(obj, key, value) {
    key = $ecbafd4b4677e0ac$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ecbafd4b4677e0ac$var$_toPropertyKey(arg) {
    var key = $ecbafd4b4677e0ac$var$_toPrimitive(arg, "string");
    return $ecbafd4b4677e0ac$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ecbafd4b4677e0ac$var$_toPrimitive(input, hint) {
    if ($ecbafd4b4677e0ac$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ecbafd4b4677e0ac$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ecbafd4b4677e0ac$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(dataKey)) return defaultValue;
    if ((0, $aee02c7eefa94d8b$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $ecbafd4b4677e0ac$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($3cec2c584f4e381e$exports)))(data, function(entry) {
        return $ecbafd4b4677e0ac$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        var domain = flattenData.filter(function(entry) {
            return (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($b7ad2834a36a6519$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(entry);
    }) : flattenData;
    // 支持Date类型的x轴
    return validateData.map(function(entry) {
        return (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $ecbafd4b4677e0ac$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $aee02c7eefa94d8b$export$9d334328eb75e624)(cur - before) !== (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $aee02c7eefa94d8b$export$9d334328eb75e624)(after - cur) === (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var min = Math.min(before, after);
                var max = Math.max(before, after);
                if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $ecbafd4b4677e0ac$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $ecbafd4b4677e0ac$export$8f9424d123c36aa = function getLegendProps(_ref2) {
    var children = _ref2.children, formattedGraphicalItems = _ref2.formattedGraphicalItems, legendWidth = _ref2.legendWidth, legendContent = _ref2.legendContent;
    var legendItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $22f8c7fa15a15fc3$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref3) {
        var item = _ref3.item, props = _ref3.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref4) {
        var item = _ref4.item;
        var _item$props2 = item.props, dataKey = _item$props2.dataKey, name = _item$props2.name, legendType = _item$props2.legendType, hide = _item$props2.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: $ecbafd4b4677e0ac$export$ec6cab5a7a3b93bf(item),
            value: name || dataKey,
            payload: item.props
        };
    });
    return $ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread({}, legendItem.props), (0, $22f8c7fa15a15fc3$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};
var $ecbafd4b4677e0ac$export$570d306bee26c748 = function getBarSizeList(_ref5) {
    var globalSize = _ref5.barSize, _ref5$stackGroups = _ref5.stackGroups, stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $65af1a52cac4dd09$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $ecbafd4b4677e0ac$export$d36834ecd87f906b = function getBarPosition(_ref6) {
    var barGap = _ref6.barGap, barCategoryGap = _ref6.barCategoryGap, bandSize = _ref6.bandSize, _ref6$sizeList = _ref6.sizeList, sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList, maxBarSize = _ref6.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newRes = [].concat($ecbafd4b4677e0ac$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: prev.offset + prev.size + realBarGap,
                        size: useFull ? fullBarSize : entry.barSize
                    }
                }
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, []);
    } else {
        var _offset = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($ecbafd4b4677e0ac$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, []);
    }
    return result;
};
var $ecbafd4b4677e0ac$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, items, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
    var legendProps = $ecbafd4b4677e0ac$export$8f9424d123c36aa({
        children: children,
        legendWidth: legendWidth
    });
    var newOffset = offset;
    if (legendProps) {
        var box = legendBox || {};
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(offset[align])) newOffset = $ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread({}, offset), {}, $ecbafd4b4677e0ac$var$_defineProperty({}, align, newOffset[align] + (box.width || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(offset[verticalAlign])) newOffset = $ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread({}, offset), {}, $ecbafd4b4677e0ac$var$_defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
    return newOffset;
};
var $ecbafd4b4677e0ac$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $ecbafd4b4677e0ac$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $2f8a30b541520345$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $ecbafd4b4677e0ac$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $ecbafd4b4677e0ac$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($b7ad2834a36a6519$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $ecbafd4b4677e0ac$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $ecbafd4b4677e0ac$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $ecbafd4b4677e0ac$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $ecbafd4b4677e0ac$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $ecbafd4b4677e0ac$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $ecbafd4b4677e0ac$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $ecbafd4b4677e0ac$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)if (!tag[entry[i]]) {
            tag[entry[i]] = true;
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $ecbafd4b4677e0ac$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $ecbafd4b4677e0ac$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, min, max) {
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === min) hasMin = true;
        if (entry.coordinate === max) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(min);
    if (!hasMax) values.push(max);
    return values;
};
var $ecbafd4b4677e0ac$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($ebdb18b484d894aa$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
var $ecbafd4b4677e0ac$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
    var customizedHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(childHandler)) customizedHandler = childHandler;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(parentHandler)) customizedHandler = parentHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(defaultHandler) || customizedHandler) return function(arg1, arg2, arg3, arg4) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(defaultHandler)) defaultHandler(arg1, arg2, arg3, arg4);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(customizedHandler)) customizedHandler(arg1, arg2, arg3, arg4);
    };
    return null;
};
var $ecbafd4b4677e0ac$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $30f8fd6045919cf1$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $30f8fd6045919cf1$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $30f8fd6045919cf1$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $30f8fd6045919cf1$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $30f8fd6045919cf1$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5616f51c0f760501$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($27db65edc002de9d$exports)))(scale));
        return {
            scale: ($30f8fd6045919cf1$exports[name] || $30f8fd6045919cf1$exports.scalePoint)(),
            realScaleType: $30f8fd6045919cf1$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $30f8fd6045919cf1$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $ecbafd4b4677e0ac$var$EPS = 1e-4;
var $ecbafd4b4677e0ac$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var min = Math.min(range[0], range[1]) - $ecbafd4b4677e0ac$var$EPS;
    var max = Math.max(range[0], range[1]) + $ecbafd4b4677e0ac$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < min || first > max || last < min || last > max) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $ecbafd4b4677e0ac$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $ecbafd4b4677e0ac$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(domain[0]) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(domain[1])) return value;
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(value[0]) || value[0] < min) result[0] = min;
    if (!(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(value[1]) || value[1] > max) result[1] = max;
    if (result[0] > max) result[0] = max;
    if (result[1] < min) result[1] = min;
    return result;
};
var $ecbafd4b4677e0ac$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($ebdb18b484d894aa$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $ecbafd4b4677e0ac$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($ebdb18b484d894aa$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $ecbafd4b4677e0ac$var$STACK_OFFSET_MAP = {
    sign: $ecbafd4b4677e0ac$export$3104c513558164c1,
    expand: (0, $c0ba789d13717a18$exports.stackOffsetExpand),
    none: (0, $c0ba789d13717a18$exports.stackOffsetNone),
    silhouette: (0, $c0ba789d13717a18$exports.stackOffsetSilhouette),
    wiggle: (0, $c0ba789d13717a18$exports.stackOffsetWiggle),
    positive: $ecbafd4b4677e0ac$export$9f2c6ead70935022
};
var $ecbafd4b4677e0ac$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var stack = (0, $c0ba789d13717a18$exports.stack)().keys(dataKeys).value(function(d, key) {
        return +$ecbafd4b4677e0ac$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $c0ba789d13717a18$exports.stackOrderNone)).offset($ecbafd4b4677e0ac$var$STACK_OFFSET_MAP[offsetType]);
    return stack(data);
};
var $ecbafd4b4677e0ac$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var stackGroups = items.reduce(function(result, item) {
        var _item$props3 = item.props, stackId = _item$props3.stackId, hide = _item$props3.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $aee02c7eefa94d8b$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread({}, result), {}, $ecbafd4b4677e0ac$var$_defineProperty({}, axisId, parentGroup));
    }, {});
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
            var g = group.stackGroups[stackId];
            return $ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread({}, res), {}, $ecbafd4b4677e0ac$var$_defineProperty({}, stackId, {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: g.items,
                stackedData: $ecbafd4b4677e0ac$export$c2170542cfc0177c(data, g.items, offsetType)
            }));
        }, {});
        return $ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread({}, result), {}, $ecbafd4b4677e0ac$var$_defineProperty({}, axisId, group));
    }, {});
};
var $ecbafd4b4677e0ac$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $7e2ff32b48b653a5$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($b7ad2834a36a6519$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $7e2ff32b48b653a5$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $ecbafd4b4677e0ac$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref7) {
    var axis = _ref7.axis, ticks = _ref7.ticks, bandSize = _ref7.bandSize, entry = _ref7.entry, index = _ref7.index, dataKey = _ref7.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $aee02c7eefa94d8b$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $ecbafd4b4677e0ac$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(value) ? axis.scale(value) : null;
};
var $ecbafd4b4677e0ac$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref8) {
    var axis = _ref8.axis, ticks = _ref8.ticks, offset = _ref8.offset, bandSize = _ref8.bandSize, entry = _ref8.entry, index = _ref8.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $ecbafd4b4677e0ac$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $ecbafd4b4677e0ac$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref9) {
    var numericAxis = _ref9.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var min = Math.min(domain[0], domain[1]);
        var max = Math.max(domain[0], domain[1]);
        if (min <= 0 && max >= 0) return 0;
        if (max < 0) return max;
        return min;
    }
    return domain[0];
};
var $ecbafd4b4677e0ac$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $aee02c7eefa94d8b$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group && group.items.length) {
            var itemIndex = -1;
            for(var i = 0, len = group.items.length; i < len; i++)if (group.items[i] === item) {
                itemIndex = i;
                break;
            }
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $ecbafd4b4677e0ac$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($b7ad2834a36a6519$exports)))(entry.concat([
                result[0]
            ]).filter((0, $aee02c7eefa94d8b$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(entry.concat([
                result[1]
            ]).filter((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $ecbafd4b4677e0ac$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $ecbafd4b4677e0ac$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $ecbafd4b4677e0ac$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $ecbafd4b4677e0ac$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $ecbafd4b4677e0ac$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($ecbafd4b4677e0ac$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$ecbafd4b4677e0ac$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($ecbafd4b4677e0ac$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$ecbafd4b4677e0ac$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $ecbafd4b4677e0ac$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($768d47a24ee3d1c4$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $ecbafd4b4677e0ac$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($accecf4f4d483c19$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $ecbafd4b4677e0ac$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $ecbafd4b4677e0ac$var$_objectSpread($ecbafd4b4677e0ac$var$_objectSpread({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $ecbafd4b4677e0ac$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $ecbafd4b4677e0ac$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $fb34ba651878b323$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fb34ba651878b323$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fb34ba651878b323$var$_typeof(obj);
}
function $fb34ba651878b323$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fb34ba651878b323$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fb34ba651878b323$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fb34ba651878b323$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fb34ba651878b323$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fb34ba651878b323$var$_defineProperty(obj, key, value) {
    key = $fb34ba651878b323$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fb34ba651878b323$var$_toPropertyKey(arg) {
    var key = $fb34ba651878b323$var$_toPrimitive(arg, "string");
    return $fb34ba651878b323$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fb34ba651878b323$var$_toPrimitive(input, hint) {
    if ($fb34ba651878b323$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fb34ba651878b323$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fb34ba651878b323$var$_slicedToArray(arr, i) {
    return $fb34ba651878b323$var$_arrayWithHoles(arr) || $fb34ba651878b323$var$_iterableToArrayLimit(arr, i) || $fb34ba651878b323$var$_unsupportedIterableToArray(arr, i) || $fb34ba651878b323$var$_nonIterableRest();
}
function $fb34ba651878b323$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fb34ba651878b323$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fb34ba651878b323$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fb34ba651878b323$var$_arrayLikeToArray(o, minLen);
}
function $fb34ba651878b323$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fb34ba651878b323$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $fb34ba651878b323$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $fb34ba651878b323$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $fb34ba651878b323$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $fb34ba651878b323$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $fb34ba651878b323$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$fb34ba651878b323$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$fb34ba651878b323$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $fb34ba651878b323$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $fb34ba651878b323$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $fb34ba651878b323$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $fb34ba651878b323$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $ecbafd4b4677e0ac$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $ecbafd4b4677e0ac$export$9d80152e23bae434)(scale);
        var ticks = (0, $ecbafd4b4677e0ac$export$ac086aaa4358d590)(scale, $fb34ba651878b323$var$_objectSpread($fb34ba651878b323$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $fb34ba651878b323$var$_objectSpread($fb34ba651878b323$var$_objectSpread($fb34ba651878b323$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $fb34ba651878b323$var$_objectSpread($fb34ba651878b323$var$_objectSpread({}, result), {}, $fb34ba651878b323$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $fb34ba651878b323$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $fb34ba651878b323$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $fb34ba651878b323$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $fb34ba651878b323$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $fb34ba651878b323$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $fb34ba651878b323$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $fb34ba651878b323$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $fb34ba651878b323$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $fb34ba651878b323$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $fb34ba651878b323$var$_objectSpread($fb34ba651878b323$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $fb34ba651878b323$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};



function $6a5e9973c598b4e9$var$_extends() {
    $6a5e9973c598b4e9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a5e9973c598b4e9$var$_extends.apply(this, arguments);
}
var $6a5e9973c598b4e9$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $6a5e9973c598b4e9$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $fb34ba651878b323$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $fb34ba651878b323$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $6a5e9973c598b4e9$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $6a5e9973c598b4e9$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $6a5e9973c598b4e9$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $6a5e9973c598b4e9$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $6a5e9973c598b4e9$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $6a5e9973c598b4e9$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $6a5e9973c598b4e9$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $6a5e9973c598b4e9$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $6a5e9973c598b4e9$export$e98c2c7eb2b14f45 = function Sector(props) {
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $6a5e9973c598b4e9$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $6a5e9973c598b4e9$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $6a5e9973c598b4e9$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};
$6a5e9973c598b4e9$export$e98c2c7eb2b14f45.defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};






var $lDSNw = parcelRequire("lDSNw");





function $4eefa9e1680e4ef8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4eefa9e1680e4ef8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4eefa9e1680e4ef8$var$_typeof(obj);
}
function $4eefa9e1680e4ef8$var$_extends() {
    $4eefa9e1680e4ef8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4eefa9e1680e4ef8$var$_extends.apply(this, arguments);
}
function $4eefa9e1680e4ef8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4eefa9e1680e4ef8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4eefa9e1680e4ef8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4eefa9e1680e4ef8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4eefa9e1680e4ef8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4eefa9e1680e4ef8$var$_defineProperty(obj, key, value) {
    key = $4eefa9e1680e4ef8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4eefa9e1680e4ef8$var$_toPropertyKey(arg) {
    var key = $4eefa9e1680e4ef8$var$_toPrimitive(arg, "string");
    return $4eefa9e1680e4ef8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4eefa9e1680e4ef8$var$_toPrimitive(input, hint) {
    if ($4eefa9e1680e4ef8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4eefa9e1680e4ef8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4eefa9e1680e4ef8$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $c0ba789d13717a18$exports.curveBasisClosed),
    curveBasisOpen: (0, $c0ba789d13717a18$exports.curveBasisOpen),
    curveBasis: (0, $c0ba789d13717a18$exports.curveBasis),
    curveBumpX: (0, $c0ba789d13717a18$exports.curveBumpX),
    curveBumpY: (0, $c0ba789d13717a18$exports.curveBumpY),
    curveLinearClosed: (0, $c0ba789d13717a18$exports.curveLinearClosed),
    curveLinear: (0, $c0ba789d13717a18$exports.curveLinear),
    curveMonotoneX: (0, $c0ba789d13717a18$exports.curveMonotoneX),
    curveMonotoneY: (0, $c0ba789d13717a18$exports.curveMonotoneY),
    curveNatural: (0, $c0ba789d13717a18$exports.curveNatural),
    curveStep: (0, $c0ba789d13717a18$exports.curveStep),
    curveStepAfter: (0, $c0ba789d13717a18$exports.curveStepAfter),
    curveStepBefore: (0, $c0ba789d13717a18$exports.curveStepBefore)
};
var $4eefa9e1680e4ef8$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $4eefa9e1680e4ef8$var$getX = function getX(p) {
    return p.x;
};
var $4eefa9e1680e4ef8$var$getY = function getY(p) {
    return p.y;
};
var $4eefa9e1680e4ef8$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($27db65edc002de9d$exports)))(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return $4eefa9e1680e4ef8$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $4eefa9e1680e4ef8$var$CURVE_FACTORIES[name] || (0, $c0ba789d13717a18$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $4eefa9e1680e4ef8$var$getPath = function getPath(_ref) {
    var type = _ref.type, points = _ref.points, baseLine = _ref.baseLine, layout = _ref.layout, connectNulls = _ref.connectNulls;
    var curveFactory = $4eefa9e1680e4ef8$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $4eefa9e1680e4ef8$var$defined(entry);
    }) : points;
    var lineFunction;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $4eefa9e1680e4ef8$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $4eefa9e1680e4ef8$var$_objectSpread($4eefa9e1680e4ef8$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, $c0ba789d13717a18$exports.area)().y($4eefa9e1680e4ef8$var$getY).x1($4eefa9e1680e4ef8$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $c0ba789d13717a18$exports.area)().x($4eefa9e1680e4ef8$var$getX).y1($4eefa9e1680e4ef8$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($4eefa9e1680e4ef8$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $c0ba789d13717a18$exports.area)().y($4eefa9e1680e4ef8$var$getY).x1($4eefa9e1680e4ef8$var$getX).x0(baseLine);
    else if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $c0ba789d13717a18$exports.area)().x($4eefa9e1680e4ef8$var$getX).y1($4eefa9e1680e4ef8$var$getY).y0(baseLine);
    else lineFunction = (0, $c0ba789d13717a18$exports.line)().x($4eefa9e1680e4ef8$var$getX).y($4eefa9e1680e4ef8$var$getY);
    lineFunction.defined($4eefa9e1680e4ef8$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $4eefa9e1680e4ef8$var$getPath(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $4eefa9e1680e4ef8$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props), (0, $f50c94b715022fe9$export$7c4c290a4a9c1b1e)(props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};
$4eefa9e1680e4ef8$export$b0e83c3ef8d2db1.defaultProps = {
    type: "linear",
    points: [],
    connectNulls: false
};




var $lDSNw = parcelRequire("lDSNw");
var $6e2d5ffef9bacf2c$exports = {};
"use strict";
Object.defineProperty($6e2d5ffef9bacf2c$exports, "__esModule", {
    value: true
});
var $b23e8fa9caedcac5$exports = {};
var $227cd17cb41a68e1$exports = {};
var $227cd17cb41a68e1$var$openParentheses = "(".charCodeAt(0);
var $227cd17cb41a68e1$var$closeParentheses = ")".charCodeAt(0);
var $227cd17cb41a68e1$var$singleQuote = "'".charCodeAt(0);
var $227cd17cb41a68e1$var$doubleQuote = '"'.charCodeAt(0);
var $227cd17cb41a68e1$var$backslash = "\\".charCodeAt(0);
var $227cd17cb41a68e1$var$slash = "/".charCodeAt(0);
var $227cd17cb41a68e1$var$comma = ",".charCodeAt(0);
var $227cd17cb41a68e1$var$colon = ":".charCodeAt(0);
var $227cd17cb41a68e1$var$star = "*".charCodeAt(0);
$227cd17cb41a68e1$exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $227cd17cb41a68e1$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $227cd17cb41a68e1$var$comma || code === $227cd17cb41a68e1$var$colon || code === $227cd17cb41a68e1$var$slash && value.charCodeAt(next + 1) !== $227cd17cb41a68e1$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $227cd17cb41a68e1$var$singleQuote || code === $227cd17cb41a68e1$var$doubleQuote) {
            next = pos;
            quote = code === $227cd17cb41a68e1$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $227cd17cb41a68e1$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $227cd17cb41a68e1$var$slash && value.charCodeAt(pos + 1) === $227cd17cb41a68e1$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $227cd17cb41a68e1$var$slash || code === $227cd17cb41a68e1$var$comma || code === $227cd17cb41a68e1$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($227cd17cb41a68e1$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $227cd17cb41a68e1$var$singleQuote && code !== $227cd17cb41a68e1$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $227cd17cb41a68e1$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($227cd17cb41a68e1$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $227cd17cb41a68e1$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $227cd17cb41a68e1$var$singleQuote || code === $227cd17cb41a68e1$var$doubleQuote || code === $227cd17cb41a68e1$var$comma || code === $227cd17cb41a68e1$var$colon || code === $227cd17cb41a68e1$var$slash || code === $227cd17cb41a68e1$var$openParentheses || code === $227cd17cb41a68e1$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($227cd17cb41a68e1$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};


var $736b76e383b2b89f$exports = {};
$736b76e383b2b89f$exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};


var $4a97998f2f0c9644$exports = {};
function $4a97998f2f0c9644$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $4a97998f2f0c9644$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $4a97998f2f0c9644$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $4a97998f2f0c9644$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $4a97998f2f0c9644$var$stringifyNode(nodes, custom);
}
$4a97998f2f0c9644$exports = $4a97998f2f0c9644$var$stringify;


function $b23e8fa9caedcac5$var$ValueParser(value) {
    if (this instanceof $b23e8fa9caedcac5$var$ValueParser) {
        this.nodes = $227cd17cb41a68e1$exports(value);
        return this;
    }
    return new $b23e8fa9caedcac5$var$ValueParser(value);
}
$b23e8fa9caedcac5$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $4a97998f2f0c9644$exports(this.nodes) : "";
};
$b23e8fa9caedcac5$var$ValueParser.prototype.walk = function(cb, bubble) {
    $736b76e383b2b89f$exports(this.nodes, cb, bubble);
    return this;
};

$b23e8fa9caedcac5$var$ValueParser.unit = (parcelRequire("kgaqp"));
$b23e8fa9caedcac5$var$ValueParser.walk = $736b76e383b2b89f$exports;
$b23e8fa9caedcac5$var$ValueParser.stringify = $4a97998f2f0c9644$exports;
$b23e8fa9caedcac5$exports = $b23e8fa9caedcac5$var$ValueParser;


var $6e2d5ffef9bacf2c$var$_postcssValueParser2 = $6e2d5ffef9bacf2c$var$_interopRequireDefault($b23e8fa9caedcac5$exports);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $c904d8a37e0c5236$export$8f49e4af10703ce3;
var $c904d8a37e0c5236$export$7acfa6ed01010e37;
var $c904d8a37e0c5236$export$98e6a39c04603d36;
var $c904d8a37e0c5236$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, "name", {
            enumerable: false,
            writable: false,
            value: "JisonParserError"
        });
        if (msg == null) msg = "???";
        Object.defineProperty(this, "message", {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty("captureStackTrace")) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, "stack", {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = "JisonParserError";
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === "function") {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return "end of input";
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: "MathExpression",
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: "LengthValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: "AngleValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: "TimeValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: "FrequencyValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: "ResolutionValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: "EmValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "em"
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: "ExValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ex"
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: "ChValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ch"
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: "RemValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "rem"
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: "VhValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vh"
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: "VwValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vw"
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: "VminValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmin"
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: "VmaxValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmax"
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: "PercentageValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "%"
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === "function") this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === "function") this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== "function") ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error("assertion failed: " + (msg || "***"));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === "undefined" && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === "function") this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === "function") this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === "function") {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === "function") lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === "number") errStr = "Parse error on line " + (lexer.yylineno + 1) + ": ";
                            else errStr = "Parse error: ";
                            if (typeof lexer.showPosition === "function") errStr += "\n" + lexer.showPosition(69, 10) + "\n";
                            if (expected.length) errStr += "Expecting " + expected.join(", ") + ", got unexpected " + errSymbolDescr;
                            else errStr += "Unexpected " + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== "undefined") retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo("Parsing halted. No viable error recovery approach available due to internal system failure.", null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== "undefined") {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== "undefined") retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === "function" && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo("Parsing aborted due to exception.", ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== "undefined") retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, "name", {
                enumerable: false,
                writable: false,
                value: "JisonLexerError"
            });
            if (msg == null) msg = "???";
            Object.defineProperty(this, "message", {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty("captureStackTrace")) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, "stack", {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = "JisonLexerError";
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: "",
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: "",
            matched: "",
            matches: false,
            yytext: "",
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = "" + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf("\n") > 0 && msg.indexOf("^") > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === "function") {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += "\n";
                        msg += "\n  Erroneous area:\n" + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === "function") {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== "\n" && pos_str[0] !== "\n") msg += "\n" + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === "function") return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === "function") return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = "";
                if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": " + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput("", {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = "";
                this.yyleng = 0;
                this.match = "";
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === "number") rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || "";
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== "string") {
                    if (rv) this._input = "" + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === "\n") lines = true;
                else if (ch === "\r") {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === "\n") {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = "";
                    if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).", false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(-maxLines);
                past = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = "..." + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(0, maxLines);
                next = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + "...";
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, " ");
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, " ") + "\n" + c + "^";
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split("\n");
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(" ");
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ": " + line;
                    var errpfx = new Array(lineno_display_width + 1).join("^");
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join(".");
                        var mark = new Array(len).join("^");
                        rv += "\n" + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, " ");
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(" ") + "  (...continued...)";
                    intermediate_line += "\n" + new Array(lineno_display_width + 1).join("-") + "  (---------------)";
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join("\n");
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = "line " + l1 + ", ";
                    if (dc <= 1) rv += "column " + c1;
                    else rv += "columns " + c1 + " .. " + c2;
                } else rv = "lines " + l1 + "(column " + c1 + ") .. " + l2 + "(column " + c2 + ")";
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += " {String Offset: " + r1 + "}";
                    else rv += " {String Offset range: " + r1 + " .. " + r2 + "}";
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = "";
                        if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo("Internal lexer engine error" + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = "";
                    if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": Unrecognized text.", this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === "function") r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === "function" || typeof this.options.pre_lex === "function" || this.yy && typeof this.yy.pre_lex === "function" || this.yy && typeof this.yy.post_lex === "function" || typeof this.options.post_lex === "function" || typeof this.post_lex === "function") && typeof this.fastLex === "function"
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions["INITIAL"];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                "INITIAL": {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$c904d8a37e0c5236$export$8f49e4af10703ce3 = $c904d8a37e0c5236$var$parser;
$c904d8a37e0c5236$export$7acfa6ed01010e37 = $c904d8a37e0c5236$var$parser.Parser;
$c904d8a37e0c5236$export$98e6a39c04603d36 = function() {
    return $c904d8a37e0c5236$var$parser.parse.apply($c904d8a37e0c5236$var$parser, arguments);
};


var $3408a959153ab305$exports = {};
"use strict";
Object.defineProperty($3408a959153ab305$exports, "__esModule", {
    value: true
});
$3408a959153ab305$exports.flip = $3408a959153ab305$var$flip;
var $2e6cb5b6be4bd9bc$exports = {};
"use strict";
Object.defineProperty($2e6cb5b6be4bd9bc$exports, "__esModule", {
    value: true
});
var $226051f7e5a1867e$exports = {};
var $226051f7e5a1867e$var$conversions = {
    // length
    "px": {
        "px": 1,
        "cm": 96.0 / 2.54,
        "mm": 96.0 / 25.4,
        "in": 96,
        "pt": 96.0 / 72.0,
        "pc": 16
    },
    "cm": {
        "px": 2.54 / 96.0,
        "cm": 1,
        "mm": 0.1,
        "in": 2.54,
        "pt": 2.54 / 72.0,
        "pc": 2.54 / 6.0
    },
    "mm": {
        "px": 25.4 / 96.0,
        "cm": 10,
        "mm": 1,
        "in": 25.4,
        "pt": 25.4 / 72.0,
        "pc": 25.4 / 6.0
    },
    "in": {
        "px": 1.0 / 96.0,
        "cm": 1.0 / 2.54,
        "mm": 1.0 / 25.4,
        "in": 1,
        "pt": 1.0 / 72.0,
        "pc": 1.0 / 6.0
    },
    "pt": {
        "px": 0.75,
        "cm": 72.0 / 2.54,
        "mm": 72.0 / 25.4,
        "in": 72,
        "pt": 1,
        "pc": 12
    },
    "pc": {
        "px": 0.0625,
        "cm": 6.0 / 2.54,
        "mm": 6.0 / 25.4,
        "in": 6,
        "pt": 6.0 / 72.0,
        "pc": 1
    },
    // angle
    "deg": {
        "deg": 1,
        "grad": 0.9,
        "rad": 180 / Math.PI,
        "turn": 360
    },
    "grad": {
        "deg": 400 / 360,
        "grad": 1,
        "rad": 200 / Math.PI,
        "turn": 400
    },
    "rad": {
        "deg": Math.PI / 180,
        "grad": Math.PI / 200,
        "rad": 1,
        "turn": Math.PI * 2
    },
    "turn": {
        "deg": 1 / 360,
        "grad": 1 / 400,
        "rad": 0.5 / Math.PI,
        "turn": 1
    },
    // time
    "s": {
        "s": 1,
        "ms": 0.001
    },
    "ms": {
        "s": 1000,
        "ms": 1
    },
    // frequency
    "Hz": {
        "Hz": 1,
        "kHz": 1000
    },
    "kHz": {
        "Hz": 0.001,
        "kHz": 1
    },
    // resolution
    "dpi": {
        "dpi": 1,
        "dpcm": 1.0 / 2.54,
        "dppx": 1 / 96
    },
    "dpcm": {
        "dpi": 2.54,
        "dpcm": 1,
        "dppx": 2.54 / 96.0
    },
    "dppx": {
        "dpi": 96,
        "dpcm": 96.0 / 2.54,
        "dppx": 1
    }
};
$226051f7e5a1867e$exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$226051f7e5a1867e$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$226051f7e5a1867e$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    var converted = $226051f7e5a1867e$var$conversions[targetUnit][sourceUnit] * value;
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    return converted;
};


var $2e6cb5b6be4bd9bc$var$_cssUnitConverter2 = $2e6cb5b6be4bd9bc$var$_interopRequireDefault($226051f7e5a1867e$exports);
function $2e6cb5b6be4bd9bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2e6cb5b6be4bd9bc$var$convertNodes(left, right, precision) {
    switch(left.type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
            return $2e6cb5b6be4bd9bc$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $2e6cb5b6be4bd9bc$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $2e6cb5b6be4bd9bc$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
$2e6cb5b6be4bd9bc$exports.default = $2e6cb5b6be4bd9bc$var$convertNodes;
$2e6cb5b6be4bd9bc$exports = $2e6cb5b6be4bd9bc$exports["default"];


var $3408a959153ab305$var$_convert2 = $3408a959153ab305$var$_interopRequireDefault($2e6cb5b6be4bd9bc$exports);
function $3408a959153ab305$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3408a959153ab305$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $3408a959153ab305$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $3408a959153ab305$var$reduce(node.value, precision);
    return node;
}
function $3408a959153ab305$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $3408a959153ab305$var$isValueType(type) {
    switch(type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
        case "EmValue":
        case "ExValue":
        case "ChValue":
        case "RemValue":
        case "VhValue":
        case "VwValue":
        case "VminValue":
        case "VmaxValue":
        case "PercentageValue":
        case "Value":
            return true;
    }
    return false;
}
function $3408a959153ab305$var$convertMathExpression(node, precision) {
    var nodes = (0, $3408a959153ab305$var$_convert2.default)(node.left, node.right, precision);
    var left = $3408a959153ab305$var$reduce(nodes.left, precision);
    var right = $3408a959153ab305$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === "/" && right.operator === "*" || left.operator === "-" && right.operator === "+" || left.operator === "*" && right.operator === "/" || left.operator === "+" && right.operator === "-") {
            if ($3408a959153ab305$var$isEqual(left.right, right.right)) nodes = (0, $3408a959153ab305$var$_convert2.default)(left.left, right.left, precision);
            else if ($3408a959153ab305$var$isEqual(left.right, right.left)) nodes = (0, $3408a959153ab305$var$_convert2.default)(left.left, right.right, precision);
            left = $3408a959153ab305$var$reduce(nodes.left, precision);
            right = $3408a959153ab305$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $3408a959153ab305$var$flip(operator) {
    return operator === "+" ? "-" : "+";
}
function $3408a959153ab305$var$flipValue(node) {
    if ($3408a959153ab305$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == "MathExpression") {
        node.left = $3408a959153ab305$var$flipValue(node.left);
        node.right = $3408a959153ab305$var$flipValue(node.right);
    }
    return node;
}
function $3408a959153ab305$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === "CssVariable" || right.type === "CssVariable") return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $3408a959153ab305$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $3408a959153ab305$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($3408a959153ab305$var$isValueType(left.type) && (right.operator === "+" || right.operator === "-") && right.type === "MathExpression") {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $3408a959153ab305$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === "-" ? $3408a959153ab305$var$flip(right.operator) : right.operator;
            return $3408a959153ab305$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $3408a959153ab305$var$reduce({
                type: "MathExpression",
                operator: op === "-" ? $3408a959153ab305$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $3408a959153ab305$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === "MathExpression" && (left.operator === "+" || left.operator === "-") && $3408a959153ab305$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $3408a959153ab305$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $3408a959153ab305$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === "-") {
                node.right = $3408a959153ab305$var$reduce({
                    type: "MathExpression",
                    operator: op === "-" ? "+" : "-",
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === "-" ? "-" : "+";
            } else node.right = $3408a959153ab305$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === "-" ? "+" : "-";
            }
            return $3408a959153ab305$var$reduce(node, precision);
        }
    }
    return node;
}
function $3408a959153ab305$var$reduceDivisionExpression(node, precision) {
    if (!$3408a959153ab305$var$isValueType(node.right.type)) return node;
    if (node.right.type !== "Value") throw new Error('Cannot divide by "' + node.right.unit + '", number expected');
    if (node.right.value === 0) throw new Error("Cannot divide by zero");
    // (expr) / value
    if (node.left.type === "MathExpression") {
        if ($3408a959153ab305$var$isValueType(node.left.left.type) && $3408a959153ab305$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $3408a959153ab305$var$reduce(node.left, precision);
        }
        return node;
    } else if ($3408a959153ab305$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $3408a959153ab305$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === "MathExpression" && node.right.type === "Value") {
        if ($3408a959153ab305$var$isValueType(node.left.left.type) && $3408a959153ab305$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($3408a959153ab305$var$isValueType(node.left.type) && node.right.type === "Value") {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === "Value" && node.right.type === "MathExpression") {
        if ($3408a959153ab305$var$isValueType(node.right.left.type) && $3408a959153ab305$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === "Value" && $3408a959153ab305$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $3408a959153ab305$var$reduceMathExpression(node, precision) {
    node = $3408a959153ab305$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $3408a959153ab305$var$reduceAddSubExpression(node, precision);
        case "/":
            return $3408a959153ab305$var$reduceDivisionExpression(node, precision);
        case "*":
            return $3408a959153ab305$var$reduceMultiplicationExpression(node);
    }
    return node;
}
$3408a959153ab305$exports.default = $3408a959153ab305$var$reduce;


var $6e2d5ffef9bacf2c$var$_reducer2 = $6e2d5ffef9bacf2c$var$_interopRequireDefault($3408a959153ab305$exports);
var $69d4fde6ffca89ec$exports = {};
"use strict";
Object.defineProperty($69d4fde6ffca89ec$exports, "__esModule", {
    value: true
});
$69d4fde6ffca89ec$exports.default = function(calc, node, precision) {
    var str = $69d4fde6ffca89ec$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $69d4fde6ffca89ec$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $69d4fde6ffca89ec$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $69d4fde6ffca89ec$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === "MathExpression" && $69d4fde6ffca89ec$var$order[op] < $69d4fde6ffca89ec$var$order[left.operator]) str += "(" + $69d4fde6ffca89ec$var$stringify(left, prec) + ")";
            else str += $69d4fde6ffca89ec$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === "MathExpression" && $69d4fde6ffca89ec$var$order[op] < $69d4fde6ffca89ec$var$order[right.operator]) str += "(" + $69d4fde6ffca89ec$var$stringify(right, prec) + ")";
            else if (right.type === "MathExpression" && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $3408a959153ab305$exports.flip)(right.operator);
                str += $69d4fde6ffca89ec$var$stringify(right, prec);
            } else str += $69d4fde6ffca89ec$var$stringify(right, prec);
            return str;
        case "Value":
            return $69d4fde6ffca89ec$var$round(node.value, prec);
        case "CssVariable":
            if (node.fallback) return "var(" + node.value + ", " + $69d4fde6ffca89ec$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case "Calc":
            if (node.prefix) return "-" + node.prefix + "-calc(" + $69d4fde6ffca89ec$var$stringify(node.value, prec) + ")";
            return "calc(" + $69d4fde6ffca89ec$var$stringify(node.value, prec) + ")";
        default:
            return $69d4fde6ffca89ec$var$round(node.value, prec) + node.unit;
    }
}
$69d4fde6ffca89ec$exports = $69d4fde6ffca89ec$exports["default"];


var $6e2d5ffef9bacf2c$var$_stringifier2 = $6e2d5ffef9bacf2c$var$_interopRequireDefault($69d4fde6ffca89ec$exports);
function $6e2d5ffef9bacf2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $6e2d5ffef9bacf2c$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
$6e2d5ffef9bacf2c$exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $6e2d5ffef9bacf2c$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== "function" || !$6e2d5ffef9bacf2c$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $6e2d5ffef9bacf2c$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf("constant") >= 0 || contents.indexOf("env") >= 0) return;
        var ast = $c904d8a37e0c5236$export$8f49e4af10703ce3.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $6e2d5ffef9bacf2c$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = "word";
        node.value = (0, $6e2d5ffef9bacf2c$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
$6e2d5ffef9bacf2c$exports = $6e2d5ffef9bacf2c$exports["default"];




var $cc2a040df4551157$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $cc2a040df4551157$export$98f03c5d19621d70 = {
    isSsr: $cc2a040df4551157$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $cc2a040df4551157$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $cc2a040df4551157$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $cc2a040df4551157$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $45bc9796bb269564$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $45bc9796bb269564$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $45bc9796bb269564$var$_typeof(obj);
}
function $45bc9796bb269564$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $45bc9796bb269564$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $45bc9796bb269564$var$ownKeys(Object(source), !0).forEach(function(key) {
            $45bc9796bb269564$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $45bc9796bb269564$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $45bc9796bb269564$var$_defineProperty(obj, key, value) {
    key = $45bc9796bb269564$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $45bc9796bb269564$var$_toPropertyKey(arg) {
    var key = $45bc9796bb269564$var$_toPrimitive(arg, "string");
    return $45bc9796bb269564$var$_typeof(key) === "symbol" ? key : String(key);
}
function $45bc9796bb269564$var$_toPrimitive(input, hint) {
    if ($45bc9796bb269564$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($45bc9796bb269564$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $45bc9796bb269564$var$_toConsumableArray(arr) {
    return $45bc9796bb269564$var$_arrayWithoutHoles(arr) || $45bc9796bb269564$var$_iterableToArray(arr) || $45bc9796bb269564$var$_unsupportedIterableToArray(arr) || $45bc9796bb269564$var$_nonIterableSpread();
}
function $45bc9796bb269564$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $45bc9796bb269564$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $45bc9796bb269564$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $45bc9796bb269564$var$_arrayLikeToArray(o, minLen);
}
function $45bc9796bb269564$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $45bc9796bb269564$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $45bc9796bb269564$var$_arrayLikeToArray(arr);
}
function $45bc9796bb269564$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $45bc9796bb269564$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $45bc9796bb269564$var$MAX_CACHE_NUM = 2000;
var $45bc9796bb269564$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $45bc9796bb269564$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $45bc9796bb269564$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $45bc9796bb269564$var$autoCompleteStyle(name, value) {
    if ($45bc9796bb269564$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $45bc9796bb269564$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($45bc9796bb269564$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($45bc9796bb269564$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $45bc9796bb269564$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($45bc9796bb269564$var$camelToMiddleLine(s), ":").concat($45bc9796bb269564$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
var $45bc9796bb269564$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var str = "".concat(text);
    var styleString = $45bc9796bb269564$export$9a2c38fb88d8e30(style);
    var cacheKey = "".concat(str, "-").concat(styleString);
    if ($45bc9796bb269564$var$stringCache.widthCache[cacheKey]) return $45bc9796bb269564$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($45bc9796bb269564$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $45bc9796bb269564$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $45bc9796bb269564$var$_objectSpread($45bc9796bb269564$var$_objectSpread({}, $45bc9796bb269564$var$SPAN_STYLE), style);
        Object.keys(measurementSpanStyle).map(function(styleKey) {
            measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
            return styleKey;
        });
        measurementSpan.textContent = str;
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $45bc9796bb269564$var$stringCache.widthCache[cacheKey] = result;
        if (++$45bc9796bb269564$var$stringCache.cacheCount > $45bc9796bb269564$var$MAX_CACHE_NUM) {
            $45bc9796bb269564$var$stringCache.cacheCount = 0;
            $45bc9796bb269564$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $45bc9796bb269564$export$622cea445a1c5b7d = function getOffset(el) {
    var html = el.ownerDocument.documentElement;
    var box = {
        top: 0,
        left: 0
    };
    // If we don't have gBCR, just use 0,0 rather than error
    // BlackBerry 5, iOS 3 (original iPhone)
    if (typeof el.getBoundingClientRect !== "undefined") box = el.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset - html.clientTop,
        left: box.left + window.pageXOffset - html.clientLeft
    };
};
var $45bc9796bb269564$export$f209e6c32ad3d02e = function calculateChartCoordinate(event, offset) {
    return {
        chartX: Math.round(event.pageX - offset.left),
        chartY: Math.round(event.pageY - offset.top)
    };
};


var $8722da9ca6e7f376$var$_excluded = [
    "dx",
    "dy",
    "textAnchor",
    "verticalAnchor",
    "scaleToFit",
    "angle",
    "lineHeight",
    "capHeight",
    "className",
    "breakAll"
];
function $8722da9ca6e7f376$var$_extends() {
    $8722da9ca6e7f376$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8722da9ca6e7f376$var$_extends.apply(this, arguments);
}
function $8722da9ca6e7f376$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8722da9ca6e7f376$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8722da9ca6e7f376$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8722da9ca6e7f376$var$_slicedToArray(arr, i) {
    return $8722da9ca6e7f376$var$_arrayWithHoles(arr) || $8722da9ca6e7f376$var$_iterableToArrayLimit(arr, i) || $8722da9ca6e7f376$var$_unsupportedIterableToArray(arr, i) || $8722da9ca6e7f376$var$_nonIterableRest();
}
function $8722da9ca6e7f376$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8722da9ca6e7f376$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8722da9ca6e7f376$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8722da9ca6e7f376$var$_arrayLikeToArray(o, minLen);
}
function $8722da9ca6e7f376$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8722da9ca6e7f376$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $8722da9ca6e7f376$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8722da9ca6e7f376$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $8722da9ca6e7f376$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split($8722da9ca6e7f376$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $45bc9796bb269564$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $45bc9796bb269564$export$e5560531f057ad5d)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $8722da9ca6e7f376$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "…";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $8722da9ca6e7f376$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $8722da9ca6e7f376$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $8722da9ca6e7f376$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $8722da9ca6e7f376$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(children) ? children.toString().split($8722da9ca6e7f376$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $8722da9ca6e7f376$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $8722da9ca6e7f376$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $8722da9ca6e7f376$var$getWordsWithoutCalculate(children);
        return $8722da9ca6e7f376$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $8722da9ca6e7f376$var$getWordsWithoutCalculate(children);
};
var $8722da9ca6e7f376$var$textDefaultProps = {
    x: 0,
    y: 0,
    lineHeight: "1em",
    capHeight: "0.71em",
    // Magic number from d3
    scaleToFit: false,
    textAnchor: "start",
    verticalAnchor: "end",
    // Maintain compat with existing charts / default SVG behavior
    fill: "#808080"
};
var $8722da9ca6e7f376$export$5f1af8db9871e1d6 = function Text(props) {
    var wordsByLines = (0, $lDSNw.useMemo)(function() {
        return $8722da9ca6e7f376$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: props.scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        props.scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, textAnchor = props.textAnchor, verticalAnchor = props.verticalAnchor, scaleToFit = props.scaleToFit, angle = props.angle, lineHeight = props.lineHeight, capHeight = props.capHeight, className = props.className, breakAll = props.breakAll, textProps = $8722da9ca6e7f376$var$_objectWithoutProperties(props, $8722da9ca6e7f376$var$_excluded);
    if (!(0, $aee02c7eefa94d8b$export$402a499e1ea44294)(textProps.x) || !(0, $aee02c7eefa94d8b$export$402a499e1ea44294)(textProps.y)) return null;
    var x = textProps.x + ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = textProps.y + ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($6e2d5ffef9bacf2c$exports)))("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($6e2d5ffef9bacf2c$exports)))("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, (/*@__PURE__*/$parcel$interopDefault($6e2d5ffef9bacf2c$exports)))("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("text", $8722da9ca6e7f376$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-text", className),
        textAnchor: textAnchor,
        fill: textProps.fill.includes("url") ? $8722da9ca6e7f376$var$textDefaultProps.fill : textProps.fill
    }), wordsByLines.map(function(line, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
        }, line.words.join(breakAll ? "" : " ")));
    }));
};
$8722da9ca6e7f376$export$5f1af8db9871e1d6.defaultProps = $8722da9ca6e7f376$var$textDefaultProps;






var $lDSNw = parcelRequire("lDSNw");





function $8a059853790af0f6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8a059853790af0f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8a059853790af0f6$var$_typeof(obj);
}
function $8a059853790af0f6$var$_toConsumableArray(arr) {
    return $8a059853790af0f6$var$_arrayWithoutHoles(arr) || $8a059853790af0f6$var$_iterableToArray(arr) || $8a059853790af0f6$var$_unsupportedIterableToArray(arr) || $8a059853790af0f6$var$_nonIterableSpread();
}
function $8a059853790af0f6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8a059853790af0f6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8a059853790af0f6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8a059853790af0f6$var$_arrayLikeToArray(o, minLen);
}
function $8a059853790af0f6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8a059853790af0f6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8a059853790af0f6$var$_arrayLikeToArray(arr);
}
function $8a059853790af0f6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8a059853790af0f6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8a059853790af0f6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8a059853790af0f6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8a059853790af0f6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8a059853790af0f6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8a059853790af0f6$var$_defineProperty(obj, key, value) {
    key = $8a059853790af0f6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8a059853790af0f6$var$_toPropertyKey(arg) {
    var key = $8a059853790af0f6$var$_toPrimitive(arg, "string");
    return $8a059853790af0f6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8a059853790af0f6$var$_toPrimitive(input, hint) {
    if ($8a059853790af0f6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8a059853790af0f6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8a059853790af0f6$var$_extends() {
    $8a059853790af0f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8a059853790af0f6$var$_extends.apply(this, arguments);
}
var $8a059853790af0f6$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(formatter)) return formatter(label);
    return label;
};
var $8a059853790af0f6$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $8a059853790af0f6$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $8a059853790af0f6$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(labelProps.id) ? (0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("text", $8a059853790af0f6$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $8a059853790af0f6$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $8a059853790af0f6$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $8a059853790af0f6$var$_objectSpread($8a059853790af0f6$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $8a059853790af0f6$var$_objectSpread($8a059853790af0f6$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $8a059853790af0f6$var$_objectSpread($8a059853790af0f6$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $8a059853790af0f6$var$_objectSpread($8a059853790af0f6$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $8a059853790af0f6$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $8a059853790af0f6$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $8a059853790af0f6$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $8a059853790af0f6$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $8a059853790af0f6$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $8a059853790af0f6$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $8a059853790af0f6$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $8a059853790af0f6$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1e60876e846aca7c$exports)))(position) && ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(position.x) || (0, $aee02c7eefa94d8b$export$e50269385c77c348)(position.x)) && ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(position.y) || (0, $aee02c7eefa94d8b$export$e50269385c77c348)(position.y))) return $8a059853790af0f6$var$_objectSpread({
        x: x + (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $8a059853790af0f6$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $8a059853790af0f6$var$isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(viewBox.cx);
};
function $8a059853790af0f6$export$b04be29aa201d4f5(props) {
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(children) && !/*#__PURE__*/ (0, $lDSNw.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $lDSNw.isValidElement)(content)) return /*#__PURE__*/ (0, $lDSNw.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(content)) {
        label = /*#__PURE__*/ (0, $lDSNw.createElement)(content, props);
        if (/*#__PURE__*/ (0, $lDSNw.isValidElement)(label)) return label;
    } else label = $8a059853790af0f6$var$getLabel(props);
    var isPolarLabel = $8a059853790af0f6$var$isPolar(viewBox);
    var attrs = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $8a059853790af0f6$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $8a059853790af0f6$var$getAttrsOfPolarLabel(props) : $8a059853790af0f6$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8722da9ca6e7f376$export$5f1af8db9871e1d6), $8a059853790af0f6$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$8a059853790af0f6$export$b04be29aa201d4f5.displayName = "Label";
$8a059853790af0f6$export$b04be29aa201d4f5.defaultProps = {
    offset: 5
};
var $8a059853790af0f6$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(width) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(height)) {
        if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(x) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(top) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(x) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(cx) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $8a059853790af0f6$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($8a059853790af0f6$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $aee02c7eefa94d8b$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($8a059853790af0f6$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $lDSNw.isValidElement)(label)) {
        if (label.type === $8a059853790af0f6$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $lDSNw.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($8a059853790af0f6$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($8a059853790af0f6$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1e60876e846aca7c$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($8a059853790af0f6$export$b04be29aa201d4f5, $8a059853790af0f6$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $8a059853790af0f6$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $8a059853790af0f6$var$parseViewBox(parentProps);
    var explicitChildren = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, $8a059853790af0f6$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $lDSNw.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $8a059853790af0f6$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($8a059853790af0f6$var$_toConsumableArray(explicitChildren));
};
$8a059853790af0f6$export$b04be29aa201d4f5.parseViewBox = $8a059853790af0f6$var$parseViewBox;
$8a059853790af0f6$export$b04be29aa201d4f5.renderCallByParent = $8a059853790af0f6$var$renderCallByParent;





var $1a216a5b69c69121$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $1a216a5b69c69121$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$1a216a5b69c69121$exports = $1a216a5b69c69121$var$last;




var $lDSNw = parcelRequire("lDSNw");




function $0c2a2118f871337c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0c2a2118f871337c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0c2a2118f871337c$var$_typeof(obj);
}
var $0c2a2118f871337c$var$_excluded = [
    "data",
    "valueAccessor",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $0c2a2118f871337c$var$_toConsumableArray(arr) {
    return $0c2a2118f871337c$var$_arrayWithoutHoles(arr) || $0c2a2118f871337c$var$_iterableToArray(arr) || $0c2a2118f871337c$var$_unsupportedIterableToArray(arr) || $0c2a2118f871337c$var$_nonIterableSpread();
}
function $0c2a2118f871337c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c2a2118f871337c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0c2a2118f871337c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0c2a2118f871337c$var$_arrayLikeToArray(o, minLen);
}
function $0c2a2118f871337c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0c2a2118f871337c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0c2a2118f871337c$var$_arrayLikeToArray(arr);
}
function $0c2a2118f871337c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0c2a2118f871337c$var$_extends() {
    $0c2a2118f871337c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c2a2118f871337c$var$_extends.apply(this, arguments);
}
function $0c2a2118f871337c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0c2a2118f871337c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0c2a2118f871337c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0c2a2118f871337c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0c2a2118f871337c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0c2a2118f871337c$var$_defineProperty(obj, key, value) {
    key = $0c2a2118f871337c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0c2a2118f871337c$var$_toPropertyKey(arg) {
    var key = $0c2a2118f871337c$var$_toPrimitive(arg, "string");
    return $0c2a2118f871337c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0c2a2118f871337c$var$_toPrimitive(input, hint) {
    if ($0c2a2118f871337c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0c2a2118f871337c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0c2a2118f871337c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0c2a2118f871337c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0c2a2118f871337c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0c2a2118f871337c$var$defaultProps = {
    valueAccessor: function valueAccessor(entry) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($1a216a5b69c69121$exports)))(entry.value) : entry.value;
    }
};
function $0c2a2118f871337c$export$835fcf23ab7bf88(props) {
    var data = props.data, valueAccessor = props.valueAccessor, dataKey = props.dataKey, clockWise = props.clockWise, id = props.id, textBreakAll = props.textBreakAll, others = $0c2a2118f871337c$var$_objectWithoutProperties(props, $0c2a2118f871337c$var$_excluded);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8a059853790af0f6$export$b04be29aa201d4f5), $0c2a2118f871337c$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            index: index,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $8a059853790af0f6$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(clockWise) ? entry : $0c2a2118f871337c$var$_objectSpread($0c2a2118f871337c$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
        }));
    }));
}
$0c2a2118f871337c$export$835fcf23ab7bf88.displayName = "LabelList";
function $0c2a2118f871337c$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($0c2a2118f871337c$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($0c2a2118f871337c$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1e60876e846aca7c$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($0c2a2118f871337c$export$835fcf23ab7bf88, $0c2a2118f871337c$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $0c2a2118f871337c$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, $0c2a2118f871337c$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $lDSNw.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $0c2a2118f871337c$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($0c2a2118f871337c$var$_toConsumableArray(explicitChildren));
}
$0c2a2118f871337c$export$835fcf23ab7bf88.renderCallByParent = $0c2a2118f871337c$var$renderCallByParent;
$0c2a2118f871337c$export$835fcf23ab7bf88.defaultProps = $0c2a2118f871337c$var$defaultProps;








/* eslint no-console: 0 */ var $befee2dc5ecaf26b$var$isDev = false;
var $befee2dc5ecaf26b$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($befee2dc5ecaf26b$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



function $5aa5233e2c02a9d3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5aa5233e2c02a9d3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5aa5233e2c02a9d3$var$_typeof(obj);
}
function $5aa5233e2c02a9d3$var$_extends() {
    $5aa5233e2c02a9d3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5aa5233e2c02a9d3$var$_extends.apply(this, arguments);
}
function $5aa5233e2c02a9d3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5aa5233e2c02a9d3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5aa5233e2c02a9d3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5aa5233e2c02a9d3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5aa5233e2c02a9d3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5aa5233e2c02a9d3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5aa5233e2c02a9d3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5aa5233e2c02a9d3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5aa5233e2c02a9d3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5aa5233e2c02a9d3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5aa5233e2c02a9d3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5aa5233e2c02a9d3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5aa5233e2c02a9d3$var$_setPrototypeOf(subClass, superClass);
}
function $5aa5233e2c02a9d3$var$_setPrototypeOf(o, p) {
    $5aa5233e2c02a9d3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5aa5233e2c02a9d3$var$_setPrototypeOf(o, p);
}
function $5aa5233e2c02a9d3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5aa5233e2c02a9d3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5aa5233e2c02a9d3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5aa5233e2c02a9d3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5aa5233e2c02a9d3$var$_possibleConstructorReturn(this, result);
    };
}
function $5aa5233e2c02a9d3$var$_possibleConstructorReturn(self, call) {
    if (call && ($5aa5233e2c02a9d3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5aa5233e2c02a9d3$var$_assertThisInitialized(self);
}
function $5aa5233e2c02a9d3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5aa5233e2c02a9d3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5aa5233e2c02a9d3$var$_getPrototypeOf(o) {
    $5aa5233e2c02a9d3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5aa5233e2c02a9d3$var$_getPrototypeOf(o);
}
function $5aa5233e2c02a9d3$var$_defineProperty(obj, key, value) {
    key = $5aa5233e2c02a9d3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5aa5233e2c02a9d3$var$_toPropertyKey(arg) {
    var key = $5aa5233e2c02a9d3$var$_toPrimitive(arg, "string");
    return $5aa5233e2c02a9d3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5aa5233e2c02a9d3$var$_toPrimitive(input, hint) {
    if ($5aa5233e2c02a9d3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5aa5233e2c02a9d3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $5aa5233e2c02a9d3$export$2ae8800cf67c848c = /*#__PURE__*/ function(_PureComponent) {
    $5aa5233e2c02a9d3$var$_inherits(Pie, _PureComponent);
    var _super = $5aa5233e2c02a9d3$var$_createSuper(Pie);
    function Pie(props) {
        var _this;
        $5aa5233e2c02a9d3$var$_classCallCheck(this, Pie);
        _this = _super.call(this, props);
        $5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$var$_assertThisInitialized(_this), "pieRef", null);
        $5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$var$_assertThisInitialized(_this), "sectorRefs", []);
        $5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$var$_assertThisInitialized(_this), "id", (0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("recharts-pie-"));
        $5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    $5aa5233e2c02a9d3$var$_createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                var customLabelProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(label);
                var customLabelLineProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(labelLine);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({}, pieProps), entry), {}, {
                        stroke: "none"
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({}, pieProps), entry), {}, {
                        fill: "none",
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ],
                        key: "line"
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(valueKey)) realDataKey = "value";
                    else if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(dataKey)) realDataKey = valueKey;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                        key: "label-".concat(i)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps), Pie.renderLabelItem(label, labelProps, (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, realDataKey))));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = _this2.isActiveIndex(i) ? activeShape : inactiveShape;
                    var sectorProps = $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $5aa5233e2c02a9d3$var$_extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "sector-".concat(i) // eslint-disable-line react/no-array-index-key
                    }), Pie.renderSectorItem(sectorOptions, sectorProps));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $1f1c6c2214af1451$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(entry, "paddingAngle", 0) : 0;
                        if (prev) {
                            var angleIp = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case "ArrowLeft":
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case "ArrowRight":
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case "Escape":
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, (/*@__PURE__*/$parcel$interopDefault($accecf4f4d483c19$exports)))(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(cx) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(cy) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(innerRadius) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(outerRadius)) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-pie", className);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, $8a059853790af0f6$export$b04be29aa201d4f5).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, $0c2a2118f871337c$export$835fcf23ab7bf88).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return "start";
                if (x < cx) return "end";
                return "middle";
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) return option(props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1), $5aa5233e2c02a9d3$var$_extends({}, props, {
                    type: "linear",
                    className: "recharts-pie-label-line"
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                var label = value;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(label)) return label;
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8722da9ca6e7f376$export$5f1af8db9871e1d6), $5aa5233e2c02a9d3$var$_extends({}, props, {
                    alignmentBaseline: "middle",
                    className: "recharts-pie-label-text"
                }), label);
            }
        },
        {
            key: "renderSectorItem",
            value: function renderSectorItem(option, props) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) return option(props);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b9a99be29b3e5771$exports)))(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $6a5e9973c598b4e9$export$e98c2c7eb2b14f45), $5aa5233e2c02a9d3$var$_extends({
                    tabIndex: -1
                }, props, option));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $6a5e9973c598b4e9$export$e98c2c7eb2b14f45), $5aa5233e2c02a9d3$var$_extends({
                    tabIndex: -1
                }, props));
            }
        }
    ]);
    return Pie;
}((0, $lDSNw.PureComponent));
$5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$export$2ae8800cf67c848c, "displayName", "Pie");
$5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$export$2ae8800cf67c848c, "defaultProps", {
    stroke: "#fff",
    fill: "#808080",
    legendType: "rect",
    cx: "50%",
    cy: "50%",
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: "80%",
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: "ease",
    nameKey: "name",
    blendStroke: false
});
$5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$export$2ae8800cf67c848c, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
$5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$export$2ae8800cf67c848c, "getRealPieData", function(item) {
    var _item$props = item.props, data = _item$props.data, children = _item$props.children;
    var presentationProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(item.props);
    var cells = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $1a0af961fe314d4f$export$f6f0c3fe4ec306ea));
    if (data && data.length) return data.map(function(entry, index) {
        return $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
$5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$export$2ae8800cf67c848c, "parseCoordinateOfPie", function(item, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, $fb34ba651878b323$export$ad5c48602371adfa)(width, height);
    var cx = left + (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(item.props.cx, width, width / 2);
    var cy = top + (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(item.props.cy, height, height / 2);
    var innerRadius = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(item.props.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
$5aa5233e2c02a9d3$var$_defineProperty($5aa5233e2c02a9d3$export$2ae8800cf67c848c, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var pieData = $5aa5233e2c02a9d3$export$2ae8800cf67c848c.getRealPieData(item);
    if (!pieData || !pieData.length) return null;
    var _item$props2 = item.props, cornerRadius = _item$props2.cornerRadius, startAngle = _item$props2.startAngle, endAngle = _item$props2.endAngle, paddingAngle = _item$props2.paddingAngle, dataKey = _item$props2.dataKey, nameKey = _item$props2.nameKey, valueKey = _item$props2.valueKey, tooltipType = _item$props2.tooltipType;
    var minAngle = Math.abs(item.props.minAngle);
    var coordinate = $5aa5233e2c02a9d3$export$2ae8800cf67c848c.parseCoordinateOfPie(item, offset);
    var deltaAngle = $5aa5233e2c02a9d3$export$2ae8800cf67c848c.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(dataKey) && (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(valueKey)) {
        (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
        realDataKey = "value";
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(dataKey)) {
        (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, realDataKey, 0);
        return result + ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, realDataKey, 0);
            var name = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, nameKey, i);
            var percent = ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return $5aa5233e2c02a9d3$var$_objectSpread($5aa5233e2c02a9d3$var$_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

/**
 * @fileOverview Pie Chart
 */ var $c880f31ef4285855$exports = {};
var $610a1d6d8172f6b1$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $610a1d6d8172f6b1$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$610a1d6d8172f6b1$exports = $610a1d6d8172f6b1$var$arrayEvery;


var $c9231733feef23fc$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $c9231733feef23fc$var$baseEvery(collection, predicate) {
    var result = true;
    $c2b15ad98b6e43d3$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$c9231733feef23fc$exports = $c9231733feef23fc$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $c880f31ef4285855$var$every(collection, predicate, guard) {
    var func = $84ca1aa52314c546$exports(collection) ? $610a1d6d8172f6b1$exports : $c9231733feef23fc$exports;
    if (guard && $3a756535bab803ed$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $52c7c35fde7b0b7d$exports(predicate, 3));
}
$c880f31ef4285855$exports = $c880f31ef4285855$var$every;


var $383a22bbb40a25d5$exports = {};
var $1e6fea28cc5494d5$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $1e6fea28cc5494d5$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$842d4a0d91f878c6$exports(collection)) {
            var iteratee = $52c7c35fde7b0b7d$exports(predicate, 3);
            collection = $0ec295ae69d8df95$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$1e6fea28cc5494d5$exports = $1e6fea28cc5494d5$var$createFind;


var $507ae23bc596e25a$exports = {};


var $553a214ce2dddb14$exports = {};
var $f05b5bb275d33c44$exports = {};
var $fbd8a7db3b673b7b$exports = {};
var $6b38964ac83c2729$exports = {};
var $6e940245d40615df$exports = {};
/** Used to match a single whitespace character. */ var $6e940245d40615df$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6e940245d40615df$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6e940245d40615df$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$6e940245d40615df$exports = $6e940245d40615df$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $6b38964ac83c2729$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $6b38964ac83c2729$var$baseTrim(string) {
    return string ? string.slice(0, $6e940245d40615df$exports(string) + 1).replace($6b38964ac83c2729$var$reTrimStart, "") : string;
}
$6b38964ac83c2729$exports = $6b38964ac83c2729$var$baseTrim;




/** Used as references for various `Number` constants. */ var $fbd8a7db3b673b7b$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $fbd8a7db3b673b7b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $fbd8a7db3b673b7b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $fbd8a7db3b673b7b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $fbd8a7db3b673b7b$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $fbd8a7db3b673b7b$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($e7b08efe289d0f2f$exports(value)) return $fbd8a7db3b673b7b$var$NAN;
    if ($1e60876e846aca7c$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $1e60876e846aca7c$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $6b38964ac83c2729$exports(value);
    var isBinary = $fbd8a7db3b673b7b$var$reIsBinary.test(value);
    return isBinary || $fbd8a7db3b673b7b$var$reIsOctal.test(value) ? $fbd8a7db3b673b7b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $fbd8a7db3b673b7b$var$reIsBadHex.test(value) ? $fbd8a7db3b673b7b$var$NAN : +value;
}
$fbd8a7db3b673b7b$exports = $fbd8a7db3b673b7b$var$toNumber;


/** Used as references for various `Number` constants. */ var $f05b5bb275d33c44$var$INFINITY = 1 / 0, $f05b5bb275d33c44$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $f05b5bb275d33c44$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $fbd8a7db3b673b7b$exports(value);
    if (value === $f05b5bb275d33c44$var$INFINITY || value === -$f05b5bb275d33c44$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $f05b5bb275d33c44$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$f05b5bb275d33c44$exports = $f05b5bb275d33c44$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $553a214ce2dddb14$var$toInteger(value) {
    var result = $f05b5bb275d33c44$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$553a214ce2dddb14$exports = $553a214ce2dddb14$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $507ae23bc596e25a$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $507ae23bc596e25a$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $553a214ce2dddb14$exports(fromIndex);
    if (index < 0) index = $507ae23bc596e25a$var$nativeMax(length + index, 0);
    return $517bb4d11a6e6516$exports(array, $52c7c35fde7b0b7d$exports(predicate, 3), index);
}
$507ae23bc596e25a$exports = $507ae23bc596e25a$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $383a22bbb40a25d5$var$find = $1e6fea28cc5494d5$exports($507ae23bc596e25a$exports);
$383a22bbb40a25d5$exports = $383a22bbb40a25d5$var$find;



var $0f96fe226c12ba87$exports = {};
var $1007e42b3c091255$exports = {};

var $4732045a38bb53c1$exports = {};

var $50pTR = parcelRequire("50pTR");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $4732045a38bb53c1$var$now = function() {
    return $50pTR.Date.now();
};
$4732045a38bb53c1$exports = $4732045a38bb53c1$var$now;



/** Error message constants. */ var $1007e42b3c091255$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1007e42b3c091255$var$nativeMax = Math.max, $1007e42b3c091255$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1007e42b3c091255$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($1007e42b3c091255$var$FUNC_ERROR_TEXT);
    wait = $fbd8a7db3b673b7b$exports(wait) || 0;
    if ($1e60876e846aca7c$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $1007e42b3c091255$var$nativeMax($fbd8a7db3b673b7b$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $1007e42b3c091255$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $4732045a38bb53c1$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($4732045a38bb53c1$exports());
    }
    function debounced() {
        var time = $4732045a38bb53c1$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$1007e42b3c091255$exports = $1007e42b3c091255$var$debounce;



/** Error message constants. */ var $0f96fe226c12ba87$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $0f96fe226c12ba87$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($0f96fe226c12ba87$var$FUNC_ERROR_TEXT);
    if ($1e60876e846aca7c$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $1007e42b3c091255$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$0f96fe226c12ba87$exports = $0f96fe226c12ba87$var$throttle;




var $a21dbcbc31c2551f$exports = {};
var $056e8caabe9bafc9$exports = {};
var $6c28bd9c5e8db472$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6c28bd9c5e8db472$var$nativeCeil = Math.ceil, $6c28bd9c5e8db472$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $6c28bd9c5e8db472$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $6c28bd9c5e8db472$var$nativeMax($6c28bd9c5e8db472$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$6c28bd9c5e8db472$exports = $6c28bd9c5e8db472$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $056e8caabe9bafc9$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $3a756535bab803ed$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $f05b5bb275d33c44$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $f05b5bb275d33c44$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $f05b5bb275d33c44$exports(step);
        return $6c28bd9c5e8db472$exports(start, end, step, fromRight);
    };
}
$056e8caabe9bafc9$exports = $056e8caabe9bafc9$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $a21dbcbc31c2551f$var$range = $056e8caabe9bafc9$exports();
$a21dbcbc31c2551f$exports = $a21dbcbc31c2551f$var$range;



var $91585826593d324b$exports = {};


/** `Object#toString` result references. */ var $91585826593d324b$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $91585826593d324b$var$isBoolean(value) {
    return value === true || value === false || $c7f0e95f7b8234dc$exports(value) && $381d490267e538c0$exports(value) == $91585826593d324b$var$boolTag;
}
$91585826593d324b$exports = $91585826593d324b$var$isBoolean;




var $lDSNw = parcelRequire("lDSNw");





/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $b051f00980c9ed83$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}



var $65ffb5bd58ae1668$exports = {};
var $0317a6720f6cfe40$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0317a6720f6cfe40$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $eebc8199e29d4fa6$exports) $eebc8199e29d4fa6$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$0317a6720f6cfe40$exports = $0317a6720f6cfe40$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $65ffb5bd58ae1668$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $52c7c35fde7b0b7d$exports(iteratee, 3);
    $a77c320a217cd25e$exports(object, function(value, key, object) {
        $0317a6720f6cfe40$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$65ffb5bd58ae1668$exports = $65ffb5bd58ae1668$var$mapValues;










var $lDSNw = parcelRequire("lDSNw");



var $lDSNw = parcelRequire("lDSNw");



function $084ca05f02b53339$var$_extends() {
    $084ca05f02b53339$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $084ca05f02b53339$var$_extends.apply(this, arguments);
}
function $084ca05f02b53339$var$_slicedToArray(arr, i) {
    return $084ca05f02b53339$var$_arrayWithHoles(arr) || $084ca05f02b53339$var$_iterableToArrayLimit(arr, i) || $084ca05f02b53339$var$_unsupportedIterableToArray(arr, i) || $084ca05f02b53339$var$_nonIterableRest();
}
function $084ca05f02b53339$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $084ca05f02b53339$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $084ca05f02b53339$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $084ca05f02b53339$var$_arrayLikeToArray(o, minLen);
}
function $084ca05f02b53339$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $084ca05f02b53339$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $084ca05f02b53339$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $084ca05f02b53339$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $084ca05f02b53339$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $084ca05f02b53339$export$4617fb02663045ef = function Rectangle(props) {
    var pathRef = (0, $lDSNw.useRef)();
    var _useState = (0, $lDSNw.useState)(-1), _useState2 = $084ca05f02b53339$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $lDSNw.useLayoutEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $084ca05f02b53339$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $084ca05f02b53339$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $1f1c6c2214af1451$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $1f1c6c2214af1451$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $084ca05f02b53339$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $084ca05f02b53339$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};
$084ca05f02b53339$export$4617fb02663045ef.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};











var $6ecebb08067248a7$var$_excluded = [
    "value",
    "background"
];
function $6ecebb08067248a7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6ecebb08067248a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6ecebb08067248a7$var$_typeof(obj);
}
function $6ecebb08067248a7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6ecebb08067248a7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6ecebb08067248a7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6ecebb08067248a7$var$_extends() {
    $6ecebb08067248a7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ecebb08067248a7$var$_extends.apply(this, arguments);
}
function $6ecebb08067248a7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ecebb08067248a7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ecebb08067248a7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6ecebb08067248a7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ecebb08067248a7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ecebb08067248a7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6ecebb08067248a7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6ecebb08067248a7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6ecebb08067248a7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6ecebb08067248a7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6ecebb08067248a7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6ecebb08067248a7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6ecebb08067248a7$var$_setPrototypeOf(subClass, superClass);
}
function $6ecebb08067248a7$var$_setPrototypeOf(o, p) {
    $6ecebb08067248a7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6ecebb08067248a7$var$_setPrototypeOf(o, p);
}
function $6ecebb08067248a7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6ecebb08067248a7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6ecebb08067248a7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6ecebb08067248a7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6ecebb08067248a7$var$_possibleConstructorReturn(this, result);
    };
}
function $6ecebb08067248a7$var$_possibleConstructorReturn(self, call) {
    if (call && ($6ecebb08067248a7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6ecebb08067248a7$var$_assertThisInitialized(self);
}
function $6ecebb08067248a7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6ecebb08067248a7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6ecebb08067248a7$var$_getPrototypeOf(o) {
    $6ecebb08067248a7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6ecebb08067248a7$var$_getPrototypeOf(o);
}
function $6ecebb08067248a7$var$_defineProperty(obj, key, value) {
    key = $6ecebb08067248a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ecebb08067248a7$var$_toPropertyKey(arg) {
    var key = $6ecebb08067248a7$var$_toPrimitive(arg, "string");
    return $6ecebb08067248a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6ecebb08067248a7$var$_toPrimitive(input, hint) {
    if ($6ecebb08067248a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6ecebb08067248a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6ecebb08067248a7$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $6ecebb08067248a7$var$_inherits(Bar, _PureComponent);
    var _super = $6ecebb08067248a7$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $6ecebb08067248a7$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $6ecebb08067248a7$var$_defineProperty($6ecebb08067248a7$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $6ecebb08067248a7$var$_defineProperty($6ecebb08067248a7$var$_assertThisInitialized(_this), "id", (0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("recharts-bar-"));
        $6ecebb08067248a7$var$_defineProperty($6ecebb08067248a7$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $6ecebb08067248a7$var$_defineProperty($6ecebb08067248a7$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $6ecebb08067248a7$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var shape = this.props.shape;
                var baseProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                return data && data.map(function(entry, i) {
                    var props = $6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread({}, baseProps), entry), {}, {
                        index: i
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $6ecebb08067248a7$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
                    }), Bar.renderRectangle(shape, props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props = this.props, data = _this$props.data, layout = _this$props.layout, isAnimationActive = _this$props.isAnimationActive, animationBegin = _this$props.animationBegin, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, animationId = _this$props.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $1f1c6c2214af1451$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props2 = this.props, data = _this$props2.data, isAnimationActive = _this$props2.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($accecf4f4d483c19$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var data = this.props.data;
                var backgroundProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $6ecebb08067248a7$var$_objectWithoutProperties(entry, $6ecebb08067248a7$var$_excluded);
                    if (!background) return null;
                    var props = $6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        index: i,
                        key: "background-bar-".concat(i),
                        className: "recharts-bar-background-rectangle"
                    });
                    return Bar.renderRectangle(_this4.props.background, props);
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props3 = this.props, data = _this$props3.data, xAxis = _this$props3.xAxis, yAxis = _this$props3.yAxis, layout = _this$props3.layout, children = _this$props3.children;
                var errorBarItems = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $2f8a30b541520345$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(item, {
                        key: "error-bar-".concat(i),
                        // eslint-disable-line react/no-array-index-key
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, hide = _this$props4.hide, data = _this$props4.data, className = _this$props4.className, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, left = _this$props4.left, top = _this$props4.top, width = _this$props4.width, height = _this$props4.height, isAnimationActive = _this$props4.isAnimationActive, background = _this$props4.background, id = _this$props4.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $0c2a2118f871337c$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        },
        {
            key: "renderRectangle",
            value: function renderRectangle(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) rectangle = option(props);
                else rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $084ca05f02b53339$export$4617fb02663045ef), props);
                return rectangle;
            }
        }
    ]);
    return Bar;
}((0, $lDSNw.PureComponent));
$6ecebb08067248a7$var$_defineProperty($6ecebb08067248a7$export$bbc6c6369b38e3d1, "displayName", "Bar");
$6ecebb08067248a7$var$_defineProperty($6ecebb08067248a7$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    // data of bar
    data: [],
    layout: "vertical",
    isAnimationActive: !(0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $6ecebb08067248a7$var$_defineProperty($6ecebb08067248a7$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $ecbafd4b4677e0ac$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $ecbafd4b4677e0ac$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $1a0af961fe314d4f$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $ecbafd4b4677e0ac$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, dataKey);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $ecbafd4b4677e0ac$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $ecbafd4b4677e0ac$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread($6ecebb08067248a7$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $ecbafd4b4677e0ac$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $6ecebb08067248a7$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $28de3275627d2ded$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $28de3275627d2ded$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $28de3275627d2ded$var$_typeof(obj);
}
function $28de3275627d2ded$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $28de3275627d2ded$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $28de3275627d2ded$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $28de3275627d2ded$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $28de3275627d2ded$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $28de3275627d2ded$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $28de3275627d2ded$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $28de3275627d2ded$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $28de3275627d2ded$var$ownKeys(Object(source), !0).forEach(function(key) {
            $28de3275627d2ded$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $28de3275627d2ded$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $28de3275627d2ded$var$_defineProperty(obj, key, value) {
    key = $28de3275627d2ded$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $28de3275627d2ded$var$_toPropertyKey(arg) {
    var key = $28de3275627d2ded$var$_toPrimitive(arg, "string");
    return $28de3275627d2ded$var$_typeof(key) === "symbol" ? key : String(key);
}
function $28de3275627d2ded$var$_toPrimitive(input, hint) {
    if ($28de3275627d2ded$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($28de3275627d2ded$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $28de3275627d2ded$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $6ecebb08067248a7$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
            if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === "no-gap") {
                var gap = (0, $aee02c7eefa94d8b$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $ecbafd4b4677e0ac$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $ecbafd4b4677e0ac$export$9d80152e23bae434)(scale);
        var ticks = (0, $ecbafd4b4677e0ac$export$ac086aaa4358d590)(scale, $28de3275627d2ded$var$_objectSpread($28de3275627d2ded$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $28de3275627d2ded$var$_objectSpread($28de3275627d2ded$var$_objectSpread($28de3275627d2ded$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $ecbafd4b4677e0ac$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $28de3275627d2ded$var$_objectSpread($28de3275627d2ded$var$_objectSpread({}, result), {}, $28de3275627d2ded$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $28de3275627d2ded$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $28de3275627d2ded$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $28de3275627d2ded$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $28de3275627d2ded$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $28de3275627d2ded$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $28de3275627d2ded$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$28de3275627d2ded$var$_defineProperty($28de3275627d2ded$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $28de3275627d2ded$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $28de3275627d2ded$var$_objectSpread($28de3275627d2ded$var$_objectSpread({}, res), {}, $28de3275627d2ded$var$_defineProperty({}, key, $28de3275627d2ded$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $28de3275627d2ded$var$_objectSpread($28de3275627d2ded$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($65ffb5bd58ae1668$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($c880f31ef4285855$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $28de3275627d2ded$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $28de3275627d2ded$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $28de3275627d2ded$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


function $54d564eb55c7ddd8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $54d564eb55c7ddd8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $54d564eb55c7ddd8$var$_typeof(obj);
}
function $54d564eb55c7ddd8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54d564eb55c7ddd8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $54d564eb55c7ddd8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $54d564eb55c7ddd8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $54d564eb55c7ddd8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $54d564eb55c7ddd8$var$_defineProperty(obj, key, value) {
    key = $54d564eb55c7ddd8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $54d564eb55c7ddd8$var$_toPropertyKey(arg) {
    var key = $54d564eb55c7ddd8$var$_toPrimitive(arg, "string");
    return $54d564eb55c7ddd8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $54d564eb55c7ddd8$var$_toPrimitive(input, hint) {
    if ($54d564eb55c7ddd8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($54d564eb55c7ddd8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $54d564eb55c7ddd8$export$8d7cd2cadfe08ccd(ticks) {
    var N = 1;
    var previous = (0, $b051f00980c9ed83$export$41514b9f058a6886)(ticks, N, function(tickItem) {
        return tickItem.isShow;
    });
    while(N <= ticks.length){
        if (previous !== undefined) return previous;
        N++;
        previous = (0, $b051f00980c9ed83$export$41514b9f058a6886)(ticks, N, function(tickItem) {
            return tickItem.isShow;
        });
    }
    return ticks.slice(0, 1);
}
function $54d564eb55c7ddd8$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $b051f00980c9ed83$export$41514b9f058a6886)(ticks, interval + 1);
}
function $54d564eb55c7ddd8$var$getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $28de3275627d2ded$export$3ee78d51cffc2b68)(size, angle);
}
function $54d564eb55c7ddd8$var$getTicksEnd(_ref) {
    var angle = _ref.angle, ticks = _ref.ticks, tickFormatter = _ref.tickFormatter, viewBox = _ref.viewBox, orientation = _ref.orientation, minTickGap = _ref.minTickGap, unit = _ref.unit, fontSize = _ref.fontSize, letterSpacing = _ref.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === "width" ? (0, $45bc9796bb269564$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var result = (ticks || []).slice();
    var len = result.length;
    var sign = len >= 2 ? (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === "width" ? x : y;
        end = sizeKey === "width" ? x + width : y + height;
    } else {
        start = sizeKey === "width" ? x + width : y + height;
        end = sizeKey === "width" ? x : y;
    }
    for(var i = len - 1; i >= 0; i--){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
        // Recharts only supports angles when sizeKey === 'width'
        var size = sizeKey === "width" ? $54d564eb55c7ddd8$var$getAngledTickWidth((0, $45bc9796bb269564$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $45bc9796bb269564$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * size / 2 - end);
            result[i] = entry = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            end = entry.tickCoord - sign * (size / 2 + minTickGap);
            result[i] = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $54d564eb55c7ddd8$var$getTicksStart(_ref2, preserveEnd) {
    var angle = _ref2.angle, ticks = _ref2.ticks, tickFormatter = _ref2.tickFormatter, viewBox = _ref2.viewBox, orientation = _ref2.orientation, minTickGap = _ref2.minTickGap, unit = _ref2.unit, fontSize = _ref2.fontSize, letterSpacing = _ref2.letterSpacing;
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var result = (ticks || []).slice();
    // we need add the width of 'unit' only when sizeKey === 'width'
    var unitSize = unit && sizeKey === "width" ? (0, $45bc9796bb269564$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var len = result.length;
    var sign = len >= 2 ? (0, $aee02c7eefa94d8b$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
    var start, end;
    if (sign === 1) {
        start = sizeKey === "width" ? x : y;
        end = sizeKey === "width" ? x + width : y + height;
    } else {
        start = sizeKey === "width" ? x + width : y + height;
        end = sizeKey === "width" ? x : y;
    }
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
        // Recharts only supports angles when sizeKey === 'width'
        var tailSize = sizeKey === "width" ? $54d564eb55c7ddd8$var$getAngledTickWidth((0, $45bc9796bb269564$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $45bc9796bb269564$export$e5560531f057ad5d)(tailContent, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    for(var i = 0; i < count; i++){
        var entry = result[i];
        var content = (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
        var size = sizeKey === "width" ? $54d564eb55c7ddd8$var$getAngledTickWidth((0, $45bc9796bb269564$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $45bc9796bb269564$export$e5560531f057ad5d)(content, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * size / 2 - start);
            result[i] = entry = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
        if (isShow) {
            start = entry.tickCoord + sign * (size / 2 + minTickGap);
            result[i] = $54d564eb55c7ddd8$var$_objectSpread($54d564eb55c7ddd8$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    }
    return result;
}
function $54d564eb55c7ddd8$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(interval) || (0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr) return $54d564eb55c7ddd8$export$beeebbe3ff1b306b(ticks, typeof interval === "number" && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    if (interval === "equidistantPreserveStart") {
        candidates = $54d564eb55c7ddd8$var$getTicksStart({
            angle: angle,
            ticks: ticks,
            tickFormatter: tickFormatter,
            viewBox: viewBox,
            orientation: orientation,
            minTickGap: minTickGap,
            unit: unit,
            fontSize: fontSize,
            letterSpacing: letterSpacing
        });
        return $54d564eb55c7ddd8$export$8d7cd2cadfe08ccd(candidates);
    }
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = $54d564eb55c7ddd8$var$getTicksStart({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }, interval === "preserveStartEnd");
    else candidates = $54d564eb55c7ddd8$var$getTicksEnd({
        angle: angle,
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit,
        fontSize: fontSize,
        letterSpacing: letterSpacing
    });
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}








var $lDSNw = parcelRequire("lDSNw");






var $lDSNw = parcelRequire("lDSNw");


/**
 * @fileOverview Default Tooltip Content
 */ function $c0178cac85c40f45$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c0178cac85c40f45$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c0178cac85c40f45$var$_typeof(obj);
}
function $c0178cac85c40f45$var$_slicedToArray(arr, i) {
    return $c0178cac85c40f45$var$_arrayWithHoles(arr) || $c0178cac85c40f45$var$_iterableToArrayLimit(arr, i) || $c0178cac85c40f45$var$_unsupportedIterableToArray(arr, i) || $c0178cac85c40f45$var$_nonIterableRest();
}
function $c0178cac85c40f45$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0178cac85c40f45$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0178cac85c40f45$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0178cac85c40f45$var$_arrayLikeToArray(o, minLen);
}
function $c0178cac85c40f45$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0178cac85c40f45$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c0178cac85c40f45$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c0178cac85c40f45$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c0178cac85c40f45$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c0178cac85c40f45$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c0178cac85c40f45$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c0178cac85c40f45$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c0178cac85c40f45$var$_defineProperty(obj, key, value) {
    key = $c0178cac85c40f45$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0178cac85c40f45$var$_toPropertyKey(arg) {
    var key = $c0178cac85c40f45$var$_toPrimitive(arg, "string");
    return $c0178cac85c40f45$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c0178cac85c40f45$var$_toPrimitive(input, hint) {
    if ($c0178cac85c40f45$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c0178cac85c40f45$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c0178cac85c40f45$var$defaultFormatter(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(value) && (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(value[0]) && (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $c0178cac85c40f45$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($768d47a24ee3d1c4$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = $c0178cac85c40f45$var$_objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $c0178cac85c40f45$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $c0178cac85c40f45$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $c0178cac85c40f45$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = $c0178cac85c40f45$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};




function $deb1267103fb31f8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $deb1267103fb31f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $deb1267103fb31f8$var$_typeof(obj);
}
function $deb1267103fb31f8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $deb1267103fb31f8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $deb1267103fb31f8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $deb1267103fb31f8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $deb1267103fb31f8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $deb1267103fb31f8$var$_defineProperty(obj, key, value) {
    key = $deb1267103fb31f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $deb1267103fb31f8$var$_toPropertyKey(arg) {
    var key = $deb1267103fb31f8$var$_toPrimitive(arg, "string");
    return $deb1267103fb31f8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $deb1267103fb31f8$var$_toPrimitive(input, hint) {
    if ($deb1267103fb31f8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($deb1267103fb31f8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $deb1267103fb31f8$var$_slicedToArray(arr, i) {
    return $deb1267103fb31f8$var$_arrayWithHoles(arr) || $deb1267103fb31f8$var$_iterableToArrayLimit(arr, i) || $deb1267103fb31f8$var$_unsupportedIterableToArray(arr, i) || $deb1267103fb31f8$var$_nonIterableRest();
}
function $deb1267103fb31f8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $deb1267103fb31f8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $deb1267103fb31f8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $deb1267103fb31f8$var$_arrayLikeToArray(o, minLen);
}
function $deb1267103fb31f8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $deb1267103fb31f8$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $deb1267103fb31f8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $deb1267103fb31f8$var$CLS_PREFIX = "recharts-tooltip-wrapper";
var $deb1267103fb31f8$var$EPS = 1;
function $deb1267103fb31f8$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $deb1267103fb31f8$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($78a3e0804befecf2$exports)))(payload, $deb1267103fb31f8$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($78a3e0804befecf2$exports)))(payload, option);
    return payload;
}
function $deb1267103fb31f8$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $c0178cac85c40f45$export$6fe33945eebf9ac8), props);
}
var $deb1267103fb31f8$var$tooltipDefaultProps = {
    active: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    reverseDirection: {
        x: false,
        y: false
    },
    offset: 10,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    coordinate: {
        x: 0,
        y: 0
    },
    // this doesn't exist on TooltipProps
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    cursorStyle: {},
    separator: " : ",
    wrapperStyle: {},
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
    cursor: true,
    trigger: "hover",
    isAnimationActive: !(0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr,
    animationEasing: "ease",
    animationDuration: 400,
    filterNull: true,
    useTranslate3d: false
};
var $deb1267103fb31f8$export$28c660c63b792dea = function Tooltip(props) {
    var _classNames;
    var _useState = (0, $lDSNw.useState)(-1), _useState2 = $deb1267103fb31f8$var$_slicedToArray(_useState, 2), boxWidth = _useState2[0], setBoxWidth = _useState2[1];
    var _useState3 = (0, $lDSNw.useState)(-1), _useState4 = $deb1267103fb31f8$var$_slicedToArray(_useState3, 2), boxHeight = _useState4[0], setBoxHeight = _useState4[1];
    var _useState5 = (0, $lDSNw.useState)(false), _useState6 = $deb1267103fb31f8$var$_slicedToArray(_useState5, 2), dismissed = _useState6[0], setDismissed = _useState6[1];
    var _useState7 = (0, $lDSNw.useState)({
        x: 0,
        y: 0
    }), _useState8 = $deb1267103fb31f8$var$_slicedToArray(_useState7, 2), dismissedAtCoordinate = _useState8[0], setDismissedAtCoordinate = _useState8[1];
    var wrapperNode = (0, $lDSNw.useRef)();
    var allowEscapeViewBox = props.allowEscapeViewBox, reverseDirection = props.reverseDirection, coordinate = props.coordinate, offset = props.offset, position = props.position, viewBox = props.viewBox;
    var handleKeyDown = (0, $lDSNw.useCallback)(function(event) {
        if (event.key === "Escape") {
            setDismissed(true);
            setDismissedAtCoordinate(function(prev) {
                return $deb1267103fb31f8$var$_objectSpread($deb1267103fb31f8$var$_objectSpread({}, prev), {}, {
                    x: coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
                    y: coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
                });
            });
        }
    }, [
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.x,
        coordinate === null || coordinate === void 0 ? void 0 : coordinate.y
    ]);
    (0, $lDSNw.useEffect)(function() {
        var updateBBox = function updateBBox() {
            if (dismissed) {
                document.removeEventListener("keydown", handleKeyDown);
                if ((coordinate === null || coordinate === void 0 ? void 0 : coordinate.x) !== dismissedAtCoordinate.x || (coordinate === null || coordinate === void 0 ? void 0 : coordinate.y) !== dismissedAtCoordinate.y) setDismissed(false);
            } else document.addEventListener("keydown", handleKeyDown);
            if (wrapperNode.current && wrapperNode.current.getBoundingClientRect) {
                var box = wrapperNode.current.getBoundingClientRect();
                if (Math.abs(box.width - boxWidth) > $deb1267103fb31f8$var$EPS || Math.abs(box.height - boxHeight) > $deb1267103fb31f8$var$EPS) {
                    setBoxWidth(box.width);
                    setBoxHeight(box.height);
                }
            } else if (boxWidth !== -1 || boxHeight !== -1) {
                setBoxWidth(-1);
                setBoxHeight(-1);
            }
        };
        updateBBox();
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        boxHeight,
        boxWidth,
        coordinate,
        dismissed,
        dismissedAtCoordinate.x,
        dismissedAtCoordinate.y,
        handleKeyDown
    ]);
    var getTranslate = function getTranslate(_ref) {
        var key = _ref.key, tooltipDimension = _ref.tooltipDimension, viewBoxDimension = _ref.viewBoxDimension;
        if (position && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(position[key])) return position[key];
        var negative = coordinate[key] - tooltipDimension - offset;
        var positive = coordinate[key] + offset;
        if (allowEscapeViewBox !== null && allowEscapeViewBox !== void 0 && allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
        if (reverseDirection !== null && reverseDirection !== void 0 && reverseDirection[key]) {
            var _tooltipBoundary = negative;
            var _viewBoxBoundary = viewBox[key];
            if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
            return Math.max(negative, viewBox[key]);
        }
        var tooltipBoundary = positive + tooltipDimension;
        var viewBoxBoundary = viewBox[key] + viewBoxDimension;
        if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
        return Math.max(positive, viewBox[key]);
    };
    var payload = props.payload, payloadUniqBy = props.payloadUniqBy, filterNull = props.filterNull, active = props.active, wrapperStyle = props.wrapperStyle, useTranslate3d = props.useTranslate3d, isAnimationActive = props.isAnimationActive, animationDuration = props.animationDuration, animationEasing = props.animationEasing;
    var finalPayload = $deb1267103fb31f8$var$getUniqPayload(payloadUniqBy, filterNull && payload && payload.length ? payload.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(entry.value);
    }) : payload);
    var hasPayload = finalPayload && finalPayload.length;
    var content = props.content;
    var outerStyle = $deb1267103fb31f8$var$_objectSpread({
        pointerEvents: "none",
        visibility: !dismissed && active && hasPayload ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
    }, wrapperStyle);
    var translateX, translateY;
    if (position && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(position.x) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(position.y)) {
        translateX = position.x;
        translateY = position.y;
    } else if (boxWidth > 0 && boxHeight > 0 && coordinate) {
        translateX = getTranslate({
            key: "x",
            tooltipDimension: boxWidth,
            viewBoxDimension: viewBox.width
        });
        translateY = getTranslate({
            key: "y",
            tooltipDimension: boxHeight,
            viewBoxDimension: viewBox.height
        });
    } else outerStyle.visibility = "hidden";
    outerStyle = $deb1267103fb31f8$var$_objectSpread($deb1267103fb31f8$var$_objectSpread({}, (0, $7f91566aef852dee$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    })), outerStyle);
    if (isAnimationActive && active) outerStyle = $deb1267103fb31f8$var$_objectSpread($deb1267103fb31f8$var$_objectSpread({}, (0, $7f91566aef852dee$export$ff9926a5d1daa67c)({
        transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
    })), outerStyle);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))($deb1267103fb31f8$var$CLS_PREFIX, (_classNames = {}, $deb1267103fb31f8$var$_defineProperty(_classNames, "".concat($deb1267103fb31f8$var$CLS_PREFIX, "-right"), (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $deb1267103fb31f8$var$_defineProperty(_classNames, "".concat($deb1267103fb31f8$var$CLS_PREFIX, "-left"), (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $deb1267103fb31f8$var$_defineProperty(_classNames, "".concat($deb1267103fb31f8$var$CLS_PREFIX, "-bottom"), (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $deb1267103fb31f8$var$_defineProperty(_classNames, "".concat($deb1267103fb31f8$var$CLS_PREFIX, "-top"), (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _classNames));
    return(/*#__PURE__*/ // ESLint is disabled to allow listening to the `Escape` key. Refer to
    // https://github.com/recharts/recharts/pull/2925
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", {
        tabIndex: -1,
        role: "dialog",
        className: cls,
        style: outerStyle,
        ref: wrapperNode
    }, $deb1267103fb31f8$var$renderContent(content, $deb1267103fb31f8$var$_objectSpread($deb1267103fb31f8$var$_objectSpread({}, props), {}, {
        payload: finalPayload
    }))));
};
// needs to be set so that renderByOrder can find the correct handler function
$deb1267103fb31f8$export$28c660c63b792dea.displayName = "Tooltip";
/**
 * needs to be set so that renderByOrder can access an have default values for
 * children.props when there are no props set by the consumer
 * doesn't work if using default parameters
 */ $deb1267103fb31f8$export$28c660c63b792dea.defaultProps = $deb1267103fb31f8$var$tooltipDefaultProps;





var $lDSNw = parcelRequire("lDSNw");



function $471cde688b803c6c$var$_extends() {
    $471cde688b803c6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $471cde688b803c6c$var$_extends.apply(this, arguments);
}
var $471cde688b803c6c$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $471cde688b803c6c$export$3c877bb842c36952 = function Cross(props) {
    var x = props.x, y = props.y, width = props.width, height = props.height, top = props.top, left = props.left, className = props.className;
    if (!(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(x) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(y) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(width) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(height) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(top) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $471cde688b803c6c$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-cross", className),
        d: $471cde688b803c6c$var$getPath(x, y, width, height, top, left)
    }));
};
$471cde688b803c6c$export$3c877bb842c36952.defaultProps = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    width: 0,
    height: 0
};




var $lDSNw = parcelRequire("lDSNw");



function $90ad9fc64491da49$var$_extends() {
    $90ad9fc64491da49$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $90ad9fc64491da49$var$_extends.apply(this, arguments);
}
var $90ad9fc64491da49$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("circle", $90ad9fc64491da49$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props), (0, $f50c94b715022fe9$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};







var $lDSNw = parcelRequire("lDSNw");









var $c3cea5bf0564466b$var$_excluded = [
    "viewBox"
], $c3cea5bf0564466b$var$_excluded2 = [
    "viewBox"
], $c3cea5bf0564466b$var$_excluded3 = [
    "ticks"
];
function $c3cea5bf0564466b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c3cea5bf0564466b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c3cea5bf0564466b$var$_typeof(obj);
}
function $c3cea5bf0564466b$var$_extends() {
    $c3cea5bf0564466b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c3cea5bf0564466b$var$_extends.apply(this, arguments);
}
function $c3cea5bf0564466b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c3cea5bf0564466b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c3cea5bf0564466b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c3cea5bf0564466b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c3cea5bf0564466b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c3cea5bf0564466b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c3cea5bf0564466b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c3cea5bf0564466b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c3cea5bf0564466b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c3cea5bf0564466b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c3cea5bf0564466b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c3cea5bf0564466b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c3cea5bf0564466b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c3cea5bf0564466b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c3cea5bf0564466b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c3cea5bf0564466b$var$_setPrototypeOf(subClass, superClass);
}
function $c3cea5bf0564466b$var$_setPrototypeOf(o, p) {
    $c3cea5bf0564466b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c3cea5bf0564466b$var$_setPrototypeOf(o, p);
}
function $c3cea5bf0564466b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c3cea5bf0564466b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c3cea5bf0564466b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c3cea5bf0564466b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c3cea5bf0564466b$var$_possibleConstructorReturn(this, result);
    };
}
function $c3cea5bf0564466b$var$_possibleConstructorReturn(self, call) {
    if (call && ($c3cea5bf0564466b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c3cea5bf0564466b$var$_assertThisInitialized(self);
}
function $c3cea5bf0564466b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c3cea5bf0564466b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c3cea5bf0564466b$var$_getPrototypeOf(o) {
    $c3cea5bf0564466b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c3cea5bf0564466b$var$_getPrototypeOf(o);
}
function $c3cea5bf0564466b$var$_defineProperty(obj, key, value) {
    key = $c3cea5bf0564466b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c3cea5bf0564466b$var$_toPropertyKey(arg) {
    var key = $c3cea5bf0564466b$var$_toPrimitive(arg, "string");
    return $c3cea5bf0564466b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c3cea5bf0564466b$var$_toPrimitive(input, hint) {
    if ($c3cea5bf0564466b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c3cea5bf0564466b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c3cea5bf0564466b$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $c3cea5bf0564466b$var$_inherits(CartesianAxis, _Component);
    var _super = $c3cea5bf0564466b$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $c3cea5bf0564466b$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    $c3cea5bf0564466b$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $c3cea5bf0564466b$var$_objectWithoutProperties(_ref, $c3cea5bf0564466b$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $c3cea5bf0564466b$var$_objectWithoutProperties(_this$props, $c3cea5bf0564466b$var$_excluded2);
                return !(0, $85fb59aede47d0be$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $85fb59aede47d0be$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $85fb59aede47d0be$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props)), (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", $c3cea5bf0564466b$var$_extends({}, props, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $54d564eb55c7ddd8$export$3d27d42b1034de5c)($c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(tick);
                var tickLineProps = $c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread($c3cea5bf0564466b$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $c3cea5bf0564466b$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", $c3cea5bf0564466b$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $c3cea5bf0564466b$var$_objectWithoutProperties(_this$props8, $c3cea5bf0564466b$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $8a059853790af0f6$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8722da9ca6e7f376$export$5f1af8db9871e1d6), $c3cea5bf0564466b$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $lDSNw.Component));
$c3cea5bf0564466b$var$_defineProperty($c3cea5bf0564466b$export$bdd99f2cdf352bae, "displayName", "CartesianAxis");
$c3cea5bf0564466b$var$_defineProperty($c3cea5bf0564466b$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});





var $lDSNw = parcelRequire("lDSNw");






function $f5d1f58591bbbbcd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f5d1f58591bbbbcd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f5d1f58591bbbbcd$var$_typeof(obj);
}
function $f5d1f58591bbbbcd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f5d1f58591bbbbcd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f5d1f58591bbbbcd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f5d1f58591bbbbcd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f5d1f58591bbbbcd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f5d1f58591bbbbcd$var$_defineProperty(obj, key, value) {
    key = $f5d1f58591bbbbcd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f5d1f58591bbbbcd$var$_toPropertyKey(arg) {
    var key = $f5d1f58591bbbbcd$var$_toPrimitive(arg, "string");
    return $f5d1f58591bbbbcd$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f5d1f58591bbbbcd$var$_toPrimitive(input, hint) {
    if ($f5d1f58591bbbbcd$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f5d1f58591bbbbcd$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f5d1f58591bbbbcd$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $f5d1f58591bbbbcd$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $f5d1f58591bbbbcd$var$PREFIX_LIST.reduce(function(res, entry) {
        return $f5d1f58591bbbbcd$var$_objectSpread($f5d1f58591bbbbcd$var$_objectSpread({}, res), {}, $f5d1f58591bbbbcd$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $0f4ca4fca2188641$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0f4ca4fca2188641$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0f4ca4fca2188641$var$_typeof(obj);
}
function $0f4ca4fca2188641$var$_extends() {
    $0f4ca4fca2188641$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f4ca4fca2188641$var$_extends.apply(this, arguments);
}
function $0f4ca4fca2188641$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0f4ca4fca2188641$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0f4ca4fca2188641$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0f4ca4fca2188641$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0f4ca4fca2188641$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0f4ca4fca2188641$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0f4ca4fca2188641$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0f4ca4fca2188641$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0f4ca4fca2188641$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0f4ca4fca2188641$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0f4ca4fca2188641$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0f4ca4fca2188641$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0f4ca4fca2188641$var$_setPrototypeOf(subClass, superClass);
}
function $0f4ca4fca2188641$var$_setPrototypeOf(o, p) {
    $0f4ca4fca2188641$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0f4ca4fca2188641$var$_setPrototypeOf(o, p);
}
function $0f4ca4fca2188641$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0f4ca4fca2188641$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0f4ca4fca2188641$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0f4ca4fca2188641$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0f4ca4fca2188641$var$_possibleConstructorReturn(this, result);
    };
}
function $0f4ca4fca2188641$var$_possibleConstructorReturn(self, call) {
    if (call && ($0f4ca4fca2188641$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0f4ca4fca2188641$var$_assertThisInitialized(self);
}
function $0f4ca4fca2188641$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0f4ca4fca2188641$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0f4ca4fca2188641$var$_getPrototypeOf(o) {
    $0f4ca4fca2188641$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0f4ca4fca2188641$var$_getPrototypeOf(o);
}
function $0f4ca4fca2188641$var$_defineProperty(obj, key, value) {
    key = $0f4ca4fca2188641$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0f4ca4fca2188641$var$_toPropertyKey(arg) {
    var key = $0f4ca4fca2188641$var$_toPrimitive(arg, "string");
    return $0f4ca4fca2188641$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0f4ca4fca2188641$var$_toPrimitive(input, hint) {
    if ($0f4ca4fca2188641$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0f4ca4fca2188641$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0f4ca4fca2188641$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $30f8fd6045919cf1$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($a21dbcbc31c2551f$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $0f4ca4fca2188641$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $0f4ca4fca2188641$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $0f4ca4fca2188641$var$_inherits(Brush, _PureComponent);
    var _super = $0f4ca4fca2188641$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $0f4ca4fca2188641$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            });
            _this.detachDragEndListener();
        });
        $0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $0f4ca4fca2188641$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($0f4ca4fca2188641$var$_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind($0f4ca4fca2188641$var$_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    $0f4ca4fca2188641$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props = this.props, gap = _this$props.gap, data = _this$props.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props2 = this.props, data = _this$props2.data, tickFormatter = _this$props2.tickFormatter, dataKey = _this$props2.dataKey;
                var text = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props3 = this.props, x = _this$props3.x, width = _this$props3.width, travellerWidth = _this$props3.travellerWidth, startIndex = _this$props3.startIndex, endIndex = _this$props3.endIndex, onChange = _this$props3.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $0f4ca4fca2188641$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, onChange = _this$props4.onChange, gap = _this$props4.gap, data = _this$props4.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $0f4ca4fca2188641$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $0f4ca4fca2188641$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, fill = _this$props5.fill, stroke = _this$props5.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, data = _this$props6.data, children = _this$props6.children, padding = _this$props6.padding;
                var chartElement = (0, $lDSNw.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this$props7 = this.props, y = _this$props7.y, travellerWidth = _this$props7.travellerWidth, height = _this$props7.height, traveller = _this$props7.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $0f4ca4fca2188641$var$_objectSpread($0f4ca4fca2188641$var$_objectSpread({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props8 = this.props, y = _this$props8.y, height = _this$props8.height, stroke = _this$props8.stroke, travellerWidth = _this$props8.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props9 = this.props, startIndex = _this$props9.startIndex, endIndex = _this$props9.endIndex, y = _this$props9.y, height = _this$props9.height, travellerWidth = _this$props9.travellerWidth, stroke = _this$props9.stroke;
                var _this$state3 = this.state, startX = _this$state3.startX, endX = _this$state3.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8722da9ca6e7f376$export$5f1af8db9871e1d6), $0f4ca4fca2188641$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8722da9ca6e7f376$export$5f1af8db9871e1d6), $0f4ca4fca2188641$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props10 = this.props, data = _this$props10.data, className = _this$props10.className, children = _this$props10.children, x = _this$props10.x, y = _this$props10.y, width = _this$props10.width, height = _this$props10.height, alwaysShowText = _this$props10.alwaysShowText;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX, isTextActive = _this$state4.isTextActive, isSlideMoving = _this$state4.isSlideMoving, isTravellerMoving = _this$state4.isTravellerMoving;
                if (!data || !data.length || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(x) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(y) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(width) || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Children.count(children) === 1;
                var style = (0, $f5d1f58591bbbbcd$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $0f4ca4fca2188641$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $0f4ca4fca2188641$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(range, x) {
                var len = range.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (range[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= range[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $lDSNw.PureComponent));
$0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$export$59bc2e3533b384a0, "displayName", "Brush");
$0f4ca4fca2188641$var$_defineProperty($0f4ca4fca2188641$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});







var $lDSNw = parcelRequire("lDSNw");





var $480629d0d650fbb6$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};





function $437bcbb07acb55f5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $437bcbb07acb55f5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $437bcbb07acb55f5$var$_typeof(obj);
}
function $437bcbb07acb55f5$var$_extends() {
    $437bcbb07acb55f5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $437bcbb07acb55f5$var$_extends.apply(this, arguments);
}
function $437bcbb07acb55f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $437bcbb07acb55f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $437bcbb07acb55f5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $437bcbb07acb55f5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $437bcbb07acb55f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $437bcbb07acb55f5$var$_defineProperty(obj, key, value) {
    key = $437bcbb07acb55f5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $437bcbb07acb55f5$var$_toPropertyKey(arg) {
    var key = $437bcbb07acb55f5$var$_toPrimitive(arg, "string");
    return $437bcbb07acb55f5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $437bcbb07acb55f5$var$_toPrimitive(input, hint) {
    if ($437bcbb07acb55f5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($437bcbb07acb55f5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $437bcbb07acb55f5$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $28de3275627d2ded$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function $437bcbb07acb55f5$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(x);
    var isY = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(y);
    (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $437bcbb07acb55f5$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $437bcbb07acb55f5$var$_objectSpread($437bcbb07acb55f5$var$_objectSpread({
        clipPath: clipPath
    }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-reference-dot", className)
    }, $437bcbb07acb55f5$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $8a059853790af0f6$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$437bcbb07acb55f5$export$aa7f0b0106bff39.displayName = "ReferenceDot";
$437bcbb07acb55f5$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
$437bcbb07acb55f5$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $90ad9fc64491da49$export$d046b3c4a416f60d), $437bcbb07acb55f5$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};


var $135289627702b8ae$exports = {};


var $33dd51b8e2353267$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $33dd51b8e2353267$var$baseSome(collection, predicate) {
    var result;
    $c2b15ad98b6e43d3$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$33dd51b8e2353267$exports = $33dd51b8e2353267$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $135289627702b8ae$var$some(collection, predicate, guard) {
    var func = $84ca1aa52314c546$exports(collection) ? $1b27f0f94dfa755c$exports : $33dd51b8e2353267$exports;
    if (guard && $3a756535bab803ed$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $52c7c35fde7b0b7d$exports(predicate, 3));
}
$135289627702b8ae$exports = $135289627702b8ae$var$some;




var $lDSNw = parcelRequire("lDSNw");








function $a603384991ab9807$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a603384991ab9807$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a603384991ab9807$var$_typeof(obj);
}
function $a603384991ab9807$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a603384991ab9807$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a603384991ab9807$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a603384991ab9807$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a603384991ab9807$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a603384991ab9807$var$_defineProperty(obj, key, value) {
    key = $a603384991ab9807$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a603384991ab9807$var$_toPropertyKey(arg) {
    var key = $a603384991ab9807$var$_toPrimitive(arg, "string");
    return $a603384991ab9807$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a603384991ab9807$var$_toPrimitive(input, hint) {
    if ($a603384991ab9807$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a603384991ab9807$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a603384991ab9807$var$_slicedToArray(arr, i) {
    return $a603384991ab9807$var$_arrayWithHoles(arr) || $a603384991ab9807$var$_iterableToArrayLimit(arr, i) || $a603384991ab9807$var$_unsupportedIterableToArray(arr, i) || $a603384991ab9807$var$_nonIterableRest();
}
function $a603384991ab9807$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a603384991ab9807$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a603384991ab9807$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a603384991ab9807$var$_arrayLikeToArray(o, minLen);
}
function $a603384991ab9807$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a603384991ab9807$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $a603384991ab9807$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a603384991ab9807$var$_extends() {
    $a603384991ab9807$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a603384991ab9807$var$_extends.apply(this, arguments);
}
var $a603384991ab9807$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", $a603384991ab9807$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
// TODO: ScaleHelper
var $a603384991ab9807$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($135289627702b8ae$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $a603384991ab9807$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $28de3275627d2ded$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(fixedX);
    var isY = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $a603384991ab9807$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $a603384991ab9807$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $a603384991ab9807$var$_objectSpread($a603384991ab9807$var$_objectSpread({
        clipPath: clipPath
    }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-reference-line", className)
    }, $a603384991ab9807$var$renderLine(shape, lineProps), (0, $8a059853790af0f6$export$b04be29aa201d4f5).renderCallByParent(props, (0, $28de3275627d2ded$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$a603384991ab9807$export$b2f28e248e7838eb.displayName = "ReferenceLine";
$a603384991ab9807$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};




var $lDSNw = parcelRequire("lDSNw");









function $2557e4e77e0ef47b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2557e4e77e0ef47b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2557e4e77e0ef47b$var$_typeof(obj);
}
function $2557e4e77e0ef47b$var$_extends() {
    $2557e4e77e0ef47b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2557e4e77e0ef47b$var$_extends.apply(this, arguments);
}
function $2557e4e77e0ef47b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2557e4e77e0ef47b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2557e4e77e0ef47b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2557e4e77e0ef47b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2557e4e77e0ef47b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2557e4e77e0ef47b$var$_defineProperty(obj, key, value) {
    key = $2557e4e77e0ef47b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2557e4e77e0ef47b$var$_toPropertyKey(arg) {
    var key = $2557e4e77e0ef47b$var$_toPrimitive(arg, "string");
    return $2557e4e77e0ef47b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2557e4e77e0ef47b$var$_toPrimitive(input, hint) {
    if ($2557e4e77e0ef47b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2557e4e77e0ef47b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2557e4e77e0ef47b$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $28de3275627d2ded$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $28de3275627d2ded$export$c7964a5b9439ae62)(p1, p2);
};
function $2557e4e77e0ef47b$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $aee02c7eefa94d8b$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $2557e4e77e0ef47b$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $480629d0d650fbb6$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-reference-area", className)
    }, $2557e4e77e0ef47b$export$b4ec4f050ce240b9.renderRect(shape, $2557e4e77e0ef47b$var$_objectSpread($2557e4e77e0ef47b$var$_objectSpread({
        clipPath: clipPath
    }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(props, true)), rect)), (0, $8a059853790af0f6$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$2557e4e77e0ef47b$export$b4ec4f050ce240b9.displayName = "ReferenceArea";
$2557e4e77e0ef47b$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
$2557e4e77e0ef47b$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $084ca05f02b53339$export$4617fb02663045ef), $2557e4e77e0ef47b$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $03154b9bb1f05b55$var$_toConsumableArray(arr) {
    return $03154b9bb1f05b55$var$_arrayWithoutHoles(arr) || $03154b9bb1f05b55$var$_iterableToArray(arr) || $03154b9bb1f05b55$var$_unsupportedIterableToArray(arr) || $03154b9bb1f05b55$var$_nonIterableSpread();
}
function $03154b9bb1f05b55$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $03154b9bb1f05b55$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $03154b9bb1f05b55$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $03154b9bb1f05b55$var$_arrayLikeToArray(o, minLen);
}
function $03154b9bb1f05b55$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $03154b9bb1f05b55$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $03154b9bb1f05b55$var$_arrayLikeToArray(arr);
}
function $03154b9bb1f05b55$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $03154b9bb1f05b55$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $a603384991ab9807$export$b2f28e248e7838eb));
    var dots = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $437bcbb07acb55f5$export$aa7f0b0106bff39));
    var elements = [].concat($03154b9bb1f05b55$var$_toConsumableArray(lines), $03154b9bb1f05b55$var$_toConsumableArray(dots));
    var areas = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $2557e4e77e0ef47b$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $480629d0d650fbb6$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $480629d0d650fbb6$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(el.props[key1]) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $8bb2d63f0537ebff$exports = {};
"use strict";
var $8bb2d63f0537ebff$var$has = Object.prototype.hasOwnProperty, $8bb2d63f0537ebff$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $8bb2d63f0537ebff$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $8bb2d63f0537ebff$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $8bb2d63f0537ebff$var$Events().__proto__) $8bb2d63f0537ebff$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $8bb2d63f0537ebff$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $8bb2d63f0537ebff$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $8bb2d63f0537ebff$var$EE(fn, context || emitter, once), evt = $8bb2d63f0537ebff$var$prefix ? $8bb2d63f0537ebff$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $8bb2d63f0537ebff$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $8bb2d63f0537ebff$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $8bb2d63f0537ebff$var$EventEmitter() {
    this._events = new $8bb2d63f0537ebff$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($8bb2d63f0537ebff$var$has.call(events, name)) names.push($8bb2d63f0537ebff$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $8bb2d63f0537ebff$var$prefix ? $8bb2d63f0537ebff$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $8bb2d63f0537ebff$var$prefix ? $8bb2d63f0537ebff$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $8bb2d63f0537ebff$var$prefix ? $8bb2d63f0537ebff$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $8bb2d63f0537ebff$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $8bb2d63f0537ebff$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $8bb2d63f0537ebff$var$prefix ? $8bb2d63f0537ebff$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $8bb2d63f0537ebff$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $8bb2d63f0537ebff$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $8bb2d63f0537ebff$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $8bb2d63f0537ebff$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $8bb2d63f0537ebff$var$prefix ? $8bb2d63f0537ebff$var$prefix + event : event;
        if (this._events[evt]) $8bb2d63f0537ebff$var$clearEvent(this, evt);
    } else {
        this._events = new $8bb2d63f0537ebff$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$8bb2d63f0537ebff$var$EventEmitter.prototype.off = $8bb2d63f0537ebff$var$EventEmitter.prototype.removeListener;
$8bb2d63f0537ebff$var$EventEmitter.prototype.addListener = $8bb2d63f0537ebff$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$8bb2d63f0537ebff$var$EventEmitter.prefixed = $8bb2d63f0537ebff$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$8bb2d63f0537ebff$var$EventEmitter.EventEmitter = $8bb2d63f0537ebff$var$EventEmitter;
$8bb2d63f0537ebff$exports = $8bb2d63f0537ebff$var$EventEmitter;


var $df0857262e6ccaff$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($8bb2d63f0537ebff$exports)))();
if ($df0857262e6ccaff$export$9bcdfe5f29bb33.setMaxListeners) $df0857262e6ccaff$export$9bcdfe5f29bb33.setMaxListeners(10);
var $df0857262e6ccaff$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents";



function $a7ba8bf33fb82d4a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a7ba8bf33fb82d4a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a7ba8bf33fb82d4a$var$_typeof(obj);
}
function $a7ba8bf33fb82d4a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a7ba8bf33fb82d4a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a7ba8bf33fb82d4a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a7ba8bf33fb82d4a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a7ba8bf33fb82d4a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a7ba8bf33fb82d4a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a7ba8bf33fb82d4a$var$_defineProperty(obj, key, value) {
    key = $a7ba8bf33fb82d4a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a7ba8bf33fb82d4a$var$_toPropertyKey(arg) {
    var key = $a7ba8bf33fb82d4a$var$_toPrimitive(arg, "string");
    return $a7ba8bf33fb82d4a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a7ba8bf33fb82d4a$var$_toPrimitive(input, hint) {
    if ($a7ba8bf33fb82d4a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a7ba8bf33fb82d4a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a7ba8bf33fb82d4a$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $a7ba8bf33fb82d4a$var$_classCallCheck(this, AccessibilityManager);
        $a7ba8bf33fb82d4a$var$_defineProperty(this, "activeIndex", 0);
        $a7ba8bf33fb82d4a$var$_defineProperty(this, "coordinateList", []);
        $a7ba8bf33fb82d4a$var$_defineProperty(this, "layout", "horizontal");
    }
    $a7ba8bf33fb82d4a$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var pageX = x + coordinate;
                var pageY = y + this.offset.top;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();


var $bc90a147d6e1cdb7$var$_excluded = [
    "item"
], $bc90a147d6e1cdb7$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $bc90a147d6e1cdb7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bc90a147d6e1cdb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bc90a147d6e1cdb7$var$_typeof(obj);
}
function $bc90a147d6e1cdb7$var$_slicedToArray(arr, i) {
    return $bc90a147d6e1cdb7$var$_arrayWithHoles(arr) || $bc90a147d6e1cdb7$var$_iterableToArrayLimit(arr, i) || $bc90a147d6e1cdb7$var$_unsupportedIterableToArray(arr, i) || $bc90a147d6e1cdb7$var$_nonIterableRest();
}
function $bc90a147d6e1cdb7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bc90a147d6e1cdb7$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $bc90a147d6e1cdb7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bc90a147d6e1cdb7$var$_extends() {
    $bc90a147d6e1cdb7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc90a147d6e1cdb7$var$_extends.apply(this, arguments);
}
function $bc90a147d6e1cdb7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bc90a147d6e1cdb7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bc90a147d6e1cdb7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bc90a147d6e1cdb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bc90a147d6e1cdb7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bc90a147d6e1cdb7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bc90a147d6e1cdb7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bc90a147d6e1cdb7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bc90a147d6e1cdb7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bc90a147d6e1cdb7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bc90a147d6e1cdb7$var$_setPrototypeOf(subClass, superClass);
}
function $bc90a147d6e1cdb7$var$_setPrototypeOf(o, p) {
    $bc90a147d6e1cdb7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bc90a147d6e1cdb7$var$_setPrototypeOf(o, p);
}
function $bc90a147d6e1cdb7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bc90a147d6e1cdb7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bc90a147d6e1cdb7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bc90a147d6e1cdb7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bc90a147d6e1cdb7$var$_possibleConstructorReturn(this, result);
    };
}
function $bc90a147d6e1cdb7$var$_possibleConstructorReturn(self, call) {
    if (call && ($bc90a147d6e1cdb7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bc90a147d6e1cdb7$var$_assertThisInitialized(self);
}
function $bc90a147d6e1cdb7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bc90a147d6e1cdb7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bc90a147d6e1cdb7$var$_getPrototypeOf(o) {
    $bc90a147d6e1cdb7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bc90a147d6e1cdb7$var$_getPrototypeOf(o);
}
function $bc90a147d6e1cdb7$var$_toConsumableArray(arr) {
    return $bc90a147d6e1cdb7$var$_arrayWithoutHoles(arr) || $bc90a147d6e1cdb7$var$_iterableToArray(arr) || $bc90a147d6e1cdb7$var$_unsupportedIterableToArray(arr) || $bc90a147d6e1cdb7$var$_nonIterableSpread();
}
function $bc90a147d6e1cdb7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bc90a147d6e1cdb7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bc90a147d6e1cdb7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bc90a147d6e1cdb7$var$_arrayLikeToArray(o, minLen);
}
function $bc90a147d6e1cdb7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bc90a147d6e1cdb7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bc90a147d6e1cdb7$var$_arrayLikeToArray(arr);
}
function $bc90a147d6e1cdb7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bc90a147d6e1cdb7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bc90a147d6e1cdb7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bc90a147d6e1cdb7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bc90a147d6e1cdb7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bc90a147d6e1cdb7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bc90a147d6e1cdb7$var$_defineProperty(obj, key, value) {
    key = $bc90a147d6e1cdb7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bc90a147d6e1cdb7$var$_toPropertyKey(arg) {
    var key = $bc90a147d6e1cdb7$var$_toPrimitive(arg, "string");
    return $bc90a147d6e1cdb7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bc90a147d6e1cdb7$var$_toPrimitive(input, hint) {
    if ($bc90a147d6e1cdb7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bc90a147d6e1cdb7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $bc90a147d6e1cdb7$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $bc90a147d6e1cdb7$var$originCoordinate = {
    x: 0,
    y: 0
};
// use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals
var $bc90a147d6e1cdb7$var$isFinit = Number.isFinite ? Number.isFinite : isFinite;
var $bc90a147d6e1cdb7$var$defer = // eslint-disable-next-line no-nested-ternary
typeof requestAnimationFrame === "function" ? requestAnimationFrame : typeof setImmediate === "function" ? setImmediate : setTimeout;
var $bc90a147d6e1cdb7$var$deferClear = // eslint-disable-next-line no-nested-ternary
typeof cancelAnimationFrame === "function" ? cancelAnimationFrame : typeof clearImmediate === "function" ? clearImmediate : clearTimeout;
var $bc90a147d6e1cdb7$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $bc90a147d6e1cdb7$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, rangeObj), (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, rangeObj), (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $bc90a147d6e1cdb7$var$originCoordinate;
};
var $bc90a147d6e1cdb7$var$getDisplayedData = function getDisplayedData(data, _ref, item) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($bc90a147d6e1cdb7$var$_toConsumableArray(result), $bc90a147d6e1cdb7$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData && itemsData.length > 0) return itemsData;
    if (item && item.props && item.props.data && item.props.data.length > 0) return item.props.data;
    if (data && data.length && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(dataStartIndex) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ function $bc90a147d6e1cdb7$var$isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(domainStart) && (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}
function $bc90a147d6e1cdb7$var$getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $bc90a147d6e1cdb7$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $bc90a147d6e1cdb7$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var hide = child.props.hide;
        if (hide) return result;
        var data = child.props.data;
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $aee02c7eefa94d8b$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($bc90a147d6e1cdb7$var$_toConsumableArray(result), [
            (0, $ecbafd4b4677e0ac$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $bc90a147d6e1cdb7$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $bc90a147d6e1cdb7$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $ecbafd4b4677e0ac$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $bc90a147d6e1cdb7$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $bc90a147d6e1cdb7$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $bc90a147d6e1cdb7$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $ecbafd4b4677e0ac$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    var axisMap = axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $bc90a147d6e1cdb7$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ($bc90a147d6e1cdb7$var$isDomainSpecifiedByUser(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $ecbafd4b4677e0ac$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $ecbafd4b4677e0ac$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $bc90a147d6e1cdb7$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $ecbafd4b4677e0ac$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $aee02c7eefa94d8b$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($a21dbcbc31c2551f$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $ecbafd4b4677e0ac$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($bc90a147d6e1cdb7$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $ecbafd4b4677e0ac$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(entry) ? finalDomain : [].concat($bc90a147d6e1cdb7$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $ecbafd4b4677e0ac$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $ecbafd4b4677e0ac$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($a21dbcbc31c2551f$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $ecbafd4b4677e0ac$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $ecbafd4b4677e0ac$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $03154b9bb1f05b55$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $ecbafd4b4677e0ac$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, result), {}, $bc90a147d6e1cdb7$var$_defineProperty({}, axisId, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
    return axisMap;
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $bc90a147d6e1cdb7$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $bc90a147d6e1cdb7$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $ecbafd4b4677e0ac$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    var axisMap = graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $bc90a147d6e1cdb7$var$getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($a21dbcbc31c2551f$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $ecbafd4b4677e0ac$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $03154b9bb1f05b55$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $ecbafd4b4677e0ac$export$a0bc8660980558a0)(originalDomain, (0, $ecbafd4b4677e0ac$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $03154b9bb1f05b55$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, result), {}, $bc90a147d6e1cdb7$var$_defineProperty({}, axisId, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))($bc90a147d6e1cdb7$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $bc90a147d6e1cdb7$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $bc90a147d6e1cdb7$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $bc90a147d6e1cdb7$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $bc90a147d6e1cdb7$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($768d47a24ee3d1c4$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $ecbafd4b4677e0ac$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var $bc90a147d6e1cdb7$var$createDefaultState = function createDefaultState(props) {
    var _brushItem$props, _brushItem$props2;
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $0f4ca4fca2188641$export$59bc2e3533b384a0));
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = (brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props = brushItem.props) === null || _brushItem$props === void 0 ? void 0 : _brushItem$props.endIndex) !== undefined ? brushItem === null || brushItem === void 0 ? void 0 : (_brushItem$props2 = brushItem.props) === null || _brushItem$props2 === void 0 ? void 0 : _brushItem$props2.endIndex : props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(defaultShowTooltip) ? defaultShowTooltip : false
    };
};
var $bc90a147d6e1cdb7$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $65af1a52cac4dd09$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $bc90a147d6e1cdb7$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $bc90a147d6e1cdb7$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $0f4ca4fca2188641$export$59bc2e3533b384a0));
    var legendItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $22f8c7fa15a15fc3$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, result), {}, $bc90a147d6e1cdb7$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, result), {}, $bc90a147d6e1cdb7$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $0f4ca4fca2188641$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) offset = (0, $ecbafd4b4677e0ac$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
    });
};
var $bc90a147d6e1cdb7$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $bc90a147d6e1cdb7$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $bc90a147d6e1cdb7$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $ecbafd4b4677e0ac$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $bc90a147d6e1cdb7$var$getDisplayedData(props.data, {
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }, item);
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _objectSpread6;
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                var id = item.props["".concat(entry.axisType, "Id")];
                var axis = axisMap && axisMap[id];
                return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $bc90a147d6e1cdb7$var$_defineProperty(_objectSpread6, entry.axisType, axis), $bc90a147d6e1cdb7$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, {});
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $ecbafd4b4677e0ac$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $65af1a52cac4dd09$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $ecbafd4b4677e0ac$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $ecbafd4b4677e0ac$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $ecbafd4b4677e0ac$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, pos), {}, {
                        position: $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, composedFn($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $bc90a147d6e1cdb7$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $bc90a147d6e1cdb7$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $bc90a147d6e1cdb7$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $65af1a52cac4dd09$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $65af1a52cac4dd09$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $bc90a147d6e1cdb7$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $ecbafd4b4677e0ac$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, result), {}, $bc90a147d6e1cdb7$var$_defineProperty({}, name, $bc90a147d6e1cdb7$var$getAxisMap(props, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $bc90a147d6e1cdb7$var$calculateOffset($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $bc90a147d6e1cdb7$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $bc90a147d6e1cdb7$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $bc90a147d6e1cdb7$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _this;
            $bc90a147d6e1cdb7$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $a7ba8bf33fb82d4a$export$a2c2de1efa8671eb)());
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "clearDeferId", function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(_this.deferId) && $bc90a147d6e1cdb7$var$deferClear) $bc90a147d6e1cdb7$var$deferClear(_this.deferId);
                _this.deferId = null;
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($bc90a147d6e1cdb7$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, chartId, data) {
                var syncId = _this.props.syncId;
                if (syncId === cId && chartId !== _this.uniqueChartId) {
                    _this.clearDeferId();
                    _this.deferId = $bc90a147d6e1cdb7$var$defer && $bc90a147d6e1cdb7$var$defer(_this.applySyncEvent.bind($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), data));
                }
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $bc90a147d6e1cdb7$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var onMouseEnter = _this.props.onMouseEnter;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var onMouseMove = _this.props.onMouseMove;
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {Object} e        Event object
       * @return {Null} no return
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                if (e && (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(e.persist)) e.persist();
                _this.triggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var onMouseLeave = _this.props.onMouseLeave;
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
                _this.cancelThrottledTriggerAfterMouseMove();
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $65af1a52cac4dd09$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(event)) {
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    var handler = event;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    handler(mouse, e);
                }
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var onClick = _this.props.onClick;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseMove(e.changedTouches[0]);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $ecbafd4b4677e0ac$export$846dc5ac5fecff74)((0, $54d564eb55c7ddd8$export$3d27d42b1034de5c)($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, (0, $c3cea5bf0564466b$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $ecbafd4b4677e0ac$export$846dc5ac5fecff74)((0, $54d564eb55c7ddd8$export$3d27d42b1034de5c)($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, (0, $c3cea5bf0564466b$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(axis, true);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _this$state2 = _this.state, isTooltipActive = _this$state2.isTooltipActive, activeCoordinate = _this$state2.activeCoordinate, activePayload = _this$state2.activePayload, offset = _this$state2.offset, activeTooltipIndex = _this$state2.activeTooltipIndex;
                var tooltipEventType = _this.getTooltipEventType();
                if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1);
                if (chartName === "ScatterChart") {
                    restProps = activeCoordinate;
                    cursorComp = (0, $471cde688b803c6c$export$3c877bb842c36952);
                } else if (chartName === "BarChart") {
                    restProps = _this.getCursorRectangle();
                    cursorComp = (0, $084ca05f02b53339$export$4617fb02663045ef);
                } else if (layout === "radial") {
                    var _this$getCursorPoints = _this.getCursorPoints(), cx = _this$getCursorPoints.cx, cy = _this$getCursorPoints.cy, radius = _this$getCursorPoints.radius, startAngle = _this$getCursorPoints.startAngle, endAngle = _this$getCursorPoints.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $6a5e9973c598b4e9$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: _this.getCursorPoints()
                    };
                    cursorComp = (0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1);
                }
                var key = element.key || "_recharts-cursor";
                var cursorProps = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
                    stroke: "#ccc",
                    pointerEvents: "none"
                }, offset), restProps), (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: "recharts-tooltip-cursor"
                });
                return /*#__PURE__*/ (0, $lDSNw.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $lDSNw.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $lDSNw.createElement)(cursorComp, cursorProps);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(element, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state3 = _this.state, xAxisMap = _this$state3.xAxisMap, yAxisMap = _this$state3.yAxisMap, offset = _this$state3.offset;
                var _this$props = _this.props, width = _this$props.width, height = _this$props.height;
                var xAxis = (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($383a22bbb40a25d5$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c880f31ef4285855$exports)))(axis.domain, $bc90a147d6e1cdb7$var$isFinit);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(element, {
                    key: element.key || "grid",
                    x: (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(element, {
                    polarAngles: (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(polarAngles) ? polarAngles : (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(polarRadius) ? polarRadius : (0, $ecbafd4b4677e0ac$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $ecbafd4b4677e0ac$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $bc90a147d6e1cdb7$var$_objectWithoutProperties(props, $bc90a147d6e1cdb7$var$_excluded);
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(item, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    ref: function ref(legend) {
                        _this.legendInstance = legend;
                    },
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var children = _this.props.children;
                var tooltipItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $deb1267103fb31f8$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(tooltipItem, {
                    viewBox: $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isTooltipActive,
                    label: activeLabel,
                    payload: isTooltipActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props3 = _this.props, margin = _this$props3.margin, data = _this$props3.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $ecbafd4b4677e0ac$export$760ec406ba47bace)(_this.handleBrushChange, null, element.props.onChange),
                    data: data,
                    x: (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $bc90a147d6e1cdb7$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $ecbafd4b4677e0ac$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(activeDot)), (0, $f50c94b715022fe9$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $deb1267103fb31f8$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide;
                var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $ecbafd4b4677e0ac$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onCLick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $ecbafd4b4677e0ac$export$760ec406ba47bace)(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
                    onMouseEnter: (0, $ecbafd4b4677e0ac$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $lDSNw.cloneElement)(element, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    var activePoint, basePoint;
                    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                        // number transform to string
                        var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                        activePoint = (0, $aee02c7eefa94d8b$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                        basePoint = isRange && baseLine && (0, $aee02c7eefa94d8b$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                    } else {
                        activePoint = points[activeTooltipIndex];
                        basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                    }
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(activePoint)) return [
                        graphicalItem
                    ].concat($bc90a147d6e1cdb7$var$_toConsumableArray(_this.renderActivePoints({
                        item: item,
                        activePoint: activePoint,
                        basePoint: basePoint,
                        childIndex: activeTooltipIndex,
                        isRange: isRange
                    })));
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $bc90a147d6e1cdb7$var$_defineProperty($bc90a147d6e1cdb7$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $lDSNw.cloneElement)(element, $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _this.uniqueChartId = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(_props.id) ? (0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("recharts") : _props.id;
            _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
            if (_props.throttleDelay) _this.triggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($0f96fe226c12ba87$exports)))(_this.triggeredAfterMouseMove, _props.throttleDelay);
            _this.state = {};
            return _this;
        }
        $bc90a147d6e1cdb7$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(this.props.syncId)) this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.handleMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // add syncId
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(prevProps.syncId) && !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(this.props.syncId)) this.addListener();
                    // remove syncId
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(prevProps.syncId) && (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(this.props.syncId)) this.removeListener();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDeferId();
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(this.props.syncId)) this.removeListener();
                    this.cancelThrottledTriggerAfterMouseMove();
                }
            },
            {
                key: "cancelThrottledTriggerAfterMouseMove",
                value: function cancelThrottledTriggerAfterMouseMove() {
                    if (typeof this.triggeredAfterMouseMove.cancel === "function") this.triggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(this.props.children, (0, $deb1267103fb31f8$export$28c660c63b792dea));
                    if (tooltipItem && (0, (/*@__PURE__*/$parcel$interopDefault($91585826593d324b$exports)))(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var containerOffset = (0, $45bc9796bb269564$export$622cea445a1c5b7d)(this.container);
                    var e = (0, $45bc9796bb269564$export$f209e6c32ad3d02e)(event, containerOffset);
                    var rangeObj = this.inRange(e.chartX, e.chartY);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $bc90a147d6e1cdb7$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "getCursorRectangle",
                value: function getCursorRectangle() {
                    var layout = this.props.layout;
                    var _this$state10 = this.state, activeCoordinate = _this$state10.activeCoordinate, offset = _this$state10.offset, tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
                    var halfSize = tooltipAxisBandSize / 2;
                    return {
                        stroke: "none",
                        fill: "#ccc",
                        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
                        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
                        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
                        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
                    };
                }
            },
            {
                key: "getCursorPoints",
                value: function getCursorPoints() {
                    var layout = this.props.layout;
                    var _this$state11 = this.state, activeCoordinate = _this$state11.activeCoordinate, offset = _this$state11.offset;
                    var x1, y1, x2, y2;
                    if (layout === "horizontal") {
                        x1 = activeCoordinate.x;
                        x2 = x1;
                        y1 = offset.top;
                        y2 = offset.top + offset.height;
                    } else if (layout === "vertical") {
                        y1 = activeCoordinate.y;
                        y2 = y1;
                        x1 = offset.left;
                        x2 = offset.left + offset.width;
                    } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(activeCoordinate.cx) || !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(activeCoordinate.cy)) {
                        if (layout === "centric") {
                            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
                            var innerPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
                            var outerPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
                            x1 = innerPoint.x;
                            y1 = innerPoint.y;
                            x2 = outerPoint.x;
                            y2 = outerPoint.y;
                        } else {
                            var _cx = activeCoordinate.cx, _cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
                            var startPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(_cx, _cy, radius, startAngle);
                            var endPoint = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(_cx, _cy, radius, endAngle);
                            return {
                                points: [
                                    startPoint,
                                    endPoint
                                ],
                                cx: _cx,
                                cy: _cy,
                                radius: radius,
                                startAngle: startAngle,
                                endAngle: endAngle
                            };
                        }
                    }
                    return [
                        {
                            x: x1,
                            y: y1
                        },
                        {
                            x: x2,
                            y: y2
                        }
                    ];
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var layout = this.props.layout;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
                        return isInRange ? {
                            x: x,
                            y: y
                        } : null;
                    }
                    var _this$state12 = this.state, angleAxisMap = _this$state12.angleAxisMap, radiusAxisMap = _this$state12.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $aee02c7eefa94d8b$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $fb34ba651878b323$export$e85a2bf8cd31c504)({
                            x: x,
                            y: y
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $65af1a52cac4dd09$export$64c61536a2b72e0f)(children, (0, $deb1267103fb31f8$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    var outerEvents = (0, $f50c94b715022fe9$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $df0857262e6ccaff$export$9bcdfe5f29bb33).on((0, $df0857262e6ccaff$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $df0857262e6ccaff$export$9bcdfe5f29bb33).setMaxListeners && (0, $df0857262e6ccaff$export$9bcdfe5f29bb33)._maxListeners) (0, $df0857262e6ccaff$export$9bcdfe5f29bb33).setMaxListeners((0, $df0857262e6ccaff$export$9bcdfe5f29bb33)._maxListeners + 1);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $df0857262e6ccaff$export$9bcdfe5f29bb33).removeListener((0, $df0857262e6ccaff$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $df0857262e6ccaff$export$9bcdfe5f29bb33).setMaxListeners && (0, $df0857262e6ccaff$export$9bcdfe5f29bb33)._maxListeners) (0, $df0857262e6ccaff$export$9bcdfe5f29bb33).setMaxListeners((0, $df0857262e6ccaff$export$9bcdfe5f29bb33)._maxListeners - 1);
                }
            },
            {
                key: "triggerSyncEvent",
                value: function triggerSyncEvent(data) {
                    var syncId = this.props.syncId;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(syncId)) (0, $df0857262e6ccaff$export$9bcdfe5f29bb33).emit((0, $df0857262e6ccaff$export$ff9a08f6d0c38b8f), syncId, this.uniqueChartId, data);
                }
            },
            {
                key: "applySyncEvent",
                value: function applySyncEvent(data) {
                    var _this$props4 = this.props, layout = _this$props4.layout, syncMethod = _this$props4.syncMethod;
                    var updateId = this.state.updateId;
                    var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(data.dataStartIndex) || !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(data.dataEndIndex)) this.setState($bc90a147d6e1cdb7$var$_objectSpread({
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, this.state)));
                    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(data.activeTooltipIndex)) {
                        var chartX = data.chartX, chartY = data.chartY;
                        var activeTooltipIndex = data.activeTooltipIndex;
                        var _this$state13 = this.state, offset = _this$state13.offset, tooltipTicks = _this$state13.tooltipTicks;
                        if (!offset) return;
                        if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                        activeTooltipIndex = syncMethod(tooltipTicks, data);
                        else if (syncMethod === "value") {
                            // Set activeTooltipIndex to the index with the same value as data.activeLabel
                            // For loop instead of findIndex because the latter is very slow in some browsers
                            activeTooltipIndex = -1; // in case we cannot find the element
                            for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                                activeTooltipIndex = i;
                                break;
                            }
                        }
                        var viewBox = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, offset), {}, {
                            x: offset.left,
                            y: offset.top
                        });
                        // When a categorical chart is combined with another chart, the value of chartX
                        // and chartY may beyond the boundaries.
                        var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                        var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                        var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                        var activePayload = $bc90a147d6e1cdb7$var$getTooltipContent(this.state, this.props.data, activeTooltipIndex);
                        var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                            x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                            y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                        } : $bc90a147d6e1cdb7$var$originCoordinate;
                        this.setState($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, data), {}, {
                            activeLabel: activeLabel,
                            activeCoordinate: activeCoordinate,
                            activePayload: activePayload,
                            activeTooltipIndex: activeTooltipIndex
                        }));
                    } else this.setState(data);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $65af1a52cac4dd09$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $c3cea5bf0564466b$export$bdd99f2cdf352bae), $bc90a147d6e1cdb7$var$_extends({}, axisOptions, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $bc90a147d6e1cdb7$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, res), {}, $bc90a147d6e1cdb7$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $bc90a147d6e1cdb7$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, res), {}, $bc90a147d6e1cdb7$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap, _this$state$xAxisMap$;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 ? void 0 : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0 ? void 0 : _this$state$xAxisMap$.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap, _this$state$yAxisMap$;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 ? void 0 : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0 ? void 0 : _this$state$yAxisMap$.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $65af1a52cac4dd09$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $084ca05f02b53339$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $fb34ba651878b323$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $65af1a52cac4dd09$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $bc90a147d6e1cdb7$var$_objectWithoutProperties(_this$props6, $bc90a147d6e1cdb7$var$_excluded2);
                    var attrs = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others);
                    var map = {
                        CartesianGrid: {
                            handler: this.renderGrid,
                            once: true
                        },
                        ReferenceArea: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceLine: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceDot: {
                            handler: this.renderReferenceElement
                        },
                        XAxis: {
                            handler: this.renderXAxis
                        },
                        YAxis: {
                            handler: this.renderYAxis
                        },
                        Brush: {
                            handler: this.renderBrush,
                            once: true
                        },
                        Bar: {
                            handler: this.renderGraphicChild
                        },
                        Line: {
                            handler: this.renderGraphicChild
                        },
                        Area: {
                            handler: this.renderGraphicChild
                        },
                        Radar: {
                            handler: this.renderGraphicChild
                        },
                        RadialBar: {
                            handler: this.renderGraphicChild
                        },
                        Scatter: {
                            handler: this.renderGraphicChild
                        },
                        Pie: {
                            handler: this.renderGraphicChild
                        },
                        Funnel: {
                            handler: this.renderGraphicChild
                        },
                        Tooltip: {
                            handler: this.renderCursor,
                            once: true
                        },
                        PolarGrid: {
                            handler: this.renderPolarGrid,
                            once: true
                        },
                        PolarAngleAxis: {
                            handler: this.renderPolarAxis
                        },
                        PolarRadiusAxis: {
                            handler: this.renderPolarAxis
                        },
                        Customized: {
                            handler: this.renderCustomized
                        }
                    };
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $09ba7bcaf26150d4$export$7b92b459e668cb21), $bc90a147d6e1cdb7$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $65af1a52cac4dd09$export$a98d6da55570cb82)(children, map));
                    if (this.props.accessibilityLayer) {
                        var _2, _img;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_2 = 0, _2 !== void 0) ? _2 : this.props.tabIndex;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_img = "img", _img !== void 0) ? _img : this.props.role;
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", $bc90a147d6e1cdb7$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-wrapper", className),
                        style: $bc90a147d6e1cdb7$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $09ba7bcaf26150d4$export$7b92b459e668cb21), $bc90a147d6e1cdb7$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $65af1a52cac4dd09$export$a98d6da55570cb82)(children, map)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $lDSNw.Component)), $bc90a147d6e1cdb7$var$_defineProperty(_class, "displayName", chartName), $bc90a147d6e1cdb7$var$_defineProperty(_class, "defaultProps", $bc90a147d6e1cdb7$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps)), $bc90a147d6e1cdb7$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(prevState.updateId)) {
            var defaultState = $bc90a147d6e1cdb7$var$createDefaultState(nextProps);
            return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $85fb59aede47d0be$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $bc90a147d6e1cdb7$var$createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, $bc90a147d6e1cdb7$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($bc90a147d6e1cdb7$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $65af1a52cac4dd09$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($bc90a147d6e1cdb7$var$_objectSpread($bc90a147d6e1cdb7$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }), $bc90a147d6e1cdb7$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $lDSNw.isValidElement)(option)) dot = /*#__PURE__*/ (0, $lDSNw.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $90ad9fc64491da49$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};




var $lDSNw = parcelRequire("lDSNw");



var $lDSNw = parcelRequire("lDSNw");


var $aa01d36dc78131b3$var$_excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function $aa01d36dc78131b3$var$_extends() {
    $aa01d36dc78131b3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aa01d36dc78131b3$var$_extends.apply(this, arguments);
}
function $aa01d36dc78131b3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $aa01d36dc78131b3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $aa01d36dc78131b3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $aa01d36dc78131b3$var$_toConsumableArray(arr) {
    return $aa01d36dc78131b3$var$_arrayWithoutHoles(arr) || $aa01d36dc78131b3$var$_iterableToArray(arr) || $aa01d36dc78131b3$var$_unsupportedIterableToArray(arr) || $aa01d36dc78131b3$var$_nonIterableSpread();
}
function $aa01d36dc78131b3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aa01d36dc78131b3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aa01d36dc78131b3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aa01d36dc78131b3$var$_arrayLikeToArray(o, minLen);
}
function $aa01d36dc78131b3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aa01d36dc78131b3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aa01d36dc78131b3$var$_arrayLikeToArray(arr);
}
function $aa01d36dc78131b3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $aa01d36dc78131b3$var$isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var $aa01d36dc78131b3$var$getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if ($aa01d36dc78131b3$var$isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if ($aa01d36dc78131b3$var$isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var $aa01d36dc78131b3$var$getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = $aa01d36dc78131b3$var$getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat($aa01d36dc78131b3$var$_toConsumableArray(res), $aa01d36dc78131b3$var$_toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? "M" : "L").concat(point.x, ",").concat(point.y);
        }, "");
    }).join("");
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var $aa01d36dc78131b3$var$getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = $aa01d36dc78131b3$var$getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === "Z" ? outerPath.slice(0, -1) : outerPath, "L").concat($aa01d36dc78131b3$var$getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var $aa01d36dc78131b3$export$7d31b617c820d435 = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = $aa01d36dc78131b3$var$_objectWithoutProperties(props, $aa01d36dc78131b3$var$_excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-polygon", className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== "none";
        var rangePath = $aa01d36dc78131b3$var$getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $aa01d36dc78131b3$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true), {
            fill: rangePath.slice(-1) === "Z" ? others.fill : "none",
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $aa01d36dc78131b3$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $aa01d36dc78131b3$var$getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $aa01d36dc78131b3$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true), {
            fill: "none",
            d: $aa01d36dc78131b3$var$getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = $aa01d36dc78131b3$var$getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("path", $aa01d36dc78131b3$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true), {
        fill: singlePath.slice(-1) === "Z" ? others.fill : "none",
        className: layerClass,
        d: singlePath
    }));
};






function $0dca7af5ae2a023f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0dca7af5ae2a023f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0dca7af5ae2a023f$var$_typeof(obj);
}
function $0dca7af5ae2a023f$var$_extends() {
    $0dca7af5ae2a023f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0dca7af5ae2a023f$var$_extends.apply(this, arguments);
}
function $0dca7af5ae2a023f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0dca7af5ae2a023f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0dca7af5ae2a023f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0dca7af5ae2a023f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0dca7af5ae2a023f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0dca7af5ae2a023f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0dca7af5ae2a023f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0dca7af5ae2a023f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0dca7af5ae2a023f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0dca7af5ae2a023f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0dca7af5ae2a023f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0dca7af5ae2a023f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0dca7af5ae2a023f$var$_setPrototypeOf(subClass, superClass);
}
function $0dca7af5ae2a023f$var$_setPrototypeOf(o, p) {
    $0dca7af5ae2a023f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0dca7af5ae2a023f$var$_setPrototypeOf(o, p);
}
function $0dca7af5ae2a023f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0dca7af5ae2a023f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0dca7af5ae2a023f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0dca7af5ae2a023f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0dca7af5ae2a023f$var$_possibleConstructorReturn(this, result);
    };
}
function $0dca7af5ae2a023f$var$_possibleConstructorReturn(self, call) {
    if (call && ($0dca7af5ae2a023f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0dca7af5ae2a023f$var$_assertThisInitialized(self);
}
function $0dca7af5ae2a023f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0dca7af5ae2a023f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0dca7af5ae2a023f$var$_getPrototypeOf(o) {
    $0dca7af5ae2a023f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0dca7af5ae2a023f$var$_getPrototypeOf(o);
}
function $0dca7af5ae2a023f$var$_defineProperty(obj, key, value) {
    key = $0dca7af5ae2a023f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0dca7af5ae2a023f$var$_toPropertyKey(arg) {
    var key = $0dca7af5ae2a023f$var$_toPrimitive(arg, "string");
    return $0dca7af5ae2a023f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0dca7af5ae2a023f$var$_toPrimitive(input, hint) {
    if ($0dca7af5ae2a023f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0dca7af5ae2a023f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0dca7af5ae2a023f$var$RADIAN = Math.PI / 180;
var $0dca7af5ae2a023f$var$eps = 1e-5;
var $0dca7af5ae2a023f$export$67d930e793705898 = /*#__PURE__*/ function(_PureComponent) {
    $0dca7af5ae2a023f$var$_inherits(PolarAngleAxis, _PureComponent);
    var _super = $0dca7af5ae2a023f$var$_createSuper(PolarAngleAxis);
    function PolarAngleAxis() {
        $0dca7af5ae2a023f$var$_classCallCheck(this, PolarAngleAxis);
        return _super.apply(this, arguments);
    }
    $0dca7af5ae2a023f$var$_createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, radius, data.coordinate);
                var p2 = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, radius + (orientation === "inner" ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * $0dca7af5ae2a023f$var$RADIAN);
                var textAnchor;
                if (cos > $0dca7af5ae2a023f$var$eps) textAnchor = orientation === "outer" ? "start" : "end";
                else if (cos < -$0dca7af5ae2a023f$var$eps) textAnchor = orientation === "outer" ? "end" : "start";
                else textAnchor = "middle";
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = $0dca7af5ae2a023f$var$_objectSpread($0dca7af5ae2a023f$var$_objectSpread({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props)), {}, {
                    fill: "none"
                }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(axisLine));
                if (axisLineType === "circle") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $90ad9fc64491da49$export$d046b3c4a416f60d), $0dca7af5ae2a023f$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $aa01d36dc78131b3$export$7d31b617c820d435), $0dca7af5ae2a023f$var$_extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(tick);
                var tickLineProps = $0dca7af5ae2a023f$var$_objectSpread($0dca7af5ae2a023f$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(tickLine));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = $0dca7af5ae2a023f$var$_objectSpread($0dca7af5ae2a023f$var$_objectSpread($0dca7af5ae2a023f$var$_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $0dca7af5ae2a023f$var$_extends({
                        className: "recharts-polar-angle-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", $0dca7af5ae2a023f$var$_extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-polar-angle-axis"
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8722da9ca6e7f376$export$5f1af8db9871e1d6), $0dca7af5ae2a023f$var$_extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarAngleAxis;
}((0, $lDSNw.PureComponent));
$0dca7af5ae2a023f$var$_defineProperty($0dca7af5ae2a023f$export$67d930e793705898, "displayName", "PolarAngleAxis");
$0dca7af5ae2a023f$var$_defineProperty($0dca7af5ae2a023f$export$67d930e793705898, "axisType", "angleAxis");
$0dca7af5ae2a023f$var$_defineProperty($0dca7af5ae2a023f$export$67d930e793705898, "defaultProps", {
    type: "category",
    angleAxisId: 0,
    scale: "auto",
    cx: 0,
    cy: 0,
    orientation: "outer",
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});



var $dc0d8d518375f4a4$exports = {};



/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $dc0d8d518375f4a4$var$minBy(array, iteratee) {
    return array && array.length ? $60cc081a6c7671c3$exports(array, $52c7c35fde7b0b7d$exports(iteratee, 2), $57d8fea5e5433e11$exports) : undefined;
}
$dc0d8d518375f4a4$exports = $dc0d8d518375f4a4$var$minBy;


var $061b74b988266bce$exports = {};



/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $061b74b988266bce$var$maxBy(array, iteratee) {
    return array && array.length ? $60cc081a6c7671c3$exports(array, $52c7c35fde7b0b7d$exports(iteratee, 2), $fb3f6c96a64a9c37$exports) : undefined;
}
$061b74b988266bce$exports = $061b74b988266bce$var$maxBy;



var $lDSNw = parcelRequire("lDSNw");






var $a5b56cc281a569f6$var$_excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], $a5b56cc281a569f6$var$_excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function $a5b56cc281a569f6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a5b56cc281a569f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a5b56cc281a569f6$var$_typeof(obj);
}
function $a5b56cc281a569f6$var$_extends() {
    $a5b56cc281a569f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a5b56cc281a569f6$var$_extends.apply(this, arguments);
}
function $a5b56cc281a569f6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a5b56cc281a569f6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a5b56cc281a569f6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a5b56cc281a569f6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a5b56cc281a569f6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a5b56cc281a569f6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a5b56cc281a569f6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a5b56cc281a569f6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a5b56cc281a569f6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a5b56cc281a569f6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a5b56cc281a569f6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a5b56cc281a569f6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a5b56cc281a569f6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a5b56cc281a569f6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a5b56cc281a569f6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a5b56cc281a569f6$var$_setPrototypeOf(subClass, superClass);
}
function $a5b56cc281a569f6$var$_setPrototypeOf(o, p) {
    $a5b56cc281a569f6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a5b56cc281a569f6$var$_setPrototypeOf(o, p);
}
function $a5b56cc281a569f6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a5b56cc281a569f6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a5b56cc281a569f6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a5b56cc281a569f6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a5b56cc281a569f6$var$_possibleConstructorReturn(this, result);
    };
}
function $a5b56cc281a569f6$var$_possibleConstructorReturn(self, call) {
    if (call && ($a5b56cc281a569f6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a5b56cc281a569f6$var$_assertThisInitialized(self);
}
function $a5b56cc281a569f6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a5b56cc281a569f6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a5b56cc281a569f6$var$_getPrototypeOf(o) {
    $a5b56cc281a569f6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a5b56cc281a569f6$var$_getPrototypeOf(o);
}
function $a5b56cc281a569f6$var$_defineProperty(obj, key, value) {
    key = $a5b56cc281a569f6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a5b56cc281a569f6$var$_toPropertyKey(arg) {
    var key = $a5b56cc281a569f6$var$_toPrimitive(arg, "string");
    return $a5b56cc281a569f6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a5b56cc281a569f6$var$_toPrimitive(input, hint) {
    if ($a5b56cc281a569f6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a5b56cc281a569f6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a5b56cc281a569f6$export$d2607afddf4df58d = /*#__PURE__*/ function(_PureComponent) {
    $a5b56cc281a569f6$var$_inherits(PolarRadiusAxis, _PureComponent);
    var _super = $a5b56cc281a569f6$var$_createSuper(PolarRadiusAxis);
    function PolarRadiusAxis() {
        $a5b56cc281a569f6$var$_classCallCheck(this, PolarRadiusAxis);
        return _super.apply(this, arguments);
    }
    $a5b56cc281a569f6$var$_createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = "end";
                        break;
                    case "right":
                        textAnchor = "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($061b74b988266bce$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, (/*@__PURE__*/$parcel$interopDefault($dc0d8d518375f4a4$exports)))(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = $a5b56cc281a569f6$var$_objectWithoutProperties(_this$props3, $a5b56cc281a569f6$var$_excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, extent[0], angle);
                var point1 = (0, $fb34ba651878b323$export$5c9a959bb3fc7749)(cx, cy, extent[1], angle);
                var props = $a5b56cc281a569f6$var$_objectSpread($a5b56cc281a569f6$var$_objectSpread($a5b56cc281a569f6$var$_objectSpread({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others)), {}, {
                    fill: "none"
                }, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(axisLine)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", $a5b56cc281a569f6$var$_extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = $a5b56cc281a569f6$var$_objectWithoutProperties(_this$props4, $a5b56cc281a569f6$var$_excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others);
                var customTickProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(tick);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = $a5b56cc281a569f6$var$_objectSpread($a5b56cc281a569f6$var$_objectSpread($a5b56cc281a569f6$var$_objectSpread($a5b56cc281a569f6$var$_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $a5b56cc281a569f6$var$_extends({
                        className: "recharts-polar-radius-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-polar-radius-axis"
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, $8a059853790af0f6$export$b04be29aa201d4f5).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $8722da9ca6e7f376$export$5f1af8db9871e1d6), $a5b56cc281a569f6$var$_extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarRadiusAxis;
}((0, $lDSNw.PureComponent));
$a5b56cc281a569f6$var$_defineProperty($a5b56cc281a569f6$export$d2607afddf4df58d, "displayName", "PolarRadiusAxis");
$a5b56cc281a569f6$var$_defineProperty($a5b56cc281a569f6$export$d2607afddf4df58d, "axisType", "radiusAxis");
$a5b56cc281a569f6$var$_defineProperty($a5b56cc281a569f6$export$d2607afddf4df58d, "defaultProps", {
    type: "number",
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: "right",
    stroke: "#ccc",
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: "auto",
    allowDuplicatedCategory: true
});




var $a786daf6318ca405$export$b99d3348f709c998 = (0, $bc90a147d6e1cdb7$export$77871aede60e6838)({
    chartName: "PieChart",
    GraphicalChild: (0, $5aa5233e2c02a9d3$export$2ae8800cf67c848c),
    validateTooltipEventTypes: [
        "item"
    ],
    defaultTooltipEventType: "item",
    legendContent: "children",
    axisComponents: [
        {
            axisType: "angleAxis",
            AxisComp: (0, $0dca7af5ae2a023f$export$67d930e793705898)
        },
        {
            axisType: "radiusAxis",
            AxisComp: (0, $a5b56cc281a569f6$export$d2607afddf4df58d)
        }
    ],
    formatAxisMap: (0, $fb34ba651878b323$export$ece7de1383db5ac),
    defaultProps: {
        layout: "centric",
        startAngle: 0,
        endAngle: 360,
        cx: "50%",
        cy: "50%",
        innerRadius: 0,
        outerRadius: "80%"
    }
});



var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");

var $ef4Zh = parcelRequire("ef4Zh");


/* global Reflect, Promise */ var $74048de8971253e1$var$extendStatics = function(d, b) {
    $74048de8971253e1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $74048de8971253e1$var$extendStatics(d, b);
};
function $74048de8971253e1$var$__extends(d, b) {
    $74048de8971253e1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $74048de8971253e1$var$__assign = function() {
    $74048de8971253e1$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $74048de8971253e1$var$__assign.apply(this, arguments);
};
function $74048de8971253e1$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $74048de8971253e1$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case "debounce":
            return (0, (/*@__PURE__*/$parcel$interopDefault($1007e42b3c091255$exports)))(resizeCallback, refreshRate, refreshOptions);
        case "throttle":
            return (0, (/*@__PURE__*/$parcel$interopDefault($0f96fe226c12ba87$exports)))(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $74048de8971253e1$var$isFunction = function(fn) {
    return typeof fn === "function";
};
var $74048de8971253e1$var$isSSR = function() {
    return typeof window === "undefined";
};
var $74048de8971253e1$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $74048de8971253e1$var$createNotifier = function(setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            return {
                width: width,
                height: height
            };
        });
    };
};
var $74048de8971253e1$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $74048de8971253e1$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($74048de8971253e1$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($74048de8971253e1$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $74048de8971253e1$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $74048de8971253e1$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $ef4Zh.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case "renderProp":
                    return currentElement;
                case "childFunction":
                    return currentElement;
                case "child":
                    return currentElement;
                case "childArray":
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $74048de8971253e1$var$createNotifier(function(setStateFunc) {
                return _this.setState(setStateFunc, function() {
                    return onResize === null || onResize === void 0 ? void 0 : onResize(_this.state.width, _this.state.height);
                });
            }, handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$74048de8971253e1$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($74048de8971253e1$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return "renderProp";
            if ($74048de8971253e1$var$isFunction(children)) return "childFunction";
            if ((0, $lDSNw.isValidElement)(children)) return "child";
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return "childArray";
            // DEPRECATED. Use `Child Function Pattern` instead
            return "parent";
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $lDSNw.createRef)();
        _this.observableElement = null;
        if ($74048de8971253e1$var$isSSR()) return _this;
        _this.resizeHandler = $74048de8971253e1$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($74048de8971253e1$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? "div" : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        switch(renderType){
            case "renderProp":
                return render === null || render === void 0 ? void 0 : render(childProps);
            case "childFunction":
                var childFunction = children;
                return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
            case "child":
                // @TODO bug prone logic
                var child = children;
                if (child.type && typeof child.type === "string") {
                    // child is a native DOM elements such as div, span etc
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    childProps.targetRef;
                    var nativeProps = $74048de8971253e1$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $lDSNw.cloneElement)(child, nativeProps);
                }
                // class or functional component otherwise
                return (0, $lDSNw.cloneElement)(child, childProps);
            case "childArray":
                var childArray = children;
                return childArray.map(function(el) {
                    return !!el && (0, $lDSNw.cloneElement)(el, childProps);
                });
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $lDSNw.PureComponent));
function $74048de8971253e1$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $74048de8971253e1$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $lDSNw.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $74048de8971253e1$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($74048de8971253e1$export$2e2bcd8739ae039, $74048de8971253e1$var$__assign({}, options, {
                targetRef: targetRef
            }), (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(ComponentInner, $74048de8971253e1$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $lDSNw.Component));
    function forwardRefWrapper(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(ResizeDetectorHOC, $74048de8971253e1$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $lDSNw.forwardRef)(forwardRefWrapper);
}
var $74048de8971253e1$var$useEnhancedEffect = $74048de8971253e1$var$isSSR() ? (0, $lDSNw.useEffect) : (0, $lDSNw.useLayoutEffect);
function $74048de8971253e1$export$453c3d1cba18d800(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.skipOnMount, skipOnMount = _c === void 0 ? false : _c, refreshMode = _b.refreshMode, _d = _b.refreshRate, refreshRate = _d === void 0 ? 1000 : _d, refreshOptions = _b.refreshOptions, _e = _b.handleWidth, handleWidth = _e === void 0 ? true : _e, _f = _b.handleHeight, handleHeight = _f === void 0 ? true : _f, targetRef = _b.targetRef, observerOptions = _b.observerOptions, onResize = _b.onResize;
    var skipResize = (0, $lDSNw.useRef)(skipOnMount);
    var localRef = (0, $lDSNw.useRef)(null);
    var resizeHandler = (0, $lDSNw.useRef)();
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var _g = (0, $lDSNw.useState)({
        width: undefined,
        height: undefined
    }), size = _g[0], setSize = _g[1];
    $74048de8971253e1$var$useEnhancedEffect(function() {
        if (!handleWidth && !handleHeight) return;
        var notifyResize = $74048de8971253e1$var$createNotifier(setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current;
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $74048de8971253e1$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) resizeObserver.observe(ref.current, observerOptions);
        return function() {
            var _a, _b;
            resizeObserver.disconnect();
            (_b = (_a = resizeHandler.current).cancel) === null || _b === void 0 || _b.call(_a);
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        observerOptions,
        ref.current
    ]);
    (0, $lDSNw.useEffect)(function() {
        onResize === null || onResize === void 0 || onResize(size.width, size.height);
    }, [
        size
    ]);
    return $74048de8971253e1$var$__assign({
        ref: ref
    }, size);
}




function $023ad977e9872439$var$_extends() {
    $023ad977e9872439$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $023ad977e9872439$var$_extends.apply(this, arguments);
}
function $023ad977e9872439$var$_slicedToArray(arr, i) {
    return $023ad977e9872439$var$_arrayWithHoles(arr) || $023ad977e9872439$var$_iterableToArrayLimit(arr, i) || $023ad977e9872439$var$_unsupportedIterableToArray(arr, i) || $023ad977e9872439$var$_nonIterableRest();
}
function $023ad977e9872439$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $023ad977e9872439$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $023ad977e9872439$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $023ad977e9872439$var$_arrayLikeToArray(o, minLen);
}
function $023ad977e9872439$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $023ad977e9872439$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $023ad977e9872439$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $023ad977e9872439$export$e60a4704009a0009 = /*#__PURE__*/ (0, $lDSNw.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize;
    var _useState = (0, $lDSNw.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $023ad977e9872439$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var containerRef = (0, $lDSNw.useRef)(null);
    (0, $lDSNw.useImperativeHandle)(ref, function() {
        return containerRef;
    }, [
        containerRef
    ]);
    var getContainerSize = (0, $lDSNw.useCallback)(function() {
        if (!containerRef.current) return null;
        return {
            containerWidth: containerRef.current.clientWidth,
            containerHeight: containerRef.current.clientHeight
        };
    }, []);
    var updateDimensionsImmediate = (0, $lDSNw.useCallback)(function() {
        var newSize = getContainerSize();
        if (newSize) {
            var containerWidth = newSize.containerWidth, containerHeight = newSize.containerHeight;
            if (onResize) onResize(containerWidth, containerHeight);
            setSizes(function(currentSizes) {
                var oldWidth = currentSizes.containerWidth, oldHeight = currentSizes.containerHeight;
                if (containerWidth !== oldWidth || containerHeight !== oldHeight) return {
                    containerWidth: containerWidth,
                    containerHeight: containerHeight
                };
                return currentSizes;
            });
        }
    }, [
        getContainerSize,
        onResize
    ]);
    var chartContent = (0, $lDSNw.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)((0, $aee02c7eefa94d8b$export$e50269385c77c348)(width) || (0, $aee02c7eefa94d8b$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $aee02c7eefa94d8b$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $aee02c7eefa94d8b$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $befee2dc5ecaf26b$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        return /*#__PURE__*/ (0, $lDSNw.cloneElement)(children, {
            width: calculatedWidth,
            height: calculatedHeight
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    (0, $lDSNw.useEffect)(function() {
        var size = getContainerSize();
        if (size) setSizes(size);
    }, [
        getContainerSize
    ]);
    var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $74048de8971253e1$export$2e2bcd8739ae039), {
        handleWidth: true,
        handleHeight: true,
        onResize: updateDimensionsImmediate,
        targetRef: containerRef,
        refreshMode: debounce > 0 ? "debounce" : undefined,
        refreshRate: debounce
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("div", $023ad977e9872439$var$_extends({}, id != null ? {
        id: "".concat(id)
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-responsive-container", className),
        style: style,
        ref: containerRef
    }), chartContent));
});


function $4e1434c56bc5fb69$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4e1434c56bc5fb69$export$2b05aa197bed65b6 = ({ data: data = [], onItemHoverLeave: onItemHoverLeave = ()=>{}, width: width = 250, height: height = 180 })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($4e1434c56bc5fb69$var$RelativeScoreCompareChartRoot, {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
            minWidth: width,
            minHeight: height,
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $a786daf6318ca405$export$b99d3348f709c998), {
                width: width,
                height: height,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $22f8c7fa15a15fc3$export$ed247974535929c7), {
                        iconSize: 15,
                        width: 130,
                        height: 200,
                        layout: "vertical",
                        verticalAlign: "bottom",
                        align: "right"
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5aa5233e2c02a9d3$export$2ae8800cf67c848c), {
                        data: data,
                        cx: 125,
                        cy: 180,
                        startAngle: 180,
                        endAngle: 0,
                        innerRadius: 60,
                        outerRadius: 80,
                        fill: "#8884d8",
                        paddingAngle: 5,
                        dataKey: "value",
                        children: data.map(({ fill: fill }, index)=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1a0af961fe314d4f$export$f6f0c3fe4ec306ea), {
                                fill: fill,
                                onMouseEnter: ()=>onItemHoverLeave(data[index].name),
                                onMouseLeave: ()=>onItemHoverLeave()
                            }, `cell-${index}`))
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $deb1267103fb31f8$export$28c660c63b792dea), {})
                ]
            })
        })
    });
const $4e1434c56bc5fb69$var$RelativeScoreCompareChartRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "eugs6oc0"
})({
    name: "1p95zaa",
    styles: "margin-left:25px;.recharts-legend-wrapper{pointer-events:none;position:relative!important;margin-top:40px;margin-left:55px;ul{li{margin-top:10px;font-size:14px;font-weight:bold;}}}"
});




var $lDSNw = parcelRequire("lDSNw");

parcelRequire("lDSNw");
var $5eabc5d0503c2071$exports = {};

$parcel$export($5eabc5d0503c2071$exports, "cardContainer", function () { return $5eabc5d0503c2071$export$6b2d426110a11d7a; }, function (v) { return $5eabc5d0503c2071$export$6b2d426110a11d7a = v; });
$parcel$export($5eabc5d0503c2071$exports, "cardImage", function () { return $5eabc5d0503c2071$export$8654921a6a5908fc; }, function (v) { return $5eabc5d0503c2071$export$8654921a6a5908fc = v; });
$parcel$export($5eabc5d0503c2071$exports, "cardTitle", function () { return $5eabc5d0503c2071$export$3aac624c619dfa7f; }, function (v) { return $5eabc5d0503c2071$export$3aac624c619dfa7f = v; });
$parcel$export($5eabc5d0503c2071$exports, "firstCard", function () { return $5eabc5d0503c2071$export$ce135c5e25be73ee; }, function (v) { return $5eabc5d0503c2071$export$ce135c5e25be73ee = v; });
$parcel$export($5eabc5d0503c2071$exports, "ranking", function () { return $5eabc5d0503c2071$export$893da7a5de6ad431; }, function (v) { return $5eabc5d0503c2071$export$893da7a5de6ad431 = v; });
var $5eabc5d0503c2071$export$6b2d426110a11d7a;
var $5eabc5d0503c2071$export$8654921a6a5908fc;
var $5eabc5d0503c2071$export$3aac624c619dfa7f;
var $5eabc5d0503c2071$export$ce135c5e25be73ee;
var $5eabc5d0503c2071$export$893da7a5de6ad431;
$5eabc5d0503c2071$export$6b2d426110a11d7a = `_05uEZW_cardContainer`;
$5eabc5d0503c2071$export$8654921a6a5908fc = `_05uEZW_cardImage`;
$5eabc5d0503c2071$export$3aac624c619dfa7f = `_05uEZW_cardTitle`;
$5eabc5d0503c2071$export$ce135c5e25be73ee = `_05uEZW_firstCard`;
$5eabc5d0503c2071$export$893da7a5de6ad431 = `_05uEZW_ranking`;


const $4fd37e908d2cd4a6$var$CATRouselCard = (props)=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($5eabc5d0503c2071$exports))).cardContainer} ${props.ranking === 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($5eabc5d0503c2071$exports))).firstCard : null}`,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                // style={{ backgroundImage: `url(${props.image})` }}
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5eabc5d0503c2071$exports))).cardImage,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
                    src: props.image,
                    style: {
                        height: "auto",
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5eabc5d0503c2071$exports))).cardTitle,
                children: props.title.replace(/_/g, " ")
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5eabc5d0503c2071$exports))).ranking,
                children: [
                    "#",
                    props.ranking
                ]
            })
        ]
    });
};
var $4fd37e908d2cd4a6$export$2e2bcd8739ae039 = $4fd37e908d2cd4a6$var$CATRouselCard;



const $db5e93aa6b08855c$export$507c9b29d3aea303 = /*#__PURE__*/ (0, $lDSNw.forwardRef)(({ recommendations: recommendations }, ref)=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).cardsContainer,
        ref: ref,
        children: recommendations.map((recommendation, index)=>{
            return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4fd37e908d2cd4a6$export$2e2bcd8739ae039), {
                image: recommendation.url,
                title: recommendation.id,
                ranking: index + 1
            }, index);
        })
    });
});


const $176b22b005b5f212$export$bbb6dbedeed940c2 = ({ currentDomainRecommendations: currentDomainRecommendations, creativeData: creativeData })=>{
    const [chartData, setChartData] = (0, $lDSNw.useState)([]);
    const [recommendations, setRecommendations] = (0, $lDSNw.useState)([]);
    (0, $lDSNw.useEffect)(()=>{
        if (creativeData?.DCOA && currentDomainRecommendations) {
            const recoPrep = (0, $1eefc8ec6b0aa42b$export$4a168f3c5dfef519)(currentDomainRecommendations);
            setRecommendations(recoPrep);
            const chartData = (0, $1eefc8ec6b0aa42b$export$6eaed201bc0ad2f9)(recoPrep);
            setChartData(chartData);
        }
    }, [
        creativeData,
        currentDomainRecommendations
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: creativeData?.DCOA?.type === "carousel" && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                    name: "topProducts",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).sectionTitle,
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                            icon: (0, $36045e57d0ad82eb$export$bc8ca14ab51f93db)
                        }),
                        "Top Products"
                    ]
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $db5e93aa6b08855c$export$507c9b29d3aea303), {
                    recommendations: recommendations
                })
            ]
        })
    });
};







var $lDSNw = parcelRequire("lDSNw");





var $6f1cc25c964e79da$exports = {};
"use strict";
Object.defineProperty($6f1cc25c964e79da$exports, "__esModule", {
    value: true
});

var $lDSNw = parcelRequire("lDSNw");
function $6f1cc25c964e79da$var$createStore(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
var $6f1cc25c964e79da$var$isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var $6f1cc25c964e79da$var$useIsomorphicLayoutEffect = $6f1cc25c964e79da$var$isSSR ? $lDSNw.useEffect : $lDSNw.useLayoutEffect;
function $6f1cc25c964e79da$var$create(createState) {
    var api = typeof createState === "function" ? $6f1cc25c964e79da$var$createStore(createState) : createState;
    var useStore = function useStore(selector, equalityFn) {
        if (selector === void 0) selector = api.getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var _ref = $lDSNw.useReducer(function(c) {
            return c + 1;
        }, 0), forceUpdate = _ref[1];
        var state = api.getState();
        var stateRef = $lDSNw.useRef(state);
        var selectorRef = $lDSNw.useRef(selector);
        var equalityFnRef = $lDSNw.useRef(equalityFn);
        var erroredRef = $lDSNw.useRef(false);
        var currentSliceRef = $lDSNw.useRef();
        if (currentSliceRef.current === undefined) currentSliceRef.current = selector(state);
        var newStateSlice;
        var hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        $6f1cc25c964e79da$var$useIsomorphicLayoutEffect(function() {
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        var stateBeforeSubscriptionRef = $lDSNw.useRef(state);
        $6f1cc25c964e79da$var$useIsomorphicLayoutEffect(function() {
            var listener = function listener() {
                try {
                    var nextState = api.getState();
                    var nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            var unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        var sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
        $lDSNw.useDebugValue(sliceToReturn);
        return sliceToReturn;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
        var items = [
            useStore,
            api
        ];
        return {
            next: function next() {
                var done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}
$6f1cc25c964e79da$exports["default"] = $6f1cc25c964e79da$var$create;




// checking if the buildID value is a: pxyz buildID, a pxyz creativeID or a gumgum adBuyID
function $3205e0f1ddb62c1d$var$isCreativeID(buildID) {
    return buildID.length === 32;
}
function $3205e0f1ddb62c1d$var$isNumber(value) {
    // Convert the value to a number and check if it is NaN.
    return !isNaN(Number(value));
}
function $3205e0f1ddb62c1d$var$isAdBuyID(buildID) {
    // AdBuyIDs are numbers - other IDs are strings
    return $3205e0f1ddb62c1d$var$isNumber(buildID);
}
const $3205e0f1ddb62c1d$export$fb7e043d17077d69 = (buildID)=>{
    return $3205e0f1ddb62c1d$var$isCreativeID(buildID) || $3205e0f1ddb62c1d$var$isAdBuyID(buildID);
};


const $9d599987579e8430$export$4e70f71bf0757296 = async (buildId)=>{
    // if the buildId is a ad line id or creative id, we'll need to find the buildId to load
    // here we'll need to query for a scrub session with the ad/creative id and access the parent collection for the buildId
    if ((0, $3205e0f1ddb62c1d$export$fb7e043d17077d69)(buildId)) {
        const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collectionGroup("scrubSessions").where("creativeID", "==", buildId).limit(1);
        const querySnapshot = await dataRef.get();
        if (querySnapshot.docs.length > 0) buildId = querySnapshot.docs[0].ref.parent.parent.id;
        else throw "No data.";
    }
    // note: this above logic is repeated in /hooks/useStudioBuildID.js - it would be good to consolidate this logic
    const creativeURL = `https://studio.playgroundxyz.com/${buildId}/quiet?pos=middle-ad&size=300x250&dpframe=0`;
    return fetch(creativeURL).then((res)=>res.text()).then((result)=>result, (error)=>{
        console.error("Cannot fetch the creative:", error);
    });
};


const $765e87d18dbf9ea1$export$e4710db0108d3739 = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        items: [],
        get: (buildId)=>get().items.find((item)=>item.buildId === buildId),
        update: (buildId, data)=>{
            set((state)=>({
                    items: state.items.map((item)=>item.buildId === buildId ? {
                            ...item,
                            ...data
                        } : item)
                }));
        },
        create: async (buildIds)=>{
            const newCreatives = await Promise.all(buildIds.map(async (buildId)=>{
                return {
                    buildId: buildId,
                    iframeSrcDoc: await (0, $9d599987579e8430$export$4e70f71bf0757296)(buildId),
                    iframeLoaded: false,
                    dwellTimes: [],
                    sessionSize: null,
                    scrollMode: null,
                    sequences: null,
                    videoSequences: null,
                    creativeScrollProgress: null,
                    domainsList: [],
                    format: null
                };
            }));
            set((state)=>({
                    items: [
                        ...state.items,
                        ...newCreatives
                    ]
                }));
        },
        delete: (buildId)=>{
            set((state)=>({
                    items: state.items.filter((item)=>item.buildId !== buildId)
                }));
        },
        loadCreativeSequences: async (minSequenceLength = 1, triggerType = "scrub", domainWhiteList = [])=>{
            const buildIds = get().items.map(({ buildId: buildId })=>buildId);
            await Promise.all(buildIds.map(async (buildId)=>{
                let sequenceData = await (0, $abbc57578fc5f1d4$export$c554f64eaaa85ca7)({
                    buildID: buildId,
                    minSequenceLength: minSequenceLength,
                    triggerType: triggerType,
                    filterDomain: domainWhiteList
                });
                const { dwellTimes: dwellTimes, sessionSize: sessionSize, scrollMode: scrollMode, sequences: sequences, videoSequences: videoSequences, scrubBaseline: scrubBaseline, dwellTimeBaseline: dwellTimeBaseline = [], scriptVersion: scriptVersion, brandNames: brandNames, campaignNames: campaignNames, creativeNames: creativeNames, format: format, domainsList: domainsList } = sequenceData.data;
                get().update(buildId, {
                    dwellTimes: dwellTimes,
                    sessionSize: sessionSize,
                    scrollMode: scrollMode,
                    sequences: sequences,
                    videoSequences: videoSequences,
                    scrubBaseline: scrubBaseline,
                    dwellTimeBaseline: dwellTimeBaseline,
                    scriptVersion: scriptVersion,
                    brandNames: brandNames,
                    campaignNames: campaignNames,
                    creativeNames: creativeNames,
                    format: format,
                    domainsList: domainsList
                });
            }));
        },
        cleanUp: ()=>{
            set(()=>({
                    items: []
                }));
        }
    })); // if (process.env.NODE_ENV === "development") {
 //   mountStoreDevtool("CreativeStore", useCreatives);
 // }




var $lDSNw = parcelRequire("lDSNw");








var $lDSNw = parcelRequire("lDSNw");










var $327c7a210e36e160$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
];
function $327c7a210e36e160$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $327c7a210e36e160$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $327c7a210e36e160$var$_typeof(obj);
}
function $327c7a210e36e160$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $327c7a210e36e160$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $327c7a210e36e160$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $327c7a210e36e160$var$_extends() {
    $327c7a210e36e160$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $327c7a210e36e160$var$_extends.apply(this, arguments);
}
function $327c7a210e36e160$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $327c7a210e36e160$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $327c7a210e36e160$var$ownKeys(Object(source), !0).forEach(function(key) {
            $327c7a210e36e160$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $327c7a210e36e160$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $327c7a210e36e160$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $327c7a210e36e160$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $327c7a210e36e160$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $327c7a210e36e160$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $327c7a210e36e160$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $327c7a210e36e160$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $327c7a210e36e160$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $327c7a210e36e160$var$_setPrototypeOf(subClass, superClass);
}
function $327c7a210e36e160$var$_setPrototypeOf(o, p) {
    $327c7a210e36e160$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $327c7a210e36e160$var$_setPrototypeOf(o, p);
}
function $327c7a210e36e160$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $327c7a210e36e160$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $327c7a210e36e160$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $327c7a210e36e160$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $327c7a210e36e160$var$_possibleConstructorReturn(this, result);
    };
}
function $327c7a210e36e160$var$_possibleConstructorReturn(self, call) {
    if (call && ($327c7a210e36e160$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $327c7a210e36e160$var$_assertThisInitialized(self);
}
function $327c7a210e36e160$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $327c7a210e36e160$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $327c7a210e36e160$var$_getPrototypeOf(o) {
    $327c7a210e36e160$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $327c7a210e36e160$var$_getPrototypeOf(o);
}
function $327c7a210e36e160$var$_defineProperty(obj, key, value) {
    key = $327c7a210e36e160$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $327c7a210e36e160$var$_toPropertyKey(arg) {
    var key = $327c7a210e36e160$var$_toPrimitive(arg, "string");
    return $327c7a210e36e160$var$_typeof(key) === "symbol" ? key : String(key);
}
function $327c7a210e36e160$var$_toPrimitive(input, hint) {
    if ($327c7a210e36e160$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($327c7a210e36e160$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $327c7a210e36e160$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $327c7a210e36e160$var$_inherits(Area, _PureComponent);
    var _super = $327c7a210e36e160$var$_createSuper(Area);
    function Area() {
        var _this;
        $327c7a210e36e160$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $327c7a210e36e160$var$_defineProperty($327c7a210e36e160$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true
        });
        $327c7a210e36e160$var$_defineProperty($327c7a210e36e160$var$_assertThisInitialized(_this), "id", (0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("recharts-area-"));
        $327c7a210e36e160$var$_defineProperty($327c7a210e36e160$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $327c7a210e36e160$var$_defineProperty($327c7a210e36e160$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $327c7a210e36e160$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $327c7a210e36e160$var$_objectSpread($327c7a210e36e160$var$_objectSpread($327c7a210e36e160$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $327c7a210e36e160$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxY = Math.max(baseLine, maxY);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxX = Math.max(baseLine, maxX);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($7a8edb845f1490bc$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === "vertical") return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $327c7a210e36e160$var$_objectWithoutProperties(_this$props4, $327c7a210e36e160$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1), $327c7a210e36e160$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== "none" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1), $327c7a210e36e160$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== "none" && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1), $327c7a210e36e160$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = _.isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $1f1c6c2214af1451$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $327c7a210e36e160$var$_objectSpread($327c7a210e36e160$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") {
                            var interpolator = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($ebdb18b484d894aa$exports)))(baseLine)) {
                            var _interpolator = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $327c7a210e36e160$var$_objectSpread($327c7a210e36e160$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($accecf4f4d483c19$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($accecf4f4d483c19$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-area", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $65af1a52cac4dd09$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $0c2a2118f871337c$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $lDSNw.PureComponent));
$327c7a210e36e160$var$_defineProperty($327c7a210e36e160$export$ea1a111407f37557, "displayName", "Area");
$327c7a210e36e160$var$_defineProperty($327c7a210e36e160$export$ea1a111407f37557, "defaultProps", {
    stroke: "#3182bd",
    fill: "#3182bd",
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: "line",
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
});
$327c7a210e36e160$var$_defineProperty($327c7a210e36e160$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(baseValue) && typeof baseValue === "number") return baseValue;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var max = Math.max(domain[0], domain[1]);
        var min = Math.min(domain[0], domain[1]);
        if (baseValue === "dataMin") return min;
        if (baseValue === "dataMax") return max;
        return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === "dataMin") return domain[0];
    if (baseValue === "dataMax") return domain[1];
    return domain[0];
});
$327c7a210e36e160$var$_defineProperty($327c7a210e36e160$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $327c7a210e36e160$export$ea1a111407f37557.getBaseValue(props, item, xAxis, yAxis);
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var originalValue = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, dataKey);
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = originalValue;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($84ca1aa52314c546$exports)))(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(value[1]) || hasStack && (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(originalValue);
        if (layout === "horizontal") return {
            x: (0, $ecbafd4b4677e0ac$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $ecbafd4b4677e0ac$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        if (layout === "horizontal") return {
            x: entry.x,
            y: !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(entry, "value[0]")) && !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(entry, "y")) ? yAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(entry, "value[0]")) : null
        };
        return {
            x: !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(entry, "value[0]")) ? xAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($e98d756dd2f93ef0$exports)))(entry, "value[0]")) : null,
            y: entry.y
        };
    });
    else if (layout === "horizontal") baseLine = yAxis.scale(baseValue);
    else baseLine = xAxis.scale(baseValue);
    return $327c7a210e36e160$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$327c7a210e36e160$var$_defineProperty($327c7a210e36e160$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $90ad9fc64491da49$export$d046b3c4a416f60d), $327c7a210e36e160$var$_extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
});

/**
 * @fileOverview Area Chart
 */ 

/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $15dd4d13ef92156e$export$ea77231de273b52d = function XAxis() {
    return null;
};
$15dd4d13ef92156e$export$ea77231de273b52d.displayName = "XAxis";
$15dd4d13ef92156e$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $43d5f89303df56d7$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$43d5f89303df56d7$export$f96c4024c52de8f4.displayName = "YAxis";
$43d5f89303df56d7$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};



var $141478e0e2068f7a$export$f510429275d6f1a8 = (0, $bc90a147d6e1cdb7$export$77871aede60e6838)({
    chartName: "AreaChart",
    GraphicalChild: (0, $327c7a210e36e160$export$ea1a111407f37557),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $15dd4d13ef92156e$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $43d5f89303df56d7$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $28de3275627d2ded$export$ece7de1383db5ac)
});



var $lDSNw = parcelRequire("lDSNw");


var $4dcb9526aae227cc$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
];
function $4dcb9526aae227cc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4dcb9526aae227cc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4dcb9526aae227cc$var$_typeof(obj);
}
function $4dcb9526aae227cc$var$_extends() {
    $4dcb9526aae227cc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4dcb9526aae227cc$var$_extends.apply(this, arguments);
}
function $4dcb9526aae227cc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4dcb9526aae227cc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4dcb9526aae227cc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4dcb9526aae227cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4dcb9526aae227cc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4dcb9526aae227cc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4dcb9526aae227cc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4dcb9526aae227cc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4dcb9526aae227cc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4dcb9526aae227cc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4dcb9526aae227cc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4dcb9526aae227cc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4dcb9526aae227cc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4dcb9526aae227cc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4dcb9526aae227cc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4dcb9526aae227cc$var$_setPrototypeOf(subClass, superClass);
}
function $4dcb9526aae227cc$var$_setPrototypeOf(o, p) {
    $4dcb9526aae227cc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4dcb9526aae227cc$var$_setPrototypeOf(o, p);
}
function $4dcb9526aae227cc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4dcb9526aae227cc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4dcb9526aae227cc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4dcb9526aae227cc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4dcb9526aae227cc$var$_possibleConstructorReturn(this, result);
    };
}
function $4dcb9526aae227cc$var$_possibleConstructorReturn(self, call) {
    if (call && ($4dcb9526aae227cc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4dcb9526aae227cc$var$_assertThisInitialized(self);
}
function $4dcb9526aae227cc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4dcb9526aae227cc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4dcb9526aae227cc$var$_getPrototypeOf(o) {
    $4dcb9526aae227cc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4dcb9526aae227cc$var$_getPrototypeOf(o);
}
function $4dcb9526aae227cc$var$_defineProperty(obj, key, value) {
    key = $4dcb9526aae227cc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4dcb9526aae227cc$var$_toPropertyKey(arg) {
    var key = $4dcb9526aae227cc$var$_toPrimitive(arg, "string");
    return $4dcb9526aae227cc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4dcb9526aae227cc$var$_toPrimitive(input, hint) {
    if ($4dcb9526aae227cc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4dcb9526aae227cc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4dcb9526aae227cc$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $4dcb9526aae227cc$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $4dcb9526aae227cc$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $4dcb9526aae227cc$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $4dcb9526aae227cc$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $4dcb9526aae227cc$var$_objectSpread($4dcb9526aae227cc$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $4dcb9526aae227cc$var$_objectSpread($4dcb9526aae227cc$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
                    return Math.round(e + x - x);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
                var items = roundedSortedVerticalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedVerticalPoints[i + 1];
                    var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: entry,
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
                    return Math.round(e + y - y);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
                var items = roundedSortedHorizontalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
                    var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: entry,
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === "none") return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight;
                if (!(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(x) || x !== +x || !(0, $aee02c7eefa94d8b$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints;
                // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(horizontalCoordinatesGenerator)) horizontalPoints = horizontalCoordinatesGenerator({
                    yAxis: yAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(verticalCoordinatesGenerator)) verticalPoints = verticalCoordinatesGenerator({
                    xAxis: xAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $4dcb9526aae227cc$var$_objectWithoutProperties(props, $4dcb9526aae227cc$var$_excluded);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("line", $4dcb9526aae227cc$var$_extends({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others), {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $lDSNw.PureComponent));
$4dcb9526aae227cc$var$_defineProperty($4dcb9526aae227cc$export$6440e27b9f186856, "displayName", "CartesianGrid");
$4dcb9526aae227cc$var$_defineProperty($4dcb9526aae227cc$export$6440e27b9f186856, "defaultProps", {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
});



const $bb694f7d1eba5bdb$export$10ae52a8e50aaeda = ({ buildId: buildId, onAreaSelected: onAreaSelected, recommendations: recommendations, selectedVideo: selectedVideo })=>{
    const [creative = null] = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.items);
    const addCreatives = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.create);
    const loadCreativeSequences = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.loadCreativeSequences);
    (0, $lDSNw.useEffect)(()=>{
        addCreatives([
            buildId
        ]);
    }, []);
    const [data, setData] = (0, $lDSNw.useState)([]);
    (0, $lDSNw.useEffect)(()=>{
        !creative?.sequences && loadCreativeSequences();
        if (creative?.videoSequences) setData(Object.entries(creative.videoSequences).map(([key, { videoDropOffCollector: videoDropOffCollector }])=>{
            const [_, filename] = key.split("_");
            const { id: id = null } = recommendations.find((item)=>{
                return new RegExp(filename).test(item.videoSource);
            }) || {};
            return {
                key: key,
                id: id,
                videoDropOffCollector: videoDropOffCollector
            };
        }));
    }, [
        creative
    ]);
    const [refAreaLeft, setRefAreaLeft] = (0, $lDSNw.useState)("");
    const [refAreaRight, setRefAreaRight] = (0, $lDSNw.useState)("");
    const [dragging, setDragging] = (0, $lDSNw.useState)(false);
    (0, $lDSNw.useEffect)(()=>{
        setRefAreaLeft("");
        setRefAreaRight("");
    }, [
        selectedVideo
    ]);
    return data.length ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8c971e9544ccda33$export$98f03c5d19621d70), {
                styles: (0, $8c971e9544ccda33$export$dbf350e5966cf602)(".col-resize-hover{path{transition:var(--transitions-0);}&:hover{", selectedVideo ? `cursor: col-resize;` : "", ";}}", "")
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                width: "80%",
                aspect: 5 / 3,
                maxHeight: 270,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $141478e0e2068f7a$export$f510429275d6f1a8), {
                    data: Array.from({
                        length: 100
                    }, (_, i)=>({
                            timeline: i,
                            ...data.map(({ key: key, videoDropOffCollector: videoDropOffCollector })=>({
                                    key: key,
                                    value: videoDropOffCollector[i]
                                })).reduce((acc, { key: key, value: value })=>{
                                acc[key] = value;
                                return acc;
                            }, {})
                        })),
                    margin: {
                        top: 0,
                        right: 10,
                        left: 50,
                        bottom: 20
                    },
                    onMouseDown: (e)=>{
                        if (!selectedVideo) return;
                        setDragging(true);
                        setRefAreaLeft(e.activeLabel);
                        setRefAreaRight(null);
                    },
                    onMouseMove: (e)=>{
                        if (!selectedVideo) return;
                        dragging && refAreaLeft && setRefAreaRight(e.activeLabel);
                    },
                    onMouseUp: ()=>{
                        if (!selectedVideo) return;
                        setDragging(false);
                        onAreaSelected(refAreaLeft < refAreaRight ? {
                            start: refAreaLeft / 100,
                            end: refAreaRight / 100
                        } : {
                            start: refAreaRight / 100,
                            end: refAreaLeft / 100
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                            stroke: "#e8e8e8",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                            dataKey: "timeline",
                            type: "number",
                            tickLine: true,
                            domain: [
                                0,
                                100
                            ],
                            allowDataOverflow: true,
                            axisLine: false,
                            ticks: [
                                "Video start",
                                "Video end"
                            ],
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8a059853790af0f6$export$b04be29aa201d4f5), {
                                    value: "Video start",
                                    offset: 0,
                                    position: "insideLeft",
                                    style: {
                                        fontSize: "100%",
                                        fill: "#e0e0e0"
                                    }
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8a059853790af0f6$export$b04be29aa201d4f5), {
                                    value: "Video end",
                                    offset: 0,
                                    position: "insideRight",
                                    style: {
                                        fontSize: "100%",
                                        fill: "#e0e0e0"
                                    }
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8a059853790af0f6$export$b04be29aa201d4f5), {
                                    value: "Video Drop off Rate (%)",
                                    offset: -40,
                                    angle: -90,
                                    position: "insideTopLeft",
                                    style: {
                                        fontSize: "130%",
                                        fill: "#c5c5c5"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("defs", {
                            children: data.map(({ key: key }, i)=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("linearGradient", {
                                    id: `color${key}`,
                                    x1: "0",
                                    y1: "0",
                                    x2: "0",
                                    y2: "1",
                                    children: [
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "5%",
                                            stopColor: (0, $1eefc8ec6b0aa42b$export$eb4a6c9777179c4c)(i),
                                            stopOpacity: 0.8
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "95%",
                                            stopColor: (0, $1eefc8ec6b0aa42b$export$eb4a6c9777179c4c)(i),
                                            stopOpacity: 0
                                        })
                                    ]
                                }, key))
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                            axisLine: false,
                            tickLine: false,
                            hide: true
                        }),
                        data.map(({ key: key, id: id }, i)=>{
                            const stroke = (0, $1eefc8ec6b0aa42b$export$eb4a6c9777179c4c)(i);
                            const fill = `url(#color${key})`;
                            return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                                className: "col-resize-hover",
                                opacity: selectedVideo && selectedVideo !== id ? 0.2 : 1,
                                type: "monotone",
                                dataKey: key,
                                stroke: stroke,
                                strokeWidth: selectedVideo && selectedVideo !== id ? 2 : 4,
                                fill: fill,
                                isAnimationActive: false,
                                ...selectedVideo && selectedVideo !== id ? {
                                    strokeDasharray: "5,5"
                                } : {}
                            }, key);
                        }),
                        refAreaLeft && refAreaRight && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                            x: refAreaLeft,
                            stroke: "var(--colors-neutral-2)",
                            strokeWidth: "1px",
                            isFront: true
                        }),
                        refAreaLeft && refAreaRight && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                            x: refAreaRight,
                            stroke: "var(--colors-neutral-2)",
                            strokeWidth: "1px",
                            isFront: true
                        }),
                        refAreaLeft && refAreaRight && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2557e4e77e0ef47b$export$b4ec4f050ce240b9), {
                            x1: refAreaLeft,
                            x2: refAreaRight,
                            stroke: "var(--colors-neutral-3)",
                            strokeOpacity: 0.3
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4c28a9656c805907$export$ba01ffa8d63a745d), {});
};








var $lDSNw = parcelRequire("lDSNw");





var $lDSNw = parcelRequire("lDSNw");
function $8f02ef5ae77e5c0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8f02ef5ae77e5c0c$export$f503bc85d719e8b0 = ({ id: id, src: src, onMouseEnterLeave: onMouseEnterLeave, onSelect: onSelect, isSelected: isSelected = null, color: color, start: start = 0, end: end = 1, isUserMuted: isUserMuted = true, isHighlighted: isHighlighted = null, isWinner: isWinner = false })=>{
    const ref = (0, $lDSNw.useRef)();
    const onMouseEnter = (id)=>{
        onMouseEnterLeave(id);
        if (!isSelected) {
            ref.current.muted = true;
            ref.current.playbackRate = 5;
            ref.current.play();
        }
    };
    const onMouseLeave = ()=>{
        onMouseEnterLeave();
        if (!isSelected) {
            ref.current.currentTime = 0;
            ref.current.pause();
        }
    };
    const playClip = (e)=>{
        const { duration: duration, currentTime: currentTime } = e.target;
        if (currentTime >= duration * end) e.target.currentTime = duration * start;
        if (currentTime < duration * start) e.target.currentTime = duration * start;
    };
    (0, $lDSNw.useEffect)(()=>{
        ref.current.currentTime = 0;
        if (isSelected) {
            ref.current.muted = isUserMuted || false;
            ref.current.playbackRate = 1;
            ref.current.play();
        } else ref.current.pause();
        return ()=>{
            ref.current.pause();
        };
    }, [
        isSelected,
        isUserMuted
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (isSelected) {
            ref.current.currentTime = 0;
            ref.current.addEventListener("timeupdate", playClip, false);
            ref.current.muted = true;
            ref.current.play();
        } else {
            ref.current.removeEventListener("timeupdate", playClip);
            ref.current.pause();
        }
        return ()=>{
            ref.current.removeEventListener("timeupdate", playClip);
            ref.current.pause();
        };
    }, [
        end
    ]);
    const [duration, setDuration] = (0, $lDSNw.useState)();
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($8f02ef5ae77e5c0c$var$Card, {
        isSelected: isSelected,
        isHighlighted: isHighlighted,
        children: [
            isWinner && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($8f02ef5ae77e5c0c$var$WinnerTag, {
                children: "\uD83C\uDFC6"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($8f02ef5ae77e5c0c$var$Video, {
                ref: ref,
                width: 200,
                src: src,
                onMouseEnter: ()=>onMouseEnter(id),
                onMouseLeave: ()=>onMouseLeave(),
                onClick: ()=>onSelect(isSelected ? null : id),
                muted: true,
                loop: true,
                accentColor: color,
                onLoadedMetadata: (e)=>setDuration(e.target.duration)
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                type: "body02",
                as: "p",
                children: [
                    "Duration: ",
                    duration ? `${duration.toFixed(2)}s` : "..."
                ]
            })
        ]
    });
};
const $8f02ef5ae77e5c0c$var$WinnerTag = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("span", {
    target: "e146cggf2"
})({
    name: "v8kj24",
    styles: "font-size:35px;position:absolute;top:calc(100% - 60px);right:-10px;transform:rotate(5deg);transition:transform 0.25s ease-in-out"
});
const $8f02ef5ae77e5c0c$var$Video = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("video", {
    target: "e146cggf1"
})("opacity:", ({ fade: fade })=>fade ? "0.6" : "1", ";background-color:", ({ accentColor: accentColor })=>accentColor ?? "transparent", ";border:4px solid ", ({ accentColor: accentColor })=>accentColor ?? "transparent", ";cursor:pointer;");
const $8f02ef5ae77e5c0c$var$Card = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "e146cggf0"
})("position:relative;z-index:1;width:100%;perspective:1000px;transition:transform 0.25s ease-in-out;", ({ isHighlighted: isHighlighted })=>isHighlighted ? "transform: scale(1.02) rotateX(6deg) translateY(-6px);" : "", " ", ({ isSelected: isSelected })=>isSelected ? "transform: scale(1.1) rotateX(0deg) translateY(0px); " : "", " &:hover{", ({ isSelected: isSelected })=>!isSelected ? "transform: scale(1.02) rotateX(6deg) translateY(-6px);" : "", " span{transform:rotate(9deg);}}");


function $b2bfecbcce28c4a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b2bfecbcce28c4a4$export$7a01b79b6377466e = ({ recommendations: recommendations, onMouseEnterLeave: onMouseEnterLeave, onSelect: onSelect, start: start, end: end, selectedId: selectedId, highlightedId: highlightedId, winnerId: winnerId })=>{
    const [isUserMuted, setIsUserMuted] = (0, $lDSNw.useState)(false);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($b2bfecbcce28c4a4$var$VideoSelectorRoot, {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($b2bfecbcce28c4a4$var$VideoPlayersWrapper, {
                children: recommendations.map(({ videoSource: videoSource, id: id }, i)=>{
                    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8f02ef5ae77e5c0c$export$f503bc85d719e8b0), {
                        id: id,
                        src: videoSource,
                        isSelected: selectedId === id,
                        isHighlighted: highlightedId === id,
                        onMouseEnterLeave: onMouseEnterLeave,
                        onSelect: onSelect,
                        color: (0, $1eefc8ec6b0aa42b$export$eb4a6c9777179c4c)(i),
                        isUserMuted: isUserMuted,
                        isWinner: winnerId === id,
                        start: start,
                        end: end
                    }, id);
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $7153b660cd53c35b$export$353f5b6fc5456de1), {
                    title: isUserMuted ? "unmute videos" : "mute videos",
                    onClick: ()=>setIsUserMuted((value)=>!value),
                    children: isUserMuted ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                        icon: (0, $36045e57d0ad82eb$export$aa8decd057dfd29b)
                    }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                        icon: (0, $36045e57d0ad82eb$export$5940d3e475d90cc4)
                    })
                })
            })
        ]
    });
};
const $b2bfecbcce28c4a4$var$VideoSelectorRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ec9h4kp1"
})({
    name: "1fxcfcx",
    styles: "display:grid;grid-gap:var(--space-2);padding:var(--space-2) 0"
});
const $b2bfecbcce28c4a4$var$VideoPlayersWrapper = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ec9h4kp0"
})({
    name: "1ai9938",
    styles: "display:grid;grid-template-columns:repeat(3, 1fr);grid-gap:var(--space-4);width:100%;max-width:1200px"
});


const $a52f76ca3657e28c$export$f2699614dcb42575 = ({ currentDomainRecommendations: currentDomainRecommendations, creativeData: creativeData, buildID: buildID })=>{
    const [start, setStart] = (0, $lDSNw.useState)(0);
    const [end, setEnd] = (0, $lDSNw.useState)(1);
    const [selectedVideo, setSelectedVideo] = (0, $lDSNw.useState)();
    const [hoveredVideo, setHoveredVideo] = (0, $lDSNw.useState)();
    const onAreaSelected = ({ start: start, end: end })=>{
        setStart(start);
        setEnd(end);
    };
    const [chartData, setChartData] = (0, $lDSNw.useState)([]);
    const [recommendations, setRecommendations] = (0, $lDSNw.useState)([]);
    (0, $lDSNw.useEffect)(()=>{
        if (creativeData?.DCOA && currentDomainRecommendations) {
            const recoPrep = (0, $1eefc8ec6b0aa42b$export$123b3f6a12b10eb2)(currentDomainRecommendations);
            setRecommendations(recoPrep);
            const chartData = (0, $1eefc8ec6b0aa42b$export$747ddc15ee52f80)(recoPrep);
            setChartData(chartData);
        }
    }, [
        creativeData,
        currentDomainRecommendations
    ]);
    const onHoveredItem = (id)=>{
        setHoveredVideo(id);
    };
    const onSelectedItem = (id)=>{
        setSelectedVideo(id);
        setEnd(1);
        setStart(0);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        style: {
            display: "flex",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        name: "topProducts",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).sectionTitle,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                icon: (0, $36045e57d0ad82eb$export$c03de0cc616e77bb)
                            }),
                            "DCOA Video Assets (",
                            recommendations.length,
                            ")",
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                                type: "body02",
                                as: "p",
                                children: "These are all the videos that we tested for this campaign"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b2bfecbcce28c4a4$export$7a01b79b6377466e), {
                        recommendations: recommendations,
                        onSelect: onSelectedItem,
                        onMouseEnterLeave: onHoveredItem,
                        highlightedId: hoveredVideo,
                        start: start,
                        end: end,
                        selectedId: selectedVideo,
                        winnerId: chartData?.[0]?.name
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        name: "topProducts",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).sectionTitle,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                icon: (0, $36045e57d0ad82eb$export$bc8ca14ab51f93db)
                            }),
                            "Drop Off Visualisation",
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                                type: "body02",
                                as: "p",
                                children: "Compare how your videos performed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $bb694f7d1eba5bdb$export$10ae52a8e50aaeda), {
                        buildId: buildID,
                        onAreaSelected: onAreaSelected,
                        selectedVideo: selectedVideo ?? hoveredVideo,
                        recommendations: recommendations
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        name: "topProducts",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).sectionTitleWeight,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                icon: (0, $36045e57d0ad82eb$export$1de7b9cf7d1b153b)
                            }),
                            "Weight Distribution"
                        ]
                    }),
                    !!chartData ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4e1434c56bc5fb69$export$2b05aa197bed65b6), {
                        data: chartData,
                        onItemHoverLeave: onHoveredItem
                    }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6d34caa3f6c24444$export$e854a2165401836f), {
                        size: "s"
                    })
                ]
            })
        ]
    });
};


const $ab99fcdea71c7d42$export$56785f27969796ad = (0, $5058ffe240ffde31$export$369b6b2b30582e8e)(({ match: { params: { buildID: buildID } }, header: isUserloggedIn })=>{
    const [creativeData, loadingCreativeData, errorCreativeData] = (0, $abbc57578fc5f1d4$export$c8df2540c925bbd4)(buildID);
    const [currentDomainRecommendations, loadingRecommendations, errorRecommendations] = (0, $abbc57578fc5f1d4$export$d6364df2fe2951ac)(buildID);
    errorCreativeData && console.error(errorCreativeData);
    errorRecommendations && console.error(errorRecommendations);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).catrouselViewer,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).campaignTitle,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).brand,
                        children: creativeData?.brandNames ?? "Campaign name"
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e698b80e74857b87$exports))).campaign,
                        children: creativeData?.brandNames ?? "Campaign name"
                    })
                ]
            }),
            (loadingCreativeData || loadingRecommendations) && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6d34caa3f6c24444$export$e854a2165401836f), {}),
            creativeData?.DCOA?.type === "carousel" && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $176b22b005b5f212$export$bbb6dbedeed940c2), {
                buildID: buildID,
                creativeData: creativeData,
                currentDomainRecommendations: currentDomainRecommendations
            }),
            creativeData?.DCOA?.type === "video" && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a52f76ca3657e28c$export$f2699614dcb42575), {
                buildID: buildID,
                creativeData: creativeData,
                currentDomainRecommendations: currentDomainRecommendations
            })
        ]
    });
});






var $lDSNw = parcelRequire("lDSNw");



var $lDSNw = parcelRequire("lDSNw");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3ee3b72d91cbc81c$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $a59c7fc8689634e5$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $5058ffe240ffde31$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3ee3b72d91cbc81c$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $8429ec9982803cf6$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $a59c7fc8689634e5$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $5058ffe240ffde31$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component);
var $3ee3b72d91cbc81c$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3ee3b72d91cbc81c$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $a59c7fc8689634e5$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $3ee3b72d91cbc81c$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3ee3b72d91cbc81c$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).forwardRef;
if (typeof $3ee3b72d91cbc81c$var$forwardRef === "undefined") $3ee3b72d91cbc81c$var$forwardRef = $3ee3b72d91cbc81c$var$forwardRefShim;
function $3ee3b72d91cbc81c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3ee3b72d91cbc81c$var$LinkAnchor = $3ee3b72d91cbc81c$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $e357090fb59eb644$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3ee3b72d91cbc81c$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3ee3b72d91cbc81c$var$forwardRefShim !== $3ee3b72d91cbc81c$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3ee3b72d91cbc81c$export$a6c7ac8248d6e38a = $3ee3b72d91cbc81c$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3ee3b72d91cbc81c$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $e357090fb59eb644$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $5058ffe240ffde31$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $3ee3b72d91cbc81c$var$normalizeToLocation($3ee3b72d91cbc81c$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3ee3b72d91cbc81c$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $a59c7fc8689634e5$export$fe53371bee54353d)(context.location) === (0, $a59c7fc8689634e5$export$fe53371bee54353d)($3ee3b72d91cbc81c$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3ee3b72d91cbc81c$var$forwardRefShim !== $3ee3b72d91cbc81c$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(component, props);
    });
});
var $3ee3b72d91cbc81c$var$toType, $3ee3b72d91cbc81c$var$refType;
var $3ee3b72d91cbc81c$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3ee3b72d91cbc81c$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).forwardRef;
if (typeof $3ee3b72d91cbc81c$var$forwardRef$1 === "undefined") $3ee3b72d91cbc81c$var$forwardRef$1 = $3ee3b72d91cbc81c$var$forwardRefShim$1;
function $3ee3b72d91cbc81c$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3ee3b72d91cbc81c$export$b0d92dbee9b5b60d = $3ee3b72d91cbc81c$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $e357090fb59eb644$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $5058ffe240ffde31$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $faa21f25e6a568af$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3ee3b72d91cbc81c$var$normalizeToLocation($3ee3b72d91cbc81c$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $5058ffe240ffde31$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3ee3b72d91cbc81c$var$joinClassnames(className, activeClassName);
            style = (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3ee3b72d91cbc81c$var$forwardRefShim$1 !== $3ee3b72d91cbc81c$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($3ee3b72d91cbc81c$export$a6c7ac8248d6e38a, props);
    });
});
var $3ee3b72d91cbc81c$var$ariaCurrentType;


var $7ba0b64708da26c8$exports = {};

$parcel$export($7ba0b64708da26c8$exports, "app", function () { return $7ba0b64708da26c8$export$729c8b7179294ba; }, function (v) { return $7ba0b64708da26c8$export$729c8b7179294ba = v; });
var $7ba0b64708da26c8$export$729c8b7179294ba;
$7ba0b64708da26c8$export$729c8b7179294ba = `B2wDDG_app`;



parcelRequire("lDSNw");
var $3770fe25e9b7dc75$exports = {};

$parcel$export($3770fe25e9b7dc75$exports, "catAnimationMask", function () { return $3770fe25e9b7dc75$export$431e7dc1074c2d90; }, function (v) { return $3770fe25e9b7dc75$export$431e7dc1074c2d90 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catBeard", function () { return $3770fe25e9b7dc75$export$73bdb274f89af80c; }, function (v) { return $3770fe25e9b7dc75$export$73bdb274f89af80c = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catBelly", function () { return $3770fe25e9b7dc75$export$5398bf2031e9c665; }, function (v) { return $3770fe25e9b7dc75$export$5398bf2031e9c665 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catBody", function () { return $3770fe25e9b7dc75$export$2a71e762265d391a; }, function (v) { return $3770fe25e9b7dc75$export$2a71e762265d391a = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catEar", function () { return $3770fe25e9b7dc75$export$8f8871c0128f2e1b; }, function (v) { return $3770fe25e9b7dc75$export$8f8871c0128f2e1b = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catEye", function () { return $3770fe25e9b7dc75$export$34cf84fbb3a715fd; }, function (v) { return $3770fe25e9b7dc75$export$34cf84fbb3a715fd = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catEyeLight", function () { return $3770fe25e9b7dc75$export$63890c941ef7c0c0; }, function (v) { return $3770fe25e9b7dc75$export$63890c941ef7c0c0 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catFace", function () { return $3770fe25e9b7dc75$export$bbbf410468772135; }, function (v) { return $3770fe25e9b7dc75$export$bbbf410468772135 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catFoot", function () { return $3770fe25e9b7dc75$export$98eede413b2c7e37; }, function (v) { return $3770fe25e9b7dc75$export$98eede413b2c7e37 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catHand", function () { return $3770fe25e9b7dc75$export$39e0395f550ed16d; }, function (v) { return $3770fe25e9b7dc75$export$39e0395f550ed16d = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catHead", function () { return $3770fe25e9b7dc75$export$de825c557507027b; }, function (v) { return $3770fe25e9b7dc75$export$de825c557507027b = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catLeg", function () { return $3770fe25e9b7dc75$export$a8cabef4960e09ed; }, function (v) { return $3770fe25e9b7dc75$export$a8cabef4960e09ed = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catMouth", function () { return $3770fe25e9b7dc75$export$3d1a73f50d75e73; }, function (v) { return $3770fe25e9b7dc75$export$3d1a73f50d75e73 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "catTail", function () { return $3770fe25e9b7dc75$export$c899ae9f242b50f8; }, function (v) { return $3770fe25e9b7dc75$export$c899ae9f242b50f8 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "eye-light-animation", function () { return $3770fe25e9b7dc75$export$cf7b01ff5076364f; }, function (v) { return $3770fe25e9b7dc75$export$cf7b01ff5076364f = v; });
$parcel$export($3770fe25e9b7dc75$exports, "foot-animation", function () { return $3770fe25e9b7dc75$export$5f5c938c6abd3ec3; }, function (v) { return $3770fe25e9b7dc75$export$5f5c938c6abd3ec3 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "head-animation", function () { return $3770fe25e9b7dc75$export$967fc58f3fea429; }, function (v) { return $3770fe25e9b7dc75$export$967fc58f3fea429 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "loadingCat", function () { return $3770fe25e9b7dc75$export$29de1d95d1fea35; }, function (v) { return $3770fe25e9b7dc75$export$29de1d95d1fea35 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "loadingPage", function () { return $3770fe25e9b7dc75$export$f5f2b7216332d86e; }, function (v) { return $3770fe25e9b7dc75$export$f5f2b7216332d86e = v; });
$parcel$export($3770fe25e9b7dc75$exports, "mask-animation", function () { return $3770fe25e9b7dc75$export$627b24f22bcb56b5; }, function (v) { return $3770fe25e9b7dc75$export$627b24f22bcb56b5 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "mask-animation-sub-left", function () { return $3770fe25e9b7dc75$export$66797f242d679cb5; }, function (v) { return $3770fe25e9b7dc75$export$66797f242d679cb5 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "mask-animation-sub-right", function () { return $3770fe25e9b7dc75$export$7b7b6f770e601a77; }, function (v) { return $3770fe25e9b7dc75$export$7b7b6f770e601a77 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "mouth-animation", function () { return $3770fe25e9b7dc75$export$ad9ed0c563ffe1d8; }, function (v) { return $3770fe25e9b7dc75$export$ad9ed0c563ffe1d8 = v; });
$parcel$export($3770fe25e9b7dc75$exports, "right", function () { return $3770fe25e9b7dc75$export$79ffe56a765070d2; }, function (v) { return $3770fe25e9b7dc75$export$79ffe56a765070d2 = v; });
var $3770fe25e9b7dc75$export$431e7dc1074c2d90;
var $3770fe25e9b7dc75$export$73bdb274f89af80c;
var $3770fe25e9b7dc75$export$5398bf2031e9c665;
var $3770fe25e9b7dc75$export$2a71e762265d391a;
var $3770fe25e9b7dc75$export$8f8871c0128f2e1b;
var $3770fe25e9b7dc75$export$34cf84fbb3a715fd;
var $3770fe25e9b7dc75$export$63890c941ef7c0c0;
var $3770fe25e9b7dc75$export$bbbf410468772135;
var $3770fe25e9b7dc75$export$98eede413b2c7e37;
var $3770fe25e9b7dc75$export$39e0395f550ed16d;
var $3770fe25e9b7dc75$export$de825c557507027b;
var $3770fe25e9b7dc75$export$a8cabef4960e09ed;
var $3770fe25e9b7dc75$export$3d1a73f50d75e73;
var $3770fe25e9b7dc75$export$c899ae9f242b50f8;
var $3770fe25e9b7dc75$export$cf7b01ff5076364f;
var $3770fe25e9b7dc75$export$5f5c938c6abd3ec3;
var $3770fe25e9b7dc75$export$967fc58f3fea429;
var $3770fe25e9b7dc75$export$29de1d95d1fea35;
var $3770fe25e9b7dc75$export$f5f2b7216332d86e;
var $3770fe25e9b7dc75$export$627b24f22bcb56b5;
var $3770fe25e9b7dc75$export$66797f242d679cb5;
var $3770fe25e9b7dc75$export$7b7b6f770e601a77;
var $3770fe25e9b7dc75$export$ad9ed0c563ffe1d8;
var $3770fe25e9b7dc75$export$79ffe56a765070d2;
$3770fe25e9b7dc75$export$431e7dc1074c2d90 = `Oi3BmG_catAnimationMask`;
$3770fe25e9b7dc75$export$73bdb274f89af80c = `Oi3BmG_catBeard`;
$3770fe25e9b7dc75$export$5398bf2031e9c665 = `Oi3BmG_catBelly`;
$3770fe25e9b7dc75$export$2a71e762265d391a = `Oi3BmG_catBody`;
$3770fe25e9b7dc75$export$8f8871c0128f2e1b = `Oi3BmG_catEar`;
$3770fe25e9b7dc75$export$34cf84fbb3a715fd = `Oi3BmG_catEye`;
$3770fe25e9b7dc75$export$63890c941ef7c0c0 = `Oi3BmG_catEyeLight`;
$3770fe25e9b7dc75$export$bbbf410468772135 = `Oi3BmG_catFace`;
$3770fe25e9b7dc75$export$98eede413b2c7e37 = `Oi3BmG_catFoot`;
$3770fe25e9b7dc75$export$39e0395f550ed16d = `Oi3BmG_catHand`;
$3770fe25e9b7dc75$export$de825c557507027b = `Oi3BmG_catHead`;
$3770fe25e9b7dc75$export$a8cabef4960e09ed = `Oi3BmG_catLeg`;
$3770fe25e9b7dc75$export$3d1a73f50d75e73 = `Oi3BmG_catMouth`;
$3770fe25e9b7dc75$export$c899ae9f242b50f8 = `Oi3BmG_catTail`;
$3770fe25e9b7dc75$export$cf7b01ff5076364f = `Oi3BmG_eye-light-animation`;
$3770fe25e9b7dc75$export$cf7b01ff5076364f;
$3770fe25e9b7dc75$export$5f5c938c6abd3ec3 = `Oi3BmG_foot-animation`;
$3770fe25e9b7dc75$export$5f5c938c6abd3ec3;
$3770fe25e9b7dc75$export$967fc58f3fea429 = `Oi3BmG_head-animation`;
$3770fe25e9b7dc75$export$967fc58f3fea429;
$3770fe25e9b7dc75$export$29de1d95d1fea35 = `Oi3BmG_loadingCat`;
$3770fe25e9b7dc75$export$f5f2b7216332d86e = `Oi3BmG_loadingPage`;
$3770fe25e9b7dc75$export$627b24f22bcb56b5 = `Oi3BmG_mask-animation`;
$3770fe25e9b7dc75$export$627b24f22bcb56b5;
$3770fe25e9b7dc75$export$66797f242d679cb5 = `Oi3BmG_mask-animation-sub-left`;
$3770fe25e9b7dc75$export$66797f242d679cb5;
$3770fe25e9b7dc75$export$7b7b6f770e601a77 = `Oi3BmG_mask-animation-sub-right`;
$3770fe25e9b7dc75$export$7b7b6f770e601a77;
$3770fe25e9b7dc75$export$ad9ed0c563ffe1d8 = `Oi3BmG_mouth-animation`;
$3770fe25e9b7dc75$export$ad9ed0c563ffe1d8;
$3770fe25e9b7dc75$export$79ffe56a765070d2 = `Oi3BmG_right`;


const $aad5568159569f9e$export$3e669075e2e95b06 = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).loadingCat,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catBody
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catAnimationMask
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catHead,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catFace
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catEar
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catHand
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catEye
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catEyeLight
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catMouth
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catBeardLeft
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catBeardRight
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catFoot,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catBelly
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catLeg
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).catTail
                    })
                ]
            })
        ]
    });
const $aad5568159569f9e$var$LoadingPage = ()=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3770fe25e9b7dc75$exports))).loadingPage,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($aad5568159569f9e$export$3e669075e2e95b06, {})
    });
};
var $aad5568159569f9e$export$2e2bcd8739ae039 = $aad5568159569f9e$var$LoadingPage;



parcelRequire("lDSNw");
var $b42d10715ec7689a$exports = {};

$parcel$export($b42d10715ec7689a$exports, "Modal", function () { return $b42d10715ec7689a$export$2b77a92f1a5ad772; }, function (v) { return $b42d10715ec7689a$export$2b77a92f1a5ad772 = v; });
$parcel$export($b42d10715ec7689a$exports, "closeButton", function () { return $b42d10715ec7689a$export$efe229eab43a9869; }, function (v) { return $b42d10715ec7689a$export$efe229eab43a9869 = v; });
var $b42d10715ec7689a$export$2b77a92f1a5ad772;
var $b42d10715ec7689a$export$efe229eab43a9869;
$b42d10715ec7689a$export$2b77a92f1a5ad772 = `qBTUOG_Modal`;
$b42d10715ec7689a$export$efe229eab43a9869 = `qBTUOG_closeButton`;



parcelRequire("lDSNw");
var $788c27bdad7c3ea9$exports = {};

$parcel$export($788c27bdad7c3ea9$exports, "Backdrop", function () { return $788c27bdad7c3ea9$export$698223c589197ab7; }, function (v) { return $788c27bdad7c3ea9$export$698223c589197ab7 = v; });
var $788c27bdad7c3ea9$export$698223c589197ab7;
$788c27bdad7c3ea9$export$698223c589197ab7 = `XI4vqW_Backdrop`;


const $92e14464bca0d6b4$var$backdrop = (props)=>{
    return props.show ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($788c27bdad7c3ea9$exports))).Backdrop,
        onClick: props.clicked
    }) : null;
};
var $92e14464bca0d6b4$export$2e2bcd8739ae039 = $92e14464bca0d6b4$var$backdrop;


var $80c1c9ed8285bd25$exports = {};

$80c1c9ed8285bd25$exports = new URL((parcelRequire("5V6iE")).resolve("iKIFv"), import.meta.url).toString();


var $880d71f906ece37f$export$2e2bcd8739ae039 = ({ show: show, onClose: onClose, children: children })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92e14464bca0d6b4$export$2e2bcd8739ae039), {
                show: show,
                clicked: onClose
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b42d10715ec7689a$exports))).Modal,
                style: {
                    transform: show ? "translateY(0)" : "translateY(-100vh)",
                    opacity: show ? "1" : "0"
                },
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($80c1c9ed8285bd25$exports))),
                        alt: "Close modal",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($b42d10715ec7689a$exports))).closeButton,
                        onClick: onClose
                    }),
                    children
                ]
            })
        ]
    });
};




var $lDSNw = parcelRequire("lDSNw");


var $lDSNw = parcelRequire("lDSNw");
const $62548df2a7b28942$var$STATUS = {
    STOP: "STOP",
    START: "START",
    PAUSE: "PAUSE",
    OVER: "OVER"
};
const $62548df2a7b28942$var$JUMP_DELTA = 5;
const $62548df2a7b28942$var$JUMP_MAX_HEIGHT = 53;







class $62548df2a7b28942$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component {
    constructor(props){
        super(props);
        let imageLoadCount = 0;
        let onImageLoaded = ()=>{
            ++imageLoadCount;
            if (imageLoadCount === 3) {
                let myFont = new FontFace("Roboto Mono", "url(https://fonts.gstatic.com/s/robotomono/v13/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vq_QOW-AJi8SJQtQ4Y.woff)");
                myFont.load().then((font)=>{
                    this.robotoFont = font;
                    this.__draw();
                });
            }
        };
        // 资源文件
        let skyImage = new Image();
        let groundImage = new Image();
        let playerImage = new Image();
        let playerLeftImage = new Image();
        let playerRightImage = new Image();
        let playerDieImage = new Image();
        let obstacleImage = new Image();
        skyImage.onload = onImageLoaded;
        groundImage.onload = onImageLoaded;
        playerImage.onload = onImageLoaded;
        skyImage.src = (parcelRequire("39sek"));
        groundImage.src = (parcelRequire("6ARCB"));
        playerImage.src = (parcelRequire("5EMV6"));
        playerLeftImage.src = (parcelRequire("fvQWf"));
        playerRightImage.src = (parcelRequire("6NXnm"));
        playerDieImage.src = (parcelRequire("4l43E"));
        obstacleImage.src = (parcelRequire("54LfL"));
        this.options = {
            fps: 120,
            skySpeed: 80,
            groundSpeed: 200,
            skyImage: skyImage,
            groundImage: groundImage,
            playerImage: [
                playerImage,
                playerLeftImage,
                playerRightImage,
                playerDieImage
            ],
            obstacleImage: obstacleImage,
            skyOffset: 0,
            groundOffset: 0,
            ...this.props.options
        };
        this.status = $62548df2a7b28942$var$STATUS.STOP;
        this.timer = null;
        this.score = 0;
        this.highScore = window.localStorage ? window.localStorage["highScore"] || 0 : 0;
        this.jumpHeight = 0;
        this.jumpDelta = 0;
        this.obstaclesBase = 1;
        this.obstacles = this.__obstaclesGenerate();
        this.currentDistance = 0;
        this.playerStatus = 0;
    }
    componentDidMount() {
        if (window.innerWidth >= 680) this.canvas.width = 680;
        const onSpacePress = ()=>{
            switch(this.status){
                case $62548df2a7b28942$var$STATUS.STOP:
                    this.start();
                    break;
                case $62548df2a7b28942$var$STATUS.START:
                    this.jump();
                    break;
                case $62548df2a7b28942$var$STATUS.OVER:
                    this.restart();
                    break;
                default:
            }
        };
        window.onkeypress = function(e) {
            if (e.key === " ") onSpacePress();
        };
        this.canvas.parentNode.onclick = onSpacePress;
        window.onblur = this.pause;
        window.onfocus = this.goOn;
    }
    componentWillUnmount() {
        window.onblur = null;
        window.onfocus = null;
    }
    __draw() {
        if (!this.canvas) return;
        document.fonts.add(this.robotoFont);
        const { options: options } = this;
        let level = Math.min(200, Math.floor(this.score / 100));
        let groundSpeed = (options.groundSpeed + level) / options.fps;
        let skySpeed = options.skySpeed / options.fps;
        let obstacleWidth = options.obstacleImage.width;
        let playerWidth = options.playerImage[0].width;
        let playerHeight = options.playerImage[0].height;
        const ctx = this.canvas.getContext("2d");
        const { width: width, height: height } = this.canvas;
        ctx.clearRect(0, 0, width, height);
        ctx.save();
        // 云
        this.options.skyOffset = this.options.skyOffset < width ? this.options.skyOffset + skySpeed : this.options.skyOffset - width;
        ctx.translate(-this.options.skyOffset, 0);
        ctx.drawImage(this.options.skyImage, 0, 0);
        ctx.drawImage(this.options.skyImage, this.options.skyImage.width, 0);
        // 地面
        this.options.groundOffset = this.options.groundOffset < width ? this.options.groundOffset + groundSpeed : this.options.groundOffset - width;
        ctx.translate(this.options.skyOffset - this.options.groundOffset, 0);
        ctx.drawImage(this.options.groundImage, 0, 76);
        ctx.drawImage(this.options.groundImage, this.options.groundImage.width, 76);
        // 恐龙
        // 这里已经将坐标还原回左上角
        ctx.translate(this.options.groundOffset, 0);
        ctx.drawImage(this.options.playerImage[this.playerStatus], 80, 64 - this.jumpHeight);
        // 更新跳跃高度/速度
        this.jumpHeight = this.jumpHeight + this.jumpDelta;
        if (this.jumpHeight <= 1) {
            this.jumpHeight = 0;
            this.jumpDelta = 0;
        } else if (this.jumpHeight < $62548df2a7b28942$var$JUMP_MAX_HEIGHT && this.jumpDelta > 0) this.jumpDelta = this.jumpHeight * this.jumpHeight * 0.001033 - this.jumpHeight * 0.137 + 5;
        else if (this.jumpHeight < $62548df2a7b28942$var$JUMP_MAX_HEIGHT && this.jumpDelta < 0) ;
        else if (this.jumpHeight >= $62548df2a7b28942$var$JUMP_MAX_HEIGHT) this.jumpDelta = -$62548df2a7b28942$var$JUMP_DELTA / 2.7;
        // 分数
        let scoreText = (this.status === $62548df2a7b28942$var$STATUS.OVER ? "GAME OVER  " : "") + Math.floor(this.score);
        ctx.font = "18px Roboto Mono";
        ctx.textAlign = "right";
        ctx.fillStyle = "#595959";
        ctx.fillText(scoreText, width - 30, 23);
        if (this.status === $62548df2a7b28942$var$STATUS.START) {
            this.score += 0.5;
            if (this.score > this.highScore) {
                this.highScore = this.score;
                window.localStorage["highScore"] = this.score;
            }
            this.currentDistance += groundSpeed;
            if (this.score % 4 === 0) this.playerStatus = (this.playerStatus + 1) % 3;
        }
        if (this.highScore) {
            ctx.textAlign = "left";
            ctx.fillText("HIGH  " + Math.floor(this.highScore), 30, 23);
            ctx.font = "Roboto Mono";
        }
        // 障碍
        let pop = 0;
        for(let i = 0; i < this.obstacles.length; ++i){
            if (this.currentDistance >= this.obstacles[i].distance) {
                let offset = width - (this.currentDistance - this.obstacles[i].distance + groundSpeed);
                if (offset > 0) ctx.drawImage(options.obstacleImage, offset, 84);
                else ++pop;
            } else break;
        }
        for(let i = 0; i < pop; ++i)this.obstacles.shift();
        if (this.obstacles.length < 5) this.obstacles = this.obstacles.concat(this.__obstaclesGenerate());
        // 碰撞检测
        let firstOffset = width - (this.currentDistance - this.obstacles[0].distance + groundSpeed);
        if (90 - obstacleWidth < firstOffset && firstOffset < 60 + playerWidth && 64 - this.jumpHeight + playerHeight > 84) this.stop();
        ctx.restore();
    }
    __obstaclesGenerate() {
        let res = [];
        for(let i = 0; i < 10; ++i){
            let random = Math.floor(Math.random() * 100) % 60;
            random = (Math.random() * 10 % 2 === 0 ? 1 : -1) * random;
            res.push({
                distance: random + this.obstaclesBase * 200
            });
            ++this.obstaclesBase;
        }
        return res;
    }
    __setTimer() {
        this.timer = setInterval(()=>this.__draw(), 1000 / this.options.fps);
    }
    __clearTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
    __clear() {
        this.score = 0;
        this.jumpHeight = 0;
        this.currentDistance = 0;
        this.obstacles = [];
        this.obstaclesBase = 1;
        this.playerStatus = 0;
    }
    start = ()=>{
        if (this.status === $62548df2a7b28942$var$STATUS.START) return;
        this.status = $62548df2a7b28942$var$STATUS.START;
        this.__setTimer();
        this.jump();
    };
    pause = ()=>{
        if (this.status === $62548df2a7b28942$var$STATUS.START) {
            this.status = $62548df2a7b28942$var$STATUS.PAUSE;
            this.__clearTimer();
        }
    };
    goOn = ()=>{
        if (this.status === $62548df2a7b28942$var$STATUS.PAUSE) {
            this.status = $62548df2a7b28942$var$STATUS.START;
            this.__setTimer();
        }
    };
    stop = ()=>{
        if (this.status === $62548df2a7b28942$var$STATUS.OVER) return;
        this.status = $62548df2a7b28942$var$STATUS.OVER;
        this.playerStatus = 3;
        this.__clearTimer();
        this.__draw();
        this.__clear();
    };
    restart = ()=>{
        this.obstacles = this.__obstaclesGenerate();
        this.start();
    };
    jump = ()=>{
        if (this.jumpHeight > 2) return;
        this.jumpDelta = $62548df2a7b28942$var$JUMP_DELTA;
        this.jumpHeight = $62548df2a7b28942$var$JUMP_DELTA;
    };
    render() {
        return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("canvas", {
            id: "canvas",
            ref: (ref)=>this.canvas = ref,
            height: 160,
            width: 340
        });
    }
}



var $2WUgS = parcelRequire("2WUgS");

var $hvPjh = parcelRequire("hvPjh");
function $8b62d45bd189d563$export$ba99498080d0627b() {
    var _a;
    return typeof $hvPjh === "object" && ((_a = $hvPjh === null || $hvPjh === void 0 ? void 0 : $hvPjh.versions) === null || _a === void 0 ? void 0 : _a.node) !== undefined;
}
function $8b62d45bd189d563$export$d8dbb4fdb3ae0564() {
    return typeof window === "object" && (window === null || window === void 0 ? void 0 : window.document) !== undefined;
}
var $8b62d45bd189d563$var$fallbackGlobalObject = {};
var $8b62d45bd189d563$export$256479dc0cea61c4 = function() {
    if ($8b62d45bd189d563$export$ba99498080d0627b()) return $parcel$global;
    else if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    else return $8b62d45bd189d563$var$fallbackGlobalObject;
};
var $8b62d45bd189d563$export$224a3b045e74f323 = function() {
    var global1 = $8b62d45bd189d563$export$256479dc0cea61c4();
    if (global1.__AMPLITUDE__ === undefined) global1.__AMPLITUDE__ = {};
    return global1.__AMPLITUDE__;
};
var $8b62d45bd189d563$export$1c944194a70dd5e9 = function(milliseconds) {
    return (0, $2WUgS.__awaiter)(void 0, void 0, void 0, function() {
        return (0, $2WUgS.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, milliseconds);
                        })
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
};
var $8b62d45bd189d563$export$e518fb76ed3fba53 = function() {
    var _a;
    if ($8b62d45bd189d563$export$d8dbb4fdb3ae0564()) {
        var augmentedWindow = window;
        var augmentedArray = Array;
        if (augmentedWindow.Prototype !== undefined && ((_a = augmentedArray.prototype) === null || _a === void 0 ? void 0 : _a.toJSON) !== undefined) {
            delete augmentedArray.prototype.toJSON;
            return true;
        }
    }
    return false;
};


var $815d751d09b8fc16$exports = {};
/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ /* global define */ (function($) {
    "use strict";
    /**
   * Add integers, wrapping at 2^32.
   * This uses 16-bit operations internally to work around bugs in interpreters.
   *
   * @param {number} x First integer
   * @param {number} y Second integer
   * @returns {number} Sum
   */ function safeAdd(x, y) {
        var lsw = (x & 0xffff) + (y & 0xffff);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xffff;
    }
    /**
   * Bitwise rotate a 32-bit number to the left.
   *
   * @param {number} num 32-bit number
   * @param {number} cnt Rotation count
   * @returns {number} Rotated number
   */ function bitRotateLeft(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} q q
   * @param {number} a a
   * @param {number} b b
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5cmn(q, a, b, x, s, t) {
        return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5ff(a, b, c, d, x, s, t) {
        return md5cmn(b & c | ~b & d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5gg(a, b, c, d, x, s, t) {
        return md5cmn(b & d | c & ~d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5hh(a, b, c, d, x, s, t) {
        return md5cmn(b ^ c ^ d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5ii(a, b, c, d, x, s, t) {
        return md5cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    /**
   * Calculate the MD5 of an array of little-endian words, and a bit length.
   *
   * @param {Array} x Array of little-endian words
   * @param {number} len Bit length
   * @returns {Array<number>} MD5 Array
   */ function binlMD5(x, len) {
        /* append padding */ x[len >> 5] |= 0x80 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;
        var i;
        var olda;
        var oldb;
        var oldc;
        var oldd;
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;
        for(i = 0; i < x.length; i += 16){
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;
            a = md5ff(a, b, c, d, x[i], 7, -680876936);
            d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
            b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
            a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = md5gg(b, c, d, a, x[i], 20, -373897302);
            a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
            a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
            d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = md5hh(d, a, b, c, x[i], 11, -358537222);
            c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
            a = md5ii(a, b, c, d, x[i], 6, -198630844);
            d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
            a = safeAdd(a, olda);
            b = safeAdd(b, oldb);
            c = safeAdd(c, oldc);
            d = safeAdd(d, oldd);
        }
        return [
            a,
            b,
            c,
            d
        ];
    }
    /**
   * Convert an array of little-endian words to a string
   *
   * @param {Array<number>} input MD5 Array
   * @returns {string} MD5 string
   */ function binl2rstr(input) {
        var i;
        var output = "";
        var length32 = input.length * 32;
        for(i = 0; i < length32; i += 8)output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
        return output;
    }
    /**
   * Convert a raw string to an array of little-endian words
   * Characters >255 have their high-byte silently ignored.
   *
   * @param {string} input Raw input string
   * @returns {Array<number>} Array of little-endian words
   */ function rstr2binl(input) {
        var i;
        var output = [];
        output[(input.length >> 2) - 1] = undefined;
        for(i = 0; i < output.length; i += 1)output[i] = 0;
        var length8 = input.length * 8;
        for(i = 0; i < length8; i += 8)output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
        return output;
    }
    /**
   * Calculate the MD5 of a raw string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */ function rstrMD5(s) {
        return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
    }
    /**
   * Calculates the HMAC-MD5 of a key and some data (raw strings)
   *
   * @param {string} key HMAC key
   * @param {string} data Raw input string
   * @returns {string} Raw MD5 string
   */ function rstrHMACMD5(key, data) {
        var i;
        var bkey = rstr2binl(key);
        var ipad = [];
        var opad = [];
        var hash;
        ipad[15] = opad[15] = undefined;
        if (bkey.length > 16) bkey = binlMD5(bkey, key.length * 8);
        for(i = 0; i < 16; i += 1){
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5c5c5c5c;
        }
        hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
        return binl2rstr(binlMD5(opad.concat(hash), 640));
    }
    /**
   * Convert a raw string to a hex string
   *
   * @param {string} input Raw input string
   * @returns {string} Hex encoded string
   */ function rstr2hex(input) {
        var hexTab = "0123456789abcdef";
        var output = "";
        var x;
        var i;
        for(i = 0; i < input.length; i += 1){
            x = input.charCodeAt(i);
            output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
        }
        return output;
    }
    /**
   * Encode a string as UTF-8
   *
   * @param {string} input Input string
   * @returns {string} UTF8 string
   */ function str2rstrUTF8(input) {
        return unescape(encodeURIComponent(input));
    }
    /**
   * Encodes input string as raw MD5 string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */ function rawMD5(s) {
        return rstrMD5(str2rstrUTF8(s));
    }
    /**
   * Encodes input string as Hex encoded string
   *
   * @param {string} s Input string
   * @returns {string} Hex encoded string
   */ function hexMD5(s) {
        return rstr2hex(rawMD5(s));
    }
    /**
   * Calculates the raw HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */ function rawHMACMD5(k, d) {
        return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
    }
    /**
   * Calculates the Hex encoded HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */ function hexHMACMD5(k, d) {
        return rstr2hex(rawHMACMD5(k, d));
    }
    /**
   * Calculates MD5 value for a given string.
   * If a key is provided, calculates the HMAC-MD5 value.
   * Returns a Hex encoded string unless the raw argument is given.
   *
   * @param {string} string Input string
   * @param {string} [key] HMAC key
   * @param {boolean} [raw] Raw output switch
   * @returns {string} MD5 output
   */ function md5(string, key, raw) {
        if (!key) {
            if (!raw) return hexMD5(string);
            return rawMD5(string);
        }
        if (!raw) return hexHMACMD5(key, string);
        return rawHMACMD5(key, string);
    }
    if (typeof define === "function" && define.amd) define(function() {
        return md5;
    });
    else if (0, $815d751d09b8fc16$exports) $815d751d09b8fc16$exports = md5;
    else $.md5 = md5;
})($815d751d09b8fc16$exports);


var $a211073f771f7c8d$exports = {};

$parcel$export($a211073f771f7c8d$exports, "extract", function () { return $a211073f771f7c8d$export$f9380c9a627682d3; });
$parcel$export($a211073f771f7c8d$exports, "parse", function () { return $a211073f771f7c8d$export$98e6a39c04603d36; });
$parcel$export($a211073f771f7c8d$exports, "stringify", function () { return $a211073f771f7c8d$export$fac44ee5b035f737; });
$parcel$export($a211073f771f7c8d$exports, "parseUrl", function () { return $a211073f771f7c8d$export$7a5253c0f62e0150; });
$parcel$export($a211073f771f7c8d$exports, "stringifyUrl", function () { return $a211073f771f7c8d$export$a8c1621ea79325d3; });
$parcel$export($a211073f771f7c8d$exports, "pick", function () { return $a211073f771f7c8d$export$357523c63a2253b9; });
$parcel$export($a211073f771f7c8d$exports, "exclude", function () { return $a211073f771f7c8d$export$44c361b8ec72ef7f; });
const $52b948b984c3696d$var$token = "%[a-f0-9]{2}";
const $52b948b984c3696d$var$singleMatcher = new RegExp("(" + $52b948b984c3696d$var$token + ")|([^%]+?)", "gi");
const $52b948b984c3696d$var$multiMatcher = new RegExp("(" + $52b948b984c3696d$var$token + ")+", "gi");
function $52b948b984c3696d$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $52b948b984c3696d$var$decodeComponents(left), $52b948b984c3696d$var$decodeComponents(right));
}
function $52b948b984c3696d$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($52b948b984c3696d$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $52b948b984c3696d$var$decodeComponents(tokens, i).join("");
            tokens = input.match($52b948b984c3696d$var$singleMatcher) || [];
        }
        return input;
    }
}
function $52b948b984c3696d$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    let match = $52b948b984c3696d$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $52b948b984c3696d$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $52b948b984c3696d$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $52b948b984c3696d$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $52b948b984c3696d$var$customDecodeURIComponent(encodedURI);
    }
}


function $9645dab21897d107$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


function $a4575b43035a0cca$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $a4575b43035a0cca$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $a4575b43035a0cca$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $a4575b43035a0cca$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


const $a211073f771f7c8d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $a211073f771f7c8d$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $a211073f771f7c8d$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $a211073f771f7c8d$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $a211073f771f7c8d$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $a211073f771f7c8d$var$encode(key, options),
                            "[",
                            $a211073f771f7c8d$var$encode(index, options),
                            "]=",
                            $a211073f771f7c8d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $a211073f771f7c8d$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $a211073f771f7c8d$var$encode(key, options),
                            "[]=",
                            $a211073f771f7c8d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $a211073f771f7c8d$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $a211073f771f7c8d$var$encode(key, options),
                            ":list=",
                            $a211073f771f7c8d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $a211073f771f7c8d$var$encode(key, options),
                                keyValueSep,
                                $a211073f771f7c8d$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $a211073f771f7c8d$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $a211073f771f7c8d$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $a211073f771f7c8d$var$encode(key, options),
                            "=",
                            $a211073f771f7c8d$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $a211073f771f7c8d$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $a211073f771f7c8d$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $a211073f771f7c8d$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$a211073f771f7c8d$var$decode(item, options)) : value === null ? value : $a211073f771f7c8d$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $a211073f771f7c8d$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$a211073f771f7c8d$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $a211073f771f7c8d$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $a211073f771f7c8d$var$encode(value, options) {
    if (options.encode) return options.strict ? $a211073f771f7c8d$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $a211073f771f7c8d$var$decode(value, options) {
    if (options.decode) return (0, $52b948b984c3696d$export$2e2bcd8739ae039)(value);
    return value;
}
function $a211073f771f7c8d$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $a211073f771f7c8d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $a211073f771f7c8d$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $a211073f771f7c8d$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $a211073f771f7c8d$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $a211073f771f7c8d$export$f9380c9a627682d3(input) {
    input = $a211073f771f7c8d$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $a211073f771f7c8d$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $a211073f771f7c8d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $a211073f771f7c8d$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $9645dab21897d107$export$2e2bcd8739ae039)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $a211073f771f7c8d$var$decode(value, options);
        formatter($a211073f771f7c8d$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $a211073f771f7c8d$var$parseValue(value2, options);
        else returnValue[key] = $a211073f771f7c8d$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $a211073f771f7c8d$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
function $a211073f771f7c8d$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $a211073f771f7c8d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $a211073f771f7c8d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $a211073f771f7c8d$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $a211073f771f7c8d$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $a211073f771f7c8d$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $a211073f771f7c8d$var$encode(key, options) + "=" + $a211073f771f7c8d$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $a211073f771f7c8d$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $9645dab21897d107$export$2e2bcd8739ae039)(url, "#");
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split("?")?.[0] ?? "",
        query: $a211073f771f7c8d$export$98e6a39c04603d36($a211073f771f7c8d$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $a211073f771f7c8d$var$decode(hash, options)
        } : {}
    };
}
function $a211073f771f7c8d$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$a211073f771f7c8d$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $a211073f771f7c8d$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $a211073f771f7c8d$export$f9380c9a627682d3(object.url);
    const query = {
        ...$a211073f771f7c8d$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $a211073f771f7c8d$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $a211073f771f7c8d$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$a211073f771f7c8d$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $a211073f771f7c8d$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$a211073f771f7c8d$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $a211073f771f7c8d$export$7a5253c0f62e0150(input, options);
    return $a211073f771f7c8d$export$a8c1621ea79325d3({
        url: url,
        query: (0, $a4575b43035a0cca$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $a211073f771f7c8d$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $a211073f771f7c8d$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $dd727a8531c7066c$export$2e2bcd8739ae039 = $a211073f771f7c8d$exports;



var $axiof = parcelRequire("axiof");
var $14ffd7b4a562b7f1$var$ApplicationContextProviderImpl = /** @class */ function() {
    function ApplicationContextProviderImpl() {}
    ApplicationContextProviderImpl.prototype.getApplicationContext = function() {
        return {
            versionName: this.versionName,
            language: $14ffd7b4a562b7f1$var$getLanguage(),
            platform: "Web",
            os: undefined,
            deviceModel: undefined
        };
    };
    return ApplicationContextProviderImpl;
}();
var $14ffd7b4a562b7f1$var$getLanguage = function() {
    return typeof navigator !== "undefined" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
};
var $14ffd7b4a562b7f1$var$EventBridgeImpl = /** @class */ function() {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function(event) {
        if (!this.receiver) {
            if (this.queue.length < 512) this.queue.push(event);
        } else this.receiver(event);
    };
    EventBridgeImpl.prototype.setEventReceiver = function(receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function(event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $14ffd7b4a562b7f1$var$__assign = function() {
    $14ffd7b4a562b7f1$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $14ffd7b4a562b7f1$var$__assign.apply(this, arguments);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $14ffd7b4a562b7f1$var$isEqual = function(obj1, obj2) {
    var primitive = [
        "string",
        "number",
        "boolean",
        "undefined"
    ];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) return false;
    for(var _i = 0, primitive_1 = primitive; _i < primitive_1.length; _i++){
        var p = primitive_1[_i];
        if (p === typeA) return obj1 === obj2;
    }
    // check null
    if (obj1 == null && obj2 == null) return true;
    else if (obj1 == null || obj2 == null) return false;
    // if got here - objects
    if (obj1.length !== obj2.length) return false;
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) return false;
    if (isArrayA && isArrayB) //arrays
    for(var i = 0; i < obj1.length; i++){
        if (!$14ffd7b4a562b7f1$var$isEqual(obj1[i], obj2[i])) return false;
    }
    else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!$14ffd7b4a562b7f1$var$isEqual(sorted1, sorted2)) return false;
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function(key) {
            if (!$14ffd7b4a562b7f1$var$isEqual(obj1[key], obj2[key])) result_1 = false;
        });
        return result_1;
    }
    return true;
};
var $14ffd7b4a562b7f1$var$ID_OP_SET = "$set";
var $14ffd7b4a562b7f1$var$ID_OP_UNSET = "$unset";
var $14ffd7b4a562b7f1$var$ID_OP_CLEAR_ALL = "$clearAll";
// Polyfill for Object.entries
if (!Object.entries) Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while(i--)resArray[i] = [
        ownProps[i],
        obj[ownProps[i]]
    ];
    return resArray;
};
var $14ffd7b4a562b7f1$var$IdentityStoreImpl = /** @class */ function() {
    function IdentityStoreImpl() {
        this.identity = {
            userProperties: {}
        };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self1 = this;
        var actingUserProperties = $14ffd7b4a562b7f1$var$__assign({}, this.identity.userProperties);
        var actingIdentity = $14ffd7b4a562b7f1$var$__assign($14ffd7b4a562b7f1$var$__assign({}, this.identity), {
            userProperties: actingUserProperties
        });
        return {
            setUserId: function(userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function(deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function(userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            updateUserProperties: function(actions) {
                var actingProperties = actingIdentity.userProperties || {};
                for(var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++){
                    var _b = _a[_i], action = _b[0], properties = _b[1];
                    switch(action){
                        case $14ffd7b4a562b7f1$var$ID_OP_SET:
                            for(var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++){
                                var _e = _d[_c], key = _e[0], value = _e[1];
                                actingProperties[key] = value;
                            }
                            break;
                        case $14ffd7b4a562b7f1$var$ID_OP_UNSET:
                            for(var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++){
                                var key = _g[_f];
                                delete actingProperties[key];
                            }
                            break;
                        case $14ffd7b4a562b7f1$var$ID_OP_CLEAR_ALL:
                            actingProperties = {};
                            break;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function() {
                self1.setIdentity(actingIdentity);
                return this;
            }
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function() {
        return $14ffd7b4a562b7f1$var$__assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function(identity) {
        var originalIdentity = $14ffd7b4a562b7f1$var$__assign({}, this.identity);
        this.identity = $14ffd7b4a562b7f1$var$__assign({}, identity);
        if (!$14ffd7b4a562b7f1$var$isEqual(originalIdentity, this.identity)) this.listeners.forEach(function(listener) {
            listener(identity);
        });
    };
    IdentityStoreImpl.prototype.addIdentityListener = function(listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function(listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}();
var $14ffd7b4a562b7f1$var$safeGlobal = typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : self;
var $14ffd7b4a562b7f1$export$5af12d25e001b77c = /** @class */ function() {
    function AnalyticsConnector() {
        this.identityStore = new $14ffd7b4a562b7f1$var$IdentityStoreImpl();
        this.eventBridge = new $14ffd7b4a562b7f1$var$EventBridgeImpl();
        this.applicationContextProvider = new $14ffd7b4a562b7f1$var$ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function(instanceName) {
        if (!$14ffd7b4a562b7f1$var$safeGlobal["analyticsConnectorInstances"]) $14ffd7b4a562b7f1$var$safeGlobal["analyticsConnectorInstances"] = {};
        if (!$14ffd7b4a562b7f1$var$safeGlobal["analyticsConnectorInstances"][instanceName]) $14ffd7b4a562b7f1$var$safeGlobal["analyticsConnectorInstances"][instanceName] = new AnalyticsConnector();
        return $14ffd7b4a562b7f1$var$safeGlobal["analyticsConnectorInstances"][instanceName];
    };
    return AnalyticsConnector;
}();


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $4b20083169abaabd$export$a143d493d941bafc;
var $4b20083169abaabd$export$e4cf37d7f6fb9e0a;
var $4b20083169abaabd$export$f99ded8fe4b79145;
var $4b20083169abaabd$export$599f31c3813fae4d;
"use strict";
var $a890810c684395e6$export$a48f0734ac7c2329;
var $a890810c684395e6$export$d622b2ad8d90c771;
var $a890810c684395e6$export$6100ba28696e12de;
"use strict";
$a890810c684395e6$export$a48f0734ac7c2329 = $a890810c684395e6$var$byteLength;
$a890810c684395e6$export$d622b2ad8d90c771 = $a890810c684395e6$var$toByteArray;
$a890810c684395e6$export$6100ba28696e12de = $a890810c684395e6$var$fromByteArray;
var $a890810c684395e6$var$lookup = [];
var $a890810c684395e6$var$revLookup = [];
var $a890810c684395e6$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $a890810c684395e6$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $a890810c684395e6$var$i = 0, $a890810c684395e6$var$len = $a890810c684395e6$var$code.length; $a890810c684395e6$var$i < $a890810c684395e6$var$len; ++$a890810c684395e6$var$i){
    $a890810c684395e6$var$lookup[$a890810c684395e6$var$i] = $a890810c684395e6$var$code[$a890810c684395e6$var$i];
    $a890810c684395e6$var$revLookup[$a890810c684395e6$var$code.charCodeAt($a890810c684395e6$var$i)] = $a890810c684395e6$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$a890810c684395e6$var$revLookup["-".charCodeAt(0)] = 62;
$a890810c684395e6$var$revLookup["_".charCodeAt(0)] = 63;
function $a890810c684395e6$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $a890810c684395e6$var$byteLength(b64) {
    var lens = $a890810c684395e6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a890810c684395e6$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a890810c684395e6$var$toByteArray(b64) {
    var tmp;
    var lens = $a890810c684395e6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $a890810c684395e6$var$Arr($a890810c684395e6$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $a890810c684395e6$var$revLookup[b64.charCodeAt(i)] << 18 | $a890810c684395e6$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $a890810c684395e6$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $a890810c684395e6$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $a890810c684395e6$var$revLookup[b64.charCodeAt(i)] << 2 | $a890810c684395e6$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $a890810c684395e6$var$revLookup[b64.charCodeAt(i)] << 10 | $a890810c684395e6$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $a890810c684395e6$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $a890810c684395e6$var$tripletToBase64(num) {
    return $a890810c684395e6$var$lookup[num >> 18 & 0x3F] + $a890810c684395e6$var$lookup[num >> 12 & 0x3F] + $a890810c684395e6$var$lookup[num >> 6 & 0x3F] + $a890810c684395e6$var$lookup[num & 0x3F];
}
function $a890810c684395e6$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($a890810c684395e6$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $a890810c684395e6$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($a890810c684395e6$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($a890810c684395e6$var$lookup[tmp >> 2] + $a890810c684395e6$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($a890810c684395e6$var$lookup[tmp >> 10] + $a890810c684395e6$var$lookup[tmp >> 4 & 0x3F] + $a890810c684395e6$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $bf79d62cddbcdda3$export$aafa59e2e03f2942;
var $bf79d62cddbcdda3$export$68d8715fc104d294;
$bf79d62cddbcdda3$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$bf79d62cddbcdda3$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $4b20083169abaabd$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$4b20083169abaabd$export$a143d493d941bafc = $4b20083169abaabd$var$Buffer;
$4b20083169abaabd$export$e4cf37d7f6fb9e0a = $4b20083169abaabd$var$SlowBuffer;
$4b20083169abaabd$export$f99ded8fe4b79145 = 50;
const $4b20083169abaabd$var$K_MAX_LENGTH = 0x7fffffff;
$4b20083169abaabd$export$599f31c3813fae4d = $4b20083169abaabd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $4b20083169abaabd$var$Buffer.TYPED_ARRAY_SUPPORT = $4b20083169abaabd$var$typedArraySupport();
if (!$4b20083169abaabd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $4b20083169abaabd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($4b20083169abaabd$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$4b20083169abaabd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($4b20083169abaabd$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$4b20083169abaabd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $4b20083169abaabd$var$createBuffer(length) {
    if (length > $4b20083169abaabd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $4b20083169abaabd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $4b20083169abaabd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $4b20083169abaabd$var$allocUnsafe(arg);
    }
    return $4b20083169abaabd$var$from(arg, encodingOrOffset, length);
}
$4b20083169abaabd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $4b20083169abaabd$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $4b20083169abaabd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $4b20083169abaabd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($4b20083169abaabd$var$isInstance(value, ArrayBuffer) || value && $4b20083169abaabd$var$isInstance(value.buffer, ArrayBuffer)) return $4b20083169abaabd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($4b20083169abaabd$var$isInstance(value, SharedArrayBuffer) || value && $4b20083169abaabd$var$isInstance(value.buffer, SharedArrayBuffer))) return $4b20083169abaabd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $4b20083169abaabd$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $4b20083169abaabd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $4b20083169abaabd$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $4b20083169abaabd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $4b20083169abaabd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($4b20083169abaabd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($4b20083169abaabd$var$Buffer, Uint8Array);
function $4b20083169abaabd$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $4b20083169abaabd$var$alloc(size, fill, encoding) {
    $4b20083169abaabd$var$assertSize(size);
    if (size <= 0) return $4b20083169abaabd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $4b20083169abaabd$var$createBuffer(size).fill(fill, encoding) : $4b20083169abaabd$var$createBuffer(size).fill(fill);
    return $4b20083169abaabd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $4b20083169abaabd$var$Buffer.alloc = function(size, fill, encoding) {
    return $4b20083169abaabd$var$alloc(size, fill, encoding);
};
function $4b20083169abaabd$var$allocUnsafe(size) {
    $4b20083169abaabd$var$assertSize(size);
    return $4b20083169abaabd$var$createBuffer(size < 0 ? 0 : $4b20083169abaabd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $4b20083169abaabd$var$Buffer.allocUnsafe = function(size) {
    return $4b20083169abaabd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $4b20083169abaabd$var$Buffer.allocUnsafeSlow = function(size) {
    return $4b20083169abaabd$var$allocUnsafe(size);
};
function $4b20083169abaabd$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$4b20083169abaabd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $4b20083169abaabd$var$byteLength(string, encoding) | 0;
    let buf = $4b20083169abaabd$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $4b20083169abaabd$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $4b20083169abaabd$var$checked(array.length) | 0;
    const buf = $4b20083169abaabd$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $4b20083169abaabd$var$fromArrayView(arrayView) {
    if ($4b20083169abaabd$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $4b20083169abaabd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $4b20083169abaabd$var$fromArrayLike(arrayView);
}
function $4b20083169abaabd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $4b20083169abaabd$var$Buffer.prototype);
    return buf;
}
function $4b20083169abaabd$var$fromObject(obj) {
    if ($4b20083169abaabd$var$Buffer.isBuffer(obj)) {
        const len = $4b20083169abaabd$var$checked(obj.length) | 0;
        const buf = $4b20083169abaabd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $4b20083169abaabd$var$numberIsNaN(obj.length)) return $4b20083169abaabd$var$createBuffer(0);
        return $4b20083169abaabd$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $4b20083169abaabd$var$fromArrayLike(obj.data);
}
function $4b20083169abaabd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $4b20083169abaabd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $4b20083169abaabd$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $4b20083169abaabd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $4b20083169abaabd$var$Buffer.alloc(+length);
}
$4b20083169abaabd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $4b20083169abaabd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$4b20083169abaabd$var$Buffer.compare = function compare(a, b) {
    if ($4b20083169abaabd$var$isInstance(a, Uint8Array)) a = $4b20083169abaabd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($4b20083169abaabd$var$isInstance(b, Uint8Array)) b = $4b20083169abaabd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$4b20083169abaabd$var$Buffer.isBuffer(a) || !$4b20083169abaabd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$4b20083169abaabd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$4b20083169abaabd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $4b20083169abaabd$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $4b20083169abaabd$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($4b20083169abaabd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$4b20083169abaabd$var$Buffer.isBuffer(buf)) buf = $4b20083169abaabd$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$4b20083169abaabd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $4b20083169abaabd$var$byteLength(string, encoding) {
    if ($4b20083169abaabd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $4b20083169abaabd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $4b20083169abaabd$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $4b20083169abaabd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $4b20083169abaabd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$4b20083169abaabd$var$Buffer.byteLength = $4b20083169abaabd$var$byteLength;
function $4b20083169abaabd$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $4b20083169abaabd$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $4b20083169abaabd$var$utf8Slice(this, start, end);
        case "ascii":
            return $4b20083169abaabd$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $4b20083169abaabd$var$latin1Slice(this, start, end);
        case "base64":
            return $4b20083169abaabd$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $4b20083169abaabd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$4b20083169abaabd$var$Buffer.prototype._isBuffer = true;
function $4b20083169abaabd$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$4b20083169abaabd$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$4b20083169abaabd$var$swap(this, i, i + 1);
    return this;
};
$4b20083169abaabd$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $4b20083169abaabd$var$swap(this, i, i + 3);
        $4b20083169abaabd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$4b20083169abaabd$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $4b20083169abaabd$var$swap(this, i, i + 7);
        $4b20083169abaabd$var$swap(this, i + 1, i + 6);
        $4b20083169abaabd$var$swap(this, i + 2, i + 5);
        $4b20083169abaabd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$4b20083169abaabd$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $4b20083169abaabd$var$utf8Slice(this, 0, length);
    return $4b20083169abaabd$var$slowToString.apply(this, arguments);
};
$4b20083169abaabd$var$Buffer.prototype.toLocaleString = $4b20083169abaabd$var$Buffer.prototype.toString;
$4b20083169abaabd$var$Buffer.prototype.equals = function equals(b) {
    if (!$4b20083169abaabd$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $4b20083169abaabd$var$Buffer.compare(this, b) === 0;
};
$4b20083169abaabd$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $4b20083169abaabd$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($4b20083169abaabd$var$customInspectSymbol) $4b20083169abaabd$var$Buffer.prototype[$4b20083169abaabd$var$customInspectSymbol] = $4b20083169abaabd$var$Buffer.prototype.inspect;
$4b20083169abaabd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($4b20083169abaabd$var$isInstance(target, Uint8Array)) target = $4b20083169abaabd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$4b20083169abaabd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $4b20083169abaabd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($4b20083169abaabd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $4b20083169abaabd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($4b20083169abaabd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $4b20083169abaabd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $4b20083169abaabd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $4b20083169abaabd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$4b20083169abaabd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$4b20083169abaabd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $4b20083169abaabd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$4b20083169abaabd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $4b20083169abaabd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $4b20083169abaabd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($4b20083169abaabd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $4b20083169abaabd$var$utf8Write(buf, string, offset, length) {
    return $4b20083169abaabd$var$blitBuffer($4b20083169abaabd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $4b20083169abaabd$var$asciiWrite(buf, string, offset, length) {
    return $4b20083169abaabd$var$blitBuffer($4b20083169abaabd$var$asciiToBytes(string), buf, offset, length);
}
function $4b20083169abaabd$var$base64Write(buf, string, offset, length) {
    return $4b20083169abaabd$var$blitBuffer($4b20083169abaabd$var$base64ToBytes(string), buf, offset, length);
}
function $4b20083169abaabd$var$ucs2Write(buf, string, offset, length) {
    return $4b20083169abaabd$var$blitBuffer($4b20083169abaabd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$4b20083169abaabd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $4b20083169abaabd$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $4b20083169abaabd$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $4b20083169abaabd$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $4b20083169abaabd$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $4b20083169abaabd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$4b20083169abaabd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $4b20083169abaabd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $a890810c684395e6$export$6100ba28696e12de(buf);
    else return $a890810c684395e6$export$6100ba28696e12de(buf.slice(start, end));
}
function $4b20083169abaabd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $4b20083169abaabd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $4b20083169abaabd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $4b20083169abaabd$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $4b20083169abaabd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $4b20083169abaabd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $4b20083169abaabd$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $4b20083169abaabd$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $4b20083169abaabd$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $4b20083169abaabd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $4b20083169abaabd$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$4b20083169abaabd$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $4b20083169abaabd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $4b20083169abaabd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$4b20083169abaabd$var$Buffer.prototype.readUintLE = $4b20083169abaabd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$4b20083169abaabd$var$Buffer.prototype.readUintBE = $4b20083169abaabd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$4b20083169abaabd$var$Buffer.prototype.readUint8 = $4b20083169abaabd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$4b20083169abaabd$var$Buffer.prototype.readUint16LE = $4b20083169abaabd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$4b20083169abaabd$var$Buffer.prototype.readUint16BE = $4b20083169abaabd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$4b20083169abaabd$var$Buffer.prototype.readUint32LE = $4b20083169abaabd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$4b20083169abaabd$var$Buffer.prototype.readUint32BE = $4b20083169abaabd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$4b20083169abaabd$var$Buffer.prototype.readBigUInt64LE = $4b20083169abaabd$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $4b20083169abaabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4b20083169abaabd$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$4b20083169abaabd$var$Buffer.prototype.readBigUInt64BE = $4b20083169abaabd$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $4b20083169abaabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4b20083169abaabd$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$4b20083169abaabd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4b20083169abaabd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4b20083169abaabd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$4b20083169abaabd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4b20083169abaabd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4b20083169abaabd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$4b20083169abaabd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$4b20083169abaabd$var$Buffer.prototype.readBigInt64LE = $4b20083169abaabd$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $4b20083169abaabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4b20083169abaabd$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$4b20083169abaabd$var$Buffer.prototype.readBigInt64BE = $4b20083169abaabd$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $4b20083169abaabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4b20083169abaabd$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$4b20083169abaabd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 4, this.length);
    return $bf79d62cddbcdda3$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$4b20083169abaabd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 4, this.length);
    return $bf79d62cddbcdda3$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$4b20083169abaabd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 8, this.length);
    return $bf79d62cddbcdda3$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$4b20083169abaabd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkOffset(offset, 8, this.length);
    return $bf79d62cddbcdda3$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $4b20083169abaabd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$4b20083169abaabd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$4b20083169abaabd$var$Buffer.prototype.writeUintLE = $4b20083169abaabd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4b20083169abaabd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4b20083169abaabd$var$Buffer.prototype.writeUintBE = $4b20083169abaabd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4b20083169abaabd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4b20083169abaabd$var$Buffer.prototype.writeUint8 = $4b20083169abaabd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$4b20083169abaabd$var$Buffer.prototype.writeUint16LE = $4b20083169abaabd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4b20083169abaabd$var$Buffer.prototype.writeUint16BE = $4b20083169abaabd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4b20083169abaabd$var$Buffer.prototype.writeUint32LE = $4b20083169abaabd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$4b20083169abaabd$var$Buffer.prototype.writeUint32BE = $4b20083169abaabd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $4b20083169abaabd$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $4b20083169abaabd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $4b20083169abaabd$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $4b20083169abaabd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$4b20083169abaabd$var$Buffer.prototype.writeBigUInt64LE = $4b20083169abaabd$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $4b20083169abaabd$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$4b20083169abaabd$var$Buffer.prototype.writeBigUInt64BE = $4b20083169abaabd$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $4b20083169abaabd$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$4b20083169abaabd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4b20083169abaabd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4b20083169abaabd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4b20083169abaabd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4b20083169abaabd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$4b20083169abaabd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4b20083169abaabd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4b20083169abaabd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$4b20083169abaabd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$4b20083169abaabd$var$Buffer.prototype.writeBigInt64LE = $4b20083169abaabd$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $4b20083169abaabd$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$4b20083169abaabd$var$Buffer.prototype.writeBigInt64BE = $4b20083169abaabd$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $4b20083169abaabd$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $4b20083169abaabd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $4b20083169abaabd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $bf79d62cddbcdda3$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$4b20083169abaabd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $4b20083169abaabd$var$writeFloat(this, value, offset, true, noAssert);
};
$4b20083169abaabd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $4b20083169abaabd$var$writeFloat(this, value, offset, false, noAssert);
};
function $4b20083169abaabd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4b20083169abaabd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $bf79d62cddbcdda3$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$4b20083169abaabd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $4b20083169abaabd$var$writeDouble(this, value, offset, true, noAssert);
};
$4b20083169abaabd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $4b20083169abaabd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$4b20083169abaabd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$4b20083169abaabd$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$4b20083169abaabd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$4b20083169abaabd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $4b20083169abaabd$var$Buffer.isBuffer(val) ? val : $4b20083169abaabd$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $4b20083169abaabd$var$errors = {};
function $4b20083169abaabd$var$E(sym, getMessage, Base) {
    $4b20083169abaabd$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$4b20083169abaabd$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$4b20083169abaabd$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$4b20083169abaabd$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $4b20083169abaabd$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $4b20083169abaabd$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $4b20083169abaabd$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $4b20083169abaabd$var$checkBounds(buf, offset, byteLength) {
    $4b20083169abaabd$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $4b20083169abaabd$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $4b20083169abaabd$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $4b20083169abaabd$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $4b20083169abaabd$var$checkBounds(buf, offset, byteLength);
}
function $4b20083169abaabd$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $4b20083169abaabd$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $4b20083169abaabd$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $4b20083169abaabd$var$validateNumber(value, type);
        throw new $4b20083169abaabd$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $4b20083169abaabd$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $4b20083169abaabd$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $4b20083169abaabd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $4b20083169abaabd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($4b20083169abaabd$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $4b20083169abaabd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $4b20083169abaabd$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $4b20083169abaabd$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $4b20083169abaabd$var$base64ToBytes(str) {
    return $a890810c684395e6$export$d622b2ad8d90c771($4b20083169abaabd$var$base64clean(str));
}
function $4b20083169abaabd$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $4b20083169abaabd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $4b20083169abaabd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $4b20083169abaabd$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $4b20083169abaabd$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $4b20083169abaabd$var$BufferBigIntNotDefined : fn;
}
function $4b20083169abaabd$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $aa416a6ee3239dd2$require$Buffer = $4b20083169abaabd$export$a143d493d941bafc;
function $aa416a6ee3239dd2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa416a6ee3239dd2$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aa416a6ee3239dd2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aa416a6ee3239dd2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aa416a6ee3239dd2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aa416a6ee3239dd2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aa416a6ee3239dd2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aa416a6ee3239dd2$var$_typeof(obj);
}
function $aa416a6ee3239dd2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aa416a6ee3239dd2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $aa416a6ee3239dd2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $aa416a6ee3239dd2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aa416a6ee3239dd2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aa416a6ee3239dd2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $aa416a6ee3239dd2$var$_defineProperty(obj, key, value) {
    key = $aa416a6ee3239dd2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aa416a6ee3239dd2$var$_toConsumableArray(arr) {
    return $aa416a6ee3239dd2$var$_arrayWithoutHoles(arr) || $aa416a6ee3239dd2$var$_iterableToArray(arr) || $aa416a6ee3239dd2$var$_unsupportedIterableToArray(arr) || $aa416a6ee3239dd2$var$_nonIterableSpread();
}
function $aa416a6ee3239dd2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aa416a6ee3239dd2$var$_arrayLikeToArray(arr);
}
function $aa416a6ee3239dd2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aa416a6ee3239dd2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aa416a6ee3239dd2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aa416a6ee3239dd2$var$_arrayLikeToArray(o, minLen);
}
function $aa416a6ee3239dd2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aa416a6ee3239dd2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aa416a6ee3239dd2$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $aa416a6ee3239dd2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $aa416a6ee3239dd2$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $aa416a6ee3239dd2$var$_toPropertyKey(arg) {
    var key = $aa416a6ee3239dd2$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var $aa416a6ee3239dd2$var$Constants = {
    DEFAULT_INSTANCE: "$default_instance",
    API_VERSION: 2,
    MAX_STRING_LENGTH: 4096,
    MAX_PROPERTY_KEYS: 1000,
    IDENTIFY_EVENT: "$identify",
    GROUP_IDENTIFY_EVENT: "$groupidentify",
    EVENT_LOG_URL: "api.amplitude.com",
    EVENT_LOG_EU_URL: "api.eu.amplitude.com",
    DYNAMIC_CONFIG_URL: "regionconfig.amplitude.com",
    DYNAMIC_CONFIG_EU_URL: "regionconfig.eu.amplitude.com",
    // localStorageKeys
    LAST_EVENT_ID: "amplitude_lastEventId",
    LAST_EVENT_TIME: "amplitude_lastEventTime",
    LAST_IDENTIFY_ID: "amplitude_lastIdentifyId",
    LAST_SEQUENCE_NUMBER: "amplitude_lastSequenceNumber",
    SESSION_ID: "amplitude_sessionId",
    // Used in cookie as well
    DEVICE_ID: "amplitude_deviceId",
    OPT_OUT: "amplitude_optOut",
    USER_ID: "amplitude_userId",
    // indexes of properties in cookie v2 storage format
    DEVICE_ID_INDEX: 0,
    USER_ID_INDEX: 1,
    OPT_OUT_INDEX: 2,
    SESSION_ID_INDEX: 3,
    LAST_EVENT_TIME_INDEX: 4,
    EVENT_ID_INDEX: 5,
    IDENTIFY_ID_INDEX: 6,
    SEQUENCE_NUMBER_INDEX: 7,
    COOKIE_TEST_PREFIX: "amp_cookie_test",
    COOKIE_PREFIX: "amp",
    // Storage options
    STORAGE_DEFAULT: "",
    STORAGE_COOKIES: "cookies",
    STORAGE_NONE: "none",
    STORAGE_LOCAL: "localStorage",
    STORAGE_SESSION: "sessionStorage",
    // revenue keys
    REVENUE_EVENT: "revenue_amount",
    REVENUE_PRODUCT_ID: "$productId",
    REVENUE_QUANTITY: "$quantity",
    REVENUE_PRICE: "$price",
    REVENUE_REVENUE_TYPE: "$revenueType",
    AMP_DEVICE_ID_PARAM: "amp_device_id",
    // url param
    AMP_REFERRER_PARAM: "amp_referrer",
    // url param for overwriting the document.refer
    REFERRER: "referrer",
    REFERRING_DOMAIN: "referring_domain",
    // UTM Params
    UTM_SOURCE: "utm_source",
    UTM_MEDIUM: "utm_medium",
    UTM_CAMPAIGN: "utm_campaign",
    UTM_TERM: "utm_term",
    UTM_CONTENT: "utm_content",
    ATTRIBUTION_EVENT: "[Amplitude] Attribution Captured",
    TRANSPORT_HTTP: "http",
    TRANSPORT_BEACON: "beacon"
};
/*
 * UTF-8 encoder/decoder
 * http://www.webtoolkit.info/
 */ var $aa416a6ee3239dd2$var$UTF8 = {
    encode: function encode(s) {
        var utftext = "";
        for(var n = 0; n < s.length; n++){
            var c = s.charCodeAt(n);
            if (c < 128) utftext += String.fromCharCode(c);
            else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode(c >> 6 | 192);
                utftext += String.fromCharCode(c & 63 | 128);
            } else {
                utftext += String.fromCharCode(c >> 12 | 224);
                utftext += String.fromCharCode(c >> 6 & 63 | 128);
                utftext += String.fromCharCode(c & 63 | 128);
            }
        }
        return utftext;
    },
    decode: function decode(utftext) {
        var s = "";
        var i = 0;
        var c = 0, c1 = 0, c2 = 0;
        while(i < utftext.length){
            c = utftext.charCodeAt(i);
            if (c < 128) {
                s += String.fromCharCode(c);
                i++;
            } else if (c > 191 && c < 224) {
                c1 = utftext.charCodeAt(i + 1);
                s += String.fromCharCode((c & 31) << 6 | c1 & 63);
                i += 2;
            } else {
                c1 = utftext.charCodeAt(i + 1);
                c2 = utftext.charCodeAt(i + 2);
                s += String.fromCharCode((c & 15) << 12 | (c1 & 63) << 6 | c2 & 63);
                i += 3;
            }
        }
        return s;
    }
};
/* global globalThis */ var $aa416a6ee3239dd2$var$GlobalScope = function() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof self !== "undefined") return self;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
}();
/*
 * Base64 encoder/decoder
 * http://www.webtoolkit.info/
 */ var $aa416a6ee3239dd2$var$Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function encode(input) {
        try {
            if ($aa416a6ee3239dd2$var$GlobalScope.btoa && $aa416a6ee3239dd2$var$GlobalScope.atob) return $aa416a6ee3239dd2$var$GlobalScope.btoa(unescape(encodeURIComponent(input)));
        } catch (e) {
        //log(e);
        }
        return $aa416a6ee3239dd2$var$Base64._encode(input);
    },
    _encode: function _encode(input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = $aa416a6ee3239dd2$var$UTF8.encode(input);
        while(i < input.length){
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;
            if (isNaN(chr2)) enc3 = enc4 = 64;
            else if (isNaN(chr3)) enc4 = 64;
            output = output + $aa416a6ee3239dd2$var$Base64._keyStr.charAt(enc1) + $aa416a6ee3239dd2$var$Base64._keyStr.charAt(enc2) + $aa416a6ee3239dd2$var$Base64._keyStr.charAt(enc3) + $aa416a6ee3239dd2$var$Base64._keyStr.charAt(enc4);
        }
        return output;
    },
    decode: function decode(input) {
        try {
            if ($aa416a6ee3239dd2$var$GlobalScope.btoa && $aa416a6ee3239dd2$var$GlobalScope.atob) return decodeURIComponent(escape($aa416a6ee3239dd2$var$GlobalScope.atob(input)));
        } catch (e) {
        //log(e);
        }
        return $aa416a6ee3239dd2$var$Base64._decode(input);
    },
    _decode: function _decode(input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9+/=]/g, "");
        while(i < input.length){
            enc1 = $aa416a6ee3239dd2$var$Base64._keyStr.indexOf(input.charAt(i++));
            enc2 = $aa416a6ee3239dd2$var$Base64._keyStr.indexOf(input.charAt(i++));
            enc3 = $aa416a6ee3239dd2$var$Base64._keyStr.indexOf(input.charAt(i++));
            enc4 = $aa416a6ee3239dd2$var$Base64._keyStr.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 !== 64) output = output + String.fromCharCode(chr2);
            if (enc4 !== 64) output = output + String.fromCharCode(chr3);
        }
        output = $aa416a6ee3239dd2$var$UTF8.decode(output);
        return output;
    }
};
/**
 * toString ref.
 * @private
 */ var $aa416a6ee3239dd2$var$toString = Object.prototype.toString;
/**
 * Return the type of `val`.
 * @private
 * @param {Mixed} val
 * @return {String}
 * @api public
 */ function $aa416a6ee3239dd2$var$type(val) {
    switch($aa416a6ee3239dd2$var$toString.call(val)){
        case "[object Date]":
            return "date";
        case "[object RegExp]":
            return "regexp";
        case "[object Arguments]":
            return "arguments";
        case "[object Array]":
            return "array";
        case "[object Error]":
            return "error";
    }
    if (val === null) return "null";
    if (val === undefined) return "undefined";
    if (val !== val) return "nan";
    if (val && val.nodeType === 1) return "element";
    if (typeof $aa416a6ee3239dd2$require$Buffer !== "undefined" && typeof $aa416a6ee3239dd2$require$Buffer.isBuffer === "function" && $aa416a6ee3239dd2$require$Buffer.isBuffer(val)) return "buffer";
    val = val.valueOf ? val.valueOf() : Object.prototype.valueOf.apply(val);
    return $aa416a6ee3239dd2$var$_typeof(val);
}
var $aa416a6ee3239dd2$var$logLevels = {
    DISABLE: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3
};
var $aa416a6ee3239dd2$var$logLevel = $aa416a6ee3239dd2$var$logLevels.WARN;
var $aa416a6ee3239dd2$var$setLogLevel = function setLogLevel(logLevelName) {
    if (Object.prototype.hasOwnProperty.call($aa416a6ee3239dd2$var$logLevels, logLevelName)) $aa416a6ee3239dd2$var$logLevel = $aa416a6ee3239dd2$var$logLevels[logLevelName];
};
var $aa416a6ee3239dd2$var$getLogLevel = function getLogLevel() {
    return $aa416a6ee3239dd2$var$logLevel;
};
var $aa416a6ee3239dd2$var$log = {
    error: function error(s) {
        if ($aa416a6ee3239dd2$var$logLevel >= $aa416a6ee3239dd2$var$logLevels.ERROR) $aa416a6ee3239dd2$var$_log(s);
    },
    warn: function warn(s) {
        if ($aa416a6ee3239dd2$var$logLevel >= $aa416a6ee3239dd2$var$logLevels.WARN) $aa416a6ee3239dd2$var$_log(s);
    },
    info: function info(s) {
        if ($aa416a6ee3239dd2$var$logLevel >= $aa416a6ee3239dd2$var$logLevels.INFO) $aa416a6ee3239dd2$var$_log(s);
    }
};
var $aa416a6ee3239dd2$var$_log = function _log(s) {
    try {
        console.log("[Amplitude] " + s);
    } catch (e) {
    // console logging not available
    }
};
var $aa416a6ee3239dd2$var$isEmptyString = function isEmptyString(str) {
    return !str || str.length === 0;
};
var $aa416a6ee3239dd2$var$sessionStorageEnabled = function sessionStorageEnabled() {
    try {
        if ($aa416a6ee3239dd2$var$GlobalScope.sessionStorage) return true;
    } catch (e) {
    // sessionStorage disabled
    }
    return false;
};
// truncate string values in event and user properties so that request size does not get too large
var $aa416a6ee3239dd2$var$truncate = function truncate(value) {
    if ($aa416a6ee3239dd2$var$type(value) === "array") for(var i = 0; i < value.length; i++)value[i] = truncate(value[i]);
    else if ($aa416a6ee3239dd2$var$type(value) === "object") {
        for(var key in value)if (key in value) value[key] = truncate(value[key]);
    } else value = $aa416a6ee3239dd2$var$_truncateValue(value);
    return value;
};
var $aa416a6ee3239dd2$var$_truncateValue = function _truncateValue(value) {
    if ($aa416a6ee3239dd2$var$type(value) === "string") return value.length > $aa416a6ee3239dd2$var$Constants.MAX_STRING_LENGTH ? value.substring(0, $aa416a6ee3239dd2$var$Constants.MAX_STRING_LENGTH) : value;
    return value;
};
var $aa416a6ee3239dd2$var$validateInput = function validateInput(input, name, expectedType) {
    if ($aa416a6ee3239dd2$var$type(input) !== expectedType) {
        $aa416a6ee3239dd2$var$log.error("Invalid " + name + " input type. Expected " + expectedType + " but received " + $aa416a6ee3239dd2$var$type(input));
        return false;
    }
    return true;
};
var $aa416a6ee3239dd2$var$validateDeviceId = function validateDeviceId(deviceId) {
    if (!$aa416a6ee3239dd2$var$validateInput(deviceId, "deviceId", "string")) return false;
    if (deviceId.indexOf(".") >= 0) {
        $aa416a6ee3239dd2$var$log.error("Device IDs may not contain '.' characters. Value will be ignored: \"".concat(deviceId, '"'));
        return false;
    }
    return true;
};
var $aa416a6ee3239dd2$var$validateTransport = function validateTransport(transport) {
    if (!$aa416a6ee3239dd2$var$validateInput(transport, "transport", "string")) return false;
    if (transport !== $aa416a6ee3239dd2$var$Constants.TRANSPORT_HTTP && transport !== $aa416a6ee3239dd2$var$Constants.TRANSPORT_BEACON) {
        $aa416a6ee3239dd2$var$log.error("transport value must be one of '".concat($aa416a6ee3239dd2$var$Constants.TRANSPORT_BEACON, "' or '").concat($aa416a6ee3239dd2$var$Constants.TRANSPORT_HTTP, "'"));
        return false;
    }
    if (transport !== $aa416a6ee3239dd2$var$Constants.TRANSPORT_HTTP && typeof navigator !== "undefined" && !navigator.sendBeacon) {
        $aa416a6ee3239dd2$var$log.error("browser does not support sendBeacon, so transport must be HTTP");
        return false;
    }
    return true;
};
// do some basic sanitization and type checking, also catch property dicts with more than 1000 key/value pairs
var $aa416a6ee3239dd2$var$validateProperties = function validateProperties(properties) {
    var propsType = $aa416a6ee3239dd2$var$type(properties);
    if (propsType !== "object") {
        $aa416a6ee3239dd2$var$log.error("Error: invalid properties format. Expecting Javascript object, received " + propsType + ", ignoring");
        return {};
    }
    if (Object.keys(properties).length > $aa416a6ee3239dd2$var$Constants.MAX_PROPERTY_KEYS) {
        $aa416a6ee3239dd2$var$log.error("Error: too many properties (more than 1000), ignoring");
        return {};
    }
    var copy = {}; // create a copy with all of the valid properties
    for(var property in properties){
        if (!Object.prototype.hasOwnProperty.call(properties, property)) continue;
        // validate key
        var key = property;
        var keyType = $aa416a6ee3239dd2$var$type(key);
        if (keyType !== "string") {
            key = String(key);
            $aa416a6ee3239dd2$var$log.warn("WARNING: Non-string property key, received type " + keyType + ', coercing to string "' + key + '"');
        }
        // validate value
        var value = $aa416a6ee3239dd2$var$validatePropertyValue(key, properties[property]);
        if (value === null) continue;
        copy[key] = value;
    }
    return copy;
};
var $aa416a6ee3239dd2$var$invalidValueTypes = [
    "nan",
    "function",
    "arguments",
    "regexp",
    "element"
];
var $aa416a6ee3239dd2$var$validatePropertyValue = function validatePropertyValue(key, value) {
    var valueType = $aa416a6ee3239dd2$var$type(value);
    if ($aa416a6ee3239dd2$var$invalidValueTypes.indexOf(valueType) !== -1) {
        $aa416a6ee3239dd2$var$log.warn('WARNING: Property key "' + key + '" with invalid value type ' + valueType + ", ignoring");
        value = null;
    } else if (valueType === "undefined") value = null;
    else if (valueType === "error") {
        value = String(value);
        $aa416a6ee3239dd2$var$log.warn('WARNING: Property key "' + key + '" with value type error, coercing to ' + value);
    } else if (valueType === "array") {
        // check for nested arrays or objects
        var arrayCopy = [];
        for(var i = 0; i < value.length; i++){
            var element = value[i];
            var elemType = $aa416a6ee3239dd2$var$type(element);
            if (elemType === "array") {
                $aa416a6ee3239dd2$var$log.warn("WARNING: Cannot have " + elemType + " nested in an array property value, skipping");
                continue;
            } else if (elemType === "object") arrayCopy.push($aa416a6ee3239dd2$var$validateProperties(element));
            else arrayCopy.push(validatePropertyValue(key, element));
        }
        value = arrayCopy;
    } else if (valueType === "object") value = $aa416a6ee3239dd2$var$validateProperties(value);
    return value;
};
var $aa416a6ee3239dd2$var$validateGroups = function validateGroups(groups) {
    var groupsType = $aa416a6ee3239dd2$var$type(groups);
    if (groupsType !== "object") {
        $aa416a6ee3239dd2$var$log.error("Error: invalid groups format. Expecting Javascript object, received " + groupsType + ", ignoring");
        return {};
    }
    var copy = {}; // create a copy with all of the valid properties
    for(var group in groups){
        if (!Object.prototype.hasOwnProperty.call(groups, group)) continue;
        // validate key
        var key = group;
        var keyType = $aa416a6ee3239dd2$var$type(key);
        if (keyType !== "string") {
            key = String(key);
            $aa416a6ee3239dd2$var$log.warn("WARNING: Non-string groupType, received type " + keyType + ', coercing to string "' + key + '"');
        }
        // validate value
        var value = $aa416a6ee3239dd2$var$validateGroupName(key, groups[group]);
        if (value === null) continue;
        copy[key] = value;
    }
    return copy;
};
var $aa416a6ee3239dd2$var$validateGroupName = function validateGroupName(key, groupName) {
    var groupNameType = $aa416a6ee3239dd2$var$type(groupName);
    if (groupNameType === "string") return groupName;
    if (groupNameType === "date" || groupNameType === "number" || groupNameType === "boolean") {
        groupName = String(groupName);
        $aa416a6ee3239dd2$var$log.warn("WARNING: Non-string groupName, received type " + groupNameType + ', coercing to string "' + groupName + '"');
        return groupName;
    }
    if (groupNameType === "array") {
        // check for nested arrays or objects
        var arrayCopy = [];
        for(var i = 0; i < groupName.length; i++){
            var element = groupName[i];
            var elemType = $aa416a6ee3239dd2$var$type(element);
            if (elemType === "array" || elemType === "object") {
                $aa416a6ee3239dd2$var$log.warn("WARNING: Skipping nested " + elemType + " in array groupName");
                continue;
            } else if (elemType === "string") arrayCopy.push(element);
            else if (elemType === "date" || elemType === "number" || elemType === "boolean") {
                element = String(element);
                $aa416a6ee3239dd2$var$log.warn("WARNING: Non-string groupName, received type " + elemType + ', coercing to string "' + element + '"');
                arrayCopy.push(element);
            }
        }
        return arrayCopy;
    }
    $aa416a6ee3239dd2$var$log.warn("WARNING: Non-string groupName, received type " + groupNameType + ". Please use strings or array of strings for groupName");
};
// parses the value of a url param (for example ?gclid=1234&...)
var $aa416a6ee3239dd2$var$getQueryParam = function getQueryParam(name, query) {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(query);
    return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, " "));
};
var $aa416a6ee3239dd2$var$isWebWorkerEnvironment = function isWebWorkerEnvironment() {
    return typeof WorkerGlobalScope !== "undefined";
};
var $aa416a6ee3239dd2$var$validateSessionId = function validateSessionId(sessionId) {
    if ($aa416a6ee3239dd2$var$validateInput(sessionId, "sessionId", "number") && new Date(sessionId).getTime() > 0) return true;
    $aa416a6ee3239dd2$var$log.error("sessionId value must in milliseconds since epoch (Unix Timestamp)");
    return false;
};
var $aa416a6ee3239dd2$var$getLocation = function getLocation() {
    return $aa416a6ee3239dd2$var$GlobalScope.location;
};
var $aa416a6ee3239dd2$var$getHost = function getHost(url) {
    var defaultHostname = $aa416a6ee3239dd2$var$GlobalScope.location ? $aa416a6ee3239dd2$var$GlobalScope.location.hostname : "";
    if (url) {
        if (typeof document !== "undefined") {
            var a = document.createElement("a");
            a.href = url;
            return a.hostname || defaultHostname;
        }
        if (typeof URL === "function") {
            var u = new URL(url);
            return u.hostname || defaultHostname;
        }
    }
    return defaultHostname;
};
var $aa416a6ee3239dd2$var$utils = {
    setLogLevel: $aa416a6ee3239dd2$var$setLogLevel,
    getLogLevel: $aa416a6ee3239dd2$var$getLogLevel,
    logLevels: $aa416a6ee3239dd2$var$logLevels,
    log: $aa416a6ee3239dd2$var$log,
    isEmptyString: $aa416a6ee3239dd2$var$isEmptyString,
    isWebWorkerEnvironment: $aa416a6ee3239dd2$var$isWebWorkerEnvironment,
    getQueryParam: $aa416a6ee3239dd2$var$getQueryParam,
    sessionStorageEnabled: $aa416a6ee3239dd2$var$sessionStorageEnabled,
    truncate: $aa416a6ee3239dd2$var$truncate,
    validateGroups: $aa416a6ee3239dd2$var$validateGroups,
    validateInput: $aa416a6ee3239dd2$var$validateInput,
    validateProperties: $aa416a6ee3239dd2$var$validateProperties,
    validateDeviceId: $aa416a6ee3239dd2$var$validateDeviceId,
    validateTransport: $aa416a6ee3239dd2$var$validateTransport,
    validateSessionId: $aa416a6ee3239dd2$var$validateSessionId,
    getLocation: $aa416a6ee3239dd2$var$getLocation,
    getHost: $aa416a6ee3239dd2$var$getHost
};
var $aa416a6ee3239dd2$var$get$1 = function get(name) {
    try {
        var ca = document.cookie.split(";");
        var value = null;
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(name) === 0) {
                value = c.substring(name.length, c.length);
                break;
            }
        }
        return value;
    } catch (e) {
        return null;
    }
};
var $aa416a6ee3239dd2$var$getAll = function getAll(name) {
    try {
        var cookieArray = document.cookie.split(";").map(function(c) {
            return c.trimStart();
        });
        var values = [];
        var _iterator = $aa416a6ee3239dd2$var$_createForOfIteratorHelper(cookieArray), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var cookie = _step.value;
                while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
                if (cookie.indexOf(name) === 0) values.push(cookie.substring(name.length));
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return values;
    } catch (e) {
        return [];
    }
};
var $aa416a6ee3239dd2$var$set$1 = function set(name, value, opts) {
    var expires = value !== null ? opts.expirationDays : -1;
    if (expires) {
        var date = new Date();
        date.setTime(date.getTime() + expires * 86400000);
        expires = date;
    }
    var str = name + "=" + value;
    if (expires) str += "; expires=" + expires.toUTCString();
    str += "; path=/";
    if (opts.domain) str += "; domain=" + opts.domain;
    if (opts.secure) str += "; Secure";
    if (opts.sameSite) str += "; SameSite=" + opts.sameSite;
    document.cookie = str;
};
var $aa416a6ee3239dd2$var$getLastEventTime = function getLastEventTime() {
    var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var strValue = cookie.split(".")[$aa416a6ee3239dd2$var$Constants.LAST_EVENT_TIME_INDEX];
    var parsedValue;
    if (strValue) parsedValue = parseInt(strValue, 32);
    if (parsedValue) return parsedValue;
    else {
        $aa416a6ee3239dd2$var$utils.log.warn("unable to parse malformed cookie: ".concat(cookie));
        return 0;
    }
};
var $aa416a6ee3239dd2$var$sortByEventTime = function sortByEventTime(cookies) {
    return $aa416a6ee3239dd2$var$_toConsumableArray(cookies).sort(function(c1, c2) {
        var t1 = $aa416a6ee3239dd2$var$getLastEventTime(c1);
        var t2 = $aa416a6ee3239dd2$var$getLastEventTime(c2);
        // sort c1 first if its last event time is more recent
        // i.e its event time integer is larger that c2's
        return t2 - t1;
    });
};
// test that cookies are enabled - navigator.cookiesEnabled yields false positives in IE, need to test directly
var $aa416a6ee3239dd2$var$areCookiesEnabled = function areCookiesEnabled() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cookieName = $aa416a6ee3239dd2$var$Constants.COOKIE_TEST_PREFIX;
    if (typeof document === "undefined") return false;
    var _areCookiesEnabled = false;
    try {
        var uid = String(Date.now());
        $aa416a6ee3239dd2$var$set$1(cookieName, uid, opts);
        $aa416a6ee3239dd2$var$utils.log.info("Testing if cookies available");
        _areCookiesEnabled = $aa416a6ee3239dd2$var$get$1(cookieName + "=") === uid;
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.warn('Error thrown when checking for cookies. Reason: "'.concat(e, '"'));
    } finally{
        $aa416a6ee3239dd2$var$utils.log.info("Cleaning up cookies availability test");
        $aa416a6ee3239dd2$var$set$1(cookieName, null, opts);
    }
    return _areCookiesEnabled;
};
var $aa416a6ee3239dd2$var$baseCookie = {
    set: $aa416a6ee3239dd2$var$set$1,
    get: $aa416a6ee3239dd2$var$get$1,
    getAll: $aa416a6ee3239dd2$var$getAll,
    getLastEventTime: $aa416a6ee3239dd2$var$getLastEventTime,
    sortByEventTime: $aa416a6ee3239dd2$var$sortByEventTime,
    areCookiesEnabled: $aa416a6ee3239dd2$var$areCookiesEnabled
};
// A URL safe variation on the the list of Base64 characters
var $aa416a6ee3239dd2$var$base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
var $aa416a6ee3239dd2$var$base64Id = function base64Id() {
    var str = "";
    for(var i = 0; i < 22; ++i)str += $aa416a6ee3239dd2$var$base64Chars.charAt(Math.floor(Math.random() * 64));
    return str;
};
// Utility that finds top level domain to write to
var $aa416a6ee3239dd2$var$topDomain = function topDomain(url) {
    var host = $aa416a6ee3239dd2$var$utils.getHost(url);
    var parts = host.split(".");
    var levels = [];
    var cname = "_tldtest_" + $aa416a6ee3239dd2$var$base64Id();
    if ($aa416a6ee3239dd2$var$utils.isWebWorkerEnvironment()) return "";
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join("."));
    for(var _i = 0; _i < levels.length; ++_i){
        var domain = levels[_i];
        var opts = {
            domain: "." + domain
        };
        $aa416a6ee3239dd2$var$baseCookie.set(cname, 1, opts);
        if ($aa416a6ee3239dd2$var$baseCookie.get(cname)) {
            $aa416a6ee3239dd2$var$baseCookie.set(cname, null, opts);
            return domain;
        }
    }
    return "";
};
/*
 * Cookie data
 */ var $aa416a6ee3239dd2$var$_options = {
    expirationDays: undefined,
    domain: undefined
};
var $aa416a6ee3239dd2$var$reset = function reset() {
    $aa416a6ee3239dd2$var$_options = {
        expirationDays: undefined,
        domain: undefined
    };
};
var $aa416a6ee3239dd2$var$options = function options(opts) {
    if (arguments.length === 0) return $aa416a6ee3239dd2$var$_options;
    opts = opts || {};
    $aa416a6ee3239dd2$var$_options.expirationDays = opts.expirationDays;
    $aa416a6ee3239dd2$var$_options.secure = opts.secure;
    $aa416a6ee3239dd2$var$_options.sameSite = opts.sameSite;
    var domain = !$aa416a6ee3239dd2$var$utils.isEmptyString(opts.domain) ? opts.domain : "." + $aa416a6ee3239dd2$var$topDomain($aa416a6ee3239dd2$var$utils.getLocation().href);
    var token = Math.random();
    $aa416a6ee3239dd2$var$_options.domain = domain;
    $aa416a6ee3239dd2$var$set("amplitude_test", token);
    var stored = $aa416a6ee3239dd2$var$get("amplitude_test");
    if (!stored || stored !== token) domain = null;
    $aa416a6ee3239dd2$var$remove("amplitude_test");
    $aa416a6ee3239dd2$var$_options.domain = domain;
    return $aa416a6ee3239dd2$var$_options;
};
var $aa416a6ee3239dd2$var$_domainSpecific = function _domainSpecific(name) {
    // differentiate between cookies on different domains
    var suffix = "";
    if ($aa416a6ee3239dd2$var$_options.domain) suffix = $aa416a6ee3239dd2$var$_options.domain.charAt(0) === "." ? $aa416a6ee3239dd2$var$_options.domain.substring(1) : $aa416a6ee3239dd2$var$_options.domain;
    return name + suffix;
};
var $aa416a6ee3239dd2$var$get = function get(name) {
    var nameEq = $aa416a6ee3239dd2$var$_domainSpecific(name) + "=";
    var value = $aa416a6ee3239dd2$var$baseCookie.get(nameEq);
    try {
        if (value) return JSON.parse($aa416a6ee3239dd2$var$Base64.decode(value));
    } catch (e) {
        return null;
    }
    return null;
};
var $aa416a6ee3239dd2$var$set = function set(name, value) {
    try {
        $aa416a6ee3239dd2$var$baseCookie.set($aa416a6ee3239dd2$var$_domainSpecific(name), $aa416a6ee3239dd2$var$Base64.encode(JSON.stringify(value)), $aa416a6ee3239dd2$var$_options);
        return true;
    } catch (e) {
        return false;
    }
};
var $aa416a6ee3239dd2$var$setRaw = function setRaw(name, value) {
    try {
        $aa416a6ee3239dd2$var$baseCookie.set($aa416a6ee3239dd2$var$_domainSpecific(name), value, $aa416a6ee3239dd2$var$_options);
        return true;
    } catch (e) {
        return false;
    }
};
var $aa416a6ee3239dd2$var$getRaw = function getRaw(name) {
    var nameEq = $aa416a6ee3239dd2$var$_domainSpecific(name) + "=";
    return $aa416a6ee3239dd2$var$baseCookie.get(nameEq);
};
var $aa416a6ee3239dd2$var$remove = function remove(name) {
    try {
        $aa416a6ee3239dd2$var$baseCookie.set($aa416a6ee3239dd2$var$_domainSpecific(name), null, $aa416a6ee3239dd2$var$_options);
        return true;
    } catch (e) {
        return false;
    }
};
var $aa416a6ee3239dd2$var$Cookie = {
    reset: $aa416a6ee3239dd2$var$reset,
    options: $aa416a6ee3239dd2$var$options,
    get: $aa416a6ee3239dd2$var$get,
    set: $aa416a6ee3239dd2$var$set,
    remove: $aa416a6ee3239dd2$var$remove,
    setRaw: $aa416a6ee3239dd2$var$setRaw,
    getRaw: $aa416a6ee3239dd2$var$getRaw
};
var $aa416a6ee3239dd2$var$WorkerStorage = /*#__PURE__*/ function() {
    function WorkerStorage() {
        $aa416a6ee3239dd2$var$_classCallCheck(this, WorkerStorage);
        this.map = new Map();
        this.length = 0;
    }
    $aa416a6ee3239dd2$var$_createClass(WorkerStorage, [
        {
            key: "key",
            value: function key(index) {
                var keys = Array.from(this.map.keys());
                var key = keys[index];
                return this.map.get(key);
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                return this.map.get(key);
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                if (!this.map.has(key)) this.length += 1;
                this.map.set(key, value);
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                if (this.map.has(key)) {
                    this.length -= 1;
                    this.map["delete"](key);
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.map.clear();
                this.length = 0;
            }
        }
    ]);
    return WorkerStorage;
}();
/*
 * Implement localStorage to support Firefox 2-3 and IE 5-7
 */ var $aa416a6ee3239dd2$var$localStorage;
// test that Window.localStorage is available and works
var $aa416a6ee3239dd2$var$windowLocalStorageAvailable = function windowLocalStorageAvailable() {
    var uid = new Date();
    var result;
    try {
        $aa416a6ee3239dd2$var$GlobalScope.localStorage.setItem(uid, uid);
        result = $aa416a6ee3239dd2$var$GlobalScope.localStorage.getItem(uid) === String(uid);
        $aa416a6ee3239dd2$var$GlobalScope.localStorage.removeItem(uid);
        return result;
    } catch (e) {
    // localStorage not available
    }
    return false;
};
if ($aa416a6ee3239dd2$var$windowLocalStorageAvailable()) $aa416a6ee3239dd2$var$localStorage = $aa416a6ee3239dd2$var$GlobalScope.localStorage;
else if (typeof $aa416a6ee3239dd2$var$GlobalScope !== "undefined" && $aa416a6ee3239dd2$var$GlobalScope.globalStorage) // Firefox 2-3 use globalStorage
// See https://developer.mozilla.org/en/dom/storage#globalStorage
try {
    $aa416a6ee3239dd2$var$localStorage = $aa416a6ee3239dd2$var$GlobalScope.globalStorage[$aa416a6ee3239dd2$var$GlobalScope.location.hostname];
} catch (e) {
// Something bad happened...
}
else if (typeof document !== "undefined") {
    // IE 5-7 use userData
    // See http://msdn.microsoft.com/en-us/library/ms531424(v=vs.85).aspx
    var $aa416a6ee3239dd2$var$div = document.createElement("div"), $aa416a6ee3239dd2$var$attrKey = "localStorage";
    $aa416a6ee3239dd2$var$div.style.display = "none";
    document.getElementsByTagName("head")[0].appendChild($aa416a6ee3239dd2$var$div);
    if ($aa416a6ee3239dd2$var$div.addBehavior) {
        $aa416a6ee3239dd2$var$div.addBehavior("#default#userdata");
        $aa416a6ee3239dd2$var$localStorage = {
            length: 0,
            setItem: function setItem(k, v) {
                $aa416a6ee3239dd2$var$div.load($aa416a6ee3239dd2$var$attrKey);
                if (!$aa416a6ee3239dd2$var$div.getAttribute(k)) this.length++;
                $aa416a6ee3239dd2$var$div.setAttribute(k, v);
                $aa416a6ee3239dd2$var$div.save($aa416a6ee3239dd2$var$attrKey);
            },
            getItem: function getItem(k) {
                $aa416a6ee3239dd2$var$div.load($aa416a6ee3239dd2$var$attrKey);
                return $aa416a6ee3239dd2$var$div.getAttribute(k);
            },
            removeItem: function removeItem(k) {
                $aa416a6ee3239dd2$var$div.load($aa416a6ee3239dd2$var$attrKey);
                if ($aa416a6ee3239dd2$var$div.getAttribute(k)) this.length--;
                $aa416a6ee3239dd2$var$div.removeAttribute(k);
                $aa416a6ee3239dd2$var$div.save($aa416a6ee3239dd2$var$attrKey);
            },
            clear: function clear() {
                $aa416a6ee3239dd2$var$div.load($aa416a6ee3239dd2$var$attrKey);
                var i = 0;
                var attr;
                while(attr = $aa416a6ee3239dd2$var$div.XMLDocument.documentElement.attributes[i++])$aa416a6ee3239dd2$var$div.removeAttribute(attr.name);
                $aa416a6ee3239dd2$var$div.save($aa416a6ee3239dd2$var$attrKey);
                this.length = 0;
            },
            key: function key(k) {
                $aa416a6ee3239dd2$var$div.load($aa416a6ee3239dd2$var$attrKey);
                return $aa416a6ee3239dd2$var$div.XMLDocument.documentElement.attributes[k];
            }
        };
        $aa416a6ee3239dd2$var$div.load($aa416a6ee3239dd2$var$attrKey);
        $aa416a6ee3239dd2$var$localStorage.length = $aa416a6ee3239dd2$var$div.XMLDocument.documentElement.attributes.length;
    }
} else if ($aa416a6ee3239dd2$var$utils.isWebWorkerEnvironment()) // Web worker
$aa416a6ee3239dd2$var$localStorage = new $aa416a6ee3239dd2$var$WorkerStorage();
if (!$aa416a6ee3239dd2$var$localStorage) /* eslint-disable no-unused-vars */ $aa416a6ee3239dd2$var$localStorage = {
    length: 0,
    setItem: function setItem(k, v) {},
    getItem: function getItem(k) {},
    removeItem: function removeItem(k) {},
    clear: function clear() {},
    key: function key(k) {}
};
var $aa416a6ee3239dd2$var$localStorage$1 = $aa416a6ee3239dd2$var$localStorage;
/*
 * Abstraction layer for cookie storage.
 * Uses cookie if available, otherwise fallback to localstorage.
 */ var $aa416a6ee3239dd2$var$cookieStorage = function cookieStorage() {
    this.storage = null;
};
$aa416a6ee3239dd2$var$cookieStorage.prototype.getStorage = function(disableCookies) {
    if (this.storage !== null) return this.storage;
    if (!disableCookies && $aa416a6ee3239dd2$var$baseCookie.areCookiesEnabled()) this.storage = $aa416a6ee3239dd2$var$Cookie;
    else {
        // if cookies disabled, fallback to localstorage
        // note: localstorage does not persist across subdomains
        var keyPrefix = "amp_cookiestore_";
        this.storage = {
            _options: {
                expirationDays: undefined,
                domain: undefined,
                secure: false
            },
            reset: function reset() {
                this._options = {
                    expirationDays: undefined,
                    domain: undefined,
                    secure: false
                };
            },
            options: function options(opts) {
                if (arguments.length === 0) return this._options;
                opts = opts || {};
                this._options.expirationDays = opts.expirationDays || this._options.expirationDays;
                // localStorage is specific to subdomains
                this._options.domain = opts.domain || this._options.domain || $aa416a6ee3239dd2$var$GlobalScope && $aa416a6ee3239dd2$var$GlobalScope.location && $aa416a6ee3239dd2$var$GlobalScope.location.hostname;
                return this._options.secure = opts.secure || false;
            },
            get: function get(name) {
                try {
                    return JSON.parse($aa416a6ee3239dd2$var$localStorage$1.getItem(keyPrefix + name));
                } catch (e) {} /* eslint-disable-line no-empty */ 
                return null;
            },
            set: function set(name, value) {
                try {
                    $aa416a6ee3239dd2$var$localStorage$1.setItem(keyPrefix + name, JSON.stringify(value));
                    return true;
                } catch (e) {} /* eslint-disable-line no-empty */ 
                return false;
            },
            remove: function remove(name) {
                try {
                    $aa416a6ee3239dd2$var$localStorage$1.removeItem(keyPrefix + name);
                } catch (e) {
                    return false;
                }
            }
        };
    }
    return this.storage;
};
var $aa416a6ee3239dd2$var$_storageOptionExists;
var $aa416a6ee3239dd2$var$storageOptionExists = ($aa416a6ee3239dd2$var$_storageOptionExists = {}, $aa416a6ee3239dd2$var$_defineProperty($aa416a6ee3239dd2$var$_storageOptionExists, $aa416a6ee3239dd2$var$Constants.STORAGE_COOKIES, true), $aa416a6ee3239dd2$var$_defineProperty($aa416a6ee3239dd2$var$_storageOptionExists, $aa416a6ee3239dd2$var$Constants.STORAGE_NONE, true), $aa416a6ee3239dd2$var$_defineProperty($aa416a6ee3239dd2$var$_storageOptionExists, $aa416a6ee3239dd2$var$Constants.STORAGE_LOCAL, true), $aa416a6ee3239dd2$var$_defineProperty($aa416a6ee3239dd2$var$_storageOptionExists, $aa416a6ee3239dd2$var$Constants.STORAGE_SESSION, true), $aa416a6ee3239dd2$var$_storageOptionExists);
/**
 * MetadataStorage involves SDK data persistance
 * storage priority: cookies -> localStorage -> in memory
 * This priority can be overriden by setting the storage options.
 * if in localStorage, unable track users between subdomains
 * if in memory, then memory can't be shared between different tabs
 */ var $aa416a6ee3239dd2$var$MetadataStorage = /*#__PURE__*/ function() {
    function MetadataStorage(_ref) {
        var storageKey = _ref.storageKey, disableCookies = _ref.disableCookies, domain = _ref.domain, secure = _ref.secure, sameSite = _ref.sameSite, expirationDays = _ref.expirationDays, storage = _ref.storage;
        $aa416a6ee3239dd2$var$_classCallCheck(this, MetadataStorage);
        this.storageKey = storageKey;
        this.domain = domain;
        this.secure = secure;
        this.sameSite = sameSite;
        this.expirationDays = expirationDays;
        this.cookieDomain = "";
        var loc = $aa416a6ee3239dd2$var$utils.getLocation() ? $aa416a6ee3239dd2$var$utils.getLocation().href : undefined;
        var writableTopDomain = !disableCookies ? $aa416a6ee3239dd2$var$topDomain(loc) : "";
        this.cookieDomain = domain || (writableTopDomain ? "." + writableTopDomain : null);
        if ($aa416a6ee3239dd2$var$storageOptionExists[storage]) this.storage = storage;
        else {
            var disableCookieStorage = disableCookies || !$aa416a6ee3239dd2$var$baseCookie.areCookiesEnabled({
                domain: this.cookieDomain,
                secure: this.secure,
                sameSite: this.sameSite,
                expirationDays: this.expirationDays
            });
            if (disableCookieStorage) this.storage = $aa416a6ee3239dd2$var$Constants.STORAGE_LOCAL;
            else this.storage = $aa416a6ee3239dd2$var$Constants.STORAGE_COOKIES;
        }
    }
    $aa416a6ee3239dd2$var$_createClass(MetadataStorage, [
        {
            key: "getCookieStorageKey",
            value: function getCookieStorageKey() {
                if (!this.domain) return this.storageKey;
                var suffix = this.domain.charAt(0) === "." ? this.domain.substring(1) : this.domain;
                return "".concat(this.storageKey).concat(suffix ? "_".concat(suffix) : "");
            }
        },
        {
            key: "save",
            value: function save(_ref2) {
                var deviceId = _ref2.deviceId, userId = _ref2.userId, optOut = _ref2.optOut, sessionId = _ref2.sessionId, lastEventTime = _ref2.lastEventTime, eventId = _ref2.eventId, identifyId = _ref2.identifyId, sequenceNumber = _ref2.sequenceNumber;
                if (this.storage === $aa416a6ee3239dd2$var$Constants.STORAGE_NONE) return;
                var value = [
                    deviceId,
                    $aa416a6ee3239dd2$var$Base64.encode(userId || ""),
                    // used to convert not unicode to alphanumeric since cookies only use alphanumeric
                    optOut ? "1" : "",
                    sessionId ? sessionId.toString(32) : "0",
                    // generated when instantiated, timestamp (but re-uses session id in cookie if not expired) @TODO clients may want custom session id
                    lastEventTime ? lastEventTime.toString(32) : "0",
                    // last time an event was set
                    eventId ? eventId.toString(32) : "0",
                    identifyId ? identifyId.toString(32) : "0",
                    sequenceNumber ? sequenceNumber.toString(32) : "0"
                ].join(".");
                switch(this.storage){
                    case $aa416a6ee3239dd2$var$Constants.STORAGE_SESSION:
                        if ($aa416a6ee3239dd2$var$GlobalScope.sessionStorage) $aa416a6ee3239dd2$var$GlobalScope.sessionStorage.setItem(this.storageKey, value);
                        break;
                    case $aa416a6ee3239dd2$var$Constants.STORAGE_LOCAL:
                        $aa416a6ee3239dd2$var$localStorage$1.setItem(this.storageKey, value);
                        break;
                    case $aa416a6ee3239dd2$var$Constants.STORAGE_COOKIES:
                        this.saveCookie(value);
                        break;
                }
            }
        },
        {
            key: "saveCookie",
            value: function saveCookie(value) {
                $aa416a6ee3239dd2$var$baseCookie.set(this.getCookieStorageKey(), value, {
                    domain: this.cookieDomain,
                    secure: this.secure,
                    sameSite: this.sameSite,
                    expirationDays: this.expirationDays
                });
            }
        },
        {
            key: "load",
            value: function load() {
                var _this = this;
                var str;
                if (this.storage === $aa416a6ee3239dd2$var$Constants.STORAGE_COOKIES) {
                    var cookieKey = this.getCookieStorageKey() + "=";
                    var allCookies = $aa416a6ee3239dd2$var$baseCookie.getAll(cookieKey);
                    if (allCookies.length === 0 || allCookies.length === 1) str = allCookies[0];
                    else {
                        // dedup cookies by deleting them all and restoring
                        // the one with the most recent event time
                        var latestCookie = $aa416a6ee3239dd2$var$baseCookie.sortByEventTime(allCookies)[0];
                        allCookies.forEach(function() {
                            return $aa416a6ee3239dd2$var$baseCookie.set(_this.getCookieStorageKey(), null, {});
                        });
                        this.saveCookie(latestCookie);
                        str = $aa416a6ee3239dd2$var$baseCookie.get(cookieKey);
                    }
                }
                if (!str) str = $aa416a6ee3239dd2$var$localStorage$1.getItem(this.storageKey);
                if (!str) try {
                    str = $aa416a6ee3239dd2$var$GlobalScope.sessionStorage && $aa416a6ee3239dd2$var$GlobalScope.sessionStorage.getItem(this.storageKey);
                } catch (e) {
                    $aa416a6ee3239dd2$var$utils.log.info('window.sessionStorage unavailable. Reason: "'.concat(e, '"'));
                }
                if (!str) return null;
                var values = str.split(".");
                var userId = null;
                if (values[$aa416a6ee3239dd2$var$Constants.USER_ID_INDEX]) try {
                    userId = $aa416a6ee3239dd2$var$Base64.decode(values[$aa416a6ee3239dd2$var$Constants.USER_ID_INDEX]);
                } catch (e) {
                    userId = null;
                }
                return {
                    deviceId: values[$aa416a6ee3239dd2$var$Constants.DEVICE_ID_INDEX],
                    userId: userId,
                    optOut: values[$aa416a6ee3239dd2$var$Constants.OPT_OUT_INDEX] === "1",
                    sessionId: parseInt(values[$aa416a6ee3239dd2$var$Constants.SESSION_ID_INDEX], 32),
                    lastEventTime: parseInt(values[$aa416a6ee3239dd2$var$Constants.LAST_EVENT_TIME_INDEX], 32),
                    eventId: parseInt(values[$aa416a6ee3239dd2$var$Constants.EVENT_ID_INDEX], 32),
                    identifyId: parseInt(values[$aa416a6ee3239dd2$var$Constants.IDENTIFY_ID_INDEX], 32),
                    sequenceNumber: parseInt(values[$aa416a6ee3239dd2$var$Constants.SEQUENCE_NUMBER_INDEX], 32)
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                var str;
                if (this.storage === $aa416a6ee3239dd2$var$Constants.STORAGE_COOKIES) {
                    str = $aa416a6ee3239dd2$var$baseCookie.get(this.getCookieStorageKey() + "=");
                    $aa416a6ee3239dd2$var$baseCookie.set(this.getCookieStorageKey(), null, {
                        domain: this.cookieDomain,
                        secure: this.secure,
                        sameSite: this.sameSite,
                        expirationDays: 0
                    });
                }
                if (!str) {
                    str = $aa416a6ee3239dd2$var$localStorage$1.getItem(this.storageKey);
                    $aa416a6ee3239dd2$var$localStorage$1.clear();
                }
                if (!str) try {
                    str = $aa416a6ee3239dd2$var$GlobalScope.sessionStorage && $aa416a6ee3239dd2$var$GlobalScope.sessionStorage.getItem(this.storageKey);
                    $aa416a6ee3239dd2$var$GlobalScope.sessionStorage.clear();
                } catch (e) {
                    $aa416a6ee3239dd2$var$utils.log.info('window.sessionStorage unavailable. Reason: "'.concat(e, '"'));
                }
                return !!str;
            }
        }
    ]);
    return MetadataStorage;
}();
var $aa416a6ee3239dd2$var$getUtmData = function getUtmData(rawCookie, query) {
    // Translate the utmz cookie format into url query string format.
    var cookie = rawCookie ? "?" + rawCookie.split(".").slice(-1)[0].replace(/\|/g, "&") : "";
    var fetchParam = function fetchParam(queryName, query, cookieName, cookie) {
        return $aa416a6ee3239dd2$var$utils.getQueryParam(queryName, query) || $aa416a6ee3239dd2$var$utils.getQueryParam(cookieName, cookie);
    };
    var utmSource = fetchParam($aa416a6ee3239dd2$var$Constants.UTM_SOURCE, query, "utmcsr", cookie);
    var utmMedium = fetchParam($aa416a6ee3239dd2$var$Constants.UTM_MEDIUM, query, "utmcmd", cookie);
    var utmCampaign = fetchParam($aa416a6ee3239dd2$var$Constants.UTM_CAMPAIGN, query, "utmccn", cookie);
    var utmTerm = fetchParam($aa416a6ee3239dd2$var$Constants.UTM_TERM, query, "utmctr", cookie);
    var utmContent = fetchParam($aa416a6ee3239dd2$var$Constants.UTM_CONTENT, query, "utmcct", cookie);
    var utmData = {};
    var addIfNotNull = function addIfNotNull(key, value) {
        if (!$aa416a6ee3239dd2$var$utils.isEmptyString(value)) utmData[key] = value;
    };
    addIfNotNull($aa416a6ee3239dd2$var$Constants.UTM_SOURCE, utmSource);
    addIfNotNull($aa416a6ee3239dd2$var$Constants.UTM_MEDIUM, utmMedium);
    addIfNotNull($aa416a6ee3239dd2$var$Constants.UTM_CAMPAIGN, utmCampaign);
    addIfNotNull($aa416a6ee3239dd2$var$Constants.UTM_TERM, utmTerm);
    addIfNotNull($aa416a6ee3239dd2$var$Constants.UTM_CONTENT, utmContent);
    return utmData;
};
/*
 * Wrapper for a user properties JSON object that supports operations.
 * Note: if a user property is used in multiple operations on the same Identify object,
 * only the first operation will be saved, and the rest will be ignored.
 */ var $aa416a6ee3239dd2$var$AMP_OP_ADD = "$add";
var $aa416a6ee3239dd2$var$AMP_OP_APPEND = "$append";
var $aa416a6ee3239dd2$var$AMP_OP_CLEAR_ALL = "$clearAll";
var $aa416a6ee3239dd2$var$AMP_OP_PREPEND = "$prepend";
var $aa416a6ee3239dd2$var$AMP_OP_SET = "$set";
var $aa416a6ee3239dd2$var$AMP_OP_SET_ONCE = "$setOnce";
var $aa416a6ee3239dd2$var$AMP_OP_UNSET = "$unset";
var $aa416a6ee3239dd2$var$AMP_OP_PREINSERT = "$preInsert";
var $aa416a6ee3239dd2$var$AMP_OP_POSTINSERT = "$postInsert";
var $aa416a6ee3239dd2$var$AMP_OP_REMOVE = "$remove";
/**
 * Identify API - instance constructor. Identify objects are a wrapper for user property operations.
 * Each method adds a user property operation to the Identify object, and returns the same Identify object,
 * allowing you to chain multiple method calls together.
 * Note: if the same user property is used in multiple operations on a single Identify object,
 * only the first operation on that property will be saved, and the rest will be ignored.
 * @constructor Identify
 * @public
 * @example var identify = new amplitude.Identify();
 */ var $aa416a6ee3239dd2$var$Identify = function Identify() {
    this.userPropertiesOperations = {};
    this.properties = []; // keep track of keys that have been added
};
/**
 * Increment a user property by a given value (can also be negative to decrement).
 * If the user property does not have a value set yet, it will be initialized to 0 before being incremented.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string} value - The amount by which to increment the user property. Allows numbers as strings (ex: '123').
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().add('karma', 1).add('friends', 1);
 * amplitude.identify(identify); // send the Identify call
 */ $aa416a6ee3239dd2$var$Identify.prototype.add = function(property, value) {
    if ($aa416a6ee3239dd2$var$type(value) === "number" || $aa416a6ee3239dd2$var$type(value) === "string") this._addOperation($aa416a6ee3239dd2$var$AMP_OP_ADD, property, value);
    else $aa416a6ee3239dd2$var$utils.log.error("Unsupported type for value: " + $aa416a6ee3239dd2$var$type(value) + ", expecting number or string");
    return this;
};
/**
 * Append a value or values to a user property.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are appended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values appended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to append.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().append('ab-tests', 'new-user-tests');
 * identify.append('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */ $aa416a6ee3239dd2$var$Identify.prototype.append = function(property, value) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_APPEND, property, value);
    return this;
};
/**
 * Clear all user properties for the current user.
 * SDK user should instead call amplitude.clearUserProperties() instead of using this.
 * $clearAll needs to be sent on its own Identify object. If there are already other operations, then don't add $clearAll.
 * If $clearAll already in an Identify object, don't allow other operations to be added.
 * @private
 */ $aa416a6ee3239dd2$var$Identify.prototype.clearAll = function() {
    if (Object.keys(this.userPropertiesOperations).length > 0) {
        if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, $aa416a6ee3239dd2$var$AMP_OP_CLEAR_ALL)) $aa416a6ee3239dd2$var$utils.log.error("Need to send $clearAll on its own Identify object without any other operations, skipping $clearAll");
        return this;
    }
    this.userPropertiesOperations[$aa416a6ee3239dd2$var$AMP_OP_CLEAR_ALL] = "-";
    return this;
};
/**
 * Prepend a value or values to a user property.
 * Prepend means inserting the value or values at the front of a list.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are prepended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values prepended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to prepend.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().prepend('ab-tests', 'new-user-tests');
 * identify.prepend('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */ $aa416a6ee3239dd2$var$Identify.prototype.prepend = function(property, value) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_PREPEND, property, value);
    return this;
};
/**
 * Sets the value of a given user property. If a value already exists, it will be overwriten with the new value.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().set('user_type', 'beta');
 * identify.set('name', {'first': 'John', 'last': 'Doe'}); // dict is flattened and becomes name.first: John, name.last: Doe
 * amplitude.identify(identify); // send the Identify call
 */ $aa416a6ee3239dd2$var$Identify.prototype.set = function(property, value) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_SET, property, value);
    return this;
};
/**
 * Sets the value of a given user property only once. Subsequent setOnce operations on that user property will be ignored;
 * however, that user property can still be modified through any of the other operations.
 * Useful for capturing properties such as 'initial_signup_date', 'initial_referrer', etc.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set once.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().setOnce('sign_up_date', '2016-04-01');
 * amplitude.identify(identify); // send the Identify call
 */ $aa416a6ee3239dd2$var$Identify.prototype.setOnce = function(property, value) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_SET_ONCE, property, value);
    return this;
};
/**
 * Unset and remove a user property. This user property will no longer show up in a user's profile.
 * @public
 * @param {string} property - The user property key.
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().unset('user_type').unset('age');
 * amplitude.identify(identify); // send the Identify call
 */ $aa416a6ee3239dd2$var$Identify.prototype.unset = function(property) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_UNSET, property, "-");
    return this;
};
/**
 * Preinsert a value or values to a user property, if it does not exist in the user property already.
 * Preinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */ $aa416a6ee3239dd2$var$Identify.prototype.preInsert = function(property, value) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_PREINSERT, property, value);
    return this;
};
/**
 * Postinsert a value or values to a user property, if it does not exist in the user property already.
 * Postinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */ $aa416a6ee3239dd2$var$Identify.prototype.postInsert = function(property, value) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_POSTINSERT, property, value);
    return this;
};
/**
 * Remove a value or values to a user property, if it does exist in the user property.
 * If the item does not exist in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to remove.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */ $aa416a6ee3239dd2$var$Identify.prototype.remove = function(property, value) {
    this._addOperation($aa416a6ee3239dd2$var$AMP_OP_REMOVE, property, value);
    return this;
};
/**
 * Helper function that adds operation to the Identify's object
 * Handle's filtering of duplicate user property keys, and filtering for clearAll.
 * @private
 */ $aa416a6ee3239dd2$var$Identify.prototype._addOperation = function(operation, property, value) {
    // check that the identify doesn't already contain a clearAll
    if (Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, $aa416a6ee3239dd2$var$AMP_OP_CLEAR_ALL)) {
        $aa416a6ee3239dd2$var$utils.log.error("This identify already contains a $clearAll operation, skipping operation " + operation);
        return;
    }
    // check that property wasn't already used in this Identify
    if (this.properties.indexOf(property) !== -1) {
        $aa416a6ee3239dd2$var$utils.log.error('User property "' + property + '" already used in this identify, skipping operation ' + operation);
        return;
    }
    if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, operation)) this.userPropertiesOperations[operation] = {};
    this.userPropertiesOperations[operation][property] = value;
    this.properties.push(property);
};
/*
 * Simple AJAX request object
 */ var $aa416a6ee3239dd2$var$Request = function Request(url, data, headers) {
    this.url = url;
    this.data = data || {};
    this.headers = headers;
};
var $aa416a6ee3239dd2$var$CORS_HEADER = "Cross-Origin-Resource-Policy";
function $aa416a6ee3239dd2$var$setHeaders(xhr, headers) {
    for(var header in headers){
        if (header === $aa416a6ee3239dd2$var$CORS_HEADER && !headers[header]) continue;
        xhr.setRequestHeader(header, headers[header]);
    }
}
$aa416a6ee3239dd2$var$Request.prototype.send = function(callback) {
    var isIE = $aa416a6ee3239dd2$var$GlobalScope.XDomainRequest ? true : false;
    if (isIE) {
        var xdr = new $aa416a6ee3239dd2$var$GlobalScope.XDomainRequest();
        xdr.open("POST", this.url, true);
        xdr.onload = function() {
            callback(200, xdr.responseText);
        };
        xdr.onerror = function() {
            // status code not available from xdr, try string matching on responseText
            if (xdr.responseText === "Request Entity Too Large") callback(413, xdr.responseText);
            else callback(500, xdr.responseText);
        };
        xdr.ontimeout = function() {};
        xdr.onprogress = function() {};
        xdr.send((0, $dd727a8531c7066c$export$2e2bcd8739ae039).stringify(this.data));
    } else if (typeof XMLHttpRequest !== "undefined") {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", this.url, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) callback(xhr.status, xhr.responseText);
        };
        $aa416a6ee3239dd2$var$setHeaders(xhr, this.headers);
        xhr.send((0, $dd727a8531c7066c$export$2e2bcd8739ae039).stringify(this.data));
    } else {
        var responseStatus = undefined;
        fetch(this.url, {
            method: "POST",
            headers: this.headers,
            body: (0, $dd727a8531c7066c$export$2e2bcd8739ae039).stringify(this.data)
        }).then(function(response) {
            responseStatus = response.status;
            return response.text();
        }).then(function(responseText) {
            callback(responseStatus, responseText);
        });
    }
//log('sent request to ' + this.url + ' with data ' + decodeURIComponent(queryString(this.data)));
};
/**
 * Revenue API - instance constructor. Wrapper for logging Revenue data. Revenue objects get passed to amplitude.logRevenueV2 to send to Amplitude servers.
 * Each method updates a revenue property in the Revenue object, and returns the same Revenue object,
 * allowing you to chain multiple method calls together.
 *
 * Note: price is a required field to log revenue events.
 * If quantity is not specified then defaults to 1.
 * @constructor Revenue
 * @public
 * @example var revenue = new amplitude.Revenue();
 */ var $aa416a6ee3239dd2$var$Revenue = function Revenue() {
    // required fields
    this._price = null;
    // optional fields
    this._productId = null;
    this._quantity = 1;
    this._revenueType = null;
    this._properties = null;
};
/**
 * Set a value for the product identifer.
 * @public
 * @param {string} productId - The value for the product identifier. Empty and invalid strings are ignored.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */ $aa416a6ee3239dd2$var$Revenue.prototype.setProductId = function setProductId(productId) {
    if ($aa416a6ee3239dd2$var$type(productId) !== "string") $aa416a6ee3239dd2$var$utils.log.error("Unsupported type for productId: " + $aa416a6ee3239dd2$var$type(productId) + ", expecting string");
    else if ($aa416a6ee3239dd2$var$utils.isEmptyString(productId)) $aa416a6ee3239dd2$var$utils.log.error("Invalid empty productId");
    else this._productId = productId;
    return this;
};
/**
 * Set a value for the quantity. Note revenue amount is calculated as price * quantity.
 * @public
 * @param {number} quantity - Integer value for the quantity. If not set, quantity defaults to 1.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setQuantity(5);
 * amplitude.logRevenueV2(revenue);
 */ $aa416a6ee3239dd2$var$Revenue.prototype.setQuantity = function setQuantity(quantity) {
    if ($aa416a6ee3239dd2$var$type(quantity) !== "number") $aa416a6ee3239dd2$var$utils.log.error("Unsupported type for quantity: " + $aa416a6ee3239dd2$var$type(quantity) + ", expecting number");
    else this._quantity = parseInt(quantity);
    return this;
};
/**
 * Set a value for the price. This field is required for all revenue being logged.
 *
 * Note: revenue amount is calculated as price * quantity.
 * @public
 * @param {number} price - Double value for the quantity.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */ $aa416a6ee3239dd2$var$Revenue.prototype.setPrice = function setPrice(price) {
    if ($aa416a6ee3239dd2$var$type(price) !== "number") $aa416a6ee3239dd2$var$utils.log.error("Unsupported type for price: " + $aa416a6ee3239dd2$var$type(price) + ", expecting number");
    else this._price = price;
    return this;
};
/**
 * Set a value for the revenueType (for example purchase, cost, tax, refund, etc).
 * @public
 * @param {string} revenueType - RevenueType to designate.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setRevenueType('purchase');
 * amplitude.logRevenueV2(revenue);
 */ $aa416a6ee3239dd2$var$Revenue.prototype.setRevenueType = function setRevenueType(revenueType) {
    if ($aa416a6ee3239dd2$var$type(revenueType) !== "string") $aa416a6ee3239dd2$var$utils.log.error("Unsupported type for revenueType: " + $aa416a6ee3239dd2$var$type(revenueType) + ", expecting string");
    else this._revenueType = revenueType;
    return this;
};
/**
 * Set event properties for the revenue event.
 * @public
 * @param {object} eventProperties - Revenue event properties to set.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var event_properties = {'city': 'San Francisco'};
 * var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setEventProperties(event_properties);
 * amplitude.logRevenueV2(revenue);
 */ $aa416a6ee3239dd2$var$Revenue.prototype.setEventProperties = function setEventProperties(eventProperties) {
    if ($aa416a6ee3239dd2$var$type(eventProperties) !== "object") $aa416a6ee3239dd2$var$utils.log.error("Unsupported type for eventProperties: " + $aa416a6ee3239dd2$var$type(eventProperties) + ", expecting object");
    else this._properties = $aa416a6ee3239dd2$var$utils.validateProperties(eventProperties);
    return this;
};
/**
 * @private
 */ $aa416a6ee3239dd2$var$Revenue.prototype._isValidRevenue = function _isValidRevenue() {
    if ($aa416a6ee3239dd2$var$type(this._price) !== "number") {
        $aa416a6ee3239dd2$var$utils.log.error("Invalid revenue, need to set price field");
        return false;
    }
    return true;
};
/**
 * @private
 */ $aa416a6ee3239dd2$var$Revenue.prototype._toJSONObject = function _toJSONObject() {
    var obj = $aa416a6ee3239dd2$var$type(this._properties) === "object" ? this._properties : {};
    if (this._productId !== null) obj[$aa416a6ee3239dd2$var$Constants.REVENUE_PRODUCT_ID] = this._productId;
    if (this._quantity !== null) obj[$aa416a6ee3239dd2$var$Constants.REVENUE_QUANTITY] = this._quantity;
    if (this._price !== null) obj[$aa416a6ee3239dd2$var$Constants.REVENUE_PRICE] = this._price;
    if (this._revenueType !== null) obj[$aa416a6ee3239dd2$var$Constants.REVENUE_REVENUE_TYPE] = this._revenueType;
    return obj;
};
/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */ var $aa416a6ee3239dd2$var$uuid = function uuid(a) {
    return a // if the placeholder was passed, return
     ? // a random number from 0 to 15
    (a ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    a / 4).toString(16) // in hexadecimal
     : // or otherwise a concatenated string:
    "10000000-1000-4000-8000-100000000000".replace(// replacing
    /[018]/g, // zeroes, ones, and eights with
    uuid // random hex digits
    );
};
var $aa416a6ee3239dd2$var$getLanguage = function getLanguage() {
    return typeof navigator !== "undefined" && (navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage) || "";
};
var $aa416a6ee3239dd2$var$language = {
    getLanguage: $aa416a6ee3239dd2$var$getLanguage
};
/**
 * AmplitudeServerZone is for Data Residency and handling server zone related properties.
 * The server zones now are US and EU.
 *
 * For usage like sending data to Amplitude's EU servers, you need to configure the serverZone during nitializing.
 */ var $aa416a6ee3239dd2$var$AmplitudeServerZone = {
    US: "US",
    EU: "EU"
};
var $aa416a6ee3239dd2$var$getEventLogApi = function getEventLogApi(serverZone) {
    var eventLogUrl = $aa416a6ee3239dd2$var$Constants.EVENT_LOG_URL;
    switch(serverZone){
        case $aa416a6ee3239dd2$var$AmplitudeServerZone.EU:
            eventLogUrl = $aa416a6ee3239dd2$var$Constants.EVENT_LOG_EU_URL;
            break;
        case $aa416a6ee3239dd2$var$AmplitudeServerZone.US:
            eventLogUrl = $aa416a6ee3239dd2$var$Constants.EVENT_LOG_URL;
            break;
    }
    return eventLogUrl;
};
var $aa416a6ee3239dd2$var$getDynamicConfigApi = function getDynamicConfigApi(serverZone) {
    var dynamicConfigUrl = $aa416a6ee3239dd2$var$Constants.DYNAMIC_CONFIG_URL;
    switch(serverZone){
        case $aa416a6ee3239dd2$var$AmplitudeServerZone.EU:
            dynamicConfigUrl = $aa416a6ee3239dd2$var$Constants.DYNAMIC_CONFIG_EU_URL;
            break;
        case $aa416a6ee3239dd2$var$AmplitudeServerZone.US:
            dynamicConfigUrl = $aa416a6ee3239dd2$var$Constants.DYNAMIC_CONFIG_URL;
            break;
    }
    return dynamicConfigUrl;
};
var $aa416a6ee3239dd2$var$version = "8.21.9";
/**
 * Options used when initializing Amplitude
 * @typedef {Object} Options
 * @property {string} [apiEndpoint=`api.amplitude.com`] - Endpoint to send amplitude event requests to.
 * @property {boolean} [batchEvents=`false`] -  If `true`, then events are batched together and uploaded only when the number of unsent events is greater than or equal to eventUploadThreshold or after eventUploadPeriodMillis milliseconds have passed since the first unsent event was logged.
 * @property {number} [cookieExpiration=`365`] - The number of days after which the Amplitude cookie will expire. 12 months is for GDPR compliance.
 * @property {string} [cookieName=`amplitude_id`] - *DEPRECATED*
 * @property {string} [sameSiteCookie='None'] -  Sets the SameSite flag on the amplitude cookie. Decides cookie privacy policy.
 * @property {boolean} [cookieForceUpgrade=`false`] - Forces pre-v6.0.0 instances to adopt post-v6.0.0 compat cookie formats.
 * @property {boolean} [deferInitialization=`null`] -  If `true`, disables the core functionality of the sdk, including saving a cookie and all logging, until explicitly enabled. To enable tracking, please call `amplitude.getInstance().enableTracking()` *Note: This will not affect users who already have an amplitude cookie. The decision to track events is determined by whether or not a user has an amplitude analytics cookie. If the `cookieExpiration</code> is manually defined to be a short lifespan, you may need to run `amplitude.getInstance().enableTracking()` upon the cookie expiring or upon logging in.*
 * @property {boolean} [disableCookies=`false`] -  Disable Ampllitude cookies altogether.
 * @property {string} [deviceId=A randomly generated UUID.] -  The custom Device ID to set. *Note: This is not recommended unless you know what you are doing (e.g. you have your own system for tracking user devices).*
 * @property {boolean} [deviceIdFromUrlParam=`false`] -  If `true`, then the SDK will parse Device ID values from the URL parameter amp_device_id if available. Device IDs defined in the configuration options during init will take priority over Device IDs from URL parameters.
 * @property {string} [domain=The top domain of the current page's URL. ('https://amplitude.com')] -  Set a custom domain for the Amplitude cookie. To include subdomains, add a preceding period, eg: `.amplitude.com`.
 * @property {number} [eventUploadPeriodMillis=`30000` (30 sec)] -  Amount of time in milliseconds that the SDK waits before uploading events if batchEvents is true.
 * @property {number} [eventUploadThreshold=`30`] -  Minimum number of events to batch together per request if batchEvents is true.
 * @property {boolean} [forceHttps=`true`] -  If `true`, the events will always be uploaded to HTTPS endpoint. Otherwise, it will use the embedding site's protocol.
 * @property {boolean} [includeFbclid=`false`] -  If `true`, captures the fbclid URL parameter as well as the user's initial_fbclid via a setOnce operation.
 * @property {boolean} [includeGclid=`false`] -  If `true`, captures the gclid URL parameter as well as the user's initial_gclid via a setOnce operation.
 * @property {boolean} [includeReferrer=`false`] -  If `true`, captures the referrer and referring_domain for each session, as well as the user's initial_referrer and initial_referring_domain via a setOnce operation.
 * @property {boolean} [includeUtm=`false`] -  If `true`, finds UTM parameters in the query string or the _utmz cookie, parses, and includes them as user properties on all events uploaded. This also captures initial UTM parameters for each session via a setOnce operation.
 * @property {Object} [ingestionMetadata] Ingestion metadata
 * @property {string} [ingestionMetadata.sourceName] source name in ingestion metadata, e.g. "ampli"
 * @property {string} [ingestionMetadata.sourceVersion] source version in ingestion metadata, e.g. "1.0.0"
 * @property {string} [language=The language determined by the browser] -  Custom language to set.
 * @property {Object} [library=`{ name: 'amplitude-js', version: packageJsonVersion }`] -  Values for the library version
 * @property {string} [logLevel=`WARN`] -  Level of logs to be printed in the developer console. Valid values are 'DISABLE', 'ERROR', 'WARN', 'INFO'. To learn more about the different options, see below.
 * @property {boolean} [logAttributionCapturedEvent=`false`] - If `true`, the SDK will log an Amplitude event anytime new attribution values are captured from the user. **Note: These events count towards your event volume.** Event name being logged: [Amplitude] Attribution Captured. Event Properties that can be logged: `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, `utm_content`, `referrer`, `referring_domain`, `gclid`, `fbclid`. For UTM properties to be logged, `includeUtm` must be set to `true`. For the `referrer` and `referring_domain` properties to be logged, `includeReferrer` must be set to `true`. For the `gclid` property to be logged, `includeGclid` must be set to `true`. For the `fbclid` property to be logged, `includeFbclid` must be set to `true`.
 * @property {boolean} [optOut=`false`] -  Whether or not to disable tracking for the current user.
 * @property {function} [onError=`() => {}`] - Function to call on error.
 * @property {function} [onExitPage=`() => {}`] - Function called when the user exits the browser. Useful logging on page exit.
 * @property {Object} [plan] Tracking plan properties
 * @property {string} [plan.branch] The tracking plan branch name e.g. "main"
 * @property {string} [plan.source] The tracking plan source e.g. "web"
 * @property {string} [plan.version] The tracking plan version e.g. "1", "15"
 * @property {string} [plan.versionId] The tracking plan version Id e.g. "9ec23ba0-275f-468f-80d1-66b88bff9529"
 * @property {string} [platform=`Web`] -  Platform device is running on. Defaults to `Web` (browser, including mobile browsers).
 * @property {number} [savedMaxCount=`1000`] -  Maximum number of events to save in localStorage. If more events are logged while offline, then old events are removed.
 * @property {boolean} [saveEvents=`true`] -  If `true`, saves events to localStorage and removes them upon successful upload. *Note: Without saving events, events may be lost if the user navigates to another page before the events are uploaded.*
 * @property {boolean} [saveParamsReferrerOncePerSession=`true`] -  If `true`, then includeGclid, includeFbclid, includeReferrer, and includeUtm will only track their respective properties once per session. New values that come in during the middle of the user's session will be ignored. Set to false to always capture new values.
 * @property {boolean} [secureCookie=`false`] -  If `true`, the amplitude cookie will be set with the Secure flag.
 * @property {number} [sessionTimeout=`30*60*1000` (30 min)] -  The time between logged events before a new session starts in milliseconds.
 * @property {string[]} [storage=`''`] - Sets storage strategy.  Options are 'cookies', 'localStorage', 'sessionStorage', or `none`. Will override `disableCookies` option
 * @property {Object} [trackingOptions=`{ city: true, country: true, carrier: true, device_manufacturer: true, device_model: true, dma: true, ip_address: true, language: true, os_name: true, os_version: true, platform: true, region: true, version_name: true}`] - Type of data associated with a user.
 * @property {string} [transport=`http`] - Network transport mechanism used to send events. Options are 'http' and 'beacon'.
 * @property {boolean} [unsetParamsReferrerOnNewSession=`false`] -  If `false`, the existing `referrer` and `utm_parameter` values will be carried through each new session. If set to `true`, the `referrer` and `utm_parameter` user properties, which include `referrer`, `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, and `utm_content`, will be set to `null` upon instantiating a new session. Note: This only works if `includeReferrer` or `includeUtm` is set to `true`.
 * @property {string} [unsentKey=`amplitude_unsent`] - localStorage key that stores unsent events.
 * @property {string} [unsentIdentifyKey=`amplitude_unsent_identify`] - localStorage key that stores unsent identifies.
 * @property {number} [uploadBatchSize=`100`] -  The maximum number of events to send to the server per request.
 * @property {Object} [headers=`{ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }`] - Headers attached to an event(s) upload network request. Custom header properties are merged with this object.
 * @property {string} [serverZone] - For server zone related configuration, used for server api endpoint and dynamic configuration.
 * @property {boolean} [useDynamicConfig] - Enable dynamic configuration to find best server url for user.
 * @property {boolean} [serverZoneBasedApi] - To update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @property {number} [sessionId=`null`] - The custom Session ID for the current session. *Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * @property {string} [partnerId=`null`] - The partner id value
 */ var $aa416a6ee3239dd2$var$DEFAULT_OPTIONS = {
    apiEndpoint: $aa416a6ee3239dd2$var$Constants.EVENT_LOG_URL,
    batchEvents: false,
    cookieExpiration: 365,
    // 12 months is for GDPR compliance
    cookieName: "amplitude_id",
    // this is a deprecated option
    sameSiteCookie: "Lax",
    // cookie privacy policy
    cookieForceUpgrade: false,
    deferInitialization: false,
    disableCookies: false,
    // this is a deprecated option
    deviceIdFromUrlParam: false,
    domain: "",
    eventUploadPeriodMillis: 30000,
    // 30s
    eventUploadThreshold: 30,
    forceHttps: true,
    includeFbclid: false,
    includeGclid: false,
    includeReferrer: false,
    includeUtm: false,
    ingestionMetadata: {
        sourceName: "",
        sourceVersion: ""
    },
    language: $aa416a6ee3239dd2$var$language.getLanguage(),
    library: {
        name: "amplitude-js",
        version: $aa416a6ee3239dd2$var$version
    },
    logLevel: "WARN",
    logAttributionCapturedEvent: false,
    optOut: false,
    onError: function onError() {},
    onExitPage: function onExitPage() {},
    onNewSessionStart: function onNewSessionStart() {},
    plan: {
        branch: "",
        source: "",
        version: "",
        versionId: ""
    },
    platform: "Web",
    savedMaxCount: 1000,
    saveEvents: true,
    saveParamsReferrerOncePerSession: true,
    secureCookie: false,
    sessionTimeout: 1800000,
    storage: $aa416a6ee3239dd2$var$Constants.STORAGE_DEFAULT,
    trackingOptions: {
        city: true,
        country: true,
        carrier: true,
        device_manufacturer: true,
        device_model: true,
        dma: true,
        ip_address: true,
        language: true,
        os_name: true,
        os_version: true,
        platform: true,
        region: true,
        version_name: true
    },
    transport: $aa416a6ee3239dd2$var$Constants.TRANSPORT_HTTP,
    unsetParamsReferrerOnNewSession: false,
    unsentKey: "amplitude_unsent",
    unsentIdentifyKey: "amplitude_unsent_identify",
    uploadBatchSize: 100,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Cross-Origin-Resource-Policy": "cross-origin"
    },
    serverZone: $aa416a6ee3239dd2$var$AmplitudeServerZone.US,
    useDynamicConfig: false,
    serverZoneBasedApi: false,
    sessionId: null,
    partnerId: ""
};
/**
 * Dynamic Configuration
 * Find the best server url automatically based on app users' geo location.
 */ var $aa416a6ee3239dd2$var$ConfigManager = /*#__PURE__*/ function() {
    function ConfigManager() {
        $aa416a6ee3239dd2$var$_classCallCheck(this, ConfigManager);
        if (!ConfigManager.instance) {
            this.ingestionEndpoint = $aa416a6ee3239dd2$var$Constants.EVENT_LOG_URL;
            ConfigManager.instance = this;
        }
        return ConfigManager.instance;
    }
    $aa416a6ee3239dd2$var$_createClass(ConfigManager, [
        {
            key: "refresh",
            value: function refresh(serverZone, forceHttps, callback) {
                var protocol = "https";
                if (!forceHttps && "https:" !== $aa416a6ee3239dd2$var$GlobalScope.location.protocol) protocol = "http";
                var dynamicConfigUrl = protocol + "://" + $aa416a6ee3239dd2$var$getDynamicConfigApi(serverZone);
                var self1 = this;
                var isIE = $aa416a6ee3239dd2$var$GlobalScope.XDomainRequest ? true : false;
                if (isIE) {
                    var xdr = new $aa416a6ee3239dd2$var$GlobalScope.XDomainRequest();
                    xdr.open("GET", dynamicConfigUrl, true);
                    xdr.onload = function() {
                        var response = JSON.parse(xdr.responseText);
                        self1.ingestionEndpoint = response["ingestionEndpoint"];
                        if (callback) callback();
                    };
                    xdr.onerror = function() {};
                    xdr.ontimeout = function() {};
                    xdr.onprogress = function() {};
                    xdr.send();
                } else {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", dynamicConfigUrl, true);
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4 && xhr.status === 200) {
                            var response = JSON.parse(xhr.responseText);
                            self1.ingestionEndpoint = response["ingestionEndpoint"];
                            if (callback) callback();
                        }
                    };
                    xhr.send();
                }
            }
        }
    ]);
    return ConfigManager;
}();
var $aa416a6ee3239dd2$var$instance$1 = new $aa416a6ee3239dd2$var$ConfigManager();
/**
 * AmplitudeClient SDK API - instance constructor.
 * The Amplitude class handles creation of client instances, all you need to do is call amplitude.getInstance()
 * @constructor AmplitudeClient
 * @public
 * @example var amplitudeClient = new AmplitudeClient();
 */ var $aa416a6ee3239dd2$var$AmplitudeClient = function AmplitudeClient(instanceName) {
    if (!(0, $8b62d45bd189d563$export$d8dbb4fdb3ae0564)() && !$aa416a6ee3239dd2$var$utils.isWebWorkerEnvironment()) $aa416a6ee3239dd2$var$utils.log.warn("amplitude-js will not work in a non-browser environment. If you are planning to add Amplitude to a node environment, please use @amplitude/node");
    this._instanceName = $aa416a6ee3239dd2$var$utils.isEmptyString(instanceName) ? $aa416a6ee3239dd2$var$Constants.DEFAULT_INSTANCE : instanceName.toLowerCase();
    this._unsentEvents = [];
    this._unsentIdentifys = [];
    this.options = $aa416a6ee3239dd2$var$_objectSpread2($aa416a6ee3239dd2$var$_objectSpread2({}, $aa416a6ee3239dd2$var$DEFAULT_OPTIONS), {}, {
        headers: $aa416a6ee3239dd2$var$_objectSpread2({}, $aa416a6ee3239dd2$var$DEFAULT_OPTIONS.headers),
        ingestionMetadata: $aa416a6ee3239dd2$var$_objectSpread2({}, $aa416a6ee3239dd2$var$DEFAULT_OPTIONS.ingestionMetadata),
        library: $aa416a6ee3239dd2$var$_objectSpread2({}, $aa416a6ee3239dd2$var$DEFAULT_OPTIONS.library),
        plan: $aa416a6ee3239dd2$var$_objectSpread2({}, $aa416a6ee3239dd2$var$DEFAULT_OPTIONS.plan),
        trackingOptions: $aa416a6ee3239dd2$var$_objectSpread2({}, $aa416a6ee3239dd2$var$DEFAULT_OPTIONS.trackingOptions)
    });
    this._q = []; // queue for proxied functions before script load
    this._sending = false;
    this._updateScheduled = false;
    this._onInitCallbacks = [];
    this._onNewSessionStartCallbacks = [];
    // event meta data
    this._eventId = 0;
    this._identifyId = 0;
    this._lastEventTime = null;
    this._newSession = false;
    // sequence used for by frontend for prioritizing event send retries
    this._sequenceNumber = 0;
    this._sessionId = null;
    this._isInitialized = false;
    // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
    this._connector = null;
    this._userAgent = typeof navigator !== "undefined" && navigator && navigator.userAgent || null;
    this._ua = new (0, (/*@__PURE__*/$parcel$interopDefault($axiof)))(this._userAgent).getResult();
};
$aa416a6ee3239dd2$var$AmplitudeClient.prototype.Identify = $aa416a6ee3239dd2$var$Identify;
$aa416a6ee3239dd2$var$AmplitudeClient.prototype.Revenue = $aa416a6ee3239dd2$var$Revenue;
/**
 * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
 * This is required before any other methods can be called.
 * @public
 * @param {string} apiKey - The API key for your app.
 * @param {string} opt_userId - (optional) An identifier for this user.
 * @param {object} opt_config - (optional) Configuration options.
 * See [options.js](https://amplitude.github.io/Amplitude-JavaScript/Options) for a list of options and default values.
 * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
 * @example amplitudeClient.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
    var _this = this;
    if ($aa416a6ee3239dd2$var$type(apiKey) !== "string" || $aa416a6ee3239dd2$var$utils.isEmptyString(apiKey)) {
        $aa416a6ee3239dd2$var$utils.log.error("Invalid apiKey. Please re-initialize with a valid apiKey");
        return;
    }
    try {
        // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
        this._connector = (0, $14ffd7b4a562b7f1$export$5af12d25e001b77c).getInstance(this._instanceName);
        $aa416a6ee3239dd2$var$_parseConfig(this.options, opt_config);
        if (((0, $8b62d45bd189d563$export$d8dbb4fdb3ae0564)() || $aa416a6ee3239dd2$var$utils.isWebWorkerEnvironment()) && $aa416a6ee3239dd2$var$GlobalScope.Prototype !== undefined && Array.prototype.toJSON) {
            (0, $8b62d45bd189d563$export$e518fb76ed3fba53)();
            $aa416a6ee3239dd2$var$utils.log.warn("Prototype.js injected Array.prototype.toJSON. Deleting Array.prototype.toJSON to prevent double-stringify");
        }
        if (this.options.cookieName !== $aa416a6ee3239dd2$var$DEFAULT_OPTIONS.cookieName) $aa416a6ee3239dd2$var$utils.log.warn("The cookieName option is deprecated. We will be ignoring it for newer cookies");
        if (this.options.serverZoneBasedApi) this.options.apiEndpoint = $aa416a6ee3239dd2$var$getEventLogApi(this.options.serverZone);
        this._refreshDynamicConfig();
        this.options.apiKey = apiKey;
        this._storageSuffix = "_" + apiKey + (this._instanceName === $aa416a6ee3239dd2$var$Constants.DEFAULT_INSTANCE ? "" : "_" + this._instanceName);
        this._storageSuffixV5 = apiKey.slice(0, 6);
        this._oldCookiename = this.options.cookieName + this._storageSuffix;
        this._unsentKey = this.options.unsentKey + this._storageSuffix;
        this._unsentIdentifyKey = this.options.unsentIdentifyKey + this._storageSuffix;
        this._cookieName = $aa416a6ee3239dd2$var$Constants.COOKIE_PREFIX + "_" + this._storageSuffixV5;
        this.cookieStorage = new $aa416a6ee3239dd2$var$cookieStorage().getStorage(this.options.disableCookies);
        this.cookieStorage.options({
            expirationDays: this.options.cookieExpiration,
            domain: this.options.domain,
            secure: this.options.secureCookie,
            sameSite: this.options.sameSiteCookie
        });
        this._metadataStorage = new $aa416a6ee3239dd2$var$MetadataStorage({
            storageKey: this._cookieName,
            disableCookies: this.options.disableCookies,
            expirationDays: this.options.cookieExpiration,
            domain: this.options.domain,
            secure: this.options.secureCookie,
            sameSite: this.options.sameSiteCookie,
            storage: this.options.storage
        });
        var hasOldCookie = !!this.cookieStorage.get(this._oldCookiename);
        var hasNewCookie = !!this._metadataStorage.load();
        this._useOldCookie = !hasNewCookie && hasOldCookie && !this.options.cookieForceUpgrade;
        var hasCookie = hasNewCookie || hasOldCookie;
        if (this.options.deferInitialization && !hasCookie) {
            this._deferInitialization(apiKey, opt_userId, opt_config, opt_callback);
            return;
        }
        this.options.domain = this.cookieStorage.options().domain;
        if ($aa416a6ee3239dd2$var$type(this.options.logLevel) === "string") $aa416a6ee3239dd2$var$utils.setLogLevel(this.options.logLevel);
        var trackingOptions = $aa416a6ee3239dd2$var$_generateApiPropertiesTrackingConfig(this);
        this._apiPropertiesTrackingOptions = Object.keys(trackingOptions).length > 0 ? {
            tracking_options: trackingOptions
        } : {};
        if (this.options.cookieForceUpgrade && hasOldCookie) {
            if (!hasNewCookie) $aa416a6ee3239dd2$var$_upgradeCookieData(this);
            this.cookieStorage.remove(this._oldCookiename);
        }
        $aa416a6ee3239dd2$var$_loadCookieData(this);
        this._pendingReadStorage = true;
        var initFromStorage = function initFromStorage(storedDeviceId) {
            if (opt_config && opt_config.deviceId && !$aa416a6ee3239dd2$var$utils.validateDeviceId(opt_config.deviceId)) {
                $aa416a6ee3239dd2$var$utils.log.error('Invalid device ID rejected. Randomly generated UUID will be used instead of "'.concat(opt_config.deviceId, '"'));
                delete opt_config.deviceId;
            }
            _this.options.deviceId = _this._getInitialDeviceId(opt_config && opt_config.deviceId, storedDeviceId);
            _this.options.userId = $aa416a6ee3239dd2$var$type(opt_userId) === "string" && !$aa416a6ee3239dd2$var$utils.isEmptyString(opt_userId) && opt_userId || $aa416a6ee3239dd2$var$type(opt_userId) === "number" && opt_userId.toString() || _this.options.userId || null;
            var now = new Date().getTime();
            var startNewSession = !_this._sessionId || !_this._lastEventTime || now - _this._lastEventTime > _this.options.sessionTimeout || _this.options.sessionId;
            if (startNewSession) {
                if (_this.options.unsetParamsReferrerOnNewSession) _this._unsetUTMParams();
                _this._newSession = true;
                _this._sessionId = _this.options.sessionId || now;
                // reset this.options.sessionId to avoid re-usage
                // use instance.getSessionId() to get session id
                _this.options.sessionId = undefined;
                // only capture UTM params and referrer if new session
                if (_this.options.saveParamsReferrerOncePerSession) _this._trackParamsAndReferrer();
            }
            if (!_this.options.saveParamsReferrerOncePerSession) _this._trackParamsAndReferrer();
            // load unsent events and identifies before any attempt to log new ones
            if (_this.options.saveEvents) {
                $aa416a6ee3239dd2$var$_validateUnsentEventQueue(_this._unsentEvents);
                $aa416a6ee3239dd2$var$_validateUnsentEventQueue(_this._unsentIdentifys);
            }
            _this._lastEventTime = now;
            $aa416a6ee3239dd2$var$_saveCookieData(_this);
            _this._pendingReadStorage = false;
            _this._sendEventsIfReady(); // try sending unsent events
            for(var i = 0; i < _this._onInitCallbacks.length; i++)_this._onInitCallbacks[i](_this);
            _this._onInitCallbacks = [];
            _this._isInitialized = true;
            if (startNewSession) _this._runNewSessionStartCallbacks();
        };
        if (this.options.saveEvents) {
            this._unsentEvents = this._loadSavedUnsentEvents(this.options.unsentKey).map(function(event1) {
                return {
                    event: event1
                };
            }).concat(this._unsentEvents);
            this._unsentIdentifys = this._loadSavedUnsentEvents(this.options.unsentIdentifyKey).map(function(event1) {
                return {
                    event: event1
                };
            }).concat(this._unsentIdentifys);
        }
        if (opt_config && opt_config.onNewSessionStart) this.onNewSessionStart(this.options.onNewSessionStart);
        initFromStorage();
        this.runQueuedFunctions();
        if ($aa416a6ee3239dd2$var$type(opt_callback) === "function") opt_callback(this);
        var onExitPage = this.options.onExitPage;
        if ($aa416a6ee3239dd2$var$type(onExitPage) === "function" && $aa416a6ee3239dd2$var$GlobalScope.addEventListener) {
            if (!this.pageHandlersAdded) {
                this.pageHandlersAdded = true;
                var handleVisibilityChange = function handleVisibilityChange() {
                    var prevTransport = _this.options.transport;
                    _this.setTransport($aa416a6ee3239dd2$var$Constants.TRANSPORT_BEACON);
                    onExitPage();
                    _this.setTransport(prevTransport);
                };
                // Monitoring just page exits because that is the most requested feature for now
                // "If you're specifically trying to detect page unload events, the pagehide event is the best option."
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event
                $aa416a6ee3239dd2$var$GlobalScope.addEventListener("pagehide", function() {
                    handleVisibilityChange();
                }, false);
            }
        }
        // Sets an event receiver to receive and forward exposure events from the experiment SDK.
        this._connector.eventBridge.setEventReceiver(function(event1) {
            _this._logEvent(event1.eventType, event1.eventProperties, event1.userProperties);
        });
        // Set the user ID and device ID in the core identity store to enable fetching variants.
        var editor = this._connector.identityStore.editIdentity();
        if (this.options.deviceId) editor.setDeviceId(this.options.deviceId);
        if (this.options.userId) editor.setUserId(this.options.userId);
        editor.commit();
    } catch (err) {
        $aa416a6ee3239dd2$var$utils.log.error(err);
        if (opt_config && $aa416a6ee3239dd2$var$type(opt_config.onError) === "function") opt_config.onError(err);
    }
};
$aa416a6ee3239dd2$var$AmplitudeClient.prototype._runNewSessionStartCallbacks = function() {
    for(var i = 0; i < this._onNewSessionStartCallbacks.length; i++)this._onNewSessionStartCallbacks[i](this);
};
$aa416a6ee3239dd2$var$AmplitudeClient.prototype.deleteLowerLevelDomainCookies = function() {
    var host = $aa416a6ee3239dd2$var$utils.getHost();
    var cookieHost = this.options.domain && this.options.domain[0] === "." ? this.options.domain.slice(1) : this.options.domain;
    if (!cookieHost || !$aa416a6ee3239dd2$var$utils.isWebWorkerEnvironment()) return;
    if (host !== cookieHost) {
        if (new RegExp(cookieHost + "$").test(host)) {
            var hostParts = host.split(".");
            var cookieHostParts = cookieHost.split(".");
            for(var i = hostParts.length; i > cookieHostParts.length; --i){
                var deleteDomain = hostParts.slice(hostParts.length - i).join(".");
                $aa416a6ee3239dd2$var$baseCookie.set(this._cookieName, null, {
                    domain: "." + deleteDomain
                });
            }
            $aa416a6ee3239dd2$var$baseCookie.set(this._cookieName, null, {});
        }
    }
};
$aa416a6ee3239dd2$var$AmplitudeClient.prototype._getInitialDeviceId = function(configDeviceId, storedDeviceId) {
    if (configDeviceId) return configDeviceId;
    if (this.options.deviceIdFromUrlParam) {
        var deviceIdFromUrlParam = this._getDeviceIdFromUrlParam(this._getUrlParams());
        if (deviceIdFromUrlParam) return deviceIdFromUrlParam;
    }
    if (this.options.deviceId) return this.options.deviceId;
    if (storedDeviceId) return storedDeviceId;
    return $aa416a6ee3239dd2$var$base64Id();
};
// validate properties for unsent events
var $aa416a6ee3239dd2$var$_validateUnsentEventQueue = function _validateUnsentEventQueue(queue) {
    for(var i = 0; i < queue.length; i++){
        var userProperties = queue[i].event.user_properties;
        var eventProperties = queue[i].event.event_properties;
        var groups = queue[i].event.groups;
        queue[i].event.user_properties = $aa416a6ee3239dd2$var$utils.validateProperties(userProperties);
        queue[i].event.event_properties = $aa416a6ee3239dd2$var$utils.validateProperties(eventProperties);
        queue[i].event.groups = $aa416a6ee3239dd2$var$utils.validateGroups(groups);
    }
};
/**
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._trackParamsAndReferrer = function _trackParamsAndReferrer() {
    var utmProperties;
    var referrerProperties;
    var gclidProperties;
    var fbclidProperties;
    if (this.options.includeUtm) utmProperties = this._initUtmData();
    if (this.options.includeReferrer) referrerProperties = this._saveReferrer(this._getReferrer());
    if (this.options.includeGclid) gclidProperties = this._saveGclid(this._getUrlParams());
    if (this.options.includeFbclid) fbclidProperties = this._saveFbclid(this._getUrlParams());
    if (this.options.logAttributionCapturedEvent) {
        var attributionProperties = $aa416a6ee3239dd2$var$_objectSpread2($aa416a6ee3239dd2$var$_objectSpread2($aa416a6ee3239dd2$var$_objectSpread2($aa416a6ee3239dd2$var$_objectSpread2({}, utmProperties), referrerProperties), gclidProperties), fbclidProperties);
        if (Object.keys(attributionProperties).length > 0) this.logEvent($aa416a6ee3239dd2$var$Constants.ATTRIBUTION_EVENT, attributionProperties);
    }
};
/**
 * Parse and validate user specified config values and overwrite existing option value
 * DEFAULT_OPTIONS provides list of all config keys that are modifiable, as well as expected types for values
 * @private
 */ var $aa416a6ee3239dd2$var$_parseConfig = function _parseConfig(options, config) {
    if ($aa416a6ee3239dd2$var$type(config) !== "object") return;
    // Add exception in headers
    var freeFormObjectKeys = new Set([
        "headers"
    ]);
    var zeroAllowedKeys = new Set([
        "eventUploadPeriodMillis"
    ]);
    // validates config value is defined, is the correct type, and some additional value sanity checks
    var parseValidateAndLoad = function parseValidateAndLoad(key) {
        if (!Object.prototype.hasOwnProperty.call(options, key)) return; // skip bogus config values
        var inputValue = config[key];
        var expectedType = $aa416a6ee3239dd2$var$type(options[key]);
        if (key === "transport" && !$aa416a6ee3239dd2$var$utils.validateTransport(inputValue)) return;
        else if (key === "sessionId" && inputValue !== null) {
            options[key] = $aa416a6ee3239dd2$var$utils.validateSessionId(inputValue) ? inputValue : null;
            return;
        } else if (!$aa416a6ee3239dd2$var$utils.validateInput(inputValue, key + " option", expectedType)) return;
        if (expectedType === "boolean") options[key] = !!inputValue;
        else if (expectedType === "string" && !$aa416a6ee3239dd2$var$utils.isEmptyString(inputValue) || expectedType === "number" && (inputValue > 0 || inputValue === 0 && zeroAllowedKeys.has(key)) || expectedType === "function") options[key] = inputValue;
        else if (expectedType === "object") _parseConfig(options[key], inputValue);
    };
    for(var key in config){
        if (freeFormObjectKeys.has(key)) options[key] = $aa416a6ee3239dd2$var$_objectSpread2($aa416a6ee3239dd2$var$_objectSpread2({}, options[key]), config[key]);
        else if (Object.prototype.hasOwnProperty.call(config, key)) parseValidateAndLoad(key);
    }
};
/**
 * Run functions queued up by proxy loading snippet
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.runQueuedFunctions = function() {
    var queue = this._q;
    this._q = [];
    for(var i = 0; i < queue.length; i++){
        var fn = this[queue[i][0]];
        if ($aa416a6ee3239dd2$var$type(fn) === "function") fn.apply(this, queue[i].slice(1));
    }
};
/**
 * Check that the apiKey is set before calling a function. Logs a warning message if not set.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._apiKeySet = function _apiKeySet(methodName) {
    if ($aa416a6ee3239dd2$var$utils.isEmptyString(this.options.apiKey)) {
        $aa416a6ee3239dd2$var$utils.log.error("Invalid apiKey. Please set a valid apiKey with init() before calling " + methodName);
        return false;
    }
    return true;
};
/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._loadSavedUnsentEvents = function _loadSavedUnsentEvents(unsentKey) {
    var savedUnsentEventsString = this._getFromStorage($aa416a6ee3239dd2$var$localStorage$1, unsentKey);
    var unsentEvents = this._parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey);
    this._setInStorage($aa416a6ee3239dd2$var$localStorage$1, unsentKey, JSON.stringify(unsentEvents));
    return unsentEvents;
};
/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._parseSavedUnsentEventsString = function _parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey) {
    if ($aa416a6ee3239dd2$var$utils.isEmptyString(savedUnsentEventsString)) return []; // new app, does not have any saved events
    if ($aa416a6ee3239dd2$var$type(savedUnsentEventsString) === "string") try {
        var events = JSON.parse(savedUnsentEventsString);
        if ($aa416a6ee3239dd2$var$type(events) === "array") // handle case where JSON dumping of unsent events is corrupted
        return events;
    } catch (e) {} /* eslint-disable-line no-empty */ 
    $aa416a6ee3239dd2$var$utils.log.error("Unable to load " + unsentKey + " events. Restart with a new empty queue.");
    return [];
};
/**
 * Returns true if a new session was created during initialization, otherwise false.
 * @public
 * @return {boolean} Whether a new session was created during initialization.
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.isNewSession = function isNewSession() {
    return this._newSession;
};
/**
 * Add callbacks to call after init. Useful for users who load Amplitude through a snippet.
 * @public
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.onInit = function onInit(callback) {
    if (this._isInitialized) callback(this);
    else this._onInitCallbacks.push(callback);
};
/**
 * Add callbacks to call after new session start.
 * @public
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.onNewSessionStart = function onNewSessionStart(callback) {
    this._onNewSessionStartCallbacks.push(callback);
};
/**
 * Returns the id of the current session.
 * @public
 * @return {number} Id of the current session.
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.getSessionId = function getSessionId() {
    return this._sessionId;
};
/**
 * Increments the eventId and returns it.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.nextEventId = function nextEventId() {
    this._eventId++;
    return this._eventId;
};
/**
 * Increments the identifyId and returns it.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.nextIdentifyId = function nextIdentifyId() {
    this._identifyId++;
    return this._identifyId;
};
/**
 * Increments the sequenceNumber and returns it.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.nextSequenceNumber = function nextSequenceNumber() {
    this._sequenceNumber++;
    return this._sequenceNumber;
};
/**
 * Returns the total count of unsent events and identifys
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._unsentCount = function _unsentCount() {
    return this._unsentEvents.length + this._unsentIdentifys.length;
};
/**
 * Send events if ready. Returns true if events are sent.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._sendEventsIfReady = function _sendEventsIfReady() {
    if (this._unsentCount() === 0) return false;
    // if batching disabled, send any unsent events immediately
    if (!this.options.batchEvents) {
        this.sendEvents();
        return true;
    }
    // if batching enabled, check if min threshold met for batch size
    if (this._unsentCount() >= this.options.eventUploadThreshold) {
        this.sendEvents();
        return true;
    }
    // if beacon transport is activated, send events immediately
    // because there is no way to retry them later
    if (this.options.transport === $aa416a6ee3239dd2$var$Constants.TRANSPORT_BEACON) {
        this.sendEvents();
        return true;
    }
    // otherwise schedule an upload after 30s
    if (!this._updateScheduled) {
        // make sure we only schedule 1 upload
        this._updateScheduled = true;
        setTimeout((function() {
            this._updateScheduled = false;
            this.sendEvents();
        }).bind(this), this.options.eventUploadPeriodMillis);
    }
    return false; // an upload was scheduled, no events were uploaded
};
/**
 * Clears any stored events and metadata. Storage is then re-created on next event sending.
 * @public
 * @return {boolean} True if metadata was cleared, false if none existed
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.clearStorage = function clearStorage() {
    return this._metadataStorage.clear();
};
/**
 * Helper function to fetch values from storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._getFromStorage = function _getFromStorage(storage, key) {
    return storage.getItem(key + this._storageSuffix);
};
/**
 * Helper function to set values in storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._setInStorage = function _setInStorage(storage, key, value) {
    storage.setItem(key + this._storageSuffix, value);
};
/**
 * Fetches deviceId, userId, event meta data from amplitude cookie
 * @private
 */ var $aa416a6ee3239dd2$var$_loadCookieData = function _loadCookieData(scope) {
    if (!scope._useOldCookie) {
        var props = scope._metadataStorage.load();
        if ($aa416a6ee3239dd2$var$type(props) === "object") $aa416a6ee3239dd2$var$_loadCookieDataProps(scope, props);
        return;
    }
    var cookieData = scope.cookieStorage.get(scope._oldCookiename);
    if ($aa416a6ee3239dd2$var$type(cookieData) === "object") {
        $aa416a6ee3239dd2$var$_loadCookieDataProps(scope, cookieData);
        return;
    }
};
var $aa416a6ee3239dd2$var$_upgradeCookieData = function _upgradeCookieData(scope) {
    var cookieData = scope.cookieStorage.get(scope._oldCookiename);
    if ($aa416a6ee3239dd2$var$type(cookieData) === "object") {
        $aa416a6ee3239dd2$var$_loadCookieDataProps(scope, cookieData);
        $aa416a6ee3239dd2$var$_saveCookieData(scope);
    }
};
var $aa416a6ee3239dd2$var$_loadCookieDataProps = function _loadCookieDataProps(scope, cookieData) {
    if (cookieData.deviceId) scope.options.deviceId = cookieData.deviceId;
    if (cookieData.userId) scope.options.userId = cookieData.userId;
    if (cookieData.optOut !== null && cookieData.optOut !== undefined) // Do not clobber config opt out value if cookieData has optOut as false
    {
        if (cookieData.optOut !== false) scope.options.optOut = cookieData.optOut;
    }
    if (cookieData.sessionId) scope._sessionId = parseInt(cookieData.sessionId, 10);
    if (cookieData.lastEventTime) scope._lastEventTime = parseInt(cookieData.lastEventTime, 10);
    if (cookieData.eventId) scope._eventId = parseInt(cookieData.eventId, 10);
    if (cookieData.identifyId) scope._identifyId = parseInt(cookieData.identifyId, 10);
    if (cookieData.sequenceNumber) scope._sequenceNumber = parseInt(cookieData.sequenceNumber, 10);
};
/**
 * Saves deviceId, userId, event meta data to amplitude cookie
 * @private
 */ var $aa416a6ee3239dd2$var$_saveCookieData = function _saveCookieData(scope) {
    var cookieData = {
        deviceId: scope.options.deviceId,
        userId: scope.options.userId,
        optOut: scope.options.optOut,
        sessionId: scope._sessionId,
        lastEventTime: scope._lastEventTime,
        eventId: scope._eventId,
        identifyId: scope._identifyId,
        sequenceNumber: scope._sequenceNumber
    };
    if (scope._useOldCookie) scope.cookieStorage.set(scope.options.cookieName + scope._storageSuffix, cookieData);
    else scope._metadataStorage.save(cookieData);
};
/**
 * Parse the utm properties out of cookies and query for adding to user properties.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._initUtmData = function _initUtmData(queryParams, cookieParams) {
    queryParams = queryParams || this._getUrlParams();
    cookieParams = cookieParams || this.cookieStorage.get("__utmz");
    var utmProperties = $aa416a6ee3239dd2$var$getUtmData(cookieParams, queryParams);
    $aa416a6ee3239dd2$var$_sendParamsReferrerUserProperties(this, utmProperties);
    return utmProperties;
};
/**
 * Unset the utm params from the Amplitude instance and update the identify.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._unsetUTMParams = function _unsetUTMParams() {
    var identify = new $aa416a6ee3239dd2$var$Identify();
    identify.unset($aa416a6ee3239dd2$var$Constants.REFERRER);
    identify.unset($aa416a6ee3239dd2$var$Constants.REFERRING_DOMAIN);
    identify.unset($aa416a6ee3239dd2$var$Constants.UTM_SOURCE);
    identify.unset($aa416a6ee3239dd2$var$Constants.UTM_MEDIUM);
    identify.unset($aa416a6ee3239dd2$var$Constants.UTM_CAMPAIGN);
    identify.unset($aa416a6ee3239dd2$var$Constants.UTM_TERM);
    identify.unset($aa416a6ee3239dd2$var$Constants.UTM_CONTENT);
    this.identify(identify);
};
/**
 * The calling function should determine when it is appropriate to send these user properties. This function
 * will no longer contain any session storage checking logic.
 * @private
 */ var $aa416a6ee3239dd2$var$_sendParamsReferrerUserProperties = function _sendParamsReferrerUserProperties(scope, userProperties) {
    if ($aa416a6ee3239dd2$var$type(userProperties) !== "object" || Object.keys(userProperties).length === 0) return;
    // setOnce the initial user properties
    var identify = new $aa416a6ee3239dd2$var$Identify();
    for(var key in userProperties)if (Object.prototype.hasOwnProperty.call(userProperties, key)) {
        identify.setOnce("initial_" + key, userProperties[key]);
        identify.set(key, userProperties[key]);
    }
    scope.identify(identify);
};
/**
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._getReferrer = function _getReferrer() {
    var urlRefer = this._getReferrerFromUrlParam(this._getUrlParams());
    if (urlRefer) return urlRefer;
    else return typeof document !== "undefined" ? document.referrer : "";
};
/**
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._getUrlParams = function _getUrlParams() {
    return $aa416a6ee3239dd2$var$GlobalScope.location.search;
};
/**
 * Try to fetch Google Gclid from url params.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._saveGclid = function _saveGclid(urlParams) {
    var gclid = $aa416a6ee3239dd2$var$utils.getQueryParam("gclid", urlParams);
    if ($aa416a6ee3239dd2$var$utils.isEmptyString(gclid)) return;
    var gclidProperties = {
        gclid: gclid
    };
    $aa416a6ee3239dd2$var$_sendParamsReferrerUserProperties(this, gclidProperties);
    return gclidProperties;
};
/**
 * Try to fetch Facebook Fbclid from url params.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._saveFbclid = function _saveFbclid(urlParams) {
    var fbclid = $aa416a6ee3239dd2$var$utils.getQueryParam("fbclid", urlParams);
    if ($aa416a6ee3239dd2$var$utils.isEmptyString(fbclid)) return;
    var fbclidProperties = {
        fbclid: fbclid
    };
    $aa416a6ee3239dd2$var$_sendParamsReferrerUserProperties(this, fbclidProperties);
    return fbclidProperties;
};
/**
 * Try to fetch Amplitude device id from url params.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._getDeviceIdFromUrlParam = function _getDeviceIdFromUrlParam(urlParams) {
    return $aa416a6ee3239dd2$var$utils.getQueryParam($aa416a6ee3239dd2$var$Constants.AMP_DEVICE_ID_PARAM, urlParams);
};
/**
 * Try to fetch referrer from url params.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._getReferrerFromUrlParam = function _getReferrerFromUrlParam(urlParams) {
    return $aa416a6ee3239dd2$var$utils.getQueryParam($aa416a6ee3239dd2$var$Constants.AMP_REFERRER_PARAM, urlParams);
};
/**
 * Parse the domain from referrer info
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._getReferringDomain = function _getReferringDomain(referrer) {
    if ($aa416a6ee3239dd2$var$utils.isEmptyString(referrer)) return null;
    var parts = referrer.split("/");
    if (parts.length >= 3) return parts[2];
    return null;
};
/**
 * Fetch the referrer information, parse the domain and send.
 * Since user properties are propagated on the server, only send once per session, don't need to send with every event
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._saveReferrer = function _saveReferrer(referrer) {
    if ($aa416a6ee3239dd2$var$utils.isEmptyString(referrer)) return;
    var referrerInfo = {
        referrer: referrer,
        referring_domain: this._getReferringDomain(referrer)
    };
    $aa416a6ee3239dd2$var$_sendParamsReferrerUserProperties(this, referrerInfo);
    return referrerInfo;
};
/**
 * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
 * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.saveEvents = function saveEvents() {
    try {
        var serializedUnsentEvents = JSON.stringify(this._unsentEvents.map(function(_ref) {
            var event1 = _ref.event;
            return event1;
        }));
        this._setInStorage($aa416a6ee3239dd2$var$localStorage$1, this.options.unsentKey, serializedUnsentEvents);
    } catch (e) {} /* eslint-disable-line no-empty */ 
    try {
        var serializedIdentifys = JSON.stringify(this._unsentIdentifys.map(function(unsentIdentify) {
            return unsentIdentify.event;
        }));
        this._setInStorage($aa416a6ee3239dd2$var$localStorage$1, this.options.unsentIdentifyKey, serializedIdentifys);
    } catch (e) {} /* eslint-disable-line no-empty */ 
};
/**
 * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
 * @public
 * @param {string} domain to set.
 * @example amplitudeClient.setDomain('.amplitude.com');
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setDomain = function setDomain(domain) {
    if (this._shouldDeferCall()) return this._q.push([
        "setDomain"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!$aa416a6ee3239dd2$var$utils.validateInput(domain, "domain", "string")) return;
    try {
        this.cookieStorage.options({
            expirationDays: this.options.cookieExpiration,
            secure: this.options.secureCookie,
            domain: domain,
            sameSite: this.options.sameSiteCookie
        });
        this.options.domain = this.cookieStorage.options().domain;
        $aa416a6ee3239dd2$var$_loadCookieData(this);
        $aa416a6ee3239dd2$var$_saveCookieData(this);
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Sets an identifier for the current user.
 * @public
 * @param {string} userId - identifier to set. Can be null.
 * @param {boolean} startNewSession - (optional) if start a new session or not
 * @example amplitudeClient.setUserId('joe@gmail.com');
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setUserId = function setUserId(userId) {
    var startNewSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!$aa416a6ee3239dd2$var$utils.validateInput(startNewSession, "startNewSession", "boolean")) return;
    if (this._shouldDeferCall()) return this._q.push([
        "setUserId"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    try {
        this.options.userId = userId !== undefined && userId !== null && "" + userId || null;
        if (startNewSession) {
            if (this.options.unsetParamsReferrerOnNewSession) this._unsetUTMParams();
            this._newSession = true;
            this._sessionId = new Date().getTime();
            this._runNewSessionStartCallbacks();
            // only capture UTM params and referrer if new session
            if (this.options.saveParamsReferrerOncePerSession) this._trackParamsAndReferrer();
        }
        $aa416a6ee3239dd2$var$_saveCookieData(this);
        // Update core identity store to propagate new user info
        // to experiment SDK and trigger a fetch if the ID has changed.
        if (this._connector) this._connector.identityStore.editIdentity().setUserId(this.options.userId).commit();
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Add user to a group or groups. You need to specify a groupType and groupName(s).
 *
 * For example you can group people by their organization.
 * In that case, groupType is "orgId" and groupName would be the actual ID(s).
 * groupName can be a string or an array of strings to indicate a user in multiple gruups.
 * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
 *
 * Note: this will also set groupType: groupName as a user property.
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
 * @public
 * @param {string} groupType - the group type (ex: orgId)
 * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
 * @example amplitudeClient.setGroup('orgId', 15); // this adds the current user to orgId 15.
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setGroup = function(groupType, groupName) {
    if (this._shouldDeferCall()) return this._q.push([
        "setGroup"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("setGroup()") || !$aa416a6ee3239dd2$var$utils.validateInput(groupType, "groupType", "string") || $aa416a6ee3239dd2$var$utils.isEmptyString(groupType)) return;
    var groups = {};
    groups[groupType] = groupName;
    var identify = new $aa416a6ee3239dd2$var$Identify().set(groupType, groupName);
    this._logEvent($aa416a6ee3239dd2$var$Constants.IDENTIFY_EVENT, null, null, identify.userPropertiesOperations, groups, null, null, null);
};
/**
 * Sets whether to opt current user out of tracking.
 * @public
 * @param {boolean} enable - if true then no events will be logged or sent.
 * @example: amplitude.setOptOut(true);
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setOptOut = function setOptOut(enable) {
    if (this._shouldDeferCall()) return this._q.push([
        "setOptOut"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!$aa416a6ee3239dd2$var$utils.validateInput(enable, "enable", "boolean")) return;
    try {
        this.options.optOut = enable;
        $aa416a6ee3239dd2$var$_saveCookieData(this);
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Set a custom Session ID for the current session.
 * Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * The Session ID to set for the current session must be in milliseconds since epoch (Unix Timestamp).
 * @public
 * @param {int} sessionId to set.
 * @example amplitudeClient.setSessionId(1622158968000);
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setSessionId = function setSessionId(sessionId) {
    if (!$aa416a6ee3239dd2$var$utils.validateInput(sessionId, "sessionId", "number")) return;
    try {
        this._sessionId = sessionId;
        $aa416a6ee3239dd2$var$_saveCookieData(this);
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Sets the current Unix timestamp as the new Session ID for the instance.
 * @public
 * @example amplitudeClient.resetSessionId();
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.resetSessionId = function resetSessionId() {
    this.setSessionId(new Date().getTime());
};
/**
 * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
 * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
 * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
 * This uses src/uuid.js to regenerate the deviceId.
 * @public
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.regenerateDeviceId = function regenerateDeviceId() {
    if (this._shouldDeferCall()) return this._q.push([
        "regenerateDeviceId"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    this.setDeviceId($aa416a6ee3239dd2$var$base64Id());
};
/**
 * Sets a custom deviceId for current user. **Values may not have `.` inside them**
 * Note: this is not recommended unless you know what you are doing (like if you have your own system for managing deviceIds).
 * Make sure the deviceId you set is sufficiently unique
 * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
 * @public
 * @param {string} deviceId - custom deviceId for current user.
 * @example amplitudeClient.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setDeviceId = function setDeviceId(deviceId) {
    if (this._shouldDeferCall()) return this._q.push([
        "setDeviceId"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!$aa416a6ee3239dd2$var$utils.validateDeviceId(deviceId)) return;
    try {
        if (!$aa416a6ee3239dd2$var$utils.isEmptyString(deviceId)) {
            this.options.deviceId = "" + deviceId;
            $aa416a6ee3239dd2$var$_saveCookieData(this);
            // Update core identity store to propagate new user info
            // to experiment SDK and trigger a fetch if the ID has changed.
            if (this._connector) this._connector.identityStore.editIdentity().setDeviceId(this.options.deviceId).commit();
        }
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Sets the network transport type for events. Typically used to set to 'beacon'
 * on an end-of-lifecycle event handler such as `onpagehide` or `onvisibilitychange`
 * @public
 * @param {string} transport - transport mechanism to use for events. Must be one of `http` or `beacon`.
 * @example amplitudeClient.setTransport('beacon');
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setTransport = function setTransport(transport) {
    if (this._shouldDeferCall()) return this._q.push([
        "setTransport"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!$aa416a6ee3239dd2$var$utils.validateTransport(transport)) return;
    this.options.transport = transport;
};
/**
 * Sets user properties for the current user.
 * @public
 * @param {object} - object with string keys and values for the user properties to set.
 * @param {boolean} - DEPRECATED opt_replace: in earlier versions of the JS SDK the user properties object was kept in
 * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
 * @example amplitudeClient.setUserProperties({'gender': 'female', 'sign_up_complete': true})
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setUserProperties = function setUserProperties(userProperties) {
    if (this._shouldDeferCall()) return this._q.push([
        "setUserProperties"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("setUserProperties()") || !$aa416a6ee3239dd2$var$utils.validateInput(userProperties, "userProperties", "object")) return;
    // sanitize the userProperties dict before converting into identify
    var sanitized = $aa416a6ee3239dd2$var$utils.truncate($aa416a6ee3239dd2$var$utils.validateProperties(userProperties));
    if (Object.keys(sanitized).length === 0) return;
    // convert userProperties into an identify call
    var identify = new $aa416a6ee3239dd2$var$Identify();
    for(var property in sanitized)if (Object.prototype.hasOwnProperty.call(sanitized, property)) identify.set(property, sanitized[property]);
    this.identify(identify);
};
/**
 * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
 * @public
 * @example amplitudeClient.clearUserProperties();
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.clearUserProperties = function clearUserProperties() {
    if (this._shouldDeferCall()) return this._q.push([
        "clearUserProperties"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("clearUserProperties()")) return;
    var identify = new $aa416a6ee3239dd2$var$Identify();
    identify.clearAll();
    this.identify(identify);
};
/**
 * Applies the proxied functions on the proxied object to an instance of the real object.
 * Used to convert proxied Identify and Revenue objects.
 * @private
 */ var $aa416a6ee3239dd2$var$_convertProxyObjectToRealObject = function _convertProxyObjectToRealObject(instance, proxy) {
    for(var i = 0; i < proxy._q.length; i++){
        var fn = instance[proxy._q[i][0]];
        if ($aa416a6ee3239dd2$var$type(fn) === "function") fn.apply(instance, proxy._q[i].slice(1));
    }
    return instance;
};
/**
 * Send an identify call containing user property operations to Amplitude servers.
 * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
 * reference page for more information on the Identify API and user property operations.
 * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
 * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
 * Note: the server response code and response body from the identify event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example
 * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
 * amplitude.identify(identify);
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.identify = function(identify_obj, opt_callback, opt_error_callback, outOfSession) {
    if (this._shouldDeferCall()) return this._q.push([
        "identify"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("identify()")) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "API key is not set"
        });
        return;
    }
    // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
    if ($aa416a6ee3239dd2$var$type(identify_obj) === "object" && Object.prototype.hasOwnProperty.call(identify_obj, "_q")) identify_obj = $aa416a6ee3239dd2$var$_convertProxyObjectToRealObject(new $aa416a6ee3239dd2$var$Identify(), identify_obj);
    if (identify_obj instanceof $aa416a6ee3239dd2$var$Identify) {
        // only send if there are operations
        if (Object.keys(identify_obj.userPropertiesOperations).length > 0) return this._logEvent($aa416a6ee3239dd2$var$Constants.IDENTIFY_EVENT, null, null, identify_obj.userPropertiesOperations, null, null, null, opt_callback, opt_error_callback, outOfSession);
        else $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "No user property operations"
        });
    } else {
        $aa416a6ee3239dd2$var$utils.log.error("Invalid identify input type. Expected Identify object but saw " + $aa416a6ee3239dd2$var$type(identify_obj));
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "Invalid identify input type"
        });
    }
};
$aa416a6ee3239dd2$var$AmplitudeClient.prototype.groupIdentify = function(group_type, group_name, identify_obj, opt_callback, opt_error_callback, outOfSession) {
    if (this._shouldDeferCall()) return this._q.push([
        "groupIdentify"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("groupIdentify()")) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "API key is not set"
        });
        return;
    }
    if (!$aa416a6ee3239dd2$var$utils.validateInput(group_type, "group_type", "string") || $aa416a6ee3239dd2$var$utils.isEmptyString(group_type)) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "Invalid group type"
        });
        return;
    }
    if (group_name === null || group_name === undefined) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "Invalid group name"
        });
        return;
    }
    // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
    if ($aa416a6ee3239dd2$var$type(identify_obj) === "object" && Object.prototype.hasOwnProperty.call(identify_obj, "_q")) identify_obj = $aa416a6ee3239dd2$var$_convertProxyObjectToRealObject(new $aa416a6ee3239dd2$var$Identify(), identify_obj);
    if (identify_obj instanceof $aa416a6ee3239dd2$var$Identify) {
        // only send if there are operations
        if (Object.keys(identify_obj.userPropertiesOperations).length > 0) return this._logEvent($aa416a6ee3239dd2$var$Constants.GROUP_IDENTIFY_EVENT, null, null, null, $aa416a6ee3239dd2$var$_defineProperty({}, group_type, group_name), identify_obj.userPropertiesOperations, null, opt_callback, opt_error_callback, outOfSession);
        else $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "No group property operations"
        });
    } else {
        $aa416a6ee3239dd2$var$utils.log.error("Invalid identify input type. Expected Identify object but saw " + $aa416a6ee3239dd2$var$type(identify_obj));
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "Invalid identify input type"
        });
    }
};
/**
 * Set a versionName for your application.
 * @public
 * @param {string} versionName - The version to set for your application.
 * @example amplitudeClient.setVersionName('1.12.3');
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setVersionName = function setVersionName(versionName) {
    if (this._shouldDeferCall()) return this._q.push([
        "setVersionName"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!$aa416a6ee3239dd2$var$utils.validateInput(versionName, "versionName", "string")) return;
    this.options.versionName = versionName;
};
/**
 * Private logEvent method. Keeps apiProperties from being publicly exposed.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._logEvent = function _logEvent(eventType, eventProperties, apiProperties, userProperties, groups, groupProperties, timestamp, callback, errorCallback, outOfSession) {
    $aa416a6ee3239dd2$var$_loadCookieData(this); // reload cookie before each log event to sync event meta-data between windows and tabs
    if (!eventType) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(callback, errorCallback, 0, "No request sent", {
            reason: "Missing eventType"
        });
        return;
    }
    if (this.options.optOut) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(callback, errorCallback, 0, "No request sent", {
            reason: "optOut is set to true"
        });
        return;
    }
    try {
        var eventId;
        if (eventType === $aa416a6ee3239dd2$var$Constants.IDENTIFY_EVENT || eventType === $aa416a6ee3239dd2$var$Constants.GROUP_IDENTIFY_EVENT) eventId = this.nextIdentifyId();
        else eventId = this.nextEventId();
        var sequenceNumber = this.nextSequenceNumber();
        var eventTime = $aa416a6ee3239dd2$var$type(timestamp) === "number" ? timestamp : new Date().getTime();
        if (outOfSession) this._sessionId = -1;
        else if (!this._sessionId || !this._lastEventTime || eventTime - this._lastEventTime > this.options.sessionTimeout) {
            this._sessionId = eventTime;
            this._runNewSessionStartCallbacks();
        }
        this._lastEventTime = eventTime;
        $aa416a6ee3239dd2$var$_saveCookieData(this);
        var osName = this._ua.browser.name;
        var osVersion = this._ua.browser.major;
        var deviceModel = this._ua.device.model || this._ua.os.name;
        var deviceVendor = this._ua.device.vendor;
        userProperties = userProperties || {};
        var trackingOptions = $aa416a6ee3239dd2$var$_objectSpread2({}, this._apiPropertiesTrackingOptions);
        apiProperties = $aa416a6ee3239dd2$var$_objectSpread2($aa416a6ee3239dd2$var$_objectSpread2({}, apiProperties || {}), trackingOptions);
        eventProperties = eventProperties || {};
        groups = groups || {};
        groupProperties = groupProperties || {};
        var event1 = {
            device_id: this.options.deviceId,
            user_id: this.options.userId,
            timestamp: eventTime,
            event_id: eventId,
            session_id: this._sessionId || -1,
            event_type: eventType,
            version_name: this.options.versionName || null,
            platform: $aa416a6ee3239dd2$var$_shouldTrackField(this, "platform") ? this.options.platform : null,
            os_name: $aa416a6ee3239dd2$var$_shouldTrackField(this, "os_name") ? osName || null : null,
            os_version: $aa416a6ee3239dd2$var$_shouldTrackField(this, "os_version") ? osVersion || null : null,
            device_model: $aa416a6ee3239dd2$var$_shouldTrackField(this, "device_model") ? deviceModel || null : null,
            device_manufacturer: $aa416a6ee3239dd2$var$_shouldTrackField(this, "device_manufacturer") ? deviceVendor || null : null,
            language: $aa416a6ee3239dd2$var$_shouldTrackField(this, "language") ? this.options.language : null,
            api_properties: apiProperties,
            event_properties: $aa416a6ee3239dd2$var$utils.truncate($aa416a6ee3239dd2$var$utils.validateProperties(eventProperties)),
            user_properties: $aa416a6ee3239dd2$var$utils.truncate($aa416a6ee3239dd2$var$utils.validateProperties(userProperties)),
            uuid: $aa416a6ee3239dd2$var$uuid(),
            library: this.options.library,
            sequence_number: sequenceNumber,
            // for ordering events and identifys
            groups: $aa416a6ee3239dd2$var$utils.truncate($aa416a6ee3239dd2$var$utils.validateGroups(groups)),
            group_properties: $aa416a6ee3239dd2$var$utils.truncate($aa416a6ee3239dd2$var$utils.validateProperties(groupProperties)),
            user_agent: this._userAgent,
            partner_id: this.options.partnerId || null
        };
        if ($aa416a6ee3239dd2$var$_isObservePlanSet(this)) event1.plan = {
            branch: this.options.plan.branch || undefined,
            source: this.options.plan.source || undefined,
            version: this.options.plan.version || undefined,
            versionId: this.options.plan.versionId || undefined
        };
        if ($aa416a6ee3239dd2$var$_isIngestionMetadataSet(this)) event1.ingestion_metadata = {
            source_name: this.options.ingestionMetadata.sourceName || undefined,
            source_version: this.options.ingestionMetadata.sourceVersion || undefined
        };
        if (eventType === $aa416a6ee3239dd2$var$Constants.IDENTIFY_EVENT || eventType === $aa416a6ee3239dd2$var$Constants.GROUP_IDENTIFY_EVENT) {
            this._unsentIdentifys.push({
                event: event1,
                callback: callback,
                errorCallback: errorCallback
            });
            this._limitEventsQueued(this._unsentIdentifys);
        } else {
            this._unsentEvents.push({
                event: event1,
                callback: callback,
                errorCallback: errorCallback
            });
            this._limitEventsQueued(this._unsentEvents);
        }
        if (this.options.saveEvents) this.saveEvents();
        this._sendEventsIfReady();
        // In the case of an identify event, update the core user store so the experiment SDK can fetch new variants and
        // utilize user properties in real time.
        if (eventType === $aa416a6ee3239dd2$var$Constants.IDENTIFY_EVENT && this._connector) this._connector.identityStore.editIdentity().updateUserProperties($aa416a6ee3239dd2$var$utils.truncate($aa416a6ee3239dd2$var$utils.validateProperties(userProperties))).commit();
        return eventId;
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
var $aa416a6ee3239dd2$var$_isObservePlanSet = function _isObservePlanSet(scope) {
    return scope.options.plan && (scope.options.plan.source || scope.options.plan.branch || scope.options.plan.version || scope.options.plan.versionId);
};
var $aa416a6ee3239dd2$var$_isIngestionMetadataSet = function _isIngestionMetadataSet(scope) {
    return scope.options.ingestionMetadata && (scope.options.ingestionMetadata.sourceName || scope.options.ingestionMetadata.sourceVersion);
};
var $aa416a6ee3239dd2$var$_shouldTrackField = function _shouldTrackField(scope, field) {
    return !!scope.options.trackingOptions[field];
};
var $aa416a6ee3239dd2$var$_generateApiPropertiesTrackingConfig = function _generateApiPropertiesTrackingConfig(scope) {
    // to limit size of config payload, only send fields that have been disabled
    var fields = [
        "city",
        "country",
        "dma",
        "ip_address",
        "region"
    ];
    var config = {};
    for(var i = 0; i < fields.length; i++){
        var field = fields[i];
        if (!$aa416a6ee3239dd2$var$_shouldTrackField(scope, field)) config[field] = false;
    }
    return config;
};
/**
 * Remove old events from the beginning of the array if too many have accumulated. Default limit is 1000 events.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._limitEventsQueued = function _limitEventsQueued(queue) {
    if (queue.length > this.options.savedMaxCount) {
        var deletedEvents = queue.splice(0, queue.length - this.options.savedMaxCount);
        deletedEvents.forEach(function(event1) {
            $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(event1.callback, event1.errorCallback, 0, "No request sent", {
                reason: "Event dropped because options.savedMaxCount exceeded. User may be offline or have a content blocker"
            });
        });
    }
};
/**
 * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
 * and the server response code and response body from the upload request are passed to the callback function.
 * @callback Amplitude~eventCallback
 * @param {number} responseCode - Server response code for the event / identify upload request.
 * @param {string} responseBody - Server response body for the event / identify upload request.
 * @param {object} details - (optional) Additional information associated with sending event.
 */ /**
 * Log an event with eventType and eventProperties
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if this event is out of session or not
 * @example amplitudeClient.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback, opt_error_callback) {
    var outOfSession = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (this._shouldDeferCall()) return this._q.push([
        "logEvent"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    return this.logEventWithTimestamp(eventType, eventProperties, null, opt_callback, opt_error_callback, outOfSession);
};
/**
 * Log an event with eventType and eventProperties and a custom timestamp
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {number} timestamp - (optional) the custom timestamp as milliseconds since epoch.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if out of the sessioin or not
 * @example amplitudeClient.logEventWithTimestamp('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15}, Date.now());
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.logEventWithTimestamp = function logEvent(eventType, eventProperties, timestamp, opt_callback, opt_error_callback) {
    var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    if (this._shouldDeferCall()) return this._q.push([
        "logEventWithTimestamp"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("logEvent()")) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "API key not set"
        });
        return -1;
    }
    if (!$aa416a6ee3239dd2$var$utils.validateInput(eventType, "eventType", "string")) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "Invalid type for eventType"
        });
        return -1;
    }
    if ($aa416a6ee3239dd2$var$utils.isEmptyString(eventType)) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
            reason: "Missing eventType"
        });
        return -1;
    }
    if (!$aa416a6ee3239dd2$var$utils.validateInput(outOfSession, "outOfSession", "boolean")) $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, "No request sent", {
        reason: "Invalid outOfSession value"
    });
    return this._logEvent(eventType, eventProperties, null, null, null, null, timestamp, opt_callback, opt_error_callback, outOfSession);
};
/**
 * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
 * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
 * (unless you explicitly set it with setGroup).
 *
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
 * about groups and Count by Distinct on the Amplitude platform.
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
 * groupName can be a string or an array of strings.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example amplitudeClient.logEventWithGroups('Clicked Button', null, {'orgId': 24});
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.logEventWithGroups = function(eventType, eventProperties, groups, opt_callback, opt_error_callback) {
    var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    if (this._shouldDeferCall()) return this._q.push([
        "logEventWithGroups"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("logEventWithGroups()")) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(event.callback, event.errorCallback, 0, "No request sent", {
            reason: "API key not set"
        });
        return -1;
    }
    if (!$aa416a6ee3239dd2$var$utils.validateInput(eventType, "eventType", "string")) {
        $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(event.callback, event.errorCallback, 0, "No request sent", {
            reason: "Invalid type for eventType"
        });
        return -1;
    }
    if (!$aa416a6ee3239dd2$var$utils.validateInput(outOfSession, "outOfSession", "boolean")) $aa416a6ee3239dd2$var$_logErrorsWithCallbacks(event.callback, event.errorCallback, 0, "No request sent", {
        reason: "Invalid outOfSession value"
    });
    return this._logEvent(eventType, eventProperties, null, null, groups, null, null, opt_callback, opt_error_callback, outOfSession);
};
/**
 * Test that n is a number or a numeric value.
 * @private
 */ var $aa416a6ee3239dd2$var$_isNumber = function _isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};
/**
 * Handles errors that are sent to both callbacks
 * @private
 */ var $aa416a6ee3239dd2$var$_logErrorsWithCallbacks = function _logErrorsWithCallbacks(opt_callback, opt_error_callback, status, response, details) {
    if ($aa416a6ee3239dd2$var$type(opt_callback) === "function") opt_callback(status, response, details);
    if ($aa416a6ee3239dd2$var$type(opt_error_callback) === "function") opt_error_callback(status, response, details);
};
/**
 * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
 * revenueType and event properties.
 *
 * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
 * reference page for more information on the Revenue interface and logging revenue.
 * @public
 * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
    if (this._shouldDeferCall()) return this._q.push([
        "logRevenueV2"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    if (!this._apiKeySet("logRevenueV2()")) return;
    // if revenue input is a proxied object created by the async loading snippet, convert it into an revenue object
    if ($aa416a6ee3239dd2$var$type(revenue_obj) === "object" && Object.prototype.hasOwnProperty.call(revenue_obj, "_q")) revenue_obj = $aa416a6ee3239dd2$var$_convertProxyObjectToRealObject(new $aa416a6ee3239dd2$var$Revenue(), revenue_obj);
    if (revenue_obj instanceof $aa416a6ee3239dd2$var$Revenue) {
        // only send if revenue is valid
        if (revenue_obj && revenue_obj._isValidRevenue()) return this.logEvent($aa416a6ee3239dd2$var$Constants.REVENUE_EVENT, revenue_obj._toJSONObject());
    } else $aa416a6ee3239dd2$var$utils.log.error("Invalid revenue input type. Expected Revenue object but saw " + $aa416a6ee3239dd2$var$type(revenue_obj));
};
/**
   * Log revenue event with a price, quantity, and product identifier. DEPRECATED - use logRevenueV2
   * @public
   * @deprecated
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @example amplitudeClient.logRevenue(3.99, 1, 'product_1234');
   */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.logRevenue = function logRevenue(price, quantity, product) {
    if (this._shouldDeferCall()) return this._q.push([
        "logRevenue"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    // Test that the parameters are of the right type.
    if (!this._apiKeySet("logRevenue()") || !$aa416a6ee3239dd2$var$_isNumber(price) || quantity !== undefined && !$aa416a6ee3239dd2$var$_isNumber(quantity)) // utils.log('Price and quantity arguments to logRevenue must be numbers');
    return -1;
    return this._logEvent($aa416a6ee3239dd2$var$Constants.REVENUE_EVENT, {}, {
        productId: product,
        special: "revenue_amount",
        quantity: quantity || 1,
        price: price
    }, null, null, null, null, null);
};
/**
 * Calls error callback on unsent events
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._logErrorsOnEvents = function _logErrorsOnEvents(maxEventId, maxIdentifyId, status, response) {
    var queues = [
        "_unsentEvents",
        "_unsentIdentifys"
    ];
    for(var j = 0; j < queues.length; j++){
        var queue = queues[j];
        var maxId = queue === "_unsentEvents" ? maxEventId : maxIdentifyId;
        for(var i = 0; i < this[queue].length || 0; i++){
            var unsentEvent = this[queue][i];
            if (unsentEvent.event.event_id <= maxId) {
                if (unsentEvent.errorCallback) unsentEvent.errorCallback(status, response);
            }
        }
    }
};
/**
 * Remove events in storage with event ids up to and including maxEventId.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId, status, response) {
    $aa416a6ee3239dd2$var$_removeEvents(this, "_unsentEvents", maxEventId, status, response);
    $aa416a6ee3239dd2$var$_removeEvents(this, "_unsentIdentifys", maxIdentifyId, status, response);
};
/**
 * Helper function to remove events up to maxId from a single queue.
 * Does a true filter in case events get out of order or old events are removed.
 * @private
 */ var $aa416a6ee3239dd2$var$_removeEvents = function _removeEvents(scope, eventQueue, maxId, status, response) {
    if (maxId < 0) return;
    var filteredEvents = [];
    for(var i = 0; i < scope[eventQueue].length || 0; i++){
        var unsentEvent = scope[eventQueue][i];
        if (unsentEvent.event.event_id > maxId) filteredEvents.push(unsentEvent);
        else if (unsentEvent.callback) unsentEvent.callback(status, response);
    }
    scope[eventQueue] = filteredEvents;
};
/**
 * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
 * If batchEvents is true, then events are only sent when batch criterias are met.
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.sendEvents = function sendEvents() {
    if (!this._apiKeySet("sendEvents()")) {
        this.removeEvents(Infinity, Infinity, 0, "No request sent", {
            reason: "API key not set"
        });
        return;
    }
    if (this.options.optOut) {
        this.removeEvents(Infinity, Infinity, 0, "No request sent", {
            reason: "Opt out is set to true"
        });
        return;
    }
    // How is it possible to get into this state?
    if (this._unsentCount() === 0) return;
    // We only make one request at a time. sendEvents will be invoked again once
    // the last request completes.
    // beacon data is sent synchronously, so don't pause for it
    if (this.options.transport !== $aa416a6ee3239dd2$var$Constants.TRANSPORT_BEACON) {
        if (this._sending) return;
        this._sending = true;
    }
    var protocol = this.options.forceHttps ? "https" : "https:" === $aa416a6ee3239dd2$var$GlobalScope.location.protocol ? "https" : "http";
    var url = protocol + "://" + this.options.apiEndpoint;
    // fetch events to send
    var numEvents = Math.min(this._unsentCount(), this.options.uploadBatchSize);
    var mergedEvents = this._mergeEventsAndIdentifys(numEvents);
    var maxEventId = mergedEvents.maxEventId;
    var maxIdentifyId = mergedEvents.maxIdentifyId;
    var events = JSON.stringify(mergedEvents.eventsToSend.map(function(_ref2) {
        var event1 = _ref2.event;
        return event1;
    }));
    var uploadTime = new Date().getTime();
    var data = {
        client: this.options.apiKey,
        e: events,
        v: $aa416a6ee3239dd2$var$Constants.API_VERSION,
        upload_time: uploadTime,
        checksum: (0, (/*@__PURE__*/$parcel$interopDefault($815d751d09b8fc16$exports)))($aa416a6ee3239dd2$var$Constants.API_VERSION + this.options.apiKey + events + uploadTime)
    };
    if (this.options.transport === $aa416a6ee3239dd2$var$Constants.TRANSPORT_BEACON && typeof navigator !== "undefined") {
        var success = navigator.sendBeacon(url, new URLSearchParams(data));
        if (success) {
            this.removeEvents(maxEventId, maxIdentifyId, 200, "success");
            if (this.options.saveEvents) this.saveEvents();
        } else this._logErrorsOnEvents(maxEventId, maxIdentifyId, 0, "");
        return;
    }
    var scope = this;
    try {
        new $aa416a6ee3239dd2$var$Request(url, data, this.options.headers).send(function(status, response) {
            scope._sending = false;
            try {
                if (status === 200) {
                    scope.removeEvents(maxEventId, maxIdentifyId, status, response);
                    // Update the event cache after the removal of sent events.
                    if (scope.options.saveEvents) scope.saveEvents();
                    // Send more events if any queued during previous send.
                    scope._sendEventsIfReady();
                // handle payload too large
                } else {
                    scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
                    if (status === 413) {
                        // utils.log('request too large');
                        // Can't even get this one massive event through. Drop it, even if it is an identify.
                        if (scope.options.uploadBatchSize === 1) scope.removeEvents(maxEventId, maxIdentifyId, status, response);
                        // The server complained about the length of the request. Backoff and try again.
                        scope.options.uploadBatchSize = Math.ceil(numEvents / 2);
                        scope.sendEvents();
                    }
                }
            // else {
            //  all the events are still queued, and will be retried when the next
            //  event is sent In the interest of debugging, it would be nice to have
            //  something like an event emitter for a better debugging experince
            //  here.
            // }
            } catch (e) {
            // utils.log.error('failed upload');
            }
        });
    } catch (e) {
        var status = 0, response = "Request failed to send";
        $aa416a6ee3239dd2$var$utils.log.error(response);
        scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
        scope.removeEvents(maxEventId, maxIdentifyId, status, response, {
            reason: e.message
        });
    }
};
/**
 * Merge unsent events and identifys together in sequential order based on their sequence number, for uploading.
 * Identifys given higher priority than Events. Also earlier sequence given priority
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._mergeEventsAndIdentifys = function _mergeEventsAndIdentifys(numEvents) {
    // coalesce events from both queues
    var eventsToSend = [];
    var eventIndex = 0;
    var maxEventId = -1;
    var identifyIndex = 0;
    var maxIdentifyId = -1;
    while(eventsToSend.length < numEvents){
        var unsentEvent = void 0;
        var noIdentifys = identifyIndex >= this._unsentIdentifys.length;
        var noEvents = eventIndex >= this._unsentEvents.length;
        // case 0: no events or identifys left
        // note this should not happen, this means we have less events and identifys than expected
        if (noEvents && noIdentifys) {
            $aa416a6ee3239dd2$var$utils.log.error("Merging Events and Identifys, less events and identifys than expected");
            break;
        } else if (noIdentifys) {
            unsentEvent = this._unsentEvents[eventIndex++];
            maxEventId = unsentEvent.event.event_id;
        // case 2: no events - grab from identifys
        } else if (noEvents) {
            unsentEvent = this._unsentIdentifys[identifyIndex++];
            maxIdentifyId = unsentEvent.event.event_id;
        // case 3: need to compare sequence numbers
        } else // events logged before v2.5.0 won't have a sequence number, put those first
        if (!("sequence_number" in this._unsentEvents[eventIndex].event) || this._unsentEvents[eventIndex].event.sequence_number < this._unsentIdentifys[identifyIndex].event.sequence_number) {
            unsentEvent = this._unsentEvents[eventIndex++];
            maxEventId = unsentEvent.event.event_id;
        } else {
            unsentEvent = this._unsentIdentifys[identifyIndex++];
            maxIdentifyId = unsentEvent.event.event_id;
        }
        eventsToSend.push(unsentEvent);
    }
    return {
        eventsToSend: eventsToSend,
        maxEventId: maxEventId,
        maxIdentifyId: maxIdentifyId
    };
};
/**
   * Set global user properties. Note this is deprecated, and we recommend using setUserProperties
   * @public
   * @deprecated
   */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.setUserProperties(userProperties);
};
/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.__VERSION__ = function getVersion() {
    return this.options.library.version;
};
/**
 * Sets the library name and version. Default is `amplitude-js` and the version defined in package.json. Used if you're building another library on top of amplitude-js and want a custom data source value
 * @public
 * @param {string} name - Custom library name
 * @param {string} version - Custom library version
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setLibrary = function setLibrary(name, version) {
    if (name !== null && typeof name !== "undefined") this.options.library.name = name;
    if (version !== null && typeof version !== "undefined") this.options.library.version = version;
};
/**
 * Determines whether or not to push call to this._q or invoke it
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._shouldDeferCall = function _shouldDeferCall() {
    return this._pendingReadStorage || this._initializationDeferred;
};
/**
 * Defers Initialization by putting all functions into storage until users
 * have accepted terms for tracking
 * @private
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._deferInitialization = function _deferInitialization() {
    this._initializationDeferred = true;
    this._q.push([
        "init"
    ].concat(Array.prototype.slice.call(arguments, 0)));
};
/**
 * Enable tracking via logging events and dropping a cookie
 * Intended to be used with the deferInitialization configuration flag
 * This will drop a cookie and reset initialization deferred
 * @public
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.enableTracking = function enableTracking() {
    // This will call init (which drops the cookie) and will run any pending tasks
    this._initializationDeferred = false;
    $aa416a6ee3239dd2$var$_saveCookieData(this);
    this.runQueuedFunctions();
};
/**
 * Find best server url if choose to enable dynamic configuration.
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype._refreshDynamicConfig = function _refreshDynamicConfig() {
    if (this.options.useDynamicConfig) $aa416a6ee3239dd2$var$instance$1.refresh(this.options.serverZone, this.options.forceHttps, (function() {
        this.options.apiEndpoint = $aa416a6ee3239dd2$var$instance$1.ingestionEndpoint;
    }).bind(this));
};
/**
 * Returns the deviceId value.
 * @public
 * @return {string} Id of current device.
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.getDeviceId = function getDeviceId() {
    return this.options.deviceId;
};
/**
 * Returns the userId.
 * @public
 * @return {string} Id of current user.
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.getUserId = function getUserId() {
    return this.options.userId;
};
/**
 * Set a custom session expiration time.
 * @public
 * @param {number} timeInMillis - session expireation time in milliseconds.
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setMinTimeBetweenSessionsMillis = function setMinTimeBetweenSessionsMillis(timeInMillis) {
    if (!$aa416a6ee3239dd2$var$utils.validateInput(timeInMillis, "timeInMillis", "number")) return;
    if (this._shouldDeferCall()) return this._q.push([
        "setMinTimeBetweenSessionsMillis"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    try {
        this.options.sessionTimeout = timeInMillis;
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Sets minimum number of events to batch together per request if batchEvents is true.
 * @public
 * @param {number} eventUploadThreshold - The number of the event upload threshold. Default value is 30.
 * @example amplitudeClient.setEventUploadThreshold(10);
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setEventUploadThreshold = function setEventUploadThreshold(eventUploadThreshold) {
    if (!$aa416a6ee3239dd2$var$utils.validateInput(eventUploadThreshold, "eventUploadThreshold", "number")) return;
    if (this._shouldDeferCall()) return this._q.push([
        "setEventUploadThreshold"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    try {
        this.options.eventUploadThreshold = eventUploadThreshold;
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Dynamically adjust server URL
 * @public
 * @param {bool} useDynamicConfig - if enable dynamic config or not.
 * @example amplitudeClient.setUseDynamicConfig(true);
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setUseDynamicConfig = function setUseDynamicConfig(useDynamicConfig) {
    if (!$aa416a6ee3239dd2$var$utils.validateInput(useDynamicConfig, "useDynamicConfig", "boolean")) return;
    if (this._shouldDeferCall()) return this._q.push([
        "setUseDynamicConfig"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    try {
        this.options.useDynamicConfig = useDynamicConfig;
        this._refreshDynamicConfig();
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Sets the server zone, used for server api endpoint and dynamic configuration.
 * @public
 * @param {string} serverZone - the server zone value. AmplitudeServerZone.US or AmplitudeServerZone.EU.
 * @param {bool} serverZoneBasedApi - (optional) update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @example amplitudeClient.setServerZone(AmplitudeServerZone.EU, true);
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setServerZone = function setServerZone(serverZone) {
    var serverZoneBasedApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (serverZone !== $aa416a6ee3239dd2$var$AmplitudeServerZone.EU && serverZone !== $aa416a6ee3239dd2$var$AmplitudeServerZone.US || !$aa416a6ee3239dd2$var$utils.validateInput(serverZoneBasedApi, "serverZoneBasedApi", "boolean")) return;
    if (this._shouldDeferCall()) return this._q.push([
        "setServerZone"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    try {
        this.options.serverZone = serverZone;
        this.options.serverZoneBasedApi = serverZoneBasedApi;
        if (serverZoneBasedApi) this.options.apiEndpoint = $aa416a6ee3239dd2$var$getEventLogApi(this.options.serverZone);
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Sets the server URL for the request.
 * @public
 * @param {string} serverUrl - The value of the server URL.
 * @example amplitudeClient.setServerUrl('api.amplitude.com');
 */ $aa416a6ee3239dd2$var$AmplitudeClient.prototype.setServerUrl = function setServerUrl(serverUrl) {
    if (!$aa416a6ee3239dd2$var$utils.validateInput(serverUrl, "serverUrl", "string")) return;
    if (this._shouldDeferCall()) return this._q.push([
        "setServerUrl"
    ].concat(Array.prototype.slice.call(arguments, 0)));
    try {
        this.options.apiEndpoint = serverUrl;
    } catch (e) {
        $aa416a6ee3239dd2$var$utils.log.error(e);
    }
};
/**
 * Deprecated legacy API of the Amplitude JS SDK - instance manager.
 *
 * Wraps around the current [AmplitudeClient](https://amplitude.github.io/Amplitude-JavaScript/) which provides more features
 * Function calls directly on amplitude have been deprecated. Please call methods on the default shared instance: amplitude.getInstance() instead.
 *
 * See the [3.0.0 changelog](https://github.com/amplitude/Amplitude-JavaScript/blob/ed405afb5f06d5cf5b72539a5d09179abcf7e1fe/README.md#300-update-and-logging-events-to-multiple-amplitude-apps) for more information about this change.
 * @constructor Amplitude
 * @public
 * @deprecated
 * @example var amplitude = new Amplitude();
 */ var $aa416a6ee3239dd2$var$Amplitude = function Amplitude() {
    this.options = $aa416a6ee3239dd2$var$_objectSpread2({}, $aa416a6ee3239dd2$var$DEFAULT_OPTIONS);
    this._q = [];
    this._instances = {}; // mapping of instance names to instances
};
$aa416a6ee3239dd2$var$Amplitude.prototype.Identify = $aa416a6ee3239dd2$var$Identify;
$aa416a6ee3239dd2$var$Amplitude.prototype.Revenue = $aa416a6ee3239dd2$var$Revenue;
$aa416a6ee3239dd2$var$Amplitude.prototype.getInstance = function getInstance(instance) {
    instance = $aa416a6ee3239dd2$var$utils.isEmptyString(instance) ? $aa416a6ee3239dd2$var$Constants.DEFAULT_INSTANCE : instance.toLowerCase();
    var client = this._instances[instance];
    if (client === undefined) {
        client = new $aa416a6ee3239dd2$var$AmplitudeClient(instance);
        this._instances[instance] = client;
    }
    return client;
};
/**
   * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
   * This is required before any other methods can be called.
   * @public
   * @param {string} apiKey - The API key for your app.
   * @param {string} opt_userId - (optional) An identifier for this user.
   * @param {object} opt_config - (optional) Configuration options.
   * See [options.js](https://github.com/amplitude/Amplitude-JavaScript/blob/master/src/options.js#L14) for list of options and default values.
   * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
   * @deprecated Please use amplitude.getInstance().init(apiKey, opt_userId, opt_config, opt_callback);
   * @example amplitude.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
    this.getInstance().init(apiKey, opt_userId, opt_config, (function(instance) {
        // make options such as deviceId available for callback functions
        this.options = instance.options;
        if ($aa416a6ee3239dd2$var$type(opt_callback) === "function") opt_callback(instance);
    }).bind(this));
};
/**
   * Returns true if a new session was created during initialization, otherwise false.
   * @public
   * @return {boolean} Whether a new session was created during initialization.
   * @deprecated Please use amplitude.getInstance().isNewSession();
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.isNewSession = function isNewSession() {
    return this.getInstance().isNewSession();
};
/**
   * Returns the id of the current session.
   * @public
   * @return {number} Id of the current session.
   * @deprecated Please use amplitude.getInstance().getSessionId();
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.getSessionId = function getSessionId() {
    return this.getInstance().getSessionId();
};
/**
   * Increments the eventId and returns it.
   * @private
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.nextEventId = function nextEventId() {
    return this.getInstance().nextEventId();
};
/**
   * Increments the identifyId and returns it.
   * @private
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.nextIdentifyId = function nextIdentifyId() {
    return this.getInstance().nextIdentifyId();
};
/**
   * Increments the sequenceNumber and returns it.
   * @private
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.nextSequenceNumber = function nextSequenceNumber() {
    return this.getInstance().nextSequenceNumber();
};
/**
   * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
   * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
   * @private
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.saveEvents = function saveEvents() {
    this.getInstance().saveEvents();
};
/**
   * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
   * @public
   * @param {string} domain to set.
   * @deprecated Please use amplitude.getInstance().setDomain(domain);
   * @example amplitude.setDomain('.amplitude.com');
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setDomain = function setDomain(domain) {
    this.getInstance().setDomain(domain);
};
/**
   * Sets an identifier for the current user.
   * @public
   * @param {string} userId - identifier to set. Can be null.
   * @deprecated Please use amplitude.getInstance().setUserId(userId);
   * @example amplitude.setUserId('joe@gmail.com');
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setUserId = function setUserId(userId) {
    this.getInstance().setUserId(userId);
};
/**
   * Add user to a group or groups. You need to specify a groupType and groupName(s).
   * For example you can group people by their organization.
   * In that case groupType is "orgId" and groupName would be the actual ID(s).
   * groupName can be a string or an array of strings to indicate a user in multiple gruups.
   * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
   * Note: this will also set groupType: groupName as a user property.
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
   * @public
   * @param {string} groupType - the group type (ex: orgId)
   * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
   * @deprecated Please use amplitude.getInstance().setGroup(groupType, groupName);
   * @example amplitude.setGroup('orgId', 15); // this adds the current user to orgId 15.
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setGroup = function(groupType, groupName) {
    this.getInstance().setGroup(groupType, groupName);
};
/**
   * Sets whether to opt current user out of tracking.
   * @public
   * @param {boolean} enable - if true then no events will be logged or sent.
   * @deprecated Please use amplitude.getInstance().setOptOut(enable);
   * @example: amplitude.setOptOut(true);
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setOptOut = function setOptOut(enable) {
    this.getInstance().setOptOut(enable);
};
/**
   * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
   * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
   * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
   * This uses src/uuid.js to regenerate the deviceId.
   * @public
   * @deprecated Please use amplitude.getInstance().regenerateDeviceId();
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.regenerateDeviceId = function regenerateDeviceId() {
    this.getInstance().regenerateDeviceId();
};
/**
   * Sets a custom deviceId for current user. Note: this is not recommended unless you know what you are doing
   * (like if you have your own system for managing deviceIds).
   *
   * Make sure the deviceId you set is sufficiently unique
   * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
   * @public
   * @param {string} deviceId - custom deviceId for current user.
   * @deprecated Please use amplitude.getInstance().setDeviceId(deviceId);
   * @example amplitude.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setDeviceId = function setDeviceId(deviceId) {
    this.getInstance().setDeviceId(deviceId);
};
/**
   * Sets user properties for the current user.
   * @public
   * @param {object} userProperties - object with string keys and values for the user properties to set.
   * @param {boolean} opt_replace - Deprecated. In earlier versions of the JS SDK the user properties object was kept in
   * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
   * @deprecated Please use amplitude.getInstance().setUserProperties(userProperties);
   * @example amplitude.setUserProperties({'gender': 'female', 'sign_up_complete': true})
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setUserProperties = function setUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
};
/**
   * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
   * @public
   * @deprecated Please use amplitude.getInstance().clearUserProperties();
   * @example amplitude.clearUserProperties();
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.clearUserProperties = function clearUserProperties() {
    this.getInstance().clearUserProperties();
};
/**
   * Send an identify call containing user property operations to Amplitude servers.
   * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
   * reference page for more information on the Identify API and user property operations.
   * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
   * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
   * Note: the server response code and response body from the identify event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().identify(identify);
   * @example
   * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
   * amplitude.identify(identify);
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.identify = function(identify_obj, opt_callback) {
    this.getInstance().identify(identify_obj, opt_callback);
};
/**
   * Set a versionName for your application.
   * @public
   * @param {string} versionName - The version to set for your application.
   * @deprecated Please use amplitude.getInstance().setVersionName(versionName);
   * @example amplitude.setVersionName('1.12.3');
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setVersionName = function setVersionName(versionName) {
    this.getInstance().setVersionName(versionName);
};
/**
   * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
   * and the server response code and response body from the upload request are passed to the callback function.
   * @callback Amplitude~eventCallback
   * @param {number} responseCode - Server response code for the event / identify upload request.
   * @param {string} responseBody - Server response body for the event / identify upload request.
   */ /**
   * Log an event with eventType and eventProperties
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEvent(eventType, eventProperties, opt_callback);
   * @example amplitude.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback) {
    return this.getInstance().logEvent(eventType, eventProperties, opt_callback);
};
/**
   * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
   *
   * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
   * (unless you explicitly set it with setGroup).
   *
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
   * about groups and Count by Distinct on the Amplitude platform.
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
   * groupName can be a string or an array of strings.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
   * @example amplitude.logEventWithGroups('Clicked Button', null, {'orgId': 24});
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.logEventWithGroups = function(eventType, eventProperties, groups, opt_callback) {
    return this.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
};
/**
   * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
   * revenueType and event properties.
   *
   * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
   * reference page for more information on the Revenue interface and logging revenue.
   * @public
   * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
   * amplitude.logRevenueV2(revenue);
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
    return this.getInstance().logRevenueV2(revenue_obj);
};
/**
   * Log revenue event with a price, quantity, and product identifier.
   * @public
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example amplitude.logRevenue(3.99, 1, 'product_1234');
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.logRevenue = function logRevenue(price, quantity, product) {
    return this.getInstance().logRevenue(price, quantity, product);
};
/**
   * Remove events in storage with event ids up to and including maxEventId.
   * @private
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId) {
    this.getInstance().removeEvents(maxEventId, maxIdentifyId);
};
/**
   * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
   * If batchEvents is true, then events are only sent when batch criterias are met.
   * @private
   * @param {Amplitude~eventCallback} callback - (optional) callback to run after events are sent.
   * Note the server response code and response body are passed to the callback as input arguments.
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.sendEvents = function sendEvents(callback) {
    this.getInstance().sendEvents(callback);
};
/**
   * Set global user properties.
   * @public
   * @deprecated Please use amplitudeClient.setUserProperties
   */ $aa416a6ee3239dd2$var$Amplitude.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
};
/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */ $aa416a6ee3239dd2$var$Amplitude.prototype.__VERSION__ = $aa416a6ee3239dd2$var$version;
// Entry point
var $aa416a6ee3239dd2$var$old = typeof $aa416a6ee3239dd2$var$GlobalScope !== "undefined" && $aa416a6ee3239dd2$var$GlobalScope.amplitude || {};
var $aa416a6ee3239dd2$export$2e2bcd8739ae039 = new $aa416a6ee3239dd2$var$Amplitude();
$aa416a6ee3239dd2$export$2e2bcd8739ae039._q = $aa416a6ee3239dd2$var$old._q || [];
/**
 * Instantiates Amplitude object and runs all queued function logged by stubbed methods provided by snippets
 * Event queue allows async loading of SDK to not blocking client's app
 */ for(var $aa416a6ee3239dd2$var$instance in $aa416a6ee3239dd2$var$old._iq)// migrate each instance's queue
if (Object.prototype.hasOwnProperty.call($aa416a6ee3239dd2$var$old._iq, $aa416a6ee3239dd2$var$instance)) $aa416a6ee3239dd2$export$2e2bcd8739ae039.getInstance($aa416a6ee3239dd2$var$instance)._q = $aa416a6ee3239dd2$var$old._iq[$aa416a6ee3239dd2$var$instance]._q || [];



var $lDSNw = parcelRequire("lDSNw");
// Should be moved to Firebase?
// M - eventually
const $fa80e68d246605f9$export$3a8aaff34855e439 = [
    // ----------------
    // CPT
    {
        email: "pat.mifsud@playgroundxyz.com",
        demoCreativeID: "satobo",
        team: "CPT"
    },
    {
        email: "mathieu.mence@playgroundxyz.com",
        demoCreativeID: "retijo",
        team: "CPT"
    },
    {
        email: "steve.nash@playgroundxyz.com",
        demoCreativeID: "cibire",
        team: "CPT"
    },
    {
        email: "anara.davletaliyeva@playgroundxyz.com",
        demoCreativeID: "mogema",
        team: "CPT"
    },
    {
        email: "andrea.agathocleous@playgroundxyz.com",
        demoCreativeID: "fihisu",
        team: "CPT"
    },
    {
        email: "ryman.white@playgroundxyz.com",
        team: "CPT",
        demoCreativeID: "bitacu"
    },
    // ----------------
    // SALES
    {
        email: "david.ditonto@playgroundxyz.com",
        demoCreativeID: "xonivu",
        team: "sales"
    },
    {
        email: "georgia.falloon@playgroundxyz.com",
        demoCreativeID: "wowixa",
        team: "sales"
    },
    {
        email: "jake.selley@playgroundxyz.com",
        demoCreativeID: "kowile",
        team: "sales"
    },
    {
        email: "karan.kent@playgroundxyz.com",
        demoCreativeID: "fawidi",
        team: "sales"
    },
    {
        email: "krystan.irvine@playgroundxyz.com",
        demoCreativeID: "zipiqa",
        team: "sales"
    },
    {
        email: "alex.hill@playgroundxyz.com",
        demoCreativeID: "fumonu",
        team: "sales"
    },
    {
        email: "amber.mumford@playgroundxyz.com",
        demoCreativeID: "savene",
        team: "sales"
    },
    {
        email: "amelia.lyall@playgroundxyz.com",
        demoCreativeID: "soxowu",
        team: "sales"
    },
    {
        email: "ben.dimond@playgroundxyz.com",
        demoCreativeID: "hibete",
        team: "sales"
    },
    {
        email: "bernard.tam@playgroundxyz.com",
        demoCreativeID: "gaqequ",
        team: "sales"
    },
    {
        email: "james.higson@playgroundxyz.com",
        demoCreativeID: "kiduwu",
        team: "sales"
    },
    {
        email: "jess.aylett@playgroundxyz.com",
        demoCreativeID: "jekefu",
        team: "sales"
    },
    {
        email: "michael.buhagiar@playgroundxyz.com",
        demoCreativeID: "yadujo",
        team: "sales"
    },
    {
        email: "rob.hall@playgroundxyz.com",
        demoCreativeID: "rejozu",
        team: "sales"
    },
    {
        email: "billy.gittins@playgroundxyz.com",
        demoCreativeID: "risocu",
        team: "sales"
    },
    {
        email: "tarlyn.mcstay@playgroundxyz.com",
        demoCreativeID: "nepeju",
        team: "sales"
    },
    {
        email: "sorrel.osborne@playgroundxyz.com",
        demoCreativeID: "jicavo",
        team: "sales"
    },
    {
        email: "kevin.smyth@playgroundxyz.com",
        demoCreativeID: "sivigo",
        team: "sales"
    },
    {
        email: "ben.swaik@playgroundxyz.com",
        demoCreativeID: "gumowo",
        team: "sales"
    },
    // ----------------
    // DESIGN
    {
        email: "jesse.whitmore@playgroundxyz.com",
        demoCreativeID: "wohedo",
        team: "design"
    },
    {
        email: "kristjan.rattus@playgroundxyz.com",
        demoCreativeID: "xiyubi",
        team: "design"
    },
    {
        email: "kristjanfreelance@gmail.com",
        demoCreativeID: "xiyubi",
        team: "design"
    },
    {
        email: "nick.mudge@playgroundxyz.com",
        demoCreativeID: "dapeqa",
        team: "design"
    },
    {
        email: "annie.lemaire-brooks@playgroundxyz.com",
        demoCreativeID: "xogige",
        team: "design"
    },
    {
        email: "suyin.ng@playgroundxyz.com",
        demoCreativeID: "bugiqa",
        team: "design"
    },
    {
        email: "marc.gundesen@playgroundxyz.com",
        demoCreativeID: "hosohu",
        team: "design"
    },
    {
        email: "vinko.kraljevic@playgroundxyz.com",
        demoCreativeID: "vizigo",
        team: "design"
    },
    {
        email: "jean-louis.lamyanfoon@playgroundxyz.com",
        team: "design"
    },
    // Misc staff
    {
        email: "madeleine.navin@playgroundxyz.com",
        team: "staff"
    },
    {
        email: "yohei.naito@gumgum.com",
        team: "staff"
    },
    {
        email: "ehope@gumgum.com",
        team: "staff"
    }
];


// move to env variable
const $d712a5077c581ffa$var$consoleLogging = false;
const $d712a5077c581ffa$export$5d572ecdd7af4c65 = ()=>{
    (0, $lDSNw.useEffect)(()=>{
        if ($d712a5077c581ffa$var$consoleLogging) console.log("Starting analytics - process.env.AMPLITUDE_KEY", "e9eca8d3cd8b7b65ea0536e0ed968aea");
        (0, $aa416a6ee3239dd2$export$2e2bcd8739ae039).getInstance().init("e9eca8d3cd8b7b65ea0536e0ed968aea");
    }, []);
};
const $d712a5077c581ffa$export$dc9329aa05938094 = (user)=>{
    if ($d712a5077c581ffa$var$consoleLogging) console.log("setting user: ", user);
    const foundUser = (0, $fa80e68d246605f9$export$3a8aaff34855e439).find((meta)=>meta.email === user.email);
    const team = foundUser?.team || "";
    (0, $aa416a6ee3239dd2$export$2e2bcd8739ae039).getInstance().setUserId(user.uid);
    (0, $aa416a6ee3239dd2$export$2e2bcd8739ae039).getInstance().setUserProperties({
        name: user.displayName || user.email || "",
        email: user.email || "",
        cohort: team
    });
};
const $d712a5077c581ffa$var$analyticsSendEvent = (eventName, eventProperties = null)=>{
    if ($d712a5077c581ffa$var$consoleLogging) console.log("sent event: ", eventName, eventProperties);
    return (0, $aa416a6ee3239dd2$export$2e2bcd8739ae039).getInstance().logEvent(eventName, eventProperties);
};
const $d712a5077c581ffa$export$c96b87a5365cb76c = {
    // Creative viewer
    creativeViewed: (build_id, in_ab_test = false)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("creativeViewed", {
            build_id: build_id,
            in_ab_test: in_ab_test
        });
    },
    creativeSessionsLoaded: (build_id, in_ab_test = false, sessions, format)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("creativeSessionsLoaded", {
            build_id: build_id,
            in_ab_test: in_ab_test,
            sessions: sessions,
            format: format
        });
    },
    creativePreviewScrubed: (build_id)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("creativePreviewScrubed", {
            build_id: build_id
        });
    },
    creativeQrExpand: (build_id, direction)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("creativeQrExpand", {
            build_id: build_id,
            direction: direction
        });
    },
    // AB Test
    abtestViewed: (build_ids)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("abtestViewed", {
            build_ids: build_ids
        });
    },
    abtestLoaded: (build_ids)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("abtestLoaded", {
            build_ids: build_ids
        });
    },
    abtestScrubed: (build_ids)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("abtestScrubed", {
            build_ids: build_ids
        });
    },
    // Shared UI Interactions
    featureShareOpened: (build_ids)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("featureShareOpened", {
            build_ids: build_ids
        });
    },
    featureShareInteraction: (build_ids, type)=>{
        // avilable types: copy_link, open_in_new_tab
        $d712a5077c581ffa$var$analyticsSendEvent("featureShareInteraction", {
            build_ids: build_ids,
            type: type
        });
    },
    featureFeedbackOpened: (build_id = "unknown")=>{
        $d712a5077c581ffa$var$analyticsSendEvent("featureFeedbackOpened", {
            build_id: build_id
        });
    },
    featureFeedbackSubmit: (build_id = "unknown", type)=>{
        // avilable types: submit, cancel
        $d712a5077c581ffa$var$analyticsSendEvent("featureFeedbackSubmit", {
            build_id: build_id,
            type: type
        });
    },
    // Demo
    demoViewed: ()=>{
        $d712a5077c581ffa$var$analyticsSendEvent("demoViewed");
    },
    demoNoSessions: ()=>{
        $d712a5077c581ffa$var$analyticsSendEvent("demoNoSessions");
    },
    demoNoCreative: ()=>{
        $d712a5077c581ffa$var$analyticsSendEvent("demoNoCreative");
    },
    demoClearedData: ()=>{
        $d712a5077c581ffa$var$analyticsSendEvent("demoClearedData");
    },
    demoClickedHowToUse: ()=>{
        $d712a5077c581ffa$var$analyticsSendEvent("demoClickedHowToUse");
    },
    // Errors
    error404: (url = "unknown")=>{
        $d712a5077c581ffa$var$analyticsSendEvent("error404", {
            url: url
        });
    },
    errorGeneral: (error = "unknown", url = "unknown")=>{
        $d712a5077c581ffa$var$analyticsSendEvent("errorGeneral", {
            error: error,
            url: url
        });
    },
    // GUI
    guiPanel: (type = "unknown")=>{
        $d712a5077c581ffa$var$analyticsSendEvent("guiPanel", {
            type: type
        });
    },
    guiAdjust: (setting = "unknown", value = "unknown")=>{
        $d712a5077c581ffa$var$analyticsSendEvent("guiAdjust", {
            setting: setting,
            value: value
        });
    },
    guiDomainWhitelistChange: (domain = "unknown", url = "unknown", in_ab_test = false)=>{
        $d712a5077c581ffa$var$analyticsSendEvent("guiDomainWhitelistChange", {
            domain: domain,
            url: url,
            in_ab_test: in_ab_test
        });
    }
};


var $923acc790b27d968$exports = {};

$parcel$export($923acc790b27d968$exports, "dontCry", function () { return $923acc790b27d968$export$25592139914dc632; }, function (v) { return $923acc790b27d968$export$25592139914dc632 = v; });
$parcel$export($923acc790b27d968$exports, "gameWrapper", function () { return $923acc790b27d968$export$d890caf0287c33ae; }, function (v) { return $923acc790b27d968$export$d890caf0287c33ae = v; });
$parcel$export($923acc790b27d968$exports, "wrapper", function () { return $923acc790b27d968$export$cc74dcc53cfce4eb; }, function (v) { return $923acc790b27d968$export$cc74dcc53cfce4eb = v; });
var $923acc790b27d968$export$25592139914dc632;
var $923acc790b27d968$export$d890caf0287c33ae;
var $923acc790b27d968$export$cc74dcc53cfce4eb;
$923acc790b27d968$export$25592139914dc632 = `tyXuyq_dontCry`;
$923acc790b27d968$export$d890caf0287c33ae = `tyXuyq_gameWrapper`;
$923acc790b27d968$export$cc74dcc53cfce4eb = `tyXuyq_wrapper`;


var $6dee32e5d04b745b$exports = {};
"use strict";

var $eZ0I6 = parcelRequire("eZ0I6");
var $089cc5388ab2fc67$exports = {};
"use strict";
$089cc5388ab2fc67$exports = function() {
    return /\bv?(?:0|[1-9][0-9]*)\.(?:0|[1-9][0-9]*)\.(?:0|[1-9][0-9]*)(?:-[\da-z\-]+(?:\.[\da-z\-]+)*)?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?\b/ig;
};


function $6dee32e5d04b745b$var$sort(semvers, compare) {
    if (!semvers instanceof Array) throw new Error("It is not an array");
    return semvers.sort(function(v1, v2) {
        var sv1 = $089cc5388ab2fc67$exports().exec(v1)[0] || v1;
        var sv2 = $089cc5388ab2fc67$exports().exec(v2)[0] || v2;
        return compare(sv1, sv2);
    });
}
$6dee32e5d04b745b$exports = {
    asc: function(semvers) {
        return $6dee32e5d04b745b$var$sort(semvers, $eZ0I6.compare);
    },
    desc: function(semvers) {
        return $6dee32e5d04b745b$var$sort(semvers, $eZ0I6.rcompare);
    }
};



const $1d2a9bf39ef7c690$export$28c2fde9c958d23b = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        // this is the default state of the application
        userInfo: null,
        upScrollHeat: 0,
        scrollHeat: 0,
        showScrollHeat: false,
        showUpScrollHeat: false,
        viewerScale: 1,
        showModal: {
            open: false,
            text: ""
        },
        availableScriptVersions: [],
        selectedScriptVersions: [],
        availableVerticals: [],
        selectedVerticals: [],
        setShowModal: (state, text)=>{
            set({
                showModal: {
                    open: state,
                    text: text
                }
            });
            console.log(text);
        },
        setUserInfo: (useInfo)=>{
            set({
                userInfo: useInfo
            });
        },
        setLogOut: ()=>{
            set({
                userInfo: {
                    displayName: "",
                    email: "",
                    photoURL: "",
                    loggedIn: false,
                    id: "",
                    missingDemoCreative: false
                }
            });
        },
        videoFrames: {},
        setVideoFrames: (frames)=>{
            set({
                videoFrames: {
                    ...get().videoFrames,
                    ...frames
                }
            });
        },
        iframeVideoProgress: 0,
        setIframeVideoProgress: (progress)=>{
            set({
                iframeVideoProgress: progress
            });
        },
        addAvailableScriptVersion: (version)=>{
            let availableScriptVersionsClone = [
                ...get().availableScriptVersions
            ];
            availableScriptVersionsClone.push(version);
            availableScriptVersionsClone = (0, (/*@__PURE__*/$parcel$interopDefault($6dee32e5d04b745b$exports))).desc(availableScriptVersionsClone);
            set({
                availableScriptVersions: availableScriptVersionsClone
            });
        },
        addAvailableVerticals: (vertical)=>{
            let availableVerticalsClone = [
                ...get().availableVerticals
            ];
            availableVerticalsClone.push(vertical);
            availableVerticalsClone.sort();
            set({
                availableVerticals: availableVerticalsClone
            });
        },
        setMissingDemoCreative: (value)=>{
            set((state)=>({
                    userInfo: {
                        ...state.userInfo,
                        missingDemoCreative: value
                    }
                }));
        }
    }));


const $927db14b17997692$var$DontCry = ()=>{
    (0, $lDSNw.useEffect)(()=>{
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).error404(window.location.href);
    }, []);
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($923acc790b27d968$exports))).dontCry,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($923acc790b27d968$exports))).wrapper,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($923acc790b27d968$exports))).gameWrapper,
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $62548df2a7b28942$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("h1", {
                    children: "OOPS - 404"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("h2", {
                    children: "The page you requested doesn't exist."
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("p", {
                    children: "Please contact us if this seems to be a mistake."
                })
            ]
        })
    });
};
var $927db14b17997692$export$2e2bcd8739ae039 = $927db14b17997692$var$DontCry;




var $a43a80b4364d3d64$exports = {};

$a43a80b4364d3d64$exports = new URL((parcelRequire("5V6iE")).resolve("bKx1s"), import.meta.url).toString();



var $cbda6f697f1b91f9$export$1e511d4a378977f5;
var $cbda6f697f1b91f9$export$2e2bcd8739ae039;
"use strict";
$cbda6f697f1b91f9$export$1e511d4a378977f5 = true;

var $lDSNw = parcelRequire("lDSNw");
var $cbda6f697f1b91f9$var$_react2 = $cbda6f697f1b91f9$var$_interopRequireDefault($lDSNw);
function $cbda6f697f1b91f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbda6f697f1b91f9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cbda6f697f1b91f9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cbda6f697f1b91f9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $cbda6f697f1b91f9$var$ELEMENT_ID = "firebaseui_container";
var $cbda6f697f1b91f9$var$firebaseUiDeletion = Promise.resolve();


var $cbda6f697f1b91f9$var$FirebaseAuth = function(_React$Component) {
    $cbda6f697f1b91f9$var$_inherits(FirebaseAuth, _React$Component);
    function FirebaseAuth(props) {
        $cbda6f697f1b91f9$var$_classCallCheck(this, FirebaseAuth);
        var _this = $cbda6f697f1b91f9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
        _this.uiConfig = props.uiConfig;
        _this.firebaseAuth = props.firebaseAuth;
        _this.className = props.className;
        _this.uiCallback = props.uiCallback;
        _this.unregisterAuthObserver = function() {};
        return _this;
    }
    FirebaseAuth.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;
        {};
        var firebaseui = (parcelRequire("kZrZm"));
        return $cbda6f697f1b91f9$var$firebaseUiDeletion.then(function() {
            _this2.firebaseUiWidget = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(_this2.firebaseAuth);
            if (_this2.uiConfig.signInFlow === "popup") _this2.firebaseUiWidget.reset();
            _this2.userSignedIn = false;
            _this2.unregisterAuthObserver = _this2.firebaseAuth.onAuthStateChanged(function(user) {
                if (!user && _this2.userSignedIn) _this2.firebaseUiWidget.reset();
                _this2.userSignedIn = !!user;
            });
            if (_this2.uiCallback) _this2.uiCallback(_this2.firebaseUiWidget);
            _this2.firebaseUiWidget.start("#" + $cbda6f697f1b91f9$var$ELEMENT_ID, _this2.uiConfig);
        });
    };
    FirebaseAuth.prototype.componentWillUnmount = function componentWillUnmount() {
        var _this3 = this;
        $cbda6f697f1b91f9$var$firebaseUiDeletion = $cbda6f697f1b91f9$var$firebaseUiDeletion.then(function() {
            _this3.unregisterAuthObserver();
            return _this3.firebaseUiWidget.delete();
        });
        return $cbda6f697f1b91f9$var$firebaseUiDeletion;
    };
    FirebaseAuth.prototype.render = function render() {
        return $cbda6f697f1b91f9$var$_react2.default.createElement("div", {
            className: this.className,
            id: $cbda6f697f1b91f9$var$ELEMENT_ID
        });
    };
    return FirebaseAuth;
}($cbda6f697f1b91f9$var$_react2.default.Component);
$cbda6f697f1b91f9$export$2e2bcd8739ae039 = $cbda6f697f1b91f9$var$FirebaseAuth;



var $8d6d590ee67b3da0$exports = {};

$parcel$export($8d6d590ee67b3da0$exports, "loginScreen", function () { return $8d6d590ee67b3da0$export$3f918d38a2b1f4aa; }, function (v) { return $8d6d590ee67b3da0$export$3f918d38a2b1f4aa = v; });
$parcel$export($8d6d590ee67b3da0$exports, "loginWrapper", function () { return $8d6d590ee67b3da0$export$d6c0fbe55d3a4d57; }, function (v) { return $8d6d590ee67b3da0$export$d6c0fbe55d3a4d57 = v; });
var $8d6d590ee67b3da0$export$3f918d38a2b1f4aa;
var $8d6d590ee67b3da0$export$d6c0fbe55d3a4d57;
$8d6d590ee67b3da0$export$3f918d38a2b1f4aa = `gAKfdW_loginScreen`;
$8d6d590ee67b3da0$export$d6c0fbe55d3a4d57 = `gAKfdW_loginWrapper`;


function $821d6aacb8743eb9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $821d6aacb8743eb9$var$StyleWrapper = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "er2786f0"
})({
    name: "17vrkpy",
    styles: '#firebaseui_container{button{color:var(--colors-primary);}button[type="submit"]{background-color:var(--colors-primary);color:white;}.mdl-shadow--2dp{box-shadow:none;}.firebaseui-textfield.mdl-textfield .firebaseui-label::after{background-color:var(--colors-primary);}}'
});
const $821d6aacb8743eb9$var$LoginScreen = ()=>{
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    if (userInfo.loggedIn === false) {
        const firebaseUIConfig = {
            // popup / redirect
            signInFlow: "popup",
            callbacks: {
                signInSuccessWithAuthResult: ()=>false
            },
            signInOptions: [
                (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).auth.EmailAuthProvider.PROVIDER_ID,
                {
                    provider: (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).auth.GoogleAuthProvider.PROVIDER_ID,
                    customParameters: {
                        // Forces account selection even when one account
                        // is available.
                        hd: "playgroundxyz.com"
                    }
                }
            ]
        };
        return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8d6d590ee67b3da0$exports))).loginScreen,
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8d6d590ee67b3da0$exports))).loginWrapper,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a43a80b4364d3d64$exports))),
                        alt: "login"
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("h1", {
                        children: "Please Login"
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("p", {
                        children: "Login with your GumGum Google Account to access the Creative Attention Tracker."
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($821d6aacb8743eb9$var$StyleWrapper, {
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cbda6f697f1b91f9$export$2e2bcd8739ae039), {
                            uiConfig: firebaseUIConfig,
                            firebaseAuth: (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).auth()
                        })
                    })
                ]
            })
        });
    }
};
var $821d6aacb8743eb9$export$2e2bcd8739ae039 = $821d6aacb8743eb9$var$LoginScreen;




var $lDSNw = parcelRequire("lDSNw");







var $ef4Zh = parcelRequire("ef4Zh");
const $0b21e37f51b583f7$export$19dbccc67153f737 = (Component)=>(props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ef4Zh))).createPortal(/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(Component, {
            ...props
        }), document.getElementById("alerts"));
    };
const $0b21e37f51b583f7$export$97f2a48bc6874b01 = (Component)=>(props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ef4Zh))).createPortal(/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(Component, {
            ...props
        }), document.getElementById("shoot"));
    };



parcelRequire("lDSNw");
function $165d2eb6edbb3186$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $165d2eb6edbb3186$var$InlineModalRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "e1esmgxn3"
})((props)=>props.isInline ? `

position: absolute;
right: 0;
  ` : "", " min-width:300px;transform:", (props)=>props.show ? "translateY(0)" : "translateY(-100vh)", ";opacity:", (props)=>props.show ? 1 : 0, ";padding:var(--space-3);border:solid 1px var(--colors-neutral-4);background:white;border-radius:var(--radii-0);z-index:9999;box-shadow:0px 13px 46px 0px rgba(0, 0, 0, 0.06);transition:opacity 0.1s ease-in-out;");
const $165d2eb6edbb3186$var$InlineModalBody = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "e1esmgxn2"
})({
    name: "te7fcj",
    styles: "display:flex;justify-content:space-between;flex-direction:column;gap:var(--space-3)"
});
const $165d2eb6edbb3186$var$InlineModalHeader = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("header", {
    target: "e1esmgxn1"
})({
    name: "1ui6xqd",
    styles: "color:var(--colors-neutral-0);border-bottom:1px solid var(--colors-neutral-4);margin-bottom:var(--space-3);display:flex;align-items:center"
});
const $165d2eb6edbb3186$var$InlineModalCloseSlot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "e1esmgxn0"
})({
    name: "1p68xaq",
    styles: "position:absolute;right:var(--space-1);top:var(--space-1)"
});
const $165d2eb6edbb3186$var$ShootBackdrop = (0, $0b21e37f51b583f7$export$97f2a48bc6874b01)((0, $92e14464bca0d6b4$export$2e2bcd8739ae039));
const $165d2eb6edbb3186$var$InlineModal = ({ show: show, handleClose: handleClose, title: title, children: children })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($165d2eb6edbb3186$var$ShootBackdrop, {
                show: show,
                clicked: handleClose,
                color: "none"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($165d2eb6edbb3186$var$InlineModalRoot, {
                show: show,
                isInline: true,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($165d2eb6edbb3186$var$InlineModalHeader, {
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                                type: "baseline",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($165d2eb6edbb3186$var$InlineModalCloseSlot, {
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b8a1238394860ec0$export$c25acd513dcc8062), {
                                    onClick: handleClose
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($165d2eb6edbb3186$var$InlineModalBody, {
                        children: children
                    })
                ]
            })
        ]
    });
};
var $165d2eb6edbb3186$export$2e2bcd8739ae039 = $165d2eb6edbb3186$var$InlineModal;







var $lDSNw = parcelRequire("lDSNw");
"use client";
function $ff6f3b7bb8b3fb4f$export$867b668ad7ef61e5(value) {
    const [isButton, setIsButton] = (0, $lDSNw.useState)(!value);
    const refCallback = (0, $lDSNw.useCallback)((node)=>{
        if (!node) return;
        setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return {
        ref: refCallback,
        type: type
    };
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $33d216fe4070af25$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $33d216fe4070af25$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $lDSNw.createContext)(defaultValue);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $lDSNw.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage != null ? errorMessage : $33d216fe4070af25$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}


"use client";
var [$b19f3fcc4b547227$export$85041a2bb9328e33, $b19f3fcc4b547227$export$749e21be8b14b968] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    strict: false,
    name: "ButtonGroupContext"
});


// src/utils/create-transform.ts
// src/index.ts
var $a223a0f4c9b3f9de$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $a223a0f4c9b3f9de$var$isDev() {
    return false;
}
function $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var $a223a0f4c9b3f9de$export$c106dd0671a0fc2d = (options)=>{
    const { condition: condition, message: message } = options;
    if (condition && $a223a0f4c9b3f9de$var$isDev()) console.warn(message);
};
function $a223a0f4c9b3f9de$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $a223a0f4c9b3f9de$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var $a223a0f4c9b3f9de$var$isFunction = (value)=>typeof value === "function";
var $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $a223a0f4c9b3f9de$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
function $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $a223a0f4c9b3f9de$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}



var $gHhSd = parcelRequire("gHhSd");
var $01a983b3ad87bd07$var$isImportant = (value)=>/!(important)?$/.test(value);
var $01a983b3ad87bd07$var$withoutImportant = (value)=>typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var $01a983b3ad87bd07$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        const valueStr = String(value);
        const important = $01a983b3ad87bd07$var$isImportant(valueStr);
        const valueWithoutImportant = $01a983b3ad87bd07$var$withoutImportant(valueStr);
        const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
        let transformed = (0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
        transformed = $01a983b3ad87bd07$var$withoutImportant(transformed);
        return important ? `${transformed} !important` : transformed;
    };
function $01a983b3ad87bd07$var$createTransform(options) {
    const { scale: scale, transform: transform2, compose: compose } = options;
    const fn = (value, theme)=>{
        var _a;
        const _value = $01a983b3ad87bd07$export$92f5bb613cffac78(scale, value)(theme);
        let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}
// src/utils/pipe.ts
var $01a983b3ad87bd07$var$pipe = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
// src/utils/prop-config.ts
function $01a983b3ad87bd07$var$toConfig(scale, transform2) {
    return (property)=>{
        const result = {
            property: property,
            scale: scale
        };
        result.transform = $01a983b3ad87bd07$var$createTransform({
            scale: scale,
            transform: transform2
        });
        return result;
    };
}
var $01a983b3ad87bd07$var$getRtl = ({ rtl: rtl, ltr: ltr })=>(theme)=>theme.direction === "rtl" ? rtl : ltr;
function $01a983b3ad87bd07$var$logical(options) {
    const { property: property, scale: scale, transform: transform2 } = options;
    return {
        scale: scale,
        property: $01a983b3ad87bd07$var$getRtl(property),
        transform: scale ? $01a983b3ad87bd07$var$createTransform({
            scale: scale,
            compose: transform2
        }) : transform2
    };
}
// src/utils/templates.ts
var $01a983b3ad87bd07$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $01a983b3ad87bd07$var$getTransformTemplate() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$01a983b3ad87bd07$var$transformTemplate
    ].join(" ");
}
function $01a983b3ad87bd07$var$getTransformGpuTemplate() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$01a983b3ad87bd07$var$transformTemplate
    ].join(" ");
}
var $01a983b3ad87bd07$var$filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
var $01a983b3ad87bd07$var$backdropFilterTemplate = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $01a983b3ad87bd07$var$getRingTemplate(value) {
    return {
        "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
        "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
        "--chakra-ring-width": value,
        boxShadow: [
            `var(--chakra-ring-offset-shadow)`,
            `var(--chakra-ring-shadow)`,
            `var(--chakra-shadow, 0 0 #0000)`
        ].join(", ")
    };
}
var $01a983b3ad87bd07$var$flexDirectionTemplate = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};
// src/utils/parse-gradient.ts
var $01a983b3ad87bd07$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
var $01a983b3ad87bd07$var$valueSet = new Set(Object.values($01a983b3ad87bd07$var$directionMap));
var $01a983b3ad87bd07$var$globalSet = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
var $01a983b3ad87bd07$var$trimSpace = (str)=>str.trim();
function $01a983b3ad87bd07$var$parseGradient(value, theme) {
    if (value == null || $01a983b3ad87bd07$var$globalSet.has(value)) return value;
    const prevent = $01a983b3ad87bd07$var$isCSSFunction(value) || $01a983b3ad87bd07$var$globalSet.has(value);
    if (!prevent) return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results == null ? void 0 : results[1];
    const values = results == null ? void 0 : results[2];
    if (!type || !values) return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map($01a983b3ad87bd07$var$trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0) return value;
    const direction = maybeDirection in $01a983b3ad87bd07$var$directionMap ? $01a983b3ad87bd07$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop)=>{
        if ($01a983b3ad87bd07$var$valueSet.has(stop)) return stop;
        const firstStop = stop.indexOf(" ");
        const [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        const _stopOrFunc = $01a983b3ad87bd07$var$isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
        const key = `colors.${_color}`;
        const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color2,
            ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [
                _stopOrFunc
            ]
        ].join(" ") : color2;
    });
    return `${_type}(${_values.join(", ")})`;
}
var $01a983b3ad87bd07$var$isCSSFunction = (value)=>{
    return typeof value === "string" && value.includes("(") && value.includes(")");
};
var $01a983b3ad87bd07$var$gradientTransform = (value, theme)=>$01a983b3ad87bd07$var$parseGradient(value, theme != null ? theme : {});
// src/utils/transform-functions.ts
function $01a983b3ad87bd07$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
var $01a983b3ad87bd07$var$analyzeCSSValue = (value)=>{
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
var $01a983b3ad87bd07$var$wrap = (str)=>(value)=>`${str}(${value})`;
var $01a983b3ad87bd07$var$transformFunctions = {
    filter (value) {
        return value !== "auto" ? value : $01a983b3ad87bd07$var$filterTemplate;
    },
    backdropFilter (value) {
        return value !== "auto" ? value : $01a983b3ad87bd07$var$backdropFilterTemplate;
    },
    ring (value) {
        return $01a983b3ad87bd07$var$getRingTemplate($01a983b3ad87bd07$var$transformFunctions.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return $01a983b3ad87bd07$var$getTransformTemplate();
        if (value === "auto-gpu") return $01a983b3ad87bd07$var$getTransformGpuTemplate();
        return value;
    },
    vh (value) {
        return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px (value) {
        if (value == null) return value;
        const { unitless: unitless } = $01a983b3ad87bd07$var$analyzeCSSValue(value);
        return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction (value) {
        return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float (value, theme) {
        const map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ($01a983b3ad87bd07$var$isCssVar(value) || value == null) return value;
        const unitless = typeof value === "string" && !value.endsWith("deg");
        return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: $01a983b3ad87bd07$var$gradientTransform,
    blur: $01a983b3ad87bd07$var$wrap("blur"),
    opacity: $01a983b3ad87bd07$var$wrap("opacity"),
    brightness: $01a983b3ad87bd07$var$wrap("brightness"),
    contrast: $01a983b3ad87bd07$var$wrap("contrast"),
    dropShadow: $01a983b3ad87bd07$var$wrap("drop-shadow"),
    grayscale: $01a983b3ad87bd07$var$wrap("grayscale"),
    hueRotate: $01a983b3ad87bd07$var$wrap("hue-rotate"),
    invert: $01a983b3ad87bd07$var$wrap("invert"),
    saturate: $01a983b3ad87bd07$var$wrap("saturate"),
    sepia: $01a983b3ad87bd07$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        const prevent = $01a983b3ad87bd07$var$isCSSFunction(value) || $01a983b3ad87bd07$var$globalSet.has(value);
        return !prevent ? `url(${value})` : value;
    },
    outline (value) {
        const isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        var _a;
        const { space: space2, divide: divide2 } = (_a = $01a983b3ad87bd07$var$flexDirectionTemplate[value]) != null ? _a : {};
        const result = {
            flexDirection: value
        };
        if (space2) result[space2] = 1;
        if (divide2) result[divide2] = 1;
        return result;
    }
};
// src/utils/index.ts
var $01a983b3ad87bd07$var$t = {
    borderWidths: $01a983b3ad87bd07$var$toConfig("borderWidths"),
    borderStyles: $01a983b3ad87bd07$var$toConfig("borderStyles"),
    colors: $01a983b3ad87bd07$var$toConfig("colors"),
    borders: $01a983b3ad87bd07$var$toConfig("borders"),
    gradients: $01a983b3ad87bd07$var$toConfig("gradients", $01a983b3ad87bd07$var$transformFunctions.gradient),
    radii: $01a983b3ad87bd07$var$toConfig("radii", $01a983b3ad87bd07$var$transformFunctions.px),
    space: $01a983b3ad87bd07$var$toConfig("space", $01a983b3ad87bd07$var$pipe($01a983b3ad87bd07$var$transformFunctions.vh, $01a983b3ad87bd07$var$transformFunctions.px)),
    spaceT: $01a983b3ad87bd07$var$toConfig("space", $01a983b3ad87bd07$var$pipe($01a983b3ad87bd07$var$transformFunctions.vh, $01a983b3ad87bd07$var$transformFunctions.px)),
    degreeT (property) {
        return {
            property: property,
            transform: $01a983b3ad87bd07$var$transformFunctions.degree
        };
    },
    prop (property, scale, transform2) {
        return {
            property: property,
            scale: scale,
            ...scale && {
                transform: $01a983b3ad87bd07$var$createTransform({
                    scale: scale,
                    transform: transform2
                })
            }
        };
    },
    propT (property, transform2) {
        return {
            property: property,
            transform: transform2
        };
    },
    sizes: $01a983b3ad87bd07$var$toConfig("sizes", $01a983b3ad87bd07$var$pipe($01a983b3ad87bd07$var$transformFunctions.vh, $01a983b3ad87bd07$var$transformFunctions.px)),
    sizesT: $01a983b3ad87bd07$var$toConfig("sizes", $01a983b3ad87bd07$var$pipe($01a983b3ad87bd07$var$transformFunctions.vh, $01a983b3ad87bd07$var$transformFunctions.fraction)),
    shadows: $01a983b3ad87bd07$var$toConfig("shadows"),
    logical: $01a983b3ad87bd07$var$logical,
    blur: $01a983b3ad87bd07$var$toConfig("blur", $01a983b3ad87bd07$var$transformFunctions.blur)
};
// src/config/background.ts
var $01a983b3ad87bd07$export$8ce1fd94bee2f412 = {
    background: $01a983b3ad87bd07$var$t.colors("background"),
    backgroundColor: $01a983b3ad87bd07$var$t.colors("backgroundColor"),
    backgroundImage: $01a983b3ad87bd07$var$t.gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: $01a983b3ad87bd07$var$transformFunctions.bgClip
    },
    bgSize: $01a983b3ad87bd07$var$t.prop("backgroundSize"),
    bgPosition: $01a983b3ad87bd07$var$t.prop("backgroundPosition"),
    bg: $01a983b3ad87bd07$var$t.colors("background"),
    bgColor: $01a983b3ad87bd07$var$t.colors("backgroundColor"),
    bgPos: $01a983b3ad87bd07$var$t.prop("backgroundPosition"),
    bgRepeat: $01a983b3ad87bd07$var$t.prop("backgroundRepeat"),
    bgAttachment: $01a983b3ad87bd07$var$t.prop("backgroundAttachment"),
    bgGradient: $01a983b3ad87bd07$var$t.gradients("backgroundImage"),
    bgClip: {
        transform: $01a983b3ad87bd07$var$transformFunctions.bgClip
    }
};
Object.assign($01a983b3ad87bd07$export$8ce1fd94bee2f412, {
    bgImage: $01a983b3ad87bd07$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $01a983b3ad87bd07$export$8ce1fd94bee2f412.backgroundImage
});
// src/config/border.ts
var $01a983b3ad87bd07$export$1edee58a52776cd9 = {
    border: $01a983b3ad87bd07$var$t.borders("border"),
    borderWidth: $01a983b3ad87bd07$var$t.borderWidths("borderWidth"),
    borderStyle: $01a983b3ad87bd07$var$t.borderStyles("borderStyle"),
    borderColor: $01a983b3ad87bd07$var$t.colors("borderColor"),
    borderRadius: $01a983b3ad87bd07$var$t.radii("borderRadius"),
    borderTop: $01a983b3ad87bd07$var$t.borders("borderTop"),
    borderBlockStart: $01a983b3ad87bd07$var$t.borders("borderBlockStart"),
    borderTopLeftRadius: $01a983b3ad87bd07$var$t.radii("borderTopLeftRadius"),
    borderStartStartRadius: $01a983b3ad87bd07$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: $01a983b3ad87bd07$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: $01a983b3ad87bd07$var$t.radii("borderTopRightRadius"),
    borderStartEndRadius: $01a983b3ad87bd07$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: $01a983b3ad87bd07$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: $01a983b3ad87bd07$var$t.borders("borderRight"),
    borderInlineEnd: $01a983b3ad87bd07$var$t.borders("borderInlineEnd"),
    borderBottom: $01a983b3ad87bd07$var$t.borders("borderBottom"),
    borderBlockEnd: $01a983b3ad87bd07$var$t.borders("borderBlockEnd"),
    borderBottomLeftRadius: $01a983b3ad87bd07$var$t.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: $01a983b3ad87bd07$var$t.radii("borderBottomRightRadius"),
    borderLeft: $01a983b3ad87bd07$var$t.borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: $01a983b3ad87bd07$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: $01a983b3ad87bd07$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: $01a983b3ad87bd07$var$t.borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: $01a983b3ad87bd07$var$t.borders("borderInline"),
    borderY: $01a983b3ad87bd07$var$t.borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: $01a983b3ad87bd07$var$t.borders("borderBlock"),
    borderTopWidth: $01a983b3ad87bd07$var$t.borderWidths("borderTopWidth"),
    borderBlockStartWidth: $01a983b3ad87bd07$var$t.borderWidths("borderBlockStartWidth"),
    borderTopColor: $01a983b3ad87bd07$var$t.colors("borderTopColor"),
    borderBlockStartColor: $01a983b3ad87bd07$var$t.colors("borderBlockStartColor"),
    borderTopStyle: $01a983b3ad87bd07$var$t.borderStyles("borderTopStyle"),
    borderBlockStartStyle: $01a983b3ad87bd07$var$t.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: $01a983b3ad87bd07$var$t.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: $01a983b3ad87bd07$var$t.borderWidths("borderBlockEndWidth"),
    borderBottomColor: $01a983b3ad87bd07$var$t.colors("borderBottomColor"),
    borderBlockEndColor: $01a983b3ad87bd07$var$t.colors("borderBlockEndColor"),
    borderBottomStyle: $01a983b3ad87bd07$var$t.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: $01a983b3ad87bd07$var$t.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: $01a983b3ad87bd07$var$t.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: $01a983b3ad87bd07$var$t.borderWidths("borderInlineStartWidth"),
    borderLeftColor: $01a983b3ad87bd07$var$t.colors("borderLeftColor"),
    borderInlineStartColor: $01a983b3ad87bd07$var$t.colors("borderInlineStartColor"),
    borderLeftStyle: $01a983b3ad87bd07$var$t.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: $01a983b3ad87bd07$var$t.borderStyles("borderInlineStartStyle"),
    borderRightWidth: $01a983b3ad87bd07$var$t.borderWidths("borderRightWidth"),
    borderInlineEndWidth: $01a983b3ad87bd07$var$t.borderWidths("borderInlineEndWidth"),
    borderRightColor: $01a983b3ad87bd07$var$t.colors("borderRightColor"),
    borderInlineEndColor: $01a983b3ad87bd07$var$t.colors("borderInlineEndColor"),
    borderRightStyle: $01a983b3ad87bd07$var$t.borderStyles("borderRightStyle"),
    borderInlineEndStyle: $01a983b3ad87bd07$var$t.borderStyles("borderInlineEndStyle"),
    borderTopRadius: $01a983b3ad87bd07$var$t.radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: $01a983b3ad87bd07$var$t.radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: $01a983b3ad87bd07$var$t.radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: $01a983b3ad87bd07$var$t.radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($01a983b3ad87bd07$export$1edee58a52776cd9, {
    rounded: $01a983b3ad87bd07$export$1edee58a52776cd9.borderRadius,
    roundedTop: $01a983b3ad87bd07$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $01a983b3ad87bd07$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $01a983b3ad87bd07$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $01a983b3ad87bd07$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $01a983b3ad87bd07$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $01a983b3ad87bd07$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $01a983b3ad87bd07$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $01a983b3ad87bd07$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $01a983b3ad87bd07$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $01a983b3ad87bd07$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $01a983b3ad87bd07$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $01a983b3ad87bd07$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $01a983b3ad87bd07$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $01a983b3ad87bd07$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $01a983b3ad87bd07$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $01a983b3ad87bd07$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $01a983b3ad87bd07$export$1edee58a52776cd9.borderInlineEndStyle
});
// src/config/color.ts
var $01a983b3ad87bd07$export$35e9368ef982300f = {
    color: $01a983b3ad87bd07$var$t.colors("color"),
    textColor: $01a983b3ad87bd07$var$t.colors("color"),
    fill: $01a983b3ad87bd07$var$t.colors("fill"),
    stroke: $01a983b3ad87bd07$var$t.colors("stroke")
};
// src/config/effect.ts
var $01a983b3ad87bd07$export$dc573d8a6576cdb3 = {
    boxShadow: $01a983b3ad87bd07$var$t.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: $01a983b3ad87bd07$var$t.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: $01a983b3ad87bd07$var$t.prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($01a983b3ad87bd07$export$dc573d8a6576cdb3, {
    shadow: $01a983b3ad87bd07$export$dc573d8a6576cdb3.boxShadow
});
// src/config/filter.ts
var $01a983b3ad87bd07$export$3dea766d36a8935f = {
    filter: {
        transform: $01a983b3ad87bd07$var$transformFunctions.filter
    },
    blur: $01a983b3ad87bd07$var$t.blur("--chakra-blur"),
    brightness: $01a983b3ad87bd07$var$t.propT("--chakra-brightness", $01a983b3ad87bd07$var$transformFunctions.brightness),
    contrast: $01a983b3ad87bd07$var$t.propT("--chakra-contrast", $01a983b3ad87bd07$var$transformFunctions.contrast),
    hueRotate: $01a983b3ad87bd07$var$t.degreeT("--chakra-hue-rotate"),
    invert: $01a983b3ad87bd07$var$t.propT("--chakra-invert", $01a983b3ad87bd07$var$transformFunctions.invert),
    saturate: $01a983b3ad87bd07$var$t.propT("--chakra-saturate", $01a983b3ad87bd07$var$transformFunctions.saturate),
    dropShadow: $01a983b3ad87bd07$var$t.propT("--chakra-drop-shadow", $01a983b3ad87bd07$var$transformFunctions.dropShadow),
    backdropFilter: {
        transform: $01a983b3ad87bd07$var$transformFunctions.backdropFilter
    },
    backdropBlur: $01a983b3ad87bd07$var$t.blur("--chakra-backdrop-blur"),
    backdropBrightness: $01a983b3ad87bd07$var$t.propT("--chakra-backdrop-brightness", $01a983b3ad87bd07$var$transformFunctions.brightness),
    backdropContrast: $01a983b3ad87bd07$var$t.propT("--chakra-backdrop-contrast", $01a983b3ad87bd07$var$transformFunctions.contrast),
    backdropHueRotate: $01a983b3ad87bd07$var$t.degreeT("--chakra-backdrop-hue-rotate"),
    backdropInvert: $01a983b3ad87bd07$var$t.propT("--chakra-backdrop-invert", $01a983b3ad87bd07$var$transformFunctions.invert),
    backdropSaturate: $01a983b3ad87bd07$var$t.propT("--chakra-backdrop-saturate", $01a983b3ad87bd07$var$transformFunctions.saturate)
};
// src/config/flexbox.ts
var $01a983b3ad87bd07$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: $01a983b3ad87bd07$var$transformFunctions.flexDirection
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: $01a983b3ad87bd07$var$t.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: $01a983b3ad87bd07$var$t.space("gap"),
    rowGap: $01a983b3ad87bd07$var$t.space("rowGap"),
    columnGap: $01a983b3ad87bd07$var$t.space("columnGap")
};
Object.assign($01a983b3ad87bd07$export$feec61708a55c80e, {
    flexDir: $01a983b3ad87bd07$export$feec61708a55c80e.flexDirection
});
// src/config/grid.ts
var $01a983b3ad87bd07$export$85fc379452d91af0 = {
    gridGap: $01a983b3ad87bd07$var$t.space("gridGap"),
    gridColumnGap: $01a983b3ad87bd07$var$t.space("gridColumnGap"),
    gridRowGap: $01a983b3ad87bd07$var$t.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};
// src/config/interactivity.ts
var $01a983b3ad87bd07$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: $01a983b3ad87bd07$var$transformFunctions.outline
    },
    outlineOffset: true,
    outlineColor: $01a983b3ad87bd07$var$t.colors("outlineColor")
};
// src/config/layout.ts
var $01a983b3ad87bd07$export$b3219800bda33a1f = {
    width: $01a983b3ad87bd07$var$t.sizesT("width"),
    inlineSize: $01a983b3ad87bd07$var$t.sizesT("inlineSize"),
    height: $01a983b3ad87bd07$var$t.sizes("height"),
    blockSize: $01a983b3ad87bd07$var$t.sizes("blockSize"),
    boxSize: $01a983b3ad87bd07$var$t.sizes([
        "width",
        "height"
    ]),
    minWidth: $01a983b3ad87bd07$var$t.sizes("minWidth"),
    minInlineSize: $01a983b3ad87bd07$var$t.sizes("minInlineSize"),
    minHeight: $01a983b3ad87bd07$var$t.sizes("minHeight"),
    minBlockSize: $01a983b3ad87bd07$var$t.sizes("minBlockSize"),
    maxWidth: $01a983b3ad87bd07$var$t.sizes("maxWidth"),
    maxInlineSize: $01a983b3ad87bd07$var$t.sizes("maxInlineSize"),
    maxHeight: $01a983b3ad87bd07$var$t.sizes("maxHeight"),
    maxBlockSize: $01a983b3ad87bd07$var$t.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
            const mq = `@media screen and (min-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
            const mq = `@media screen and (max-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: $01a983b3ad87bd07$var$t.propT("float", $01a983b3ad87bd07$var$transformFunctions.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($01a983b3ad87bd07$export$b3219800bda33a1f, {
    w: $01a983b3ad87bd07$export$b3219800bda33a1f.width,
    h: $01a983b3ad87bd07$export$b3219800bda33a1f.height,
    minW: $01a983b3ad87bd07$export$b3219800bda33a1f.minWidth,
    maxW: $01a983b3ad87bd07$export$b3219800bda33a1f.maxWidth,
    minH: $01a983b3ad87bd07$export$b3219800bda33a1f.minHeight,
    maxH: $01a983b3ad87bd07$export$b3219800bda33a1f.maxHeight,
    overscroll: $01a983b3ad87bd07$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $01a983b3ad87bd07$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $01a983b3ad87bd07$export$b3219800bda33a1f.overscrollBehaviorY
});
// src/config/list.ts
var $01a983b3ad87bd07$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: $01a983b3ad87bd07$var$t.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: $01a983b3ad87bd07$var$t.prop("listStyleImage")
};
// src/get.ts
function $01a983b3ad87bd07$var$get(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $01a983b3ad87bd07$var$memoize = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $01a983b3ad87bd07$var$memoizedGet = $01a983b3ad87bd07$var$memoize($01a983b3ad87bd07$var$get);
// src/config/others.ts
var $01a983b3ad87bd07$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $01a983b3ad87bd07$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
var $01a983b3ad87bd07$var$getWithPriority = (theme, key, styles)=>{
    const result = {};
    const obj = $01a983b3ad87bd07$var$memoizedGet(theme, key, {});
    for(const prop in obj){
        const isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
var $01a983b3ad87bd07$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $01a983b3ad87bd07$var$srOnly;
            if (value === "focusable") return $01a983b3ad87bd07$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$01a983b3ad87bd07$var$getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$01a983b3ad87bd07$var$getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$01a983b3ad87bd07$var$getWithPriority(theme, value, styles)
    }
};
// src/config/position.ts
var $01a983b3ad87bd07$export$5880b8b5730aff45 = {
    position: true,
    pos: $01a983b3ad87bd07$var$t.prop("position"),
    zIndex: $01a983b3ad87bd07$var$t.prop("zIndex", "zIndices"),
    inset: $01a983b3ad87bd07$var$t.spaceT("inset"),
    insetX: $01a983b3ad87bd07$var$t.spaceT([
        "left",
        "right"
    ]),
    insetInline: $01a983b3ad87bd07$var$t.spaceT("insetInline"),
    insetY: $01a983b3ad87bd07$var$t.spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: $01a983b3ad87bd07$var$t.spaceT("insetBlock"),
    top: $01a983b3ad87bd07$var$t.spaceT("top"),
    insetBlockStart: $01a983b3ad87bd07$var$t.spaceT("insetBlockStart"),
    bottom: $01a983b3ad87bd07$var$t.spaceT("bottom"),
    insetBlockEnd: $01a983b3ad87bd07$var$t.spaceT("insetBlockEnd"),
    left: $01a983b3ad87bd07$var$t.spaceT("left"),
    insetInlineStart: $01a983b3ad87bd07$var$t.logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: $01a983b3ad87bd07$var$t.spaceT("right"),
    insetInlineEnd: $01a983b3ad87bd07$var$t.logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($01a983b3ad87bd07$export$5880b8b5730aff45, {
    insetStart: $01a983b3ad87bd07$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $01a983b3ad87bd07$export$5880b8b5730aff45.insetInlineEnd
});
// src/config/ring.ts
var $01a983b3ad87bd07$export$e7d0da6968da5dd = {
    ring: {
        transform: $01a983b3ad87bd07$var$transformFunctions.ring
    },
    ringColor: $01a983b3ad87bd07$var$t.colors("--chakra-ring-color"),
    ringOffset: $01a983b3ad87bd07$var$t.prop("--chakra-ring-offset-width"),
    ringOffsetColor: $01a983b3ad87bd07$var$t.colors("--chakra-ring-offset-color"),
    ringInset: $01a983b3ad87bd07$var$t.prop("--chakra-ring-inset")
};
// src/config/space.ts
var $01a983b3ad87bd07$export$a941ed4b947d12f8 = {
    margin: $01a983b3ad87bd07$var$t.spaceT("margin"),
    marginTop: $01a983b3ad87bd07$var$t.spaceT("marginTop"),
    marginBlockStart: $01a983b3ad87bd07$var$t.spaceT("marginBlockStart"),
    marginRight: $01a983b3ad87bd07$var$t.spaceT("marginRight"),
    marginInlineEnd: $01a983b3ad87bd07$var$t.spaceT("marginInlineEnd"),
    marginBottom: $01a983b3ad87bd07$var$t.spaceT("marginBottom"),
    marginBlockEnd: $01a983b3ad87bd07$var$t.spaceT("marginBlockEnd"),
    marginLeft: $01a983b3ad87bd07$var$t.spaceT("marginLeft"),
    marginInlineStart: $01a983b3ad87bd07$var$t.spaceT("marginInlineStart"),
    marginX: $01a983b3ad87bd07$var$t.spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: $01a983b3ad87bd07$var$t.spaceT("marginInline"),
    marginY: $01a983b3ad87bd07$var$t.spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: $01a983b3ad87bd07$var$t.spaceT("marginBlock"),
    padding: $01a983b3ad87bd07$var$t.space("padding"),
    paddingTop: $01a983b3ad87bd07$var$t.space("paddingTop"),
    paddingBlockStart: $01a983b3ad87bd07$var$t.space("paddingBlockStart"),
    paddingRight: $01a983b3ad87bd07$var$t.space("paddingRight"),
    paddingBottom: $01a983b3ad87bd07$var$t.space("paddingBottom"),
    paddingBlockEnd: $01a983b3ad87bd07$var$t.space("paddingBlockEnd"),
    paddingLeft: $01a983b3ad87bd07$var$t.space("paddingLeft"),
    paddingInlineStart: $01a983b3ad87bd07$var$t.space("paddingInlineStart"),
    paddingInlineEnd: $01a983b3ad87bd07$var$t.space("paddingInlineEnd"),
    paddingX: $01a983b3ad87bd07$var$t.space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: $01a983b3ad87bd07$var$t.space("paddingInline"),
    paddingY: $01a983b3ad87bd07$var$t.space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: $01a983b3ad87bd07$var$t.space("paddingBlock")
};
Object.assign($01a983b3ad87bd07$export$a941ed4b947d12f8, {
    m: $01a983b3ad87bd07$export$a941ed4b947d12f8.margin,
    mt: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginTop,
    mr: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginRight,
    me: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginBottom,
    ml: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginLeft,
    ms: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginInlineStart,
    mx: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginX,
    my: $01a983b3ad87bd07$export$a941ed4b947d12f8.marginY,
    p: $01a983b3ad87bd07$export$a941ed4b947d12f8.padding,
    pt: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingTop,
    py: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingY,
    px: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingX,
    pb: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingBottom,
    pl: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingLeft,
    ps: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingRight,
    pe: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $01a983b3ad87bd07$export$a941ed4b947d12f8.paddingInlineEnd
});
// src/config/text-decoration.ts
var $01a983b3ad87bd07$export$6b7f9af9aa033040 = {
    textDecorationColor: $01a983b3ad87bd07$var$t.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: $01a983b3ad87bd07$var$t.shadows("textShadow")
};
// src/config/transform.ts
var $01a983b3ad87bd07$export$51186ad6e864892a = {
    clipPath: true,
    transform: $01a983b3ad87bd07$var$t.propT("transform", $01a983b3ad87bd07$var$transformFunctions.transform),
    transformOrigin: true,
    translateX: $01a983b3ad87bd07$var$t.spaceT("--chakra-translate-x"),
    translateY: $01a983b3ad87bd07$var$t.spaceT("--chakra-translate-y"),
    skewX: $01a983b3ad87bd07$var$t.degreeT("--chakra-skew-x"),
    skewY: $01a983b3ad87bd07$var$t.degreeT("--chakra-skew-y"),
    scaleX: $01a983b3ad87bd07$var$t.prop("--chakra-scale-x"),
    scaleY: $01a983b3ad87bd07$var$t.prop("--chakra-scale-y"),
    scale: $01a983b3ad87bd07$var$t.prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: $01a983b3ad87bd07$var$t.degreeT("--chakra-rotate")
};
// src/config/transition.ts
var $01a983b3ad87bd07$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: $01a983b3ad87bd07$var$t.prop("transitionDuration", "transition.duration"),
    transitionProperty: $01a983b3ad87bd07$var$t.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: $01a983b3ad87bd07$var$t.prop("transitionTimingFunction", "transition.easing")
};
// src/config/typography.ts
var $01a983b3ad87bd07$export$d846a084e680d8e = {
    fontFamily: $01a983b3ad87bd07$var$t.prop("fontFamily", "fonts"),
    fontSize: $01a983b3ad87bd07$var$t.prop("fontSize", "fontSizes", $01a983b3ad87bd07$var$transformFunctions.px),
    fontWeight: $01a983b3ad87bd07$var$t.prop("fontWeight", "fontWeights"),
    lineHeight: $01a983b3ad87bd07$var$t.prop("lineHeight", "lineHeights"),
    letterSpacing: $01a983b3ad87bd07$var$t.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
};
// src/config/scroll.ts
var $01a983b3ad87bd07$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    scrollMargin: $01a983b3ad87bd07$var$t.spaceT("scrollMargin"),
    scrollMarginTop: $01a983b3ad87bd07$var$t.spaceT("scrollMarginTop"),
    scrollMarginBottom: $01a983b3ad87bd07$var$t.spaceT("scrollMarginBottom"),
    scrollMarginLeft: $01a983b3ad87bd07$var$t.spaceT("scrollMarginLeft"),
    scrollMarginRight: $01a983b3ad87bd07$var$t.spaceT("scrollMarginRight"),
    scrollMarginX: $01a983b3ad87bd07$var$t.spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: $01a983b3ad87bd07$var$t.spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    scrollPadding: $01a983b3ad87bd07$var$t.spaceT("scrollPadding"),
    scrollPaddingTop: $01a983b3ad87bd07$var$t.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: $01a983b3ad87bd07$var$t.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: $01a983b3ad87bd07$var$t.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: $01a983b3ad87bd07$var$t.spaceT("scrollPaddingRight"),
    scrollPaddingX: $01a983b3ad87bd07$var$t.spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: $01a983b3ad87bd07$var$t.spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};
function $01a983b3ad87bd07$var$resolveReference(operand) {
    if ((0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $01a983b3ad87bd07$var$toExpression = (operator, ...operands)=>operands.map($01a983b3ad87bd07$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
var $01a983b3ad87bd07$var$add = (...operands)=>`calc(${$01a983b3ad87bd07$var$toExpression("+", ...operands)})`;
var $01a983b3ad87bd07$var$subtract = (...operands)=>`calc(${$01a983b3ad87bd07$var$toExpression("-", ...operands)})`;
var $01a983b3ad87bd07$var$multiply = (...operands)=>`calc(${$01a983b3ad87bd07$var$toExpression("*", ...operands)})`;
var $01a983b3ad87bd07$var$divide = (...operands)=>`calc(${$01a983b3ad87bd07$var$toExpression("/", ...operands)})`;
var $01a983b3ad87bd07$var$negate = (x)=>{
    const value = $01a983b3ad87bd07$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $01a983b3ad87bd07$var$multiply(value, -1);
};
var $01a983b3ad87bd07$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$01a983b3ad87bd07$export$42bfa9b2d4dad91a($01a983b3ad87bd07$var$add(x, ...operands)),
        subtract: (...operands)=>$01a983b3ad87bd07$export$42bfa9b2d4dad91a($01a983b3ad87bd07$var$subtract(x, ...operands)),
        multiply: (...operands)=>$01a983b3ad87bd07$export$42bfa9b2d4dad91a($01a983b3ad87bd07$var$multiply(x, ...operands)),
        divide: (...operands)=>$01a983b3ad87bd07$export$42bfa9b2d4dad91a($01a983b3ad87bd07$var$divide(x, ...operands)),
        negate: ()=>$01a983b3ad87bd07$export$42bfa9b2d4dad91a($01a983b3ad87bd07$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $01a983b3ad87bd07$var$add,
    subtract: $01a983b3ad87bd07$var$subtract,
    multiply: $01a983b3ad87bd07$var$multiply,
    divide: $01a983b3ad87bd07$var$divide,
    negate: $01a983b3ad87bd07$var$negate
});
// src/create-theme-vars/css-var.ts
function $01a983b3ad87bd07$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $01a983b3ad87bd07$var$escape(value) {
    const valueStr = $01a983b3ad87bd07$var$replaceWhiteSpace(value.toString());
    return $01a983b3ad87bd07$var$escapeSymbol($01a983b3ad87bd07$var$escapeDot(valueStr));
}
function $01a983b3ad87bd07$var$escapeDot(value) {
    if (value.includes("\\.")) return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
}
function $01a983b3ad87bd07$var$escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function $01a983b3ad87bd07$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        value
    ].filter(Boolean).join("-");
}
function $01a983b3ad87bd07$export$bb435e137b4b8e38(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function $01a983b3ad87bd07$export$3695bd65cc73dae9(value, prefix = "") {
    return $01a983b3ad87bd07$var$escape(`--${$01a983b3ad87bd07$export$9748efee331ec573(value, prefix)}`);
}
function $01a983b3ad87bd07$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    const cssVariable = $01a983b3ad87bd07$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $01a983b3ad87bd07$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
function $01a983b3ad87bd07$export$bd40561c6c056841(scope, keys2) {
    const vars = {};
    for (const key of keys2){
        if (Array.isArray(key)) {
            const [name, fallback] = key;
            vars[name] = $01a983b3ad87bd07$export$8b4981022bd80a4e(`${scope}-${name}`, fallback);
            continue;
        }
        vars[key] = $01a983b3ad87bd07$export$8b4981022bd80a4e(`${scope}-${key}`);
    }
    return vars;
}
function $01a983b3ad87bd07$var$getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
function $01a983b3ad87bd07$var$analyzeCSSValue2(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $01a983b3ad87bd07$var$px(value) {
    if (value == null) return value;
    const { unitless: unitless } = $01a983b3ad87bd07$var$analyzeCSSValue2(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
}
var $01a983b3ad87bd07$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var $01a983b3ad87bd07$var$sortBps = (breakpoints)=>Object.fromEntries(Object.entries(breakpoints).sort($01a983b3ad87bd07$var$sortByBreakpointValue));
function $01a983b3ad87bd07$var$normalize(breakpoints) {
    const sorted = $01a983b3ad87bd07$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $01a983b3ad87bd07$var$keys(breakpoints) {
    const value = Object.keys($01a983b3ad87bd07$var$sortBps(breakpoints));
    return new Set(value);
}
function $01a983b3ad87bd07$var$subtract2(value) {
    var _a;
    if (!value) return value;
    value = (_a = $01a983b3ad87bd07$var$px(value)) != null ? _a : value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m)=>`${parseFloat(m) + OFFSET}`);
}
function $01a983b3ad87bd07$var$toMediaQueryString(min, max) {
    const query = [
        "@media screen"
    ];
    if (min) query.push("and", `(min-width: ${$01a983b3ad87bd07$var$px(min)})`);
    if (max) query.push("and", `(max-width: ${$01a983b3ad87bd07$var$px(max)})`);
    return query.join(" ");
}
function $01a983b3ad87bd07$var$analyzeBreakpoints(breakpoints) {
    var _a;
    if (!breakpoints) return null;
    breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
    const normalized = $01a983b3ad87bd07$var$normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort($01a983b3ad87bd07$var$sortByBreakpointValue).map(([breakpoint, minW], index, entry)=>{
        var _a2;
        let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
        maxW = parseFloat(maxW) > 0 ? $01a983b3ad87bd07$var$subtract2(maxW) : void 0;
        return {
            _minW: $01a983b3ad87bd07$var$subtract2(minW),
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $01a983b3ad87bd07$var$toMediaQueryString(null, maxW),
            minWQuery: $01a983b3ad87bd07$var$toMediaQueryString(minW),
            minMaxQuery: $01a983b3ad87bd07$var$toMediaQueryString(minW, maxW)
        };
    });
    const _keys = $01a983b3ad87bd07$var$keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            const keys2 = Object.keys(test);
            return keys2.length > 0 && keys2.every((key)=>_keys.has(key));
        },
        asObject: $01a983b3ad87bd07$var$sortBps(breakpoints),
        asArray: $01a983b3ad87bd07$var$normalize(breakpoints),
        details: queries,
        get (key) {
            return queries.find((q)=>q.breakpoint === key);
        },
        media: [
            null,
            ...normalized.map((minW)=>$01a983b3ad87bd07$var$toMediaQueryString(minW)).slice(1)
        ],
        toArrayValue (test) {
            if (!(0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(test)) throw new Error("toArrayValue: value must be an object");
            const result = _keysArr.map((bp)=>{
                var _a2;
                return (_a2 = test[bp]) != null ? _a2 : null;
            });
            while($01a983b3ad87bd07$var$getLastItem(result) === null)result.pop();
            return result;
        },
        toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                const key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
// src/pseudos.ts
var $01a983b3ad87bd07$var$state = {
    hover: (str, post)=>`${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post)=>`${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post)=>`${str}:focus-visible ${post}`,
    focusWithin: (str, post)=>`${str}:focus-within ${post}`,
    active: (str, post)=>`${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post)=>`${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post)=>`${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post)=>`${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post)=>`${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post)=>`${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post)=>`${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post)=>`${str}:placeholder-shown ${post}`
};
var $01a983b3ad87bd07$var$toGroup = (fn)=>$01a983b3ad87bd07$var$merge((v)=>fn(v, "&"), "[role=group]", "[data-group]", ".group");
var $01a983b3ad87bd07$var$toPeer = (fn)=>$01a983b3ad87bd07$var$merge((v)=>fn(v, "~ &"), "[data-peer]", ".peer");
var $01a983b3ad87bd07$var$merge = (fn, ...selectors)=>selectors.map(fn).join(", ");
var $01a983b3ad87bd07$export$a36cf593fde2a546 = {
    _hover: "&:hover, &[data-hover]",
    _active: "&:active, &[data-active]",
    _focus: "&:focus, &[data-focus]",
    _highlighted: "&[data-highlighted]",
    _focusWithin: "&:focus-within",
    _focusVisible: "&:focus-visible, &[data-focus-visible]",
    _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    _before: "&::before",
    _after: "&::after",
    _empty: "&:empty",
    _expanded: "&[aria-expanded=true], &[data-expanded]",
    _checked: "&[aria-checked=true], &[data-checked]",
    _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    _pressed: "&[aria-pressed=true], &[data-pressed]",
    _invalid: "&[aria-invalid=true], &[data-invalid]",
    _valid: "&[data-valid], &[data-state=valid]",
    _loading: "&[data-loading], &[aria-busy=true]",
    _selected: "&[aria-selected=true], &[data-selected]",
    _hidden: "&[hidden], &[data-hidden]",
    _autofill: "&:-webkit-autofill",
    _even: "&:nth-of-type(even)",
    _odd: "&:nth-of-type(odd)",
    _first: "&:first-of-type",
    _firstLetter: "&::first-letter",
    _last: "&:last-of-type",
    _notFirst: "&:not(:first-of-type)",
    _notLast: "&:not(:last-of-type)",
    _visited: "&:visited",
    _activeLink: "&[aria-current=page]",
    _activeStep: "&[aria-current=step]",
    _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    _groupHover: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.hover),
    _peerHover: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.hover),
    _groupFocus: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.focus),
    _peerFocus: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.focus),
    _groupFocusVisible: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.focusVisible),
    _peerFocusVisible: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.focusVisible),
    _groupActive: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.active),
    _peerActive: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.active),
    _groupDisabled: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.disabled),
    _peerDisabled: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.disabled),
    _groupInvalid: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.invalid),
    _peerInvalid: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.invalid),
    _groupChecked: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.checked),
    _peerChecked: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.checked),
    _groupFocusWithin: $01a983b3ad87bd07$var$toGroup($01a983b3ad87bd07$var$state.focusWithin),
    _peerFocusWithin: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.focusWithin),
    _peerPlaceholderShown: $01a983b3ad87bd07$var$toPeer($01a983b3ad87bd07$var$state.placeholderShown),
    _placeholder: "&::placeholder",
    _placeholderShown: "&:placeholder-shown",
    _fullScreen: "&:fullscreen",
    _selection: "&::selection",
    _rtl: "[dir=rtl] &, &[dir=rtl]",
    _ltr: "[dir=ltr] &, &[dir=ltr]",
    _mediaDark: "@media (prefers-color-scheme: dark)",
    _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    _horizontal: "&[data-orientation=horizontal]",
    _vertical: "&[data-orientation=vertical]"
};
var $01a983b3ad87bd07$export$4ec9644154df43c2 = Object.keys($01a983b3ad87bd07$export$a36cf593fde2a546);
function $01a983b3ad87bd07$var$tokenToCssVar(token, prefix) {
    return $01a983b3ad87bd07$export$8b4981022bd80a4e(String(token).replace(/\./g, "-"), void 0, prefix);
}
function $01a983b3ad87bd07$var$createThemeVars(flatTokens, options) {
    let cssVars = {};
    const cssMap = {};
    for (const [token, tokenValue] of Object.entries(flatTokens)){
        const { isSemantic: isSemantic, value: value } = tokenValue;
        const { variable: variable, reference: reference } = $01a983b3ad87bd07$var$tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
        if (!isSemantic) {
            if (token.startsWith("space")) {
                const keys2 = token.split(".");
                const [firstKey, ...referenceKeys] = keys2;
                const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
                const negativeValue = $01a983b3ad87bd07$export$42bfa9b2d4dad91a.negate(value);
                const negatedReference = $01a983b3ad87bd07$export$42bfa9b2d4dad91a.negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    var: variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                var: variable,
                varRef: reference
            };
            continue;
        }
        const lookupToken = (maybeToken)=>{
            const scale = String(token).split(".")[0];
            const withScale = [
                scale,
                maybeToken
            ].join(".");
            const resolvedTokenValue = flatTokens[withScale];
            if (!resolvedTokenValue) return maybeToken;
            const { reference: reference2 } = $01a983b3ad87bd07$var$tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
            return reference2;
        };
        const normalizedValue = (0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(value) ? value : {
            default: value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))(cssVars, Object.entries(normalizedValue).reduce((acc, [conditionAlias, conditionValue])=>{
            var _a, _b;
            if (!conditionValue) return acc;
            const tokenReference = lookupToken(`${conditionValue}`);
            if (conditionAlias === "default") {
                acc[variable] = tokenReference;
                return acc;
            }
            const conditionSelector = (_b = (_a = $01a983b3ad87bd07$export$a36cf593fde2a546) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
            acc[conditionSelector] = {
                [variable]: tokenReference
            };
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            var: variable,
            varRef: reference
        };
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}
// ../../utilities/object-utils/src/omit.ts
function $01a983b3ad87bd07$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
// ../../utilities/object-utils/src/pick.ts
function $01a983b3ad87bd07$var$pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}
// ../../utilities/object-utils/src/walk-object.ts
function $01a983b3ad87bd07$var$isObject5(value) {
    return typeof value === "object" && value != null && !Array.isArray(value);
}
function $01a983b3ad87bd07$var$walkObject(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        var _a;
        if ($01a983b3ad87bd07$var$isObject5(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop == null ? void 0 : stop(value, childPath)) return predicate(value, path);
                result[key] = inner(child, childPath);
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}
// src/create-theme-vars/theme-tokens.ts
var $01a983b3ad87bd07$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
];
function $01a983b3ad87bd07$var$extractTokens(theme) {
    const _tokens = $01a983b3ad87bd07$var$tokens;
    return $01a983b3ad87bd07$var$pick(theme, _tokens);
}
function $01a983b3ad87bd07$var$extractSemanticTokens(theme) {
    return theme.semanticTokens;
}
function $01a983b3ad87bd07$var$omitVars(rawTheme) {
    const { __cssMap: __cssMap, __cssVars: __cssVars, __breakpoints: __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
}
// src/create-theme-vars/flatten-tokens.ts
var $01a983b3ad87bd07$var$isSemanticCondition = (key)=>$01a983b3ad87bd07$export$4ec9644154df43c2.includes(key) || "default" === key;
function $01a983b3ad87bd07$export$8f520cff3dbc4769({ tokens: tokens2, semanticTokens: semanticTokens }) {
    const result = {};
    $01a983b3ad87bd07$var$walkObject(tokens2, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: false,
            value: value
        };
    });
    $01a983b3ad87bd07$var$walkObject(semanticTokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: true,
            value: value
        };
    }, {
        stop: (value)=>Object.keys(value).every($01a983b3ad87bd07$var$isSemanticCondition)
    });
    return result;
}
// src/create-theme-vars/to-css-var.ts
function $01a983b3ad87bd07$export$d4e5dc2a444c0164(rawTheme) {
    var _a;
    const theme = $01a983b3ad87bd07$var$omitVars(rawTheme);
    const tokens2 = $01a983b3ad87bd07$var$extractTokens(theme);
    const semanticTokens = $01a983b3ad87bd07$var$extractSemanticTokens(theme);
    const flatTokens = $01a983b3ad87bd07$export$8f520cff3dbc4769({
        tokens: tokens2,
        semanticTokens: semanticTokens
    });
    const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
    const { cssMap: cssMap, cssVars: cssVars } = $01a983b3ad87bd07$var$createThemeVars(flatTokens, {
        cssVarPrefix: cssVarPrefix
    });
    const defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
        __cssVars: {
            ...defaultCssVars,
            ...cssVars
        },
        __cssMap: cssMap,
        __breakpoints: $01a983b3ad87bd07$var$analyzeBreakpoints(theme.breakpoints)
    });
    return theme;
}
var $01a983b3ad87bd07$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, $01a983b3ad87bd07$export$8ce1fd94bee2f412, $01a983b3ad87bd07$export$1edee58a52776cd9, $01a983b3ad87bd07$export$35e9368ef982300f, $01a983b3ad87bd07$export$feec61708a55c80e, $01a983b3ad87bd07$export$b3219800bda33a1f, $01a983b3ad87bd07$export$3dea766d36a8935f, $01a983b3ad87bd07$export$e7d0da6968da5dd, $01a983b3ad87bd07$export$2499a341a8256d68, $01a983b3ad87bd07$export$85fc379452d91af0, $01a983b3ad87bd07$export$36263e8f8d7ce3b1, $01a983b3ad87bd07$export$5880b8b5730aff45, $01a983b3ad87bd07$export$dc573d8a6576cdb3, $01a983b3ad87bd07$export$a941ed4b947d12f8, $01a983b3ad87bd07$export$209876d7b1ac8f3, $01a983b3ad87bd07$export$d846a084e680d8e, $01a983b3ad87bd07$export$6b7f9af9aa033040, $01a983b3ad87bd07$export$51186ad6e864892a, $01a983b3ad87bd07$export$8837f4fc672e936d, $01a983b3ad87bd07$export$66bb15e2994e6a26);
var $01a983b3ad87bd07$var$layoutSystem = Object.assign({}, $01a983b3ad87bd07$export$a941ed4b947d12f8, $01a983b3ad87bd07$export$b3219800bda33a1f, $01a983b3ad87bd07$export$feec61708a55c80e, $01a983b3ad87bd07$export$85fc379452d91af0, $01a983b3ad87bd07$export$5880b8b5730aff45);
var $01a983b3ad87bd07$export$bccb7c6ca2f4f912 = Object.keys($01a983b3ad87bd07$var$layoutSystem);
var $01a983b3ad87bd07$export$332cc7004bcbb8b4 = [
    ...Object.keys($01a983b3ad87bd07$export$30cfa87a708babfc),
    ...$01a983b3ad87bd07$export$4ec9644154df43c2
];
var $01a983b3ad87bd07$var$styleProps = {
    ...$01a983b3ad87bd07$export$30cfa87a708babfc,
    ...$01a983b3ad87bd07$export$a36cf593fde2a546
};
var $01a983b3ad87bd07$export$95b76554d0cd12d6 = (prop)=>prop in $01a983b3ad87bd07$var$styleProps;
var $01a983b3ad87bd07$var$expandResponsive = (styles)=>(theme)=>{
        if (!theme.__breakpoints) return styles;
        const { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        const computedStyles = {};
        for(const key in styles){
            let value = (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(styles[key], theme);
            if (value == null) continue;
            value = (0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            const queries = value.slice(0, medias.length).length;
            for(let index = 0; index < queries; index += 1){
                const media = medias == null ? void 0 : medias[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };
// src/utils/split-by-comma.ts
function $01a983b3ad87bd07$var$splitByComma(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for(let i = 0; i < value.length; i++){
        const char = value[i];
        if (char === "(") {
            inParens = true;
            chunk += char;
        } else if (char === ")") {
            inParens = false;
            chunk += char;
        } else if (char === "," && !inParens) {
            chunks.push(chunk);
            chunk = "";
        } else chunk += char;
    }
    chunk = chunk.trim();
    if (chunk) chunks.push(chunk);
    return chunks;
}
// src/css.ts
function $01a983b3ad87bd07$var$isCssVar2(value) {
    return /^var\(--.+\)$/.test(value);
}
var $01a983b3ad87bd07$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && typeof value === "string" && !$01a983b3ad87bd07$var$isCssVar2(value);
var $01a983b3ad87bd07$var$resolveTokenValue = (theme, value)=>{
    var _a, _b;
    if (value == null) return value;
    const getVar = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
    };
    const getValue = (val)=>{
        var _a2;
        return (_a2 = getVar(val)) != null ? _a2 : val;
    };
    const [tokenValue, fallbackValue] = $01a983b3ad87bd07$var$splitByComma(value);
    value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
    return value;
};
function $01a983b3ad87bd07$export$955358618f994a11(options) {
    const { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    const css2 = (stylesOrFn, nested = false)=>{
        var _a, _b, _c;
        const _styles = (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(stylesOrFn, theme);
        const styles = $01a983b3ad87bd07$var$expandResponsive(_styles)(theme);
        let computedStyles = {};
        for(let key in styles){
            const valueOrFn = styles[key];
            let value = (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(valueOrFn, theme);
            if (key in pseudos) key = pseudos[key];
            if ($01a983b3ad87bd07$var$isCSSVariableTokenValue(key, value)) value = $01a983b3ad87bd07$var$resolveTokenValue(theme, value);
            let config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(value)) {
                computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, computedStyles[key], css2(value, true));
                continue;
            }
            let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
            rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
            const configProperty = (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(config == null ? void 0 : config.property, theme);
            if (!nested && (config == null ? void 0 : config.static)) {
                const staticStyles = (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (const property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css2;
}
var $01a983b3ad87bd07$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        const cssFn = $01a983b3ad87bd07$export$955358618f994a11({
            theme: theme,
            pseudos: $01a983b3ad87bd07$export$a36cf593fde2a546,
            configs: $01a983b3ad87bd07$export$30cfa87a708babfc
        });
        return cssFn(styles);
    };
// src/define-styles.ts
function $01a983b3ad87bd07$export$9a6b93c1c4f92839(styles) {
    return styles;
}
function $01a983b3ad87bd07$export$5c9a64458a4ed8a4(config) {
    return config;
}
function $01a983b3ad87bd07$export$d5f717dc145477b8(parts) {
    return {
        definePartsStyle (config) {
            return config;
        },
        defineMultiStyleConfig (config) {
            return {
                parts: parts,
                ...config
            };
        }
    };
}
function $01a983b3ad87bd07$var$normalize2(value, toArray) {
    if (Array.isArray(value)) return value;
    if ((0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(value)) return toArray(value);
    if (value != null) return [
        value
    ];
}
function $01a983b3ad87bd07$var$getNextIndex(values, i) {
    for(let j = i + 1; j < values.length; j++){
        if (values[j] != null) return j;
    }
    return -1;
}
function $01a983b3ad87bd07$var$createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
        var _a, _b;
        if (!breakpointUtil) return;
        const result = {};
        const normalized = $01a983b3ad87bd07$var$normalize2(value, breakpointUtil.toArrayValue);
        if (!normalized) return result;
        const len = normalized.length;
        const isSingle = len === 1;
        const isMultipart = !!config.parts;
        for(let i = 0; i < len; i++){
            const key = breakpointUtil.details[i];
            const nextKey = breakpointUtil.details[$01a983b3ad87bd07$var$getNextIndex(normalized, i)];
            const query = $01a983b3ad87bd07$var$toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
            const styles = (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
            if (!styles) continue;
            if (isMultipart) {
                (_b = config.parts) == null || _b.forEach((part)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))(result, {
                        [part]: isSingle ? styles[part] : {
                            [query]: styles[part]
                        }
                    });
                });
                continue;
            }
            if (!isMultipart) {
                if (isSingle) (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))(result, styles);
                else result[query] = styles;
                continue;
            }
            result[query] = styles;
        }
        return result;
    };
}
function $01a983b3ad87bd07$export$f94106bbb00e81eb(config) {
    return (props)=>{
        var _a;
        const { variant: variant, size: size, theme: theme } = props;
        const recipe = $01a983b3ad87bd07$var$createResolver(theme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)((_a = config.baseStyle) != null ? _a : {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
    };
}
// src/get-css-var.ts
function $01a983b3ad87bd07$export$93c8e06b7014dc33(theme, scale, value) {
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
}
// src/theming-props.ts
function $01a983b3ad87bd07$export$adfcf5a5e4d17785(props) {
    return $01a983b3ad87bd07$var$omit(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}


"use client";
var $6aa4a10cd14d3ebb$var$allPropNames = /* @__PURE__ */ new Set([
    ...(0, $01a983b3ad87bd07$export$332cc7004bcbb8b4),
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
var $6aa4a10cd14d3ebb$var$validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $6aa4a10cd14d3ebb$export$3ba67b570e26eea0(prop) {
    return $6aa4a10cd14d3ebb$var$validHTMLProps.has(prop) || !$6aa4a10cd14d3ebb$var$allPropNames.has(prop);
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
var $53a9951d8b44cf80$export$49ddd74a6729fdb0 = (0, $lDSNw.createContext)({});
$53a9951d8b44cf80$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
function $53a9951d8b44cf80$export$20f3076712c8dfa() {
    const context = (0, $lDSNw.useContext)($53a9951d8b44cf80$export$49ddd74a6729fdb0);
    if (context === void 0) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
}
function $53a9951d8b44cf80$export$d18f2ef57b0d7644(light, dark) {
    const { colorMode: colorMode } = $53a9951d8b44cf80$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}



// src/object.ts

var $gHhSd = parcelRequire("gHhSd");
function $f9ff6ad38b3f7068$export$30a06c8d3562193f(object, keys) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $f9ff6ad38b3f7068$export$357523c63a2253b9(object, keys) {
    const result = {};
    keys.forEach((key)=>{
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $f9ff6ad38b3f7068$export$65980d18b75784e2(object, keys) {
    const picked = {};
    const omitted = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
function $f9ff6ad38b3f7068$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $f9ff6ad38b3f7068$export$fc10aeed3a532e2a = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $f9ff6ad38b3f7068$export$1bb32d0c65da6059 = $f9ff6ad38b3f7068$export$fc10aeed3a532e2a($f9ff6ad38b3f7068$export$3988ae62b71be9a3);
function $f9ff6ad38b3f7068$export$73b8ef55a37133c7(path, scale) {
    return $f9ff6ad38b3f7068$export$1bb32d0c65da6059(scale, path, path);
}
function $f9ff6ad38b3f7068$export$3417cf6417437960(object, fn) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        const value = object[key];
        const shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $f9ff6ad38b3f7068$export$2458ce75c8ef9806 = (object)=>$f9ff6ad38b3f7068$export$3417cf6417437960(object, (val)=>val !== null && val !== void 0);
var $f9ff6ad38b3f7068$export$259b4dd69e654a7a = (obj)=>Object.keys(obj);
var $f9ff6ad38b3f7068$export$5150077fc2e7c662 = (entries)=>entries.reduce((carry, [key, value])=>{
        carry[key] = value;
        return carry;
    }, {});
var $f9ff6ad38b3f7068$export$93c8e06b7014dc33 = (theme, scale, value)=>{
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

// src/assertion.ts
function $11a3432987b73819$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $11a3432987b73819$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $11a3432987b73819$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
function $11a3432987b73819$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $11a3432987b73819$export$4c0262a4f954db45(value) {
    return $11a3432987b73819$export$43bee75e5e14138e(value) && value.length === 0;
}
function $11a3432987b73819$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $11a3432987b73819$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== void 0;
}
function $11a3432987b73819$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === void 0;
}
function $11a3432987b73819$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$11a3432987b73819$export$43bee75e5e14138e(value);
}
function $11a3432987b73819$export$83b788b1a3698c03(value) {
    return $11a3432987b73819$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $11a3432987b73819$export$e0287cc73292b477(value) {
    return value && !$11a3432987b73819$export$83b788b1a3698c03(value);
}
function $11a3432987b73819$export$630801d484da15df(value) {
    return value == null;
}
function $11a3432987b73819$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $11a3432987b73819$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
}
function $11a3432987b73819$export$dd1bc94b04021eeb(value) {
    if ($11a3432987b73819$export$43bee75e5e14138e(value)) return $11a3432987b73819$export$4c0262a4f954db45(value);
    if ($11a3432987b73819$export$a6cdc56e425d0d0a(value)) return $11a3432987b73819$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $11a3432987b73819$export$a866f231438cc228 = false;
var $11a3432987b73819$export$61cb32cff9a99948 = false;
function $11a3432987b73819$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $11a3432987b73819$export$4215e022093e324e(value) {
    return value && $11a3432987b73819$export$a6cdc56e425d0d0a(value) && $11a3432987b73819$export$a6cdc56e425d0d0a(value.target);
}


// src/function.ts
function $61d460608c17cbaf$export$624e501d81f5ffce(valueOrFn, ...args) {
    return (0, $11a3432987b73819$export$f6e2535fb5126e54)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function $61d460608c17cbaf$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $61d460608c17cbaf$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
var $61d460608c17cbaf$export$f672e0b6f7222cd7 = (fn1, ...fns)=>fns.reduce((f1, f2)=>(...args)=>f1(f2(...args)), fn1);
function $61d460608c17cbaf$export$d2de3aaeafa91619(fn) {
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $61d460608c17cbaf$export$8793edee2d425525 = ()=>{};
var $61d460608c17cbaf$export$c106dd0671a0fc2d = /* @__PURE__ */ $61d460608c17cbaf$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $11a3432987b73819$export$a866f231438cc228)) console.warn(message);
    });
var $61d460608c17cbaf$export$a3bc9b8ed74fc = /* @__PURE__ */ $61d460608c17cbaf$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $11a3432987b73819$export$a866f231438cc228)) console.error(message);
    });
var $61d460608c17cbaf$export$a4627e546088548d = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
var $61d460608c17cbaf$var$distance1D = (a, b)=>Math.abs(a - b);
var $61d460608c17cbaf$var$isPoint = (point)=>"x" in point && "y" in point;
function $61d460608c17cbaf$export$9f17032d917177de(a, b) {
    if ((0, $11a3432987b73819$export$7e4aa119212bc614)(a) && (0, $11a3432987b73819$export$7e4aa119212bc614)(b)) return $61d460608c17cbaf$var$distance1D(a, b);
    if ($61d460608c17cbaf$var$isPoint(a) && $61d460608c17cbaf$var$isPoint(b)) {
        const xDelta = $61d460608c17cbaf$var$distance1D(a.x, b.x);
        const yDelta = $61d460608c17cbaf$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}


// src/assign-after.ts
function $74828c0ad3f9aa05$export$1ab078c80230a125(target, ...sources) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    const result = {
        ...target
    };
    for (const nextSource of sources){
        if (nextSource == null) continue;
        for(const nextKey in nextSource){
            if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
            if (nextKey in result) delete result[nextKey];
            result[nextKey] = nextSource[nextKey];
        }
    }
    return result;
}




var $lDSNw = parcelRequire("lDSNw");
"use client";
var $85dcf13924e77255$var$_a;
var $85dcf13924e77255$var$emotion_styled = ($85dcf13924e77255$var$_a = (0, $2809f842de743c7e$export$2e2bcd8739ae039).default) != null ? $85dcf13924e77255$var$_a : (0, $2809f842de743c7e$export$2e2bcd8739ae039);
var $85dcf13924e77255$export$9dba07f3d84163bb = ({ baseStyle: baseStyle })=>(props)=>{
        const { theme: theme, css: cssProp, __css: __css, sx: sx, ...rest } = props;
        const styleProps = (0, $f9ff6ad38b3f7068$export$3417cf6417437960)(rest, (_, prop)=>(0, $01a983b3ad87bd07$export$95b76554d0cd12d6)(prop));
        const finalBaseStyle = (0, $61d460608c17cbaf$export$624e501d81f5ffce)(baseStyle, props);
        const finalStyles = (0, $74828c0ad3f9aa05$export$1ab078c80230a125)({}, __css, finalBaseStyle, (0, $f9ff6ad38b3f7068$export$2458ce75c8ef9806)(styleProps), sx);
        const computedCSS = (0, $01a983b3ad87bd07$export$dbf350e5966cf602)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
function $85dcf13924e77255$export$3817b7a54a07cec7(component, options) {
    const { baseStyle: baseStyle, ...styledOptions } = options != null ? options : {};
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $6aa4a10cd14d3ebb$export$3ba67b570e26eea0);
    const styleObject = $85dcf13924e77255$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    const Component = $85dcf13924e77255$var$emotion_styled(component, styledOptions)(styleObject);
    const chakraComponent = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).forwardRef(function ChakraComponent(props, ref) {
        const { colorMode: colorMode, forced: forced } = (0, $53a9951d8b44cf80$export$20f3076712c8dfa)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(Component, {
            ref: ref,
            "data-theme": forced ? colorMode : void 0,
            ...props
        });
    });
    return chakraComponent;
}


"use client";
// src/factory.ts
function $5c12d9132a121f51$var$factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy((0, $85dcf13924e77255$export$3817b7a54a07cec7), {
        /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */ apply (target, thisArg, argArray) {
            return (0, $85dcf13924e77255$export$3817b7a54a07cec7)(...argArray);
        },
        /**
     * @example
     * <chakra.div />
     */ get (_, element) {
            if (!cache.has(element)) cache.set(element, (0, $85dcf13924e77255$export$3817b7a54a07cec7)(element));
            return cache.get(element);
        }
    });
}
var $5c12d9132a121f51$export$7cd122d781af9fa4 = $5c12d9132a121f51$var$factory();




var $lDSNw = parcelRequire("lDSNw");

"use client";
function $73d982c18f610c82$export$e1c22a2ee2645e36(props) {
    const { children: children, className: className, ...rest } = props;
    const _children = (0, $lDSNw.isValidElement)(children) ? (0, $lDSNw.cloneElement)(children, {
        "aria-hidden": true,
        focusable: false
    }) : children;
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-button__icon", className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
    });
}
$73d982c18f610c82$export$e1c22a2ee2645e36.displayName = "ButtonIcon";



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $3064a344dac4d694$export$257a8862b851cb5b(component) {
    return (0, $lDSNw.forwardRef)(component);
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $7ead6df74eee26d7$export$93d4e7f90805808f() {
    const theme = (0, $lDSNw.useContext)((0, $fee187d89b24554e$export$971d5caa766a69d7));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}



"use client";
function $45384fe8bd4bf97a$export$a513a93efd9ab8a7() {
    const colorModeResult = (0, $53a9951d8b44cf80$export$20f3076712c8dfa)();
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    return {
        ...colorModeResult,
        theme: theme
    };
}
function $45384fe8bd4bf97a$var$getBreakpointValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__breakpoints) == null ? void 0 : _a2.asArray) == null ? void 0 : _b2[val];
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $45384fe8bd4bf97a$var$getTokenValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.value;
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $45384fe8bd4bf97a$export$31dcd79391e423fe(scale, token, fallback) {
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    return $45384fe8bd4bf97a$export$257b2d10b709d8ef(scale, token, fallback)(theme);
}
function $45384fe8bd4bf97a$export$257b2d10b709d8ef(scale, token, fallback) {
    const _token = Array.isArray(token) ? token : [
        token
    ];
    const _fallback = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    return (theme)=>{
        const fallbackArr = _fallback.filter(Boolean);
        const result = _token.map((token2, index)=>{
            var _a, _b;
            if (scale === "breakpoints") return $45384fe8bd4bf97a$var$getBreakpointValue(theme, token2, (_a = fallbackArr[index]) != null ? _a : token2);
            const path = `${scale}.${token2}`;
            return $45384fe8bd4bf97a$var$getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
        });
        return Array.isArray(token) ? result : result[0];
    };
}



// src/extend-theme.ts

"use client";
var $ce252c3b9f4b2082$export$1fad0bb5bac74e8f = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
];
function $ce252c3b9f4b2082$export$73a6ae01926a4f0e(unit) {
    if (!(0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(unit)) return false;
    return $ce252c3b9f4b2082$export$1fad0bb5bac74e8f.every((propertyName)=>Object.prototype.hasOwnProperty.call(unit, propertyName));
}


"use client";
// src/foundations/transition.ts
var $70333e35d4c40549$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
var $70333e35d4c40549$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var $70333e35d4c40549$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
var $70333e35d4c40549$var$transition = {
    property: $70333e35d4c40549$var$transitionProperty,
    easing: $70333e35d4c40549$var$transitionTimingFunction,
    duration: $70333e35d4c40549$var$transitionDuration
};
var $70333e35d4c40549$export$6b266f9cfc4b7bb8 = $70333e35d4c40549$var$transition;


"use client";
// src/foundations/z-index.ts
var $a6e32dd965fc65a6$var$zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};
var $a6e32dd965fc65a6$export$d9d5ef55fed42171 = $a6e32dd965fc65a6$var$zIndices;


"use client";
// src/foundations/borders.ts
var $8790157f32d0bdc8$var$borders = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};
var $8790157f32d0bdc8$export$196bfcf31ca4deb7 = $8790157f32d0bdc8$var$borders;


"use client";
// src/foundations/breakpoints.ts
var $11ae52a2e94bc72e$var$breakpoints = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
};
var $11ae52a2e94bc72e$export$d0717e75346b884a = $11ae52a2e94bc72e$var$breakpoints;


"use client";
// src/foundations/colors.ts
var $c2e5be99086e3d7a$var$colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    },
    linkedin: {
        50: "#E8F4F9",
        100: "#CFEDFB",
        200: "#9BDAF3",
        300: "#68C7EC",
        400: "#34B3E4",
        500: "#00A0DC",
        600: "#008CC9",
        700: "#0077B5",
        800: "#005E93",
        900: "#004471"
    },
    facebook: {
        50: "#E8F4F9",
        100: "#D9DEE9",
        200: "#B7C2DA",
        300: "#6482C0",
        400: "#4267B2",
        500: "#385898",
        600: "#314E89",
        700: "#29487D",
        800: "#223B67",
        900: "#1E355B"
    },
    messenger: {
        50: "#D0E6FF",
        100: "#B9DAFF",
        200: "#A2CDFF",
        300: "#7AB8FF",
        400: "#2E90FF",
        500: "#0078FF",
        600: "#0063D1",
        700: "#0052AC",
        800: "#003C7E",
        900: "#002C5C"
    },
    whatsapp: {
        50: "#dffeec",
        100: "#b9f5d0",
        200: "#90edb3",
        300: "#65e495",
        400: "#3cdd78",
        500: "#22c35e",
        600: "#179848",
        700: "#0c6c33",
        800: "#01421c",
        900: "#001803"
    },
    twitter: {
        50: "#E5F4FD",
        100: "#C8E9FB",
        200: "#A8DCFA",
        300: "#83CDF7",
        400: "#57BBF5",
        500: "#1DA1F2",
        600: "#1A94DA",
        700: "#1681BF",
        800: "#136B9E",
        900: "#0D4D71"
    },
    telegram: {
        50: "#E3F2F9",
        100: "#C5E4F3",
        200: "#A2D4EC",
        300: "#7AC1E4",
        400: "#47A9DA",
        500: "#0088CC",
        600: "#007AB8",
        700: "#006BA1",
        800: "#005885",
        900: "#003F5E"
    }
};
var $c2e5be99086e3d7a$export$59d2d4241383b416 = $c2e5be99086e3d7a$var$colors;


"use client";
// src/foundations/radius.ts
var $11150b9f48ede479$var$radii = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};
var $11150b9f48ede479$export$9aaceac1356558f4 = $11150b9f48ede479$var$radii;


"use client";
// src/foundations/shadows.ts
var $cf7fa7d317879aae$var$shadows = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var $cf7fa7d317879aae$export$e70f92e6000288b2 = $cf7fa7d317879aae$var$shadows;


"use client";
// src/foundations/blur.ts
var $6b8bd723973a3e65$var$blur = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};
var $6b8bd723973a3e65$export$6b4e890355bf1451 = $6b8bd723973a3e65$var$blur;


"use client";
// src/foundations/typography.ts
var $c403c3ffdcceff1d$var$typography = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
        "3xs": "0.45rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};
var $c403c3ffdcceff1d$export$d7c5d8884f83c8db = $c403c3ffdcceff1d$var$typography;


"use client";
// src/foundations/spacing.ts
var $81f292d0de8e4fb7$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};


"use client";
// src/foundations/sizes.ts
var $fd4b35e8bdb8da6d$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
};
var $fd4b35e8bdb8da6d$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
var $fd4b35e8bdb8da6d$var$sizes = {
    ...(0, $81f292d0de8e4fb7$export$5458b64234d1333c),
    ...$fd4b35e8bdb8da6d$var$largeSizes,
    container: $fd4b35e8bdb8da6d$var$container
};
var $fd4b35e8bdb8da6d$export$d7d4c689520cc141 = $fd4b35e8bdb8da6d$var$sizes;



"use client";
// src/foundations/index.ts
var $50f899fd68925481$export$651a0b7b10dae380 = {
    breakpoints: (0, $11ae52a2e94bc72e$export$d0717e75346b884a),
    zIndices: (0, $a6e32dd965fc65a6$export$d9d5ef55fed42171),
    radii: (0, $11150b9f48ede479$export$9aaceac1356558f4),
    blur: (0, $6b8bd723973a3e65$export$6b4e890355bf1451),
    colors: (0, $c2e5be99086e3d7a$export$59d2d4241383b416),
    ...(0, $c403c3ffdcceff1d$export$d7c5d8884f83c8db),
    sizes: (0, $fd4b35e8bdb8da6d$export$d7d4c689520cc141),
    shadows: (0, $cf7fa7d317879aae$export$e70f92e6000288b2),
    space: (0, $81f292d0de8e4fb7$export$5458b64234d1333c),
    borders: (0, $8790157f32d0bdc8$export$196bfcf31ca4deb7),
    transition: (0, $70333e35d4c40549$export$6b266f9cfc4b7bb8)
};











"use client";
var { defineMultiStyleConfig: $f69149d8e034a8c7$var$defineMultiStyleConfig, definePartsStyle: $f69149d8e034a8c7$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
]);
var $f69149d8e034a8c7$var$$size = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("stepper-indicator-size");
var $f69149d8e034a8c7$var$$iconSize = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("stepper-icon-size");
var $f69149d8e034a8c7$var$$titleFontSize = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("stepper-title-font-size");
var $f69149d8e034a8c7$var$$descFontSize = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("stepper-description-font-size");
var $f69149d8e034a8c7$var$$accentColor = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("stepper-accent-color");
var $f69149d8e034a8c7$var$baseStyle = $f69149d8e034a8c7$var$definePartsStyle(({ colorScheme: c })=>({
        stepper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4",
            "&[data-orientation=vertical]": {
                flexDirection: "column",
                alignItems: "flex-start"
            },
            "&[data-orientation=horizontal]": {
                flexDirection: "row",
                alignItems: "center"
            },
            [$f69149d8e034a8c7$var$$accentColor.variable]: `colors.${c}.500`,
            _dark: {
                [$f69149d8e034a8c7$var$$accentColor.variable]: `colors.${c}.200`
            }
        },
        title: {
            fontSize: $f69149d8e034a8c7$var$$titleFontSize.reference,
            fontWeight: "medium"
        },
        description: {
            fontSize: $f69149d8e034a8c7$var$$descFontSize.reference,
            color: "chakra-subtle-text"
        },
        number: {
            fontSize: $f69149d8e034a8c7$var$$titleFontSize.reference
        },
        step: {
            flexShrink: 0,
            position: "relative",
            display: "flex",
            gap: "2",
            "&[data-orientation=horizontal]": {
                alignItems: "center"
            },
            flex: "1",
            "&:last-of-type:not([data-stretch])": {
                flex: "initial"
            }
        },
        icon: {
            flexShrink: 0,
            width: $f69149d8e034a8c7$var$$iconSize.reference,
            height: $f69149d8e034a8c7$var$$iconSize.reference
        },
        indicator: {
            flexShrink: 0,
            borderRadius: "full",
            width: $f69149d8e034a8c7$var$$size.reference,
            height: $f69149d8e034a8c7$var$$size.reference,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&[data-status=active]": {
                borderWidth: "2px",
                borderColor: $f69149d8e034a8c7$var$$accentColor.reference
            },
            "&[data-status=complete]": {
                bg: $f69149d8e034a8c7$var$$accentColor.reference,
                color: "chakra-inverse-text"
            },
            "&[data-status=incomplete]": {
                borderWidth: "2px"
            }
        },
        separator: {
            bg: "chakra-border-color",
            flex: "1",
            "&[data-status=complete]": {
                bg: $f69149d8e034a8c7$var$$accentColor.reference
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: "2"
            },
            "&[data-orientation=vertical]": {
                width: "2px",
                position: "absolute",
                height: "100%",
                maxHeight: `calc(100% - ${$f69149d8e034a8c7$var$$size.reference} - 8px)`,
                top: `calc(${$f69149d8e034a8c7$var$$size.reference} + 4px)`,
                insetStart: `calc(${$f69149d8e034a8c7$var$$size.reference} / 2 - 1px)`
            }
        }
    }));
var $f69149d8e034a8c7$export$54c84d54375c8d75 = $f69149d8e034a8c7$var$defineMultiStyleConfig({
    baseStyle: $f69149d8e034a8c7$var$baseStyle,
    sizes: {
        xs: $f69149d8e034a8c7$var$definePartsStyle({
            stepper: {
                [$f69149d8e034a8c7$var$$size.variable]: "sizes.4",
                [$f69149d8e034a8c7$var$$iconSize.variable]: "sizes.3",
                [$f69149d8e034a8c7$var$$titleFontSize.variable]: "fontSizes.xs",
                [$f69149d8e034a8c7$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        sm: $f69149d8e034a8c7$var$definePartsStyle({
            stepper: {
                [$f69149d8e034a8c7$var$$size.variable]: "sizes.6",
                [$f69149d8e034a8c7$var$$iconSize.variable]: "sizes.4",
                [$f69149d8e034a8c7$var$$titleFontSize.variable]: "fontSizes.sm",
                [$f69149d8e034a8c7$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        md: $f69149d8e034a8c7$var$definePartsStyle({
            stepper: {
                [$f69149d8e034a8c7$var$$size.variable]: "sizes.8",
                [$f69149d8e034a8c7$var$$iconSize.variable]: "sizes.5",
                [$f69149d8e034a8c7$var$$titleFontSize.variable]: "fontSizes.md",
                [$f69149d8e034a8c7$var$$descFontSize.variable]: "fontSizes.sm"
            }
        }),
        lg: $f69149d8e034a8c7$var$definePartsStyle({
            stepper: {
                [$f69149d8e034a8c7$var$$size.variable]: "sizes.10",
                [$f69149d8e034a8c7$var$$iconSize.variable]: "sizes.6",
                [$f69149d8e034a8c7$var$$titleFontSize.variable]: "fontSizes.lg",
                [$f69149d8e034a8c7$var$$descFontSize.variable]: "fontSizes.md"
            }
        })
    },
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


"use client";
// src/anatomy.ts
function $25c341340a3b536e$export$477202748c7242bf(name, map = {}) {
    let called = false;
    function assert() {
        if (!called) {
            called = true;
            return;
        }
        throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }
    function parts(...values) {
        assert();
        for (const part of values)map[part] = toPart(part);
        return $25c341340a3b536e$export$477202748c7242bf(name, map);
    }
    function extend(...parts2) {
        for (const part of parts2){
            if (part in map) continue;
            map[part] = toPart(part);
        }
        return $25c341340a3b536e$export$477202748c7242bf(name, map);
    }
    function selectors() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.selector
            ]));
        return value;
    }
    function classnames() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.className
            ]));
        return value;
    }
    function toPart(part) {
        const el = [
            "container",
            "root"
        ].includes(part != null ? part : "") ? [
            name
        ] : [
            name,
            part
        ];
        const attr = el.filter(Boolean).join("__");
        const className = `chakra-${attr}`;
        const partObj = {
            className: className,
            selector: `.${className}`,
            toString: ()=>part
        };
        return partObj;
    }
    const __type = {};
    return {
        parts: parts,
        toPart: toPart,
        extend: extend,
        selectors: selectors,
        classnames: classnames,
        get keys () {
            return Object.keys(map);
        },
        __type: __type
    };
}


"use client";
// src/components.ts
var $fe6b83d1d0338593$export$377a77e99e7c73a5 = (0, $25c341340a3b536e$export$477202748c7242bf)("accordion").parts("root", "container", "button", "panel").extend("icon");
var $fe6b83d1d0338593$export$fc51889fa4de265a = (0, $25c341340a3b536e$export$477202748c7242bf)("alert").parts("title", "description", "container").extend("icon", "spinner");
var $fe6b83d1d0338593$export$60f8655d889e17c7 = (0, $25c341340a3b536e$export$477202748c7242bf)("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var $fe6b83d1d0338593$export$2fb03f744a6ecf93 = (0, $25c341340a3b536e$export$477202748c7242bf)("breadcrumb").parts("link", "item", "container").extend("separator");
var $fe6b83d1d0338593$export$1699c5cb20c07888 = (0, $25c341340a3b536e$export$477202748c7242bf)("button").parts();
var $fe6b83d1d0338593$export$21946b04497ed6ac = (0, $25c341340a3b536e$export$477202748c7242bf)("checkbox").parts("control", "icon", "container").extend("label");
var $fe6b83d1d0338593$export$2c953111278f3272 = (0, $25c341340a3b536e$export$477202748c7242bf)("progress").parts("track", "filledTrack").extend("label");
var $fe6b83d1d0338593$export$d3f4aaa4b0f2907a = (0, $25c341340a3b536e$export$477202748c7242bf)("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $fe6b83d1d0338593$export$2813c9511eeab082 = (0, $25c341340a3b536e$export$477202748c7242bf)("editable").parts("preview", "input", "textarea");
var $fe6b83d1d0338593$export$4b243e3f209a7e5e = (0, $25c341340a3b536e$export$477202748c7242bf)("form").parts("container", "requiredIndicator", "helperText");
var $fe6b83d1d0338593$export$bb18c440c00e82d9 = (0, $25c341340a3b536e$export$477202748c7242bf)("formError").parts("text", "icon");
var $fe6b83d1d0338593$export$1ffeb100b532f46d = (0, $25c341340a3b536e$export$477202748c7242bf)("input").parts("addon", "field", "element", "group");
var $fe6b83d1d0338593$export$12b3a655a94374ed = (0, $25c341340a3b536e$export$477202748c7242bf)("list").parts("container", "item", "icon");
var $fe6b83d1d0338593$export$e251092a5dcb1329 = (0, $25c341340a3b536e$export$477202748c7242bf)("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
var $fe6b83d1d0338593$export$34e33beb8d992ac2 = (0, $25c341340a3b536e$export$477202748c7242bf)("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $fe6b83d1d0338593$export$859cc7ca3200df97 = (0, $25c341340a3b536e$export$477202748c7242bf)("numberinput").parts("root", "field", "stepperGroup", "stepper");
var $fe6b83d1d0338593$export$12bb869d7991ac50 = (0, $25c341340a3b536e$export$477202748c7242bf)("pininput").parts("field");
var $fe6b83d1d0338593$export$afda07d12cd4337d = (0, $25c341340a3b536e$export$477202748c7242bf)("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var $fe6b83d1d0338593$export$ba6328c242bd649c = (0, $25c341340a3b536e$export$477202748c7242bf)("progress").parts("label", "filledTrack", "track");
var $fe6b83d1d0338593$export$d28d06d0e29ef022 = (0, $25c341340a3b536e$export$477202748c7242bf)("radio").parts("container", "control", "label");
var $fe6b83d1d0338593$export$17993f0be9538b5a = (0, $25c341340a3b536e$export$477202748c7242bf)("select").parts("field", "icon");
var $fe6b83d1d0338593$export$c21b4b3f8b239f32 = (0, $25c341340a3b536e$export$477202748c7242bf)("slider").parts("container", "track", "thumb", "filledTrack", "mark");
var $fe6b83d1d0338593$export$2cfbad67ae6ee421 = (0, $25c341340a3b536e$export$477202748c7242bf)("stat").parts("container", "label", "helpText", "number", "icon");
var $fe6b83d1d0338593$export$921c1a2d1ce1e86a = (0, $25c341340a3b536e$export$477202748c7242bf)("switch").parts("container", "track", "thumb");
var $fe6b83d1d0338593$export$8b1b9cdd5db9f5fd = (0, $25c341340a3b536e$export$477202748c7242bf)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var $fe6b83d1d0338593$export$97383552563be58d = (0, $25c341340a3b536e$export$477202748c7242bf)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var $fe6b83d1d0338593$export$4c2f5f7f2ea94a8e = (0, $25c341340a3b536e$export$477202748c7242bf)("tag").parts("container", "label", "closeButton");
var $fe6b83d1d0338593$export$487a447ffa5755b6 = (0, $25c341340a3b536e$export$477202748c7242bf)("card").parts("container", "header", "body", "footer");




"use client";
function $64b1ed50d45c4df0$var$toRef(operand) {
    if ((0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $64b1ed50d45c4df0$var$toExpr = (operator, ...operands)=>operands.map($64b1ed50d45c4df0$var$toRef).join(` ${operator} `).replace(/calc/g, "");
var $64b1ed50d45c4df0$var$add = (...operands)=>`calc(${$64b1ed50d45c4df0$var$toExpr("+", ...operands)})`;
var $64b1ed50d45c4df0$var$subtract = (...operands)=>`calc(${$64b1ed50d45c4df0$var$toExpr("-", ...operands)})`;
var $64b1ed50d45c4df0$var$multiply = (...operands)=>`calc(${$64b1ed50d45c4df0$var$toExpr("*", ...operands)})`;
var $64b1ed50d45c4df0$var$divide = (...operands)=>`calc(${$64b1ed50d45c4df0$var$toExpr("/", ...operands)})`;
var $64b1ed50d45c4df0$var$negate = (x)=>{
    const value = $64b1ed50d45c4df0$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $64b1ed50d45c4df0$var$multiply(value, -1);
};
var $64b1ed50d45c4df0$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$64b1ed50d45c4df0$export$42bfa9b2d4dad91a($64b1ed50d45c4df0$var$add(x, ...operands)),
        subtract: (...operands)=>$64b1ed50d45c4df0$export$42bfa9b2d4dad91a($64b1ed50d45c4df0$var$subtract(x, ...operands)),
        multiply: (...operands)=>$64b1ed50d45c4df0$export$42bfa9b2d4dad91a($64b1ed50d45c4df0$var$multiply(x, ...operands)),
        divide: (...operands)=>$64b1ed50d45c4df0$export$42bfa9b2d4dad91a($64b1ed50d45c4df0$var$divide(x, ...operands)),
        negate: ()=>$64b1ed50d45c4df0$export$42bfa9b2d4dad91a($64b1ed50d45c4df0$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $64b1ed50d45c4df0$var$add,
    subtract: $64b1ed50d45c4df0$var$subtract,
    multiply: $64b1ed50d45c4df0$var$multiply,
    divide: $64b1ed50d45c4df0$var$divide,
    negate: $64b1ed50d45c4df0$var$negate
});

"use client";
// src/css-var.ts
function $1ac6a326e189a005$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $1ac6a326e189a005$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $1ac6a326e189a005$var$escape(value) {
    const valueStr = $1ac6a326e189a005$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $1ac6a326e189a005$export$2ad0182371401ea4(value) ? valueStr.replace(".", `\\.`) : value;
}
function $1ac6a326e189a005$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        $1ac6a326e189a005$var$escape(value)
    ].filter(Boolean).join("-");
}
function $1ac6a326e189a005$export$44410db3a43190e8(name, fallback) {
    return `var(${$1ac6a326e189a005$var$escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function $1ac6a326e189a005$export$e2ffa342f278b3a3(value, prefix = "") {
    return `--${$1ac6a326e189a005$export$9748efee331ec573(value, prefix)}`;
}
function $1ac6a326e189a005$export$8b4981022bd80a4e(name, options) {
    const cssVariable = $1ac6a326e189a005$export$e2ffa342f278b3a3(name, options == null ? void 0 : options.prefix);
    return {
        variable: cssVariable,
        reference: $1ac6a326e189a005$export$44410db3a43190e8(cssVariable, $1ac6a326e189a005$var$getFallback(options == null ? void 0 : options.fallback))
    };
}
function $1ac6a326e189a005$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback == null ? void 0 : fallback.reference;
}


"use client";
var { defineMultiStyleConfig: $e3bb69f65f89805f$var$defineMultiStyleConfig, definePartsStyle: $e3bb69f65f89805f$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$921c1a2d1ce1e86a).keys);
var $e3bb69f65f89805f$var$$width = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("switch-track-width");
var $e3bb69f65f89805f$var$$height = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("switch-track-height");
var $e3bb69f65f89805f$var$$diff = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("switch-track-diff");
var $e3bb69f65f89805f$var$diffValue = (0, $64b1ed50d45c4df0$export$42bfa9b2d4dad91a).subtract($e3bb69f65f89805f$var$$width, $e3bb69f65f89805f$var$$height);
var $e3bb69f65f89805f$var$$translateX = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("switch-thumb-x");
var $e3bb69f65f89805f$var$$bg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("switch-bg");
var $e3bb69f65f89805f$var$baseStyleTrack = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "0.5",
        width: [
            $e3bb69f65f89805f$var$$width.reference
        ],
        height: [
            $e3bb69f65f89805f$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        [$e3bb69f65f89805f$var$$bg.variable]: "colors.gray.300",
        _dark: {
            [$e3bb69f65f89805f$var$$bg.variable]: "colors.whiteAlpha.400"
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            [$e3bb69f65f89805f$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$e3bb69f65f89805f$var$$bg.variable]: `colors.${c}.200`
            }
        },
        bg: $e3bb69f65f89805f$var$$bg.reference
    };
});
var $e3bb69f65f89805f$var$baseStyleThumb = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $e3bb69f65f89805f$var$$height.reference
    ],
    height: [
        $e3bb69f65f89805f$var$$height.reference
    ],
    _checked: {
        transform: `translateX(${$e3bb69f65f89805f$var$$translateX.reference})`
    }
});
var $e3bb69f65f89805f$var$baseStyle = $e3bb69f65f89805f$var$definePartsStyle((props)=>({
        container: {
            [$e3bb69f65f89805f$var$$diff.variable]: $e3bb69f65f89805f$var$diffValue,
            [$e3bb69f65f89805f$var$$translateX.variable]: $e3bb69f65f89805f$var$$diff.reference,
            _rtl: {
                [$e3bb69f65f89805f$var$$translateX.variable]: (0, $64b1ed50d45c4df0$export$42bfa9b2d4dad91a)($e3bb69f65f89805f$var$$diff).negate().toString()
            }
        },
        track: $e3bb69f65f89805f$var$baseStyleTrack(props),
        thumb: $e3bb69f65f89805f$var$baseStyleThumb
    }));
var $e3bb69f65f89805f$var$sizes = {
    sm: $e3bb69f65f89805f$var$definePartsStyle({
        container: {
            [$e3bb69f65f89805f$var$$width.variable]: "1.375rem",
            [$e3bb69f65f89805f$var$$height.variable]: "sizes.3"
        }
    }),
    md: $e3bb69f65f89805f$var$definePartsStyle({
        container: {
            [$e3bb69f65f89805f$var$$width.variable]: "1.875rem",
            [$e3bb69f65f89805f$var$$height.variable]: "sizes.4"
        }
    }),
    lg: $e3bb69f65f89805f$var$definePartsStyle({
        container: {
            [$e3bb69f65f89805f$var$$width.variable]: "2.875rem",
            [$e3bb69f65f89805f$var$$height.variable]: "sizes.6"
        }
    })
};
var $e3bb69f65f89805f$export$6856b73e98185bff = $e3bb69f65f89805f$var$defineMultiStyleConfig({
    baseStyle: $e3bb69f65f89805f$var$baseStyle,
    sizes: $e3bb69f65f89805f$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});




"use client";
// src/component.ts
function $8082054e8b009135$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $8082054e8b009135$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}


"use client";
var { defineMultiStyleConfig: $f6e60a497ff2aec1$var$defineMultiStyleConfig, definePartsStyle: $f6e60a497ff2aec1$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$8b1b9cdd5db9f5fd).keys);
var $f6e60a497ff2aec1$var$baseStyle = $f6e60a497ff2aec1$var$definePartsStyle({
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
});
var $f6e60a497ff2aec1$var$numericStyles = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
});
var $f6e60a497ff2aec1$var$variantSimple = $f6e60a497ff2aec1$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $8082054e8b009135$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$f6e60a497ff2aec1$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$f6e60a497ff2aec1$var$numericStyles
        },
        caption: {
            color: (0, $8082054e8b009135$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $f6e60a497ff2aec1$var$variantStripe = $f6e60a497ff2aec1$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $8082054e8b009135$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$f6e60a497ff2aec1$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$f6e60a497ff2aec1$var$numericStyles
        },
        caption: {
            color: (0, $8082054e8b009135$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    },
                    td: {
                        background: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $f6e60a497ff2aec1$var$variants = {
    simple: $f6e60a497ff2aec1$var$variantSimple,
    striped: $f6e60a497ff2aec1$var$variantStripe,
    unstyled: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({})
};
var $f6e60a497ff2aec1$var$sizes = {
    sm: $f6e60a497ff2aec1$var$definePartsStyle({
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    }),
    md: $f6e60a497ff2aec1$var$definePartsStyle({
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    }),
    lg: $f6e60a497ff2aec1$var$definePartsStyle({
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    })
};
var $f6e60a497ff2aec1$export$3339219781bb5161 = $f6e60a497ff2aec1$var$defineMultiStyleConfig({
    baseStyle: $f6e60a497ff2aec1$var$baseStyle,
    variants: $f6e60a497ff2aec1$var$variants,
    sizes: $f6e60a497ff2aec1$var$sizes,
    defaultProps: {
        variant: "simple",
        size: "md",
        colorScheme: "gray"
    }
});





/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */ function $71930fd5b7ce96f5$export$864d727b48066337(low, high, value) {
    return Math.min(Math.max(low, value), high);
}
class $71930fd5b7ce96f5$var$ColorError extends Error {
    constructor(color){
        super(`Failed to parse color: "${color}"`);
    }
}
var $71930fd5b7ce96f5$export$21f8cadbc4af9bbf = $71930fd5b7ce96f5$var$ColorError;
/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */ function $71930fd5b7ce96f5$export$88c26fe48243d749(color) {
    if (typeof color !== "string") throw new $71930fd5b7ce96f5$export$21f8cadbc4af9bbf(color);
    if (color.trim().toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let normalizedColor = color.trim();
    normalizedColor = $71930fd5b7ce96f5$var$namedColorRegex.test(color) ? $71930fd5b7ce96f5$var$nameToHex(color) : color;
    const reducedHexMatch = $71930fd5b7ce96f5$var$reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
        const arr = Array.from(reducedHexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt($71930fd5b7ce96f5$var$r(x, 2), 16)),
            parseInt($71930fd5b7ce96f5$var$r(arr[3] || "f", 2), 16) / 255
        ];
    }
    const hexMatch = $71930fd5b7ce96f5$var$hexRegex.exec(normalizedColor);
    if (hexMatch) {
        const arr = Array.from(hexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 16)),
            parseInt(arr[3] || "ff", 16) / 255
        ];
    }
    const rgbaMatch = $71930fd5b7ce96f5$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
        const arr = Array.from(rgbaMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 10)),
            parseFloat(arr[3] || "1")
        ];
    }
    const hslaMatch = $71930fd5b7ce96f5$var$hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
        const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
        if ($71930fd5b7ce96f5$export$864d727b48066337(0, 100, s) !== s) throw new $71930fd5b7ce96f5$export$21f8cadbc4af9bbf(color);
        if ($71930fd5b7ce96f5$export$864d727b48066337(0, 100, l) !== l) throw new $71930fd5b7ce96f5$export$21f8cadbc4af9bbf(color);
        return [
            ...$71930fd5b7ce96f5$var$hslToRgb(h, s, l),
            Number.isNaN(a) ? 1 : a
        ];
    }
    throw new $71930fd5b7ce96f5$export$21f8cadbc4af9bbf(color);
}
function $71930fd5b7ce96f5$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return (hash >>> 0) % 2341;
}
const $71930fd5b7ce96f5$var$colorToInt = (x)=>parseInt(x.replace(/_/g, ""), 36);
const $71930fd5b7ce96f5$var$compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next)=>{
    const key = $71930fd5b7ce96f5$var$colorToInt(next.substring(0, 3));
    const hex = $71930fd5b7ce96f5$var$colorToInt(next.substring(3)).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = "";
    for(let i = 0; i < 6 - hex.length; i++)prefix += "0";
    acc[key] = `${prefix}${hex}`;
    return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */ function $71930fd5b7ce96f5$var$nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = $71930fd5b7ce96f5$var$compressedColorMap[$71930fd5b7ce96f5$var$hash(normalizedColorName)];
    if (!result) throw new $71930fd5b7ce96f5$export$21f8cadbc4af9bbf(color);
    return `#${result}`;
}
const $71930fd5b7ce96f5$var$r = (str, amount)=>Array.from(Array(amount)).map(()=>str).join("");
const $71930fd5b7ce96f5$var$reducedHexRegex = new RegExp(`^#${$71930fd5b7ce96f5$var$r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
const $71930fd5b7ce96f5$var$hexRegex = new RegExp(`^#${$71930fd5b7ce96f5$var$r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
const $71930fd5b7ce96f5$var$rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$71930fd5b7ce96f5$var$r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
const $71930fd5b7ce96f5$var$hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const $71930fd5b7ce96f5$var$namedColorRegex = /^[a-z]+$/i;
const $71930fd5b7ce96f5$var$roundColor = (color)=>{
    return Math.round(color * 255);
};
const $71930fd5b7ce96f5$var$hslToRgb = (hue, saturation, lightness)=>{
    let l = lightness / 100;
    if (saturation === 0) // achromatic
    return [
        l,
        l,
        l
    ].map($71930fd5b7ce96f5$var$roundColor);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [
        finalRed,
        finalGreen,
        finalBlue
    ].map($71930fd5b7ce96f5$var$roundColor);
};
// taken from:
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */ function $71930fd5b7ce96f5$export$c7d9b10ca8edee87(color) {
    const [red, green, blue, alpha] = $71930fd5b7ce96f5$export$88c26fe48243d749(color).map((value, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? value : value / 255);
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    // achromatic
    if (max === min) return [
        0,
        0,
        lightness,
        alpha
    ];
    const delta = max - min;
    const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
    return [
        hue,
        saturation,
        lightness,
        alpha
    ];
}
/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$810b04175080204c(hue, saturation, lightness, alpha) {
    return `hsla(${(hue % 360).toFixed()}, ${$71930fd5b7ce96f5$export$864d727b48066337(0, 100, saturation * 100).toFixed()}%, ${$71930fd5b7ce96f5$export$864d727b48066337(0, 100, lightness * 100).toFixed()}%, ${parseFloat($71930fd5b7ce96f5$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */ function $71930fd5b7ce96f5$export$2b372a09365374d6(color, degrees) {
    const [h, s, l, a] = $71930fd5b7ce96f5$export$c7d9b10ca8edee87(color);
    return $71930fd5b7ce96f5$export$810b04175080204c(h + degrees, s, l, a);
}
/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$4b073707ff63303(color, amount) {
    const [hue, saturation, lightness, alpha] = $71930fd5b7ce96f5$export$c7d9b10ca8edee87(color);
    return $71930fd5b7ce96f5$export$810b04175080204c(hue, saturation, lightness - amount, alpha);
}
/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$fb75607d98509d9(color, amount) {
    const [h, s, l, a] = $71930fd5b7ce96f5$export$c7d9b10ca8edee87(color);
    return $71930fd5b7ce96f5$export$810b04175080204c(h, s - amount, l, a);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js
/**
 * Returns a number (float) representing the luminance of a color.
 */ function $71930fd5b7ce96f5$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    function f(x) {
        const channel = x / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    const [r, g, b] = $71930fd5b7ce96f5$export$88c26fe48243d749(color);
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}
// taken from:
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */ function $71930fd5b7ce96f5$export$850ce485a60d103b(color1, color2) {
    const luminance1 = $71930fd5b7ce96f5$export$c852d90bf7403b62(color1);
    const luminance2 = $71930fd5b7ce96f5$export$c852d90bf7403b62(color2);
    return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}
/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$4e46ac54fc82cf3b(red, green, blue, alpha) {
    return `rgba(${$71930fd5b7ce96f5$export$864d727b48066337(0, 255, red).toFixed()}, ${$71930fd5b7ce96f5$export$864d727b48066337(0, 255, green).toFixed()}, ${$71930fd5b7ce96f5$export$864d727b48066337(0, 255, blue).toFixed()}, ${parseFloat($71930fd5b7ce96f5$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Mixes two colors together. Taken from sass's implementation.
 */ function $71930fd5b7ce96f5$export$2c9e8a9632a706b2(color1, color2, weight) {
    const normalize = (n, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? n : n / 255;
    const [r1, g1, b1, a1] = $71930fd5b7ce96f5$export$88c26fe48243d749(color1).map(normalize);
    const [r2, g2, b2, a2] = $71930fd5b7ce96f5$export$88c26fe48243d749(color2).map(normalize);
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    const alphaDelta = a2 - a1;
    const normalizedWeight = weight * 2 - 1;
    const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
    const weight2 = (combinedWeight + 1) / 2;
    const weight1 = 1 - weight2;
    const r = (r1 * weight1 + r2 * weight2) * 255;
    const g = (g1 * weight1 + g2 * weight2) * 255;
    const b = (b1 * weight1 + b2 * weight2) * 255;
    const a = a2 * weight + a1 * (1 - weight);
    return $71930fd5b7ce96f5$export$4e46ac54fc82cf3b(r, g, b, a);
}
/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */ function $71930fd5b7ce96f5$export$5cdac61cf538712e(...colors) {
    return (n)=>{
        const lastIndex = colors.length - 1;
        const lowIndex = $71930fd5b7ce96f5$export$864d727b48066337(0, lastIndex, Math.floor(n * lastIndex));
        const highIndex = $71930fd5b7ce96f5$export$864d727b48066337(0, lastIndex, Math.ceil(n * lastIndex));
        const color1 = colors[lowIndex];
        const color2 = colors[highIndex];
        const unit = 1 / lastIndex;
        const weight = (n - unit * lowIndex) / unit;
        return $71930fd5b7ce96f5$export$2c9e8a9632a706b2(color1, color2, weight);
    };
}
const $71930fd5b7ce96f5$var$guidelines = {
    decorative: 1.5,
    readable: 3,
    aa: 4.5,
    aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */ function $71930fd5b7ce96f5$export$f4ab80233a44f806(color, standard = "aa", background = "#fff") {
    return $71930fd5b7ce96f5$export$850ce485a60d103b(color, background) < $71930fd5b7ce96f5$var$guidelines[standard];
}
/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$c0816ed86df316af(color, amount) {
    return $71930fd5b7ce96f5$export$4b073707ff63303(color, -amount);
}
/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$d11da87e55cc498f(color, amount) {
    const [r, g, b, a] = $71930fd5b7ce96f5$export$88c26fe48243d749(color);
    return $71930fd5b7ce96f5$export$4e46ac54fc82cf3b(r, g, b, a - amount);
}
/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$f4f50e3877dd0530(color, amount) {
    return $71930fd5b7ce96f5$export$d11da87e55cc498f(color, -amount);
}
/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */ function $71930fd5b7ce96f5$export$dcb2d24cf045d06(color) {
    return $71930fd5b7ce96f5$export$c852d90bf7403b62(color) > 0.179;
}
/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */ function $71930fd5b7ce96f5$export$61654c1796c44811(color) {
    return $71930fd5b7ce96f5$export$dcb2d24cf045d06(color) ? "#000" : "#fff";
}
/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $71930fd5b7ce96f5$export$5fcac96f5a87e3db(color, amount) {
    return $71930fd5b7ce96f5$export$fb75607d98509d9(color, -amount);
}
/**
 * Takes in any color and returns it as a hex code.
 */ function $71930fd5b7ce96f5$export$7ea66e3774a60b67(color) {
    const [r, g, b, a] = $71930fd5b7ce96f5$export$88c26fe48243d749(color);
    let hex = (x)=>{
        const h = $71930fd5b7ce96f5$export$864d727b48066337(0, 255, x).toString(16);
        // NOTE: padStart could be used here but it breaks Node 6 compat
        // https://github.com/ricokahler/color2k/issues/351
        return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
/**
 * Takes in any color and returns it as an rgba string.
 */ function $71930fd5b7ce96f5$export$5db297beaffffbfc(color) {
    return $71930fd5b7ce96f5$export$4e46ac54fc82cf3b(...$71930fd5b7ce96f5$export$88c26fe48243d749(color));
}
/**
 * Takes in any color and returns it as an hsla string.
 */ function $71930fd5b7ce96f5$export$b9678a7d4ac803cc(color) {
    return $71930fd5b7ce96f5$export$810b04175080204c(...$71930fd5b7ce96f5$export$c7d9b10ca8edee87(color));
}


"use client";
// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function $e204bb335adaaa0a$var$dlv_es_default(t, e, l, n, r) {
    for(e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)t = t ? t[e[n]] : r;
    return t === r ? l : t;
}
// src/color.ts
var $e204bb335adaaa0a$var$isEmptyObject = (obj)=>Object.keys(obj).length === 0;
var $e204bb335adaaa0a$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    const hex = $e204bb335adaaa0a$var$dlv_es_default(theme, `colors.${color}`, color);
    try {
        (0, $71930fd5b7ce96f5$export$7ea66e3774a60b67)(hex);
        return hex;
    } catch  {
        return fallback != null ? fallback : "#000000";
    }
};
var $e204bb335adaaa0a$export$fdaf813cf8a11246 = (theme, color, fallback)=>{
    var _a;
    return (_a = (0, $01a983b3ad87bd07$export$93c8e06b7014dc33)(theme, "colors", color)) != null ? _a : fallback;
};
var $e204bb335adaaa0a$var$getBrightness = (color)=>{
    const [r, g, b] = (0, $71930fd5b7ce96f5$export$88c26fe48243d749)(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
};
var $e204bb335adaaa0a$export$7297c25227171a1f = (color)=>(theme)=>{
        const hex = $e204bb335adaaa0a$export$5551a2d24ff40153(theme, color);
        const brightness = $e204bb335adaaa0a$var$getBrightness(hex);
        const isDark2 = brightness < 128;
        return isDark2 ? "dark" : "light";
    };
var $e204bb335adaaa0a$export$a79ad82046afa44e = (color)=>(theme)=>$e204bb335adaaa0a$export$7297c25227171a1f(color)(theme) === "dark";
var $e204bb335adaaa0a$export$44af652f4cca9039 = (color)=>(theme)=>$e204bb335adaaa0a$export$7297c25227171a1f(color)(theme) === "light";
var $e204bb335adaaa0a$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        const raw = $e204bb335adaaa0a$export$5551a2d24ff40153(theme, color);
        return (0, $71930fd5b7ce96f5$export$d11da87e55cc498f)(raw, 1 - opacity);
    };
var $e204bb335adaaa0a$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        const raw = $e204bb335adaaa0a$export$5551a2d24ff40153(theme, color);
        return (0, $71930fd5b7ce96f5$export$7ea66e3774a60b67)((0, $71930fd5b7ce96f5$export$2c9e8a9632a706b2)(raw, "#fff", amount));
    };
var $e204bb335adaaa0a$export$2b471577c483101c = (color, amount)=>(theme)=>{
        const raw = $e204bb335adaaa0a$export$5551a2d24ff40153(theme, color);
        return (0, $71930fd5b7ce96f5$export$7ea66e3774a60b67)((0, $71930fd5b7ce96f5$export$2c9e8a9632a706b2)(raw, "#000", amount / 100));
    };
var $e204bb335adaaa0a$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        const raw = $e204bb335adaaa0a$export$5551a2d24ff40153(theme, color);
        return (0, $71930fd5b7ce96f5$export$7ea66e3774a60b67)((0, $71930fd5b7ce96f5$export$4b073707ff63303)(raw, amount / 100));
    };
var $e204bb335adaaa0a$export$c0816ed86df316af = (color, amount)=>(theme)=>{
        const raw = $e204bb335adaaa0a$export$5551a2d24ff40153(theme, color);
        (0, $71930fd5b7ce96f5$export$7ea66e3774a60b67)((0, $71930fd5b7ce96f5$export$c0816ed86df316af)(raw, amount / 100));
    };
var $e204bb335adaaa0a$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, $71930fd5b7ce96f5$export$850ce485a60d103b)($e204bb335adaaa0a$export$5551a2d24ff40153(theme, bg), $e204bb335adaaa0a$export$5551a2d24ff40153(theme, fg));
var $e204bb335adaaa0a$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>$e204bb335adaaa0a$export$3fe5b5ca1e6a6a28($e204bb335adaaa0a$export$5551a2d24ff40153(theme, bgColor), $e204bb335adaaa0a$export$5551a2d24ff40153(theme, textColor), options);
function $e204bb335adaaa0a$export$3fe5b5ca1e6a6a28(color1, color2, wcag2 = {
    level: "AA",
    size: "small"
}) {
    var _a, _b;
    const readabilityLevel = $e204bb335adaaa0a$export$b7b705aaad1c5b6a(color1, color2);
    switch(((_a = wcag2.level) != null ? _a : "AA") + ((_b = wcag2.size) != null ? _b : "small")){
        case "AAsmall":
        case "AAAlarge":
            return readabilityLevel >= 4.5;
        case "AAlarge":
            return readabilityLevel >= 3;
        case "AAAsmall":
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $e204bb335adaaa0a$export$b7b705aaad1c5b6a(color1, color2) {
    return (Math.max((0, $71930fd5b7ce96f5$export$c852d90bf7403b62)(color1), (0, $71930fd5b7ce96f5$export$c852d90bf7403b62)(color2)) + 0.05) / (Math.min((0, $71930fd5b7ce96f5$export$c852d90bf7403b62)(color1), (0, $71930fd5b7ce96f5$export$c852d90bf7403b62)(color2)) + 0.05);
}
var $e204bb335adaaa0a$export$504efcfbebdbcaf = (color)=>(theme)=>{
        const raw = $e204bb335adaaa0a$export$5551a2d24ff40153(theme, color);
        const hsl = (0, $71930fd5b7ce96f5$export$c7d9b10ca8edee87)(raw);
        const complementHsl = Object.assign(hsl, [
            (hsl[0] + 180) % 360
        ]);
        return (0, $71930fd5b7ce96f5$export$7ea66e3774a60b67)((0, $71930fd5b7ce96f5$export$810b04175080204c)(...complementHsl));
    };
function $e204bb335adaaa0a$export$db0ffb03ee9f3080(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
        backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
        backgroundSize: `${size} ${size}`
    };
}
var $e204bb335adaaa0a$var$randomHex = ()=>`#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function $e204bb335adaaa0a$export$f3c6ed4330abfc18(opts) {
    const fallback = $e204bb335adaaa0a$var$randomHex();
    if (!opts || $e204bb335adaaa0a$var$isEmptyObject(opts)) return fallback;
    if (opts.string && opts.colors) return $e204bb335adaaa0a$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $e204bb335adaaa0a$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $e204bb335adaaa0a$var$randomFromList(opts.colors);
    return fallback;
}
function $e204bb335adaaa0a$var$randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for(let i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let j = 0; j < 3; j += 1){
        const value = hash >> j * 8 & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
}
function $e204bb335adaaa0a$var$randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0) return list[0];
    for(let i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $e204bb335adaaa0a$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}


"use client";
var $2d82814d085c9104$var$$fg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tabs-color");
var $2d82814d085c9104$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tabs-bg");
var $2d82814d085c9104$var$$border = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tabs-border-color");
var { defineMultiStyleConfig: $2d82814d085c9104$var$defineMultiStyleConfig, definePartsStyle: $2d82814d085c9104$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$97383552563be58d).keys);
var $2d82814d085c9104$var$baseStyleRoot = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
});
var $2d82814d085c9104$var$baseStyleTab = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : void 0,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
            zIndex: 1,
            boxShadow: "outline"
        },
        _disabled: {
            cursor: "not-allowed",
            opacity: 0.4
        }
    };
});
var $2d82814d085c9104$var$baseStyleTablist = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { align: align = "start", orientation: orientation } = props;
    const alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
});
var $2d82814d085c9104$var$baseStyleTabpanel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    p: 4
});
var $2d82814d085c9104$var$baseStyle = $2d82814d085c9104$var$definePartsStyle((props)=>({
        root: $2d82814d085c9104$var$baseStyleRoot(props),
        tab: $2d82814d085c9104$var$baseStyleTab(props),
        tablist: $2d82814d085c9104$var$baseStyleTablist(props),
        tabpanel: $2d82814d085c9104$var$baseStyleTabpanel
    }));
var $2d82814d085c9104$var$sizes = {
    sm: $2d82814d085c9104$var$definePartsStyle({
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    }),
    md: $2d82814d085c9104$var$definePartsStyle({
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    }),
    lg: $2d82814d085c9104$var$definePartsStyle({
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    })
};
var $2d82814d085c9104$var$variantLine = $2d82814d085c9104$var$definePartsStyle((props)=>{
    const { colorScheme: c, orientation: orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                [$2d82814d085c9104$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$2d82814d085c9104$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "currentColor"
            },
            _active: {
                [$2d82814d085c9104$var$$bg.variable]: "colors.gray.200",
                _dark: {
                    [$2d82814d085c9104$var$$bg.variable]: "colors.whiteAlpha.300"
                }
            },
            _disabled: {
                _active: {
                    bg: "none"
                }
            },
            color: $2d82814d085c9104$var$$fg.reference,
            bg: $2d82814d085c9104$var$$bg.reference
        }
    };
});
var $2d82814d085c9104$var$variantEnclosed = $2d82814d085c9104$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            [$2d82814d085c9104$var$$border.variable]: "transparent",
            _selected: {
                [$2d82814d085c9104$var$$fg.variable]: `colors.${c}.600`,
                [$2d82814d085c9104$var$$border.variable]: `colors.white`,
                _dark: {
                    [$2d82814d085c9104$var$$fg.variable]: `colors.${c}.300`,
                    [$2d82814d085c9104$var$$border.variable]: `colors.gray.800`
                },
                borderColor: "inherit",
                borderBottomColor: $2d82814d085c9104$var$$border.reference
            },
            color: $2d82814d085c9104$var$$fg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $2d82814d085c9104$var$variantEnclosedColored = $2d82814d085c9104$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            [$2d82814d085c9104$var$$bg.variable]: "colors.gray.50",
            _dark: {
                [$2d82814d085c9104$var$$bg.variable]: "colors.whiteAlpha.50"
            },
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                [$2d82814d085c9104$var$$bg.variable]: "colors.white",
                [$2d82814d085c9104$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$2d82814d085c9104$var$$bg.variable]: "colors.gray.800",
                    [$2d82814d085c9104$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            },
            color: $2d82814d085c9104$var$$fg.reference,
            bg: $2d82814d085c9104$var$$bg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $2d82814d085c9104$var$variantSoftRounded = $2d82814d085c9104$var$definePartsStyle((props)=>{
    const { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, `${c}.700`),
                bg: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, `${c}.100`)
            }
        }
    };
});
var $2d82814d085c9104$var$variantSolidRounded = $2d82814d085c9104$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            [$2d82814d085c9104$var$$fg.variable]: "colors.gray.600",
            _dark: {
                [$2d82814d085c9104$var$$fg.variable]: "inherit"
            },
            _selected: {
                [$2d82814d085c9104$var$$fg.variable]: "colors.white",
                [$2d82814d085c9104$var$$bg.variable]: `colors.${c}.600`,
                _dark: {
                    [$2d82814d085c9104$var$$fg.variable]: "colors.gray.800",
                    [$2d82814d085c9104$var$$bg.variable]: `colors.${c}.300`
                }
            },
            color: $2d82814d085c9104$var$$fg.reference,
            bg: $2d82814d085c9104$var$$bg.reference
        }
    };
});
var $2d82814d085c9104$var$variantUnstyled = $2d82814d085c9104$var$definePartsStyle({});
var $2d82814d085c9104$var$variants = {
    line: $2d82814d085c9104$var$variantLine,
    enclosed: $2d82814d085c9104$var$variantEnclosed,
    "enclosed-colored": $2d82814d085c9104$var$variantEnclosedColored,
    "soft-rounded": $2d82814d085c9104$var$variantSoftRounded,
    "solid-rounded": $2d82814d085c9104$var$variantSolidRounded,
    unstyled: $2d82814d085c9104$var$variantUnstyled
};
var $2d82814d085c9104$export$847a245e7ebce2a1 = $2d82814d085c9104$var$defineMultiStyleConfig({
    baseStyle: $2d82814d085c9104$var$baseStyle,
    sizes: $2d82814d085c9104$var$sizes,
    variants: $2d82814d085c9104$var$variants,
    defaultProps: {
        size: "md",
        variant: "line",
        colorScheme: "blue"
    }
});




"use client";
var $a911a67ae6d2c889$export$3cb96c9f6c8d16a4 = (0, $01a983b3ad87bd07$export$bd40561c6c056841)("badge", [
    "bg",
    "color",
    "shadow"
]);
var $a911a67ae6d2c889$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: $a911a67ae6d2c889$export$3cb96c9f6c8d16a4.bg.reference,
    color: $a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.reference,
    boxShadow: $a911a67ae6d2c889$export$3cb96c9f6c8d16a4.shadow.reference
});
var $a911a67ae6d2c889$var$variantSolid = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const dark = (0, $e204bb335adaaa0a$export$d11da87e55cc498f)(`${c}.500`, 0.6)(theme);
    return {
        [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.500`,
        [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.variable]: `colors.white`,
        _dark: {
            [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.bg.variable]: dark,
            [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.variable]: `colors.whiteAlpha.800`
        }
    };
});
var $a911a67ae6d2c889$var$variantSubtle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkBg = (0, $e204bb335adaaa0a$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.100`,
        [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.800`,
        _dark: {
            [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.bg.variable]: darkBg,
            [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.200`
        }
    };
});
var $a911a67ae6d2c889$var$variantOutline = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkColor = (0, $e204bb335adaaa0a$export$d11da87e55cc498f)(`${c}.200`, 0.8)(theme);
    return {
        [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.500`,
        _dark: {
            [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.variable]: darkColor
        },
        [$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.shadow.variable]: `inset 0 0 0px 1px ${$a911a67ae6d2c889$export$3cb96c9f6c8d16a4.color.reference}`
    };
});
var $a911a67ae6d2c889$var$variants = {
    solid: $a911a67ae6d2c889$var$variantSolid,
    subtle: $a911a67ae6d2c889$var$variantSubtle,
    outline: $a911a67ae6d2c889$var$variantOutline
};
var $a911a67ae6d2c889$export$eb6e7cbc82d0f88b = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $a911a67ae6d2c889$var$baseStyle,
    variants: $a911a67ae6d2c889$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "gray"
    }
});




"use client";
var { defineMultiStyleConfig: $e9b6b31835b11b4c$var$defineMultiStyleConfig, definePartsStyle: $e9b6b31835b11b4c$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$4c2f5f7f2ea94a8e).keys);
var $e9b6b31835b11b4c$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tag-bg");
var $e9b6b31835b11b4c$var$$color = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tag-color");
var $e9b6b31835b11b4c$var$$shadow = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tag-shadow");
var $e9b6b31835b11b4c$var$$minH = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tag-min-height");
var $e9b6b31835b11b4c$var$$minW = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tag-min-width");
var $e9b6b31835b11b4c$var$$fontSize = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tag-font-size");
var $e9b6b31835b11b4c$var$$paddingX = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("tag-padding-inline");
var $e9b6b31835b11b4c$var$baseStyleContainer = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$e9b6b31835b11b4c$var$$color.variable]: (0, $a911a67ae6d2c889$export$3cb96c9f6c8d16a4).color.reference,
    [$e9b6b31835b11b4c$var$$bg.variable]: (0, $a911a67ae6d2c889$export$3cb96c9f6c8d16a4).bg.reference,
    [$e9b6b31835b11b4c$var$$shadow.variable]: (0, $a911a67ae6d2c889$export$3cb96c9f6c8d16a4).shadow.reference,
    color: $e9b6b31835b11b4c$var$$color.reference,
    bg: $e9b6b31835b11b4c$var$$bg.reference,
    boxShadow: $e9b6b31835b11b4c$var$$shadow.reference,
    borderRadius: "md",
    minH: $e9b6b31835b11b4c$var$$minH.reference,
    minW: $e9b6b31835b11b4c$var$$minW.reference,
    fontSize: $e9b6b31835b11b4c$var$$fontSize.reference,
    px: $e9b6b31835b11b4c$var$$paddingX.reference,
    _focusVisible: {
        [$e9b6b31835b11b4c$var$$shadow.variable]: "shadows.outline"
    }
});
var $e9b6b31835b11b4c$var$baseStyleLabel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    lineHeight: 1.2,
    overflow: "visible"
});
var $e9b6b31835b11b4c$var$baseStyleCloseButton = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focusVisible: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
});
var $e9b6b31835b11b4c$var$baseStyle = $e9b6b31835b11b4c$var$definePartsStyle({
    container: $e9b6b31835b11b4c$var$baseStyleContainer,
    label: $e9b6b31835b11b4c$var$baseStyleLabel,
    closeButton: $e9b6b31835b11b4c$var$baseStyleCloseButton
});
var $e9b6b31835b11b4c$var$sizes = {
    sm: $e9b6b31835b11b4c$var$definePartsStyle({
        container: {
            [$e9b6b31835b11b4c$var$$minH.variable]: "sizes.5",
            [$e9b6b31835b11b4c$var$$minW.variable]: "sizes.5",
            [$e9b6b31835b11b4c$var$$fontSize.variable]: "fontSizes.xs",
            [$e9b6b31835b11b4c$var$$paddingX.variable]: "space.2"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    }),
    md: $e9b6b31835b11b4c$var$definePartsStyle({
        container: {
            [$e9b6b31835b11b4c$var$$minH.variable]: "sizes.6",
            [$e9b6b31835b11b4c$var$$minW.variable]: "sizes.6",
            [$e9b6b31835b11b4c$var$$fontSize.variable]: "fontSizes.sm",
            [$e9b6b31835b11b4c$var$$paddingX.variable]: "space.2"
        }
    }),
    lg: $e9b6b31835b11b4c$var$definePartsStyle({
        container: {
            [$e9b6b31835b11b4c$var$$minH.variable]: "sizes.8",
            [$e9b6b31835b11b4c$var$$minW.variable]: "sizes.8",
            [$e9b6b31835b11b4c$var$$fontSize.variable]: "fontSizes.md",
            [$e9b6b31835b11b4c$var$$paddingX.variable]: "space.3"
        }
    })
};
var $e9b6b31835b11b4c$var$variants = {
    subtle: $e9b6b31835b11b4c$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $a911a67ae6d2c889$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.subtle(props)
        };
    }),
    solid: $e9b6b31835b11b4c$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $a911a67ae6d2c889$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.solid(props)
        };
    }),
    outline: $e9b6b31835b11b4c$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $a911a67ae6d2c889$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.outline(props)
        };
    })
};
var $e9b6b31835b11b4c$export$f8ab9ac2a319695b = $e9b6b31835b11b4c$var$defineMultiStyleConfig({
    variants: $e9b6b31835b11b4c$var$variants,
    baseStyle: $e9b6b31835b11b4c$var$baseStyle,
    sizes: $e9b6b31835b11b4c$var$sizes,
    defaultProps: {
        size: "md",
        variant: "subtle",
        colorScheme: "gray"
    }
});





"use client";
var { definePartsStyle: $846cf22ac3b45cdd$var$definePartsStyle, defineMultiStyleConfig: $846cf22ac3b45cdd$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$1ffeb100b532f46d).keys);
var $846cf22ac3b45cdd$var$$height = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("input-height");
var $846cf22ac3b45cdd$var$$fontSize = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("input-font-size");
var $846cf22ac3b45cdd$var$$padding = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("input-padding");
var $846cf22ac3b45cdd$var$$borderRadius = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("input-border-radius");
var $846cf22ac3b45cdd$var$baseStyle = $846cf22ac3b45cdd$var$definePartsStyle({
    addon: {
        height: $846cf22ac3b45cdd$var$$height.reference,
        fontSize: $846cf22ac3b45cdd$var$$fontSize.reference,
        px: $846cf22ac3b45cdd$var$$padding.reference,
        borderRadius: $846cf22ac3b45cdd$var$$borderRadius.reference
    },
    field: {
        width: "100%",
        height: $846cf22ac3b45cdd$var$$height.reference,
        fontSize: $846cf22ac3b45cdd$var$$fontSize.reference,
        px: $846cf22ac3b45cdd$var$$padding.reference,
        borderRadius: $846cf22ac3b45cdd$var$$borderRadius.reference,
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    }
});
var $846cf22ac3b45cdd$var$size = {
    lg: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$846cf22ac3b45cdd$var$$fontSize.variable]: "fontSizes.lg",
        [$846cf22ac3b45cdd$var$$padding.variable]: "space.4",
        [$846cf22ac3b45cdd$var$$borderRadius.variable]: "radii.md",
        [$846cf22ac3b45cdd$var$$height.variable]: "sizes.12"
    }),
    md: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$846cf22ac3b45cdd$var$$fontSize.variable]: "fontSizes.md",
        [$846cf22ac3b45cdd$var$$padding.variable]: "space.4",
        [$846cf22ac3b45cdd$var$$borderRadius.variable]: "radii.md",
        [$846cf22ac3b45cdd$var$$height.variable]: "sizes.10"
    }),
    sm: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$846cf22ac3b45cdd$var$$fontSize.variable]: "fontSizes.sm",
        [$846cf22ac3b45cdd$var$$padding.variable]: "space.3",
        [$846cf22ac3b45cdd$var$$borderRadius.variable]: "radii.sm",
        [$846cf22ac3b45cdd$var$$height.variable]: "sizes.8"
    }),
    xs: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$846cf22ac3b45cdd$var$$fontSize.variable]: "fontSizes.xs",
        [$846cf22ac3b45cdd$var$$padding.variable]: "space.2",
        [$846cf22ac3b45cdd$var$$borderRadius.variable]: "radii.sm",
        [$846cf22ac3b45cdd$var$$height.variable]: "sizes.6"
    })
};
var $846cf22ac3b45cdd$var$sizes = {
    lg: $846cf22ac3b45cdd$var$definePartsStyle({
        field: $846cf22ac3b45cdd$var$size.lg,
        group: $846cf22ac3b45cdd$var$size.lg
    }),
    md: $846cf22ac3b45cdd$var$definePartsStyle({
        field: $846cf22ac3b45cdd$var$size.md,
        group: $846cf22ac3b45cdd$var$size.md
    }),
    sm: $846cf22ac3b45cdd$var$definePartsStyle({
        field: $846cf22ac3b45cdd$var$size.sm,
        group: $846cf22ac3b45cdd$var$size.sm
    }),
    xs: $846cf22ac3b45cdd$var$definePartsStyle({
        field: $846cf22ac3b45cdd$var$size.xs,
        group: $846cf22ac3b45cdd$var$size.xs
    })
};
function $846cf22ac3b45cdd$var$getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $8082054e8b009135$export$549ff81930776885)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $8082054e8b009135$export$549ff81930776885)("red.500", "red.300")(props)
    };
}
var $846cf22ac3b45cdd$var$variantOutline = $846cf22ac3b45cdd$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $846cf22ac3b45cdd$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $8082054e8b009135$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0 0 0 1px ${(0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                zIndex: 1,
                borderColor: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0 0 0 1px ${(0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)("inherit", "whiteAlpha.50")(props),
            bg: (0, $8082054e8b009135$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
        }
    };
});
var $846cf22ac3b45cdd$var$variantFilled = $846cf22ac3b45cdd$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $846cf22ac3b45cdd$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $8082054e8b009135$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $8082054e8b009135$export$549ff81930776885)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, ec)
            },
            _focusVisible: {
                bg: "transparent",
                borderColor: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $8082054e8b009135$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props)
        }
    };
});
var $846cf22ac3b45cdd$var$variantFlushed = $846cf22ac3b45cdd$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $846cf22ac3b45cdd$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0px 1px 0px 0px ${(0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                borderColor: (0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0px 1px 0px 0px ${(0, $e204bb335adaaa0a$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent"
        }
    };
});
var $846cf22ac3b45cdd$var$variantUnstyled = $846cf22ac3b45cdd$var$definePartsStyle({
    field: {
        bg: "transparent",
        px: "0",
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: "0",
        height: "auto"
    }
});
var $846cf22ac3b45cdd$var$variants = {
    outline: $846cf22ac3b45cdd$var$variantOutline,
    filled: $846cf22ac3b45cdd$var$variantFilled,
    flushed: $846cf22ac3b45cdd$var$variantFlushed,
    unstyled: $846cf22ac3b45cdd$var$variantUnstyled
};
var $846cf22ac3b45cdd$export$b1b9f3bced726e54 = $846cf22ac3b45cdd$var$defineMultiStyleConfig({
    baseStyle: $846cf22ac3b45cdd$var$baseStyle,
    sizes: $846cf22ac3b45cdd$var$sizes,
    variants: $846cf22ac3b45cdd$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});



"use client";
var $d2d1cb6244bb50b7$var$_a;
var $d2d1cb6244bb50b7$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    ...($d2d1cb6244bb50b7$var$_a = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $d2d1cb6244bb50b7$var$_a.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
});
var $d2d1cb6244bb50b7$var$_a2, $d2d1cb6244bb50b7$var$_b;
var $d2d1cb6244bb50b7$var$variants = {
    outline: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.outline(props).field) != null ? _b3 : {};
    }),
    flushed: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.flushed(props).field) != null ? _b3 : {};
    }),
    filled: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.filled(props).field) != null ? _b3 : {};
    }),
    unstyled: ($d2d1cb6244bb50b7$var$_b = ($d2d1cb6244bb50b7$var$_a2 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : $d2d1cb6244bb50b7$var$_a2.unstyled.field) != null ? $d2d1cb6244bb50b7$var$_b : {}
};
var $d2d1cb6244bb50b7$var$_a3, $d2d1cb6244bb50b7$var$_b2, $d2d1cb6244bb50b7$var$_c, $d2d1cb6244bb50b7$var$_d, $d2d1cb6244bb50b7$var$_e, $d2d1cb6244bb50b7$var$_f, $d2d1cb6244bb50b7$var$_g, $d2d1cb6244bb50b7$var$_h;
var $d2d1cb6244bb50b7$var$sizes = {
    xs: ($d2d1cb6244bb50b7$var$_b2 = ($d2d1cb6244bb50b7$var$_a3 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $d2d1cb6244bb50b7$var$_a3.xs.field) != null ? $d2d1cb6244bb50b7$var$_b2 : {},
    sm: ($d2d1cb6244bb50b7$var$_d = ($d2d1cb6244bb50b7$var$_c = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $d2d1cb6244bb50b7$var$_c.sm.field) != null ? $d2d1cb6244bb50b7$var$_d : {},
    md: ($d2d1cb6244bb50b7$var$_f = ($d2d1cb6244bb50b7$var$_e = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $d2d1cb6244bb50b7$var$_e.md.field) != null ? $d2d1cb6244bb50b7$var$_f : {},
    lg: ($d2d1cb6244bb50b7$var$_h = ($d2d1cb6244bb50b7$var$_g = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $d2d1cb6244bb50b7$var$_g.lg.field) != null ? $d2d1cb6244bb50b7$var$_h : {}
};
var $d2d1cb6244bb50b7$export$394b8322fab774c1 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $d2d1cb6244bb50b7$var$baseStyle,
    sizes: $d2d1cb6244bb50b7$var$sizes,
    variants: $d2d1cb6244bb50b7$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});




"use client";
var $584e03ef2dd8e988$var$$bg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("tooltip-bg");
var $584e03ef2dd8e988$var$$fg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("tooltip-fg");
var $584e03ef2dd8e988$var$$arrowBg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("popper-arrow-bg");
var $584e03ef2dd8e988$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    bg: $584e03ef2dd8e988$var$$bg.reference,
    color: $584e03ef2dd8e988$var$$fg.reference,
    [$584e03ef2dd8e988$var$$bg.variable]: "colors.gray.700",
    [$584e03ef2dd8e988$var$$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
        [$584e03ef2dd8e988$var$$bg.variable]: "colors.gray.300",
        [$584e03ef2dd8e988$var$$fg.variable]: "colors.gray.900"
    },
    [$584e03ef2dd8e988$var$$arrowBg.variable]: $584e03ef2dd8e988$var$$bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
});
var $584e03ef2dd8e988$export$7472a7883840b563 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $584e03ef2dd8e988$var$baseStyle
});





"use client";
var { defineMultiStyleConfig: $4f18b54ebe330039$var$defineMultiStyleConfig, definePartsStyle: $4f18b54ebe330039$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$ba6328c242bd649c).keys);
var $4f18b54ebe330039$var$filledStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    const stripeStyle = (0, $8082054e8b009135$export$549ff81930776885)((0, $e204bb335adaaa0a$export$db0ffb03ee9f3080)(), (0, $e204bb335adaaa0a$export$db0ffb03ee9f3080)("1rem", "rgba(0,0,0,0.1)"))(props);
    const bgColor = (0, $8082054e8b009135$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, $e204bb335adaaa0a$export$5551a2d24ff40153)(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
        ...addStripe && stripeStyle,
        ...isIndeterminate ? {
            bgImage: gradient
        } : {
            bgColor: bgColor
        }
    };
});
var $4f18b54ebe330039$var$baseStyleLabel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
});
var $4f18b54ebe330039$var$baseStyleTrack = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    return {
        bg: (0, $8082054e8b009135$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
    };
});
var $4f18b54ebe330039$var$baseStyleFilledTrack = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    return {
        transitionProperty: "common",
        transitionDuration: "slow",
        ...$4f18b54ebe330039$var$filledStyle(props)
    };
});
var $4f18b54ebe330039$var$baseStyle = $4f18b54ebe330039$var$definePartsStyle((props)=>({
        label: $4f18b54ebe330039$var$baseStyleLabel,
        filledTrack: $4f18b54ebe330039$var$baseStyleFilledTrack(props),
        track: $4f18b54ebe330039$var$baseStyleTrack(props)
    }));
var $4f18b54ebe330039$var$sizes = {
    xs: $4f18b54ebe330039$var$definePartsStyle({
        track: {
            h: "1"
        }
    }),
    sm: $4f18b54ebe330039$var$definePartsStyle({
        track: {
            h: "2"
        }
    }),
    md: $4f18b54ebe330039$var$definePartsStyle({
        track: {
            h: "3"
        }
    }),
    lg: $4f18b54ebe330039$var$definePartsStyle({
        track: {
            h: "4"
        }
    })
};
var $4f18b54ebe330039$export$dc04d8e6a17afea1 = $4f18b54ebe330039$var$defineMultiStyleConfig({
    sizes: $4f18b54ebe330039$var$sizes,
    baseStyle: $4f18b54ebe330039$var$baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


"use client";
// src/utils/run-if-fn.ts
var $5cd80c5f093c55ed$var$isFunction = (value)=>typeof value === "function";
function $5cd80c5f093c55ed$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $5cd80c5f093c55ed$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}





"use client";
var { definePartsStyle: $61fd30b3ec317514$var$definePartsStyle, defineMultiStyleConfig: $61fd30b3ec317514$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$21946b04497ed6ac).keys);
var $61fd30b3ec317514$var$$size = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("checkbox-size");
var $61fd30b3ec317514$var$baseStyleControl = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        w: $61fd30b3ec317514$var$$size.reference,
        h: $61fd30b3ec317514$var$$size.reference,
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $8082054e8b009135$export$549ff81930776885)("white", "gray.900")(props),
            _hover: {
                bg: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props),
                borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props)
            },
            _disabled: {
                borderColor: (0, $8082054e8b009135$export$549ff81930776885)("gray.200", "transparent")(props),
                bg: (0, $8082054e8b009135$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                color: (0, $8082054e8b009135$export$549ff81930776885)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $8082054e8b009135$export$549ff81930776885)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)("gray.100", "transparent")(props)
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $8082054e8b009135$export$549ff81930776885)("red.500", "red.300")(props)
        }
    };
});
var $61fd30b3ec317514$var$baseStyleContainer = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    _disabled: {
        cursor: "not-allowed"
    }
});
var $61fd30b3ec317514$var$baseStyleLabel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
});
var $61fd30b3ec317514$var$baseStyleIcon = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    transitionProperty: "transform",
    transitionDuration: "normal"
});
var $61fd30b3ec317514$var$baseStyle = $61fd30b3ec317514$var$definePartsStyle((props)=>({
        icon: $61fd30b3ec317514$var$baseStyleIcon,
        container: $61fd30b3ec317514$var$baseStyleContainer,
        control: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($61fd30b3ec317514$var$baseStyleControl, props),
        label: $61fd30b3ec317514$var$baseStyleLabel
    }));
var $61fd30b3ec317514$var$sizes = {
    sm: $61fd30b3ec317514$var$definePartsStyle({
        control: {
            [$61fd30b3ec317514$var$$size.variable]: "sizes.3"
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "3xs"
        }
    }),
    md: $61fd30b3ec317514$var$definePartsStyle({
        control: {
            [$61fd30b3ec317514$var$$size.variable]: "sizes.4"
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "2xs"
        }
    }),
    lg: $61fd30b3ec317514$var$definePartsStyle({
        control: {
            [$61fd30b3ec317514$var$$size.variable]: "sizes.5"
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "2xs"
        }
    })
};
var $61fd30b3ec317514$export$86286d8c37984115 = $61fd30b3ec317514$var$defineMultiStyleConfig({
    baseStyle: $61fd30b3ec317514$var$baseStyle,
    sizes: $61fd30b3ec317514$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





"use client";
var { defineMultiStyleConfig: $411e979a43979d78$var$defineMultiStyleConfig, definePartsStyle: $411e979a43979d78$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$d28d06d0e29ef022).keys);
var $411e979a43979d78$var$baseStyleControl = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const controlStyle = (_a = (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)((0, $61fd30b3ec317514$export$86286d8c37984115).baseStyle, props)) == null ? void 0 : _a.control;
    return {
        ...controlStyle,
        borderRadius: "full",
        _checked: {
            ...controlStyle == null ? void 0 : controlStyle["_checked"],
            _before: {
                content: `""`,
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        }
    };
});
var $411e979a43979d78$var$baseStyle = $411e979a43979d78$var$definePartsStyle((props)=>{
    var _a, _b, _c, _d;
    return {
        label: (_b = (_a = (0, $61fd30b3ec317514$export$86286d8c37984115)).baseStyle) == null ? void 0 : _b.call(_a, props).label,
        container: (_d = (_c = (0, $61fd30b3ec317514$export$86286d8c37984115)).baseStyle) == null ? void 0 : _d.call(_c, props).container,
        control: $411e979a43979d78$var$baseStyleControl(props)
    };
});
var $411e979a43979d78$var$sizes = {
    md: $411e979a43979d78$var$definePartsStyle({
        control: {
            w: "4",
            h: "4"
        },
        label: {
            fontSize: "md"
        }
    }),
    lg: $411e979a43979d78$var$definePartsStyle({
        control: {
            w: "5",
            h: "5"
        },
        label: {
            fontSize: "lg"
        }
    }),
    sm: $411e979a43979d78$var$definePartsStyle({
        control: {
            width: "3",
            height: "3"
        },
        label: {
            fontSize: "sm"
        }
    })
};
var $411e979a43979d78$export$f0b387b940941887 = $411e979a43979d78$var$defineMultiStyleConfig({
    baseStyle: $411e979a43979d78$var$baseStyle,
    sizes: $411e979a43979d78$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





"use client";
var { defineMultiStyleConfig: $ae39e675d135eedf$var$defineMultiStyleConfig, definePartsStyle: $ae39e675d135eedf$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$17993f0be9538b5a).keys);
var $ae39e675d135eedf$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("select-bg");
var $ae39e675d135eedf$var$_a;
var $ae39e675d135eedf$var$baseStyleField = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    ...($ae39e675d135eedf$var$_a = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $ae39e675d135eedf$var$_a.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $ae39e675d135eedf$var$$bg.reference,
    [$ae39e675d135eedf$var$$bg.variable]: "colors.white",
    _dark: {
        [$ae39e675d135eedf$var$$bg.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
        bg: $ae39e675d135eedf$var$$bg.reference
    }
});
var $ae39e675d135eedf$var$baseStyleIcon = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
        opacity: 0.5
    }
});
var $ae39e675d135eedf$var$baseStyle = $ae39e675d135eedf$var$definePartsStyle({
    field: $ae39e675d135eedf$var$baseStyleField,
    icon: $ae39e675d135eedf$var$baseStyleIcon
});
var $ae39e675d135eedf$var$iconSpacing = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    paddingInlineEnd: "8"
});
var $ae39e675d135eedf$var$_a2, $ae39e675d135eedf$var$_b, $ae39e675d135eedf$var$_c, $ae39e675d135eedf$var$_d, $ae39e675d135eedf$var$_e, $ae39e675d135eedf$var$_f, $ae39e675d135eedf$var$_g, $ae39e675d135eedf$var$_h;
var $ae39e675d135eedf$var$sizes = {
    lg: {
        ...($ae39e675d135eedf$var$_a2 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_a2.lg,
        field: {
            ...($ae39e675d135eedf$var$_b = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_b.lg.field,
            ...$ae39e675d135eedf$var$iconSpacing
        }
    },
    md: {
        ...($ae39e675d135eedf$var$_c = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_c.md,
        field: {
            ...($ae39e675d135eedf$var$_d = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_d.md.field,
            ...$ae39e675d135eedf$var$iconSpacing
        }
    },
    sm: {
        ...($ae39e675d135eedf$var$_e = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_e.sm,
        field: {
            ...($ae39e675d135eedf$var$_f = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_f.sm.field,
            ...$ae39e675d135eedf$var$iconSpacing
        }
    },
    xs: {
        ...($ae39e675d135eedf$var$_g = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_g.xs,
        field: {
            ...($ae39e675d135eedf$var$_h = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : $ae39e675d135eedf$var$_h.xs.field,
            ...$ae39e675d135eedf$var$iconSpacing
        },
        icon: {
            insetEnd: "1"
        }
    }
};
var $ae39e675d135eedf$export$21af0fc3c16183e1 = $ae39e675d135eedf$var$defineMultiStyleConfig({
    baseStyle: $ae39e675d135eedf$var$baseStyle,
    sizes: $ae39e675d135eedf$var$sizes,
    variants: (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).defaultProps
});



"use client";
var $558e9ba631bf4f3f$var$$startColor = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("skeleton-start-color");
var $558e9ba631bf4f3f$var$$endColor = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("skeleton-end-color");
var $558e9ba631bf4f3f$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    [$558e9ba631bf4f3f$var$$startColor.variable]: "colors.gray.100",
    [$558e9ba631bf4f3f$var$$endColor.variable]: "colors.gray.400",
    _dark: {
        [$558e9ba631bf4f3f$var$$startColor.variable]: "colors.gray.800",
        [$558e9ba631bf4f3f$var$$endColor.variable]: "colors.gray.600"
    },
    background: $558e9ba631bf4f3f$var$$startColor.reference,
    borderColor: $558e9ba631bf4f3f$var$$endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
});
var $558e9ba631bf4f3f$export$7680371ad2d79142 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $558e9ba631bf4f3f$var$baseStyle
});



"use client";
var $18146315fbe1ba22$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("skip-link-bg");
var $18146315fbe1ba22$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
        boxShadow: "outline",
        padding: "4",
        position: "fixed",
        top: "6",
        insetStart: "6",
        [$18146315fbe1ba22$var$$bg.variable]: "colors.white",
        _dark: {
            [$18146315fbe1ba22$var$$bg.variable]: "colors.gray.700"
        },
        bg: $18146315fbe1ba22$var$$bg.reference
    }
});
var $18146315fbe1ba22$export$a8cf3228ef52959 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $18146315fbe1ba22$var$baseStyle
});





"use client";
var { defineMultiStyleConfig: $2ad9cdad15c1a93e$var$defineMultiStyleConfig, definePartsStyle: $2ad9cdad15c1a93e$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$c21b4b3f8b239f32).keys);
var $2ad9cdad15c1a93e$var$$thumbSize = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("slider-thumb-size");
var $2ad9cdad15c1a93e$var$$trackSize = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("slider-track-size");
var $2ad9cdad15c1a93e$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("slider-bg");
var $2ad9cdad15c1a93e$var$baseStyleContainer = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        },
        ...(0, $8082054e8b009135$export$f3eec17ee6065eee)({
            orientation: orientation,
            vertical: {
                h: "100%"
            },
            horizontal: {
                w: "100%"
            }
        })
    };
});
var $2ad9cdad15c1a93e$var$baseStyleTrack = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const orientationStyles = (0, $8082054e8b009135$export$f3eec17ee6065eee)({
        orientation: props.orientation,
        horizontal: {
            h: $2ad9cdad15c1a93e$var$$trackSize.reference
        },
        vertical: {
            w: $2ad9cdad15c1a93e$var$$trackSize.reference
        }
    });
    return {
        ...orientationStyles,
        overflow: "hidden",
        borderRadius: "sm",
        [$2ad9cdad15c1a93e$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$2ad9cdad15c1a93e$var$$bg.variable]: "colors.whiteAlpha.200"
        },
        _disabled: {
            [$2ad9cdad15c1a93e$var$$bg.variable]: "colors.gray.300",
            _dark: {
                [$2ad9cdad15c1a93e$var$$bg.variable]: "colors.whiteAlpha.300"
            }
        },
        bg: $2ad9cdad15c1a93e$var$$bg.reference
    };
});
var $2ad9cdad15c1a93e$var$baseStyleThumb = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    const orientationStyle = (0, $8082054e8b009135$export$f3eec17ee6065eee)({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: `translateX(-50%)`,
            _active: {
                transform: `translateX(-50%) scale(1.15)`
            }
        },
        horizontal: {
            top: "50%",
            transform: `translateY(-50%)`,
            _active: {
                transform: `translateY(-50%) scale(1.15)`
            }
        }
    });
    return {
        ...orientationStyle,
        w: $2ad9cdad15c1a93e$var$$thumbSize.reference,
        h: $2ad9cdad15c1a93e$var$$thumbSize.reference,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0,
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    };
});
var $2ad9cdad15c1a93e$var$baseStyleFilledTrack = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        width: "inherit",
        height: "inherit",
        [$2ad9cdad15c1a93e$var$$bg.variable]: `colors.${c}.500`,
        _dark: {
            [$2ad9cdad15c1a93e$var$$bg.variable]: `colors.${c}.200`
        },
        bg: $2ad9cdad15c1a93e$var$$bg.reference
    };
});
var $2ad9cdad15c1a93e$var$baseStyle = $2ad9cdad15c1a93e$var$definePartsStyle((props)=>({
        container: $2ad9cdad15c1a93e$var$baseStyleContainer(props),
        track: $2ad9cdad15c1a93e$var$baseStyleTrack(props),
        thumb: $2ad9cdad15c1a93e$var$baseStyleThumb(props),
        filledTrack: $2ad9cdad15c1a93e$var$baseStyleFilledTrack(props)
    }));
var $2ad9cdad15c1a93e$var$sizeLg = $2ad9cdad15c1a93e$var$definePartsStyle({
    container: {
        [$2ad9cdad15c1a93e$var$$thumbSize.variable]: `sizes.4`,
        [$2ad9cdad15c1a93e$var$$trackSize.variable]: `sizes.1`
    }
});
var $2ad9cdad15c1a93e$var$sizeMd = $2ad9cdad15c1a93e$var$definePartsStyle({
    container: {
        [$2ad9cdad15c1a93e$var$$thumbSize.variable]: `sizes.3.5`,
        [$2ad9cdad15c1a93e$var$$trackSize.variable]: `sizes.1`
    }
});
var $2ad9cdad15c1a93e$var$sizeSm = $2ad9cdad15c1a93e$var$definePartsStyle({
    container: {
        [$2ad9cdad15c1a93e$var$$thumbSize.variable]: `sizes.2.5`,
        [$2ad9cdad15c1a93e$var$$trackSize.variable]: `sizes.0.5`
    }
});
var $2ad9cdad15c1a93e$var$sizes = {
    lg: $2ad9cdad15c1a93e$var$sizeLg,
    md: $2ad9cdad15c1a93e$var$sizeMd,
    sm: $2ad9cdad15c1a93e$var$sizeSm
};
var $2ad9cdad15c1a93e$export$fff8df8fd8e1ed6f = $2ad9cdad15c1a93e$var$defineMultiStyleConfig({
    baseStyle: $2ad9cdad15c1a93e$var$baseStyle,
    sizes: $2ad9cdad15c1a93e$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});




"use client";
var $29c61cc93d4fb7c0$var$$size = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("spinner-size");
var $29c61cc93d4fb7c0$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    width: [
        $29c61cc93d4fb7c0$var$$size.reference
    ],
    height: [
        $29c61cc93d4fb7c0$var$$size.reference
    ]
});
var $29c61cc93d4fb7c0$var$sizes = {
    xs: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$29c61cc93d4fb7c0$var$$size.variable]: "sizes.3"
    }),
    sm: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$29c61cc93d4fb7c0$var$$size.variable]: "sizes.4"
    }),
    md: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$29c61cc93d4fb7c0$var$$size.variable]: "sizes.6"
    }),
    lg: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$29c61cc93d4fb7c0$var$$size.variable]: "sizes.8"
    }),
    xl: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$29c61cc93d4fb7c0$var$$size.variable]: "sizes.12"
    })
};
var $29c61cc93d4fb7c0$export$d76156e68e556d3f = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $29c61cc93d4fb7c0$var$baseStyle,
    sizes: $29c61cc93d4fb7c0$var$sizes,
    defaultProps: {
        size: "md"
    }
});




"use client";
var { defineMultiStyleConfig: $b4583206a34b89a6$var$defineMultiStyleConfig, definePartsStyle: $b4583206a34b89a6$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$2cfbad67ae6ee421).keys);
var $b4583206a34b89a6$var$baseStyleLabel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontWeight: "medium"
});
var $b4583206a34b89a6$var$baseStyleHelpText = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    opacity: 0.8,
    marginBottom: "2"
});
var $b4583206a34b89a6$var$baseStyleNumber = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    verticalAlign: "baseline",
    fontWeight: "semibold"
});
var $b4583206a34b89a6$var$baseStyleIcon = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
});
var $b4583206a34b89a6$var$baseStyle = $b4583206a34b89a6$var$definePartsStyle({
    container: {},
    label: $b4583206a34b89a6$var$baseStyleLabel,
    helpText: $b4583206a34b89a6$var$baseStyleHelpText,
    number: $b4583206a34b89a6$var$baseStyleNumber,
    icon: $b4583206a34b89a6$var$baseStyleIcon
});
var $b4583206a34b89a6$var$sizes = {
    md: $b4583206a34b89a6$var$definePartsStyle({
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    })
};
var $b4583206a34b89a6$export$f3301eb37a20f09e = $b4583206a34b89a6$var$defineMultiStyleConfig({
    baseStyle: $b4583206a34b89a6$var$baseStyle,
    sizes: $b4583206a34b89a6$var$sizes,
    defaultProps: {
        size: "md"
    }
});



"use client";
var $71ea4626b95d1b0a$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("kbd-bg");
var $71ea4626b95d1b0a$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    [$71ea4626b95d1b0a$var$$bg.variable]: "colors.gray.100",
    _dark: {
        [$71ea4626b95d1b0a$var$$bg.variable]: "colors.whiteAlpha.100"
    },
    bg: $71ea4626b95d1b0a$var$$bg.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
});
var $71ea4626b95d1b0a$export$e193528a501e9a4a = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $71ea4626b95d1b0a$var$baseStyle
});



"use client";
var $554af029b6cac9a2$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focusVisible: {
        boxShadow: "outline"
    }
});
var $554af029b6cac9a2$export$af7f58b96695762e = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $554af029b6cac9a2$var$baseStyle
});




"use client";
var { defineMultiStyleConfig: $fb5380deacf696eb$var$defineMultiStyleConfig, definePartsStyle: $fb5380deacf696eb$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$12b3a655a94374ed).keys);
var $fb5380deacf696eb$var$baseStyleIcon = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
});
var $fb5380deacf696eb$var$baseStyle = $fb5380deacf696eb$var$definePartsStyle({
    icon: $fb5380deacf696eb$var$baseStyleIcon
});
var $fb5380deacf696eb$export$ce840f8e8ef752d = $fb5380deacf696eb$var$defineMultiStyleConfig({
    baseStyle: $fb5380deacf696eb$var$baseStyle
});




"use client";
var { defineMultiStyleConfig: $8feddc653f29eb67$var$defineMultiStyleConfig, definePartsStyle: $8feddc653f29eb67$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$e251092a5dcb1329).keys);
var $8feddc653f29eb67$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("menu-bg");
var $8feddc653f29eb67$var$$shadow = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("menu-shadow");
var $8feddc653f29eb67$var$baseStyleList = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    [$8feddc653f29eb67$var$$bg.variable]: "#fff",
    [$8feddc653f29eb67$var$$shadow.variable]: "shadows.sm",
    _dark: {
        [$8feddc653f29eb67$var$$bg.variable]: "colors.gray.700",
        [$8feddc653f29eb67$var$$shadow.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px",
    bg: $8feddc653f29eb67$var$$bg.reference,
    boxShadow: $8feddc653f29eb67$var$$shadow.reference
});
var $8feddc653f29eb67$var$baseStyleItem = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
        [$8feddc653f29eb67$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$8feddc653f29eb67$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$8feddc653f29eb67$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$8feddc653f29eb67$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _expanded: {
        [$8feddc653f29eb67$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$8feddc653f29eb67$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    bg: $8feddc653f29eb67$var$$bg.reference
});
var $8feddc653f29eb67$var$baseStyleGroupTitle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
});
var $8feddc653f29eb67$var$baseStyleIcon = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $8feddc653f29eb67$var$baseStyleCommand = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    opacity: 0.6
});
var $8feddc653f29eb67$var$baseStyleDivider = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
});
var $8feddc653f29eb67$var$baseStyleButton = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $8feddc653f29eb67$var$baseStyle = $8feddc653f29eb67$var$definePartsStyle({
    button: $8feddc653f29eb67$var$baseStyleButton,
    list: $8feddc653f29eb67$var$baseStyleList,
    item: $8feddc653f29eb67$var$baseStyleItem,
    groupTitle: $8feddc653f29eb67$var$baseStyleGroupTitle,
    icon: $8feddc653f29eb67$var$baseStyleIcon,
    command: $8feddc653f29eb67$var$baseStyleCommand,
    divider: $8feddc653f29eb67$var$baseStyleDivider
});
var $8feddc653f29eb67$export$687ce088075ea42b = $8feddc653f29eb67$var$defineMultiStyleConfig({
    baseStyle: $8feddc653f29eb67$var$baseStyle
});





"use client";
var { defineMultiStyleConfig: $31363ad5391aa394$var$defineMultiStyleConfig, definePartsStyle: $31363ad5391aa394$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$34e33beb8d992ac2).keys);
var $31363ad5391aa394$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("modal-bg");
var $31363ad5391aa394$var$$shadow = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("modal-shadow");
var $31363ad5391aa394$var$baseStyleOverlay = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $31363ad5391aa394$var$baseStyleDialogContainer = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto",
        overscrollBehaviorY: "none"
    };
});
var $31363ad5391aa394$var$baseStyleDialog = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        color: "inherit",
        my: isCentered ? "auto" : "16",
        mx: isCentered ? "auto" : void 0,
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
        [$31363ad5391aa394$var$$bg.variable]: "colors.white",
        [$31363ad5391aa394$var$$shadow.variable]: "shadows.lg",
        _dark: {
            [$31363ad5391aa394$var$$bg.variable]: "colors.gray.700",
            [$31363ad5391aa394$var$$shadow.variable]: "shadows.dark-lg"
        },
        bg: $31363ad5391aa394$var$$bg.reference,
        boxShadow: $31363ad5391aa394$var$$shadow.reference
    };
});
var $31363ad5391aa394$var$baseStyleHeader = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $31363ad5391aa394$var$baseStyleCloseButton = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $31363ad5391aa394$var$baseStyleBody = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { scrollBehavior: scrollBehavior } = props;
    return {
        px: "6",
        py: "2",
        flex: "1",
        overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
});
var $31363ad5391aa394$var$baseStyleFooter = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $31363ad5391aa394$var$baseStyle = $31363ad5391aa394$var$definePartsStyle((props)=>({
        overlay: $31363ad5391aa394$var$baseStyleOverlay,
        dialogContainer: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($31363ad5391aa394$var$baseStyleDialogContainer, props),
        dialog: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($31363ad5391aa394$var$baseStyleDialog, props),
        header: $31363ad5391aa394$var$baseStyleHeader,
        closeButton: $31363ad5391aa394$var$baseStyleCloseButton,
        body: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($31363ad5391aa394$var$baseStyleBody, props),
        footer: $31363ad5391aa394$var$baseStyleFooter
    }));
function $31363ad5391aa394$var$getSize(value) {
    if (value === "full") return $31363ad5391aa394$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            minH: "$100vh",
            my: "0",
            borderRadius: "0"
        }
    });
    return $31363ad5391aa394$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $31363ad5391aa394$var$sizes = {
    xs: $31363ad5391aa394$var$getSize("xs"),
    sm: $31363ad5391aa394$var$getSize("sm"),
    md: $31363ad5391aa394$var$getSize("md"),
    lg: $31363ad5391aa394$var$getSize("lg"),
    xl: $31363ad5391aa394$var$getSize("xl"),
    "2xl": $31363ad5391aa394$var$getSize("2xl"),
    "3xl": $31363ad5391aa394$var$getSize("3xl"),
    "4xl": $31363ad5391aa394$var$getSize("4xl"),
    "5xl": $31363ad5391aa394$var$getSize("5xl"),
    "6xl": $31363ad5391aa394$var$getSize("6xl"),
    full: $31363ad5391aa394$var$getSize("full")
};
var $31363ad5391aa394$export$158ae9a07be41c05 = $31363ad5391aa394$var$defineMultiStyleConfig({
    baseStyle: $31363ad5391aa394$var$baseStyle,
    sizes: $31363ad5391aa394$var$sizes,
    defaultProps: {
        size: "md"
    }
});








"use client";
var { defineMultiStyleConfig: $5ff242150e969476$var$defineMultiStyleConfig, definePartsStyle: $5ff242150e969476$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$859cc7ca3200df97).keys);
var $5ff242150e969476$var$$stepperWidth = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("number-input-stepper-width");
var $5ff242150e969476$var$$inputPadding = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("number-input-input-padding");
var $5ff242150e969476$var$inputPaddingValue = (0, $64b1ed50d45c4df0$export$42bfa9b2d4dad91a)($5ff242150e969476$var$$stepperWidth).add("0.5rem").toString();
var $5ff242150e969476$var$$bg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("number-input-bg");
var $5ff242150e969476$var$$fg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("number-input-color");
var $5ff242150e969476$var$$border = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("number-input-border-color");
var $5ff242150e969476$var$baseStyleRoot = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    [$5ff242150e969476$var$$stepperWidth.variable]: "sizes.6",
    [$5ff242150e969476$var$$inputPadding.variable]: $5ff242150e969476$var$inputPaddingValue
});
var $5ff242150e969476$var$baseStyleField = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    var _a, _b;
    return (_b = (_a = (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)((0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
});
var $5ff242150e969476$var$baseStyleStepperGroup = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    width: $5ff242150e969476$var$$stepperWidth.reference
});
var $5ff242150e969476$var$baseStyleStepper = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderStart: "1px solid",
    borderStartColor: $5ff242150e969476$var$$border.reference,
    color: $5ff242150e969476$var$$fg.reference,
    bg: $5ff242150e969476$var$$bg.reference,
    [$5ff242150e969476$var$$fg.variable]: "colors.chakra-body-text",
    [$5ff242150e969476$var$$border.variable]: "colors.chakra-border-color",
    _dark: {
        [$5ff242150e969476$var$$fg.variable]: "colors.whiteAlpha.800",
        [$5ff242150e969476$var$$border.variable]: "colors.whiteAlpha.300"
    },
    _active: {
        [$5ff242150e969476$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$5ff242150e969476$var$$bg.variable]: "colors.whiteAlpha.300"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }
});
var $5ff242150e969476$var$baseStyle = $5ff242150e969476$var$definePartsStyle((props)=>{
    var _a;
    return {
        root: $5ff242150e969476$var$baseStyleRoot,
        field: (_a = (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($5ff242150e969476$var$baseStyleField, props)) != null ? _a : {},
        stepperGroup: $5ff242150e969476$var$baseStyleStepperGroup,
        stepper: $5ff242150e969476$var$baseStyleStepper
    };
});
function $5ff242150e969476$var$getSize(size) {
    var _a, _b, _c;
    const sizeStyle = (_a = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).sizes) == null ? void 0 : _a[size];
    const radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    const _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
    const fontSize = (0, $c403c3ffdcceff1d$export$d7c5d8884f83c8db).fontSizes[_fontSize];
    return $5ff242150e969476$var$definePartsStyle({
        field: {
            ...sizeStyle.field,
            paddingInlineEnd: $5ff242150e969476$var$$inputPadding.reference,
            verticalAlign: "top"
        },
        stepper: {
            fontSize: (0, $64b1ed50d45c4df0$export$42bfa9b2d4dad91a)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    });
}
var $5ff242150e969476$var$sizes = {
    xs: $5ff242150e969476$var$getSize("xs"),
    sm: $5ff242150e969476$var$getSize("sm"),
    md: $5ff242150e969476$var$getSize("md"),
    lg: $5ff242150e969476$var$getSize("lg")
};
var $5ff242150e969476$export$b9bc5fa6e7f960a1 = $5ff242150e969476$var$defineMultiStyleConfig({
    baseStyle: $5ff242150e969476$var$baseStyle,
    sizes: $5ff242150e969476$var$sizes,
    variants: (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).defaultProps
});





"use client";
var $8151251dc736b454$var$_a;
var $8151251dc736b454$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    ...($8151251dc736b454$var$_a = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $8151251dc736b454$var$_a.field,
    textAlign: "center"
});
var $8151251dc736b454$var$sizes = {
    lg: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    }),
    md: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    }),
    sm: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    }),
    xs: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    })
};
var $8151251dc736b454$var$_a2, $8151251dc736b454$var$_b;
var $8151251dc736b454$var$variants = {
    outline: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)((_a3 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.outline, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    flushed: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)((_a3 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.flushed, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    filled: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)((_a3 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.filled, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    unstyled: ($8151251dc736b454$var$_b = ($8151251dc736b454$var$_a2 = (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).variants) == null ? void 0 : $8151251dc736b454$var$_a2.unstyled.field) != null ? $8151251dc736b454$var$_b : {}
};
var $8151251dc736b454$export$8504c22c55a552e0 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $8151251dc736b454$var$baseStyle,
    sizes: $8151251dc736b454$var$sizes,
    variants: $8151251dc736b454$var$variants,
    defaultProps: (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54).defaultProps
});





"use client";
var { defineMultiStyleConfig: $7c73a34aeebde440$var$defineMultiStyleConfig, definePartsStyle: $7c73a34aeebde440$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$afda07d12cd4337d).keys);
var $7c73a34aeebde440$var$$popperBg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("popper-bg");
var $7c73a34aeebde440$var$$arrowBg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("popper-arrow-bg");
var $7c73a34aeebde440$var$$arrowShadowColor = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("popper-arrow-shadow-color");
var $7c73a34aeebde440$var$baseStylePopper = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    zIndex: 10
});
var $7c73a34aeebde440$var$baseStyleContent = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    [$7c73a34aeebde440$var$$popperBg.variable]: `colors.white`,
    bg: $7c73a34aeebde440$var$$popperBg.reference,
    [$7c73a34aeebde440$var$$arrowBg.variable]: $7c73a34aeebde440$var$$popperBg.reference,
    [$7c73a34aeebde440$var$$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
        [$7c73a34aeebde440$var$$popperBg.variable]: `colors.gray.700`,
        [$7c73a34aeebde440$var$$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
        outline: 0,
        boxShadow: "outline"
    }
});
var $7c73a34aeebde440$var$baseStyleHeader = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
});
var $7c73a34aeebde440$var$baseStyleBody = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2
});
var $7c73a34aeebde440$var$baseStyleFooter = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
});
var $7c73a34aeebde440$var$baseStyleCloseButton = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
});
var $7c73a34aeebde440$var$baseStyle = $7c73a34aeebde440$var$definePartsStyle({
    popper: $7c73a34aeebde440$var$baseStylePopper,
    content: $7c73a34aeebde440$var$baseStyleContent,
    header: $7c73a34aeebde440$var$baseStyleHeader,
    body: $7c73a34aeebde440$var$baseStyleBody,
    footer: $7c73a34aeebde440$var$baseStyleFooter,
    closeButton: $7c73a34aeebde440$var$baseStyleCloseButton
});
var $7c73a34aeebde440$export$135f12f777be1ef7 = $7c73a34aeebde440$var$defineMultiStyleConfig({
    baseStyle: $7c73a34aeebde440$var$baseStyle
});





"use client";
var { definePartsStyle: $a64de357cbcdc044$var$definePartsStyle, defineMultiStyleConfig: $a64de357cbcdc044$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$d3f4aaa4b0f2907a).keys);
var $a64de357cbcdc044$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("drawer-bg");
var $a64de357cbcdc044$var$$bs = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("drawer-box-shadow");
function $a64de357cbcdc044$var$getSize(value) {
    if (value === "full") return $a64de357cbcdc044$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    });
    return $a64de357cbcdc044$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $a64de357cbcdc044$var$baseStyleOverlay = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "overlay"
});
var $a64de357cbcdc044$var$baseStyleDialogContainer = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
});
var $a64de357cbcdc044$var$baseStyleDialog = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { isFullHeight: isFullHeight } = props;
    return {
        ...isFullHeight && {
            height: "100vh"
        },
        zIndex: "modal",
        maxH: "100vh",
        color: "inherit",
        [$a64de357cbcdc044$var$$bg.variable]: "colors.white",
        [$a64de357cbcdc044$var$$bs.variable]: "shadows.lg",
        _dark: {
            [$a64de357cbcdc044$var$$bg.variable]: "colors.gray.700",
            [$a64de357cbcdc044$var$$bs.variable]: "shadows.dark-lg"
        },
        bg: $a64de357cbcdc044$var$$bg.reference,
        boxShadow: $a64de357cbcdc044$var$$bs.reference
    };
});
var $a64de357cbcdc044$var$baseStyleHeader = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $a64de357cbcdc044$var$baseStyleCloseButton = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $a64de357cbcdc044$var$baseStyleBody = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
});
var $a64de357cbcdc044$var$baseStyleFooter = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $a64de357cbcdc044$var$baseStyle = $a64de357cbcdc044$var$definePartsStyle((props)=>({
        overlay: $a64de357cbcdc044$var$baseStyleOverlay,
        dialogContainer: $a64de357cbcdc044$var$baseStyleDialogContainer,
        dialog: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($a64de357cbcdc044$var$baseStyleDialog, props),
        header: $a64de357cbcdc044$var$baseStyleHeader,
        closeButton: $a64de357cbcdc044$var$baseStyleCloseButton,
        body: $a64de357cbcdc044$var$baseStyleBody,
        footer: $a64de357cbcdc044$var$baseStyleFooter
    }));
var $a64de357cbcdc044$var$sizes = {
    xs: $a64de357cbcdc044$var$getSize("xs"),
    sm: $a64de357cbcdc044$var$getSize("md"),
    md: $a64de357cbcdc044$var$getSize("lg"),
    lg: $a64de357cbcdc044$var$getSize("2xl"),
    xl: $a64de357cbcdc044$var$getSize("4xl"),
    full: $a64de357cbcdc044$var$getSize("full")
};
var $a64de357cbcdc044$export$8057937c11129602 = $a64de357cbcdc044$var$defineMultiStyleConfig({
    baseStyle: $a64de357cbcdc044$var$baseStyle,
    sizes: $a64de357cbcdc044$var$sizes,
    defaultProps: {
        size: "xs"
    }
});




"use client";
var { definePartsStyle: $cfe42fa8d4a04207$var$definePartsStyle, defineMultiStyleConfig: $cfe42fa8d4a04207$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$2813c9511eeab082).keys);
var $cfe42fa8d4a04207$var$baseStylePreview = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $cfe42fa8d4a04207$var$baseStyleInput = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $cfe42fa8d4a04207$var$baseStyleTextarea = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $cfe42fa8d4a04207$var$baseStyle = $cfe42fa8d4a04207$var$definePartsStyle({
    preview: $cfe42fa8d4a04207$var$baseStylePreview,
    input: $cfe42fa8d4a04207$var$baseStyleInput,
    textarea: $cfe42fa8d4a04207$var$baseStyleTextarea
});
var $cfe42fa8d4a04207$export$a09813cbe72349b1 = $cfe42fa8d4a04207$var$defineMultiStyleConfig({
    baseStyle: $cfe42fa8d4a04207$var$baseStyle
});




"use client";
var { definePartsStyle: $8483826f56e13a7e$var$definePartsStyle, defineMultiStyleConfig: $8483826f56e13a7e$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$4b243e3f209a7e5e).keys);
var $8483826f56e13a7e$var$$fg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("form-control-color");
var $8483826f56e13a7e$var$baseStyleRequiredIndicator = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    marginStart: "1",
    [$8483826f56e13a7e$var$$fg.variable]: "colors.red.500",
    _dark: {
        [$8483826f56e13a7e$var$$fg.variable]: "colors.red.300"
    },
    color: $8483826f56e13a7e$var$$fg.reference
});
var $8483826f56e13a7e$var$baseStyleHelperText = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    mt: "2",
    [$8483826f56e13a7e$var$$fg.variable]: "colors.gray.600",
    _dark: {
        [$8483826f56e13a7e$var$$fg.variable]: "colors.whiteAlpha.600"
    },
    color: $8483826f56e13a7e$var$$fg.reference,
    lineHeight: "normal",
    fontSize: "sm"
});
var $8483826f56e13a7e$var$baseStyle = $8483826f56e13a7e$var$definePartsStyle({
    container: {
        width: "100%",
        position: "relative"
    },
    requiredIndicator: $8483826f56e13a7e$var$baseStyleRequiredIndicator,
    helperText: $8483826f56e13a7e$var$baseStyleHelperText
});
var $8483826f56e13a7e$export$870bcc1d98fee0aa = $8483826f56e13a7e$var$defineMultiStyleConfig({
    baseStyle: $8483826f56e13a7e$var$baseStyle
});




"use client";
var { definePartsStyle: $eb50bba4e617f017$var$definePartsStyle, defineMultiStyleConfig: $eb50bba4e617f017$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$bb18c440c00e82d9).keys);
var $eb50bba4e617f017$var$$fg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("form-error-color");
var $eb50bba4e617f017$var$baseStyleText = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    [$eb50bba4e617f017$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$eb50bba4e617f017$var$$fg.variable]: `colors.red.300`
    },
    color: $eb50bba4e617f017$var$$fg.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
});
var $eb50bba4e617f017$var$baseStyleIcon = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    marginEnd: "0.5em",
    [$eb50bba4e617f017$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$eb50bba4e617f017$var$$fg.variable]: `colors.red.300`
    },
    color: $eb50bba4e617f017$var$$fg.reference
});
var $eb50bba4e617f017$var$baseStyle = $eb50bba4e617f017$var$definePartsStyle({
    text: $eb50bba4e617f017$var$baseStyleText,
    icon: $eb50bba4e617f017$var$baseStyleIcon
});
var $eb50bba4e617f017$export$b8d6747e16cd5f4d = $eb50bba4e617f017$var$defineMultiStyleConfig({
    baseStyle: $eb50bba4e617f017$var$baseStyle
});



"use client";
var $b5540cc09d90536e$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
});
var $b5540cc09d90536e$export$c49af69dbfc0c993 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $b5540cc09d90536e$var$baseStyle
});



"use client";
var $8d42ff30ed9b1257$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontFamily: "heading",
    fontWeight: "bold"
});
var $8d42ff30ed9b1257$var$sizes = {
    "4xl": (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    }),
    "3xl": (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    }),
    "2xl": (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    }),
    xl: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    lg: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    md: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: "xl",
        lineHeight: 1.2
    }),
    sm: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: "md",
        lineHeight: 1.2
    }),
    xs: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        lineHeight: 1.2
    })
};
var $8d42ff30ed9b1257$export$5f175074e0f09e7b = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $8d42ff30ed9b1257$var$baseStyle,
    sizes: $8d42ff30ed9b1257$var$sizes,
    defaultProps: {
        size: "xl"
    }
});





"use client";
var { defineMultiStyleConfig: $cc3fdae94eb1b55b$var$defineMultiStyleConfig, definePartsStyle: $cc3fdae94eb1b55b$var$definePartsStyle } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$2fb03f744a6ecf93).keys);
var $cc3fdae94eb1b55b$var$$decor = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("breadcrumb-link-decor");
var $cc3fdae94eb1b55b$var$baseStyleLink = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $cc3fdae94eb1b55b$var$$decor.reference,
    [$cc3fdae94eb1b55b$var$$decor.variable]: "none",
    "&:not([aria-current=page])": {
        cursor: "pointer",
        _hover: {
            [$cc3fdae94eb1b55b$var$$decor.variable]: "underline"
        },
        _focusVisible: {
            boxShadow: "outline"
        }
    }
});
var $cc3fdae94eb1b55b$var$baseStyle = $cc3fdae94eb1b55b$var$definePartsStyle({
    link: $cc3fdae94eb1b55b$var$baseStyleLink
});
var $cc3fdae94eb1b55b$export$e2d8c6f6af55009 = $cc3fdae94eb1b55b$var$defineMultiStyleConfig({
    baseStyle: $cc3fdae94eb1b55b$var$baseStyle
});





"use client";
var $2b594e3bbb20055b$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
});
var $2b594e3bbb20055b$var$variantGhost = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $8082054e8b009135$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props)
        }
    };
    const darkHoverBg = (0, $e204bb335adaaa0a$export$d11da87e55cc498f)(`${c}.200`, 0.12)(theme);
    const darkActiveBg = (0, $e204bb335adaaa0a$export$d11da87e55cc498f)(`${c}.200`, 0.24)(theme);
    return {
        color: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.600`, `${c}.200`)(props),
        bg: "transparent",
        _hover: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.50`, darkHoverBg)(props)
        },
        _active: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.100`, darkActiveBg)(props)
        }
    };
});
var $2b594e3bbb20055b$var$variantOutline = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    const borderColor = (0, $8082054e8b009135$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props);
    return {
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor",
        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
            marginEnd: "-1px"
        },
        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
            marginBottom: "-1px"
        },
        ...(0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($2b594e3bbb20055b$var$variantGhost, props)
    };
});
var $2b594e3bbb20055b$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
var $2b594e3bbb20055b$var$variantSolid = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const { colorScheme: c } = props;
    if (c === "gray") {
        const bg2 = (0, $8082054e8b009135$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props);
        return {
            bg: bg2,
            color: (0, $8082054e8b009135$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
            _hover: {
                bg: (0, $8082054e8b009135$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props),
                _disabled: {
                    bg: bg2
                }
            },
            _active: {
                bg: (0, $8082054e8b009135$export$549ff81930776885)(`gray.300`, `whiteAlpha.400`)(props)
            }
        };
    }
    const { bg: bg = `${c}.500`, color: color = "white", hoverBg: hoverBg = `${c}.600`, activeBg: activeBg = `${c}.700` } = (_a = $2b594e3bbb20055b$var$accessibleColorMap[c]) != null ? _a : {};
    const background = (0, $8082054e8b009135$export$549ff81930776885)(bg, `${c}.200`)(props);
    return {
        bg: background,
        color: (0, $8082054e8b009135$export$549ff81930776885)(color, `gray.800`)(props),
        _hover: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(hoverBg, `${c}.300`)(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $8082054e8b009135$export$549ff81930776885)(activeBg, `${c}.400`)(props)
        }
    };
});
var $2b594e3bbb20055b$var$variantLink = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $8082054e8b009135$export$549ff81930776885)(`${c}.700`, `${c}.500`)(props)
        }
    };
});
var $2b594e3bbb20055b$var$variantUnstyled = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
});
var $2b594e3bbb20055b$var$variants = {
    ghost: $2b594e3bbb20055b$var$variantGhost,
    outline: $2b594e3bbb20055b$var$variantOutline,
    solid: $2b594e3bbb20055b$var$variantSolid,
    link: $2b594e3bbb20055b$var$variantLink,
    unstyled: $2b594e3bbb20055b$var$variantUnstyled
};
var $2b594e3bbb20055b$var$sizes = {
    lg: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        h: "12",
        minW: "12",
        fontSize: "lg",
        px: "6"
    }),
    md: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        h: "10",
        minW: "10",
        fontSize: "md",
        px: "4"
    }),
    sm: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        h: "8",
        minW: "8",
        fontSize: "sm",
        px: "3"
    }),
    xs: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        h: "6",
        minW: "6",
        fontSize: "xs",
        px: "2"
    })
};
var $2b594e3bbb20055b$export$577deec5d331f6be = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $2b594e3bbb20055b$var$baseStyle,
    variants: $2b594e3bbb20055b$var$variants,
    sizes: $2b594e3bbb20055b$var$sizes,
    defaultProps: {
        variant: "solid",
        size: "md",
        colorScheme: "gray"
    }
});




"use client";
var { definePartsStyle: $2298b44dfcfa2848$var$definePartsStyle, defineMultiStyleConfig: $2298b44dfcfa2848$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$487a447ffa5755b6).keys);
var $2298b44dfcfa2848$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("card-bg");
var $2298b44dfcfa2848$var$$padding = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("card-padding");
var $2298b44dfcfa2848$var$$shadow = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("card-shadow");
var $2298b44dfcfa2848$var$$radius = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("card-radius");
var $2298b44dfcfa2848$var$$border = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("card-border-width", "0");
var $2298b44dfcfa2848$var$$borderColor = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("card-border-color");
var $2298b44dfcfa2848$var$baseStyle = $2298b44dfcfa2848$var$definePartsStyle({
    container: {
        [$2298b44dfcfa2848$var$$bg.variable]: "colors.chakra-body-bg",
        backgroundColor: $2298b44dfcfa2848$var$$bg.reference,
        boxShadow: $2298b44dfcfa2848$var$$shadow.reference,
        borderRadius: $2298b44dfcfa2848$var$$radius.reference,
        color: "chakra-body-text",
        borderWidth: $2298b44dfcfa2848$var$$border.reference,
        borderColor: $2298b44dfcfa2848$var$$borderColor.reference
    },
    body: {
        padding: $2298b44dfcfa2848$var$$padding.reference,
        flex: "1 1 0%"
    },
    header: {
        padding: $2298b44dfcfa2848$var$$padding.reference
    },
    footer: {
        padding: $2298b44dfcfa2848$var$$padding.reference
    }
});
var $2298b44dfcfa2848$var$sizes = {
    sm: $2298b44dfcfa2848$var$definePartsStyle({
        container: {
            [$2298b44dfcfa2848$var$$radius.variable]: "radii.base",
            [$2298b44dfcfa2848$var$$padding.variable]: "space.3"
        }
    }),
    md: $2298b44dfcfa2848$var$definePartsStyle({
        container: {
            [$2298b44dfcfa2848$var$$radius.variable]: "radii.md",
            [$2298b44dfcfa2848$var$$padding.variable]: "space.5"
        }
    }),
    lg: $2298b44dfcfa2848$var$definePartsStyle({
        container: {
            [$2298b44dfcfa2848$var$$radius.variable]: "radii.xl",
            [$2298b44dfcfa2848$var$$padding.variable]: "space.7"
        }
    })
};
var $2298b44dfcfa2848$var$variants = {
    elevated: $2298b44dfcfa2848$var$definePartsStyle({
        container: {
            [$2298b44dfcfa2848$var$$shadow.variable]: "shadows.base",
            _dark: {
                [$2298b44dfcfa2848$var$$bg.variable]: "colors.gray.700"
            }
        }
    }),
    outline: $2298b44dfcfa2848$var$definePartsStyle({
        container: {
            [$2298b44dfcfa2848$var$$border.variable]: "1px",
            [$2298b44dfcfa2848$var$$borderColor.variable]: "colors.chakra-border-color"
        }
    }),
    filled: $2298b44dfcfa2848$var$definePartsStyle({
        container: {
            [$2298b44dfcfa2848$var$$bg.variable]: "colors.chakra-subtle-bg"
        }
    }),
    unstyled: {
        body: {
            [$2298b44dfcfa2848$var$$padding.variable]: 0
        },
        header: {
            [$2298b44dfcfa2848$var$$padding.variable]: 0
        },
        footer: {
            [$2298b44dfcfa2848$var$$padding.variable]: 0
        }
    }
};
var $2298b44dfcfa2848$export$880f7b1201440c23 = $2298b44dfcfa2848$var$defineMultiStyleConfig({
    baseStyle: $2298b44dfcfa2848$var$baseStyle,
    variants: $2298b44dfcfa2848$var$variants,
    sizes: $2298b44dfcfa2848$var$sizes,
    defaultProps: {
        variant: "elevated",
        size: "md"
    }
});





"use client";
var $66aa61b834d7acbe$var$$size = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("close-button-size");
var $66aa61b834d7acbe$var$$bg = (0, $1ac6a326e189a005$export$8b4981022bd80a4e)("close-button-bg");
var $66aa61b834d7acbe$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    w: [
        $66aa61b834d7acbe$var$$size.reference
    ],
    h: [
        $66aa61b834d7acbe$var$$size.reference
    ],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        [$66aa61b834d7acbe$var$$bg.variable]: "colors.blackAlpha.100",
        _dark: {
            [$66aa61b834d7acbe$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$66aa61b834d7acbe$var$$bg.variable]: "colors.blackAlpha.200",
        _dark: {
            [$66aa61b834d7acbe$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _focusVisible: {
        boxShadow: "outline"
    },
    bg: $66aa61b834d7acbe$var$$bg.reference
});
var $66aa61b834d7acbe$var$sizes = {
    lg: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$66aa61b834d7acbe$var$$size.variable]: "sizes.10",
        fontSize: "md"
    }),
    md: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$66aa61b834d7acbe$var$$size.variable]: "sizes.8",
        fontSize: "xs"
    }),
    sm: (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
        [$66aa61b834d7acbe$var$$size.variable]: "sizes.6",
        fontSize: "2xs"
    })
};
var $66aa61b834d7acbe$export$47615e5b7f7e315f = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $66aa61b834d7acbe$var$baseStyle,
    sizes: $66aa61b834d7acbe$var$sizes,
    defaultProps: {
        size: "md"
    }
});




"use client";
var { variants: $37cd195a232979b2$var$variants, defaultProps: $37cd195a232979b2$var$defaultProps } = (0, $a911a67ae6d2c889$export$eb6e7cbc82d0f88b);
var $37cd195a232979b2$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: (0, $a911a67ae6d2c889$export$3cb96c9f6c8d16a4).bg.reference,
    color: (0, $a911a67ae6d2c889$export$3cb96c9f6c8d16a4).color.reference,
    boxShadow: (0, $a911a67ae6d2c889$export$3cb96c9f6c8d16a4).shadow.reference
});
var $37cd195a232979b2$export$f9b9a8633a36e3c7 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $37cd195a232979b2$var$baseStyle,
    variants: $37cd195a232979b2$var$variants,
    defaultProps: $37cd195a232979b2$var$defaultProps
});



"use client";
var $f3d4e61f1bc69a12$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
});
var $f3d4e61f1bc69a12$export$3ca0760d240fe5f4 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $f3d4e61f1bc69a12$var$baseStyle
});



"use client";
var $2f1186059c47eccb$var$baseStyle = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    opacity: 0.6,
    borderColor: "inherit"
});
var $2f1186059c47eccb$var$variantSolid = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderStyle: "solid"
});
var $2f1186059c47eccb$var$variantDashed = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderStyle: "dashed"
});
var $2f1186059c47eccb$var$variants = {
    solid: $2f1186059c47eccb$var$variantSolid,
    dashed: $2f1186059c47eccb$var$variantDashed
};
var $2f1186059c47eccb$export$f0e91f779c5bb416 = (0, $01a983b3ad87bd07$export$5c9a64458a4ed8a4)({
    baseStyle: $2f1186059c47eccb$var$baseStyle,
    variants: $2f1186059c47eccb$var$variants,
    defaultProps: {
        variant: "solid"
    }
});




"use client";
var { definePartsStyle: $f72c35381dc7f7bb$var$definePartsStyle, defineMultiStyleConfig: $f72c35381dc7f7bb$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$377a77e99e7c73a5).keys);
var $f72c35381dc7f7bb$var$baseStyleContainer = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
});
var $f72c35381dc7f7bb$var$baseStyleButton = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: "4",
    py: "2"
});
var $f72c35381dc7f7bb$var$baseStylePanel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    pt: "2",
    px: "4",
    pb: "5"
});
var $f72c35381dc7f7bb$var$baseStyleIcon = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontSize: "1.25em"
});
var $f72c35381dc7f7bb$var$baseStyle = $f72c35381dc7f7bb$var$definePartsStyle({
    container: $f72c35381dc7f7bb$var$baseStyleContainer,
    button: $f72c35381dc7f7bb$var$baseStyleButton,
    panel: $f72c35381dc7f7bb$var$baseStylePanel,
    icon: $f72c35381dc7f7bb$var$baseStyleIcon
});
var $f72c35381dc7f7bb$export$20ec2254f76fa604 = $f72c35381dc7f7bb$var$defineMultiStyleConfig({
    baseStyle: $f72c35381dc7f7bb$var$baseStyle
});





"use client";
var { definePartsStyle: $2a334ddd560814f6$var$definePartsStyle, defineMultiStyleConfig: $2a334ddd560814f6$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$fc51889fa4de265a).keys);
var $2a334ddd560814f6$var$$fg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("alert-fg");
var $2a334ddd560814f6$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("alert-bg");
var $2a334ddd560814f6$var$baseStyle = $2a334ddd560814f6$var$definePartsStyle({
    container: {
        bg: $2a334ddd560814f6$var$$bg.reference,
        px: "4",
        py: "3"
    },
    title: {
        fontWeight: "bold",
        lineHeight: "6",
        marginEnd: "2"
    },
    description: {
        lineHeight: "6"
    },
    icon: {
        color: $2a334ddd560814f6$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "6"
    },
    spinner: {
        color: $2a334ddd560814f6$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "5"
    }
});
function $2a334ddd560814f6$var$getBg(props) {
    const { theme: theme, colorScheme: c } = props;
    const darkBg = (0, $e204bb335adaaa0a$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        light: `colors.${c}.100`,
        dark: darkBg
    };
}
var $2a334ddd560814f6$var$variantSubtle = $2a334ddd560814f6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $2a334ddd560814f6$var$getBg(props);
    return {
        container: {
            [$2a334ddd560814f6$var$$fg.variable]: `colors.${c}.500`,
            [$2a334ddd560814f6$var$$bg.variable]: bg.light,
            _dark: {
                [$2a334ddd560814f6$var$$fg.variable]: `colors.${c}.200`,
                [$2a334ddd560814f6$var$$bg.variable]: bg.dark
            }
        }
    };
});
var $2a334ddd560814f6$var$variantLeftAccent = $2a334ddd560814f6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $2a334ddd560814f6$var$getBg(props);
    return {
        container: {
            [$2a334ddd560814f6$var$$fg.variable]: `colors.${c}.500`,
            [$2a334ddd560814f6$var$$bg.variable]: bg.light,
            _dark: {
                [$2a334ddd560814f6$var$$fg.variable]: `colors.${c}.200`,
                [$2a334ddd560814f6$var$$bg.variable]: bg.dark
            },
            paddingStart: "3",
            borderStartWidth: "4px",
            borderStartColor: $2a334ddd560814f6$var$$fg.reference
        }
    };
});
var $2a334ddd560814f6$var$variantTopAccent = $2a334ddd560814f6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $2a334ddd560814f6$var$getBg(props);
    return {
        container: {
            [$2a334ddd560814f6$var$$fg.variable]: `colors.${c}.500`,
            [$2a334ddd560814f6$var$$bg.variable]: bg.light,
            _dark: {
                [$2a334ddd560814f6$var$$fg.variable]: `colors.${c}.200`,
                [$2a334ddd560814f6$var$$bg.variable]: bg.dark
            },
            pt: "2",
            borderTopWidth: "4px",
            borderTopColor: $2a334ddd560814f6$var$$fg.reference
        }
    };
});
var $2a334ddd560814f6$var$variantSolid = $2a334ddd560814f6$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        container: {
            [$2a334ddd560814f6$var$$fg.variable]: `colors.white`,
            [$2a334ddd560814f6$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$2a334ddd560814f6$var$$fg.variable]: `colors.gray.900`,
                [$2a334ddd560814f6$var$$bg.variable]: `colors.${c}.200`
            },
            color: $2a334ddd560814f6$var$$fg.reference
        }
    };
});
var $2a334ddd560814f6$var$variants = {
    subtle: $2a334ddd560814f6$var$variantSubtle,
    "left-accent": $2a334ddd560814f6$var$variantLeftAccent,
    "top-accent": $2a334ddd560814f6$var$variantTopAccent,
    solid: $2a334ddd560814f6$var$variantSolid
};
var $2a334ddd560814f6$export$9d77d9665d829e89 = $2a334ddd560814f6$var$defineMultiStyleConfig({
    baseStyle: $2a334ddd560814f6$var$baseStyle,
    variants: $2a334ddd560814f6$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "blue"
    }
});







"use client";
var { definePartsStyle: $ce558396c1a92b86$var$definePartsStyle, defineMultiStyleConfig: $ce558396c1a92b86$var$defineMultiStyleConfig } = (0, $01a983b3ad87bd07$export$d5f717dc145477b8)((0, $fe6b83d1d0338593$export$60f8655d889e17c7).keys);
var $ce558396c1a92b86$var$$border = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("avatar-border-color");
var $ce558396c1a92b86$var$$bg = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("avatar-bg");
var $ce558396c1a92b86$var$$fs = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("avatar-font-size");
var $ce558396c1a92b86$var$$size = (0, $01a983b3ad87bd07$export$8b4981022bd80a4e)("avatar-size");
var $ce558396c1a92b86$var$baseStyleBadge = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $ce558396c1a92b86$var$$border.reference,
    [$ce558396c1a92b86$var$$border.variable]: "white",
    _dark: {
        [$ce558396c1a92b86$var$$border.variable]: "colors.gray.800"
    }
});
var $ce558396c1a92b86$var$baseStyleExcessLabel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    bg: $ce558396c1a92b86$var$$bg.reference,
    fontSize: $ce558396c1a92b86$var$$fs.reference,
    width: $ce558396c1a92b86$var$$size.reference,
    height: $ce558396c1a92b86$var$$size.reference,
    lineHeight: "1",
    [$ce558396c1a92b86$var$$bg.variable]: "colors.gray.200",
    _dark: {
        [$ce558396c1a92b86$var$$bg.variable]: "colors.whiteAlpha.400"
    }
});
var $ce558396c1a92b86$var$baseStyleContainer = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)((props)=>{
    const { name: name, theme: theme } = props;
    const bg = name ? (0, $e204bb335adaaa0a$export$f3c6ed4330abfc18)({
        string: name
    }) : "colors.gray.400";
    const isBgDark = (0, $e204bb335adaaa0a$export$a79ad82046afa44e)(bg)(theme);
    let color = "white";
    if (!isBgDark) color = "gray.800";
    return {
        bg: $ce558396c1a92b86$var$$bg.reference,
        fontSize: $ce558396c1a92b86$var$$fs.reference,
        color: color,
        borderColor: $ce558396c1a92b86$var$$border.reference,
        verticalAlign: "top",
        width: $ce558396c1a92b86$var$$size.reference,
        height: $ce558396c1a92b86$var$$size.reference,
        "&:not([data-loaded])": {
            [$ce558396c1a92b86$var$$bg.variable]: bg
        },
        [$ce558396c1a92b86$var$$border.variable]: "colors.white",
        _dark: {
            [$ce558396c1a92b86$var$$border.variable]: "colors.gray.800"
        }
    };
});
var $ce558396c1a92b86$var$baseStyleLabel = (0, $01a983b3ad87bd07$export$9a6b93c1c4f92839)({
    fontSize: $ce558396c1a92b86$var$$fs.reference,
    lineHeight: "1"
});
var $ce558396c1a92b86$var$baseStyle = $ce558396c1a92b86$var$definePartsStyle((props)=>({
        badge: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($ce558396c1a92b86$var$baseStyleBadge, props),
        excessLabel: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($ce558396c1a92b86$var$baseStyleExcessLabel, props),
        container: (0, $5cd80c5f093c55ed$export$624e501d81f5ffce)($ce558396c1a92b86$var$baseStyleContainer, props),
        label: $ce558396c1a92b86$var$baseStyleLabel
    }));
function $ce558396c1a92b86$var$getSize(size) {
    const themeSize = size !== "100%" ? (0, $fd4b35e8bdb8da6d$export$d7d4c689520cc141)[size] : void 0;
    return $ce558396c1a92b86$var$definePartsStyle({
        container: {
            [$ce558396c1a92b86$var$$size.variable]: themeSize != null ? themeSize : size,
            [$ce558396c1a92b86$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        },
        excessLabel: {
            [$ce558396c1a92b86$var$$size.variable]: themeSize != null ? themeSize : size,
            [$ce558396c1a92b86$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        }
    });
}
var $ce558396c1a92b86$var$sizes = {
    "2xs": $ce558396c1a92b86$var$getSize(4),
    xs: $ce558396c1a92b86$var$getSize(6),
    sm: $ce558396c1a92b86$var$getSize(8),
    md: $ce558396c1a92b86$var$getSize(12),
    lg: $ce558396c1a92b86$var$getSize(16),
    xl: $ce558396c1a92b86$var$getSize(24),
    "2xl": $ce558396c1a92b86$var$getSize(32),
    full: $ce558396c1a92b86$var$getSize("100%")
};
var $ce558396c1a92b86$export$9975d21893c10e66 = $ce558396c1a92b86$var$defineMultiStyleConfig({
    baseStyle: $ce558396c1a92b86$var$baseStyle,
    sizes: $ce558396c1a92b86$var$sizes,
    defaultProps: {
        size: "md"
    }
});



"use client";
// src/components/index.ts
var $4f1426586426de9e$export$9b5ac10f59f76296 = {
    Accordion: (0, $f72c35381dc7f7bb$export$20ec2254f76fa604),
    Alert: (0, $2a334ddd560814f6$export$9d77d9665d829e89),
    Avatar: (0, $ce558396c1a92b86$export$9975d21893c10e66),
    Badge: (0, $a911a67ae6d2c889$export$eb6e7cbc82d0f88b),
    Breadcrumb: (0, $cc3fdae94eb1b55b$export$e2d8c6f6af55009),
    Button: (0, $2b594e3bbb20055b$export$577deec5d331f6be),
    Checkbox: (0, $61fd30b3ec317514$export$86286d8c37984115),
    CloseButton: (0, $66aa61b834d7acbe$export$47615e5b7f7e315f),
    Code: (0, $37cd195a232979b2$export$f9b9a8633a36e3c7),
    Container: (0, $f3d4e61f1bc69a12$export$3ca0760d240fe5f4),
    Divider: (0, $2f1186059c47eccb$export$f0e91f779c5bb416),
    Drawer: (0, $a64de357cbcdc044$export$8057937c11129602),
    Editable: (0, $cfe42fa8d4a04207$export$a09813cbe72349b1),
    Form: (0, $8483826f56e13a7e$export$870bcc1d98fee0aa),
    FormError: (0, $eb50bba4e617f017$export$b8d6747e16cd5f4d),
    FormLabel: (0, $b5540cc09d90536e$export$c49af69dbfc0c993),
    Heading: (0, $8d42ff30ed9b1257$export$5f175074e0f09e7b),
    Input: (0, $846cf22ac3b45cdd$export$b1b9f3bced726e54),
    Kbd: (0, $71ea4626b95d1b0a$export$e193528a501e9a4a),
    Link: (0, $554af029b6cac9a2$export$af7f58b96695762e),
    List: (0, $fb5380deacf696eb$export$ce840f8e8ef752d),
    Menu: (0, $8feddc653f29eb67$export$687ce088075ea42b),
    Modal: (0, $31363ad5391aa394$export$158ae9a07be41c05),
    NumberInput: (0, $5ff242150e969476$export$b9bc5fa6e7f960a1),
    PinInput: (0, $8151251dc736b454$export$8504c22c55a552e0),
    Popover: (0, $7c73a34aeebde440$export$135f12f777be1ef7),
    Progress: (0, $4f18b54ebe330039$export$dc04d8e6a17afea1),
    Radio: (0, $411e979a43979d78$export$f0b387b940941887),
    Select: (0, $ae39e675d135eedf$export$21af0fc3c16183e1),
    Skeleton: (0, $558e9ba631bf4f3f$export$7680371ad2d79142),
    SkipLink: (0, $18146315fbe1ba22$export$a8cf3228ef52959),
    Slider: (0, $2ad9cdad15c1a93e$export$fff8df8fd8e1ed6f),
    Spinner: (0, $29c61cc93d4fb7c0$export$d76156e68e556d3f),
    Stat: (0, $b4583206a34b89a6$export$f3301eb37a20f09e),
    Switch: (0, $e3bb69f65f89805f$export$6856b73e98185bff),
    Table: (0, $f6e60a497ff2aec1$export$3339219781bb5161),
    Tabs: (0, $2d82814d085c9104$export$847a245e7ebce2a1),
    Tag: (0, $e9b6b31835b11b4c$export$f8ab9ac2a319695b),
    Textarea: (0, $d2d1cb6244bb50b7$export$394b8322fab774c1),
    Tooltip: (0, $584e03ef2dd8e988$export$7472a7883840b563),
    Card: (0, $2298b44dfcfa2848$export$880f7b1201440c23),
    Stepper: (0, $f69149d8e034a8c7$export$54c84d54375c8d75)
};









































"use client";
// src/semantic-tokens.ts
var $7a432c504d184e4d$export$c1b409c4e1d33fce = {
    colors: {
        "chakra-body-text": {
            _light: "gray.800",
            _dark: "whiteAlpha.900"
        },
        "chakra-body-bg": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-border-color": {
            _light: "gray.200",
            _dark: "whiteAlpha.300"
        },
        "chakra-inverse-text": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-subtle-bg": {
            _light: "gray.100",
            _dark: "gray.700"
        },
        "chakra-subtle-text": {
            _light: "gray.600",
            _dark: "gray.400"
        },
        "chakra-placeholder-color": {
            _light: "gray.500",
            _dark: "whiteAlpha.400"
        }
    }
};


"use client";
// src/styles.ts
var $a016b3c343ec37c6$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            fontFamily: "body",
            color: "chakra-body-text",
            bg: "chakra-body-bg",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "chakra-placeholder-color"
        },
        "*, *::before, &::after": {
            borderColor: "chakra-border-color"
        }
    }
};










"use client";
// src/index.ts
var $823d38277d136a79$var$direction = "ltr";
var $823d38277d136a79$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
var $823d38277d136a79$export$bca14c5b3b88a9c9 = {
    semanticTokens: $7a432c504d184e4d$export$c1b409c4e1d33fce,
    direction: $823d38277d136a79$var$direction,
    ...(0, $50f899fd68925481$export$651a0b7b10dae380),
    components: $4f1426586426de9e$export$9b5ac10f59f76296,
    styles: $a016b3c343ec37c6$export$9dd6ff9ea0189349,
    config: $823d38277d136a79$var$config
};
var $823d38277d136a79$export$2e2bcd8739ae039 = $823d38277d136a79$export$bca14c5b3b88a9c9;
var $823d38277d136a79$export$9e955aef208055a6 = {
    semanticTokens: $7a432c504d184e4d$export$c1b409c4e1d33fce,
    direction: $823d38277d136a79$var$direction,
    components: {},
    ...(0, $50f899fd68925481$export$651a0b7b10dae380),
    styles: $a016b3c343ec37c6$export$9dd6ff9ea0189349,
    config: $823d38277d136a79$var$config
};



var $gHhSd = parcelRequire("gHhSd");
function $25860983085fed1c$var$isFunction(value) {
    return typeof value === "function";
}
function $25860983085fed1c$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
var $25860983085fed1c$var$createExtendTheme = (theme2)=>{
    return function extendTheme2(...extensions) {
        let overrides = [
            ...extensions
        ];
        let activeTheme = extensions[extensions.length - 1];
        if ((0, $ce252c3b9f4b2082$export$73a6ae01926a4f0e)(activeTheme) && // this ensures backward compatibility
        // previously only `extendTheme(override, activeTheme?)` was allowed
        overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
        else activeTheme = theme2;
        return $25860983085fed1c$var$pipe(...overrides.map((extension)=>(prevTheme)=>$25860983085fed1c$var$isFunction(extension) ? extension(prevTheme) : $25860983085fed1c$export$c42236daa9a25fdd(prevTheme, extension)))(activeTheme);
    };
};
var $25860983085fed1c$export$33a2b855d5b8731e = $25860983085fed1c$var$createExtendTheme((0, $823d38277d136a79$export$bca14c5b3b88a9c9));
var $25860983085fed1c$export$4c7add5200c9692a = $25860983085fed1c$var$createExtendTheme((0, $823d38277d136a79$export$9e955aef208055a6));
function $25860983085fed1c$export$c42236daa9a25fdd(...overrides) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, ...overrides, $25860983085fed1c$var$mergeThemeCustomizer);
}
function $25860983085fed1c$var$mergeThemeCustomizer(source, override, key, object) {
    if (($25860983085fed1c$var$isFunction(source) || $25860983085fed1c$var$isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) return (...args)=>{
        const sourceValue = $25860983085fed1c$var$isFunction(source) ? source(...args) : source;
        const overrideValue = $25860983085fed1c$var$isFunction(override) ? override(...args) : override;
        return (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({}, sourceValue, overrideValue, $25860983085fed1c$var$mergeThemeCustomizer);
    };
    return void 0;
}



var $gHhSd = parcelRequire("gHhSd");

var $lDSNw = parcelRequire("lDSNw");
var $d3b0f8b2bbbbc513$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $d3b0f8b2bbbbc513$var$hasElementType = typeof Element !== "undefined";
var $d3b0f8b2bbbbc513$var$hasMap = typeof Map === "function";
var $d3b0f8b2bbbbc513$var$hasSet = typeof Set === "function";
var $d3b0f8b2bbbbc513$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $d3b0f8b2bbbbc513$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$d3b0f8b2bbbbc513$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($d3b0f8b2bbbbc513$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$d3b0f8b2bbbbc513$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($d3b0f8b2bbbbc513$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($d3b0f8b2bbbbc513$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($d3b0f8b2bbbbc513$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$d3b0f8b2bbbbc513$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$d3b0f8b2bbbbc513$exports = function isEqual(a, b) {
    try {
        return $d3b0f8b2bbbbc513$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


"use client";
function $f2811f1004d7a60c$var$useStyleConfigImpl(themeKey, props = {}) {
    var _a;
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme: theme, colorMode: colorMode } = (0, $45384fe8bd4bf97a$export$a513a93efd9ab8a7)();
    const themeStyleConfig = themeKey ? (0, $f9ff6ad38b3f7068$export$1bb32d0c65da6059)(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($gHhSd)))({
        theme: theme,
        colorMode: colorMode
    }, (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {}, (0, $f9ff6ad38b3f7068$export$2458ce75c8ef9806)((0, $f9ff6ad38b3f7068$export$30a06c8d3562193f)(rest, [
        "children"
    ])));
    const stylesRef = (0, $lDSNw.useRef)({});
    if (styleConfig) {
        const getStyles = (0, $01a983b3ad87bd07$export$f94106bbb00e81eb)(styleConfig);
        const styles = getStyles(mergedProps);
        const isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($d3b0f8b2bbbbc513$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $f2811f1004d7a60c$export$b863f77547fbcb03(themeKey, props = {}) {
    return $f2811f1004d7a60c$var$useStyleConfigImpl(themeKey, props);
}
function $f2811f1004d7a60c$export$31cdfe60c085d76f(themeKey, props = {}) {
    return $f2811f1004d7a60c$var$useStyleConfigImpl(themeKey, props);
}
function $f2811f1004d7a60c$export$d47b3683b351a542(themeKey, props) {
    var _a;
    const { baseConfig: baseConfig, ...restProps } = props;
    const { theme: theme } = (0, $45384fe8bd4bf97a$export$a513a93efd9ab8a7)();
    const overrides = (_a = theme.components) == null ? void 0 : _a[themeKey];
    const styleConfig = overrides ? (0, $25860983085fed1c$export$c42236daa9a25fdd)(overrides, baseConfig) : baseConfig;
    return $f2811f1004d7a60c$var$useStyleConfigImpl(null, {
        ...restProps,
        styleConfig: styleConfig
    });
}




"use client";
var $35745663698a221c$var$spin = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $35745663698a221c$export$7f7cbe89f1eacd2 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("Spinner", props);
    const { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-spinner", className);
    const spinnerStyles = {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: `${$35745663698a221c$var$spin} ${speed} linear infinite`,
        ...styles
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
            srOnly: true,
            children: label
        })
    });
});
$35745663698a221c$export$7f7cbe89f1eacd2.displayName = "Spinner";





var $lDSNw = parcelRequire("lDSNw");

"use client";
function $ba03c5026b26e846$export$f2c034885dd3ba7b(props) {
    const { label: label, placement: placement, spacing: spacing = "0.5rem", children: children = /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $35745663698a221c$export$7f7cbe89f1eacd2), {
        color: "currentColor",
        width: "1em",
        height: "1em"
    }), className: className, __css: __css, ...rest } = props;
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = (0, $lDSNw.useMemo)(()=>({
            display: "flex",
            alignItems: "center",
            position: label ? "relative" : "absolute",
            [marginProp]: label ? spacing : 0,
            fontSize: "1em",
            lineHeight: "normal",
            ...__css
        }), [
        __css,
        label,
        marginProp,
        spacing
    ]);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        className: _className,
        ...rest,
        __css: spinnerStyles,
        children: children
    });
}
$ba03c5026b26e846$export$f2c034885dd3ba7b.displayName = "ButtonSpinner";



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $dc32195927d0d802$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $dc32195927d0d802$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            $dc32195927d0d802$export$d734136a7b018efe(ref, node);
        });
    };
}
function $dc32195927d0d802$export$74665b213cb5c4cf(...refs) {
    return (0, $lDSNw.useMemo)(()=>$dc32195927d0d802$export$c9058316764c140e(...refs), refs);
}





var $lDSNw = parcelRequire("lDSNw");

"use client";
var $92ce3a654c928239$export$353f5b6fc5456de1 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const group = (0, $b19f3fcc4b547227$export$749e21be8b14b968)();
    const styles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("Button", {
        ...group,
        ...props
    });
    const { isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, isLoading: isLoading, isActive: isActive, children: children, leftIcon: leftIcon, rightIcon: rightIcon, loadingText: loadingText, iconSpacing: iconSpacing = "0.5rem", type: type, spinner: spinner, spinnerPlacement: spinnerPlacement = "start", className: className, as: as, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const buttonStyles = (0, $lDSNw.useMemo)(()=>{
        const _focus = {
            ...styles == null ? void 0 : styles["_focus"],
            zIndex: 1
        };
        return {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            outline: "none",
            ...styles,
            ...!!group && {
                _focus: _focus
            }
        };
    }, [
        styles,
        group
    ]);
    const { ref: _ref, type: defaultType } = (0, $ff6f3b7bb8b3fb4f$export$867b668ad7ef61e5)(as);
    const contentProps = {
        rightIcon: rightIcon,
        leftIcon: leftIcon,
        iconSpacing: iconSpacing,
        children: children
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).button, {
        ref: (0, $dc32195927d0d802$export$74665b213cb5c4cf)(ref, _ref),
        as: as,
        type: type != null ? type : defaultType,
        "data-active": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isActive),
        "data-loading": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isLoading),
        __css: buttonStyles,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-button", className),
        ...rest,
        disabled: isDisabled || isLoading,
        children: [
            isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ba03c5026b26e846$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--start",
                label: loadingText,
                placement: "start",
                spacing: iconSpacing,
                children: spinner
            }),
            isLoading ? loadingText || /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
                opacity: 0,
                children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($92ce3a654c928239$var$ButtonContent, {
                    ...contentProps
                })
            }) : /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($92ce3a654c928239$var$ButtonContent, {
                ...contentProps
            }),
            isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ba03c5026b26e846$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--end",
                label: loadingText,
                placement: "end",
                spacing: iconSpacing,
                children: spinner
            })
        ]
    });
});
$92ce3a654c928239$export$353f5b6fc5456de1.displayName = "Button";
function $92ce3a654c928239$var$ButtonContent(props) {
    const { leftIcon: leftIcon, rightIcon: rightIcon, children: children, iconSpacing: iconSpacing } = props;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            leftIcon && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $73d982c18f610c82$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $73d982c18f610c82$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
}



var $lDSNw = parcelRequire("lDSNw");

function $df098d69721f4386$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $df098d69721f4386$var$SnackAlert = (0, $0b21e37f51b583f7$export$19dbccc67153f737)((0, $86896944c76a0602$export$b7063aba2b72bcec));
const $df098d69721f4386$var$ShareRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "eiivkfb0"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $df098d69721f4386$var$Share = ({ url: url, description: description, content: content, onClick: onClick, buildIDs: buildIDs, isLoading: isLoading = false, error: error, leftIcon: leftIcon = (0, $36045e57d0ad82eb$export$c08b4b0e2b0dc027) })=>{
    const [showShare, setShowShare] = (0, $lDSNw.useState)(false);
    const [showCopyConfirm, setShowCopyConfirm] = (0, $lDSNw.useState)(false);
    const handleShareModal = (e)=>{
        onClick && onClick(e);
        setShowShare(!showShare);
    };
    const handleCopy = ()=>{
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).featureShareInteraction(buildIDs, "copy_link");
        navigator.clipboard.writeText(url);
        setShowCopyConfirm(true);
        setTimeout(()=>{
            setShowShare(false);
            setShowCopyConfirm(false);
        }, 2000);
    };
    const toNewTab = ()=>{
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).featureShareInteraction(buildIDs, "open_in_new_tab");
        window.open(url, "_blank").focus();
    };
    const handleClose = ()=>{
        setShowShare(false);
    };
    (0, $lDSNw.useEffect)(()=>{
        if (error) {
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).errorGeneral(error, window.location.href);
            setShowShare(false);
        }
    }, [
        error
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (showShare) (0, $d712a5077c581ffa$export$c96b87a5365cb76c).featureShareOpened(buildIDs);
    }, [
        showShare
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($df098d69721f4386$var$ShareRoot, {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                size: "sm",
                onClick: handleShareModal,
                leftIcon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                    icon: leftIcon
                }),
                children: content
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $165d2eb6edbb3186$export$2e2bcd8739ae039), {
                title: description,
                show: showShare,
                handleClose: handleClose,
                children: [
                    url && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $93a99fe5a3d73d0c$export$f5b8910cec6cf069), {
                        type: "text",
                        value: url,
                        readOnly: true,
                        onClick: (e)=>e.target.select()
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        children: [
                            error && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($df098d69721f4386$var$SnackAlert, {
                                title: "Something wrong happened",
                                status: "error"
                            }),
                            showCopyConfirm ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($df098d69721f4386$var$SnackAlert, {
                                title: "Copied",
                                status: "success"
                            }) : !isLoading ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $73d7766f123d34ce$export$69b1032f2ecdf404), {
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                                        size: "sm",
                                        variant: "primary",
                                        onClick: handleCopy,
                                        leftIcon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                            icon: (0, $36045e57d0ad82eb$export$2c5a9d8548d8810e)
                                        }),
                                        children: "Copy link"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                                        size: "sm",
                                        variant: "secondary",
                                        onClick: toNewTab,
                                        leftIcon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                            icon: (0, $36045e57d0ad82eb$export$b4da69a0247f3620)
                                        }),
                                        children: "Open in new tab"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4c28a9656c805907$export$ba01ffa8d63a745d), {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $df098d69721f4386$export$2e2bcd8739ae039 = $df098d69721f4386$var$Share;




const $a3a72dde8926071a$export$a1279bd7c7d1f05d = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        showGUI: false,
        minSequenceLength: 1,
        showDwellTime: false,
        startProgress: 30,
        endProgress: 65,
        triggerType: "scrub",
        domainWhiteList: [],
        baselineOverride: null,
        // 👇 used in Single Video Chart
        showLegacyVideoChart: false,
        useLegacyBaseline: false,
        turnOffBaselineCompensation: false,
        GUIToggle: ()=>{
            set((prev)=>{
                return {
                    showGUI: !prev.showGUI
                };
            });
        },
        setShowDwellTime: (value)=>{
            set({
                showDwellTime: value
            });
        },
        setMinSequenceLength: (value)=>{
            set({
                minSequenceLength: value
            });
        },
        setStartProgress: (value)=>{
            set({
                startProgress: value
            });
        },
        setEndProgress: (value)=>{
            set({
                endProgress: value
            });
        },
        setTriggerType: (value)=>{
            set({
                triggerType: value
            });
        },
        setDomainWhiteList: (value)=>set({
                domainWhiteList: value
            }),
        setBaselineOverride: (value)=>set({
                baselineOverride: value
            }),
        // 👇 used in Single Video Chart
        setShowLegacyVideoChart: (state)=>{
            set({
                showLegacyVideoChart: state
            });
        },
        setUseLegacyBaseline: (state)=>{
            set({
                useLegacyBaseline: state
            });
        },
        setTurnOffBaselineCompensation: (state)=>{
            set({
                turnOffBaselineCompensation: state
            });
        }
    }));



var $lDSNw = parcelRequire("lDSNw");

function $991862bd4a7fec07$export$f14b4792342014e8(c, r, d) {
    const u = {
        count: 0
    }, i = (e)=>{
        const o = (0, $lDSNw.useRef)(u.count);
        return (0, $lDSNw.useEffect)(()=>{
            o.current += 1, o.current === u.count + 1 && (o.current -= 1, r.setState(e));
        }), null;
    };
    if (i.displayName = `((${c})) devtool`, "undefined" == typeof document) return;
    if (!d) {
        let e = document.getElementById(`simple-zustand-devtools-${c}`);
        e || (e = document.createElement("div"), e.id = `simple-zustand-devtools-${c}`), document.body.appendChild(e), d = e;
    }
    const m = (0, $a1f2ba2fe2d2776b$export$882461b6382ed46c)(d), s = (t)=>{
        t && (m.render((0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(i, Object.assign({}, t))), u.count += 1);
    };
    s(r.getState()), r.subscribe(s);
}



//Benchmark override ☢
const $defc3f76c7e5931b$var$spicedBenchmarks = {
    zehawi: {
        benchmarkEngagementRate: 5
    },
    puvoki: {
        benchmarkEngagedAttentionTime: 5.55,
        benchmarkEngagementRate: 6.21
    }
};
const $defc3f76c7e5931b$var$overrodeBenchmarks = {
    nayoyo: {
        attentionTime: null,
        benchmarkEngagementRate: 6.71,
        benchmarkEngagedAttentionTime: 5.27,
        engagementRate: 5.64,
        engagedAttentionTime: 6.92,
        creatives: null
    }
};
const $defc3f76c7e5931b$export$f5417e9be50ddb9b = (buildId, domains = [])=>{
    const url = new URL(`https://api.playground.xyz/report/cat/results/${buildId}`);
    const params = {
        domainWhiteList: domains.join(",")
    };
    if (domains.length !== 0) url.search = new URLSearchParams(params).toString();
    return $defc3f76c7e5931b$var$overrodeBenchmarks[buildId] ? Promise.resolve($defc3f76c7e5931b$var$overrodeBenchmarks[buildId]) : fetch(url, {
        method: "GET",
        redirect: "follow"
    }).then((response)=>response.text()).then((text)=>JSON.parse(text).data).then(({ metrics: metrics, verticalBenchmarks: verticalBenchmarks, errors: errors, playground: playground })=>{
        if (!metrics) throw new Error(`No metrics available at this time for build ${buildId}`);
        if (!playground["creatives"]) throw new Error("no creatives metadata");
        if (errors) throw new Error(errors[0].title);
        const payload = {
            attentionTime: metrics["avg.attention_time"],
            benchmarkEngagementRate: verticalBenchmarks["rate.engagement"],
            benchmarkEngagedAttentionTime: verticalBenchmarks["avg.engaged_attention_time"],
            engagementRate: metrics["rate.engagement"],
            engagedAttentionTime: metrics["avg.engaged_attention_time"],
            creatives: playground["creatives"][0].name,
            playground: playground
        };
        return Object.assign({}, payload, $defc3f76c7e5931b$var$spicedBenchmarks[buildId] ?? {});
    });
};


const $d5dab4c422a78054$export$9d9fdfda0409c2a2 = {
    ER: "ER",
    EAT: "EAT"
};
const $d5dab4c422a78054$export$90856cc8b6bce002 = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        items: [],
        update: (buildId, metricsUpdates)=>{
            set((state)=>({
                    items: state.items.map((item)=>{
                        if (item.buildId === buildId) item = {
                            ...item,
                            ...metricsUpdates
                        };
                        return item;
                    })
                }));
        },
        get: (buildId)=>get().items.find((item)=>item.buildId === buildId),
        fetchMetrics: async (buildId, domains = [])=>{
            const { attentionTime: attentionTime, benchmarkEngagementRate: benchmarkEngagementRate, benchmarkEngagedAttentionTime: benchmarkEngagedAttentionTime, engagementRate: engagementRate, engagedAttentionTime: engagedAttentionTime } = await (0, $defc3f76c7e5931b$export$f5417e9be50ddb9b)(buildId, domains);
            let items = get().items;
            const currentMetrics = items.find((item)=>item.buildId === buildId);
            if (!currentMetrics) items.push({
                buildId: buildId,
                attentionTime: attentionTime,
                benchmarkEngagementRate: benchmarkEngagementRate,
                benchmarkEngagedAttentionTime: benchmarkEngagedAttentionTime,
                engagementRate: engagementRate,
                engagedAttentionTime: engagedAttentionTime
            });
            else items = items.map((item)=>item.buildId === buildId ? {
                    ...item,
                    attentionTime: attentionTime,
                    benchmarkEngagementRate: benchmarkEngagementRate,
                    benchmarkEngagedAttentionTime: benchmarkEngagedAttentionTime,
                    engagementRate: engagementRate,
                    engagedAttentionTime: engagedAttentionTime
                } : item);
            set(()=>({
                    items: [
                        ...items
                    ]
                }));
        },
        create: async (buildIds)=>{
            for (let buildId of buildIds)try {
                await get().fetchMetrics(buildId);
            } catch (error) {
                //Todo: surface errors if any
                set((state)=>({
                        items: [
                            ...state.items,
                            {
                                buildId: buildId,
                                attentionTime: null,
                                benchmarkEngagementRate: null,
                                benchmarkEngagedAttentionTime: null,
                                engagementRate: null,
                                engagedAttentionTime: null,
                                error: {
                                    attentionTime: "Not enough data",
                                    engagementRate: "Not enough data",
                                    engagedAttentionTime: "Not enough data"
                                }
                            }
                        ]
                    }));
            }
        },
        getBestPerforming: ()=>{
            const metrics = [
                ...get().items
            ];
            const params = new URLSearchParams(window.location.href.split("?")[1]);
            const rule = params.get("compareRule");
            if (metrics.length < 2) return;
            switch(rule){
                default:
                case $d5dab4c422a78054$export$9d9fdfda0409c2a2.EAT:
                    {
                        const { buildId: buildId } = metrics.sort((a, b)=>Number(b.engagedAttentionTime) - Number(a.engagedAttentionTime))[0];
                        return {
                            rule: "EAT",
                            buildId: buildId
                        };
                    }
                case $d5dab4c422a78054$export$9d9fdfda0409c2a2.ER:
                    {
                        const { buildId: buildId } = metrics.sort((a, b)=>Number(b.engagementRate) - Number(a.engagementRate))[0];
                        return {
                            rule: "ER",
                            buildId: buildId
                        };
                    }
            }
        }
    }));



const $f93c997b56f0c027$export$4af55d2ad01cdc22 = (e)=>{
    if (e.target.contentWindow !== null && e.target.contentWindow.document.getElementById("middle-ad") !== null) {
        const seamlessFrame = e.target.contentWindow.document.getElementById("middle-ad").getElementsByTagName("iframe")[0];
        seamlessFrame.addEventListener("onload", ()=>{
            console.log("iframe loaded!");
        }, true);
        const format = $f93c997b56f0c027$export$56b99a300be83d83(seamlessFrame.contentWindow.xyzContext.dimension.creative.format);
        return seamlessFrame.contentWindow[format] && seamlessFrame.contentWindow[format].$markerElement && seamlessFrame.contentWindow[format].$markerElement.length ? seamlessFrame.contentWindow[format].$markerElement[0].getBoundingClientRect().height : 0;
    } else {
        console.error("NO AD HEIGHT DETECTED");
        return 0;
    }
};
const $f93c997b56f0c027$export$56b99a300be83d83 = (format)=>{
    switch(format){
        case "hang-time-jnr":
            return "hangTimeJnr";
        case "hang-time":
            return "hangTime";
        case "hitchhike":
            return "hitchhike";
        case "hover-board":
            return "hoverBoard";
        case "video-switch":
            return "videoSwitch";
        default:
            console.error("Format not found");
            return;
    }
};
const $f93c997b56f0c027$export$1bcd6871fa54402c = (video)=>{
    if (!video) return false;
    return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
};
const $f93c997b56f0c027$export$74265bcf7deb1b4 = (window, target)=>{
    return new Promise((resolve)=>{
        if (!window.document.querySelector(target) || window.document.querySelector(target).length === 0) setTimeout(()=>{
            // we're checking if the target has loaded
            // and not progressing until it has
            $f93c997b56f0c027$export$74265bcf7deb1b4(window, target).then(()=>resolve());
        }, 50);
        else {
            console.log(`${target} is there!`);
            resolve();
        }
    });
};
const $f93c997b56f0c027$export$9a00dee1beb8f576 = (string, delimiter)=>{
    let words = string.split(delimiter).map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    return words.join(" ");
};
const $f93c997b56f0c027$export$621e425396705b25 = (buildID, format = "hang-time")=>{
    const urlStart = `https://studio.playgroundxyz.com/${buildID}/`;
    const urlEnd = `quiet?pos=middle-ad&size=300x250&show-engagements=true`;
    return urlStart + urlEnd;
};
const $f93c997b56f0c027$export$42a76b873cea5d5 = (iframe)=>{
    try {
        const sizeToggler = iframe.document.body.querySelector(".size-toggler");
        console.log("find me", sizeToggler);
        sizeToggler.style.right = "70px";
        sizeToggler.style.bottom = "40px";
        sizeToggler.style.transform = "scale(1.6)";
    } catch (e) {
        console.log("couldn't enlarge size toggler ", e);
    }
};



var $f60691f64d37fa54$exports = {};
$f60691f64d37fa54$exports = JSON.parse('["foxsports.com.au","news.com.au","nine.com.au","7news.com.au","theguardian.com","theage.com.au","9news.com.au","smh.com.au"]');




var $lDSNw = parcelRequire("lDSNw");







var $lDSNw = parcelRequire("lDSNw");


"use client";
var $b9e16fda3a2a93e8$export$e71c4d32a2263218 = (0, $5c12d9132a121f51$export$7cd122d781af9fa4)("div");
$b9e16fda3a2a93e8$export$e71c4d32a2263218.displayName = "Box";
var $b9e16fda3a2a93e8$export$b09fb900337259de = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Square2(props, ref) {
    const { size: size, centerContent: centerContent = true, ...rest } = props;
    const styles = centerContent ? {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } : {};
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($b9e16fda3a2a93e8$export$e71c4d32a2263218, {
        ref: ref,
        boxSize: size,
        __css: {
            ...styles,
            flexShrink: 0,
            flexGrow: 0
        },
        ...rest
    });
});
$b9e16fda3a2a93e8$export$b09fb900337259de.displayName = "Square";
var $b9e16fda3a2a93e8$export$c89a927ffc67e6fa = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Circle2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($b9e16fda3a2a93e8$export$b09fb900337259de, {
        size: size,
        ref: ref,
        borderRadius: "9999px",
        ...rest
    });
});
$b9e16fda3a2a93e8$export$c89a927ffc67e6fa.displayName = "Circle";




var $lDSNw = parcelRequire("lDSNw");

"use client";
var $afaf87b4b67d333c$export$c25acd513dcc8062 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { icon: icon, children: children, isRound: isRound, "aria-label": ariaLabel, ...rest } = props;
    const element = icon || children;
    const _children = (0, $lDSNw.isValidElement)(element) ? (0, $lDSNw.cloneElement)(element, {
        "aria-hidden": true,
        focusable: false
    }) : null;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
        padding: "0",
        borderRadius: isRound ? "full" : void 0,
        ref: ref,
        "aria-label": ariaLabel,
        ...rest,
        children: _children
    });
});
$afaf87b4b67d333c$export$c25acd513dcc8062.displayName = "IconButton";





"use client";
var $5b8bf08ef96c0b6f$var$fallbackIcon = {
    path: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
                strokeLinecap: "round",
                fill: "none",
                d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
                fill: "currentColor",
                strokeLinecap: "round",
                d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("circle", {
                fill: "none",
                strokeMiterlimit: "10",
                cx: "12",
                cy: "12",
                r: "11.25"
            })
        ]
    }),
    viewBox: "0 0 24 24"
};
var $5b8bf08ef96c0b6f$export$f04a61298a47a40f = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css, ...rest } = props;
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-icon", className);
    const customStyles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("Icon", props);
    const styles = {
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color,
        ...__css,
        ...customStyles
    };
    const shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    const _viewBox = viewBox != null ? viewBox : $5b8bf08ef96c0b6f$var$fallbackIcon.viewBox;
    if (element && typeof element !== "string") return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).svg, {
        as: element,
        ...shared,
        ...rest
    });
    const _path = children != null ? children : $5b8bf08ef96c0b6f$var$fallbackIcon.path;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).svg, {
        verticalAlign: "middle",
        viewBox: _viewBox,
        ...shared,
        ...rest,
        children: _path
    });
});
$5b8bf08ef96c0b6f$export$f04a61298a47a40f.displayName = "Icon";
var $5b8bf08ef96c0b6f$export$21036209a317fcec = $5b8bf08ef96c0b6f$export$f04a61298a47a40f;




var $lDSNw = parcelRequire("lDSNw");

"use client";
function $c101c0301221342e$export$274edc73af1ae9c8(options) {
    const { viewBox: viewBox = "0 0 24 24", d: pathDefinition, displayName: displayName, defaultProps: defaultProps = {} } = options;
    const path = (0, $lDSNw.Children).toArray(options.path);
    const Comp = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
            ref: ref,
            viewBox: viewBox,
            ...defaultProps,
            ...props,
            children: path.length ? path : /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
                fill: "currentColor",
                d: pathDefinition
            })
        }));
    Comp.displayName = displayName;
    return Comp;
}


"use client";
var $251e31a124359657$export$a6b7c34d56975de0 = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    d: "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
    displayName: "AddIcon"
});



"use client";
var $127490c0d053d8d5$export$cb808a3c41736d8e = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    displayName: "MinusIcon",
    path: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("g", {
        fill: "currentColor",
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("rect", {
            height: "4",
            width: "20",
            x: "2",
            y: "10"
        })
    })
});


function $16e7a7f9714a2a6b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $16e7a7f9714a2a6b$export$c8598ceb51ca7025 = ({ show: show, children: children, onToggle: onToggle, ...rest })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($16e7a7f9714a2a6b$var$GUIWrapperRoot, {
        className: `${show ? "show" : "hide"}`,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($16e7a7f9714a2a6b$var$GUITitle, {
                onClick: onToggle,
                show: show,
                children: show ? "Close Controls" : "Open Controls"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($16e7a7f9714a2a6b$var$GUIBody, {
                children: children
            })
        ]
    });
const $16e7a7f9714a2a6b$var$GUIWrapperRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
    target: "evmrwhe8"
})({
    name: "dn0ye9",
    styles: "--GUI-primary:var(--colors-modes-dark-neutral-0);--GUI-secondary:var(--colors-modes-dark-neutral-1);--GUI-accent:var(--colors-primary);--GUI-text:white;position:fixed;right:max(calc((100vw - var(--maxScreenWidth)) / 2 + var(--space-4)), 20px);bottom:0;background:var(--GUI-secondary);transition:transform 0.2s ease-in-out;box-shadow:var(--shadows-high);color:var(--GUI-text);&.hide{transform:translateY(100%);opacity:0.8;box-shadow:var(--shadows-low);}"
});
const $16e7a7f9714a2a6b$var$GUITitle = ({ show: show, onClick: onClick, children: children })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($16e7a7f9714a2a6b$var$TitleRoot, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                icon: show ? (0, $36045e57d0ad82eb$export$8db9bc521720fccd) : (0, $36045e57d0ad82eb$export$877e5ae47a854215)
            }),
            children
        ]
    });
const $16e7a7f9714a2a6b$var$TitleRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "evmrwhe7"
})({
    name: "iuuerl",
    styles: "background:var(--GUI-primary);color:var(--GUI-text);height:30px;display:flex;justify-content:center;align-items:center;user-select:none;cursor:pointer;position:absolute;top:-30px;width:100%;border-top-left-radius:10px;border-top-right-radius:10px;gap:10px"
});
const $16e7a7f9714a2a6b$export$daec6fb4b8b794fe = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("i", {
    target: "evmrwhe6"
})({
    name: "zb1lk8",
    styles: "margin-top:10px;display:block"
});
const $16e7a7f9714a2a6b$var$GUIBody = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "evmrwhe5"
})({
    name: "1gynneb",
    styles: "padding:20px;gap:5px;display:flex;flex-direction:column"
});
const $16e7a7f9714a2a6b$export$e0d104a3bb02fa25 = ({ title: title, children: children })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($16e7a7f9714a2a6b$var$GUIRowRoot, {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($16e7a7f9714a2a6b$var$GUIControlValue, {
                children: children
            })
        ]
    });
const $16e7a7f9714a2a6b$var$GUIRowRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "evmrwhe4"
})({
    name: "a26lvh",
    styles: "display:flex;justify-content:space-between;&:not(:last-of-type){padding-bottom:5px;border-bottom:1px solid var(--GUI-accent);}"
});
const $16e7a7f9714a2a6b$var$GUIControlValue = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "evmrwhe3"
})({
    name: "1as1xps",
    styles: "display:flex;justify-content:flex-end;align-items:center;width:250px;user-select:none"
});
const $16e7a7f9714a2a6b$var$GUIValue = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "evmrwhe2"
})({
    name: "mza0ky",
    styles: "padding:3px 5px;margin:0 7px;background:var(--GUI-primary);border-radius:35px;-webkit-appearance:none;outline:none;width:60px;text-align:center"
});
const $16e7a7f9714a2a6b$var$GUISelectRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("select", {
    target: "evmrwhe1"
})({
    name: "fnwhpp",
    styles: "background-color:var(--GUI-primary);box-sizing:content-box;color:white;border-radius:10px;padding-left:10px;padding-top:2px;padding-bottom:2px"
});
const $16e7a7f9714a2a6b$export$fa08ce9ad5cfed0 = ({ options: options, ...restProps })=>{
    // console.log(options);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($16e7a7f9714a2a6b$var$GUISelectRoot, {
        ...restProps,
        children: options.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("option", {
                value: key,
                children: label
            }, key))
    });
};
const $16e7a7f9714a2a6b$export$409ddba4ba8fc5e = ({ value: value = false, onChange: onChange })=>{
    const [toggle, setToggle] = (0, $lDSNw.useState)(value);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($16e7a7f9714a2a6b$var$GUISwitchRoot, {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("input", {
                type: "checkbox",
                onChange: ()=>{
                    setToggle((value)=>{
                        onChange(!value);
                        return !value;
                    });
                },
                checked: toggle
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {})
        ]
    });
};
const $16e7a7f9714a2a6b$var$GUISwitchRoot = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("label", {
    target: "evmrwhe0"
})({
    name: "hag836",
    styles: 'position:relative;display:inline-block;width:50px;height:20px;margin-left:10px;input{opacity:0;width:0;height:0;&:checked+span{background-color:var(--GUI-accent);}&:focus+span{box-shadow:0 0 1px var(--GUI-secondary);}&:checked+span:before{transform:translateX(29px);}}span{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:var(--GUI-primary);-webkit-transition:0.4s;transition:0.4s;border-radius:10px;&:before{position:absolute;content:"";height:12px;width:12px;left:4px;bottom:4px;background-color:white;-webkit-transition:0.4s;transition:0.4s;border-radius:34px;}}'
});
const $16e7a7f9714a2a6b$export$c6bde390f80b46d1 = ({ lowerbound: lowerbound, upperbound: upperbound, currentValue: currentValue, step: step = 1, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                "aria-label": "decrement value",
                size: "sm",
                isRound: true,
                isDisabled: currentValue <= lowerbound,
                onClick: ()=>{
                    onChange({
                        step: step * -1
                    });
                },
                icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $127490c0d053d8d5$export$cb808a3c41736d8e), {})
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($16e7a7f9714a2a6b$var$GUIValue, {
                children: currentValue
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                "aria-label": "increment value",
                size: "sm",
                isDisabled: currentValue >= upperbound,
                isRound: true,
                onClick: ()=>{
                    onChange({
                        step: step
                    });
                },
                icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $251e31a124359657$export$a6b7c34d56975de0), {})
            })
        ]
    });
};


const $dd799f14f0ed3f88$export$30eb518a543288d4 = (0, $0b21e37f51b583f7$export$97f2a48bc6874b01)(()=>{
    const showGUI = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.showGUI);
    const GUIToggle = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.GUIToggle);
    const setDomainWhiteList = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setDomainWhiteList);
    // use effects for now, probably a better way to do this
    (0, $lDSNw.useEffect)(()=>{
        if (showGUI) (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiPanel("open");
    }, [
        showGUI
    ]);
    const handleWhitelistChange = (value)=>{
        setDomainWhiteList(value ? (0, (/*@__PURE__*/$parcel$interopDefault($f60691f64d37fa54$exports))) : []);
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiAdjust("setDomainWhiteList", value);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $16e7a7f9714a2a6b$export$c8598ceb51ca7025), {
        show: showGUI,
        onToggle: GUIToggle,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                title: "Domain Filter",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$409ddba4ba8fc5e), {
                    onChange: handleWhitelistChange
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$daec6fb4b8b794fe), {
                children: "*This is an experimental feature. None of the settings will be stored."
            })
        ]
    });
});






parcelRequire("lDSNw");




parcelRequire("lDSNw");


"use client";
var $187510d0bbc2a208$export$50d5391cd1a018c6 = (props)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        className: "chakra-stack__item",
        ...props,
        __css: {
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0,
            ...props["__css"]
        }
    });
$187510d0bbc2a208$export$50d5391cd1a018c6.displayName = "StackItem";


// src/responsive.ts

var $236059bf8082cb80$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $236059bf8082cb80$export$eca1915781c2aaca(prop, mapper) {
    if (Array.isArray(prop)) return prop.map((item)=>item === null ? null : mapper(item));
    if ((0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(prop)) return Object.keys(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $236059bf8082cb80$export$d9dcf045f3ec145e(obj, bps = $236059bf8082cb80$export$d07517a676ce386f) {
    const result = bps.map((br)=>{
        var _a;
        return (_a = obj[br]) != null ? _a : null;
    });
    const lastItem = result[result.length - 1];
    while(lastItem === null)result.pop();
    return result;
}
function $236059bf8082cb80$export$60476530468641e7(values, bps = $236059bf8082cb80$export$d07517a676ce386f) {
    const result = {};
    values.forEach((value, index)=>{
        const key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $236059bf8082cb80$export$2f4b3062f5f33794(obj, bps = $236059bf8082cb80$export$d07517a676ce386f) {
    const keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
var $236059bf8082cb80$export$4cdfc817e07de39e = (v)=>Number.isNaN(Number(v));


"use client";
function $c924f8e2d9fe73f3$export$d4a6a5cc582519a5(options) {
    const { spacing: spacing, direction: direction } = options;
    const dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $236059bf8082cb80$export$eca1915781c2aaca)(direction, (value)=>dividerStyles[value])
    };
}


// src/index.ts

var $lDSNw = parcelRequire("lDSNw");
function $b40941a6e809376a$export$b2c43d7d050b2e63(children) {
    return (0, $lDSNw.Children).toArray(children).filter((child)=>(0, $lDSNw.isValidElement)(child));
}





var $lDSNw = parcelRequire("lDSNw");

"use client";
var $2e65c9f8b8a92486$export$694e0d28c7ffc90c = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const direction = isInline ? "row" : directionProp != null ? directionProp : "column";
    const dividerStyle = (0, $lDSNw.useMemo)(()=>(0, $c924f8e2d9fe73f3$export$d4a6a5cc582519a5)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = (0, $lDSNw.useMemo)(()=>{
        const validChildren = (0, $b40941a6e809376a$export$b2c43d7d050b2e63)(children);
        return shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const wrappedChild = /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $187510d0bbc2a208$export$50d5391cd1a018c6), {
                children: child
            }, key);
            const _child = shouldWrapChildren ? wrappedChild : child;
            if (!hasDivider) return _child;
            const clonedDivider = (0, $lDSNw.cloneElement)(divider, {
                __css: dividerStyle
            });
            const _divider = isLast ? null : clonedDivider;
            return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $lDSNw.Fragment), {
                children: [
                    _child,
                    _divider
                ]
            }, key);
        });
    }, [
        divider,
        dividerStyle,
        hasDivider,
        shouldUseChildren,
        shouldWrapChildren,
        children
    ]);
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-stack", className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
    });
});
$2e65c9f8b8a92486$export$694e0d28c7ffc90c.displayName = "Stack";




"use client";
var $34f549143475a073$export$15e411dc07b9c834 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2e65c9f8b8a92486$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "row",
        ref: ref
    }));
$34f549143475a073$export$15e411dc07b9c834.displayName = "HStack";



// src/compact.ts
function $0fbee2d796a5b411$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}



"use client";
var $8b7e41b0c142e65e$export$5f1af8db9871e1d6 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Text2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("Text", props);
    const { className: className, align: align, decoration: decoration, casing: casing, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const aliasedProps = (0, $0fbee2d796a5b411$export$8e16b83750b44988)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).p, {
        ref: ref,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
    });
});
$8b7e41b0c142e65e$export$5f1af8db9871e1d6.displayName = "Text";


function $ae26d2322f4678ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ae26d2322f4678ff$export$57579a683bdd41d1 = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "e1a3p1cc6"
})({
    name: "b3yety",
    styles: "position:relative;width:100%;display:flex;justify-content:space-around;color:var(--colors-neutral-2);background:white;box-sizing:border-box;opacity:1;>div{width:50%;display:flex;justify-content:space-around;align-items:center;span{width:30px;height:4px;display:block;border-radius:4px;}}"
});
const $ae26d2322f4678ff$var$ActualLegend = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("span", {
    target: "e1a3p1cc5"
})({
    name: "1m7p0sk",
    styles: "height:4px;width:30px;background:var(--colors-brandGradient);display:block;border-radius:4px"
});
const $ae26d2322f4678ff$var$BaselineLegend = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("span", {
    target: "e1a3p1cc4"
})({
    name: "qra8h9",
    styles: "height:4px;width:30px;background:#c4c4c4;display:block;border-radius:4px"
});
const $ae26d2322f4678ff$var$OldLegend = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("span", {
    target: "e1a3p1cc3"
})({
    name: "thfv0t",
    styles: "height:4px;width:30px;background:#c5c5c5;display:block;border-radius:4px"
});
const $ae26d2322f4678ff$var$NewLegend = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("span", {
    target: "e1a3p1cc2"
})({
    name: "1escepx",
    styles: "height:4px;width:30px;background:var(--colors-secondary);display:block;border-radius:4px"
});
const $ae26d2322f4678ff$var$ScrubLegend = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("span", {
    target: "e1a3p1cc1"
})({
    name: "1kvy5f6",
    styles: "height:4px;width:30px;background:var(--colors-neutral-2);display:block;border-radius:4px"
});
const $ae26d2322f4678ff$var$DwelltimeLegend = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "e1a3p1cc0"
})({
    name: "634nrf",
    styles: "height:20px;width:20px;border-radius:20px;background:var(--colors-brandGradient);opacity:0.9"
});
$ae26d2322f4678ff$export$57579a683bdd41d1.Actual = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ae26d2322f4678ff$var$LegendsHStack, {
        gap: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "xs",
                children: "Actual:"
            }),
            " ",
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ae26d2322f4678ff$var$ActualLegend, {})
        ]
    });
$ae26d2322f4678ff$export$57579a683bdd41d1.Baseline = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ae26d2322f4678ff$var$LegendsHStack, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "xs",
                children: "Format Average:"
            }),
            " ",
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ae26d2322f4678ff$var$BaselineLegend, {})
        ]
    });
$ae26d2322f4678ff$export$57579a683bdd41d1.Old = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ae26d2322f4678ff$var$LegendsHStack, {
        gap: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "xs",
                children: "Creative A:"
            }),
            " ",
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ae26d2322f4678ff$var$OldLegend, {})
        ]
    });
$ae26d2322f4678ff$export$57579a683bdd41d1.New = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ae26d2322f4678ff$var$LegendsHStack, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "xs",
                children: "Creative B:"
            }),
            " ",
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ae26d2322f4678ff$var$NewLegend, {})
        ]
    });
$ae26d2322f4678ff$export$57579a683bdd41d1.Scrub = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ae26d2322f4678ff$var$LegendsHStack, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "xs",
                children: "Ad Engagement:"
            }),
            " ",
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ae26d2322f4678ff$var$ScrubLegend, {})
        ]
    });
$ae26d2322f4678ff$export$57579a683bdd41d1.Dwelltime = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ae26d2322f4678ff$var$LegendsHStack, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "xs",
                children: "Dwell Time:"
            }),
            " ",
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ae26d2322f4678ff$var$DwelltimeLegend, {})
        ]
    });
const $ae26d2322f4678ff$var$LegendsHStack = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        alignItems: "center",
        gap: 2,
        py: "1",
        children: children
    });
};



var $lDSNw = parcelRequire("lDSNw");




"use client";
var $aa57447b0555e960$export$f51f4c4ede09e011 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Flex2(props, ref) {
    const { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink, ...rest } = props;
    const styles = {
        display: "flex",
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$aa57447b0555e960$export$f51f4c4ede09e011.displayName = "Flex";


const $72ac3f8b3eb24366$export$4bae593ab138bf46 = ({ xAxisLabel: xAxisLabel = "Ad Progress", yAxisLabel: yAxisLabel = "Ad Engagement", bottomLeftLabel: bottomLeftLabel = "Scroll in", bottomRightLabel: bottomRightLabel = "Scroll out", ...rest })=>{
    const queryParams = new URLSearchParams(location.search);
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                w: "360px",
                justifyContent: "center",
                position: "relative",
                transformOrigin: "top left",
                transform: "rotate(270deg)",
                ...rest,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                    fontSize: isPresentationMode ? "26px" : "sm",
                    color: "blackAlpha.500",
                    children: yAxisLabel
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                ...rest,
                position: "relative",
                top: "-50px",
                w: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        pl: 12,
                        fontSize: isPresentationMode ? "md" : "xs",
                        color: "blackAlpha.500",
                        children: bottomLeftLabel
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        fontSize: isPresentationMode ? "lg" : "sm",
                        color: "blackAlpha.500",
                        children: xAxisLabel
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        mr: 2,
                        fontSize: isPresentationMode ? "lg" : "xs",
                        color: "blackAlpha.500",
                        children: bottomRightLabel
                    })
                ]
            })
        ]
    });
};



"use client";
// src/tooltip.transition.tsx
var $9bd342d3986c7d71$export$dcdf75081b88279d = {
    exit: {
        scale: 0.85,
        opacity: 0,
        transition: {
            opacity: {
                duration: 0.15,
                easings: "easeInOut"
            },
            scale: {
                duration: 0.2,
                easings: "easeInOut"
            }
        }
    },
    enter: {
        scale: 1,
        opacity: 1,
        transition: {
            opacity: {
                easings: "easeOut",
                duration: 0.2
            },
            scale: {
                duration: 0.2,
                ease: [
                    0.175,
                    0.885,
                    0.4,
                    1.1
                ]
            }
        }
    }
};


// src/dom.ts
function $9fe60e153b4d4482$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $9fe60e153b4d4482$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$9fe60e153b4d4482$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $9fe60e153b4d4482$export$f21a1ffae260145a(node) {
    var _a, _b;
    return (_b = (_a = $9fe60e153b4d4482$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
function $9fe60e153b4d4482$export$b204af158042fbac(node) {
    return $9fe60e153b4d4482$export$45a5e7f76e0caa8d(node) ? node.ownerDocument : document;
}
function $9fe60e153b4d4482$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $9fe60e153b4d4482$export$4e09c449d6c407f7() {
    return Boolean(globalThis == null ? void 0 : globalThis.document);
}
function $9fe60e153b4d4482$export$cd4e5573fbe2b576(node) {
    return $9fe60e153b4d4482$export$b204af158042fbac(node).activeElement;
}
function $9fe60e153b4d4482$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}


// src/scroll.ts
function $d20cb2dd272e02af$var$isScrollParent(el) {
    const win = el.ownerDocument.defaultView || window;
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = win.getComputedStyle(el);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $d20cb2dd272e02af$var$getParent(el) {
    if (el.localName === "html") return el;
    return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function $d20cb2dd272e02af$export$cfa2225e87938781(el) {
    if ([
        "html",
        "body",
        "#document"
    ].includes(el.localName)) return el.ownerDocument.body;
    if ((0, $9fe60e153b4d4482$export$1b3bfaa9684536aa)(el) && $d20cb2dd272e02af$var$isScrollParent(el)) return el;
    return $d20cb2dd272e02af$export$cfa2225e87938781($d20cb2dd272e02af$var$getParent(el));
}


"use client";
// src/utils.ts
var $985d22c34d4a36b5$var$toVar = (value, fallback)=>({
        var: value,
        varRef: fallback ? `var(${value}, ${fallback})` : `var(${value})`
    });
var $985d22c34d4a36b5$export$fd62969fb0b7081c = {
    arrowShadowColor: $985d22c34d4a36b5$var$toVar("--popper-arrow-shadow-color"),
    arrowSize: $985d22c34d4a36b5$var$toVar("--popper-arrow-size", "8px"),
    arrowSizeHalf: $985d22c34d4a36b5$var$toVar("--popper-arrow-size-half"),
    arrowBg: $985d22c34d4a36b5$var$toVar("--popper-arrow-bg"),
    transformOrigin: $985d22c34d4a36b5$var$toVar("--popper-transform-origin"),
    arrowOffset: $985d22c34d4a36b5$var$toVar("--popper-arrow-offset")
};
function $985d22c34d4a36b5$export$bba5a971afe05444(placement) {
    if (placement.includes("top")) return `1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("bottom")) return `-1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("right")) return `-1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("left")) return `1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
}
var $985d22c34d4a36b5$var$transforms = {
    top: "bottom center",
    "top-start": "bottom left",
    "top-end": "bottom right",
    bottom: "top center",
    "bottom-start": "top left",
    "bottom-end": "top right",
    left: "right center",
    "left-start": "right top",
    "left-end": "right bottom",
    right: "left center",
    "right-start": "left top",
    "right-end": "left bottom"
};
var $985d22c34d4a36b5$export$4b94194e48e4ec29 = (placement)=>$985d22c34d4a36b5$var$transforms[placement];
var $985d22c34d4a36b5$var$defaultEventListeners = {
    scroll: true,
    resize: true
};
function $985d22c34d4a36b5$export$fafd30a196ad8838(value) {
    let eventListeners;
    if (typeof value === "object") eventListeners = {
        enabled: true,
        options: {
            ...$985d22c34d4a36b5$var$defaultEventListeners,
            ...value
        }
    };
    else eventListeners = {
        enabled: value,
        options: $985d22c34d4a36b5$var$defaultEventListeners
    };
    return eventListeners;
}


"use client";
// src/modifiers.ts
var $5b39cb705ef77067$export$45d38cc6268103c7 = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: ({ state: state })=>{
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state: state })=>()=>{
            const reference = state.elements.reference;
            state.elements.popper.style.width = `${reference.offsetWidth}px`;
        }
};
var $5b39cb705ef77067$export$bd7bb1bc943e0611 = {
    name: "transformOrigin",
    enabled: true,
    phase: "write",
    fn: ({ state: state })=>{
        $5b39cb705ef77067$var$setTransformOrigin(state);
    },
    effect: ({ state: state })=>()=>{
            $5b39cb705ef77067$var$setTransformOrigin(state);
        }
};
var $5b39cb705ef77067$var$setTransformOrigin = (state)=>{
    state.elements.popper.style.setProperty((0, $985d22c34d4a36b5$export$fd62969fb0b7081c).transformOrigin.var, (0, $985d22c34d4a36b5$export$4b94194e48e4ec29)(state.placement));
};
var $5b39cb705ef77067$export$36f2614d91c73bb6 = {
    name: "positionArrow",
    enabled: true,
    phase: "afterWrite",
    fn: ({ state: state })=>{
        $5b39cb705ef77067$var$setArrowStyles(state);
    }
};
var $5b39cb705ef77067$var$setArrowStyles = (state)=>{
    var _a;
    if (!state.placement) return;
    const overrides = $5b39cb705ef77067$var$getArrowStyle(state.placement);
    if (((_a = state.elements) == null ? void 0 : _a.arrow) && overrides) {
        Object.assign(state.elements.arrow.style, {
            [overrides.property]: overrides.value,
            width: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowSize.varRef,
            height: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowSize.varRef,
            zIndex: -1
        });
        const vars = {
            [(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowSizeHalf.var]: `calc(${(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowSize.varRef} / 2 - 1px)`,
            [(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowOffset.var]: `calc(${(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowSizeHalf.varRef} * -1)`
        };
        for(const property in vars)state.elements.arrow.style.setProperty(property, vars[property]);
    }
};
var $5b39cb705ef77067$var$getArrowStyle = (placement)=>{
    if (placement.startsWith("top")) return {
        property: "bottom",
        value: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("bottom")) return {
        property: "top",
        value: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("left")) return {
        property: "right",
        value: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("right")) return {
        property: "left",
        value: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowOffset.varRef
    };
};
var $5b39cb705ef77067$export$616f7fc4ffce8510 = {
    name: "innerArrow",
    enabled: true,
    phase: "main",
    requires: [
        "arrow"
    ],
    fn: ({ state: state })=>{
        $5b39cb705ef77067$var$setInnerArrowStyles(state);
    },
    effect: ({ state: state })=>()=>{
            $5b39cb705ef77067$var$setInnerArrowStyles(state);
        }
};
var $5b39cb705ef77067$var$setInnerArrowStyles = (state)=>{
    if (!state.elements.arrow) return;
    const inner = state.elements.arrow.querySelector("[data-popper-arrow-inner]");
    if (!inner) return;
    const boxShadow = (0, $985d22c34d4a36b5$export$bba5a971afe05444)(state.placement);
    if (boxShadow) inner.style.setProperty("--popper-arrow-default-shadow", boxShadow);
    Object.assign(inner.style, {
        transform: "rotate(45deg)",
        background: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowBg.varRef,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: "inherit",
        boxShadow: `var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))`
    });
};


"use client";
// src/popper.placement.ts
var $863262f1d465b21b$var$logicals = {
    "start-start": {
        ltr: "left-start",
        rtl: "right-start"
    },
    "start-end": {
        ltr: "left-end",
        rtl: "right-end"
    },
    "end-start": {
        ltr: "right-start",
        rtl: "left-start"
    },
    "end-end": {
        ltr: "right-end",
        rtl: "left-end"
    },
    start: {
        ltr: "left",
        rtl: "right"
    },
    end: {
        ltr: "right",
        rtl: "left"
    }
};
var $863262f1d465b21b$var$opposites = {
    "auto-start": "auto-end",
    "auto-end": "auto-start",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-start": "bottom-end",
    "bottom-end": "bottom-start"
};
function $863262f1d465b21b$export$833b022d5a236f09(placement, dir = "ltr") {
    var _a, _b;
    const value = ((_a = $863262f1d465b21b$var$logicals[placement]) == null ? void 0 : _a[dir]) || placement;
    if (dir === "ltr") return value;
    return (_b = $863262f1d465b21b$var$opposites[placement]) != null ? _b : value;
}




function $9a3daa99292f546a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $e159ab793f4c1f0e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e159ab793f4c1f0e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e159ab793f4c1f0e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $9f0db939ba2276c3$export$8960430cfd85939f = Math.max;
var $9f0db939ba2276c3$export$96ec731ed4dcb222 = Math.min;
var $9f0db939ba2276c3$export$2077e0241d6afd3c = Math.round;



function $2c1a5afb32bfb2fc$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $e7e1121870ced99f$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $2c1a5afb32bfb2fc$export$2e2bcd8739ae039)());
}


function $04447a86e0258ffe$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9f0db939ba2276c3$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9f0db939ba2276c3$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $e159ab793f4c1f0e$export$45a5e7f76e0caa8d)(element) ? (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $e7e1121870ced99f$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $de025d583228fdf1$export$2e2bcd8739ae039(node) {
    var win = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $00c5217081eb788c$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $528b6b57349d46cc$export$2e2bcd8739ae039(node) {
    if (node === (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(node) || !(0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(node)) return (0, $de025d583228fdf1$export$2e2bcd8739ae039)(node);
    else return (0, $00c5217081eb788c$export$2e2bcd8739ae039)(node);
}


function $c07aca7856167192$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $8a6edbe09465b1d3$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $e159ab793f4c1f0e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $c7ac289f9ae7d731$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $04447a86e0258ffe$export$2e2bcd8739ae039)((0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(element)).left + (0, $de025d583228fdf1$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $511ac700e6435295$export$2e2bcd8739ae039(element) {
    return (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $32aa42427a56f38e$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $511ac700e6435295$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $7e1c3a110a3480eb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9f0db939ba2276c3$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9f0db939ba2276c3$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $7e1c3a110a3480eb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(offsetParent) && $7e1c3a110a3480eb$var$isElementScaled(offsetParent);
    var documentElement = (0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $04447a86e0258ffe$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c07aca7856167192$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $32aa42427a56f38e$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $528b6b57349d46cc$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $04447a86e0258ffe$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $c7ac289f9ae7d731$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $94dd526eb5e66b0f$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $04447a86e0258ffe$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $10f611ceffb158c3$export$2e2bcd8739ae039(element) {
    if ((0, $c07aca7856167192$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $e159ab793f4c1f0e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $84b281249345dec7$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $c07aca7856167192$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(node) && (0, $32aa42427a56f38e$export$2e2bcd8739ae039)(node)) return node;
    return $84b281249345dec7$export$2e2bcd8739ae039((0, $10f611ceffb158c3$export$2e2bcd8739ae039)(node));
}





function $f39d94ca9545bb21$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $84b281249345dec7$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $32aa42427a56f38e$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($f39d94ca9545bb21$export$2e2bcd8739ae039((0, $10f611ceffb158c3$export$2e2bcd8739ae039)(target)));
}







function $283df72c771c466f$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $c07aca7856167192$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3ced1cad3d71768e$var$getTrueOffsetParent(element) {
    if (!(0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $511ac700e6435295$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3ced1cad3d71768e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $2c1a5afb32bfb2fc$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $2c1a5afb32bfb2fc$export$2e2bcd8739ae039)());
    if (isIE && (0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $511ac700e6435295$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $10f611ceffb158c3$export$2e2bcd8739ae039)(element);
    if ((0, $e159ab793f4c1f0e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $c07aca7856167192$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $511ac700e6435295$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3ced1cad3d71768e$export$2e2bcd8739ae039(element) {
    var window = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(element);
    var offsetParent = $3ced1cad3d71768e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $283df72c771c466f$export$2e2bcd8739ae039)(offsetParent) && (0, $511ac700e6435295$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $3ced1cad3d71768e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $c07aca7856167192$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $c07aca7856167192$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $511ac700e6435295$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $3ced1cad3d71768e$var$getContainingBlock(element) || window;
}


var $615cac49c686e8db$export$1e95b668f3b82d = "top";
var $615cac49c686e8db$export$40e543e69a8b3fbb = "bottom";
var $615cac49c686e8db$export$79ffe56a765070d2 = "right";
var $615cac49c686e8db$export$eabcd2c8791e7bf4 = "left";
var $615cac49c686e8db$export$dfb5619354ba860 = "auto";
var $615cac49c686e8db$export$aec2ce47c367b8c3 = [
    $615cac49c686e8db$export$1e95b668f3b82d,
    $615cac49c686e8db$export$40e543e69a8b3fbb,
    $615cac49c686e8db$export$79ffe56a765070d2,
    $615cac49c686e8db$export$eabcd2c8791e7bf4
];
var $615cac49c686e8db$export$b3571188c770cc5a = "start";
var $615cac49c686e8db$export$bd5df0f255a350f8 = "end";
var $615cac49c686e8db$export$390fd549c5303b4d = "clippingParents";
var $615cac49c686e8db$export$d7b7311ec04a3e8f = "viewport";
var $615cac49c686e8db$export$ae5ab1c730825774 = "popper";
var $615cac49c686e8db$export$ca50aac9f3ba507f = "reference";
var $615cac49c686e8db$export$368f9a87e87fa4e1 = /*#__PURE__*/ $615cac49c686e8db$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $615cac49c686e8db$export$b3571188c770cc5a,
        placement + "-" + $615cac49c686e8db$export$bd5df0f255a350f8
    ]);
}, []);
var $615cac49c686e8db$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($615cac49c686e8db$export$aec2ce47c367b8c3, [
    $615cac49c686e8db$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $615cac49c686e8db$export$b3571188c770cc5a,
        placement + "-" + $615cac49c686e8db$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $615cac49c686e8db$export$421679a7c3d56e = "beforeRead";
var $615cac49c686e8db$export$aafa59e2e03f2942 = "read";
var $615cac49c686e8db$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $615cac49c686e8db$export$c65e99957a05207c = "beforeMain";
var $615cac49c686e8db$export$f22da7240b7add18 = "main";
var $615cac49c686e8db$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $615cac49c686e8db$export$8d4d2d70e7d46032 = "beforeWrite";
var $615cac49c686e8db$export$68d8715fc104d294 = "write";
var $615cac49c686e8db$export$70a6e5159acce2e6 = "afterWrite";
var $615cac49c686e8db$export$d087d3878fdf71d5 = [
    $615cac49c686e8db$export$421679a7c3d56e,
    $615cac49c686e8db$export$aafa59e2e03f2942,
    $615cac49c686e8db$export$6964f6c886723980,
    $615cac49c686e8db$export$c65e99957a05207c,
    $615cac49c686e8db$export$f22da7240b7add18,
    $615cac49c686e8db$export$bab79516f2d662fe,
    $615cac49c686e8db$export$8d4d2d70e7d46032,
    $615cac49c686e8db$export$68d8715fc104d294,
    $615cac49c686e8db$export$70a6e5159acce2e6
];


function $55b9ffcc4b1efbff$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $55b9ffcc4b1efbff$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $55b9ffcc4b1efbff$var$order(modifiers); // order based on phase
    return (0, $615cac49c686e8db$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6151bd342ce0595a$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $58f3b129cbfc17cb$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $c9c8bfd437fe25cb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $c9c8bfd437fe25cb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $c9c8bfd437fe25cb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c9c8bfd437fe25cb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $c9c8bfd437fe25cb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $e159ab793f4c1f0e$export$45a5e7f76e0caa8d)(reference) ? (0, $f39d94ca9545bb21$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $f39d94ca9545bb21$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $f39d94ca9545bb21$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $55b9ffcc4b1efbff$export$2e2bcd8739ae039)((0, $58f3b129cbfc17cb$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c9c8bfd437fe25cb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7e1c3a110a3480eb$export$2e2bcd8739ae039)(reference, (0, $3ced1cad3d71768e$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $94dd526eb5e66b0f$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6151bd342ce0595a$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c9c8bfd437fe25cb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c9c8bfd437fe25cb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c9c8bfd437fe25cb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e3db6b8d2989ef0a$var$passive = {
    passive: true
};
function $e3db6b8d2989ef0a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e3db6b8d2989ef0a$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e3db6b8d2989ef0a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e3db6b8d2989ef0a$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e3db6b8d2989ef0a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e3db6b8d2989ef0a$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e3db6b8d2989ef0a$var$effect,
    data: {}
};



function $cb5798918f6a320d$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $6462d3d6f13f79e0$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $cf81446cb6bc20e7$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $06843e4380d402ee$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $cb5798918f6a320d$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $6462d3d6f13f79e0$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $615cac49c686e8db$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $615cac49c686e8db$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $615cac49c686e8db$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $615cac49c686e8db$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $cf81446cb6bc20e7$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $615cac49c686e8db$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $615cac49c686e8db$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $791a61db0a6bc2ee$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $06843e4380d402ee$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $791a61db0a6bc2ee$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $791a61db0a6bc2ee$var$popperOffsets,
    data: {}
};










var $bde1fee015894e98$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bde1fee015894e98$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9f0db939ba2276c3$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9f0db939ba2276c3$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bde1fee015894e98$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $615cac49c686e8db$export$eabcd2c8791e7bf4);
    var sideY = (0, $615cac49c686e8db$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3ced1cad3d71768e$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(popper);
            if ((0, $511ac700e6435295$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $615cac49c686e8db$export$1e95b668f3b82d) || (placement === (0, $615cac49c686e8db$export$eabcd2c8791e7bf4) || placement === (0, $615cac49c686e8db$export$79ffe56a765070d2)) && variation === (0, $615cac49c686e8db$export$bd5df0f255a350f8)) {
            sideY = (0, $615cac49c686e8db$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $615cac49c686e8db$export$eabcd2c8791e7bf4) || (placement === (0, $615cac49c686e8db$export$1e95b668f3b82d) || placement === (0, $615cac49c686e8db$export$40e543e69a8b3fbb)) && variation === (0, $615cac49c686e8db$export$bd5df0f255a350f8)) {
            sideX = (0, $615cac49c686e8db$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bde1fee015894e98$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bde1fee015894e98$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $bde1fee015894e98$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $cb5798918f6a320d$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $6462d3d6f13f79e0$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bde1fee015894e98$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bde1fee015894e98$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bde1fee015894e98$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $bde1fee015894e98$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $4114a9afb75b7064$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(element) || !(0, $c07aca7856167192$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $4114a9afb75b7064$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(element) || !(0, $c07aca7856167192$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $4114a9afb75b7064$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $4114a9afb75b7064$var$applyStyles,
    effect: $4114a9afb75b7064$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $3bbbefe16b0fda7b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $cb5798918f6a320d$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $615cac49c686e8db$export$eabcd2c8791e7bf4),
        (0, $615cac49c686e8db$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $615cac49c686e8db$export$eabcd2c8791e7bf4),
        (0, $615cac49c686e8db$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $3bbbefe16b0fda7b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $615cac49c686e8db$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $3bbbefe16b0fda7b$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3bbbefe16b0fda7b$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $3bbbefe16b0fda7b$var$offset
};


var $4b8db82f502597e0$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4b8db82f502597e0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $4b8db82f502597e0$var$hash[matched];
    });
}



var $6f3ef5a5146dfc4d$var$hash = {
    start: "end",
    end: "start"
};
function $6f3ef5a5146dfc4d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $6f3ef5a5146dfc4d$var$hash[matched];
    });
}







function $f1db5134a892b879$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $9a3daa99292f546a$export$2e2bcd8739ae039)(element);
    var html = (0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $e7e1121870ced99f$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $c7ac289f9ae7d731$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a8a221cee8762d71$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $de025d583228fdf1$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9f0db939ba2276c3$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9f0db939ba2276c3$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $c7ac289f9ae7d731$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $511ac700e6435295$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $9f0db939ba2276c3$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $b1d40c3e33940009$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $e159ab793f4c1f0e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $91be797b462b6262$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $4d179f3f4f72ce7a$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $04447a86e0258ffe$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $4d179f3f4f72ce7a$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $615cac49c686e8db$export$d7b7311ec04a3e8f) ? (0, $91be797b462b6262$export$2e2bcd8739ae039)((0, $f1db5134a892b879$export$2e2bcd8739ae039)(element, strategy)) : (0, $e159ab793f4c1f0e$export$45a5e7f76e0caa8d)(clippingParent) ? $4d179f3f4f72ce7a$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $91be797b462b6262$export$2e2bcd8739ae039)((0, $a8a221cee8762d71$export$2e2bcd8739ae039)((0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $4d179f3f4f72ce7a$var$getClippingParents(element) {
    var clippingParents = (0, $f39d94ca9545bb21$export$2e2bcd8739ae039)((0, $10f611ceffb158c3$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $511ac700e6435295$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $e159ab793f4c1f0e$export$1b3bfaa9684536aa)(element) ? (0, $3ced1cad3d71768e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $e159ab793f4c1f0e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $e159ab793f4c1f0e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $b1d40c3e33940009$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $c07aca7856167192$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $4d179f3f4f72ce7a$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $4d179f3f4f72ce7a$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $4d179f3f4f72ce7a$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9f0db939ba2276c3$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9f0db939ba2276c3$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9f0db939ba2276c3$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9f0db939ba2276c3$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $4d179f3f4f72ce7a$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $4aaf14c76bbcff26$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $75fb1c6d17541728$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $4aaf14c76bbcff26$export$2e2bcd8739ae039)(), paddingObject);
}


function $193f0f8268e3c698$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $50aea322213ecae5$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $615cac49c686e8db$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $615cac49c686e8db$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $615cac49c686e8db$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $75fb1c6d17541728$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $193f0f8268e3c698$export$2e2bcd8739ae039)(padding, (0, $615cac49c686e8db$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $615cac49c686e8db$export$ae5ab1c730825774) ? (0, $615cac49c686e8db$export$ca50aac9f3ba507f) : (0, $615cac49c686e8db$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4d179f3f4f72ce7a$export$2e2bcd8739ae039)((0, $e159ab793f4c1f0e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $8a6edbe09465b1d3$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $04447a86e0258ffe$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $06843e4380d402ee$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $91be797b462b6262$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $615cac49c686e8db$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $615cac49c686e8db$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $615cac49c686e8db$export$79ffe56a765070d2),
                (0, $615cac49c686e8db$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $615cac49c686e8db$export$1e95b668f3b82d),
                (0, $615cac49c686e8db$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $d34fff954ea3d739$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $615cac49c686e8db$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $6462d3d6f13f79e0$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $615cac49c686e8db$export$368f9a87e87fa4e1) : (0, $615cac49c686e8db$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $6462d3d6f13f79e0$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $615cac49c686e8db$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $50aea322213ecae5$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $cb5798918f6a320d$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $41a59cf6954ff6bb$var$getExpandedFallbackPlacements(placement) {
    if ((0, $cb5798918f6a320d$export$2e2bcd8739ae039)(placement) === (0, $615cac49c686e8db$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $4b8db82f502597e0$export$2e2bcd8739ae039)(placement);
    return [
        (0, $6f3ef5a5146dfc4d$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $6f3ef5a5146dfc4d$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $41a59cf6954ff6bb$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $cb5798918f6a320d$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $4b8db82f502597e0$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $41a59cf6954ff6bb$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $cb5798918f6a320d$export$2e2bcd8739ae039)(placement) === (0, $615cac49c686e8db$export$dfb5619354ba860) ? (0, $d34fff954ea3d739$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $cb5798918f6a320d$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $6462d3d6f13f79e0$export$2e2bcd8739ae039)(placement) === (0, $615cac49c686e8db$export$b3571188c770cc5a);
        var isVertical = [
            (0, $615cac49c686e8db$export$1e95b668f3b82d),
            (0, $615cac49c686e8db$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $50aea322213ecae5$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $615cac49c686e8db$export$79ffe56a765070d2) : (0, $615cac49c686e8db$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $615cac49c686e8db$export$40e543e69a8b3fbb) : (0, $615cac49c686e8db$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $4b8db82f502597e0$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $4b8db82f502597e0$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $41a59cf6954ff6bb$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $41a59cf6954ff6bb$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $5a14af3c3dba4a6a$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $b9dff2b303aad689$export$f28d906d67a997f3(min, value, max) {
    return (0, $9f0db939ba2276c3$export$8960430cfd85939f)(min, (0, $9f0db939ba2276c3$export$96ec731ed4dcb222)(value, max));
}
function $b9dff2b303aad689$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b9dff2b303aad689$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $dd086f4d423f5a35$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $50aea322213ecae5$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $cb5798918f6a320d$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $6462d3d6f13f79e0$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $cf81446cb6bc20e7$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $5a14af3c3dba4a6a$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $615cac49c686e8db$export$1e95b668f3b82d) : (0, $615cac49c686e8db$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $615cac49c686e8db$export$40e543e69a8b3fbb) : (0, $615cac49c686e8db$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $615cac49c686e8db$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $615cac49c686e8db$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $94dd526eb5e66b0f$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $4aaf14c76bbcff26$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b9dff2b303aad689$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3ced1cad3d71768e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b9dff2b303aad689$export$f28d906d67a997f3)(tether ? (0, $9f0db939ba2276c3$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9f0db939ba2276c3$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $615cac49c686e8db$export$1e95b668f3b82d) : (0, $615cac49c686e8db$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $615cac49c686e8db$export$40e543e69a8b3fbb) : (0, $615cac49c686e8db$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $615cac49c686e8db$export$1e95b668f3b82d),
            (0, $615cac49c686e8db$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b9dff2b303aad689$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b9dff2b303aad689$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $dd086f4d423f5a35$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $dd086f4d423f5a35$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $d3a1dc751a5d9dca$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $75fb1c6d17541728$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $193f0f8268e3c698$export$2e2bcd8739ae039)(padding, (0, $615cac49c686e8db$export$aec2ce47c367b8c3)));
};
function $d3a1dc751a5d9dca$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $cb5798918f6a320d$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $cf81446cb6bc20e7$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $615cac49c686e8db$export$eabcd2c8791e7bf4),
        (0, $615cac49c686e8db$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $d3a1dc751a5d9dca$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $94dd526eb5e66b0f$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $615cac49c686e8db$export$1e95b668f3b82d) : (0, $615cac49c686e8db$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $615cac49c686e8db$export$40e543e69a8b3fbb) : (0, $615cac49c686e8db$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3ced1cad3d71768e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b9dff2b303aad689$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $d3a1dc751a5d9dca$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $b1d40c3e33940009$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $d3a1dc751a5d9dca$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $d3a1dc751a5d9dca$var$arrow,
    effect: $d3a1dc751a5d9dca$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $47875fced566b74d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $47875fced566b74d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $615cac49c686e8db$export$1e95b668f3b82d),
        (0, $615cac49c686e8db$export$79ffe56a765070d2),
        (0, $615cac49c686e8db$export$40e543e69a8b3fbb),
        (0, $615cac49c686e8db$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $47875fced566b74d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $50aea322213ecae5$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $50aea322213ecae5$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $47875fced566b74d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $47875fced566b74d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $47875fced566b74d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $47875fced566b74d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $47875fced566b74d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $47875fced566b74d$var$hide
};




var $533144dae380ef13$export$d34966752335dd47 = [
    (0, $e3db6b8d2989ef0a$export$2e2bcd8739ae039),
    (0, $791a61db0a6bc2ee$export$2e2bcd8739ae039),
    (0, $bde1fee015894e98$export$2e2bcd8739ae039),
    (0, $4114a9afb75b7064$export$2e2bcd8739ae039),
    (0, $3bbbefe16b0fda7b$export$2e2bcd8739ae039),
    (0, $41a59cf6954ff6bb$export$2e2bcd8739ae039),
    (0, $dd086f4d423f5a35$export$2e2bcd8739ae039),
    (0, $d3a1dc751a5d9dca$export$2e2bcd8739ae039),
    (0, $47875fced566b74d$export$2e2bcd8739ae039)
];
var $533144dae380ef13$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $c9c8bfd437fe25cb$export$ed5e13716264f202)({
    defaultModifiers: $533144dae380ef13$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $8e546c4090357a18$export$f4d5bf230a36dd6e(props = {}) {
    const { enabled: enabled = true, modifiers: modifiers, placement: placementProp = "bottom", strategy: strategy = "absolute", arrowPadding: arrowPadding = 8, eventListeners: eventListeners = true, offset: offset, gutter: gutter = 8, flip: flip = true, boundary: boundary = "clippingParents", preventOverflow: preventOverflow = true, matchWidth: matchWidth2, direction: direction = "ltr" } = props;
    const reference = (0, $lDSNw.useRef)(null);
    const popper = (0, $lDSNw.useRef)(null);
    const instance = (0, $lDSNw.useRef)(null);
    const placement = (0, $863262f1d465b21b$export$833b022d5a236f09)(placementProp, direction);
    const cleanup = (0, $lDSNw.useRef)(()=>{});
    const setupPopper = (0, $lDSNw.useCallback)(()=>{
        var _a;
        if (!enabled || !reference.current || !popper.current) return;
        (_a = cleanup.current) == null || _a.call(cleanup);
        instance.current = (0, $533144dae380ef13$export$8f7491d57c8f97a9)(reference.current, popper.current, {
            placement: placement,
            modifiers: [
                (0, $5b39cb705ef77067$export$616f7fc4ffce8510),
                (0, $5b39cb705ef77067$export$36f2614d91c73bb6),
                (0, $5b39cb705ef77067$export$bd7bb1bc943e0611),
                {
                    ...(0, $5b39cb705ef77067$export$45d38cc6268103c7),
                    enabled: !!matchWidth2
                },
                {
                    name: "eventListeners",
                    ...(0, $985d22c34d4a36b5$export$fafd30a196ad8838)(eventListeners)
                },
                {
                    name: "arrow",
                    options: {
                        padding: arrowPadding
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: offset != null ? offset : [
                            0,
                            gutter
                        ]
                    }
                },
                {
                    name: "flip",
                    enabled: !!flip,
                    options: {
                        padding: 8
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: !!preventOverflow,
                    options: {
                        boundary: boundary
                    }
                },
                // allow users override internal modifiers
                ...modifiers != null ? modifiers : []
            ],
            strategy: strategy
        });
        instance.current.forceUpdate();
        cleanup.current = instance.current.destroy;
    }, [
        placement,
        enabled,
        modifiers,
        matchWidth2,
        eventListeners,
        arrowPadding,
        offset,
        gutter,
        flip,
        preventOverflow,
        boundary,
        strategy
    ]);
    (0, $lDSNw.useEffect)(()=>{
        return ()=>{
            var _a;
            if (!reference.current && !popper.current) {
                (_a = instance.current) == null || _a.destroy();
                instance.current = null;
            }
        };
    }, []);
    const referenceRef = (0, $lDSNw.useCallback)((node)=>{
        reference.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getReferenceProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(referenceRef, ref)
        }), [
        referenceRef
    ]);
    const popperRef = (0, $lDSNw.useCallback)((node)=>{
        popper.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getPopperProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(popperRef, ref),
            style: {
                ...props2.style,
                position: strategy,
                minWidth: matchWidth2 ? void 0 : "max-content",
                inset: "0 auto auto 0"
            }
        }), [
        strategy,
        popperRef,
        matchWidth2
    ]);
    const getArrowProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>{
        const { size: size, shadowColor: shadowColor, bg: bg, style: style, ...rest } = props2;
        return {
            ...rest,
            ref: ref,
            "data-popper-arrow": "",
            style: $8e546c4090357a18$var$getArrowStyle(props2)
        };
    }, []);
    const getArrowInnerProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            "data-popper-arrow-inner": ""
        }), []);
    return {
        update () {
            var _a;
            (_a = instance.current) == null || _a.update();
        },
        forceUpdate () {
            var _a;
            (_a = instance.current) == null || _a.forceUpdate();
        },
        transformOrigin: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).transformOrigin.varRef,
        referenceRef: referenceRef,
        popperRef: popperRef,
        getPopperProps: getPopperProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getReferenceProps: getReferenceProps
    };
}
function $8e546c4090357a18$var$getArrowStyle(props) {
    const { size: size, shadowColor: shadowColor, bg: bg, style: style } = props;
    const computedStyle = {
        ...style,
        position: "absolute"
    };
    if (size) computedStyle["--popper-arrow-size"] = size;
    if (shadowColor) computedStyle["--popper-arrow-shadow-color"] = shadowColor;
    if (bg) computedStyle["--popper-arrow-bg"] = bg;
    return computedStyle;
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $076eda8ddf8e17cf$export$25bec8c6f54ee79a(callback, deps = []) {
    const callbackRef = (0, $lDSNw.useRef)(callback);
    (0, $lDSNw.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $lDSNw.useCallback)((...args)=>{
        var _a;
        return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
    }, deps);
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $1ece6bed0c1f2ca7$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const handleOpen = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onOpenProp);
    const handleClose = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $lDSNw.useState)(props.defaultIsOpen || false);
    const isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
    const isControlled = isOpenProp !== void 0;
    const uid = (0, $lDSNw.useId)();
    const id = idProp != null ? idProp : `disclosure-${uid}`;
    const onClose = (0, $lDSNw.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        handleClose == null || handleClose();
    }, [
        isControlled,
        handleClose
    ]);
    const onOpen = (0, $lDSNw.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        handleOpen == null || handleOpen();
    }, [
        isControlled,
        handleOpen
    ]);
    const onToggle = (0, $lDSNw.useCallback)(()=>{
        if (isOpen) onClose();
        else onOpen();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    function getButtonProps(props2 = {}) {
        return {
            ...props2,
            "aria-expanded": isOpen,
            "aria-controls": id,
            onClick (event) {
                var _a;
                (_a = props2.onClick) == null || _a.call(props2, event);
                onToggle();
            }
        };
    }
    function getDisclosureProps(props2 = {}) {
        return {
            ...props2,
            hidden: !isOpen,
            id: id
        };
    }
    return {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: getButtonProps,
        getDisclosureProps: getDisclosureProps
    };
}



var $lDSNw = parcelRequire("lDSNw");

"use client";
function $75d55078b16d3eca$export$7080b3e976bc91ab(target, event, handler, options) {
    const listener = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(handler);
    (0, $lDSNw.useEffect)(()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        if (!handler || !node) return;
        node.addEventListener(event, listener, options);
        return ()=>{
            node.removeEventListener(event, listener, options);
        };
    }, [
        event,
        target,
        options,
        listener,
        handler
    ]);
    return ()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        node == null || node.removeEventListener(event, listener, options);
    };
}





var $lDSNw = parcelRequire("lDSNw");
"use client";
var $25fbab3266844cb0$var$getDoc = (ref)=>{
    var _a;
    return ((_a = ref.current) == null ? void 0 : _a.ownerDocument) || document;
};
var $25fbab3266844cb0$var$getWin = (ref)=>{
    var _a, _b;
    return ((_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) == null ? void 0 : _b.defaultView) || window;
};
function $25fbab3266844cb0$export$1c4b08e0eca38426(props = {}) {
    const { openDelay: openDelay = 0, closeDelay: closeDelay = 0, closeOnClick: closeOnClick = true, closeOnMouseDown: closeOnMouseDown, closeOnScroll: closeOnScroll, closeOnPointerDown: closeOnPointerDown = closeOnMouseDown, closeOnEsc: closeOnEsc = true, onOpen: onOpenProp, onClose: onCloseProp, placement: placement, id: id, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, arrowSize: arrowSize = 10, arrowShadowColor: arrowShadowColor, arrowPadding: arrowPadding, modifiers: modifiers, isDisabled: isDisabled, gutter: gutter, offset: offset, direction: direction, ...htmlProps } = props;
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $1ece6bed0c1f2ca7$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onOpen: onOpenProp,
        onClose: onCloseProp
    });
    const { referenceRef: referenceRef, getPopperProps: getPopperProps, getArrowInnerProps: getArrowInnerProps, getArrowProps: getArrowProps } = (0, $8e546c4090357a18$export$f4d5bf230a36dd6e)({
        enabled: isOpen,
        placement: placement,
        arrowPadding: arrowPadding,
        modifiers: modifiers,
        gutter: gutter,
        offset: offset,
        direction: direction
    });
    const uuid = (0, $lDSNw.useId)();
    const uid = id != null ? id : uuid;
    const tooltipId = `tooltip-${uid}`;
    const ref = (0, $lDSNw.useRef)(null);
    const enterTimeout = (0, $lDSNw.useRef)();
    const clearEnterTimeout = (0, $lDSNw.useCallback)(()=>{
        if (enterTimeout.current) {
            clearTimeout(enterTimeout.current);
            enterTimeout.current = void 0;
        }
    }, []);
    const exitTimeout = (0, $lDSNw.useRef)();
    const clearExitTimeout = (0, $lDSNw.useCallback)(()=>{
        if (exitTimeout.current) {
            clearTimeout(exitTimeout.current);
            exitTimeout.current = void 0;
        }
    }, []);
    const closeNow = (0, $lDSNw.useCallback)(()=>{
        clearExitTimeout();
        onClose();
    }, [
        onClose,
        clearExitTimeout
    ]);
    const dispatchCloseEvent = $25fbab3266844cb0$var$useCloseEvent(ref, closeNow);
    const openWithDelay = (0, $lDSNw.useCallback)(()=>{
        if (!isDisabled && !enterTimeout.current) {
            if (isOpen) dispatchCloseEvent();
            const win = $25fbab3266844cb0$var$getWin(ref);
            enterTimeout.current = win.setTimeout(onOpen, openDelay);
        }
    }, [
        dispatchCloseEvent,
        isDisabled,
        isOpen,
        onOpen,
        openDelay
    ]);
    const closeWithDelay = (0, $lDSNw.useCallback)(()=>{
        clearEnterTimeout();
        const win = $25fbab3266844cb0$var$getWin(ref);
        exitTimeout.current = win.setTimeout(closeNow, closeDelay);
    }, [
        closeDelay,
        closeNow,
        clearEnterTimeout
    ]);
    const onClick = (0, $lDSNw.useCallback)(()=>{
        if (isOpen && closeOnClick) closeWithDelay();
    }, [
        closeOnClick,
        closeWithDelay,
        isOpen
    ]);
    const onPointerDown = (0, $lDSNw.useCallback)(()=>{
        if (isOpen && closeOnPointerDown) closeWithDelay();
    }, [
        closeOnPointerDown,
        closeWithDelay,
        isOpen
    ]);
    const onKeyDown = (0, $lDSNw.useCallback)((event)=>{
        if (isOpen && event.key === "Escape") closeWithDelay();
    }, [
        isOpen,
        closeWithDelay
    ]);
    (0, $75d55078b16d3eca$export$7080b3e976bc91ab)(()=>$25fbab3266844cb0$var$getDoc(ref), "keydown", closeOnEsc ? onKeyDown : void 0);
    (0, $75d55078b16d3eca$export$7080b3e976bc91ab)(()=>{
        const node = ref.current;
        if (!node) return null;
        const scrollParent = (0, $d20cb2dd272e02af$export$cfa2225e87938781)(node);
        return scrollParent.localName === "body" ? $25fbab3266844cb0$var$getWin(ref) : scrollParent;
    }, "scroll", ()=>{
        if (isOpen && closeOnScroll) closeNow();
    }, {
        passive: true,
        capture: true
    });
    (0, $lDSNw.useEffect)(()=>{
        if (!isDisabled) return;
        clearEnterTimeout();
        if (isOpen) onClose();
    }, [
        isDisabled,
        isOpen,
        onClose,
        clearEnterTimeout
    ]);
    (0, $lDSNw.useEffect)(()=>{
        return ()=>{
            clearEnterTimeout();
            clearExitTimeout();
        };
    }, [
        clearEnterTimeout,
        clearExitTimeout
    ]);
    (0, $75d55078b16d3eca$export$7080b3e976bc91ab)(()=>ref.current, "pointerleave", closeWithDelay);
    const getTriggerProps = (0, $lDSNw.useCallback)((props2 = {}, _ref = null)=>{
        const triggerProps = {
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, _ref, referenceRef),
            onPointerEnter: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onPointerEnter, (e)=>{
                if (e.pointerType === "touch") return;
                openWithDelay();
            }),
            onClick: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onClick, onClick),
            onPointerDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onPointerDown, onPointerDown),
            onFocus: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onFocus, openWithDelay),
            onBlur: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onBlur, closeWithDelay),
            "aria-describedby": isOpen ? tooltipId : void 0
        };
        return triggerProps;
    }, [
        openWithDelay,
        closeWithDelay,
        onPointerDown,
        isOpen,
        tooltipId,
        onClick,
        referenceRef
    ]);
    const getTooltipPositionerProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>getPopperProps({
            ...props2,
            style: {
                ...props2.style,
                [(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowSize.var]: arrowSize ? `${arrowSize}px` : void 0,
                [(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowShadowColor.var]: arrowShadowColor
            }
        }, forwardedRef), [
        getPopperProps,
        arrowSize,
        arrowShadowColor
    ]);
    const getTooltipProps = (0, $lDSNw.useCallback)((props2 = {}, ref2 = null)=>{
        const styles = {
            ...props2.style,
            position: "relative",
            transformOrigin: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).transformOrigin.varRef
        };
        return {
            ref: ref2,
            ...htmlProps,
            ...props2,
            id: tooltipId,
            role: "tooltip",
            style: styles
        };
    }, [
        htmlProps,
        tooltipId
    ]);
    return {
        isOpen: isOpen,
        show: openWithDelay,
        hide: closeWithDelay,
        getTriggerProps: getTriggerProps,
        getTooltipProps: getTooltipProps,
        getTooltipPositionerProps: getTooltipPositionerProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps
    };
}
var $25fbab3266844cb0$var$closeEventName = "chakra-ui:close-tooltip";
function $25fbab3266844cb0$var$useCloseEvent(ref, close) {
    (0, $lDSNw.useEffect)(()=>{
        const doc = $25fbab3266844cb0$var$getDoc(ref);
        doc.addEventListener($25fbab3266844cb0$var$closeEventName, close);
        return ()=>doc.removeEventListener($25fbab3266844cb0$var$closeEventName, close);
    }, [
        close,
        ref
    ]);
    return ()=>{
        const doc = $25fbab3266844cb0$var$getDoc(ref);
        const win = $25fbab3266844cb0$var$getWin(ref);
        doc.dispatchEvent(new win.CustomEvent($25fbab3266844cb0$var$closeEventName));
    };
}





"use client";
var [$582380aaf86f03b6$var$PortalManagerContextProvider, $582380aaf86f03b6$export$ef203b29c2cc1f5d] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $582380aaf86f03b6$export$52c7ef79917c2f38(props) {
    const { children: children, zIndex: zIndex } = props;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($582380aaf86f03b6$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        },
        children: children
    });
}
$582380aaf86f03b6$export$52c7ef79917c2f38.displayName = "PortalManager";



var $lDSNw = parcelRequire("lDSNw");
"use client";
var $e18ad61408bb6e80$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $lDSNw.useLayoutEffect) : (0, $lDSNw.useEffect);




var $ef4Zh = parcelRequire("ef4Zh");

var $lDSNw = parcelRequire("lDSNw");

"use client";
var [$e51c5ae64f7cf3d3$var$PortalContextProvider, $e51c5ae64f7cf3d3$var$usePortalContext] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
var $e51c5ae64f7cf3d3$var$PORTAL_CLASSNAME = "chakra-portal";
var $e51c5ae64f7cf3d3$var$PORTAL_SELECTOR = `.chakra-portal`;
var $e51c5ae64f7cf3d3$var$Container = (props)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0
        },
        children: props.children
    });
var $e51c5ae64f7cf3d3$var$DefaultPortal = (props)=>{
    const { appendToParentPortal: appendToParentPortal, children: children } = props;
    const [tempNode, setTempNode] = (0, $lDSNw.useState)(null);
    const portal = (0, $lDSNw.useRef)(null);
    const [, forceUpdate] = (0, $lDSNw.useState)({});
    (0, $lDSNw.useEffect)(()=>forceUpdate({}), []);
    const parentPortal = $e51c5ae64f7cf3d3$var$usePortalContext();
    const manager = (0, $582380aaf86f03b6$export$ef203b29c2cc1f5d)();
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (!tempNode) return;
        const doc = tempNode.ownerDocument;
        const host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $e51c5ae64f7cf3d3$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate({});
        const portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, [
        tempNode
    ]);
    const _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($e51c5ae64f7cf3d3$var$Container, {
        zIndex: manager == null ? void 0 : manager.zIndex,
        children: children
    }) : children;
    return portal.current ? (0, $ef4Zh.createPortal)(/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($e51c5ae64f7cf3d3$var$PortalContextProvider, {
        value: portal.current,
        children: _children
    }), portal.current) : /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("span", {
        ref: (el)=>{
            if (el) setTempNode(el);
        }
    });
};
var $e51c5ae64f7cf3d3$var$ContainerPortal = (props)=>{
    const { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
    const portal = (0, $lDSNw.useMemo)(()=>{
        const node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
        if (node) node.className = $e51c5ae64f7cf3d3$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    const [, forceUpdate] = (0, $lDSNw.useState)({});
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>forceUpdate({}), []);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return (0, $ef4Zh.createPortal)(/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($e51c5ae64f7cf3d3$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null,
        children: children
    }), portal);
    return null;
};
function $e51c5ae64f7cf3d3$export$602eac185826482c(props) {
    const portalProps = {
        appendToParentPortal: true,
        ...props
    };
    const { containerRef: containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($e51c5ae64f7cf3d3$var$ContainerPortal, {
        containerRef: containerRef,
        ...rest
    }) : /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($e51c5ae64f7cf3d3$var$DefaultPortal, {
        ...rest
    });
}
$e51c5ae64f7cf3d3$export$602eac185826482c.className = $e51c5ae64f7cf3d3$var$PORTAL_CLASSNAME;
$e51c5ae64f7cf3d3$export$602eac185826482c.selector = $e51c5ae64f7cf3d3$var$PORTAL_SELECTOR;
$e51c5ae64f7cf3d3$export$602eac185826482c.displayName = "Portal";




var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
const $0d2249efd167eccf$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $b31fc856a06471a3$export$700979bc83e7db82 = (0, $0d2249efd167eccf$export$4e09c449d6c407f7) ? (0, $lDSNw.useLayoutEffect) : (0, $lDSNw.useEffect);


function $5662a3f646cd3518$export$80c2a3957bcb42ea() {
    const isMounted = (0, $lDSNw.useRef)(false);
    (0, $b31fc856a06471a3$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $96ab74a89bc7c563$export$8793edee2d425525 = (any)=>any;


function $fc46d801a33c7c8d$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */ let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $da1e784331315f60$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $da1e784331315f60$var$maxElapsed = 40;
function $da1e784331315f60$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $da1e784331315f60$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $fc46d801a33c7c8d$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $da1e784331315f60$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $da1e784331315f60$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $da1e784331315f60$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$da1e784331315f60$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $8e7cd14116eefbbb$export$2cef06c20297c17d, cancel: $8e7cd14116eefbbb$export$ec99c0ef4978dccb, state: $8e7cd14116eefbbb$export$fff89137e9e818ce, steps: $8e7cd14116eefbbb$export$be3f796aed065412 } = (0, $da1e784331315f60$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $96ab74a89bc7c563$export$8793edee2d425525), true);


function $b7e3474d1ae2f16f$export$91db9bc4f8ac944a() {
    const isMounted = (0, $5662a3f646cd3518$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $lDSNw.useState)(0);
    const forceRender = (0, $lDSNw.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $lDSNw.useCallback)(()=>(0, $8e7cd14116eefbbb$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
/**
 * @public
 */ const $ad062c71ac58a929$export$f224e4635b6f8ce2 = (0, $lDSNw.createContext)(null);



var $lDSNw = parcelRequire("lDSNw");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $2f15184e95154688$export$fe4300aa8eebea86(init) {
    const ref = (0, $lDSNw.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $lDSNw = parcelRequire("lDSNw");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $17401782f795045a$var$PopChildMeasure extends $lDSNw.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $17401782f795045a$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $lDSNw.useId)();
    const ref = (0, $lDSNw.useRef)(null);
    const size = (0, $lDSNw.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $lDSNw.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $lDSNw.createElement($17401782f795045a$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $lDSNw.cloneElement(children, {
        ref: ref
    }));
}


const $9340f7c03dd378e1$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $2f15184e95154688$export$fe4300aa8eebea86)($9340f7c03dd378e1$var$newChildrenMap);
    const id = (0, $lDSNw.useId)();
    const context = (0, $lDSNw.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $lDSNw.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $lDSNw.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $lDSNw.createElement((0, $17401782f795045a$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $lDSNw.createElement((0, $ad062c71ac58a929$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $9340f7c03dd378e1$var$newChildrenMap() {
    return new Map();
}



var $lDSNw = parcelRequire("lDSNw");
const $d975c5dcc3d215ef$export$a3579ca508007a95 = (0, $lDSNw.createContext)({});




var $lDSNw = parcelRequire("lDSNw");
function $5a56703348758885$export$f3a192d0cbd30b96(callback) {
    return (0, $lDSNw.useEffect)(()=>()=>callback(), []);
}



let $30298752de581a70$export$491112666e282270 = (0, $96ab74a89bc7c563$export$8793edee2d425525);
let $30298752de581a70$export$f5708dca728d7177 = (0, $96ab74a89bc7c563$export$8793edee2d425525);
var $30298752de581a70$var$check, $30298752de581a70$var$message, $30298752de581a70$var$check1, $30298752de581a70$var$message1;


const $0204198b5355405f$var$getChildKey = (child)=>child.key || "";
function $0204198b5355405f$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $0204198b5355405f$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $0204198b5355405f$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $lDSNw.Children).forEach(children, (child)=>{
        if ((0, $lDSNw.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $0204198b5355405f$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $30298752de581a70$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $lDSNw.useContext)((0, $d975c5dcc3d215ef$export$a3579ca508007a95)).forceRender || (0, $b7e3474d1ae2f16f$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $5662a3f646cd3518$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $0204198b5355405f$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $lDSNw.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $lDSNw.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $lDSNw.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $lDSNw.useRef)(true);
    (0, $b31fc856a06471a3$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $0204198b5355405f$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $5a56703348758885$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $lDSNw.createElement($lDSNw.Fragment, null, childrenToRender.map((child)=>$lDSNw.createElement((0, $9340f7c03dd378e1$export$979daf65881a382a), {
            key: $0204198b5355405f$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($0204198b5355405f$var$getChildKey);
    const targetKeys = filteredChildren.map($0204198b5355405f$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                allChildren.delete(key);
                exitingChildren.delete(key);
                // Remove this child from the present children
                const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
                presentChildren.current.splice(removeIndex, 1);
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    presentChildren.current = filteredChildren;
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $lDSNw.createElement((0, $9340f7c03dd378e1$export$979daf65881a382a), {
                key: $0204198b5355405f$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $lDSNw.createElement((0, $9340f7c03dd378e1$export$979daf65881a382a), {
            key: $0204198b5355405f$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $lDSNw.createElement($lDSNw.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $lDSNw.cloneElement)(child)));
};


var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
/**
 * @public
 */ const $85eb84fe60111644$export$22a697fb29aac98d = (0, $lDSNw.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $lDSNw = parcelRequire("lDSNw");
const $5d069b983a3907c1$export$2285bbca2c666415 = (0, $lDSNw.createContext)({});



var $lDSNw = parcelRequire("lDSNw");




var $lDSNw = parcelRequire("lDSNw");
const $20339373abb676cf$export$40f10139ecf1f171 = (0, $lDSNw.createContext)({
    strict: false
});



function $72816b8fc702a017$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $lDSNw.useContext)((0, $5d069b983a3907c1$export$2285bbca2c666415));
    const lazyContext = (0, $lDSNw.useContext)((0, $20339373abb676cf$export$40f10139ecf1f171));
    const presenceContext = (0, $lDSNw.useContext)((0, $ad062c71ac58a929$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $lDSNw.useContext)((0, $85eb84fe60111644$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $lDSNw.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $lDSNw.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    (0, $b31fc856a06471a3$export$700979bc83e7db82)(()=>{
        visualElement && visualElement.render();
    });
    (0, $lDSNw.useEffect)(()=>{
        visualElement && visualElement.updateFeatures();
    });
    /**
     * Ideally this function would always run in a useEffect.
     *
     * However, if we have optimised appear animations to handoff from,
     * it needs to happen synchronously to ensure there's no flash of
     * incorrect styles in the event of a hydration error.
     *
     * So if we detect a situtation where optimised appear animations
     * are running, we use useLayoutEffect to trigger animations.
     */ const useAnimateChangesEffect = window.HandoffAppearAnimations ? (0, $b31fc856a06471a3$export$700979bc83e7db82) : (0, $lDSNw.useEffect);
    useAnimateChangesEffect(()=>{
        if (visualElement && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    return visualElement;
}



var $lDSNw = parcelRequire("lDSNw");
function $8a65e6d1ff14311a$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $799e61fd60e92eb5$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $lDSNw.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $8a65e6d1ff14311a$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $lDSNw = parcelRequire("lDSNw");

/**
 * Decides if the supplied variable is variant label
 */ function $ff2b58769c7190e2$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $7b4ea908288cf313$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $921392e203866556$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $921392e203866556$export$1405a65085f40b9 = [
    "initial",
    ...$921392e203866556$export$16e45afcc206d3a8
];


function $2384c2032528c821$export$4b3c3bd8d910d78d(props) {
    return (0, $7b4ea908288cf313$export$aa71198ceeaf53ce)(props.animate) || (0, $921392e203866556$export$1405a65085f40b9).some((name)=>(0, $ff2b58769c7190e2$export$720b90e312cea233)(props[name]));
}
function $2384c2032528c821$export$ce46fa4165cdec40(props) {
    return Boolean($2384c2032528c821$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $12c0c93b50a37cc8$export$12fc32fc096a04a3(props, context) {
    if ((0, $2384c2032528c821$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $ff2b58769c7190e2$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $ff2b58769c7190e2$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $d7533bd04dec97eb$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $12c0c93b50a37cc8$export$12fc32fc096a04a3)(props, (0, $lDSNw.useContext)((0, $5d069b983a3907c1$export$2285bbca2c666415)));
    return (0, $lDSNw.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $d7533bd04dec97eb$var$variantLabelsAsDependency(initial),
        $d7533bd04dec97eb$var$variantLabelsAsDependency(animate)
    ]);
}
function $d7533bd04dec97eb$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $5440a2b5f580bf74$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $5440a2b5f580bf74$export$65570e08d843624d = {};
for(const key in $5440a2b5f580bf74$var$featureProps)$5440a2b5f580bf74$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$5440a2b5f580bf74$var$featureProps[key].some((name)=>!!props[name])
};


function $d4a57efac126faf8$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $5440a2b5f580bf74$export$65570e08d843624d)[key] = {
        ...(0, $5440a2b5f580bf74$export$65570e08d843624d)[key],
        ...features[key]
    };
}






var $lDSNw = parcelRequire("lDSNw");
/**
 * Internal, exported only for usage in Framer
 */ const $04642920b4180e3c$export$da5f7b802957459a = (0, $lDSNw.createContext)({});


const $377b5c86d10366fc$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $bc69a2cdb154a2f9$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $d4a57efac126faf8$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $lDSNw.useContext)((0, $85eb84fe60111644$export$22a697fb29aac98d)),
            ...props,
            layoutId: $bc69a2cdb154a2f9$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $d7533bd04dec97eb$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $0d2249efd167eccf$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $72816b8fc702a017$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $lDSNw.useContext)((0, $04642920b4180e3c$export$da5f7b802957459a));
            const isStrict = (0, $lDSNw.useContext)((0, $20339373abb676cf$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $lDSNw.createElement((0, $5d069b983a3907c1$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $lDSNw.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $799e61fd60e92eb5$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $lDSNw.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $377b5c86d10366fc$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $bc69a2cdb154a2f9$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $lDSNw.useContext)((0, $d975c5dcc3d215ef$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $f275755cb24413fd$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $bc69a2cdb154a2f9$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $ad8b30d48419f025$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $749992b660858c8c$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $ad8b30d48419f025$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
const $1ba5906becf00f74$export$91ddd985b97788d1 = {};
function $1ba5906becf00f74$export$de9e7791c71225fd(correctors) {
    Object.assign($1ba5906becf00f74$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ed889dd17e65b750$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ed889dd17e65b750$export$7b42a0094fb00b6e = new Set($ed889dd17e65b750$export$280dc01950909d86);


function $c453d364f5fc16f3$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ed889dd17e65b750$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $1ba5906becf00f74$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $1a0ef3d59b00772c$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $6f9043e2dcf3290e$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $6f9043e2dcf3290e$var$numTransforms = (0, $ed889dd17e65b750$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $6f9043e2dcf3290e$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $6f9043e2dcf3290e$var$numTransforms; i++){
        const key = (0, $ed889dd17e65b750$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $6f9043e2dcf3290e$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $017a916d7c7d6823$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $017a916d7c7d6823$export$9de1236619d9e756 = $017a916d7c7d6823$var$checkStringStartsWith("--");
const $017a916d7c7d6823$export$31f9caa2600b5723 = $017a916d7c7d6823$var$checkStringStartsWith("var(--");
const $017a916d7c7d6823$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $2d7eeb0289a638d2$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $45e03c7d2655bcf8$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $45e03c7d2655bcf8$export$58f0f39f63f3cf42 = {
    ...$45e03c7d2655bcf8$export$98e628dec113755e,
    transform: (v)=>(0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $45e03c7d2655bcf8$export$dcdf75081b88279d = {
    ...$45e03c7d2655bcf8$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $16d8203a4f86b801$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $16d8203a4f86b801$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $16d8203a4f86b801$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $16d8203a4f86b801$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $16d8203a4f86b801$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $a08d8e53c3ef0aef$var$createUnitType = (unit)=>({
        test: (v)=>(0, $16d8203a4f86b801$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $a08d8e53c3ef0aef$export$41fc368e1a942b97 = $a08d8e53c3ef0aef$var$createUnitType("deg");
const $a08d8e53c3ef0aef$export$626336c2cd4b14de = $a08d8e53c3ef0aef$var$createUnitType("%");
const $a08d8e53c3ef0aef$export$91c0eda1d06bf008 = $a08d8e53c3ef0aef$var$createUnitType("px");
const $a08d8e53c3ef0aef$export$f91e8c45a95a32f2 = $a08d8e53c3ef0aef$var$createUnitType("vh");
const $a08d8e53c3ef0aef$export$aed3d7b7d206c196 = $a08d8e53c3ef0aef$var$createUnitType("vw");
const $a08d8e53c3ef0aef$export$44e2e1705876d7ed = {
    ...$a08d8e53c3ef0aef$export$626336c2cd4b14de,
    parse: (v)=>$a08d8e53c3ef0aef$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$a08d8e53c3ef0aef$export$626336c2cd4b14de.transform(v * 100)
};



const $30a261cebc18b14c$export$7d260a2a5f8bc19e = {
    ...(0, $45e03c7d2655bcf8$export$98e628dec113755e),
    transform: Math.round
};


const $0d12138c7dd54005$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderTopWidth: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderRightWidth: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderRadius: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    radius: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    maxWidth: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    height: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    maxHeight: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    size: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    top: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    right: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    bottom: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    left: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    paddingTop: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    paddingRight: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    paddingBottom: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    paddingLeft: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    margin: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    marginTop: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    marginRight: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    marginBottom: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    marginLeft: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    rotateX: (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    rotateY: (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    rotateZ: (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    scale: $45e03c7d2655bcf8$export$dcdf75081b88279d,
    scaleX: (0, $45e03c7d2655bcf8$export$dcdf75081b88279d),
    scaleY: (0, $45e03c7d2655bcf8$export$dcdf75081b88279d),
    scaleZ: (0, $45e03c7d2655bcf8$export$dcdf75081b88279d),
    skew: (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    skewX: (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    skewY: (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    distance: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    translateX: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    translateY: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    translateZ: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    x: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    y: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    z: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    perspective: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    transformPerspective: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    opacity: (0, $45e03c7d2655bcf8$export$58f0f39f63f3cf42),
    originX: (0, $a08d8e53c3ef0aef$export$44e2e1705876d7ed),
    originY: (0, $a08d8e53c3ef0aef$export$44e2e1705876d7ed),
    originZ: (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $30a261cebc18b14c$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $45e03c7d2655bcf8$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $45e03c7d2655bcf8$export$58f0f39f63f3cf42),
    numOctaves: (0, $30a261cebc18b14c$export$7d260a2a5f8bc19e)
};


function $b0315c50a209627b$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $017a916d7c7d6823$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $0d12138c7dd54005$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $2d7eeb0289a638d2$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ed889dd17e65b750$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $6f9043e2dcf3290e$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $5bc491cb3845384e$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $f5e98454b97e5bd9$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $1a0ef3d59b00772c$export$605d60a2578142d3)(source[key]) && !(0, $c453d364f5fc16f3$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $f5e98454b97e5bd9$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $lDSNw.useMemo)(()=>{
        const state = (0, $5bc491cb3845384e$export$8940b483cf52eeda)();
        (0, $b0315c50a209627b$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $f5e98454b97e5bd9$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $f5e98454b97e5bd9$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $f5e98454b97e5bd9$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $f5e98454b97e5bd9$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $f5e98454b97e5bd9$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $cc04e77999095066$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $cc04e77999095066$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $cc04e77999095066$var$validMotionProps.has(key);
}


let $0450247bec6105ce$var$shouldForward = (key)=>!(0, $cc04e77999095066$export$2f9c46555243bf04)(key);
function $0450247bec6105ce$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $0450247bec6105ce$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $cc04e77999095066$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $0450247bec6105ce$export$59d6962c470509a5((parcelRequire("jQ8wd")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $0450247bec6105ce$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($0450247bec6105ce$var$shouldForward(key) || forwardMotionProps === true && (0, $cc04e77999095066$export$2f9c46555243bf04)(key) || !isDom && !(0, $cc04e77999095066$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $lDSNw = parcelRequire("lDSNw");



function $55d949375c230878$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $55d949375c230878$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $55d949375c230878$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $55d949375c230878$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $3cacec990aac7474$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $3cacec990aac7474$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $3cacec990aac7474$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $3cacec990aac7474$var$dashKeys : $3cacec990aac7474$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $2843e1c4e472cf03$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $b0315c50a209627b$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $55d949375c230878$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $3cacec990aac7474$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $631cbe966446e7ed$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $5bc491cb3845384e$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $838d2f4fd7f91578$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $9b578f950b869b78$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $lDSNw.useMemo)(()=>{
        const state = (0, $631cbe966446e7ed$export$41be8b43e1c4d4f9)();
        (0, $2843e1c4e472cf03$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $838d2f4fd7f91578$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $f5e98454b97e5bd9$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $e5156e96303eef99$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $749992b660858c8c$export$88f3fc2fd3766989)(Component) ? (0, $9b578f950b869b78$export$84309c4f53cb1bd5) : (0, $f5e98454b97e5bd9$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $0450247bec6105ce$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $lDSNw.useMemo)(()=>(0, $1a0ef3d59b00772c$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $lDSNw.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $0ae1983d28b655df$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $7332f00dfb525394$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $41d85b56b686a00d$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $f5ec18fd7ddd660f$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $7332f00dfb525394$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $41d85b56b686a00d$export$28931db5d57958e5).has(key) ? (0, $0ae1983d28b655df$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8cce55fadfe2714$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $1a0ef3d59b00772c$export$605d60a2578142d3)(prevProps.style[key]) || (0, $c453d364f5fc16f3$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $e0664acc21d105f5$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a8cce55fadfe2714$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(props[key]) || (0, $1a0ef3d59b00772c$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ed889dd17e65b750$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $lDSNw = parcelRequire("lDSNw");


function $5e3507e00af8f9a9$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $e3b59f1f412643dd$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $c7e75a80b48d7b76$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $c7e75a80b48d7b76$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $e3b59f1f412643dd$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $0b52e95251463d69$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $1a0ef3d59b00772c$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $c7e75a80b48d7b76$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $aae39889b3fcd58e$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $aae39889b3fcd58e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $aae39889b3fcd58e$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $lDSNw.useContext)((0, $5d069b983a3907c1$export$2285bbca2c666415));
        const presenceContext = (0, $lDSNw.useContext)((0, $ad062c71ac58a929$export$f224e4635b6f8ce2));
        const make = ()=>$aae39889b3fcd58e$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $2f15184e95154688$export$fe4300aa8eebea86)(make);
    };
function $aae39889b3fcd58e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $0b52e95251463d69$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $2384c2032528c821$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $2384c2032528c821$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $7b4ea908288cf313$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $5e3507e00af8f9a9$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $4801fa18e944fca3$export$44dabd3fae512e85 = {
    useVisualState: (0, $aae39889b3fcd58e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $e0664acc21d105f5$export$16da615486abaa45),
        createRenderState: (0, $631cbe966446e7ed$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $2843e1c4e472cf03$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, (0, $838d2f4fd7f91578$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
            (0, $f5ec18fd7ddd660f$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





const $92f95384005542c3$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $aae39889b3fcd58e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a8cce55fadfe2714$export$16da615486abaa45,
        createRenderState: (0, $5bc491cb3845384e$export$8940b483cf52eeda)
    })
};


function $c78a8f308c51272a$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $749992b660858c8c$export$88f3fc2fd3766989)(Component) ? (0, $4801fa18e944fca3$export$44dabd3fae512e85) : (0, $92f95384005542c3$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $e5156e96303eef99$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $e27424cad408cc9d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $33c71e83ab52dbe1$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $0333827eec1eee23$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $0333827eec1eee23$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $33c71e83ab52dbe1$export$a4cf9c8a4b063a6e)(event) && handler(event, $0333827eec1eee23$export$12f84bb882d06e1a(event));
};


function $338c8d5747cd9466$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $e27424cad408cc9d$export$b1d829ddf82884aa)(target, eventName, (0, $0333827eec1eee23$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $b73321d0941478df$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $b73321d0941478df$export$a4627e546088548d = (...transformers)=>transformers.reduce($b73321d0941478df$var$combineFunctions);


function $033cc5d388df80c5$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $033cc5d388df80c5$var$globalHorizontalLock = $033cc5d388df80c5$export$518c5fc2dcb7974b("dragHorizontal");
const $033cc5d388df80c5$var$globalVerticalLock = $033cc5d388df80c5$export$518c5fc2dcb7974b("dragVertical");
function $033cc5d388df80c5$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $033cc5d388df80c5$var$globalVerticalLock();
    else if (drag === "x") lock = $033cc5d388df80c5$var$globalHorizontalLock();
    else {
        const openHorizontal = $033cc5d388df80c5$var$globalHorizontalLock();
        const openVertical = $033cc5d388df80c5$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $033cc5d388df80c5$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $033cc5d388df80c5$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $c0c91a2231bc20d6$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $a6a35bf069425ab7$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $033cc5d388df80c5$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $a6a35bf069425ab7$export$93a81ea037eac456 extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $b73321d0941478df$export$a4627e546088548d)($a6a35bf069425ab7$var$addHoverEvent(this.node, true), $a6a35bf069425ab7$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $60bd8df8ee876683$export$d4826db40d47595b extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $b73321d0941478df$export$a4627e546088548d)((0, $e27424cad408cc9d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $e27424cad408cc9d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $cd77294e26642748$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $cd77294e26642748$export$e841ada32ff745b(parent, child.parentElement);
};




function $567e04bf0a0eaac4$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $0333827eec1eee23$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $567e04bf0a0eaac4$export$f026abdbba7f0c9e extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $96ab74a89bc7c563$export$8793edee2d425525);
        this.removeEndListeners = (0, $96ab74a89bc7c563$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $96ab74a89bc7c563$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $cd77294e26642748$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $b73321d0941478df$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $567e04bf0a0eaac4$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $e27424cad408cc9d$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $567e04bf0a0eaac4$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $e27424cad408cc9d$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $567e04bf0a0eaac4$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $e27424cad408cc9d$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $b73321d0941478df$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $033cc5d388df80c5$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $e27424cad408cc9d$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $b73321d0941478df$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $ac40961ba6ae40f9$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $ac40961ba6ae40f9$var$observers = new WeakMap();
const $ac40961ba6ae40f9$var$fireObserverCallback = (entry)=>{
    const callback = $ac40961ba6ae40f9$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $ac40961ba6ae40f9$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($ac40961ba6ae40f9$var$fireObserverCallback);
};
function $ac40961ba6ae40f9$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$ac40961ba6ae40f9$var$observers.has(lookupRoot)) $ac40961ba6ae40f9$var$observers.set(lookupRoot, {});
    const rootObservers = $ac40961ba6ae40f9$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($ac40961ba6ae40f9$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $ac40961ba6ae40f9$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $ac40961ba6ae40f9$var$initIntersectionObserver(options);
    $ac40961ba6ae40f9$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $ac40961ba6ae40f9$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $29a54e6b17842415$var$thresholdNames = {
    some: 0,
    all: 1
};
class $29a54e6b17842415$export$150851c8cc2f0c72 extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $29a54e6b17842415$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $ac40961ba6ae40f9$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($29a54e6b17842415$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $29a54e6b17842415$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $c349b91541cd6d66$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $29a54e6b17842415$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $567e04bf0a0eaac4$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $60bd8df8ee876683$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $a6a35bf069425ab7$export$93a81ea037eac456)
    }
};





function $2b68ac128ebe6843$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $f27e913e77c63b79$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $f27e913e77c63b79$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $f27e913e77c63b79$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $5e3507e00af8f9a9$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $f27e913e77c63b79$var$getCurrent(visualElement), $f27e913e77c63b79$var$getVelocity(visualElement));
}






const $4c1d35f26eac46bf$export$ed7b8fa9dbf0105d = "framerAppearId";
const $4c1d35f26eac46bf$export$8592e1c077c890a6 = "data-" + (0, $0ae1983d28b655df$export$9fd24a634729c672)($4c1d35f26eac46bf$export$ed7b8fa9dbf0105d);



/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $1abee33eaa7e390f$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $1abee33eaa7e390f$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $e3e23a74a7cb0e73$export$888a3d84909f9e3d = {
    current: false
};


const $09d5b589a5d30230$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $ee98be4f63608364$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $ee98be4f63608364$export$2cf569f5e2221176[easing] || (0, $09d5b589a5d30230$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($ee98be4f63608364$export$fcdd8f3f2160beda));
}
const $ee98be4f63608364$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $ee98be4f63608364$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $ee98be4f63608364$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $ee98be4f63608364$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $ee98be4f63608364$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $ee98be4f63608364$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $ee98be4f63608364$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $09d5b589a5d30230$export$ff43f99925d7366b)(easing) ? $ee98be4f63608364$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($ee98be4f63608364$export$916ea73bcd3a6030) : $ee98be4f63608364$export$2cf569f5e2221176[easing];
}


function $1197e6e42581d47e$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $ee98be4f63608364$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $618d52bbbf3e4f6d$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $901b67cdb26be364$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $901b67cdb26be364$var$subdivisionPrecision = 0.0000001;
const $901b67cdb26be364$var$subdivisionMaxIterations = 12;
function $901b67cdb26be364$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $901b67cdb26be364$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $901b67cdb26be364$var$subdivisionPrecision && ++i < $901b67cdb26be364$var$subdivisionMaxIterations);
    return currentT;
}
function $901b67cdb26be364$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $96ab74a89bc7c563$export$8793edee2d425525;
    const getTForX = (aX)=>$901b67cdb26be364$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $901b67cdb26be364$var$calcBezier(getTForX(t), mY1, mY2);
}


const $24832a331fe9ffd8$export$929e5a82286172a6 = (0, $901b67cdb26be364$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $24832a331fe9ffd8$export$57636bb43b1ccbb0 = (0, $901b67cdb26be364$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $24832a331fe9ffd8$export$c07234257a03d5e9 = (0, $901b67cdb26be364$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $5b1a2d3b2f2af4bf$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $fe0c7fdf15e72f5d$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $ab939d9ed6983ef0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $0ff46d99e2e9d5f5$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $0ff46d99e2e9d5f5$export$c8d67a19199d1a50 = (0, $ab939d9ed6983ef0$export$2c07eeff45156d4d)($0ff46d99e2e9d5f5$export$e444123e42d03385);
const $0ff46d99e2e9d5f5$export$30d3455eee55bed5 = (0, $fe0c7fdf15e72f5d$export$f946554fb8aeaf0d)($0ff46d99e2e9d5f5$export$c8d67a19199d1a50);





const $9285f214b892ad85$export$77edfce482316a60 = (0, $901b67cdb26be364$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $9285f214b892ad85$export$b01116c84cdfe1a2 = (0, $ab939d9ed6983ef0$export$2c07eeff45156d4d)($9285f214b892ad85$export$77edfce482316a60);
const $9285f214b892ad85$export$ddc5fd596f6c71b2 = (0, $fe0c7fdf15e72f5d$export$f946554fb8aeaf0d)($9285f214b892ad85$export$b01116c84cdfe1a2);



const $e821149a1b587c11$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $9285f214b892ad85$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $b8226dd038d876f6$var$easingLookup = {
    linear: (0, $96ab74a89bc7c563$export$8793edee2d425525),
    easeIn: $24832a331fe9ffd8$export$929e5a82286172a6,
    easeInOut: $24832a331fe9ffd8$export$c07234257a03d5e9,
    easeOut: $24832a331fe9ffd8$export$57636bb43b1ccbb0,
    circIn: $0ff46d99e2e9d5f5$export$e444123e42d03385,
    circInOut: $0ff46d99e2e9d5f5$export$30d3455eee55bed5,
    circOut: $0ff46d99e2e9d5f5$export$c8d67a19199d1a50,
    backIn: $9285f214b892ad85$export$b01116c84cdfe1a2,
    backInOut: $9285f214b892ad85$export$ddc5fd596f6c71b2,
    backOut: $9285f214b892ad85$export$77edfce482316a60,
    anticipate: $e821149a1b587c11$export$6b0af63b873d419e
};
const $b8226dd038d876f6$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $30298752de581a70$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $901b67cdb26be364$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $30298752de581a70$export$f5708dca728d7177)($b8226dd038d876f6$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $b8226dd038d876f6$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $1b8f682079e4a969$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $16d8203a4f86b801$export$844ec244b1367d54)(v) && (0, $16d8203a4f86b801$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $1b8f682079e4a969$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $16d8203a4f86b801$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $16d8203a4f86b801$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $1861d209e111ebc1$var$clampRgbUnit = (v)=>(0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $1861d209e111ebc1$export$7a99c86b5b1f4c9e = {
    ...(0, $45e03c7d2655bcf8$export$98e628dec113755e),
    transform: (v)=>Math.round($1861d209e111ebc1$var$clampRgbUnit(v))
};
const $1861d209e111ebc1$export$4e46ac54fc82cf3b = {
    test: (0, $1b8f682079e4a969$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $1b8f682079e4a969$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $1861d209e111ebc1$export$7a99c86b5b1f4c9e.transform(red) + ", " + $1861d209e111ebc1$export$7a99c86b5b1f4c9e.transform(green) + ", " + $1861d209e111ebc1$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $16d8203a4f86b801$export$83d2e9e3e4ee39ed)((0, $45e03c7d2655bcf8$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $eb422f658bf0af2e$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $eb422f658bf0af2e$export$834dfc94dde4b3d8 = {
    test: (0, $1b8f682079e4a969$export$2c8400d58aca05e)("#"),
    parse: $eb422f658bf0af2e$var$parseHex,
    transform: (0, $1861d209e111ebc1$export$4e46ac54fc82cf3b).transform
};






const $846ad43209415cbb$export$810b04175080204c = {
    test: (0, $1b8f682079e4a969$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $1b8f682079e4a969$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $a08d8e53c3ef0aef$export$626336c2cd4b14de).transform((0, $16d8203a4f86b801$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $a08d8e53c3ef0aef$export$626336c2cd4b14de).transform((0, $16d8203a4f86b801$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $16d8203a4f86b801$export$83d2e9e3e4ee39ed)((0, $45e03c7d2655bcf8$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $c4bfaea293d0fe9a$export$35e9368ef982300f = {
    test: (v)=>(0, $1861d209e111ebc1$export$4e46ac54fc82cf3b).test(v) || (0, $eb422f658bf0af2e$export$834dfc94dde4b3d8).test(v) || (0, $846ad43209415cbb$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $1861d209e111ebc1$export$4e46ac54fc82cf3b).test(v)) return (0, $1861d209e111ebc1$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $846ad43209415cbb$export$810b04175080204c).test(v)) return (0, $846ad43209415cbb$export$810b04175080204c).parse(v);
        else return (0, $eb422f658bf0af2e$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $16d8203a4f86b801$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $1861d209e111ebc1$export$4e46ac54fc82cf3b).transform(v) : (0, $846ad43209415cbb$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $471418eb0e7f05e0$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $bdc6878561ea6a42$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $bdc6878561ea6a42$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $bdc6878561ea6a42$var$hueToRgb(p, q, hue + 1 / 3);
        green = $bdc6878561ea6a42$var$hueToRgb(p, q, hue);
        blue = $bdc6878561ea6a42$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $d395832c237c3fa0$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $d395832c237c3fa0$var$colorTypes = [
    (0, $eb422f658bf0af2e$export$834dfc94dde4b3d8),
    (0, $1861d209e111ebc1$export$4e46ac54fc82cf3b),
    (0, $846ad43209415cbb$export$810b04175080204c)
];
const $d395832c237c3fa0$var$getColorType = (v)=>$d395832c237c3fa0$var$colorTypes.find((type)=>type.test(v));
function $d395832c237c3fa0$var$asRGBA(color) {
    const type = $d395832c237c3fa0$var$getColorType(color);
    (0, $30298752de581a70$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $846ad43209415cbb$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $bdc6878561ea6a42$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $d395832c237c3fa0$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $d395832c237c3fa0$var$asRGBA(from);
    const toRGBA = $d395832c237c3fa0$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $d395832c237c3fa0$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $d395832c237c3fa0$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $d395832c237c3fa0$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $1861d209e111ebc1$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $4b79962a2c93122d$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $16d8203a4f86b801$export$844ec244b1367d54)(v) && (((_a = v.match((0, $16d8203a4f86b801$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $16d8203a4f86b801$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $4b79962a2c93122d$var$cssVarTokeniser = {
    regex: (0, $017a916d7c7d6823$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $96ab74a89bc7c563$export$8793edee2d425525)
};
const $4b79962a2c93122d$var$colorTokeniser = {
    regex: (0, $16d8203a4f86b801$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f).parse
};
const $4b79962a2c93122d$var$numberTokeniser = {
    regex: (0, $16d8203a4f86b801$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $45e03c7d2655bcf8$export$98e628dec113755e).parse
};
function $4b79962a2c93122d$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $4b79962a2c93122d$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $4b79962a2c93122d$var$tokenise(info, $4b79962a2c93122d$var$cssVarTokeniser);
    $4b79962a2c93122d$var$tokenise(info, $4b79962a2c93122d$var$colorTokeniser);
    $4b79962a2c93122d$var$tokenise(info, $4b79962a2c93122d$var$numberTokeniser);
    return info;
}
function $4b79962a2c93122d$var$parseComplexValue(v) {
    return $4b79962a2c93122d$export$b61fc7c44bf646d5(v).values;
}
function $4b79962a2c93122d$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $4b79962a2c93122d$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($4b79962a2c93122d$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($4b79962a2c93122d$var$colorTokeniser.token, (0, $c4bfaea293d0fe9a$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($4b79962a2c93122d$var$numberTokeniser.token, (0, $16d8203a4f86b801$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $4b79962a2c93122d$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $4b79962a2c93122d$var$getAnimatableNone(v) {
    const parsed = $4b79962a2c93122d$var$parseComplexValue(v);
    const transformer = $4b79962a2c93122d$var$createTransformer(v);
    return transformer(parsed.map($4b79962a2c93122d$var$convertNumbersToZero));
}
const $4b79962a2c93122d$export$83a0e34f1302825b = {
    test: $4b79962a2c93122d$var$test,
    parse: $4b79962a2c93122d$var$parseComplexValue,
    createTransformer: $4b79962a2c93122d$var$createTransformer,
    getAnimatableNone: $4b79962a2c93122d$var$getAnimatableNone
};


const $69ec83be07b06e5c$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $69ec83be07b06e5c$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $c4bfaea293d0fe9a$export$35e9368ef982300f).test(origin)) return (0, $d395832c237c3fa0$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $69ec83be07b06e5c$var$mixImmediate(origin, target) : $69ec83be07b06e5c$export$65516310a87d8205(origin, target);
}
const $69ec83be07b06e5c$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$69ec83be07b06e5c$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $69ec83be07b06e5c$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $69ec83be07b06e5c$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $69ec83be07b06e5c$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $4b79962a2c93122d$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $4b79962a2c93122d$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $4b79962a2c93122d$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $b73321d0941478df$export$a4627e546088548d)($69ec83be07b06e5c$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $30298752de581a70$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $69ec83be07b06e5c$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $bd39c7cde96f5c7c$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $5fa77b345479d9bc$var$mixNumber = (from, to)=>(p)=>(0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(from, to, p);
function $5fa77b345479d9bc$var$detectMixerFactory(v) {
    if (typeof v === "number") return $5fa77b345479d9bc$var$mixNumber;
    else if (typeof v === "string") return (0, $c4bfaea293d0fe9a$export$35e9368ef982300f).test(v) ? (0, $d395832c237c3fa0$export$51e568cf5c039bac) : (0, $69ec83be07b06e5c$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $69ec83be07b06e5c$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $69ec83be07b06e5c$export$ebc23b6840c51ba1;
    return $5fa77b345479d9bc$var$mixNumber;
}
function $5fa77b345479d9bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $5fa77b345479d9bc$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $96ab74a89bc7c563$export$8793edee2d425525) : ease;
            mixer = (0, $b73321d0941478df$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $5fa77b345479d9bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $30298752de581a70$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $5fa77b345479d9bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $bd39c7cde96f5c7c$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $1db025ab26673439$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $bd39c7cde96f5c7c$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $335ee98ff4419f5c$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $1db025ab26673439$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $1b2661ae31d6406b$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $191e203f1b64c33a$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $24832a331fe9ffd8$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $191e203f1b64c33a$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $5b1a2d3b2f2af4bf$export$216948827bbdc797)(ease) ? ease.map((0, $b8226dd038d876f6$export$ef97fe084f156ca4)) : (0, $b8226dd038d876f6$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $1b2661ae31d6406b$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $335ee98ff4419f5c$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $5fa77b345479d9bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $191e203f1b64c33a$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $0115147ffb086263$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $2f6dc2b78dc464df$var$velocitySampleDuration = 5; // ms
function $2f6dc2b78dc464df$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $2f6dc2b78dc464df$var$velocitySampleDuration, 0);
    return (0, $0115147ffb086263$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $c81530e099a6583c$var$safeMin = 0.001;
const $c81530e099a6583c$export$a3cdb76e84ee608e = 0.01;
const $c81530e099a6583c$export$1824b851fad8862b = 10.0;
const $c81530e099a6583c$export$ff08f2d53484465 = 0.05;
const $c81530e099a6583c$export$201ca48e54038115 = 1;
function $c81530e099a6583c$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $30298752de581a70$export$491112666e282270)(duration <= (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)($c81530e099a6583c$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)($c81530e099a6583c$export$ff08f2d53484465, $c81530e099a6583c$export$201ca48e54038115, dampingRatio);
    duration = (0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)($c81530e099a6583c$export$a3cdb76e84ee608e, $c81530e099a6583c$export$1824b851fad8862b, (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $c81530e099a6583c$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $c81530e099a6583c$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $c81530e099a6583c$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $c81530e099a6583c$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$c81530e099a6583c$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $c81530e099a6583c$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $c81530e099a6583c$var$rootIterations = 12;
function $c81530e099a6583c$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $c81530e099a6583c$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $c81530e099a6583c$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $f8c658829581418e$var$durationKeys = [
    "duration",
    "bounce"
];
const $f8c658829581418e$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $f8c658829581418e$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $f8c658829581418e$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$f8c658829581418e$var$isSpringType(options, $f8c658829581418e$var$physicsKeys) && $f8c658829581418e$var$isSpringType(options, $f8c658829581418e$var$durationKeys)) {
        const derived = (0, $c81530e099a6583c$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $f8c658829581418e$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $f8c658829581418e$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $c81530e099a6583c$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $2f6dc2b78dc464df$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $5411bdf9d71c1020$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $f8c658829581418e$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $2f6dc2b78dc464df$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $b9153ec2216d3384$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $8e7cd14116eefbbb$export$fff89137e9e818ce).isProcessing ? (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $c058a50896fa4932$export$f4ff70a5b4808fd8 = 20000;
function $c058a50896fa4932$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $c058a50896fa4932$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $c058a50896fa4932$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $c94319f09b80d075$var$types = {
    decay: (0, $5411bdf9d71c1020$export$ee3ff3a17106998),
    inertia: $5411bdf9d71c1020$export$ee3ff3a17106998,
    tween: (0, $191e203f1b64c33a$export$d25ddfdf17c3ad3e),
    keyframes: (0, $191e203f1b64c33a$export$d25ddfdf17c3ad3e),
    spring: $f8c658829581418e$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $c94319f09b80d075$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $b9153ec2216d3384$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $c94319f09b80d075$var$types[type] || (0, $191e203f1b64c33a$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $191e203f1b64c33a$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $5fa77b345479d9bc$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $c058a50896fa4932$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $c058a50896fa4932$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $ef6861d38665af80$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $aa9fb47d1aba65a7$var$supportsWaapi = (0, $ef6861d38665af80$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $aa9fb47d1aba65a7$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $aa9fb47d1aba65a7$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $aa9fb47d1aba65a7$var$maxDuration = 20000;
const $aa9fb47d1aba65a7$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $ee98be4f63608364$export$fcdd8f3f2160beda)(options.ease);
function $aa9fb47d1aba65a7$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $aa9fb47d1aba65a7$var$supportsWaapi() && $aa9fb47d1aba65a7$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($aa9fb47d1aba65a7$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $c94319f09b80d075$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $aa9fb47d1aba65a7$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $aa9fb47d1aba65a7$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $aa9fb47d1aba65a7$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $1197e6e42581d47e$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $618d52bbbf3e4f6d$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $96ab74a89bc7c563$export$8793edee2d425525;
        },
        get time () {
            return (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $c94319f09b80d075$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $aa9fb47d1aba65a7$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $aa9fb47d1aba65a7$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $974ca2b400d5deda$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $96ab74a89bc7c563$export$8793edee2d425525),
            pause: (0, $96ab74a89bc7c563$export$8793edee2d425525),
            stop: (0, $96ab74a89bc7c563$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $96ab74a89bc7c563$export$8793edee2d425525),
            complete: (0, $96ab74a89bc7c563$export$8793edee2d425525)
        };
    };
    return delay ? (0, $c94319f09b80d075$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $35f453cdbb42114a$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $35f453cdbb42114a$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $35f453cdbb42114a$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $35f453cdbb42114a$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $35f453cdbb42114a$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $35f453cdbb42114a$var$keyframesTransition;
    else if ((0, $ed889dd17e65b750$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $35f453cdbb42114a$var$criticallyDampedSpring(keyframes[1]) : $35f453cdbb42114a$var$underDampedSpring;
    return $35f453cdbb42114a$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $9bb8a6630e0fd929$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $4b79962a2c93122d$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $ff7017f0e2fcf461$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $ff7017f0e2fcf461$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $16d8203a4f86b801$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $ff7017f0e2fcf461$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $ff7017f0e2fcf461$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $ff7017f0e2fcf461$export$3dea766d36a8935f = {
    ...(0, $4b79962a2c93122d$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($ff7017f0e2fcf461$var$functionRegex);
        return functions ? functions.map($ff7017f0e2fcf461$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $bfe95f1661b06e97$export$98cd7c72c5a731fb = {
    ...(0, $0d12138c7dd54005$export$eec14432cd1cb67b),
    color: // Color props
    $c4bfaea293d0fe9a$export$35e9368ef982300f,
    backgroundColor: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    outlineColor: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    fill: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    stroke: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    borderTopColor: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    borderRightColor: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    borderBottomColor: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    borderLeftColor: (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    filter: $ff7017f0e2fcf461$export$3dea766d36a8935f,
    WebkitFilter: (0, $ff7017f0e2fcf461$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $bfe95f1661b06e97$export$67d1babe0338d23b = (key)=>$bfe95f1661b06e97$export$98cd7c72c5a731fb[key];


function $b538f6c83aa83e08$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $bfe95f1661b06e97$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $ff7017f0e2fcf461$export$3dea766d36a8935f)) defaultValueType = (0, $4b79962a2c93122d$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $692a76877a756e8c$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $6ab57b73a0b6b83a$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $692a76877a756e8c$export$ade84c85e44a6cb1)(value);
}


function $c09031afed92bb73$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $9bb8a6630e0fd929$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $6ab57b73a0b6b83a$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $b538f6c83aa83e08$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $348b60fbdaab4f2a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $348b60fbdaab4f2a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $b7c14186c3e9f1d6$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $348b60fbdaab4f2a$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $c09031afed92bb73$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $9bb8a6630e0fd929$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $9bb8a6630e0fd929$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $30298752de581a70$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $348b60fbdaab4f2a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $35f453cdbb42114a$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $e3e23a74a7cb0e73$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $974ca2b400d5deda$export$6f34fc8ef6c42b70)((0, $e3e23a74a7cb0e73$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $aa9fb47d1aba65a7$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $c94319f09b80d075$export$ee9b76de7353d815)(options);
    };
};



function $8ef33fbe900edab6$export$98397f3adbf6259f(value) {
    return Boolean((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $c55b012453b89b1a$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $400b44de453c8d64$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $400b44de453c8d64$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $400b44de453c8d64$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $57bc7a6005435ddc$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $400b44de453c8d64$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $400b44de453c8d64$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $efd4ea1cd2d913bc$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $efd4ea1cd2d913bc$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.15.1";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $8e7cd14116eefbbb$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $8e7cd14116eefbbb$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $efd4ea1cd2d913bc$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $57bc7a6005435ddc$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $0115147ffb086263$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $efd4ea1cd2d913bc$export$ce8bdc721e76545f(init, options) {
    return new $efd4ea1cd2d913bc$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $29ec92d90b75b9b0$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $faea08cd01041a9f$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $7d5014e4f3423923$export$d176691c1998a1f5 = [
    (0, $45e03c7d2655bcf8$export$98e628dec113755e),
    (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008),
    (0, $a08d8e53c3ef0aef$export$626336c2cd4b14de),
    (0, $a08d8e53c3ef0aef$export$41fc368e1a942b97),
    (0, $a08d8e53c3ef0aef$export$aed3d7b7d206c196),
    (0, $a08d8e53c3ef0aef$export$f91e8c45a95a32f2),
    (0, $faea08cd01041a9f$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $7d5014e4f3423923$export$eefdd52e3ccae428 = (v)=>$7d5014e4f3423923$export$d176691c1998a1f5.find((0, $29ec92d90b75b9b0$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $1d549efb46a6db6c$var$valueTypes = [
    ...(0, $7d5014e4f3423923$export$d176691c1998a1f5),
    (0, $c4bfaea293d0fe9a$export$35e9368ef982300f),
    (0, $4b79962a2c93122d$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $1d549efb46a6db6c$export$950e7e59ea1ffed7 = (v)=>$1d549efb46a6db6c$var$valueTypes.find((0, $29ec92d90b75b9b0$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $f3d5c0f6e2d7b1e8$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $efd4ea1cd2d913bc$export$ce8bdc721e76545f)(value));
}
function $f3d5c0f6e2d7b1e8$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $f27e913e77c63b79$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $c7e75a80b48d7b76$export$5485128c47bd48bb)(target[key]);
        $f3d5c0f6e2d7b1e8$var$setMotionValue(visualElement, key, value);
    }
}
function $f3d5c0f6e2d7b1e8$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $f3d5c0f6e2d7b1e8$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $f3d5c0f6e2d7b1e8$var$setVariants(child, variantLabels);
        });
    });
}
function $f3d5c0f6e2d7b1e8$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $f3d5c0f6e2d7b1e8$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $f3d5c0f6e2d7b1e8$var$setVariants(visualElement, [
        definition
    ]);
    else $f3d5c0f6e2d7b1e8$export$1f61c53461aff4a5(visualElement, definition);
}
function $f3d5c0f6e2d7b1e8$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $c55b012453b89b1a$export$65583ed5a868f2d9)(value) || (0, $692a76877a756e8c$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $1d549efb46a6db6c$export$950e7e59ea1ffed7)(value) && (0, $4b79962a2c93122d$export$83a0e34f1302825b).test(targetValue)) value = (0, $b538f6c83aa83e08$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $efd4ea1cd2d913bc$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $f3d5c0f6e2d7b1e8$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $f3d5c0f6e2d7b1e8$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $f3d5c0f6e2d7b1e8$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $faddd33c4719fa3d$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $faddd33c4719fa3d$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $faddd33c4719fa3d$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $4c1d35f26eac46bf$export$8592e1c077c890a6];
            if (appearId) valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $8e7cd14116eefbbb$export$2cef06c20297c17d));
        }
        value.start((0, $b7c14186c3e9f1d6$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ed889dd17e65b750$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $8ef33fbe900edab6$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $f3d5c0f6e2d7b1e8$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $49b982bba12c24d3$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $f27e913e77c63b79$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $faddd33c4719fa3d$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $49b982bba12c24d3$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $49b982bba12c24d3$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($49b982bba12c24d3$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($49b982bba12c24d3$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $49b982bba12c24d3$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $9cae0cb103802ab1$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $49b982bba12c24d3$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $49b982bba12c24d3$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $f27e913e77c63b79$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $faddd33c4719fa3d$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $d824e13395911f48$var$reversePriorityOrder = [
    ...(0, $921392e203866556$export$16e45afcc206d3a8)
].reverse();
const $d824e13395911f48$var$numAnimationTypes = (0, $921392e203866556$export$16e45afcc206d3a8).length;
function $d824e13395911f48$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $9cae0cb103802ab1$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $d824e13395911f48$export$bb53502b7a672aa8(visualElement) {
    let animate = $d824e13395911f48$var$animateList(visualElement);
    const state = $d824e13395911f48$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $f27e913e77c63b79$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $d824e13395911f48$var$numAnimationTypes; i++){
            const type = $d824e13395911f48$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $ff2b58769c7190e2$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $7b4ea908288cf313$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $d824e13395911f48$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $e3b59f1f412643dd$export$9153ad4c4999f4a0)(next) && (0, $e3b59f1f412643dd$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $2b68ac128ebe6843$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $d824e13395911f48$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $2b68ac128ebe6843$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $d824e13395911f48$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $d824e13395911f48$var$createState() {
    return {
        animate: $d824e13395911f48$var$createTypeState(true),
        whileInView: $d824e13395911f48$var$createTypeState(),
        whileHover: $d824e13395911f48$var$createTypeState(),
        whileTap: $d824e13395911f48$var$createTypeState(),
        whileDrag: $d824e13395911f48$var$createTypeState(),
        whileFocus: $d824e13395911f48$var$createTypeState(),
        exit: $d824e13395911f48$var$createTypeState()
    };
}



class $d6dfa7a27e2e3b02$export$b45b3fe5caabdca extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $d824e13395911f48$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $7b4ea908288cf313$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $86127662bb3a4418$var$id = 0;
class $86127662bb3a4418$export$4989d1eb6104cc6c extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $86127662bb3a4418$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $e67a0abf4f9f5536$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $d6dfa7a27e2e3b02$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $86127662bb3a4418$export$4989d1eb6104cc6c)
    }
};









const $7154b4827d91113e$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $7154b4827d91113e$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $7154b4827d91113e$export$9f17032d917177de(a.x, b.x);
    const yDelta = $7154b4827d91113e$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $4d0981fea3ba1224$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $4d0981fea3ba1224$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $7154b4827d91113e$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $8e7cd14116eefbbb$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $4d0981fea3ba1224$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $4d0981fea3ba1224$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $4d0981fea3ba1224$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $33c71e83ab52dbe1$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $0333827eec1eee23$export$12f84bb882d06e1a)(event);
        const initialInfo = $4d0981fea3ba1224$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $8e7cd14116eefbbb$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $4d0981fea3ba1224$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $b73321d0941478df$export$a4627e546088548d)((0, $338c8d5747cd9466$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $4d0981fea3ba1224$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $4d0981fea3ba1224$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $4d0981fea3ba1224$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $4d0981fea3ba1224$var$subtractPoint(point, $4d0981fea3ba1224$var$lastDevicePoint(history)),
        offset: $4d0981fea3ba1224$var$subtractPoint(point, $4d0981fea3ba1224$var$startDevicePoint(history)),
        velocity: $4d0981fea3ba1224$var$getVelocity(history, 0.1)
    };
}
function $4d0981fea3ba1224$var$startDevicePoint(history) {
    return history[0];
}
function $4d0981fea3ba1224$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $4d0981fea3ba1224$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $4d0981fea3ba1224$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $3eca2991868626a6$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $3eca2991868626a6$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $3eca2991868626a6$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $3eca2991868626a6$export$c1c127004b72a37(target) / $3eca2991868626a6$export$c1c127004b72a37(source);
    if ($3eca2991868626a6$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($3eca2991868626a6$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $3eca2991868626a6$export$c0d25e96fc67d310(delta, source, target, origin) {
    $3eca2991868626a6$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $3eca2991868626a6$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $3eca2991868626a6$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $3eca2991868626a6$export$c1c127004b72a37(relative);
}
function $3eca2991868626a6$export$426154f9d100f99(target, relative, parent) {
    $3eca2991868626a6$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $3eca2991868626a6$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $3eca2991868626a6$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $3eca2991868626a6$export$c1c127004b72a37(layout);
}
function $3eca2991868626a6$export$2785bfcc929c5650(target, layout, parent) {
    $3eca2991868626a6$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $3eca2991868626a6$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $6b1fb1c441026ccf$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $6b1fb1c441026ccf$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $6b1fb1c441026ccf$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $6b1fb1c441026ccf$export$690c180aa5775042(layoutBox.x, left, right),
        y: $6b1fb1c441026ccf$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $6b1fb1c441026ccf$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $6b1fb1c441026ccf$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $6b1fb1c441026ccf$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $6b1fb1c441026ccf$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $6b1fb1c441026ccf$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $3eca2991868626a6$export$c1c127004b72a37)(source);
    const targetLength = (0, $3eca2991868626a6$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $bd39c7cde96f5c7c$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $bd39c7cde96f5c7c$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $6b1fb1c441026ccf$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $6b1fb1c441026ccf$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $6b1fb1c441026ccf$export$7c5eaef8f4723d22(dragElastic = $6b1fb1c441026ccf$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $6b1fb1c441026ccf$export$a3366d3bac43a742;
    return {
        x: $6b1fb1c441026ccf$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $6b1fb1c441026ccf$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $6b1fb1c441026ccf$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $6b1fb1c441026ccf$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $6b1fb1c441026ccf$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $6b1fb1c441026ccf$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $f19f144286c96018$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $f19f144286c96018$export$3d227df54007d73a = ()=>({
        x: $f19f144286c96018$export$ff25708b37f72782(),
        y: $f19f144286c96018$export$ff25708b37f72782()
    });
const $f19f144286c96018$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $f19f144286c96018$export$6459fc9e86be362e = ()=>({
        x: $f19f144286c96018$export$6db76765312617ac(),
        y: $f19f144286c96018$export$6db76765312617ac()
    });


function $3d22c9c0645cee99$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $381504be40b7816c$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $381504be40b7816c$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $381504be40b7816c$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $c9d6e1e0900346b0$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $c9d6e1e0900346b0$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$c9d6e1e0900346b0$var$isIdentityScale(scale) || !$c9d6e1e0900346b0$var$isIdentityScale(scaleX) || !$c9d6e1e0900346b0$var$isIdentityScale(scaleY);
}
function $c9d6e1e0900346b0$export$a545127cf1fbb600(values) {
    return $c9d6e1e0900346b0$export$bdf30dca883ea463(values) || $c9d6e1e0900346b0$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $c9d6e1e0900346b0$export$bf80f5f8f4dc327f(values) {
    return $c9d6e1e0900346b0$var$is2DTranslate(values.x) || $c9d6e1e0900346b0$var$is2DTranslate(values.y);
}
function $c9d6e1e0900346b0$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $2935cacc4303edbd$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $2935cacc4303edbd$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $2935cacc4303edbd$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $2935cacc4303edbd$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $2935cacc4303edbd$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $2935cacc4303edbd$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $2935cacc4303edbd$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $2935cacc4303edbd$export$d80074982803af5c(box, { x: x, y: y }) {
    $2935cacc4303edbd$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $2935cacc4303edbd$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $2935cacc4303edbd$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $2935cacc4303edbd$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $2935cacc4303edbd$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $c9d6e1e0900346b0$export$a545127cf1fbb600)(node.latestValues)) $2935cacc4303edbd$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $2935cacc4303edbd$var$snapToDefault(treeScale.x);
    treeScale.y = $2935cacc4303edbd$var$snapToDefault(treeScale.y);
}
function $2935cacc4303edbd$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $2935cacc4303edbd$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $2935cacc4303edbd$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $2935cacc4303edbd$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $2935cacc4303edbd$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $2935cacc4303edbd$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $2935cacc4303edbd$export$58b16271041fbfb(box, transform) {
    $2935cacc4303edbd$export$625f1dd140a2f5e7(box.x, transform, $2935cacc4303edbd$var$xKeys);
    $2935cacc4303edbd$export$625f1dd140a2f5e7(box.y, transform, $2935cacc4303edbd$var$yKeys);
}


function $f159b97852bd76e5$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $381504be40b7816c$export$d3955c6a8f65a36b)((0, $381504be40b7816c$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $f159b97852bd76e5$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $f159b97852bd76e5$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}










const $956f776eb124a5dc$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $956f776eb124a5dc$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $f19f144286c96018$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $0333827eec1eee23$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $033cc5d388df80c5$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $a08d8e53c3ef0aef$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $3eca2991868626a6$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $956f776eb124a5dc$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $4d0981fea3ba1224$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$956f776eb124a5dc$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $6b1fb1c441026ccf$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $8a65e6d1ff14311a$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $6b1fb1c441026ccf$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $6b1fb1c441026ccf$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $6b1fb1c441026ccf$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $8a65e6d1ff14311a$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $30298752de581a70$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $f159b97852bd76e5$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $6b1fb1c441026ccf$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $381504be40b7816c$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $381504be40b7816c$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
            if (!$956f776eb124a5dc$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $b7c14186c3e9f1d6$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$956f776eb124a5dc$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $8a65e6d1ff14311a$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $6b1fb1c441026ccf$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
            if (!$956f776eb124a5dc$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $956f776eb124a5dc$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $8a65e6d1ff14311a$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $e27424cad408cc9d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $6b1fb1c441026ccf$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $956f776eb124a5dc$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $956f776eb124a5dc$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $8509466a9b4eb833$export$5d97dc2872682820 extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $96ab74a89bc7c563$export$8793edee2d425525);
        this.removeListeners = (0, $96ab74a89bc7c563$export$8793edee2d425525);
        this.controls = new (0, $956f776eb124a5dc$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $96ab74a89bc7c563$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $30c279eb49ca5ef3$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $30c279eb49ca5ef3$export$b4f8f1ee75ce5859 extends (0, $c0c91a2231bc20d6$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $96ab74a89bc7c563$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $4d0981fea3ba1224$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $30c279eb49ca5ef3$var$asyncHandler(onPanSessionStart),
            onStart: $30c279eb49ca5ef3$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $338c8d5747cd9466$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $b6f4d24a99ec1efd$export$2a8c16d82a0a0e26() {
    const context = (0, $lDSNw.useContext)((0, $ad062c71ac58a929$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $lDSNw.useId)();
    (0, $lDSNw.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $b6f4d24a99ec1efd$export$8249053f690ea39a() {
    return $b6f4d24a99ec1efd$export$ee27c052bca048fb((0, $lDSNw.useContext)((0, $ad062c71ac58a929$export$f224e4635b6f8ce2)));
}
function $b6f4d24a99ec1efd$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $597f916ad13d6a6d$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $47a280e94df1d4ce$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $47a280e94df1d4ce$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $47a280e94df1d4ce$export$fafff692be55225d(latest, node.target.x);
        const y = $47a280e94df1d4ce$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $50adb5fe712299b1$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $4b79962a2c93122d$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $4b79962a2c93122d$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $f9ac4ccafc17b924$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $1ba5906becf00f74$export$de9e7791c71225fd)($f9ac4ccafc17b924$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $597f916ad13d6a6d$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $f9ac4ccafc17b924$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $b6f4d24a99ec1efd$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $lDSNw.useContext)((0, $d975c5dcc3d215ef$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($f9ac4ccafc17b924$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $lDSNw.useContext)((0, $04642920b4180e3c$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $f9ac4ccafc17b924$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $47a280e94df1d4ce$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $47a280e94df1d4ce$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $47a280e94df1d4ce$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $47a280e94df1d4ce$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $47a280e94df1d4ce$export$5eafb6257a5844c),
    boxShadow: (0, $50adb5fe712299b1$export$eb0bc629e74dcf8)
};








const $6a764734e05ba2ba$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $6a764734e05ba2ba$var$numBorders = $6a764734e05ba2ba$var$borders.length;
const $6a764734e05ba2ba$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $6a764734e05ba2ba$var$isPx = (value)=>typeof value === "number" || (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008).test(value);
function $6a764734e05ba2ba$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $6a764734e05ba2ba$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $6a764734e05ba2ba$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $6a764734e05ba2ba$var$numBorders; i++){
        const borderLabel = `border${$6a764734e05ba2ba$var$borders[i]}Radius`;
        let followRadius = $6a764734e05ba2ba$var$getRadius(follow, borderLabel);
        let leadRadius = $6a764734e05ba2ba$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $6a764734e05ba2ba$var$isPx(followRadius) === $6a764734e05ba2ba$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)($6a764734e05ba2ba$var$asNumber(followRadius), $6a764734e05ba2ba$var$asNumber(leadRadius), progress), 0);
            if ((0, $a08d8e53c3ef0aef$export$626336c2cd4b14de).test(leadRadius) || (0, $a08d8e53c3ef0aef$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $6a764734e05ba2ba$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $6a764734e05ba2ba$var$easeCrossfadeIn = $6a764734e05ba2ba$var$compress(0, 0.5, (0, $0ff46d99e2e9d5f5$export$c8d67a19199d1a50));
const $6a764734e05ba2ba$var$easeCrossfadeOut = $6a764734e05ba2ba$var$compress(0.5, 0.95, (0, $96ab74a89bc7c563$export$8793edee2d425525));
function $6a764734e05ba2ba$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $bd39c7cde96f5c7c$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $0a0fcfc1b2657c89$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $0a0fcfc1b2657c89$export$c53fd88f45d77e4b(box, originBox) {
    $0a0fcfc1b2657c89$export$a0230ae482601ae8(box.x, originBox.x);
    $0a0fcfc1b2657c89$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $223ee03087c6b90d$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $2935cacc4303edbd$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $2935cacc4303edbd$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $223ee03087c6b90d$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $a08d8e53c3ef0aef$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $223ee03087c6b90d$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $223ee03087c6b90d$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $223ee03087c6b90d$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $223ee03087c6b90d$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $223ee03087c6b90d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $223ee03087c6b90d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $223ee03087c6b90d$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $223ee03087c6b90d$export$42b76f1d0d16d5b(box.x, transforms, $223ee03087c6b90d$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $223ee03087c6b90d$export$42b76f1d0d16d5b(box.y, transforms, $223ee03087c6b90d$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $821faf0fc57e7e7a$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $821faf0fc57e7e7a$export$a7ec7642fe550fb6(delta) {
    return $821faf0fc57e7e7a$var$isAxisDeltaZero(delta.x) && $821faf0fc57e7e7a$var$isAxisDeltaZero(delta.y);
}
function $821faf0fc57e7e7a$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $821faf0fc57e7e7a$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $821faf0fc57e7e7a$export$c5706146bc63213(box) {
    return (0, $3eca2991868626a6$export$c1c127004b72a37)(box.x) / (0, $3eca2991868626a6$export$c1c127004b72a37)(box.y);
}



class $88001081c8bda114$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $400b44de453c8d64$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $400b44de453c8d64$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $09b88d87be5130fb$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $4e358e9761a1c89a$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $9c5df0c537cf4567$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $400b44de453c8d64$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $400b44de453c8d64$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $4e358e9761a1c89a$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $e295f0abddeb3eea$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(checkElapsed);
}



function $12aa87368af90de3$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $177bb9ad58634554$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $dd650ad9aec5d6c0$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $1a0ef3d59b00772c$export$605d60a2578142d3)(value) ? value : (0, $efd4ea1cd2d913bc$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b7c14186c3e9f1d6$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $d4d4a9f50423455c$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d4d4a9f50423455c$var$animationTarget = 1000;
let $d4d4a9f50423455c$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $d4d4a9f50423455c$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $d4d4a9f50423455c$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d4d4a9f50423455c$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $d4d4a9f50423455c$var$projectionFrameData.totalNodes = $d4d4a9f50423455c$var$projectionFrameData.resolvedTargetDeltas = $d4d4a9f50423455c$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($d4d4a9f50423455c$export$131f2f0cc5fe9609);
                this.nodes.forEach($d4d4a9f50423455c$var$resolveTargetDelta);
                this.nodes.forEach($d4d4a9f50423455c$var$calcProjection);
                this.nodes.forEach($d4d4a9f50423455c$export$c2664f37bc951031);
                (0, $12aa87368af90de3$export$e5185e241753e543)($d4d4a9f50423455c$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $9c5df0c537cf4567$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $57bc7a6005435ddc$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $177bb9ad58634554$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $e295f0abddeb3eea$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $597f916ad13d6a6d$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $597f916ad13d6a6d$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d4d4a9f50423455c$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d4d4a9f50423455c$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $821faf0fc57e7e7a$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $348b60fbdaab4f2a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $d4d4a9f50423455c$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d4d4a9f50423455c$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d4d4a9f50423455c$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($d4d4a9f50423455c$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($d4d4a9f50423455c$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d4d4a9f50423455c$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d4d4a9f50423455c$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).delta = (0, $8c0ed17df19d7c2a$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).timestamp);
            (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).timestamp = now;
            (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).isProcessing = true;
            (0, $8e7cd14116eefbbb$export$be3f796aed065412).update.process((0, $8e7cd14116eefbbb$export$fff89137e9e818ce));
            (0, $8e7cd14116eefbbb$export$be3f796aed065412).preRender.process((0, $8e7cd14116eefbbb$export$fff89137e9e818ce));
            (0, $8e7cd14116eefbbb$export$be3f796aed065412).render.process((0, $8e7cd14116eefbbb$export$fff89137e9e818ce));
            (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($d4d4a9f50423455c$var$clearSnapshot);
            this.sharedNodes.forEach($d4d4a9f50423455c$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $f19f144286c96018$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $821faf0fc57e7e7a$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $c9d6e1e0900346b0$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d4d4a9f50423455c$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $f19f144286c96018$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $f19f144286c96018$export$6459fc9e86be362e)();
            (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $2935cacc4303edbd$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $f19f144286c96018$export$6459fc9e86be362e)();
            (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $2935cacc4303edbd$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $c9d6e1e0900346b0$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $2935cacc4303edbd$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $c9d6e1e0900346b0$export$a545127cf1fbb600)(this.latestValues)) (0, $2935cacc4303edbd$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $f19f144286c96018$export$6459fc9e86be362e)();
            (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $c9d6e1e0900346b0$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $c9d6e1e0900346b0$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $223ee03087c6b90d$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $c9d6e1e0900346b0$export$a545127cf1fbb600)(this.latestValues)) (0, $223ee03087c6b90d$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                    (0, $3eca2991868626a6$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $f19f144286c96018$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $3eca2991868626a6$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $2935cacc4303edbd$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                    (0, $3eca2991868626a6$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $d4d4a9f50423455c$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $c9d6e1e0900346b0$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $c9d6e1e0900346b0$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $8e7cd14116eefbbb$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $2935cacc4303edbd$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $f19f144286c96018$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $f19f144286c96018$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $f19f144286c96018$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $3eca2991868626a6$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $09b88d87be5130fb$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $d4d4a9f50423455c$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $f19f144286c96018$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $f19f144286c96018$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d4d4a9f50423455c$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d4d4a9f50423455c$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d4d4a9f50423455c$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $3eca2991868626a6$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d4d4a9f50423455c$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $821faf0fc57e7e7a$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                    (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $6a764734e05ba2ba$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(()=>{
                (0, $597f916ad13d6a6d$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $dd650ad9aec5d6c0$export$335a17c977067b99)(0, $d4d4a9f50423455c$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d4d4a9f50423455c$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d4d4a9f50423455c$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $f19f144286c96018$export$6459fc9e86be362e)();
                const xLength = (0, $3eca2991868626a6$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $3eca2991868626a6$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $0a0fcfc1b2657c89$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $2935cacc4303edbd$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $3eca2991868626a6$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $88001081c8bda114$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $d4d4a9f50423455c$var$transformAxes.length; i++){
                const key = "rotate" + $d4d4a9f50423455c$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $0b52e95251463d69$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $0b52e95251463d69$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $c9d6e1e0900346b0$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $09b88d87be5130fb$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $1ba5906becf00f74$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $1ba5906becf00f74$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $0b52e95251463d69$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d4d4a9f50423455c$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d4d4a9f50423455c$var$updateLayout(node) {
    node.updateLayout();
}
function $d4d4a9f50423455c$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $3eca2991868626a6$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d4d4a9f50423455c$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $3d22c9c0645cee99$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $3eca2991868626a6$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $f19f144286c96018$export$3d227df54007d73a)();
        (0, $3eca2991868626a6$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $f19f144286c96018$export$3d227df54007d73a)();
        if (isShared) (0, $3eca2991868626a6$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $3eca2991868626a6$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $821faf0fc57e7e7a$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                    (0, $3eca2991868626a6$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $f19f144286c96018$export$6459fc9e86be362e)();
                    (0, $3eca2991868626a6$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $821faf0fc57e7e7a$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d4d4a9f50423455c$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $d4d4a9f50423455c$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d4d4a9f50423455c$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d4d4a9f50423455c$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d4d4a9f50423455c$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d4d4a9f50423455c$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $d4d4a9f50423455c$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d4d4a9f50423455c$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $d4d4a9f50423455c$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d4d4a9f50423455c$var$calcProjection(node) {
    node.calcProjection();
}
function $d4d4a9f50423455c$var$resetRotation(node) {
    node.resetRotation();
}
function $d4d4a9f50423455c$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d4d4a9f50423455c$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d4d4a9f50423455c$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d4d4a9f50423455c$export$6ffd3e6ae339a132(output, from, to, p) {
    $d4d4a9f50423455c$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d4d4a9f50423455c$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d4d4a9f50423455c$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d4d4a9f50423455c$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $d4d4a9f50423455c$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $d4d4a9f50423455c$var$roundPoint = $d4d4a9f50423455c$var$userAgentContains("applewebkit/") && !$d4d4a9f50423455c$var$userAgentContains("chrome/") ? Math.round : (0, $96ab74a89bc7c563$export$8793edee2d425525);
function $d4d4a9f50423455c$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $d4d4a9f50423455c$var$roundPoint(axis.min);
    axis.max = $d4d4a9f50423455c$var$roundPoint(axis.max);
}
function $d4d4a9f50423455c$var$roundBox(box) {
    $d4d4a9f50423455c$var$roundAxis(box.x);
    $d4d4a9f50423455c$var$roundAxis(box.y);
}
function $d4d4a9f50423455c$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $3eca2991868626a6$export$28d0384c4b79bde2)((0, $821faf0fc57e7e7a$export$c5706146bc63213)(snapshot), (0, $821faf0fc57e7e7a$export$c5706146bc63213)(layout), 0.2);
}




const $8c1df4f1cbe384a4$export$2d029a49a09b6177 = (0, $d4d4a9f50423455c$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $e27424cad408cc9d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $65d88694b090b0ca$export$b91509fcf893b648 = {
    current: undefined
};
const $65d88694b090b0ca$export$b61a9eb3dbde8858 = (0, $d4d4a9f50423455c$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$65d88694b090b0ca$export$b91509fcf893b648.current) {
            const documentNode = new (0, $8c1df4f1cbe384a4$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $65d88694b090b0ca$export$b91509fcf893b648.current = documentNode;
        }
        return $65d88694b090b0ca$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $35ceaf494aa7ab7f$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $30c279eb49ca5ef3$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $8509466a9b4eb833$export$5d97dc2872682820),
        ProjectionNode: (0, $65d88694b090b0ca$export$b61a9eb3dbde8858),
        MeasureLayout: $f9ac4ccafc17b924$export$779f5fb01ad751cd
    }
};












/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $a0c95ab546fbf1b4$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $a0c95ab546fbf1b4$export$b9f0c1f373aee2b0(current) {
    const match = $a0c95ab546fbf1b4$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $a0c95ab546fbf1b4$var$maxDepth = 4;
function $a0c95ab546fbf1b4$var$getVariableValue(current, element, depth = 1) {
    (0, $30298752de581a70$export$f5708dca728d7177)(depth <= $a0c95ab546fbf1b4$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $a0c95ab546fbf1b4$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ((0, $017a916d7c7d6823$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $a0c95ab546fbf1b4$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $a0c95ab546fbf1b4$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $017a916d7c7d6823$export$31f9caa2600b5723)(current)) return;
        const resolved = $a0c95ab546fbf1b4$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $017a916d7c7d6823$export$31f9caa2600b5723)(current)) continue;
        const resolved = $a0c95ab546fbf1b4$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $c512a44b2820ee1d$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $c512a44b2820ee1d$var$isPositionalKey = (key)=>$c512a44b2820ee1d$var$positionalKeys.has(key);
const $c512a44b2820ee1d$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($c512a44b2820ee1d$var$isPositionalKey);
};
const $c512a44b2820ee1d$var$isNumOrPxType = (v)=>v === (0, $45e03c7d2655bcf8$export$98e628dec113755e) || v === (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008);
const $c512a44b2820ee1d$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $c512a44b2820ee1d$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $c512a44b2820ee1d$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $c512a44b2820ee1d$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $c512a44b2820ee1d$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $c512a44b2820ee1d$var$nonTranslationalTransformKeys = (0, $ed889dd17e65b750$export$280dc01950909d86).filter((key)=>!$c512a44b2820ee1d$var$transformKeys.has(key));
function $c512a44b2820ee1d$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $c512a44b2820ee1d$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $c512a44b2820ee1d$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $c512a44b2820ee1d$var$getTranslateFromMatrix(4, 13),
    y: $c512a44b2820ee1d$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$c512a44b2820ee1d$export$781d46a8aa670d52.translateX = $c512a44b2820ee1d$export$781d46a8aa670d52.x;
$c512a44b2820ee1d$export$781d46a8aa670d52.translateY = $c512a44b2820ee1d$export$781d46a8aa670d52.y;
const $c512a44b2820ee1d$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $c512a44b2820ee1d$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $c512a44b2820ee1d$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $c512a44b2820ee1d$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($c512a44b2820ee1d$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $7d5014e4f3423923$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $e3b59f1f412643dd$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $7d5014e4f3423923$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $7d5014e4f3423923$export$eefdd52e3ccae428)(to[i]);
                    (0, $30298752de581a70$export$f5708dca728d7177)(toType === fromType || $c512a44b2820ee1d$var$isNumOrPxType(fromType) && $c512a44b2820ee1d$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $30298752de581a70$export$f5708dca728d7177)((0, $7d5014e4f3423923$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $7d5014e4f3423923$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($c512a44b2820ee1d$var$isNumOrPxType(fromType) && $c512a44b2820ee1d$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $a08d8e53c3ef0aef$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $c512a44b2820ee1d$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $c512a44b2820ee1d$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $0d2249efd167eccf$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $c512a44b2820ee1d$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $c512a44b2820ee1d$var$hasPositionalKey(target) ? $c512a44b2820ee1d$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $c344d68ece16e572$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $a0c95ab546fbf1b4$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $c512a44b2820ee1d$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $e671c8c0cf744841$export$ff7706047246b98b = {
    current: null
};
const $e671c8c0cf744841$export$6476d16e2fd2d0db = {
    current: false
};


function $1e6bd770b9ac82d8$export$ca9f41fb23dded3d() {
    (0, $e671c8c0cf744841$export$6476d16e2fd2d0db).current = true;
    if (!(0, $0d2249efd167eccf$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $e671c8c0cf744841$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $e671c8c0cf744841$export$ff7706047246b98b).current = false;
}














function $1e4c3c7bb59ec713$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $8ef33fbe900edab6$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $efd4ea1cd2d913bc$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $8ef33fbe900edab6$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $efd4ea1cd2d913bc$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $d7ed75243a14bc0a$export$bc2a978a17abfdde = new WeakMap();



const $9cc88ec4fe95c36b$var$featureNames = Object.keys((0, $5440a2b5f580bf74$export$65570e08d843624d));
const $9cc88ec4fe95c36b$var$numFeatures = $9cc88ec4fe95c36b$var$featureNames.length;
const $9cc88ec4fe95c36b$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $9cc88ec4fe95c36b$var$numVariantProps = (0, $921392e203866556$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $9cc88ec4fe95c36b$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $8e7cd14116eefbbb$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $2384c2032528c821$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $2384c2032528c821$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $1a0ef3d59b00772c$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $8ef33fbe900edab6$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $d7ed75243a14bc0a$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $e671c8c0cf744841$export$6476d16e2fd2d0db).current) (0, $1e6bd770b9ac82d8$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $e671c8c0cf744841$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $d7ed75243a14bc0a$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ed889dd17e65b750$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $9cc88ec4fe95c36b$var$numFeatures; i++){
            const name = $9cc88ec4fe95c36b$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $5440a2b5f580bf74$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $8a65e6d1ff14311a$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $f19f144286c96018$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $9cc88ec4fe95c36b$var$propEventHandlers.length; i++){
            const key = $9cc88ec4fe95c36b$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $1e4c3c7bb59ec713$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $9cc88ec4fe95c36b$var$numVariantProps; i++){
            const name = (0, $921392e203866556$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $ff2b58769c7190e2$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $efd4ea1cd2d913bc$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $5e3507e00af8f9a9$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $1a0ef3d59b00772c$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $57bc7a6005435ddc$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $ff5a09661eee7244$export$e49735c2a366bdc7 extends (0, $9cc88ec4fe95c36b$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $f3d5c0f6e2d7b1e8$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $f3d5c0f6e2d7b1e8$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $c344d68ece16e572$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $37c15da893958d18$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $37c15da893958d18$export$23fea75b03ac16b3 extends (0, $ff5a09661eee7244$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $ed889dd17e65b750$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $bfe95f1661b06e97$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $37c15da893958d18$export$3735103072e4a80(instance);
            const value = ((0, $017a916d7c7d6823$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $f159b97852bd76e5$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $b0315c50a209627b$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a8cce55fadfe2714$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $7332f00dfb525394$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $acfbf925bfd99c10$export$86bcdffbaf733d84 extends (0, $ff5a09661eee7244$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ed889dd17e65b750$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $bfe95f1661b06e97$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $41d85b56b686a00d$export$28931db5d57958e5).has(key) ? (0, $0ae1983d28b655df$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $f19f144286c96018$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $e0664acc21d105f5$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $2843e1c4e472cf03$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $f5ec18fd7ddd660f$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $838d2f4fd7f91578$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $93b93dde1a2563e6$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $749992b660858c8c$export$88f3fc2fd3766989)(Component) ? new (0, $acfbf925bfd99c10$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $37c15da893958d18$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $bc2b9fd81c20ea7d$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $65d88694b090b0ca$export$b61a9eb3dbde8858),
        MeasureLayout: $f9ac4ccafc17b924$export$779f5fb01ad751cd
    }
};


const $0a9a7dc0535ece35$var$preloadedFeatures = {
    ...(0, $e67a0abf4f9f5536$export$7f9953c70dacfd7f),
    ...(0, $c349b91541cd6d66$export$e5b72898e5a201f1),
    ...(0, $35ceaf494aa7ab7f$export$d7d5d435647ed5a0),
    ...(0, $bc2b9fd81c20ea7d$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $0a9a7dc0535ece35$export$e25e478948902b8b = /*@__PURE__*/ (0, $f275755cb24413fd$export$a28d6df673050e18)((Component, config)=>(0, $c78a8f308c51272a$export$732916c0e88175fb)(Component, config, $0a9a7dc0535ece35$var$preloadedFeatures, (0, $93b93dde1a2563e6$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $0a9a7dc0535ece35$export$546614c4a05701f9(key) {
    return (0, $bc69a2cdb154a2f9$export$46b7e4b9dc6110c3)((0, $c78a8f308c51272a$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $0a9a7dc0535ece35$var$preloadedFeatures, (0, $93b93dde1a2563e6$export$56ba0183203348f5)));
}



var $lDSNw = parcelRequire("lDSNw");

"use client";
// ../../utilities/object-utils/src/omit.ts
function $55f5c4969dc36ab6$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
// ../../utilities/object-utils/src/pick.ts
function $55f5c4969dc36ab6$var$pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}
var $55f5c4969dc36ab6$var$MotionDiv = (0, $5c12d9132a121f51$export$7cd122d781af9fa4)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).div);
var $55f5c4969dc36ab6$export$28c660c63b792dea = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    var _a, _b;
    const styles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("Tooltip", props);
    const ownProps = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    const { children: children, label: label, shouldWrapChildren: shouldWrapChildren, "aria-label": ariaLabel, hasArrow: hasArrow, bg: bg, portalProps: portalProps, background: background, backgroundColor: backgroundColor, bgColor: bgColor, motionProps: motionProps, ...rest } = ownProps;
    const userDefinedBg = (_b = (_a = background != null ? background : backgroundColor) != null ? _a : bg) != null ? _b : bgColor;
    if (userDefinedBg) {
        styles.bg = userDefinedBg;
        const bgVar = (0, $01a983b3ad87bd07$export$93c8e06b7014dc33)(theme, "colors", userDefinedBg);
        styles[(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowBg.var] = bgVar;
    }
    const tooltip = (0, $25fbab3266844cb0$export$1c4b08e0eca38426)({
        ...rest,
        direction: theme.direction
    });
    const shouldWrap = typeof children === "string" || shouldWrapChildren;
    let trigger;
    if (shouldWrap) trigger = /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        display: "inline-block",
        tabIndex: 0,
        ...tooltip.getTriggerProps(),
        children: children
    });
    else {
        const child = (0, $lDSNw.Children).only(children);
        trigger = (0, $lDSNw.cloneElement)(child, tooltip.getTriggerProps(child.props, child.ref));
    }
    const hasAriaLabel = !!ariaLabel;
    const _tooltipProps = tooltip.getTooltipProps({}, ref);
    const tooltipProps = hasAriaLabel ? $55f5c4969dc36ab6$var$omit(_tooltipProps, [
        "role",
        "id"
    ]) : _tooltipProps;
    const srOnlyProps = $55f5c4969dc36ab6$var$pick(_tooltipProps, [
        "role",
        "id"
    ]);
    if (!label) return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: children
    });
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            trigger,
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0204198b5355405f$export$3ae376d12526dd6f), {
                children: tooltip.isOpen && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e51c5ae64f7cf3d3$export$602eac185826482c), {
                    ...portalProps,
                    children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                        ...tooltip.getTooltipPositionerProps(),
                        __css: {
                            zIndex: styles.zIndex,
                            pointerEvents: "none"
                        },
                        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)($55f5c4969dc36ab6$var$MotionDiv, {
                            variants: (0, $9bd342d3986c7d71$export$dcdf75081b88279d),
                            initial: "exit",
                            animate: "enter",
                            exit: "exit",
                            ...motionProps,
                            ...tooltipProps,
                            __css: styles,
                            children: [
                                label,
                                hasAriaLabel && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
                                    srOnly: true,
                                    ...srOnlyProps,
                                    children: ariaLabel
                                }),
                                hasArrow && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                                    "data-popper-arrow": true,
                                    className: "chakra-tooltip__arrow-wrapper",
                                    children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                                        "data-popper-arrow-inner": true,
                                        className: "chakra-tooltip__arrow",
                                        __css: {
                                            bg: styles.bg
                                        }
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
});
$55f5c4969dc36ab6$export$28c660c63b792dea.displayName = "Tooltip";




"use client";
var $faa28d8241353df1$export$fa82770841cc54a0 = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    displayName: "InfoOutlineIcon",
    path: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)("g", {
        fill: "currentColor",
        stroke: "currentColor",
        strokeLinecap: "square",
        strokeWidth: "2",
        children: [
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                fill: "none",
                r: "11",
                stroke: "currentColor"
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("line", {
                fill: "none",
                x1: "11.959",
                x2: "11.959",
                y1: "11",
                y2: "17"
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("circle", {
                cx: "11.959",
                cy: "7",
                r: "1",
                stroke: "none"
            })
        ]
    })
});


const $e6cc4722f36e6ae1$export$8332d5ac2ccf0d1e = ({ text: text, tooltipText: tooltipText, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        alignItems: "center",
        justifyContent: "center",
        ...rest,
        pt: "2",
        pb: "6",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "md",
                fontWeight: 500,
                children: text
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $55f5c4969dc36ab6$export$28c660c63b792dea), {
                label: tooltipText,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $faa28d8241353df1$export$fa82770841cc54a0), {
                    mx: 2,
                    boxSize: "15px",
                    color: "blackAlpha.500",
                    cursor: "pointer"
                })
            })
        ]
    });
};



const $81a2471855a1299c$var$normalizeBaselineAndActual = (incomingData, showBaseline, startProgress, endProgress)=>{
    const dataClone = [
        ...incomingData
    ].slice(startProgress, endProgress + 1);
    const sequenceMax = dataClone.reduce((prev, current)=>prev.playfulness > current.playfulness ? prev : current).playfulness;
    const sequenceMin = dataClone.reduce((prev, current)=>prev.playfulness < current.playfulness ? prev : current).playfulness;
    const playfulnessBMax = dataClone[0].playfulnessB ? dataClone.reduce((prev, current)=>prev.playfulnessB > current.playfulnessB ? prev : current).playfulnessB : 0;
    const playfulnessBMin = dataClone[0].playfulnessB ? dataClone.reduce((prev, current)=>prev.playfulness < current.playfulness ? prev : current).playfulnessB : 1;
    const baselineMax = dataClone.reduce((prev, current)=>prev.scrubBaseline > current.scrubBaseline ? prev : current).scrubBaseline;
    const baselineMin = dataClone.reduce((prev, current)=>prev.scrubBaseline < current.scrubBaseline ? prev : current).scrubBaseline;
    let max = Math.max(sequenceMax, baselineMax, playfulnessBMax);
    let min = Math.min(sequenceMin, baselineMin, playfulnessBMin);
    if (!showBaseline) {
        max = sequenceMax;
        min = sequenceMin;
    }
    const gap = max - min;
    return incomingData.map((value)=>{
        const newValue = {
            ...value
        };
        const normalizeThese = (initialObject, newObject, keys, gap, dataLength)=>{
            keys.forEach((key)=>{
                if (initialObject[key] >= min && initialObject[key] <= max) newObject[key] = (initialObject[key] - min) * (dataLength / gap);
                else if (initialObject[key] > max) newObject[key] = 100;
                else newObject[key] = 0;
            });
        };
        normalizeThese(value, newValue, [
            "playfulness",
            "playfulnessB",
            "scrubBaseline"
        ], gap, incomingData.length);
        return newValue;
    });
};
const $81a2471855a1299c$var$ScrubChart = ({ adProgress: adProgress, data: data, startProgress: startProgress, endProgress: endProgress, colors: colors, isABGraph: isABGraph = false, showBaseline: showBaseline = true, demoMode: demoMode, format: format, children: children })=>{
    const [chartData, setChartData] = (0, $lDSNw.useState)([]);
    (0, $lDSNw.useEffect)(()=>{
        if (!data.length) return;
        setChartData($81a2471855a1299c$var$normalizeBaselineAndActual(data, showBaseline, startProgress, endProgress, demoMode));
    }, [
        data
    ]);
    const queryParams = new URLSearchParams(location.search);
    // -----------------------------------------------------
    // should be in presentation mode?
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    // this is the URL param that is passed thorugh when gif-generator
    // is viewing the page to create a gif for the slide deck
    // -----------------------------------------------------
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e6cc4722f36e6ae1$export$8332d5ac2ccf0d1e), {
                text: "Scrub Engagement",
                visibility: isPresentationMode ? "hidden" : "visible",
                tooltipText: "We track when users pause, backtrack and play with the ad to understand which parts drive the most attention."
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                width: "100%",
                maxHeight: isPresentationMode ? "600px" : "32vh",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $141478e0e2068f7a$export$f510429275d6f1a8), {
                    data: chartData,
                    margin: isPresentationMode ? {
                        top: 40,
                        right: 0,
                        left: 0,
                        bottom: 80
                    } : {
                        top: 0,
                        right: 0,
                        left: 50,
                        bottom: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                            stroke: "#e8e8e8",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                            dataKey: "timeline",
                            type: "number",
                            tickLine: true,
                            domain: [
                                startProgress,
                                endProgress
                            ],
                            allowDataOverflow: true,
                            axisLine: false,
                            ticks: [
                                "Scroll in",
                                "Scroll out"
                            ],
                            hide: isPresentationMode
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                            axisLine: false,
                            tickLine: false,
                            hide: true
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "playfulness",
                            stroke: isABGraph ? colors[0] || "grey" : `url(#linear)`,
                            strokeWidth: 4,
                            fill: "rgba(255,255,255,0)",
                            isAnimationActive: false
                        }),
                        isABGraph && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "playfulnessB",
                            stroke: colors[1] || "grey",
                            strokeWidth: 4,
                            fill: "rgba(255,255,255,0)",
                            isAnimationActive: false
                        }),
                        showBaseline && !isABGraph ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "scrubBaseline",
                            stroke: "#c5c5c5",
                            strokeWidth: 2,
                            fillOpacity: 0.1,
                            fill: "#c5c5c5",
                            isAnimationActive: false
                        }) : null,
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                            x: Math.round(adProgress),
                            fill: "#000",
                            stroke: "rgba(0,0,0,0.15)",
                            strokeWidth: "4px",
                            isFront: true
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("linearGradient", {
                                id: "linear",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                        offset: "25%",
                                        stopColor: "#00CE7C"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "#4AC1E0"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $72ac3f8b3eb24366$export$4bae593ab138bf46), {
                display: isPresentationMode ? "none" : "flex"
            }),
            children,
            !isABGraph && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                w: "100%",
                justifyContent: "center",
                display: isPresentationMode ? "none" : "flex",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                    justifyContent: "space-evenly",
                    width: "400px",
                    padding: "16px 0px",
                    border: "1px solid",
                    borderColor: "blackAlpha.300",
                    borderRadius: "10px",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ae26d2322f4678ff$export$57579a683bdd41d1).Actual, {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ae26d2322f4678ff$export$57579a683bdd41d1).Baseline, {})
                    ]
                })
            }),
            isABGraph && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                w: "100%",
                justifyContent: "center",
                display: isPresentationMode ? "none" : "flex",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                    justifyContent: "space-evenly",
                    width: "400px",
                    padding: "16px 0px",
                    border: "1px solid",
                    borderColor: "blackAlpha.300",
                    borderRadius: "10px",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ae26d2322f4678ff$export$57579a683bdd41d1).Old, {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ae26d2322f4678ff$export$57579a683bdd41d1).New, {})
                    ]
                })
            })
        ]
    });
};
var $81a2471855a1299c$export$2e2bcd8739ae039 = $81a2471855a1299c$var$ScrubChart;




var $houiY = parcelRequire("houiY");

var $lDSNw = parcelRequire("lDSNw");
var $cf8480bef8315c4c$exports = {};

$parcel$export($cf8480bef8315c4c$exports, "actual", function () { return $cf8480bef8315c4c$export$f2bb41c35c9c6b13; }, function (v) { return $cf8480bef8315c4c$export$f2bb41c35c9c6b13 = v; });
$parcel$export($cf8480bef8315c4c$exports, "baseline", function () { return $cf8480bef8315c4c$export$baf5c2f62dd5cf3e; }, function (v) { return $cf8480bef8315c4c$export$baf5c2f62dd5cf3e = v; });
$parcel$export($cf8480bef8315c4c$exports, "dwellTime", function () { return $cf8480bef8315c4c$export$d374588d52786018; }, function (v) { return $cf8480bef8315c4c$export$d374588d52786018 = v; });
$parcel$export($cf8480bef8315c4c$exports, "graphContainer", function () { return $cf8480bef8315c4c$export$bec5028bc8f0dea4; }, function (v) { return $cf8480bef8315c4c$export$bec5028bc8f0dea4 = v; });
$parcel$export($cf8480bef8315c4c$exports, "graphParentContainer", function () { return $cf8480bef8315c4c$export$8c3fc9904ac2de19; }, function (v) { return $cf8480bef8315c4c$export$8c3fc9904ac2de19 = v; });
$parcel$export($cf8480bef8315c4c$exports, "legends", function () { return $cf8480bef8315c4c$export$33854e570d464ff0; }, function (v) { return $cf8480bef8315c4c$export$33854e570d464ff0 = v; });
$parcel$export($cf8480bef8315c4c$exports, "metricWrapper", function () { return $cf8480bef8315c4c$export$448cab58f842928; }, function (v) { return $cf8480bef8315c4c$export$448cab58f842928 = v; });
$parcel$export($cf8480bef8315c4c$exports, "scrub", function () { return $cf8480bef8315c4c$export$1b16ec8d157f41c5; }, function (v) { return $cf8480bef8315c4c$export$1b16ec8d157f41c5 = v; });
var $cf8480bef8315c4c$export$f2bb41c35c9c6b13;
var $cf8480bef8315c4c$export$baf5c2f62dd5cf3e;
var $cf8480bef8315c4c$export$d374588d52786018;
var $cf8480bef8315c4c$export$bec5028bc8f0dea4;
var $cf8480bef8315c4c$export$8c3fc9904ac2de19;
var $cf8480bef8315c4c$export$33854e570d464ff0;
var $cf8480bef8315c4c$export$448cab58f842928;
var $cf8480bef8315c4c$export$1b16ec8d157f41c5;
$cf8480bef8315c4c$export$f2bb41c35c9c6b13 = `-M0OLG_actual`;
$cf8480bef8315c4c$export$baf5c2f62dd5cf3e = `-M0OLG_baseline`;
$cf8480bef8315c4c$export$d374588d52786018 = `-M0OLG_dwellTime`;
$cf8480bef8315c4c$export$bec5028bc8f0dea4 = `-M0OLG_graphContainer`;
$cf8480bef8315c4c$export$8c3fc9904ac2de19 = `-M0OLG_graphParentContainer`;
$cf8480bef8315c4c$export$33854e570d464ff0 = `-M0OLG_legends`;
$cf8480bef8315c4c$export$448cab58f842928 = `-M0OLG_metricWrapper`;
$cf8480bef8315c4c$export$1b16ec8d157f41c5 = `-M0OLG_scrub`;


const $fa1fd01f2a4e7c6a$export$97dd871d2d20e798 = ({ creatives: creatives, colors: colors })=>{
    const startProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.startProgress);
    const endProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.endProgress);
    //const domainWhiteList = GUIStore((state) => state.domainWhiteList);
    const [sequenceData, setSequenceData] = (0, $lDSNw.useState)([]);
    const allSequencesLoaded = !!creatives.length && creatives.map(({ sequences: sequences })=>sequences).every((seq)=>seq !== null);
    const graphContainerRef = (0, $lDSNw.useRef)(null);
    // Sequence Data processing
    (0, $lDSNw.useEffect)(()=>{
        if (!allSequencesLoaded) return;
        const dataWithBaseline = creatives[0].sequences.map((data, i)=>{
            return {
                ...data,
                dwellTimeBaseline: // need to clean this up
                creatives[0].dwellTimeBaseline ? creatives[0].dwellTimeBaseline[i] : [],
                scrubBaseline: creatives[0].scrubBaseline ? creatives[0].scrubBaseline[i] : [],
                playfulnessB: creatives[1].sequences?.[i].playfulness ? creatives[1].sequences?.[i].playfulness : []
            };
        });
        setSequenceData(dataWithBaseline);
    }, [
        allSequencesLoaded,
        creatives
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($cf8480bef8315c4c$exports))).graphParentContainer,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf8480bef8315c4c$exports))).graphContainer,
            ref: graphContainerRef,
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $81a2471855a1299c$export$2e2bcd8739ae039), {
                adProgress: creatives[0]?.creativeScrollProgress,
                data: sequenceData,
                startProgress: startProgress,
                endProgress: endProgress,
                isABGraph: true,
                colors: colors,
                format: creatives[0]?.format
            })
        })
    });
};
$fa1fd01f2a4e7c6a$export$97dd871d2d20e798.propTypes = {
    buidIds: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string),
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).number
};




var $lDSNw = parcelRequire("lDSNw");




var $houiY = parcelRequire("houiY");


var $lDSNw = parcelRequire("lDSNw");
var $0a7f5b3a0089ee25$exports = {};

$0a7f5b3a0089ee25$exports = new URL((parcelRequire("5V6iE")).resolve("8H1v1"), import.meta.url).toString();


const $3f36e2e2c6807a5d$export$e8ba9bdc74afad99 = (mainFrameRef, headerColor)=>{
    // Get the iframe header and menu
    const iframeHeader = mainFrameRef.current.contentDocument.querySelector("header");
    const iframeHeaderMenu = mainFrameRef.current.contentDocument.querySelector(".header-menu");
    // Change the header color
    if (iframeHeader) iframeHeader.style = `
      transition: background-color 1s, background 1s;
      background: linear-gradient(0deg, ${headerColor} 60%, rgba(9,30,44,1) 350%)!important;
      margin-top: -1px; /* Fix the gap between the header and the iframe */
    `;
    // Hide the menu
    if (iframeHeaderMenu) iframeHeaderMenu.style = `
      transition: opacity 1s;
      opacity: 0;
    `;
};



function $2ac71661ebc4b3c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ac71661ebc4b3c3$var$IFRAME_DEFAULT_SCALE_FACTOR = 0.8;
const $2ac71661ebc4b3c3$var$PreviewerIFrame = /*#__PURE__*/ (0, $lDSNw.forwardRef)((props, ref)=>{
    const [scale, setScale] = (0, $lDSNw.useState)(0.8);
    const demoBuildIds = [
        "nikaya",
        "nayoyo"
    ]; //TODO: move
    const { preventUserScroll: preventUserScroll = false, creativeFormat: creativeFormat, showWrapper: showWrapper = true, heading: heading = null } = props;
    const wrapperRef = (0, $lDSNw.useRef)(); // for scaling
    const mainFrameRef = (0, $lDSNw.useRef)();
    const seamlessFrameRef = (0, $lDSNw.useRef)();
    const [animatedIn, setAnimatedIn] = (0, $lDSNw.useState)(false);
    (0, $lDSNw.useImperativeHandle)(ref, ()=>({
            mainFrame: mainFrameRef.current,
            animateIn: ()=>{
                if (!animatedIn && seamlessFrameRef.current) setAnimatedIn(()=>{
                    setTimeout(()=>{
                        seamlessFrameRef.current.contentWindow.scrollTo({
                            top: 1300,
                            behavior: "smooth"
                        });
                    }, 1000);
                    return true;
                });
            }
        }), [
        ref
    ]);
    const handleResize = ()=>{
        // get the iframes parent height
        const iframe = wrapperRef.current;
        const parentHeight = iframe?.parentElement?.clientHeight;
        if (!parentHeight) return;
        // set the default scale factor
        let scaleFactor = props.scale ?? $2ac71661ebc4b3c3$var$IFRAME_DEFAULT_SCALE_FACTOR;
        const containerWidth = document.getElementById("creative-viewer-container")?.clientWidth || window.innerWidth;
        // if the window is tall and thin, limit the scale of the iframe
        // to prevent it from being cropped
        const containerAspectRatio = containerWidth / window.innerHeight;
        if (containerAspectRatio < 1) {
            scaleFactor = Math.min(0.4, containerAspectRatio);
            console.log("scaleFactor", scaleFactor);
        }
        // if it's a presentation mode, make the iframe scale to full
        if (isPresentationMode) scaleFactor = 0.99; // 100% scale causes some weird issues
        setScale(parentHeight / 745 * scaleFactor);
    };
    const onIframeLoad = (e)=>{
        // change bg of header to match chart key color
        if (props.headerColor) // Recolors the menubar of the ad preview to match the header colour provided
        // used in AB tests so the user can visually link a preview to a line chart colour
        (0, $3f36e2e2c6807a5d$export$e8ba9bdc74afad99)(mainFrameRef, props.headerColor);
        if (props?.onAdProgress) {
            seamlessFrameRef.current = e.target;
            const seamlessFrame = seamlessFrameRef.current.contentDocument.getElementById("middle-ad").getElementsByTagName("iframe")[0];
            const format = (0, $f93c997b56f0c027$export$56b99a300be83d83)(seamlessFrame.contentWindow.xyzContext.dimension.creative.format);
            const getProgressRef = (format, mode)=>{
                if (seamlessFrame.contentWindow[format]) return seamlessFrame.contentWindow[format][mode];
                else return seamlessFrame.contentWindow.format[mode];
            };
            seamlessFrameRef.current.contentWindow.addEventListener("scroll", ()=>{
                props.onAdProgress(getProgressRef(format, props.scrollMode === "timeline" ? "timeline" : "progress"));
            });
        }
        if (props?.onLoadHandler) props.onLoadHandler(e);
        handleResize();
    };
    (0, $lDSNw.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const queryParams = new URLSearchParams(window.location.search);
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($2ac71661ebc4b3c3$var$IframeWrapper, {
        ref: wrapperRef,
        className: "iframe-wrapper",
        alignItems: isPresentationMode ? "flex-start" : "center",
        h: isPresentationMode ? "100vh" : "auto",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($2ac71661ebc4b3c3$var$DeviceFrame, {
                transform: `scale(${scale})`,
                children: [
                    heading && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: "0px",
                            width: "100%"
                        },
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                        as: "iframe",
                        ...$2ac71661ebc4b3c3$var$mobileIframeStyle,
                        title: "iframe",
                        ref: mainFrameRef,
                        pointerEvents: preventUserScroll ? "none" : "auto",
                        "data-xyz": "phone-wrapper",
                        srcDoc: props.srcDoc,
                        onLoad: (e)=>{
                            onIframeLoad(e);
                        }
                    })
                ]
            }),
            !demoBuildIds.includes(props.creativeID) && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($2ac71661ebc4b3c3$var$MetaContainer, {
                display: isPresentationMode ? "none" : "block",
                children: [
                    props.scriptVersion && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                        type: "body02",
                        children: [
                            " AdSDK Version: ",
                            props.scriptVersion
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                        type: "body02"
                    })
                ]
            })
        ]
    });
});
$2ac71661ebc4b3c3$var$PreviewerIFrame.propTypes = {
    srcDoc: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    creativeFormat: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    onLoadHandler: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func,
    scriptVersion: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    resetTransform: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    scrollMode: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    onAdProgress: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).func,
    creativeID: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string,
    preventUserScroll: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).bool,
    headerColor: (0, (/*@__PURE__*/$parcel$interopDefault($houiY))).string
};
const $2ac71661ebc4b3c3$var$IframeWrapper = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
    target: "eww34xs1"
})({
    name: "85tip",
    styles: "display:flex;flex-direction:column;justify-content:flex-start;width:100%"
});
const $2ac71661ebc4b3c3$var$mobileIframeStyle = {
    w: "100%",
    h: "auto",
    margin: "76px 26px 20px 24px",
    border: "none",
    borderRadius: "0px 0px 36px 36px",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.25) inset"
};
const $2ac71661ebc4b3c3$var$DeviceFrame = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($0a7f5b3a0089ee25$exports)))})`,
        width: "375px",
        height: "745px",
        transformOrigin: "top",
        alignItems: "stretch",
        transition: "transform 0.15s ease",
        justifyContent: "center",
        backgroundColor: "white",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        border: "none",
        borderRadius: "10px 10px 60px 60px",
        ...rest,
        children: children
    });
};
const $2ac71661ebc4b3c3$var$MetaContainer = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
    target: "eww34xs0"
})({
    name: "j2kwh0",
    styles: "position:absolute;bottom:var(--space-4);padding:var(--space-1) var(--space-2);border-radius:10px;z-index:10;opacity:0.7;text-align:center;position:fixed;& *{margin:0;line-height:1.25;}&:hover{opacity:1;}"
});
var $2ac71661ebc4b3c3$export$2e2bcd8739ae039 = $2ac71661ebc4b3c3$var$PreviewerIFrame;



var $91d5a7447996148c$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $91d5a7447996148c$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $91d5a7447996148c$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $91d5a7447996148c$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $91d5a7447996148c$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $91d5a7447996148c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $91d5a7447996148c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $91d5a7447996148c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $91d5a7447996148c$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $91d5a7447996148c$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $91d5a7447996148c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $91d5a7447996148c$var$root = $91d5a7447996148c$var$freeGlobal || $91d5a7447996148c$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $91d5a7447996148c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $91d5a7447996148c$var$objectToString = $91d5a7447996148c$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $91d5a7447996148c$var$nativeMax = Math.max, $91d5a7447996148c$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $91d5a7447996148c$var$now = function() {
    return $91d5a7447996148c$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $91d5a7447996148c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($91d5a7447996148c$var$FUNC_ERROR_TEXT);
    wait = $91d5a7447996148c$var$toNumber(wait) || 0;
    if ($91d5a7447996148c$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $91d5a7447996148c$var$nativeMax($91d5a7447996148c$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $91d5a7447996148c$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $91d5a7447996148c$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($91d5a7447996148c$var$now());
    }
    function debounced() {
        var time = $91d5a7447996148c$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $91d5a7447996148c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($91d5a7447996148c$var$FUNC_ERROR_TEXT);
    if ($91d5a7447996148c$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $91d5a7447996148c$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $91d5a7447996148c$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $91d5a7447996148c$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $91d5a7447996148c$var$isSymbol(value) {
    return typeof value == "symbol" || $91d5a7447996148c$var$isObjectLike(value) && $91d5a7447996148c$var$objectToString.call(value) == $91d5a7447996148c$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $91d5a7447996148c$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($91d5a7447996148c$var$isSymbol(value)) return $91d5a7447996148c$var$NAN;
    if ($91d5a7447996148c$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $91d5a7447996148c$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($91d5a7447996148c$var$reTrim, "");
    var isBinary = $91d5a7447996148c$var$reIsBinary.test(value);
    return isBinary || $91d5a7447996148c$var$reIsOctal.test(value) ? $91d5a7447996148c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $91d5a7447996148c$var$reIsBadHex.test(value) ? $91d5a7447996148c$var$NAN : +value;
}
$91d5a7447996148c$exports = $91d5a7447996148c$var$throttle;



const $f3f9ecb178a21bd0$export$acd6c212f68906c7 = /*#__PURE__*/ (0, $lDSNw.forwardRef)(({ buildId: buildId, format: format, iframeSrcDoc: iframeSrcDoc, scriptVersion: scriptVersion, scrollMode: scrollMode, i: i, color: color }, forwardRef)=>{
    const getCreative = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.get);
    const updateCreative = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.update);
    const getMetrics = (0, $d5dab4c422a78054$export$90856cc8b6bce002)((state)=>state.get);
    const metric = getMetrics(buildId);
    const attentionTime = metric?.attentionTime || null;
    const [scale, setScale] = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).useState(null);
    const handleResize = ()=>{
        const iframe = forwardRef[i].mainFrame;
        const parentWidth = iframe.parentElement.parentElement.offsetWidth;
        setScale(parentWidth / 400);
    };
    (0, $lDSNw.useEffect)(()=>{
        // if iframe scale hasn't been passed manually as a prop,
        // add an event listener to set it based on width of parent
        if (!scale) {
            window.addEventListener("resize", (0, (/*@__PURE__*/$parcel$interopDefault($91d5a7447996148c$exports)))(handleResize, 10));
            handleResize();
        }
    }, []);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2ac71661ebc4b3c3$export$2e2bcd8739ae039), {
        preventUserScroll: true,
        creativeFormat: getCreative(buildId)?.format,
        ref: (ref)=>{
            forwardRef[i] = ref;
            return forwardRef;
        },
        srcDoc: iframeSrcDoc,
        onAdProgress: (progress)=>updateCreative(buildId, {
                creativeScrollProgress: progress
            }),
        scriptVersion: scriptVersion,
        scrollMode: scrollMode,
        isLoading: !scrollMode,
        onLoadHandler: ()=>updateCreative(buildId, {
                iframeLoaded: true
            }),
        resetTransform: true,
        headerColor: color,
        sessionSize: getCreative(buildId)?.sessionSize,
        attentionTime: attentionTime?.toFixed(2),
        isAB: true,
        scale: scale
    }, i);
});


function $9d3ad9e33a6a34b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9d3ad9e33a6a34b3$export$d962f8021d62870f = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ebhhase4"
})({
    name: "1mvzxyt",
    styles: "display:flex;flex-direction:column;width:100%;min-height:100vh;padding-top:50px"
});
const $9d3ad9e33a6a34b3$export$7c4d2b536147788a = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ebhhase3"
})("display:flex;flex-direction:", ({ flexDirection: flexDirection })=>flexDirection || "row", ";margin:0 auto;width:100%;height:100%;max-width:var(--maxScreenWidth);max-height:calc(100vh - 110px);");
// --------------------------------
//
const $9d3ad9e33a6a34b3$var$MetricPanelContainer = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ebhhase2"
})({
    name: "1qsurv1",
    styles: "display:flex;flex-direction:row;width:100%;justify-content:space-between;gap:5%"
});
// --------------------------------
// Mobile formatted creative
const $9d3ad9e33a6a34b3$var$MobileSidePanel = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ebhhase1"
})({
    name: "f5q0ss",
    styles: "display:flex;flex-direction:column;overflow:hidden;padding:var(--space-4);height:100%;max-width:25%;max-height:45vw;::-webkit-scrollbar{display:none;}"
});
const $9d3ad9e33a6a34b3$var$MobileMiddlePanel = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ebhhase0"
})({
    name: "5gqwvf",
    styles: "display:flex;flex-direction:column;height:100%;border-right:1px solid var(--colors-neutral-4);border-left:1px solid var(--colors-neutral-4);overflow-y:scroll;padding:var(--space-4) var(--space-4) 10vh var(--space-4);::-webkit-scrollbar{display:none;}"
});
const $9d3ad9e33a6a34b3$export$18f23c8236927f2a = ({ creatives: creatives, wheelHandler: wheelHandler, metArray: metArray, previewerRefs: previewerRefs, keyColors: keyColors })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($9d3ad9e33a6a34b3$export$7c4d2b536147788a, {
        flexDirection: "row",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($9d3ad9e33a6a34b3$var$MobileSidePanel, {
                onWheel: wheelHandler,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f3f9ecb178a21bd0$export$acd6c212f68906c7), {
                    ...creatives[0],
                    i: 0,
                    ref: previewerRefs.current,
                    color: keyColors[0]
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($9d3ad9e33a6a34b3$var$MobileMiddlePanel, {
                onWheel: wheelHandler,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $fa1fd01f2a4e7c6a$export$97dd871d2d20e798), {
                    creatives: creatives,
                    colors: keyColors
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($9d3ad9e33a6a34b3$var$MobileSidePanel, {
                onWheel: wheelHandler,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f3f9ecb178a21bd0$export$acd6c212f68906c7), {
                    ...creatives[1],
                    i: 1,
                    ref: previewerRefs.current,
                    color: keyColors[1]
                })
            })
        ]
    });
};




parcelRequire("lDSNw");


function $ed9d7c0ede8e1182$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ed9d7c0ede8e1182$var$SubheadInner = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "en43ea82"
})({
    name: "15gsic5",
    styles: "display:flex;width:100%;gap:var(--space-3);max-width:var(--maxScreenWidth);padding:0 var(--space-4);margin:0 auto;flex-direction:row;align-items:center;justify-content:space-between"
});
const $ed9d7c0ede8e1182$var$RightContainer = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "en43ea81"
})({
    name: "8lnqkt",
    styles: "display:flex;align-items:center;gap:var(--space-2)"
});
const $ed9d7c0ede8e1182$var$Sessions = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "en43ea80"
})({
    name: "191fcxm",
    styles: "margin-right:var(--space-3);& *{white-space:nowrap;}"
});
const $ed9d7c0ede8e1182$export$82431628d8b8c126 = ({ sessionSize: sessionSize, minSessions: minSessions, title: title, children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        w: "100%",
        minH: "50px",
        borderBottom: "1px solid var(--colors-neutral-4)",
        ...rest,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ed9d7c0ede8e1182$var$SubheadInner, {
            children: [
                title,
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($ed9d7c0ede8e1182$var$RightContainer, {
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ed9d7c0ede8e1182$var$Sessions, {
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                                type: "body01",
                                as: "span",
                                style: {
                                    whiteSpace: "nowrap"
                                },
                                children: sessionSize && `Sessions: ${sessionSize} / ${minSessions}`
                            })
                        }),
                        children
                    ]
                })
            ]
        })
    });
};



const $6fe29ede4c487ba5$var$keyColors = [
    "#C5C5C5",
    "#4AC1E0"
];
const $6fe29ede4c487ba5$export$c31b32036292dca5 = (props)=>{
    const creatives = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.items);
    const addCreatives = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.create);
    const loadCreativeSequences = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.loadCreativeSequences);
    const cleanUp = (0, $765e87d18dbf9ea1$export$e4710db0108d3739)((state)=>state.cleanUp);
    const metArray = (0, $d5dab4c422a78054$export$90856cc8b6bce002)((state)=>state.items);
    const addMetrics = (0, $d5dab4c422a78054$export$90856cc8b6bce002)((state)=>state.create);
    const fetchMetrics = (0, $d5dab4c422a78054$export$90856cc8b6bce002)((state)=>state.fetchMetrics);
    const minSequenceLength = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.minSequenceLength);
    const triggerType = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.triggerType);
    const domainWhiteList = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.domainWhiteList);
    const [scrubbed, setscrubbed] = (0, $lDSNw.useState)(false);
    const previewerRefs = (0, $lDSNw.useRef)([]);
    const SnackBarAlert = (0, $0b21e37f51b583f7$export$19dbccc67153f737)((0, $86896944c76a0602$export$b7063aba2b72bcec));
    // LIFE CYCLE EVENTS
    (0, $lDSNw.useEffect)(()=>{
        if (!!props.match.params.creativeID && !!props.match.params.creativeID2) {
            const buildIds = [
                props.match.params.creativeID,
                props.match.params.creativeID2
            ];
            addCreatives([
                ...buildIds
            ]);
            addMetrics([
                ...buildIds
            ]);
            // Analytic view events
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).creativeViewed(buildIds[0], true);
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).creativeViewed(buildIds[1], true);
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).abtestViewed([
                ...buildIds
            ]);
        }
    }, [
        props.match.params.creativeID,
        props.match.params.creativeID2
    ]);
    // load sequences
    (0, $lDSNw.useEffect)(()=>{
        if (creatives.every(({ sequences: sequences })=>sequences === null)) loadCreativeSequences(minSequenceLength, triggerType);
    }, [
        creatives,
        minSequenceLength,
        triggerType
    ]);
    (0, $lDSNw.useEffect)(()=>{
        creatives.forEach(({ buildId: buildId })=>{
            fetchMetrics(buildId, domainWhiteList);
        });
        loadCreativeSequences(minSequenceLength, triggerType, domainWhiteList);
    }, [
        domainWhiteList
    ]);
    (0, $lDSNw.useEffect)(()=>{
        return cleanUp;
    }, []);
    //animate in trigger
    (0, $lDSNw.useEffect)(()=>{
        if (creatives.length === 2) {
            previewerRefs.current.forEach((previewRef)=>{
                previewRef.animateIn();
            });
            // test loaded
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).abtestLoaded([
                creatives[0].buildId,
                creatives[1].buildId
            ]);
        }
    }, [
        creatives.length > 0 && creatives.map(({ iframeLoaded: iframeLoaded })=>iframeLoaded).every((val)=>val === true)
    ]);
    const wheelHandler = (e)=>{
        if (previewerRefs.current.length < 2) return;
        // probably a better way to do, throattle wasn't working for me
        if (!scrubbed) {
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).abtestScrubed([
                creatives[0].buildId,
                creatives[1].buildId
            ]);
            setscrubbed(true);
        }
        creatives.forEach((p, i)=>{
            const ref = previewerRefs.current[i].mainFrame;
            const iframeScrollPosition = ref.contentWindow.scrollY;
            const newScrollPosition = iframeScrollPosition + e.deltaY;
            ref.contentWindow.scrollTo(0, newScrollPosition);
        });
    };
    // alerts and errors
    const zeroMetricError = metArray?.[0]?.attentionTime === 0 || metArray?.[1]?.attentionTime === 0;
    const formatIsntHangtimeError = (creatives[0]?.format && creatives[0]?.format, creatives[1]?.format && (creatives[1]?.format, false));
    const creativeHasVideoError = !!creatives[0]?.videoSequences && Object.keys(creatives[0]?.videoSequences).length > 0 || !!creatives[1]?.videoSequences && Object.keys(creatives[1]?.videoSequences).length > 0;
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $9d3ad9e33a6a34b3$export$d962f8021d62870f), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ed9d7c0ede8e1182$export$82431628d8b8c126), {
                title: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                    as: "span",
                    type: "body2",
                    children: [
                        "AB Test \xa0",
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $21f7d76a059ae835$export$a6c7ac8248d6e38a), {
                            title: "Preview this ad in a new tab",
                            maxWidth: "200px",
                            target: "_blank",
                            href: (0, $f93c997b56f0c027$export$621e425396705b25)(creatives[0]?.buildId, creatives[0]?.format),
                            children: creatives[0]?.creativeNames || ""
                        }),
                        creatives[0]?.creativeNames && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
                            children: " vs "
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $21f7d76a059ae835$export$a6c7ac8248d6e38a), {
                            title: "Preview this ad in a new tab",
                            maxWidth: "200px",
                            target: "_blank",
                            href: (0, $f93c997b56f0c027$export$621e425396705b25)(creatives[1]?.buildId, creatives[1]?.format),
                            children: creatives[1]?.creativeNames || ""
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $df098d69721f4386$export$2e2bcd8739ae039), {
                    description: "Share a link to this AB test",
                    content: "Share",
                    url: window.location.href
                })
            }),
            creatives.length === 2 && creatives[0]?.format ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $9d3ad9e33a6a34b3$export$18f23c8236927f2a), {
                creatives: creatives,
                wheelHandler: wheelHandler,
                metArray: metArray,
                previewerRefs: previewerRefs,
                keyColors: $6fe29ede4c487ba5$var$keyColors
            }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6d34caa3f6c24444$export$e854a2165401836f), {
                size: "s"
            }),
            props.loggedIn && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $dd799f14f0ed3f88$export$30eb518a543288d4), {}),
            zeroMetricError && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(SnackBarAlert, {
                title: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
                    children: "We're having some issues fetching the metrics for this AB test. Sorry! Please check back a little later."
                }),
                status: "warning"
            }),
            formatIsntHangtimeError && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(SnackBarAlert, {
                title: "This ad format isn't supported yet in AB Tests. Please stick to hangtime ads for now.",
                status: "warning"
            }),
            creativeHasVideoError && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(SnackBarAlert, {
                title: "Creatives with video aren't really supported in AB Tests yet, so take the results with a grain of salt.",
                delayToClose: 8000,
                status: "warning"
            })
        ]
    });
};




var $lDSNw = parcelRequire("lDSNw");




parcelRequire("lDSNw");
var $a7865f9d1e13993b$exports = {};

$parcel$export($a7865f9d1e13993b$exports, "lds-ellipsis1", function () { return $a7865f9d1e13993b$export$dc4fb3704f078e18; }, function (v) { return $a7865f9d1e13993b$export$dc4fb3704f078e18 = v; });
$parcel$export($a7865f9d1e13993b$exports, "lds-ellipsis2", function () { return $a7865f9d1e13993b$export$4ebe1ab2f28b4d49; }, function (v) { return $a7865f9d1e13993b$export$4ebe1ab2f28b4d49 = v; });
$parcel$export($a7865f9d1e13993b$exports, "lds-ellipsis3", function () { return $a7865f9d1e13993b$export$f1cc0963ce95f124; }, function (v) { return $a7865f9d1e13993b$export$f1cc0963ce95f124 = v; });
$parcel$export($a7865f9d1e13993b$exports, "loading", function () { return $a7865f9d1e13993b$export$46c1c92549715335; }, function (v) { return $a7865f9d1e13993b$export$46c1c92549715335 = v; });
var $a7865f9d1e13993b$export$dc4fb3704f078e18;
var $a7865f9d1e13993b$export$4ebe1ab2f28b4d49;
var $a7865f9d1e13993b$export$f1cc0963ce95f124;
var $a7865f9d1e13993b$export$46c1c92549715335;
$a7865f9d1e13993b$export$dc4fb3704f078e18 = `_6D-nAW_lds-ellipsis1`;
$a7865f9d1e13993b$export$dc4fb3704f078e18;
$a7865f9d1e13993b$export$4ebe1ab2f28b4d49 = `_6D-nAW_lds-ellipsis2`;
$a7865f9d1e13993b$export$4ebe1ab2f28b4d49;
$a7865f9d1e13993b$export$f1cc0963ce95f124 = `_6D-nAW_lds-ellipsis3`;
$a7865f9d1e13993b$export$f1cc0963ce95f124;
$a7865f9d1e13993b$export$46c1c92549715335 = `_6D-nAW_loading`;


const $642bd4537957c1d1$var$LoadingBar = ()=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a7865f9d1e13993b$exports))).loading,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {})
            ]
        })
    });
};
var $642bd4537957c1d1$export$2e2bcd8739ae039 = $642bd4537957c1d1$var$LoadingBar;


var $78add6abf8d3eeaa$exports = {};

$parcel$export($78add6abf8d3eeaa$exports, "campaign", function () { return $78add6abf8d3eeaa$export$b98c010fcdebc6be; }, function (v) { return $78add6abf8d3eeaa$export$b98c010fcdebc6be = v; });
$parcel$export($78add6abf8d3eeaa$exports, "catrouselSelector", function () { return $78add6abf8d3eeaa$export$d58fb5b5964bad35; }, function (v) { return $78add6abf8d3eeaa$export$d58fb5b5964bad35 = v; });
$parcel$export($78add6abf8d3eeaa$exports, "creativeContainer", function () { return $78add6abf8d3eeaa$export$8ffd18fef0fff809; }, function (v) { return $78add6abf8d3eeaa$export$8ffd18fef0fff809 = v; });
$parcel$export($78add6abf8d3eeaa$exports, "creativeName", function () { return $78add6abf8d3eeaa$export$c40cac144e837928; }, function (v) { return $78add6abf8d3eeaa$export$c40cac144e837928 = v; });
$parcel$export($78add6abf8d3eeaa$exports, "creativeWrapper", function () { return $78add6abf8d3eeaa$export$cd88ae4f7e630b0a; }, function (v) { return $78add6abf8d3eeaa$export$cd88ae4f7e630b0a = v; });
var $78add6abf8d3eeaa$export$b98c010fcdebc6be;
var $78add6abf8d3eeaa$export$d58fb5b5964bad35;
var $78add6abf8d3eeaa$export$8ffd18fef0fff809;
var $78add6abf8d3eeaa$export$c40cac144e837928;
var $78add6abf8d3eeaa$export$cd88ae4f7e630b0a;
$78add6abf8d3eeaa$export$b98c010fcdebc6be = `eW-DEG_campaign`;
$78add6abf8d3eeaa$export$d58fb5b5964bad35 = `eW-DEG_catrouselSelector`;
$78add6abf8d3eeaa$export$8ffd18fef0fff809 = `eW-DEG_creativeContainer`;
$78add6abf8d3eeaa$export$c40cac144e837928 = `eW-DEG_creativeName`;
$78add6abf8d3eeaa$export$cd88ae4f7e630b0a = `eW-DEG_creativeWrapper`;



const $21a80a5e84121fae$var$CATRouselSelector = ()=>{
    const demoCreativeIDs = [
        "lawaso",
        "topane"
    ]; // manually stopping some test data from displaying
    const [catrouselCreatives, setCatrouselCreatives] = (0, $lDSNw.useState)([]);
    const [creatives, loadingCreatives, errorCreatives] = (0, $d5c35a4573de93de$export$b806f8b31e648973)((0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT-Rousel"));
    if (errorCreatives) console.error(errorCreatives);
    if (!loadingCreatives) console.log(creatives.docs);
    (0, $lDSNw.useEffect)(()=>{
        if (!loadingCreatives && creatives) {
            let allCreatives = [];
            creatives.docs.map(async (creativeDoc, index)=>{
                const creativeData = creativeDoc.data();
                if (creativeData.campaigns) {
                    creativeData.id = creativeDoc.id;
                    allCreatives.push(creativeData);
                } else if (!demoCreativeIDs.includes(creativeDoc.id)) {
                    getCampaignName(creativeDoc.id, creativeData);
                    creativeData.id = creativeDoc.id;
                    creativeData.campaigns = "";
                    creativeData.creatives = "";
                    creativeData.brands = "";
                    creativeData.verticals = "";
                    allCreatives.push(creativeData);
                }
            });
            setCatrouselCreatives(allCreatives);
        }
    }, [
        creatives,
        loadingCreatives,
        errorCreatives
    ]);
    const getCampaignName = (creativeID, creativeData)=>{
        (0, $defc3f76c7e5931b$export$f5417e9be50ddb9b)(creativeID).then((data)=>{
            let campaignNames = "";
            let creativeNames = "";
            let brandNames = "";
            let brandVerticals = [];
            if (data && !data.errors) {
                data.playground.campaigns.forEach((campaign)=>{
                    campaignNames += " " + campaign.name;
                });
                data.playground.creatives.forEach((creative)=>{
                    creativeNames += " " + creative.name;
                });
                data.playground.brands.forEach((brand)=>{
                    brandNames += " " + brand.name;
                    brandVerticals.push(brand.vertical);
                });
                (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT-Rousel").doc(creativeID).update({
                    campaigns: campaignNames,
                    creatives: creativeNames,
                    brands: brandNames,
                    verticals: brandVerticals
                }, {
                    merge: true
                });
            }
        }).catch((error)=>console.log(error));
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($78add6abf8d3eeaa$exports))).catrouselSelector,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($78add6abf8d3eeaa$exports))).creativeContainer,
            children: !loadingCreatives ? catrouselCreatives.map((creativeDoc, index)=>{
                return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $3ee3b72d91cbc81c$export$a6c7ac8248d6e38a), {
                    to: `/catrousel/${creativeDoc.id}`,
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($78add6abf8d3eeaa$exports))).creativeWrapper,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($78add6abf8d3eeaa$exports))).campaign,
                                children: [
                                    creativeDoc.brands,
                                    " - ",
                                    creativeDoc.campaigns
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
                                src: `http://metababy.playground.xyz/${creativeDoc.id}/400x400/hang-time/small-thumbnail`,
                                alt: creativeDoc.id
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("p", {
                                children: [
                                    "Creative ID: ",
                                    creativeDoc.id
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($78add6abf8d3eeaa$exports))).creativeName,
                                children: creativeDoc.creatives
                            })
                        ]
                    })
                }, creativeDoc.id);
            }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $642bd4537957c1d1$export$2e2bcd8739ae039), {})
        })
    });
};
var $21a80a5e84121fae$export$2e2bcd8739ae039 = $21a80a5e84121fae$var$CATRouselSelector;







var $lDSNw = parcelRequire("lDSNw");








var $lDSNw = parcelRequire("lDSNw");
function $0537f2a037169a3d$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $0537f2a037169a3d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0537f2a037169a3d$export$2e2bcd8739ae039(obj);
}



function $f781f6bd6376231c$export$2e2bcd8739ae039(input, hint) {
    if ((0, $0537f2a037169a3d$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $0537f2a037169a3d$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $e0c241408d4ff741$export$2e2bcd8739ae039(arg) {
    var key = (0, $f781f6bd6376231c$export$2e2bcd8739ae039)(arg, "string");
    return (0, $0537f2a037169a3d$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $eeb121c6867ae1fe$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $e0c241408d4ff741$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $bdde4b1c202df3e9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bdde4b1c202df3e9$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bdde4b1c202df3e9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bdde4b1c202df3e9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function $33a340fa235c14e9$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8711b91e19e897d7$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $b4b3a1f29562493e$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $71b7a83391865d08$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $b4b3a1f29562493e$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $b4b3a1f29562493e$export$2e2bcd8739ae039)(o, minLen);
}


function $e67eb5f9953b403a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $9ea381ad8ba4870c$export$2e2bcd8739ae039(arr, i) {
    return (0, $33a340fa235c14e9$export$2e2bcd8739ae039)(arr) || (0, $8711b91e19e897d7$export$2e2bcd8739ae039)(arr, i) || (0, $71b7a83391865d08$export$2e2bcd8739ae039)(arr, i) || (0, $e67eb5f9953b403a$export$2e2bcd8739ae039)();
}



function $92b932a9010e733e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $e357090fb59eb644$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $lDSNw = parcelRequire("lDSNw");
var $b2cf16ebe44f9041$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $b2cf16ebe44f9041$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $b2cf16ebe44f9041$var$_excluded);
    var _useState = (0, $lDSNw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $lDSNw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $lDSNw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $lDSNw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $lDSNw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $lDSNw.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $lDSNw.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $lDSNw = parcelRequire("lDSNw");


function $13600594d241a5f3$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $d582913ea91ca96d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $e0c241408d4ff741$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $d582913ea91ca96d$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $d582913ea91ca96d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d582913ea91ca96d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $e478241f0c67c862$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $aa0c8fc10b49674f$export$2e2bcd8739ae039)(subClass, superClass);
}


function $fbac09773847b98c$export$2e2bcd8739ae039(o) {
    $fbac09773847b98c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fbac09773847b98c$export$2e2bcd8739ae039(o);
}


function $f2d0ddc5deac0c66$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $faa75fb0eaf5b80f$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $23b2f2ca2dfb18f4$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $0537f2a037169a3d$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $faa75fb0eaf5b80f$export$2e2bcd8739ae039)(self);
}


function $e4e44fec2fa4313d$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $f2d0ddc5deac0c66$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $fbac09773847b98c$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $fbac09773847b98c$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $23b2f2ca2dfb18f4$export$2e2bcd8739ae039)(this, result);
    };
}



function $aa1aed4648756a06$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $b4b3a1f29562493e$export$2e2bcd8739ae039)(arr);
}


function $1981fa5e4edd75a9$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $0ec76d2635685e29$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $fe96c4cfaf321b89$export$2e2bcd8739ae039(arr) {
    return (0, $aa1aed4648756a06$export$2e2bcd8739ae039)(arr) || (0, $1981fa5e4edd75a9$export$2e2bcd8739ae039)(arr) || (0, $71b7a83391865d08$export$2e2bcd8739ae039)(arr) || (0, $0ec76d2635685e29$export$2e2bcd8739ae039)();
}



var $lDSNw = parcelRequire("lDSNw");






function $b2d90021a6dce772$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $lDSNw = parcelRequire("lDSNw");

var $ef4Zh = parcelRequire("ef4Zh");
const $60a12f55b0e6f717$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $60a12f55b0e6f717$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $60a12f55b0e6f717$export$803cd8101b6c182b = /*#__PURE__*/ $60a12f55b0e6f717$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $60a12f55b0e6f717$export$27b07d8a310ed8b5[0], side + "-" + $60a12f55b0e6f717$export$27b07d8a310ed8b5[1]), []);
const $60a12f55b0e6f717$export$96ec731ed4dcb222 = Math.min;
const $60a12f55b0e6f717$export$8960430cfd85939f = Math.max;
const $60a12f55b0e6f717$export$2077e0241d6afd3c = Math.round;
const $60a12f55b0e6f717$export$a3fe094919f356fd = Math.floor;
const $60a12f55b0e6f717$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $60a12f55b0e6f717$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $60a12f55b0e6f717$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $60a12f55b0e6f717$export$7d15b64cf5a3a4c4(start, value, end) {
    return $60a12f55b0e6f717$export$8960430cfd85939f(start, $60a12f55b0e6f717$export$96ec731ed4dcb222(value, end));
}
function $60a12f55b0e6f717$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $60a12f55b0e6f717$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $60a12f55b0e6f717$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $60a12f55b0e6f717$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $60a12f55b0e6f717$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $60a12f55b0e6f717$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($60a12f55b0e6f717$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $60a12f55b0e6f717$export$2b57e0052a6d6d4c(placement) {
    return $60a12f55b0e6f717$export$8a000a963141ac32($60a12f55b0e6f717$export$f28e8f882010718a(placement));
}
function $60a12f55b0e6f717$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $60a12f55b0e6f717$export$f0989780f32bfcda(placement);
    const alignmentAxis = $60a12f55b0e6f717$export$2b57e0052a6d6d4c(placement);
    const length = $60a12f55b0e6f717$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $60a12f55b0e6f717$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $60a12f55b0e6f717$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $60a12f55b0e6f717$export$496432a3699e50b1(placement) {
    const oppositePlacement = $60a12f55b0e6f717$export$9c5e28bad23365fa(placement);
    return [
        $60a12f55b0e6f717$export$2b182c584985588b(placement),
        oppositePlacement,
        $60a12f55b0e6f717$export$2b182c584985588b(oppositePlacement)
    ];
}
function $60a12f55b0e6f717$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$60a12f55b0e6f717$var$oppositeAlignmentMap[alignment]);
}
function $60a12f55b0e6f717$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $60a12f55b0e6f717$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $60a12f55b0e6f717$export$f0989780f32bfcda(placement);
    let list = $60a12f55b0e6f717$var$getSideList($60a12f55b0e6f717$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($60a12f55b0e6f717$export$2b182c584985588b));
    }
    return list;
}
function $60a12f55b0e6f717$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$60a12f55b0e6f717$var$oppositeSideMap[side]);
}
function $60a12f55b0e6f717$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $60a12f55b0e6f717$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $60a12f55b0e6f717$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $60a12f55b0e6f717$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $fd448fb8a64b5575$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $60a12f55b0e6f717$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $60a12f55b0e6f717$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $60a12f55b0e6f717$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $60a12f55b0e6f717$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $fd448fb8a64b5575$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $fd448fb8a64b5575$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $fd448fb8a64b5575$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $fd448fb8a64b5575$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $60a12f55b0e6f717$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $60a12f55b0e6f717$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $60a12f55b0e6f717$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $fd448fb8a64b5575$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $60a12f55b0e6f717$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $60a12f55b0e6f717$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $60a12f55b0e6f717$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $60a12f55b0e6f717$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = (0, $60a12f55b0e6f717$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? min$1 - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset + alignmentOffset
                }
            };
        }
    });
function $fd448fb8a64b5575$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $60a12f55b0e6f717$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $60a12f55b0e6f717$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $60a12f55b0e6f717$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $60a12f55b0e6f717$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $fd448fb8a64b5575$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $60a12f55b0e6f717$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $60a12f55b0e6f717$export$803cd8101b6c182b) ? $fd448fb8a64b5575$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $fd448fb8a64b5575$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $60a12f55b0e6f717$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $60a12f55b0e6f717$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $60a12f55b0e6f717$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $fd448fb8a64b5575$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
            const side = (0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $60a12f55b0e6f717$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $60a12f55b0e6f717$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $60a12f55b0e6f717$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $fd448fb8a64b5575$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $60a12f55b0e6f717$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $fd448fb8a64b5575$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $fd448fb8a64b5575$var$isAnySideFullyClipped(overflow) {
    return (0, $60a12f55b0e6f717$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $fd448fb8a64b5575$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $fd448fb8a64b5575$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $fd448fb8a64b5575$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $fd448fb8a64b5575$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $fd448fb8a64b5575$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $fd448fb8a64b5575$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $fd448fb8a64b5575$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $fd448fb8a64b5575$var$getBoundingRect(rects) {
    const minX = (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $fd448fb8a64b5575$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $60a12f55b0e6f717$export$ee05aea0aeecbad4)($fd448fb8a64b5575$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $fd448fb8a64b5575$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $fd448fb8a64b5575$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $60a12f55b0e6f717$export$ee05aea0aeecbad4)($fd448fb8a64b5575$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $60a12f55b0e6f717$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $60a12f55b0e6f717$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $fd448fb8a64b5575$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $60a12f55b0e6f717$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $60a12f55b0e6f717$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $fd448fb8a64b5575$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $fd448fb8a64b5575$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $fd448fb8a64b5575$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $fd448fb8a64b5575$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $60a12f55b0e6f717$export$f28e8f882010718a)((0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $60a12f55b0e6f717$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $60a12f55b0e6f717$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $60a12f55b0e6f717$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $fd448fb8a64b5575$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $60a12f55b0e6f717$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $60a12f55b0e6f717$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $fd448fb8a64b5575$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $60a12f55b0e6f717$export$fef61f332f2c0afc)(options, state);
            const overflow = await $fd448fb8a64b5575$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $60a12f55b0e6f717$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $60a12f55b0e6f717$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $60a12f55b0e6f717$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $60a12f55b0e6f717$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $60a12f55b0e6f717$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $059496737e6a753a$export$651544f548703224(node) {
    if ($059496737e6a753a$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $059496737e6a753a$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $059496737e6a753a$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($059496737e6a753a$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $059496737e6a753a$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $059496737e6a753a$export$38b2d434cce3ea22(value).Node;
}
function $059496737e6a753a$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $059496737e6a753a$export$38b2d434cce3ea22(value).Element;
}
function $059496737e6a753a$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $059496737e6a753a$export$38b2d434cce3ea22(value).HTMLElement;
}
function $059496737e6a753a$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $059496737e6a753a$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $059496737e6a753a$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $059496737e6a753a$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $059496737e6a753a$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($059496737e6a753a$export$651544f548703224(element));
}
function $059496737e6a753a$export$d6c4e8150c35fed1(element) {
    const webkit = $059496737e6a753a$export$78551043582a6a98();
    const css = $059496737e6a753a$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $059496737e6a753a$export$940d8225183e1404(element) {
    let currentNode = $059496737e6a753a$export$4e12058fc4d51d56(element);
    while($059496737e6a753a$export$1b3bfaa9684536aa(currentNode) && !$059496737e6a753a$export$d1162fb0b6d4cd51(currentNode)){
        if ($059496737e6a753a$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $059496737e6a753a$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $059496737e6a753a$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $059496737e6a753a$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($059496737e6a753a$export$651544f548703224(node));
}
function $059496737e6a753a$export$3735103072e4a80(element) {
    return $059496737e6a753a$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $059496737e6a753a$export$dc8fc79fa2800137(element) {
    if ($059496737e6a753a$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $059496737e6a753a$export$4e12058fc4d51d56(node) {
    if ($059496737e6a753a$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $059496737e6a753a$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $059496737e6a753a$export$e495491855dc5418(node);
    return $059496737e6a753a$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $059496737e6a753a$export$7cd01a57c8ca906c(node) {
    const parentNode = $059496737e6a753a$export$4e12058fc4d51d56(node);
    if ($059496737e6a753a$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($059496737e6a753a$export$1b3bfaa9684536aa(parentNode) && $059496737e6a753a$export$989e911fa9af580a(parentNode)) return parentNode;
    return $059496737e6a753a$export$7cd01a57c8ca906c(parentNode);
}
function $059496737e6a753a$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    const scrollableAncestor = $059496737e6a753a$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $059496737e6a753a$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $059496737e6a753a$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $059496737e6a753a$export$3b57c1601291186b(scrollableAncestor));
}


function $69793dd0b3b21fcc$var$getCssDimensions(element) {
    const css = (0, $059496737e6a753a$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $059496737e6a753a$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $60a12f55b0e6f717$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $60a12f55b0e6f717$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $69793dd0b3b21fcc$var$unwrapElement(element) {
    return !(0, $059496737e6a753a$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $69793dd0b3b21fcc$var$getScale(element) {
    const domElement = $69793dd0b3b21fcc$var$unwrapElement(element);
    if (!(0, $059496737e6a753a$export$1b3bfaa9684536aa)(domElement)) return (0, $60a12f55b0e6f717$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $69793dd0b3b21fcc$var$getCssDimensions(domElement);
    let x = ($ ? (0, $60a12f55b0e6f717$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $60a12f55b0e6f717$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $69793dd0b3b21fcc$var$noOffsets = /*#__PURE__*/ (0, $60a12f55b0e6f717$export$a397704b5e280835)(0);
function $69793dd0b3b21fcc$var$getVisualOffsets(element) {
    const win = (0, $059496737e6a753a$export$38b2d434cce3ea22)(element);
    if (!(0, $059496737e6a753a$export$78551043582a6a98)() || !win.visualViewport) return $69793dd0b3b21fcc$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $69793dd0b3b21fcc$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $059496737e6a753a$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $69793dd0b3b21fcc$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $69793dd0b3b21fcc$var$unwrapElement(element);
    let scale = (0, $60a12f55b0e6f717$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $059496737e6a753a$export$45a5e7f76e0caa8d)(offsetParent)) scale = $69793dd0b3b21fcc$var$getScale(offsetParent);
        } else scale = $69793dd0b3b21fcc$var$getScale(element);
    }
    const visualOffsets = $69793dd0b3b21fcc$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $69793dd0b3b21fcc$var$getVisualOffsets(domElement) : (0, $60a12f55b0e6f717$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $059496737e6a753a$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $059496737e6a753a$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $059496737e6a753a$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $69793dd0b3b21fcc$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $059496737e6a753a$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $059496737e6a753a$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $60a12f55b0e6f717$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $69793dd0b3b21fcc$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $059496737e6a753a$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $059496737e6a753a$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $60a12f55b0e6f717$export$a397704b5e280835)(1);
    const offsets = (0, $60a12f55b0e6f717$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $059496737e6a753a$export$651544f548703224)(offsetParent) !== "body" || (0, $059496737e6a753a$export$989e911fa9af580a)(documentElement)) scroll = (0, $059496737e6a753a$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $059496737e6a753a$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $69793dd0b3b21fcc$var$getBoundingClientRect(offsetParent);
            scale = $69793dd0b3b21fcc$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $69793dd0b3b21fcc$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $69793dd0b3b21fcc$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $69793dd0b3b21fcc$var$getBoundingClientRect((0, $059496737e6a753a$export$e495491855dc5418)(element)).left + (0, $059496737e6a753a$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $69793dd0b3b21fcc$var$getDocumentRect(element) {
    const html = (0, $059496737e6a753a$export$e495491855dc5418)(element);
    const scroll = (0, $059496737e6a753a$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $69793dd0b3b21fcc$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $059496737e6a753a$export$3735103072e4a80)(body).direction === "rtl") x += (0, $60a12f55b0e6f717$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $69793dd0b3b21fcc$var$getViewportRect(element, strategy) {
    const win = (0, $059496737e6a753a$export$38b2d434cce3ea22)(element);
    const html = (0, $059496737e6a753a$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $059496737e6a753a$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $69793dd0b3b21fcc$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $69793dd0b3b21fcc$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $059496737e6a753a$export$1b3bfaa9684536aa)(element) ? $69793dd0b3b21fcc$var$getScale(element) : (0, $60a12f55b0e6f717$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $69793dd0b3b21fcc$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $69793dd0b3b21fcc$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $69793dd0b3b21fcc$var$getDocumentRect((0, $059496737e6a753a$export$e495491855dc5418)(element));
    else if ((0, $059496737e6a753a$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $69793dd0b3b21fcc$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $69793dd0b3b21fcc$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $60a12f55b0e6f717$export$ee05aea0aeecbad4)(rect);
}
function $69793dd0b3b21fcc$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $059496737e6a753a$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $059496737e6a753a$export$45a5e7f76e0caa8d)(parentNode) || (0, $059496737e6a753a$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $059496737e6a753a$export$3735103072e4a80)(parentNode).position === "fixed" || $69793dd0b3b21fcc$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $69793dd0b3b21fcc$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $059496737e6a753a$export$3b57c1601291186b)(element).filter((el)=>(0, $059496737e6a753a$export$45a5e7f76e0caa8d)(el) && (0, $059496737e6a753a$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $059496737e6a753a$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $059496737e6a753a$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $059496737e6a753a$export$45a5e7f76e0caa8d)(currentNode) && !(0, $059496737e6a753a$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $059496737e6a753a$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $059496737e6a753a$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $059496737e6a753a$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $69793dd0b3b21fcc$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $059496737e6a753a$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $69793dd0b3b21fcc$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $69793dd0b3b21fcc$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $69793dd0b3b21fcc$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $60a12f55b0e6f717$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $69793dd0b3b21fcc$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $69793dd0b3b21fcc$var$getDimensions(element) {
    return $69793dd0b3b21fcc$var$getCssDimensions(element);
}
function $69793dd0b3b21fcc$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $059496737e6a753a$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $059496737e6a753a$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $69793dd0b3b21fcc$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $60a12f55b0e6f717$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $059496737e6a753a$export$651544f548703224)(offsetParent) !== "body" || (0, $059496737e6a753a$export$989e911fa9af580a)(documentElement)) scroll = (0, $059496737e6a753a$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $69793dd0b3b21fcc$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $69793dd0b3b21fcc$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $69793dd0b3b21fcc$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $059496737e6a753a$export$1b3bfaa9684536aa)(element) || (0, $059496737e6a753a$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $69793dd0b3b21fcc$var$getOffsetParent(element, polyfill) {
    const window = (0, $059496737e6a753a$export$38b2d434cce3ea22)(element);
    if (!(0, $059496737e6a753a$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $69793dd0b3b21fcc$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $059496737e6a753a$export$71535ffaa902797f)(offsetParent) && (0, $059496737e6a753a$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $69793dd0b3b21fcc$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $059496737e6a753a$export$651544f548703224)(offsetParent) === "html" || (0, $059496737e6a753a$export$651544f548703224)(offsetParent) === "body" && (0, $059496737e6a753a$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $059496737e6a753a$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $059496737e6a753a$export$940d8225183e1404)(element) || window;
}
const $69793dd0b3b21fcc$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $69793dd0b3b21fcc$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $69793dd0b3b21fcc$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $69793dd0b3b21fcc$var$isRTL(element) {
    return (0, $059496737e6a753a$export$3735103072e4a80)(element).direction === "rtl";
}
const $69793dd0b3b21fcc$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $69793dd0b3b21fcc$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $059496737e6a753a$export$e495491855dc5418,
    getClippingRect: $69793dd0b3b21fcc$var$getClippingRect,
    getOffsetParent: $69793dd0b3b21fcc$var$getOffsetParent,
    getElementRects: $69793dd0b3b21fcc$var$getElementRects,
    getClientRects: $69793dd0b3b21fcc$var$getClientRects,
    getDimensions: $69793dd0b3b21fcc$var$getDimensions,
    getScale: $69793dd0b3b21fcc$var$getScale,
    isElement: $059496737e6a753a$export$45a5e7f76e0caa8d,
    isRTL: $69793dd0b3b21fcc$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $69793dd0b3b21fcc$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $059496737e6a753a$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $60a12f55b0e6f717$export$a3fe094919f356fd)(top);
        const insetRight = (0, $60a12f55b0e6f717$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $60a12f55b0e6f717$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $60a12f55b0e6f717$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $60a12f55b0e6f717$export$8960430cfd85939f)(0, (0, $60a12f55b0e6f717$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $69793dd0b3b21fcc$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $69793dd0b3b21fcc$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $059496737e6a753a$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $059496737e6a753a$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $69793dd0b3b21fcc$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $69793dd0b3b21fcc$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $69793dd0b3b21fcc$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $69793dd0b3b21fcc$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $69793dd0b3b21fcc$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $fd448fb8a64b5575$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $lDSNw = parcelRequire("lDSNw");
var $e063c96a1d8f564a$var$index = (0, $lDSNw.useLayoutEffect);
var $e063c96a1d8f564a$export$2e2bcd8739ae039 = $e063c96a1d8f564a$var$index;


var $167f833695fdfb3b$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $167f833695fdfb3b$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $167f833695fdfb3b$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $167f833695fdfb3b$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($167f833695fdfb3b$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $167f833695fdfb3b$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($167f833695fdfb3b$var$isArray(value)) return value.filter(Boolean);
    if ((0, $0537f2a037169a3d$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $167f833695fdfb3b$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(props, $167f833695fdfb3b$var$_excluded$4);
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $167f833695fdfb3b$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $167f833695fdfb3b$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $167f833695fdfb3b$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $167f833695fdfb3b$var$normalizedHeight(el) {
    if ($167f833695fdfb3b$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $167f833695fdfb3b$var$getScrollTop(el) {
    if ($167f833695fdfb3b$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $167f833695fdfb3b$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($167f833695fdfb3b$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $167f833695fdfb3b$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $167f833695fdfb3b$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $167f833695fdfb3b$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $167f833695fdfb3b$export$b4171a6734a65d42;
    var start = $167f833695fdfb3b$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $167f833695fdfb3b$var$easeOutCubic(currentTime, start, change, duration);
        $167f833695fdfb3b$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $167f833695fdfb3b$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $167f833695fdfb3b$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $167f833695fdfb3b$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $167f833695fdfb3b$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $167f833695fdfb3b$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $167f833695fdfb3b$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $167f833695fdfb3b$var$passiveOptionAccessed = false;
var $167f833695fdfb3b$var$options = {
    get passive () {
        return $167f833695fdfb3b$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $167f833695fdfb3b$var$w = typeof window !== "undefined" ? window : {};
if ($167f833695fdfb3b$var$w.addEventListener && $167f833695fdfb3b$var$w.removeEventListener) {
    $167f833695fdfb3b$var$w.addEventListener("p", $167f833695fdfb3b$export$b4171a6734a65d42, $167f833695fdfb3b$var$options);
    $167f833695fdfb3b$var$w.removeEventListener("p", $167f833695fdfb3b$export$b4171a6734a65d42, false);
}
var $167f833695fdfb3b$export$2408f22a0fab9ae5 = $167f833695fdfb3b$var$passiveOptionAccessed;
function $167f833695fdfb3b$export$3466f893ebf79586(item) {
    return item != null;
}
function $167f833695fdfb3b$var$isArray(arg) {
    return Array.isArray(arg);
}
function $167f833695fdfb3b$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $167f833695fdfb3b$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $167f833695fdfb3b$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $167f833695fdfb3b$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $167f833695fdfb3b$var$_excluded$3 = [
    "children",
    "innerProps"
], $167f833695fdfb3b$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $167f833695fdfb3b$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $167f833695fdfb3b$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $167f833695fdfb3b$var$normalizedHeight(scrollParent);
    var scrollTop = $167f833695fdfb3b$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $167f833695fdfb3b$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $167f833695fdfb3b$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $167f833695fdfb3b$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $167f833695fdfb3b$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $167f833695fdfb3b$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $167f833695fdfb3b$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $167f833695fdfb3b$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $167f833695fdfb3b$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, $167f833695fdfb3b$var$alignToControl(placement), "100%"), (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $167f833695fdfb3b$var$PortalPlacementContext = /*#__PURE__*/ (0, $lDSNw.createContext)(null);
// NOTE: internal only
var $167f833695fdfb3b$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $lDSNw.useContext)($167f833695fdfb3b$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $lDSNw.useRef)(null);
    var _useState = (0, $lDSNw.useState)(maxMenuHeight), _useState2 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $lDSNw.useState)(null), _useState4 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e063c96a1d8f564a$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $167f833695fdfb3b$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $167f833695fdfb3b$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $167f833695fdfb3b$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $167f833695fdfb3b$var$Menu$1 = $167f833695fdfb3b$var$Menu;
// ==============================
// Menu List
// ==============================
var $167f833695fdfb3b$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $167f833695fdfb3b$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $167f833695fdfb3b$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $167f833695fdfb3b$export$3b14a55fb2447963 = $167f833695fdfb3b$var$noticeCSS;
var $167f833695fdfb3b$export$342063e11d6c3cad = $167f833695fdfb3b$var$noticeCSS;
var $167f833695fdfb3b$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref6, $167f833695fdfb3b$var$_excluded$3);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $167f833695fdfb3b$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref7, $167f833695fdfb3b$var$_excluded2$1);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $167f833695fdfb3b$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $167f833695fdfb3b$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $lDSNw.useRef)(null);
    var cleanupRef = (0, $lDSNw.useRef)(null);
    var _useState5 = (0, $lDSNw.useState)($167f833695fdfb3b$var$coercePlacement(menuPlacement)), _useState6 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $lDSNw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $lDSNw.useState)(null), _useState8 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $lDSNw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $167f833695fdfb3b$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e063c96a1d8f564a$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $lDSNw.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $69793dd0b3b21fcc$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e063c96a1d8f564a$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $lDSNw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $167f833695fdfb3b$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $ef4Zh.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $167f833695fdfb3b$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $167f833695fdfb3b$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $167f833695fdfb3b$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $167f833695fdfb3b$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $167f833695fdfb3b$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $167f833695fdfb3b$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $167f833695fdfb3b$var$_templateObject;
var $167f833695fdfb3b$var$_excluded$2 = [
    "size"
], $167f833695fdfb3b$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $167f833695fdfb3b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $167f833695fdfb3b$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $167f833695fdfb3b$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $167f833695fdfb3b$var$_excluded$2);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("svg", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $167f833695fdfb3b$var$_ref2
    }, props));
};
var $167f833695fdfb3b$var$CrossIcon = function CrossIcon(props) {
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$Svg, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $167f833695fdfb3b$var$DownChevron = function DownChevron(props) {
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$Svg, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $167f833695fdfb3b$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $167f833695fdfb3b$export$f1e1789686576879 = $167f833695fdfb3b$var$baseCSS;
var $167f833695fdfb3b$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$DownChevron, null));
};
var $167f833695fdfb3b$export$407448d2b89b1813 = $167f833695fdfb3b$var$baseCSS;
var $167f833695fdfb3b$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $167f833695fdfb3b$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $167f833695fdfb3b$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, innerProps, $167f833695fdfb3b$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $167f833695fdfb3b$var$loadingDotAnimations = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)($167f833695fdfb3b$var$_templateObject || ($167f833695fdfb3b$var$_templateObject = (0, $b2d90021a6dce772$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $167f833695fdfb3b$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $167f833695fdfb3b$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $8c971e9544ccda33$export$dbf350e5966cf602)({
            animation: "".concat($167f833695fdfb3b$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $167f833695fdfb3b$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref7, $167f833695fdfb3b$var$_excluded2);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $167f833695fdfb3b$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $167f833695fdfb3b$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $167f833695fdfb3b$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps), children);
};
var $167f833695fdfb3b$var$Control$1 = $167f833695fdfb3b$var$Control;
var $167f833695fdfb3b$var$_excluded$1 = [
    "data"
];
var $167f833695fdfb3b$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $167f833695fdfb3b$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Heading, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", null, children));
};
var $167f833695fdfb3b$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $167f833695fdfb3b$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $167f833695fdfb3b$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_cleanCommonProps, $167f833695fdfb3b$var$_excluded$1);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $167f833695fdfb3b$var$Group$1 = $167f833695fdfb3b$var$Group;
var $167f833695fdfb3b$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $167f833695fdfb3b$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $167f833695fdfb3b$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $167f833695fdfb3b$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $167f833695fdfb3b$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $167f833695fdfb3b$var$spacingStyle)
};
var $167f833695fdfb3b$var$inputStyle = function inputStyle(isHidden) {
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $167f833695fdfb3b$var$spacingStyle);
};
var $167f833695fdfb3b$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $167f833695fdfb3b$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_cleanCommonProps, $167f833695fdfb3b$var$_excluded);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("input", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $167f833695fdfb3b$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $167f833695fdfb3b$var$Input$1 = $167f833695fdfb3b$var$Input;
var $167f833695fdfb3b$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $167f833695fdfb3b$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $167f833695fdfb3b$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $167f833695fdfb3b$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $167f833695fdfb3b$var$MultiValueContainer = $167f833695fdfb3b$var$MultiValueGeneric;
var $167f833695fdfb3b$var$MultiValueLabel = $167f833695fdfb3b$var$MultiValueGeneric;
function $167f833695fdfb3b$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($167f833695fdfb3b$var$CrossIcon, {
        size: 14
    }));
}
var $167f833695fdfb3b$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $167f833695fdfb3b$var$MultiValue$1 = $167f833695fdfb3b$var$MultiValue;
var $167f833695fdfb3b$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $167f833695fdfb3b$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $167f833695fdfb3b$var$Option$1 = $167f833695fdfb3b$var$Option;
var $167f833695fdfb3b$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $167f833695fdfb3b$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $167f833695fdfb3b$var$Placeholder$1 = $167f833695fdfb3b$var$Placeholder;
var $167f833695fdfb3b$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $167f833695fdfb3b$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $167f833695fdfb3b$var$SingleValue$1 = $167f833695fdfb3b$var$SingleValue;
var $167f833695fdfb3b$export$db3b6bfb95261072 = {
    ClearIndicator: $167f833695fdfb3b$var$ClearIndicator,
    Control: $167f833695fdfb3b$var$Control$1,
    DropdownIndicator: $167f833695fdfb3b$var$DropdownIndicator,
    DownChevron: $167f833695fdfb3b$var$DownChevron,
    CrossIcon: $167f833695fdfb3b$var$CrossIcon,
    Group: $167f833695fdfb3b$var$Group$1,
    GroupHeading: $167f833695fdfb3b$var$GroupHeading,
    IndicatorsContainer: $167f833695fdfb3b$var$IndicatorsContainer,
    IndicatorSeparator: $167f833695fdfb3b$var$IndicatorSeparator,
    Input: $167f833695fdfb3b$var$Input$1,
    LoadingIndicator: $167f833695fdfb3b$var$LoadingIndicator,
    Menu: $167f833695fdfb3b$var$Menu$1,
    MenuList: $167f833695fdfb3b$var$MenuList,
    MenuPortal: $167f833695fdfb3b$var$MenuPortal,
    LoadingMessage: $167f833695fdfb3b$var$LoadingMessage,
    NoOptionsMessage: $167f833695fdfb3b$var$NoOptionsMessage,
    MultiValue: $167f833695fdfb3b$var$MultiValue$1,
    MultiValueContainer: $167f833695fdfb3b$var$MultiValueContainer,
    MultiValueLabel: $167f833695fdfb3b$var$MultiValueLabel,
    MultiValueRemove: $167f833695fdfb3b$var$MultiValueRemove,
    Option: $167f833695fdfb3b$var$Option$1,
    Placeholder: $167f833695fdfb3b$var$Placeholder$1,
    SelectContainer: $167f833695fdfb3b$var$SelectContainer,
    SingleValue: $167f833695fdfb3b$var$SingleValue$1,
    ValueContainer: $167f833695fdfb3b$var$ValueContainer
};
var $167f833695fdfb3b$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $167f833695fdfb3b$export$db3b6bfb95261072), props.components);
};



var $b416a8bfe9e12ed9$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $b416a8bfe9e12ed9$var$isEqual(first, second) {
    if (first === second) return true;
    if ($b416a8bfe9e12ed9$var$safeIsNaN(first) && $b416a8bfe9e12ed9$var$safeIsNaN(second)) return true;
    return false;
}
function $b416a8bfe9e12ed9$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$b416a8bfe9e12ed9$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $b416a8bfe9e12ed9$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $b416a8bfe9e12ed9$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $81a3a23b6ce0f763$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $81a3a23b6ce0f763$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $81a3a23b6ce0f763$var$A11yText = function A11yText(props) {
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        css: $81a3a23b6ce0f763$var$_ref
    }, props));
};
var $81a3a23b6ce0f763$var$A11yText$1 = $81a3a23b6ce0f763$var$A11yText;
var $81a3a23b6ce0f763$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $81a3a23b6ce0f763$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $lDSNw.useMemo)(function() {
        return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $81a3a23b6ce0f763$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $lDSNw.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $lDSNw.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $lDSNw.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $lDSNw.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)((0, $lDSNw.Fragment), null, (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)((0, $lDSNw.Fragment), null, (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($81a3a23b6ce0f763$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($81a3a23b6ce0f763$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $81a3a23b6ce0f763$var$LiveRegion$1 = $81a3a23b6ce0f763$var$LiveRegion;
var $81a3a23b6ce0f763$var$diacritics = [
    {
        base: "A",
        letters: "AⒶＡ\xc0\xc1\xc2ẦẤẪẨ\xc3ĀĂẰẮẴẲȦǠ\xc4ǞẢ\xc5ǺǍȀȂẠẬẶḀĄȺⱯ"
    },
    {
        base: "AA",
        letters: "Ꜳ"
    },
    {
        base: "AE",
        letters: "\xc6ǼǢ"
    },
    {
        base: "AO",
        letters: "Ꜵ"
    },
    {
        base: "AU",
        letters: "Ꜷ"
    },
    {
        base: "AV",
        letters: "ꜸꜺ"
    },
    {
        base: "AY",
        letters: "Ꜽ"
    },
    {
        base: "B",
        letters: "BⒷＢḂḄḆɃƂƁ"
    },
    {
        base: "C",
        letters: "CⒸＣĆĈĊČ\xc7ḈƇȻꜾ"
    },
    {
        base: "D",
        letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
    },
    {
        base: "DZ",
        letters: "ǱǄ"
    },
    {
        base: "Dz",
        letters: "ǲǅ"
    },
    {
        base: "E",
        letters: "EⒺＥ\xc8\xc9\xcaỀẾỄỂẼĒḔḖĔĖ\xcbẺĚȄȆẸỆȨḜĘḘḚƐƎ"
    },
    {
        base: "F",
        letters: "FⒻＦḞƑꝻ"
    },
    {
        base: "G",
        letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
    },
    {
        base: "H",
        letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
    },
    {
        base: "I",
        letters: "IⒾＩ\xcc\xcd\xceĨĪĬİ\xcfḮỈǏȈȊỊĮḬƗ"
    },
    {
        base: "J",
        letters: "JⒿＪĴɈ"
    },
    {
        base: "K",
        letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
    },
    {
        base: "L",
        letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
    },
    {
        base: "LJ",
        letters: "Ǉ"
    },
    {
        base: "Lj",
        letters: "ǈ"
    },
    {
        base: "M",
        letters: "MⓂＭḾṀṂⱮƜ"
    },
    {
        base: "N",
        letters: "NⓃＮǸŃ\xd1ṄŇṆŅṊṈȠƝꞐꞤ"
    },
    {
        base: "NJ",
        letters: "Ǌ"
    },
    {
        base: "Nj",
        letters: "ǋ"
    },
    {
        base: "O",
        letters: "OⓄＯ\xd2\xd3\xd4ỒỐỖỔ\xd5ṌȬṎŌṐṒŎȮȰ\xd6ȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬ\xd8ǾƆƟꝊꝌ"
    },
    {
        base: "OI",
        letters: "Ƣ"
    },
    {
        base: "OO",
        letters: "Ꝏ"
    },
    {
        base: "OU",
        letters: "Ȣ"
    },
    {
        base: "P",
        letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
    },
    {
        base: "Q",
        letters: "QⓆＱꝖꝘɊ"
    },
    {
        base: "R",
        letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
    },
    {
        base: "S",
        letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
    },
    {
        base: "T",
        letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
    },
    {
        base: "TZ",
        letters: "Ꜩ"
    },
    {
        base: "U",
        letters: "UⓊＵ\xd9\xda\xdbŨṸŪṺŬ\xdcǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
    },
    {
        base: "V",
        letters: "VⓋＶṼṾƲꝞɅ"
    },
    {
        base: "VY",
        letters: "Ꝡ"
    },
    {
        base: "W",
        letters: "WⓌＷẀẂŴẆẄẈⱲ"
    },
    {
        base: "X",
        letters: "XⓍＸẊẌ"
    },
    {
        base: "Y",
        letters: "YⓎＹỲ\xddŶỸȲẎŸỶỴƳɎỾ"
    },
    {
        base: "Z",
        letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
    },
    {
        base: "a",
        letters: "aⓐａẚ\xe0\xe1\xe2ầấẫẩ\xe3āăằắẵẳȧǡ\xe4ǟả\xe5ǻǎȁȃạậặḁąⱥɐ"
    },
    {
        base: "aa",
        letters: "ꜳ"
    },
    {
        base: "ae",
        letters: "\xe6ǽǣ"
    },
    {
        base: "ao",
        letters: "ꜵ"
    },
    {
        base: "au",
        letters: "ꜷ"
    },
    {
        base: "av",
        letters: "ꜹꜻ"
    },
    {
        base: "ay",
        letters: "ꜽ"
    },
    {
        base: "b",
        letters: "bⓑｂḃḅḇƀƃɓ"
    },
    {
        base: "c",
        letters: "cⓒｃćĉċč\xe7ḉƈȼꜿↄ"
    },
    {
        base: "d",
        letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
    },
    {
        base: "dz",
        letters: "ǳǆ"
    },
    {
        base: "e",
        letters: "eⓔｅ\xe8\xe9\xeaềếễểẽēḕḗĕė\xebẻěȅȇẹệȩḝęḙḛɇɛǝ"
    },
    {
        base: "f",
        letters: "fⓕｆḟƒꝼ"
    },
    {
        base: "g",
        letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
    },
    {
        base: "h",
        letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
    },
    {
        base: "hv",
        letters: "ƕ"
    },
    {
        base: "i",
        letters: "iⓘｉ\xec\xed\xeeĩīĭ\xefḯỉǐȉȋịįḭɨı"
    },
    {
        base: "j",
        letters: "jⓙｊĵǰɉ"
    },
    {
        base: "k",
        letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
    },
    {
        base: "l",
        letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
    },
    {
        base: "lj",
        letters: "ǉ"
    },
    {
        base: "m",
        letters: "mⓜｍḿṁṃɱɯ"
    },
    {
        base: "n",
        letters: "nⓝｎǹń\xf1ṅňṇņṋṉƞɲŉꞑꞥ"
    },
    {
        base: "nj",
        letters: "ǌ"
    },
    {
        base: "o",
        letters: "oⓞｏ\xf2\xf3\xf4ồốỗổ\xf5ṍȭṏōṑṓŏȯȱ\xf6ȫỏőǒȍȏơờớỡởợọộǫǭ\xf8ǿɔꝋꝍɵ"
    },
    {
        base: "oi",
        letters: "ƣ"
    },
    {
        base: "ou",
        letters: "ȣ"
    },
    {
        base: "oo",
        letters: "ꝏ"
    },
    {
        base: "p",
        letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
    },
    {
        base: "q",
        letters: "qⓠｑɋꝗꝙ"
    },
    {
        base: "r",
        letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
    },
    {
        base: "s",
        letters: "sⓢｓ\xdfśṥŝṡšṧṣṩșşȿꞩꞅẛ"
    },
    {
        base: "t",
        letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
    },
    {
        base: "tz",
        letters: "ꜩ"
    },
    {
        base: "u",
        letters: "uⓤｕ\xf9\xfa\xfbũṹūṻŭ\xfcǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
    },
    {
        base: "v",
        letters: "vⓥｖṽṿʋꝟʌ"
    },
    {
        base: "vy",
        letters: "ꝡ"
    },
    {
        base: "w",
        letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
    },
    {
        base: "x",
        letters: "xⓧｘẋẍ"
    },
    {
        base: "y",
        letters: "yⓨｙỳ\xfdŷỹȳẏ\xffỷẙỵƴɏỿ"
    },
    {
        base: "z",
        letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
    }
];
var $81a3a23b6ce0f763$var$anyDiacritic = new RegExp("[" + $81a3a23b6ce0f763$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $81a3a23b6ce0f763$var$diacriticToBase = {};
for(var $81a3a23b6ce0f763$var$i = 0; $81a3a23b6ce0f763$var$i < $81a3a23b6ce0f763$var$diacritics.length; $81a3a23b6ce0f763$var$i++){
    var $81a3a23b6ce0f763$var$diacritic = $81a3a23b6ce0f763$var$diacritics[$81a3a23b6ce0f763$var$i];
    for(var $81a3a23b6ce0f763$var$j = 0; $81a3a23b6ce0f763$var$j < $81a3a23b6ce0f763$var$diacritic.letters.length; $81a3a23b6ce0f763$var$j++)$81a3a23b6ce0f763$var$diacriticToBase[$81a3a23b6ce0f763$var$diacritic.letters[$81a3a23b6ce0f763$var$j]] = $81a3a23b6ce0f763$var$diacritic.base;
}
var $81a3a23b6ce0f763$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($81a3a23b6ce0f763$var$anyDiacritic, function(match) {
        return $81a3a23b6ce0f763$var$diacriticToBase[match];
    });
};
var $81a3a23b6ce0f763$var$memoizedStripDiacriticsForInput = (0, $b416a8bfe9e12ed9$export$2e2bcd8739ae039)($81a3a23b6ce0f763$var$stripDiacritics);
var $81a3a23b6ce0f763$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $81a3a23b6ce0f763$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $81a3a23b6ce0f763$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $81a3a23b6ce0f763$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $81a3a23b6ce0f763$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $81a3a23b6ce0f763$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $81a3a23b6ce0f763$var$memoizedStripDiacriticsForInput(input);
            candidate = $81a3a23b6ce0f763$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $81a3a23b6ce0f763$var$_excluded = [
    "innerRef"
];
function $81a3a23b6ce0f763$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $81a3a23b6ce0f763$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $167f833695fdfb3b$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("input", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $8c971e9544ccda33$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $81a3a23b6ce0f763$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $81a3a23b6ce0f763$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $lDSNw.useRef)(false);
    var isTop = (0, $lDSNw.useRef)(false);
    var touchStart = (0, $lDSNw.useRef)(0);
    var scrollTarget = (0, $lDSNw.useRef)(null);
    var handleEventDelta = (0, $lDSNw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $81a3a23b6ce0f763$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $lDSNw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $lDSNw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $lDSNw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $lDSNw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $167f833695fdfb3b$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $lDSNw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $lDSNw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $81a3a23b6ce0f763$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $81a3a23b6ce0f763$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $81a3a23b6ce0f763$var$preventTouchMove(e) {
    e.preventDefault();
}
function $81a3a23b6ce0f763$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $81a3a23b6ce0f763$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $81a3a23b6ce0f763$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $81a3a23b6ce0f763$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $81a3a23b6ce0f763$var$activeScrollLocks = 0;
var $81a3a23b6ce0f763$var$listenerOptions = {
    capture: false,
    passive: false
};
function $81a3a23b6ce0f763$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $lDSNw.useRef)({});
    var scrollTarget = (0, $lDSNw.useRef)(null);
    var addScrollLock = (0, $lDSNw.useCallback)(function(touchScrollTarget) {
        if (!$81a3a23b6ce0f763$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $81a3a23b6ce0f763$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $81a3a23b6ce0f763$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($81a3a23b6ce0f763$var$LOCK_STYLES).forEach(function(key) {
                var val = $81a3a23b6ce0f763$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $81a3a23b6ce0f763$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $81a3a23b6ce0f763$var$preventTouchMove, $81a3a23b6ce0f763$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $81a3a23b6ce0f763$var$preventInertiaScroll, $81a3a23b6ce0f763$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $81a3a23b6ce0f763$var$allowTouchMove, $81a3a23b6ce0f763$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $81a3a23b6ce0f763$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $lDSNw.useCallback)(function(touchScrollTarget) {
        if (!$81a3a23b6ce0f763$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $81a3a23b6ce0f763$var$activeScrollLocks = Math.max($81a3a23b6ce0f763$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $81a3a23b6ce0f763$var$activeScrollLocks < 1) $81a3a23b6ce0f763$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $81a3a23b6ce0f763$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $81a3a23b6ce0f763$var$preventTouchMove, $81a3a23b6ce0f763$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $81a3a23b6ce0f763$var$preventInertiaScroll, $81a3a23b6ce0f763$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $81a3a23b6ce0f763$var$allowTouchMove, $81a3a23b6ce0f763$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $lDSNw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $81a3a23b6ce0f763$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $81a3a23b6ce0f763$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $81a3a23b6ce0f763$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $81a3a23b6ce0f763$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $81a3a23b6ce0f763$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $81a3a23b6ce0f763$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)((0, $lDSNw.Fragment), null, lockEnabled && (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", {
        onClick: $81a3a23b6ce0f763$var$blurSelectInput,
        css: $81a3a23b6ce0f763$var$_ref2$1
    }), children(targetRef));
}
function $81a3a23b6ce0f763$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $81a3a23b6ce0f763$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $81a3a23b6ce0f763$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $81a3a23b6ce0f763$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $81a3a23b6ce0f763$var$RequiredInput$1 = $81a3a23b6ce0f763$var$RequiredInput;
var $81a3a23b6ce0f763$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $81a3a23b6ce0f763$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $81a3a23b6ce0f763$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $81a3a23b6ce0f763$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $81a3a23b6ce0f763$var$defaultStyles = {
    clearIndicator: (0, $167f833695fdfb3b$export$407448d2b89b1813),
    container: (0, $167f833695fdfb3b$export$8b22cf2602fb60ce),
    control: (0, $167f833695fdfb3b$export$4368d992c4eafac0),
    dropdownIndicator: (0, $167f833695fdfb3b$export$f1e1789686576879),
    group: (0, $167f833695fdfb3b$export$39b482c5e57630a8),
    groupHeading: (0, $167f833695fdfb3b$export$2d1720544b23b823),
    indicatorsContainer: (0, $167f833695fdfb3b$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $167f833695fdfb3b$export$dda1d9f60106f0e9),
    input: (0, $167f833695fdfb3b$export$35e795649ee09318),
    loadingIndicator: (0, $167f833695fdfb3b$export$882b5998b3b9117c),
    loadingMessage: (0, $167f833695fdfb3b$export$342063e11d6c3cad),
    menu: (0, $167f833695fdfb3b$export$953cecd6e717a553),
    menuList: (0, $167f833695fdfb3b$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $167f833695fdfb3b$export$ae1af26003f05816),
    multiValue: (0, $167f833695fdfb3b$export$ffb5f4729a158638),
    multiValueLabel: (0, $167f833695fdfb3b$export$9e5f44173e64f162),
    multiValueRemove: (0, $167f833695fdfb3b$export$625550452a3fa3ec),
    noOptionsMessage: (0, $167f833695fdfb3b$export$3b14a55fb2447963),
    option: (0, $167f833695fdfb3b$export$90a7f3efeed30595),
    placeholder: (0, $167f833695fdfb3b$export$efccba1c4a2ef57b),
    singleValue: (0, $167f833695fdfb3b$export$d141bba7fdc215a3),
    valueContainer: (0, $167f833695fdfb3b$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $81a3a23b6ce0f763$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $81a3a23b6ce0f763$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $81a3a23b6ce0f763$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $81a3a23b6ce0f763$var$baseUnit = 4;
// The minimum height of the control
var $81a3a23b6ce0f763$var$controlHeight = 38;
// The amount of space between the control and menu */
var $81a3a23b6ce0f763$var$menuGutter = $81a3a23b6ce0f763$var$baseUnit * 2;
var $81a3a23b6ce0f763$var$spacing = {
    baseUnit: $81a3a23b6ce0f763$var$baseUnit,
    controlHeight: $81a3a23b6ce0f763$var$controlHeight,
    menuGutter: $81a3a23b6ce0f763$var$menuGutter
};
var $81a3a23b6ce0f763$export$4368d992c4eafac0 = {
    borderRadius: $81a3a23b6ce0f763$var$borderRadius,
    colors: $81a3a23b6ce0f763$var$colors,
    spacing: $81a3a23b6ce0f763$var$spacing
};
var $81a3a23b6ce0f763$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $167f833695fdfb3b$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $167f833695fdfb3b$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $81a3a23b6ce0f763$export$db3b6bfb95261072(),
    formatGroupLabel: $81a3a23b6ce0f763$var$formatGroupLabel,
    getOptionLabel: $81a3a23b6ce0f763$export$8b22cf2602fb60ce,
    getOptionValue: $81a3a23b6ce0f763$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $81a3a23b6ce0f763$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $167f833695fdfb3b$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $81a3a23b6ce0f763$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $81a3a23b6ce0f763$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $81a3a23b6ce0f763$var$_isOptionSelected(props, option, selectValue);
    var label = $81a3a23b6ce0f763$var$getOptionLabel(props, option);
    var value = $81a3a23b6ce0f763$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $81a3a23b6ce0f763$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $81a3a23b6ce0f763$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $81a3a23b6ce0f763$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $81a3a23b6ce0f763$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $81a3a23b6ce0f763$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $167f833695fdfb3b$export$3466f893ebf79586));
}
function $81a3a23b6ce0f763$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $81a3a23b6ce0f763$var$buildFocusableOptions(props, selectValue) {
    return $81a3a23b6ce0f763$var$buildFocusableOptionsFromCategorizedOptions($81a3a23b6ce0f763$var$buildCategorizedOptions(props, selectValue));
}
function $81a3a23b6ce0f763$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$81a3a23b6ce0f763$var$shouldHideSelectedOptions(props) || !isSelected) && $81a3a23b6ce0f763$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $81a3a23b6ce0f763$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $81a3a23b6ce0f763$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $81a3a23b6ce0f763$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $81a3a23b6ce0f763$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $81a3a23b6ce0f763$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $81a3a23b6ce0f763$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $81a3a23b6ce0f763$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $81a3a23b6ce0f763$var$getOptionValue(props, i) === candidate;
    });
}
function $81a3a23b6ce0f763$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $81a3a23b6ce0f763$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $81a3a23b6ce0f763$var$instanceId = 1;
var $81a3a23b6ce0f763$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $e478241f0c67c862$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $e4e44fec2fa4313d$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $13600594d241a5f3$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $167f833695fdfb3b$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $167f833695fdfb3b$export$ef35774e6d314e91)([].concat((0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $167f833695fdfb3b$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $167f833695fdfb3b$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $167f833695fdfb3b$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $167f833695fdfb3b$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $167f833695fdfb3b$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $167f833695fdfb3b$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $81a3a23b6ce0f763$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $81a3a23b6ce0f763$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $81a3a23b6ce0f763$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $167f833695fdfb3b$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $81a3a23b6ce0f763$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $81a3a23b6ce0f763$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $167f833695fdfb3b$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $81a3a23b6ce0f763$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$81a3a23b6ce0f763$var$instanceId);
        _this.state.selectValue = (0, $167f833695fdfb3b$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $d582913ea91ca96d$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $167f833695fdfb3b$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $167f833695fdfb3b$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $81a3a23b6ce0f763$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($81a3a23b6ce0f763$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $81a3a23b6ce0f763$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $81a3a23b6ce0f763$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $81a3a23b6ce0f763$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $81a3a23b6ce0f763$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox"
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $lDSNw.createElement($81a3a23b6ce0f763$var$DummyInput, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $167f833695fdfb3b$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $lDSNw.createElement(Input, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $lDSNw.createElement(Placeholder, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $lDSNw.createElement(MultiValue, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $lDSNw.createElement(SingleValue, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $lDSNw.createElement(ClearIndicator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $lDSNw.createElement(LoadingIndicator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $lDSNw.createElement(IndicatorSeparator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $lDSNw.createElement(DropdownIndicator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $lDSNw.createElement(Option, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $lDSNw.createElement(Group, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $lDSNw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $lDSNw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $lDSNw.createElement((0, $167f833695fdfb3b$export$3a1a48c8f6ef640e), (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $lDSNw.createElement(Menu, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $lDSNw.createElement($81a3a23b6ce0f763$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $lDSNw.createElement(MenuList, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $lDSNw.createElement(MenuPortal, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $lDSNw.createElement($81a3a23b6ce0f763$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $lDSNw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $lDSNw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $lDSNw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $lDSNw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $lDSNw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $lDSNw.createElement($81a3a23b6ce0f763$var$LiveRegion$1, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $lDSNw.createElement(SelectContainer, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $lDSNw.createElement(Control, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $lDSNw.createElement(ValueContainer, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $lDSNw.createElement(IndicatorsContainer, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $167f833695fdfb3b$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $81a3a23b6ce0f763$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $81a3a23b6ce0f763$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $81a3a23b6ce0f763$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $167f833695fdfb3b$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $lDSNw.Component));
$81a3a23b6ce0f763$export$25ce5a424b770e84.defaultProps = $81a3a23b6ce0f763$export$407448d2b89b1813;





var $0baaadaaf0d46ebd$exports = {};
var $ad2825581d82d592$exports = {};
var $d2d215f185f68b9d$exports = {};
var $96c81c11efc2e8a4$exports = {};
function $96c81c11efc2e8a4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $96c81c11efc2e8a4$exports = $96c81c11efc2e8a4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $96c81c11efc2e8a4$exports.__esModule = true, $96c81c11efc2e8a4$exports["default"] = $96c81c11efc2e8a4$exports, $96c81c11efc2e8a4$var$_typeof(obj);
}
$96c81c11efc2e8a4$exports = $96c81c11efc2e8a4$var$_typeof, $96c81c11efc2e8a4$exports.__esModule = true, $96c81c11efc2e8a4$exports["default"] = $96c81c11efc2e8a4$exports;


var $d2d215f185f68b9d$var$_typeof = $96c81c11efc2e8a4$exports.default;
var $38f5ea38cb5d9321$exports = {};

var $38f5ea38cb5d9321$var$_typeof = $96c81c11efc2e8a4$exports.default;
function $38f5ea38cb5d9321$var$_toPrimitive(input, hint) {
    if ($38f5ea38cb5d9321$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($38f5ea38cb5d9321$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$38f5ea38cb5d9321$exports = $38f5ea38cb5d9321$var$_toPrimitive, $38f5ea38cb5d9321$exports.__esModule = true, $38f5ea38cb5d9321$exports["default"] = $38f5ea38cb5d9321$exports;


function $d2d215f185f68b9d$var$_toPropertyKey(arg) {
    var key = $38f5ea38cb5d9321$exports(arg, "string");
    return $d2d215f185f68b9d$var$_typeof(key) === "symbol" ? key : String(key);
}
$d2d215f185f68b9d$exports = $d2d215f185f68b9d$var$_toPropertyKey, $d2d215f185f68b9d$exports.__esModule = true, $d2d215f185f68b9d$exports["default"] = $d2d215f185f68b9d$exports;


function $ad2825581d82d592$var$_defineProperty(obj, key, value) {
    key = $d2d215f185f68b9d$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$ad2825581d82d592$exports = $ad2825581d82d592$var$_defineProperty, $ad2825581d82d592$exports.__esModule = true, $ad2825581d82d592$exports["default"] = $ad2825581d82d592$exports;


function $0baaadaaf0d46ebd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0baaadaaf0d46ebd$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0baaadaaf0d46ebd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ad2825581d82d592$exports(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0baaadaaf0d46ebd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
$0baaadaaf0d46ebd$exports = $0baaadaaf0d46ebd$var$_objectSpread2, $0baaadaaf0d46ebd$exports.__esModule = true, $0baaadaaf0d46ebd$exports["default"] = $0baaadaaf0d46ebd$exports;


var $a32c203c897eee6d$exports = {};
var $908ece04953970fd$exports = {};
function $908ece04953970fd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$908ece04953970fd$exports = $908ece04953970fd$var$_arrayWithHoles, $908ece04953970fd$exports.__esModule = true, $908ece04953970fd$exports["default"] = $908ece04953970fd$exports;


var $05c75b719184f197$exports = {};
function $05c75b719184f197$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$05c75b719184f197$exports = $05c75b719184f197$var$_iterableToArrayLimit, $05c75b719184f197$exports.__esModule = true, $05c75b719184f197$exports["default"] = $05c75b719184f197$exports;


var $22a9dde4a3aec4fd$exports = {};
var $9dd5f119a68f6f46$exports = {};
function $9dd5f119a68f6f46$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$9dd5f119a68f6f46$exports = $9dd5f119a68f6f46$var$_arrayLikeToArray, $9dd5f119a68f6f46$exports.__esModule = true, $9dd5f119a68f6f46$exports["default"] = $9dd5f119a68f6f46$exports;


function $22a9dde4a3aec4fd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9dd5f119a68f6f46$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9dd5f119a68f6f46$exports(o, minLen);
}
$22a9dde4a3aec4fd$exports = $22a9dde4a3aec4fd$var$_unsupportedIterableToArray, $22a9dde4a3aec4fd$exports.__esModule = true, $22a9dde4a3aec4fd$exports["default"] = $22a9dde4a3aec4fd$exports;


var $99fe83ee7daa473f$exports = {};
function $99fe83ee7daa473f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$99fe83ee7daa473f$exports = $99fe83ee7daa473f$var$_nonIterableRest, $99fe83ee7daa473f$exports.__esModule = true, $99fe83ee7daa473f$exports["default"] = $99fe83ee7daa473f$exports;


function $a32c203c897eee6d$var$_slicedToArray(arr, i) {
    return $908ece04953970fd$exports(arr) || $05c75b719184f197$exports(arr, i) || $22a9dde4a3aec4fd$exports(arr, i) || $99fe83ee7daa473f$exports();
}
$a32c203c897eee6d$exports = $a32c203c897eee6d$var$_slicedToArray, $a32c203c897eee6d$exports.__esModule = true, $a32c203c897eee6d$exports["default"] = $a32c203c897eee6d$exports;


var $d1b9d98a6c66defe$exports = {};
var $6797bd588922fe08$exports = {};
function $6797bd588922fe08$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$6797bd588922fe08$exports = $6797bd588922fe08$var$_objectWithoutPropertiesLoose, $6797bd588922fe08$exports.__esModule = true, $6797bd588922fe08$exports["default"] = $6797bd588922fe08$exports;


function $d1b9d98a6c66defe$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6797bd588922fe08$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$d1b9d98a6c66defe$exports = $d1b9d98a6c66defe$var$_objectWithoutProperties, $d1b9d98a6c66defe$exports.__esModule = true, $d1b9d98a6c66defe$exports["default"] = $d1b9d98a6c66defe$exports;


var $90575ab79cd7cbf3$exports = {};
function $90575ab79cd7cbf3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$90575ab79cd7cbf3$exports = $90575ab79cd7cbf3$var$_classCallCheck, $90575ab79cd7cbf3$exports.__esModule = true, $90575ab79cd7cbf3$exports["default"] = $90575ab79cd7cbf3$exports;


var $9fdad93293d85f40$exports = {};

function $9fdad93293d85f40$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d2d215f185f68b9d$exports(descriptor.key), descriptor);
    }
}
function $9fdad93293d85f40$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9fdad93293d85f40$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9fdad93293d85f40$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$9fdad93293d85f40$exports = $9fdad93293d85f40$var$_createClass, $9fdad93293d85f40$exports.__esModule = true, $9fdad93293d85f40$exports["default"] = $9fdad93293d85f40$exports;


var $64294f917169bb37$exports = {};
var $27ab36d8ddd8ce6c$exports = {};
function $27ab36d8ddd8ce6c$var$_setPrototypeOf(o, p) {
    $27ab36d8ddd8ce6c$exports = $27ab36d8ddd8ce6c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $27ab36d8ddd8ce6c$exports.__esModule = true, $27ab36d8ddd8ce6c$exports["default"] = $27ab36d8ddd8ce6c$exports;
    return $27ab36d8ddd8ce6c$var$_setPrototypeOf(o, p);
}
$27ab36d8ddd8ce6c$exports = $27ab36d8ddd8ce6c$var$_setPrototypeOf, $27ab36d8ddd8ce6c$exports.__esModule = true, $27ab36d8ddd8ce6c$exports["default"] = $27ab36d8ddd8ce6c$exports;


function $64294f917169bb37$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $27ab36d8ddd8ce6c$exports(subClass, superClass);
}
$64294f917169bb37$exports = $64294f917169bb37$var$_inherits, $64294f917169bb37$exports.__esModule = true, $64294f917169bb37$exports["default"] = $64294f917169bb37$exports;


var $89bd5f7fa8963a2d$exports = {};
var $82adfe266ccfd91c$exports = {};
function $82adfe266ccfd91c$var$_getPrototypeOf(o) {
    $82adfe266ccfd91c$exports = $82adfe266ccfd91c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $82adfe266ccfd91c$exports.__esModule = true, $82adfe266ccfd91c$exports["default"] = $82adfe266ccfd91c$exports;
    return $82adfe266ccfd91c$var$_getPrototypeOf(o);
}
$82adfe266ccfd91c$exports = $82adfe266ccfd91c$var$_getPrototypeOf, $82adfe266ccfd91c$exports.__esModule = true, $82adfe266ccfd91c$exports["default"] = $82adfe266ccfd91c$exports;


var $57d1087bf1359790$exports = {};
function $57d1087bf1359790$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$57d1087bf1359790$exports = $57d1087bf1359790$var$_isNativeReflectConstruct, $57d1087bf1359790$exports.__esModule = true, $57d1087bf1359790$exports["default"] = $57d1087bf1359790$exports;


var $d26a35961f959f71$exports = {};

var $d26a35961f959f71$var$_typeof = $96c81c11efc2e8a4$exports.default;
var $6f80f3cd04bff76e$exports = {};
function $6f80f3cd04bff76e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$6f80f3cd04bff76e$exports = $6f80f3cd04bff76e$var$_assertThisInitialized, $6f80f3cd04bff76e$exports.__esModule = true, $6f80f3cd04bff76e$exports["default"] = $6f80f3cd04bff76e$exports;


function $d26a35961f959f71$var$_possibleConstructorReturn(self, call) {
    if (call && ($d26a35961f959f71$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6f80f3cd04bff76e$exports(self);
}
$d26a35961f959f71$exports = $d26a35961f959f71$var$_possibleConstructorReturn, $d26a35961f959f71$exports.__esModule = true, $d26a35961f959f71$exports["default"] = $d26a35961f959f71$exports;


function $89bd5f7fa8963a2d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $57d1087bf1359790$exports();
    return function _createSuperInternal() {
        var Super = $82adfe266ccfd91c$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $82adfe266ccfd91c$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d26a35961f959f71$exports(this, result);
    };
}
$89bd5f7fa8963a2d$exports = $89bd5f7fa8963a2d$var$_createSuper, $89bd5f7fa8963a2d$exports.__esModule = true, $89bd5f7fa8963a2d$exports["default"] = $89bd5f7fa8963a2d$exports;


var $de6f154e4c4f62d3$exports = {};
var $fc0dd622522b685a$exports = {};

function $fc0dd622522b685a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9dd5f119a68f6f46$exports(arr);
}
$fc0dd622522b685a$exports = $fc0dd622522b685a$var$_arrayWithoutHoles, $fc0dd622522b685a$exports.__esModule = true, $fc0dd622522b685a$exports["default"] = $fc0dd622522b685a$exports;


var $76f1722ce87cf504$exports = {};
function $76f1722ce87cf504$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$76f1722ce87cf504$exports = $76f1722ce87cf504$var$_iterableToArray, $76f1722ce87cf504$exports.__esModule = true, $76f1722ce87cf504$exports["default"] = $76f1722ce87cf504$exports;



var $96bf82080dc41fde$exports = {};
function $96bf82080dc41fde$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$96bf82080dc41fde$exports = $96bf82080dc41fde$var$_nonIterableSpread, $96bf82080dc41fde$exports.__esModule = true, $96bf82080dc41fde$exports["default"] = $96bf82080dc41fde$exports;


function $de6f154e4c4f62d3$var$_toConsumableArray(arr) {
    return $fc0dd622522b685a$exports(arr) || $76f1722ce87cf504$exports(arr) || $22a9dde4a3aec4fd$exports(arr) || $96bf82080dc41fde$exports();
}
$de6f154e4c4f62d3$exports = $de6f154e4c4f62d3$var$_toConsumableArray, $de6f154e4c4f62d3$exports.__esModule = true, $de6f154e4c4f62d3$exports["default"] = $de6f154e4c4f62d3$exports;




var $abfabb07f3123aef$exports = {};
function $abfabb07f3123aef$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$abfabb07f3123aef$exports = $abfabb07f3123aef$var$_taggedTemplateLiteral, $abfabb07f3123aef$exports.__esModule = true, $abfabb07f3123aef$exports["default"] = $abfabb07f3123aef$exports;



parcelRequire("ef4Zh");


var $b528be877820f307$var$StateManagedSelect = /*#__PURE__*/ (0, $lDSNw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $b2cf16ebe44f9041$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $lDSNw.createElement((0, $81a3a23b6ce0f763$export$25ce5a424b770e84), (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $b528be877820f307$export$2e2bcd8739ae039 = $b528be877820f307$var$StateManagedSelect;
var $b528be877820f307$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $lDSNw.useMemo)(function() {
        return (0, $6a2c18332cff1b13$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $lDSNw.createElement((0, $fee187d89b24554e$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};


var $3b401e016e2cfb0d$exports = {};

$parcel$export($3b401e016e2cfb0d$exports, "actionButton", function () { return $3b401e016e2cfb0d$export$a75c7ea49564edd7; }, function (v) { return $3b401e016e2cfb0d$export$a75c7ea49564edd7 = v; });
$parcel$export($3b401e016e2cfb0d$exports, "comparisonSelector", function () { return $3b401e016e2cfb0d$export$7747b56067d99dca; }, function (v) { return $3b401e016e2cfb0d$export$7747b56067d99dca = v; });
$parcel$export($3b401e016e2cfb0d$exports, "save", function () { return $3b401e016e2cfb0d$export$a1544dad697b423d; }, function (v) { return $3b401e016e2cfb0d$export$a1544dad697b423d = v; });
$parcel$export($3b401e016e2cfb0d$exports, "select", function () { return $3b401e016e2cfb0d$export$2e6c959c16ff56b8; }, function (v) { return $3b401e016e2cfb0d$export$2e6c959c16ff56b8 = v; });
$parcel$export($3b401e016e2cfb0d$exports, "title", function () { return $3b401e016e2cfb0d$export$fb184b623420d9be; }, function (v) { return $3b401e016e2cfb0d$export$fb184b623420d9be = v; });
var $3b401e016e2cfb0d$export$a75c7ea49564edd7;
var $3b401e016e2cfb0d$export$7747b56067d99dca;
var $3b401e016e2cfb0d$export$a1544dad697b423d;
var $3b401e016e2cfb0d$export$2e6c959c16ff56b8;
var $3b401e016e2cfb0d$export$fb184b623420d9be;
$3b401e016e2cfb0d$export$a75c7ea49564edd7 = `_iXspa_actionButton`;
$3b401e016e2cfb0d$export$7747b56067d99dca = `_iXspa_comparisonSelector`;
$3b401e016e2cfb0d$export$a1544dad697b423d = `_iXspa_save`;
$3b401e016e2cfb0d$export$2e6c959c16ff56b8 = `_iXspa_select`;
$3b401e016e2cfb0d$export$fb184b623420d9be = `_iXspa_title`;







const $616456b4968ecfbe$export$5adb86993fa577da = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        comparisonCreativeID: null,
        databaseError: false,
        errorMessage: "",
        scrollMode: "",
        dwellTimes: [],
        sequences: [],
        comparisonDwellTimes: [],
        comparisonSequences: [],
        sessionSize: 0,
        comparisonSessionSize: 0,
        scriptVersion: "",
        comparisonCreativeChanged: false,
        setComparisonCreativeID: (buildID)=>{
            set({
                comparisonCreativeID: buildID
            });
        },
        setDatabaseError: (value)=>{
            set({
                databaseError: value
            });
        },
        loadCreativeSequences: (buildID, minSequenceLength, triggerType, type)=>{
            set({
                sequences: [],
                dwellTimes: []
            });
            const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT3").doc(buildID).collection(buildID === "nayoyo" ? "sessions" : triggerType === "scrub" ? "scrubSessions" : "dwellTimeSessions");
            dataRef.get().then((querySnapshot)=>{
                if (querySnapshot.empty) set({
                    errorMessage: "Creative hasn't registered any data in CAT yet. Please wait for the creative to go live.",
                    databaseError: true
                });
                else {
                    let sequencesCollector = [];
                    let dwellTimeCollector = Array(101).fill(0);
                    let dwellTimeCounter = Array(101).fill(0);
                    let sessionSize = 0;
                    let sequencesLength = 0;
                    querySnapshot.forEach((doc)=>{
                        const sequences = doc.data().sequences ? doc.data().sequences : [];
                        const dwellTime = doc.data().dwellTime ? doc.data().dwellTime : [];
                        sequencesLength += sequences.length;
                        if (sequences.length >= minSequenceLength) {
                            sequencesCollector = [
                                ...sequencesCollector.concat(sequences)
                            ];
                            sessionSize++;
                        }
                        if (dwellTime.length) dwellTime.forEach((time, i)=>{
                            dwellTimeCollector[i] += time;
                            dwellTimeCounter[i]++;
                        });
                    });
                    if (sequencesCollector.length && sequencesCollector[0].startProgress) set({
                        scrollMode: "progress"
                    });
                    else set({
                        scrollMode: "timeline"
                    });
                    const dwellTimes = dwellTimeCollector.map((time, i)=>{
                        return {
                            timeline: i,
                            dwellTime: +(time / dwellTimeCounter[i]).toFixed(2),
                            counter: dwellTimeCounter[i]
                        };
                    });
                    if (type === "original") {
                        set({
                            dwellTimes: dwellTimes,
                            sessionSize: sessionSize
                        });
                        set((prevState)=>{
                            return {
                                ...prevState,
                                sequences: sequencesCollector,
                                errorMessage: "",
                                databaseError: false
                            };
                        });
                    } else {
                        set({
                            comparisonDwellTimes: dwellTimes,
                            comparisonSessionSize: sessionSize
                        });
                        set((prevState)=>{
                            return {
                                ...prevState,
                                comparisonSequences: sequencesCollector,
                                errorMessage: "",
                                databaseError: false
                            };
                        });
                    }
                }
            }).catch((error)=>{
                console.error("Error getting document:", error);
                set({
                    errorMessage: error,
                    databaseError: true
                });
            });
        // const rootDataRef = firebase.firestore().collection("CAT3").doc(buildID);
        // rootDataRef.get().then((querySnapshot) => {
        //   const scriptVersion = querySnapshot.data().scriptVersion
        //     ? querySnapshot.data().scriptVersion
        //     : "unknown";
        //   set({ scriptVersion: scriptVersion });
        // });
        },
        setComparisonCreativeChanged: (value)=>{
            set({
                comparisonCreativeChanged: value
            });
        },
        clearSequences: ()=>{
            set({
                sequences: [],
                creativeScrollProgress: 0
            });
        },
        clearBuildID: ()=>{
            set({
                buildID: ""
            });
        }
    }));


const $4ebefc4734ba02a5$var$CATComparisonSelector = ({ scriptVersion: scriptVersion, buildID: buildID })=>{
    const [creativeData, loadingCreativeData, errorCreativeData] = (0, $d5c35a4573de93de$export$b806f8b31e648973)((0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT3").where("scriptVersion", "==", scriptVersion));
    const [availableBuilds, setAvailableBuilds] = (0, $lDSNw.useState)([]);
    const comparisonCreative = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.comparisonCreativeID);
    const setComparisonCreativeID = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.setComparisonCreativeID);
    const comparisonCreativeChanged = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.comparisonCreativeChanged);
    const setComparisonCreativeChanged = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.setComparisonCreativeChanged);
    (0, $lDSNw.useEffect)(()=>{
        if (!loadingCreativeData && !errorCreativeData && creativeData) {
            const docs = creativeData.docs;
            const buildIDs = docs.map((doc)=>{
                const info = doc.data();
                return {
                    label: info.creativeNames + "-" + doc.id,
                    value: doc.id
                };
            });
            setAvailableBuilds(buildIDs);
        } else if (errorCreativeData) console.error(errorCreativeData);
    }, [
        loadingCreativeData,
        creativeData
    ]);
    const handleChange = (selectedBuild)=>{
        console.log(selectedBuild);
        if (selectedBuild === null) // clear comparisonCreative in the database
        setComparisonCreativeID(null);
        else // set comparisonCreative in the database
        setComparisonCreativeID(selectedBuild.value);
        setComparisonCreativeChanged(true);
    };
    const writeComparisonCreative = (id)=>{
        const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT-Rousel").doc(buildID);
        dataRef.set({
            comparisonCreative: id
        }, {
            merge: true
        });
        setComparisonCreativeChanged(false);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3b401e016e2cfb0d$exports))).comparisonSelector,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3b401e016e2cfb0d$exports))).title,
                children: "Standard Creative Build ID:"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b528be877820f307$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3b401e016e2cfb0d$exports))).select,
                options: availableBuilds,
                isClearable: true,
                value: comparisonCreative !== null ? {
                    label: comparisonCreative,
                    value: comparisonCreative
                } : null,
                onChange: handleChange
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($3b401e016e2cfb0d$exports))).actionButton} ${comparisonCreativeChanged ? (0, (/*@__PURE__*/$parcel$interopDefault($3b401e016e2cfb0d$exports))).save : null}`,
                onClick: ()=>comparisonCreativeChanged ? writeComparisonCreative(comparisonCreative) : null,
                children: "Save Changes"
            })
        ]
    });
};
var $4ebefc4734ba02a5$export$2e2bcd8739ae039 = $4ebefc4734ba02a5$var$CATComparisonSelector;




var $96e06bc224b60508$exports = {};

$parcel$export($96e06bc224b60508$exports, "active", function () { return $96e06bc224b60508$export$89da14300d534261; }, function (v) { return $96e06bc224b60508$export$89da14300d534261 = v; });
$parcel$export($96e06bc224b60508$exports, "actual", function () { return $96e06bc224b60508$export$f2bb41c35c9c6b13; }, function (v) { return $96e06bc224b60508$export$f2bb41c35c9c6b13 = v; });
$parcel$export($96e06bc224b60508$exports, "baseline", function () { return $96e06bc224b60508$export$baf5c2f62dd5cf3e; }, function (v) { return $96e06bc224b60508$export$baf5c2f62dd5cf3e = v; });
$parcel$export($96e06bc224b60508$exports, "brand", function () { return $96e06bc224b60508$export$96ff94e0adb1d772; }, function (v) { return $96e06bc224b60508$export$96ff94e0adb1d772 = v; });
$parcel$export($96e06bc224b60508$exports, "campaign", function () { return $96e06bc224b60508$export$b98c010fcdebc6be; }, function (v) { return $96e06bc224b60508$export$b98c010fcdebc6be = v; });
$parcel$export($96e06bc224b60508$exports, "campaignTitle", function () { return $96e06bc224b60508$export$143582cd53d50983; }, function (v) { return $96e06bc224b60508$export$143582cd53d50983 = v; });
$parcel$export($96e06bc224b60508$exports, "cardsContainer", function () { return $96e06bc224b60508$export$583b62a65da9ae06; }, function (v) { return $96e06bc224b60508$export$583b62a65da9ae06 = v; });
$parcel$export($96e06bc224b60508$exports, "catComparison", function () { return $96e06bc224b60508$export$4a752138cb317f9e; }, function (v) { return $96e06bc224b60508$export$4a752138cb317f9e = v; });
$parcel$export($96e06bc224b60508$exports, "catComparisonContainer", function () { return $96e06bc224b60508$export$64b0404f98d8b928; }, function (v) { return $96e06bc224b60508$export$64b0404f98d8b928 = v; });
$parcel$export($96e06bc224b60508$exports, "catrouselViewer", function () { return $96e06bc224b60508$export$ad1f04563ea156d9; }, function (v) { return $96e06bc224b60508$export$ad1f04563ea156d9 = v; });
$parcel$export($96e06bc224b60508$exports, "dummy", function () { return $96e06bc224b60508$export$3e042c74ad7d42ae; }, function (v) { return $96e06bc224b60508$export$3e042c74ad7d42ae = v; });
$parcel$export($96e06bc224b60508$exports, "dwellTime", function () { return $96e06bc224b60508$export$d374588d52786018; }, function (v) { return $96e06bc224b60508$export$d374588d52786018 = v; });
$parcel$export($96e06bc224b60508$exports, "legends", function () { return $96e06bc224b60508$export$33854e570d464ff0; }, function (v) { return $96e06bc224b60508$export$33854e570d464ff0 = v; });
$parcel$export($96e06bc224b60508$exports, "noMore", function () { return $96e06bc224b60508$export$7124ee307633d35; }, function (v) { return $96e06bc224b60508$export$7124ee307633d35 = v; });
$parcel$export($96e06bc224b60508$exports, "scrub", function () { return $96e06bc224b60508$export$1b16ec8d157f41c5; }, function (v) { return $96e06bc224b60508$export$1b16ec8d157f41c5 = v; });
$parcel$export($96e06bc224b60508$exports, "sectionNavigation", function () { return $96e06bc224b60508$export$e8fb2107fdab453c; }, function (v) { return $96e06bc224b60508$export$e8fb2107fdab453c = v; });
$parcel$export($96e06bc224b60508$exports, "sectionNavigationItem", function () { return $96e06bc224b60508$export$aa948fdce21f3ecc; }, function (v) { return $96e06bc224b60508$export$aa948fdce21f3ecc = v; });
$parcel$export($96e06bc224b60508$exports, "sectionTitle", function () { return $96e06bc224b60508$export$1a952fe22cdce89e; }, function (v) { return $96e06bc224b60508$export$1a952fe22cdce89e = v; });
$parcel$export($96e06bc224b60508$exports, "showMore", function () { return $96e06bc224b60508$export$ae9a281c4379b144; }, function (v) { return $96e06bc224b60508$export$ae9a281c4379b144 = v; });
$parcel$export($96e06bc224b60508$exports, "tooltipText", function () { return $96e06bc224b60508$export$f6280bcb2c59d0ac; }, function (v) { return $96e06bc224b60508$export$f6280bcb2c59d0ac = v; });
var $96e06bc224b60508$export$89da14300d534261;
var $96e06bc224b60508$export$f2bb41c35c9c6b13;
var $96e06bc224b60508$export$baf5c2f62dd5cf3e;
var $96e06bc224b60508$export$96ff94e0adb1d772;
var $96e06bc224b60508$export$b98c010fcdebc6be;
var $96e06bc224b60508$export$143582cd53d50983;
var $96e06bc224b60508$export$583b62a65da9ae06;
var $96e06bc224b60508$export$4a752138cb317f9e;
var $96e06bc224b60508$export$64b0404f98d8b928;
var $96e06bc224b60508$export$ad1f04563ea156d9;
var $96e06bc224b60508$export$3e042c74ad7d42ae;
var $96e06bc224b60508$export$d374588d52786018;
var $96e06bc224b60508$export$33854e570d464ff0;
var $96e06bc224b60508$export$7124ee307633d35;
var $96e06bc224b60508$export$1b16ec8d157f41c5;
var $96e06bc224b60508$export$e8fb2107fdab453c;
var $96e06bc224b60508$export$aa948fdce21f3ecc;
var $96e06bc224b60508$export$1a952fe22cdce89e;
var $96e06bc224b60508$export$ae9a281c4379b144;
var $96e06bc224b60508$export$f6280bcb2c59d0ac;
$96e06bc224b60508$export$89da14300d534261 = `Qf_rUG_active`;
$96e06bc224b60508$export$f2bb41c35c9c6b13 = `Qf_rUG_actual`;
$96e06bc224b60508$export$baf5c2f62dd5cf3e = `Qf_rUG_baseline`;
$96e06bc224b60508$export$96ff94e0adb1d772 = `Qf_rUG_brand`;
$96e06bc224b60508$export$b98c010fcdebc6be = `Qf_rUG_campaign`;
$96e06bc224b60508$export$143582cd53d50983 = `Qf_rUG_campaignTitle`;
$96e06bc224b60508$export$583b62a65da9ae06 = `Qf_rUG_cardsContainer`;
$96e06bc224b60508$export$4a752138cb317f9e = `Qf_rUG_catComparison`;
$96e06bc224b60508$export$64b0404f98d8b928 = `Qf_rUG_catComparisonContainer`;
$96e06bc224b60508$export$ad1f04563ea156d9 = `Qf_rUG_catrouselViewer`;
$96e06bc224b60508$export$3e042c74ad7d42ae = `Qf_rUG_dummy`;
$96e06bc224b60508$export$d374588d52786018 = `Qf_rUG_dwellTime`;
$96e06bc224b60508$export$33854e570d464ff0 = `Qf_rUG_legends`;
$96e06bc224b60508$export$7124ee307633d35 = `Qf_rUG_noMore`;
$96e06bc224b60508$export$1b16ec8d157f41c5 = `Qf_rUG_scrub`;
$96e06bc224b60508$export$e8fb2107fdab453c = `Qf_rUG_sectionNavigation`;
$96e06bc224b60508$export$aa948fdce21f3ecc = `Qf_rUG_sectionNavigationItem`;
$96e06bc224b60508$export$1a952fe22cdce89e = `Qf_rUG_sectionTitle`;
$96e06bc224b60508$export$ae9a281c4379b144 = `Qf_rUG_showMore`;
$96e06bc224b60508$export$f6280bcb2c59d0ac = `Qf_rUG_tooltipText`;


const $93dc62a660df7844$var$CATRouselViewer = (props)=>{
    const [recommendations, setRecommendations] = (0, $lDSNw.useState)([]);
    const [campaignName, setCampaignName] = (0, $lDSNw.useState)({});
    const [scriptVersion, setScriptVersion] = (0, $lDSNw.useState)("");
    const [topProductsRange, setTopProductsRange] = (0, $lDSNw.useState)(7);
    const [currentSection, setCurrentSection] = (0, $lDSNw.useState)("topProducts");
    const topProductsRef = (0, $lDSNw.useRef)(null);
    const catComparisonRef = (0, $lDSNw.useRef)(null);
    const [currentScrollData, setCurrentScrollData] = (0, $lDSNw.useState)([]);
    const comparisonCreative = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.comparisonCreativeID);
    const setComparisonCreativeID = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.setComparisonCreativeID);
    const loadCreativeSequences = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.loadCreativeSequences);
    const sequences = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.sequences);
    const sessionSize = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.sessionSize);
    const comparisonSequences = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.comparisonSequences);
    const comparisonSessionSize = (0, $616456b4968ecfbe$export$5adb86993fa577da)((state)=>state.comparisonSessionSize);
    const [creativeData, loadingCreativeData, errorCreativeData] = (0, $d5c35a4573de93de$export$3d94ca782eda2c23)((0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT-Rousel").doc(props.match.params.buildID));
    const [CATData, loadingCATData, errorCATData] = (0, $d5c35a4573de93de$export$3d94ca782eda2c23)((0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT3").doc(props.match.params.buildID));
    (0, $lDSNw.useEffect)(()=>{
        if (!loadingCreativeData && !errorCreativeData) {
            setComparisonCreativeID(creativeData.comparisonCreative);
            combineRecommendationsFromDifferentDomains(creativeData.currentRecommendation.scrubBasedRecommendation);
        }
    }, [
        creativeData,
        errorCreativeData,
        loadingCreativeData,
        setComparisonCreativeID
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!loadingCATData && !errorCATData) {
            setCampaignName({
                brand: CATData.brandNames,
                campaign: CATData.campaignNames
            });
            setScriptVersion(CATData.scriptVersion);
        }
    }, [
        CATData,
        loadingCATData,
        errorCATData
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (props.match.params.buildID && !loadingCreativeData && !errorCreativeData && comparisonCreative) {
            loadCreativeSequences(props.match.params.buildID, 0, "scrub", "original");
            loadCreativeSequences(comparisonCreative, 0, "scrub", "comparison");
        }
    }, [
        props.match.params.buildID,
        comparisonCreative,
        loadingCreativeData,
        errorCreativeData
    ]);
    (0, $lDSNw.useEffect)(()=>{
        const originalData = (0, $11d563350f5dc624$export$6c9dbc2dfbd602db)(sequences, "timeline", sessionSize);
        const comparisonData = (0, $11d563350f5dc624$export$6c9dbc2dfbd602db)(comparisonSequences, "timeline", comparisonSessionSize);
        setCurrentScrollData(attachBaselineData(originalData, comparisonData));
    }, [
        comparisonSequences,
        sequences,
        sessionSize,
        comparisonSessionSize
    ]);
    const attachBaselineData = (incomeData, comparisonData)=>{
        return incomeData.map((data, i)=>{
            return {
                ...data,
                dwellTimeBaseline: 0,
                scrubBaseline: comparisonData[i].playfulness
            };
        });
    };
    const executeScroll = (targetRef)=>targetRef.current.scrollIntoView({
            behavior: "smooth"
        });
    if (errorCreativeData) console.error(errorCreativeData);
    const showMoreHandler = ()=>{
        const newTopProductsRange = topProductsRange + 8;
        setTopProductsRange(newTopProductsRange);
    };
    const combineRecommendationsFromDifferentDomains = (recommendations)=>{
        let recommendationsBySlot = [];
        for (const [key, value] of Object.entries(recommendations))value.forEach((individualRecommendations, index)=>{
            if (recommendationsBySlot[index]) recommendationsBySlot[index] = recommendationsBySlot[index].concat(individualRecommendations[`slot${index}`]);
            else recommendationsBySlot[index] = [
                ...individualRecommendations[`slot${index}`]
            ];
            recommendationsBySlot[index].sort((a, b)=>b.score - a.score);
        });
        const recommendationsBySlotWithoutZeros = recommendationsBySlot.map((slotRecommendation)=>{
            return slotRecommendation.filter((individualRecommendation)=>individualRecommendation.score !== 0);
        });
        // get the medium score for each slot
        // const slotsMediums = recommendationsBySlotWithoutZeros.map(
        //   (recommendationsPerSlot) => {
        //     const middle = Math.floor(recommendationsPerSlot.length / 2);
        //     return recommendationsPerSlot.length % 2 !== 0
        //       ? recommendationsPerSlot[middle].score
        //       : (recommendationsPerSlot[middle - 1].score +
        //           recommendationsPerSlot[middle].score) /
        //           2;
        //   },
        // );
        // get the mean score for each slot
        const slotsMean = recommendationsBySlotWithoutZeros.map((recommendationsPerSlot, slotIndex)=>{
            const totalScore = recommendationsPerSlot.reduce((sum, accum)=>sum + accum.score, 0);
            return totalScore / recommendationsPerSlot.length;
        });
        // calculate distances between each score and its relative slot's mean
        const recommendationsBySlotWithDistance = recommendationsBySlotWithoutZeros.map((recommendationsPerSlot, slotIndex)=>{
            return recommendationsPerSlot.map((individualRecommendation)=>{
                individualRecommendation.distance = individualRecommendation.score - slotsMean[slotIndex];
                return individualRecommendation;
            });
        });
        // flatten the array of recommendations per slot and sort them by distance to means
        const recommendationsBySlotWithDistanceFlattened = recommendationsBySlotWithDistance.flat().sort((a, b)=>{
            return b.distance - a.distance;
        });
        // Zheng's note: from the line where recommendationsBySlotWithoutZeros is defined, there's nothing scientific about these.
        // It's my plain attempt to level the scores aggregated by the cloud function in this limited amount of time.
        // which uses the formula of:
        // score = scrub destination * individualScrubWeight + dwellTime  * individualDwellTimeWeight
        // combine duplicated items and average their scores
        const recommendationsWithoutDuplicates = [];
        recommendationsBySlotWithDistanceFlattened.forEach(function(recommendation) {
            if (!this[recommendation.id]) {
                this[recommendation.id] = recommendation;
                this[recommendation.id].distance = [
                    recommendation.distance
                ];
                recommendationsWithoutDuplicates.push(this[recommendation.id]);
            } else this[recommendation.id].distance.push(recommendation.distance);
        }, Object.create(null));
        // calculate average distance between each item
        const recommendationsWithoutDuplicatesAvg = recommendationsWithoutDuplicates.map((recommendation)=>{
            recommendation.distance = recommendation.distance.reduce((a, b)=>a + b, 0) / recommendation.distance.length;
            return recommendation;
        });
        setRecommendations(recommendationsWithoutDuplicatesAvg.sort((a, b)=>{
            return b.distance - a.distance;
        }));
    };
    const renderEmptyComparisonContainer = ()=>{
        return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).catComparisonContainer,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).dummy
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).noMore,
                    children: props.header ? "Please select the build id for it to compare to." : "Coming Soon..."
                })
            ]
        });
    };
    const normalizeBaselineAndActual = (incomingData)=>{
        if (incomingData.length) {
            const dataClone = [
                ...incomingData
            ].slice(30, 65);
            const sequenceMax = dataClone.reduce((prev, current)=>prev.playfulness > current.playfulness ? prev : current).playfulness;
            const sequenceMin = dataClone.reduce(function(prev, current) {
                return prev.playfulness < current.playfulness ? prev : current;
            }).playfulness;
            const baselineMax = dataClone.reduce((prev, current)=>prev.scrubBaseline > current.scrubBaseline ? prev : current).scrubBaseline;
            const baselineMin = dataClone.reduce(function(prev, current) {
                return prev.scrubBaseline < current.scrubBaseline ? prev : current;
            }).scrubBaseline;
            const max = Math.max(sequenceMax, baselineMax);
            const min = Math.min(sequenceMin, baselineMin);
            const gap = max - min;
            return incomingData.map((value)=>{
                const newValue = {
                    ...value
                };
                if (value.playfulness >= min && value.playfulness <= max) newValue.playfulness = (value.playfulness - min) * (incomingData.length / gap);
                else if (value.playfulness > max) newValue.playfulness = 100;
                else newValue.playfulness = 0;
                if (value.scrubBaseline >= min && value.scrubBaseline <= max) newValue.scrubBaseline = (value.scrubBaseline - min) * (incomingData.length / gap);
                else if (value.scrubBaseline > max) newValue.scrubBaseline = 100;
                else newValue.scrubBaseline = 0;
                return newValue;
            });
        } else return [];
    };
    const renderComparisonContainer = ()=>{
        return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).catComparisonContainer,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                    width: "100%",
                    aspect: 2,
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $141478e0e2068f7a$export$f510429275d6f1a8), {
                        data: normalizeBaselineAndActual(currentScrollData),
                        margin: {
                            top: 20,
                            right: 0,
                            bottom: 25,
                            left: 0
                        },
                        padding: {
                            top: 20,
                            right: 0,
                            bottom: 20,
                            left: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                                stroke: "#e8e8e8",
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                                dataKey: "timeline",
                                type: "number",
                                tickLine: true,
                                domain: [
                                    30,
                                    65
                                ],
                                allowDataOverflow: true,
                                axisLine: false,
                                ticks: [
                                    "Scroll in",
                                    "Scroll out"
                                ],
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8a059853790af0f6$export$b04be29aa201d4f5), {
                                        value: "Scroll in",
                                        offset: 0,
                                        position: "insideLeft",
                                        style: {
                                            fontSize: "100%",
                                            fill: "#c5c5c5"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8a059853790af0f6$export$b04be29aa201d4f5), {
                                        value: "Scroll out",
                                        offset: 0,
                                        position: "insideRight",
                                        style: {
                                            fontSize: "100%",
                                            fill: "#c5c5c5"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8a059853790af0f6$export$b04be29aa201d4f5), {
                                        value: "Ad Progress",
                                        offset: -15,
                                        position: "insideBottom",
                                        style: {
                                            fontSize: "130%",
                                            fill: "#c5c5c5"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("linearGradient", {
                                    id: "linear",
                                    children: [
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "25%",
                                            stopColor: "#00CE7C"
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "#4AC1E0"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                                axisLine: false,
                                tickLine: false,
                                hide: true
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                                type: "monotone",
                                dataKey: "scrubBaseline",
                                stroke: "#c5c5c5",
                                strokeWidth: 5,
                                fillOpacity: 0.5,
                                fill: "#c5c5c5",
                                isAnimationActive: false
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                                type: "monotone",
                                dataKey: "playfulness",
                                stroke: "url(#linear)",
                                strokeWidth: 5,
                                fill: "rgba(255,255,255,0)",
                                isAnimationActive: false
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).legends,
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).actual,
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $3ee3b72d91cbc81c$export$a6c7ac8248d6e38a), {
                                    to: `/creative/${props.match.params.buildID}`,
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                        icon: (0, $36045e57d0ad82eb$export$88bc01ff8dbecc55)
                                    })
                                }),
                                "CAT-rousel Creative:",
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).baseline,
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $3ee3b72d91cbc81c$export$a6c7ac8248d6e38a), {
                                    to: `/creative/${comparisonCreative}`,
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                        icon: (0, $36045e57d0ad82eb$export$88bc01ff8dbecc55)
                                    })
                                }),
                                "Standard Creative:",
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {})
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).catrouselViewer,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).campaignTitle,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).brand,
                        children: campaignName.brand
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).campaign,
                        children: campaignName.campaign
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).sectionNavigation,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).sectionNavigationItem} ${currentSection === "topProducts" ? (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).active : null}`,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                icon: (0, $36045e57d0ad82eb$export$bc8ca14ab51f93db),
                                onClick: ()=>{
                                    executeScroll(topProductsRef);
                                    setCurrentSection("topProducts");
                                }
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).tooltipText,
                                children: "Top Products"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).sectionNavigationItem} ${currentSection === "catComparison" ? (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).active : null}`,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                icon: (0, $36045e57d0ad82eb$export$2238e05f8920005a),
                                onClick: ()=>{
                                    executeScroll(catComparisonRef);
                                    setCurrentSection("catComparison");
                                }
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).tooltipText,
                                children: "CAT Comparison"
                            })
                        ]
                    })
                ]
            }),
            recommendations.length > 0 ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).cardsContainer,
                ref: topProductsRef,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        name: "topProducts",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).sectionTitle,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                icon: (0, $36045e57d0ad82eb$export$bc8ca14ab51f93db)
                            }),
                            "Top Products"
                        ]
                    }),
                    recommendations.slice(0, topProductsRange).map((recommendation, index)=>{
                        return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4fd37e908d2cd4a6$export$2e2bcd8739ae039), {
                            image: recommendation.url,
                            title: recommendation.id,
                            ranking: index + 1
                        }, index);
                    }),
                    topProductsRange < recommendations.length ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).showMore,
                        onClick: showMoreHandler,
                        children: "Show More Products"
                    }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).noMore,
                        children: "No More Products"
                    })
                ]
            }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $642bd4537957c1d1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).catComparison,
                ref: catComparisonRef,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                        name: "catComparison",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($96e06bc224b60508$exports))).sectionTitle,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                                icon: (0, $36045e57d0ad82eb$export$2238e05f8920005a)
                            }),
                            "CAT Comparison",
                            " ",
                            props.header ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4ebefc4734ba02a5$export$2e2bcd8739ae039), {
                                buildID: props.match.params.buildID,
                                scriptVersion: scriptVersion
                            }) : null
                        ]
                    }),
                    comparisonCreative ? renderComparisonContainer() : renderEmptyComparisonContainer()
                ]
            })
        ]
    });
};
const $93dc62a660df7844$var$CATRouselViewerWithRouter = (0, $5058ffe240ffde31$export$369b6b2b30582e8e)($93dc62a660df7844$var$CATRouselViewer);
var $93dc62a660df7844$export$2e2bcd8739ae039 = $93dc62a660df7844$var$CATRouselViewerWithRouter;





parcelRequire("lDSNw");
var $d4ccd6fc161746b2$exports = {};
"use strict";
function $d4ccd6fc161746b2$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d4ccd6fc161746b2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d4ccd6fc161746b2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d4ccd6fc161746b2$var$_typeof(obj);
}
function $d4ccd6fc161746b2$var$_extends() {
    $d4ccd6fc161746b2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d4ccd6fc161746b2$var$_extends.apply(this, arguments);
}
function $d4ccd6fc161746b2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d4ccd6fc161746b2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d4ccd6fc161746b2$var$ownKeys(source, true).forEach(function(key) {
            $d4ccd6fc161746b2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d4ccd6fc161746b2$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d4ccd6fc161746b2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d4ccd6fc161746b2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d4ccd6fc161746b2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d4ccd6fc161746b2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d4ccd6fc161746b2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d4ccd6fc161746b2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d4ccd6fc161746b2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d4ccd6fc161746b2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d4ccd6fc161746b2$var$_possibleConstructorReturn(self, call) {
    if (call && ($d4ccd6fc161746b2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d4ccd6fc161746b2$var$_assertThisInitialized(self);
}
function $d4ccd6fc161746b2$var$_getPrototypeOf(o) {
    $d4ccd6fc161746b2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d4ccd6fc161746b2$var$_getPrototypeOf(o);
}
function $d4ccd6fc161746b2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d4ccd6fc161746b2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d4ccd6fc161746b2$var$_setPrototypeOf(subClass, superClass);
}
function $d4ccd6fc161746b2$var$_setPrototypeOf(o, p) {
    $d4ccd6fc161746b2$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d4ccd6fc161746b2$var$_setPrototypeOf(o, p);
}
function $d4ccd6fc161746b2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $lDSNw = parcelRequire("lDSNw");

var $c83bae22fdb68953$exports = {};
var $5ff34f127f8c2610$exports = {};
var $1b88bf9362013140$exports = {};
$1b88bf9362013140$exports = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};


function $5ff34f127f8c2610$var$QR8bitByte(data) {
    this.mode = $1b88bf9362013140$exports.MODE_8BIT_BYTE;
    this.data = data;
}
$5ff34f127f8c2610$var$QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.data.length;
    },
    write: function(buffer) {
        for(var i = 0; i < this.data.length; i++)// not JIS ...
        buffer.put(this.data.charCodeAt(i), 8);
    }
};
$5ff34f127f8c2610$exports = $5ff34f127f8c2610$var$QR8bitByte;


var $c5aa32ee44a1a829$exports = {};
// ErrorCorrectLevel
var $087892b3fc1b6cc7$exports = {};
$087892b3fc1b6cc7$exports = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};


function $c5aa32ee44a1a829$var$QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
$c5aa32ee44a1a829$var$QRRSBlock.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    // 2
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    // 3
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    // 4		
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    // 5
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    // 6
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    // 7		
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    // 8
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    // 9
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    // 10		
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    // 11
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    // 12
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    // 13
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    // 14
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    // 15
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    // 16
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    // 17
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    // 18
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    // 19
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    // 20
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    // 21
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    // 22
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    // 23
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    // 24
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    // 25
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    // 26
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    // 27
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    // 28
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    // 29
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    // 30
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    // 31
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    // 32
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    // 33
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    // 34
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    // 35
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    // 36
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    // 37
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    // 38
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    // 39
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    // 40
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
$c5aa32ee44a1a829$var$QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = $c5aa32ee44a1a829$var$QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = new Array();
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new $c5aa32ee44a1a829$var$QRRSBlock(totalCount, dataCount));
    }
    return list;
};
$c5aa32ee44a1a829$var$QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case $087892b3fc1b6cc7$exports.L:
            return $c5aa32ee44a1a829$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case $087892b3fc1b6cc7$exports.M:
            return $c5aa32ee44a1a829$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case $087892b3fc1b6cc7$exports.Q:
            return $c5aa32ee44a1a829$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case $087892b3fc1b6cc7$exports.H:
            return $c5aa32ee44a1a829$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$c5aa32ee44a1a829$exports = $c5aa32ee44a1a829$var$QRRSBlock;


var $2c71b007b8f6c607$exports = {};
function $2c71b007b8f6c607$var$QRBitBuffer() {
    this.buffer = new Array();
    this.length = 0;
}
$2c71b007b8f6c607$var$QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$2c71b007b8f6c607$exports = $2c71b007b8f6c607$var$QRBitBuffer;


var $51e45cccff1616ab$exports = {};

var $48523bf204348c43$exports = {};
var $f6595397ed6c8c4b$exports = {};
var $f6595397ed6c8c4b$var$QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return $f6595397ed6c8c4b$var$QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return $f6595397ed6c8c4b$var$QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var $f6595397ed6c8c4b$var$i = 0; $f6595397ed6c8c4b$var$i < 8; $f6595397ed6c8c4b$var$i++)$f6595397ed6c8c4b$var$QRMath.EXP_TABLE[$f6595397ed6c8c4b$var$i] = 1 << $f6595397ed6c8c4b$var$i;
for(var $f6595397ed6c8c4b$var$i = 8; $f6595397ed6c8c4b$var$i < 256; $f6595397ed6c8c4b$var$i++)$f6595397ed6c8c4b$var$QRMath.EXP_TABLE[$f6595397ed6c8c4b$var$i] = $f6595397ed6c8c4b$var$QRMath.EXP_TABLE[$f6595397ed6c8c4b$var$i - 4] ^ $f6595397ed6c8c4b$var$QRMath.EXP_TABLE[$f6595397ed6c8c4b$var$i - 5] ^ $f6595397ed6c8c4b$var$QRMath.EXP_TABLE[$f6595397ed6c8c4b$var$i - 6] ^ $f6595397ed6c8c4b$var$QRMath.EXP_TABLE[$f6595397ed6c8c4b$var$i - 8];
for(var $f6595397ed6c8c4b$var$i = 0; $f6595397ed6c8c4b$var$i < 255; $f6595397ed6c8c4b$var$i++)$f6595397ed6c8c4b$var$QRMath.LOG_TABLE[$f6595397ed6c8c4b$var$QRMath.EXP_TABLE[$f6595397ed6c8c4b$var$i]] = $f6595397ed6c8c4b$var$i;
$f6595397ed6c8c4b$exports = $f6595397ed6c8c4b$var$QRMath;


function $48523bf204348c43$var$QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
$48523bf204348c43$var$QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= $f6595397ed6c8c4b$exports.gexp($f6595397ed6c8c4b$exports.glog(this.get(i)) + $f6595397ed6c8c4b$exports.glog(e.get(j)));
        return new $48523bf204348c43$var$QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = $f6595397ed6c8c4b$exports.glog(this.get(0)) - $f6595397ed6c8c4b$exports.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= $f6595397ed6c8c4b$exports.gexp($f6595397ed6c8c4b$exports.glog(e.get(i)) + ratio);
        // recursive call
        return new $48523bf204348c43$var$QRPolynomial(num, 0).mod(e);
    }
};
$48523bf204348c43$exports = $48523bf204348c43$var$QRPolynomial;



var $51e45cccff1616ab$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var $51e45cccff1616ab$var$QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while($51e45cccff1616ab$var$QRUtil.getBCHDigit(d) - $51e45cccff1616ab$var$QRUtil.getBCHDigit($51e45cccff1616ab$var$QRUtil.G15) >= 0)d ^= $51e45cccff1616ab$var$QRUtil.G15 << $51e45cccff1616ab$var$QRUtil.getBCHDigit(d) - $51e45cccff1616ab$var$QRUtil.getBCHDigit($51e45cccff1616ab$var$QRUtil.G15);
        return (data << 10 | d) ^ $51e45cccff1616ab$var$QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while($51e45cccff1616ab$var$QRUtil.getBCHDigit(d) - $51e45cccff1616ab$var$QRUtil.getBCHDigit($51e45cccff1616ab$var$QRUtil.G18) >= 0)d ^= $51e45cccff1616ab$var$QRUtil.G18 << $51e45cccff1616ab$var$QRUtil.getBCHDigit(d) - $51e45cccff1616ab$var$QRUtil.getBCHDigit($51e45cccff1616ab$var$QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return $51e45cccff1616ab$var$QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case $51e45cccff1616ab$var$QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new $48523bf204348c43$exports([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new $48523bf204348c43$exports([
            1,
            $f6595397ed6c8c4b$exports.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $1b88bf9362013140$exports.MODE_NUMBER:
                return 10;
            case $1b88bf9362013140$exports.MODE_ALPHA_NUM:
                return 9;
            case $1b88bf9362013140$exports.MODE_8BIT_BYTE:
                return 8;
            case $1b88bf9362013140$exports.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $1b88bf9362013140$exports.MODE_NUMBER:
                return 12;
            case $1b88bf9362013140$exports.MODE_ALPHA_NUM:
                return 11;
            case $1b88bf9362013140$exports.MODE_8BIT_BYTE:
                return 16;
            case $1b88bf9362013140$exports.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $1b88bf9362013140$exports.MODE_NUMBER:
                return 14;
            case $1b88bf9362013140$exports.MODE_ALPHA_NUM:
                return 13;
            case $1b88bf9362013140$exports.MODE_8BIT_BYTE:
                return 16;
            case $1b88bf9362013140$exports.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
$51e45cccff1616ab$exports = $51e45cccff1616ab$var$QRUtil;



function $c83bae22fdb68953$var$QRCode(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
// for client side minification
var $c83bae22fdb68953$var$proto = $c83bae22fdb68953$var$QRCode.prototype;
$c83bae22fdb68953$var$proto.addData = function(data) {
    var newData = new $5ff34f127f8c2610$exports(data);
    this.dataList.push(newData);
    this.dataCache = null;
};
$c83bae22fdb68953$var$proto.isDark = function(row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
    return this.modules[row][col];
};
$c83bae22fdb68953$var$proto.getModuleCount = function() {
    return this.moduleCount;
};
$c83bae22fdb68953$var$proto.make = function() {
    // Calculate automatically typeNumber if provided is < 1
    if (this.typeNumber < 1) {
        var typeNumber = 1;
        for(typeNumber = 1; typeNumber < 40; typeNumber++){
            var rsBlocks = $c5aa32ee44a1a829$exports.getRSBlocks(typeNumber, this.errorCorrectLevel);
            var buffer = new $2c71b007b8f6c607$exports();
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
            for(var i = 0; i < this.dataList.length; i++){
                var data = this.dataList[i];
                buffer.put(data.mode, 4);
                buffer.put(data.getLength(), $51e45cccff1616ab$exports.getLengthInBits(data.mode, typeNumber));
                data.write(buffer);
            }
            if (buffer.getLengthInBits() <= totalDataCount * 8) break;
        }
        this.typeNumber = typeNumber;
    }
    this.makeImpl(false, this.getBestMaskPattern());
};
$c83bae22fdb68953$var$proto.makeImpl = function(test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for(var row = 0; row < this.moduleCount; row++){
        this.modules[row] = new Array(this.moduleCount);
        for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null; //(col + row) % 3;
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) this.setupTypeNumber(test);
    if (this.dataCache == null) this.dataCache = $c83bae22fdb68953$var$QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    this.mapData(this.dataCache, maskPattern);
};
$c83bae22fdb68953$var$proto.setupPositionProbePattern = function(row, col) {
    for(var r = -1; r <= 7; r++){
        if (row + r <= -1 || this.moduleCount <= row + r) continue;
        for(var c = -1; c <= 7; c++){
            if (col + c <= -1 || this.moduleCount <= col + c) continue;
            if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$c83bae22fdb68953$var$proto.getBestMaskPattern = function() {
    var minLostPoint = 0;
    var pattern = 0;
    for(var i = 0; i < 8; i++){
        this.makeImpl(true, i);
        var lostPoint = $51e45cccff1616ab$exports.getLostPoint(this);
        if (i == 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
        }
    }
    return pattern;
};
$c83bae22fdb68953$var$proto.createMovieClip = function(target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for(var row = 0; row < this.modules.length; row++){
        var y = row * cs;
        for(var col = 0; col < this.modules[row].length; col++){
            var x = col * cs;
            var dark = this.modules[row][col];
            if (dark) {
                qr_mc.beginFill(0, 100);
                qr_mc.moveTo(x, y);
                qr_mc.lineTo(x + cs, y);
                qr_mc.lineTo(x + cs, y + cs);
                qr_mc.lineTo(x, y + cs);
                qr_mc.endFill();
            }
        }
    }
    return qr_mc;
};
$c83bae22fdb68953$var$proto.setupTimingPattern = function() {
    for(var r = 8; r < this.moduleCount - 8; r++){
        if (this.modules[r][6] != null) continue;
        this.modules[r][6] = r % 2 == 0;
    }
    for(var c = 8; c < this.moduleCount - 8; c++){
        if (this.modules[6][c] != null) continue;
        this.modules[6][c] = c % 2 == 0;
    }
};
$c83bae22fdb68953$var$proto.setupPositionAdjustPattern = function() {
    var pos = $51e45cccff1616ab$exports.getPatternPosition(this.typeNumber);
    for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
        var row = pos[i];
        var col = pos[j];
        if (this.modules[row][col] != null) continue;
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$c83bae22fdb68953$var$proto.setupTypeNumber = function(test) {
    var bits = $51e45cccff1616ab$exports.getBCHTypeNumber(this.typeNumber);
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
};
$c83bae22fdb68953$var$proto.setupTypeInfo = function(test, maskPattern) {
    var data = this.errorCorrectLevel << 3 | maskPattern;
    var bits = $51e45cccff1616ab$exports.getBCHTypeInfo(data);
    // vertical		
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 6) this.modules[i][8] = mod;
        else if (i < 8) this.modules[i + 1][8] = mod;
        else this.modules[this.moduleCount - 15 + i][8] = mod;
    }
    // horizontal
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
        else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
        else this.modules[8][15 - i - 1] = mod;
    }
    // fixed module
    this.modules[this.moduleCount - 8][8] = !test;
};
$c83bae22fdb68953$var$proto.mapData = function(data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = this.moduleCount - 1; col > 0; col -= 2){
        if (col == 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                var mask = $51e45cccff1616ab$exports.getMask(maskPattern, row, col - c);
                if (mask) dark = !dark;
                this.modules[row][col - c] = dark;
                bitIndex--;
                if (bitIndex == -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || this.moduleCount <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
};
$c83bae22fdb68953$var$QRCode.PAD0 = 0xEC;
$c83bae22fdb68953$var$QRCode.PAD1 = 0x11;
$c83bae22fdb68953$var$QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = $c5aa32ee44a1a829$exports.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new $2c71b007b8f6c607$exports();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), $51e45cccff1616ab$exports.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    // calc num max data.
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    // padding
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    // padding
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($c83bae22fdb68953$var$QRCode.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($c83bae22fdb68953$var$QRCode.PAD1, 8);
    }
    return $c83bae22fdb68953$var$QRCode.createBytes(buffer, rsBlocks);
};
$c83bae22fdb68953$var$QRCode.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = $51e45cccff1616ab$exports.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new $48523bf204348c43$exports(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
$c83bae22fdb68953$exports = $c83bae22fdb68953$var$QRCode;



// Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
function $d4ccd6fc161746b2$var$convertStr(str) {
    var out = "";
    for(var i = 0; i < str.length; i++){
        var charcode = str.charCodeAt(i);
        if (charcode < 0x0080) out += String.fromCharCode(charcode);
        else if (charcode < 0x0800) {
            out += String.fromCharCode(0xc0 | charcode >> 6);
            out += String.fromCharCode(0x80 | charcode & 0x3f);
        } else if (charcode < 0xd800 || charcode >= 0xe000) {
            out += String.fromCharCode(0xe0 | charcode >> 12);
            out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
            out += String.fromCharCode(0x80 | charcode & 0x3f);
        } else {
            // This is a surrogate pair, so we'll reconsitute the pieces and work
            // from that
            i++;
            charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
            out += String.fromCharCode(0xf0 | charcode >> 18);
            out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
            out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
            out += String.fromCharCode(0x80 | charcode & 0x3f);
        }
    }
    return out;
}
var $d4ccd6fc161746b2$var$DEFAULT_PROPS = {
    size: 128,
    level: "L",
    bgColor: "#FFFFFF",
    fgColor: "#000000",
    includeMargin: false
};
var $d4ccd6fc161746b2$var$PROP_TYPES = {};
var $d4ccd6fc161746b2$var$MARGIN_SIZE = 4; // This is *very* rough estimate of max amount of QRCode allowed to be covered.
// It is "wrong" in a lot of ways (area is a terrible way to estimate, it
// really should be number of modules covered), but if for some reason we don't
// get an explicit height or width, I'd rather default to something than throw.
var $d4ccd6fc161746b2$var$DEFAULT_IMG_SCALE = 0.1;
function $d4ccd6fc161746b2$var$generatePath(modules) {
    var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var ops = [];
    modules.forEach(function(row, y) {
        var start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                // M0 0h7v1H0z injects the space with the move and drops the comma,
                // saving a char per operation
                ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
                start = null;
                return;
            } // end of row, clean up or skip
            if (x === row.length - 1) {
                if (!cell) // We would have closed the op above already so this can only mean
                // 2+ light modules in a row.
                return;
                if (start === null) // Just a single dark module.
                ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
                else // Otherwise finish the current line.
                ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
} // We could just do this in generatePath, except that we want to support
// non-Path2D canvas, so we need to keep it an explicit step.
function $d4ccd6fc161746b2$var$excavateModules(modules, excavation) {
    return modules.slice().map(function(row, y) {
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map(function(cell, x) {
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $d4ccd6fc161746b2$var$getImageSettings(props, cells) {
    var imageSettings = props.imageSettings, size = props.size, includeMargin = props.includeMargin;
    if (imageSettings == null) return null;
    var margin = includeMargin ? $d4ccd6fc161746b2$var$MARGIN_SIZE : 0;
    var numCells = cells.length + margin * 2;
    var defaultSize = Math.floor(size * $d4ccd6fc161746b2$var$DEFAULT_IMG_SCALE);
    var scale = numCells / size;
    var w = (imageSettings.width || defaultSize) * scale;
    var h = (imageSettings.height || defaultSize) * scale;
    var x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    var y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    var excavation = null;
    if (imageSettings.excavate) {
        var floorX = Math.floor(x);
        var floorY = Math.floor(y);
        var ceilW = Math.ceil(w + x - floorX);
        var ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation
    };
} // For canvas we're going to switch our drawing mode based on whether or not
// the environment supports Path2D. We only need the constructor to be
// supported, but Edge doesn't actually support the path (string) type
// argument. Luckily it also doesn't support the addPath() method. We can
// treat that as the same thing.
var $d4ccd6fc161746b2$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
var $d4ccd6fc161746b2$var$QRCodeCanvas = /*#__PURE__*/ function(_React$PureComponent) {
    $d4ccd6fc161746b2$var$_inherits(QRCodeCanvas, _React$PureComponent);
    function QRCodeCanvas() {
        var _getPrototypeOf2;
        var _this;
        $d4ccd6fc161746b2$var$_classCallCheck(this, QRCodeCanvas);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $d4ccd6fc161746b2$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $d4ccd6fc161746b2$var$_getPrototypeOf(QRCodeCanvas)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $d4ccd6fc161746b2$var$_defineProperty($d4ccd6fc161746b2$var$_assertThisInitialized(_this), "_canvas", void 0);
        $d4ccd6fc161746b2$var$_defineProperty($d4ccd6fc161746b2$var$_assertThisInitialized(_this), "_image", void 0);
        $d4ccd6fc161746b2$var$_defineProperty($d4ccd6fc161746b2$var$_assertThisInitialized(_this), "state", {
            imgLoaded: false
        });
        $d4ccd6fc161746b2$var$_defineProperty($d4ccd6fc161746b2$var$_assertThisInitialized(_this), "handleImageLoad", function() {
            _this.setState({
                imgLoaded: true
            });
        });
        return _this;
    }
    $d4ccd6fc161746b2$var$_createClass(QRCodeCanvas, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this._image && this._image.complete) this.handleImageLoad();
                this.update();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this$props$imageSett, _nextProps$imageSetti;
                var currentSrc = (_this$props$imageSett = this.props.imageSettings) === null || _this$props$imageSett === void 0 ? void 0 : _this$props$imageSett.src;
                var nextSrc = (_nextProps$imageSetti = nextProps.imageSettings) === null || _nextProps$imageSetti === void 0 ? void 0 : _nextProps$imageSetti.src;
                if (currentSrc !== nextSrc) this.setState({
                    imgLoaded: false
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: "update",
            value: function update() {
                var _this$props = this.props, value = _this$props.value, size = _this$props.size, level = _this$props.level, bgColor = _this$props.bgColor, fgColor = _this$props.fgColor, includeMargin = _this$props.includeMargin, imageSettings = _this$props.imageSettings; // We'll use type===-1 to force QRCode to automatically pick the best type
                var qrcode = new $c83bae22fdb68953$exports(-1, $087892b3fc1b6cc7$exports[level]);
                qrcode.addData($d4ccd6fc161746b2$var$convertStr(value));
                qrcode.make();
                if (this._canvas != null) {
                    var canvas = this._canvas;
                    var ctx = canvas.getContext("2d");
                    if (!ctx) return;
                    var cells = qrcode.modules;
                    if (cells === null) return;
                    var margin = includeMargin ? $d4ccd6fc161746b2$var$MARGIN_SIZE : 0;
                    var numCells = cells.length + margin * 2;
                    var calculatedImageSettings = $d4ccd6fc161746b2$var$getImageSettings(this.props, cells);
                    if (imageSettings != null && calculatedImageSettings != null) {
                        if (calculatedImageSettings.excavation != null) cells = $d4ccd6fc161746b2$var$excavateModules(cells, calculatedImageSettings.excavation);
                    } // We're going to scale this so that the number of drawable units
                    // matches the number of cells. This avoids rounding issues, but does
                    // result in some potentially unwanted single pixel issues between
                    // blocks, only in environments that don't support Path2D.
                    var pixelRatio = window.devicePixelRatio || 1;
                    canvas.height = canvas.width = size * pixelRatio;
                    var scale = size / numCells * pixelRatio;
                    ctx.scale(scale, scale); // Draw solid background, only paint dark modules.
                    ctx.fillStyle = bgColor;
                    ctx.fillRect(0, 0, numCells, numCells);
                    ctx.fillStyle = fgColor;
                    if ($d4ccd6fc161746b2$var$SUPPORTS_PATH2D) // $FlowFixMe: Path2D c'tor doesn't support args yet.
                    ctx.fill(new Path2D($d4ccd6fc161746b2$var$generatePath(cells, margin)));
                    else cells.forEach(function(row, rdx) {
                        row.forEach(function(cell, cdx) {
                            if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                        });
                    });
                    if (this.state.imgLoaded && this._image && calculatedImageSettings != null) ctx.drawImage(this._image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, value = _this$props2.value, size = _this$props2.size, level = _this$props2.level, bgColor = _this$props2.bgColor, fgColor = _this$props2.fgColor, style = _this$props2.style, includeMargin = _this$props2.includeMargin, imageSettings = _this$props2.imageSettings, otherProps = $d4ccd6fc161746b2$var$_objectWithoutProperties(_this$props2, [
                    "value",
                    "size",
                    "level",
                    "bgColor",
                    "fgColor",
                    "style",
                    "includeMargin",
                    "imageSettings"
                ]);
                var canvasStyle = $d4ccd6fc161746b2$var$_objectSpread({
                    height: size,
                    width: size
                }, style);
                var img = null;
                var imgSrc = imageSettings && imageSettings.src;
                if (imageSettings != null && imgSrc != null) img = $lDSNw.createElement("img", {
                    src: imgSrc,
                    style: {
                        display: "none"
                    },
                    onLoad: this.handleImageLoad,
                    ref: function ref(_ref) {
                        return _this2._image = _ref;
                    }
                });
                return $lDSNw.createElement($lDSNw.Fragment, null, $lDSNw.createElement("canvas", $d4ccd6fc161746b2$var$_extends({
                    style: canvasStyle,
                    height: size,
                    width: size,
                    ref: function ref(_ref2) {
                        return _this2._canvas = _ref2;
                    }
                }, otherProps)), img);
            }
        }
    ]);
    return QRCodeCanvas;
}($lDSNw.PureComponent);
$d4ccd6fc161746b2$var$_defineProperty($d4ccd6fc161746b2$var$QRCodeCanvas, "defaultProps", $d4ccd6fc161746b2$var$DEFAULT_PROPS);
var $d4ccd6fc161746b2$var$QRCodeSVG = /*#__PURE__*/ function(_React$PureComponent2) {
    $d4ccd6fc161746b2$var$_inherits(QRCodeSVG, _React$PureComponent2);
    function QRCodeSVG() {
        $d4ccd6fc161746b2$var$_classCallCheck(this, QRCodeSVG);
        return $d4ccd6fc161746b2$var$_possibleConstructorReturn(this, $d4ccd6fc161746b2$var$_getPrototypeOf(QRCodeSVG).apply(this, arguments));
    }
    $d4ccd6fc161746b2$var$_createClass(QRCodeSVG, [
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, value = _this$props3.value, size = _this$props3.size, level = _this$props3.level, bgColor = _this$props3.bgColor, fgColor = _this$props3.fgColor, includeMargin = _this$props3.includeMargin, imageSettings = _this$props3.imageSettings, otherProps = $d4ccd6fc161746b2$var$_objectWithoutProperties(_this$props3, [
                    "value",
                    "size",
                    "level",
                    "bgColor",
                    "fgColor",
                    "includeMargin",
                    "imageSettings"
                ]); // We'll use type===-1 to force QRCode to automatically pick the best type
                var qrcode = new $c83bae22fdb68953$exports(-1, $087892b3fc1b6cc7$exports[level]);
                qrcode.addData($d4ccd6fc161746b2$var$convertStr(value));
                qrcode.make();
                var cells = qrcode.modules;
                if (cells === null) return null;
                var margin = includeMargin ? $d4ccd6fc161746b2$var$MARGIN_SIZE : 0;
                var numCells = cells.length + margin * 2;
                var calculatedImageSettings = $d4ccd6fc161746b2$var$getImageSettings(this.props, cells);
                var image = null;
                if (imageSettings != null && calculatedImageSettings != null) {
                    if (calculatedImageSettings.excavation != null) cells = $d4ccd6fc161746b2$var$excavateModules(cells, calculatedImageSettings.excavation);
                    image = $lDSNw.createElement("image", {
                        xlinkHref: imageSettings.src,
                        height: calculatedImageSettings.h,
                        width: calculatedImageSettings.w,
                        x: calculatedImageSettings.x + margin,
                        y: calculatedImageSettings.y + margin,
                        preserveAspectRatio: "none"
                    });
                } // Drawing strategy: instead of a rect per module, we're going to create a
                // single path for the dark modules and layer that on top of a light rect,
                // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
                // way faster than DOM ops.
                // For level 1, 441 nodes -> 2
                // For level 40, 31329 -> 2
                var fgPath = $d4ccd6fc161746b2$var$generatePath(cells, margin);
                return $lDSNw.createElement("svg", $d4ccd6fc161746b2$var$_extends({
                    shapeRendering: "crispEdges",
                    height: size,
                    width: size,
                    viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
                }, otherProps), $lDSNw.createElement("path", {
                    fill: bgColor,
                    d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
                }), $lDSNw.createElement("path", {
                    fill: fgColor,
                    d: fgPath
                }), image);
            }
        }
    ]);
    return QRCodeSVG;
}($lDSNw.PureComponent);
$d4ccd6fc161746b2$var$_defineProperty($d4ccd6fc161746b2$var$QRCodeSVG, "defaultProps", $d4ccd6fc161746b2$var$DEFAULT_PROPS);
var $d4ccd6fc161746b2$var$QRCode = function QRCode(props) {
    var renderAs = props.renderAs, otherProps = $d4ccd6fc161746b2$var$_objectWithoutProperties(props, [
        "renderAs"
    ]);
    var Component = renderAs === "svg" ? $d4ccd6fc161746b2$var$QRCodeSVG : $d4ccd6fc161746b2$var$QRCodeCanvas;
    return $lDSNw.createElement(Component, otherProps);
};
$d4ccd6fc161746b2$var$QRCode.defaultProps = $d4ccd6fc161746b2$var$_objectSpread({
    renderAs: "canvas"
}, $d4ccd6fc161746b2$var$DEFAULT_PROPS);
$d4ccd6fc161746b2$exports = $d4ccd6fc161746b2$var$QRCode;



var $lDSNw = parcelRequire("lDSNw");


function $5e2e7dfba3eb8bc8$export$2e2bcd8739ae039(id) {
    const [buildID, setBuildID] = (0, $lDSNw.useState)(id);
    (0, $lDSNw.useEffect)(()=>{
        if ((0, $3205e0f1ddb62c1d$export$fb7e043d17077d69)(id)) {
            const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collectionGroup("scrubSessions").where("creativeID", "==", id).limit(1);
            dataRef.get().then((querySnapshot)=>{
                if (querySnapshot.docs.length > 0) setBuildID(querySnapshot.docs[0].ref.parent.parent.id);
                else throw "No data.";
            });
        } else setBuildID(id);
    }, [
        id
    ]);
    return buildID;
}







const $d1b76096ae2e411e$export$9252076f3eb12b04 = (buildID, cb)=>{
    const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).database().ref(`catDemo/${buildID}`);
    dataRef.on("value", (snapshot)=>{
        const data = snapshot.val();
        if (data) cb(data);
        else throw new Error("No data found.");
    });
};
const $d1b76096ae2e411e$export$d34e3452fdd9507e = (buildID)=>{
    (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).analytics().logEvent("clear_demo_data");
    const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).database().ref(`catDemo/${buildID}`);
    dataRef.set({
        status: "removed"
    });
};
const $d1b76096ae2e411e$export$9eb65c060ba39a9a = (buildID)=>{
    (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).database().ref(`catDemo/${buildID}`).off();
};



const $ece625921076c11d$export$311f681dd6bb3e49 = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        buildID: "",
        format: "",
        scrollMode: "timeline",
        formatObject: null,
        setFormatObject: (formatObject)=>{
            set({
                formatObject: formatObject
            });
        },
        iframeSrcDoc: "",
        iframeLoaded: false,
        iframeVideo: null,
        sequences: [],
        sessionSize: 0,
        dwellTimes: [],
        creativeScrollProgress: 0,
        scrubBaseline: [],
        dwellTimeBaseline: [],
        scriptVersion: "unknown",
        vertical: null,
        errorLoadingCreative: false,
        setIframeVideo: (iframeVideo)=>{
            set({
                iframeVideo: iframeVideo
            });
        },
        setBuildID: (buildID)=>{
            set({
                buildID: buildID
            });
        },
        setCreativeScrollProgress: (progress)=>{
            set({
                creativeScrollProgress: progress
            });
        },
        setBaseline: (baseline)=>{
            set({
                scrubBaseline: get()[`${baseline}ScrubBaseline`],
                dwellTimeBaseline: get()[`${baseline}DwellTimeBaseline`]
            });
        },
        fetchIframeSourceDoc: async (buildID)=>{
            try {
                const response = await (0, $9d599987579e8430$export$4e70f71bf0757296)(buildID);
                set({
                    iframeSrcDoc: response
                });
            } catch (error) {
                console.error("Cannot fetch the creative:", error);
                throw new Error("Cannot fetch the creative thru this build id");
            }
        },
        clearIframe: ()=>{
            set({
                iframeLoaded: false,
                iframeSrcDoc: ""
            });
        },
        loadCreativeSequences: async (buildID, minSequenceLength, triggerType, filterDomain = [], isDemo = false)=>{
            set({
                sequences: [],
                dwellTimes: [],
                scriptVersion: "",
                brandNames: "",
                campaignNames: "",
                creativeNames: "",
                sessionSize: "",
                format: "",
                videoSequences: {},
                containsVideo: null,
                vertical: "",
                usingAggregatedData: false
            });
            if (isDemo) {
                (0, $d1b76096ae2e411e$export$9252076f3eb12b04)(buildID, (data)=>{
                    const values = Object.values(data);
                    // use .progress if the data recorded is from format.progress
                    set({
                        containsVideo: null,
                        scrollMode: values.length && values[0][0].startProgress ? "progress" : "timeline",
                        sessionSize: values.length,
                        sequences: values.flatMap((value)=>{
                            const sequences = value.length ? value : [];
                            return sequences.length >= minSequenceLength ? sequences : [];
                        })
                    });
                });
                return;
            }
            // currently there is no pre-aggregated data for adBuyIDs or creativeIDs
            if ((0, $3205e0f1ddb62c1d$export$fb7e043d17077d69)(buildID)) {
                let sequenceData = await (0, $abbc57578fc5f1d4$export$c554f64eaaa85ca7)({
                    buildID: buildID,
                    minSequenceLength: minSequenceLength,
                    triggerType: triggerType,
                    filterDomain: filterDomain,
                    queryByCreativeID: true
                }).catch((e)=>{
                    set({
                        errorLoadingCreative: true
                    });
                    throw new Error("Could not get sequences.");
                });
                const { format: format = "hang-time", containsVideo: containsVideo } = sequenceData.data;
                const baseline = await (0, $abbc57578fc5f1d4$export$2369333ddd6d5edd)(containsVideo ? `${format}-video` : format);
                const dwellTimeBaseline = baseline.dwellTime;
                const scrubBaseline = baseline.scrubBaseline;
                // get the vanillia videoDropOffBaselines
                const videoDropOffBaseline = containsVideo ? baseline.videoDropOffBaseline : null;
                const byDurationVideoDropOffBaselines = containsVideo ? await (0, $abbc57578fc5f1d4$export$d77a2064e943270a)(format) : null;
                set({
                    ...sequenceData.data,
                    dwellTimeBaseline: dwellTimeBaseline,
                    scrubBaseline: scrubBaseline,
                    videoDropOffBaseline: videoDropOffBaseline,
                    byDurationVideoDropOffBaselines: byDurationVideoDropOffBaselines
                });
                return;
            }
            let aggregatedCreativeData = await (0, $abbc57578fc5f1d4$export$ab07af100e3ae3cc)(buildID).catch((e)=>{
                set({
                    errorLoadingCreative: true
                });
                throw new Error("Could not get aggregated data.");
            });
            const { aggregatedSessionSize: aggregatedSessionSize, scrubs: scrubs, dwellTime: dwellTime, format: format = "hang-time", containsVideo: containsVideo, scriptVersion: scriptVersion, videoInViewSequence: videoInViewSequence, videoDropOff: videoDropOff, aggregatedVideoSessionSize: aggregatedVideoSessionSize, domains: domains } = aggregatedCreativeData;
            const definitelyHasVideo = containsVideo && aggregatedVideoSessionSize;
            const sequences = scrubs.map((scrub, i)=>({
                    timeline: i,
                    playfulness: scrub / aggregatedSessionSize
                }));
            const dwellTimes = dwellTime.map((dwell, i)=>({
                    timeline: i,
                    dwellTime: dwell / aggregatedSessionSize,
                    counter: aggregatedSessionSize
                }));
            let videoSequences = {};
            if (definitelyHasVideo) {
                const videoDropOffSessions = videoDropOff.reduce((acc, curr)=>acc + curr, 0);
                let droppedOff = 0;
                videoSequences.videoDropOffSequence = videoDropOff.map((dropOff, i, arr)=>{
                    if (i !== arr.length - 1) droppedOff += dropOff;
                    return Math.round((videoDropOffSessions - droppedOff) / videoDropOffSessions * 100);
                });
            // TODO: videoSequences.videoInViewSequence at some point when we know how we want to chart them
            }
            const baseline = await (0, $abbc57578fc5f1d4$export$2369333ddd6d5edd)(definitelyHasVideo ? `${format}-video` : format);
            const dwellTimeBaseline = baseline.dwellTime;
            const scrubBaseline = baseline.scrubBaseline;
            const videoDropOffBaseline = definitelyHasVideo ? baseline.videoDropOffBaseline : null;
            const byDurationVideoDropOffBaselines = definitelyHasVideo ? await (0, $abbc57578fc5f1d4$export$d77a2064e943270a)(format) : null;
            const creativeSequences = {
                sequences: sequences,
                dwellTimes: dwellTimes,
                dwellTimeBaseline: dwellTimeBaseline,
                usingAggregatedData: true,
                scrubBaseline: scrubBaseline,
                format: format,
                domains: domains,
                // we'll probably add these soon
                // formatScrubBaseline: scrubBaseline,
                // formatDwellTimeBaseline: dwellTimeBaseline,
                sessionSize: aggregatedSessionSize,
                containsVideo: !!definitelyHasVideo,
                defaultBaseline: "format",
                videoSequences: videoSequences,
                videoDropOffBaseline: videoDropOffBaseline,
                byDurationVideoDropOffBaselines: byDurationVideoDropOffBaselines,
                // we'll probably add these soon also
                // vertical: "",
                // verticalScrubBaseline: scrubBaseline,
                // verticalDwellTimeBaseline: dwellTimeBaseline,
                scriptVersion: scriptVersion
            };
            set(creativeSequences);
            return;
        },
        updateChart: (data)=>{
            const { scrubs: scrubs, dwellTime: dwellTime, sessionCount: sessionCount, videoDropOff: videoDropOff, videoInViewSequence: videoInViewSequence, videoSessionCount: videoSessionCount } = data;
            let droppedOff = 0;
            const videoDropOffSequence = videoDropOff && videoSessionCount ? videoDropOff.map((dropOff, i, arr)=>{
                if (i !== arr.length - 1) droppedOff += dropOff;
                return Math.round((videoSessionCount - droppedOff) / videoSessionCount * 100);
            }) : [];
            set({
                sequences: scrubs.map((scrub, i)=>({
                        timeline: i,
                        playfulness: scrub / sessionCount
                    })),
                dwellTimes: dwellTime,
                sessionSize: sessionCount,
                videoSequences: {
                    videoDropOffSequence: videoDropOffSequence
                }
            });
        },
        clearSequences: ()=>{
            set({
                sequences: [],
                creativeScrollProgress: 0
            });
        },
        clearDemoData: (buildID)=>{
            (0, $d1b76096ae2e411e$export$d34e3452fdd9507e)(buildID);
        },
        clearBuildID: ()=>{
            set({
                buildID: ""
            });
        },
        detachDemoDatabase: (buildID)=>{
            (0, $d1b76096ae2e411e$export$9eb65c060ba39a9a)(buildID);
        }
    }));



var $lDSNw = parcelRequire("lDSNw");


"use client";
function $29a8efb14c0efed3$export$7ee548861327febe(props) {
    const { isOpen: isOpen, ref: ref } = props;
    const [mounted, setMounted] = (0, $lDSNw.useState)(isOpen);
    const [once, setOnce] = (0, $lDSNw.useState)(false);
    (0, $lDSNw.useEffect)(()=>{
        if (!once) {
            setMounted(isOpen);
            setOnce(true);
        }
    }, [
        isOpen,
        once,
        mounted
    ]);
    (0, $75d55078b16d3eca$export$7080b3e976bc91ab)(()=>ref.current, "animationend", ()=>{
        setMounted(isOpen);
    });
    const hidden = isOpen ? false : !mounted;
    return {
        present: !hidden,
        onComplete () {
            var _a;
            const win = (0, $9fe60e153b4d4482$export$f21a1ffae260145a)(ref.current);
            const evt = new win.CustomEvent("animationend", {
                bubbles: true
            });
            (_a = ref.current) == null || _a.dispatchEvent(evt);
        }
    };
}



"use client";
function $3433b5747f0b1833$var$isRefObject(val) {
    return "current" in val;
}
var $3433b5747f0b1833$var$isDom = ()=>typeof window !== "undefined";
function $3433b5747f0b1833$var$getPlatform() {
    var _a;
    const agent = navigator.userAgentData;
    return (_a = agent == null ? void 0 : agent.platform) != null ? _a : navigator.platform;
}
var $3433b5747f0b1833$var$vn = (v)=>$3433b5747f0b1833$var$isDom() && v.test(navigator.vendor);
var $3433b5747f0b1833$var$pt = (v)=>$3433b5747f0b1833$var$isDom() && v.test($3433b5747f0b1833$var$getPlatform());
var $3433b5747f0b1833$var$isApple = ()=>$3433b5747f0b1833$var$pt(/mac|iphone|ipad|ipod/i);
var $3433b5747f0b1833$var$isSafari = ()=>$3433b5747f0b1833$var$isApple() && $3433b5747f0b1833$var$vn(/apple/i);
function $3433b5747f0b1833$export$16a61b931588d888(props) {
    const { ref: ref, elements: elements, enabled: enabled } = props;
    const doc = ()=>{
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
    };
    (0, $75d55078b16d3eca$export$7080b3e976bc91ab)(doc, "pointerdown", (event)=>{
        if (!$3433b5747f0b1833$var$isSafari() || !enabled) return;
        const target = event.target;
        const els = elements != null ? elements : [
            ref
        ];
        const isValidTarget = els.some((elementOrRef)=>{
            const el = $3433b5747f0b1833$var$isRefObject(elementOrRef) ? elementOrRef.current : elementOrRef;
            return (el == null ? void 0 : el.contains(target)) || el === target;
        });
        if (doc().activeElement !== target && isValidTarget) {
            event.preventDefault();
            target.focus();
        }
    });
}




// src/tabbable.ts
var $6b177b9c1065987a$export$f5f22eac728522fd = (element)=>window.getComputedStyle(element).display === "none";
var $6b177b9c1065987a$export$54209d29bacd2cb9 = (element)=>element.hasAttribute("tabindex");
var $6b177b9c1065987a$export$87df0ed37d24dd13 = (element)=>$6b177b9c1065987a$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
function $6b177b9c1065987a$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $6b177b9c1065987a$export$63ed1d20cf8213cf(element) {
    return (0, $9fe60e153b4d4482$export$1b3bfaa9684536aa)(element) && element.localName === "input" && "select" in element;
}
function $6b177b9c1065987a$export$8a2eb51c14bb8899(element) {
    const doc = (0, $9fe60e153b4d4482$export$1b3bfaa9684536aa)(element) ? (0, $9fe60e153b4d4482$export$b204af158042fbac)(element) : document;
    return doc.activeElement === element;
}
function $6b177b9c1065987a$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $6b177b9c1065987a$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $6b177b9c1065987a$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $6b177b9c1065987a$export$3453cc819780f652(element) {
    const value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $6b177b9c1065987a$export$4c063cf1350e6fed(element) {
    if (!(0, $9fe60e153b4d4482$export$1b3bfaa9684536aa)(element) || $6b177b9c1065987a$export$ee695c13482bb5dd(element) || $6b177b9c1065987a$export$30e0dc115df457ed(element)) return false;
    const { localName: localName } = element;
    const focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    const others = {
        a: ()=>element.hasAttribute("href"),
        audio: ()=>element.hasAttribute("controls"),
        video: ()=>element.hasAttribute("controls")
    };
    if (localName in others) return others[localName]();
    if ($6b177b9c1065987a$export$3453cc819780f652(element)) return true;
    return $6b177b9c1065987a$export$54209d29bacd2cb9(element);
}
function $6b177b9c1065987a$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return (0, $9fe60e153b4d4482$export$1b3bfaa9684536aa)(element) && $6b177b9c1065987a$export$4c063cf1350e6fed(element) && !$6b177b9c1065987a$export$87df0ed37d24dd13(element);
}



// src/index.ts
var $d0f02b683c9e4505$var$focusableElList = [
    "input:not(:disabled):not([disabled])",
    "select:not(:disabled):not([disabled])",
    "textarea:not(:disabled):not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not(:disabled):not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $d0f02b683c9e4505$var$focusableElSelector = $d0f02b683c9e4505$var$focusableElList.join();
var $d0f02b683c9e4505$var$isVisible = (el)=>el.offsetWidth > 0 && el.offsetHeight > 0;
function $d0f02b683c9e4505$export$4ae682d253b556eb(container) {
    const focusableEls = Array.from(container.querySelectorAll($d0f02b683c9e4505$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter((el)=>(0, $6b177b9c1065987a$export$4c063cf1350e6fed)(el) && $d0f02b683c9e4505$var$isVisible(el));
}
function $d0f02b683c9e4505$export$748138f04a69bf21(container) {
    const allFocusable = $d0f02b683c9e4505$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $d0f02b683c9e4505$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    const allFocusable = Array.from(container.querySelectorAll($d0f02b683c9e4505$var$focusableElSelector));
    const allTabbable = allFocusable.filter((0, $6b177b9c1065987a$export$bebd5a1431fec25d));
    if ((0, $6b177b9c1065987a$export$bebd5a1431fec25d)(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $d0f02b683c9e4505$export$168b663469d4c75e(container, fallbackToFocusable) {
    const [first] = $d0f02b683c9e4505$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return first || null;
}
function $d0f02b683c9e4505$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    const allTabbable = $d0f02b683c9e4505$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $d0f02b683c9e4505$export$28f33206776129a7(container, fallbackToFocusable) {
    const allFocusable = $d0f02b683c9e4505$export$4ae682d253b556eb(container);
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $6b177b9c1065987a$export$bebd5a1431fec25d)) || allFocusable.find((0, $6b177b9c1065987a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $d0f02b683c9e4505$export$2e5518c3303f364a(container, fallbackToFocusable) {
    const allFocusable = $d0f02b683c9e4505$export$4ae682d253b556eb(container).reverse();
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $6b177b9c1065987a$export$bebd5a1431fec25d)) || allFocusable.find((0, $6b177b9c1065987a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}





var $lDSNw = parcelRequire("lDSNw");
"use client";
function $aa3008ed2427a149$export$496315a1608d9602(callback, deps) {
    const renderCycleRef = (0, $lDSNw.useRef)(false);
    const effectCycleRef = (0, $lDSNw.useRef)(false);
    (0, $lDSNw.useEffect)(()=>{
        const mounted = renderCycleRef.current;
        const run = mounted && effectCycleRef.current;
        if (run) return callback();
        effectCycleRef.current = true;
    }, deps);
    (0, $lDSNw.useEffect)(()=>{
        renderCycleRef.current = true;
        return ()=>{
            renderCycleRef.current = false;
        };
    }, []);
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $0a4488045172e95b$var$preventReturnFocus(containerRef) {
    const el = containerRef.current;
    if (!el) return false;
    const activeElement = (0, $9fe60e153b4d4482$export$cd4e5573fbe2b576)(el);
    if (!activeElement) return false;
    if (el.contains(activeElement)) return false;
    if ((0, $6b177b9c1065987a$export$bebd5a1431fec25d)(activeElement)) return true;
    return false;
}
function $0a4488045172e95b$export$68b323438c1fbb28(containerRef, options) {
    const { shouldFocus: shouldFocusProp, visible: visible, focusRef: focusRef } = options;
    const shouldFocus = shouldFocusProp && !visible;
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        if (!shouldFocus) return;
        if ($0a4488045172e95b$var$preventReturnFocus(containerRef)) return;
        const el = (focusRef == null ? void 0 : focusRef.current) || containerRef.current;
        let rafId;
        if (el) {
            rafId = requestAnimationFrame(()=>{
                el.focus({
                    preventScroll: true
                });
            });
            return ()=>{
                cancelAnimationFrame(rafId);
            };
        }
    }, [
        shouldFocus,
        containerRef,
        focusRef
    ]);
}
var $0a4488045172e95b$var$defaultOptions = {
    preventScroll: true,
    shouldFocus: false
};
function $0a4488045172e95b$export$54b5c2a5755195e7(target, options = $0a4488045172e95b$var$defaultOptions) {
    const { focusRef: focusRef, preventScroll: preventScroll, shouldFocus: shouldFocus, visible: visible } = options;
    const element = $0a4488045172e95b$var$isRefObject(target) ? target.current : target;
    const autoFocusValue = shouldFocus && visible;
    const autoFocusRef = (0, $lDSNw.useRef)(autoFocusValue);
    const lastVisibleRef = (0, $lDSNw.useRef)(visible);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (!lastVisibleRef.current && visible) autoFocusRef.current = autoFocusValue;
        lastVisibleRef.current = visible;
    }, [
        visible,
        autoFocusValue
    ]);
    const onFocus = (0, $lDSNw.useCallback)(()=>{
        if (!visible || !element || !autoFocusRef.current) return;
        autoFocusRef.current = false;
        if (element.contains(document.activeElement)) return;
        if (focusRef == null ? void 0 : focusRef.current) requestAnimationFrame(()=>{
            var _a;
            (_a = focusRef.current) == null || _a.focus({
                preventScroll: preventScroll
            });
        });
        else {
            const tabbableEls = (0, $d0f02b683c9e4505$export$4ae682d253b556eb)(element);
            if (tabbableEls.length > 0) requestAnimationFrame(()=>{
                tabbableEls[0].focus({
                    preventScroll: preventScroll
                });
            });
        }
    }, [
        visible,
        preventScroll,
        element,
        focusRef
    ]);
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        onFocus();
    }, [
        onFocus
    ]);
    (0, $75d55078b16d3eca$export$7080b3e976bc91ab)(element, "transitionend", onFocus);
}
function $0a4488045172e95b$var$isRefObject(val) {
    return "current" in val;
}






// src/index.ts
function $62bbd782f684d120$export$76655e7dd9ffc0ba(options) {
    const { wasSelected: wasSelected, enabled: enabled, isSelected: isSelected, mode: mode = "unmount" } = options;
    if (!enabled) return true;
    if (isSelected) return true;
    if (mode === "keepMounted" && wasSelected) return true;
    return false;
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
var $515bdff9a4f5789c$var$TRIGGER = {
    click: "click",
    hover: "hover"
};
function $515bdff9a4f5789c$export$542a6fd13ac93354(props = {}) {
    const { closeOnBlur: closeOnBlur = true, closeOnEsc: closeOnEsc = true, initialFocusRef: initialFocusRef, id: id, returnFocusOnClose: returnFocusOnClose = true, autoFocus: autoFocus = true, arrowSize: arrowSize, arrowShadowColor: arrowShadowColor, trigger: trigger = $515bdff9a4f5789c$var$TRIGGER.click, openDelay: openDelay = 200, closeDelay: closeDelay = 200, isLazy: isLazy, lazyBehavior: lazyBehavior = "unmount", computePositionOnMount: computePositionOnMount, ...popperProps } = props;
    const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $1ece6bed0c1f2ca7$export$6e3e27031a30522f)(props);
    const anchorRef = (0, $lDSNw.useRef)(null);
    const triggerRef = (0, $lDSNw.useRef)(null);
    const popoverRef = (0, $lDSNw.useRef)(null);
    const isHoveringRef = (0, $lDSNw.useRef)(false);
    const hasBeenOpened = (0, $lDSNw.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    const [hasHeader, setHasHeader] = (0, $lDSNw.useState)(false);
    const [hasBody, setHasBody] = (0, $lDSNw.useState)(false);
    const uuid = (0, $lDSNw.useId)();
    const uid = id != null ? id : uuid;
    const [triggerId, popoverId, headerId, bodyId] = [
        "popover-trigger",
        "popover-content",
        "popover-header",
        "popover-body"
    ].map((id2)=>`${id2}-${uid}`);
    const { referenceRef: referenceRef, getArrowProps: getArrowProps, getPopperProps: getPopperProps, getArrowInnerProps: getArrowInnerProps, forceUpdate: forceUpdate } = (0, $8e546c4090357a18$export$f4d5bf230a36dd6e)({
        ...popperProps,
        enabled: isOpen || !!computePositionOnMount
    });
    const animated = (0, $29a8efb14c0efed3$export$7ee548861327febe)({
        isOpen: isOpen,
        ref: popoverRef
    });
    (0, $3433b5747f0b1833$export$16a61b931588d888)({
        enabled: isOpen,
        ref: triggerRef
    });
    (0, $0a4488045172e95b$export$68b323438c1fbb28)(popoverRef, {
        focusRef: triggerRef,
        visible: isOpen,
        shouldFocus: returnFocusOnClose && trigger === $515bdff9a4f5789c$var$TRIGGER.click
    });
    (0, $0a4488045172e95b$export$54b5c2a5755195e7)(popoverRef, {
        focusRef: initialFocusRef,
        visible: isOpen,
        shouldFocus: autoFocus && trigger === $515bdff9a4f5789c$var$TRIGGER.click
    });
    const shouldRenderChildren = (0, $62bbd782f684d120$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenOpened.current,
        enabled: isLazy,
        mode: lazyBehavior,
        isSelected: animated.present
    });
    const getPopoverProps = (0, $lDSNw.useCallback)((props2 = {}, _ref = null)=>{
        const popoverProps = {
            ...props2,
            style: {
                ...props2.style,
                transformOrigin: (0, $985d22c34d4a36b5$export$fd62969fb0b7081c).transformOrigin.varRef,
                [(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowSize.var]: arrowSize ? `${arrowSize}px` : void 0,
                [(0, $985d22c34d4a36b5$export$fd62969fb0b7081c).arrowShadowColor.var]: arrowShadowColor
            },
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(popoverRef, _ref),
            children: shouldRenderChildren ? props2.children : null,
            id: popoverId,
            tabIndex: -1,
            role: "dialog",
            onKeyDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onKeyDown, (event)=>{
                if (closeOnEsc && event.key === "Escape") onClose();
            }),
            onBlur: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onBlur, (event)=>{
                const relatedTarget = $515bdff9a4f5789c$var$getRelatedTarget(event);
                const targetIsPopover = $515bdff9a4f5789c$var$contains(popoverRef.current, relatedTarget);
                const targetIsTrigger = $515bdff9a4f5789c$var$contains(triggerRef.current, relatedTarget);
                const isValidBlur = !targetIsPopover && !targetIsTrigger;
                if (isOpen && closeOnBlur && isValidBlur) onClose();
            }),
            "aria-labelledby": hasHeader ? headerId : void 0,
            "aria-describedby": hasBody ? bodyId : void 0
        };
        if (trigger === $515bdff9a4f5789c$var$TRIGGER.hover) {
            popoverProps.role = "tooltip";
            popoverProps.onMouseEnter = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>{
                isHoveringRef.current = true;
            });
            popoverProps.onMouseLeave = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseLeave, (event)=>{
                if (event.nativeEvent.relatedTarget === null) return;
                isHoveringRef.current = false;
                setTimeout(()=>onClose(), closeDelay);
            });
        }
        return popoverProps;
    }, [
        shouldRenderChildren,
        popoverId,
        hasHeader,
        headerId,
        hasBody,
        bodyId,
        trigger,
        closeOnEsc,
        onClose,
        isOpen,
        closeOnBlur,
        closeDelay,
        arrowShadowColor,
        arrowSize
    ]);
    const getPopoverPositionerProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>getPopperProps({
            ...props2,
            style: {
                visibility: isOpen ? "visible" : "hidden",
                ...props2.style
            }
        }, forwardedRef), [
        isOpen,
        getPopperProps
    ]);
    const getAnchorProps = (0, $lDSNw.useCallback)((props2, _ref = null)=>{
        return {
            ...props2,
            // If anchor is rendered, it is used as reference.
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(_ref, anchorRef, referenceRef)
        };
    }, [
        anchorRef,
        referenceRef
    ]);
    const openTimeout = (0, $lDSNw.useRef)();
    const closeTimeout = (0, $lDSNw.useRef)();
    const maybeReferenceRef = (0, $lDSNw.useCallback)((node)=>{
        if (anchorRef.current == null) referenceRef(node);
    }, [
        referenceRef
    ]);
    const getTriggerProps = (0, $lDSNw.useCallback)((props2 = {}, _ref = null)=>{
        const triggerProps = {
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(triggerRef, _ref, maybeReferenceRef),
            id: triggerId,
            "aria-haspopup": "dialog",
            "aria-expanded": isOpen,
            "aria-controls": popoverId
        };
        if (trigger === $515bdff9a4f5789c$var$TRIGGER.click) triggerProps.onClick = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onClick, onToggle);
        if (trigger === $515bdff9a4f5789c$var$TRIGGER.hover) {
            triggerProps.onFocus = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onFocus, ()=>{
                if (openTimeout.current === void 0) onOpen();
            });
            triggerProps.onBlur = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onBlur, (event)=>{
                const relatedTarget = $515bdff9a4f5789c$var$getRelatedTarget(event);
                const isValidBlur = !$515bdff9a4f5789c$var$contains(popoverRef.current, relatedTarget);
                if (isOpen && closeOnBlur && isValidBlur) onClose();
            });
            triggerProps.onKeyDown = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onKeyDown, (event)=>{
                if (event.key === "Escape") onClose();
            });
            triggerProps.onMouseEnter = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>{
                isHoveringRef.current = true;
                openTimeout.current = window.setTimeout(()=>onOpen(), openDelay);
            });
            triggerProps.onMouseLeave = (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>{
                isHoveringRef.current = false;
                if (openTimeout.current) {
                    clearTimeout(openTimeout.current);
                    openTimeout.current = void 0;
                }
                closeTimeout.current = window.setTimeout(()=>{
                    if (isHoveringRef.current === false) onClose();
                }, closeDelay);
            });
        }
        return triggerProps;
    }, [
        triggerId,
        isOpen,
        popoverId,
        trigger,
        maybeReferenceRef,
        onToggle,
        onOpen,
        closeOnBlur,
        onClose,
        openDelay,
        closeDelay
    ]);
    (0, $lDSNw.useEffect)(()=>{
        return ()=>{
            if (openTimeout.current) clearTimeout(openTimeout.current);
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
        };
    }, []);
    const getHeaderProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            id: headerId,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, (node)=>{
                setHasHeader(!!node);
            })
        }), [
        headerId
    ]);
    const getBodyProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            id: bodyId,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, (node)=>{
                setHasBody(!!node);
            })
        }), [
        bodyId
    ]);
    return {
        forceUpdate: forceUpdate,
        isOpen: isOpen,
        onAnimationComplete: animated.onComplete,
        onClose: onClose,
        getAnchorProps: getAnchorProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getPopoverPositionerProps: getPopoverPositionerProps,
        getPopoverProps: getPopoverProps,
        getTriggerProps: getTriggerProps,
        getHeaderProps: getHeaderProps,
        getBodyProps: getBodyProps
    };
}
function $515bdff9a4f5789c$var$contains(parent, child) {
    return parent === child || (parent == null ? void 0 : parent.contains(child));
}
function $515bdff9a4f5789c$var$getRelatedTarget(event) {
    var _a;
    const activeEl = event.currentTarget.ownerDocument.activeElement;
    return (_a = event.relatedTarget) != null ? _a : activeEl;
}



"use client";
var [$d100e637d00baa15$export$bf694c7c431c162a, $d100e637d00baa15$export$1468d0761b26e6c8] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});
var [$d100e637d00baa15$export$286407fa0c94e3f1, $d100e637d00baa15$export$bdabad59d033c81a] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `PopoverStylesContext`,
    errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
});





"use client";
function $477e0f2775c64f2e$export$5b6b19405a83ff9d(props) {
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Popover", props);
    const { children: children, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    const context = (0, $515bdff9a4f5789c$export$542a6fd13ac93354)({
        ...rest,
        direction: theme.direction
    });
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d100e637d00baa15$export$bf694c7c431c162a), {
        value: context,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d100e637d00baa15$export$286407fa0c94e3f1), {
            value: styles,
            children: (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(children, {
                isOpen: context.isOpen,
                onClose: context.onClose,
                forceUpdate: context.forceUpdate
            })
        })
    });
}
$477e0f2775c64f2e$export$5b6b19405a83ff9d.displayName = "Popover";





"use client";
var $ed866da64dbb3b59$var$resolveVar = (scale, value)=>value ? `${scale}.${value}, ${value}` : void 0;
function $ed866da64dbb3b59$export$3152841115e061b2(props) {
    var _a;
    const { bg: bg, bgColor: bgColor, backgroundColor: backgroundColor, shadow: shadow, boxShadow: boxShadow, shadowColor: shadowColor } = props;
    const { getArrowProps: getArrowProps, getArrowInnerProps: getArrowInnerProps } = (0, $d100e637d00baa15$export$1468d0761b26e6c8)();
    const styles = (0, $d100e637d00baa15$export$bdabad59d033c81a)();
    const arrowBg = (_a = bg != null ? bg : bgColor) != null ? _a : backgroundColor;
    const arrowShadow = shadow != null ? shadow : boxShadow;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...getArrowProps(),
        className: "chakra-popover__arrow-positioner",
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
            className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-popover__arrow", props.className),
            ...getArrowInnerProps(props),
            __css: {
                "--popper-arrow-shadow-color": $ed866da64dbb3b59$var$resolveVar("colors", shadowColor),
                "--popper-arrow-bg": $ed866da64dbb3b59$var$resolveVar("colors", arrowBg),
                "--popper-arrow-shadow": $ed866da64dbb3b59$var$resolveVar("shadows", arrowShadow),
                ...styles.arrow
            }
        })
    });
}
$ed866da64dbb3b59$export$3152841115e061b2.displayName = "PopoverArrow";





"use client";
var $0a6464059de3a62e$export$472ec417bca1d382 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function PopoverBody2(props, ref) {
    const { getBodyProps: getBodyProps } = (0, $d100e637d00baa15$export$1468d0761b26e6c8)();
    const styles = (0, $d100e637d00baa15$export$bdabad59d033c81a)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...getBodyProps(props, ref),
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-popover__body", props.className),
        __css: styles.body
    });
});
$0a6464059de3a62e$export$472ec417bca1d382.displayName = "PopoverBody";





"use client";
function $59805e3bb0d0b8f6$var$CloseIcon(props) {
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": true,
        ...props,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    });
}
var $59805e3bb0d0b8f6$export$de65de8213222d10 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function CloseButton2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("CloseButton", props);
    const { children: children, isDisabled: isDisabled, __css: __css, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).button, {
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: {
            ...baseStyle,
            ...styles,
            ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($59805e3bb0d0b8f6$var$CloseIcon, {
            width: "1em",
            height: "1em"
        })
    });
});
$59805e3bb0d0b8f6$export$de65de8213222d10.displayName = "CloseButton";





"use client";
var $b1a9c1b9073ec5cf$export$4c88dacf86a15877 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function PopoverCloseButton2(props, ref) {
    const { onClose: onClose } = (0, $d100e637d00baa15$export$1468d0761b26e6c8)();
    const styles = (0, $d100e637d00baa15$export$bdabad59d033c81a)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $59805e3bb0d0b8f6$export$de65de8213222d10), {
        size: "sm",
        onClick: onClose,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-popover__close-btn", props.className),
        __css: styles.closeButton,
        ref: ref,
        ...props
    });
});
$b1a9c1b9073ec5cf$export$4c88dacf86a15877.displayName = "PopoverCloseButton";





"use client";
function $ba84bd7e45172145$var$mergeVariants(variants) {
    if (!variants) return;
    return {
        enter: {
            ...variants.enter,
            visibility: "visible"
        },
        exit: {
            ...variants.exit,
            transitionEnd: {
                visibility: "hidden"
            }
        }
    };
}
var $ba84bd7e45172145$var$scaleFade = {
    exit: {
        opacity: 0,
        scale: 0.95,
        transition: {
            duration: 0.1,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    },
    enter: {
        scale: 1,
        opacity: 1,
        transition: {
            duration: 0.15,
            ease: [
                0,
                0,
                0.2,
                1
            ]
        }
    }
};
var $ba84bd7e45172145$var$MotionSection = (0, $5c12d9132a121f51$export$7cd122d781af9fa4)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).section);
var $ba84bd7e45172145$export$295130c75b678e2c = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function PopoverTransition2(props, ref) {
    const { variants: variants = $ba84bd7e45172145$var$scaleFade, ...rest } = props;
    const { isOpen: isOpen } = (0, $d100e637d00baa15$export$1468d0761b26e6c8)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($ba84bd7e45172145$var$MotionSection, {
        ref: ref,
        variants: $ba84bd7e45172145$var$mergeVariants(variants),
        initial: false,
        animate: isOpen ? "enter" : "exit",
        ...rest
    });
});
$ba84bd7e45172145$export$295130c75b678e2c.displayName = "PopoverTransition";






"use client";
var $de04819b4e852901$export$d7e1f420b25549ff = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function PopoverContent2(props, ref) {
    const { rootProps: rootProps, motionProps: motionProps, ...contentProps } = props;
    const { getPopoverProps: getPopoverProps, getPopoverPositionerProps: getPopoverPositionerProps, onAnimationComplete: onAnimationComplete } = (0, $d100e637d00baa15$export$1468d0761b26e6c8)();
    const styles = (0, $d100e637d00baa15$export$bdabad59d033c81a)();
    const contentStyles = {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        ...styles.content
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...getPopoverPositionerProps(rootProps),
        __css: styles.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ba84bd7e45172145$export$295130c75b678e2c), {
            ...motionProps,
            ...getPopoverProps(contentProps, ref),
            onAnimationComplete: (0, $a223a0f4c9b3f9de$export$9dd9a52f2dd5b9ce)(onAnimationComplete, contentProps.onAnimationComplete),
            className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-popover__content", props.className),
            __css: contentStyles
        })
    });
});
$de04819b4e852901$export$d7e1f420b25549ff.displayName = "PopoverContent";





"use client";
var $e7f912796dcf7bff$export$24cbcada8f546cfe = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function PopoverHeader2(props, ref) {
    const { getHeaderProps: getHeaderProps } = (0, $d100e637d00baa15$export$1468d0761b26e6c8)();
    const styles = (0, $d100e637d00baa15$export$bdabad59d033c81a)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).header, {
        ...getHeaderProps(props, ref),
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-popover__header", props.className),
        __css: styles.header
    });
});
$e7f912796dcf7bff$export$24cbcada8f546cfe.displayName = "PopoverHeader";



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $b8cdd4baf94d547a$export$7dacb05d26466c3(props) {
    const child = (0, $lDSNw.Children).only(props.children);
    const { getTriggerProps: getTriggerProps } = (0, $d100e637d00baa15$export$1468d0761b26e6c8)();
    return (0, $lDSNw.cloneElement)(child, getTriggerProps(child.props, child.ref));
}
$b8cdd4baf94d547a$export$7dacb05d26466c3.displayName = "PopoverTrigger";




"use client";
var $2603e0709778e5bc$export$e6c02a6dccfa2120 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2e65c9f8b8a92486$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "column",
        ref: ref
    }));
$2603e0709778e5bc$export$e6c02a6dccfa2120.displayName = "VStack";


// THIS FILE IS AUTO GENERATED
var $9a72749df40d6337$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];


var $14ac770f22d16fda$exports = {};

$parcel$export($14ac770f22d16fda$exports, "GenIcon", function () { return $14ac770f22d16fda$export$6fce6cce1e9a936d; });

var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
var $b76d9fe747048608$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $b76d9fe747048608$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createContext($b76d9fe747048608$export$4a4ef469214f8641);


var $14ac770f22d16fda$var$__assign = undefined && undefined.__assign || function() {
    $14ac770f22d16fda$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $14ac770f22d16fda$var$__assign.apply(this, arguments);
};
var $14ac770f22d16fda$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $14ac770f22d16fda$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement(node.tag, $14ac770f22d16fda$var$__assign({
            key: i
        }, node.attr), $14ac770f22d16fda$var$Tree2Element(node.child));
    });
}
function $14ac770f22d16fda$export$6fce6cce1e9a936d(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement($14ac770f22d16fda$export$a188ecdd443fe91a, $14ac770f22d16fda$var$__assign({
            attr: $14ac770f22d16fda$var$__assign({}, data.attr)
        }, props), $14ac770f22d16fda$var$Tree2Element(data.child));
    };
}
function $14ac770f22d16fda$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = $14ac770f22d16fda$var$__rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("svg", $14ac770f22d16fda$var$__assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $14ac770f22d16fda$var$__assign($14ac770f22d16fda$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("title", null, title), props.children);
    };
    return (0, $b76d9fe747048608$export$a49f528ae1a4d0ed) !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $b76d9fe747048608$export$a49f528ae1a4d0ed).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $b76d9fe747048608$export$4a4ef469214f8641));
}





function $f59ac49c6e1fede1$export$2bf3fb3e90d51391(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h2v18H2zm18 0h2v18h-2zM5 13h2v1h2v-1h2v1h2v-1h4v1h2v-4h-2v1h-4v-1h-2v1H9v-1H7v1H5zm0-9v4h2V7h8v1h2V7h2V5h-2V4h-2v1H7V4zm0 13v3h2v-1h2v1h2v-1h8v-2h-8v-1H9v1H7v-1H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e77806a849509fbd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.836 12.014-4.345.725 3.29-4.113a1 1 0 0 0-.227-1.457l-6-4a.999.999 0 0 0-1.262.125l-4 4 1.414 1.414 3.42-3.42 2.584 1.723-2.681 3.352a5.913 5.913 0 0 0-5.5.752l1.451 1.451A3.972 3.972 0 0 1 8 12c2.206 0 4 1.794 4 4 0 .739-.216 1.425-.566 2.02l1.451 1.451A5.961 5.961 0 0 0 14 16c0-.445-.053-.878-.145-1.295L17 14.181V20h2v-7a.998.998 0 0 0-1.164-.986zM8 20c-2.206 0-4-1.794-4-4 0-.739.216-1.425.566-2.02l-1.451-1.451A5.961 5.961 0 0 0 2 16c0 3.309 2.691 6 6 6 1.294 0 2.49-.416 3.471-1.115l-1.451-1.451A3.972 3.972 0 0 1 8 20z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$968617f754132e10(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$799e4ff45bcb7150(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12a7 7 0 0 0-7-7v14a7 7 0 0 0 7-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$67e2883dba1b8aca(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v4H7v2h4v4h2v-4h4v-2h-4zm7.292-1.292-3.01-3 1.412-1.417 3.01 3zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$49194a744441ad47(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c4.879 0 9-4.121 9-9s-4.121-9-9-9-9 4.121-9 9 4.121 9 9 9zm0-16c3.794 0 7 3.206 7 7s-3.206 7-7 7-7-3.206-7-7 3.206-7 7-7zm5.284-2.293 1.412-1.416 3.01 3-1.413 1.417zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$15384bc7c79c8f4b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.292 6.708-3.01-3 1.412-1.417 3.01 3zm1.415 13.585-2.287-2.287C20.409 16.563 21 14.838 21 13c0-4.879-4.121-9-9-9-1.838 0-3.563.591-5.006 1.58L5.91 4.496l.788-.79-1.416-1.412-.786.788-.789-.789-1.414 1.414 18 18 1.414-1.414zM12 6c3.794 0 7 3.206 7 7 0 1.292-.387 2.507-1.027 3.559L15.414 14H17v-2h-3.586L13 11.586V8h-2v1.586L8.441 7.027C9.493 6.387 10.708 6 12 6zM4.305 8.426A8.792 8.792 0 0 0 3 13c0 4.879 4.121 9 9 9a8.792 8.792 0 0 0 4.574-1.305l-1.461-1.461A6.801 6.801 0 0 1 12 20c-3.794 0-7-3.206-7-7 0-1.111.281-2.169.766-3.113L4.305 8.426z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d0f8d2b38f56da0c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7zm8.292-13.292-3.01-3 1.412-1.417 3.01 3zM6.698 3.707l-2.99 2.999L2.29 5.294l2.99-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.832 10.555A1 1 0 0 0 14 9H9v2h3.132l-2.964 4.445A1 1 0 0 0 10 17h5v-2h-3.132l2.964-4.445z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b98c5a0ee2f38944(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12V8h-2v6h6v-2zm4.284-8.293 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4362232cdcda0842(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.99",
                    "cy": "11.99",
                    "r": "2.01"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a6 6 0 0 0-6 6h2a4 4 0 0 1 4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ecb128441f88858e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16v2H4zm0-4h16v2H4zm0 8h16v2H4zm0 4h16v2H4zm2 4h12v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aba8baf44b863532(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm0-4h11v2H4zm0-4h16v2H4zm0-8h16v2H4zm0 4h11v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2a53ccb760cd9a73(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm3-4h10v2H7zm-3-4h16v2H4zm0-8h16v2H4zm3 4h10v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b1b6d7e8df84f1d0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm5-4h11v2H9zm-5-4h16v2H4zm0-8h16v2H4zm5 4h11v2H9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$26b2fc81f2d1d40b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$47766d8eb9a938f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 15-3-4-3 4h1.906c-.436 2.469-2.438 4.471-4.906 4.906V13h2v-2h-2V9.336c1.543-.459 2.714-1.923 2.714-3.621C15.714 3.666 14.048 2 12 2S8.286 3.666 8.286 5.715c0 1.698 1.171 3.162 2.714 3.621V11H9v2h2v6.906C8.531 19.471 6.529 17.469 6.094 15H8l-3-4-3 4h2.073c.511 3.885 3.929 7 7.927 7s7.416-3.115 7.927-7H22zM10.286 5.715C10.286 4.77 11.055 4 12 4s1.714.77 1.714 1.715c0 .951-.801 1.785-1.714 1.785s-1.714-.834-1.714-1.785z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c11bd8ff93c43c83(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3zm-2.439-2.439c.014-.014.023-.03.037-.044l1.031.413.742-1.857-5-2-.742 1.856 1.373.549L7 10.5a1.499 1.499 0 0 0 2.561 1.061zm3.068-1.49.742 1.857 1.037-.415c.011.011.019.024.029.035a1.488 1.488 0 0 0 2.112 0c.271-.271.438-.644.438-1.056l-.001-.01 1.386-.554-.742-1.857-5.001 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b3c6e2d67ed9c5fd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm2.113 13H9.986l-1.723-3.094L10.202 9h3.736l1.871 3.062L14.113 15zM4 12c0-.953.186-1.87.508-2.727L7.696 15H4.61A7.757 7.757 0 0 1 4 12zm12.283-3h3.106A7.74 7.74 0 0 1 20 12c0 .844-.143 1.66-.397 2.432L16.283 9zm1.905-2h-6.653l1.905-2.857c1.886.359 3.562 1.403 4.748 2.857zm-7.095-2.941L9.132 7H9v.197L7.17 9.942 5.65 7.214c1.3-1.703 3.249-2.895 5.443-3.155zM5.812 17h7.147l-1.709 2.961C9.084 19.748 7.141 18.63 5.812 17zm7.828 2.82 3.357-5.815 1.544 2.526c-1.154 1.642-2.901 2.854-4.901 3.289z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$79b04e827ae3efaf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h1v-6.995c.006-.502.177-3.005 3-3.005s2.994 2.503 3 3v7h7v-2h-1V4h1V2H2v2h1v16H2v2h6zM19 4v2H5V4h14zM5 8h14v12h-2v-5c0-1.729-1.045-5-5-5s-5 3.271-5 5v5H5V8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b6bcafa9306b0d10(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-4v3H7l5 5 5-5h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$59d6c74e296501ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h3v3h4v-3h3l-5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fc773aa83381ad42(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.291-2.999-2.998A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.291A.994.994 0 0 0 2 5.999V19c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5.999a.994.994 0 0 0-.294-.708zM6.414 4h11.172l.999.999H5.415L6.414 4zM4 19V6.999h16L20.002 19H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12H9v-2H7v4h10v-4h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca974970354494c4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm16.002 14H5V5h14l.002 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h2V7h-5v2h3zm-3 3H9v-3H7v5h5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$acdb40732972ca79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fd80ab35386d20ec(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm6-14.414-6.707 6.707 1.414 1.414L11 7.414V16h2V7.414l4.293 4.293 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dc0a709301d1b6ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm4 7h8.586l-4.293 4.293 1.414 1.414L20.414 12l-6.707-6.707-1.414 1.414L16.586 11H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2d4d46ad79960a81(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-2 5H7.414l4.293-4.293-1.414-1.414L3.586 12l6.707 6.707 1.414-1.414L7.414 13H16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e9d1e7f7f5fdd975(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm6 16.414 6.707-6.707-1.414-1.414L13 16.586V8h-2v8.586l-4.293-4.293-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$abb8a1c8130ccc52(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm5-14v8.586L6.707 8.293 5.293 9.707 12 16.414l6.707-6.707-1.414-1.414L13 12.586V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4afa981bd2ec10b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10.293-.707L7.586 12l6.707 6.707 1.414-1.414L11.414 13H20v-2h-8.586l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d8f866e775ee443(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zM4 13h8.586l-4.293 4.293 1.414 1.414L16.414 12 9.707 5.293 8.293 6.707 12.586 11H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8a28f7e5531c329a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm.707 11.707L11 11.414V20h2v-8.586l4.293 4.293 1.414-1.414L12 7.586l-6.707 6.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9743b4b6b43c547b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c1.466 0 2.961-.371 4.442-1.104l-.885-1.793C14.353 19.698 13.156 20 12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8v1c0 .692-.313 2-1.5 2-1.396 0-1.494-1.819-1.5-2V8h-2v.025A4.954 4.954 0 0 0 12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5c1.45 0 2.748-.631 3.662-1.621.524.89 1.408 1.621 2.838 1.621 2.273 0 3.5-2.061 3.5-4v-1c0-5.514-4.486-10-10-10zm0 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1a92273912d5be3f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.102 20.898c.698.699 1.696 1.068 2.887 1.068 1.742 0 3.855-.778 6.012-2.127 2.156 1.35 4.27 2.127 6.012 2.127 1.19 0 2.188-.369 2.887-1.068 1.269-1.269 1.411-3.413.401-6.039-.358-.932-.854-1.895-1.457-2.859a16.792 16.792 0 0 0 1.457-2.859c1.01-2.626.867-4.771-.401-6.039-.698-.699-1.696-1.068-2.887-1.068-1.742 0-3.855.778-6.012 2.127-2.156-1.35-4.27-2.127-6.012-2.127-1.19 0-2.188.369-2.887 1.068C1.833 4.371 1.69 6.515 2.7 9.141c.359.932.854 1.895 1.457 2.859A16.792 16.792 0 0 0 2.7 14.859c-1.01 2.626-.867 4.77.402 6.039zm16.331-5.321c.689 1.79.708 3.251.052 3.907-.32.32-.815.482-1.473.482-1.167 0-2.646-.503-4.208-1.38a26.611 26.611 0 0 0 4.783-4.784c.336.601.623 1.196.846 1.775zM12 17.417a23.568 23.568 0 0 1-2.934-2.483A23.998 23.998 0 0 1 6.566 12 23.74 23.74 0 0 1 12 6.583a23.568 23.568 0 0 1 2.934 2.483 23.998 23.998 0 0 1 2.5 2.934A23.74 23.74 0 0 1 12 17.417zm6.012-13.383c.657 0 1.152.162 1.473.482.656.656.638 2.117-.052 3.907-.223.579-.51 1.174-.846 1.775a26.448 26.448 0 0 0-4.783-4.784c1.562-.876 3.041-1.38 4.208-1.38zM4.567 8.423c-.689-1.79-.708-3.251-.052-3.907.32-.32.815-.482 1.473-.482 1.167 0 2.646.503 4.208 1.38a26.448 26.448 0 0 0-4.783 4.784 13.934 13.934 0 0 1-.846-1.775zm0 7.154c.223-.579.51-1.174.846-1.775a26.448 26.448 0 0 0 4.783 4.784c-1.563.877-3.041 1.38-4.208 1.38-.657 0-1.152-.162-1.473-.482-.656-.656-.637-2.117.052-3.907z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2.574"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6ae8286cfce978ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8.999c0 1.902.765 3.627 2 4.89V21a.998.998 0 0 0 1.447.895L12 20.118l3.553 1.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851v-7.11a6.976 6.976 0 0 0 2-4.891C19 5.14 15.86 2 12 2S5 5.14 5 8.999zm7.447 9.106a1 1 0 0 0-.895 0L9 19.382v-4.067c.911.434 1.926.685 3 .685s2.089-.25 3-.685v4.066l-2.553-1.276zM12 4c2.756 0 5 2.242 5 4.999A5.006 5.006 0 0 1 12 14c-2.757 0-5-2.243-5-5.001A5.005 5.005 0 0 1 12 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97f961cad0c07da7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.035 15.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479zm1.442-5.403 1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848l-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.742 10.71-1.408-1.42-3.331 3.299-1.296-1.296-1.414 1.414 2.704 2.704z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$52334fb5538cf90b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479zm-1.442 5.403-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848l1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4da03244d23a866a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.64 21.71a8 8 0 0 0 5.6-2.47l6-6c2.87-2.87 3.31-7.11 1-9.45s-6.58-1.91-9.45 1l-6 6c-2.87 2.87-3.31 7.11-1 9.45a5.38 5.38 0 0 0 3.85 1.47zm-2-9 2.78 2.79 1.42-1.42-2.79-2.79 1.41-1.41 2.83 2.83 1.42-1.42-2.83-2.83 1.41-1.41 2.83 2.83 1.42-1.42-2.79-2.78c2-1.61 4.65-1.87 6-.47s1.09 4.56-1 6.62l-6 6c-2.06 2.05-5.09 2.5-6.62 1s-1.06-4.07.55-6.08z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f48d78c5d5681f58(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.76 21a17.68 17.68 0 0 0 4 .43 13.89 13.89 0 0 0 9.93-3.69C23 12.37 21.06 4.11 21 3.76a1 1 0 0 0-.76-.76 17.91 17.91 0 0 0-4-.43 13.82 13.82 0 0 0-9.96 3.71C.94 11.63 2.94 19.89 3 20.24a1 1 0 0 0 .76.76zM7.7 7.7a11.86 11.86 0 0 1 8.49-3.1 17.57 17.57 0 0 1 3 .25c.31 1.87.91 7.67-2.86 11.44a11.91 11.91 0 0 1-8.55 3.11 17.16 17.16 0 0 1-2.93-.25c-.32-1.88-.92-7.67 2.85-11.45z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.29 15.29 1.42 1.42 1.79-1.79 1.79 1.79 1.42-1.42-1.8-1.79 1.59-1.59 1.79 1.8 1.42-1.42-1.8-1.79 1.8-1.79-1.42-1.42-1.79 1.8-1.79-1.8-1.42 1.42 1.8 1.79-1.59 1.59-1.79-1.8-1.42 1.42 1.8 1.79z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a55768a78d9cce1a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.111 21.889a5.962 5.962 0 0 0 4.242-1.757l7.778-7.778a6.007 6.007 0 0 0 0-8.485 5.965 5.965 0 0 0-4.243-1.757 5.962 5.962 0 0 0-4.242 1.757l-7.778 7.778a6.007 6.007 0 0 0 0 8.485 5.965 5.965 0 0 0 4.243 1.757zm-2.829-8.828 7.778-7.778a3.976 3.976 0 0 1 2.828-1.171c1.069 0 2.073.416 2.829 1.171a4.006 4.006 0 0 1 0 5.657l-7.778 7.778a3.976 3.976 0 0 1-2.828 1.171 3.977 3.977 0 0 1-2.829-1.171 4.008 4.008 0 0 1 0-5.657z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "15",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8f36a4ab2d92275f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-4V4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H4c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9c0-1.103-.897-2-2-2zM4 11h4v8H4v-8zm6-1V4h4v15h-4v-9zm10 9h-4V9h4v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fe0deda55718b38(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h2v11h-2zm4-3h2v14h-2zM9 9h2v8H9zM4 19h16v2H4zm1-7h2v5H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b644b9b9bf4fa43d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm16.001 14H5V5h14l.001 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v10h-2zm4 3h2v7h-2zm-8 2h2v5H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d56105c6d3f2318f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h2v14H9zm4 2h2v12h-2zm4-4h2v16h-2zM5 12h2v8H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$206a44d9e164f65f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7h2v10H5zm9 0h1v10h-1zm-4 0h3v10h-3zM8 7h1v10H8zm8 0h3v10h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h4V3H4c-1.103 0-2 .897-2 2v4h2V5zm0 16h4v-2H4v-4H2v4c0 1.103.897 2 2 2zM20 3h-4v2h4v4h2V5c0-1.103-.897-2-2-2zm0 16h-4v2h4c1.103 0 2-.897 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$46bc625e618f83b8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 18V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h2v8H6zm3 0h1v8H9zm8 0h1v8h-1zm-4 0h3v8h-3zm-2 0h1v8h-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ddc94ed7056fc8b0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2a9.937 9.937 0 0 0-7.071 2.938c-3.898 3.898-3.898 10.243 0 14.143 1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.244 0-14.143A9.937 9.937 0 0 0 11.99 2zm5.657 15.667a7.957 7.957 0 0 1-3.816 2.129l-.001-.037a6.199 6.199 0 0 1 .421-2.259l-1.863-.729a8.188 8.188 0 0 0-.552 3.239 7.953 7.953 0 0 1-5.503-2.344 7.965 7.965 0 0 1-2.332-5.503c.08.002.16.005.24.005a8.16 8.16 0 0 0 2.988-.558l-.73-1.862a6.156 6.156 0 0 1-2.281.412 7.936 7.936 0 0 1 2.115-3.809 7.963 7.963 0 0 1 3.972-2.168 5.974 5.974 0 0 1-.357 1.95l1.881.681a7.92 7.92 0 0 0 .482-2.701c0-.033-.004-.065-.005-.098 2.013.079 3.9.896 5.342 2.336a7.959 7.959 0 0 1 2.324 5.348 7.908 7.908 0 0 0-2.787.473l.684 1.88a5.91 5.91 0 0 1 1.935-.361 7.953 7.953 0 0 1-2.157 3.976z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.112 14.13a7.599 7.599 0 0 0-.926 1.121l1.656 1.12c.2-.296.43-.574.683-.826a6.428 6.428 0 0 1 1.178-.929l-1.049-1.703a8.408 8.408 0 0 0-1.542 1.217zM8.456 8.474a5.713 5.713 0 0 1-.827.681l1.119 1.658a7.72 7.72 0 0 0 1.122-.926 8.501 8.501 0 0 0 1.217-1.542L9.384 7.297a6.519 6.519 0 0 1-.928 1.177z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e36d696224a3672c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.146-5.504-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1-1H6.764L4.31 11h15.38l-2.454 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h2v5H9zm4 0h2v5h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b49a5069d42514d4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.071c1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.243 0-14.143C17.177 3.034 14.665 1.99 12 1.99S6.823 3.034 4.929 4.929c-3.899 3.898-3.899 10.243 0 14.142zm7.38-15.065a7.912 7.912 0 0 1 4.594 1.678L12 10.586l-1.46-1.46c1.161-1.479 1.792-3.308 1.769-5.12zM9.11 7.696 7.098 5.684a7.929 7.929 0 0 1 3.218-1.51c-.015 1.236-.445 2.477-1.206 3.522zM7.686 9.1a6.065 6.065 0 0 1-3.459 1.057 7.923 7.923 0 0 1 1.458-3.058L7.686 9.1zm-3.675 3.046c.077.002.154.014.231.014a8.05 8.05 0 0 0 4.877-1.626L10.586 12l-4.901 4.901a7.972 7.972 0 0 1-1.674-4.755zm12.294 2.745c1.042-.758 2.28-1.188 3.508-1.206a7.947 7.947 0 0 1-1.497 3.217l-2.011-2.011zm.597 3.425a7.935 7.935 0 0 1-3.059 1.47 6.05 6.05 0 0 1 1.057-3.472l2.002 2.002zm-5.044 1.686a7.922 7.922 0 0 1-4.761-1.686L12 13.414l1.463 1.463c-1.103 1.444-1.659 3.266-1.605 5.125zm8.124-8.31c-1.807-.018-3.633.61-5.108 1.768L13.414 12l4.901-4.901a7.968 7.968 0 0 1 1.667 4.593z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$76b1576c5c5ce1e6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H7V7c0-1.103.897-2 2-2s2 .897 2 2h2c0-2.206-1.794-4-4-4S5 4.794 5 7v3H3a1 1 0 0 0-1 1v2c0 2.606 1.674 4.823 4 5.65V22h2v-3h8v3h2v-3.35c2.326-.827 4-3.044 4-5.65v-2a1 1 0 0 0-1-1zm-1 3c0 2.206-1.794 4-4 4H8c-2.206 0-4-1.794-4-4v-1h16v1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c4a045f4a2652dc5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h14c1.103 0 2-.897 2-2v-2h2v-4h-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2zM4 8h14l.002 8H4V8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c019d417139ec929(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.557V3h-2v2H6V3H4v6.557C2.81 10.25 2 11.525 2 13v4a1 1 0 0 0 1 1h1v4h2v-4h12v4h2v-4h1a1 1 0 0 0 1-1v-4c0-1.475-.811-2.75-2-3.443zM18 7v2h-5V7h5zM6 7h5v2H6V7zm14 9H4v-3c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a823d785d5d6e1bb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8zm0 17.735C10.389 18.427 5.979 14.441 6 10c0-3.309 2.691-6 6-6s6 2.691 6 6.005c.021 4.437-4.388 8.423-6 9.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.586 8.707 9.293l-1.414 1.414L11 14.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a09708e29f7a20ad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-1h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-4 13c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1V5h12v14zm4-3h-2V8h2v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h2v10H6zm6 0h2v10h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fa8b1934c2ceb54e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.707 15.293 19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.037 10h7.926v2H8.037z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$120214b0f076ab00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm9-4v-2a.996.996 0 0 0-.293-.707L19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258c-1.323.364-2.463 1.128-3.346 2.127L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.362-1.362A.993.993 0 0 0 21 18zM12 5c2.757 0 5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17h-.586L8.207 6.793C9.12 5.705 10.471 5 12 5zm-5.293 9.707A.996.996 0 0 0 7 14v-2.879L5.068 9.189C5.037 9.457 5 9.724 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h10.879l-2-2H5v-.586l1.707-1.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7b79450551f19714(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.037h-2V10H8.037v2H11v2.963h2V12h2.963v-2H13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9505f35da76e382e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$694451d435fa708(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM5 8V5c0-.805.55-.988 1-1h13v12H5V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-4h2V8h-2V6h-2v2H9v2h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5d6f1f9dbb6fef22(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13v4H6v2h3v2h2v-2h2v2h2v-2.051c1.968-.249 3.5-1.915 3.5-3.949 0-1.32-.65-2.484-1.64-3.213A3.982 3.982 0 0 0 18 9c0-1.858-1.279-3.411-3-3.858V3h-2v2h-2V3H9v2H6v2h2v6zm6.5 4H10v-4h4.5c1.103 0 2 .897 2 2s-.897 2-2 2zM10 7h4c1.103 0 2 .897 2 2s-.897 2-2 2h-4V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d430c4caa4898571(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h12c1.654 0 3-1.346 3-3s-1.346-3-3-3H6v2h13a1 1 0 0 1 0 2H7c-1.654 0-3-1.346-3-3s1.346-3 3-3h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 10H7a4.973 4.973 0 0 0-3 1.002V7c0-1.654 1.346-3 3-3h13v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4be7d0b794f9a3e2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-1.846.634-3.542 1.688-4.897l11.209 11.209A7.946 7.946 0 0 1 12 20c-4.411 0-8-3.589-8-8zm14.312 4.897L7.103 5.688A7.948 7.948 0 0 1 12 4c4.411 0 8 3.589 8 8a7.954 7.954 0 0 1-1.688 4.897z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$45e9249b82c40f9e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.41 16.192 1.18 1.615L10 14.584V21a1 1 0 0 0 1.541.841l7-4.5a.999.999 0 0 0 .049-1.649L13.537 12l5.053-3.692a1.002 1.002 0 0 0-.049-1.65l-7-4.5a1.002 1.002 0 0 0-1.021-.037c-.32.176-.52.513-.52.879v6.416L5.59 6.192 4.41 7.808 10 11.893v.215l-5.59 4.084zM12 4.832l4.232 2.721L12 10.646V4.832zm0 8.522 4.232 3.093L12 19.168v-5.814z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ecea33d560a2d329(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22V9h5V7H4v2h5v13h2v-7h2v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7b8027a59bdb477b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.061 11.22A4.46 4.46 0 0 0 18 8.5C18 6.019 15.981 4 13.5 4H6v15h8c2.481 0 4.5-2.019 4.5-4.5a4.48 4.48 0 0 0-1.439-3.28zM13.5 7c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V7h4.5zm.5 9H9v-3h5c.827 0 1.5.673 1.5 1.5S14.827 16 14 16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bb20460fd8e7b57d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 6-6 7h4v5l6-7h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$60a5b1eef911ca53(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3.001c-1.4 0-2.584 1.167-2.707 1.293L17.207 5.38l-1.091-1.088a.999.999 0 0 0-1.413.001L13.46 5.537A8.353 8.353 0 0 0 10.5 5C5.813 5 2 8.813 2 13.5S5.813 22 10.5 22s8.5-3.813 8.5-8.5c0-.909-.144-1.8-.428-2.658l1.345-1.345a1.002 1.002 0 0 0-.001-1.415l-1.293-1.29 1.088-1.088c.229-.229.845-.703 1.289-.703h1v-2h-1zm-4.511 7.978c.339.804.511 1.652.511 2.521 0 3.584-2.916 6.5-6.5 6.5S4 17.084 4 13.5 6.916 7 10.5 7c.96 0 1.89.21 2.762.624.381.181.837.103 1.136-.196l1.014-1.014 2.384 2.377-1.092 1.092a.998.998 0 0 0-.215 1.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13.5a4.47 4.47 0 0 0 1.318 3.182l1.414-1.414C8.26 14.795 8 14.168 8 13.5s.26-1.295.732-1.768A2.484 2.484 0 0 1 10.5 11V9a4.469 4.469 0 0 0-3.182 1.318A4.47 4.47 0 0 0 6 13.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f4543d3523a9e29a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.049 4.951a3.953 3.953 0 0 0-1.028-1.801c-1.51-1.51-4.146-1.51-5.656 0a4.009 4.009 0 0 0-.618 4.86l-3.714 3.714c-1.505-.89-3.591-.649-4.86.618a4.004 4.004 0 0 0 0 5.657 3.946 3.946 0 0 0 1.8 1.028c.178.681.53 1.302 1.028 1.8A3.966 3.966 0 0 0 8.829 22a3.973 3.973 0 0 0 2.828-1.172 4.007 4.007 0 0 0 .617-4.859l3.714-3.714c1.507.891 3.593.65 4.861-.619a4.003 4.003 0 0 0 0-5.656 3.942 3.942 0 0 0-1.8-1.029zm.387 5.271c-.756.755-2.073.756-2.829 0l-.707-.707-6.363 6.364.707.707a2.003 2.003 0 0 1 0 2.828c-.757.757-2.074.755-2.829 0a1.963 1.963 0 0 1-.571-1.31l-.047-.9-.9-.047a1.972 1.972 0 0 1-1.31-.571 2.003 2.003 0 0 1 0-2.829c.377-.377.879-.585 1.413-.585s1.036.208 1.414.585l.707.707 6.364-6.363-.707-.707a2.003 2.003 0 0 1 0-2.829c.756-.754 2.072-.754 2.828 0 .343.343.546.809.572 1.312l.048.897.897.048c.503.026.969.229 1.312.572.377.378.585.88.585 1.414s-.207 1.036-.584 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3d78f020330f7a11(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.293 8.293-2.069 2.069A7.017 7.017 0 0 0 15 8.681V4h1V2H8v2h1v4.681A7.01 7.01 0 0 0 5 15c0 3.859 3.141 7 7 7s7-3.141 7-7a6.958 6.958 0 0 0-.652-2.934l2.359-2.359-1.414-1.414zm-8.959 1.998.666-.235V4h2v6.056l.666.235A5.006 5.006 0 0 1 16.886 14H7.114a5.006 5.006 0 0 1 3.22-3.709zM12 20a5.007 5.007 0 0 1-4.898-4h9.797A5.009 5.009 0 0 1 12 20z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7af52b48352165(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8v11c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v3zm3-4h13v12H5V5c0-.806.55-.988 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$123ef4735db9ef98(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2zm0 14H5V5c0-.806.55-.988 1-1h13v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1cf32fbe5032559b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2.01H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.998 5 19.815 5 19.01c0-.101.009-.191.024-.273.112-.575.583-.717.987-.727H20c.018 0 .031-.009.049-.01H21V4.01c0-1.103-.897-2-2-2zm0 14H5v-11c0-.806.55-.988 1-1h7v7l2-1 2 1v-7h2v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$82098580f0305256(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h7v14H4zm9 0V5h7l.001 14H13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h3v2h-3zm0 4h3v2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9a2e068642f14f65(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8v11c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v3zm3-4h13v12H5V5c0-.806.55-.988 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.997 14 3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.218-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069L11.997 14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6d7e497f1f358b3d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3h-7a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h5.758c.526 0 1.042.214 1.414.586l1.121 1.121c.009.009.021.012.03.021.086.079.182.149.294.196h.002a.996.996 0 0 0 .762 0h.002c.112-.047.208-.117.294-.196.009-.009.021-.012.03-.021l1.121-1.121A2.015 2.015 0 0 1 15.242 20H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.758 18H4V5h6c.552 0 1 .449 1 1v12.689A4.032 4.032 0 0 0 8.758 18zM20 18h-4.758c-.799 0-1.584.246-2.242.689V6c0-.551.448-1 1-1h6v13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$320dfe9218d3c8ab(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8c-.202 0-4.85.029-9 2.008C7.85 8.029 3.202 8 3 8a1 1 0 0 0-1 1v9.883a1 1 0 0 0 .305.719c.195.188.48.305.729.28l.127-.001c.683 0 4.296.098 8.416 2.025.016.008.034.005.05.011.119.049.244.083.373.083s.254-.034.374-.083c.016-.006.034-.003.05-.011 4.12-1.928 7.733-2.025 8.416-2.025l.127.001c.238.025.533-.092.729-.28.194-.189.304-.449.304-.719V9a1 1 0 0 0-1-1zM4 10.049c1.485.111 4.381.48 7 1.692v7.742c-3-1.175-5.59-1.494-7-1.576v-7.858zm16 7.858c-1.41.082-4 .401-7 1.576v-7.742c2.619-1.212 5.515-1.581 7-1.692v7.858z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f1bc7c2f54ff588e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM5 8V5c0-.805.55-.988 1-1h13v12H5V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h9v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de6f72b540de87df(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h6v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f1d09e9d1202789c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H9v2H7v2h2v2h2v-2h2V9h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$93c33bb8132c3862(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ebce9c6331118af2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.409 9.512c.361-.372.585-.888.585-1.456s-.223-1.083-.585-1.456a1.962 1.962 0 0 0-1.412-.603S13.001 5.994 12 7.026c-1.001-1.032-1.997-1.029-1.997-1.029-.552 0-1.051.23-1.412.603-.362.373-.585.887-.585 1.456s.223 1.084.585 1.456L12 13.203l3.409-3.691z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7a7898f1ceb35013(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b312ba7611840993(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14v-3h3V9h-3V6h-2v3H8v2h3v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6f0b72fcd3e9dbec(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22V4c0-1.103-.897-2-2-2zm0 16.553-6-3.428-6 3.428V4h12v14.553z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b98b567254aaa79f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5H6c-1.103 0-2 .897-2 2v16l6-3.601L16 23V7c0-1.103-.897-2-2-2zm0 14.467-4-2.399-4 2.399V7h8v12.467z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1h-8c-1.103 0-2 .897-2 2h8c1.103 0 2 .897 2 2v10.443l2 2.489V3c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca246191f518b82b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h12V3H3v18h6zm10-4v2h-6v-6h6v4zM15 5h4v6h-6V5h2zM5 7V5h6v6H5V7zm0 12v-6h6v6H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$253719f2ff1c1c1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2v2H3zm0 4h2v2H3zm0 4h2v2H3zM3 3h2v2H3zm8 0h2v2h-2zM7 3h2v2H7zm8 0h2v2h-2zm4 0h2v2h-2zm0 12h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-4 4h2v2h-2zm-8 0h2v2H7zm4-4h2v2h-2zm0 8h2v2h-2zm0-4h2v2h-2zm6 8H3v2h18v-2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$269674a2abcdac3d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zM7 19h2v2H7zm8 0h2v2h-2zM3 19h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm0-4h2v2H3zm12 0h2v2h-2zM7 3h2v2H7zm12 0h2v2h-2zm0 12h2v2h-2zm0-8h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h6v8h2v-8h8v-2h-8V3h-2v8H3v2h1.93z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d00c5efdfdb62234(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3h2v2h-2zm4 0h2v2h-2zM7 3h2v2H7zm12 0h2v2h-2zm0 8h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm0 12h2v2h-2zm-4 0h2v2h-2zm-8 0h2v2H7zm4 0h2v2h-2zm0-4h2v2h-2zm0-8h2v2h-2zm4 4h2v2h-2zm-8 0h2v2H7zm4 0h2v2h-2zM3 5v16h2V3H3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ea7bf9a3ec4ff38(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zm-8 0h2v2h-2zm4 0h2v2h-2zm-8 0h2v2H7zm-4 0h2v2H3zM3 7h2v2H3zm0 8h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm-8-8h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$db23436176eac26f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H3v18h18V3h-2zm0 4v12H5V5h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e0050b50c43d1d33(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zM7 19h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2zm-8 0h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 0h2v2H7zm12 12h2v2h-2zM16 3h-5v2h5c1.654 0 3 1.346 3 3v5h2V8c0-2.757-2.243-5-5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ecb8f95861816d62(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19h2v2h-2zm-4 0h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3zM3 7h2v2H3zm0 8h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm12 0h2v2h-2zm-4 0h2v2h-2zM7 3h2v2H7zm4 4h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2zm8-6v16h2V3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$29c4de8860616e90(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm0 12h2v2h-2zm-8 0h2v2h-2zm4 0h2v2h-2zm-8 0h2v2H7zm-4 0h2v2H3zm0-8h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 4h2v2H7zm8 0h2v2h-2zm-4-4h2v2h-2zm0 8h2v2h-2zm0-4h2v2h-2zm10-8H3v2h18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$82cd39d0ddac22fc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.928 11.607c-.202-.488-.635-.605-.928-.633V8c0-1.103-.897-2-2-2h-6V4.61c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5c-1.103 0-2 .897-2 2v2.997l-.082.006A1 1 0 0 0 1.99 12v2a1 1 0 0 0 1 1H3v5c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5a1 1 0 0 0 1-1v-1.938a1.006 1.006 0 0 0-.072-.455zM5 20V8h14l.001 3.996L19 12v2l.001.005.001 5.995H5z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "8.5",
                    "cy": "12",
                    "rx": "1.5",
                    "ry": "2"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "15.5",
                    "cy": "12",
                    "rx": "1.5",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h8v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5c0f505505271784(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H3a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zm-5.45 8.16a1 1 0 0 0-.55.9V20H9v-.94a1 1 0 0 0-.55-.9A8 8 0 0 1 4.06 12h15.88a8 8 0 0 1-4.39 6.16zM9 9V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 7 3V2H5v1a4.53 4.53 0 0 0 1.28 3.17A2.49 2.49 0 0 1 7 7.93V9zm4 0V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 11 3V2H9v1a4.53 4.53 0 0 0 1.28 3.15A2.49 2.49 0 0 1 11 7.93V9zm4 0V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 15 3V2h-2v1a4.53 4.53 0 0 0 1.28 3.15A2.49 2.49 0 0 1 15 7.93V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$515bb2ca78fb298b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1 3.58 3.58 0 0 0-1.8-3 3.66 3.66 0 0 0-3.63-3.13 3.86 3.86 0 0 0-1 .13 3.7 3.7 0 0 0-5.11 0 3.86 3.86 0 0 0-1-.13A3.66 3.66 0 0 0 4.81 7 3.58 3.58 0 0 0 3 10a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66zm-.89-11 .83-.26-.16-.9a1.64 1.64 0 0 1 1.66-1.62 1.78 1.78 0 0 1 .83.2l.81.45.5-.77a1.71 1.71 0 0 1 2.84 0l.5.77.81-.45a1.78 1.78 0 0 1 .83-.2 1.65 1.65 0 0 1 1.67 1.6l-.16.85.82.28A1.59 1.59 0 0 1 19 10H5a1.59 1.59 0 0 1 1.11-1.39zM19.94 12a8 8 0 0 1-4.39 6.16 1 1 0 0 0-.55.9V20H9v-.94a1 1 0 0 0-.55-.9A8 8 0 0 1 4.06 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fe1879d95da1a52b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ce020a314ffb000c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v2a2 2 0 0 0 1 1.72V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.72A2 2 0 0 0 22 7V5a2 2 0 0 0-2-2zM4 5h16v2H4zm1 14V9h14v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5ea09147989cdb35(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4V2H4v20h6v-2H6V4zm4 16v2h6V2h-6v2h4v16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d4dd3ea0410bcb1a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "17",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "17",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$12eb9ea1c70997ff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.864 8.465a3.505 3.505 0 0 0-3.03-4.449A3.005 3.005 0 0 0 14 2a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 2c-1.301 0-2.41.831-2.825 2.015a3.505 3.505 0 0 0-3.039 4.45A4.028 4.028 0 0 0 2 12c0 1.075.428 2.086 1.172 2.832A4.067 4.067 0 0 0 3 16c0 1.957 1.412 3.59 3.306 3.934A3.515 3.515 0 0 0 9.5 22c.979 0 1.864-.407 2.5-1.059A3.484 3.484 0 0 0 14.5 22a3.51 3.51 0 0 0 3.19-2.06 4.006 4.006 0 0 0 3.138-5.108A4.003 4.003 0 0 0 22 12a4.028 4.028 0 0 0-2.136-3.535zM9.5 20c-.711 0-1.33-.504-1.47-1.198L7.818 18H7c-1.103 0-2-.897-2-2 0-.352.085-.682.253-.981l.456-.816-.784-.51A2.019 2.019 0 0 1 4 12c0-.977.723-1.824 1.682-1.972l1.693-.26-1.059-1.346a1.502 1.502 0 0 1 1.498-2.39L9 6.207V5a1 1 0 0 1 2 0v13.5c0 .827-.673 1.5-1.5 1.5zm9.575-6.308-.784.51.456.816c.168.3.253.63.253.982 0 1.103-.897 2-2.05 2h-.818l-.162.802A1.502 1.502 0 0 1 14.5 20c-.827 0-1.5-.673-1.5-1.5V5c0-.552.448-1 1-1s1 .448 1 1.05v1.207l1.186-.225a1.502 1.502 0 0 1 1.498 2.39l-1.059 1.347 1.693.26A2.002 2.002 0 0 1 20 12c0 .683-.346 1.315-.925 1.692z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2e6dc974cdaaf128(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-5-2v2H9V4h6zM4 8h16v4h-3v-2h-2v2H9v-2H7v2H4V8zm0 11v-5h3v2h2v-2h6v2h2v-2h3.001v5H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$237f5f81b7ece358(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-4 2v11H8V8h8zm-1-4v2H9V4h6zM4 8h2v11H4V8zm14 11V8h2l.001 11H18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$899530e60c03be(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-5-2v2H9V4h6zM8 8h12v3H4V8h4zM4 19v-6h6v2h4v-2h6l.001 6H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e98b008ab1970e4a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.293-2-2L19 8.586V6a1 1 0 0 0-1-1h-2.586l-.707-.707-2-2a.999.999 0 0 0-1.414 0l-2 2L8.586 5H6a1 1 0 0 0-1 1v2.586l-.707.707-2 2a.999.999 0 0 0 0 1.414l2 2 .707.707V18a1 1 0 0 0 1 1h2.586l.707.707 2 2a.997.997 0 0 0 1.414 0l2-2 .707-.707H18a1 1 0 0 0 1-1v-2.586l.707-.707 2-2a.999.999 0 0 0 0-1.414zm-4.414 3-.293.293V17h-2.414l-.293.293-1 1L12 19.586l-1.293-1.293-1-1L9.414 17H7v-2.414l-.293-.293-1-1L4.414 12l1.293-1.293 1-1L7 9.414V7h2.414l.293-.293 1-1L12 4.414l1.293 1.293 1 1 .293.293H17v2.414l.293.293 1 1L19.586 12l-1.293 1.293-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8c2.206 0 4-1.794 4-4s-1.794-4-4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$73cd63736481246a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 9.293 19 8.586V6a1 1 0 0 0-1-1h-2.586l-.707-.707-2-2a.999.999 0 0 0-1.414 0l-2 2L8.586 5H6a1 1 0 0 0-1 1v2.586l-.707.707-2 2a.999.999 0 0 0 0 1.414l2 2 .707.707V18a1 1 0 0 0 1 1h2.586l.707.707 2 2a.997.997 0 0 0 1.414 0l2-2 .707-.707H18a1 1 0 0 0 1-1v-2.586l.707-.707 2-2a.999.999 0 0 0 0-1.414l-2-2zm-2.414 5-.293.293V17h-2.414l-.293.293-1 1L12 19.586l-1.293-1.293-1-1L9.414 17H7v-2.414l-.293-.293-1-1L4.414 12l1.293-1.293 1-1L7 9.414V7h2.414l.293-.293 1-1L12 4.414l1.293 1.293 1 1 .293.293H17v2.414l.293.293 1 1L19.586 12l-1.293 1.293-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c005b417c3cf8580(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.707 4.293-1.414 1.414c2.733 2.733 2.733 7.353 0 10.086l1.414 1.414c3.5-3.5 3.5-9.414 0-12.914zm-4.414 4.414c.566.566.879 1.292.879 2.043s-.313 1.477-.879 2.043l1.414 1.414c.944-.943 1.465-2.172 1.465-3.457s-.521-2.514-1.465-3.457l-1.414 1.414zm-9.086-3L4.793 4.293c-3.5 3.5-3.5 9.414 0 12.914l1.414-1.414c-2.733-2.733-2.733-7.353 0-10.086z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 7.293c-.944.943-1.465 2.172-1.465 3.457s.521 2.514 1.465 3.457l1.414-1.414c-.566-.566-.879-1.292-.879-2.043s.313-1.477.879-2.043L7.293 7.293zM14 10.5a2 2 0 0 0-4 0 1.993 1.993 0 0 0 .895 1.666L10.002 22h3.996l-.893-9.835c.54-.358.895-.97.895-1.665z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2b05f1c6623e6878(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8.001h-4V4.999a2.92 2.92 0 0 0-.874-2.108 2.943 2.943 0 0 0-2.39-.879C10.202 2.144 9 3.508 9 5.117V8H5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-9.999c0-1.103-.897-2-2-2zM5 10h6V5.117c0-.57.407-1.07 1.002-1.117.266 0 .512.103.712.307a.956.956 0 0 1 .286.692V10h.995l.005.001h5V12H5v-2zm0 10v-6h14l.002 6H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6cee0c0281330615(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 2.293a.999.999 0 0 0-1.414 0l-5.84 5.84c-.015-.001-.029-.009-.044-.009a.997.997 0 0 0-.707.293L4.288 9.831a2.985 2.985 0 0 0-.878 2.122c0 .802.313 1.556.879 2.121l.707.707-2.122 2.122A2.92 2.92 0 0 0 2 19.012a2.968 2.968 0 0 0 1.063 2.308c.519.439 1.188.68 1.885.68.834 0 1.654-.341 2.25-.937l2.04-2.039.707.706c1.134 1.133 3.109 1.134 4.242.001l1.415-1.414a.997.997 0 0 0 .293-.707c0-.026-.013-.05-.015-.076l5.827-5.827a.999.999 0 0 0 0-1.414l-8-8zm-.935 16.024a1.023 1.023 0 0 1-1.414-.001l-1.414-1.413a.999.999 0 0 0-1.414 0l-2.746 2.745a1.19 1.19 0 0 1-.836.352.91.91 0 0 1-.594-.208A.978.978 0 0 1 4 19.01a.959.959 0 0 1 .287-.692l2.829-2.829a.999.999 0 0 0 0-1.414L5.701 12.66a.99.99 0 0 1-.292-.706c0-.268.104-.519.293-.708l.707-.707 7.071 7.072-.708.706zm1.889-2.392L8.075 9.339 13 4.414 19.586 11l-4.925 4.925z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ab7465b158038f44(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v2H9zm0 4h6v2H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 5.414 1.707-1.707-1.414-1.414-1.563 1.562C15.483 2.708 13.824 2 12 2s-3.483.708-4.73 1.855L5.707 2.293 4.293 3.707 6 5.414A6.937 6.937 0 0 0 5 9H3v2h2v2H3v2h2c0 3.86 3.141 7 7 7s7-3.14 7-7h2v-2h-2v-2h2V9h-2a6.937 6.937 0 0 0-1-3.586zM17 13v2c0 2.757-2.243 5-5 5s-5-2.243-5-5V9c0-2.757 2.243-5 5-5s5 2.243 5 5v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6afd7cd3e5a4c0b8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.895 6.519 2.813-2.812-1.414-1.414-2.846 2.846a6.575 6.575 0 0 0-.723-.454 5.778 5.778 0 0 0-5.45 0c-.25.132-.488.287-.722.453L5.707 2.293 4.293 3.707l2.813 2.812A8.473 8.473 0 0 0 5.756 9H2v2h2.307c-.065.495-.107.997-.107 1.5 0 .507.042 1.013.107 1.511H2v2h2.753c.013.039.021.08.034.118.188.555.421 1.093.695 1.6.044.081.095.155.141.234l-2.33 2.33 1.414 1.414 2.11-2.111a7.477 7.477 0 0 0 2.068 1.619c.479.253.982.449 1.496.58a6.515 6.515 0 0 0 3.237.001 6.812 6.812 0 0 0 1.496-.58c.465-.246.914-.55 1.333-.904.258-.218.5-.462.734-.716l2.111 2.111 1.414-1.414-2.33-2.33c.047-.08.098-.155.142-.236.273-.505.507-1.043.694-1.599.013-.039.021-.079.034-.118H22v-2h-2.308c.065-.499.107-1.004.107-1.511 0-.503-.042-1.005-.106-1.5H22V9h-3.756a8.494 8.494 0 0 0-1.349-2.481zM8.681 7.748c.445-.558.96-.993 1.528-1.294a3.773 3.773 0 0 1 3.581 0 4.894 4.894 0 0 1 1.53 1.295c.299.373.54.8.753 1.251H7.927c.214-.451.454-.879.754-1.252zM17.8 12.5c0 .522-.042 1.044-.126 1.553-.079.49-.199.973-.355 1.436a8.28 8.28 0 0 1-.559 1.288 7.59 7.59 0 0 1-.733 1.11c-.267.333-.56.636-.869.898-.31.261-.639.484-.979.664s-.695.317-1.057.41c-.04.01-.082.014-.122.023V14h-2v5.881c-.04-.009-.082-.013-.122-.023-.361-.093-.717-.23-1.057-.41s-.669-.403-.978-.664a6.462 6.462 0 0 1-.871-.899 7.402 7.402 0 0 1-.731-1.108 8.337 8.337 0 0 1-.56-1.289 9.075 9.075 0 0 1-.356-1.438A9.61 9.61 0 0 1 6.319 11H17.68c.079.491.12.995.12 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b3b8174c7127c017(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 0 0 .707-1.707L9 9.586V4h10v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f0dfdda6f6c67bb3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm0 18H6V4h12v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h3v2H8zm5 0h3v2h-3zm-5 4h3v2H8zm5 .031h3V12h-3zM8 14h3v2H8zm5 0h3v2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c5cdcb399fe36cf5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H9c-1.103 0-2 .897-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zM5 12h6v8H5v-8zm14 8h-6v-8c0-1.103-.897-2-2-2H9V4h10v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 .001h2v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c804fcdf4567d68e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921H8v2h8v-2h-.774c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363zm-2.724.213c-.434.617-.796 2.075-1.006 3.075h-2.351c-.209-1.002-.572-2.463-1.011-3.08a20.502 20.502 0 0 0-1.196-1.492C7.644 11.294 7 10.544 7 9c0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.521-.643 2.274-1.615 3.413-.373.438-.796.933-1.203 1.512z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9d69550f34b50e44(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 18c-4.337 0-8-3.663-8-8s3.663-8 8-8 8 3.663 8 8-3.663 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.081 0-2 .919-2 2s.919 2 2 2 2-.919 2-2-.919-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7a2062c5660e88d6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.411 7H16v.031A5.037 5.037 0 0 0 14.969 8H15V4.589A8.039 8.039 0 0 1 19.411 9zM12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm1-10.931v3.032a4.988 4.988 0 0 0-2 0V4.069c.328-.041.66-.069 1-.069s.672.028 1 .069zm-4 .52V8h.031A5.037 5.037 0 0 0 8 9.031V9H4.589C5.402 7 6.999 5.402 9 4.589zM4.069 11h3.032a4.995 4.995 0 0 0 .001 2H4.069C4.028 12.672 4 12.339 4 12s.028-.672.069-1zm.52 4H8v-.031c.284.381.621.718 1 1.005v3.437A8.039 8.039 0 0 1 4.589 15zM11 19.931v-3.032a4.988 4.988 0 0 0 2 0v3.032c-.328.041-.66.069-1 .069s-.672-.028-1-.069zm4-.52v-3.437a5.038 5.038 0 0 0 1-1.005V15h3.411A8.039 8.039 0 0 1 15 19.411zM19.931 13h-3.032a4.995 4.995 0 0 0-.001-2h3.032c.042.328.07.661.07 1s-.028.672-.069 1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f4f13bc3ebc3d0b5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.259 11.948A.986.986 0 0 0 22 11V8a.999.999 0 0 0-.996-.999V6H21c0-2.206-1.794-4-4-4H7C4.794 2 3 3.794 3 6v1a1 1 0 0 0-1 1v3c0 .461.317.832.742.948a3.953 3.953 0 0 0-.741 2.298l.004 3.757c.001.733.404 1.369.995 1.716V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.274a2.02 2.02 0 0 0 .421-.313c.377-.378.585-.881.584-1.415l-.004-3.759a3.966 3.966 0 0 0-.742-2.291zM5 18h-.995l-.004-3.757c-.001-.459.161-.89.443-1.243h15.111c.283.353.445.783.446 1.242L20.006 18H5zm6.004-10v3H5V8h6.004zM19 11h-5.996V8H19v3zM7 4h10c1.103 0 2 .897 2 2h-4V5H9v1H5c0-1.103.897-2 2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ffd3b8b1d196f22(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.004 7.975V6c0-2.206-1.794-4-4-4h-10c-2.206 0-4 1.794-4 4v1.998l-.076.004A1 1 0 0 0 2 9v2a1 1 0 0 0 1 1h.004v6c0 .735.403 1.372.996 1.72V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.276A1.994 1.994 0 0 0 21.004 18v-6a1 1 0 0 0 1-1V9.062a1.006 1.006 0 0 0-.072-.455c-.203-.487-.635-.604-.928-.632zM19.006 18H5.004v-5h14.001l.001 5zM11.004 7v4h-6V7h6zm8 0v4h-6V7h6zm-12-3h10c.736 0 1.375.405 1.722 1H5.282c.347-.595.986-1 1.722-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ed9876059d0fc45f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4zM5 4h14v7H5V4zm0 16v-7h14.001v7H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4V6H8v3h8V6h-2zm0 8v1h-4v-1H8v3h8v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7c77630cc8566a5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9.76 9-2.45V10H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-4V6.76l9-2.45V2.24L2 7.69zM11 12v3H7v-3zm6 0v8H7v-3h10v-2h-4v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f56d2840c74492f8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-6V2h-2v3H5C3.346 5 2 6.346 2 8v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.654-1.346-3-3-3zM5 7h14a1 1 0 0 1 1 1l.001 3.12c-.896.228-1.469.734-1.916 1.132-.507.45-.842.748-1.588.748-.745 0-1.08-.298-1.587-.747-.595-.529-1.409-1.253-2.915-1.253-1.505 0-2.319.724-2.914 1.253-.507.45-.841.747-1.586.747-.743 0-1.077-.297-1.582-.747-.447-.398-1.018-.905-1.913-1.133V8a1 1 0 0 1 1-1zM4 18v-4.714c.191.123.374.274.583.461C5.178 14.276 5.991 15 7.495 15c1.505 0 2.319-.724 2.914-1.253.507-.45.841-.747 1.586-.747s1.08.298 1.587.747c.595.529 1.409 1.253 2.915 1.253s2.321-.724 2.916-1.253c.211-.188.395-.34.588-.464L20.002 18H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$995831d1f247544d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM5 20V4h14l.001 16H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zM7 6h10v4H7zm4 10h2v2h-2zm4-4h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1339765c5b271acb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7v2H5a2 2 0 0 0-2 2zm16 14H5V8h14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ccba7e5a6dd58c2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a759bd324b4a74e4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.628 12.183-1.8-1.799 1.37-1.371 1.8 1.799zm-7.623 4.018V18h1.799l4.976-4.97-1.799-1.799z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f4b14fc6ca56b393(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h6v6h-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.001 16H5V8h14l.001 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ada22d2216d6ac3b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cc1bfd380e57ca75(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.648 14.711 11.997 18l3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.219-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bd10fca3b056219d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h8v2H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ddd0c21d480b320b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h3v3h2v-3h3v-2h-3v-3h-2v3H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b9bcc8411a35990e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.981 14.811-.467 2.726 2.449-1.287 2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L11.963 10l-1.225 2.481L8 12.879z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e82c00b8fd777b53(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10v2h10V9H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f93e0038926199a9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.293 16.293 1.414 1.414L12 15.414l2.293 2.293 1.414-1.414L13.414 14l2.293-2.293-1.414-1.414L12 12.586l-2.293-2.293-1.414 1.414L10.586 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$308f12ac724ae49(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a8d4537d18549382(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.125 2H5.875A1.877 1.877 0 0 0 4 3.875v12.25C4 17.159 4.841 18 5.875 18H11v2H7v2h10v-2h-4v-2h5.125A1.877 1.877 0 0 0 20 16.125V3.875A1.877 1.877 0 0 0 18.125 2zM18 16H6V4h12v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e5203f9adc7265bd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c0-.959-.68-1.761-1.581-1.954C16.779 8.445 17 7.75 17 7c0-2.206-1.794-4-4-4-1.517 0-2.821.857-3.5 2.104C8.821 3.857 7.517 3 6 3 3.794 3 2 4.794 2 7c0 .902.312 1.727.817 2.396A1.994 1.994 0 0 0 2 11v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-2.638l4 2v-7l-4 2V11zm-5-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM6 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM4 19v-8h12l.002 8H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$93b2365bd2e7ba81(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.014 12.135c.074 2.062 1.789 3.777 3.851 3.851l-3.851-3.851z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h11.879l-2-2H4V8.121L2.144 6.265A1.976 1.976 0 0 0 2 7v11c0 1.103.897 2 2 2zM20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.997.997 0 0 0-.707.293L6.586 5h-.172L3.707 2.293 2.293 3.707l18 18 1.414-1.414-.626-.626A1.98 1.98 0 0 0 22 18V7c0-1.103-.897-2-2-2zm-6.081 7.505-2.424-2.425c.163-.046.331-.08.505-.08 1.065 0 2 .935 2 2 0 .174-.033.342-.081.505zm1.502 1.501A3.881 3.881 0 0 0 16 12c0-2.168-1.832-4-4-4-.729 0-1.412.22-2.007.579L7.914 6.5l2.5-2.5h3.172l2.707 2.707A.996.996 0 0 0 17 7l3-.001V18h-.586l-3.993-3.994z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$da016fd1f63a5de(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.168 0-4 1.832-4 4s1.832 4 4 4 4-1.832 4-4-1.832-4-4-4zm0 6c-1.065 0-2-.935-2-2s.935-2 2-2 2 .935 2 2-.935 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 18V7h3c.266 0 .52-.105.707-.293L10.414 4h3.172l2.707 2.707A.996.996 0 0 0 17 7h3l.002 11H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a8f5d18a73d4f327(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h1v3h2v-3h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H9V2H7v3H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1zM7 7h2v10H7zm7 10h1v3h2v-3h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4h-2v3h-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm1-8h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7a3f0546a141b1ca(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.999 20.133a4.969 4.969 0 0 0 3.536-1.465l7.134-7.133a5.007 5.007 0 0 0-.001-7.072C18.723 3.52 17.467 3 16.132 3s-2.591.52-3.534 1.464l-7.134 7.134a5.009 5.009 0 0 0 0 7.072 4.97 4.97 0 0 0 3.535 1.463zm5.013-14.255A2.979 2.979 0 0 1 16.132 5c.802 0 1.556.313 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892L11.12 8.77l2.892-2.892zm-7.134 7.134 2.828-2.828 4.242 4.243-2.827 2.827c-1.133 1.133-3.11 1.132-4.243.001a3.005 3.005 0 0 1 0-4.243z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5d731cea62acb993(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10v4c0 1.103.897 2 2 2h3v-2H8v-4h3V8H8c-1.103 0-2 .897-2 2zm7 0v4c0 1.103.897 2 2 2h3v-2h-3v-4h3V8h-3c-1.103 0-2 .897-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6f37cb39275b888d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.156-1.368-4.105A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.105A2.003 2.003 0 0 0 2 12v5c0 .753.423 1.402 1.039 1.743-.013.066-.039.126-.039.195V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0 0 22 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f9cd72e6230c0a24(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.999 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-12c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12zm-12-12h12l.002 10H5.999V5zm-2 14h16v2h-16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ddadb2fdf3fd72ba(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 5-6H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f8d9209c5b662ed3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 5-6H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2046c1716aa0ae5c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.998 17 7-8h-14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8265c3a576270e68(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17V7l-6 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fe0c6acc09c41ef6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17V7l-6 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f6175fc5dcbcb9f2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19V5l-8 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f5c83ad635ef917f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 17 6-5-6-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bf0e0e2bc0c27b79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 17 6-5-6-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fb8de75ec7cc4482(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 19 8-7-8-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$be40bc736f06952d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10l-5-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5931f4968095ddc6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10l-5-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$32043bfb2bc0da5d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14l-7-8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f5f5bb58e7711f0d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h2c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2h2c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2h-2c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2zM20 7v10h-2V7h2zM8 5h8l.001 14H8V5zM4 7h2v10H4V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b6bfdb50a7bdae00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13h2v-2.99h2.99v-2H15V5.03h-2v2.98h-2.99v2H13V13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17h8a1 1 0 0 0 .93-.64L21.76 9h-2.14l-2.31 6h-6.64L6.18 4.23A2 2 0 0 0 4.33 3H2v2h2.33l4.75 11.38A1 1 0 0 0 10 17z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$663f8fd76f1c2a37(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H2v2h2.3l3.28 9a3 3 0 0 0 2.82 2H19v-2h-8.6a1 1 0 0 1-.94-.66L9 13h9.28a2 2 0 0 0 1.92-1.45L22 5.27A1 1 0 0 0 21.27 4 .84.84 0 0 0 21 4zm-2.75 7h-10L6.43 6h13.24z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ffcccceb9c4c4908(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 13.99 4-5h-3v-4h-2v4h-3l4 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.31 15h-6.64L6.18 4.23A2 2 0 0 0 4.33 3H2v2h2.33l4.75 11.38A1 1 0 0 0 10 17h8a1 1 0 0 0 .93-.64L21.76 9h-2.14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9b5c2babbbe5e4c1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921zM17.307 15h-6.64l-2.5-6h11.39l-2.25 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$27dec20038adb00a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21.001h2C13 14.935 8.065 10 2 10v2c4.962 0 9 4.038 9 9.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21.001h2C9 17.141 5.86 14 2 14v2c2.757 0 5 2.243 5 5.001z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v2.052c.68.025 1.349.094 2 .217V6h16v13h-5.269c.123.651.191 1.32.217 2H20c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$861e319455e39c77(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11 4h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6h-4v-4h4v4zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ecfe7e87348d7a8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6H5v-4h4v4zm8-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de9e078d6a4dbe85(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9 8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054 5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71 1.701.68 2-5-1.536-.613.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152 12.162 5.354-2.201 5.013z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b2479a85d064f456(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.06 14.68a1 1 0 0 0 .46.6l1.91 1.11v2.2a1 1 0 0 0 1 1h2.2l1.11 1.91a1 1 0 0 0 .86.5 1 1 0 0 0 .51-.14l1.9-1.1 1.91 1.1a1 1 0 0 0 1.37-.36l1.1-1.91h2.2a1 1 0 0 0 1-1v-2.2l1.91-1.11a1 1 0 0 0 .37-1.36L20.76 12l1.11-1.91a1 1 0 0 0-.37-1.36l-1.91-1.1v-2.2a1 1 0 0 0-1-1h-2.2l-1.1-1.91a1 1 0 0 0-.61-.46 1 1 0 0 0-.76.1L12 3.26l-1.9-1.1a1 1 0 0 0-1.36.36L7.63 4.43h-2.2a1 1 0 0 0-1 1v2.2l-1.9 1.1a1 1 0 0 0-.37 1.37l1.1 1.9-1.1 1.91a1 1 0 0 0-.1.77zm3.22-3.17L4.39 10l1.55-.9a1 1 0 0 0 .49-.86V6.43h1.78a1 1 0 0 0 .87-.5L10 4.39l1.54.89a1 1 0 0 0 1 0l1.55-.89.91 1.54a1 1 0 0 0 .87.5h1.77v1.78a1 1 0 0 0 .5.86l1.54.9-.89 1.54a1 1 0 0 0 0 1l.89 1.54-1.54.9a1 1 0 0 0-.5.86v1.78h-1.83a1 1 0 0 0-.86.5l-.89 1.54-1.55-.89a1 1 0 0 0-1 0l-1.51.89-.89-1.54a1 1 0 0 0-.87-.5H6.43v-1.78a1 1 0 0 0-.49-.81l-1.55-.9.89-1.54a1 1 0 0 0 0-1.05z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3d2077b4f8c31528(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13V4c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v9a1 1 0 0 0-1 1v8h2v-5h12v5h2v-8a1 1 0 0 0-1-1zm-2-9v9h-2V4h2zm-4 0v9h-2V4h2zM7 4h2v9H7V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d22b940c076d1501(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 16V5h16l.001 11H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h4v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$915a41a9c76b0829(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.553 11.658-4-2-2.448 4.895 1.79.894 1.552-3.105 4 2 2.448-4.895-1.79-.894z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b472328df0ee64e2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18v3.766l1.515-.909L11.277 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h1zM4 8h12v8h-5.277L7 18.234V16H4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c84298c0fb5ae4e3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e14872571ad6c4e7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b19dfa3361ebd95a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.9a.998.998 0 0 0-.548-.795l-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897C5.231 16.625 4.911 9.642 4.966 7.635L12 4.118l7.029 3.515c.037 1.989-.328 9.018-7.029 12.264z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 12.586-2.293-2.293-1.414 1.414L11 15.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4b3acde3207a1587(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.933 13.519-2.226-2.226-1.414 1.414 3.774 3.774 5.702-6.84-1.538-1.282z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cf3080c02ad47d63(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b9f7389f6c02dd7e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.996 12.556 9.7 11.285l-1.4 1.43 2.704 2.647 4.699-4.651-1.406-1.422z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a99ef0fd13d45c93(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 11h6v2h-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM7 17V7h10v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$590e5daa56a72adb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17V7c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2zM7 7h10l.002 10H7V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b3d1cb79f176ec3b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$90bce6ed39879d8b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.16 2a1 1 0 0 0-.66.13l-12 7a.64.64 0 0 0-.13.1l-.1.08a1.17 1.17 0 0 0-.17.26.84.84 0 0 0-.1.43v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V10a8.08 8.08 0 0 0-6.84-8zm0 2.05A6.07 6.07 0 0 1 19.93 9H6.7zM20 19H4v-8h16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "16",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$77522efccc3f2993(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ed6940deb80784e2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$915a21b834079cdc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$76c099a8049bb69a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1e996db4bb66466(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c9af122d4caa8a05(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$da8e1139fc0a24ab(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 7.707 13.586 12l-4.293 4.293 1.414 1.414L16.414 12l-5.707-5.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8dab96e56f0bea09(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 7.707 13.586 12l-4.293 4.293 1.414 1.414L16.414 12l-5.707-5.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9766f718116018a1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6e5a85690dc4a183(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ab1b7175030fb2bb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$35d9fb186a9534cd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$475b61eb4f9ccc8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15.586-4.293-4.293-1.414 1.414L12 18.414l5.707-5.707-1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.707 7.707-1.414-1.414L12 10.586 7.707 6.293 6.293 7.707 12 13.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a001e3d5a2622dcf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.707 7.707-1.414-1.414L5.586 12l5.707 5.707 1.414-1.414L8.414 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.293 6.293 10.586 12l5.707 5.707 1.414-1.414L13.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$31f8723d45a03ad1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.296 7.71 14.621 12l-4.325 4.29 1.408 1.42L17.461 12l-5.757-5.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.704 6.29 5.296 7.71 9.621 12l-4.325 4.29 1.408 1.42L12.461 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6f34e3aa3f5d1051(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 11.293 1.414 1.414L12 8.414l4.293 4.293 1.414-1.414L12 5.586z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 16.293 1.414 1.414L12 13.414l4.293 4.293 1.414-1.414L12 10.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7036137dbdba63a8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-4a1 1 0 0 0-.8.4l-3 4 1.6 1.2L9 13v7h2v-4h2v4h2v-7l1.2 1.6 1.6-1.2-3-4A1 1 0 0 0 14 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6160a4bc2b7cf2bc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-1.103-.897-2-2-2h-2V2h-2v2h-4V2H8v2H6c-1.103 0-2 .897-2 2v2H2v2h2v4H2v2h2v2c0 1.103.897 2 2 2h2v2h2v-2h4v2h2v-2h2c1.103 0 2-.897 2-2v-2h2v-2h-2v-4h2V8h-2V6zM6 18V6h12l.002 12H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c7e64c2625738363(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.447 14.105 18 12.382V12a1 1 0 0 0-.485-.857L13 8.434V6h2V4h-2V2h-2v2H9v2h2v2.434l-4.515 2.709A1 1 0 0 0 6 12v.382l-3.447 1.724A.998.998 0 0 0 2 15v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6c0-.379-.214-.725-.553-.895zM4 15.618l2-1V20H4v-4.382zM12 15a2 2 0 0 0-2 2v3H8v-7.434l4-2.4 4 2.4V20h-2v-3a2 2 0 0 0-2-2zm8 5h-2v-5.382l2 1V20z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c165f2ac7570941f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v20h1a10 10 0 0 0 0-20zm1 17.94V4.06a8 8 0 0 1 0 15.88z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$220007b7f3720e41(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v11h11v-1A10 10 0 0 0 12 2zm1 9V4.06A8 8 0 0 1 19.94 11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$865ba662b84276f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v9H2v1a10 10 0 0 0 17.07 7.07A10 10 0 0 0 12 2zm5.66 15.66A8 8 0 0 1 4.06 13H13V4.06a8 8 0 0 1 4.66 13.6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b5b00119dc253f9b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c.001 5.515 4.487 10.001 10 10.001 5.514 0 10-4.486 10.001-10.001 0-5.514-4.486-10-10.001-10zm0 18.001c-4.41 0-7.999-3.589-8-8.001 0-4.411 3.589-8 8-8 4.412 0 8.001 3.589 8.001 8-.001 4.412-3.59 8.001-8.001 8.001z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7510826a18fdc3bc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.707 2.293a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a.999.999 0 0 0 .707-1.707l-9-9zM18.001 20H6v-9.586l6-6 6 6V15l.001 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ac71bd890fe099f4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-2.25a1 1 0 0 0-1-1h-7.5a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 17H5V5h2v2h10V5h2v15z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2f63c901575b75ac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.551v-.678A4.005 4.005 0 0 0 16 6c0-2.206-1.794-4-4-4S8 3.794 8 6h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2a1 1 0 0 0-1 1v1.551l-8.665 7.702A1.001 1.001 0 0 0 3 20h18a1.001 1.001 0 0 0 .664-1.748L13 10.551zM5.63 18 12 12.338 18.37 18H5.63z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6e3f8965e72309e6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.948 11.112C18.511 7.67 15.563 5 12.004 5c-2.756 0-5.15 1.611-6.243 4.15-2.148.642-3.757 2.67-3.757 4.85 0 2.757 2.243 5 5 5h1v-2h-1c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.757 2.673-3.016l.581-.102.192-.558C8.153 8.273 9.898 7 12.004 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-2v2h2c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.004 14v-4h-2v4h-3l4 5 4-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f90be273289a01ad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v3H8zm0 4h2v3H8zm3-2h2v3h-2zm0 4h2v3h-2zm3-6h2v3h-2zm0 4h2v3h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.245 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.582-.103.191-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$47913fbd678e197b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v4H8zm0 5h2v2H8zm3-3h2v4h-2zm0 5h2v2h-2zm3-7h2v4h-2zm0 5h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$96a516b47e1f232d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 13-1 5h2v4l3.975-6H13l1-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$676fa943db61e14(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v7H8zm3 2h2v7h-2zm3-2h2v7h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.113C18.507 6.671 15.56 4.001 12 4.001c-2.756 0-5.15 1.611-6.243 4.15C3.609 8.793 2 10.82 2 13.001c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.274 9.895 6.001 12 6.001c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$93dbaf0f8ca773a5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "19",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "21",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "19",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "16",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c0bc174b8e617dae(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 19v-4h3l-4-5-4 5h3v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h2v-2H7c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.756 2.673-3.015l.581-.102.192-.558C8.149 8.274 9.895 7 12 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-3v2h3c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bd2782b513eb984(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM18 17H7c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.756 2.673-3.015l.581-.102.192-.558C8.149 8.274 9.895 7 12 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c633dc6a510d6999(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8cb77b3e14c1ec70(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 9.293 5.586 13l3.707 3.707 1.414-1.414L8.414 13l2.293-2.293zm5.414 0-1.414 1.414L15.586 13l-2.293 2.293 1.414 1.414L18.414 13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$188992bcb6366fc8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22h1v-2h-.989C8.703 19.994 6 19.827 6 16c0-1.993-.665-3.246-1.502-4C5.335 11.246 6 9.993 6 8c0-3.827 2.703-3.994 3-4h1V2H8.998C7.269 2.004 4 3.264 4 8c0 2.8-1.678 2.99-2.014 3L2 13c.082 0 2 .034 2 3 0 4.736 3.269 5.996 5 6zm13-11c-.082 0-2-.034-2-3 0-4.736-3.269-5.996-5-6h-1v2h.989c.308.006 3.011.173 3.011 4 0 1.993.665 3.246 1.502 4-.837.754-1.502 2.007-1.502 4 0 3.827-2.703 3.994-3 4h-1v2h1.002C16.731 21.996 20 20.736 20 16c0-2.8 1.678-2.99 2.014-3L22 11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c48aebbdefa7e93e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.293 6.293 2.586 12l5.707 5.707 1.414-1.414L5.414 12l4.293-4.293zm7.414 11.414L21.414 12l-5.707-5.707-1.414 1.414L18.586 12l-4.293 4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$214532546a619fe3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h10a1 1 0 0 0 .99-.858L19.867 8H21V6h-1.382l-1.724-3.447A.998.998 0 0 0 17 2H7c-.379 0-.725.214-.895.553L4.382 6H3v2h1.133L6.01 21.142A1 1 0 0 0 7 22zm10.418-11H6.582l-.429-3h11.693l-.428 3zm-9.551 9-.429-3h9.123l-.429 3H7.867zM7.618 4h8.764l1 2H6.618l1-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4e0d1c51f40969c9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v3H5zm4 0h2v3H9zm4 0h2v3h-2zm6 7h-2V7H3v11c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3h2c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-4 9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9h10v9zm2-2v-5h2l.002 5H17z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e23b92de55efbbad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$25979c680dbfa538(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.976 0 8-1.374 8-4V6c0-2.626-4.024-4-8-4S4 3.374 4 6v12c0 2.626 4.024 4 8 4zm0-2c-3.722 0-6-1.295-6-2v-1.268C7.541 17.57 9.777 18 12 18s4.459-.43 6-1.268V18c0 .705-2.278 2-6 2zm0-16c3.722 0 6 1.295 6 2s-2.278 2-6 2-6-1.295-6-2 2.278-2 6-2zM6 8.732C7.541 9.57 9.777 10 12 10s4.459-.43 6-1.268V10c0 .705-2.278 2-6 2s-6-1.295-6-2V8.732zm0 4C7.541 13.57 9.777 14 12 14s4.459-.43 6-1.268V14c0 .705-2.278 2-6 2s-6-1.295-6-2v-1.268z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5fcc4835555b8791(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6C7.03 6 2 7.546 2 10.5v4C2 17.454 7.03 19 12 19s10-1.546 10-4.5v-4C22 7.546 16.97 6 12 6zm-8 8.5v-1.197a9.989 9.989 0 0 0 2 .86v1.881c-1.312-.514-2-1.126-2-1.544zm12 .148v1.971c-.867.179-1.867.31-3 .358v-2a21.75 21.75 0 0 0 3-.329zm-5 2.33a18.788 18.788 0 0 1-3-.358v-1.971c.959.174 1.972.287 3 .33v1.999zm7-.934v-1.881a9.931 9.931 0 0 0 2-.86V14.5c0 .418-.687 1.03-2 1.544zM12 13c-5.177 0-8-1.651-8-2.5S6.823 8 12 8s8 1.651 8 2.5-2.823 2.5-8 2.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$871fe0037bd8118c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15h7v7h2v-9H2v2zM15 2h-2v9h9V9h-7V2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e8f1c76e9e43aae2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.95 5.64 13.59 12l6.36 6.36 1.41-1.41L16.41 12l4.95-4.95-1.41-1.41zM2.64 7.05 7.59 12l-4.95 4.95 1.41 1.41L10.41 12 4.05 5.64 2.64 7.05z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c5e9921818f95297(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.59 7.05 2.64 5.64 4.05 12 10.41l6.36-6.36-1.41-1.41L12 7.59zM5.64 19.95l1.41 1.41L12 16.41l4.95 4.95 1.41-1.41L12 13.59l-6.36 6.36z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$55b1abe50f7a73e3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.121 6.465 14 4.344V10h5.656l-2.121-2.121 3.172-3.172-1.414-1.414zM4.707 3.293 3.293 4.707l3.172 3.172L4.344 10H10V4.344L7.879 6.465zM19.656 14H14v5.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172zM6.465 16.121l-3.172 3.172 1.414 1.414 3.172-3.172L10 19.656V14H4.344z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3411a32825c79144(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H5c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2zM5 20v-8h14l.002 8H5zM5 6h14v2H5zm2-4h10v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca6943a89832faf3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13.998c-.092.065-2 2.083-2 3.5 0 1.494.949 2.448 2 2.5.906.044 2-.891 2-2.5 0-1.5-1.908-3.435-2-3.5zm-16.586-1c0 .534.208 1.036.586 1.414l5.586 5.586c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l7-7-.707-.707L11 4.584 8.707 2.291 7.293 3.705l2.293 2.293L4 11.584c-.378.378-.586.88-.586 1.414zM11 7.412l5.586 5.586L11 18.584h.001l-.001 1v-1l-5.586-5.586L11 7.412z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2ce82419c7783a1a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 13a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm2.75-7.17A5 5 0 0 0 13 7.1v-3a7.94 7.94 0 0 1 3.9 1.62zM11 7.1a5 5 0 0 0-1.75.73L7.1 5.69A7.94 7.94 0 0 1 11 4.07zM7.83 9.25A5 5 0 0 0 7.1 11h-3a7.94 7.94 0 0 1 1.59-3.9zM7.1 13a5 5 0 0 0 .73 1.75L5.69 16.9A7.94 7.94 0 0 1 4.07 13zm2.15 3.17a5 5 0 0 0 1.75.73v3a7.94 7.94 0 0 1-3.9-1.62zm3.75.73a5 5 0 0 0 1.75-.73l2.15 2.14a7.94 7.94 0 0 1-3.9 1.62zm3.17-2.15A5 5 0 0 0 16.9 13h3a7.94 7.94 0 0 1-1.62 3.9zM16.9 11a5 5 0 0 0-.73-1.75l2.14-2.15a7.94 7.94 0 0 1 1.62 3.9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$86e08e4d1150169(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.893 3.001H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h15.893c1.103 0 2-.897 2-2V5a2.003 2.003 0 0 0-2-1.999zM8 19.001H4V8h4v11.001zm6 0h-4V8h4v11.001zm2 0V8h3.893l.001 11.001H16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c0bda049f729c0c1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14c-2.206 0-4 1.794-4 4s1.794 4 4 4a4.003 4.003 0 0 0 3.998-3.98H10V16h4v2.039h.004A4.002 4.002 0 0 0 18 22c2.206 0 4-1.794 4-4s-1.794-4-4-4h-2v-4h2c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4v2h-4V5.98h-.002A4.003 4.003 0 0 0 6 2C3.794 2 2 3.794 2 6s1.794 4 4 4h2v4H6zm2 4c0 1.122-.879 2-2 2s-2-.878-2-2 .879-2 2-2h2v2zm10-2c1.121 0 2 .878 2 2s-.879 2-2 2-2-.878-2-2v-2h2zM16 6c0-1.122.879-2 2-2s2 .878 2 2-.879 2-2 2h-2V6zM6 8c-1.121 0-2-.878-2-2s.879-2 2-2 2 .878 2 2v2H6zm4 2h4v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c4218d4ff4b5d0d0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bbf57797b9d8c680(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 8.207-1.414-1.414L11 11.586 8.707 9.293l-1.414 1.414L11 14.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fc4cb3506fbc03ff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4e220f504caba76f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1eb1a1b49aaa918b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.771 9.123-1.399-1.398-3.869 3.864v1.398h1.398zM14.098 6l1.398 1.398-1.067 1.067-1.398-1.398z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$847bcbb314a8648e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$22324a0345d17afe(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$59ca7713fb73b36c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d1206aab82093965(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3fa78c100091d25a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 5.991-2L16 8l-6 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d66bed06d4cf99ef(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.124 16.992-.248-1.984 8-1 .248 1.984z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a469f359288b06ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h.5c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5h-13C2.673 2 2 2.673 2 3.5V18l5.333-4H16zm-9.333-2L4 14V4h12v8H6.667z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 8H20v6.001c0 1.1-.893 1.993-1.99 1.999H8v.5c0 .827.673 1.5 1.5 1.5h7.167L22 22V9.5c0-.827-.673-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d03aae0c8d832f5e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.937.005-.034.016-.136.017-.17a.998.998 0 0 0-1.254-1.006A2.963 2.963 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM12 20c-4.411 0-8-3.589-8-8a7.962 7.962 0 0 1 6.006-7.75A5.006 5.006 0 0 0 15 9l.101-.001a5.007 5.007 0 0 0 4.837 4C19.444 16.941 16.073 20 12 20z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "8.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c533a80aec893a15(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.683 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.035 6.035 0 0 0 3.542-.35 6.048 6.048 0 0 0 1.907-1.284c.272-.271.52-.571.734-.889l-1.658-1.119a4.147 4.147 0 0 1-.489.592z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 2c2.953 0 5.531 1.613 6.918 4H5.082C6.469 5.613 9.047 4 12 4zm0 16c-4.411 0-8-3.589-8-8 0-.691.098-1.359.264-2H5v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2h2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h.736c.166.641.264 1.309.264 2 0 4.411-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97997cc6c575ffb8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h6v2H6zm0 4h6v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bb4f32e7db64cba7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4dfb046d0b638df5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.421 0 10-4.579 10-10S17.421 2 12 2 2 6.579 2 12s4.579 10 10 10zm0-18c4.337 0 8 3.663 8 8s-3.663 8-8 8-8-3.663-8-8 3.663-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c.901 0 2.581-.168 3.707-1.292l-1.414-1.416C13.85 14.735 12.992 15 12 15c-1.626 0-3-1.374-3-3s1.374-3 3-3c.993 0 1.851.265 2.293.707l1.414-1.414C14.582 7.168 12.901 7 12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9680404f9e3786b9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5c0-.815.396-1.532 1-1.988A2.47 2.47 0 0 0 11.5 11a2.5 2.5 0 1 0 0 5 2.47 2.47 0 0 0 1.5-.512 2.486 2.486 0 0 1-1-1.988z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$63e50420157b13d4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.001 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 11h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5zM6 14h6v2.001H6zm7 0h5v2.001h-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a3acdccb43e92c71(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 6h16v2H4V6zm0 12v-6h16.001l.001 6H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h6v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$18611da51bb1ee12(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93A10 10 0 0 0 4.93 19.07 10 10 0 0 0 19.07 4.93zM6.34 6.34a8 8 0 0 1 8.78-1.71l-.29.3.71.71.52-.53a9.53 9.53 0 0 1 .84.57L5.68 16.9a9.53 9.53 0 0 1-.57-.84l.53-.52-.71-.71-.29.29a8 8 0 0 1 1.7-8.78zm11.32 11.32a8 8 0 0 1-8.78 1.71l.29-.3-.71-.71-.52.53a9.53 9.53 0 0 1-.84-.57L18.32 7.1a9.53 9.53 0 0 1 .57.84l-.53.52.71.71.29-.29a8 8 0 0 1-1.7 8.78zm-6.37-2.12.71.7-1.41 1.42-.71-.66zm2.83-2.83.71.7-1.42 1.42-.7-.71zM17 9.88l.71.71L16.24 12l-.7-.71zm-4.29-1.42-.71-.7 1.41-1.42.71.71zm-2.83 2.83-.71-.7 1.42-1.42.7.71zm-2.83 2.83-.71-.71L7.76 12l.7.71z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e61520984eed4d32(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.103-.897-2-2-2H7V2H5v3H2v2h15v15h2v-3h3v-2h-3V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9v8c0 1.103.897 2 2 2h8v-2H7V9H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7a9b4da1a128de89(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v7h-2zm0 13h2v7h-2zm4-4h7v2h-7zM2 11h7v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aaa53e8673e379f0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 17.931V17h-2v2.931A8.008 8.008 0 0 1 4.069 13H7v-2H4.069A8.008 8.008 0 0 1 11 4.069V7h2V4.069A8.007 8.007 0 0 1 19.931 11H17v2h2.931A8.008 8.008 0 0 1 13 19.931z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$41ab892c02c92cac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.219 3.375 8 7.399 4.781 3.375A1.002 1.002 0 0 0 3 4v15c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4a1.002 1.002 0 0 0-1.781-.625L16 7.399l-3.219-4.024c-.381-.474-1.181-.474-1.562 0zM5 19v-2h14.001v2H5zm10.219-9.375c.381.475 1.182.475 1.563 0L19 6.851 19.001 15H5V6.851l2.219 2.774c.381.475 1.182.475 1.563 0L12 5.601l3.219 4.024z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7cb3d1963e1a586(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.895 3.553A1.001 1.001 0 0 0 17 3H7c-.379 0-.725.214-.895.553l-4 8a1 1 0 0 0 0 .895l4 8c.17.338.516.552.895.552h10c.379 0 .725-.214.895-.553l4-8a1 1 0 0 0 0-.895l-4-7.999zM19.382 11h-7.764l-3-6h7.764l3 6zM4.118 12 7 6.236 9.882 12 7 17.764 4.118 12zm12.264 7H8.618l3-6h7.764l-3 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a1e9299b31fc8ed6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.406 6.086-9-4a1.001 1.001 0 0 0-.813 0l-9 4c-.02.009-.034.024-.054.035-.028.014-.058.023-.084.04-.022.015-.039.034-.06.05a.87.87 0 0 0-.19.194c-.02.028-.041.053-.059.081a1.119 1.119 0 0 0-.076.165c-.009.027-.023.052-.031.079A1.013 1.013 0 0 0 2 7v10c0 .396.232.753.594.914l9 4c.13.058.268.086.406.086a.997.997 0 0 0 .402-.096l.004.01 9-4A.999.999 0 0 0 22 17V7a.999.999 0 0 0-.594-.914zM12 4.095 18.538 7 12 9.905l-1.308-.581L5.463 7 12 4.095zM4 16.351V8.539l7 3.111v7.811l-7-3.11zm9 3.11V11.65l7-3.111v7.812l-7 3.11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$623ce768397a7a79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 0 0 .227 1.066l5 5A.996.996 0 0 0 8 22h8c.414 0 .785-.255.934-.641l5-13a.999.999 0 0 0-.227-1.066l-5-5zM18.585 7h-5.171l-3-3h5.172l2.999 3zM8.381 4.795l3.438 3.438-4.462 10.71-3.19-3.191L8.381 4.795zM15.313 20h-6.23l4.583-11h5.878l-4.231 11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fa48e07a2c34c9ac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.069V2h-2v2.069A8.01 8.01 0 0 0 4.069 11H2v2h2.069A8.008 8.008 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d8babaee8afd14a4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4H5V5zm15-2h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6zm-5-6h4v4H5v-4zm13-1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ec2f1b482648b4da(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6.5C10 4.57 8.43 3 6.5 3S3 4.57 3 6.5 4.57 10 6.5 10a3.45 3.45 0 0 0 1.613-.413l2.357 2.528-2.318 2.318A3.46 3.46 0 0 0 6.5 14C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21s3.5-1.57 3.5-3.5c0-.601-.166-1.158-.434-1.652l2.269-2.268L17 19.121a3 3 0 0 0 2.121.879H22L9.35 8.518c.406-.572.65-1.265.65-2.018zM6.5 8C5.673 8 5 7.327 5 6.5S5.673 5 6.5 5 8 5.673 8 6.5 7.327 8 6.5 8zm0 11c-.827 0-1.5-.673-1.5-1.5S5.673 16 6.5 16s1.5.673 1.5 1.5S7.327 19 6.5 19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 4.879-3.707 4.414 1.414 1.414L22 4h-2.879A3 3 0 0 0 17 4.879z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8689a7406c82a5ae(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15.414V20h2v-4.586c0-.526-.214-1.042-.586-1.414l-2-2L13 9.414l2 2c.372.372.888.586 1.414.586H20v-2h-3.586l-3.707-3.707a.999.999 0 0 0-1.414 0L8 9.586c-.378.378-.586.88-.586 1.414s.208 1.036.586 1.414l3 3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM6 22c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$86ecdb499dd74218(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.131 0 9-1.935 9-4.5V7h-.053c.033-.164.053-.33.053-.5C21 3.935 17.131 2 12 2 7.209 2 3.52 3.688 3.053 6H3v11.5c0 2.565 3.869 4.5 9 4.5zm0-2c-4.273 0-7-1.48-7-2.5V9.394C6.623 10.387 9.111 11 12 11s5.377-.613 7-1.606V17.5c0 1.02-2.727 2.5-7 2.5zm0-16c4.273 0 7 1.48 7 2.5S16.273 9 12 9 5 7.52 5 6.5 7.727 4 12 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$57d134ada4168ff3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17V7c0-2.168-3.663-4-8-4S4 4.832 4 7v10c0 2.168 3.663 4 8 4s8-1.832 8-4zM12 5c3.691 0 5.931 1.507 6 1.994C17.931 7.493 15.691 9 12 9S6.069 7.493 6 7.006C6.069 6.507 8.309 5 12 5zM6 9.607C7.479 10.454 9.637 11 12 11s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2V9.607zM6 17v-2.393C7.479 15.454 9.637 16 12 16s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2f97d4e24c23ab86(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h7v2H8v2h8v-2h-3v-2h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 14V5h16l.002 9H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c1be82127ecfe0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h16l.002 14H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h12v2H6zm0 4h12v2H6zm0 4h6v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$38121a7245ca4ad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H7c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9.997 19H4V9h6l-.003 10zm10-2H12V9c0-1.103-.897-2-2-2H7V5h13l-.003 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$41bb9c8f9645e1e4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3e8d0f22bbd495ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h4v3h-4zm0 5h4v3h-4zm0 5h4v3h-4zm6-10h4v3h-4zm0 5h4v3h-4zm0 5h4v3h-4zM4 3h4v3H4zm0 5h4v3H4zm0 5h4v3H4zm6 5h4v3h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$77f2a6ff848c37a6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.813 3.838A2 2 0 0 0 16.187 3H7.813c-.644 0-1.252.313-1.667.899l-4 6.581a.999.999 0 0 0 .111 1.188l9 10a.995.995 0 0 0 1.486.001l9-10a.997.997 0 0 0 .111-1.188l-4.041-6.643zM12 19.505 5.245 12h13.509L12 19.505zM4.777 10l3.036-5 8.332-.062L19.222 10H4.777z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3b1bc8a804861384(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$91fa380ef37c610e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3dbcd47c2d4511f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e0f1f0de6f27d80d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$80c5219f8a1cb23(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$895f5dae278f817f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ccfe039c44079a16(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.781 13.875-2-2.5A1 1 0 0 0 19 11h-6V9h6c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5a1 1 0 0 0-.781.375l-2 2.5a1.001 1.001 0 0 0 0 1.25l2 2.5A1 1 0 0 0 5 9h6v2H5c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h6v4h2v-4h6a1 1 0 0 0 .781-.375l2-2.5a1.001 1.001 0 0 0 0-1.25zM4.281 5.5 5.48 4H19l.002 3H5.48L4.281 5.5zM18.52 16H5v-3h13.52l1.2 1.5-1.2 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$10dfe9df6ba0ab1a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$88afd66e78e9fba2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15c0-4.625-3.507-8.441-8-8.941V4h-2v2.059c-4.493.5-8 4.316-8 8.941v2h18v-2zM5 15c0-3.859 3.141-7 7-7s7 3.141 7 7H5zm-3 3h20v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$af0293d11edcc260(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H6.693A2.01 2.01 0 0 0 4.82 4.298l-2.757 7.351A1 1 0 0 0 2 12v2c0 1.103.897 2 2 2h5.612L8.49 19.367a2.004 2.004 0 0 0 .274 1.802c.376.52.982.831 1.624.831H12c.297 0 .578-.132.769-.36l4.7-5.64H20c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-8.469 17h-1.145l1.562-4.684A1 1 0 0 0 11 14H4v-1.819L6.693 5H16v9.638L11.531 20zM18 14V5h2l.001 9H18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$db4fd13c14fd8798(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 12.293 9.414 11l1.293-1.293-1.414-1.414L8 9.586 6.707 8.293 5.293 9.707 6.586 11l-1.293 1.293 1.414 1.414L8 12.414l1.293 1.293zm6.586-4L16 9.586l-1.293-1.293-1.414 1.414L14.586 11l-1.293 1.293 1.414 1.414L16 12.414l1.293 1.293 1.414-1.414L17.414 11l1.293-1.293zM10 16h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$57e54b1f62fc96f7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.794 11.09c.332-.263.648-.542.947-.84l.136-.142c.283-.293.552-.598.801-.919l.062-.075c.255-.335.486-.688.702-1.049l.128-.22c.205-.364.395-.737.559-1.123.02-.047.035-.095.055-.142.147-.361.274-.731.383-1.109.021-.07.044-.14.063-.211.107-.402.189-.813.251-1.229.013-.087.021-.175.032-.263.051-.432.087-.869.087-1.311V2h-2v.457c0 .184-.031.361-.042.543H6.022C6.012 2.819 6 2.64 6 2.457V2H4v.457c0 4.876 3.269 9.218 7.952 10.569l.028.009c2.881.823 5.056 3.146 5.769 5.965H6.251l.799-2h7.607a7.416 7.416 0 0 0-2.063-2h-4c.445-.424.956-.774 1.491-1.09a9.922 9.922 0 0 1-2.08-1.014C5.55 14.812 4 17.779 4 21.015V23h2v-1.985L6.001 21h11.998l.001.015V23h2v-1.985c0-3.83-2.159-7.303-5.443-9.07a11.1 11.1 0 0 0 1.072-.729c.055-.042.11-.082.165-.126zm-1.19-1.604a8.945 8.945 0 0 1-2.325 1.348c-.092.036-.185.068-.278.102A8.95 8.95 0 0 1 8.836 9h6.292c-.171.161-.332.333-.517.48l-.007.006zM17.619 5c-.005.016-.007.033-.012.049l-.044.151a9.089 9.089 0 0 1-.513 1.252c-.096.19-.213.365-.321.548h-9.48a9.066 9.066 0 0 1-.871-2h11.241z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$23f78314831bb9a5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v9H5V5zM5 19v-3h14v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$565cd00d7eefe7ae(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 5h3v14H5zm5 14V5h9v14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d42aa1155316ba96(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 5h9v14H5zm11 14V5h3v14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3b7113ce77c9ecfe(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v3H5V5zM5 19v-9h14v9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$deb842918359b2f5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1e3d21bca2c1c6a1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.999 8.5h2c0-2.837-2.755-4.131-5-4.429V2h-2v2.071c-2.245.298-5 1.592-5 4.429 0 2.706 2.666 4.113 5 4.43v4.97c-1.448-.251-3-1.024-3-2.4h-2c0 2.589 2.425 4.119 5 4.436V22h2v-2.07c2.245-.298 5-1.593 5-4.43s-2.755-4.131-5-4.429V6.1c1.33.239 3 .941 3 2.4zm-8 0c0-1.459 1.67-2.161 3-2.4v4.799c-1.371-.253-3-1.002-3-2.399zm8 7c0 1.459-1.67 2.161-3 2.4v-4.8c1.33.239 3 .941 3 2.4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$461837172998129c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h9.62a3.995 3.995 0 0 0 3.037-1.397l5.102-5.952a1 1 0 0 0-.442-1.6l-1.968-.656a3.043 3.043 0 0 0-2.823.503l-3.185 2.547-.617-1.235A3.98 3.98 0 0 0 9.146 11H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h5.146c.763 0 1.448.423 1.789 1.105l.447.895H7v2h6.014a.996.996 0 0 0 .442-.11l.003-.001.004-.002h.003l.002-.001h.004l.001-.001c.011.003.003-.001.003-.001.012 0 .002-.001.002-.001h.001l.002-.001.003-.001.002-.001.002-.001.003-.001.002-.001.002-.001.003-.002.002-.001.002-.001.003-.001.002-.001h.001l.002-.001h.001l.002-.001.002-.001c.011-.001.003-.001.003-.001l.002-.001a.915.915 0 0 0 .11-.078l4.146-3.317c.261-.208.623-.273.94-.167l.557.186-4.133 4.823a2.029 2.029 0 0 1-1.52.688H4v-6zm9.761-10.674C13.3 2.832 11 5.457 11 7.5c0 1.93 1.57 3.5 3.5 3.5S18 9.43 18 7.5c0-2.043-2.3-4.668-2.761-5.174-.379-.416-1.099-.416-1.478 0zM16 7.5c0 .827-.673 1.5-1.5 1.5S13 8.327 13 7.5c0-.708.738-1.934 1.5-2.934.762 1 1.5 2.226 1.5 2.934z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$524e901f25a7a5e9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h9.62a3.995 3.995 0 0 0 3.037-1.397l5.102-5.952a1 1 0 0 0-.442-1.6l-1.968-.656a3.043 3.043 0 0 0-2.823.503l-3.185 2.547-.617-1.235A3.98 3.98 0 0 0 9.146 11H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h5.146c.763 0 1.448.423 1.789 1.105l.447.895H7v2h6.014a.996.996 0 0 0 .442-.11l.003-.001.004-.002h.003l.002-.001h.004l.001-.001c.009.003.003-.001.003-.001.01 0 .002-.001.002-.001h.001l.002-.001.003-.001.002-.001.002-.001.003-.001.002-.001c.003 0 .001-.001.002-.001l.003-.002.002-.001.002-.001.003-.001.002-.001h.001l.002-.001h.001l.002-.001.002-.001c.009-.001.003-.001.003-.001l.002-.001a.915.915 0 0 0 .11-.078l4.146-3.317c.262-.208.623-.273.94-.167l.557.186-4.133 4.823a2.029 2.029 0 0 1-1.52.688H4v-6zM16 2h-.017c-.163.002-1.006.039-1.983.705-.951-.648-1.774-.7-1.968-.704L12.002 2h-.004c-.801 0-1.555.313-2.119.878C9.313 3.445 9 4.198 9 5s.313 1.555.861 2.104l3.414 3.586a1.006 1.006 0 0 0 1.45-.001l3.396-3.568C18.688 6.555 19 5.802 19 5s-.313-1.555-.878-2.121A2.978 2.978 0 0 0 16.002 2H16zm1 3c0 .267-.104.518-.311.725L14 8.55l-2.707-2.843C11.104 5.518 11 5.267 11 5s.104-.518.294-.708A.977.977 0 0 1 11.979 4c.025.001.502.032 1.067.485.081.065.163.139.247.222l.707.707.707-.707c.084-.083.166-.157.247-.222.529-.425.976-.478 1.052-.484a.987.987 0 0 1 .701.292c.189.189.293.44.293.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2f30aeef1870bf2e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.385 21.788a.997.997 0 0 0 .857.182l8-2A.999.999 0 0 0 20 19V5a1 1 0 0 0-.758-.97l-8-2A1.003 1.003 0 0 0 10 3v1H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4v1c0 .308.142.599.385.788zM12 4.281l6 1.5v12.438l-6 1.5V4.281zM7 18V6h3v12H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.242 13.159c.446-.112.758-.512.758-.971v-.377a1 1 0 1 0-2 .001v.377a1 1 0 0 0 1.242.97z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$57b8d0c931fadc2e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f68ebf6c67628dd9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3c606ea54a9db5c9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$51c628f460505b72(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4v4h-4zm0-6h4v4h-4zm0 12h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f470d8598a151bb9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-3.032A5.013 5.013 0 0 0 13 7.102V4.069A8.008 8.008 0 0 1 19.931 11zM12 9c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 11c-4.411 0-8-3.589-8-8 0-4.072 3.061-7.436 7-7.931v3.032A5.009 5.009 0 0 0 7 12c0 2.757 2.243 5 5 5a5.007 5.007 0 0 0 4.898-4h3.032c-.494 3.939-3.858 7-7.93 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4afe1dd8ff36850f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.707 12.707-1.414-1.414L13 15.586V6h-2v9.586l-4.293-4.293-1.414 1.414L12 19.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$16228af8ac53ecce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.993C6.486 1.994 2 6.48 2 11.994c0 5.513 4.486 9.999 10 10 5.514 0 10-4.486 10-10s-4.485-10-10-10.001zm0 18.001c-4.411-.001-8-3.59-8-8 0-4.411 3.589-8 8-8.001 4.411.001 8 3.59 8 8.001s-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v4H7.991l4.005 4.005L16 12h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$10dfc656fb07a41e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.886 5.536A1.002 1.002 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13a.998.998 0 0 0 1.644 0l9-13a.998.998 0 0 0 .064-1.033zM12 17.243 4.908 7h14.184L12 17.243z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$50537374d2a9e540(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 4-5h-3V4h-2v7H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1818c7adc786527d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.901 10.566A1.001 1.001 0 0 0 20 10h-4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v7H4a1.001 1.001 0 0 0-.781 1.625l8 10a1 1 0 0 0 1.562 0l8-10c.24-.301.286-.712.12-1.059zM12 19.399 6.081 12H10V4h4v8h3.919L12 19.399z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5bd1116e31709694(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zM12 14.197 8.535 9h6.93L12 14.197zM18.132 5l-1.333 2H7.201L5.868 5h12.264z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca2e012f3d881fee(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c4.636 0 8-3.468 8-8.246C20 7.522 12.882 2.4 12.579 2.185a1 1 0 0 0-1.156-.001C11.12 2.397 4 7.503 4 13.75 4 18.53 7.364 22 12 22zm-.001-17.74C13.604 5.55 18 9.474 18 13.754 18 17.432 15.532 20 12 20s-6-2.57-6-6.25c0-4.29 4.394-8.203 5.999-9.49z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2c405fb3e2e6c1c6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5v14h3v-6h6v6h3V5h-3v6H9V5zM3 15a1 1 0 0 0 1 1h1V8H4a1 1 0 0 0-1 1v2H2v2h1v2zm18-6a1 1 0 0 0-1-1h-1v8h1a1 1 0 0 0 1-1v-2h1v-2h-1V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$38d8bf7c47627e51(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H9v3H6v2h3v3h2v-3h3v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2zM4 8h12l.002 12H4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b356bf779563cd1e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6ee1f0da132eebe0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 17.013 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.583v4.43zM18.045 4.458l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58zM9 13.417l6.03-5.973 1.586 1.586-6.029 5.971L9 15.006v-1.589z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f3371ea50c76c4c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.555 8.168-9-6a1 1 0 0 0-1.109 0l-9 6A1 1 0 0 0 2 9v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V9c0-.334-.167-.646-.445-.832zM12 4.202 19.197 9 12 13.798 4.803 9 12 4.202zM4 20v-9.131l7.445 4.963a1 1 0 0 0 1.11 0L20 10.869 19.997 20H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$98d3f8101463cc92(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5a8942a08ce01580(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v6h-2zm4-3h2v12h-2zM7 4h2v16H7zm12 7h2v2h-2zM3 10h2v4H3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a82dab551c8e3c27(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.586 15.408 4.299 4.299a.996.996 0 0 0 .707.293h12.001v-2h-6.958l7.222-7.222c.78-.779.78-2.049 0-2.828L14.906 3a2.003 2.003 0 0 0-2.828 0l-4.75 4.749-4.754 4.843a2.007 2.007 0 0 0 .012 2.816zM13.492 4.414l4.95 4.95-2.586 2.586L10.906 7l2.586-2.586zM8.749 9.156l.743-.742 4.95 4.95-4.557 4.557a1.026 1.026 0 0 0-.069.079h-1.81l-4.005-4.007 4.748-4.837z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c152efb7e06d9a94(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2zm0 8h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 7.293-5-5A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707zM20 15.586 15.586 20H8.414L4 15.586V8.414L8.414 4h7.172L20 8.414v7.172z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7e19c89bffd9db6d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2zm0 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c83eac5ddd614898(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.001 10h2v5h-2zM11 16h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19 12 5.137 19.344 19H4.661z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9b7044fca1bc9c5c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.464 6c1.43 0 2.779.613 3.799 1.726l1.475-1.352C17.334 4.843 15.461 4 13.464 4c-1.998 0-3.87.843-5.272 2.375A8.034 8.034 0 0 0 6.589 9H4v2h2.114c-.038.33-.064.663-.064 1s.026.67.064 1H4v2h2.589c.362.97.901 1.861 1.603 2.626C9.594 19.157 11.466 20 13.464 20c1.997 0 3.87-.843 5.273-2.374l-1.475-1.352C16.243 17.387 14.894 18 13.464 18s-2.778-.612-3.798-1.726A5.937 5.937 0 0 1 8.801 15H13v-2H8.139c-.05-.328-.089-.66-.089-1s.039-.672.089-1H13V9H8.801c.24-.457.516-.893.865-1.274C10.686 6.613 12.034 6 13.464 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e054c73d7724213e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2zm-4 7H9V9h6v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$243212fa0859b991(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4H8v4H4v2h6zM8 20h2v-6H4v2h4zm12-6h-6v6h2v-4h4zm0-6h-4V4h-2v6h6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f3edd7b571c3804c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.002 3h-14c-1.103 0-2 .897-2 2v4h2V5h14v14h-14v-4h-2v4c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.898-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 16 5-4-5-4v3.001H3v2h8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3404598a7bed3ce2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H3v9h9v-2H5zm7-7h7v7h2V3h-9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f2fce9b3793be667(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.29 5.64 1.93 12l6.36 6.36 1.42-1.41L4.76 12l4.95-4.95-1.42-1.41zm6 1.41L19.24 12l-4.95 4.95 1.42 1.41L22.07 12l-6.36-6.36-1.42 1.41z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6ed1e85262622c68(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19.24-4.95-4.95-1.41 1.42L12 22.07l6.36-6.36-1.41-1.42L12 19.24zM5.64 8.29l1.41 1.42L12 4.76l4.95 4.95 1.41-1.42L12 1.93 5.64 8.29z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e8e451695e730b77(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15.344-2.121 2.121-3.172-3.172-1.414 1.414 3.172 3.172L15.344 21H21zM3 8.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172L8.656 3H3zM21 3h-5.656l2.121 2.121-3.172 3.172 1.414 1.414 3.172-3.172L21 8.656zM3 21h5.656l-2.121-2.121 3.172-3.172-1.414-1.414-3.172 3.172L3 15.344z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c5a109de9f35a16(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h2V7h3l-4-5-4 5h3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7985f90d85a2bf55(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v3.881l.659.239C4.461 11.41 5 12.166 5 13s-.539 1.59-1.341 1.88L3 15.119V19c0 1.103.897 2 2 2h3.881l.239-.659C9.41 19.539 10.166 19 11 19s1.59.539 1.88 1.341l.239.659H17c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4h-2l-.003 5h-2.545c-.711-1.22-2.022-2-3.452-2s-2.741.78-3.452 2H5v-2.548C6.22 15.741 7 14.43 7 13s-.78-2.741-2-3.452V7h5V5a1 1 0 0 1 2 0v2h5v5h2a1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$888c93ea5f006b9d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 2c3.213 0 5.982 1.908 7.254 4.648a7.8 7.8 0 0 1-.895-.498c-.409-.258-.873-.551-1.46-.772-.669-.255-1.4-.378-2.234-.378s-1.565.123-2.234.377c-.587.223-1.051.516-1.472.781-.378.237-.703.443-1.103.594C9.41 8.921 8.926 9 8.33 9c-.595 0-1.079-.079-1.524-.248-.4-.151-.728-.358-1.106-.598-.161-.101-.34-.208-.52-.313C6.587 5.542 9.113 4 12 4zm0 16c-4.411 0-8-3.589-8-8 0-.81.123-1.59.348-2.327.094.058.185.11.283.173.411.26.876.554 1.466.776.669.255 1.399.378 2.233.378.833 0 1.564-.123 2.235-.377.587-.223 1.051-.516 1.472-.781.378-.237.703-.443 1.103-.595.445-.168.929-.247 1.525-.247s1.08.079 1.525.248c.399.15.725.356 1.114.602.409.258.873.551 1.46.773.363.138.748.229 1.153.291.049.357.083.717.083 1.086 0 4.411-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bd1827583883162(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 16 5-4-5-4zm-6 0 5-4-5-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2f4468dfa3c50e78(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-7-5v10zM5 7v10l7-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$83b185228a5ef1c5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.691 2 6 4.691 6 8c0 2.967 2.167 5.432 5 5.91V17H8v2h3v2.988h2V19h3v-2h-3v-3.09c2.833-.479 5-2.943 5-5.91 0-3.309-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f837e29f6f02cabe(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.948 7.684A.997.997 0 0 0 14 7h-4a.998.998 0 0 0-.948.684l-2 6 1.775.593L8 18h2v4h4v-4h2l-.827-3.724 1.775-.593-2-5.999z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9f7ead2438cdcfb1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.937 8.68c-.011-.032-.02-.063-.033-.094a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.99.99 0 0 0-.05-.258zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7e8abfbd9c79b1bd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 2.293A.996.996 0 0 0 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9a.996.996 0 0 0-.293-.707l-6-6zM6 4h6.586L18 9.414l.002 9.174-2.568-2.568c.35-.595.566-1.281.566-2.02 0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4c.739 0 1.425-.216 2.02-.566L16.586 20H6V4zm6 12c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8fb5332042be443f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.903 8.586a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.952.952 0 0 0-.051-.259c-.01-.032-.019-.063-.033-.093zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8v2H8zm0 4h8v2H8zm0-8h2v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$269a0764aca79ed0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9 11V5h6v6H9zm6 2v6H9v-6h6zM5 5h2v2H5V5zm0 4h2v2H5V9zm0 4h2v2H5v-2zm0 4h2v2H5v-2zm14.002 2H17v-2h2.002v2zm-.001-4H17v-2h2.001v2zm0-4H17V9h2.001v2zM17 7V5h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$62c81be36cc1809d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H5a1 1 0 0 0-1 1v2.59c0 .523.213 1.037.583 1.407L10 13.414V21a1.001 1.001 0 0 0 1.447.895l4-2c.339-.17.553-.516.553-.895v-5.586l5.417-5.417c.37-.37.583-.884.583-1.407V4a1 1 0 0 0-1-1zm-6.707 9.293A.996.996 0 0 0 14 13v5.382l-2 1V13a.996.996 0 0 0-.293-.707L6 6.59V5h14.001l.002 1.583-5.71 5.71z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$27e22ca0aa7a5f46(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h10v2H7zM4 7h16v2H4zm6 8h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$300c5732459ffc1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.962 17.674C7 19.331 7 20.567 7 22h2c0-1.521 0-3.244-1.343-5.389l-1.695 1.063zM16.504 3.387C13.977 1.91 7.55.926 4.281 4.305c-3.368 3.481-2.249 9.072.001 11.392.118.122.244.229.369.333.072.061.146.116.205.184l1.494-1.33a3.918 3.918 0 0 0-.419-.391c-.072-.06-.146-.119-.214-.188-1.66-1.711-2.506-6.017.001-8.608 2.525-2.611 8.068-1.579 9.777-.581 2.691 1.569 4.097 4.308 4.109 4.333l1.789-.895c-.065-.135-1.668-3.289-4.889-5.167z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.34 12.822c-1.03-1.26-1.787-2.317-1.392-3.506.263-.785.813-1.325 1.637-1.604 1.224-.41 2.92-.16 4.04.601l1.123-1.654c-1.648-1.12-3.982-1.457-5.804-.841-1.408.476-2.435 1.495-2.892 2.866-.776 2.328.799 4.254 1.74 5.405.149.183.29.354.409.512C11 18.323 11 20.109 11 22h2c0-2.036 0-4.345-3.201-8.601a19.71 19.71 0 0 0-.459-.577zm5.791-3.344c1.835 1.764 3.034 4.447 3.889 8.701l1.961-.395c-.939-4.678-2.316-7.685-4.463-9.748l-1.387 1.442z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.556 9.169-1.115 1.66c.027.019 2.711 1.88 3.801 5.724l1.924-.545c-1.299-4.582-4.476-6.749-4.61-6.839zm3.132 9.29c.21 1.168.312 2.326.312 3.541h2c0-1.335-.112-2.608-.343-3.895l-1.969.354z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6a15a7fa598bbf43(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zM4 18V8h16l.001 10H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$be89551b28b33f63(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.293 17.707 1.414-1.414L13.414 12l4.293-4.293-1.414-1.414L10.586 12zM7 6h2v12H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cfa2ce31bcb30637(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H6V2H4v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 9H6V6h12v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f589d15348842281(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.996.996 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.874 12h8v2h-8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f7141e0a175ee24a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V7c0-1.103-.897-2-2-2h-6.1L9.616 3.213A.997.997 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14h.007a1 1 0 0 0 .158.551zM17.341 18H4.517l2.143-5h12.824l-2.143 5zM18 7v4H6c-.4 0-.762.238-.919.606L4 14.129V7h14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c939ca84af7904f9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.996.996 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6e11f6c1721ee671(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.997.997 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ab95a1907a3f369f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v3H5zm7.5-14h-1c-.401 0-.764.24-.921.609L5.745 16h2.173l1.273-3h5.604l1.268 3h2.171L13.421 4.61A1 1 0 0 0 12.5 4zm-2.46 7 1.959-4.616L13.95 11h-3.91z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1085bb0b4b70fc45(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h7v2h-7zm1 4h6v2h-6zm2 4h4v2h-4zM9.307 4l-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16H9.307zm-1.239 9L10.5 6.515 12.932 13H8.068z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fbbbb69802939f76(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-4-3 4h2v4h-2l3 4 3-4h-2V6zM9.307 4l-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16H9.307zm-1.239 9L10.5 6.515 12.932 13H8.068z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$94a07f16ebf45fc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.307 4-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16h-2.387zm-1.239 9L12.5 6.515 14.932 13h-4.864z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4c38b6f0f6f36533(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h2v20H3zm7 4h7v2h-7zm0 4h7v2h-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6v20h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 18H8V4h11v16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7f3aef9e079a9adb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$854975d1247ee5aa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929a9.936 9.936 0 0 0-7.07-2.938 9.943 9.943 0 0 0-7.072 2.938c-3.899 3.898-3.899 10.243 0 14.142a9.94 9.94 0 0 0 7.073 2.938 9.936 9.936 0 0 0 7.07-2.937c3.899-3.898 3.899-10.243-.001-14.143zM12.181 4h-.359c.061-.001.119-.009.18-.009s.118.008.179.009zm6.062 13H16l-1.258 2.516a7.956 7.956 0 0 1-2.741.493 7.96 7.96 0 0 1-2.746-.494L8 17.01H5.765a7.96 7.96 0 0 1-1.623-3.532L6 11 4.784 8.567a7.936 7.936 0 0 1 1.559-2.224 7.994 7.994 0 0 1 3.22-1.969L12 6l2.438-1.625a8.01 8.01 0 0 1 3.22 1.968 7.94 7.94 0 0 1 1.558 2.221L18 11l1.858 2.478A7.952 7.952 0 0 1 18.243 17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 11 1.5 4h4l1.5-4L12 8.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2d6025fba60e8a0f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.47 13.77-1.41-1.42 5.66-5.65-1.42-1.42-5.65 5.66-1.42-1.41 5.66-5.66-1.42-1.42-6.36 6.37a3 3 0 0 0 0 4.24l.71.71-6.37 6.36 1.42 1.42 6.36-6.37.71.71a3 3 0 0 0 4.24 0l6.37-6.36-1.42-1.42z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2291602c4932cdaa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 2 .001 5H10V7H8v2H6V4h12zM6 20v-9h2v3h2v-3h8.001l.001 9H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ed9a4220106669f4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8bf2fe34fb7a7881(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.937 7.53C19.227 4.119 15.803 2 12 2 6.486 2 2 6.486 2 12s4.486 10 10 10c3.803 0 7.227-2.119 8.937-5.53a1 1 0 0 0-.397-1.316L15.017 12l5.522-3.153c.461-.264.636-.842.398-1.317zm-8.433 3.602a.999.999 0 0 0 0 1.736l6.173 3.525A7.949 7.949 0 0 1 12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8a7.95 7.95 0 0 1 6.677 3.606l-6.173 3.526z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eee0984926999671(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.395 3.058c.149.899.766 1.676 1.565 2.112.897.49 1.685.446 2.384.197L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM4 5h7l.001 4H4V5zm0 14v-8h7.001l.001 8H4zm14-9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$46b987e9e5a1aeb0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.038-9 9v8h.051c.245 1.691 1.69 3 3.449 3 1.174 0 2.074-.417 2.672-1.174a3.99 3.99 0 0 0 5.668-.014c.601.762 1.504 1.188 2.66 1.188 1.93 0 3.5-1.57 3.5-3.5V11c0-4.962-4.037-9-9-9zm7 16.5c0 .827-.673 1.5-1.5 1.5-.449 0-1.5 0-1.5-2v-1h-2v1c0 1.103-.897 2-2 2s-2-.897-2-2v-1H8v1c0 1.845-.774 2-1.5 2-.827 0-1.5-.673-1.5-1.5V11c0-3.86 3.141-7 7-7s7 3.14 7 7v7.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2389a0608d2714fb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-1.209A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-4.5-3c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.478c.511-1.576 1.253-3 1.978-3zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM4 9h7v2H4V9zm2 11v-7h5v7H6zm12 0h-5v-7h5v7zm-5-9V9.085L13.017 9H20l.001 2H13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8ba4bdff0e6477c1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 4C15.57 4 14 5.57 14 7.5c0 1.554 1.025 2.859 2.43 3.315-.146.932-.547 1.7-1.23 2.323-1.946 1.773-5.527 1.935-7.2 1.907V8.837c1.44-.434 2.5-1.757 2.5-3.337C10.5 3.57 8.93 2 7 2S3.5 3.57 3.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337C3.5 20.43 5.07 22 7 22s3.5-1.57 3.5-3.5c0-.551-.14-1.065-.367-1.529 2.06-.186 4.657-.757 6.409-2.35 1.097-.997 1.731-2.264 1.904-3.768C19.915 10.438 21 9.1 21 7.5 21 5.57 19.43 4 17.5 4zm-12 1.5C5.5 4.673 6.173 4 7 4s1.5.673 1.5 1.5S7.827 7 7 7s-1.5-.673-1.5-1.5zM7 20c-.827 0-1.5-.673-1.5-1.5a1.5 1.5 0 0 1 1.482-1.498l.13.01A1.495 1.495 0 0 1 7 20zM17.5 9c-.827 0-1.5-.673-1.5-1.5S16.673 6 17.5 6s1.5.673 1.5 1.5S18.327 9 17.5 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a142c2817929d14e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.967 0-5.431 2.167-5.909 5H2v2h4.092c.479 2.832 2.942 4.998 5.909 4.998s5.43-2.166 5.909-4.998H22v-2h-4.09c-.478-2.833-2.942-5-5.91-5zm0 9.998c-2.205 0-3.999-1.794-3.999-3.999S9.795 8 12 8c2.206 0 4 1.794 4 3.999s-1.794 3.999-4 3.999z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$27f9b63461049e7a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.01 2c-1.93 0-3.5 1.57-3.5 3.5 0 1.58 1.06 2.903 2.5 3.337v7.16c-.001.179.027 1.781 1.174 2.931C6.892 19.64 7.84 20 9 20v2l4-3-4-3v2c-1.823 0-1.984-1.534-1.99-2V8.837c1.44-.434 2.5-1.757 2.5-3.337 0-1.93-1.571-3.5-3.5-3.5zm0 5c-.827 0-1.5-.673-1.5-1.5S5.183 4 6.01 4s1.5.673 1.5 1.5S6.837 7 6.01 7zm13 8.163V7.997C19.005 6.391 17.933 4 15 4V2l-4 3 4 3V6c1.829 0 2.001 1.539 2.01 2v7.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337zm-1 4.837c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7de4a9fd2bd11970(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 18.5C2.5 20.43 4.07 22 6 22s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337v-3.488c.244.273.509.527.813.744 1.18.844 2.617 1.098 3.918 1.098.966 0 1.853-.14 2.506-.281a3.5 3.5 0 0 0 3.264 2.265c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5a3.5 3.5 0 0 0-3.404 2.718c-1.297.321-3.664.616-5.119-.426-.666-.477-1.09-1.239-1.306-2.236C8.755 7.96 9.5 6.821 9.5 5.5 9.5 3.57 7.93 2 6 2S2.5 3.57 2.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337zm15-8c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5S16 12.827 16 12s.673-1.5 1.5-1.5zm-10 8c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S5.173 17 6 17s1.5.673 1.5 1.5zm-3-13C4.5 4.673 5.173 4 6 4s1.5.673 1.5 1.5S6.827 7 6 7s-1.5-.673-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9cbac0b3c8d941e6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.01 15.163V7.997C19.005 6.391 17.933 4 15 4V2l-4 3 4 3V6c1.829 0 2.001 1.539 2.01 2v7.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337zm-1 4.837c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM9.5 5.5C9.5 3.57 7.93 2 6 2S2.5 3.57 2.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337C2.5 20.43 4.07 22 6 22s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V8.837C8.44 8.403 9.5 7.08 9.5 5.5zm-5 0C4.5 4.673 5.173 4 6 4s1.5.673 1.5 1.5S6.827 7 6 7s-1.5-.673-1.5-1.5zm3 13c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S5.173 17 6 17s1.5.673 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$540937da3f05b2d3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.559 8.855c.166 1.183.789 3.207 3.087 4.079C11 13.829 11 14.534 11 15v.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V15c0-.466 0-1.171 2.354-2.065 2.298-.872 2.921-2.896 3.087-4.079C19.912 8.441 21 7.102 21 5.5 21 3.57 19.43 2 17.5 2S14 3.57 14 5.5c0 1.552 1.022 2.855 2.424 3.313-.146.735-.565 1.791-1.778 2.252-1.192.452-2.053.953-2.646 1.536-.593-.583-1.453-1.084-2.646-1.536-1.213-.461-1.633-1.517-1.778-2.252C8.978 8.355 10 7.052 10 5.5 10 3.57 8.43 2 6.5 2S3 3.57 3 5.5c0 1.602 1.088 2.941 2.559 3.355zM17.5 4c.827 0 1.5.673 1.5 1.5S18.327 7 17.5 7 16 6.327 16 5.5 16.673 4 17.5 4zm-4 14.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5.673-1.5 1.5-1.5 1.5.673 1.5 1.5zM6.5 4C7.327 4 8 4.673 8 5.5S7.327 7 6.5 7 5 6.327 5 5.5 5.673 4 6.5 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$409733760882acca(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.948 11.684-2-6A.997.997 0 0 0 19 5h-3v2h2.279l1.334 4H15c-1.103 0-2 .897-2 2h-2c0-1.103-.897-2-2-2H4.387l1.334-4H8V5H5a.998.998 0 0 0-.948.684l-2 6 .012.004A.928.928 0 0 0 2 12v4c0 1.654 1.346 3 3 3h3c1.654 0 3-1.346 3-3v-1h2v1c0 1.654 1.346 3 3 3h3c1.654 0 3-1.346 3-3v-4a.964.964 0 0 0-.063-.313l.011-.003zM9 16c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1v-3h5v3zm11 0c0 .551-.448 1-1 1h-3c-.552 0-1-.449-1-1v-3h5v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ad7ca2aa5547a3a8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.977 13.783-2-9A1.002 1.002 0 0 0 19 4h-3v2h2.198l.961 4.326A4.467 4.467 0 0 0 17.5 10c-1.953 0-3.603 1.258-4.224 3h-2.553c-.621-1.742-2.271-3-4.224-3-.587 0-1.145.121-1.659.326L5.802 6H8V4H5a1 1 0 0 0-.976.783l-2 9 .047.011A4.552 4.552 0 0 0 2 14.5C2 16.981 4.019 19 6.5 19c2.31 0 4.197-1.756 4.449-4h2.102c.252 2.244 2.139 4 4.449 4 2.481 0 4.5-2.019 4.5-4.5 0-.242-.034-.475-.071-.706l.048-.011zM6.5 17C5.122 17 4 15.878 4 14.5S5.122 12 6.5 12 9 13.122 9 14.5 7.878 17 6.5 17zm11 0c-1.379 0-2.5-1.122-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$83902b62e4118035(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18.791V20H9v2h6v-2h-2v-1.845a9.934 9.934 0 0 0 3.071-2.084c3.898-3.898 3.898-10.243 0-14.143l-1.414 1.414c3.119 3.12 3.119 8.195 0 11.314-3.119 3.118-8.195 3.12-11.314 0L1.929 16.07A9.971 9.971 0 0 0 9 18.994a9.98 9.98 0 0 0 2-.203z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9c0 3.309 2.691 6 6 6s6-2.691 6-6-2.691-6-6-6-6 2.691-6 6zm10 0c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5fb448e625a86fb5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-2.764a14.67 14.67 0 0 0-1.792-6.243A8.013 8.013 0 0 1 19.931 11zM12.53 4.027c1.035 1.364 2.427 3.78 2.627 6.973H9.03c.139-2.596.994-5.028 2.451-6.974.172-.01.344-.026.519-.026.179 0 .354.016.53.027zm-3.842.7C7.704 6.618 7.136 8.762 7.03 11H4.069a8.013 8.013 0 0 1 4.619-6.273zM4.069 13h2.974c.136 2.379.665 4.478 1.556 6.23A8.01 8.01 0 0 1 4.069 13zm7.381 6.973C10.049 18.275 9.222 15.896 9.041 13h6.113c-.208 2.773-1.117 5.196-2.603 6.972-.182.012-.364.028-.551.028-.186 0-.367-.016-.55-.027zm4.011-.772c.955-1.794 1.538-3.901 1.691-6.201h2.778a8.005 8.005 0 0 1-4.469 6.201z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$239404be342cf1d6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm5 2h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4V5zM3 20a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6zm2-5h4v4H5v-4zm8 5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6zm2-5h4v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e1e34d10aed76f01(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7h4v4h-4zm6 0h4v4h-4zM4 7h4v4H4zm6 6h4v4h-4zm6 0h4v4h-4zM4 13h4v4H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$85ce17bc8f7bab50(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zm0 6h4v4H7zm6-6h4v4h-4zm0 6h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$91db4c347da30aee(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h4v4H7zm0-6h4v4H7zm0 12h4v4H7zm6-6h4v4h-4zm0-6h4v4h-4zm0 12h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$340dd48851648332(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H4.984c-1.103 0-2 .897-2 2v14.016c0 1.103.897 2 2 2H19c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-4zm4 5h-3V5h3v3zM4.984 10h3v4.016h-3V10zm5 0H14v4.016H9.984V10zM16 10h3v4.016h-3V10zm-2-5v3H9.984V5H14zM7.984 5v3h-3V5h3zm-3 11.016h3v3h-3v-3zm5 3v-3H14v3H9.984zm6.016 0v-3h3.001v3H16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c7edfedd6f2583fd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.604 11.048a5.67 5.67 0 0 0 .751-3.44c-.179-1.784-1.175-3.361-2.803-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.693 3.693 0 0 1-1.072 2.986l-1.192 1.192 1.618.475C18.951 13.701 19 17.957 19 18h2c0-1.789-.956-5.285-4.396-6.952z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm1.5 7H8c-3.309 0-6 2.691-6 6v1h2v-1c0-2.206 1.794-4 4-4h3c2.206 0 4 1.794 4 4v1h2v-1c0-3.309-2.691-6-6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c5f8c5dcfb21dbda(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.98 14.804A1 1 0 0 0 16 14h-4.133l-.429-3H16V9h-4.847l-.163-1.142A1 1 0 0 0 10 7H9a1.003 1.003 0 0 0-.99 1.142l.877 6.142A2.009 2.009 0 0 0 10.867 16h4.313l.839 4.196c.094.467.504.804.981.804h3v-2h-2.181l-.839-4.196z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.51 17.5c-.739 1.476-2.25 2.5-4.01 2.5A4.505 4.505 0 0 1 4 15.5a4.503 4.503 0 0 1 2.817-4.167l-.289-2.025C3.905 10.145 2 12.604 2 15.5 2 19.084 4.916 22 8.5 22a6.497 6.497 0 0 0 5.545-3.126l-.274-1.374H12.51z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7cfce07e1eeb92fc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "9.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c5 0 6-5 6-5H6s1 5 6 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3aad312a2b50037c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 12 2 .012c.012-.462.194-1.012 1-1.012s.988.55 1 1h2c0-1.206-.799-3-3-3s-3 1.794-3 3zm-5-1c.806 0 .988.55 1 1h2c0-1.206-.799-3-3-3s-3 1.794-3 3l2 .012C7.012 11.55 7.194 11 8 11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ad476f800fd4542(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.535 12.634 2.05-2.083a1.485 1.485 0 0 0-.018-2.118 1.49 1.49 0 0 0-2.065-.034 1.488 1.488 0 0 0-2.067.068c-.586.6-.579 1.53.019 2.117l2.081 2.05zm7 0 2.05-2.083a1.485 1.485 0 0 0-.018-2.118 1.49 1.49 0 0 0-2.065-.034 1.488 1.488 0 0 0-2.068.067c-.586.6-.579 1.53.019 2.117l2.082 2.051z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$54647de6f46a8c6d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9f8e185f3ee6e0af(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a9.11 9.11 0 0 0-.18-1.81 8.53 8.53 0 0 0-.53-1.69 8.08 8.08 0 0 0-.83-1.5 8.73 8.73 0 0 0-1.1-1.33A8.27 8.27 0 0 0 17 7.54a8.08 8.08 0 0 0-1.53-.83L15 6.52V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.52l-.5.19a8.08 8.08 0 0 0-1.5.83 8.27 8.27 0 0 0-1.33 1.1A8.27 8.27 0 0 0 4.54 10a8.08 8.08 0 0 0-.83 1.53 9 9 0 0 0-.53 1.69A9.11 9.11 0 0 0 3 15v3H2v2h20v-2h-1zM5 15a7.33 7.33 0 0 1 .14-1.41 6.64 6.64 0 0 1 .41-1.31 7.15 7.15 0 0 1 .64-1.19 7.15 7.15 0 0 1 1.9-1.9A7.33 7.33 0 0 1 9 8.68V15h2V6h2v9h2V8.68a8.13 8.13 0 0 1 .91.51 7.09 7.09 0 0 1 1 .86 6.44 6.44 0 0 1 .85 1 6 6 0 0 1 .65 1.19 7.13 7.13 0 0 1 .41 1.31A7.33 7.33 0 0 1 19 15v3H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3b6794a13ac5a987(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.018 3.815 15.232 8h-4.966l.716-3.815-1.964-.37L8.232 8H4v2h3.857l-.751 4H3v2h3.731l-.714 3.805 1.965.369L8.766 16h4.966l-.714 3.805 1.965.369.783-4.174H20v-2h-3.859l.751-4H21V8h-3.733l.716-3.815-1.965-.37zM14.106 14H9.141l.751-4h4.966l-.752 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3e1a397b471b6b9f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.983 13.821-1.851-10.18A1.998 1.998 0 0 0 18.165 2H5.835a2 2 0 0 0-1.968 1.643l-1.85 10.178.019.003c-.012.06-.036.114-.036.176v5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-5c0-.063-.024-.116-.035-.176l.018-.003zM5.835 4h12.331l1.637 9H4.198l1.637-9zM4 19v-4h16l.002 4H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16h2v2h-2zm-3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a2dc825d1a2df633(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20V4h-3v6H9V4H6v16h3v-7h6v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$482d3fcaa43e96b7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v-1.707c0-4.442-3.479-8.161-7.755-8.29-2.204-.051-4.251.736-5.816 2.256A7.933 7.933 0 0 0 4 10v2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2V10a5.95 5.95 0 0 1 1.821-4.306 5.977 5.977 0 0 1 4.363-1.691C15.392 4.099 18 6.921 18 10.293V20h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v8H7zm8 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c8cf7678f8f2fdcc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.649 5.286 14 8.548V2.025h-4v6.523L4.351 5.286l-2 3.465 5.648 3.261-5.648 3.261 2 3.465L10 15.477V22h4v-6.523l5.649 3.261 2-3.465-5.648-3.261 5.648-3.261z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7f69424e4e983e1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.279 8.833 12 9.112l-.279-.279a2.745 2.745 0 0 0-3.906 0 2.745 2.745 0 0 0 0 3.907L12 16.926l4.186-4.186a2.745 2.745 0 0 0 0-3.907 2.746 2.746 0 0 0-3.907 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7e74e28a0e8d2f47(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.998 17 4.186-4.186a2.745 2.745 0 0 0 0-3.907 2.746 2.746 0 0 0-3.907 0l-.278.279-.279-.279a2.746 2.746 0 0 0-3.907 0 2.746 2.746 0 0 0 0 3.907L11.998 17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4zm-2 15H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$20ee294cf53d474b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412l7.332 7.332c.17.299.498.492.875.492a.99.99 0 0 0 .792-.409l7.415-7.415c2.354-2.354 2.354-6.049-.002-8.416a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595zm6.791 1.61c1.563 1.571 1.564 4.025.002 5.588L12 18.586l-6.793-6.793c-1.562-1.563-1.561-4.017-.002-5.584.76-.756 1.754-1.172 2.799-1.172s2.035.416 2.789 1.17l.5.5a.999.999 0 0 0 1.414 0l.5-.5c1.512-1.509 4.074-1.505 5.584-.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fecebdf00b671f57(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$625c9c86086bb099(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757c-.273.021-.55.038-.841.038-5.351 0-7.424-3.846-7.926-5a8.642 8.642 0 0 1 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm0-14c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.951 3.547-4.615 3.561-4.657a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5zm4.972 10.558-2.28-2.28c.19-.39.308-.819.308-1.278 0-1.641-1.359-3-3-3-.459 0-.888.118-1.277.309L8.915 7.501A9.26 9.26 0 0 1 12 7c5.351 0 7.424 3.846 7.926 5-.302.692-1.166 2.342-2.954 3.558z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5eaaba001bfc8c93(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.707 5.826-3.535-3.533a.999.999 0 0 0-1.408-.006L7.096 10.82a1.01 1.01 0 0 0-.273.488l-1.024 4.437L4 18h2.828l1.142-1.129 3.588-.828c.18-.042.345-.133.477-.262l8.667-8.535a1 1 0 0 0 .005-1.42zm-9.369 7.833-2.121-2.12 7.243-7.131 2.12 2.12-7.242 7.131zM4 20h16v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$432341eb42921ce2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v5h5v-2h-3V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.292 8.497a8.957 8.957 0 0 0-1.928-2.862 9.004 9.004 0 0 0-4.55-2.452 9.09 9.09 0 0 0-3.626 0 8.965 8.965 0 0 0-4.552 2.453 9.048 9.048 0 0 0-1.928 2.86A8.963 8.963 0 0 0 4 12l.001.025H2L5 16l3-3.975H6.001L6 12a6.957 6.957 0 0 1 1.195-3.913 7.066 7.066 0 0 1 1.891-1.892 7.034 7.034 0 0 1 2.503-1.054 7.003 7.003 0 0 1 8.269 5.445 7.117 7.117 0 0 1 0 2.824 6.936 6.936 0 0 1-1.054 2.503c-.25.371-.537.72-.854 1.036a7.058 7.058 0 0 1-2.225 1.501 6.98 6.98 0 0 1-1.313.408 7.117 7.117 0 0 1-2.823 0 6.957 6.957 0 0 1-2.501-1.053 7.066 7.066 0 0 1-1.037-.855l-1.414 1.414A8.985 8.985 0 0 0 13 21a9.05 9.05 0 0 0 3.503-.707 9.009 9.009 0 0 0 3.959-3.26A8.968 8.968 0 0 0 22 12a8.928 8.928 0 0 0-.708-3.503z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$179a1d76ce2af61a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.895 7.553-2-4A1.001 1.001 0 0 0 18 3h-5c-.379 0-.725.214-.895.553L10.382 7H6c-.379 0-.725.214-.895.553l-2 4a1 1 0 0 0 0 .895l2 4c.17.338.516.552.895.552h4.382l1.724 3.447A.998.998 0 0 0 13 21h5c.379 0 .725-.214.895-.553l2-4a1 1 0 0 0 0-.895L19.118 12l1.776-3.553a1 1 0 0 0 .001-.894zM13.618 5h3.764l1.5 3-1.5 3h-3.764l-1.5-3 1.5-3zm-8.5 7 1.5-3h3.764l1.5 3-1.5 3H6.618l-1.5-3zm12.264 7h-3.764l-1.5-3 1.5-3h3.764l1.5 3-1.5 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$afaf603566b10458(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.71 2.29a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42A1 1 0 0 0 3 13h1v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7h1a1 1 0 0 0 1-1 1 1 0 0 0-.29-.71zM6 20v-9.59l6-6 6 6V20z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7e12ff96abbd7f07(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a7c943e709d7ad12(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm9-8.586 6 6V15l.001 5H6v-9.585l6-6.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$44f14167aef3c761(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.223 11.641-.223.22-.224-.22a2.224 2.224 0 0 0-3.125 0 2.13 2.13 0 0 0 0 3.07L12 18l3.349-3.289a2.13 2.13 0 0 0 0-3.07 2.225 2.225 0 0 0-3.126 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.293-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707zM18.001 20H6v-9.585l6-6 6 6V15l.001 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$60e97356d99528d2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm9-8.586 6 6V15l.001 5H6v-9.586l6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c3.703 0 4.901-3.539 4.95-3.689l-1.9-.621c-.008.023-.781 2.31-3.05 2.31-2.238 0-3.02-2.221-3.051-2.316l-1.899.627C7.099 14.461 8.297 18 12 18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ee2c9182b434f219(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm7 7v-5h4v5h-4zm2-15.586 6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586l6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$664ab3df3bb1c6ab(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.005 15.995 4-4-4-4v3h-3v2h3zm14-5v-3l-4 4 4 4v-3h3v-2h-2.072zm-8 7h2v3h-2zm0-5h2v3h-2zm0-5h2v3h-2zm0-5h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$25706e2f5cc6e9b9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 8-4 4 4 4v-3h8v-2h-8V8zM3 18h2v3H3zM3 13h2v3H3zM3 8h2v3H3zM3 3h2v3H3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3e2a228ad8854cd3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11H5v2h8v3l4-4-4-4v3zM19 3h2v3h-2zM19 8h2v3h-2zM19 13h2v3h-2zM19 18h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c3b19089af4cf71(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "11.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.205 7H12a1 1 0 0 0-1 1v7H4V6H2v14h2v-3h16v3h2v-8.205A4.8 4.8 0 0 0 17.205 7zM13 15V9h4.205A2.798 2.798 0 0 1 20 11.795V15h-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$738aa90e7ba10c30(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.566 11.021A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.208.566.545.566.9v.158c0 .354-.212.69-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.355.212-.692.566-.9zm-1.015 3.681A5.008 5.008 0 0 1 17 19v1H7v-1a5.01 5.01 0 0 1 2.45-4.299c.971-.573 1.55-1.554 1.55-2.622v-.158c0-1.069-.58-2.051-1.551-2.623A5.008 5.008 0 0 1 7 5V4h10v1c0 1.76-.938 3.406-2.449 4.298C13.58 9.87 13 10.852 13 11.921v.158c0 1.068.579 2.049 1.551 2.623z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3275291a1113c991(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.715 12c1.151 0 2-.849 2-2s-.849-2-2-2-2 .849-2 2 .848 2 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .841-2 1.875v12.25C2 19.159 2.897 20 4 20h16c1.103 0 2-.841 2-1.875V5.875C22 4.841 21.103 4 20 4zm0 14-16-.011V6l16 .011V18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h4v2h-4zm1 4h3v2h-3zm-1.57 2.536c0-1.374-1.676-2.786-3.715-2.786S6 14.162 6 15.536V16h7.43v-.464z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$78af611713733068(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h13v7h2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-2H4V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 11-3 4h11l-4-6-3 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ac7af6bfdc8654ef(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 14-1-1-3 4h12l-5-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$82d2dba16d7e5280(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.499",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.499 14-1.5-2-3 4h12l-4.5-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-16 14V6h16l.002 12H3.999z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3593cf966ee5bbb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 12-1-1-2 3h10l-4-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$728194f892d4e745(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 18 4-5h-3V2h-2v11H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$476299a9d49c1176(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7c-2.094 0-3.611 1.567-5.001 3.346C10.609 8.567 9.093 7 7 7c-2.757 0-5 2.243-5 5a4.98 4.98 0 0 0 1.459 3.534A4.956 4.956 0 0 0 6.99 17h.012c2.089-.005 3.605-1.572 4.996-3.351C13.389 15.431 14.906 17 17 17c2.757 0 5-2.243 5-5s-2.243-5-5-5zM6.998 15l-.008 1v-1c-.799 0-1.55-.312-2.114-.878A3.004 3.004 0 0 1 7 9c1.33 0 2.56 1.438 3.746 2.998C9.558 13.557 8.328 14.997 6.998 15zM17 15c-1.33 0-2.561-1.44-3.749-3.002C14.438 10.438 15.668 9 17 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$75b1655f5e7081d6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2v6h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b34b7ea9acc45f83(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 4h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5deacbf0c91ca3f9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 7.4 22.25 6 18 1.75l-1.4 1.41L18 4.58 16.6 6l-2.13-2.13-1.41-1.42-1.41 1.42.7.71L3 13.92a2 2 0 0 0-.3 2.45L4 18.56l-2.25 2.28 1.41 1.41L5.44 20l2.19 1.31a2 2 0 0 0 1 .28 2 2 0 0 0 1.45-.59l9.34-9.34.71.7 1.42-1.41-1.42-1.42L18 7.4 19.42 6zM18 10.23l-9.34 9.35L6 18l-1.58-2.66.86-.87 2.83 2.83 1.42-1.41-2.83-2.83 1.41-1.41 2.83 2.82 1.41-1.41-2.83-2.83 1.42-1.41 2.83 2.83 1.41-1.42-2.83-2.83L13.77 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7ab2127c02dfb159(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm9.001-2L14 10h.001v4zM19 10l.001 9H10v-3h4c1.103 0 2-.897 2-2v-4h3zM5 5h9v3h-4c-1.103 0-2 .897-2 2v4H5V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$986b6922e41f5a52(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4H9v3h2.868L9.012 17H5v3h10v-3h-2.868l2.856-10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$abd7f8bdb41c2768(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "11",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9H8v2H6v2h2v2h2v-2h2v-2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H9a7 7 0 0 0-7 7 7 7 0 0 0 7 7h6a7 7 0 0 0 7-7 7 7 0 0 0-7-7zm0 12H9A5 5 0 1 1 9 7h6a5 5 0 1 1 0 10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ab389aade8bd7acb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v3H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-3h3c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm0 8h-5v4h.001v1H9v-5H4V9h5V4h6v5h5v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v-4l-3 2zm8 0 3-2-3-2zm-6-6h4l-2-3zm2 11 2-3h-4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4bf7353686e24e59(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.65A5 5 0 0 0 17 4H7a5 5 0 0 0-5 4.74A2 2 0 0 0 2 9v7.5A3.48 3.48 0 0 0 5.5 20c1.43 0 2.32-1.06 3.19-2.09.32-.37.65-.76 1-1.1a4.81 4.81 0 0 1 1.54-.75 6.61 6.61 0 0 1 1.54 0 4.81 4.81 0 0 1 1.54.75c.35.34.68.73 1 1.1.87 1 1.76 2.09 3.19 2.09a3.48 3.48 0 0 0 3.5-3.5V9a2.09 2.09 0 0 0 0-.26zm-2 7.85a1.5 1.5 0 0 1-1.5 1.5c-.5 0-1-.64-1.66-1.38-.34-.39-.72-.85-1.15-1.26a6.68 6.68 0 0 0-2.46-1.25 6.93 6.93 0 0 0-2.46 0 6.68 6.68 0 0 0-2.46 1.25c-.43.41-.81.87-1.15 1.26C6.54 17.36 6 18 5.5 18A1.5 1.5 0 0 1 4 16.5V9a.77.77 0 0 0 0-.15A3 3 0 0 1 7 6h10a3 3 0 0 1 3 2.72v.12A.86.86 0 0 0 20 9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f0037939e2c7ee8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17a5.007 5.007 0 0 0 4.898-4H14v2h2v-2h2v3h2v-3h1v-2h-9.102A5.007 5.007 0 0 0 7 7c-2.757 0-5 2.243-5 5s2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$858958de03e25161(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.66 3.6a3 3 0 0 0-4.24 0l-.71.71-7.07 7.07 2.12 2.12-6.36 6.36 1.41 1.42L19.66 6.43c1.1-1.1 1.1-1.73.71-2.12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b7889f807187b9ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.813 4.419A.997.997 0 0 0 16 4H3a1 1 0 0 0-.813 1.581L6.771 12l-4.585 6.419A1 1 0 0 0 3 20h13a.997.997 0 0 0 .813-.419l5-7a.997.997 0 0 0 0-1.162l-5-7zM15.485 18H4.943l3.87-5.419a.997.997 0 0 0 0-1.162L4.943 6h10.542l4.286 6-4.286 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$36765037fe9d863c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20h18a1 1 0 0 0 .864-1.504l-7-12c-.359-.615-1.369-.613-1.729 0L9.866 12.1l-1.02-1.632A.998.998 0 0 0 8 10h-.001a1 1 0 0 0-.847.47l-5 8A1 1 0 0 0 3 20zM14 8.985 19.259 18h-5.704l-2.486-3.987L14 8.985zm-5.999 3.9L11.197 18H4.805l3.196-5.115zM6 8c1.654 0 3-1.346 3-3S7.654 2 6 2 3 3.346 3 5s1.346 3 3 3zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ad7e701daa868fc3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.722c.595-.347 1-.985 1-1.722V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v11c0 .736.405 1.375 1 1.722V18H2v2h20v-2h-2v-.278zM5 16V5h14l.002 11H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7adefa8c63c004b4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.707 17.707 13.414 12 7.707 6.293 6.293 7.707 10.586 12l-4.293 4.293zM15 6h2v12h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$973299fce9862263(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4zm5.555-9.168-1.109-1.664-3 2a1.001 1.001 0 0 0 .108 1.727l4 2 .895-1.789-2.459-1.229 1.565-1.045zm-6.557 1.23a1 1 0 0 0-.443-.894l-3-2-1.11 1.664 1.566 1.044-2.459 1.229.895 1.789 4-2a.998.998 0 0 0 .551-.832z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$366846f88a0f8cdf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749zm9.464-4.69 6.964 3.859-6.917 3.853-6.964-3.89 6.917-3.822z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM16 4h6v2h-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$671152336bcd4163(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 11.125-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749zm-9.461 4.73-6.964-3.89 6.917-3.822 6.964 3.859-6.917 3.853z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a.994.994 0 0 0 .485-.126l9-5-.971-1.748L12 19.856l-8.515-4.73-.971 1.748 9 5A1 1 0 0 0 12 22zm8-20h-2v2h-2v2h2v2h2V6h2V4h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$251521b49043bf29(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.999a1 1 0 0 0-.516-.874l-9.022-5a1.003 1.003 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5A1 1 0 0 0 22 7.999zm-9.977 3.855L5.06 7.965l6.917-3.822 6.964 3.859-6.918 3.852z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 11.126 12 15.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 15.126 12 19.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b669f997422ac089(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 2 .001 4H5V5h14zM5 11h8v8H5v-8zm10 8v-8h4.001l.001 8H15z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$957554055c751a2f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.88 2.15-1.2.4a13.84 13.84 0 0 1-6.41.64 11.87 11.87 0 0 0-6.68.9A7.23 7.23 0 0 0 3.3 9.5a8.65 8.65 0 0 0 1.47 6.6c-.06.21-.12.42-.17.63A22.6 22.6 0 0 0 4 22h2a30.69 30.69 0 0 1 .59-4.32 9.25 9.25 0 0 0 4.52 1.11 11 11 0 0 0 4.28-.87C23 14.67 22 3.86 22 3.41zm-7.27 13.93c-2.61 1.11-5.73.92-7.48-.45a13.79 13.79 0 0 1 1.21-2.84A10.17 10.17 0 0 1 9.73 11a9 9 0 0 1 1.81-1.42A12 12 0 0 1 16 8V7a11.43 11.43 0 0 0-5.26 1.08 10.28 10.28 0 0 0-4.12 3.65 15.07 15.07 0 0 0-1 1.87 7 7 0 0 1-.38-3.73 5.24 5.24 0 0 1 3.14-4 8.93 8.93 0 0 1 3.82-.84c.62 0 1.23.06 1.87.11a16.2 16.2 0 0 0 6-.35C20 7.55 19.5 14 14.61 16.08z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f8446b104977d2a1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f6b63a476ac175ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 1.993C6.486 1.994 2 6.48 1.999 11.994c0 5.514 4.486 10 10.001 10 5.514-.001 10-4.487 10-10 0-5.514-4.486-10-10.001-10.001zM12 19.994c-4.412 0-8.001-3.589-8.001-8 .001-4.411 3.59-8 8-8.001C16.411 3.994 20 7.583 20 11.994c0 4.41-3.589 7.999-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.012 7.989-4.005 4.005 4.005 4.004v-3.004h3.994v-2h-3.994z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6000c506194ed55a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.464 2.114a.998.998 0 0 0-1.033.063l-13 9a1.003 1.003 0 0 0 0 1.645l13 9A1 1 0 0 0 19 21V3a1 1 0 0 0-.536-.886zM17 19.091 6.757 12 17 4.909v14.182z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f6a5f67b712ea195(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.006 2.007A9.93 9.93 0 0 0 4.935 4.93c-3.898 3.898-3.898 10.242 0 14.142 1.885 1.885 4.396 2.923 7.071 2.923s5.187-1.038 7.071-2.923c3.898-3.899 3.898-10.243 0-14.142a9.931 9.931 0 0 0-7.071-2.923zm5.657 15.65c-1.507 1.507-3.516 2.337-5.657 2.337s-4.15-.83-5.657-2.337c-3.118-3.119-3.118-8.194 0-11.313 1.507-1.507 3.517-2.337 5.657-2.337s4.15.83 5.657 2.337c3.118 3.119 3.118 8.194 0 11.313z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.346 8.247-3.215 3.215-2.125-2.125V15h5.663l-2.124-2.124 3.215-3.215z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d33ea2a54407ef66(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h10v2H4zm0-4h16v2H4zm0 8h10v2H4zm0 4h10v2H4zm0 4h16v2H4zm16-3V8l-4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$51dbe75572f1dc50(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.993 2.007a9.928 9.928 0 0 0-7.071 2.922c-3.899 3.899-3.899 10.243 0 14.143a9.931 9.931 0 0 0 7.071 2.923 9.928 9.928 0 0 0 7.071-2.923c3.899-3.899 3.899-10.243 0-14.143a9.927 9.927 0 0 0-7.071-2.922zm5.657 15.65a7.945 7.945 0 0 1-5.657 2.337c-2.141 0-4.15-.83-5.657-2.337-3.119-3.119-3.119-8.195 0-11.314a7.946 7.946 0 0 1 5.657-2.336c2.142 0 4.15.829 5.657 2.336 3.12 3.119 3.12 8.195 0 11.314z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.657 9H8.993v5.663l2.125-2.124 3.215 3.214 1.414-1.414-3.215-3.214z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$52a15d65df4d4dc1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a9.83 9.83 0 0 1-3.26-.55 2.23 2.23 0 0 0-1.7.19 3.51 3.51 0 0 1-2.47.24 3.55 3.55 0 0 1-2.45-2.45A3.51 3.51 0 0 1 2.36 17a2.23 2.23 0 0 0 .19-1.7 10.07 10.07 0 0 1 0-6.53 9.87 9.87 0 0 1 6.18-6.23 10.07 10.07 0 0 1 6.53 0A2.23 2.23 0 0 0 17 2.36a3.51 3.51 0 0 1 2.47-.24 3.55 3.55 0 0 1 2.45 2.45A3.51 3.51 0 0 1 21.64 7a2.23 2.23 0 0 0-.19 1.7 10.07 10.07 0 0 1 0 6.53 9.87 9.87 0 0 1-6.19 6.19A10.33 10.33 0 0 1 12 22zm-3.84-2.64a3.91 3.91 0 0 1 1.23.2 8 8 0 0 0 5.24 0 7.84 7.84 0 0 0 4.94-4.93 8 8 0 0 0 0-5.24 4.19 4.19 0 0 1 .29-3.23 1.53 1.53 0 0 0 .09-1.08 1.49 1.49 0 0 0-1-1 1.53 1.53 0 0 0-1.08.09 4.19 4.19 0 0 1-3.23.29 8 8 0 0 0-5.24 0 7.84 7.84 0 0 0-4.97 4.91 8 8 0 0 0 0 5.24 4.19 4.19 0 0 1-.29 3.23 1.53 1.53 0 0 0-.09 1.08 1.49 1.49 0 0 0 1 1 1.53 1.53 0 0 0 1.08-.09 4.47 4.47 0 0 1 2.03-.47z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12H6a6 6 0 0 1 6-6v2a4 4 0 0 0-4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b745b3305e65a65a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h2v18H7zM4 3h2v18H4zm6 0h2v18h-2zm9.062 17.792-6.223-16.89 1.877-.692 6.223 16.89z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7aef473c16483225(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802S14.253 2 13.612 2H12c-.297 0-.578.132-.769.36L6.531 8H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 0 0 1.873-1.298l2.757-7.351A1 1 0 0 0 22 12v-2c0-1.103-.897-2-2-2zM4 10h2v9H4v-9zm16 1.819L17.307 19H8V9.362L12.468 4h1.146l-1.562 4.683A.998.998 0 0 0 13 10h7v1.819z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$29772f36bac0bbe5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3H3v18h18v-2H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.586 8.707 8.293 7.293 9.707 13 15.414l3-3 4.293 4.293 1.414-1.414L16 9.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7936686565a25c35(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v17a1 1 0 0 0 1 1h17v-2H5V3H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.293 14.707a.999.999 0 0 0 1.414 0l5-5-1.414-1.414L16 12.586l-2.293-2.293a.999.999 0 0 0-1.414 0l-5 5 1.414 1.414L13 12.414l2.293 2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a7a202a8129e9a2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.222 19.778a4.983 4.983 0 0 0 3.535 1.462 4.986 4.986 0 0 0 3.536-1.462l2.828-2.829-1.414-1.414-2.828 2.829a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.829-2.828-1.414-1.414-2.829 2.828a5.006 5.006 0 0 0 0 7.071zm15.556-8.485a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0L9.879 7.051l1.414 1.414 2.828-2.829a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.829 2.828 1.414 1.414 2.829-2.828z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.464 16.95-1.415-1.414 8.487-8.486 1.414 1.415z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dc079a8d40043159(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6861dfc33f6ba93a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$73bdc54a0d0601bc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h2c4.411 0 8-4.038 8-9h-2c0 3.86-2.691 7-6 7v-7.358l6-1.385V8.204l-6 1.385V7.642l6-1.385V4.204l-6 1.385V3H9v3.05l-3 .693v2.053l3-.692v1.947l-3 .692v2.053l3-.692V21z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c829fb65853add70(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h11v2H4zm0 4h11v2H4zm0 4h7v2H4zm15.299-2.708-4.3 4.291-1.292-1.291-1.414 1.415 2.706 2.704 5.712-5.703z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fb811b125b72a3ba(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.063 15H13v2h9v-2zM4 7h11v2H4zm0 4h11v2H4zm0 4h7v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e50a69b4449785ac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.282 12.064c-.428.328-.72.609-.875.851-.155.24-.249.498-.279.768h2.679v-.748H5.413c.081-.081.152-.151.212-.201.062-.05.182-.142.361-.27.303-.218.511-.42.626-.604.116-.186.173-.375.173-.578a.898.898 0 0 0-.151-.512.892.892 0 0 0-.412-.341c-.174-.076-.419-.111-.733-.111-.3 0-.537.038-.706.114a.889.889 0 0 0-.396.338c-.094.143-.159.346-.194.604l.894.076c.025-.188.074-.317.147-.394a.375.375 0 0 1 .279-.108c.11 0 .2.035.272.108a.344.344 0 0 1 .108.258.55.55 0 0 1-.108.297c-.074.102-.241.254-.503.453zm.055 6.386a.398.398 0 0 1-.282-.105c-.074-.07-.128-.195-.162-.378L4 18.085c.059.204.142.372.251.506.109.133.248.235.417.306.168.069.399.103.692.103.3 0 .541-.047.725-.14a1 1 0 0 0 .424-.403c.098-.175.146-.354.146-.544a.823.823 0 0 0-.088-.393.708.708 0 0 0-.249-.261 1.015 1.015 0 0 0-.286-.11.943.943 0 0 0 .345-.299.673.673 0 0 0 .113-.383.747.747 0 0 0-.281-.596c-.187-.159-.49-.238-.909-.238-.365 0-.648.072-.847.219-.2.143-.334.353-.404.626l.844.151c.023-.162.067-.274.133-.338s.151-.098.257-.098a.33.33 0 0 1 .241.089c.059.06.087.139.087.238 0 .104-.038.193-.117.27s-.177.112-.293.112a.907.907 0 0 1-.116-.011l-.045.649a1.13 1.13 0 0 1 .289-.056c.132 0 .237.041.313.126.077.082.115.199.115.352 0 .146-.04.266-.119.354a.394.394 0 0 1-.301.134zm.948-10.083V5h-.739a1.47 1.47 0 0 1-.394.523c-.168.142-.404.262-.708.365v.754a2.595 2.595 0 0 0 .937-.48v2.206h.904zM9 6h11v2H9zm0 5h11v2H9zm0 5h11v2H9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$80b9ef4c073ebd10(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v-3h-2v3h-3v2h3v3h2v-3h3v-2h-.937zM4 7h11v2H4zm0 4h11v2H4zm0 4h8v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$634249aa224fc9a0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v2H4zm0 5h2v2H4zm0 5h2v2H4zm16-8V6H8.023v2H18.8zM8 11h12v2H8zm0 5h12v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$546002cbc11e4ce3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$920aa91797e95190(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.343",
                    "cy": "17.657",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.657",
                    "cy": "6.343",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "12",
                    "r": "2.001"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.343",
                    "cy": "6.344",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.657",
                    "cy": "17.658",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6e1591fcad101d1b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11h5v2H2zm15 0h5v2h-5zm-6 6h2v5h-2zm0-15h2v5h-2zM4.222 5.636l1.414-1.414 3.536 3.536-1.414 1.414zm15.556 12.728-1.414 1.414-3.536-3.536 1.414-1.414zm-12.02-3.536 1.414 1.414-3.536 3.536-1.414-1.414zm7.07-7.071 3.536-3.535 1.414 1.415-3.536 3.535z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$57d680683a603ea0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.42 21.815a1.004 1.004 0 0 0 1.16 0C12.884 21.598 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.996c-.029 6.444 7.116 11.602 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.004.021 4.438-4.388 8.423-6 9.731-1.611-1.308-6.021-5.293-6-9.735 0-3.309 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$893e00bb8c957f57(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zm6 10 .002 8H6v-8h12zm-9-2V7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e6718a38cccc1a64(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1h2zm1 4 .002 8H6v-8h12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b0ae4c01b4c9042a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.654 0 3 1.346 3 3h2c0-2.757-2.243-5-5-5S7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3zm6.002 16H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a491a7d3cbf68c5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v2H9V7zm9.002 13H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4fb717b912c1aca5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.998 16 5-4-5-4v3h-9v2h9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.999 2.999a8.938 8.938 0 0 0-6.364 2.637L8.049 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051S20 10.13 20 12s-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637C21.063 16.665 22 14.405 22 12s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dc6b9d1ab05b8027(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 16 5-4-5-4v3H4v2h9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$289b724c4c4a9567(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 12 5 4v-3h9v-2H7V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.001 2.999a8.938 8.938 0 0 0-6.364 2.637L8.051 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051 2.051 3.08 2.051 4.95-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637c1.7-1.699 2.637-3.959 2.637-6.364s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$96d6b71e66e8b699(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13v-2H7V8l-5 4 5 4v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2981416dade4463f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.998c-1.836 0-3.356.389-4.617.971L3.707 2.293 2.293 3.707l3.315 3.316c-2.613 1.952-3.543 4.618-3.557 4.66l-.105.316.105.316C2.073 12.382 4.367 19 12 19c1.835 0 3.354-.389 4.615-.971l3.678 3.678 1.414-1.414-3.317-3.317c2.614-1.952 3.545-4.618 3.559-4.66l.105-.316-.105-.316c-.022-.068-2.316-6.686-9.949-6.686zM4.074 12c.103-.236.274-.586.521-.989l5.867 5.867C6.249 16.23 4.523 13.035 4.074 12zm9.247 4.907-7.48-7.481a8.138 8.138 0 0 1 1.188-.982l8.055 8.054a8.835 8.835 0 0 1-1.763.409zm3.648-1.352-1.541-1.541c.354-.596.572-1.28.572-2.015 0-.474-.099-.924-.255-1.349A.983.983 0 0 1 15 11a1 1 0 0 1-1-1c0-.439.288-.802.682-.936A3.97 3.97 0 0 0 12 7.999c-.735 0-1.419.218-2.015.572l-1.07-1.07A9.292 9.292 0 0 1 12 6.998c5.351 0 7.425 3.847 7.926 5a8.573 8.573 0 0 1-2.957 3.557z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dd8c72349f992f53(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-3c-1.103 0-2 .897-2 2v8c0 1.103-.897 2-2 2s-2-.897-2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v8c0 4.963 4.037 9 9 9s9-4.037 9-9V5c0-1.103-.897-2-2-2zm-3 2h3v3h-3V5zM5 5h3v3H5V5zm7 15c-3.859 0-7-3.141-7-7v-3h3v3c0 2.206 1.794 4 4 4s4-1.794 4-4v-3h3v3c0 3.859-3.141 7-7 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9e745e336516ba2d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H6c-1.103 0-2 .897-2 2v5h2V8l6.4 4.8a1.001 1.001 0 0 0 1.2 0L20 8v9h-8v2h8c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7 6.75L6.666 6h12.668L13 10.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h7v2H2zm2 3h6v2H4zm3 3h4v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ae4162682006e4b0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H3a1 1 0 0 0-1 1v7h2v7h4v-7h2V8a1 1 0 0 0-1-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.21 7.73a1 1 0 0 0-1-.73h-4.5a1 1 0 0 0-1 .73L12 14h2l-1 4h2v4h4v-4h2l-1-4h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f3273318c1b69d09(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11V4h-7l2.793 2.793-4.322 4.322A5.961 5.961 0 0 0 8 10c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6c0-1.294-.416-2.49-1.115-3.471l4.322-4.322L20 11zM8 20c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5564b78992f4bc07(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7H9a1 1 0 0 0-1 1v7h2v7h4v-7h2V8a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9890a23e89ef1967(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.447 6.105-6-3a1 1 0 0 0-.895 0L9 5.882 3.447 3.105A1 1 0 0 0 2 4v13c0 .379.214.725.553.895l6 3a1 1 0 0 0 .895 0L15 18.118l5.553 2.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851V7c0-.379-.214-.725-.553-.895zM10 7.618l4-2v10.764l-4 2V7.618zm-6-2 4 2v10.764l-4-2V5.618zm16 12.764-4-2V5.618l4 2v10.764z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c66cb3b94976eb92(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 17 1-2V9.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 3.794 8 6c0 1.858 1.279 3.411 3 3.858V15l1 2zM10 6c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.267 10.563-.533 1.928C18.325 13.207 20 14.584 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C4.197 11.54 2 13.623 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f742ea9eee1a8cf2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.42 21.814a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.005.021 4.438-4.388 8.423-6 9.73-1.611-1.308-6.021-5.294-6-9.735 0-3.309 2.691-6 6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aec7295899680426(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5C3.346 6 2 7.346 2 9v5c0 2.206 1.794 4 4 4h1.637c1.166 0 2.28-.557 2.981-1.491.66-.879 2.104-.88 2.764.001A3.744 3.744 0 0 0 16.363 18H18c2.206 0 4-1.794 4-4V9c0-1.654-1.346-3-3-3zm1 8c0 1.103-.897 2-2 2h-1.637c-.54 0-1.057-.259-1.382-.69-.71-.948-1.797-1.492-2.981-1.492s-2.271.544-2.981 1.491A1.741 1.741 0 0 1 7.637 16H6c-1.103 0-2-.897-2-2V9c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v5z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "7.5",
                    "cy": "11.5",
                    "rx": "2.5",
                    "ry": "1.5"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "16.5",
                    "cy": "11.5",
                    "rx": "2.5",
                    "ry": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2e8bdf5ddcca6fd9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H5v3H2v2h3v3h2V7h3V5H7V2zm7 3h8v2h-8zm0 10h8v2h-8zm0 4h8v2h-8zm-5.71-4.71L6 16.59l-2.29-2.3-1.42 1.42L4.59 18l-2.3 2.29 1.42 1.42L6 19.41l2.29 2.3 1.42-1.42L7.41 18l2.3-2.29-1.42-1.42z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$885ee3022e2a449a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.859 0 7-3.141 7-7s-3.141-7-7-7c-3.86 0-7 3.141-7 7s3.14 7 7 7zm0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm-1-8H7v5.518a8.957 8.957 0 0 1 4-1.459V2zm6 0h-4v4.059a8.957 8.957 0 0 1 4 1.459V2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.019 15.811-.468 2.726L12 17.25l2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L12 11l-1.225 2.481-2.738.398z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8bdcd17b97a2d20b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h4v2h-4zm-6.026 5H16v2H7.974zM6 10h4v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$119a9fbb40502382(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6b090369e9fe04b0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.974 15H16v2H7.974z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97b3ac56412853f4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V8a.997.997 0 0 0-.293-.707l-5-5A.996.996 0 0 0 14 2H6c-1.103 0-2 .897-2 2zm14 4.414L18.001 20H6V4h7.586L18 8.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h2v4H8zm4 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d14b72abead49539(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h12v2H4zm0-5h16v2H4zm0 12h7.235v-2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$447cbd48bb399ff0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm4 5h12v2H8zm5 5h7v2h-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6936cbc2bf0e4dfe(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8b2bc4c0e9d0d78(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19v-9a2 2 0 0 0-2-2h-1v8a2 2 0 0 1-2 2H8v1a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$247444d52b9d9b8b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5b4b6ef25c145ac8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$887f353dcbb74faf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm2 0h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 7.207-1.414-1.414L11 10.586 8.707 8.293 7.293 9.707 11 13.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c4300133bd9dba64(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm14 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aa676d8f5ed09768(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4d9452389f20cc8b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.479 7.219-4.977 4.969v1.799h1.8l4.975-4.969zm2.219-2.22 1.8 1.8-1.37 1.37-1.8-1.799z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7ee3630c91c52967(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm14 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v6h-2zm0 7h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$33f955f2f3147f79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$df98c5b1a0ef3140(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$679b61b1d55acc25(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$37cb47277fe1c519(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 7.207-1.414-1.414L11 10.586 8.707 8.293 7.293 9.707 11 13.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$938fa8298a8d74f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1bf5a3b2d65e2bd2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.766L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.234V16H4V4h16v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4bc451d48bfb96f8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.803 9.189-1.399-1.398-3.869 3.864v1.399h1.399zm.327-3.123 1.398 1.399-1.066 1.066-1.399-1.398z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fc3ff3390d9f64d8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ee7b759180289633(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$626e140ee4c9aaf0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h-2v3H8v2h3v3h2v-3h3V9h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e73ab232370be5c7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.339-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.586 8.707 9.293l-1.414 1.414L11 14.414l6.207-6.207-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4eb334e53dadc52a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$74d9b3e02134d433(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.897 5.515 5 6.934V22l5.34-4.004C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.671 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$341bf37e45fb0a79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.503 11.589v1.398h1.398l3.87-3.864-1.399-1.398zm5.927-3.125-1.398-1.398 1.067-1.067 1.398 1.398z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a2be84075c72d18b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e0c96e9fd5de86b6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dcef372538bbbcdf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.293 6.293 12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293 1.414 1.414L12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$724493cb958e64fb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.516 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4bb4fd757a4d0052(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f78ac874aec0e1a0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 13.586-2.293-2.293-1.414 1.414L11 16.414l6.207-6.207-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f9b7f413dfb671c3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$38a63eaffd773b6d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v12a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 13c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c1f43f417b9f9e41(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14.987v1.999h1.999l5.529-5.522-1.998-1.998zm8.47-4.465-1.998-2L14.995 7l2 1.999z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9fb1d30e9f9486d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v8h-2zm0 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4b23195138c92606(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$843507194b89ba60(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.292 7.295 12 10.587 8.708 7.295 7.294 8.709l3.292 3.292-3.292 3.292 1.414 1.414L12 13.415l3.292 3.292 1.414-1.414-3.292-3.292 3.292-3.292z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a943ebe4155db079(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v12a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 13c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$71b0b04ec9b6772b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$831823b28e9b7b9b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dc787ecebd3bcc75(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 22c2.003 0 3.887-.78 5.313-2.207l6.904-7.096A1 1 0 0 0 21 11h-3.301l4.175-7.514a1.001 1.001 0 0 0-1.359-1.36l-7.11 3.95.576-2.879a1 1 0 0 0-1.629-.957L4.196 9.197c-2.924 2.924-2.924 7.682 0 10.606A7.452 7.452 0 0 0 9.5 22zM5.552 10.665l5.902-5.031-.248 1.24-.186.93v.001l-.424 2.119 7.83-4.35-3.3 5.94-.001.001L14.301 13h4.331l-5.243 5.389C12.35 19.428 10.969 20 9.5 20s-2.851-.572-3.89-1.611c-2.143-2.144-2.143-5.634-.058-7.724z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 18a3.492 3.492 0 0 0 1.484-6.659c.005.053.016.105.016.159a1.5 1.5 0 1 1-3 0c0-.054.011-.106.016-.159A3.492 3.492 0 0 0 9.5 18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$611eb9e2f11dd504(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 20V4h8l.001 16H8zM3 7h2V5H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 11h2V9H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 15h2v-2H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 19h2v-2H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$14f2e297a30e9577(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-3.388-3.388A7.942 7.942 0 0 0 20 12.021h-2a5.95 5.95 0 0 1-1.109 3.456l-1.452-1.452c.348-.591.561-1.27.561-2.004v-6C16 3.804 14.215 2 12.021 2c-.07 0-.14.009-.209.025A4.005 4.005 0 0 0 8 6.021v.565L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM10 6.021c0-1.103.897-2 2-2a.918.918 0 0 0 .164-.015C13.188 4.08 14 4.956 14 6.021v6c0 .172-.029.335-.071.494L10 8.586V6.021zm-4 6H4c0 4.072 3.06 7.436 7 7.931v2.069h2v-2.07a7.993 7.993 0 0 0 2.218-.611l-1.558-1.558a5.979 5.979 0 0 1-1.66.239c-3.309 0-6-2.692-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.011 12.132a3.993 3.993 0 0 0 3.877 3.877l-3.877-3.877z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f216758fa181ece7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4s4-1.794 4-4zm-6 0V6c0-1.103.897-2 2-2a.89.89 0 0 0 .163-.015C13.188 4.06 14 4.935 14 6v6c0 1.103-.897 2-2 2s-2-.897-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fa54013bcb78a051(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2zM5 5h9l-.003 9H5V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$459b13c30b581264(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h10v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1d3f6223d34c040e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm13.997 3H10v-9h9l-.003 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8724a57b8bd2a9df(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h14v2H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$af95f11edd45a5d7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.75 2h-10c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-10 18V4h10l.002 16H6.75z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.75",
                    "cy": "18",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$abcfe636a3a565f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM7.001 7H19v10H7.001V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$742ebee5978017bc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 2.808c-.756-.756-2.072-.756-2.828 0l-9.899 9.899a2.001 2.001 0 0 0 0 2.828l5.657 5.657c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l9.899-9.899c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-5.657-5.657zm-5.656 16.97v1-1l-5.657-5.657 9.899-9.899 5.657 5.657-9.899 9.899z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "15",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.707 21.707-1.414-1.414 6-6 1.414 1.415zM8.293 2.293l1.414 1.414-6 6-1.414-1.415z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$40cf6c8cc7590551(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM7 16.999V5h10l.002 11.999H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2273e7aa309fb81e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9937c2fc6c37516f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 11a3 3 0 0 0-3 3H7a3 3 0 0 0-3-3V9a3 3 0 0 0 3-3h10a3 3 0 0 0 3 3v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$878567ae99509067(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.742 13.045a8.088 8.088 0 0 1-2.077.271c-2.135 0-4.14-.83-5.646-2.336a8.025 8.025 0 0 1-2.064-7.723A1 1 0 0 0 9.73 2.034a10.014 10.014 0 0 0-4.489 2.582c-3.898 3.898-3.898 10.243 0 14.143a9.937 9.937 0 0 0 7.072 2.93 9.93 9.93 0 0 0 7.07-2.929 10.007 10.007 0 0 0 2.583-4.491 1.001 1.001 0 0 0-1.224-1.224zm-2.772 4.301a7.947 7.947 0 0 1-5.656 2.343 7.953 7.953 0 0 1-5.658-2.344c-3.118-3.119-3.118-8.195 0-11.314a7.923 7.923 0 0 1 2.06-1.483 10.027 10.027 0 0 0 2.89 7.848 9.972 9.972 0 0 0 7.848 2.891 8.036 8.036 0 0 1-1.484 2.059z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d9b0eb12bc83a461(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2h-2C7.691 2 5 4.691 5 8v8c0 3.309 2.691 6 6 6h2c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-2 2v6H7V8c0-2.206 1.794-4 4-4zm6 12c0 2.206-1.794 4-4 4h-2c-2.206 0-4-1.794-4-4v-4h10v4zm-4-6V4c2.206 0 4 1.794 4 4v2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5402202a7708440a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.975 22H12c3.859 0 7-3.14 7-7V9c0-3.841-3.127-6.974-6.981-7h-.06C8.119 2.022 5 5.157 5 9v6c0 3.86 3.129 7 6.975 7zM7 9a5.007 5.007 0 0 1 4.985-5C14.75 4.006 17 6.249 17 9v6c0 2.757-2.243 5-5 5h-.025C9.186 20 7 17.804 7 15V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ddfb3f243c4b4363(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11H7V7l-5 5 5 5v-4h10v4l5-5-5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2c6b04b672ae3952(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 17 5 5 5-5h-4V7h4l-5-5-5 5h4v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8afed1b0b5686b6a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11h-5V6h3l-4-4-4 4h3v5H6V8l-4 4 4 4v-3h5v5H8l4 4 4-4h-3v-5h5v3l4-4-4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$76c698e9ed79501d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.465l-2.667-4H20l.001 4zM9.536 9 6.869 5h2.596l2.667 4H9.536zm5 0-2.667-4h2.596l2.667 4h-2.596zM4 5h.465l2.667 4H4V5zm0 14v-8h16l.002 8H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 18 5.5-3-5.5-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c2c06ef3e929dd67(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.466l-2.667-4H20l.001 4zM9.535 9 6.868 5h2.597l2.667 4H9.535zm5 0-2.667-4h2.597l2.667 4h-2.597zM4 5h.465l2.667 4H4V5zm0 14v-8h16l.002 8H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4fc9af5c33097261(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.684 5.821-9-3.272A1.998 1.998 0 0 0 8 4.428v6.129A3.953 3.953 0 0 0 6 10c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V4.428L19 7.7v6.856A3.962 3.962 0 0 0 17 14c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V7.7c0-.838-.529-1.594-1.316-1.879zM6 16c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm11 4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e0a14dd258ee5dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.002 9.63c-.023.411.207.794.581.966l7.504 3.442 3.442 7.503c.164.356.52.583.909.583l.057-.002a1 1 0 0 0 .894-.686l5.595-17.032c.117-.358.023-.753-.243-1.02s-.66-.358-1.02-.243L2.688 8.736a1 1 0 0 0-.686.894zm16.464-3.971-4.182 12.73-2.534-5.522a.998.998 0 0 0-.492-.492L5.734 9.841l12.732-4.182z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$917e9218ad7cf01f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3c-1.654 0-3 1.346-3 3 0 .502.136.968.354 1.385l-1.116 1.302A3.976 3.976 0 0 0 13 8c-.739 0-1.425.216-2.02.566L9.566 7.152A3.449 3.449 0 0 0 10 5.5C10 3.57 8.43 2 6.5 2S3 3.57 3 5.5 4.57 9 6.5 9c.601 0 1.158-.166 1.652-.434L9.566 9.98A3.972 3.972 0 0 0 9 12c0 .997.38 1.899.985 2.601l-1.692 1.692.025.025A2.962 2.962 0 0 0 7 16c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.476-.121-.919-.318-1.318l.025.025 1.954-1.954c.421.15.867.247 1.339.247 2.206 0 4-1.794 4-4a3.96 3.96 0 0 0-.439-1.785l1.253-1.462c.364.158.764.247 1.186.247 1.654 0 3-1.346 3-3s-1.346-3-3-3zM7 20a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM5 5.5C5 4.673 5.673 4 6.5 4S8 4.673 8 5.5 7.327 7 6.5 7 5 6.327 5 5.5zm8 8.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3187803eaabcd85(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.875 3H4.125C2.953 3 2 3.897 2 5v14c0 1.103.953 2 2.125 2h15.75C21.047 21 22 20.103 22 19V5c0-1.103-.953-2-2.125-2zm0 16H4.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008L3.988 5.046c.007-.01.052-.046.137-.046h15.75c.079.001.122.028.125.008l.012 13.946c-.007.01-.052.046-.137.046z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h6v6H6zm7 8H6v2h12v-2h-4zm1-4h4v2h-4zm0-4h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$287e723f45186e58(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h10v4H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$941540e214cc4594(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zM21 3h-2v14.59l-2-2V7h-2v6.59l-2-2V10h-1.59l-7.7-7.71-1.42 1.42 18 18 1.42-1.42-.71-.7V3zm-6 18h1.88L15 19.12V21zm-4 0h2v-3.88l-2-2V21z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$57f797dc387bb9ff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8a.996.996 0 0 0 .707-.293l7-7a.997.997 0 0 0 .196-.293c.014-.03.022-.061.033-.093a.991.991 0 0 0 .051-.259c.002-.021.013-.041.013-.062V5c0-1.103-.897-2-2-2zM5 5h14v7h-6a1 1 0 0 0-1 1v6H5V5zm9 12.586V14h3.586L14 17.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$14eec3db42acfc41(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h10v2H7zm0 4h5v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$da970c91061b1699(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.71 20.296-1.786-1.786c.045-.163.076-.332.076-.51v-7h-2v5.586L7.414 6H13V4H6c-.178 0-.347.031-.51.076l-1.78-1.78L2.296 3.71l18 18 1.414-1.414zM4 8.121V18c0 1.103.897 2 2 2h9.879l-2-2H6v-7.879l-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8be0fe0bfe1f5396(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19H5V6h8c0-.712.153-1.387.422-2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h13c1.103 0 2-.897 2-2v-8.422A4.962 4.962 0 0 1 18 11v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4cf17b2f5c4a0ee9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h6v2h2v-2h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-6v-2h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4V2h-2v2H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4v2H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zM8 6h8v3H8zm-2 9h12v3H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f96f005efa5cdc82(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v20H2zM21 13H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm-1 5H8v-3h12zM7 11h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm1-5h8v3H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d2088bdbf537d459(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2zM18 14a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-2 4H4v-3h12zM7 11h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm1-5h8v3H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$696350a1f72fcbef(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v2H2zM4 3v14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm2 1h3v12H6zM13 17a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1zm2-9h3v8h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$efcb6e4b2f50fe66(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v4h-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6H2v2h2v6a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6h2v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4h2v-2h-2zM9 18H6V6h3zm9-2h-3V8h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aeac432bdcbd9e6c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h20v2H2zM11 21V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zm-2-1H6V8h3zM19 6h-5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 10h-3V8h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a49ca961314d1169(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2zM5 14V5h9v3h-4c-1.103 0-2 .897-2 2v4H5zm9.001 0H10v-4h4.001v4zM10 16h4c1.103 0 2-.897 2-2v-4h3l.001 9H10v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f7d48dfd77ae7dde(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8a.76.76 0 0 0 0-.21v-.08a.77.77 0 0 0-.07-.16.35.35 0 0 0-.05-.08l-.1-.13-.08-.06-.12-.09-9-5a1 1 0 0 0-1 0l-9 5-.09.07-.11.08a.41.41 0 0 0-.07.11.39.39 0 0 0-.08.1.59.59 0 0 0-.06.14.3.3 0 0 0 0 .1A.76.76 0 0 0 2 8v8a1 1 0 0 0 .52.87l9 5a.75.75 0 0 0 .13.06h.1a1.06 1.06 0 0 0 .5 0h.1l.14-.06 9-5A1 1 0 0 0 22 16V8zm-10 3.87L5.06 8l2.76-1.52 6.83 3.9zm0-7.72L18.94 8 16.7 9.25 9.87 5.34zM4 9.7l7 3.92v5.68l-7-3.89zm9 9.6v-5.68l3-1.68V15l2-1v-3.18l2-1.11v5.7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$adb65a5554637092(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H7c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM7 7V4h11l.002 3H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15v-2c0-1.103-.897-2-2-2H4V5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h7v2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e98ad8f74e06ae6a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.061 22c1.523 0 2.84-.543 3.91-1.613 1.123-1.123 1.707-2.854 1.551-4.494l8.564-8.564a3.123 3.123 0 0 0-.002-4.414c-1.178-1.18-3.234-1.18-4.412 0l-8.884 8.884c-1.913.169-3.807 1.521-3.807 3.919 0 .303.021.588.042.86.08 1.031.109 1.418-1.471 2.208a1.001 1.001 0 0 0-.122 1.717C2.52 20.563 4.623 22 7.061 22c-.001 0-.001 0 0 0zM18.086 4.328a1.144 1.144 0 0 1 1.586.002 1.12 1.12 0 0 1 0 1.584L12 13.586 10.414 12l7.672-7.672zM6.018 16.423c-.018-.224-.037-.458-.037-.706 0-1.545 1.445-1.953 2.21-1.953.356 0 .699.073.964.206.945.475 1.26 1.293 1.357 1.896.177 1.09-.217 2.368-.956 3.107C8.865 19.664 8.049 20 7.061 20H7.06c-.75 0-1.479-.196-2.074-.427 1.082-.973 1.121-1.989 1.032-3.15z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2d3aff6971fda2b1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4 2.096a10.08 10.08 0 0 0-8.937 3.331A10.054 10.054 0 0 0 2.096 13.4c.53 3.894 3.458 7.207 7.285 8.246a9.982 9.982 0 0 0 2.618.354l.142-.001a3.001 3.001 0 0 0 2.516-1.426 2.989 2.989 0 0 0 .153-2.879l-.199-.416a1.919 1.919 0 0 1 .094-1.912 2.004 2.004 0 0 1 2.576-.755l.412.197c.412.198.85.299 1.301.299A3.022 3.022 0 0 0 22 12.14a9.935 9.935 0 0 0-.353-2.76c-1.04-3.826-4.353-6.754-8.247-7.284zm5.158 10.909-.412-.197c-1.828-.878-4.07-.198-5.135 1.494-.738 1.176-.813 2.576-.204 3.842l.199.416a.983.983 0 0 1-.051.961.992.992 0 0 1-.844.479h-.112a8.061 8.061 0 0 1-2.095-.283c-3.063-.831-5.403-3.479-5.826-6.586-.321-2.355.352-4.623 1.893-6.389a8.002 8.002 0 0 1 7.16-2.664c3.107.423 5.755 2.764 6.586 5.826.198.73.293 1.474.282 2.207-.012.807-.845 1.183-1.441.894z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e7ceaa09c63c81f5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.56,3.34a1,1,0,0,0-1-.08l-17,8a1,1,0,0,0-.57.92,1,1,0,0,0,.6.9L8,15.45v6.72L13.84,18l4.76,2.08a.93.93,0,0,0,.4.09,1,1,0,0,0,.52-.15,1,1,0,0,0,.48-.79l1-15A1,1,0,0,0,20.56,3.34ZM18.1,17.68l-5.27-2.31L16,9.17,8.35,13.42,5.42,12.13,18.89,5.79Z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$81b4440e7f5047b0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.004 5H9c-1.838 0-3.586.737-4.924 2.076C2.737 8.415 2 10.163 2 12c0 1.838.737 3.586 2.076 4.924C5.414 18.263 7.162 19 9 19h8v-2H9c-1.303 0-2.55-.529-3.51-1.49C4.529 14.55 4 13.303 4 12c0-1.302.529-2.549 1.49-3.51C6.45 7.529 7.697 7 9 7h8V6l.001 1h.003c.79 0 1.539.314 2.109.886.571.571.886 1.322.887 2.116a2.966 2.966 0 0 1-.884 2.11A2.988 2.988 0 0 1 17 13H9a.99.99 0 0 1-.698-.3A.991.991 0 0 1 8 12c0-.252.11-.507.301-.698A.987.987 0 0 1 9 11h8V9H9c-.79 0-1.541.315-2.114.889C6.314 10.461 6 11.211 6 12s.314 1.54.888 2.114A2.974 2.974 0 0 0 9 15h8.001a4.97 4.97 0 0 0 3.528-1.473 4.967 4.967 0 0 0-.001-7.055A4.95 4.95 0 0 0 17.004 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8351d79a60600ff0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2v4h2V6h2v14h2V6h3V4H9c-3.309 0-6 2.691-6 6s2.691 6 6 6zM9 6h2v8H9c-2.206 0-4-1.794-4-4s1.794-4 4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2289512e5b9b9cef(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.91 3.91 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31-.07.08-.15.13-.22.2-3-2.41-6.29-3.77-7.9-2.16a2.16 2.16 0 0 0-.41.59v.1l-.18.53-4.41 13.1A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17L20 17.28a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9V7a8.44 8.44 0 0 0-5 1.31zM5.7 19.93a1.29 1.29 0 0 1-1.63-1.63l1.36-4.1a10.7 10.7 0 0 0 4.29 4.39zm7-2.33a8.87 8.87 0 0 1-6.3-6.29l1-3 .06.09c.11.22.25.45.39.68s.16.29.26.44.33.48.51.73.19.28.3.42.43.55.66.82l.29.35c.34.39.7.77 1.08 1.16s.68.64 1 1l.33.28.78.63.37.28c.28.2.55.4.83.58l.31.2c.36.22.72.43 1.07.61h.05zm6.51-2.23h-.06c-.69.38-3.56-.57-6.79-3.81-.34-.34-.66-.67-.95-1l-.29-.35-.53-.64-.29-.4c-.13-.19-.27-.37-.39-.55l-.26-.42-.29-.47c-.08-.14-.14-.27-.21-.4s-.15-.26-.21-.4a3.31 3.31 0 0 1-.14-.36c-.05-.13-.11-.26-.15-.38S8.6 6 8.57 5.88s-.05-.22-.07-.32a2.26 2.26 0 0 1 0-.26 1 1 0 0 1 0-.24l.11-.31c.36-.36 2.23 0 4.73 1.9A4.13 4.13 0 0 1 12 7v2a6.45 6.45 0 0 0 3-.94l.48.46c.42.42.81.85 1.18 1.28a5.32 5.32 0 0 0-.6 3.4l2-.39a3.57 3.57 0 0 1 0-1.12 11.3 11.3 0 0 1 .81 1.45c.56 1.32.52 2.06.34 2.23z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de83555d307f4b8a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11V5c0-1.103-.897-2-2-2h-3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H4c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h7c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-9 2v5H4V5h3v2h8V5h3v6h-5c-1.103 0-2 .897-2 2zm2 7v-7h7l.001 7H13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ae6fd087372da206(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h2v6h-2zM9 9h2v6H9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$816d9082b987955a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h3v10H8zm5 0h3v10h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$26fd12202c30b953(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.404 2.998c-.757-.754-2.077-.751-2.828.005l-1.784 1.791L11.586 7H7a.998.998 0 0 0-.939.658l-4 11c-.133.365-.042.774.232 1.049l2 2a.997.997 0 0 0 1.049.232l11-4A.998.998 0 0 0 17 17v-4.586l2.207-2.207v-.001h.001L21 8.409c.378-.378.586-.881.585-1.415 0-.535-.209-1.038-.588-1.415l-2.593-2.581zm-3.111 8.295A.996.996 0 0 0 15 12v4.3l-9.249 3.363 4.671-4.671c.026.001.052.008.078.008A1.5 1.5 0 1 0 9 13.5c0 .026.007.052.008.078l-4.671 4.671L7.7 9H12c.266 0 .52-.105.707-.293L14.5 6.914 17.086 9.5l-1.793 1.793zm3.206-3.208-2.586-2.586 1.079-1.084 2.593 2.581-1.086 1.089z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1670e339606d5212(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dcce33bc1cae19a3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.57 22a2 2 0 0 0 1.43-.59l2.71-2.71a1 1 0 0 0 0-1.41l-4-4a1 1 0 0 0-1.41 0l-1.6 1.59a7.55 7.55 0 0 1-3-1.59 7.62 7.62 0 0 1-1.59-3l1.59-1.6a1 1 0 0 0 0-1.41l-4-4a1 1 0 0 0-1.41 0L2.59 6A2 2 0 0 0 2 7.43 15.28 15.28 0 0 0 6.3 17.7 15.28 15.28 0 0 0 16.57 22zM6 5.41 8.59 8 7.3 9.29a1 1 0 0 0-.3.91 10.12 10.12 0 0 0 2.3 4.5 10.08 10.08 0 0 0 4.5 2.3 1 1 0 0 0 .91-.27L16 15.41 18.59 18l-2 2a13.28 13.28 0 0 1-8.87-3.71A13.28 13.28 0 0 1 4 7.41zM20 11h2a8.81 8.81 0 0 0-9-9v2a6.77 6.77 0 0 1 7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c2.1 0 3 .9 3 3h2c0-3.22-1.78-5-5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4a41b7be370b1296(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.712 13.288a.999.999 0 0 0-1.414 0l-1.597 1.596c-.824-.245-2.166-.771-2.99-1.596-.874-.874-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a1.03 1.03 0 0 0-1.414 0l-2.709 2.71c-.382.38-.597.904-.588 1.437.022 1.423.396 6.367 4.297 10.268C10.195 21.6 15.142 21.977 16.566 22h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-3.999-4zM16.585 20c-1.248-.021-5.518-.356-8.874-3.712C4.343 12.92 4.019 8.636 4 7.414l2.004-2.005L8.59 7.995 7.297 9.288c-.238.238-.34.582-.271.912.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.994.994 0 0 0 .912-.271l1.293-1.293 2.586 2.586L16.585 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.795 6.791 13.005 4v6.995H20l-2.791-2.79 4.503-4.503-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$18f8a865ee9a3463(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 12.5a8.92 8.92 0 0 1-1-2.2l1.59-1.59a1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-1.41 0L2.59 6A2 2 0 0 0 2 7.44 15.44 15.44 0 0 0 5.62 17L2.3 20.29l1.41 1.42 18-18-1.41-1.42zM7 15.55a13.36 13.36 0 0 1-3-8.13l2-2L8.59 8 7.3 9.29a1 1 0 0 0-.27.92 11 11 0 0 0 1.62 3.73zm9.71-2.26a1 1 0 0 0-1.41 0l-1.6 1.6-.34-.12-1.56 1.55a12.06 12.06 0 0 0 2 .66 1 1 0 0 0 .91-.27l1.3-1.3L18.59 18l-2 2A13.61 13.61 0 0 1 10 18.1l-1.43 1.45a15.63 15.63 0 0 0 8 2.45 2 2 0 0 0 1.43-.58l2.71-2.71a1 1 0 0 0 0-1.42z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$98872fb245cf526b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.712 13.288a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0L2.586 6c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268S15.142 21.977 16.566 22h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-3.999-4zM16.585 20c-1.248-.021-5.518-.356-8.873-3.712C4.346 12.922 4.02 8.637 4 7.414l2.005-2.005 2.586 2.586-1.293 1.293a1 1 0 0 0-.272.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.993.993 0 0 0 .912-.271l1.293-1.293 2.586 2.586L16.585 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.795 5.791-4.497 4.497 1.414 1.414 4.497-4.497L21.005 10V2.995H14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6e29bee1fcf1f943(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.707 12.293a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0L3.581 5.005c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268s8.844 4.274 10.269 4.298h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-4-4.001zm-.127 6.712c-1.248-.021-5.518-.356-8.873-3.712-3.366-3.366-3.692-7.651-3.712-8.874L7 4.414 9.586 7 8.293 8.293a1 1 0 0 0-.272.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.991.991 0 0 0 .912-.271L17 14.414 19.586 17l-2.006 2.005z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7f55099ed4e760b7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.024 11.536 10 10l-2 3h9l-3.5-5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.503",
                    "cy": "7.497",
                    "r": "1.503"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2zm0 14H5V5c0-.806.55-.988 1-1h13v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97ee7b87501686e8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9H13V4.069A8.008 8.008 0 0 1 19.931 11zM4 12c0-4.072 3.061-7.436 7-7.931V12a.996.996 0 0 0 .111.438c.015.03.022.063.041.093l4.202 6.723A7.949 7.949 0 0 1 12 20c-4.411 0-8-3.589-8-8zm13.052 6.196L13.805 13h6.126a7.992 7.992 0 0 1-2.879 5.196z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2e884536e2465693(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a9.936 9.936 0 0 0-7.071 2.929C3.04 6.818 2 9.33 2 12s1.04 5.182 2.929 7.071C6.818 20.96 9.33 22 12 22s5.182-1.04 7.071-2.929C20.96 17.182 22 14.67 22 12s-1.04-5.182-2.929-7.071A9.936 9.936 0 0 0 12 2zm5.657 15.657C16.146 19.168 14.137 20 12 20s-4.146-.832-5.657-2.343C4.832 16.146 4 14.137 4 12s.832-4.146 2.343-5.657A7.927 7.927 0 0 1 11 4.069V12a1 1 0 0 0 1 1h7.931a7.927 7.927 0 0 1-2.274 4.657zM13 11V4.062a7.945 7.945 0 0 1 4.657 2.281A7.934 7.934 0 0 1 19.938 11H13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d6a54bcae64af37f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.166V12h6.834A6.817 6.817 0 0 0 12 5.166z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f989daf3f28cc7d1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 22 1-2v-3h5a1 1 0 0 0 1-1v-1.586c0-.526-.214-1.042-.586-1.414L17 11.586V8a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v3a1 1 0 0 0 1 1v3.586L5.586 13A2.01 2.01 0 0 0 5 14.414V16a1 1 0 0 0 1 1h5v3l1 2zM8 4h8v2H8V4zM7 14.414l1.707-1.707A.996.996 0 0 0 9 12V8h6v4c0 .266.105.52.293.707L17 14.414V15H7v-.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e264e6c046b1bf41(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.76 20.2a2.73 2.73 0 0 0 2.15.85 8.86 8.86 0 0 0 3.37-.86 9 9 0 0 0 12.27-10.9c1.31-2.23 1.75-4.26.67-5.48a2.94 2.94 0 0 0-2.57-1A5 5 0 0 0 16.1 4 9 9 0 0 0 3.58 15.14c-1.06 1.21-2.05 3.68-.82 5.06zm1.5-1.32c-.22-.25 0-1.07.37-1.76a9.26 9.26 0 0 0 1.57 1.74c-1.03.3-1.71.28-1.94.02zm14.51-5.17A7 7 0 0 1 15.58 18 7.12 7.12 0 0 1 12 19a6.44 6.44 0 0 1-1.24-.13 30.73 30.73 0 0 0 4.42-3.29 31.5 31.5 0 0 0 3.8-4 6.88 6.88 0 0 1-.21 2.13zm.09-8.89a.94.94 0 0 1 .87.32c.23.26.16.94-.26 1.93a9.2 9.2 0 0 0-1.61-1.86 2.48 2.48 0 0 1 1-.39zM5.22 10.31A6.94 6.94 0 0 1 8.41 6 7 7 0 0 1 12 5a6.9 6.9 0 0 1 6 3.41 5.19 5.19 0 0 1 .35.66 27.43 27.43 0 0 1-4.49 5A27.35 27.35 0 0 1 8.35 18a7 7 0 0 1-3.13-7.65z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$594eb123317aaa8c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 17 8-5-8-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7cb7bf01cf98523(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6v12l10-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bf254f4489e0fc55(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8h2v5c0 2.206 1.794 4 4 4h2v5h2v-5h2c2.206 0 4-1.794 4-4V8h2V6H3v2zm4 0h10v5c0 1.103-.897 2-2 2H9c-1.103 0-2-.897-2-2V8zm0-6h2v3H7zm8 0h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3155b70ded5a0a73(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$300e526b232de67e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cc863403bdd61165(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1bbb93005150f6d5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.01",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.01 22h2l.5-7h-3l.5 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 0-2.45 19.68l-.15-2.12a8 8 0 1 1 5.21 0l-.15 2.12A10 10 0 0 0 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.32 9.61a3.44 3.44 0 0 1 .37.68 3.83 3.83 0 0 1 .23.75 3.57 3.57 0 0 1 .09.8 3.66 3.66 0 0 1-.09.81 3.83 3.83 0 0 1-.23.75 3.44 3.44 0 0 1-.37.68 4.7 4.7 0 0 1-.35.43l-.19 2.62a5.33 5.33 0 0 0 .58-.31A5.86 5.86 0 0 0 17 15.2a5.57 5.57 0 0 0 .55-1 5.89 5.89 0 0 0 .35-1.13 6.06 6.06 0 0 0 .1-1.23 6.22 6.22 0 0 0-.13-1.21A6.09 6.09 0 0 0 17 8.49a6.29 6.29 0 0 0-.73-.89 5.67 5.67 0 0 0-.89-.73 6.3 6.3 0 0 0-1-.56A6.17 6.17 0 0 0 13.21 6a6.11 6.11 0 0 0-2.41 0 5.51 5.51 0 0 0-1.13.36 5.57 5.57 0 0 0-1 .55 5.67 5.67 0 0 0-.89.73 6.29 6.29 0 0 0-.78.85 6.09 6.09 0 0 0-.9 2.14 6.21 6.21 0 0 0-.1 1.21 6.06 6.06 0 0 0 .12 1.21 5.89 5.89 0 0 0 .35 1.13 5.57 5.57 0 0 0 .55 1 6.24 6.24 0 0 0 1.62 1.62 5.33 5.33 0 0 0 .58.31L9 14.51a4.7 4.7 0 0 1-.35-.43 3.44 3.44 0 0 1-.37-.68 3.83 3.83 0 0 1-.23-.75 3.65 3.65 0 0 1-.05-.81 3.56 3.56 0 0 1 .08-.8 3.83 3.83 0 0 1 .23-.75 3.44 3.44 0 0 1 .37-.68 4 4 0 0 1 .5-.61 3.87 3.87 0 0 1 .59-.48 3.44 3.44 0 0 1 .68-.37 3.86 3.86 0 0 1 .75-.24 4.36 4.36 0 0 1 1.61 0 3.86 3.86 0 0 1 .75.24 3.58 3.58 0 0 1 1.27.85 3.49 3.49 0 0 1 .49.61z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2ba4c37bc23ca3e4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.978 13.21a1 1 0 0 0-.396-1.024l-14-10a.999.999 0 0 0-1.575.931l2 17a1 1 0 0 0 1.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 0 0 .782-.769zm-8.674.31a1 1 0 0 0-.578.347l-3.008 3.677L7.257 5.127l10.283 7.345-5.236 1.048z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a66ae5001c559722(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h7v2H7zm0-4h10.97v2H7zm0 8h13v2H7zM4 4h2v16H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$395e14dfbb03735b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707l-5-5zM20 15.586 15.586 20H8.414L4 15.586V8.414L8.414 4h7.172L20 8.414v7.172z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2ba6ce455c50b5d4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2a7 7 0 0 0-4.94 2l-7.78 7.82a1 1 0 0 0 0 1.41l3.54 3.54-3.54 3.53 1.42 1.42 3.53-3.54 3.54 3.54a1 1 0 0 0 1.41 0L20 13.94A7 7 0 0 0 15 2zm3.54 10.54-7.07 7.06-2.82-2.83-1.42-1.42-2.83-2.83 7.07-7.07a5 5 0 0 1 7.08 7.08z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cb5aa41d76ef646e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.553 19.105.764 1.843C7.498 20.555 9.422 20 10 20c.838 0 1.462.208 2.184.448.775.259 1.654.552 2.816.552 1.177 0 3.078-.921 3.447-1.105l-.895-1.789c-.721.36-2.031.894-2.552.894-.838 0-1.462-.208-2.184-.448C12.041 18.293 11.162 18 10 18c-.229 0-.526.037-.857.099C9.702 16.95 10 15.561 10 14h3v-2H9.626c-.042-.107-.084-.216-.125-.317C9.243 11.052 9 10.455 9 9c0-1.369.521-3 3-3 2.224 0 3.021 2.227 3.052 2.316l1.896-.633C16.898 7.533 15.679 4 12 4 8.313 4 7 6.583 7 9c0 1.491.234 2.35.478 3H5v2h3c0 2.467-.892 4.328-2.447 5.105z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4c170728021c14ea(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21c4.411 0 8-3.589 8-8 0-3.35-2.072-6.221-5-7.411v2.223A6 6 0 0 1 18 13c0 3.309-2.691 6-6 6s-6-2.691-6-6a5.999 5.999 0 0 1 3-5.188V5.589C6.072 6.779 4 9.65 4 13c0 4.411 3.589 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v10h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$386247ce8bc03aa1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-1V2H6v5H5c-1.654 0-3 1.346-3 3v7c0 1.103.897 2 2 2h2v3h12v-3h2c1.103 0 2-.897 2-2v-7c0-1.654-1.346-3-3-3zM8 4h8v3H8V4zm8 16H8v-4h8v4zm4-3h-2v-3H6v3H4v-7c0-.551.449-1 1-1h14c.552 0 1 .449 1 1v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ade16f77595c8d0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.97 4.757a.999.999 0 0 0-1.918-.073l-3.186 9.554-2.952-6.644a1.002 1.002 0 0 0-1.843.034L5.323 12H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 14H22v-2h-3.22l-1.81-7.243z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1118291bad1786f9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.707 2.293A.997.997 0 0 0 11 2H6a.997.997 0 0 0-.707.293l-3 3A.996.996 0 0 0 2 6v5c0 .266.105.52.293.707l10 10a.997.997 0 0 0 1.414 0l8-8a.999.999 0 0 0 0-1.414l-10-10zM13 19.586l-9-9V6.414L6.414 4h4.172l9 9L13 19.586z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.353",
                    "cy": "8.353",
                    "r": "1.647"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4773a99ea177e617(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 3.293A.996.996 0 0 0 13 3H4a1 1 0 0 0-1 1v9c0 .266.105.52.293.707l8 8a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414l-8-8zM12 19.586l-7-7V5h7.586l7 7L12 19.586z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.496",
                    "cy": "8.495",
                    "r": "1.505"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a6dcc353b5a8bdd0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.445 21.832a1 1 0 0 0 1.11 0l9-6A.998.998 0 0 0 21.8 14.4l-9-12c-.377-.504-1.223-.504-1.6 0l-9 12a1 1 0 0 0 .245 1.432l9 6zM13 19.131V6l6.565 8.754L13 19.131zM11 6v13.131l-6.565-4.377L11 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e2d6943b73f05a7a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h4.01V2H2v6h2V4zm0 12H2v6h6.01v-2H4v-4zm16 4h-4v2h6v-6h-2v4zM16 4h4v4h2V2h-6v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h6V5H5zm2-4h2v2H7zM5 19h6v-6H5zm2-4h2v2H7zM19 5h-6v6h6zm-2 4h-2V7h2zm-3.99 4h2v2h-2zm2 2h2v2h-2zm2 2h2v2h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e9283c75dc5e4e85(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3zm2-6h4v4H5zM3 21h8v-8H3zm2-6h4v4H5zm8-12v8h8V3zm6 6h-4V5h4zm-5.99 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm4 0h2v2h-2zm2 2h2v2h-2zm-4 0h2v2h-2zm2-6h2v2h-2zm2 2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$39df4a309a666900(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C9.243 4 7 6.243 7 9h2c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.069-.454 1.465-1.481 2.255-.382.294-.813.626-1.226 1.038C10.981 13.604 10.995 14.897 11 15v2h2v-2.009c0-.024.023-.601.707-1.284.32-.32.682-.598 1.031-.867C15.798 12.024 17 11.1 17 9c0-2.757-2.243-5-5-5zm-1 14h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4afe814935377d7d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 18c-4.337 0-8-3.664-8-8 0-3.998 3.115-7.417 7-7.927V6.09C8.167 6.569 6 9.033 6 12c0 3.309 2.691 6 6 6 1.595 0 3.1-.626 4.237-1.763l-1.414-1.415A3.97 3.97 0 0 1 12 16c-2.206 0-4-1.794-4-4 0-1.858 1.279-3.411 3-3.858v2.146c-.59.353-1 .993-1 1.712 0 1.081.919 2 2 2s2-.919 2-2c0-.719-.41-1.359-1-1.712V4.073c3.885.51 7 3.929 7 7.927 0 4.336-3.663 8-8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$342ee65223c82bf3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.627 0-3 1.373-3 3s1.373 3 3 3 3-1.373 3-3-1.373-3-3-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a1907ec5749c5b53(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12c0 3.859 3.14 7 7 7 3.859 0 7-3.141 7-7s-3.141-7-7-7c-3.86 0-7 3.141-7 7zm12 0c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5 5 2.243 5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2526c9aea7fa2886(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.25 5.025-7.898-2.962-.703 1.873L14.484 5H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.018-.767-1.85-1.75-1.975zM4 19v-7h16v-2H4V7h16l.001 12H4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "15.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15h4.999v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$806d61becc30a3fc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-3V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6a1 1 0 0 0-1-1zM5 19a1 1 0 0 1-1-1V5h12v13c0 .351.061.688.171 1H5zm15-1a1 1 0 0 1-2 0v-5h2v5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h8v2H6zm0 4h8v2H6zm5 4h3v2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$33876bbbe1293e02(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h16l.001 14H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1826edb2fe7f6c7c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.224 15.543-.813-1.464-1.748.972.812 1.461c.048.085.082.173.104.264a1.024 1.024 0 0 1-.014.5.988.988 0 0 1-.104.235 1 1 0 0 1-.347.352.978.978 0 0 1-.513.137H14v-2l-4 3 4 3v-2h4.601c.278 0 .552-.037.811-.109a2.948 2.948 0 0 0 1.319-.776c.178-.179.332-.38.456-.593a2.992 2.992 0 0 0 .336-2.215 3.163 3.163 0 0 0-.299-.764zM5.862 11.039l-2.31 4.62a3.06 3.06 0 0 0-.261.755 2.997 2.997 0 0 0 .851 2.735c.178.174.376.326.595.453A3.022 3.022 0 0 0 6.236 20H8v-2H6.236a1.016 1.016 0 0 1-.5-.13.974.974 0 0 1-.353-.349 1 1 0 0 1-.149-.468.933.933 0 0 1 .018-.245c.018-.087.048-.173.089-.256l2.256-4.512 1.599.923L8.598 8 4 9.964l1.862 1.075zm12.736 1.925L19.196 8l-1.638.945-2.843-5.117a2.95 2.95 0 0 0-1.913-1.459 3.227 3.227 0 0 0-.772-.083 3.003 3.003 0 0 0-1.498.433A2.967 2.967 0 0 0 9.41 3.944l-.732 1.464 1.789.895.732-1.465c.045-.09.101-.171.166-.242a.933.933 0 0 1 .443-.27 1.053 1.053 0 0 1 .53-.011.963.963 0 0 1 .63.485l2.858 5.146L14 11l4.598 1.964z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7d957fdd21714893(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h3v-2H9c-1.654 0-3-1.346-3-3s1.346-3 3-3h6v3l5-4-5-4v3H9c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$945cc6c6e0655707(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21h12l-6-6-6 6zM18 3H6l6 6 6-6zM3 11h3v2H3zm5 0h3v2H8zm5 0h3v2h-3zm5 0h3v2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d2ba2b1e5743f9d3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 18 6-6-6-6v12zm12-6 6 6V6l-6 6zm-4-9h2v3h-2zm0 5h2v3h-2zm0 5h2v3h-2zm0 5h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$24fc855157ba932(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11H7.101l.001-.009a4.956 4.956 0 0 1 .752-1.787 5.054 5.054 0 0 1 2.2-1.811c.302-.128.617-.226.938-.291a5.078 5.078 0 0 1 2.018 0 4.978 4.978 0 0 1 2.525 1.361l1.416-1.412a7.036 7.036 0 0 0-2.224-1.501 6.921 6.921 0 0 0-1.315-.408 7.079 7.079 0 0 0-2.819 0 6.94 6.94 0 0 0-1.316.409 7.04 7.04 0 0 0-3.08 2.534 6.978 6.978 0 0 0-1.054 2.505c-.028.135-.043.273-.063.41H2l4 4 4-4zm4 2h2.899l-.001.008a4.976 4.976 0 0 1-2.103 3.138 4.943 4.943 0 0 1-1.787.752 5.073 5.073 0 0 1-2.017 0 4.956 4.956 0 0 1-1.787-.752 5.072 5.072 0 0 1-.74-.61L7.05 16.95a7.032 7.032 0 0 0 2.225 1.5c.424.18.867.317 1.315.408a7.07 7.07 0 0 0 2.818 0 7.031 7.031 0 0 0 4.395-2.945 6.974 6.974 0 0 0 1.053-2.503c.027-.135.043-.273.063-.41H22l-4-4-4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$293bdcbfab065b85(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.14 2a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.14 10a3 3 0 0 0-3-3h-5v10h2v-4h1.46l2.67 4h2.4l-2.75-4.12A3 3 0 0 0 16.14 10zm-3 1h-3V9h3a1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ba4010438f05598(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.005 5.995h-1v2h1v8h-1v2h1c1.103 0 2-.897 2-2v-8c0-1.102-.898-2-2-2zm-14 4H15v4H6.005z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.005 17.995V4H20V2h-8v2h3.005v1.995h-11c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11V20H12v2h8v-2h-2.995v-2.005zm-13-2v-8h11v8h-11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e03cc20a42fb21bf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-5v2h4v9H4V8h5v3l5-4-5-4v3H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6d06ec66a4e599db(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-8a1 1 0 0 0-1-1h-6V6l-5 4 5 4v-3h5v7h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12.4 6 10l3-2.4V6l-5 4 5 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eea9da3eaa602078(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11h6v7h2v-8a1 1 0 0 0-1-1h-7V6l-5 4 5 4v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dfbb5f024251df6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a1 1 0 0 0-1-1h-8v2h7v5h-3l3.969 5L22 13h-3V7zM5 17a1 1 0 0 0 1 1h8v-2H7v-5h3L6 6l-4 5h3v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$238a07ea7d262f7d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3-3 1.331-3 3 1.329 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219 9.053 9.053 0 0 0-2.43-2.43 8.95 8.95 0 0 0-3.219-1.355 9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053 7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725 7.11 7.11 0 0 1-.644 1.188 7.2 7.2 0 0 1-.858 1.039 7.028 7.028 0 0 1-3.536 1.907 7.13 7.13 0 0 1-2.822 0 6.961 6.961 0 0 1-2.503-1.054 7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034 9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183 9.014 9.014 0 0 0 3.218-1.355 8.886 8.886 0 0 0 1.331-1.099 9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fc272bf10a543b28(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h-2V3H8v7H6V3H4v8c0 1.654 1.346 3 3 3h1v7h2v-7h1c1.654 0 3-1.346 3-3V3h-2v7zm7-7h-1c-1.159 0-2 1.262-2 3v8h2v7h2V4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fefb0309919be4e4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 10.105a8.696 8.696 0 0 0-.789-1.456l-1.658 1.119a6.606 6.606 0 0 1 .987 2.345 6.659 6.659 0 0 1 0 2.648 6.495 6.495 0 0 1-.384 1.231 6.404 6.404 0 0 1-.603 1.112 6.654 6.654 0 0 1-1.776 1.775 6.606 6.606 0 0 1-2.343.987 6.734 6.734 0 0 1-2.646 0 6.55 6.55 0 0 1-3.317-1.788 6.605 6.605 0 0 1-1.408-2.088 6.613 6.613 0 0 1-.382-1.23 6.627 6.627 0 0 1 .382-3.877A6.551 6.551 0 0 1 7.36 8.797 6.628 6.628 0 0 1 9.446 7.39c.395-.167.81-.296 1.23-.382.107-.022.216-.032.324-.049V10l5-4-5-4v2.938a8.805 8.805 0 0 0-.725.111 8.512 8.512 0 0 0-3.063 1.29A8.566 8.566 0 0 0 4.11 16.77a8.535 8.535 0 0 0 1.835 2.724 8.614 8.614 0 0 0 2.721 1.833 8.55 8.55 0 0 0 5.061.499 8.576 8.576 0 0 0 6.162-5.056c.22-.52.389-1.061.5-1.608a8.643 8.643 0 0 0 0-3.45 8.684 8.684 0 0 0-.499-1.607z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1df2dfd388cab67a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16V8l-5 4zm6 0V8l-5 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7d243b4b55297b06(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12V7l-7 5 7 5zm7-5-7 5 7 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f6d8be57c118e136(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1v-8h-2v7H5V4h5V2H4a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11h2a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h2a9 9 0 0 0-9-9v2a7 7 0 0 1 7 7zM9.65 15.67a1 1 0 0 0-.14-.51.76.76 0 0 0-.38-.31 2.3 2.3 0 0 0-.75-.09H7V18h.65v-1.35h.14a1.31 1.31 0 0 1 .33 0 .58.58 0 0 1 .19.14 4.72 4.72 0 0 1 .35.48l.47.7h.78l-.39-.63a3.56 3.56 0 0 0-.38-.53 1.25 1.25 0 0 0-.35-.27 1 1 0 0 0 .64-.3.84.84 0 0 0 .22-.57zm-.74.33a.4.4 0 0 1-.18.14 2.36 2.36 0 0 1-.59 0h-.49v-.82h1a.4.4 0 0 1 .25.13.36.36 0 0 1 .09.26.43.43 0 0 1-.08.29zM10.92 16.62h1.36v-.54h-1.36v-.77h1.57v-.55h-2.22V18h.65v-1.38zM13.01 14.76h.65V18h-.65zM16.1 14.82a2.48 2.48 0 0 0-.62-.06h-1.2V18h1.24a1.76 1.76 0 0 0 .57-.07 1.07 1.07 0 0 0 .46-.26 1.35 1.35 0 0 0 .35-.57 2 2 0 0 0 .1-.69 2.35 2.35 0 0 0-.11-.76 1.33 1.33 0 0 0-.31-.53 1.09 1.09 0 0 0-.48-.3zm.16 2.18a.74.74 0 0 1-.17.31.57.57 0 0 1-.27.13 1.79 1.79 0 0 1-.39 0h-.49v-2.13h.29a3.06 3.06 0 0 1 .54 0 .71.71 0 0 1 .3.15.82.82 0 0 1 .19.32 2.05 2.05 0 0 1 .06.57 2.41 2.41 0 0 1-.06.65z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c923e5cccfcd8790(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b759f4dd4ff94b94(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 1.993c-5.514.001-10 4.487-10 10.001s4.486 10 10.001 10c5.513 0 9.999-4.486 10-10 0-5.514-4.486-10-10.001-10.001zM12 19.994c-4.412 0-8.001-3.589-8.001-8s3.589-8 8-8.001C16.411 3.994 20 7.583 20 11.994c-.001 4.411-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.994H8v2h4V16l4.005-4.005L12 7.991z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1ff7d9e68c086a28(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A.998.998 0 0 0 5 3v18a1 1 0 0 0 .536.886zM7 4.909 17.243 12 7 19.091V4.909z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$df5670c794633a52(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.007a9.928 9.928 0 0 0-7.071 2.922c-3.899 3.899-3.899 10.243 0 14.143A9.93 9.93 0 0 0 12 21.995a9.93 9.93 0 0 0 7.071-2.923c3.899-3.899 3.899-10.243 0-14.143A9.928 9.928 0 0 0 12 2.007zm5.657 15.65A7.946 7.946 0 0 1 12 19.994c-2.141 0-4.15-.83-5.657-2.337-3.119-3.119-3.119-8.195 0-11.314A7.944 7.944 0 0 1 12 4.007c2.141 0 4.15.829 5.657 2.336 3.119 3.119 3.119 8.195 0 11.314z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.661 8.247 8.247 9.661l3.214 3.214L9.336 15H15V9.337l-2.125 2.124z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$64c776e9392b0380(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h10v2H10zm-6 4h16v2H4zm6-8h10v2H10zm0-4h10v2H10zM4 3h16v2H4zm0 5v8l4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$726b2df47b67105e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.006 2.007a9.927 9.927 0 0 0-7.071 2.922c-3.898 3.899-3.898 10.243 0 14.142 1.885 1.885 4.396 2.923 7.071 2.923s5.187-1.038 7.071-2.923c3.898-3.898 3.898-10.242 0-14.142a9.928 9.928 0 0 0-7.071-2.922zm5.657 15.649c-1.507 1.507-3.517 2.337-5.657 2.337s-4.15-.83-5.657-2.337c-3.118-3.119-3.118-8.194 0-11.313 1.507-1.507 3.516-2.336 5.657-2.336s4.15.829 5.657 2.336c3.118 3.119 3.118 8.194 0 11.313z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.467 11.125-3.214 3.214 1.414 1.414 3.214-3.214 2.125 2.124V9H9.343z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a35f24233f293e95(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.92 2.38A15.72 15.72 0 0 0 17.5 2a8.26 8.26 0 0 0-6 2.06Q9.89 5.67 8.31 7.27c-1.21-.13-4.08-.2-6 1.74a1 1 0 0 0 0 1.41l11.3 11.32a1 1 0 0 0 1.41 0c1.95-2 1.89-4.82 1.77-6l3.21-3.2c3.19-3.19 1.74-9.18 1.68-9.43a1 1 0 0 0-.76-.73zm-2.36 8.75L15 14.67a1 1 0 0 0-.27.9 6.81 6.81 0 0 1-.54 3.94L4.52 9.82a6.67 6.67 0 0 1 4-.5A1 1 0 0 0 9.39 9s1.4-1.45 3.51-3.56A6.61 6.61 0 0 1 17.5 4a14.51 14.51 0 0 1 2.33.2c.24 1.43.62 5.04-1.27 6.93z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.73",
                    "cy": "8.3",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16c-2 1-2 5-2 5a7.81 7.81 0 0 0 5-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3439b2d9f80f5de5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.758 8.758 5.344 7.344a8.048 8.048 0 0 0-1.841 2.859l1.873.701a6.048 6.048 0 0 1 1.382-2.146zM19 12.999a7.935 7.935 0 0 0-2.344-5.655A7.917 7.917 0 0 0 12 5.069V2L7 6l5 4V7.089a5.944 5.944 0 0 1 3.242 1.669A5.956 5.956 0 0 1 17 13v.002c0 .33-.033.655-.086.977-.007.043-.011.088-.019.131a6.053 6.053 0 0 1-1.138 2.536c-.16.209-.331.412-.516.597a5.954 5.954 0 0 1-.728.613 5.906 5.906 0 0 1-2.277 1.015c-.142.03-.285.05-.43.069-.062.009-.122.021-.184.027a6.104 6.104 0 0 1-1.898-.103L9.3 20.819a8.087 8.087 0 0 0 2.534.136c.069-.007.138-.021.207-.03.205-.026.409-.056.61-.098l.053-.009-.001-.005a7.877 7.877 0 0 0 2.136-.795l.001.001.028-.019a7.906 7.906 0 0 0 1.01-.67c.27-.209.532-.43.777-.675.248-.247.47-.513.681-.785.021-.028.049-.053.07-.081l-.006-.004a7.899 7.899 0 0 0 1.093-1.997l.008.003c.029-.078.05-.158.076-.237.037-.11.075-.221.107-.333.04-.14.073-.281.105-.423.022-.099.048-.195.066-.295.032-.171.056-.344.076-.516.01-.076.023-.15.03-.227.023-.249.037-.5.037-.753.002-.002.002-.004.002-.008zM6.197 16.597l-1.6 1.201a8.045 8.045 0 0 0 2.569 2.225l.961-1.754a6.018 6.018 0 0 1-1.93-1.672zM5 13c0-.145.005-.287.015-.429l-1.994-.143a7.977 7.977 0 0 0 .483 3.372l1.873-.701A5.975 5.975 0 0 1 5 13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca59815cdf481717(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.242 17.242a6.04 6.04 0 0 1-1.37 1.027l.961 1.754a8.068 8.068 0 0 0 2.569-2.225l-1.6-1.201a5.938 5.938 0 0 1-.56.645zm1.743-4.671a5.975 5.975 0 0 1-.362 2.528l1.873.701a7.977 7.977 0 0 0 .483-3.371l-1.994.142zm1.512-2.368a8.048 8.048 0 0 0-1.841-2.859l-1.414 1.414a6.071 6.071 0 0 1 1.382 2.146l1.873-.701zm-8.128 8.763c-.047-.005-.094-.015-.141-.021a6.701 6.701 0 0 1-.468-.075 5.923 5.923 0 0 1-2.421-1.122 5.954 5.954 0 0 1-.583-.506 6.138 6.138 0 0 1-.516-.597 5.91 5.91 0 0 1-.891-1.634 6.086 6.086 0 0 1-.247-.902c-.008-.043-.012-.088-.019-.131A6.332 6.332 0 0 1 6 13.002V13c0-1.603.624-3.109 1.758-4.242A5.944 5.944 0 0 1 11 7.089V10l5-4-5-4v3.069a7.917 7.917 0 0 0-4.656 2.275A7.936 7.936 0 0 0 4 12.999v.009c0 .253.014.504.037.753.007.076.021.15.03.227.021.172.044.345.076.516.019.1.044.196.066.295.032.142.065.283.105.423.032.112.07.223.107.333.026.079.047.159.076.237l.008-.003A7.948 7.948 0 0 0 5.6 17.785l-.007.005c.021.028.049.053.07.081.211.272.433.538.681.785a8.236 8.236 0 0 0 .966.816c.265.192.537.372.821.529l.028.019.001-.001a7.877 7.877 0 0 0 2.136.795l-.001.005.053.009c.201.042.405.071.61.098.069.009.138.023.207.03a8.038 8.038 0 0 0 2.532-.137l-.424-1.955a6.11 6.11 0 0 1-1.904.102z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b11dd4c72355a9e5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20.001C19 11.729 12.271 5 4 5v2c7.168 0 13 5.832 13 13.001h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20.001h2C14 14.486 9.514 10 4 10v2c4.411 0 8 3.589 8 8.001z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$95540e4661149996(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h2v-3h6v-2h-6v-2h4.5c2.757 0 5-2.243 5-5s-2.243-5-5-5H9a1 1 0 0 0-1 1v7H5v2h3v2H5v2h3v3zm2-15h4.5c1.654 0 3 1.346 3 3s-1.346 3-3 3H10V6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e735de7293765210(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.875 7H3.125C1.953 7 1 7.897 1 9v6c0 1.103.953 2 2.125 2h17.75C22.047 17 23 16.103 23 15V9c0-1.103-.953-2-2.125-2zm0 8H3.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008l-.012-5.946c.007-.01.052-.046.137-.046H5v3h2V9h2v4h2V9h2v3h2V9h2v4h2V9h1.875c.079.001.122.028.125.008l.012 5.946c-.007.01-.052.046-.137.046z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c679b970b0e6ad1c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.777 10.969a2.007 2.007 0 0 0 2.148.83l3.316-.829-.483-1.94-3.316.829-1.379-2.067a2.01 2.01 0 0 0-1.272-.854l-3.846-.77a1.998 1.998 0 0 0-2.181 1.067l-1.658 3.316 1.789.895 1.658-3.317 1.967.394L7.434 17H3v2h4.434c.698 0 1.355-.372 1.715-.971l1.918-3.196 5.169 1.034 1.816 5.449 1.896-.633-1.815-5.448a2.007 2.007 0 0 0-1.506-1.33l-3.039-.607 1.772-2.954.417.625z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$51838bb4a8de4813(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6V4H6v2h3.5c1.302 0 2.401.838 2.815 2H6v2h6.315A2.994 2.994 0 0 1 9.5 12H6v2.414L11.586 20h2.828l-6-6H9.5a5.007 5.007 0 0 0 4.898-4H17V8h-2.602a4.933 4.933 0 0 0-.924-2H17z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8e1d979714c61cb4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d00af8be2c321b98(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V8a1 1 0 0 0-.29-.71l-4-4A1 1 0 0 0 16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm10-2H9v-5h6zM13 7h-2V5h2zM5 5h2v4h8V5h.59L19 8.41V19h-2v-5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v5H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$db535c5d3b9d9665(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v5h2V5h4V3H4a1 1 0 0 0-1 1zm18 5V4a1 1 0 0 0-1-1h-5v2h4v4h2zm-2 10h-4v2h5a1 1 0 0 0 1-1v-5h-2v4zM9 21v-2H5v-4H3v5a1 1 0 0 0 1 1h5zM2 11h20v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8fcfe9a8973a3444(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h17v-2H5V3H3v17a1 1 0 0 0 1 1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cdaeb3da1523c431(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h3v-2H5v-2H3v3a1 1 0 0 0 1 1zM19 4a1 1 0 0 0-1-1h-3v2h2v2h2V4zM5 5h2V3H4a1 1 0 0 0-1 1v3h2V5zM3 9h2v4H3zm14 0h2v3h-2zM9 3h4v2H9zm0 14h3v2H9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$647db1aa39782410(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.023 16.977a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.962 6.962 0 0 0 16 9c0-3.859-3.14-7-7-7S2 5.141 2 9s3.14 7 7 7c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604c-.379-.372-.885-.866-1.391-1.36zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$74644445c6794ba6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.412 8.586c.379.38.588.882.588 1.414h2a3.977 3.977 0 0 0-1.174-2.828c-1.514-1.512-4.139-1.512-5.652 0l1.412 1.416c.76-.758 2.07-.756 2.826-.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de460bd0a99f9df0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9e94ff6a559af6a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm8.933 3.519-1.726-1.726-1.414 1.414 3.274 3.274 5.702-6.84-1.538-1.282z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a417c6057ffd7c4d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H9V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v6H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1V9h1zm-3-4h2v2h-2V5zM5 5h2v2H5V5zm2 14H5v-2h2v2zm12 0h-2v-2h2v2zm-2-4h-1a1 1 0 0 0-1 1v1H9v-1a1 1 0 0 0-1-1H7V9h1a1 1 0 0 0 1-1V7h6v1a1 1 0 0 0 1 1h1v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e1acbfa47e400dd7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.426 11.095-17-8A.999.999 0 0 0 3.03 4.242L4.969 12 3.03 19.758a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81zM5.481 18.197l.839-3.357L12 12 6.32 9.16l-.839-3.357L18.651 12l-13.17 6.197z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b58474a48b44af7e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM4 9V5h16v4zm16 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM4 19v-4h16v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h2v2h-2zm-3 0h2v2h-2zm3 10h2v2h-2zm-3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eb468609c081cf11(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.494 9.05a8.14 8.14 0 0 0-4.544-4.544C14.713 3.088 13.485 2 12 2S9.287 3.088 9.05 4.506A8.136 8.136 0 0 0 4.506 9.05C3.088 9.287 2 10.515 2 12s1.088 2.713 2.506 2.95a8.14 8.14 0 0 0 4.544 4.544C9.287 20.912 10.515 22 12 22s2.713-1.088 2.95-2.506a8.14 8.14 0 0 0 4.544-4.544C20.912 14.713 22 13.485 22 12s-1.088-2.713-2.506-2.95zM12 4a1 1 0 0 1 1 1c0 .06-.023.11-.034.167a1.015 1.015 0 0 1-.083.279c-.014.027-.034.049-.051.075a1.062 1.062 0 0 1-.16.209c-.04.037-.09.062-.136.092-.054.036-.104.078-.165.103-.115.047-.239.075-.371.075s-.256-.028-.371-.075c-.061-.024-.111-.066-.165-.103-.046-.03-.096-.055-.136-.092a1.062 1.062 0 0 1-.16-.209c-.017-.026-.037-.048-.051-.075a1.026 1.026 0 0 1-.083-.279C11.023 5.11 11 5.06 11 5a1 1 0 0 1 1-1zm-7 7c.06 0 .11.023.167.034.099.017.194.041.279.083.027.014.049.034.075.051.075.047.149.097.209.16.037.04.062.09.092.136.036.054.078.104.103.165.047.115.075.239.075.371s-.028.256-.075.371c-.024.061-.066.111-.103.165-.03.046-.055.096-.092.136-.06.063-.134.113-.209.16-.026.017-.048.037-.075.051a1.026 1.026 0 0 1-.279.083C5.11 12.977 5.06 13 5 13a1 1 0 0 1 0-2zm7 9a1 1 0 0 1-1-1c0-.06.023-.11.034-.167.017-.099.041-.194.083-.279.014-.027.034-.049.051-.075.047-.075.097-.149.16-.209.04-.037.09-.062.136-.092.054-.036.104-.078.165-.103.115-.047.239-.075.371-.075s.256.028.371.075c.061.024.111.066.165.103.046.03.096.055.136.092.063.06.113.134.16.209.017.026.037.048.051.075.042.085.066.181.083.279.011.057.034.107.034.167a1 1 0 0 1-1 1zm2.583-2.512c-.006-.011-.017-.019-.022-.029a3.007 3.007 0 0 0-.996-1.007c-.054-.033-.109-.06-.166-.09a2.902 2.902 0 0 0-.486-.205c-.064-.021-.128-.044-.194-.061-.233-.057-.471-.096-.719-.096s-.486.039-.718.097c-.066.017-.13.039-.195.061a2.928 2.928 0 0 0-.485.205c-.056.029-.112.057-.166.09a3.007 3.007 0 0 0-.996 1.007c-.006.011-.017.019-.022.029a6.15 6.15 0 0 1-2.905-2.905c.011-.006.019-.017.029-.022a3.007 3.007 0 0 0 1.007-.996c.033-.054.061-.11.09-.166.083-.154.15-.316.205-.485.021-.065.044-.129.061-.195.056-.234.095-.472.095-.72s-.039-.486-.097-.718a2.568 2.568 0 0 0-.061-.194 2.902 2.902 0 0 0-.205-.486c-.03-.057-.057-.112-.09-.166A3.007 3.007 0 0 0 6.54 9.44c-.01-.006-.018-.017-.028-.023a6.15 6.15 0 0 1 2.905-2.905c.006.01.017.018.022.029.248.411.588.755.996 1.007.054.033.11.061.166.09.155.083.316.15.486.205.064.021.128.044.194.061.233.057.47.096.719.096a2.94 2.94 0 0 0 .912-.158c.17-.055.331-.122.486-.205.056-.029.112-.057.166-.09.408-.252.748-.596.996-1.007.006-.011.017-.019.022-.029a6.15 6.15 0 0 1 2.905 2.905c-.011.006-.019.017-.029.022a3.007 3.007 0 0 0-1.007.996c-.033.054-.061.11-.09.166-.083.155-.15.316-.205.486-.021.064-.044.128-.061.194A3.07 3.07 0 0 0 16 12a2.94 2.94 0 0 0 .158.912c.055.17.122.331.205.486.029.056.057.112.09.166.252.408.596.748 1.007.996.011.006.019.017.029.022a6.145 6.145 0 0 1-2.906 2.906zM19 13c-.06 0-.11-.023-.167-.034a1.015 1.015 0 0 1-.279-.083c-.027-.014-.049-.034-.075-.051a1.062 1.062 0 0 1-.209-.16c-.037-.04-.062-.09-.092-.136-.036-.054-.078-.104-.103-.165-.047-.115-.075-.239-.075-.371s.028-.256.075-.371c.024-.061.066-.111.103-.165.03-.046.055-.096.092-.136.06-.063.134-.113.209-.16.026-.017.048-.037.075-.051.085-.042.181-.066.279-.083.057-.011.107-.034.167-.034a1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$29a4ddbc89b3dcc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14.185v-2.369A2.997 2.997 0 0 0 22 9c0-1.654-1.346-3-3-3a2.99 2.99 0 0 0-2.116.876L12.969 5.31c.01-.103.031-.204.031-.31 0-1.654-1.346-3-3-3S7 3.346 7 5c0 .762.295 1.451.765 1.981L6.091 9.212A2.977 2.977 0 0 0 5 9c-1.654 0-3 1.346-3 3s1.346 3 3 3c.159 0 .313-.023.465-.047L7.4 17.532c-.248.436-.4.932-.4 1.468 0 1.654 1.346 3 3 3a2.994 2.994 0 0 0 2.863-2.153l3.962-.792A2.987 2.987 0 0 0 19 20c1.654 0 3-1.346 3-3a2.995 2.995 0 0 0-2-2.815zM19 8a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-9-4a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-6 8a1.001 1.001 0 1 1 1 1c-.552 0-1-.449-1-1zm6 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.761-2.172A3.005 3.005 0 0 0 10 16c-.386 0-.752.079-1.091.213l-1.674-2.231C7.705 13.451 8 12.762 8 12c0-.536-.152-1.032-.399-1.467l1.935-2.58c.152.024.305.047.464.047a2.99 2.99 0 0 0 2.116-.876l3.915 1.566c-.01.103-.031.204-.031.31 0 1.302.839 2.401 2 2.815v2.369a2.996 2.996 0 0 0-2 2.815c0 .061.015.117.018.177l-3.257.652zM19 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$96663b21b518e41c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6c0-1.654-1.346-3-3-3a2.993 2.993 0 0 0-2.815 2h-6.37A2.993 2.993 0 0 0 6 3C4.346 3 3 4.346 3 6c0 1.302.839 2.401 2 2.815v6.369A2.997 2.997 0 0 0 3 18c0 1.654 1.346 3 3 3a2.993 2.993 0 0 0 2.815-2h6.369a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3a2.997 2.997 0 0 0-2-2.816V8.816A2.996 2.996 0 0 0 21 6zm-3-1a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-2.815 12h-6.37A2.99 2.99 0 0 0 7 15.184V8.816A2.99 2.99 0 0 0 8.815 7h6.369A2.99 2.99 0 0 0 17 8.815v6.369A2.99 2.99 0 0 0 15.185 17zM6 5a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm0 14a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm12 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cf16ee5e9f9baa5b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15c-.183 0-.358.022-.532.054L8.946 6.532C8.978 6.359 9 6.182 9 6c0-1.654-1.346-3-3-3S3 4.346 3 6c0 1.302.839 2.401 2 2.815v6.369A2.997 2.997 0 0 0 3 18c0 1.654 1.346 3 3 3a2.993 2.993 0 0 0 2.815-2h6.369a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3S19.654 15 18 15zm-11 .184V8.816c.329-.118.629-.291.894-.508l7.799 7.799a2.961 2.961 0 0 0-.508.894h-6.37A2.99 2.99 0 0 0 7 15.184zM6 5a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm0 14a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm12 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$16824897133becdb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 15a3.51 3.51 0 0 0 2.36-.93l6.26 3.58a3.06 3.06 0 0 0-.12.85 3.53 3.53 0 1 0 1.14-2.57l-6.26-3.58a2.74 2.74 0 0 0 .12-.76l6.15-3.52A3.49 3.49 0 1 0 14 5.5a3.35 3.35 0 0 0 .12.85L8.43 9.6A3.5 3.5 0 1 0 5.5 15zm12 2a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm0-13A1.5 1.5 0 1 1 16 5.5 1.5 1.5 0 0 1 17.5 4zm-12 6A1.5 1.5 0 1 1 4 11.5 1.5 1.5 0 0 1 5.5 10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4a59dd5eb201bfaf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.05V4a1 1 0 0 0-1-1 1 1 0 0 0-.7.29l-7 7a1 1 0 0 0 0 1.42l7 7A1 1 0 0 0 11 18v-3.1h.85a10.89 10.89 0 0 1 8.36 3.72 1 1 0 0 0 1.11.35A1 1 0 0 0 22 18c0-9.12-8.08-10.68-11-10.95zm.85 5.83a14.74 14.74 0 0 0-2 .13A1 1 0 0 0 9 14v1.59L4.42 11 9 6.41V8a1 1 0 0 0 1 1c.91 0 8.11.2 9.67 6.43a13.07 13.07 0 0 0-7.82-2.55z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5de4452f4292849b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8v8h2V8c0-2.206-1.794-4-4-4H5v16h2V6h4c1.103 0 2 .897 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16c0 1.103-.897 2-2 2h-4V8H9v12h6c2.206 0 4-1.794 4-4V4h-2v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4c9b3fc843bfc305(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.438 5.089a1.002 1.002 0 0 0-.959.015c-.684.389-1.355.577-2.053.577-2.035 0-3.952-1.629-5.722-3.39-.375-.373-1.063-.373-1.438 0C9.592 3.959 7.598 5.663 5.51 5.663c-.69 0-1.351-.184-2.018-.561-.298-.166-.658-.171-.96-.012s-.501.461-.528.801c-.011.129-.944 12.872 9.683 16.041a.99.99 0 0 0 .286.042H12c.097 0 .192-.014.285-.041 10.657-3.17 9.695-15.916 9.684-16.044a1 1 0 0 0-.531-.8zm-9.452 14.842c-6.979-2.255-7.934-9.412-8.014-12.477.505.14 1.019.209 1.537.209 2.492 0 4.65-1.567 6.476-3.283 1.893 1.788 3.983 3.301 6.442 3.301.53 0 1.057-.074 1.575-.22-.074 3.065-1.021 10.217-8.016 12.47z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a40b8da5e8c33a32(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.342 8.447 1.105-.553A.998.998 0 0 0 21.8 6.4l-3-4A1 1 0 0 0 18 2H6a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 .352 1.494l1.105.553-1.131 2.262A5.052 5.052 0 0 0 2 12.944v.591a6.028 6.028 0 0 0 3.894 5.618l3.431 1.286a5.488 5.488 0 0 1 1.969 1.268.997.997 0 0 0 1.413 0 5.486 5.486 0 0 1 1.969-1.267l3.432-1.287A6.03 6.03 0 0 0 22 13.535v-.591c0-.771-.183-1.545-.527-2.236l-1.131-2.261zM20 13.535a4.019 4.019 0 0 1-2.596 3.745l-3.431 1.287a7.5 7.5 0 0 0-1.974 1.101 7.515 7.515 0 0 0-1.974-1.102L6.596 17.28A4.019 4.019 0 0 1 4 13.535v-.591c0-.463.109-.928.316-1.342l1.131-2.261a2.003 2.003 0 0 0-.895-2.684l-.033-.015L6.5 4h11l1.981 2.642-.034.017a2.004 2.004 0 0 0-.895 2.684l1.131 2.26c.208.414.317.878.317 1.341v.591z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bc8fdd54cef73b87(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.41 6.11-8-4a.94.94 0 0 0-.89 0l-8 4A1 1 0 0 0 3 6.9c0 .11-1 10.77 8.59 15a1 1 0 0 0 .41.1.93.93 0 0 0 .4-.09C21.92 17.67 21 7 21 6.9a1 1 0 0 0-.59-.79zM12 19.9C5.2 16.63 4.88 9.64 4.93 7.63l7-3.51 7 3.51c.13 2.01-.19 9-6.93 12.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6d0a8fb1d88cf0ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.63 21.91A.9.9 0 0 0 12 22a1 1 0 0 0 .41-.09C22 17.67 21 7 21 6.9a1 1 0 0 0-.55-.79l-8-4a1 1 0 0 0-.9 0l-8 4A1 1 0 0 0 3 6.9c0 .1-.92 10.77 8.63 15.01zM5 7.63l7-3.51 7 3.51c.05 2-.27 9-7 12.27C5.26 16.63 4.94 9.64 5 7.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.06 16h2v-3h3.01v-2h-3.01V8h-2v3h-3v2h3v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7ae3d9edea07dc89(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.9a.998.998 0 0 0-.548-.795l-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897V12H5.51a15.473 15.473 0 0 1-.544-4.365L12 4.118V12h6.46c-.759 2.74-2.498 5.979-6.46 7.897z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e79c1557c0937ad7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.48 6.105-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.99.99 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014a1.001 1.001 0 0 0-.548-.795zm-8.447 13.792C5.265 16.625 4.944 9.642 4.999 7.635l7.034-3.517 7.029 3.515c.038 1.989-.328 9.018-7.029 12.264z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.293 8.293 12 10.586 9.707 8.293 8.293 9.707 10.586 12l-2.293 2.293 1.414 1.414L12 13.414l2.293 2.293 1.414-1.414L13.414 12l2.293-2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2b627b11ece51322(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.903a.997.997 0 0 0-.547-.797l-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967zm-8.977 12.944c-6.86-4.01-7.14-10.352-7.063-12.205l7.071-3.523 6.998 3.511c.005 1.87-.481 8.243-7.006 12.217z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c334f2f4ea67e6c3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "15.5",
                    "rx": "3",
                    "ry": "2.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d586b0b68bee3997(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V9a1 1 0 0 0-1-1h-3V7c0-2.757-2.243-5-5-5S7 4.243 7 7v1H4a1 1 0 0 0-1 1v11c0 1.103.897 2 2 2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-4 3h2v2h2v-2h6v2h2v-2h2l.002 10H5V10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d39ac8210b2be2e7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c-1.095 0-2-.905-2-2 0-.354.103-.683.268-.973C12.178 9.02 12.092 9 12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-.092-.02-.178-.027-.268-.29.165-.619.268-.973.268z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$32390061daf1dfda(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$503629127d55026f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18.33A6.78 6.78 0 0 0 19.5 15a6.73 6.73 0 0 0-1.5 3.33 1.51 1.51 0 1 0 3 0zM11 20.33A6.78 6.78 0 0 0 9.5 17 6.73 6.73 0 0 0 8 20.33 1.59 1.59 0 0 0 9.5 22a1.59 1.59 0 0 0 1.5-1.67zM14.5 22a1.59 1.59 0 0 0 1.5-1.67A6.78 6.78 0 0 0 14.5 17a6.73 6.73 0 0 0-1.5 3.33A1.59 1.59 0 0 0 14.5 22zM3 18.33A1.59 1.59 0 0 0 4.5 20 1.59 1.59 0 0 0 6 18.33 6.78 6.78 0 0 0 4.5 15 6.73 6.73 0 0 0 3 18.33zM13 4.07V2h-2v2.07A8 8 0 0 0 4 12H2v2h20v-2h-2a8 8 0 0 0-7-7.93zM6 12a6 6 0 0 1 12 0z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9643475fbcf16e5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17h-1.559l-9.7-10.673A1 1 0 0 0 5.001 6H2v2h2.559l4.09 4.5-4.09 4.501H2v2h3.001a1 1 0 0 0 .74-.327L10 13.987l4.259 4.686a1 1 0 0 0 .74.327H17v3l5-4-5-4v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.441 8H17v3l5-3.938L17 3v3h-2.001a1 1 0 0 0-.74.327l-3.368 3.707 1.48 1.346L15.441 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$19a299c3b110faff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h6v12H4zm8 0V7h8V5l.002 14H12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10h2v2H6zm0 4h2v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5964071f6bb48b54(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$adbfad983e9566eb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$62d56c0523a2d546(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bb00f624f17053dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2zm4-3h2v14h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a1d355a80101a1ac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2zm4-3h2v14h-2zm4-3h2v17h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f873f2d7ee39544(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13.01h-7V10h1c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h1v3.01H4V18H3v4h4v-4H6v-2.99h5V18h-1v4h4v-4h-1v-2.99h5V18h-1v4h4v-4h-1v-4.99zM10 8V4h4l.002 4H10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a24b854f2d35f8f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 5-4-5-4zm5-4v4h2V8h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ce74a4f06615d671(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7v10l7-5zm9 10V7h-2v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bc3bd2c4b52bf4b1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16V8l-5 4zM9 8v8h2V8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f409824f84ad45c7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 7-7 5 7 5zm-7 5V7H7v10h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9b0ae21860676e1c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "15.5",
                    "rx": "3",
                    "ry": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7c-2.905 0-3.983 2.386-4 3.99l2 .021C8.002 10.804 8.076 9 10 9V7zm4 0v2c1.826 0 1.992 1.537 2 2.007L17 11h1c0-1.608-1.065-4-4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d2121f2c6c29c3b5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14.5c-1.58 0-2.903 1.06-3.337 2.5H2v2h2.163c.434 1.44 1.757 2.5 3.337 2.5s2.903-1.06 3.337-2.5H22v-2H10.837c-.434-1.44-1.757-2.5-3.337-2.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5S9 17.173 9 18s-.673 1.5-1.5 1.5zm9-11c-1.58 0-2.903 1.06-3.337 2.5H2v2h11.163c.434 1.44 1.757 2.5 3.337 2.5s2.903-1.06 3.337-2.5H22v-2h-2.163c-.434-1.44-1.757-2.5-3.337-2.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.837 5C12.403 3.56 11.08 2.5 9.5 2.5S6.597 3.56 6.163 5H2v2h4.163C6.597 8.44 7.92 9.5 9.5 9.5s2.903-1.06 3.337-2.5h9.288V5h-9.288zM9.5 7.5C8.673 7.5 8 6.827 8 6s.673-1.5 1.5-1.5S11 5.173 11 6s-.673 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$745f2d93f8ce40aa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5h9v2h-9zM2 7h7v2h2V3H9v2H2zm7 10h13v2H9zm10-6h3v2h-3zm-2 4V9.012h-2V11H2v2h13v2zM7 21v-6H5v2H2v2h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$531d845d2044fda2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 15V5h16l.001 10H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 13 5-3-5-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$76060a7353710733(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$acbc817f05087504(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM7 3.99H5v12H2l4 4 4-4H7zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1f99558b25e60db4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h2V8h3L8 4 4 8h3zm13-4h-3V4h-2v12h-3l4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fb06fe0fe9132ee(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 20 4-4H7V4H5v12H2zm5-12h9v2h-9zm0 4h7v2h-7zm0-8h11v2H11zm0 12h5v2h-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$19f92fa56c7ba1cf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h9v2h-9zm0 4h7v2h-7zm0-8h11v2H11zm0 12h5v2h-5zm-6 3h2V8h3L6 4 2 8h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9d627d7dda3bbad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM6 3.99l-4 4h3v12h2v-12h3zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ebeb37a948324da2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16H4l6 6V2H8zm6-11v17h2V8h4l-6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bb5799cbdabc3ea8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.787 9.023c-.125.027-1.803.418-3.953 1.774-.323-1.567-1.279-4.501-4.108-7.485L12 2.546l-.726.767C8.435 6.308 7.483 9.25 7.163 10.827 5.005 9.448 3.34 9.052 3.218 9.024L2 8.752V10c0 7.29 3.925 12 10 12 5.981 0 10-4.822 10-12V8.758l-1.213.265zM8.999 12.038c.002-.033.152-3.1 3.001-6.532C14.814 8.906 14.999 12 15 12v.125a18.933 18.933 0 0 0-3.01 3.154 19.877 19.877 0 0 0-2.991-3.113v-.128zM12 20c-5.316 0-7.549-4.196-7.937-8.564 1.655.718 4.616 2.426 7.107 6.123l.841 1.249.825-1.26c2.426-3.708 5.425-5.411 7.096-6.122C19.534 15.654 17.304 20 12 20z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$15dc7f8fe8622e7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13H7V9H5v6h14V9h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9903010ac355374b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 18H6V4h12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.01",
                    "cy": "7",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$243608fcc9167efd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.002 2h-4a1 1 0 0 0-1 1v3.812a5.998 5.998 0 0 0-3 5.188v.988L3 13l.002.072V21a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9a5.999 5.999 0 0 0-3-5.188V3a1 1 0 0 0-1-1zm-3 4V4h2v2h-2zm5.001 14h-8v-6h8v6zm-8.001-8c0-2.206 1.794-4 4-4s4 1.794 4 4h-8zm8.001-9h2v2h-2zM16 3h2v2h-2zm0 3h2v2h-2zm3-3h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$13261437e157baba(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$340991a50132b3b2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5zm3 15c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b19e6fe5e452e9bd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2028ea63395ba7a6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.516 14.323-1.49 6.452a.998.998 0 0 0 1.529 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082a1 1 0 0 0-.59-1.74l-5.701-.454-2.467-5.461a.998.998 0 0 0-1.822 0L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.214 4.107zm2.853-4.326a.998.998 0 0 0 .832-.586L12 5.43l1.799 3.981a.998.998 0 0 0 .832.586l3.972.315-3.271 2.944c-.284.256-.397.65-.293 1.018l1.253 4.385-3.736-2.491a.995.995 0 0 0-1.109 0l-3.904 2.603 1.05-4.546a1 1 0 0 0-.276-.94l-3.038-2.962 4.09-.326z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5a8430ecd1870ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.758 16.243 1.414-1.415a3.97 3.97 0 0 1-1.173-2.831c0-1.068.417-2.071 1.173-2.825L7.758 7.756a5.957 5.957 0 0 0-1.76 4.24c0 1.604.625 3.112 1.76 4.247zm8.484 0A5.96 5.96 0 0 0 18 12a5.96 5.96 0 0 0-1.758-4.243l-1.414 1.414C15.584 9.927 16 10.932 16 12s-.416 2.073-1.172 2.829l1.414 1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.344 17.657a7.953 7.953 0 0 1-2.345-5.659c0-2.137.833-4.145 2.345-5.654L4.93 4.929c-1.89 1.886-2.931 4.397-2.931 7.069s1.041 5.183 2.931 7.073l1.414-1.414zM17.657 6.343A7.948 7.948 0 0 1 20 12a7.948 7.948 0 0 1-2.343 5.657l1.414 1.414A9.932 9.932 0 0 0 22 12a9.934 9.934 0 0 0-2.929-7.071l-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1bdb9d77380b2451(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12a2 2 0 0 0-.703.133l-2.398-1.963c.059-.214.101-.436.101-.67C17 8.114 15.886 7 14.5 7S12 8.114 12 9.5c0 .396.1.765.262 1.097l-2.909 3.438A2.06 2.06 0 0 0 9 14c-.179 0-.348.03-.512.074l-2.563-2.563C5.97 11.348 6 11.179 6 11c0-1.108-.892-2-2-2s-2 .892-2 2 .892 2 2 2c.179 0 .348-.03.512-.074l2.563 2.563A1.906 1.906 0 0 0 7 16c0 1.108.892 2 2 2s2-.892 2-2c0-.237-.048-.46-.123-.671l2.913-3.442c.227.066.462.113.71.113a2.48 2.48 0 0 0 1.133-.281l2.399 1.963A2.077 2.077 0 0 0 18 14c0 1.108.892 2 2 2s2-.892 2-2-.892-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3bb1b4348a77b1df(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.796 9.982C20.849 5.357 16.729 2 12 2 6.486 2 2 6.486 2 12c0 4.729 3.357 8.849 7.982 9.796a.988.988 0 0 0 .908-.272l10.633-10.633c.238-.238.34-.578.273-.909zM11 18a7.93 7.93 0 0 1 1.365-4.471 8.18 8.18 0 0 1 .978-1.186 8.211 8.211 0 0 1 1.184-.977 8.128 8.128 0 0 1 1.36-.738c.481-.203.986-.36 1.501-.466a8.112 8.112 0 0 1 2.17-.134l-8.529 8.529c-.013-.185-.029-.37-.029-.557zm-7-6c0-4.411 3.589-8 8-8 2.909 0 5.528 1.589 6.929 4.005a9.99 9.99 0 0 0-1.943.198c-.643.132-1.274.328-1.879.583a10.15 10.15 0 0 0-1.699.923c-.533.361-1.03.771-1.479 1.22s-.858.945-1.221 1.48c-.359.533-.67 1.104-.922 1.698A10.013 10.013 0 0 0 9 18c0 .491.048.979.119 1.461C6.089 18.288 4 15.336 4 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3a8dd9ee1959d1da(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dacc89e8764f70ae(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v10H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f6ee8b7ba760c0a2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v5h-2zM9 2h6v2H9zm10.293 5.707-2-2 1.414-1.414 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f948c26f1bcfb643(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v2.831c0 1.053.382 2.01 1 2.746V19c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8.424c.618-.735 1-1.692 1-2.746V5zm-2 0v2.831c0 1.14-.849 2.112-1.891 2.167L18 10c-1.103 0-2-.897-2-2V4h3c.552 0 1 .449 1 1zM10 4h4v4c0 1.103-.897 2-2 2s-2-.897-2-2V4zM4 5c0-.551.448-1 1-1h3v4c0 1.103-.897 2-2 2l-.109-.003C4.849 9.943 4 8.971 4 7.831V5zm6 14v-3h4v3h-4zm6 0v-3c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v3H5v-7.131c.254.067.517.111.787.125A3.988 3.988 0 0 0 9 10.643c.733.832 1.807 1.357 3 1.357s2.267-.525 3-1.357a3.988 3.988 0 0 0 3.213 1.351c.271-.014.533-.058.787-.125V19h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$29eb57ef2810e51a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.148 2.971A2.008 2.008 0 0 0 17.434 2H6.566c-.698 0-1.355.372-1.714.971L2.143 7.485A.995.995 0 0 0 2 8a3.97 3.97 0 0 0 1 2.618V19c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8.382A3.97 3.97 0 0 0 22 8a.995.995 0 0 0-.143-.515l-2.709-4.514zm.836 5.28A2.003 2.003 0 0 1 18 10c-1.103 0-2-.897-2-2 0-.068-.025-.128-.039-.192l.02-.004L15.22 4h2.214l2.55 4.251zM10.819 4h2.361l.813 4.065C13.958 9.137 13.08 10 12 10s-1.958-.863-1.993-1.935L10.819 4zM6.566 4H8.78l-.76 3.804.02.004C8.025 7.872 8 7.932 8 8c0 1.103-.897 2-2 2a2.003 2.003 0 0 1-1.984-1.749L6.566 4zM10 19v-3h4v3h-4zm6 0v-3c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v3H5v-7.142c.321.083.652.142 1 .142a3.99 3.99 0 0 0 3-1.357c.733.832 1.807 1.357 3 1.357s2.267-.525 3-1.357A3.99 3.99 0 0 0 18 12c.348 0 .679-.059 1-.142V19h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$891aa577fa75bac4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h2v-5h2V9c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v4h2v5h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18.446 11.386-.893 1.789C19.108 13.95 20 14.98 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.02.892-2.05 2.446-2.825l-.893-1.789C3.295 12.512 2 14.193 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-1.807-1.295-3.488-3.554-4.614z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7b299a4b0ab8664a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11h-8c-4 0-4-1.816-4-2.5C8 7.882 8 6 12 6c2.8 0 2.99 1.678 3 2.014L16 8h1c0-1.384-1.045-4-5-4-5.416 0-6 3.147-6 4.5 0 .728.148 1.667.736 2.5H4v2h16v-2zm-8 7c-3.793 0-3.99-1.815-4-2H6c0 .04.069 4 6 4 5.221 0 6-2.819 6-4.5 0-.146-.009-.317-.028-.5h-2.006c.032.2.034.376.034.5 0 .684 0 2.5-4 2.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5503c788234b39d2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h-6v-3l-5 4 5 4v-3h7a1 1 0 0 0 1-1V5h-2v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a12ae5fedddb16e0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13H8V5H6v9a1 1 0 0 0 1 1h7v3l5-4-5-4v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$10c399988deb760(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3zM4.219 18.363l2.12-2.122 1.415 1.414-2.12 2.122zM16.24 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.342 7.759 4.22 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c2e948ac351d93a6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aadc343f7bc3fb2a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.51 2 4 4.2 4 7v10c0 2.8 3.51 5 8 5s8-2.2 8-5V7c0-2.8-3.51-5-8-5zm0 18c-3.54 0-6-1.58-6-3v-6.67A10.52 10.52 0 0 0 12 12a10.52 10.52 0 0 0 6-1.67V17c0 1.42-2.46 3-6 3zm0-10c-3.54 0-6-1.58-6-3s2.46-3 6-3 6 1.58 6 3-2.46 3-6 3z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "rx": "3",
                    "ry": "1.71"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$680350ca70c8c6b0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.003",
                    "cy": "6.002",
                    "r": "2.002"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.875 13.219c-.567.453-.978.781-1.878.781-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.445.676-3.124 1.219-.588.47-.975.781-1.875.781-.898 0-1.286-.311-1.873-.78C4.443 12.676 3.6 12 2 12v2c.897 0 1.285.311 1.872.78.679.544 1.523 1.22 3.123 1.22s2.446-.676 3.125-1.22c.587-.47.976-.78 1.874-.78.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219 1.602 0 2.447-.676 3.127-1.219.588-.47.977-.781 1.876-.781v-2c-1.601 0-2.446.676-3.125 1.219zM16.997 19c-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.445.676-3.124 1.219-.588.47-.975.781-1.875.781-.898 0-1.286-.311-1.873-.78C4.443 17.676 3.6 17 2 17v2c.897 0 1.285.311 1.872.78.679.544 1.523 1.22 3.123 1.22s2.446-.676 3.125-1.22c.587-.47.976-.78 1.874-.78.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219 1.602 0 2.447-.676 3.127-1.219.588-.47.977-.781 1.876-.781v-2c-1.601 0-2.446.676-3.125 1.219-.567.453-.978.781-1.878.781zM11 5.419l2.104 2.104-2.057 2.57c.286-.056.596-.093.947-.093 1.602 0 2.447.676 3.127 1.219.588.47.977.781 1.876.781.9 0 1.311-.328 1.878-.781.132-.105.274-.217.423-.326l-2.096-2.09.005-.005-5.5-5.5a.999.999 0 0 0-1.414 0l-4 4 1.414 1.414L11 5.419z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$48a47d2622327849(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 7.101.01.001a4.978 4.978 0 0 1 2.526 1.362 5.005 5.005 0 0 1 1.363 2.528 5.061 5.061 0 0 1-.001 2.016 4.976 4.976 0 0 1-1.363 2.527l1.414 1.414a7.014 7.014 0 0 0 1.908-3.54 6.98 6.98 0 0 0 0-2.819 6.957 6.957 0 0 0-1.907-3.539 6.97 6.97 0 0 0-2.223-1.5 6.921 6.921 0 0 0-1.315-.408c-.137-.028-.275-.043-.412-.063V2L9 6l4 4V7.101zm-7.45 7.623c.174.412.392.812.646 1.19.249.37.537.718.854 1.034a7.036 7.036 0 0 0 2.224 1.501c.425.18.868.317 1.315.408.167.034.338.056.508.078v2.944l4-4-4-4v3.03c-.035-.006-.072-.003-.107-.011a4.978 4.978 0 0 1-2.526-1.362 4.994 4.994 0 0 1 .001-7.071L7.051 7.05a7.01 7.01 0 0 0-1.5 2.224A6.974 6.974 0 0 0 5 12a6.997 6.997 0 0 0 .55 2.724z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4baed15c81a1ab19(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H6zm0 15V5h12l.002 12H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$80cb83897a825dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h15.893c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2v-5h4v5H4zM14 7v5h-4V7h4zM8 7v5H4V7h4zm2 12v-5h4v5h-4zm6 0v-5h3.894v5H16zm3.893-7H16V7h3.893v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$26ccdc53d3f039fa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0 0 22 14c0-5.514-4.486-10-10-10zm7.41 13H4.59A7.875 7.875 0 0 1 4 14c0-4.411 3.589-8 8-8s8 3.589 8 8a7.875 7.875 0 0 1-.59 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.939 12.939a1.53 1.53 0 0 0 0 2.561 1.53 1.53 0 0 0 2.121-.44l3.962-6.038a.034.034 0 0 0 0-.035.033.033 0 0 0-.045-.01l-6.038 3.962z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$735b51d1d591c050(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.868 4.504A1 1 0 0 0 17 4H3a1 1 0 0 0-.868 1.496L5.849 12l-3.717 6.504A1 1 0 0 0 3 20h14a1 1 0 0 0 .868-.504l4-7a.998.998 0 0 0 0-.992l-4-7zM16.42 18H4.724l3.145-5.504a.998.998 0 0 0 0-.992L4.724 6H16.42l3.429 6-3.429 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bae3b9e13086b7f0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H8.515a2 2 0 0 0-1.627.838l-4.701 6.581a.997.997 0 0 0 0 1.162l4.701 6.581A2 2 0 0 0 8.515 20H20c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 14H8.515l-4.286-6 4.286-6H20v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$db425eb5cf68fb47(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.069V2h-2v2.069A8.008 8.008 0 0 0 4.069 11H2v2h2.069A8.007 8.007 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b8f7a52170f66dc4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15zM5 5h2v2h10V5h2v15H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.292 10.295 12 12.587l-2.292-2.292-1.414 1.414 2.292 2.292-2.292 2.292 1.414 1.414L12 15.415l2.292 2.292 1.414-1.414-2.292-2.292 2.292-2.292z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$845f23214ce45c6a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15c0 1.103.897 2 2 2zM5 5h2v2h10V5h2v15H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 13.586-1.793-1.793-1.414 1.414L11 16.414l5.207-5.207-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b5593507b3ccb10c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.156-1.368-4.105A2.995 2.995 0 0 0 16.559 4H14V2h-4v2H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.105A2.003 2.003 0 0 0 2 12v5c0 .753.423 1.402 1.039 1.743-.013.066-.039.126-.039.195V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0 0 22 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6ddf19589fa1d209(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.081c1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.243 0-14.143C17.177 3.044 14.665 2 12 2S6.823 3.044 4.929 4.938c-3.899 3.899-3.899 10.244 0 14.143zm12.728-1.414a7.969 7.969 0 0 1-3.813 2.129c-.009-1.602.586-3.146 1.691-4.251 1.163-1.163 2.732-1.828 4.277-1.851a7.945 7.945 0 0 1-2.155 3.973zm2.325-5.965c-2.124-.021-4.284.853-5.861 2.429-1.532 1.532-2.327 3.68-2.263 5.881a7.946 7.946 0 0 1-5.516-2.345 7.97 7.97 0 0 1-2.332-5.512c.077.002.154.014.231.014 2.115 0 4.16-.804 5.637-2.28 1.58-1.58 2.457-3.739 2.43-5.873a7.948 7.948 0 0 1 5.349 2.337 7.96 7.96 0 0 1 2.325 5.349zM6.343 6.353a7.968 7.968 0 0 1 3.973-2.169c-.018 1.555-.685 3.124-1.851 4.291-1.104 1.103-2.642 1.696-4.238 1.691a7.929 7.929 0 0 1 2.116-3.813z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2ff116499b8a616d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h6v2h-6zM6.293 9.707 8.586 12l-2.293 2.293 1.414 1.414L11.414 12 7.707 8.293z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9f1eefcf4f969428(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.293 2.707.818.818L3.318 14.318C2.468 15.168 2 16.298 2 17.5s.468 2.332 1.318 3.183C4.169 21.532 5.299 22 6.5 22s2.331-.468 3.182-1.318L20.475 9.889l.818.818 1.414-1.414-8-8-1.414 1.414zm3.182 8.354-2.403-2.404-1.414 1.414 2.403 2.404-1.414 1.415-.99-.99-1.414 1.414.99.99-1.415 1.415-2.403-2.404L7 15.728l2.403 2.404-1.136 1.136c-.945.944-2.59.944-3.535 0C4.26 18.795 4 18.168 4 17.5s.26-1.295.732-1.768L15.525 4.939l3.535 3.535-2.585 2.587z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d313ea232ddf78ef(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8h2V6h3.252L7.68 18H5v2h8v-2h-2.252L13.32 6H17v2h2V4H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8c20aa0dcdf32ee8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8c9c69ba44cabede(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v6h6v-2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2c5deb91d54f44aa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.145 8.27 1.563-1.563-1.414-1.414L18.586 7c-1.05-.63-2.274-1-3.586-1-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7a6.966 6.966 0 0 0-1.855-4.73zM15 18c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h2v4h-2zm-1-7h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6de61432823885f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.555 8.832-1.109-1.664-3 2a1.001 1.001 0 0 0 .108 1.727l4 2 .895-1.789-2.459-1.229 1.565-1.045zm-6.557 1.23a1 1 0 0 0-.443-.894l-3-2-1.11 1.664 1.566 1.044-2.459 1.229.895 1.789 4-2a.998.998 0 0 0 .551-.832z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$934e011a7050eb0d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9c-1.628 0-3 1.372-3 3s1.372 3 3 3 3-1.372 3-3-1.372-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.3 0-5.989 2.689-6 6v.016A6.01 6.01 0 0 0 8 18h8a6.01 6.01 0 0 0 6-5.994V12c-.009-3.309-2.699-6-6-6zm0 10H8a4.006 4.006 0 0 1-4-3.99C4.004 9.799 5.798 8 8 8h8c2.202 0 3.996 1.799 4 4.006A4.007 4.007 0 0 1 16 16zm4-3.984.443-.004.557.004h-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ef26b00be459d6c9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9c-1.628 0-3 1.372-3 3s1.372 3 3 3 3-1.372 3-3-1.372-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8c3.309 0 6-2.691 6-6s-2.691-6-6-6zm0 10H8a4.006 4.006 0 0 1-4-3.99C4.004 9.799 5.798 8 8 8h8c2.206 0 4 1.794 4 4s-1.794 4-4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$433354ff407f4162(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 9H4.069a7.965 7.965 0 0 1 .52-2H11v2zm0 4H4.589a7.965 7.965 0 0 1-.52-2H11v2zm0-10.931V7H5.765A7.996 7.996 0 0 1 11 4.069zM5.765 17H11v2.931A7.996 7.996 0 0 1 5.765 17zM13 19.931V4.069c3.939.495 7 3.858 7 7.931s-3.061 7.436-7 7.931z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fdc6775b6cb2fc46(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.943 2.667A1 1 0 0 0 13 2h-2a1 1 0 0 0-.943.667L4.292 19H2v2h20v-2h-2.292L13.943 2.667zM15.47 13H8.53l1.06-3h4.82l1.06 3zm-3.763-9h.586l1.412 4h-3.41l1.412-4zM7.825 15h8.35l1.412 4H6.413l1.412-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$71251cfb1df05dce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.87 3.34A3.55 3.55 0 0 0 16.38 2H7.62a3.47 3.47 0 0 0-2.5 1.35A4.32 4.32 0 0 0 4 6v12a1 1 0 0 0 1 1h2l-2 3h2.32L8 21h8l.68 1H19l-2-3h2a1 1 0 0 0 1-1V6a4.15 4.15 0 0 0-1.13-2.66zM7.62 4h8.72a1.77 1.77 0 0 1 1 .66 3.25 3.25 0 0 1 .25.34H6.39a2.3 2.3 0 0 1 .25-.35A1.65 1.65 0 0 1 7.62 4zM6 8V7h12v3H6zm12 9H6v-5h12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1bf85f78d605768d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.924 10.383a1 1 0 0 0-.217-1.09l-5-5-1.414 1.414L16.586 9H4v2h15a1 1 0 0 0 .924-.617zM4.076 13.617a1 1 0 0 0 .217 1.09l5 5 1.414-1.414L7.414 15H20v-2H5a.999.999 0 0 0-.924.617z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f1f3282d6f250ed9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 12 5-4-5-4v2.999H2v2h13zm7 3H9v-3l-5 4 5 4v-3h13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a43769d5a8d07f32(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H9c-1.103 0-2 .897-2 2v2H3v2h2v12c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V8h2V6h-4V4c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm8 16H7V8h10v12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b97656dc3dae9e6b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h2v8H9zm4 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fda418c3ef4b6f55(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.586-4 4-6.293-6.293-1.414 1.414L10 16.414l4-4 4.293 4.293L16 19h6v-6l-2.293 2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c591ef0fc1e0a1e6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 10.414 4 4 5.707-5.707L22 11V5h-6l2.293 2.293L14 11.586l-4-4-7.707 7.707 1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5e93217e2d03a0c5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm14-6-.003 9H10v-3h4c1.103 0 2-.897 2-2v-4h3zM5 10h5V5h4l-.003 9H5v-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$48b87caa8d97c2e7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14c-1.654 0-3 1.346-3 3 0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$128e9d80b07c1d5f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3c0 4.31 1.799 6.91 4.819 7.012A6.001 6.001 0 0 0 11 17.91V20H9v2h6v-2h-2v-2.09a6.01 6.01 0 0 0 4.181-2.898C20.201 14.91 22 12.31 22 8V5a1 1 0 0 0-1-1zM4 8V6h2v6.83C4.216 12.078 4 9.299 4 8zm8 8c-2.206 0-4-1.794-4-4V4h8v8c0 2.206-1.794 4-4 4zm6-3.17V6h2v2c0 1.299-.216 4.078-2 4.83z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3da7d5744809c4f9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-5.586l2.293-2.293-1.414-1.414L12 5.586 8.707 2.293 7.293 3.707 9.586 6H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM4 19V8h16l.002 11H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$58bda85e47a4b359(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v2H5zM6 4v6c0 3.309 2.691 6 6 6s6-2.691 6-6V4h-2v6c0 2.206-1.794 4-4 4s-4-1.794-4-4V4H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$60ac947adc77f78(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6c1.654 0 3 1.346 3 3s-1.346 3-3 3h-3v2h3c2.757 0 5-2.243 5-5s-2.243-5-5-5H9V5L4 9l5 4v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1e416f8a6be2bf4c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h1V8a2 2 0 0 1 2-2h8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2zm3 3a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1v8a2 2 0 0 1-2 2H8v1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b9ea69c8cc14eebb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 10.5 16 9l-3 1h-2L8 9l-.5 1.5 3 1V13L9 17.25l1.5.75 1.25-3.5h.5L13.5 18l1.5-.75L13.5 13v-1.5l3-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$403faa1d9a4da6ee(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.949 14.121 19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0l-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121a2.723 2.723 0 0 1-.844.57L13.414 12l1.414-1.414-.707-.707a4.965 4.965 0 0 0-3.535-1.465c-.235 0-.464.032-.691.066L3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.536-5.536c.277-.184.538-.396.778-.636zm-6.363 3.536a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l1.476-1.475-1.414-1.414L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f4dc7568de46c9ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.414V18h2V8.414l4.293 4.293 1.414-1.414L12 4.586l-6.707 6.707 1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8c658c63ab608e37(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 1.993C6.486 1.994 2 6.48 2 11.994c.001 5.514 4.487 10 10 10 5.515 0 10.001-4.486 10.001-10s-4.486-10-10-10.001zM12 19.994c-4.41 0-7.999-3.589-8-8 0-4.411 3.589-8 8.001-8.001 4.411.001 8 3.59 8 8.001s-3.589 8-8.001 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.001 8.001-4.005 4.005h3.005V16h2v-3.994h3.004z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cba6b01fcd883c6d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19zm9-12.243L19.092 17H4.908L12 6.757z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8979f448dd145c66(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2V9h3l-4-5-4 5h3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e5a6139bf977f343(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.829 9.172c.181.181.346.38.488.592l1.658-1.119a6.063 6.063 0 0 0-1.621-1.62 5.963 5.963 0 0 0-2.148-.903 5.985 5.985 0 0 0-5.448 1.634 5.993 5.993 0 0 0-.733.889l1.657 1.119a4.017 4.017 0 0 1 2.51-1.683 3.989 3.989 0 0 1 3.637 1.091z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.507",
                    "cy": "13.507",
                    "r": "1.493"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e6115151b9b6e0b8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.781 2.375c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10zM15 12h-1v8h-4v-8H6.081L12 4.601 17.919 12H15z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2634576f4386fe0a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h1v2h-4V6h2l-3-4-3 4h2v8H7v-2.277c.596-.347 1-.985 1-1.723a2 2 0 0 0-4 0c0 .738.404 1.376 1 1.723V14c0 1.103.897 2 2 2h4v2.277A1.99 1.99 0 0 0 10 20a2 2 0 0 0 4 0c0-.738-.404-1.376-1-1.723V14h4c1.103 0 2-.897 2-2v-2h1V6h-4v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$53c5f3d3a6e20db(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.29 8.29 16 12.58l-1.3-1.29-1.41 1.42 2.7 2.7 5.72-5.7zM4 8a3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4zm6 0a1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$52f156f8b895e1c4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2A10.13 10.13 0 0 0 2 12a10 10 0 0 0 4 7.92V20h.1a9.7 9.7 0 0 0 11.8 0h.1v-.08A10 10 0 0 0 22 12 10.13 10.13 0 0 0 12 2zM8.07 18.93A3 3 0 0 1 11 16.57h2a3 3 0 0 1 2.93 2.36 7.75 7.75 0 0 1-7.86 0zm9.54-1.29A5 5 0 0 0 13 14.57h-2a5 5 0 0 0-4.61 3.07A8 8 0 0 1 4 12a8.1 8.1 0 0 1 8-8 8.1 8.1 0 0 1 8 8 8 8 0 0 1-2.39 5.64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4zm0 6a1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$56a22c883a2fe74a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11h8v2h-8zM8 4a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4zm0 6a1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2zm-4 8a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dc4442b6cd0ac36a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c1.151 0 2-.848 2-2s-.849-2-2-2c-1.15 0-2 .848-2 2s.85 2 2 2zm0 1c-2.209 0-4 1.612-4 3.6v.386h8V14.6c0-1.988-1.791-3.6-4-3.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h4l3 3 3-3h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-5 15-2 2-2-2H5V4h14l.002 13H14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9c0f76e7bcd6986d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 8a3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4zm6 0a1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$64b6df923cf1e43f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12c2.28 0 4-1.72 4-4s-1.72-4-4-4-4 1.72-4 4 1.72 4 4 4zm0-6c1.178 0 2 .822 2 2s-.822 2-2 2-2-.822-2-2 .822-2 2-2zm1 7H7c-2.757 0-5 2.243-5 5v1h2v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h2v-1c0-2.757-2.243-5-5-5zm9.364-10.364L16.95 4.05C18.271 5.373 19 7.131 19 9s-.729 3.627-2.05 4.95l1.414 1.414C20.064 13.663 21 11.403 21 9s-.936-4.663-2.636-6.364z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 5.464 14.121 6.88C14.688 7.445 15 8.198 15 9s-.312 1.555-.879 2.12l1.414 1.416C16.479 11.592 17 10.337 17 9s-.521-2.592-1.465-3.536z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ec6685360400ec2a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.71 15.71 2.29-2.3 2.29 2.3 1.42-1.42-2.3-2.29 2.3-2.29-1.42-1.42-2.29 2.3-2.29-2.3-1.42 1.42L16.58 12l-2.29 2.29zM12 8a3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4zM6 8a1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f0c4132e8380b405(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dcd181671fe08e9a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.277 8c.347.596.985 1 1.723 1a2 2 0 0 0 0-4c-.738 0-1.376.404-1.723 1H16V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H5.723C5.376 5.404 4.738 5 4 5a2 2 0 0 0 0 4c.738 0 1.376-.404 1.723-1H8v.369C5.133 9.84 4.318 12.534 4.091 14H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.984.984 0 0 0 9 11h6a.98.98 0 0 0 .792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277zM6 18H4v-2h2v2zm14 0h-2v-2h2v2zm-6-9h-4V5h4v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$29c758681b0a45ba(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19h3v2h-3zM13 19h3v2h-3zM8 19h3v2H8zM3 19h3v2H3zM13 5h-2v8H8l4 4 4-4h-3V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d2a7663db20fceee(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5V2h-2v3H8l4 4 4-4zm0 17v-3h3l-4-4-4 4h3v3zM3 11h3v2H3zm5 0h3v2H8zm5 0h3v2h-3zm5 0h3v2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cb955b991e484fc5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 7-4 4h3v8h2v-8h3l-4-4zM3 3h3v2H3zM8 3h3v2H8zM13 3h3v2h-3zM18 3h3v2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$49672822fb6e4822(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.95 3.564.708.707-9.193 9.193C2.521 14.408 2 15.664 2 17s.521 2.592 1.465 3.535C4.408 21.479 5.664 22 7 22s2.592-.521 3.535-1.465l9.193-9.193.707.708 1.414-1.414-8.485-8.486-1.414 1.414zM9.121 19.121c-1.133 1.133-3.109 1.133-4.242 0C4.313 18.555 4 17.802 4 17s.313-1.555.879-2.121L5.758 14h8.484l-5.121 5.121zM16.242 12H7.758l6.314-6.314 4.242 4.242L16.242 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$22b39038e5ed8884(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7zm-2 7.586L8.414 7H16v7.586zM4 19h10.879l-2-2H4V8.121L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$90c1099fd61abd3e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8H9v3H6v2h3v3h2v-3h3v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.999 10H4V7h12v5l.001 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$18fa20d6a7327504(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9c0-1.103-.897-2-2-2h-1.434l-2.418-4.029A2.008 2.008 0 0 0 10.434 2H5v2h5.434l1.8 3H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3l4 2v-7l-4 2V9zm-1.998 9H4V9h12l.001 4H16v1l.001.001.001 3.999z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h6v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cb513ea8a0448d64(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.998 10H4V7h12l.001 4.999L16 12l.001.001.001 4.999z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7c89fda785245a2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 8a4.505 4.505 0 0 0-4.5 4.5c0 .925.281 1.784.762 2.5h-3.523c.48-.716.761-1.575.761-2.5C11 10.019 8.981 8 6.5 8S2 10.019 2 12.5 4.019 17 6.5 17c.171 0 .334-.032.5-.051V17h11v-.051c2.244-.252 4-2.139 4-4.449 0-2.481-2.019-4.5-4.5-4.5zM4 12.5C4 11.121 5.121 10 6.5 10S9 11.121 9 12.5 7.879 15 6.5 15 4 13.879 4 12.5zM17.5 15c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1935d4dccc5e8665(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21c3.527-1.547 5.999-4.909 5.999-9S19.527 4.547 16 3v2c2.387 1.386 3.999 4.047 3.999 7S18.387 17.614 16 19v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .38-.116c.026-.015.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$93f202172a4f3c72(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .379-.116c.026-.014.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.018-.056-.02-.082-.033a.977.977 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9zm12-2v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f5b4897b76629183(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-2.023-2.023A9.566 9.566 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.113 8.113 0 0 1-1.672 4.913l-1.285-1.285C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V4a1 1 0 0 0-1.554-.832L7.727 6.313l-4.02-4.02-1.414 1.414 18 18 1.414-1.414zM12 5.868v4.718L9.169 7.755 12 5.868zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20v-1.879l-2-2v2.011l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9h.879L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f21b800546c3128b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .379-.116c.026-.014.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.018-.056-.02-.082-.033a.977.977 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$94a1f6d2eeef9da4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.978 12.27c.245.368.611.647 1.031.787l2.675.892.633-1.896-2.675-.892-1.663-2.495a2.016 2.016 0 0 0-.769-.679l-1.434-.717a1.989 1.989 0 0 0-1.378-.149l-3.193.797a2.002 2.002 0 0 0-1.306 1.046l-1.794 3.589 1.789.895 1.794-3.589 2.223-.556-1.804 8.346-3.674 2.527 1.133 1.648 3.675-2.528c.421-.29.713-.725.82-1.225l.517-2.388 2.517 1.888.925 4.625 1.961-.393-.925-4.627a2 2 0 0 0-.762-1.206l-2.171-1.628.647-3.885 1.208 1.813z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$77ce57f1fa714701(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h15v3h-6c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h6.001v3H5zm15-9v4h-6v-4h6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$59e37cb37da15fb3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h2v4h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$612ed1b6ec710a5c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.996 9c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707C11.83 8.253 12.577 9 13.991 9c1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 8.253 20.585 9 22 9V7c-.563 0-.804-.217-1.295-.707C20.159 5.747 19.411 5 17.996 5s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 5.747 11.407 5 9.993 5s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 5.747 3.413 5 2 5v2c.561 0 .801.217 1.291.707C3.836 8.253 4.583 9 5.996 9zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 13.253 20.585 14 22 14v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 10.747 11.407 10 9.993 10s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 10.747 3.413 10 2 10v2c.561 0 .801.217 1.291.707C3.836 13.253 4.583 14 5.996 14zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 18.253 20.585 19 22 19v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 15.747 11.407 15 9.993 15s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 15.747 3.413 15 2 15v2c.561 0 .801.217 1.291.707C3.836 18.253 4.583 19 5.996 19z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d935c713661080f4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.038-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.962-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7 0-3.86 3.141-7 7-7s7 3.14 7 7c0 3.859-3.141 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3eb5223ff6a6263f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$55241d5e28572ceb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.671 14.307C16.184 12.819 14.17 12 12 12s-4.184.819-5.671 2.307l1.414 1.414c1.11-1.11 2.621-1.722 4.257-1.722 1.636.001 3.147.612 4.257 1.722l1.414-1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b7c3cbe6054a43dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.671 14.307C16.184 12.819 14.17 12 12 12s-4.184.819-5.671 2.307l1.414 1.414c1.11-1.11 2.621-1.722 4.257-1.722 1.636.001 3.147.612 4.257 1.722l1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.437 11.292c-4.572-4.573-12.301-4.573-16.873 0l1.414 1.414c3.807-3.807 10.238-3.807 14.045 0l1.414-1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f2feb089f36dce0f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m1.293 8.395 1.414 1.414c.504-.504 1.052-.95 1.622-1.359L2.9 7.021c-.56.422-1.104.87-1.607 1.374zM6.474 5.06 3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.012-5.012.976-.975a7.86 7.86 0 0 0-4.099-2.148L11.294 9.88c2.789-.191 5.649.748 7.729 2.827l1.414-1.414c-2.898-2.899-7.061-3.936-10.888-3.158L8.024 6.61A13.366 13.366 0 0 1 12 6c3.537 0 6.837 1.353 9.293 3.809l1.414-1.414C19.874 5.561 16.071 4 12 4a15.198 15.198 0 0 0-5.526 1.06zm-2.911 6.233 1.414 1.414a9.563 9.563 0 0 1 2.058-1.551L5.576 9.697c-.717.451-1.395.979-2.013 1.596zm2.766 3.014 1.414 1.414c.692-.692 1.535-1.151 2.429-1.428l-1.557-1.557a7.76 7.76 0 0 0-2.286 1.571zm7.66 3.803-2.1-2.1a1.996 1.996 0 1 0 2.1 2.1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e4578ce5a76a129b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.537 0 6.837 1.353 9.293 3.809l1.414-1.414C19.874 5.561 16.071 4 12 4c-4.071.001-7.874 1.561-10.707 4.395l1.414 1.414C5.163 7.353 8.463 6 12 6zm5.671 8.307c-3.074-3.074-8.268-3.074-11.342 0l1.414 1.414c2.307-2.307 6.207-2.307 8.514 0l1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.437 11.293c-4.572-4.574-12.301-4.574-16.873 0l1.414 1.414c3.807-3.807 10.238-3.807 14.045 0l1.414-1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$673e4dc354d778e0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.5C13 3.57 11.43 2 9.5 2 7.466 2 6.25 3.525 6.25 5h2c0-.415.388-1 1.25-1 .827 0 1.5.673 1.5 1.5S10.327 7 9.5 7H2v2h7.5C11.43 9 13 7.43 13 5.5zm2.5 9.5H8v2h7.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5c-.862 0-1.25-.585-1.25-1h-2c0 1.475 1.216 3 3.25 3 1.93 0 3.5-1.57 3.5-3.5S17.43 15 15.5 15z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5c-2.206 0-4 1.794-4 4h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2H2v2h16c2.206 0 4-1.794 4-4s-1.794-4-4-4zM2 15h4v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ad10b48ac4007bd3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 2 .001 4H4V5h16zM4 19v-8h16.001l.001 8H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6h2v2h-2zm3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3f4106b5864e1d66(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h16l.001 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.707 10.707-1.414-1.414L12 11.586 9.707 9.293l-1.414 1.414L10.586 13l-2.293 2.293 1.414 1.414L12 14.414l2.293 2.293 1.414-1.414L13.414 13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2f63d962b635422e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h5v-2H4V7h16v12h-5v2h5c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21v-5h3l-4-5-4 5h3v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$379387aa4620280b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2V7h16l.001 12H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$227b674691f842e2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM4 19v-8h12V9l.002 10H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2h13.001c1.101 0 1.996.895 1.999 1.994L20.002 15H20v2c1.103 0 2-.897 2-2V8.007L22.001 8V6L22 5.99V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8133b17149dea681(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.713 12.123c.264-.952.312-2.03.143-3.206l-.866-6.059A1 1 0 0 0 18 2H6a1 1 0 0 0-.99.858l-.865 6.058c-.169 1.177-.121 2.255.142 3.206.864 3.134 3.551 5.392 6.713 5.794V20H9v2h6v-2h-2v-2.084c3.162-.402 5.849-2.66 6.713-5.793zM17.133 4l.57 4H6.296l.571-4h10.266zM6.215 11.59c-.132-.474-.181-1.009-.159-1.59h11.889c.021.581-.028 1.116-.159 1.591A6.021 6.021 0 0 1 12 16a6.019 6.019 0 0 1-5.785-4.41z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$95078c9560f45286(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.828 14.828a3.988 3.988 0 0 1-2.02 1.09 4.108 4.108 0 0 1-1.616 0 4.103 4.103 0 0 1-.749-.232 4.161 4.161 0 0 1-.679-.368 4.115 4.115 0 0 1-1.082-1.082l-1.658 1.117c.215.319.462.619.733.889a5.991 5.991 0 0 0 8.485.002c.272-.271.52-.571.734-.891l-1.658-1.117c-.143.211-.307.41-.49.592z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10c-2 0-2.5 2-2.5 2h5s-.501-2-2.5-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cf99134e694c2931(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 9c-2 0-2.5 2-2.5 2h5s-.501-2-2.5-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-2 16v-3h4v3c0 1.103-.897 2-2 2s-2-.897-2-2zm5.856 1.005c.085-.323.144-.656.144-1.005v-1.499C17.589 15.028 18 13 18 13H6s.412 2.028 2 3.501V18c0 .349.059.682.144 1.005A8.005 8.005 0 0 1 4 12c0-4.411 3.589-8 8-8s8 3.589 8 8a8.005 8.005 0 0 1-4.144 7.005z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4da655e1b570b1e7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.758 5H19.68l-.844 3h-4.893l-.899-3h-2.088l-.899 3H5.164L4.32 5H2.242l.844 3H2v2h1.648l.563 2H2v2h2.773l1.688 6h2.083l1.8-6h3.313l1.8 6h2.083l1.688-6H22v-2h-2.211l.563-2H22V8h-1.086l.844-3zM5.727 10h3.729l-.6 2H6.289l-.562-2zm1.804 6.417L6.852 14h1.404l-.725 2.417zM10.944 12l.6-2h.912l.6 2h-2.112zm5.525 4.417L15.744 14h1.404l-.679 2.417zM17.711 12h-2.567l-.6-2h3.729l-.562 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ce500512f49adbd6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-.899.156-1.762.431-2.569L6 11l2 2v2l2 2 1 1v1.931C7.061 19.436 4 16.072 4 12zm14.33 4.873C17.677 16.347 16.687 16 16 16v-1a2 2 0 0 0-2-2h-4v-3a2 2 0 0 0 2-2V7h1a2 2 0 0 0 2-2v-.411C17.928 5.778 20 8.65 20 12a7.947 7.947 0 0 1-1.67 4.873z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f5acbb0fb0d23be(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.122 21c.378.378.88.586 1.414.586S7.572 21.378 7.95 21l4.336-4.336a7.495 7.495 0 0 0 2.217.333 7.446 7.446 0 0 0 5.302-2.195 7.484 7.484 0 0 0 1.632-8.158l-.57-1.388-4.244 4.243-2.121-2.122 4.243-4.243-1.389-.571A7.478 7.478 0 0 0 14.499 2c-2.003 0-3.886.78-5.301 2.196a7.479 7.479 0 0 0-1.862 7.518L3 16.05a2.001 2.001 0 0 0 0 2.828L5.122 21zm4.548-8.791-.254-.616a5.486 5.486 0 0 1 1.196-5.983 5.46 5.46 0 0 1 4.413-1.585l-3.353 3.353 4.949 4.95 3.355-3.355a5.49 5.49 0 0 1-1.587 4.416c-1.55 1.55-3.964 2.027-5.984 1.196l-.615-.255-5.254 5.256h.001l-.001 1v-1l-2.122-2.122 5.256-5.255z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d2e5d8ba349d963(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4b4ba9e3520e942b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2e0c61638dd04e19(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 3.4 12 10.333 6.8 3.4 5.2 4.6 10 11H7v2h4v2H7v2h4v4h2v-4h4v-2h-4v-2h4v-2h-3l4.8-6.4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d042aac5fb0b5792(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H9v3H6v2h3v3h2v-3h3V9h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7b4c735a1f73f87a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9h8v2H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c8a61f0b29413f7c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12v-2H4V8H2v12c0 1.103.897 2 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-2 9h-3v3h-2v-3h-3V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$679d1b9b0fec9d47(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.833-3.833 3.833-10.31 0-14.143s-10.31-3.833-14.143 0-3.833 10.31 0 14.143 10.31 3.833 14.143 0zM7.051 7.051c2.706-2.707 7.191-2.708 9.898 0l-9.898 9.898c-2.708-2.707-2.71-7.19 0-9.898z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$55141e3c2f1fa60(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 17V5c3.829 0 7 3.169 7 7 0 3.828-3.171 7-7 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e72ba0fa475dcfb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm4 10h-3v3h-2v-3H8v-2h3V9h2v3h3v2zm1.284-10.293 1.412-1.416 3.01 3-1.413 1.417zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$39d0ec6dfec8112f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.284 3.707 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3zM12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm1 14h-2v-2h2v2zm0-4h-2V8h2v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$855b373f93a09d3d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.292 6.708-3.01-3 1.412-1.417 3.01 3zm1.415 13.585-2.287-2.288C20.409 16.563 21 14.837 21 13c0-4.878-4.121-9-9-9-1.838 0-3.563.59-5.006 1.581L5.91 4.496l.788-.79-1.416-1.412-.786.788-.789-.789-1.414 1.414 18 18 1.414-1.414zM17 14h-1.586l-2-2H17v2zm-6-6h2v3.586l-2-2V8zm1 14c1.658 0 3.224-.485 4.574-1.305L4.305 8.426A8.794 8.794 0 0 0 3 13c0 4.878 4.122 9 9 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$27fba77fd937d577(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.284 3.707 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3zM12 4c-4.878 0-9 4.121-9 9s4.122 9 9 9c4.879 0 9-4.121 9-9s-4.121-9-9-9zm4 13H8.131l4-6H8V9h7.868l-1.035 1.554-.001.001L11.869 15H16v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3dd7ab9bac44ffda(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.878 0-9 4.122-9 9s4.122 9 9 9c4.879 0 9-4.122 9-9s-4.121-9-9-9zm5 10h-6V8h2v4h4v2zm3.292-7.292-3.01-3 1.412-1.417 3.01 3zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b52ef31f3cfdc3ab(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-4.607 8.055A4.956 4.956 0 0 0 7 12H5a6.978 6.978 0 0 1 2.051-4.95 6.978 6.978 0 0 1 2.225-1.5l.779 1.842c-.596.252-1.13.612-1.59 1.072s-.82.995-1.072 1.591zm4.6 3.945a2.007 2.007 0 1 1 0-4.014 2.007 2.007 0 0 1 0 4.014z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c6e4b960bf08eece(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.86 12.48 19.15 8a2 2 0 0 0-1.72-1H15V5a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 1 1.73 3.49 3.49 0 0 0 7 .27h3.1a3.48 3.48 0 0 0 6.9 0 2 2 0 0 0 2-2v-3a1.07 1.07 0 0 0-.14-.52zM6.5 19A1.5 1.5 0 1 1 8 17.5 1.5 1.5 0 0 1 6.5 19zm5.5-8h-2v2H8v-2H6V9h2V7h2v2h2zm4.5 8a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zM15 12V9h2.43l1.8 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8e5ccc1cbcac88bd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.626 8.878a7.937 7.937 0 0 1 1.71-2.541 7.92 7.92 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.49 2.49 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059-1.19.5-2.26 1.22-3.18 2.139A9.98 9.98 0 0 0 2 12h2c0-1.086.211-2.136.626-3.122zm14.747 6.244c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.973 9.973 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538c2.502 0 4.538-2.036 4.538-4.538S14.502 7.462 12 7.462z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$52a4bdeaad1906ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5.002-.022-1.373-.549.742-1.857 5 2-.742 1.857-1.031-.413c-.014.014-.023.031-.037.044A1.499 1.499 0 0 1 7 10.5zM8 17s1-3 4-3 4 3 4 3H8zm8.986-6.507c0 .412-.167.785-.438 1.056a1.488 1.488 0 0 1-2.112 0c-.011-.011-.019-.024-.029-.035l-1.037.415-.742-1.857 5-2 .742 1.857-1.386.554a.036.036 0 0 1 .002.01z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c104a6f86ae306f0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V6H3v14H2v2h6v-7c0-.163.046-4 4-4 3.821 0 3.993 3.602 4 4v7h6v-2h-1V8zM2 2h20v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5c7269a8dff56690(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.997.997 0 0 0-.707.293L2.294 5.292A.996.996 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM12 18l-5-5h3v-3h4v3h3l-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4d4176c6e9a33cc1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM14 14v3h-4v-3H7l5-5 5 5h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3dce0588723137fc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.704 5.29-2.997-2.997A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.296 5.29A.994.994 0 0 0 2 5.999V19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5.999a.994.994 0 0 0-.296-.709zM6.414 4h11.172l1 1H5.414l1-1zM17 13v1H7v-4h2v2h6v-2h2v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3a5b946e88fed514(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14zm9-13h6v6h-2V8h-4V6zm-6 6h2v4h4v2H6v-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$42b60ac20155134a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm6-14-6 6h5v6h2v-6h5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$826134b7529b906f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10 5H8v2h6v5l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f0917a04e1063cac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-8 12v-5h6v-2h-6V6l-6 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9323c802f5bb5675(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm5 4v6H6l6 6 6-6h-5V8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d69379643f8f37d5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm5-14v6H6l6 6 6-6h-5V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d74c41b9350e4e5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10 7h6v-2h-6V6l-6 6 6 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c3053117d4c22da(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-8 5H4v2h6v5l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$959c0f585cf54921(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm5 10v6h2v-6h5l-6-6-6 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$42d98f9707f3f7bb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8.999a6.99 6.99 0 0 0 2.879 5.646l.001.001a6.972 6.972 0 0 0 1.881.979l.051.019a6.906 6.906 0 0 0 1.163.271 6.79 6.79 0 0 0 1.024.085H12c.35 0 .69-.034 1.027-.084l.182-.028c.336-.059.664-.139.981-.243l.042-.016C17 14.693 19 12.078 19 8.999 19 5.14 15.86 2 12 2S5 5.14 5 8.999zM12 4c2.756 0 5 2.242 5 4.999h-2A3.003 3.003 0 0 0 12 6V4zM7.521 16.795V22L12 20.5l4.479 1.5.001-5.205a8.932 8.932 0 0 1-8.959 0z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3465a7f48a13ba18(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.666 12.277a7.72 7.72 0 0 0 .171-.665c.003-.017.004-.033.008-.05.02-.098.029-.199.045-.298.025-.157.055-.313.07-.471a7.979 7.979 0 0 0-2.303-6.45A7.979 7.979 0 0 0 14 2v8H6.517l-.858-2H2v2h2.341l1.828 4.266A3.504 3.504 0 0 0 4 17.5C4 19.43 5.57 21 7.5 21c1.759 0 3.204-1.309 3.449-3h2.102c.245 1.691 1.69 3 3.449 3 1.93 0 3.5-1.57 3.5-3.5 0-.63-.181-1.213-.473-1.725.042-.041.089-.077.131-.119.36-.361.688-.759.977-1.184.288-.43.536-.886.736-1.359.016-.037.026-.076.041-.113h.001l.015-.042c.088-.22.168-.441.235-.668l.003-.013zM7.5 19c-.827 0-1.5-.673-1.5-1.5S6.673 16 7.5 16s1.5.673 1.5 1.5S8.327 19 7.5 19zm9 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3b19029953bf8e21(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15a1 1 0 0 0-1-1H9c-.551 0-1 .448-1 1v2h8v-2zm-8 4h8v3H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0-2.967-2.167-5.432-5-5.91V5c0-1.654-1.346-3-3-3h-2C9.346 2 8 3.346 8 5v1.09C5.167 6.568 3 9.033 3 12v8c0 1.103.897 2 2 2h1v-7c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3v7h1c1.103 0 2-.897 2-2v-8zM10 5c0-.552.449-1 1-1h2a1 1 0 0 1 1 1v1h-4V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e178a06d25b4a340(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8c0 .173.012.347.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16c0-.173-.012-.347-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479zm-9.01 7.895-3.667-3.714 1.424-1.404 2.257 2.286 4.327-4.294 1.408 1.42-5.749 5.706z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3de23a5d554708a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.047 14.668a.994.994 0 0 0 .465.607l1.91 1.104v2.199a1 1 0 0 0 1 1h2.199l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135L12 20.75l1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1V16.38l1.91-1.104a1 1 0 0 0 .365-1.367L20.75 12l1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1H16.38l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.25l-1.909-1.104a1 1 0 0 0-1.366.365l-1.104 1.91H5.422a1 1 0 0 0-1 1V7.62l-1.91 1.104a1.003 1.003 0 0 0-.365 1.368L3.251 12l-1.104 1.908a1.009 1.009 0 0 0-.1.76zM12 13c-3.48 0-4-1.879-4-3 0-1.287 1.029-2.583 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .515-2 1 0 .374 0 1 2 1 3.48 0 4 1.879 4 3 0 1.287-1.029 2.583-3 2.915V18h-2v-1.08c-2.339-.367-3-2.003-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.325 0-1-2-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1445f40e83b537d0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8c0 .173.012.347.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16c0-.173-.012-.347-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c6cbb0485993da13(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.13 4.41 4.23 4.23L14.3 9.7l-4.24-4.24-1.77 1.77 4.24 4.24-1.06 1.06-4.24-4.24-1.77 1.77L9.7 14.3l-1.06 1.06-4.23-4.23C1.86 14 1.55 18 3.79 20.21a5.38 5.38 0 0 0 3.85 1.5 8 8 0 0 0 5.6-2.47l6-6c2.87-2.87 3.31-7.11 1-9.45s-6.24-1.93-9.11.62z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c684c5b0c3041779(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.247 3.034c-.069-.018-1.742-.433-4.052-.433-2.842 0-6.868.64-9.91 3.687-5.34 5.349-3.34 13.61-3.252 13.96a1 1 0 0 0 .728.726c.069.018 1.726.426 4.018.426 2.849 0 6.884-.641 9.932-3.688 5.335-5.335 3.351-13.6 3.264-13.949a1.005 1.005 0 0 0-.728-.729zm-3.537 9.262-1.414 1.414-1.793-1.792-1.586 1.586 1.792 1.793-1.414 1.414-1.792-1.793-1.793 1.793-1.414-1.414 1.793-1.793-1.793-1.794 1.414-1.414 1.793 1.794 1.586-1.586-1.794-1.793 1.414-1.414 1.794 1.793 1.793-1.793 1.414 1.414-1.793 1.793 1.793 1.792z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ff300b126b5e2be3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.91 10 22h4l-1-2.09c4-.65 7-5.28 7-9.91a8 8 0 0 0-16 0c0 4.63 3.08 9.26 7 9.91zm1-15.66v1.5A4.26 4.26 0 0 0 7.75 10h-1.5A5.76 5.76 0 0 1 12 4.25z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$64c7d389ac74b73c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.646 3.868-7.778 7.778a6.007 6.007 0 0 0 0 8.485 5.984 5.984 0 0 0 4.242 1.754 5.984 5.984 0 0 0 4.243-1.754l7.778-7.778a6.007 6.007 0 0 0 0-8.485 6.008 6.008 0 0 0-8.485 0zM9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$12929e46a53b1ad0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v4.001h1V18H2v3h16l3 .001V21h1v-3h-1v-5.999h1V8L12 2 2 8zm4 10v-5.999h2V18H6zm5 0v-5.999h2V18h-2zm7 0h-2v-5.999h2V18zM14 8a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bc8bd63fa70b9e32(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21H3a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f335a6bab15013c6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM9 18H7v-6h2v6zm4 0h-2V7h2v11zm4 0h-2v-8h2v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8e0d7ce337974b89(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 17H5V7h3zm2 0H9V7h1zm2 0h-1V7h1zm4 0h-3V7h3zm3 0h-2V7h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$56d7876ae1bf4b74(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.984 12.236a9.966 9.966 0 0 0-2.913-7.308 9.966 9.966 0 0 0-7.308-2.913 9.04 9.04 0 0 1-.673 4.313l-1.84-.78a7.044 7.044 0 0 0 .526-3.284 9.927 9.927 0 0 0-4.847 2.665 9.924 9.924 0 0 0-2.666 4.852 7.082 7.082 0 0 0 2.576-.276l.575 1.916c-1.1.33-2.257.443-3.398.344a9.964 9.964 0 0 0 2.913 7.307 9.965 9.965 0 0 0 7.307 2.913 9.079 9.079 0 0 1 .344-3.398l1.916.575a7.06 7.06 0 0 0-.276 2.576 9.927 9.927 0 0 0 4.853-2.666 9.926 9.926 0 0 0 2.665-4.848 7.056 7.056 0 0 0-3.284.526l-.78-1.841a9.025 9.025 0 0 1 4.31-.673zM9.17 9.173a9.017 9.017 0 0 1-2.192 1.612l-.927-1.772a7.01 7.01 0 0 0 2.576-2.314l1.663 1.113c-.328.49-.705.948-1.12 1.361zm7.074 7.068a6.991 6.991 0 0 0-1.257 1.708l-1.772-.927a9.025 9.025 0 0 1 2.972-3.312l1.113 1.663a6.987 6.987 0 0 0-1.056.868z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dfaf0c49e5147f5c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.132 2.504 4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.263A2.004 2.004 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.145-5.504-1.736-.992zM14 13h2v5h-2v-5zm-6 0h2v5H8v-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b6e32884a80c469c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.328 4.258a9.953 9.953 0 0 0-5.949-2.235 8.99 8.99 0 0 1-1.835 7.107L12 10.586l6.328-6.328zM7.701 9.115 4.258 5.672a9.938 9.938 0 0 0-2.112 4.704 7.007 7.007 0 0 0 5.555-1.261zm12.041-3.443L13.414 12l1.456 1.456a8.993 8.993 0 0 1 7.107-1.835 9.953 9.953 0 0 0-2.235-5.949zm2.112 7.952a7.007 7.007 0 0 0-5.555 1.261l3.443 3.443a9.924 9.924 0 0 0 2.112-4.704zM9.115 7.701a7.007 7.007 0 0 0 1.261-5.555 9.928 9.928 0 0 0-4.704 2.112l3.443 3.443zm4.509 14.153a9.936 9.936 0 0 0 4.704-2.111L14.885 16.3a7.003 7.003 0 0 0-1.261 5.554zM12 13.414l-6.328 6.328a9.953 9.953 0 0 0 5.949 2.235 8.99 8.99 0 0 1 1.835-7.107L12 13.414zm-7.742 4.914L10.586 12 9.13 10.544a8.993 8.993 0 0 1-7.107 1.835 9.953 9.953 0 0 0 2.235 5.949z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fddd02bf7a2be191(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H7V7.113c0-.997.678-1.923 1.661-2.085A2.003 2.003 0 0 1 11 7h2a4.003 4.003 0 0 0-4.398-3.98C6.523 3.222 5 5.089 5 7.178V10H3a1 1 0 0 0-1 1v2c0 2.606 1.674 4.823 4 5.65V22h2v-3h8v3h2v-3.35c2.326-.827 4-3.044 4-5.65v-2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$93253816af847355(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2zM9 17l2-3.89L7 12l6-5-1 3.89L16 12l-7 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c63aa1ad3de7461a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h14a2 2 0 0 0 2-2v-2h2v-4h-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2zm1-9h12v6H5V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$165dca654837b289(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2V8zM5 15V9h3l4 6H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8f42e520fc178837(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2V8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5d061b1d10dbd80b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.556V3h-2v2H6V3H4v6.557C2.81 10.25 2 11.526 2 13v4a1 1 0 0 0 1 1h1v4h2v-4h12v4h2v-4h1a1 1 0 0 0 1-1v-4c0-1.474-.811-2.75-2-3.444zM11 9H6V7h5v2zm7 0h-5V7h5v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a98210aa06da1f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zm-1 13.414-3.707-3.707 1.414-1.414L11 12.586l5.293-5.293 1.414 1.414L11 15.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$66dbf697e91484d0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-1h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM8 17H6V7h2v10zm6 0h-2V7h2v10zm6-1h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$df42c0d810070208(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm8.707-5.707L19 14.586V10c0-3.217-2.185-5.926-5.145-6.743C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.997.997 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.997.997 0 0 0-.293-.707zM16 12H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3c263b50245ab9a9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.345 18.931A.993.993 0 0 0 21 18v-1a.996.996 0 0 0-.293-.707L19 14.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258c-1.323.364-2.463 1.128-3.346 2.127L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.362-1.362zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zM5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h10.879L5.068 9.189C5.037 9.457 5 9.724 5 10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d925a9a06de80873(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm8.707-5.707L19 14.586V10c0-3.217-2.185-5.926-5.145-6.743C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.997.997 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.997.997 0 0 0-.293-.707zM16 12h-3v3h-2v-3H8v-2h3V7h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$19b77f788411012a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.705 3.71-1.41-1.42C1 5.563 1 7.935 1 11h1l1-.063C3 8.009 3 6.396 5.705 3.71zm13.999-1.42-1.408 1.42C21 6.396 21 8.009 21 11l2-.063c0-3.002 0-5.374-3.296-8.647zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.184 4.073 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$92b32ae1a2915059(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$65073ca5248a7446(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4a2 2 0 0 0-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM8 7h3V5h2v2h3v2h-3v6h-2V9H8V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c49d7488d2c61435(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.447 5.345A3.27 3.27 0 0 0 16.29 3a3.293 3.293 0 0 0-3.277 3h-2.025a3.297 3.297 0 0 0-3.284-3 3.268 3.268 0 0 0-3.151 2.345l-2.511 8.368A1.027 1.027 0 0 0 2 14v1a5.006 5.006 0 0 0 5.001 5 5.003 5.003 0 0 0 4.576-3h.846a5.003 5.003 0 0 0 4.576 3A5.006 5.006 0 0 0 22 14.999V14c0-.098-.015-.194-.042-.287l-2.511-8.368zM7.001 18A3.005 3.005 0 0 1 4 15c0-.076.017-.147.022-.222A2.995 2.995 0 0 1 7 12a3 3 0 0 1 3 3v.009A3.004 3.004 0 0 1 7.001 18zm9.998 0A3.004 3.004 0 0 1 14 15.009V15a3 3 0 0 1 6-.001A3.005 3.005 0 0 1 16.999 18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e2d02df9a2a3cf98(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h12c1.654 0 3-1.346 3-3s-1.346-3-3-3H6v2h13a1 1 0 0 1 0 2H7c-1.654 0-3-1.346-3-3s1.346-3 3-3h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 13h.003L4 13.002V13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$90fcb128eddb0262(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 16v-5H7l6-7v5h4l-6 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9e94e4077cf647e3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.168 8H13l.806-4.835A1 1 0 0 0 12.819 2H7.667a1 1 0 0 0-.986.835l-1.667 10A1 1 0 0 0 6 14h4v8l8.01-12.459A1 1 0 0 0 17.168 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$931563a05c13edc2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.293 4.293-1.086 1.086-1.086-1.086a.999.999 0 0 0-1.414 0l-1.249 1.249A8.427 8.427 0 0 0 10.499 5C5.813 5 2 8.813 2 13.5S5.813 22 10.499 22s8.5-3.813 8.5-8.5a8.42 8.42 0 0 0-.431-2.654L19.914 9.5a.999.999 0 0 0 0-1.414l-1.293-1.293 1.09-1.09C19.94 5.474 20.556 5 21 5h1V3h-1c-1.4 0-2.584 1.167-2.707 1.293zM10.499 10c-.935 0-1.813.364-2.475 1.025A3.48 3.48 0 0 0 7 13.5H5c0-1.468.571-2.849 1.609-3.888A5.464 5.464 0 0 1 10.499 8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d024a81e229e0801(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.852 5.148a3.317 3.317 0 0 0-.96-2.183 3.333 3.333 0 1 0-4.713 4.714l-5.499 5.5a3.333 3.333 0 1 0-4.714 4.713c.606.606 1.39.918 2.183.96.042.793.354 1.576.96 2.183a3.333 3.333 0 1 0 4.713-4.714l5.499-5.499a3.333 3.333 0 1 0 4.714-4.713 3.313 3.313 0 0 0-2.183-.961z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a00f3d09a86e79ec(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.293 8.293-2.069 2.069A7.017 7.017 0 0 0 15 8.681V4h1V2H8v2h1v4.681A7.01 7.01 0 0 0 5 15c0 3.859 3.141 7 7 7s7-3.141 7-7a6.958 6.958 0 0 0-.652-2.934l2.359-2.359-1.414-1.414zm-8.959 1.998.666-.235V4h2v6.056l.666.235A5.006 5.006 0 0 1 16.886 14H7.114a5.006 5.006 0 0 1 3.22-3.709z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ac029f0006d6ef41(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1zM8 9h3V6h2v3h3v2h-3v3h-2v-3H8V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ff3d34219af4f6f4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a2f3257c1bb0f772(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727H21V4a2 2 0 0 0-2-2zm0 9-2-1-2 1V4h4v7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7fefd678c19955dd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-1 4v2h-5V7h5zm-5 4h5v2h-5v-2zM4 19V5h7v14H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8ec2adab91b821cc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727zM8.648 7.642a2.224 2.224 0 0 1 3.125 0l.224.219.223-.219a2.225 2.225 0 0 1 3.126 0 2.129 2.129 0 0 1 0 3.069L11.998 14l-3.349-3.289a2.128 2.128 0 0 1-.001-3.069z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a54ff9a1e4169caa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3h-7a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h5.758a2.01 2.01 0 0 1 1.414.586l1.121 1.121c.009.009.021.012.03.021.086.08.182.15.294.196h.002a.996.996 0 0 0 .762 0h.002c.112-.046.208-.117.294-.196.009-.009.021-.012.03-.021l1.121-1.121A2.01 2.01 0 0 1 15.242 20H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 15h-4.758a4.03 4.03 0 0 0-2.242.689V6c0-.551.448-1 1-1h6v13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6fcfbb7598d1bf0e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v11.529S6.621 19.357 12 22c5.379-2.643 10-2.471 10-2.471V8s-5.454 0-10 2.471C7.454 8 2 8 2 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b8e5b117018f9a02(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4a2 2 0 0 0-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1zM8 6h9v2H8V6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b4d9d0a494c84c81(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM13 11H7V9h6v2zm7 0h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$be4165fe64582b8d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM13 11h-2v2H9v-2H7V9h2V7h2v2h2v2zm7 0h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8b10e838e9d64e39(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zm1.5 9h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2c9d7122821d4ce5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22V4c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v18l7-4.666L19 22zM8.006 8.056c0-.568.224-1.083.585-1.456.361-.372.86-.603 1.412-.603 0 0 .996-.003 1.997 1.029 1.001-1.032 1.997-1.029 1.997-1.029.552 0 1.051.23 1.412.603s.585.888.585 1.456-.224 1.084-.585 1.456L12 13.203 8.591 9.512a2.083 2.083 0 0 1-.585-1.456z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a62659ef99d47033(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v18l7-4.848L19 22V4a2 2 0 0 0-2-2zm-1 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9949c97dbc40d60d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v18l7-4.848L19 22V4a2 2 0 0 0-2-2zm-1 9h-3v3h-2v-3H8V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f08c292b26cd944(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.222 14.667 13l-.89-3.111L16 8l-2.667-.333L12 5l-1.333 2.667L8 8l2.223 1.889L9.333 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.723V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v17.723l7-4.571 7 4.571zM8 8l2.667-.333L12 5l1.333 2.667L16 8l-2.223 1.889.89 3.111L12 11.222 9.333 13l.89-3.111L8 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7f0e2d1a6b9fb5f8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10.132v-6c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2V22l7-4.666L19 22V10.132z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$350dbd991d3becfa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.999 23V7c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2v16l6-3.601 6 3.601z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.585 3h1.414c1.103 0 2 .897 2 2v10.443l2 2.489V3c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2h6.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3f99b3adf93094de(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.975V8a2 2 0 0 0-2-2h-6V4.688c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5a2 2 0 0 0-2 2v2.998l-.072.005A.999.999 0 0 0 2 12v2a1 1 0 0 0 1 1v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a1 1 0 0 0 1-1v-1.938a1.004 1.004 0 0 0-.072-.455c-.202-.488-.635-.605-.928-.632zM7 12c0-1.104.672-2 1.5-2s1.5.896 1.5 2-.672 2-1.5 2S7 13.104 7 12zm8.998 6c-1.001-.003-7.997 0-7.998 0v-2s7.001-.002 8.002 0l-.004 2zm-.498-4c-.828 0-1.5-.896-1.5-2s.672-2 1.5-2 1.5.896 1.5 2-.672 2-1.5 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e4ff20fbd2e9a96e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H3a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zM9 9V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 7 3V2H5v1a4.51 4.51 0 0 0 1.28 3.17A2.49 2.49 0 0 1 7 7.93V9zm4 0V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 11 3V2H9v1a4.51 4.51 0 0 0 1.28 3.15A2.49 2.49 0 0 1 11 7.93V9zm4 0V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 15 3V2h-2v1a4.51 4.51 0 0 0 1.28 3.15A2.49 2.49 0 0 1 15 7.93V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de63398c4248b17d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10a3.58 3.58 0 0 0-1.8-3 3.66 3.66 0 0 0-3.63-3.13 3.86 3.86 0 0 0-1 .13 3.7 3.7 0 0 0-5.11 0 3.86 3.86 0 0 0-1-.13A3.66 3.66 0 0 0 4.81 7 3.58 3.58 0 0 0 3 10a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zM5 10a1.59 1.59 0 0 1 1.11-1.39l.83-.26-.16-.85a1.64 1.64 0 0 1 1.66-1.62 1.78 1.78 0 0 1 .83.2l.81.45.5-.77a1.71 1.71 0 0 1 2.84 0l.5.77.81-.45a1.78 1.78 0 0 1 .83-.2 1.65 1.65 0 0 1 1.67 1.6l-.16.85.82.28A1.59 1.59 0 0 1 19 10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cf15928840ff1540(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM6.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 12zM9 6.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 9 6.5zm2.5 6.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 11.5 13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1cffd2563891d75b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h20v4H2zm17 5H3v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8h-2zm-3 6H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3bab334ffebdcb9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.299 17.596c.432 1.332 1.745 2.182 3.146 2.182H6.5A2.78 2.78 0 0 0 9.223 22c.457 0 .884-.115 1.262-.313a.992.992 0 0 0 .515-.882V3.027a.997.997 0 0 0-.785-.983 2.324 2.324 0 0 0-1.479.201c-.744.356-1.18 1.151-1.18 1.978v.055a2.778 2.778 0 0 0-2.744 4.433A3.327 3.327 0 0 0 2 12c0 1.178.611 2.211 1.533 2.812-.43.771-.571 1.746-.234 2.784zm15.889-8.885a2.778 2.778 0 0 0-2.744-4.433v-.055c0-.826-.437-1.622-1.181-1.978a2.32 2.32 0 0 0-1.478-.201.998.998 0 0 0-.785.983v17.777c0 .365.192.712.516.882.378.199.804.314 1.261.314a2.78 2.78 0 0 0 2.723-2.223h.056c1.4 0 2.714-.85 3.146-2.182.337-1.038.196-2.013-.234-2.784A3.35 3.35 0 0 0 22 12a3.327 3.327 0 0 0-2.812-3.289z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9fb28a5bbe878bd7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v4h5v-2h2v2h6v-2h2v2h5V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm8 11h-2v-2H9v2H7v-2H2v6c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-6h-5v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e03c375159a51541(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM6 8h2v11H6V8zm12 11h-2V8h2v11zM15 4v2H9V4h6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5def5cb2df505d6b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v3h20V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm5 10h-4v-2H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$463078b813e511b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.546 11.646 19 9.101V5.5a.5.5 0 0 0-.5-.5h-3.601l-2.546-2.546a.5.5 0 0 0-.707 0L9.101 5H5.5a.5.5 0 0 0-.5.5v3.601l-2.546 2.546a.5.5 0 0 0 0 .707L5 14.899V18.5a.5.5 0 0 0 .5.5h3.601l2.546 2.546a.5.5 0 0 0 .707 0L14.899 19H18.5a.5.5 0 0 0 .5-.5v-3.601l2.546-2.546a.5.5 0 0 0 0-.707zM12 8a4 4 0 0 1 0 8"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$428fb69f80a0b68c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.546 11.646 19 9.101V5.5a.5.5 0 0 0-.5-.5h-3.601l-2.546-2.546a.5.5 0 0 0-.707 0L9.101 5H5.5a.5.5 0 0 0-.5.5v3.601l-2.546 2.546a.5.5 0 0 0 0 .707L5 14.899V18.5a.5.5 0 0 0 .5.5h3.601l2.546 2.546a.5.5 0 0 0 .707 0L14.899 19H18.5a.5.5 0 0 0 .5-.5v-3.601l2.546-2.546a.5.5 0 0 0 0-.707zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$44f76b459b657e99(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.001h-2V8h-1V4.999a2.92 2.92 0 0 0-.874-2.108 2.943 2.943 0 0 0-2.39-.879C10.202 2.144 9 3.508 9 5.117V8H6c-1.103 0-2 .897-2 2v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10.001c0-1.103-.897-2-2-2zM6 12v-2h5V5.117c0-.57.407-1.07 1.002-1.117.266 0 .512.103.712.307a.956.956 0 0 1 .286.692V10h.995l.005.001h4V12H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f105102c43c73e69(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.207 11.278-2.035-2.035-1.415-1.415-5.035-5.035a.999.999 0 0 0-1.414 0L6.151 7.949 4.736 9.363a2.985 2.985 0 0 0-.878 2.122c0 .802.313 1.556.879 2.121l.707.707-2.122 2.122a2.925 2.925 0 0 0-.873 2.108 2.968 2.968 0 0 0 1.063 2.308 2.92 2.92 0 0 0 1.886.681c.834 0 1.654-.341 2.25-.937l2.039-2.039.707.706c1.133 1.133 3.107 1.134 4.242.001l.708-.707.569-.569.138-.138 5.156-5.157a.999.999 0 0 0 0-1.414zm-7.277 5.865-.708.706a1.021 1.021 0 0 1-1.414 0l-1.414-1.413a.999.999 0 0 0-1.414 0l-2.746 2.745a1.192 1.192 0 0 1-.836.352.914.914 0 0 1-.595-.208.981.981 0 0 1-.354-.782.955.955 0 0 1 .287-.692l2.829-2.829a.999.999 0 0 0 0-1.414l-1.414-1.415c-.189-.188-.293-.438-.293-.706s.104-.519.293-.708l.707-.707 3.536 3.536 3.536 3.535z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$65cd2967230faf8e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 5.414 1.707-1.707-1.414-1.414-1.563 1.562C15.483 2.708 13.824 2 12 2s-3.483.708-4.73 1.855L5.707 2.293 4.293 3.707 6 5.414A6.937 6.937 0 0 0 5 9H3v2h2v2H3v2h2c0 3.86 3.141 7 7 7s7-3.14 7-7h2v-2h-2v-2h2V9h-2a6.937 6.937 0 0 0-1-3.586zM15 15H9v-2h6v2zm0-4H9V9h6v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8b4eee823158fb5f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.787 7h10.426c-.108-.158-.201-.331-.318-.481l2.813-2.812-1.414-1.414-2.846 2.846a6.575 6.575 0 0 0-.723-.454 5.778 5.778 0 0 0-5.45 0c-.25.132-.488.287-.722.453L5.707 2.293 4.293 3.707l2.813 2.812c-.118.151-.21.323-.319.481zM5.756 9H2v2h2.307c-.065.495-.107.997-.107 1.5 0 .507.042 1.013.107 1.511H2v2h2.753c.013.039.021.08.034.118.188.555.421 1.093.695 1.6.044.081.095.155.141.234l-2.33 2.33 1.414 1.414 2.11-2.111a7.477 7.477 0 0 0 2.068 1.619c.479.253.982.449 1.496.58.204.052.411.085.618.118V16h2v5.914a6.23 6.23 0 0 0 .618-.118 6.812 6.812 0 0 0 1.496-.58c.465-.246.914-.55 1.333-.904.258-.218.5-.462.734-.716l2.111 2.111 1.414-1.414-2.33-2.33c.047-.08.098-.155.142-.236.273-.505.507-1.043.694-1.599.013-.039.021-.079.034-.118H22v-2h-2.308c.065-.499.107-1.004.107-1.511 0-.503-.042-1.005-.106-1.5H22V9H5.756z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6526e65f04dfcd25(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.991 2H9.01C7.899 2 7 2.899 7 4.01v5.637l-4.702 4.642A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4.009C21 2.899 20.102 2 18.991 2zm-8.069 13.111V20H5v-5.568l2.987-2.949 2.935 3.003v.625zM13 9h-2V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cb73e9468dc0d1e9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2zm-6 14H8v-2h3v2zm0-4H8v-2h3v2zm0-4H8V6h3v2zm5 8h-3v-2h3v2zm0-4h-3v-2h3v2zm0-4h-3V6h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7957376d87c83510(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14.001h2v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-8a2 2 0 0 0-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2zM5 20v-8h6v8H5zm9-12h-2V6h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V6h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$50884fbd2ad67ad3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921h-.792v2h8.032v-2h-.79c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$59128cf897ee6c30(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 17c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 7c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8fc135796c2cb11e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.736 8h-3.16A5.02 5.02 0 0 0 14 7.424V4.263A8.015 8.015 0 0 1 19.736 10zM12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 4.263v3.161A5.02 5.02 0 0 0 7.424 10h-3.16A8.015 8.015 0 0 1 10 4.263zM4.264 14h3.16A5.02 5.02 0 0 0 10 16.576v3.161A8.015 8.015 0 0 1 4.264 14zM14 19.737v-3.161A5.02 5.02 0 0 0 16.576 14h3.16A8.015 8.015 0 0 1 14 19.737z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a06532b8709a2f8c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.597V11h1V8h-1V6c0-2.206-1.794-4-4-4H7C4.794 2 3 3.794 3 6v2H2v3h1v.597a3.97 3.97 0 0 0-.999 2.648l.004 3.758c.001.733.404 1.369.995 1.716V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.274a2.02 2.02 0 0 0 .421-.313c.377-.378.585-.881.584-1.415l-.004-3.759A3.965 3.965 0 0 0 21 11.597zM8 4h8v2H8V4zM6.5 17a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 17zm4.5-5H5V8h6v4zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 17zm1.5-5h-6V8h6v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ba6492651ffafb9d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.021c.003-.146-.007-1.465-1.3-2.735C18.427 2.036 17.143 2 17 2H6.996c-.239 0-1.493.063-2.708 1.302C3.036 4.578 3 5.859 3 6v3H2v3h1v6c0 .734.406 1.373 1 1.721V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 21 18v-6h1V9h-1V6.021zM9 4h6v2H9V4zM6.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 18zm4.5-5H5V8h6v5zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 18zm1.5-5h-6V8h6v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7850afcb00bdcdc0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-6a1 1 0 0 0-1 1v3h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM8 6h2v2H8V6zM6 16H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V6h2v2zm4 8H8v-2h2v2zm0-4H8v-2h2v2zm9 4h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$55b218fca60fe109(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v7h18V4zm-5 4H8V5h2v1h4V5h2v3zM5 22h14c1.103 0 2-.897 2-2v-7H3v7c0 1.103.897 2 2 2zm3-6h2v1h4v-1h2v3H8v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2cc8d9f9c97a9f8c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9.76 9-2.45V10H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-4V6.76l9-2.45V2.24L2 7.69zM11 12v3H7v-3zm6 0v3h-4v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$26ed1de8b1af4180(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.997 15c-1.601 0-2.446-.676-3.125-1.219-.567-.453-.977-.781-1.878-.781-.898 0-1.287.311-1.874.78-.679.544-1.524 1.22-3.125 1.22s-2.444-.676-3.123-1.22C3.285 13.311 2.897 13 2 13v5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-5c-.899 0-1.288.311-1.876.781-.68.543-1.525 1.219-3.127 1.219zM19 5h-6V2h-2v3H5C3.346 5 2 6.346 2 8v3c1.6 0 2.443.676 3.122 1.22.587.469.975.78 1.873.78.899 0 1.287-.311 1.875-.781.679-.543 1.524-1.219 3.124-1.219 1.602 0 2.447.676 3.127 1.219.588.47.977.781 1.876.781.9 0 1.311-.328 1.878-.781C19.554 11.676 20.399 11 22 11V8c0-1.654-1.346-3-3-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$489e1bd2395a7345(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm3-3H7v-2h2v2zm0-4H7v-2h2v2zm0-4H7V9h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm4 8h-2v-6h2v6zm0-8h-2V9h2v2zM6 4h12v3H6V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e05cf576aa38ab85(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$32a68c61c66ddac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm6-3.586-3.707-3.707 1.414-1.414L11 15.586l4.293-4.293 1.414 1.414L11 18.414zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1577d68784e8864c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm4.799-2.013H8v-1.799l4.977-4.97 1.799 1.799-4.977 4.97zm5.824-5.817-1.799-1.799L15.196 11l1.799 1.799-1.372 1.371zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eed40fa3d9d78ff9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-1 15h-6v-6h6v6zm1-10H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b54b1744607ee4e5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-6 16h-2v-2h2v2zm0-4h-2v-5h2v5zm6-7H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$780255bd91d8e24b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-3.648 11.711L12.002 19l-3.349-3.289a2.129 2.129 0 0 1 0-3.069 2.224 2.224 0 0 1 3.125 0l.224.219.224-.219a2.225 2.225 0 0 1 3.126 0 2.129 2.129 0 0 1 0 3.069zM19 9H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9b3ff237e3c07eed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm11-6H8v-2h8v2zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c0ba74100f73a125(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm11-6h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e7258b07c5939187(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-4.588 15-2.449-1.288L9.514 19l.468-2.728L8 14.342l2.738-.398 1.225-2.48 1.225 2.48 2.738.398-1.981 1.931.467 2.727zM19 9H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f7321010597771a7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-2 8v2H7v-3h10v1zm2-3H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a37d9d9a65d1d137(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm10.707-4.707-1.414 1.414L12 16.414l-2.293 2.293-1.414-1.414L10.586 15l-2.293-2.293 1.414-1.414L12 13.586l2.293-2.293 1.414 1.414L13.414 15l2.293 2.293zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$870daab4e0ab865e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2zM9 18H7v-2h2v2zm0-4H7v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm2-5H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d324159d42d501d5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.125 2H5.875A1.877 1.877 0 0 0 4 3.875v12.25C4 17.159 4.841 18 5.875 18H11v2H7v2h10v-2h-4v-2h5.125A1.877 1.877 0 0 0 20 16.125V3.875A1.877 1.877 0 0 0 18.125 2zM12 15c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$86517e2013a14559(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c0-.959-.68-1.761-1.581-1.954C16.779 8.445 17 7.75 17 7c0-2.206-1.794-4-4-4-1.516 0-2.822.857-3.5 2.104C8.822 3.857 7.516 3 6 3 3.794 3 2 4.794 2 7c0 .902.312 1.726.817 2.396A1.993 1.993 0 0 0 2 11v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-2.637l4 2v-7l-4 2V11zm-5-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM6 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f1ddb4a162d55c5c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h11.879l-3.083-3.083A4.774 4.774 0 0 1 12 17c-2.71 0-5-2.29-5-5 0-.271.039-.535.083-.796L2.144 6.265C2.054 6.493 2 6.74 2 7v11c0 1.103.897 2 2 2zM20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5h-.172L3.707 2.293 2.293 3.707l18 18 1.414-1.414-.626-.626A1.98 1.98 0 0 0 22 18V7c0-1.103-.897-2-2-2zm-5.312 8.274A2.86 2.86 0 0 0 15 12c0-1.626-1.374-3-3-3-.456 0-.884.12-1.274.312l-1.46-1.46A4.88 4.88 0 0 1 12 7c2.71 0 5 2.29 5 5a4.88 4.88 0 0 1-.852 2.734l-1.46-1.46z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ea8859dce1a722c4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-8 12c-2.71 0-5-2.29-5-5 0-2.711 2.29-5 5-5s5 2.289 5 5c0 2.71-2.29 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v2H9v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e495107577593394(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.626 0-3 1.374-3 3s1.374 3 3 3 3-1.374 3-3-1.374-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-8 12c-2.71 0-5-2.29-5-5s2.29-5 5-5 5 2.29 5 5-2.29 5-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2de0288d585276fe(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072 4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072 4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892-4.242-4.244 2.892-2.891z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3a9b3e10c8c3c1e0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-9 6H8v4h3v2H8c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2zm7 0h-3v4h3v2h-3c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$592ddeefabe56(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM9 14H4v-2h5v2zm11 0h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2zM4 3h4v2H4zm12 0h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a8edb0fa8a7d3a35(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.634 17.918a1.765 1.765 0 0 0 1.201 1.291l.18.791H4v2h16v-2H6.683a.84.84 0 0 0-.007-.278l-.196-.863 10.357-2.356.196.863a.886.886 0 0 0 1.06.667l.863-.197a.885.885 0 0 0 .667-1.06l-.251-1.103c.446-.416.67-1.046.525-1.683l-.59-2.59a1.76 1.76 0 0 0-1.262-1.307l-2.049-3.378a2.774 2.774 0 0 0-2.982-1.263l-7.868 1.79a2.769 2.769 0 0 0-2.144 2.43l-.387 3.932a1.76 1.76 0 0 0-.57 1.724l.589 2.59zm3.02-.688a1.327 1.327 0 1 1-.59-2.589 1.327 1.327 0 0 1 .59 2.589zm11.222-2.552a1.328 1.328 0 1 1-.59-2.587 1.328 1.328 0 0 1 .59 2.587zM5.589 9.192l7.869-1.791a.773.773 0 0 1 .83.351l1.585 2.613-.566.129-10.046 2.287-.568.129.299-3.042a.772.772 0 0 1 .597-.676zM18.405 4 17 2l-.5 3L19 9l3 1-2-2.539 2-.933-2-.933L22 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d3512d106c383cc8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845l-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.388V5.279l-9.684-3.228a.996.996 0 0 0-.658.009L2 5.572V7.7l10.015-3.642L22 7.388z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d26dfbab36f7f8e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 13.155-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM5.277 5c.347.595.985 1 1.723 1s1.376-.405 1.723-1h6.555c.346.595.984 1 1.722 1s1.376-.405 1.723-1H17V3h1.723c-.347-.595-.985-1-1.723-1s-1.376.405-1.723 1H8.723C8.376 2.405 7.738 2 7 2s-1.376.405-1.723 1H7v2H5.277z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3b0e48a922ecdcad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 13.155-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM9 4.378c.005-1.088-1.037-2.051-1.387-2.344a.176.176 0 0 0-.228 0C7.033 2.325 5.995 3.271 6 4.377 6 5.272 6.673 6 7.5 6S9 5.272 9 4.378zm4.5 0c.005-1.088-1.037-2.052-1.387-2.344a.176.176 0 0 0-.228 0c-.353.291-1.391 1.238-1.386 2.344C10.5 5.272 11.173 6 12 6s1.5-.728 1.5-1.622zm4.5 0c.005-1.088-1.037-2.052-1.387-2.344a.176.176 0 0 0-.228 0c-.352.291-1.39 1.237-1.385 2.343C15 5.272 15.673 6 16.5 6S18 5.272 18 4.378z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e2fb74403c44079d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.155-1.368-4.104A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3decec7c3091b554(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a0df58f495d2ee4c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2zm0 14-5-6h10l-5 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$64789445a32ed9cb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm12-11-5 6-5-6h10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c25caf8916037a42(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm2 15-6-5 6-5v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$da5a37a3849f0197(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm9-14v10l-6-5 6-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6f7e66dca7a4d610(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zM10 7l6 5-6 5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c5b94e36b7da58d4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm5-14 6 5-6 5V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d7e35e5914a6f0d5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.485 2 2 6.486 2 12s4.485 10 10 10c5.514 0 10-4.486 10-10S17.514 2 12 2zM7 14l5-6 5 6H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5b4e23453cdea4c2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm7-13 5 6H7l5-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e33db3808b6d74a7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H8c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM2 7v10c0 1.103.897 2 2 2V5c-1.103 0-2 .897-2 2zm18-2v14c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7dc9a397eb22d7da(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7H7.334L6.18 4.23A1.995 1.995 0 0 0 4.333 3H2v2h2.334l4.743 11.385c.155.372.52.615.923.615h8c.417 0 .79-.259.937-.648l3-8A1.003 1.003 0 0 0 21 7zm-4 6h-2v2h-2v-2h-2v-2h2V9h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1443a94a0cf77182(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H2v2h2.3l3.521 9.683A2.004 2.004 0 0 0 9.7 17H18v-2H9.7l-.728-2H18c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2a224e9b91490c00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7H7.334L6.18 4.23A1.995 1.995 0 0 0 4.333 3H2v2h2.334l4.743 11.385c.155.372.52.615.923.615h8c.417 0 .79-.259.937-.648l3-8A1.003 1.003 0 0 0 21 7zm-7 8-3-3h2V9h2v3h2l-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e6130142ce65dd8e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$425e5911e4dfdf96(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11h-2V6h1V2h-2v2h-1V2h-2v2h-1V2h-2v2h-1V2H8v2H7V2H5v4h1v5H4V9H2v12h7v-5a3 3 0 0 1 6 0v5h7V9h-2zm-10-1H8V7h2zm6 0h-2V7h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fce017c91ca06e9a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14a5 5 0 0 0 2.71-.81L20 13a3.16 3.16 0 0 0 .45-.37l.21-.2a4.48 4.48 0 0 0 .48-.58l.06-.08a4.28 4.28 0 0 0 .41-.76 1.57 1.57 0 0 0 .09-.23 4.21 4.21 0 0 0 .2-.63l.06-.25A5.5 5.5 0 0 0 22 9V2l-3 3h-4l-3-3v7a5 5 0 0 0 5 5zm2-7a1 1 0 1 1-1 1 1 1 0 0 1 1-1zm-4 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 22v-5H8v5H5V11.9a3.49 3.49 0 0 1-2.48-1.64A3.59 3.59 0 0 1 2 8.5 3.65 3.65 0 0 1 6 5a1.89 1.89 0 0 0 2-2 1 1 0 0 1 1-1 1 1 0 0 1 1 1 3.89 3.89 0 0 1-4 4C4.19 7 4 8.16 4 8.51S4.18 10 6 10h5.09A6 6 0 0 0 19 14.65V22h-3v-5h-2v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fb69a91761edd1c3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 10h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cb47d97586e4fcb8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM4 21h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm13 0c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d67623360fbb3bd0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.618 7.462 6.403 2.085a1.007 1.007 0 0 0-.77-.016 1.002 1.002 0 0 0-.552.537l-3 7a1 1 0 0 0 .525 1.313L9.563 13.9 8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054 3.419 1.465a1 1 0 0 0 1.311-.518l3-6.857a1 1 0 0 0-.513-1.316zm1.312 8.91-1.858-.742 1.998-5 1.858.741z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2ce2b2493b4e27ee(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.047 14.667a.992.992 0 0 0 .466.607l1.909 1.104v2.199a1 1 0 0 0 1 1h2.199l1.104 1.91a1.002 1.002 0 0 0 1.366.366L12 20.75l1.91 1.104a1.002 1.002 0 0 0 1.366-.366l1.103-1.909h2.199a1 1 0 0 0 1-1V16.38l1.909-1.104a.999.999 0 0 0 .366-1.366L20.75 12l1.104-1.909a1 1 0 0 0-.366-1.366l-1.909-1.104V5.422a1 1 0 0 0-1-1H16.38l-1.103-1.909a1.004 1.004 0 0 0-.607-.466.994.994 0 0 0-.759.1L12 3.25l-1.909-1.104a.998.998 0 0 0-1.366.365l-1.104 1.91H5.422a1 1 0 0 0-1 1V7.62L2.513 8.725a1.001 1.001 0 0 0-.365 1.366L3.251 12l-1.104 1.909a1.003 1.003 0 0 0-.1.758z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b73afce833cdf4cb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 13h4v2H5v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ccc740ebd522105(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14zM9.553 9.658l4 2 1.553-3.105 1.789.895-2.447 4.895-4-2-1.553 3.105-1.789-.895 2.447-4.895z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f678dd1188dd8e19(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h2v4.081L11.101 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$43091f1f869fbf38(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.999 14.413-3.713-3.705L7.7 11.292l2.299 2.295 5.294-5.294 1.414 1.414-6.706 6.706z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6d9d40b1b3e33ce9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.488 21.754c.294.157.663.156.957-.001 8.012-4.304 8.581-12.713 8.574-15.104a.988.988 0 0 0-.596-.903l-8.05-3.566a1.005 1.005 0 0 0-.813.001L3.566 5.747a.99.99 0 0 0-.592.892c-.034 2.379.445 10.806 8.514 15.115zM8.674 10.293l2.293 2.293 4.293-4.293 1.414 1.414-5.707 5.707-3.707-3.707 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$238aa1685fac0a6b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-7.933 13.481-3.774-3.774 1.414-1.414 2.226 2.226 4.299-5.159 1.537 1.28-5.702 6.841z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5683caf72c39b122(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7zm4 10.414-2.707-2.707 1.414-1.414L11 12.586l3.793-3.793 1.414 1.414L11 15.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4704017a9841f639(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-1 8H8v-2h8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$12d24a6ce047807d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$46356714b89237c5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.16 2a1 1 0 0 0-.66.13l-12 7a.64.64 0 0 0-.13.1l-.1.08a1.17 1.17 0 0 0-.17.26.84.84 0 0 0-.1.43v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V10a8.08 8.08 0 0 0-6.84-8zm0 2.05A6.07 6.07 0 0 1 19.93 9H6.7zM6.5 18A1.5 1.5 0 1 1 8 16.5 1.5 1.5 0 0 1 6.5 18zm5-3a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm5.5 3a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e28c3eebc35ede26(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 6h-4v4h4v4h-4v4h-4v-4H8v4H4v-4h4v-4H4V8h4V4h4v4h4V4h4v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h4v4H8zm4 4h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$41720ee56bc76afc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 14.414-5.707-5.707 1.414-1.414L12 13.586l4.293-4.293 1.414 1.414L12 16.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8c06e4a83697c035(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM7.707 9.293 12 13.586l4.293-4.293 1.414 1.414L12 16.414l-5.707-5.707 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$90b6614c4f3b1ab3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 7.939 12 12.879l-4.939-4.94-2.122 2.122L12 17.121l7.061-7.06z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8149e63ecc6c1a29(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm2.707 14.293-1.414 1.414L7.586 12l5.707-5.707 1.414 1.414L10.414 12l4.293 4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f02c49019b62d407(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5zm9.707 13.293-1.414 1.414L7.586 12l5.707-5.707 1.414 1.414L10.414 12l4.293 4.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ac1fc41928890673(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.939 4.939 6.879 12l7.06 7.061 2.122-2.122L11.121 12l4.94-4.939z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6a89064f8b5be341(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.293 15.707-1.414-1.414L13.586 12 9.293 7.707l1.414-1.414L16.414 12l-5.707 5.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2a9954c322c512e3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm6.293 2.707 1.414-1.414L16.414 12l-5.707 5.707-1.414-1.414L13.586 12 9.293 7.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$658729f7539b3b6f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.061 19.061 17.121 12l-7.06-7.061-2.122 2.122L12.879 12l-4.94 4.939z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6b1128169b8dd6d5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.293 12.707L12 10.414l-4.293 4.293-1.414-1.414L12 7.586l5.707 5.707-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6ab24fa868b69fc8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm7-13.414 5.707 5.707-1.414 1.414L12 10.414l-4.293 4.293-1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1c5687c788472316(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6.879-7.061 7.06 2.122 2.122L12 11.121l4.939 4.94 2.122-2.122z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$22d6f91ace84ab93(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 10.939 12 15.879l-4.939-4.94-2.122 2.122L12 20.121l7.061-7.06z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 3.939 12 8.879l-4.939-4.94-2.122 2.122L12 13.121l7.061-7.06z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$58844571d5a63747(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.121 12 4.94-4.939-2.122-2.122L3.879 12l7.06 7.061 2.122-2.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.939 4.939 10.879 12l7.06 7.061 2.122-2.122L15.121 12l4.94-4.939z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$df28e06f837e0ab8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.061 4.939-2.122 2.122L15.879 12l-4.94 4.939 2.122 2.122L20.121 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.061 19.061 13.121 12l-7.06-7.061-2.122 2.122L8.879 12l-4.94 4.939z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3581f01a6c64350c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 3.879-7.061 7.06 2.122 2.122L12 8.121l4.939 4.94 2.122-2.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.939 17.939 2.122 2.122L12 15.121l4.939 4.94 2.122-2.122L12 10.879z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$df6f809c754315d5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a2 2 0 0 0-2-2h-1V2h-2v3h-4V2H8v3H7a2 2 0 0 0-2 2v1H2v2h3v4H2v2h3v1a2 2 0 0 0 2 2h1v3h2v-3h4v3h2v-3h1a2 2 0 0 0 2-2v-1h3v-2h-3v-4h3V8h-3V7zm-4 8H9V9h6v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e33239745a9fb010(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22v-4a2 2 0 0 1 4 0v4h4V12a1 1 0 0 0-.485-.857L13 8.434V6h2V4h-2V2h-2v2H9v2h2v2.434l-4.515 2.709A1 1 0 0 0 6 12v10h4zm-7 0h2v-8.118l-2.447 1.224A.998.998 0 0 0 2 16v5a1 1 0 0 0 1 1zm18.447-6.895L19 13.882V22h2a1 1 0 0 0 1-1v-5c0-.379-.214-.725-.553-.895z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$501061bf9d138626(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v20h1a10 10 0 0 0 0-20z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1d379a90db57c85d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v11h11v-1A10 10 0 0 0 12 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97cde512adfb269(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v9H2v1a10 10 0 0 0 17.07 7.07A10 10 0 0 0 12 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cd16d96874119c0e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e7fc8c4b3766b69e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-4V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM6 18H4v-2h2v2zm0-4H4v-2h2v2zm5 4H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V8h2v2zm0-4H9V4h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2zm0-4h-2V4h2v2zm5 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6748b4be9580a35d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669zM16 15h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a8b2f23b805f4850(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.61 5.757 9.149 3.609 9.792 2 11.82 2 14c0 2.657 2.089 4.815 4.708 4.971V19H17.99v-.003L18 19c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888zM8 12h3V9h2v3h3l-4 5-4-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b8c428e19d910d1d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.82 2 13c0 2.757 2.243 5 5 5h1.333L10 13h4l-2 3h2.975l-1.325 2H18c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM11 18H8.333L8 19h3v3l2.649-4H11.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2884ffd3046eba7a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.82 2 13c0 2.757 2.243 5 5 5h1v3h2v-3h4v3h2v-3h2c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$860dd9c1c4bc335f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM13 14v3h-2v-3H8l4-5 4 5h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ef88809ebb1e84d1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d427f72a4e9e06d8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-1V4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a4 4 0 0 0 4 4h6c1.858 0 3.411-1.279 3.858-3H19a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zm1 6a1 1 0 0 1-1 1h-1V7h1a1 1 0 0 1 1 1v3zm-2 8H3c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a53a2519ee18e524(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18a6.06 6.06 0 0 0 5.17-6 7.62 7.62 0 0 1 6.52-7.51l2.59-.37c-.07-.08-.13-.16-.21-.24-3.26-3.26-9.52-2.28-14 2.18C2.28 9.9 1 15 2.76 18.46z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.73 12a7.63 7.63 0 0 1-6.51 7.52l-2.46.35.15.17c3.26 3.26 9.52 2.29 14-2.17C21.68 14.11 23 9 21.25 5.59l-3.34.48A6.05 6.05 0 0 0 12.73 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b6daf3df45314401(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.5 5-1.224-2.447A1 1 0 0 0 16.382 2H7.618a1 1 0 0 0-.894.553L5.5 5H3v2h18V5h-2.5zM6.734 21.142c.071.492.493.858.991.858h8.551a1 1 0 0 0 .99-.858L19 9H5l1.734 12.142zM16 12l-.714 5H8.714L8 12h8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$948aeae0a68d589f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v3H5zm4 0h2v3H9zm4 0h2v3h-2zm6 7h-2V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h2c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-2 7v-5h2l.002 5H17z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$38d9f58ed796bae5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.344 15.271 2 3.46a1 1 0 0 0 1.366.365l1.396-.806c.58.457 1.221.832 1.895 1.112V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.598a8.094 8.094 0 0 0 1.895-1.112l1.396.806c.477.275 1.091.11 1.366-.365l2-3.46a1.004 1.004 0 0 0-.365-1.366l-1.372-.793a7.683 7.683 0 0 0-.002-2.224l1.372-.793c.476-.275.641-.89.365-1.366l-2-3.46a1 1 0 0 0-1.366-.365l-1.396.806A8.034 8.034 0 0 0 15 4.598V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.598A8.094 8.094 0 0 0 7.105 5.71L5.71 4.904a.999.999 0 0 0-1.366.365l-2 3.46a1.004 1.004 0 0 0 .365 1.366l1.372.793a7.683 7.683 0 0 0 0 2.224l-1.372.793c-.476.275-.641.89-.365 1.366zM12 8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$42b4772163af801b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c3.976 0 8-1.374 8-4s-4.024-4-8-4-8 1.374-8 4 4.024 4 8 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0 2.626 4.024 4 8 4s8-1.374 8-4V8c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14c0 2.626 4.024 4 8 4s8-1.374 8-4v-2c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18c0 2.626 4.024 4 8 4s8-1.374 8-4v-2c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8ee7196da5cf19b7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C7.031 5 2 6.546 2 9.5S7.031 14 12 14c4.97 0 10-1.546 10-4.5S16.97 5 12 5zm-5 9.938v3c1.237.299 2.605.482 4 .541v-3a21.166 21.166 0 0 1-4-.541zm6 .54v3a20.994 20.994 0 0 0 4-.541v-3a20.994 20.994 0 0 1-4 .541zm6-1.181v3c1.801-.755 3-1.857 3-3.297v-3c0 1.44-1.199 2.542-3 3.297zm-14 3v-3C3.2 13.542 2 12.439 2 11v3c0 1.439 1.2 2.542 3 3.297z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b0168961e21d9d1e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H5c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2zM5 6h14v2H5zm2-4h10v2H7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3b888eabc3588227(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14c-.092.064-2 2.083-2 3.5 0 1.494.949 2.448 2 2.5.906.044 2-.891 2-2.5 0-1.5-1.908-3.436-2-3.5zM9.586 20c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l7-7-.707-.707L11 4.586 8.707 2.293 7.293 3.707 9.586 6 4 11.586c-.378.378-.586.88-.586 1.414s.208 1.036.586 1.414L9.586 20zM11 7.414 16.586 13H5.414L11 7.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eda80101b5e0dbe1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.08 11.25A4.84 4.84 0 0 1 8 9.05L4.43 5.49A9.88 9.88 0 0 0 2 11.25zM9.05 8a4.84 4.84 0 0 1 2.2-.91V2a9.88 9.88 0 0 0-5.76 2.43zm3.7-6v5A4.84 4.84 0 0 1 15 8l3.56-3.56A9.88 9.88 0 0 0 12.75 2zM8 15a4.84 4.84 0 0 1-.91-2.2H2a9.88 9.88 0 0 0 2.39 5.76zm3.25 1.92a4.84 4.84 0 0 1-2.2-.92l-3.56 3.57A9.88 9.88 0 0 0 11.25 22zM16 9.05a4.84 4.84 0 0 1 .91 2.2h5a9.88 9.88 0 0 0-2.39-5.76zM15 16a4.84 4.84 0 0 1-2.2.91v5a9.88 9.88 0 0 0 5.76-2.39zm1.92-3.25A4.84 4.84 0 0 1 16 15l3.56 3.56A9.88 9.88 0 0 0 22 12.75z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ef7bb14cc17e2956(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-3 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ec8c8b8e7bdab32b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-9 11.914-3.707-3.707 1.414-1.414L11 11.086l4.793-4.793 1.414 1.414L11 13.914z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e952b7ff5ce15cd3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1.999H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2v-12c0-1.103-.897-2-2-2zm-6 11H7v-2h7v2zm3-4H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b976aa2d3976cf46(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM9 12a2 2 0 1 1 .001-4.001A2 2 0 0 1 9 12zm6 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 15 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ef31c3beb8ff6c96(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8.999 14.987H7v-1.999l5.53-5.522 1.998 1.999-5.529 5.522zm6.472-6.464-1.999-1.999 1.524-1.523L16.995 7l-1.524 1.523z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eebd8de51b809319(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-7 13h-2v-2h2v2zm0-4h-2V5h2v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$375fc326f4f96404(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-4 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$899e6e2d70dd774(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-3.294 11.543-1.414 1.414-3.293-3.292-3.292 3.292-1.414-1.414 3.292-3.292-3.292-3.293 1.414-1.414 3.292 3.292 3.293-3.292 1.414 1.414-3.292 3.293 3.292 3.292z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cf3ce140938efe47(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ce69d9ac709711ec(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3 13-8 2 2-8 8-2-2 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1b60305c851f2137(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.553 18.895 4 2a1.001 1.001 0 0 0 .894 0L12 19.118l3.553 1.776a.99.99 0 0 0 .894.001l4-2c.339-.17.553-.516.553-.895v-5c0-.379-.214-.725-.553-.895L17 10.382V6c0-.379-.214-.725-.553-.895l-4-2a1 1 0 0 0-.895 0l-4 2C7.214 5.275 7 5.621 7 6v4.382l-3.447 1.724A.998.998 0 0 0 3 13v5c0 .379.214.725.553.895zM8 12.118l2.264 1.132-2.913 1.457-2.264-1.132L8 12.118zm4-2.5 3-1.5v2.264l-3 1.5V9.618zm6.264 3.632-2.882 1.441-2.264-1.132L16 12.118l2.264 1.132zM8 18.882l-.062-.031V16.65L11 15.118v2.264l-3 1.5zm8 0v-2.264l3-1.5v2.264l-3 1.5zM12 5.118l2.264 1.132-2.882 1.441-2.264-1.132L12 5.118z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d021fe1dcd07873d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm1.124 6.492-.248-1.984 8-1 .248 1.984-8 1zm7.369-5.006a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ffcd3c2be17ee7ff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H6a2 2 0 0 0-2 2v3H2v2h2v2H2v2h2v2H2v2h2v3a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-8 2.999c1.648 0 3 1.351 3 3A3.012 3.012 0 0 1 13 11c-1.647 0-3-1.353-3-3.001 0-1.649 1.353-3 3-3zM19 18H7v-.75c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c3dc6fe74843328b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h3.5c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5h-13C2.673 2 2 2.673 2 3.5V18l5.333-4H13zm-9-.1.154-.016L4 14v-.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 8H20v6.001c0 1.1-.893 1.993-1.99 1.999H8v.5c0 .827.673 1.5 1.5 1.5h7.167L22 22V9.5c0-.827-.673-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dd15f9754f2d81d1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.938.005-.034.016-.134.017-.168a.998.998 0 0 0-1.254-1.006A3.002 3.002 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM8.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-2 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm2.5-6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm3.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ec3cccbd6058d79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.095 14.244a5.982 5.982 0 0 1-3.034 1.634 6.05 6.05 0 0 1-2.414 0 5.919 5.919 0 0 1-2.148-.903 6.078 6.078 0 0 1-1.621-1.622l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 1.273.86c.243.102.495.181.749.232a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117c-.215.32-.462.62-.734.891zM19 10a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2h-2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fcb4e44a8bbe5ac2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2zm2-10h6v2H6v-2zm0 4h6v2H6v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ec472062452c0d35(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8bdc1753519f1d49(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 13c.992 0 1.85-.265 2.293-.708l1.414 1.415C14.581 16.832 12.901 17 12 17c-2.757 0-5-2.243-5-5s2.243-5 5-5c.901 0 2.582.168 3.707 1.293l-1.414 1.414C13.851 9.264 12.993 9 12 9c-1.626 0-3 1.374-3 3s1.374 3 3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$35af1f94846e261f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM11 17H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V7h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$16995d17b372799a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7.5 12a2.5 2.5 0 1 1 0-5 2.47 2.47 0 0 1 1.5.512c-.604.456-1 1.173-1 1.988s.396 1.532 1 1.988a2.47 2.47 0 0 1-1.5.512zm4 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8eff5347fafd31d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2zm6 7.5H5v-2h6v2zm8 0h-6v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7c37f53ef2004e70(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v2h20V6c0-1.103-.897-2-2-2zM2 18c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-6H2v6zm3-3h6v2H5v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c2fd368b3b427b78(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.67 16.26.54.53-.62.61a9 9 0 0 0 .84 1.11L18.51 4.42a10.93 10.93 0 0 0-1.1-.83l-.62.61-.53-.53.48-.48A10 10 0 0 0 3.2 16.74zM14.86 5.07l.53.53L14 7l-.53-.53zm-2.79 2.8.52.53-1.39 1.4-.53-.53zm-2.8 2.8.53.53-1.4 1.39-.53-.53zm-2.8 2.79L7 14l-1.4 1.4-.53-.53zm.12 6.95.62-.61.53.53-.48.48A10 10 0 0 0 20.8 7.26l-.47.48-.54-.53.62-.61a9 9 0 0 0-.84-1.11L5.49 19.58a10.93 10.93 0 0 0 1.1.83zM18.4 8.61l.53.53-1.4 1.4L17 10zm-2.8 2.8.53.53-1.4 1.39-.53-.53zm-2.8 2.79.53.53-1.39 1.4-.54-.53zM10 17l.53.53-1.4 1.4-.53-.53z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1c4b02637cc2e8d5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7.5C19 6.121 17.879 5 16.5 5H8V2H5v3H2v3h14v14h3v-3h3v-3h-3V7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10H5v6.5C5 17.879 6.121 19 7.5 19H14v-3H8v-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$393279d734dbfece(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 2-5 5-4-5-4 5-5-5v13h18zM5 21h14a2 2 0 0 0 2-2v-2H3v2a2 2 0 0 0 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$87e5d24d13e69e69(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.895 3.553A1.001 1.001 0 0 0 17 3H7c-.379 0-.725.214-.895.553l-4 8a1 1 0 0 0 0 .895l4 8c.17.338.516.552.895.552h10c.379 0 .725-.214.895-.553l4-8a1 1 0 0 0 0-.895l-4-7.999zM19.382 11h-7.764l-3-6h7.764l3 6zm-3 8H8.618l3-6h7.764l-3 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4acb8b2cfad06436(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.406 6.086-9-4a1.001 1.001 0 0 0-.813 0l-9 4c-.02.009-.034.024-.054.035-.028.014-.058.023-.084.04-.022.015-.039.034-.06.05a.87.87 0 0 0-.19.194c-.02.028-.041.053-.059.081a1.119 1.119 0 0 0-.076.165c-.009.027-.023.052-.031.079A1.013 1.013 0 0 0 2 7v10c0 .396.232.753.594.914l9 4c.13.058.268.086.406.086a.997.997 0 0 0 .402-.096l.004.01 9-4A.999.999 0 0 0 22 17V7a.999.999 0 0 0-.594-.914zM12 4.095 18.538 7 12 9.905l-1.308-.581L5.463 7 12 4.095zm1 15.366V11.65l7-3.111v7.812l-7 3.11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d902507138a90cc7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 0 0 .227 1.066l5 5A.996.996 0 0 0 8 22h8c.414 0 .785-.255.934-.641l5-13a.999.999 0 0 0-.227-1.066l-5-5zM18.585 7h-5.171l-3-3h5.172l2.999 3zm-3.272 13h-6.23l4.583-11h5.878l-4.231 11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$62f7de1b52ef0a08(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 0h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM10 13H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm8 1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$298b4675faa1a4db(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.131 0 9-1.935 9-4.5V7c0-.051-.024-.097-.033-.146.016-.117.033-.234.033-.354C21 3.935 17.131 2 12 2S3 3.935 3 6.5v11c0 2.565 3.869 4.5 9 4.5zm0-18c4.273 0 7 1.48 7 2.5a.683.683 0 0 1-.025.158c-.004.01-.012.018-.015.027-.274.848-2.29 1.98-5.496 2.253l-.05.003C12.965 8.979 12.494 9 12 9 7.727 9 5 7.52 5 6.5S7.727 4 12 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$11c659bd4d04c819(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm-1 7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4zm10 0a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7zm1-10h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$588b627663dc43f7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-2.168-3.663-4-8-4S4 3.832 4 6v2c0 2.168 3.663 4 8 4s8-1.832 8-4V6zm-8 13c-4.337 0-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4v-3c0 2.168-3.663 4-8 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 2.168-3.663 4-8 4s-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4v-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca1181e8aa648820(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14H5v-2h6v2zm8-4H5v-2h14v2zm0-4H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fa6e9431701e40e2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H7c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM6 9h4l-.003 9H4V9h2zm6 8V9c0-1.103-.897-2-2-2H7V5h11v12h-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$76d54c3161a3171d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.445 3h-8.89c-.345 0-.666.178-.849.47L3.25 9h17.5l-3.456-5.53a1.003 1.003 0 0 0-.849-.47zM11.26 21.186a1 1 0 0 0 1.48 0L22 11H2l9.26 10.186z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5e973647c9c3be00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-7 10.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3b0f6ff206b11e4b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9.5 13.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 9.5 13.5zm5 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 14.5 13.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca24a68f708d7466(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 9.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 13.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f60423b9d8e9d2d3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm8 8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$26d04c2a4c6903bf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 13.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5d1673a5b269f28e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 13.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm8 8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 13.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c1c5bb10d35b1545(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.294-8.978-9a1.001 1.001 0 0 0-1.415-.002l-9.021 9a1 1 0 0 0 0 1.416l9.021 9c.39.389 1.026.388 1.415-.002l8.978-9a.998.998 0 0 0 0-1.412zM15 16h-2v-4h-3v2l-3-3 3-3v2h5v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3ee54d4a2b89ba7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.295 12.707 8.978 9c.389.39 1.025.391 1.414.002l9.021-9a1 1 0 0 0 0-1.416l-9.021-9a.999.999 0 0 0-1.414.002l-8.978 9a.998.998 0 0 0 0 1.412zm6.707-2.706h5v-2l3 3-3 3v-2h-3v4h-2v-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6d6ed03eefe86010(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-6V8h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5L2 5l3 3h6v3H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v5h2v-5h6l3-3-3-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$664f47d8919b6643(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.998",
                    "cy": "11.998",
                    "r": "2.002"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a6772a06b8a831fa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-.8 6.4 6-8 1.6 1.2-6 8-1.6-1.2zM15 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3d0ebdb23c302a42(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15c0-4.625-3.507-8.441-8-8.941V4h-2v2.059c-4.493.5-8 4.316-8 8.941v2h18v-2zM2 18h20v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8f69231b11a0070c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-1v13h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM4 16h7l-1.122 3.368A2 2 0 0 0 11.775 22H12l5-5.438V3H6l-3.937 8.649-.063.293V14a2 2 0 0 0 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ed135ae5cde8b9c1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8 12.414l-1.293 1.293-1.414-1.414L6.586 11 5.293 9.707l1.414-1.414L8 9.586l1.293-1.293 1.414 1.414L9.414 11l1.293 1.293-1.414 1.414L8 12.414zM14 18h-4v-2h4v2zm4.707-5.707-1.414 1.414L16 12.414l-1.293 1.293-1.414-1.414L14.586 11l-1.293-1.293 1.414-1.414L16 9.586l1.293-1.293 1.414 1.414L17.414 11l1.293 1.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2d3db0114b8cda0b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 5l.001 9H5V5h14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1f8c58469a8a9129(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2zm-11 0V5h9l.002 14H10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ea3421651e7fd2b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5zM5 5h9v14H5V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4758cb52e66c2110(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm2 14v-9h14.001l.001 9H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f0681aed51f19b11(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2l-1.27-1.27A2.49 2.49 0 0 0 16 4h-2.5A2.64 2.64 0 0 0 11 2v6.36a4.38 4.38 0 0 0 1.13 2.72 6.57 6.57 0 0 0 4.13 1.82l3.45-1.38a3 3 0 0 0 1.73-1.84L22 8.15a1.06 1.06 0 0 0 0-.31V7a1 1 0 0 0-1-1zm-5 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 11.74A5.24 5.24 0 0 1 10.07 9H6a1.88 1.88 0 0 1-2-2 1 1 0 0 0-2 0 4.69 4.69 0 0 0 .48 2A3.58 3.58 0 0 0 4 10.53V22h3v-5h6v5h3v-8.13a7.35 7.35 0 0 1-4.62-2.13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2942385bc9827b95(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 14.915V18h-2v-1.08c-2.339-.367-3-2.002-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.324 0-1-2-1-3.48 0-4-1.88-4-3 0-1.288 1.029-2.584 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .516-2 1 0 .374 0 1 2 1 3.48 0 4 1.88 4 3 0 1.288-1.029 2.584-3 2.915z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$276044ace118ff3c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.726 13.02 14 16H9v-1h4.065a.5.5 0 0 0 .416-.777l-.888-1.332A1.995 1.995 0 0 0 10.93 12H3a1 1 0 0 0-1 1v6a2 2 0 0 0 2 2h9.639a3 3 0 0 0 2.258-1.024L22 13l-1.452-.484a2.998 2.998 0 0 0-2.822.504zM15.403 12a3 3 0 0 0 3-3c0-2.708-3-6-3-6s-3 3.271-3 6a3 3 0 0 0 3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4878f60af1508f23(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.726 13.02 14 16H9v-1h4.065a.5.5 0 0 0 .416-.777l-.888-1.332A1.995 1.995 0 0 0 10.93 12H3a1 1 0 0 0-1 1v6a2 2 0 0 0 2 2h9.639a3 3 0 0 0 2.258-1.024L22 13l-1.452-.484a2.998 2.998 0 0 0-2.822.504zm1.532-5.63c.451-.465.73-1.108.73-1.818s-.279-1.353-.73-1.818A2.447 2.447 0 0 0 17.494 3S16.25 2.997 15 4.286C13.75 2.997 12.506 3 12.506 3a2.45 2.45 0 0 0-1.764.753c-.451.466-.73 1.108-.73 1.818s.279 1.354.73 1.818L15 12l4.258-4.61z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$86fb5bb4e5af95e3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5v14a1 1 0 0 0 1 1h3v-2H7V6h2V4H6a1 1 0 0 0-1 1zm14.242-.97-8-2A1 1 0 0 0 10 3v18a.998.998 0 0 0 1.242.97l8-2A1 1 0 0 0 20 19V5a1 1 0 0 0-.758-.97zM15 12.188a1.001 1.001 0 0 1-2 0v-.377a1 1 0 1 1 2 .001v.376z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8539449dd99c647b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6c2.507.423 4.577 2.493 5 5h4c-.471-4.717-4.283-8.529-9-9v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-.478 2.833-2.982 4.949-5.949 4.949-3.309 0-6-2.691-6-6C6.051 8.982 8.167 6.478 11 6V2c-5.046.504-8.949 4.773-8.949 9.949 0 5.514 4.486 10 10 10 5.176 0 9.445-3.903 9.949-8.949h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aa44b0f0dc6aaf96(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h-5V6h-2v6H6l6 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$526f37362725556b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15-5-5h4V7h2v5h4l-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e560f4cd030715a0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14zm-8-9V7h2v5h4l-5 5-5-5h4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3a0cfcbce940dda7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ce55496bf7706648(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 8zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$42659254ba10513f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.901 10.566A1.001 1.001 0 0 0 20 10h-4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v7H4a1.001 1.001 0 0 0-.781 1.625l8 10a1 1 0 0 0 1.562 0l8-10c.24-.301.286-.712.12-1.059z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$15de544109cecf6b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zm-2.7.445-2 3H7.868l-2-3h12.264z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5d7c0405cdbbf74e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.578 2.184a1.004 1.004 0 0 0-1.156 0C11.119 2.398 4 7.513 4 13.75 4 18.53 7.364 22 12 22s8-3.468 8-8.246c0-6.241-7.119-11.356-7.422-11.57zM6 13.75c0-4.283 4.395-8.201 6-9.49V20c-3.533 0-6-2.57-6-6.25z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c17e291df7cf7ea4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6 2.4c-.4-.3-.9-.3-1.2 0C9.5 3.9 4 8.5 4 14c0 4.4 3.6 8 8 8s8-3.6 8-8c0-5.4-5.5-10.1-7.4-11.6"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$67fc7f642d701ae1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1zM18 3.924a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 3.117c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.32 12.265c-.415.384-1.041.964-1.041 2.067 0 1.104.626 1.684 1.041 2.068.352.325.4.398.4.6h2c0-1.104-.626-1.684-1.041-2.068-.352-.325-.4-.398-.4-.6s.048-.275.4-.6c.414-.384 1.041-.964 1.041-2.068 0-1.103-.626-1.683-1.041-2.066-.351-.325-.399-.397-.399-.598h-2c0 1.104.627 1.683 1.042 2.066.351.324.399.396.399.597-.001.203-.05.276-.401.602zm4 0c-.414.384-1.04.964-1.04 2.067s.626 1.684 1.04 2.067c.351.325.399.398.399.601h2c0-1.104-.626-1.684-1.04-2.067-.351-.325-.399-.398-.399-.601s.049-.275.399-.601c.414-.384 1.04-.964 1.04-2.068 0-1.103-.626-1.682-1.04-2.065-.35-.324-.399-.397-.399-.598h-2c0 1.103.626 1.683 1.041 2.066.35.324.398.397.398.598.001.202-.048.275-.399.601z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cba95c150cbf505d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2zm2-9h3v-3h2v3h3v2h-3v3H9v-3H6v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$456b91b1207753aa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9a36c9ac366576f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zM9.799 14.987H8v-1.799l4.977-4.97 1.799 1.799-4.977 4.97zm5.824-5.817-1.799-1.799L15.196 6l1.799 1.799-1.372 1.371z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4f2ce887f97655f8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.988 2.012 3 3L19.701 7.3l-3-3zM8 16h3l7.287-7.287-3-3L8 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .896-2 2v14c0 1.104.897 2 2 2h14a2 2 0 0 0 2-2v-8.668l-2 2V19z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$59d55cc2523217fc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6-6 8h12zM6 16h12v2H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6c19ac77771091bc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.555 8.168-9-6a1 1 0 0 0-1.109 0l-9 6A.995.995 0 0 0 2.004 9H2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9h-.004a.997.997 0 0 0-.441-.832zM20 12.7 12 17l-8-4.3v-2.403l8 4.299 8-4.299V12.7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$96e88edc330fd645(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4.7-8 5.334L4 8.7V6.297l8 5.333 8-5.333V8.7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5d4e34eec1d52c76(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.48 3 7.73 7.75 3 12.59a2 2 0 0 0 0 2.82l4.3 4.3A1 1 0 0 0 8 20h12v-2h-7l7.22-7.22a2 2 0 0 0 0-2.83L15.31 3a2 2 0 0 0-2.83 0zM8.41 18l-4-4 4.75-4.84.74-.75 4.95 4.95-4.56 4.56-.07.08z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1ced68917d686323(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707l-5-5zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$66f976dc6ed59af0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7a5f509db86ed399(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A.999.999 0 0 0 3 21h18a.998.998 0 0 0 .883-1.467L12.884 2.532zM13 18h-2v-2h2v2zm-2-4V9h2l.001 5H11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c285d656bb28027c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.394 3.062c.15.899.769 1.676 1.57 2.111.895.487 1.68.442 2.378.194L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM6 18l1-5H4l5-7-1 5h3l-5 7zm12-8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d745eeb184893474(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.002 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-14c-1.103 0-2 .897-2 2v6.001H10V7l6 5-6 5v-3.999H3.002V19c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f1f9e3f518e4cf9f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v4h1a2 2 0 0 1 0 4H3v4c0 1.103.897 2 2 2h4v-1a2 2 0 0 1 4 0v1h4c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eb879f0aeb4ec5ac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4 15.76-1 4A1 1 0 0 0 3.75 21a1 1 0 0 0 .49 0l4-1a1 1 0 0 0 .47-.26L17 11.41l1.29 1.3 1.42-1.42-1.3-1.29L21 7.41a2 2 0 0 0 0-2.82L19.41 3a2 2 0 0 0-2.82 0L14 5.59l-1.3-1.3-1.42 1.42L12.58 7l-8.29 8.29a1 1 0 0 0-.29.47zm1.87.75L14 8.42 15.58 10l-8.09 8.1-2.12.53z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$44c47f75e0a46f78(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 2.521.945 4.82 2.49 6.582 1.24 1.52 3.266 3.066 6.439 3.358a9.731 9.731 0 0 0 2.141 0c3.174-.292 5.199-1.839 6.439-3.358A9.948 9.948 0 0 0 22 12c0-5.514-4.486-10-10-10zM4.709 8.724c.154.09.308.182.456.276.396.25.791.5 1.286.688.494.187 1.088.312 1.879.312.792 0 1.386-.125 1.881-.313s.891-.437 1.287-.687.792-.5 1.287-.688c.494-.187 1.088-.312 1.88-.312s1.386.125 1.88.313c.495.187.891.437 1.287.687s.792.5 1.287.688c.178.067.374.122.581.171.191.682.3 1.398.3 2.141 0 .843-.133 1.654-.375 2.417-.261.195-.733.474-1.577.756-.769.256-1.672.458-2.685.602a25.337 25.337 0 0 1-6.727 0c-1.013-.144-1.916-.346-2.685-.602-.844-.282-1.316-.561-1.577-.756a7.953 7.953 0 0 1 .335-5.693z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$701dbf70fe42d93b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8 0-1.168.258-2.275.709-3.276.154.09.308.182.456.276.396.25.791.5 1.286.688.494.187 1.088.312 1.879.312.792 0 1.386-.125 1.881-.313s.891-.437 1.287-.687.792-.5 1.287-.688c.494-.187 1.088-.312 1.88-.312s1.386.125 1.88.313c.495.187.891.437 1.287.687s.792.5 1.287.688c.178.067.374.122.581.171.191.682.3 1.398.3 2.141 0 4.411-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e2aab56f193e0369(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10V6l-5 4V6l-5 4V4H2v16h20V6l-5 4zm-8 7H7v-3h2v3zm5 0h-2v-3h2v3zm5 0h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$27fc007e02eded93(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.485 2 2 6.485 2 12s4.485 10 10 10c5.514 0 10-4.485 10-10S17.514 2 12 2zm1 14v-4l-6 4V8l6 4V8l6 4-6 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3e80c4b6b27294ff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6h-3v2H9v2h2v2H9v2h2v8H7v-6h2v-2H7V8h2V6H7V4h2V2H6zm7 2 5 5h-5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h2v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$86041f71f1123a99(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6zm8 7h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d21397dbd14aa532(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.446 17.412c.275 0 .581-.061.762-.132l.138.713c-.168.084-.546.174-1.037.174-1.397 0-2.117-.869-2.117-2.021C7.191 14.768 8.175 14 9.398 14c.474 0 .833.096.995.18l-.186.726a1.98 1.98 0 0 0-.768-.149c-.726 0-1.29.438-1.29 1.337.001.808.482 1.318 1.297 1.318zm2.491.755c-.461 0-.917-.119-1.145-.245l.186-.756c.246.126.624.252 1.014.252.42 0 .642-.174.642-.438 0-.252-.192-.396-.678-.57-.672-.234-1.109-.605-1.109-1.193 0-.689.575-1.217 1.529-1.217.455 0 .791.096 1.031.203l-.204.738a1.919 1.919 0 0 0-.846-.192c-.396 0-.587.181-.587.39 0 .258.228.372.749.57.714.264 1.05.636 1.05 1.205-.001.678-.523 1.253-1.632 1.253zm3.24 0c-.461 0-.917-.119-1.145-.245l.186-.756c.246.126.624.252 1.014.252.42 0 .642-.174.642-.438 0-.252-.192-.396-.678-.57-.672-.234-1.109-.605-1.109-1.193 0-.689.575-1.217 1.529-1.217.455 0 .791.096 1.031.203l-.204.738a1.919 1.919 0 0 0-.846-.192c-.396 0-.587.181-.587.39 0 .258.228.372.749.57.714.264 1.05.636 1.05 1.205 0 .678-.523 1.253-1.632 1.253zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f7c18524539d0fd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.186 14.552c-.617 0-.977.587-.977 1.373 0 .791.371 1.35.983 1.35.617 0 .971-.588.971-1.374 0-.726-.348-1.349-.977-1.349z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.155 17.454c-.426.354-1.073.521-1.864.521-.475 0-.81-.03-1.038-.06v-3.971a8.16 8.16 0 0 1 1.235-.083c.768 0 1.266.138 1.655.432.42.312.684.81.684 1.522 0 .775-.282 1.309-.672 1.639zm2.99.546c-1.2 0-1.901-.906-1.901-2.058 0-1.211.773-2.116 1.967-2.116 1.241 0 1.919.929 1.919 2.045-.001 1.325-.805 2.129-1.985 2.129zm4.655-.762c.275 0 .581-.061.762-.132l.138.713c-.168.084-.546.174-1.037.174-1.397 0-2.117-.869-2.117-2.021 0-1.379.983-2.146 2.207-2.146.474 0 .833.096.995.18l-.186.726a1.979 1.979 0 0 0-.768-.15c-.726 0-1.29.438-1.29 1.338 0 .809.48 1.318 1.296 1.318zM14 9h-1V4l5 5h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.584 14.563c-.203 0-.335.018-.413.036v2.645c.078.018.204.018.317.018.828.006 1.367-.449 1.367-1.415.006-.84-.485-1.284-1.271-1.284z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e16814321f9494df(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22a2 2 0 0 0 2-2v-5l-5 4v-3H8v-2h7v-3l5 4V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$73fd0605dd322f20(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12c.178 0 .348-.03.512-.074l-3.759-3.759A4.966 4.966 0 0 1 12 19c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5a4.964 4.964 0 0 1-.833 2.753l3.759 3.759c.044-.164.074-.334.074-.512V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$87430bd14df28003(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.667 15.772A4.512 4.512 0 0 1 9.984 18c-.737 0-1.271-.186-1.644-.546-.371-.348-.575-.875-.569-1.469.006-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.498-.174-.941-.174-.762 0-1.338.432-1.338 1.308 0 .833.522 1.325 1.271 1.325.21 0 .378-.024.45-.061v-.846h-.624v-.713h1.505v2.13zm1.634.186h-.918v-4.042h.918v4.042zm3.262-3.292h-1.553v.923h1.451v.744h-1.451v1.625h-.918v-4.042h2.471v.75zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ce99a427defb5926(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2 5 5h-5V4zM8.531 18h-.76v-1.411H6.515V18h-.767v-3.373h.767v1.296h1.257v-1.296h.76V18zm3-2.732h-.921V18h-.766v-2.732h-.905v-.641h2.592v.641zM14.818 18l-.05-1.291c-.017-.405-.03-.896-.03-1.387h-.016c-.104.431-.245.911-.375 1.307l-.41 1.316h-.597l-.359-1.307a15.154 15.154 0 0 1-.306-1.316h-.011c-.021.456-.034.976-.059 1.396L12.545 18h-.705l.216-3.373h1.015l.331 1.126c.104.391.21.811.284 1.206h.017c.095-.391.209-.836.32-1.211l.359-1.121h.996L15.563 18h-.745zm3.434 0h-2.108v-3.373h.767v2.732h1.342V18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$82db06834ee72847(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm7-18 5 5h-5V4zm-4.5 7a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 11zm.5 5 1.597 1.363L13 13l4 6H7l2-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5490ff5f34378fde(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4h-7v3l-5-4 5-4v3h7zM13 4l5 5h-5V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$74ca7a7e7f410edb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.239 16.446c0 1.152-.551 1.554-1.438 1.554-.21 0-.486-.036-.665-.097l.101-.737c.127.042.289.072.469.072.384 0 .623-.174.623-.804v-2.543h.911v2.555zm3.294-.365c-.313.293-.773.426-1.313.426-.12 0-.228-.007-.312-.019v1.445h-.906v-3.988a7.528 7.528 0 0 1 1.236-.083c.563 0 .965.107 1.234.323.259.204.433.54.433.936s-.133.732-.372.96zm4.331 1.667c-.28.096-.815.228-1.349.228-.737 0-1.271-.186-1.643-.546-.371-.348-.575-.875-.57-1.469.007-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.497-.174-.941-.174-.761 0-1.338.432-1.338 1.308 0 .833.523 1.325 1.271 1.325.211 0 .378-.024.451-.061v-.846h-.624v-.713h1.504v2.13zM14 9h-1V4l5 5h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.285 14.552c-.186 0-.312.018-.377.036v1.193c.077.018.174.023.307.023.484 0 .784-.246.784-.659 0-.372-.257-.593-.714-.593z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f977ebfae89dd307(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.745 14.186c0 1.345-.644 1.814-1.681 1.814-.245 0-.567-.042-.777-.112l.119-.861c.147.049.336.084.546.084.448 0 .729-.203.729-.938v-2.97h1.064v2.983zm2.043 1.807c-.539 0-1.071-.141-1.337-.287l.217-.883c.287.147.729.294 1.184.294.491 0 .749-.203.749-.511 0-.295-.224-.463-.791-.666-.784-.272-1.295-.707-1.295-1.394 0-.806.672-1.422 1.786-1.422.533 0 .925.112 1.205.238l-.238.861c-.189-.091-.525-.224-.987-.224s-.687.21-.687.455c0 .301.267.435.875.665.834.309 1.226.742 1.226 1.408-.002.793-.61 1.466-1.907 1.466zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f42be1b9c6366f69(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.823 15.122c-.517 0-.816.491-.816 1.146 0 .661.311 1.126.82 1.126.517 0 .812-.49.812-1.146 0-.604-.291-1.126-.816-1.126z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM8.022 16.704c0 .961-.461 1.296-1.2 1.296-.176 0-.406-.029-.557-.08l.086-.615c.104.035.239.06.391.06.319 0 .52-.145.52-.67v-2.122h.761v2.131zm1.459 1.291c-.385 0-.766-.1-.955-.205l.155-.631c.204.105.521.211.846.211.35 0 .534-.146.534-.365 0-.211-.159-.331-.564-.476-.562-.195-.927-.506-.927-.996 0-.576.481-1.017 1.277-1.017.38 0 .659.08.861.171l-.172.615c-.135-.065-.375-.16-.705-.16s-.491.15-.491.325c0 .215.19.311.627.476.596.22.876.53.876 1.006.001.566-.436 1.046-1.362 1.046zm3.306.005c-1.001 0-1.586-.755-1.586-1.716 0-1.012.646-1.768 1.642-1.768 1.035 0 1.601.776 1.601 1.707C14.443 17.33 13.773 18 12.787 18zm4.947-.055h-.802l-.721-1.302a12.64 12.64 0 0 1-.585-1.19l-.016.005c.021.445.031.921.031 1.472v1.016h-.701v-3.373h.891l.701 1.236c.2.354.4.775.552 1.155h.014c-.05-.445-.065-.9-.065-1.406v-.985h.702v3.372zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b89d7e0aa20c5394(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.481 14.015c-.238 0-.393.021-.483.042v3.089c.091.021.237.021.371.021.966.007 1.597-.525 1.597-1.653.007-.981-.568-1.499-1.485-1.499z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.934 15.951-.07-1.807a53.142 53.142 0 0 1-.042-1.94h-.021a26.098 26.098 0 0 1-.525 1.828l-.574 1.842H9l-.504-1.828a21.996 21.996 0 0 1-.428-1.842h-.013c-.028.638-.049 1.366-.084 1.954l-.084 1.793h-.988L7.2 13.23h1.422l.462 1.576c.147.546.295 1.135.399 1.688h.021a39.87 39.87 0 0 1 .448-1.694l.504-1.569h1.394l.26 4.721h-1.044zm5.25-.56c-.498.413-1.253.609-2.178.609a9.27 9.27 0 0 1-1.212-.07v-4.636a9.535 9.535 0 0 1 1.443-.099c.896 0 1.478.161 1.933.505.49.364.799.945.799 1.778 0 .904-.33 1.528-.785 1.913zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a4e425e409f77704(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.267 14.68c-.184 0-.308.018-.372.036v1.178c.076.018.171.023.302.023.479 0 .774-.242.774-.651 0-.366-.254-.586-.704-.586zm3.487.012c-.2 0-.33.018-.407.036v2.61c.077.018.201.018.313.018.817.006 1.349-.444 1.349-1.396.006-.83-.479-1.268-1.255-1.268z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.498 16.19c-.309.29-.765.42-1.296.42a2.23 2.23 0 0 1-.308-.018v1.426H7v-3.936A7.558 7.558 0 0 1 8.219 14c.557 0 .953.106 1.22.319.254.202.426.533.426.923-.001.392-.131.723-.367.948zm3.807 1.355c-.42.349-1.059.515-1.84.515-.468 0-.799-.03-1.024-.06v-3.917A7.947 7.947 0 0 1 11.66 14c.757 0 1.249.136 1.633.426.415.308.675.799.675 1.504 0 .763-.279 1.29-.663 1.615zM17 14.77h-1.532v.911H16.9v.734h-1.432v1.604h-.906V14.03H17v.74zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b0508a2c4cb298ec(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm7-18 5 5h-5V4zM8 14h3v-3h2v3h3v2h-3v3h-2v-3H8v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7247f2596dbfd440(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.782 14.576c-.186 0-.312.018-.377.036v1.193c.077.018.174.023.306.023.485 0 .785-.246.785-.659 0-.371-.258-.593-.714-.593z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.03 16.105c-.313.293-.774.426-1.313.426-.12 0-.229-.007-.312-.019v1.445h-.906V13.97a7.504 7.504 0 0 1 1.235-.083c.563 0 .966.107 1.235.323.258.204.432.54.432.936s-.131.731-.371.959zm4.302 1.853h-.96l-.863-1.56c-.24-.432-.504-.953-.701-1.427l-.019.006c.024.534.036 1.104.036 1.763v1.218h-.84v-4.042h1.067l.84 1.481c.24.426.479.93.659 1.385h.019a14.746 14.746 0 0 1-.078-1.685v-1.182h.84v4.043zm4.169-.186a4.512 4.512 0 0 1-1.349.228c-.737 0-1.271-.186-1.644-.546-.371-.348-.575-.875-.569-1.469.006-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.498-.174-.941-.174-.762 0-1.338.432-1.338 1.308 0 .833.522 1.325 1.271 1.325.21 0 .378-.024.45-.061v-.846h-.624v-.713h1.505v2.13zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$86203dd4a553987b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.998 14.768H8.895v3.274h-.917v-3.274H6.893V14h3.105v.768zm2.725 3.274-.365-.731c-.15-.282-.246-.492-.359-.726h-.013c-.083.233-.185.443-.312.726l-.335.731h-1.045l1.171-2.045L10.336 14h1.05l.354.738c.121.245.21.443.306.671h.013c.096-.258.174-.438.276-.671l.341-.738h1.043l-1.139 1.973 1.198 2.069h-1.055zm4.384-3.274h-1.104v3.274h-.917v-3.274h-1.085V14h3.105v.768zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$69614396b670c8d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4zM7 8h3v2H7V8zm0 4h10v2H7v-2zm0 4h10v2H7v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$84edcae984889387(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4v1h-2V3H7v2H5V3H3v18h2v-2h2v2h10v-2h2v2h2V3h-2v1zM5 7h2v2H5V7zm0 4h2v2H5v-2zm0 6v-2h2v2H5zm12 0v-2h2v2h-2zm2-4h-2v-2h2v2zm-2-4V7h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8f024ac268413ead(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20v-4.586L20.414 8c.375-.375.586-.884.586-1.415V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2.585c0 .531.211 1.04.586 1.415L11 15.414V22l2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7d185692529aaea1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM9 4h6v2H9zm7 10h-3v3h-2v-3H8v-2h3V9h2v3h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2b541d4df37c0613(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.303 6-3-2H6V2H4v20h2v-8h4.697l3 2H20V6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de4cff875e94c994(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6V2H4zm4 3v2h2V5h2v2h2V5h2v2h2v2h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H8v-2H6V9h2V7H6V5h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h2v2H8zm4 0h2v2h-2zm-2-2h2v2h-2zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d650b67c8a6bd101(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H6V2H4v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8a609ca318c3f83b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.579 2.393a.982.982 0 0 0-1.153.006C9.592 3.728 4 8.252 4 14c0 3.247 1.948 6.043 4.734 7.296A3.971 3.971 0 0 1 8 19c-.017-3.221 3.558-6.893 3.71-7a.497.497 0 0 1 .579 0c.152.107 3.711 2.974 3.711 7.002 0 .854-.275 1.643-.733 2.294C18.052 20.043 20 17.248 20 14.005c0-5.861-5.582-10.307-7.421-11.612z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3dfa9a5c2417866a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.783V4h1V2H8v2h1v5.783l-4.268 9.389a1.992 1.992 0 0 0 .14 1.911A1.99 1.99 0 0 0 6.553 22h10.895a1.99 1.99 0 0 0 1.681-.917c.37-.574.423-1.289.14-1.911L15 9.783zm-4.09.631c.06-.13.09-.271.09-.414V4h2v6c0 .143.03.284.09.414L15.177 15H8.825l2.085-4.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$446f444fe9c8ae99(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.84 21.871 12 22a10.221 10.221 0 0 0-9.013-8.891L2 13l.021.173a10.001 10.001 0 0 0 8.819 8.698zm11.139-8.698L22 13l-.987.109c-4.7.523-8.427 4.2-9.013 8.891l1.16-.129a10.001 10.001 0 0 0 8.819-8.698zM18.063 5.5a2.5 2.5 0 0 0-3.415-.915c-.062.035-.111.081-.168.121.005-.069.02-.136.02-.206a2.5 2.5 0 1 0-5 0c0 .07.015.137.021.206-.057-.04-.107-.086-.168-.121a2.5 2.5 0 0 0-2.5 4.33c.061.035.126.056.188.085-.062.029-.127.05-.188.085a2.5 2.5 0 0 0 2.5 4.33c.062-.035.111-.081.168-.121-.006.069-.021.136-.021.206a2.5 2.5 0 1 0 5 0c0-.07-.015-.137-.021-.206.057.04.106.086.168.121a2.5 2.5 0 0 0 2.5-4.33c-.061-.035-.126-.056-.188-.085.063-.029.127-.05.188-.085a2.5 2.5 0 0 0 .916-3.415zM12 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b27d7df02c9ba368(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-4 9H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$984e027fe531dbfc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V8c0-1.103-.897-2-2-2h-6.655L8.789 4H4c-1.103 0-2 .897-2 2v13h.007a1 1 0 0 0 .158.551zM18 8v3H6c-.4 0-.762.238-.919.606L4 14.129V8h14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$95c5d8504ba7d69e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-4 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$72baebb0eff79851(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5f215ef026c0e0f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h2v20H3zm16 0H6v20h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-1 10H9v-2h9v2zm0-4H9V6h9v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fba61bd17216b52d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v5h4V6h2v3h10V4c0-1.103-.897-2-2-2zm-8 13H8v-5H4v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V10H10v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$67ab530b2f4cbb68(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.719 0 7.063-2.035 8.809-5.314L13 12l7.809-4.686C19.063 4.035 15.719 2 12 2 6.486 2 2 6.486 2 12s4.486 10 10 10zm-.5-16a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 11.5 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$12728e91056a91b6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.394 3.062c.15.899.769 1.676 1.57 2.111.895.487 1.68.442 2.378.194L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM11 8H4V5h7v3zm7 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$856a6d8d90ec766f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11v8h.051c.245 1.692 1.69 3 3.449 3 1.174 0 2.074-.417 2.672-1.174a3.99 3.99 0 0 0 5.668-.014c.601.762 1.504 1.188 2.66 1.188 1.93 0 3.5-1.57 3.5-3.5V11c0-4.962-4.037-9-9-9s-9 4.038-9 9zm6 1c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6-4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$708a8e6bff8fcd11(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H4v8a2 2 0 0 0 2 2h5V12H5zm13 0h-5v10h5a2 2 0 0 0 2-2v-8h-2zm.791-5A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H2v4h9V9h2v2h9V7h-3.209zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM15.5 4c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.477c.51-1.576 1.251-3 1.977-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e1d005f9e1c2bb84(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v1l11 4 9-4V7L11 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11v4.267c0 1.621 4.001 3.893 9 3.734 4-.126 6.586-1.972 7-3.467.024-.089.037-.178.037-.268V11L13 14l-5-1.667v3.213l-1-.364V12l-3-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d067e0171b621a86(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM4 21h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b46bbc851019155e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 16h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e87945934887f1e3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm1.5 1H8c-3.309 0-6 2.691-6 6v1h15v-1c0-3.309-2.691-6-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.604 11.048a5.67 5.67 0 0 0 .751-3.44c-.179-1.784-1.175-3.361-2.803-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.693 3.693 0 0 1-1.072 2.986l-1.192 1.192 1.618.475C18.951 13.701 19 17.957 19 18h2c0-1.789-.956-5.285-4.396-6.952z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9b95064911cb5b7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM8 4h8v2H8V4zM6 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2-4H4V8h16v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h2v2h-2zm3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4554a8ee2dd72f2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.278 2.231a1.001 1.001 0 0 0-.64-.231H5a2 2 0 0 0-2 2v7.21a2 2 0 0 0 1.779 1.987L12 14v6a2 2 0 0 0 4 0V8l3.03 1.212a2.001 2.001 0 0 0 2.641-1.225l.113-.34a.998.998 0 0 0-.309-1.084l-5.197-4.332z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b3947908e71aeb26(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-7.21a2 2 0 0 0-1.987 1.779L10 12H4a2 2 0 0 0 0 4h12l-1.212 3.03a2.001 2.001 0 0 0 1.225 2.641l.34.113a.998.998 0 0 0 1.084-.309l4.332-5.197c.149-.179.231-.406.231-.64V5a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c4b97b808536f9c4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8H8l1.212-3.03a2 2 0 0 0-1.225-2.641l-.34-.113a.998.998 0 0 0-1.084.309L2.231 7.722a1.001 1.001 0 0 0-.231.64V19a2 2 0 0 0 2 2h7.21a2 2 0 0 0 1.987-1.779L14 12h6a2 2 0 0 0 0-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7856e584e48e0f6d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.221 10.803 12 10V4a2 2 0 0 0-4 0v12l-3.031-1.212a2 2 0 0 0-2.64 1.225l-.113.34a.998.998 0 0 0 .309 1.084l5.197 4.332c.179.149.406.231.64.231H19a2 2 0 0 0 2-2v-7.21a2 2 0 0 0-1.779-1.987z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ba8cfb9820555bbd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 5A1.5 1.5 0 0 0 19 6.5V11h-1V4.5a1.5 1.5 0 0 0-3 0V11h-1V3.5a1.5 1.5 0 0 0-3 0V11h-1V5.5a1.5 1.5 0 0 0-3 0v10.81l-2.22-3.6a1.5 1.5 0 0 0-2.56 1.58l3.31 5.34A5 5 0 0 0 9.78 22H17a5 5 0 0 0 5-5V6.5A1.5 1.5 0 0 0 20.5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$feef83faa2a3fa64(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.493 6a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 8zM8.5 8a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 8zM12 18c-5 0-6-5-6-5h12s-1 5-6 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3e2ccd27365349bb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8 9c2.201 0 3 1.794 3 3H9c-.012-.45-.194-1-1-1s-.988.55-1 1.012L5 12c0-1.206.799-3 3-3zm4 9c-4 0-5-4-5-4h10s-1 4-5 4zm5-6c-.012-.45-.194-1-1-1s-.988.55-1 1.012L13 12c0-1.206.799-3 3-3s3 1.794 3 3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cc4daa051608fb09(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM6.435 8.467A1.49 1.49 0 0 1 8.502 8.4a1.49 1.49 0 0 1 2.065.033c.597.592.604 1.521.018 2.118l-2.05 2.083-2.082-2.05a1.484 1.484 0 0 1-.018-2.117zM12 18c-4 0-5-4-5-4h10s-1 4-5 4zm5.585-7.449-2.05 2.083-2.082-2.05a1.485 1.485 0 0 1-.019-2.117 1.49 1.49 0 0 1 2.068-.067 1.49 1.49 0 0 1 2.065.033c.597.591.605 1.521.018 2.118z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1ac95802ec4bac10(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.493 7a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 9zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9zm3.5 9c-4 0-5-4-5-4h10s-1 4-5 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e3869c77febbaa9a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3a8 8 0 0 0-5-7.4V13h-1V5h-4v8H9V7.6A8 8 0 0 0 4 15v3H2v2h20v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9945a2eb92407ef6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 5h-2v-2h2v2zm4 0h-2v-2h2v2zm.775-7H21l-1.652-7.434A2 2 0 0 0 17.396 2H6.604a2 2 0 0 0-1.952 1.566L3 11h17.775z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ddbe87b94f7cfe20(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.186 10.74L12 16.926 7.814 12.74a2.745 2.745 0 0 1 0-3.907 2.745 2.745 0 0 1 3.906 0l.28.279.279-.279a2.745 2.745 0 0 1 3.906 0 2.745 2.745 0 0 1 .001 3.907z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$10680e7e7564ce72(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1zM7.812 8.907a2.746 2.746 0 0 1 3.907 0l.279.279.278-.279a2.746 2.746 0 0 1 3.907 0 2.745 2.745 0 0 1 0 3.907L11.998 17l-4.187-4.186a2.747 2.747 0 0 1 .001-3.907z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bfd6cfbc7cd27c58(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.205 4.791a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412L12 21.414l8.207-8.207c2.354-2.353 2.355-6.049-.002-8.416z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$298968d86f26cd07(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 16h-2v-2h2v2zm.976-4.885c-.196.158-.385.309-.535.459-.408.407-.44.777-.441.793v.133h-2v-.167c0-.118.029-1.177 1.026-2.174.195-.195.437-.393.691-.599.734-.595 1.216-1.029 1.216-1.627a1.934 1.934 0 0 0-3.867.001h-2C8.066 7.765 9.831 6 12 6s3.934 1.765 3.934 3.934c0 1.597-1.179 2.55-1.958 3.181z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f59b29641aa2454b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.073 12.194 4.212 8.333c-1.52 1.657-2.096 3.317-2.106 3.351L2 12l.105.316C2.127 12.383 4.421 19 12.054 19c.929 0 1.775-.102 2.552-.273l-2.746-2.746a3.987 3.987 0 0 1-3.787-3.787zM12.054 5c-1.855 0-3.375.404-4.642.998L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.298-3.298c2.638-1.953 3.579-4.637 3.593-4.679l.105-.316-.105-.316C21.98 11.617 19.687 5 12.054 5zm1.906 7.546c.187-.677.028-1.439-.492-1.96s-1.283-.679-1.96-.492L10 8.586A3.955 3.955 0 0 1 12.054 8c2.206 0 4 1.794 4 4a3.94 3.94 0 0 1-.587 2.053l-1.507-1.507z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$605598636d473447(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.74 2.32a1 1 0 0 0-1.48 0l-9 10A1 1 0 0 0 3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a1 1 0 0 0 1-1 1 1 0 0 0-.26-.68z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$efb3e67deff8572e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669zM12 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c803ddc35b0a1817(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .913-.593.998.998 0 0 0-.17-1.076l-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14zm5.653-2.359a2.224 2.224 0 0 1 3.125 0l.224.22.223-.22a2.225 2.225 0 0 1 3.126 0 2.13 2.13 0 0 1 0 3.07L12.002 18l-3.349-3.289a2.13 2.13 0 0 1 0-3.07z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b63883c1256cb0d7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .913-.593.998.998 0 0 0-.17-1.076l-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14zm5.949-.316C8.98 13.779 9.762 16 12 16c2.269 0 3.042-2.287 3.05-2.311l1.9.621C16.901 14.461 15.703 18 12 18s-4.901-3.539-4.95-3.689l1.899-.627z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7e203e6ca1c9b8d7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a453a51bd5ba1baf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 8c0 1.5-.5 3.5-2.9 4.3.7-1.7.8-3.4.3-5-.7-2.1-3-3.7-4.6-4.6-.4-.3-1.1.1-1 .7 0 1.1-.3 2.7-2 4.4C4.1 10 3 12.3 3 14.5 3 17.4 5 21 9 21c-4-4-1-7.5-1-7.5.8 5.9 5 7.5 7 7.5 1.7 0 5-1.2 5-6.4 0-3.1-1.3-5.5-2.4-6.9-.3-.5-1-.2-1.1.3"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7a522d23bb9f1a90(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "11",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.205 7H12v8H4V6H2v14h2v-3h16v3h2v-4c0-.009-.005-.016-.005-.024H22V11c0-2.096-1.698-4-3.795-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$100e1f1434cf8882(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H4v2h1v1a7.014 7.014 0 0 0 3.433 6.02c.355.21.567.547.567.901v.158c0 .354-.212.691-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.016 7.016 0 0 0-3.434-6.021c-.354-.208-.566-.545-.566-.9v-.158c0-.354.212-.69.566-.9A7.016 7.016 0 0 0 19 5V4h1V2H5zm12 3a5.01 5.01 0 0 1-2.45 4.299A3.107 3.107 0 0 0 13.166 11h-2.332a3.114 3.114 0 0 0-1.385-1.702A5.008 5.008 0 0 1 7 5V4h10v1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bda1f7f35cfbe743(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.566 11.021A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.208.566.545.566.9v.158c0 .354-.212.69-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.355.212-.692.566-.9zM17 19v1H7v-1a5.01 5.01 0 0 1 2.45-4.299A3.111 3.111 0 0 0 10.834 13h2.332c.23.691.704 1.3 1.385 1.702A5.008 5.008 0 0 1 17 19z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$33e29dc3e9553c6f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22h1v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.354.212-.691.566-.9A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.209.566.545.566.9v.158c0 .354-.212.691-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h15zM17 4v1a5.005 5.005 0 0 1-1.004 3H8.004A5.005 5.005 0 0 1 7 5V4h10zM9.45 14.702c.971-.574 1.55-1.554 1.55-2.623V12h2v.079c0 1.068.579 2.049 1.551 2.623A4.98 4.98 0 0 1 16.573 17H7.427a4.977 4.977 0 0 1 2.023-2.298z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c3e0a6a57203cfa2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM8.715 8c1.151 0 2 .849 2 2s-.849 2-2 2-2-.849-2-2 .848-2 2-2zm3.715 8H5v-.465c0-1.373 1.676-2.785 3.715-2.785s3.715 1.412 3.715 2.785V16zM19 15h-4v-2h4v2zm0-4h-5V9h5v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$22cccc51ff6f9426(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 13 3-4 3 4.5V12h4V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-4H5l3-4 1 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d6c3989251f893cb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm3-7 2.363 2.363L14 11l5 7H5l3-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8a8dd6a7ef68f67c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-13.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5.5 10h-7l4-5 1.5 2 3-4 5.5 7h-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eff530f24fe4f53f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5c0-1.103-.897-2-2-2zm-1 9h-3.142c-.446 1.722-1.997 3-3.858 3s-3.412-1.278-3.858-3H4V5h16v7h-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5c670dfee8b7e6b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9d4cea17ec269325(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm8 3h2v2h-2V7zm0 4h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6c3d02160bdeeb9e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.61 9.24 8.35l3.31 3.31-1.06 1.06-3.31-3.31-1.77 1.77 3.31 3.31-1.06 1.06-3.31-3.31-2 2A2 2 0 0 0 3 16.66l1 1.89-2.25 2.29 1.41 1.41L5.45 20l1.89 1a2 2 0 0 0 1 .26 2 2 0 0 0 1.42-.59L18.39 12zm7.8 3.59-1.79-1.8 1.42-1.41 1.41 1.41 1.41-1.41-4.24-4.24-1.41 1.41 1.41 1.42-1.41 1.41-1.8-1.79-1.74-1.75-1.41 1.42 1.03 1.03v.01l6.41 6.41h.01l1.03 1.03 1.42-1.41-1.74-1.74h-.01z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c41750ae9bca8c93(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.857 8.485-3-5A.997.997 0 0 0 18 3h-4.586l-.707-.707a.999.999 0 0 0-1.414 0L10.586 3H6a.997.997 0 0 0-.857.485l-3 5A1.001 1.001 0 0 0 2.002 9H2v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9h-.002c0-.178-.046-.356-.141-.515zM20 18h-6v-4h-4v4H4v-8h2.414l.293-.293 2-2L12 4.414l4.293 4.293 1 1 .293.293H20v8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.895",
                    "cy": "9.895",
                    "r": "2.105"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h2v3H6zm10 0h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c3f6300425202782(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h2v2H6zm2 16h3v2H8zm8-16h2v2h-2zm-3 16h3v2h-3zm7-8V9h-2V7h-2V5h-2v2h-4V5H8v2H6v2H4v2H2v8h2v-4h2v4h2v-3h8v3h2v-4h2v4h2v-8zm-10 1H8V9h2zm6 0h-2V9h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7961baaeb731abe1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8a6 6 0 0 0 0 12h8a6 6 0 0 0 0-12zm-5 7H9v2H7v-2H5v-2h2V9h2v2h2v2zm3.5 2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6c8d48411797920d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-4V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM7 14l-3-2 3-2v4zm5 6-2-3h4l-2 3zm0-6a2 2 0 1 1 .001-4.001A2 2 0 0 1 12 14zm-2-7 2-3 2 3h-4zm7 7v-4l3 2-3 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7a1bb0be4d2c40b6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.986 9.74a3.193 3.193 0 0 0-.008-.088A5.003 5.003 0 0 0 17 5H7a4.97 4.97 0 0 0-4.987 4.737c-.01.079-.013.161-.013.253v6.51c0 .925.373 1.828 1.022 2.476A3.524 3.524 0 0 0 5.5 20c1.8 0 2.504-1 3.5-3 .146-.292.992-2 3-2 1.996 0 2.853 1.707 3 2 1.004 2 1.7 3 3.5 3 .925 0 1.828-.373 2.476-1.022A3.524 3.524 0 0 0 22 16.5V10c0-.095-.004-.18-.014-.26zM7 12.031a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 12.031zm10-5a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-2 4a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2 2a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2-2a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$16cdca6b0f5ed4df(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.433 17.325 3.079 19.8a1 1 0 0 0 1.131 1.131l2.475-.354C7.06 20.524 8 18 8 18s.472.405.665.466c.412.13.813-.274.948-.684L10 16.01s.577.292.786.335c.266.055.524-.109.707-.293a.988.988 0 0 0 .241-.391L12 14.01s.675.187.906.214c.263.03.519-.104.707-.293l1.138-1.137a5.502 5.502 0 0 0 5.581-1.338 5.507 5.507 0 0 0 0-7.778 5.507 5.507 0 0 0-7.778 0 5.5 5.5 0 0 0-1.338 5.581l-7.501 7.5a.994.994 0 0 0-.282.566zM18.504 5.506a2.919 2.919 0 0 1 0 4.122l-4.122-4.122a2.919 2.919 0 0 1 4.122 0z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d4efbdf7a475d8c8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-8 2h2v2h-2V7zm0 4h2v2h-2v-2zM9 7h2v2H9V7zm0 4h2v2H9v-2zM5 7h2v2H5V7zm0 4h2v2H5v-2zm12 6H7v-2h10v2zm2-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a4797990dde35a20(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.813 4.419A.997.997 0 0 0 16 4H3a1 1 0 0 0-.813 1.581L6.771 12l-4.585 6.419A1 1 0 0 0 3 20h13a.997.997 0 0 0 .813-.419l5-7a.997.997 0 0 0 0-1.162l-5-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e66ae75163dbd123(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17h-2V9h2V7a.998.998 0 0 0-.594-.914l-9.432-4.191-8.421 4.21A1 1 0 0 0 2 7v2h2v8H2v4h19v-4zm-5-8v8h-3V9h3zM7 9h3v8H7V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eaee9349515d9972(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 7-5.223 8.487L7 13l-5 7h20z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4d800f8ce4f18055(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6.447 9.105 2.459-1.229-1.567-1.044 1.109-1.664 3 2a1 1 0 0 1-.108 1.727l-4 2-.893-1.79zM12 18c-4 0-5-4-5-4h10s-1 4-5 4zm5.553-5.105-4-2a1 1 0 0 1-.108-1.727l3-2 1.109 1.664-1.566 1.044 2.459 1.229-.894 1.79z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$455b364445ef254a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 11.125-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 15.126 12 19.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748zM16 4h6v2h-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f9766c2266780f56(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM20 8V6h2V4h-2V2h-2v2h-2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c7253c0b0c05985a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 7.125-9.022-5a1.003 1.003 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15.856-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 15.856z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19.856-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d1af741d58fd9769(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v4h18V5c0-1.103-.897-2-2-2zM3 19c0 1.103.897 2 2 2h8V11H3v8zm12 2h4c1.103 0 2-.897 2-2v-8h-6v10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$80c004f1b3ef8ff6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 3.41-.12-1.26-1.2.4a13.84 13.84 0 0 1-6.41.64 11.87 11.87 0 0 0-6.68.9A7.23 7.23 0 0 0 3.3 9.5a9 9 0 0 0 .39 4.58 16.6 16.6 0 0 1 1.18-2.2 9.85 9.85 0 0 1 4.07-3.43 11.16 11.16 0 0 1 5.06-1A12.08 12.08 0 0 0 9.34 9.2a9.48 9.48 0 0 0-1.86 1.53 11.38 11.38 0 0 0-1.39 1.91 16.39 16.39 0 0 0-1.57 4.54A26.42 26.42 0 0 0 4 22h2a30.69 30.69 0 0 1 .59-4.32 9.25 9.25 0 0 0 4.52 1.11 11 11 0 0 0 4.28-.87C23 14.67 22 3.86 22 3.41z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$46bfafff79cf1556(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5 12 7 6v-5h6v-2h-6V6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$357d2074835e8814(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-5v4l-5-5 5-5v4h5v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ffd68c975b0373f3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14zM12 7v4h5v2h-5v4l-5-5 5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e747a4dee5d9e463(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.431 12.822 13 9A1 1 0 0 0 19 21V3a1 1 0 0 0-1.569-.823l-13 9a1.003 1.003 0 0 0 0 1.645z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f4b40ef30d709958(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.898-3.899 3.898-10.244 0-14.143-3.899-3.899-10.244-3.898-14.143 0-3.898 3.899-3.899 10.243 0 14.143 3.9 3.899 10.244 3.899 14.143 0zM8.464 8.464l2.829 2.829 3.535-3.536 1.414 1.414-3.535 3.536 2.828 2.829H8.464V8.464z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2c32550c758cd150(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.898-3.899 3.898-10.244 0-14.143-3.899-3.898-10.243-3.898-14.143 0-3.898 3.899-3.898 10.244 0 14.143 3.9 3.899 10.244 3.899 14.143 0zM8.465 8.464h7.07l-2.828 2.829 3.535 3.536-1.414 1.414-3.535-3.536-2.828 2.829V8.464z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c33bbaaa0aba1261(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.45 8.74A2.23 2.23 0 0 1 21.64 7a3.51 3.51 0 0 0 .24-2.47 3.55 3.55 0 0 0-2.45-2.45 3.51 3.51 0 0 0-2.43.28 2.23 2.23 0 0 1-1.7.19 10.07 10.07 0 0 0-6.53 0 9.87 9.87 0 0 0-6.23 6.18 10.07 10.07 0 0 0 0 6.53A2.23 2.23 0 0 1 2.36 17a3.51 3.51 0 0 0-.24 2.47 3.55 3.55 0 0 0 2.45 2.45A3.51 3.51 0 0 0 7 21.64a2.23 2.23 0 0 1 1.7-.19A9.83 9.83 0 0 0 12 22a10.33 10.33 0 0 0 3.27-.54 9.87 9.87 0 0 0 6.19-6.19 10.07 10.07 0 0 0-.01-6.53zM12 7a5 5 0 0 0-5 5H5a7 7 0 0 1 7-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$efd7b1c05a40585c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h1V8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2zM20 8h-7l1.122-3.368A2 2 0 0 0 12.225 2H12L7 7.438V21h11l3.912-8.596L22 12v-2a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bae99b90d625436c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s8.029-5.56 8-12c0-4.411-3.589-8-8-8S4 5.589 4 9.995C3.971 16.44 11.696 21.784 12 22zM8 9h3V6h2v3h3v2h-3v3h-2v-3H8V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6116e29f48c6124b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b700c8a0fb8d465b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d56f401b3380a38a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3h2c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-7.939 5.499A2.002 2.002 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723V20h-2v-2.277a1.992 1.992 0 0 1-.939-2.224z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8cf747a378bf416a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7zm4 10.723V20h-2v-2.277a1.993 1.993 0 0 1 .567-3.677A2.001 2.001 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3450e1d6b3a24487(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.625 0-8.442 3.507-8.941 8.001H10v-3l5 4-5 4v-3H3.06C3.56 17.494 7.376 21 12 21c4.963 0 9-4.037 9-9s-4.037-9-9-9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b9590f526108b90(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-13a.5.5 0 0 0-.5.5V11h6V8l5 4-5 4v-3H5v8.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-19a.5.5 0 0 0-.5-.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d267d8c81f3b0a06(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.963 0-9 4.037-9 9v.001l5-4v3h7v2H8v3l-5-4C3.001 16.964 7.037 21 12 21s9-4.037 9-9-4.037-9-9-9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$64bf84495c1fbc97(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a1 1 0 0 0-1 1v9l5-4v3h6v2h-6v3l-5-4v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c4aa5426654988f6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.998c-1.836 0-3.356.389-4.617.971L3.707 2.293 2.293 3.707l3.315 3.315c-2.613 1.952-3.543 4.618-3.557 4.66l-.105.316.105.316C2.073 12.382 4.367 19 12 19c1.835 0 3.354-.389 4.615-.971l3.678 3.678 1.414-1.414-3.317-3.317c2.614-1.952 3.545-4.618 3.559-4.66l.105-.316-.105-.316c-.022-.068-2.316-6.686-9.949-6.686zM12.043 7H12a5 5 0 0 1 5 5 4.894 4.894 0 0 1-.852 2.734l-.721-.721A3.919 3.919 0 0 0 16 11.999c0-.474-.099-.925-.255-1.349A.985.985 0 0 1 15 11a1 1 0 0 1-1-1c0-.439.288-.802.682-.936A3.965 3.965 0 0 0 12 7.999c-.735 0-1.419.218-2.015.572l-.72-.72C10.053 7.326 10.982 7 12 7h-.043L12 6.998l.043.002zm-7.969 4.999c.103-.235.274-.586.521-.989l5.867 5.867c-4.213-.647-5.939-3.842-6.388-4.878zm9.247 4.908-7.48-7.48a8.146 8.146 0 0 1 1.188-.984l8.055 8.055a8.835 8.835 0 0 1-1.763.409z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bc0ed23e5116d6c4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 4-.5-1-.5 1-1 .125.834.708L9.5 6l1-.666 1 .666-.334-1.167.834-.708zm8.334 10.666L18.5 13l-.834 1.666-1.666.209 1.389 1.181L16.834 18l1.666-1.111L20.166 18l-.555-1.944L21 14.875zM6.667 6.333 6 5l-.667 1.333L4 6.5l1.111.944L4.667 9 6 8.111 7.333 9l-.444-1.556L8 6.5zM3.414 17c0 .534.208 1.036.586 1.414L5.586 20c.378.378.88.586 1.414.586s1.036-.208 1.414-.586L20 8.414c.378-.378.586-.88.586-1.414S20.378 5.964 20 5.586L18.414 4c-.756-.756-2.072-.756-2.828 0L4 15.586c-.378.378-.586.88-.586 1.414zM17 5.414 18.586 7 15 10.586 13.414 9 17 5.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4abfdaab417d4d37(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a1 1 0 0 0-1 1v3h5V4a1 1 0 0 0-1-1zm7 1v3h5V4a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1zm0 10a3 3 0 0 1-6 0V9H4v5a8 8 0 0 0 16 0V9h-5v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ce1e753fbf5cda02(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 6.882-7-3.5v13.236l7 3.5 6-3 7 3.5V7.382l-7-3.5-6 3zM15 15l-6 3V9l6-3v9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3e8b10b9cf588a16(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 17 1-2V9.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 3.794 8 6c0 1.858 1.279 3.411 3 3.858V15l1 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.267 10.563-.533 1.928C18.325 13.207 20 14.584 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C4.197 11.54 2 13.623 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f2e37d5d66391193(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9271e39691832631(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5C3.346 6 2 7.346 2 9v5c0 2.206 1.794 4 4 4h1.637c1.166 0 2.28-.557 2.981-1.491.66-.879 2.104-.88 2.764.001A3.744 3.744 0 0 0 16.363 18H18c2.206 0 4-1.794 4-4V9c0-1.654-1.346-3-3-3zM7.5 13C6.119 13 5 12.328 5 11.5S6.119 10 7.5 10s2.5.672 2.5 1.5S8.881 13 7.5 13zm9 0c-1.381 0-2.5-.672-2.5-1.5s1.119-1.5 2.5-1.5 2.5.672 2.5 1.5-1.119 1.5-2.5 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bf3449bf19d64760(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-4v4.059a8.946 8.946 0 0 1 4 1.459V2zm-6 0H7v5.518a8.946 8.946 0 0 1 4-1.459V2zm1 20a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-1.225-8.519L12 11l1.225 2.481 2.738.397-1.981 1.932.468 2.727L12 17.25l-2.449 1.287.468-2.727-1.981-1.932 2.737-.397z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f1feb38321689379(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.664 3.478 8 8v7l.748.267-1.127 2.254a1.999 1.999 0 0 0 1.156 2.792l4.084 1.361a2.015 2.015 0 0 0 2.421-1.003l1.303-2.606 4.079 1.457A1 1 0 0 0 22 18.581V4.419a1 1 0 0 0-1.336-.941zm-7.171 16.299L9.41 18.416l1.235-2.471 4.042 1.444-1.194 2.388zM4 15h2V8H4c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$17534e9207fa84cd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6 8h4v2H6v-2zm10 7H7.974v-2H16v2zm2-5h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fc034a16ce0d7851(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 12zm6.993-.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3c5390421a2626ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm9 6.5H7.974v-2H16v2zm-.507-5.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3258ca509e37594d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V7l-5-5zm-6 8H7V6h2v4zm3 0h-2V6h2v4zm3 0h-2V6h2v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9de17d156d981a44(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-3 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f8447b4b2f231cb3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7 9h4V5h2v4h4v2h-4v4h-2v-4H7V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a195bdce7ece4b16(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm5.707 4.293L11 10.586l4.793-4.793 1.414 1.414L11 13.414 7.293 9.707l1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e40620cf3250cf79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7 7h10v2H7V7zm0 4h7v2H7v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c74778485149a78b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM9 12a2 2 0 1 1 .001-4.001A2 2 0 0 1 9 12zm6 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 15 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cd6aabf001c837f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm4.302 11.987h-1.8v-1.799l4.978-4.97 1.798 1.799-4.976 4.97zm5.823-5.817-1.798-1.799L14.698 5l1.8 1.799-1.373 1.371z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$68d013c9dc7434c7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm8 1h2v6h-2V5zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$528fbcbc0866b0f4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm11 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$20a6dd5fb2787a91(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7.293 6.707l1.414-1.414L12 8.586l3.293-3.293 1.414 1.414L13.414 10l3.293 3.293-1.414 1.414L12 11.414l-3.293 3.293-1.414-1.414L10.586 10 7.293 6.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8822de5902903713(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.999 2h-14c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4h3.5c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$312c877cfe343ef6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-9 11.914-3.707-3.707 1.414-1.414L11 11.086l4.793-4.793 1.414 1.414L11 13.914z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a84f1a6dbe9ff726(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-6 11H7v-2h7v2zm3-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bbd332ca4d53e911(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.017C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-9 8a2 2 0 1 1-2-2c.086 0 .167.015.25.025.082-.014.164-.025.25-.025A1.5 1.5 0 0 1 11 9.5c0 .086-.012.168-.025.25.01.083.025.165.025.25zm4 2a2 2 0 0 1-2-2c0-.086.015-.167.025-.25A1.592 1.592 0 0 1 13 9.5 1.5 1.5 0 0 1 14.5 8c.086 0 .168.011.25.025.083-.01.164-.025.25-.025a2 2 0 0 1 0 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$816e388bbf0dcda3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zM8.999 14.999H7V13l5.53-5.522 1.998 1.999-5.529 5.522zm6.472-6.464-1.999-1.999 1.524-1.523 1.999 1.999-1.524 1.523z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e3c6d25ebeb27aa5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-7 13h-2v-2h2v2zm0-4h-2V5h2v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ae032764176a7ed8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-4 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$95de4eff320fa0fd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm4 9h-3v3h-2v-3H8V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$83b3987534438833(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm-1 12.414-3.707-3.707 1.414-1.414L11 11.586l4.793-4.793 1.414 1.414L11 14.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d8522645de58f9be(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm2 11H7v-2h7v2zm3-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$48b752c9efa0807c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.897 5.516 5 6.934V22l5.34-4.004C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm-2.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$df1bc830d47398d2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.516 5 6.934V22l5.34-4.005C17.697 17.854 22 14.32 22 10c0-4.411-4.486-8-10-8zM9.302 13.986H7.503v-1.798l4.976-4.97 1.798 1.799-4.975 4.969zm5.823-5.816-1.799-1.798 1.372-1.371 1.799 1.798-1.372 1.371z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$755104d6b4a98d23(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.516 5 6.934V22l5.34-4.005C17.697 17.854 22 14.32 22 10c0-4.411-4.486-8-10-8zm1 12h-2v-2h2v2zm0-4h-2V5h2v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$13b8a5619df64df7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm4 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9f9db47f80048a00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm3.707 10.293-1.414 1.414L12 11.414l-2.293 2.293-1.414-1.414L10.586 10 8.293 7.707l1.414-1.414L12 8.586l2.293-2.293 1.414 1.414L13.414 10l2.293 2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2f59f9abacd85c63(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$898ebec873e3b810(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm1 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cd23d898e37068bb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-5 14.414-3.707-3.707 1.414-1.414L11 13.586l4.793-4.793 1.414 1.414L11 16.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$34f86e92c28fdaed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-2 13H7v-2h7v2zm3-4H7V9h10v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9342ccb50a14e5cf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-5 10.5A1.5 1.5 0 0 1 9.5 14c-.086 0-.168-.011-.25-.025-.083.01-.164.025-.25.025a2 2 0 1 1 2-2c0 .085-.015.167-.025.25.013.082.025.164.025.25zm4 1.5c-.086 0-.167-.015-.25-.025a1.471 1.471 0 0 1-.25.025 1.5 1.5 0 0 1-1.5-1.5c0-.085.012-.168.025-.25-.01-.083-.025-.164-.025-.25a2 2 0 1 1 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9c2c3d50caace7dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zM8.999 17H7v-1.999l5.53-5.522 1.999 1.999L8.999 17zm6.473-6.465-1.999-1.999 1.524-1.523 1.999 1.999-1.524 1.523z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b011ba1d491b6397(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-3 16h-2v-2h2v2zm0-4h-2V6h2v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bd3f153d024ac183(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm0 11H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e3a44d9fbd53c4b9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm.706 13.293-1.414 1.414L12 13.415l-3.292 3.292-1.414-1.414 3.292-3.292-3.292-3.292 1.414-1.414L12 10.587l3.292-3.292 1.414 1.414-3.292 3.292 3.292 3.292z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1d390e51825fb433(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ab089aa8d5fb42b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-3.293 11.293-1.414 1.414L12 11.414l-3.293 3.293-1.414-1.414L10.586 10 7.293 6.707l1.414-1.414L12 8.586l3.293-3.293 1.414 1.414L13.414 10l3.293 3.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b10d6676547f6cdc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$307bfa947e4b34f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.507 2.138a1 1 0 0 0-1.155.102L4.196 9.197c-2.924 2.924-2.924 7.682 0 10.606a7.472 7.472 0 0 0 5.3 2.192c1.924 0 3.85-.734 5.317-2.202l6.903-7.096A1 1 0 0 0 21 11h-3.301l4.175-7.514a1.001 1.001 0 0 0-1.359-1.36l-7.11 3.95.576-2.879a1.002 1.002 0 0 0-.474-1.059zM14 14.5a4.5 4.5 0 0 1-9 0c0-1.57.807-2.949 2.025-3.754-.01.084-.025.167-.025.254a2 2 0 1 0 3.845-.772C12.669 10.802 14 12.486 14 14.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8774534489a95731(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.999 22h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2zm-5-15h2V5h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2V9h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2v-2h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2v-2h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f6490a1ac48724b9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12c0 2.206 1.794 4 4 4s4-1.794 4-4h-2v-2h2V8h-2V6h2c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6h4v2H8v2h4v2H8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2dcf3cab9bf072b3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-3.4-3.4A7.93 7.93 0 0 0 20 12h-2a5.945 5.945 0 0 1-1.119 3.467l-1.449-1.45A3.926 3.926 0 0 0 16 12V6c0-2.217-1.785-4.021-3.979-4.021-.07 0-.14.009-.209.025A4.006 4.006 0 0 0 8 6v.586L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM6 12H4c0 4.072 3.06 7.436 7 7.931V22h2v-2.069a7.935 7.935 0 0 0 2.241-.63l-1.549-1.548A5.983 5.983 0 0 1 12 18c-3.309 0-6-2.691-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.007 12.067a3.996 3.996 0 0 0 3.926 3.926l-3.926-3.926z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d132fa5d071478a0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c2.206 0 4-1.794 4-4V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6H4c0 4.072 3.061 7.436 7 7.931z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f393120cf2598d5a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1305fc1f76696483(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5zm12 10H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ec0f917514d95789(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 2.808a2.003 2.003 0 0 0-2.828 0l-9.899 9.899a2.001 2.001 0 0 0 0 2.828l5.657 5.657c.39.39.902.585 1.414.585s1.024-.195 1.414-.585l9.899-9.899c.78-.779.78-2.049 0-2.828l-5.657-5.657zM8.707 16.707a.999.999 0 1 1-1.414-1.414.999.999 0 1 1 1.414 1.414zm7 5-1.414-1.414 6-6 1.414 1.415zM8.293 2.293l1.414 1.414-6 6-1.414-1.415z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e3efcaf1f1246a1e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10zm-5-5a1 1 0 1 1 0 2 1 1 0 1 1 0-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c37b9284b43d400d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.807A9.002 9.002 0 0 1 10.049 2a9.942 9.942 0 0 0-5.12 2.735c-3.905 3.905-3.905 10.237 0 14.142 3.906 3.906 10.237 3.905 14.143 0a9.946 9.946 0 0 0 2.735-5.119A9.003 9.003 0 0 1 12 11.807z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b551104260eed46b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2v8h6V8c0-3.309-2.691-6-6-6zM5 16c0 3.309 2.691 6 6 6h2c3.309 0 6-2.691 6-6v-4H5v4zm0-8v2h6V2C7.691 2 5 4.691 5 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$234f34eacbc199b6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.975 22H12c3.859 0 7-3.14 7-7V9c0-3.841-3.127-6.974-6.981-7h-.06C8.119 2.022 5 5.157 5 9v6c0 3.86 3.129 7 6.975 7zM11 6h2v6h-2V6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$770975959c84cf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.465l-2.667-4H20l.001 4zM15.5 15 10 18v-6l5.5 3zm-.964-6-2.667-4h2.596l2.667 4h-2.596zm-2.404 0H9.536L6.869 5h2.596l2.667 4zM4 5h.465l2.667 4H4V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aad3a5f064c3ef5b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.466l-2.667-4H20l.001 4zm-5.466 0-2.667-4h2.596l2.667 4h-2.596zm-2.404 0H9.535L6.869 5h2.596l2.666 4zM4 5h.465l2.667 4H4V5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1e89f786be6b9c6b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18.573c2.206 0 4-1.794 4-4V4.428L19 7.7v7.43a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V7a.998.998 0 0 0-.658-.939l-11-4A.999.999 0 0 0 8 3v8.13a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$54cf176712a2640(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.002 9.538c-.023.411.207.794.581.966l7.504 3.442 3.442 7.503c.164.356.52.583.909.583l.057-.002a1 1 0 0 0 .894-.686l5.595-17.032c.117-.358.023-.753-.243-1.02s-.66-.358-1.02-.243L2.688 8.645a.997.997 0 0 0-.686.893z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$19984b250010189(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3A2.502 2.502 0 0 0 17 5.5c0 .357.078.696.214 1.005l-1.955 2.199A3.977 3.977 0 0 0 13 8c-.74 0-1.424.216-2.019.566L8.707 6.293l-.023.023C8.88 5.918 9 5.475 9 5a3 3 0 1 0-3 3c.475 0 .917-.12 1.316-.316l-.023.023L9.567 9.98A3.956 3.956 0 0 0 9 12c0 .997.38 1.899.985 2.601l-2.577 2.576A2.472 2.472 0 0 0 6.5 17C5.122 17 4 18.121 4 19.5S5.122 22 6.5 22 9 20.879 9 19.5c0-.321-.066-.626-.177-.909l2.838-2.838c.421.15.867.247 1.339.247 2.206 0 4-1.794 4-4 0-.636-.163-1.229-.428-1.764l2.117-2.383c.256.088.526.147.811.147C20.879 8 22 6.879 22 5.5S20.879 3 19.5 3zM13 14c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a11d0431e40e7e6b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17a1 1 0 0 1-2 0V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13a2 2 0 0 0 2 2h15c1.654 0 3-1.346 3-3V7h-2v10zM12 7h3v2h-3V7zm0 4h3v2h-3v-2zM5 7h5v6H5V7zm0 10v-2h10v2H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b1a721f0c38db587(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 12H7v-4h10v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$af3f0e28cc3f10cf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8l8-8V5a2 2 0 0 0-2-2zm-7 16v-7h7l-7 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$719d70dc22fa2916(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7 10H7v-2h5v2zm5-4H7V8h10v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b64c2b8ecc7d0e8f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-7.422A4.962 4.962 0 0 1 18 11a5 5 0 0 1-5-5c0-.712.153-1.387.422-2H6c-.178 0-.347.031-.51.076L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.783-1.783c.045-.163.076-.332.076-.51zM4 18c0 1.103.897 2 2 2h9.879L4 8.121V18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f5d2fae398ee5aec(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6c0-.712.153-1.387.422-2H6c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7.422A4.962 4.962 0 0 1 18 11a5 5 0 0 1-5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e7f0ffc469e08fce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13h-6v-2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4V2h-2v3H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4v2H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6v3h2v-3h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a8b768433a6f50ad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v20H2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "13",
                    "width": "16",
                    "height": "6",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "5",
                    "width": "12",
                    "height": "6",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1af303f85ae36ffb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "13",
                    "width": "16",
                    "height": "6",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "5",
                    "width": "12",
                    "height": "6",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e5d18587c021f1de(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v2H2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "6",
                    "height": "16",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "6",
                    "width": "6",
                    "height": "12",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$229e32a163340d6c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4h-2V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v6H2v2h3v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6h2v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$570eecc194e8e9ff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h20v2H2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "6",
                    "width": "6",
                    "height": "16",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "6",
                    "width": "6",
                    "height": "12",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$155c96c0a3bc28a1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$33b9b806df9ff7ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.993 7.95a.96.96 0 0 0-.029-.214c-.007-.025-.021-.049-.03-.074-.021-.057-.04-.113-.07-.165-.016-.027-.038-.049-.057-.075-.032-.045-.063-.091-.102-.13-.023-.022-.053-.04-.078-.061-.039-.032-.075-.067-.12-.094-.004-.003-.009-.003-.014-.006l-.008-.006-8.979-4.99a1.002 1.002 0 0 0-.97-.001l-9.021 4.99c-.003.003-.006.007-.011.01l-.01.004c-.035.02-.061.049-.094.073-.036.027-.074.051-.106.082-.03.031-.053.067-.079.102-.027.035-.057.066-.079.104-.026.043-.04.092-.059.139-.014.033-.032.064-.041.1a.975.975 0 0 0-.029.21c-.001.017-.007.032-.007.05V16c0 .363.197.698.515.874l8.978 4.987.001.001.002.001.02.011c.043.024.09.037.135.054.032.013.063.03.097.039a1.013 1.013 0 0 0 .506 0c.033-.009.064-.026.097-.039.045-.017.092-.029.135-.054l.02-.011.002-.001.001-.001 8.978-4.987c.316-.176.513-.511.513-.874V7.998c0-.017-.006-.031-.007-.048zm-10.021 3.922L5.058 8.005 7.82 6.477l6.834 3.905-2.682 1.49zm.048-7.719L18.941 8l-2.244 1.247-6.83-3.903 2.153-1.191zM13 19.301l.002-5.679L16 11.944V15l2-1v-3.175l2-1.119v5.705l-7 3.89z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2604d15a340fef96(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H7c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15v-2c0-1.103-.897-2-2-2H4V5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h7v2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$343d2a025771cfaa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.084 2.914c-1.178-1.179-3.234-1.179-4.412 0l-8.379 8.379a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0l8.379-8.379a3.123 3.123 0 0 0-.002-4.414zm-1.412 3L12 13.586 10.414 12l7.672-7.672a1.146 1.146 0 0 1 1.586.002 1.123 1.123 0 0 1 0 1.584zM8 15c-1.265-.634-3.5 0-3.5 2 0 1.197.5 2-1.5 3 0 0 3.25 2.25 5.5 0 1.274-1.274 1.494-4-.5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7d2fc381b7b74b4d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.38 21.646A9.985 9.985 0 0 0 12 22l.141-.001a2.998 2.998 0 0 0 2.515-1.425c.542-.876.6-1.953.153-2.88l-.198-.415c-.453-.942-.097-1.796.388-2.281.485-.485 1.341-.841 2.28-.388h.001l.413.199a2.99 2.99 0 0 0 2.881-.153A2.997 2.997 0 0 0 22 12.141a9.926 9.926 0 0 0-.353-2.76c-1.038-3.827-4.353-6.754-8.246-7.285-3.149-.427-6.241.602-8.471 2.833S1.666 10.247 2.096 13.4c.53 3.894 3.458 7.208 7.284 8.246zM15.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM9 15.506a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-2.5-6.5a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 6.5 9.006z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e7f7395364af40dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.6 13.083 3.452 1.511L16 9.167l-6 7 8.6 3.916a1 1 0 0 0 1.399-.85l1-15a1.002 1.002 0 0 0-1.424-.972l-17 8a1.002 1.002 0 0 0 .025 1.822zM8 22.167l4.776-2.316L8 17.623z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1b847eeb25c00875(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3H5v18h4v-5h4.5c3.584 0 6.5-2.916 6.5-6.5S17.084 3 13.5 3zm0 9H9V7h4.5C14.879 7 16 8.121 16 9.5S14.879 12 13.5 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c537d8cc6b14e372(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7a8.44 8.44 0 0 0-5 1.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.9 3.9 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31l-.23.21a16.71 16.71 0 0 0-3.41-2.2c-2.53-1.14-3.83-.61-4.47 0a2.18 2.18 0 0 0-.46.68l-.18.53L5.1 8.87C6.24 11.71 9 16.76 15 18.94l5-1.66a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9zm-3.79 8.37h-.06c-.69.37-3.55-.57-6.79-3.81-.34-.34-.66-.67-.95-1-.1-.11-.19-.23-.29-.35l-.53-.64-.28-.39c-.14-.19-.28-.38-.4-.56s-.16-.26-.24-.39-.22-.34-.31-.51-.13-.24-.19-.37-.17-.28-.23-.42-.09-.23-.14-.34-.11-.27-.15-.4S8.6 6 8.58 5.9s-.06-.24-.08-.34a2 2 0 0 1 0-.24 1.15 1.15 0 0 1 0-.26l.11-.31c.17-.18.91-.23 2.23.37a13.83 13.83 0 0 1 2.49 1.54A4.17 4.17 0 0 1 12 7v2a6.43 6.43 0 0 0 3-.94l.49.46c.44.43.83.86 1.19 1.27A5.31 5.31 0 0 0 16 13.2l2-.39a3.23 3.23 0 0 1 0-1.14c1.29 1.97 1.53 3.39 1.21 3.7zM4.4 11l-2.23 6.7A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17l6.52-2.17A18.7 18.7 0 0 1 4.4 11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e00866d74a4260c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4h6v2H9zm11 7h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V6a2 2 0 0 0-2-2h-2a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v-9a2 2 0 0 1 2-2h10zM9 6V4h6v2H9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$430fd4722ce8cf3f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.12 22a7.71 7.71 0 0 0 6.57-5 7.23 7.23 0 0 0 .46-3.21 3.26 3.26 0 0 1 1-2.57l.61-.61A3.89 3.89 0 0 0 19.43 6l2.28-2.28-1.42-1.43L18 4.55a3.82 3.82 0 0 0-4.66.57l-.75.75a3.22 3.22 0 0 1-2.52 1 7.05 7.05 0 0 0-3.32.57A7.75 7.75 0 0 0 2 14.11 7.59 7.59 0 0 0 10.12 22zM9.5 9.25v1.5a3.75 3.75 0 0 0-3.75 3.75h-1.5A5.26 5.26 0 0 1 9.5 9.25z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3519e2960064c275(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.587 6.999H7.702a2 2 0 0 0-1.88 1.316l-3.76 10.342c-.133.365-.042.774.232 1.049l.293.293 6.422-6.422c-.001-.026-.008-.052-.008-.078a1.5 1.5 0 1 1 1.5 1.5c-.026 0-.052-.007-.078-.008l-6.422 6.422.293.293a.997.997 0 0 0 1.049.232l10.342-3.761a2 2 0 0 0 1.316-1.88v-3.885L19 10.414 13.586 5l-1.999 1.999zm8.353 2.062-5-5 2.12-2.121 5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$751c6d6760adc9b9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 19.707 18 10.414 13.586 6l-9.293 9.293a1.003 1.003 0 0 0-.263.464L3 21l5.242-1.03c.176-.044.337-.135.465-.263zM21 7.414a2 2 0 0 0 0-2.828L19.414 3a2 2 0 0 0-2.828 0L15 4.586 19.414 9 21 7.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2debc071e13ad2bb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b2d63f97ee0e4e8e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.793 6.793 13 4v7h7l-2.793-2.793 4.5-4.5-1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.422 13.443a1.001 1.001 0 0 0-1.391.043l-2.392 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.86 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1.001 1.001 0 0 0-.291.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.324 21 17.705 21c.203 0 .326-.006.359-.008a.99.99 0 0 0 .648-.291l1.861-2.171a1.001 1.001 0 0 0-.086-1.391l-4.065-3.696z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$828eb0f42b21c324(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 13.42a5.24 5.24 0 0 1-.93-2.06L10.7 9a1 1 0 0 0 0-1.39l-3.65-4.1a1 1 0 0 0-1.4-.08L3.48 5.29a1 1 0 0 0-.29.65 15.25 15.25 0 0 0 3.54 9.92l-4.44 4.43 1.42 1.42 18-18-1.42-1.42zm7.44.02a1 1 0 0 0-1.39.05L12.82 16a4.07 4.07 0 0 1-.51-.14l-2.66 2.61A15.46 15.46 0 0 0 17.89 21h.36a1 1 0 0 0 .65-.29l1.86-2.17a1 1 0 0 0-.09-1.39z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$34ed590fe19be37e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.793 5.793-4.5 4.5 1.414 1.414 4.5-4.5L21 10V3h-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.422 13.446a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.516a1 1 0 0 0-1.391-.087L3.299 5.29a.996.996 0 0 0-.291.648c-.015.25-.301 6.172 4.291 10.766 4.006 4.006 9.024 4.299 10.406 4.299.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dd99b63e01d750fb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.487 17.14-4.065-3.696a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.085-1.39z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4669b1072b6ddc96(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V3a1 1 0 0 0-1-1zM9.503 5a1.503 1.503 0 1 1 0 3.006 1.503 1.503 0 0 1 0-3.006zM12 13H7l3-3 1.5 1.399L14.5 8l3.5 5h-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8578686f0e47f305(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3zm0 16H5a1 1 0 0 1-1-1v-6h2v4h2v-4h1v4h2v-4h1v4h2v-4h2v4h2v-4h2v6a1 1 0 0 1-1 1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2761fb397355d487(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.051V11h8.949c-.47-4.717-4.232-8.479-8.949-8.949zm4.969 17.953c2.189-1.637 3.694-4.14 3.98-7.004h-8.183l4.203 7.004z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12V2.051C5.954 2.555 2 6.824 2 12c0 5.514 4.486 10 10 10a9.93 9.93 0 0 0 4.255-.964s-5.253-8.915-5.254-9.031A.02.02 0 0 0 11 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$804fd393613a8b13(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929A9.97 9.97 0 0 0 12 2a9.936 9.936 0 0 0-7.071 2.929C3.04 6.818 2 9.33 2 12s1.04 5.182 2.929 7.071C6.818 20.96 9.33 22 12 22s5.182-1.04 7.071-2.929A9.936 9.936 0 0 0 22 12a9.97 9.97 0 0 0-2.929-7.071zm-1.414 12.728C16.146 19.168 14.137 20 12 20s-4.146-.832-5.657-2.343C4.832 16.146 4 14.137 4 12s.832-4.146 2.343-5.657A7.948 7.948 0 0 1 12 4v8h8a7.948 7.948 0 0 1-2.343 5.657z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a1024174399082b1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 10V5c4 0 7 3 7 7h-7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1c58d138eb90f285(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.586V6h2V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2h2v5.586l-2.707 1.707A.996.996 0 0 0 6 14v2a1 1 0 0 0 1 1h4v3l1 2 1-2v-3h4a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L15 11.586z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5c58dc1001953924(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.76 2.021a.995.995 0 0 0-.989.703L3.579 19.166a1 1 0 0 0 1.255 1.255l16.442-5.192a.991.991 0 0 0 .702-.988C21.6 7.666 16.334 2.4 9.76 2.021zM10 16a2 2 0 1 1 .001-4.001A2 2 0 0 1 10 16zm6-2a2 2 0 1 1 .001-4.001A2 2 0 0 1 16 14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b29d7418dd9f7e0f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.414 13.778 2 15.192l4.949 2.121 2.122 4.95 1.414-1.414-.707-3.536L13.091 14l3.61 7.704 1.339-1.339-1.19-10.123 2.828-2.829a2 2 0 1 0-2.828-2.828l-2.903 2.903L3.824 6.297 2.559 7.563l7.644 3.67-3.253 3.253-3.536-.708z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4d37c4cff7b5c02d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.842 15.296a1.61 1.61 0 0 0 1.892-1.189v-.001a1.609 1.609 0 0 0-1.177-1.949l-4.576-1.133L9.825 4.21l-2.224-.225 2.931 6.589-4.449-.449-2.312-3.829-1.38.31 1.24 5.52 15.211 3.17zM3 18h18v2H3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$94942006feb6bcb1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18v2H3zm18.509-9.473a1.61 1.61 0 0 0-2.036-1.019L15 9 7 6 5 7l6 4-4 2-4-2-1 1 4 4 14.547-5.455a1.611 1.611 0 0 0 .962-2.018z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a6e9926b8a295b68(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.21v-1.895L14 8V4a2 2 0 0 0-4 0v4.105L2 14.42v1.789l8-2.81V18l-3 2v2l5-2 5 2v-2l-3-2v-4.685l8 2.895z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f791cd9ad50bc058(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.165 15.582c4.587-4.073 8.141-9.424 6.057-11.771-.661-.744-1.584-1.089-2.575-.983-.832.091-1.687.502-2.549 1.192a8.922 8.922 0 0 0-8.712.282 8.917 8.917 0 0 0-4.109 5.515 8.892 8.892 0 0 0 .306 5.325c-1.065 1.203-2.054 3.677-.823 5.063.517.581 1.257.841 2.147.841 2.707 0 6.808-2.399 10.258-5.464zm3.699-10.767c.358-.034.632.064.861.323.231.261.169.946-.252 1.929a9.059 9.059 0 0 0-1.617-1.853c.431-.262.776-.373 1.008-.399zM4.633 17.118a8.979 8.979 0 0 0 1.568 1.737c-1.025.303-1.714.283-1.945.021-.217-.243.002-1.069.377-1.758zm16.31-5.869c-1.215 1.797-2.906 3.671-4.778 5.333-1.934 1.719-4.066 3.208-6.05 4.202a9.082 9.082 0 0 0 1.874.212 8.986 8.986 0 0 0 4.616-1.282 8.915 8.915 0 0 0 4.338-8.465z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$66c03e6e3a69001c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.493C13 18.427 14.573 20 16.507 20s3.507-1.573 3.507-3.507c0-.177-.027-.347-.053-.517H20V6h2V4h-3a1 1 0 0 0-1 1v8.333a3.465 3.465 0 0 0-1.493-.346A3.51 3.51 0 0 0 13 16.493zM2 5h14v2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h14v2H2zm0 4h9v2H2zm0 4h9v2H2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e52c6a768c03a964(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8h2v5c0 2.206 1.794 4 4 4h2v5h2v-5h2c2.206 0 4-1.794 4-4V8h2V6H3v2zm4-6h2v3H7zm8 0h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$49d4f3f0f1032ef8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$59799628e0f37d3e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm2-10h4V7h2v4h4v2h-4v4h-2v-4H7v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$74b6dbe3f99f2318(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.978 13.21a1 1 0 0 0-.396-1.024l-14-10a.999.999 0 0 0-1.575.931l2 17a1 1 0 0 0 1.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 0 0 .782-.769z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9689ab65c8197df8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 7.293-5-5A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4d489c2feb2104f2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4a7 7 0 0 0-9.9 0l-7.82 7.82a1 1 0 0 0 0 1.41l3.54 3.54-3.54 3.53 1.42 1.42 3.53-3.54 3.54 3.54a1 1 0 0 0 1.41 0L20 13.94A7 7 0 0 0 20 4zm-2.7 2.7a3.33 3.33 0 0 0-4.6 0l-1.06-1.06a4.76 4.76 0 0 1 6.72 0z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bf2b2fbc0cbb33e9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-1V2H6v5H5a3 3 0 0 0-3 3v7a2 2 0 0 0 2 2h2v3h12v-3h2a2 2 0 0 0 2-2v-7a3 3 0 0 0-3-3zM8 4h8v3H8V4zm0 16v-4h8v4H8zm11-8h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$199ca8719300136a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.707 2.293A.996.996 0 0 0 11 2H6a.996.996 0 0 0-.707.293l-3 3A.996.996 0 0 0 2 6v5c0 .266.105.52.293.707l10 10a.997.997 0 0 0 1.414 0l8-8a.999.999 0 0 0 0-1.414l-10-10zM8.353 10a1.647 1.647 0 1 1-.001-3.293A1.647 1.647 0 0 1 8.353 10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$607d1c37d7680e76(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8 8a2 2 0 0 0 2.828 0l7.172-7.172a2 2 0 0 0 0-2.828l-8-8zM7 9a2 2 0 1 1 .001-4.001A2 2 0 0 1 7 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bfce10453496a090(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.445 21.832a1 1 0 0 0 1.11 0l9-6A.998.998 0 0 0 21.8 14.4l-9-12c-.377-.504-1.223-.504-1.6 0l-9 12a1 1 0 0 0 .245 1.432l9 6zm8.12-7.078L12 19.798V4.667l7.565 10.087z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$391353b652a62c9e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.945-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 6.5 10zm11 0c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 17.5 10z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$583ca45bb010d036(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.95 8.721-.025-.168-.026.006A4.5 4.5 0 1 0 17.5 14c.223 0 .437-.034.65-.065-.069.232-.14.468-.254.68-.114.308-.292.575-.469.844-.148.291-.409.488-.601.737-.201.242-.475.403-.692.604-.213.21-.492.315-.714.463-.232.133-.434.28-.65.35l-.539.222-.474.197.484 1.939.597-.144c.191-.048.424-.104.689-.171.271-.05.56-.187.882-.312.317-.143.686-.238 1.028-.467.344-.218.741-.4 1.091-.692.339-.301.748-.562 1.05-.944.33-.358.656-.734.909-1.162.293-.408.492-.856.702-1.299.19-.443.343-.896.468-1.336.237-.882.343-1.72.384-2.437.034-.718.014-1.315-.028-1.747a7.028 7.028 0 0 0-.063-.539zm-11 0-.025-.168-.026.006A4.5 4.5 0 1 0 6.5 14c.223 0 .437-.034.65-.065-.069.232-.14.468-.254.68-.114.308-.292.575-.469.844-.148.291-.409.488-.601.737-.201.242-.475.403-.692.604-.213.21-.492.315-.714.463-.232.133-.434.28-.65.35l-.539.222c-.301.123-.473.195-.473.195l.484 1.939.597-.144c.191-.048.424-.104.689-.171.271-.05.56-.187.882-.312.317-.143.686-.238 1.028-.467.344-.218.741-.4 1.091-.692.339-.301.748-.562 1.05-.944.33-.358.656-.734.909-1.162.293-.408.492-.856.702-1.299.19-.443.343-.896.468-1.336.237-.882.343-1.72.384-2.437.034-.718.014-1.315-.028-1.747a7.571 7.571 0 0 0-.064-.537z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$440fca6e6b66b204(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.691 6.292C5.094 4.771 7.217 4 10 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 6.925 10H10a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2H3a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789zM20 20h-6a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789C16.094 4.771 18.217 4 21 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 17.925 10H21a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$399c97979c396628(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.309 17.708C22.196 15.66 22.006 13.03 22 13V5a1 1 0 0 0-1-1h-6c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h3.078a2.89 2.89 0 0 1-.429 1.396c-.508.801-1.465 1.348-2.846 1.624l-.803.16V20h1c2.783 0 4.906-.771 6.309-2.292zm-11.007 0C11.19 15.66 10.999 13.03 10.993 13V5a1 1 0 0 0-1-1h-6c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h3.078a2.89 2.89 0 0 1-.429 1.396c-.508.801-1.465 1.348-2.846 1.624l-.803.16V20h1c2.783 0 4.906-.771 6.309-2.292z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ab2beff5c116dee3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.203 6.98.804-.161V4h-1c-2.784 0-4.906.771-6.309 2.292C6.81 8.34 7 10.97 7.006 11v8a1 1 0 0 0 1 1h7c1.103 0 2-.897 2-2v-7a1 1 0 0 0-1-1h-4.079c.022-.402.123-.912.429-1.396.509-.801 1.466-1.347 2.847-1.624z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$59dcd36df1c3ead2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.804 17.02 8 17.18V20h1c2.783 0 4.906-.771 6.309-2.292C17.196 15.66 17.006 13.03 17 13V5a1 1 0 0 0-1-1H9c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h4.078a2.89 2.89 0 0 1-.429 1.396c-.507.801-1.464 1.347-2.845 1.624z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fa904186f097ffd5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.912 8.531 7.121 3.877a.501.501 0 0 0-.704-.166 9.982 9.982 0 0 0-4.396 7.604.505.505 0 0 0 .497.528l5.421.09a4.042 4.042 0 0 1 1.973-3.402zm8.109-4.51a.504.504 0 0 0-.729.151L14.499 8.83a4.03 4.03 0 0 1 1.546 3.112l5.419-.09a.507.507 0 0 0 .499-.53 9.986 9.986 0 0 0-3.942-7.301zm-4.067 11.511a4.015 4.015 0 0 1-1.962.526 4.016 4.016 0 0 1-1.963-.526l-2.642 4.755a.5.5 0 0 0 .207.692A9.948 9.948 0 0 0 11.992 22a9.94 9.94 0 0 0 4.396-1.021.5.5 0 0 0 .207-.692l-2.641-4.755z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$959e6cdafff8b618(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.249 5.025-7.897-2.962-.703 1.873L14.484 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7c0-1.02-.766-1.851-1.751-1.975zM10 17H6v-2h4v2zm6.5 1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm3.5-7H4V7h16v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fecb55976a5a1c00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v6a1 1 0 0 1-2 0V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6h-2zm-6-1v2H6v-2h8zM6 9V7h8v2H6zm8 6v2h-3v-2h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$42b257271691991c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7b2c0b38a6639d82(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-3v2h3a1 1 0 0 0 0-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm2.13 15-2.67-4H10v4H8V7h5a3 3 0 0 1 .79 5.88L16.54 17z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$17f0e40eb4942ced(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5.995h-1v12h1c1.103 0 2-.897 2-2v-8c0-1.102-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17.995V4h2.995V2h-8v2H15v1.995H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11V20h-3.005v2h8v-2H17v-2.005zm-11-4v-4h9v4H6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d74ad7ec6e248965(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 8-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM9 19H7v-9h2v9zm4 0h-2v-6h2v6zm4 0h-2v-3h2v3zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$58daf2275ebbc631(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.485 2 12s4.486 10 10 10c5.515 0 10-4.485 10-10S17.515 2 12 2zm5 14-6-4v4l-6-4 6-4v4l6-4v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e4633b3c5da6e85d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-7-6v5H6v2h6v5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b51e33eab5545b13(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15v-4H7v-2h5V7l5 5-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ed22d27b2f9029f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm4 6h5V7l5 5-5 5v-4H7v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$75a67b431e8a963c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$27ff4a2f40fdd782(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 4.929c-3.898 3.899-3.898 10.244 0 14.143 3.899 3.898 10.243 3.898 14.143 0 3.898-3.899 3.898-10.244 0-14.143-3.9-3.899-10.244-3.899-14.143 0zm10.606 10.607h-7.07l2.828-2.829-3.535-3.536 1.414-1.414 3.535 3.536 2.828-2.829v7.072z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b43d38114ed6f8de(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929c-3.899-3.898-10.243-3.898-14.143 0-3.898 3.899-3.898 10.244 0 14.143 3.899 3.898 10.243 3.898 14.143 0 3.899-3.9 3.899-10.244 0-14.143zm-3.536 10.607-2.828-2.829-3.535 3.536-1.414-1.414 3.535-3.536-2.828-2.829h7.07v7.072z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f573195de7781d79(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.78 15.84S18.64 13 19.61 12c3.07-3 1.54-9.18 1.54-9.18S15 1.29 12 4.36C9.66 6.64 8.14 8.22 8.14 8.22S4.3 7.42 2 9.72L14.25 22c2.3-2.33 1.53-6.16 1.53-6.16zm-1.5-9a2 2 0 0 1 2.83 0 2 2 0 1 1-2.83 0zM3 21a7.81 7.81 0 0 0 5-2l-3-3c-2 1-2 5-2 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c7f22b1ce0023cfe(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.875 7H3.125C1.953 7 1 7.897 1 9v6c0 1.103.953 2 2.125 2h17.75C22.047 17 23 16.103 23 15V9c0-1.103-.953-2-2.125-2zM7 12H5V9h2v3zm4 1H9V9h2v4zm4-1h-2V9h2v3zm4 1h-2V9h2v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2b70f449db73b6ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zM8 17s1-3 4-3 4 3 4 3H8zm7.493-5.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$280217b8bac7e2f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V8l-5-5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zM7 5h4v2h2V5h2v4H7V5zm0 8h10v6H7v-6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f494df9898bbe930(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-2V4h1V2H4v2h1v6H3a1 1 0 0 0-1 1v9h20v-9a1 1 0 0 0-1-1zm-7 8v-4h-4v4H7V4h10v14h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h2v2H9zm4 0h2v2h-2zm-4 4h2v2H9zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$41b479607ed408e8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604-1.392-1.358a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.967 6.967 0 0 0 16 9c0-3.859-3.141-7-7-7S2 5.141 2 9s3.141 7 7 7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$924501c421a18b18(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fd2d3fdf063c065d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6.933 12.481-3.274-3.274 1.414-1.414 1.726 1.726 4.299-5.159 1.537 1.281-5.702 6.84z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h11v-2H4V8H2v12c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3c6c57793986ba22(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.426 11.095-17-8A1 1 0 0 0 3.03 4.242l1.212 4.849L12 12l-7.758 2.909-1.212 4.849a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$503afd7b083fc939(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-5 5h-2V6h2zm4 0h-2V6h2zm1 5H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-5 5h-2v-2h2zm4 0h-2v-2h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d3dd88e43df617b6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.867 2.504c-.355-.624-1.381-.623-1.736 0l-3.999 7A1 1 0 0 0 13 11h8a1.001 1.001 0 0 0 .868-1.496l-4.001-7zM3 22h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1zm14.5-9c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3ead7095a42bac6e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 0 0 6 9c-1.654 0-3 1.346-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a7a3dd25e75f94a4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.914V2.586L6.293 7.293l-3.774 3.774 3.841 3.201L11 18.135V13.9c8.146-.614 11 4.1 11 4.1 0-2.937-.242-5.985-2.551-8.293C16.765 7.022 12.878 6.832 11 6.914z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$54163a20de539fb0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.881 5.223a.496.496 0 0 0-.747-.412c-.672.392-1.718.898-2.643.898-.421 0-.849-.064-1.289-.198a5.712 5.712 0 0 1-.808-.309c-1.338-.639-2.567-1.767-3.696-2.889a1.008 1.008 0 0 0-.698-.29 1.008 1.008 0 0 0-.698.29c-1.129 1.122-2.358 2.25-3.696 2.889h-.001a5.655 5.655 0 0 1-.807.309c-.44.134-.869.198-1.289.198-.925 0-1.971-.507-2.643-.898a.496.496 0 0 0-.747.412c-.061 1.538-.077 4.84.688 7.444 1.399 4.763 4.48 7.976 8.91 9.292l.14.041.14-.014V22v-.014H12l.143.014.14-.041c4.43-1.316 7.511-4.529 8.91-9.292.765-2.604.748-5.906.688-7.444z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c405eff96221d42(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.43 5.76-8-3.56a1 1 0 0 0-.82 0l-8 3.56a1 1 0 0 0-.59.9c0 2.37.44 10.8 8.51 15.11a1 1 0 0 0 1 0c8-4.3 8.58-12.71 8.57-15.1a1 1 0 0 0-.67-.91zm-4.43 7H8v-2h8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$82725bc2104bbb22(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.43 5.76-8-3.56a1 1 0 0 0-.82 0l-8 3.56a1 1 0 0 0-.59.9c0 2.37.44 10.8 8.51 15.11a1 1 0 0 0 1 0c8-4.3 8.58-12.71 8.57-15.1a1 1 0 0 0-.67-.91zm-4.43 7h-3v3h-2v-3H8v-2h3v-3h2v3h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$221ae7b904d1e7b1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.492 21.771c.294.157.663.157.957-.001 8.012-4.304 8.581-12.713 8.574-15.104a.988.988 0 0 0-.596-.903l-8.051-3.565a1.005 1.005 0 0 0-.813.001L3.57 5.765a.988.988 0 0 0-.592.891c-.034 2.379.445 10.806 8.514 15.115zM8.293 9.707l1.414-1.414L12 10.586l2.293-2.293 1.414 1.414L13.414 12l2.293 2.293-1.414 1.414L12 13.414l-2.293 2.293-1.414-1.414L10.586 12 8.293 9.707z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e9a2a6c2a4a696de(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.496 6.106-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967a1 1 0 0 0-.547-.797z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4013c1f4aa2a712b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.997 20c-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.446.676-3.125 1.22-.587.469-.975.78-1.874.78-.897 0-1.285-.311-1.872-.78C4.444 18.676 3.601 18 2 18v2c.898 0 1.286.311 1.873.78.679.544 1.523 1.22 3.122 1.22 1.601 0 2.445-.676 3.124-1.219.588-.47.976-.781 1.875-.781.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219s2.446-.676 3.125-1.219C20.689 20.328 21.1 20 22 20v-2c-1.602 0-2.447.676-3.127 1.219-.588.47-.977.781-1.876.781zM6 8.5 4 9l2 8h.995c1.601 0 2.445-.676 3.124-1.219.588-.47.976-.781 1.875-.781.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219H18l.027-.107.313-1.252L20 9l-2-.5V5.001a1 1 0 0 0-.804-.981L13 3.181V2h-2v1.181l-4.196.839A1 1 0 0 0 6 5.001V8.5zm2-2.681 4-.8 4 .8V8l-4-1-4 1V5.819z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5182c68f98565fe7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm5 7.5c-1.657 0-3-1.119-3-2.5s1.343-2.5 3-2.5 3 1.119 3 2.5-1.343 2.5-3 2.5zm3.493-6.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1715ce3c7455dc13(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3a1 1 0 0 0-1 1v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1zm-9 9c-3.309 0-6-2.691-6-6h2c0 2.206 1.794 4 4 4s4-1.794 4-4h2c0 3.309-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cdd33c06b8663c02(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-3v-.777c0-2.609-1.903-4.945-4.5-5.198A5.005 5.005 0 0 0 7 7v1H4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm12-12v2h-2v-2h2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-2 3h2v2H7v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$af9a1bb1f2c69360(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h2V10a1 1 0 0 1 1-1h12V7a1 1 0 0 0-1-1h-3.051c-.252-2.244-2.139-4-4.449-4S6.303 3.756 6.051 6H3a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm6.5-16c1.207 0 2.218.86 2.45 2h-4.9c.232-1.14 1.243-2 2.45-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H9a1 1 0 0 0-1 1v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a1 1 0 0 0-1-1zm-6 7c-2.757 0-5-2.243-5-5h2c0 1.654 1.346 3 3 3s3-1.346 3-3h2c0 2.757-2.243 5-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e53edcdd02eac2e9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.084 0-2 .916-2 2s.916 2 2 2 2-.916 2-2-.916-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c1755153e71432ae(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18.33A6.78 6.78 0 0 0 19.5 15a6.73 6.73 0 0 0-1.5 3.33 1.51 1.51 0 1 0 3 0zM11 20.33A6.78 6.78 0 0 0 9.5 17 6.73 6.73 0 0 0 8 20.33 1.59 1.59 0 0 0 9.5 22a1.59 1.59 0 0 0 1.5-1.67zM16 20.33A6.78 6.78 0 0 0 14.5 17a6.73 6.73 0 0 0-1.5 3.33A1.59 1.59 0 0 0 14.5 22a1.59 1.59 0 0 0 1.5-1.67zM6 18.33A6.78 6.78 0 0 0 4.5 15 6.73 6.73 0 0 0 3 18.33 1.59 1.59 0 0 0 4.5 20 1.59 1.59 0 0 0 6 18.33zM2 12h20v2H2zM13 4.07V2h-2v2.07A8 8 0 0 0 4.07 11h15.86A8 8 0 0 0 13 4.07z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4ce4194f80922dce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4 14h-2v-4l-6 4V8l6 4V8h2v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$669464e6abb963ac(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2zm4 14-6-4v4H8V8h2v4l6-4v8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$25ef6c0a72592305(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C5.505 2 2 6.637 2 11c0 2.129 1.009 3.979 3 5.508V21h3v-3h2v3h4v-3h2v3h3v-4.493c1.991-1.528 3-3.379 3-5.507 0-4.363-3.505-9-10-9zM8 13c-1.121 0-2-1.098-2-2.5S6.879 8 8 8s2 1.098 2 2.5S9.121 13 8 13zm8 0c-1.121 0-2-1.098-2-2.5S14.879 8 16 8s2 1.098 2 2.5-.879 2.5-2 2.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aa594291ab1ea7ca(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-4 9.01-2-.02C6.017 9.386 7.095 7 10 7v2c-1.924 0-1.998 1.805-2 2.01zM12 18c-1.657 0-3-1.119-3-2.5s1.343-2.5 3-2.5 3 1.119 3 2.5-1.343 2.5-3 2.5zm5-7-1 .008C15.992 10.536 15.826 9 14 9V7c2.935 0 4 2.393 4 4h-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$603af3737068d887(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM10 13V7l5 3-5 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c8727c7e2b4a67fa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm3.493-13a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 9zm-4.301 6.919a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117a6.027 6.027 0 0 1-1.619 1.621 6.003 6.003 0 0 1-2.149.904 6.116 6.116 0 0 1-2.414-.001 5.919 5.919 0 0 1-2.148-.903 6.078 6.078 0 0 1-1.621-1.622l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 2.022 1.093zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fcf5dfccec802898(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.227 11h11.547c.862 0 1.32-1.02.747-1.665L12.748 2.84a.998.998 0 0 0-1.494 0L5.479 9.335C4.906 9.98 5.364 11 6.227 11zm5.026 10.159a.998.998 0 0 0 1.494 0l5.773-6.495c.574-.644.116-1.664-.747-1.664H6.227c-.862 0-1.32 1.02-.747 1.665l5.773 6.494z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4729a95bd88df748(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.114c-3.998-5.951-8.574-7.043-8.78-7.09L2 8.75V10c0 7.29 3.925 12 10 12 5.981 0 10-4.822 10-12V8.75l-1.22.274c-.206.047-4.782 1.139-8.78 7.09z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.274 3.767c-1.799 1.898-2.84 3.775-3.443 5.295 1.329.784 2.781 1.943 4.159 3.685 1.364-1.76 2.826-2.925 4.17-3.709-.605-1.515-1.646-3.383-3.435-5.271L12 3l-.726.767z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97af10849d7258e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "15",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm0 16a5 5 0 1 1 5-5 5 5 0 0 1-5 5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e3f4501376ec5ad8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.003 3h2v2h-2zM16 3h2v2h-2zm0 3h2v2h-2zm3-3h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zM4.012 12v9a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1v-9a4 4 0 0 0-4-4H8.012a4 4 0 0 0-4 4zM7.003 2h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de5f73d2da2c02e2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm7 2h8v2h-8V7zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2zM6 7h2v2H6V7zm0 4h2v2H6v-2zm0 4h2v2H6v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$36727ac736765a1b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5dd314a311ad48ee(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$51e86a55e0364972(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.025 20.775A.998.998 0 0 0 6 22a1 1 0 0 0 .555-.168L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082a1 1 0 0 0-.59-1.74l-5.701-.454-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.214 4.107-1.491 6.452zM12 5.429l2.042 4.521.588.047h.001l3.972.315-3.271 2.944-.001.002-.463.416.171.597v.003l1.253 4.385L12 15.798V5.429z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bbf5c63ab3baf1ad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.947 9.179a1.001 1.001 0 0 0-.868-.676l-5.701-.453-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.213 4.107-1.49 6.452a1 1 0 0 0 1.53 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082c.297-.268.406-.686.278-1.065z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9c87249216e4922b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c-4.136 0-7.5 3.364-7.5 7.5 0 .871.157 1.704.432 2.482l9.551-9.551A7.462 7.462 0 0 0 18.5 11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 4.583 3.158 8.585 7.563 9.69A9.431 9.431 0 0 1 9 18.5C9 13.262 13.262 9 18.5 9c1.12 0 2.191.205 3.19.563C20.585 5.158 16.583 2 12 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$40470c68e24c1eff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm1 8h-2V8h2v5zM9 2h6v2H9zm9.707 2.293 2 2-1.414 1.414-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dbf7b9ab8664696(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5C3.346 2 2 3.346 2 5v2.831c0 1.053.382 2.01 1 2.746V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h4v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9.424c.618-.735 1-1.692 1-2.746V5c0-1.654-1.346-3-3-3zm1 3v2.831c0 1.14-.849 2.112-1.891 2.167L18 10c-1.103 0-2-.897-2-2V4h3c.552 0 1 .449 1 1zM10 8V4h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zM4 5c0-.551.448-1 1-1h3v4c0 1.103-.897 2-2 2l-.109-.003C4.849 9.943 4 8.971 4 7.831V5zm6 11H6v-3h4v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d71ed526451202d6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.999 8a.997.997 0 0 0-.143-.515L19.147 2.97A2.01 2.01 0 0 0 17.433 2H6.565c-.698 0-1.355.372-1.714.971L2.142 7.485A.997.997 0 0 0 1.999 8c0 1.005.386 1.914 1 2.618V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h4v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9.382c.614-.704 1-1.613 1-2.618zm-2.016.251A2.002 2.002 0 0 1 17.999 10c-1.103 0-2-.897-2-2 0-.068-.025-.128-.039-.192l.02-.004L15.219 4h2.214l2.55 4.251zm-9.977-.186L10.818 4h2.361l.813 4.065C13.957 9.138 13.079 10 11.999 10s-1.958-.862-1.993-1.935zM6.565 4h2.214l-.76 3.804.02.004c-.015.064-.04.124-.04.192 0 1.103-.897 2-2 2a2.002 2.002 0 0 1-1.984-1.749L6.565 4zm3.434 12h-4v-3h4v3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2152f732f3bc4dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.995 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007-2.246-5.007-5.007-5.007S6.995 9.239 6.995 12zM11 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2H2zm17 0h3v2h-3zM5.637 19.778l-1.414-1.414 2.121-2.121 1.414 1.414zM16.242 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.344 7.759 4.223 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$20171b54b647f187(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12.07",
                    "cy": "7",
                    "rx": "3",
                    "ry": "1.71"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.07 22c4.48 0 8-2.2 8-5V7c0-2.8-3.52-5-8-5s-8 2.2-8 5v10c0 2.8 3.51 5 8 5zm0-18c3.53 0 6 1.58 6 3a2 2 0 0 1-.29.87c-.68 1-2.53 2-5 2.12h-1.39C8.88 9.83 7 8.89 6.35 7.84a2.16 2.16 0 0 1-.28-.76V7c0-1.42 2.46-3 6-3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ff3e8e27a7ea3126(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.316 4.055C19.556 3.478 15 1.985 15 2a3 3 0 1 1-6 0c0-.015-4.556 1.478-6.317 2.055A.992.992 0 0 0 2 5.003v3.716a1 1 0 0 0 1.242.97L6 9v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9l2.758.689A1 1 0 0 0 22 8.719V5.003a.992.992 0 0 0-.684-.948z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$209431032318eb90(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0 0 22 14c0-5.514-4.486-10-10-10zm5.022 5.022L13.06 15.06a1.53 1.53 0 0 1-2.121.44 1.53 1.53 0 0 1 0-2.561l6.038-3.962a.033.033 0 0 1 .045.01.034.034 0 0 1 0 .035z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$616cd900537fc02b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.868 11.504-4-7A1 1 0 0 0 17 4H3a1 1 0 0 0-.868 1.496L5.849 12l-3.717 6.504A1 1 0 0 0 3 20h14a1 1 0 0 0 .868-.504l4-7a.998.998 0 0 0 0-.992z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ebd787fd2ccad269(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.842 6.218a1.977 1.977 0 0 0-.424-.628A1.99 1.99 0 0 0 20 5H8c-.297 0-.578.132-.769.359l-5 6c-.309.371-.309.91 0 1.281l5 6c.191.228.472.36.769.36h12a1.977 1.977 0 0 0 1.41-.582A1.99 1.99 0 0 0 22 17V7c0-.266-.052-.525-.158-.782zm-4.135 8.075-1.414 1.414L14 13.414l-2.293 2.293-1.414-1.414L12.586 12l-2.293-2.293 1.414-1.414L14 10.586l2.293-2.293 1.414 1.414L15.414 12l2.293 2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$295860ad2c918c62(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.842 6.218a1.977 1.977 0 0 0-.424-.628A1.99 1.99 0 0 0 20 5H8c-.297 0-.578.132-.769.359l-5 6c-.309.371-.309.91 0 1.281l5 6c.191.228.472.36.769.36h12a1.977 1.977 0 0 0 1.41-.582A1.99 1.99 0 0 0 22 17V7c0-.266-.052-.525-.158-.782z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$37f0ee9e2904b03c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.155-1.368-4.104A2.995 2.995 0 0 0 16.559 4H14V2h-4v2H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7d3bcdddfb7d4e8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.071a9.953 9.953 0 0 0 6.692 2.906c-.463-2.773.365-5.721 2.5-7.856 2.136-2.135 5.083-2.963 7.856-2.5-.092-2.433-1.053-4.839-2.906-6.692s-4.26-2.814-6.692-2.906c.463 2.773-.365 5.721-2.5 7.856-2.136 2.135-5.083 2.963-7.856 2.5a9.944 9.944 0 0 0 2.906 6.692z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 15.535a6.996 6.996 0 0 0-1.911 6.318 9.929 9.929 0 0 0 8.229-8.229 6.999 6.999 0 0 0-6.318 1.911zm-7.07-7.07a6.996 6.996 0 0 0 1.911-6.318 9.929 9.929 0 0 0-8.23 8.229 7 7 0 0 0 6.319-1.911z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b812ffd7d56d8b80(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6.414 15.707 5 14.293 7.293 12 5 9.707l1.414-1.414L10.121 12l-3.707 3.707zM19 16h-7v-2h7v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8be82fd61d0bb5fa(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16a3.001 3.001 0 0 0 6 0c0-.353-.072-.686-.184-1H9.184A2.962 2.962 0 0 0 9 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4h-3.185A2.995 2.995 0 0 0 12 2c-1.654 0-3 1.346-3 3v5.8A6.027 6.027 0 0 0 6 16c0 3.309 2.691 6 6 6s6-2.691 6-6a6.027 6.027 0 0 0-3-5.2V10h3V8h-3V6h3zm-4.405 6.324A4.033 4.033 0 0 1 16 16c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.585.944-3.027 2.405-3.676l.595-.263V5a1 1 0 0 1 2 0v7.061l.595.263z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eb0f4751ff03bdf6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.293 14.707L11 12.414V6h2v5.586l3.707 3.707-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7ac6c9edf8642113(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.25 2c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zM18 13h-6.75V6h2v5H18v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f04e11a946998f00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2zm19.707-5.293-1.414-1.414L18.586 7A6.937 6.937 0 0 0 15 6c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7a6.968 6.968 0 0 0-1.855-4.73l1.562-1.563zM16 14h-2V8.958h2V14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9f631067c315bb03(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6.447 9.105 2.459-1.229-1.567-1.044 1.109-1.664 3 2a1 1 0 0 1-.108 1.727l-4 2-.893-1.79zM8 17s1-3 4-3 4 3 4 3H8zm9.553-4.105-4-2a1 1 0 0 1-.108-1.727l3-2 1.109 1.664-1.566 1.044 2.459 1.229-.894 1.79z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$95135e1096aa2cc2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h4v6h6v-6h4l-7-8zM4 3h16v2H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$96e7a904080b9d85(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8a6.01 6.01 0 0 0 6-5.994v-.018C21.985 8.685 19.297 6 16 6zm-8 9c-1.627 0-3-1.373-3-3s1.373-3 3-3 3 1.373 3 3-1.373 3-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c143f7490f01228e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8c3.309 0 6-2.691 6-6s-2.691-6-6-6zm0 9c-1.627 0-3-1.373-3-3s1.373-3 3-3 3 1.373 3 3-1.373 3-3 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$695d9bd5435e87a6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 9H4.069a7.965 7.965 0 0 1 .52-2H11v2zm0 4H4.589a7.965 7.965 0 0 1-.52-2H11v2zm0-10.931V7H5.765A7.996 7.996 0 0 1 11 4.069zM5.765 17H11v2.931A7.996 7.996 0 0 1 5.765 17z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bef3e79591b97402(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.648V20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8.352c1.067-.552 3-1.928 3-4.648V5H5v2c0 2.72 1.933 4.096 3 4.648zM11 11h2v3h-2v-3zM5 2h14v2H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$664d960e94823f2e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2V3h-2v3H7V3H5v3H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v6h2v-6h10v6h2v-6h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM4.42 13l2.857-5H9.58l-2.857 5H4.42zm7.857-5h2.303l-2.857 5H9.42l2.857-5zm5 0h2.303l-2.857 5H14.42l2.857-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$442c60b8a6742c5c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.649 16H5.352l-1.06 3H2v2h20v-2h-2.292zM6.057 14h11.886l-1.412-4H7.469zM13 2h-2a1 1 0 0 0-.943.667L8.175 8h7.65l-1.882-5.333A1 1 0 0 0 13 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c6d7e92aef41fb74(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.958 16 .043 1.042c.005.12.142 2.255 2.999 3.338v1.12a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1.12c2.857-1.083 2.994-3.218 2.999-3.338L21.043 16H18v-1.62c2.857-1.083 2.994-3.218 2.999-3.338L21.043 10H18V8.38c2.857-1.083 2.994-3.218 2.999-3.338L21.043 4H18V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V4H2.958l.043 1.042c.005.12.142 2.255 2.999 3.338V10H2.958l.043 1.042c.005.12.142 2.255 2.999 3.338V16H2.958zM12 4a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 4zm0 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 10zm0 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$147f6d9770d6442f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.375 2H7.621c-.224 0-1.399.065-2.503 1.351C4.031 4.616 4 5.862 4 6v11a2 2 0 0 0 2 2h1l-2 3h2.353l.667-1h8l.677 1H19l-2-3h1a2 2 0 0 0 2-2V6c.001-.188-.032-1.434-1.129-2.665C17.715 2.037 16.509 2 16.375 2zM10 4h4v2h-4V4zM7.5 17a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 7.5 17zm9 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16.5 17zm1.5-5H6V8h12v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97846075833a2890(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H6zm10.618-3L15 2H9L7.382 4H3v2h18V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5db9d3794d95048e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H6zm4 12H8v-9h2v9zm6 0h-2v-9h2v9zm.618-15L15 2H9L7.382 4H3v2h18V4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e1391db622662af4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 10-6-8-6 8h3l-5 8h7v4h2v-4h7l-5-8h3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2bb72cd21c764ca2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 18-4-5h3l-4-5h2l-5-6-5 6h2l-4 5h3l-4 5h7v4h2v-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3574ee208b4a8def(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3c0 4.31 1.8 6.91 4.82 7A6 6 0 0 0 11 17.91V20H9v2h6v-2h-2v-2.09A6 6 0 0 0 17.18 15c3-.1 4.82-2.7 4.82-7V5a1 1 0 0 0-1-1zM4 8V6h2v6.83C4.22 12.08 4 9.3 4 8zm14 4.83V6h2v2c0 1.3-.22 4.08-2 4.83z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6c3d41b3a2012775(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.15 8a2 2 0 0 0-1.72-1H15V5a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 1 1.73 3.49 3.49 0 0 0 7 .27h3.1a3.48 3.48 0 0 0 6.9 0 2 2 0 0 0 2-2v-3a1.07 1.07 0 0 0-.14-.52zM15 9h2.43l1.8 3H15zM6.5 19A1.5 1.5 0 1 1 8 17.5 1.5 1.5 0 0 1 6.5 19zm10 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$db6ef685f3262dcb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-5.586l2.293-2.293-1.414-1.414L12 5.586 8.707 2.293 7.293 3.707 9.586 6H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1e294517557064c3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 3.33A1.67 1.67 0 1 1 10.33 7 1.67 1.67 0 0 1 12 5.33zm3.33 12.5-1.66.84-1.39-3.89h-.56l-1.39 3.89-1.66-.84 1.66-4.72v-1.66L7 10.33l.56-1.66 3.33 1.11h2.22l3.33-1.11.56 1.66-3.33 1.12v1.66z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$96e5eb28c83f15f5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18v-6h5l-6-7-6 7h5v6z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6961490adaaebda5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-15 5 5h-4v5h-2v-5H7l5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f329fcb48f7b69bc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm7-14 5 5h-4v5h-2v-5H7l5-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ad32abbfe9f695f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8c8fede8b81d9866(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.507 15a1.494 1.494 0 1 1 .001-2.987A1.494 1.494 0 0 1 8.507 15zm4.301-6.919a4.108 4.108 0 0 0-1.616 0 4.12 4.12 0 0 0-.751.233c-.234.1-.463.224-.678.368a4.077 4.077 0 0 0-1.08 1.082L7.024 8.646a6.026 6.026 0 0 1 2.639-2.175 6.097 6.097 0 0 1 1.128-.35 6.061 6.061 0 0 1 2.415 0 5.919 5.919 0 0 1 2.148.903 6.078 6.078 0 0 1 1.621 1.622l-1.658 1.117a3.994 3.994 0 0 0-.488-.59 3.988 3.988 0 0 0-2.021-1.092zM15.5 15a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 15.5 15z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1eb73ee974daa647(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2c74c7a111a04c5c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM19 15H9v-.25C9 12.901 11.254 11 14 11s5 1.901 5 3.75V15z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2c5258cac6a902be(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.988 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h11.988zM9 5h6v2H9V5zm5.25 6.25A2.26 2.26 0 0 1 12 13.501c-1.235 0-2.25-1.015-2.25-2.251S10.765 9 12 9a2.259 2.259 0 0 1 2.25 2.25zM7.5 18.188c0-1.664 2.028-3.375 4.5-3.375s4.5 1.711 4.5 3.375v.563h-9v-.563z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c1727116c14f5f24(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm11.294-4.708-4.3 4.292-1.292-1.292-1.414 1.414 2.706 2.704 5.712-5.702z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e5f0ae3c1218669b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 5c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zm-5.106 9.772c.897-1.32 2.393-2.2 4.106-2.2h2c1.714 0 3.209.88 4.106 2.2C15.828 18.14 14.015 19 12 19s-3.828-.86-5.106-2.228z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$91119298a5b9077f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$73acf5ffb5cf071e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11h8v2h-8zM4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$68a652f334808ec0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h4l3 3 3-3h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-7 3c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zM7.177 16c.558-1.723 2.496-3 4.823-3s4.266 1.277 4.823 3H7.177z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$10bebbf351122e40(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5zM19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5f8b92627508603c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h1zm6-17.001c1.647 0 3 1.351 3 3C15 9.647 13.647 11 12 11S9 9.647 9 7.999c0-1.649 1.353-3 3-3zM6 17.25c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18H6v-.75z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$61b7228d0e89d91a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm9.364-10.364L16.95 4.05C18.271 5.373 19 7.131 19 9s-.729 3.627-2.05 4.95l1.414 1.414C20.064 13.663 21 11.403 21 9s-.936-4.663-2.636-6.364z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 5.464 14.121 6.88C14.688 7.445 15 8.198 15 9s-.312 1.555-.879 2.12l1.414 1.416C16.479 11.592 17 10.337 17 9s-.521-2.592-1.465-3.536z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ede029fdffd5644(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm11.293-4.707L18 10.586l-2.293-2.293-1.414 1.414 2.292 2.292-2.293 2.293 1.414 1.414 2.293-2.293 2.294 2.294 1.414-1.414L19.414 12l2.293-2.293z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$10f384485a90f963(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8b6c0d5e95868ed5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.277 8c.347.596.985 1 1.723 1a2 2 0 0 0 0-4c-.738 0-1.376.404-1.723 1H16V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H5.723C5.376 5.404 4.738 5 4 5a2 2 0 0 0 0 4c.738 0 1.376-.404 1.723-1H8v.368C5.134 9.839 4.319 12.534 4.092 14H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.984.984 0 0 0 9 11h6a.98.98 0 0 0 .792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277zM14 9h-4V5h4v4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$28278e330dcfb3ab(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22a4.965 4.965 0 0 0 3.535-1.465l9.193-9.193.707.708 1.414-1.414-8.485-8.486-1.414 1.414.708.707-9.193 9.193C2.521 14.408 2 15.664 2 17s.521 2.592 1.465 3.535A4.965 4.965 0 0 0 7 22zM18.314 9.928 15.242 13H6.758l7.314-7.314 4.242 4.242z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9a03ea482c207bad(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h10.879L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2zM18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cf1782e0374339bf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3.333L22 17V7l-4 3.333V7zm-4 6h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$89b9c61e6b5bc8c5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9c0-1.103-.897-2-2-2h-1.434l-2.418-4.029A2.008 2.008 0 0 0 10.434 2H5v2h5.434l1.8 3H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3l4 2v-7l-4 2V9zm-7 8H5v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6a3f670868743012(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d9b35407e199610b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12a2 2 0 0 0 2 2h12v-2H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-9 12V6l7 4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a314b2d1afcb2c18(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.952 17.538c-.749-.749-.908-1.869-.5-2.846l.021-.049c.399-.974 1.309-1.643 2.362-1.643h.08c.638 0 1.085-.447 1.085-1s-.447-1-1-1h-.17c-1.053 0-1.958-.669-2.357-1.644l-.021-.049c-.408-.977-.249-2.097.5-2.846l.119-.119a.999.999 0 1 0-1.414-1.414l-.119.119c-.749.749-1.869.908-2.846.5l-.049-.021C13.669 5.128 13 4.218 13 3.165v-.081C13 2.447 12.553 2 12 2s-1 .447-1 1v.036c0 1.096-.66 2.084-1.673 2.503l-.006.003a2.71 2.71 0 0 1-2.953-.588l-.025-.025-2.636-2.636-1.414 1.414 18 18 1.414-1.414-2.636-2.636-.119-.119zM12 10a2 2 0 1 1 2 2c-.257 0-.501-.053-.728-.142l-1.131-1.131A1.998 1.998 0 0 1 12 10zm-4 3a1 1 0 0 1-1-1 .99.99 0 0 1 .244-.635L5.431 9.552A2.634 2.634 0 0 1 3.085 11h-.001C2.447 11 2 11.447 2 12s.447 1 1 1h.068a2.66 2.66 0 0 1 2.459 1.644l.021.049a2.69 2.69 0 0 1-.583 2.929l-.036.036a.999.999 0 1 0 1.414 1.414l.036-.036a2.689 2.689 0 0 1 2.929-.583l.143.06A2.505 2.505 0 0 1 11 20.83v.085c0 .638.447 1.085 1 1.085s1-.448 1-1v-.17c0-.976.568-1.853 1.443-2.266l-5.809-5.809A.98.98 0 0 1 8 13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4c46c39b1584a9dd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-.17c-1.053 0-1.958-.669-2.357-1.644l-.021-.049c-.408-.977-.249-2.097.5-2.846l.119-.119a.999.999 0 1 0-1.414-1.414l-.119.119c-.749.749-1.869.908-2.846.5l-.049-.021C13.669 5.128 13 4.218 13 3.165v-.081C13 2.447 12.553 2 12 2s-1 .447-1 1v.036c0 1.096-.66 2.084-1.673 2.503l-.006.003a2.71 2.71 0 0 1-2.953-.588l-.025-.025a.999.999 0 1 0-1.414 1.414l.036.036a2.69 2.69 0 0 1 .583 2.929l-.027.064A2.638 2.638 0 0 1 3.085 11h-.001C2.447 11 2 11.447 2 12s.447 1 1 1h.068a2.66 2.66 0 0 1 2.459 1.644l.021.049a2.69 2.69 0 0 1-.583 2.929l-.036.036a.999.999 0 1 0 1.414 1.414l.036-.036a2.689 2.689 0 0 1 2.929-.583l.143.06A2.505 2.505 0 0 1 11 20.83v.085c0 .638.447 1.085 1 1.085s1-.448 1-1v-.17c0-1.015.611-1.93 1.55-2.318l.252-.104a2.508 2.508 0 0 1 2.736.545l.119.119a.999.999 0 1 0 1.414-1.414l-.119-.119c-.749-.749-.908-1.869-.5-2.846l.021-.049c.399-.975 1.309-1.644 2.362-1.644h.08c.638 0 1.085-.447 1.085-1s-.447-1-1-1zM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm5 3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-4.5a2 2 0 1 1 .001-4.001A2 2 0 0 1 14 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f2b538637edf5d72(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21c3.527-1.547 5.999-4.909 5.999-9S19.527 4.547 16 3v2c2.387 1.386 3.999 4.047 3.999 7S18.387 17.614 16 19v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5zM4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1d77e16abb4f369d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zM16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b95c71941b124c5e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.727 6.313-4.02-4.02-1.414 1.414 18 18 1.414-1.414-2.02-2.02A9.578 9.578 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.13 8.13 0 0 1-1.671 4.914l-1.286-1.286C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V2.132L7.727 6.313zM4 17h2.697L14 21.868v-3.747L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6d130e1361c2f715(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eead8f73f805f425(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h8v6h-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2v-2h-8c-1.103 0-2-.897-2-2V9c0-1.103.897-2 2-2h8V5c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cdda49412254e6a0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-2 9h-2v-4h2v4zM5 7a1.001 1.001 0 0 1 0-2h13v2H5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f30acef13d2bcfd9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1zM18 3.924a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 7c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.766 16.929c1.399-.261 2.571-1.315 3.023-2.665a3.853 3.853 0 0 0-.153-2.893.482.482 0 0 0-.544-.266c-.604.149-1.019.448-1.5.801-.786.577-1.765 1.294-3.592 1.294-.813 0-1.45-.146-1.984-.354l-.013.009a4.006 4.006 0 0 0 4.763 4.074z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8aee02d4ff3a9ae8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0-.909-.613-1.67-1.445-1.912l-1.31-3.443A1 1 0 0 0 14.311 2H8.689a1 1 0 0 0-.934.645l-1.31 3.443A1.996 1.996 0 0 0 5 8v8c0 .909.613 1.67 1.445 1.912l1.31 3.443a1 1 0 0 0 .934.645h5.621c.415 0 .787-.257.935-.645l1.31-3.443A1.996 1.996 0 0 0 18 16v-2h1v-4h-1V8zm-1.998 8H7V8h9l.002 8z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6cfa2e9a22c95acd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v5h5v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 12c0-2.953-1.612-5.53-3.999-6.916V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2.083C5.613 6.469 4.001 9.047 4.001 12a8.003 8.003 0 0 0 4.136 7H8v2.041a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V19h-.139a8 8 0 0 0 4.138-7zm-8 5.999A6.005 6.005 0 0 1 6.001 12a6.005 6.005 0 0 1 5.998-5.999c3.31 0 6 2.691 6 5.999a6.005 6.005 0 0 1-6 5.999z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$296d5cb8e095d6da(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.037-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.963-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm-1.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 10.5 11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1b0f885b351e9d3b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm0 10h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm7.293-14.707-3.586-3.586a.999.999 0 0 0-1.414 0l-3.586 3.586a.999.999 0 0 0 0 1.414l3.586 3.586a.999.999 0 0 0 1.414 0l3.586-3.586a.999.999 0 0 0 0-1.414z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f50baf60f0e85cb4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-3 3h2v2h-2V6zm-3 0h2v2h-2V6zM4 19v-9h16.001l.001 9H4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e2762442cb01230a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17.916V20H9v2h6v-2h-2v-2.084c3.162-.402 5.849-2.66 6.713-5.793.264-.952.312-2.03.143-3.206l-.866-6.059A1 1 0 0 0 18 2H6a1 1 0 0 0-.99.858l-.865 6.058c-.169 1.177-.121 2.255.143 3.206.863 3.134 3.55 5.392 6.712 5.794zM17.133 4l.57 4H6.296l.571-4h10.266z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5ab5e911e56ef25f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9zm7.741 7.244a5.982 5.982 0 0 1-3.034 1.634 6.042 6.042 0 0 1-3.541-.349 5.997 5.997 0 0 1-2.642-2.176l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 1.273.86c.243.102.495.181.749.232a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117c-.214.32-.461.62-.734.891zM13 12s.5-2 2.5-2c1.999 0 2.5 2 2.5 2h-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d530df7cf7d81014(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19v-4h-4v4c0 1.103.897 2 2 2s2-.897 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 4.434 2.903 8.198 6.906 9.505A3.969 3.969 0 0 1 8 19v-2.499C6.412 15.027 6 13 6 13h12s-.411 2.027-2 3.501V19c0 .953-.349 1.816-.906 2.504C19.097 20.197 22 16.434 22 12c0-5.514-4.486-10-10-10zm-3.5 9a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 11zm4.5 0s.5-2 2.5-2c1.999 0 2.5 2 2.5 2h-5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$68edfb13e606982(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.512 6.112-3.89 3.889-3.535-3.536 3.889-3.889a6.501 6.501 0 0 0-8.484 8.486l-6.276 6.275a.999.999 0 0 0 0 1.414l2.122 2.122a.999.999 0 0 0 1.414 0l6.275-6.276a6.501 6.501 0 0 0 7.071-1.414 6.504 6.504 0 0 0 1.414-7.071z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$265b80c3c2cb9021(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b093506895e0ed65(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5zm-4.793 9.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8e99ba9dd4968cd0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.062 4.938A9.942 9.942 0 0 0 12.016 2h-.026a9.94 9.94 0 0 0-7.071 2.938c-3.898 3.898-3.898 10.243 0 14.143 1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.9-3.899 3.9-10.243.001-14.143zM13.5 15a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 13.5 15zM6.333 6.353A7.953 7.953 0 0 1 11.99 4l.026.001c1.652.008 3.242 1.066 3.55 2.371.366 1.552-1.098 3.278-4.018 4.737-5.113 2.555-5.312 5.333-4.975 6.762l.008.021c-.082-.075-.169-.146-.249-.226-3.118-3.119-3.118-8.194.001-11.313z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9a1a871ccad6726c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.98 11.802a.995.995 0 0 0-.738-.771l-6.86-1.716 2.537-5.921a.998.998 0 0 0-.317-1.192.996.996 0 0 0-1.234.024l-11 9a1 1 0 0 0 .39 1.744l6.719 1.681-3.345 5.854A1.001 1.001 0 0 0 8 22a.995.995 0 0 0 .6-.2l12-9a1 1 0 0 0 .38-.998z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d6644c5099748afb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8zm4 9h-3v3H9v-3H6V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$58fc48982ffa3bbd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zM6 9h8v2H6V9z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$aa52300c49db39e0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.379 14.791c.004.01.098.269.151.396a5.859 5.859 0 0 0 1.258 1.865 5.86 5.86 0 0 0 6.437 1.259 5.876 5.876 0 0 0 3.124-3.125 5.802 5.802 0 0 0 .461-2.285c0-.793-.153-1.563-.461-2.287a5.862 5.862 0 0 0-1.257-1.864 5.86 5.86 0 0 0-4.152-1.72 6 6 0 0 0-2.318.461c-.57.241-1.536.862-2.102 1.446l-.002.002V4.107h8.117c.295-.003.295-.417.295-.55 0-.137 0-.549-.296-.553H7.857a.387.387 0 0 0-.388.384v6.801c0 .221.273.379.527.434.496.104.61-.053.732-.222l.015-.021c.187-.275.767-.858.771-.863a4.776 4.776 0 0 1 3.406-1.403 4.76 4.76 0 0 1 3.394 1.403 4.75 4.75 0 0 1 1.408 3.385c0 1.28-.498 2.483-1.4 3.385a4.858 4.858 0 0 1-3.416 1.403 4.656 4.656 0 0 1-2.42-.668l.004-4.137c0-.552.238-1.151.64-1.604a2.351 2.351 0 0 1 1.778-.803c.667 0 1.291.254 1.754.714.46.455.714 1.064.714 1.711a2.443 2.443 0 0 1-2.474 2.466c-.268 0-.753-.117-.773-.123-.281-.084-.4.305-.439.435-.151.492.077.59.122.604.448.138.741.164 1.124.164a3.555 3.555 0 0 0 3.551-3.553c0-1.943-1.592-3.526-3.548-3.526a3.59 3.59 0 0 0-2.536 1.033c-.644.632-1.013 1.478-1.013 2.317v.021c-.004.105-.004 2.583-.005 3.398l-.005-.006c-.368-.407-.731-1.029-.973-1.668-.097-.25-.309-.206-.601-.116-.127.04-.514.159-.429.438l.002.004zm4.172-.972c.002.118.111.223.175.286l.021.019c.111.11.217.164.315.164.081 0 .13-.037.148-.054.05-.046.604-.608.658-.662l.618.618c.058.064.12.097.192.098.1 0 .207-.058.32-.174.267-.272.134-.42.069-.49l-.628-.63.655-.658c.144-.155.017-.32-.111-.446-.183-.184-.359-.23-.474-.127l-.65.652-.657-.658a.183.183 0 0 0-.128-.051c-.087 0-.191.06-.308.177-.202.201-.246.341-.141.453l.657.656-.653.655a.247.247 0 0 0-.078.172m1.434-8.891c-1.053 0-2.171.211-2.992.566a.23.23 0 0 0-.151.205c-.011.093.013.216.076.377.051.131.187.478.449.376a7.566 7.566 0 0 1 2.618-.498c.96 0 1.892.188 2.768.558.696.296 1.354.721 2.068 1.341a.243.243 0 0 0 .165.068c.138 0 .271-.137.386-.266.191-.214.321-.392.135-.569a7.674 7.674 0 0 0-2.354-1.52 8.088 8.088 0 0 0-3.168-.638m5.668 12.986c-.127-.126-.235-.199-.33-.228a.24.24 0 0 0-.247.059l-.063.062a7.07 7.07 0 0 1-5.018 2.081 7.09 7.09 0 0 1-5.02-2.081 6.794 6.794 0 0 1-1.521-2.255 7.618 7.618 0 0 1-.462-1.596c-.004-.018-.005-.031-.009-.041-.044-.232-.257-.249-.564-.202-.127.019-.517.078-.479.358l.002.006a8.104 8.104 0 0 0 2.288 4.478 8.089 8.089 0 0 0 2.59 1.747 8.093 8.093 0 0 0 3.175.642 8.062 8.062 0 0 0 3.172-.643 8.129 8.129 0 0 0 2.658-1.813c.083-.09.154-.248-.172-.574"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f80985f4359fa683(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 10.61A2.7 2.7 0 0 0 19 10a2.74 2.74 0 0 0-1.1-.19 3.28 3.28 0 0 0-2.16.76v-.05a3.67 3.67 0 0 0-5.09-3.39 3.61 3.61 0 0 0-1.78 1.56 3.67 3.67 0 0 0-3.12-1.86 3.74 3.74 0 0 0-1.82.44 3.66 3.66 0 0 0-1.37 1.28A3.77 3.77 0 0 0 2 10.34a3.67 3.67 0 0 0 3.42 3.83l-1.6 2.76h2.39l2.65-4.59a3.63 3.63 0 0 0 2.93 1.84l-1.59 2.76h2.4l1.86-3.23a3.53 3.53 0 0 0 2.07 3.19 3.52 3.52 0 0 0 2.61.05 2.58 2.58 0 0 0 .9-.74v.73h2V7.06h-2.11zm-12.78.72a1.69 1.69 0 0 1-1.46.83 1.72 1.72 0 0 1-.86-.16 1.75 1.75 0 0 1-.62-.62 1.78 1.78 0 0 1-.21-.87 1.69 1.69 0 0 1 1.67-1.69 1.63 1.63 0 0 1 .84.23 1.58 1.58 0 0 1 .62.61 1.62 1.62 0 0 1 .23.83 1.72 1.72 0 0 1-.21.84zm6.38 0a1.58 1.58 0 0 1-.62.61 1.53 1.53 0 0 1-.84.22 1.78 1.78 0 0 1-.84-.22 1.65 1.65 0 0 1-.61-.62 1.67 1.67 0 0 1 0-1.69 1.73 1.73 0 0 1 .62-.61 1.63 1.63 0 0 1 .84-.23 1.69 1.69 0 0 1 .84.23 1.69 1.69 0 0 1 .63 2.28zm6.3 3a1.72 1.72 0 0 1-2 .85 1.72 1.72 0 0 1-1-.7 1.75 1.75 0 0 1-.29-1.15 1.77 1.77 0 0 1 .51-1.07 1.75 1.75 0 0 1 2.35-.11 1.73 1.73 0 0 1 .43 2.18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5eaf9a549ec44172(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.966V4.034h-6.654zM3 4.034v15.932L9.658 4.034zM9.092 16.76h3.104l1.268 3.205h2.778L12.003 9.904z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4e0b4c73bc5284ff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 16.709c-1.013-1.271-1.609-2.386-1.808-3.34-.197-.769-.12-1.385.218-1.848.357-.532.89-.791 1.589-.791s1.231.259 1.589.796c.335.458.419 1.075.215 1.848-.218.974-.813 2.087-1.808 3.341l.005-.006zm7.196.855c-.14.934-.775 1.708-1.65 2.085-1.687.734-3.359-.437-4.789-2.026 2.365-2.961 2.803-5.268 1.787-6.758-.596-.855-1.449-1.271-2.544-1.271-2.206 0-3.419 1.867-2.942 4.034.276 1.173 1.013 2.506 2.186 3.996-.735.813-1.432 1.391-2.047 1.748-.478.258-.934.418-1.37.456-2.008.299-3.582-1.647-2.867-3.656.1-.259.297-.734.634-1.471l.019-.039c1.097-2.382 2.43-5.088 3.961-8.09l.039-.1.435-.836c.338-.616.477-.892 1.014-1.231.258-.157.576-.235.934-.235.715 0 1.271.418 1.511.753.118.18.259.419.436.716l.419.815.06.119c1.53 3.001 2.863 5.702 3.955 8.089l.02.019.401.915.237.573c.183.459.221.915.16 1.393l.001.002zm.913-1.791c-.139-.438-.378-.953-.675-1.569v-.022a262.99 262.99 0 0 0-3.976-8.128l-.084-.121C14.486 4.109 13.849 3.014 12 3.014c-1.827 0-2.604 1.27-3.397 2.922l-.061.119c-1.251 2.426-2.564 5.128-3.975 8.13v.039l-.418.914c-.158.378-.237.575-.259.636C2.878 18.556 4.964 21 7.489 21c.021 0 .099 0 .198-.021h.278c1.313-.159 2.664-.993 4.035-2.485 1.371 1.49 2.725 2.326 4.033 2.485h.279c.1.021.18.021.2.021 2.525.002 4.61-2.444 3.598-5.227z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3f636432421a2e6d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.177 9.059a3.582 3.582 0 0 0-3.576 3.584 3.584 3.584 0 0 0 3.576 3.585 3.578 3.578 0 0 0 3.575-3.585 3.582 3.582 0 0 0-3.575-3.584zm2.518 2.268-2.366 1.229c-.07.039-.153-.017-.153-.093V9.791h.001c0-.06.054-.104.109-.104a2.943 2.943 0 0 1 2.452 1.492c.028.055.011.121-.043.148z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.578 3H5.361A2.363 2.363 0 0 0 3 5.366v13.277a2.368 2.368 0 0 0 2.361 2.371h13.217a2.367 2.367 0 0 0 2.361-2.372V5.372A2.368 2.368 0 0 0 18.578 3zm-8.112 3.404a.78.78 0 0 1 .779-.781h1.815c.43 0 .778.35.778.781v.618a.106.106 0 0 1-.131.104 5.677 5.677 0 0 0-3.106.017c-.07.016-.136-.033-.136-.104v-.635zM7.08 8.993a.78.78 0 0 1 .001-1.103l.371-.371.002-.002a.776.776 0 0 1 1.099.002l.31.311c.043.05.038.127-.017.159a5.82 5.82 0 0 0-1.296 1.3c-.044.049-.114.06-.163.011l-.306-.306-.001-.001zm5.097 8.737a5.078 5.078 0 0 1-5.074-5.087c0-2.813 2.272-5.092 5.074-5.092a5.074 5.074 0 0 1 5.074 5.086c0 2.815-2.272 5.093-5.074 5.093z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3cd9118c50eece2e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.027 17.023c.061-.098.156-.105.289-.02 3.035 1.76 6.338 2.645 9.906 2.645 2.381 0 4.73-.447 7.051-1.332l.262-.117c.115-.051.195-.084.244-.109.189-.074.326-.037.438.109.102.143.076.279-.1.4-.213.158-.5.342-.84.545-1.037.619-2.203 1.098-3.492 1.441a14.815 14.815 0 0 1-3.77.508c-1.889 0-3.68-.33-5.369-.99a14.875 14.875 0 0 1-4.531-2.797c-.084-.061-.125-.123-.125-.184 0-.039.016-.074.041-.109l-.004.01zm5.479-5.189c0-.84.207-1.555.619-2.152.414-.592.977-1.041 1.703-1.346.666-.281 1.465-.48 2.43-.602.326-.037.861-.086 1.6-.145v-.31c0-.773-.084-1.299-.248-1.564-.252-.359-.65-.541-1.203-.541h-.15c-.4.039-.746.162-1.039.383a1.51 1.51 0 0 0-.564.916c-.049.25-.172.387-.361.426l-2.105-.264c-.209-.051-.311-.15-.311-.326 0-.037.006-.074.018-.123.209-1.078.715-1.881 1.52-2.404.814-.514 1.752-.814 2.828-.875h.451c1.379 0 2.469.361 3.244 1.076.115.123.227.25.34.398.1.139.188.264.234.377.063.111.127.275.164.475.051.213.088.352.113.426.023.086.051.25.064.514.006.262.016.41.016.461v4.406c0 .314.049.602.137.865.088.26.174.451.262.563l.428.561a.598.598 0 0 1 .111.303c0 .102-.049.188-.148.26-1.002.877-1.553 1.352-1.639 1.428-.137.113-.313.125-.525.039a5.397 5.397 0 0 1-.439-.414l-.258-.291c-.051-.063-.141-.174-.266-.352l-.25-.363c-.676.74-1.338 1.205-2.002 1.393-.414.125-.914.188-1.529.188-.926 0-1.701-.285-2.303-.863-.598-.576-.9-1.389-.9-2.453l-.043-.063.001-.007zm3.131-.367c0 .475.117.852.355 1.139.236.285.563.428.965.428.035 0 .088-.008.16-.018.078-.012.111-.02.141-.02.512-.133.902-.461 1.189-.982a2.62 2.62 0 0 0 .299-.758c.076-.268.1-.494.111-.666.016-.166.016-.453.016-.84v-.451c-.703 0-1.24.049-1.604.148-1.063.303-1.604.977-1.604 2.029l-.029-.016v.007zm7.646 5.865c.025-.051.063-.092.109-.143.301-.201.596-.342.877-.416a6.597 6.597 0 0 1 1.344-.201c.117-.01.234 0 .346.025.539.051.873.141.977.273.053.078.074.191.074.328v.125c0 .426-.117.926-.348 1.502s-.553 1.041-.963 1.402c-.061.049-.115.074-.164.074-.025 0-.051 0-.074-.01-.076-.037-.09-.1-.055-.201.451-1.051.672-1.787.672-2.201 0-.127-.025-.227-.074-.289-.119-.137-.457-.217-1.02-.217a9.42 9.42 0 0 0-.727.039c-.303.041-.582.078-.834.115-.074 0-.123-.014-.15-.037-.025-.025-.031-.039-.018-.064 0-.014.006-.025.018-.053v-.049l.01-.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$45efdbd5a9a8495e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.344 8.71c-.707 0-1.279.572-1.279 1.278v4.53a1.278 1.278 0 1 0 2.558 0v-4.53c0-.706-.572-1.278-1.279-1.278zm-12.688 0c-.707 0-1.279.572-1.279 1.278v4.53a1.278 1.278 0 1 0 2.558 0v-4.53A1.277 1.277 0 0 0 5.656 8.71zm8.889-3.809.768-1.388a.343.343 0 0 0-.133-.47.344.344 0 0 0-.471.135l-.789 1.42c-.588-.235-1.236-.368-1.92-.368s-1.332.132-1.92.367l-.789-1.418a.344.344 0 0 0-.471-.135.345.345 0 0 0-.133.47l.768 1.388C8.072 5.69 7.148 7.099 7.148 8.71c0 .011 0 .021.002.034-.002.006-.002.013-.002.019v.001h9.703V8.71c.001-1.611-.923-3.019-2.306-3.809zM9.76 6.869a.346.346 0 1 1 .005-.693.346.346 0 0 1-.005.693zm4.48 0a.347.347 0 0 1 0-.692.346.346 0 0 1 0 .692zM7.148 16.12c0 .646.525 1.171 1.174 1.171h.586v2.401a1.279 1.279 0 0 0 2.558 0v-2.401h1.066v2.401c0 .707.572 1.278 1.277 1.278.709 0 1.281-.571 1.281-1.278v-2.401h.586c.648 0 1.174-.524 1.174-1.171V9.028H7.148v7.092z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d695cadf1cf77dfb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.483 12.482h3.034L12 8.831z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.074 3.689 6.038l1.268 10.987 7.043 3.9 7.043-3.9 1.268-10.987L12 3.074zm5.187 13.621H15.25l-1.045-2.606h-4.41L8.75 16.695H6.813L12 5.047l5.187 11.648z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bd3a1088a06ee518(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.665 16.811a10.316 10.316 0 0 1-1.021 1.837c-.537.767-.978 1.297-1.316 1.592-.525.482-1.089.73-1.692.744-.432 0-.954-.123-1.562-.373-.61-.249-1.17-.371-1.683-.371-.537 0-1.113.122-1.73.371-.616.25-1.114.381-1.495.393-.577.025-1.154-.229-1.729-.764-.367-.32-.826-.87-1.377-1.648-.59-.829-1.075-1.794-1.455-2.891-.407-1.187-.611-2.335-.611-3.447 0-1.273.275-2.372.826-3.292a4.857 4.857 0 0 1 1.73-1.751 4.65 4.65 0 0 1 2.34-.662c.46 0 1.063.142 1.81.422s1.227.422 1.436.422c.158 0 .689-.167 1.593-.498.853-.307 1.573-.434 2.163-.384 1.6.129 2.801.759 3.6 1.895-1.43.867-2.137 2.08-2.123 3.637.012 1.213.453 2.222 1.317 3.023a4.33 4.33 0 0 0 1.315.863c-.106.307-.218.6-.336.882zM15.998 2.38c0 .95-.348 1.838-1.039 2.659-.836.976-1.846 1.541-2.941 1.452a2.955 2.955 0 0 1-.021-.36c0-.913.396-1.889 1.103-2.688.352-.404.8-.741 1.343-1.009.542-.264 1.054-.41 1.536-.435.013.128.019.255.019.381z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8e1453e98b0470be(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.005 10.238v1.69l10.002 6.254 9.988-6.254v-1.69l-9.988 6.229z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.938 12.469 1.465-.938c-1.161-1.701-3.153-2.876-5.396-2.876-2.257 0-4.236 1.135-5.371 2.89.093-.093.146-.146.238-.211 2.811-2.336 6.86-1.808 9.064 1.135z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.051 13.063a2.99 2.99 0 0 1 1.78-.58c1.083 0 2.047.554 2.692 1.49l1.399-.871c-.607-.963-1.688-1.557-2.916-1.557-1.226 0-2.309.62-2.955 1.518zM5.25 9.012c4.117-3.246 9.937-2.362 13.037 1.953l.026.026 1.517-.938a9.337 9.337 0 0 0-7.823-4.235 9.35 9.35 0 0 0-7.825 4.235c.304-.342.686-.751 1.068-1.041z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$de6fa9cfadda30a4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 11.35a4.32 4.32 0 0 1-.79-.08 3.9 3.9 0 0 1-.73-.23l-.17-.04h-.12q-.15 0-.15.21v.33a.43.43 0 0 0 0 .19.5.5 0 0 0 .21.19 3 3 0 0 0 .76.26 4.38 4.38 0 0 0 1 .12 3 3 0 0 0 1-.14 1.94 1.94 0 0 0 .73-.37 1.81 1.81 0 0 0 .49-.58 1.79 1.79 0 0 0 .17-.78 1.54 1.54 0 0 0-.3-.93 2.15 2.15 0 0 0-1-.64l-.95-.3a2 2 0 0 1-.73-.36.65.65 0 0 1-.2-.47.66.66 0 0 1 .31-.6 1.82 1.82 0 0 1 .89-.18 2.89 2.89 0 0 1 1.27.26.79.79 0 0 0 .26.08c.1 0 .15-.08.15-.22v-.36a.38.38 0 0 0-.06-.22.56.56 0 0 0-.2-.16 1.55 1.55 0 0 0-.28-.12 3.44 3.44 0 0 0-.38-.11l-.44-.1A3.4 3.4 0 0 0 19 6a2.82 2.82 0 0 0-.83.11 2.19 2.19 0 0 0-.7.35A1.61 1.61 0 0 0 17 7a1.5 1.5 0 0 0-.18.74 1.6 1.6 0 0 0 .33 1 2.08 2.08 0 0 0 1.06.68l1 .3a1.58 1.58 0 0 1 .67.34.66.66 0 0 1 .18.47.72.72 0 0 1-.35.63 1.83 1.83 0 0 1-.96.19zM12.94 6.5a.48.48 0 0 0-.13-.26.37.37 0 0 0-.26-.07H12a.43.43 0 0 0-.26.07.42.42 0 0 0-.13.26l-1 4.4-1.14-4.4a.48.48 0 0 0-.14-.26s-.13-.07-.26-.07h-.65c-.11 0-.16.06-.16.17a1.22 1.22 0 0 0 .06.27l1.56 5.14A.61.61 0 0 0 10 12a.45.45 0 0 0 .26.06h.57a.49.49 0 0 0 .27-.06.57.57 0 0 0 .12-.27l1-4.28 1 4.29a.42.42 0 0 0 .12.26.4.4 0 0 0 .27.07h.57a.41.41 0 0 0 .25-.07.44.44 0 0 0 .14-.26l1.61-5.14a.73.73 0 0 0 0-.16.52.52 0 0 0 0-.11.15.15 0 0 0-.17-.17h-.62a.45.45 0 0 0-.26.07.68.68 0 0 0-.13.26L14 11zM5.77 8.63a5.92 5.92 0 0 0-.71-.05 2.42 2.42 0 0 0-1.63.52 1.72 1.72 0 0 0-.6 1.37 1.7 1.7 0 0 0 .49 1.28 1.82 1.82 0 0 0 1.33.48 2.48 2.48 0 0 0 2-.92 3.5 3.5 0 0 0 .2.39 2.34 2.34 0 0 0 .24.31.26.26 0 0 0 .37 0l.42-.28a.28.28 0 0 0 .13-.2.27.27 0 0 0 0-.16 3.63 3.63 0 0 1-.21-.47 2 2 0 0 1-.07-.6V8.19a2.2 2.2 0 0 0-.55-1.64A2.42 2.42 0 0 0 5.33 6a3.9 3.9 0 0 0-1 .13 3.9 3.9 0 0 0-.84.3.47.47 0 0 0-.18.14.37.37 0 0 0 0 .23v.33c0 .14 0 .2.14.2a.26.26 0 0 0 .11 0l.23-.08A4.32 4.32 0 0 1 4.42 7a3 3 0 0 1 .72-.09 1.5 1.5 0 0 1 1.08.31 1.46 1.46 0 0 1 .31 1.06v.49zm.78.9v.27a2.36 2.36 0 0 1-.07.58 1.06 1.06 0 0 1-.23.43 1.38 1.38 0 0 1-.63.42 2.12 2.12 0 0 1-.68.12.94.94 0 0 1-.7-.24.92.92 0 0 1-.24-.71.92.92 0 0 1 .33-.76 1.52 1.52 0 0 1 1-.27h.62a5.67 5.67 0 0 1 .6.16zM19.76 15a19.68 19.68 0 0 1-7.55 1.54 20 20 0 0 1-9.9-2.62c-.24-.15-.43.1-.22.29A14.68 14.68 0 0 0 12 18a14.4 14.4 0 0 0 8.1-2.47c.34-.31.03-.72-.34-.53z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.38 14.06c-.19.14-.16.33.05.3.71-.09 2.28-.27 2.56.09s-.31 1.83-.58 2.49c-.08.2.1.28.28.13a3.9 3.9 0 0 0 1.23-3.34 3.94 3.94 0 0 0-3.54.33z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$79fc6fc0ddeab389(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.217 12.486c1.964-.422 1.693-2.772 1.637-3.287-.096-.788-1.028-2.172-2.291-2.061-1.588.141-1.821 2.44-1.821 2.44-.216 1.06.515 3.33 2.475 2.908m3.646-3.944c1.084 0 1.959-1.251 1.959-2.792 0-1.537-.871-2.785-1.955-2.785-1.086 0-1.966 1.242-1.966 2.785s.88 2.792 1.965 2.792m4.671.186c1.454.195 2.38-1.355 2.568-2.53.188-1.166-.754-2.528-1.776-2.763-1.031-.237-2.303 1.411-2.431 2.484-.136 1.318.188 2.627 1.634 2.813m5.751 1.973c0-.562-.46-2.253-2.19-2.253-1.729 0-1.965 1.596-1.965 2.726 0 1.077.089 2.573 2.247 2.528 2.148-.052 1.913-2.438 1.913-3.002M18.1 15.626s-2.247-1.739-3.557-3.613c-1.776-2.768-4.304-1.64-5.144-.239-.845 1.418-2.153 2.306-2.339 2.544-.188.232-2.709 1.596-2.147 4.079.563 2.483 2.528 2.439 2.528 2.439s1.446.142 3.133-.234c1.686-.375 3.13.091 3.13.091s3.92 1.317 5.005-1.212c1.072-2.537-.61-3.847-.61-3.847"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$49d0e7e4554fbe87(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.803 5.731c.589 0 1.119.051 1.605.155.483.103.895.273 1.243.508.343.235.611.547.804.939.187.387.28.871.28 1.443 0 .62-.14 1.138-.421 1.551-.283.414-.7.753-1.256 1.015.757.219 1.318.602 1.69 1.146.374.549.557 1.206.557 1.976 0 .625-.119 1.162-.358 1.613a3.11 3.11 0 0 1-.974 1.114 4.315 4.315 0 0 1-1.399.64 6.287 6.287 0 0 1-1.609.206H2V5.731h5.803zm-.351 4.972c.48 0 .878-.114 1.192-.345.312-.228.463-.604.463-1.119 0-.286-.051-.522-.151-.707a1.114 1.114 0 0 0-.417-.428 1.683 1.683 0 0 0-.597-.215 3.609 3.609 0 0 0-.697-.061H4.71v2.875h2.742zm.151 5.239c.267 0 .521-.023.76-.077.241-.052.455-.136.637-.261.182-.12.332-.283.44-.491.109-.206.162-.475.162-.798 0-.634-.179-1.085-.533-1.358-.355-.27-.831-.404-1.414-.404H4.71v3.39h2.893zm8.565-.041c.367.358.896.538 1.584.538.493 0 .919-.125 1.278-.373.354-.249.57-.515.653-.79h2.155c-.346 1.072-.871 1.838-1.589 2.299-.709.463-1.572.693-2.58.693-.702 0-1.334-.113-1.9-.337a4.033 4.033 0 0 1-1.439-.958 4.37 4.37 0 0 1-.905-1.485 5.433 5.433 0 0 1-.32-1.899c0-.666.111-1.289.329-1.864a4.376 4.376 0 0 1 .934-1.493c.405-.42.885-.751 1.444-.994a4.634 4.634 0 0 1 1.858-.362c.754 0 1.413.146 1.979.44a3.967 3.967 0 0 1 1.39 1.182c.363.493.622 1.058.783 1.691.161.632.217 1.292.171 1.983h-6.431c.001.704.238 1.371.606 1.729zm2.812-4.681c-.291-.322-.783-.496-1.385-.496-.391 0-.714.065-.974.199a1.97 1.97 0 0 0-.62.491 1.772 1.772 0 0 0-.328.628 2.82 2.82 0 0 0-.111.587h3.982c-.058-.624-.272-1.085-.564-1.409zm-3.918-4.663h4.989v1.215h-4.989z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1b9d40e71686eedd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.71 3 3.593 1.264v12.645l5.061-2.919-2.48-1.165-1.566-3.897 7.974 2.802v4.073l-8.984 5.183-3.595-2L5.71 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6912d6a49142239b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.953 8.819-.547 2.19c.619.154 2.529.784 2.838-.456.322-1.291-1.673-1.579-2.291-1.734zm-.822 3.296-.603 2.415c.743.185 3.037.921 3.376-.441.355-1.422-2.029-1.789-2.773-1.974z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.421 2.299C9.064.964 3.641 4.224 2.306 9.581.97 14.936 4.23 20.361 9.583 21.697c5.357 1.335 10.783-1.924 12.117-7.281 1.336-5.356-1.924-10.781-7.279-12.117zm1.991 8.275c-.145.974-.686 1.445-1.402 1.611.985.512 1.485 1.298 1.009 2.661-.592 1.691-1.998 1.834-3.87 1.48l-.454 1.82-1.096-.273.447-1.794a44.624 44.624 0 0 1-.875-.228l-.449 1.804-1.095-.275.454-1.823c-.257-.066-.517-.136-.782-.202L6.87 15l.546-1.256s.808.215.797.199c.311.077.448-.125.502-.261l.719-2.875.115.029a.864.864 0 0 0-.114-.037l.512-2.053c.013-.234-.066-.528-.511-.639.018-.011-.797-.198-.797-.198l.291-1.172 1.514.378-.001.005c.227.057.461.111.7.165l.449-1.802 1.097.273-.44 1.766c.294.067.591.135.879.207l.438-1.755 1.097.273-.449 1.802c1.384.479 2.396 1.195 2.198 2.525z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2254ec992fb90e72(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.427 13.011c.037-.667.363-1.254.856-1.671a2.855 2.855 0 0 1 1.844-.66c.71 0 1.36.25 1.845.66.492.417.819 1.005.856 1.671.038.686-.237 1.323-.721 1.795a2.829 2.829 0 0 1-1.979.782 2.83 2.83 0 0 1-1.981-.782c-.483-.472-.759-1.109-.72-1.795z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.124 14.361c.005.26.089.767.213 1.164a6.156 6.156 0 0 0 1.328 2.299 6.833 6.833 0 0 0 2.323 1.667 7.465 7.465 0 0 0 3.05.635 7.495 7.495 0 0 0 3.051-.645 6.913 6.913 0 0 0 2.321-1.675 6.196 6.196 0 0 0 1.326-2.303 5.76 5.76 0 0 0 .25-1.285 5.942 5.942 0 0 0-.888-3.594 6.496 6.496 0 0 0-1.545-1.703l.001-.001-6.249-4.799-.016-.014c-.411-.314-1.101-.313-1.551.002-.457.319-.508.846-.104 1.18l-.001.001 2.606 2.121-7.943.009h-.012c-.656 0-1.287.432-1.412.976-.128.555.318 1.015 1.001 1.017l-.001.003 4.027-.008-7.188 5.516-.027.021c-.677.519-.896 1.382-.47 1.929.434.556 1.354.556 2.04.002l3.922-3.209c.001 0-.056.433-.052.694zm10.078 1.45c-.808.824-1.938 1.291-3.163 1.293-1.226.002-2.356-.461-3.165-1.283a3.739 3.739 0 0 1-.864-1.352 3.503 3.503 0 0 1-.199-1.511c.044-.505.193-.987.434-1.422.236-.429.562-.815.962-1.144a4.477 4.477 0 0 1 2.832-.988 4.478 4.478 0 0 1 2.832.98c.399.326.725.711.961 1.139.24.436.39.916.434 1.421a3.52 3.52 0 0 1-.198 1.511 3.804 3.804 0 0 1-.866 1.356z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$390309c5fd079b7b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.954 10.667c-.072-.322-.272-.621-.502-.745-.07-.039-.522-.088-1.004-.109-.809-.036-.898-.052-1.152-.201-.405-.237-.516-.493-.518-1.187-.002-1.327-.554-2.559-1.646-3.67-.776-.793-1.645-1.329-2.634-1.629-.236-.072-.768-.097-2.545-.118-2.787-.033-3.405.024-4.356.402-1.748.697-3.008 2.166-3.465 4.05-.087.353-.103.92-.124 4.177-.025 4.08.004 4.68.258 5.488.212.668.425 1.077.861 1.657.835 1.108 2.083 1.907 3.334 2.133.595.107 7.931.135 8.683.032 1.306-.178 2.331-.702 3.293-1.684.694-.71 1.129-1.479 1.414-2.499.117-.424.127-.63.149-3.117.017-1.878.002-2.758-.046-2.98zM8.007 8.108c.313-.316.399-.329 2.364-.329 1.764 0 1.822.004 2.081.134.375.189.538.456.538.88 0 .384-.153.653-.493.869-.184.115-.293.123-2.021.133-1.067.007-1.916-.013-2.043-.048-.669-.184-.918-1.143-.426-1.639zm7.706 8.037-.597.098-3.114.035c-2.736.033-3.511-.018-3.652-.08-.288-.124-.554-.472-.602-.78-.042-.292.104-.696.33-.9.285-.257.409-.266 3.911-.27 3.602-.002 3.583-.003 3.925.315.482.45.381 1.251-.201 1.582z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e4764cb54ad794ec(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.002 2.997H5.999A3.011 3.011 0 0 0 2.997 6v12.002a3.012 3.012 0 0 0 3.002 3.001h12.003a3.012 3.012 0 0 0 3.001-3.001V6a3.012 3.012 0 0 0-3.001-3.003zm-1.64 12.647c-.152.36-.389.68-.693.927a3.594 3.594 0 0 1-1.206.614c-.49.151-1.074.229-1.75.229H7.888V6.909h5.103c.943 0 1.7.213 2.267.646.569.436.854 1.082.854 1.958 0 .528-.13.983-.389 1.357-.259.373-.63.664-1.111.868v.034c.642.135 1.137.438 1.464.912.327.473.493 1.069.493 1.789 0 .405-.078.788-.225 1.147l.02.021v.003zm-2.084-2.589c-.309-.282-.739-.419-1.297-.419H9.737v3.276h3.253c.554 0 .991-.144 1.298-.435.308-.289.464-.701.464-1.229-.005-.518-.156-.919-.464-1.193h-.014.004zm-.451-2.119c.299-.251.444-.613.444-1.084 0-.526-.131-.902-.397-1.116-.264-.214-.646-.326-1.146-.326H9.727v2.898h3.001c.436.001.81-.127 1.099-.372z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f8e2ebf8d2ff2df1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.66 7a1.51 1.51 0 0 0-.55-.57l-7.34-4.24a1.67 1.67 0 0 0-1.54 0L3.89 6.43a1.68 1.68 0 0 0-.77 1.33v8.48a1.57 1.57 0 0 0 .22.76 1.51 1.51 0 0 0 .55.57l7.34 4.24a1.67 1.67 0 0 0 1.54 0l7.34-4.24a1.51 1.51 0 0 0 .55-.57 1.57 1.57 0 0 0 .22-.76V7.76a1.57 1.57 0 0 0-.22-.76zM12 17.92A5.92 5.92 0 1 1 17.13 9L16 9.71l-.36.2-1 .61A3 3 0 0 0 9 12a2.88 2.88 0 0 0 .4 1.48 3 3 0 0 0 5.13 0l2.6 1.52A5.94 5.94 0 0 1 12 17.92zm5.92-5.59h-.66V13h-.65v-.66H16v-.66h.66V11h.65v.66h.66zm2.47 0h-.66V13h-.66v-.66h-.65v-.66h.65V11h.66v.66h.66z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a65ddfa07ab38fbb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.742 2.04c-1.404.183-3.06.808-4.281 1.626-1.01.664-2.397 2.02-2.309 2.251.193.501 3.28 5.658 3.33 5.562.038-.067.095-.279.123-.49.25-1.385 1.425-2.704 2.897-3.253.568-.221.683-.221 5.495-.27l4.917-.047-.395-.646c-1.385-2.26-3.522-3.819-6.197-4.512-.731-.193-2.81-.318-3.58-.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.2 7.217c-.453.799-.983 2.415-1.107 3.358-.588 4.273 1.568 8.4 5.379 10.315.894.452 2.174.885 2.732.933l.356.029 1.674-2.838c.915-1.559 1.655-2.849 1.636-2.868-.02-.019-.231.039-.481.125-1.569.53-3.387.086-4.57-1.116-.424-.424-1.002-1.357-2.84-4.542C4.71 8.41 3.642 6.601 3.603 6.601c-.028 0-.211.279-.403.616z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.15 8.804c1.222 1.242 1.655 3.003 1.116 4.59-.086.26-1.212 2.271-2.501 4.485-1.29 2.203-2.349 4.031-2.349 4.06 0 .115 1.328.057 2.175-.087 4.32-.74 7.573-4.002 8.265-8.276.26-1.558.164-2.925-.307-4.503l-.25-.837h-6.707l.557.568z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.608 8.563C9.598 8.987 8.905 9.7 8.53 10.71c-.173.453-.202.713-.173 1.424.03.75.068.963.347 1.511.366.75.962 1.329 1.751 1.703.462.221.654.25 1.54.25.895 0 1.077-.029 1.559-.26.712-.326 1.462-1.077 1.79-1.79.23-.48.259-.663.259-1.558 0-.886-.029-1.078-.25-1.54-.375-.788-.952-1.386-1.703-1.75-.568-.28-.742-.318-1.56-.348-.788-.019-.99.01-1.48.212z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e0d4e1c38ab9efe4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.838 8.445c0-.001-.001-.001 0 0l-.003-.004-.001-.001v-.001a.809.809 0 0 0-.235-.228l-9.164-6.08a.834.834 0 0 0-.898 0L2.371 8.214A.786.786 0 0 0 2 8.897v6.16a.789.789 0 0 0 .131.448v.001l.002.002.01.015v.002h.001l.001.001.001.001c.063.088.14.16.226.215l9.165 6.082a.787.787 0 0 0 .448.139.784.784 0 0 0 .45-.139l9.165-6.082a.794.794 0 0 0 .371-.685v-6.16a.793.793 0 0 0-.133-.452zm-9.057-4.172 6.953 4.613-3.183 2.112-3.771-2.536V4.273zm-1.592 0v4.189l-3.771 2.536-3.181-2.111 6.952-4.614zm-7.595 6.098 2.395 1.59-2.395 1.611v-3.201zm7.595 9.311-6.96-4.617 3.195-2.15 3.765 2.498v4.269zm.795-5.653-3.128-2.078 3.128-2.105 3.131 2.105-3.131 2.078zm.797 5.653v-4.27l3.766-2.498 3.193 2.15-6.959 4.618zm7.597-6.11-2.396-1.611 2.396-1.59v3.201z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$503a23cb82f9a7f7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.354 6.479a10.021 10.021 0 0 0-7.421-4.429c-3.108-.294-6.031.771-8.123 2.963C3.533 6.35 2.699 7.839 2.21 9.66c-.217.805-.247 1.104-.244 2.396.002 1.293.034 1.599.255 2.432a10.232 10.232 0 0 0 7.451 7.332c.315.078.702.16.859.182.696.097 2.381.056 3.131-.075 3.088-.538 5.832-2.531 7.24-5.258 1.644-3.181 1.426-7.222-.548-10.19zm-.41 7.688c-.808 2.99-3.263 5.272-6.361 5.912-4.831.997-9.538-2.658-9.839-7.641-.194-3.217 1.755-6.446 4.745-7.863 1.133-.536 2.045-.733 3.425-.738 1.327-.004 2.064.132 3.223.596 2.324.931 4.146 3.04 4.816 5.573.281 1.06.276 3.103-.009 4.161z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.042 14.955c-.915-.324-1.616-1.275-1.74-2.36-.183-1.607.422-2.856 1.654-3.415.669-.303 1.882-.296 2.603.016.438.19 1.261.933 1.261 1.139 0 .033-.284.201-.631.372l-.632.312-.337-.337c-.187-.188-.475-.363-.649-.396-.433-.082-.952.111-1.187.44-.389.546-.415 1.972-.048 2.533.191.291.512.494.813.518.635.05.796-.006 1.172-.401l.379-.398.488.269c.269.148.527.305.575.347.164.148-.592.92-1.199 1.224-.517.259-.679.293-1.358.286-.425-.006-.949-.074-1.164-.149zm5.816 0c-.901-.32-1.591-1.241-1.739-2.325-.215-1.569.419-2.888 1.654-3.45.717-.324 1.934-.3 2.661.056.45.221 1.201.911 1.201 1.104 0 .034-.295.203-.654.377l-.654.317-.341-.37c-.304-.332-.385-.369-.802-.369-.576 0-.945.225-1.145.698-.18.423-.201 1.461-.043 1.934.324.961 1.505 1.188 2.175.419l.304-.346.58.294c.32.161.582.319.582.352 0 .219-.75.918-1.256 1.17-.517.259-.679.293-1.358.287-.425-.005-.949-.073-1.165-.148z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b44b471ec7d38069(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.192 3.143h15.615l-1.42 16.034-6.404 1.812-6.369-1.813L4.192 3.143zM16.9 6.424l-9.8-.002.158 1.949 7.529.002-.189 2.02H9.66l.179 1.913h4.597l-.272 2.62-2.164.598-2.197-.603-.141-1.569h-1.94l.216 2.867L12 17.484l3.995-1.137.905-9.923z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c61f9e89d85fe826(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.551 11.485a2.327 2.327 0 0 0-2.328 2.332c0 1.314 1.013 2.313 2.441 2.313l-.012.002c1.192 0 2.193-.983 2.193-2.28.001-1.349-1.001-2.367-2.294-2.367z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm15.52 15.605h-2.682v-1.058c-.825.81-1.667 1.103-2.786 1.103-1.142 0-2.124-.371-2.947-1.114-1.086-.956-1.648-2.227-1.648-3.701 0-1.351.524-2.561 1.507-3.506.878-.859 1.946-1.298 3.139-1.298 1.14 0 2.018.385 2.647 1.192V6.118l2.77-.574v-.002l.002.003h-.002v13.06z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$90f4c3ba16aa5926(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.68 5.47H22V8h-4.32zm0 3.51H22v2.53h-4.32zm0 3.51H22v2.53h-4.32zM2 16h4.32v2.53H2zm5.22 0h4.32v2.53H7.22zm5.23 0h4.32v2.53h-4.32zm5.23 0H22v2.53h-4.32zm-5.23-3.51h4.32v2.53h-4.32zm-5.23 0h4.32v2.53H7.22zm0-3.51h4.32v2.53H7.22z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$66b4b52d29c8d744(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.826 10.083a.784.784 0 0 0-.468-.175h-.701v4.198h.701a.786.786 0 0 0 .469-.175c.155-.117.233-.292.233-.525v-2.798c.001-.233-.079-.408-.234-.525zM19.236 3H4.764C3.791 3 3.002 3.787 3 4.76v14.48c.002.973.791 1.76 1.764 1.76h14.473c.973 0 1.762-.787 1.764-1.76V4.76A1.765 1.765 0 0 0 19.236 3zM9.195 13.414c0 .755-.466 1.901-1.942 1.898H5.389V8.665h1.903c1.424 0 1.902 1.144 1.903 1.899v2.85zm4.045-3.562H11.1v1.544h1.309v1.188H11.1v1.543h2.142v1.188h-2.498a.813.813 0 0 1-.833-.792V9.497a.813.813 0 0 1 .792-.832h2.539l-.002 1.187zm4.165 4.632c-.531 1.235-1.481.99-1.906 0l-1.548-5.818h1.309l1.193 4.569 1.188-4.569h1.31l-1.546 5.818z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$711cedb23ee7e8d0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.57 3h-3.271l-.326.33-1.544 2.942-.486.327H6.432v4.495h3.03l.27.327-3.3 6.305v3.273h3.272l.327-.33 1.543-2.943.486-.326h5.511v-4.495h-3.03l-.269-.329 3.299-6.303L17.57 3z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9ce455ca572368d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.803 8.8v6.801h3.2v.799h-3.2v1.602h5.2V8.8h-5.2zm-6 0v6.801h3.199v.799h-3.199v1.602h5.199V8.8h-5.199zM5.2 5.999V8.8H2v6.801h5.201V5.999H5.2zM10.001 8.8h-2v6.801h2V8.8zM20.003 14h-1.2v-3.601h1.2V14zM5.2 14H4v-3.601h1.2V14zm8.802 0h-1.2v-3.601h1.2V14zm-4.001-8.001h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c9d4f487a4a8eff1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.005 21.992v-3.877c4.104 0 7.288-4.068 5.714-8.388a5.81 5.81 0 0 0-3.457-3.446c-4.319-1.563-8.389 1.61-8.389 5.714H2.008c0-6.541 6.325-11.642 13.184-9.499 2.991.94 5.383 3.321 6.313 6.313 2.141 6.858-2.96 13.183-9.5 13.183z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.017 18.139H8.152v-3.866h3.865zm-3.865 2.959H5.193v-2.959h2.959zm-2.959-2.959H2.711v-2.483h2.482v2.483z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8145f0a87079cec1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$438ba6838e30f90(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.593 10.971c-.542 0-.969.475-.969 1.055 0 .578.437 1.055.969 1.055.541 0 .968-.477.968-1.055.011-.581-.427-1.055-.968-1.055zm3.468 0c-.542 0-.969.475-.969 1.055 0 .578.437 1.055.969 1.055.541 0 .968-.477.968-1.055-.001-.581-.427-1.055-.968-1.055z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.678 3H4.947A1.952 1.952 0 0 0 3 4.957v12.844c0 1.083.874 1.957 1.947 1.957H15.72l-.505-1.759 1.217 1.131 1.149 1.064L19.625 22V4.957A1.952 1.952 0 0 0 17.678 3zM14.01 15.407s-.342-.408-.626-.771c1.244-.352 1.719-1.13 1.719-1.13-.39.256-.76.438-1.093.562a6.679 6.679 0 0 1-3.838.398 7.944 7.944 0 0 1-1.396-.41 5.402 5.402 0 0 1-.693-.321c-.029-.021-.057-.029-.085-.048a.117.117 0 0 1-.039-.03c-.171-.094-.266-.16-.266-.16s.456.76 1.663 1.121c-.285.36-.637.789-.637.789-2.099-.067-2.896-1.444-2.896-1.444 0-3.059 1.368-5.538 1.368-5.538 1.368-1.027 2.669-.998 2.669-.998l.095.114c-1.71.495-2.499 1.245-2.499 1.245s.21-.114.561-.275c1.016-.446 1.823-.57 2.156-.599.057-.009.105-.019.162-.019a7.756 7.756 0 0 1 4.778.893s-.751-.712-2.366-1.206l.133-.152s1.302-.029 2.669.998c0 0 1.368 2.479 1.368 5.538 0-.001-.807 1.376-2.907 1.443z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$52fae1c5a84539ca(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.077 3C7.149 3 3 6.96 3 11.843V21l9.075-.01c4.928 0 8.925-4.11 8.925-8.993C21 7.113 17 3 12.077 3zm3.92 12.859a5.568 5.568 0 0 1-6.102 1.043l-3.595.805 1.001-3.192a5.435 5.435 0 0 1 .11-5.415 5.55 5.55 0 0 1 4.753-2.678v.001h.006a5.533 5.533 0 0 1 5.131 3.438 5.442 5.442 0 0 1-1.304 5.998z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5bc91b730766080a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.533 12.249c-.011 1.985 1.445 3.168 3.768 2.63V9.618c-2.352-.716-3.758.733-3.768 2.631m3.839-10.238h3.199v15.143c-3.066.501-6.004.819-8.104-.355-2.705-1.513-2.923-6.319-.782-8.46 1.085-1.085 3.271-1.85 5.616-1.351V2.225c-.006-.101-.012-.202.071-.214m8.389 3.342h-3.199V2.011h3.199v3.342z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.761 7.044c-.003 2.356-.003 4.048-.003 6.911-.136 2.813-.104 5.052-1.135 6.398-.203.266-.634.652-.995.924-.303.228-.881.691-1.208.711-.331.021-1.18-.459-1.564-.64-.505-.237-.971-.553-1.493-.71 1.218-.754 2.372-1.32 2.844-2.844.41-1.326.355-3.247.355-5.119 0-1.849.009-3.998.009-5.63l3.19-.001z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$435ab075ec107f5f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.17 9.82a4.76 4.76 0 0 0-.84.07 3.12 3.12 0 0 0-1.43-2.14l-.28-.16-.19.27a3.7 3.7 0 0 0-.51 1.19 2.84 2.84 0 0 0 .33 2.22 4.11 4.11 0 0 1-1.45.35H2.63a.63.63 0 0 0-.63.62 9.6 9.6 0 0 0 .58 3.39 5 5 0 0 0 2 2.6 8.86 8.86 0 0 0 4.42.95 13.27 13.27 0 0 0 2.42-.18 10.09 10.09 0 0 0 3.19-1.15A8.9 8.9 0 0 0 16.78 16a11.94 11.94 0 0 0 2.13-3.67h.19a3.08 3.08 0 0 0 2.23-.84 2.36 2.36 0 0 0 .59-.87l.08-.22-.2-.16a2.69 2.69 0 0 0-1.63-.42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.61 9.35H3.85a.16.16 0 0 0-.16.15v1.58a.16.16 0 0 0 .16.15h1.76a.16.16 0 0 0 .16-.15V9.5a.16.16 0 0 0-.16-.15zm2.44 0H6.28a.16.16 0 0 0-.16.15v1.58a.16.16 0 0 0 .16.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zm2.47 0H8.75a.15.15 0 0 0-.15.15v1.58a.15.15 0 0 0 .15.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zm.67 0a.15.15 0 0 0-.19.15v1.58a.15.15 0 0 0 .15.15H13a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zM6.28 7.09H8a.16.16 0 0 1 .16.16v1.56A.16.16 0 0 1 8 9H6.28a.15.15 0 0 1-.15-.15V7.24a.15.15 0 0 1 .15-.15zm2.47 0h1.77a.15.15 0 0 1 .15.15v1.57a.16.16 0 0 1-.16.16H8.75a.15.15 0 0 1-.15-.15V7.24a.15.15 0 0 1 .15-.15zm2.44 0H13a.15.15 0 0 1 .15.15v1.57A.15.15 0 0 1 13 9h-1.81a.16.16 0 0 1-.19-.19V7.24a.15.15 0 0 1 .19-.15z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11.04",
                    "y": "4.82",
                    "width": "2.07",
                    "height": "1.88",
                    "rx": ".15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.65 9.35a.15.15 0 0 0-.15.15v1.58a.15.15 0 0 0 .15.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f810bc82e96689bd(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.66 6.98a9.932 9.932 0 0 0-3.641-3.64C15.486 2.447 13.813 2 12 2s-3.486.447-5.02 1.34c-1.533.893-2.747 2.107-3.64 3.64S2 10.187 2 12s.446 3.487 1.34 5.02a9.924 9.924 0 0 0 3.641 3.64C8.514 21.553 10.187 22 12 22s3.486-.447 5.02-1.34a9.932 9.932 0 0 0 3.641-3.64C21.554 15.487 22 13.813 22 12s-.446-3.487-1.34-5.02zM12 3.66c2 0 3.772.64 5.32 1.919-.92 1.174-2.286 2.14-4.1 2.9-1.002-1.813-2.088-3.327-3.261-4.54A7.715 7.715 0 0 1 12 3.66zM5.51 6.8a8.116 8.116 0 0 1 2.711-2.22c1.212 1.201 2.325 2.7 3.34 4.5-2 .6-4.114.9-6.341.9-.573 0-1.006-.013-1.3-.04A8.549 8.549 0 0 1 5.51 6.8zM3.66 12c0-.054.003-.12.01-.2.007-.08.01-.146.01-.2.254.014.641.02 1.161.02 2.666 0 5.146-.367 7.439-1.1.187.373.381.793.58 1.26-1.32.293-2.674 1.006-4.061 2.14S6.4 16.247 5.76 17.5c-1.4-1.587-2.1-3.42-2.1-5.5zM12 20.34c-1.894 0-3.594-.587-5.101-1.759.601-1.187 1.524-2.322 2.771-3.401 1.246-1.08 2.483-1.753 3.71-2.02a29.441 29.441 0 0 1 1.56 6.62 8.166 8.166 0 0 1-2.94.56zm7.08-3.96a8.351 8.351 0 0 1-2.58 2.621c-.24-2.08-.7-4.107-1.379-6.081.932-.066 1.765-.1 2.5-.1.799 0 1.686.034 2.659.1a8.098 8.098 0 0 1-1.2 3.46zm-1.24-5c-1.16 0-2.233.047-3.22.14a27.053 27.053 0 0 0-.68-1.62c2.066-.906 3.532-2.006 4.399-3.3 1.2 1.414 1.854 3.027 1.96 4.84-.812-.04-1.632-.06-2.459-.06z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9c3205e077cc13ce(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.004 3.5 2 6.689l5.004 3.186 5.002-3.186zm10.005 0-5.003 3.189 5.003 3.186 5.003-3.186zM2 13.062l5.004 3.187 5.002-3.187-5.002-3.187zm15.009-3.187-5.003 3.187 5.003 3.187 5.003-3.187zM7.004 17.311l5.002 3.189 5.003-3.189-5.003-3.186z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$67b7f1d80a37d262(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.474 14.42a3.162 3.162 0 1 0 0 6.324 3.162 3.162 0 0 0 0-6.324zm3.936-.606a5.433 5.433 0 0 1 1.513 3.769 5.441 5.441 0 0 1-2.335 4.47c2.609-.803 4.771-2.767 5.737-5.142 1.338-3.288.09-5.761-1.999-8.005.066.288.103.592.103.898a4.175 4.175 0 0 1-3.019 4.01zm-3.577-4.003c0 1.34 1.087 2.419 2.42 2.419s2.423-1.087 2.423-2.419a2.418 2.418 0 0 0-2.417-2.417 2.425 2.425 0 0 0-2.426 2.417z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.303 21.093a5.435 5.435 0 0 1-1.276-3.51 5.441 5.441 0 0 1 4.8-5.408 4.162 4.162 0 0 1 3.99-6.492c-1.361-1.176-2.724-2.369-3.799-3.672.547 5.714-5.2 3.638-7.332 8.904-1.422 3.527-.138 7.892 3.617 10.178z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$441349dbe119bbbe(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.021 12.111V8.004h1.001v2.525c.493-.586 1.17-.756 1.838-.756 1.118 0 2.361.754 2.361 2.383 0 .195-.014.381-.051.559.2-.797 1.063-1.09 2.418-1.123.426-.016.914-.016 1.302-.016v-.111c0-.738-.464-1.039-1.276-1.039-.602 0-1.04.25-1.09.676H12.46c.113-1.076 1.253-1.352 2.242-1.352.889 0 1.666.225 2.017.852l-.365-.702h1.177l1.716 3.443 1.716-3.445H22l-3.105 6.098h-1.124l.894-1.703-1.945-3.656c.108.213.167.465.167.777v2.055c0 .289.009.574.034.838h-.931a5.478 5.478 0 0 1-.038-.639c-.503.613-1.103.803-1.937.803-1.236 0-1.897-.652-1.897-1.416 0-.125.013-.236.031-.338-.251 1.041-1.135 1.74-2.31 1.74-.727 0-1.414-.262-1.837-.775 0 .201-.013.412-.033.611h-.986c.018-.324.034-.713.034-1.037v-.877H2.985c.054.914.683 1.451 1.547 1.451.599 0 1.131-.25 1.309-.775h1.035c-.2 1.078-1.344 1.439-2.329 1.439-1.789.018-2.582-.973-2.582-2.301 0-1.463.819-2.428 2.602-2.428 1.409 0 2.445.738 2.454 2.342v.004zm7.627.153c-.915.027-1.479.193-1.479.793 0 .389.301.809 1.09.809 1.052 0 1.615-.574 1.615-1.514v-.109c-.376 0-.826.006-1.239.02h.011l.002.001zm-5.059 1.564c.927 0 1.566-.672 1.566-1.686s-.642-1.686-1.58-1.686c-.928 0-1.578.672-1.578 1.686s.639 1.686 1.565 1.686h.027zM5.958 11.73c-.037-.939-.714-1.291-1.44-1.291-.788 0-1.414.395-1.516 1.291h2.956z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$df9963ab25525bea(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.349 13.684H8.874c0 .433.063.825.195 1.178a3.334 3.334 0 0 0 1.381 1.634c.309.196.646.359 1.005.484.356.13.729.226 1.107.288.821.13 1.658.123 2.477-.021a9.79 9.79 0 0 0 2.421-.783c.393-.18.79-.376 1.201-.594v3.805a13.453 13.453 0 0 1-2.711.978c-.457.112-.92.196-1.396.246-.486.054-.975.079-1.464.079a8.185 8.185 0 0 1-1.95-.232 7.679 7.679 0 0 1-1.762-.668 7.29 7.29 0 0 1-1.51-1.062 6.67 6.67 0 0 1-1.941-3.103 6.978 6.978 0 0 1-.267-1.953c0-.737.101-1.439.303-2.11a6.718 6.718 0 0 1 2.264-3.342 7.38 7.38 0 0 1 1.847-1.066 3.891 3.891 0 0 0-.869 1.329 5.682 5.682 0 0 0-.401 1.538h6.391c0-.646-.063-1.207-.196-1.689-.131-.484-.342-.885-.637-1.201A2.64 2.64 0 0 0 13.23 6.7c-.462-.16-1.021-.241-1.675-.241-.771 0-1.543.111-2.314.344a9.804 9.804 0 0 0-2.2.955c-.695.412-1.335.897-1.919 1.452a9.167 9.167 0 0 0-1.474 1.819c.084-.742.247-1.474.485-2.18a9.304 9.304 0 0 1 .912-1.938 8.622 8.622 0 0 1 1.303-1.609 7.735 7.735 0 0 1 1.655-1.235 8.45 8.45 0 0 1 1.955-.792 10.042 10.042 0 0 1 2.233-.254c.46 0 .917.041 1.375.124.457.084.903.196 1.339.342a8.012 8.012 0 0 1 2.315 1.239 7.95 7.95 0 0 1 1.711 1.833c.463.692.813 1.459 1.055 2.292s.365 1.701.365 2.602v2.23h-.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7b17d5affe11ff65(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.139 14.058c-.438 0-.693-.294-.693-1.058v-2.696l1.456.112.074-.694-1.496.074v-1.53h-.438c-.216 1.201-.759 1.638-1.488 1.712v.364h.869v3.062c0 .836.588 1.271 1.313 1.271.585 0 1.202-.255 1.418-.763l-.217-.255c-.108.18-.402.401-.798.401zm-3.494-.803c-.294.69-.767.729-1.24.729h-1.53c-.508 0-.729-.186-.729-.62v-2.258s1.092 0 1.457.039c.291.035.438.109.546.473l.108.511h.438l-.039-1.309.074-1.278h-.434l-.147.585c-.073.399-.147.438-.546.508-.508.038-1.457.038-1.457.038V7.979c0-.112 0-.147.185-.147h2.291c.402 0 .62.326.763.98l.147.512h.399c.039-1.457.074-2.074.074-2.074s-.981.105-1.562.105H3.53L2 7.324v.399l.508.107c.367.074.475.147.475.473 0 0 .039.984.039 2.619 0 1.639-.039 2.623-.039 2.623 0 .291-.108.399-.475.473L2 14.131v.396l1.565-.035h2.623c.581 0 1.965.035 1.965.035.034-.361.216-1.964.255-2.146H8.04l-.395.874zm6.04-2.622c0-.474.437-.655.875-.655.36 0 .653.147.729.325l.255.729.361-.035c0-.364.038-.838.111-1.201-.328-.147-.983-.221-1.421-.221-.984 0-1.747.441-1.747 1.387 0 1.674 2.44 1.31 2.44 2.549 0 .399-.256.729-.876.729-.581 0-.837-.294-.945-.585l-.29-.693h-.369c.04.476.074.948 0 1.382 0 0 .767.294 1.531.294 1.022 0 1.858-.507 1.858-1.457 0-1.674-2.512-1.421-2.512-2.548zm6.369-.945v.364l.259.074c.252.07.36.178.36.363 0 .108-.034.144-.073.291-.108.291-.802 2.003-1.162 2.767a75.566 75.566 0 0 1-1.093-2.949c-.035-.073-.035-.108-.035-.146 0-.148.105-.292.361-.326l.329-.074v-.364l-1.346.073-1.096-.039v.368l.187.069c.251.074.287.11.469.512.693 1.53 1.457 3.529 1.716 4.15-.584 1.019-1.204 1.309-1.677 1.309-.291 0-.399-.147-.435-.329l-.146-.763-.4.035c-.073.477-.147.984-.255 1.383.287.182.616.294 1.053.293.691 0 1.675-.182 2.623-2.332l1.601-3.747c.145-.293.182-.329.546-.476l.183-.144v-.362l-.945.034-1.024-.034z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$deb9360e34bc5b94(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e26bcd18dafeb0ed(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8.615v-6.96h-2.338v-2.725h2.338v-2c0-2.325 1.42-3.592 3.5-3.592.699-.002 1.399.034 2.095.107v2.42h-1.435c-1.128 0-1.348.538-1.348 1.325v1.735h2.697l-.35 2.725h-2.348V21H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2ed946b786982dbb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$47e650e5d434b168(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.332 8.668a3.333 3.333 0 0 0 0-6.663H8.668a3.333 3.333 0 0 0 0 6.663 3.333 3.333 0 0 0 0 6.665 3.333 3.333 0 0 0 0 6.664A3.334 3.334 0 0 0 12 18.664V8.668h3.332z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.332",
                    "cy": "12",
                    "r": "3.332"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e537ad2b2244199b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.239 15.063 7.21 2.381a.453.453 0 0 1 .847-.145l2.12 3.979-4.938 8.848zM19.24 18.14 17.363 6.469a.454.454 0 0 0-.766-.246L4.76 18.14l6.55 3.691c.411.23.912.23 1.323 0l6.607-3.691zM13.917 7.955 12.4 5.052a.452.452 0 0 0-.8 0L4.939 16.989l8.978-9.034z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4ba5599c07afe0e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.634 11.138a2.16 2.16 0 0 0-.06-.286l-.187.236a6.354 6.354 0 0 0-.228-1.274 8.66 8.66 0 0 0-.591-1.511 5.33 5.33 0 0 0-.54-.92c-.109-.17-.203-.296-.221-.322-.362-.589-.767-.947-1.249-1.621a4.942 4.942 0 0 1-.615-1.679 6.091 6.091 0 0 0-.303 1.097c-.483-.489-.913-.846-1.168-1.08-1.267-1.183-1.113-1.79-1.113-1.79s-2.364 2.635-1.342 5.377a5.278 5.278 0 0 0 1.764 2.347c.989.813 2.052 1.452 2.609 3.101a5.2 5.2 0 0 0-1.967-2.087c.253.602.38 1.232.371 1.884a4.468 4.468 0 0 1-4.476 4.465 4.28 4.28 0 0 1-.985-.109 4.117 4.117 0 0 1-1.107-.379 4.4 4.4 0 0 1-1.334-1.226v-.007a.372.372 0 0 0 .075.024c.187.067.372.118.567.153a3.558 3.558 0 0 0 2.245-.263c.708-.396 1.139-.685 1.484-.574.348.109.608-.22.373-.565a1.853 1.853 0 0 0-1.79-.692c-.711.101-1.36.599-2.28.117-.067-.032-.117-.066-.176-.101-.06-.042.202.051.134.009a4.138 4.138 0 0 1-.582-.347c-.009-.009.145.043.126.033a2.235 2.235 0 0 1-.608-.614 1.118 1.118 0 0 1-.04-.973.844.844 0 0 1 .38-.354l.192.1s-.059-.1-.085-.151c.01-.008.019 0 .035-.008.102.042.329.159.455.236a.6.6 0 0 1 .212.186s.043-.017.009-.108a.511.511 0 0 0-.221-.263h.018c.093.051.178.102.261.167.076-.186.119-.368.112-.563a.825.825 0 0 0-.043-.313c-.035-.067.017-.093.075-.025a.545.545 0 0 0-.051-.152s.034-.051.051-.062c.043-.04.084-.082.136-.107.293-.185.599-.347.92-.474a6.52 6.52 0 0 0 .515-.228c.067-.042.127-.084.186-.136.22-.185.364-.438.413-.718.01-.04.01-.074.01-.107v-.069c-.034-.144-.279-.245-1.553-.372a1.104 1.104 0 0 1-.911-.852v.007a2.035 2.035 0 0 0-.051.146c.016-.053.033-.094.051-.146v-.007a3.257 3.257 0 0 1 1.249-1.553c.031-.025-.126.007-.093-.017.102-.051.211-.103.329-.145.059-.018-.245-.134-.515-.11a1.545 1.545 0 0 0-.473.11c.067-.049.252-.118.21-.118a2.837 2.837 0 0 0-.97.363c0-.033.01-.06.018-.083a1.474 1.474 0 0 0-.6.464v-.112a2.706 2.706 0 0 0-.295.28h-.008a3.92 3.92 0 0 0-2.205-.184l-.008-.009h.008a1.684 1.684 0 0 1-.387-.439l-.01.007-.015-.016c-.053-.068-.093-.152-.147-.246-.04-.06-.074-.136-.116-.21 0 0 0-.008-.008-.008-.01 0-.026.077-.033.049a2.668 2.668 0 0 1-.179-1.053H5.28a1.12 1.12 0 0 0-.448.589c-.041.086-.067.128-.092.179v-.028l.024-.125c-.006.009-.006.017-.017.025a1.06 1.06 0 0 0-.15.23 1.117 1.117 0 0 0-.103.243v-.042c0-.034.009-.085 0-.067l-.009.023a5.968 5.968 0 0 0-.506 1.902c-.016.118-.016.228-.016.337v.018a4.422 4.422 0 0 0-.514.683 9.703 9.703 0 0 0-1.082 2.659c.161-.354.354-.701.583-1.021a9.332 9.332 0 0 0-.659 3.454c.076-.346.169-.684.278-1.022a8.737 8.737 0 0 0 .787 4.062 9.397 9.397 0 0 0 3.738 4.229 8.052 8.052 0 0 0 2.169 1.048c.102.033.213.074.313.109-.034-.018-.059-.035-.092-.042a9.912 9.912 0 0 0 2.818.413c3.387 0 4.501-1.292 4.61-1.418.16-.151.303-.331.396-.541.068-.024.127-.05.195-.084l.041-.016c.051-.026.075-.034.075-.034a7.11 7.11 0 0 0 1.437-.896 3.475 3.475 0 0 0 1.326-1.951c.125-.286.125-.6.024-.894.05-.084.094-.161.101-.178a7.954 7.954 0 0 0 1.199-3.876v-.116a4.918 4.918 0 0 0-.072-.872z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f26374a1ad31eb95(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.78 18.29c0 .12.15 0 0 0zm-3.35-2.7c.39.17-.31-.6 0 0zm-5.03.28c.15.26 0-.12 0 0zm5.6.39c-.27-.42-.2.06 0 .32.48.47.18-.26 0-.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.24 19.06c-.53.63-1-.07-1.63.13-1.1 0 .09-.5.06-1-.58-.45-1.24.61-1.62.9a10.75 10.75 0 0 1-2.67-.83 8 8 0 0 1-2.6-1.94 8.36 8.36 0 0 1-1.87-2.84 21.36 21.36 0 0 1-.84-5.74c.07-1.3 1.44.14 2-.33-.21-.67-1.29-.88-1.89-1.16-.58 0-.79-.55-1.4-.59 0-.73-1.13-.33-1.56-.84.42-1.08-1.37 0-1.23-.91.58-1.2-1.78-1-.8.06.95.54-.93.93-.38 1.29a.59.59 0 0 1-.53.86c-.74.07-.67 1.09.06.55.81-.25.14.11-.25.18a1.3 1.3 0 0 0-.95 1.9 35.32 35.32 0 0 1 1 3.42A16.25 16.25 0 0 0 5.84 17 9.78 9.78 0 0 0 8 19a9.89 9.89 0 0 0 2.43 1.22 18 18 0 0 0 4.73.73 16.53 16.53 0 0 0 2.9-.24c.87.09 1.49-.65 2.26-.26.48-.42 1.16-.23 1.63-.54.32-1.22-1.22-.27-1.71-.85zm-1.74-.74c-.22 0 .05-.34 0 0zm-7.63-11c-.1 0-.08-.12-.16-.15-.8-.37.39-.23.16.19zm6.76 11.39c-.35-.08.28-.25 0 0zm-2.81.11c-.23 0 .18-.14 0 0zm-1.88-1.18c-.13 0 0-.13 0 0zm-.22-.17c-.36 0-.09-.23 0 0zm-.42-.36c-.33.08 0-.34 0 0zm-6-11.66c-.53-.28.11.33-.34.32-.24 0-.69-.52-.54-.78.3.16.83.21.92.5zm-.92-.81h-.11c-.03-.27.87-.06.15.04zm-1.02-.79c-.42-.19 0-.93.44-.58.51.73-.95-.08-.44.58zm.49.69c-.27.11.16-.21 0 0zm.48.92c.6.46-.34 0-.72.29-.61.06.66-.34.72-.29zm.17.6c.35 0 1.88-.69 1.37-.07.47.55.1.37-.21 0 .28.19.06 1-.37.45s-.5-.18-.17.21C5.8 6 4.88 6.28 4.21 6.5c-.43-.04 1.13-.37 1.29-.44zM3.58 7.51c-.16.4.24.53.62.6.62-.17-.41-.28.06-.44.26 0-.82-.26.08-.38S6.09 6.77 7 6.58a8.71 8.71 0 0 1 2.35-.19c.3.35-.23.94-.77 1a8.61 8.61 0 0 1-2 .39c-.8-.1-1.37.61-2.19.7.22-.4-.18-.14-.59-.16.21.82-1.47-.21-.48-.41-.74-.26-.75.52-.67 1-.65-.91.07-1.29.93-1.4zm1.88 1.08c-.22-.05.17-.2 0 0zm-.72.88s-.34-.08-.2-.17c1 .13-.9-.33.13-.22.66-.02.44.36.07.39zm.33.17c-.12.12 0-.24 0 0zm-.71 0c-.44-.09.21-.22 0 0zm-.06 1.43c-.07.1-.1-.08 0 0zM4 10.9c-.55-.19 0-.21 0 0zm-.12 1.28c-.26-.09-.25-.5-.37-.72-.38-1.03.41.4.33.72zm.23-1.49c-.69-.08-.05-.49 0 0zm0-.34h-.09c-.76-.35.45-.17-.02 0zM4 9.56c-.61-.31.58-.36 0 0zm.21.26c-.34.06.05-.32 0 0zm-1.3.07c-.12.08 0-.23 0 0zM3 9.75c-.16 0 0-.27 0 0zm.08-1c-.4-.1.33-.25 0 0zm.26 2c-.44-.1-.12-.65 0 0zm.3 1.25c.42.51.26.79.69 1.41-.56-.35-.67-1.2-1-1.75-.41-.9.23-.01.31.34zm4.09 6.38c-.34-.07-.57-.43-.81-.66a4.88 4.88 0 0 1-1.57-1.94 12.26 12.26 0 0 1-1.46-2.38c-.41-.92.25.07.35.42.21.68.88 1.07.94 1.52.74.42.36 1.12 1 1.31.27-.14.3.84.89.64-.33.15.13.33.3.61.35-.05 1.17.82.36.52zM4.62 12c-.31-.07.33-.11 0 0zm.2.47c-.55-.14.52-.2 0 0zm1.39.47c.4-.17.16.78.55.9.76 1-.53 0-1-.07.06 0-.38-.12-.19-.16-.14-.15-.45-.66.26-.32.6.24.65.06.38-.39zm1.31 1.76c0 .15-.72.13-.06.42-.38 0-.5 0 0 .3-.22.17.43.31.21.57.66.52-.12.13-.4-.08s-.85-.35-.75-.5c.81.42.21 0-.15-.3.65.16-.51-.48.1-.31.19.05-.27-.38.33-.07-.54-.52.47-.12.72-.07zm.48-.17c-.61-.14 0-.34 0 0zm-.17 2c-.61-.26.39 0 0 0zm-.45-.17c-.71-.23.52 0 0 0zm-.09.11c-.22 0 0-.17 0 0zm-1.08-1.55c-.72-.3-.2-.33 0 0zm-.54-.35c-.58-.33-.08-.33 0 0zm0 .65c-.57-.44-.07-.25 0 0zm-.15-1.34c-.35 0 .13-.2 0 0zM8 17.38c-.51-.15 0-.14 0 0zM7.63 17h-.16c-.68-.54.31-.38.75-.14.97.14-.22.39-.59.14zm2.7 1.65c-.68-.16.16-.27 0 0zm-.17-.52c-.05 0-.1-.11 0 0zm-.86-1.34c-.59-.14.21-.19.36 0 1.02.21-.06.26-.36 0zM9.51 18H9.4l-.13-.06c-.56-.59 1.19.28.24.06zm-.28.69c-.15.06 0-.14 0 0zm.29-1.19-.16-.05c-.66-.45.84.09.16 0zm.16 1.72c-.4-.16.26-.25 0 0zm.1-.74c-.58-.14.36-.13 0 0zm.13-.61c-.44-.06.05-.21 0 0zm-.72-.88c.46.06.47.27 0 .14-.09 0-.24 0-.28-.17-.76-.5.03-.25.28-.02zm-.06 2c-.2.12 0-.22 0 0zm-.31-.51c-.53 0 .4-.26 0 0zm-.12.35c-.26-.1.17-.08 0 0zm.3-.89c-.52-.14.25-.18 0 0zm-.16-.57c-.28 0-.06-.16 0 0zm-.54-.95c-.57-.46 1.18.38 0 0zm-.06.19c0 .06-.11-.09 0 0zm3.65 3.78a9.4 9.4 0 0 1-2.56-.85l-.33-.2c-.57-.31-.5-.38.06-.07.19.16 1.59.73.93.35-.29-.07-1.9-.95-.84-.57a20.92 20.92 0 0 0 2.74 1.21 7.14 7.14 0 0 0 2.43.15c.65.33 1.33-.08 2 .21a13.05 13.05 0 0 1-4.45-.23zm-1.25-.7c-.51-.09.16-.23 0 0zm.73-1c-.58-.11.6-.23 0 0zm.84 1.31c1 .37-.6.12-.93-.09-.92-.38.72.09.93.09zm-1.06-1.1c-.81-.12.9 0 0 0zm1.52.85c-.29.23 0-.3 0 0zm.29.05c-.15.06 0-.17 0 0zm.27-.38c-.16.2 0-.23 0 0zm.31 0c-.45.17.47-.39 0 0zm.14 0c.49-.42.51-.22.5.13-.43.48-.17-.2-.44.06s-.19-.1-.06-.17zm.83.45c-.5 0 .51-.54 0 0zm0 .18c-.2.05 0-.13 0 0zm-.16-.35c-.39-.26.94-.61 0 0zm.57.09h-.08c-.03-.23.54-.27.08.02zm.15.19c-.3-.08.47-.4 0 0zm.36-.1c-.51.18.48-.4 0 0zm.22.11-.12.08c-.23-.14.71-.48.12-.07zm-.43-.53c-.54-.18-1.4-.76-2-.37-.8.51.41-.56-.24-.08-.66.79-.45-.5-1.09-.11 0-.12-.57-.16-.17-.37-.36 0-.13-.05 0-.34-.16 0-1 0-1.36-.29-.4-.52.07-.3.48-.23-.67.12.24.5.68.29-.2-.09-.43-.52-1-.9a18.83 18.83 0 0 0-2.13-1c-.84-.5.18-.18.47.08.84.37.51-.51 0-.74-.54 0-.67-.59-1.1-.56.67.11 1.14-.17.39-.85s.3.63-.11.44c-.19-.25-.05-.6-.65-.73 0 .23-.08.58-.21.1-.17 0-.36.21-.5-.28.13-.57-.56-.7-.67-1.06.6.38.87.08.45-.33s-.33-.11-.49 0c-.59.6-.06-1-.32-.56-.26 0-.11.29-.1.65-.86-.21.2.45.45.81-.39-.4-.32.31-.65 0-.11-.3-.12-.77-.67-.85.62-.22-.36-.65-.28-.67.35-.32.4-.76.82-.07-.53 0 0 .88.12.6 0-.47.22-1-.59-1.19-.24.32-.65-.63-.18-.43-.06-.63.74-.26.69-.53.42-.18-.5-.77 0-1 .38.24 1.36-.36.7-.44.42 0 .75.18.79-.24.33.07 1.24.36.42-.09a3.45 3.45 0 0 1 1.13-.25c.79-.61.63 1 .45 1.45.3-.21.24.94.14 1.37.16-.22.23.36 0 .77 0-.07.4-.13.12.35-.22-.47-.31 1-.17.32.37-.61.28 0 .39.24.08.55.32 1.06.4 1.56.35.35-.15.11-.15.59.11-.14.58.19.57.68 0-.78.09-.18.47 0a5.48 5.48 0 0 0 1 1.42c.37.43 0 .13.14.39a3.19 3.19 0 0 0 2.09 1.28 1.46 1.46 0 0 0 1.57.7c-.6.37 1.68.47.91.67-.23.16-.62-.2-1.01-.18zM8.7 15.89c-.24 0 0-.2 0 0zm.38.22c-.18 0-.12-.24 0 0zm-2.61-3.65c-.24-.07.1-.09 0 0zm-.59 0c-.26 0 0-.34 0 0zm-.3-.08c-.1.05 0-.11 0 0zm11 8.25c-.39-.07.32-.22 0 0zm.73-1.05h-.3c.06-.45 1.33-.1 1.85-.09-.16.34-1.13.04-1.55.13zm2 0c-.27 0 .12-.32 0 0zm1-.09c-.25.13 0-.3 0 0zm.48.11c-.52-.12.24-.12.4-.14.94.02 0 .16-.47.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.51 7.11c1-.2-.38-.33-.69 0 .18.13.41-.21.69 0zm-.82.13c0 .19.18-.22 0 0zm2.62-.48c.67-.11.11-.41-.09.1.07.14.11-.05.09-.1zm-.62.1c.93.36-.05-1 0 0zm-2.92.93a.51.51 0 0 1 .33.1c.75.52-.1-.84-.33-.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.81 7.43c.16.13.29-.21 0 0zm.37.01.14.12c.68.06-.11-.46-.14-.12zM10.69 16c.09.3 0-.39 0 0zm-4.78-5c.1.18.18-.18 0 0zm.09.61c.19.34 0-.51 0 0zm.21-.49c.33.21-.28-.52 0 0zm-.41-.82c.07.15.24.16.37.2 1.32.61-.95-1-.37-.2zm.54 1.43c.31.53.18-.37 0 0zm.48-.16c.37.92-.23-.12-.3-.43a2.11 2.11 0 0 0 .28 1c.34.51.19-.28.55.23-.2-.45.1-.2.06-.4s-1-1.17-.59-.4zm.36 1.78c.09.31.18 0 0 0zM5.85 9c.06.14.11 0 0 0zm.67.42c.32.41.17-.36 0 0zm-.89 1.14.14.15c.99.29-1.05-.95-.14-.15zm.7-.37c1 .41-.09-.27-.44-.2.11.13.32.07.44.2zm-.18-.44c.18.18.82.51.31.06.32-.06 0-.16-.24-.32-.44-.67.07.06-.07.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.51 10.64c-.53-.44.16.21-.06.2-.55-.4-.32-.11 0 .2.33.5.6-.3.06-.4zm2.14.64c.12.11-.06-.68 0 0zm1.02-3.5c0 .12.07-.1 0 0zM9 12.47c0 .21 0-.18 0 0zm-.29-1.22c.08.46.1-.78 0 0zm.14.22v.1c.21-.51.04-.79 0-.1zm-.1-2.7c-.14.7-.27.41-.08-.11-.05-.67-.45.41-.27.72.29.47.6-1.16.35-.61zm1.01 5.98c.13.35.11-.42 0 0zm-1.35-4.28c0 .2 0-.14 0 0zm.64 1.7c0 .26.11-.38 0 0zM9.5 14l.07.11c.14-.49-.36-.79-.07-.11zm-1.56-.52c.27.22-.13-.23 0 0zm1.23-.85c.08.29 0-.42 0 0zM8.14 9.81c.15.33-.05-.27 0 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.3 10.23c.24.34-.26-.64 0 0zm-.06 1.15c-.13-1-.42.45 0 .69.13.34.25.2.3-.19-.32 0 .08-.62-.3-.5z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cc137ebfb8cb74ef(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.747 14.746A2.745 2.745 0 1 1 11.494 12a2.744 2.744 0 0 1-2.747 2.746zm6.506 0a2.746 2.746 0 1 1-.001-5.493 2.746 2.746 0 0 1 .001 5.493z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9a91cc5c0528e322(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.157 12a4.573 4.573 0 1 1-9.147 0 4.573 4.573 0 0 1 9.147 0zm10.833 0a4.573 4.573 0 1 1-9.147 0 4.573 4.573 0 0 1 9.147 0z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$23ae75791c059129(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 2.01 3.9 12l3.09 3.09 2.71-2.7L20.09 2l-6.19.01zm.82 14.6 5.39-5.38h-5.93c-.11 0-.26 0-.34.07l-2.23 2.23-3.09 3.07 3.09 3.1 2.15 2.15c.07.07.14.17.26.15h6.07z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e8ba43b4ba750fa0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.549 5.557-.403 2.113c-.049.229-.337.47-.605.47h-3.76c-.425 0-.729.296-.729.714v.463c0 .43.307.725.73.725h3.194c.298 0 .591.33.524.646l-.404 2.083c-.037.181-.237.475-.592.475h-2.609c-.477 0-.617.069-.936.454-.316.395-3.175 3.827-3.175 3.827-.026.033-.054.022-.054-.011V5.522c0-.271.234-.588.586-.588h7.756c.283 0 .549.269.477.618v.005zm.341 8.288c.111-.437 1.319-6.63 1.722-8.593m-1.489-2.311H8.457c-1.33 0-1.723 1.002-1.723 1.635v15.353c0 .71.381.975.596 1.062.214.087.807.161 1.163-.247 0 0 4.563-5.296 4.64-5.373.125-.118.125-.118.238-.118h2.954c1.245 0 1.438-.885 1.574-1.405.114-.429 1.325-6.622 1.721-8.595.307-1.496-.079-2.311-1.495-2.311h-.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a6f88cbe10a016b0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.62 11.108-8.731-8.729a1.292 1.292 0 0 0-1.823 0L9.257 4.19l2.299 2.3a1.532 1.532 0 0 1 1.939 1.95l2.214 2.217a1.53 1.53 0 0 1 1.583 2.531c-.599.6-1.566.6-2.166 0a1.536 1.536 0 0 1-.337-1.662l-2.074-2.063V14.9c.146.071.286.169.407.29a1.537 1.537 0 0 1 0 2.166 1.536 1.536 0 0 1-2.174 0 1.528 1.528 0 0 1 0-2.164c.152-.15.322-.264.504-.339v-5.49a1.529 1.529 0 0 1-.83-2.008l-2.26-2.271-5.987 5.982c-.5.504-.5 1.32 0 1.824l8.731 8.729a1.286 1.286 0 0 0 1.821 0l8.69-8.689a1.284 1.284 0 0 0 .003-1.822"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8ded6b9d7c50aff8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7d0956e3024c1e1e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.892 9.889a.664.664 0 0 0-.025-.087l-2.104-6.479a.84.84 0 0 0-.8-.57.822.822 0 0 0-.789.575l-2.006 6.175H8.834L6.826 3.327a.823.823 0 0 0-.786-.575h-.006a.837.837 0 0 0-.795.575L3.133 9.815c0 .005-.005.01-.007.016l-1.067 3.281a1.195 1.195 0 0 0 .435 1.34l9.227 6.706c.167.121.393.12.558-.003l9.229-6.703a1.2 1.2 0 0 0 .435-1.34l-1.051-3.223zM17.97 3.936l1.809 5.566H16.16l1.81-5.566zm-11.94 0 1.812 5.566H4.228L6.03 3.936zm-2.982 9.752a.253.253 0 0 1-.093-.284l.793-2.437 5.817 7.456-6.517-4.735zm1.499-3.239h3.601l2.573 7.916-6.174-7.916zm7.452 8.794-2.856-8.798h5.718l-1.792 5.515-1.07 3.283zm1.282-.877 2.467-7.588.106-.329h3.604l-5.586 7.156-.591.761zm7.671-4.678-6.519 4.733.022-.029 5.794-7.425.792 2.436a.25.25 0 0 1-.089.285z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e7eb672280fcfbff(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.73 5.41-1.28 1L12 10.46 6.55 6.37l-1.28-1A2 2 0 0 0 2 7.05v11.59A1.36 1.36 0 0 0 3.36 20h3.19v-7.72L12 16.37l5.45-4.09V20h3.19A1.36 1.36 0 0 0 22 18.64V7.05a2 2 0 0 0-3.27-1.64z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d3fc37782c26572f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.79 10.17a.18.18 0 0 0-.11 0l-.2.27H7a.15.15 0 0 0 .1-.06l.17-.26v-.05zm-1.47.89a.14.14 0 0 0-.11 0l-.2.26v.05h4.6a.09.09 0 0 0 .09-.06l.08-.23v-.06zM4.6 12a.13.13 0 0 0-.1.06l-.13.24v.06h2.15a.08.08 0 0 0 .07-.07v-.23s0-.07-.06-.07zm15.99-3.07a3.62 3.62 0 0 0-2.78-.5 4.09 4.09 0 0 0-2.72 1.63 4 4 0 0 0-.67 1.26h-3.14a.25.25 0 0 0-.24.16c-.14.25-.37.76-.5 1.06s0 .29.18.29h1.88a2.8 2.8 0 0 1-.26.36 1.81 1.81 0 0 1-1.65.65 1.53 1.53 0 0 1-1.32-1.53 2.07 2.07 0 0 1 1-1.85 1.71 1.71 0 0 1 1.77-.15 1.36 1.36 0 0 1 .45.37c.13.15.14.14.29.1l1.63-.43c.12 0 .16-.08.1-.16a3 3 0 0 0-1.13-1.38 3.35 3.35 0 0 0-2.58-.47A4.31 4.31 0 0 0 8.16 10a3.81 3.81 0 0 0-.82 2.85A3 3 0 0 0 8.57 15a3.46 3.46 0 0 0 2.62.65A4.06 4.06 0 0 0 14 14a4.33 4.33 0 0 0 .41-.69 3 3 0 0 0 1 1.55 3.68 3.68 0 0 0 2.38.86c.25 0 .51 0 .78-.09a4.51 4.51 0 0 0 2.33-1.25A3.72 3.72 0 0 0 22 11.1a3 3 0 0 0-1.41-2.17zm-1.78 4.73a1.81 1.81 0 0 1-1.59.06 1.61 1.61 0 0 1-.9-1.84A2.12 2.12 0 0 1 18 10.19a1.59 1.59 0 0 1 2 1.29 2.91 2.91 0 0 1 0 .32 2.11 2.11 0 0 1-1.19 1.86z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4012be3d7dfbe2b1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.511 9.722a7.833 7.833 0 0 0-2.359-3.804l-.035.035.005-.042A7.81 7.81 0 0 0 4.418 9.722c.031-.013.066-.013.099-.023a5.643 5.643 0 0 0-.306 9.166l.006-.006-.006.024a5.612 5.612 0 0 0 3.407 1.134h4.321l.024.024h4.341a5.644 5.644 0 0 0 3.207-10.319zm-3.206 6.845h-4.341l-.006.006v-.031h-4.34c-.308 0-.611-.066-.892-.193l.002-.001a2.17 2.17 0 1 1 2.87-2.871l2.518-2.518a5.634 5.634 0 0 0-3.396-2.1c.018-.009.035-.024.05-.021a4.334 4.334 0 0 1 5.931-.451h.046a4.334 4.334 0 0 1 1.558 3.407v.433a2.17 2.17 0 1 1 0 4.34z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ea754221d9bdec76(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.014 11.974C21.996 6.462 17.521 2 12.008 2 6.493 2 2.019 6.462 2.001 11.974L2 11.948v.112l.001-.023c.017 5.513 4.491 9.977 10.007 9.977 5.514 0 9.988-4.462 10.006-9.974l.001.026v-.118l-.001.026zM9.281 16.557c-2.509 0-4.548-2.039-4.548-4.549s2.039-4.549 4.548-4.549c1.23 0 2.258.451 3.046 1.188l-1.295 1.255c-.325-.309-.899-.673-1.751-.673-1.505 0-2.733 1.251-2.733 2.785 0 1.533 1.229 2.784 2.733 2.784 1.742 0 2.384-1.206 2.502-1.92H9.279V11.18h4.255c.066.286.115.554.115.932 0 2.597-1.742 4.445-4.368 4.445zm10.458-4.095H17.92v1.819h-1.364v-1.819h-1.82v-1.364h1.82v-1.82h1.364v1.82h1.819v1.364z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$fbcf0e24197ce4cb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.545 15.025v-2.421h2.422v-1.815h-2.422V8.368H17.73v2.421h-2.421v1.815h2.421v2.421zM8.052 8.302c1.133 0 1.896.484 2.33.896l1.722-1.67c-1.048-.98-2.415-1.58-4.052-1.58C4.714 5.947 2 8.659 2 12s2.714 6.053 6.052 6.053c3.493 0 5.812-2.457 5.812-5.913 0-.503-.064-.86-.153-1.24H8.049v2.256h3.332c-.158.951-1.011 2.556-3.329 2.556-2.003 0-3.637-1.665-3.637-3.704 0-2.042 1.634-3.706 3.637-3.706z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$88d24af29d9be671(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.283 10.356h-8.327v3.451h4.792c-.446 2.193-2.313 3.453-4.792 3.453a5.27 5.27 0 0 1-5.279-5.28 5.27 5.27 0 0 1 5.279-5.279c1.259 0 2.397.447 3.29 1.178l2.6-2.599c-1.584-1.381-3.615-2.233-5.89-2.233a8.908 8.908 0 0 0-8.934 8.934 8.907 8.907 0 0 0 8.934 8.934c4.467 0 8.529-3.249 8.529-8.934 0-.528-.081-1.097-.202-1.625z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$eca5d3b1eaf8ab30(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 14.56a2.07 2.07 0 0 0-.47-.18V9.62a1.64 1.64 0 0 0 .48-.18 1.78 1.78 0 0 0-1.78-3.09 1.62 1.62 0 0 0-.41.32l-4.11-2.38a1.7 1.7 0 0 0 .07-.51 1.78 1.78 0 0 0-3.56 0 1.7 1.7 0 0 0 .07.51L6.28 6.66a1.58 1.58 0 0 0-.41-.31 1.78 1.78 0 0 0-1.78 3.09 1.64 1.64 0 0 0 .48.18v4.76a2.07 2.07 0 0 0-.47.18 1.78 1.78 0 1 0 1.78 3.09 1.72 1.72 0 0 0 .4-.31l4.11 2.37a1.7 1.7 0 0 0-.07.51 1.78 1.78 0 0 0 3.56 0 1.69 1.69 0 0 0-.09-.56l4.09-2.36a1.7 1.7 0 0 0 .44.35 1.78 1.78 0 1 0 1.78-3.09zM6.72 15.69a1.72 1.72 0 0 0-.19-.47 1.53 1.53 0 0 0-.31-.4l5.38-9.33a1.82 1.82 0 0 0 1 0l5.4 9.33a1.53 1.53 0 0 0-.31.4 1.72 1.72 0 0 0-.19.47zM17.5 7.4a1.81 1.81 0 0 0 .17 1.38 1.75 1.75 0 0 0 1.12.84v4.76h-.07l-5.39-9.31.05-.07zM10.82 5a.12.12 0 0 0 0 .05L5.48 14.4h-.07V9.62a1.75 1.75 0 0 0 1.12-.84A1.81 1.81 0 0 0 6.7 7.4zm2.6 14a1.78 1.78 0 0 0-1.32-.58 1.75 1.75 0 0 0-1.28.54L6.7 16.6v-.06h10.78v.11z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dced9111e20ac16c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.17 2H4.83A1.79 1.79 0 0 0 3 3.8v16.4A1.79 1.79 0 0 0 4.83 22h14.34A1.8 1.8 0 0 0 21 20.2V3.8A1.8 1.8 0 0 0 19.17 2zM20 20.2a.8.8 0 0 1-.81.8H4.83a.79.79 0 0 1-.8-.8V3.8a.79.79 0 0 1 .8-.8h14.34a.8.8 0 0 1 .81.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.53 19 2.25-2-2.25-2v4zm5.69-9a12 12 0 0 0-3.75.7V5h-2v8.65L8.88 13a12.3 12.3 0 0 1 4.29-1c1 0 1.25.55 1.25 1.05v6h2V13a2.68 2.68 0 0 0-.8-2.1 3.27 3.27 0 0 0-2.4-.9zM13 8.25h2A5.89 5.89 0 0 0 16.47 5h-2A7.17 7.17 0 0 1 13 8.25z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3fcba13dfa6843c4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.136 3.012h15.729l-1.431 16.15-6.451 1.826-6.414-1.826-1.433-16.15zm5.266 7.302-.173-2.035 7.533.002.173-1.963-9.87-.002.522 5.998h6.835l-.243 2.566-2.179.602-2.214-.605-.141-1.58H7.691l.247 3.123L12 17.506l4.028-1.08.558-6.111H9.402v-.001z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$17969d92ed86d00(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.646 10.237c-.057-.032-.16-.048-.313-.048v3.542c.201 0 .324-.041.371-.122s.07-.301.07-.66v-2.092c0-.244-.008-.4-.023-.469a.223.223 0 0 0-.105-.151zm3.499 1.182c-.082 0-.137.031-.162.091-.025.061-.037.214-.037.46v1.426c0 .237.014.389.041.456.029.066.086.1.168.1.086 0 .199-.035.225-.103.027-.069.039-.234.039-.495V11.97c0-.228-.014-.377-.043-.447-.032-.069-.147-.104-.231-.104z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM6.631 14.663H5.229V9.266h1.402v5.397zm4.822 0H10.23l-.006-3.643-.49 3.643h-.875L8.342 11.1l-.004 3.563H7.111V9.266H8.93c.051.327.107.71.166 1.15l.201 1.371.324-2.521h1.832v5.397zm3.664-1.601c0 .484-.027.808-.072.97a.728.728 0 0 1-.238.383.996.996 0 0 1-.422.193c-.166.037-.418.055-.754.055h-1.699V9.266h1.047c.678 0 1.07.031 1.309.093.24.062.422.164.545.306.125.142.203.3.234.475.031.174.051.516.051 1.026v1.896zm3.654.362c0 .324-.023.565-.066.723a.757.757 0 0 1-.309.413.947.947 0 0 1-.572.174c-.158 0-.365-.035-.502-.104a1.144 1.144 0 0 1-.377-.312l-.088.344h-1.262V9.266h1.35v1.755a1.09 1.09 0 0 1 .375-.289c.137-.064.344-.096.504-.096.186 0 .348.029.484.087a.716.716 0 0 1 .44.549c.016.1.023.313.023.638v1.514z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ff8a7a219e9ea7f1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.947 8.305a6.53 6.53 0 0 0-.419-2.216 4.61 4.61 0 0 0-2.633-2.633 6.606 6.606 0 0 0-2.186-.42c-.962-.043-1.267-.055-3.709-.055s-2.755 0-3.71.055a6.606 6.606 0 0 0-2.185.42 4.607 4.607 0 0 0-2.633 2.633 6.554 6.554 0 0 0-.419 2.185c-.043.963-.056 1.268-.056 3.71s0 2.754.056 3.71c.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.043 1.268.056 3.71.056s2.755 0 3.71-.056a6.59 6.59 0 0 0 2.186-.419 4.615 4.615 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.187.043-.962.056-1.267.056-3.71-.002-2.442-.002-2.752-.058-3.709zm-8.953 8.297c-2.554 0-4.623-2.069-4.623-4.623s2.069-4.623 4.623-4.623a4.623 4.623 0 0 1 0 9.246zm4.807-8.339a1.077 1.077 0 0 1-1.078-1.078 1.077 1.077 0 1 1 2.155 0c0 .596-.482 1.078-1.077 1.078z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.994",
                    "cy": "11.979",
                    "r": "3.003"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1dbf56b2b63a8fd5(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 7.377a4.623 4.623 0 1 0 0 9.248 4.623 4.623 0 0 0 0-9.248zm0 7.627a3.004 3.004 0 1 1 0-6.008 3.004 3.004 0 0 1 0 6.008z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.806",
                    "cy": "7.207",
                    "r": "1.078"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.533 6.111A4.605 4.605 0 0 0 17.9 3.479a6.606 6.606 0 0 0-2.186-.42c-.963-.042-1.268-.054-3.71-.054s-2.755 0-3.71.054a6.554 6.554 0 0 0-2.184.42 4.6 4.6 0 0 0-2.633 2.632 6.585 6.585 0 0 0-.419 2.186c-.043.962-.056 1.267-.056 3.71 0 2.442 0 2.753.056 3.71.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.042 1.268.055 3.71.055s2.755 0 3.71-.055a6.615 6.615 0 0 0 2.186-.419 4.613 4.613 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.186.043-.962.056-1.267.056-3.71s0-2.753-.056-3.71a6.581 6.581 0 0 0-.421-2.217zm-1.218 9.532a5.043 5.043 0 0 1-.311 1.688 2.987 2.987 0 0 1-1.712 1.711 4.985 4.985 0 0 1-1.67.311c-.95.044-1.218.055-3.654.055-2.438 0-2.687 0-3.655-.055a4.96 4.96 0 0 1-1.669-.311 2.985 2.985 0 0 1-1.719-1.711 5.08 5.08 0 0 1-.311-1.669c-.043-.95-.053-1.218-.053-3.654 0-2.437 0-2.686.053-3.655a5.038 5.038 0 0 1 .311-1.687c.305-.789.93-1.41 1.719-1.712a5.01 5.01 0 0 1 1.669-.311c.951-.043 1.218-.055 3.655-.055s2.687 0 3.654.055a4.96 4.96 0 0 1 1.67.311 2.991 2.991 0 0 1 1.712 1.712 5.08 5.08 0 0 1 .311 1.669c.043.951.054 1.218.054 3.655 0 2.436 0 2.698-.043 3.654h-.011z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5bd0ab505178971a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.154 8.514c.85-2.039.906-3.738-.113-4.757-1.133-1.132-3.852-.792-6.737.565h-.341c-2.037 0-4.02.738-5.492 2.039-1.244 1.133-2.15 2.605-2.547 4.246.283-.337 1.869-2.207 3.68-3.226.058 0 .51-.283.51-.283-.057 0-.905.85-1.074 1.02-3.965 4.076-6.285 10.248-4.473 12.059 1.188 1.189 3.34.906 5.831-.452 1.075.51 2.265.735 3.565.735 1.699 0 3.285-.453 4.643-1.359 1.416-.906 2.436-2.319 3.059-3.962h-4.416c-.566 1.075-1.869 1.812-3.227 1.812-1.926 0-3.512-1.586-3.568-3.397v-.169h11.551v-.17c0-.283.057-.623.057-.848-.001-1.362-.341-2.664-.908-3.853zM4.811 19.838c-.906-.906-.621-2.662.453-4.756.51 1.416 1.359 2.662 2.435 3.567.341.282.735.565 1.133.792-1.814.963-3.285 1.133-4.021.397zm11.606-8.606H9.51v-.057c.113-1.756 1.754-3.285 3.681-3.285 1.812 0 3.284 1.416 3.397 3.285v.057h-.171zm3.454-3.171a6.948 6.948 0 0 0-1.303-1.585 8.445 8.445 0 0 0-2.718-1.699c1.813-.849 3.341-.961 4.134-.169.623.736.567 1.981-.113 3.453 0 .057 0 .057 0 0 0 .057 0 .057 0 0z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d805072887f3ab56(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.361 3.008H4.638c-.901 0-1.63.729-1.63 1.63v14.724c0 .9.729 1.631 1.63 1.631h14.724c.9 0 1.631-.73 1.631-1.631V4.638a1.63 1.63 0 0 0-1.632-1.63zM9.018 6.505c.597 0 1.098.472 1.098 1.078 0 .616-.501 1.08-1.098 1.08v.022c-.604 0-1.09-.486-1.09-1.088 0-.605.486-1.092 1.09-1.092zm7.354 10.352c-1.112 0-1.651-.662-1.651-1.566 0-.26.033-.533.114-.812l.528-1.906c.068-.208.086-.405.086-.581 0-.615-.375-.984-.971-.984-.761 0-1.26.543-1.52 1.598l-1.033 4.146h-1.811l.327-1.303c-.534.873-1.271 1.412-2.183 1.412-1.102 0-1.617-.632-1.617-1.584a4.02 4.02 0 0 1 .096-.811l.826-3.366H6.285l.388-1.43h3.075l-1.216 4.804c-.08.309-.11.559-.11.738 0 .307.148.396.385.452.146.03 1.295.011 1.918-1.376l.798-3.188h-1.294l.391-1.404h2.787l-.359 1.617c.484-.899 1.452-1.762 2.406-1.762 1.012 0 1.855.728 1.855 2.111 0 .4-.063.796-.18 1.18l-.52 1.858a2.286 2.286 0 0 0-.075.492c0 .326.136.484.368.484.238 0 .553-.181.899-1.172l.708.272c-.414 1.473-1.182 2.081-2.137 2.081z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$93105d83d25496bf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.37 17.51c-3.09.86 1.87 2.64 5.8 1a7.18 7.18 0 0 1-1.1-.54 11.59 11.59 0 0 1-4.16.18c-1.31-.15-.54-.64-.54-.64zm5.33-1.68a16.27 16.27 0 0 1-5.36.26c-1.31-.14-.45-.77-.45-.77-3.4 1.12 1.89 2.4 6.64 1a2.25 2.25 0 0 1-.83-.49zm1.82-9.73s-6.87 1.71-3.59 5.49a1.47 1.47 0 0 1-.25 2.12s2.46-1.27 1.33-2.86-1.86-2.22 2.51-4.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.13 19.14s.56.46-.63.82c-2.27.69-9.43.9-11.42 0-.72-.31.62-.74 1-.83a2.54 2.54 0 0 1 .69-.08c-.8-.56-5.15 1.1-2.21 1.58 8.05 1.37 14.64-.56 12.57-1.49zm-2.76-4.88a7 7 0 0 1 .92-.49s-1.51.27-3 .4a28.11 28.11 0 0 1-4.82.05C6.09 13.91 9.74 13 9.74 13a6.81 6.81 0 0 0-3.16.75c-2.06 1.03 5.09 1.48 8.79.51zm.91 2.44a.39.39 0 0 1-.08.09c5-1.32 3.18-4.65.78-3.81a.71.71 0 0 0-.33.25s.14-.05.43-.12c1.22-.25 2.92 1.63-.8 3.59zM12 13c-.74-1.67-3.26-3.14 0-5.71C16.09 4.08 14 2 14 2c.84 3.31-3 4.31-4.34 6.37-.93 1.41.47 2.92 2.34 4.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.41 21.32a29.75 29.75 0 0 1-9.14.14s.46.38 2.84.53c3.61.23 9.15-.12 9.29-1.83 0 0-.26.64-2.99 1.16z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$dc08754299d05ee3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v18H3V3zm16.525 13.707c-.131-.821-.666-1.511-2.252-2.155-.552-.259-1.165-.438-1.349-.854-.068-.248-.078-.382-.034-.529.113-.484.687-.629 1.137-.495.293.09.563.315.732.676.775-.507.775-.507 1.316-.844-.203-.314-.304-.451-.439-.586-.473-.528-1.103-.798-2.126-.775l-.528.067c-.507.124-.991.395-1.283.754-.855.968-.608 2.655.427 3.354 1.023.765 2.521.933 2.712 1.653.18.878-.652 1.159-1.475 1.058-.607-.136-.945-.439-1.316-1.002l-1.372.788c.157.359.337.517.607.832 1.305 1.316 4.568 1.249 5.153-.754.021-.067.18-.528.056-1.237l.034.049zm-6.737-5.434h-1.686c0 1.453-.007 2.898-.007 4.354 0 .924.047 1.772-.104 2.033-.247.517-.886.451-1.175.359-.297-.146-.448-.349-.623-.641-.047-.078-.082-.146-.095-.146l-1.368.844c.229.473.563.879.994 1.137.641.383 1.502.507 2.404.305.588-.17 1.095-.519 1.358-1.059.384-.697.302-1.553.299-2.509.008-1.541 0-3.083 0-4.635l.003-.042z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$287d59ba20038bae(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.539 14.059-1.874 1.875-1.777 1.777-.347.35a3.993 3.993 0 0 1-3.785 1.048A2.41 2.41 0 0 1 3 18.567c0-1.138.792-2.092 1.852-2.342a3.993 3.993 0 0 1 1.047-3.811l.135-.135 1.777 1.778-.138.135a1.48 1.48 0 0 0 0 2.092 1.462 1.462 0 0 0 2.09 0l.349-.349 1.775-1.778 1.877-1.879 1.775 1.781zm.693 4.988a3.986 3.986 0 0 1-3.996-.988l-.135-.139 1.773-1.777.135.139a1.48 1.48 0 0 0 2.09 0 1.474 1.474 0 0 0-.002-2.086l-.35-.349-1.773-1.777-1.877-1.878 1.777-1.776 1.875 1.879 1.774 1.777.349.349a3.962 3.962 0 0 1 1.058 3.766 2.407 2.407 0 0 1-.336 4.79 2.392 2.392 0 0 1-2.352-1.924l-.01-.006zm-8.001-8.962 1.881-1.879 1.777-1.777.347-.346a3.972 3.972 0 0 1 3.949-1.002 2.408 2.408 0 1 1 2.699 2.716 3.98 3.98 0 0 1-1.012 3.925l-.137.139-1.777-1.777.139-.138a1.474 1.474 0 1 0-2.086-2.085l-.347.346-1.777 1.776-1.879 1.876-1.777-1.774zm-1.99 1.984-.346-.347a3.984 3.984 0 0 1-.999-3.965 2.414 2.414 0 0 1-1.874-2.35A2.41 2.41 0 0 1 5.43 3c1.197 0 2.19.875 2.378 2.019a3.99 3.99 0 0 1 3.734 1.061l.138.14-1.778 1.776-.137-.136a1.481 1.481 0 0 0-2.088 0 1.481 1.481 0 0 0-.004 2.092l.349.35 1.777 1.777 1.879 1.879-1.775 1.777-1.883-1.879-1.778-1.777v-.01h-.001z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7252c317e53a446e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.345 6.935c-1.756 2.523-1.538 5.806-.196 8.487l.098.19c.021.04.041.082.063.121.012.024.026.047.039.069a7.842 7.842 0 0 0 .198.344l.073.12a9.14 9.14 0 0 0 .211.33 10.179 10.179 0 0 0 .221.319l.036.049c.063.088.129.175.196.261l.074.094.182.223.069.082c.082.097.167.194.252.289l.005.005c.004.004.007.006.01.011.083.091.17.181.256.271l.083.083.205.201.084.08c.092.087.186.172.281.256l.004.004.049.041c.083.073.169.145.255.215l.105.084a11.03 11.03 0 0 0 .565.424c.029.021.057.042.087.062l.024.017c.076.053.154.103.231.153.033.022.066.045.101.067a10.975 10.975 0 0 0 .886.509c.065.034.129.068.195.101l.045.022.08.039c.102.048.205.097.308.143l.066.029c.119.052.239.102.36.149l.088.035a13.895 13.895 0 0 0 .382.142c.125.044.252.085.38.124l.092.028c.128.039.256.085.39.11 8.492 1.548 10.958-5.102 10.958-5.102-2.072 2.698-5.748 3.41-9.232 2.618-.132-.03-.261-.071-.39-.109l-.097-.029a10.929 10.929 0 0 1-.755-.264l-.093-.036c-.12-.047-.239-.097-.356-.148l-.071-.031a11.932 11.932 0 0 1-.301-.14l-.087-.042c-.078-.038-.155-.079-.232-.118-.051-.027-.104-.053-.155-.082a8.294 8.294 0 0 1-.278-.156l-.094-.052a11.4 11.4 0 0 1-.363-.223l-.098-.065a10.557 10.557 0 0 1-.259-.172l-.083-.059c-.082-.058-.164-.116-.244-.176a11.921 11.921 0 0 1-.328-.255l-.099-.079c-.092-.076-.184-.152-.274-.231a12.01 12.01 0 0 1-.319-.288c-.028-.026-.055-.051-.081-.078a7.985 7.985 0 0 1-.208-.203l-.081-.081a10.76 10.76 0 0 1-.254-.269l-.012-.012a11.75 11.75 0 0 1-.258-.293l-.067-.081a10.313 10.313 0 0 1-.254-.313 11.855 11.855 0 0 1-.215-.286C3.864 11.825 3.17 8.186 4.715 5.198"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.794 4.809c-1.27 1.827-1.2 4.273-.21 6.205.166.324.353.639.561.938.191.273.401.597.654.816.092.101.187.199.284.295l.076.074c.094.092.19.182.291.271l.011.01.003.002c.111.097.224.19.34.281l.078.06a8.281 8.281 0 0 0 .366.268c.053.037.108.072.161.107.026.017.051.035.078.051a7.14 7.14 0 0 0 .301.184c.076.044.155.087.233.13.026.015.055.029.082.043.055.028.108.057.163.083a9.645 9.645 0 0 0 .365.171l.074.031c.093.039.186.077.281.113l.117.044c.086.032.171.06.256.089l.117.037c.121.038.243.085.37.107 6.556 1.086 8.068-3.961 8.068-3.961-1.364 1.964-4.006 2.902-6.825 2.17a7.866 7.866 0 0 1-.743-.232l-.118-.043a7.629 7.629 0 0 1-.353-.145 8.79 8.79 0 0 1-.344-.159c-.057-.028-.113-.058-.17-.087l-.099-.051a9.352 9.352 0 0 1-.533-.313l-.08-.053a7.65 7.65 0 0 1-.602-.435c-1.234-.974-2.213-2.306-2.678-3.815-.488-1.566-.382-3.323.462-4.75"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.379 3.221c-.749 1.102-.823 2.469-.304 3.686.548 1.292 1.671 2.304 2.981 2.785a3.85 3.85 0 0 0 .234.079c.077.024.152.053.233.067 3.62.699 4.601-1.857 4.862-2.234-.86 1.239-2.306 1.536-4.078 1.105a5.403 5.403 0 0 1-.939-.344 5.39 5.39 0 0 1-.895-.545c-1.585-1.204-2.573-3.501-1.536-5.372"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a11c76aadfb78ec6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.58 11.375c.008-.117.018-.231.018-.35 0-3.243-2.668-5.871-5.959-5.871A5.966 5.966 0 0 0 8.26 8.502a2.732 2.732 0 0 0-1.674-.568c-1.521 0-2.752 1.21-2.752 2.704 0 .283.043.554.125.808a3.957 3.957 0 0 0-1.98 3.418c0 2.173 1.773 3.938 3.975 3.972h11.898c.074 0 .15.012.227.012 2.178 0 3.943-1.739 3.943-3.893a3.885 3.885 0 0 0-2.432-3.579h-.01v-.001zM7.355 15.842a2.329 2.329 0 0 1-.748-1.318 2.865 2.865 0 0 1-.053-.544c0-.74.27-1.347.809-1.827.537-.48 1.221-.722 2.049-.722.854 0 1.654.32 2.363.957.176.158.352.338.514.536l.912 1.071c.158.217.324.399.5.56.471.422.977.632 1.408.632.365 0 .67-.112.912-.336.209-.19.336-.45.363-.73l.008-.123a1.054 1.054 0 0 0-.055-.347 1.275 1.275 0 0 0-1.238-.838c-.453 0-.902.153-1.396.631l-.807-.95-.088-.108c.713-.691 1.414-.95 2.367-.95.838 0 1.525.237 2.037.712l.014.014c.539.474.801 1.089.801 1.842a2.6 2.6 0 0 1-.049.528 2.38 2.38 0 0 1-.74 1.301 2.685 2.685 0 0 1-1.428.677 4.505 4.505 0 0 1-.588.038c-.863 0-1.676-.313-2.365-.938a4.866 4.866 0 0 1-.537-.576l-.914-1.065a3.58 3.58 0 0 0-.488-.563c-.463-.425-.977-.626-1.428-.626-.129 0-.26.018-.389.051a1.19 1.19 0 0 0-.523.289c-.232.216-.365.52-.365.839 0 .324.113.6.352.825l.014.013c.25.227.563.338.926.338.463 0 .914-.162 1.4-.639l.801.938.088.099c-.725.703-1.428.965-2.342.965-.838 0-1.525-.238-2.051-.713l-.046.057z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e0fb90ceb2d73e53(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.198 9.127 3.309-4.799c.628-.902 1.434-1.354 2.427-1.354.806 0 1.506.287 2.097.861.59.574.885 1.26.885 2.059 0 .59-.155 1.113-.469 1.563l-2.983 4.34 3.649 4.627c.363.461.547 1 .547 1.617 0 .816-.286 1.518-.86 2.105a2.81 2.81 0 0 1-2.084.879c-.895 0-1.577-.291-2.047-.873L10.2 14.574v3.074c0 .879-.152 1.561-.457 2.049-.555.885-1.356 1.328-2.417 1.328-.963 0-1.711-.328-2.24-.977-.496-.602-.744-1.396-.744-2.387V6.258c0-.936.253-1.709.755-2.318.525-.643 1.255-.965 2.186-.965.887 0 1.624.322 2.216.965.329.357.537.717.625 1.082.053.227.079.646.079 1.266v2.84h-.005z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ca822288ab6f0f61(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.013 13.738-2.254.387a4.475 4.475 0 0 0 1.753 2.231l.865-2.095a.27.27 0 0 0 .022-.228c-.022-.18-.204-.295-.386-.295zm.865-2.914c.205 0 .387-.159.387-.364l.114-2.277-.456.091a4.516 4.516 0 0 0-2.118 1.162l1.89 1.343c.069.022.115.045.183.045zm-1.002 1.48a.366.366 0 0 0-.045-.524l-1.685-1.503a4.797 4.797 0 0 0-.661 2.778l2.209-.637c.091-.023.137-.046.182-.114zm1.457.797.616.296.614-.296.16-.661-.433-.546h-.683l-.433.546zm1.344-2.436c.114.159.341.182.5.091l1.867-1.32a4.286 4.286 0 0 0-2.573-1.23l.137 2.3a.215.215 0 0 0 .069.159z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.944 14.103-1.73-7.446c-.113-.364-.387-.66-.729-.842L12.541 2.49c-.182-.091-.387-.114-.569-.114s-.387 0-.569.045L4.457 5.769a1.22 1.22 0 0 0-.683.842l-1.708 7.492c-.068.387.023.774.25 1.093l4.805 5.943c.273.273.66.456 1.047.479h7.651c.41.045.797-.137 1.048-.479l4.805-5.943c.227-.319.318-.706.272-1.093zm-2.845.501c-.046 0-.068 0-.114-.023-.022-.023-.022-.023-.045-.023-.046 0-.068-.022-.092-.022-.091-.023-.159-.068-.25-.114a.32.32 0 0 1-.137-.045h-.022a3.91 3.91 0 0 0-.729-.205h-.022a.26.26 0 0 0-.182.068s0 .023-.023.023l-.183-.024a5.628 5.628 0 0 1-2.46 3.097l.068.182s-.022 0-.022.022a.264.264 0 0 0-.022.228c.091.228.205.455.364.66v.045a.396.396 0 0 1 .091.114.81.81 0 0 1 .159.228c.023.022.046.045.046.068 0 0 .022 0 .022.022a.582.582 0 0 1 .023.342.38.38 0 0 1-.205.25c-.068.022-.114.045-.183.045a.511.511 0 0 1-.433-.273c-.022 0-.022-.022-.022-.022-.022-.023-.022-.045-.046-.068-.045-.068-.068-.159-.091-.25l-.046-.137v-.022a3.816 3.816 0 0 0-.296-.706.353.353 0 0 0-.182-.137c0-.023 0-.023-.023-.023l-.091-.159c-.228.068-.479.159-.729.205-.41.114-.82.159-1.229.159a5.368 5.368 0 0 1-1.981-.364l-.091.182c0 .023 0 .023-.023.023a.35.35 0 0 0-.182.137c-.114.228-.228.455-.296.706l-.045.137c-.023.091-.068.159-.091.25-.022.023-.045.045-.045.068-.023 0-.023.022-.023.022a.508.508 0 0 1-.433.273.434.434 0 0 1-.159-.045.469.469 0 0 1-.182-.615c.023 0 .023-.023.023-.023.022-.023.022-.045.045-.068.068-.091.114-.182.159-.228s.068-.068.091-.114v-.023a3.73 3.73 0 0 0 .364-.66.268.268 0 0 0-.023-.228s-.022 0-.022-.022l.114-.16a3.578 3.578 0 0 1-.615-.41 5.493 5.493 0 0 1-1.867-2.664l-.205.022s0-.022-.023-.022a.256.256 0 0 0-.182-.068h-.022a4.015 4.015 0 0 0-.751.205h-.024c-.045 0-.091.023-.137.046-.068.022-.159.068-.25.091-.022 0-.091-.022-.091 0 0 .023 0 .023-.023.023-.045.023-.068.023-.114.023a.424.424 0 0 1-.456-.319.445.445 0 0 1 .364-.524c.023-.023.023-.023.046-.023.045 0 .068-.022.091-.022.091 0 .182-.023.273-.023.045-.022.091-.022.137-.022a4.2 4.2 0 0 0 .774-.137c.068-.046.137-.091.16-.16 0 0 .022 0 .022-.022l.182-.046c-.205-1.298.091-2.618.797-3.734.022-.045.045-.068.068-.114l-.131-.132a.106.106 0 0 1-.004.019v-.023l.004.004c.01-.065-.031-.145-.072-.186-.182-.182-.41-.319-.638-.455l-.136-.069a2.587 2.587 0 0 1-.251-.136c-.022 0-.068-.045-.068-.045s0-.023-.022-.023a.49.49 0 0 1-.092-.639c.068-.114.182-.159.319-.159a.54.54 0 0 1 .319.114l.023.023c.022.022.045.022.068.045.068.069.114.137.182.205.023.022.068.045.091.091.159.182.364.364.569.524.045.022.091.045.137.045.045 0 .068-.023.091-.023h.023l.137.091a5.426 5.426 0 0 1 2.801-1.594c.273-.046.523-.091.774-.114l.023-.182v-.045c.068-.045.091-.114.114-.182 0-.273 0-.524-.045-.774v-.023c0-.045 0-.091-.023-.137a1.129 1.129 0 0 1-.045-.273v-.113c0-.114.045-.228.137-.319.114-.114.25-.182.387-.159a.45.45 0 0 1 .387.478v.137c-.023.091-.023.182-.045.273 0 .045-.023.091-.023.136v.023c-.048.273-.048.524-.048.774.023.068.045.136.114.182v-.023l.023.182a5.84 5.84 0 0 1 2.96 1.184c.183.182.387.364.569.546l.183-.114h.022c.022.023.068.023.091.023.046 0 .091-.023.137-.045.205-.137.41-.319.569-.501.022-.023.068-.046.091-.091.046-.068.114-.137.183-.205.022 0 .045-.022.068-.045l.022-.023a.546.546 0 0 1 .318-.114c.114 0 .251.068.319.16.159.205.113.478-.091.637 0 .023.022.023 0 .046-.023.022-.046.022-.068.045-.092.045-.16.091-.251.137l-.137.068a4.104 4.104 0 0 0-.638.455c-.045.046-.068.137-.068.205v.023l-.136.137c.364.569.638 1.207.797 1.867.137.66.182 1.343.091 2.003l.182.046a.278.278 0 0 0 .16.159c.25.068.523.114.773.137h.023a.297.297 0 0 0 .137.022c.091 0 .182 0 .272.023.046 0 .092 0 .092.023 0 .022.022.022.045.022a.537.537 0 0 1 .41.479.49.49 0 0 1-.453.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.085 14.718a.352.352 0 0 0-.455.091l-1.116 2.027c.456.136.957.228 1.435.228.341 0 .66-.045.979-.114.159-.045.296-.068.433-.091l-1.093-1.981c-.069-.069-.115-.115-.183-.16zm3.644-4.441-1.708 1.548a.36.36 0 0 0-.091.16c-.046.205.068.41.273.455l2.163.615a4.375 4.375 0 0 0-.092-1.435 4.63 4.63 0 0 0-.545-1.343zm-2.073 3.484a.371.371 0 0 0-.205.433l.889 2.141a4.366 4.366 0 0 0 1.366-1.366c.182-.25.318-.547.433-.865l-2.277-.387a.634.634 0 0 0-.206.044z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2fe59477387353b6(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.142 10.843c0-.64.098-1.018.098-1.707 0-1.067-.393-1.411-1.263-1.411h-.641v.755h.196c.444 0 .542.147.542.689 0 .509-.049 1.018-.049 1.608 0 .755.246 1.05.739 1.165v.049c-.493.116-.739.411-.739 1.166 0 .591.049 1.067.049 1.608 0 .558-.114.705-.542.705v.017h-.196v.788h.641c.87 0 1.263-.344 1.263-1.411 0-.706-.098-1.067-.098-1.707 0-.345.213-.706.854-.739v-.853c-.642-.016-.854-.377-.854-.722zm-3.299 1.001c-.493-.196-.952-.312-.952-.64 0-.246.197-.395.558-.395.361 0 .689.148 1.05.411l.657-.87c-.409-.313-.968-.641-1.724-.641-1.115 0-1.871.641-1.871 1.544 0 .804.706 1.214 1.298 1.443.508.196 1.001.361 1.001.689 0 .246-.197.41-.641.41-.41 0-.821-.164-1.263-.509l-.657.952c.492.41 1.247.689 1.871.689 1.313 0 2.019-.689 2.019-1.592-.001-.9-.707-1.277-1.346-1.491zm-11.21 1.854c-.114 0-.262-.098-.262-.41V7.725H4.039c-.886 0-1.279.344-1.279 1.411 0 .706.099 1.101.099 1.707 0 .345-.213.706-.854.739v.853c.641.017.854.378.854.723 0 .606-.099.968-.099 1.674 0 1.067.394 1.411 1.264 1.411h.64v-.755h-.197c-.411 0-.542-.164-.542-.706 0-.541.049-1.001.049-1.607 0-.756-.245-1.05-.738-1.165v-.051c.493-.114.738-.409.738-1.165 0-.59-.049-1.066-.049-1.607 0-.542.114-.689.542-.689h.442v4.711c0 1.001.345 1.657 1.346 1.657.313 0 .559-.05.739-.115l-.165-1.066c-.098.013-.146.013-.196.013zm7.238-1.854c-.509-.196-.969-.312-.969-.64 0-.246.197-.395.558-.395.361 0 .689.148 1.051.411l.656-.87c-.41-.313-.968-.641-1.723-.641-1.116 0-1.872.641-1.872 1.544 0 .804.707 1.214 1.297 1.443.51.196 1.002.361 1.002.689 0 .246-.197.41-.641.41-.41 0-.82-.164-1.264-.509l-.64.952c.492.41 1.247.689 1.871.689 1.313 0 2.019-.689 2.019-1.592.001-.9-.705-1.277-1.345-1.491zm-4.842-2.15c-1.198 0-2.347 1.001-2.314 2.577 0 1.624 1.066 2.576 2.479 2.576.591 0 1.247-.214 1.756-.558l-.492-.87c-.36.213-.706.312-1.066.312-.657 0-1.165-.312-1.297-1.066h2.971c.017-.115.049-.345.049-.607.016-1.33-.707-2.364-2.086-2.364zm-.935 2.068c.099-.655.492-.969.951-.969.592 0 .821.411.821.969H8.094z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c4ea3fa645ae5530(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.339 18.337H5.667v-8.59h2.672v8.59zM7.003 8.574a1.548 1.548 0 1 1 0-3.096 1.548 1.548 0 0 1 0 3.096zm11.335 9.763h-2.669V14.16c0-.996-.018-2.277-1.388-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248h-2.667v-8.59h2.56v1.174h.037c.355-.675 1.227-1.387 2.524-1.387 2.704 0 3.203 1.778 3.203 4.092v4.71z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$74e34d67553ecf8a(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.983",
                    "cy": "5.009",
                    "r": "2.188"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bde189796fbbfa57(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 22.019-3.717-2.146V9.863l2.479-1.43v10.01l1.238.753 1.238-.753V8.434l2.479 1.43v10.01L12 22.019zm8.666-15.014v10.009l-2.475 1.43V8.434L12 4.861 5.807 8.434v10.01l-2.473-1.43V7.005L12 2l8.666 5.005z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3dd86f90f6ac041b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.279 11.506c.132-.016.257-.018.373 0 .066-.154.078-.419.019-.708-.09-.429-.211-.688-.461-.646-.251.04-.261.35-.17.779.05.24.14.446.239.575zm-2.149.339c.18.078.29.129.331.086.029-.028.021-.084-.022-.154a1.05 1.05 0 0 0-.464-.371 1.26 1.26 0 0 0-1.228.146c-.119.088-.232.209-.218.283.007.023.023.042.065.05.099.011.444-.164.843-.188.282-.02.513.068.693.148zm-.361.205c-.232.037-.361.113-.443.187-.071.062-.113.128-.113.177l.018.042.037.014c.053 0 .171-.046.171-.046.324-.115.539-.102.752-.078.117.014.172.02.198-.02.007-.012.018-.035-.007-.074-.056-.091-.291-.24-.613-.202zm1.784.756c.159.078.333.046.39-.069.059-.115-.024-.272-.183-.349-.158-.079-.333-.049-.39.066-.057.115.026.274.183.352zm1.018-.891c-.128-.002-.234.138-.238.316-.003.177.1.321.229.322.129.002.235-.139.238-.315s-.099-.32-.229-.323zm-8.644 3.183c-.032-.04-.085-.029-.136-.015-.036.007-.076.017-.119.016a.265.265 0 0 1-.221-.111c-.059-.09-.056-.225.01-.378l.03-.069c.104-.231.275-.619.082-.988a.88.88 0 0 0-.671-.488.861.861 0 0 0-.739.267c-.284.313-.327.741-.273.893.021.056.053.071.075.074.048.007.119-.029.164-.15l.014-.038c.02-.064.057-.184.118-.278a.518.518 0 0 1 .717-.15c.2.131.275.375.19.608-.044.121-.115.351-.1.54.032.383.27.537.48.556.206.007.35-.108.387-.193.021-.053.003-.084-.008-.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.821 14.397c-.009-.029-.061-.216-.13-.44l-.144-.384c.281-.423.286-.799.249-1.013a1.284 1.284 0 0 0-.372-.724c-.222-.232-.677-.472-1.315-.651l-.335-.093c-.002-.015-.018-.79-.031-1.123-.011-.24-.031-.616-.148-.986-.14-.502-.381-.938-.684-1.221.835-.864 1.355-1.817 1.354-2.634-.003-1.571-1.933-2.049-4.312-1.063l-.503.214c-.002-.002-.911-.894-.924-.905-2.714-2.366-11.192 7.06-8.48 9.349l.593.501a2.916 2.916 0 0 0-.166 1.345c.065.631.389 1.234.915 1.701.5.442 1.159.724 1.796.723 1.055 2.432 3.465 3.922 6.291 4.007 3.032.09 5.576-1.333 6.644-3.889.069-.179.365-.987.365-1.7-.001-.718-.406-1.015-.663-1.014zM7.416 16.309a1.38 1.38 0 0 1-.28.021c-.916-.026-1.905-.85-2.003-1.827-.109-1.08.443-1.912 1.421-2.108.116-.025.258-.038.41-.031.548.032 1.354.452 1.539 1.645.164 1.055-.096 2.132-1.087 2.3zm-1.021-4.562a2.325 2.325 0 0 0-1.473.94c-.197-.164-.562-.48-.626-.604-.524-.994.571-2.928 1.337-4.02 1.889-2.698 4.851-4.739 6.223-4.371.222.064.96.921.96.921s-1.37.759-2.642 1.819c-1.711 1.32-3.006 3.236-3.779 5.315zm9.611 4.158a.05.05 0 0 0 .03-.054.05.05 0 0 0-.056-.045s-1.434.212-2.789-.283c.147-.479.541-.308 1.134-.259a8.287 8.287 0 0 0 2.735-.296c.613-.177 1.419-.524 2.045-1.018.212.465.286.975.286.975s.163-.029.3.055c.13.08.224.245.16.671-.133.798-.471 1.445-1.042 2.041a4.259 4.259 0 0 1-1.249.934 5.337 5.337 0 0 1-.814.346c-2.149.701-4.349-.07-5.058-1.727a2.761 2.761 0 0 1-.142-.392c-.302-1.092-.046-2.4.755-3.226v-.001c.051-.052.102-.113.102-.191 0-.064-.042-.133-.077-.183-.28-.406-1.253-1.099-1.057-2.44.139-.964.982-1.642 1.768-1.602l.2.012c.34.02.637.063.917.076.47.019.891-.049 1.391-.465.169-.142.304-.263.532-.301.024-.006.084-.025.203-.021a.681.681 0 0 1 .343.109c.4.266.457.912.479 1.385.012.269.045.922.055 1.108.026.428.139.489.365.563.129.044.248.074.423.125.529.147.845.3 1.043.493a.637.637 0 0 1 .188.372c.065.457-.353 1.021-1.455 1.533-1.206.559-2.669.701-3.679.588l-.354-.04c-.81-.108-1.269.936-.784 1.651.313.461 1.164.761 2.017.761 1.953.002 3.455-.832 4.015-1.554l.044-.063c.026-.042.005-.063-.03-.041-.455.312-2.483 1.552-4.651 1.18 0 0-.264-.044-.504-.138-.19-.072-.591-.258-.639-.668 1.747.543 2.85.031 2.85.03zm-2.773-.327zM9.886 8.053c.672-.776 1.499-1.452 2.241-1.83.025-.014.052.015.038.038a2.125 2.125 0 0 0-.208.508c-.006.027.023.049.046.032.462-.314 1.264-.651 1.968-.693a.03.03 0 0 1 .021.055 1.66 1.66 0 0 0-.31.311c-.014.02-.001.049.024.049.494.003 1.191.175 1.644.43.03.018.008.077-.025.069-.688-.157-1.811-.277-2.979.008-1.044.254-1.84.646-2.419 1.069-.03.02-.065-.019-.041-.046z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1bb9637453e756a7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.553 18.15H3.447a1.443 1.443 0 0 1-1.442-1.441V7.291c0-.795.647-1.441 1.442-1.441h17.105c.795 0 1.442.646 1.442 1.441v9.418a1.441 1.441 0 0 1-1.441 1.441zM6.811 15.268V11.52l1.922 2.402 1.922-2.402v3.748h1.922V8.732h-1.922l-1.922 2.403-1.922-2.403H4.889v6.535h1.922zM19.688 12h-1.922V8.732h-1.923V12h-1.922l2.884 3.364L19.688 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b7abc94b31fdbb31(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.454 17.021c.048.041.1.082.151.122a6.173 6.173 0 0 1-3.42 1.03A6.17 6.17 0 0 1 2.01 12a6.175 6.175 0 0 1 9.592-5.144c-.05.043-.1.082-.138.126A6.633 6.633 0 0 0 9.166 12c0 1.925.833 3.755 2.288 5.021zm4.361-11.195a6.14 6.14 0 0 0-3.416 1.03c.049.043.099.082.137.126 1.462 1.263 2.299 3.094 2.299 5.018s-.835 3.753-2.288 5.021c-.049.041-.101.082-.151.122a6.162 6.162 0 0 0 3.418 1.03 6.174 6.174 0 1 0 .001-12.347zM12 7.15A6.152 6.152 0 0 0 9.644 12 6.15 6.15 0 0 0 12 16.853 6.157 6.157 0 0 0 14.357 12 6.15 6.15 0 0 0 12 7.15z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5618e1c37114fedb(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.24c2.5-.3 4.69-1.84 5-3.25a33.59 33.59 0 0 0 .4-5.42C21.33 4.23 18.48 3 18.48 3A17.64 17.64 0 0 0 12 2a17.64 17.64 0 0 0-6.48 1S2.68 4.23 2.68 8.57v3.44c.1 4.24.78 8.42 4.7 9.46A14.73 14.73 0 0 0 12 22a9.21 9.21 0 0 0 3.54-.81l-.07-1.64A11.41 11.41 0 0 1 12 20c-1.8-.06-3.71-.19-4-2.4a4.26 4.26 0 0 1 0-.63 22.68 22.68 0 0 0 4 .54 23.6 23.6 0 0 0 4-.27zm-6.54-9.8q-1.35 0-1.35 1.62v5.1H6V8.9a3.78 3.78 0 0 1 .82-2.56 2.85 2.85 0 0 1 2.23-1 2.68 2.68 0 0 1 2.4 1.23l.52.87.52-.87a2.68 2.68 0 0 1 2.4-1.23 2.85 2.85 0 0 1 2.23 1A3.78 3.78 0 0 1 18 8.9v5.26h-2.11v-5.1q0-1.62-1.35-1.62c-1 0-1.51.64-1.51 1.92v2.79H11V9.36c0-1.28-.54-1.92-1.54-1.92z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1d5966979233102b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.957 6.73a.073.073 0 0 0-.019-.097c-.004-.004-.008-.008-.012-.01l-.006-.002-6.033-3.018a.729.729 0 0 0-.292-.067.692.692 0 0 0-.586.317l-3.474 5.646 4.359 7.083 6.063-9.852zm-1.064 13.543c.611.306 1.107.092 1.107-.478V8.483l-5.809 9.439 4.702 2.351zM9.622 8.213v6.426l5.711 2.855zm-7.068 9.558 5.19 2.595a.845.845 0 0 0 .374.098c.323 0 .549-.25.549-.669V6.701a.067.067 0 0 0-.035-.059L2.739 3.697a.669.669 0 0 0-.3-.079c-.258 0-.439.199-.439.534v12.723c0 .341.25.744.554.896z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a1a007a211a36b1e(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-2.046 4.265-.966.925a.28.28 0 0 0-.106.271v6.801a.28.28 0 0 0 .106.271l.942.926v.204h-4.741v-.204l.977-.948c.097-.096.097-.125.097-.271V9.742l-2.716 6.896h-.368L8.018 9.742v4.622a.644.644 0 0 0 .176.531l1.271 1.541v.203H5.861v-.203l1.271-1.541a.618.618 0 0 0 .164-.531V9.02a.468.468 0 0 0-.152-.395l-1.13-1.36v-.203H9.52l2.71 5.943 2.382-5.943h3.343v.203z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$35e72d25f6bc113c(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 7.269a.733.733 0 0 0-.24-.619l-1.77-2.133v-.32h5.498l4.25 9.32 3.736-9.32H21v.319l-1.515 1.451a.45.45 0 0 0-.168.425v10.666a.448.448 0 0 0 .168.425l1.479 1.451v.319h-7.436v-.319l1.529-1.487c.152-.15.152-.195.152-.424V8.401L10.95 19.218h-.575L5.417 8.401v7.249c-.041.305.06.612.275.833L7.684 18.9v.319H2.036V18.9l1.992-2.417a.971.971 0 0 0 .257-.833V7.269z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$7ceb49f1316c1f0f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.92 0-8.91 3.729-8.91 8.332 0 2.616 1.291 4.952 3.311 6.479V21l3.041-1.687c.811.228 1.668.35 2.559.35 4.92 0 8.91-3.73 8.91-8.331C20.91 6.729 16.92 3 12 3zm.938 11.172-2.305-2.394-4.438 2.454 4.865-5.163 2.305 2.395 4.439-2.455-4.866 5.163z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$97d75f056aec8a21(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.26 7.8a4.82 4.82 0 0 0-3.93-2.44 3.91 3.91 0 0 0-2.54 1.09 10.58 10.58 0 0 0-1.52 1.71 11 11 0 0 0-1.63-1.72 4.39 4.39 0 0 0-2.88-1.08A5 5 0 0 0 3.7 8 11.49 11.49 0 0 0 2 14a7 7 0 0 0 .18 1.64A4.44 4.44 0 0 0 2.71 17a3.23 3.23 0 0 0 3 1.6c1.25 0 2.19-.56 3.3-2a26.4 26.4 0 0 0 2.21-3.6l.63-1.12c.06-.09.11-.18.16-.27l.15.25 1.79 3A14.77 14.77 0 0 0 16 17.63a3.38 3.38 0 0 0 2.55 1 3 3 0 0 0 2.54-1.23 2.2 2.2 0 0 0 .18-.28 4.1 4.1 0 0 0 .31-.63l.12-.35A6.53 6.53 0 0 0 22 15a9 9 0 0 0 0-1 11.15 11.15 0 0 0-1.74-6.2zm-10.12 3.56c-.64 1-1.57 2.51-2.37 3.61-1 1.37-1.51 1.51-2.07 1.51a1.29 1.29 0 0 1-1.15-.66 3.3 3.3 0 0 1-.39-1.7A9.74 9.74 0 0 1 5.54 9a2.8 2.8 0 0 1 2.19-1.47A3 3 0 0 1 10 8.74a14.07 14.07 0 0 1 1 1.31zm8.42 5.12c-.48 0-.85-.19-1.38-.83A34.87 34.87 0 0 1 14.82 12l-.52-.86c-.36-.61-.71-1.16-1-1.65a2.46 2.46 0 0 1 .17-.27c.94-1.39 1.77-2.17 2.8-2.17a3.12 3.12 0 0 1 2.49 1.66 10.17 10.17 0 0 1 1.37 5.34c-.04 1.31-.34 2.43-1.57 2.43z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3648aa56b1325c46(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "20.288",
                    "cy": "8.344",
                    "r": "1.707"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.581 11.513h3.413v3.656c0 .942-.765 1.706-1.707 1.706h-1.706v-5.362zM2.006 4.2v15.6l11.213 1.979V2.221L2.006 4.2zm8.288 5.411-1.95.049v5.752H6.881V9.757l-1.949.098V8.539l5.362-.292v1.364zm3.899.439v8.288h1.95c.808 0 1.463-.655 1.463-1.462V10.05h-3.413zm1.463-4.875c-.586 0-1.105.264-1.463.673v2.555c.357.409.877.673 1.463.673a1.95 1.95 0 0 0 0-3.901z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$706e702d859b2cc2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.55 21H3v-8.55h8.55V21zM21 21h-8.55v-8.55H21V21zm-9.45-9.45H3V3h8.55v8.55zm9.45 0h-8.55V3H21v8.55z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8ab70fecd6544b67(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.74 4.23c-.84-1-1.57-2-1.71-2.22H12c-.14.21-.87 1.22-1.71 2.22-7.2 9.19 1.14 15.39 1.14 15.39l.07.05c.06.95.22 2.33.22 2.33h.62s.15-1.37.21-2.33l.07-.06s8.32-6.19 1.12-15.38zM12 19.48a3.48 3.48 0 0 1-.48-.48L12 9l.45 10a3.57 3.57 0 0 1-.45.48z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$99c23b8f1adf765f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.13 9.68 22 11.8v-.11c-.07-.24-.28-.45-.7-.87l-2-2-2.07.87zM12.2 7.24a1.31 1.31 0 0 1 .16.47l3 1.29a1.11 1.11 0 0 1 .29-.14l.48-3-2-2-1.95 3.3s0 .05.02.08zM10.61 7a1.1 1.1 0 0 1 1-.2h.05l2.16-3.34-.66-.66c-.42-.42-.63-.63-.87-.7a1 1 0 0 0-.63 0c-.24.07-.45.28-.87.7l-3 3c.31.14 2.5 1.06 2.78 1.19zm-3.12 5.29h.27a1.45 1.45 0 0 1 .29 0l2.38-3.68v-.06a1 1 0 0 1-.27-.95L9 7l-1.7-.73L5 8.61l2.51 3.66zm7.62-2.44v-.08a.59.59 0 0 1 0-.14l-2.86-1.27h-.05a1.05 1.05 0 0 1-.88.47h-.17s-.05 0-.06.05L8.73 12.5v.05l6.33-2.7s.05.02.05 0zm1.36-.91a.83.83 0 0 1 .26.19l2-.84-1.89-1.87-.4 2.47zm-2.29 5.54A.91.91 0 0 1 15 14v-.05l.54-3.37-.09-.08L9 13.15a2.76 2.76 0 0 1 .08.27zM2 11.95zm12.14 3.18L8.92 14v.06L13.47 21l.42-.43c.15-.92.71-4.33.78-4.72a.9.9 0 0 1-.53-.72zm1.65.32a.88.88 0 0 1-.36.27l-.64 3.94L18.43 16zm1.07-5.13a.07.07 0 0 0-.06 0 .92.92 0 0 1-.61.34v.06l-.55 3.4a.88.88 0 0 1 .34.62h.06l2.95.61 2.28-2.28a4.22 4.22 0 0 0 .65-.74zM8.3 14.59a1.27 1.27 0 0 1-.86 0l-1.22 1.9 4.69 4.68a2.68 2.68 0 0 0 .87.71 1 1 0 0 0 .63 0 1.86 1.86 0 0 0 .7-.54l-4.69-6.8zm4.71 6.82zm-6.62-7.82s.06 0 .06-.05 0 0-.06 0l-4.14-.86a7.07 7.07 0 0 0 .51.54l1.36 1.36 2.27-1zm.28-.66a1.05 1.05 0 0 1 .2-.27v-.06C6.1 11.4 5.3 10.24 4.5 9.07l-1.75 1.75c-.42.42-.63.63-.7.87A.75.75 0 0 0 2 12l4.67 1zm.17 1.33a.61.61 0 0 1-.07-.1L4.59 15l1.08 1.1 1.17-1.82s.01-.02 0-.02z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$76727962b2c0a5d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.985c-.275 0-.532-.074-.772-.202l-2.439-1.448c-.365-.203-.182-.277-.072-.314.496-.165.588-.201 1.101-.493.056-.037.129-.02.185.017l1.87 1.12c.074.036.166.036.221 0l7.319-4.237c.074-.036.11-.11.11-.202V7.768c0-.091-.036-.165-.11-.201l-7.319-4.219c-.073-.037-.165-.037-.221 0L4.552 7.566c-.073.036-.11.129-.11.201v8.457c0 .073.037.166.11.202l2 1.157c1.082.548 1.762-.095 1.762-.735V8.502c0-.11.091-.221.22-.221h.936c.108 0 .22.092.22.221v8.347c0 1.449-.788 2.294-2.164 2.294-.422 0-.752 0-1.688-.46l-1.925-1.099a1.55 1.55 0 0 1-.771-1.34V7.786c0-.55.293-1.064.771-1.339l7.316-4.237a1.637 1.637 0 0 1 1.544 0l7.317 4.237c.479.274.771.789.771 1.339v8.458c0 .549-.293 1.063-.771 1.34l-7.317 4.236c-.241.11-.516.165-.773.165zm2.256-5.816c-3.21 0-3.87-1.468-3.87-2.714 0-.11.092-.221.22-.221h.954c.11 0 .201.073.201.184.147.971.568 1.449 2.514 1.449 1.54 0 2.202-.35 2.202-1.175 0-.477-.185-.825-2.587-1.063-1.999-.2-3.246-.643-3.246-2.238 0-1.485 1.247-2.366 3.339-2.366 2.347 0 3.503.809 3.649 2.568a.297.297 0 0 1-.056.165c-.037.036-.091.073-.146.073h-.953a.212.212 0 0 1-.202-.164c-.221-1.012-.789-1.34-2.292-1.34-1.689 0-1.891.587-1.891 1.027 0 .531.237.696 2.514.99 2.256.293 3.32.715 3.32 2.294-.02 1.615-1.339 2.531-3.67 2.531z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2cfc99affd960273(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.986 12.341c-2.825 0-5.173-2.346-5.173-5.122C6.813 4.347 9.161 2 11.987 2c2.922 0 5.173 2.346 5.173 5.219a5.142 5.142 0 0 1-5.157 5.123l-.017-.001zm0-7.324c-1.196 0-2.106 1.005-2.106 2.203 0 1.196.91 2.106 2.107 2.106 1.245 0 2.107-.91 2.107-2.106.001-1.199-.862-2.203-2.108-2.203zm2.06 11.586 2.923 2.825c.575.621.575 1.531 0 2.106-.622.621-1.581.621-2.06 0l-2.922-2.873-2.826 2.873c-.287.287-.671.43-1.103.43-.335 0-.718-.144-1.054-.43-.575-.575-.575-1.485 0-2.107l2.97-2.825a13.49 13.49 0 0 1-3.063-1.339c-.719-.383-.862-1.34-.479-2.059.479-.718 1.341-.909 2.108-.43a6.62 6.62 0 0 0 6.897 0c.767-.479 1.676-.288 2.107.43.432.719.239 1.675-.432 2.059-.909.575-1.963 1.006-3.065 1.341l-.001-.001z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8028680e017b4392(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.71 6.366C7.604 7.67 6.888 9.602 6.838 11.765v.471c.05 2.165.766 4.094 1.872 5.397 1.434 1.865 3.564 3.046 5.948 3.046a7.218 7.218 0 0 0 4.006-1.225 9.943 9.943 0 0 1-7.139 2.533A9.995 9.995 0 0 1 2 12C2 6.477 6.478 2 12 2h.038a9.971 9.971 0 0 1 6.627 2.545c-1.173-.773-2.543-1.225-4.009-1.225-2.382 0-4.514 1.184-5.95 3.046h.004zM22 12a9.971 9.971 0 0 1-3.335 7.455c-2.564 1.25-4.954.375-5.747-.172 2.52-.553 4.422-3.6 4.422-7.283 0-3.686-1.901-6.73-4.422-7.283.792-.545 3.183-1.42 5.747-.172A9.971 9.971 0 0 1 22 12z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e99f27497efd98a4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.508",
                    "cy": "9.831",
                    "r": "6.496"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.996 3.335H6.17v17.33H2.996z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$ad089dcd3166f551(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.554 9.488c.121.563.106 1.246-.04 2.051-.582 2.978-2.477 4.466-5.683 4.466h-.442a.666.666 0 0 0-.444.166.72.72 0 0 0-.239.427l-.041.189-.553 3.479-.021.151a.706.706 0 0 1-.247.426.666.666 0 0 1-.447.166H8.874a.395.395 0 0 1-.331-.15.457.457 0 0 1-.09-.363c.061-.373.148-.938.267-1.689.117-.75.206-1.314.267-1.689s.15-.938.272-1.685c.121-.748.212-1.31.271-1.685.033-.248.179-.371.433-.371h1.316c.893.013 1.682-.057 2.375-.211 1.172-.262 2.134-.744 2.886-1.449.685-.637 1.203-1.462 1.56-2.473.162-.47.277-.917.352-1.338.006-.041.014-.066.025-.074.008-.011.022-.014.035-.011a.378.378 0 0 1 .062.035c.524.398.854.941.98 1.632zm-1.728-2.836c0 .717-.154 1.508-.465 2.374-.537 1.562-1.547 2.618-3.037 3.168-.758.269-1.602.408-2.535.425 0 .006-.301.007-.904.007l-.903-.007c-.672 0-1.067.32-1.187.964-.013.053-.298 1.83-.855 5.329-.008.066-.048.102-.121.102H4.854a.473.473 0 0 1-.369-.165.469.469 0 0 1-.115-.39L6.702 3.664a.784.784 0 0 1 .276-.483.785.785 0 0 1 .519-.19h6.014c.228 0 .555.044.979.131.428.084.801.194 1.123.321.718.274 1.266.688 1.645 1.237.379.552.568 1.207.568 1.972z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e6669d9cfe0aeea7(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.102 21c1.406 0 6.985-6.329 6.985-10.571C19.087 6.368 15.915 3 12.102 3c-4.017 0-7.188 3.366-7.188 7.429C4.913 14.67 10.492 21 12.102 21zM10.979 5.885a4.696 4.696 0 0 1 1.143-.139c2.25 0 4.186 1.913 4.186 4.398 0 2.238-1.936 4.151-4.196 4.151-2.509 0-4.444-1.913-4.444-4.151 0-1.047.338-1.98.922-2.723v.022c0 .934.755 1.676 1.688 1.676.933.002 1.722-.764 1.722-1.697a1.68 1.68 0 0 0-1.02-1.54l-.001.003z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6ccf0aa9f80e5aca(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.15 16.78h1.57a.14.14 0 0 0 .14-.12l.35-1.82h1.22a4.88 4.88 0 0 0 1.51-.2A2.79 2.79 0 0 0 8 14a3.18 3.18 0 0 0 .67-.85 3.43 3.43 0 0 0 .36-1 2.43 2.43 0 0 0-.41-2.16 2.64 2.64 0 0 0-2.09-.78h-3a.16.16 0 0 0-.15.13L2 16.6a.19.19 0 0 0 0 .13.17.17 0 0 0 .15.05zM5 10.62h1a1.45 1.45 0 0 1 1.08.29c.17.18.2.52.11 1a1.81 1.81 0 0 1-.57 1.12 2.17 2.17 0 0 1-1.33.33h-.8zm9.8-.95a2.7 2.7 0 0 0-1.88-.51h-1.19l.33-1.76a.15.15 0 0 0 0-.13.16.16 0 0 0-.11 0h-1.57a.14.14 0 0 0-.14.12l-1.38 7.27a.13.13 0 0 0 0 .12.13.13 0 0 0 .11.06h1.54a.14.14 0 0 0 .14-.13l.77-4.07h1.11c.45 0 .61.1.66.16a.81.81 0 0 1 0 .62l-.61 3.24a.13.13 0 0 0 0 .12.14.14 0 0 0 .11.06h1.56a.16.16 0 0 0 .15-.13l.64-3.4a1.7 1.7 0 0 0-.24-1.64zm4.52-.51h-3.13a.14.14 0 0 0-.15.13l-1.46 7.31a.16.16 0 0 0 0 .13.14.14 0 0 0 .11.05h1.63a.14.14 0 0 0 .15-.12l.37-1.82h1.27a5.28 5.28 0 0 0 1.56-.2 3 3 0 0 0 1.18-.64 3.31 3.31 0 0 0 .7-.85 3.45 3.45 0 0 0 .37-1 2.38 2.38 0 0 0-.42-2.16 2.81 2.81 0 0 0-2.18-.83zm.62 2.77a1.83 1.83 0 0 1-.6 1.12 2.28 2.28 0 0 1-1.37.33h-.8l.54-2.76h1a1.6 1.6 0 0 1 1.13.29c.16.18.16.52.1 1.02z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$664ec432f5fcc911(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.077 9.457c0-.778.136-1.513.404-2.199a5.63 5.63 0 0 1 1.121-1.802 7.614 7.614 0 0 1 1.644-1.329 7.513 7.513 0 0 1 2.002-.844 8.57 8.57 0 0 1 2.185-.281c1.139 0 2.199.241 3.182.721a6.021 6.021 0 0 1 2.391 2.094c.614.915.919 1.95.919 3.104 0 .692-.068 1.369-.207 2.031a8.28 8.28 0 0 1-.646 1.913 6.605 6.605 0 0 1-1.082 1.617 4.723 4.723 0 0 1-1.568 1.114 4.962 4.962 0 0 1-2.045.417c-.489 0-.977-.115-1.459-.346-.482-.23-.828-.546-1.036-.951-.073.281-.173.687-.306 1.218-.128.53-.214.872-.252 1.027-.04.154-.114.411-.222.767a5.183 5.183 0 0 1-.281.769l-.344.674a7.98 7.98 0 0 1-.498.838c-.181.262-.405.575-.672.935l-.149.053-.099-.108c-.107-1.133-.162-1.811-.162-2.035 0-.663.079-1.407.235-2.233.153-.825.395-1.862.72-3.109.325-1.246.511-1.979.561-2.196-.229-.467-.345-1.077-.345-1.827 0-.599.187-1.16.562-1.688.376-.526.851-.789 1.427-.789.441 0 .783.146 1.028.439.246.292.366.66.366 1.109 0 .476-.158 1.165-.476 2.066-.318.902-.476 1.575-.476 2.022 0 .453.162.832.486 1.129a1.68 1.68 0 0 0 1.179.449c.396 0 .763-.09 1.104-.271a2.46 2.46 0 0 0 .849-.733 6.123 6.123 0 0 0 1.017-2.225c.096-.422.17-.823.216-1.2.049-.379.07-.737.07-1.077 0-1.247-.396-2.219-1.183-2.915-.791-.696-1.821-1.042-3.088-1.042-1.441 0-2.646.466-3.611 1.401-.966.932-1.452 2.117-1.452 3.554 0 .317.048.623.139.919.089.295.186.53.291.704.104.171.202.338.291.492.09.154.137.264.137.33 0 .202-.053.465-.16.79-.111.325-.242.487-.4.487-.015 0-.077-.011-.185-.034a2.21 2.21 0 0 1-.979-.605 3.17 3.17 0 0 1-.659-1.022 6.986 6.986 0 0 1-.352-1.169 4.884 4.884 0 0 1-.132-1.153z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cd97fb230954a6bf(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.472 2 2 6.473 2 11.99c0 4.232 2.633 7.85 6.35 9.306-.088-.79-.166-2.006.034-2.868.182-.78 1.172-4.966 1.172-4.966s-.299-.599-.299-1.484c0-1.388.805-2.425 1.808-2.425.853 0 1.264.64 1.264 1.407 0 .858-.546 2.139-.827 3.327-.235.994.499 1.805 1.479 1.805 1.775 0 3.141-1.872 3.141-4.575 0-2.392-1.719-4.064-4.173-4.064-2.843 0-4.512 2.132-4.512 4.335 0 .858.331 1.779.744 2.28a.3.3 0 0 1 .069.286c-.076.315-.245.994-.277 1.133-.044.183-.145.222-.335.134-1.247-.581-2.027-2.405-2.027-3.871 0-3.151 2.289-6.045 6.601-6.045 3.466 0 6.159 2.469 6.159 5.77 0 3.444-2.171 6.213-5.184 6.213-1.013 0-1.964-.525-2.29-1.146l-.623 2.374c-.225.868-.834 1.956-1.241 2.62a10 10 0 0 0 2.958.445c5.517 0 9.99-4.473 9.99-9.99S17.507 2 11.99 2"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b0197d96248edba1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.954 11.616 2.957-2.957L6.36 3.291c-.633-.342-1.226-.39-1.746-.016l8.34 8.341zm3.461 3.462 3.074-1.729c.6-.336.929-.812.929-1.34 0-.527-.329-1.004-.928-1.34l-2.783-1.563-3.133 3.132 2.841 2.84zM4.1 4.002c-.064.197-.1.417-.1.658v14.705c0 .381.084.709.236.97l8.097-8.098L4.1 4.002zm8.854 8.855L4.902 20.91c.154.059.32.09.495.09.312 0 .637-.092.968-.276l9.255-5.197-2.666-2.67z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9fa7afc89966da3d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.327 3.983H4.746c-.947 0-1.736.726-1.736 1.673v5.396c0 4.892 4.04 8.964 9.026 8.964 4.955 0 8.964-4.072 8.964-8.964V5.656c0-.947-.758-1.673-1.673-1.673zm-2.178 6.691-4.293 4.04c-.221.253-.567.348-.82.348-.315 0-.631-.095-.884-.348l-4.229-4.04c-.441-.473-.504-1.262 0-1.768.475-.441 1.263-.504 1.736 0l3.377 3.251 3.44-3.251c.441-.504 1.23-.441 1.673 0 .442.506.442 1.295 0 1.768z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a10ba41d340c3407(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.74 12.89v-.11c.06-.15.12-.29.19-.43a5.15 5.15 0 0 0 .26-3.74.86.86 0 0 0-.66-.74 3.12 3.12 0 0 0-2.08.61v.18a11.34 11.34 0 0 1-.06 2.41 2.37 2.37 0 0 0 .62 2 2 2 0 0 0 1.43.63 8.05 8.05 0 0 1 .3-.81zM10 8.58a.36.36 0 0 1-.09-.23.19.19 0 0 1 .09-.12.74.74 0 0 1 .48-.07c.25 0 .5.16.48.34a.51.51 0 0 1-.49.33h-.06a.63.63 0 0 1-.41-.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 11a12.58 12.58 0 0 0 .06-2.3v-.28a7 7 0 0 1 1.54-4.55c-1-.32-3.4-1-4.87.1-.9.64-1.32 1.84-1.23 3.55a24.85 24.85 0 0 0 1 4.4c.68 2.22 1.45 3.62 2.11 3.85.1 0 .41.13.86-.41.64-.76 1.23-1.41 1.5-1.7l-.19-.19A2.89 2.89 0 0 1 7.88 11zm3.5 3.4c-.16-.06-.24-.1-.42.11a2.52 2.52 0 0 0-.29.35c-.35.43-.5.58-1.51.79a2 2 0 0 0-.4.11 1 1 0 0 0 .37.16 2.21 2.21 0 0 0 2.5-.8.41.41 0 0 0 0-.35.59.59 0 0 0-.25-.37zm6.29-5.82a5.29 5.29 0 0 0 .08-.79c-.66-.08-1.42-.07-1.72.36-.58.83.56 2.88 1 3.75a4.34 4.34 0 0 1 .26.48 1.79 1.79 0 0 0 .15.31 3.72 3.72 0 0 0 .16-2.13 7.51 7.51 0 0 1-.07-1.05 6 6 0 0 1 .14-.93zm-.56-.16a.6.6 0 0 1-.32.17h-.06a.47.47 0 0 1-.44-.3c0-.14.2-.24.44-.28s.48 0 .5.15a.38.38 0 0 1-.12.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.88a6.06 6.06 0 0 1 1.37 2.57.71.71 0 0 1 0 .15 5.67 5.67 0 0 1-.09 1.06 7.11 7.11 0 0 0-.09.86 6.61 6.61 0 0 0 .07 1 4 4 0 0 1-.36 2.71l.07.08c2.22-3.49 3-7.54 2.29-8.43a4.77 4.77 0 0 0-3.81-1.8 7.34 7.34 0 0 0-1.63.16A6.17 6.17 0 0 1 17 4.88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.65 14c-.07-.2-.37-.85-1.47-.62a6.28 6.28 0 0 1-1 .13 19.74 19.74 0 0 0 2.06-4.88c.37-1.45.66-3.39-.11-4.38A5.91 5.91 0 0 0 16.37 2a8.44 8.44 0 0 0-2.46.35 9.38 9.38 0 0 0-1.45-.14 4.8 4.8 0 0 0-2.46.62 12.22 12.22 0 0 0-1.77-.44A5.44 5.44 0 0 0 4 3.05c-1.24.87-1.81 2.39-1.71 4.52a26.28 26.28 0 0 0 1 4.67A15.76 15.76 0 0 0 4.4 15a3.39 3.39 0 0 0 1.75 1.83 1.71 1.71 0 0 0 1.69-.37 2 2 0 0 0 1 .59 3.65 3.65 0 0 0 2.35-.14v.81a8.46 8.46 0 0 0 .31 2.36 1 1 0 0 1 0 .13 3 3 0 0 0 .71 1.24 2.08 2.08 0 0 0 1.49.56 3 3 0 0 0 .7-.08 3.27 3.27 0 0 0 2.21-1.27 7.34 7.34 0 0 0 .91-4v-.26h.17a5.24 5.24 0 0 0 2.4-.4c.45-.23 1.91-1 1.56-2zm-1.81 1.47a4.7 4.7 0 0 1-1.8.34 2.62 2.62 0 0 1-.79-.1c-.1.94-.32 2.69-.45 3.42a2.47 2.47 0 0 1-2.25 2.3 3.23 3.23 0 0 1-.66.07A2 2 0 0 1 12 20a16.77 16.77 0 0 1-.28-4.06 2.56 2.56 0 0 1-1.78.66 3.94 3.94 0 0 1-.94-.13c-.09 0-.87-.23-.86-.73s.66-.59.9-.64c.86-.18.92-.25 1.19-.59a2.79 2.79 0 0 1 .19-.24 2.56 2.56 0 0 1-1.11-.3c-.23.25-.86.93-1.54 1.74a1.43 1.43 0 0 1-1.11.63 1.23 1.23 0 0 1-.35 0C5.43 16 4.6 14.55 3.84 12a25.21 25.21 0 0 1-1-4.53c-.1-1.92.4-3.28 1.47-4 1.92-1.36 5-.31 5.7-.06a4 4 0 0 1 2.41-.66 5.58 5.58 0 0 1 1.4.18 7.51 7.51 0 0 1 2.5-.4 5.35 5.35 0 0 1 4.32 2c.69.88.23 3 0 3.89a18.84 18.84 0 0 1-2.41 5.41c.16.11.65.31 2 0 .46-.1.73 0 .82.25.22.55-.7 1.13-1.21 1.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.43 13.59a4 4 0 0 1-.62-1c0-.07-.12-.24-.23-.43-.58-1-1.79-3.22-1-4.34a2.16 2.16 0 0 1 2.12-.61 6.28 6.28 0 0 0-1.13-1.94 5.41 5.41 0 0 0-4.13-2 3.34 3.34 0 0 0-2.55.95A5.82 5.82 0 0 0 8.51 7.8l.15-.08A3.7 3.7 0 0 1 10 7.3a1.45 1.45 0 0 1 1.76 1.19 5.73 5.73 0 0 1-.29 4.09 3.29 3.29 0 0 0-.17.39v.11c-.1.27-.19.52-.25.73a.94.94 0 0 1 .57.07 1.16 1.16 0 0 1 .62.74v.16a.28.28 0 0 1 0 .09 22.22 22.22 0 0 0 .22 4.9 1.5 1.5 0 0 0 2 1.09A1.92 1.92 0 0 0 16.25 19c.15-.88.45-3.35.49-3.88 0-1.06.52-1.27.84-1.36z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 14.33-.08-.06h-.12c-.26.07-.5.14-.47.8a1.9 1.9 0 0 0 .93.12 4.29 4.29 0 0 0 1.38-.29 3 3 0 0 0 .79-.52 3.47 3.47 0 0 1-2.43-.05z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$12b0b3b46556958d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.337 9h-2.838v3h2.838a1.501 1.501 0 1 0 0-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1.337 12h-2.838v3H8.501V7h4.837a3.498 3.498 0 0 1 3.499 3.499 3.499 3.499 0 0 1-3.5 3.501z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$9f9551dffcae9923(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.585 11.692h4.328s2.432.039 2.432-2.35V5.391S16.714 3 11.936 3C7.362 3 7.647 4.983 7.647 4.983l.006 2.055h4.363v.617H5.92s-2.927-.332-2.927 4.282 2.555 4.45 2.555 4.45h1.524v-2.141s-.083-2.554 2.513-2.554zm-.056-5.74a.784.784 0 1 1 0-1.57.784.784 0 1 1 0 1.57z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.452 7.532h-1.524v2.141s.083 2.554-2.513 2.554h-4.328s-2.432-.04-2.432 2.35v3.951s-.369 2.391 4.409 2.391c4.573 0 4.288-1.983 4.288-1.983l-.006-2.054h-4.363v-.617h6.097s2.927.332 2.927-4.282-2.555-4.451-2.555-4.451zm-3.981 10.436a.784.784 0 1 1 0 1.57.784.784 0 1 1 0-1.57z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$13dbdcbce594d15(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.555 17.025c-.624-1.227-1.354-2.465-2.781-2.465-.271 0-.546.046-.795.157l-.484-.967c.59-.509 1.544-.911 2.77-.911 1.908 0 2.889.922 3.667 2.094.459-1.001.678-2.354.678-4.03 0-4.188-1.308-6.336-4.366-6.336-3.014 0-4.318 2.148-4.318 6.336 0 4.164 1.305 6.291 4.318 6.291.478 0 .913-.051 1.311-.169zm.747 1.461a7.977 7.977 0 0 1-2.059.274c-4.014 0-7.941-3.202-7.941-7.858C3.303 6.203 7.229 3 11.243 3c4.081 0 7.972 3.179 7.972 7.903 0 2.628-1.226 4.763-3.007 6.143.572.861 1.157 1.436 1.988 1.436.899 0 1.261-.687 1.328-1.236h1.167c.07.73-.301 3.754-3.574 3.754-1.989 0-3.035-1.146-3.822-2.496l.007-.018z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d0ee981d8f88f12d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11.245",
                    "r": "1.785"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.002 14.794-.395-.101c-2.934-.741-4.617-2.001-4.617-3.452 0-1.452 1.684-2.711 4.617-3.452l.395-.1.111.391a19.507 19.507 0 0 0 1.136 2.983l.085.178-.085.178c-.46.963-.841 1.961-1.136 2.985l-.111.39zm-.577-6.095c-2.229.628-3.598 1.586-3.598 2.542 0 .954 1.368 1.913 3.598 2.54.273-.868.603-1.717.985-2.54a20.356 20.356 0 0 1-.985-2.542zm10.572 6.095-.11-.392a19.628 19.628 0 0 0-1.137-2.984l-.085-.177.085-.179c.46-.961.839-1.96 1.137-2.984l.11-.39.395.1c2.935.741 4.617 2 4.617 3.453 0 1.452-1.683 2.711-4.617 3.452l-.395.101zm-.41-3.553c.4.866.733 1.718.987 2.54 2.23-.627 3.599-1.586 3.599-2.54 0-.956-1.368-1.913-3.599-2.542a20.683 20.683 0 0 1-.987 2.542z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.419 8.695-.11-.39c-.826-2.908-.576-4.991.687-5.717 1.235-.715 3.222.13 5.303 2.265l.284.292-.284.291a19.718 19.718 0 0 0-2.02 2.474l-.113.162-.196.016a19.646 19.646 0 0 0-3.157.509l-.394.098zm1.582-5.529c-.224 0-.422.049-.589.145-.828.477-.974 2.138-.404 4.38.891-.197 1.79-.338 2.696-.417a21.058 21.058 0 0 1 1.713-2.123c-1.303-1.267-2.533-1.985-3.416-1.985zm7.997 16.984c-1.188 0-2.714-.896-4.298-2.522l-.283-.291.283-.29a19.827 19.827 0 0 0 2.021-2.477l.112-.16.194-.019a19.473 19.473 0 0 0 3.158-.507l.395-.1.111.391c.822 2.906.573 4.992-.688 5.718a1.978 1.978 0 0 1-1.005.257zm-3.415-2.82c1.302 1.267 2.533 1.986 3.415 1.986.225 0 .423-.05.589-.145.829-.478.976-2.142.404-4.384-.89.198-1.79.34-2.698.419a20.526 20.526 0 0 1-1.71 2.124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.58 8.695-.395-.099a19.477 19.477 0 0 0-3.158-.509l-.194-.017-.112-.162A19.551 19.551 0 0 0 11.7 5.434l-.283-.291.283-.29c2.08-2.134 4.066-2.979 5.303-2.265 1.262.727 1.513 2.81.688 5.717l-.111.39zm-3.287-1.421c.954.085 1.858.228 2.698.417.571-2.242.425-3.903-.404-4.381-.824-.477-2.375.253-4.004 1.841.616.67 1.188 1.378 1.71 2.123zM8.001 20.15a1.983 1.983 0 0 1-1.005-.257c-1.263-.726-1.513-2.811-.688-5.718l.108-.391.395.1c.964.243 2.026.414 3.158.507l.194.019.113.16c.604.878 1.28 1.707 2.02 2.477l.284.29-.284.291c-1.583 1.627-3.109 2.522-4.295 2.522zm-.993-5.362c-.57 2.242-.424 3.906.404 4.384.825.47 2.371-.255 4.005-1.842a21.17 21.17 0 0 1-1.713-2.123 20.692 20.692 0 0 1-2.696-.419z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15.313c-.687 0-1.392-.029-2.1-.088l-.196-.017-.113-.162a25.697 25.697 0 0 1-1.126-1.769 26.028 26.028 0 0 1-.971-1.859l-.084-.177.084-.179c.299-.632.622-1.252.971-1.858.347-.596.726-1.192 1.126-1.77l.113-.16.196-.018a25.148 25.148 0 0 1 4.198 0l.194.019.113.16a25.136 25.136 0 0 1 2.1 3.628l.083.179-.083.177a24.742 24.742 0 0 1-2.1 3.628l-.113.162-.194.017c-.706.057-1.412.087-2.098.087zm-1.834-.904c1.235.093 2.433.093 3.667 0a24.469 24.469 0 0 0 1.832-3.168 23.916 23.916 0 0 0-1.832-3.168 23.877 23.877 0 0 0-3.667 0 23.743 23.743 0 0 0-1.832 3.168 24.82 24.82 0 0 0 1.832 3.168z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$18a50b1efc8f43dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.002 2.005 12 2.004c-5.52 0-9.996 4.475-9.996 9.995 0 5.521 4.477 9.998 9.996 9.998 5.521 0 9.996-4.475 9.996-9.997 0-5.52-4.475-9.995-9.994-9.995zm.162 13.53a.267.267 0 0 1-.174.066v.001H6.455a.268.268 0 0 1-.266-.268V8.646c0-.148.119-.268.266-.268h2.589c1.612 0 2.576.87 2.576 2.327 0 .969-.486 1.729-1.272 2.039l1.842 2.413a.269.269 0 0 1-.026.378zm3.695.068h-2.665a.268.268 0 0 1-.266-.269V8.646c0-.148.119-.267.266-.267h2.472c1.853 0 2.242 1.091 2.242 2.007 0 .529-.141.949-.421 1.258.681.28 1.047.913 1.047 1.827 0 1.335-1.001 2.132-2.675 2.132z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$68489345e0ea8d1d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.67",
                    "cy": "13",
                    "r": "1.001"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.09 15.391A3.28 3.28 0 0 1 12 16a3.271 3.271 0 0 1-2.081-.63.27.27 0 0 0-.379.38c.71.535 1.582.809 2.471.77a3.811 3.811 0 0 0 2.469-.77v.04a.284.284 0 0 0 .006-.396.28.28 0 0 0-.396-.003zm.209-3.351a1 1 0 0 0 0 2l-.008.039c.016.002.033 0 .051 0a1 1 0 0 0 .958-1.038 1 1 0 0 0-1.001-1.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.479 2 2 6.477 2 12c0 5.521 4.479 10 10 10s10-4.479 10-10c0-5.523-4.479-10-10-10zm5.859 11.33c.012.146.012.293 0 .439 0 2.24-2.609 4.062-5.83 4.062s-5.83-1.82-5.83-4.062a2.681 2.681 0 0 1 0-.439 1.46 1.46 0 0 1-.455-2.327 1.458 1.458 0 0 1 2.063-.063 7.145 7.145 0 0 1 3.899-1.23l.743-3.47v-.004A.313.313 0 0 1 12.82 6l2.449.49a1.001 1.001 0 1 1-.131.61L13 6.65l-.649 3.12a7.123 7.123 0 0 1 3.85 1.23 1.46 1.46 0 0 1 2.469 1c.01.563-.307 1.08-.811 1.33z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5753ada9c86be70f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.661 15.549a1.315 1.315 0 0 0 1.185-1.386 1.363 1.363 0 0 0-1.35-1.302h-.048a1.352 1.352 0 0 0-1.303 1.397c.024.379.179.687.391.911-.827 1.609-2.07 2.794-3.954 3.788-1.266.663-2.604.912-3.905.734-1.089-.153-1.94-.64-2.463-1.421-.78-1.185-.852-2.462-.201-3.74a5.597 5.597 0 0 1 1.658-1.931 7.88 7.88 0 0 1-.331-1.218c-3.506 2.51-3.148 5.942-2.084 7.564.794 1.184 2.415 1.941 4.19 1.941.474 0 .972-.035 1.457-.154 3.077-.592 5.409-2.438 6.747-5.16l.011-.023z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.887 12.589c-1.834-2.154-4.533-3.337-7.611-3.337h-.403c-.2-.438-.661-.711-1.183-.711h-.036c-.744 0-1.325.64-1.301 1.385.023.71.627 1.302 1.35 1.302h.059a1.332 1.332 0 0 0 1.183-.828h.439c1.824 0 3.551.532 5.126 1.574 1.206.792 2.072 1.834 2.557 3.077.425 1.019.402 2.013-.035 2.843-.675 1.302-1.812 1.988-3.314 1.988-.947 0-1.871-.296-2.345-.509-.283.235-.758.626-1.102.863 1.042.473 2.096.746 3.113.746 2.309 0 4.023-1.302 4.676-2.557.709-1.422.651-3.813-1.161-5.859l-.012.023z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.647 15.975c.023.71.626 1.302 1.35 1.302h.048a1.334 1.334 0 0 0 1.302-1.397c0-.71-.616-1.301-1.338-1.301h-.048c-.048 0-.118 0-.178.022-.982-1.657-1.397-3.434-1.242-5.349.094-1.445.567-2.7 1.42-3.742.71-.888 2.048-1.326 2.96-1.35 2.556-.048 3.622 3.138 3.704 4.404l1.184.354C16.536 5.036 14.122 3 11.813 3 9.647 3 7.647 4.574 6.842 6.884c-1.102 3.077-.379 6.036.971 8.404-.118.154-.189.426-.166.687z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f83317ac28474992(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c5.522 0 10 4.478 10 10s-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2zm-1.987 13.332c.146.537.13 1.039-.021 1.493l-.054.15a2.803 2.803 0 0 1-.527.821c-.582.633-1.394.872-1.742.671-.375-.219-.188-1.112.487-1.825.726-.765 1.766-1.258 1.766-1.258v-.002l.091-.05zm8.258-9.051c-.452-1.777-3.397-2.362-6.185-1.371-1.656.589-3.453 1.515-4.743 2.723-1.536 1.434-1.78 2.684-1.68 3.206.355 1.843 2.881 3.048 3.92 3.942v.005c-.307.149-2.548 1.274-3.072 2.438-.563 1.225.088 2.101.513 2.212 1.313.363 2.662-.3 3.388-1.374.699-1.051.638-2.4.337-3.063.413-.112.899-.162 1.524-.086 1.751.199 2.101 1.3 2.024 1.75-.074.449-.436.711-.561.786-.126.076-.163.101-.151.151.013.074.076.074.175.063.138-.025.914-.375.951-1.227.037-1.074-.988-2.273-2.813-2.25-.75.014-1.226.076-1.563.214a.295.295 0 0 0-.088-.088c-1.125-1.213-3.213-2.063-3.125-3.675.025-.588.237-2.137 4-4.012 3.088-1.538 5.551-1.112 5.977-.175.61 1.336-1.314 3.825-4.526 4.187-1.225.138-1.862-.337-2.026-.513-.174-.188-.198-.2-.261-.161-.101.05-.038.212 0 .313.1.249.487.688 1.163.912.587.188 2.024.299 3.75-.375 1.937-.749 3.449-2.838 3.012-4.588l.06.056z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$36897e57f6497a82(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.49 20.937 5.381-1.166S17.93 6.633 17.914 6.546c-.016-.086-.086-.144-.158-.144s-1.439-.101-1.439-.101-.949-.949-1.064-1.05c-.027-.029-.057-.043-.086-.058l-.677 15.744zm.446-15.772c-.016 0-.043.014-.057.014-.016 0-.217.059-.533.158-.318-.919-.879-1.768-1.871-1.768h-.086c-.289-.361-.633-.519-.936-.519-2.316 0-3.426 2.892-3.77 4.359-.892.275-1.538.476-1.613.505-.504.158-.517.172-.574.648-.057.344-1.367 10.489-1.367 10.489l10.117 1.899.69-15.785zm-2.635.704v.102c-.559.173-1.178.36-1.783.547.346-1.323.992-1.972 1.553-2.217.146.375.23.878.23 1.568zm-.92-2.2c.1 0 .201.028.303.102-.732.344-1.539 1.222-1.871 2.978a59.11 59.11 0 0 1-1.411.432c.389-1.339 1.325-3.512 2.979-3.512zm.402 7.812s-.604-.315-1.322-.315c-1.08 0-1.123.676-1.123.849 0 .921 2.418 1.28 2.418 3.453 0 1.712-1.08 2.806-2.547 2.806-1.756 0-2.648-1.094-2.648-1.094l.475-1.554s.922.792 1.697.792a.693.693 0 0 0 .721-.69c0-1.209-1.986-1.268-1.986-3.252 0-1.669 1.195-3.295 3.627-3.295.936 0 1.395.272 1.395.272l-.707 2.028zm.922-7.281c.518.06.85.648 1.064 1.311-.258.087-.547.173-.863.273v-.187c0-.561-.072-1.022-.201-1.397z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1ba4490332e26c8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.42 9.87 12 20.78l5.58-10.91H6.42zM5.9 4.01 2 9.24h3.62l.28-5.23zm6.1-.59L6.63 9.24h10.74L12 3.42zM2.04 9.87l9.09 10.58L5.72 9.87H2.04zM11.53 3h-.15l-4.84.51a.09.09 0 0 1 0 .05l-.27 5.15zm1.34 17.45 9.09-10.58h-3.68l-5.41 10.58zm4.58-16.87a.09.09 0 0 1 0-.05l-4-.42-1-.11 5.26 5.71zm.65.43.28 5.23H22l-2.22-2.98-1.68-2.25z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$95d5beec51840c31(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.857 17.417c-2.947 0-4.294-1.524-4.294-2.641 0-.266.108-.521.298-.705a.946.946 0 0 1 .71-.264c1.261 0 .931 1.92 3.286 1.92 1.203 0 1.91-.736 1.91-1.425 0-.415-.234-.889-1.028-1.079l-2.629-.673c-2.111-.545-2.479-1.737-2.479-2.842 0-2.293 2.068-3.124 4.036-3.124 1.814 0 3.97 1.016 3.97 2.391 0 .592-.488.91-1.055.91-1.078 0-.897-1.536-3.063-1.536-1.077 0-1.645.513-1.645 1.23s.839.96 1.574 1.123l1.941.445c2.126.486 2.691 1.751 2.691 2.963 0 1.865-1.423 3.305-4.226 3.305m8.139-3.942c.086-.49.128-.986.128-1.482a8.472 8.472 0 0 0-2.952-6.474 8.211 8.211 0 0 0-6.788-1.856A4.818 4.818 0 0 0 7.935 3a4.954 4.954 0 0 0-4.27 2.519 5.103 5.103 0 0 0-.015 5.011 8.51 8.51 0 0 0 2.282 7.453 8.23 8.23 0 0 0 7.333 2.355 4.823 4.823 0 0 0 2.443.662 4.954 4.954 0 0 0 4.269-2.518 5.095 5.095 0 0 0 .016-5.009"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a24687d6bc034038(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.935 12.646a1.617 1.617 0 0 0-2.022-1.034l-1.632.532c-.355-1.099-.735-2.268-1.092-3.365l.006-.002-.004-.008 1.613-.523a1.62 1.62 0 0 0 1.035-2.023 1.62 1.62 0 0 0-2.025-1.034l-1.621.527-.519-1.604a1.619 1.619 0 0 0-2.024-1.034 1.618 1.618 0 0 0-1.033 2.024l.522 1.609-3.368 1.092-.524-1.611a1.618 1.618 0 0 0-2.022-1.034 1.617 1.617 0 0 0-1.034 2.023l.524 1.616-1.662.541a1.602 1.602 0 0 0-.988 1.95c.25.856 1.152 1.373 1.979 1.092.006 0 .658-.209 1.665-.536l1.099 3.386h-.002v.002l-1.67.545a1.599 1.599 0 0 0-.987 1.949c.25.857 1.15 1.374 1.979 1.093.007 0 .659-.211 1.665-.538l.003.005a.024.024 0 0 0 .008-.002l.539 1.657a1.6 1.6 0 0 0 1.949.989c.857-.25 1.373-1.151 1.094-1.979 0-.006-.209-.654-.533-1.654l-.003-.009c1.104-.358 2.276-.739 3.376-1.098l.543 1.668a1.602 1.602 0 0 0 1.949.989c.856-.251 1.374-1.152 1.092-1.979 0-.007-.209-.659-.535-1.663l.019-.006-.003-.007 1.609-.522a1.62 1.62 0 0 0 1.035-2.024zM10.86 14.238l-1.097-3.377a.02.02 0 0 0 .005-.001v-.006c1.098-.356 2.268-.735 3.363-1.092l1.098 3.377-3.369 1.099z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1bfde123a9b504b8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.194 14.644c0 1.16-.943 2.107-2.103 2.107a2.11 2.11 0 0 1-2.104-2.107 2.11 2.11 0 0 1 2.104-2.106h2.103v2.106zm1.061 0c0-1.16.944-2.106 2.104-2.106a2.11 2.11 0 0 1 2.103 2.106v5.274a2.11 2.11 0 0 1-2.103 2.106 2.108 2.108 0 0 1-2.104-2.106v-5.274zm2.104-8.455c-1.16 0-2.104-.948-2.104-2.107s.944-2.106 2.104-2.106a2.11 2.11 0 0 1 2.103 2.106v2.107H9.359zm0 1.06a2.11 2.11 0 0 1 2.103 2.107 2.11 2.11 0 0 1-2.103 2.106H4.092a2.11 2.11 0 0 1-2.104-2.106 2.11 2.11 0 0 1 2.104-2.107h5.267zm8.447 2.107c0-1.16.943-2.107 2.103-2.107a2.11 2.11 0 0 1 2.104 2.107 2.11 2.11 0 0 1-2.104 2.106h-2.103V9.356zm-1.061 0c0 1.16-.944 2.106-2.104 2.106a2.11 2.11 0 0 1-2.103-2.106V4.082a2.11 2.11 0 0 1 2.103-2.106c1.16 0 2.104.946 2.104 2.106v5.274zm-2.104 8.455c1.16 0 2.104.948 2.104 2.107s-.944 2.106-2.104 2.106a2.11 2.11 0 0 1-2.103-2.106v-2.107h2.103zm0-1.06a2.11 2.11 0 0 1-2.103-2.107 2.11 2.11 0 0 1 2.103-2.106h5.268a2.11 2.11 0 0 1 2.104 2.106 2.11 2.11 0 0 1-2.104 2.107h-5.268z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$426ffd451bf4cb69(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.166 3c.796 0 3.495.223 4.769 3.073.426.959.324 2.589.24 3.898l-.002.047c-.011.146-.018.278-.024.41a.62.62 0 0 0 .322.072c.241-.013.53-.096.831-.241a.81.81 0 0 1 .373-.084c.146 0 .289.023.409.072.361.12.59.385.59.674.013.361-.313.675-.975.939-.071.023-.169.061-.276.096-.363.109-.917.289-1.073.651-.072.181-.049.421.098.697l.012.013c.048.109 1.228 2.795 3.854 3.229a.401.401 0 0 1 .337.409c0 .06-.013.119-.036.181-.193.457-1.023.795-2.53 1.021-.047.073-.096.302-.132.459-.022.144-.06.289-.107.444-.061.218-.217.325-.446.325h-.024a2.45 2.45 0 0 1-.433-.059 4.799 4.799 0 0 0-1.024-.108c-.24 0-.48.012-.732.06-.483.084-.904.373-1.386.71-.687.481-1.469 1.036-2.649 1.036-.048 0-.096-.012-.146-.012h-.119c-1.181 0-1.951-.543-2.637-1.036-.481-.338-.89-.626-1.373-.711a5.507 5.507 0 0 0-.745-.06c-.435 0-.771.072-1.023.12-.17.035-.314.059-.435.059a.45.45 0 0 1-.47-.337c-.048-.154-.071-.313-.107-.456-.038-.146-.085-.396-.133-.458-1.543-.179-2.373-.517-2.565-.986a.473.473 0 0 1-.044-.181.398.398 0 0 1 .337-.409c2.625-.434 3.805-3.119 3.854-3.232l.013-.023c.145-.277.18-.52.096-.699-.156-.349-.711-.529-1.07-.65a1.759 1.759 0 0 1-.279-.096c-.89-.35-1.011-.748-.962-1.024.072-.384.541-.637.939-.637.117 0 .217.023.308.06.337.155.635.241.888.241a.742.742 0 0 0 .373-.085l-.041-.458c-.08-1.307-.182-2.935.247-3.889 1.236-2.836 3.929-3.054 4.724-3.054L12.117 3h.049z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c1e8dad3115eb4ba(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.971 12.188c-.041 0-.078.038-.083.082l-.194 1.797.194 1.756c.005.049.042.082.083.082s.075-.033.084-.082l.211-1.756-.225-1.797c0-.046-.037-.082-.074-.082m-.75.691c-.051 0-.076.03-.088.079l-.138 1.109.138 1.092c0 .046.037.078.075.078.039 0 .073-.038.087-.087l.176-1.1-.176-1.112c0-.051-.037-.076-.075-.076m1.526-1.025c-.052 0-.1.039-.1.087l-.176 2.139.188 2.051c0 .049.037.1.099.1.052 0 .089-.051.102-.1l.211-2.064-.211-2.126c-.013-.049-.052-.1-.102-.1m.79-.075c-.063 0-.114.051-.126.113l-.161 2.201.177 2.123c.012.063.061.114.122.114.064 0 .113-.051.125-.124l.201-2.113-.201-2.187a.11.11 0 0 0-.111-.112l-.026-.015zm.962.301a.128.128 0 0 0-.133-.125.134.134 0 0 0-.137.125l-.182 2.026.169 2.138a.13.13 0 0 0 .132.131c.062 0 .123-.055.123-.132l.189-2.139-.189-2.036.028.012zm.674-1.426a.154.154 0 0 0-.148.15l-.176 3.3.156 2.139c0 .077.066.137.15.137.078 0 .145-.074.15-.15l.174-2.137-.173-3.313c-.007-.088-.074-.152-.15-.152m.8-.762a.178.178 0 0 0-.17.163l-.15 4.063.138 2.125c0 .1.075.174.163.174.086 0 .161-.074.174-.174l.162-2.125-.161-4.052c-.013-.1-.088-.175-.175-.175m.826-.372c-.102 0-.176.073-.188.173l-.139 4.4.139 2.102c.012.1.086.188.188.188a.193.193 0 0 0 .187-.188l.163-2.102-.164-4.4c0-.1-.087-.188-.188-.188m1.038.038a.196.196 0 0 0-.199-.199.205.205 0 0 0-.201.199l-.125 4.538.124 2.089c.015.111.101.199.214.199s.201-.088.201-.199l.136-2.089-.136-4.55-.014.012zm.625-.111c-.113 0-.213.1-.213.211l-.125 4.439.125 2.063c0 .125.1.213.213.213a.221.221 0 0 0 .214-.224l.125-2.064-.14-4.428c0-.122-.1-.225-.225-.225m.838.139a.236.236 0 0 0-.237.237l-.086 4.29.113 2.063c0 .124.1.231.236.231.125 0 .227-.1.237-.237l.101-2.038-.112-4.265c-.01-.137-.113-.238-.237-.238m.988-.786a.27.27 0 0 0-.139-.037c-.05 0-.1.013-.137.037a.25.25 0 0 0-.125.214v.05l-.086 5.044.096 2.043v.007c.006.05.024.112.06.15.05.051.12.086.196.086a.28.28 0 0 0 .175-.074.262.262 0 0 0 .076-.188l.013-.201.097-1.838-.113-5.075a.24.24 0 0 0-.111-.199l-.002-.019zm.837-.457a.155.155 0 0 0-.124-.052.283.283 0 0 0-.174.052.265.265 0 0 0-.1.201v.023l-.114 5.513.063 1.014.052.988a.274.274 0 0 0 .548-.012l.125-2.013-.125-5.536a.273.273 0 0 0-.138-.231m7.452 3.15c-.336 0-.663.072-.949.193a4.34 4.34 0 0 0-5.902-3.651c-.188.075-.227.151-.238.301v7.812a.31.31 0 0 0 .275.29h6.827a2.428 2.428 0 0 0 2.45-2.438 2.457 2.457 0 0 0-2.45-2.463"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$64739c22c97adae9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 2.019c-5.495 0-9.991 4.496-9.991 9.991 0 5.494 4.496 9.99 9.991 9.99 5.494 0 9.99-4.496 9.99-9.99 0-5.495-4.446-9.991-9.99-9.991zm4.595 14.436c-.199.299-.549.4-.85.201-2.349-1.45-5.296-1.75-8.793-.951-.348.102-.648-.148-.748-.449-.101-.35.149-.648.45-.749 3.795-.85 7.093-.499 9.69 1.1.35.149.4.548.251.848zm1.2-2.747c-.251.349-.7.499-1.051.249-2.697-1.646-6.792-2.148-9.939-1.148-.398.101-.85-.1-.949-.498-.101-.402.1-.852.499-.952 3.646-1.098 8.143-.548 11.239 1.351.3.149.45.648.201.998zm.099-2.799c-3.197-1.897-8.542-2.097-11.59-1.146a.938.938 0 0 1-1.148-.6.937.937 0 0 1 .599-1.151c3.547-1.049 9.392-.85 13.089 1.351.449.249.599.849.349 1.298-.25.35-.849.498-1.299.248z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$96ee438e63a5af2b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.205 16.392c-2.469 3.289-7.741 2.179-11.122 2.338 0 0-.599.034-1.201.133 0 0 .228-.097.519-.198 2.374-.821 3.496-.986 4.939-1.727 2.71-1.388 5.408-4.413 5.957-7.555-1.032 3.022-4.17 5.623-7.027 6.679-1.955.722-5.492 1.424-5.493 1.424a5.28 5.28 0 0 1-.143-.076c-2.405-1.17-2.475-6.38 1.894-8.059 1.916-.736 3.747-.332 5.818-.825 2.208-.525 4.766-2.18 5.805-4.344 1.165 3.458 2.565 8.866.054 12.21zm.042-13.28a9.212 9.212 0 0 1-1.065 1.89 9.982 9.982 0 0 0-7.167-3.031C6.492 1.971 2 6.463 2 11.985a9.983 9.983 0 0 0 3.205 7.334l.22.194a.856.856 0 1 1 .001.001l.149.132A9.96 9.96 0 0 0 12.015 22c5.278 0 9.613-4.108 9.984-9.292.274-2.539-.476-5.763-1.752-9.596"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$bf431a2720d71dc(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.886 9.264c-1.502-1.5-3.941-1.5-5.475 0l-6.13 6.131a.981.981 0 0 0 0 1.377.982.982 0 0 0 1.376 0l6.13-6.131a1.925 1.925 0 0 1 2.722 2.723l-6.037 6.035c.751.75 1.971.75 2.723 0l4.66-4.66c1.531-1.534 1.531-3.973.031-5.475zm-2.064 2.033a.982.982 0 0 0-1.376 0l-6.134 6.162c-.751.75-1.97.75-2.72 0-.376-.375-1.002-.375-1.377 0s-.375 1.002 0 1.375c1.502 1.502 3.942 1.502 5.475 0l6.131-6.129c.375-.406.375-1.033.001-1.408zm-2.035-6.129c-1.501-1.502-3.941-1.502-5.475 0l-6.131 6.129a.98.98 0 0 0 0 1.375.98.98 0 0 0 1.377 0l6.168-6.129a1.934 1.934 0 0 1 2.727 0 .982.982 0 0 0 1.376 0c.352-.406.352-1-.024-1.375h-.018zm-2.063 2.031a.978.978 0 0 0-1.376 0l-6.131 6.164a1.933 1.933 0 0 1-2.723 0 1.927 1.927 0 0 1 0-2.723l6.037-6.039a1.928 1.928 0 0 0-2.722 0L3.118 9.264c-1.501 1.502-1.501 3.941 0 5.475 1.501 1.502 3.94 1.502 5.475 0l6.129-6.131c.377-.408.377-1.033 0-1.408h.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cc15c4d0655eb1f9(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.24 19.399v-4.804h1.6V21H4.381v-6.405h1.598v4.804H17.24zM7.582 17.8h8.055v-1.604H7.582V17.8zm.195-3.64 7.859 1.641.34-1.552-7.861-1.642-.338 1.553zm1.018-3.794 7.281 3.398.678-1.463-7.281-3.399-.678 1.454v.01zm2.037-3.589 6.166 5.142 1.018-1.216-6.162-5.14-1.016 1.213-.006.001zm3.982-3.778-1.311.969 4.803 6.454 1.313-.971-4.807-6.452h.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d6615c3824ee4dc4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.21 17.32 7 16.8a2.13 2.13 0 1 0 1.17-2.93l1.28.53a1.58 1.58 0 0 1-1.22 2.92z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 0-10 9.34l5.38 2.21a2.31 2.31 0 0 1 .47-.24A2.62 2.62 0 0 1 9 13.1l2.44-3.56a3.8 3.8 0 1 1 3.8 3.8h-.08l-3.51 2.5a2.77 2.77 0 0 1-5.47.68l-3.77-1.6A10 10 0 1 0 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.79 9.5a2.53 2.53 0 1 0-2.53 2.5 2.54 2.54 0 0 0 2.53-2.5zm-4.42 0a1.9 1.9 0 1 1 1.9 1.91 1.9 1.9 0 0 1-1.9-1.92z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$d754551a209bfa24(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.479 9.883c-1.626-.604-2.512-1.067-2.512-1.803 0-.622.511-.977 1.423-.977 1.667 0 3.379.642 4.558 1.22l.666-4.111c-.935-.446-2.847-1.177-5.49-1.177-1.87 0-3.425.489-4.536 1.401-1.155.954-1.757 2.334-1.757 4 0 3.023 1.847 4.312 4.847 5.403 1.936.688 2.579 1.178 2.579 1.934 0 .732-.629 1.155-1.762 1.155-1.403 0-3.716-.689-5.231-1.578l-.674 4.157c1.304.732 3.705 1.488 6.197 1.488 1.976 0 3.624-.467 4.735-1.356 1.245-.977 1.89-2.422 1.89-4.289 0-3.091-1.889-4.38-4.935-5.468h.002z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$cc8ec133134f0ae8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 9.51a4.22 4.22 0 0 1-1.91-1.34A5.77 5.77 0 0 0 12 6a4.72 4.72 0 0 0-5 4 3.23 3.23 0 0 1 3.5-1.49 4.32 4.32 0 0 1 1.91 1.35A5.77 5.77 0 0 0 17 12a4.72 4.72 0 0 0 5-4 3.2 3.2 0 0 1-3.5 1.51zm-13 4.98a4.22 4.22 0 0 1 1.91 1.34A5.77 5.77 0 0 0 12 18a4.72 4.72 0 0 0 5-4 3.23 3.23 0 0 1-3.5 1.49 4.32 4.32 0 0 1-1.91-1.35A5.8 5.8 0 0 0 7 12a4.72 4.72 0 0 0-5 4 3.2 3.2 0 0 1 3.5-1.51z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$45f5bdd5c5f02b55(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.665 3.717-17.73 6.837c-1.21.486-1.203 1.161-.222 1.462l4.552 1.42 10.532-6.645c.498-.303.953-.14.579.192l-8.533 7.701h-.002l.002.001-.314 4.692c.46 0 .663-.211.921-.46l2.211-2.15 4.599 3.397c.848.467 1.457.227 1.668-.785l3.019-14.228c.309-1.239-.473-1.8-1.282-1.434z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a8036b5ead1c6020(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a2a57acda1693186(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 3H5.25A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V5.25A2.25 2.25 0 0 0 18.75 3zm-7.92 13.635a1.08 1.08 0 0 1-1.08 1.08H6.42a1.08 1.08 0 0 1-1.08-1.08V6.42c0-.597.483-1.08 1.08-1.08h3.33c.596 0 1.08.483 1.08 1.08v10.215zm7.83-4.5a1.08 1.08 0 0 1-1.08 1.08h-3.33a1.08 1.08 0 0 1-1.08-1.08V6.42c0-.597.484-1.08 1.08-1.08h3.33c.597 0 1.08.483 1.08 1.08v5.715z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8426209a512d8ea0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.31 10.28a2.5 2.5 0 1 0 2.5 2.49 2.5 2.5 0 0 0-2.5-2.49zm0 3.8a1.31 1.31 0 1 1 0-2.61 1.31 1.31 0 1 1 0 2.61zm7.38-3.8a2.5 2.5 0 1 0 2.5 2.49 2.5 2.5 0 0 0-2.5-2.49zM17 12.77a1.31 1.31 0 1 1-1.31-1.3 1.31 1.31 0 0 1 1.31 1.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm7.38 10.77a3.69 3.69 0 0 1-6.2 2.71L12 16.77l-1.18-1.29a3.69 3.69 0 1 1-5-5.44l-1.2-1.3H7.3a8.33 8.33 0 0 1 9.41 0h2.67l-1.2 1.31a3.71 3.71 0 0 1 1.2 2.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.77 9.05a7.19 7.19 0 0 0-5.54 0A4.06 4.06 0 0 1 12 12.7a4.08 4.08 0 0 1 2.77-3.65z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$da0bbb82e25a4c2f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.078 20.953c-2.692 0-4.699-1.385-4.699-4.7v-5.308H6.931V8.07c2.694-.699 3.821-3.017 3.95-5.023h2.796v4.558h3.263v3.34h-3.263v4.622c0 1.386.699 1.864 1.813 1.864h1.58v3.522h-2.992z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$5b7befee7c6400b1(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.642 8.084c-.364.189-.79.42-1.242.42s-.81-.209-1.066-.413c-.13-.101-.234-.202-.313-.276-.137-.108-.12-.259-.064-.254.094.012.108.136.168.191.08.075.18.172.302.269.243.192.567.38.973.38s.878-.238 1.167-.4c.163-.092.371-.256.541-.381.13-.095.125-.21.232-.198.107.013.028.127-.122.258a3.404 3.404 0 0 1-.576.404z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.649 17.77c-.142-.16-.209-.456-.281-.771s-.153-.654-.411-.874l-.002-.001a1.054 1.054 0 0 0-.317-.192c.359-1.065.219-2.126-.145-3.084-.444-1.177-1.222-2.202-1.815-2.903-.664-.838-1.313-1.633-1.301-2.808.021-1.793.197-5.118-2.958-5.122a4.66 4.66 0 0 0-.401.017c-3.526.283-2.59 4.008-2.643 5.255-.064.912-.249 1.631-.877 2.523-.736.876-1.774 2.295-2.266 3.771-.232.697-.342 1.407-.241 2.08a1.9 1.9 0 0 0-.091.089c-.216.231-.376.511-.555.699-.166.167-.403.229-.664.323s-.547.231-.721.565l-.001.002a1 1 0 0 0-.108.484c0 .154.023.311.046.461.048.313.097.609.032.81-.206.564-.232.954-.087 1.237.146.284.444.409.783.479.676.141 1.592.106 2.314.489l.062-.117-.061.118c.773.404 1.557.547 2.182.405.454-.104.821-.374 1.011-.789.489-.002 1.025-.209 1.885-.256.583-.047 1.312.207 2.149.16a1.119 1.119 0 0 0 .099.264c.324.649.928.946 1.571.896s1.329-.43 1.883-1.089l-.102-.085.102.084c.527-.64 1.403-.905 1.984-1.255.29-.175.525-.395.544-.713.018-.318-.169-.675-.599-1.152zm-7.79-11.708c-.003-.234.036-.435.126-.639s.201-.351.358-.47.312-.174.494-.176h.009c.179 0 .332.053.489.167.159.116.274.261.366.463a1.493 1.493 0 0 1 .141.636c.002.235-.038.435-.127.639a1.23 1.23 0 0 1-.18.299l-.074-.033c-.089-.038-.167-.069-.237-.096s-.124-.044-.181-.064c.041-.049.122-.108.151-.181a.943.943 0 0 0 .072-.347l.002-.016a.953.953 0 0 0-.05-.337c-.038-.113-.086-.195-.155-.263s-.139-.099-.223-.101h-.011a.324.324 0 0 0-.217.086.618.618 0 0 0-.174.25.944.944 0 0 0-.072.348l-.001.015a.992.992 0 0 0 .014.2 2.463 2.463 0 0 0-.507-.171 1.681 1.681 0 0 1-.014-.19v-.019zm-2.144.052c-.012-.202.009-.376.064-.556s.13-.311.238-.418a.516.516 0 0 1 .349-.168h.03c.118 0 .225.04.335.127a.968.968 0 0 1 .284.389c.076.171.116.343.127.545v.002a1.51 1.51 0 0 1-.002.243c-.023.006-.046.014-.068.021-.128.044-.23.093-.328.158a.845.845 0 0 0 .003-.214v-.012a.95.95 0 0 0-.068-.274.523.523 0 0 0-.138-.203c-.052-.044-.1-.065-.153-.064l-.017.001c-.061.005-.11.034-.157.092a.536.536 0 0 0-.101.223.912.912 0 0 0-.019.293l.001.012c.01.103.031.189.067.275a.528.528 0 0 0 .166.224c-.059.045-.098.078-.146.113l-.11.081a.995.995 0 0 1-.229-.342 1.528 1.528 0 0 1-.128-.546v-.002zm.155 1.228c.187-.14.315-.234.402-.298.086-.063.121-.086.148-.112h.001c.14-.132.362-.374.699-.49.115-.04.245-.065.39-.066.275-.001.608.089 1.01.348.247.16.439.174.882.363h.001c.213.087.338.202.399.321.061.12.063.25.012.387-.103.273-.429.562-.887.705h-.001c-.224.072-.418.233-.647.364a1.449 1.449 0 0 1-.842.217 1.105 1.105 0 0 1-.374-.083 1.202 1.202 0 0 1-.27-.167c-.161-.131-.303-.295-.51-.416h-.002c-.333-.19-.515-.408-.573-.598-.057-.189-.003-.351.162-.475zm.131 13.018v.001c-.047.623-.398.961-.938 1.085-.539.123-1.27 0-1.999-.381h-.001c-.808-.427-1.768-.385-2.384-.514-.308-.064-.509-.161-.602-.341-.092-.18-.094-.494.102-1.028l.001-.002.001-.002c.097-.299.025-.626-.021-.934-.047-.307-.07-.586.034-.781l.001-.002c.135-.259.332-.352.576-.439.245-.088.534-.157.764-.386l.001-.001.001-.001c.212-.223.371-.503.557-.702.157-.167.314-.279.551-.28h.009c.041 0 .085.003.132.011.314.047.588.268.853.625l.762 1.389h.001c.202.423.631.89.994 1.365.362.475.644.952.607 1.317l-.002.001zm-.063-1.01a6.721 6.721 0 0 0-.333-.469 13.467 13.467 0 0 0-.229-.293c.151 0 .28-.024.384-.072a.486.486 0 0 0 .266-.274c.09-.242 0-.583-.288-.973-.29-.39-.778-.83-1.494-1.269-.527-.328-.821-.729-.959-1.165s-.119-.907-.013-1.373c.204-.894.729-1.762 1.063-2.308.09-.066.032.123-.339.811-.332.629-.953 2.081-.103 3.214a6.722 6.722 0 0 1 .538-2.398c.472-1.067 1.456-2.919 1.534-4.395.041.029.18.123.241.158.182.106.316.262.492.403.177.142.396.264.729.283l.093.003c.343 0 .61-.112.833-.239.242-.138.436-.292.618-.351h.001c.387-.122.694-.335.869-.585.302 1.186 1.001 2.897 1.45 3.733.239.443.715 1.385.92 2.52.13-.004.273.015.427.054.537-1.393-.455-2.892-.909-3.31-.184-.178-.192-.258-.102-.254.492.436 1.139 1.311 1.374 2.3.107.451.13.925.016 1.393.056.023.113.048.171.076.862.42 1.181.785 1.027 1.283-.05-.002-.1-.001-.148 0h-.014c.125-.395-.151-.687-.889-1.02-.764-.336-1.373-.303-1.476.379a1.302 1.302 0 0 0-.017.109c-.057.02-.114.045-.172.076-.358.197-.555.553-.664.99-.108.437-.14.964-.17 1.558-.019.298-.141.702-.266 1.129-1.249.897-2.986 1.283-4.461.276zm9.628.057c-.524.317-1.456.593-2.05 1.313-.517.615-1.146.952-1.7.996-.555.044-1.033-.186-1.315-.752v-.001l-.001-.003c-.175-.333-.102-.858.045-1.412.147-.554.359-1.123.388-1.585v-.001c.03-.592.063-1.11.163-1.509.1-.399.256-.669.533-.821l.039-.02c.031.513.285 1.036.734 1.149.491.129 1.199-.292 1.498-.636.06-.002.118-.006.175-.007.262-.006.481.009.707.205v.001h.001c.173.146.255.423.326.733.071.31.128.647.342.888h.001c.41.456.542.764.531.96-.011.198-.153.344-.417.502z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.738 6.762c.015.048.093.04.138.063.04.02.071.065.116.066.042.001.107-.015.113-.057.008-.056-.073-.091-.126-.111-.067-.026-.153-.039-.216-.004-.014.008-.03.027-.025.043zm-.46 0c-.016.048-.094.04-.139.063-.039.02-.071.065-.115.066-.042.001-.108-.015-.114-.057-.007-.056.074-.091.126-.111.067-.026.153-.039.217-.004.015.008.03.027.025.043z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$645fc67474c9e656(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.265 3 3 6.236v13.223h4.502V21l2.531.85 2.392-2.391h3.658l4.923-4.924V3H4.265zm15.052 10.691-2.813 2.814h-4.502l-2.391 2.391v-2.391H5.813V4.688h13.504v9.003zm-2.812-5.767v4.923h-1.688V7.924h1.688zm-4.502 0v4.923h-1.688V7.924h1.688z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$92a08e2cc65b9271(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c5e2dea084660d11(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.24 3H4.76A1.76 1.76 0 0 0 3 4.76v14.48A1.76 1.76 0 0 0 4.76 21h14.48A1.76 1.76 0 0 0 21 19.24V4.76A1.76 1.76 0 0 0 19.24 3zm-5.8 10h-2.25v6.44H9.4V13H7.15v-1.46h6.29zm5.8 5.28a1.71 1.71 0 0 1-.67.74 3 3 0 0 1-1 .39 5.81 5.81 0 0 1-1.2.12 7 7 0 0 1-1.23-.11 4.52 4.52 0 0 1-1-.33v-1.71l-.06-.06h.06v.07a3.41 3.41 0 0 0 1 .54 3.06 3.06 0 0 0 1.13.2 2.58 2.58 0 0 0 .6-.06 1.47 1.47 0 0 0 .42-.17.75.75 0 0 0 .25-.25.69.69 0 0 0-.06-.74 1.24 1.24 0 0 0-.35-.33 3.12 3.12 0 0 0-.53-.3l-.67-.28a3.57 3.57 0 0 1-1.37-1 2 2 0 0 1-.46-1.33 2.16 2.16 0 0 1 .24-1.06 2.09 2.09 0 0 1 .66-.71 2.88 2.88 0 0 1 1-.42 5.11 5.11 0 0 1 1.19-.13 7 7 0 0 1 1.09.07 4.53 4.53 0 0 1 .88.23v1.65a2.42 2.42 0 0 0-.42-.24 3.58 3.58 0 0 0-.49-.17 3 3 0 0 0-.49-.1 2.45 2.45 0 0 0-.46 0 2.29 2.29 0 0 0-.56.06 1.54 1.54 0 0 0-.43.16.78.78 0 0 0-.26.25.63.63 0 0 0-.09.33.62.62 0 0 0 .1.35 1.19 1.19 0 0 0 .3.29 2.15 2.15 0 0 0 .46.28l.63.28a6.56 6.56 0 0 1 .84.42 2.65 2.65 0 0 1 .64.49 1.79 1.79 0 0 1 .42.63 2.48 2.48 0 0 1 .14.85 2.68 2.68 0 0 1-.25 1.08z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a3c0cb1dd58821a4(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.4 17.8 1.21 2.07L19.77 22 22 14.08 20.72 12 22 10l-2.23-8-8.16 2.13L10.4 6.2H8L2 12l6 5.81zm9.92-5.8-1.73 6L15 12l3.59-6zM10.6 6.54 16.84 5l-3.59 6H6.08zM13.27 13l3.59 6-6.26-1.55L6.1 13z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c47e7fe046dd8bd0(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.625 8.063V3h6.75v5.063h-6.75zm6.75 2.812H21V21H3V10.875h5.625v5.063h6.75v-5.063z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$225bd5b4e1c8a665(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.47 6.07a4.54 4.54 0 0 0-4.38 3.69 19.9 19.9 0 0 1-2.28-4.9H8.55v6a2.14 2.14 0 1 1-4.28 0v-6L2 4.91v6a4.4 4.4 0 1 0 8.8-.05v-1a20.55 20.55 0 0 0 1.65 2.7l-1.38 6.61h2.32l1-4.81a5.61 5.61 0 0 0 3.11.89 4.57 4.57 0 0 0 0-9.14zm0 6.83a4.09 4.09 0 0 1-2.55-1l.23-.91v-.05c.16-1 .66-2.6 2.35-2.6a2.25 2.25 0 0 1 2.27 2.24 2.41 2.41 0 0 1-2.27 2.32z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$84f5482e8eee0723(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3.27a7.49 7.49 0 0 1 .66 3.35c0 2.72-1.93 6.72-3.49 9.27L9.53 2.44l-6.91.65L5.79 22h7.88c3.45-4.54 7.71-11 7.71-16a7.3 7.3 0 0 0-1.06-4z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8f76019b98718c62(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.062 10.414c-2.036 4.349-6.949 10.267-10.054 10.267-3.06 0-3.501-6.527-5.173-10.869-.823-2.138-1.354-1.646-2.896-.567L2 8.031c2.248-1.976 4.499-4.272 5.88-4.399 1.559-.148 2.517.916 2.873 3.193.475 2.994 1.137 7.641 2.291 7.641.9 0 3.117-3.686 3.232-5.004.203-1.93-1.421-1.989-2.828-1.387 2.228-7.295 11.494-5.95 7.614 2.339z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$b5546e307cf52d8(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.539 9.186a4.155 4.155 0 0 0-1.451-.251c-1.6 0-2.73.806-2.738 1.963-.01.85.803 1.329 1.418 1.613.631.292.842.476.84.737-.004.397-.504.577-.969.577-.639 0-.988-.089-1.525-.312l-.199-.093-.227 1.332c.389.162 1.09.301 1.814.313 1.701 0 2.813-.801 2.826-2.032.014-.679-.426-1.192-1.352-1.616-.563-.275-.912-.459-.912-.738 0-.247.299-.511.924-.511a2.95 2.95 0 0 1 1.213.229l.15.067.227-1.287-.039.009zm4.152-.143h-1.25c-.389 0-.682.107-.852.493l-2.404 5.446h1.701l.34-.893 2.076.002c.049.209.199.891.199.891h1.5l-1.31-5.939zm-10.642-.05h1.621l-1.014 5.942H9.037l1.012-5.944v.002zm-4.115 3.275.168.825 1.584-4.05h1.717l-2.551 5.931H5.139l-1.4-5.022a.339.339 0 0 0-.149-.199 6.948 6.948 0 0 0-1.592-.589l.022-.125h2.609c.354.014.639.125.734.503l.57 2.729v-.003zm12.757.606.646-1.662c-.008.018.133-.343.215-.566l.111.513.375 1.714H18.69v.001h.001z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$f750bc37189194b2(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.29 4.1-4.12-2a1.36 1.36 0 0 0-.48-.1h-.08a1.18 1.18 0 0 0-.72.24l-.14.12-7.88 7.19L4.44 7a.83.83 0 0 0-.54-.17.88.88 0 0 0-.53.17l-1.1 1a.8.8 0 0 0-.27.61.84.84 0 0 0 .27.62l3 2.71-3 2.72a.84.84 0 0 0 0 1.23l1.1 1a.89.89 0 0 0 .6.22.93.93 0 0 0 .47-.17l3.43-2.61 7.88 7.19a1.2 1.2 0 0 0 .76.36h.17a1 1 0 0 0 .49-.12l4.12-2a1.25 1.25 0 0 0 .71-1.1V5.23a1.26 1.26 0 0 0-.71-1.13zM17 16.47l-6-4.53 6-4.53z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$3c28440a69073090(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.579 6.855c.14-.465 0-.806-.662-.806h-2.193c-.558 0-.813.295-.953.619 0 0-1.115 2.719-2.695 4.482-.51.513-.743.675-1.021.675-.139 0-.341-.162-.341-.627V6.855c0-.558-.161-.806-.626-.806H9.642c-.348 0-.558.258-.558.504 0 .528.79.65.871 2.138v3.228c0 .707-.127.836-.407.836-.743 0-2.551-2.729-3.624-5.853-.209-.607-.42-.852-.98-.852H2.752c-.627 0-.752.295-.752.619 0 .582.743 3.462 3.461 7.271 1.812 2.601 4.363 4.011 6.687 4.011 1.393 0 1.565-.313 1.565-.853v-1.966c0-.626.133-.752.574-.752.324 0 .882.164 2.183 1.417 1.486 1.486 1.732 2.153 2.567 2.153h2.192c.626 0 .939-.313.759-.931-.197-.615-.907-1.51-1.849-2.569-.512-.604-1.277-1.254-1.51-1.579-.325-.419-.231-.604 0-.976.001.001 2.672-3.761 2.95-5.04z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a5dc9a5f5173c734(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 12.765 5.592-9.437h-3.276L12 7.33v.002L9.688 3.328h-3.28z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.461 3.332 12 14.235 5.539 3.332H1.992L12 20.672l10.008-17.34z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$567bb6dec941869f(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.043 6.925a4.985 4.985 0 0 0-4.98 4.979c-.001.94.263 1.856.761 2.649l.118.188-.503 1.837 1.885-.494.181.108a4.97 4.97 0 0 0 2.535.693h.001a4.986 4.986 0 0 0 4.979-4.978 4.946 4.946 0 0 0-1.456-3.522 4.946 4.946 0 0 0-3.521-1.46zm2.928 7.118c-.125.35-.723.668-1.01.711a2.044 2.044 0 0 1-.943-.059 8.51 8.51 0 0 1-.853-.315c-1.502-.648-2.482-2.159-2.558-2.26-.074-.1-.61-.812-.61-1.548 0-.737.386-1.099.523-1.249a.552.552 0 0 1 .4-.186c.1 0 .199.001.287.005.092.004.215-.035.336.257.125.3.425 1.036.462 1.111.037.074.062.162.013.262-.05.101-.074.162-.15.25-.074.088-.157.195-.224.263-.075.074-.153.155-.066.305.088.149.388.64.832 1.037.572.51 1.055.667 1.204.743.15.074.237.063.325-.038.087-.101.374-.437.474-.586.1-.15.199-.125.337-.076.137.051.873.412 1.022.487.148.074.249.112.287.175.036.062.036.361-.088.711z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-7.96 14.896h-.002a5.98 5.98 0 0 1-2.862-.729L6 18l.85-3.104a5.991 5.991 0 0 1 5.19-8.983 5.95 5.95 0 0 1 4.238 1.757 5.95 5.95 0 0 1 1.751 4.237 5.998 5.998 0 0 1-5.989 5.989z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$c606e88b452d2880(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$51887419968dd225(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.081 12.932c-.78 1.611-1.849 3.792-2.379 4.776-.513.896-.94.776-1.278.024-1.172-2.77-3.58-7.625-4.712-10.347-.209-.502-.367-.823-.516-.95-.151-.125-.462-.2-.936-.227-.174-.019-.26-.061-.26-.131v-.379l.043-.038c.771-.004 4.503 0 4.503 0l.042.038v.362c0 .1-.063.147-.188.147l-.47.024c-.403.026-.605.137-.605.365 0 .112.044.275.139.501.902 2.206 4.017 8.772 4.017 8.772l.114.039 2.01-4.012-.402-.89L9.82 8.285s-.265-.545-.357-.727c-.607-1.203-.593-1.265-1.206-1.347-.173-.02-.261-.042-.261-.125v-.39l.05-.037h3.578l.095.03v.376c0 .088-.063.125-.189.125l-.257.039c-.66.051-.551.318-.113 1.186l1.319 2.712 1.465-2.922c.244-.533.194-.668.093-.789-.058-.07-.255-.185-.677-.2l-.168-.018a.191.191 0 0 1-.121-.043.125.125 0 0 1-.056-.107v-.357l.051-.037c1.04-.007 3.371 0 3.371 0l.05.037v.364c0 .101-.05.148-.161.148-.539.024-.652.079-.854.366-.1.154-.313.49-.538.865l-1.919 3.563-.054.112 2.328 4.763.142.041 3.665-8.704c.129-.352.107-.602-.053-.746-.165-.144-.289-.228-.716-.246l-.35-.014a.211.211 0 0 1-.127-.037.128.128 0 0 1-.06-.1v-.361l.049-.038h4.137l.034.038v.364c0 .1-.062.15-.174.15-.541.024-.94.15-1.203.351-.263.213-.465.514-.614.89 0 0-3.371 7.72-4.524 10.289-.438.84-.878.765-1.253-.026-.477-.977-1.478-3.156-2.206-4.761l.045-.03z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$a7f78c2d9b7274b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 5.557 7.357-1.002.004 7.097-7.354.042L3 5.557zm7.354 6.913.006 7.103-7.354-1.011v-6.14l7.348.048zm.892-8.046L21.001 3v8.562l-9.755.077V4.424zm9.758 8.113-.003 8.523-9.755-1.378-.014-7.161 9.772.016z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$e3392f13199d3930(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.444 8.256c-.4.212-.544.562-.544 1.53 0 0 .202-.194.499-.303a2.01 2.01 0 0 0 .512-.275c.338-.247.385-.562.385-1.096 0 0-.553-.016-.852.144zm-2.349.229c-.32.286-.418.739-.418.739l-1.078 4.141L8.71 9.97c-.087-.355-.246-.808-.495-1.107-.31-.378-.944-.401-1.015-.401-.068 0-.709.023-1.026.407-.246.303-.406.751-.493 1.108l-.889 3.395-1.066-4.147s-.092-.459-.418-.739c-.529-.465-1.314-.367-1.314-.367l2.048 7.764s.677.052 1.015-.126c.441-.224.659-.401.929-1.463.241-.94.912-3.704.974-3.905.029-.098.07-.332.241-.332.179 0 .214.229.241.332.064.195.729 2.965.976 3.905.268 1.055.481 1.227.929 1.463.338.178 1.015.126 1.015.126l2.048-7.759c-.002 0-.789-.099-1.315.361zm3.201.9s-.129.195-.42.367c-.188.104-.367.178-.562.271-.323.154-.414.332-.414.595v5.266s.522.063.854-.104c.436-.222.533-.435.541-1.404V9.385zm5.112 2.632 2.599-3.875s-1.096-.189-1.641.309c-.35.315-.738.885-.738.885l-.952 1.386c-.053.069-.104.15-.2.15-.099 0-.161-.075-.202-.15l-.962-1.382s-.385-.568-.74-.884c-.54-.499-1.641-.31-1.641-.31l2.603 3.865-2.603 3.858s1.146.149 1.688-.35c.35-.315.688-.837.688-.837l.95-1.383c.053-.068.104-.147.2-.147.1 0 .161.075.202.147l.952 1.383s.355.51.7.837c.538.499 1.667.35 1.667.35l-2.57-3.852z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$2797e84131a037e3(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.891 7.788a8.966 8.966 0 0 1 1.099 4.313 8.986 8.986 0 0 1-4.47 7.771l2.746-7.939c.513-1.282.684-2.309.684-3.219a7.165 7.165 0 0 0-.059-.926m-6.651.087a14.14 14.14 0 0 0 1.026-.088c.485-.063.428-.775-.056-.749 0 0-1.463.112-2.4.112-.887 0-2.375-.125-2.375-.125-.487-.024-.55.713-.061.738 0 0 .449.052.938.075l1.399 3.838-1.975 5.899-3.274-9.724a17.006 17.006 0 0 0 1.028-.083c.487-.063.43-.775-.055-.747 0 0-1.455.115-2.395.115-.167 0-.365-.007-.575-.013C6.093 4.726 8.862 3.113 12 3.113c2.341 0 4.471.894 6.071 2.36-.038-.002-.076-.008-.117-.008-.883 0-1.51.77-1.51 1.596 0 .741.427 1.369.883 2.108.343.601.742 1.37.742 2.481 0 .763-.295 1.662-.685 2.899l-.896 2.987-3.25-9.675.002.014zM12 21.087a8.983 8.983 0 0 1-2.54-.364l2.697-7.838 2.763 7.572c.021.044.042.085.065.124a9.016 9.016 0 0 1-2.985.508m-8.99-8.988a8.94 8.94 0 0 1 .778-3.658l4.287 11.749a8.993 8.993 0 0 1-5.065-8.091m8.99-10c-5.513 0-10 4.487-10 10s4.487 10 10 10 10-4.487 10-10-4.487-10-10-10"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$4ddfe4e437374a4b(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a.4.4 0 0 0-.38.62l2 3.38-3.06 5.4a.45.45 0 0 0 0 .45.43.43 0 0 0 .38.19h2.87a.89.89 0 0 0 .79-.55s3-5.31 3.11-5.51l-2-3.46A.91.91 0 0 0 7.92 6zm12.16-4a.84.84 0 0 0-.77.55L10 13.93l4.09 7.52a.91.91 0 0 0 .81.55h2.88a.43.43 0 0 0 .38-.18.45.45 0 0 0 0-.45l-4.07-7.43 6.36-11.31a.45.45 0 0 0 0-.45.44.44 0 0 0-.38-.18z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$1dafb2f092af7166(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.131 21s-.63-.114-1.138-.114c-.457 0-1.142.114-1.142.114l.143-7.646C9.933 11.52 6.814 5.933 4.868 3c.979.223 1.391.209 2.374 0l.015.025c1.239 2.194 3.135 5.254 4.736 7.905C13.575 8.325 16.064 4.258 16.74 3c.765.201 1.536.193 2.392 0-.9 1.213-4.175 6.88-6.153 10.354L13.125 21h.006z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$6774b3ebca4c8c55(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.824 16.675c-.105.726-1.587 2.609-2.269 2.882-.232.093-.457.07-.637-.068-.116-.09-.235-.272-1.833-2.866l-.475-.773c-.183-.277-.148-.642.078-.92.223-.27.549-.37.832-.262.016.008 1.195.397 1.195.397 2.688.883 2.775.917 2.891 1.002.17.139.249.356.214.608h.004zm-5.386-3.946c-.19-.289-.187-.63.01-.865l.746-1.019c1.642-2.235 1.732-2.353 1.843-2.431a.636.636 0 0 1 .652-.024c.651.316 1.966 2.269 2.045 3.019v.025a.623.623 0 0 1-.259.587c-.123.079-.235.125-3.291.866-.483.123-.752.19-.91.247l.021-.023c-.302.091-.64-.055-.831-.357l-.026-.025zm-1.875-1.159c-.146.046-.591.185-1.139-.702 0 0-3.694-5.813-3.78-5.992-.053-.201.011-.429.19-.613.55-.569 3.534-1.405 4.315-1.215.255.066.43.227.491.453.045.25.408 5.646.46 6.854.051 1.034-.392 1.171-.537 1.215zm.487 5.913c-.008 2.827-.015 2.922-.061 3.056-.079.211-.26.352-.51.398-.72.122-2.972-.71-3.441-1.267a.739.739 0 0 1-.157-.37c-.013-.09 0-.18.033-.259.057-.146.135-.259 2.158-2.63l.594-.706c.203-.26.563-.338.899-.204.325.124.528.405.506.708v1.259l-.021.015zm-6.13-1.808c-.222-.006-.42-.14-.535-.358-.083-.162-.142-.428-.18-.752-.102-.974.023-2.444.314-2.911.138-.214.338-.327.559-.319.146 0 .276.046 3.167 1.236l.848.337c.302.111.489.427.472.787-.022.348-.224.616-.521.696l-1.202.382c-2.689.864-2.778.888-2.919.877l-.003.025zm11.22 5.322h-.004l-.003.003.007-.003z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$101e30cc6832dd8d(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z"
                }
            }
        ]
    })(props);
}
function $f59ac49c6e1fede1$export$8e4c78f27d73463(props) {
    return (0, $14ac770f22d16fda$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.984 7.506v6.74c.006 1.524 1.361 2.75 3.014 2.745h10.693c.303 0 .549-.225.549-.498v-6.74c-.008-1.523-1.363-2.75-3.014-2.744H2.531c-.302 0-.547.224-.547.497zm14.936 2.63 4.416-2.963c.383-.292.68-.219.68.309v9.036c0 .601-.363.528-.68.309L16.92 13.87v-3.734z"
                }
            }
        ]
    })(props);
}


const $d8c48a7438123691$export$110709f040143804 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
        w: "100%",
        h: "100%",
        p: 4,
        borderColor: "gray.200",
        justifyContent: "flex-start",
        borderRight: "1px solid var(--colors-neutral-4)",
        overflow: "hidden",
        maxW: "32%",
        ...rest,
        children: children
    });
};
const $d8c48a7438123691$export$364a989a35814102 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
        flexGrow: 1,
        minH: "550px",
        w: "100%",
        h: "100%",
        overflowY: "scroll",
        ...rest,
        children: children
    });
};
const $d8c48a7438123691$export$2479ffe3e021e6e9 = (props)=>{
    const { buildId: buildId } = props;
    const qrId = (0, $5e2e7dfba3eb8bc8$export$2e2bcd8739ae039)(buildId);
    const urlString = `https://studio.playgroundxyz.com/${qrId}/quiet?pos=middle-ad&size=300x250&dpframe=0`;
    // accessing the iframe video (if it exists) to pause it when the qrCode displays, as chart re-rendering is causing rendering issues for the Popover
    const iframeVideo = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.iframeVideo);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $477e0f2775c64f2e$export$5b6b19405a83ff9d), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b8cdd4baf94d547a$export$7dacb05d26466c3), {
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                    onMouseEnter: ()=>{
                        if (iframeVideo) iframeVideo.pause();
                    },
                    onMouseLeave: ()=>{
                        if (iframeVideo) iframeVideo.play();
                    },
                    "aria-label": "Scan QR Code",
                    icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$e9283c75dc5e4e85), {
                        size: "25px"
                    }),
                    size: "sm"
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e51c5ae64f7cf3d3$export$602eac185826482c), {
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $de04819b4e852901$export$d7e1f420b25549ff), {
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ed866da64dbb3b59$export$3152841115e061b2), {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b1a9c1b9073ec5cf$export$4c88dacf86a15877), {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e7f912796dcf7bff$export$24cbcada8f546cfe), {
                            fontSize: "sm",
                            children: "Scan to view this creative on mobile"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a6464059de3a62e$export$472ec417bca1d382), {
                            py: 10,
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4ccd6fc161746b2$exports))), {
                                renderAs: "svg",
                                style: {
                                    width: "100%"
                                },
                                size: 250,
                                value: urlString,
                                bgColor: "#fff"
                            })
                        })
                    ]
                })
            })
        ]
    });
};







var $lDSNw = parcelRequire("lDSNw");
const $92d9d78e175a9034$var$MissingPage = ()=>{
    (0, $lDSNw.useEffect)(()=>{
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).error404(window.location.href);
    }, []);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                maxWidth: "750px",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("h2", {
                    children: "We're sorry, the report you requested could not be found... \uD83D\uDE3F"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("p", {
                    style: {
                        marginBottom: "50px"
                    },
                    children: "(Here's a game to make up for it!)"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $62548df2a7b28942$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $92d9d78e175a9034$export$2e2bcd8739ae039 = $92d9d78e175a9034$var$MissingPage;







var $lDSNw = parcelRequire("lDSNw");
parcelRequire("dZzSU");
var $8eXKx = parcelRequire("8eXKx");
const $1c35ceb551c89c22$var$db = (0, $8eXKx.default).firestore();
const $1c35ceb551c89c22$export$f70888b2b726fe1c = async (buildId)=>{
    const countsRef = $1c35ceb551c89c22$var$db.collection("/Counts/byCreative/creatives/").doc(buildId);
    try {
        const snapshot = await countsRef.get();
        if (snapshot.exists) return snapshot.data();
        else return {
            favourites: 0,
            views: 0
        };
    } catch (e) {
        console.log("error", e);
    }
};
const $1c35ceb551c89c22$export$196d223966088022 = async (userId)=>{
    const countsRef = $1c35ceb551c89c22$var$db.collection("/Counts/byUser/users/").doc(userId);
    try {
        const snapshot = await countsRef.get();
        if (snapshot.exists) {
            const data = snapshot.data();
            return {
                favourites: data.favourites.sort((a, b)=>b.updated - a.updated)
            };
        } else return {
            favourites: []
        };
    } catch (e) {
        console.log("error", e);
    }
};
const $1c35ceb551c89c22$export$4460301e8a8c1807 = async (userId, buildId)=>{
    const userRef = $1c35ceb551c89c22$var$db.collection("/Counts/byUser/users/").doc(userId);
    const creativeRef = $1c35ceb551c89c22$var$db.collection("/Counts/byCreative/creatives/").doc(buildId);
    const updated = new Date().getTime();
    const transaction = $1c35ceb551c89c22$var$db.runTransaction(async (t)=>{
        const userDoc = await t.get(userRef);
        const creativeDoc = await t.get(creativeRef);
        if (userDoc.exists) {
            const favourites = userDoc.data().favourites;
            const alreadyFavourited = favourites.find((fav)=>fav.id === buildId);
            if (!alreadyFavourited) {
                favourites.push({
                    id: buildId,
                    updated: updated
                });
                t.set(userRef, {
                    favourites: favourites
                }, {
                    merge: true
                });
            }
        } else t.set(userRef, {
            favourites: [
                {
                    id: buildId,
                    updated: updated
                }
            ]
        });
        if (creativeDoc.exists) {
            const favourites = creativeDoc.data().favourites;
            t.set(creativeRef, {
                favourites: favourites + 1,
                updated: updated
            }, {
                merge: true
            });
        } else t.set(creativeRef, {
            favourites: 1,
            updated: updated
        }, {
            merge: true
        });
    });
    await transaction;
    return;
};
const $1c35ceb551c89c22$export$239b3526d33b4806 = async (userId, buildId)=>{
    const userRef = $1c35ceb551c89c22$var$db.collection("/Counts/byUser/users/").doc(userId);
    const creativeRef = $1c35ceb551c89c22$var$db.collection("/Counts/byCreative/creatives/").doc(buildId);
    const updated = new Date().getTime();
    const transaction = $1c35ceb551c89c22$var$db.runTransaction(async (t)=>{
        const userDoc = await t.get(userRef);
        const creativeDoc = await t.get(creativeRef);
        if (userDoc.exists) {
            const favourites = userDoc.data().favourites;
            const isFavourited = favourites.find((fav)=>fav.id === buildId);
            if (isFavourited) {
                const newFavourites = favourites.filter((fav)=>fav.id !== buildId);
                t.update(userRef, {
                    favourites: newFavourites
                });
            }
        } else t.set(userRef, {
            favourites: []
        });
        if (creativeDoc.exists) {
            const favourites = creativeDoc.data().favourites;
            t.set(creativeRef, {
                favourites: favourites - 1,
                updated: updated
            }, {
                merge: true
            });
        } else t.set(creativeRef, {
            favourites: 0,
            updated: updated
        }, {
            merge: true
        });
    });
    await transaction;
    return;
};
const $1c35ceb551c89c22$export$f99a4371c4cfc8f6 = async (limit = 10)=>{
    const countsRef = $1c35ceb551c89c22$var$db.collection("/Counts/byCreative/creatives/");
    const snapshot = await countsRef.orderBy("favourites", "desc").orderBy("updated", "desc").where("favourites", ">", 0).limit(limit).get();
    const topFavourited = [];
    snapshot.forEach((doc)=>{
        topFavourited.push({
            id: doc.id,
            ...doc.data()
        });
    });
    const topWithScores = $1c35ceb551c89c22$var$getTopFavouritesWithScores(topFavourited);
    return topWithScores;
};
const $1c35ceb551c89c22$var$calculateWeightedScore = (item, currentTime)=>{
    // tinker with these values to adjust the weighting of the score
    const favouritesWeight = 0.9;
    const recencyWeight = 0.1;
    const favouritesScore = item.favourites * favouritesWeight;
    // Calculate recency score (higher score for more recent items)
    const timeDiff = currentTime - item.updated;
    const daysSinceUpdate = timeDiff / 86400000;
    const recencyScore = 1 / (daysSinceUpdate + 1) * recencyWeight;
    return favouritesScore + recencyScore;
};
const $1c35ceb551c89c22$var$getTopFavouritesWithScores = (favourites)=>{
    const currentTime = Date.now();
    return favourites.map((item)=>{
        const score = $1c35ceb551c89c22$var$calculateWeightedScore(item, currentTime);
        return {
            ...item,
            score: score
        };
    }).sort((a, b)=>b.score - a.score);
};



var $lDSNw = parcelRequire("lDSNw");
const $522db9f04f01389a$export$def26607a7f95168 = (buildId)=>{
    const [counts, setCounts] = (0, $lDSNw.useState)({});
    const [loading, setLoading] = (0, $lDSNw.useState)(false);
    const [error, setError] = (0, $lDSNw.useState)(null);
    (0, $lDSNw.useEffect)(()=>{
        if (!buildId) return;
        if (loading) return;
        fetchCounts(buildId);
    }, [
        buildId
    ]);
    const fetchCounts = async (buildId)=>{
        setLoading(true);
        try {
            const counts = await (0, $1c35ceb551c89c22$export$f70888b2b726fe1c)(buildId);
            setCounts(counts);
        } catch (error) {
            setError(error);
        } finally{
            setLoading(false);
        }
    };
    const refetchCounts = async ()=>{
        await fetchCounts(buildId);
        return;
    };
    return {
        counts: counts,
        loading: loading,
        error: error,
        refetchCounts: refetchCounts
    };
};
const $522db9f04f01389a$export$93687b24650bc8ab = (userId)=>{
    const [counts, setCounts] = (0, $lDSNw.useState)({});
    const [loading, setLoading] = (0, $lDSNw.useState)(false);
    const [error, setError] = (0, $lDSNw.useState)(null);
    (0, $lDSNw.useEffect)(()=>{
        if (!userId) return;
        if (loading) return;
        fetchCounts(userId);
    }, [
        userId
    ]);
    const fetchCounts = async (userId)=>{
        setLoading(true);
        try {
            const counts = await (0, $1c35ceb551c89c22$export$196d223966088022)(userId);
            setCounts(counts);
        } catch (error) {
            setError(error);
        } finally{
            setLoading(false);
        }
    };
    const addFavourite = async (buildId)=>{
        setLoading(true);
        try {
            await (0, $1c35ceb551c89c22$export$4460301e8a8c1807)(userId, buildId);
            fetchCounts(userId);
        } catch (error) {
            setError(error);
            setLoading(false);
        }
    };
    const removeFavourite = async (buildId)=>{
        setLoading(true);
        try {
            await (0, $1c35ceb551c89c22$export$239b3526d33b4806)(userId, buildId);
            fetchCounts(userId);
        } catch (error) {
            setError(error);
            setLoading(false);
        }
    };
    const toggleFavourite = async (buildId)=>{
        setLoading(true);
        try {
            if (counts.favourites && counts.favourites.find((fav)=>fav.id === buildId)) await (0, $1c35ceb551c89c22$export$239b3526d33b4806)(userId, buildId);
            else await (0, $1c35ceb551c89c22$export$4460301e8a8c1807)(userId, buildId);
            fetchCounts(userId);
        } catch (error) {
            setError(error);
            setLoading(false);
        }
    };
    return {
        counts: counts,
        loading: loading,
        error: error,
        addFavourite: addFavourite,
        removeFavourite: removeFavourite,
        toggleFavourite: toggleFavourite
    };
};
const $522db9f04f01389a$export$be543f108f7c3ef7 = ()=>{
    const [topFavourites, setTopFavourites] = (0, $lDSNw.useState)([]);
    const [loading, setLoading] = (0, $lDSNw.useState)(false);
    const [error, setError] = (0, $lDSNw.useState)(null);
    (0, $lDSNw.useEffect)(()=>{
        if (loading) return;
        fetchCounts();
    }, []);
    const fetchCounts = async ()=>{
        setLoading(true);
        try {
            const counts = await (0, $1c35ceb551c89c22$export$f99a4371c4cfc8f6)();
            setTopFavourites(counts);
        } catch (error) {
            console.log("error", error);
            setError(error);
        } finally{
            setLoading(false);
        }
    };
    return {
        topFavourites: topFavourites,
        loading: loading,
        error: error
    };
};


const $7c10c71055b2923e$var$Favourite = ({ buildID: buildID, userID: userID })=>{
    const [isFavourite, setIsFavourite] = (0, $lDSNw.useState)(false);
    const { counts: byCreative, refetchCounts: refetchCounts } = (0, $522db9f04f01389a$export$def26607a7f95168)(buildID);
    const { favourites: favouritesCount } = byCreative;
    const { counts: counts, loading: loading, addFavourite: addFavourite, removeFavourite: removeFavourite } = (0, $522db9f04f01389a$export$93687b24650bc8ab)(userID);
    const { favourites: favourites } = counts;
    (0, $lDSNw.useEffect)(()=>{
        if (favourites && favourites.find((fav)=>fav.id === buildID)) setIsFavourite(true);
        else setIsFavourite(false);
    }, [
        favourites
    ]);
    const handleClicked = async ()=>{
        if (isFavourite) await removeFavourite(buildID);
        else await addFavourite(buildID);
        setIsFavourite(!isFavourite);
        refetchCounts();
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $55f5c4969dc36ab6$export$28c660c63b792dea), {
        label: `Favourited ${favouritesCount} ${favouritesCount === 1 ? "time" : "times"}`,
        "aria-label": "favourite count",
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
            disabled: loading,
            "aria-label": "Favourite",
            size: "sm",
            icon: isFavourite ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                as: (0, $f59ac49c6e1fede1$export$bbf5c63ab3baf1ad),
                color: "yellow.400"
            }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                as: (0, $f59ac49c6e1fede1$export$bbf5c63ab3baf1ad),
                color: "gray.500"
            }),
            onClick: handleClicked
        })
    });
};
var $7c10c71055b2923e$export$2e2bcd8739ae039 = $7c10c71055b2923e$var$Favourite;


var $47583530b0c2cd74$exports = {};
/*!
 * jQuery JavaScript Library v3.7.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-05-11T18:29Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $47583530b0c2cd74$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $47583530b0c2cd74$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $47583530b0c2cd74$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) return elem.textContent;
            else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "�";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented
        // as part of Sizzle so let's maintain them in the 3.x line
        // for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});



var $lDSNw = parcelRequire("lDSNw");



parcelRequire("lDSNw");




var $4a7c7a4d854dc191$exports = {};

$parcel$export($4a7c7a4d854dc191$exports, "demoControls", function () { return $4a7c7a4d854dc191$export$67969e4d6620c073; }, function (v) { return $4a7c7a4d854dc191$export$67969e4d6620c073 = v; });
$parcel$export($4a7c7a4d854dc191$exports, "flush", function () { return $4a7c7a4d854dc191$export$4909b86c8034bf73; }, function (v) { return $4a7c7a4d854dc191$export$4909b86c8034bf73 = v; });
$parcel$export($4a7c7a4d854dc191$exports, "howTo", function () { return $4a7c7a4d854dc191$export$91392eeb01bb62de; }, function (v) { return $4a7c7a4d854dc191$export$91392eeb01bb62de = v; });
$parcel$export($4a7c7a4d854dc191$exports, "icon", function () { return $4a7c7a4d854dc191$export$1ca1ec8b29a4ce27; }, function (v) { return $4a7c7a4d854dc191$export$1ca1ec8b29a4ce27 = v; });
var $4a7c7a4d854dc191$export$67969e4d6620c073;
var $4a7c7a4d854dc191$export$4909b86c8034bf73;
var $4a7c7a4d854dc191$export$91392eeb01bb62de;
var $4a7c7a4d854dc191$export$1ca1ec8b29a4ce27;
$4a7c7a4d854dc191$export$67969e4d6620c073 = `Fl13WW_demoControls`;
$4a7c7a4d854dc191$export$4909b86c8034bf73 = `Fl13WW_flush`;
$4a7c7a4d854dc191$export$91392eeb01bb62de = `Fl13WW_howTo`;
$4a7c7a4d854dc191$export$1ca1ec8b29a4ce27 = `Fl13WW_icon`;


const $ad11f00ae4a3656b$var$DemoControls = ()=>{
    const clearDemoData = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.clearDemoData);
    const buildID = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.buildID);
    const handleClearDemoData = ()=>{
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).demoClearedData();
        clearDemoData(buildID);
    };
    const handleHowToClick = ()=>{
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).demoClickedHowToUse();
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a7c7a4d854dc191$exports))).demoControls,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a7c7a4d854dc191$exports))).flush,
                onClick: handleClearDemoData,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                        icon: (0, $36045e57d0ad82eb$export$e7fc4fe34e767f28),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4a7c7a4d854dc191$exports))).icon
                    }),
                    "Clear demo data"
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4a7c7a4d854dc191$exports))).howTo,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("a", {
                    href: "https://playgroundxyz.atlassian.net/wiki/spaces/SAL/pages/1455850175/How+to+use+the+CAT+demo",
                    target: "_blank",
                    onClick: handleHowToClick,
                    rel: "noopener noreferrer",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a59a3f093b9574b7$export$2b9260d4a45c8710), {
                            icon: (0, $36045e57d0ad82eb$export$d96973f90e8f6e47),
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4a7c7a4d854dc191$exports))).icon
                        }),
                        "How to use demo mode"
                    ]
                })
            })
        ]
    });
};
var $ad11f00ae4a3656b$export$2e2bcd8739ae039 = $ad11f00ae4a3656b$var$DemoControls;








var $lDSNw = parcelRequire("lDSNw");








var $lDSNw = parcelRequire("lDSNw");

"use client";
var [$cff529dd6c5b5069$var$FormControlStylesProvider, $cff529dd6c5b5069$export$2824197c2cd75b1e] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `FormControlStylesContext`,
    errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
});
var [$cff529dd6c5b5069$var$FormControlProvider, $cff529dd6c5b5069$export$97a2352498389516] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    strict: false,
    name: "FormControlContext"
});
function $cff529dd6c5b5069$var$useFormControlProvider(props) {
    const { id: idProp, isRequired: isRequired, isInvalid: isInvalid, isDisabled: isDisabled, isReadOnly: isReadOnly, ...htmlProps } = props;
    const uuid = (0, $lDSNw.useId)();
    const id = idProp || `field-${uuid}`;
    const labelId = `${id}-label`;
    const feedbackId = `${id}-feedback`;
    const helpTextId = `${id}-helptext`;
    const [hasFeedbackText, setHasFeedbackText] = (0, $lDSNw.useState)(false);
    const [hasHelpText, setHasHelpText] = (0, $lDSNw.useState)(false);
    const [isFocused, setFocus] = (0, $lDSNw.useState)(false);
    const getHelpTextProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: helpTextId,
            ...props2,
            /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $dc32195927d0d802$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasHelpText(true);
            })
        }), [
        helpTextId
    ]);
    const getLabelProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            "data-focus": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isReadOnly),
            id: props2.id !== void 0 ? props2.id : labelId,
            htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
        }), [
        id,
        isDisabled,
        isFocused,
        isInvalid,
        isReadOnly,
        labelId
    ]);
    const getErrorMessageProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: feedbackId,
            ...props2,
            /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $dc32195927d0d802$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasFeedbackText(true);
            }),
            "aria-live": "polite"
        }), [
        feedbackId
    ]);
    const getRootProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ...htmlProps,
            ref: forwardedRef,
            role: "group"
        }), [
        htmlProps
    ]);
    const getRequiredIndicatorProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            role: "presentation",
            "aria-hidden": true,
            children: props2.children || "*"
        }), []);
    return {
        isRequired: !!isRequired,
        isInvalid: !!isInvalid,
        isReadOnly: !!isReadOnly,
        isDisabled: !!isDisabled,
        isFocused: !!isFocused,
        onFocus: ()=>setFocus(true),
        onBlur: ()=>setFocus(false),
        hasFeedbackText: hasFeedbackText,
        setHasFeedbackText: setHasFeedbackText,
        hasHelpText: hasHelpText,
        setHasHelpText: setHasHelpText,
        id: id,
        labelId: labelId,
        feedbackId: feedbackId,
        helpTextId: helpTextId,
        htmlProps: htmlProps,
        getHelpTextProps: getHelpTextProps,
        getErrorMessageProps: getErrorMessageProps,
        getRootProps: getRootProps,
        getLabelProps: getLabelProps,
        getRequiredIndicatorProps: getRequiredIndicatorProps
    };
}
var $cff529dd6c5b5069$export$fe5d99d8691b3f62 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function FormControl2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Form", props);
    const ownProps = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const { getRootProps: getRootProps, htmlProps: _, ...context } = $cff529dd6c5b5069$var$useFormControlProvider(ownProps);
    const className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-form-control", props.className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($cff529dd6c5b5069$var$FormControlProvider, {
        value: context,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($cff529dd6c5b5069$var$FormControlStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                ...getRootProps({}, ref),
                className: className,
                __css: styles["container"]
            })
        })
    });
});
$cff529dd6c5b5069$export$fe5d99d8691b3f62.displayName = "FormControl";
var $cff529dd6c5b5069$export$75f9ed82f6172e27 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function FormHelperText2(props, ref) {
    const field = $cff529dd6c5b5069$export$97a2352498389516();
    const styles = $cff529dd6c5b5069$export$2824197c2cd75b1e();
    const className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-form__helper-text", props.className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...field == null ? void 0 : field.getHelpTextProps(props, ref),
        __css: styles.helperText,
        className: className
    });
});
$cff529dd6c5b5069$export$75f9ed82f6172e27.displayName = "FormHelperText";





"use client";
var $ce8810ad1819f649$export$842aba50ed0ce9d7 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function FormLabel2(passedProps, ref) {
    var _a;
    const styles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("FormLabel", passedProps);
    const props = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(passedProps);
    const { className: className, children: children, requiredIndicator: requiredIndicator = /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($ce8810ad1819f649$export$b36d93bade3250e4, {}), optionalIndicator: optionalIndicator = null, ...rest } = props;
    const field = (0, $cff529dd6c5b5069$export$97a2352498389516)();
    const ownProps = (_a = field == null ? void 0 : field.getLabelProps(rest, ref)) != null ? _a : {
        ref: ref,
        ...rest
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).label, {
        ...ownProps,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-form__label", props.className),
        __css: {
            display: "block",
            textAlign: "start",
            ...styles
        },
        children: [
            children,
            (field == null ? void 0 : field.isRequired) ? requiredIndicator : optionalIndicator
        ]
    });
});
$ce8810ad1819f649$export$842aba50ed0ce9d7.displayName = "FormLabel";
var $ce8810ad1819f649$export$b36d93bade3250e4 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function RequiredIndicator2(props, ref) {
    const field = (0, $cff529dd6c5b5069$export$97a2352498389516)();
    const styles = (0, $cff529dd6c5b5069$export$2824197c2cd75b1e)();
    if (!(field == null ? void 0 : field.isRequired)) return null;
    const className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-form__required-indicator", props.className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        ...field == null ? void 0 : field.getRequiredIndicatorProps(props, ref),
        __css: styles.requiredIndicator,
        className: className
    });
});
$ce8810ad1819f649$export$b36d93bade3250e4.displayName = "RequiredIndicator";



"use client";
function $f51ab13b55b1484d$export$62ecd8ad1bbe1a18(props) {
    const { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, isRequired: isRequired, ...rest } = $f51ab13b55b1484d$export$1819803dd567b95f(props);
    return {
        ...rest,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        "aria-invalid": (0, $a223a0f4c9b3f9de$export$91a6105db3d4be7b)(isInvalid),
        "aria-required": (0, $a223a0f4c9b3f9de$export$91a6105db3d4be7b)(isRequired),
        "aria-readonly": (0, $a223a0f4c9b3f9de$export$91a6105db3d4be7b)(isReadOnly)
    };
}
function $f51ab13b55b1484d$export$1819803dd567b95f(props) {
    var _a, _b, _c;
    const field = (0, $cff529dd6c5b5069$export$97a2352498389516)();
    const { id: id, disabled: disabled, readOnly: readOnly, required: required, isRequired: isRequired, isInvalid: isInvalid, isReadOnly: isReadOnly, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, ...rest } = props;
    const labelIds = props["aria-describedby"] ? [
        props["aria-describedby"]
    ] : [];
    if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) labelIds.push(field.feedbackId);
    if (field == null ? void 0 : field.hasHelpText) labelIds.push(field.helpTextId);
    return {
        ...rest,
        "aria-describedby": labelIds.join(" ") || void 0,
        id: id != null ? id : field == null ? void 0 : field.id,
        isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
        isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
        isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
        isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
        onFocus: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onFocus, onFocus),
        onBlur: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onBlur, onBlur)
    };
}







"use client";
// src/visually-hidden.style.ts
var $d32f2509939c2ede$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0, 0, 0, 0)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};


const $18410bfe75a7cff5$export$9f57505b7bd8dae = ()=>typeof document !== "undefined";
function $18410bfe75a7cff5$export$867a782338812cb4() {
    const agent = navigator.userAgentData;
    return agent?.platform ?? navigator.platform;
}
const $18410bfe75a7cff5$var$pt = (v)=>$18410bfe75a7cff5$export$9f57505b7bd8dae() && v.test($18410bfe75a7cff5$export$867a782338812cb4());
const $18410bfe75a7cff5$var$ua = (v)=>$18410bfe75a7cff5$export$9f57505b7bd8dae() && v.test(navigator.userAgent);
const $18410bfe75a7cff5$var$vn = (v)=>$18410bfe75a7cff5$export$9f57505b7bd8dae() && v.test(navigator.vendor);
const $18410bfe75a7cff5$export$a1d0d20ee9546562 = ()=>$18410bfe75a7cff5$export$9f57505b7bd8dae() && !!navigator.maxTouchPoints;
const $18410bfe75a7cff5$export$9ac100e40613ea10 = ()=>$18410bfe75a7cff5$var$pt(/^Mac/) && !$18410bfe75a7cff5$export$a1d0d20ee9546562();
const $18410bfe75a7cff5$export$186c6964ca17d99 = ()=>$18410bfe75a7cff5$var$pt(/^iPhone/);
const $18410bfe75a7cff5$export$95df08bae54cb4df = ()=>$18410bfe75a7cff5$export$5231b1f790f5c149() && $18410bfe75a7cff5$var$vn(/apple/i);
const $18410bfe75a7cff5$export$b7d78993b74f766d = ()=>$18410bfe75a7cff5$var$ua(/firefox\//i);
const $18410bfe75a7cff5$export$5231b1f790f5c149 = ()=>$18410bfe75a7cff5$var$pt(/mac|iphone|ipad|ipod/i);
const $18410bfe75a7cff5$export$41a665f744414057 = ()=>$18410bfe75a7cff5$export$5231b1f790f5c149() && !$18410bfe75a7cff5$export$9ac100e40613ea10();


let $0a621fd10183d7e8$var$hasSetup = false;
let $0a621fd10183d7e8$var$modality = null;
let $0a621fd10183d7e8$var$hasEventBeforeFocus = false;
let $0a621fd10183d7e8$var$hasBlurredWindowRecently = false;
const $0a621fd10183d7e8$var$handlers = /* @__PURE__ */ new Set();
function $0a621fd10183d7e8$var$trigger(modality2, event) {
    $0a621fd10183d7e8$var$handlers.forEach((handler)=>handler(modality2, event));
}
const $0a621fd10183d7e8$var$isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;
function $0a621fd10183d7e8$var$isValidKey(e) {
    return !(e.metaKey || !$0a621fd10183d7e8$var$isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $0a621fd10183d7e8$var$onKeyboardEvent(event) {
    $0a621fd10183d7e8$var$hasEventBeforeFocus = true;
    if ($0a621fd10183d7e8$var$isValidKey(event)) {
        $0a621fd10183d7e8$var$modality = "keyboard";
        $0a621fd10183d7e8$var$trigger("keyboard", event);
    }
}
function $0a621fd10183d7e8$var$onPointerEvent(event) {
    $0a621fd10183d7e8$var$modality = "pointer";
    if (event.type === "mousedown" || event.type === "pointerdown") {
        $0a621fd10183d7e8$var$hasEventBeforeFocus = true;
        const target = event.composedPath ? event.composedPath()[0] : event.target;
        let matches = false;
        try {
            matches = target.matches(":focus-visible");
        } catch  {}
        if (matches) return;
        $0a621fd10183d7e8$var$trigger("pointer", event);
    }
}
function $0a621fd10183d7e8$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
function $0a621fd10183d7e8$var$onClickEvent(e) {
    if ($0a621fd10183d7e8$var$isVirtualClick(e)) {
        $0a621fd10183d7e8$var$hasEventBeforeFocus = true;
        $0a621fd10183d7e8$var$modality = "virtual";
    }
}
function $0a621fd10183d7e8$var$onWindowFocus(event) {
    if (event.target === window || event.target === document) return;
    if (!$0a621fd10183d7e8$var$hasEventBeforeFocus && !$0a621fd10183d7e8$var$hasBlurredWindowRecently) {
        $0a621fd10183d7e8$var$modality = "virtual";
        $0a621fd10183d7e8$var$trigger("virtual", event);
    }
    $0a621fd10183d7e8$var$hasEventBeforeFocus = false;
    $0a621fd10183d7e8$var$hasBlurredWindowRecently = false;
}
function $0a621fd10183d7e8$var$onWindowBlur() {
    $0a621fd10183d7e8$var$hasEventBeforeFocus = false;
    $0a621fd10183d7e8$var$hasBlurredWindowRecently = true;
}
function $0a621fd10183d7e8$var$isFocusVisible() {
    return $0a621fd10183d7e8$var$modality !== "pointer";
}
function $0a621fd10183d7e8$var$setupGlobalFocusEvents() {
    if (!(0, $18410bfe75a7cff5$export$9f57505b7bd8dae)() || $0a621fd10183d7e8$var$hasSetup) return;
    const { focus: focus } = HTMLElement.prototype;
    HTMLElement.prototype.focus = function focusElement(...args) {
        $0a621fd10183d7e8$var$hasEventBeforeFocus = true;
        focus.apply(this, args);
    };
    document.addEventListener("keydown", $0a621fd10183d7e8$var$onKeyboardEvent, true);
    document.addEventListener("keyup", $0a621fd10183d7e8$var$onKeyboardEvent, true);
    document.addEventListener("click", $0a621fd10183d7e8$var$onClickEvent, true);
    window.addEventListener("focus", $0a621fd10183d7e8$var$onWindowFocus, true);
    window.addEventListener("blur", $0a621fd10183d7e8$var$onWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $0a621fd10183d7e8$var$onPointerEvent, true);
        document.addEventListener("pointermove", $0a621fd10183d7e8$var$onPointerEvent, true);
        document.addEventListener("pointerup", $0a621fd10183d7e8$var$onPointerEvent, true);
    } else {
        document.addEventListener("mousedown", $0a621fd10183d7e8$var$onPointerEvent, true);
        document.addEventListener("mousemove", $0a621fd10183d7e8$var$onPointerEvent, true);
        document.addEventListener("mouseup", $0a621fd10183d7e8$var$onPointerEvent, true);
    }
    $0a621fd10183d7e8$var$hasSetup = true;
}
function $0a621fd10183d7e8$export$920b4983565c6f4d(fn) {
    $0a621fd10183d7e8$var$setupGlobalFocusEvents();
    fn($0a621fd10183d7e8$var$isFocusVisible());
    const handler = ()=>fn($0a621fd10183d7e8$var$isFocusVisible());
    $0a621fd10183d7e8$var$handlers.add(handler);
    return ()=>{
        $0a621fd10183d7e8$var$handlers.delete(handler);
    };
}
function $0a621fd10183d7e8$export$1238a82db5699f92(fn) {
    $0a621fd10183d7e8$var$setupGlobalFocusEvents();
    fn($0a621fd10183d7e8$var$modality);
    const handler = ()=>fn($0a621fd10183d7e8$var$modality);
    $0a621fd10183d7e8$var$handlers.add(handler);
    return ()=>{
        $0a621fd10183d7e8$var$handlers.delete(handler);
    };
}
function $0a621fd10183d7e8$export$8397ddfc504fdb9a(value) {
    $0a621fd10183d7e8$var$modality = value;
    $0a621fd10183d7e8$var$trigger(value, null);
}
function $0a621fd10183d7e8$export$630ff653c5ada6a9() {
    return $0a621fd10183d7e8$var$modality;
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
// ../../utilities/object-utils/src/omit.ts
function $a0176ee07c7c2984$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
function $a0176ee07c7c2984$export$e375f10ce42261c5(props = {}) {
    const formControlProps = (0, $f51ab13b55b1484d$export$1819803dd567b95f)(props);
    const { isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, isInvalid: isInvalid, id: id, onBlur: onBlur, onFocus: onFocus, "aria-describedby": ariaDescribedBy } = formControlProps;
    const { defaultChecked: defaultChecked, isChecked: checkedProp, isFocusable: isFocusable, onChange: onChange, isIndeterminate: isIndeterminate, name: name, value: value, tabIndex: tabIndex, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-invalid": ariaInvalid, ...rest } = props;
    const htmlProps = $a0176ee07c7c2984$var$omit(rest, [
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "isInvalid",
        "id",
        "onBlur",
        "onFocus",
        "aria-describedby"
    ]);
    const onChangeProp = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onChange);
    const onBlurProp = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onBlur);
    const onFocusProp = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onFocus);
    const [isFocusVisible, setIsFocusVisible] = (0, $lDSNw.useState)(false);
    const [isFocused, setFocused] = (0, $lDSNw.useState)(false);
    const [isHovered, setHovered] = (0, $lDSNw.useState)(false);
    const [isActive, setActive] = (0, $lDSNw.useState)(false);
    (0, $lDSNw.useEffect)(()=>{
        return (0, $0a621fd10183d7e8$export$920b4983565c6f4d)(setIsFocusVisible);
    }, []);
    const inputRef = (0, $lDSNw.useRef)(null);
    const [rootIsLabelElement, setRootIsLabelElement] = (0, $lDSNw.useState)(true);
    const [checkedState, setCheckedState] = (0, $lDSNw.useState)(!!defaultChecked);
    const isControlled = checkedProp !== void 0;
    const isChecked = isControlled ? checkedProp : checkedState;
    const handleChange = (0, $lDSNw.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) {
            if (isChecked) setCheckedState(event.target.checked);
            else setCheckedState(isIndeterminate ? true : event.target.checked);
        }
        onChangeProp == null || onChangeProp(event);
    }, [
        isReadOnly,
        isDisabled,
        isChecked,
        isControlled,
        isIndeterminate,
        onChangeProp
    ]);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (inputRef.current) inputRef.current.indeterminate = Boolean(isIndeterminate);
    }, [
        isIndeterminate
    ]);
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        if (isDisabled) setFocused(false);
    }, [
        isDisabled,
        setFocused
    ]);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        const el = inputRef.current;
        if (!(el == null ? void 0 : el.form)) return;
        const formResetListener = ()=>{
            setCheckedState(!!defaultChecked);
        };
        el.form.addEventListener("reset", formResetListener);
        return ()=>{
            var _a;
            return (_a = el.form) == null ? void 0 : _a.removeEventListener("reset", formResetListener);
        };
    }, []);
    const trulyDisabled = isDisabled && !isFocusable;
    const onKeyDown = (0, $lDSNw.useCallback)((event)=>{
        if (event.key === " ") setActive(true);
    }, [
        setActive
    ]);
    const onKeyUp = (0, $lDSNw.useCallback)((event)=>{
        if (event.key === " ") setActive(false);
    }, [
        setActive
    ]);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        const notInSync = inputRef.current.checked !== isChecked;
        if (notInSync) setCheckedState(inputRef.current.checked);
    }, [
        inputRef.current
    ]);
    const getCheckboxProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>{
        const onPressDown = (event)=>{
            if (isFocused) event.preventDefault();
            setActive(true);
        };
        return {
            ...props2,
            ref: forwardedRef,
            "data-active": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-indeterminate": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseDown, onPressDown),
            onMouseUp: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseUp, ()=>setActive(false)),
            onMouseEnter: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>setHovered(true)),
            onMouseLeave: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>setHovered(false))
        };
    }, [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isFocusVisible,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly
    ]);
    const getIndicatorProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            "data-active": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-indeterminate": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isReadOnly)
        }), [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isFocusVisible,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly
    ]);
    const getRootProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...htmlProps,
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setRootIsLabelElement(node.tagName === "LABEL");
            }),
            onClick: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onClick, ()=>{
                var _a;
                if (!rootIsLabelElement) {
                    (_a = inputRef.current) == null || _a.click();
                    requestAnimationFrame(()=>{
                        var _a2;
                        (_a2 = inputRef.current) == null || _a2.focus({
                            preventScroll: true
                        });
                    });
                }
            }),
            "data-disabled": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        htmlProps,
        isDisabled,
        isChecked,
        isInvalid,
        rootIsLabelElement
    ]);
    const getInputProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>{
        return {
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(inputRef, forwardedRef),
            type: "checkbox",
            name: name,
            value: value,
            id: id,
            tabIndex: tabIndex,
            onChange: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onChange, handleChange),
            onBlur: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onBlur, onBlurProp, ()=>setFocused(false)),
            onFocus: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onFocus, onFocusProp, ()=>setFocused(true)),
            onKeyDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onKeyUp: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onKeyUp, onKeyUp),
            required: isRequired,
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
            "aria-describedby": ariaDescribedBy,
            "aria-disabled": isDisabled,
            style: (0, $d32f2509939c2ede$export$8fecac46448b5689)
        };
    }, [
        name,
        value,
        id,
        handleChange,
        onBlurProp,
        onFocusProp,
        onKeyDown,
        onKeyUp,
        isRequired,
        isChecked,
        trulyDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        ariaInvalid,
        isInvalid,
        ariaDescribedBy,
        isDisabled,
        tabIndex
    ]);
    const getLabelProps = (0, $lDSNw.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            onMouseDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onMouseDown, $a0176ee07c7c2984$var$stopEvent),
            "data-disabled": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        isChecked,
        isDisabled,
        isInvalid
    ]);
    const state = {
        isInvalid: isInvalid,
        isFocused: isFocused,
        isChecked: isChecked,
        isActive: isActive,
        isHovered: isHovered,
        isIndeterminate: isIndeterminate,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired
    };
    return {
        state: state,
        getRootProps: getRootProps,
        getCheckboxProps: getCheckboxProps,
        getIndicatorProps: getIndicatorProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        htmlProps: htmlProps
    };
}
function $a0176ee07c7c2984$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}





var $lDSNw = parcelRequire("lDSNw");

"use client";
var $c0dd95528ddccc0c$export$b5d5cf8927ab7262 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Switch2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Switch", props);
    const { spacing: spacing = "0.5rem", children: children, ...ownProps } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const { getIndicatorProps: getIndicatorProps, getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getRootProps: getRootProps, getLabelProps: getLabelProps } = (0, $a0176ee07c7c2984$export$e375f10ce42261c5)(ownProps);
    const containerStyles = (0, $lDSNw.useMemo)(()=>({
            display: "inline-block",
            position: "relative",
            verticalAlign: "middle",
            lineHeight: 0,
            ...styles.container
        }), [
        styles.container
    ]);
    const trackStyles = (0, $lDSNw.useMemo)(()=>({
            display: "inline-flex",
            flexShrink: 0,
            justifyContent: "flex-start",
            boxSizing: "content-box",
            cursor: "pointer",
            ...styles.track
        }), [
        styles.track
    ]);
    const labelStyles = (0, $lDSNw.useMemo)(()=>({
            userSelect: "none",
            marginStart: spacing,
            ...styles.label
        }), [
        spacing,
        styles.label
    ]);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).label, {
        ...getRootProps(),
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-switch", props.className),
        __css: containerStyles,
        children: [
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("input", {
                className: "chakra-switch__input",
                ...getInputProps({}, ref)
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
                ...getCheckboxProps(),
                className: "chakra-switch__track",
                __css: trackStyles,
                children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
                    __css: styles.thumb,
                    className: "chakra-switch__thumb",
                    ...getIndicatorProps()
                })
            }),
            children && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
                className: "chakra-switch__label",
                ...getLabelProps(),
                __css: labelStyles,
                children: children
            })
        ]
    });
});
$c0dd95528ddccc0c$export$b5d5cf8927ab7262.displayName = "Switch";


const $054b67e2ceabb83e$var$GUI = ({ domainsList: domainsList = [], dwellTimes: dwellTimes, defaultBaseline: defaultBaseline, ...rest })=>{
    const showGUI = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.showGUI);
    const GUIToggle = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.GUIToggle);
    const minSequenceLength = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.minSequenceLength);
    const setMinSequenceLength = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setMinSequenceLength);
    // const showDwellTime = GUIStore((state) => state.showDwellTime);
    const setShowDwellTime = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setShowDwellTime);
    const startProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.startProgress);
    const endProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.endProgress);
    const setStartProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setStartProgress);
    const setEndProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setEndProgress);
    // const setDomainWhiteList = GUIStore((state) => state.setDomainWhiteList);
    const setBaselineOverride = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setBaselineOverride);
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const updateChart = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.updateChart);
    const showLegacyVideoChart = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.showLegacyVideoChart);
    const setShowLegacyVideoChart = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setShowLegacyVideoChart);
    const useLegacyBaseline = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.useLegacyBaseline);
    const setUseLegacyBaseline = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setUseLegacyBaseline);
    const videoFrames = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.videoFrames);
    const turnOffBaselineCompensation = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.turnOffBaselineCompensation);
    const setTurnOffBaselineCompensation = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setTurnOffBaselineCompensation);
    // userMetadata
    const [canViewDwellTime, setCanViewDwellTime] = (0, $lDSNw.useState)(false);
    const dwellTimeToggleHandler = (e)=>{
        (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).analytics().logEvent("gui_toggle_include_duration" + e);
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiAdjust("dwell_time", e);
        setShowDwellTime(e);
    };
    const scrubNumberHandler = ({ step: step })=>{
        (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).analytics().logEvent("plus");
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiAdjust("scrub_number", Math.sign(step) ? "plus" : "minus");
        setMinSequenceLength(minSequenceLength + step);
    };
    const startProgressHandler = ({ step: step })=>{
        (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).analytics().logEvent("plus");
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiAdjust("start_progress", Math.sign(step) ? "plus" : "minus");
        setStartProgress(startProgress + step);
    };
    const endProgressHandler = ({ step: step })=>{
        (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).analytics().logEvent("plus");
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiAdjust("end_progress", Math.sign(step) ? "plus" : "minus");
        setEndProgress(endProgress + step);
    };
    (0, $lDSNw.useEffect)(()=>{
        const matchingUser = (0, $fa80e68d246605f9$export$3a8aaff34855e439).filter((userMeta)=>{
            return userInfo.email.toLowerCase().includes(userMeta.email.toLowerCase()) || userMeta.email.toLowerCase().includes(userInfo.email.toLowerCase());
        });
        if (matchingUser.length) setCanViewDwellTime(!!matchingUser[0].team && (matchingUser[0].team === "CPT" || matchingUser[0].team === "design" || matchingUser[0].team === "staff"));
    }, [
        userInfo
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (showGUI) (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiPanel("open");
    }, [
        showGUI
    ]);
    const handleDomainWhitelistChange = (value)=>{
        const domain = value.target.value === domainOptions[0].label ? null : value.target.value;
        if (domain === null) return;
        updateChart(domainsList.find((d)=>d.domain === domain));
        // wanted to get sessions in here too but couldn't figure out how
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiDomainWhitelistChange(domain, window.location.href, false);
    };
    const handleBaselineChange = (value)=>{
        setBaselineOverride(value.target.value);
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).guiAdjust("baseline_filter", value.target.value);
    };
    const domainOptions = [
        {
            key: null,
            label: "All Domains"
        },
        ...domainsList.sort((a, b)=>b.sessionCount - a.sessionCount).map(({ domain: domain, sessionCount: sessionCount })=>({
                label: `${domain} (sessions: ${sessionCount})`,
                key: domain
            }))
    ];
    const hasVideo = videoFrames && Object.keys(videoFrames).length > 0;
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $16e7a7f9714a2a6b$export$c8598ceb51ca7025), {
        show: showGUI,
        onToggle: GUIToggle,
        ...rest,
        children: [
            domainsList && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                title: "Domain Filter",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$fa08ce9ad5cfed0), {
                    options: domainOptions,
                    defaultValue: domainOptions[0].label,
                    onChange: handleDomainWhitelistChange
                })
            }),
            hasVideo && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $lDSNw.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                        title: "Video - Switch to Legacy Chart",
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$409ddba4ba8fc5e), {
                            value: showLegacyVideoChart,
                            onChange: setShowLegacyVideoChart
                        })
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                        title: "Video - Use Legacy Baseline",
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$409ddba4ba8fc5e), {
                            value: useLegacyBaseline,
                            onChange: setUseLegacyBaseline
                        })
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                        title: "Video - Turn off baseline compensation",
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$409ddba4ba8fc5e), {
                            value: turnOffBaselineCompensation,
                            onChange: setTurnOffBaselineCompensation
                        })
                    })
                ]
            }, "video"),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                title: "Ad Progress Start",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$c6bde390f80b46d1), {
                    lowerbound: 0,
                    upperbound: 100,
                    currentValue: startProgress,
                    onChange: startProgressHandler,
                    step: 5
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                title: "Ad Progress End",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$c6bde390f80b46d1), {
                    lowerbound: 0,
                    upperbound: 100,
                    currentValue: endProgress,
                    onChange: endProgressHandler,
                    step: 5
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$e0d104a3bb02fa25), {
                title: "Show Dwell Time",
                children: canViewDwellTime && dwellTimes?.length ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$409ddba4ba8fc5e), {
                    onChange: dwellTimeToggleHandler
                }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
                    children: " No dwell times have loaded yet ... "
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $16e7a7f9714a2a6b$export$daec6fb4b8b794fe), {
                children: "*This is an experimental feature. None of the settings will be stored."
            })
        ]
    });
};
var $054b67e2ceabb83e$export$2e2bcd8739ae039 = $054b67e2ceabb83e$var$GUI;
const $054b67e2ceabb83e$var$LeftLabelSwitch = ({ id: id, label: label, isChecked: isChecked, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $cff529dd6c5b5069$export$fe5d99d8691b3f62), {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ce8810ad1819f649$export$842aba50ed0ce9d7), {
                fontWeight: 400,
                htmlFor: id,
                fontSize: "sm",
                mr: 3,
                mb: "0",
                children: label
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c0dd95528ddccc0c$export$b5d5cf8927ab7262), {
                id: id,
                size: "sm",
                colorScheme: "blackAlpha",
                isChecked: isChecked,
                onChange: (e)=>onChange && onChange(e.target.checked)
            })
        ]
    });
};







var $lDSNw = parcelRequire("lDSNw");
/**
 * @fileOverview Composed Chart
 */ 






var $lDSNw = parcelRequire("lDSNw");











var $cd596fa7fc5c5a32$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function $cd596fa7fc5c5a32$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cd596fa7fc5c5a32$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cd596fa7fc5c5a32$var$_typeof(obj);
}
function $cd596fa7fc5c5a32$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cd596fa7fc5c5a32$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cd596fa7fc5c5a32$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cd596fa7fc5c5a32$var$_extends() {
    $cd596fa7fc5c5a32$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd596fa7fc5c5a32$var$_extends.apply(this, arguments);
}
function $cd596fa7fc5c5a32$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cd596fa7fc5c5a32$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cd596fa7fc5c5a32$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cd596fa7fc5c5a32$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cd596fa7fc5c5a32$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cd596fa7fc5c5a32$var$_toConsumableArray(arr) {
    return $cd596fa7fc5c5a32$var$_arrayWithoutHoles(arr) || $cd596fa7fc5c5a32$var$_iterableToArray(arr) || $cd596fa7fc5c5a32$var$_unsupportedIterableToArray(arr) || $cd596fa7fc5c5a32$var$_nonIterableSpread();
}
function $cd596fa7fc5c5a32$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cd596fa7fc5c5a32$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cd596fa7fc5c5a32$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cd596fa7fc5c5a32$var$_arrayLikeToArray(o, minLen);
}
function $cd596fa7fc5c5a32$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cd596fa7fc5c5a32$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cd596fa7fc5c5a32$var$_arrayLikeToArray(arr);
}
function $cd596fa7fc5c5a32$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cd596fa7fc5c5a32$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cd596fa7fc5c5a32$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cd596fa7fc5c5a32$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $cd596fa7fc5c5a32$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cd596fa7fc5c5a32$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cd596fa7fc5c5a32$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $cd596fa7fc5c5a32$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $cd596fa7fc5c5a32$var$_setPrototypeOf(subClass, superClass);
}
function $cd596fa7fc5c5a32$var$_setPrototypeOf(o, p) {
    $cd596fa7fc5c5a32$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cd596fa7fc5c5a32$var$_setPrototypeOf(o, p);
}
function $cd596fa7fc5c5a32$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cd596fa7fc5c5a32$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cd596fa7fc5c5a32$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cd596fa7fc5c5a32$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cd596fa7fc5c5a32$var$_possibleConstructorReturn(this, result);
    };
}
function $cd596fa7fc5c5a32$var$_possibleConstructorReturn(self, call) {
    if (call && ($cd596fa7fc5c5a32$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $cd596fa7fc5c5a32$var$_assertThisInitialized(self);
}
function $cd596fa7fc5c5a32$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cd596fa7fc5c5a32$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cd596fa7fc5c5a32$var$_getPrototypeOf(o) {
    $cd596fa7fc5c5a32$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cd596fa7fc5c5a32$var$_getPrototypeOf(o);
}
function $cd596fa7fc5c5a32$var$_defineProperty(obj, key, value) {
    key = $cd596fa7fc5c5a32$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd596fa7fc5c5a32$var$_toPropertyKey(arg) {
    var key = $cd596fa7fc5c5a32$var$_toPrimitive(arg, "string");
    return $cd596fa7fc5c5a32$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cd596fa7fc5c5a32$var$_toPrimitive(input, hint) {
    if ($cd596fa7fc5c5a32$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cd596fa7fc5c5a32$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $cd596fa7fc5c5a32$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    $cd596fa7fc5c5a32$var$_inherits(Line, _PureComponent);
    var _super = $cd596fa7fc5c5a32$var$_createSuper(Line);
    function Line() {
        var _this;
        $cd596fa7fc5c5a32$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$var$_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0;; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($cd596fa7fc5c5a32$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($cd596fa7fc5c5a32$var$_toConsumableArray(Line.repeat(lines, count)), $cd596fa7fc5c5a32$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(", ");
        });
        $cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$var$_assertThisInitialized(_this), "id", (0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("recharts-line-"));
        $cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$var$_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $cd596fa7fc5c5a32$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $2f8a30b541520345$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(item, {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "bar-".concat(i),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $cd596fa7fc5c5a32$var$_objectSpread($cd596fa7fc5c5a32$var$_objectSpread($cd596fa7fc5c5a32$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $cd596fa7fc5c5a32$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $cd596fa7fc5c5a32$var$_objectWithoutProperties(_this$props3, $cd596fa7fc5c5a32$var$_excluded);
                var curveProps = $cd596fa7fc5c5a32$var$_objectSpread($cd596fa7fc5c5a32$var$_objectSpread($cd596fa7fc5c5a32$var$_objectSpread({}, (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: "none",
                    className: "recharts-line-curve",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1), $cd596fa7fc5c5a32$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $1f1c6c2214af1451$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $cd596fa7fc5c5a32$var$_objectSpread($cd596fa7fc5c5a32$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $cd596fa7fc5c5a32$var$_objectSpread($cd596fa7fc5c5a32$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $cd596fa7fc5c5a32$var$_objectSpread($cd596fa7fc5c5a32$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($accecf4f4d483c19$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-line", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $65af1a52cac4dd09$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $0c2a2118f871337c$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($cd596fa7fc5c5a32$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($cd596fa7fc5c5a32$var$_toConsumableArray(result), $cd596fa7fc5c5a32$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) dotItem = option(props);
                else {
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-line-dot", option ? option.className : "");
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $90ad9fc64491da49$export$d046b3c4a416f60d), $cd596fa7fc5c5a32$var$_extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, $lDSNw.PureComponent));
$cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$export$17d680238e50603e, "displayName", "Line");
$cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: "line",
    stroke: "#3182bd",
    strokeWidth: 1,
    fill: "#fff",
    points: [],
    isAnimationActive: !(0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease",
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $cd596fa7fc5c5a32$var$_defineProperty($cd596fa7fc5c5a32$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === "horizontal") return {
            x: (0, $ecbafd4b4677e0ac$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $ecbafd4b4677e0ac$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $cd596fa7fc5c5a32$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});






var $lDSNw = parcelRequire("lDSNw");






/**
 * @fileOverview Z Axis
 */ var $a2b54c20a64b9a75$export$2363a7fa7edfe988 = function ZAxis() {
    return null;
};
$a2b54c20a64b9a75$export$2363a7fa7edfe988.displayName = "ZAxis";
$a2b54c20a64b9a75$export$2363a7fa7edfe988.defaultProps = {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: "auto",
    type: "number"
};









function $b2c6e9297b87bf84$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b2c6e9297b87bf84$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b2c6e9297b87bf84$var$_typeof(obj);
}
function $b2c6e9297b87bf84$var$_extends() {
    $b2c6e9297b87bf84$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b2c6e9297b87bf84$var$_extends.apply(this, arguments);
}
function $b2c6e9297b87bf84$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b2c6e9297b87bf84$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b2c6e9297b87bf84$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b2c6e9297b87bf84$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b2c6e9297b87bf84$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b2c6e9297b87bf84$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b2c6e9297b87bf84$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b2c6e9297b87bf84$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b2c6e9297b87bf84$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b2c6e9297b87bf84$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b2c6e9297b87bf84$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b2c6e9297b87bf84$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b2c6e9297b87bf84$var$_setPrototypeOf(subClass, superClass);
}
function $b2c6e9297b87bf84$var$_setPrototypeOf(o, p) {
    $b2c6e9297b87bf84$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b2c6e9297b87bf84$var$_setPrototypeOf(o, p);
}
function $b2c6e9297b87bf84$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b2c6e9297b87bf84$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b2c6e9297b87bf84$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b2c6e9297b87bf84$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b2c6e9297b87bf84$var$_possibleConstructorReturn(this, result);
    };
}
function $b2c6e9297b87bf84$var$_possibleConstructorReturn(self, call) {
    if (call && ($b2c6e9297b87bf84$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b2c6e9297b87bf84$var$_assertThisInitialized(self);
}
function $b2c6e9297b87bf84$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b2c6e9297b87bf84$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b2c6e9297b87bf84$var$_getPrototypeOf(o) {
    $b2c6e9297b87bf84$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b2c6e9297b87bf84$var$_getPrototypeOf(o);
}
function $b2c6e9297b87bf84$var$_defineProperty(obj, key, value) {
    key = $b2c6e9297b87bf84$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b2c6e9297b87bf84$var$_toPropertyKey(arg) {
    var key = $b2c6e9297b87bf84$var$_toPrimitive(arg, "string");
    return $b2c6e9297b87bf84$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b2c6e9297b87bf84$var$_toPrimitive(input, hint) {
    if ($b2c6e9297b87bf84$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b2c6e9297b87bf84$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b2c6e9297b87bf84$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    $b2c6e9297b87bf84$var$_inherits(Scatter, _PureComponent);
    var _super = $b2c6e9297b87bf84$var$_createSuper(Scatter);
    function Scatter() {
        var _this;
        $b2c6e9297b87bf84$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b2c6e9297b87bf84$var$_defineProperty($b2c6e9297b87bf84$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $b2c6e9297b87bf84$var$_defineProperty($b2c6e9297b87bf84$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $b2c6e9297b87bf84$var$_defineProperty($b2c6e9297b87bf84$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $b2c6e9297b87bf84$var$_defineProperty($b2c6e9297b87bf84$var$_assertThisInitialized(_this), "id", (0, $aee02c7eefa94d8b$export$8b15d37bc3f197d4)("recharts-scatter-"));
        return _this;
    }
    $b2c6e9297b87bf84$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                return points.map(function(entry, i) {
                    var props = $b2c6e9297b87bf84$var$_objectSpread($b2c6e9297b87bf84$var$_objectSpread({
                        key: "symbol-".concat(i)
                    }, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), $b2c6e9297b87bf84$var$_extends({
                        className: "recharts-scatter-symbol"
                    }, (0, $f50c94b715022fe9$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        role: "img"
                    }), Scatter.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $1f1c6c2214af1451$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $b2c6e9297b87bf84$var$_objectSpread($b2c6e9297b87bf84$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $aee02c7eefa94d8b$export$d871d53bd7eeb390)(0, entry.size);
                        return $b2c6e9297b87bf84$var$_objectSpread($b2c6e9297b87bf84$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($accecf4f4d483c19$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(children, (0, $2f8a30b541520345$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var direction = item.props.direction;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(item, {
                        key: i,
                        // eslint-disable-line react/no-array-index-key
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === "x" ? "vertical" : "horizontal",
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === "x" ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(this.props);
                var customLineProps = (0, $65af1a52cac4dd09$export$d697c39a2985a4c)(line);
                var linePoints, lineItem;
                if (lineType === "joint") linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === "fitting") {
                    var _getLinearRegression = (0, $aee02c7eefa94d8b$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $b2c6e9297b87bf84$var$_objectSpread($b2c6e9297b87bf84$var$_objectSpread($b2c6e9297b87bf84$var$_objectSpread({}, scatterProps), {}, {
                    fill: "none",
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $4eefa9e1680e4ef8$export$b0e83c3ef8d2db1), $b2c6e9297b87bf84$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($f736a71bb7ffc367$exports)))("recharts-scatter", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $cf8cc3c87e97bf14$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $0c2a2118f871337c$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "renderSymbolItem",
            value: function renderSymbolItem(option, props) {
                var symbol;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).isValidElement(option)) symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($b12409ad867c77f5$exports)))(option)) symbol = option(props);
                else if (typeof option === "string") symbol = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lDSNw))).createElement((0, $dfbea7091b7a3eec$export$fa456266707bf4e4), $b2c6e9297b87bf84$var$_extends({}, props, {
                    type: option
                }));
                return symbol;
            }
        }
    ]);
    return Scatter;
}((0, $lDSNw.PureComponent));
$b2c6e9297b87bf84$var$_defineProperty($b2c6e9297b87bf84$export$1c460fb4285edadc, "displayName", "Scatter");
$b2c6e9297b87bf84$var$_defineProperty($b2c6e9297b87bf84$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: "circle",
    lineType: "joint",
    lineJointType: "linear",
    data: [],
    shape: "circle",
    hide: false,
    isAnimationActive: !(0, $cc2a040df4551157$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "linear"
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $b2c6e9297b87bf84$var$_defineProperty($b2c6e9297b87bf84$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $65af1a52cac4dd09$export$fdd5e64c0e8495bb)(item.props.children, (0, $1a0af961fe314d4f$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $a2b54c20a64b9a75$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(zAxisDataKey) && (0, $ecbafd4b4677e0ac$export$f97fc4a450f29a)(entry, zAxisDataKey) || "-";
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || "",
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($0a099db9feea9f1c$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || "",
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== "-") tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || "",
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $ecbafd4b4677e0ac$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $ecbafd4b4677e0ac$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== "-" ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $b2c6e9297b87bf84$var$_objectSpread($b2c6e9297b87bf84$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $b2c6e9297b87bf84$var$_objectSpread({
        points: points
    }, offset);
});






var $77d815ec488f9d85$export$f881f4f9e4007a57 = (0, $bc90a147d6e1cdb7$export$77871aede60e6838)({
    chartName: "ComposedChart",
    GraphicalChild: [
        (0, $cd596fa7fc5c5a32$export$17d680238e50603e),
        (0, $327c7a210e36e160$export$ea1a111407f37557),
        (0, $6ecebb08067248a7$export$bbc6c6369b38e3d1),
        (0, $b2c6e9297b87bf84$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $15dd4d13ef92156e$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $43d5f89303df56d7$export$f96c4024c52de8f4)
        },
        {
            axisType: "zAxis",
            AxisComp: (0, $a2b54c20a64b9a75$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $28de3275627d2ded$export$ece7de1383db5ac)
});



/**
 * Takes in the captured video sequence data and fills in
 * the gaps left by data not capturing at a fast enough
 * speed to fill the 0-100 progress array of a video
 * @param {array} sequence
 * @returns an array of length sequence.length
 */ var $a65e4c58a1e95f17$export$3ab96cd06322e36b;
const $a65e4c58a1e95f17$var$normalizeVideoSequence = (sequence)=>{
    if (sequence[0] === null) sequence[0] = 50;
    for(let i = 0; i < sequence.length; i++){
        let percentInView = sequence[i];
        if (percentInView === null) {
            let j = 1;
            let nextValue = sequence[i + j];
            while(nextValue === null){
                j++;
                if (i + j > 100) return sequence.map((value)=>value === null ? 0 : value);
                nextValue = sequence[i + j];
            }
            // when we hit the next number, we work back to fill in the gaps
            // get the difference between the last and next nonZero
            let differenceToFill = sequence[i + j] - sequence[i - 1];
            let increments = differenceToFill / (j + 1);
            for(let k = 0; k < j; k++)sequence[i + k] = Math.round(sequence[i - 1] + increments * (k + 1));
        }
    }
    return sequence;
};
$a65e4c58a1e95f17$export$3ab96cd06322e36b = $a65e4c58a1e95f17$var$normalizeVideoSequence;
const $a65e4c58a1e95f17$export$6beeef4e929bee30 = (incomingData, startProgress, endProgress)=>{
    if (!incomingData.length) return [];
    const dataClone = [
        ...incomingData
    ].slice(startProgress, endProgress);
    const sequenceMax = dataClone.reduce((prev, current)=>prev.playfulness > current.playfulness ? prev : current).playfulness;
    const sequenceMin = dataClone.reduce(function(prev, current) {
        return prev.playfulness < current.playfulness ? prev : current;
    }).playfulness;
    const baselineMax = dataClone.reduce((prev, current)=>prev.scrubBaseline > current.scrubBaseline ? prev : current).scrubBaseline;
    const baselineMin = dataClone.reduce(function(prev, current) {
        return prev.scrubBaseline < current.scrubBaseline ? prev : current;
    }).scrubBaseline;
    const max = Math.max(sequenceMax, baselineMax);
    const min = Math.min(sequenceMin, baselineMin);
    const gap = max - min;
    return dataClone.map((value)=>{
        const newValue = {
            ...value
        };
        if (value.playfulness >= min && value.playfulness <= max) newValue.playfulness = (value.playfulness - min) * (incomingData.length / gap);
        else if (value.playfulness > max) newValue.playfulness = 100;
        else newValue.playfulness = 0;
        if (value.scrubBaseline >= min && value.scrubBaseline <= max) newValue.scrubBaseline = (value.scrubBaseline - min) * (incomingData.length / gap);
        else if (value.scrubBaseline > max) newValue.scrubBaseline = 100;
        else newValue.scrubBaseline = 0;
        return newValue;
    });
};


const $58ce4ab6bb5823e6$var$DwellTimeChart = ({ adProgress: adProgress, data: data, startProgress: startProgress, endProgress: endProgress })=>{
    const dwellTimeRange = [
        10,
        1500
    ];
    const [actualData, setActualData] = (0, $lDSNw.useState)([]);
    const [baselineData, setBaselineData] = (0, $lDSNw.useState)([]);
    (0, $lDSNw.useEffect)(()=>{
        const normalizedData = (0, $a65e4c58a1e95f17$export$6beeef4e929bee30)(data, startProgress, endProgress);
        setActualData(normalizedData);
        const convertBaseline = normalizedData.map((value)=>{
            return {
                dwellTime: value.dwellTimeBaseline,
                playfulness: value.scrubBaseline,
                timeline: value.timeline
            };
        });
        setBaselineData(convertBaseline);
    }, [
        data,
        startProgress,
        endProgress
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                width: "100%",
                aspect: 5 / 3,
                maxHeight: 270,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $77d815ec488f9d85$export$f881f4f9e4007a57), {
                    margin: {
                        top: 0,
                        right: 10,
                        left: 50,
                        bottom: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                            stroke: "#e8e8e8",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                            dataKey: "timeline",
                            type: "number",
                            tickLine: true,
                            domain: [
                                startProgress,
                                endProgress
                            ],
                            allowDataOverflow: true,
                            axisLine: false,
                            ticks: [
                                "Scroll in",
                                "Scroll out"
                            ],
                            name: "Ad Progress"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                            dataKey: "playfulness",
                            hide: true,
                            name: "Ad Engagement",
                            allowDataOverflow: true
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a2b54c20a64b9a75$export$2363a7fa7edfe988), {
                            dataKey: "dwellTime",
                            range: dwellTimeRange,
                            name: "Avg Dwell Time",
                            unit: "ms",
                            scale: "time"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("linearGradient", {
                                id: "linear",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                        offset: "25%",
                                        stopColor: "rgba(255,138,63, 0.9)"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "rgba(254,0,96, 0.9)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b2c6e9297b87bf84$export$1c460fb4285edadc), {
                            name: "Dwell Time Baseline",
                            data: baselineData,
                            fill: "rgba(197,197,197,0.6)",
                            line: {
                                stroke: "#c5c5c5",
                                strokeWidth: 2
                            },
                            shape: "circle",
                            lineType: "joint"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b2c6e9297b87bf84$export$1c460fb4285edadc), {
                            name: "Dwell Time",
                            data: actualData,
                            fill: "url(#linear)",
                            line: {
                                stroke: "#8b9192",
                                strokeWidth: 2
                            },
                            shape: "circle",
                            lineType: "joint"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "scrubBaseline",
                            stroke: "#c5c5c5",
                            strokeWidth: 2,
                            fillOpacity: 0.1,
                            fill: "#c5c5c5",
                            isAnimationActive: false
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                            x: Math.round(adProgress),
                            fill: "#000",
                            stroke: "rgba(0,0,0,0.15)",
                            strokeWidth: "4px",
                            isFront: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $72ac3f8b3eb24366$export$4bae593ab138bf46), {}),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $ae26d2322f4678ff$export$57579a683bdd41d1), {
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ae26d2322f4678ff$export$57579a683bdd41d1).Scrub, {}),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ae26d2322f4678ff$export$57579a683bdd41d1).Dwelltime, {})
                ]
            })
        ]
    });
};
var $58ce4ab6bb5823e6$export$2e2bcd8739ae039 = $58ce4ab6bb5823e6$var$DwellTimeChart;








var $lDSNw = parcelRequire("lDSNw");



var $lDSNw = parcelRequire("lDSNw");



const $fccb2ff9c1d348a0$export$acaa6426d77a227e = ({ data: data, progress: progress, showBaseline: showBaseline = true, videoDuration: videoDuration, videoChange: videoChange, showLegacyVideoChart: showLegacyVideoChart })=>{
    const cursorPositionRef = (0, $lDSNw.useRef)(0);
    // -----------------------------------------------------
    // should be in presentation mode?
    const queryParams = new URLSearchParams(location.search);
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    // this is the URL param that is passed thorugh when gif-generator
    // is viewing the page to create a gif for the slide deck
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                position: "relative",
                justifyContent: "center",
                display: isPresentationMode ? "none" : "flex",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e6cc4722f36e6ae1$export$8332d5ac2ccf0d1e), {
                    text: "Video Stickiness",
                    tooltipText: `How well a video retained viewers when compared to the average for ${videoDuration} second videos.`
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                width: "100%",
                aspect: 5 / 3,
                maxHeight: isPresentationMode ? 500 : 270,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $77d815ec488f9d85$export$f881f4f9e4007a57), {
                    onClick: ()=>{
                        if (cursorPositionRef.current) videoChange(cursorPositionRef.current);
                    },
                    data: data,
                    margin: {
                        top: 20,
                        right: 10,
                        left: 50
                    },
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                            stroke: "#e8e8e8",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                            dataKey: "timeline",
                            type: "number",
                            tickLine: true,
                            domain: [
                                0.5,
                                99.5
                            ],
                            allowDataOverflow: true,
                            axisLine: false,
                            ticks: [
                                "Video start",
                                "Video end"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $deb1267103fb31f8$export$28c660c63b792dea), {
                            content: (props)=>{
                                if (!props.payload[0]?.payload?.timeline) return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {});
                                cursorPositionRef.current = props.payload[0]?.payload?.timeline;
                                return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {});
                            }
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("defs", {
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("linearGradient", {
                                    id: "linear",
                                    gradientTransform: "rotate(90)",
                                    children: [
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "25%",
                                            stopColor: "#00CE7C"
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "#4AC1E0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("linearGradient", {
                                    id: "linear2",
                                    gradientTransform: "rotate(90)",
                                    children: [
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "25%",
                                            stopColor: "#4AC1E0"
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                            offset: "100%",
                                            stopColor: "#00CE7C"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                            hide: true,
                            axisLine: false
                        }),
                        showLegacyVideoChart ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "inView",
                            stroke: "url(#linear)",
                            strokeWidth: 2,
                            isAnimationActive: false,
                            fill: "#ffffff00"
                        }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6ecebb08067248a7$export$bbc6c6369b38e3d1), {
                                    type: "monotone",
                                    dataKey: "difference",
                                    fill: "url(#linear)",
                                    isAnimationActive: false,
                                    children: data.map((entry, index)=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1a0af961fe314d4f$export$f6f0c3fe4ec306ea), {
                                            fill: entry.difference >= 0 ? "url(#linear2)" : "url(#linear)"
                                        }, `cell-${index}`))
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                                    y: 0,
                                    fill: "#000",
                                    stroke: "#c4c4c4",
                                    strokeWidth: "3px",
                                    isFront: true
                                })
                            ]
                        }),
                        showBaseline && showLegacyVideoChart && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $327c7a210e36e160$export$ea1a111407f37557), {
                            type: "monotone",
                            dataKey: "baseline",
                            stroke: "#c5c5c5",
                            strokeWidth: 2,
                            fillOpacity: 0.1,
                            fill: "#c5c5c5",
                            isAnimationActive: false
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                            x: progress,
                            fill: "#000",
                            stroke: "rgba(0,0,0,0.15)",
                            strokeWidth: "4px",
                            isFront: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $72ac3f8b3eb24366$export$4bae593ab138bf46), {
                top: "4",
                xAxisLabel: "" //"Video Progress"
                ,
                yAxisLabel: showLegacyVideoChart ? "Video Attention Rate (%)" : `Viewer Retention vs. ${videoDuration}sec Avg.`,
                bottomLeftLabel: "" //"Video start"
                ,
                bottomRightLabel: "" //"Video end"
            })
        ]
    });
};


"use client";
// ../../legacy/utils/src/dom.ts
var $7d90f0d51d02568c$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $7d90f0d51d02568c$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
var $7d90f0d51d02568c$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
// ../../legacy/utils/src/function.ts
function $7d90f0d51d02568c$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}


"use client";
// src/slider-utils.ts
function $80699df7ed538f20$export$24b60fe7179439bc(id) {
    return {
        root: `slider-root-${id}`,
        getThumb: (i)=>`slider-thumb-${id}-${i}`,
        getInput: (i)=>`slider-input-${id}-${i}`,
        track: `slider-track-${id}`,
        innerTrack: `slider-filled-track-${id}`,
        getMarker: (i)=>`slider-marker-${id}-${i}`,
        output: `slider-output-${id}`
    };
}
function $80699df7ed538f20$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
var $80699df7ed538f20$var$zeroSize = {
    width: 0,
    height: 0
};
var $80699df7ed538f20$var$normalize = (a)=>a || $80699df7ed538f20$var$zeroSize;
function $80699df7ed538f20$export$ffd58b7f6f099a57(options) {
    const { orientation: orientation, thumbPercents: thumbPercents, thumbRects: thumbRects, isReversed: isReversed } = options;
    const getThumbStyle = (i)=>{
        var _a;
        const rect = (_a = thumbRects[i]) != null ? _a : $80699df7ed538f20$var$zeroSize;
        return {
            position: "absolute",
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            touchAction: "none",
            ...$80699df7ed538f20$export$f3eec17ee6065eee({
                orientation: orientation,
                vertical: {
                    bottom: `calc(${thumbPercents[i]}% - ${rect.height / 2}px)`
                },
                horizontal: {
                    left: `calc(${thumbPercents[i]}% - ${rect.width / 2}px)`
                }
            })
        };
    };
    const size = orientation === "vertical" ? thumbRects.reduce((a, b)=>$80699df7ed538f20$var$normalize(a).height > $80699df7ed538f20$var$normalize(b).height ? a : b, $80699df7ed538f20$var$zeroSize) : thumbRects.reduce((a, b)=>$80699df7ed538f20$var$normalize(a).width > $80699df7ed538f20$var$normalize(b).width ? a : b, $80699df7ed538f20$var$zeroSize);
    const rootStyle = {
        position: "relative",
        touchAction: "none",
        WebkitTapHighlightColor: "rgba(0,0,0,0)",
        userSelect: "none",
        outline: 0,
        ...$80699df7ed538f20$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: size ? {
                paddingLeft: size.width / 2,
                paddingRight: size.width / 2
            } : {},
            horizontal: size ? {
                paddingTop: size.height / 2,
                paddingBottom: size.height / 2
            } : {}
        })
    };
    const trackStyle = {
        position: "absolute",
        ...$80699df7ed538f20$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: {
                left: "50%",
                transform: "translateX(-50%)",
                height: "100%"
            },
            horizontal: {
                top: "50%",
                transform: "translateY(-50%)",
                width: "100%"
            }
        })
    };
    const isSingleThumb = thumbPercents.length === 1;
    const fallback = [
        0,
        isReversed ? 100 - thumbPercents[0] : thumbPercents[0]
    ];
    const range = isSingleThumb ? fallback : thumbPercents;
    let start = range[0];
    if (!isSingleThumb && isReversed) start = 100 - start;
    const percent = Math.abs(range[range.length - 1] - range[0]);
    const innerTrackStyle = {
        ...trackStyle,
        ...$80699df7ed538f20$export$f3eec17ee6065eee({
            orientation: orientation,
            vertical: isReversed ? {
                height: `${percent}%`,
                top: `${start}%`
            } : {
                height: `${percent}%`,
                bottom: `${start}%`
            },
            horizontal: isReversed ? {
                width: `${percent}%`,
                right: `${start}%`
            } : {
                width: `${percent}%`,
                left: `${start}%`
            }
        })
    };
    return {
        trackStyle: trackStyle,
        innerTrackStyle: innerTrackStyle,
        rootStyle: rootStyle,
        getThumbStyle: getThumbStyle
    };
}
function $80699df7ed538f20$export$4cb40dd77883f9(options) {
    const { isReversed: isReversed, direction: direction, orientation: orientation } = options;
    if (direction === "ltr" || orientation === "vertical") return isReversed;
    return !isReversed;
}


// src/add-dom-event.ts
function $30a52b031d65328d$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}


// src/assertion.ts
function $0084ad16d1bba51e$export$764db16956f554f8(event) {
    const win = $0084ad16d1bba51e$export$8d16348623687f6(event);
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $0084ad16d1bba51e$export$c4dfce035d43d1e0(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}
function $0084ad16d1bba51e$export$d06464d6b74eedc4(event) {
    return $0084ad16d1bba51e$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}
function $0084ad16d1bba51e$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}


// src/get-event-point.ts
function $e0f42002cb8a7ed4$var$pointFromTouch(e, type = "page") {
    const point = e.touches[0] || e.changedTouches[0];
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
function $e0f42002cb8a7ed4$var$pointFromMouse(point, type = "page") {
    return {
        x: point[`${type}X`],
        y: point[`${type}Y`]
    };
}
function $e0f42002cb8a7ed4$export$a8637644cbd23a7b(event, type = "page") {
    return (0, $0084ad16d1bba51e$export$c4dfce035d43d1e0)(event) ? $e0f42002cb8a7ed4$var$pointFromTouch(event, type) : $e0f42002cb8a7ed4$var$pointFromMouse(event, type);
}



// src/add-pointer-event.ts
function $4a3fe6895a502611$var$filter(cb) {
    return (event)=>{
        const isMouse = (0, $0084ad16d1bba51e$export$764db16956f554f8)(event);
        if (!isMouse || isMouse && event.button === 0) cb(event);
    };
}
function $4a3fe6895a502611$var$wrap(cb, filterPrimary = false) {
    function listener(event) {
        cb(event, {
            point: (0, $e0f42002cb8a7ed4$export$a8637644cbd23a7b)(event)
        });
    }
    const fn = filterPrimary ? $4a3fe6895a502611$var$filter(listener) : listener;
    return fn;
}
function $4a3fe6895a502611$export$fcff2e64e6676b81(target, type, cb, options) {
    return (0, $30a52b031d65328d$export$b1d829ddf82884aa)(target, type, $4a3fe6895a502611$var$wrap(cb, type === "pointerdown"), options);
}


const $c0bf8085a5c1321b$export$f8caf8121275292d = 1 / 60 * 1000;
const $c0bf8085a5c1321b$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $c0bf8085a5c1321b$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($c0bf8085a5c1321b$var$getCurrentTime()), $c0bf8085a5c1321b$export$f8caf8121275292d);


function $d619c0a670dd45b1$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3c3477b7c3f59158$var$maxElapsed = 40;
let $3c3477b7c3f59158$var$useDefaultElapsed = true;
let $3c3477b7c3f59158$var$runNextFrame = false;
let $3c3477b7c3f59158$var$isProcessing = false;
const $3c3477b7c3f59158$var$frame = {
    delta: 0,
    timestamp: 0
};
const $3c3477b7c3f59158$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3c3477b7c3f59158$var$steps = $3c3477b7c3f59158$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $d619c0a670dd45b1$export$b995e5e85f5c8289)(()=>$3c3477b7c3f59158$var$runNextFrame = true);
    return acc;
}, {});
const $3c3477b7c3f59158$var$sync = $3c3477b7c3f59158$var$stepsOrder.reduce((acc, key)=>{
    const step = $3c3477b7c3f59158$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$3c3477b7c3f59158$var$runNextFrame) $3c3477b7c3f59158$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $3c3477b7c3f59158$export$d93e9c1fe0553512 = $3c3477b7c3f59158$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $3c3477b7c3f59158$var$steps[key].cancel;
    return acc;
}, {});
const $3c3477b7c3f59158$export$cd75ccfd720a3cd4 = $3c3477b7c3f59158$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$3c3477b7c3f59158$var$steps[key].process($3c3477b7c3f59158$var$frame);
    return acc;
}, {});
const $3c3477b7c3f59158$var$processStep = (stepId)=>$3c3477b7c3f59158$var$steps[stepId].process($3c3477b7c3f59158$var$frame);
const $3c3477b7c3f59158$var$processFrame = (timestamp)=>{
    $3c3477b7c3f59158$var$runNextFrame = false;
    $3c3477b7c3f59158$var$frame.delta = $3c3477b7c3f59158$var$useDefaultElapsed ? (0, $c0bf8085a5c1321b$export$f8caf8121275292d) : Math.max(Math.min(timestamp - $3c3477b7c3f59158$var$frame.timestamp, $3c3477b7c3f59158$var$maxElapsed), 1);
    $3c3477b7c3f59158$var$frame.timestamp = timestamp;
    $3c3477b7c3f59158$var$isProcessing = true;
    $3c3477b7c3f59158$var$stepsOrder.forEach($3c3477b7c3f59158$var$processStep);
    $3c3477b7c3f59158$var$isProcessing = false;
    if ($3c3477b7c3f59158$var$runNextFrame) {
        $3c3477b7c3f59158$var$useDefaultElapsed = false;
        (0, $c0bf8085a5c1321b$export$4fdea63ab5513fd5)($3c3477b7c3f59158$var$processFrame);
    }
};
const $3c3477b7c3f59158$var$startLoop = ()=>{
    $3c3477b7c3f59158$var$runNextFrame = true;
    $3c3477b7c3f59158$var$useDefaultElapsed = true;
    if (!$3c3477b7c3f59158$var$isProcessing) (0, $c0bf8085a5c1321b$export$4fdea63ab5513fd5)($3c3477b7c3f59158$var$processFrame);
};
const $3c3477b7c3f59158$export$7244445918e670ed = ()=>$3c3477b7c3f59158$var$frame;
var $3c3477b7c3f59158$export$2e2bcd8739ae039 = $3c3477b7c3f59158$var$sync;


"use client";
var $c429ae68af2fe326$var$__defProp = Object.defineProperty;
var $c429ae68af2fe326$var$__defNormalProp = (obj, key, value)=>key in obj ? $c429ae68af2fe326$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c429ae68af2fe326$var$__publicField = (obj, key, value)=>{
    $c429ae68af2fe326$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $c429ae68af2fe326$export$3a7c8887437719ed = class {
    constructor(event, handlers, threshold){
        /**
     * We use this to keep track of the `x` and `y` pan session history
     * as the pan event happens. It helps to calculate the `offset` and `delta`
     */ $c429ae68af2fe326$var$__publicField(this, "history", []);
        // The pointer event that started the pan session
        $c429ae68af2fe326$var$__publicField(this, "startEvent", null);
        // The current pointer event for the pan session
        $c429ae68af2fe326$var$__publicField(this, "lastEvent", null);
        // The current pointer event info for the pan session
        $c429ae68af2fe326$var$__publicField(this, "lastEventInfo", null);
        $c429ae68af2fe326$var$__publicField(this, "handlers", {});
        $c429ae68af2fe326$var$__publicField(this, "removeListeners", ()=>{});
        /**
     * Minimal pan distance required before recognizing the pan.
     * @default "3px"
     */ $c429ae68af2fe326$var$__publicField(this, "threshold", 3);
        $c429ae68af2fe326$var$__publicField(this, "win");
        $c429ae68af2fe326$var$__publicField(this, "updatePoint", ()=>{
            if (!(this.lastEvent && this.lastEventInfo)) return;
            const info = $c429ae68af2fe326$var$getPanInfo(this.lastEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            const isDistancePastThreshold = $c429ae68af2fe326$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { timestamp: timestamp } = (0, $3c3477b7c3f59158$export$7244445918e670ed)();
            this.history.push({
                ...info.point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart == null || onStart(this.lastEvent, info);
                this.startEvent = this.lastEvent;
            }
            onMove == null || onMove(this.lastEvent, info);
        });
        $c429ae68af2fe326$var$__publicField(this, "onPointerMove", (event, info)=>{
            this.lastEvent = event;
            this.lastEventInfo = info;
            (0, $3c3477b7c3f59158$export$2e2bcd8739ae039).update(this.updatePoint, true);
        });
        $c429ae68af2fe326$var$__publicField(this, "onPointerUp", (event, info)=>{
            const panInfo = $c429ae68af2fe326$var$getPanInfo(info, this.history);
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            this.end();
            if (!onEnd || !this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        });
        var _a;
        this.win = (_a = event.view) != null ? _a : window;
        if ((0, $0084ad16d1bba51e$export$d06464d6b74eedc4)(event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
        event.stopPropagation();
        event.preventDefault();
        const info = {
            point: (0, $e0f42002cb8a7ed4$export$a8637644cbd23a7b)(event)
        };
        const { timestamp: timestamp } = (0, $3c3477b7c3f59158$export$7244445918e670ed)();
        this.history = [
            {
                ...info.point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart == null || onSessionStart(event, $c429ae68af2fe326$var$getPanInfo(info, this.history));
        this.removeListeners = $c429ae68af2fe326$var$pipe((0, $4a3fe6895a502611$export$fcff2e64e6676b81)(this.win, "pointermove", this.onPointerMove), (0, $4a3fe6895a502611$export$fcff2e64e6676b81)(this.win, "pointerup", this.onPointerUp), (0, $4a3fe6895a502611$export$fcff2e64e6676b81)(this.win, "pointercancel", this.onPointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        var _a;
        (_a = this.removeListeners) == null || _a.call(this);
        (0, $3c3477b7c3f59158$export$d93e9c1fe0553512).update(this.updatePoint);
    }
};
function $c429ae68af2fe326$var$subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $c429ae68af2fe326$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $c429ae68af2fe326$var$subtract(info.point, history[history.length - 1]),
        offset: $c429ae68af2fe326$var$subtract(info.point, history[0]),
        velocity: $c429ae68af2fe326$var$getVelocity(history, 0.1)
    };
}
var $c429ae68af2fe326$var$toMilliseconds = (v)=>v * 1e3;
function $c429ae68af2fe326$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = history[history.length - 1];
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $c429ae68af2fe326$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
function $c429ae68af2fe326$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
function $c429ae68af2fe326$var$distance1D(a, b) {
    return Math.abs(a - b);
}
function $c429ae68af2fe326$var$isPoint(point) {
    return "x" in point && "y" in point;
}
function $c429ae68af2fe326$export$9f17032d917177de(a, b) {
    if (typeof a === "number" && typeof b === "number") return $c429ae68af2fe326$var$distance1D(a, b);
    if ($c429ae68af2fe326$var$isPoint(a) && $c429ae68af2fe326$var$isPoint(b)) {
        const xDelta = $c429ae68af2fe326$var$distance1D(a.x, b.x);
        const yDelta = $c429ae68af2fe326$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}




var $lDSNw = parcelRequire("lDSNw");
"use client";
function $da85c0157995e6ab$export$bcd07ba85a740103(value) {
    const ref = (0, $lDSNw.useRef)(null);
    ref.current = value;
    return ref;
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $bed78dd0a1344c24$export$9ad22d853bfe2640(ref, options) {
    const { onPan: onPan, onPanStart: onPanStart, onPanEnd: onPanEnd, onPanSessionStart: onPanSessionStart, onPanSessionEnd: onPanSessionEnd, threshold: threshold } = options;
    const hasPanEvents = Boolean(onPan || onPanStart || onPanEnd || onPanSessionStart || onPanSessionEnd);
    const panSession = (0, $lDSNw.useRef)(null);
    const handlersRef = (0, $da85c0157995e6ab$export$bcd07ba85a740103)({
        onSessionStart: onPanSessionStart,
        onSessionEnd: onPanSessionEnd,
        onStart: onPanStart,
        onMove: onPan,
        onEnd (event, info) {
            panSession.current = null;
            onPanEnd == null || onPanEnd(event, info);
        }
    });
    (0, $lDSNw.useEffect)(()=>{
        var _a;
        (_a = panSession.current) == null || _a.updateHandlers(handlersRef.current);
    });
    (0, $lDSNw.useEffect)(()=>{
        const node = ref.current;
        if (!node || !hasPanEvents) return;
        function onPointerDown(event) {
            panSession.current = new (0, $c429ae68af2fe326$export$3a7c8887437719ed)(event, handlersRef.current, threshold);
        }
        return (0, $4a3fe6895a502611$export$fcff2e64e6676b81)(node, "pointerdown", onPointerDown);
    }, [
        ref,
        hasPanEvents,
        handlersRef,
        threshold
    ]);
    (0, $lDSNw.useEffect)(()=>{
        return ()=>{
            var _a;
            (_a = panSession.current) == null || _a.end();
            panSession.current = null;
        };
    }, []);
}





var $lDSNw = parcelRequire("lDSNw");

"use client";
function $1c6446ce89a1d8f0$export$7301e09313e4cf1b(prop, state) {
    const controlled = typeof prop !== "undefined";
    const value = controlled ? prop : state;
    return (0, $lDSNw.useMemo)(()=>[
            controlled,
            value
        ], [
        controlled,
        value
    ]);
}
function $1c6446ce89a1d8f0$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(shouldUpdate);
    const [uncontrolledState, setUncontrolledState] = (0, $lDSNw.useState)(defaultValue);
    const controlled = valueProp !== void 0;
    const value = controlled ? valueProp : uncontrolledState;
    const setValue = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)((next)=>{
        const setter = next;
        const nextValue = typeof next === "function" ? setter(value) : next;
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!controlled) setUncontrolledState(nextValue);
        onChangeProp(nextValue);
    }, [
        controlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        setValue
    ];
}


function $84bbf86d3748d64d$export$6bfdefed991d4198(element, callback) {
    if (!element) {
        callback(void 0);
        return;
    }
    callback({
        width: element.offsetWidth,
        height: element.offsetHeight
    });
    const win = element.ownerDocument.defaultView ?? window;
    const observer = new win.ResizeObserver((entries)=>{
        if (!Array.isArray(entries) || !entries.length) return;
        const [entry] = entries;
        let width;
        let height;
        if ("borderBoxSize" in entry) {
            const borderSizeEntry = entry["borderBoxSize"];
            const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
            width = borderSize["inlineSize"];
            height = borderSize["blockSize"];
        } else {
            width = element.offsetWidth;
            height = element.offsetHeight;
        }
        callback({
            width: width,
            height: height
        });
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>observer.unobserve(element);
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
var $341d24bfa995ce91$var$useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $lDSNw.useLayoutEffect) : (0, $lDSNw.useEffect);
function $341d24bfa995ce91$var$trackMutation(el, cb) {
    var _a, _b;
    if (!el || !el.parentElement) return;
    const win = (_b = (_a = el.ownerDocument) == null ? void 0 : _a.defaultView) != null ? _b : window;
    const observer = new win.MutationObserver(()=>{
        cb();
    });
    observer.observe(el.parentElement, {
        childList: true
    });
    return ()=>{
        observer.disconnect();
    };
}
function $341d24bfa995ce91$export$b45c235b0389f404({ getNodes: getNodes, observeMutation: observeMutation = true }) {
    const [sizes, setSizes] = (0, $lDSNw.useState)([]);
    const [count, setCount] = (0, $lDSNw.useState)(0);
    $341d24bfa995ce91$var$useSafeLayoutEffect(()=>{
        const elements = getNodes();
        const cleanups = elements.map((element, index)=>(0, $84bbf86d3748d64d$export$6bfdefed991d4198)(element, (size)=>{
                setSizes((sizes2)=>{
                    return [
                        ...sizes2.slice(0, index),
                        size,
                        ...sizes2.slice(index + 1)
                    ];
                });
            }));
        if (observeMutation) {
            const firstNode = elements[0];
            cleanups.push($341d24bfa995ce91$var$trackMutation(firstNode, ()=>{
                setCount((count2)=>count2 + 1);
            }));
        }
        return ()=>{
            cleanups.forEach((cleanup)=>{
                cleanup == null || cleanup();
            });
        };
    }, [
        count
    ]);
    return sizes;
}
function $341d24bfa995ce91$var$isRef(ref) {
    return typeof ref === "object" && ref !== null && "current" in ref;
}
function $341d24bfa995ce91$export$1ab7ae714698c4b8(subject) {
    const [size] = $341d24bfa995ce91$export$b45c235b0389f404({
        observeMutation: false,
        getNodes () {
            const node = $341d24bfa995ce91$var$isRef(subject) ? subject.current : subject;
            return [
                node
            ];
        }
    });
    return size;
}




// src/index.ts
function $d941b61ab99338f5$var$toNumber(value) {
    const num = parseFloat(value);
    return typeof num !== "number" || Number.isNaN(num) ? 0 : num;
}
function $d941b61ab99338f5$export$3e91a10e66078270(value, precision) {
    let nextValue = $d941b61ab99338f5$var$toNumber(value);
    const scaleFactor = 10 ** (precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
function $d941b61ab99338f5$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    let e = 1;
    let p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
function $d941b61ab99338f5$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $d941b61ab99338f5$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
function $d941b61ab99338f5$export$3e1fe053092824a3(value, from, step) {
    const nextValue = Math.round((value - from) / step) * step + from;
    const precision = $d941b61ab99338f5$export$a42544f265f8403(step);
    return $d941b61ab99338f5$export$3e91a10e66078270(nextValue, precision);
}
function $d941b61ab99338f5$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    if (max < min) console.warn("clamp: max cannot be less than min");
    return Math.min(Math.max(value, min), max);
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
function $644c428fac9f8ef9$export$56b2c08e277f365(props) {
    var _a;
    const { min: min = 0, max: max = 100, onChange: onChange, value: valueProp, defaultValue: defaultValue, isReversed: isReversedProp, direction: direction = "ltr", orientation: orientation = "horizontal", id: idProp, isDisabled: isDisabled, isReadOnly: isReadOnly, onChangeStart: onChangeStartProp, onChangeEnd: onChangeEndProp, step: step = 1, getAriaValueText: getAriaValueTextProp, "aria-valuetext": ariaValueText, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, name: name, focusThumbOnChange: focusThumbOnChange = true, ...htmlProps } = props;
    const onChangeStart = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onChangeStartProp);
    const onChangeEnd = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onChangeEndProp);
    const getAriaValueText = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(getAriaValueTextProp);
    const isReversed = (0, $80699df7ed538f20$export$4cb40dd77883f9)({
        isReversed: isReversedProp,
        direction: direction,
        orientation: orientation
    });
    const [computedValue, setValue] = (0, $1c6446ce89a1d8f0$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue != null ? defaultValue : $644c428fac9f8ef9$var$getDefaultValue(min, max),
        onChange: onChange
    });
    const [isDragging, setDragging] = (0, $lDSNw.useState)(false);
    const [isFocused, setFocused] = (0, $lDSNw.useState)(false);
    const isInteractive = !(isDisabled || isReadOnly);
    const tenSteps = (max - min) / 10;
    const oneStep = step || (max - min) / 100;
    const value = (0, $d941b61ab99338f5$export$31ee16100cde6ce2)(computedValue, min, max);
    const reversedValue = max - value + min;
    const trackValue = isReversed ? reversedValue : value;
    const thumbPercent = (0, $d941b61ab99338f5$export$83ce4bc8280540e6)(trackValue, min, max);
    const isVertical = orientation === "vertical";
    const stateRef = (0, $da85c0157995e6ab$export$bcd07ba85a740103)({
        min: min,
        max: max,
        step: step,
        isDisabled: isDisabled,
        value: value,
        isInteractive: isInteractive,
        isReversed: isReversed,
        isVertical: isVertical,
        eventSource: null,
        focusThumbOnChange: focusThumbOnChange,
        orientation: orientation
    });
    const trackRef = (0, $lDSNw.useRef)(null);
    const thumbRef = (0, $lDSNw.useRef)(null);
    const rootRef = (0, $lDSNw.useRef)(null);
    const reactId = (0, $lDSNw.useId)();
    const uuid = idProp != null ? idProp : reactId;
    const [thumbId, trackId] = [
        `slider-thumb-${uuid}`,
        `slider-track-${uuid}`
    ];
    const getValueFromPointer = (0, $lDSNw.useCallback)((event)=>{
        var _a2, _b;
        if (!trackRef.current) return;
        const state2 = stateRef.current;
        state2.eventSource = "pointer";
        const trackRect = trackRef.current.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = (_b = (_a2 = event.touches) == null ? void 0 : _a2[0]) != null ? _b : event;
        const diff = isVertical ? trackRect.bottom - clientY : clientX - trackRect.left;
        const length = isVertical ? trackRect.height : trackRect.width;
        let percent = diff / length;
        if (isReversed) percent = 1 - percent;
        let nextValue = (0, $d941b61ab99338f5$export$7a6e99933c50b5b2)(percent, state2.min, state2.max);
        if (state2.step) nextValue = parseFloat((0, $d941b61ab99338f5$export$3e1fe053092824a3)(nextValue, state2.min, state2.step));
        nextValue = (0, $d941b61ab99338f5$export$31ee16100cde6ce2)(nextValue, state2.min, state2.max);
        return nextValue;
    }, [
        isVertical,
        isReversed,
        stateRef
    ]);
    const constrain = (0, $lDSNw.useCallback)((value2)=>{
        const state2 = stateRef.current;
        if (!state2.isInteractive) return;
        value2 = parseFloat((0, $d941b61ab99338f5$export$3e1fe053092824a3)(value2, state2.min, oneStep));
        value2 = (0, $d941b61ab99338f5$export$31ee16100cde6ce2)(value2, state2.min, state2.max);
        setValue(value2);
    }, [
        oneStep,
        setValue,
        stateRef
    ]);
    const actions = (0, $lDSNw.useMemo)(()=>({
            stepUp (step2 = oneStep) {
                const next = isReversed ? value - step2 : value + step2;
                constrain(next);
            },
            stepDown (step2 = oneStep) {
                const next = isReversed ? value + step2 : value - step2;
                constrain(next);
            },
            reset () {
                constrain(defaultValue || 0);
            },
            stepTo (value2) {
                constrain(value2);
            }
        }), [
        constrain,
        isReversed,
        value,
        oneStep,
        defaultValue
    ]);
    const onKeyDown = (0, $lDSNw.useCallback)((event)=>{
        const state2 = stateRef.current;
        const keyMap = {
            ArrowRight: ()=>actions.stepUp(),
            ArrowUp: ()=>actions.stepUp(),
            ArrowLeft: ()=>actions.stepDown(),
            ArrowDown: ()=>actions.stepDown(),
            PageUp: ()=>actions.stepUp(tenSteps),
            PageDown: ()=>actions.stepDown(tenSteps),
            Home: ()=>constrain(state2.min),
            End: ()=>constrain(state2.max)
        };
        const action = keyMap[event.key];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
            state2.eventSource = "keyboard";
        }
    }, [
        actions,
        constrain,
        tenSteps,
        stateRef
    ]);
    const valueText = (_a = getAriaValueText == null ? void 0 : getAriaValueText(value)) != null ? _a : ariaValueText;
    const thumbSize = (0, $341d24bfa995ce91$export$1ab7ae714698c4b8)(thumbRef);
    const { getThumbStyle: getThumbStyle, rootStyle: rootStyle, trackStyle: trackStyle, innerTrackStyle: innerTrackStyle } = (0, $lDSNw.useMemo)(()=>{
        const state2 = stateRef.current;
        const thumbRect = thumbSize != null ? thumbSize : {
            width: 0,
            height: 0
        };
        return (0, $80699df7ed538f20$export$ffd58b7f6f099a57)({
            isReversed: isReversed,
            orientation: state2.orientation,
            thumbRects: [
                thumbRect
            ],
            thumbPercents: [
                thumbPercent
            ]
        });
    }, [
        isReversed,
        thumbSize,
        thumbPercent,
        stateRef
    ]);
    const focusThumb = (0, $lDSNw.useCallback)(()=>{
        const state2 = stateRef.current;
        if (state2.focusThumbOnChange) setTimeout(()=>{
            var _a2;
            return (_a2 = thumbRef.current) == null ? void 0 : _a2.focus();
        });
    }, [
        stateRef
    ]);
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        const state2 = stateRef.current;
        focusThumb();
        if (state2.eventSource === "keyboard") onChangeEnd == null || onChangeEnd(state2.value);
    }, [
        value,
        onChangeEnd
    ]);
    function setValueFromPointer(event) {
        const nextValue = getValueFromPointer(event);
        if (nextValue != null && nextValue !== stateRef.current.value) setValue(nextValue);
    }
    (0, $bed78dd0a1344c24$export$9ad22d853bfe2640)(rootRef, {
        onPanSessionStart (event) {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setDragging(true);
            focusThumb();
            setValueFromPointer(event);
            onChangeStart == null || onChangeStart(state2.value);
        },
        onPanSessionEnd () {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setDragging(false);
            onChangeEnd == null || onChangeEnd(state2.value);
        },
        onPan (event) {
            const state2 = stateRef.current;
            if (!state2.isInteractive) return;
            setValueFromPointer(event);
        }
    });
    const getRootProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ...htmlProps,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, rootRef),
            tabIndex: -1,
            "aria-disabled": (0, $7d90f0d51d02568c$export$91a6105db3d4be7b)(isDisabled),
            "data-focused": (0, $7d90f0d51d02568c$export$5cc3b7b83e34ade7)(isFocused),
            style: {
                ...props2.style,
                ...rootStyle
            }
        };
    }, [
        htmlProps,
        isDisabled,
        isFocused,
        rootStyle
    ]);
    const getTrackProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, trackRef),
            id: trackId,
            "data-disabled": (0, $7d90f0d51d02568c$export$5cc3b7b83e34ade7)(isDisabled),
            style: {
                ...props2.style,
                ...trackStyle
            }
        };
    }, [
        isDisabled,
        trackId,
        trackStyle
    ]);
    const getInnerTrackProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            style: {
                ...props2.style,
                ...innerTrackStyle
            }
        };
    }, [
        innerTrackStyle
    ]);
    const getThumbProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, thumbRef),
            role: "slider",
            tabIndex: isInteractive ? 0 : void 0,
            id: thumbId,
            "data-active": (0, $7d90f0d51d02568c$export$5cc3b7b83e34ade7)(isDragging),
            "aria-valuetext": valueText,
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-orientation": orientation,
            "aria-disabled": (0, $7d90f0d51d02568c$export$91a6105db3d4be7b)(isDisabled),
            "aria-readonly": (0, $7d90f0d51d02568c$export$91a6105db3d4be7b)(isReadOnly),
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabel ? void 0 : ariaLabelledBy,
            style: {
                ...props2.style,
                ...getThumbStyle(0)
            },
            onKeyDown: (0, $7d90f0d51d02568c$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onFocus: (0, $7d90f0d51d02568c$export$5bdd3f730ec2c47e)(props2.onFocus, ()=>setFocused(true)),
            onBlur: (0, $7d90f0d51d02568c$export$5bdd3f730ec2c47e)(props2.onBlur, ()=>setFocused(false))
        };
    }, [
        isInteractive,
        thumbId,
        isDragging,
        valueText,
        min,
        max,
        value,
        orientation,
        isDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        getThumbStyle,
        onKeyDown
    ]);
    const getMarkerProps = (0, $lDSNw.useCallback)((props2, ref = null)=>{
        const isInRange = !(props2.value < min || props2.value > max);
        const isHighlighted = value >= props2.value;
        const markerPercent = (0, $d941b61ab99338f5$export$83ce4bc8280540e6)(props2.value, min, max);
        const markerStyle = {
            position: "absolute",
            pointerEvents: "none",
            ...$644c428fac9f8ef9$var$orient({
                orientation: orientation,
                vertical: {
                    bottom: isReversed ? `${100 - markerPercent}%` : `${markerPercent}%`
                },
                horizontal: {
                    left: isReversed ? `${100 - markerPercent}%` : `${markerPercent}%`
                }
            })
        };
        return {
            ...props2,
            ref: ref,
            role: "presentation",
            "aria-hidden": true,
            "data-disabled": (0, $7d90f0d51d02568c$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $7d90f0d51d02568c$export$5cc3b7b83e34ade7)(!isInRange),
            "data-highlighted": (0, $7d90f0d51d02568c$export$5cc3b7b83e34ade7)(isHighlighted),
            style: {
                ...props2.style,
                ...markerStyle
            }
        };
    }, [
        isDisabled,
        isReversed,
        max,
        min,
        orientation,
        value
    ]);
    const getInputProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>{
        return {
            ...props2,
            ref: ref,
            type: "hidden",
            value: value,
            name: name
        };
    }, [
        name,
        value
    ]);
    const state = {
        value: value,
        isFocused: isFocused,
        isDragging: isDragging
    };
    return {
        state: state,
        actions: actions,
        getRootProps: getRootProps,
        getTrackProps: getTrackProps,
        getInnerTrackProps: getInnerTrackProps,
        getThumbProps: getThumbProps,
        getMarkerProps: getMarkerProps,
        getInputProps: getInputProps
    };
}
function $644c428fac9f8ef9$var$orient(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
function $644c428fac9f8ef9$var$getDefaultValue(min, max) {
    return max < min ? min : min + (max - min) / 2;
}






"use client";
var [$0c7e57679d2cb40c$export$d1709061ba4d965f, $0c7e57679d2cb40c$export$65ed0685dbd65652] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: "SliderContext",
    hookName: "useSliderContext",
    providerName: "<Slider />"
});
var [$0c7e57679d2cb40c$var$SliderStylesProvider, $0c7e57679d2cb40c$export$8db8bb766e6e05f9] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `SliderStylesContext`,
    hookName: `useSliderStyles`,
    providerName: "<Slider />"
});
var $0c7e57679d2cb40c$export$472062a354075cee = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const sliderProps = {
        ...props,
        orientation: (_a = props == null ? void 0 : props.orientation) != null ? _a : "horizontal"
    };
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Slider", sliderProps);
    const ownProps = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(sliderProps);
    const { direction: direction } = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    ownProps.direction = direction;
    const { getInputProps: getInputProps, getRootProps: getRootProps, ...context } = (0, $644c428fac9f8ef9$export$56b2c08e277f365)(ownProps);
    const rootProps = getRootProps();
    const inputProps = getInputProps({}, ref);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($0c7e57679d2cb40c$export$d1709061ba4d965f, {
        value: context,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($0c7e57679d2cb40c$var$SliderStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                ...rootProps,
                className: (0, $7d90f0d51d02568c$export$a274e22fb40f762e)("chakra-slider", sliderProps.className),
                __css: styles.container,
                children: [
                    sliderProps.children,
                    /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("input", {
                        ...inputProps
                    })
                ]
            })
        })
    });
});
$0c7e57679d2cb40c$export$472062a354075cee.displayName = "Slider";
var $0c7e57679d2cb40c$export$2c1b491743890dec = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { getThumbProps: getThumbProps } = $0c7e57679d2cb40c$export$65ed0685dbd65652();
    const styles = $0c7e57679d2cb40c$export$8db8bb766e6e05f9();
    const thumbProps = getThumbProps(props, ref);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...thumbProps,
        className: (0, $7d90f0d51d02568c$export$a274e22fb40f762e)("chakra-slider__thumb", props.className),
        __css: styles.thumb
    });
});
$0c7e57679d2cb40c$export$2c1b491743890dec.displayName = "SliderThumb";
var $0c7e57679d2cb40c$export$105594979f116971 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { getTrackProps: getTrackProps } = $0c7e57679d2cb40c$export$65ed0685dbd65652();
    const styles = $0c7e57679d2cb40c$export$8db8bb766e6e05f9();
    const trackProps = getTrackProps(props, ref);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: (0, $7d90f0d51d02568c$export$a274e22fb40f762e)("chakra-slider__track", props.className),
        __css: styles.track
    });
});
$0c7e57679d2cb40c$export$105594979f116971.displayName = "SliderTrack";
var $0c7e57679d2cb40c$export$73137d74280e0c3e = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { getInnerTrackProps: getInnerTrackProps } = $0c7e57679d2cb40c$export$65ed0685dbd65652();
    const styles = $0c7e57679d2cb40c$export$8db8bb766e6e05f9();
    const trackProps = getInnerTrackProps(props, ref);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...trackProps,
        className: (0, $7d90f0d51d02568c$export$a274e22fb40f762e)("chakra-slider__filled-track", props.className),
        __css: styles.filledTrack
    });
});
$0c7e57679d2cb40c$export$73137d74280e0c3e.displayName = "SliderFilledTrack";
var $0c7e57679d2cb40c$export$6f85f6a3c5da6f62 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { getMarkerProps: getMarkerProps } = $0c7e57679d2cb40c$export$65ed0685dbd65652();
    const styles = $0c7e57679d2cb40c$export$8db8bb766e6e05f9();
    const markProps = getMarkerProps(props, ref);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...markProps,
        className: (0, $7d90f0d51d02568c$export$a274e22fb40f762e)("chakra-slider__marker", props.className),
        __css: styles.mark
    });
});
$0c7e57679d2cb40c$export$6f85f6a3c5da6f62.displayName = "SliderMark";






"use client";
var $59dff7172c56c932$export$1a94f80a613efc3a = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function NativeImage2(props, ref) {
    const { htmlWidth: htmlWidth, htmlHeight: htmlHeight, alt: alt, ...rest } = props;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
        width: htmlWidth,
        height: htmlHeight,
        ref: ref,
        alt: alt,
        ...rest
    });
});
$59dff7172c56c932$export$1a94f80a613efc3a.displayName = "NativeImage";




var $lDSNw = parcelRequire("lDSNw");
"use client";
function $182222eadb1df6a4$export$e4da99f09da8b739(props) {
    const { loading: loading, src: src, srcSet: srcSet, onLoad: onLoad, onError: onError, crossOrigin: crossOrigin, sizes: sizes, ignoreFallback: ignoreFallback } = props;
    const [status, setStatus] = (0, $lDSNw.useState)("pending");
    (0, $lDSNw.useEffect)(()=>{
        setStatus(src ? "loading" : "pending");
    }, [
        src
    ]);
    const imageRef = (0, $lDSNw.useRef)();
    const load = (0, $lDSNw.useCallback)(()=>{
        if (!src) return;
        flush();
        const img = new Image();
        img.src = src;
        if (crossOrigin) img.crossOrigin = crossOrigin;
        if (srcSet) img.srcset = srcSet;
        if (sizes) img.sizes = sizes;
        if (loading) img.loading = loading;
        img.onload = (event)=>{
            flush();
            setStatus("loaded");
            onLoad == null || onLoad(event);
        };
        img.onerror = (error)=>{
            flush();
            setStatus("failed");
            onError == null || onError(error);
        };
        imageRef.current = img;
    }, [
        src,
        crossOrigin,
        srcSet,
        sizes,
        onLoad,
        onError,
        loading
    ]);
    const flush = ()=>{
        if (imageRef.current) {
            imageRef.current.onload = null;
            imageRef.current.onerror = null;
            imageRef.current = null;
        }
    };
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (ignoreFallback) return void 0;
        if (status === "loading") load();
        return ()=>{
            flush();
        };
    }, [
        status,
        load,
        ignoreFallback
    ]);
    return ignoreFallback ? "loaded" : status;
}
var $182222eadb1df6a4$export$b80814126d314dea = (status, fallbackStrategy)=>status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";




"use client";
// ../../utilities/object-utils/src/omit.ts
function $c83c2faef81a6f1a$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
var $c83c2faef81a6f1a$export$3e431a229df88919 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Image2(props, ref) {
    const { fallbackSrc: fallbackSrc, fallback: fallback, src: src, srcSet: srcSet, align: align, fit: fit, loading: loading, ignoreFallback: ignoreFallback, crossOrigin: crossOrigin, fallbackStrategy: fallbackStrategy = "beforeLoadOrError", referrerPolicy: referrerPolicy, ...rest } = props;
    const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
    const shouldIgnoreFallbackImage = loading != null || // use can opt out of fallback image
    ignoreFallback || // if the user doesn't provide any kind of fallback we should ignore it
    !providedFallback;
    const status = (0, $182222eadb1df6a4$export$e4da99f09da8b739)({
        ...props,
        crossOrigin: crossOrigin,
        ignoreFallback: shouldIgnoreFallbackImage
    });
    const showFallbackImage = (0, $182222eadb1df6a4$export$b80814126d314dea)(status, fallbackStrategy);
    const shared = {
        ref: ref,
        objectFit: fit,
        objectPosition: align,
        ...shouldIgnoreFallbackImage ? rest : $c83c2faef81a6f1a$var$omit(rest, [
            "onError",
            "onLoad"
        ])
    };
    if (showFallbackImage) {
        if (fallback) return fallback;
        return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).img, {
            as: (0, $59dff7172c56c932$export$1a94f80a613efc3a),
            className: "chakra-image__placeholder",
            src: fallbackSrc,
            ...shared
        });
    }
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).img, {
        as: (0, $59dff7172c56c932$export$1a94f80a613efc3a),
        src: src,
        srcSet: srcSet,
        crossOrigin: crossOrigin,
        loading: loading,
        referrerPolicy: referrerPolicy,
        className: "chakra-image",
        ...shared
    });
});
$c83c2faef81a6f1a$export$3e431a229df88919.displayName = "Image";





"use client";
var [$69ca21f7af981501$var$TagStylesProvider, $69ca21f7af981501$export$fa5e32657e7ee8a0] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `TagStylesContext`,
    errorMessage: `useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tag />" `
});
var $69ca21f7af981501$export$3288d34c523a1192 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Tag", props);
    const ownProps = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const containerStyles = {
        display: "inline-flex",
        verticalAlign: "top",
        alignItems: "center",
        maxWidth: "100%",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($69ca21f7af981501$var$TagStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
            ref: ref,
            ...ownProps,
            __css: containerStyles
        })
    });
});
$69ca21f7af981501$export$3288d34c523a1192.displayName = "Tag";
var $69ca21f7af981501$export$f5486329f0fd0847 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const styles = $69ca21f7af981501$export$fa5e32657e7ee8a0();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        ref: ref,
        noOfLines: 1,
        ...props,
        __css: styles.label
    });
});
$69ca21f7af981501$export$f5486329f0fd0847.displayName = "TagLabel";
var $69ca21f7af981501$export$1b1a9388acf57360 = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        ref: ref,
        verticalAlign: "top",
        marginEnd: "0.5rem",
        ...props
    }));
$69ca21f7af981501$export$1b1a9388acf57360.displayName = "TagLeftIcon";
var $69ca21f7af981501$export$469b69b26b54518e = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        ref: ref,
        verticalAlign: "top",
        marginStart: "0.5rem",
        ...props
    }));
$69ca21f7af981501$export$469b69b26b54518e.displayName = "TagRightIcon";
var $69ca21f7af981501$var$TagCloseIcon = (props)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        verticalAlign: "inherit",
        viewBox: "0 0 512 512",
        ...props,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
        })
    });
$69ca21f7af981501$var$TagCloseIcon.displayName = "TagCloseIcon";
var $69ca21f7af981501$export$2c1e51182f03e1ee = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { isDisabled: isDisabled, children: children, ...rest } = props;
    const styles = $69ca21f7af981501$export$fa5e32657e7ee8a0();
    const btnStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: "0",
        ...styles.closeButton
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).button, {
        ref: ref,
        "aria-label": "close",
        ...rest,
        type: "button",
        disabled: isDisabled,
        __css: btnStyles,
        children: children || /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($69ca21f7af981501$var$TagCloseIcon, {})
    });
});
$69ca21f7af981501$export$2c1e51182f03e1ee.displayName = "TagCloseButton";




var $lDSNw = parcelRequire("lDSNw");


// using zustand to create a store for the aspect ratio of the video thumbnails
// as the video is not loaded again we need to store the aspect ratio of the video
const $b29bc0d3968c1dde$var$useVideoLocal = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set)=>({
        aspectRatio: 6.734177215189874,
        setAspectRatio: (aspectRatio)=>set({
                aspectRatio: aspectRatio
            })
    }));
const $b29bc0d3968c1dde$export$c8beed618d2f74c8 = ({ videoUrl: videoUrl, videoDuration: videoDuration })=>{
    const videoRef = (0, $lDSNw.useRef)();
    const canvasRef = (0, $lDSNw.useRef)();
    const framesRef = (0, $lDSNw.useRef)(videoDuration ? new Array(videoDuration) : []); // TODO - this is a hack to get around the fact that videoDuration is not available on first render FIXME
    const videoFrames = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.videoFrames);
    const setVideoFrames = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.setVideoFrames);
    // used to set the aspect ratio of container to match the video thumbnails aspect ratio
    const aspectRatio = $b29bc0d3968c1dde$var$useVideoLocal((state)=>state.aspectRatio);
    const setAspectRatio = $b29bc0d3968c1dde$var$useVideoLocal((state)=>state.setAspectRatio);
    (0, $lDSNw.useEffect)(()=>{
        if (videoFrames[videoUrl]) return;
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        video.crossOrigin = "anonymous";
        video.addEventListener("loadedmetadata", ()=>{
            // Set canvas dimensions equal to video dimensions
            // 1 thumb per seconds
            const thumbsTotal = Math.floor(video.duration);
            canvas.width = video.videoWidth / 6;
            canvas.height = video.videoHeight / 6;
            // Set the aspect ratio of the canvas to match the video thumbnails
            // also set height to 2x as the hover effect will double the size
            const thumbAreaRatio = canvas.width * thumbsTotal / (canvas.height * 2);
            if (aspectRatio !== thumbAreaRatio) setAspectRatio(thumbAreaRatio);
            let i = 0;
            video.addEventListener("seeked", async ()=>{
                // Draw the current frame of the video onto the canvas
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                // Convert the canvas image to a data URL and store it
                framesRef.current[i] = canvas.toDataURL();
                i++;
                if (i < Math.floor(video.duration)) {
                    // Seek to the next second of the video
                    video.currentTime = i;
                    setVideoFrames({
                        [videoUrl]: framesRef.current
                    });
                }
            });
            // Start the frame extraction process
            video.currentTime = i;
        });
    }, [
        videoUrl
    ]);
    // -----------------------------------------------------
    // should be in presentation mode?
    const queryParams = new URLSearchParams(location.search);
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    // this is the URL param that is passed thorugh when gif-generator
    // is viewing the page to create a gif for the slide deck
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        id: "video-frames",
        position: "relative",
        aspectRatio: aspectRatio,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("video", {
                ref: videoRef,
                src: videoUrl,
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                pos: "absolute",
                width: "100%",
                bg: "gray.100",
                borderRadius: "0 0 5px 5px",
                maxH: "130px",
                children: videoFrames[videoUrl] && videoFrames[videoUrl].map((frameUrl, index)=>{
                    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 0.8
                        },
                        whileHover: {
                            scale: 1.4,
                            zIndex: 2,
                            opacity: 1,
                            duration: 0.5
                        },
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            transformOrigin: "top center",
                            position: "relative",
                            width: `${100 / videoDuration}%`
                        },
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $69ca21f7af981501$export$3288d34c523a1192), {
                                fontSize: isPresentationMode ? "24px" : "sm",
                                colorScheme: "gray",
                                px: isPresentationMode ? "1.5" : "1",
                                position: "absolute",
                                top: "0",
                                zIndex: "1",
                                children: [
                                    index,
                                    "s"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
                                borderLeft: "2px solid black",
                                height: "100%",
                                src: frameUrl,
                                alt: `Frame ${index + 1}`,
                                borderRadius: "sm",
                                boxShadow: "sm",
                                placeholder: "blur"
                            }, index)
                        ]
                    }, `frame-${index + 1}`);
                })
            })
        ]
    });
};



const $4b332390c9f221f8$var$SingleVideoChart = ({ showBaseline: showBaseline = false, iframeVideo: iframeVideo = null, videoSequences: videoSequences, videoDropOffBaseline: videoDropOffBaseline = Array.from({
    length: 101
}, ()=>0), byDurationVideoDropOffBaselines: byDurationVideoDropOffBaselines = null })=>{
    const iframeVideoProgress = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.iframeVideoProgress);
    const setIframeVideoProgress = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.setIframeVideoProgress);
    const showLegacyVideoChart = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.showLegacyVideoChart);
    const useLegacyBaseline = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.useLegacyBaseline);
    const turnOffBaselineCompensation = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.turnOffBaselineCompensation);
    const [videoIsPlaying, setVideoIsPlaying] = (0, $lDSNw.useState)(true);
    const videoRangeChange = (event)=>{
        setIframeVideoProgress(event.target.value);
        let newTime = iframeVideo.duration / 100 * event.target.value;
        if (newTime) iframeVideo.currentTime = newTime;
    };
    (0, $lDSNw.useEffect)(()=>{
        const isPlaying = (0, $f93c997b56f0c027$export$1bcd6871fa54402c)(iframeVideo);
        setVideoIsPlaying(isPlaying);
    }, [
        iframeVideo,
        (0, $f93c997b56f0c027$export$1bcd6871fa54402c)(iframeVideo)
    ]);
    function percentChange(oldValue, newValue) {
        let change = newValue - oldValue;
        let percentChange = change / oldValue * 100;
        return percentChange;
    }
    const videoUrl = iframeVideo ? iframeVideo.getElementsByTagName("source")[0].src : null;
    const videoDuration = iframeVideo ? Math.floor(iframeVideo.duration) : null;
    const formatForChart = (data, key, baseline)=>{
        if (!data[key].length) return;
        return data[key].map((value, index)=>{
            return {
                inView: value,
                timeline: index,
                baseline: baseline[index],
                difference: percentChange(baseline[index], value) // value - baseline[index] 👈🏻 value to use for straight difference
            };
        });
    };
    function findClosest(target, arr, key) {
        return arr.reduce((prev, curr)=>Math.abs(curr[key] - target) < Math.abs(prev[key] - target) ? curr : prev);
    }
    let chartData = (0, $lDSNw.useMemo)(()=>{
        if (!byDurationVideoDropOffBaselines || byDurationVideoDropOffBaselines.length === 0) return;
        // get closest baseline
        const videoBaseline = findClosest(videoDuration, byDurationVideoDropOffBaselines, "duration");
        // here we're reducing the video baseline
        // the amount we reduce it by increases as the index increases slightly
        const modifiedDropoffBaseline = videoBaseline.videoDropOff.map((value, index)=>{
            const clampedIndex = Math.min(index, 50);
            const modifier = 1 - clampedIndex / 100 * 0.2;
            return value * modifier;
        });
        let baselineToFormat = modifiedDropoffBaseline;
        if (turnOffBaselineCompensation) baselineToFormat = videoBaseline.videoDropOff;
        if (useLegacyBaseline) baselineToFormat = videoDropOffBaseline;
        return formatForChart(videoSequences, "videoDropOffSequence", baselineToFormat // videoDropOffBaseline 👈🏻 old baseline array
        );
    }, [
        videoSequences["videoDropOffSequence"],
        byDurationVideoDropOffBaselines,
        useLegacyBaseline,
        turnOffBaselineCompensation
    ]);
    // -----------------------------------------------------
    // should be in presentation mode?
    const queryParams = new URLSearchParams(location.search);
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    // this is the URL param that is passed thorugh when gif-generator
    // is viewing the page to create a gif for the slide deck
    // console.log('SingleVideoChart.js: isPresentationMode:', isPresentationMode);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $fccb2ff9c1d348a0$export$acaa6426d77a227e), {
                id: "SingleVideoChart",
                data: chartData,
                progress: iframeVideoProgress,
                showBaseline: showBaseline,
                videoDuration: videoDuration,
                videoChange: (val)=>videoRangeChange({
                        target: {
                            value: val
                        }
                    }),
                showLegacyVideoChart: showLegacyVideoChart
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                marginLeft: "10px",
                marginRight: "6px",
                direction: "column",
                marginTop: "-66px",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                            opacity: isPresentationMode ? "0" : "1",
                            size: "sm",
                            isRound: true,
                            variant: "ghost",
                            icon: videoIsPlaying ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$816d9082b987955a), {
                                size: "20px"
                            }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$7cb7bf01cf98523), {
                                size: "20px"
                            }),
                            onClick: ()=>{
                                videoIsPlaying ? iframeVideo.pause() : iframeVideo.play();
                                setVideoIsPlaying(!videoIsPlaying);
                            }
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                            direction: "column",
                            marginLeft: "5px",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0c7e57679d2cb40c$export$472062a354075cee), {
                                    value: iframeVideoProgress,
                                    onChange: (val)=>videoRangeChange({
                                            target: {
                                                value: val
                                            }
                                        }),
                                    colorScheme: "blackAlpha",
                                    mt: "9px",
                                    mb: "0",
                                    children: [
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$105594979f116971), {
                                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$73137d74280e0c3e), {
                                                id: "imagesVideo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$2c1b491743890dec), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                    width: "100%",
                                    position: "relative",
                                    mt: "-5px",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b29bc0d3968c1dde$export$c8beed618d2f74c8), {
                                        videoUrl: videoUrl,
                                        videoDuration: videoDuration
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $4b332390c9f221f8$export$2e2bcd8739ae039 = $4b332390c9f221f8$var$SingleVideoChart;




"use client";
var $c3bb0020087677ee$export$2957fc44b3d2481 = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
});





"use client";
var $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Divider2(props, ref) {
    const { borderLeftWidth: borderLeftWidth, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderWidth: borderWidth, borderStyle: borderStyle, borderColor: borderColor, ...styles } = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("Divider", props);
    const { className: className, orientation: orientation = "horizontal", __css: __css, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const dividerStyles = {
        vertical: {
            borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
            height: "100%"
        },
        horizontal: {
            borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
            width: "100%"
        }
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).hr, {
        ref: ref,
        "aria-orientation": orientation,
        ...rest,
        __css: {
            ...styles,
            border: "0",
            borderColor: borderColor,
            borderStyle: borderStyle,
            ...dividerStyles[orientation],
            ...__css
        },
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-divider", className)
    });
});
$cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb.displayName = "Divider";

// src/use-id.ts

var $lDSNw = parcelRequire("lDSNw");
function $2ed800c032563ea1$export$f680877a34711e37(idProp, prefix) {
    const id = (0, $lDSNw.useId)();
    return (0, $lDSNw.useMemo)(()=>idProp || [
            prefix,
            id
        ].filter(Boolean).join("-"), [
        idProp,
        prefix,
        id
    ]);
}
function $2ed800c032563ea1$export$365c04e2f432779(idProp, ...prefixes) {
    const id = $2ed800c032563ea1$export$f680877a34711e37(idProp);
    return (0, $lDSNw.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $2ed800c032563ea1$export$bc294ecf36b44bfb(partId) {
    const [id, setId] = (0, $lDSNw.useState)(null);
    const ref = (0, $lDSNw.useCallback)((node)=>{
        setId(node ? partId : null);
    }, [
        partId
    ]);
    return {
        ref: ref,
        id: id,
        isRendered: Boolean(id)
    };
}


// src/use-safe-layout-effect.ts
// src/dom.ts
function $680947ad877d8c5f$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $680947ad877d8c5f$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$680947ad877d8c5f$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $680947ad877d8c5f$export$f21a1ffae260145a(node) {
    var _a, _b;
    return $680947ad877d8c5f$export$45a5e7f76e0caa8d(node) ? (_b = (_a = $680947ad877d8c5f$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function $680947ad877d8c5f$export$b204af158042fbac(node) {
    var _a;
    return $680947ad877d8c5f$export$45a5e7f76e0caa8d(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function $680947ad877d8c5f$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $680947ad877d8c5f$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $680947ad877d8c5f$export$4e09c449d6c407f7 = /* @__PURE__ */ $680947ad877d8c5f$export$71594e8a50f746f4();
var $680947ad877d8c5f$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $680947ad877d8c5f$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
var $680947ad877d8c5f$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $680947ad877d8c5f$export$cd4e5573fbe2b576(node) {
    const doc = $680947ad877d8c5f$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $680947ad877d8c5f$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $680947ad877d8c5f$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}
function $680947ad877d8c5f$export$17948c8429b9b73a(event) {
    const { key: key, keyCode: keyCode } = event;
    const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    const eventKey = isArrowKey ? `Arrow${key}` : key;
    return eventKey;
}
function $680947ad877d8c5f$export$a7a83d2a1d2d9e91(event) {
    var _a, _b;
    const target = (_a = event.target) != null ? _a : event.currentTarget;
    const activeElement = $680947ad877d8c5f$export$cd4e5573fbe2b576(target);
    return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function $680947ad877d8c5f$export$189689d1febf0166(event) {
    return event.button !== 0;
}



var $lDSNw = parcelRequire("lDSNw");
var $bcafaa39f3d0c824$export$deebe11a338de063 = (0, $680947ad877d8c5f$export$4e09c449d6c407f7) ? (0, $lDSNw.useLayoutEffect) : (0, $lDSNw.useEffect);



var $lDSNw = parcelRequire("lDSNw");
function $7f9483effb912969$export$25bec8c6f54ee79a(fn, deps = []) {
    const ref = (0, $lDSNw.useRef)(fn);
    (0, $bcafaa39f3d0c824$export$deebe11a338de063)(()=>{
        ref.current = fn;
    });
    return (0, $lDSNw.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, deps);
}




var $lDSNw = parcelRequire("lDSNw");
function $c27355d82449ae1c$export$7301e09313e4cf1b(prop, state) {
    const isControlled = prop !== void 0;
    const value = isControlled && typeof prop !== "undefined" ? prop : state;
    return [
        isControlled,
        value
    ];
}
function $c27355d82449ae1c$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $7f9483effb912969$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $7f9483effb912969$export$25bec8c6f54ee79a)(shouldUpdate);
    const [valueState, setValue] = (0, $lDSNw.useState)(defaultValue);
    const isControlled = valueProp !== void 0;
    const value = isControlled ? valueProp : valueState;
    const updateValue = (0, $lDSNw.useCallback)((next)=>{
        const nextValue = (0, $61d460608c17cbaf$export$624e501d81f5ffce)(next, value);
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!isControlled) setValue(nextValue);
        onChangeProp(nextValue);
    }, [
        isControlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        updateValue
    ];
}





var $lDSNw = parcelRequire("lDSNw");
function $22a40b748afc455e$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const onOpenPropCallbackRef = (0, $7f9483effb912969$export$25bec8c6f54ee79a)(onOpenProp);
    const onClosePropCallbackRef = (0, $7f9483effb912969$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $lDSNw.useState)(props.defaultIsOpen || false);
    const [isControlled, isOpen] = (0, $c27355d82449ae1c$export$7301e09313e4cf1b)(isOpenProp, isOpenState);
    const id = (0, $2ed800c032563ea1$export$f680877a34711e37)(idProp, "disclosure");
    const onClose = (0, $lDSNw.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        onClosePropCallbackRef == null || onClosePropCallbackRef();
    }, [
        isControlled,
        onClosePropCallbackRef
    ]);
    const onOpen = (0, $lDSNw.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        onOpenPropCallbackRef == null || onOpenPropCallbackRef();
    }, [
        isControlled,
        onOpenPropCallbackRef
    ]);
    const onToggle = (0, $lDSNw.useCallback)(()=>{
        const action = isOpen ? onClose : onOpen;
        action();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    return {
        isOpen: !!isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: (props2 = {})=>({
                ...props2,
                "aria-expanded": isOpen,
                "aria-controls": id,
                onClick: (0, $61d460608c17cbaf$export$5bdd3f730ec2c47e)(props2.onClick, onToggle)
            }),
        getDisclosureProps: (props2 = {})=>({
                ...props2,
                hidden: !isOpen,
                id: id
            })
    };
}



var $lDSNw = parcelRequire("lDSNw");
var $acf5b3ef7b65fd7c$exports = {};

$acf5b3ef7b65fd7c$exports = new URL((parcelRequire("5V6iE")).resolve("as8WK"), import.meta.url).toString();


const $f5420fcdd20427c8$export$1c16cfd27c0b8d3c = ({ ...rest })=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $22a40b748afc455e$export$6e3e27031a30522f)();
    const hoveringRef = (0, $lDSNw.useRef)(false);
    const handleMouseLeave = ()=>{
        setTimeout(()=>{
            if (!hoveringRef.current) onClose();
        }, 500);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $477e0f2775c64f2e$export$5b6b19405a83ff9d), {
            returnFocusOnClose: false,
            isOpen: isOpen,
            onClose: onClose,
            placement: "left",
            closeOnBlur: true,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b8cdd4baf94d547a$export$7dacb05d26466c3), {
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        ...$f5420fcdd20427c8$var$linkStyle,
                        backgroundColor: isOpen ? "gray.50" : "transparent",
                        color: isOpen ? "teal.700" : "gray.600",
                        onClick: onOpen,
                        onMouseEnter: ()=>(onOpen(), hoveringRef.current = true),
                        onMouseLeave: ()=>{
                            handleMouseLeave();
                            hoveringRef.current = false;
                        },
                        ...rest,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                                as: (0, $c3bb0020087677ee$export$2957fc44b3d2481),
                                mr: 2.5,
                                mt: "-0.5"
                            }),
                            "How do we measure this?"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $de04819b4e852901$export$d7e1f420b25549ff), {
                    ...$f5420fcdd20427c8$var$popoverContainerStyle,
                    onMouseEnter: ()=>hoveringRef.current = true,
                    onMouseLeave: ()=>{
                        handleMouseLeave();
                        hoveringRef.current = false;
                    },
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ed866da64dbb3b59$export$3152841115e061b2), {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0a6464059de3a62e$export$472ec417bca1d382), {
                            as: (0, $2603e0709778e5bc$export$e6c02a6dccfa2120),
                            spacing: 4,
                            alignItems: "flex-start",
                            pos: "relative",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "lg",
                                    color: "gray.600",
                                    fontWeight: "bold",
                                    fontFamily: "roboto mono, monospace",
                                    children: "How do we measure this?"
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {}),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    children: "As your creative ran, we measured how users scrolled while the ad filled the screen. When a user backtracks or pauses for long enough, we classify them as ‘engaged,’ and we start measuring exactly which parts of the ad they are scrubbing, pausing, and backtracking on."
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    children: "We can then tally up to 5000 of these engaged sessions and chart them, highlighting the creative elements of your ad where people are playing or staying."
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset, rgba(20, 20, 20, 0.1) 0px 30px 150px",
                                    position: "absolute",
                                    bottom: -10,
                                    right: -24,
                                    transform: "rotate(10deg)",
                                    background: "white",
                                    borderRadius: "md",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($acf5b3ef7b65fd7c$exports))),
                                        w: "78px",
                                        opacity: 0.7
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $f5420fcdd20427c8$var$linkStyle = {
    fontSize: [
        "xs",
        "sm"
    ],
    cursor: "pointer",
    px: 2.5,
    py: 1,
    textUnderlineOffset: 3,
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    borderRadius: "md",
    ml: "-1.5" // align with the text
};
const $f5420fcdd20427c8$var$popoverContainerStyle = {
    zIndex: 100,
    mt: "50px",
    minWidth: "400px",
    py: 4,
    pb: 8,
    pl: 2,
    pr: 20,
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px, rgba(0, 0, 0, 0.15) 0px 7px 13px -3px, rgba(0, 0, 0, 0.1) 0px -3px 0px inset, rgba(20, 20, 20, 0.3) 0px 30px 150px"
};






var $lDSNw = parcelRequire("lDSNw");

const $bfb46151bcf8c40a$export$5d88b4290381d9a7 = ()=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $22a40b748afc455e$export$6e3e27031a30522f)();
    const hoveringRef = (0, $lDSNw.useRef)(false);
    const handleMouseLeave = ()=>{
        setTimeout(()=>{
            if (!hoveringRef.current) onClose();
        }, 500);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $477e0f2775c64f2e$export$5b6b19405a83ff9d), {
            returnFocusOnClose: false,
            isOpen: isOpen,
            onClose: onClose,
            placement: "right",
            closeOnBlur: true,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b8cdd4baf94d547a$export$7dacb05d26466c3), {
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        ...$bfb46151bcf8c40a$var$linkStyle,
                        backgroundColor: isOpen ? "gray.50" : "transparent",
                        color: isOpen ? "teal.700" : "gray.600",
                        onClick: onOpen,
                        onMouseEnter: ()=>(onOpen(), hoveringRef.current = true),
                        onMouseLeave: ()=>{
                            handleMouseLeave();
                            hoveringRef.current = false;
                        },
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                                as: (0, $c3bb0020087677ee$export$2957fc44b3d2481),
                                mr: 2.5,
                                mt: "-0.5"
                            }),
                            "How do we measure this?"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $de04819b4e852901$export$d7e1f420b25549ff), {
                    ...$bfb46151bcf8c40a$var$popoverContainerStyle,
                    onMouseEnter: ()=>hoveringRef.current = true,
                    onMouseLeave: ()=>{
                        handleMouseLeave();
                        hoveringRef.current = false;
                    },
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ed866da64dbb3b59$export$3152841115e061b2), {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0a6464059de3a62e$export$472ec417bca1d382), {
                            as: (0, $2603e0709778e5bc$export$e6c02a6dccfa2120),
                            spacing: 4,
                            alignItems: "flex-start",
                            pos: "relative",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "lg",
                                    color: "gray.600",
                                    fontWeight: "bold",
                                    fontFamily: "roboto mono, monospace",
                                    children: "How do we measure this?"
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {}),
                                "No content yet",
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset, rgba(20, 20, 20, 0.1) 0px 30px 150px",
                                    position: "absolute",
                                    bottom: -10,
                                    right: -24,
                                    transform: "rotate(10deg)",
                                    background: "white",
                                    borderRadius: "md",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($acf5b3ef7b65fd7c$exports))),
                                        w: "78px",
                                        opacity: 0.7
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $bfb46151bcf8c40a$var$linkStyle = {
    fontSize: [
        "xs",
        "sm"
    ],
    cursor: "pointer",
    px: 2.5,
    py: 1,
    textUnderlineOffset: 3,
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    borderRadius: "md",
    ml: "-1.5" // align with the text
};
const $bfb46151bcf8c40a$var$popoverContainerStyle = {
    zIndex: 100,
    mt: "50px",
    minWidth: "400px",
    py: 4,
    pb: 8,
    pl: 2,
    pr: 20,
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px, rgba(0, 0, 0, 0.15) 0px 7px 13px -3px, rgba(0, 0, 0, 0.1) 0px -3px 0px inset, rgba(20, 20, 20, 0.3) 0px 30px 150px"
};






var $lDSNw = parcelRequire("lDSNw");

const $69d046efbd249df0$export$4a23b3811cef465 = ({ ...rest })=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $22a40b748afc455e$export$6e3e27031a30522f)();
    const hoveringRef = (0, $lDSNw.useRef)(false);
    const handleMouseLeave = ()=>{
        setTimeout(()=>{
            if (!hoveringRef.current) onClose();
        }, 500);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $477e0f2775c64f2e$export$5b6b19405a83ff9d), {
            returnFocusOnClose: false,
            isOpen: isOpen,
            onClose: onClose,
            placement: "right",
            closeOnBlur: true,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b8cdd4baf94d547a$export$7dacb05d26466c3), {
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        ...$69d046efbd249df0$var$linkStyle,
                        backgroundColor: isOpen ? "gray.50" : "transparent",
                        color: isOpen ? "teal.700" : "gray.600",
                        onClick: onOpen,
                        onMouseEnter: ()=>(onOpen(), hoveringRef.current = true),
                        onMouseLeave: ()=>{
                            handleMouseLeave();
                            hoveringRef.current = false;
                        },
                        ...rest,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                                as: (0, $c3bb0020087677ee$export$2957fc44b3d2481),
                                mr: 2.5,
                                mt: "-0.5"
                            }),
                            "How do we measure this?"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $de04819b4e852901$export$d7e1f420b25549ff), {
                    ...$69d046efbd249df0$var$popoverContainerStyle,
                    onMouseEnter: ()=>hoveringRef.current = true,
                    onMouseLeave: ()=>{
                        handleMouseLeave();
                        hoveringRef.current = false;
                    },
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ed866da64dbb3b59$export$3152841115e061b2), {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0a6464059de3a62e$export$472ec417bca1d382), {
                            as: (0, $2603e0709778e5bc$export$e6c02a6dccfa2120),
                            spacing: 4,
                            alignItems: "flex-start",
                            pos: "relative",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "lg",
                                    color: "gray.600",
                                    fontWeight: "bold",
                                    fontFamily: "roboto mono, monospace",
                                    children: "How do we measure this?"
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {}),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    children: "We track user scrolling behavior while your creative is displayed. Rapid scrolling down, up, and back down is logged."
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    children: [
                                        "If they do it several times, it’s a sign they’re engaging with the scroll effects on your ad",
                                        " ",
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                            as: "span",
                                            color: "gray",
                                            fontStyle: "italic",
                                            children: "(unless there’s an earthquake – but just to be sure we measure up to 5000 sessions)."
                                        }),
                                        " ",
                                        "Ordinary scrolling? We disregard that."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    children: "All recorded sessions are averaged into the chart above, with a few raw sessions for reference. This shows how users engaged with your ad’s elements during animation, and whether the animation captured their interest."
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset, rgba(20, 20, 20, 0.1) 0px 30px 150px",
                                    position: "absolute",
                                    bottom: -10,
                                    right: -24,
                                    transform: "rotate(10deg)",
                                    background: "white",
                                    borderRadius: "md",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($acf5b3ef7b65fd7c$exports))),
                                        w: "78px",
                                        opacity: 0.7
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $69d046efbd249df0$var$linkStyle = {
    fontSize: [
        "xs",
        "sm"
    ],
    cursor: "pointer",
    px: 2.5,
    py: 1,
    textUnderlineOffset: 3,
    textDecoration: "underline",
    textDecorationStyle: "dotted",
    borderRadius: "md",
    ml: "-1.5" // align with the text
};
const $69d046efbd249df0$var$popoverContainerStyle = {
    zIndex: 100,
    mt: "50px",
    minWidth: "400px",
    py: 4,
    pb: 8,
    pl: 2,
    pr: 20,
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px, rgba(0, 0, 0, 0.15) 0px 7px 13px -3px, rgba(0, 0, 0, 0.1) 0px -3px 0px inset, rgba(20, 20, 20, 0.3) 0px 30px 150px"
};


const $aabe32da29ab7737$export$f54a093675066994 = {
    Velocity: $69d046efbd249df0$export$4a23b3811cef465,
    Hangtime: $f5420fcdd20427c8$export$1c16cfd27c0b8d3c,
    HangtimeVideo: $bfb46151bcf8c40a$export$5d88b4290381d9a7
};




var $lDSNw = parcelRequire("lDSNw");




"use client";
var $9a48381610983ea3$export$7dd004358974b05d = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    viewBox: "0 0 14 14",
    path: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("g", {
        fill: "currentColor",
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("polygon", {
            points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
        })
    })
});


"use client";
var $f8be84f562dfc2c1$export$cae179f078f4b4a4 = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    displayName: "CloseIcon",
    d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
});



"use client";
var $663bea26f8f88efa$export$2ad141e9e3d81b82 = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    displayName: "EditIcon",
    path: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)("g", {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: "2",
        children: [
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
                d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
                d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
            })
        ]
    })
});






var $lDSNw = parcelRequire("lDSNw");

"use client";
var $a854ac4f7023a709$var$attachedStyles = {
    horizontal: {
        "> *:first-of-type:not(:last-of-type)": {
            borderEndRadius: 0
        },
        "> *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0
        },
        "> *:not(:first-of-type):last-of-type": {
            borderStartRadius: 0
        }
    },
    vertical: {
        "> *:first-of-type:not(:last-of-type)": {
            borderBottomRadius: 0
        },
        "> *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0
        },
        "> *:not(:first-of-type):last-of-type": {
            borderTopRadius: 0
        }
    }
};
var $a854ac4f7023a709$var$gapStyles = {
    horizontal: (spacing)=>({
            "& > *:not(style) ~ *:not(style)": {
                marginStart: spacing
            }
        }),
    vertical: (spacing)=>({
            "& > *:not(style) ~ *:not(style)": {
                marginTop: spacing
            }
        })
};
var $a854ac4f7023a709$export$69b1032f2ecdf404 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function ButtonGroup2(props, ref) {
    const { size: size, colorScheme: colorScheme, variant: variant, className: className, spacing: spacing = "0.5rem", isAttached: isAttached, isDisabled: isDisabled, orientation: orientation = "horizontal", ...rest } = props;
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-button__group", className);
    const context = (0, $lDSNw.useMemo)(()=>({
            size: size,
            colorScheme: colorScheme,
            variant: variant,
            isDisabled: isDisabled
        }), [
        size,
        colorScheme,
        variant,
        isDisabled
    ]);
    let groupStyles = {
        display: "inline-flex",
        ...isAttached ? $a854ac4f7023a709$var$attachedStyles[orientation] : $a854ac4f7023a709$var$gapStyles[orientation](spacing)
    };
    const isVertical = orientation === "vertical";
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b19f3fcc4b547227$export$85041a2bb9328e33), {
        value: context,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
            ref: ref,
            role: "group",
            __css: groupStyles,
            className: _className,
            "data-attached": isAttached ? "" : void 0,
            "data-orientation": orientation,
            flexDir: isVertical ? "column" : void 0,
            ...rest
        })
    });
});
$a854ac4f7023a709$export$69b1032f2ecdf404.displayName = "ButtonGroup";









var $lDSNw = parcelRequire("lDSNw");
"use client";
function $06ecd34833b283f9$var$contains(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $06ecd34833b283f9$export$52a148af2bad544(props = {}) {
    const { onChange: onChangeProp, onCancel: onCancelProp, onSubmit: onSubmitProp, onBlur: onBlurProp, value: valueProp, isDisabled: isDisabled, defaultValue: defaultValue, startWithEditView: startWithEditView, isPreviewFocusable: isPreviewFocusable = true, submitOnBlur: submitOnBlur = true, selectAllOnFocus: selectAllOnFocus = true, placeholder: placeholder, onEdit: onEditCallback, finalFocusRef: finalFocusRef, ...htmlProps } = props;
    const onEditProp = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(onEditCallback);
    const defaultIsEditing = Boolean(startWithEditView && !isDisabled);
    const [isEditing, setIsEditing] = (0, $lDSNw.useState)(defaultIsEditing);
    const [value, setValue] = (0, $1c6446ce89a1d8f0$export$6f32135080cb4c3)({
        defaultValue: defaultValue || "",
        value: valueProp,
        onChange: onChangeProp
    });
    const [prevValue, setPrevValue] = (0, $lDSNw.useState)(value);
    const inputRef = (0, $lDSNw.useRef)(null);
    const previewRef = (0, $lDSNw.useRef)(null);
    const editButtonRef = (0, $lDSNw.useRef)(null);
    const cancelButtonRef = (0, $lDSNw.useRef)(null);
    const submitButtonRef = (0, $lDSNw.useRef)(null);
    (0, $3433b5747f0b1833$export$16a61b931588d888)({
        ref: inputRef,
        enabled: isEditing,
        elements: [
            cancelButtonRef,
            submitButtonRef
        ]
    });
    const isInteractive = !isEditing && !isDisabled;
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        var _a, _b;
        if (isEditing) {
            (_a = inputRef.current) == null || _a.focus();
            if (selectAllOnFocus) (_b = inputRef.current) == null || _b.select();
        }
    }, []);
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        var _a, _b, _c, _d;
        if (!isEditing) {
            if (finalFocusRef) (_a = finalFocusRef.current) == null || _a.focus();
            else (_b = editButtonRef.current) == null || _b.focus();
            return;
        }
        (_c = inputRef.current) == null || _c.focus();
        if (selectAllOnFocus) (_d = inputRef.current) == null || _d.select();
        onEditProp == null || onEditProp();
    }, [
        isEditing,
        onEditProp,
        selectAllOnFocus
    ]);
    const onEdit = (0, $lDSNw.useCallback)(()=>{
        if (isInteractive) setIsEditing(true);
    }, [
        isInteractive
    ]);
    const onUpdatePrevValue = (0, $lDSNw.useCallback)(()=>{
        setPrevValue(value);
    }, [
        value
    ]);
    const onCancel = (0, $lDSNw.useCallback)(()=>{
        setIsEditing(false);
        setValue(prevValue);
        onCancelProp == null || onCancelProp(prevValue);
        onBlurProp == null || onBlurProp(prevValue);
    }, [
        onCancelProp,
        onBlurProp,
        setValue,
        prevValue
    ]);
    const onSubmit = (0, $lDSNw.useCallback)(()=>{
        setIsEditing(false);
        setPrevValue(value);
        onSubmitProp == null || onSubmitProp(value);
        onBlurProp == null || onBlurProp(prevValue);
    }, [
        value,
        onSubmitProp,
        onBlurProp,
        prevValue
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (isEditing) return;
        const inputEl = inputRef.current;
        if ((inputEl == null ? void 0 : inputEl.ownerDocument.activeElement) === inputEl) inputEl == null || inputEl.blur();
    }, [
        isEditing
    ]);
    const onChange = (0, $lDSNw.useCallback)((event)=>{
        setValue(event.currentTarget.value);
    }, [
        setValue
    ]);
    const onKeyDown = (0, $lDSNw.useCallback)((event)=>{
        const eventKey = event.key;
        const keyMap = {
            Escape: onCancel,
            Enter: (event2)=>{
                if (!event2.shiftKey && !event2.metaKey) onSubmit();
            }
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        onCancel,
        onSubmit
    ]);
    const onKeyDownWithoutSubmit = (0, $lDSNw.useCallback)((event)=>{
        const eventKey = event.key;
        const keyMap = {
            Escape: onCancel
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        onCancel
    ]);
    const isValueEmpty = value.length === 0;
    const onBlur = (0, $lDSNw.useCallback)((event)=>{
        var _a;
        if (!isEditing) return;
        const doc = event.currentTarget.ownerDocument;
        const relatedTarget = (_a = event.relatedTarget) != null ? _a : doc.activeElement;
        const targetIsCancel = $06ecd34833b283f9$var$contains(cancelButtonRef.current, relatedTarget);
        const targetIsSubmit = $06ecd34833b283f9$var$contains(submitButtonRef.current, relatedTarget);
        const isValidBlur = !targetIsCancel && !targetIsSubmit;
        if (isValidBlur) {
            if (submitOnBlur) onSubmit();
            else onCancel();
        }
    }, [
        submitOnBlur,
        onSubmit,
        onCancel,
        isEditing
    ]);
    const getPreviewProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>{
        const tabIndex = isInteractive && isPreviewFocusable ? 0 : void 0;
        return {
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, previewRef),
            children: isValueEmpty ? placeholder : value,
            hidden: isEditing,
            "aria-disabled": (0, $a223a0f4c9b3f9de$export$91a6105db3d4be7b)(isDisabled),
            tabIndex: tabIndex,
            onFocus: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onFocus, onEdit, onUpdatePrevValue)
        };
    }, [
        isDisabled,
        isEditing,
        isInteractive,
        isPreviewFocusable,
        isValueEmpty,
        onEdit,
        onUpdatePrevValue,
        placeholder,
        value
    ]);
    const getInputProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            hidden: !isEditing,
            placeholder: placeholder,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, inputRef),
            disabled: isDisabled,
            "aria-disabled": (0, $a223a0f4c9b3f9de$export$91a6105db3d4be7b)(isDisabled),
            value: value,
            onBlur: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onBlur, onBlur),
            onChange: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onChange, onChange),
            onKeyDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onFocus: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onFocus, onUpdatePrevValue)
        }), [
        isDisabled,
        isEditing,
        onBlur,
        onChange,
        onKeyDown,
        onUpdatePrevValue,
        placeholder,
        value
    ]);
    const getTextareaProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            hidden: !isEditing,
            placeholder: placeholder,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, inputRef),
            disabled: isDisabled,
            "aria-disabled": (0, $a223a0f4c9b3f9de$export$91a6105db3d4be7b)(isDisabled),
            value: value,
            onBlur: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onBlur, onBlur),
            onChange: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onChange, onChange),
            onKeyDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDownWithoutSubmit),
            onFocus: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onFocus, onUpdatePrevValue)
        }), [
        isDisabled,
        isEditing,
        onBlur,
        onChange,
        onKeyDownWithoutSubmit,
        onUpdatePrevValue,
        placeholder,
        value
    ]);
    const getEditButtonProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            "aria-label": "Edit",
            ...props2,
            type: "button",
            onClick: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onClick, onEdit),
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(ref, editButtonRef),
            disabled: isDisabled
        }), [
        onEdit,
        isDisabled
    ]);
    const getSubmitButtonProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            "aria-label": "Submit",
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(submitButtonRef, ref),
            type: "button",
            onClick: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onClick, onSubmit),
            disabled: isDisabled
        }), [
        onSubmit,
        isDisabled
    ]);
    const getCancelButtonProps = (0, $lDSNw.useCallback)((props2 = {}, ref = null)=>({
            "aria-label": "Cancel",
            id: "cancel",
            ...props2,
            ref: (0, $dc32195927d0d802$export$c9058316764c140e)(cancelButtonRef, ref),
            type: "button",
            onClick: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props2.onClick, onCancel),
            disabled: isDisabled
        }), [
        onCancel,
        isDisabled
    ]);
    return {
        isEditing: isEditing,
        isDisabled: isDisabled,
        isValueEmpty: isValueEmpty,
        value: value,
        onEdit: onEdit,
        onCancel: onCancel,
        onSubmit: onSubmit,
        getPreviewProps: getPreviewProps,
        getInputProps: getInputProps,
        getTextareaProps: getTextareaProps,
        getEditButtonProps: getEditButtonProps,
        getSubmitButtonProps: getSubmitButtonProps,
        getCancelButtonProps: getCancelButtonProps,
        htmlProps: htmlProps
    };
}



"use client";
var [$89fb98883e814e53$export$bc814bd957ab7c7d, $89fb98883e814e53$export$d5ae1d14c8c7d41e] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `EditableStylesContext`,
    errorMessage: `useEditableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Editable />" `
});
var [$89fb98883e814e53$export$53886cd407101d55, $89fb98883e814e53$export$dbad47e4f848463d] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: "EditableContext",
    errorMessage: "useEditableContext: context is undefined. Seems you forgot to wrap the editable components in `<Editable />`"
});





"use client";
var $3659a212c111ecb2$export$b1c809d287d72650 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Editable2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Editable", props);
    const ownProps = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const { htmlProps: htmlProps, ...context } = (0, $06ecd34833b283f9$export$52a148af2bad544)(ownProps);
    const { isEditing: isEditing, onSubmit: onSubmit, onCancel: onCancel, onEdit: onEdit } = context;
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-editable", props.className);
    const children = (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(props.children, {
        isEditing: isEditing,
        onSubmit: onSubmit,
        onCancel: onCancel,
        onEdit: onEdit
    });
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $89fb98883e814e53$export$53886cd407101d55), {
        value: context,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $89fb98883e814e53$export$bc814bd957ab7c7d), {
            value: styles,
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                ref: ref,
                ...htmlProps,
                className: _className,
                children: children
            })
        })
    });
});
$3659a212c111ecb2$export$b1c809d287d72650.displayName = "Editable";

"use client";
// src/shared.ts
var $6bf775e3660ac214$export$e8ccb531c7793070 = {
    fontSize: "inherit",
    fontWeight: "inherit",
    textAlign: "inherit",
    bg: "transparent"
};






"use client";
var $6c3707fafeffcb54$export$bfb3cbb78d3c298 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function EditableInput2(props, ref) {
    const { getInputProps: getInputProps } = (0, $89fb98883e814e53$export$dbad47e4f848463d)();
    const styles = (0, $89fb98883e814e53$export$d5ae1d14c8c7d41e)();
    const inputProps = getInputProps(props, ref);
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-editable__input", props.className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).input, {
        ...inputProps,
        __css: {
            outline: 0,
            ...(0, $6bf775e3660ac214$export$e8ccb531c7793070),
            ...styles.input
        },
        className: _className
    });
});
$6c3707fafeffcb54$export$bfb3cbb78d3c298.displayName = "EditableInput";






"use client";
var $d8a29379bfa0b828$export$79dad7f65abf77d0 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function EditablePreview2(props, ref) {
    const { getPreviewProps: getPreviewProps } = (0, $89fb98883e814e53$export$dbad47e4f848463d)();
    const styles = (0, $89fb98883e814e53$export$d5ae1d14c8c7d41e)();
    const previewProps = getPreviewProps(props, ref);
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-editable__preview", props.className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        ...previewProps,
        __css: {
            cursor: "text",
            display: "inline-block",
            ...(0, $6bf775e3660ac214$export$e8ccb531c7793070),
            ...styles.preview
        },
        className: _className
    });
});
$d8a29379bfa0b828$export$79dad7f65abf77d0.displayName = "EditablePreview";






"use client";
var $e703e2734fe4eb45$export$67f7c9674b1fe02a = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function EditableTextarea2(props, ref) {
    const { getTextareaProps: getTextareaProps } = (0, $89fb98883e814e53$export$dbad47e4f848463d)();
    const styles = (0, $89fb98883e814e53$export$d5ae1d14c8c7d41e)();
    const textareaProps = getTextareaProps(props, ref);
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-editable__textarea", props.className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).textarea, {
        ...textareaProps,
        __css: {
            outline: 0,
            ...(0, $6bf775e3660ac214$export$e8ccb531c7793070),
            ...styles.textarea
        },
        className: _className
    });
});
$e703e2734fe4eb45$export$67f7c9674b1fe02a.displayName = "EditableTextarea";





"use client";
var $ddf28f2444832ff6$export$f5b8910cec6cf069 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Input2(props, ref) {
    const { htmlSize: htmlSize, ...rest } = props;
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Input", rest);
    const ownProps = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(rest);
    const input = (0, $f51ab13b55b1484d$export$62ecd8ad1bbe1a18)(ownProps);
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-input", props.className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).input, {
        size: htmlSize,
        ...input,
        __css: styles.field,
        ref: ref,
        className: _className
    });
});
$ddf28f2444832ff6$export$f5b8910cec6cf069.displayName = "Input";
$ddf28f2444832ff6$export$f5b8910cec6cf069.id = "Input";


"use client";
// src/use-editable-controls.tsx
function $fd8ceedecd9dee64$export$6a53985c1e5d51c() {
    const { isEditing: isEditing, getEditButtonProps: getEditButtonProps, getCancelButtonProps: getCancelButtonProps, getSubmitButtonProps: getSubmitButtonProps } = (0, $89fb98883e814e53$export$dbad47e4f848463d)();
    return {
        isEditing: isEditing,
        getEditButtonProps: getEditButtonProps,
        getCancelButtonProps: getCancelButtonProps,
        getSubmitButtonProps: getSubmitButtonProps
    };
}

"use client";
// src/toast.utils.ts
var $60c62996e9016866$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $60c62996e9016866$export$67080b9d5f0a62ea(toasts, id) {
    const position = $60c62996e9016866$export$500f52ac46324ec6(toasts, id);
    const index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
function $60c62996e9016866$export$500f52ac46324ec6(toasts, id) {
    for (const [position, values] of Object.entries(toasts)){
        if ($60c62996e9016866$export$6486ede9e74d7d9d(values, id)) return position;
    }
}
var $60c62996e9016866$export$795910f5f15a9633 = (toasts, id)=>!!$60c62996e9016866$export$500f52ac46324ec6(toasts, id);
function $60c62996e9016866$export$27777812cc6d52de(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}
function $60c62996e9016866$export$55dd410e8ef136e0(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
        position: "fixed",
        zIndex: "var(--toast-z-index, 5500)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        margin: margin,
        top: top,
        bottom: bottom,
        right: right,
        left: left
    };
}



var $lDSNw = parcelRequire("lDSNw");

"use client";
function $d8399c51f553dcf8$export$d8e6abf214c9ec0f(callback, delay) {
    const fn = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(callback);
    (0, $lDSNw.useEffect)(()=>{
        if (delay == null) return void 0;
        let timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}







var $lDSNw = parcelRequire("lDSNw");

"use client";
var $d6b8419d0789d9fe$var$toastMotionVariants = {
    initial: (props)=>{
        const { position: position } = props;
        const dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        let factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
var $d6b8419d0789d9fe$export$8743ba3ef25f9582 = (0, $lDSNw.memo)((props)=>{
    const { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5e3, containerStyle: containerStyle, motionVariants: motionVariants = $d6b8419d0789d9fe$var$toastMotionVariants, toastSpacing: toastSpacing = "0.5rem" } = props;
    const [delay, setDelay] = (0, $lDSNw.useState)(duration);
    const isPresent = (0, $b6f4d24a99ec1efd$export$8249053f690ea39a)();
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete == null || onCloseComplete();
    }, [
        isPresent
    ]);
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    const onMouseEnter = ()=>setDelay(null);
    const onMouseLeave = ()=>setDelay(duration);
    const close = ()=>{
        if (isPresent) onRequestRemove();
    };
    (0, $lDSNw.useEffect)(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $d8399c51f553dcf8$export$d8e6abf214c9ec0f)(close, delay);
    const containerStyles = (0, $lDSNw.useMemo)(()=>({
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: toastSpacing,
            ...containerStyle
        }), [
        containerStyle,
        toastSpacing
    ]);
    const toastStyle = (0, $lDSNw.useMemo)(()=>(0, $60c62996e9016866$export$27777812cc6d52de)(position), [
        position
    ]);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).div, {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: toastStyle,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(message, {
                id: id,
                onClose: close
            })
        })
    });
});
$d6b8419d0789d9fe$export$8743ba3ef25f9582.displayName = "ToastComponent";



"use client";
// src/toast.placement.ts
function $2b20d9a229263974$export$5b03f73d5fd4425(position, dir) {
    var _a;
    const computedPosition = position != null ? position : "bottom";
    const logicals = {
        "top-start": {
            ltr: "top-left",
            rtl: "top-right"
        },
        "top-end": {
            ltr: "top-right",
            rtl: "top-left"
        },
        "bottom-start": {
            ltr: "bottom-left",
            rtl: "bottom-right"
        },
        "bottom-end": {
            ltr: "bottom-right",
            rtl: "bottom-left"
        }
    };
    const logical = logicals[computedPosition];
    return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
}




"use client";
function $d0ad39a009c16a4f$export$7dd004358974b05d(props) {
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        })
    });
}
function $d0ad39a009c16a4f$export$2957fc44b3d2481(props) {
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        })
    });
}
function $d0ad39a009c16a4f$export$f7dc499a72baa103(props) {
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
}




"use client";
var [$ad518572a539c304$export$a7901f7b4cce70b0, $ad518572a539c304$export$50b520f08832063d] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
});
var [$ad518572a539c304$export$17cf5063e294f385, $ad518572a539c304$export$167ececdbea67592] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
});
var $ad518572a539c304$var$STATUSES = {
    info: {
        icon: (0, $d0ad39a009c16a4f$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $d0ad39a009c16a4f$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $d0ad39a009c16a4f$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $d0ad39a009c16a4f$export$f7dc499a72baa103),
        colorScheme: "red"
    },
    loading: {
        icon: (0, $35745663698a221c$export$7f7cbe89f1eacd2),
        colorScheme: "blue"
    }
};
function $ad518572a539c304$export$8df8f66d0469c54d(status) {
    return $ad518572a539c304$var$STATUSES[status].colorScheme;
}
function $ad518572a539c304$export$c742923ea4ac4c1c(status) {
    return $ad518572a539c304$var$STATUSES[status].icon;
}





"use client";
var $d9fbb0ef89ab07a2$export$caec2af78bcc877f = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Alert2(props, ref) {
    var _a;
    const { status: status = "info", addRole: addRole = true, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const colorScheme = (_a = props.colorScheme) != null ? _a : (0, $ad518572a539c304$export$8df8f66d0469c54d)(status);
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Alert", {
        ...props,
        colorScheme: colorScheme
    });
    const alertStyles = {
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ad518572a539c304$export$a7901f7b4cce70b0), {
        value: {
            status: status
        },
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ad518572a539c304$export$17cf5063e294f385), {
            value: styles,
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                "data-status": status,
                role: addRole ? "alert" : void 0,
                ref: ref,
                ...rest,
                className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-alert", props.className),
                __css: alertStyles
            })
        })
    });
});
$d9fbb0ef89ab07a2$export$caec2af78bcc877f.displayName = "Alert";





"use client";
var $92e649f18d4d70e9$export$d4feae172fccda11 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function AlertDescription2(props, ref) {
    const styles = (0, $ad518572a539c304$export$167ececdbea67592)();
    const { status: status } = (0, $ad518572a539c304$export$50b520f08832063d)();
    const descriptionStyles = {
        display: "inline",
        ...styles.description
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    });
});
$92e649f18d4d70e9$export$d4feae172fccda11.displayName = "AlertDescription";





"use client";
function $63dec9e49fecebda$export$4a143c8822a09fb4(props) {
    const { status: status } = (0, $ad518572a539c304$export$50b520f08832063d)();
    const BaseIcon = (0, $ad518572a539c304$export$c742923ea4ac4c1c)(status);
    const styles = (0, $ad518572a539c304$export$167ececdbea67592)();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        display: "inherit",
        "data-status": status,
        ...props,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)(BaseIcon, {
            h: "100%",
            w: "100%"
        })
    });
}
$63dec9e49fecebda$export$4a143c8822a09fb4.displayName = "AlertIcon";





"use client";
var $9f48903f67f619c2$export$4a7253439a300753 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function AlertTitle2(props, ref) {
    const styles = (0, $ad518572a539c304$export$167ececdbea67592)();
    const { status: status } = (0, $ad518572a539c304$export$50b520f08832063d)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-alert__title", props.className),
        __css: styles.title
    });
});
$9f48903f67f619c2$export$4a7253439a300753.displayName = "AlertTitle";






"use client";
// src/toast.store.ts
var $f9f37931be849d7a$var$initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
};
var $f9f37931be849d7a$export$e80fa18a42ed98ef = $f9f37931be849d7a$var$createStore($f9f37931be849d7a$var$initialState);
function $f9f37931be849d7a$var$createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn)=>{
        state = setStateFn(state);
        listeners.forEach((l)=>l());
    };
    return {
        getState: ()=>state,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                setState(()=>initialState2);
                listeners.delete(listener);
            };
        },
        /**
     * Delete a toast record at its position
     */ removeToast: (id, position)=>{
            setState((prevState)=>({
                    ...prevState,
                    // id may be string or number
                    // eslint-disable-next-line eqeqeq
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        },
        notify: (message, options)=>{
            const toast = $f9f37931be849d7a$var$createToast(message, options);
            const { position: position, id: id } = toast;
            setState((prevToasts)=>{
                var _a, _b;
                const isTop = position.includes("top");
                const toasts = isTop ? [
                    toast,
                    ...(_a = prevToasts[position]) != null ? _a : []
                ] : [
                    ...(_b = prevToasts[position]) != null ? _b : [],
                    toast
                ];
                return {
                    ...prevToasts,
                    [position]: toasts
                };
            });
            return id;
        },
        update: (id, options)=>{
            if (!id) return;
            setState((prevState)=>{
                const nextState = {
                    ...prevState
                };
                const { position: position, index: index } = (0, $60c62996e9016866$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = {
                    ...nextState[position][index],
                    ...options,
                    message: $f9f37931be849d7a$export$d9d796c483697359(options)
                };
                return nextState;
            });
        },
        closeAll: ({ positions: positions } = {})=>{
            setState((prev)=>{
                const allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                const positionsToClose = positions != null ? positions : allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>({
                            ...toast,
                            requestClose: true
                        }));
                    return acc;
                }, {
                    ...prev
                });
            });
        },
        close: (id)=>{
            setState((prevState)=>{
                const position = (0, $60c62996e9016866$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return {
                    ...prevState,
                    [position]: prevState[position].map((toast)=>{
                        if (toast.id == id) return {
                            ...toast,
                            requestClose: true
                        };
                        return toast;
                    })
                };
            });
        },
        isActive: (id)=>Boolean((0, $60c62996e9016866$export$67080b9d5f0a62ea)($f9f37931be849d7a$export$e80fa18a42ed98ef.getState(), id).position)
    };
}
var $f9f37931be849d7a$var$counter = 0;
function $f9f37931be849d7a$var$createToast(message, options = {}) {
    var _a, _b;
    $f9f37931be849d7a$var$counter += 1;
    const id = (_a = options.id) != null ? _a : $f9f37931be849d7a$var$counter;
    const position = (_b = options.position) != null ? _b : "bottom";
    return {
        id: id,
        message: message,
        position: position,
        duration: options.duration,
        onCloseComplete: options.onCloseComplete,
        onRequestRemove: ()=>$f9f37931be849d7a$export$e80fa18a42ed98ef.removeToast(String(id), position),
        status: options.status,
        requestClose: false,
        containerStyle: options.containerStyle
    };
}
var $f9f37931be849d7a$export$8d8dc7d5f743331b = (props)=>{
    const { status: status, variant: variant = "solid", id: id, title: title, isClosable: isClosable, onClose: onClose, description: description, colorScheme: colorScheme, icon: icon } = props;
    const ids = id ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $d9fbb0ef89ab07a2$export$caec2af78bcc877f), {
        addRole: false,
        status: status,
        variant: variant,
        id: ids == null ? void 0 : ids.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme: colorScheme,
        children: [
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $63dec9e49fecebda$export$4a143c8822a09fb4), {
                children: icon
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                flex: "1",
                maxWidth: "100%",
                children: [
                    title && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $9f48903f67f619c2$export$4a7253439a300753), {
                        id: ids == null ? void 0 : ids.title,
                        children: title
                    }),
                    description && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92e649f18d4d70e9$export$d4feae172fccda11), {
                        id: ids == null ? void 0 : ids.description,
                        display: "block",
                        children: description
                    })
                ]
            }),
            isClosable && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $59805e3bb0d0b8f6$export$de65de8213222d10), {
                size: "sm",
                onClick: onClose,
                position: "absolute",
                insetEnd: 1,
                top: 1
            })
        ]
    });
};
function $f9f37931be849d7a$export$d9d796c483697359(options = {}) {
    const { render: render, toastComponent: ToastComponent = $f9f37931be849d7a$export$8d8dc7d5f743331b } = options;
    const renderToast = (props)=>{
        if (typeof render === "function") return render({
            ...props,
            ...options
        });
        return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)(ToastComponent, {
            ...props,
            ...options
        });
    };
    return renderToast;
}
function $f9f37931be849d7a$export$f3af62d19eb14261(dir, defaultOptions) {
    const normalizeToastOptions = (options)=>{
        var _a;
        return {
            ...defaultOptions,
            ...options,
            position: (0, $2b20d9a229263974$export$5b03f73d5fd4425)((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
        };
    };
    const toast = (options)=>{
        const normalizedToastOptions = normalizeToastOptions(options);
        const Message = $f9f37931be849d7a$export$d9d796c483697359(normalizedToastOptions);
        return $f9f37931be849d7a$export$e80fa18a42ed98ef.notify(Message, normalizedToastOptions);
    };
    toast.update = (id, options)=>{
        $f9f37931be849d7a$export$e80fa18a42ed98ef.update(id, normalizeToastOptions(options));
    };
    toast.promise = (promise, options)=>{
        const id = toast({
            ...options.loading,
            status: "loading",
            duration: null
        });
        promise.then((data)=>toast.update(id, {
                status: "success",
                duration: 5e3,
                ...(0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(options.success, data)
            })).catch((error)=>toast.update(id, {
                status: "error",
                duration: 5e3,
                ...(0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(options.error, error)
            }));
    };
    toast.closeAll = $f9f37931be849d7a$export$e80fa18a42ed98ef.closeAll;
    toast.close = $f9f37931be849d7a$export$e80fa18a42ed98ef.close;
    toast.isActive = $f9f37931be849d7a$export$e80fa18a42ed98ef.isActive;
    return toast;
}






var $lDSNw = parcelRequire("lDSNw");


"use client";
var [$a28809c469396bf0$export$cfcc07abbe2e36a8, $a28809c469396bf0$export$7c4af276256dc908] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `ToastOptionsContext`,
    strict: false
});
var $a28809c469396bf0$export$f5d03d415824e0e = (props)=>{
    const state = (0, $lDSNw.useSyncExternalStore)((0, $f9f37931be849d7a$export$e80fa18a42ed98ef).subscribe, (0, $f9f37931be849d7a$export$e80fa18a42ed98ef).getState, (0, $f9f37931be849d7a$export$e80fa18a42ed98ef).getState);
    const { motionVariants: motionVariants, component: Component = (0, $d6b8419d0789d9fe$export$8743ba3ef25f9582), portalProps: portalProps } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position)=>{
        const toasts = state[position];
        return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            "aria-label": "Notifications",
            id: `chakra-toast-manager-${position}`,
            style: (0, $60c62996e9016866$export$55dd410e8ef136e0)(position),
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0204198b5355405f$export$3ae376d12526dd6f), {
                initial: false,
                children: toasts.map((toast)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)(Component, {
                        motionVariants: motionVariants,
                        ...toast
                    }, toast.id))
            })
        }, position);
    });
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e51c5ae64f7cf3d3$export$602eac185826482c), {
        ...portalProps,
        children: toastList
    });
};





var $lDSNw = parcelRequire("lDSNw");
"use client";
function $586cea86be2fe10b$export$a407b657d3044108(options) {
    const { theme: theme } = (0, $45384fe8bd4bf97a$export$a513a93efd9ab8a7)();
    const defaultOptions = (0, $a28809c469396bf0$export$7c4af276256dc908)();
    return (0, $lDSNw.useMemo)(()=>(0, $f9f37931be849d7a$export$f3af62d19eb14261)(theme.direction, {
            ...defaultOptions,
            ...options
        }), [
        options,
        theme.direction,
        defaultOptions
    ]);
}
var $586cea86be2fe10b$export$6c81af436bf0e329 = $586cea86be2fe10b$export$a407b657d3044108;



var $lDSNw = parcelRequire("lDSNw");
const $820a2ba43b88e8a8$export$1c673afd5aa0b669 = ({ showEditControls: showEditControls = true, textStyle: textStyle, inputStyle: inputStyle, onEdit: onEdit, isLoading: isLoading = false, fieldType: fieldType = "text", value: value })=>{
    const toast = (0, $586cea86be2fe10b$export$a407b657d3044108)();
    const EditableControls = ({ isLoading: isLoading })=>{
        if (!showEditControls) return null;
        const { isEditing: isEditing, getSubmitButtonProps: getSubmitButtonProps, getCancelButtonProps: getCancelButtonProps, getEditButtonProps: getEditButtonProps } = (0, $fd8ceedecd9dee64$export$6a53985c1e5d51c)();
        return isEditing ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $a854ac4f7023a709$export$69b1032f2ecdf404), {
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                    ...$820a2ba43b88e8a8$var$iconStyleProps,
                    icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $9a48381610983ea3$export$7dd004358974b05d), {}),
                    isLoading: isLoading,
                    ...getSubmitButtonProps()
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                    ...$820a2ba43b88e8a8$var$iconStyleProps,
                    icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f8be84f562dfc2c1$export$cae179f078f4b4a4), {}),
                    isLoading: isLoading,
                    ...getCancelButtonProps()
                })
            ]
        }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
            justifyContent: "center",
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                ...$820a2ba43b88e8a8$var$iconStyleProps,
                icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $663bea26f8f88efa$export$2ad141e9e3d81b82), {}),
                isLoading: isLoading,
                ...getEditButtonProps()
            })
        });
    };
    const [editableValue, setEditableValue] = (0, $lDSNw.useState)(value);
    (0, $lDSNw.useEffect)(()=>{
        setEditableValue(value); // Update internal state when external value changes
    }, [
        value
    ]);
    const handleEdit = async (content)=>{
        if (content === value) return;
        setEditableValue(content); // Update local state on edit
        try {
            await onEdit(content);
            toast($820a2ba43b88e8a8$var$SUCCESS_TOAST);
        } catch (e) {
            toast($820a2ba43b88e8a8$var$ERROR_TOAST);
        }
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $3659a212c111ecb2$export$b1c809d287d72650), {
        value: editableValue,
        pointerEvents: showEditControls ? "inherit" : "none",
        onChange: (newVal)=>setEditableValue(newVal),
        onSubmit: handleEdit,
        display: "flex",
        flexDir: "row",
        w: "100%",
        className: "editable-description" //for hiding on screenshots etc
        ,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d8a29379bfa0b828$export$79dad7f65abf77d0), {
                _hover: showEditControls && {
                    cursor: "pointer",
                    backgroundColor: "yellow.100"
                },
                fontSize: "md",
                textAlign: "center",
                w: "100%",
                ...textStyle
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ddf28f2444832ff6$export$f5b8910cec6cf069), {
                as: fieldType === "text" ? (0, $6c3707fafeffcb54$export$bfb3cbb78d3c298) : (0, $e703e2734fe4eb45$export$67f7c9674b1fe02a),
                ...$820a2ba43b88e8a8$var$inputStyleDefaults,
                ...inputStyle,
                ...textStyle
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(EditableControls, {
                isLoading: isLoading
            })
        ]
    });
};
const $820a2ba43b88e8a8$var$iconStyleProps = {
    color: "gray.800",
    fontSize: "1em",
    size: "sm",
    variant: "ghost"
};
const $820a2ba43b88e8a8$var$inputStyleDefaults = {
    p: "0!important",
    m: "0!important",
    w: "100%",
    height: "auto",
    fontSize: "md",
    fontWeight: "inherit",
    display: "flex",
    color: "gray.600",
    border: "none",
    outline: "none",
    maxW: "800px",
    textAlign: "center"
};
const $820a2ba43b88e8a8$var$ERROR_TOAST = {
    title: "Error updating description",
    description: "Please check your connection and try again.",
    status: "error",
    // sad
    duration: 7000,
    isClosable: true,
    position: "top"
};
const $820a2ba43b88e8a8$var$SUCCESS_TOAST = {
    title: "Update made \uD83D\uDC4D",
    status: "success",
    // sad
    duration: 2000,
    isClosable: true,
    position: "top"
};




var $lDSNw = parcelRequire("lDSNw");
// a hook to handle all of the
const $a7fb1b2a3b6f3dc3$var$CREATIVE_BUILD_REF = {
    hangtime: (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("CAT3"),
    velocity: (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("Velocity").doc("beta").collection("v1")
};
const $a7fb1b2a3b6f3dc3$export$902d4c991a42811e = ({ buildId: buildId, format: format = "hangtime" })=>{
    const [annotations, setAnnotations] = (0, $lDSNw.useState)({});
    const [loading, setLoading] = (0, $lDSNw.useState)(true);
    const fetchAnnotations = async ()=>{
        try {
            setLoading(true);
            const doc = $a7fb1b2a3b6f3dc3$var$CREATIVE_BUILD_REF[format].doc(buildId);
            const snapshot = await doc.get();
            const data = snapshot.data()?.meta || {};
            setAnnotations(data);
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    const setAnnotation = async (key, value)=>{
        try {
            const doc = $a7fb1b2a3b6f3dc3$var$CREATIVE_BUILD_REF[format].doc(buildId);
            setLoading(true);
            await doc.set({
                meta: {
                    [key]: value
                }
            }, {
                merge: true
            });
            setLoading(false);
            setAnnotations({
                ...annotations,
                [key]: value
            });
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    (0, $lDSNw.useEffect)(()=>{
        if (!buildId) return;
        fetchAnnotations();
    }, [
        buildId
    ]);
    return {
        annotations: annotations,
        loading: loading,
        fetchAnnotations: fetchAnnotations,
        setAnnotation: setAnnotation
    };
};






function $bfb203ce0f8df31c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bfb203ce0f8df31c$export$3865e82159b2890b = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ef8zzxs2"
})({
    name: "1wwcwop",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;justify-items:center;gap:var(--space-4);width:100%"
});
const $bfb203ce0f8df31c$export$ecafa4fdc2696dca = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ef8zzxs1"
})({
    name: "b6wrti",
    styles: "display:flex;flex-direction:column;width:100%"
});
const $bfb203ce0f8df31c$export$22d03f919da772b6 = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)("div", {
    target: "ef8zzxs0"
})({
    name: "1m7a6kc",
    styles: "display:flex;flex-direction:row;align-items:center;align-content:center;justify-content:space-between;width:100%"
});


// const SnackBarAlert = withAlertsRender(SnackBar);
const $2b3798460e1a1c8e$var$Graph = ({ creative: creative, adProgress: adProgress, showMetric: showMetric, demoMode: demoMode })=>{
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const showDwellTime = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.showDwellTime);
    const startProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.startProgress);
    const endProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.endProgress);
    const setStartProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setStartProgress);
    const setEndProgress = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.setEndProgress);
    const [sequenceData, setSequenceData] = (0, $lDSNw.useState)([]);
    const iframeVideo = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.iframeVideo);
    const videoSequences = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.videoSequences);
    const videoDropOffBaseline = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.videoDropOffBaseline);
    const byDurationVideoDropOffBaselines = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.byDurationVideoDropOffBaselines);
    // -----------------------------------------------------
    // should be in presentation mode?
    const queryParams = new URLSearchParams(location.search);
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    // this is the URL param that is passed thorugh when gif-generator
    // is viewing the page to create a gif for the slide deck
    const { buildID: buildID, sequences: sequences, scrollMode: scrollMode, dwellTimes: dwellTimes, scrubBaseline: scrubBaseline, dwellTimeBaseline: dwellTimeBaseline, sessionSize: sessionSize, creativeFormat: creativeFormat, containsVideo: containsVideo, usingAggregatedData: usingAggregatedData } = creative;
    const isSampleCreative = buildID === "nayoyo";
    // for different formats we adjust the start and end points for the graph
    (0, $lDSNw.useEffect)(()=>{
        if (creativeFormat !== "hang-time") {
            setStartProgress(20);
            setEndProgress(75);
        } else if (isSampleCreative) {
            setStartProgress(0);
            setEndProgress(100);
        } else {
            setStartProgress(30);
            setEndProgress(65);
        }
    }, [
        creativeFormat,
        buildID
    ]);
    // Sequence and Baseline Data processing
    (0, $lDSNw.useEffect)(()=>{
        let creativeSequences = sequences;
        // in demoMode we still need to crunch the raw sequence data
        if (demoMode) creativeSequences = (0, $11d563350f5dc624$export$6c9dbc2dfbd602db)(sequences, scrollMode, startProgress, endProgress, sessionSize);
        const dataWithBaseline = creativeSequences.map((data, i)=>{
            return {
                ...data,
                dwellTimeBaseline: dwellTimeBaseline?.[i],
                scrubBaseline: scrubBaseline?.[i]
            };
        });
        setSequenceData(dataWithBaseline);
    }, [
        sequences,
        showDwellTime,
        scrollMode,
        startProgress,
        endProgress,
        sessionSize,
        dwellTimeBaseline,
        scrubBaseline,
        demoMode
    ]);
    const { annotations: annotations, setAnnotation: setAnnotation, loading: annotationsLoading } = (0, $a7fb1b2a3b6f3dc3$export$902d4c991a42811e)({
        buildId: buildID,
        format: "hangtime"
    });
    const hasMultipleTabs = showDwellTime || containsVideo;
    const defaultTabToDisplay = containsVideo ? "video" : "scrub";
    const [inViewPanel, setInViewPanel] = (0, $lDSNw.useState)(defaultTabToDisplay);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $bfb203ce0f8df31c$export$3865e82159b2890b), {
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $bfb203ce0f8df31c$export$ecafa4fdc2696dca), {
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                        display: isPresentationMode || !hasMultipleTabs ? "none" : "flex",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                                variant: inViewPanel === "scrub" ? "solid" : "outline",
                                borderWidth: "1px",
                                size: "sm",
                                onClick: ()=>{
                                    setInViewPanel("scrub");
                                },
                                children: "Scrub Chart"
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                                display: containsVideo ? "block" : "none",
                                size: "sm",
                                onClick: ()=>{
                                    setInViewPanel("video");
                                },
                                variant: inViewPanel === "video" ? "solid" : "outline",
                                borderWidth: "1px",
                                children: "Video Chart"
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                                display: showDwellTime ? "block" : "none",
                                size: "sm",
                                variant: inViewPanel === "dwell" ? "solid" : "outline",
                                borderWidth: "1px",
                                onClick: ()=>{
                                    setInViewPanel("dwell");
                                },
                                children: "Dwell Chart"
                            })
                        ]
                    }),
                    inViewPanel === "scrub" && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($2b3798460e1a1c8e$var$ChartBox, {
                        pt: isPresentationMode ? "0" : "4",
                        pl: isPresentationMode ? "0" : "8",
                        pr: isPresentationMode ? "0" : "12",
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $81a2471855a1299c$export$2e2bcd8739ae039), {
                            adProgress: adProgress,
                            data: sequenceData,
                            scrubBaseline: scrubBaseline,
                            dwellTimeBaseline: dwellTimeBaseline,
                            startProgress: startProgress,
                            endProgress: endProgress,
                            showBaseline: !isSampleCreative && !demoMode,
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($2b3798460e1a1c8e$var$EditableDescVStack, {
                                display: isPresentationMode ? "none" : "flex",
                                mt: "-6",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                                        showEditControls: userInfo?.loggedIn,
                                        onEdit: (value)=>setAnnotation("scrubChartDesc", value),
                                        value: annotations?.scrubChartDesc,
                                        isLoading: annotationsLoading
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aabe32da29ab7737$export$f54a093675066994).Hangtime, {})
                                ]
                            })
                        })
                    }),
                    inViewPanel === "video" && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($2b3798460e1a1c8e$var$ChartBox, {
                        pt: isPresentationMode ? "0" : "4",
                        pl: isPresentationMode ? "0" : "8",
                        pr: isPresentationMode ? "0" : "12",
                        children: containsVideo && iframeVideo && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4b332390c9f221f8$export$2e2bcd8739ae039), {
                            showBaseline: !isSampleCreative && !demoMode,
                            buildID: buildID,
                            iframeVideo: iframeVideo,
                            videoSequences: usingAggregatedData ? videoSequences : Object.values(videoSequences)[0],
                            videoDropOffBaseline: videoDropOffBaseline,
                            byDurationVideoDropOffBaselines: byDurationVideoDropOffBaselines
                        })
                    }),
                    inViewPanel === "dwell" && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($2b3798460e1a1c8e$var$ChartBox, {
                        pt: isPresentationMode ? "0" : "4",
                        pl: isPresentationMode ? "0" : "8",
                        pr: isPresentationMode ? "0" : "12",
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $58ce4ab6bb5823e6$export$2e2bcd8739ae039), {
                            adProgress: adProgress,
                            data: sequenceData.map((sequence, i)=>{
                                const combined = sequence;
                                combined.dwellTime = dwellTimes[i].dwellTime;
                                return combined;
                            }),
                            scrubBaseline: scrubBaseline,
                            dwellTimeBaseline: dwellTimeBaseline,
                            startProgress: startProgress,
                            endProgress: endProgress
                        })
                    })
                ]
            })
        })
    });
};
const $2b3798460e1a1c8e$var$ChartBox = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        w: "100%",
        h: "100%",
        as: (0, $0a9a7dc0535ece35$export$e25e478948902b8b).div,
        gap: "0",
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        ...rest,
        children: children
    });
};
const $2b3798460e1a1c8e$var$EditableDescVStack = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
        className: "editable-description-container",
        px: "16",
        pb: "6",
        w: "100%",
        gap: "1.5",
        ...rest,
        children: children
    });
};
var $2b3798460e1a1c8e$export$2e2bcd8739ae039 = $2b3798460e1a1c8e$var$Graph;






// import { mountStoreDevtool } from "simple-zustand-devtools";
const $519e9fb0795f028d$export$d063033a2d9cec01 = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        attentionTime: "loading...",
        benchmarkEngagementRate: 0,
        benchmarkEngagedAttentionTime: 0,
        engagementRate: "loading...",
        engagedAttentionTime: "loading...",
        fetchMetrics: async (creativeID, domainWhiteList = [])=>{
            set({
                engagementRate: "loading...",
                engagedAttentionTime: "loading...",
                attentionTime: "loading..."
            });
            if (creativeID) {
                const { attentionTime: attentionTime, benchmarkEngagementRate: benchmarkEngagementRate, benchmarkEngagedAttentionTime: benchmarkEngagedAttentionTime, engagementRate: engagementRate, engagedAttentionTime: engagedAttentionTime, creatives: creatives } = await (0, $defc3f76c7e5931b$export$f5417e9be50ddb9b)(creativeID, domainWhiteList);
                set({
                    attentionTime: attentionTime,
                    benchmarkEngagementRate: benchmarkEngagementRate,
                    benchmarkEngagedAttentionTime: benchmarkEngagedAttentionTime,
                    engagementRate: engagementRate,
                    engagedAttentionTime: engagedAttentionTime,
                    creatives: creatives
                });
            }
        }
    }));









const $687f59f63f20e56e$var$SnackBarAlert = (0, $0b21e37f51b583f7$export$19dbccc67153f737)((0, $86896944c76a0602$export$b7063aba2b72bcec));
const $687f59f63f20e56e$var$CreativeViewer = (props)=>{
    // LOCAL STATES
    const [qrExpand, setQrExpand] = (0, $lDSNw.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $lDSNw.useState)();
    const [creativeScrolled, setCreativeScrolled] = (0, $lDSNw.useState)(false);
    // GLOBAL STATES
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const setMissingDemoCreative = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.setMissingDemoCreative);
    const setIframeVideoProgress = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.setIframeVideoProgress);
    const creatives = (0, $519e9fb0795f028d$export$d063033a2d9cec01)((state)=>state.creatives);
    const attentionTime = (0, $519e9fb0795f028d$export$d063033a2d9cec01)((state)=>state.attentionTime);
    const buildID = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.buildID);
    const sequences = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.sequences);
    const scrollMode = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.scrollMode);
    const dwellTimes = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.dwellTimes);
    const scriptVersion = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.scriptVersion);
    const domains = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.domains);
    const scrubBaseline = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.scrubBaseline);
    const dwellTimeBaseline = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.dwellTimeBaseline);
    const sessionSize = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.sessionSize);
    const videoSequences = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.videoSequences);
    const setFormatObject = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.setFormatObject);
    const setIframeVideo = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.setIframeVideo);
    const setBuildID = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.setBuildID);
    const clearBuildID = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.clearBuildID);
    const brandNames = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.brandNames);
    const campaignNames = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.campaignNames);
    const creativeNames = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.creativeNames);
    const usingAggregatedData = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.usingAggregatedData);
    const errorLoadingCreative = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.errorLoadingCreative);
    let creativeFormat = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.format); // overwriten if demo mode
    let vertical = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.vertical);
    const location = (0, $5058ffe240ffde31$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const iframeSrcDoc = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.iframeSrcDoc);
    const fetchIframeSourceDoc = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.fetchIframeSourceDoc);
    const clearIframe = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.clearIframe);
    const detachDemoDatabase = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.detachDemoDatabase);
    const loadCreativeSequences = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.loadCreativeSequences);
    const clearSequences = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.clearSequences);
    const creativeScrollProgress = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.creativeScrollProgress);
    const setCreativeScrollProgress = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.setCreativeScrollProgress);
    const containsVideo = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.containsVideo);
    const domainsList = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.domainsList);
    const defaultBaseline = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.defaultBaseline);
    const setBaseline = (0, $ece625921076c11d$export$311f681dd6bb3e49)((state)=>state.setBaseline);
    const minSequenceLength = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.minSequenceLength);
    const triggerType = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.triggerType);
    const domainWhiteList = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.domainWhiteList);
    // Hardcoding the creativeFormat for now, since the demo creative
    // doesn't have one.
    if (props.demoMode) creativeFormat = "hang-time";
    const iframeOnLoadHandler = async (e)=>{
        let eTarget = e.target;
        if (!eTarget.contentWindow.document.getElementById("middle-ad")) return;
        const iframeWindow = eTarget.contentWindow;
        if (iframeWindow.length) {
            let targetFrame = iframeWindow.document.getElementById("middle-ad").getElementsByTagName("iframe")[0];
            let format = targetFrame.contentWindow.xyzContext.dimension.creative.format;
            let camelCaseFormat = format.replace(/-([a-z])/g, function(g) {
                return g[1].toUpperCase();
            });
            let formatObject = targetFrame.contentWindow[camelCaseFormat] || targetFrame.contentWindow.format;
            setFormatObject(formatObject);
            let foundVideo = false;
            const checkVideoElement = ()=>{
                if (containsVideo && !foundVideo) {
                    let videoElement = null;
                    if (formatObject.catVideo || formatObject.video) {
                        foundVideo = true;
                        switch(format){
                            case "hang-time":
                                videoElement = formatObject.catVideo || formatObject.video.container.childNodes[0];
                                break;
                            case "video-switch":
                                videoElement = formatObject.catVideo || formatObject.video;
                                // overriding the regular video switch jump to long version
                                // by adding a loop to the S, M or L that is being viewed.
                                videoElement.loop = true;
                                break;
                            default:
                                videoElement = null;
                        }
                        setIframeVideo(videoElement);
                        // To keep the video progress updating smoothly in the videoChart
                        // we need to set a shorter interval than the 250ms offered by
                        // 'timeupdate' events.
                        let videoWatcher = setInterval(()=>{
                            if ((0, $f93c997b56f0c027$export$1bcd6871fa54402c)(videoElement)) setIframeVideoProgress(videoElement.currentTime / videoElement.duration * 100);
                        }, 25);
                        targetFrame.addEventListener("beforeunload", function() {
                            clearInterval(videoWatcher);
                        });
                    }
                }
            };
            // We need to wait for the video to be injected into the
            // creative access the video element for play/pause controls
            iframeWindow.addEventListener("scroll", (ev)=>{
                iframeScrollHandler(ev);
                checkVideoElement();
            });
            // For formats other than hangtime, the load times of the nested iframes
            // can cause the viewer to check for .xyz-overlay before it has loaded.
            // checkForElement is halting the below code (controlling the scroll to
            // the creative) executing until that element is present - not an ideal
            // solution but working...
            await (0, $f93c997b56f0c027$export$74265bcf7deb1b4)(iframeWindow, ".xyz-overlay");
            const xyzOverlay = iframeWindow.document.body.getElementsByClassName("xyz-overlay")[0];
            const top = xyzOverlay.getBoundingClientRect().top;
            const $target = (0, (/*@__PURE__*/$parcel$interopDefault($47583530b0c2cd74$exports)))(eTarget);
            $target.contents().children().scrollTop(800);
            let scrollDistance = 100;
            if (format === "video-switch") scrollDistance = 1400;
            else if (format === "hover-board") scrollDistance = -150;
            $target.contents().children().animate({
                scrollTop: top + scrollDistance
            }, 1500, "swing");
            if (containsVideo && !foundVideo && document.hidden) {
                const visibilityHandler = ()=>{
                    if (!document.hidden) {
                        console.log("Tab is in the foreground");
                        checkVideoElement();
                        let videoCheckCounter = 0;
                        const checkVideoTimer = setInterval(()=>{
                            checkVideoElement();
                            if (foundVideo) {
                                document.removeEventListener("visibilitychange", visibilityHandler);
                                clearInterval(checkVideoTimer);
                            }
                            // check for video element in the creative
                            if (videoCheckCounter > 20) {
                                console.warn("Video not found in creative");
                                document.removeEventListener("visibilitychange", visibilityHandler);
                                clearInterval(checkVideoTimer);
                            }
                            videoCheckCounter++;
                        }, 250);
                    }
                };
                document.addEventListener("visibilitychange", visibilityHandler);
            }
        }
    };
    const iframeScrollHandler = (e)=>{
        const seamlessFrame = e.target.getElementById("middle-ad").getElementsByTagName("iframe")[0];
        let frameFormat = seamlessFrame.contentWindow.xyzContext.dimension.creative.format;
        const format = frameFormat.includes("-") ? (0, $f93c997b56f0c027$export$56b99a300be83d83)(seamlessFrame.contentWindow.xyzContext.dimension.creative.format) : frameFormat;
        // adjusted the below to .cat.timeline to support adding formats that
        // do not keep the timeline value updated on the main format object
        let progress = scrollMode === "timeline" ? seamlessFrame.contentWindow[format] ? seamlessFrame.contentWindow[format].timeline || seamlessFrame.contentWindow[format].cat.timeline : seamlessFrame.contentWindow.format.timeline || seamlessFrame.contentWindow.format.cat.timeline : seamlessFrame.contentWindow[format] ? seamlessFrame.contentWindow[format].progress : seamlessFrame.contentWindow.format.progress;
        setCreativeScrollProgress(progress);
    };
    const QRClickHandler = ()=>{
        (0, $d712a5077c581ffa$export$c96b87a5365cb76c).creativeQrExpand(buildID, !qrExpand ? "expand" : "collapse");
        setQrExpand(!qrExpand);
    };
    // LIFE CYCLE EVENTS
    // here we're forcing the buildID to always be the parent studio buildID, even if
    // the user is requesting via an adBuyId or creativeId
    const checkedBuildID = (0, $5e2e7dfba3eb8bc8$export$2e2bcd8739ae039)(props.match.params.creativeID);
    // Set buildID state when props changed
    (0, $lDSNw.useEffect)(()=>{
        if (props.demoMode && userInfo.loggedIn) {
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).demoViewed();
            const matchingUser = (0, $fa80e68d246605f9$export$3a8aaff34855e439).filter((userMeta)=>{
                return props.userEmail.toLowerCase().includes(userMeta.email.toLowerCase()) || userMeta.email.toLowerCase().includes(props.userEmail.toLowerCase());
            });
            if (matchingUser.length) {
                const demoCreativeID = matchingUser[0].demoCreativeID;
                setBuildID(demoCreativeID);
            } else {
                (0, $d712a5077c581ffa$export$c96b87a5365cb76c).demoNoCreative();
                setMissingDemoCreative(true);
            }
        } else if (checkedBuildID) setBuildID(checkedBuildID);
    }, [
        props.mode,
        props.demoMode,
        props.match.params.creativeID,
        props.userEmail,
        userInfo.loggedIn,
        checkedBuildID
    ]);
    // fetch iframe source doc when build id changes
    (0, $lDSNw.useEffect)(()=>{
        if (buildID) {
            // set title to buildID
            document.title = `CAT report - ${buildID}`;
            // Analytics - log creative viewed
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).creativeViewed(buildID);
            try {
                // if there is a preview ID override in query params, we'll use that
                if (queryParams.has("preview")) {
                    const previewID = queryParams.get("preview");
                    fetchIframeSourceDoc(previewID);
                } else // otherwise we'll use the buildID as normal
                fetchIframeSourceDoc(buildID);
            } catch (error) {
                setErrorMessage(error);
            }
            return ()=>{
                document.title = "CAT";
            };
        }
    }, [
        buildID
    ]);
    // load sequences when setBuildID or minSequenceLength changes
    (0, $lDSNw.useEffect)(()=>{
        if (buildID) try {
            loadCreativeSequences(buildID, minSequenceLength, triggerType, [], props.demoMode && userInfo.loggedIn);
        } catch (error) {
            setErrorMessage(error);
        }
    }, [
        minSequenceLength,
        props.demoMode,
        userInfo.loggedIn,
        buildID,
        triggerType
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (buildID) loadCreativeSequences(buildID, 1, "scrub", domainWhiteList);
    }, [
        domainWhiteList
    ]);
    const baselineOverride = (0, $a3a72dde8926071a$export$a1279bd7c7d1f05d)((state)=>state.baselineOverride);
    (0, $lDSNw.useEffect)(()=>{
        setBaseline(baselineOverride);
    }, [
        baselineOverride
    ]);
    // general unmount clear useless states preventing pollution. for real!
    (0, $lDSNw.useEffect)(()=>{
        return ()=>{
            if (props.demoMode) detachDemoDatabase(buildID);
            clearIframe();
            clearSequences();
            clearBuildID();
        };
    }, []);
    // Any way to move these into a seperate file to not clog up this one?
    // custom hooks?
    // analytics - scrolled
    (0, $lDSNw.useEffect)(()=>{
        if (creativeScrollProgress > 50 && creativeScrolled === false) {
            setCreativeScrolled(true);
            (0, $d712a5077c581ffa$export$c96b87a5365cb76c).creativePreviewScrubed(buildID);
        }
    }, [
        creativeScrollProgress
    ]);
    // analytics - viewed
    (0, $lDSNw.useEffect)(()=>{
        if (sessionSize > 0) (0, $d712a5077c581ffa$export$c96b87a5365cb76c).creativeSessionsLoaded(buildID, false, sessionSize, creativeFormat ?? "unknown");
    }, [
        sessionSize
    ]);
    // alerts and errors
    const zeroMetricError = attentionTime === 0;
    // -----------------------------------------------------
    // should be in presentation mode?
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    // this is the URL param that is passed thorugh when gif-generator
    // is viewing the page to create a gif for the slide deck
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
        width: "100vw",
        height: isPresentationMode ? "100vh" : "calc(100vh - 50px)",
        pt: isPresentationMode ? "0" : "50px",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $ed9d7c0ede8e1182$export$82431628d8b8c126), {
                display: isPresentationMode ? "none" : "flex",
                title: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $99ceae00e3750c32$export$5f1af8db9871e1d6), {
                    type: "body02",
                    as: "span",
                    children: [
                        "Cat Report \xa0",
                        creativeFormat && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $21f7d76a059ae835$export$a6c7ac8248d6e38a), {
                            href: (0, $f93c997b56f0c027$export$621e425396705b25)(buildID, creativeFormat) || "#",
                            title: "Preview this ad in a new tab",
                            maxWidth: "200px",
                            target: "_blank",
                            children: creativeNames
                        })
                    ]
                }),
                sessionSize: sessionSize,
                minSessions: 5000,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d8c48a7438123691$export$2479ffe3e021e6e9), {
                        buildId: buildID
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $df098d69721f4386$export$2e2bcd8739ae039), {
                        description: "Share a link to this CAT report",
                        content: "Share",
                        buildIDs: [
                            buildID
                        ],
                        url: window.location.href
                    }),
                    userInfo.loggedIn && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $7c10c71055b2923e$export$2e2bcd8739ae039), {
                        buildID: buildID,
                        userID: userInfo.id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                id: "creative-viewer-container",
                maxWidth: isPresentationMode ? "100%" : "var(--maxScreenWidth)",
                alignItems: "flex-start",
                width: "100%",
                height: "100%",
                children: [
                    !errorLoadingCreative && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d8c48a7438123691$export$110709f040143804), {
                        p: isPresentationMode ? 0 : undefined,
                        borderRight: isPresentationMode ? "none" : "1px solid var(--colors-neutral-4)",
                        children: creativeFormat && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2ac71661ebc4b3c3$export$2e2bcd8739ae039), {
                            srcDoc: iframeSrcDoc,
                            creativeFormat: creativeFormat,
                            onLoadHandler: iframeOnLoadHandler,
                            creativeID: buildID,
                            sessionSize: sessionSize,
                            attentionTime: attentionTime,
                            scriptVersion: scriptVersion,
                            creativeNames: creativeNames,
                            brandNames: brandNames,
                            campaignNames: campaignNames,
                            isLoading: false,
                            isLegacy: true
                        })
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d8c48a7438123691$export$364a989a35814102), {
                        children: props.demoMode || creativeFormat ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2b3798460e1a1c8e$export$2e2bcd8739ae039), {
                                    creative: {
                                        buildID: buildID,
                                        sequences: sequences,
                                        scrollMode: scrollMode,
                                        creatives: creatives,
                                        dwellTimes: dwellTimes,
                                        scrubBaseline: scrubBaseline,
                                        dwellTimeBaseline: dwellTimeBaseline,
                                        sessionSize: sessionSize,
                                        creativeFormat: creativeFormat,
                                        videoSequences: videoSequences,
                                        containsVideo: containsVideo,
                                        vertical: vertical,
                                        usingAggregatedData: usingAggregatedData
                                    },
                                    adProgress: creativeScrollProgress,
                                    showMetric: true,
                                    demoMode: props.demoMode
                                }),
                                props.demoMode && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ad11f00ae4a3656b$export$2e2bcd8739ae039), {})
                            ]
                        }) : errorLoadingCreative ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92d9d78e175a9034$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6d34caa3f6c24444$export$e854a2165401836f), {
                            size: "s"
                        })
                    })
                ]
            }),
            userInfo.loggedIn && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $054b67e2ceabb83e$export$2e2bcd8739ae039), {
                display: isPresentationMode ? "none" : "flex",
                domainsList: domains ? domains : [],
                dwellTimes: dwellTimes,
                defaultBaseline: defaultBaseline
            }),
            !!errorMessage && !props.demoMode && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($687f59f63f20e56e$var$SnackBarAlert, {
                title: errorMessage ? `${errorMessage}` : `We couldn't find your chart at this time.`,
                status: "error"
            }),
            !!props.demoMode && sessionSize <= 1 && !userInfo.missingDemoCreative && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($687f59f63f20e56e$var$SnackBarAlert, {
                title: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
                    children: [
                        "This demo creative doesn't have any recorded sessions. Scan\xa0",
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $21f7d76a059ae835$export$a6c7ac8248d6e38a), {
                            onClick: ()=>setQrExpand(!qrExpand),
                            children: "the QR code"
                        }),
                        "\xa0 to start gathering data ↗"
                    ]
                }),
                status: "warning"
            }),
            !!props.demoMode && !!userInfo.missingDemoCreative && !!userInfo.loggedIn && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($687f59f63f20e56e$var$SnackBarAlert, {
                title: "Pssstt... you should ask Andrea to setup a demo creative for your account.",
                delayToClose: 8000,
                status: "warning"
            }),
            zeroMetricError && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($687f59f63f20e56e$var$SnackBarAlert, {
                title: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
                    children: "We're having some issues fetching the metrics for this creative. Sorry! Please check back a little later."
                }),
                status: "warning"
            })
        ]
    });
};
const $687f59f63f20e56e$var$CreativeViewerWithRouter = (0, $5058ffe240ffde31$export$369b6b2b30582e8e)($687f59f63f20e56e$var$CreativeViewer);
var $687f59f63f20e56e$export$2e2bcd8739ae039 = $687f59f63f20e56e$var$CreativeViewerWithRouter;







var $lDSNw = parcelRequire("lDSNw");

function $6514dfe9493a8613$export$e51b731bc9951cc1(buildID) {
    const [dcoData, setDcoData] = (0, $lDSNw.useState)({});
    const [isLoading, setIsLoading] = (0, $lDSNw.useState)(true);
    (0, $lDSNw.useEffect)(()=>{
        (0, $abbc57578fc5f1d4$export$899b73fa4a791c00)(buildID).then((data)=>{
            setDcoData(data);
            setIsLoading(false);
        });
    }, []);
    return [
        dcoData,
        isLoading
    ];
}




var $lDSNw = parcelRequire("lDSNw");



var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
const $1a794e13b7b9edd4$export$2b8a1fb072f61d10 = (0, $lDSNw.createContext)(null);






function $a30d1377b53035b5$export$bdf3520827dcd47e(order, value, offset, velocity) {
    if (!velocity) return order;
    const index = order.findIndex((item)=>item.value === value);
    if (index === -1) return order;
    const nextOffset = velocity > 0 ? 1 : -1;
    const nextItem = order[index + nextOffset];
    if (!nextItem) return order;
    const item = order[index];
    const nextLayout = nextItem.layout;
    const nextItemCenter = (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(nextLayout.min, nextLayout.max, 0.5);
    if (nextOffset === 1 && item.layout.max + offset > nextItemCenter || nextOffset === -1 && item.layout.min + offset < nextItemCenter) return (0, $400b44de453c8d64$export$ec937e64de6c1257)(order, index, index + nextOffset);
    return order;
}


function $af07d5aff3e1dd00$export$be27b7672e0f20ab({ children: children, as: as = "ul", axis: axis = "y", onReorder: onReorder, values: values, ...props }, externalRef) {
    const Component = (0, $2f15184e95154688$export$fe4300aa8eebea86)(()=>(0, $0a9a7dc0535ece35$export$e25e478948902b8b)(as));
    const order = [];
    const isReordering = (0, $lDSNw.useRef)(false);
    (0, $30298752de581a70$export$f5708dca728d7177)(Boolean(values), "Reorder.Group must be provided a values prop");
    const context = {
        axis: axis,
        registerItem: (value, layout)=>{
            /**
             * Ensure entries can't add themselves more than once
             */ if (layout && order.findIndex((entry)=>value === entry.value) === -1) {
                order.push({
                    value: value,
                    layout: layout[axis]
                });
                order.sort($af07d5aff3e1dd00$var$compareMin);
            }
        },
        updateOrder: (id, offset, velocity)=>{
            if (isReordering.current) return;
            const newOrder = (0, $a30d1377b53035b5$export$bdf3520827dcd47e)(order, id, offset, velocity);
            if (order !== newOrder) {
                isReordering.current = true;
                onReorder(newOrder.map($af07d5aff3e1dd00$var$getValue).filter((value)=>values.indexOf(value) !== -1));
            }
        }
    };
    (0, $lDSNw.useEffect)(()=>{
        isReordering.current = false;
    });
    return $lDSNw.createElement(Component, {
        ...props,
        ref: externalRef,
        ignoreStrict: true
    }, $lDSNw.createElement((0, $1a794e13b7b9edd4$export$2b8a1fb072f61d10).Provider, {
        value: context
    }, children));
}
const $af07d5aff3e1dd00$export$eb2fcfdbd7ba97d4 = (0, $lDSNw.forwardRef)($af07d5aff3e1dd00$export$be27b7672e0f20ab);
function $af07d5aff3e1dd00$var$getValue(item) {
    return item.value;
}
function $af07d5aff3e1dd00$var$compareMin(a, b) {
    return a.layout.min - b.layout.min;
}




var $lDSNw = parcelRequire("lDSNw");




var $lDSNw = parcelRequire("lDSNw");



/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $f15e70f9a053973a$export$15b697acf84c78b9(initial) {
    const value = (0, $2f15184e95154688$export$fe4300aa8eebea86)(()=>(0, $efd4ea1cd2d913bc$export$ce8bdc721e76545f)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ const { isStatic: isStatic } = (0, $lDSNw.useContext)((0, $85eb84fe60111644$export$22a697fb29aac98d));
    if (isStatic) {
        const [, setLatest] = (0, $lDSNw.useState)(initial);
        (0, $lDSNw.useEffect)(()=>value.on("change", setLatest), []);
    }
    return value;
}



const $8cc64c9c779f9f49$var$isCustomValueType = (v)=>{
    return typeof v === "object" && v.mix;
};
const $8cc64c9c779f9f49$var$getMixer = (v)=>$8cc64c9c779f9f49$var$isCustomValueType(v) ? v.mix : undefined;
function $8cc64c9c779f9f49$export$51186ad6e864892a(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0, $5fa77b345479d9bc$export$89e29e4ab65e70a9)(inputRange, outputRange, {
        mixer: $8cc64c9c779f9f49$var$getMixer(outputRange[0]),
        ...options
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}





function $9962a020b86525d6$export$7dee4fa9fc2b33f3(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */ const value = (0, $f15e70f9a053973a$export$15b697acf84c78b9)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */ const updateValue = ()=>value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */ updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */ (0, $b31fc856a06471a3$export$700979bc83e7db82)(()=>{
        const scheduleUpdate = ()=>(0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(updateValue, false, true);
        const subscriptions = values.map((v)=>v.on("change", scheduleUpdate));
        return ()=>{
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            (0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(updateValue);
        };
    });
    return value;
}



function $2b6c3e16a91db55a$export$a87ba948fb2b39ec(input, inputRangeOrTransformer, outputRange, options) {
    const transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : (0, $8cc64c9c779f9f49$export$51186ad6e864892a)(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input) ? $2b6c3e16a91db55a$var$useListTransform(input, transformer) : $2b6c3e16a91db55a$var$useListTransform([
        input
    ], ([latest])=>transformer(latest));
}
function $2b6c3e16a91db55a$var$useListTransform(values, transformer) {
    const latest = (0, $2f15184e95154688$export$fe4300aa8eebea86)(()=>[]);
    return (0, $9962a020b86525d6$export$7dee4fa9fc2b33f3)(values, ()=>{
        latest.length = 0;
        const numValues = values.length;
        for(let i = 0; i < numValues; i++)latest[i] = values[i].get();
        return transformer(latest);
    });
}



function $2db59b21f11650fb$var$useDefaultMotionValue(value, defaultValue = 0) {
    return (0, $1a0ef3d59b00772c$export$605d60a2578142d3)(value) ? value : (0, $f15e70f9a053973a$export$15b697acf84c78b9)(defaultValue);
}
function $2db59b21f11650fb$export$dfd959aaaf2d771a({ children: children, style: style = {}, value: value, as: as = "li", onDrag: onDrag, layout: layout = true, ...props }, externalRef) {
    const Component = (0, $2f15184e95154688$export$fe4300aa8eebea86)(()=>(0, $0a9a7dc0535ece35$export$e25e478948902b8b)(as));
    const context = (0, $lDSNw.useContext)((0, $1a794e13b7b9edd4$export$2b8a1fb072f61d10));
    const point = {
        x: $2db59b21f11650fb$var$useDefaultMotionValue(style.x),
        y: $2db59b21f11650fb$var$useDefaultMotionValue(style.y)
    };
    const zIndex = (0, $2b6c3e16a91db55a$export$a87ba948fb2b39ec)([
        point.x,
        point.y
    ], ([latestX, latestY])=>latestX || latestY ? 1 : "unset");
    const measuredLayout = (0, $lDSNw.useRef)(null);
    (0, $30298752de581a70$export$f5708dca728d7177)(Boolean(context), "Reorder.Item must be a child of Reorder.Group");
    const { axis: axis, registerItem: registerItem, updateOrder: updateOrder } = context;
    (0, $lDSNw.useEffect)(()=>{
        registerItem(value, measuredLayout.current);
    }, [
        context
    ]);
    return $lDSNw.createElement(Component, {
        drag: axis,
        ...props,
        dragSnapToOrigin: true,
        style: {
            ...style,
            x: point.x,
            y: point.y,
            zIndex: zIndex
        },
        layout: layout,
        onDrag: (event, gesturePoint)=>{
            const { velocity: velocity } = gesturePoint;
            velocity[axis] && updateOrder(value, point[axis].get(), velocity[axis]);
            onDrag && onDrag(event, gesturePoint);
        },
        onLayoutMeasure: (measured)=>{
            measuredLayout.current = measured;
        },
        ref: externalRef,
        ignoreStrict: true
    }, children);
}
const $2db59b21f11650fb$export$6d08773d2e66f8f2 = (0, $lDSNw.forwardRef)($2db59b21f11650fb$export$dfd959aaaf2d771a);


const $df0a6ddd7916717b$export$335fca4219867448 = {
    Group: $af07d5aff3e1dd00$export$eb2fcfdbd7ba97d4,
    Item: $2db59b21f11650fb$export$6d08773d2e66f8f2
};





var $f60f43e206f6ad67$export$f10d6a896d4ffbcf;
var $f60f43e206f6ad67$export$db8b3cda9846c2d1;
var $f60f43e206f6ad67$export$1391212d75b2ee65;
var $f60f43e206f6ad67$export$cefd6aa31297bf18;
var $f60f43e206f6ad67$export$b65312caea8950cc;
var $f60f43e206f6ad67$export$33cacb20a48e02bf;
var $f60f43e206f6ad67$export$31d8f5e76b42bed9;
var $f60f43e206f6ad67$export$85a9d61b61b2ebd7;
function $f60f43e206f6ad67$var$delay(ms, cb) {
    return new Promise((resolve)=>{
        const id = setTimeout(()=>{
            clearTimeout(id);
            if (cb) cb();
            resolve();
        }, ms);
    });
}
// dodgy - just need to reference this in multiple places so just want it set once
const $f60f43e206f6ad67$var$heatmapColors = [
    100,
    200,
    300,
    400,
    500,
    600
];
function $f60f43e206f6ad67$var$getBrightness(value) {
    const brightnessArray = $f60f43e206f6ad67$var$heatmapColors;
    const brightnessIndex = $f60f43e206f6ad67$var$getClosestIndex(value, brightnessArray);
    return brightnessArray[brightnessIndex];
}
function $f60f43e206f6ad67$var$getClosestIndex(value, arr) {
    let closestIndex = 0;
    let closestDifference = Math.abs(value - arr[0]);
    for(let i = 1; i < arr.length; i++){
        const difference = Math.abs(value - arr[i]);
        if (difference < closestDifference) {
            closestDifference = difference;
            closestIndex = i;
        }
    }
    return closestIndex;
}
function $f60f43e206f6ad67$var$changeArrayRange(arr) {
    const newMin = $f60f43e206f6ad67$var$heatmapColors[0];
    const newMax = $f60f43e206f6ad67$var$heatmapColors[$f60f43e206f6ad67$var$heatmapColors.length - 1];
    // Find the current minimum and maximum values in the array
    const currentMin = Math.min(...arr);
    const currentMax = Math.max(...arr);
    // Calculate the range of the current values
    const currentRange = currentMax - currentMin;
    // Calculate the range of the new values
    const newRange = newMax - newMin;
    // Iterate over the array and reassign the values
    const transformedArray = arr.map((value)=>{
        // Calculate the percentage of the current value within the current range
        const percentage = (value - currentMin) / currentRange;
        // Map the percentage to the new range and add the new minimum
        const transformedValue = percentage * newRange + newMin;
        // Round the transformed value to the nearest integer
        return Math.round(transformedValue);
    });
    return transformedArray;
}
/*
 * Returns a color (red, green, gray) based on the value.
 */ function $f60f43e206f6ad67$var$valueToColor(value, style = "light") {
    if (style === "light") return value > 0 ? "green.400" : value < 0 ? "red.300" : "gray.400";
    if (style === "dark") return value > 0 ? "green.600" : value < 0 ? "red.600" : "gray.500";
}
function $f60f43e206f6ad67$var$findClosestIndex(array, value) {
    // Normalize the value to the number of indexes in the array
    const normalizedValue = value * (array.length - 1);
    // Find the closest index
    let closestIndex = 0;
    let closestDifference = Math.abs(normalizedValue - closestIndex);
    for(let i = 1; i < array.length; i++){
        const difference = Math.abs(normalizedValue - i);
        if (difference < closestDifference) {
            closestIndex = i;
            closestDifference = difference;
        }
    }
    return closestIndex;
}
function $f60f43e206f6ad67$var$playHistory(history, setValue, speed = 500) {
    for(let i = 0; i < history.length; i++)$f60f43e206f6ad67$var$delay(speed * i, ()=>setValue(i));
}
/**
 * Calculates in percent, the change between 2 numbers.
 * e.g from 1000 to 500 = 50%
 *
 * @param oldNumber The initial value
 * @param newNumber The value that changed
 */ function $f60f43e206f6ad67$var$getPercentageChange(oldNumber, newNumber) {
    var decreaseValue = oldNumber - newNumber;
    return decreaseValue / oldNumber * 100;
}
$f60f43e206f6ad67$export$f10d6a896d4ffbcf = $f60f43e206f6ad67$var$getPercentageChange;
$f60f43e206f6ad67$export$db8b3cda9846c2d1 = $f60f43e206f6ad67$var$findClosestIndex;
$f60f43e206f6ad67$export$1391212d75b2ee65 = $f60f43e206f6ad67$var$delay;
$f60f43e206f6ad67$export$cefd6aa31297bf18 = $f60f43e206f6ad67$var$valueToColor;
$f60f43e206f6ad67$export$b65312caea8950cc = $f60f43e206f6ad67$var$getClosestIndex;
$f60f43e206f6ad67$export$33cacb20a48e02bf = $f60f43e206f6ad67$var$getBrightness;
$f60f43e206f6ad67$export$31d8f5e76b42bed9 = $f60f43e206f6ad67$var$changeArrayRange;
$f60f43e206f6ad67$export$85a9d61b61b2ebd7 = $f60f43e206f6ad67$var$playHistory;






"use client";
var $596f68ba801b1475$export$1f54913ccc4368b1 = (0, $5c12d9132a121f51$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
});
$596f68ba801b1475$export$1f54913ccc4368b1.displayName = "Center";
var $596f68ba801b1475$var$centerStyles = {
    horizontal: {
        insetStart: "50%",
        transform: "translateX(-50%)"
    },
    vertical: {
        top: "50%",
        transform: "translateY(-50%)"
    },
    both: {
        insetStart: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)"
    }
};
var $596f68ba801b1475$export$335dd19f2cdf1a5c = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function AbsoluteCenter2(props, ref) {
    const { axis: axis = "both", ...rest } = props;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: $596f68ba801b1475$var$centerStyles[axis],
        ...rest,
        position: "absolute"
    });
});


const $575803f9d0a14b84$export$f7b0227af4862dc0 = ({ children: children, CustomIcon: CustomIcon, color: color = "#718096", width: // Chakra gray.500
width = "24px", height: height = "24px", padding: padding = "4px", ...props })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $596f68ba801b1475$export$1f54913ccc4368b1), {
        padding: padding,
        borderRadius: "3",
        backgroundColor: `${color}20`,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
            as: CustomIcon,
            color: color,
            w: width,
            h: height
        })
    });
};





const $856e61fba54672e0$export$773623a5e66bea38 = ({ value: value, startValue: startValue, size: size = "xs" })=>{
    const percentageChange = Math.round((0, $f60f43e206f6ad67$export$f10d6a896d4ffbcf)(value, startValue));
    const color = (0, $f60f43e206f6ad67$export$cefd6aa31297bf18)(percentageChange, "dark");
    const formatted = value > startValue ? `+${percentageChange}%` : `${percentageChange}%`;
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
        fontSize: size,
        color: color,
        children: formatted
    });
};


const $3a4c415576984982$export$11bfb2cb8610109b = ({ values: values, index: index, label: label, icon: icon, color: color, showLabel: showLabel = true })=>{
    const percentageChange = Math.round((0, $f60f43e206f6ad67$export$f10d6a896d4ffbcf)(values[index], values[0]));
    const performanceColor = (0, $f60f43e206f6ad67$export$cefd6aa31297bf18)(percentageChange);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            showLabel && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                marginBottom: "8px",
                direction: "row",
                justify: "space-between",
                alignItems: "center",
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $575803f9d0a14b84$export$f7b0227af4862dc0), {
                                width: "16px",
                                height: "16px",
                                padding: "2px",
                                CustomIcon: (0, $f59ac49c6e1fede1$export$7936686565a25c35),
                                color: color
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                marginLeft: "2",
                                fontSize: "xs",
                                lineHeight: 1.1,
                                fontWeight: 500,
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $856e61fba54672e0$export$773623a5e66bea38), {
                        value: values[index],
                        startValue: values[0]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                w: "100%",
                h: "8px",
                bg: "#eee",
                position: "relative",
                borderRadius: "sm",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                        position: "absolute",
                        left: `${values[0] * 100}%`,
                        bg: "gray.300",
                        w: "2px",
                        h: "100%"
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                        as: (0, $0a9a7dc0535ece35$export$e25e478948902b8b).div,
                        backgroundColor: performanceColor,
                        borderRadius: "sm",
                        initial: {
                            width: `${values[index] * 100}%`
                        },
                        animate: {
                            width: `${values[index] * 100}%`
                        }
                    })
                ]
            })
        ]
    });
};



var $1acb2933a9e38d03$export$9defdf5fd4260665;
function $1acb2933a9e38d03$var$easeInOutCubic(progress) {
    return progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
}
function $1acb2933a9e38d03$var$scrollToElementById(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    const elementRect = element.getBoundingClientRect();
    const offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetScrollY = elementRect.top + offsetTop - 150; // -150 extra so the scrolled in element is not at the very top of the page
    const duration = 500; // Adjust this value as needed
    const startTime = Date.now();
    const animationStep = ()=>{
        const currentTime = Date.now();
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easing = $1acb2933a9e38d03$var$easeInOutCubic(progress);
        window.scrollTo(0, offsetTop + (targetScrollY - offsetTop) * easing);
        if (progress < 1) window.requestAnimationFrame(animationStep);
    };
    window.requestAnimationFrame(animationStep);
}
$1acb2933a9e38d03$export$9defdf5fd4260665 = $1acb2933a9e38d03$var$scrollToElementById;






const $9e2466b20bdede90$export$2ce376c2cc3355c8 = ({ children: children, selected: selected, text: text, id: id, icon: icon })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        width: "100%",
        padding: "5px 5px",
        my: 2,
        border: selected ? "solid 1px #ccc" : "solid 1px transparent",
        borderRadius: "md",
        _hover: {
            cursor: "pointer",
            backgroundColor: "gray.50"
        },
        onClick: ()=>{
            (0, $1acb2933a9e38d03$export$9defdf5fd4260665)(id);
        },
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                alignItems: "center",
                children: [
                    icon && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $575803f9d0a14b84$export$f7b0227af4862dc0), {
                        CustomIcon: icon,
                        width: "24px",
                        height: "24px"
                    }),
                    text && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        ml: icon ? 2 : 0,
                        fontSize: "md",
                        children: text
                    })
                ]
            }),
            children
        ]
    });
};


const $cc20dc7d2a15f4dc$export$f40fc8d0c925c16f = ({ index: index, list: list, byVariation: byVariation, inViewItem: inViewItem })=>{
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: list && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $df0a6ddd7916717b$export$335fca4219867448).Group, {
            axis: "y",
            values: list,
            onReorder: ()=>{},
            style: {
                width: "100%"
            },
            children: list[index]?.variations.map((item, i)=>{
                const { id: id, created: created } = item;
                const variationHistory = byVariation.find((v)=>v.id === id);
                const color = theme.colors[variationHistory.color]["500"];
                return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $df0a6ddd7916717b$export$335fca4219867448).Item, {
                    style: {
                        listStyle: "none"
                    },
                    dragListener: false,
                    value: created,
                    onClick: ()=>{
                        (0, $1acb2933a9e38d03$export$9defdf5fd4260665)(id);
                    },
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $9e2466b20bdede90$export$2ce376c2cc3355c8), {
                        id: id,
                        selected: inViewItem === id,
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $3a4c415576984982$export$11bfb2cb8610109b), {
                            label: variationHistory.name,
                            color: color,
                            values: variationHistory.history.map((v)=>v.weighting),
                            index: index
                        })
                    })
                }, id);
            })
        })
    });
};




"use client";
var $310f0e9ced5c23ed$export$ef2184bd89960b14 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Grid2(props, ref) {
    const { templateAreas: templateAreas, gap: gap, rowGap: rowGap, columnGap: columnGap, column: column, row: row, autoFlow: autoFlow, autoRows: autoRows, templateRows: templateRows, autoColumns: autoColumns, templateColumns: templateColumns, ...rest } = props;
    const styles = {
        display: "grid",
        gridTemplateAreas: templateAreas,
        gridGap: gap,
        gridRowGap: rowGap,
        gridColumnGap: columnGap,
        gridAutoColumns: autoColumns,
        gridColumn: column,
        gridRow: row,
        gridAutoFlow: autoFlow,
        gridAutoRows: autoRows,
        gridTemplateRows: templateRows,
        gridTemplateColumns: templateColumns
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$310f0e9ced5c23ed$export$ef2184bd89960b14.displayName = "Grid";





"use client";
function $0b7c49ac564235ce$var$spanFn(span) {
    return (0, $236059bf8082cb80$export$eca1915781c2aaca)(span, (value)=>value === "auto" ? "auto" : `span ${value}/span ${value}`);
}
var $0b7c49ac564235ce$export$9eb849b9b922d396 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function GridItem2(props, ref) {
    const { area: area, colSpan: colSpan, colStart: colStart, colEnd: colEnd, rowEnd: rowEnd, rowSpan: rowSpan, rowStart: rowStart, ...rest } = props;
    const styles = (0, $0fbee2d796a5b411$export$8e16b83750b44988)({
        gridArea: area,
        gridColumn: $0b7c49ac564235ce$var$spanFn(colSpan),
        gridRow: $0b7c49ac564235ce$var$spanFn(rowSpan),
        gridColumnStart: colStart,
        gridColumnEnd: colEnd,
        gridRowStart: rowStart,
        gridRowEnd: rowEnd
    });
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$0b7c49ac564235ce$export$9eb849b9b922d396.displayName = "GridItem";




var $lDSNw = parcelRequire("lDSNw");



var $lDSNw = parcelRequire("lDSNw");




var $lDSNw = parcelRequire("lDSNw");

"use client";
var $51ac38fa1e679c69$export$f6b1e3902165e5e1 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Wrap2(props, ref) {
    const { spacing: spacing = "0.5rem", spacingX: spacingX, spacingY: spacingY, children: children, justify: justify, direction: direction, align: align, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const _children = (0, $lDSNw.useMemo)(()=>shouldWrapChildren ? (0, $lDSNw.Children).map(children, (child, index)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($51ac38fa1e679c69$export$aee5d1a2d22b42b6, {
                children: child
            }, index)) : children, [
        children,
        shouldWrapChildren
    ]);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-wrap", className),
        ...rest,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).ul, {
            className: "chakra-wrap__list",
            __css: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: justify,
                alignItems: align,
                flexDirection: direction,
                listStyleType: "none",
                gap: spacing,
                columnGap: spacingX,
                rowGap: spacingY,
                padding: "0"
            },
            children: _children
        })
    });
});
$51ac38fa1e679c69$export$f6b1e3902165e5e1.displayName = "Wrap";
var $51ac38fa1e679c69$export$aee5d1a2d22b42b6 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function WrapItem2(props, ref) {
    const { className: className, ...rest } = props;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).li, {
        ref: ref,
        __css: {
            display: "flex",
            alignItems: "flex-start"
        },
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-wrap__listitem", className),
        ...rest
    });
});
$51ac38fa1e679c69$export$aee5d1a2d22b42b6.displayName = "WrapItem";






const $c0f4a4645e458cf0$export$9e823c18fb568b0c = ({ children: children, active: active, color: color, icon: icon, text: text, onMouseEnter: onMouseEnter = ()=>{}, onMouseLeave: onMouseLeave = ()=>{}, onClick: onClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
        spacing: "2",
        display: "flex",
        direction: "row",
        padding: "8px 8px",
        borderRadius: "md",
        _hover: {
            opacity: "0.9",
            cursor: "pointer"
        },
        border: "solid 1px white",
        borderColor: active ? color : "white",
        onMouseEnter: ()=>{
            onMouseEnter();
        },
        onMouseLeave: ()=>{
            onMouseLeave();
        },
        onClick: ()=>{
            onClick();
        },
        fontWeight: "400",
        opacity: active ? "1" : "0.5",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                w: "16px",
                h: "16px",
                borderRadius: "sm",
                bgColor: color,
                opacity: active ? "1" : "0.5"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                margin: "0px 5px",
                fontSize: "sm",
                children: text
            })
        ]
    });
};


const $5c5634ce37004f86$export$502a55a813e9c262 = ({ series: series, inactiveSeries: inactiveSeries, onSelect: onSelect, onHoverStart: onHoverStart, onHoverEnd: onHoverEnd })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $51ac38fa1e679c69$export$f6b1e3902165e5e1), {
        spacing: "20px",
        justify: "center",
        children: series.map((item)=>{
            const { color: color, icon: icon, key: key } = item;
            const active = !inactiveSeries.includes(key);
            return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $51ac38fa1e679c69$export$aee5d1a2d22b42b6), {
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c0f4a4645e458cf0$export$9e823c18fb568b0c), {
                    text: key,
                    color: color,
                    icon: icon,
                    active: active,
                    onMouseEnter: ()=>{
                        onHoverStart(key);
                    },
                    onMouseLeave: ()=>{
                        onHoverEnd(null);
                    },
                    onClick: ()=>{
                        onSelect(key);
                    }
                })
            });
        })
    });
};





const $1ea5b7f31ef9d701$export$9f95857259638e76 = ({ icon: icon = (0, $f59ac49c6e1fede1$export$75b1655f5e7081d6), label: label, color: color })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $55f5c4969dc36ab6$export$28c660c63b792dea), {
        hasArrow: true,
        label: label,
        bg: "gray.50",
        color: "gray.800",
        children: icon && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                width: "16px",
                height: "16px",
                as: icon,
                color: color
            })
        })
    });
};






"use client";
var $f6cebb21c70a92ce$export$37acb3580601e69a = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Badge2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$b863f77547fbcb03)("Badge", props);
    const { className: className, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        ref: ref,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-badge", props.className),
        ...rest,
        __css: {
            display: "inline-block",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            ...styles
        }
    });
});
$f6cebb21c70a92ce$export$37acb3580601e69a.displayName = "Badge";


const $ced5a496f5523aca$export$54d0e8420ac838ac = ({ adProgress: adProgress = null, series: series, xAxisDomain: xAxisDomain = [
    0,
    100
], yAxisDomain: yAxisDomain = [
    0,
    1
], showLegend: showLegend = false, type: type = "area", height: height = 400, width: width = "100%", animationDuration: animationDuration = 1000, header: header = null, active: active = true })=>{
    // setting just the first two series to be active by default
    const [inactiveSeries, setInactiveSeries] = (0, $lDSNw.useState)(series.map((s, i)=>i > 1 ? s.key : ""));
    const [hoveredSeries, setHoveredSeries] = (0, $lDSNw.useState)(null);
    // not going to render the chart lines if there is nothing to render
    const shouldRenderChartData = !series.some(({ data: data })=>data.length === 1);
    const Chart = getChart(type);
    function getChart(type) {
        switch(type){
            case "area":
                return 0, $327c7a210e36e160$export$ea1a111407f37557;
            case "bar":
                return 0, $6ecebb08067248a7$export$bbc6c6369b38e3d1;
            case "heat":
                return 0, $6ecebb08067248a7$export$bbc6c6369b38e3d1;
            default:
                return 0, $327c7a210e36e160$export$ea1a111407f37557;
        }
    }
    function combineSeries(series) {
        const data = [];
        const length = series[0].data.length;
        for(let i = 0; i < length; i++){
            const item = {};
            series.forEach((seriesItem)=>{
                item[seriesItem.key] = seriesItem.data[i];
                item.key = seriesItem.key;
                item.color = seriesItem.color;
            });
            item.timeline = i;
            data.push(item);
        }
        if (type === "heat") {
            /**
       * To get the "heat map" colours we need to convert the values to
       * brightness values based on Chakra colour scales.
       */ const values = (0, $f60f43e206f6ad67$export$31d8f5e76b42bed9)(data.map((item)=>item[item.key]));
            const newData = data.map((item, i)=>{
                const color = item.color;
                const brightness = (0, $f60f43e206f6ad67$export$33cacb20a48e02bf)(values[i]);
                return {
                    ...item,
                    [item.key]: 1,
                    fill: `var(--chakra-colors-${color}-${brightness})`
                };
            });
            return newData;
        }
        return data;
    }
    const toggleItem = (item)=>{
        if (inactiveSeries.includes(item)) setInactiveSeries((prevState)=>prevState.filter((element)=>element !== item));
        else setInactiveSeries((prevState)=>[
                ...prevState,
                item
            ]);
    };
    const data = combineSeries(series);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            header && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                marginBottom: "2",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                fontSize: "md",
                                mr: 2,
                                fontWeight: 400,
                                children: header.title
                            }),
                            header.tooltip && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1ea5b7f31ef9d701$export$9f95857259638e76), {
                                label: header.tooltip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                        children: header.keys && header.keys.map((key)=>{
                            return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                                mx: "8px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                        w: "30px",
                                        h: "4px",
                                        borderRadius: "xl",
                                        bgColor: key.color,
                                        mr: "8px"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                        fontSize: "xs",
                                        children: key.title
                                    })
                                ]
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                width: width,
                height: height,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $77d815ec488f9d85$export$f881f4f9e4007a57), {
                    data: data,
                    barCategoryGap: 0,
                    margin: {
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0
                    },
                    children: [
                        showLegend && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $22f8c7fa15a15fc3$export$ed247974535929c7), {
                            content: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c5634ce37004f86$export$502a55a813e9c262), {
                                series: series,
                                inactiveSeries: inactiveSeries,
                                onSelect: toggleItem,
                                onHoverStart: setHoveredSeries,
                                onHoverEnd: setHoveredSeries
                            })
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                            fill: "#F8F8F8",
                            stroke: "transparent"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                            dataKey: "timeline",
                            type: "number",
                            tickLine: true,
                            domain: xAxisDomain,
                            allowDataOverflow: true,
                            axisLine: false,
                            ticks: [
                                "Scroll in",
                                "Scroll out"
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                            domain: yAxisDomain,
                            hide: true
                        }),
                        data && shouldRenderChartData && series.map((item, index)=>{
                            return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(Chart, {
                                type: "monotone",
                                dataKey: item.key,
                                animationDuration: animationDuration,
                                stroke: type === "heat" ? "none" : item.color,
                                strokeWidth: hoveredSeries === item.key ? 3 : 2,
                                fill: item.fill ? item.color : "none",
                                fillOpacity: type === "heat" ? 1 : 0.3,
                                isAnimationActive: true,
                                hide: inactiveSeries.includes(item.key),
                                strokeDasharray: item.dashed ? "5 5" : "0 0"
                            }, index);
                        }),
                        adProgress && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                            x: Math.round(adProgress),
                            fill: "#000",
                            stroke: "rgba(0,0,0,0.50)",
                            strokeWidth: "3px",
                            isFront: true
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("linearGradient", {
                                id: "linear",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                        offset: "25%",
                                        stopColor: "#00CE7C"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "#4AC1E0"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            !active && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $596f68ba801b1475$export$1f54913ccc4368b1), {
                pos: "absolute",
                backdropFilter: "blur(1.5px)",
                bgColor: "#ffffff30",
                top: "0px",
                left: "0px",
                width: "100%",
                height: "100%",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f6cebb21c70a92ce$export$37acb3580601e69a), {
                    padding: 2,
                    variant: "subtle",
                    colorScheme: "orange",
                    children: "No data available. Campaign yet to start."
                })
            })
        ]
    });
};






var $lDSNw = parcelRequire("lDSNw");





const $3776c4bbbeb4290e$export$700087f99bb44ee4 = ({ buildID: buildID, dcoVariation: dcoVariation, setScrollProgress: setScrollProgress, scale: scale = 0.5, position: position = {
    top: "0px",
    right: "0px"
}, title: title = "Preview", color: color = "gray", emoji: emoji = null })=>{
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    const [iframeSrcDoc, setIframeSrcDoc] = (0, $lDSNw.useState)(null);
    const [adWindow, setAdWindow] = (0, $lDSNw.useState)(null);
    const scrollCallback = (e)=>{
        const iframe = e.target.getElementById("middle-ad").getElementsByTagName("iframe")[0];
        const progress = iframe.contentWindow.format.cat.timeline;
        if (setScrollProgress) setScrollProgress(progress);
    };
    const iframeOnLoadHandler = (e)=>{
        const previewWindow = e.target.contentWindow;
        const iframeWindow = previewWindow.document.getElementById("middle-ad").getElementsByTagName("iframe")[0];
        // to load the correct variation we send an event that the iframe listens for
        iframeWindow.contentWindow.dispatchEvent(new CustomEvent("dcoPreviewID", {
            detail: {
                dcoPreviewID: dcoVariation
            }
        }));
        previewWindow.scrollTo({
            top: 1500,
            behavior: "smooth"
        });
        setAdWindow(previewWindow);
        previewWindow.addEventListener("scroll", scrollCallback);
    };
    (0, $lDSNw.useEffect)(()=>{
        if (adWindow) return adWindow.removeEventListener("scroll", scrollCallback);
    }, [
        adWindow
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (buildID && !iframeSrcDoc) try {
            (0, $9d599987579e8430$export$4e70f71bf0757296)(buildID).then((srcDoc)=>{
                setIframeSrcDoc(srcDoc);
            });
        } catch (error) {
            setErrorMessage(error);
        }
    }, [
        dcoVariation
    ]);
    // Bit of weirdness with the Heading in the iframe, as it's scaled down in size inside the preview iframe
    const Heading = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
            pt: "4",
            px: "5",
            pb: "3",
            gap: "4",
            bg: "#dddddd",
            position: "relative",
            borderTopRadius: "30px",
            mr: "2" //so it lines up with the mobile frame
            ,
            ml: "1",
            borderBottom: "solid 1px #ccc",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $575803f9d0a14b84$export$f7b0227af4862dc0), {
                    CustomIcon: (0, $f59ac49c6e1fede1$export$7936686565a25c35),
                    color: theme.colors[color]["500"],
                    width: "24px",
                    height: "24px"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                    fontSize: "xl",
                    noOfLines: 1,
                    fontWeight: "500",
                    color: "black",
                    children: title
                }),
                emoji && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                    cursor: "default",
                    pos: "absolute",
                    right: "-10px",
                    transform: "rotate(20deg)",
                    fontSize: "80px",
                    color: "black",
                    children: emoji
                })
            ]
        });
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0204198b5355405f$export$3ae376d12526dd6f), {
            children: iframeSrcDoc && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).div, {
                style: {
                    position: "relative",
                    top: position.top,
                    right: position.right,
                    width: "100%"
                },
                initial: {
                    opacity: 0,
                    y: -100
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                exit: {
                    opacity: 0,
                    y: 100
                },
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2ac71661ebc4b3c3$export$2e2bcd8739ae039), {
                    srcDoc: iframeSrcDoc,
                    heading: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)(Heading, {}),
                    onLoadHandler: iframeOnLoadHandler,
                    creativeFormat: "hang-time",
                    showWrapper: false,
                    creativeID: buildID,
                    isLoading: false,
                    isLegacy: true,
                    scale: scale
                }, dcoVariation)
            }, `${dcoVariation}-wrapper`)
        })
    });
};







const $46d22a6566f60f3c$export$97be854b3aad3c92 = ({ showTrack: showTrack = true, ...props })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0c7e57679d2cb40c$export$472062a354075cee), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$105594979f116971), {
                opacity: showTrack ? 1 : 0,
                h: "1.5",
                borderRadius: "full",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$73137d74280e0c3e), {
                    opacity: showTrack ? 1 : 0,
                    transition: "0s linear",
                    as: (0, $0a9a7dc0535ece35$export$e25e478948902b8b).div
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$2c1b491743890dec), {
                height: "32px",
                width: "6px",
                bg: "gray.500",
                transition: "0s linear",
                as: (0, $0a9a7dc0535ece35$export$e25e478948902b8b).div
            })
        ]
    });
};





const $aae431bc98eb0cc8$export$7a7fa4424cb20976 = ({ index: index, setIndex: setIndex, history: history, showButton: showButton = true, width: width = "200px", showTrack: showTrack = true, Chart: Chart = null, active: active = true })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        direction: "row",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                mr: 4,
                fontSize: "sm",
                children: "Optimisation Start"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                position: "relative",
                children: [
                    Chart && Chart,
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $46d22a6566f60f3c$export$97be854b3aad3c92), {
                        isDisabled: !active,
                        showTrack: showTrack,
                        colorScheme: "gray",
                        width: width,
                        min: 0,
                        max: history.length - 1,
                        value: index || 0,
                        onChange: (val)=>{
                            setIndex(val);
                        },
                        defaultValue: 0
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                mx: 4,
                fontSize: "sm",
                children: "End"
            }),
            showButton && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
                isDisabled: !active,
                size: "sm",
                margin: "0px 10px 0px 10px",
                borderRadius: "full",
                icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$7cb7bf01cf98523), {}),
                onClick: ()=>{
                    (0, $f60f43e206f6ad67$export$85a9d61b61b2ebd7)(history, setIndex);
                }
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1ea5b7f31ef9d701$export$9f95857259638e76), {
                label: "See how performance progressed during the optimisation period."
            })
        ]
    });
};




const $102e1f5ba4edbb25$export$c473c5da53cb704f = ({ parentBuildID: parentBuildID, history: history, variationId: variationId, active: active })=>{
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    const ref = (0, $lDSNw.useRef)(null);
    const [scrollProgress, setScrollProgress] = (0, $lDSNw.useState)(0);
    const [historyIndex, setHistoryIndex] = (0, $lDSNw.useState)(history.length - 1);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        ref: ref,
        style: {
            display: "flex",
            direction: "row",
            with: "100%",
            position: "relative"
        },
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $310f0e9ced5c23ed$export$ef2184bd89960b14), {
            gridTemplateColumns: "250px 1fr",
            gap: 2,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0b7c49ac564235ce$export$9eb849b9b922d396), {
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $3776c4bbbeb4290e$export$700087f99bb44ee4), {
                        buildID: parentBuildID,
                        dcoVariation: variationId,
                        title: history[historyIndex].name,
                        color: history[historyIndex].color,
                        setScrollProgress: setScrollProgress,
                        scale: "0.6",
                        position: {
                            top: "0px",
                            right: "0px"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0b7c49ac564235ce$export$9eb849b9b922d396), {
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                                    margin: "10px 10px 10px 0px",
                                    width: "150px",
                                    justify: "space-between",
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                            fontSize: "sm",
                                            children: "Weighting:"
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                            fontWeight: 500,
                                            fontSize: "lg",
                                            children: [
                                                (history[historyIndex].weighting * 100).toFixed(1),
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                            ml: 4,
                                            fontSize: "sm",
                                            children: "Change:"
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $856e61fba54672e0$export$773623a5e66bea38), {
                                            size: "lg",
                                            value: history[historyIndex].weighting,
                                            startValue: history[0].weighting
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1ea5b7f31ef9d701$export$9f95857259638e76), {
                                            label: "The weighting of impressions this variation is recommended to receive."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                                    position: "relative",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aae431bc98eb0cc8$export$7a7fa4424cb20976), {
                                        active: active,
                                        index: historyIndex,
                                        setIndex: setHistoryIndex,
                                        history: history,
                                        showButton: true,
                                        showTrack: false,
                                        Chart: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                                            height: "30px",
                                            borderRadius: "sm",
                                            position: "absolute",
                                            top: "0px",
                                            left: "0px",
                                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ced5a496f5523aca$export$54d0e8420ac838ac), {
                                                fill: true,
                                                height: 60,
                                                animationDuration: 0,
                                                width: 200,
                                                xAxisDomain: [
                                                    0,
                                                    history.length - 1
                                                ],
                                                yAxisDomain: [
                                                    0,
                                                    1
                                                ],
                                                series: [
                                                    {
                                                        key: "weighting",
                                                        data: history.map((h)=>h.weighting).splice(0, historyIndex + 1),
                                                        color: theme.colors.red["600"],
                                                        fill: true
                                                    }
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                            direction: "column",
                            height: "100%",
                            width: "800px",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {
                                    margin: "10px 0px 30px 0px"
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                    overflow: "hidden",
                                    borderRadius: "md",
                                    height: "275px",
                                    children: [
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ced5a496f5523aca$export$54d0e8420ac838ac), {
                                            active: active,
                                            header: {
                                                title: "Scrub Interactions",
                                                keys: [
                                                    {
                                                        title: "Scrubs",
                                                        color: "#E53E3E"
                                                    }
                                                ],
                                                tooltip: "We track as users scroll, pause and back-track on the ad to understand which parts are most engaging."
                                            },
                                            fill: true,
                                            height: 170,
                                            xAxisDomain: [
                                                20,
                                                75
                                            ],
                                            yAxisDomain: [
                                                0,
                                                1
                                            ],
                                            series: [
                                                {
                                                    key: "scrub",
                                                    data: history[historyIndex].data,
                                                    color: theme.colors.red["600"],
                                                    fill: true
                                                }
                                            ],
                                            adProgress: scrollProgress
                                        }),
                                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                                            style: {
                                                overflow: "hidden",
                                                height: "100%",
                                                position: "relative",
                                                top: "-30px"
                                            },
                                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
                                                pos: "relative",
                                                top: "-7px",
                                                src: `https://meta-baby.uc.r.appspot.com/${parentBuildID}/375x745/hang-time/filmstrip?variationID=${variationId}&styles=[".content{opacity:0.3;}\n.page-style-article%20header{display:none;}"]&scrollToElement.offset=-362&screenshotSize=14&scrollIncrement=60`
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};






var $lDSNw = parcelRequire("lDSNw");
function $eb8793357a67e95a$export$6f8d6e7261983be1(ref) {
    const [isIntersecting, setIntersecting] = (0, $lDSNw.useState)(false);
    (0, $lDSNw.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            const { isVisible: isVisible, isIntersecting: isIntersecting } = entry;
            setIntersecting(isIntersecting);
        }, {
            threshold: 0.9
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref
    ]);
    return isIntersecting;
}



var $lDSNw = parcelRequire("lDSNw");


const $41cd8b08f8508245$export$60332b2344f7fe41 = ({ children: children, heading: heading, link: link = null, setInViewItem: setInViewItem, id: id, height: height = "100%", icon: icon = null })=>{
    const ref = (0, $lDSNw.useRef)(null);
    const isVisible = (0, $eb8793357a67e95a$export$6f8d6e7261983be1)(ref);
    (0, $lDSNw.useEffect)(()=>{
        if (isVisible) setInViewItem();
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        width: "1100px",
        height: height,
        overall: "hidden",
        padding: "20px 0",
        borderRadius: "lg",
        backgroundColor: "white",
        boxShadow: "md",
        marginY: 4,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
            id: id,
            ref: ref,
            children: [
                heading && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                            alignItems: "center",
                            px: "30px",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                                    style: {
                                        marginRight: "12px"
                                    },
                                    children: icon && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $575803f9d0a14b84$export$f7b0227af4862dc0), {
                                        width: "26px",
                                        height: "26px",
                                        padding: "2px",
                                        CustomIcon: icon
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "xl",
                                    children: heading
                                }),
                                link && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $3ee3b72d91cbc81c$export$a6c7ac8248d6e38a), {
                                    to: link.path,
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                        color: "#4AC1E0",
                                        fontSize: "xl",
                                        children: link.text
                                    })
                                })
                            ]
                        }),
                        children && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {
                            marginTop: "20px"
                        })
                    ]
                }),
                children
            ]
        })
    });
};





var $lDSNw = parcelRequire("lDSNw");






const $87a416ea668ec228$export$5be96b25616cd6a5 = ({ history: history, setInViewItem: setInViewItem, setIndex: setIndex, optimisationPerformance: optimisationPerformance, index: index, buildID: buildID, byVariation: byVariation, active: active })=>{
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    const [scrollProgress, setScrollProgress] = (0, $lDSNw.useState)(0);
    // converting into the data we need with the correct color values
    const processedVariations = byVariation.map((item)=>{
        return {
            data: item.history[index].data,
            key: item.name,
            color: theme.colors[item.color]["500"],
            icon: (0, $f59ac49c6e1fede1$export$c829fb65853add70),
            fill: false,
            dashed: false
        };
    });
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $41cd8b08f8508245$export$60332b2344f7fe41), {
        id: "results",
        heading: "Catalyst Results",
        icon: (0, $f59ac49c6e1fede1$export$c829fb65853add70),
        setInViewItem: ()=>{
            setInViewItem("results");
        },
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
            display: "flex",
            direction: "column",
            position: "relative",
            px: "30px",
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                    alignItems: "flex-start",
                    padding: "20px 0px",
                    w: "60%",
                    spacing: "20px",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                            fontSize: "md",
                            fontWeight: 400,
                            children: "During optimisation, Catalyst delivers different ad variations to different users. After the optimisation period, the variations that received the most user interaction will be delivered most frequently."
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                            fontSize: "md",
                            fontWeight: 400,
                            children: [
                                "This campaign contains ",
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("strong", {
                                    children: byVariation.length
                                }),
                                " ",
                                "variations. View the performance of each variation below."
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                            direction: "column",
                            width: "100%",
                            children: optimisationPerformance && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ced5a496f5523aca$export$54d0e8420ac838ac), {
                                header: {
                                    title: "Overall vs Control",
                                    keys: [
                                        {
                                            title: "Overall",
                                            color: theme.colors.red["600"]
                                        },
                                        {
                                            title: "Control",
                                            color: theme.colors.gray["500"]
                                        }
                                    ],
                                    tooltip: "The combined performance of all variations vs a small control (non-optimised) group."
                                },
                                active: active,
                                animationDuration: 0,
                                height: 200,
                                xAxisDomain: [
                                    0,
                                    optimisationPerformance.overall.length - 1
                                ],
                                yAxisDomain: [
                                    0,
                                    70
                                ],
                                showLegend: false,
                                series: [
                                    {
                                        data: optimisationPerformance.overall.slice(0, index + 1),
                                        key: "Catalyst",
                                        color: theme.colors.red["600"],
                                        // icon: BiListCheck, // icons are available to be passed in to the key buttons, but we don't have any yet
                                        fill: true,
                                        dashed: false
                                    },
                                    {
                                        data: optimisationPerformance.control.slice(0, index + 1),
                                        key: "Control",
                                        color: theme.colors.gray["500"],
                                        // icon: BiListCheck, // icons are available to be passed in to the key buttons, but we don't have any yet
                                        fill: false,
                                        dashed: true
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {
                            marginTop: "-20px"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                            direction: "column",
                            width: "100%",
                            children: history[index]?.control?.scrubs && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ced5a496f5523aca$export$54d0e8420ac838ac), {
                                active: active,
                                header: {
                                    title: "Performance by Variation",
                                    tooltip: "Compare the individual Creative Attention performance of each ad variation."
                                },
                                height: 300,
                                xAxisDomain: [
                                    20,
                                    80
                                ],
                                yAxisDomain: [
                                    0,
                                    1
                                ],
                                adProgress: scrollProgress,
                                showLegend: true,
                                series: [
                                    {
                                        data: history[index].overall.scrubs,
                                        key: "Overall",
                                        color: theme.colors["red"]["600"],
                                        fill: false,
                                        dashed: false
                                    },
                                    {
                                        data: history[index].control.scrubs,
                                        key: "Control",
                                        color: theme.colors["gray"]["500"],
                                        fill: false,
                                        dashed: true
                                    },
                                    ...processedVariations
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                    pos: "absolute",
                    top: "-50px",
                    right: "0px",
                    px: "30px",
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aae431bc98eb0cc8$export$7a7fa4424cb20976), {
                        active: active,
                        index: index,
                        setIndex: setIndex,
                        history: history
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $3776c4bbbeb4290e$export$700087f99bb44ee4), {
                        setScrollProgress: setScrollProgress,
                        buildID: buildID,
                        dcoVariation: byVariation[0].id,
                        title: byVariation[0].name,
                        color: byVariation[0].color,
                        emoji: "\uD83C\uDFC6",
                        scale: 0.9,
                        position: {
                            top: "50px",
                            right: "-30px"
                        }
                    })
                })
            ]
        })
    });
};




"use client";
function $0edfc44162837079$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
var $0edfc44162837079$export$c82e186cf428d56d = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)({
    "0%": {
        strokeDasharray: "1, 400",
        strokeDashoffset: "0"
    },
    "50%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-100"
    },
    "100%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-260"
    }
});
var $0edfc44162837079$export$bb628a54ab399bc9 = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $0edfc44162837079$export$504d7abb21fa8c9 = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)({
    "0%": {
        left: "-40%"
    },
    "100%": {
        left: "100%"
    }
});
var $0edfc44162837079$export$735606310a3da449 = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)({
    from: {
        backgroundPosition: "1rem 0"
    },
    to: {
        backgroundPosition: "0 0"
    }
});
function $0edfc44162837079$export$c5752331c2d05cd(options) {
    const { value: value = 0, min: min, max: max, valueText: valueText, getValueText: getValueText, isIndeterminate: isIndeterminate, role: role = "progressbar" } = options;
    const percent = $0edfc44162837079$var$valueToPercent(value, min, max);
    const getAriaValueText = ()=>{
        if (value == null) return void 0;
        return typeof getValueText === "function" ? getValueText(value, percent) : valueText;
    };
    return {
        bind: {
            "data-indeterminate": isIndeterminate ? "" : void 0,
            "aria-valuemax": max,
            "aria-valuemin": min,
            "aria-valuenow": isIndeterminate ? void 0 : value,
            "aria-valuetext": getAriaValueText(),
            role: role
        },
        percent: percent,
        value: value
    };
}





"use client";
var [$eec9473168f5eb41$var$ProgressStylesProvider, $eec9473168f5eb41$export$47e08dbe93d2e76f] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `ProgressStylesContext`,
    errorMessage: `useProgressStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Progress />" `
});
var $eec9473168f5eb41$var$ProgressFilledTrack = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    const { min: min, max: max, value: value, isIndeterminate: isIndeterminate, role: role, ...rest } = props;
    const progress2 = (0, $0edfc44162837079$export$c5752331c2d05cd)({
        value: value,
        min: min,
        max: max,
        isIndeterminate: isIndeterminate,
        role: role
    });
    const styles = $eec9473168f5eb41$export$47e08dbe93d2e76f();
    const trackStyles = {
        height: "100%",
        ...styles.filledTrack
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        style: {
            width: `${progress2.percent}%`,
            ...rest.style
        },
        ...progress2.bind,
        ...rest,
        __css: trackStyles
    });
});
var $eec9473168f5eb41$export$b25a304ec7d746bb = (0, $3064a344dac4d694$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { value: value, min: min = 0, max: max = 100, hasStripe: hasStripe, isAnimated: isAnimated, children: children, borderRadius: propBorderRadius, isIndeterminate: isIndeterminate, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-valuetext": ariaValueText, title: title, role: role, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Progress", props);
    const borderRadius = propBorderRadius != null ? propBorderRadius : (_a = styles.track) == null ? void 0 : _a.borderRadius;
    const stripeAnimation = {
        animation: `${(0, $0edfc44162837079$export$735606310a3da449)} 1s linear infinite`
    };
    const shouldAddStripe = !isIndeterminate && hasStripe;
    const shouldAnimateStripe = shouldAddStripe && isAnimated;
    const css = {
        ...shouldAnimateStripe && stripeAnimation,
        ...isIndeterminate && {
            position: "absolute",
            willChange: "left",
            minWidth: "50%",
            animation: `${0, $0edfc44162837079$export$504d7abb21fa8c9} 1s ease infinite normal none running`
        }
    };
    const trackStyles = {
        overflow: "hidden",
        position: "relative",
        ...styles.track
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        borderRadius: borderRadius,
        __css: trackStyles,
        ...rest,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)($eec9473168f5eb41$var$ProgressStylesProvider, {
            value: styles,
            children: [
                /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($eec9473168f5eb41$var$ProgressFilledTrack, {
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText,
                    min: min,
                    max: max,
                    value: value,
                    isIndeterminate: isIndeterminate,
                    css: css,
                    borderRadius: borderRadius,
                    title: title,
                    role: role
                }),
                children
            ]
        })
    });
});
$eec9473168f5eb41$export$b25a304ec7d746bb.displayName = "Progress";




const $527ac5de4f108ecb$export$af88ceee752b86 = ({ dcoMeta: dcoMeta, optimisationProgress: optimisationProgress })=>{
    const status = dcoMeta.active ? {
        color: "orange.500",
        text: "In Progress",
        icon: (0, $f59ac49c6e1fede1$export$9f1eefcf4f969428)
    } : optimisationProgress === 100 ? {
        color: "green.500",
        text: "Complete",
        icon: (0, $f59ac49c6e1fede1$export$c84298c0fb5ae4e3)
    } : {
        color: "gray.500",
        text: "Not Started",
        icon: (0, $f59ac49c6e1fede1$export$8c20aa0dcdf32ee8)
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
        direction: "row",
        width: "100%",
        bg: "white",
        height: "100%",
        padding: "10px 10px",
        alignItems: "center",
        borderBottom: "solid 1px #eee",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                fontSize: "md",
                fontWeight: "600",
                children: "Catalyst Report"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {
                orientation: "vertical",
                mx: "5"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                        as: status.icon,
                        height: "20px",
                        width: "20px",
                        color: status.color
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        fontSize: "sm",
                        fontWeight: "400",
                        children: status.text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {
                orientation: "vertical",
                mx: "5"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                spacing: 5,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        fontSize: "sm",
                        fontWeight: "400",
                        children: "Optimisation Progress"
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $eec9473168f5eb41$export$b25a304ec7d746bb), {
                        borderRadius: "sm",
                        w: "100px",
                        colorScheme: status.color.split(".")[0],
                        size: "sm",
                        value: optimisationProgress
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1ea5b7f31ef9d701$export$9f95857259638e76), {
                        label: `This campaign is ${Math.round(optimisationProgress)}% through the optimisation phase. During optimisation we're gathering data on all variations to determine the best performing.`
                    })
                ]
            })
        ]
    });
};



const $735d6c3d3be0d28c$export$abc2b1c02cffc32b = ({ buildID: buildID, dcoData: dcoData })=>{
    const { dcoMetaData: dcoMetaData, dcoHistoryData: dcoHistoryData, historyByVariation: historyByVariation, overallScrubPerformance: overallScrubPerformance } = dcoData;
    const optimisationIndex = dcoMetaData.optimisationTimeline.findIndex((item)=>item.optimisationUsed === false);
    const optimisationProgress = optimisationIndex === -1 ? 100 : optimisationIndex / dcoMetaData.optimisationTimeline.length * 100;
    const active = optimisationProgress > 0;
    const [index, setIndex] = (0, $lDSNw.useState)(dcoHistoryData.length - 1);
    const [inViewItem, setInViewItem] = (0, $lDSNw.useState)(null);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $596f68ba801b1475$export$1f54913ccc4368b1), {
        w: "100%",
        h: "100%",
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $310f0e9ced5c23ed$export$ef2184bd89960b14), {
            backgroundColor: "gray.50",
            bg: "gray.50",
            position: "absolute",
            top: "50px",
            width: "100%",
            templateAreas: `"header header"
                  "nav main"`,
            gridTemplateRows: "50px 1fr",
            gridTemplateColumns: "250px 1fr",
            h: "100%",
            maxW: "1410px",
            color: "blackAlpha.700",
            fontWeight: "bold",
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0b7c49ac564235ce$export$9eb849b9b922d396), {
                    width: "100%",
                    height: "50px",
                    zIndex: "201",
                    position: "fixed",
                    bg: "gray.50",
                    area: "header",
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).div, {
                        style: {
                            height: "100%"
                        },
                        initial: {
                            y: -100
                        },
                        animate: {
                            y: 0
                        },
                        transition: {
                            duration: 1
                        },
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $527ac5de4f108ecb$export$af88ceee752b86), {
                            dcoMeta: dcoMetaData,
                            optimisationProgress: optimisationProgress
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0b7c49ac564235ce$export$9eb849b9b922d396), {
                    position: "fixed",
                    top: "100px",
                    zIndex: "200",
                    bg: "gray.50",
                    area: "nav",
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).div, {
                        as: (0, $0a9a7dc0535ece35$export$e25e478948902b8b).div,
                        initial: {
                            x: -300
                        },
                        animate: {
                            x: 0
                        },
                        transition: {
                            duration: 1
                        },
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                            direction: "column",
                            bg: "white",
                            borderRight: "solid 1px #eee",
                            padding: "10px 20px 10px 10px",
                            width: "250px",
                            height: "100vh",
                            zIndex: "200",
                            spacing: "5px",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $9e2466b20bdede90$export$2ce376c2cc3355c8), {
                                    text: "Catalyst Results",
                                    id: "results",
                                    selected: inViewItem === "results",
                                    icon: (0, $f59ac49c6e1fede1$export$c829fb65853add70)
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "sm",
                                    marginLeft: "5px",
                                    color: "gray.500",
                                    children: "Ad Variations"
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cc20dc7d2a15f4dc$export$f40fc8d0c925c16f), {
                                    inViewItem: inViewItem,
                                    list: dcoHistoryData,
                                    index: index,
                                    byVariation: historyByVariation
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0b7c49ac564235ce$export$9eb849b9b922d396), {
                    bg: "gray.50",
                    area: "main",
                    boxShadow: "1000px 0px 10px 0 var(--chakra-colors-gray-50)",
                    pb: "20px",
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        spacing: "1",
                        alignItems: "flex-start",
                        padding: "0 20px",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                transition: {
                                    duration: 0.5
                                },
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $87a416ea668ec228$export$5be96b25616cd6a5), {
                                    history: dcoHistoryData,
                                    optimisationPerformance: overallScrubPerformance,
                                    setInViewItem: setInViewItem,
                                    setIndex: setIndex,
                                    index: index,
                                    buildID: buildID,
                                    byVariation: historyByVariation,
                                    active: active
                                })
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $41cd8b08f8508245$export$60332b2344f7fe41), {
                                icon: (0, $f59ac49c6e1fede1$export$db425eb5cf68fb47),
                                heading: "See how our attention tracking tech works -\xa0",
                                link: {
                                    text: "Try an interactive demo \uD83D\uDCF2",
                                    path: "/demo"
                                },
                                setInViewItem: ()=>{
                                    setInViewItem("demo");
                                }
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                                w: "100%",
                                pt: "3",
                                pb: "0",
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "lg",
                                    children: "Variations"
                                })
                            }),
                            historyByVariation.map((item)=>{
                                return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $41cd8b08f8508245$export$60332b2344f7fe41), {
                                    id: item.id,
                                    height: "490px",
                                    setInViewItem: ()=>{
                                        setInViewItem(item.id);
                                    },
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $102e1f5ba4edbb25$export$c473c5da53cb704f), {
                                        parentBuildID: buildID,
                                        history: item.history,
                                        variationId: item.id,
                                        active: active
                                    })
                                }, item.id);
                            })
                        ]
                    })
                })
            ]
        })
    });
};


const $e35c56f335165994$export$c96d114208f4b6d4 = (0, $5058ffe240ffde31$export$369b6b2b30582e8e)(({ match: { params: { buildID: buildID } } })=>{
    const [dcoData, isLoading] = (0, $6514dfe9493a8613$export$e51b731bc9951cc1)(buildID);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        height: "100%",
        direction: "column",
        w: "100%",
        children: isLoading ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
            mt: "50px",
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6d34caa3f6c24444$export$e854a2165401836f), {})
        }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $735d6c3d3be0d28c$export$abc2b1c02cffc32b), {
            buildID: buildID,
            dcoData: dcoData
        })
    });
});






"use client";
var $9aca4c08d30fd905$var$css = String.raw;
var $9aca4c08d30fd905$var$vhPolyfill = $9aca4c08d30fd905$var$css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
var $9aca4c08d30fd905$export$43a6590e493ec44a = ()=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8c971e9544ccda33$export$98f03c5d19621d70), {
        styles: $9aca4c08d30fd905$var$vhPolyfill
    });
var $9aca4c08d30fd905$export$b751feffed387621 = ({ scope: scope = "" })=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8c971e9544ccda33$export$98f03c5d19621d70), {
        styles: $9aca4c08d30fd905$var$css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${$9aca4c08d30fd905$var$vhPolyfill}
    `
    });
var $9aca4c08d30fd905$export$428e8dbfc1580f11 = $9aca4c08d30fd905$export$b751feffed387621;




"use client";
// src/color-mode.utils.ts
var $88252a2eccd2b853$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
function $88252a2eccd2b853$export$4bb933d353baa01c(options = {}) {
    const { preventTransition: preventTransition = true } = options;
    const utils = {
        setDataset: (value)=>{
            const cleanup = preventTransition ? utils.preventTransition() : void 0;
            document.documentElement.dataset.theme = value;
            document.documentElement.style.colorScheme = value;
            cleanup == null || cleanup();
        },
        setClassName (dark) {
            document.body.classList.add(dark ? $88252a2eccd2b853$var$classNames.dark : $88252a2eccd2b853$var$classNames.light);
            document.body.classList.remove(dark ? $88252a2eccd2b853$var$classNames.light : $88252a2eccd2b853$var$classNames.dark);
        },
        query () {
            return window.matchMedia("(prefers-color-scheme: dark)");
        },
        getSystemTheme (fallback) {
            var _a;
            const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
            return dark ? "dark" : "light";
        },
        addListener (fn) {
            const mql = utils.query();
            const listener = (e)=>{
                fn(e.matches ? "dark" : "light");
            };
            if (typeof mql.addListener === "function") mql.addListener(listener);
            else mql.addEventListener("change", listener);
            return ()=>{
                if (typeof mql.removeListener === "function") mql.removeListener(listener);
                else mql.removeEventListener("change", listener);
            };
        },
        preventTransition () {
            const css = document.createElement("style");
            css.appendChild(document.createTextNode(`*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`));
            document.head.appendChild(css);
            return ()=>{
                (()=>window.getComputedStyle(document.body))();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        document.head.removeChild(css);
                    });
                });
            };
        }
    };
    return utils;
}


"use client";
// src/storage-manager.ts
var $5d1242c153f761d4$export$86880b4b2e1a2384 = "chakra-ui-color-mode";
function $5d1242c153f761d4$export$cdf53b88b62eb393(key) {
    return {
        ssr: false,
        type: "localStorage",
        get (init) {
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            let value;
            try {
                value = localStorage.getItem(key) || init;
            } catch (e) {}
            return value || init;
        },
        set (value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {}
        }
    };
}
var $5d1242c153f761d4$export$8e35886de8a54f45 = $5d1242c153f761d4$export$cdf53b88b62eb393($5d1242c153f761d4$export$86880b4b2e1a2384);
function $5d1242c153f761d4$var$parseCookie(cookie, key) {
    const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
    return match == null ? void 0 : match[2];
}
function $5d1242c153f761d4$export$df28b7d6efe2673c(key, cookie) {
    return {
        ssr: !!cookie,
        type: "cookie",
        get (init) {
            if (cookie) return $5d1242c153f761d4$var$parseCookie(cookie, key);
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            return $5d1242c153f761d4$var$parseCookie(document.cookie, key) || init;
        },
        set (value) {
            document.cookie = `${key}=${value}; max-age=31536000; path=/`;
        }
    };
}
var $5d1242c153f761d4$export$2e2b0158437077e3 = $5d1242c153f761d4$export$df28b7d6efe2673c($5d1242c153f761d4$export$86880b4b2e1a2384);
var $5d1242c153f761d4$export$d76e8eed3e914fa0 = (cookie)=>$5d1242c153f761d4$export$df28b7d6efe2673c($5d1242c153f761d4$export$86880b4b2e1a2384, cookie);




var $lDSNw = parcelRequire("lDSNw");

"use client";
var $7aa26356f9ce81cc$var$noop = ()=>{};
function $7aa26356f9ce81cc$var$getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function $7aa26356f9ce81cc$export$7a858aa3ff83dde7(props) {
    const { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode, disableTransitionOnChange: disableTransitionOnChange } = {}, colorModeManager: colorModeManager = (0, $5d1242c153f761d4$export$8e35886de8a54f45) } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = (0, $lDSNw.useState)(()=>$7aa26356f9ce81cc$var$getTheme(colorModeManager, defaultColorMode));
    const [resolvedColorMode, setResolvedColorMode] = (0, $lDSNw.useState)(()=>$7aa26356f9ce81cc$var$getTheme(colorModeManager));
    const { getSystemTheme: getSystemTheme, setClassName: setClassName, setDataset: setDataset, addListener: addListener } = (0, $lDSNw.useMemo)(()=>(0, $88252a2eccd2b853$export$4bb933d353baa01c)({
            preventTransition: disableTransitionOnChange
        }), [
        disableTransitionOnChange
    ]);
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = (0, $lDSNw.useCallback)((value2)=>{
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
    }, [
        colorModeManager,
        getSystemTheme,
        setClassName,
        setDataset
    ]);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (initialColorMode === "system") setResolvedColorMode(getSystemTheme());
    }, []);
    (0, $lDSNw.useEffect)(()=>{
        const managerValue = colorModeManager.get();
        if (managerValue) {
            setColorMode(managerValue);
            return;
        }
        if (initialColorMode === "system") {
            setColorMode("system");
            return;
        }
        setColorMode(defaultColorMode);
    }, [
        colorModeManager,
        defaultColorMode,
        initialColorMode,
        setColorMode
    ]);
    const toggleColorMode = (0, $lDSNw.useCallback)(()=>{
        setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [
        resolvedValue,
        setColorMode
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!useSystemColorMode) return;
        return addListener(setColorMode);
    }, [
        useSystemColorMode,
        addListener,
        setColorMode
    ]);
    const context = (0, $lDSNw.useMemo)(()=>({
            colorMode: value != null ? value : resolvedValue,
            toggleColorMode: value ? $7aa26356f9ce81cc$var$noop : toggleColorMode,
            setColorMode: value ? $7aa26356f9ce81cc$var$noop : setColorMode,
            forced: value !== void 0
        }), [
        resolvedValue,
        toggleColorMode,
        setColorMode,
        value
    ]);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $53a9951d8b44cf80$export$49ddd74a6729fdb0).Provider, {
        value: context,
        children: children
    });
}
$7aa26356f9ce81cc$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
function $7aa26356f9ce81cc$export$8b41b18ed1f3731e(props) {
    const context = (0, $lDSNw.useMemo)(()=>({
            colorMode: "dark",
            toggleColorMode: $7aa26356f9ce81cc$var$noop,
            setColorMode: $7aa26356f9ce81cc$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $53a9951d8b44cf80$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$7aa26356f9ce81cc$export$8b41b18ed1f3731e.displayName = "DarkMode";
function $7aa26356f9ce81cc$export$cee2b1aa9166b2a3(props) {
    const context = (0, $lDSNw.useMemo)(()=>({
            colorMode: "light",
            toggleColorMode: $7aa26356f9ce81cc$var$noop,
            setColorMode: $7aa26356f9ce81cc$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $53a9951d8b44cf80$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$7aa26356f9ce81cc$export$cee2b1aa9166b2a3.displayName = "LightMode";


// src/context.ts

var $lDSNw = parcelRequire("lDSNw");
function $0c97b135c7dd815b$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = (0, $lDSNw.createContext)(void 0);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $lDSNw.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}






var $lDSNw = parcelRequire("lDSNw");

"use client";
function $0ee78d01d64a4dc0$export$d8964aec282183a3(props) {
    const { cssVarsRoot: cssVarsRoot, theme: theme, children: children } = props;
    const computedTheme = (0, $lDSNw.useMemo)(()=>(0, $01a983b3ad87bd07$export$d4e5dc2a444c0164)(theme), [
        theme
    ]);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $fee187d89b24554e$export$407448d2b89b1813), {
        theme: computedTheme,
        children: [
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($0ee78d01d64a4dc0$export$d767872124667db6, {
                root: cssVarsRoot
            }),
            children
        ]
    });
}
function $0ee78d01d64a4dc0$export$d767872124667db6({ root: root = ":host, :root" }) {
    const selector = [
        root,
        `[data-theme]`
    ].join(",");
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8c971e9544ccda33$export$98f03c5d19621d70), {
        styles: (theme)=>({
                [selector]: theme.__cssVars
            })
    });
}
var [$0ee78d01d64a4dc0$export$dc4c659861f00dbe, $0ee78d01d64a4dc0$export$28e6b9b82ee883c] = (0, $0c97b135c7dd815b$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $0ee78d01d64a4dc0$export$11d9f9905bcdc114(componentName) {
    return (0, $0c97b135c7dd815b$export$fd42f52fd3ae1109)({
        name: `${componentName}StylesContext`,
        errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
    });
}
function $0ee78d01d64a4dc0$export$f05794e648629f6c() {
    const { colorMode: colorMode } = (0, $53a9951d8b44cf80$export$20f3076712c8dfa)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8c971e9544ccda33$export$98f03c5d19621d70), {
        styles: (theme)=>{
            const styleObjectOrFn = (0, $f9ff6ad38b3f7068$export$1bb32d0c65da6059)(theme, "styles.global");
            const globalStyles = (0, $61d460608c17cbaf$export$624e501d81f5ffce)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return void 0;
            const styles = (0, $01a983b3ad87bd07$export$dbf350e5966cf602)(globalStyles)(theme);
            return styles;
        }
    });
}




var $lDSNw = parcelRequire("lDSNw");

"use client";
var $a7587505528881ba$var$EnvironmentContext = (0, $lDSNw.createContext)({
    getDocument () {
        return document;
    },
    getWindow () {
        return window;
    }
});
$a7587505528881ba$var$EnvironmentContext.displayName = "EnvironmentContext";
function $a7587505528881ba$export$ea7ed2425832167d({ defer: defer } = {}) {
    const [, forceUpdate] = (0, $lDSNw.useReducer)((c)=>c + 1, 0);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (!defer) return;
        forceUpdate();
    }, [
        defer
    ]);
    return (0, $lDSNw.useContext)($a7587505528881ba$var$EnvironmentContext);
}
function $a7587505528881ba$export$29a4c0b32fc9db42(props) {
    const { children: children, environment: environmentProp, disabled: disabled } = props;
    const ref = (0, $lDSNw.useRef)(null);
    const context = (0, $lDSNw.useMemo)(()=>{
        if (environmentProp) return environmentProp;
        return {
            getDocument: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
            },
            getWindow: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
            }
        };
    }, [
        environmentProp
    ]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)($a7587505528881ba$var$EnvironmentContext.Provider, {
        value: context,
        children: [
            children,
            showSpan && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("span", {
                id: "__chakra_env",
                hidden: true,
                ref: ref
            })
        ]
    });
}
$a7587505528881ba$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";



"use client";
var $897fc0158b3736a0$export$80dbe0482bcbd25a = (props)=>{
    const { children: children, colorModeManager: colorModeManager, portalZIndex: portalZIndex, resetScope: resetScope, resetCSS: resetCSS = true, theme: theme = {}, environment: environment, cssVarsRoot: cssVarsRoot, disableEnvironment: disableEnvironment, disableGlobalStyle: disableGlobalStyle } = props;
    const _children = /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a7587505528881ba$export$29a4c0b32fc9db42), {
        environment: environment,
        disabled: disableEnvironment,
        children: children
    });
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0ee78d01d64a4dc0$export$d8964aec282183a3), {
        theme: theme,
        cssVarsRoot: cssVarsRoot,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $7aa26356f9ce81cc$export$7a858aa3ff83dde7), {
            colorModeManager: colorModeManager,
            options: theme.config,
            children: [
                resetCSS ? /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $9aca4c08d30fd905$export$b751feffed387621), {
                    scope: resetScope
                }) : /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $9aca4c08d30fd905$export$43a6590e493ec44a), {}),
                !disableGlobalStyle && /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0ee78d01d64a4dc0$export$f05794e648629f6c), {}),
                portalZIndex ? /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $582380aaf86f03b6$export$52c7ef79917c2f38), {
                    zIndex: portalZIndex,
                    children: _children
                }) : _children
            ]
        })
    });
};





"use client";
var $f499e6d2572af6ff$var$createChakraProvider = (providerTheme)=>{
    return function ChakraProvider2({ children: children, theme: theme = providerTheme, toastOptions: toastOptions, ...restProps }) {
        return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $897fc0158b3736a0$export$80dbe0482bcbd25a), {
            theme: theme,
            ...restProps,
            children: [
                /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a28809c469396bf0$export$cfcc07abbe2e36a8), {
                    value: toastOptions == null ? void 0 : toastOptions.defaultOptions,
                    children: children
                }),
                /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a28809c469396bf0$export$f5d03d415824e0e), {
                    ...toastOptions
                })
            ]
        });
    };
};
var $f499e6d2572af6ff$export$80dbe0482bcbd25a = $f499e6d2572af6ff$var$createChakraProvider((0, $823d38277d136a79$export$bca14c5b3b88a9c9));
var $f499e6d2572af6ff$export$39d642dd5c97e94c = $f499e6d2572af6ff$var$createChakraProvider((0, $823d38277d136a79$export$9e955aef208055a6));



parcelRequire("lDSNw");


parcelRequire("lDSNw");


var $facff3618c841378$exports = {};

$parcel$export($facff3618c841378$exports, "logout", function () { return $facff3618c841378$export$a0973bcfe11b05c9; }, function (v) { return $facff3618c841378$export$a0973bcfe11b05c9 = v; });
$parcel$export($facff3618c841378$exports, "logoutPanel", function () { return $facff3618c841378$export$32e78f20c08413f2; }, function (v) { return $facff3618c841378$export$32e78f20c08413f2 = v; });
$parcel$export($facff3618c841378$exports, "username", function () { return $facff3618c841378$export$5e1be761f603d585; }, function (v) { return $facff3618c841378$export$5e1be761f603d585 = v; });
var $facff3618c841378$export$a0973bcfe11b05c9;
var $facff3618c841378$export$32e78f20c08413f2;
var $facff3618c841378$export$5e1be761f603d585;
$facff3618c841378$export$a0973bcfe11b05c9 = `z2YRCW_logout`;
$facff3618c841378$export$32e78f20c08413f2 = `z2YRCW_logoutPanel`;
$facff3618c841378$export$5e1be761f603d585 = `z2YRCW_username`;


const $b2f4640c38d55dcc$var$LogOut = ()=>{
    const setLogOut = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.setLogOut);
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const logOutHandler = ()=>{
        (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).auth().signOut().then(function() {
            setLogOut();
        }).catch(function(error) {
            console.error(error);
        });
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($facff3618c841378$exports))).logoutPanel,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
                src: `${userInfo.photoURL ? userInfo.photoURL : "https://coenterprises.com.au/wp-content/uploads/2018/02/male-placeholder-image.jpeg"}`,
                alt: "avatar"
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($facff3618c841378$exports))).logout,
                onClick: logOutHandler,
                children: "Logout"
            })
        ]
    });
};
var $b2f4640c38d55dcc$export$2e2bcd8739ae039 = $b2f4640c38d55dcc$var$LogOut;


var $e389081efb30fcc8$exports = {};

$parcel$export($e389081efb30fcc8$exports, "active", function () { return $e389081efb30fcc8$export$89da14300d534261; }, function (v) { return $e389081efb30fcc8$export$89da14300d534261 = v; });
$parcel$export($e389081efb30fcc8$exports, "cat", function () { return $e389081efb30fcc8$export$99aaa11fb71d263; }, function (v) { return $e389081efb30fcc8$export$99aaa11fb71d263 = v; });
$parcel$export($e389081efb30fcc8$exports, "catLogo", function () { return $e389081efb30fcc8$export$43a256886a76ca5; }, function (v) { return $e389081efb30fcc8$export$43a256886a76ca5 = v; });
$parcel$export($e389081efb30fcc8$exports, "header", function () { return $e389081efb30fcc8$export$38e42c68cf43b5d4; }, function (v) { return $e389081efb30fcc8$export$38e42c68cf43b5d4 = v; });
$parcel$export($e389081efb30fcc8$exports, "headerInner", function () { return $e389081efb30fcc8$export$39dd1d7fe083ad3e; }, function (v) { return $e389081efb30fcc8$export$39dd1d7fe083ad3e = v; });
$parcel$export($e389081efb30fcc8$exports, "headerWrapper", function () { return $e389081efb30fcc8$export$33ec9fcec07f6e7f; }, function (v) { return $e389081efb30fcc8$export$33ec9fcec07f6e7f = v; });
$parcel$export($e389081efb30fcc8$exports, "nav", function () { return $e389081efb30fcc8$export$80e4b313e5e6b30d; }, function (v) { return $e389081efb30fcc8$export$80e4b313e5e6b30d = v; });
$parcel$export($e389081efb30fcc8$exports, "noLink", function () { return $e389081efb30fcc8$export$5aa36f6d1fcc7667; }, function (v) { return $e389081efb30fcc8$export$5aa36f6d1fcc7667 = v; });
var $e389081efb30fcc8$export$89da14300d534261;
var $e389081efb30fcc8$export$99aaa11fb71d263;
var $e389081efb30fcc8$export$43a256886a76ca5;
var $e389081efb30fcc8$export$38e42c68cf43b5d4;
var $e389081efb30fcc8$export$39dd1d7fe083ad3e;
var $e389081efb30fcc8$export$33ec9fcec07f6e7f;
var $e389081efb30fcc8$export$80e4b313e5e6b30d;
var $e389081efb30fcc8$export$5aa36f6d1fcc7667;
$e389081efb30fcc8$export$89da14300d534261 = `kEWYqq_active`;
$e389081efb30fcc8$export$99aaa11fb71d263 = `kEWYqq_cat`;
$e389081efb30fcc8$export$43a256886a76ca5 = `kEWYqq_catLogo`;
$e389081efb30fcc8$export$38e42c68cf43b5d4 = `kEWYqq_header`;
$e389081efb30fcc8$export$39dd1d7fe083ad3e = `kEWYqq_headerInner`;
$e389081efb30fcc8$export$33ec9fcec07f6e7f = `kEWYqq_headerWrapper`;
$e389081efb30fcc8$export$80e4b313e5e6b30d = `kEWYqq_nav`;
$e389081efb30fcc8$export$5aa36f6d1fcc7667 = `kEWYqq_noLink`;


var $3b4086b396ff5887$exports = {};

$3b4086b396ff5887$exports = new URL((parcelRequire("5V6iE")).resolve("7WzPb"), import.meta.url).toString();



let $6a12f0e5b07bb381$var$logo;
function $6a12f0e5b07bb381$var$Header({ loggedIn: loggedIn, text: text }) {
    const queryParams = new URLSearchParams(window.location.search);
    const isPresentationMode = queryParams.get("layoutMode") === "presentation";
    if (loggedIn) $6a12f0e5b07bb381$var$logo = /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).headerWrapper,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                as: (0, $3ee3b72d91cbc81c$export$a6c7ac8248d6e38a),
                to: "/",
                variant: "ghost",
                px: 0,
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).cat,
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3b4086b396ff5887$exports))),
                        alt: "logo",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).catLogo
                    })
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b2f4640c38d55dcc$export$2e2bcd8739ae039), {})
        ]
    });
    else $6a12f0e5b07bb381$var$logo = /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).cat} ${(0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).noLink}`,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3b4086b396ff5887$exports))),
            alt: "logo",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).catLogo
        })
    });
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).header,
        display: isPresentationMode ? "none" : "flex",
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e389081efb30fcc8$exports))).headerInner,
            children: $6a12f0e5b07bb381$var$logo
        })
    });
}
var $6a12f0e5b07bb381$export$2e2bcd8739ae039 = $6a12f0e5b07bb381$var$Header;








var $lDSNw = parcelRequire("lDSNw");
"use client";
function $e0af31c12482a606$export$43d26308f6d75a57() {
    const listeners = (0, $lDSNw.useRef)(/* @__PURE__ */ new Map());
    const currentListeners = listeners.current;
    const add = (0, $lDSNw.useCallback)((el, type, listener, options)=>{
        listeners.current.set(listener, {
            type: type,
            el: el,
            options: options
        });
        el.addEventListener(type, listener, options);
    }, []);
    const remove = (0, $lDSNw.useCallback)((el, type, listener, options)=>{
        el.removeEventListener(type, listener, options);
        listeners.current.delete(listener);
    }, []);
    (0, $lDSNw.useEffect)(()=>()=>{
            currentListeners.forEach((value, key)=>{
                remove(value.el, value.type, key, value.options);
            });
        }, [
        remove,
        currentListeners
    ]);
    return {
        add: add,
        remove: remove
    };
}





var $lDSNw = parcelRequire("lDSNw");
"use client";
function $cf565c06db5dad98$var$isValidElement(event) {
    const element = event.target;
    const { tagName: tagName, isContentEditable: isContentEditable } = element;
    return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
}
function $cf565c06db5dad98$export$ed213cc82e426b1a(props = {}) {
    const { ref: htmlRef, isDisabled: isDisabled, isFocusable: isFocusable, clickOnEnter: clickOnEnter = true, clickOnSpace: clickOnSpace = true, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, tabIndex: tabIndexProp, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, ...htmlProps } = props;
    const [isButton, setIsButton] = (0, $lDSNw.useState)(true);
    const [isPressed, setIsPressed] = (0, $lDSNw.useState)(false);
    const listeners = (0, $e0af31c12482a606$export$43d26308f6d75a57)();
    const refCallback = (node)=>{
        if (!node) return;
        if (node.tagName !== "BUTTON") setIsButton(false);
    };
    const tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
    const trulyDisabled = isDisabled && !isFocusable;
    const handleClick = (0, $lDSNw.useCallback)((event)=>{
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        const self = event.currentTarget;
        self.focus();
        onClick == null || onClick(event);
    }, [
        isDisabled,
        onClick
    ]);
    const onDocumentKeyUp = (0, $lDSNw.useCallback)((e)=>{
        if (isPressed && $cf565c06db5dad98$var$isValidElement(e)) {
            e.preventDefault();
            e.stopPropagation();
            setIsPressed(false);
            listeners.remove(document, "keyup", onDocumentKeyUp, false);
        }
    }, [
        isPressed,
        listeners
    ]);
    const handleKeyDown = (0, $lDSNw.useCallback)((event)=>{
        onKeyDown == null || onKeyDown(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$cf565c06db5dad98$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnEnter = clickOnEnter && event.key === "Enter";
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(true);
        }
        if (shouldClickOnEnter) {
            event.preventDefault();
            const self = event.currentTarget;
            self.click();
        }
        listeners.add(document, "keyup", onDocumentKeyUp, false);
    }, [
        isDisabled,
        isButton,
        onKeyDown,
        clickOnEnter,
        clickOnSpace,
        listeners,
        onDocumentKeyUp
    ]);
    const handleKeyUp = (0, $lDSNw.useCallback)((event)=>{
        onKeyUp == null || onKeyUp(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$cf565c06db5dad98$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(false);
            const self = event.currentTarget;
            self.click();
        }
    }, [
        clickOnSpace,
        isButton,
        isDisabled,
        onKeyUp
    ]);
    const onDocumentMouseUp = (0, $lDSNw.useCallback)((event)=>{
        if (event.button !== 0) return;
        setIsPressed(false);
        listeners.remove(document, "mouseup", onDocumentMouseUp, false);
    }, [
        listeners
    ]);
    const handleMouseDown = (0, $lDSNw.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (!isButton) setIsPressed(true);
        const target = event.currentTarget;
        target.focus({
            preventScroll: true
        });
        listeners.add(document, "mouseup", onDocumentMouseUp, false);
        onMouseDown == null || onMouseDown(event);
    }, [
        isDisabled,
        isButton,
        onMouseDown,
        listeners,
        onDocumentMouseUp
    ]);
    const handleMouseUp = (0, $lDSNw.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (!isButton) setIsPressed(false);
        onMouseUp == null || onMouseUp(event);
    }, [
        onMouseUp,
        isButton
    ]);
    const handleMouseOver = (0, $lDSNw.useCallback)((event)=>{
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        onMouseOver == null || onMouseOver(event);
    }, [
        isDisabled,
        onMouseOver
    ]);
    const handleMouseLeave = (0, $lDSNw.useCallback)((event)=>{
        if (isPressed) {
            event.preventDefault();
            setIsPressed(false);
        }
        onMouseLeave == null || onMouseLeave(event);
    }, [
        isPressed,
        onMouseLeave
    ]);
    const ref = (0, $dc32195927d0d802$export$c9058316764c140e)(htmlRef, refCallback);
    if (isButton) return {
        ...htmlProps,
        ref: ref,
        type: "button",
        "aria-disabled": trulyDisabled ? void 0 : isDisabled,
        disabled: trulyDisabled,
        onClick: handleClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    };
    return {
        ...htmlProps,
        ref: ref,
        role: "button",
        "data-active": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(isPressed),
        "aria-disabled": isDisabled ? "true" : void 0,
        tabIndex: trulyDisabled ? void 0 : tabIndex,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseLeave: handleMouseLeave
    };
}



var $lDSNw = parcelRequire("lDSNw");
"use client";
var $d9a1e7b93dc45950$var$__defProp = Object.defineProperty;
var $d9a1e7b93dc45950$var$__defNormalProp = (obj, key, value)=>key in obj ? $d9a1e7b93dc45950$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d9a1e7b93dc45950$export$5cb848ba4d1f099 = (obj, key, value)=>{
    $d9a1e7b93dc45950$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
function $d9a1e7b93dc45950$export$96d07f33920abf3e(nodes) {
    return nodes.sort((a, b)=>{
        const compare = a.compareDocumentPosition(b);
        if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
        if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) return 1;
        if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) throw Error("Cannot sort the given nodes.");
        else return 0;
    });
}
var $d9a1e7b93dc45950$export$45a5e7f76e0caa8d = (el)=>typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function $d9a1e7b93dc45950$export$c42e0e80904d519(current, max, loop) {
    let next = current + 1;
    if (loop && next >= max) next = 0;
    return next;
}
function $d9a1e7b93dc45950$export$1081b7170ed6e343(current, max, loop) {
    let next = current - 1;
    if (loop && next < 0) next = max;
    return next;
}
var $d9a1e7b93dc45950$export$deebe11a338de063 = typeof window !== "undefined" ? (0, $lDSNw.useLayoutEffect) : (0, $lDSNw.useEffect);
var $d9a1e7b93dc45950$export$f2db7d5238e1d23f = (value)=>value;


"use client";
// src/descendant.ts
var $9651198b03a34db2$export$e6418ef1851accd = class {
    constructor(){
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "descendants", /* @__PURE__ */ new Map());
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "register", (nodeOrOptions)=>{
            if (nodeOrOptions == null) return;
            if ((0, $d9a1e7b93dc45950$export$45a5e7f76e0caa8d)(nodeOrOptions)) return this.registerNode(nodeOrOptions);
            return (node)=>{
                this.registerNode(node, nodeOrOptions);
            };
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "unregister", (node)=>{
            this.descendants.delete(node);
            const sorted = (0, $d9a1e7b93dc45950$export$96d07f33920abf3e)(Array.from(this.descendants.keys()));
            this.assignIndex(sorted);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "destroy", ()=>{
            this.descendants.clear();
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "assignIndex", (descendants)=>{
            this.descendants.forEach((descendant)=>{
                const index = descendants.indexOf(descendant.node);
                descendant.index = index;
                descendant.node.dataset["index"] = descendant.index.toString();
            });
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "count", ()=>this.descendants.size);
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "enabledCount", ()=>this.enabledValues().length);
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "values", ()=>{
            const values = Array.from(this.descendants.values());
            return values.sort((a, b)=>a.index - b.index);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "enabledValues", ()=>{
            return this.values().filter((descendant)=>!descendant.disabled);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "item", (index)=>{
            if (this.count() === 0) return void 0;
            return this.values()[index];
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "enabledItem", (index)=>{
            if (this.enabledCount() === 0) return void 0;
            return this.enabledValues()[index];
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "first", ()=>this.item(0));
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "firstEnabled", ()=>this.enabledItem(0));
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "last", ()=>this.item(this.descendants.size - 1));
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "lastEnabled", ()=>{
            const lastIndex = this.enabledValues().length - 1;
            return this.enabledItem(lastIndex);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "indexOf", (node)=>{
            var _a, _b;
            if (!node) return -1;
            return (_b = (_a = this.descendants.get(node)) == null ? void 0 : _a.index) != null ? _b : -1;
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "enabledIndexOf", (node)=>{
            if (node == null) return -1;
            return this.enabledValues().findIndex((i)=>i.node.isSameNode(node));
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "next", (index, loop = true)=>{
            const next = (0, $d9a1e7b93dc45950$export$c42e0e80904d519)(index, this.count(), loop);
            return this.item(next);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "nextEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const nextEnabledIndex = (0, $d9a1e7b93dc45950$export$c42e0e80904d519)(enabledIndex, this.enabledCount(), loop);
            return this.enabledItem(nextEnabledIndex);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "prev", (index, loop = true)=>{
            const prev = (0, $d9a1e7b93dc45950$export$1081b7170ed6e343)(index, this.count() - 1, loop);
            return this.item(prev);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "prevEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const prevEnabledIndex = (0, $d9a1e7b93dc45950$export$1081b7170ed6e343)(enabledIndex, this.enabledCount() - 1, loop);
            return this.enabledItem(prevEnabledIndex);
        });
        (0, $d9a1e7b93dc45950$export$5cb848ba4d1f099)(this, "registerNode", (node, options)=>{
            if (!node || this.descendants.has(node)) return;
            const keys = Array.from(this.descendants.keys()).concat(node);
            const sorted = (0, $d9a1e7b93dc45950$export$96d07f33920abf3e)(keys);
            if (options == null ? void 0 : options.disabled) options.disabled = !!options.disabled;
            const descendant = {
                node: node,
                index: -1,
                ...options
            };
            this.descendants.set(node, descendant);
            this.assignIndex(sorted);
        });
    }
};






var $lDSNw = parcelRequire("lDSNw");
"use client";
function $f804e39eab5fd41b$var$useDescendants() {
    const descendants = (0, $lDSNw.useRef)(new (0, $9651198b03a34db2$export$e6418ef1851accd)());
    (0, $d9a1e7b93dc45950$export$deebe11a338de063)(()=>{
        return ()=>descendants.current.destroy();
    });
    return descendants.current;
}
var [$f804e39eab5fd41b$var$DescendantsContextProvider, $f804e39eab5fd41b$var$useDescendantsContext] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function $f804e39eab5fd41b$var$useDescendant(options) {
    const descendants = $f804e39eab5fd41b$var$useDescendantsContext();
    const [index, setIndex] = (0, $lDSNw.useState)(-1);
    const ref = (0, $lDSNw.useRef)(null);
    (0, $d9a1e7b93dc45950$export$deebe11a338de063)(()=>{
        return ()=>{
            if (!ref.current) return;
            descendants.unregister(ref.current);
        };
    }, []);
    (0, $d9a1e7b93dc45950$export$deebe11a338de063)(()=>{
        if (!ref.current) return;
        const dataIndex = Number(ref.current.dataset["index"]);
        if (index != dataIndex && !Number.isNaN(dataIndex)) setIndex(dataIndex);
    });
    const refCallback = options ? (0, $d9a1e7b93dc45950$export$f2db7d5238e1d23f)(descendants.register(options)) : (0, $d9a1e7b93dc45950$export$f2db7d5238e1d23f)(descendants.register);
    return {
        descendants: descendants,
        index: index,
        enabledIndex: descendants.enabledIndexOf(ref.current),
        register: (0, $dc32195927d0d802$export$c9058316764c140e)(refCallback, ref)
    };
}
function $f804e39eab5fd41b$export$126c4100f8947d7() {
    const ContextProvider = (0, $d9a1e7b93dc45950$export$f2db7d5238e1d23f)($f804e39eab5fd41b$var$DescendantsContextProvider);
    const _useDescendantsContext = ()=>(0, $d9a1e7b93dc45950$export$f2db7d5238e1d23f)($f804e39eab5fd41b$var$useDescendantsContext());
    const _useDescendant = (options)=>$f804e39eab5fd41b$var$useDescendant(options);
    const _useDescendants = ()=>$f804e39eab5fd41b$var$useDescendants();
    return [
        // context provider
        ContextProvider,
        // call this when you need to read from context
        _useDescendantsContext,
        // descendants state information, to be called and passed to `ContextProvider`
        _useDescendants,
        // descendant index information
        _useDescendant
    ];
}










var $lDSNw = parcelRequire("lDSNw");
"use client";
var [$7c2fd4f406a903b2$export$29ffb0a76b0529f5, $7c2fd4f406a903b2$export$41df96b51c5f5358, $7c2fd4f406a903b2$export$82af15abb0e12d09, $7c2fd4f406a903b2$export$48a1e112587310fb] = (0, $f804e39eab5fd41b$export$126c4100f8947d7)();
function $7c2fd4f406a903b2$export$d2589202ac9c89c3(props) {
    var _a;
    const { defaultIndex: defaultIndex, onChange: onChange, index: index, isManual: isManual, isLazy: isLazy, lazyBehavior: lazyBehavior = "unmount", orientation: orientation = "horizontal", direction: direction = "ltr", ...htmlProps } = props;
    const [focusedIndex, setFocusedIndex] = (0, $lDSNw.useState)(defaultIndex != null ? defaultIndex : 0);
    const [selectedIndex, setSelectedIndex] = (0, $1c6446ce89a1d8f0$export$6f32135080cb4c3)({
        defaultValue: defaultIndex != null ? defaultIndex : 0,
        value: index,
        onChange: onChange
    });
    (0, $lDSNw.useEffect)(()=>{
        if (index != null) setFocusedIndex(index);
    }, [
        index
    ]);
    const descendants = $7c2fd4f406a903b2$export$82af15abb0e12d09();
    const uuid = (0, $lDSNw.useId)();
    const uid = (_a = props.id) != null ? _a : uuid;
    const id = `tabs-${uid}`;
    return {
        id: id,
        selectedIndex: selectedIndex,
        focusedIndex: focusedIndex,
        setSelectedIndex: setSelectedIndex,
        setFocusedIndex: setFocusedIndex,
        isManual: isManual,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        orientation: orientation,
        descendants: descendants,
        direction: direction,
        htmlProps: htmlProps
    };
}
var [$7c2fd4f406a903b2$export$aea4e5437b3b752e, $7c2fd4f406a903b2$export$5c3d36c3adf0ba92] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: "TabsContext",
    errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
function $7c2fd4f406a903b2$export$773e389e644c5874(props) {
    const { focusedIndex: focusedIndex, orientation: orientation, direction: direction } = $7c2fd4f406a903b2$export$5c3d36c3adf0ba92();
    const descendants = $7c2fd4f406a903b2$export$41df96b51c5f5358();
    const onKeyDown = (0, $lDSNw.useCallback)((event)=>{
        const nextTab = ()=>{
            var _a;
            const next = descendants.nextEnabled(focusedIndex);
            if (next) (_a = next.node) == null || _a.focus();
        };
        const prevTab = ()=>{
            var _a;
            const prev = descendants.prevEnabled(focusedIndex);
            if (prev) (_a = prev.node) == null || _a.focus();
        };
        const firstTab = ()=>{
            var _a;
            const first = descendants.firstEnabled();
            if (first) (_a = first.node) == null || _a.focus();
        };
        const lastTab = ()=>{
            var _a;
            const last = descendants.lastEnabled();
            if (last) (_a = last.node) == null || _a.focus();
        };
        const isHorizontal = orientation === "horizontal";
        const isVertical = orientation === "vertical";
        const eventKey = event.key;
        const ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
        const ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
        const keyMap = {
            [ArrowStart]: ()=>isHorizontal && prevTab(),
            [ArrowEnd]: ()=>isHorizontal && nextTab(),
            ArrowDown: ()=>isVertical && nextTab(),
            ArrowUp: ()=>isVertical && prevTab(),
            Home: firstTab,
            End: lastTab
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        descendants,
        focusedIndex,
        orientation,
        direction
    ]);
    return {
        ...props,
        role: "tablist",
        "aria-orientation": orientation,
        onKeyDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $7c2fd4f406a903b2$export$fdf4756d5b8ef90a(props) {
    const { isDisabled: isDisabled = false, isFocusable: isFocusable = false, ...htmlProps } = props;
    const { setSelectedIndex: setSelectedIndex, isManual: isManual, id: id, setFocusedIndex: setFocusedIndex, selectedIndex: selectedIndex } = $7c2fd4f406a903b2$export$5c3d36c3adf0ba92();
    const { index: index, register: register } = $7c2fd4f406a903b2$export$48a1e112587310fb({
        disabled: isDisabled && !isFocusable
    });
    const isSelected = index === selectedIndex;
    const onClick = ()=>{
        setSelectedIndex(index);
    };
    const onFocus = ()=>{
        setFocusedIndex(index);
        const isDisabledButFocusable = isDisabled && isFocusable;
        const shouldSelect = !isManual && !isDisabledButFocusable;
        if (shouldSelect) setSelectedIndex(index);
    };
    const clickableProps = (0, $cf565c06db5dad98$export$ed213cc82e426b1a)({
        ...htmlProps,
        ref: (0, $dc32195927d0d802$export$c9058316764c140e)(register, props.ref),
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        onClick: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props.onClick, onClick)
    });
    const type = "button";
    return {
        ...clickableProps,
        id: $7c2fd4f406a903b2$var$makeTabId(id, index),
        role: "tab",
        tabIndex: isSelected ? 0 : -1,
        type: type,
        "aria-selected": isSelected,
        "aria-controls": $7c2fd4f406a903b2$var$makeTabPanelId(id, index),
        onFocus: isDisabled ? void 0 : (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props.onFocus, onFocus)
    };
}
var [$7c2fd4f406a903b2$var$TabPanelProvider, $7c2fd4f406a903b2$var$useTabPanelContext] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({});
function $7c2fd4f406a903b2$export$a7a84e09564ff6eb(props) {
    const context = $7c2fd4f406a903b2$export$5c3d36c3adf0ba92();
    const { id: id, selectedIndex: selectedIndex } = context;
    const validChildren = (0, $b40941a6e809376a$export$b2c43d7d050b2e63)(props.children);
    const children = validChildren.map((child, index)=>(0, $lDSNw.createElement)($7c2fd4f406a903b2$var$TabPanelProvider, {
            key: index,
            value: {
                isSelected: index === selectedIndex,
                id: $7c2fd4f406a903b2$var$makeTabPanelId(id, index),
                tabId: $7c2fd4f406a903b2$var$makeTabId(id, index),
                selectedIndex: selectedIndex
            }
        }, child));
    return {
        ...props,
        children: children
    };
}
function $7c2fd4f406a903b2$export$fae0121b5afe572d(props) {
    const { children: children, ...htmlProps } = props;
    const { isLazy: isLazy, lazyBehavior: lazyBehavior } = $7c2fd4f406a903b2$export$5c3d36c3adf0ba92();
    const { isSelected: isSelected, id: id, tabId: tabId } = $7c2fd4f406a903b2$var$useTabPanelContext();
    const hasBeenSelected = (0, $lDSNw.useRef)(false);
    if (isSelected) hasBeenSelected.current = true;
    const shouldRenderChildren = (0, $62bbd782f684d120$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenSelected.current,
        isSelected: isSelected,
        enabled: isLazy,
        mode: lazyBehavior
    });
    return {
        // Puts the tabpanel in the page `Tab` sequence.
        tabIndex: 0,
        ...htmlProps,
        children: shouldRenderChildren ? children : null,
        role: "tabpanel",
        "aria-labelledby": tabId,
        hidden: !isSelected,
        id: id
    };
}
function $7c2fd4f406a903b2$export$99e5024a51e009d8() {
    const context = $7c2fd4f406a903b2$export$5c3d36c3adf0ba92();
    const descendants = $7c2fd4f406a903b2$export$41df96b51c5f5358();
    const { selectedIndex: selectedIndex, orientation: orientation } = context;
    const isHorizontal = orientation === "horizontal";
    const isVertical = orientation === "vertical";
    const [rect, setRect] = (0, $lDSNw.useState)(()=>{
        if (isHorizontal) return {
            left: 0,
            width: 0
        };
        if (isVertical) return {
            top: 0,
            height: 0
        };
        return void 0;
    });
    const [hasMeasured, setHasMeasured] = (0, $lDSNw.useState)(false);
    (0, $e18ad61408bb6e80$export$deebe11a338de063)(()=>{
        if (selectedIndex == null) return;
        const tab = descendants.item(selectedIndex);
        if (tab == null) return;
        if (isHorizontal) setRect({
            left: tab.node.offsetLeft,
            width: tab.node.offsetWidth
        });
        if (isVertical) setRect({
            top: tab.node.offsetTop,
            height: tab.node.offsetHeight
        });
        const id = requestAnimationFrame(()=>{
            setHasMeasured(true);
        });
        return ()=>{
            if (id) cancelAnimationFrame(id);
        };
    }, [
        selectedIndex,
        isHorizontal,
        isVertical,
        descendants
    ]);
    return {
        position: "absolute",
        transitionProperty: "left, right, top, bottom, height, width",
        transitionDuration: hasMeasured ? "200ms" : "0ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        ...rect
    };
}
function $7c2fd4f406a903b2$var$makeTabId(id, index) {
    return `${id}--tab-${index}`;
}
function $7c2fd4f406a903b2$var$makeTabPanelId(id, index) {
    return `${id}--tabpanel-${index}`;
}






var $lDSNw = parcelRequire("lDSNw");

"use client";
var [$6a502e7cb1933381$var$TabsStylesProvider, $6a502e7cb1933381$export$ab005bc413ad22f0] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `TabsStylesContext`,
    errorMessage: `useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tabs />" `
});
var $6a502e7cb1933381$export$b2539bed5023c21c = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Tabs2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Tabs", props);
    const { children: children, className: className, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const { htmlProps: htmlProps, descendants: descendants, ...ctx } = (0, $7c2fd4f406a903b2$export$d2589202ac9c89c3)(rest);
    const context = (0, $lDSNw.useMemo)(()=>ctx, [
        ctx
    ]);
    const { isFitted: _, ...rootProps } = htmlProps;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $7c2fd4f406a903b2$export$29ffb0a76b0529f5), {
        value: descendants,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $7c2fd4f406a903b2$export$aea4e5437b3b752e), {
            value: context,
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($6a502e7cb1933381$var$TabsStylesProvider, {
                value: styles,
                children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
                    className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-tabs", className),
                    ref: ref,
                    ...rootProps,
                    __css: styles.root,
                    children: children
                })
            })
        })
    });
});
$6a502e7cb1933381$export$b2539bed5023c21c.displayName = "Tabs";






"use client";
var $60ff4a7bee9d5c20$export$3e41faf802a29e71 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Tab2(props, ref) {
    const styles = (0, $6a502e7cb1933381$export$ab005bc413ad22f0)();
    const tabProps = (0, $7c2fd4f406a903b2$export$fdf4756d5b8ef90a)({
        ...props,
        ref: ref
    });
    const tabStyles = {
        outline: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...styles.tab
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).button, {
        ...tabProps,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-tabs__tab", props.className),
        __css: tabStyles
    });
});
$60ff4a7bee9d5c20$export$3e41faf802a29e71.displayName = "Tab";






"use client";
var $5195078522b2fc7e$export$e51a686c67fdaa2d = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function TabList2(props, ref) {
    const tablistProps = (0, $7c2fd4f406a903b2$export$773e389e644c5874)({
        ...props,
        ref: ref
    });
    const styles = (0, $6a502e7cb1933381$export$ab005bc413ad22f0)();
    const tablistStyles = {
        display: "flex",
        ...styles.tablist
    };
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...tablistProps,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-tabs__tablist", props.className),
        __css: tablistStyles
    });
});
$5195078522b2fc7e$export$e51a686c67fdaa2d.displayName = "TabList";






"use client";
var $1523771cacfd3c91$export$3d96ec278d3efce4 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function TabPanel2(props, ref) {
    const panelProps = (0, $7c2fd4f406a903b2$export$fae0121b5afe572d)({
        ...props,
        ref: ref
    });
    const styles = (0, $6a502e7cb1933381$export$ab005bc413ad22f0)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        outline: "0",
        ...panelProps,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-tabs__tab-panel", props.className),
        __css: styles.tabpanel
    });
});
$1523771cacfd3c91$export$3d96ec278d3efce4.displayName = "TabPanel";






"use client";
var $9be6ee0d259ba9e2$export$5dae8d435677f210 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function TabPanels2(props, ref) {
    const panelsProps = (0, $7c2fd4f406a903b2$export$a7a84e09564ff6eb)(props);
    const styles = (0, $6a502e7cb1933381$export$ab005bc413ad22f0)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ...panelsProps,
        width: "100%",
        ref: ref,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-tabs__tab-panels", props.className),
        __css: styles.tabpanels
    });
});
$9be6ee0d259ba9e2$export$5dae8d435677f210.displayName = "TabPanels";




/**
 * @fileOverview Line Chart
 */ 




var $ad7331bbe400fed9$export$54d0e8420ac838ac = (0, $bc90a147d6e1cdb7$export$77871aede60e6838)({
    chartName: "LineChart",
    GraphicalChild: (0, $cd596fa7fc5c5a32$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $15dd4d13ef92156e$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $43d5f89303df56d7$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $28de3275627d2ded$export$ece7de1383db5ac)
});



var $lDSNw = parcelRequire("lDSNw");





var $lDSNw = parcelRequire("lDSNw");

function $ed548c58496df3ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ed548c58496df3ce$var$IFRAME_SCALE_FACTOR = 0.8;
const $ed548c58496df3ce$export$378d088832c92c75 = ({ srcDoc: srcDoc, mainFrameRef: mainFrameRef, onIframeLoad: onIframeLoad, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const { isOpen: isOpen, onToggle: onToggle, onClose: onClose } = (0, $22a40b748afc455e$export$6e3e27031a30522f)();
    const canStillTriggerPopoverRef = (0, $lDSNw.useRef)(true);
    const preventUserScroll = false;
    const showWrapper = true;
    const handleMouseEnter = (e)=>{
        canStillTriggerPopoverRef.current = false;
        onClose();
        onMouseEnter(e);
    };
    const launchPopover = ()=>{
        if (canStillTriggerPopoverRef.current) onToggle();
    };
    (0, $lDSNw.useEffect)(()=>{
        setTimeout(()=>{
            launchPopover();
        }, 13000);
    }, []);
    // handle scaling of the device for layout responsivness
    const [scale, setScale] = (0, $lDSNw.useState)(0.8);
    const iframeWrapperRef = (0, $lDSNw.useRef)(null);
    const handleResize = (0, $lDSNw.useCallback)(()=>{
        const iframe = iframeWrapperRef.current;
        if (iframe && iframe.parentElement) {
            const parentHeight = iframe.parentElement.clientHeight;
            setScale(parentHeight / 745 * $ed548c58496df3ce$var$IFRAME_SCALE_FACTOR);
        }
    }, []);
    const handleOnIframeLoad = (e)=>{
        handleResize();
        onIframeLoad(e);
    };
    const debouncedHandleResize = (0, (/*@__PURE__*/$parcel$interopDefault($1007e42b3c091255$exports)))(handleResize, 100); // Adjust debounce time as needed
    (0, $lDSNw.useEffect)(()=>{
        window.addEventListener("resize", debouncedHandleResize);
        return ()=>{
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ed548c58496df3ce$var$IframeWrapper, {
        ref: iframeWrapperRef,
        className: "iframe-wrapper",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $477e0f2775c64f2e$export$5b6b19405a83ff9d), {
            autoFocus: false,
            isOpen: isOpen,
            onClose: onClose,
            placement: "right",
            closeOnBlur: true,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b8cdd4baf94d547a$export$7dacb05d26466c3), {
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ed548c58496df3ce$var$DeviceFrame, {
                        transform: `scale(${scale})`,
                        borderRadius: "36px",
                        _hover: {
                            outline: "1px solid #00BA77"
                        },
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                            as: "iframe",
                            title: "iframe",
                            ...$ed548c58496df3ce$var$mobileIframeStyle,
                            pointerEvents: preventUserScroll ? "none" : "auto",
                            "data-xyz": "phone-wrapper",
                            srcDoc: srcDoc,
                            ref: mainFrameRef,
                            onMouseEnter: handleMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onLoad: (e)=>handleOnIframeLoad(e)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($ed548c58496df3ce$var$ScrollToDemoPopover, {})
            ]
        })
    });
};
const $ed548c58496df3ce$var$IframeWrapper = /*#__PURE__*/ (0, $39930abee900df6c$export$2e2bcd8739ae039)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
    target: "e1pdd5a70"
})({
    name: "85tip",
    styles: "display:flex;flex-direction:column;justify-content:flex-start;width:100%"
});
const $ed548c58496df3ce$var$mobileIframeStyle = {
    w: "100%",
    h: "auto",
    margin: "76px 26px 20px 24px",
    border: "none",
    borderRadius: "0px 0px 36px 36px",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.25) inset"
};
const $ed548c58496df3ce$var$DeviceFrame = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        background: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($0a7f5b3a0089ee25$exports)))})`,
        width: "375px",
        height: "745px",
        transformOrigin: "top",
        alignItems: "stretch",
        transition: "transform 0.15s ease",
        justifyContent: "center",
        backgroundColor: "white",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        border: "none",
        borderRadius: "10px 10px 60px 60px",
        ...rest,
        children: children
    });
};
const $ed548c58496df3ce$var$ScrollToDemoPopover = ()=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $de04819b4e852901$export$d7e1f420b25549ff), {
        w: "130px",
        right: "200%",
        p: "0",
        bg: "#666666",
        borderColor: "#666666",
        borderRadius: 12,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a6464059de3a62e$export$472ec417bca1d382), {
            p: "0",
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
                borderRadius: 16,
                src: "https://studio-tool-global.production.playground.xyz/static-assets/765a9ff60d996be47d2f64738bf0356313ffe8ad/previewer/img/scroll-down.png"
            })
        })
    });
};







var $lDSNw = parcelRequire("lDSNw");
var $e042f9da040d1e0c$exports = {};
// Velocity module contains shared functions for processing scroll
// data and calculating velocity, distance and pressure metrics.
// These functions are shared across the cat-functions and cat-viewer as
// we process the data in cloud functions for storing in the db, but
// also need to process the data "live" in the viewer to display the
// interactive demo with each build.
function $e042f9da040d1e0c$var$processScrollDataWithTime(data) {
    // Array to hold the formatted {x, y} data points
    let chartData = [];
    let directionChangesCount = 0;
    let direction;
    data.forEach((point, index)=>{
        // this is just a hack after changing data structure mid-hacking
        const timeKey = point.hasOwnProperty("t") ? "t" : "time";
        const directionKey = point.hasOwnProperty("d") ? "d" : "direction";
        if (index === 0) {
            // Start the chart at {x: 0, y: 0}
            direction = point[directionKey];
            chartData.push({
                x: 0,
                y: 0,
                direction: direction
            });
        } else {
            if (point[directionKey] !== direction) {
                directionChangesCount++;
                direction = point[directionKey];
            }
            // Calculate the difference in 'y' and time elapsed since the first point
            const y = point.y - data[index - 1].y;
            const x = point[timeKey] - data[index - 1][timeKey];
            // Add the new data point
            chartData.push({
                y: Math.abs(y),
                x: Math.abs(x),
                direction: direction
            });
        }
    });
    return chartData;
}
function $e042f9da040d1e0c$var$getSingleSessionTotalScrollDistance(session) {
    return session.reduce((acc, curr)=>acc + curr.y, 0);
}
function $e042f9da040d1e0c$var$getAverageScrollDistance(scrolls) {
    return scrolls.reduce((total, session)=>{
        return total + $e042f9da040d1e0c$var$getSingleSessionTotalScrollDistance(session);
    }, 0) / scrolls.length;
}
function $e042f9da040d1e0c$var$calculateVelocity(deltaY, deltaX) {
    // Calculate velocity (pixels/ms) as deltaY / deltaX
    if (deltaX === 0) // Prevent division by zero
    return 0;
    return deltaY / deltaX;
}
// This function processes a single session of data and calculates the velocity for each point.
function $e042f9da040d1e0c$var$processSingleSessionForVelocity(session) {
    if (!session.length) return []; // Handle empty arrays safely.
    // Set the velocity of the first point to 0 and use it as is.
    const processed = [
        {
            ...session[0],
            velocity: 0
        }
    ];
    // Process remaining points in the session
    for(let i = 1; i < session.length; i++){
        const { x: x, y: y } = session[i];
        const velocity = $e042f9da040d1e0c$var$calculateVelocity(y, x);
        processed.push({
            x: x,
            y: y,
            velocity: velocity
        });
    }
    return processed;
}
// This function maps each subArray through the processing function.
function $e042f9da040d1e0c$var$addVelocity(data) {
    const result = data.map($e042f9da040d1e0c$var$processSingleSessionForVelocity);
    return result;
}
function $e042f9da040d1e0c$var$combineVelocitySessions(data) {
    // Determine the maximum length of any session's data
    const maxLength = data.reduce((max, session)=>Math.max(max, session.length), 0);
    // Initialize an array to store summed distances and times, and count of items for averaging
    const sums = Array.from({
        length: maxLength
    }, ()=>({
            totalTime: 0,
            totalDistance: 0,
            totalVelocity: 0,
            count: 0
        }));
    // Sum up all distances and times for each index
    data.forEach((session)=>{
        session.forEach((item, index)=>{
            if (!item) {
                console.log("item is null", item);
                return;
            }
            sums[index].totalDistance += item.y;
            sums[index].totalTime += item.x;
            sums[index].totalVelocity += item.velocity;
            sums[index].count++;
        });
    });
    // Calculate averages for each index
    const averages = sums.map((item, _, array)=>{
        if (!item.count) return {
            averageDistance: 0,
            averageTime: 0,
            averageVelocity: 0
        };
        // NOTE: item.count may not be good to stop values in the "tail" of the data looking huge.
        return {
            averageDistance: item.totalDistance / item.count,
            averageTime: item.totalTime / item.count,
            averageVelocity: item.totalVelocity / item.count
        };
    });
    // After calculating averages, accumulate totalTime
    let accumulatedTime = 0;
    averages.forEach((item)=>{
        accumulatedTime += item.averageTime; // Accumulate totalTime
        item.accumulatedTime = accumulatedTime; // Assign accumulatedTime to each item
    });
    // Calculate rolling average of averageVelocity using up to the last 5 points
    for(let i = 0; i < averages.length; i++){
        let sum = 0;
        let count = 0;
        // Determine the start index for the loop, ensuring it's within bounds
        let startIndex = Math.max(0, i - 2); // including the current index, this will sum the last 3 points
        // Loop from the start index to i, inclusive
        for(let j = startIndex; j <= i; j++){
            sum += averages[j].averageVelocity;
            count++;
        }
        // Calculate and assign rolling average
        averages[i].rollingAverageVelocity = sum / count;
    }
    return averages;
}
function $e042f9da040d1e0c$var$calculateRollingPressure(averages) {
    if (averages.length === 0) return [];
    const maxPressure = 2.5; // Maximum pressure value - this might need to be 2... to match the frontend
    const sensitivity = 1; // Sensitivity of pressure to changes in velocity
    const decayRate = 0.5; // Natural decay rate of pressure per iteration
    let pressures = [];
    averages.forEach((item, index)=>{
        let increment;
        if (index === 0) increment = item.rollingAverageVelocity * sensitivity;
        else {
            const decayFactor = Math.exp(-pressures[index - 1].pressure / maxPressure * sensitivity);
            increment = decayFactor * item.rollingAverageVelocity * sensitivity;
            // Apply a decay to the current pressure
            pressures[index - 1].pressure *= 1 - decayRate;
        }
        // Calculate new pressure, ensure it doesn't exceed maxPressure or fall below zero
        const newPressure = pressures.length > 0 ? Math.max(0, pressures[index - 1].pressure + increment) : increment;
        const pressure = Math.min(newPressure, maxPressure);
        pressures.push({
            accumulatedTime: item.accumulatedTime,
            pressure: pressure
        });
    });
    // Apply a final entry to return things to 0
    pressures.push({
        accumulatedTime: pressures[pressures.length - 1].accumulatedTime + 200,
        pressure: 0
    });
    return pressures;
}
function $e042f9da040d1e0c$var$getAveragePressure(pressureData) {
    const aggregatedPressure = pressureData.reduce((acc, curr, idx, arr)=>{
        // Skip the first and last entries as they are defaulted
        // to 0 pressure and should not be included in the average
        if (idx === 0 || idx === arr.length - 1) return acc;
        acc.totalPressure += curr.pressure;
        acc.count++;
        return acc;
    }, {
        totalPressure: 0,
        count: 0
    });
    const averagePressure = aggregatedPressure.totalPressure / aggregatedPressure.count;
    return averagePressure;
}
/**
 * A helper to bundle the above functions into a single call
 * @param {*} scrolls
 * @returns
 */ function $e042f9da040d1e0c$var$getSingleSessionPressures(scrolls) {
    const groupedByDirection = $e042f9da040d1e0c$var$aggregateByDirection(scrolls);
    if (groupedByDirection.length <= 1) return [];
    const withVelocity = $e042f9da040d1e0c$var$processSingleSessionForVelocity(groupedByDirection);
    const averageVelocityData = $e042f9da040d1e0c$var$combineVelocitySessions([
        withVelocity
    ]);
    const pressures = $e042f9da040d1e0c$var$calculateRollingPressure(averageVelocityData);
    return pressures;
}
function $e042f9da040d1e0c$var$aggregateByDirection(session) {
    return session.reduce((acc, curr)=>{
        // if the current direction is the same as the previous direction, we need to
        // aggregate the x and y values into the previous object
        if (acc.length > 0 && acc[acc.length - 1].direction === curr.direction) {
            acc[acc.length - 1].x += curr.x;
            acc[acc.length - 1].y += curr.y;
        } else acc.push({
            ...curr
        });
        return acc;
    }, []);
}
function $e042f9da040d1e0c$var$prepareScrollSquiggleChartData(data) {
    if (data.length === 0) return [];
    // Preprocessing step to aggregate data by direction
    const aggregatedData = data.map((session)=>{
        // each session has scrolls that may have sequences in the same direction, we
        // need to aggregate these sequences into one value/object in the array to
        // represent each direction movement
        return $e042f9da040d1e0c$var$aggregateByDirection(session);
    });
    // Determine the maximum length of all sessions
    const maxLength = aggregatedData.reduce((max, session)=>Math.max(max, session.length), 0);
    // Array to store sum of x and y, and count for averaging
    const values = Array.from({
        length: maxLength
    }, ()=>({
            count: 0,
            diffX: 0,
            diffY: 0
        }));
    // Accumulate values for each index available in each session
    aggregatedData.forEach((session)=>{
        session.forEach((point, index)=>{
            const { x: x = 0, y: y = 0 } = point;
            values[index].diffX += x;
            values[index].diffY += y;
            values[index].count++;
        });
    });
    const result = values.reduce((acc, { diffX: diffX, diffY: diffY, count: count }, i)=>{
        // Calculate the current x increment and y position
        // NOTE: Adjusting to use the y value as the increment as we want the live squiggle to
        // be passing points on the y axis that represent the distance
        const xIncrement = 50; // Math.round(Math.abs(diffY / count)); //  Math.round(diffX / count);
        const yPosition = Math.round((i % 2 === 0 ? -1 : 1) * diffY / count);
        // Start of the current beat is the accumulated x from the previous beat
        const startX = Math.round(acc.accumulatedX);
        // Calculate the end x position of the current beat
        const endX = Math.round(startX + xIncrement);
        // Create the beat with start, peak, and end points
        const beat = [
            // { x: startX, y: 0 }, // Start of the beat
            {
                x: startX + xIncrement / 2,
                y: yPosition
            },
            {
                x: endX,
                y: 0
            }
        ];
        // Update the accumulated x for the next beat
        acc.accumulatedX = endX;
        // Append the current beat to the result
        acc.result = [
            ...acc.result,
            ...beat
        ];
        return acc;
    }, {
        accumulatedX: 0,
        result: [
            {
                x: 0,
                y: 0
            }
        ]
    } // start everything at 0,0
    ).result;
    return result;
}
$e042f9da040d1e0c$exports = {
    getAverageScrollDistance: $e042f9da040d1e0c$var$getAverageScrollDistance,
    processScrollDataWithTime: $e042f9da040d1e0c$var$processScrollDataWithTime,
    getSingleSessionTotalScrollDistance: $e042f9da040d1e0c$var$getSingleSessionTotalScrollDistance,
    addVelocity: $e042f9da040d1e0c$var$addVelocity,
    processSingleSessionForVelocity: $e042f9da040d1e0c$var$processSingleSessionForVelocity,
    combineVelocitySessions: $e042f9da040d1e0c$var$combineVelocitySessions,
    calculateRollingPressure: $e042f9da040d1e0c$var$calculateRollingPressure,
    getAveragePressure: $e042f9da040d1e0c$var$getAveragePressure,
    getSingleSessionPressures: $e042f9da040d1e0c$var$getSingleSessionPressures,
    prepareScrollSquiggleChartData: $e042f9da040d1e0c$var$prepareScrollSquiggleChartData,
    aggregateByDirection: $e042f9da040d1e0c$var$aggregateByDirection
};


var $9b62cfaad7f54fdc$exports = {};
function $9b62cfaad7f54fdc$var$aggregateScrollSquiggle({ avgScrollSquiggle: avgScrollSquiggle, incomingScrollSquiggle: incomingScrollSquiggle, totalSessions: totalSessions }) {
    if (!avgScrollSquiggle || !avgScrollSquiggle.length) return incomingScrollSquiggle;
    const maxLength = Math.max(avgScrollSquiggle.length, incomingScrollSquiggle.length);
    // Initialize the new scroll squiggle array with appropriate length and default values
    const newScrollSquiggle = new Array(maxLength).fill(null).map((_, index)=>{
        const avgPoint = avgScrollSquiggle[index];
        const newPoint = incomingScrollSquiggle[index];
        // De-average the existing data if it exists
        const baseY = avgPoint ? avgPoint.y * totalSessions : 0;
        // Add the new session data if it exists
        const incomingY = newPoint ? newPoint.y : 0;
        // Re-average the combined data
        const newY = (baseY + incomingY) / (totalSessions + 1);
        // setting a standard x value for the squiggle
        // doing this as aggregating the x values is very messy
        // we can have sessions come in that wildly throw off the x values
        return {
            x: index * 50,
            y: Math.round(newY)
        };
    });
    return newScrollSquiggle;
}
function $9b62cfaad7f54fdc$var$aggregatePressureSequence({ avgPressureSequence: avgPressureSequence, incomingPressureSequence: incomingPressureSequence, totalSessions: totalSessions }) {
    const maxLength = Math.max(avgPressureSequence.length, incomingPressureSequence.length);
    // Initialize the new pressure sequence array with appropriate length and default values
    let rollingAccumulatedTime = 0;
    const newPressureSequence = new Array(maxLength).fill(null).map((_, index)=>{
        const avgPoint = avgPressureSequence[index];
        const newPoint = incomingPressureSequence[index];
        // De-average the existing data if it exists
        const baseY = avgPoint ? avgPoint.pressure * totalSessions : 0;
        const baseTime = avgPoint ? avgPoint.accumulatedTime : 0;
        // Add the new session data if it exists
        const incomingY = newPoint ? newPoint.pressure : 0;
        const incomingTime = newPoint ? newPoint.accumulatedTime : 0;
        // Re-average the combined data
        const newY = (baseY + incomingY) / (totalSessions + 1);
        const newTime = (baseTime + incomingTime) / (totalSessions + 1);
        // accumulatedTime should be rolling accumulation of all previous times
        rollingAccumulatedTime += newTime;
        return {
            accumulatedTime: rollingAccumulatedTime,
            pressure: newY
        };
    });
    return newPressureSequence;
}
$9b62cfaad7f54fdc$exports = {
    aggregateScrollSquiggle: $9b62cfaad7f54fdc$var$aggregateScrollSquiggle,
    aggregatePressureSequence: $9b62cfaad7f54fdc$var$aggregatePressureSequence
};


const $379be3281ad335a2$var$useScrollData = (currentY, RESET_INTERVAL = 500, minimumDistance = 10)=>{
    const [metrics, setMetrics] = (0, $lDSNw.useState)({
        scrollDistance: 0,
        sessionPressure: 0,
        pressureArray: [],
        liveScrollSquiggle: []
    });
    const [catPayload, setCatPayload] = (0, $lDSNw.useState)([]);
    const [direction, setDirection] = (0, $lDSNw.useState)(1);
    const [y, setY] = (0, $lDSNw.useState)(0);
    const [directionChangeY, setDirectionChangeY] = (0, $lDSNw.useState)(0);
    const [directionChangesCount, setDirectionChangesCount] = (0, $lDSNw.useState)(0);
    const resetData = ()=>{
        console.log("Resetting data...");
        setDirectionChangesCount(0);
        setCatPayload([]); // Reset the payload array after saving
    };
    const resetTimer = (0, $lDSNw.useRef)(null);
    const debounceResetData = ()=>{
        if (resetTimer.current) clearTimeout(resetTimer.current);
        resetTimer.current = setTimeout(resetData, RESET_INTERVAL);
    };
    const onScroll = (scrollY)=>{
        const now = Date.now();
        const dify = scrollY - y;
        const dir = Math.sign(dify);
        const distance = Math.abs(scrollY - directionChangeY);
        if (dir !== direction) setDirectionChangesCount((prev)=>prev + 1);
        setY(scrollY);
        if (distance > minimumDistance) {
            setDirection(dir);
            setDirectionChangeY(y);
            setCatPayload((prev)=>[
                    ...prev,
                    {
                        d: dir,
                        y: Math.round(directionChangeY),
                        t: now
                    }
                ]);
        }
        if (catPayload.length >= 6 && directionChangesCount >= 1) debounceResetData();
    // resetInactivityTimer();
    };
    (0, $lDSNw.useEffect)(()=>{
        if (currentY !== undefined) onScroll(currentY);
    }, [
        currentY
    ]);
    (0, $lDSNw.useEffect)(()=>{
        const scrolls = (0, $e042f9da040d1e0c$exports.processScrollDataWithTime)(catPayload);
        if (scrolls.length === 0) {
            setMetrics({
                scrollDistance: 0,
                sessionPressure: 0,
                pressureArray: [],
                liveScrollSquiggle: []
            });
            return;
        }
        const scrollSquiggle = (0, $e042f9da040d1e0c$exports.prepareScrollSquiggleChartData)([
            scrolls
        ]);
        const liveScrollSquiggle = (0, $9b62cfaad7f54fdc$exports.aggregateScrollSquiggle)({
            avgScrollSquiggle: scrollSquiggle,
            incomingScrollSquiggle: scrollSquiggle,
            totalSessions: 1
        });
        const distance = (0, $e042f9da040d1e0c$exports.getSingleSessionTotalScrollDistance)(scrolls);
        const pressures = (0, $e042f9da040d1e0c$exports.getSingleSessionPressures)(scrolls);
        setMetrics({
            scrollDistance: distance,
            sessionPressure: pressures[pressures.length - 2]?.pressure || 0,
            pressureArray: pressures,
            liveScrollSquiggle: liveScrollSquiggle
        });
    }, [
        catPayload
    ]);
    return metrics;
};
var $379be3281ad335a2$export$2e2bcd8739ae039 = $379be3281ad335a2$var$useScrollData;





var $lDSNw = parcelRequire("lDSNw");

var $c7e13dff727887fc$exports = {};
var $d4ff56daf440a7b3$exports = {};
var $c2fbe463c938733d$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $c2fbe463c938733d$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($c2fbe463c938733d$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $c2fbe463c938733d$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $c2fbe463c938733d$exports = function whatwgRNG() {
        $c2fbe463c938733d$var$getRandomValues($c2fbe463c938733d$var$rnds8);
        return $c2fbe463c938733d$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $c2fbe463c938733d$var$rnds = new Array(16);
    $c2fbe463c938733d$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $c2fbe463c938733d$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $c2fbe463c938733d$var$rnds;
    };
}


var $1be7f67418e575ca$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1be7f67418e575ca$var$byteToHex = [];
for(var $1be7f67418e575ca$var$i = 0; $1be7f67418e575ca$var$i < 256; ++$1be7f67418e575ca$var$i)$1be7f67418e575ca$var$byteToHex[$1be7f67418e575ca$var$i] = ($1be7f67418e575ca$var$i + 0x100).toString(16).substr(1);
function $1be7f67418e575ca$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $1be7f67418e575ca$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$1be7f67418e575ca$exports = $1be7f67418e575ca$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $d4ff56daf440a7b3$var$_nodeId;
var $d4ff56daf440a7b3$var$_clockseq;
// Previous uuid creation time
var $d4ff56daf440a7b3$var$_lastMSecs = 0;
var $d4ff56daf440a7b3$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $d4ff56daf440a7b3$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $d4ff56daf440a7b3$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $d4ff56daf440a7b3$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $c2fbe463c938733d$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $d4ff56daf440a7b3$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $d4ff56daf440a7b3$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $d4ff56daf440a7b3$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $d4ff56daf440a7b3$var$_lastMSecs + (nsecs - $d4ff56daf440a7b3$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $d4ff56daf440a7b3$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $d4ff56daf440a7b3$var$_lastMSecs = msecs;
    $d4ff56daf440a7b3$var$_lastNSecs = nsecs;
    $d4ff56daf440a7b3$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $1be7f67418e575ca$exports(b);
}
$d4ff56daf440a7b3$exports = $d4ff56daf440a7b3$var$v1;


var $770b817b9ba0c140$exports = {};


function $770b817b9ba0c140$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $c2fbe463c938733d$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $1be7f67418e575ca$exports(rnds);
}
$770b817b9ba0c140$exports = $770b817b9ba0c140$var$v4;


var $c7e13dff727887fc$var$uuid = $770b817b9ba0c140$exports;
$c7e13dff727887fc$var$uuid.v1 = $d4ff56daf440a7b3$exports;
$c7e13dff727887fc$var$uuid.v4 = $770b817b9ba0c140$exports;
$c7e13dff727887fc$exports = $c7e13dff727887fc$var$uuid;


function $d8719f0214228429$export$5931e35698b46017({ value: value, minValue: minValue, maxValue: maxValue, startColor: startColor, endColor: endColor }) {
    // Ensure the value is within bounds
    const clampedValue = Math.min(Math.max(value, minValue), maxValue);
    // Calculate the ratio of the value within the range
    const ratio = (clampedValue - minValue) / (maxValue - minValue);
    // Interpolate the color components
    const r = Math.round(startColor.r + (endColor.r - startColor.r) * ratio);
    const g = Math.round(startColor.g + (endColor.g - startColor.g) * ratio);
    const b = Math.round(startColor.b + (endColor.b - startColor.b) * ratio);
    // Return the interpolated color in hex format
    return `rgb(${r}, ${g}, ${b})`;
}
function $d8719f0214228429$export$fe43042dbe18fdfb(arr) {
    return arr.reduce((acc, curr)=>acc + curr, 0) / arr.length;
}


const $e110900b167a1ef9$var$Gauge = ({ pressure: pressure, averagePressure: averagePressure, avgScrollDistance: avgScrollDistance, scrollDistance: scrollDistance })=>{
    const [lines, setLines] = (0, $lDSNw.useState)([]);
    const [activeLineId, setActiveLineId] = (0, $lDSNw.useState)(null);
    const maxY = 400;
    const margin = 20;
    const tickInterval = 100;
    const maxPressure = 2;
    const orange = {
        r: 255,
        g: 165,
        b: 0
    };
    const pink = {
        r: 255,
        g: 105,
        b: 180
    };
    const calculateYPosition = (pressure)=>{
        const effectiveMaxY = maxY - margin * 2;
        let yPos = margin + (1 - pressure / maxPressure) * effectiveMaxY;
        // Clamp yPos to ensure it's within the drawable area
        yPos = Math.max(margin, Math.min(yPos, maxY - margin));
        return yPos;
    };
    (0, $lDSNw.useEffect)(()=>{
        if (pressure > 0) {
            const now = Date.now();
            if (!activeLineId || now - lines.find((line)=>line.id === activeLineId)?.lastUpdated > 500) {
                const newLine = {
                    id: (0, $c7e13dff727887fc$exports.v4)(),
                    pressure: pressure,
                    lastUpdated: now
                };
                setLines((lines)=>[
                        ...lines,
                        newLine
                    ]);
                setActiveLineId(newLine.id);
            } else setLines((lines)=>lines.map((line)=>line.id === activeLineId ? {
                        ...line,
                        pressure: pressure,
                        lastUpdated: now
                    } : line));
        }
    }, [
        pressure
    ]);
    // Interval to check inactivity
    (0, $lDSNw.useEffect)(()=>{
        const interval = setInterval(()=>{
            const now = Date.now();
            if (activeLineId) {
                const activeLine = lines.find((line)=>line.id === activeLineId);
                if (activeLine && now - activeLine.lastUpdated > 500) {
                    setLines((lines)=>lines.map((line)=>{
                            if (line.id === activeLineId) return {
                                ...line,
                                pressure: 0
                            };
                            return line;
                        }));
                    setActiveLineId(null); // Deactivate the line after 500ms of inactivity
                }
            }
        }, 100); // Checking every 100ms
        return ()=>clearInterval(interval);
    }, [
        activeLineId,
        lines
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("svg", {
            width: "300",
            height: "500",
            viewBox: "-20 -20 340 640",
            style: {
                marginLeft: "-15px",
                zIndex: 1
            },
            children: [
                [
                    ...Array(Math.floor(maxY / tickInterval) + 1)
                ].map((_, i)=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("g", {
                        transform: `translate(0, ${maxY - i * tickInterval})`,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("line", {
                                x1: "30",
                                x2: "500",
                                y1: "0",
                                y2: "0",
                                stroke: "lightgray",
                                strokeWidth: "1"
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("text", {
                                x: "0",
                                y: "5",
                                fill: "grey",
                                fontSize: "16",
                                textAnchor: "end",
                                children: (i * tickInterval / maxY * maxPressure).toFixed(1)
                            })
                        ]
                    }, i)),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).text, {
                    x: "43",
                    y: calculateYPosition(averagePressure) + 5,
                    fill: "#4EC1E0",
                    fontSize: "18",
                    textAnchor: "end",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.5,
                        delay: 1
                    },
                    children: "creative"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).line, {
                    x1: "60",
                    x2: "500",
                    strokeWidth: "5",
                    strokeLinecap: "round",
                    stroke: "#4EC1E0",
                    y1: calculateYPosition(0),
                    y2: calculateYPosition(0),
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        y1: calculateYPosition(averagePressure),
                        y2: calculateYPosition(averagePressure),
                        opacity: 1
                    },
                    transition: {
                        type: "spring",
                        stiffness: 80,
                        damping: 8,
                        duration: 0.5,
                        delay: 0.5
                    }
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).text, {
                    x: "45",
                    y: calculateYPosition(0.7) + 5,
                    fill: "grey",
                    fontSize: "18",
                    textAnchor: "end",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    transition: {
                        duration: 0.5,
                        delay: 2
                    },
                    children: "baseline"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).line, {
                    "stroke-dasharray": "4",
                    x1: "60",
                    x2: "400",
                    strokeLinecap: "round",
                    strokeWidth: "5",
                    stroke: "lightgray",
                    initial: {
                        opacity: 0
                    },
                    y1: calculateYPosition(0),
                    y2: calculateYPosition(0),
                    animate: {
                        y1: calculateYPosition(0.7),
                        y2: calculateYPosition(0.7),
                        opacity: 1
                    },
                    transition: {
                        type: "spring",
                        stiffness: 80,
                        damping: 8,
                        duration: 0.5,
                        delay: 1.5
                    }
                }),
                pressure > 1.9 && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).text, {
                        x: "100",
                        y: "60",
                        width: "260",
                        height: "100",
                        fill: "red",
                        fontWeight: 600,
                        fontFamily: "'Courier New', monospace",
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: [
                                0,
                                0.3,
                                0.3,
                                0
                            ] // Sequence of opacity values to create the flashing effect
                        },
                        fontSize: "40px",
                        transition: {
                            duration: 0.1,
                            // Adjust duration to control the speed of the flash
                            times: [
                                0,
                                0.25,
                                0.75,
                                1
                            ],
                            // Controls the timing of the opacity changes within each cycle
                            repeat: Infinity,
                            repeatType: "loop"
                        },
                        children: "MAXING!!!"
                    })
                }),
                lines.map((line)=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0a9a7dc0535ece35$export$e25e478948902b8b).line, {
                        x1: "50",
                        x2: "500",
                        y1: calculateYPosition(0),
                        y2: calculateYPosition(0),
                        stroke: (0, $d8719f0214228429$export$5931e35698b46017)({
                            value: line.pressure,
                            minValue: 0,
                            maxValue: maxPressure,
                            startColor: orange,
                            endColor: pink
                        }),
                        strokeWidth: "5",
                        animate: {
                            y1: calculateYPosition(line.pressure),
                            y2: calculateYPosition(line.pressure),
                            opacity: line.pressure > 0 ? 1 : 0
                        },
                        transition: {
                            type: "spring",
                            stiffness: 70,
                            damping: 6,
                            duration: 0.1
                        }
                    }, line.id))
            ]
        })
    });
};
var $e110900b167a1ef9$export$2e2bcd8739ae039 = $e110900b167a1ef9$var$Gauge;








"use client";
var [$2759ae9e0990fd66$var$StatStylesProvider, $2759ae9e0990fd66$export$f7ff375b7b7b2dfa] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `StatStylesContext`,
    errorMessage: `useStatStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Stat />" `
});
var $2759ae9e0990fd66$export$cbbc350c1dfc80cb = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Stat2(props, ref) {
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Stat", props);
    const statStyles = {
        position: "relative",
        flex: "1 1 0%",
        ...styles.container
    };
    const { className: className, children: children, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($2759ae9e0990fd66$var$StatStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
            ref: ref,
            ...rest,
            className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-stat", className),
            __css: statStyles,
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("dl", {
                children: children
            })
        })
    });
});
$2759ae9e0990fd66$export$cbbc350c1dfc80cb.displayName = "Stat";





"use client";
var $d3fa1ae388014565$export$21a84d5a2b0277d2 = (props)=>/* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        color: "red.400",
        ...props,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
        })
    });
$d3fa1ae388014565$export$21a84d5a2b0277d2.displayName = "StatDownArrow";
function $d3fa1ae388014565$export$a08824a6bc8ad609(props) {
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        color: "green.400",
        ...props,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
        })
    });
}
$d3fa1ae388014565$export$a08824a6bc8ad609.displayName = "StatUpArrow";
function $d3fa1ae388014565$export$9000422b7fad8a96(props) {
    const { type: type, "aria-label": ariaLabel, ...rest } = props;
    const styles = (0, $2759ae9e0990fd66$export$f7ff375b7b7b2dfa)();
    const BaseIcon = type === "increase" ? $d3fa1ae388014565$export$a08824a6bc8ad609 : $d3fa1ae388014565$export$21a84d5a2b0277d2;
    const defaultAriaLabel = type === "increase" ? "increased by" : "decreased by";
    const label = ariaLabel || defaultAriaLabel;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
                srOnly: true,
                children: label
            }),
            /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)(BaseIcon, {
                "aria-hidden": true,
                ...rest,
                __css: styles.icon
            })
        ]
    });
}
$d3fa1ae388014565$export$9000422b7fad8a96.displayName = "StatArrow";





"use client";
var $55c711a79f25d1ba$export$81019c9bf758e16f = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function StatHelpText2(props, ref) {
    const styles = (0, $2759ae9e0990fd66$export$f7ff375b7b7b2dfa)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).dd, {
        ref: ref,
        ...props,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-stat__help-text", props.className),
        __css: styles.helpText
    });
});
$55c711a79f25d1ba$export$81019c9bf758e16f.displayName = "StatHelpText";





"use client";
var $825a27f8e8c8cb46$export$92a9ae124ca46bcc = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function StatLabel2(props, ref) {
    const styles = (0, $2759ae9e0990fd66$export$f7ff375b7b7b2dfa)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).dt, {
        ref: ref,
        ...props,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-stat__label", props.className),
        __css: styles.label
    });
});
$825a27f8e8c8cb46$export$92a9ae124ca46bcc.displayName = "StatLabel";





"use client";
var $3ff6cd3e130cf044$export$5c0a4a67368ad1d1 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function StatNumber2(props, ref) {
    const styles = (0, $2759ae9e0990fd66$export$f7ff375b7b7b2dfa)();
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).dd, {
        ref: ref,
        ...props,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-stat__number", props.className),
        __css: {
            ...styles.number,
            fontFeatureSettings: "pnum",
            fontVariantNumeric: "proportional-nums"
        }
    });
});
$3ff6cd3e130cf044$export$5c0a4a67368ad1d1.displayName = "StatNumber";




function $fc61e179ad34e8d3$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $30298752de581a70$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}





function $bc00eb14a09f3d3b$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $8e7cd14116eefbbb$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $8e7cd14116eefbbb$export$ec99c0ef4978dccb)(onFrame);
}



const $36df6584287c947a$export$20d68f04f30763a5 = (0, $ef6861d38665af80$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $68fecaebdb131a48$export$c1e41718f71efe41 {
    constructor(animations){
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $36df6584287c947a$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $bc00eb14a09f3d3b$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    stop() {
        this.runAll("stop");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


function $487ae004ca6ecb9b$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}







function $0c491cb61ad41d14$export$f2911d8192f464a8(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $177bb9ad58634554$export$17eda790a720ec57)(element) ? new (0, $acfbf925bfd99c10$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $37c15da893958d18$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
    node.mount(element);
    (0, $d7ed75243a14bc0a$export$bc2a978a17abfdde).set(element, node);
}






/**
 * Create a progress => progress easing function from a generator.
 */ function $c040c96019375e15$export$7f1511d09ee75a99(options, scale = 100) {
    const generator = (0, $f8c658829581418e$export$b36281d89752ae66)({
        keyframes: [
            0,
            scale
        ],
        ...options
    });
    const duration = Math.min((0, $c058a50896fa4932$export$cbdd6b3d40ea54e2)(generator), (0, $c058a50896fa4932$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $1abee33eaa7e390f$export$f64c3bfbc58eec0f)(duration)
    };
}








/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $41b70f2d49992771$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $1f7c4542f5c3ecff$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



function $9259770ad4e1f83e$export$41c5e731255a462(easing, i) {
    return (0, $5b1a2d3b2f2af4bf$export$216948827bbdc797)(easing) ? easing[(0, $1f7c4542f5c3ecff$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}




function $65b46c93dc58a6a9$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $400b44de453c8d64$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $65b46c93dc58a6a9$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $65b46c93dc58a6a9$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $471418eb0e7f05e0$export$2c9e8a9632a706b2)(startTime, endTime, offset[i]),
        easing: (0, $9259770ad4e1f83e$export$41c5e731255a462)(easing, i)
    });
}


function $ff9ca37e35ac292c$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $9406d27c5a5c225f$var$defaultSegmentEasing = "easeInOut";
function $9406d27c5a5c225f$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $41b70f2d49992771$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $41b70f2d49992771$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numElements = 0)=>{
            const valueKeyframesAsList = $9406d27c5a5c225f$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $335ee98ff4419f5c$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            if (numKeyframes <= 2 && type === "spring") {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $9406d27c5a5c225f$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $1abee33eaa7e390f$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $c040c96019375e15$export$7f1511d09ee75a99)(springTransition, absoluteDelta);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $1db025ab26673439$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $65b46c93dc58a6a9$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $9406d27c5a5c225f$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $9406d27c5a5c225f$var$getValueSequence("default", subjectSequence));
        } else {
            /**
             * Find all the elements specified in the definition and parse value
             * keyframes from their timeline definitions.
             */ const elements = (0, $fc61e179ad34e8d3$export$90ceba2564a894f8)(subject, scope, elementCache);
            const numElements = elements.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
                keyframes;
                transition;
                const element = elements[elementIndex];
                const subjectSequence = $9406d27c5a5c225f$var$getSubjectSequence(element, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $9406d27c5a5c225f$export$7c1391340308742e(transition, key), $9406d27c5a5c225f$var$getValueSequence(key, subjectSequence), elementIndex, numElements);
            }
            prevTime = currentTime;
            currentTime += maxDuration;
        }
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $ff9ca37e35ac292c$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $bd39c7cde96f5c7c$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($9406d27c5a5c225f$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $9406d27c5a5c225f$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $9406d27c5a5c225f$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $9406d27c5a5c225f$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $9406d27c5a5c225f$export$7c1391340308742e(transition, key) {
    return transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $9406d27c5a5c225f$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $9406d27c5a5c225f$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($9406d27c5a5c225f$var$isNumber);



function $136e98c0ece94819$var$animateElements(elementOrSelector, keyframes, options, scope) {
    const elements = (0, $fc61e179ad34e8d3$export$90ceba2564a894f8)(elementOrSelector, scope);
    const numElements = elements.length;
    (0, $30298752de581a70$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
    const animations = [];
    for(let i = 0; i < numElements; i++){
        const element = elements[i];
        /**
         * Check each element for an associated VisualElement. If none exists,
         * we need to create one.
         */ if (!(0, $d7ed75243a14bc0a$export$bc2a978a17abfdde).has(element)) /**
             * TODO: We only need render-specific parts of the VisualElement.
             * With some additional work the size of the animate() function
             * could be reduced significantly.
             */ (0, $0c491cb61ad41d14$export$f2911d8192f464a8)(element);
        const visualElement = (0, $d7ed75243a14bc0a$export$bc2a978a17abfdde).get(element);
        const transition = {
            ...options
        };
        /**
         * Resolve stagger function if provided.
         */ if (typeof transition.delay === "function") transition.delay = transition.delay(i, numElements);
        animations.push(...(0, $faddd33c4719fa3d$export$68cacfeee78d98d2)(visualElement, {
            ...keyframes,
            transition: transition
        }, {}));
    }
    return new (0, $68fecaebdb131a48$export$c1e41718f71efe41)(animations);
}
const $136e98c0ece94819$var$isSequence = (value)=>Array.isArray(value) && Array.isArray(value[0]);
function $136e98c0ece94819$var$animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $9406d27c5a5c225f$export$1f0f44b51a4b2f73)(sequence, options, scope);
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        let animation;
        if ((0, $1a0ef3d59b00772c$export$605d60a2578142d3)(subject)) animation = (0, $dd650ad9aec5d6c0$export$335a17c977067b99)(subject, keyframes.default, transition.default);
        else animation = $136e98c0ece94819$var$animateElements(subject, keyframes, transition);
        animations.push(animation);
    });
    return new (0, $68fecaebdb131a48$export$c1e41718f71efe41)(animations);
}
const $136e98c0ece94819$export$c17e592002be9b90 = (scope)=>{
    /**
     * Implementation
     */ function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
        let animation;
        if ($136e98c0ece94819$var$isSequence(valueOrElementOrSequence)) animation = $136e98c0ece94819$var$animateSequence(valueOrElementOrSequence, keyframes, scope);
        else if ((0, $487ae004ca6ecb9b$export$d276bfce3b1077ca)(keyframes)) animation = $136e98c0ece94819$var$animateElements(valueOrElementOrSequence, keyframes, options, scope);
        else animation = (0, $dd650ad9aec5d6c0$export$335a17c977067b99)(valueOrElementOrSequence, keyframes, options);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
};
const $136e98c0ece94819$export$e3607ec2d7a891c4 = $136e98c0ece94819$export$c17e592002be9b90();



var $lDSNw = parcelRequire("lDSNw");
const $58b49877cb94efe0$export$2a17896bf39d0d2 = ({ from: from, to: to, skipAnimation: skipAnimation })=>{
    const ref = (0, $lDSNw.useRef)();
    (0, $lDSNw.useEffect)(()=>{
        if (skipAnimation || !ref.current || from === to || isNaN(from) || isNaN(to)) return;
        const controls = (0, $136e98c0ece94819$export$e3607ec2d7a891c4)(from, to, {
            duration: 1.5,
            delay: 1,
            ease: "circOut",
            onUpdate (value) {
                ref.current.textContent = value.toFixed(1);
            }
        });
        return ()=>controls.stop();
    }, [
        from,
        to
    ]);
    if (skipAnimation) return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {
        children: to.toFixed(1)
    });
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {
        ref: ref
    });
};


const $54ad8e9c745aa669$export$4ef99c76cb70f09f = ({ title: title, value: value, unit: unit, benchmark: benchmark, animate: animate = true, ...rest })=>{
    const from = animate ? 0 : value;
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2759ae9e0990fd66$export$cbbc350c1dfc80cb), {
        ...rest,
        maxW: "160px",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $825a27f8e8c8cb46$export$92a9ae124ca46bcc), {
                ...$54ad8e9c745aa669$var$sharedStyle,
                children: title
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $3ff6cd3e130cf044$export$5c0a4a67368ad1d1), {
                ...$54ad8e9c745aa669$var$sharedStyle,
                fontSize: "3xl",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $58b49877cb94efe0$export$2a17896bf39d0d2), {
                        from: from,
                        to: value,
                        skipAnimation: !animate
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        as: "span",
                        fontSize: "md",
                        display: unit ? "inline" : "none",
                        ml: 1,
                        children: unit
                    })
                ]
            }),
            benchmark && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $55c711a79f25d1ba$export$81019c9bf758e16f), {
                ...$54ad8e9c745aa669$var$sharedStyle,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d3fa1ae388014565$export$9000422b7fad8a96), {
                        type: value >= benchmark ? "increase" : "decrease"
                    }),
                    (value * 100 / benchmark - 100 || 0).toFixed(2),
                    "%"
                ]
            })
        ]
    });
};
const $54ad8e9c745aa669$var$sharedStyle = {
    fontFamily: "roboto mono",
    textTransform: "uppercase",
    color: "gray.700"
};



var $lDSNw = parcelRequire("lDSNw");

var $lDSNw = parcelRequire("lDSNw");
class $b6bd6492f0970a4d$export$7cc8817ce52d7e02 {
    constructor(data, target, setPlayingCallback, setCurrentIndexCallback, setCurrentProgressCallback){
        this.data = data;
        this.target = target;
        this.currentIndex = 0;
        this.isPlaying = false;
        this.elapsedDuration = 0;
        this.totalDuration = this.data.reduce((acc, { duration: duration })=>acc + duration, 0);
        this.currentProgress = 0;
        // callbacks to update the UI/ state ---
        this.setPlayingCallback = setPlayingCallback;
        this.setCurrentIndexCallback = setCurrentIndexCallback;
        this.setCurrentProgressCallback = setCurrentProgressCallback;
        this.lastFrameTimestamp = null;
        this.animationFrameId = null;
    }
    // internal methods -----------------------------------------------------------
    // we update the local state of the sequencer and call the callback to update the UI
    setPlaying(isPlaying) {
        this.isPlaying = isPlaying;
        this.setPlayingCallback(isPlaying);
    }
    setCurrentIndex(index) {
        this.currentIndex = index;
        this.setCurrentIndexCallback(index);
    }
    setCurrentProgress(elapsedDuration) {
        this.currentProgress = elapsedDuration;
        this.setCurrentProgressCallback(elapsedDuration);
    }
    //--------------------------------------------------------------------------------
    play(index = 0) {
        if (this.isPlaying) this.jumpToIndex(index);
        if (!this.isPlaying && index < this.data.length) {
            this.setPlaying(true);
            this.setCurrentIndex(index);
            let { yDifference: yDifference, duration: duration } = this.data[this.currentIndex];
            this.scroll(yDifference, duration);
        }
    }
    pause() {
        if (this.animationFrameId) {
            window.cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
        this.setPlaying(false);
    }
    resume() {
        if (!this.isPlaying && this.currentIndex < this.data.length) {
            this.setPlaying(true);
            let { yDifference: yDifference, duration: duration } = this.data[this.currentIndex];
            this.scroll(yDifference, duration);
        }
    }
    playNext() {
        if (!this.isPlaying) {
            console.error("You've asked me to playNext, but the sequencer is not playing");
            return;
        }
        if (this.currentIndex >= this.data.length) {
            this.cancel();
            return;
        }
        const currentData = this.data[this.currentIndex];
        this.setCurrentIndex(this.currentIndex + 1);
        this.scroll(currentData.yDifference, currentData.duration);
    }
    cancel() {
        this.setPlaying(false);
        this.elapsedDuration = 0;
        this.setCurrentProgress(0);
        this.lastFrameTimestamp = null;
        this.setCurrentIndex(0);
        this.animationFrameId = null;
    }
    jumpToIndex(index) {
        const wasPlaying = this.isPlaying;
        this.pause();
        if (index >= this.data.length) return;
        this.setCurrentIndex(index);
        // resest progress and elapsed duration
        this.elapsedDuration = $b6bd6492f0970a4d$var$calculateElapsedDuration(index, this.data);
        this.setCurrentProgress(this.elapsedDuration / this.totalDuration * 100);
        this.lastFrameTimestamp = null;
        if (wasPlaying) this.playNext();
    }
    jumpToPercentElapsed(percent) {
        const targetElapsedDuration = percent / 100 * this.totalDuration;
        const index = this.data.findIndex(({ duration: duration }, i)=>{
            return $b6bd6492f0970a4d$var$calculateElapsedDuration(i, this.data) + duration >= targetElapsedDuration;
        });
        this.jumpToIndex(index);
    }
    scroll(delta, // how much we will scroll
    duration // duration of this scroll action
    ) {
        let start = null;
        // current position of the window
        const from = this.target.pageYOffset;
        // where we will scroll to at the end of the delta
        const to = from + delta;
        window.requestAnimationFrame((function step(timestamp) {
            if (!start) start = timestamp;
            const progress = (timestamp - start) / duration;
            // ---------------------------------------------
            // for calculating the % progress of the scroll
            if (this.lastFrameTimestamp) {
                this.elapsedDuration += timestamp - this.lastFrameTimestamp;
                this.setCurrentProgress(this.elapsedDuration / this.totalDuration * 100);
            }
            this.lastFrameTimestamp = timestamp;
            // ---------------------------------------------
            if (progress < 1) {
                const scrollPos = progress * delta + from;
                this.target.scrollTo(0, Math.round(scrollPos));
                this.animationFrameId = window.requestAnimationFrame(step.bind(this));
            } else {
                this.target.scrollTo(0, to);
                this.setCurrentIndex(this.currentIndex + 1);
                if (this.currentIndex < this.data.length && this.isPlaying) {
                    let { yDifference: yDifference, duration: duration } = this.data[this.currentIndex];
                    this.scroll(yDifference, duration);
                }
            }
        }).bind(this));
    }
}
const $b6bd6492f0970a4d$var$calculateElapsedDuration = (index, data)=>{
    return data.slice(0, index).reduce((acc, { duration: duration })=>acc + duration, 0);
};


function $2fa1e6752e8574e8$export$ff0acae64d99fa5c(targetRef) {
    const [scrollQueue, setScrollQueue] = (0, $lDSNw.useState)([]);
    const [playing, setPlaying] = (0, $lDSNw.useState)(false);
    const [currentMovementIndex, setCurrentMovementIndex] = (0, $lDSNw.useState)(0);
    const [currentProgress, setCurrentProgress] = (0, $lDSNw.useState)(0); // percentage
    const [currentY, setCurrentY] = (0, $lDSNw.useState)(0); // y position in pixels
    // ------------------------------------------------------------
    const scrollSequencer = (0, $lDSNw.useRef)(null);
    // setting up the actions, binding them to the sequencer
    const play = (0, $lDSNw.useCallback)((index)=>{
        scrollSequencer.current?.play(index);
    }, [
        scrollSequencer.current
    ]);
    const pause = (0, $lDSNw.useCallback)(()=>{
        scrollSequencer.current?.pause();
    }, [
        scrollSequencer.current
    ]);
    const resume = (0, $lDSNw.useCallback)(()=>{
        scrollSequencer.current?.resume();
    }, [
        scrollSequencer.current
    ]);
    const playFromPercent = (0, $lDSNw.useCallback)((percent)=>{
        //between 0 and 1 for percentage
        scrollSequencer.current?.jumpToPercentElapsed(percent);
    }, [
        scrollSequencer.current
    ]);
    // function throttle(func: Function, limit: number) {
    //   let inThrottle: boolean;
    //   return function (this: any) {
    //     const args = arguments;
    //     const context = this;
    //     if (!inThrottle) {
    //       func.apply(context, args);
    //       inThrottle = true;
    //       setTimeout(() => (inThrottle = false), limit);
    //     }
    //   };
    // }
    const loadQueue = (0, $lDSNw.useCallback)((queue)=>{
        setScrollQueue(queue);
        const iframeWindow = targetRef.current.contentWindow;
        if (!iframeWindow) return console.error("iframe has no contentWindow");
        loadIFrame();
        scrollSequencer.current = new (0, $b6bd6492f0970a4d$export$7cc8817ce52d7e02)(queue, iframeWindow, //👇 callbacks to set state back in this hook ------
        setPlaying, setCurrentMovementIndex, setCurrentProgress);
    }, [
        setScrollQueue,
        targetRef.current
    ]);
    // run this to get y postition back
    const loadIFrame = (0, $lDSNw.useCallback)(()=>{
        const iframeWindow = targetRef.current.contentWindow;
        if (!iframeWindow) return console.error("iframe has no contentWindow");
        // attach a scrollListener to iframeWindow with throttling
        // felt laggy? so throttled... might not be fixing much
        // this is where we can access the iframe content
        // const formatIframe = iframeWindow.document
        //   .getElementById('middle-ad')
        //   .getElementsByTagName('iframe')[0];
        iframeWindow.addEventListener("scroll", ()=>{
            setCurrentY(iframeWindow.scrollY);
        });
    }, [
        targetRef.current
    ]);
    const scrollActions = {
        play: play,
        pause: pause,
        resume: resume,
        loadQueue: loadQueue,
        loadIFrame: loadIFrame,
        playFromPercent: playFromPercent
    };
    const scrollStatus = {
        playing: playing,
        currentMovementIndex: currentMovementIndex,
        scrollQueue: // currentProgress,
        scrollQueue
    };
    return {
        scrollStatus: scrollStatus,
        scrollActions: scrollActions,
        currentY: currentY,
        currentProgress: currentProgress
    };
}


const $674cb942fc811b49$export$2956bc0e1eaabac7 = (scrollData, config = {
    initalY: 3000,
    //inital scroll position.
    durationScale: 1,
    scrollLengthScale: 1,
    delayDurationScale: 2,
    minDuration: 100,
    maxDuration: 1500,
    easingFunction: (t)=>t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
})=>{
    const scrollQueue = [];
    const engadements = scrollData.flat(1);
    // const initalScroll = {
    //   duration: getNextMovementDuration(0, 1000, config),
    //   yDifference: config.initalY,
    // };
    // scrollQueue.push(initalScroll);
    engadements.forEach((engadement, index)=>{
        let direction = engadement[1].direction === 1 ? "down" : "up"; // the direction of the change/ middle value
        const initalTime = engadement[0].time;
        const initalY = engadement[0].y;
        const movement1 = {
            duration: $674cb942fc811b49$var$getNextMovementDuration(initalTime, engadement[1].time, config),
            yDifference: $674cb942fc811b49$var$getNextMovementY(// right now, YDifference can be positive or negative to indicate direction. but could just be positive and we alternate elsewhere if we want to.
            initalY, engadement[1].y, config),
            engadementIndex: index
        };
        const movement2 = {
            duration: $674cb942fc811b49$var$getNextMovementDuration(engadement[1].time, engadement[2].time, config),
            yDifference: $674cb942fc811b49$var$getNextMovementY(engadement[1].y, engadement[2].y, config),
            engadementIndex: index
        };
        // add the movements to the queue
        scrollQueue.push(movement1, movement2);
        // Delay -----------------------------------------------------------------------
        if (index < engadements.length - 1) {
            const nextEngadement = engadements[index + 1];
            const delay = $674cb942fc811b49$var$getDelay(engadement[2].time, nextEngadement[0].time, config);
            // add a delay to the queue
            scrollQueue.push({
                duration: delay,
                yDifference: 0,
                engadementIndex: index
            });
        }
    });
    return scrollQueue;
};
// getScrollQueue Helpers -----------------------------------------------------------------------
const $674cb942fc811b49$var$getNextMovementDuration = (previousTime, currentTime, config)=>{
    let duration = (currentTime - previousTime) * config.durationScale;
    if (duration < config.minDuration) {
        const upperBounds = config.minDuration * 2;
        duration = $674cb942fc811b49$var$randomIntFromInterval(config.minDuration, upperBounds) * config.durationScale;
    }
    if (duration > config.maxDuration) duration = config.maxDuration * config.durationScale;
    return duration;
};
const $674cb942fc811b49$var$getNextMovementY = (previousY, currentY, config)=>{
    const direction = currentY > previousY ? 1 : -1;
    const amplitude = Math.abs(currentY - previousY) * config.scrollLengthScale;
    return direction * amplitude;
};
const $674cb942fc811b49$var$getDelay = (lastTime, nextSessionFirstTime, config)=>{
    let delay = nextSessionFirstTime - lastTime;
    // is the delay within a reasonable range?
    // if not, it might be a new session or strange data, and we just add a random one
    if (delay < config.minDuration) delay = config.minDuration * config.delayDurationScale;
    else if (delay > config.maxDuration) delay = $674cb942fc811b49$var$randomIntFromInterval(config.minDuration, config.maxDuration) * config.delayDurationScale;
    return delay;
};
const $674cb942fc811b49$var$randomIntFromInterval = (min, max)=>{
    return Math.floor(Math.random() * (max - min + 1) + min);
};


const $5cabf5fab4ef129f$export$671214622682cb48 = (scrollData, config = {
    initalY: 3000,
    //inital scroll position.
    durationScale: 1,
    scrollLengthScale: 1,
    // delayDurationScale: 2,
    minDuration: 50,
    maxDuration: 1000,
    easingFunction: (t)=>t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
})=>{
    const scrollQueue = [];
    // const initalScroll = {
    //   duration: getNextMovementDuration(0, 1000, config),
    //   yDifference: config.initalY,
    // };
    // scrollQueue.push(initalScroll);
    scrollData?.forEach((scroll, index)=>{
        // let direction = scroll.y < 0 ? "down" : "up"; // the direction of the change/ middle value
        const previousScroll = scrollData[index - 1] || {
            x: 0,
            y: 0
        };
        const movement = {
            duration: $5cabf5fab4ef129f$var$getNextMovementDuration(previousScroll.x, scroll.x, config),
            yDifference: $5cabf5fab4ef129f$var$getNextMovementY(previousScroll.y, scroll.y, config),
            engadementIndex: 0 //not using this in getScrollQueueFromScrollData yet, but it's used in fromEngadements
        };
        scrollQueue.push(movement);
    });
    return scrollQueue;
};
// getScrollQueue Helpers -----------------------------------------------------------------------
const $5cabf5fab4ef129f$var$getNextMovementDuration = (previousTime, currentTime, config)=>{
    let duration = (currentTime - previousTime) * config.durationScale;
    if (duration < config.minDuration) {
        const upperBounds = config.minDuration * 2;
        duration = $5cabf5fab4ef129f$var$randomIntFromInterval(config.minDuration, upperBounds) * config.durationScale;
    }
    if (duration > config.maxDuration) duration = config.maxDuration * config.durationScale;
    return duration;
};
const $5cabf5fab4ef129f$var$getNextMovementY = (previousY, currentY, config)=>{
    const direction = currentY > previousY ? 1 : -1;
    const amplitude = Math.abs(currentY - previousY) * config.scrollLengthScale;
    return direction * amplitude;
};
const $5cabf5fab4ef129f$var$randomIntFromInterval = (min, max)=>{
    return Math.floor(Math.random() * (max - min + 1) + min);
};




const $69965dd7e56a3a6d$export$2547fe6f09835b60 = [
    {
        y: 10,
        x: 400
    },
    {
        y: 200,
        x: 1400
    },
    {
        y: 220,
        x: 1500
    },
    {
        y: 230,
        x: 1700
    },
    {
        y: 2,
        x: 2500
    },
    {
        y: 10,
        x: 2600
    },
    {
        y: 10,
        x: 3000
    },
    {
        y: 15,
        x: 3350
    },
    {
        y: 40,
        x: 3600
    },
    {
        y: 270,
        x: 4000
    },
    {
        y: 290,
        x: 4250
    },
    {
        y: 300,
        x: 4600
    },
    {
        y: 280,
        x: 5000
    },
    {
        y: 270,
        x: 5100
    }
];



const $0211b21c941da8b7$export$4e8cf45f820f4937 = ({ rechartsData: rechartsData, mainFrameRef: mainFrameRef, buildId: buildId, iframeState: iframeState })=>{
    const { averagePressure: averagePressure, avgScrollDistance: avgScrollDistance, scrollSquiggle: scrollSquiggle } = rechartsData;
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const playTimer = (0, $lDSNw.useRef)(null);
    const { scrollStatus: scrollStatus, scrollActions: scrollActions, currentProgress: currentProgress, currentY: currentY } = (0, $2fa1e6752e8574e8$export$ff0acae64d99fa5c)(mainFrameRef);
    const { annotations: annotations, setAnnotation: setAnnotation, loading: annotationsLoading } = (0, $a7fb1b2a3b6f3dc3$export$902d4c991a42811e)({
        buildId: buildId,
        format: "velocity"
    });
    const { sessionPressure: sessionPressure, pressureArray: pressureArray, scrollDistance: scrollDistance, liveScrollSquiggle: liveScrollSquiggle = [] } = (0, $379be3281ad335a2$export$2e2bcd8739ae039)(currentY);
    const parentRef = (0, $lDSNw.useRef)(null);
    const runSetup = ()=>{
        // sets up listener in the useAdScrollState hook
        // to pass through y position
        scrollActions.loadIFrame();
        const scrollConfig = {
            // initalY: 3000, //inital scroll position.
            durationScale: 1.3,
            scrollLengthScale: 1.3,
            // delayDurationScale: 2,
            minDuration: 0,
            maxDuration: 4000
        };
        const scrollQueue = (0, $5cabf5fab4ef129f$export$671214622682cb48)((0, $69965dd7e56a3a6d$export$2547fe6f09835b60), scrollConfig);
        scrollActions.loadQueue(scrollQueue);
        if (playTimer.current) clearTimeout(playTimer.current);
        if (iframeState.isHoveringIframe) return;
        playTimer.current = setTimeout(()=>{
        // scrollActions.play();
        }, 3500);
    };
    (0, $lDSNw.useEffect)(()=>{
        if (iframeState.iframeLoaded) runSetup();
    }, [
        iframeState.iframeLoaded
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!iframeState.isHoveringIframe) return;
        clearTimeout(playTimer.current);
        scrollActions.pause();
    }, [
        iframeState.isHoveringIframe
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                w: "100%",
                pb: 6,
                alignItems: "flex-start",
                borderBottom: "1px solid",
                borderColor: "gray.200",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                        textStyle: {
                            fontSize: "2xl",
                            fontWeight: "medium"
                        },
                        onEdit: (value)=>setAnnotation("title", value),
                        isLoading: annotationsLoading,
                        value: annotations?.title,
                        showEditControls: userInfo?.loggedIn
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                        showEditControls: userInfo?.loggedIn,
                        textStyle: {
                            fontSize: "sm"
                        },
                        onEdit: (value)=>setAnnotation("description", value),
                        value: annotations?.description,
                        isLoading: annotationsLoading
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aabe32da29ab7737$export$f54a093675066994).Velocity, {})
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                justifyContent: "flex-start",
                w: "100%",
                h: "100%",
                alignItems: "stretch",
                gap: "6",
                py: 12,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        borderRadius: "md",
                        w: "100%",
                        maxW: "40%",
                        overflow: "hidden",
                        h: "100%",
                        border: "1px solid",
                        borderColor: "gray.200",
                        pos: "relative",
                        ref: parentRef,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($0211b21c941da8b7$var$TopGradient, {}),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e110900b167a1ef9$export$2e2bcd8739ae039), {
                                pressure: sessionPressure,
                                averagePressure: averagePressure,
                                avgScrollDistance: avgScrollDistance,
                                scrollDistance: scrollDistance
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($0211b21c941da8b7$var$BottomGradient, {}),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($0211b21c941da8b7$var$StatHStack, {
                                opacity: sessionPressure > 0 ? 1 : 0,
                                pb: "7",
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Velocity",
                                    value: sessionPressure,
                                    animate: false
                                })
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($0211b21c941da8b7$var$StatHStack, {
                                opacity: sessionPressure > 0 ? 0 : 1,
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Av Velocity",
                                    value: averagePressure,
                                    benchmark: averagePressure * 0.86
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        w: "100%",
                        h: "100%",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                                w: "100%",
                                h: "100%",
                                pos: "relative",
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($0211b21c941da8b7$var$DistanceChart, {
                                        avgScrollDistance: avgScrollDistance,
                                        avgScrollDistanceBenchmark: avgScrollDistance * 0.95,
                                        liveScrollDistance: scrollDistance,
                                        sessionPressure: sessionPressure
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($0211b21c941da8b7$var$StatHStack, {
                                        opacity: sessionPressure > 0 ? 1 : 0,
                                        pb: "7",
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                            title: "Distance",
                                            value: scrollDistance,
                                            animate: false,
                                            unit: "px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($0211b21c941da8b7$var$StatHStack, {
                                        opacity: sessionPressure > 0 ? 0 : 1,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                            title: "Av Scroll Distance",
                                            value: avgScrollDistance,
                                            unit: "px",
                                            benchmark: avgScrollDistance * 0.95
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                                showEditControls: userInfo?.loggedIn,
                                textStyle: {
                                    fontSize: "sm"
                                },
                                onEdit: (value)=>setAnnotation("distanceDesc", value),
                                value: annotations?.distanceDesc,
                                isLoading: annotationsLoading
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $0211b21c941da8b7$var$TopGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-b, whiteAlpha.500, transparent)"
    });
const $0211b21c941da8b7$var$BottomGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-t, whiteAlpha.500, transparent)"
    });
const $0211b21c941da8b7$var$StatHStack = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        pos: "absolute",
        bottom: 4,
        left: 6,
        transition: "opacity 0.7s ease",
        w: "100%",
        gap: 1,
        ...rest,
        children: children
    });
const $0211b21c941da8b7$var$DistanceChart = ({ avgScrollDistance: avgScrollDistance, avgScrollDistanceBenchmark: avgScrollDistanceBenchmark, liveScrollDistance: liveScrollDistance, sessionPressure: sessionPressure })=>{
    // dummy data for scale
    const data = [
        {
            name: "Min",
            value: 0
        },
        {
            name: "Max",
            value: Math.max(avgScrollDistance, avgScrollDistanceBenchmark, liveScrollDistance)
        }
    ];
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
        aspect: 5 / 3,
        maxHeight: 300,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $77d815ec488f9d85$export$f881f4f9e4007a57), {
            data: data,
            layout: "vertical",
            margin: {
                bottom: -10
            },
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                    strokeDasharray: "3 3"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                    type: "number",
                    fontSize: "0.8rem",
                    unit: "px",
                    minTickGap: 125,
                    stroke: "#C7C7C7",
                    domain: [
                        (dataMin)=>dataMin * 3,
                        (dataMax)=>dataMax * 2
                    ],
                    label: {
                        fill: "#C7C7C7"
                    }
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                    dataKey: "name",
                    type: "category",
                    hide: true
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6ecebb08067248a7$export$bbc6c6369b38e3d1), {
                    dataKey: "value",
                    fill: "transparent"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                    x: avgScrollDistance,
                    stroke: "#00BA77",
                    animationDuration: 4,
                    label: {
                        value: "Av. Scroll Distance",
                        transform: "translate(0, 5)",
                        fill: "#00BA77",
                        ...$0211b21c941da8b7$var$refLineStyle
                    }
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                    x: avgScrollDistanceBenchmark,
                    stroke: "#C7C7C7",
                    animationDuration: 4,
                    label: {
                        value: "Benchmark*",
                        transform: "translate(0, 25)",
                        fill: "#C7C7C7",
                        ...$0211b21c941da8b7$var$refLineStyle
                    }
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                    x: liveScrollDistance,
                    display: sessionPressure > 0 ? "block" : "none",
                    stroke: "#FF7426",
                    animationDuration: 4,
                    isFront: true,
                    label: {
                        value: "Demo",
                        transform: "translate(0, 45)",
                        opacity: sessionPressure > 0 ? 1 : 0,
                        fill: "#FF7426",
                        ...$0211b21c941da8b7$var$refLineStyle
                    }
                })
            ]
        })
    });
};
const $0211b21c941da8b7$var$refLineStyle = {
    fontFamily: "roboto mono, monospace",
    fontSize: "0.8rem",
    position: "insideTopRight"
};












var $lDSNw = parcelRequire("lDSNw");



const $aaeb35c295b0f8f6$export$2952cdcf45ac5d44 = ({ rechartsData: rechartsData, mainFrameRef: mainFrameRef, buildId: buildId, iframeState: iframeState = {
    iframeLoaded: true,
    isHoveringIframe: false
} })=>{
    const { averagePressure: averagePressure, avgScrollDistance: avgScrollDistance } = rechartsData;
    const { currentY: currentY, scrollActions: scrollActions } = (0, $2fa1e6752e8574e8$export$ff0acae64d99fa5c)(mainFrameRef);
    const playTimer = (0, $lDSNw.useRef)(null);
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const { annotations: annotations, setAnnotation: setAnnotation, loading: annotationsLoading } = (0, $a7fb1b2a3b6f3dc3$export$902d4c991a42811e)({
        buildId: buildId,
        format: "velocity"
    });
    const { sessionPressure: sessionPressure, scrollDistance: scrollDistance, liveScrollSquiggle: liveScrollSquiggle, scrollSquiggle: scrollSquiggle } = (0, $379be3281ad335a2$export$2e2bcd8739ae039)(currentY);
    const runSetup = ()=>{
        // sets up listener in the useAdScrollState hook
        // to pass through y position
        scrollActions.loadIFrame();
        const scrollConfig = {
            // initalY: 3000, //inital scroll position.
            durationScale: 1.2,
            scrollLengthScale: 1.5,
            // delayDurationScale: 2,
            minDuration: 0,
            maxDuration: 4000
        };
        const scrollQueue = (0, $5cabf5fab4ef129f$export$671214622682cb48)((0, $69965dd7e56a3a6d$export$2547fe6f09835b60), scrollConfig);
        console.log("scrollQueue", scrollQueue);
        scrollActions.loadQueue(scrollQueue);
        if (playTimer.current) clearTimeout(playTimer.current);
        if (iframeState.isHoveringIframe) return;
        playTimer.current = setTimeout(()=>{
            scrollActions.play();
        }, 3500);
    };
    (0, $lDSNw.useEffect)(()=>{
        if (iframeState.iframeLoaded) runSetup();
        return ()=>{
            clearTimeout(playTimer.current);
        };
    }, [
        iframeState.iframeLoaded
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!iframeState.isHoveringIframe) return;
        clearTimeout(playTimer.current);
        scrollActions.pause();
    }, [
        iframeState.isHoveringIframe
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
            w: "100%",
            h: "100%",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: "12",
            py: 12,
            pr: 3,
            pl: 6,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                    borderRadius: "md",
                    p: 6,
                    border: "1px solid",
                    borderColor: "gray.200",
                    pos: "relative",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($aaeb35c295b0f8f6$var$TopGradient, {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e110900b167a1ef9$export$2e2bcd8739ae039), {
                            pressure: sessionPressure,
                            averagePressure: averagePressure,
                            avgScrollDistance: avgScrollDistance,
                            scrollDistance: scrollDistance
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($aaeb35c295b0f8f6$var$BottomGradient, {}),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($aaeb35c295b0f8f6$var$StatHStack, {
                            opacity: sessionPressure > 0 ? 1 : 0,
                            pb: "7",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Velocity",
                                    value: sessionPressure,
                                    animate: false
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Distance",
                                    value: scrollDistance,
                                    animate: false,
                                    unit: "px"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                    w: "100%",
                    alignItems: "flex-start",
                    h: "100%",
                    pt: "5%",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                            pb: 6,
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                                    textStyle: {
                                        fontSize: "3xl",
                                        fontWeight: "medium"
                                    },
                                    inputStyle: {
                                        width: "100%"
                                    },
                                    onEdit: (value)=>setAnnotation("title", value),
                                    isLoading: annotationsLoading,
                                    value: annotations?.title,
                                    showEditControls: userInfo?.loggedIn
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                                    showEditControls: userInfo?.loggedIn,
                                    textStyle: {
                                        fontSize: "sm"
                                    },
                                    onEdit: (value)=>setAnnotation("description", value),
                                    value: annotations?.description,
                                    isLoading: annotationsLoading,
                                    inputStyle: {
                                        width: "100%",
                                        minHeight: "200px"
                                    },
                                    fieldType: "textarea"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                            w: "100%",
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Av. Velocity",
                                    value: averagePressure,
                                    benchmark: averagePressure * 0.95
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Av. Distance",
                                    value: avgScrollDistance,
                                    benchmark: avgScrollDistance * 0.86,
                                    unit: "px"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $aaeb35c295b0f8f6$var$TopGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-b, whiteAlpha.500, transparent)",
        zIndex: 1
    });
const $aaeb35c295b0f8f6$var$BottomGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-t, whiteAlpha.500, transparent)",
        zIndex: 1
    });
const $aaeb35c295b0f8f6$var$StatHStack = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        pos: "absolute",
        // justifyContent="center"
        bottom: 4,
        left: 6,
        transition: "opacity 0.7s ease",
        w: "100%",
        gap: 1,
        ...rest,
        children: children
    });
const $aaeb35c295b0f8f6$var$LiveScrubChart = ({ scrollSquiggle: scrollSquiggle, liveScrollSquiggle: liveScrollSquiggle })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
        aspect: 0.6,
        maxHeight: 500,
        width: "110%",
        zIndex: 0,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $ad7331bbe400fed9$export$54d0e8420ac838ac), {
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                    dataKey: "x",
                    hide: true,
                    type: "number",
                    interval: "preserveStart",
                    domain: [
                        "dataMin",
                        2000
                    ]
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                    dataKey: "y",
                    hide: true,
                    domain: [
                        (dataMin)=>dataMin * 2,
                        (dataMax)=>dataMax * 2
                    ]
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cd596fa7fc5c5a32$export$17d680238e50603e), {
                    data: liveScrollSquiggle,
                    strokeWidth: 2,
                    dot: false,
                    type: "monotone",
                    dataKey: "y",
                    stroke: "#8884d8"
                })
            ]
        })
    });
};












var $lDSNw = parcelRequire("lDSNw");


const $d1052c328993fb55$export$2c80b568c03b30a9 = ({ currentProgress: currentProgress, playFromPercent: playFromPercent, sliderTrackStyle: sliderTrackStyle = {} })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0c7e57679d2cb40c$export$472062a354075cee), {
        position: "absolute!important",
        focusThumbOnChange: false,
        overflow: "hidden",
        top: "0",
        display: "flex",
        alignItems: "flex-end",
        h: "100%",
        value: currentProgress / 100 * 100,
        onChange: (value)=>{
            console.log(value);
            playFromPercent(value);
        },
        colorScheme: "blackAlpha",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$105594979f116971), {
                bottom: "0",
                bg: "none",
                h: "100%",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$73137d74280e0c3e), {
                    bg: "#00BA77",
                    opacity: 0.02,
                    style: {
                        boxShadow: "1px 0 10px 0px #00BA77"
                    },
                    ...sliderTrackStyle
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$2c1b491743890dec), {
                h: "100%",
                w: "1px",
                bg: "#00BA77"
            })
        ]
    }, "scroll-slider");
};






const $777cc3ba08e35d18$export$f92f4a2a01389f68 = ({ rechartsData: rechartsData, mainFrameRef: mainFrameRef, buildId: buildId, iframeState: iframeState })=>{
    const { averagePressure: averagePressure, avgScrollDistance: avgScrollDistance, scrollSquiggle: scrollSquiggle } = rechartsData;
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const playTimer = (0, $lDSNw.useRef)(null);
    const { scrollStatus: scrollStatus, scrollActions: scrollActions, currentProgress: currentProgress, currentY: currentY } = (0, $2fa1e6752e8574e8$export$ff0acae64d99fa5c)(mainFrameRef);
    const { annotations: annotations, setAnnotation: setAnnotation, loading: annotationsLoading } = (0, $a7fb1b2a3b6f3dc3$export$902d4c991a42811e)({
        buildId: buildId,
        format: "velocity"
    });
    const { sessionPressure: sessionPressure, pressureArray: pressureArray, scrollDistance: scrollDistance } = (0, $379be3281ad335a2$export$2e2bcd8739ae039)(currentY);
    const parentRef = (0, $lDSNw.useRef)(null);
    const runSetup = ()=>{
        // sets up listener in the useAdScrollState hook
        // to pass through y position
        scrollActions.loadIFrame();
        const scrollConfig = {
            // initalY: 3000, //inital scroll position.
            durationScale: 2.2,
            scrollLengthScale: 1.3,
            // delayDurationScale: 2,
            minDuration: 0,
            maxDuration: 4000
        };
        const scrollQueue = (0, $5cabf5fab4ef129f$export$671214622682cb48)(scrollSquiggle, scrollConfig);
        scrollActions.loadQueue(scrollQueue);
        playTimer.current = setTimeout(()=>{
            scrollActions.play();
        }, 3000);
    };
    (0, $lDSNw.useEffect)(()=>{
        if (iframeState.iframeLoaded) runSetup();
        return ()=>{
            clearTimeout(playTimer.current);
        };
    }, [
        iframeState.iframeLoaded
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!iframeState.isHoveringIframe) return;
        clearTimeout(playTimer.current);
        scrollActions.pause();
    }, [
        iframeState.isHoveringIframe
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                w: "100%",
                pt: "4",
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                    textStyle: {
                        fontSize: "4xl",
                        fontWeight: "medium"
                    },
                    onEdit: (value)=>setAnnotation("title", value),
                    isLoading: annotationsLoading,
                    value: annotations?.title,
                    showEditControls: userInfo?.loggedIn
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                justifyContent: "flex-start",
                w: "100%",
                h: "100%",
                alignItems: "stretch",
                gap: "6",
                py: 8,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        borderRadius: "md",
                        w: "100%",
                        maxW: "330px",
                        overflow: "hidden",
                        h: "100%",
                        px: 5,
                        border: "1px solid",
                        borderColor: "gray.200",
                        pos: "relative",
                        ref: parentRef,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($777cc3ba08e35d18$var$TopGradient, {}),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e110900b167a1ef9$export$2e2bcd8739ae039), {
                                pressure: sessionPressure,
                                averagePressure: averagePressure,
                                avgScrollDistance: avgScrollDistance,
                                scrollDistance: scrollDistance
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($777cc3ba08e35d18$var$BottomGradient, {}),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($777cc3ba08e35d18$var$StatHStack, {
                                opacity: sessionPressure > 0 ? 1 : 0,
                                pb: "7",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                        title: "Velocity",
                                        value: sessionPressure,
                                        animate: false
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                        title: "Distance",
                                        value: scrollDistance,
                                        animate: false,
                                        unit: "px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)($777cc3ba08e35d18$var$StatHStack, {
                                opacity: sessionPressure > 0 ? 0 : 1,
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                        title: "Av Velocity",
                                        value: averagePressure,
                                        benchmark: averagePressure * 0.86
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                        title: "Av Distance",
                                        value: avgScrollDistance,
                                        unit: "px",
                                        benchmark: avgScrollDistance * 0.95
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        w: "100%",
                        h: "100%",
                        gap: "0",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                w: "100%",
                                h: "100%",
                                pos: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                                        aspect: 5 / 3,
                                        maxHeight: 300,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $ad7331bbe400fed9$export$54d0e8420ac838ac), {
                                            data: scrollSquiggle,
                                            children: [
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                                                    strokeDasharray: "3 3"
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                                                    dataKey: "x",
                                                    hide: true,
                                                    type: "number",
                                                    interval: "preserveStart",
                                                    domain: [
                                                        "dataMin",
                                                        "dataMax"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                                                    dataKey: "y",
                                                    hide: true,
                                                    domain: [
                                                        (dataMin)=>dataMin * 2,
                                                        (dataMax)=>dataMax * 2
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cd596fa7fc5c5a32$export$17d680238e50603e), {
                                                    strokeWidth: 2,
                                                    dot: false,
                                                    type: "monotone",
                                                    dataKey: "y",
                                                    stroke: "#8884d8"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d1052c328993fb55$export$2c80b568c03b30a9), {
                                        currentProgress: currentProgress,
                                        playFromPercent: scrollActions.playFromPercent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                                w: "100%",
                                pos: "relative",
                                h: "32px",
                                borderRadius: "lg",
                                overflow: "hidden",
                                mb: "6",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d1052c328993fb55$export$2c80b568c03b30a9), {
                                        currentProgress: currentProgress,
                                        playFromPercent: scrollActions.playFromPercent,
                                        sliderTrackStyle: {
                                            bg: "gray.200",
                                            opacity: 0.6
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                        pos: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($777cc3ba08e35d18$var$PlayButton, {
                                            scrollStatus: scrollStatus,
                                            scrollActions: scrollActions
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                                showEditControls: userInfo?.loggedIn,
                                textStyle: {
                                    fontSize: "sm",
                                    pl: 2
                                },
                                onEdit: (value)=>setAnnotation("description", value),
                                value: annotations?.description,
                                isLoading: annotationsLoading
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aabe32da29ab7737$export$f54a093675066994).Velocity, {})
                        ]
                    })
                ]
            })
        ]
    });
};
const $777cc3ba08e35d18$var$TopGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-b, whiteAlpha.500, transparent)"
    });
const $777cc3ba08e35d18$var$BottomGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-t, whiteAlpha.500, transparent)"
    });
const $777cc3ba08e35d18$var$StatHStack = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        pos: "absolute",
        justifyContent: "center",
        bottom: 4,
        left: 0,
        px: 5,
        transition: "opacity 0.7s ease",
        w: "100%",
        gap: 1,
        ...rest,
        children: children
    });
const $777cc3ba08e35d18$var$PlayButton = ({ scrollStatus: scrollStatus, scrollActions: scrollActions })=>{
    const showPlayButton = !scrollStatus.playing;
    const showRestartButton = scrollStatus.currentMovementIndex === scrollStatus.scrollQueue.length;
    if (showRestartButton) return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
        size: "sm",
        backgroundColor: "gray.200",
        icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$7cb7bf01cf98523), {}),
        onClick: ()=>scrollActions.playFromPercent(0)
    });
    if (showPlayButton) return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
        size: "sm",
        backgroundColor: "gray.200",
        icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$7cb7bf01cf98523), {}),
        onClick: ()=>scrollActions.resume()
    });
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
        size: "sm",
        backgroundColor: "gray.100",
        icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$816d9082b987955a), {}),
        onClick: ()=>scrollActions.pause()
    });
};












var $lDSNw = parcelRequire("lDSNw");




const $6abc2b8c265253b0$export$d1d86185404df7c2 = ({ rechartsData: rechartsData, mainFrameRef: mainFrameRef, buildId: buildId, iframeState: iframeState })=>{
    const { averagePressure: averagePressure, avgScrollDistance: avgScrollDistance, scrollSquiggle: scrollSquiggle } = rechartsData;
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const playTimer = (0, $lDSNw.useRef)(null);
    const { scrollStatus: scrollStatus, scrollActions: scrollActions, currentProgress: currentProgress, currentY: currentY } = (0, $2fa1e6752e8574e8$export$ff0acae64d99fa5c)(mainFrameRef);
    const { annotations: annotations, setAnnotation: setAnnotation, loading: annotationsLoading } = (0, $a7fb1b2a3b6f3dc3$export$902d4c991a42811e)({
        buildId: buildId,
        format: "velocity"
    });
    const { sessionPressure: sessionPressure, scrollDistance: scrollDistance, liveScrollSquiggle: liveScrollSquiggle = [] } = (0, $379be3281ad335a2$export$2e2bcd8739ae039)(currentY);
    const parentRef = (0, $lDSNw.useRef)(null);
    const runSetup = ()=>{
        // sets up listener in the useAdScrollState hook
        // to pass through y position
        scrollActions.loadIFrame();
        const scrollConfig = {
            // initalY: 3000, //inital scroll position.
            durationScale: 1.3,
            scrollLengthScale: 1.3,
            // delayDurationScale: 2,
            minDuration: 0,
            maxDuration: 4000
        };
        const scrollQueue = (0, $5cabf5fab4ef129f$export$671214622682cb48)((0, $69965dd7e56a3a6d$export$2547fe6f09835b60), scrollConfig);
        scrollActions.loadQueue(scrollQueue);
        if (playTimer.current) clearTimeout(playTimer.current);
        if (iframeState.isHoveringIframe) return;
        playTimer.current = setTimeout(()=>{
        // scrollActions.play();
        }, 3500);
    };
    (0, $lDSNw.useEffect)(()=>{
        if (iframeState.iframeLoaded) runSetup();
    }, [
        iframeState.iframeLoaded
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!iframeState.isHoveringIframe) return;
        clearTimeout(playTimer.current);
        scrollActions.pause();
    }, [
        iframeState.isHoveringIframe
    ]);
    // useEffect(() => {
    //   if (liveScrollSquiggle.length > 0) {
    //     const lastLiveItem = liveScrollSquiggle[liveScrollSquiggle.length - 1];
    //     const lastItem = scrollSquiggle[scrollSquiggle.length - 1];
    //     if (lastLiveItem.x > lastItem.x) {
    //       scrollSquiggle.push({ x: lastLiveItem.x, y: lastItem.y, dummy: true });
    //     }
    //   }
    // }, [liveScrollSquiggle]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                w: "100%",
                pb: 6,
                pt: 4,
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                        textStyle: {
                            fontSize: "3xl",
                            fontWeight: "medium"
                        },
                        onEdit: (value)=>setAnnotation("title", value),
                        isLoading: annotationsLoading,
                        value: annotations?.title,
                        showEditControls: userInfo?.loggedIn
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                        showEditControls: userInfo?.loggedIn,
                        textStyle: {
                            fontSize: "sm",
                            maxWidth: "600px"
                        },
                        onEdit: (value)=>setAnnotation("description", value),
                        value: annotations?.description,
                        isLoading: annotationsLoading,
                        fieldType: "textarea"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                justifyContent: "flex-start",
                w: "100%",
                h: "100%",
                alignItems: "stretch",
                gap: "6",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        borderRadius: "md",
                        w: "100%",
                        maxW: "40%",
                        overflow: "hidden",
                        h: "100%",
                        border: "1px solid",
                        borderColor: "gray.200",
                        pos: "relative",
                        ref: parentRef,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6abc2b8c265253b0$var$TopGradient, {}),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e110900b167a1ef9$export$2e2bcd8739ae039), {
                                pressure: sessionPressure,
                                averagePressure: averagePressure,
                                avgScrollDistance: avgScrollDistance,
                                scrollDistance: scrollDistance
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6abc2b8c265253b0$var$BottomGradient, {}),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6abc2b8c265253b0$var$StatHStack, {
                                opacity: sessionPressure > 0 ? 1 : 0,
                                pb: "7",
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Velocity",
                                    value: sessionPressure,
                                    animate: false
                                })
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6abc2b8c265253b0$var$StatHStack, {
                                opacity: sessionPressure > 0 ? 0 : 1,
                                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                    title: "Av Velocity",
                                    value: averagePressure,
                                    benchmark: averagePressure * 0.86
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        w: "100%",
                        h: "100%",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                                w: "100%",
                                h: "100%",
                                pos: "relative",
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6abc2b8c265253b0$var$LiveScrubChart, {
                                        liveScrollSquiggle: liveScrollSquiggle,
                                        scrollSquiggle: scrollSquiggle,
                                        avgScrollDistance: avgScrollDistance,
                                        avgScrollDistanceBenchmark: avgScrollDistance * 0.95
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6abc2b8c265253b0$var$StatHStack, {
                                        opacity: sessionPressure > 0 ? 1 : 0,
                                        pb: "7",
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                            title: "Distance",
                                            value: scrollDistance,
                                            animate: false,
                                            unit: "px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6abc2b8c265253b0$var$StatHStack, {
                                        opacity: sessionPressure > 0 ? 0 : 1,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $54ad8e9c745aa669$export$4ef99c76cb70f09f), {
                                            title: "Av Scroll Distance",
                                            value: avgScrollDistance,
                                            unit: "px",
                                            benchmark: avgScrollDistance * 0.95
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                                showEditControls: userInfo?.loggedIn,
                                textStyle: {
                                    fontSize: "sm",
                                    pl: 2
                                },
                                onEdit: (value)=>setAnnotation("description", value),
                                value: annotations?.description,
                                isLoading: annotationsLoading
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aabe32da29ab7737$export$f54a093675066994).Velocity, {})
                        ]
                    })
                ]
            })
        ]
    });
};
const $6abc2b8c265253b0$var$TopGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-b, whiteAlpha.500, transparent)"
    });
const $6abc2b8c265253b0$var$BottomGradient = ()=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        pos: "absolute",
        bottom: 0,
        right: 0,
        h: "30%",
        w: "100%",
        bgGradient: "linear(to-t, whiteAlpha.500, transparent)"
    });
const $6abc2b8c265253b0$var$StatHStack = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        pos: "absolute",
        bottom: 4,
        left: 6,
        transition: "opacity 0.7s ease",
        w: "100%",
        gap: 1,
        ...rest,
        children: children
    });
const $6abc2b8c265253b0$var$LiveScrubChart = ({ scrollSquiggle: scrollSquiggle, liveScrollSquiggle: liveScrollSquiggle, avgScrollDistance: avgScrollDistance, avgScrollDistanceBenchmark: avgScrollDistanceBenchmark })=>{
    console.log("liveScrollSquiggle", liveScrollSquiggle);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
        aspect: 5 / 3,
        maxHeight: 300,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $ad7331bbe400fed9$export$54d0e8420ac838ac), {
            margin: {
                bottom: -10
            },
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                    strokeDasharray: "3 3"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                    dataKey: "x",
                    type: "number",
                    interval: "preserveStart",
                    domain: [
                        "dataMin",
                        "dataMax"
                    ],
                    fontSize: "0.8rem",
                    unit: "px",
                    minTickGap: 125,
                    stroke: "#C7C7C7",
                    label: {
                        fill: "#C7C7C7"
                    }
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                    dataKey: "y",
                    hide: true,
                    domain: [
                        (dataMin)=>dataMin * 3,
                        (dataMax)=>dataMax * 3
                    ]
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cd596fa7fc5c5a32$export$17d680238e50603e), {
                    data: scrollSquiggle,
                    strokeWidth: 2,
                    dot: false,
                    opacity: liveScrollSquiggle.length > 0 ? 0.2 : 1,
                    animationDuration: 0.5,
                    type: "monotone",
                    dataKey: "y",
                    stroke: "#8884d8"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cd596fa7fc5c5a32$export$17d680238e50603e), {
                    data: liveScrollSquiggle,
                    strokeWidth: 2,
                    dot: false,
                    type: "monotone",
                    dataKey: "y",
                    stroke: "#8884d8"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                    x: avgScrollDistance,
                    stroke: "#00BA77",
                    animationDuration: 4,
                    label: {
                        value: "Av. Scroll Distance",
                        transform: "translate(0, 5)",
                        fill: "#00BA77",
                        ...$6abc2b8c265253b0$var$refLineStyle
                    }
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                    x: avgScrollDistanceBenchmark,
                    stroke: "#C7C7C7",
                    animationDuration: 4,
                    label: {
                        value: "Benchmark*",
                        transform: "translate(0, 25)",
                        fill: "#C7C7C7",
                        ...$6abc2b8c265253b0$var$refLineStyle
                    }
                })
            ]
        })
    });
};
const $6abc2b8c265253b0$var$refLineStyle = {
    fontFamily: "roboto mono, monospace",
    fontSize: "0.8rem",
    position: "insideTopRight"
};









var $lDSNw = parcelRequire("lDSNw");





const $a5325818beeb4fd7$export$797dc5e45774be29 = `We track user scrolling behavior while your creative is displayed. Rapid scrolling down, up, and back down is logged. Multiple instances indicate engagement with the creative’s velocity scrub effects (excluding anomalies like earthquakes or screen cleaning – we analyze over 5000 sessions for precision). Normal article scrolling is disregarded. 

All recorded sessions are averaged into the chart above, with a few raw sessions for reference. This shows how users engaged with your ad’s elements during animation, and whether the animation captured their interest.`;



const $6f7cbaff9826524b$export$dbb4751eaa62ba7d = ({ rechartsData: rechartsData, mainFrameRef: mainFrameRef, buildId: buildId, iframeState: iframeState })=>{
    const { scrollSquiggle: scrollSquiggle, scrollSquiggleBenchmark: scrollSquiggleBenchmark, scrollSquiggleLength: scrollSquiggleLength, scrollSquiggleWithBenchmarkLength: scrollSquiggleWithBenchmarkLength } = rechartsData;
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const playTimer = (0, $lDSNw.useRef)(null);
    const { scrollStatus: scrollStatus, scrollActions: scrollActions, currentProgress: currentProgress, currentY: currentY } = (0, $2fa1e6752e8574e8$export$ff0acae64d99fa5c)(mainFrameRef);
    const { liveScrollSquiggle: liveScrollSquiggle = [] } = (0, $379be3281ad335a2$export$2e2bcd8739ae039)(currentY);
    const { annotations: annotations, setAnnotation: setAnnotation, loading: annotationsLoading } = (0, $a7fb1b2a3b6f3dc3$export$902d4c991a42811e)({
        buildId: buildId,
        format: "velocity"
    });
    const runSetup = ()=>{
        // sets up listener in the useAdScrollState hook
        // to pass through y position
        scrollActions.loadIFrame();
        const scrollConfig = {
            // initalY: 3000, //inital scroll position.
            durationScale: 2,
            scrollLengthScale: 0.25,
            // delayDurationScale: 2,
            minDuration: 0,
            maxDuration: 4000
        };
        const scrollQueue = (0, $5cabf5fab4ef129f$export$671214622682cb48)(scrollSquiggle, scrollConfig);
        scrollActions.loadQueue(scrollQueue);
        playTimer.current = setTimeout(()=>{
            scrollActions.play();
        }, 1500);
    };
    (0, $lDSNw.useEffect)(()=>{
        if (iframeState.iframeLoaded) runSetup();
        return ()=>{
            clearTimeout(playTimer.current);
        };
    }, [
        iframeState.iframeLoaded
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!iframeState.isHoveringIframe) return;
        clearTimeout(playTimer.current);
        scrollActions.pause();
    }, [
        iframeState.isHoveringIframe
    ]);
    // if playing timeline, don't show live scroll squiggle
    // else show the live scroll squiggle IF there is one
    const lineValue = scrollStatus.playing ? scrollSquiggle : liveScrollSquiggle || scrollSquiggle;
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
            w: "100%",
            alignItems: "stretch",
            pt: "3%",
            spacing: 6,
            maxW: "750px",
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                w: "100%",
                h: "100%",
                gap: "5",
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                        pos: "relative",
                        w: "100%",
                        h: "100%",
                        border: "1px solid",
                        borderColor: "gray.200",
                        borderRadius: "md",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                w: "100%",
                                h: "100%",
                                pos: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                                        aspect: 5 / 3,
                                        maxHeight: 300,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $ad7331bbe400fed9$export$54d0e8420ac838ac), {
                                            data: scrollSquiggle,
                                            children: [
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                                                    strokeDasharray: "1 3"
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                                                    dataKey: "x",
                                                    hide: true,
                                                    type: "number",
                                                    interval: "preserveEnd",
                                                    domain: [
                                                        "dataMin",
                                                        "dataMax"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                                                    dataKey: "y",
                                                    hide: true,
                                                    domain: [
                                                        (dataMin)=>dataMin * 2,
                                                        (dataMax)=>dataMax * 2
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cd596fa7fc5c5a32$export$17d680238e50603e), {
                                                    strokeWidth: 1,
                                                    dot: false,
                                                    type: "monotone",
                                                    data: scrollSquiggleBenchmark,
                                                    dataKey: "y",
                                                    stroke: "#C7C7C7"
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cd596fa7fc5c5a32$export$17d680238e50603e), {
                                                    strokeWidth: 1,
                                                    dot: false,
                                                    type: "monotone",
                                                    stroke: "#00BA77",
                                                    data: lineValue,
                                                    dataKey: "y"
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                                                    x: scrollSquiggleLength,
                                                    stroke: "#00BA77",
                                                    animationDuration: 4,
                                                    label: {
                                                        value: "This creative",
                                                        transform: "translate(0, 5)",
                                                        fill: "#00BA77",
                                                        ...$6f7cbaff9826524b$var$refLineStyle
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $a603384991ab9807$export$b2f28e248e7838eb), {
                                                    x: scrollSquiggleWithBenchmarkLength,
                                                    stroke: "#C7C7C7",
                                                    animationDuration: 4,
                                                    label: {
                                                        value: "Benchmark*",
                                                        transform: "translate(0, 25)",
                                                        fill: "#C7C7C7",
                                                        ...$6f7cbaff9826524b$var$refLineStyle
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d1052c328993fb55$export$2c80b568c03b30a9), {
                                        currentProgress: currentProgress,
                                        playFromPercent: scrollActions.playFromPercent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                                w: "100%",
                                pos: "relative",
                                h: "32px",
                                borderRadius: " 0 0 6px 6px",
                                overflow: "hidden",
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d1052c328993fb55$export$2c80b568c03b30a9), {
                                        currentProgress: currentProgress,
                                        playFromPercent: scrollActions.playFromPercent,
                                        sliderTrackStyle: {
                                            bg: "gray.200",
                                            opacity: 0.6
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                                        pos: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($6f7cbaff9826524b$var$PlayButton, {
                                            scrollStatus: scrollStatus,
                                            scrollActions: scrollActions
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                        w: "100%",
                        pb: 6,
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $820a2ba43b88e8a8$export$1c673afd5aa0b669), {
                                showEditControls: userInfo?.loggedIn,
                                textStyle: {
                                    fontSize: "md",
                                    pl: 1,
                                    pr: 18,
                                    color: annotations?.description ? "black" : "gray.500"
                                },
                                inputStyle: {
                                    minHeight: "130px"
                                },
                                fieldType: "textarea",
                                onEdit: (value)=>setAnnotation("description", value),
                                value: annotations?.description || (0, $a5325818beeb4fd7$export$797dc5e45774be29),
                                isLoading: annotationsLoading
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aabe32da29ab7737$export$f54a093675066994).Velocity, {})
                        ]
                    })
                ]
            })
        })
    });
};
const $6f7cbaff9826524b$var$PlayButton = ({ scrollStatus: scrollStatus, scrollActions: scrollActions })=>{
    const showPlayButton = !scrollStatus.playing;
    const showRestartButton = scrollStatus.currentMovementIndex === scrollStatus.scrollQueue.length;
    if (showRestartButton) return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
        size: "sm",
        borderRadius: 0,
        backgroundColor: "gray.200",
        icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$7cb7bf01cf98523), {}),
        onClick: ()=>scrollActions.playFromPercent(0)
    });
    if (showPlayButton) return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
        size: "sm",
        borderRadius: 0,
        backgroundColor: "gray.200",
        icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$7cb7bf01cf98523), {}),
        onClick: ()=>scrollActions.resume()
    });
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $afaf87b4b67d333c$export$c25acd513dcc8062), {
        size: "sm",
        borderRadius: 0,
        backgroundColor: "gray.100",
        icon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f59ac49c6e1fede1$export$816d9082b987955a), {}),
        onClick: ()=>scrollActions.pause()
    });
};
const $6f7cbaff9826524b$var$refLineStyle = {
    fontFamily: "roboto mono, monospace",
    fontSize: "0.8rem",
    position: "insideTopRight"
};


const $082061eefb4d7689$export$2df69ed760041572 = ({ rechartsData: rechartsData, iframeSrcDoc: iframeSrcDoc, buildId: buildId })=>{
    const mainFrameRef = (0, $lDSNw.useRef)(null);
    const [demoTabIdx, setDemoTabIdx] = (0, $lDSNw.useState)(0);
    const [iframeLoaded, setIframeLoaded] = (0, $lDSNw.useState)(false);
    const [isHoveringIframe, setIsHoveringIframe] = (0, $lDSNw.useState)(false);
    const iframeState = {
        iframeLoaded: iframeLoaded,
        isHoveringIframe: isHoveringIframe
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
        width: "100%",
        height: "calc(100vh - 50px)",
        pt: "50px",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ed9d7c0ede8e1182$export$82431628d8b8c126), {
                title: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                    spacing: 4,
                    w: "100%",
                    alignItems: "center",
                    color: "gray.600",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                            as: "span",
                            color: "gray.600",
                            children: "Velocity Prototype:"
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6a502e7cb1933381$export$b2539bed5023c21c), {
                            isLazy: true,
                            index: demoTabIdx,
                            onChange: setDemoTabIdx,
                            variant: "soft-rounded",
                            colorScheme: "gray",
                            size: "sm",
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5195078522b2fc7e$export$e51a686c67fdaa2d), {
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $60ff4a7bee9d5c20$export$3e41faf802a29e71), {
                                        children: "Simple Scrub"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $60ff4a7bee9d5c20$export$3e41faf802a29e71), {
                                        children: "Simple Gauge"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $60ff4a7bee9d5c20$export$3e41faf802a29e71), {
                                        children: "Gauge and Distance"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $60ff4a7bee9d5c20$export$3e41faf802a29e71), {
                                        children: "Gauge and Scroll Chart"
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $60ff4a7bee9d5c20$export$3e41faf802a29e71), {
                                        children: "Gauge with Live Scribble"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                maxWidth: "var(--maxScreenWidth)",
                width: "100%",
                height: "100%",
                align: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d8c48a7438123691$export$110709f040143804), {
                        children: iframeSrcDoc && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ed548c58496df3ce$export$378d088832c92c75), {
                            srcDoc: iframeSrcDoc,
                            onIframeLoad: ()=>setIframeLoaded(true),
                            mainFrameRef: mainFrameRef,
                            onMouseEnter: ()=>setIsHoveringIframe(true),
                            onMouseLeave: ()=>setIsHoveringIframe(false)
                        })
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d8c48a7438123691$export$364a989a35814102), {
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6a502e7cb1933381$export$b2539bed5023c21c), {
                            index: demoTabIdx,
                            isLazy: true,
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $9be6ee0d259ba9e2$export$5dae8d435677f210), {
                                children: [
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1523771cacfd3c91$export$3d96ec278d3efce4), {
                                        as: (0, $2603e0709778e5bc$export$e6c02a6dccfa2120),
                                        spacing: 4,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6f7cbaff9826524b$export$dbb4751eaa62ba7d), {
                                            rechartsData: rechartsData,
                                            buildId: buildId,
                                            mainFrameRef: mainFrameRef,
                                            iframeState: iframeState
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1523771cacfd3c91$export$3d96ec278d3efce4), {
                                        as: (0, $2603e0709778e5bc$export$e6c02a6dccfa2120),
                                        spacing: 1,
                                        w: "100%",
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aaeb35c295b0f8f6$export$2952cdcf45ac5d44), {
                                            rechartsData: rechartsData,
                                            iframeState: iframeState,
                                            buildId: buildId,
                                            mainFrameRef: mainFrameRef
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1523771cacfd3c91$export$3d96ec278d3efce4), {
                                        as: (0, $aa57447b0555e960$export$f51f4c4ede09e011),
                                        direction: "column",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0211b21c941da8b7$export$4e8cf45f820f4937), {
                                            mainFrameRef: mainFrameRef,
                                            rechartsData: rechartsData,
                                            iframeState: iframeState,
                                            buildId: buildId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1523771cacfd3c91$export$3d96ec278d3efce4), {
                                        as: (0, $2603e0709778e5bc$export$e6c02a6dccfa2120),
                                        spacing: 4,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $777cc3ba08e35d18$export$f92f4a2a01389f68), {
                                            rechartsData: rechartsData,
                                            buildId: buildId,
                                            mainFrameRef: mainFrameRef,
                                            iframeState: iframeState
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1523771cacfd3c91$export$3d96ec278d3efce4), {
                                        as: (0, $2603e0709778e5bc$export$e6c02a6dccfa2120),
                                        spacing: 4,
                                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6abc2b8c265253b0$export$d1d86185404df7c2), {
                                            rechartsData: rechartsData,
                                            buildId: buildId,
                                            mainFrameRef: mainFrameRef,
                                            iframeState: iframeState
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $082061eefb4d7689$var$PressureChart = ({ data: data, scrollStatus: scrollStatus, scrollActions: scrollActions })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e800b0e3b29b4f13$exports.Fragment), {
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
            position: "relative",
            w: "100%",
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $023ad977e9872439$export$e60a4704009a0009), {
                    width: "100%",
                    aspect: 5 / 3,
                    maxHeight: 300,
                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $ad7331bbe400fed9$export$54d0e8420ac838ac), {
                        data: data,
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4dcb9526aae227cc$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $15dd4d13ef92156e$export$ea77231de273b52d), {
                                dataKey: "accumulatedTime",
                                hide: true,
                                type: "number",
                                interval: "preserveStart",
                                domain: [
                                    "dataMin",
                                    "dataMax"
                                ]
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $43d5f89303df56d7$export$f96c4024c52de8f4), {
                                dataKey: "pressure",
                                hide: true
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $cd596fa7fc5c5a32$export$17d680238e50603e), {
                                strokeWidth: 2,
                                dot: false,
                                type: "monotone",
                                dataKey: "pressure",
                                stroke: "#8884d8"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $0c7e57679d2cb40c$export$472062a354075cee), {
                    position: "absolute!important",
                    focusThumbOnChange: false,
                    overflow: "hidden",
                    top: "0",
                    display: "flex",
                    alignItems: "flex-end",
                    h: "100%",
                    value: scrollStatus.currentProgress / 100 * 100,
                    onChange: (value)=>{
                        scrollActions.playFromPercent(value);
                    },
                    colorScheme: "blackAlpha",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$105594979f116971), {
                            bottom: "0",
                            bg: "none",
                            h: "100%",
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$73137d74280e0c3e), {
                                bg: "teal.100",
                                opacity: 0.1,
                                style: {
                                    boxShadow: "1px 0 10px 0px teal"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $0c7e57679d2cb40c$export$2c1b491743890dec), {
                            h: "100%",
                            w: "3px",
                            bg: "teal.200"
                        })
                    ]
                }, "scroll-slider")
            ]
        })
    });
};



var $lDSNw = parcelRequire("lDSNw");



var $lDSNw = parcelRequire("lDSNw");



const $603fcfa8751b62c0$export$a09617fd98a7c9b4 = (id)=>{
    const [fetchedIds, setFetchedIds] = (0, $lDSNw.useState)({});
    (0, $lDSNw.useEffect)(()=>{
        if (id && !fetchedIds[id]) {
            $603fcfa8751b62c0$var$getData(id).then((data)=>{
                if (!data) return;
                const { totalSessions: totalSessions, avgScrollDistance: avgScrollDistance, avgPressure: avgPressure, avgScrollSquiggle: avgScrollSquiggle, avgPressureSequence: avgPressureSequence, scrollSquiggleBenchmark: scrollSquiggleBenchmark } = data;
                setFetchedIds((prev)=>({
                        ...prev,
                        [id]: {
                            totalSessions: totalSessions,
                            scrollSquiggleBenchmark: scrollSquiggleBenchmark,
                            scrollSquiggleWithBenchmarkLength: $603fcfa8751b62c0$var$getScrollLength(scrollSquiggleBenchmark),
                            scrollSquiggleLength: $603fcfa8751b62c0$var$getScrollLength(avgScrollSquiggle),
                            sessionPressure: avgPressureSequence,
                            averagePressure: avgPressure,
                            avgScrollDistance: avgScrollDistance,
                            scrollSquiggle: avgScrollSquiggle
                        }
                    }));
            });
            return;
        }
    }, [
        id,
        fetchedIds
    ]);
    return fetchedIds[id];
};
async function $603fcfa8751b62c0$var$getData(id) {
    const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("Velocity").doc("beta").collection("v1").doc(id);
    const buildDataSnap = await dataRef.get();
    if (!buildDataSnap.exists) {
        console.error("No data found for build", id);
        return null;
    }
    const buildData = buildDataSnap.data();
    if (!buildData.avgScrollSquiggle) {
        console.error("No averageScrollSquiggle data found for build", id);
        return null;
    }
    // fetch benchmark data
    const benchmarkRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("Velocity").doc("beta");
    const benchmarkDataSnap = await benchmarkRef.get();
    const benchmarkData = benchmarkDataSnap.data();
    return {
        ...buildData,
        ...benchmarkData
    };
}
// Can be used in debugging and testing to access the raw sessions
// of a build rather than the aggregated data. Swap out for getData above!
async function $603fcfa8751b62c0$var$getDataAsRawSessions(id, limit = 100) {
    const dataRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("Velocity").doc("beta").collection("v1").doc(id).collection("entries").limit(limit);
    const buildDataSnap = await dataRef.get();
    const buildData = buildDataSnap.docs.map((doc)=>doc.data().data);
    const scrolls = buildData.map((doc)=>(0, $e042f9da040d1e0c$exports.processScrollDataWithTime)(doc));
    console.log("scrolls", scrolls);
    // get the average scroll distance for the build
    const avgScrollDistance = (0, $e042f9da040d1e0c$exports.getAverageScrollDistance)(scrolls);
    const aggregatedData = scrolls.map((session)=>{
        // each session has scrolls that may have sequences in the same direction, we
        // need to aggregate these sequences into one value/object in the array to
        // represent each direction movement
        return (0, $e042f9da040d1e0c$exports.aggregateByDirection)(session);
    });
    // calculate velocity and pressure data
    const velocityData = (0, $e042f9da040d1e0c$exports.addVelocity)(aggregatedData);
    const averageVelocityData = (0, $e042f9da040d1e0c$exports.combineVelocitySessions)(velocityData);
    const sessionPressure = (0, $e042f9da040d1e0c$exports.calculateRollingPressure)(averageVelocityData);
    // calculate the average pressure for the build
    const averagePressure = (0, $d8719f0214228429$export$fe43042dbe18fdfb)(scrolls.reduce((acc, session)=>{
        const incomingPressureSequence = (0, $e042f9da040d1e0c$exports.getSingleSessionPressures)(session);
        if (!incomingPressureSequence.length) {
            console.error("No pressure data found in the session");
            return acc;
        }
        const sessionPressure = (0, $e042f9da040d1e0c$exports.getAveragePressure)(incomingPressureSequence);
        acc.push(sessionPressure);
        return acc;
    }, []));
    // mimicking the aggregation of scroll squiggles that happens in the cloud function
    let totalSessions = 0;
    let averageScrollSquiggle = [];
    for(let i = 0; i < scrolls.length; i++){
        const scrollSession = scrolls[i];
        totalSessions++;
        const scrollSquiggle = (0, $e042f9da040d1e0c$exports.prepareScrollSquiggleChartData)([
            scrollSession
        ]);
        const newAverageScrollSquiggle = (0, $9b62cfaad7f54fdc$exports.aggregateScrollSquiggle)({
            avgScrollSquiggle: averageScrollSquiggle,
            incomingScrollSquiggle: scrollSquiggle,
            totalSessions: totalSessions
        });
        averageScrollSquiggle = newAverageScrollSquiggle;
    }
    // fetch benchmark data
    const benchmarkRef = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).firestore().collection("Velocity").doc("beta");
    const benchmarkDataSnap = await benchmarkRef.get();
    const benchmarkData = benchmarkDataSnap.data();
    return {
        ...benchmarkData,
        totalSessions: totalSessions,
        avgScrollDistance: avgScrollDistance,
        sessionPressure: sessionPressure,
        avgPressure: averagePressure,
        avgScrollSquiggle: averageScrollSquiggle
    };
}
// -----------------------------------------------------------------------------------------
const $603fcfa8751b62c0$var$calculateTempBenchmark = (scrollSquiggle)=>{
    // Iterate over the new data array to adjust 'y' values
    return scrollSquiggle.map((point, index)=>{
        const randomAdjustment = Math.random(); // Generate a random number for probability
        let newY;
        if (randomAdjustment < 0.7) {
            // Decrease 'y' by 10-50%
            const decreasePercentage = 0.3 + (0.4 - 0.6) * Math.random();
            newY = point.y * (1 - decreasePercentage);
        } else if (randomAdjustment >= 0.7 && randomAdjustment < 0.8) // Keep 'y' the same
        newY = point.y;
        else // Increase 'y' by ~5%
        newY = point.y * 1.1;
        return {
            x: point.x,
            y: newY
        };
    });
};
//
// getScrollLength
// for the benchmark lines
// This needs a sanity check
// not calculating the average scroll length here, we're hoping that the returned scroll squiggle data is averaged out in a way where
// it's length is the average scroll length or at least the point at which we stop getting non outlier data
// we find the last non zero y value
// we then jump forward one index and return the x value of that index
// why jump forward one index? because the line on the chart has easing, and it's at this next index point
// where the line returns back to the middle, so thats where the benchmark line looks like it's finished
function $603fcfa8751b62c0$var$getScrollLength(data) {
    let lastIndexWithNonZeroY = -1;
    // Iterate over the data to find the last index with non-zero y
    for(let i = 0; i < data.length; i++)if (data[i].y !== 0) lastIndexWithNonZeroY = i;
    // Check if there is a next object
    if (lastIndexWithNonZeroY !== -1 && lastIndexWithNonZeroY + 1 < data.length) return data[lastIndexWithNonZeroY + 1].x;
    // if there is no next object, return the value of the last object
    if (lastIndexWithNonZeroY !== -1) return data[lastIndexWithNonZeroY].x;
    // If no suitable object is found, return the last x value
    return data[data.length - 1].x;
}


const $d19e3c6af46a3027$export$33b53cb4c9648603 = (0, $5058ffe240ffde31$export$369b6b2b30582e8e)(({ match: { params: { buildID: buildID } } })=>{
    const velocityTestData = (0, $603fcfa8751b62c0$export$a09617fd98a7c9b4)(buildID) || [];
    const isLoading = false;
    const [creativeID] = buildID.split("-v");
    const [iframeSrcDoc, setIframeSrcDoc] = (0, $lDSNw.useState)(null);
    (0, $lDSNw.useEffect)(()=>{
        if (creativeID && !iframeSrcDoc) try {
            (0, $9d599987579e8430$export$4e70f71bf0757296)(creativeID).then((srcDoc)=>{
                setIframeSrcDoc(srcDoc);
            });
        // fetchMetas(creativeID).then((meta) => {
        //   console.log("meta", meta);
        // }); <- doesn't seem to work as we don't have what it expects for velocity yet
        } catch (error) {
            console.error(error);
        }
    }, [
        creativeID
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        height: "100%",
        direction: "column",
        w: "100%",
        children: isLoading ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
            mt: "50px",
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6d34caa3f6c24444$export$e854a2165401836f), {})
        }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $082061eefb4d7689$export$2df69ed760041572), {
            rechartsData: velocityTestData,
            iframeSrcDoc: iframeSrcDoc,
            buildId: buildID
        })
    });
});



const $f06663add05bf783$export$9b5ac10f59f76296 = {
    // overwrite the tab component so that text stays on one line
    Button: {
        baseStyle: {
            fontWeight: "medium"
        }
    },
    Input: {
        baseStyle: {
            fontWeight: "medium",
            borderRadius: "md",
            borderColor: "border-default-muted",
            _hover: {
                borderColor: "border-default"
            },
            _focus: {
                borderColor: "border-default-focus"
            }
        }
    },
    Select: {
        baseStyle: {
            fontWeight: "medium",
            borderRadius: "md",
            borderColor: "border-default-muted",
            _hover: {
                borderColor: "border-default"
            },
            _focus: {
                borderColor: "border-default-focus"
            }
        }
    },
    Tabs: {
        baseStyle: {
            tab: {
                textOverflow: "ellipsis",
                // stop tabs from wrapping
                whiteSpace: "nowrap",
                // which is never what we want
                fontWeight: "medium"
            }
        }
    }
};



const $2958027e26205d9e$export$8f45430ccf837300 = {
    // ----------------------------------
    // BRAND COLORS
    // Note - if you're making updates to contextualGreen, creativeBlue, deepBlue, or pxyzPink,
    // you should also update the overwrites below.
    //🟩
    // contextual green overwrites the default chakra green
    green: {
        50: "#E8FFF6",
        100: "#A4FFDB",
        200: "#5AFFBD",
        300: "#2FF3A5",
        400: "#00CE7C",
        //main
        500: "#00B76E",
        600: "#00965B",
        700: "#007748",
        800: "#00643C",
        900: "#005231"
    },
    //🟦
    // creative blue overwrites the default chakra cyan
    cyan: {
        50: "#ECFBFF",
        100: "#B5EFFF",
        200: "#7CE2FD",
        //main
        300: "#4AC1E0",
        400: "#3DAAC7",
        500: "#2E94AF",
        600: "#1E7C95",
        700: "#0F657C",
        800: "#05586E",
        900: "#004A5D"
    },
    //⬛️
    // deep blue overwrites the default chakra blue
    blue: {
        50: "#EDFAFF",
        100: "#C1EBFB",
        200: "#A7D1E1",
        300: "#8AB4C4",
        400: "#6E98A8",
        500: "#507A8A",
        600: "#366070",
        700: "#214B5B",
        800: "#163B48",
        900: "#002A3A" //main
    },
    // 👛
    // pxyz pink overwrites the default chakra pink
    pink: {
        50: "#FFF3F6",
        100: "#FFD0DC",
        200: "#FFABC0",
        300: "#FF7EA0",
        400: "#FF5581",
        500: "#E93362",
        //main
        600: "#D12D57",
        700: "#BA1A44",
        800: "#AC0E37",
        900: "#9F022B"
    },
    // ------------------------------------------
    // Adding additional greys to the chakra grey
    //   since we use .grey50 as the bg color in light mode, needed to add more granularity in dark mode
    //   otherwise there was a large jump in contrast from 800 to 900
    gray: {
        ...(0, $823d38277d136a79$export$bca14c5b3b88a9c9).colors.gray,
        850: "#191E29",
        950: "#171920"
    }
};


// Global styles that are applied to the entire app through the chakra theme
// https://chakra-ui.com/docs/theming/theme
const $3ae69d2670979fc8$export$9dd6ff9ea0189349 = {
    global: {
        "html, body": {
            fontFamily: "Mulish, sans-serif",
            color: "text-default",
            bg: "bg-default",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "text-default-placeholder"
        },
        "*, *::before, &::after": {
            borderColor: "border-default",
            wordWrap: "break-word"
        }
    }
};


const $838f53170a809da5$export$e41b8ed6facb449f = (0, $25860983085fed1c$export$33a2b855d5b8731e)({
    colors: // ----------------------------------
    // 🎨 COLORS
    $2958027e26205d9e$export$8f45430ccf837300,
    // ----------------------------------
    // Conditional tokens - mostly used for color switching
    // https://chakra-ui.com/docs/styled-system/semantic-tokens
    // copied from https://github.com/chakra-ui/chakra-ui/blob/main/website/theme.ts
    semanticTokens: {
        colors: {
            // --------------------------------------------------
            // NEW
            // Text default tokens that change with color mode
            "text-default": {
                default: "gray.600",
                _dark: "gray.300"
            },
            "text-default-muted": {
                default: "gray.500",
                _dark: "gray.400"
            },
            "text-default-subtle": {
                default: "gray.400",
                _dark: "gray.500"
            },
            "text-default-placeholder": {
                default: "gray.400",
                _dark: "gray.500"
            },
            "text-default-accent": {
                default: "green.500",
                _dark: "green.300"
            },
            "text-strong": {
                default: "gray.800",
                _dark: "gray.100"
            },
            // BG default tokens that change with color mode
            "bg-default": {
                default: "white",
                _dark: "gray.900"
            },
            "bg-default-lv2": {
                default: "gray.50",
                _dark: "gray.850"
            },
            "bg-default-lv3": {
                default: "gray.100",
                _dark: "gray.800"
            },
            "bg-default-lv4": {
                default: "gray.200",
                _dark: "gray.700"
            },
            // Border default tokens that change with color mode
            "border-default": {
                default: "gray.400",
                _dark: "gray.600"
            },
            "border-default-muted": {
                default: "gray.200",
                _dark: "gray.700"
            },
            "border-default-subtle": {
                default: "gray.100",
                _dark: "gray.800"
            },
            "border-default-focus": {
                default: "green.500",
                _dark: "green.300"
            }
        }
    },
    // ----------------------------------
    // 🔠 FONTS
    fonts: {
        heading: `'Mulish', sans-serif`,
        body: `'Mulish', sans-serif`
    },
    components: // ----------------------------------
    // 📐 ADDING VARIATIONS TO CHAKRA COMPONENTS
    $f06663add05bf783$export$9b5ac10f59f76296,
    styles: // ----------------------------------
    //  MISC GLOBAL CSS STYLES
    $3ae69d2670979fc8$export$9dd6ff9ea0189349
});








"use client";
var $fe0178c31f6bf101$export$f7dc499a72baa103 = (0, $c101c0301221342e$export$274edc73af1ae9c8)({
    d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z",
    displayName: "WarningIcon"
});







const $11cbf6547623ee9f$export$b1bf61df9821ca0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $34f549143475a073$export$15e411dc07b9c834), {
        w: "100%",
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
            fontWeight: "400",
            fontSize: "xs",
            noOfLines: 1,
            color: "text-default-muted",
            children: children
        })
    });
};


const $18241cbe551e2043$export$f26c6e0ae7e86bee = {
    w: "100%",
    h: "auto",
    pl: {
        base: 1.5,
        md: 2
    },
    pr: {
        base: 1.5,
        md: 2
    },
    pt: {
        base: 1,
        md: 1.5
    },
    pb: {
        base: 0,
        md: 0.5
    },
    borderRadius: "md",
    spacing: 0
};


const $d28a2bdd7d2bf2b3$export$7e0b3af1e60a3273 = ({ children: children, title: title = "", secondRow: secondRow, isSelected: isSelected, tooltip: tooltip = true, color: color = "text-default", onClick: onClick, ...props })=>{
    const selectedBg = (0, $53a9951d8b44cf80$export$d18f2ef57b0d7644)("gray.200", "gray.700");
    const hoverColor = (0, $53a9951d8b44cf80$export$d18f2ef57b0d7644)("black", "white");
    const isClickable = Boolean(onClick);
    const showTooltip = tooltip !== false;
    const toolTipLabel = typeof tooltip === "string" ? tooltip : title;
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
        cursor: isClickable ? "pointer" : "default",
        onClick: onClick,
        ...(0, $18241cbe551e2043$export$f26c6e0ae7e86bee),
        ...isSelected && {
            bg: selectedBg
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                w: "100%",
                spacing: 1.5,
                children: [
                    props.lefticon,
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $55f5c4969dc36ab6$export$28c660c63b792dea), {
                        label: toolTipLabel,
                        placement: "right",
                        openDelay: 500,
                        isDisabled: !showTooltip,
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                            w: "100%",
                            fontWeight: "500",
                            fontSize: "sm",
                            noOfLines: 1,
                            wordBreak: "break-all",
                            color: color,
                            ...isClickable && {
                                _hover: {
                                    color: hoverColor
                                },
                                _groupHover: {
                                    color: hoverColor
                                }
                            },
                            children: title
                        })
                    }, title),
                    children,
                    props.righticon
                ]
            }),
            secondRow && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $11cbf6547623ee9f$export$b1bf61df9821ca0), {
                children: secondRow
            })
        ]
    });
};


const $c1fd71c50d10744b$export$e987c629098cbc7d = [
    {
        value: "All Formats",
        label: "All Formats"
    },
    {
        value: "Hang Time Mobile",
        label: "Hang Time Mobile"
    },
    {
        value: "Hang Time Mobile Video",
        label: "Hang Time Mobile Video"
    },
    {
        value: "Velocity",
        label: "Velocity"
    },
    {
        value: "Hang Time Desktop",
        label: "Hang Time Desktop"
    }
];
const $c1fd71c50d10744b$export$8049eeb4ac268de = 1000;
const $c1fd71c50d10744b$export$f021ead993eccd3a = 250;
const $c1fd71c50d10744b$export$800dbaa27f73c3f5 = {
    // add the id to the middle of the array
    // e.g. METABABY_IMAGE_URLS.hangtime[0] + id + METABABY_IMAGE_URLS.hangtime[1]
    hangtime: [
        "https://20230804t043942-dot-meta-baby.uc.r.appspot.com/",
        "/375x745/hang-time/filmstrip?&styles=[%22.content{opacity:0.3;}.page-style-article%20header{display:none;}%22]&scrollToElement.offset=-360&screenshotSize=20&scrollIncrement=50&customFileID=wrapdeck&regnerateMedia=true"
    ]
};




"use client";
var [$4f8e0e860215c7e7$export$f051b3a3c1998e0, $4f8e0e860215c7e7$export$7e0f545483b3a68c] = (0, $0ee78d01d64a4dc0$export$11d9f9905bcdc114)("Card");





"use client";
var $cf46332c905a7e0a$export$60332b2344f7fe41 = (0, $3064a344dac4d694$export$257a8862b851cb5b)(function Card2(props, ref) {
    const { className: className, children: children, direction: direction = "column", justify: justify, align: align, ...rest } = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Card", props);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-card", className),
        __css: {
            display: "flex",
            flexDirection: direction,
            justifyContent: justify,
            alignItems: align,
            position: "relative",
            minWidth: 0,
            wordWrap: "break-word",
            ...styles.container
        },
        ...rest,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $4f8e0e860215c7e7$export$f051b3a3c1998e0), {
            value: styles,
            children: children
        })
    });
});


parcelRequire("lDSNw");
const $580c646a730137d9$export$e621d7b0c460ecb0 = ({ key: key, onClick: onClick, children: children = null, thumbnailComponent: thumbnailComponent = /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $35745663698a221c$export$7f7cbe89f1eacd2), {}), topRightIcon: topRightIcon = null })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $cf46332c905a7e0a$export$60332b2344f7fe41), {
        cursor: onClick ? "pointer" : "default",
        onClick: onClick,
        w: "160px",
        h: "220px",
        ...$580c646a730137d9$var$cardStaticStyle,
        children: [
            topRightIcon,
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $596f68ba801b1475$export$1f54913ccc4368b1), {
                borderRadius: "8px 8px 0 0",
                transition: "all 0.2s ease",
                bg: "bg-default-lv3",
                h: "100%",
                maxH: "70%",
                overflow: "hidden",
                px: "3",
                py: "3",
                _groupHover: {
                    px: "2.5",
                    pt: "3.5"
                },
                children: thumbnailComponent
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                px: "1",
                py: "1.5",
                role: "group",
                w: "100%",
                children: children
            })
        ]
    }, key);
};
const $580c646a730137d9$var$cardStaticStyle = {
    boxShadow: "none",
    borderWidth: "1px",
    borderColor: "border-default-muted",
    backgroundColor: "bg-default",
    borderRadius: "8px",
    role: "group",
    _hover: {
        borderColor: "border-default-focus"
    }
};




const $592a228dfc22f6a1$var$filmstripAnimation = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)({
    "0%": {
        backgroundPosition: "0 0"
    },
    "40%": {
        backgroundPosition: "100% 0"
    },
    "50%": {
        backgroundPosition: "100% 0"
    },
    "90%": {
        backgroundPosition: "0 0"
    },
    "100%": {
        backgroundPosition: "0 0"
    }
});
const $592a228dfc22f6a1$export$c123e5e2a7aab46a = ({ filmstripUrl: filmstripUrl })=>{
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
        //
        w: "auto",
        h: "100%",
        minH: "100px",
        maxH: "100%",
        aspectRatio: "120/238",
        //
        bg: "gray.300",
        boxShadow: $592a228dfc22f6a1$var$imgLightBoxShadow,
        //
        borderRadius: "md",
        outline: "2px solid",
        outlineOffset: "-1px",
        outlineColor: "whiteAlpha.600",
        //
        bgImage: `url(${filmstripUrl})`,
        bgRepeat: "no-repeat",
        bgPosition: "0 0",
        bgSize: "auto 100%",
        //
        animation: `${$592a228dfc22f6a1$var$filmstripAnimation} 4s steps(19) infinite paused`,
        _groupHover: {
            animationPlayState: "running"
        }
    });
};
const $592a228dfc22f6a1$var$imgLightBoxShadow = "0px 15px 40px 0px rgba(18, 41, 64, 0.20), 0px 5px 10px 0px rgba(18, 41, 64, 0.10), 0px 0px 0px 1px rgba(18, 41, 64, 0.04), 0px 2px 0px 2px rgba(18, 41, 64, 0.05)";




var $lDSNw = parcelRequire("lDSNw");
var $e5c59f1e7d574bc4$exports = {};

$e5c59f1e7d574bc4$exports = new URL((parcelRequire("5V6iE")).resolve("jGDV8"), import.meta.url).toString();


function $7914f0fca7d41f85$export$6f0e152fdd9895bf({ isFavourited: isFavourited = false, handleClick: handleClick, handleFavouriteClick: handleFavouriteClick, creative: creative, ...rest }) {
    const { id: id, aggregatedSessionSize: aggregatedSessionSize, brand: brand, campaign: campaign, format: format, vertical: vertical, favCount: favCount } = creative;
    const mockPreviewImage = $7914f0fca7d41f85$var$getPreviewImageUrl(id, format);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $580c646a730137d9$export$e621d7b0c460ecb0), {
        topRightIcon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($7914f0fca7d41f85$var$FavoriteIcon, {
            isFavourited: isFavourited,
            favCount: favCount,
            onClick: handleFavouriteClick
        }),
        thumbnailComponent: mockPreviewImage ? /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $592a228dfc22f6a1$export$c123e5e2a7aab46a), {
            filmstripUrl: mockPreviewImage
        }) : /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c83c2faef81a6f1a$export$3e431a229df88919), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($e5c59f1e7d574bc4$exports))),
            alt: "placeholder",
            w: "100%",
            h: "100%"
        }),
        onClick: handleClick,
        ...rest,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $e800b0e3b29b4f13$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d28a2bdd7d2bf2b3$export$7e0b3af1e60a3273), {
                    title: campaign,
                    secondRow: brand,
                    righticon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($7914f0fca7d41f85$var$VideoIcon, {
                                containsVideo: creative.containsVideo
                            }),
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($7914f0fca7d41f85$var$SessionSizeWarningIcon, {
                                sessionSize: aggregatedSessionSize
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                    w: "100%",
                    color: "text-default-muted",
                    justifyContent: "space-between",
                    px: 2,
                    pb: 0.5,
                    gap: "0",
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                            fontSize: "xs",
                            noOfLines: 1,
                            textTransform: "capitalize",
                            color: "gray.500",
                            w: "100%",
                            children: vertical
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $34f549143475a073$export$15e411dc07b9c834), {
                            spacing: 1.5,
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "xs",
                                    textTransform: "uppercase",
                                    fontFamily: "mono",
                                    color: "gray.500",
                                    children: id
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                    fontSize: "xs",
                                    textTransform: "capitalize",
                                    fontWeight: "bold",
                                    color: "gray.400",
                                    fontFamily: "mono",
                                    children: $7914f0fca7d41f85$var$formatIcon[format] || "??"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $7914f0fca7d41f85$var$SessionSizeWarningIcon = ({ sessionSize: sessionSize })=>{
    if (sessionSize > (0, $c1fd71c50d10744b$export$8049eeb4ac268de)) return null;
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $55f5c4969dc36ab6$export$28c660c63b792dea), {
        label: `Not enough impressions to show a meaningful result yet. Check back later.`,
        borderRadius: 4,
        bg: "red.400",
        w: "180px",
        hasArrow: true,
        p: 3,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $fe0178c31f6bf101$export$f7dc499a72baa103), {
            boxSize: 3,
            color: "red.300",
            ml: 1
        })
    });
};
const $7914f0fca7d41f85$var$VideoIcon = ({ containsVideo: containsVideo })=>{
    if (!containsVideo) return null;
    // Needed to add an extra Box to wrap the Icon to fix the alignment and tooltip
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $55f5c4969dc36ab6$export$28c660c63b792dea), {
        label: `Creative contains video`,
        borderRadius: 4,
        bg: "text-default",
        hasArrow: true,
        p: 3,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
            boxSize: 3,
            ml: 1,
            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                as: (0, $f59ac49c6e1fede1$export$6a3f670868743012),
                boxSize: 3,
                color: "text-default"
            })
        })
    });
};
const $7914f0fca7d41f85$var$FavoriteIcon = ({ isFavourited: isFavourited, favCount: favCount, onClick: onClick })=>{
    const [loading, setLoading] = (0, $lDSNw.useState)(false);
    const handleClick = async (e)=>{
        e.stopPropagation();
        setLoading(true);
        await onClick(e);
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
        pl: "0.5",
        pr: "0",
        py: "1",
        h: "auto",
        top: 0.5,
        right: "0",
        borderRadius: "full",
        position: "absolute",
        variant: "outline",
        borderColor: "gray.100",
        isLoading: loading,
        _hover: {
            bg: "gray.200",
            border: "1px solid",
            borderColor: "gray.300"
        },
        _active: {
            bg: "gray.300",
            borderColor: "gray.400"
        },
        onClick: handleClick,
        rightIcon: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
            as: isFavourited ? (0, $f59ac49c6e1fede1$export$bbf5c63ab3baf1ad) : (0, $f59ac49c6e1fede1$export$2028ea63395ba7a6),
            color: isFavourited ? "#ffc20b" : "gray.400",
            filter: isFavourited ? "drop-shadow(0 1px 0 #82610054)" : "",
            fontSize: "1.2em"
        }),
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
            as: "span",
            mr: "-1.5" // trying to fix annoying padding-inline-start thing
            ,
            fontSize: "xs",
            color: "gray.500",
            children: favCount > 0 ? favCount : ""
        })
    });
};
const $7914f0fca7d41f85$var$formatIcon = {
    "hang-time": "HT"
};
const $7914f0fca7d41f85$var$getPreviewImageUrl = (id, format)=>{
    if (format === "hang-time") return (0, $c1fd71c50d10744b$export$800dbaa27f73c3f5).hangtime[0] + id + (0, $c1fd71c50d10744b$export$800dbaa27f73c3f5).hangtime[1];
    return false;
};






var $lDSNw = parcelRequire("lDSNw");

const $1c57069f3240e515$var$FavouritesCardGrid = ({ data: data, userFavourites: userFavourites, toggleFavourite: toggleFavourite, limit: limit })=>{
    const { topFavourites: topFavourites } = (0, $522db9f04f01389a$export$be543f108f7c3ef7)();
    const [favourties, setFavourites] = (0, $lDSNw.useState)([]);
    const [currentUserFavourites, setCurrentUserFavourites] = (0, $lDSNw.useState)([]);
    (0, $lDSNw.useEffect)(()=>{
        if (!data || !topFavourites) return;
        const latestFavourites = topFavourites.map((fav)=>{
            const match = data.find((creative)=>creative.id === fav.id);
            if (!match) return null;
            return {
                ...match,
                favCount: fav.favourites
            };
        }).filter((x)=>x);
        setFavourites(latestFavourites.slice(0, limit));
    }, [
        data,
        topFavourites,
        limit
    ]);
    (0, $lDSNw.useEffect)(()=>{
        if (!data || !userFavourites) return;
        const allUserFavourites = userFavourites.map((fav)=>{
            const match = data.find((creative)=>creative.id === fav.id);
            if (!match) return null;
            return match;
        }).filter((x)=>x);
        setCurrentUserFavourites(allUserFavourites);
    }, [
        data,
        userFavourites
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $6a502e7cb1933381$export$b2539bed5023c21c), {
        variant: "soft-rounded",
        colorScheme: "green",
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5195078522b2fc7e$export$e51a686c67fdaa2d), {
                ml: -1,
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $60ff4a7bee9d5c20$export$3e41faf802a29e71), {
                        children: "Highlights"
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $60ff4a7bee9d5c20$export$3e41faf802a29e71), {
                        children: "My Favourites"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $9be6ee0d259ba9e2$export$5dae8d435677f210), {
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1523771cacfd3c91$export$3d96ec278d3efce4), {
                        px: 0,
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $661e47f6bd02c88f$export$7e43f8ce08f3359d), {
                            gridAutoFlow: "column",
                            overflowX: "scroll",
                            creatives: favourties,
                            userFavourites: userFavourites,
                            toggleFavourite: toggleFavourite
                        })
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1523771cacfd3c91$export$3d96ec278d3efce4), {
                        px: 0,
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $661e47f6bd02c88f$export$7e43f8ce08f3359d), {
                            gridAutoFlow: "column",
                            overflowX: "scroll",
                            creatives: currentUserFavourites,
                            userFavourites: userFavourites,
                            toggleFavourite: toggleFavourite
                        })
                    })
                ]
            })
        ]
    });
};
var $1c57069f3240e515$export$2e2bcd8739ae039 = $1c57069f3240e515$var$FavouritesCardGrid;



const $661e47f6bd02c88f$export$7e43f8ce08f3359d = ({ creatives: creatives, userFavourites: userFavourites, toggleFavourite: toggleFavourite, ...rest })=>{
    const history = (0, $5058ffe240ffde31$export$3420e1dc2c4a518c)();
    const handleCardClick = (e, id)=>{
        if (e.ctrlKey || e.metaKey || e.button === 1) window.open(`/creative/${id}`, "_blank");
        else history.push(`/creative/${id}`);
    };
    const handleFavouriteClick = async (e, buildID)=>{
        e.stopPropagation();
        await toggleFavourite(buildID);
    };
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $310f0e9ced5c23ed$export$ef2184bd89960b14), {
        templateColumns: "repeat(auto-fit, 180px)",
        height: "auto",
        width: "100%",
        gap: "16px",
        ...rest,
        children: [
            creatives.map((creative)=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $7914f0fca7d41f85$export$6f0e152fdd9895bf), {
                    creative: creative,
                    isFavourited: userFavourites.some((fav)=>fav.id === creative.id),
                    handleFavouriteClick: (e)=>handleFavouriteClick(e, creative.id),
                    handleClick: (e)=>handleCardClick(e, creative.id)
                }, creative.id)),
            !creatives.length && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                children: "No creatives found"
            })
        ]
    });
};




var $lDSNw = parcelRequire("lDSNw");

var $14847ccff6e0f445$exports = {};
$14847ccff6e0f445$exports = JSON.parse('{"1":"Orly Beauty","2":"Yahoo Publisher Network","3":"AdBrite","4":"Google AdSense","5":"Daily Dose Publishing","6":"Amazon Associates","7":"Lucas Design International","8":"FriendFinder","9":"Black Label Ads","10":"Tsavo Media NSFW","11":"Clicksor","12":"Gunggo","13":"Daily Fill","14":"Context Response","15":"Context Response, NSFW","16":"MediaMath","17":"Riyaz Patel","18":"JC Innovations","19":"GumGum OpenX","20":"GumGum OpenX NSFW","21":"Tsavo Media","22":"Ignited","23":"Visitor Market","24":"Visitor Market NSFW","25":"AdManage","26":"GumGum OpenX Enterprise","27":"GumGum OpenX Enterprise NSFW","28":"GumGum","29":"AdMedia","30":"AdMedia NSFW","31":"GumGum Remnant NSFW","32":"Sharethrough","33":"Adconion","34":"Intelligent Beauty","35":"Starcom","36":"Ad.ly","37":"Miva","38":"JewelMint","39":"VideoEgg","40":"7Search","41":"PriceGrabber","42":"Pulse360","43":"Shopzilla","44":"Say Media","45":"NexTag","46":"Sybarite Elite","47":"Vibrant","48":"Smiley Media","49":"MySpace","50":"adMarketplace","51":"Advertising.com","52":"Marchex","53":"Groupon","54":"NAMoffers","55":"Linkshare","56":"Deal Group Media","57":"Genie Knows","58":"Macbellads","59":"Affinity","60":"ShopStyle","61":"Total Beauty","62":"Linksprint","63":"Datalot","64":"Yellowbook","65":"Yahoo Reseller","66":"Commission Junction","67":"Advertise.com","68":"Web.com","69":"AdMeld","70":"Beachmint","71":"TownRant","72":"ScoreBig","73":"Gannette","74":"AdBlade","75":"ShoeDazzle","76":"Spark Studios","77":"Dealnews","78":"BidRivals","79":"Blekko","80":"True Car","81":"DSNR","82":"Supermedia","83":"Senior Care Media","84":"W3i","85":"Prosperity Learning","86":"Universal Pictures","87":"Looksmart","88":"Disney Studios","89":"ABC Family","90":"Socialbit","91":"CW","92":"CBS","93":"Wells Fargo","94":"ABC","95":"Criteo","96":"Sqoot","97":"Lionsgate","98":"OpenX","99":"DMOL","100":"Fox","101":"Sony","102":"Clinique","103":"Lifelock","104":"Paramount","105":"HowAboutWe.com","106":"Toshiba","107":"BP","108":"Toyota","109":"Chitika","110":"Elizabeth Arden","111":"Experian","112":"Entertainment One","113":"Obox","115":"UGG Australia","116":"NBC","117":"Under Armour","118":"Alliance Films","119":"McAfee","120":"Target Interactive","121":"Hearst","122":"NASTYGAL","123":"Warner Bros","124":"Universal Studios, Hollywood","125":"Cats Pride","126":"StyleSaint","127":"iMedia Connection","128":"Media.Net","129":"Rubicon Project","130":"Serino Coyne","131":"THE UPS STORE","132":"Canon","133":"Oakley","134":"Lisa Hoffman Beauty","135":"Gulf States Toyota","136":"Random House","137":"Cesar","138":"AdMetrics Media","139":"Travel Spike","140":"Maybelline","141":"Summit Entertainment","142":"FUSE TV","143":"LG","144":"Unruly Media (Reseller)","145":"OneScreen","146":"Cadbury","147":"Lifetime","148":"COTY","149":"LOREAL","150":"Illinois Lottery","151":"AARP","152":"preachers daughter","153":"Allstate","154":"Casale Media","155":"CA State Lottery","156":"Lincoln","157":"Aruba Tourism","158":"Phillips 66","159":"Amtrak","160":"New England Toyota Dealers","161":"Zenovia","162":"Avazu","163":"Telemundo","164":"Credit Union","165":"Lands End","166":"Autism Speaks","167":"Buffalo Wild Wings","168":"Wells Dairy","169":"Kraft Foods","170":"Carnival Cruises","171":"Ford","172":"Miami Tourism","173":"Publisher\'s Clearing House","174":"Fruit 2O","175":"Serta","176":"Ulta Beauty","177":"USA","178":"McDonalds","179":"Travel Channel","180":"Honda","181":"AMC","182":"American Express","183":"Hpnotiq","184":"Adsparent","185":"Videology","186":"Xandr","188":"HGTV","189":"Pedigree","190":"Aetna","191":"AT&T","192":"LiveNation","193":"First 5","194":"Hachette","195":"WebSpectator","196":"Bravo","197":"Revlon","198":"Disney Channel","199":"Give Back Brands","200":"Friskies","201":"BidSwitch","202":"Temptations","203":"Macy\'s","204":"Tootsie Pops","205":"Marcal","206":"Conair","207":"Oxygen","208":"Southeast Toyota","209":"Bisquick","210":"Victoria\'s Secret PINK","211":"Capital One","212":"Hoosier Lottery","213":"Tenaya Lodge","214":"Chick-fil-A","215":"Coca-Cola","216":"BET","217":"ESPN","218":"National Breast Cancer Foundation","219":"McDonald\'s Black In-Screen","220":"Katy Perry","221":"Marzetti","222":"VUDU","223":"Cotton Blue to Green","224":"Feature Forward","225":"NetSeer","226":"7th Chamber","227":"Visible Measures","228":"Southwest Airlines","229":"E! Entertainment","230":"Quicken Loans","231":"Central Market","232":"Kellogg\'s","233":"Best Buy","234":"Samaritan\'s Purse","235":"SALT","236":"coca cola","237":"Amazon Digital Services","238":"Google","239":"AutoTrader.com ","240":"Dish Network","241":"BMW","242":"AdoreMe","243":"Nokia","244":"Energizer","245":"Comcast","246":"Shamrock Farms","247":"Time Warner Cable","248":"Ball Canning","249":"Full Sail University ","250":"Acura","251":"Hilton","252":"Mohegan Sun","253":"Devon Energy","254":"Turner","255":"Unilever","256":"Chobani","257":"Georgia Lottery","258":"O\'Keefe\'s","259":"Jetblue","260":"Whirlpool ","261":"Specific Media","262":"Cheap Caribbean","263":"Disney Parks","264":"CPXi","265":"specific","266":"Texas Tourism","267":"MGM","268":"U.S. Bombardier","269":"Garmin","270":"C8.Network","271":"Dollar Tree","272":"Collective","273":"Mission Foods","274":"Chango","275":"Shopilize","276":"Johnsonville","277":"Bridgestone ","278":"American Licorice Company","279":"VH1","280":"NearWoo","281":"Brand.net","282":"MNI","283":"ThinkGeek","284":"Marriott","285":"Oberto","286":"StackAdapt","287":"EQ Works","288":"Perfetti Van Melle - Airheads","289":"PubMatic","290":"PNC Bank","291":"American Family Insurance","292":"Mastercard","293":"Sealy","294":"BMO Harris","295":"Gillette","296":"Zemanta","297":"Airpush","298":"adidas","299":"Coast Guard","300":"The Trade Desk","301":"Texas Pete","302":"Magnetic Media","303":"Adaptive Media","304":"Army National Guard","305":"Oreo","306":"MyVegas.com","307":"Miller Coors","308":"Coinstar","309":"SmaRTB","310":"Dicks Sporting Goods","311":"United Airlines","312":"Sleep Number","313":"Harley Davidson","314":"eBay","315":"Dave & Busters","316":"CPG Class Action","317":"American Eagle Outfitters","318":"Abercrombie & Fitch","319":"toyota scion","320":"Hyundai","321":"California Milk Processor Board","322":"Icelandic Glacial","323":"Adconion Direct","324":"Heinz","325":"Paso Robles Wine Country Alliance","326":"SmartyPants","327":"Dodge","328":"American Legacy Foundation","329":"AC Delco","330":"Lee County","331":"P&G/Family Dollar","332":"NY Cares Summer","333":"New York Cares","334":"Stand Up To Cancer","335":"Cenegenics Womans Product","336":"Dell","337":"Anheuser-Busch","338":"Crown Imports - Negra Modelo","339":"Remy Martin","340":"IKEA","341":"Samsung","342":"iStock","343":"Ram","344":"PetSmart Charities, Inc","345":"Relativity","346":"Staples","347":"Sociomantic","348":"Jarden","349":"Kids II","350":"Clorox","351":"Sally Beauty","352":"Nexxen","353":"Townebank & VDA","354":"Dewar\'s","355":"Ybrant","356":"Adara","357":"CSC Brands","358":"UnitedHealthcare","359":"Incomm","360":"PBS","361":"Lee","362":"FDA","363":"Adaptive","364":"Lysol","365":"Qantas","366":"Saks Fifth Avenue","367":"PocketMath","368":"PayPal","369":"Applebee\'s","370":"North Lake Tahoe","371":"Appsfire","372":"EngageBDR","373":"Navistar","374":"Gamestop","375":"SmartyAds","376":"Planet Fitness","377":"Colorado Lottery ","378":"Biltmore Estate","379":"MeUndies","380":"Michigan State University","381":"Discovery","382":"NBC Golf Channel","383":"Nissan","384":"Pantene","385":"Outback Steakhouse","386":"A&E","387":"Department of Homeland Security","388":"Ball Horticulture","389":"Kixer","390":"test1","391":"Venus","392":"Giant Media","393":"KFC","394":"BidMonitor","395":"Singapore Airlines","396":"boy next door","397":"CarMax","398":"Verizon","399":"Volvo","400":"BlackRock","401":"Kozy Shack","402":"Bush\'s Beans","403":"Sub-Zero, Wolf & Cove","404":"Mazola","405":"Calvin Klein","406":"Abbott Laboratories","407":"Shamrock Farms Q2 FY15","408":"Troy-Bilt","409":"Schick","410":"iDA of Singapore","411":"Kinky Boots/On the Town","412":"Shell US (previously CA but the currency was USD)","413":"Husqvarna","414":"Sprint","415":"Go Rving","416":"Children\'s Hospital Colorado","417":"Arizona Lottery","418":"Olay","419":"Tracfone","422":"Hulu","423":"test 4 bk","424":"Time Inc.","425":"MARS","426":"Gourmet Garden","427":"DSW","428":"Tempur-Sealy","429":"UNICEF","430":"Paramount Home Entertainment GmbH","431":"Penske Truck Leasing","432":"Valvoline","433":"Australian Gold","434":"Dreft","435":"Spike TV","436":"SunTrust","437":"Panera Bread","438":"Jeep","439":"MilkPEP","440":"Infiniti","441":"Gravity","442":"Universal Orlando Resort","443":"Bidtellect","444":"Regions Bank","445":"Miele","446":"Chuck E Cheese","447":"Disneyland","448":"PetSmart","449":"Compare the Market","450":"Sanuk","451":"Bowflex","452":"Disney Aulani","453":"CoverGirl","454":"NBC Entertainment","455":"OtterBox","456":"CKE","457":"General Mills","458":"NBCU","459":"Walt Disney World","460":"Las Vegas Convention and Visitors Authority","461":"Tim Hortons","462":"Gatorade","463":"TGI Friday\'s","464":"Frito-Lay","465":"Budweiser","466":"Keurig Dr Pepper","467":"LiftMaster","468":"BASF","469":"Mouser","470":"InterContinental Hotels Group","471":"DistrictM","472":"Bounty","473":"Air Canada","474":"Scott\'s Lawn Service","475":"REDI Cincinnati","476":"IHOP","477":"Big Heart Pet Brands","478":"Arkansas Blue Cross Blue Shield","479":"Unruly Media","480":"Spirit Airlines","481":"Jaguar UK","482":"Wacoal","483":"PulsePoint","484":"Canon Canada","485":"Lane Bryant","486":"Church & Dwight Canada Corporation","487":"Emirates","488":"Petco","489":"Equus","490":"Hawaiian Electric","491":"Procter & Gamble","492":"Ohio Lottery","493":"Denny\'s","494":"Nationwide Bank","495":"Smuckers","496":"UPS","497":"Chrysler","498":"Pantelion Films","499":"Polaris","500":"StriVectin","501":"Jaguar","502":"James Hardie","503":"ZTE USA","504":"San Antonio CVB","505":"Mitsubishi Motors","506":"Disney Consumer Products","507":"Hewlett Packard","508":"Philosophy","509":"Fleischmann\'s Yeast","510":"Jaguar Land Rover","511":"Warner Brothers","512":"Colonial Williamsburg","513":"Michelin","514":"Ford Canada","515":"Paris Presents","516":"Fitbit","517":"MTV","518":"Bimbo Bakeries","519":"Muckfest MS","520":"Stainmaster","521":"FitLife","522":"Nova Southeastern University","523":"Forbes Advertiser","524":"Sovrn","525":"SeaWorld","526":"Campbells","527":"Murad","528":"L\'Oreal Canada","529":"California Tobacco Control Program","530":"Traditional Medicinals","531":"Frontier West Communications","532":"Next Issue","533":"Donuts Inc","534":"Nature\'s Bounty","535":"Darden","536":"Nordstrom","537":"Hillshire Brands","538":"Wyoming Office of Tourism","539":"Yamaha","540":"Susan G Komen","541":"Commodity Futures Trading Commission","542":"Dyson","543":"Nest Labs","544":"Meyer Corporation","545":"Ace Hardware Corporation","546":"American Italian Pasta Company","547":"Bon Savor","548":"Borden Dairy Company","549":"2011 Mac Tournament","550":"About.com","551":"Allrecipes.com","552":"Allure","553":"Almond Board of California","554":"American Greetings Corporation","555":"American Rights At Work","556":"AOL Inc.","557":"Atlantic Coast Conference","558":"AutoIn.net","559":"Banana Republic","560":"Barilla CFN","561":"BBC","562":"Beauty Products Exposed","563":"Big 12 Conference","564":"Big Ten Conference","565":"BlackPlanet","566":"bon appetit","567":"Bossip","568":"Buick","569":"Cadillac","570":"CBS Sports","571":"Chase","572":"Chevrolet","573":"Circa Belly Fat","574":"Circa Skin","575":"Comedy Central","576":"Comet","577":"ConAgra Foods","578":"Concierge","579":"Conde Nast","580":"Conference USA","581":"Conoco Mountain West Basketball Conference","582":"Del Monte Foods","583":"Depend","584":"Dish World IPTV","585":"Ebony","586":"Electrolux","587":"Elle","588":"epicurious","589":"ESPN Deportes","590":"Lowes","591":"FIAT Products","592":"Fiat","593":"Flash Player Update - DELETE ME","594":"Fodor\'s","595":"FoodNetwork","596":"Fox Sports","597":"Frommer\'s","598":"Gamble Aware","599":"Gap","600":"General Motors","601":"Glidden","602":"Goya Foods","603":"Health Headlines","604":"Hellmann\'s","605":"HelloBeautiful","606":"Home Depot","607":"Home Goods","608":"Honeyshed","609":"HuffPost","610":"iLivid","611":"In Touch Mag","612":"Jet","613":"Johnson & Johnson","614":"KC Walmart Depends","615":"Keybiotics","616":"Keystone XL","617":"King\'s Hawaiian","618":"Kohl\'s","619":"Le Reve","620":"Life & Style Mag","621":"LockedOn Media","622":"Love Your Look","623":"Lower My Bills","624":"Lumber Liquidators","625":"MademeNoire","626":"Major League Baseball (MLB)","627":"Major League Soccer (MLS)","628":"Martha Stewart Living Omnimedia","629":"Mate1","630":"Medical Health News","631":"Microsoft Corporation","632":"Minwax","633":"Miramax","634":"My Wine Club","635":"National Basketball Association (NBA)","636":"National Enquirer","637":"National Football League (NFL)","638":"National Hockey League (NHL)","639":"NBC Sports","640":"NCAA","641":"Nestle","642":"Nickelodeon","643":"Nikon","644":"Nutronics Labs","645":"OK! Mag","646":"Olympus","647":"PAC 12","648":"PGA","649":"Planned Parenthood","650":"PopSugar","651":"Popular Screensavers","652":"Publishers Clearing House","653":"Publix Super Markets","654":"Purina","655":"R.W. Knudsen","656":"Reckitt Benckiser","657":"Red Funnel Isle of Wight Ferries","658":"Refinery29","659":"Renner","660":"Salmon Fishing in the Yemen","661":"Bonnier Corporation","662":"SEC Conference","663":"Seventh Generation","664":"Showtime","665":"Simon & Schuster","666":"SkipIt","667":"Sky Sports","668":"Solo","669":"Sorbee","670":"Sporting News","671":"Stages of Beauty","672":"Star Magazine","673":"Starbucks","674":"Starz","675":"Statoil","676":"In The Raw","677":"Sun Belt Conference","678":"Sur La Table","679":"Telefonica","680":"Terlato Wines International","681":"Terra Nova","682":"Tervis Tumbler","683":"Charles Schwab","684":"Daily Meal Shop","685":"The God Who Wasn\'t There","686":"The Week","687":"TMZ","688":"TotalBeauty","689":"Tourism Ireland","690":"Transformers (Movie)","691":"Tribe Hummus","692":"TV Guide","693":"Univision","694":"Wenner Media (old)","695":"Velux","696":"Vertical Response","697":"Walmart","698":"Wedding Wire","699":"Weekend To End Women\'s Cancers","700":"White House Black Market","701":"World Energy Research","702":"Wynn Resorts","703":"Yahoo en Espanol","704":"Yahoo! Sports","705":"Yankee Candle","706":"Discover Financial","707":"SC Johnson","708":"SlimFast","709":"Freight Forwarders","710":"The Good Dinosaur","711":"Acuity Insurance","712":"Charmin","713":"H-E-B","714":"Fujifilm","715":"General Growth Properties","716":"Virginia Lottery","717":"Build A Bear Workshop","718":"Bai Drinks","719":"Scion","720":"Universal Technical Institute (UTIN)","721":"Cholula","722":"Salvation Army","723":"InPowered","724":"Old Navy","725":"Sky Movies","726":"Nutribullet","727":"TEST","728":"Pepsi","729":"Matomy","730":"RSVLTS","731":"Weight Watchers","732":"TOUS","733":"InDemand","734":"Visit St Pete-Clearwater","735":"Palermo\'s Pizza","736":"Centers for Disease Control and Prevention (CDC)","737":"Ad Council","738":"Gaia","739":"So Delicious","740":"Bloomin\' Brands","741":"John Deere","742":"3M","743":"Omni Resorts & Hotels","744":"MoviePilot.com","745":"Wisconsin Department of Tourism","746":"Hyatt","747":"Placesyoullsee.com","748":"SuperPretzel","749":"Kicksologists.com","750":"Bunkersparadise.com","751":"DodgersNation.com","752":"Visit Florida","753":"Kaplan University","754":"Lindt & Sprungli","755":"Stamford Hospital","756":"Womanista","757":"Example Publisher","758":"Ragu & Bertolli Foods","759":"Mattel","760":"Test2","761":"CIBC","762":"La Prairie","763":"Academy Sports","764":"whatculture.com","765":"Sexy Hair","766":"Live Nation","767":"Tourism Australia","768":"Ranker.com Advertiser","769":"Dogs Trust Trustee Limited","770":"Georgia Power","771":"Neiman Marcus","772":"Intel","773":"CenturyLink","774":"Farm Bureau Financial Services","775":"SkyStores Buy&Keep","776":"Bad Bear Media Advertiser","777":"HollywoodLife","778":"tattoo-models.net","779":"inquisitr.com Advertiser","780":"Traffic Exchange","781":"Swoop","782":"Rent-A-Center","783":"World Wide Fund for Nature","784":"Reseller Waterfall","785":"John Muir Health","786":"9laughs.com","787":"Next Direct","788":"RevContent","789":"BoredomTherapy.com","790":"Time Inc Passback Advertiser","791":"Benjamin Moore","792":"Dressbarn","793":"destinationtips.com","794":"Gardein","795":"mediaite.com","796":"Land O\'Lakes","797":"Time Warner Advertiser","798":"TopSpeed.com","799":"Potawatomi Casino","800":"thegazette.com","801":"iloveoldschoolmusic.com","802":"NRG Energy","803":"Game Show Network","804":"NeuLion","805":"Smoothie King","806":"HBO","807":"allkpop.com","808":"Martinelli\'s","809":"At Home","810":"Pandora","811":"University of Phoenix","812":"Lonza","813":"Global Brewers","814":"Visit Denver","815":"Haseko Homes","816":"Santa Catalina Island Company","817":"Muscle Milk","818":"Palmer\'s","819":"TruGreen","820":"Aperol","821":"Ripple Foods","822":"SpotXchange","823":"DFPS","824":"Louisville CVB","825":"Bellator","826":"Bonnier Advertiser","827":"Bauer Australia","828":"TV Land","829":"GirlsAskGuys.com","830":"True Value","831":"The Outlet Collection - Seattle","832":"Dove Men+Care UK","833":"Nordstrom Rack","834":"Zotos","835":"Delta Airlines","836":"Mondelez","837":"burdastyle.com","838":"Partnership for Drug-Free Kids","839":"San Diego Zoo","840":"ComEd","841":"JLO  Vegas Residency 2016","842":"Ocean Spray","843":"American Kennel Club","844":"Ghirardelli","845":"T-Mobile","846":"Hood","847":"thatoregonlife.com","848":"LL Bean","849":"Energy Upgrade California","850":"Frontline","851":"Pinehurst","852":"Hugo Boss","853":"Stearns & Foster","854":"Rio Hotel and Casino","855":"countryrebel.com Passback Campaign","856":"ComboTag","857":"Oceania Cruise Lines","858":"iMDS","859":"Fiji Airways","860":"movieweb.com Advertiser","861":"Drug Free Kids","862":"Otis Spunkmeyer","863":"Meat and Livestock Australia","864":"Heavy.com","865":"Amazon","866":"hiphop-n-more.com","867":"March of Dimes","868":"TheBolde.com","869":"Farmer John","870":"Belk","871":"ACH Foods","872":"TripleLift - Mirage Test","873":"CORT Furniture","874":"Yahoo! AUNZ","875":"Commonwealth Bank of Australia","876":"Casino Rama","877":"Grupo Gallegos","878":"Scenic Tours","879":"nydailynews.com","880":"Allday.com","881":"Northwestern Medicine","882":"Stearns and Foster - Q3 Media Program - July 2016","883":"Horticulture Innovation Australia","884":"TheSimsResource","885":"Holden Australia","886":"Ziff Davis","887":"Simon Malls","888":"HooplaNow.com Advertiser","889":"2K Games AU/NZ","890":"Diageo","891":"Spartan","892":"Taubmans Paints","893":"Kaiser Permanente","894":"NativeAds","895":"NIB Health Insurance","896":"Yahoo7","897":"ParentHerald.com Passback Advertiser","898":"MessyNessyChic.com","899":"Atlantis","900":"GumGumTestI8n","901":"Genesis","902":"Clearlink","903":"eOne","904":"Vicks","905":"Ricola","906":"Lyft","907":"Kia","908":"Big Machine Label Group","909":"Bacardi","910":"Lull","911":"New York Life","912":"holyhorsepower.com","913":"Outbrain","914":"Tarte Cosmetics","915":"All Nippon Airways","916":"fashionnstyle.com Advertiser","917":"TEST - ADOPS: A/B Testing","918":"Cambia Health Solutions","919":"FIAT US","920":"World Vision","921":"Potatoes USA","922":"Taboola","923":"otherbuzz.com Passback Advertiser","924":"Rimmel","925":"Phoenix Children\'s Hospital","926":"Dermstore","927":"Goodwill Arizona","928":"Epom","929":"Swince - Passback","930":"Schweppes","931":"Dermastore","932":"United States Marine Corps","933":"Looper.com","934":"Starwood Hotels and Resorts","935":"Hershey\'s","936":"Arizona Department of Health","937":"Mobusi Advertiser","938":"MD Anderson","939":"thesimsresource.com","940":"Swiss Airlines","941":"TCF Bank","942":"Shedd","943":"Subway","944":"rndr.com Advertiser","945":"mancavin.com Passback Advertiser","946":"Ladbrokes","947":"B&Q","948":"Victoria Fine Foods","949":"Ben Bridge Jeweler","950":"Drawbridge","951":"Mazda","952":"CPUgame","953":"The Blogger Network Passback","954":"University of Melbourne","955":"Logitech","956":"Stanley Black and Decker","957":"AnyClip","958":"NovaRoll","959":"Yashi","960":"Highmark","961":"Dockers","962":"Church of LDS","963":"H&M","964":"Philips","965":"NY Lotto","966":"reuters.com Passback","967":"Alcon - Dailies","968":"Wenner Media","969":"Microsoft Store","970":"Mobil","971":"Sky Cinema","972":"Wealthsimple","973":"David Yurman","974":"ANZ The Australia and New Zealand Banking Group","975":"Lego Australia","976":"Subway Australia","977":"Victoria University (Australia)","978":"American Express AU","979":"Universal Sony Pictures","980":"Anki","981":"Royal Caribbean","982":"International Publications Media Group","983":"omgchocolatedesserts.com Advertiser","984":"FreshPet","985":"TruMoo","986":"Travel Insurance Direct","987":"Apple","988":"Southern Nevada Water Authority","989":"Medibank Australia","990":"James Squire","991":"Mars Media Group","992":"Defence Force Recruitment (Australia)","993":"Kentucky Lottery","994":"MUNDOmedia Ltd. Passback","995":"American Savings Bank","996":"Young Hollywood Passback","997":"Prince Resorts Hawaii","998":"UK Land Rover","999":"Michelle Bridges","1000":"Pirate\'s Booty","1001":"Inneractive","1002":"Atlantic Health System","1003":"Tourism Northern Territory (NT)","1004":"La Trobe","1005":"Look Fantastic","1006":"FORD","1007":"WWW.MUNDOFLANEUR.COM Passback","1008":"Addvantage Media Passback","1009":"Sea Island","1010":"eHarmony","1011":"Provide Commerce - ProFlowers","1012":"Rubios","1013":"SunTimes.com Passback","1014":"AZEK","1015":"Flight Centre","1016":"Myer","1017":"Horticulture Innovation Australia","1018":"AVON","1019":"eBay","1020":"RACQ","1021":"Ronnie O\'Sullivan","1022":"Schweppes","1023":"Helen of Troy","1024":"Collegespun.com Advertiser","1025":"Georgia Pacific","1026":"Test Advertiser","1027":"Adidas","1028":"Citibank (Australia)","1029":"Tourism Western Australia","1030":"B&Q","1031":"Honda","1032":"Rinnai","1033":"Kahala Hotel & Resort","1034":"BIC","1035":"Belle Tire","1036":"CBS Interactive Passback","1037":"Paramount Home Entertainment","1038":"Yahoo7 (Publisher)","1039":"Crest","1040":"Serge Test","1041":"Visa","1042":"Morton Salt","1043":"DePaul University","1044":"Stanford Health","1045":"DIXONS","1046":"H&M","1047":"Motor Trend","1048":"Zodiac Pool Systems","1049":"Sky Mobile","1050":"Chris & George Mackey Dealerships","1051":"Lincoln","1052":"O2","1053":"Toys \\"R\\" Us","1054":"Ural","1055":"Lion (Australia)","1056":"Maine Tourism","1057":"Volvo","1058":"Aveeno","1059":"Yokohama Tires","1060":"Boppy","1061":"Harper Collins","1062":"Centene","1063":"Rust-Oleum","1064":"house_of_cards","1065":"Lixil","1066":"Fontem","1067":"Target","1068":"Dignity Health","1069":"Kindred Healthcare","1070":"GumGum Japan","1071":"Home City Ice Settlement","1072":"Citi","1073":"screenrant.com Passback Advertiser","1074":"Hannaford","1075":"Mullen","1076":"Admetic","1077":"Jaguar Land Rover UK","1078":"Freedom Mobile","1079":"Hawaiian Tropic","1080":"Paper Plus","1081":"CPA Australia","1082":"MINI","1083":"Church & Dwight","1084":"AMB Sports & Entertainment","1085":"WMATA","1086":"The Gap, Inc.","1087":"Deutsche Telekom AG","1088":"Munchkin, Inc.","1089":"Prometheus","1090":"Alcon","1091":"FlyBy","1092":"Juicy Juice","1093":"New World - NZ","1094":"School of Rock","1095":"ABC News","1096":"Livestly Passback Campaign","1097":"AdNews","1098":"Destination DC","1099":"Nolet\'s Gin","1100":"ProHealth Urgent Care","1101":"KFC","1102":"Walden University","1103":"Microsoft AU","1104":"Holden AU","1105":"Jaguar Land Rover","1106":"Loews Hotels","1107":"Lindt Australia","1108":"Smaato","1109":"coke","1110":"Petbarn (Australia)","1111":"20th Century Fox","1112":"Duracell","1113":"Moen","1114":"Social Tables","1115":"Air Canada","1116":"dulux","1117":"Hunter Fans","1118":"Philips","1119":"Fitness First","1120":"Monroe Shocks","1121":"Missouri Lottery","1122":"Frontier FIOS","1123":"Hot Pepper Beauty","1124":"Kalahari Resorts","1125":"Samsung UK","1126":"A Place at the Table","1127":"USTA","1128":"Biore","1129":"exxon_mobil","1130":"CIRIO","1131":"FRAM Fresh Breeze","1132":"Floor & Decor","1133":"Scott Toilet Paper","1134":"Frontier (Australia)","1135":"DC Lottery","1136":"PepsiCo","1137":"UNHCR","1138":"Coach","1139":"Nestle","1140":"NIB Health Insurance (AU)","1141":"Hamilton Island","1142":"Future Plc UK Advertiser","1143":"Hutchinson 3G UK","1144":"Lavazza","1145":"Nike","1146":"topshop_2017","1147":"Uber","1148":"Potawatomi Hotel and Casino","1149":"Penn State Athletics","1150":"L\'oreal","1151":"33Across","1152":"Dogs Trust","1153":"gilette","1154":"Ruth\'s Chris Steakhouse","1155":"Starbucks","1156":"Now TV","1157":"SpikeyBits Advertiser","1158":"Boll + Branch","1159":"Lee County Visitor and Conventions Bureau","1160":"GlassView","1161":"VISA UK","1162":"Vail Resorts","1163":"Phelps Group","1164":"MyEyeDr","1165":"Septembeard","1166":"MM.LaFleur","1167":".","1168":"Bauer Media Australia Advertiser","1169":"Crocs","1170":"SU2C","1171":"DirecTV","1172":"Optus Australia","1173":"pandora uk","1174":"Covergirl","1175":"Vodafone","1176":"SoCal Energy","1177":"National Australia Bank","1178":"Meat & Livestock Australia","1179":"Ford Tactical Q3","1180":"Samsung","1181":"virgin media uk","1182":"therichest.org Advertiser","1183":"Best Western","1184":"LATAM Airlines Group","1185":"Cinemex (Octopus Media)","1186":"Government of the State of Michoac\xe1n","1187":"Nike","1188":"Noosa","1189":"Open Road","1190":"Kirin","1191":"Net A Porter","1192":"Sweaty Betty","1193":"Puerto Rico Tourism Company","1194":"Chico\'s","1195":"Ford Australia","1196":"Barber Foods","1197":"Coty","1198":"First Aid Beauty","1199":"Time Inc (UK) Direct","1200":"Reebok","1201":"Cetaphil","1202":"Proctor & Gamble","1203":"Sun-Maid","1204":"VerticalScope Passback Advertiser","1208":"Energizer Australia","1209":"Chipotle Mexican Grill","1210":"GumGumTestCredstash","1211":"Too Faced","1212":"Wonders of Wildlife Museum & Aquarium","1213":"Louisiana Office of Tourism","1214":"BWS","1215":"volkswagen","1216":"Exxon","1217":"Exxon","1218":"Wounded Warrior Project","1219":"Jameson","1220":"Emirates","1221":"ILY Pet Food","1222":"LifeProof","1223":"National Association of Realtors","1224":"Diageo","1225":"The Atlantic Advertiser","1226":"McDonalds","1227":"High and Mighty","1228":"Valvoline","1229":"Twin Peaks","1230":"Sherway Gardens","1231":"Royal Caribbean","1232":"St. Louis Children\'s Hospital","1233":"PECO","1234":"Aspen Pharmacare","1235":"Casino Rama","1236":"Tout","1237":"XBOX","1238":"Brown Forman","1239":"American Cancer Society","1240":"Essie","1241":"Reynolds Consumer Products","1242":"GiftConnect","1243":"AZ Office of Tourism","1244":"Bose","1245":"J.Crew","1246":"Ohio Ballot","1247":"Utah Office of Tourism","1248":"American Pistachio Growers","1249":"Massarius Advertiser","1250":"Adventure World WA","1251":"Real Estate Council of Ontario","1252":"PMC/HollywoodLife Advertiser","1253":"Sephora","1254":"Squaw Valley","1255":"Otsuka","1256":"H Code Media Passback","1257":"H Code Media Advertiser","1258":"Sky Animation","1259":"MANTAN Advertiser","1260":"Smile Direct Club","1261":"Blue Shield of California","1262":"Invisalign","1263":"TD Ameritrade","1264":"Rituals","1265":"Palm Bay","1266":"Victoria Government","1267":"MetroPCS","1268":"Thermomix","1269":"Public Transport Victoria","1270":"Sky","1271":"Hiland Dairy","1272":"Alex & Ani","1273":"GlaxoSmithKline","1274":"My Navi News Advertiser","1275":"Jaguar (UK)","1276":"Algoma University","1277":"Motorsport Passback Advertiser","1278":"Karcher","1279":"Boots","1280":"Spiritual Gangster","1281":"CAT","1282":"Telstra","1283":"NovoRoll","1284":"Brooks","1285":"Ferrero","1286":"CPTM (Tourism Board of Mexico)","1287":"K\xedvac","1288":"AAMI","1289":"Westfield","1290":"Qdoba","1291":"Downton Abbey","1292":"L\'Occitane","1293":"Bauer/Lifeandstyle Advertiser","1294":"Ambetter","1295":"Deutsch Family Wine & Spirits","1296":"Red Bull GmbH","1297":"Isuzu","1298":"Jeep","1299":"Porsche","1300":"City Harvest","1301":"PayPal","1302":"My Navi Gakusei no Madoguchi Advertiser","1303":"Select Health","1304":"Lexus","1305":"UK Ignore","1306":"Under Armour Teddy Riner","1307":"Sanderson Farm","1308":"Mercedes-Benz","1309":"Maestros","1310":"Waitress","1311":"MTV","1312":"Ultherapy","1313":"Focus on Energy","1314":"Pharmacy Guild of Australia","1315":"Alsea","1316":"Realtor.com","1317":"Voya","1318":"QuitLine","1319":"L\'Oreal","1320":"Nationwide Children\'s Hospital","1321":"PUMA","1322":"Allegiant Air","1323":"Morinaga","1324":"thejasminebrand.com Advertiser","1325":"DAZN","1326":"Taptica","1327":"Norwegian Cruise Line","1328":"Doha Film Institute","1329":"Doha Film Institute","1330":"Amore Pacific","1331":"Citibanamex","1332":"New Museum","1333":"Timex","1334":"New Hampshire Lottery","1335":"Chicago Coalition for the Homeless","1336":"Energizer","1337":"BP","1338":"Metropolitan Police Service","1339":"UNHCR","1340":"SAP","1341":"Loreal","1342":"Coach","1343":"Countdown (New Zealand)","1344":"CMT","1345":"Playstation","1346":"La Quinta","1347":"BMW","1348":"Crosspath Trading Ltd","1349":"Parco","1350":"Parco Co.","1351":"Duracell","1352":"Colgate","1353":"Luxottica","1354":"KIA","1355":"Huawei","1356":"Butlin\'s","1357":"TUI","1358":"Playstation","1359":"Responsible Energy Development in Colorado","1360":"Triumph","1361":"Voice Media Advertiser","1362":"P&O Cruises","1363":"Chase United Plus","1364":"Chinet","1365":"Lavazza","1366":"Cox Communications","1367":"Aer Lingus","1368":"Adobe","1369":"Warner Brothers Home Entertainment","1370":"Suja Juice","1371":"Hope Foods","1372":"New Balance Athletics","1373":"Telcel","1374":"The Lion King","1375":"Pia Advertiser","1376":"Inland Empire","1377":"WGN America","1378":"Tommy Bahama","1379":"Broadway","1380":"Callaway","1381":"Jewelers Mutual","1382":"University of Western Australia","1383":"LPM","1384":"Boston Pizza","1385":"Mapfre","1386":"Florida Lottery","1387":"DTE","1388":"Henkel","1389":"AAMC","1390":"Pandora","1391":"Kinky Boots","1392":"PUMA","1393":"Yor Media Advertiser","1394":"VisitScotland","1395":"Renault","1396":"Church and Dwight","1397":"MamaCare","1398":"Cedars-Sinai","1399":"Office of Lottery and Charitable Games","1400":"Schick","1401":"Economist Intelligence Unit","1402":"Stage Stores","1404":"Snack Media Advertiser","1405":"I-ne","1406":"Bebo","1407":"Brolico","1409":"Volkswagen (Japan)","1410":"Service Employees International Union","1411":"Baltimore Gas and Electric (BGE)","1412":"Sherwin Williams","1413":"Bleecker Street","1414":"Gorin (Japan)","1415":"Mizuho Bank (Japan)","1416":"Drybar","1417":"Dell UK","1418":"interplaymedia.com.au Advertiser","1419":"Ajinomoto (Japan)","1420":"JAL (Japan Airlines Co., Ltd)","1421":"Intergate Hotel (Japan)","1422":"Pernod Ricard\'s Avion","1423":"Oregon Lottery","1424":"Levi\'s","1425":"Rachael Ray","1426":"BNMedia LLC Advertiser","1427":"Urban Drainage and Flood Control","1428":"Ad.net Advertiser-Passback","1429":"gettyimages.com Passback Advertiser","1430":"H&R Block","1431":"Warner Brothers Interactive Entertainment","1432":"Keurig","1433":"PopTV","1434":"BMW","1435":"Sanofi","1436":"TJX","1437":"Jimmy Dean","1438":"US Army","1439":"Mastercard Japan","1440":"JP Post (Japan)","1441":"Eli Lilly","1442":"Hakkasan","1443":"Suntory","1444":"HomeGoods","1445":"Merck","1446":"Avis","1447":"Mars","1448":"Central Bancompany","1449":"Fathom Unlimited, Inc. Advertiser","1450":"LATAM (Octopus Media)","1451":"Mars","1452":"ConAgra","1453":"Bulla","1454":"Pepco","1455":"Estrella Jalisico","1456":"Quest Nutrition","1457":"Mon Guerlain","1458":"NSW Government","1459":"HEB Grocery","1460":"toopanda Advertiser","1461":"AMP","1462":"Nordstrom","1463":"Sun Basket","1464":"California Avocado Commission","1465":"Lifenet Insurance","1466":"NTT Docomo","1467":"USPS","1468":"Rohto (Japan)","1469":"Van Metre","1470":"Delta Dental","1471":"Link & Motivation","1472":"Sweetwater Brewery","1473":"John Deere","1474":"Peugeot (Octopus Media)","1475":"DFS","1476":"Sabre","1477":"Papa Johns","1478":"Baladna","1479":"Combe","1480":"Canadian Tire","1481":"Puma","1482":"B.Glen (Japan)","1483":"GE","1484":"Not_in_use","1485":"SpringServe","1486":"History","1487":"Cinepolis (Octopus Media)","1488":"Neutrogena","1489":"Head & Shoulders (Japan)","1490":"Uproxx.com Advertiser","1491":"Uproxx.com - Don\'t Use","1492":"Boden","1493":"Burger King","1494":"Las Vegas Golden Knights","1495":"Swarovski","1496":"Heineken (Octopus Media)","1497":"Decencia (Japan)","1498":"Art Gallery NSW","1499":"Go Outdoors","1500":"Mercedes (Octopus Media)","1501":"Wyndham Hotels","1502":"Starcom","1503":"Kinsella Media","1504":"DNC","1505":"Megafood","1506":"Hankook Tires","1507":"Candy Club","1508":"Go RVing","1509":"Quest Arabia","1510":"General Motors (Octopus Media)","1511":"The Week Advertiser","1512":"DAZN (Japan)","1513":"Visit Orlando (Octopus Media)","1514":"Nestle","1515":"Blue 449 Sydney","1516":"GrowWise","1517":"Mitsubishi Motors","1518":"MetLife","1519":"Tag Heuer (Octopus Media)","1520":"GTB Melbourne","1521":"Ford","1522":"Dexcom","1523":"Georgia Department of Transportation","1524":"Visa (Octopus Media)","1525":"Brighthouse Financial","1526":"CFA Institute","1527":"Avengers (Octopus Media)","1528":"Tahoe South","1529":"Chrysler","1530":"Kellogg\'s (Japan)","1531":"Aguila (Octopus Media)","1532":"Microsoft","1533":"Sirius XM","1534":"Nike (Octopus Media)","1535":"GMO AD Marketing Inc Advertiser","1536":"Arnotts","1537":"Salon Advertiser","1538":"Claro (Octopus Media)","1539":"Test 1","1540":"Greyhound","1541":"Vivint","1542":"Virginia Commonwealth University","1543":"Michigan Lottery","1544":"Eika","1545":"toonzone.net Advertiser","1546":"Live Nation (AU)","1547":"Chicago The Musical","1548":"Gumtree Advertiser","1549":"Marvel Studios","1550":"Aston Martin","1551":"Tyson","1552":"Veggie Noodles","1553":"American Heart Association","1554":"Continental & General Tires","1555":"Weight Watchers","1556":"Epson","1557":"Luzianne Tea","1558":"Toho (Japan)","1559":"indieshuffle.com Passback Advertiser","1560":"GSK","1561":"Longchamp","1562":"StarKist","1563":"Daily Engage Media Advertiser","1564":"Banfield Pet Hospital","1565":"Dell","1566":"Qantas","1567":"Worldstar HipHop Advertiser","1568":"Digitalmusicnews.com Advertiser","1569":"Tiffany & Co","1570":"Toyota (Japan)","1571":"LottoWest","1572":"Carphone Warehouse","1573":"Pentair","1574":"Spark Foundry (AU)","1575":"Sweet Baby Ray\'s","1576":"BB&T","1577":"MetaRail","1578":"Autocar Advertiser","1579":"Western Union","1580":"Vuse","1581":"Chip Chicklets Advertiser","1582":"Hawaiian Airlines","1583":"Mrs Macs Pies","1584":"Peet\'s","1585":"Terpel (Octopus Media)","1586":"LKQD","1587":"ALCOSAN","1588":"AdUX Italy","1589":"AdUX Spain","1590":"AdUX France","1591":"AdUX Belgium","1592":"Townnews Advertiser","1593":"LEGO","1594":"MoneyTag Advertiser","1595":"Corferias","1596":"Compare The Market","1597":"United Airlines","1598":"Greater Fort Lauderdale","1599":"Red Gobo Inc Advertiser","1600":"Les Miserables","1601":"Seaport District","1602":"Royal Ontario Museum","1603":"Neato","1604":"VISA (Japan)","1605":"rebel Sport (Australia)","1606":"Stevia in the Raw","1607":"LG","1608":"Sony Pictures (Octopus Media)","1609":"MAGAZINE HOUSE CO., LTD Advertiser","1610":"Ocean Resort Casino","1611":"SA Tourism","1612":"JCPenney","1613":"Obox Media French Advertiser","1614":"Johnson & Johnson","1615":"DAZN for docomo (Japan)","1616":"Bausch & Lomb","1617":"Beats by Dre","1618":"Mirum (Octopus Media)","1619":"Carulla (Octopus Media)","1620":"Wusthof","1621":"George Weston Foods","1622":"EyeBuy Direct","1623":"New Balance","1624":"Resona Bank","1625":"Blue Salon","1626":"Golf Canada","1627":"GumGum- SF Training","1628":"Lurpak Butter (AU)","1629":"Constellation Wines","1630":"APlus Advertiser","1631":"Wasserman Media Group","1632":"ICBC","1633":"Test","1634":"Mediavague Co., ltd. Advertiser","1635":"AdUX France - Nuxe","1636":"Hawaiian Airlines","1637":"StubHub","1638":"Specsavers","1639":"Alliance for Lifetime Income","1640":"Vodafone","1641":"Estee Lauder Companies","1642":"Amazon","1643":"AAMI Health Insurance","1644":"Lowe\'s","1645":"The Ad Council","1646":"Quinstreet Inc","1647":"Joyo Bank (Japan)","1648":"Sankei Advertiser","1649":"HRC (Japan)","1650":"Associated Bank","1651":"Alexia Foods","1652":"Toyota (AU)","1653":"Dr. Pepper","1654":"Plated","1655":"Navitas","1656":"Jack Daniels (AU)","1657":"Kellogg\'s","1658":"Garnier","1659":"NextAge","1660":"PrizeGrab Advertiser","1661":"Annapurna Pictures","1662":"Lixil","1663":"Dallas Convention & Visitors Bureau","1664":"NOVA Entertainment","1665":"AdUX Spain Advertiser","1666":"Allwell","1667":"Fiat Chrysler (Australia)","1668":"Haagen-Dazs (Japan)","1669":"Sky UK Ltd","1670":"Nine Australia Advertiser","1671":"Brick Industry","1672":"PA Lottery","1673":"Google DV360","1674":"Entertainment Film Distributors","1675":"at home (Japan)","1676":"Kirin Brewery (Japan)","1677":"Brightcom","1678":"Donuts Advertiser","1679":"Ben and Jerry\'s","1680":"KISS","1681":"Natural History Museum","1682":"UCare Health","1683":"CDW","1684":"Autotrader","1685":"Tic Tac (Octopus Media)","1686":"Swisse Wellness","1687":"McDonald\'s","1688":"Code 42","1689":"Bell Media","1690":"Bank of the West","1691":"Kioti Tractor","1692":"MYOB (AU)","1693":"Tommy Hilfiger","1694":"Internet Matters","1695":"Bunnings Warehouse (AU)","1696":"Meiji Co.,Ltd. (Japan)","1697":"Wake Forest Baptist Health","1698":"Frankly Inc Advertiser","1699":"Goop","1700":"NextGen America","1701":"E!","1702":"LG","1703":"LVMH (Japan)","1704":"Humana","1705":"Cuprinol","1706":"Electronic Arts","1707":"Stony Brook University","1708":"Peroni","1709":"American Express (UK)","1710":"Netscout","1711":"TriNet","1712":"CVS","1713":"Esurance","1714":"Ignore","1715":"Ignore","1716":"GumGum","1717":"GumGum","1718":"Alzheimer\'s LA","1719":"OVO Mobile (AU)","1720":"Western Wear","1721":"Michelin","1722":"GUM Sunstar America","1723":"The Lion King","1724":"ANA (All Nippon Airways) (Japan)","1725":"Vince Clothing","1726":"Air New Zealand","1727":"Nectar","1728":"Los Cabos (Octopus Media)","1729":"Royal Opera House","1730":"Book of Mormon","1731":"Blurb","1732":"REBBL","1733":"Ikea","1734":"LEGO","1735":"Oriental Land (Japan)","1736":"Canntrust","1737":"Boots","1738":"Movado","1739":"Vitalant (Blood Systems Inc.)","1740":"Virgin (Australia)","1741":"Richemont Luxury Group","1742":"DailyMail US Advertiser","1743":"Head over Heels","1744":"Travel Alberta","1745":"Singapore Airlines (AU)","1746":"Johnston Press Advertiser","1747":"Salt River Project","1748":"Pony Malta (Octopus Media)","1749":"Blue Buffalo","1750":"Cosmax","1751":"Boot Barn","1752":"Capital One","1753":"Miller (Octopus Media)","1754":"Mitsubishi Jisho (Japan)","1755":"Ohio Statewide Races","1756":"National Security Agency","1757":"Twisted Shotz","1758":"Amarilo (Octopus Media)","1759":"AM Advertiser Test 1","1760":"FourM Advertiser","1761":"P&G Japan","1762":"MIXI (Japan)","1763":"New Demo Advertiser","1764":"LDV (Australia)","1765":"Legg Mason","1766":"Not Your Average Joes","1767":"MDVIP","1768":"FWD (Japan)","1769":"Uber (Octopus Media)","1770":"UFC (Australia)","1771":"Disney Parks & Resorts Canada","1772":"TSA PreCheck","1773":"California Walnut Board","1774":"Sony Pictures","1775":"Crash Media Group Advertiser","1776":"Mylan","1777":"FitBit","1778":"Levi\'s (Octopus Media)","1779":"Snackbrands (AU)","1780":"IDG RoW Advertiser","1781":"Graydown2 Advertiser","1782":"Rutgers","1783":"Chapstick (Octopus Media)","1784":"Google","1785":"delete","1786":"Kansas Lottery","1787":"Shiseido (Japan)","1788":"FISKARS","1789":"Woolworths Limited (AU)","1790":"Buick (Octopus Media)","1791":"LDLT","1792":"Jeep","1793":"Citrix","1794":"Royal Mail","1795":"Obox Media Direct Sold","1796":"ITOYOKADO (Japan)","1797":"Acuvue","1798":"Allergan","1799":"Sabio","1800":"Conquer Cancer","1801":"Next","1802":"Wichita State University","1803":"Land Rover","1804":"College Board","1805":"GumGum AUS Test","1806":"GumGum EU Test","1807":"GumGum UK Test","1808":"Oxfam","1809":"GumGum US Test","1810":"Nestle","1811":"Huawei","1812":"Muscular Dystrophy Association","1813":"Alberta Wheat","1814":"SUNSTAR AMERICAS","1815":"Newsquest Advertiser","1816":"Colorado Tourism Office","1817":"The Dominick Hotel","1818":"Fitbit UK","1819":"AAA","1820":"GumGum Passback","1821":"GumGum Advertiser","1822":"La Paz (Octopus Media)","1823":"Pernod Ricard","1824":"Westpac","1825":"Nikkan Sports Advertiser","1826":"Medical College of Virginia Foundation","1827":"Bidder Media Advertiser","1828":"Bose","1829":"Bose Europe","1830":"Turnberry Isle","1831":"American Express JP","1832":"Renault","1833":"Rutgers Camden","1834":"Peter\'s Ice Cream","1835":"iJam Advertiser","1836":"babymed.com Advertiser","1837":"bestplaces.net Advertiser","1838":"Dankz Furniture","1839":"St George","1840":"Allure Media Australia Advertiser","1841":"Dairy Farmers of Canada","1842":"Epic Games","1843":"Poker (Octopus Media)","1844":"Big Lots","1845":"ronhazelton.com Advertiser","1846":"Secretaria de Agricultura (Octopus Media)","1847":"Holiday Inn","1848":"BluTonic Advertiser","1849":"Sobey\'s & Safeway","1850":"Netflix (AU)","1851":"NAC","1852":"Subaru","1853":"Sisley","1854":"Adidas Japan","1855":"AU Creative Test","1856":"Dunkin Donuts","1857":"Bloomingdales","1858":"Odysea","1859":"eBay","1860":"CU Boulder","1861":"University Health Systems","1862":"Tobacco Free Florida","1863":"H&M (Octopus Media)","1864":"Caroline or Change","1865":"Jacob\'s Creek","1866":"Branston Pickle","1867":"Yahoo","1868":"Rage","1869":"Sugardale Hotdog","1870":"IN LINE MEDIA","1871":"Nuveen","1872":"Inline Media Inc","1873":"Stop & Shop","1874":"Can-Am","1875":"Public Health England","1876":"Sequential Brands Group","1877":"Dreamworld","1878":"Flybe","1879":"Data Tailor INC  Advertiser","1880":"Deckers Japan","1881":"Crafta Inc Advertiser","1882":"MIC Japan","1883":"Hewlett Packard","1884":"Visit Jersey","1885":"Motor Planning Advertiser","1886":"Kowakogyo","1887":"The Bathroom Showroom","1888":"Campari","1889":"Marks & Spencer","1890":"Blue Cross / Blue Shield Alabama","1891":"Cremo","1892":"Look Kiero","1893":"Nissan Japan","1894":"85Sixty","1895":"Alterra","1896":"Nutrish","1897":"Chiba Kogyo Bank","1898":"Facebook","1899":"REI","1900":"Central Montana","1901":"Gila Rivers Gaming Enterprises","1902":"Truth Initiative","1903":"DiGiorno","1904":"Australian Government","1905":"WWE","1906":"StackSports.com Advertiser","1907":"Dropbox","1908":"Danone Japan","1909":"Panasonic Japan","1910":"Softbank Japan","1911":"Stokke Japan","1912":"Lotte Japan","1913":"BeBit Japan","1914":"House Japan","1915":"JNTO","1916":"Mitsui Sumitomo Bank","1917":"AM Resorts","1918":"Aladdin","1919":"Trade House Media Advertiser","1920":"Ben & Jerry\'s (AU)","1921":"Metropolitan Washington Airports Authority","1922":"VNN Sports Advertiser","1923":"Gault&Millau","1924":"Albion","1925":"Paramount Pictures","1926":"Suncorp (Australia)","1927":"Atlanta Botanical Garden","1928":"Natural History Museum","1929":"Toyota","1930":"Eucerin","1931":"B2 AdOps Advertiser","1932":"Constellation Energy","1933":"Sloggi","1934":"MEMOCO co., Ltd. Advertiser","1935":"Ego Pharmaceuticals","1936":"Fiji Water","1937":"Wingstop","1938":"Encore Resorts","1939":"Meishoku","1940":"Cabot Creamery","1941":"Phantom of the Opera","1942":"Harry Potter","1943":"The Children\'s Hospital at Westmead","1944":"Boots (IE)","1945":"Johnson Insurance","1946":"Odeon","1947":"Visit Baltimore","1948":"GMO AD Marketing - SSP Advertiser","1949":"My Navi Woman Advertiser","1950":"Subway","1951":"Disney Streaming Services","1952":"United Healthcare Group","1953":"Toyo Tires","1954":"Quo Card","1955":"Honda","1956":"Irvine Management Co.","1957":"NEC Japan","1958":"Pier 1 Imports","1959":"Group SEB Japan","1960":"Nespresso Japan","1961":"Sony Playstation","1962":"Century 21","1963":"Pocket Nation","1964":"IA Medicaid","1965":"Jimmy John\'s","1966":"CCM","1967":"Recruit Staffing JP","1968":"Orkin","1969":"SBS","1970":"GumGum Japan Test","1971":"UC Berkeley","1972":"Valley Metro","1973":"My Fair Lady","1974":"Freddie Mac","1975":"Merial","1976":"Esso","1977":"Google Japan","1978":"Alterra Mountain Co.","1979":"7-Eleven","1980":"Tapi Carpets","1981":"Chase Pulse","1982":"Department of Health","1983":"TheWrap.com Advertiser","1984":"Crescent Tools","1985":"Royal Caribbean Cruises","1986":"Zoetis, Inc.","1987":"Bay Area Credit Unions","1988":"Paramount (AU)","1989":"Sapporo Beer","1990":"Hotel Nikko","1991":"Shueisha.inc Advertiser","1992":"Wet n Wild","1993":"Red Hat","1994":"Wowow","1995":"Hampton Court","1996":"Roomba","1997":"GumGum Product Test - Analytics","1998":"Museum of London","1999":"EE","2000":"Eurosport","2001":"Lexus (AU)","2002":"Caesars Entertainment","2003":"Tourism Tasmania","2004":"All About Navi Advertiser","2005":"MECU","2006":"Epix","2007":"TD Bank","2008":"Biogen","2009":"Merivale","2010":"Volkswagen IE","2011":"Cathay Pacific","2012":"CrowdLab Advertiser","2013":"Walgreens","2014":"VSP","2015":"Hawaii Tourism Authority","2016":"Mamma Mia","2017":"Motiv31 Proper Passback","2018":"Entre co.,Ltd","2019":"Beauty Experience","2020":"OrthoFX","2021":"Save The Children","2022":"Motiv31","2023":"GoPro","2024":"Jaguar Land Rover (Japan)","2025":"INOVA Schar Cancer Institute","2026":"Encore Boston Harbor","2027":"Autoc One Advertiser","2028":"Mainline Health","2029":"Viant","2030":"Citroen","2031":"Choice Hotels","2032":"Dole Foods","2033":"GWR","2034":"Ad Frontiers Passback","2035":"Ad Frontiers Advertiser","2036":"Vermont Department of Tourism & Marketing","2037":"Indeed","2038":"Hard Rock Cafe","2039":"Dow","2040":"King Kong","2041":"Mountain Dew","2042":"Kindred Group","2043":"Caterpillar Inc.","2044":"The Nature Conservancy","2045":"Citizen Japan","2046":"Jeep Europe","2047":"Pennsylvania Lottery","2048":"Immediate Media Passback","2049":"CDC Sepsis","2050":"RAM Canada","2051":"Airbnb","2052":"Salesforce","2053":"House Districts","2054":"Hadestown","2055":"World Vision","2056":"Immediate Media Advertiser","2057":"Z Plus Music","2058":"JCB","2059":"JD Sports","2060":"MindAd Media  Advertiser","2061":"HMT Associates","2062":"W.I. System","2063":"SK-II","2064":"AltaMed","2065":"Efficiency Vermont","2066":"Welch\'s","2067":"Natrol","2068":"9dots Media Advertiser","2069":"SF MOMA","2070":"Foundation Medicine","2071":"Cancer Treatment Centers of America","2072":"BWW Media Group Advertiser","2073":"Exxon Mobil - UK","2074":"Bengoshi Dot Com","2075":"NARS Cosmetics","2076":"Walt Disney Japan","2077":"Dyson Japan","2078":"Nando\'s Peri Peri","2079":"DumDums","2080":"Adobe Systems Japan","2081":"General Mills","2082":"The Keg Steakhouse + Bar","2083":"Takeda Pharmaceuticals","2084":"Legoland UK","2085":"Microsoft Australia","2086":"Norfolk Southern","2087":"Breeder\'s Cup","2088":"Jet2","2089":"Audi","2090":"University of Missouri","2091":"El Financiero Advertiser","2092":"Jack in the Box","2093":"Lancome","2094":"Ken\'s","2095":"Orix","2096":"Karada Factory","2097":"The Metropolitan Opera","2098":"Lexus","2099":"KAO Japan","2100":"The Telegraph Advertiser","2101":"South Carolina Parks Recreation and Tourism","2102":"Kanebo","2103":"Godiva","2104":"Audi Japan","2105":"SheaMoisture","2106":"Gold Global Pty Ltd Advertiser","2107":"Eurostar","2108":"SCANA Energy","2109":"Pure Storage","2110":"Gemological Institute of America","2111":"Kodansha Ltd. Advertiser","2112":"Iceland","2113":"Sanrio","2114":"Deluxe Corporation","2115":"Co-Op - HVCB 2019","2116":"HVCB","2117":"EMX Digital","2118":"South Western Railway","2119":"Movies Anytime","2120":"Priorities USA","2121":"Museum of Contemporary Art - Toronto","2122":"grape Advertiser","2123":"Godiva","2124":"Audley Travel","2125":"Office of Director of National Intelligence","2126":"ONE COMPATH CO., LTD Advertiser","2127":"Mindbody","2128":"Yakult","2129":"Sony Pictures","2130":"Certified Financial Planners","2131":"NFON","2132":"Jalpak","2133":"London Zoo","2134":"InnovAge","2135":"Rao\'s Soup","2136":"McDonalds Japan","2137":"Panda Restaurant Group","2138":"Swiss Airlines","2139":"GoDaddy","2140":"& Juliet","2141":"Disney+","2142":"Kristin Chenoworth Concert","2143":"Adidas APAC","2144":"Interac","2145":"Ally Financial","2146":"Lightbox Jewelry","2147":"Medicaid","2148":"Stash Tea","2149":"Pet Shelter Project","2150":"Rakuten TV","2151":"Energizer","2152":"Corelle Brands","2153":"Howard Hughes","2154":"Gala Bingo","2155":"EA Games","2156":"Newell Brands","2157":"Performash","2158":"IHI corporation","2159":"Pendry Residences","2160":"Children\'s Hospital","2161":"USJ LLC","2162":"Princess Cruises","2163":"Group SEB","2164":"Singapore Airlines","2165":"Excellus","2166":"The Body Shop","2167":"Aramco","2168":"Aramco","2169":"Adyen","2170":"Mailchimp","2171":"Microsoft Japan","2172":"Rakuten","2173":"Sony Sonpo","2174":"Michael Hill Jewelers","2175":"Andrew Yang for President","2176":"WestJet","2177":"Orbis","2178":"Car and Classic Advertiser","2179":"Wendy\'s","2180":"TK Maxx","2181":"Storck Brands","2182":"Helzberg Diamonds","2183":"Majesty Golf","2184":"Nature Made","2185":"PUIG","2186":"Luminary","2187":"General Motors","2188":"Kroger","2189":"PGA Europe","2190":"E-Verify","2191":"Best Friend\'s Animal Society","2192":"Snow brand","2193":"Dior Japan","2194":"WMF Japan","2195":"SC Johnson","2196":"Apollo Theater","2197":"Reach PLC Advertiser","2198":"LINE Securities","2199":"Supership","2200":"Cineworld","2201":"Deep Heat","2202":"Johnson and Johnson Japan","2203":"HBO UK","2204":"Livescore.com Advertiser","2205":"Hotel Okura","2206":"JT","2207":"Menuhin","2208":"Gulf News Advertiser","2209":"Kyocera","2210":"Hawaiian Airlines Japan","2211":"Genesys","2212":"DE Lottery","2213":"Studio Bombshell","2214":"Vauxhall","2215":"National Rail Advertiser","2216":"Amarin Pharma Inc","2217":"Goldman Sachs","2218":"Schwartz","2219":"Zejula","2220":"Cloudera","2221":"This Works","2222":"Branson Tourism","2223":"Danone","2224":"Visit Sarasota County","2225":"Pasona","2226":"Deloitte","2227":"GNC","2228":"Time Out Advertiser","2229":"Jiffy Lube","2230":"Little Caesars","2231":"Endo Pharmaceuticals","2232":"BJ\'s Restaurant Group","2233":"Wildlife Conservation Society","2234":"Tasty Bite","2235":"A-Max Insurance","2236":"Asahi Soft Drinks","2237":"SEIKO","2238":"Tokyu Livable","2239":"First Watch","2240":"Raising the Roof","2241":"Gaitame","2242":"GignoSystem Japan Advertiser","2243":"Daiwa Securities","2244":"Children\'s Hospital Fredricksburg","2245":"Mary Brown\'s","2246":"Peugeot","2247":"Peugeot","2248":"Chunichi Shimbun Advertiser","2249":"Equinox","2250":"yotsuba","2251":"thesportsdrop.com Advertiser","2252":"USGA","2253":"Asics Japan","2254":"MAC Cosmetics","2255":"Hourglass Cosmetics","2256":"Shikigaku","2257":"Dune","2258":"PlutoTV","2259":"Great London Authority","2260":"CREXi","2261":"Interspace co., ltd Advertiser","2262":"Vanguard","2263":"Activision","2264":"Riot Games","2265":"Nintendo","2266":"Ubisoft","2267":"CocaCola Japan","2268":"Pfizer","2269":"Caleres","2270":"Tabasco","2271":"Express","2272":"Visa","2273":"Oglethorpe University","2274":"Kawasaki Heavy Industries","2275":"Church & Dwight","2276":"Apartments.com","2277":"Fuji News Network, Inc Advertiser","2278":"Home Hardware","2279":"Brahmin","2280":"Daiichisankyo","2281":"Credit Saison","2282":"Ralph Lauren","2283":"Hyundai","2284":"United States Coast Guard","2285":"Zespri Kiwifruit","2286":"Shiseido","2287":"Traeger Grills","2288":"Indeed Japan","2289":"Peak Media","2290":"AcuityAds","2291":"Hill\'s Pet Food","2292":"vgb.bg Advertiser","2293":"Celgene Pharmaceuticals","2294":"Celege Pharmaceuticals","2295":"BLACKROCK Japan","2296":"Check A Trade","2297":"99 Cent Store","2298":"Mandom","2299":"SC Johnson Japan","2300":"Shinsei Bank","2301":"Dell","2302":"Florida Virtual School","2303":"Elanco","2304":"USA Today Sports Advertiser","2305":"Michael J Fox Foundation","2306":"PhRMA","2307":"Versus Arthritis","2308":"Manta.com (Publisher)","2309":"Manta Publisher","2311":"Manta Advertiser","2312":"The Publisher Desk Advertiser","2313":"JT Mega","2314":"Career College Japan","2315":"FIGR","2316":"Index Exchange","2317":"Jergens","2318":"Quikrete","2319":"Instacart","2320":"Innocent","2321":"Zevo","2322":"Prairie Fresh","2323":"Dollar Shave Club","2324":"Nintendo","2325":"Slack","2326":"Burt\'s Bees","2327":"Western Governors University","2328":"Drone Racing League","2329":"Jergen\'s (CA)","2330":"Biohaven","2331":"Pfizer (CA)","2332":"Les Schwab","2333":"Square Japan","2334":"Domino Sugar","2335":"Monetize Partner Advertiser","2336":"Ninlaro","2337":"Nagase","2338":"Bug Botanist","2339":"Schlage","2340":"Aston Martin","2341":"Sunstar Japan","2342":"Resorttrust JP","2343":"Compassion International Inc.","2344":"Accenture Japan","2345":"Exelon","2346":"Grass Roots Neighbors","2347":"Microsoft","2348":"Sonic","2349":"Towa Pictures","2350":"California Milk Advisory Board","2351":"Philip Morris International (PMI)","2352":"Boston Globe","2353":"Likewise","2354":"Petoskey","2355":"NatureLab","2356":"Howard\'s Appliances","2357":"Samsung Global (JP)","2358":"Mrs. Meyers","2359":"Trojan","2360":"Alexandria Ocasio-Cortez","2361":"Jamaal Bowman","2362":"Reckitt Benckiser Japan","2363":"Otsuka Kagu","2364":"NH Medicaid","2365":"Tweed by Canopy","2366":"Nikkei Inc. Advertiser","2367":"Supergoop","2368":"Oxy Core","2369":"Holy Cross Hospital","2370":"National Diamond Council","2371":"Popeye\'s Louisiana Kitchen","2372":"Conduent","2373":"Supergoop - US","2374":"GuideWell Emergency Doctors","2375":"Rokinren Bank","2376":"Luray Caverns","2377":"Welch\'s (CA)","2378":"California Government","2379":"V Shred","2380":"Clif","2381":"Democratic Congressional Campaign Committee","2382":"NInlaro","2383":"Japan Cloud Capital","2384":"The Cellular Connection","2385":"Altra","2386":"NEW ART CIMA Co.,Ltd","2387":"Boy Scouts of America","2388":"Bumble Bee Seafoods","2389":"Tempur Japan","2390":"Subway","2391":"iRobot","2392":"Bigen","2393":"Florida Blue","2394":"Aireloom","2395":"Boost Mobile LLC","2396":"ITmedia Inc Advertiser","2397":"Cherry Creek North","2398":"Solar Together","2399":"Andersen Windows","2400":"Weedmaps","2401":"Explore Minnesota","2402":"Club Med","2403":"Vote From Home","2404":"DivaCup","2405":"Ojai Valley Inn","2406":"Stanford Children\'s Hospital","2407":"Chef Merito","2408":"Biden for President","2409":"Western Canada Lottery Corporation","2410":"Principal Financial","2411":"Brita","2412":"Zeta","2413":"UC Colorado Springs","2414":"ServiceNow","2415":"Monster Energy","2416":"Zicam","2417":"Steve Bullock","2418":"Cigna","2419":"Colorado Springs Utilities","2420":"Government of the United Kingdom","2421":"Charlotte Regional Visitors Authority","2422":"DAC Group","2423":"Joni Ernst","2424":"Virginia State Police","2425":"Inbrija","2426":"Yamasaki Lasana","2427":"OERB","2428":"Realogy","2429":"Experience Prince Georges County","2430":"Foxy Bingo","2431":"Crash Media passback","2432":"Energy Trust of Oregon","2433":"Experience Kissimmee","2434":"Mavenclad","2435":"Dos Equis","2436":"Progress NC","2437":"Riunite Wine","2438":"Circle K","2439":"PWC","2440":"NatureSweet","2441":"Smartwool","2442":"Virginia Housing Development Authority (VHDA)","2443":"NorCal Toyota","2444":"Skip the Dishes (CA)","2445":"Brennan Center","2446":"Be a Hero PAC","2447":"Ontario Power Generation","2448":"Ontario Power Generation (CA)","2449":"York U","2450":"F.Y. Eye Inc","2451":"Finkenauer for Congress","2452":"Kakaku.com Advertiser","2453":"RTB House","2454":"314 Action Fund","2455":"BLM West LA","2456":"Nevada Health Link","2457":"GH Bass","2458":"BuzzFeed Japan Corporation Advertiser","2459":"Forward California","2460":"Accenture","2461":"Becel","2462":"Travel Nevada","2463":"Mitsubishi Electric","2464":"Ultimate Kronos Group","2465":"MTG Co. Ltd","2466":"AppBank Inc. Advertiser","2467":"Hasbro","2468":"Erath Winery","2469":"MoneyFarm","2470":"University of Arizona","2471":"Cannabis - 48 North (CA)","2472":"Sony Interactive Entertainment Inc","2473":"Audi (US)","2474":"Demand Justice","2475":"Specsavers","2476":"PopSockets","2477":"Fever-Tree","2478":"Mercedes Benz Japan","2479":"Penguin Random House","2480":"Hasbro","2481":"Happy Egg","2482":"One Love","2483":"Pacifica Beauty","2484":"Dynabook Japan","2485":"Facebook Japan","2486":"KEEN Footwear","2487":"Miller Lite","2488":"Reno Sparks","2489":"Canon (CA)","2490":"Nomura Holdings","2491":"SAP Concur Japan","2492":"Porsche US","2493":"PayPal Japan","2494":"Korent Hemp","2495":"Korent Hemp (US)","2496":"International Animal Rescue","2497":"Nestle Japan","2498":"Truist","2499":"Georgetown School of Continuing Studies","2500":"Organigram","2501":"IKEA Japan","2502":"actindi Advertiser","2503":"Glentel","2504":"Tourism Santa Fe","2505":"Takeda Consumer Healthcare","2506":"Porsche (CA)","2507":"AmeriSave","2508":"Chiquita","2509":"Danner","2510":"Tesco Mobile","2511":"Imperial Tobacco Japan","2512":"Warnock for Senate","2513":"Coca Cola (CA)","2514":"NY529","2515":"Visit Seattle","2516":"Affirm","2517":"Zircon","2518":"Urban List Advertiser","2519":"Sparkling Ice","2520":"EA Games","2521":"Fossil","2522":"Fossil","2523":"Church\'s Chicken","2524":"Lactalis","2525":"NerdWallet","2526":"Angelino\'s Coffee","2527":"Uniworld Group","2528":"Amelia Island Convention and Visitors Bureau","2529":"NTT DATA","2530":"Dentsu Japan","2531":"Lexus","2532":"Sambazon","2533":"Celebrity Cruises","2534":"Aldi Grocery Store","2535":"Truvia","2536":"Merrell","2537":"Buick (CA)","2538":"Slack Japan","2539":"Edison","2540":"Kijiji Auto","2541":"Squarespace","2542":"Recruit Sumai Company","2543":"American Healthcare Association","2544":"NGK INSULATORS","2545":"Burt\'s Bees","2546":"Sky Media Advertiser","2547":"Network 10","2548":"Donato\'s Pizza","2549":"Hawaii Central Pacific Bank","2550":"GMC","2551":"Blue Nile","2552":"AINU Upopoy","2553":"Electrolux Japan","2554":"Vyne Therapeutics","2555":"Northern Light Health","2556":"Novant","2557":"BandLab Passback Advertiser","2558":"Hudson Yard","2559":"Aflac","2560":"UK Bauer Media Advertiser","2561":"Dove","2562":"National Science Foundation","2563":"Dove","2564":"Ajinomoto Foods","2565":"Tag Heuer Japan","2566":"KFC Japan","2567":"Sony Network Communications","2568":"Breakthrough Energy","2569":"Quest Diagnostics","2570":"Scottish Government","2571":"Chevrolet (CA)","2572":"FCA Japan","2573":"IG Securities Limited","2574":"Asahi Group Foods","2575":"Nationwide UK","2576":"BECU","2577":"Bank of Colorado/Pinnacle Bank","2578":"Smart & Final","2579":"Daily Mail","2580":"Leviton","2581":"Improve Digital","2582":"Weblio Inc. Advertiser","2583":"Togetter Inc. Advertiser","2584":"PODS","2585":"Quatreau","2586":"Rhythm Energy","2587":"PayPay","2588":"Camelot","2589":"Connections Academy","2590":"Dr Oetker","2591":"Acadia Healthcare","2592":"Mark Anthony Wines","2593":"University of Waterloo","2594":"People\'s United Bank","2595":"Henkel (CA)","2596":"DeepIntent","2597":"Fusosha Advertiser","2598":"Create Sustainably","2599":"Biossance","2600":"End Citizens United","2601":"Blue Bunny","2602":"TaylorMade","2603":"Nippon Life Insurance Company","2604":"Huffington Post Japan Advertiser","2605":"HuffPost Japan, Ltd. Advertiser","2606":"Illuminarium Experiences","2607":"TransUnion","2608":"Green Mountain Energy","2609":"Boar\'s Head","2610":"NetJets","2611":"Advent Health","2612":"pixiv Inc. Advertiser","2613":"Official Charts Advertiser","2614":"Montane","2615":"Glass House Farms","2616":"NeoCell","2617":"Ortho Clinical Diagnostics","2618":"Alfa Romeo","2619":"Taylor Farms","2620":"Stellantis","2621":"Visit Telluride","2622":"BEAMS","2623":"Makita Corporation","2624":"Princess Cruises","2625":"H&S","2626":"E & J Gallo","2627":"Craftsman","2628":"Red Bull","2629":"P&O Cruises","2630":"Archant Advertiser","2631":"Savencia Fromage","2632":"Patron","2633":"Lionsgate","2634":"Chowie Wowie","2635":"Canaca","2636":"Magnite","2637":"Garrison Hughes","2638":"Cresco Sunnyside","2639":"Scott\'s Miracle Gro","2640":"DNU","2641":"Splash Wines","2642":"Hipp Q2 2021","2643":"Hipp Organic","2644":"Fedex","2645":"Otsuka Pharmaceutical Co., Ltd.","2646":"Athleta","2647":"Tastes of Chicago","2648":"CAS","2649":"Disney Home Entertainment","2650":"3 in 5","2651":"Empire State Building","2652":"Meals on Wheels","2653":"Batiste","2654":"Froneri","2655":"Scotch Brite","2656":"Scotch Brite","2657":"Virginia Tourism","2658":"OC Fair","2659":"Ontrak","2660":"Luminis","2661":"ACEs Aware","2662":"ABC Liquor","2663":"ASUS JAPAN","2664":"Stagecoach","2665":"Equativ","2666":"TrueCar","2667":"Mirror","2668":"mitsui sumitomo card","2669":"Warner Brothers UK","2670":"Radisson Hotel Group","2671":"OTD Chesapeake Bay","2672":"RaceTrac","2673":"News Break","2674":"Affordable Art Fair UK","2675":"CIBC (CA)","2676":"Citylink","2677":"Next Trip Journeys","2678":"IBM","2679":"Inspira Health","2680":"Buro247 Advertiser","2681":"TaylorMade Japan","2682":"UK Pink Lady","2683":"Kevin Test","2684":"Kevin Test Advertiser","2685":"WATABE WEDDING CORPORATION","2686":"Whataburger","2687":"JHU Carey Business School","2688":"Telus","2689":"Twisted Tea","2690":"Nova Scotia Tourism","2691":"Doja Life","2692":"Aventura Travel","2693":"Coors Light","2694":"Nijito","2695":"Beverly Glen Laboratories Inc","2696":"Wacoal","2697":"Quidel","2698":"Vitamix","2699":"Luxottica","2700":"kanzen Ltd. Advertiser","2701":"PHILIPS Japan","2702":"Longchamp Japan","2703":"Casillero Del Diablo UK","2704":"McCormick","2705":"Freebie TV","2706":"Logitech","2707":"4Moms","2708":"IMC Toys","2709":"Shoe Show","2710":"Virgin Red UK","2711":"Southern Comfort","2712":"Alpecin","2713":"Crunch Fitness","2714":"DNU","2715":"Avanti West Coast Trains","2716":"Independence Blue Cross","2717":"Eisai","2718":"Farmer Focus","2719":"ALL HEARTS COMPANY","2720":"For it Advertiser","2721":"Kraft","2722":"Diageo","2723":"Parent Club","2724":"Day Out With The Kids Advertiser","2725":"CO-OP Food","2726":"Mosaic","2727":"Nexon","2728":"Costa Del Mar","2729":"Pocky","2730":"Visit Estes Park","2731":"Centers for Medicare and Medicaid Services (CMS)","2732":"Biofreeze","2733":"Virginia DMV","2734":"Clarins","2735":"American Bridge PAC","2736":"ICE","2737":"Visit Britain","2738":"Diageo UK","2739":"Hays Recruiting","2740":"Henkel AU","2741":"Carter\'s","2742":"Birmingham 2022 Commonwealth Games","2743":"JAMR","2744":"Braze","2745":"Maruchan","2746":"National Honey Board","2747":"RDG","2748":"MetLife Japan","2749":"aeropostale","2750":"Royal Bank of Canada","2751":"Signet","2752":"zdo not use","2753":"Oriental Trading Company","2754":"California Lutheran University","2755":"Sargento","2756":"IRIS OHYAMA","2757":"P&O Ferries","2758":"Indiana University","2759":"Crystal Ski","2760":"Corby Spirit and Wine","2761":"Florajen","2762":"Bridges Consumer Healthcare","2763":"MTD Products Inc","2764":"Evergreen","2765":"Providence Health","2766":"SecFi","2767":"El Pollo Loco","2768":"Simply Media Advertiser","2769":"Major7","2770":"KPMG","2771":"Instagram","2772":"Burlington International Airport","2773":"FabFitFun","2774":"MGA Entertainment","2775":"Nectar","2776":"Deterra System","2777":"OLG","2778":"Rogers Theo","2779":"Western Union","2780":"Advise Insurance","2781":"Superfly","2782":"Epic","2783":"CareFirst","2784":"Certiport","2785":"Regeneron","2786":"Insomnia Cookies","2787":"MerakiGo","2788":"National Geographic","2789":"Party Casino","2790":"York School","2791":"STAIRGE","2792":"Ineos","2793":"Plymouth Gin","2794":"Pfizer Japan","2795":"MDLIVE","2796":"Brown Forman","2797":"Lenovo","2798":"Florida Keys Vacation Rentals","2799":"Woodford Reserve","2800":"FAO Schwarz","2801":"Augusta Precious Metals","2802":"Sharper Image","2803":"Morrisons","2804":"Baxter Credit Union","2805":"Experience Sioux Falls","2806":"Homesense","2807":"Online Casino Canada","2808":"Yuengling","2809":"Publicis AU","2810":"Zippo","2811":"Athenahealth","2812":"Lenovo US","2813":"Lundberg Family Farms","2814":"Network Rail UK","2815":"Playa Resorts","2816":"ASPCA","2817":"Spin Master","2818":"Aioi Nissay Dowa Insuarance","2819":"NavyArmy Community Credit Union","2820":"Nishinippon Shimbun Advertiser","2821":"Nishinippon Shimbun Advertiser -use this","2822":"First Tech Federal Credit Union","2823":"SUNTORY JP","2824":"General Motors Japan","2825":"Disney Broadway UK","2826":"Harry Winston","2827":"Paylocity","2828":"Kraft Heinz Company Japan","2829":"Ace Contact","2830":"FUJIFILM","2831":"Victoria\'s Secret","2832":"Sanford Health","2833":"Ember Fund","2834":"Calpol J&J","2835":"Honda Powersports","2836":"FILA","2837":"MINI","2838":"Fine Wine & Good Spirits","2839":"NCSOFT Corp JP","2840":"Ecco Co.","2841":"Lottery Now","2842":"Lenovo Japan","2843":"Virgin Money","2844":"Washington Department of Health","2845":"San Diego Gas & Electric","2846":"Starbucks US","2847":"Sumitomo Mitsui Card Co., Ltd.","2848":"Arterra Wines Canada Inc","2849":"Glow Recipe","2850":"Maggie Hassan","2851":"Mall of America","2852":"National Book Tokens","2853":"Advanced Auto Parts","2854":"Canopy - 7ACRES","2855":"Columbia","2856":"Withings, Inc","2857":"Santander","2858":"Amazon Web Services","2859":"Direct Auto","2860":"Lucid Motors","2861":"ACOM CO., LTD.","2862":"Fasthosts","2863":"Orajel","2864":"Remy Martin","2865":"Fender","2866":"Michael Kors","2867":"Forever21","2868":"Add3","2869":"AllianceBernstein Japan Ltd","2870":"Sumally","2871":"ExxonMobil","2872":"Sound United","2873":"TSB","2874":"Danone","2875":"Washington Tourism Alliance","2876":"Morris Brown","2877":"Duke Energy","2878":"Edge Holiday","2879":"Broadpeak","2880":"Kumon Institute of Education Co., Ltd.","2881":"Very","2882":"Company The Muiscal","2883":"Under Armor","2884":"Nassau Paradise Island","2885":"Atlantic Union Bank","2886":"Acorn TV","2887":"AG Barr","2888":"Kanposeimei JP","2889":"Koiwai Dairy Products Co Ltd","2890":"The First Years","2891":"Personal Capital","2892":"AMD","2893":"Good Samaritan Society","2894":"Epson","2895":"Earth\'s Own","2896":"Presidential Inaugural Committee","2897":"Mitsubishi UFJ NICOS JP","2898":"Revanesse","2899":"Magic Mike Live","2900":"JustPremium Test","2901":"HOBO","2902":"Missouri Foundation for Health","2903":"Healthcare Education Project","2904":"Johnsonville Sausage","2905":"Sky TV Europe","2906":"Sky TV","2907":"Cleveland Clinic","2908":"SkinnyPop","2909":"Wilko","2910":"Met Opera","2911":"Alaska Airlines","2912":"Pioneer Japan","2913":"Kamran Test Advertiser","2914":"Intel","2915":"SVS Sound","2916":"Comfort Dental","2917":"Human Rights Campaign","2918":"Weathernews Advertiser","2919":"Peraton","2920":"IHG Japan","2921":"Jameson Whiskey","2922":"Walkers Doritos","2923":"Kampgrounds of America","2924":"Travel Centers for America","2925":"The Small and Medium Enterprise Agency JP","2926":"Colorectal","2927":"JustPremium Test - USD","2928":"NHK","2929":"Southern Environmental Law Center","2930":"UNHCR","2931":"Miidas","2932":"Rimowa Japan","2933":"Purina","2934":"Space Coast Credit Union","2935":"Brooklyn Academy of Music","2936":"South Dakota Tourism","2937":"Carleton University","2938":"Fitcrunch","2939":"Toyota UK","2940":"Currys","2941":"donate unrefugees","2942":"Bread Financial","2943":"British Airways","2944":"Care USA","2945":"Bridgestone","2946":"Vans","2947":"Kohler","2948":"Arm & Hammer","2949":"Pennington","2950":"Fluct Inc Advertiser","2951":"Laurel Road","2952":"Roundabout Theatre Company","2953":"Sunglass Hut","2954":"Japan Securities Dealers Association","2955":"Influent Media Advertiser","2956":"Dafalgan","2957":"New York Pizza","2958":"Dairy Queen","2959":"Fenwicks","2960":"Sephora","2961":"Dentsu - DE","2962":"Bosch DE","2963":"Live Kindly","2964":"Samsung EU","2965":"The Keg Steakhouse + Bar","2966":"Sony Pictures EU","2967":"McDonalds","2968":"Warner Bros EU","2969":"Spadel","2970":"UKTV","2971":"Fox Nation","2972":"Erdel Rex","2973":"Visit Duluth","2974":"Ferrero EU","2975":"ReserveBar","2976":"Intratuin","2977":"Proximus","2978":"SAP DE","2979":"Candy Digital","2980":"Guitar Center","2981":"Jumbo","2982":"Realty Mogul","2983":"Leafly","2984":"LVM","2985":"vluchteling","2986":"Lidl","2987":"Heinz Sielmann","2988":"AEG BE","2989":"Gucci Ltd","2990":"CNN+","2991":"HSBC","2992":"Bell Canada","2993":"Haagen Dazs","2994":"Espace Plomberium","2995":"Canada Goose","2996":"TePe","2997":"Van de Velde","2998":"YARUKI Switch Group JP","2999":"Jack Daniels","3000":"UPI BE","3001":"Engie","3002":"Disney Movies/Dewynters","3003":"Golden Hippo","3004":"Dave Perry Miller","3005":"Enterprise Rent-A-Car","3006":"Enterprise Rent-A-Car","3007":"Nintendo","3008":"D\'Ieteren","3009":"Napoleon Grills","3010":"Bol.com","3011":"Maine Spirits","3012":"Sat1","3013":"Flughafen M\xfcnchen","3014":"IndyCar","3015":"BMVG","3016":"GRAIL","3017":"Tim Horton\'s","3018":"Somfy","3019":"Daimler","3020":"Just Eat for Business","3021":"Loterie Nationale","3022":"Watchguard Tech","3023":"Jacqmotte","3024":"Sundance Now","3025":"\xd8rsted","3026":"AMC+","3027":"ALLBLK","3028":"Ikeda Mohando","3029":"Keytrade","3030":"Contigo","3031":"KAO Brands","3032":"Perrigo (NiQuitin)","3033":"Chattanooga Tourism Company","3034":"TePe DE","3035":"EG","3036":"Coca-Cola","3037":"Sam Houston State University","3038":"Olgam Live Plasma","3039":"Media Markt BE","3040":"RealtyMogul","3041":"MSD K.K","3042":"Bijenkorf","3043":"Mucho Burrito","3044":"Great Wolf Lodge","3045":"Connected Homes","3046":"Nivea DE","3047":"NY Pizza","3048":"Aldi","3049":"Wyndham Hotels","3050":"UFC","3051":"Mondelez EU","3052":"KBC","3053":"Aloysious Butler & Clark","3054":"Psycho Music","3055":"Miele","3056":"Bamboo HR","3057":"Kathy Hochul","3058":"London & Partners","3059":"Meijer","3060":"WorkHuman HR Software","3061":"Kaufland","3062":"Siemens","3063":"SAP","3064":"Bitcar","3065":"BitCar","3066":"Adobe Advertising","3067":"Vision Express","3068":"New Blue","3069":"Colruyt","3070":"seat","3071":"LiveRamp","3072":"Pocono Mountain Visitors Bureau","3073":"Direct Relief","3074":"Cupra Born","3075":"Centro Comercial Arena","3076":"Bock Development Group","3077":"Shudder","3078":"Frederick Wildman and Sons","3079":"Opel","3080":"Disney Theatrical","3081":"H&M EU","3082":"Japan Sport Council","3083":"Service Now","3084":"Tesco","3085":"Bacardi Europe","3086":"Panasonic","3087":"Klarna","3088":"Sony Pictures Europe","3089":"Emsa","3090":"Specsavers","3091":"Honibe","3092":"Loyola","3093":"Debbie Test Pub Advertiser","3094":"Patagonia","3095":"Share Now","3096":"Treo","3097":"Case IH","3098":"ASAHI BREWERIES, LTD.","3099":"Van den Borre","3100":"B2C Outcaring","3101":"Duvel","3102":"Cornet","3103":"Kruger","3104":"Universal Pictures EMEA","3105":"The Brick","3106":"Hyundai","3107":"Thomas Reuters","3108":"RedBull EMEA","3109":"Sun Life Financial","3110":"Dormimundo","3111":"ON24","3112":"Product - Erik - Inc USD","3113":"Product - Erik - NL EUR","3114":"Grand Optical","3115":"Danone","3116":"MA Treasury","3117":"Amex","3118":"Shady Grove Fertility","3119":"Stad BE","3120":"BitPanda","3121":"Tropical Smoothie Cafe","3122":"Cafe Rio","3123":"Sysdig","3124":"Medi Market","3125":"NRW Bank","3126":"Jack Daniels","3127":"Hiscox","3128":"States United to Prevent Gun Violence","3129":"The Baltimore Banner","3130":"8x4","3131":"Varta","3132":"IKK Classic","3133":"Disney Theatrical Group","3134":"Tennessee Tourism","3135":"Grifols","3136":"American Express UE","3137":"Freixenet","3138":"Circus","3139":"Free Now","3140":"Bombay Saphire","3141":"Everglades Foundation","3142":"Invincible Entertainment","3143":"Bet+","3144":"Turismo Navarro","3145":"Suzuki EMEA","3146":"SB12","3147":"Pernord Ricard","3148":"NYC&Co","3149":"American Express UK","3150":"Kingpin","3151":"Amazon","3152":"Reckitt UE","3153":"Spa Space","3154":"Mark Kelly","3155":"Pabst Blue Ribbon","3156":"Cedars Food","3157":"Qualcomm","3158":"Saputo","3159":"Adidas","3160":"Asana","3161":"Montana Office of Tourism","3162":"Panama City Beach","3163":"Arby\'s","3164":"Renault UE","3165":"US Department of Veterans Affairs","3166":"Chewy","3167":"Galderma","3168":"Cullen/Frost Bankers Inc","3169":"Hendriks Gin UE","3170":"Office Depot","3171":"Volkswagen UE","3172":"Danerolles","3173":"Product - Erik - GBP","3174":"Heineken UE","3175":"Attorney Charlie Hall","3176":"PSEG","3177":"DIAMOND Advertiser","3178":"Name.com","3179":"Five Star","3180":"Amazon UE","3181":"Sony Pictures UE","3182":"Sandals","3183":"Bundes Liga","3184":"TETRA Hotels","3185":"Hyperoptic","3186":"Dibbs","3187":"Wood Mackenzie","3188":"Shark Haircare","3189":"National Express","3190":"Mediavine","3191":"InMobi","3192":"Rituals NL","3193":"G500","3194":"Earth\'s Own","3195":"Studio Canal","3196":"Jaguar & Land Rover UE","3197":"Salem Five Bank","3198":"Hormel","3199":"Broadway Shows","3200":"Northern Rail","3201":"Uber Japan","3202":"Metrolinx","3203":"Picsart","3204":"Sky TV EU","3205":"Corning","3206":"U.S. Space & Rocket Center","3207":"Tchibo","3208":"Sick Kids Hospital","3209":"ITV","3210":"TikTok","3211":"Lego EMEA","3212":"Snowmass Tourism","3213":"Southern Glazer\'s Wine & Spirits","3214":"Santander Bank EMEA","3215":"Bebat","3216":"DHKT","3217":"Glade","3218":"The Ride","3219":"Hitachi","3220":"Bottega VEGA","3221":"Beobank","3222":"European Wax Center 2022","3223":"European Wax Center","3224":"Albertsons Companies, Inc.","3225":"Base","3226":"Coldwell Banker","3227":"Pepsico UK","3228":"PIZZA PIZZA","3229":"Braven Health","3230":"Something Navy","3231":"National University","3232":"SNCB","3233":"Lufthansa","3234":"Senator Catherine Cortez Masto","3235":"Katie Porter","3236":"The Global Fund","3237":"AUTOGRAPH PRODUCTIONS Advertiser","3238":"Stage Entertainment","3239":"Hisense","3240":"front-row.jp  Passback Campaign","3241":"Swedish Match","3242":"WellaNioxin","3243":"Maryland Department of Transportation (MDOT)","3244":"Hippo","3245":"ADP","3246":"kracie","3247":"Taisho Pharmaceutical","3248":"Teambank","3249":"Salesforce UK","3250":"McDonalds EMEA","3251":"ABI","3252":"Pennsylvania Horse Racing Association","3253":"Omnigov - DfE","3254":"GlaxoSmithKline CA","3255":"University of Colorado","3256":"GroupM Japan K.K.","3257":"Zyx","3258":"Pro7","3259":"Cotton Traders","3260":"Meta","3261":"Lidl","3262":"Inkey List","3263":"One Georgia","3264":"Vital Farms","3265":"NovoZymes","3266":"American Eagle","3267":"Dodl","3268":"Yeo Valley","3269":"Maryland Marketing Partnership","3270":"Hill House Home","3271":"Firehouse Restaurant Group, Inc.","3272":"J\xe4germeister","3273":"Bumble","3274":"Barclays","3275":"SC Johnson UK","3276":"Upper Canada College","3277":"World Vision","3278":"Panasonic","3279":"Ripple","3280":"Bacofoil","3281":"DNI","3282":"Universal Pictures UK","3283":"Nissan - BE","3284":"Citroen","3285":"Atlantis Bahamas","3286":"Lancome","3287":"Fuegorita","3288":"Prudential","3289":"Swarovski Japan Ltd","3290":"ASDA","3291":"Paramount","3292":"Gulf Oil","3293":"Perrigo BE","3294":"MTN Ops","3295":"Mercedes","3296":"Movember","3297":"DFDS","3298":"Barilla","3299":"National Aquarium","3300":"Children\'s Health of Dallas","3301":"Visit Philly","3302":"PZ Cussons","3303":"Irwin Mitchell","3304":"Jean Paul Gauthier","3305":"Lunya","3306":"Senate Majority Pac","3307":"Better Maine","3308":"Family Friendly Action PAC","3309":"Cyborg","3310":"Lagunitas Brewing Company","3311":"Cyborg Inc","3312":"VELTRA Inc. Advertiser passback","3313":"VELTRA Inc. Advertiser","3314":"Audible","3315":"Fnac","3316":"FindMyPast","3317":"Volt Lighting","3318":"Rust Oleum","3319":"University Games","3320":"Enfamil","3321":"FAST RETAILING CO., LTD.","3322":"Koala Sleep Japan KK","3323":"Karcher","3324":"Armageddon Time","3325":"Max Mara","3326":"Clarins","3327":"Disney/Publicis","3328":"Splunk","3329":"Hornblower Group","3330":"Media TradeCraft Advertiser","3331":"S&B Food","3332":"Melia","3333":"Pearson Education","3334":"Social Mobility Foundation UK","3335":"Qlik","3336":"Garmin","3337":"Peoples Postcode Lottery","3338":"Thalys","3339":"Adidas UK & IE","3340":"CB2","3341":"Jakks Pacific","3342":"Aeon Bank Ltd","3343":"Defra","3344":"Covid-19 Education","3345":"Krylon","3346":"Duluth Trading Company","3347":"Ryobi Technologies","3348":"wicked","3349":"YogiTea","3350":"X20","3351":"Don Davis","3352":"Marylebone Cricket Club","3353":"Mailchimp","3354":"Paramount+","3355":"Plutus Financial","3356":"Korbel","3357":"George Washington University","3358":"AdElement","3359":"Klinge Pharma","3360":"Dr. Schaer","3361":"Florida Crystals","3362":"RTL","3363":"Destination Canada","3364":"Network Rail","3365":"Global Industrial Services Inc","3366":"Weight Watchers UK","3367":"Northwell Health","3368":"Sunrise Senior Living, Inc","3369":"Medtronic","3370":"Barbados Tourist Board","3371":"JPMC","3372":"Sports Interaction","3373":"Petro Canada","3374":"Vanden Borre","3375":"KFC","3376":"Kobayashi Pharmaceutical Co Ltd","3377":"Sonatype","3378":"JDE Nordics","3379":"LiveScore","3380":"GOTV","3381":"Nuna Baby Essentials","3382":"UGG Japan","3383":"ICI Paris XL","3384":"Ralph Lauren","3385":"Bucherer","3386":"Apple UK","3387":"University of Central Lancashire (UCLAN)","3388":"Grisi","3389":"Petline","3390":"Master Card EU","3391":"Voo Internet","3392":"New York Lottery","3393":"GumGum","3394":"Jamieson Vitamins","3395":"Gulfstream Park","3396":"BVR","3397":"Cointreau","3398":"Carolina Herrera","3399":"Sun Valley Resort","3400":"Porter Airlines","3401":"Bermuda Tourism Board","3402":"1-800 Flowers","3403":"Mother Farm","3404":"The Out","3405":"Citizen Watches US","3406":"Dietz & Watson","3407":"Hain Daniels UK","3408":"Epson Japan","3409":"Grupo Bimbo","3410":"Stellantis","3411":"New Jersey Manufacturer\'s Insurance","3412":"Minnesota Lottery","3413":"Elecrify America","3414":"Middle East OmniGov - UK","3415":"Trustford","3416":"SIXT","3417":"Reckitt Benckiser UK","3418":"Great Ormand Street Hospital (GOSH)","3419":"Baha Mar","3420":"Yanmar Holding Co Ltd","3421":"James Villas","3422":"&BARR","3423":"Ceuta","3424":"AXA UK","3425":"Zott","3426":"Sunsweet Growers","3427":"Royal Society for the Protection of Birds (RSPB)","3428":"Av\xe8ne","3429":"Apple EU","3430":"USIM - US - New York","3431":"Flight Centre","3432":"Aldi UK","3433":"Disney Theatrical Productions UK/Dewynters","3434":"Norse US","3435":"McCoy\'s Building Supply","3436":"Williamsburg Tourism Council","3437":"New York Bakery","3438":"High Liner","3439":"CIT Bank","3440":"Government of Ontario","3441":"Talk Talk","3442":"Available Car","3443":"Mazda","3444":"Change The Bill","3445":"DVLA","3446":"La Compagnie","3447":"Burger King DE","3448":"Pandora","3449":"Vena Solutions","3450":"EE Limited","3451":"Polestar","3452":"Universal Pictures DE","3453":"Avera Health","3454":"The Newberry","3455":"e.l.f. Cosmetics UK","3456":"ELF Cosmetics USA","3457":"Grasshopper Co.","3458":"Spar BE","3459":"Kabel Eins","3460":"Full House Lottery","3461":"Tobacco-Free Kids","3462":"wwf","3463":"Arlington CVB","3464":"Azamara Cruise","3465":"Whole Earth Foods UK","3466":"American Beverage Association","3467":"US Air Force","3468":"Mondelez UK","3469":"Hawk","3470":"BAT","3471":"Brookfield Residential","3472":"SAPIX YOZEMI GROUP","3473":"Cytiva","3474":"VAI Resorts","3475":"SBI Holding, Inc.","3476":"Waitrose","3477":"Glendalough Double Barrel","3478":"Sumitomo Corporation","3479":"The White Company","3480":"Aktion Mensch","3481":"Dai Nippon Printing","3482":"Invesco","3483":"Bailey Nurseries","3484":"Alcon","3485":"Allegheny Health Network","3486":"Sensodyne","3487":"Cinemark","3488":"Virgin Atlantic","3489":"Vorboss UK","3490":"DENVER MUSEUM","3491":"SkyBet","3492":"Campari","3493":"Stonewall Charity","3494":"Ticketsmarter","3495":"Alibaba Cloud Japan","3496":"Paradise Advertising & Marketing, Inc.","3497":"Golden Palace","3498":"Idaho Potato Commission","3499":"Danone EU","3500":"Open University - EMEA","3501":"Dianomi","3502":"Estrid","3503":"Aurora DE","3504":"Coty UK","3505":"Proper Twelve","3506":"Paramount DE","3507":"Smart Energy GB","3508":"Treasury Wine Estates","3509":"Bauer UK","3510":"Doordash","3511":"SwedishMatch Austria","3512":"AG Insurance","3513":"Cortina","3514":"HaagenDazs UK","3515":"Pizza Hut Canada","3516":"\xd6sterreich Werbung","3517":"Nerds","3518":"H&M","3519":"Atlantic Lottery","3520":"Topps Tiles","3521":"Subaru DE","3522":"Synthroid","3523":"The Trevor Project","3524":"Meta (Facebook UK)","3525":"MobyLines","3526":"St.Tropez","3527":"FreeSat","3528":"Perrigo","3529":"Sage","3530":"American Opportunity","3531":"Canada Safety Council","3532":"Colorado Department of Transportation","3533":"Hudson Yards Group","3534":"Rally Credit Union","3535":"Madopi","3536":"Harris Teeter","3537":"Rohde&Schwarz","3538":"Gothaer","3539":"Coca-cola","3540":"Medical University of South Carolina","3541":"Sandy Hook Promise","3542":"Bank of Oklahoma","3543":"Boehringer Ingelheim","3544":"TKMaxx","3545":"The Canada Life Assurance Company","3546":"Caribou","3547":"Black Hills Energy","3548":"BOK Financial","3549":"Diageo Japan","3550":"Brico","3551":"Eucerin","3552":"Cottage Springs","3553":"JD Williams","3554":"South Carolina Education Lottery","3555":"Pluto TV","3556":"Dyson","3557":"SpotCo","3558":"Ontario Lottery and Gaming Corporation","3559":"MOTUL Japan","3560":"Internet Initiative Japan Inc.","3561":"NBrown UK","3562":"giffgaff","3563":"Nature\'s Way","3564":"Delaware North Companies Inc","3565":"Elitch Gardens","3566":"Atol","3567":"Eva Air","3568":"Viega Inc","3569":"Oscar Mayer","3570":"Wild Waves Theme & Water Park","3571":"Black Diamond","3572":"Colorado Behavioral Healthcare System","3573":"ButcherBox","3574":"Massachusetts State Lottery","3575":"Longwood Gardens Inc","3576":"La Chouffe","3577":"Rabobank","3578":"Parade (Broadway)","3579":"Zoro","3580":"Zoro","3581":"PopWorks","3582":"Spotifcar","3583":"ABI Goose Island","3584":"SONOS","3585":"Grammarly","3586":"Mochida Healthcare","3587":"Karl Lagerfeld","3588":"Chilly\'s Bottles","3589":"Nike EMEA","3590":"Disney+","3591":"Elizabeth Arden DE","3592":"Service Now UK","3593":"Rakuten","3594":"NEC Co","3595":"Dentsu","3596":"IQ Zone","3597":"Kaspersky","3598":"Memorial Sloan-Kettering Cancer Center Inc","3599":"La Colombe","3600":"Hansaplast","3601":"DNU","3602":"1800 Tequila","3603":"Avrio Health","3604":"Mercedes-Benz","3605":"Just for Men","3606":"Bonza","3607":"Impossible Food","3608":"SYFOVRE","3609":"WaltDisneyWorld UK","3610":"Kiko","3611":"Standard General","3612":"Dallas Zoo Management Inc","3613":"Dallas Zoo Management Inc","3614":"Identity Digital Inc.","3615":"ODK Media Advertiser","3616":"JAMRS","3617":"Asics","3618":"Glenfiddich","3619":"Bravecto","3620":"United Carpets","3621":"Centr","3622":"Molson Coors","3623":"MJ The Musical","3624":"97Percent Advocacy","3625":"Tsuji Culinary Institute","3626":"Betsson EUR","3627":"Mediabrands NL","3628":"Symplr","3629":"Pella Windows & Doors","3630":"Anschutz Medical Campus","3631":"zipcar","3632":"Ontario Place","3633":"Novo Nordisk","3634":"Birra Menabrea","3635":"Vet-Concept","3636":"Lenovo UK","3637":"Citizen DE","3638":"Mazda DE","3639":"North Italia","3640":"LCBO (Liquor Control Board of Ontario)","3641":"New Seasons Market","3642":"Lavera DE","3643":"RVR","3644":"Visit Napa Valley","3645":"WildAid","3646":"Ouga Japan","3647":"Oatly EU","3648":"VSA Partners","3649":"Cacique","3650":"Tomorrow Turf","3651":"OrthoCarolina","3652":"American Honda Finance Corporation","3653":"Incyte","3654":"Kimberly-Clark Corp.","3655":"AbbVie","3656":"William Grant & Sons (WG & Sons)","3657":"FUNDiT passback ADVERTISER not use","3658":"Tito\'s","3659":"FUNDiT Advertiser","3660":"Hyland\'s Naturals","3661":"John Varvatos","3662":"Leeds Hospitals Charity","3663":"Hema","3664":"& Juliet","3665":"20th Century Fox","3666":"Tempur Pedic","3667":"NJM Insurance","3668":"Trainline","3669":"Spendesk","3670":"GoodPlanet","3671":"Rogers","3675":"Canva","3676":"Heverlee","3677":"ScotRail","3678":"Chevron","3679":"Houston Methodist","3680":"Vaillant","3681":"Moosehead Breweries","3682":"General Mills","3683":"St. Louis Community College","3684":"e.l.f. Cosmetics","3685":"Great Western Railway (GWR)","3686":"Cross Country Trains","3687":"NIQ","3688":"GU Energy","3689":"Audible, Inc.","3690":"JERA","3691":"Bike Republic","3692":"Santa Monica","3693":"Macmillan","3694":"South Carolina Department of Agriculture","3695":"Shell Canada","3696":"Chester Zoo","3697":"Meta Platforms Inc","3698":"Jong&Out","3699":"University Of West Scotland","3700":"Home Instead","3701":"Ruth Strauss Foundation","3702":"Groupe SEB","3703":"Wings Financial","3704":"Okta","3705":"Playstation EU","3706":"Frameless","3707":"First Bus","3708":"Lodge Cast Iron","3709":"Situation Interactive","3710":"Kimberly Akimbo","3711":"Wicked","3712":"Congstar DE","3713":"Eggland\'s Best, Inc.","3714":"North Texas Tolltag Authority","3715":"Westfield UK","3716":"Moffitt Cancer Center","3717":"Shogakukan Advertiser","3718":"Green Cars","3719":"Maersk Company","3720":"Novuna","3721":"Disney Studios EU","3722":"Stone Mountain Park Association","3723":"ABI","3724":"GoDogGo","3725":"Allied Global Marketing","3726":"Stellantis","3727":"Betsson Group","3728":"Gemini Worktops","3729":"Britvic","3730":"Peavey Mart","3731":"La redoute","3732":"TNT Sports (bt sports)","3733":"American Indian College Fund","3734":"My daytrip","3735":"Borgata","3736":"La-Z-Boy","3737":"Vodafone DE","3738":"SlashNext","3739":"AI Media Group","3740":"Boston Medical Center","3741":"Gilead","3742":"Soreen","3743":"Snickers","3744":"Christie Lighting","3745":"Irving","3746":"PAMA Liqueur","3748":"PartenaMut","3749":"Sony Pictures Canada","3750":"Big Y","3751":"Garmin UK","3752":"iprospect","3753":"Nissan DE","3754":"Pillsbury","3755":"5 Second Rule","3756":"Immersive LLC","3757":"Cobra","3758":"Capital Investment Advisors","3759":"SourceAmerica","3760":"Grosvenor Casino","3761":"Mecca Bingo","3762":"Faribault Foods Inc","3763":"Admiral","3764":"Superdry","3765":"Elevation pictures","3766":"Adform","3767":"Postbank DE","3768":"Sanofi","3769":"UCSF","3770":"digitalundivided","3771":"Tullamore Dew DE","3772":"Movado_UK","3773":"Greene King","3774":"Longbranch","3775":"Polaroid","3776":"Nasuni","3777":"IONOS","3778":"Fair Trade","3779":"LA Tourism","3780":"Regence","3781":"ASUS Computer","3782":"Metro State University Denver","3783":"Froth-Pak","3784":"Dominos","3785":"XBOX UK","3786":"Snaidero Chicago","3787":"Happy Beauty Company","3788":"RBC Royal Bank of Canada","3789":"Galeria DE","3790":"Lidemans","3791":"Ministry of Justice","3792":"Oatly","3793":"backmarket","3794":"Newfields Art Museum","3795":"Zales","3796":"Solidaris","3797":"OHIOANS UNITED FOR REPRODUCTIVE RIGHTS","3798":"Inspire Medical Systems Inc","3799":"Harmony The Musical","3800":"Novavax, Inc.","3801":"Orthomol","3802":"Clean Choice Energy","3803":"DNU1","3804":"Americorps","3805":"NewFest","3806":"Fidelity Investments","3807":"Valspar UK","3808":"V&CO","3809":"Colorado Department of Labor and Employment","3810":"San Diego Tourism Authority","3811":"Lifepoint Health","3812":"Owl Labs","3813":"Ring","3814":"Beiersdorf","3815":"Working Forests Initiative","3816":"University of Chicago Medicine","3817":"The Shark is Broken","3818":"VF Japan KK","3819":"JP Morgan","3820":"Angelini Pharma","3821":"Dexcom","3822":"1ST/BET","3823":"Reckitt","3824":"Royal Canadian Mint","3825":"Denkyosha","3826":"MSFT","3827":"The Brain Tumour Charity","3828":"Volkswagen DE","3829":"Choir of Man","3830":"Fisher Nut Company","3831":"Charlotte\'s Got A Lot","3832":"British American Tobacco","3833":"McCain Foods","3834":"SQUARE ENIX CO., LTD","3835":"Nescafe UK","3836":"South Carolina Ports Authority","3837":"Seibu Railway","3838":"Experience Columbus","3839":"Ralph Lauren - NA - US West","3840":"Takara Tomy","3841":"Sports Direct UK","3842":"Hungry For Truth","3843":"Hungry For Truth","3844":"Knicks and Rangers","3845":"Canada Mortgage and Housing Corporation (CMHC)","3846":"Puig EU","3847":"Costar","3848":"Deutsche Bank","3849":"Collect & Go","3850":"Harry Potter","3851":"Netflix","3852":"Aviva","3853":"Crown Estates","3854":"Vanish","3855":"Meta EU","3856":"DPC NL","3857":"Agria","3858":"WeTell","3859":"DBEIS","3860":"Nestle Canada","3861":"Gilead Sciences","3862":"Gilead Sciences","3863":"Timberland Japan","3864":"Signet","3865":"Ann Taylor","3866":"Unicharm Japan","3867":"Lindt UK","3868":"MJ The Musical","3869":"WEKA","3870":"Mrs Doubtfire","3871":"Francis Ford Coppola Winery","3872":"Find My Past","3873":"Nurtec","3874":"DNU0","3875":"Techint Labs","3876":"Exploding Kittens","3877":"Aston Martin","3878":"Jellycat","3879":"Blue Apron","3880":"Big Ski","3881":"Sun Valley","3882":"Artsen Zonder Grenzen","3883":"ABN Amro","3884":"Rad Power Bikes","3885":"Nintendo (Canada)","3886":"Phoenix Raceway","3887":"Amarula","3888":"Hilti","3889":"United States Navy","3890":"Malwarebytes","3891":"Kentucky Tourism","3892":"Highland Park","3893":"Warner Brothers - Canada","3894":"White Ribbon","3895":"Galderma","3896":"Atlus","3897":"New York Islanders","3898":"My Neighbor Totoro","3899":"DWS","3900":"SKY DE","3901":"Deutsche Tele Medien","3902":"American Diabetes Association, Inc.","3903":"Hallmark","3904":"Virginia SCC","3905":"SodaStream","3906":"ING","3907":"Mirolin","3908":"Paradise International Co., Ltd","3909":"Dolce & Gabbana CA","3910":"TRESemme","3911":"Accor hotels","3912":"Cisco","3913":"Amway","3914":"Huawei DE","3915":"Delaware Lottery","3916":"Alzheimer’s Society","3917":"DIOR Canada","3918":"Lenovo EU","3919":"Madhive","3920":"Esperion","3921":"Murata Manufacturing Co., Ltd","3922":"Shionogi Healthcare Co., Ltd","3923":"Canadian Cancer Society","3924":"Bel Group","3925":"Minnesota Department of Health","3926":"Dairy Farmers of America","3927":"Seikatsu Club","3928":"Dats24 by Colruyt","3929":"Atkins","3930":"Electoral Commission UK","3931":"Lotus EU","3932":"Merchant Gourmet","3933":"ACRA","3934":"IG Group","3935":"Dewynters Disney Frozen the Musical","3936":"KPMG","3937":"Test Publisher - APAC","3938":"Test Publisher - SEA","3939":"Direct Energy","3940":"Oura Ring","3941":"CBC Canada","3942":"REWE","3943":"Awork","3944":"JTB Corp.","3945":"Albert Heijn","3946":"Equifax - UK","3947":"Toho Gas","3948":"Viatris","3949":"Tourism New Brunswick","3950":"Effectv","3951":"JRA","3952":"Age Co","3953":"Visit South Bend","3954":"Sega","3955":"Church & Dwight Canada Corp.","3956":"Flutter UK","3957":"Allwyn","3958":"AlEn Cleaning","3959":"SPRIX Inc.","3960":"Rockwell Automation","3961":"Rockwell Automation","3962":"Atlus_Euro","3963":"Nemacolin","3964":"Carglass","3965":"Blue Triton Brands - NA - US West","3966":"M-net","3967":"Related Rentals","3968":"Square Restaurants","3969":"ArubaTourism","3970":"Manhattan Theatre Club","3971":"Sony Assurance Inc.","3972":"Karo","3973":"Museum of Pop Culture","3974":"Delaware Valley Honda","3975":"Reliant Energy","3976":"Haleon","3977":"Harry Winston","3978":"OMD","3979":"TAZO","3980":"Dr. Falk","3981":"Red Cross","3982":"Barclays","3983":"Tourism New Zealand","3984":"Jeep","3985":"Airheads","3986":"EDF","3987":"Merlin","3988":"99 Restaurants","3989":"au Jibun Bank Corporation","3990":"Volvo Car Japan","3991":"National Safety Apparel","3992":"James Hardie","3993":"Yello Strom","3994":"Velux Deutschland","3995":"Japan Frito-Lay, Ltd.","3996":"Vans EMEA","3997":"United Airlines","3998":"Avoya Travel","3999":"Sumitomo Mitsui Auto Service","4000":"Brookfield Zoo","4001":"Museum of Fine Arts","4002":"Tomy Boon","4003":"TV One","4004":"Academy of Motion Picture Arts & Science","4005":"Canadian Women\'s Foundation","4006":"Marshmallow","4007":"Black & Abroad","4008":"Omaze","4009":"Costa","4010":"Paramount Streaming","4011":"Sarsons","4012":"IWD International Womens Day","4013":"McCain","4014":"British Health Fundation","4015":"Oakley","4016":"National Geographic NL","4017":"Hendrick\'s Gin","4018":"Raymond Chabot","4019":"Kenvue","4020":"Fiat NL","4021":"Samsung Japan","4022":"Van Marcke","4023":"Visit Britain","4024":"Sabra Hummus","4025":"T Rowe Price","4026":"California Department of Industrial Relations","4027":"AU Test Advertiser -  AUD","4028":"Test Malaysia","4029":"Test PH","4030":"Audi","4031":"Jared","4032":"Adey","4033":"Ubalt","4034":"Test","4035":"Test","4036":"Test","4037":"MSD","4038":"Cava","4039":"Warner Brothers Discovery","4040":"Just Brands","4041":"Minnesota Zoo","4042":"Wedinsure","4043":"eTrade","4044":"Nestle","4045":"Immoscoop","4046":"Sofology","4047":"Audi","4048":"Bethmann Bank","4049":"McCain Foodservice","4050":"Bergader Privatkaeserei","4051":"Yale Health","4052":"Disney - APAC - AUD","4053":"Adventure Valley Durbuy","4054":"Decathlon DE","4055":"Tempo Team","4056":"Boehringer Ingelheim","4057":"\xd8rsted","4058":"FCA Fiat Chrysler Automobiles","4059":"Test - NZ","4060":"Format Testing","4061":"Format Testing","4062":"Format Testing","4063":"Labour Party","4064":"Pets at Home","4065":"Coast Capital","4066":"Hospital Corporation of America","4067":"Emmi DE","4068":"NA - West - Colorado Springs Airport","4069":"YES Network","4070":"School for Life - APAC - NSW","4071":"Studio Canal - APAC - NSW","4072":"Kimberly-Clark","4073":"DEA","4074":"Rogers SportsNet","4075":"HK Test","4076":"Washington Spirits","4077":"The Sphere","4078":"Clutch","4079":"Live! Maryland","4080":"Snadeiro 2024","4081":"Amazon Ads","4082":"The Notebook on Broadway","4083":"NHSBT","4084":"University of Maryland Eastern Shore","4085":"Maison Perrier","4086":"Hisense USA by UK","4087":"Pernod Ricard","4088":"SharkNinja","4089":"Gogo squeeZ","4090":"SSP CO., LTD","4091":"A250","4092":"Beeswax","4093":"Driscoll Children\'s Hospital","4094":"First Financial Bank","4095":"Karo UK","4096":"Cover More Insurance","4097":"Glucerna","4098":"Travis Mathew","4099":"Puffy","4100":"Puffy Mattresses","4101":"Nevadans for Reproductive Freedom","4102":"Outsiders Musical","4103":"West Virginia Division of Tourism","4104":"Klobuchar 2024","4105":"NAB","4106":"Visit California","4107":"City of Toronto","4108":"Campbell\'s","4109":"City of Melbourne","4110":"Cellarbrations","4111":"Skylark","4112":"RSL Queensland - APAC - QLD","4113":"University of Auckland","4114":"Uber","4115":"Woolworths","4116":"Spark","4117":"Thermomix - APAC - WA","4118":"Samsung","4119":"Motorola","4120":"Frucor Suntory NZ / V Energy","4121":"Hendrick\'s Gin","4122":"Lexus","4123":"Monde Nissin","4124":"Lionsgate","4125":"Temasek Polytechnic","4126":"Chobani","4127":"Foodpanda","4128":"British Airways UK","4129":"Columbia Sportswear","4130":"Meiomi Wines","4131":"CHINTAI","4132":"Shopify","4133":"American Cancer Story","4134":"MSD","4135":"Burlington","4136":"OXO","4137":"Adobe APAC","4138":"Cashrewards","4139":"Standard Chartered Bank Malaysia","4140":"Standard Chartered Bank","4141":"Standard Chartered Bank - APAC - Malaysia","4142":"Corona","4143":"Aspen Dental","4144":"Folger Shakespeare Library","4145":"LVMH - SEA - Singapore","4146":"Amazon Prime Video - SEA","4147":"Foodpanda","4148":"Tokyo-Tokyo","4149":"Trust Bank","4150":"NIB health insurance","4151":"Aldi AU","4152":"NTUC Income","4153":"Westpac","4154":"Air New Zealand","4155":"State Emergency Service - APAC - SA","4156":"Sunwing","4157":"Miir","4158":"TAFE - APAC - QLD","4159":"Priceline","4160":"Macquarie University","4161":"CUB","4162":"Asahi","4163":"Mood Tea","4164":"Unilever","4165":"Fonterra","4166":"Bank Australia","4167":"Carnegie Mellon University","4168":"Maryland Lottery","4169":"Visit Montana","4170":"Studio Creator","4171":"Santander UK","4172":"Binge","4173":"The Lottery Corporation - APAC - QLD","4174":"Hospital Research Foundation","4175":"City of Perth","4176":"Briscoes","4177":"Tourism WA - APAC - WA","4178":"View Boston","4179":"Chamonix","4180":"kiwibank","4181":"L\'oreal","4182":"The Coca Cola Company","4183":"Thinkerbell South","4184":"Coca Cola","4185":"ST JUDE CHILDRENS RES HOSPITAL(STJ)","4186":"Sleeper","4187":"Erie Insurance","4188":"Yamaha Drums","4189":"Acura","4190":"Substance Abuse and Mental Health Services Adminis","4191":"Fox Entertainment","4192":"Revlon","4193":"Flight Centre","4194":"Door Dash","4195":"RMIT","4196":"Lifeline","4197":"Samsung - SEA","4198":"Pernod Ricard - Australia","4199":"Green River Branding","4200":"Flibco","4201":"Comic Relief","4202":"Project Human Dignity","4203":"Dale\'s Pale Ale","4204":"Meet Boston","4205":"Chicken Farmers of Canada","4206":"ahm","4207":"Flight Centre - APAC - QLD","4208":"Parmigiano Reggiano","4209":"Carlsberg","4210":"Hyundai","4211":"Semaglutide","4212":"Vitaco","4213":"WG&S Glenfiddich","4214":"G\'Day Parks - APAC - SA","4215":"Industry Superfunds Australia","4216":"Southern Cross","4217":"Whirpool","4218":"Movado","4219":"Vertex Inc.","4220":"PureGym","4221":"Cracker Barrel","4222":"Cocoons","4223":"Ampol","4224":"Ebay","4225":"AO","4226":"Green Gobbler","4227":"Kimpton","4228":"San Pellegrino","4229":"Mars Petcare","4230":"Notre Dame University - APAC - WA","4231":"L\'Oreal","4232":"Australian Retirement Trust","4233":"Maybank","4234":"Dyson Malaysia","4235":"Tennis Channel","4236":"Tenaga Nasional Berhad","4237":"Dan Murphy\'s","4238":"CBH Group - APAC - WA","4239":"Cunard","4240":"Jacobs Douwe Egberts","4241":"Canada Goose","4242":"Dr. Oetker","4243":"Queensland Government - APAC - QLD","4244":"Beam Suntory","4245":"Nespresso (SG)","4246":"Bulgari","4247":"Qantas","4248":"Mobil","4249":"Phillip Morris International UK","4250":"London Business School (LBS)","4251":"Kim Crawford","4252":"TPG","4253":"McDonald\'s","4254":"Franklin Templeton","4255":"QUT - APAC - QLD","4256":"TikTok Shop","4257":"Department of Transportation (DOT)","4258":"Carrefour","4259":"Delicato","4260":"Samsung","4261":"Penguin Random House","4262":"Acer","4263":"Alaska Milk - APAC - SEA - PH","4264":"GoTo Foods","4265":"Rockefeller Center","4266":"Rockefeller Center","4267":"iNova","4268":"Coppola","4269":"Pins Mechanical","4270":"New Yorkers for Better Recycling","4271":"Discover Puerto Rico","4272":"Kennedy Space Center Visitor Complex","4273":"Flip Insurance","4274":"Accor","4275":"SC Johnson","4276":"Cancer Council Australia","4277":"Jetstar","4278":"petit-bateau","4279":"AGC Inc.","4280":"Manulife Direct - Hong Kong","4281":"YAMATO HOLDINGS CO., LTD.","4282":"Jam Shed","4283":"Dyson","4284":"Samsung SEA (MY)","4285":"NALO","4286":"Chevrolet","4287":"Grundfos","4288":"Adelaide Economic Development Agency","4289":"Bedshed","4290":"Ford","4291":"Edith Cowan University","4292":"The Iconic","4293":"Ibis Hotels","4294":"Goodyear Tires","4295":"DMM.com","4296":"The Children’s Cancer Institute Australia (CCIA)","4297":"Costa Del Mar","4298":"De\'Longhi","4299":"Ladbrokes","4300":"English Heritage","4301":"Hershey\'s","4302":"Mitsubishi - APAC - SA","4303":"Coca Cola","4304":"Toyota","4305":"KIMBERLY-CLARK","4306":"Beiersdorf","4307":"THIRSTY CAMEL","4308":"Ubisoft","4309":"Apple Japan","4310":"KFC","4311":"GoTyme","4312":"North York General Hospital","4313":"New Balance","4314":"Scentre Group","4315":"Grab","4316":"Grab","4317":"Princess Oriental","4318":"Shark","4319":"Opera","4320":"AdMedia DSP","4321":"Luminus","4322":"Canadian Blood Services","4323":"Destination Canada","4324":"BHP","4325":"Pizza Hut AU","4326":"Commonwealth Bank","4327":"Disney","4328":"Visa","4329":"AutoCAD","4330":"Powershop","4331":"University of South Australia","4332":"Southern Poverty Law Center","4333":"Madri","4334":"WA Return Recycle Renew","4335":"McCormick","4336":"Avis","4337":"Griffith University","4338":"Fresca Programmatic","4339":"Amazon","4340":"Paramount Pictures NZ","4341":"Monzo","4342":"Battle Cats","4343":"Red Tractor","4344":"MSI","4345":"International Brotherhood of Electrical Workers","4346":"United Airlines","4347":"Manulife","4348":"Sunbeam DO NOT USE","4349":"Sunbeam","4350":"Manulife","4351":"MARS","4352":"True North Adventure Cruises","4353":"Unilever","4354":"Shopify UK - USD","4355":"Big Gay Jamboree","4356":"Afterpay","4357":"Audible","4358":"LG","4359":"Warner Brother\'s","4360":"Mepal","4361":"Turtle Bay Resort","4362":"Queensland Government","4363":"Heidepark","4364":"Station Casinos","4365":"Procell","4366":"2 Degrees New Zealand","4367":"Hill\'s","4368":"Resort World Genting","4369":"Abbott","4370":"Qatar Airways","4371":"London Pride","4372":"Wawa","4373":"Nespresso","4374":"Sucasa","4375":"Hummgroup","4376":"First Hawaiian Bank","4377":"Tiffany & Co","4378":"Chadstone","4379":"Carnival Cruises","4380":"Payconiq","4381":"2KGames_UK","4382":"NEON","4383":"UNICEF","4384":"Danone - APAC - AUD","4385":"WA Government","4386":"Curzon Film","4387":"Watsons","4388":"ACMN","4389":"Fletcher Living","4390":"Anaconda","4391":"Campari EU","4392":"SA Gov - Department for the Premier & Cabinet","4393":"Kate Somerville","4394":"Interislander","4395":"AirAsia","4396":"Suntory","4397":"Hero Software","4398":"City Experiences","4399":"Domino\'s Pizza","4400":"Adobe","4401":"Cinnamon Toast Crunch","4402":"Angela Alsobrooks","4403":"yuu Reward Club","4404":"Intuit","4405":"LA Tourism APAC","4406":"University of Adelaide -  APAC -  NSW","4407":"Lego","4408":"Lactalis","4409":"MG Motors","4410":"BP","4411":"Xero","4412":"Ancestry","4413":"Defence SA","4414":"Kellogss","4415":"Chemist Warehouse","4416":"La Lorraine Bakery Group","4417":"La Lorraine Bakery Group","4418":"IKEA","4419":"Delmarva Power & Light Company","4420":"Audi","4421":"Battery World","4422":"Fonterra","4423":"Fonterra","4424":"Unilever","4425":"Expedia","4426":"Act Belong Commit","4427":"Hydro Flask","4428":"NA - West - Comfort Zone","4429":"Ashley Furniture","4430":"AstraZeneca","4431":"EMD Serono","4432":"Bensimon Byrne","4433":"BMO Harris","4434":"Booyah","4435":"Bully Pulpit","4436":"DEPT","4437":"Eversana","4438":"FirstBank","4439":"GetYourGuide","4440":"States United Democracy","4441":"Goodyear","4442":"Biofreeze","4443":"Rugby Australia - APAC - NSW","4444":"Kleenheat","4445":"Key Pharmaceuticals","4446":"The Pinnacle Foundation","4447":"Lord\'s Cricket Ground","4448":"kicker - DE","4449":"Messe M\xfcnchen","4450":"Disney","4451":"Goodman Fielder NZ","4452":"Crunchyroll","4453":"Friends of Sherrod Brown","4454":"Colgate","4455":"Motorola","4456":"H&M","4457":"ING bank","4458":"Kelly Scott Madison","4459":"Kinesso","4460":"Caplyta","4461":"Klick Health","4462":"Bayer","4463":"Life Time Fitness","4464":"Molekule","4465":"Madison Square Garden","4466":"Novartis","4467":"NYU Langone Health","4468":"Olipop","4469":"Park City Tourism","4470":"Powers Interactive","4471":"Supernus Pharmaceuticals","4472":"ThermoFisher Scientific","4473":"Subcolade","4474":"Sunosi","4475":"SuperATV","4476":"Auvelity","4477":"Tyrvaya","4478":"US Bank","4479":"USAA","4480":"Dermavant Sciences","4481":"Western Media Group","4482":"Workday","4483":"WNBA","4484":"Salix Pharmaceuticals","4485":"Yosemite Consulting","4486":"DNU.","4487":"Bamboo Rose","4488":"Westinghouse","4489":"Hawaiian Shopping Centres","4490":"Australian Government Defence","4491":"Hell\'s Kitchen on Broadway","4492":"Bunnings NZ","4493":"Bosch - APAC - VIC","4494":"JB Hi-Fi","4495":"Sydney Airport","4496":"Lotterywest","4497":"BP","4498":"ABC Direct - APAC - NSW","4499":"Hyundai","4500":"McArthurGlen","4501":"Lotto Hessen","4502":"University of Adelaide","4503":"Guinness","4504":"Mayo Clinic","4505":"MINI Cooper","4506":"She Runs It","4507":"PICO","4508":"Cancer Council WA","4509":"Weis","4510":"Tommy Hilfifer APAC","4511":"Petstock APAC","4512":"Krungsri Corporation","4513":"Swinburne","4514":"Honda","4515":"Racing Victoria","4516":"Mcdonald\'s","4517":"Ajinomoto","4518":"Swisse","4519":"Firth","4520":"Lexus","4521":"Mars","4522":"Jazz Pharmaceuticals","4523":"Giant/Martin\'s","4524":"Horizon Blue Cross Blue Shield","4525":"Phathom Pharmaceuticals","4526":"Mogo Interactive","4527":"New York Presbyterian","4528":"GWM -  APAC -  VIC","4529":"UOB","4530":"Chery","4531":"Burger King","4532":"Globe Telecom","4533":"Key","4534":"LensCrafters","4535":"Resene","4536":"VGW","4537":"Garmin","4538":"Proximo Pendleton Whiskey","4539":"The Good Grocer","4540":"Pacifico Programmatic","4541":"Singapore Airlines","4542":"Volvo","4543":"Kmart","4544":"Sydney Fringe Festival","4545":"Reckitt Benckiser","4546":"NSA","4547":"NARCAN Nasal Spray","4548":"NV Energy","4549":"Mattel","4550":"Fonterra","4551":"Harley Davidson","4552":"Hubbl","4553":"Unilab","4554":"Merlin Entertainment","4555":"VGW Direct","4556":"The Lottery Corporation","4557":"Jetstar Australia","4558":"Nutriasia","4559":"1Password","4560":"Ford Motor Company AU","4561":"Moultrie Mobile","4562":"Moose APAC","4563":"Callaway Golf","4564":"Australia Post","4565":"PEET","4566":"Voyages","4567":"Mitsubishi Motors - APAC - Japan","4568":"Ray-Ban","4569":"Haleon","4570":"CMU","4571":"Sierra Tequila APAC","4572":"Accolade Wines","4573":"Grant Burge","4574":"Momentum Energy","4575":"Sony PlayStation","4576":"Villarica","4577":"Central Michigan University","4578":"CMU","4579":"Trane","4580":"Meridian","4581":"Canteen Australia","4582":"Levi\'s","4583":"Newington College","4584":"Royal Adelaide Show","4585":"WA Police","4586":"St John WA","4587":"Unilever","4588":"Scholl","4589":"Conga Foods - APAC","4590":"Flybuys","4591":"Nandos APAC","4592":"Universal Robina Corporation","4593":"Disney Theatrical Productions","4594":"Pacific Foods","4595":"Sandals","4596":"Gillibrand for Senare","4597":"Gillibrand for Senate","4598":"Arnott\'s","4599":"City of Tea Tree Gully Council","4600":"Calvin Klein APAC","4601":"AXA","4602":"Bel Japon","4603":"The Nippon Foundation","4604":"Rakuten Card","4605":"Square","4606":"TCVB","4607":"Native Ocean","4608":"Oatside","4609":"Beiersdorf","4610":"DS Political","4611":"Uber","4612":"Temple University Health","4613":"SMU","4614":"GMSV","4615":"Disney - APAC - NZD","4616":"BT (British Telecom)","4617":"Resolve Conflict Family Law","4618":"Freedom Furniture AU","4619":"Royal Agricultural Society of WA","4620":"Lion","4621":"Woodside","4622":"Aus Unity","4623":"Hershey","4624":"CBRE","4625":"The Lactation Network","4626":"International Leadership of Texas","4627":"John Frieda","4628":"Pointsbet","4629":"Fonterra","4630":"England Women’s International Cricket","4631":"Sine Digital","4632":"Sine Digital","4633":"Upfield","4634":"Jollibee","4635":"Reece","4636":"Go Health","4637":"Expedia","4638":"Ticombo","4639":"Vinda","4640":"Apple UK","4641":"Publicis Canada","4642":"William Grant and Sons","4643":"Century Pacific","4644":"Goodman Fielder","4645":"Heritage Bank","4646":"Hublot","4647":"Protect Freedom PAC","4648":"TG Therapeutics","4649":"Axsome Therapeutics","4650":"Intra-Cellular Therapies","4651":"Cisco","4652":"LEGO","4653":"Indivior","4654":"Oyster Point Pharma","4655":"MSWA","4656":"Perfection Fresh Australia","4657":"Drakes Supermarkets","4658":"Western Power","4659":"Hansaplast","4660":"GoPuff","4661":"Sabic","4662":"New York Bakery Co","4663":"Dot\'s Pretzels","4664":"AdVictory","4665":"WV Tourism","4666":"Smokey the Bear","4667":"easyJet UK","4668":"K\xf6stritzer","4669":"UCB Biopharma","4670":"Mizkan","4671":"Circle K","4672":"Mouth Sinai","4673":"Version2","4674":"Centerwell","4675":"Mirvish Productions","4676":"Alberta Blue Cross","4677":"Aflac","4678":"R&R Partners","4679":"Clorox","4680":"Stellantis","4681":"Unilever","4682":"Apellis Pharmaceuticals","4683":"Arcutis Biotherapeutics","4684":"Assembly Global","4685":"Assembly Global","4686":"U-Pack","4687":"Saputo","4688":"Sprayway","4689":"Pizza Hut","4690":"Mediahub","4691":"University of Michigan Health","4692":"Forward Montana","4693":"HIMS","4694":"Logan\'s Roadhouse","4695":"Premier Boxing Championships","4696":"Bardstown Bourbon","4697":"Sailpoint","4698":"Thomson Reuters","4699":"ShareFile","4700":"State Farm","4701":"Geloso","4702":"Temecula Valley Wine Growers Association","4703":"Media.Monks","4704":"Teremana Tequila","4705":"Elevance Health","4706":"Zespri","4707":"American Heart Association - AHA","4708":"The Perth Mint","4709":"Suntory","4710":"Murdoch University","4711":"Carolina Herrera","4712":"Miral","4713":"Aramco","4714":"KLM","4715":"Catch.com","4716":"Art Gallery of South Australia","4717":"Singapore Tourism Board","4718":"ANZ Worldline","4719":"Market Development Fund","4720":"Jean Paul Gautiller","4721":"Rabanne","4722":"Stonegate","4723":"Zurich","4724":"Zurich","4725":"The North Face","4726":"De\'Longhi","4727":"F45","4728":"Channel 4","4729":"AtkinsR\xe9alis","4730":"Evereve","4731":"Pink Casino","4732":"Seqirus","4733":"Moderna","4734":"GE Sealants","4735":"Vanguard","4736":"FCNT","4737":"Hill\'s Pet Nutrition","4738":"Canadian Insulin","4739":"Xaxis","4740":"Sam\'s Club","4741":"Cat\'s Pride","4742":"Kinesso","4743":"GroupM CA","4744":"NBN","4745":"PUIG","4746":"AXS","4747":"Visa","4748":"CMI","4749":"BlueScope","4750":"Mastercard","4751":"South Australia Police","4752":"IBM","4753":"Qantas","4754":"Prestige Brands","4755":"The Entertainment and Education Group (TEEG)","4756":"Netflix","4757":"Book of Mormon","4758":"Hadestown","4759":"Basic Fit","4760":"Jacamo","4761":"British Columbia Lottery Corporation","4762":"Bowers & Wilkins","4763":"Canadian Insulin","4764":"Mariott Hotels","4765":"McGrath Foundation","4766":"Port Adelaide","4767":"University of Wollongong","4768":"Hershey\'s","4769":"Bet365","4770":"persimmon homes","4771":"Orange","4772":"BET MGM","4773":"The Shoebox Project","4774":"Health and Human Services","4775":"Fanatics Sportsbook","4776":"Basis","4777":"KeyStart","4778":"Avis Budget Group","4779":"Norwegian Cruise Line","4780":"Chong + Koster","4781":"GMMB","4782":"Soundwave","4783":"Arizona State University (ASU)","4784":"NRMA","4785":"Scitech","4786":"Square","4787":"Klick","4788":"CodeHouse","4789":"Galderma","4790":"Accor Hotels","4791":"Adidas","4792":"CAMC","4793":"Westdeutsche Lotterie","4794":"DELL Alienware","4795":"Oasis at Death Valley","4796":"Foodland","4797":"nike","4798":"Ford UK","4799":"Harvey Water","4800":"Kelloggs","4801":"Intuit","4802":"VLAM","4803":"Stork Baby Gift Baskets","4804":"Good Drinks Aus"}');


var $ba8ed6e0680fafe2$exports = {};
$ba8ed6e0680fafe2$exports = JSON.parse('[{"id":8,"enumVertical":"AUTO","name":"Auto","description":"Auto","contentCategoryId":"IAB2"},{"id":11,"enumVertical":"BUSINESS","name":"Business & Finance","description":"Business & Finance","contentCategoryId":"IAB3"},{"id":1,"enumVertical":"ENTERTAINMENT","name":"Entertainment","description":"Entertainment","contentCategoryId":"IAB1"},{"id":5,"enumVertical":"FASHION","name":"Fashion","description":"Fashion","contentCategoryId":"IAB18"},{"id":12,"enumVertical":"FOOD","name":"Food & Drink","description":"Food & Drink","contentCategoryId":"IAB8"},{"id":13,"enumVertical":"GAMING","name":"Gaming","description":"Gaming","contentCategoryId":"IAB9-30"},{"id":14,"enumVertical":"HEALTH","name":"Health & Wellness","description":"Health & Wellness","contentCategoryId":"IAB7"},{"id":15,"enumVertical":"HOME","name":"Home & Garden","description":"Home & Garden","contentCategoryId":"IAB10"},{"id":10,"enumVertical":"HUMOR","name":"Humor","description":"Humor","contentCategoryId":"IAB1-4"},{"id":16,"enumVertical":"LIFESTYLES","name":"Lifestyles","description":"Lifestyles","contentCategoryId":"IAB9"},{"id":6,"enumVertical":"MISC","name":"Miscellaneous","description":"miscellaneous","contentCategoryId":"IAB24"},{"id":3,"enumVertical":"NEWS","name":"News","description":"News","contentCategoryId":"IAB12"},{"id":7,"enumVertical":"SOCIAL","name":"Social Networks","description":"Social Networks","contentCategoryId":"IAB25-1"},{"id":2,"enumVertical":"SPORTS","name":"Sports","description":"Sports","contentCategoryId":"IAB17"},{"id":9,"enumVertical":"TECHNOLOGY","name":"Technology","description":"Technology","contentCategoryId":"IAB19"},{"id":4,"enumVertical":"TRAVEL","name":"Travel","description":"Travel","contentCategoryId":"IAB20"}]');


const $7758283a20c4dc72$var$META_V2_URL = "https://firebasestorage.googleapis.com/v0/b/cat-cache/o/meta-v2.json?alt=media&token=f4c75f83-6e73-4a62-b2c9-a30b97595127";
const $7758283a20c4dc72$var$GENERIC_EXCLUDE = [
    "",
    "unknown",
    "null",
    "undefined"
];
const $7758283a20c4dc72$var$BRANDS_EXCLUDE = $7758283a20c4dc72$var$GENERIC_EXCLUDE.concat([
    "{advertiserId}"
]);
const $7758283a20c4dc72$var$VERTICALS_EXCLUDE = $7758283a20c4dc72$var$GENERIC_EXCLUDE.concat([
    "{verticalId}"
]);
const $7758283a20c4dc72$var$FORMATS_EXCLUDE = $7758283a20c4dc72$var$GENERIC_EXCLUDE.concat([
    "hang-time-desktop-v2"
]);
const $7758283a20c4dc72$var$FEATURES_OPTIONS = [
    {
        value: "display",
        label: "Display only"
    },
    {
        value: "video",
        label: "Video only"
    }
];
// create a map of ggAdvertisers id to name
const $7758283a20c4dc72$var$ggVerticalsMap = (0, (/*@__PURE__*/$parcel$interopDefault($ba8ed6e0680fafe2$exports))).reduce((acc, ggVertical)=>{
    acc[ggVertical.id] = ggVertical.name;
    return acc;
}, {});
const $7758283a20c4dc72$var$sortByLowerCase = (a, b)=>{
    const la = a.toLowerCase();
    const lb = b.toLowerCase();
    return la.localeCompare(lb);
};
// Expand property names and map to human readable values
const $7758283a20c4dc72$var$mapMetaItemProperties = (item)=>{
    const { id: id, a: a, s: s, b: b, p: p, c: c, n: n, f: f, h: h, u: u, v: v } = item;
    const format = f ? f : "hang-time";
    const brand = isNaN(b) ? b : (0, (/*@__PURE__*/$parcel$interopDefault($14847ccff6e0f445$exports)))[b];
    return {
        id: id,
        adBuyId: a,
        aggregatedSessionSize: s,
        brand: brand,
        campaign: p,
        creative: c,
        favCount: n,
        format: format,
        containsVideo: h,
        updated: u,
        vertical: isNaN(v) ? v : $7758283a20c4dc72$var$ggVerticalsMap[v]
    };
};
const $7758283a20c4dc72$var$fetchHomepageData = async ()=>{
    try {
        const response = await fetch($7758283a20c4dc72$var$META_V2_URL);
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        const data = await response.json();
        const mergedData = data.map((meta)=>$7758283a20c4dc72$var$mapMetaItemProperties(meta)).filter((meta)=>{
            // exclude items with empty or excluded values
            if (!meta || $7758283a20c4dc72$var$FORMATS_EXCLUDE.includes(meta.format) || $7758283a20c4dc72$var$VERTICALS_EXCLUDE.includes(meta.vertical) || $7758283a20c4dc72$var$BRANDS_EXCLUDE.includes(meta.brand)) return false;
            return true;
        });
        // sort by updated date
        mergedData.sort((a, b)=>new Date(b.updated).getTime() - new Date(a.updated).getTime());
        const optionsAsArray = mergedData.reduce((acc, item)=>{
            const brand = item.brand?.trim() || "";
            const format = item.format?.trim() || "";
            const vertical = item.vertical?.trim() || "";
            if (!acc.brands.includes(brand) && !!brand) acc.brands.push(brand);
            if (!acc.verticals.includes(vertical) && !!vertical) acc.verticals.push(vertical);
            if (!acc.formats.includes(format) && !!format) acc.formats.push(format);
            return acc;
        }, {
            brands: [],
            verticals: [],
            formats: []
        });
        const newOptions = {
            brands: optionsAsArray.brands.sort($7758283a20c4dc72$var$sortByLowerCase).map((brand)=>({
                    value: brand,
                    label: brand
                })),
            verticals: optionsAsArray.verticals.sort($7758283a20c4dc72$var$sortByLowerCase).map((vertical)=>({
                    value: vertical,
                    label: vertical
                })),
            formats: optionsAsArray.formats.sort($7758283a20c4dc72$var$sortByLowerCase).map((format)=>({
                    value: format,
                    label: format
                })),
            features: $7758283a20c4dc72$var$FEATURES_OPTIONS
        };
        console.log(newOptions);
        return {
            data: mergedData,
            options: newOptions
        };
    } catch (error) {
        console.log(error);
    }
    return {
        data: [],
        options: []
    };
};
var $7758283a20c4dc72$export$2e2bcd8739ae039 = $7758283a20c4dc72$var$fetchHomepageData;




const $9cc17e77937578a8$var$PAGE_SIZE = 21;
const $9cc17e77937578a8$export$b26ae958e8e72f05 = (0, (/*@__PURE__*/$parcel$interopDefault($6f1cc25c964e79da$exports)))((set, get)=>({
        status: "ready",
        numberOfVisibleCreatives: $9cc17e77937578a8$var$PAGE_SIZE,
        options: {
            brands: [],
            verticals: [],
            formats: [],
            features: []
        },
        filters: {
            brand: [],
            vertical: [],
            format: [],
            features: [],
            sessionSize: (0, $c1fd71c50d10744b$export$8049eeb4ac268de)
        },
        data: [],
        filteredData: [],
        pageData: [],
        hasNextPage: false,
        loadMore: ()=>{
            const numberOfVisibleCreatives = get().numberOfVisibleCreatives + $9cc17e77937578a8$var$PAGE_SIZE;
            set((state)=>{
                return {
                    numberOfVisibleCreatives: numberOfVisibleCreatives,
                    pageData: state.filteredData.slice(0, numberOfVisibleCreatives),
                    hasNextPage: numberOfVisibleCreatives < state.filteredData.length
                };
            });
        },
        setStatus: (status)=>{
            set({
                status: status
            });
        },
        setData: (data)=>{
            set((state)=>{
                // always apply the filter when re seting the data
                const filteredData = $9cc17e77937578a8$var$applyFilter(data, state.filters);
                return {
                    data: data,
                    filteredData: filteredData,
                    pageData: filteredData.slice(0, $9cc17e77937578a8$var$PAGE_SIZE),
                    numberOfVisibleCreatives: $9cc17e77937578a8$var$PAGE_SIZE,
                    hasNextPage: $9cc17e77937578a8$var$PAGE_SIZE < data.length
                };
            });
        },
        setOptions: (options)=>{
            set({
                options: options
            });
        },
        getFilteredData: ()=>{
            return get().filteredData;
        },
        getPageData: ()=>{
            return get().filteredData.slice(0, get().numberOfVisibleCreatives);
        },
        changeFilters: (selectedOption, field)=>{
            set((state)=>{
                const filters = {
                    ...state.filters,
                    [field]: selectedOption
                };
                const filteredData = $9cc17e77937578a8$var$applyFilter(state.data, filters);
                return {
                    filteredData: filteredData,
                    filters: filters,
                    numberOfVisibleCreatives: $9cc17e77937578a8$var$PAGE_SIZE,
                    pageData: filteredData.slice(0, $9cc17e77937578a8$var$PAGE_SIZE),
                    hasNextPage: state.numberOfVisibleCreatives < filteredData.length
                };
            });
        },
        clearFilters: ()=>{
            set((state)=>{
                const filters = {
                    brand: [],
                    vertical: [],
                    format: [],
                    features: [],
                    sessionSize: (0, $c1fd71c50d10744b$export$8049eeb4ac268de)
                };
                const filteredData = $9cc17e77937578a8$var$applyFilter(state.data, filters);
                return {
                    filteredData: filteredData,
                    filters: filters,
                    numberOfVisibleCreatives: $9cc17e77937578a8$var$PAGE_SIZE,
                    pageData: filteredData.slice(0, $9cc17e77937578a8$var$PAGE_SIZE),
                    hasNextPage: $9cc17e77937578a8$var$PAGE_SIZE < filteredData.length
                };
            });
        }
    }));
function $9cc17e77937578a8$var$applyFilter(data, filters) {
    const filteredData = data.filter((item)=>(filters.brand.length ? filters.brand.some((option)=>option.value === item.brand) : true) && (filters.vertical.length ? filters.vertical.some((option)=>option.value === item.vertical) : true) && (filters.format.length ? filters.format.some((option)=>option.value === item.format) : true) && (filters.features.length ? filters.features.some((option)=>option.value === "video" && item.containsVideo || option.value === "display" && !item.containsVideo) : true) && (typeof filters.sessionSize === "number" ? item.aggregatedSessionSize >= filters.sessionSize : true));
    // sort by date if no filters are applied from dropdowns
    const sortByDateFirst = filters.brand.length === 0 && filters.vertical.length === 0 && filters.format.length == 0 && filters.features.length == 0;
    // sort resultis by updated date if no filters are applied
    // aggregatedSessionSize is considered a filter so it is not included in the check
    if (sortByDateFirst) {
        filteredData.sort((a, b)=>{
            return b.updated - a.updated;
        });
        return filteredData;
    }
    // group results by favourite count then by updated date
    filteredData.sort((a, b)=>{
        if (a.favCount === b.favCount) return b.updated - a.updated;
        return b.favCount - a.favCount;
    });
    return filteredData;
}






var $lDSNw = parcelRequire("lDSNw");




var $lDSNw = parcelRequire("lDSNw");
var $538aa6a2b60a37e7$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $538aa6a2b60a37e7$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $538aa6a2b60a37e7$var$_excluded);
    var _useState = (0, $lDSNw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $lDSNw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $lDSNw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $lDSNw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $lDSNw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $lDSNw.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $lDSNw.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $lDSNw = parcelRequire("lDSNw");








var $lDSNw = parcelRequire("lDSNw");









var $lDSNw = parcelRequire("lDSNw");

var $ef4Zh = parcelRequire("ef4Zh");


var $1364988d5fdddede$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $1364988d5fdddede$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $1364988d5fdddede$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $1364988d5fdddede$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($1364988d5fdddede$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $1364988d5fdddede$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($1364988d5fdddede$var$isArray(value)) return value.filter(Boolean);
    if ((0, $0537f2a037169a3d$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $1364988d5fdddede$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(props, $1364988d5fdddede$var$_excluded$4);
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $1364988d5fdddede$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $1364988d5fdddede$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $1364988d5fdddede$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $1364988d5fdddede$var$normalizedHeight(el) {
    if ($1364988d5fdddede$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $1364988d5fdddede$var$getScrollTop(el) {
    if ($1364988d5fdddede$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $1364988d5fdddede$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($1364988d5fdddede$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $1364988d5fdddede$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $1364988d5fdddede$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $1364988d5fdddede$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $1364988d5fdddede$export$b4171a6734a65d42;
    var start = $1364988d5fdddede$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $1364988d5fdddede$var$easeOutCubic(currentTime, start, change, duration);
        $1364988d5fdddede$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $1364988d5fdddede$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $1364988d5fdddede$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $1364988d5fdddede$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $1364988d5fdddede$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $1364988d5fdddede$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $1364988d5fdddede$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $1364988d5fdddede$var$passiveOptionAccessed = false;
var $1364988d5fdddede$var$options = {
    get passive () {
        return $1364988d5fdddede$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $1364988d5fdddede$var$w = typeof window !== "undefined" ? window : {};
if ($1364988d5fdddede$var$w.addEventListener && $1364988d5fdddede$var$w.removeEventListener) {
    $1364988d5fdddede$var$w.addEventListener("p", $1364988d5fdddede$export$b4171a6734a65d42, $1364988d5fdddede$var$options);
    $1364988d5fdddede$var$w.removeEventListener("p", $1364988d5fdddede$export$b4171a6734a65d42, false);
}
var $1364988d5fdddede$export$2408f22a0fab9ae5 = $1364988d5fdddede$var$passiveOptionAccessed;
function $1364988d5fdddede$export$3466f893ebf79586(item) {
    return item != null;
}
function $1364988d5fdddede$var$isArray(arg) {
    return Array.isArray(arg);
}
function $1364988d5fdddede$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $1364988d5fdddede$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $1364988d5fdddede$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $1364988d5fdddede$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $1364988d5fdddede$var$_excluded$3 = [
    "children",
    "innerProps"
], $1364988d5fdddede$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $1364988d5fdddede$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $1364988d5fdddede$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $1364988d5fdddede$var$normalizedHeight(scrollParent);
    var scrollTop = $1364988d5fdddede$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1364988d5fdddede$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $1364988d5fdddede$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $1364988d5fdddede$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1364988d5fdddede$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $1364988d5fdddede$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $1364988d5fdddede$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $1364988d5fdddede$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $1364988d5fdddede$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, $1364988d5fdddede$var$alignToControl(placement), "100%"), (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $1364988d5fdddede$var$PortalPlacementContext = /*#__PURE__*/ (0, $lDSNw.createContext)(null);
// NOTE: internal only
var $1364988d5fdddede$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $lDSNw.useContext)($1364988d5fdddede$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $lDSNw.useRef)(null);
    var _useState = (0, $lDSNw.useState)(maxMenuHeight), _useState2 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $lDSNw.useState)(null), _useState4 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e063c96a1d8f564a$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $1364988d5fdddede$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $1364988d5fdddede$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $1364988d5fdddede$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $1364988d5fdddede$var$Menu$1 = $1364988d5fdddede$var$Menu;
// ==============================
// Menu List
// ==============================
var $1364988d5fdddede$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $1364988d5fdddede$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $1364988d5fdddede$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $1364988d5fdddede$export$3b14a55fb2447963 = $1364988d5fdddede$var$noticeCSS;
var $1364988d5fdddede$export$342063e11d6c3cad = $1364988d5fdddede$var$noticeCSS;
var $1364988d5fdddede$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref6, $1364988d5fdddede$var$_excluded$3);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $1364988d5fdddede$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref7, $1364988d5fdddede$var$_excluded2$1);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $1364988d5fdddede$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $1364988d5fdddede$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $lDSNw.useRef)(null);
    var cleanupRef = (0, $lDSNw.useRef)(null);
    var _useState5 = (0, $lDSNw.useState)($1364988d5fdddede$var$coercePlacement(menuPlacement)), _useState6 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $lDSNw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $lDSNw.useState)(null), _useState8 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $lDSNw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $1364988d5fdddede$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e063c96a1d8f564a$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $lDSNw.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $69793dd0b3b21fcc$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e063c96a1d8f564a$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $lDSNw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $1364988d5fdddede$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $ef4Zh.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $1364988d5fdddede$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $1364988d5fdddede$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $1364988d5fdddede$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $1364988d5fdddede$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $1364988d5fdddede$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $1364988d5fdddede$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $1364988d5fdddede$var$_templateObject;
var $1364988d5fdddede$var$_excluded$2 = [
    "size"
], $1364988d5fdddede$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $1364988d5fdddede$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $1364988d5fdddede$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $1364988d5fdddede$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $1364988d5fdddede$var$_excluded$2);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("svg", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $1364988d5fdddede$var$_ref2
    }, props));
};
var $1364988d5fdddede$var$CrossIcon = function CrossIcon(props) {
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$Svg, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $1364988d5fdddede$var$DownChevron = function DownChevron(props) {
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$Svg, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $1364988d5fdddede$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $1364988d5fdddede$export$f1e1789686576879 = $1364988d5fdddede$var$baseCSS;
var $1364988d5fdddede$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$DownChevron, null));
};
var $1364988d5fdddede$export$407448d2b89b1813 = $1364988d5fdddede$var$baseCSS;
var $1364988d5fdddede$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $1364988d5fdddede$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $1364988d5fdddede$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, innerProps, $1364988d5fdddede$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $1364988d5fdddede$var$loadingDotAnimations = (0, $8c971e9544ccda33$export$d25ddfdf17c3ad3e)($1364988d5fdddede$var$_templateObject || ($1364988d5fdddede$var$_templateObject = (0, $b2d90021a6dce772$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $1364988d5fdddede$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $1364988d5fdddede$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $8c971e9544ccda33$export$dbf350e5966cf602)({
            animation: "".concat($1364988d5fdddede$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $1364988d5fdddede$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref7, $1364988d5fdddede$var$_excluded2);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $1364988d5fdddede$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $1364988d5fdddede$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $1364988d5fdddede$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $1364988d5fdddede$var$Control$1 = $1364988d5fdddede$var$Control;
var $1364988d5fdddede$var$_excluded$1 = [
    "data"
];
var $1364988d5fdddede$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $1364988d5fdddede$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Heading, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", null, children));
};
var $1364988d5fdddede$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $1364988d5fdddede$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $1364988d5fdddede$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_cleanCommonProps, $1364988d5fdddede$var$_excluded$1);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $1364988d5fdddede$var$Group$1 = $1364988d5fdddede$var$Group;
var $1364988d5fdddede$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $1364988d5fdddede$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $1364988d5fdddede$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $1364988d5fdddede$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $1364988d5fdddede$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $1364988d5fdddede$var$spacingStyle)
};
var $1364988d5fdddede$var$inputStyle = function inputStyle(isHidden) {
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $1364988d5fdddede$var$spacingStyle);
};
var $1364988d5fdddede$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $1364988d5fdddede$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_cleanCommonProps, $1364988d5fdddede$var$_excluded);
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("input", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $1364988d5fdddede$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $1364988d5fdddede$var$Input$1 = $1364988d5fdddede$var$Input;
var $1364988d5fdddede$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $1364988d5fdddede$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $1364988d5fdddede$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $1364988d5fdddede$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $1364988d5fdddede$var$MultiValueContainer = $1364988d5fdddede$var$MultiValueGeneric;
var $1364988d5fdddede$var$MultiValueLabel = $1364988d5fdddede$var$MultiValueGeneric;
function $1364988d5fdddede$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($1364988d5fdddede$var$CrossIcon, {
        size: 14
    }));
}
var $1364988d5fdddede$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $1364988d5fdddede$var$MultiValue$1 = $1364988d5fdddede$var$MultiValue;
var $1364988d5fdddede$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $1364988d5fdddede$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $1364988d5fdddede$var$Option$1 = $1364988d5fdddede$var$Option;
var $1364988d5fdddede$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $1364988d5fdddede$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $1364988d5fdddede$var$Placeholder$1 = $1364988d5fdddede$var$Placeholder;
var $1364988d5fdddede$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $1364988d5fdddede$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, $1364988d5fdddede$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $1364988d5fdddede$var$SingleValue$1 = $1364988d5fdddede$var$SingleValue;
var $1364988d5fdddede$export$db3b6bfb95261072 = {
    ClearIndicator: $1364988d5fdddede$var$ClearIndicator,
    Control: $1364988d5fdddede$var$Control$1,
    DropdownIndicator: $1364988d5fdddede$var$DropdownIndicator,
    DownChevron: $1364988d5fdddede$var$DownChevron,
    CrossIcon: $1364988d5fdddede$var$CrossIcon,
    Group: $1364988d5fdddede$var$Group$1,
    GroupHeading: $1364988d5fdddede$var$GroupHeading,
    IndicatorsContainer: $1364988d5fdddede$var$IndicatorsContainer,
    IndicatorSeparator: $1364988d5fdddede$var$IndicatorSeparator,
    Input: $1364988d5fdddede$var$Input$1,
    LoadingIndicator: $1364988d5fdddede$var$LoadingIndicator,
    Menu: $1364988d5fdddede$var$Menu$1,
    MenuList: $1364988d5fdddede$var$MenuList,
    MenuPortal: $1364988d5fdddede$var$MenuPortal,
    LoadingMessage: $1364988d5fdddede$var$LoadingMessage,
    NoOptionsMessage: $1364988d5fdddede$var$NoOptionsMessage,
    MultiValue: $1364988d5fdddede$var$MultiValue$1,
    MultiValueContainer: $1364988d5fdddede$var$MultiValueContainer,
    MultiValueLabel: $1364988d5fdddede$var$MultiValueLabel,
    MultiValueRemove: $1364988d5fdddede$var$MultiValueRemove,
    Option: $1364988d5fdddede$var$Option$1,
    Placeholder: $1364988d5fdddede$var$Placeholder$1,
    SelectContainer: $1364988d5fdddede$var$SelectContainer,
    SingleValue: $1364988d5fdddede$var$SingleValue$1,
    ValueContainer: $1364988d5fdddede$var$ValueContainer
};
var $1364988d5fdddede$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $1364988d5fdddede$export$db3b6bfb95261072), props.components);
};





function $33b14307a6ff7705$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $33b14307a6ff7705$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $33b14307a6ff7705$var$A11yText = function A11yText(props) {
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        css: $33b14307a6ff7705$var$_ref
    }, props));
};
var $33b14307a6ff7705$var$A11yText$1 = $33b14307a6ff7705$var$A11yText;
var $33b14307a6ff7705$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $33b14307a6ff7705$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $lDSNw.useMemo)(function() {
        return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $33b14307a6ff7705$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $lDSNw.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $lDSNw.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $lDSNw.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $lDSNw.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)((0, $lDSNw.Fragment), null, (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)((0, $lDSNw.Fragment), null, (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($33b14307a6ff7705$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)($33b14307a6ff7705$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $33b14307a6ff7705$var$LiveRegion$1 = $33b14307a6ff7705$var$LiveRegion;
var $33b14307a6ff7705$var$diacritics = [
    {
        base: "A",
        letters: "AⒶＡ\xc0\xc1\xc2ẦẤẪẨ\xc3ĀĂẰẮẴẲȦǠ\xc4ǞẢ\xc5ǺǍȀȂẠẬẶḀĄȺⱯ"
    },
    {
        base: "AA",
        letters: "Ꜳ"
    },
    {
        base: "AE",
        letters: "\xc6ǼǢ"
    },
    {
        base: "AO",
        letters: "Ꜵ"
    },
    {
        base: "AU",
        letters: "Ꜷ"
    },
    {
        base: "AV",
        letters: "ꜸꜺ"
    },
    {
        base: "AY",
        letters: "Ꜽ"
    },
    {
        base: "B",
        letters: "BⒷＢḂḄḆɃƂƁ"
    },
    {
        base: "C",
        letters: "CⒸＣĆĈĊČ\xc7ḈƇȻꜾ"
    },
    {
        base: "D",
        letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
    },
    {
        base: "DZ",
        letters: "ǱǄ"
    },
    {
        base: "Dz",
        letters: "ǲǅ"
    },
    {
        base: "E",
        letters: "EⒺＥ\xc8\xc9\xcaỀẾỄỂẼĒḔḖĔĖ\xcbẺĚȄȆẸỆȨḜĘḘḚƐƎ"
    },
    {
        base: "F",
        letters: "FⒻＦḞƑꝻ"
    },
    {
        base: "G",
        letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
    },
    {
        base: "H",
        letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
    },
    {
        base: "I",
        letters: "IⒾＩ\xcc\xcd\xceĨĪĬİ\xcfḮỈǏȈȊỊĮḬƗ"
    },
    {
        base: "J",
        letters: "JⒿＪĴɈ"
    },
    {
        base: "K",
        letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
    },
    {
        base: "L",
        letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
    },
    {
        base: "LJ",
        letters: "Ǉ"
    },
    {
        base: "Lj",
        letters: "ǈ"
    },
    {
        base: "M",
        letters: "MⓂＭḾṀṂⱮƜ"
    },
    {
        base: "N",
        letters: "NⓃＮǸŃ\xd1ṄŇṆŅṊṈȠƝꞐꞤ"
    },
    {
        base: "NJ",
        letters: "Ǌ"
    },
    {
        base: "Nj",
        letters: "ǋ"
    },
    {
        base: "O",
        letters: "OⓄＯ\xd2\xd3\xd4ỒỐỖỔ\xd5ṌȬṎŌṐṒŎȮȰ\xd6ȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬ\xd8ǾƆƟꝊꝌ"
    },
    {
        base: "OI",
        letters: "Ƣ"
    },
    {
        base: "OO",
        letters: "Ꝏ"
    },
    {
        base: "OU",
        letters: "Ȣ"
    },
    {
        base: "P",
        letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
    },
    {
        base: "Q",
        letters: "QⓆＱꝖꝘɊ"
    },
    {
        base: "R",
        letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
    },
    {
        base: "S",
        letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
    },
    {
        base: "T",
        letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
    },
    {
        base: "TZ",
        letters: "Ꜩ"
    },
    {
        base: "U",
        letters: "UⓊＵ\xd9\xda\xdbŨṸŪṺŬ\xdcǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
    },
    {
        base: "V",
        letters: "VⓋＶṼṾƲꝞɅ"
    },
    {
        base: "VY",
        letters: "Ꝡ"
    },
    {
        base: "W",
        letters: "WⓌＷẀẂŴẆẄẈⱲ"
    },
    {
        base: "X",
        letters: "XⓍＸẊẌ"
    },
    {
        base: "Y",
        letters: "YⓎＹỲ\xddŶỸȲẎŸỶỴƳɎỾ"
    },
    {
        base: "Z",
        letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
    },
    {
        base: "a",
        letters: "aⓐａẚ\xe0\xe1\xe2ầấẫẩ\xe3āăằắẵẳȧǡ\xe4ǟả\xe5ǻǎȁȃạậặḁąⱥɐ"
    },
    {
        base: "aa",
        letters: "ꜳ"
    },
    {
        base: "ae",
        letters: "\xe6ǽǣ"
    },
    {
        base: "ao",
        letters: "ꜵ"
    },
    {
        base: "au",
        letters: "ꜷ"
    },
    {
        base: "av",
        letters: "ꜹꜻ"
    },
    {
        base: "ay",
        letters: "ꜽ"
    },
    {
        base: "b",
        letters: "bⓑｂḃḅḇƀƃɓ"
    },
    {
        base: "c",
        letters: "cⓒｃćĉċč\xe7ḉƈȼꜿↄ"
    },
    {
        base: "d",
        letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
    },
    {
        base: "dz",
        letters: "ǳǆ"
    },
    {
        base: "e",
        letters: "eⓔｅ\xe8\xe9\xeaềếễểẽēḕḗĕė\xebẻěȅȇẹệȩḝęḙḛɇɛǝ"
    },
    {
        base: "f",
        letters: "fⓕｆḟƒꝼ"
    },
    {
        base: "g",
        letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
    },
    {
        base: "h",
        letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
    },
    {
        base: "hv",
        letters: "ƕ"
    },
    {
        base: "i",
        letters: "iⓘｉ\xec\xed\xeeĩīĭ\xefḯỉǐȉȋịįḭɨı"
    },
    {
        base: "j",
        letters: "jⓙｊĵǰɉ"
    },
    {
        base: "k",
        letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
    },
    {
        base: "l",
        letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
    },
    {
        base: "lj",
        letters: "ǉ"
    },
    {
        base: "m",
        letters: "mⓜｍḿṁṃɱɯ"
    },
    {
        base: "n",
        letters: "nⓝｎǹń\xf1ṅňṇņṋṉƞɲŉꞑꞥ"
    },
    {
        base: "nj",
        letters: "ǌ"
    },
    {
        base: "o",
        letters: "oⓞｏ\xf2\xf3\xf4ồốỗổ\xf5ṍȭṏōṑṓŏȯȱ\xf6ȫỏőǒȍȏơờớỡởợọộǫǭ\xf8ǿɔꝋꝍɵ"
    },
    {
        base: "oi",
        letters: "ƣ"
    },
    {
        base: "ou",
        letters: "ȣ"
    },
    {
        base: "oo",
        letters: "ꝏ"
    },
    {
        base: "p",
        letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
    },
    {
        base: "q",
        letters: "qⓠｑɋꝗꝙ"
    },
    {
        base: "r",
        letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
    },
    {
        base: "s",
        letters: "sⓢｓ\xdfśṥŝṡšṧṣṩșşȿꞩꞅẛ"
    },
    {
        base: "t",
        letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
    },
    {
        base: "tz",
        letters: "ꜩ"
    },
    {
        base: "u",
        letters: "uⓤｕ\xf9\xfa\xfbũṹūṻŭ\xfcǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
    },
    {
        base: "v",
        letters: "vⓥｖṽṿʋꝟʌ"
    },
    {
        base: "vy",
        letters: "ꝡ"
    },
    {
        base: "w",
        letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
    },
    {
        base: "x",
        letters: "xⓧｘẋẍ"
    },
    {
        base: "y",
        letters: "yⓨｙỳ\xfdŷỹȳẏ\xffỷẙỵƴɏỿ"
    },
    {
        base: "z",
        letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
    }
];
var $33b14307a6ff7705$var$anyDiacritic = new RegExp("[" + $33b14307a6ff7705$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $33b14307a6ff7705$var$diacriticToBase = {};
for(var $33b14307a6ff7705$var$i = 0; $33b14307a6ff7705$var$i < $33b14307a6ff7705$var$diacritics.length; $33b14307a6ff7705$var$i++){
    var $33b14307a6ff7705$var$diacritic = $33b14307a6ff7705$var$diacritics[$33b14307a6ff7705$var$i];
    for(var $33b14307a6ff7705$var$j = 0; $33b14307a6ff7705$var$j < $33b14307a6ff7705$var$diacritic.letters.length; $33b14307a6ff7705$var$j++)$33b14307a6ff7705$var$diacriticToBase[$33b14307a6ff7705$var$diacritic.letters[$33b14307a6ff7705$var$j]] = $33b14307a6ff7705$var$diacritic.base;
}
var $33b14307a6ff7705$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($33b14307a6ff7705$var$anyDiacritic, function(match) {
        return $33b14307a6ff7705$var$diacriticToBase[match];
    });
};
var $33b14307a6ff7705$var$memoizedStripDiacriticsForInput = (0, $b416a8bfe9e12ed9$export$2e2bcd8739ae039)($33b14307a6ff7705$var$stripDiacritics);
var $33b14307a6ff7705$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $33b14307a6ff7705$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $33b14307a6ff7705$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $33b14307a6ff7705$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $33b14307a6ff7705$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $33b14307a6ff7705$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $33b14307a6ff7705$var$memoizedStripDiacriticsForInput(input);
            candidate = $33b14307a6ff7705$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $33b14307a6ff7705$var$_excluded = [
    "innerRef"
];
function $33b14307a6ff7705$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $33b14307a6ff7705$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $1364988d5fdddede$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("input", (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $8c971e9544ccda33$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $33b14307a6ff7705$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $33b14307a6ff7705$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $lDSNw.useRef)(false);
    var isTop = (0, $lDSNw.useRef)(false);
    var touchStart = (0, $lDSNw.useRef)(0);
    var scrollTarget = (0, $lDSNw.useRef)(null);
    var handleEventDelta = (0, $lDSNw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $33b14307a6ff7705$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $lDSNw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $lDSNw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $lDSNw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $lDSNw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $1364988d5fdddede$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $lDSNw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $lDSNw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $33b14307a6ff7705$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $33b14307a6ff7705$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $33b14307a6ff7705$var$preventTouchMove(e) {
    e.preventDefault();
}
function $33b14307a6ff7705$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $33b14307a6ff7705$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $33b14307a6ff7705$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $33b14307a6ff7705$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $33b14307a6ff7705$var$activeScrollLocks = 0;
var $33b14307a6ff7705$var$listenerOptions = {
    capture: false,
    passive: false
};
function $33b14307a6ff7705$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $lDSNw.useRef)({});
    var scrollTarget = (0, $lDSNw.useRef)(null);
    var addScrollLock = (0, $lDSNw.useCallback)(function(touchScrollTarget) {
        if (!$33b14307a6ff7705$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $33b14307a6ff7705$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $33b14307a6ff7705$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($33b14307a6ff7705$var$LOCK_STYLES).forEach(function(key) {
                var val = $33b14307a6ff7705$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $33b14307a6ff7705$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $33b14307a6ff7705$var$preventTouchMove, $33b14307a6ff7705$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $33b14307a6ff7705$var$preventInertiaScroll, $33b14307a6ff7705$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $33b14307a6ff7705$var$allowTouchMove, $33b14307a6ff7705$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $33b14307a6ff7705$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $lDSNw.useCallback)(function(touchScrollTarget) {
        if (!$33b14307a6ff7705$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $33b14307a6ff7705$var$activeScrollLocks = Math.max($33b14307a6ff7705$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $33b14307a6ff7705$var$activeScrollLocks < 1) $33b14307a6ff7705$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $33b14307a6ff7705$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $33b14307a6ff7705$var$preventTouchMove, $33b14307a6ff7705$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $33b14307a6ff7705$var$preventInertiaScroll, $33b14307a6ff7705$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $33b14307a6ff7705$var$allowTouchMove, $33b14307a6ff7705$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $lDSNw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $33b14307a6ff7705$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $33b14307a6ff7705$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $33b14307a6ff7705$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $33b14307a6ff7705$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $33b14307a6ff7705$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $33b14307a6ff7705$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)((0, $lDSNw.Fragment), null, lockEnabled && (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("div", {
        onClick: $33b14307a6ff7705$var$blurSelectInput,
        css: $33b14307a6ff7705$var$_ref2$1
    }), children(targetRef));
}
function $33b14307a6ff7705$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $33b14307a6ff7705$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $33b14307a6ff7705$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $8c971e9544ccda33$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $33b14307a6ff7705$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $33b14307a6ff7705$var$RequiredInput$1 = $33b14307a6ff7705$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $33b14307a6ff7705$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $33b14307a6ff7705$var$isIPhone() {
    return $33b14307a6ff7705$var$testPlatform(/^iPhone/i);
}
function $33b14307a6ff7705$var$isMac() {
    return $33b14307a6ff7705$var$testPlatform(/^Mac/i);
}
function $33b14307a6ff7705$var$isIPad() {
    return $33b14307a6ff7705$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $33b14307a6ff7705$var$isMac() && navigator.maxTouchPoints > 1;
}
function $33b14307a6ff7705$var$isIOS() {
    return $33b14307a6ff7705$var$isIPhone() || $33b14307a6ff7705$var$isIPad();
}
function $33b14307a6ff7705$var$isAppleDevice() {
    return $33b14307a6ff7705$var$isMac() || $33b14307a6ff7705$var$isIOS();
}
var $33b14307a6ff7705$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $33b14307a6ff7705$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $33b14307a6ff7705$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $33b14307a6ff7705$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $33b14307a6ff7705$var$defaultStyles = {
    clearIndicator: (0, $1364988d5fdddede$export$407448d2b89b1813),
    container: (0, $1364988d5fdddede$export$8b22cf2602fb60ce),
    control: (0, $1364988d5fdddede$export$4368d992c4eafac0),
    dropdownIndicator: (0, $1364988d5fdddede$export$f1e1789686576879),
    group: (0, $1364988d5fdddede$export$39b482c5e57630a8),
    groupHeading: (0, $1364988d5fdddede$export$2d1720544b23b823),
    indicatorsContainer: (0, $1364988d5fdddede$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $1364988d5fdddede$export$dda1d9f60106f0e9),
    input: (0, $1364988d5fdddede$export$35e795649ee09318),
    loadingIndicator: (0, $1364988d5fdddede$export$882b5998b3b9117c),
    loadingMessage: (0, $1364988d5fdddede$export$342063e11d6c3cad),
    menu: (0, $1364988d5fdddede$export$953cecd6e717a553),
    menuList: (0, $1364988d5fdddede$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $1364988d5fdddede$export$ae1af26003f05816),
    multiValue: (0, $1364988d5fdddede$export$ffb5f4729a158638),
    multiValueLabel: (0, $1364988d5fdddede$export$9e5f44173e64f162),
    multiValueRemove: (0, $1364988d5fdddede$export$625550452a3fa3ec),
    noOptionsMessage: (0, $1364988d5fdddede$export$3b14a55fb2447963),
    option: (0, $1364988d5fdddede$export$90a7f3efeed30595),
    placeholder: (0, $1364988d5fdddede$export$efccba1c4a2ef57b),
    singleValue: (0, $1364988d5fdddede$export$d141bba7fdc215a3),
    valueContainer: (0, $1364988d5fdddede$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $33b14307a6ff7705$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $33b14307a6ff7705$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $33b14307a6ff7705$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $33b14307a6ff7705$var$baseUnit = 4;
// The minimum height of the control
var $33b14307a6ff7705$var$controlHeight = 38;
// The amount of space between the control and menu */
var $33b14307a6ff7705$var$menuGutter = $33b14307a6ff7705$var$baseUnit * 2;
var $33b14307a6ff7705$var$spacing = {
    baseUnit: $33b14307a6ff7705$var$baseUnit,
    controlHeight: $33b14307a6ff7705$var$controlHeight,
    menuGutter: $33b14307a6ff7705$var$menuGutter
};
var $33b14307a6ff7705$export$4368d992c4eafac0 = {
    borderRadius: $33b14307a6ff7705$var$borderRadius,
    colors: $33b14307a6ff7705$var$colors,
    spacing: $33b14307a6ff7705$var$spacing
};
var $33b14307a6ff7705$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $1364988d5fdddede$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $1364988d5fdddede$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $33b14307a6ff7705$export$db3b6bfb95261072(),
    formatGroupLabel: $33b14307a6ff7705$var$formatGroupLabel,
    getOptionLabel: $33b14307a6ff7705$export$8b22cf2602fb60ce,
    getOptionValue: $33b14307a6ff7705$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $33b14307a6ff7705$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $1364988d5fdddede$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $33b14307a6ff7705$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $33b14307a6ff7705$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $33b14307a6ff7705$var$_isOptionSelected(props, option, selectValue);
    var label = $33b14307a6ff7705$var$getOptionLabel(props, option);
    var value = $33b14307a6ff7705$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $33b14307a6ff7705$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $33b14307a6ff7705$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $33b14307a6ff7705$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $33b14307a6ff7705$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $33b14307a6ff7705$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $1364988d5fdddede$export$3466f893ebf79586));
}
function $33b14307a6ff7705$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $33b14307a6ff7705$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $33b14307a6ff7705$var$buildFocusableOptions(props, selectValue) {
    return $33b14307a6ff7705$var$buildFocusableOptionsFromCategorizedOptions($33b14307a6ff7705$var$buildCategorizedOptions(props, selectValue));
}
function $33b14307a6ff7705$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$33b14307a6ff7705$var$shouldHideSelectedOptions(props) || !isSelected) && $33b14307a6ff7705$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $33b14307a6ff7705$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $33b14307a6ff7705$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $33b14307a6ff7705$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $33b14307a6ff7705$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $33b14307a6ff7705$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $33b14307a6ff7705$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $33b14307a6ff7705$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $33b14307a6ff7705$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $33b14307a6ff7705$var$getOptionValue(props, i) === candidate;
    });
}
function $33b14307a6ff7705$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $33b14307a6ff7705$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $33b14307a6ff7705$var$instanceId = 1;
var $33b14307a6ff7705$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $e478241f0c67c862$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $e4e44fec2fa4313d$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $13600594d241a5f3$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $33b14307a6ff7705$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $1364988d5fdddede$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $1364988d5fdddede$export$ef35774e6d314e91)([].concat((0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $1364988d5fdddede$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $1364988d5fdddede$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $1364988d5fdddede$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $1364988d5fdddede$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $1364988d5fdddede$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $33b14307a6ff7705$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $33b14307a6ff7705$var$buildFocusableOptionsWithIds($33b14307a6ff7705$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $1364988d5fdddede$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $33b14307a6ff7705$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $33b14307a6ff7705$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $33b14307a6ff7705$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $1364988d5fdddede$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $33b14307a6ff7705$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $33b14307a6ff7705$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $1364988d5fdddede$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $33b14307a6ff7705$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$33b14307a6ff7705$var$instanceId);
        _this.state.selectValue = (0, $1364988d5fdddede$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $33b14307a6ff7705$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $d582913ea91ca96d$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $1364988d5fdddede$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $1364988d5fdddede$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $33b14307a6ff7705$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($33b14307a6ff7705$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, $33b14307a6ff7705$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $33b14307a6ff7705$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $33b14307a6ff7705$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $33b14307a6ff7705$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $lDSNw.createElement($33b14307a6ff7705$var$DummyInput, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $1364988d5fdddede$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $lDSNw.createElement(Input, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $lDSNw.createElement(Placeholder, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $lDSNw.createElement(MultiValue, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $lDSNw.createElement(SingleValue, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $lDSNw.createElement(ClearIndicator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $lDSNw.createElement(LoadingIndicator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $lDSNw.createElement(IndicatorSeparator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $lDSNw.createElement(DropdownIndicator, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $lDSNw.createElement(Option, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $lDSNw.createElement(Group, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $lDSNw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $lDSNw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $lDSNw.createElement((0, $1364988d5fdddede$export$3a1a48c8f6ef640e), (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $lDSNw.createElement(Menu, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $lDSNw.createElement($33b14307a6ff7705$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $lDSNw.createElement(MenuList, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $lDSNw.createElement(MenuPortal, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $lDSNw.createElement($33b14307a6ff7705$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $lDSNw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $lDSNw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $lDSNw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $lDSNw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $lDSNw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $lDSNw.createElement($33b14307a6ff7705$var$LiveRegion$1, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $lDSNw.createElement(SelectContainer, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $lDSNw.createElement(Control, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $lDSNw.createElement(ValueContainer, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $lDSNw.createElement(IndicatorsContainer, (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $1364988d5fdddede$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $33b14307a6ff7705$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $33b14307a6ff7705$var$buildFocusableOptionsWithIds($33b14307a6ff7705$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $33b14307a6ff7705$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $33b14307a6ff7705$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $33b14307a6ff7705$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $1364988d5fdddede$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $lDSNw.Component));
$33b14307a6ff7705$export$25ce5a424b770e84.defaultProps = $33b14307a6ff7705$export$407448d2b89b1813;

















parcelRequire("ef4Zh");


var $935d291a7dd3f6d8$var$StateManagedSelect = /*#__PURE__*/ (0, $lDSNw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $538aa6a2b60a37e7$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $lDSNw.createElement((0, $33b14307a6ff7705$export$25ce5a424b770e84), (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $935d291a7dd3f6d8$export$2e2bcd8739ae039 = $935d291a7dd3f6d8$var$StateManagedSelect;
var $935d291a7dd3f6d8$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $lDSNw.useMemo)(function() {
        return (0, $6a2c18332cff1b13$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $lDSNw.createElement((0, $fee187d89b24554e$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};






"use client";
function $fc5207baf814cda5$export$4b9ea961bfd9be6e(values, breakpoint, breakpoints = (0, $236059bf8082cb80$export$d07517a676ce386f)) {
    let index = Object.keys(values).indexOf(breakpoint);
    if (index !== -1) return values[breakpoint];
    let stopIndex = breakpoints.indexOf(breakpoint);
    while(stopIndex >= 0){
        const key = breakpoints[stopIndex];
        if (values.hasOwnProperty(key)) {
            index = stopIndex;
            break;
        }
        stopIndex -= 1;
    }
    if (index !== -1) {
        const key = breakpoints[index];
        return values[key];
    }
    return void 0;
}




var $lDSNw = parcelRequire("lDSNw");
"use client";
function $a67f4f7ce0166ad7$export$32d5543ab307c01(query, options = {}) {
    const { ssr: ssr = true, fallback: fallback } = options;
    const { getWindow: getWindow } = (0, $a7587505528881ba$export$ea7ed2425832167d)();
    const queries = Array.isArray(query) ? query : [
        query
    ];
    let fallbackValues = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    fallbackValues = fallbackValues.filter((v)=>v != null);
    const [value, setValue] = (0, $lDSNw.useState)(()=>{
        return queries.map((query2, index)=>({
                media: query2,
                matches: ssr ? !!fallbackValues[index] : getWindow().matchMedia(query2).matches
            }));
    });
    (0, $lDSNw.useEffect)(()=>{
        const win = getWindow();
        setValue(queries.map((query2)=>({
                media: query2,
                matches: win.matchMedia(query2).matches
            })));
        const mql = queries.map((query2)=>win.matchMedia(query2));
        const handler = (evt)=>{
            setValue((prev)=>{
                return prev.slice().map((item)=>{
                    if (item.media === evt.media) return {
                        ...item,
                        matches: evt.matches
                    };
                    return item;
                });
            });
        };
        mql.forEach((mql2)=>{
            if (typeof mql2.addListener === "function") mql2.addListener(handler);
            else mql2.addEventListener("change", handler);
        });
        return ()=>{
            mql.forEach((mql2)=>{
                if (typeof mql2.removeListener === "function") mql2.removeListener(handler);
                else mql2.removeEventListener("change", handler);
            });
        };
    }, [
        getWindow
    ]);
    return value.map((item)=>item.matches);
}




"use client";
function $dcb4307dbf9a05a6$export$199d6754bdf4e1e3(arg) {
    var _a, _b;
    const opts = (0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(arg) ? arg : {
        fallback: arg != null ? arg : "base"
    };
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery: minMaxQuery, breakpoint: breakpoint })=>({
            breakpoint: breakpoint,
            query: minMaxQuery.replace("@media screen and ", "")
        }));
    const fallback = breakpoints.map((bp)=>bp.breakpoint === opts.fallback);
    const values = (0, $a67f4f7ce0166ad7$export$32d5543ab307c01)(breakpoints.map((bp)=>bp.query), {
        fallback: fallback,
        ssr: opts.ssr
    });
    const index = values.findIndex((value)=>value == true);
    return (_b = (_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) != null ? _b : opts.fallback;
}





"use client";
function $ea9feb6f6829a50e$export$dc0946e21e709aff(values, arg) {
    var _a;
    const opts = (0, $a223a0f4c9b3f9de$export$a6cdc56e425d0d0a)(arg) ? arg : {
        fallback: arg != null ? arg : "base"
    };
    const breakpoint = (0, $dcb4307dbf9a05a6$export$199d6754bdf4e1e3)(opts);
    const theme = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    if (!breakpoint) return;
    const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
    const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0, $236059bf8082cb80$export$60476530468641e7)(values, breakpoints)).map(([key, value])=>[
            key,
            value
        ])) : values;
    return (0, $fc5207baf814cda5$export$4b9ea961bfd9be6e)(obj, breakpoint, breakpoints);
}






var $lDSNw = parcelRequire("lDSNw");
"use client";
function $64c1f280ff52779c$var$isPrintableCharacter(event) {
    const { key: key } = event;
    return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}
function $64c1f280ff52779c$export$b0ebbe7904d8d94a(props = {}) {
    const { timeout: timeout = 300, preventDefault: preventDefault = ()=>true } = props;
    const [keys, setKeys] = (0, $lDSNw.useState)([]);
    const timeoutRef = (0, $lDSNw.useRef)();
    const flush = ()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    const clearKeysAfterDelay = ()=>{
        flush();
        timeoutRef.current = setTimeout(()=>{
            setKeys([]);
            timeoutRef.current = null;
        }, timeout);
    };
    (0, $lDSNw.useEffect)(()=>flush, []);
    function onKeyDown(fn) {
        return (event)=>{
            if (event.key === "Backspace") {
                const keysCopy = [
                    ...keys
                ];
                keysCopy.pop();
                setKeys(keysCopy);
                return;
            }
            if ($64c1f280ff52779c$var$isPrintableCharacter(event)) {
                const keysCopy = keys.concat(event.key);
                if (preventDefault(event)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                setKeys(keysCopy);
                fn(keysCopy.join(""));
                clearKeysAfterDelay();
            }
        };
    }
    return onKeyDown;
}


"use client";
// src/get-next-item-from-search.ts
function $e4084908b5cde179$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
    if (!currentItem) {
        const foundItem = items.find((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
        return foundItem;
    }
    const matchingItems = items.filter((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
    if (matchingItems.length > 0) {
        let nextIndex;
        if (matchingItems.includes(currentItem)) {
            const currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        }
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    }
    return currentItem;
}








var $lDSNw = parcelRequire("lDSNw");

"use client";
function $179252284255db58$export$71b2224f1ce5e08e(props) {
    const { ref: ref, handler: handler, enabled: enabled = true } = props;
    const savedHandler = (0, $076eda8ddf8e17cf$export$25bec8c6f54ee79a)(handler);
    const stateRef = (0, $lDSNw.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    const state = stateRef.current;
    (0, $lDSNw.useEffect)(()=>{
        if (!enabled) return;
        const onPointerDown = (e)=>{
            if ($179252284255db58$var$isValidEvent(e, ref)) state.isPointerDown = true;
        };
        const onMouseUp = (event)=>{
            if (state.ignoreEmulatedMouseEvents) {
                state.ignoreEmulatedMouseEvents = false;
                return;
            }
            if (state.isPointerDown && handler && $179252284255db58$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const onTouchEnd = (event)=>{
            state.ignoreEmulatedMouseEvents = true;
            if (handler && state.isPointerDown && $179252284255db58$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const doc = $179252284255db58$var$getOwnerDocument(ref.current);
        doc.addEventListener("mousedown", onPointerDown, true);
        doc.addEventListener("mouseup", onMouseUp, true);
        doc.addEventListener("touchstart", onPointerDown, true);
        doc.addEventListener("touchend", onTouchEnd, true);
        return ()=>{
            doc.removeEventListener("mousedown", onPointerDown, true);
            doc.removeEventListener("mouseup", onMouseUp, true);
            doc.removeEventListener("touchstart", onPointerDown, true);
            doc.removeEventListener("touchend", onTouchEnd, true);
        };
    }, [
        handler,
        ref,
        savedHandler,
        state,
        enabled
    ]);
}
function $179252284255db58$var$isValidEvent(event, ref) {
    var _a;
    const target = event.target;
    if (target) {
        const doc = $179252284255db58$var$getOwnerDocument(target);
        if (!doc.contains(target)) return false;
    }
    return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}
function $179252284255db58$var$getOwnerDocument(node) {
    var _a;
    return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}











var $lDSNw = parcelRequire("lDSNw");
"use client";
var [$88e92a213fd6a914$export$6bd12c048acae948, $88e92a213fd6a914$export$fb081774625c317c, $88e92a213fd6a914$export$c383d7d91778257e, $88e92a213fd6a914$export$e44adeffd1a0865c] = (0, $f804e39eab5fd41b$export$126c4100f8947d7)();
var [$88e92a213fd6a914$export$62b22d151866115d, $88e92a213fd6a914$export$21c7ab35b39f78ec] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    strict: false,
    name: "MenuContext"
});
function $88e92a213fd6a914$var$useIds(idProp, ...prefixes) {
    const reactId = (0, $lDSNw.useId)();
    const id = idProp || reactId;
    return (0, $lDSNw.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $88e92a213fd6a914$var$getOwnerDocument(node) {
    var _a;
    return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}
function $88e92a213fd6a914$var$isActiveElement(element) {
    const doc = $88e92a213fd6a914$var$getOwnerDocument(element);
    return doc.activeElement === element;
}
function $88e92a213fd6a914$export$38eaa17faae8f579(props = {}) {
    const { id: id, closeOnSelect: closeOnSelect = true, closeOnBlur: closeOnBlur = true, initialFocusRef: initialFocusRef, autoSelect: autoSelect = true, isLazy: isLazy, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, onClose: onCloseProp, onOpen: onOpenProp, placement: placement = "bottom-start", lazyBehavior: lazyBehavior = "unmount", direction: direction, computePositionOnMount: computePositionOnMount = false, ...popperProps } = props;
    const menuRef = (0, $lDSNw.useRef)(null);
    const buttonRef = (0, $lDSNw.useRef)(null);
    const descendants = $88e92a213fd6a914$export$c383d7d91778257e();
    const focusMenu = (0, $lDSNw.useCallback)(()=>{
        requestAnimationFrame(()=>{
            var _a;
            (_a = menuRef.current) == null || _a.focus({
                preventScroll: false
            });
        });
    }, []);
    const focusFirstItem = (0, $lDSNw.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            var _a;
            if (initialFocusRef) (_a = initialFocusRef.current) == null || _a.focus();
            else {
                const first = descendants.firstEnabled();
                if (first) setFocusedIndex(first.index);
            }
        });
        timeoutIds.current.add(id2);
    }, [
        descendants,
        initialFocusRef
    ]);
    const focusLastItem = (0, $lDSNw.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            const last = descendants.lastEnabled();
            if (last) setFocusedIndex(last.index);
        });
        timeoutIds.current.add(id2);
    }, [
        descendants
    ]);
    const onOpenInternal = (0, $lDSNw.useCallback)(()=>{
        onOpenProp == null || onOpenProp();
        if (autoSelect) focusFirstItem();
        else focusMenu();
    }, [
        autoSelect,
        focusFirstItem,
        focusMenu,
        onOpenProp
    ]);
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, onToggle: onToggle } = (0, $1ece6bed0c1f2ca7$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onClose: onCloseProp,
        onOpen: onOpenInternal
    });
    (0, $179252284255db58$export$71b2224f1ce5e08e)({
        enabled: isOpen && closeOnBlur,
        ref: menuRef,
        handler: (event)=>{
            var _a;
            if (!((_a = buttonRef.current) == null ? void 0 : _a.contains(event.target))) onClose();
        }
    });
    const popper = (0, $8e546c4090357a18$export$f4d5bf230a36dd6e)({
        ...popperProps,
        enabled: isOpen || computePositionOnMount,
        placement: placement,
        direction: direction
    });
    const [focusedIndex, setFocusedIndex] = (0, $lDSNw.useState)(-1);
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        if (!isOpen) setFocusedIndex(-1);
    }, [
        isOpen
    ]);
    (0, $0a4488045172e95b$export$68b323438c1fbb28)(menuRef, {
        focusRef: buttonRef,
        visible: isOpen,
        shouldFocus: true
    });
    const animationState = (0, $29a8efb14c0efed3$export$7ee548861327febe)({
        isOpen: isOpen,
        ref: menuRef
    });
    const [buttonId, menuId] = $88e92a213fd6a914$var$useIds(id, `menu-button`, `menu-list`);
    const openAndFocusMenu = (0, $lDSNw.useCallback)(()=>{
        onOpen();
        focusMenu();
    }, [
        onOpen,
        focusMenu
    ]);
    const timeoutIds = (0, $lDSNw.useRef)(/* @__PURE__ */ new Set([]));
    $88e92a213fd6a914$var$useUnmountEffect(()=>{
        timeoutIds.current.forEach((id2)=>clearTimeout(id2));
        timeoutIds.current.clear();
    });
    const openAndFocusFirstItem = (0, $lDSNw.useCallback)(()=>{
        onOpen();
        focusFirstItem();
    }, [
        focusFirstItem,
        onOpen
    ]);
    const openAndFocusLastItem = (0, $lDSNw.useCallback)(()=>{
        onOpen();
        focusLastItem();
    }, [
        onOpen,
        focusLastItem
    ]);
    const refocus = (0, $lDSNw.useCallback)(()=>{
        var _a, _b;
        const doc = $88e92a213fd6a914$var$getOwnerDocument(menuRef.current);
        const hasFocusWithin = (_a = menuRef.current) == null ? void 0 : _a.contains(doc.activeElement);
        const shouldRefocus = isOpen && !hasFocusWithin;
        if (!shouldRefocus) return;
        const node = (_b = descendants.item(focusedIndex)) == null ? void 0 : _b.node;
        node == null || node.focus();
    }, [
        isOpen,
        focusedIndex,
        descendants
    ]);
    const rafId = (0, $lDSNw.useRef)(null);
    return {
        openAndFocusMenu: openAndFocusMenu,
        openAndFocusFirstItem: openAndFocusFirstItem,
        openAndFocusLastItem: openAndFocusLastItem,
        onTransitionEnd: refocus,
        unstable__animationState: animationState,
        descendants: descendants,
        popper: popper,
        buttonId: buttonId,
        menuId: menuId,
        forceUpdate: popper.forceUpdate,
        orientation: "vertical",
        isOpen: isOpen,
        onToggle: onToggle,
        onOpen: onOpen,
        onClose: onClose,
        menuRef: menuRef,
        buttonRef: buttonRef,
        focusedIndex: focusedIndex,
        closeOnSelect: closeOnSelect,
        closeOnBlur: closeOnBlur,
        autoSelect: autoSelect,
        setFocusedIndex: setFocusedIndex,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        initialFocusRef: initialFocusRef,
        rafId: rafId
    };
}
function $88e92a213fd6a914$export$660510f872408795(props = {}, externalRef = null) {
    const menu = $88e92a213fd6a914$export$21c7ab35b39f78ec();
    const { onToggle: onToggle, popper: popper, openAndFocusFirstItem: openAndFocusFirstItem, openAndFocusLastItem: openAndFocusLastItem } = menu;
    const onKeyDown = (0, $lDSNw.useCallback)((event)=>{
        const eventKey = event.key;
        const keyMap = {
            Enter: openAndFocusFirstItem,
            ArrowDown: openAndFocusFirstItem,
            ArrowUp: openAndFocusLastItem
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
        }
    }, [
        openAndFocusFirstItem,
        openAndFocusLastItem
    ]);
    return {
        ...props,
        ref: (0, $dc32195927d0d802$export$c9058316764c140e)(menu.buttonRef, externalRef, popper.referenceRef),
        id: menu.buttonId,
        "data-active": (0, $a223a0f4c9b3f9de$export$5cc3b7b83e34ade7)(menu.isOpen),
        "aria-expanded": menu.isOpen,
        "aria-haspopup": "menu",
        "aria-controls": menu.menuId,
        onClick: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props.onClick, onToggle),
        onKeyDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $88e92a213fd6a914$var$isTargetMenuItem(target) {
    var _a;
    return $88e92a213fd6a914$var$isHTMLElement(target) && !!((_a = target == null ? void 0 : target.getAttribute("role")) == null ? void 0 : _a.startsWith("menuitem"));
}
function $88e92a213fd6a914$export$8dcac42583be8292(props = {}, ref = null) {
    const menu = $88e92a213fd6a914$export$21c7ab35b39f78ec();
    if (!menu) throw new Error(`useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>`);
    const { focusedIndex: focusedIndex, setFocusedIndex: setFocusedIndex, menuRef: menuRef, isOpen: isOpen, onClose: onClose, menuId: menuId, isLazy: isLazy, lazyBehavior: lazyBehavior, unstable__animationState: animated } = menu;
    const descendants = $88e92a213fd6a914$export$fb081774625c317c();
    const createTypeaheadHandler = (0, $64c1f280ff52779c$export$b0ebbe7904d8d94a)({
        preventDefault: (event)=>event.key !== " " && $88e92a213fd6a914$var$isTargetMenuItem(event.target)
    });
    const onKeyDown = (0, $lDSNw.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.target)) return;
        const eventKey = event.key;
        const keyMap = {
            Tab: (event2)=>event2.preventDefault(),
            Escape: onClose,
            ArrowDown: ()=>{
                const next = descendants.nextEnabled(focusedIndex);
                if (next) setFocusedIndex(next.index);
            },
            ArrowUp: ()=>{
                const prev = descendants.prevEnabled(focusedIndex);
                if (prev) setFocusedIndex(prev.index);
            }
        };
        const fn = keyMap[eventKey];
        if (fn) {
            event.preventDefault();
            fn(event);
            return;
        }
        const onTypeahead = createTypeaheadHandler((character)=>{
            const nextItem = (0, $e4084908b5cde179$export$18ed781d9da46f95)(descendants.values(), character, (item)=>{
                var _a, _b;
                return (_b = (_a = item == null ? void 0 : item.node) == null ? void 0 : _a.textContent) != null ? _b : "";
            }, descendants.item(focusedIndex));
            if (nextItem) {
                const index = descendants.indexOf(nextItem.node);
                setFocusedIndex(index);
            }
        });
        if ($88e92a213fd6a914$var$isTargetMenuItem(event.target)) onTypeahead(event);
    }, [
        descendants,
        focusedIndex,
        createTypeaheadHandler,
        onClose,
        setFocusedIndex
    ]);
    const hasBeenOpened = (0, $lDSNw.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    const shouldRenderChildren = (0, $62bbd782f684d120$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenOpened.current,
        enabled: isLazy,
        mode: lazyBehavior,
        isSelected: animated.present
    });
    return {
        ...props,
        ref: (0, $dc32195927d0d802$export$c9058316764c140e)(menuRef, ref),
        children: shouldRenderChildren ? props.children : null,
        tabIndex: -1,
        role: "menu",
        id: menuId,
        style: {
            ...props.style,
            transformOrigin: "var(--popper-transform-origin)"
        },
        "aria-orientation": "vertical",
        onKeyDown: (0, $a223a0f4c9b3f9de$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $88e92a213fd6a914$export$5149508ab5f84d86(props = {}) {
    const { popper: popper, isOpen: isOpen } = $88e92a213fd6a914$export$21c7ab35b39f78ec();
    return popper.getPopperProps({
        ...props,
        style: {
            visibility: isOpen ? "visible" : "hidden",
            ...props.style
        }
    });
}
function $88e92a213fd6a914$export$9d32628fc2aea7da(props = {}, externalRef = null) {
    const { onMouseEnter: onMouseEnterProp, onMouseMove: onMouseMoveProp, onMouseLeave: onMouseLeaveProp, onClick: onClickProp, onFocus: onFocusProp, isDisabled: isDisabled, isFocusable: isFocusable, closeOnSelect: closeOnSelect, type: typeProp, ...htmlProps } = props;
    const menu = $88e92a213fd6a914$export$21c7ab35b39f78ec();
    const { setFocusedIndex: setFocusedIndex, focusedIndex: focusedIndex, closeOnSelect: menuCloseOnSelect, onClose: onClose, menuRef: menuRef, isOpen: isOpen, menuId: menuId, rafId: rafId } = menu;
    const ref = (0, $lDSNw.useRef)(null);
    const id = `${menuId}-menuitem-${(0, $lDSNw.useId)()}`;
    const { index: index, register: register } = $88e92a213fd6a914$export$e44adeffd1a0865c({
        disabled: isDisabled && !isFocusable
    });
    const onMouseEnter = (0, $lDSNw.useCallback)((event)=>{
        onMouseEnterProp == null || onMouseEnterProp(event);
        if (isDisabled) return;
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        index,
        isDisabled,
        onMouseEnterProp
    ]);
    const onMouseMove = (0, $lDSNw.useCallback)((event)=>{
        onMouseMoveProp == null || onMouseMoveProp(event);
        if (ref.current && !$88e92a213fd6a914$var$isActiveElement(ref.current)) onMouseEnter(event);
    }, [
        onMouseEnter,
        onMouseMoveProp
    ]);
    const onMouseLeave = (0, $lDSNw.useCallback)((event)=>{
        onMouseLeaveProp == null || onMouseLeaveProp(event);
        if (isDisabled) return;
        setFocusedIndex(-1);
    }, [
        setFocusedIndex,
        isDisabled,
        onMouseLeaveProp
    ]);
    const onClick = (0, $lDSNw.useCallback)((event)=>{
        onClickProp == null || onClickProp(event);
        if (!$88e92a213fd6a914$var$isTargetMenuItem(event.currentTarget)) return;
        if (closeOnSelect != null ? closeOnSelect : menuCloseOnSelect) onClose();
    }, [
        onClose,
        onClickProp,
        menuCloseOnSelect,
        closeOnSelect
    ]);
    const onFocus = (0, $lDSNw.useCallback)((event)=>{
        onFocusProp == null || onFocusProp(event);
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        onFocusProp,
        index
    ]);
    const isFocused = index === focusedIndex;
    const trulyDisabled = isDisabled && !isFocusable;
    (0, $aa3008ed2427a149$export$496315a1608d9602)(()=>{
        if (!isOpen) return;
        if (isFocused && !trulyDisabled && ref.current) {
            if (rafId.current) cancelAnimationFrame(rafId.current);
            rafId.current = requestAnimationFrame(()=>{
                var _a;
                (_a = ref.current) == null || _a.focus();
                rafId.current = null;
            });
        } else if (menuRef.current && !$88e92a213fd6a914$var$isActiveElement(menuRef.current)) menuRef.current.focus({
            preventScroll: true
        });
    }, [
        isFocused,
        trulyDisabled,
        menuRef,
        isOpen
    ]);
    const clickableProps = (0, $cf565c06db5dad98$export$ed213cc82e426b1a)({
        onClick: onClick,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        ref: (0, $dc32195927d0d802$export$c9058316764c140e)(register, ref, externalRef),
        isDisabled: isDisabled,
        isFocusable: isFocusable
    });
    return {
        ...htmlProps,
        ...clickableProps,
        type: typeProp != null ? typeProp : clickableProps.type,
        id: id,
        role: "menuitem",
        tabIndex: isFocused ? 0 : -1
    };
}
function $88e92a213fd6a914$export$8ca3fd7c19c454af(props = {}, ref = null) {
    const { type: type = "radio", isChecked: isChecked, ...rest } = props;
    const ownProps = $88e92a213fd6a914$export$9d32628fc2aea7da(rest, ref);
    return {
        ...ownProps,
        role: `menuitem${type}`,
        "aria-checked": isChecked
    };
}
function $88e92a213fd6a914$export$9dcb3089500f52be(props = {}) {
    const { children: children, type: type = "radio", value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, ...htmlProps } = props;
    const isRadio = type === "radio";
    const fallback = isRadio ? "" : [];
    const [value, setValue] = (0, $1c6446ce89a1d8f0$export$6f32135080cb4c3)({
        defaultValue: defaultValue != null ? defaultValue : fallback,
        value: valueProp,
        onChange: onChangeProp
    });
    const onChange = (0, $lDSNw.useCallback)((selectedValue)=>{
        if (type === "radio" && typeof value === "string") setValue(selectedValue);
        if (type === "checkbox" && Array.isArray(value)) {
            const nextValue = value.includes(selectedValue) ? value.filter((item)=>item !== selectedValue) : value.concat(selectedValue);
            setValue(nextValue);
        }
    }, [
        value,
        setValue,
        type
    ]);
    const validChildren = (0, $b40941a6e809376a$export$b2c43d7d050b2e63)(children);
    const clones = validChildren.map((child)=>{
        if (child.type.id !== "MenuItemOption") return child;
        const onClick = (event)=>{
            var _a, _b;
            onChange(child.props.value);
            (_b = (_a = child.props).onClick) == null || _b.call(_a, event);
        };
        const isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
        return (0, $lDSNw.cloneElement)(child, {
            type: type,
            onClick: onClick,
            isChecked: isChecked
        });
    });
    return {
        ...htmlProps,
        children: clones
    };
}
function $88e92a213fd6a914$export$8091e3849c182a6() {
    const { isOpen: isOpen, onClose: onClose } = $88e92a213fd6a914$export$21c7ab35b39f78ec();
    return {
        isOpen: isOpen,
        onClose: onClose
    };
}
function $88e92a213fd6a914$var$isHTMLElement(el) {
    var _a;
    if (!$88e92a213fd6a914$var$isElement(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $88e92a213fd6a914$var$isElement(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $88e92a213fd6a914$var$useUnmountEffect(fn, deps = []) {
    return (0, $lDSNw.useEffect)(()=>()=>fn(), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
}






var $lDSNw = parcelRequire("lDSNw");

"use client";
var [$5a2fe1e3920d6969$var$MenuStylesProvider, $5a2fe1e3920d6969$export$e7aea412cbc2ca01] = (0, $33d216fe4070af25$export$fd42f52fd3ae1109)({
    name: `MenuStylesContext`,
    errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
});
var $5a2fe1e3920d6969$export$d9b273488cd8ce6f = (props)=>{
    const { children: children } = props;
    const styles = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Menu", props);
    const ownProps = (0, $01a983b3ad87bd07$export$adfcf5a5e4d17785)(props);
    const { direction: direction } = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)();
    const { descendants: descendants, ...ctx } = (0, $88e92a213fd6a914$export$38eaa17faae8f579)({
        ...ownProps,
        direction: direction
    });
    const context = (0, $lDSNw.useMemo)(()=>ctx, [
        ctx
    ]);
    const { isOpen: isOpen, onClose: onClose, forceUpdate: forceUpdate } = context;
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $88e92a213fd6a914$export$6bd12c048acae948), {
        value: descendants,
        children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $88e92a213fd6a914$export$62b22d151866115d), {
            value: context,
            children: /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)($5a2fe1e3920d6969$var$MenuStylesProvider, {
                value: styles,
                children: (0, $a223a0f4c9b3f9de$export$624e501d81f5ffce)(children, {
                    isOpen: isOpen,
                    onClose: onClose,
                    forceUpdate: forceUpdate
                })
            })
        })
    });
};
$5a2fe1e3920d6969$export$d9b273488cd8ce6f.displayName = "Menu";





var $lDSNw = parcelRequire("lDSNw");

"use client";
var $6395b15843ef8aa1$export$46e1d66043f363e6 = (props)=>{
    const { className: className, children: children, ...rest } = props;
    const styles = (0, $5a2fe1e3920d6969$export$e7aea412cbc2ca01)();
    const child = (0, $lDSNw.Children).only(children);
    const clone = (0, $lDSNw.isValidElement)(child) ? (0, $lDSNw.cloneElement)(child, {
        focusable: "false",
        "aria-hidden": true,
        className: (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-menu__icon", child.props.className)
    }) : null;
    const _className = (0, $a223a0f4c9b3f9de$export$a274e22fb40f762e)("chakra-menu__icon-wrapper", className);
    return /* @__PURE__ */ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        className: _className,
        ...rest,
        __css: styles.icon,
        children: clone
    });
};
$6395b15843ef8aa1$export$46e1d66043f363e6.displayName = "MenuIcon";




var $lDSNw = parcelRequire("lDSNw");






var $lDSNw = parcelRequire("lDSNw");


var $388204da6bde0d94$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $388204da6bde0d94$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $388204da6bde0d94$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return 'Create "'.concat(inputValue, '"');
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $388204da6bde0d94$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $388204da6bde0d94$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $388204da6bde0d94$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $388204da6bde0d94$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $388204da6bde0d94$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $388204da6bde0d94$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $388204da6bde0d94$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $33b14307a6ff7705$export$39b482c5e57630a8) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $33b14307a6ff7705$export$8b22cf2602fb60ce) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $lDSNw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $1364988d5fdddede$export$7f8ddf7c7c20b3cd)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $lDSNw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [
            newOption
        ].concat((0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)(propsOptions)) : [].concat((0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $lDSNw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== "select-option") return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: "create-option",
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $1364988d5fdddede$export$96f57966bedc81b4)(isMulti, [].concat((0, $fe96c4cfaf321b89$export$2e2bcd8739ae039)((0, $1364988d5fdddede$export$7f8ddf7c7c20b3cd)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}















parcelRequire("ef4Zh");



var $c48ddd64ec5cff67$var$CreatableSelect = /*#__PURE__*/ (0, $lDSNw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $538aa6a2b60a37e7$export$3b14a55fb2447963)(props);
    var selectProps = (0, $388204da6bde0d94$export$3b14a55fb2447963)(creatableProps);
    return /*#__PURE__*/ $lDSNw.createElement((0, $33b14307a6ff7705$export$25ce5a424b770e84), (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: ref
    }, selectProps));
});
var $c48ddd64ec5cff67$export$2e2bcd8739ae039 = $c48ddd64ec5cff67$var$CreatableSelect;




var $lDSNw = parcelRequire("lDSNw");







var $lDSNw = parcelRequire("lDSNw");

var $af3c6c1320d38a6d$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $af3c6c1320d38a6d$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $92b932a9010e733e$export$2e2bcd8739ae039)(_ref, $af3c6c1320d38a6d$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $lDSNw.useRef)(undefined);
    var mounted = (0, $lDSNw.useRef)(false);
    var _useState = (0, $lDSNw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $lDSNw.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $lDSNw.useState)(propsDefaultOptions === true), _useState6 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $lDSNw.useState)(undefined), _useState8 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $lDSNw.useState)([]), _useState10 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $lDSNw.useState)(false), _useState12 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $lDSNw.useState)({}), _useState14 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $lDSNw.useState)(undefined), _useState16 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $lDSNw.useState)(undefined), _useState18 = (0, $9ea381ad8ba4870c$export$2e2bcd8739ae039)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $lDSNw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $lDSNw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $lDSNw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $lDSNw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $1364988d5fdddede$export$61196ced6d74a310)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, optionsCache), {}, (0, $eeb121c6867ae1fe$export$2e2bcd8739ae039)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)((0, $bdde4b1c202df3e9$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}















parcelRequire("ef4Zh");



var $803cbafdf557dc26$var$AsyncSelect = /*#__PURE__*/ (0, $lDSNw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $af3c6c1320d38a6d$export$3b14a55fb2447963)(props);
    var selectProps = (0, $538aa6a2b60a37e7$export$3b14a55fb2447963)(stateManagedProps);
    return /*#__PURE__*/ $lDSNw.createElement((0, $33b14307a6ff7705$export$25ce5a424b770e84), (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: ref
    }, selectProps));
});
var $803cbafdf557dc26$export$2e2bcd8739ae039 = $803cbafdf557dc26$var$AsyncSelect;




var $lDSNw = parcelRequire("lDSNw");

















parcelRequire("ef4Zh");



var $adf2e0274e79f79c$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $lDSNw.forwardRef)(function(props, ref) {
    var stateManagerProps = (0, $af3c6c1320d38a6d$export$3b14a55fb2447963)(props);
    var creatableProps = (0, $538aa6a2b60a37e7$export$3b14a55fb2447963)(stateManagerProps);
    var selectProps = (0, $388204da6bde0d94$export$3b14a55fb2447963)(creatableProps);
    return /*#__PURE__*/ $lDSNw.createElement((0, $33b14307a6ff7705$export$25ce5a424b770e84), (0, $5d282778a8cc30d8$export$2e2bcd8739ae039)({
        ref: ref
    }, selectProps));
});
var $adf2e0274e79f79c$export$2e2bcd8739ae039 = $adf2e0274e79f79c$var$AsyncCreatableSelect;


var $ee6103f5a2a86aaf$var$V = (e)=>{
    let { className: r, clearValue: o, cx: n, getStyles: s, getClassNames: t, getValue: a, hasValue: i, isMulti: p, isRtl: l, options: c, selectOption: d, selectProps: m, setValue: f, theme: x, ...u } = e;
    return {
        ...u
    };
}, $ee6103f5a2a86aaf$var$Pe = (e)=>typeof e == "string" && [
        "sm",
        "md",
        "lg"
    ].includes(e), $ee6103f5a2a86aaf$var$ge = (e)=>$ee6103f5a2a86aaf$var$Pe(e) ? e : e === "xs" ? "sm" : e === "xl" ? "lg" : "md", $ee6103f5a2a86aaf$var$O = (e)=>{
    let r = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)(), o = $ee6103f5a2a86aaf$var$ge(r.components.Input.defaultProps.size), n = e != null ? e : o;
    return (0, $ea9feb6f6829a50e$export$dc0946e21e709aff)(typeof n == "string" ? [
        n
    ] : n, {
        fallback: "md"
    }) || o;
};
var $ee6103f5a2a86aaf$var$W = (e)=>{
    let { children: r, className: o, cx: n, innerProps: s, isDisabled: t, isRtl: a, hasValue: i, selectProps: { chakraStyles: p } } = e, l = {
        position: "relative",
        direction: a ? "rtl" : void 0,
        ...t ? {
            cursor: "not-allowed"
        } : {}
    }, c = p != null && p.container ? p.container(l, e) : l;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...s,
        className: n({
            "--is-disabled": t,
            "--is-rtl": a,
            "--has-value": i
        }, o),
        sx: c,
        children: r
    });
}, $ee6103f5a2a86aaf$var$Y = (e)=>{
    let { children: r, className: o, cx: n, isMulti: s, hasValue: t, innerProps: a, selectProps: { chakraStyles: i, size: p, variant: l, focusBorderColor: c, errorBorderColor: d, controlShouldRenderValue: m } } = e, f = $ee6103f5a2a86aaf$var$O(p), x = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Input", {
        size: f,
        variant: l,
        focusBorderColor: c,
        errorBorderColor: d
    }), u = {
        display: s && t && m ? "flex" : "grid",
        alignItems: "center",
        flex: 1,
        paddingY: "2px",
        paddingX: x.field.px,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, S = i != null && i.valueContainer ? i.valueContainer(u, e) : u;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...a,
        className: n({
            "value-container": !0,
            "value-container--is-multi": s,
            "value-container--has-value": t
        }, o),
        sx: S,
        children: r
    });
}, $ee6103f5a2a86aaf$var$_ = (e)=>{
    let { children: r, className: o, cx: n, innerProps: s, selectProps: { chakraStyles: t } } = e, a = {
        display: "flex",
        alignItems: "center",
        alignSelf: "stretch",
        flexShrink: 0
    }, i = t != null && t.indicatorsContainer ? t.indicatorsContainer(a, e) : a;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...s,
        className: n({
            indicators: !0
        }, o),
        sx: i,
        children: r
    });
};
var $ee6103f5a2a86aaf$var$he = (e)=>{
    let { className: r, cx: o, children: n, innerRef: s, innerProps: t, isDisabled: a, isFocused: i, menuIsOpen: p, selectProps: { chakraStyles: l, size: c, variant: d, focusBorderColor: m, errorBorderColor: f, isInvalid: x, isReadOnly: u } } = e, S = $ee6103f5a2a86aaf$var$O(c), { field: { height: b, h: g, ...I } } = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Input", {
        size: S,
        variant: d,
        focusBorderColor: m,
        errorBorderColor: f
    }), C = {
        ...I,
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        padding: 0,
        overflow: "hidden",
        height: "auto",
        minH: b || g,
        ...a ? {
            pointerEvents: "none"
        } : {}
    }, B = l != null && l.control ? l.control(C, e) : C;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ref: s,
        className: o({
            control: !0,
            "control--is-disabled": a,
            "control--is-focused": i,
            "control--menu-is-open": p
        }, r),
        sx: B,
        ...t,
        "data-focus": i ? !0 : void 0,
        "data-focus-visible": i ? !0 : void 0,
        "data-invalid": x ? !0 : void 0,
        "data-disabled": a ? !0 : void 0,
        "data-readonly": u ? !0 : void 0,
        children: n
    });
}, $ee6103f5a2a86aaf$var$Z = (e)=>{
    let { className: r, cx: o, selectProps: { chakraStyles: n, useBasicStyles: s, variant: t } } = e, a = {
        opacity: 1,
        ...s || t !== "outline" ? {
            display: "none"
        } : {}
    }, i = n != null && n.indicatorSeparator ? n.indicatorSeparator(a, e) : a;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $cdbab28a1c30f5ac$export$2e0a83ec2e27ecbb), {
        className: o({
            "indicator-separator": !0
        }, r),
        sx: i,
        orientation: "vertical"
    });
}, $ee6103f5a2a86aaf$var$Be = (e)=>(0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        role: "presentation",
        focusable: "false",
        "aria-hidden": "true",
        ...e,
        children: (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        })
    }), $ee6103f5a2a86aaf$var$J = (e)=>{
    let { children: r, className: o, cx: n, innerProps: s, selectProps: { chakraStyles: t, useBasicStyles: a, size: i, focusBorderColor: p, errorBorderColor: l, variant: c } } = e, d = $ee6103f5a2a86aaf$var$O(i), m = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Input", {
        size: d,
        variant: c,
        focusBorderColor: p,
        errorBorderColor: l
    }), x = {
        sm: "16px",
        md: "20px",
        lg: "24px"
    }[d], u = {
        ...m.addon,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        borderRadius: 0,
        borderWidth: 0,
        fontSize: x,
        ...a && {
            background: "transparent",
            padding: 0,
            width: 6,
            marginRight: 2,
            marginLeft: 1,
            cursor: "inherit"
        }
    }, S = t != null && t.dropdownIndicator ? t.dropdownIndicator(u, e) : u, b = {
        height: "1em",
        width: "1em"
    }, g = t != null && t.downChevron ? t.downChevron(b, e) : b;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...s,
        className: n({
            indicator: !0,
            "dropdown-indicator": !0
        }, o),
        sx: S,
        children: r || (0, $e800b0e3b29b4f13$exports.jsx)($ee6103f5a2a86aaf$var$Be, {
            sx: g
        })
    });
}, $ee6103f5a2a86aaf$var$ve = (e)=>(0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": !0,
        ...e,
        children: (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    }), $ee6103f5a2a86aaf$var$K = (e)=>{
    let { children: r, className: o, cx: n, innerProps: s, selectProps: { chakraStyles: t, size: a } } = e, i = $ee6103f5a2a86aaf$var$O(a), l = {
        ...(0, $f2811f1004d7a60c$export$b863f77547fbcb03)("CloseButton", {
            size: i
        }),
        marginX: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        cursor: "pointer"
    }, c = t != null && t.clearIndicator ? t.clearIndicator(l, e) : l, d = {
        width: "1em",
        height: "1em"
    }, m = t != null && t.crossIcon ? t.crossIcon(d, e) : d;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        role: "button",
        className: n({
            indicator: !0,
            "clear-indicator": !0
        }, o),
        sx: c,
        "aria-label": "Clear selected options",
        ...s,
        children: r || (0, $e800b0e3b29b4f13$exports.jsx)($ee6103f5a2a86aaf$var$ve, {
            sx: m
        })
    });
}, $ee6103f5a2a86aaf$var$Q = (e)=>{
    let { className: r, cx: o, innerProps: n, selectProps: { chakraStyles: s, size: t }, color: a, emptyColor: i, speed: p, thickness: l, spinnerSize: c } = e, d = $ee6103f5a2a86aaf$var$O(t), f = {
        sm: "xs",
        md: "sm",
        lg: "md"
    }[d], x = {
        marginRight: 3
    }, u = s != null && s.loadingIndicator ? s.loadingIndicator(x, e) : x;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $35745663698a221c$export$7f7cbe89f1eacd2), {
        className: o({
            indicator: !0,
            "loading-indicator": !0
        }, r),
        sx: u,
        ...n,
        size: c || f,
        color: a,
        emptyColor: i,
        speed: p,
        thickness: l
    });
}, $ee6103f5a2a86aaf$var$U = $ee6103f5a2a86aaf$var$he;
var $ee6103f5a2a86aaf$var$we = (e)=>{
    let { className: r, cx: o, value: n, selectProps: { chakraStyles: s, isReadOnly: t } } = e, { innerRef: a, isDisabled: i, isHidden: p, inputClassName: l, ...c } = $ee6103f5a2a86aaf$var$V(e), d = {
        gridArea: "1 / 2",
        minW: "2px",
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    }, m = {
        flex: "1 1 auto",
        display: "inline-grid",
        gridArea: "1 / 1 / 2 / 3",
        gridTemplateColumns: "0 min-content",
        color: "inherit",
        marginX: "0.125rem",
        paddingY: "0.125rem",
        visibility: i ? "hidden" : "visible",
        transform: n ? "translateZ(0)" : "",
        _after: {
            content: 'attr(data-value) " "',
            visibility: "hidden",
            whiteSpace: "pre",
            padding: 0,
            ...d
        }
    }, f = s != null && s.inputContainer ? s.inputContainer(m, e) : m, x = {
        background: 0,
        opacity: p ? 0 : 1,
        width: "100%",
        ...d
    }, u = s != null && s.input ? s.input(x, e) : x;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        className: o({
            "input-container": !0
        }, r),
        "data-value": n || "",
        sx: f,
        children: (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).input, {
            className: o({
                input: !0
            }, l),
            ref: a,
            sx: u,
            disabled: i,
            readOnly: t ? !0 : void 0,
            ...c
        })
    });
}, $ee6103f5a2a86aaf$var$ee = $ee6103f5a2a86aaf$var$we;
var $ee6103f5a2a86aaf$var$ke = (e)=>e ? ({
        bottom: "top",
        top: "bottom"
    })[e] : "top", $ee6103f5a2a86aaf$var$Ae = (e)=>{
    let { className: r, cx: o, children: n, innerProps: s, innerRef: t, placement: a, selectProps: { chakraStyles: i } } = e, p = {
        position: "absolute",
        [$ee6103f5a2a86aaf$var$ke(a)]: "100%",
        marginY: "8px",
        width: "100%",
        zIndex: 1
    }, l = i != null && i.menu ? i.menu(p, e) : p;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $5a2fe1e3920d6969$export$d9b273488cd8ce6f), {
        children: (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
            ...s,
            ref: t,
            className: o({
                menu: !0
            }, r),
            sx: l,
            children: n
        })
    });
}, $ee6103f5a2a86aaf$var$oe = $ee6103f5a2a86aaf$var$Ae, $ee6103f5a2a86aaf$var$ne = (e)=>{
    var I;
    let { className: r, cx: o, innerRef: n, children: s, maxHeight: t, isMulti: a, innerProps: i, selectProps: { chakraStyles: p, size: l, variant: c, focusBorderColor: d, errorBorderColor: m } } = e, f = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Menu"), x = $ee6103f5a2a86aaf$var$O(l), S = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Input", {
        size: x,
        variant: c,
        focusBorderColor: d,
        errorBorderColor: m
    }).field, b = {
        ...f.list,
        minW: "100%",
        maxHeight: `${t}px`,
        overflowY: "auto",
        "--input-border-radius": S == null ? void 0 : S["--input-border-radius"],
        borderRadius: (S == null ? void 0 : S.borderRadius) || ((I = f.list) == null ? void 0 : I.borderRadius),
        position: "relative",
        WebkitOverflowScrolling: "touch"
    }, g = p != null && p.menuList ? p.menuList(b, e) : b;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...i,
        className: o({
            "menu-list": !0,
            "menu-list--is-multi": a
        }, r),
        sx: g,
        ref: n,
        children: s
    });
}, $ee6103f5a2a86aaf$var$re = (e)=>{
    let { children: r, className: o, cx: n, innerProps: s, selectProps: { chakraStyles: t, size: a } } = e, i = $ee6103f5a2a86aaf$var$O(a), l = {
        color: "chakra-subtle-text",
        textAlign: "center",
        paddingY: {
            sm: "6px",
            md: "8px",
            lg: "10px"
        }[i],
        fontSize: i
    }, c = t != null && t.loadingMessage ? t.loadingMessage(l, e) : l;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...s,
        className: n({
            "menu-notice": !0,
            "menu-notice--loading": !0
        }, o),
        sx: c,
        children: r
    });
}, $ee6103f5a2a86aaf$var$se = (e)=>{
    let { children: r, className: o, cx: n, innerProps: s, selectProps: { chakraStyles: t, size: a } } = e, i = $ee6103f5a2a86aaf$var$O(a), l = {
        color: "chakra-subtle-text",
        textAlign: "center",
        paddingY: {
            sm: "6px",
            md: "8px",
            lg: "10px"
        }[i],
        fontSize: i
    }, c = t != null && t.noOptionsMessage ? t.noOptionsMessage(l, e) : l;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...s,
        className: n({
            "menu-notice": !0,
            "menu-notice--no-options": !0
        }, o),
        sx: c,
        children: r
    });
}, $ee6103f5a2a86aaf$var$ie = (e)=>{
    let { children: r, className: o, cx: n, theme: s, getStyles: t, Heading: a, headingProps: i, label: p, selectProps: l, innerProps: c, getClassNames: d } = e, { chakraStyles: m } = l, f = {}, x = m != null && m.group ? m.group(f, e) : f;
    return (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...c,
        className: n({
            group: !0
        }, o),
        sx: x,
        children: [
            (0, $e800b0e3b29b4f13$exports.jsx)(a, {
                ...i,
                selectProps: l,
                cx: n,
                theme: s,
                getStyles: t,
                getClassNames: d,
                children: p
            }),
            (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
                children: r
            })
        ]
    });
}, $ee6103f5a2a86aaf$var$ae = (e)=>{
    let { cx: r, className: o, selectProps: { chakraStyles: n, size: s, hasStickyGroupHeaders: t } } = e, { data: a, ...i } = $ee6103f5a2a86aaf$var$V(e), p = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Menu"), l = $ee6103f5a2a86aaf$var$O(s), c = {
        sm: "xs",
        md: "sm",
        lg: "md"
    }, d = {
        sm: "0.4rem 0.8rem",
        md: "0.5rem 1rem",
        lg: "0.6rem 1.2rem"
    }, m = {
        ...p.groupTitle,
        fontSize: c[l],
        padding: d[l],
        margin: 0,
        borderBottomWidth: t ? "1px" : 0,
        position: t ? "sticky" : "static",
        top: -2,
        bg: p.list.bg,
        zIndex: 1
    }, f = n != null && n.groupHeading ? n.groupHeading(m, e) : m;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...i,
        className: r({
            "group-heading": !0
        }, o),
        sx: f
    });
}, $ee6103f5a2a86aaf$var$je = (e)=>(0, $e800b0e3b29b4f13$exports.jsx)("svg", {
        viewBox: "0 0 14 14",
        width: "1em",
        height: "1em",
        ...e,
        children: (0, $e800b0e3b29b4f13$exports.jsx)("polygon", {
            fill: "currentColor",
            points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
        })
    }), $ee6103f5a2a86aaf$var$le = (e)=>{
    let { className: r, cx: o, innerRef: n, innerProps: s, children: t, isFocused: a, isDisabled: i, isSelected: p, selectProps: { chakraStyles: l, size: c, isMulti: d, hideSelectedOptions: m, selectedOptionStyle: f, selectedOptionColorScheme: x } } = e, u = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Menu").item, S = $ee6103f5a2a86aaf$var$O(c), b = {
        sm: "0.6rem",
        md: "0.8rem",
        lg: "1rem"
    }, g = {
        sm: "0.3rem",
        md: "0.4rem",
        lg: "0.5rem"
    }, I = (0, $53a9951d8b44cf80$export$d18f2ef57b0d7644)(`${x}.500`, `${x}.300`), M = (0, $53a9951d8b44cf80$export$d18f2ef57b0d7644)("white", "black"), C = f === "check" && (!d || m === !1), B = f === "color", v = {
        ...u,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        width: "100%",
        textAlign: "start",
        fontSize: S,
        paddingX: b[S],
        paddingY: g[S],
        ...B && {
            _selected: {
                bg: I,
                color: M,
                _active: {
                    bg: I
                }
            }
        }
    }, y = l != null && l.option ? l.option(v, e) : v;
    return (0, $e800b0e3b29b4f13$exports.jsxs)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...s,
        className: o({
            option: !0,
            "option--is-disabled": i,
            "option--is-focused": a,
            "option--is-selected": p
        }, r),
        sx: y,
        ref: n,
        "data-focus": a ? !0 : void 0,
        "aria-disabled": i ? !0 : void 0,
        "aria-selected": p,
        children: [
            C && (0, $e800b0e3b29b4f13$exports.jsx)((0, $6395b15843ef8aa1$export$46e1d66043f363e6), {
                fontSize: "0.8em",
                marginEnd: "0.75rem",
                opacity: p ? 1 : 0,
                children: (0, $e800b0e3b29b4f13$exports.jsx)($ee6103f5a2a86aaf$var$je, {})
            }),
            t
        ]
    });
};
var $ee6103f5a2a86aaf$var$De = (e)=>typeof e == "object" && e !== null && "colorScheme" in e && typeof e.colorScheme == "string", $ee6103f5a2a86aaf$var$He = (e)=>typeof e == "object" && e !== null && "variant" in e && typeof e.variant == "string", $ee6103f5a2a86aaf$var$ue = (e)=>typeof e == "object" && e !== null && "isFixed" in e && typeof e.isFixed == "boolean", $ee6103f5a2a86aaf$var$Ee = (e)=>{
    let { children: r, className: o, components: n, cx: s, data: t, innerProps: a, isDisabled: i, isFocused: p, removeProps: l, selectProps: c, cropWithEllipsis: d } = e, { Container: m, Label: f, Remove: x } = n, { chakraStyles: u, colorScheme: S, tagVariant: b, size: g } = c, I = $ee6103f5a2a86aaf$var$O(g), M = "", C = "", B = !1;
    $ee6103f5a2a86aaf$var$De(t) && (M = t.colorScheme), $ee6103f5a2a86aaf$var$He(t) && (C = t.variant), $ee6103f5a2a86aaf$var$ue(t) && (B = t.isFixed);
    let v = (0, $f2811f1004d7a60c$export$31cdfe60c085d76f)("Tag", {
        size: I,
        colorScheme: M || S,
        variant: C || b || (B ? "solid" : "subtle")
    }), y = {
        ...v.container,
        display: "flex",
        alignItems: "center",
        minWidth: 0,
        margin: "0.125rem"
    }, A = u != null && u.multiValue ? u.multiValue(y, e) : y, N = {
        ...v.label,
        overflow: "hidden",
        textOverflow: d || d === void 0 ? "ellipsis" : void 0,
        whiteSpace: "nowrap"
    }, D = u != null && u.multiValueLabel ? u.multiValueLabel(N, e) : N, w = {
        ...v.closeButton,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, H = u != null && u.multiValueRemove ? u.multiValueRemove(w, e) : w;
    return (0, $e800b0e3b29b4f13$exports.jsxs)(m, {
        data: t,
        innerProps: {
            className: s({
                "multi-value": !0,
                "multi-value--is-disabled": i
            }, o),
            ...a
        },
        sx: A,
        selectProps: c,
        children: [
            (0, $e800b0e3b29b4f13$exports.jsx)(f, {
                data: t,
                innerProps: {
                    className: s({
                        "multi-value__label": !0
                    }, o)
                },
                sx: D,
                selectProps: c,
                children: r
            }),
            (0, $e800b0e3b29b4f13$exports.jsx)(x, {
                data: t,
                innerProps: {
                    className: s({
                        "multi-value__remove": !0
                    }, o),
                    "aria-label": `Remove ${r || "option"}`,
                    ...l
                },
                sx: H,
                selectProps: c,
                isFocused: p
            })
        ]
    });
}, $ee6103f5a2a86aaf$var$de = (e)=>{
    let { children: r, innerProps: o, sx: n } = e;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        ...o,
        sx: n,
        children: r
    });
}, $ee6103f5a2a86aaf$var$me = (e)=>{
    let { children: r, innerProps: o, sx: n } = e;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $5c12d9132a121f51$export$7cd122d781af9fa4).span, {
        ...o,
        sx: n,
        children: r
    });
}, $ee6103f5a2a86aaf$var$We = (e)=>(0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
        verticalAlign: "inherit",
        viewBox: "0 0 512 512",
        ...e,
        children: (0, $e800b0e3b29b4f13$exports.jsx)("path", {
            fill: "currentColor",
            d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
        })
    }), $ee6103f5a2a86aaf$var$xe = (e)=>{
    let { children: r, innerProps: o, isFocused: n, data: s, sx: t } = e;
    return $ee6103f5a2a86aaf$var$ue(s) && s.isFixed ? null : (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...o,
        role: "button",
        sx: t,
        "data-focus": n ? !0 : void 0,
        "data-focus-visible": n ? !0 : void 0,
        children: r || (0, $e800b0e3b29b4f13$exports.jsx)($ee6103f5a2a86aaf$var$We, {})
    });
};
var $ee6103f5a2a86aaf$var$fe = $ee6103f5a2a86aaf$var$Ee;
var $ee6103f5a2a86aaf$var$Xe = (e)=>{
    let { children: r, className: o, cx: n, innerProps: s, selectProps: { chakraStyles: t } } = e, a = {
        gridArea: "1 / 1 / 2 / 3",
        color: "chakra-placeholder-color",
        mx: "0.125rem",
        userSelect: "none"
    }, i = t != null && t.placeholder ? t.placeholder(a, e) : a;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        ...s,
        className: n({
            placeholder: !0
        }, o),
        sx: i,
        children: r
    });
}, $ee6103f5a2a86aaf$var$Se = $ee6103f5a2a86aaf$var$Xe;
var $ee6103f5a2a86aaf$var$Je = (e)=>{
    let { children: r, className: o, cx: n, isDisabled: s, innerProps: t, selectProps: { chakraStyles: a } } = e, i = {
        gridArea: "1 / 1 / 2 / 3",
        mx: "0.125rem",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, p = a != null && a.singleValue ? a.singleValue(i, e) : i;
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $b9e16fda3a2a93e8$export$e71c4d32a2263218), {
        className: n({
            "single-value": !0,
            "single-value--is-disabled": s
        }, o),
        sx: p,
        ...t,
        children: r
    });
}, $ee6103f5a2a86aaf$var$Oe = $ee6103f5a2a86aaf$var$Je;
var $ee6103f5a2a86aaf$var$Qe = {
    ClearIndicator: $ee6103f5a2a86aaf$var$K,
    Control: $ee6103f5a2a86aaf$var$U,
    DropdownIndicator: $ee6103f5a2a86aaf$var$J,
    Group: $ee6103f5a2a86aaf$var$ie,
    GroupHeading: $ee6103f5a2a86aaf$var$ae,
    IndicatorSeparator: $ee6103f5a2a86aaf$var$Z,
    IndicatorsContainer: $ee6103f5a2a86aaf$var$_,
    Input: $ee6103f5a2a86aaf$var$ee,
    LoadingIndicator: $ee6103f5a2a86aaf$var$Q,
    LoadingMessage: $ee6103f5a2a86aaf$var$re,
    Menu: $ee6103f5a2a86aaf$var$oe,
    MenuList: $ee6103f5a2a86aaf$var$ne,
    MultiValue: $ee6103f5a2a86aaf$var$fe,
    MultiValueContainer: $ee6103f5a2a86aaf$var$de,
    MultiValueLabel: $ee6103f5a2a86aaf$var$me,
    MultiValueRemove: $ee6103f5a2a86aaf$var$xe,
    NoOptionsMessage: $ee6103f5a2a86aaf$var$se,
    Option: $ee6103f5a2a86aaf$var$le,
    Placeholder: $ee6103f5a2a86aaf$var$Se,
    SelectContainer: $ee6103f5a2a86aaf$var$W,
    SingleValue: $ee6103f5a2a86aaf$var$Oe,
    ValueContainer: $ee6103f5a2a86aaf$var$Y
}, $ee6103f5a2a86aaf$export$a86fbc2332529aa7 = $ee6103f5a2a86aaf$var$Qe;
var $ee6103f5a2a86aaf$var$et = ({ components: e = {}, theme: r, size: o, colorScheme: n = "gray", isDisabled: s, isInvalid: t, isReadOnly: a, required: i, isRequired: p, inputId: l, tagVariant: c, selectedOptionStyle: d = "color", selectedOptionColorScheme: m, selectedOptionColor: f, variant: x, focusBorderColor: u, errorBorderColor: S, chakraStyles: b = {}, onFocus: g, onBlur: I, menuIsOpen: M, ...C })=>{
    var E;
    let B = (0, $7ead6df74eee26d7$export$93d4e7f90805808f)(), { variant: v } = B.components.Input.defaultProps, y = (0, $f51ab13b55b1484d$export$62ecd8ad1bbe1a18)({
        id: l,
        isDisabled: s,
        isInvalid: t,
        isRequired: p,
        isReadOnly: a,
        onFocus: g,
        onBlur: I
    }), A = M != null ? M : y.readOnly ? !1 : void 0, N = d;
    [
        "color",
        "check"
    ].includes(d) || (N = "color");
    let w = m || f || "blue";
    return typeof w != "string" && (w = "blue"), {
        components: {
            ...$ee6103f5a2a86aaf$export$a86fbc2332529aa7,
            ...e
        },
        colorScheme: n,
        size: o,
        tagVariant: c,
        selectedOptionStyle: N,
        selectedOptionColorScheme: w,
        variant: x != null ? x : v,
        chakraStyles: b,
        focusBorderColor: u,
        errorBorderColor: S,
        onFocus: y.onFocus,
        onBlur: y.onBlur,
        isDisabled: y.disabled,
        isInvalid: !!y["aria-invalid"],
        inputId: y.id,
        isReadOnly: y.readOnly,
        required: i != null ? i : y.required,
        menuIsOpen: A,
        ...C,
        "aria-invalid": (E = C["aria-invalid"]) != null ? E : y["aria-invalid"]
    };
}, $ee6103f5a2a86aaf$export$5277e30cbd567480 = $ee6103f5a2a86aaf$var$et;
var $ee6103f5a2a86aaf$var$nt = (0, $lDSNw.forwardRef)((e, r)=>{
    let o = $ee6103f5a2a86aaf$export$5277e30cbd567480(e);
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $935d291a7dd3f6d8$export$2e2bcd8739ae039), {
        ref: r,
        ...o
    });
}), $ee6103f5a2a86aaf$export$ef9b1a59e592288f = $ee6103f5a2a86aaf$var$nt;
var $ee6103f5a2a86aaf$var$lt = (0, $lDSNw.forwardRef)((e, r)=>{
    let o = $ee6103f5a2a86aaf$export$5277e30cbd567480(e);
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $c48ddd64ec5cff67$export$2e2bcd8739ae039), {
        ref: r,
        ...o
    });
}), $ee6103f5a2a86aaf$export$4d213c67c76d12fa = $ee6103f5a2a86aaf$var$lt;
var $ee6103f5a2a86aaf$var$mt = (0, $lDSNw.forwardRef)((e, r)=>{
    let o = $ee6103f5a2a86aaf$export$5277e30cbd567480(e);
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $803cbafdf557dc26$export$2e2bcd8739ae039), {
        ref: r,
        ...o
    });
}), $ee6103f5a2a86aaf$export$aca05dd54e009a80 = $ee6103f5a2a86aaf$var$mt;
var $ee6103f5a2a86aaf$var$yt = (0, $lDSNw.forwardRef)((e, r)=>{
    let o = $ee6103f5a2a86aaf$export$5277e30cbd567480(e);
    return (0, $e800b0e3b29b4f13$exports.jsx)((0, $adf2e0274e79f79c$export$2e2bcd8739ae039), {
        ref: r,
        ...o
    });
}), $ee6103f5a2a86aaf$export$c0b2520fe082e4aa = $ee6103f5a2a86aaf$var$yt;






var $lDSNw = parcelRequire("lDSNw");
const $d3f0e615d43b5834$var$Toggle = ({ onToggle: onToggle, label: label = "", tooltipMessage: tooltipMessage = null, value: value = false, ...rest })=>{
    const [isChecked, setIsChecked] = (0, $lDSNw.useState)(value);
    const handleToggle = (event)=>{
        const newState = event.target.checked;
        setIsChecked(newState);
        onToggle(newState); // Call the callback with the new state
    };
    (0, $lDSNw.useEffect)(()=>{
        if (typeof value !== "boolean") {
            console.warn(`The value prop of the Toggle component should be a boolean, but received ${typeof value}`);
            return;
        }
        setIsChecked(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $c0dd95528ddccc0c$export$b5d5cf8927ab7262), {
                size: "sm",
                id: "switch",
                isChecked: isChecked,
                onChange: handleToggle,
                ...rest
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
                px: "1",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        fontSize: "xs",
                        color: "gray.500",
                        children: label
                    }),
                    tooltipMessage && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $55f5c4969dc36ab6$export$28c660c63b792dea), {
                        label: tooltipMessage,
                        borderRadius: 4,
                        bg: "gray.100",
                        color: "gray.800",
                        w: "180px",
                        hasArrow: true,
                        p: 3,
                        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5b8bf08ef96c0b6f$export$f04a61298a47a40f), {
                                as: (0, $f59ac49c6e1fede1$export$75b1655f5e7081d6),
                                color: "gray.400"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $d3f0e615d43b5834$export$2e2bcd8739ae039 = $d3f0e615d43b5834$var$Toggle;




const $92e38101e054c0d9$export$fef9b21a94fd7b74 = ()=>{
    const filters = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.filters);
    const handleFilterChange = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.changeFilters);
    const clearFilters = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.clearFilters);
    const options = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.options);
    const hasOptions = Object.values(options).every((option)=>option.length > 0);
    const hasFilters = Object.values(filters).some((filter)=>filter !== "");
    const filteringSessionSize = filters.sessionSize === (0, $c1fd71c50d10744b$export$8049eeb4ac268de);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
        minHeight: "68px",
        w: "100%",
        background: "red",
        maxW: "1500px",
        justifyContent: "flex-start",
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $aa57447b0555e960$export$f51f4c4ede09e011), {
            py: "4",
            w: "100%",
            maxW: "1500px",
            justifyContent: "flex-start",
            gap: "4",
            flexWrap: "wrap",
            zIndex: "15",
            background: "white",
            position: "fixed",
            filter: "drop-shadow(0px 4px 4px white)",
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ee6103f5a2a86aaf$export$ef9b1a59e592288f), {
                    ...$92e38101e054c0d9$var$sharedDropdownProps,
                    value: filters.brand,
                    isLoading: !hasOptions,
                    isClearable: true,
                    name: "Brands",
                    placeholder: "Brands",
                    options: options.brands,
                    onChange: (selectedOptions)=>handleFilterChange(selectedOptions, "brand")
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ee6103f5a2a86aaf$export$ef9b1a59e592288f), {
                    ...$92e38101e054c0d9$var$sharedDropdownProps,
                    value: filters.vertical,
                    name: "Verticals",
                    placeholder: "Verticals",
                    options: options.verticals,
                    isLoading: !hasOptions,
                    onChange: (selectedOptions)=>handleFilterChange(selectedOptions, "vertical")
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ee6103f5a2a86aaf$export$ef9b1a59e592288f), {
                    ...$92e38101e054c0d9$var$sharedDropdownProps,
                    value: filters.format,
                    name: "Units",
                    placeholder: "Units",
                    options: options.formats,
                    isLoading: !hasOptions,
                    onChange: (selectedOptions)=>handleFilterChange(selectedOptions, "format")
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ee6103f5a2a86aaf$export$ef9b1a59e592288f), {
                    ...$92e38101e054c0d9$var$sharedDropdownProps,
                    isMulti: false,
                    value: filters.features,
                    name: "Video",
                    placeholder: "Display and Video",
                    options: [
                        {
                            value: "",
                            label: "Display and Video"
                        }
                    ].concat(options.features),
                    isLoading: !hasOptions,
                    onChange: (selectedOptions)=>{
                        // as this is a single select dropdown, we need to pass an array
                        const opt = selectedOptions.value === "" ? [] : [
                            selectedOptions
                        ];
                        handleFilterChange(opt, "features");
                    }
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                    onClick: clearFilters,
                    isDisabled: !hasFilters,
                    size: "sm",
                    fontWeight: "normal",
                    variant: "outline",
                    h: "auto",
                    children: "Clear"
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d3f0e615d43b5834$export$2e2bcd8739ae039), {
                    tooltipMessage: `Hide creatives that have registered less than ${(0, $c1fd71c50d10744b$export$8049eeb4ac268de)} sessions`,
                    label: "Hide low sessions",
                    colorScheme: filteringSessionSize ? "red" : "gray",
                    value: filteringSessionSize,
                    onToggle: (state)=>{
                        if (state) handleFilterChange((0, $c1fd71c50d10744b$export$8049eeb4ac268de), "sessionSize");
                        else handleFilterChange(0, "sessionSize");
                    }
                })
            ]
        })
    });
};
const $92e38101e054c0d9$var$sharedDropdownProps = {
    isMulti: true,
    isSearchable: true,
    useBasicStyles: true,
    chakraStyles: {
        control: (provided)=>({
                ...provided,
                border: "1px solid",
                borderColor: "gray.200",
                borderRadius: "md",
                minWidth: "200px",
                minHeight: "36px"
            }),
        menu: (provided)=>({
                ...provided,
                borderRadius: "md",
                border: "1px solid",
                borderColor: "gray.200"
            })
    }
};


const $985cb50ba10c45c1$export$b94310965bed44e6 = ()=>{
    const status = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.status);
    const setStatus = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.setStatus);
    const filters = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.filters);
    const hasNextPage = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.hasNextPage);
    const homepageData = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.data);
    const loadMore = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.loadMore);
    const pageData = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.pageData);
    const setHomepageData = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.setData);
    const setHomepageOptions = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.setOptions);
    const filteredData = (0, $9cc17e77937578a8$export$b26ae958e8e72f05)((state)=>state.filteredData);
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const { counts: { favourites: userFavourites = [] }, toggleFavourite: toggleFavourite } = (0, $522db9f04f01389a$export$93687b24650bc8ab)(userInfo.id);
    (0, $lDSNw.useEffect)(()=>{
        if (status === "ready") {
            // console.log('Homepage data loaded', homepageData);
            setStatus("loading");
            (0, $7758283a20c4dc72$export$2e2bcd8739ae039)().then(({ data: data, options: options })=>{
                setHomepageData(data);
                setHomepageOptions(options);
                setStatus("loaded");
            }).catch((error)=>{
                console.error("Error fetching homepage data", error);
                setStatus("error");
            });
        }
    }, [
        status
    ]);
    if (status === "loading") return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6d34caa3f6c24444$export$e854a2165401836f), {
        size: "s"
    });
    if (status === "error") return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
        children: "There was an error fetching the data."
    });
    const hasFilters = Object.values(filters).some((filter)=>filter.length > 0);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
        justifyContent: "flexStart",
        overflow: "hidden",
        maxW: "99vw",
        w: "100%",
        pt: "50px",
        px: "4",
        children: [
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92e38101e054c0d9$export$fef9b21a94fd7b74), {}),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                transition: "height 0.5s ease, opacity 0.3s ease, margin 0.3s ease",
                mt: hasFilters ? "-50px" : "0",
                h: hasFilters ? "0" : "100%",
                opacity: hasFilters ? 0 : 1,
                pointerEvents: hasFilters ? "none" : "auto",
                border: "1px solid",
                borderRadius: "md",
                borderColor: "gray.200",
                alignItems: "flexStart",
                w: "100%",
                maxW: "1500px",
                gap: "4",
                py: "4",
                px: "4",
                children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $1c57069f3240e515$export$2e2bcd8739ae039), {
                    userFavourites: userFavourites,
                    toggleFavourite: toggleFavourite,
                    data: homepageData,
                    limit: 6
                })
            }),
            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $2603e0709778e5bc$export$e6c02a6dccfa2120), {
                justifyContent: "flexStart",
                alignItems: "flexStart",
                w: "100%",
                maxW: "1500px",
                px: "4",
                pt: "4",
                pb: "24",
                children: [
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                        fontSize: "md",
                        color: "gray.600",
                        fontWeight: "semibold",
                        mb: "1",
                        children: [
                            "Creatives",
                            " ",
                            /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $8b7e41b0c142e65e$export$5f1af8db9871e1d6), {
                                as: "span",
                                fontWeight: "normal",
                                fontSize: "sm",
                                children: [
                                    "(",
                                    pageData.length,
                                    " of ",
                                    filteredData.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $661e47f6bd02c88f$export$7e43f8ce08f3359d), {
                        userFavourites: userFavourites,
                        toggleFavourite: toggleFavourite,
                        creatives: pageData
                    }),
                    /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $92ce3a654c928239$export$353f5b6fc5456de1), {
                        onClick: loadMore,
                        display: hasNextPage ? "block" : "none",
                        // 👆 hides the button * most * of the time when there is no more creatives
                        // which is good enough for now
                        disabled: !hasNextPage,
                        colorScheme: "teal",
                        variant: "outline",
                        size: "md",
                        mt: "4",
                        children: "Load More"
                    })
                ]
            })
        ]
    });
};



const $acb65f0e3965f541$var$PrivateRoute = (props)=>{
    const { loggedIn: loggedIn, displayName: displayName, email: email } = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const overrideProps = loggedIn === null ? {
        component: null,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aad5568159569f9e$export$2e2bcd8739ae039), {})
    } : displayName == "" || email === "" ? {
        component: null,
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $821d6aacb8743eb9$export$2e2bcd8739ae039), {})
    } : {};
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
        ...props,
        ...overrideProps
    });
};
const $acb65f0e3965f541$var$App = ()=>{
    const userInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.userInfo);
    const viewerScale = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.viewerScale);
    const setUserInfo = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.setUserInfo);
    const showModal = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.showModal);
    const setShowModal = (0, $1d2a9bf39ef7c690$export$28c2fde9c958d23b)((state)=>state.setShowModal);
    (0, $d712a5077c581ffa$export$5d572ecdd7af4c65)();
    (0, $lDSNw.useEffect)(()=>{
        const unregisterAuthObserver = (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).auth().onAuthStateChanged((user)=>{
            if (user) {
                if (!/gumgum.com|playgroundxyz.com/.test(user.email)) (0, $abbc57578fc5f1d4$export$2e2bcd8739ae039).auth().signOut();
                setUserInfo({
                    displayName: user.displayName,
                    email: user.email,
                    photoURL: user.photoURL ? user.photoURL : "",
                    loggedIn: true,
                    id: user.uid
                });
                (0, $d712a5077c581ffa$export$dc9329aa05938094)(user);
            } else setUserInfo({
                displayName: "",
                email: "",
                photoURL: "",
                loggedIn: false,
                id: ""
            });
        });
        return ()=>{
            unregisterAuthObserver();
        };
    }, [
        setUserInfo
    ]);
    return /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $f499e6d2572af6ff$export$80dbe0482bcbd25a), {
        theme: (0, $838f53170a809da5$export$e41b8ed6facb449f),
        children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7ba0b64708da26c8$exports))).app,
            children: [
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $461c96fff363e55b$export$cceeabf822b64fc0), {}),
                userInfo && /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $3ee3b72d91cbc81c$export$9ba4e89fdfa1fc54), {
                    children: [
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6a12f0e5b07bb381$export$2e2bcd8739ae039), {
                            loggedIn: userInfo.displayName !== "" && userInfo.email !== ""
                        }),
                        /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsxs)((0, $5058ffe240ffde31$export$b5d5cf8927ab7262), {
                            children: [
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($acb65f0e3965f541$var$PrivateRoute, {
                                    exact: true,
                                    path: "/",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $985cb50ba10c45c1$export$b94310965bed44e6), {})
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/creative/:creativeID",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $687f59f63f20e56e$export$2e2bcd8739ae039), {
                                        scale: viewerScale,
                                        header: userInfo.displayName !== "" && userInfo.email !== ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/demo/",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $687f59f63f20e56e$export$2e2bcd8739ae039), {
                                        scale: viewerScale,
                                        demoMode: true,
                                        header: true,
                                        userEmail: userInfo.email
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($acb65f0e3965f541$var$PrivateRoute, {
                                    exact: true,
                                    path: "/demo/:creativeID",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $687f59f63f20e56e$export$2e2bcd8739ae039), {
                                        scale: viewerScale,
                                        demoMode: true,
                                        header: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/ab/:creativeID/:creativeID2",
                                    render: (props)=>/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $6fe29ede4c487ba5$export$c31b32036292dca5), {
                                            ...props,
                                            loggedIn: userInfo.loggedIn
                                        })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/catalyst/:buildID",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $e35c56f335165994$export$c96d114208f4b6d4), {
                                        header: userInfo.displayName !== "" && userInfo.email !== ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/vel/:buildID",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $d19e3c6af46a3027$export$33b53cb4c9648603), {
                                        header: userInfo.displayName !== "" && userInfo.email !== ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)($acb65f0e3965f541$var$PrivateRoute, {
                                    exact: true,
                                    path: "/catrousel",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $21a80a5e84121fae$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/catrousel/:buildID",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $93dc62a660df7844$export$2e2bcd8739ae039), {
                                        header: userInfo.displayName !== "" && userInfo.email !== ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/dcoa/:buildID",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $ab99fcdea71c7d42$export$56785f27969796ad), {
                                        header: userInfo.displayName !== "" && userInfo.email !== ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    exact: true,
                                    path: "/loading",
                                    children: /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $aad5568159569f9e$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $5058ffe240ffde31$export$e7b0ac011bb776c6), {
                                    component: (0, $927db14b17997692$export$2e2bcd8739ae039)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $880d71f906ece37f$export$2e2bcd8739ae039), {
                    show: showModal.open,
                    onClose: ()=>setShowModal(false, ""),
                    children: showModal.text
                })
            ]
        })
    });
};
var $acb65f0e3965f541$export$2e2bcd8739ae039 = $acb65f0e3965f541$var$App;


const $65651867b4ea255e$var$container = document.getElementById("root");
const $65651867b4ea255e$var$root = (0, $a1f2ba2fe2d2776b$export$882461b6382ed46c)($65651867b4ea255e$var$container);
$65651867b4ea255e$var$root.render(/*#__PURE__*/ (0, $e800b0e3b29b4f13$exports.jsx)((0, $acb65f0e3965f541$export$2e2bcd8739ae039), {}));
$888ce804d5b32d1c$export$d07f55d4c15c0440();


//# sourceMappingURL=index.5d7e000a.js.map
